/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(227);
	module.exports = __webpack_require__(518);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(696);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FormattedListParts = exports.FormattedNumberParts = exports.FormattedTimeParts = exports.FormattedDateParts = exports.FormattedDisplayName = exports.FormattedList = exports.FormattedNumber = exports.FormattedTime = exports.FormattedDate = exports.defineMessage = exports.defineMessages = exports.ReactIntlError = exports.ReactIntlErrorCode = exports.MissingTranslationError = exports.MessageFormatError = exports.MissingDataError = exports.InvalidConfigError = exports.UnsupportedFormatterError = exports.createIntlCache = exports.useIntl = exports.injectIntl = exports.createIntl = exports.RawIntlProvider = exports.IntlProvider = exports.IntlContext = exports.FormattedRelativeTime = exports.FormattedPlural = exports.FormattedMessage = exports.FormattedDateTimeRange = void 0;
	var tslib_1 = __webpack_require__(29);
	var createFormattedComponent_1 = __webpack_require__(218);
	var injectIntl_1 = (0, tslib_1.__importStar)(__webpack_require__(117));
	exports.injectIntl = injectIntl_1.default;
	Object.defineProperty(exports, "RawIntlProvider", { enumerable: true, get: function () { return injectIntl_1.Provider; } });
	Object.defineProperty(exports, "IntlContext", { enumerable: true, get: function () { return injectIntl_1.Context; } });
	var useIntl_1 = (0, tslib_1.__importDefault)(__webpack_require__(45));
	exports.useIntl = useIntl_1.default;
	var provider_1 = (0, tslib_1.__importStar)(__webpack_require__(681));
	exports.IntlProvider = provider_1.default;
	Object.defineProperty(exports, "createIntl", { enumerable: true, get: function () { return provider_1.createIntl; } });
	var relative_1 = (0, tslib_1.__importDefault)(__webpack_require__(682));
	exports.FormattedRelativeTime = relative_1.default;
	var plural_1 = (0, tslib_1.__importDefault)(__webpack_require__(680));
	exports.FormattedPlural = plural_1.default;
	var message_1 = (0, tslib_1.__importDefault)(__webpack_require__(679));
	exports.FormattedMessage = message_1.default;
	var dateTimeRange_1 = (0, tslib_1.__importDefault)(__webpack_require__(678));
	exports.FormattedDateTimeRange = dateTimeRange_1.default;
	var intl_1 = __webpack_require__(73);
	Object.defineProperty(exports, "createIntlCache", { enumerable: true, get: function () { return intl_1.createIntlCache; } });
	Object.defineProperty(exports, "UnsupportedFormatterError", { enumerable: true, get: function () { return intl_1.UnsupportedFormatterError; } });
	Object.defineProperty(exports, "InvalidConfigError", { enumerable: true, get: function () { return intl_1.InvalidConfigError; } });
	Object.defineProperty(exports, "MissingDataError", { enumerable: true, get: function () { return intl_1.MissingDataError; } });
	Object.defineProperty(exports, "MessageFormatError", { enumerable: true, get: function () { return intl_1.MessageFormatError; } });
	Object.defineProperty(exports, "MissingTranslationError", { enumerable: true, get: function () { return intl_1.MissingTranslationError; } });
	Object.defineProperty(exports, "ReactIntlErrorCode", { enumerable: true, get: function () { return intl_1.IntlErrorCode; } });
	Object.defineProperty(exports, "ReactIntlError", { enumerable: true, get: function () { return intl_1.IntlError; } });
	function defineMessages(msgs) {
	    return msgs;
	}
	exports.defineMessages = defineMessages;
	function defineMessage(msg) {
	    return msg;
	}
	exports.defineMessage = defineMessage;
	// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
	exports.FormattedDate = (0, createFormattedComponent_1.createFormattedComponent)('formatDate');
	exports.FormattedTime = (0, createFormattedComponent_1.createFormattedComponent)('formatTime');
	// @ts-ignore issue w/ TS Intl types
	exports.FormattedNumber = (0, createFormattedComponent_1.createFormattedComponent)('formatNumber');
	exports.FormattedList = (0, createFormattedComponent_1.createFormattedComponent)('formatList');
	exports.FormattedDisplayName = (0, createFormattedComponent_1.createFormattedComponent)('formatDisplayName');
	exports.FormattedDateParts = (0, createFormattedComponent_1.createFormattedDateTimePartsComponent)('formatDate');
	exports.FormattedTimeParts = (0, createFormattedComponent_1.createFormattedDateTimePartsComponent)('formatTime');
	var createFormattedComponent_2 = __webpack_require__(218);
	Object.defineProperty(exports, "FormattedNumberParts", { enumerable: true, get: function () { return createFormattedComponent_2.FormattedNumberParts; } });
	Object.defineProperty(exports, "FormattedListParts", { enumerable: true, get: function () { return createFormattedComponent_2.FormattedListParts; } });


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(312);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _json2csv = __webpack_require__(115);
	
	var _xlsx = __webpack_require__(65);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _ApiConfig = __webpack_require__(91);
	
	var _ApiConfig2 = _interopRequireDefault(_ApiConfig);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Api = function () {
	    function Api() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _classCallCheck(this, Api);
	
	        this.client = _axios2.default.create({
	            baseURL: ({"NODE_ENV":"production","PUBLIC_URL":"","API_URL":"https://api.test.e-clear.cc","BRAND":"eclear","REACT_APP_SENTRY_TRACES_SAMPLE_RATE":"0.2","REACT_APP_SENTRY_DSN":""}).REACT_APP_API_URL || ("https://api.test.e-clear.cc"),
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'application/json'
	            }
	        });
	        this.token = options.token;
	        this.onUnauthorized = options.onUnauthorized; // Callback для обработки 401 ошибки
	
	        this.client.interceptors.response.use(function (response) {
	            return response;
	        }, function (error) {
	            // Обрабатываем ошибку 401 (Unauthorized) - протухший или невалидный токен
	            if (error.response && error.response.status === 401) {
	                console.error('Unauthorized: Token expired or invalid');
	
	                // Очищаем токены
	                localStorage.removeItem("AUTH_TOKEN");
	                localStorage.removeItem("IS_REMEMBER");
	                sessionStorage.removeItem("AUTH_TOKEN");
	
	                // Вызываем callback для logout через глобальный конфиг
	                _ApiConfig2.default.executeLogout();
	
	                // Если передан callback в options, тоже вызываем его
	                if (typeof _this.onUnauthorized === 'function') {
	                    _this.onUnauthorized();
	                }
	            } else if (error.response && error.response.status >= 500) {
	                // Report server errors to Sentry
	                Sentry.captureException(error, {
	                    tags: {
	                        api_status: error.response.status,
	                        api_url: error.config && error.config.url
	                    }
	                });
	            } else if (!error.response) {
	                // Report network errors to Sentry
	                Sentry.captureException(error, {
	                    tags: {
	                        error_type: 'network_error',
	                        api_url: error.config && error.config.url
	                    }
	                });
	            }
	
	            return Promise.reject(error);
	        });
	
	        this.client.interceptors.request.use(function (config) {
	            if (_this.token) {
	                config.headers.Authorization = 'Bearer ' + _this.token;
	            }
	
	            // IMPORTANT: для FormData не задаём Content-Type вручную,
	            // иначе может сломаться multipart boundary.
	            if (typeof FormData !== "undefined" && config.data instanceof FormData) {
	                if (config.headers && config.headers["Content-Type"]) {
	                    delete config.headers["Content-Type"];
	                }
	                if (config.headers && config.headers["content-type"]) {
	                    delete config.headers["content-type"];
	                }
	            }
	
	            if (config.method && typeof config.method === "string") {
	                if (config.method.toLowerCase() === "get") {
	                    delete config.data;
	                }
	            }
	
	            return config;
	        }, function (e) {
	            return Promise.reject(e);
	        });
	    }
	
	    //запрос авторизации
	
	
	    _createClass(Api, [{
	        key: 'login',
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	                var username = _ref.username,
	                    password = _ref.password,
	                    code = _ref.code;
	                var form, data;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                form = { username: username, password: password };
	
	
	                                if (code) form.code = code;
	
	                                _context.next = 4;
	                                return this.client.post('/login', form);
	
	                            case 4:
	                                data = _context.sent;
	
	
	                                this.token = data.data.token;
	
	                                return _context.abrupt('return', data.data);
	
	                            case 7:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function login(_x2) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return login;
	        }()
	
	        //логаут
	
	    }, {
	        key: 'logout',
	        value: function logout() {
	            // Логируем выход на сервере (fire-and-forget)
	            if (this.token) {
	                this.client.post('/account/logout', {}).catch(function () {});
	            }
	            this.token = null;
	            localStorage.removeItem("AUTH_TOKEN");
	        }
	
	        //запрос данных авторизованного юзера
	
	    }, {
	        key: 'getUserData',
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                return _context2.abrupt('return', this.client('/account/dashboard').then(function (_ref4) {
	                                    var data = _ref4.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function getUserData() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return getUserData;
	        }()
	
	        //запрос данных OTP
	
	    }, {
	        key: 'getOTPData',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                return _context3.abrupt('return', this.client('/account/otp').then(function (_ref6) {
	                                    var data = _ref6.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function getOTPData() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return getOTPData;
	        }()
	
	        //запрос актуальных прав пользователя (обновление прав при перезагрузке)
	
	    }, {
	        key: 'getPermissions',
	        value: function () {
	            var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                return _context4.abrupt('return', this.client.get('/account/permissions').then(function (_ref8) {
	                                    var data = _ref8.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	
	            function getPermissions() {
	                return _ref7.apply(this, arguments);
	            }
	
	            return getPermissions;
	        }()
	
	        //запрос всех данных Dashboard
	
	    }, {
	        key: 'getDashboard',
	        value: function () {
	            var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                return _context5.abrupt('return', this.client('/transactions/dashboard').then(function (_ref10) {
	                                    var data = _ref10.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function getDashboard() {
	                return _ref9.apply(this, arguments);
	            }
	
	            return getDashboard;
	        }()
	
	        //запрос данных персонального менеджера
	
	    }, {
	        key: 'getPersonalManager',
	        value: function () {
	            var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                return _context6.abrupt('return', this.client('/account/dashboard').then(function (_ref12) {
	                                    var data = _ref12.data;
	                                    return data.manager;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	
	            function getPersonalManager() {
	                return _ref11.apply(this, arguments);
	            }
	
	            return getPersonalManager;
	        }()
	
	        // Отчёт по транзакциям
	
	    }, {
	        key: 'getProviderSummary',
	        value: function getProviderSummary(filter) {
	            return this.client.post("/statistics/provider-summary-transaction", filter).then(function (_ref13) {
	                var data = _ref13.data;
	                return data;
	            });
	        }
	
	        // Отчёт по мерчантам
	
	    }, {
	        key: 'getProviderSummaryMerchant',
	        value: function getProviderSummaryMerchant(filter) {
	            return this.client.post("/statistics/provider-summary-merchant", filter).then(function (_ref14) {
	                var data = _ref14.data;
	                return data;
	            });
	        }
	
	        //запрос списка проектов и их данные
	
	    }, {
	        key: 'getProjects',
	        value: function () {
	            var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	                return _regenerator2.default.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                return _context7.abrupt('return', this.client('/merchant/dashboard').then(function (_ref16) {
	                                    var data = _ref16.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this);
	            }));
	
	            function getProjects() {
	                return _ref15.apply(this, arguments);
	            }
	
	            return getProjects;
	        }()
	
	        //запрос списка статусов
	
	    }, {
	        key: 'getTransactionsStatusList',
	        value: function () {
	            var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	                return _regenerator2.default.wrap(function _callee8$(_context8) {
	                    while (1) {
	                        switch (_context8.prev = _context8.next) {
	                            case 0:
	                                return _context8.abrupt('return', this.client('/transactions/dashboard').then(function (_ref18) {
	                                    var data = _ref18.data;
	                                    return data.total;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context8.stop();
	                        }
	                    }
	                }, _callee8, this);
	            }));
	
	            function getTransactionsStatusList() {
	                return _ref17.apply(this, arguments);
	            }
	
	            return getTransactionsStatusList;
	        }()
	
	        //загрузка реестра
	        // Описание колонок реестра под выбранного провайдера: по нему кабинет
	        // рисует инструкцию, а бэкенд собирает такой же xlsx-образец. Держать этот
	        // список на фронте нельзя — он расходится с парсером.
	
	    }, {
	        key: 'getRegistryColumns',
	        value: function () {
	            var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(type, provider) {
	                var params, _ref20, data;
	
	                return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                        switch (_context9.prev = _context9.next) {
	                            case 0:
	                                params = { type: type };
	
	                                if (provider) params.provider = provider;
	
	                                _context9.next = 4;
	                                return this.client.get('/merchant/payout/registry/columns', { params: params });
	
	                            case 4:
	                                _ref20 = _context9.sent;
	                                data = _ref20.data;
	                                return _context9.abrupt('return', data && data.data ? data.data : null);
	
	                            case 7:
	                            case 'end':
	                                return _context9.stop();
	                        }
	                    }
	                }, _callee9, this);
	            }));
	
	            function getRegistryColumns(_x3, _x4) {
	                return _ref19.apply(this, arguments);
	            }
	
	            return getRegistryColumns;
	        }()
	    }, {
	        key: 'registryUpload',
	        value: function () {
	            var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(data) {
	                var merchantUuid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                return _regenerator2.default.wrap(function _callee10$(_context10) {
	                    while (1) {
	                        switch (_context10.prev = _context10.next) {
	                            case 0:
	                                if (merchantUuid) {
	                                    data.append('merchantUuid', merchantUuid);
	                                }
	                                return _context10.abrupt('return', this.client.post('/merchant/payout/registry/upload', data).then(function (_ref22) {
	                                    var data = _ref22.data;
	                                    return data;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context10.stop();
	                        }
	                    }
	                }, _callee10, this);
	            }));
	
	            function registryUpload(_x6) {
	                return _ref21.apply(this, arguments);
	            }
	
	            return registryUpload;
	        }()
	
	        //подтверждение выполнения загруженного реестра
	
	    }, {
	        key: 'registryProcess',
	        value: function () {
	            var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(registry, uuid) {
	                var _ref24, data;
	
	                return _regenerator2.default.wrap(function _callee11$(_context11) {
	                    while (1) {
	                        switch (_context11.prev = _context11.next) {
	                            case 0:
	                                _context11.next = 2;
	                                return this.client.post('/merchant/' + uuid + '/payout/registry/process', registry);
	
	                            case 2:
	                                _ref24 = _context11.sent;
	                                data = _ref24.data;
	                                return _context11.abrupt('return', data);
	
	                            case 5:
	                            case 'end':
	                                return _context11.stop();
	                        }
	                    }
	                }, _callee11, this);
	            }));
	
	            function registryProcess(_x7, _x8) {
	                return _ref23.apply(this, arguments);
	            }
	
	            return registryProcess;
	        }()
	
	        //загрузка мобильного реестра (СБП/телефон)
	
	    }, {
	        key: 'mobileRegistryUpload',
	        value: function () {
	            var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(data) {
	                var merchantUuid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                return _regenerator2.default.wrap(function _callee12$(_context12) {
	                    while (1) {
	                        switch (_context12.prev = _context12.next) {
	                            case 0:
	                                if (merchantUuid) {
	                                    data.append('merchantUuid', merchantUuid);
	                                }
	                                return _context12.abrupt('return', this.client.post('/merchant/payout/mobile-registry/upload', data).then(function (_ref26) {
	                                    var data = _ref26.data;
	                                    return data;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context12.stop();
	                        }
	                    }
	                }, _callee12, this);
	            }));
	
	            function mobileRegistryUpload(_x10) {
	                return _ref25.apply(this, arguments);
	            }
	
	            return mobileRegistryUpload;
	        }()
	
	        //подтверждение выполнения мобильного реестра
	
	    }, {
	        key: 'mobileRegistryProcess',
	        value: function () {
	            var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(registry, uuid) {
	                var _ref28, data;
	
	                return _regenerator2.default.wrap(function _callee13$(_context13) {
	                    while (1) {
	                        switch (_context13.prev = _context13.next) {
	                            case 0:
	                                _context13.next = 2;
	                                return this.client.post('/merchant/' + uuid + '/payout/mobile-registry/process', registry);
	
	                            case 2:
	                                _ref28 = _context13.sent;
	                                data = _ref28.data;
	                                return _context13.abrupt('return', data);
	
	                            case 5:
	                            case 'end':
	                                return _context13.stop();
	                        }
	                    }
	                }, _callee13, this);
	            }));
	
	            function mobileRegistryProcess(_x11, _x12) {
	                return _ref27.apply(this, arguments);
	            }
	
	            return mobileRegistryProcess;
	        }()
	
	        //список мобильных реестров
	
	    }, {
	        key: 'setMobileRegistryList',
	        value: function () {
	            var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(filters) {
	                return _regenerator2.default.wrap(function _callee14$(_context14) {
	                    while (1) {
	                        switch (_context14.prev = _context14.next) {
	                            case 0:
	                                return _context14.abrupt('return', this.client.post('/merchant/payout/mobile-registry/list', filters).then(function (_ref30) {
	                                    var data = _ref30.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context14.stop();
	                        }
	                    }
	                }, _callee14, this);
	            }));
	
	            function setMobileRegistryList(_x13) {
	                return _ref29.apply(this, arguments);
	            }
	
	            return setMobileRegistryList;
	        }()
	
	        //список банков-участников СБП
	
	    }, {
	        key: 'getSbpParticipants',
	        value: function () {
	            var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(uuid) {
	                return _regenerator2.default.wrap(function _callee15$(_context15) {
	                    while (1) {
	                        switch (_context15.prev = _context15.next) {
	                            case 0:
	                                return _context15.abrupt('return', this.client.get('/merchant/' + uuid + '/sbp-participants').then(function (_ref32) {
	                                    var data = _ref32.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context15.stop();
	                        }
	                    }
	                }, _callee15, this);
	            }));
	
	            function getSbpParticipants(_x14) {
	                return _ref31.apply(this, arguments);
	            }
	
	            return getSbpParticipants;
	        }()
	
	        // Скачать исходный реестр (то, что хранится в базе, восстановленное в XLSX)
	
	    }, {
	        key: 'downloadRegistryFile',
	        value: function () {
	            var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(registryId) {
	                var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	                var res, contentType, blob, a, safeName;
	                return _regenerator2.default.wrap(function _callee16$(_context16) {
	                    while (1) {
	                        switch (_context16.prev = _context16.next) {
	                            case 0:
	                                _context16.next = 2;
	                                return this.client.get('/merchant/payout/registry/' + registryId + '/download', {
	                                    responseType: "arraybuffer"
	                                });
	
	                            case 2:
	                                res = _context16.sent;
	                                contentType = res.headers && (res.headers["content-type"] || res.headers["Content-Type"]) || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
	                                blob = new Blob([res.data], { type: contentType });
	                                a = document.createElement("a");
	
	                                a.href = URL.createObjectURL(blob);
	
	                                safeName = fileName ? fileName.toLowerCase().endsWith(".xlsx") ? fileName : fileName + '.xlsx' : 'registry_' + registryId + '.xlsx';
	
	
	                                a.download = safeName;
	                                a.click();
	
	                                URL.revokeObjectURL(a.href);
	
	                            case 11:
	                            case 'end':
	                                return _context16.stop();
	                        }
	                    }
	                }, _callee16, this);
	            }));
	
	            function downloadRegistryFile(_x16) {
	                return _ref33.apply(this, arguments);
	            }
	
	            return downloadRegistryFile;
	        }()
	    }, {
	        key: 'getTags',
	        value: function () {
	            var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(uuid) {
	                return _regenerator2.default.wrap(function _callee17$(_context17) {
	                    while (1) {
	                        switch (_context17.prev = _context17.next) {
	                            case 0:
	                                return _context17.abrupt('return', this.client('/merchant/' + uuid + '/payout/tags').then(function (_ref35) {
	                                    var data = _ref35.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context17.stop();
	                        }
	                    }
	                }, _callee17, this);
	            }));
	
	            function getTags(_x17) {
	                return _ref34.apply(this, arguments);
	            }
	
	            return getTags;
	        }()
	    }, {
	        key: 'getAllTags',
	        value: function () {
	            var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee18() {
	                return _regenerator2.default.wrap(function _callee18$(_context18) {
	                    while (1) {
	                        switch (_context18.prev = _context18.next) {
	                            case 0:
	                                return _context18.abrupt('return', this.client('/merchant/payout/tags').then(function (_ref37) {
	                                    var data = _ref37.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context18.stop();
	                        }
	                    }
	                }, _callee18, this);
	            }));
	
	            function getAllTags() {
	                return _ref36.apply(this, arguments);
	            }
	
	            return getAllTags;
	        }()
	    }, {
	        key: 'getMpsChart',
	        value: function () {
	            var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee19() {
	                return _regenerator2.default.wrap(function _callee19$(_context19) {
	                    while (1) {
	                        switch (_context19.prev = _context19.next) {
	                            case 0:
	                                return _context19.abrupt('return', this.client('/merchant/chart/mps').then(function (_ref39) {
	                                    var data = _ref39.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context19.stop();
	                        }
	                    }
	                }, _callee19, this);
	            }));
	
	            function getMpsChart() {
	                return _ref38.apply(this, arguments);
	            }
	
	            return getMpsChart;
	        }()
	    }, {
	        key: 'getTopErrorsDiffChart',
	        value: function () {
	            var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee20() {
	                return _regenerator2.default.wrap(function _callee20$(_context20) {
	                    while (1) {
	                        switch (_context20.prev = _context20.next) {
	                            case 0:
	                                return _context20.abrupt('return', this.client('/merchant/chart/transactions').then(function (_ref41) {
	                                    var data = _ref41.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context20.stop();
	                        }
	                    }
	                }, _callee20, this);
	            }));
	
	            function getTopErrorsDiffChart() {
	                return _ref40.apply(this, arguments);
	            }
	
	            return getTopErrorsDiffChart;
	        }()
	    }, {
	        key: 'getCountryTopChart',
	        value: function () {
	            var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee21() {
	                return _regenerator2.default.wrap(function _callee21$(_context21) {
	                    while (1) {
	                        switch (_context21.prev = _context21.next) {
	                            case 0:
	                                return _context21.abrupt('return', this.client('/merchant/chart/countries').then(function (_ref43) {
	                                    var data = _ref43.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context21.stop();
	                        }
	                    }
	                }, _callee21, this);
	            }));
	
	            function getCountryTopChart() {
	                return _ref42.apply(this, arguments);
	            }
	
	            return getCountryTopChart;
	        }()
	    }, {
	        key: 'getCountryMapChart',
	        value: function () {
	            var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee22() {
	                return _regenerator2.default.wrap(function _callee22$(_context22) {
	                    while (1) {
	                        switch (_context22.prev = _context22.next) {
	                            case 0:
	                                return _context22.abrupt('return', this.client('/merchant/datamap/map').then(function (_ref45) {
	                                    var data = _ref45.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context22.stop();
	                        }
	                    }
	                }, _callee22, this);
	            }));
	
	            function getCountryMapChart() {
	                return _ref44.apply(this, arguments);
	            }
	
	            return getCountryMapChart;
	        }()
	    }, {
	        key: 'getCountryTopData',
	        value: function () {
	            var _ref46 = _asyncToGenerator(_regenerator2.default.mark(function _callee23() {
	                return _regenerator2.default.wrap(function _callee23$(_context23) {
	                    while (1) {
	                        switch (_context23.prev = _context23.next) {
	                            case 0:
	                                return _context23.abrupt('return', this.client('/merchant/datamap/data').then(function (_ref47) {
	                                    var data = _ref47.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context23.stop();
	                        }
	                    }
	                }, _callee23, this);
	            }));
	
	            function getCountryTopData() {
	                return _ref46.apply(this, arguments);
	            }
	
	            return getCountryTopData;
	        }()
	    }, {
	        key: 'setTransactionsChartFilters',
	        value: function () {
	            var _ref48 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(filters) {
	                var clone;
	                return _regenerator2.default.wrap(function _callee24$(_context24) {
	                    while (1) {
	                        switch (_context24.prev = _context24.next) {
	                            case 0:
	                                clone = JSON.parse(JSON.stringify(filters));
	
	
	                                clone.filters.forEach(function (filter) {
	                                    delete filter.locale;
	                                });
	
	                                return _context24.abrupt('return', this.client.post('/statistics/transactions/charts', clone).then(function (_ref49) {
	                                    var data = _ref49.data;
	                                    return data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context24.stop();
	                        }
	                    }
	                }, _callee24, this);
	            }));
	
	            function setTransactionsChartFilters(_x18) {
	                return _ref48.apply(this, arguments);
	            }
	
	            return setTransactionsChartFilters;
	        }()
	    }, {
	        key: 'setMerchantsTurnoverChart',
	        value: function () {
	            var _ref50 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(filters) {
	                var clone;
	                return _regenerator2.default.wrap(function _callee25$(_context25) {
	                    while (1) {
	                        switch (_context25.prev = _context25.next) {
	                            case 0:
	                                clone = JSON.parse(JSON.stringify(filters));
	
	
	                                if (clone.filters) {
	                                    clone.filters.forEach(function (filter) {
	                                        delete filter.locale;
	                                    });
	                                }
	
	                                return _context25.abrupt('return', this.client.post('/statistics/transactions/merchants-turnover', clone).then(function (_ref51) {
	                                    var data = _ref51.data;
	                                    return data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context25.stop();
	                        }
	                    }
	                }, _callee25, this);
	            }));
	
	            function setMerchantsTurnoverChart(_x19) {
	                return _ref50.apply(this, arguments);
	            }
	
	            return setMerchantsTurnoverChart;
	        }()
	    }, {
	        key: 'setTransactionsFilters',
	        value: function () {
	            var _ref52 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(filters) {
	                var clone;
	                return _regenerator2.default.wrap(function _callee26$(_context26) {
	                    while (1) {
	                        switch (_context26.prev = _context26.next) {
	                            case 0:
	                                clone = JSON.parse(JSON.stringify(filters));
	
	
	                                clone.filters.forEach(function (filter) {
	                                    delete filter.locale;
	                                });
	
	                                return _context26.abrupt('return', this.client.post('/statistics/transactions', clone).then(function (_ref53) {
	                                    var data = _ref53.data;
	                                    return data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context26.stop();
	                        }
	                    }
	                }, _callee26, this);
	            }));
	
	            function setTransactionsFilters(_x20) {
	                return _ref52.apply(this, arguments);
	            }
	
	            return setTransactionsFilters;
	        }()
	    }, {
	        key: 'setRegistryList',
	        value: function () {
	            var _ref54 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(filters) {
	                return _regenerator2.default.wrap(function _callee27$(_context27) {
	                    while (1) {
	                        switch (_context27.prev = _context27.next) {
	                            case 0:
	                                return _context27.abrupt('return', this.client.post('/merchant/payout/registry/list', filters).then(function (_ref55) {
	                                    var data = _ref55.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context27.stop();
	                        }
	                    }
	                }, _callee27, this);
	            }));
	
	            function setRegistryList(_x21) {
	                return _ref54.apply(this, arguments);
	            }
	
	            return setRegistryList;
	        }()
	    }, {
	        key: 'grantAdmin',
	        value: function () {
	            var _ref56 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(id) {
	                return _regenerator2.default.wrap(function _callee28$(_context28) {
	                    while (1) {
	                        switch (_context28.prev = _context28.next) {
	                            case 0:
	                                return _context28.abrupt('return', this.client.post('/account/' + id + '/grant-admin', {}).then(function (_ref57) {
	                                    var data = _ref57.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context28.stop();
	                        }
	                    }
	                }, _callee28, this);
	            }));
	
	            function grantAdmin(_x22) {
	                return _ref56.apply(this, arguments);
	            }
	
	            return grantAdmin;
	        }()
	    }, {
	        key: 'revokeAdmin',
	        value: function () {
	            var _ref58 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(id) {
	                return _regenerator2.default.wrap(function _callee29$(_context29) {
	                    while (1) {
	                        switch (_context29.prev = _context29.next) {
	                            case 0:
	                                return _context29.abrupt('return', this.client.post('/account/' + id + '/revoke-admin', {}).then(function (_ref59) {
	                                    var data = _ref59.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context29.stop();
	                        }
	                    }
	                }, _callee29, this);
	            }));
	
	            function revokeAdmin(_x23) {
	                return _ref58.apply(this, arguments);
	            }
	
	            return revokeAdmin;
	        }()
	    }, {
	        key: 'getTerminalLimits',
	        value: function () {
	            var _ref60 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(projectUuid, terminalId) {
	                return _regenerator2.default.wrap(function _callee30$(_context30) {
	                    while (1) {
	                        switch (_context30.prev = _context30.next) {
	                            case 0:
	                                return _context30.abrupt('return', this.client('/merchant/' + projectUuid + '/terminals/' + terminalId + '/limits'));
	
	                            case 1:
	                            case 'end':
	                                return _context30.stop();
	                        }
	                    }
	                }, _callee30, this);
	            }));
	
	            function getTerminalLimits(_x24, _x25) {
	                return _ref60.apply(this, arguments);
	            }
	
	            return getTerminalLimits;
	        }()
	    }, {
	        key: 'updateTerminalLimits',
	        value: function () {
	            var _ref61 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(projectUuid, terminalId, payload) {
	                return _regenerator2.default.wrap(function _callee31$(_context31) {
	                    while (1) {
	                        switch (_context31.prev = _context31.next) {
	                            case 0:
	                                return _context31.abrupt('return', this.client.post('/merchant/' + projectUuid + '/terminals/' + terminalId + '/limits', payload));
	
	                            case 1:
	                            case 'end':
	                                return _context31.stop();
	                        }
	                    }
	                }, _callee31, this);
	            }));
	
	            function updateTerminalLimits(_x26, _x27, _x28) {
	                return _ref61.apply(this, arguments);
	            }
	
	            return updateTerminalLimits;
	        }()
	    }, {
	        key: 'setRegistryListFilters',
	        value: function () {
	            var _ref62 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(filters) {
	                return _regenerator2.default.wrap(function _callee32$(_context32) {
	                    while (1) {
	                        switch (_context32.prev = _context32.next) {
	                            case 0:
	                                return _context32.abrupt('return', this.client.post('/merchant/payout/registry/list', filters).then(function (_ref63) {
	                                    var data = _ref63.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context32.stop();
	                        }
	                    }
	                }, _callee32, this);
	            }));
	
	            function setRegistryListFilters(_x29) {
	                return _ref62.apply(this, arguments);
	            }
	
	            return setRegistryListFilters;
	        }()
	    }, {
	        key: 'setPayoutsList',
	        value: function () {
	            var _ref64 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(id) {
	                return _regenerator2.default.wrap(function _callee33$(_context33) {
	                    while (1) {
	                        switch (_context33.prev = _context33.next) {
	                            case 0:
	                                return _context33.abrupt('return', this.client('/merchant/payout/registry/' + id + '/transactions').then(function (_ref65) {
	                                    var data = _ref65.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context33.stop();
	                        }
	                    }
	                }, _callee33, this);
	            }));
	
	            function setPayoutsList(_x30) {
	                return _ref64.apply(this, arguments);
	            }
	
	            return setPayoutsList;
	        }()
	    }, {
	        key: 'setRegistryReprocess',
	        value: function () {
	            var _ref66 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(id) {
	                return _regenerator2.default.wrap(function _callee34$(_context34) {
	                    while (1) {
	                        switch (_context34.prev = _context34.next) {
	                            case 0:
	                                return _context34.abrupt('return', this.client('/merchant/payout/registry/' + id + '/reprocess').then(function (_ref67) {
	                                    var data = _ref67.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context34.stop();
	                        }
	                    }
	                }, _callee34, this);
	            }));
	
	            function setRegistryReprocess(_x31) {
	                return _ref66.apply(this, arguments);
	            }
	
	            return setRegistryReprocess;
	        }()
	
	        // Повтор только неуспешных транзакций реестра (с оригинальными PAN, на бэке)
	
	    }, {
	        key: 'registryRetryFailed',
	        value: function () {
	            var _ref68 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(id) {
	                return _regenerator2.default.wrap(function _callee35$(_context35) {
	                    while (1) {
	                        switch (_context35.prev = _context35.next) {
	                            case 0:
	                                return _context35.abrupt('return', this.client.post('/merchant/payout/registry/' + id + '/retry-failed', {}).then(function (_ref69) {
	                                    var data = _ref69.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context35.stop();
	                        }
	                    }
	                }, _callee35, this);
	            }));
	
	            function registryRetryFailed(_x32) {
	                return _ref68.apply(this, arguments);
	            }
	
	            return registryRetryFailed;
	        }()
	
	        // Подтверждение отправки реестра в обработку (для retry)
	
	    }, {
	        key: 'registryReprocess',
	        value: function () {
	            var _ref70 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(id) {
	                return _regenerator2.default.wrap(function _callee36$(_context36) {
	                    while (1) {
	                        switch (_context36.prev = _context36.next) {
	                            case 0:
	                                return _context36.abrupt('return', this.client.get('/merchant/payout/registry/' + id + '/reprocess').then(function (_ref71) {
	                                    var data = _ref71.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context36.stop();
	                        }
	                    }
	                }, _callee36, this);
	            }));
	
	            function registryReprocess(_x33) {
	                return _ref70.apply(this, arguments);
	            }
	
	            return registryReprocess;
	        }()
	    }, {
	        key: 'getProjectData',
	        value: function () {
	            var _ref72 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(uuid) {
	                return _regenerator2.default.wrap(function _callee37$(_context37) {
	                    while (1) {
	                        switch (_context37.prev = _context37.next) {
	                            case 0:
	                                return _context37.abrupt('return', this.client('/merchant/' + uuid).then(function (_ref73) {
	                                    var data = _ref73.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context37.stop();
	                        }
	                    }
	                }, _callee37, this);
	            }));
	
	            function getProjectData(_x34) {
	                return _ref72.apply(this, arguments);
	            }
	
	            return getProjectData;
	        }()
	    }, {
	        key: 'createMobilePay',
	        value: function () {
	            var _ref75 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(_ref74) {
	                var amount = _ref74.amount,
	                    bank = _ref74.bank,
	                    _ref74$currency = _ref74.currency,
	                    currency = _ref74$currency === undefined ? "RUB" : _ref74$currency,
	                    widg = _ref74.widg,
	                    unlid = _ref74.unlid,
	                    provider = _ref74.provider;
	                return _regenerator2.default.wrap(function _callee38$(_context38) {
	                    while (1) {
	                        switch (_context38.prev = _context38.next) {
	                            case 0:
	                                return _context38.abrupt('return', this.client.post("/api/hydra/mobile-pay", {
	                                    amount: amount,
	                                    currency: currency,
	                                    bank: bank,
	                                    widg: widg,
	                                    unlid: unlid,
	                                    provider: provider
	                                }).then(function (_ref76) {
	                                    var data = _ref76.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context38.stop();
	                        }
	                    }
	                }, _callee38, this);
	            }));
	
	            function createMobilePay(_x35) {
	                return _ref75.apply(this, arguments);
	            }
	
	            return createMobilePay;
	        }()
	    }, {
	        key: 'checkWidgetStatus',
	        value: function () {
	            var _ref78 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(_ref77) {
	                var widg = _ref77.widg,
	                    unlid = _ref77.unlid;
	                return _regenerator2.default.wrap(function _callee39$(_context39) {
	                    while (1) {
	                        switch (_context39.prev = _context39.next) {
	                            case 0:
	                                return _context39.abrupt('return', this.client.get("/api/hydra/widget-status", {
	                                    params: { widg: widg, unlid: unlid }
	                                }).then(function (_ref79) {
	                                    var data = _ref79.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context39.stop();
	                        }
	                    }
	                }, _callee39, this);
	            }));
	
	            function checkWidgetStatus(_x36) {
	                return _ref78.apply(this, arguments);
	            }
	
	            return checkWidgetStatus;
	        }()
	    }, {
	        key: 'getWidgetConfig',
	        value: function () {
	            var _ref81 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(_ref80) {
	                var widg = _ref80.widg;
	                return _regenerator2.default.wrap(function _callee40$(_context40) {
	                    while (1) {
	                        switch (_context40.prev = _context40.next) {
	                            case 0:
	                                return _context40.abrupt('return', this.client.get("/api/hydra/widget-config", {
	                                    params: { widg: widg }
	                                }).then(function (_ref82) {
	                                    var data = _ref82.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context40.stop();
	                        }
	                    }
	                }, _callee40, this);
	            }));
	
	            function getWidgetConfig(_x37) {
	                return _ref81.apply(this, arguments);
	            }
	
	            return getWidgetConfig;
	        }()
	
	        // Данные публичной страницы оплаты NPay (QR, суммы, статус, срок) по НЕугадываемому токену.
	
	    }, {
	        key: 'getNpayPage',
	        value: function () {
	            var _ref83 = _asyncToGenerator(_regenerator2.default.mark(function _callee41(token) {
	                return _regenerator2.default.wrap(function _callee41$(_context41) {
	                    while (1) {
	                        switch (_context41.prev = _context41.next) {
	                            case 0:
	                                return _context41.abrupt('return', this.client.get('/api/npay/page/' + token).then(function (_ref84) {
	                                    var data = _ref84.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context41.stop();
	                        }
	                    }
	                }, _callee41, this);
	            }));
	
	            function getNpayPage(_x38) {
	                return _ref83.apply(this, arguments);
	            }
	
	            return getNpayPage;
	        }()
	
	        // Формирование и получение отчетов
	
	    }, {
	        key: 'getReport',
	        value: function () {
	            var _ref85 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(type, filter, filename) {
	                var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "csv";
	                var csvConstruct, excelConstruct, OneSConstruct;
	                return _regenerator2.default.wrap(function _callee42$(_context42) {
	                    while (1) {
	                        switch (_context42.prev = _context42.next) {
	                            case 0:
	                                OneSConstruct = function OneSConstruct(data, name) {
	                                    var a = document.createElement("a");
	                                    a.setAttribute("href", 'data:text/plain;charset=cp1251;base64,' + data);
	                                    a.download = name + '.txt';
	                                    a.click();
	                                };
	
	                                excelConstruct = function excelConstruct(data, name, format) {
	                                    var worksheet = XLSX.utils.json_to_sheet(data.data, { header: data.fields });
	                                    var workbook = XLSX.utils.book_new();
	                                    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
	
	                                    var wbout = XLSX.write(workbook, { bookType: format, type: "array" });
	
	                                    var blob = new Blob([wbout], {
	                                        type: format === "xlsx" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "application/vnd.ms-excel"
	                                    });
	
	                                    var a = document.createElement("a");
	                                    a.href = URL.createObjectURL(blob);
	                                    a.download = name + '.' + format;
	                                    a.click();
	                                    URL.revokeObjectURL(a.href);
	                                };
	
	                                csvConstruct = function csvConstruct(data, name) {
	                                    var universalBOM = '\uFEFF';
	                                    var json2csv = new _json2csv.Parser({ delimiter: ";", fields: data.fields });
	                                    var csv = json2csv.parse(data.data);
	
	                                    var a = document.createElement("a");
	                                    a.setAttribute("href", "data:text/csv; charset=utf-8," + encodeURIComponent(universalBOM + csv));
	                                    a.setAttribute("download", name + '.csv');
	                                    document.body.appendChild(a);
	                                    a.click();
	                                };
	
	                                _context42.t0 = type;
	                                _context42.next = _context42.t0 === "singleRegistry" ? 6 : _context42.t0 === "payout" ? 7 : _context42.t0 === "payout1C" ? 8 : _context42.t0 === "transactions" ? 9 : _context42.t0 === "transactions1C" ? 10 : 11;
	                                break;
	
	                            case 6:
	                                return _context42.abrupt('return', this.client('/merchant/payout/registry/' + filter + '/report').then(function (_ref86) {
	                                    var data = _ref86.data;
	
	                                    format === "csv" ? csvConstruct(data, filename) : excelConstruct(data, filename, format);
	                                }));
	
	                            case 7:
	                                return _context42.abrupt('return', this.client.post('/merchant/payout/registry/report', filter).then(function (_ref87) {
	                                    var data = _ref87.data;
	
	                                    format === "csv" ? csvConstruct(data, filename) : excelConstruct(data, filename, format);
	                                }));
	
	                            case 8:
	                                return _context42.abrupt('return', this.client.post('/merchant/payout/registry/report1c', filter).then(function (_ref88) {
	                                    var data = _ref88.data;
	
	                                    OneSConstruct(data, filename);
	                                }));
	
	                            case 9:
	                                return _context42.abrupt('return', this.client.post('/statistics/transactions/report', filter).then(function (_ref89) {
	                                    var data = _ref89.data;
	
	                                    format === "csv" ? csvConstruct(data, filename) : excelConstruct(data, filename, format);
	                                }));
	
	                            case 10:
	                                return _context42.abrupt('return', this.client.post('/statistics/transactions/report1c', filter).then(function (_ref90) {
	                                    var data = _ref90.data;
	
	                                    OneSConstruct(data, filename);
	                                }));
	
	                            case 11:
	                                alert("check ReportWidget");
	
	                            case 12:
	                            case 'end':
	                                return _context42.stop();
	                        }
	                    }
	                }, _callee42, this);
	            }));
	
	            function getReport(_x40, _x41, _x42) {
	                return _ref85.apply(this, arguments);
	            }
	
	            return getReport;
	        }()
	
	        // Разовая выплата
	
	    }, {
	        key: 'makeSinglePayout',
	        value: function () {
	            var _ref91 = _asyncToGenerator(_regenerator2.default.mark(function _callee43(uuid, data) {
	                var clean, cleaned;
	                return _regenerator2.default.wrap(function _callee43$(_context43) {
	                    while (1) {
	                        switch (_context43.prev = _context43.next) {
	                            case 0:
	                                clean = function clean(data) {
	
	                                    var clone = Object.assign({}, data);
	
	                                    Object.entries(clone).map(function (_ref92) {
	                                        var _ref93 = _slicedToArray(_ref92, 2),
	                                            key = _ref93[0],
	                                            val = _ref93[1];
	
	                                        if (!val) delete clone[key];
	
	                                        if (key === 'pan' && val) clone.pan = clone.pan.replace(/\s/g, '');
	
	                                        return true;
	                                    });
	
	                                    return clone;
	                                };
	
	                                cleaned = clean(data);
	                                return _context43.abrupt('return', this.client.post('/merchant/' + uuid + '/payout/single', cleaned).then(function (_ref94) {
	                                    var data = _ref94.data;
	                                    return data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context43.stop();
	                        }
	                    }
	                }, _callee43, this);
	            }));
	
	            function makeSinglePayout(_x43, _x44) {
	                return _ref91.apply(this, arguments);
	            }
	
	            return makeSinglePayout;
	        }()
	
	        //Запрос статуса выаолнения реестра по ID
	
	    }, {
	        key: 'getRegistryStatus',
	        value: function () {
	            var _ref95 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(id) {
	                return _regenerator2.default.wrap(function _callee44$(_context44) {
	                    while (1) {
	                        switch (_context44.prev = _context44.next) {
	                            case 0:
	                                return _context44.abrupt('return', this.client('/merchant/payout/registry/' + id + '/data').then(function (_ref96) {
	                                    var data = _ref96.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context44.stop();
	                        }
	                    }
	                }, _callee44, this);
	            }));
	
	            function getRegistryStatus(_x45) {
	                return _ref95.apply(this, arguments);
	            }
	
	            return getRegistryStatus;
	        }()
	
	        //Сохранение данных пользователя
	
	    }, {
	        key: 'setUserData',
	        value: function () {
	            var _ref97 = _asyncToGenerator(_regenerator2.default.mark(function _callee45(form) {
	                return _regenerator2.default.wrap(function _callee45$(_context45) {
	                    while (1) {
	                        switch (_context45.prev = _context45.next) {
	                            case 0:
	
	                                delete form.firstName;
	                                delete form.lastName;
	                                delete form.patronymic;
	
	                                return _context45.abrupt('return', this.client.post('/account/update', form).then(function (_ref98) {
	                                    var data = _ref98.data;
	                                    return data;
	                                }));
	
	                            case 4:
	                            case 'end':
	                                return _context45.stop();
	                        }
	                    }
	                }, _callee45, this);
	            }));
	
	            function setUserData(_x46) {
	                return _ref97.apply(this, arguments);
	            }
	
	            return setUserData;
	        }()
	    }, {
	        key: 'sendConfirmationEmailCode',
	        value: function () {
	            var _ref99 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(code) {
	                return _regenerator2.default.wrap(function _callee46$(_context46) {
	                    while (1) {
	                        switch (_context46.prev = _context46.next) {
	                            case 0:
	                                return _context46.abrupt('return', this.client('/account/email-confirmation/' + code).then(function (_ref100) {
	                                    var data = _ref100.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context46.stop();
	                        }
	                    }
	                }, _callee46, this);
	            }));
	
	            function sendConfirmationEmailCode(_x47) {
	                return _ref99.apply(this, arguments);
	            }
	
	            return sendConfirmationEmailCode;
	        }()
	
	        //Запрос статуса отмены/возврата транзакции
	
	    }, {
	        key: 'getTransactionStatus',
	        value: function () {
	            var _ref101 = _asyncToGenerator(_regenerator2.default.mark(function _callee47(transactionId) {
	                return _regenerator2.default.wrap(function _callee47$(_context47) {
	                    while (1) {
	                        switch (_context47.prev = _context47.next) {
	                            case 0:
	                                return _context47.abrupt('return', this.client('/transaction/status/' + transactionId).then(function (_ref102) {
	                                    var data = _ref102.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context47.stop();
	                        }
	                    }
	                }, _callee47, this);
	            }));
	
	            function getTransactionStatus(_x48) {
	                return _ref101.apply(this, arguments);
	            }
	
	            return getTransactionStatus;
	        }()
	
	        //Запрос отмены/возврата
	
	    }, {
	        key: 'makeTransactionCancel',
	        value: function () {
	            var _ref103 = _asyncToGenerator(_regenerator2.default.mark(function _callee48(transactionId, amount) {
	                return _regenerator2.default.wrap(function _callee48$(_context48) {
	                    while (1) {
	                        switch (_context48.prev = _context48.next) {
	                            case 0:
	                                return _context48.abrupt('return', this.client.post('/transaction/cancel/', { transactionId: transactionId, amount: amount }).then(function (_ref104) {
	                                    var data = _ref104.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context48.stop();
	                        }
	                    }
	                }, _callee48, this);
	            }));
	
	            function makeTransactionCancel(_x49, _x50) {
	                return _ref103.apply(this, arguments);
	            }
	
	            return makeTransactionCancel;
	        }()
	
	        //Обновление имени и меток реестра
	
	    }, {
	        key: 'updateRegistryData',
	        value: function () {
	            var _ref105 = _asyncToGenerator(_regenerator2.default.mark(function _callee49(id, form) {
	                return _regenerator2.default.wrap(function _callee49$(_context49) {
	                    while (1) {
	                        switch (_context49.prev = _context49.next) {
	                            case 0:
	                                return _context49.abrupt('return', this.client.post('/merchant/payout/registry/' + id + '/edit', form).then(function (_ref106) {
	                                    var data = _ref106.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context49.stop();
	                        }
	                    }
	                }, _callee49, this);
	            }));
	
	            function updateRegistryData(_x51, _x52) {
	                return _ref105.apply(this, arguments);
	            }
	
	            return updateRegistryData;
	        }()
	
	        // Запрос сброса пароля
	
	    }, {
	        key: 'passwordResetRequest',
	        value: function () {
	            var _ref107 = _asyncToGenerator(_regenerator2.default.mark(function _callee50(identifier) {
	                return _regenerator2.default.wrap(function _callee50$(_context50) {
	                    while (1) {
	                        switch (_context50.prev = _context50.next) {
	                            case 0:
	                                return _context50.abrupt('return', this.client.post("/password-reset/request", { identifier: identifier }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context50.stop();
	                        }
	                    }
	                }, _callee50, this);
	            }));
	
	            function passwordResetRequest(_x53) {
	                return _ref107.apply(this, arguments);
	            }
	
	            return passwordResetRequest;
	        }()
	
	        // Запрос изменения пароля по коду
	
	    }, {
	        key: 'passwordResetVerify',
	        value: function () {
	            var _ref108 = _asyncToGenerator(_regenerator2.default.mark(function _callee51(identifier, code) {
	                return _regenerator2.default.wrap(function _callee51$(_context51) {
	                    while (1) {
	                        switch (_context51.prev = _context51.next) {
	                            case 0:
	                                return _context51.abrupt('return', this.client.post("/password-reset/verify", { identifier: identifier, code: code }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context51.stop();
	                        }
	                    }
	                }, _callee51, this);
	            }));
	
	            function passwordResetVerify(_x54, _x55) {
	                return _ref108.apply(this, arguments);
	            }
	
	            return passwordResetVerify;
	        }()
	
	        //Создание контракта
	
	    }, {
	        key: 'createMetalContract',
	        value: function () {
	            var _ref109 = _asyncToGenerator(_regenerator2.default.mark(function _callee52(form) {
	                return _regenerator2.default.wrap(function _callee52$(_context52) {
	                    while (1) {
	                        switch (_context52.prev = _context52.next) {
	                            case 0:
	                                return _context52.abrupt('return', this.client.post('/merchant/psa/contracts', form));
	
	                            case 1:
	                            case 'end':
	                                return _context52.stop();
	                        }
	                    }
	                }, _callee52, this);
	            }));
	
	            function createMetalContract(_x56) {
	                return _ref109.apply(this, arguments);
	            }
	
	            return createMetalContract;
	        }()
	
	        //Изменение контракта
	
	    }, {
	        key: 'updateMetalContract',
	        value: function () {
	            var _ref110 = _asyncToGenerator(_regenerator2.default.mark(function _callee53(id, form) {
	                return _regenerator2.default.wrap(function _callee53$(_context53) {
	                    while (1) {
	                        switch (_context53.prev = _context53.next) {
	                            case 0:
	                                return _context53.abrupt('return', this.client.post('/merchant/psa/contracts/' + id, form));
	
	                            case 1:
	                            case 'end':
	                                return _context53.stop();
	                        }
	                    }
	                }, _callee53, this);
	            }));
	
	            function updateMetalContract(_x57, _x58) {
	                return _ref110.apply(this, arguments);
	            }
	
	            return updateMetalContract;
	        }()
	
	        //Удаление контракта
	
	    }, {
	        key: 'deleteMetalContract',
	        value: function () {
	            var _ref111 = _asyncToGenerator(_regenerator2.default.mark(function _callee54(id) {
	                return _regenerator2.default.wrap(function _callee54$(_context54) {
	                    while (1) {
	                        switch (_context54.prev = _context54.next) {
	                            case 0:
	                                return _context54.abrupt('return', this.client.delete('/merchant/psa/contracts/' + id));
	
	                            case 1:
	                            case 'end':
	                                return _context54.stop();
	                        }
	                    }
	                }, _callee54, this);
	            }));
	
	            function deleteMetalContract(_x59) {
	                return _ref111.apply(this, arguments);
	            }
	
	            return deleteMetalContract;
	        }()
	
	        //ПОлучение контракта по ID
	
	    }, {
	        key: 'getMetalContract',
	        value: function () {
	            var _ref112 = _asyncToGenerator(_regenerator2.default.mark(function _callee55(id) {
	                return _regenerator2.default.wrap(function _callee55$(_context55) {
	                    while (1) {
	                        switch (_context55.prev = _context55.next) {
	                            case 0:
	                                return _context55.abrupt('return', this.client('/merchant/psa/contracts/' + id).then(function (_ref113) {
	                                    var data = _ref113.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context55.stop();
	                        }
	                    }
	                }, _callee55, this);
	            }));
	
	            function getMetalContract(_x60) {
	                return _ref112.apply(this, arguments);
	            }
	
	            return getMetalContract;
	        }()
	
	        //Все контракты
	
	    }, {
	        key: 'getMetalContracts',
	        value: function () {
	            var _ref114 = _asyncToGenerator(_regenerator2.default.mark(function _callee56() {
	                return _regenerator2.default.wrap(function _callee56$(_context56) {
	                    while (1) {
	                        switch (_context56.prev = _context56.next) {
	                            case 0:
	                                return _context56.abrupt('return', this.client.get('/merchant/psa/contracts').then(function (_ref115) {
	                                    var data = _ref115.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context56.stop();
	                        }
	                    }
	                }, _callee56, this);
	            }));
	
	            function getMetalContracts() {
	                return _ref114.apply(this, arguments);
	            }
	
	            return getMetalContracts;
	        }()
	
	        //Список контрактов
	
	    }, {
	        key: 'getListMetalContracts',
	        value: function () {
	            var _ref116 = _asyncToGenerator(_regenerator2.default.mark(function _callee57(data) {
	                return _regenerator2.default.wrap(function _callee57$(_context57) {
	                    while (1) {
	                        switch (_context57.prev = _context57.next) {
	                            case 0:
	                                return _context57.abrupt('return', this.client.get('/merchant/psa/contracts', {
	                                    params: {
	                                        page: data.page,
	                                        itemsPerPage: data.itemsPerPage,
	                                        projects: data.projects
	                                    }
	                                }).then(function (_ref117) {
	                                    var data = _ref117.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context57.stop();
	                        }
	                    }
	                }, _callee57, this);
	            }));
	
	            function getListMetalContracts(_x61) {
	                return _ref116.apply(this, arguments);
	            }
	
	            return getListMetalContracts;
	        }()
	
	        //Создание ПСА
	
	    }, {
	        key: 'createPsa',
	        value: function () {
	            var _ref118 = _asyncToGenerator(_regenerator2.default.mark(function _callee58(form) {
	                return _regenerator2.default.wrap(function _callee58$(_context58) {
	                    while (1) {
	                        switch (_context58.prev = _context58.next) {
	                            case 0:
	                                return _context58.abrupt('return', this.client.post('/merchant/psa/items', form));
	
	                            case 1:
	                            case 'end':
	                                return _context58.stop();
	                        }
	                    }
	                }, _callee58, this);
	            }));
	
	            function createPsa(_x62) {
	                return _ref118.apply(this, arguments);
	            }
	
	            return createPsa;
	        }()
	
	        //Полуение ПСА
	
	    }, {
	        key: 'getPsa',
	        value: function () {
	            var _ref119 = _asyncToGenerator(_regenerator2.default.mark(function _callee59(id) {
	                return _regenerator2.default.wrap(function _callee59$(_context59) {
	                    while (1) {
	                        switch (_context59.prev = _context59.next) {
	                            case 0:
	                                return _context59.abrupt('return', this.client('/merchant/psa/items/' + id).then(function (_ref120) {
	                                    var data = _ref120.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context59.stop();
	                        }
	                    }
	                }, _callee59, this);
	            }));
	
	            function getPsa(_x63) {
	                return _ref119.apply(this, arguments);
	            }
	
	            return getPsa;
	        }()
	
	        //Сохранение ПСА
	
	    }, {
	        key: 'downloadPsa',
	        value: function () {
	            var _ref121 = _asyncToGenerator(_regenerator2.default.mark(function _callee60(id) {
	                return _regenerator2.default.wrap(function _callee60$(_context60) {
	                    while (1) {
	                        switch (_context60.prev = _context60.next) {
	                            case 0:
	                                return _context60.abrupt('return', this.client('/merchant/psa/items/' + id + '/xls', { responseType: 'arraybuffer' }));
	
	                            case 1:
	                            case 'end':
	                                return _context60.stop();
	                        }
	                    }
	                }, _callee60, this);
	            }));
	
	            function downloadPsa(_x64) {
	                return _ref121.apply(this, arguments);
	            }
	
	            return downloadPsa;
	        }()
	
	        //Удаление ПСА
	
	    }, {
	        key: 'deletePsa',
	        value: function () {
	            var _ref122 = _asyncToGenerator(_regenerator2.default.mark(function _callee61(id) {
	                return _regenerator2.default.wrap(function _callee61$(_context61) {
	                    while (1) {
	                        switch (_context61.prev = _context61.next) {
	                            case 0:
	                                return _context61.abrupt('return', this.client.delete('/merchant/psa/items/' + id));
	
	                            case 1:
	                            case 'end':
	                                return _context61.stop();
	                        }
	                    }
	                }, _callee61, this);
	            }));
	
	            function deletePsa(_x65) {
	                return _ref122.apply(this, arguments);
	            }
	
	            return deletePsa;
	        }()
	
	        //Получение списка ПСА
	
	    }, {
	        key: 'getPsaItems',
	        value: function () {
	            var _ref123 = _asyncToGenerator(_regenerator2.default.mark(function _callee62(data) {
	                return _regenerator2.default.wrap(function _callee62$(_context62) {
	                    while (1) {
	                        switch (_context62.prev = _context62.next) {
	                            case 0:
	                                return _context62.abrupt('return', this.client('/merchant/psa/items', {
	                                    params: data
	                                }).then(function (_ref124) {
	                                    var data = _ref124.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context62.stop();
	                        }
	                    }
	                }, _callee62, this);
	            }));
	
	            function getPsaItems(_x66) {
	                return _ref123.apply(this, arguments);
	            }
	
	            return getPsaItems;
	        }()
	
	        //Обновление настроек двухфакторной авторизации
	
	    }, {
	        key: 'setOTPUpdate',
	        value: function () {
	            var _ref125 = _asyncToGenerator(_regenerator2.default.mark(function _callee63(options) {
	                var clone;
	                return _regenerator2.default.wrap(function _callee63$(_context63) {
	                    while (1) {
	                        switch (_context63.prev = _context63.next) {
	                            case 0:
	                                clone = Object.assign({}, options);
	
	
	                                if (clone.OTPPhoneNumber) clone.OTPPhoneNumber = Number(clone.OTPPhoneNumber);
	
	                                if (clone.code) {
	                                    delete clone.OTPPhoneNumber;
	                                    delete clone.OTPEmail;
	                                    delete clone.OTPProvider;
	                                }
	
	                                return _context63.abrupt('return', this.client.post('/account/otp', clone).then(function (response) {
	                                    return response;
	                                }));
	
	                            case 4:
	                            case 'end':
	                                return _context63.stop();
	                        }
	                    }
	                }, _callee63, this);
	            }));
	
	            function setOTPUpdate(_x67) {
	                return _ref125.apply(this, arguments);
	            }
	
	            return setOTPUpdate;
	        }()
	
	        // Закрытие транзакции
	
	    }, {
	        key: 'declineTransaction',
	        value: function () {
	            var _ref126 = _asyncToGenerator(_regenerator2.default.mark(function _callee64(transactionId) {
	                return _regenerator2.default.wrap(function _callee64$(_context64) {
	                    while (1) {
	                        switch (_context64.prev = _context64.next) {
	                            case 0:
	                                return _context64.abrupt('return', this.client.post('/transaction/decline/', { transactionId: transactionId }).then(function (_ref127) {
	                                    var data = _ref127.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context64.stop();
	                        }
	                    }
	                }, _callee64, this);
	            }));
	
	            function declineTransaction(_x68) {
	                return _ref126.apply(this, arguments);
	            }
	
	            return declineTransaction;
	        }()
	
	        // перевод в успех
	
	    }, {
	        key: 'payoutTransaction',
	        value: function () {
	            var _ref128 = _asyncToGenerator(_regenerator2.default.mark(function _callee65(transactionId) {
	                return _regenerator2.default.wrap(function _callee65$(_context65) {
	                    while (1) {
	                        switch (_context65.prev = _context65.next) {
	                            case 0:
	                                return _context65.abrupt('return', this.client.post('/transaction/payout/', { transactionId: transactionId }).then(function (_ref129) {
	                                    var data = _ref129.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context65.stop();
	                        }
	                    }
	                }, _callee65, this);
	            }));
	
	            function payoutTransaction(_x69) {
	                return _ref128.apply(this, arguments);
	            }
	
	            return payoutTransaction;
	        }()
	
	        // Повторная отправка уведомления мерчанту по транзакции (только админы).
	        // Формат и адрес выбирает бэкенд; для депозита агента это повтор доставки.
	        // Отклонённый депозит отвечает 409 с needsConfirmation — повторный вызов
	        // с {reopenDeclined: true} открывает его заново и при успехе зачисляет.
	
	    }, {
	        key: 'resendTransactionCallback',
	        value: function () {
	            var _ref130 = _asyncToGenerator(_regenerator2.default.mark(function _callee66(transactionId) {
	                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	                return _regenerator2.default.wrap(function _callee66$(_context66) {
	                    while (1) {
	                        switch (_context66.prev = _context66.next) {
	                            case 0:
	                                return _context66.abrupt('return', this.client.post('/admin/transactions/' + transactionId + '/resend-callback', options).then(function (_ref131) {
	                                    var data = _ref131.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context66.stop();
	                        }
	                    }
	                }, _callee66, this);
	            }));
	
	            function resendTransactionCallback(_x71) {
	                return _ref130.apply(this, arguments);
	            }
	
	            return resendTransactionCallback;
	        }()
	
	        //Получение списка предоплаченных карт
	
	    }, {
	        key: 'getPreActivatedCardsList',
	        value: function () {
	            var _ref132 = _asyncToGenerator(_regenerator2.default.mark(function _callee67(id) {
	                return _regenerator2.default.wrap(function _callee67$(_context67) {
	                    while (1) {
	                        switch (_context67.prev = _context67.next) {
	                            case 0:
	                                return _context67.abrupt('return', this.client('/merchant/preactivatedcards/list').then(function (_ref133) {
	                                    var data = _ref133.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context67.stop();
	                        }
	                    }
	                }, _callee67, this);
	            }));
	
	            function getPreActivatedCardsList(_x72) {
	                return _ref132.apply(this, arguments);
	            }
	
	            return getPreActivatedCardsList;
	        }()
	
	        //Отправка формы активации карты
	
	    }, {
	        key: 'setPreActivatedCardActivate',
	        value: function () {
	            var _ref134 = _asyncToGenerator(_regenerator2.default.mark(function _callee68(ean, form) {
	                var convertToUtcDate, clone;
	                return _regenerator2.default.wrap(function _callee68$(_context68) {
	                    while (1) {
	                        switch (_context68.prev = _context68.next) {
	                            case 0:
	                                convertToUtcDate = function convertToUtcDate(date) {
	                                    if (date) {
	                                        var tempdata = new Date(date);
	                                        var year = tempdata.getFullYear();
	                                        var month = tempdata.getMonth();
	                                        var day = tempdata.getDate();
	                                        return new Date(Date.UTC(year, month, day));
	                                    } else return null;
	                                };
	
	                                clone = JSON.parse(JSON.stringify(form));
	
	
	                                clone.docSerial = form.docSerial.replace(/\s+/g, '');
	                                clone.gender = form.gender.id;
	                                clone.birthCountry = form.birthCountry.id;
	                                clone.docIssuedDate = convertToUtcDate(form.docIssuedDate);
	                                clone.birthday = convertToUtcDate(form.birthday);
	                                clone.legalAddress = {
	                                    value: form.legalAddress.value,
	                                    country: form.legalAddress.data.country,
	                                    region: form.legalAddress.data.federal_district,
	                                    district: form.legalAddress.data.region_with_type,
	                                    street: form.legalAddress.data.street_with_type,
	                                    city: form.legalAddress.data.city_with_type != null ? form.legalAddress.data.city_with_type : form.legalAddress.data.region_with_type
	                                };
	
	                                clone.residenceAddress = {
	                                    value: form.residenceAddress.value,
	                                    country: form.residenceAddress.data.country,
	                                    region: form.residenceAddress.data.federal_district,
	                                    district: form.residenceAddress.data.region_with_type,
	                                    street: form.residenceAddress.data.street_with_type,
	                                    city: form.residenceAddress.data.city_with_type != null ? form.residenceAddress.data.city_with_type : form.residenceAddress.data.region_with_type
	
	                                };
	
	                                return _context68.abrupt('return', this.client.post('/merchant/preactivatedcards/' + ean + '/activate', clone).then(function (_ref135) {
	                                    var data = _ref135.data;
	                                    return data;
	                                }));
	
	                            case 10:
	                            case 'end':
	                                return _context68.stop();
	                        }
	                    }
	                }, _callee68, this);
	            }));
	
	            function setPreActivatedCardActivate(_x73, _x74) {
	                return _ref134.apply(this, arguments);
	            }
	
	            return setPreActivatedCardActivate;
	        }()
	
	        //Получение списка предоплаченных карт
	
	    }, {
	        key: 'getPreActivatedCardDetails',
	        value: function () {
	            var _ref136 = _asyncToGenerator(_regenerator2.default.mark(function _callee69(ean) {
	                return _regenerator2.default.wrap(function _callee69$(_context69) {
	                    while (1) {
	                        switch (_context69.prev = _context69.next) {
	                            case 0:
	                                return _context69.abrupt('return', this.client('/merchant/preactivatedcards/' + ean + '/info').then(function (_ref137) {
	                                    var data = _ref137.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context69.stop();
	                        }
	                    }
	                }, _callee69, this);
	            }));
	
	            function getPreActivatedCardDetails(_x75) {
	                return _ref136.apply(this, arguments);
	            }
	
	            return getPreActivatedCardDetails;
	        }()
	
	        //Administrators API
	
	        // Получение списка аккаунтов
	
	    }, {
	        key: 'getAccountsList',
	        value: function () {
	            var _ref138 = _asyncToGenerator(_regenerator2.default.mark(function _callee70(filters) {
	                return _regenerator2.default.wrap(function _callee70$(_context70) {
	                    while (1) {
	                        switch (_context70.prev = _context70.next) {
	                            case 0:
	                                return _context70.abrupt('return', this.client.post('/accounts/list', filters).then(function (_ref139) {
	                                    var data = _ref139.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context70.stop();
	                        }
	                    }
	                }, _callee70, this);
	            }));
	
	            function getAccountsList(_x76) {
	                return _ref138.apply(this, arguments);
	            }
	
	            return getAccountsList;
	        }()
	
	        // Получение списка аккаунтов
	
	    }, {
	        key: 'postFrodList',
	        value: function () {
	            var _ref140 = _asyncToGenerator(_regenerator2.default.mark(function _callee71(uuid, filters) {
	                return _regenerator2.default.wrap(function _callee71$(_context71) {
	                    while (1) {
	                        switch (_context71.prev = _context71.next) {
	                            case 0:
	                                return _context71.abrupt('return', this.client.post('/merchant/' + uuid + '/fraud-log', filters).then(function (_ref141) {
	                                    var data = _ref141.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context71.stop();
	                        }
	                    }
	                }, _callee71, this);
	            }));
	
	            function postFrodList(_x77, _x78) {
	                return _ref140.apply(this, arguments);
	            }
	
	            return postFrodList;
	        }()
	
	        // Получение данных аккаунта
	
	    }, {
	        key: 'getAccountData',
	        value: function () {
	            var _ref142 = _asyncToGenerator(_regenerator2.default.mark(function _callee72(id) {
	                return _regenerator2.default.wrap(function _callee72$(_context72) {
	                    while (1) {
	                        switch (_context72.prev = _context72.next) {
	                            case 0:
	                                return _context72.abrupt('return', this.client('/account/' + id).then(function (_ref143) {
	                                    var data = _ref143.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context72.stop();
	                        }
	                    }
	                }, _callee72, this);
	            }));
	
	            function getAccountData(_x79) {
	                return _ref142.apply(this, arguments);
	            }
	
	            return getAccountData;
	        }()
	
	        // Изминение аккаунта
	
	    }, {
	        key: 'setAccountData',
	        value: function () {
	            var _ref144 = _asyncToGenerator(_regenerator2.default.mark(function _callee73(id, data) {
	                return _regenerator2.default.wrap(function _callee73$(_context73) {
	                    while (1) {
	                        switch (_context73.prev = _context73.next) {
	                            case 0:
	                                return _context73.abrupt('return', this.client.post('/account/' + id, data).then(function (_ref145) {
	                                    var data = _ref145.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context73.stop();
	                        }
	                    }
	                }, _callee73, this);
	            }));
	
	            function setAccountData(_x80, _x81) {
	                return _ref144.apply(this, arguments);
	            }
	
	            return setAccountData;
	        }()
	
	        // Установка антифрода
	
	    }, {
	        key: 'setFrodData',
	        value: function () {
	            var _ref146 = _asyncToGenerator(_regenerator2.default.mark(function _callee74(uuid, data) {
	                return _regenerator2.default.wrap(function _callee74$(_context74) {
	                    while (1) {
	                        switch (_context74.prev = _context74.next) {
	                            case 0:
	                                return _context74.abrupt('return', this.client.put('/merchant/' + uuid + '/frod', data).then(function (_ref147) {
	                                    var data = _ref147.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context74.stop();
	                        }
	                    }
	                }, _callee74, this);
	            }));
	
	            function setFrodData(_x82, _x83) {
	                return _ref146.apply(this, arguments);
	            }
	
	            return setFrodData;
	        }()
	
	        // Установка настроек виджета
	
	    }, {
	        key: 'setWidgetData',
	        value: function () {
	            var _ref148 = _asyncToGenerator(_regenerator2.default.mark(function _callee75(uuid, data) {
	                return _regenerator2.default.wrap(function _callee75$(_context75) {
	                    while (1) {
	                        switch (_context75.prev = _context75.next) {
	                            case 0:
	                                return _context75.abrupt('return', this.client.put('/merchant/' + uuid + '/widget', data).then(function (_ref149) {
	                                    var data = _ref149.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context75.stop();
	                        }
	                    }
	                }, _callee75, this);
	            }));
	
	            function setWidgetData(_x84, _x85) {
	                return _ref148.apply(this, arguments);
	            }
	
	            return setWidgetData;
	        }()
	
	        // Создать новый аккаунт
	
	    }, {
	        key: 'addAccount',
	        value: function () {
	            var _ref150 = _asyncToGenerator(_regenerator2.default.mark(function _callee76(data) {
	                return _regenerator2.default.wrap(function _callee76$(_context76) {
	                    while (1) {
	                        switch (_context76.prev = _context76.next) {
	                            case 0:
	                                return _context76.abrupt('return', this.client.post('/account/create', data).then(function (res) {
	                                    return Object.assign({}, res.data, { status: 200 });
	                                }).catch(function (error) {
	                                    var response = error && error.response ? error.response : {};
	                                    var responseData = response.data ? response.data : {};
	                                    var status = response.status ? response.status : 500;
	
	                                    return Object.assign({}, responseData, { status: status });
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context76.stop();
	                        }
	                    }
	                }, _callee76, this);
	            }));
	
	            function addAccount(_x86) {
	                return _ref150.apply(this, arguments);
	            }
	
	            return addAccount;
	        }()
	
	        // Получение списка проектов
	
	    }, {
	        key: 'getProjectsList',
	        value: function () {
	            var _ref151 = _asyncToGenerator(_regenerator2.default.mark(function _callee77(filters) {
	                return _regenerator2.default.wrap(function _callee77$(_context77) {
	                    while (1) {
	                        switch (_context77.prev = _context77.next) {
	                            case 0:
	                                return _context77.abrupt('return', this.client.post('/merchants/list', filters).then(function (_ref152) {
	                                    var data = _ref152.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context77.stop();
	                        }
	                    }
	                }, _callee77, this);
	            }));
	
	            function getProjectsList(_x87) {
	                return _ref151.apply(this, arguments);
	            }
	
	            return getProjectsList;
	        }()
	
	        // Поиск аккаунтов
	
	    }, {
	        key: 'makeAccountSearch',
	        value: function () {
	            var _ref153 = _asyncToGenerator(_regenerator2.default.mark(function _callee78(filters) {
	                return _regenerator2.default.wrap(function _callee78$(_context78) {
	                    while (1) {
	                        switch (_context78.prev = _context78.next) {
	                            case 0:
	                                return _context78.abrupt('return', this.client.post('/accounts/search', { search: filters }).then(function (_ref154) {
	                                    var data = _ref154.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context78.stop();
	                        }
	                    }
	                }, _callee78, this);
	            }));
	
	            function makeAccountSearch(_x88) {
	                return _ref153.apply(this, arguments);
	            }
	
	            return makeAccountSearch;
	        }()
	
	        // сброс 2FA
	
	    }, {
	        key: 'resetTwoFactor',
	        value: function () {
	            var _ref155 = _asyncToGenerator(_regenerator2.default.mark(function _callee79(accountId) {
	                return _regenerator2.default.wrap(function _callee79$(_context79) {
	                    while (1) {
	                        switch (_context79.prev = _context79.next) {
	                            case 0:
	                                return _context79.abrupt('return', this.client.post('/account/' + accountId + '/reset-2fa', {}).then(function (_ref156) {
	                                    var data = _ref156.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context79.stop();
	                        }
	                    }
	                }, _callee79, this);
	            }));
	
	            function resetTwoFactor(_x89) {
	                return _ref155.apply(this, arguments);
	            }
	
	            return resetTwoFactor;
	        }()
	
	        // Проверка транзакции
	
	    }, {
	        key: 'checkTransaction',
	        value: function () {
	            var _ref157 = _asyncToGenerator(_regenerator2.default.mark(function _callee80(id) {
	                return _regenerator2.default.wrap(function _callee80$(_context80) {
	                    while (1) {
	                        switch (_context80.prev = _context80.next) {
	                            case 0:
	                                return _context80.abrupt('return', this.client.get('/transaction/' + id + '/check'));
	
	                            case 1:
	                            case 'end':
	                                return _context80.stop();
	                        }
	                    }
	                }, _callee80, this);
	            }));
	
	            function checkTransaction(_x90) {
	                return _ref157.apply(this, arguments);
	            }
	
	            return checkTransaction;
	        }()
	
	        // Аудит транзакции (полная история событий)
	        // Поддерживает поиск по разным полям через searchType: id, uuid, externalRef, hydraId, unlid
	
	    }, {
	        key: 'getTransactionAudit',
	        value: function () {
	            var _ref158 = _asyncToGenerator(_regenerator2.default.mark(function _callee81(searchValue) {
	                var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                var params, _url, queryString, url;
	
	                return _regenerator2.default.wrap(function _callee81$(_context81) {
	                    while (1) {
	                        switch (_context81.prev = _context81.next) {
	                            case 0:
	                                params = new URLSearchParams();
	
	                                // Если указан searchType - используем новый endpoint поиска
	
	                                if (!(filters.searchType && filters.searchType !== 'id')) {
	                                    _context81.next = 8;
	                                    break;
	                                }
	
	                                params.set('q', searchValue);
	                                params.set('searchType', filters.searchType);
	
	                                if (filters.eventTypes && filters.eventTypes.length) {
	                                    params.set('eventTypes', filters.eventTypes.join(','));
	                                }
	                                if (filters.direction) {
	                                    params.set('direction', filters.direction);
	                                }
	
	                                _url = '/transaction/search/audit?' + params.toString();
	                                return _context81.abrupt('return', this.client.get(_url).then(function (_ref159) {
	                                    var data = _ref159.data;
	                                    return data;
	                                }));
	
	                            case 8:
	
	                                // Стандартный поиск по ID
	                                if (filters.eventTypes && filters.eventTypes.length) {
	                                    params.set('eventTypes', filters.eventTypes.join(','));
	                                }
	                                if (filters.actors && filters.actors.length) {
	                                    params.set('actors', filters.actors.join(','));
	                                }
	                                if (filters.direction) {
	                                    params.set('direction', filters.direction);
	                                }
	                                queryString = params.toString();
	                                url = '/transaction/' + searchValue + '/audit' + (queryString ? '?' + queryString : '');
	                                return _context81.abrupt('return', this.client.get(url).then(function (_ref160) {
	                                    var data = _ref160.data;
	                                    return data;
	                                }));
	
	                            case 14:
	                            case 'end':
	                                return _context81.stop();
	                        }
	                    }
	                }, _callee81, this);
	            }));
	
	            function getTransactionAudit(_x92) {
	                return _ref158.apply(this, arguments);
	            }
	
	            return getTransactionAudit;
	        }()
	
	        // Экспорт аудита транзакции
	
	    }, {
	        key: 'exportTransactionAudit',
	        value: function () {
	            var _ref161 = _asyncToGenerator(_regenerator2.default.mark(function _callee82(transactionId) {
	                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';
	                var url;
	                return _regenerator2.default.wrap(function _callee82$(_context82) {
	                    while (1) {
	                        switch (_context82.prev = _context82.next) {
	                            case 0:
	                                url = '/transaction/' + transactionId + '/audit/export?format=' + format;
	                                return _context82.abrupt('return', this.client.get(url, { responseType: 'blob' }).then(function (_ref162) {
	                                    var data = _ref162.data;
	                                    return data;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context82.stop();
	                        }
	                    }
	                }, _callee82, this);
	            }));
	
	            function exportTransactionAudit(_x94) {
	                return _ref161.apply(this, arguments);
	            }
	
	            return exportTransactionAudit;
	        }()
	
	        // === ТЕРМИНАЛЫ (общий список + карточка) ===
	
	    }, {
	        key: 'getTerminalsList',
	        value: function () {
	            var _ref163 = _asyncToGenerator(_regenerator2.default.mark(function _callee83(filters) {
	                return _regenerator2.default.wrap(function _callee83$(_context83) {
	                    while (1) {
	                        switch (_context83.prev = _context83.next) {
	                            case 0:
	                                return _context83.abrupt('return', this.client.post('/terminals/list', filters).then(function (_ref164) {
	                                    var data = _ref164.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context83.stop();
	                        }
	                    }
	                }, _callee83, this);
	            }));
	
	            function getTerminalsList(_x95) {
	                return _ref163.apply(this, arguments);
	            }
	
	            return getTerminalsList;
	        }()
	    }, {
	        key: 'getTerminalData',
	        value: function () {
	            var _ref165 = _asyncToGenerator(_regenerator2.default.mark(function _callee84(terminalId) {
	                return _regenerator2.default.wrap(function _callee84$(_context84) {
	                    while (1) {
	                        switch (_context84.prev = _context84.next) {
	                            case 0:
	                                return _context84.abrupt('return', this.client.get('/terminals/' + terminalId).then(function (_ref166) {
	                                    var data = _ref166.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context84.stop();
	                        }
	                    }
	                }, _callee84, this);
	            }));
	
	            function getTerminalData(_x96) {
	                return _ref165.apply(this, arguments);
	            }
	
	            return getTerminalData;
	        }()
	
	        // Получить баланс из ТКБ по terminalId
	
	    }, {
	        key: 'fetchTerminalBalanceFromTkb',
	        value: function () {
	            var _ref167 = _asyncToGenerator(_regenerator2.default.mark(function _callee85(terminalId) {
	                return _regenerator2.default.wrap(function _callee85$(_context85) {
	                    while (1) {
	                        switch (_context85.prev = _context85.next) {
	                            case 0:
	                                return _context85.abrupt('return', this.client.post('/terminals/' + terminalId + '/balance/fetch', {}).then(function (_ref168) {
	                                    var data = _ref168.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context85.stop();
	                        }
	                    }
	                }, _callee85, this);
	            }));
	
	            function fetchTerminalBalanceFromTkb(_x97) {
	                return _ref167.apply(this, arguments);
	            }
	
	            return fetchTerminalBalanceFromTkb;
	        }()
	
	        // Применить баланс (в копейках) по terminalId
	
	    }, {
	        key: 'applyTerminalBalance',
	        value: function () {
	            var _ref169 = _asyncToGenerator(_regenerator2.default.mark(function _callee86(terminalId, payload) {
	                return _regenerator2.default.wrap(function _callee86$(_context86) {
	                    while (1) {
	                        switch (_context86.prev = _context86.next) {
	                            case 0:
	                                return _context86.abrupt('return', this.client.post('/terminals/' + terminalId + '/balance/apply', payload).then(function (_ref170) {
	                                    var data = _ref170.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context86.stop();
	                        }
	                    }
	                }, _callee86, this);
	            }));
	
	            function applyTerminalBalance(_x98, _x99) {
	                return _ref169.apply(this, arguments);
	            }
	
	            return applyTerminalBalance;
	        }()
	
	        // Изменение суммы транзакции (только админы)
	
	    }, {
	        key: 'changeTransactionAmount',
	        value: function () {
	            var _ref171 = _asyncToGenerator(_regenerator2.default.mark(function _callee87(transactionId, amount) {
	                return _regenerator2.default.wrap(function _callee87$(_context87) {
	                    while (1) {
	                        switch (_context87.prev = _context87.next) {
	                            case 0:
	                                return _context87.abrupt('return', this.client.post('/transaction/amount/', { transactionId: transactionId, amount: amount }).then(function (_ref172) {
	                                    var data = _ref172.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context87.stop();
	                        }
	                    }
	                }, _callee87, this);
	            }));
	
	            function changeTransactionAmount(_x100, _x101) {
	                return _ref171.apply(this, arguments);
	            }
	
	            return changeTransactionAmount;
	        }()
	
	        // Отправка нового пароля на почту
	
	    }, {
	        key: 'sendNewPassword',
	        value: function () {
	            var _ref173 = _asyncToGenerator(_regenerator2.default.mark(function _callee88(id) {
	                return _regenerator2.default.wrap(function _callee88$(_context88) {
	                    while (1) {
	                        switch (_context88.prev = _context88.next) {
	                            case 0:
	                                return _context88.abrupt('return', this.client.post('/account/' + id + '/send-new-password', {}).then(function (_ref174) {
	                                    var data = _ref174.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context88.stop();
	                        }
	                    }
	                }, _callee88, this);
	            }));
	
	            function sendNewPassword(_x102) {
	                return _ref173.apply(this, arguments);
	            }
	
	            return sendNewPassword;
	        }()
	
	        //   Блокировка мерчанта
	
	    }, {
	        key: 'blockMerchant',
	        value: function () {
	            var _ref175 = _asyncToGenerator(_regenerator2.default.mark(function _callee89(uuid) {
	                return _regenerator2.default.wrap(function _callee89$(_context89) {
	                    while (1) {
	                        switch (_context89.prev = _context89.next) {
	                            case 0:
	                                return _context89.abrupt('return', this.client.post('/merchant/' + uuid + '/block').then(function (_ref176) {
	                                    var data = _ref176.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context89.stop();
	                        }
	                    }
	                }, _callee89, this);
	            }));
	
	            function blockMerchant(_x103) {
	                return _ref175.apply(this, arguments);
	            }
	
	            return blockMerchant;
	        }()
	
	        //   Получить список доступных провайдеров (для формы добавления сервиса)
	
	    }, {
	        key: 'getAvailableProviders',
	        value: function () {
	            var _ref177 = _asyncToGenerator(_regenerator2.default.mark(function _callee90() {
	                return _regenerator2.default.wrap(function _callee90$(_context90) {
	                    while (1) {
	                        switch (_context90.prev = _context90.next) {
	                            case 0:
	                                return _context90.abrupt('return', this.client.get('/merchant/providers/get').then(function (_ref178) {
	                                    var data = _ref178.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context90.stop();
	                        }
	                    }
	                }, _callee90, this);
	            }));
	
	            function getAvailableProviders() {
	                return _ref177.apply(this, arguments);
	            }
	
	            return getAvailableProviders;
	        }()
	
	        //   Получить список сервисов (MID) проекта с методами и комиссиями
	
	    }, {
	        key: 'getProjectServices',
	        value: function () {
	            var _ref179 = _asyncToGenerator(_regenerator2.default.mark(function _callee91(uuid) {
	                return _regenerator2.default.wrap(function _callee91$(_context91) {
	                    while (1) {
	                        switch (_context91.prev = _context91.next) {
	                            case 0:
	                                return _context91.abrupt('return', this.client.get('/merchant/' + uuid + '/terminals/full').then(function (_ref180) {
	                                    var data = _ref180.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context91.stop();
	                        }
	                    }
	                }, _callee91, this);
	            }));
	
	            function getProjectServices(_x104) {
	                return _ref179.apply(this, arguments);
	            }
	
	            return getProjectServices;
	        }()
	
	        //   Добавить новый сервис (MID) к проекту
	
	    }, {
	        key: 'addProjectService',
	        value: function () {
	            var _ref181 = _asyncToGenerator(_regenerator2.default.mark(function _callee92(uuid, form) {
	                return _regenerator2.default.wrap(function _callee92$(_context92) {
	                    while (1) {
	                        switch (_context92.prev = _context92.next) {
	                            case 0:
	                                return _context92.abrupt('return', this.client.post('/merchant/' + uuid + '/terminals/add', form).then(function (_ref182) {
	                                    var data = _ref182.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context92.stop();
	                        }
	                    }
	                }, _callee92, this);
	            }));
	
	            function addProjectService(_x105, _x106) {
	                return _ref181.apply(this, arguments);
	            }
	
	            return addProjectService;
	        }()
	
	        //   Обновить методы сервиса (чекбоксы)
	
	    }, {
	        key: 'updateServiceMethods',
	        value: function () {
	            var _ref183 = _asyncToGenerator(_regenerator2.default.mark(function _callee93(uuid, terminalId, methods) {
	                return _regenerator2.default.wrap(function _callee93$(_context93) {
	                    while (1) {
	                        switch (_context93.prev = _context93.next) {
	                            case 0:
	                                return _context93.abrupt('return', this.client.post('/merchant/' + uuid + '/terminals/' + terminalId + '/methods', { methods: methods }).then(function (_ref184) {
	                                    var data = _ref184.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context93.stop();
	                        }
	                    }
	                }, _callee93, this);
	            }));
	
	            function updateServiceMethods(_x107, _x108, _x109) {
	                return _ref183.apply(this, arguments);
	            }
	
	            return updateServiceMethods;
	        }()
	
	        //  Обновить комиссии сервиса
	
	    }, {
	        key: 'updateServiceFees',
	        value: function () {
	            var _ref185 = _asyncToGenerator(_regenerator2.default.mark(function _callee94(uuid, terminalId, fees) {
	                return _regenerator2.default.wrap(function _callee94$(_context94) {
	                    while (1) {
	                        switch (_context94.prev = _context94.next) {
	                            case 0:
	                                return _context94.abrupt('return', this.client.post('/merchant/' + uuid + '/terminals/' + terminalId + '/fees', { fees: fees }).then(function (_ref186) {
	                                    var data = _ref186.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context94.stop();
	                        }
	                    }
	                }, _callee94, this);
	            }));
	
	            function updateServiceFees(_x110, _x111, _x112) {
	                return _ref185.apply(this, arguments);
	            }
	
	            return updateServiceFees;
	        }()
	
	        //  Обновить authData (логин/ключ и т.д.)
	
	    }, {
	        key: 'updateServiceAuthData',
	        value: function () {
	            var _ref187 = _asyncToGenerator(_regenerator2.default.mark(function _callee95(uuid, terminalId, authData) {
	                return _regenerator2.default.wrap(function _callee95$(_context95) {
	                    while (1) {
	                        switch (_context95.prev = _context95.next) {
	                            case 0:
	                                return _context95.abrupt('return', this.client.post('/merchant/' + uuid + '/terminals/' + terminalId + '/auth', { authData: authData }).then(function (_ref188) {
	                                    var data = _ref188.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context95.stop();
	                        }
	                    }
	                }, _callee95, this);
	            }));
	
	            function updateServiceAuthData(_x113, _x114, _x115) {
	                return _ref187.apply(this, arguments);
	            }
	
	            return updateServiceAuthData;
	        }()
	
	        //  Сменить провайдера у сервиса
	
	    }, {
	        key: 'updateServiceProvider',
	        value: function () {
	            var _ref189 = _asyncToGenerator(_regenerator2.default.mark(function _callee96(uuid, terminalId, providerUuid) {
	                return _regenerator2.default.wrap(function _callee96$(_context96) {
	                    while (1) {
	                        switch (_context96.prev = _context96.next) {
	                            case 0:
	                                return _context96.abrupt('return', this.client.patch('/merchant/' + uuid + '/terminals/' + terminalId + '/provider', { providerUuid: providerUuid }).then(function (_ref190) {
	                                    var data = _ref190.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context96.stop();
	                        }
	                    }
	                }, _callee96, this);
	            }));
	
	            function updateServiceProvider(_x116, _x117, _x118) {
	                return _ref189.apply(this, arguments);
	            }
	
	            return updateServiceProvider;
	        }()
	
	        //  Удалить сервис (MID)
	
	    }, {
	        key: 'deleteProjectService',
	        value: function () {
	            var _ref191 = _asyncToGenerator(_regenerator2.default.mark(function _callee97(uuid, terminalId) {
	                return _regenerator2.default.wrap(function _callee97$(_context97) {
	                    while (1) {
	                        switch (_context97.prev = _context97.next) {
	                            case 0:
	                                return _context97.abrupt('return', this.client.delete('/merchant/' + uuid + '/terminals/' + terminalId).then(function (_ref192) {
	                                    var data = _ref192.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context97.stop();
	                        }
	                    }
	                }, _callee97, this);
	            }));
	
	            function deleteProjectService(_x119, _x120) {
	                return _ref191.apply(this, arguments);
	            }
	
	            return deleteProjectService;
	        }()
	
	        // постмэн
	
	    }, {
	        key: 'hydroPost',
	        value: function () {
	            var _ref193 = _asyncToGenerator(_regenerator2.default.mark(function _callee98(data) {
	                return _regenerator2.default.wrap(function _callee98$(_context98) {
	                    while (1) {
	                        switch (_context98.prev = _context98.next) {
	                            case 0:
	                                return _context98.abrupt('return', this.client.post('/hydra/emulate', data).then(function (_ref194) {
	                                    var data = _ref194.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context98.stop();
	                        }
	                    }
	                }, _callee98, this);
	            }));
	
	            function hydroPost(_x121) {
	                return _ref193.apply(this, arguments);
	            }
	
	            return hydroPost;
	        }()
	
	        // Получить всю инфу по мерчанту
	
	    }, {
	        key: 'getFullMerchant',
	        value: function () {
	            var _ref195 = _asyncToGenerator(_regenerator2.default.mark(function _callee99(uuid) {
	                return _regenerator2.default.wrap(function _callee99$(_context99) {
	                    while (1) {
	                        switch (_context99.prev = _context99.next) {
	                            case 0:
	                                return _context99.abrupt('return', this.client.get('/merchant/' + uuid + '/full').then(function (_ref196) {
	                                    var data = _ref196.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context99.stop();
	                        }
	                    }
	                }, _callee99, this);
	            }));
	
	            function getFullMerchant(_x122) {
	                return _ref195.apply(this, arguments);
	            }
	
	            return getFullMerchant;
	        }()
	
	        // ====== MERCHANT SETTINGS (MerchantSettings) ======
	
	        // создать настройку (привязка provider + terminal + data)
	
	    }, {
	        key: 'createMerchantSetting',
	        value: function () {
	            var _ref197 = _asyncToGenerator(_regenerator2.default.mark(function _callee100(uuid, payload) {
	                return _regenerator2.default.wrap(function _callee100$(_context100) {
	                    while (1) {
	                        switch (_context100.prev = _context100.next) {
	                            case 0:
	                                return _context100.abrupt('return', this.client.post('/merchant/' + uuid + '/settings', payload).then(function (_ref198) {
	                                    var data = _ref198.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context100.stop();
	                        }
	                    }
	                }, _callee100, this);
	            }));
	
	            function createMerchantSetting(_x123, _x124) {
	                return _ref197.apply(this, arguments);
	            }
	
	            return createMerchantSetting;
	        }()
	
	        // обновить настройку
	
	    }, {
	        key: 'updateMerchantSetting',
	        value: function () {
	            var _ref199 = _asyncToGenerator(_regenerator2.default.mark(function _callee101(uuid, settingId, payload) {
	                return _regenerator2.default.wrap(function _callee101$(_context101) {
	                    while (1) {
	                        switch (_context101.prev = _context101.next) {
	                            case 0:
	                                return _context101.abrupt('return', this.client.post('/merchant/' + uuid + '/settings/' + settingId, payload).then(function (_ref200) {
	                                    var data = _ref200.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context101.stop();
	                        }
	                    }
	                }, _callee101, this);
	            }));
	
	            function updateMerchantSetting(_x125, _x126, _x127) {
	                return _ref199.apply(this, arguments);
	            }
	
	            return updateMerchantSetting;
	        }()
	
	        // удалить настройку
	
	    }, {
	        key: 'deleteMerchantSetting',
	        value: function () {
	            var _ref201 = _asyncToGenerator(_regenerator2.default.mark(function _callee102(uuid, settingId) {
	                return _regenerator2.default.wrap(function _callee102$(_context102) {
	                    while (1) {
	                        switch (_context102.prev = _context102.next) {
	                            case 0:
	                                return _context102.abrupt('return', this.client.delete('/merchant/' + uuid + '/settings/' + settingId).then(function (_ref202) {
	                                    var data = _ref202.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context102.stop();
	                        }
	                    }
	                }, _callee102, this);
	            }));
	
	            function deleteMerchantSetting(_x128, _x129) {
	                return _ref201.apply(this, arguments);
	            }
	
	            return deleteMerchantSetting;
	        }()
	
	        // ====== TERMINALS ======
	
	        // создать терминал
	
	    }, {
	        key: 'createTerminal',
	        value: function () {
	            var _ref203 = _asyncToGenerator(_regenerator2.default.mark(function _callee103(uuid, payload) {
	                return _regenerator2.default.wrap(function _callee103$(_context103) {
	                    while (1) {
	                        switch (_context103.prev = _context103.next) {
	                            case 0:
	                                return _context103.abrupt('return', this.client.post('/merchant/' + uuid + '/terminals', payload).then(function (_ref204) {
	                                    var data = _ref204.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context103.stop();
	                        }
	                    }
	                }, _callee103, this);
	            }));
	
	            function createTerminal(_x130, _x131) {
	                return _ref203.apply(this, arguments);
	            }
	
	            return createTerminal;
	        }()
	
	        // обновить терминал (универсальный PATCH)
	
	    }, {
	        key: 'updateTerminal',
	        value: function () {
	            var _ref205 = _asyncToGenerator(_regenerator2.default.mark(function _callee104(uuid, terminalId, payload) {
	                return _regenerator2.default.wrap(function _callee104$(_context104) {
	                    while (1) {
	                        switch (_context104.prev = _context104.next) {
	                            case 0:
	                                return _context104.abrupt('return', this.client.post('/merchant/' + uuid + '/terminals/' + terminalId, payload).then(function (_ref206) {
	                                    var data = _ref206.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context104.stop();
	                        }
	                    }
	                }, _callee104, this);
	            }));
	
	            function updateTerminal(_x132, _x133, _x134) {
	                return _ref205.apply(this, arguments);
	            }
	
	            return updateTerminal;
	        }()
	
	        // Изминение проекта
	        // Api.js
	
	    }, {
	        key: 'setProjectData',
	        value: function () {
	            var _ref207 = _asyncToGenerator(_regenerator2.default.mark(function _callee105(uuid, data) {
	                var tmp;
	                return _regenerator2.default.wrap(function _callee105$(_context105) {
	                    while (1) {
	                        switch (_context105.prev = _context105.next) {
	                            case 0:
	                                // аккуратно собираем полезные поля
	                                tmp = {
	                                    name: data.name,
	                                    description: data.description,
	                                    url: data.url,
	                                    status: data.status,
	                                    inn: data.inn,
	                                    kpp: data.kpp,
	                                    ogrn: data.ogrn
	                                };
	
	                                // если accounts есть — добавим, если нет — не трогаем
	
	                                if (Array.isArray(data.accounts)) {
	                                    tmp.accounts = data.accounts.map(function (a) {
	                                        return a && a.id ? a.id : a;
	                                    });
	                                }
	
	                                return _context105.abrupt('return', this.client.post('/merchant/' + uuid + '/update', tmp).then(function (_ref208) {
	                                    var data = _ref208.data;
	                                    return data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context105.stop();
	                        }
	                    }
	                }, _callee105, this);
	            }));
	
	            function setProjectData(_x135, _x136) {
	                return _ref207.apply(this, arguments);
	            }
	
	            return setProjectData;
	        }()
	
	        // Создать новый проект
	
	    }, {
	        key: 'addProject',
	        value: function () {
	            var _ref209 = _asyncToGenerator(_regenerator2.default.mark(function _callee106(data) {
	                return _regenerator2.default.wrap(function _callee106$(_context106) {
	                    while (1) {
	                        switch (_context106.prev = _context106.next) {
	                            case 0:
	                                return _context106.abrupt('return', this.client.post('/merchant/create', data).then(function (_ref210) {
	                                    var data = _ref210.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context106.stop();
	                        }
	                    }
	                }, _callee106, this);
	            }));
	
	            function addProject(_x137) {
	                return _ref209.apply(this, arguments);
	            }
	
	            return addProject;
	        }()
	
	        // Получить схему (если используешь)
	
	    }, {
	        key: 'getUiDescribe',
	        value: function () {
	            var _ref211 = _asyncToGenerator(_regenerator2.default.mark(function _callee107() {
	                return _regenerator2.default.wrap(function _callee107$(_context107) {
	                    while (1) {
	                        switch (_context107.prev = _context107.next) {
	                            case 0:
	                                return _context107.abrupt('return', this.client.post('/postman/describe', {}).then(function (_ref212) {
	                                    var data = _ref212.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context107.stop();
	                        }
	                    }
	                }, _callee107, this);
	            }));
	
	            function getUiDescribe() {
	                return _ref211.apply(this, arguments);
	            }
	
	            return getUiDescribe;
	        }()
	
	        // Мерчанты
	
	    }, {
	        key: 'listMerchants',
	        value: function () {
	            var _ref213 = _asyncToGenerator(_regenerator2.default.mark(function _callee108() {
	                var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	                return _regenerator2.default.wrap(function _callee108$(_context108) {
	                    while (1) {
	                        switch (_context108.prev = _context108.next) {
	                            case 0:
	                                return _context108.abrupt('return', this.client.get('/postman/merchants', { params: { limit: limit } }).then(function (_ref214) {
	                                    var data = _ref214.data;
	                                    return data.items;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context108.stop();
	                        }
	                    }
	                }, _callee108, this);
	            }));
	
	            function listMerchants() {
	                return _ref213.apply(this, arguments);
	            }
	
	            return listMerchants;
	        }()
	
	        // Валюты
	
	    }, {
	        key: 'listCurrencies',
	        value: function () {
	            var _ref215 = _asyncToGenerator(_regenerator2.default.mark(function _callee109() {
	                return _regenerator2.default.wrap(function _callee109$(_context109) {
	                    while (1) {
	                        switch (_context109.prev = _context109.next) {
	                            case 0:
	                                return _context109.abrupt('return', this.client.get('/postman/currencies').then(function (_ref216) {
	                                    var data = _ref216.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context109.stop();
	                        }
	                    }
	                }, _callee109, this);
	            }));
	
	            function listCurrencies() {
	                return _ref215.apply(this, arguments);
	            }
	
	            return listCurrencies;
	        }()
	
	        // Предпочтительная валюта
	
	    }, {
	        key: 'merchantPreferredCurrency',
	        value: function () {
	            var _ref217 = _asyncToGenerator(_regenerator2.default.mark(function _callee110(uuid) {
	                return _regenerator2.default.wrap(function _callee110$(_context110) {
	                    while (1) {
	                        switch (_context110.prev = _context110.next) {
	                            case 0:
	                                return _context110.abrupt('return', this.client.get('/postman/merchant/' + uuid + '/preferred-currency').then(function (_ref218) {
	                                    var data = _ref218.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context110.stop();
	                        }
	                    }
	                }, _callee110, this);
	            }));
	
	            function merchantPreferredCurrency(_x139) {
	                return _ref217.apply(this, arguments);
	            }
	
	            return merchantPreferredCurrency;
	        }()
	
	        // Последние транзакции
	
	    }, {
	        key: 'latestTransactions',
	        value: function () {
	            var _ref219 = _asyncToGenerator(_regenerator2.default.mark(function _callee111(uuid) {
	                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	                return _regenerator2.default.wrap(function _callee111$(_context111) {
	                    while (1) {
	                        switch (_context111.prev = _context111.next) {
	                            case 0:
	                                return _context111.abrupt('return', this.client.get('/postman/transactions/latest', { params: { merchant: uuid, limit: limit } }).then(function (_ref220) {
	                                    var data = _ref220.data;
	                                    return data.items;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context111.stop();
	                        }
	                    }
	                }, _callee111, this);
	            }));
	
	            function latestTransactions(_x141) {
	                return _ref219.apply(this, arguments);
	            }
	
	            return latestTransactions;
	        }()
	
	        // Выполнить действие
	
	    }, {
	        key: 'uiExecute',
	        value: function () {
	            var _ref221 = _asyncToGenerator(_regenerator2.default.mark(function _callee112(payload) {
	                return _regenerator2.default.wrap(function _callee112$(_context112) {
	                    while (1) {
	                        switch (_context112.prev = _context112.next) {
	                            case 0:
	                                return _context112.abrupt('return', this.client.post('/postman/execute', payload).then(function (_ref222) {
	                                    var data = _ref222.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context112.stop();
	                        }
	                    }
	                }, _callee112, this);
	            }));
	
	            function uiExecute(_x142) {
	                return _ref221.apply(this, arguments);
	            }
	
	            return uiExecute;
	        }()
	
	        // === ANTIFRAUD API ===
	
	        // Получить список записей антифрода
	
	    }, {
	        key: 'getAntiFraudRecords',
	        value: function () {
	            var _ref223 = _asyncToGenerator(_regenerator2.default.mark(function _callee113(filters) {
	                return _regenerator2.default.wrap(function _callee113$(_context113) {
	                    while (1) {
	                        switch (_context113.prev = _context113.next) {
	                            case 0:
	                                return _context113.abrupt('return', this.client.post('/admin/antifraud/records', filters).then(function (_ref224) {
	                                    var data = _ref224.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context113.stop();
	                        }
	                    }
	                }, _callee113, this);
	            }));
	
	            function getAntiFraudRecords(_x143) {
	                return _ref223.apply(this, arguments);
	            }
	
	            return getAntiFraudRecords;
	        }()
	
	        // Получить запись антифрода по ID
	
	    }, {
	        key: 'getAntiFraudRecord',
	        value: function () {
	            var _ref225 = _asyncToGenerator(_regenerator2.default.mark(function _callee114(id) {
	                return _regenerator2.default.wrap(function _callee114$(_context114) {
	                    while (1) {
	                        switch (_context114.prev = _context114.next) {
	                            case 0:
	                                return _context114.abrupt('return', this.client.get('/admin/antifraud/records/' + id).then(function (_ref226) {
	                                    var data = _ref226.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context114.stop();
	                        }
	                    }
	                }, _callee114, this);
	            }));
	
	            function getAntiFraudRecord(_x144) {
	                return _ref225.apply(this, arguments);
	            }
	
	            return getAntiFraudRecord;
	        }()
	
	        // Добавить блокировку
	
	    }, {
	        key: 'addAntiFraudRecord',
	        value: function () {
	            var _ref227 = _asyncToGenerator(_regenerator2.default.mark(function _callee115(payload) {
	                return _regenerator2.default.wrap(function _callee115$(_context115) {
	                    while (1) {
	                        switch (_context115.prev = _context115.next) {
	                            case 0:
	                                return _context115.abrupt('return', this.client.put('/admin/antifraud/records', payload).then(function (_ref228) {
	                                    var data = _ref228.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context115.stop();
	                        }
	                    }
	                }, _callee115, this);
	            }));
	
	            function addAntiFraudRecord(_x145) {
	                return _ref227.apply(this, arguments);
	            }
	
	            return addAntiFraudRecord;
	        }()
	
	        // Разблокировать запись
	
	    }, {
	        key: 'unblockAntiFraudRecord',
	        value: function () {
	            var _ref229 = _asyncToGenerator(_regenerator2.default.mark(function _callee116(id) {
	                return _regenerator2.default.wrap(function _callee116$(_context116) {
	                    while (1) {
	                        switch (_context116.prev = _context116.next) {
	                            case 0:
	                                return _context116.abrupt('return', this.client.post('/admin/antifraud/records/' + id + '/unblock').then(function (_ref230) {
	                                    var data = _ref230.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context116.stop();
	                        }
	                    }
	                }, _callee116, this);
	            }));
	
	            function unblockAntiFraudRecord(_x146) {
	                return _ref229.apply(this, arguments);
	            }
	
	            return unblockAntiFraudRecord;
	        }()
	
	        // Удалить запись
	
	    }, {
	        key: 'deleteAntiFraudRecord',
	        value: function () {
	            var _ref231 = _asyncToGenerator(_regenerator2.default.mark(function _callee117(id) {
	                return _regenerator2.default.wrap(function _callee117$(_context117) {
	                    while (1) {
	                        switch (_context117.prev = _context117.next) {
	                            case 0:
	                                return _context117.abrupt('return', this.client.delete('/admin/antifraud/records/' + id).then(function (_ref232) {
	                                    var data = _ref232.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context117.stop();
	                        }
	                    }
	                }, _callee117, this);
	            }));
	
	            function deleteAntiFraudRecord(_x147) {
	                return _ref231.apply(this, arguments);
	            }
	
	            return deleteAntiFraudRecord;
	        }()
	
	        // Получить статистику антифрода
	
	    }, {
	        key: 'getAntiFraudStats',
	        value: function () {
	            var _ref233 = _asyncToGenerator(_regenerator2.default.mark(function _callee118() {
	                return _regenerator2.default.wrap(function _callee118$(_context118) {
	                    while (1) {
	                        switch (_context118.prev = _context118.next) {
	                            case 0:
	                                return _context118.abrupt('return', this.client.get('/admin/antifraud/stats').then(function (_ref234) {
	                                    var data = _ref234.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context118.stop();
	                        }
	                    }
	                }, _callee118, this);
	            }));
	
	            function getAntiFraudStats() {
	                return _ref233.apply(this, arguments);
	            }
	
	            return getAntiFraudStats;
	        }()
	
	        // Получить справочник (sources, kinds)
	
	    }, {
	        key: 'getAntiFraudReference',
	        value: function () {
	            var _ref235 = _asyncToGenerator(_regenerator2.default.mark(function _callee119() {
	                return _regenerator2.default.wrap(function _callee119$(_context119) {
	                    while (1) {
	                        switch (_context119.prev = _context119.next) {
	                            case 0:
	                                return _context119.abrupt('return', this.client.get('/admin/antifraud/reference').then(function (_ref236) {
	                                    var data = _ref236.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context119.stop();
	                        }
	                    }
	                }, _callee119, this);
	            }));
	
	            function getAntiFraudReference() {
	                return _ref235.apply(this, arguments);
	            }
	
	            return getAntiFraudReference;
	        }()
	
	        // Получить логи проверок антифрода
	
	    }, {
	        key: 'getAntiFraudLogs',
	        value: function () {
	            var _ref237 = _asyncToGenerator(_regenerator2.default.mark(function _callee120(filters) {
	                return _regenerator2.default.wrap(function _callee120$(_context120) {
	                    while (1) {
	                        switch (_context120.prev = _context120.next) {
	                            case 0:
	                                return _context120.abrupt('return', this.client.post('/admin/antifraud/logs', filters).then(function (_ref238) {
	                                    var data = _ref238.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context120.stop();
	                        }
	                    }
	                }, _callee120, this);
	            }));
	
	            function getAntiFraudLogs(_x148) {
	                return _ref237.apply(this, arguments);
	            }
	
	            return getAntiFraudLogs;
	        }()
	
	        // === ОСТАНОВЛЕННЫЕ ВЫПЛАТЫ (список карт) ===
	
	        // Выплаты, остановленные по списку карт; status: held | finalized | released | declined | null (все)
	
	    }, {
	        key: 'getPayoutHolds',
	        value: function () {
	            var _ref239 = _asyncToGenerator(_regenerator2.default.mark(function _callee121(status) {
	                return _regenerator2.default.wrap(function _callee121$(_context121) {
	                    while (1) {
	                        switch (_context121.prev = _context121.next) {
	                            case 0:
	                                return _context121.abrupt('return', this.client.get('/admin/payout-holds', { params: status ? { status: status } : {} }).then(function (_ref240) {
	                                    var data = _ref240.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context121.stop();
	                        }
	                    }
	                }, _callee121, this);
	            }));
	
	            function getPayoutHolds(_x149) {
	                return _ref239.apply(this, arguments);
	            }
	
	            return getPayoutHolds;
	        }()
	
	        // Провести без отправки провайдеру (списание с баланса, мерчанту — «успех»)
	
	    }, {
	        key: 'finalizePayoutHold',
	        value: function () {
	            var _ref241 = _asyncToGenerator(_regenerator2.default.mark(function _callee122(id, comment) {
	                return _regenerator2.default.wrap(function _callee122$(_context122) {
	                    while (1) {
	                        switch (_context122.prev = _context122.next) {
	                            case 0:
	                                return _context122.abrupt('return', this.client.post('/admin/payout-holds/' + id + '/finalize', { comment: comment }).then(function (_ref242) {
	                                    var data = _ref242.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context122.stop();
	                        }
	                    }
	                }, _callee122, this);
	            }));
	
	            function finalizePayoutHold(_x150, _x151) {
	                return _ref241.apply(this, arguments);
	            }
	
	            return finalizePayoutHold;
	        }()
	
	        // Передать провайдеру
	
	    }, {
	        key: 'releasePayoutHold',
	        value: function () {
	            var _ref243 = _asyncToGenerator(_regenerator2.default.mark(function _callee123(id, comment) {
	                return _regenerator2.default.wrap(function _callee123$(_context123) {
	                    while (1) {
	                        switch (_context123.prev = _context123.next) {
	                            case 0:
	                                return _context123.abrupt('return', this.client.post('/admin/payout-holds/' + id + '/release', { comment: comment }).then(function (_ref244) {
	                                    var data = _ref244.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context123.stop();
	                        }
	                    }
	                }, _callee123, this);
	            }));
	
	            function releasePayoutHold(_x152, _x153) {
	                return _ref243.apply(this, arguments);
	            }
	
	            return releasePayoutHold;
	        }()
	
	        // Отклонить; comment уходит мерчанту причиной отказа
	
	    }, {
	        key: 'declinePayoutHold',
	        value: function () {
	            var _ref245 = _asyncToGenerator(_regenerator2.default.mark(function _callee124(id, comment) {
	                return _regenerator2.default.wrap(function _callee124$(_context124) {
	                    while (1) {
	                        switch (_context124.prev = _context124.next) {
	                            case 0:
	                                return _context124.abrupt('return', this.client.post('/admin/payout-holds/' + id + '/decline', { comment: comment }).then(function (_ref246) {
	                                    var data = _ref246.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context124.stop();
	                        }
	                    }
	                }, _callee124, this);
	            }));
	
	            function declinePayoutHold(_x154, _x155) {
	                return _ref245.apply(this, arguments);
	            }
	
	            return declinePayoutHold;
	        }()
	
	        // Список карт остановки; all = true — вместе со снятыми
	
	    }, {
	        key: 'getPayoutHoldCards',
	        value: function () {
	            var _ref247 = _asyncToGenerator(_regenerator2.default.mark(function _callee125(all) {
	                return _regenerator2.default.wrap(function _callee125$(_context125) {
	                    while (1) {
	                        switch (_context125.prev = _context125.next) {
	                            case 0:
	                                return _context125.abrupt('return', this.client.get('/admin/payout-holds/cards', { params: all ? { all: 1 } : {} }).then(function (_ref248) {
	                                    var data = _ref248.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context125.stop();
	                        }
	                    }
	                }, _callee125, this);
	            }));
	
	            function getPayoutHoldCards(_x156) {
	                return _ref247.apply(this, arguments);
	            }
	
	            return getPayoutHoldCards;
	        }()
	
	        // Добавить карты: по номеру на строку
	
	    }, {
	        key: 'addPayoutHoldCards',
	        value: function () {
	            var _ref249 = _asyncToGenerator(_regenerator2.default.mark(function _callee126(cards, comment) {
	                return _regenerator2.default.wrap(function _callee126$(_context126) {
	                    while (1) {
	                        switch (_context126.prev = _context126.next) {
	                            case 0:
	                                return _context126.abrupt('return', this.client.post('/admin/payout-holds/cards', { cards: cards, comment: comment }).then(function (_ref250) {
	                                    var data = _ref250.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context126.stop();
	                        }
	                    }
	                }, _callee126, this);
	            }));
	
	            function addPayoutHoldCards(_x157, _x158) {
	                return _ref249.apply(this, arguments);
	            }
	
	            return addPayoutHoldCards;
	        }()
	
	        // Снять карту из списка
	
	    }, {
	        key: 'removePayoutHoldCard',
	        value: function () {
	            var _ref251 = _asyncToGenerator(_regenerator2.default.mark(function _callee127(id) {
	                return _regenerator2.default.wrap(function _callee127$(_context127) {
	                    while (1) {
	                        switch (_context127.prev = _context127.next) {
	                            case 0:
	                                return _context127.abrupt('return', this.client.delete('/admin/payout-holds/cards/' + id).then(function (_ref252) {
	                                    var data = _ref252.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context127.stop();
	                        }
	                    }
	                }, _callee127, this);
	            }));
	
	            function removePayoutHoldCard(_x159) {
	                return _ref251.apply(this, arguments);
	            }
	
	            return removePayoutHoldCard;
	        }()
	
	        // === MERCHANT ANTIFRAUD CHECK API ===
	
	        // Антифрод: разовая проверка (для мерчанта)
	
	    }, {
	        key: 'antifraudSingleCheck',
	        value: function () {
	            var _ref253 = _asyncToGenerator(_regenerator2.default.mark(function _callee128(merchantUuid, data) {
	                return _regenerator2.default.wrap(function _callee128$(_context128) {
	                    while (1) {
	                        switch (_context128.prev = _context128.next) {
	                            case 0:
	                                return _context128.abrupt('return', this.client.post('/merchant/antifraud/single-check', Object.assign({
	                                    merchantUuid: merchantUuid }, data)).then(function (_ref254) {
	                                    var data = _ref254.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context128.stop();
	                        }
	                    }
	                }, _callee128, this);
	            }));
	
	            function antifraudSingleCheck(_x160, _x161) {
	                return _ref253.apply(this, arguments);
	            }
	
	            return antifraudSingleCheck;
	        }()
	
	        // Антифрод: проверка файла (для мерчанта)
	
	    }, {
	        key: 'antifraudBatchCheck',
	        value: function () {
	            var _ref255 = _asyncToGenerator(_regenerator2.default.mark(function _callee129(formData) {
	                return _regenerator2.default.wrap(function _callee129$(_context129) {
	                    while (1) {
	                        switch (_context129.prev = _context129.next) {
	                            case 0:
	                                return _context129.abrupt('return', this.client.post('/merchant/antifraud/batch-check', formData).then(function (_ref256) {
	                                    var data = _ref256.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context129.stop();
	                        }
	                    }
	                }, _callee129, this);
	            }));
	
	            function antifraudBatchCheck(_x162) {
	                return _ref255.apply(this, arguments);
	            }
	
	            return antifraudBatchCheck;
	        }()
	
	        // Антифрод: логи проверок (для мерчанта)
	
	    }, {
	        key: 'getAntiFraudMerchantLogs',
	        value: function () {
	            var _ref257 = _asyncToGenerator(_regenerator2.default.mark(function _callee130(filters) {
	                return _regenerator2.default.wrap(function _callee130$(_context130) {
	                    while (1) {
	                        switch (_context130.prev = _context130.next) {
	                            case 0:
	                                return _context130.abrupt('return', this.client.post('/merchant/antifraud/logs', filters).then(function (_ref258) {
	                                    var data = _ref258.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context130.stop();
	                        }
	                    }
	                }, _callee130, this);
	            }));
	
	            function getAntiFraudMerchantLogs(_x163) {
	                return _ref257.apply(this, arguments);
	            }
	
	            return getAntiFraudMerchantLogs;
	        }()
	
	        // Антифрод: экспорт логов проверок (для мерчанта)
	
	    }, {
	        key: 'exportAntiFraudLogs',
	        value: function () {
	            var _ref259 = _asyncToGenerator(_regenerator2.default.mark(function _callee131(filters) {
	                return _regenerator2.default.wrap(function _callee131$(_context131) {
	                    while (1) {
	                        switch (_context131.prev = _context131.next) {
	                            case 0:
	                                return _context131.abrupt('return', this.client.post('/merchant/antifraud/logs/export', filters).then(function (_ref260) {
	                                    var data = _ref260.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context131.stop();
	                        }
	                    }
	                }, _callee131, this);
	            }));
	
	            function exportAntiFraudLogs(_x164) {
	                return _ref259.apply(this, arguments);
	            }
	
	            return exportAntiFraudLogs;
	        }()
	
	        // === PERMISSIONS API ===
	
	        // Получить список всех возможных прав
	
	    }, {
	        key: 'getPermissionsList',
	        value: function () {
	            var _ref261 = _asyncToGenerator(_regenerator2.default.mark(function _callee132() {
	                return _regenerator2.default.wrap(function _callee132$(_context132) {
	                    while (1) {
	                        switch (_context132.prev = _context132.next) {
	                            case 0:
	                                return _context132.abrupt('return', this.client.get('/permissions').then(function (_ref262) {
	                                    var data = _ref262.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context132.stop();
	                        }
	                    }
	                }, _callee132, this);
	            }));
	
	            function getPermissionsList() {
	                return _ref261.apply(this, arguments);
	            }
	
	            return getPermissionsList;
	        }()
	
	        // Получить права пользователя на проекте
	
	    }, {
	        key: 'getAccountMerchantPermissions',
	        value: function () {
	            var _ref263 = _asyncToGenerator(_regenerator2.default.mark(function _callee133(accountId, merchantUuid) {
	                return _regenerator2.default.wrap(function _callee133$(_context133) {
	                    while (1) {
	                        switch (_context133.prev = _context133.next) {
	                            case 0:
	                                return _context133.abrupt('return', this.client.get('/account/' + accountId + '/merchant/' + merchantUuid + '/permissions').then(function (_ref264) {
	                                    var data = _ref264.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context133.stop();
	                        }
	                    }
	                }, _callee133, this);
	            }));
	
	            function getAccountMerchantPermissions(_x165, _x166) {
	                return _ref263.apply(this, arguments);
	            }
	
	            return getAccountMerchantPermissions;
	        }()
	
	        // Обновить права пользователя на проекте
	
	    }, {
	        key: 'updateAccountMerchantPermissions',
	        value: function () {
	            var _ref265 = _asyncToGenerator(_regenerator2.default.mark(function _callee134(accountId, merchantUuid, privileges) {
	                return _regenerator2.default.wrap(function _callee134$(_context134) {
	                    while (1) {
	                        switch (_context134.prev = _context134.next) {
	                            case 0:
	                                return _context134.abrupt('return', this.client.post('/account/' + accountId + '/merchant/' + merchantUuid + '/permissions', { privileges: privileges }).then(function (_ref266) {
	                                    var data = _ref266.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context134.stop();
	                        }
	                    }
	                }, _callee134, this);
	            }));
	
	            function updateAccountMerchantPermissions(_x167, _x168, _x169) {
	                return _ref265.apply(this, arguments);
	            }
	
	            return updateAccountMerchantPermissions;
	        }()
	
	        // Получить актуальные права текущего пользователя (без перелогина)
	
	    }, {
	        key: 'getMyAccessSettings',
	        value: function () {
	            var _ref267 = _asyncToGenerator(_regenerator2.default.mark(function _callee135() {
	                return _regenerator2.default.wrap(function _callee135$(_context135) {
	                    while (1) {
	                        switch (_context135.prev = _context135.next) {
	                            case 0:
	                                return _context135.abrupt('return', this.client.get('/account/me/access-settings').then(function (_ref268) {
	                                    var data = _ref268.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context135.stop();
	                        }
	                    }
	                }, _callee135, this);
	            }));
	
	            function getMyAccessSettings() {
	                return _ref267.apply(this, arguments);
	            }
	
	            return getMyAccessSettings;
	        }()
	
	        // Получить глобальные права аккаунта
	
	    }, {
	        key: 'getGlobalPermissions',
	        value: function () {
	            var _ref269 = _asyncToGenerator(_regenerator2.default.mark(function _callee136(accountId) {
	                return _regenerator2.default.wrap(function _callee136$(_context136) {
	                    while (1) {
	                        switch (_context136.prev = _context136.next) {
	                            case 0:
	                                return _context136.abrupt('return', this.client.get('/account/' + accountId + '/global-permissions').then(function (_ref270) {
	                                    var data = _ref270.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context136.stop();
	                        }
	                    }
	                }, _callee136, this);
	            }));
	
	            function getGlobalPermissions(_x170) {
	                return _ref269.apply(this, arguments);
	            }
	
	            return getGlobalPermissions;
	        }()
	
	        // Обновить глобальные права аккаунта
	
	    }, {
	        key: 'updateGlobalPermissions',
	        value: function () {
	            var _ref271 = _asyncToGenerator(_regenerator2.default.mark(function _callee137(accountId, enabled, privileges) {
	                return _regenerator2.default.wrap(function _callee137$(_context137) {
	                    while (1) {
	                        switch (_context137.prev = _context137.next) {
	                            case 0:
	                                return _context137.abrupt('return', this.client.post('/account/' + accountId + '/global-permissions', {
	                                    enabled: enabled, privileges: privileges
	                                }).then(function (_ref272) {
	                                    var data = _ref272.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context137.stop();
	                        }
	                    }
	                }, _callee137, this);
	            }));
	
	            function updateGlobalPermissions(_x171, _x172, _x173) {
	                return _ref271.apply(this, arguments);
	            }
	
	            return updateGlobalPermissions;
	        }()
	
	        /**
	         * Сохранить все данные проекта одним запросом
	         * @param {string} uuid - UUID проекта
	         * @param {object} payload - Все данные для сохранения:
	         *   - basic: { name, description, url, status, inn, kpp, ogrn }
	         *   - fraud: { frod: boolean, antifraud: object }
	         *   - widget: { widgetKey, widgetCallback }
	         *   - users: { add: [accountId, ...], remove: [accountId, ...] }
	         *   - settings: { create: [...], update: [...], delete: [settingId, ...] }
	         */
	
	    }, {
	        key: 'saveProjectAll',
	        value: function () {
	            var _ref273 = _asyncToGenerator(_regenerator2.default.mark(function _callee138(uuid, payload) {
	                return _regenerator2.default.wrap(function _callee138$(_context138) {
	                    while (1) {
	                        switch (_context138.prev = _context138.next) {
	                            case 0:
	                                return _context138.abrupt('return', this.client.post('/merchant/' + uuid + '/save-all', payload).then(function (_ref274) {
	                                    var data = _ref274.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context138.stop();
	                        }
	                    }
	                }, _callee138, this);
	            }));
	
	            function saveProjectAll(_x174, _x175) {
	                return _ref273.apply(this, arguments);
	            }
	
	            return saveProjectAll;
	        }()
	
	        // ============================================
	        // AUDIT LOGS - Журнал действий администраторов
	        // ============================================
	
	        /**
	         * Получить список логов администратора с фильтрами
	         * @param {object} filters - Фильтры:
	         *   - actorId: number (ID администратора)
	         *   - action: string (тип действия)
	         *   - entityType: string (тип объекта)
	         *   - startDate: string (начало периода)
	         *   - endDate: string (конец периода)
	         *   - page: number
	         *   - itemsPerPage: number
	         */
	
	    }, {
	        key: 'getAuditLogs',
	        value: function () {
	            var _ref275 = _asyncToGenerator(_regenerator2.default.mark(function _callee139() {
	                var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                return _regenerator2.default.wrap(function _callee139$(_context139) {
	                    while (1) {
	                        switch (_context139.prev = _context139.next) {
	                            case 0:
	                                return _context139.abrupt('return', this.client.post('/admin/audit/list', filters).then(function (_ref276) {
	                                    var data = _ref276.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context139.stop();
	                        }
	                    }
	                }, _callee139, this);
	            }));
	
	            function getAuditLogs() {
	                return _ref275.apply(this, arguments);
	            }
	
	            return getAuditLogs;
	        }()
	
	        /**
	         * Получить доступные типы действий для фильтра
	         */
	
	    }, {
	        key: 'getAuditActions',
	        value: function () {
	            var _ref277 = _asyncToGenerator(_regenerator2.default.mark(function _callee140() {
	                return _regenerator2.default.wrap(function _callee140$(_context140) {
	                    while (1) {
	                        switch (_context140.prev = _context140.next) {
	                            case 0:
	                                return _context140.abrupt('return', this.client.get('/admin/audit/actions').then(function (_ref278) {
	                                    var data = _ref278.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context140.stop();
	                        }
	                    }
	                }, _callee140, this);
	            }));
	
	            function getAuditActions() {
	                return _ref277.apply(this, arguments);
	            }
	
	            return getAuditActions;
	        }()
	
	        /**
	         * Получить доступные типы объектов для фильтра
	         */
	
	    }, {
	        key: 'getAuditEntityTypes',
	        value: function () {
	            var _ref279 = _asyncToGenerator(_regenerator2.default.mark(function _callee141() {
	                return _regenerator2.default.wrap(function _callee141$(_context141) {
	                    while (1) {
	                        switch (_context141.prev = _context141.next) {
	                            case 0:
	                                return _context141.abrupt('return', this.client.get('/admin/audit/entity-types').then(function (_ref280) {
	                                    var data = _ref280.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context141.stop();
	                        }
	                    }
	                }, _callee141, this);
	            }));
	
	            function getAuditEntityTypes() {
	                return _ref279.apply(this, arguments);
	            }
	
	            return getAuditEntityTypes;
	        }()
	
	        /**
	         * Получить логи по конкретному объекту
	         * @param {string} entityType - Тип объекта (account, merchant, terminal, settings)
	         * @param {string} identifier - ID или UUID объекта
	         */
	
	    }, {
	        key: 'getAuditLogsByEntity',
	        value: function () {
	            var _ref281 = _asyncToGenerator(_regenerator2.default.mark(function _callee142(entityType, identifier) {
	                return _regenerator2.default.wrap(function _callee142$(_context142) {
	                    while (1) {
	                        switch (_context142.prev = _context142.next) {
	                            case 0:
	                                return _context142.abrupt('return', this.client.get('/admin/audit/entity/' + entityType + '/' + identifier).then(function (_ref282) {
	                                    var data = _ref282.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context142.stop();
	                        }
	                    }
	                }, _callee142, this);
	            }));
	
	            function getAuditLogsByEntity(_x177, _x178) {
	                return _ref281.apply(this, arguments);
	            }
	
	            return getAuditLogsByEntity;
	        }()
	
	        /**
	         * Получить логи по конкретному администратору
	         * @param {number} actorId - ID администратора
	         */
	
	    }, {
	        key: 'getAuditLogsByActor',
	        value: function () {
	            var _ref283 = _asyncToGenerator(_regenerator2.default.mark(function _callee143(actorId) {
	                return _regenerator2.default.wrap(function _callee143$(_context143) {
	                    while (1) {
	                        switch (_context143.prev = _context143.next) {
	                            case 0:
	                                return _context143.abrupt('return', this.client.get('/admin/audit/actor/' + actorId).then(function (_ref284) {
	                                    var data = _ref284.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context143.stop();
	                        }
	                    }
	                }, _callee143, this);
	            }));
	
	            function getAuditLogsByActor(_x179) {
	                return _ref283.apply(this, arguments);
	            }
	
	            return getAuditLogsByActor;
	        }()
	
	        // ============================================
	        // TRANSACTION EVENTS - Логирование событий транзакций
	        // ============================================
	
	        /**
	         * Получить список событий транзакций с фильтрацией
	         * @param {object} filters - Фильтры:
	         *   - transactionId: string
	         *   - merchantId: string
	         *   - eventTypes: array
	         *   - actors: array
	         *   - direction: string (in/out)
	         *   - dateFrom: string (ISO)
	         *   - dateTo: string (ISO)
	         *   - httpCodeFrom: number
	         *   - httpCodeTo: number
	         *   - hasError: boolean
	         *   - search: string - полнотекстовый поиск
	         *   - limit: number (default 50, max 100)
	         *   - offset: number
	         */
	
	    }, {
	        key: 'getTransactionEvents',
	        value: function () {
	            var _ref285 = _asyncToGenerator(_regenerator2.default.mark(function _callee144() {
	                var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                return _regenerator2.default.wrap(function _callee144$(_context144) {
	                    while (1) {
	                        switch (_context144.prev = _context144.next) {
	                            case 0:
	                                return _context144.abrupt('return', this.client.post('/admin/transaction-events/list', filters).then(function (_ref286) {
	                                    var data = _ref286.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context144.stop();
	                        }
	                    }
	                }, _callee144, this);
	            }));
	
	            function getTransactionEvents() {
	                return _ref285.apply(this, arguments);
	            }
	
	            return getTransactionEvents;
	        }()
	
	        /**
	         * Получить timeline событий для конкретной транзакции
	         * @param {number} transactionId - ID транзакции
	         */
	
	    }, {
	        key: 'getTransactionEventsTimeline',
	        value: function () {
	            var _ref287 = _asyncToGenerator(_regenerator2.default.mark(function _callee145(transactionId) {
	                return _regenerator2.default.wrap(function _callee145$(_context145) {
	                    while (1) {
	                        switch (_context145.prev = _context145.next) {
	                            case 0:
	                                return _context145.abrupt('return', this.client.get('/admin/transaction-events/timeline/' + transactionId).then(function (_ref288) {
	                                    var data = _ref288.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context145.stop();
	                        }
	                    }
	                }, _callee145, this);
	            }));
	
	            function getTransactionEventsTimeline(_x181) {
	                return _ref287.apply(this, arguments);
	            }
	
	            return getTransactionEventsTimeline;
	        }()
	
	        /**
	         * Получить список доступных типов событий
	         */
	
	    }, {
	        key: 'getTransactionEventTypes',
	        value: function () {
	            var _ref289 = _asyncToGenerator(_regenerator2.default.mark(function _callee146() {
	                return _regenerator2.default.wrap(function _callee146$(_context146) {
	                    while (1) {
	                        switch (_context146.prev = _context146.next) {
	                            case 0:
	                                return _context146.abrupt('return', this.client.get('/admin/transaction-events/event-types').then(function (_ref290) {
	                                    var data = _ref290.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context146.stop();
	                        }
	                    }
	                }, _callee146, this);
	            }));
	
	            function getTransactionEventTypes() {
	                return _ref289.apply(this, arguments);
	            }
	
	            return getTransactionEventTypes;
	        }()
	
	        /**
	         * Получить список доступных actors
	         */
	
	    }, {
	        key: 'getTransactionEventActors',
	        value: function () {
	            var _ref291 = _asyncToGenerator(_regenerator2.default.mark(function _callee147() {
	                return _regenerator2.default.wrap(function _callee147$(_context147) {
	                    while (1) {
	                        switch (_context147.prev = _context147.next) {
	                            case 0:
	                                return _context147.abrupt('return', this.client.get('/admin/transaction-events/actors').then(function (_ref292) {
	                                    var data = _ref292.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context147.stop();
	                        }
	                    }
	                }, _callee147, this);
	            }));
	
	            function getTransactionEventActors() {
	                return _ref291.apply(this, arguments);
	            }
	
	            return getTransactionEventActors;
	        }()
	
	        /**
	         * Получить список мерчантов для выпадающего списка
	         * @param {string} searchQuery - поисковая строка
	         */
	
	    }, {
	        key: 'getMerchants',
	        value: function () {
	            var _ref293 = _asyncToGenerator(_regenerator2.default.mark(function _callee148() {
	                var searchQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                var params;
	                return _regenerator2.default.wrap(function _callee148$(_context148) {
	                    while (1) {
	                        switch (_context148.prev = _context148.next) {
	                            case 0:
	                                params = new URLSearchParams();
	
	                                if (searchQuery) {
	                                    params.set('q', searchQuery);
	                                }
	                                return _context148.abrupt('return', this.client.get('/admin/transaction-events/merchants?' + params.toString()).then(function (_ref294) {
	                                    var data = _ref294.data;
	                                    return data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context148.stop();
	                        }
	                    }
	                }, _callee148, this);
	            }));
	
	            function getMerchants() {
	                return _ref293.apply(this, arguments);
	            }
	
	            return getMerchants;
	        }()
	
	        /**
	         * Экспортировать события в CSV
	         * @param {object} filters - Те же фильтры что и getTransactionEvents
	         */
	
	    }, {
	        key: 'exportTransactionEvents',
	        value: function () {
	            var _ref295 = _asyncToGenerator(_regenerator2.default.mark(function _callee149() {
	                var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                return _regenerator2.default.wrap(function _callee149$(_context149) {
	                    while (1) {
	                        switch (_context149.prev = _context149.next) {
	                            case 0:
	                                return _context149.abrupt('return', this.client.post('/admin/transaction-events/export', filters, {
	                                    responseType: 'blob'
	                                }).then(function (_ref296) {
	                                    var data = _ref296.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context149.stop();
	                        }
	                    }
	                }, _callee149, this);
	            }));
	
	            function exportTransactionEvents() {
	                return _ref295.apply(this, arguments);
	            }
	
	            return exportTransactionEvents;
	        }()
	
	        // ============================================
	        // DISPUTES - Система диспутов
	        // ============================================
	
	        /**
	         * Получить список диспутов с фильтрами
	         * @param {object} filters - Фильтры:
	         *   - filters: array - фильтры по статусу [{new: true}, {in_progress: true}]
	         *   - merchants: array - UUID мерчантов
	         *   - dateRange: { startDate, endDate }
	         *   - search: string - поиск по ID транзакции или тексту
	         *   - page: number
	         *   - itemsPerPage: number
	         */
	
	    }, {
	        key: 'getDisputesList',
	        value: function () {
	            var _ref297 = _asyncToGenerator(_regenerator2.default.mark(function _callee150() {
	                var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                return _regenerator2.default.wrap(function _callee150$(_context150) {
	                    while (1) {
	                        switch (_context150.prev = _context150.next) {
	                            case 0:
	                                return _context150.abrupt('return', this.client.post('/admin/disputes/list', filters).then(function (_ref298) {
	                                    var data = _ref298.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context150.stop();
	                        }
	                    }
	                }, _callee150, this);
	            }));
	
	            function getDisputesList() {
	                return _ref297.apply(this, arguments);
	            }
	
	            return getDisputesList;
	        }()
	
	        /**
	         * Получить диспут по ID
	         * @param {number} id - ID диспута
	         */
	
	    }, {
	        key: 'getDispute',
	        value: function () {
	            var _ref299 = _asyncToGenerator(_regenerator2.default.mark(function _callee151(id) {
	                return _regenerator2.default.wrap(function _callee151$(_context151) {
	                    while (1) {
	                        switch (_context151.prev = _context151.next) {
	                            case 0:
	                                return _context151.abrupt('return', this.client.get('/admin/disputes/' + id).then(function (_ref300) {
	                                    var data = _ref300.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context151.stop();
	                        }
	                    }
	                }, _callee151, this);
	            }));
	
	            function getDispute(_x185) {
	                return _ref299.apply(this, arguments);
	            }
	
	            return getDispute;
	        }()
	
	        /**
	         * Обновить диспут (статус, примечание, привязка транзакции)
	         * @param {number} id - ID диспута
	         * @param {object} payload - Данные для обновления:
	         *   - status: string (new, in_progress, resolved, archived)
	         *   - note: string - примечание
	         *   - transactionId: number - ID транзакции для привязки
	         */
	
	    }, {
	        key: 'updateDispute',
	        value: function () {
	            var _ref301 = _asyncToGenerator(_regenerator2.default.mark(function _callee152(id, payload) {
	                return _regenerator2.default.wrap(function _callee152$(_context152) {
	                    while (1) {
	                        switch (_context152.prev = _context152.next) {
	                            case 0:
	                                return _context152.abrupt('return', this.client.patch('/admin/disputes/' + id, payload).then(function (_ref302) {
	                                    var data = _ref302.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context152.stop();
	                        }
	                    }
	                }, _callee152, this);
	            }));
	
	            function updateDispute(_x186, _x187) {
	                return _ref301.apply(this, arguments);
	            }
	
	            return updateDispute;
	        }()
	
	        /**
	         * Проверить статус у провайдера для диспута
	         * @param {number} id - ID диспута
	         */
	
	    }, {
	        key: 'checkDisputeProvider',
	        value: function () {
	            var _ref303 = _asyncToGenerator(_regenerator2.default.mark(function _callee153(id) {
	                return _regenerator2.default.wrap(function _callee153$(_context153) {
	                    while (1) {
	                        switch (_context153.prev = _context153.next) {
	                            case 0:
	                                return _context153.abrupt('return', this.client.post('/admin/disputes/' + id + '/check-provider', {}).then(function (_ref304) {
	                                    var data = _ref304.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context153.stop();
	                        }
	                    }
	                }, _callee153, this);
	            }));
	
	            function checkDisputeProvider(_x188) {
	                return _ref303.apply(this, arguments);
	            }
	
	            return checkDisputeProvider;
	        }()
	
	        /**
	         * Проверить статус транзакции по ID (для ручного ввода)
	         * @param {number} transactionId - ID транзакции
	         */
	
	    }, {
	        key: 'checkDisputeTransaction',
	        value: function () {
	            var _ref305 = _asyncToGenerator(_regenerator2.default.mark(function _callee154(transactionId) {
	                return _regenerator2.default.wrap(function _callee154$(_context154) {
	                    while (1) {
	                        switch (_context154.prev = _context154.next) {
	                            case 0:
	                                return _context154.abrupt('return', this.client.get('/admin/disputes/check-transaction/' + transactionId).then(function (_ref306) {
	                                    var data = _ref306.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context154.stop();
	                        }
	                    }
	                }, _callee154, this);
	            }));
	
	            function checkDisputeTransaction(_x189) {
	                return _ref305.apply(this, arguments);
	            }
	
	            return checkDisputeTransaction;
	        }()
	
	        /**
	         * Получить справочники для диспутов (статусы, мерчанты)
	         */
	
	    }, {
	        key: 'getDisputeReference',
	        value: function () {
	            var _ref307 = _asyncToGenerator(_regenerator2.default.mark(function _callee155() {
	                return _regenerator2.default.wrap(function _callee155$(_context155) {
	                    while (1) {
	                        switch (_context155.prev = _context155.next) {
	                            case 0:
	                                return _context155.abrupt('return', this.client.get('/admin/disputes/reference').then(function (_ref308) {
	                                    var data = _ref308.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context155.stop();
	                        }
	                    }
	                }, _callee155, this);
	            }));
	
	            function getDisputeReference() {
	                return _ref307.apply(this, arguments);
	            }
	
	            return getDisputeReference;
	        }()
	
	        /**
	         * Получить статистику диспутов
	         */
	
	    }, {
	        key: 'getDisputeStats',
	        value: function () {
	            var _ref309 = _asyncToGenerator(_regenerator2.default.mark(function _callee156() {
	                var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                return _regenerator2.default.wrap(function _callee156$(_context156) {
	                    while (1) {
	                        switch (_context156.prev = _context156.next) {
	                            case 0:
	                                return _context156.abrupt('return', this.client.post('/admin/disputes/stats', filters).then(function (_ref310) {
	                                    var data = _ref310.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context156.stop();
	                        }
	                    }
	                }, _callee156, this);
	            }));
	
	            function getDisputeStats() {
	                return _ref309.apply(this, arguments);
	            }
	
	            return getDisputeStats;
	        }()
	
	        /**
	         * Получить маппинг чатов на мерчантов
	         */
	
	    }, {
	        key: 'getDisputeChatMapping',
	        value: function () {
	            var _ref311 = _asyncToGenerator(_regenerator2.default.mark(function _callee157() {
	                return _regenerator2.default.wrap(function _callee157$(_context157) {
	                    while (1) {
	                        switch (_context157.prev = _context157.next) {
	                            case 0:
	                                return _context157.abrupt('return', this.client.get('/admin/disputes/chat-mapping').then(function (_ref312) {
	                                    var data = _ref312.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context157.stop();
	                        }
	                    }
	                }, _callee157, this);
	            }));
	
	            function getDisputeChatMapping() {
	                return _ref311.apply(this, arguments);
	            }
	
	            return getDisputeChatMapping;
	        }()
	
	        /**
	         * Обновить маппинг чата на мерчанта
	         * @param {object} payload - Данные маппинга:
	         *   - chatId: string - ID чата Telegram
	         *   - merchantId: number - ID мерчанта
	         *   - chatTitle: string - Название чата (опционально)
	         *   - delete: boolean - Удалить маппинг (опционально)
	         */
	
	    }, {
	        key: 'updateDisputeChatMapping',
	        value: function () {
	            var _ref313 = _asyncToGenerator(_regenerator2.default.mark(function _callee158(payload) {
	                return _regenerator2.default.wrap(function _callee158$(_context158) {
	                    while (1) {
	                        switch (_context158.prev = _context158.next) {
	                            case 0:
	                                return _context158.abrupt('return', this.client.post('/admin/disputes/chat-mapping', payload).then(function (_ref314) {
	                                    var data = _ref314.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context158.stop();
	                        }
	                    }
	                }, _callee158, this);
	            }));
	
	            function updateDisputeChatMapping(_x191) {
	                return _ref313.apply(this, arguments);
	            }
	
	            return updateDisputeChatMapping;
	        }()
	
	        /**
	         * Получить URL вложения диспута
	         * @param {number} disputeId - ID диспута
	         * @param {number} index - Индекс вложения
	         */
	
	    }, {
	        key: 'getDisputeAttachmentUrl',
	        value: function () {
	            var _ref315 = _asyncToGenerator(_regenerator2.default.mark(function _callee159(disputeId, index) {
	                return _regenerator2.default.wrap(function _callee159$(_context159) {
	                    while (1) {
	                        switch (_context159.prev = _context159.next) {
	                            case 0:
	                                return _context159.abrupt('return', this.client.get('/admin/disputes/' + disputeId + '/attachment/' + index).then(function (_ref316) {
	                                    var data = _ref316.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context159.stop();
	                        }
	                    }
	                }, _callee159, this);
	            }));
	
	            function getDisputeAttachmentUrl(_x192, _x193) {
	                return _ref315.apply(this, arguments);
	            }
	
	            return getDisputeAttachmentUrl;
	        }()
	
	        // ============================================
	        // CRM PAYOUT REQUESTS
	        // ============================================
	
	    }, {
	        key: 'getCrmPayoutRequests',
	        value: function () {
	            var _ref317 = _asyncToGenerator(_regenerator2.default.mark(function _callee160(payload) {
	                return _regenerator2.default.wrap(function _callee160$(_context160) {
	                    while (1) {
	                        switch (_context160.prev = _context160.next) {
	                            case 0:
	                                return _context160.abrupt('return', this.client.post('/admin/crm/payout-requests', payload).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context160.stop();
	                        }
	                    }
	                }, _callee160, this);
	            }));
	
	            function getCrmPayoutRequests(_x194) {
	                return _ref317.apply(this, arguments);
	            }
	
	            return getCrmPayoutRequests;
	        }()
	    }, {
	        key: 'createCrmPayoutRequest',
	        value: function () {
	            var _ref318 = _asyncToGenerator(_regenerator2.default.mark(function _callee161(payload) {
	                return _regenerator2.default.wrap(function _callee161$(_context161) {
	                    while (1) {
	                        switch (_context161.prev = _context161.next) {
	                            case 0:
	                                return _context161.abrupt('return', this.client.post('/admin/crm/payout-requests/create', payload).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context161.stop();
	                        }
	                    }
	                }, _callee161, this);
	            }));
	
	            function createCrmPayoutRequest(_x195) {
	                return _ref318.apply(this, arguments);
	            }
	
	            return createCrmPayoutRequest;
	        }()
	    }, {
	        key: 'getCrmPayoutRequest',
	        value: function () {
	            var _ref319 = _asyncToGenerator(_regenerator2.default.mark(function _callee162(id) {
	                return _regenerator2.default.wrap(function _callee162$(_context162) {
	                    while (1) {
	                        switch (_context162.prev = _context162.next) {
	                            case 0:
	                                return _context162.abrupt('return', this.client.get('/admin/crm/payout-requests/' + id).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context162.stop();
	                        }
	                    }
	                }, _callee162, this);
	            }));
	
	            function getCrmPayoutRequest(_x196) {
	                return _ref319.apply(this, arguments);
	            }
	
	            return getCrmPayoutRequest;
	        }()
	    }, {
	        key: 'declineCrmPayoutRequest',
	        value: function () {
	            var _ref320 = _asyncToGenerator(_regenerator2.default.mark(function _callee163(id, reason) {
	                return _regenerator2.default.wrap(function _callee163$(_context163) {
	                    while (1) {
	                        switch (_context163.prev = _context163.next) {
	                            case 0:
	                                return _context163.abrupt('return', this.client.post('/admin/crm/payout-requests/' + id + '/decline', { reason: reason }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context163.stop();
	                        }
	                    }
	                }, _callee163, this);
	            }));
	
	            function declineCrmPayoutRequest(_x197, _x198) {
	                return _ref320.apply(this, arguments);
	            }
	
	            return declineCrmPayoutRequest;
	        }()
	    }, {
	        key: 'bulkDeclineCrmPayoutRequests',
	        value: function () {
	            var _ref321 = _asyncToGenerator(_regenerator2.default.mark(function _callee164(ids, reason) {
	                return _regenerator2.default.wrap(function _callee164$(_context164) {
	                    while (1) {
	                        switch (_context164.prev = _context164.next) {
	                            case 0:
	                                return _context164.abrupt('return', this.client.post('/admin/crm/payout-requests/bulk-decline', { ids: ids, reason: reason }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context164.stop();
	                        }
	                    }
	                }, _callee164, this);
	            }));
	
	            function bulkDeclineCrmPayoutRequests(_x199, _x200) {
	                return _ref321.apply(this, arguments);
	            }
	
	            return bulkDeclineCrmPayoutRequests;
	        }()
	    }, {
	        key: 'formCrmRegistry',
	        value: function () {
	            var _ref322 = _asyncToGenerator(_regenerator2.default.mark(function _callee165(requestIds, name, targetMerchantSettingsId) {
	                return _regenerator2.default.wrap(function _callee165$(_context165) {
	                    while (1) {
	                        switch (_context165.prev = _context165.next) {
	                            case 0:
	                                return _context165.abrupt('return', this.client.post('/admin/crm/payout-requests/form-registry', {
	                                    requestIds: requestIds, name: name, targetMerchantSettingsId: targetMerchantSettingsId
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context165.stop();
	                        }
	                    }
	                }, _callee165, this);
	            }));
	
	            function formCrmRegistry(_x201, _x202, _x203) {
	                return _ref322.apply(this, arguments);
	            }
	
	            return formCrmRegistry;
	        }()
	    }, {
	        key: 'retryCrmPayoutRequests',
	        value: function () {
	            var _ref323 = _asyncToGenerator(_regenerator2.default.mark(function _callee166(ids) {
	                return _regenerator2.default.wrap(function _callee166$(_context166) {
	                    while (1) {
	                        switch (_context166.prev = _context166.next) {
	                            case 0:
	                                return _context166.abrupt('return', this.client.post('/admin/crm/payout-requests/retry-failed', { ids: ids }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context166.stop();
	                        }
	                    }
	                }, _callee166, this);
	            }));
	
	            function retryCrmPayoutRequests(_x204) {
	                return _ref323.apply(this, arguments);
	            }
	
	            return retryCrmPayoutRequests;
	        }()
	    }, {
	        key: 'getCrmPayoutReference',
	        value: function () {
	            var _ref324 = _asyncToGenerator(_regenerator2.default.mark(function _callee167() {
	                return _regenerator2.default.wrap(function _callee167$(_context167) {
	                    while (1) {
	                        switch (_context167.prev = _context167.next) {
	                            case 0:
	                                return _context167.abrupt('return', this.client.get('/admin/crm/payout-requests/reference').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context167.stop();
	                        }
	                    }
	                }, _callee167, this);
	            }));
	
	            function getCrmPayoutReference() {
	                return _ref324.apply(this, arguments);
	            }
	
	            return getCrmPayoutReference;
	        }()
	    }, {
	        key: 'getCrmPayoutStats',
	        value: function () {
	            var _ref325 = _asyncToGenerator(_regenerator2.default.mark(function _callee168(projects, payoutType) {
	                return _regenerator2.default.wrap(function _callee168$(_context168) {
	                    while (1) {
	                        switch (_context168.prev = _context168.next) {
	                            case 0:
	                                return _context168.abrupt('return', this.client.post('/admin/crm/payout-requests/stats', {
	                                    projects: projects || [], payoutType: payoutType || 'card'
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context168.stop();
	                        }
	                    }
	                }, _callee168, this);
	            }));
	
	            function getCrmPayoutStats(_x205, _x206) {
	                return _ref325.apply(this, arguments);
	            }
	
	            return getCrmPayoutStats;
	        }()
	    }, {
	        key: 'sendToAntifraudCrmPayoutRequests',
	        value: function () {
	            var _ref326 = _asyncToGenerator(_regenerator2.default.mark(function _callee169(ids) {
	                return _regenerator2.default.wrap(function _callee169$(_context169) {
	                    while (1) {
	                        switch (_context169.prev = _context169.next) {
	                            case 0:
	                                return _context169.abrupt('return', this.client.post('/admin/crm/payout-requests/send-to-antifraud', { ids: ids }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context169.stop();
	                        }
	                    }
	                }, _callee169, this);
	            }));
	
	            function sendToAntifraudCrmPayoutRequests(_x207) {
	                return _ref326.apply(this, arguments);
	            }
	
	            return sendToAntifraudCrmPayoutRequests;
	        }()
	    }, {
	        key: 'moveBackToAwaitingCrmPayoutRequests',
	        value: function () {
	            var _ref327 = _asyncToGenerator(_regenerator2.default.mark(function _callee170(ids) {
	                return _regenerator2.default.wrap(function _callee170$(_context170) {
	                    while (1) {
	                        switch (_context170.prev = _context170.next) {
	                            case 0:
	                                return _context170.abrupt('return', this.client.post('/admin/crm/payout-requests/move-back-to-awaiting', { ids: ids }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context170.stop();
	                        }
	                    }
	                }, _callee170, this);
	            }));
	
	            function moveBackToAwaitingCrmPayoutRequests(_x208) {
	                return _ref327.apply(this, arguments);
	            }
	
	            return moveBackToAwaitingCrmPayoutRequests;
	        }()
	
	        // format: 'yupay' — реестр в формате провайдера Юпэй, без него — обычная выгрузка
	
	    }, {
	        key: 'downloadCrmRegistryExcel',
	        value: function () {
	            var _ref328 = _asyncToGenerator(_regenerator2.default.mark(function _callee171(registryId, format) {
	                var path;
	                return _regenerator2.default.wrap(function _callee171$(_context171) {
	                    while (1) {
	                        switch (_context171.prev = _context171.next) {
	                            case 0:
	                                path = format === 'yupay' ? '/download-yupay' : '/download';
	                                return _context171.abrupt('return', this.client.get('/admin/crm/payout-requests/registry/' + registryId + path, {
	                                    responseType: 'blob'
	                                }).then(function (r) {
	                                    // Если бэкенд вернул JSON (ошибка баланса) — он придёт как blob с типом application/json
	                                    if (r.data && r.data.type && r.data.type.indexOf('application/json') !== -1) {
	                                        return r.data.text().then(function (text) {
	                                            var json = JSON.parse(text);
	                                            var err = new Error(json.message || 'Ошибка');
	                                            err.responseData = json;
	                                            throw err;
	                                        });
	                                    }
	                                    return r.data;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context171.stop();
	                        }
	                    }
	                }, _callee171, this);
	            }));
	
	            function downloadCrmRegistryExcel(_x209, _x210) {
	                return _ref328.apply(this, arguments);
	            }
	
	            return downloadCrmRegistryExcel;
	        }()
	    }, {
	        key: 'previewCrmRegistryReport',
	        value: function () {
	            var _ref329 = _asyncToGenerator(_regenerator2.default.mark(function _callee172(registryId, formData) {
	                return _regenerator2.default.wrap(function _callee172$(_context172) {
	                    while (1) {
	                        switch (_context172.prev = _context172.next) {
	                            case 0:
	                                return _context172.abrupt('return', this.client.post('/admin/crm/payout-requests/registry/' + registryId + '/upload-report/preview', formData, {
	                                    headers: { 'Content-Type': 'multipart/form-data' }
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context172.stop();
	                        }
	                    }
	                }, _callee172, this);
	            }));
	
	            function previewCrmRegistryReport(_x211, _x212) {
	                return _ref329.apply(this, arguments);
	            }
	
	            return previewCrmRegistryReport;
	        }()
	    }, {
	        key: 'uploadCrmRegistryReport',
	        value: function () {
	            var _ref330 = _asyncToGenerator(_regenerator2.default.mark(function _callee173(registryId, formData) {
	                return _regenerator2.default.wrap(function _callee173$(_context173) {
	                    while (1) {
	                        switch (_context173.prev = _context173.next) {
	                            case 0:
	                                return _context173.abrupt('return', this.client.post('/admin/crm/payout-requests/registry/' + registryId + '/upload-report', formData, {
	                                    headers: { 'Content-Type': 'multipart/form-data' }
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context173.stop();
	                        }
	                    }
	                }, _callee173, this);
	            }));
	
	            function uploadCrmRegistryReport(_x213, _x214) {
	                return _ref330.apply(this, arguments);
	            }
	
	            return uploadCrmRegistryReport;
	        }()
	    }, {
	        key: 'getCrmRegistries',
	        value: function () {
	            var _ref331 = _asyncToGenerator(_regenerator2.default.mark(function _callee174(projects, payoutType) {
	                return _regenerator2.default.wrap(function _callee174$(_context174) {
	                    while (1) {
	                        switch (_context174.prev = _context174.next) {
	                            case 0:
	                                return _context174.abrupt('return', this.client.post('/admin/crm/payout-registries', {
	                                    projects: projects || [], payoutType: payoutType || 'card'
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context174.stop();
	                        }
	                    }
	                }, _callee174, this);
	            }));
	
	            function getCrmRegistries(_x215, _x216) {
	                return _ref331.apply(this, arguments);
	            }
	
	            return getCrmRegistries;
	        }()
	    }, {
	        key: 'disbandCrmRegistry',
	        value: function () {
	            var _ref332 = _asyncToGenerator(_regenerator2.default.mark(function _callee175(registryId) {
	                return _regenerator2.default.wrap(function _callee175$(_context175) {
	                    while (1) {
	                        switch (_context175.prev = _context175.next) {
	                            case 0:
	                                return _context175.abrupt('return', this.client.post('/admin/crm/payout-requests/disband-registry', { registryId: registryId }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context175.stop();
	                        }
	                    }
	                }, _callee175, this);
	            }));
	
	            function disbandCrmRegistry(_x217) {
	                return _ref332.apply(this, arguments);
	            }
	
	            return disbandCrmRegistry;
	        }()
	    }, {
	        key: 'removeFromCrmRegistry',
	        value: function () {
	            var _ref333 = _asyncToGenerator(_regenerator2.default.mark(function _callee176(requestIds) {
	                return _regenerator2.default.wrap(function _callee176$(_context176) {
	                    while (1) {
	                        switch (_context176.prev = _context176.next) {
	                            case 0:
	                                return _context176.abrupt('return', this.client.post('/admin/crm/payout-requests/remove-from-registry', { requestIds: requestIds }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context176.stop();
	                        }
	                    }
	                }, _callee176, this);
	            }));
	
	            function removeFromCrmRegistry(_x218) {
	                return _ref333.apply(this, arguments);
	            }
	
	            return removeFromCrmRegistry;
	        }()
	    }, {
	        key: 'addToCrmRegistry',
	        value: function () {
	            var _ref334 = _asyncToGenerator(_regenerator2.default.mark(function _callee177(registryId, requestIds) {
	                return _regenerator2.default.wrap(function _callee177$(_context177) {
	                    while (1) {
	                        switch (_context177.prev = _context177.next) {
	                            case 0:
	                                return _context177.abrupt('return', this.client.post('/admin/crm/payout-requests/add-to-registry', {
	                                    registryId: registryId, requestIds: requestIds
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context177.stop();
	                        }
	                    }
	                }, _callee177, this);
	            }));
	
	            function addToCrmRegistry(_x219, _x220) {
	                return _ref334.apply(this, arguments);
	            }
	
	            return addToCrmRegistry;
	        }()
	    }, {
	        key: 'formCrmRegistryByAmount',
	        value: function () {
	            var _ref335 = _asyncToGenerator(_regenerator2.default.mark(function _callee178(merchantUuid, targetAmount, name, payoutType) {
	                var payload;
	                return _regenerator2.default.wrap(function _callee178$(_context178) {
	                    while (1) {
	                        switch (_context178.prev = _context178.next) {
	                            case 0:
	                                payload = { merchantUuid: merchantUuid, targetAmount: targetAmount, payoutType: payoutType || 'card' };
	
	                                if (name) {
	                                    payload.name = name;
	                                }
	                                return _context178.abrupt('return', this.client.post('/admin/crm/payout-requests/form-registry-by-amount', payload).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context178.stop();
	                        }
	                    }
	                }, _callee178, this);
	            }));
	
	            function formCrmRegistryByAmount(_x221, _x222, _x223, _x224) {
	                return _ref335.apply(this, arguments);
	            }
	
	            return formCrmRegistryByAmount;
	        }()
	    }, {
	        key: 'moveToSuccessCrmPayoutRequest',
	        value: function () {
	            var _ref336 = _asyncToGenerator(_regenerator2.default.mark(function _callee179(id, fee) {
	                var payload;
	                return _regenerator2.default.wrap(function _callee179$(_context179) {
	                    while (1) {
	                        switch (_context179.prev = _context179.next) {
	                            case 0:
	                                payload = {};
	
	                                if (fee !== null && fee !== undefined) {
	                                    payload.fee = fee;
	                                }
	                                return _context179.abrupt('return', this.client.post('/admin/crm/payout-requests/' + id + '/move-to-success', payload).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context179.stop();
	                        }
	                    }
	                }, _callee179, this);
	            }));
	
	            function moveToSuccessCrmPayoutRequest(_x225, _x226) {
	                return _ref336.apply(this, arguments);
	            }
	
	            return moveToSuccessCrmPayoutRequest;
	        }()
	    }, {
	        key: 'bulkMoveToSuccessCrmPayoutRequests',
	        value: function () {
	            var _ref337 = _asyncToGenerator(_regenerator2.default.mark(function _callee180(ids, fee) {
	                var payload;
	                return _regenerator2.default.wrap(function _callee180$(_context180) {
	                    while (1) {
	                        switch (_context180.prev = _context180.next) {
	                            case 0:
	                                payload = { ids: ids };
	
	                                if (fee !== null && fee !== undefined) {
	                                    payload.fee = fee;
	                                }
	                                return _context180.abrupt('return', this.client.post('/admin/crm/payout-requests/bulk-move-to-success', payload).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 3:
	                            case 'end':
	                                return _context180.stop();
	                        }
	                    }
	                }, _callee180, this);
	            }));
	
	            function bulkMoveToSuccessCrmPayoutRequests(_x227, _x228) {
	                return _ref337.apply(this, arguments);
	            }
	
	            return bulkMoveToSuccessCrmPayoutRequests;
	        }()
	
	        // ============================================
	        // CRAFTLITE LIMIT
	        // ============================================
	
	    }, {
	        key: 'getCraftliteLimitStats',
	        value: function () {
	            var _ref338 = _asyncToGenerator(_regenerator2.default.mark(function _callee181() {
	                return _regenerator2.default.wrap(function _callee181$(_context181) {
	                    while (1) {
	                        switch (_context181.prev = _context181.next) {
	                            case 0:
	                                return _context181.abrupt('return', this.client.get('/admin/craftlite-limit/stats').then(function (_ref339) {
	                                    var data = _ref339.data;
	                                    return data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context181.stop();
	                        }
	                    }
	                }, _callee181, this);
	            }));
	
	            function getCraftliteLimitStats() {
	                return _ref338.apply(this, arguments);
	            }
	
	            return getCraftliteLimitStats;
	        }()
	
	        // ============================================
	        // SETTLEMENT
	        // ============================================
	
	    }, {
	        key: 'getSettlements',
	        value: function () {
	            var _ref340 = _asyncToGenerator(_regenerator2.default.mark(function _callee182(filters) {
	                return _regenerator2.default.wrap(function _callee182$(_context182) {
	                    while (1) {
	                        switch (_context182.prev = _context182.next) {
	                            case 0:
	                                return _context182.abrupt('return', this.client.get('/admin/settlements', { params: filters }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context182.stop();
	                        }
	                    }
	                }, _callee182, this);
	            }));
	
	            function getSettlements(_x229) {
	                return _ref340.apply(this, arguments);
	            }
	
	            return getSettlements;
	        }()
	    }, {
	        key: 'getSettlementDetail',
	        value: function () {
	            var _ref341 = _asyncToGenerator(_regenerator2.default.mark(function _callee183(id) {
	                return _regenerator2.default.wrap(function _callee183$(_context183) {
	                    while (1) {
	                        switch (_context183.prev = _context183.next) {
	                            case 0:
	                                return _context183.abrupt('return', this.client.get('/admin/settlements/' + id).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context183.stop();
	                        }
	                    }
	                }, _callee183, this);
	            }));
	
	            function getSettlementDetail(_x230) {
	                return _ref341.apply(this, arguments);
	            }
	
	            return getSettlementDetail;
	        }()
	    }, {
	        key: 'previewSettlement',
	        value: function () {
	            var _ref342 = _asyncToGenerator(_regenerator2.default.mark(function _callee184(data) {
	                return _regenerator2.default.wrap(function _callee184$(_context184) {
	                    while (1) {
	                        switch (_context184.prev = _context184.next) {
	                            case 0:
	                                return _context184.abrupt('return', this.client.post('/admin/settlements/preview', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context184.stop();
	                        }
	                    }
	                }, _callee184, this);
	            }));
	
	            function previewSettlement(_x231) {
	                return _ref342.apply(this, arguments);
	            }
	
	            return previewSettlement;
	        }()
	    }, {
	        key: 'createSettlement',
	        value: function () {
	            var _ref343 = _asyncToGenerator(_regenerator2.default.mark(function _callee185(data) {
	                return _regenerator2.default.wrap(function _callee185$(_context185) {
	                    while (1) {
	                        switch (_context185.prev = _context185.next) {
	                            case 0:
	                                return _context185.abrupt('return', this.client.post('/admin/settlements', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context185.stop();
	                        }
	                    }
	                }, _callee185, this);
	            }));
	
	            function createSettlement(_x232) {
	                return _ref343.apply(this, arguments);
	            }
	
	            return createSettlement;
	        }()
	    }, {
	        key: 'cancelSettlement',
	        value: function () {
	            var _ref344 = _asyncToGenerator(_regenerator2.default.mark(function _callee186(id, data) {
	                return _regenerator2.default.wrap(function _callee186$(_context186) {
	                    while (1) {
	                        switch (_context186.prev = _context186.next) {
	                            case 0:
	                                return _context186.abrupt('return', this.client.post('/admin/settlements/' + id + '/cancel', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context186.stop();
	                        }
	                    }
	                }, _callee186, this);
	            }));
	
	            function cancelSettlement(_x233, _x234) {
	                return _ref344.apply(this, arguments);
	            }
	
	            return cancelSettlement;
	        }()
	    }, {
	        key: 'addSettlementTransactions',
	        value: function () {
	            var _ref345 = _asyncToGenerator(_regenerator2.default.mark(function _callee187(settlementId, transactionIds) {
	                return _regenerator2.default.wrap(function _callee187$(_context187) {
	                    while (1) {
	                        switch (_context187.prev = _context187.next) {
	                            case 0:
	                                return _context187.abrupt('return', this.client.post('/admin/settlements/' + settlementId + '/add-transactions', {
	                                    transaction_ids: transactionIds
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context187.stop();
	                        }
	                    }
	                }, _callee187, this);
	            }));
	
	            function addSettlementTransactions(_x235, _x236) {
	                return _ref345.apply(this, arguments);
	            }
	
	            return addSettlementTransactions;
	        }()
	    }, {
	        key: 'removeSettlementTransactions',
	        value: function () {
	            var _ref346 = _asyncToGenerator(_regenerator2.default.mark(function _callee188(settlementId, transactionIds) {
	                return _regenerator2.default.wrap(function _callee188$(_context188) {
	                    while (1) {
	                        switch (_context188.prev = _context188.next) {
	                            case 0:
	                                return _context188.abrupt('return', this.client.post('/admin/settlements/' + settlementId + '/remove-transactions', {
	                                    transaction_ids: transactionIds
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context188.stop();
	                        }
	                    }
	                }, _callee188, this);
	            }));
	
	            function removeSettlementTransactions(_x237, _x238) {
	                return _ref346.apply(this, arguments);
	            }
	
	            return removeSettlementTransactions;
	        }()
	    }, {
	        key: 'createSettlementMultipart',
	        value: function () {
	            var _ref347 = _asyncToGenerator(_regenerator2.default.mark(function _callee189(formData) {
	                return _regenerator2.default.wrap(function _callee189$(_context189) {
	                    while (1) {
	                        switch (_context189.prev = _context189.next) {
	                            case 0:
	                                return _context189.abrupt('return', this.client.post('/admin/settlements', formData, {
	                                    headers: { 'Content-Type': 'multipart/form-data' }
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context189.stop();
	                        }
	                    }
	                }, _callee189, this);
	            }));
	
	            function createSettlementMultipart(_x239) {
	                return _ref347.apply(this, arguments);
	            }
	
	            return createSettlementMultipart;
	        }()
	    }, {
	        key: 'downloadSettlementPaymentProof',
	        value: function () {
	            var _ref348 = _asyncToGenerator(_regenerator2.default.mark(function _callee190(id) {
	                return _regenerator2.default.wrap(function _callee190$(_context190) {
	                    while (1) {
	                        switch (_context190.prev = _context190.next) {
	                            case 0:
	                                return _context190.abrupt('return', this.client.get('/admin/settlements/' + id + '/payment-proof', { responseType: 'blob' }).then(function (r) {
	                                    var disposition = r.headers['content-disposition'] || '';
	                                    var match = disposition.match(/filename="?([^"]+)"?/);
	                                    var filename = match ? match[1] : 'payment_proof';
	                                    var contentType = r.headers['content-type'] || 'application/octet-stream';
	                                    var url = window.URL.createObjectURL(new Blob([r.data], { type: contentType }));
	                                    var link = document.createElement('a');
	                                    link.href = url;
	                                    link.setAttribute('download', filename);
	                                    document.body.appendChild(link);
	                                    link.click();
	                                    link.remove();
	                                    window.URL.revokeObjectURL(url);
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context190.stop();
	                        }
	                    }
	                }, _callee190, this);
	            }));
	
	            function downloadSettlementPaymentProof(_x240) {
	                return _ref348.apply(this, arguments);
	            }
	
	            return downloadSettlementPaymentProof;
	        }()
	    }, {
	        key: 'downloadSettlementExcel',
	        value: function () {
	            var _ref349 = _asyncToGenerator(_regenerator2.default.mark(function _callee191(id) {
	                return _regenerator2.default.wrap(function _callee191$(_context191) {
	                    while (1) {
	                        switch (_context191.prev = _context191.next) {
	                            case 0:
	                                return _context191.abrupt('return', this.client.get('/admin/settlements/' + id + '/export-excel', { responseType: 'blob' }).then(function (r) {
	                                    var url = window.URL.createObjectURL(new Blob([r.data]));
	                                    var link = document.createElement('a');
	                                    link.href = url;
	                                    link.setAttribute('download', 'settlement_' + id + '.xlsx');
	                                    document.body.appendChild(link);
	                                    link.click();
	                                    link.remove();
	                                    window.URL.revokeObjectURL(url);
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context191.stop();
	                        }
	                    }
	                }, _callee191, this);
	            }));
	
	            function downloadSettlementExcel(_x241) {
	                return _ref349.apply(this, arguments);
	            }
	
	            return downloadSettlementExcel;
	        }()
	
	        // ============================================
	        // DEPOSITS
	        // ============================================
	
	    }, {
	        key: 'getDeposits',
	        value: function () {
	            var _ref350 = _asyncToGenerator(_regenerator2.default.mark(function _callee192(filters) {
	                return _regenerator2.default.wrap(function _callee192$(_context192) {
	                    while (1) {
	                        switch (_context192.prev = _context192.next) {
	                            case 0:
	                                return _context192.abrupt('return', this.client.get('/admin/deposits', { params: filters }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context192.stop();
	                        }
	                    }
	                }, _callee192, this);
	            }));
	
	            function getDeposits(_x242) {
	                return _ref350.apply(this, arguments);
	            }
	
	            return getDeposits;
	        }()
	    }, {
	        key: 'getDepositDetail',
	        value: function () {
	            var _ref351 = _asyncToGenerator(_regenerator2.default.mark(function _callee193(id) {
	                return _regenerator2.default.wrap(function _callee193$(_context193) {
	                    while (1) {
	                        switch (_context193.prev = _context193.next) {
	                            case 0:
	                                return _context193.abrupt('return', this.client.get('/admin/deposits/' + id).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context193.stop();
	                        }
	                    }
	                }, _callee193, this);
	            }));
	
	            function getDepositDetail(_x243) {
	                return _ref351.apply(this, arguments);
	            }
	
	            return getDepositDetail;
	        }()
	    }, {
	        key: 'createDeposit',
	        value: function () {
	            var _ref352 = _asyncToGenerator(_regenerator2.default.mark(function _callee194(data) {
	                return _regenerator2.default.wrap(function _callee194$(_context194) {
	                    while (1) {
	                        switch (_context194.prev = _context194.next) {
	                            case 0:
	                                return _context194.abrupt('return', this.client.post('/admin/deposits', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context194.stop();
	                        }
	                    }
	                }, _callee194, this);
	            }));
	
	            function createDeposit(_x244) {
	                return _ref352.apply(this, arguments);
	            }
	
	            return createDeposit;
	        }()
	    }, {
	        key: 'createDepositMultipart',
	        value: function () {
	            var _ref353 = _asyncToGenerator(_regenerator2.default.mark(function _callee195(formData) {
	                return _regenerator2.default.wrap(function _callee195$(_context195) {
	                    while (1) {
	                        switch (_context195.prev = _context195.next) {
	                            case 0:
	                                return _context195.abrupt('return', this.client.post('/admin/deposits', formData, {
	                                    headers: { 'Content-Type': 'multipart/form-data' }
	                                }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context195.stop();
	                        }
	                    }
	                }, _callee195, this);
	            }));
	
	            function createDepositMultipart(_x245) {
	                return _ref353.apply(this, arguments);
	            }
	
	            return createDepositMultipart;
	        }()
	    }, {
	        key: 'cancelDeposit',
	        value: function () {
	            var _ref354 = _asyncToGenerator(_regenerator2.default.mark(function _callee196(id, data) {
	                return _regenerator2.default.wrap(function _callee196$(_context196) {
	                    while (1) {
	                        switch (_context196.prev = _context196.next) {
	                            case 0:
	                                return _context196.abrupt('return', this.client.post('/admin/deposits/' + id + '/cancel', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context196.stop();
	                        }
	                    }
	                }, _callee196, this);
	            }));
	
	            function cancelDeposit(_x246, _x247) {
	                return _ref354.apply(this, arguments);
	            }
	
	            return cancelDeposit;
	        }()
	    }, {
	        key: 'downloadDepositPaymentProof',
	        value: function () {
	            var _ref355 = _asyncToGenerator(_regenerator2.default.mark(function _callee197(id) {
	                return _regenerator2.default.wrap(function _callee197$(_context197) {
	                    while (1) {
	                        switch (_context197.prev = _context197.next) {
	                            case 0:
	                                return _context197.abrupt('return', this.client.get('/admin/deposits/' + id + '/payment-proof', { responseType: 'blob' }).then(function (r) {
	                                    var disposition = r.headers['content-disposition'] || '';
	                                    var match = disposition.match(/filename="?([^"]+)"?/);
	                                    var filename = match ? match[1] : 'deposit_proof_' + id;
	                                    var url = window.URL.createObjectURL(new Blob([r.data]));
	                                    var link = document.createElement('a');
	                                    link.href = url;
	                                    link.setAttribute('download', filename);
	                                    document.body.appendChild(link);
	                                    link.click();
	                                    link.remove();
	                                    window.URL.revokeObjectURL(url);
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context197.stop();
	                        }
	                    }
	                }, _callee197, this);
	            }));
	
	            function downloadDepositPaymentProof(_x248) {
	                return _ref355.apply(this, arguments);
	            }
	
	            return downloadDepositPaymentProof;
	        }()
	
	        // ============================================
	        // TERMINAL BALANCES & LEDGER
	        // ============================================
	
	    }, {
	        key: 'getTerminalBalances',
	        value: function () {
	            var _ref356 = _asyncToGenerator(_regenerator2.default.mark(function _callee198(terminalId, merchantUuid) {
	                var config;
	                return _regenerator2.default.wrap(function _callee198$(_context198) {
	                    while (1) {
	                        switch (_context198.prev = _context198.next) {
	                            case 0:
	                                config = merchantUuid ? { params: { merchant_uuid: merchantUuid } } : undefined;
	                                return _context198.abrupt('return', this.client.get('/admin/terminals/' + terminalId + '/balances', config).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context198.stop();
	                        }
	                    }
	                }, _callee198, this);
	            }));
	
	            function getTerminalBalances(_x249, _x250) {
	                return _ref356.apply(this, arguments);
	            }
	
	            return getTerminalBalances;
	        }()
	    }, {
	        key: 'getTerminalLedger',
	        value: function () {
	            var _ref357 = _asyncToGenerator(_regenerator2.default.mark(function _callee199(terminalId, filters) {
	                return _regenerator2.default.wrap(function _callee199$(_context199) {
	                    while (1) {
	                        switch (_context199.prev = _context199.next) {
	                            case 0:
	                                return _context199.abrupt('return', this.client.get('/admin/terminals/' + terminalId + '/ledger', { params: filters }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context199.stop();
	                        }
	                    }
	                }, _callee199, this);
	            }));
	
	            function getTerminalLedger(_x251, _x252) {
	                return _ref357.apply(this, arguments);
	            }
	
	            return getTerminalLedger;
	        }()
	    }, {
	        key: 'createTerminalLedgerEntry',
	        value: function () {
	            var _ref358 = _asyncToGenerator(_regenerator2.default.mark(function _callee200(terminalId, data) {
	                return _regenerator2.default.wrap(function _callee200$(_context200) {
	                    while (1) {
	                        switch (_context200.prev = _context200.next) {
	                            case 0:
	                                return _context200.abrupt('return', this.client.post('/admin/terminals/' + terminalId + '/ledger', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context200.stop();
	                        }
	                    }
	                }, _callee200, this);
	            }));
	
	            function createTerminalLedgerEntry(_x253, _x254) {
	                return _ref358.apply(this, arguments);
	            }
	
	            return createTerminalLedgerEntry;
	        }()
	    }, {
	        key: 'updateTerminalBalanceLimits',
	        value: function () {
	            var _ref359 = _asyncToGenerator(_regenerator2.default.mark(function _callee201(terminalId, data) {
	                return _regenerator2.default.wrap(function _callee201$(_context201) {
	                    while (1) {
	                        switch (_context201.prev = _context201.next) {
	                            case 0:
	                                return _context201.abrupt('return', this.client.put('/admin/terminals/' + terminalId + '/limits', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context201.stop();
	                        }
	                    }
	                }, _callee201, this);
	            }));
	
	            function updateTerminalBalanceLimits(_x255, _x256) {
	                return _ref359.apply(this, arguments);
	            }
	
	            return updateTerminalBalanceLimits;
	        }()
	    }, {
	        key: 'updateTerminalSettlementConfig',
	        value: function () {
	            var _ref360 = _asyncToGenerator(_regenerator2.default.mark(function _callee202(terminalId, data) {
	                return _regenerator2.default.wrap(function _callee202$(_context202) {
	                    while (1) {
	                        switch (_context202.prev = _context202.next) {
	                            case 0:
	                                return _context202.abrupt('return', this.client.put('/admin/terminals/' + terminalId + '/settlement-config', data).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context202.stop();
	                        }
	                    }
	                }, _callee202, this);
	            }));
	
	            function updateTerminalSettlementConfig(_x257, _x258) {
	                return _ref360.apply(this, arguments);
	            }
	
	            return updateTerminalSettlementConfig;
	        }()
	    }, {
	        key: 'getAdminTerminalFees',
	        value: function () {
	            var _ref361 = _asyncToGenerator(_regenerator2.default.mark(function _callee203(terminalId) {
	                return _regenerator2.default.wrap(function _callee203$(_context203) {
	                    while (1) {
	                        switch (_context203.prev = _context203.next) {
	                            case 0:
	                                return _context203.abrupt('return', this.client.get('/admin/terminals/' + terminalId + '/fees').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context203.stop();
	                        }
	                    }
	                }, _callee203, this);
	            }));
	
	            function getAdminTerminalFees(_x259) {
	                return _ref361.apply(this, arguments);
	            }
	
	            return getAdminTerminalFees;
	        }()
	    }, {
	        key: 'updateAdminTerminalFees',
	        value: function () {
	            var _ref362 = _asyncToGenerator(_regenerator2.default.mark(function _callee204(terminalId, fees) {
	                return _regenerator2.default.wrap(function _callee204$(_context204) {
	                    while (1) {
	                        switch (_context204.prev = _context204.next) {
	                            case 0:
	                                return _context204.abrupt('return', this.client.put('/admin/terminals/' + terminalId + '/fees', { fees: fees }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context204.stop();
	                        }
	                    }
	                }, _callee204, this);
	            }));
	
	            function updateAdminTerminalFees(_x260, _x261) {
	                return _ref362.apply(this, arguments);
	            }
	
	            return updateAdminTerminalFees;
	        }()
	
	        // ============================================
	        // MERCHANT BALANCE API
	        // ============================================
	
	    }, {
	        key: 'getMerchantBalances',
	        value: function () {
	            var _ref363 = _asyncToGenerator(_regenerator2.default.mark(function _callee205() {
	                return _regenerator2.default.wrap(function _callee205$(_context205) {
	                    while (1) {
	                        switch (_context205.prev = _context205.next) {
	                            case 0:
	                                return _context205.abrupt('return', this.client.get('/merchant/balances').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context205.stop();
	                        }
	                    }
	                }, _callee205, this);
	            }));
	
	            function getMerchantBalances() {
	                return _ref363.apply(this, arguments);
	            }
	
	            return getMerchantBalances;
	        }()
	    }, {
	        key: 'getMerchantStatement',
	        value: function () {
	            var _ref364 = _asyncToGenerator(_regenerator2.default.mark(function _callee206(filters) {
	                return _regenerator2.default.wrap(function _callee206$(_context206) {
	                    while (1) {
	                        switch (_context206.prev = _context206.next) {
	                            case 0:
	                                return _context206.abrupt('return', this.client.get('/merchant/statement', { params: filters }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context206.stop();
	                        }
	                    }
	                }, _callee206, this);
	            }));
	
	            function getMerchantStatement(_x262) {
	                return _ref364.apply(this, arguments);
	            }
	
	            return getMerchantStatement;
	        }()
	    }, {
	        key: 'getTrafficMonitoring',
	        value: function () {
	            var _ref365 = _asyncToGenerator(_regenerator2.default.mark(function _callee207() {
	                return _regenerator2.default.wrap(function _callee207$(_context207) {
	                    while (1) {
	                        switch (_context207.prev = _context207.next) {
	                            case 0:
	                                return _context207.abrupt('return', this.client.get('/admin/traffic-monitoring').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context207.stop();
	                        }
	                    }
	                }, _callee207, this);
	            }));
	
	            function getTrafficMonitoring() {
	                return _ref365.apply(this, arguments);
	            }
	
	            return getTrafficMonitoring;
	        }()
	    }, {
	        key: 'exportMerchantStatement',
	        value: function () {
	            var _ref366 = _asyncToGenerator(_regenerator2.default.mark(function _callee208(params) {
	                return _regenerator2.default.wrap(function _callee208$(_context208) {
	                    while (1) {
	                        switch (_context208.prev = _context208.next) {
	                            case 0:
	                                return _context208.abrupt('return', this.client.get('/merchant/statement/export', { params: params, responseType: 'blob' }).then(function (r) {
	                                    var url = window.URL.createObjectURL(new Blob([r.data]));
	                                    var link = document.createElement('a');
	                                    link.href = url;
	                                    link.setAttribute('download', 'statement.xlsx');
	                                    document.body.appendChild(link);
	                                    link.click();
	                                    link.remove();
	                                    window.URL.revokeObjectURL(url);
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context208.stop();
	                        }
	                    }
	                }, _callee208, this);
	            }));
	
	            function exportMerchantStatement(_x263) {
	                return _ref366.apply(this, arguments);
	            }
	
	            return exportMerchantStatement;
	        }()
	
	        // ------------- Секретные чаты -------------
	        //
	        // Переписка шифруется на сервере и удаляется через сутки, поэтому здесь
	        // ничего не кэшируется: список и сообщения всегда запрашиваются заново,
	        // иначе кабинет показывал бы то, чего на сервере уже нет.
	
	    }, {
	        key: 'getSecretChatsUnreadCount',
	        value: function () {
	            var _ref367 = _asyncToGenerator(_regenerator2.default.mark(function _callee209() {
	                return _regenerator2.default.wrap(function _callee209$(_context209) {
	                    while (1) {
	                        switch (_context209.prev = _context209.next) {
	                            case 0:
	                                return _context209.abrupt('return', this.client.get('/account/secret-chats/unread-count').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context209.stop();
	                        }
	                    }
	                }, _callee209, this);
	            }));
	
	            function getSecretChatsUnreadCount() {
	                return _ref367.apply(this, arguments);
	            }
	
	            return getSecretChatsUnreadCount;
	        }()
	    }, {
	        key: 'getAdminSecretChatsUnreadCount',
	        value: function () {
	            var _ref368 = _asyncToGenerator(_regenerator2.default.mark(function _callee210() {
	                return _regenerator2.default.wrap(function _callee210$(_context210) {
	                    while (1) {
	                        switch (_context210.prev = _context210.next) {
	                            case 0:
	                                return _context210.abrupt('return', this.client.get('/admin/secret-chats/unread-count').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context210.stop();
	                        }
	                    }
	                }, _callee210, this);
	            }));
	
	            function getAdminSecretChatsUnreadCount() {
	                return _ref368.apply(this, arguments);
	            }
	
	            return getAdminSecretChatsUnreadCount;
	        }()
	    }, {
	        key: 'listSecretChats',
	        value: function () {
	            var _ref369 = _asyncToGenerator(_regenerator2.default.mark(function _callee211() {
	                return _regenerator2.default.wrap(function _callee211$(_context211) {
	                    while (1) {
	                        switch (_context211.prev = _context211.next) {
	                            case 0:
	                                return _context211.abrupt('return', this.client.get('/account/secret-chats').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context211.stop();
	                        }
	                    }
	                }, _callee211, this);
	            }));
	
	            function listSecretChats() {
	                return _ref369.apply(this, arguments);
	            }
	
	            return listSecretChats;
	        }()
	    }, {
	        key: 'createSecretChat',
	        value: function () {
	            var _ref370 = _asyncToGenerator(_regenerator2.default.mark(function _callee212(subject, message) {
	                return _regenerator2.default.wrap(function _callee212$(_context212) {
	                    while (1) {
	                        switch (_context212.prev = _context212.next) {
	                            case 0:
	                                return _context212.abrupt('return', this.client.post('/account/secret-chats', { subject: subject, message: message }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context212.stop();
	                        }
	                    }
	                }, _callee212, this);
	            }));
	
	            function createSecretChat(_x264, _x265) {
	                return _ref370.apply(this, arguments);
	            }
	
	            return createSecretChat;
	        }()
	    }, {
	        key: 'getSecretChatMessages',
	        value: function () {
	            var _ref371 = _asyncToGenerator(_regenerator2.default.mark(function _callee213(id) {
	                return _regenerator2.default.wrap(function _callee213$(_context213) {
	                    while (1) {
	                        switch (_context213.prev = _context213.next) {
	                            case 0:
	                                return _context213.abrupt('return', this.client.get('/account/secret-chats/' + id + '/messages').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context213.stop();
	                        }
	                    }
	                }, _callee213, this);
	            }));
	
	            function getSecretChatMessages(_x266) {
	                return _ref371.apply(this, arguments);
	            }
	
	            return getSecretChatMessages;
	        }()
	    }, {
	        key: 'postSecretChatMessage',
	        value: function () {
	            var _ref372 = _asyncToGenerator(_regenerator2.default.mark(function _callee214(id, body, files) {
	                var form;
	                return _regenerator2.default.wrap(function _callee214$(_context214) {
	                    while (1) {
	                        switch (_context214.prev = _context214.next) {
	                            case 0:
	                                if (!(files && files.length > 0)) {
	                                    _context214.next = 5;
	                                    break;
	                                }
	
	                                form = new FormData();
	
	                                form.append('body', body || '');
	                                files.forEach(function (file) {
	                                    return form.append('files[]', file);
	                                });
	
	                                return _context214.abrupt('return', this.client.post('/account/secret-chats/' + id + '/messages', form).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 5:
	                                return _context214.abrupt('return', this.client.post('/account/secret-chats/' + id + '/messages', { body: body }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 6:
	                            case 'end':
	                                return _context214.stop();
	                        }
	                    }
	                }, _callee214, this);
	            }));
	
	            function postSecretChatMessage(_x267, _x268, _x269) {
	                return _ref372.apply(this, arguments);
	            }
	
	            return postSecretChatMessage;
	        }()
	
	        /**
	         * Адрес файла. Скачивается запросом с токеном (см. downloadSecretChatFile):
	         * простая ссылка не подойдёт — заголовка авторизации у неё нет.
	         */
	
	    }, {
	        key: 'secretChatFileUrl',
	        value: function secretChatFileUrl(chatId, fileId, asAdmin) {
	            var base = asAdmin ? '/admin/secret-chats' : '/account/secret-chats';
	
	            return base + '/' + chatId + '/files/' + fileId;
	        }
	    }, {
	        key: 'downloadSecretChatFile',
	        value: function () {
	            var _ref373 = _asyncToGenerator(_regenerator2.default.mark(function _callee215(chatId, fileId, asAdmin) {
	                return _regenerator2.default.wrap(function _callee215$(_context215) {
	                    while (1) {
	                        switch (_context215.prev = _context215.next) {
	                            case 0:
	                                return _context215.abrupt('return', this.client.get(this.secretChatFileUrl(chatId, fileId, asAdmin), { responseType: 'blob' }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context215.stop();
	                        }
	                    }
	                }, _callee215, this);
	            }));
	
	            function downloadSecretChatFile(_x270, _x271, _x272) {
	                return _ref373.apply(this, arguments);
	            }
	
	            return downloadSecretChatFile;
	        }()
	    }, {
	        key: 'readSecretChat',
	        value: function () {
	            var _ref374 = _asyncToGenerator(_regenerator2.default.mark(function _callee216(id) {
	                return _regenerator2.default.wrap(function _callee216$(_context216) {
	                    while (1) {
	                        switch (_context216.prev = _context216.next) {
	                            case 0:
	                                return _context216.abrupt('return', this.client.post('/account/secret-chats/' + id + '/read', {}).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context216.stop();
	                        }
	                    }
	                }, _callee216, this);
	            }));
	
	            function readSecretChat(_x273) {
	                return _ref374.apply(this, arguments);
	            }
	
	            return readSecretChat;
	        }()
	    }, {
	        key: 'listAdminSecretChats',
	        value: function () {
	            var _ref375 = _asyncToGenerator(_regenerator2.default.mark(function _callee217() {
	                return _regenerator2.default.wrap(function _callee217$(_context217) {
	                    while (1) {
	                        switch (_context217.prev = _context217.next) {
	                            case 0:
	                                return _context217.abrupt('return', this.client.get('/admin/secret-chats').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context217.stop();
	                        }
	                    }
	                }, _callee217, this);
	            }));
	
	            function listAdminSecretChats() {
	                return _ref375.apply(this, arguments);
	            }
	
	            return listAdminSecretChats;
	        }()
	    }, {
	        key: 'listAdminSecretChatAccounts',
	        value: function () {
	            var _ref376 = _asyncToGenerator(_regenerator2.default.mark(function _callee218(query) {
	                return _regenerator2.default.wrap(function _callee218$(_context218) {
	                    while (1) {
	                        switch (_context218.prev = _context218.next) {
	                            case 0:
	                                return _context218.abrupt('return', this.client.get('/admin/secret-chats/accounts', { params: query ? { query: query } : {} }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context218.stop();
	                        }
	                    }
	                }, _callee218, this);
	            }));
	
	            function listAdminSecretChatAccounts(_x274) {
	                return _ref376.apply(this, arguments);
	            }
	
	            return listAdminSecretChatAccounts;
	        }()
	    }, {
	        key: 'createAdminSecretChat',
	        value: function () {
	            var _ref377 = _asyncToGenerator(_regenerator2.default.mark(function _callee219(accountId, subject, message) {
	                return _regenerator2.default.wrap(function _callee219$(_context219) {
	                    while (1) {
	                        switch (_context219.prev = _context219.next) {
	                            case 0:
	                                return _context219.abrupt('return', this.client.post('/admin/secret-chats', { accountId: accountId, subject: subject, message: message }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context219.stop();
	                        }
	                    }
	                }, _callee219, this);
	            }));
	
	            function createAdminSecretChat(_x275, _x276, _x277) {
	                return _ref377.apply(this, arguments);
	            }
	
	            return createAdminSecretChat;
	        }()
	    }, {
	        key: 'getAdminSecretChatMessages',
	        value: function () {
	            var _ref378 = _asyncToGenerator(_regenerator2.default.mark(function _callee220(id) {
	                return _regenerator2.default.wrap(function _callee220$(_context220) {
	                    while (1) {
	                        switch (_context220.prev = _context220.next) {
	                            case 0:
	                                return _context220.abrupt('return', this.client.get('/admin/secret-chats/' + id + '/messages').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context220.stop();
	                        }
	                    }
	                }, _callee220, this);
	            }));
	
	            function getAdminSecretChatMessages(_x278) {
	                return _ref378.apply(this, arguments);
	            }
	
	            return getAdminSecretChatMessages;
	        }()
	    }, {
	        key: 'postAdminSecretChatMessage',
	        value: function () {
	            var _ref379 = _asyncToGenerator(_regenerator2.default.mark(function _callee221(id, body, files) {
	                var form;
	                return _regenerator2.default.wrap(function _callee221$(_context221) {
	                    while (1) {
	                        switch (_context221.prev = _context221.next) {
	                            case 0:
	                                if (!(files && files.length > 0)) {
	                                    _context221.next = 5;
	                                    break;
	                                }
	
	                                form = new FormData();
	
	                                form.append('body', body || '');
	                                files.forEach(function (file) {
	                                    return form.append('files[]', file);
	                                });
	
	                                return _context221.abrupt('return', this.client.post('/admin/secret-chats/' + id + '/messages', form).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 5:
	                                return _context221.abrupt('return', this.client.post('/admin/secret-chats/' + id + '/messages', { body: body }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 6:
	                            case 'end':
	                                return _context221.stop();
	                        }
	                    }
	                }, _callee221, this);
	            }));
	
	            function postAdminSecretChatMessage(_x279, _x280, _x281) {
	                return _ref379.apply(this, arguments);
	            }
	
	            return postAdminSecretChatMessage;
	        }()
	    }, {
	        key: 'readAdminSecretChat',
	        value: function () {
	            var _ref380 = _asyncToGenerator(_regenerator2.default.mark(function _callee222(id) {
	                return _regenerator2.default.wrap(function _callee222$(_context222) {
	                    while (1) {
	                        switch (_context222.prev = _context222.next) {
	                            case 0:
	                                return _context222.abrupt('return', this.client.post('/admin/secret-chats/' + id + '/read', {}).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context222.stop();
	                        }
	                    }
	                }, _callee222, this);
	            }));
	
	            function readAdminSecretChat(_x282) {
	                return _ref380.apply(this, arguments);
	            }
	
	            return readAdminSecretChat;
	        }()
	
	        // ------------- Support tickets (merchant widget) -------------
	
	    }, {
	        key: 'listMerchantTickets',
	        value: function () {
	            var _ref381 = _asyncToGenerator(_regenerator2.default.mark(function _callee223() {
	                return _regenerator2.default.wrap(function _callee223$(_context223) {
	                    while (1) {
	                        switch (_context223.prev = _context223.next) {
	                            case 0:
	                                return _context223.abrupt('return', this.client.get('/merchant/tickets').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context223.stop();
	                        }
	                    }
	                }, _callee223, this);
	            }));
	
	            function listMerchantTickets() {
	                return _ref381.apply(this, arguments);
	            }
	
	            return listMerchantTickets;
	        }()
	    }, {
	        key: 'getMerchantTicketsUnreadCount',
	        value: function () {
	            var _ref382 = _asyncToGenerator(_regenerator2.default.mark(function _callee224() {
	                return _regenerator2.default.wrap(function _callee224$(_context224) {
	                    while (1) {
	                        switch (_context224.prev = _context224.next) {
	                            case 0:
	                                return _context224.abrupt('return', this.client.get('/merchant/tickets/unread-count').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context224.stop();
	                        }
	                    }
	                }, _callee224, this);
	            }));
	
	            function getMerchantTicketsUnreadCount() {
	                return _ref382.apply(this, arguments);
	            }
	
	            return getMerchantTicketsUnreadCount;
	        }()
	    }, {
	        key: 'getMerchantTicket',
	        value: function () {
	            var _ref383 = _asyncToGenerator(_regenerator2.default.mark(function _callee225(id) {
	                return _regenerator2.default.wrap(function _callee225$(_context225) {
	                    while (1) {
	                        switch (_context225.prev = _context225.next) {
	                            case 0:
	                                return _context225.abrupt('return', this.client.get('/merchant/tickets/' + id).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context225.stop();
	                        }
	                    }
	                }, _callee225, this);
	            }));
	
	            function getMerchantTicket(_x283) {
	                return _ref383.apply(this, arguments);
	            }
	
	            return getMerchantTicket;
	        }()
	    }, {
	        key: 'getMerchantTicketMessages',
	        value: function () {
	            var _ref384 = _asyncToGenerator(_regenerator2.default.mark(function _callee226(id, since) {
	                var params;
	                return _regenerator2.default.wrap(function _callee226$(_context226) {
	                    while (1) {
	                        switch (_context226.prev = _context226.next) {
	                            case 0:
	                                params = since ? { since: since } : {};
	                                return _context226.abrupt('return', this.client.get('/merchant/tickets/' + id + '/messages', { params: params }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context226.stop();
	                        }
	                    }
	                }, _callee226, this);
	            }));
	
	            function getMerchantTicketMessages(_x284, _x285) {
	                return _ref384.apply(this, arguments);
	            }
	
	            return getMerchantTicketMessages;
	        }()
	    }, {
	        key: 'createMerchantTicket',
	        value: function () {
	            var _ref385 = _asyncToGenerator(_regenerator2.default.mark(function _callee227(subject, body, files) {
	                var created, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, f, fd;
	
	                return _regenerator2.default.wrap(function _callee227$(_context227) {
	                    while (1) {
	                        switch (_context227.prev = _context227.next) {
	                            case 0:
	                                _context227.next = 2;
	                                return this.client.post('/merchant/tickets', { subject: subject, body: body }).then(function (r) {
	                                    return r.data;
	                                });
	
	                            case 2:
	                                created = _context227.sent;
	
	                                if (!(created && created.first_message_id && (files || []).length > 0)) {
	                                    _context227.next = 32;
	                                    break;
	                                }
	
	                                _iteratorNormalCompletion = true;
	                                _didIteratorError = false;
	                                _iteratorError = undefined;
	                                _context227.prev = 7;
	                                _iterator = files[Symbol.iterator]();
	
	                            case 9:
	                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                    _context227.next = 18;
	                                    break;
	                                }
	
	                                f = _step.value;
	                                fd = new FormData();
	
	                                fd.append('file', f);
	                                _context227.next = 15;
	                                return this.client.post('/merchant/tickets/' + created.ticket.id + '/messages/' + created.first_message_id + '/attachments', fd);
	
	                            case 15:
	                                _iteratorNormalCompletion = true;
	                                _context227.next = 9;
	                                break;
	
	                            case 18:
	                                _context227.next = 24;
	                                break;
	
	                            case 20:
	                                _context227.prev = 20;
	                                _context227.t0 = _context227['catch'](7);
	                                _didIteratorError = true;
	                                _iteratorError = _context227.t0;
	
	                            case 24:
	                                _context227.prev = 24;
	                                _context227.prev = 25;
	
	                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                    _iterator.return();
	                                }
	
	                            case 27:
	                                _context227.prev = 27;
	
	                                if (!_didIteratorError) {
	                                    _context227.next = 30;
	                                    break;
	                                }
	
	                                throw _iteratorError;
	
	                            case 30:
	                                return _context227.finish(27);
	
	                            case 31:
	                                return _context227.finish(24);
	
	                            case 32:
	                                return _context227.abrupt('return', created);
	
	                            case 33:
	                            case 'end':
	                                return _context227.stop();
	                        }
	                    }
	                }, _callee227, this, [[7, 20, 24, 32], [25,, 27, 31]]);
	            }));
	
	            function createMerchantTicket(_x286, _x287, _x288) {
	                return _ref385.apply(this, arguments);
	            }
	
	            return createMerchantTicket;
	        }()
	    }, {
	        key: 'postMerchantTicketMessage',
	        value: function () {
	            var _ref386 = _asyncToGenerator(_regenerator2.default.mark(function _callee228(id, body, files) {
	                var sent, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, f, fd;
	
	                return _regenerator2.default.wrap(function _callee228$(_context228) {
	                    while (1) {
	                        switch (_context228.prev = _context228.next) {
	                            case 0:
	                                _context228.next = 2;
	                                return this.client.post('/merchant/tickets/' + id + '/messages', { body: body }).then(function (r) {
	                                    return r.data;
	                                });
	
	                            case 2:
	                                sent = _context228.sent;
	
	                                if (!(sent && sent.message && sent.message.id && (files || []).length > 0)) {
	                                    _context228.next = 32;
	                                    break;
	                                }
	
	                                _iteratorNormalCompletion2 = true;
	                                _didIteratorError2 = false;
	                                _iteratorError2 = undefined;
	                                _context228.prev = 7;
	                                _iterator2 = files[Symbol.iterator]();
	
	                            case 9:
	                                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                                    _context228.next = 18;
	                                    break;
	                                }
	
	                                f = _step2.value;
	                                fd = new FormData();
	
	                                fd.append('file', f);
	                                _context228.next = 15;
	                                return this.client.post('/merchant/tickets/' + id + '/messages/' + sent.message.id + '/attachments', fd);
	
	                            case 15:
	                                _iteratorNormalCompletion2 = true;
	                                _context228.next = 9;
	                                break;
	
	                            case 18:
	                                _context228.next = 24;
	                                break;
	
	                            case 20:
	                                _context228.prev = 20;
	                                _context228.t0 = _context228['catch'](7);
	                                _didIteratorError2 = true;
	                                _iteratorError2 = _context228.t0;
	
	                            case 24:
	                                _context228.prev = 24;
	                                _context228.prev = 25;
	
	                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                    _iterator2.return();
	                                }
	
	                            case 27:
	                                _context228.prev = 27;
	
	                                if (!_didIteratorError2) {
	                                    _context228.next = 30;
	                                    break;
	                                }
	
	                                throw _iteratorError2;
	
	                            case 30:
	                                return _context228.finish(27);
	
	                            case 31:
	                                return _context228.finish(24);
	
	                            case 32:
	                                return _context228.abrupt('return', sent);
	
	                            case 33:
	                            case 'end':
	                                return _context228.stop();
	                        }
	                    }
	                }, _callee228, this, [[7, 20, 24, 32], [25,, 27, 31]]);
	            }));
	
	            function postMerchantTicketMessage(_x289, _x290, _x291) {
	                return _ref386.apply(this, arguments);
	            }
	
	            return postMerchantTicketMessage;
	        }()
	    }, {
	        key: 'editMerchantTicketMessage',
	        value: function () {
	            var _ref387 = _asyncToGenerator(_regenerator2.default.mark(function _callee229(id, msgId, body) {
	                return _regenerator2.default.wrap(function _callee229$(_context229) {
	                    while (1) {
	                        switch (_context229.prev = _context229.next) {
	                            case 0:
	                                return _context229.abrupt('return', this.client.patch('/merchant/tickets/' + id + '/messages/' + msgId, { body: body }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context229.stop();
	                        }
	                    }
	                }, _callee229, this);
	            }));
	
	            function editMerchantTicketMessage(_x292, _x293, _x294) {
	                return _ref387.apply(this, arguments);
	            }
	
	            return editMerchantTicketMessage;
	        }()
	    }, {
	        key: 'markMerchantTicketRead',
	        value: function () {
	            var _ref388 = _asyncToGenerator(_regenerator2.default.mark(function _callee230(id) {
	                return _regenerator2.default.wrap(function _callee230$(_context230) {
	                    while (1) {
	                        switch (_context230.prev = _context230.next) {
	                            case 0:
	                                return _context230.abrupt('return', this.client.post('/merchant/tickets/' + id + '/read').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context230.stop();
	                        }
	                    }
	                }, _callee230, this);
	            }));
	
	            function markMerchantTicketRead(_x295) {
	                return _ref388.apply(this, arguments);
	            }
	
	            return markMerchantTicketRead;
	        }()
	    }, {
	        key: 'merchantTicketAttachmentUrl',
	        value: function merchantTicketAttachmentUrl(ticketId, attachmentId) {
	            return (({"NODE_ENV":"production","PUBLIC_URL":"","API_URL":"https://api.test.e-clear.cc","BRAND":"eclear","REACT_APP_SENTRY_TRACES_SAMPLE_RATE":"0.2","REACT_APP_SENTRY_DSN":""}).REACT_APP_API_URL || ("https://api.test.e-clear.cc") || '') + '/merchant/tickets/' + ticketId + '/attachments/' + attachmentId;
	        }
	    }, {
	        key: 'downloadMerchantTicketAttachment',
	        value: function () {
	            var _ref389 = _asyncToGenerator(_regenerator2.default.mark(function _callee231(ticketId, attachmentId, filename) {
	                var r, url, link;
	                return _regenerator2.default.wrap(function _callee231$(_context231) {
	                    while (1) {
	                        switch (_context231.prev = _context231.next) {
	                            case 0:
	                                _context231.next = 2;
	                                return this.client.get('/merchant/tickets/' + ticketId + '/attachments/' + attachmentId, { responseType: 'blob' });
	
	                            case 2:
	                                r = _context231.sent;
	                                url = window.URL.createObjectURL(new Blob([r.data]));
	                                link = document.createElement('a');
	
	                                link.href = url;
	                                link.setAttribute('download', filename || 'file');
	                                document.body.appendChild(link);
	                                link.click();
	                                link.remove();
	                                window.URL.revokeObjectURL(url);
	
	                            case 11:
	                            case 'end':
	                                return _context231.stop();
	                        }
	                    }
	                }, _callee231, this);
	            }));
	
	            function downloadMerchantTicketAttachment(_x296, _x297, _x298) {
	                return _ref389.apply(this, arguments);
	            }
	
	            return downloadMerchantTicketAttachment;
	        }()
	
	        // ------------- Support tickets (admin) -------------
	
	    }, {
	        key: 'adminListTickets',
	        value: function () {
	            var _ref390 = _asyncToGenerator(_regenerator2.default.mark(function _callee232(params) {
	                return _regenerator2.default.wrap(function _callee232$(_context232) {
	                    while (1) {
	                        switch (_context232.prev = _context232.next) {
	                            case 0:
	                                return _context232.abrupt('return', this.client.get('/admin/tickets', { params: params }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context232.stop();
	                        }
	                    }
	                }, _callee232, this);
	            }));
	
	            function adminListTickets(_x299) {
	                return _ref390.apply(this, arguments);
	            }
	
	            return adminListTickets;
	        }()
	    }, {
	        key: 'adminGetTicket',
	        value: function () {
	            var _ref391 = _asyncToGenerator(_regenerator2.default.mark(function _callee233(id) {
	                return _regenerator2.default.wrap(function _callee233$(_context233) {
	                    while (1) {
	                        switch (_context233.prev = _context233.next) {
	                            case 0:
	                                return _context233.abrupt('return', this.client.get('/admin/tickets/' + id).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context233.stop();
	                        }
	                    }
	                }, _callee233, this);
	            }));
	
	            function adminGetTicket(_x300) {
	                return _ref391.apply(this, arguments);
	            }
	
	            return adminGetTicket;
	        }()
	    }, {
	        key: 'adminGetTicketMessages',
	        value: function () {
	            var _ref392 = _asyncToGenerator(_regenerator2.default.mark(function _callee234(id, since) {
	                var params;
	                return _regenerator2.default.wrap(function _callee234$(_context234) {
	                    while (1) {
	                        switch (_context234.prev = _context234.next) {
	                            case 0:
	                                params = since ? { since: since } : {};
	                                return _context234.abrupt('return', this.client.get('/admin/tickets/' + id + '/messages', { params: params }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 2:
	                            case 'end':
	                                return _context234.stop();
	                        }
	                    }
	                }, _callee234, this);
	            }));
	
	            function adminGetTicketMessages(_x301, _x302) {
	                return _ref392.apply(this, arguments);
	            }
	
	            return adminGetTicketMessages;
	        }()
	    }, {
	        key: 'adminPostTicketMessage',
	        value: function () {
	            var _ref393 = _asyncToGenerator(_regenerator2.default.mark(function _callee235(id, body, files) {
	                var sent, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, f, fd;
	
	                return _regenerator2.default.wrap(function _callee235$(_context235) {
	                    while (1) {
	                        switch (_context235.prev = _context235.next) {
	                            case 0:
	                                _context235.next = 2;
	                                return this.client.post('/admin/tickets/' + id + '/messages', { body: body }).then(function (r) {
	                                    return r.data;
	                                });
	
	                            case 2:
	                                sent = _context235.sent;
	
	                                if (!(sent && sent.message && sent.message.id && (files || []).length > 0)) {
	                                    _context235.next = 32;
	                                    break;
	                                }
	
	                                _iteratorNormalCompletion3 = true;
	                                _didIteratorError3 = false;
	                                _iteratorError3 = undefined;
	                                _context235.prev = 7;
	                                _iterator3 = files[Symbol.iterator]();
	
	                            case 9:
	                                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
	                                    _context235.next = 18;
	                                    break;
	                                }
	
	                                f = _step3.value;
	                                fd = new FormData();
	
	                                fd.append('file', f);
	                                _context235.next = 15;
	                                return this.client.post('/admin/tickets/' + id + '/messages/' + sent.message.id + '/attachments', fd);
	
	                            case 15:
	                                _iteratorNormalCompletion3 = true;
	                                _context235.next = 9;
	                                break;
	
	                            case 18:
	                                _context235.next = 24;
	                                break;
	
	                            case 20:
	                                _context235.prev = 20;
	                                _context235.t0 = _context235['catch'](7);
	                                _didIteratorError3 = true;
	                                _iteratorError3 = _context235.t0;
	
	                            case 24:
	                                _context235.prev = 24;
	                                _context235.prev = 25;
	
	                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                    _iterator3.return();
	                                }
	
	                            case 27:
	                                _context235.prev = 27;
	
	                                if (!_didIteratorError3) {
	                                    _context235.next = 30;
	                                    break;
	                                }
	
	                                throw _iteratorError3;
	
	                            case 30:
	                                return _context235.finish(27);
	
	                            case 31:
	                                return _context235.finish(24);
	
	                            case 32:
	                                return _context235.abrupt('return', sent);
	
	                            case 33:
	                            case 'end':
	                                return _context235.stop();
	                        }
	                    }
	                }, _callee235, this, [[7, 20, 24, 32], [25,, 27, 31]]);
	            }));
	
	            function adminPostTicketMessage(_x303, _x304, _x305) {
	                return _ref393.apply(this, arguments);
	            }
	
	            return adminPostTicketMessage;
	        }()
	    }, {
	        key: 'adminEditTicketMessage',
	        value: function () {
	            var _ref394 = _asyncToGenerator(_regenerator2.default.mark(function _callee236(id, msgId, body) {
	                return _regenerator2.default.wrap(function _callee236$(_context236) {
	                    while (1) {
	                        switch (_context236.prev = _context236.next) {
	                            case 0:
	                                return _context236.abrupt('return', this.client.patch('/admin/tickets/' + id + '/messages/' + msgId, { body: body }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context236.stop();
	                        }
	                    }
	                }, _callee236, this);
	            }));
	
	            function adminEditTicketMessage(_x306, _x307, _x308) {
	                return _ref394.apply(this, arguments);
	            }
	
	            return adminEditTicketMessage;
	        }()
	    }, {
	        key: 'adminDeleteTicketMessage',
	        value: function () {
	            var _ref395 = _asyncToGenerator(_regenerator2.default.mark(function _callee237(id, msgId) {
	                return _regenerator2.default.wrap(function _callee237$(_context237) {
	                    while (1) {
	                        switch (_context237.prev = _context237.next) {
	                            case 0:
	                                return _context237.abrupt('return', this.client.delete('/admin/tickets/' + id + '/messages/' + msgId).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context237.stop();
	                        }
	                    }
	                }, _callee237, this);
	            }));
	
	            function adminDeleteTicketMessage(_x309, _x310) {
	                return _ref395.apply(this, arguments);
	            }
	
	            return adminDeleteTicketMessage;
	        }()
	    }, {
	        key: 'adminDeleteTicketAttachment',
	        value: function () {
	            var _ref396 = _asyncToGenerator(_regenerator2.default.mark(function _callee238(id, aid) {
	                return _regenerator2.default.wrap(function _callee238$(_context238) {
	                    while (1) {
	                        switch (_context238.prev = _context238.next) {
	                            case 0:
	                                return _context238.abrupt('return', this.client.delete('/admin/tickets/' + id + '/attachments/' + aid).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context238.stop();
	                        }
	                    }
	                }, _callee238, this);
	            }));
	
	            function adminDeleteTicketAttachment(_x311, _x312) {
	                return _ref396.apply(this, arguments);
	            }
	
	            return adminDeleteTicketAttachment;
	        }()
	    }, {
	        key: 'adminDeleteTicket',
	        value: function () {
	            var _ref397 = _asyncToGenerator(_regenerator2.default.mark(function _callee239(id) {
	                return _regenerator2.default.wrap(function _callee239$(_context239) {
	                    while (1) {
	                        switch (_context239.prev = _context239.next) {
	                            case 0:
	                                return _context239.abrupt('return', this.client.delete('/admin/tickets/' + id).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context239.stop();
	                        }
	                    }
	                }, _callee239, this);
	            }));
	
	            function adminDeleteTicket(_x313) {
	                return _ref397.apply(this, arguments);
	            }
	
	            return adminDeleteTicket;
	        }()
	    }, {
	        key: 'adminChangeTicketStatus',
	        value: function () {
	            var _ref398 = _asyncToGenerator(_regenerator2.default.mark(function _callee240(id, status) {
	                return _regenerator2.default.wrap(function _callee240$(_context240) {
	                    while (1) {
	                        switch (_context240.prev = _context240.next) {
	                            case 0:
	                                return _context240.abrupt('return', this.client.post('/admin/tickets/' + id + '/status', { status: status }).then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context240.stop();
	                        }
	                    }
	                }, _callee240, this);
	            }));
	
	            function adminChangeTicketStatus(_x314, _x315) {
	                return _ref398.apply(this, arguments);
	            }
	
	            return adminChangeTicketStatus;
	        }()
	    }, {
	        key: 'adminMarkTicketRead',
	        value: function () {
	            var _ref399 = _asyncToGenerator(_regenerator2.default.mark(function _callee241(id) {
	                return _regenerator2.default.wrap(function _callee241$(_context241) {
	                    while (1) {
	                        switch (_context241.prev = _context241.next) {
	                            case 0:
	                                return _context241.abrupt('return', this.client.post('/admin/tickets/' + id + '/read').then(function (r) {
	                                    return r.data;
	                                }));
	
	                            case 1:
	                            case 'end':
	                                return _context241.stop();
	                        }
	                    }
	                }, _callee241, this);
	            }));
	
	            function adminMarkTicketRead(_x316) {
	                return _ref399.apply(this, arguments);
	            }
	
	            return adminMarkTicketRead;
	        }()
	    }, {
	        key: 'adminDownloadTicketAttachment',
	        value: function () {
	            var _ref400 = _asyncToGenerator(_regenerator2.default.mark(function _callee242(ticketId, attachmentId, filename) {
	                var r, url, link;
	                return _regenerator2.default.wrap(function _callee242$(_context242) {
	                    while (1) {
	                        switch (_context242.prev = _context242.next) {
	                            case 0:
	                                _context242.next = 2;
	                                return this.client.get('/admin/tickets/' + ticketId + '/attachments/' + attachmentId, { responseType: 'blob' });
	
	                            case 2:
	                                r = _context242.sent;
	                                url = window.URL.createObjectURL(new Blob([r.data]));
	                                link = document.createElement('a');
	
	                                link.href = url;
	                                link.setAttribute('download', filename || 'file');
	                                document.body.appendChild(link);
	                                link.click();
	                                link.remove();
	                                window.URL.revokeObjectURL(url);
	
	                            case 11:
	                            case 'end':
	                                return _context242.stop();
	                        }
	                    }
	                }, _callee242, this);
	            }));
	
	            function adminDownloadTicketAttachment(_x317, _x318, _x319) {
	                return _ref400.apply(this, arguments);
	            }
	
	            return adminDownloadTicketAttachment;
	        }()
	    }]);
	
	    return Api;
	}();
	
	exports.default = Api;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AuthProvider = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.withAuth = withAuth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _jwtDecode = __webpack_require__(666);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _ApiConfig = __webpack_require__(91);
	
	var _ApiConfig2 = _interopRequireDefault(_ApiConfig);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _React$createContext = _react2.default.createContext({
	    isAuthorized: false,
	    adminPrivileges: false,
	    requires2FASetup: false,
	    token: null,
	    accountAccessSettings: null,
	    globalPrivileges: null
	}),
	    Provider = _React$createContext.Provider,
	    AuthConsumer = _React$createContext.Consumer;
	
	var AuthProvider = function (_PureComponent) {
	    _inherits(AuthProvider, _PureComponent);
	
	    function AuthProvider(props) {
	        _classCallCheck(this, AuthProvider);
	
	        // Синхронная инициализация из storage — предотвращает redirect на /login при перезагрузке
	        // Токен всегда в localStorage (доступен всем вкладкам).
	        // Без "Запомнить меня" — sessionStorage маркер SESSION_ACTIVE контролирует сессию:
	        // при закрытии браузера маркер пропадёт → следующий запуск очистит токен.
	        var _this = _possibleConstructorReturn(this, (AuthProvider.__proto__ || Object.getPrototypeOf(AuthProvider)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var token = localStorage.getItem("AUTH_TOKEN");
	        var isRemember = localStorage.getItem("IS_REMEMBER") === "Y";
	
	        // Без "Запомнить меня": проверяем, что сессия браузера ещё жива
	        if (token && !isRemember) {
	            if (!sessionStorage.getItem("SESSION_ACTIVE")) {
	                // Браузер был закрыт и открыт заново — очищаем токен
	                localStorage.removeItem("AUTH_TOKEN");
	                token = null;
	            }
	        }
	
	        if (token) {
	            try {
	                var tokenDecode = (0, _jwtDecode2.default)(token);
	                // Маркер сессии для новых вкладок (sessionStorage копируется при middle-click,
	                // а для вкладок открытых вручную — устанавливаем здесь)
	                sessionStorage.setItem("SESSION_ACTIVE", "Y");
	                // Restore Sentry user context from saved token
	                Sentry.setUser({
	                    id: tokenDecode.username || 'unknown',
	                    username: tokenDecode.username,
	                    admin: !!tokenDecode.adminPrivileges
	                });
	
	                _this.state = {
	                    isAuthorized: true,
	                    token: token,
	                    isRemember: isRemember,
	                    adminPrivileges: tokenDecode.adminPrivileges,
	                    forcedPasswordChange: tokenDecode.forcedPasswordChange,
	                    requires2FASetup: tokenDecode.requires2FASetup,
	                    accountAccessSettings: tokenDecode.accountAccessSettings,
	                    globalPrivileges: tokenDecode.globalPrivileges != null ? tokenDecode.globalPrivileges : null
	                };
	            } catch (error) {
	                Sentry.captureException(error);
	                console.error("Invalid token:", error);
	                localStorage.removeItem("AUTH_TOKEN");
	                localStorage.removeItem("IS_REMEMBER");
	                sessionStorage.removeItem("SESSION_ACTIVE");
	                _this.state = _this._defaultState();
	            }
	        } else {
	            _this.state = _this._defaultState();
	        }
	        return _this;
	    }
	
	    _createClass(AuthProvider, [{
	        key: "_defaultState",
	        value: function _defaultState() {
	            return {
	                isAuthorized: false,
	                adminPrivileges: false,
	                forcedPasswordChange: false,
	                requires2FASetup: false,
	                isRemember: false,
	                token: null,
	                accountAccessSettings: null,
	                globalPrivileges: null
	            };
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _ApiConfig2.default.setLogoutCallback(this.logout);
	
	            // Подгружаем свежие права если авторизованы
	            if (this.state.isAuthorized && this.state.token) {
	                this._refreshPermissions();
	            }
	
	            // Периодическое обновление прав каждые 2 минуты
	            this._permissionsInterval = setInterval(function () {
	                if (_this2.state.isAuthorized && _this2.state.token) {
	                    _this2._refreshPermissions();
	                }
	            }, 2 * 60 * 1000);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this._permissionsInterval) {
	                clearInterval(this._permissionsInterval);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var isAuthorized = this.state.isAuthorized;
	            var adminPrivileges = this.state.adminPrivileges;
	            var forcedPasswordChange = this.state.forcedPasswordChange;
	            var requires2FASetup = this.state.requires2FASetup;
	            var isRemember = this.state.isRemember;
	            var token = this.state.token;
	            var accountAccessSettings = this.state.accountAccessSettings;
	            var globalPrivileges = this.state.globalPrivileges;
	
	
	            return _react2.default.createElement(
	                Provider,
	                { value: {
	                        isAuthorized: isAuthorized,
	                        adminPrivileges: adminPrivileges,
	                        forcedPasswordChange: forcedPasswordChange,
	                        requires2FASetup: requires2FASetup,
	                        accountAccessSettings: accountAccessSettings,
	                        globalPrivileges: globalPrivileges,
	                        isRemember: isRemember,
	                        token: token,
	                        authorize: this.authorize,
	                        logout: this.logout,
	                        remember: this.remember,
	                        clear2FASetupFlag: this.clear2FASetupFlag
	                    } },
	                this.props.children
	            );
	        }
	    }]);
	
	    return AuthProvider;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this5 = this;
	
	    this.authorize = function (token, isRemember) {
	        var tokenDecode = (0, _jwtDecode2.default)(token);
	
	        // Токен всегда в localStorage — доступен всем вкладкам
	        localStorage.setItem("AUTH_TOKEN", token);
	        // Маркер активной сессии — пропадает при закрытии браузера
	        sessionStorage.setItem("SESSION_ACTIVE", "Y");
	
	        if (isRemember) {
	            localStorage.setItem("IS_REMEMBER", "Y");
	        } else {
	            localStorage.removeItem("IS_REMEMBER");
	        }
	
	        // Set Sentry user context
	        Sentry.setUser({
	            id: tokenDecode.username || 'unknown',
	            username: tokenDecode.username,
	            admin: !!tokenDecode.adminPrivileges
	        });
	
	        _this5.setState({
	            isAuthorized: true,
	            token: token,
	            isRemember: !!isRemember,
	            adminPrivileges: tokenDecode.adminPrivileges,
	            forcedPasswordChange: tokenDecode.forcedPasswordChange,
	            requires2FASetup: tokenDecode.requires2FASetup,
	            accountAccessSettings: tokenDecode.accountAccessSettings,
	            globalPrivileges: tokenDecode.globalPrivileges != null ? tokenDecode.globalPrivileges : null
	        });
	    };
	
	    this.logout = function () {
	        if (_this5._permissionsInterval) {
	            clearInterval(_this5._permissionsInterval);
	        }
	        Sentry.setUser(null);
	        _this5.setState({ token: false, isAuthorized: false, adminPrivileges: false, globalPrivileges: null, accountAccessSettings: null });
	        localStorage.removeItem("AUTH_TOKEN");
	        localStorage.removeItem("IS_REMEMBER");
	        sessionStorage.removeItem("SESSION_ACTIVE");
	    };
	
	    this.remember = function () {
	        _this5.setState({ isRemember: !_this5.state.isRemember });
	    };
	
	    this._refreshPermissions = function () {
	        new _Api2.default({ token: _this5.state.token }).getPermissions().then(function (data) {
	            if (data && data.accountAccessSettings) {
	                var updates = {
	                    accountAccessSettings: data.accountAccessSettings,
	                    globalPrivileges: data.globalPrivileges != null ? data.globalPrivileges : null,
	                    requires2FASetup: !!data.requires2FASetup,
	                    forcedPasswordChange: !!data.forcedPasswordChange
	                };
	                // Права администратора тоже с сервера: из токена снятые права
	                // держали админское меню на экране до конца его жизни (неделю).
	                if (data.adminPrivileges !== undefined) {
	                    updates.adminPrivileges = data.adminPrivileges;
	                }
	                _this5.setState(updates);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            // Если не удалось — используем текущие из JWT
	        });
	    };
	
	    this.clear2FASetupFlag = function () {
	        _this5.setState({ requires2FASetup: false });
	    };
	};
	
	function withAuth(WrappedComponent) {
	
	    return function (_PureComponent2) {
	        _inherits(AuthHOC, _PureComponent2);
	
	        function AuthHOC() {
	            _classCallCheck(this, AuthHOC);
	
	            return _possibleConstructorReturn(this, (AuthHOC.__proto__ || Object.getPrototypeOf(AuthHOC)).apply(this, arguments));
	        }
	
	        _createClass(AuthHOC, [{
	            key: "render",
	            value: function render() {
	                var _this4 = this;
	
	                return _react2.default.createElement(
	                    AuthConsumer,
	                    null,
	                    function (contextProps) {
	                        return _react2.default.createElement(WrappedComponent, Object.assign({}, contextProps, _this4.props));
	                    }
	                );
	            }
	        }]);
	
	        return AuthHOC;
	    }(_react.PureComponent);
	}
	
	exports.AuthProvider = AuthProvider;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIcomoon = __webpack_require__(676);
	
	var _reactIcomoon2 = _interopRequireDefault(_reactIcomoon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var iconSet = __webpack_require__(663);
	
	var Icon = function Icon(_ref) {
	    var props = _objectWithoutProperties(_ref, []);
	
	    return _react2.default.createElement(_reactIcomoon2.default, Object.assign({ iconSet: iconSet }, props));
	};
	
	exports.default = Icon;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useLayoutScope = exports.LayoutScopeProvider = exports.PublicLayout = exports.AdminLayout = exports.UserLayout = exports.RoleLayout = exports.Container = exports.Column = exports.Wrapper = undefined;
	
	var _RoleLayout = __webpack_require__(100);
	
	Object.defineProperty(exports, 'RoleLayout', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_RoleLayout).default;
	    }
	});
	
	var _UserLayout = __webpack_require__(516);
	
	Object.defineProperty(exports, 'UserLayout', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_UserLayout).default;
	    }
	});
	
	var _AdminLayout = __webpack_require__(514);
	
	Object.defineProperty(exports, 'AdminLayout', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_AdminLayout).default;
	    }
	});
	
	var _PublicLayout = __webpack_require__(515);
	
	Object.defineProperty(exports, 'PublicLayout', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_PublicLayout).default;
	    }
	});
	
	var _LayoutScopeContext = __webpack_require__(193);
	
	Object.defineProperty(exports, 'LayoutScopeProvider', {
	    enumerable: true,
	    get: function get() {
	        return _LayoutScopeContext.LayoutScopeProvider;
	    }
	});
	Object.defineProperty(exports, 'useLayoutScope', {
	    enumerable: true,
	    get: function get() {
	        return _LayoutScopeContext.useLayoutScope;
	    }
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(113);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Column = function Column(props) {
	    var widthStyle = function () {
	        if (props.width === 'full') return { flex: 1, width: '100%' };
	        if (props.width == null) return {};
	        var w = String(props.width);
	        if (/^\d+$/.test(w)) return { width: w + 'px' };
	        return { width: w };
	    }();
	    return _react2.default.createElement(
	        'div',
	        { style: widthStyle, className: '' + _stylesModule2.default.Column + (props.className ? ' ' + props.className : '') },
	        props.children
	    );
	};
	
	var Container = function Container(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: props.style, className: '' + _stylesModule2.default.Container + (props.className ? ' ' + props.className : '') },
	        props.children
	    );
	};
	
	var Wrapper = function Wrapper(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: props.style, className: _stylesModule2.default.Wrapper },
	        props.children
	    );
	};
	
	exports.Wrapper = Wrapper;
	exports.Column = Column;
	exports.Container = Container;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	tslib_1.__exportStar(__webpack_require__(262), exports);
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var BrowserIntegrations = __webpack_require__(75);
	var Transports = __webpack_require__(148);
	exports.Transports = Transports;
	var windowIntegrations = {};
	// This block is needed to add compatibility with the integrations packages when used with a CDN
	var _window = utils_1.getGlobalObject();
	if (_window.Sentry && _window.Sentry.Integrations) {
	    windowIntegrations = _window.Sentry.Integrations;
	}
	var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
	exports.Integrations = INTEGRATIONS;
	//# sourceMappingURL=index.js.map

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(590);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader(_ref) {
	    var isString = _ref.isString,
	        color = _ref.color;
	
	    var styles = {
	        position: null,
	        loader: null,
	        color: null
	    };
	
	    switch (isString) {
	        case true:
	            styles.position = _stylesModule2.default.ButtonPosition;
	            styles.loader = _stylesModule2.default.ButtonLoader;
	            break;
	        default:
	            styles.position = _stylesModule2.default.Position;
	            styles.loader = _stylesModule2.default.Loader;
	    }
	
	    switch (color) {
	        case 'grey':
	            styles.color = _stylesModule2.default.Grey;
	            break;
	        default:
	            styles.color = _stylesModule2.default.White;
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: styles.position },
	        _react2.default.createElement('div', { className: styles.color + ' ' + styles.loader })
	    );
	};
	
	exports.default = Loader;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	tslib_1.__exportStar(__webpack_require__(304), exports);
	tslib_1.__exportStar(__webpack_require__(155), exports);
	tslib_1.__exportStar(__webpack_require__(305), exports);
	tslib_1.__exportStar(__webpack_require__(85), exports);
	tslib_1.__exportStar(__webpack_require__(306), exports);
	tslib_1.__exportStar(__webpack_require__(37), exports);
	tslib_1.__exportStar(__webpack_require__(86), exports);
	tslib_1.__exportStar(__webpack_require__(156), exports);
	tslib_1.__exportStar(__webpack_require__(49), exports);
	tslib_1.__exportStar(__webpack_require__(87), exports);
	tslib_1.__exportStar(__webpack_require__(88), exports);
	tslib_1.__exportStar(__webpack_require__(307), exports);
	tslib_1.__exportStar(__webpack_require__(309), exports);
	tslib_1.__exportStar(__webpack_require__(89), exports);
	tslib_1.__exportStar(__webpack_require__(90), exports);
	tslib_1.__exportStar(__webpack_require__(157), exports);
	tslib_1.__exportStar(__webpack_require__(158), exports);
	tslib_1.__exportStar(__webpack_require__(310), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(687);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageContext = _react2.default.createContext(null);
	
	exports.default = MessageContext;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddressDaData = exports.MaskedIH = exports.Select = exports.MultipleSelect = exports.MultipleField = exports.InputAmountCurrencyHelper = exports.PasswordInputHelper = exports.CardNumberInputHelper = exports.InputHelper = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _propTypes = __webpack_require__(23);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTextMask = __webpack_require__(695);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _reactIntl = __webpack_require__(2);
	
	var _UseDebounce = __webpack_require__(517);
	
	var _UseDebounce2 = _interopRequireDefault(_UseDebounce);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(587);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var generator = {
	    generate: function generate(opts) {
	        var length = opts && opts.length || 10;
	        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
	        if (opts && opts.numbers) chars += "0123456789";
	        if (opts && opts.symbols) chars += "!@#$%^&*()_+-=";
	        var result = "";
	        var array = new Uint32Array(length);
	        window.crypto.getRandomValues(array);
	        for (var i = 0; i < length; i++) {
	            result += chars[array[i] % chars.length];
	        }
	        return result;
	    }
	};
	
	
	var InputHelper = function InputHelper(_ref) {
	    var index = _ref.index,
	        onChange = _ref.onChange,
	        value = _ref.value,
	        placeholder = _ref.placeholder,
	        fieldName = _ref.fieldName,
	        label = _ref.label,
	        isDisabled = _ref.isDisabled,
	        changeRegexp = _ref.changeRegexp,
	        blurRegexp = _ref.blurRegexp,
	        isUppercase = _ref.isUppercase,
	        changeMessage = _ref.changeMessage,
	        blurMessage = _ref.blurMessage,
	        autoComplete = _ref.autoComplete,
	        readonly = _ref.readonly,
	        isRequired = _ref.isRequired;
	
	    var _useState = (0, _react.useState)(true),
	        _useState2 = _slicedToArray(_useState, 2),
	        isValid = _useState2[0],
	        setIsValid = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(''),
	        _useState4 = _slicedToArray(_useState3, 2),
	        errorMessage = _useState4[0],
	        setErrorMessage = _useState4[1];
	
	    function handlerChange(name, value) {
	
	        if (changeRegexp && value.match(changeRegexp)) {
	
	            setIsValid(false);
	
	            setErrorMessage(function () {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: changeMessage, defaultMessage: "no translate" });
	            });
	        } else {
	            setIsValid(true);
	
	            if (isUppercase) onChange(name, value.toUpperCase());else onChange(name, value);
	        }
	    }
	
	    function handlerChangeWithIndex(index, name, value) {
	
	        if (changeRegexp && value.match(changeRegexp)) {
	
	            setIsValid(false);
	
	            setErrorMessage(function () {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: changeMessage, defaultMessage: "no translate" });
	            });
	        } else {
	            setIsValid(true);
	
	            if (isUppercase) onChange(index, name, value.toUpperCase());else onChange(index, name, value);
	        }
	    }
	
	    function handlerBlur(name, value) {
	        if (isRequired && value.length === 0) {
	            setIsValid(false);
	            if (blurMessage) {
	                setErrorMessage(function () {
	                    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: blurMessage, defaultMessage: "no translate" });
	                });
	            }
	        } else if (blurRegexp && !value.match(blurRegexp)) {
	            setIsValid(false);
	            if (blurMessage) {
	                setErrorMessage(function () {
	                    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: blurMessage, defaultMessage: "no translate" });
	                });
	            }
	        } else {
	            setIsValid(true);
	        }
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "no translation" })
	        ),
	        _react2.default.createElement("input", { placeholder: placeholder,
	            className: _stylesModule2.default.Input + " " + (fieldName === 'cardHolder' ? _stylesModule2.default.Uppercase : ''),
	            value: value,
	            onChange: function onChange(e) {
	                return index != null ? handlerChangeWithIndex(index, fieldName, e.target.value) : handlerChange(fieldName, e.target.value);
	            },
	            onBlur: function onBlur(e) {
	                return handlerBlur(fieldName, e.target.value);
	            },
	            disabled: isDisabled,
	            autoComplete: autoComplete ? autoComplete : "on",
	            readOnly: readonly
	        }),
	        !isValid && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Error, onClick: function onClick() {
	                    return setIsValid(true);
	                } },
	            errorMessage
	        )
	    );
	};
	
	var InputAmountCurrencyHelper = function InputAmountCurrencyHelper(_ref2) {
	    var onChange = _ref2.onChange,
	        value = _ref2.value,
	        maxValue = _ref2.maxValue,
	        placeholder = _ref2.placeholder,
	        label = _ref2.label,
	        isDisabled = _ref2.isDisabled,
	        changeMessage = _ref2.changeMessage,
	        blurMessage = _ref2.blurMessage,
	        currency = _ref2.currency;
	
	    var _useState5 = (0, _react.useState)(true),
	        _useState6 = _slicedToArray(_useState5, 2),
	        isValid = _useState6[0],
	        setIsValid = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(''),
	        _useState8 = _slicedToArray(_useState7, 2),
	        errorMessage = _useState8[0],
	        setErrorMessage = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 1),
	        isOpened = _useState10[0];
	
	    var _useState11 = (0, _react.useState)(currency),
	        _useState12 = _slicedToArray(_useState11, 1),
	        currencyList = _useState12[0];
	
	    function handleChange(name, value) {
	
	        if (value.match(/[^0-9.]+/g)) {
	
	            setIsValid(false);
	
	            setErrorMessage(function () {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: changeMessage, defaultMessage: "no translate" });
	            });
	        } else {
	            setIsValid(true);
	
	            if (maxValue) {
	                if (value > maxValue) {
	                    onChange(name, maxValue);
	                } else {
	                    onChange(name, value);
	                }
	            } else {
	                onChange(name, value);
	            }
	        }
	    }
	
	    function handleBlur(name, value) {
	        if (value.length !== 0 && !value.match(/^\d+(\.\d{1,2})?$/)) {
	
	            setIsValid(false);
	
	            setErrorMessage(function () {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: blurMessage, defaultMessage: "no translate" });
	            });
	        } else {
	            setIsValid(true);
	        }
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "no translation" })
	        ),
	        _react2.default.createElement("input", { placeholder: placeholder,
	            className: _stylesModule2.default.Input,
	            value: value,
	            onChange: function onChange(e) {
	                return handleChange("amount", e.target.value);
	            },
	            onBlur: function onBlur(e) {
	                return handleBlur("amount", e.target.value);
	            },
	            disabled: isDisabled
	        }),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CurrencySelect },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.CurrentCurrency },
	                currency[0],
	                currencyList.length > 1 && (isOpened ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CurrencySelectIcon, icon: "cheveron-up", size: '12px' }) : _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CurrencySelectIcon, icon: "cheveron-down", size: '12px' }))
	            )
	        ),
	        !isValid && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Error, onClick: function onClick() {
	                    return setIsValid(true);
	                } },
	            errorMessage
	        )
	    );
	};
	
	var CardNumberInputHelper = function CardNumberInputHelper(_ref3) {
	    var onChange = _ref3.onChange,
	        value = _ref3.value,
	        placeholder = _ref3.placeholder,
	        isDisabled = _ref3.isDisabled;
	
	    var _useState13 = (0, _react.useState)(true),
	        _useState14 = _slicedToArray(_useState13, 2),
	        isValid = _useState14[0],
	        setIsValid = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(''),
	        _useState16 = _slicedToArray(_useState15, 2),
	        errorMessage = _useState16[0],
	        setErrorMessage = _useState16[1];
	
	    function luhnCheck(pan) {
	        if (!pan) return !1;
	
	        if (pan.length % 2 !== 0) pan = "0" + pan;
	        var K = void 0,
	            Sum = 0;
	
	        for (var i = 0; i < pan.length; i += 2) {
	            K = pan.charAt(i) * 2;Sum += (K > 9 ? K - 9 : K) + Number(pan.charAt(i + 1));
	        }
	
	        return Sum % 10 === 0;
	    }
	
	    function handlerChange(name, value) {
	        setIsValid(true);
	
	        if (value.replace(/\s/g, '').length === 16 || value.replace(/\s/g, '').length === 19) {
	            if (!luhnCheck(value.replace(/\s/g, ''))) {
	                setIsValid(false);
	                setErrorMessage(function () {
	                    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FieldsHelper.error.checkCardNumber', defaultMessage: "no translate" });
	                });
	            } else {
	                setIsValid(true);
	                onChange(name, value);
	            }
	        }
	    }
	
	    function handlerBlur(name, value) {
	
	        if (!luhnCheck(value.replace(/\s/g, ''))) {
	            setIsValid(false);
	            setErrorMessage(function () {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FieldsHelper.error.checkCardNumber', defaultMessage: "no translate" });
	            });
	        } else {
	            setIsValid(true);
	            onChange(name, value);
	        }
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B"
	        ),
	        _react2.default.createElement(_reactTextMask2.default, {
	            className: _stylesModule2.default.Input,
	            value: value,
	            mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/],
	            placeholderChar: "\u2000",
	            placeholder: placeholder,
	            onChange: function onChange(e) {
	                return handlerChange('pan', e.target.value);
	            },
	            onBlur: function onBlur(e) {
	                return handlerBlur('pan', e.target.value);
	            },
	            disabled: isDisabled,
	            autoComplete: "off"
	        }),
	        !isValid && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Error, onClick: function onClick() {
	                    return setIsValid(true);
	                } },
	            errorMessage
	        )
	    );
	};
	
	var PasswordInputHelper = function PasswordInputHelper(_ref4) {
	    var onChange = _ref4.onChange,
	        value = _ref4.value,
	        isDisabled = _ref4.isDisabled,
	        _ref4$label = _ref4.label,
	        label = _ref4$label === undefined ? "Генерация нового пароля" : _ref4$label;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.InputHeader },
	            _react2.default.createElement(
	                "label",
	                { className: _stylesModule2.default.Label },
	                label
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.InputLink, onClick: function onClick() {
	                        return onChange('password', '');
	                    } },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.LinkIcon, icon: "close", size: "12px" }),
	                "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"
	            )
	        ),
	        _react2.default.createElement("input", { className: _stylesModule2.default.Input, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", value: value, readOnly: true,
	            disabled: isDisabled }),
	        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconPassword, icon: "key2", size: '22px', onClick: function onClick() {
	                !isDisabled && onChange('password', generator.generate({ length: 10, numbers: true, symbols: true }));
	            } })
	    );
	};
	
	var MultipleField = function MultipleField(_ref5) {
	    var label = _ref5.label,
	        name = _ref5.name,
	        width = _ref5.width,
	        placeholder = _ref5.placeholder,
	        fieldName = _ref5.fieldName,
	        onChange = _ref5.onChange,
	        changeRegexp = _ref5.changeRegexp,
	        blurRegexp = _ref5.blurRegexp,
	        changeMessage = _ref5.changeMessage,
	        blurMessage = _ref5.blurMessage,
	        values = _ref5.values,
	        isDisabled = _ref5.isDisabled,
	        autoComplete = _ref5.autoComplete;
	
	    var _useState17 = (0, _react.useState)(true),
	        _useState18 = _slicedToArray(_useState17, 2),
	        isValid = _useState18[0],
	        setIsValid = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({ index: 0, message: "" }),
	        _useState20 = _slicedToArray(_useState19, 2),
	        error = _useState20[0],
	        setError = _useState20[1];
	
	    function handleRemove(index) {
	        var v = [].concat(_toConsumableArray(values));
	        v.splice(index, 1);
	        onChange(fieldName, v);
	    }
	
	    function handleAdd() {
	        var v = [].concat(_toConsumableArray(values));
	        v.push("");
	        onChange(fieldName, v);
	    }
	
	    function handlerChange(index, value) {
	
	        if (changeRegexp && value.match(changeRegexp)) {
	
	            setIsValid(false);
	
	            setError(function () {
	                return { index: index, message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: changeMessage, defaultMessage: "no translate" }) };
	            });
	        } else {
	            setIsValid(true);
	
	            var v = [].concat(_toConsumableArray(values));
	            v[index] = value;
	            onChange(fieldName, v);
	        }
	    }
	
	    function handlerBlur(index, value) {
	        if (blurRegexp && value.length !== 0 && !value.match(blurRegexp)) {
	
	            setIsValid(false);
	
	            setError(function () {
	                return { index: index, message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: blurMessage, defaultMessage: "no translate" }) };
	            });
	        } else {
	            setIsValid(true);
	        }
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "no translation" })
	        ),
	        values.map(function (val, index) {
	            return _react2.default.createElement(
	                "div",
	                { key: index, className: _stylesModule2.default.MFFieldWrap },
	                _react2.default.createElement("input", { name: name + "_" + index, onChange: function onChange(e) {
	                        return handlerChange(index, e.target.value);
	                    },
	                    onBlur: function onBlur(e) {
	                        return handlerBlur(index, e.target.value);
	                    },
	                    style: { width: width + "px" }, className: _stylesModule2.default.MFField, value: val,
	                    placeholder: placeholder, disabled: isDisabled,
	                    autoComplete: autoComplete ? autoComplete : "on" }),
	                !index ? _react2.default.createElement(_Icon2.default, { onClick: function onClick() {
	                        return handleAdd();
	                    }, style: { left: width + 10 + "px" },
	                    className: _stylesModule2.default.MFAddIcon, icon: "plus", size: '16px' }) : _react2.default.createElement(_Icon2.default, { onClick: function onClick() {
	                        return handleRemove(index);
	                    }, style: { left: width + 10 + "px" },
	                    className: _stylesModule2.default.MFRemoveIcon, icon: "close", size: '16px' }),
	                !isValid && error.index === index && _react2.default.createElement(
	                    "div",
	                    { style: { width: width + "px" }, className: _stylesModule2.default.MFFieldError,
	                        onClick: function onClick() {
	                            return setIsValid(true);
	                        } },
	                    error.message
	                )
	            );
	        })
	    );
	};
	
	var MultipleSelect = function MultipleSelect(_ref6) {
	    var label = _ref6.label,
	        placeholder = _ref6.placeholder,
	        isLoading = _ref6.isLoading,
	        selectedValues = _ref6.selectedValues,
	        values = _ref6.values,
	        onChange = _ref6.onChange,
	        excludeSearchColumn = _ref6.excludeSearchColumn;
	
	    var _useState21 = (0, _react.useState)(false),
	        _useState22 = _slicedToArray(_useState21, 2),
	        isOpened = _useState22[0],
	        setIsOpened = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(""),
	        _useState24 = _slicedToArray(_useState23, 2),
	        searchText = _useState24[0],
	        setSearchText = _useState24[1];
	
	    var wrap = (0, _react.useRef)(null);
	    var dropdown = (0, _react.useRef)(null);
	
	    var safeSelected = selectedValues || [];
	    var safeValues = values || [];
	    var safeExclude = excludeSearchColumn || [];
	
	    (0, _react.useEffect)(function () {
	        function handleClickOutside(e) {
	            if (wrap.current && !wrap.current.contains(e.target)) {
	                setIsOpened(false);
	                setSearchText("");
	            }
	        }
	
	        document.addEventListener("click", handleClickOutside);
	        return function () {
	            return document.removeEventListener("click", handleClickOutside);
	        };
	    }, []);
	
	    function toggleState() {
	        if (isLoading || safeValues.length === 0) return;
	        setIsOpened(!isOpened);
	        if (!isOpened) setSearchText("");
	    }
	
	    function handleChange(uuid, isChecked) {
	        onChange(function (prev) {
	            var newArr = prev.slice();
	            if (isChecked) {
	                newArr.push(uuid);
	            } else {
	                var index = newArr.indexOf(uuid);
	                if (index > -1) newArr.splice(index, 1);
	            }
	            return newArr;
	        });
	    }
	
	    function isChecked(uuid) {
	        return safeSelected.indexOf(uuid) !== -1;
	    }
	
	    function renderPlaceholder() {
	        if (safeSelected.length === 0) {
	            return _react2.default.createElement(_reactIntl.FormattedMessage, { id: placeholder, defaultMessage: "no translation" });
	        }
	        if (safeSelected.length > 3) {
	            return safeSelected.length + " выбрано";
	        }
	
	        var names = [];
	        for (var i = 0; i < safeSelected.length; i++) {
	            var uuid = safeSelected[i];
	            for (var j = 0; j < safeValues.length; j++) {
	                if (safeValues[j].uuid === uuid) {
	                    names.push(safeValues[j].displayName);
	                    break;
	                }
	            }
	        }
	        return names.join(", ");
	    }
	
	    function getFilteredData() {
	        if (!searchText) return safeValues;
	
	        var lower = searchText.toLowerCase();
	        var result = [];
	
	        for (var i = 0; i < safeValues.length; i++) {
	            var item = safeValues[i];
	            var found = false;
	
	            for (var key in item) {
	                if (safeExclude.indexOf(key) !== -1) continue;
	                var value = item[key];
	                if (value === null || value === undefined) continue;
	                if (String(value).toLowerCase().indexOf(lower) !== -1) {
	                    found = true;
	                    break;
	                }
	            }
	            if (found) result.push(item);
	        }
	        return result;
	    }
	
	    var filteredData = getFilteredData();
	
	    return _react2.default.createElement(
	        "div",
	        { ref: wrap, className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "no translation" })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.SelectWrap },
	            _react2.default.createElement(
	                "div",
	                {
	                    className: _stylesModule2.default.Select + " " + (isLoading || safeValues.length === 0 ? _stylesModule2.default.SelectDisabled : ""),
	                    onClick: toggleState
	                },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    renderPlaceholder()
	                ),
	                _react2.default.createElement(_Icon2.default, {
	                    className: _stylesModule2.default.SelectArrow,
	                    icon: isLoading ? "lock" : "cheveron-down",
	                    size: isLoading ? "16px" : "18px"
	                })
	            )
	        ),
	        isOpened && _react2.default.createElement(
	            "div",
	            { ref: dropdown, className: _stylesModule2.default.Dropdown },
	            safeValues.length > 10 && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MultipleSelectSearch },
	                _react2.default.createElement("input", {
	                    type: "text",
	                    value: searchText,
	                    onChange: function onChange(e) {
	                        setSearchText(e.target.value);
	                    },
	                    placeholder: "\u041F\u043E\u0438\u0441\u043A..."
	                }),
	                _react2.default.createElement(_Icon2.default, {
	                    className: _stylesModule2.default.MultipleSelectSearchIcon,
	                    color: "#999",
	                    icon: "search",
	                    size: "16px"
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MultipleSelectList },
	                filteredData.length === 0 ? _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.MultipleSelectEmpty },
	                    "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
	                ) : filteredData.map(function (el) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: el.uuid, className: _stylesModule2.default.MultipleSelectOption },
	                        _react2.default.createElement("input", {
	                            type: "checkbox",
	                            id: "option_" + el.uuid,
	                            checked: isChecked(el.uuid),
	                            onChange: function onChange(e) {
	                                handleChange(el.uuid, e.target.checked);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            {
	                                htmlFor: "option_" + el.uuid,
	                                className: _stylesModule2.default.MultipleSelectLabel
	                            },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.MultipleSelectSquare },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: "checkmark",
	                                    className: _stylesModule2.default.IconCheckmark,
	                                    color: "#FFF",
	                                    size: "13px"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                el.displayName
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var Select = function Select(_ref7) {
	    var label = _ref7.label,
	        placeholder = _ref7.placeholder,
	        isLoading = _ref7.isLoading,
	        selectedValue = _ref7.selectedValue,
	        values = _ref7.values,
	        onChange = _ref7.onChange,
	        onCleanCurrentValue = _ref7.onCleanCurrentValue,
	        isClean = _ref7.isClean,
	        isCleanLabel = _ref7.isCleanLabel,
	        fieldName = _ref7.fieldName,
	        fieldStatus = _ref7.fieldStatus;
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        isOpened = _useState26[0],
	        setIsOpened = _useState26[1];
	
	    var _useState27 = (0, _react.useState)([]),
	        _useState28 = _slicedToArray(_useState27, 2),
	        data = _useState28[0],
	        setData = _useState28[1];
	
	    var wrap = (0, _react.useRef)(null);
	    var dropdown = (0, _react.useRef)(null);
	
	    function handleClickOutside(e) {
	        if (!dropdown.current || !wrap.current.contains(e.target)) {
	            setIsOpened(false);
	        }
	    }
	
	    function handleSelect(val) {
	        setIsOpened(false);
	        onChange(val);
	    }
	
	    (0, _react.useEffect)(function () {
	        setData(values);
	    }, [values]);
	
	    (0, _react.useEffect)(function () {
	        document.addEventListener('click', handleClickOutside, false);
	
	        return function () {
	            window.removeEventListener('click', handleClickOutside);
	        };
	    }, [handleClickOutside]);
	
	    function toggleState() {
	        setIsOpened(!isOpened);
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { ref: wrap, className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.InputHeader },
	            _react2.default.createElement(
	                "label",
	                { className: _stylesModule2.default.Label },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "no translation" })
	            ),
	            isClean && _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.InputLink, onClick: function onClick() {
	                        return onCleanCurrentValue("");
	                    } },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.LinkIcon, icon: "close", size: "12px" }),
	                isCleanLabel ? isCleanLabel : "Отменить изменения"
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.SelectWrap },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Select + " " + (isLoading && _stylesModule2.default.SelectDisabled), onClick: function onClick() {
	                        !isLoading && toggleState();
	                    } },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    selectedValue ? selectedValue[fieldName] : _react2.default.createElement(_reactIntl.FormattedMessage, { id: placeholder, defaultMessage: "no translation" })
	                ),
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.SelectArrow, icon: "" + (isLoading ? "lock" : "cheveron-down"),
	                    size: "" + (isLoading ? "16px" : "18px") })
	            )
	        ),
	        isOpened && _react2.default.createElement(
	            "div",
	            { ref: dropdown, className: _stylesModule2.default.Dropdown },
	            data.map(function (val, i) {
	                return (fieldStatus !== undefined ? val[fieldStatus] === 1 || val[fieldStatus] === true : true) && _react2.default.createElement(
	                    "div",
	                    { key: i, onClick: function onClick() {
	                            return handleSelect(val);
	                        },
	                        className: _stylesModule2.default.Option },
	                    val[fieldName]
	                );
	            })
	        )
	    );
	};
	
	var MaskedIH = function MaskedIH(_ref8) {
	    var label = _ref8.label,
	        onChange = _ref8.onChange,
	        fieldName = _ref8.fieldName,
	        value = _ref8.value,
	        placeholder = _ref8.placeholder,
	        isDisabled = _ref8.isDisabled,
	        mask = _ref8.mask,
	        blurMessage = _ref8.blurMessage;
	
	    var _useState29 = (0, _react.useState)(true),
	        _useState30 = _slicedToArray(_useState29, 2),
	        isValid = _useState30[0],
	        setIsValid = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(''),
	        _useState32 = _slicedToArray(_useState31, 2),
	        errorMessage = _useState32[0],
	        setErrorMessage = _useState32[1];
	
	    function handlerChange(name, value) {
	        onChange(name, value);
	    }
	
	    function handlerBlur(name, value) {
	        if (value.length === 0) {
	            setIsValid(false);
	            setErrorMessage(function () {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: blurMessage, defaultMessage: "no translate" });
	            });
	        } else {
	            setIsValid(true);
	            onChange(name, value);
	        }
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "no translation" })
	        ),
	        _react2.default.createElement(_reactTextMask2.default, {
	            className: _stylesModule2.default.Input,
	            value: value,
	            mask: mask,
	            placeholderChar: "\u2000",
	            placeholder: placeholder,
	            onChange: function onChange(e) {
	                return handlerChange(fieldName, e.target.value);
	            },
	            onBlur: function onBlur(e) {
	                return handlerBlur(fieldName, e.target.value);
	            },
	            disabled: isDisabled,
	            autoComplete: "off"
	        }),
	        !isValid && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Error, onClick: function onClick() {
	                    return setIsValid(true);
	                } },
	            errorMessage
	        )
	    );
	};
	
	function AddressDaData(_ref9) {
	    var label = _ref9.label,
	        fieldName = _ref9.fieldName,
	        placeholder = _ref9.placeholder,
	        value = _ref9.value,
	        isDisabled = _ref9.isDisabled,
	        readonly = _ref9.readonly,
	        onChange = _ref9.onChange,
	        changeRegexp = _ref9.changeRegexp,
	        changeMessage = _ref9.changeMessage;
	
	    var _useState33 = (0, _react.useState)(""),
	        _useState34 = _slicedToArray(_useState33, 2),
	        searchTerm = _useState34[0],
	        setSearchTerm = _useState34[1];
	
	    var _useState35 = (0, _react.useState)([]),
	        _useState36 = _slicedToArray(_useState35, 2),
	        results = _useState36[0],
	        setResults = _useState36[1];
	
	    var _useState37 = (0, _react.useState)(false),
	        _useState38 = _slicedToArray(_useState37, 2),
	        isSearching = _useState38[0],
	        setIsSearching = _useState38[1];
	
	    var _useState39 = (0, _react.useState)(false),
	        _useState40 = _slicedToArray(_useState39, 2),
	        isOpened = _useState40[0],
	        setIsOpened = _useState40[1];
	
	    var _useState41 = (0, _react.useState)(true),
	        _useState42 = _slicedToArray(_useState41, 2),
	        isValid = _useState42[0],
	        setIsValid = _useState42[1];
	
	    var _useState43 = (0, _react.useState)(''),
	        _useState44 = _slicedToArray(_useState43, 2),
	        errorMessage = _useState44[0],
	        setErrorMessage = _useState44[1];
	
	    var debouncedSearchTerm = (0, _UseDebounce2.default)(searchTerm, 600);
	
	    var wrap = (0, _react.useRef)(null);
	    var dropdown = (0, _react.useRef)(null);
	    var input = (0, _react.useRef)(null);
	
	    function handleClickOutside(e) {
	        if (!dropdown.current || !wrap.current.contains(e.target)) {
	            setIsOpened(false);
	        }
	    }
	
	    (0, _react.useEffect)(function () {
	        if (value) {
	            setSearchTerm(value);
	        }
	    }, [value]);
	
	    (0, _react.useEffect)(function () {
	
	        if (debouncedSearchTerm.length > 4) {
	            setIsSearching(true);
	
	            searchSuggestions(debouncedSearchTerm).then(function (results) {
	                setIsSearching(false);
	                input.current.focus();
	                setResults(results.suggestions);
	
	                if (results.suggestions.length) setIsOpened(true);
	            });
	        } else {
	            setResults([]);
	        }
	    }, [debouncedSearchTerm]);
	
	    (0, _react.useEffect)(function () {
	        document.addEventListener('click', handleClickOutside, false);
	
	        return function () {
	            window.removeEventListener('click', handleClickOutside);
	        };
	    }, [handleClickOutside]);
	
	    var handlerChange = function handlerChange(value) {
	        if (changeRegexp && value.match(changeRegexp)) {
	
	            setIsValid(false);
	
	            setErrorMessage(function () {
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: changeMessage, defaultMessage: "no translate" });
	            });
	        } else {
	            setIsValid(true);
	            setSearchTerm(value);
	        }
	    };
	
	    var handlerBlur = function handlerBlur() {
	
	        if (results.length === 1) {
	            onChange(fieldName, results[0]);
	        }
	    };
	
	    var handleSelect = function handleSelect(id) {
	        onChange(fieldName, results[id]);
	        setSearchTerm(results[id].value);
	    };
	
	    function searchSuggestions(query) {
	        var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
	        var token = "304d96ec0d8e1b4415ccc071d59e727e90d52282";
	
	        var options = {
	            method: "POST",
	            mode: "cors",
	            headers: {
	                "Content-Type": "application/json",
	                "Accept": "application/json",
	                "Authorization": "Token " + token
	            },
	            body: JSON.stringify({ query: query })
	        };
	
	        return fetch(url, options).then(function (r) {
	            return r.json();
	        }).then(function (r) {
	            return r;
	        }).catch(function (error) {
	            Sentry.captureException(error);
	            console.error("error", error);
	            return [];
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { ref: wrap, className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "no translation" })
	        ),
	        _react2.default.createElement("input", { placeholder: placeholder,
	            className: _stylesModule2.default.Input,
	            value: searchTerm,
	            onChange: function onChange(e) {
	                return handlerChange(e.target.value);
	            },
	            onBlur: function onBlur(e) {
	                return handlerBlur(fieldName, e.target.value);
	            },
	            disabled: isDisabled || isSearching,
	            autoComplete: "off-" + Math.random(),
	            readOnly: readonly,
	            ref: input
	        }),
	        isOpened && _react2.default.createElement(
	            "div",
	            { ref: dropdown, className: _stylesModule2.default.Dropdown },
	            results.map(function (el, i) {
	                return _react2.default.createElement(
	                    "div",
	                    { key: i, onClick: function onClick() {
	                            return handleSelect(i);
	                        },
	                        className: _stylesModule2.default.DropdownItem },
	                    el.value
	                );
	            })
	        ),
	        !isValid && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Error, onClick: function onClick() {
	                    return setIsValid(true);
	                } },
	            errorMessage
	        )
	    );
	}
	
	InputAmountCurrencyHelper.propTypes = {
	    currency: _propTypes2.default.array.isRequired
	};
	
	exports.InputHelper = InputHelper;
	exports.CardNumberInputHelper = CardNumberInputHelper;
	exports.PasswordInputHelper = PasswordInputHelper;
	exports.InputAmountCurrencyHelper = InputAmountCurrencyHelper;
	exports.MultipleField = MultipleField;
	exports.MultipleSelect = MultipleSelect;
	exports.Select = Select;
	exports.MaskedIH = MaskedIH;
	exports.AddressDaData = AddressDaData;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(648);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmptyCard = function (_PureComponent) {
	    _inherits(EmptyCard, _PureComponent);
	
	    function EmptyCard() {
	        _classCallCheck(this, EmptyCard);
	
	        return _possibleConstructorReturn(this, (EmptyCard.__proto__ || Object.getPrototypeOf(EmptyCard)).apply(this, arguments));
	    }
	
	    _createClass(EmptyCard, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Card },
	                this.props.title && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.title, defaultMessage: this.props.title }),
	                        this.props.subtitle && _react2.default.createElement(
	                            'span',
	                            null,
	                            this.props.subtitle
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Body },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return EmptyCard;
	}(_react.PureComponent);
	
	exports.default = EmptyCard;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(519);


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AccessControl = __webpack_require__(99);
	
	var _AccessControl2 = _interopRequireDefault(_AccessControl);
	
	var _stylesModule = __webpack_require__(599);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Button(_ref) {
	    var label = _ref.label,
	        color = _ref.color,
	        isLoading = _ref.isLoading,
	        isDisabled = _ref.isDisabled,
	        icon = _ref.icon,
	        _onClick = _ref.onClick,
	        hasAccess = _ref.hasAccess;
	
	
	    var styles = {
	        backgroundColor: color,
	        padding: Boolean(icon) ? ".4375rem .875rem .4375rem 1.875rem" : ".4375rem .875rem"
	    };
	
	    return _react2.default.createElement(
	        "button",
	        { onClick: function onClick() {
	                return _onClick();
	            }, className: _stylesModule2.default.Btn, style: styles, disabled: isLoading || isDisabled },
	        Boolean(icon) && (isLoading ? !isDisabled && _react2.default.createElement(_Loader2.default, { isString: true }) : _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: icon, size: '17px' })),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: label, defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442" })
	    );
	}
	
	exports.default = (0, _AccessControl2.default)(Button);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireDefault(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(23));
	var _paginator = _interopRequireDefault(__webpack_require__(667));
	var _Page = _interopRequireDefault(__webpack_require__(684));
	var _classnames = _interopRequireDefault(__webpack_require__(194));
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var Pagination = exports["default"] = /*#__PURE__*/function (_React$Component) {
	  function Pagination() {
	    _classCallCheck(this, Pagination);
	    return _callSuper(this, Pagination, arguments);
	  }
	  _inherits(Pagination, _React$Component);
	  return _createClass(Pagination, [{
	    key: "isFirstPageVisible",
	    value: function isFirstPageVisible(has_previous_page) {
	      var _this$props = this.props,
	        hideDisabled = _this$props.hideDisabled,
	        hideFirstLastPages = _this$props.hideFirstLastPages;
	      if (hideFirstLastPages || hideDisabled && !has_previous_page) return false;
	      return true;
	    }
	  }, {
	    key: "isPrevPageVisible",
	    value: function isPrevPageVisible(has_previous_page) {
	      var _this$props2 = this.props,
	        hideDisabled = _this$props2.hideDisabled,
	        hideNavigation = _this$props2.hideNavigation;
	      if (hideNavigation || hideDisabled && !has_previous_page) return false;
	      return true;
	    }
	  }, {
	    key: "isNextPageVisible",
	    value: function isNextPageVisible(has_next_page) {
	      var _this$props3 = this.props,
	        hideDisabled = _this$props3.hideDisabled,
	        hideNavigation = _this$props3.hideNavigation;
	      if (hideNavigation || hideDisabled && !has_next_page) return false;
	      return true;
	    }
	  }, {
	    key: "isLastPageVisible",
	    value: function isLastPageVisible(has_next_page) {
	      var _this$props4 = this.props,
	        hideDisabled = _this$props4.hideDisabled,
	        hideFirstLastPages = _this$props4.hideFirstLastPages;
	      if (hideFirstLastPages || hideDisabled && !has_next_page) return false;
	      return true;
	    }
	  }, {
	    key: "renderPageNumber",
	    value: function renderPageNumber(i) {
	      var _this$props5 = this.props,
	        activePage = _this$props5.activePage,
	        getPageUrl = _this$props5.getPageUrl,
	        getPageText = _this$props5.getPageText,
	        onChange = _this$props5.onChange,
	        itemClass = _this$props5.itemClass,
	        linkClass = _this$props5.linkClass,
	        activeClass = _this$props5.activeClass,
	        activeLinkClass = _this$props5.activeLinkClass,
	        inactiveClass = _this$props5.inactiveClass,
	        inactiveLinkClass = _this$props5.inactiveLinkClass,
	        pageAriaLabel = _this$props5.pageAriaLabel;
	      return /*#__PURE__*/_react["default"].createElement(_Page["default"], {
	        isActive: i === activePage,
	        key: i,
	        href: getPageUrl(i),
	        pageNumber: i,
	        pageText: getPageText(i),
	        onClick: onChange,
	        itemClass: itemClass,
	        linkClass: linkClass,
	        activeClass: activeClass,
	        activeLinkClass: activeLinkClass,
	        inactiveClass: inactiveClass,
	        inactiveLinkClass: inactiveLinkClass,
	        ariaLabel: pageAriaLabel.replace(":page", i)
	      });
	    }
	  }, {
	    key: "renderEllipsis",
	    value: function renderEllipsis(position) {
	      var _this$props6 = this.props,
	        itemClass = _this$props6.itemClass,
	        linkClass = _this$props6.linkClass,
	        inactiveClass = _this$props6.inactiveClass,
	        inactiveLinkClass = _this$props6.inactiveLinkClass,
	        disabledClass = _this$props6.disabledClass,
	        ellipsisText = _this$props6.ellipsisText;
	      return /*#__PURE__*/_react["default"].createElement("li", {
	        key: "ellipsis-" + position,
	        className: (0, _classnames["default"])(itemClass, inactiveClass, disabledClass)
	      }, /*#__PURE__*/_react["default"].createElement("span", {
	        className: (0, _classnames["default"])(linkClass, inactiveLinkClass) || undefined,
	        "aria-hidden": "true"
	      }, ellipsisText));
	    }
	  }, {
	    key: "buildPages",
	    value: function buildPages() {
	      var pages = [];
	      var _this$props7 = this.props,
	        itemsCountPerPage = _this$props7.itemsCountPerPage,
	        pageRangeDisplayed = _this$props7.pageRangeDisplayed,
	        activePage = _this$props7.activePage,
	        prevPageText = _this$props7.prevPageText,
	        nextPageText = _this$props7.nextPageText,
	        firstPageText = _this$props7.firstPageText,
	        lastPageText = _this$props7.lastPageText,
	        totalItemsCount = _this$props7.totalItemsCount,
	        onChange = _this$props7.onChange,
	        itemClass = _this$props7.itemClass,
	        itemClassFirst = _this$props7.itemClassFirst,
	        itemClassPrev = _this$props7.itemClassPrev,
	        itemClassNext = _this$props7.itemClassNext,
	        itemClassLast = _this$props7.itemClassLast,
	        disabledClass = _this$props7.disabledClass,
	        inactiveClass = _this$props7.inactiveClass,
	        inactiveLinkClass = _this$props7.inactiveLinkClass,
	        linkClass = _this$props7.linkClass,
	        linkClassFirst = _this$props7.linkClassFirst,
	        linkClassPrev = _this$props7.linkClassPrev,
	        linkClassNext = _this$props7.linkClassNext,
	        linkClassLast = _this$props7.linkClassLast,
	        getPageUrl = _this$props7.getPageUrl,
	        ellipsis = _this$props7.ellipsis,
	        firstPageAriaLabel = _this$props7.firstPageAriaLabel,
	        prevPageAriaLabel = _this$props7.prevPageAriaLabel,
	        nextPageAriaLabel = _this$props7.nextPageAriaLabel,
	        lastPageAriaLabel = _this$props7.lastPageAriaLabel;
	
	      // pageRangeDisplayed={0} shows only the navigation controls. paginator
	      // turns a length of 0 into 10, so ask it for 1 and skip the numbers.
	      var showNumbers = pageRangeDisplayed !== 0;
	      var paginationInfo = new _paginator["default"](itemsCountPerPage, showNumbers ? pageRangeDisplayed : 1).build(totalItemsCount, activePage);
	      var first_page = paginationInfo.first_page,
	        last_page = paginationInfo.last_page,
	        total_pages = paginationInfo.total_pages;
	
	      // With ellipsis, keep the first and last page visible. A gap of a single
	      // page shows that page instead of an ellipsis, since both take one slot.
	      if (showNumbers && ellipsis && first_page > 1) {
	        pages.push(this.renderPageNumber(1));
	        if (first_page === 3) pages.push(this.renderPageNumber(2));else if (first_page > 3) pages.push(this.renderEllipsis("start"));
	      }
	      for (var i = first_page; showNumbers && i <= last_page; i++) {
	        pages.push(this.renderPageNumber(i));
	      }
	      if (showNumbers && ellipsis && last_page < total_pages) {
	        if (last_page === total_pages - 2) pages.push(this.renderPageNumber(total_pages - 1));else if (last_page < total_pages - 2) pages.push(this.renderEllipsis("end"));
	        pages.push(this.renderPageNumber(total_pages));
	      }
	      this.isPrevPageVisible(paginationInfo.has_previous_page) && pages.unshift(/*#__PURE__*/_react["default"].createElement(_Page["default"], {
	        key: "prev",
	        control: "prev",
	        href: getPageUrl(paginationInfo.previous_page),
	        pageNumber: paginationInfo.previous_page,
	        onClick: onChange,
	        pageText: prevPageText,
	        isDisabled: !paginationInfo.has_previous_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassPrev),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassPrev),
	        disabledClass: disabledClass,
	        inactiveClass: inactiveClass,
	        inactiveLinkClass: inactiveLinkClass,
	        ariaLabel: prevPageAriaLabel
	      }));
	      this.isFirstPageVisible(paginationInfo.has_previous_page) && pages.unshift(/*#__PURE__*/_react["default"].createElement(_Page["default"], {
	        key: "first",
	        control: "first",
	        href: getPageUrl(1),
	        pageNumber: 1,
	        onClick: onChange,
	        pageText: firstPageText,
	        isDisabled: !paginationInfo.has_previous_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassFirst),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassFirst),
	        disabledClass: disabledClass,
	        inactiveClass: inactiveClass,
	        inactiveLinkClass: inactiveLinkClass,
	        ariaLabel: firstPageAriaLabel
	      }));
	      this.isNextPageVisible(paginationInfo.has_next_page) && pages.push(/*#__PURE__*/_react["default"].createElement(_Page["default"], {
	        key: "next",
	        control: "next",
	        href: getPageUrl(paginationInfo.next_page),
	        pageNumber: paginationInfo.next_page,
	        onClick: onChange,
	        pageText: nextPageText,
	        isDisabled: !paginationInfo.has_next_page,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassNext),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassNext),
	        disabledClass: disabledClass,
	        inactiveClass: inactiveClass,
	        inactiveLinkClass: inactiveLinkClass,
	        ariaLabel: nextPageAriaLabel
	      }));
	      this.isLastPageVisible(paginationInfo.has_next_page) && pages.push(/*#__PURE__*/_react["default"].createElement(_Page["default"], {
	        key: "last",
	        control: "last",
	        href: getPageUrl(paginationInfo.total_pages),
	        pageNumber: paginationInfo.total_pages,
	        onClick: onChange,
	        pageText: lastPageText,
	        isDisabled: paginationInfo.current_page === paginationInfo.total_pages,
	        itemClass: (0, _classnames["default"])(itemClass, itemClassLast),
	        linkClass: (0, _classnames["default"])(linkClass, linkClassLast),
	        disabledClass: disabledClass,
	        inactiveClass: inactiveClass,
	        inactiveLinkClass: inactiveLinkClass,
	        ariaLabel: lastPageAriaLabel
	      }));
	      return pages;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var pages = this.buildPages();
	      return /*#__PURE__*/_react["default"].createElement("ul", {
	        className: this.props.innerClass
	      }, pages);
	    }
	  }]);
	}(_react["default"].Component);
	_defineProperty(Pagination, "propTypes", {
	  totalItemsCount: _propTypes["default"].number.isRequired,
	  onChange: _propTypes["default"].func.isRequired,
	  activePage: _propTypes["default"].number,
	  itemsCountPerPage: _propTypes["default"].number,
	  pageRangeDisplayed: _propTypes["default"].number,
	  pageAriaLabel: _propTypes["default"].string,
	  prevPageAriaLabel: _propTypes["default"].string,
	  prevPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  nextPageAriaLabel: _propTypes["default"].string,
	  nextPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  lastPageAriaLabel: _propTypes["default"].string,
	  lastPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  firstPageAriaLabel: _propTypes["default"].string,
	  firstPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  disabledClass: _propTypes["default"].string,
	  hideDisabled: _propTypes["default"].bool,
	  hideNavigation: _propTypes["default"].bool,
	  innerClass: _propTypes["default"].string,
	  itemClass: _propTypes["default"].string,
	  itemClassFirst: _propTypes["default"].string,
	  itemClassPrev: _propTypes["default"].string,
	  itemClassNext: _propTypes["default"].string,
	  itemClassLast: _propTypes["default"].string,
	  linkClass: _propTypes["default"].string,
	  activeClass: _propTypes["default"].string,
	  activeLinkClass: _propTypes["default"].string,
	  inactiveClass: _propTypes["default"].string,
	  inactiveLinkClass: _propTypes["default"].string,
	  linkClassFirst: _propTypes["default"].string,
	  linkClassPrev: _propTypes["default"].string,
	  linkClassNext: _propTypes["default"].string,
	  linkClassLast: _propTypes["default"].string,
	  hideFirstLastPages: _propTypes["default"].bool,
	  getPageUrl: _propTypes["default"].func,
	  getPageText: _propTypes["default"].func,
	  ellipsis: _propTypes["default"].bool,
	  ellipsisText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element])
	});
	_defineProperty(Pagination, "defaultProps", {
	  itemsCountPerPage: 10,
	  pageRangeDisplayed: 5,
	  activePage: 1,
	  pageAriaLabel: "Go to page number :page",
	  prevPageAriaLabel: "Go to previous page",
	  prevPageText: "⟨",
	  firstPageAriaLabel: "Go to first page",
	  firstPageText: "«",
	  nextPageAriaLabel: "Go to next page",
	  nextPageText: "⟩",
	  lastPageAriaLabel: "Go to last page",
	  lastPageText: "»",
	  innerClass: "pagination",
	  itemClass: undefined,
	  linkClass: undefined,
	  activeLinkClass: undefined,
	  hideFirstLastPages: false,
	  getPageUrl: function getPageUrl() {
	    return "#";
	  },
	  getPageText: function getPageText(i) {
	    return i + "";
	  },
	  disabledClass: "disabled",
	  ellipsis: false,
	  ellipsisText: "…"
	});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(40);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(585);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MOBILE_BREAKPOINT = 767;
	
	var MONTH_NAMES_RU = ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];
	
	var MONTH_NAMES_EN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	var DAY_NAMES_RU = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
	var DAY_NAMES_EN = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
	
	function pad(n) {
	    return n < 10 ? "0" + n : "" + n;
	}
	
	function formatDateShort(date) {
	    if (!date) return "";
	    return pad(date.getDate()) + "." + pad(date.getMonth() + 1) + "." + date.getFullYear();
	}
	
	function formatTime(date) {
	    if (!date) return "00:00";
	    return pad(date.getHours()) + ":" + pad(date.getMinutes());
	}
	
	function isSameDay(a, b) {
	    if (!a || !b) return false;
	    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
	}
	
	function isInRange(day, start, end) {
	    if (!start || !end) return false;
	    var t = day.getTime();
	    var s = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime();
	    var e = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime();
	    return t >= s && t <= e;
	}
	
	function getDaysInMonth(year, month) {
	    return new Date(year, month + 1, 0).getDate();
	}
	
	function getFirstDayOfWeek(year, month) {
	    var d = new Date(year, month, 1).getDay();
	    return d === 0 ? 6 : d - 1;
	}
	
	function buildCalendarGrid(year, month) {
	    var daysInMonth = getDaysInMonth(year, month);
	    var firstDay = getFirstDayOfWeek(year, month);
	    var prevMonth = month === 0 ? 11 : month - 1;
	    var prevYear = month === 0 ? year - 1 : year;
	    var daysInPrev = getDaysInMonth(prevYear, prevMonth);
	
	    var cells = [];
	
	    for (var i = firstDay - 1; i >= 0; i--) {
	        cells.push({
	            day: daysInPrev - i,
	            month: prevMonth,
	            year: prevYear,
	            outside: true
	        });
	    }
	
	    for (var d = 1; d <= daysInMonth; d++) {
	        cells.push({ day: d, month: month, year: year, outside: false });
	    }
	
	    var remaining = 42 - cells.length;
	    var nextMonth = month === 11 ? 0 : month + 1;
	    var nextYear = month === 11 ? year + 1 : year;
	    for (var j = 1; j <= remaining; j++) {
	        cells.push({ day: j, month: nextMonth, year: nextYear, outside: true });
	    }
	
	    return cells;
	}
	
	function DateRange(props) {
	    var onSelectDate = props.onSelectDate;
	    var defaultPeriod = props.defaultPeriod;
	
	    var intl = (0, _reactIntl.useIntl)();
	    var isRu = intl.locale === "ru";
	    var monthNames = isRu ? MONTH_NAMES_RU : MONTH_NAMES_EN;
	    var dayNames = isRu ? DAY_NAMES_RU : DAY_NAMES_EN;
	
	    var _open = (0, _react.useState)(false);
	    var isOpen = _open[0];
	    var setIsOpen = _open[1];
	
	    var _startDate = (0, _react.useState)(null);
	    var startDate = _startDate[0];
	    var setStartDate = _startDate[1];
	
	    var _endDate = (0, _react.useState)(null);
	    var endDate = _endDate[0];
	    var setEndDate = _endDate[1];
	
	    var _hoverDate = (0, _react.useState)(null);
	    var hoverDate = _hoverDate[0];
	    var setHoverDate = _hoverDate[1];
	
	    var _selectingEnd = (0, _react.useState)(false);
	    var selectingEnd = _selectingEnd[0];
	    var setSelectingEnd = _selectingEnd[1];
	
	    var _rightMonth = (0, _react.useState)(function () {
	        var now = new Date();
	        return { year: now.getFullYear(), month: now.getMonth() };
	    });
	    var rightMonth = _rightMonth[0];
	    var setRightMonth = _rightMonth[1];
	
	    var _startTime = (0, _react.useState)("00:00");
	    var startTime = _startTime[0];
	    var setStartTime = _startTime[1];
	
	    var _endTime = (0, _react.useState)("23:59");
	    var endTime = _endTime[0];
	    var setEndTime = _endTime[1];
	
	    var wrapRef = (0, _react.useRef)(null);
	    var triggerRef = (0, _react.useRef)(null);
	    var dropdownRef = (0, _react.useRef)(null);
	    var initRef = (0, _react.useRef)(false);
	
	    var _dropdownPos = (0, _react.useState)({ top: 0, left: 0 });
	    var dropdownPos = _dropdownPos[0];
	    var setDropdownPos = _dropdownPos[1];
	
	    var _isMobile = (0, _react.useState)(function () {
	        return typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT;
	    });
	    var isMobile = _isMobile[0];
	    var setIsMobile = _isMobile[1];
	
	    (0, _react.useEffect)(function () {
	        function handleResize() {
	            setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
	        }
	        window.addEventListener("resize", handleResize);
	        return function () {
	            window.removeEventListener("resize", handleResize);
	        };
	    }, []);
	
	    function getLeftMonth() {
	        var m = rightMonth.month - 1;
	        var y = rightMonth.year;
	        if (m < 0) {
	            m = 11;y--;
	        }
	        return { year: y, month: m };
	    }
	
	    function prevMonth() {
	        setRightMonth(function (prev) {
	            var m = prev.month - 1;
	            var y = prev.year;
	            if (m < 0) {
	                m = 11;y--;
	            }
	            return { year: y, month: m };
	        });
	    }
	
	    function nextMonth() {
	        setRightMonth(function (prev) {
	            var m = prev.month + 1;
	            var y = prev.year;
	            if (m > 11) {
	                m = 0;y++;
	            }
	            return { year: y, month: m };
	        });
	    }
	
	    function sendFormatDate(start, end) {
	        if (!start || !end) {
	            onSelectDate({ startDate: null, endDate: null });
	            return;
	        }
	
	        var options = {
	            day: "numeric",
	            month: "numeric",
	            year: "numeric",
	            hour: "numeric",
	            minute: "numeric",
	            timeZoneName: "short"
	        };
	
	        var startStr = start.toLocaleDateString("ru", options);
	        var endStr = end.toLocaleDateString("ru", options);
	
	        onSelectDate({
	            startDate: startStr,
	            endDate: endStr
	        });
	    }
	
	    function applyTimeToDate(date, timeStr) {
	        if (!date) return null;
	        var parts = timeStr.split(":");
	        var h = parseInt(parts[0], 10) || 0;
	        var m = parseInt(parts[1], 10) || 0;
	        var d = new Date(date);
	        d.setHours(h, m, 0, 0);
	        return d;
	    }
	
	    function handleDayClick(cell) {
	        if (!selectingEnd) {
	            var newStart = new Date(cell.year, cell.month, cell.day);
	            newStart = applyTimeToDate(newStart, startTime);
	            setStartDate(newStart);
	            setEndDate(null);
	            setSelectingEnd(true);
	        } else {
	            var clickedDate = new Date(cell.year, cell.month, cell.day);
	            var startOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
	
	            if (clickedDate < startOnly) {
	                var newS = applyTimeToDate(clickedDate, startTime);
	                setStartDate(newS);
	                setSelectingEnd(true);
	                return;
	            }
	
	            var newEnd = applyTimeToDate(clickedDate, endTime);
	            setEndDate(newEnd);
	            setSelectingEnd(false);
	
	            var finalStart = applyTimeToDate(startDate, startTime);
	            sendFormatDate(finalStart, newEnd);
	        }
	    }
	
	    function handleDayHover(cell) {
	        if (selectingEnd) {
	            setHoverDate(new Date(cell.year, cell.month, cell.day));
	        }
	    }
	
	    function setPreset(presetFn) {
	        presetFn();
	        setSelectingEnd(false);
	        setIsOpen(false);
	    }
	
	    var setToday = (0, _react.useCallback)(function () {
	        var start = new Date();
	        start.setHours(0, 0, 0, 0);
	        var end = new Date();
	        end.setHours(23, 59, 59, 999);
	        setStartDate(start);
	        setEndDate(end);
	        setStartTime("00:00");
	        setEndTime("23:59");
	        sendFormatDate(start, end);
	    }, []);
	
	    var setYesterday = (0, _react.useCallback)(function () {
	        var yesterday = new Date();
	        yesterday.setDate(yesterday.getDate() - 1);
	        var start = new Date(yesterday);
	        start.setHours(0, 0, 0, 0);
	        var end = new Date(yesterday);
	        end.setHours(23, 59, 59, 999);
	        setStartDate(start);
	        setEndDate(end);
	        setStartTime("00:00");
	        setEndTime("23:59");
	        sendFormatDate(start, end);
	    }, []);
	
	    var setWeek = (0, _react.useCallback)(function () {
	        var start = new Date();
	        start.setDate(start.getDate() - 7);
	        start.setHours(0, 0, 0, 0);
	        var end = new Date();
	        end.setHours(23, 59, 59, 999);
	        setStartDate(start);
	        setEndDate(end);
	        setStartTime("00:00");
	        setEndTime("23:59");
	        sendFormatDate(start, end);
	    }, []);
	
	    var setMonth = (0, _react.useCallback)(function () {
	        var start = new Date();
	        start.setDate(start.getDate() - 30);
	        start.setHours(0, 0, 0, 0);
	        var end = new Date();
	        end.setHours(23, 59, 59, 999);
	        setStartDate(start);
	        setEndDate(end);
	        setStartTime("00:00");
	        setEndTime("23:59");
	        sendFormatDate(start, end);
	    }, []);
	
	    var setHalfYear = (0, _react.useCallback)(function () {
	        var start = new Date();
	        start.setDate(start.getDate() - 180);
	        start.setHours(0, 0, 0, 0);
	        var end = new Date();
	        end.setHours(23, 59, 59, 999);
	        setStartDate(start);
	        setEndDate(end);
	        setStartTime("00:00");
	        setEndTime("23:59");
	        sendFormatDate(start, end);
	    }, []);
	
	    var setZero = (0, _react.useCallback)(function () {
	        setStartDate(null);
	        setEndDate(null);
	        setStartTime("00:00");
	        setEndTime("23:59");
	        sendFormatDate(null, null);
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        if (initRef.current) return;
	        initRef.current = true;
	
	        if (defaultPeriod === null) return;
	        if (!defaultPeriod) {
	            setWeek();return;
	        }
	
	        switch (defaultPeriod) {
	            case "today":
	                setToday();break;
	            case "yesterday":
	                setYesterday();break;
	            case "week":
	                setWeek();break;
	            case "month":
	                setMonth();break;
	            case "halfYear":
	                setHalfYear();break;
	            case "zero":
	                setZero();break;
	            default:
	                setWeek();
	        }
	    }, [defaultPeriod]);
	
	    (0, _react.useEffect)(function () {
	        function handleClickOutside(e) {
	            var inWrap = wrapRef.current && wrapRef.current.contains(e.target);
	            var inDropdown = dropdownRef.current && dropdownRef.current.contains(e.target);
	            if (!inWrap && !inDropdown) {
	                setIsOpen(false);
	                setSelectingEnd(false);
	            }
	        }
	        document.addEventListener("mousedown", handleClickOutside);
	        return function () {
	            document.removeEventListener("mousedown", handleClickOutside);
	        };
	    }, []);
	
	    function handleStartTimeChange(e) {
	        var val = e.target.value;
	        setStartTime(val);
	        if (startDate && endDate) {
	            var newStart = applyTimeToDate(startDate, val);
	            setStartDate(newStart);
	            sendFormatDate(newStart, endDate);
	        }
	    }
	
	    function handleEndTimeChange(e) {
	        var val = e.target.value;
	        setEndTime(val);
	        if (startDate && endDate) {
	            var newEnd = applyTimeToDate(endDate, val);
	            setEndDate(newEnd);
	            sendFormatDate(startDate, newEnd);
	        }
	    }
	
	    function renderMonth(yearMonth, showLeftArrow, showRightArrow) {
	        var year = yearMonth.year;
	        var month = yearMonth.month;
	        var grid = buildCalendarGrid(year, month);
	        var weeks = [];
	        for (var w = 0; w < 6; w++) {
	            weeks.push(grid.slice(w * 7, (w + 1) * 7));
	        }
	
	        var rangeEnd = selectingEnd && hoverDate ? hoverDate : endDate;
	
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MonthPanel },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MonthHeader },
	                showLeftArrow ? _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.NavBtn, onClick: prevMonth },
	                    "\u2190"
	                ) : _react2.default.createElement("span", { className: _stylesModule2.default.NavBtn }),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MonthTitle },
	                    monthNames[month],
	                    " ",
	                    year
	                ),
	                showRightArrow ? _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.NavBtn, onClick: nextMonth },
	                    "\u2192"
	                ) : _react2.default.createElement("span", { className: _stylesModule2.default.NavBtn })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.DayNames },
	                dayNames.map(function (name, i) {
	                    return _react2.default.createElement(
	                        "span",
	                        { key: i, className: i >= 5 ? _stylesModule2.default.Weekend : "" },
	                        name
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.DaysGrid },
	                weeks.map(function (week, wi) {
	                    return week.map(function (cell, di) {
	                        var cellDate = new Date(cell.year, cell.month, cell.day);
	                        var isStart = startDate && isSameDay(cellDate, startDate);
	                        var isEnd = rangeEnd && isSameDay(cellDate, rangeEnd);
	                        var inRange = isInRange(cellDate, startDate, rangeEnd) && !isStart && !isEnd;
	
	                        var cellClasses = _stylesModule2.default.Day;
	                        if (cell.outside) cellClasses += " " + _stylesModule2.default.Outside;
	                        if (isStart || isEnd) cellClasses += " " + _stylesModule2.default.Selected;
	                        if (inRange) cellClasses += " " + _stylesModule2.default.InRange;
	                        if (isStart && rangeEnd) cellClasses += " " + _stylesModule2.default.RangeStart;
	                        if (isEnd && startDate) cellClasses += " " + _stylesModule2.default.RangeEnd;
	
	                        return _react2.default.createElement(
	                            "span",
	                            {
	                                key: wi + "-" + di,
	                                className: cellClasses,
	                                onClick: function onClick() {
	                                    handleDayClick(cell);
	                                },
	                                onMouseEnter: function onMouseEnter() {
	                                    handleDayHover(cell);
	                                }
	                            },
	                            cell.day
	                        );
	                    });
	                })
	            )
	        );
	    }
	
	    var displayText = "";
	    if (startDate && endDate) {
	        displayText = formatDateShort(startDate) + ", " + formatTime(startDate) + "  —  " + formatDateShort(endDate) + ", " + formatTime(endDate);
	    }
	
	    var left = getLeftMonth();
	
	    function closePanel() {
	        setIsOpen(false);
	        setSelectingEnd(false);
	    }
	
	    var panelBody = _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Sidebar },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.SidebarTitle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.quickSelect", defaultMessage: "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0432\u044B\u0431\u043E\u0440" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: _stylesModule2.default.PresetBtn, onClick: function onClick() {
	                        setPreset(setToday);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.today", defaultMessage: "\u0441\u0435\u0433\u043E\u0434\u043D\u044F" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: _stylesModule2.default.PresetBtn, onClick: function onClick() {
	                        setPreset(setYesterday);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.yesterday", defaultMessage: "\u0432\u0447\u0435\u0440\u0430" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: _stylesModule2.default.PresetBtn, onClick: function onClick() {
	                        setPreset(setWeek);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.days7", defaultMessage: "7 \u0434\u043D\u0435\u0439" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: _stylesModule2.default.PresetBtn, onClick: function onClick() {
	                        setPreset(setMonth);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.days30", defaultMessage: "30 \u0434\u043D\u0435\u0439" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: _stylesModule2.default.PresetBtn, onClick: function onClick() {
	                        setPreset(setHalfYear);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.halfYear", defaultMessage: "\u043F\u043E\u043B\u0433\u043E\u0434\u0430" })
	            ),
	            _react2.default.createElement("div", { className: _stylesModule2.default.SidebarDivider }),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.TimeSection },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.TimeLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.from", defaultMessage: "\u0421:" })
	                ),
	                _react2.default.createElement("input", {
	                    type: "time",
	                    className: _stylesModule2.default.TimeInput,
	                    value: startTime,
	                    onChange: handleStartTimeChange
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.TimeSection },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.TimeLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.to", defaultMessage: "\u041F\u043E:" })
	                ),
	                _react2.default.createElement("input", {
	                    type: "time",
	                    className: _stylesModule2.default.TimeInput,
	                    value: endTime,
	                    onChange: handleEndTimeChange
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Calendars },
	            isMobile ? renderMonth(rightMonth, true, true) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                renderMonth(left, true, false),
	                renderMonth(rightMonth, false, true)
	            )
	        )
	    );
	
	    var panel = isMobile ? _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("div", { className: _stylesModule2.default.SheetBackdrop, onClick: closePanel }),
	        _react2.default.createElement(
	            "div",
	            { ref: dropdownRef, className: _stylesModule2.default.Dropdown + " " + _stylesModule2.default.Sheet },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.SheetHeader },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.SheetTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.title", defaultMessage: "\u041F\u0435\u0440\u0438\u043E\u0434" })
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { type: "button", className: _stylesModule2.default.SheetClose, onClick: closePanel },
	                    _react2.default.createElement(_Icon2.default, { icon: "close", size: "16px" })
	                )
	            ),
	            panelBody
	        )
	    ) : _react2.default.createElement(
	        "div",
	        {
	            ref: dropdownRef,
	            className: _stylesModule2.default.Dropdown,
	            style: { top: dropdownPos.top, left: dropdownPos.left }
	        },
	        panelBody
	    );
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap, ref: wrapRef },
	        _react2.default.createElement(
	            "div",
	            {
	                ref: triggerRef,
	                className: _stylesModule2.default.Trigger + (isOpen ? " " + _stylesModule2.default.TriggerActive : ""),
	                onClick: function onClick() {
	                    if (!isOpen && !isMobile && triggerRef.current) {
	                        var rect = triggerRef.current.getBoundingClientRect();
	                        var panelWidth = 532;
	                        var pos = rect.left;
	                        if (pos + panelWidth > window.innerWidth) {
	                            pos = window.innerWidth - panelWidth - 8;
	                        }
	                        if (pos < 8) pos = 8;
	                        setDropdownPos({ top: rect.bottom + 4, left: pos });
	                    }
	                    setIsOpen(!isOpen);
	                }
	            },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.TriggerLabel },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.title", defaultMessage: "\u041F\u0435\u0440\u0438\u043E\u0434" }),
	                ":"
	            ),
	            displayText ? _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.TriggerValue },
	                displayText
	            ) : _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.TriggerPlaceholder },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DateRange.placeholder", defaultMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0435\u0440\u0438\u043E\u0434" })
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.TriggerArrow },
	                isOpen ? "▲" : "▼"
	            )
	        ),
	        isOpen && _reactDom2.default.createPortal(panel, document.body)
	    );
	}
	
	exports.default = DateRange;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(592);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Modal(_ref) {
	    var children = _ref.children,
	        isOpen = _ref.isOpen,
	        onClose = _ref.onClose,
	        onConfirm = _ref.onConfirm,
	        title = _ref.title,
	        isConfirm = _ref.isConfirm,
	        _values = _ref.values;
	
	    if (!isOpen) return null;
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.ModalWrap },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Size500 },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Header },
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.Close, onClick: onClose },
	                        _react2.default.createElement(_Icon2.default, { icon: 'close', size: '15px' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Body },
	                    title && _react2.default.createElement(
	                        'h3',
	                        { className: _stylesModule2.default.Title },
	                        title
	                    ),
	                    children
	                ),
	                isConfirm && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Footer },
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.ConfirmBtn, onClick: onConfirm },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Modal.confirm', defaultMessage: '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C' })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.CancelBtn, onClick: onClose },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Modal.cancel', defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0430' })
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = Modal;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var minimal_1 = __webpack_require__(281);
	exports.addBreadcrumb = minimal_1.addBreadcrumb;
	exports.captureException = minimal_1.captureException;
	exports.captureEvent = minimal_1.captureEvent;
	exports.captureMessage = minimal_1.captureMessage;
	exports.configureScope = minimal_1.configureScope;
	exports.startTransaction = minimal_1.startTransaction;
	exports.setContext = minimal_1.setContext;
	exports.setExtra = minimal_1.setExtra;
	exports.setExtras = minimal_1.setExtras;
	exports.setTag = minimal_1.setTag;
	exports.setTags = minimal_1.setTags;
	exports.setUser = minimal_1.setUser;
	exports.withScope = minimal_1.withScope;
	var hub_1 = __webpack_require__(26);
	exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.Scope = hub_1.Scope;
	var api_1 = __webpack_require__(271);
	exports.API = api_1.API;
	var baseclient_1 = __webpack_require__(273);
	exports.BaseClient = baseclient_1.BaseClient;
	var basebackend_1 = __webpack_require__(272);
	exports.BaseBackend = basebackend_1.BaseBackend;
	var request_1 = __webpack_require__(278);
	exports.eventToSentryRequest = request_1.eventToSentryRequest;
	exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
	var sdk_1 = __webpack_require__(279);
	exports.initAndBind = sdk_1.initAndBind;
	var noop_1 = __webpack_require__(150);
	exports.NoopTransport = noop_1.NoopTransport;
	var Integrations = __webpack_require__(277);
	exports.Integrations = Integrations;
	//# sourceMappingURL=index.js.map

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(165);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Function equal to merge with the difference being that no reference
	 * to original objects is kept.
	 *
	 * @see merge
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function deepMerge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = deepMerge(result[key], val);
	    } else if (typeof val === 'object') {
	      result[key] = deepMerge({}, val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  deepMerge: deepMerge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 22 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function Amount(_ref) {
	    var amount = _ref.amount,
	        currency = _ref.currency;
	
	
	    var sign = void 0;
	
	    switch (currency) {
	        case "RUB":
	            sign = "₽";
	            break;
	        case "EUR":
	            sign = "€";
	            break;
	        case "USD":
	        case "CAD":
	            sign = "$";
	            break;
	        case "INR":
	            sign = "₹";
	            break;
	        case "JPY":
	        case "CNY":
	            sign = "¥";
	            break;
	        case "CNF":
	            sign = "₣";
	            break;
	        case "TRY":
	            sign = "₺";
	            break;
	        case "UAH":
	            sign = "₴";
	            break;
	        default:
	            sign = String(currency);
	    }
	
	    return Number(amount).toLocaleString() + sign;
	}
	
	exports.default = Amount;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(673)();
	}


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = FormatDate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormatDate(_ref) {
	    var setDate = _ref.setDate,
	        format = _ref.format,
	        _ref$isEmpty = _ref.isEmpty,
	        isEmpty = _ref$isEmpty === undefined ? false : _ref$isEmpty;
	
	
	    var date = void 0;
	
	    if (!format) format = { day: 'numeric', month: 'numeric', year: 'numeric' };
	
	    if (isEmpty && !setDate) {
	        date = _react2.default.createElement(
	            'span',
	            null,
	            '\u2014'
	        );
	    } else if (setDate) {
	        date = new Date(setDate).toLocaleString('ru', format);
	    } else {
	        date = new Date().toLocaleString('ru', format);
	    }
	
	    return date;
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MissingTranslationError = exports.MessageFormatError = exports.IntlFormatError = exports.MissingDataError = exports.InvalidConfigError = exports.UnsupportedFormatterError = exports.IntlError = exports.IntlErrorCode = void 0;
	var tslib_1 = __webpack_require__(35);
	var IntlErrorCode;
	(function (IntlErrorCode) {
	    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
	    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
	    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
	    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
	    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
	})(IntlErrorCode = exports.IntlErrorCode || (exports.IntlErrorCode = {}));
	var IntlError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(IntlError, _super);
	    function IntlError(code, message, exception) {
	        var _this = this;
	        var err = exception
	            ? exception instanceof Error
	                ? exception
	                : new Error(String(exception))
	            : undefined;
	        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
	        _this.code = code;
	        // @ts-ignore just so we don't need to declare dep on @types/node
	        if (typeof Error.captureStackTrace === 'function') {
	            // @ts-ignore just so we don't need to declare dep on @types/node
	            Error.captureStackTrace(_this, IntlError);
	        }
	        return _this;
	    }
	    return IntlError;
	}(Error));
	exports.IntlError = IntlError;
	var UnsupportedFormatterError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(UnsupportedFormatterError, _super);
	    function UnsupportedFormatterError(message, exception) {
	        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
	    }
	    return UnsupportedFormatterError;
	}(IntlError));
	exports.UnsupportedFormatterError = UnsupportedFormatterError;
	var InvalidConfigError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(InvalidConfigError, _super);
	    function InvalidConfigError(message, exception) {
	        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
	    }
	    return InvalidConfigError;
	}(IntlError));
	exports.InvalidConfigError = InvalidConfigError;
	var MissingDataError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(MissingDataError, _super);
	    function MissingDataError(message, exception) {
	        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
	    }
	    return MissingDataError;
	}(IntlError));
	exports.MissingDataError = MissingDataError;
	var IntlFormatError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(IntlFormatError, _super);
	    function IntlFormatError(message, locale, exception) {
	        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
	    }
	    return IntlFormatError;
	}(IntlError));
	exports.IntlFormatError = IntlFormatError;
	var MessageFormatError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(MessageFormatError, _super);
	    function MessageFormatError(message, locale, descriptor, exception) {
	        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
	        _this.descriptor = descriptor;
	        return _this;
	    }
	    return MessageFormatError;
	}(IntlFormatError));
	exports.MessageFormatError = MessageFormatError;
	var MissingTranslationError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(MissingTranslationError, _super);
	    function MissingTranslationError(descriptor, locale) {
	        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
	        _this.descriptor = descriptor;
	        return _this;
	    }
	    return MissingTranslationError;
	}(IntlError));
	exports.MissingTranslationError = MissingTranslationError;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var scope_1 = __webpack_require__(151);
	exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
	exports.Scope = scope_1.Scope;
	var session_1 = __webpack_require__(152);
	exports.Session = session_1.Session;
	var hub_1 = __webpack_require__(280);
	exports.getActiveDomain = hub_1.getActiveDomain;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.getMainCarrier = hub_1.getMainCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.setHubOnCarrier = hub_1.setHubOnCarrier;
	//# sourceMappingURL=index.js.map

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var loglevel_1 = __webpack_require__(299);
	exports.LogLevel = loglevel_1.LogLevel;
	var session_1 = __webpack_require__(300);
	exports.SessionStatus = session_1.SessionStatus;
	var severity_1 = __webpack_require__(301);
	exports.Severity = severity_1.Severity;
	var status_1 = __webpack_require__(302);
	exports.Status = status_1.Status;
	var transaction_1 = __webpack_require__(303);
	exports.TransactionSamplingMethod = transaction_1.TransactionSamplingMethod;
	//# sourceMappingURL=index.js.map

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Context = _react2.default.createContext(null);
	
	exports.default = Context;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/******************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, Symbol, Reflect, Promise, SuppressedError, Iterator */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __esDecorate;
	var __runInitializers;
	var __propKey;
	var __setFunctionName;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __classPrivateFieldIn;
	var __createBinding;
	var __addDisposableResource;
	var __disposeResources;
	var __rewriteRelativeImportExtension;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __esDecorate = function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
	        function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
	        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
	        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
	        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
	        var _, done = false;
	        for (var i = decorators.length - 1; i >= 0; i--) {
	            var context = {};
	            for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
	            for (var p in contextIn.access) context.access[p] = contextIn.access[p];
	            context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
	            var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
	            if (kind === "accessor") {
	                if (result === void 0) continue;
	                if (result === null || typeof result !== "object") throw new TypeError("Object expected");
	                if (_ = accept(result.get)) descriptor.get = _;
	                if (_ = accept(result.set)) descriptor.set = _;
	                if (_ = accept(result.init)) initializers.unshift(_);
	            }
	            else if (_ = accept(result)) {
	                if (kind === "field") initializers.unshift(_);
	                else descriptor[key] = _;
	            }
	        }
	        if (target) Object.defineProperty(target, contextIn.name, descriptor);
	        done = true;
	    };
	
	    __runInitializers = function (thisArg, initializers, value) {
	        var useValue = arguments.length > 2;
	        for (var i = 0; i < initializers.length; i++) {
	            value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
	        }
	        return useValue ? value : void 0;
	    };
	
	    __propKey = function (x) {
	        return typeof x === "symbol" ? x : "".concat(x);
	    };
	
	    __setFunctionName = function (f, name, prefix) {
	        if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
	        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
	        return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (g && (g = 0, op[0] && (_ = 0)), _) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        var desc = Object.getOwnPropertyDescriptor(m, k);
	        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	            desc = { enumerable: true, get: function() { return m[k]; } };
	        }
	        Object.defineProperty(o, k2, desc);
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
	        function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    var ownKeys = function(o) {
	        ownKeys = Object.getOwnPropertyNames || function (o) {
	            var ar = [];
	            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
	            return ar;
	        };
	        return ownKeys(o);
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, state, kind, f) {
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
	        if (kind === "m") throw new TypeError("Private method is not writable");
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	    };
	
	    __classPrivateFieldIn = function (state, receiver) {
	        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	        return typeof state === "function" ? receiver === state : state.has(receiver);
	    };
	
	    __addDisposableResource = function (env, value, async) {
	        if (value !== null && value !== void 0) {
	            if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
	            var dispose, inner;
	            if (async) {
	                if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
	                dispose = value[Symbol.asyncDispose];
	            }
	            if (dispose === void 0) {
	                if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
	                dispose = value[Symbol.dispose];
	                if (async) inner = dispose;
	            }
	            if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
	            if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
	            env.stack.push({ value: value, dispose: dispose, async: async });
	        }
	        else if (async) {
	            env.stack.push({ async: true });
	        }
	        return value;
	    };
	
	    var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };
	
	    __disposeResources = function (env) {
	        function fail(e) {
	            env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
	            env.hasError = true;
	        }
	        var r, s = 0;
	        function next() {
	            while (r = env.stack.pop()) {
	                try {
	                    if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
	                    if (r.dispose) {
	                        var result = r.dispose.call(r.value);
	                        if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
	                    }
	                    else s |= 1;
	                }
	                catch (e) {
	                    fail(e);
	                }
	            }
	            if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
	            if (env.hasError) throw env.error;
	        }
	        return next();
	    };
	
	    __rewriteRelativeImportExtension = function (path, preserveJsx) {
	        if (typeof path === "string" && /^\.\.?\//.test(path)) {
	            return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
	                return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
	            });
	        }
	        return path;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__esDecorate", __esDecorate);
	    exporter("__runInitializers", __runInitializers);
	    exporter("__propKey", __propKey);
	    exporter("__setFunctionName", __setFunctionName);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
	    exporter("__addDisposableResource", __addDisposableResource);
	    exporter("__disposeResources", __disposeResources);
	    exporter("__rewriteRelativeImportExtension", __rewriteRelativeImportExtension);
	});
	
	0 && (module.exports = {
	    __extends: __extends,
	    __assign: __assign,
	    __rest: __rest,
	    __decorate: __decorate,
	    __param: __param,
	    __esDecorate: __esDecorate,
	    __runInitializers: __runInitializers,
	    __propKey: __propKey,
	    __setFunctionName: __setFunctionName,
	    __metadata: __metadata,
	    __awaiter: __awaiter,
	    __generator: __generator,
	    __exportStar: __exportStar,
	    __createBinding: __createBinding,
	    __values: __values,
	    __read: __read,
	    __spread: __spread,
	    __spreadArrays: __spreadArrays,
	    __spreadArray: __spreadArray,
	    __await: __await,
	    __asyncGenerator: __asyncGenerator,
	    __asyncDelegator: __asyncDelegator,
	    __asyncValues: __asyncValues,
	    __makeTemplateObject: __makeTemplateObject,
	    __importStar: __importStar,
	    __importDefault: __importDefault,
	    __classPrivateFieldGet: __classPrivateFieldGet,
	    __classPrivateFieldSet: __classPrivateFieldSet,
	    __classPrivateFieldIn: __classPrivateFieldIn,
	    __addDisposableResource: __addDisposableResource,
	    __disposeResources: __disposeResources,
	    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension,
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(40);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(594);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useNarrowViewport() {
	    var _useState = (0, _react.useState)(0),
	        _useState2 = _slicedToArray(_useState, 2),
	        viewportWidth = _useState2[0],
	        setViewportWidth = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        function update() {
	            if (typeof window === 'undefined') return;
	            setViewportWidth(window.innerWidth);
	        }
	
	        update();
	        window.addEventListener('resize', update);
	
	        return function () {
	            return window.removeEventListener('resize', update);
	        };
	    }, []);
	
	    return viewportWidth;
	}
	
	function ResponsiveSidebarFilters(_ref) {
	    var children = _ref.children,
	        isOpen = _ref.isOpen,
	        onClose = _ref.onClose,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? 'Фильтры' : _ref$title,
	        onApplyFilters = _ref.onApplyFilters,
	        _ref$applyLabel = _ref.applyLabel,
	        applyLabel = _ref$applyLabel === undefined ? 'Фильтровать' : _ref$applyLabel,
	        _ref$isApplyDisabled = _ref.isApplyDisabled,
	        isApplyDisabled = _ref$isApplyDisabled === undefined ? false : _ref$isApplyDisabled;
	
	    var viewportWidth = useNarrowViewport();
	    var isNarrow = viewportWidth > 0 ? viewportWidth <= 1024 : false;
	    var isFullscreen = viewportWidth > 0 ? viewportWidth <= 768 : false;
	    var contentRef = (0, _react.useRef)(null);
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        hasApplyTarget = _useState4[0],
	        setHasApplyTarget = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        applyTargetDisabled = _useState6[0],
	        setApplyTargetDisabled = _useState6[1];
	
	    function findApplyTarget() {
	        if (!contentRef.current) return null;
	
	        return Array.prototype.find.call(contentRef.current.querySelectorAll('button'), function (button) {
	            var text = (button.textContent || '').trim().toLowerCase();
	            return text.indexOf('фильтровать') !== -1 || text === 'filter';
	        });
	    }
	
	    (0, _react.useEffect)(function () {
	        if (!isNarrow || !isOpen) {
	            setHasApplyTarget(false);
	            setApplyTargetDisabled(false);
	            return undefined;
	        }
	
	        var timeout = setTimeout(function () {
	            var target = findApplyTarget();
	            setHasApplyTarget(Boolean(onApplyFilters || target));
	            setApplyTargetDisabled(Boolean(target && target.disabled));
	        }, 0);
	
	        return function () {
	            return clearTimeout(timeout);
	        };
	    }, [children, isNarrow, isOpen, onApplyFilters]);
	
	    function handleApplyClick() {
	        if (typeof onApplyFilters === 'function') {
	            onApplyFilters();
	            return;
	        }
	
	        var target = findApplyTarget();
	        if (target && !target.disabled) {
	            target.click();
	        }
	    }
	
	    (0, _react.useEffect)(function () {
	        if (!isNarrow || !isOpen) return undefined;
	
	        var previousOverflow = document.body.style.overflow;
	        document.body.style.overflow = 'hidden';
	
	        function handleKeyDown(event) {
	            if (event.key === 'Escape' && typeof onClose === 'function') {
	                onClose();
	            }
	        }
	
	        window.addEventListener('keydown', handleKeyDown);
	
	        return function () {
	            document.body.style.overflow = previousOverflow;
	            window.removeEventListener('keydown', handleKeyDown);
	        };
	    }, [isNarrow, isOpen, onClose]);
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Wrapper },
	        !isNarrow && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.DesktopSidebar },
	            children
	        ),
	        isNarrow && typeof document !== 'undefined' ? _reactDom2.default.createPortal(_react2.default.createElement(
	            'div',
	            {
	                className: _stylesModule2.default.Overlay + ' ' + (isOpen ? _stylesModule2.default.OverlayOpen : _stylesModule2.default.OverlayClosed),
	                onClick: onClose
	            },
	            _react2.default.createElement(
	                'div',
	                {
	                    className: _stylesModule2.default.Panel + ' ' + (isFullscreen ? _stylesModule2.default.Fullscreen : _stylesModule2.default.Drawer),
	                    onClick: function onClick(event) {
	                        return event.stopPropagation();
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Header },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: _stylesModule2.default.Title },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.CloseButton, onClick: onClose, type: 'button' },
	                        _react2.default.createElement(_Icon2.default, { icon: 'close', size: '18px' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        ref: contentRef,
	                        className: _stylesModule2.default.Content + ' ' + (hasApplyTarget ? _stylesModule2.default.ContentWithFooter : '')
	                    },
	                    children
	                ),
	                hasApplyTarget && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Footer },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: _stylesModule2.default.ApplyButton,
	                            onClick: handleApplyClick,
	                            disabled: isApplyDisabled || applyTargetDisabled
	                        },
	                        applyLabel
	                    )
	                )
	            )
	        ), document.body) : null
	    );
	}
	
	exports.default = ResponsiveSidebarFilters;

/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.msFromTime = exports.OrdinaryHasInstance = exports.SecFromTime = exports.MinFromTime = exports.HourFromTime = exports.DateFromTime = exports.MonthFromTime = exports.InLeapYear = exports.DayWithinYear = exports.DaysInYear = exports.YearFromTime = exports.TimeFromYear = exports.DayFromYear = exports.WeekDay = exports.Day = exports.Type = exports.HasOwnProperty = exports.ArrayCreate = exports.SameValue = exports.ToObject = exports.TimeClip = exports.ToNumber = exports.ToString = void 0;
	/**
	 * https://tc39.es/ecma262/#sec-tostring
	 */
	function ToString(o) {
	    // Only symbol is irregular...
	    if (typeof o === 'symbol') {
	        throw TypeError('Cannot convert a Symbol value to a string');
	    }
	    return String(o);
	}
	exports.ToString = ToString;
	/**
	 * https://tc39.es/ecma262/#sec-tonumber
	 * @param val
	 */
	function ToNumber(val) {
	    if (val === undefined) {
	        return NaN;
	    }
	    if (val === null) {
	        return +0;
	    }
	    if (typeof val === 'boolean') {
	        return val ? 1 : +0;
	    }
	    if (typeof val === 'number') {
	        return val;
	    }
	    if (typeof val === 'symbol' || typeof val === 'bigint') {
	        throw new TypeError('Cannot convert symbol/bigint to number');
	    }
	    return Number(val);
	}
	exports.ToNumber = ToNumber;
	/**
	 * https://tc39.es/ecma262/#sec-tointeger
	 * @param n
	 */
	function ToInteger(n) {
	    var number = ToNumber(n);
	    if (isNaN(number) || SameValue(number, -0)) {
	        return 0;
	    }
	    if (isFinite(number)) {
	        return number;
	    }
	    var integer = Math.floor(Math.abs(number));
	    if (number < 0) {
	        integer = -integer;
	    }
	    if (SameValue(integer, -0)) {
	        return 0;
	    }
	    return integer;
	}
	/**
	 * https://tc39.es/ecma262/#sec-timeclip
	 * @param time
	 */
	function TimeClip(time) {
	    if (!isFinite(time)) {
	        return NaN;
	    }
	    if (Math.abs(time) > 8.64 * 1e15) {
	        return NaN;
	    }
	    return ToInteger(time);
	}
	exports.TimeClip = TimeClip;
	/**
	 * https://tc39.es/ecma262/#sec-toobject
	 * @param arg
	 */
	function ToObject(arg) {
	    if (arg == null) {
	        throw new TypeError('undefined/null cannot be converted to object');
	    }
	    return Object(arg);
	}
	exports.ToObject = ToObject;
	/**
	 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-samevalue
	 * @param x
	 * @param y
	 */
	function SameValue(x, y) {
	    if (Object.is) {
	        return Object.is(x, y);
	    }
	    // SameValue algorithm
	    if (x === y) {
	        // Steps 1-5, 7-10
	        // Steps 6.b-6.e: +0 != -0
	        return x !== 0 || 1 / x === 1 / y;
	    }
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	}
	exports.SameValue = SameValue;
	/**
	 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
	 * @param len
	 */
	function ArrayCreate(len) {
	    return new Array(len);
	}
	exports.ArrayCreate = ArrayCreate;
	/**
	 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-hasownproperty
	 * @param o
	 * @param prop
	 */
	function HasOwnProperty(o, prop) {
	    return Object.prototype.hasOwnProperty.call(o, prop);
	}
	exports.HasOwnProperty = HasOwnProperty;
	/**
	 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-type
	 * @param x
	 */
	function Type(x) {
	    if (x === null) {
	        return 'Null';
	    }
	    if (typeof x === 'undefined') {
	        return 'Undefined';
	    }
	    if (typeof x === 'function' || typeof x === 'object') {
	        return 'Object';
	    }
	    if (typeof x === 'number') {
	        return 'Number';
	    }
	    if (typeof x === 'boolean') {
	        return 'Boolean';
	    }
	    if (typeof x === 'string') {
	        return 'String';
	    }
	    if (typeof x === 'symbol') {
	        return 'Symbol';
	    }
	    if (typeof x === 'bigint') {
	        return 'BigInt';
	    }
	}
	exports.Type = Type;
	var MS_PER_DAY = 86400000;
	/**
	 * https://www.ecma-international.org/ecma-262/11.0/index.html#eqn-modulo
	 * @param x
	 * @param y
	 * @return k of the same sign as y
	 */
	function mod(x, y) {
	    return x - Math.floor(x / y) * y;
	}
	/**
	 * https://tc39.es/ecma262/#eqn-Day
	 * @param t
	 */
	function Day(t) {
	    return Math.floor(t / MS_PER_DAY);
	}
	exports.Day = Day;
	/**
	 * https://tc39.es/ecma262/#sec-week-day
	 * @param t
	 */
	function WeekDay(t) {
	    return mod(Day(t) + 4, 7);
	}
	exports.WeekDay = WeekDay;
	/**
	 * https://tc39.es/ecma262/#sec-year-number
	 * @param y
	 */
	function DayFromYear(y) {
	    return Date.UTC(y, 0) / MS_PER_DAY;
	}
	exports.DayFromYear = DayFromYear;
	/**
	 * https://tc39.es/ecma262/#sec-year-number
	 * @param y
	 */
	function TimeFromYear(y) {
	    return Date.UTC(y, 0);
	}
	exports.TimeFromYear = TimeFromYear;
	/**
	 * https://tc39.es/ecma262/#sec-year-number
	 * @param t
	 */
	function YearFromTime(t) {
	    return new Date(t).getUTCFullYear();
	}
	exports.YearFromTime = YearFromTime;
	function DaysInYear(y) {
	    if (y % 4 !== 0) {
	        return 365;
	    }
	    if (y % 100 !== 0) {
	        return 366;
	    }
	    if (y % 400 !== 0) {
	        return 365;
	    }
	    return 366;
	}
	exports.DaysInYear = DaysInYear;
	function DayWithinYear(t) {
	    return Day(t) - DayFromYear(YearFromTime(t));
	}
	exports.DayWithinYear = DayWithinYear;
	function InLeapYear(t) {
	    return DaysInYear(YearFromTime(t)) === 365 ? 0 : 1;
	}
	exports.InLeapYear = InLeapYear;
	/**
	 * https://tc39.es/ecma262/#sec-month-number
	 * @param t
	 */
	function MonthFromTime(t) {
	    var dwy = DayWithinYear(t);
	    var leap = InLeapYear(t);
	    if (dwy >= 0 && dwy < 31) {
	        return 0;
	    }
	    if (dwy < 59 + leap) {
	        return 1;
	    }
	    if (dwy < 90 + leap) {
	        return 2;
	    }
	    if (dwy < 120 + leap) {
	        return 3;
	    }
	    if (dwy < 151 + leap) {
	        return 4;
	    }
	    if (dwy < 181 + leap) {
	        return 5;
	    }
	    if (dwy < 212 + leap) {
	        return 6;
	    }
	    if (dwy < 243 + leap) {
	        return 7;
	    }
	    if (dwy < 273 + leap) {
	        return 8;
	    }
	    if (dwy < 304 + leap) {
	        return 9;
	    }
	    if (dwy < 334 + leap) {
	        return 10;
	    }
	    if (dwy < 365 + leap) {
	        return 11;
	    }
	    throw new Error('Invalid time');
	}
	exports.MonthFromTime = MonthFromTime;
	function DateFromTime(t) {
	    var dwy = DayWithinYear(t);
	    var mft = MonthFromTime(t);
	    var leap = InLeapYear(t);
	    if (mft === 0) {
	        return dwy + 1;
	    }
	    if (mft === 1) {
	        return dwy - 30;
	    }
	    if (mft === 2) {
	        return dwy - 58 - leap;
	    }
	    if (mft === 3) {
	        return dwy - 89 - leap;
	    }
	    if (mft === 4) {
	        return dwy - 119 - leap;
	    }
	    if (mft === 5) {
	        return dwy - 150 - leap;
	    }
	    if (mft === 6) {
	        return dwy - 180 - leap;
	    }
	    if (mft === 7) {
	        return dwy - 211 - leap;
	    }
	    if (mft === 8) {
	        return dwy - 242 - leap;
	    }
	    if (mft === 9) {
	        return dwy - 272 - leap;
	    }
	    if (mft === 10) {
	        return dwy - 303 - leap;
	    }
	    if (mft === 11) {
	        return dwy - 333 - leap;
	    }
	    throw new Error('Invalid time');
	}
	exports.DateFromTime = DateFromTime;
	var HOURS_PER_DAY = 24;
	var MINUTES_PER_HOUR = 60;
	var SECONDS_PER_MINUTE = 60;
	var MS_PER_SECOND = 1e3;
	var MS_PER_MINUTE = MS_PER_SECOND * SECONDS_PER_MINUTE;
	var MS_PER_HOUR = MS_PER_MINUTE * MINUTES_PER_HOUR;
	function HourFromTime(t) {
	    return mod(Math.floor(t / MS_PER_HOUR), HOURS_PER_DAY);
	}
	exports.HourFromTime = HourFromTime;
	function MinFromTime(t) {
	    return mod(Math.floor(t / MS_PER_MINUTE), MINUTES_PER_HOUR);
	}
	exports.MinFromTime = MinFromTime;
	function SecFromTime(t) {
	    return mod(Math.floor(t / MS_PER_SECOND), SECONDS_PER_MINUTE);
	}
	exports.SecFromTime = SecFromTime;
	function IsCallable(fn) {
	    return typeof fn === 'function';
	}
	/**
	 * The abstract operation OrdinaryHasInstance implements
	 * the default algorithm for determining if an object O
	 * inherits from the instance object inheritance path
	 * provided by constructor C.
	 * @param C class
	 * @param O object
	 * @param internalSlots internalSlots
	 */
	function OrdinaryHasInstance(C, O, internalSlots) {
	    if (!IsCallable(C)) {
	        return false;
	    }
	    if (internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction) {
	        var BC = internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction;
	        return O instanceof BC;
	    }
	    if (typeof O !== 'object') {
	        return false;
	    }
	    var P = C.prototype;
	    if (typeof P !== 'object') {
	        throw new TypeError('OrdinaryHasInstance called on an object with an invalid prototype property.');
	    }
	    return Object.prototype.isPrototypeOf.call(P, O);
	}
	exports.OrdinaryHasInstance = OrdinaryHasInstance;
	function msFromTime(t) {
	    return mod(t, MS_PER_SECOND);
	}
	exports.msFromTime = msFromTime;


/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.invariant = exports.UNICODE_EXTENSION_SEQUENCE_REGEX = exports.defineProperty = exports.isLiteralPart = exports.getMultiInternalSlots = exports.getInternalSlot = exports.setMultiInternalSlots = exports.setInternalSlot = exports.repeat = exports.getMagnitude = void 0;
	/**
	 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
	 * @param x number
	 */
	function getMagnitude(x) {
	    // Cannot count string length via Number.toString because it may use scientific notation
	    // for very small or very large numbers.
	    return Math.floor(Math.log(x) * Math.LOG10E);
	}
	exports.getMagnitude = getMagnitude;
	function repeat(s, times) {
	    if (typeof s.repeat === 'function') {
	        return s.repeat(times);
	    }
	    var arr = new Array(times);
	    for (var i = 0; i < arr.length; i++) {
	        arr[i] = s;
	    }
	    return arr.join('');
	}
	exports.repeat = repeat;
	function setInternalSlot(map, pl, field, value) {
	    if (!map.get(pl)) {
	        map.set(pl, Object.create(null));
	    }
	    var slots = map.get(pl);
	    slots[field] = value;
	}
	exports.setInternalSlot = setInternalSlot;
	function setMultiInternalSlots(map, pl, props) {
	    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	        var k = _a[_i];
	        setInternalSlot(map, pl, k, props[k]);
	    }
	}
	exports.setMultiInternalSlots = setMultiInternalSlots;
	function getInternalSlot(map, pl, field) {
	    return getMultiInternalSlots(map, pl, field)[field];
	}
	exports.getInternalSlot = getInternalSlot;
	function getMultiInternalSlots(map, pl) {
	    var fields = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        fields[_i - 2] = arguments[_i];
	    }
	    var slots = map.get(pl);
	    if (!slots) {
	        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
	    }
	    return fields.reduce(function (all, f) {
	        all[f] = slots[f];
	        return all;
	    }, Object.create(null));
	}
	exports.getMultiInternalSlots = getMultiInternalSlots;
	function isLiteralPart(patternPart) {
	    return patternPart.type === 'literal';
	}
	exports.isLiteralPart = isLiteralPart;
	/*
	  17 ECMAScript Standard Built-in Objects:
	    Every built-in Function object, including constructors, that is not
	    identified as an anonymous function has a name property whose value
	    is a String.
	
	    Unless otherwise specified, the name property of a built-in Function
	    object, if it exists, has the attributes { [[Writable]]: false,
	    [[Enumerable]]: false, [[Configurable]]: true }.
	*/
	function defineProperty(target, name, _a) {
	    var value = _a.value;
	    Object.defineProperty(target, name, {
	        configurable: true,
	        enumerable: false,
	        writable: true,
	        value: value,
	    });
	}
	exports.defineProperty = defineProperty;
	exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
	function invariant(condition, message, Err) {
	    if (Err === void 0) { Err = Error; }
	    if (!condition) {
	        throw new Err(message);
	    }
	}
	exports.invariant = invariant;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getNamedFormat = exports.createFormatters = exports.createIntlCache = exports.DEFAULT_INTL_CONFIG = exports.filterProps = void 0;
	var tslib_1 = __webpack_require__(35);
	var intl_messageformat_1 = __webpack_require__(39);
	var fast_memoize_1 = (0, tslib_1.__importStar)(__webpack_require__(133));
	var error_1 = __webpack_require__(25);
	function filterProps(props, allowlist, defaults) {
	    if (defaults === void 0) { defaults = {}; }
	    return allowlist.reduce(function (filtered, name) {
	        if (name in props) {
	            filtered[name] = props[name];
	        }
	        else if (name in defaults) {
	            filtered[name] = defaults[name];
	        }
	        return filtered;
	    }, {});
	}
	exports.filterProps = filterProps;
	var defaultErrorHandler = function (error) {
	    // @ts-ignore just so we don't need to declare dep on @types/node
	    if (false) {
	        console.error(error);
	    }
	};
	var defaultWarnHandler = function (warning) {
	    // @ts-ignore just so we don't need to declare dep on @types/node
	    if (false) {
	        console.warn(warning);
	    }
	};
	exports.DEFAULT_INTL_CONFIG = {
	    formats: {},
	    messages: {},
	    timeZone: undefined,
	    defaultLocale: 'en',
	    defaultFormats: {},
	    fallbackOnEmptyString: true,
	    onError: defaultErrorHandler,
	    onWarn: defaultWarnHandler,
	};
	function createIntlCache() {
	    return {
	        dateTime: {},
	        number: {},
	        message: {},
	        relativeTime: {},
	        pluralRules: {},
	        list: {},
	        displayNames: {},
	    };
	}
	exports.createIntlCache = createIntlCache;
	function createFastMemoizeCache(store) {
	    return {
	        create: function () {
	            return {
	                get: function (key) {
	                    return store[key];
	                },
	                set: function (key, value) {
	                    store[key] = value;
	                },
	            };
	        },
	    };
	}
	/**
	 * Create intl formatters and populate cache
	 * @param cache explicit cache to prevent leaking memory
	 */
	function createFormatters(cache) {
	    if (cache === void 0) { cache = createIntlCache(); }
	    var RelativeTimeFormat = Intl.RelativeTimeFormat;
	    var ListFormat = Intl.ListFormat;
	    var DisplayNames = Intl.DisplayNames;
	    var getDateTimeFormat = (0, fast_memoize_1.default)(function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	    }, {
	        cache: createFastMemoizeCache(cache.dateTime),
	        strategy: fast_memoize_1.strategies.variadic,
	    });
	    var getNumberFormat = (0, fast_memoize_1.default)(function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	    }, {
	        cache: createFastMemoizeCache(cache.number),
	        strategy: fast_memoize_1.strategies.variadic,
	    });
	    var getPluralRules = (0, fast_memoize_1.default)(function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	    }, {
	        cache: createFastMemoizeCache(cache.pluralRules),
	        strategy: fast_memoize_1.strategies.variadic,
	    });
	    return {
	        getDateTimeFormat: getDateTimeFormat,
	        getNumberFormat: getNumberFormat,
	        getMessageFormat: (0, fast_memoize_1.default)(function (message, locales, overrideFormats, opts) {
	            return new intl_messageformat_1.IntlMessageFormat(message, locales, overrideFormats, (0, tslib_1.__assign)({ formatters: {
	                    getNumberFormat: getNumberFormat,
	                    getDateTimeFormat: getDateTimeFormat,
	                    getPluralRules: getPluralRules,
	                } }, (opts || {})));
	        }, {
	            cache: createFastMemoizeCache(cache.message),
	            strategy: fast_memoize_1.strategies.variadic,
	        }),
	        getRelativeTimeFormat: (0, fast_memoize_1.default)(function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	        }, {
	            cache: createFastMemoizeCache(cache.relativeTime),
	            strategy: fast_memoize_1.strategies.variadic,
	        }),
	        getPluralRules: getPluralRules,
	        getListFormat: (0, fast_memoize_1.default)(function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return new (ListFormat.bind.apply(ListFormat, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	        }, {
	            cache: createFastMemoizeCache(cache.list),
	            strategy: fast_memoize_1.strategies.variadic,
	        }),
	        getDisplayNames: (0, fast_memoize_1.default)(function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return new (DisplayNames.bind.apply(DisplayNames, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	        }, {
	            cache: createFastMemoizeCache(cache.displayNames),
	            strategy: fast_memoize_1.strategies.variadic,
	        }),
	    };
	}
	exports.createFormatters = createFormatters;
	function getNamedFormat(formats, type, name, onError) {
	    var formatType = formats && formats[type];
	    var format;
	    if (formatType) {
	        format = formatType[name];
	    }
	    if (format) {
	        return format;
	    }
	    onError(new error_1.UnsupportedFormatterError("No ".concat(type, " format named: ").concat(name)));
	}
	exports.getNamedFormat = getNamedFormat;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var Script = _interopDefault(__webpack_require__(685));
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __awaiter(thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}
	
	function __generator(thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	}
	
	var chartDefaultProps = {
	    graph_id: null,
	    legend_toggle: false,
	    graphID: null,
	    options: {
	        colors: null
	    },
	    data: null,
	    rows: null,
	    columns: null,
	    diffdata: null,
	    chartEvents: null,
	    legendToggle: false,
	    chartActions: null,
	    getChartWrapper: function (chartWrapper, google) { },
	    getChartEditor: null,
	    className: "",
	    style: {},
	    formatters: null,
	    spreadSheetUrl: null,
	    spreadSheetQueryParameters: {
	        headers: 1,
	        gid: 1
	    },
	    rootProps: {},
	    chartWrapperParams: {},
	    controls: null,
	    render: null,
	    toolbarItems: null,
	    toolbarID: null
	};
	
	var GoogleChartLoader = (function (_super) {
	    __extends(GoogleChartLoader, _super);
	    function GoogleChartLoader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleGoogleChartsLoaderScriptLoaded = function (windowGoogleCharts) {
	            var _a = _this.props, version = _a.chartVersion, packages = _a.chartPackages, language = _a.chartLanguage, mapsApiKey = _a.mapsApiKey, onLoad = _a.onLoad;
	            windowGoogleCharts.charts.load(version || "current", {
	                packages: packages || ["corechart", "controls"],
	                language: language || "en",
	                mapsApiKey: mapsApiKey
	            });
	            windowGoogleCharts.charts.setOnLoadCallback(function () {
	                onLoad(windowGoogleCharts);
	            });
	        };
	        return _this;
	    }
	    GoogleChartLoader.prototype.shouldComponentUpdate = function (nextProps) {
	        return nextProps.chartPackages === this.props.chartPackages;
	    };
	    GoogleChartLoader.prototype.render = function () {
	        var _this = this;
	        var onError = this.props.onError;
	        return (React.createElement(Script, { url: "https://www.gstatic.com/charts/loader.js", onError: onError, onLoad: function () {
	                var windowWithGoogle = window;
	                if (windowWithGoogle.google) {
	                    _this.handleGoogleChartsLoaderScriptLoaded(windowWithGoogle.google);
	                }
	            } }));
	    };
	    return GoogleChartLoader;
	}(React.Component));
	
	var uniqueID = 0;
	var generateUniqueID = function () {
	    uniqueID += 1;
	    return "reactgooglegraph-" + uniqueID;
	};
	
	var DEFAULT_CHART_COLORS = [
	    "#3366CC",
	    "#DC3912",
	    "#FF9900",
	    "#109618",
	    "#990099",
	    "#3B3EAC",
	    "#0099C6",
	    "#DD4477",
	    "#66AA00",
	    "#B82E2E",
	    "#316395",
	    "#994499",
	    "#22AA99",
	    "#AAAA11",
	    "#6633CC",
	    "#E67300",
	    "#8B0707",
	    "#329262",
	    "#5574A6",
	    "#3B3EAC"
	];
	
	var _this = undefined;
	var loadDataTableFromSpreadSheet = function (googleViz, spreadSheetUrl, urlParams) {
	    if (urlParams === void 0) { urlParams = {}; }
	    return __awaiter(_this, void 0, void 0, function () {
	        return __generator(this, function (_a) {
	            return [2, new Promise(function (resolve, reject) {
	                    var headers = "" + (urlParams.headers ? "headers=" + urlParams.headers : "headers=0");
	                    var queryString = "" + (urlParams.query ? "&tq=" + encodeURIComponent(urlParams.query) : "");
	                    var gid = "" + (urlParams.gid ? "&gid=" + urlParams.gid : "");
	                    var sheet = "" + (urlParams.sheet ? "&sheet=" + urlParams.sheet : "");
	                    var access_token = "" + (urlParams.access_token ? "&access_token=" + urlParams.access_token : "");
	                    var urlQueryString = "" + headers + gid + sheet + queryString + access_token;
	                    var urlToSpreadSheet = spreadSheetUrl + "/gviz/tq?" + urlQueryString;
	                    var query = new googleViz.visualization.Query(urlToSpreadSheet);
	                    query.send(function (response) {
	                        if (response.isError()) {
	                            reject("Error in query:  " + response.getMessage() + " " + response.getDetailedMessage());
	                        }
	                        else {
	                            resolve(response.getDataTable());
	                        }
	                    });
	                })];
	        });
	    });
	};
	
	var _a = React.createContext(chartDefaultProps), Provider = _a.Provider, Consumer = _a.Consumer;
	var ContextProvider = function (_a) {
	    var children = _a.children, value = _a.value;
	    return React.createElement(Provider, { value: value }, children);
	};
	var ContextConsumer = function (_a) {
	    var render = _a.render;
	    return (React.createElement(Consumer, null, function (context) {
	        return render(context);
	    }));
	};
	
	var GRAY_COLOR = "#CCCCCC";
	var GoogleChartDataTableInner = (function (_super) {
	    __extends(GoogleChartDataTableInner, _super);
	    function GoogleChartDataTableInner() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            hiddenColumns: []
	        };
	        _this.listenToLegendToggle = function () {
	            var _a = _this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
	            google.visualization.events.addListener(googleChartWrapper, "select", function () {
	                var chart = googleChartWrapper.getChart();
	                var selection = chart.getSelection();
	                var dataTable = googleChartWrapper.getDataTable();
	                if (selection.length === 0 ||
	                    selection[0].row !== null ||
	                    dataTable === null) {
	                    return;
	                }
	                var columnIndex = selection[0].column;
	                var columnID = _this.getColumnID(dataTable, columnIndex);
	                if (_this.state.hiddenColumns.includes(columnID)) {
	                    _this.setState(function (state) { return (__assign({}, state, { hiddenColumns: state.hiddenColumns.filter(function (colID) { return colID !== columnID; }).slice() })); });
	                }
	                else {
	                    _this.setState(function (state) { return (__assign({}, state, { hiddenColumns: state.hiddenColumns.concat([columnID]) })); });
	                }
	            });
	        };
	        _this.applyFormatters = function (dataTable, formatters) {
	            var google = _this.props.google;
	            for (var _i = 0, formatters_1 = formatters; _i < formatters_1.length; _i++) {
	                var formatter = formatters_1[_i];
	                switch (formatter.type) {
	                    case "ArrowFormat": {
	                        var vizFormatter = new google.visualization.ArrowFormat(formatter.options);
	                        vizFormatter.format(dataTable, formatter.column);
	                        break;
	                    }
	                    case "BarFormat": {
	                        var vizFormatter = new google.visualization.BarFormat(formatter.options);
	                        vizFormatter.format(dataTable, formatter.column);
	                        break;
	                    }
	                    case "ColorFormat": {
	                        var vizFormatter = new google.visualization.ColorFormat(formatter.options);
	                        var ranges = formatter.ranges;
	                        for (var _a = 0, ranges_1 = ranges; _a < ranges_1.length; _a++) {
	                            var range = ranges_1[_a];
	                            vizFormatter.addRange.apply(vizFormatter, range);
	                        }
	                        vizFormatter.format(dataTable, formatter.column);
	                        break;
	                    }
	                    case "DateFormat": {
	                        var vizFormatter = new google.visualization.DateFormat(formatter.options);
	                        vizFormatter.format(dataTable, formatter.column);
	                        break;
	                    }
	                    case "NumberFormat": {
	                        var vizFormatter = new google.visualization.NumberFormat(formatter.options);
	                        vizFormatter.format(dataTable, formatter.column);
	                        break;
	                    }
	                    case "PatternFormat": {
	                        var vizFormatter = new google.visualization.PatternFormat(formatter.options);
	                        vizFormatter.format(dataTable, formatter.column);
	                        break;
	                    }
	                }
	            }
	        };
	        _this.getColumnID = function (dataTable, columnIndex) {
	            return (dataTable.getColumnId(columnIndex) ||
	                dataTable.getColumnLabel(columnIndex));
	        };
	        _this.draw = function (_a) {
	            var data = _a.data, diffdata = _a.diffdata, rows = _a.rows, columns = _a.columns, options = _a.options, legend_toggle = _a.legend_toggle, legendToggle = _a.legendToggle, chartType = _a.chartType, formatters = _a.formatters, spreadSheetUrl = _a.spreadSheetUrl, spreadSheetQueryParameters = _a.spreadSheetQueryParameters;
	            return __awaiter(_this, void 0, void 0, function () {
	                var _b, google, googleChartWrapper, dataTable, chartDiff, oldData, newData, columnCount, i, columnID, previousColumnLabel, previousColumnID, previousColumnType, chart;
	                return __generator(this, function (_c) {
	                    switch (_c.label) {
	                        case 0:
	                            _b = this.props, google = _b.google, googleChartWrapper = _b.googleChartWrapper;
	                            chartDiff = null;
	                            if (diffdata !== null) {
	                                oldData = google.visualization.arrayToDataTable(diffdata.old);
	                                newData = google.visualization.arrayToDataTable(diffdata.new);
	                                chartDiff = google.visualization[chartType].prototype.computeDiff(oldData, newData);
	                            }
	                            if (!(data !== null)) return [3, 1];
	                            if (Array.isArray(data)) {
	                                dataTable = google.visualization.arrayToDataTable(data);
	                            }
	                            else {
	                                dataTable = new google.visualization.DataTable(data);
	                            }
	                            return [3, 5];
	                        case 1:
	                            if (!(rows !== null && columns !== null)) return [3, 2];
	                            dataTable = google.visualization.arrayToDataTable([columns].concat(rows));
	                            return [3, 5];
	                        case 2:
	                            if (!(spreadSheetUrl !== null)) return [3, 4];
	                            return [4, loadDataTableFromSpreadSheet(google, spreadSheetUrl, spreadSheetQueryParameters)];
	                        case 3:
	                            dataTable = (_c.sent());
	                            return [3, 5];
	                        case 4:
	                            dataTable = google.visualization.arrayToDataTable([]);
	                            _c.label = 5;
	                        case 5:
	                            columnCount = dataTable.getNumberOfColumns();
	                            for (i = 0; i < columnCount; i += 1) {
	                                columnID = this.getColumnID(dataTable, i);
	                                if (this.state.hiddenColumns.includes(columnID)) {
	                                    previousColumnLabel = dataTable.getColumnLabel(i);
	                                    previousColumnID = dataTable.getColumnId(i);
	                                    previousColumnType = dataTable.getColumnType(i);
	                                    dataTable.removeColumn(i);
	                                    dataTable.addColumn({
	                                        label: previousColumnLabel,
	                                        id: previousColumnID,
	                                        type: previousColumnType
	                                    });
	                                }
	                            }
	                            chart = googleChartWrapper.getChart();
	                            if (googleChartWrapper.getChartType() === "Timeline") {
	                                chart && chart.clearChart();
	                            }
	                            googleChartWrapper.setChartType(chartType);
	                            googleChartWrapper.setOptions(options);
	                            googleChartWrapper.setDataTable(dataTable);
	                            googleChartWrapper.draw();
	                            if (this.props.googleChartDashboard !== null) {
	                                this.props.googleChartDashboard.draw(dataTable);
	                            }
	                            if (chartDiff !== null) {
	                                googleChartWrapper.setDataTable(chartDiff);
	                                googleChartWrapper.draw();
	                            }
	                            if (formatters !== null) {
	                                this.applyFormatters(dataTable, formatters);
	                                googleChartWrapper.setDataTable(dataTable);
	                                googleChartWrapper.draw();
	                            }
	                            if (legendToggle === true || legend_toggle === true) {
	                                this.grayOutHiddenColumns({ options: options });
	                            }
	                            return [2];
	                    }
	                });
	            });
	        };
	        _this.grayOutHiddenColumns = function (_a) {
	            var options = _a.options;
	            var googleChartWrapper = _this.props.googleChartWrapper;
	            var dataTable = googleChartWrapper.getDataTable();
	            if (dataTable === null)
	                return;
	            var columnCount = dataTable.getNumberOfColumns();
	            var hasAHiddenColumn = _this.state.hiddenColumns.length > 0;
	            if (hasAHiddenColumn === false)
	                return;
	            var colors = Array.from({ length: columnCount - 1 }).map(function (dontcare, i) {
	                var columnID = _this.getColumnID(dataTable, i + 1);
	                if (_this.state.hiddenColumns.includes(columnID)) {
	                    return GRAY_COLOR;
	                }
	                else if (typeof options.colors !== "undefined" &&
	                    options.colors !== null) {
	                    return options.colors[i];
	                }
	                else {
	                    return DEFAULT_CHART_COLORS[i];
	                }
	            });
	            googleChartWrapper.setOptions(__assign({}, options, { colors: colors }));
	            googleChartWrapper.draw();
	        };
	        _this.onResize = function () {
	            var googleChartWrapper = _this.props.googleChartWrapper;
	            googleChartWrapper.draw();
	        };
	        return _this;
	    }
	    GoogleChartDataTableInner.prototype.componentDidMount = function () {
	        this.draw(this.props);
	        window.addEventListener("resize", this.onResize);
	        if (this.props.legend_toggle || this.props.legendToggle) {
	            this.listenToLegendToggle();
	        }
	    };
	    GoogleChartDataTableInner.prototype.componentWillUnmount = function () {
	        var _a = this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
	        window.removeEventListener("resize", this.onResize);
	        google.visualization.events.removeAllListeners(googleChartWrapper);
	        if (googleChartWrapper.getChartType() === "Timeline") {
	            googleChartWrapper.getChart() &&
	                googleChartWrapper.getChart().clearChart();
	        }
	    };
	    GoogleChartDataTableInner.prototype.componentDidUpdate = function () {
	        this.draw(this.props);
	    };
	    GoogleChartDataTableInner.prototype.render = function () {
	        return null;
	    };
	    return GoogleChartDataTableInner;
	}(React.Component));
	var GoogleChartDataTable = (function (_super) {
	    __extends(GoogleChartDataTable, _super);
	    function GoogleChartDataTable() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GoogleChartDataTable.prototype.componentDidMount = function () { };
	    GoogleChartDataTable.prototype.componentWillUnmount = function () { };
	    GoogleChartDataTable.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    GoogleChartDataTable.prototype.render = function () {
	        var _a = this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper, googleChartDashboard = _a.googleChartDashboard;
	        return (React.createElement(ContextConsumer, { render: function (props) {
	                return (React.createElement(GoogleChartDataTableInner, __assign({}, props, { google: google, googleChartWrapper: googleChartWrapper, googleChartDashboard: googleChartDashboard })));
	            } }));
	    };
	    return GoogleChartDataTable;
	}(React.Component));
	
	var GoogleChartEvents = (function (_super) {
	    __extends(GoogleChartEvents, _super);
	    function GoogleChartEvents() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    GoogleChartEvents.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    GoogleChartEvents.prototype.listenToEvents = function (_a) {
	        var _this = this;
	        var chartEvents = _a.chartEvents, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
	        if (chartEvents === null) {
	            return;
	        }
	        google.visualization.events.removeAllListeners(googleChartWrapper);
	        var _loop_1 = function (event_1) {
	            var eventName = event_1.eventName, callback = event_1.callback;
	            google.visualization.events.addListener(googleChartWrapper, eventName, function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                callback({
	                    chartWrapper: googleChartWrapper,
	                    props: _this.props,
	                    google: google,
	                    eventArgs: args
	                });
	            });
	        };
	        for (var _i = 0, chartEvents_1 = chartEvents; _i < chartEvents_1.length; _i++) {
	            var event_1 = chartEvents_1[_i];
	            _loop_1(event_1);
	        }
	    };
	    GoogleChartEvents.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
	        return (React.createElement(ContextConsumer, { render: function (propsFromContext) {
	                _this.listenToEvents({
	                    chartEvents: propsFromContext.chartEvents || null,
	                    google: google,
	                    googleChartWrapper: googleChartWrapper
	                });
	                return null;
	            } }));
	    };
	    return GoogleChartEvents;
	}(React.Component));
	
	var controlCounter = 0;
	var GoogleChart = (function (_super) {
	    __extends(GoogleChart, _super);
	    function GoogleChart() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            googleChartWrapper: null,
	            googleChartDashboard: null,
	            googleChartControls: null,
	            googleChartEditor: null,
	            isReady: false
	        };
	        _this.graphID = null;
	        _this.dashboard_ref = React.createRef();
	        _this.toolbar_ref = React.createRef();
	        _this.getGraphID = function () {
	            var _a = _this.props, graphID = _a.graphID, graph_id = _a.graph_id;
	            var instanceGraphID;
	            if (graphID === null && graph_id === null) {
	                if (_this.graphID === null) {
	                    instanceGraphID = generateUniqueID();
	                }
	                else {
	                    instanceGraphID = _this.graphID;
	                }
	            }
	            else if (graphID !== null && graph_id === null) {
	                instanceGraphID = graphID;
	            }
	            else if (graph_id !== null && graphID === null) {
	                instanceGraphID = graph_id;
	            }
	            else {
	                instanceGraphID = graphID;
	            }
	            _this.graphID = instanceGraphID;
	            return _this.graphID;
	        };
	        _this.getControlID = function (id, index) {
	            controlCounter += 1;
	            var controlID;
	            if (typeof id === "undefined") {
	                controlID = "googlechart-control-" + index + "-" + controlCounter;
	            }
	            else {
	                controlID = id;
	            }
	            return controlID;
	        };
	        _this.addControls = function (googleChartWrapper, googleChartDashboard) {
	            var _a = _this.props, google = _a.google, controls = _a.controls;
	            var googleChartControls = controls === null
	                ? null
	                : controls.map(function (control, i) {
	                    var controlIDMaybe = control.controlID, controlType = control.controlType, controlOptions = control.options, controlWrapperParams = control.controlWrapperParams;
	                    var controlID = _this.getControlID(controlIDMaybe, i);
	                    return {
	                        controlProp: control,
	                        control: new google.visualization.ControlWrapper(__assign({ containerId: controlID, controlType: controlType, options: controlOptions }, controlWrapperParams))
	                    };
	                });
	            if (googleChartControls === null) {
	                return null;
	            }
	            googleChartDashboard.bind(googleChartControls.map(function (_a) {
	                var control = _a.control;
	                return control;
	            }), googleChartWrapper);
	            var _loop_1 = function (chartControl) {
	                var control = chartControl.control, controlProp = chartControl.controlProp;
	                var _a = controlProp.controlEvents, controlEvents = _a === void 0 ? [] : _a;
	                var _loop_2 = function (event_1) {
	                    var callback = event_1.callback, eventName = event_1.eventName;
	                    google.visualization.events.removeListener(control, eventName, callback);
	                    google.visualization.events.addListener(control, eventName, function () {
	                        var args = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            args[_i] = arguments[_i];
	                        }
	                        callback({
	                            chartWrapper: googleChartWrapper,
	                            controlWrapper: control,
	                            props: _this.props,
	                            google: google,
	                            eventArgs: args
	                        });
	                    });
	                };
	                for (var _i = 0, controlEvents_1 = controlEvents; _i < controlEvents_1.length; _i++) {
	                    var event_1 = controlEvents_1[_i];
	                    _loop_2(event_1);
	                }
	            };
	            for (var _i = 0, googleChartControls_1 = googleChartControls; _i < googleChartControls_1.length; _i++) {
	                var chartControl = googleChartControls_1[_i];
	                _loop_1(chartControl);
	            }
	            return googleChartControls;
	        };
	        _this.renderChart = function () {
	            var _a = _this.props, width = _a.width, height = _a.height, options = _a.options, style = _a.style, className = _a.className, rootProps = _a.rootProps, google = _a.google;
	            var divStyle = __assign({ height: height || (options && options.height), width: width || (options && options.width) }, style);
	            return (React.createElement("div", __assign({ id: _this.getGraphID(), style: divStyle, className: className }, rootProps), _this.state.isReady && _this.state.googleChartWrapper !== null ? (React.createElement(React.Fragment, null,
	                React.createElement(GoogleChartDataTable, { googleChartWrapper: _this.state.googleChartWrapper, google: google, googleChartDashboard: _this.state.googleChartDashboard }),
	                React.createElement(GoogleChartEvents, { googleChartWrapper: _this.state.googleChartWrapper, google: google }))) : null));
	        };
	        _this.renderControl = function (filter) {
	            if (filter === void 0) { filter = function (_a) {
	                var control = _a.control, controlProp = _a.controlProp;
	                return true;
	            }; }
	            return _this.state.isReady && _this.state.googleChartControls !== null ? (React.createElement(React.Fragment, null, _this.state.googleChartControls
	                .filter(function (_a) {
	                var controlProp = _a.controlProp, control = _a.control;
	                return filter({ control: control, controlProp: controlProp });
	            })
	                .map(function (_a) {
	                var control = _a.control, controlProp = _a.controlProp;
	                return (React.createElement("div", { key: control.getContainerId(), id: control.getContainerId() }));
	            }))) : null;
	        };
	        _this.renderToolBar = function () {
	            if (_this.props.toolbarItems === null)
	                return null;
	            return React.createElement("div", { ref: _this.toolbar_ref });
	        };
	        return _this;
	    }
	    GoogleChart.prototype.componentDidMount = function () {
	        var _a = this.props, options = _a.options, google = _a.google, chartType = _a.chartType, chartWrapperParams = _a.chartWrapperParams, toolbarItems = _a.toolbarItems, getChartEditor = _a.getChartEditor, getChartWrapper = _a.getChartWrapper;
	        var chartConfig = __assign({ chartType: chartType,
	            options: options, containerId: this.getGraphID() }, chartWrapperParams);
	        var googleChartWrapper = new google.visualization.ChartWrapper(chartConfig);
	        googleChartWrapper.setOptions(options);
	        getChartWrapper(googleChartWrapper, google);
	        var googleChartDashboard = new google.visualization.Dashboard(this.dashboard_ref);
	        var googleChartControls = this.addControls(googleChartWrapper, googleChartDashboard);
	        if (toolbarItems !== null) {
	            google.visualization.drawToolbar(this.toolbar_ref.current, toolbarItems);
	        }
	        var googleChartEditor = null;
	        if (getChartEditor !== null) {
	            googleChartEditor = new google.visualization.ChartEditor();
	            getChartEditor({
	                chartEditor: googleChartEditor,
	                chartWrapper: googleChartWrapper,
	                google: google
	            });
	        }
	        this.setState({
	            googleChartEditor: googleChartEditor,
	            googleChartControls: googleChartControls,
	            googleChartDashboard: googleChartDashboard,
	            googleChartWrapper: googleChartWrapper,
	            isReady: true
	        });
	    };
	    GoogleChart.prototype.componentDidUpdate = function () {
	        if (this.state.googleChartWrapper === null)
	            return;
	        if (this.state.googleChartDashboard === null)
	            return;
	        if (this.state.googleChartControls === null)
	            return;
	        var controls = this.props.controls;
	        for (var i = 0; i < controls.length; i += 1) {
	            var _a = controls[i], controlType = _a.controlType, options = _a.options, controlWrapperParams = _a.controlWrapperParams;
	            if (controlWrapperParams && "state" in controlWrapperParams) {
	                this.state.googleChartControls[i].control.setState(controlWrapperParams["state"]);
	            }
	            this.state.googleChartControls[i].control.setOptions(options);
	            this.state.googleChartControls[i].control.setControlType(controlType);
	        }
	    };
	    GoogleChart.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        return (this.state.isReady !== nextState.isReady ||
	            nextProps.controls !== this.props.controls);
	    };
	    GoogleChart.prototype.render = function () {
	        var _a = this.props, width = _a.width, height = _a.height, options = _a.options, style = _a.style;
	        var divStyle = __assign({ height: height || (options && options.height), width: width || (options && options.width) }, style);
	        if (this.props.render !== null) {
	            return (React.createElement("div", { ref: this.dashboard_ref, style: divStyle },
	                React.createElement("div", { ref: this.toolbar_ref, id: "toolbar" }),
	                this.props.render({
	                    renderChart: this.renderChart,
	                    renderControl: this.renderControl,
	                    renderToolbar: this.renderToolBar
	                })));
	        }
	        else {
	            return (React.createElement("div", { ref: this.dashboard_ref, style: divStyle },
	                this.renderControl(function (_a) {
	                    var controlProp = _a.controlProp;
	                    return controlProp.controlPosition !== "bottom";
	                }),
	                this.renderChart(),
	                this.renderControl(function (_a) {
	                    var controlProp = _a.controlProp;
	                    return controlProp.controlPosition === "bottom";
	                }),
	                this.renderToolBar()));
	        }
	    };
	    return GoogleChart;
	}(React.Component));
	
	var Chart = (function (_super) {
	    __extends(Chart, _super);
	    function Chart() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._isMounted = false;
	        _this.state = {
	            loadingStatus: "loading",
	            google: null
	        };
	        _this.onLoad = function (google) {
	            if (_this.isFullyLoaded(google)) {
	                _this.onSuccess(google);
	            }
	            else {
	                var id_1 = setInterval(function () {
	                    var google = window.google;
	                    if (_this._isMounted) {
	                        if (google && _this.isFullyLoaded(google)) {
	                            clearInterval(id_1);
	                            _this.onSuccess(google);
	                        }
	                    }
	                    else {
	                        clearInterval(id_1);
	                    }
	                }, 1000);
	            }
	        };
	        _this.onSuccess = function (google) {
	            _this.setState({
	                loadingStatus: "ready",
	                google: google
	            });
	        };
	        _this.onError = function () {
	            _this.setState({
	                loadingStatus: "errored"
	            });
	        };
	        return _this;
	    }
	    Chart.prototype.render = function () {
	        var _a = this.props, chartLanguage = _a.chartLanguage, chartPackages = _a.chartPackages, chartVersion = _a.chartVersion, mapsApiKey = _a.mapsApiKey, loader = _a.loader, errorElement = _a.errorElement;
	        return (React.createElement(ContextProvider, { value: this.props },
	            this.state.loadingStatus === "ready" && this.state.google !== null ? (React.createElement(GoogleChart, __assign({}, this.props, { google: this.state.google }))) : this.state.loadingStatus === "errored" && errorElement ? (errorElement) : (loader),
	            React.createElement(GoogleChartLoader, __assign({}, { chartLanguage: chartLanguage, chartPackages: chartPackages, chartVersion: chartVersion, mapsApiKey: mapsApiKey }, { onLoad: this.onLoad, onError: this.onError }))));
	    };
	    Chart.prototype.componentDidMount = function () {
	        this._isMounted = true;
	    };
	    Chart.prototype.componentWillUnmount = function () {
	        this._isMounted = false;
	    };
	    Chart.prototype.isFullyLoaded = function (google) {
	        var _a = this.props, controls = _a.controls, toolbarItems = _a.toolbarItems, getChartEditor = _a.getChartEditor;
	        return (google &&
	            google.visualization &&
	            google.visualization.ChartWrapper &&
	            google.visualization.Dashboard &&
	            (!controls || google.visualization.ChartWrapper) &&
	            (!getChartEditor || google.visualization.ChartEditor) &&
	            (!toolbarItems || google.visualization.drawToolbar));
	    };
	    Chart.defaultProps = chartDefaultProps;
	    return Chart;
	}(React.Component));
	
	exports.Chart = Chart;
	exports.default = Chart;


/***/ },
/* 35 */
29,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(26);
	exports.TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
	    '([0-9a-f]{32})?' + // trace_id
	    '-?([0-9a-f]{16})?' + // span_id
	    '-?([01])?' + // sampled
	    '[ \\t]*$');
	/**
	 * Determines if tracing is currently enabled.
	 *
	 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
	 */
	function hasTracingEnabled(options) {
	    return 'tracesSampleRate' in options || 'tracesSampler' in options;
	}
	exports.hasTracingEnabled = hasTracingEnabled;
	/**
	 * Extract transaction context data from a `sentry-trace` header.
	 *
	 * @param traceparent Traceparent string
	 *
	 * @returns Object containing data from the header, or undefined if traceparent string is malformed
	 */
	function extractTraceparentData(traceparent) {
	    var matches = traceparent.match(exports.TRACEPARENT_REGEXP);
	    if (matches) {
	        var parentSampled = void 0;
	        if (matches[3] === '1') {
	            parentSampled = true;
	        }
	        else if (matches[3] === '0') {
	            parentSampled = false;
	        }
	        return {
	            traceId: matches[1],
	            parentSampled: parentSampled,
	            parentSpanId: matches[2],
	        };
	    }
	    return undefined;
	}
	exports.extractTraceparentData = extractTraceparentData;
	/** Grabs active transaction off scope, if any */
	function getActiveTransaction(hub) {
	    if (hub === void 0) { hub = hub_1.getCurrentHub(); }
	    var _a, _b;
	    return (_b = (_a = hub) === null || _a === void 0 ? void 0 : _a.getScope()) === null || _b === void 0 ? void 0 : _b.getTransaction();
	}
	exports.getActiveTransaction = getActiveTransaction;
	/**
	 * Converts from milliseconds to seconds
	 * @param time time in ms
	 */
	function msToSec(time) {
	    return time / 1000;
	}
	exports.msToSec = msToSec;
	/**
	 * Converts from seconds to milliseconds
	 * @param time time in seconds
	 */
	function secToMs(time) {
	    return time * 1000;
	}
	exports.secToMs = secToMs;
	// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils
	var utils_1 = __webpack_require__(9);
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	//# sourceMappingURL=utils.js.map

/***/ },
/* 37 */
/***/ function(module, exports) {

	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Checks whether given value's type is one of a few Error or Error-like
	 * {@link isError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isError(wat) {
	    switch (Object.prototype.toString.call(wat)) {
	        case '[object Error]':
	            return true;
	        case '[object Exception]':
	            return true;
	        case '[object DOMException]':
	            return true;
	        default:
	            return isInstanceOf(wat, Error);
	    }
	}
	exports.isError = isError;
	/**
	 * Checks whether given value's type is ErrorEvent
	 * {@link isErrorEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isErrorEvent(wat) {
	    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
	}
	exports.isErrorEvent = isErrorEvent;
	/**
	 * Checks whether given value's type is DOMError
	 * {@link isDOMError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMError(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMError]';
	}
	exports.isDOMError = isDOMError;
	/**
	 * Checks whether given value's type is DOMException
	 * {@link isDOMException}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMException(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMException]';
	}
	exports.isDOMException = isDOMException;
	/**
	 * Checks whether given value's type is a string
	 * {@link isString}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isString(wat) {
	    return Object.prototype.toString.call(wat) === '[object String]';
	}
	exports.isString = isString;
	/**
	 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
	 * {@link isPrimitive}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPrimitive(wat) {
	    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
	}
	exports.isPrimitive = isPrimitive;
	/**
	 * Checks whether given value's type is an object literal
	 * {@link isPlainObject}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPlainObject(wat) {
	    return Object.prototype.toString.call(wat) === '[object Object]';
	}
	exports.isPlainObject = isPlainObject;
	/**
	 * Checks whether given value's type is an Event instance
	 * {@link isEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	exports.isEvent = isEvent;
	/**
	 * Checks whether given value's type is an Element instance
	 * {@link isElement}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isElement(wat) {
	    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
	}
	exports.isElement = isElement;
	/**
	 * Checks whether given value's type is an regexp
	 * {@link isRegExp}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isRegExp(wat) {
	    return Object.prototype.toString.call(wat) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	/**
	 * Checks whether given value has a then function.
	 * @param wat A value to be checked.
	 */
	function isThenable(wat) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return Boolean(wat && wat.then && typeof wat.then === 'function');
	}
	exports.isThenable = isThenable;
	/**
	 * Checks whether given value's type is a SyntheticEvent
	 * {@link isSyntheticEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isSyntheticEvent(wat) {
	    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
	}
	exports.isSyntheticEvent = isSyntheticEvent;
	/**
	 * Checks whether given value's type is an instance of provided constructor.
	 * {@link isInstanceOf}.
	 *
	 * @param wat A value to be checked.
	 * @param base A constructor to be used in a check.
	 * @returns A boolean representing the result.
	 */
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	exports.isInstanceOf = isInstanceOf;
	//# sourceMappingURL=is.js.map

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactInputMask = __webpack_require__(217);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(596);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function SearchTags(_ref) {
	    var defaultSearch = _ref.defaultSearch,
	        searchBy = _ref.searchBy,
	        onChangeSearch = _ref.onChangeSearch,
	        onSearch = _ref.onSearch,
	        isDisabled = _ref.isDisabled;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(defaultSearch || searchBy[0]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currentSelect = _useState4[0],
	        setCurrentSelect = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(''),
	        _useState6 = _slicedToArray(_useState5, 2),
	        searchString = _useState6[0],
	        setSearchString = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        tags = _useState8[0],
	        setTags = _useState8[1];
	
	    var selectRef = (0, _react.useRef)(null);
	    var listRef = (0, _react.useRef)(null);
	
	    (0, _react.useEffect)(function () {
	        var handleClickOutside = function handleClickOutside(e) {
	            if (listRef.current && selectRef.current && !selectRef.current.contains(e.target)) {
	                setIsOpened(false);
	            }
	        };
	
	        document.addEventListener('click', handleClickOutside, false);
	        return function () {
	            return document.removeEventListener('click', handleClickOutside, false);
	        };
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        onChangeSearch(tags);
	    }, [tags]);
	
	    var toggleOpened = function toggleOpened() {
	        return setIsOpened(function (prev) {
	            return !prev;
	        });
	    };
	
	    var onChangeSearchString = function onChangeSearchString(value) {
	        if (currentSelect.key === 'cardNumber') {
	            setSearchString(value.replace(/•/g, ''));
	        } else {
	            setSearchString(value);
	        }
	    };
	
	    var setCurrentSelectHandler = function setCurrentSelectHandler(val) {
	        if (currentSelect.key === 'cardNumber') {
	            setSearchString('');
	        }
	        setCurrentSelect(val);
	        setIsOpened(false);
	    };
	
	    var onDeleteTag = function onDeleteTag(index) {
	        setTags(tags.filter(function (_, i) {
	            return i !== index;
	        }));
	    };
	
	    var addTag = function addTag() {
	        if (!searchString || !searchString.trim()) return;
	
	        var newTag = {};
	
	        if (['amountEqually', 'amountMore', 'rrn', 'amountLess', 'id', 'cardNumber'].includes(currentSelect.key)) {
	            var _newTag;
	
	            newTag = (_newTag = {}, _defineProperty(_newTag, currentSelect.key, Number(searchString)), _defineProperty(_newTag, 'locale', currentSelect.locale), _newTag);
	        } else {
	            var _newTag2;
	
	            if (currentSelect.key === 'phone') {
	                var hasPhone = tags.some(function (tag) {
	                    return tag.hasOwnProperty('phone');
	                });
	                if (hasPhone) return;
	            }
	            newTag = (_newTag2 = {}, _defineProperty(_newTag2, currentSelect.key, searchString), _defineProperty(_newTag2, 'locale', currentSelect.locale), _newTag2);
	        }
	
	        setTags([].concat(_toConsumableArray(tags), [newTag]));
	        setSearchString('');
	    };
	
	    var onKeyPress = function onKeyPress(e) {
	        if (e.key === 'Enter') {
	            addTag();
	        }
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            null,
	            tags.length > 0 && tags.map(function (tag, index) {
	                var value = Object.values(tag)[0];
	                return _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Tag, key: index },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: tag.locale, defaultMessage: '\u041D\u0435 \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043E' }),
	                    ': ',
	                    value,
	                    _react2.default.createElement(_Icon2.default, {
	                        onClick: function onClick() {
	                            return onDeleteTag(index);
	                        },
	                        className: _stylesModule2.default.CloseIcon,
	                        icon: 'close',
	                        size: '9px'
	                    })
	                );
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Search + ' ' + (isDisabled ? _stylesModule2.default.Disabled : '') },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.SearchMeta },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Label },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SearchTags.label', defaultMessage: '\u041F\u043E\u0438\u0441\u043A \u043F\u043E' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: selectRef, className: _stylesModule2.default.Select },
	                    _react2.default.createElement(
	                        'div',
	                        { onClick: toggleOpened, className: _stylesModule2.default.Current },
	                        isOpened ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CurrentIcon, icon: 'cheveron-up', size: '12px' }) : _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CurrentIcon, icon: 'cheveron-down', size: '12px' }),
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: currentSelect.locale, defaultMessage: '\u041D\u0435 \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043E' }),
	                        ':'
	                    ),
	                    isOpened && _react2.default.createElement(
	                        'ul',
	                        { ref: listRef, className: _stylesModule2.default.List },
	                        searchBy.map(function (el, i) {
	                            return _react2.default.createElement(
	                                'li',
	                                {
	                                    key: i,
	                                    onClick: function onClick() {
	                                        return setCurrentSelectHandler(el);
	                                    },
	                                    style: currentSelect.key === el.key ? { fontWeight: 'bold' } : {},
	                                    className: _stylesModule2.default.Li
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: el.locale, defaultMessage: '\u041D\u0435 \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043E' })
	                            );
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.InputWrap },
	                currentSelect.key === 'cardNumber' ? _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: currentSelect.placeholder },
	                    function (placeholder) {
	                        return _react2.default.createElement(_reactInputMask2.default, {
	                            mask: '999999\u2022\u2022\u2022\u20229999',
	                            maskChar: null,
	                            className: _stylesModule2.default.Input,
	                            placeholder: placeholder,
	                            value: searchString,
	                            onChange: function onChange(e) {
	                                return onChangeSearchString(e.target.value);
	                            },
	                            onKeyPress: onKeyPress,
	                            maxLength: '14'
	                        });
	                    }
	                ) : currentSelect.key === 'phone' ? _react2.default.createElement(_reactInputMask2.default, {
	                    mask: '+7 (999) 999-99-99',
	                    maskChar: null,
	                    className: _stylesModule2.default.Input,
	                    placeholder: '+7 (___) ___-__-__',
	                    value: searchString,
	                    onChange: function onChange(e) {
	                        return onChangeSearchString(e.target.value);
	                    },
	                    onKeyPress: onKeyPress
	                }) : _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: currentSelect.placeholder },
	                    function (placeholder) {
	                        return _react2.default.createElement('input', {
	                            className: _stylesModule2.default.Input,
	                            type: 'text',
	                            value: searchString,
	                            onChange: function onChange(e) {
	                                return onChangeSearchString(e.target.value);
	                            },
	                            onKeyPress: onKeyPress,
	                            placeholder: placeholder,
	                            disabled: isDisabled
	                        });
	                    }
	                ),
	                searchString ? _react2.default.createElement(
	                    'button',
	                    { type: 'button', onClick: addTag, className: _stylesModule2.default.Btn },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SearchTags.add', defaultMessage: '\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C' })
	                ) : _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.SearchIcon, color: '#999', icon: 'search', size: '20px' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Actions },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        onClick: function onClick() {
	                            if (typeof onSearch === 'function') {
	                                onSearch(tags);
	                            }
	                        },
	                        className: _stylesModule2.default.SearchBtn,
	                        disabled: isDisabled
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SearchTags.search', defaultMessage: '\u041D\u0430\u0439\u0442\u0438' })
	                )
	            )
	        )
	    );
	}
	
	exports.default = SearchTags;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(114);
	var core_1 = __webpack_require__(213);
	(0, tslib_1.__exportStar)(__webpack_require__(215), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(213), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(214), exports);
	exports.default = core_1.IntlMessageFormat;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(675);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 41 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an Span. */
	// eslint-disable-next-line import/export
	var SpanStatus;
	(function (SpanStatus) {
	    /** The operation completed successfully. */
	    SpanStatus["Ok"] = "ok";
	    /** Deadline expired before operation could complete. */
	    SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
	    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
	    SpanStatus["Unauthenticated"] = "unauthenticated";
	    /** 403 Forbidden */
	    SpanStatus["PermissionDenied"] = "permission_denied";
	    /** 404 Not Found. Some requested entity (file or directory) was not found. */
	    SpanStatus["NotFound"] = "not_found";
	    /** 429 Too Many Requests */
	    SpanStatus["ResourceExhausted"] = "resource_exhausted";
	    /** Client specified an invalid argument. 4xx. */
	    SpanStatus["InvalidArgument"] = "invalid_argument";
	    /** 501 Not Implemented */
	    SpanStatus["Unimplemented"] = "unimplemented";
	    /** 503 Service Unavailable */
	    SpanStatus["Unavailable"] = "unavailable";
	    /** Other/generic 5xx. */
	    SpanStatus["InternalError"] = "internal_error";
	    /** Unknown. Any non-standard HTTP status code. */
	    SpanStatus["UnknownError"] = "unknown_error";
	    /** The operation was cancelled (typically by the user). */
	    SpanStatus["Cancelled"] = "cancelled";
	    /** Already exists (409) */
	    SpanStatus["AlreadyExists"] = "already_exists";
	    /** Operation was rejected because the system is not in a state required for the operation's */
	    SpanStatus["FailedPrecondition"] = "failed_precondition";
	    /** The operation was aborted, typically due to a concurrency issue. */
	    SpanStatus["Aborted"] = "aborted";
	    /** Operation was attempted past the valid range. */
	    SpanStatus["OutOfRange"] = "out_of_range";
	    /** Unrecoverable data loss or corruption */
	    SpanStatus["DataLoss"] = "data_loss";
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (SpanStatus) {
	    /**
	     * Converts a HTTP status code into a {@link SpanStatus}.
	     *
	     * @param httpStatus The HTTP response status code.
	     * @returns The span status or {@link SpanStatus.UnknownError}.
	     */
	    function fromHttpCode(httpStatus) {
	        if (httpStatus < 400) {
	            return SpanStatus.Ok;
	        }
	        if (httpStatus >= 400 && httpStatus < 500) {
	            switch (httpStatus) {
	                case 401:
	                    return SpanStatus.Unauthenticated;
	                case 403:
	                    return SpanStatus.PermissionDenied;
	                case 404:
	                    return SpanStatus.NotFound;
	                case 409:
	                    return SpanStatus.AlreadyExists;
	                case 413:
	                    return SpanStatus.FailedPrecondition;
	                case 429:
	                    return SpanStatus.ResourceExhausted;
	                default:
	                    return SpanStatus.InvalidArgument;
	            }
	        }
	        if (httpStatus >= 500 && httpStatus < 600) {
	            switch (httpStatus) {
	                case 501:
	                    return SpanStatus.Unimplemented;
	                case 503:
	                    return SpanStatus.Unavailable;
	                case 504:
	                    return SpanStatus.DeadlineExceeded;
	                default:
	                    return SpanStatus.InternalError;
	            }
	        }
	        return SpanStatus.UnknownError;
	    }
	    SpanStatus.fromHttpCode = fromHttpCode;
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	//# sourceMappingURL=spanstatus.js.map

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(44);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AdminFiltersToggle(_ref) {
	    var onClick = _ref.onClick;
	
	    return _react2.default.createElement(
	        'button',
	        { type: 'button', className: _stylesModule2.default.FiltersToggle, onClick: onClick },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AdminFiltersToggle.label' })
	    );
	}
	
	exports.default = AdminFiltersToggle;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(40);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(597);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MONTH_NAMES_RU = ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];
	
	var MONTH_NAMES_EN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	var DAY_NAMES_RU = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
	var DAY_NAMES_EN = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
	
	function pad(n) {
	    return n < 10 ? "0" + n : "" + n;
	}
	
	function isSameDay(a, b) {
	    if (!a || !b) return false;
	    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
	}
	
	function getDaysInMonth(year, month) {
	    return new Date(year, month + 1, 0).getDate();
	}
	
	function getFirstDayOfWeek(year, month) {
	    var d = new Date(year, month, 1).getDay();
	    return d === 0 ? 6 : d - 1;
	}
	
	function buildCalendarGrid(year, month) {
	    var daysInMonth = getDaysInMonth(year, month);
	    var firstDay = getFirstDayOfWeek(year, month);
	    var prevMonth = month === 0 ? 11 : month - 1;
	    var prevYear = month === 0 ? year - 1 : year;
	    var daysInPrev = getDaysInMonth(prevYear, prevMonth);
	
	    var cells = [];
	
	    for (var i = firstDay - 1; i >= 0; i--) {
	        cells.push({
	            day: daysInPrev - i,
	            month: prevMonth,
	            year: prevYear,
	            outside: true
	        });
	    }
	
	    for (var d = 1; d <= daysInMonth; d++) {
	        cells.push({ day: d, month: month, year: year, outside: false });
	    }
	
	    var remaining = 42 - cells.length;
	    var nextMonth = month === 11 ? 0 : month + 1;
	    var nextYear = month === 11 ? year + 1 : year;
	    for (var j = 1; j <= remaining; j++) {
	        cells.push({ day: j, month: nextMonth, year: nextYear, outside: true });
	    }
	
	    return cells;
	}
	
	function formatDisplay(date, dateFormat) {
	    if (!date) return "";
	    var d = pad(date.getDate());
	    var m = pad(date.getMonth() + 1);
	    var y = date.getFullYear();
	    if (dateFormat === "yyyy-MM-dd") return y + "-" + m + "-" + d;
	    return d + "." + m + "." + y;
	}
	
	/**
	 * SingleDatePicker — выбор одной даты.
	 *
	 * Props:
	 *   selected     — Date object или null
	 *   onChange      — function(date: Date)
	 *   dateFormat    — "dd.MM.yyyy" (default) или "yyyy-MM-dd"
	 *   disabled      — boolean
	 *   placeholderText — string
	 *   className     — дополнительный CSS-класс для input
	 */
	function SingleDatePicker(props) {
	    var selected = props.selected;
	    var onChange = props.onChange;
	    var dateFormat = props.dateFormat || "dd.MM.yyyy";
	    var disabled = props.disabled || false;
	    var placeholderText = props.placeholderText || "";
	    var extraClass = props.className || "";
	
	    var intl = (0, _reactIntl.useIntl)();
	    var isRu = intl.locale === "ru";
	    var monthNames = isRu ? MONTH_NAMES_RU : MONTH_NAMES_EN;
	    var dayNames = isRu ? DAY_NAMES_RU : DAY_NAMES_EN;
	
	    var _open = (0, _react.useState)(false);
	    var isOpen = _open[0];
	    var setIsOpen = _open[1];
	
	    var _viewMonth = (0, _react.useState)(function () {
	        var d = selected instanceof Date && !isNaN(selected) ? selected : new Date();
	        return { year: d.getFullYear(), month: d.getMonth() };
	    });
	    var viewMonth = _viewMonth[0];
	    var setViewMonth = _viewMonth[1];
	
	    var _dropdownPos = (0, _react.useState)({ top: 0, left: 0 });
	    var dropdownPos = _dropdownPos[0];
	    var setDropdownPos = _dropdownPos[1];
	
	    var triggerRef = (0, _react.useRef)(null);
	    var dropdownRef = (0, _react.useRef)(null);
	
	    (0, _react.useEffect)(function () {
	        function handleClickOutside(e) {
	            var inTrigger = triggerRef.current && triggerRef.current.contains(e.target);
	            var inDropdown = dropdownRef.current && dropdownRef.current.contains(e.target);
	            if (!inTrigger && !inDropdown) {
	                setIsOpen(false);
	            }
	        }
	        document.addEventListener("mousedown", handleClickOutside);
	        return function () {
	            document.removeEventListener("mousedown", handleClickOutside);
	        };
	    }, []);
	
	    function openDropdown() {
	        if (disabled) return;
	        if (!isOpen && triggerRef.current) {
	            var rect = triggerRef.current.getBoundingClientRect();
	            var panelWidth = 212;
	            var left = rect.left;
	            if (left + panelWidth > window.innerWidth) {
	                left = window.innerWidth - panelWidth - 8;
	            }
	            if (left < 8) left = 8;
	            var top = rect.bottom + 4;
	            if (top + 300 > window.innerHeight) {
	                top = rect.top - 300 - 4;
	                if (top < 8) top = 8;
	            }
	            setDropdownPos({ top: top, left: left });
	            if (selected instanceof Date && !isNaN(selected)) {
	                setViewMonth({ year: selected.getFullYear(), month: selected.getMonth() });
	            }
	        }
	        setIsOpen(!isOpen);
	    }
	
	    function prevMonth() {
	        setViewMonth(function (prev) {
	            var m = prev.month - 1;
	            var y = prev.year;
	            if (m < 0) {
	                m = 11;y--;
	            }
	            return { year: y, month: m };
	        });
	    }
	
	    function nextMonth() {
	        setViewMonth(function (prev) {
	            var m = prev.month + 1;
	            var y = prev.year;
	            if (m > 11) {
	                m = 0;y++;
	            }
	            return { year: y, month: m };
	        });
	    }
	
	    function handleDayClick(cell) {
	        var d = new Date(cell.year, cell.month, cell.day);
	        if (onChange) onChange(d);
	        setIsOpen(false);
	    }
	
	    function handleMonthSelect(e) {
	        var m = parseInt(e.target.value, 10);
	        setViewMonth(function (prev) {
	            return { year: prev.year, month: m };
	        });
	    }
	
	    function handleYearSelect(e) {
	        var y = parseInt(e.target.value, 10);
	        setViewMonth(function (prev) {
	            return { year: y, month: prev.month };
	        });
	    }
	
	    var grid = buildCalendarGrid(viewMonth.year, viewMonth.month);
	    var weeks = [];
	    for (var w = 0; w < 6; w++) {
	        weeks.push(grid.slice(w * 7, (w + 1) * 7));
	    }
	
	    var currentYear = new Date().getFullYear();
	    var years = [];
	    for (var yr = currentYear - 100; yr <= currentYear + 10; yr++) {
	        years.push(yr);
	    }
	
	    var inputClasses = _stylesModule2.default.TriggerInput;
	    if (extraClass) inputClasses = extraClass;
	    if (isOpen) inputClasses += " " + _stylesModule2.default.TriggerInputActive;
	    if (disabled) inputClasses += " " + _stylesModule2.default.TriggerInputDisabled;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement("input", {
	            ref: triggerRef,
	            type: "text",
	            readOnly: true,
	            className: inputClasses,
	            value: formatDisplay(selected, dateFormat),
	            placeholder: placeholderText,
	            onClick: openDropdown,
	            disabled: disabled
	        }),
	        isOpen && _reactDom2.default.createPortal(_react2.default.createElement(
	            "div",
	            { ref: dropdownRef, className: _stylesModule2.default.Dropdown,
	                style: { top: dropdownPos.top, left: dropdownPos.left } },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Selectors },
	                _react2.default.createElement(
	                    "select",
	                    { className: _stylesModule2.default.Select, value: viewMonth.month,
	                        onChange: handleMonthSelect },
	                    monthNames.map(function (name, i) {
	                        return _react2.default.createElement(
	                            "option",
	                            { key: i, value: i },
	                            name
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    "select",
	                    { className: _stylesModule2.default.Select, value: viewMonth.year,
	                        onChange: handleYearSelect },
	                    years.map(function (y) {
	                        return _react2.default.createElement(
	                            "option",
	                            { key: y, value: y },
	                            y
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MonthHeader },
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.NavBtn, onClick: prevMonth, type: "button" },
	                    "\u2190"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MonthTitle },
	                    monthNames[viewMonth.month],
	                    " ",
	                    viewMonth.year
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.NavBtn, onClick: nextMonth, type: "button" },
	                    "\u2192"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.DayNames },
	                dayNames.map(function (name, i) {
	                    return _react2.default.createElement(
	                        "span",
	                        { key: i, className: i >= 5 ? _stylesModule2.default.Weekend : "" },
	                        name
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.DaysGrid },
	                weeks.map(function (week, wi) {
	                    return week.map(function (cell, di) {
	                        var cellDate = new Date(cell.year, cell.month, cell.day);
	                        var isSelected = selected && isSameDay(cellDate, selected);
	
	                        var cellClasses = _stylesModule2.default.Day;
	                        if (cell.outside) cellClasses += " " + _stylesModule2.default.Outside;
	                        if (isSelected) cellClasses += " " + _stylesModule2.default.Selected;
	
	                        return _react2.default.createElement(
	                            "span",
	                            {
	                                key: wi + "-" + di,
	                                className: cellClasses,
	                                onClick: function onClick() {
	                                    handleDayClick(cell);
	                                }
	                            },
	                            cell.day
	                        );
	                    });
	                })
	            )
	        ), document.body)
	    );
	}
	
	exports.default = SingleDatePicker;

/***/ },
/* 44 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FiltersToggle":"_1OSOb1O3AFAN3rrrIg3IbH","MainColumn":"_2lNkgOTS7YJd7fgPmjfIwI","SidebarColumn":"_3vSirUbTX8UTgNAhokZwDk"};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var injectIntl_1 = __webpack_require__(117);
	var utils_1 = __webpack_require__(64);
	function useIntl() {
	    var intl = React.useContext(injectIntl_1.Context);
	    (0, utils_1.invariantIntlContext)(intl);
	    return intl;
	}
	exports.default = useIntl;


/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.invariant = exports.UNICODE_EXTENSION_SEQUENCE_REGEX = void 0;
	exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
	function invariant(condition, message, Err) {
	    if (Err === void 0) { Err = Error; }
	    if (!condition) {
	        throw new Err(message);
	    }
	}
	exports.invariant = invariant;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var ignoreOnError = 0;
	/**
	 * @hidden
	 */
	function shouldIgnoreOnError() {
	    return ignoreOnError > 0;
	}
	exports.shouldIgnoreOnError = shouldIgnoreOnError;
	/**
	 * @hidden
	 */
	function ignoreNextOnError() {
	    // onerror should trigger before setTimeout
	    ignoreOnError += 1;
	    setTimeout(function () {
	        ignoreOnError -= 1;
	    });
	}
	exports.ignoreNextOnError = ignoreNextOnError;
	/**
	 * Instruments the given function and sends an event to Sentry every time the
	 * function throws an exception.
	 *
	 * @param fn A function to wrap.
	 * @returns The wrapped function.
	 * @hidden
	 */
	function wrap(fn, options, before) {
	    if (options === void 0) { options = {}; }
	    if (typeof fn !== 'function') {
	        return fn;
	    }
	    try {
	        // We don't wanna wrap it twice
	        if (fn.__sentry__) {
	            return fn;
	        }
	        // If this has already been wrapped in the past, return that wrapped function
	        if (fn.__sentry_wrapped__) {
	            return fn.__sentry_wrapped__;
	        }
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return fn;
	    }
	    /* eslint-disable prefer-rest-params */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var sentryWrapped = function () {
	        var args = Array.prototype.slice.call(arguments);
	        try {
	            if (before && typeof before === 'function') {
	                before.apply(this, arguments);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
	            if (fn.handleEvent) {
	                // Attempt to invoke user-land function
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	                //       means the sentry.javascript SDK caught an error invoking your application code. This
	                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                return fn.handleEvent.apply(this, wrappedArguments);
	            }
	            // Attempt to invoke user-land function
	            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	            //       means the sentry.javascript SDK caught an error invoking your application code. This
	            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	            return fn.apply(this, wrappedArguments);
	        }
	        catch (ex) {
	            ignoreNextOnError();
	            core_1.withScope(function (scope) {
	                scope.addEventProcessor(function (event) {
	                    var processedEvent = tslib_1.__assign({}, event);
	                    if (options.mechanism) {
	                        utils_1.addExceptionTypeValue(processedEvent, undefined, undefined);
	                        utils_1.addExceptionMechanism(processedEvent, options.mechanism);
	                    }
	                    processedEvent.extra = tslib_1.__assign(tslib_1.__assign({}, processedEvent.extra), { arguments: args });
	                    return processedEvent;
	                });
	                core_1.captureException(ex);
	            });
	            throw ex;
	        }
	    };
	    /* eslint-enable prefer-rest-params */
	    // Accessing some objects may throw
	    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
	    try {
	        for (var property in fn) {
	            if (Object.prototype.hasOwnProperty.call(fn, property)) {
	                sentryWrapped[property] = fn[property];
	            }
	        }
	    }
	    catch (_oO) { } // eslint-disable-line no-empty
	    fn.prototype = fn.prototype || {};
	    sentryWrapped.prototype = fn.prototype;
	    Object.defineProperty(fn, '__sentry_wrapped__', {
	        enumerable: false,
	        value: sentryWrapped,
	    });
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    Object.defineProperties(sentryWrapped, {
	        __sentry__: {
	            enumerable: false,
	            value: true,
	        },
	        __sentry_original__: {
	            enumerable: false,
	            value: fn,
	        },
	    });
	    // Restore original function name (not all browsers allow that)
	    try {
	        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
	        if (descriptor.configurable) {
	            Object.defineProperty(sentryWrapped, 'name', {
	                get: function () {
	                    return fn.name;
	                },
	            });
	        }
	        // eslint-disable-next-line no-empty
	    }
	    catch (_oO) { }
	    return sentryWrapped;
	}
	exports.wrap = wrap;
	/**
	 * Injects the Report Dialog script
	 * @hidden
	 */
	function injectReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        utils_1.logger.error("Missing eventId option in showReportDialog call");
	        return;
	    }
	    if (!options.dsn) {
	        utils_1.logger.error("Missing dsn option in showReportDialog call");
	        return;
	    }
	    var script = document.createElement('script');
	    script.async = true;
	    script.src = new core_1.API(options.dsn).getReportDialogEndpoint(options);
	    if (options.onLoad) {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        script.onload = options.onLoad;
	    }
	    (document.head || document.body).appendChild(script);
	}
	exports.injectReportDialog = injectReportDialog;
	//# sourceMappingURL=helpers.js.map

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(87);
	var string_1 = __webpack_require__(90);
	var fallbackGlobalObject = {};
	/**
	 * Safely get global scope object
	 *
	 * @returns Global scope object
	 */
	function getGlobalObject() {
	    return (node_1.isNodeEnv()
	        ? global
	        : typeof window !== 'undefined'
	            ? window
	            : typeof self !== 'undefined'
	                ? self
	                : fallbackGlobalObject);
	}
	exports.getGlobalObject = getGlobalObject;
	/**
	 * UUID4 generator
	 *
	 * @returns string Generated UUID4.
	 */
	function uuid4() {
	    var global = getGlobalObject();
	    var crypto = global.crypto || global.msCrypto;
	    if (!(crypto === void 0) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	        // set 4 in byte 7
	        // eslint-disable-next-line no-bitwise
	        arr[3] = (arr[3] & 0xfff) | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        // eslint-disable-next-line no-bitwise
	        arr[4] = (arr[4] & 0x3fff) | 0x8000;
	        var pad = function (num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = "0" + v;
	            }
	            return v;
	        };
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    }
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // eslint-disable-next-line no-bitwise
	        var r = (Math.random() * 16) | 0;
	        // eslint-disable-next-line no-bitwise
	        var v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	}
	exports.uuid4 = uuid4;
	/**
	 * Parses string form of URL into an object
	 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	 * // intentionally using regex and not <a/> href parsing trick because React Native and other
	 * // environments where DOM might not be available
	 * @returns parsed URL object
	 */
	function parseUrl(url) {
	    if (!url) {
	        return {};
	    }
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) {
	        return {};
	    }
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        host: match[4],
	        path: match[5],
	        protocol: match[2],
	        relative: match[5] + query + fragment,
	    };
	}
	exports.parseUrl = parseUrl;
	/**
	 * Extracts either message or type+value from an event that can be used for user-facing logs
	 * @returns event's description
	 */
	function getEventDescription(event) {
	    if (event.message) {
	        return event.message;
	    }
	    if (event.exception && event.exception.values && event.exception.values[0]) {
	        var exception = event.exception.values[0];
	        if (exception.type && exception.value) {
	            return exception.type + ": " + exception.value;
	        }
	        return exception.type || exception.value || event.event_id || '<unknown>';
	    }
	    return event.event_id || '<unknown>';
	}
	exports.getEventDescription = getEventDescription;
	/** JSDoc */
	function consoleSandbox(callback) {
	    var global = getGlobalObject();
	    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
	    if (!('console' in global)) {
	        return callback();
	    }
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var originalConsole = global.console;
	    var wrappedLevels = {};
	    // Restore all wrapped console methods
	    levels.forEach(function (level) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (level in global.console && originalConsole[level].__sentry_original__) {
	            wrappedLevels[level] = originalConsole[level];
	            originalConsole[level] = originalConsole[level].__sentry_original__;
	        }
	    });
	    // Perform callback manipulations
	    var result = callback();
	    // Revert restoration to wrapped state
	    Object.keys(wrappedLevels).forEach(function (level) {
	        originalConsole[level] = wrappedLevels[level];
	    });
	    return result;
	}
	exports.consoleSandbox = consoleSandbox;
	/**
	 * Adds exception values, type and value to an synthetic Exception.
	 * @param event The event to modify.
	 * @param value Value of the exception.
	 * @param type Type of the exception.
	 * @hidden
	 */
	function addExceptionTypeValue(event, value, type) {
	    event.exception = event.exception || {};
	    event.exception.values = event.exception.values || [];
	    event.exception.values[0] = event.exception.values[0] || {};
	    event.exception.values[0].value = event.exception.values[0].value || value || '';
	    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
	}
	exports.addExceptionTypeValue = addExceptionTypeValue;
	/**
	 * Adds exception mechanism to a given event.
	 * @param event The event to modify.
	 * @param mechanism Mechanism of the mechanism.
	 * @hidden
	 */
	function addExceptionMechanism(event, mechanism) {
	    if (mechanism === void 0) { mechanism = {}; }
	    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
	    try {
	        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
	        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
	        Object.keys(mechanism).forEach(function (key) {
	            // @ts-ignore Mechanism has no index signature
	            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	            event.exception.values[0].mechanism[key] = mechanism[key];
	        });
	    }
	    catch (_oO) {
	        // no-empty
	    }
	}
	exports.addExceptionMechanism = addExceptionMechanism;
	/**
	 * A safe form of location.href
	 */
	function getLocationHref() {
	    try {
	        return document.location.href;
	    }
	    catch (oO) {
	        return '';
	    }
	}
	exports.getLocationHref = getLocationHref;
	// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
	var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
	/**
	 * Parses input into a SemVer interface
	 * @param input string representation of a semver version
	 */
	function parseSemver(input) {
	    var match = input.match(SEMVER_REGEXP) || [];
	    var major = parseInt(match[1], 10);
	    var minor = parseInt(match[2], 10);
	    var patch = parseInt(match[3], 10);
	    return {
	        buildmetadata: match[5],
	        major: isNaN(major) ? undefined : major,
	        minor: isNaN(minor) ? undefined : minor,
	        patch: isNaN(patch) ? undefined : patch,
	        prerelease: match[4],
	    };
	}
	exports.parseSemver = parseSemver;
	var defaultRetryAfter = 60 * 1000; // 60 seconds
	/**
	 * Extracts Retry-After value from the request header or returns default value
	 * @param now current unix timestamp
	 * @param header string representation of 'Retry-After' header
	 */
	function parseRetryAfterHeader(now, header) {
	    if (!header) {
	        return defaultRetryAfter;
	    }
	    var headerDelay = parseInt("" + header, 10);
	    if (!isNaN(headerDelay)) {
	        return headerDelay * 1000;
	    }
	    var headerDate = Date.parse("" + header);
	    if (!isNaN(headerDate)) {
	        return headerDate - now;
	    }
	    return defaultRetryAfter;
	}
	exports.parseRetryAfterHeader = parseRetryAfterHeader;
	/**
	 * This function adds context (pre/post/line) lines to the provided frame
	 *
	 * @param lines string[] containing all lines
	 * @param frame StackFrame that will be mutated
	 * @param linesOfContext number of context lines we want to add pre/post
	 */
	function addContextToFrame(lines, frame, linesOfContext) {
	    if (linesOfContext === void 0) { linesOfContext = 5; }
	    var lineno = frame.lineno || 0;
	    var maxLines = lines.length;
	    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
	    frame.pre_context = lines
	        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
	    frame.post_context = lines
	        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	}
	exports.addContextToFrame = addContextToFrame;
	/**
	 * Strip the query string and fragment off of a given URL or path (if present)
	 *
	 * @param urlPath Full URL or path, including possible query string and/or fragment
	 * @returns URL or path without query string or fragment
	 */
	function stripUrlQueryAndFragment(urlPath) {
	    // eslint-disable-next-line no-useless-escape
	    return urlPath.split(/[\?#]/, 1)[0];
	}
	exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
	//# sourceMappingURL=misc.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = useIsMobile;
	
	var _react = __webpack_require__(1);
	
	var MOBILE_QUERY = '(max-width: 768px)';
	
	function getMatches(query) {
	    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false;
	}
	
	function useIsMobile() {
	    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MOBILE_QUERY;
	
	    var _useState = (0, _react.useState)(getMatches(query)),
	        _useState2 = _slicedToArray(_useState, 2),
	        matches = _useState2[0],
	        setMatches = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
	
	        var media = window.matchMedia(query);
	        var update = function update() {
	            return setMatches(media.matches);
	        };
	        update();
	
	        if (media.addEventListener) {
	            media.addEventListener('change', update);
	            return function () {
	                return media.removeEventListener('change', update);
	            };
	        }
	
	        media.addListener(update);
	        return function () {
	            return media.removeListener(update);
	        };
	    }, [query]);
	
	    return matches;
	}

/***/ },
/* 51 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TableWrap":"ItG_gnGaDCHBvA52nTBX6","Table":"_1KZYFDIqZ086tDxG_DdaTX","HeaderCell":"_2hRT7hJcV6MtAin5DrdBOE","HeaderCenter":"_3lkbwMmtS-qwEFFgoj-WNn","Row":"_17g66lk5y8NzKVE709X5","Cell":"mg7fTTCcKDAi2fTI-dSUO","CellCenter":"_1E9vzNPZCXkbtD4fooos7v","CellMenu":"_1KCv2OUpROcRoLCKWG_ge-","DropdownCell":"YAP12QJ6aNcws2v5YLE9R","Icon":"Tk2-apyK5SZ9_R3ONmPGA","HeadCellToggle":"_26LRtbx16o68wIWmufx_Eq","InfoRow":"esX5huGm0Ys6ja1qMPgCa","Tag":"_2rkdMHC4N_0IkOEhX5RW1l","FixedTable":"_1VL0AuBjqvAOpi3y8A03X","NameText":"_1XQHs7817O0zOCnh-rxW7U","Date":"_1zJHti4VvX-AXQFt1DaxpB","Success":"kHjaBx9q_uLZo-W_Ikjoz","Failed":"_1na1RH9yZq8-dw9H6W-qyz","Other":"_1Fo45lSVcazPOC9_9wc_P8","Menu":"_2gujxWxdjcIO8PlsTAJROe","MenuItem":"_3dJcfklkof3-aYZjN5jzvX","MenuItemDisables":"_3v9-fSwsoFrDLGIGokMfrf","MenuLink":"_1EfQbQ8eeoeotvYddPHIlv","MenuIcon":"_2sxaCLmfb-UW7zq64pvVMB","Status":"_174UjdY39hIRGCQBYoQ_aK","MenuItemDisabled":"_1ZZei1dBX0unuXz3A31QhC","EmptyCell":"_1qZ7KTs4fmQFTYlNqmZJGD","EmptyTR":"Vfzps0A_5bPeep38xKf_P"};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GetOption = void 0;
	var _262_1 = __webpack_require__(31);
	/**
	 * https://tc39.es/ecma402/#sec-getoption
	 * @param opts
	 * @param prop
	 * @param type
	 * @param values
	 * @param fallback
	 */
	function GetOption(opts, prop, type, values, fallback) {
	    if (typeof opts !== 'object') {
	        throw new TypeError('Options must be an object');
	    }
	    var value = opts[prop];
	    if (value !== undefined) {
	        if (type !== 'boolean' && type !== 'string') {
	            throw new TypeError('invalid type');
	        }
	        if (type === 'boolean') {
	            value = Boolean(value);
	        }
	        if (type === 'string') {
	            value = (0, _262_1.ToString)(value);
	        }
	        if (values !== undefined && !values.filter(function (val) { return val == value; }).length) {
	            throw new RangeError("".concat(value, " is not within ").concat(values.join(', ')));
	        }
	        return value;
	    }
	    return fallback;
	}
	exports.GetOption = GetOption;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var generateUniqueID_1 = __webpack_require__(290);
	exports.initMetric = function (name, value) {
	    if (value === void 0) { value = -1; }
	    return {
	        name: name,
	        value: value,
	        delta: 0,
	        entries: [],
	        id: generateUniqueID_1.generateUniqueID(),
	        isFinal: false,
	    };
	};
	//# sourceMappingURL=initMetric.js.map

/***/ },
/* 56 */
/***/ function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var isUnloading = false;
	var listenersAdded = false;
	var onPageHide = function (event) {
	    isUnloading = !event.persisted;
	};
	var addListeners = function () {
	    addEventListener('pagehide', onPageHide);
	    // `beforeunload` is needed to fix this bug:
	    // https://bugs.chromium.org/p/chromium/issues/detail?id=987409
	    // eslint-disable-next-line @typescript-eslint/no-empty-function
	    addEventListener('beforeunload', function () { });
	};
	exports.onHidden = function (cb, once) {
	    if (once === void 0) { once = false; }
	    if (!listenersAdded) {
	        addListeners();
	        listenersAdded = true;
	    }
	    addEventListener('visibilitychange', function (_a) {
	        var timeStamp = _a.timeStamp;
	        if (document.visibilityState === 'hidden') {
	            cb({ timeStamp: timeStamp, isUnloading: isUnloading });
	        }
	    }, { capture: true, once: once });
	};
	//# sourceMappingURL=onHidden.js.map

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(558);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * MerchantTerminalSelect — каскадный выбор мерчант → терминал
	 *
	 * Режим user:
	 *   Загружает getMerchantBalances(), группирует по merchant_name
	 *   Возвращает merchant_settings_id
	 *
	 * Режим admin:
	 *   Загружает getProjects() → getProjectServices(uuid)
	 *   Возвращает terminal_id
	 *
	 * Props:
	 *   mode: 'user' | 'admin'
	 *   token: JWT token
	 *   onSelect: function(value) — вызывается при выборе терминала
	 *   label: строка (опционально)
	 *   onDataLoaded: function(data) — вызывается когда данные загружены (опционально)
	 */
	function MerchantTerminalSelect(props) {
	    var mode = props.mode || 'user';
	    var token = props.token;
	    var onSelect = props.onSelect;
	    var onMerchantSelect = props.onMerchantSelect;
	    var onDataLoaded = props.onDataLoaded;
	    var stackOnMobile = props.stackOnMobile === true;
	
	    // --- User mode state ---
	    var _balances = (0, _react.useState)([]);
	    var balances = _balances[0];
	    var setBalances = _balances[1];
	
	    // --- Admin mode state ---
	    var _merchants = (0, _react.useState)([]);
	    var merchants = _merchants[0];
	    var setMerchants = _merchants[1];
	
	    var _terminals = (0, _react.useState)([]);
	    var terminals = _terminals[0];
	    var setTerminals = _terminals[1];
	
	    var _terminalsLoading = (0, _react.useState)(false);
	    var terminalsLoading = _terminalsLoading[0];
	    var setTerminalsLoading = _terminalsLoading[1];
	
	    // --- Common state ---
	    var _selectedMerchant = (0, _react.useState)("");
	    var selectedMerchant = _selectedMerchant[0];
	    var setSelectedMerchant = _selectedMerchant[1];
	
	    var _selectedTerminal = (0, _react.useState)("");
	    var selectedTerminal = _selectedTerminal[0];
	    var setSelectedTerminal = _selectedTerminal[1];
	
	    var _merchantSearch = (0, _react.useState)("");
	    var merchantSearch = _merchantSearch[0];
	    var setMerchantSearch = _merchantSearch[1];
	
	    var _terminalSearch = (0, _react.useState)("");
	    var terminalSearch = _terminalSearch[0];
	    var setTerminalSearch = _terminalSearch[1];
	
	    // The selected label is display text, not a search entered by the user.
	    var _terminalQuery = (0, _react.useState)("");
	    var terminalQuery = _terminalQuery[0];
	    var setTerminalQuery = _terminalQuery[1];
	
	    var _showMerchantDropdown = (0, _react.useState)(false);
	    var showMerchantDropdown = _showMerchantDropdown[0];
	    var setShowMerchantDropdown = _showMerchantDropdown[1];
	
	    var _showTerminalDropdown = (0, _react.useState)(false);
	    var showTerminalDropdown = _showTerminalDropdown[0];
	    var setShowTerminalDropdown = _showTerminalDropdown[1];
	
	    var _loading = (0, _react.useState)(true);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var dropdownRef = (0, _react.useRef)(null);
	    var terminalDropdownRef = (0, _react.useRef)(null);
	    var inputRef = (0, _react.useRef)(null);
	
	    // Close dropdown on outside click
	    (0, _react.useEffect)(function () {
	        function handleClickOutside(e) {
	            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
	                setShowMerchantDropdown(false);
	            }
	            if (terminalDropdownRef.current && !terminalDropdownRef.current.contains(e.target)) {
	                setShowTerminalDropdown(false);
	            }
	        }
	        document.addEventListener("mousedown", handleClickOutside);
	        return function () {
	            document.removeEventListener("mousedown", handleClickOutside);
	        };
	    }, []);
	
	    // Load data
	    (0, _react.useEffect)(function () {
	        var api = new _Api2.default({ token: token });
	
	        if (mode === 'user') {
	            api.getMerchantBalances().then(function (r) {
	                var list = r && r.balances ? r.balances : [];
	                setBalances(list);
	
	                // Build unique merchants list
	                var merchantMap = {};
	                list.forEach(function (b) {
	                    var key = b.merchant_uuid || b.merchant_name || 'unknown';
	                    if (!merchantMap[key]) {
	                        merchantMap[key] = {
	                            uuid: b.merchant_uuid || '',
	                            name: b.merchant_name || 'Мерчант'
	                        };
	                    }
	                });
	                var uniqueMerchants = Object.keys(merchantMap).map(function (k) {
	                    return merchantMap[k];
	                });
	                // Добавляем "Все проекты" если больше одного мерчанта
	                if (uniqueMerchants.length > 1) {
	                    uniqueMerchants.unshift({ uuid: '__all__', name: 'Все проекты' });
	                }
	                setMerchants(uniqueMerchants);
	
	                // Auto-select first real merchant (skip __all__)
	                if (uniqueMerchants.length > 0) {
	                    var firstReal = uniqueMerchants.find(function (m) {
	                        return m.uuid !== '__all__';
	                    });
	                    if (firstReal) {
	                        setSelectedMerchant(firstReal.uuid);
	                        setMerchantSearch(firstReal.name);
	
	                        var firstTerminals = list.filter(function (b) {
	                            return (b.merchant_uuid || '') === firstReal.uuid;
	                        });
	                        if (firstTerminals.length > 0) {
	                            var firstMsId = String(firstTerminals[0].merchant_settings_id);
	                            setSelectedTerminal(firstMsId);
	                            setTerminalSearch(getTerminalLabel(firstTerminals[0]));
	                            if (onSelect) onSelect(firstMsId);
	                        }
	                    }
	                }
	
	                if (onDataLoaded) onDataLoaded(list);
	                setLoading(false);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                setLoading(false);
	            });
	        } else {
	            // Admin mode — загружаем список всех мерчантов
	            api.getProjectsList({ itemsPerPage: 1000 }).then(function (r) {
	                var list = r && r.data ? r.data : Array.isArray(r) ? r : [];
	                setMerchants(list);
	                setLoading(false);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                setLoading(false);
	            });
	        }
	    }, [token, mode]);
	
	    // Get terminal options for user mode
	    function getUserTerminals() {
	        if (!selectedMerchant) return [];
	        if (selectedMerchant === '__all__') return balances;
	        return balances.filter(function (b) {
	            return (b.merchant_uuid || '') === selectedMerchant;
	        });
	    }
	
	    // Handle merchant selection (admin mode) - load terminals
	    function selectMerchantAdmin(merchant) {
	        setSelectedMerchant(merchant.uuid);
	        setMerchantSearch(merchant.name);
	        setShowMerchantDropdown(false);
	        setShowTerminalDropdown(false);
	        setSelectedTerminal("");
	        setTerminalSearch("");
	        setTerminals([]);
	
	        if (onSelect) onSelect("");
	        if (onMerchantSelect) onMerchantSelect(merchant.uuid);
	
	        setTerminalsLoading(true);
	        var api = new _Api2.default({ token: token });
	        api.getProjectServices(merchant.uuid).then(function (r) {
	            var list = Array.isArray(r) ? r : r && r.data ? r.data : [];
	            setTerminals(list);
	            setTerminalsLoading(false);
	
	            // Auto-select first terminal
	            if (list.length > 0) {
	                var firstId = String(list[0].id);
	                setSelectedTerminal(firstId);
	                setTerminalSearch(getTerminalLabel(list[0]));
	                if (onSelect) onSelect(firstId);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setTerminalsLoading(false);
	        });
	    }
	
	    // Handle merchant selection (user mode)
	    function selectMerchantUser(merchant) {
	        setSelectedMerchant(merchant.uuid);
	        setMerchantSearch(merchant.name);
	        setShowMerchantDropdown(false);
	        setShowTerminalDropdown(false);
	
	        if (merchant.uuid === '__all__') {
	            // "Все проекты" → выбираем "Все терминалы"
	            var allMsIds = balances.map(function (b) {
	                return b.merchant_settings_id;
	            }).join(',');
	            setSelectedTerminal('__all__');
	            setTerminalSearch('Все терминалы');
	            if (onSelect) onSelect(allMsIds);
	            return;
	        }
	
	        // Get terminals for this merchant
	        var termList = balances.filter(function (b) {
	            return (b.merchant_uuid || '') === merchant.uuid;
	        });
	
	        if (termList.length > 0) {
	            // Если больше одного терминала, по умолчанию "Все терминалы"
	            if (termList.length > 1) {
	                var allIds = termList.map(function (b) {
	                    return b.merchant_settings_id;
	                }).join(',');
	                setSelectedTerminal('__all__');
	                setTerminalSearch('Все терминалы');
	                if (onSelect) onSelect(allIds);
	            } else {
	                var firstMsId = String(termList[0].merchant_settings_id);
	                setSelectedTerminal(firstMsId);
	                setTerminalSearch(getTerminalLabel(termList[0]));
	                if (onSelect) onSelect(firstMsId);
	            }
	        } else {
	            setSelectedTerminal("");
	            setTerminalSearch("");
	            if (onSelect) onSelect("");
	        }
	    }
	
	    // Handle terminal change (user mode)
	    function handleTerminalChangeUser(e) {
	        var val = e.target.value;
	        setSelectedTerminal(val);
	        if (val === '__all__') {
	            var termList = getUserTerminals();
	            var allIds = termList.map(function (b) {
	                return b.merchant_settings_id;
	            }).join(',');
	            setTerminalSearch('Все терминалы');
	            if (onSelect) onSelect(allIds);
	        } else {
	            var selected = getUserTerminals().find(function (b) {
	                return String(b.merchant_settings_id) === String(val);
	            });
	            setTerminalSearch(selected ? getTerminalLabel(selected) : '');
	            if (onSelect) onSelect(val);
	        }
	    }
	
	    // Handle terminal change (admin mode)
	    function handleTerminalChangeAdmin(e) {
	        var val = e.target.value;
	        setSelectedTerminal(val);
	        var selected = terminals.find(function (t) {
	            return String(t.id) === String(val);
	        });
	        setTerminalSearch(selected ? getTerminalLabel(selected) : '');
	        if (onSelect) onSelect(val);
	    }
	
	    function getTerminalOptionsList() {
	        var list = mode === 'user' ? getUserTerminals() : terminals;
	
	        if (mode === 'user' && list.length > 1) {
	            return [{ merchant_settings_id: '__all__', terminal_name: 'Все терминалы', terminal_id: '' }].concat(list);
	        }
	
	        return list;
	    }
	
	    function getTerminalLabel(item) {
	        var name = item && item.terminal_name ? item.terminal_name : item && item.name ? item.name : 'Терминал';
	        var id = item && (item.merchant_settings_id || item.id);
	
	        if (item && item.merchant_settings_id === '__all__') {
	            return 'Все терминалы';
	        }
	
	        return id ? name + ' (ID: ' + id + ')' : name;
	    }
	
	    // Filtered merchants for search
	    function getFilteredMerchants() {
	        if (!merchantSearch) return merchants;
	        var q = merchantSearch.toLowerCase();
	        return merchants.filter(function (m) {
	            var name = (m.name || '').toLowerCase();
	            var uuid = (m.uuid || '').toLowerCase();
	            return name.indexOf(q) !== -1 || uuid.indexOf(q) !== -1;
	        });
	    }
	
	    if (loading) {
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.SelectorWrapper + (stackOnMobile ? ' ' + _stylesModule2.default.StackOnMobile : '') },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.SelectorGroup },
	                _react2.default.createElement(
	                    "label",
	                    null,
	                    props.label || "Терминал"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { style: { color: "#6c757d", fontSize: "0.875rem" } },
	                    "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
	                )
	            )
	        );
	    }
	
	    var filteredMerchants = getFilteredMerchants();
	
	    var terminalOptionsList = getTerminalOptionsList();
	    var filteredTerminals = terminalOptionsList.filter(function (t) {
	        if (!terminalQuery) return true;
	        var q = terminalQuery.toLowerCase();
	        var label = getTerminalLabel(t).toLowerCase();
	        var id = String(t.merchant_settings_id || t.id || '').toLowerCase();
	        return label.indexOf(q) !== -1 || id.indexOf(q) !== -1;
	    });
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.SelectorWrapper + (stackOnMobile ? ' ' + _stylesModule2.default.StackOnMobile : '') },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.SelectorGroup, ref: dropdownRef },
	            _react2.default.createElement(
	                "label",
	                null,
	                "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.SearchableSelect },
	                _react2.default.createElement("input", {
	                    ref: inputRef,
	                    type: "text",
	                    className: _stylesModule2.default.SearchInput,
	                    placeholder: "\u041F\u043E\u0438\u0441\u043A \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430...",
	                    value: merchantSearch,
	                    onChange: function onChange(e) {
	                        setMerchantSearch(e.target.value);
	                        setShowMerchantDropdown(true);
	                    },
	                    onFocus: function onFocus() {
	                        setShowMerchantDropdown(true);
	                    }
	                }),
	                showMerchantDropdown && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Dropdown },
	                    filteredMerchants.length === 0 ? _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.DropdownEmpty },
	                        "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
	                    ) : filteredMerchants.map(function (m) {
	                        var isActive = selectedMerchant === m.uuid;
	                        var itemClass = _stylesModule2.default.DropdownItem + (isActive ? ' ' + _stylesModule2.default.DropdownItemActive : '');
	                        return _react2.default.createElement(
	                            "div",
	                            {
	                                key: m.uuid,
	                                className: itemClass,
	                                onClick: function onClick() {
	                                    if (mode === 'user') {
	                                        selectMerchantUser(m);
	                                    } else {
	                                        selectMerchantAdmin(m);
	                                    }
	                                }
	                            },
	                            m.name
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.SelectorGroup, ref: terminalDropdownRef },
	            _react2.default.createElement(
	                "label",
	                null,
	                props.label || "Терминал"
	            ),
	            terminalsLoading ? _react2.default.createElement(
	                "div",
	                { style: { color: "#6c757d", fontSize: "0.875rem", padding: "6px 0" } },
	                "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u043E\u0432..."
	            ) : _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.SearchableSelect },
	                _react2.default.createElement("input", {
	                    type: "text",
	                    className: _stylesModule2.default.SearchInput,
	                    placeholder: "\u041F\u043E\u0438\u0441\u043A \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430...",
	                    value: terminalSearch,
	                    onChange: function onChange(e) {
	                        setTerminalSearch(e.target.value);
	                        setTerminalQuery(e.target.value);
	                        setShowTerminalDropdown(true);
	                    },
	                    onFocus: function onFocus() {
	                        setTerminalQuery("");
	                        setShowTerminalDropdown(true);
	                    }
	                }),
	                showTerminalDropdown && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Dropdown },
	                    filteredTerminals.length === 0 ? _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.DropdownEmpty },
	                        "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
	                    ) : filteredTerminals.map(function (t) {
	                        var value = String(t.merchant_settings_id || t.id || '');
	                        var isActive = selectedTerminal === value;
	                        var itemClass = _stylesModule2.default.DropdownItem + (isActive ? ' ' + _stylesModule2.default.DropdownItemActive : '');
	                        return _react2.default.createElement(
	                            "div",
	                            {
	                                key: value,
	                                className: itemClass,
	                                onClick: function onClick() {
	                                    setShowTerminalDropdown(false);
	                                    if (mode === 'user' && t.merchant_settings_id === '__all__') {
	                                        var termList = getUserTerminals();
	                                        var allIds = termList.map(function (b) {
	                                            return b.merchant_settings_id;
	                                        }).join(',');
	                                        setSelectedTerminal('__all__');
	                                        setTerminalSearch('Все терминалы');
	                                        if (onSelect) onSelect(allIds);
	                                        return;
	                                    }
	
	                                    setSelectedTerminal(value);
	                                    setTerminalSearch(getTerminalLabel(t));
	                                    if (onSelect) onSelect(value);
	                                }
	                            },
	                            getTerminalLabel(t)
	                        );
	                    })
	                )
	            )
	        )
	    );
	}
	
	exports.default = MerchantTerminalSelect;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(40);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(584);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextMenu = function (_Component) {
	    _inherits(ContextMenu, _Component);
	
	    function ContextMenu(props) {
	        _classCallCheck(this, ContextMenu);
	
	        var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));
	
	        _this.icon = props.icon;
	        _this.submenuRef = _react2.default.createRef();
	
	        _this.state = {
	            isOpened: false,
	            submenuStyle: null
	        };
	
	        _this.toggleState = _this.toggleState.bind(_this);
	        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	        _this.updatePlacement = _this.updatePlacement.bind(_this);
	        return _this;
	    }
	
	    _createClass(ContextMenu, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            document.addEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: "handleClickOutside",
	        value: function handleClickOutside(e) {
	            var node = _reactDom2.default.findDOMNode(this);
	            var submenu = this.submenuRef.current;
	
	            if ((!node || !node.contains(e.target)) && (!submenu || !submenu.contains(e.target))) {
	                this.setState({
	                    isOpened: false,
	                    submenuStyle: null
	                });
	            }
	        }
	    }, {
	        key: "toggleState",
	        value: function toggleState() {
	            var _this2 = this;
	
	            var willOpen = !this.state.isOpened;
	
	            this.setState({
	                isOpened: willOpen,
	                submenuStyle: null
	            }, function () {
	                if (willOpen) {
	                    _this2.updatePlacement();
	                }
	            });
	        }
	    }, {
	        key: "updatePlacement",
	        value: function updatePlacement() {
	            var node = _reactDom2.default.findDOMNode(this);
	            var submenu = this.submenuRef.current;
	
	            if (!node || !submenu) return;
	
	            var nodeRect = node.getBoundingClientRect();
	            var submenuRect = submenu.getBoundingClientRect();
	            var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	            var edgeGap = 8;
	            var menuGap = 4;
	            var spaceBelow = viewportHeight - nodeRect.bottom;
	            var spaceAbove = nodeRect.top;
	            var opensUp = submenuRect.height + menuGap > spaceBelow && spaceAbove > spaceBelow;
	            var maxLeft = Math.max(edgeGap, viewportWidth - submenuRect.width - edgeGap);
	            var maxTop = Math.max(edgeGap, viewportHeight - submenuRect.height - edgeGap);
	            var left = Math.min(Math.max(edgeGap, nodeRect.right - submenuRect.width), maxLeft);
	            var preferredTop = opensUp ? nodeRect.top - submenuRect.height - menuGap : nodeRect.bottom + menuGap;
	            var top = Math.min(Math.max(edgeGap, preferredTop), maxTop);
	
	            this.setState({
	                submenuStyle: {
	                    left: left + "px",
	                    top: top + "px",
	                    visibility: 'visible'
	                }
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var submenuStyle = this.state.submenuStyle || { left: 0, top: 0, visibility: 'hidden' };
	
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Wrap + " " + (this.state.isOpened ? _stylesModule2.default.Opened : '') },
	                _react2.default.createElement(
	                    "div",
	                    { onClick: this.toggleState },
	                    _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.icon, icon: this.icon, size: '18px' })
	                ),
	                this.state.isOpened && _reactDom2.default.createPortal(_react2.default.createElement(
	                    "div",
	                    {
	                        datatype: "submenu",
	                        ref: this.submenuRef,
	                        className: _stylesModule2.default.Submenu,
	                        style: submenuStyle
	                    },
	                    this.props.children
	                ), document.body)
	            );
	        }
	    }]);
	
	    return ContextMenu;
	}(_react.Component);
	
	exports.default = ContextMenu;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(589);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Help = function (_Component) {
	    _inherits(Help, _Component);
	
	    function Help(props) {
	        _classCallCheck(this, Help);
	
	        var _this = _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).call(this, props));
	
	        _this.handleClickOutside = function (e) {
	
	            if (!_this.help.current || !_this.help.current.contains(e.target)) {
	                _this.setState({
	                    isOpened: false
	                });
	            }
	        };
	
	        _this.state = {
	            isOpened: false
	        };
	
	        _this.width = props.width;
	        _this.marginTop = props.marginTop;
	        _this.marginLeft = props.marginLeft;
	
	        _this.toggleState = _this.toggleState.bind(_this);
	        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	
	        _this.help = (0, _react.createRef)();
	        _this.popup = (0, _react.createRef)();
	
	        return _this;
	    }
	
	    _createClass(Help, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            document.addEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            document.addEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: "toggleState",
	        value: function toggleState() {
	            this.setState({ isOpened: !this.state.isOpened });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var helpClassName = [_stylesModule2.default.Help, this.props.placement === "bottom" ? _stylesModule2.default.HelpBottom : null].filter(Boolean).join(" ");
	            var helpStyle = {
	                top: this.marginTop ? this.marginTop + "px" : 0,
	                marginLeft: this.marginLeft ? this.marginLeft + "px" : undefined
	            };
	
	            return _react2.default.createElement(
	                "div",
	                { ref: this.help, style: helpStyle, className: helpClassName },
	                _react2.default.createElement(
	                    "div",
	                    { onMouseEnter: this.toggleState, onMouseLeave: this.toggleState, className: _stylesModule2.default.Icon },
	                    _react2.default.createElement(_Icon2.default, { icon: "question", size: '14px' })
	                ),
	                this.state.isOpened && _react2.default.createElement(
	                    "div",
	                    { style: { width: this.width + 'px' }, ref: this.popup, className: _stylesModule2.default.Popup },
	                    _react2.default.createElement("div", { className: _stylesModule2.default.Arrow }),
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Help;
	}(_react.Component);
	
	exports.default = Help;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(601);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VTabBar = function (_Component) {
	    _inherits(VTabBar, _Component);
	
	    function VTabBar() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, VTabBar);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VTabBar.__proto__ || Object.getPrototypeOf(VTabBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            activeTab: null
	        }, _this.getVisibleLabels = function (children) {
	            var result = [];
	            _react2.default.Children.forEach(children, function (child) {
	                if (child && child.props && child.props.isVisible) {
	                    var labelObj = child.props.label;
	                    var labelText = "";
	                    if (labelObj && labelObj.props && labelObj.props.defaultMessage) {
	                        labelText = labelObj.props.defaultMessage;
	                    } else if (typeof labelObj === "string") {
	                        labelText = labelObj;
	                    }
	                    if (labelText) {
	                        result.push(labelText);
	                    }
	                }
	            });
	            return result;
	        }, _this.setActiveTab = function (activeTab) {
	            if (_this.state.activeTab !== activeTab && activeTab !== null) {
	                _this.setState({ activeTab: activeTab });
	            }
	        }, _this.renderTabs = function () {
	            var children = _this.props.children;
	            var activeTab = _this.state.activeTab;
	
	
	            return _react2.default.Children.map(children, function (child) {
	                if (!child || !child.props || !child.props.isVisible) return null;
	
	                var labelObj = child.props.label;
	                var labelText = "";
	                if (labelObj && labelObj.props && labelObj.props.defaultMessage) {
	                    labelText = labelObj.props.defaultMessage;
	                } else if (typeof labelObj === "string") {
	                    labelText = labelObj;
	                } else {
	                    return null;
	                }
	
	                var isActive = activeTab === labelText;
	
	                return _react2.default.createElement(
	                    "li",
	                    { key: labelText, className: isActive ? _stylesModule2.default.Active : "" },
	                    _react2.default.createElement(
	                        "span",
	                        {
	                            onClick: function onClick(e) {
	                                e.stopPropagation();
	                                _this.setActiveTab(labelText);
	                            }
	                        },
	                        child.props.navIcon && _react2.default.createElement(_Icon2.default, {
	                            className: _stylesModule2.default.TabIcon,
	                            icon: child.props.navIcon,
	                            size: child.props.navIconSize || 14
	                        }),
	                        child.props.label
	                    )
	                );
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(VTabBar, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props = this.props,
	                children = _props.children,
	                defaultActiveTab = _props.defaultActiveTab;
	
	            var labels = this.getVisibleLabels(children);
	            var firstVisible = labels.length > 0 ? labels[0] : null;
	            this.setActiveTab(defaultActiveTab || firstVisible);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.children !== this.props.children) {
	                var labels = this.getVisibleLabels(this.props.children);
	                var currentTab = this.state.activeTab;
	                if (!currentTab || labels.length > 0 && labels.indexOf(currentTab) === -1) {
	                    this.setActiveTab(labels[0]);
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var activeTab = this.state.activeTab;
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Wrap },
	                _react2.default.createElement(
	                    "ul",
	                    { className: _stylesModule2.default.Tabs },
	                    this.renderTabs()
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Content },
	                    _react2.default.Children.map(children, function (child) {
	                        if (!child || !child.props || !child.props.isVisible) return null;
	
	                        var labelObj = child.props.label;
	                        var labelText = "";
	                        if (labelObj && labelObj.props && labelObj.props.defaultMessage) {
	                            labelText = labelObj.props.defaultMessage;
	                        } else if (typeof labelObj === "string") {
	                            labelText = labelObj;
	                        } else {
	                            return null;
	                        }
	
	                        if (activeTab === labelText) {
	                            return _react2.default.createElement(
	                                "div",
	                                null,
	                                child.props.children
	                            );
	                        }
	                        return null;
	                    })
	                )
	            );
	        }
	    }]);
	
	    return VTabBar;
	}(_react.Component);
	
	VTabBar.Tab = function (_ref2) {
	    var children = _ref2.children,
	        label = _ref2.label,
	        navIcon = _ref2.navIcon,
	        navIconSize = _ref2.navIconSize,
	        isVisible = _ref2.isVisible;
	
	    return { children: children, label: label, navIcon: navIcon, navIconSize: navIconSize, isVisible: isVisible };
	};
	
	exports.default = VTabBar;

/***/ },
/* 61 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Scroll":"_1tbNcHxwUIpURU5T7Gfhde","Table":"_6xjDSz4dSVPEk9SgKtKhY","HeaderCell":"_2VFbXAyBC7B0Wx8cIT_pNP","HeaderCenter":"_1SD9AkhutiTEKM2xLeULJw","Row":"_2CdoJTbXQ6RQGxrqr_Avlz","Cell":"_13fDH69QmJJVAXrgP3dYwd","CellCenter":"_2DJ6EgbsHabmLiIT0Wrk97","Empty":"_3ipgFrpkc7ymNumjjH60bl","EmptyRow":"_1qNJMCIAjIQ75Wrsa7KlKo","MobileCard":"_1DZ-_xViB1j8C6CAJ4A2_7","MobilePrimary":"_3QuyPoUVK6-v0uwnI4Kf0-","MobileStatus":"_1NzWGXlpcsah87D3B6ocO","MobileMetaRow":"r5QjwgVqh7Qk4EPssnSPC","MobileField":"_1Lo42jjPY_tFLxb4oQou8H","MobileName":"fO7rXkDZPI5o-zu6imIoM","MobileValue":"_2pXnq3aVsIiDgq1RpbTXr_","MobileMeta":"_2maPiy5DT_agJwiPvDwSzK"};

/***/ },
/* 62 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Scroll":"-u1KF4rJ8yVdpFhXmXm5B","Table":"_3nED_iNTX8YS-GAbZax7mv","HeaderCell":"Dm5gzgmnCiPFxhBkbBI6U","HeaderCenter":"ajCcZ_5ZfpYpPh6Bnumn6","Row":"_3z8vutrY0FcGfdlaYV84A4","Cell":"_1s4yi4AUuZ1fHH9OL177V","CellCenter":"_1EZ23n-FHrtltV8vfn7e8","Empty":"d7Nx3ToqN7zdkHVbVufEk","EmptyRow":"_38v5AWfhuQbjziSdL4P4Xy","MobileCard":"_3R1sbJn7GI2Zc9riYsVeH6","MobilePrimary":"_2frTORUIawIGdb8bnvb_ZK","MobileStatus":"_1lHs3sqDn7CvUbxL-b9vgP","MobileMetaRow":"_2eyphkg5BL7MOHIf0ITK0z","MobileField":"GAusmaJ9aSlcBQzlxfbuz","MobileName":"_3qZzz3ura2hqkEi5vk2Son","MobileValue":"_3t7cnamPmexyzhuPnEOmLp","MobileMeta":"_3qc9r0O-Onsk-_HCJizWsr"};

/***/ },
/* 63 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.shallowEqual = exports.assignUniqueKeysToParts = exports.DEFAULT_INTL_CONFIG = exports.invariantIntlContext = void 0;
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var ecma402_abstract_1 = __webpack_require__(68);
	var intl_1 = __webpack_require__(73);
	function invariantIntlContext(intl) {
	    (0, ecma402_abstract_1.invariant)(intl, '[React Intl] Could not find required `intl` object. ' +
	        '<IntlProvider> needs to exist in the component ancestry.');
	}
	exports.invariantIntlContext = invariantIntlContext;
	exports.DEFAULT_INTL_CONFIG = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, intl_1.DEFAULT_INTL_CONFIG), { textComponent: React.Fragment });
	/**
	 * Takes a `formatXMLElementFn`, and composes it in function, which passes
	 * argument `parts` through, assigning unique key to each part, to prevent
	 * "Each child in a list should have a unique "key"" React error.
	 * @param formatXMLElementFn
	 */
	function assignUniqueKeysToParts(formatXMLElementFn) {
	    return function (parts) {
	        // eslint-disable-next-line prefer-rest-params
	        return formatXMLElementFn(React.Children.toArray(parts));
	    };
	}
	exports.assignUniqueKeysToParts = assignUniqueKeysToParts;
	function shallowEqual(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	    if (!objA || !objB) {
	        return false;
	    }
	    var aKeys = Object.keys(objA);
	    var bKeys = Object.keys(objB);
	    var len = aKeys.length;
	    if (bKeys.length !== len) {
	        return false;
	    }
	    for (var i = 0; i < len; i++) {
	        var key = aKeys[i];
	        if (objA[key] !== objB[key] ||
	            !Object.prototype.hasOwnProperty.call(objB, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.shallowEqual = shallowEqual;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported XLSX */
	/*global exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */
	var XLSX = {};
	function make_xlsx_lib(XLSX){
	XLSX.version = '0.18.5';
	var current_codepage = 1200, current_ansi = 1252;
	/*global cptable:true, window */
	var $cptable;
	if(typeof cptable !== 'undefined') $cptable = cptable;
	else if(true) {
		$cptable = __webpack_require__(716);
	}
	
	var VALID_ANSI = [ 874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 10000 ];
	/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
	var CS2CP = ({
	0:    1252, /* ANSI */
	1:   65001, /* DEFAULT */
	2:   65001, /* SYMBOL */
	77:  10000, /* MAC */
	128:   932, /* SHIFTJIS */
	129:   949, /* HANGUL */
	130:  1361, /* JOHAB */
	134:   936, /* GB2312 */
	136:   950, /* CHINESEBIG5 */
	161:  1253, /* GREEK */
	162:  1254, /* TURKISH */
	163:  1258, /* VIETNAMESE */
	177:  1255, /* HEBREW */
	178:  1256, /* ARABIC */
	186:  1257, /* BALTIC */
	204:  1251, /* RUSSIAN */
	222:   874, /* THAI */
	238:  1250, /* EASTEUROPE */
	255:  1252, /* OEM */
	69:   6969  /* MISC */
	});
	
	var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
	function reset_ansi() { set_ansi(1252); }
	
	var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	function reset_cp() { set_cp(1200); reset_ansi(); }
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	
	function utf16leread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
		return o.join("");
	}
	function utf16beread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
		return o.join("");
	}
	
	var debom = function(data) {
		var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
		if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
		if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
		if(c1 == 0xFEFF) return data.slice(1);
		return data;
	};
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	var _getansi = function _ga1(x) { return String.fromCharCode(x); };
	if(typeof $cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
		debom = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return $cptable.utils.decode(1200, char_codes(data.slice(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return $cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
		_getansi = function _ga2(x) {
			return $cptable.utils.decode(current_ansi, [x])[0];
		};
	}
	var DENSE = null;
	var DIF_XL = true;
	var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	function Base64_encode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  for (var i = 0; i < input.length; ) {
	    c1 = input.charCodeAt(i++);
	    e1 = c1 >> 2;
	    c2 = input.charCodeAt(i++);
	    e2 = (c1 & 3) << 4 | c2 >> 4;
	    c3 = input.charCodeAt(i++);
	    e3 = (c2 & 15) << 2 | c3 >> 6;
	    e4 = c3 & 63;
	    if (isNaN(c2)) {
	      e3 = e4 = 64;
	    } else if (isNaN(c3)) {
	      e4 = 64;
	    }
	    o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
	  }
	  return o;
	}
	function Base64_decode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  input = input.replace(/[^\w\+\/\=]/g, "");
	  for (var i = 0; i < input.length; ) {
	    e1 = Base64_map.indexOf(input.charAt(i++));
	    e2 = Base64_map.indexOf(input.charAt(i++));
	    c1 = e1 << 2 | e2 >> 4;
	    o += String.fromCharCode(c1);
	    e3 = Base64_map.indexOf(input.charAt(i++));
	    c2 = (e2 & 15) << 4 | e3 >> 2;
	    if (e3 !== 64) {
	      o += String.fromCharCode(c2);
	    }
	    e4 = Base64_map.indexOf(input.charAt(i++));
	    c3 = (e3 & 3) << 6 | e4;
	    if (e4 !== 64) {
	      o += String.fromCharCode(c3);
	    }
	  }
	  return o;
	}
	var has_buf = (function() { return typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node; })();
	
	var Buffer_from = (function() {
		if(typeof Buffer !== 'undefined') {
			var nbfs = !Buffer.from;
			if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
			return nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		}
		return function() {};
	})();
	
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	function new_unsafe_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	var s2a = function s2a(s) {
		if(has_buf) return Buffer_from(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	};
	
	function s2ab(s) {
		if(typeof ArrayBuffer === 'undefined') return s2a(s);
		var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}
	
	function a2s(data) {
		if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
		var o = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
	}
	
	function a2u(data) {
		if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
		return new Uint8Array(data);
	}
	
	function ab2a(data) {
		if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
		if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	var o = new Array(data.length);
		for(var i = 0; i < data.length; ++i) o[i] = data[i];
		return o;
	}
	
	var bconcat = has_buf ? function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); } : function(bufs) {
		if(typeof Uint8Array !== "undefined") {
			var i = 0, maxlen = 0;
			for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
			var o = new Uint8Array(maxlen);
			var len = 0;
			for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
				len = bufs[i].length;
				if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
				else if(typeof bufs[i] == "string") { throw "wtf"; }
				else o.set(new Uint8Array(bufs[i]), maxlen);
			}
			return o;
		}
		return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
	};
	
	function utf8decode(content) {
		var out = [], widx = 0, L = content.length + 250;
		var o = new_raw_buf(content.length + 255);
		for(var ridx = 0; ridx < content.length; ++ridx) {
			var c = content.charCodeAt(ridx);
			if(c < 0x80) o[widx++] = c;
			else if(c < 0x800) {
				o[widx++] = (192|((c>>6)&31));
				o[widx++] = (128|(c&63));
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64;
				var d = content.charCodeAt(++ridx)&1023;
				o[widx++] = (240|((c>>8)&7));
				o[widx++] = (128|((c>>2)&63));
				o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
				o[widx++] = (128|(d&63));
			} else {
				o[widx++] = (224|((c>>12)&15));
				o[widx++] = (128|((c>>6)&63));
				o[widx++] = (128|(c&63));
			}
			if(widx > L) {
				out.push(o.slice(0, widx));
				widx = 0;
				o = new_raw_buf(65535);
				L = 65530;
			}
		}
		out.push(o.slice(0, widx));
		return bconcat(out);
	}
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
	/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	/* yes, in 2022 this is still faster than string compare */
	function SSF_isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function SSF_init_table(t) {
		if(!t) t = {};
		t[0]=  'General';
		t[1]=  '0';
		t[2]=  '0.00';
		t[3]=  '#,##0';
		t[4]=  '#,##0.00';
		t[9]=  '0%';
		t[10]= '0.00%';
		t[11]= '0.00E+00';
		t[12]= '# ?/?';
		t[13]= '# ??/??';
		t[14]= 'm/d/yy';
		t[15]= 'd-mmm-yy';
		t[16]= 'd-mmm';
		t[17]= 'mmm-yy';
		t[18]= 'h:mm AM/PM';
		t[19]= 'h:mm:ss AM/PM';
		t[20]= 'h:mm';
		t[21]= 'h:mm:ss';
		t[22]= 'm/d/yy h:mm';
		t[37]= '#,##0 ;(#,##0)';
		t[38]= '#,##0 ;[Red](#,##0)';
		t[39]= '#,##0.00;(#,##0.00)';
		t[40]= '#,##0.00;[Red](#,##0.00)';
		t[45]= 'mm:ss';
		t[46]= '[h]:mm:ss';
		t[47]= 'mmss.0';
		t[48]= '##0.0E+0';
		t[49]= '@';
		t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
		return t;
	}
	/* repeated to satiate webpack */
	var table_fmt = {
		0:  'General',
		1:  '0',
		2:  '0.00',
		3:  '#,##0',
		4:  '#,##0.00',
		9:  '0%',
		10: '0.00%',
		11: '0.00E+00',
		12: '# ?/?',
		13: '# ??/??',
		14: 'm/d/yy',
		15: 'd-mmm-yy',
		16: 'd-mmm',
		17: 'mmm-yy',
		18: 'h:mm AM/PM',
		19: 'h:mm:ss AM/PM',
		20: 'h:mm',
		21: 'h:mm:ss',
		22: 'm/d/yy h:mm',
		37: '#,##0 ;(#,##0)',
		38: '#,##0 ;[Red](#,##0)',
		39: '#,##0.00;(#,##0.00)',
		40: '#,##0.00;[Red](#,##0.00)',
		45: 'mm:ss',
		46: '[h]:mm:ss',
		47: 'mmss.0',
		48: '##0.0E+0',
		49: '@',
		56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
	};
	
	/* Defaults determined by systematically testing in Excel 2019 */
	
	/* These formats appear to default to other formats in the table */
	var SSF_default_map = {
		5:  37, 6:  38, 7:  39, 8:  40,         //  5 -> 37 ...  8 -> 40
	
		23:  0, 24:  0, 25:  0, 26:  0,         // 23 ->  0 ... 26 ->  0
	
		27: 14, 28: 14, 29: 14, 30: 14, 31: 14, // 27 -> 14 ... 31 -> 14
	
		50: 14, 51: 14, 52: 14, 53: 14, 54: 14, // 50 -> 14 ... 58 -> 14
		55: 14, 56: 14, 57: 14, 58: 14,
		59:  1, 60:  2, 61:  3, 62:  4,         // 59 ->  1 ... 62 ->  4
	
		67:  9, 68: 10,                         // 67 ->  9 ... 68 -> 10
		69: 12, 70: 13, 71: 14,                 // 69 -> 12 ... 71 -> 14
		72: 14, 73: 15, 74: 16, 75: 17,         // 72 -> 14 ... 75 -> 17
		76: 20, 77: 21, 78: 22,                 // 76 -> 20 ... 78 -> 22
		79: 45, 80: 46, 81: 47,                 // 79 -> 45 ... 81 -> 47
		82: 0                                   // 82 ->  0 ... 65536 -> 0 (omitted)
	};
	
	
	/* These formats technically refer to Accounting formats with no equivalent */
	var SSF_default_str = {
		//  5 -- Currency,   0 decimal, black negative
		5:  '"$"#,##0_);\\("$"#,##0\\)',
		63: '"$"#,##0_);\\("$"#,##0\\)',
	
		//  6 -- Currency,   0 decimal, red   negative
		6:  '"$"#,##0_);[Red]\\("$"#,##0\\)',
		64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
	
		//  7 -- Currency,   2 decimal, black negative
		7:  '"$"#,##0.00_);\\("$"#,##0.00\\)',
		65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
	
		//  8 -- Currency,   2 decimal, red   negative
		8:  '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	
		// 41 -- Accounting, 0 decimal, No Symbol
		41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
	
		// 42 -- Accounting, 0 decimal, $  Symbol
		42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
	
		// 43 -- Accounting, 2 decimal, No Symbol
		43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
	
		// 44 -- Accounting, 2 decimal, $  Symbol
		44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
	};
	
	function SSF_frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.00000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
		if(!mixed) return [0, sgn * P, Q];
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function SSF_parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		if(opts && opts.date1904) date += 1462;
		if(out.u > 0.9999) {
			out.u = 0;
			if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 in Gregorian */
			var d = new Date(1900, 0, 1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = SSF_fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	var SSFbasedate = new Date(1899, 11, 31, 0, 0, 0);
	var SSFdnthresh = SSFbasedate.getTime();
	var SSFbase1904 = new Date(1900, 2, 1, 0, 0, 0);
	function datenum_local(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1461*24*60*60*1000;
		else if(v >= SSFbase1904) epoch += 24*60*60*1000;
		return (epoch - (SSFdnthresh + (v.getTimezoneOffset() - SSFbasedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
	}
	/* ECMA-376 18.8.30 numFmt*/
	/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
	/* exponent >= -9 and <= 9 */
	function SSF_strip_decimal(o) {
		return (o.indexOf(".") == -1) ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
	}
	
	/* General Exponential always shows 2 digits exp and trims the mantissa */
	function SSF_normalize_exp(o) {
		if(o.indexOf("E") == -1) return o;
		return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");
	}
	
	/* exponent >= -9 and <= 9 */
	function SSF_small_exp(v) {
		var w = (v<0?12:11);
		var o = SSF_strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}
	
	/* exponent >= 11 or <= -10 likely exponential */
	function SSF_large_exp(v) {
		var o = SSF_strip_decimal(v.toFixed(11));
		return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
	}
	
	function SSF_general_num(v) {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	
		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = SSF_small_exp(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = SSF_large_exp(v);
	
		return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
	}
	
	
	/*
		"General" rules:
		- text is passed through ("@")
		- booleans are rendered as TRUE/FALSE
		- "up to 11 characters" displayed for numbers
		- Default date format (code 14) used for Dates
	
		The longest 32-bit integer text is "-2147483648", exactly 11 chars
		TODO: technically the display depends on the width of the cell
	*/
	function SSF_general(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? v.toString(10) : SSF_general_num(v);
			case 'undefined': return "";
			case 'object':
				if(v == null) return "";
				if(v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	
	function SSF_fix_hijri(date, o) {
	  /* TODO: properly adjust y/m/d and  */
	  o[0] -= 581;
	  var dow = date.getDay();
	  if(date < 60) dow = (dow + 6) % 7;
	  return dow;
	}
	//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
	function SSF_write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
				if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
				if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
	if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
				else tt = ss0 === 1 ? 10 : 1;
				ss = Math.round((tt)*(val.S + val.u));
				if(ss >= 60*tt) ss = 0;
				if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
				o = pad0(ss,2 + ss0);
				if(fmt === 'ss') return o.substr(0,2);
				return "." + o.substr(2,fmt.length-1);
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1; break;
		}
		var outstr = outl > 0 ? pad0(out, outl) : "";
		return outstr;
	}
	
	
	/*jshint -W086 */
	/*jshint +W086 */
	function commaify(s) {
		var w = 3;
		if(s.length <= w) return s;
		var j = (s.length % w), o = s.substr(0,j);
		for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
		return o;
	}
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.([0#]+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) {
		var _frac = val - Math.floor(val), dd = Math.pow(10,d);
		if (d < ('' + Math.round(_frac * dd)).length) return 0;
		return Math.round(_frac * dd);
	}
	function carry(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 1;
		}
		return 0;
	}
	function flr(val) {
		if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
		return ""+Math.floor(val);
	}
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
			case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp2(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
	o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
			o = o.replace(/\.(\d*)$/,function($$, $1) {
	return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
				if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	}
	function SSF_split_fmt(fmt) {
		var out = [];
		var in_str = false/*, cc*/;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	
	var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
	function fmt_is_date(fmt) {
		var i = 0, /*cc = 0,*/ c = "", o = "";
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': if(SSF_isgeneral(fmt, i)) i+= 6; i++; break;
				case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
				case '\\': i+=2; break;
				case '_': i+=2; break;
				case '@': ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
				case 'A': case 'a': case '上':
					if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
					if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
					if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
					++i; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.match(SSF_abstime)) return true;
					break;
				case '.':
					/* falls through */
				case '0': case '#':
					while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
					break;
				case '?': while(fmt.charAt(++i) === c){/* empty */} break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
				case '(': case ')': ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
				case ' ': ++i; break;
				default: ++i; break;
			}
		}
		return false;
	}
	
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': /* General */
					if(!SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
						if(dt==null) { dt=SSF_parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A': case 'a': case '上':
					var q={t:c, v:c};
					if(dt==null) dt=SSF_parse_date_code(v, opts);
					if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
					else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(SSF_abstime)) {
						if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
						lst = o.charAt(1);
					} else if(o.indexOf("$") > -1) {
						o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
						if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
					}
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt.charAt(++i) === c) o+=c;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
	
		/* Scan for date/time parts */
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': /*if(out[i].v === "B2");*/
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		/* time rounding depends on presence of minute / second / usec fields */
		switch(bt) {
			case 0: break;
			case 1:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
	
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i].v = ""; out[i].t = ";"; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
						(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
						(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
					)) {
						out[i].v += out[jj].v;
						out[jj] = {v:"", t:";"}; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = SSF_general(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			if(nstr.charCodeAt(0) == 40) /* '(' */ {
				myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
				ostr = write_num('n', nstr, myv);
			} else {
				myv = (v<0 && flen > 1 ? -v : v);
				ostr = write_num('n', nstr, myv);
				if(myv < 0 && out[0] && out[0].t == 't') {
					ostr = ostr.substr(1);
					out[0].v = "-" + out[0].v;
				}
			}
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr.charAt(jj++);
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	
	var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = SSF_split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function SSF_format(fmt,v,o) {
		if(o == null) o = {};
		var sfmt = "";
		switch(typeof fmt) {
			case "string":
				if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
				else sfmt = fmt;
				break;
			case "number":
				if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
				else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
				if(sfmt == null) sfmt = (o.table && o.table[SSF_default_map[fmt]]) || table_fmt[SSF_default_map[fmt]];
				if(sfmt == null) sfmt = SSF_default_str[fmt] || "General";
				break;
		}
		if(SSF_isgeneral(sfmt,0)) return SSF_general(v, o);
		if(v instanceof Date) v = datenum_local(v, o.date1904);
		var f = choose_fmt(sfmt, v);
		if(SSF_isgeneral(f[1])) return SSF_general(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	function SSF_load(fmt, idx) {
		if(typeof idx != 'number') {
			idx = +idx || -1;
	for(var i = 0; i < 0x0188; ++i) {
	if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
				if(table_fmt[i] == fmt) { idx = i; break; }
			}
	if(idx < 0) idx = 0x187;
		}
	table_fmt[idx] = fmt;
		return idx;
	}
	function SSF_load_table(tbl) {
		for(var i=0; i!=0x0188; ++i)
			if(tbl[i] !== undefined) SSF_load(tbl[i], i);
	}
	
	function make_ssf() {
		table_fmt = SSF_init_table();
	}
	
	var SSF = {
		format: SSF_format,
		load: SSF_load,
		_table: table_fmt,
		load_table: SSF_load_table,
		parse_date_code: SSF_parse_date_code,
		is_date: fmt_is_date,
		get_table: function get_table() { return SSF._table = table_fmt; }
	};
	
	var SSFImplicit/*{[number]:string}*/ = ({
		"5": '"$"#,##0_);\\("$"#,##0\\)',
		"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"23": 'General', "24": 'General', "25": 'General', "26": 'General',
		"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
		"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
		"36": 'm/d/yy',
		"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
		"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
		"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
		"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
		"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
		"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
		"59": '0',
		"60": '0.00',
		"61": '#,##0',
		"62": '#,##0.00',
		"63": '"$"#,##0_);\\("$"#,##0\\)',
		"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"67": '0%',
		"68": '0.00%',
		"69": '# ?/?',
		"70": '# ??/??',
		"71": 'm/d/yy',
		"72": 'm/d/yy',
		"73": 'd-mmm-yy',
		"74": 'd-mmm',
		"75": 'mmm-yy',
		"76": 'h:mm',
		"77": 'h:mm:ss',
		"78": 'm/d/yy h:mm',
		"79": 'mm:ss',
		"80": '[h]:mm:ss',
		"81": 'mmss.0'
	});
	
	/* dateNF parse TODO: move to SSF */
	var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
	function dateNF_regex(dateNF) {
		var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
		fmt = fmt.replace(dateNFregex, "(\\d+)");
		return new RegExp("^" + fmt + "$");
	}
	function dateNF_fix(str, dateNF, match) {
		var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
		(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
			var v = parseInt(match[i+1], 10);
			switch(n.toLowerCase().charAt(0)) {
				case 'y': Y = v; break; case 'd': d = v; break;
				case 'h': H = v; break; case 's': S = v; break;
				case 'm': if(H >= 0) M = v; else m = v; break;
			}
		});
		if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
		var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
		if(datestr.length == 7) datestr = "0" + datestr;
		if(datestr.length == 8) datestr = "20" + datestr;
		var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
		if(H == -1 && M == -1 && S == -1) return datestr;
		if(Y == -1 && m == -1 && d == -1) return timestr;
		return datestr + "T" + timestr;
	}
	
	/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	/*exported CFB */
	/*global Uint8Array:false, Uint16Array:false */
	
	/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported CRC32 */
	var CRC32 = (function() {
	var CRC32 = {};
	CRC32.version = '1.2.0';
	/* see perf/crc32table.js */
	/*global Int32Array */
	function signed_crc_table() {
		var c = 0, table = new Array(256);
	
		for(var n =0; n != 256; ++n){
			c = n;
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			table[n] = c;
		}
	
		return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
	}
	
	var T0 = signed_crc_table();
	function slice_by_16_tables(T) {
		var c = 0, v = 0, n = 0, table = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;
	
		for(n = 0; n != 256; ++n) table[n] = T[n];
		for(n = 0; n != 256; ++n) {
			v = T[n];
			for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
		}
		var out = [];
		for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
		return out;
	}
	var TT = slice_by_16_tables(T0);
	var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
	var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
	var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
	function crc32_bstr(bstr, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
		return ~C;
	}
	
	function crc32_buf(B, seed) {
		var C = seed ^ -1, L = B.length - 15, i = 0;
		for(; i < L;) C =
			Tf[B[i++] ^ (C & 255)] ^
			Te[B[i++] ^ ((C >> 8) & 255)] ^
			Td[B[i++] ^ ((C >> 16) & 255)] ^
			Tc[B[i++] ^ (C >>> 24)] ^
			Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
			T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
			T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
		L += 15;
		while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
		return ~C;
	}
	
	function crc32_str(str, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
			c = str.charCodeAt(i++);
			if(c < 0x80) {
				C = (C>>>8) ^ T0[(C^c)&0xFF];
			} else if(c < 0x800) {
				C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
				C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
			} else {
				C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			}
		}
		return ~C;
	}
	CRC32.table = T0;
	CRC32.bstr = crc32_bstr;
	CRC32.buf = crc32_buf;
	CRC32.str = crc32_str;
	return CRC32;
	})();
	/* [MS-CFB] v20171201 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '1.2.1';
	/* [MS-CFB] 2.6.4 */
	function namecmp(l, r) {
		var L = l.split("/"), R = r.split("/");
		for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
			if((c = L[i].length - R[i].length)) return c;
			if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
		}
		return L.length - R.length;
	}
	function dirname(p) {
		if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(0, c+1);
	}
	
	function filename(p) {
		if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(c+1);
	}
	/* -------------------------------------------------------------------------- */
	/* DOS Date format:
	   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
	   add 1980 to stored year
	   stored second should be doubled
	*/
	
	/* write JS date to buf as a DOS date */
	function write_dos_date(buf, date) {
		if(typeof date === "string") date = new Date(date);
		var hms = date.getHours();
		hms = hms << 6 | date.getMinutes();
		hms = hms << 5 | (date.getSeconds()>>>1);
		buf.write_shift(2, hms);
		var ymd = (date.getFullYear() - 1980);
		ymd = ymd << 4 | (date.getMonth()+1);
		ymd = ymd << 5 | date.getDate();
		buf.write_shift(2, ymd);
	}
	
	/* read four bytes from buf and interpret as a DOS date */
	function parse_dos_date(buf) {
		var hms = buf.read_shift(2) & 0xFFFF;
		var ymd = buf.read_shift(2) & 0xFFFF;
		var val = new Date();
		var d = ymd & 0x1F; ymd >>>= 5;
		var m = ymd & 0x0F; ymd >>>= 4;
		val.setMilliseconds(0);
		val.setFullYear(ymd + 1980);
		val.setMonth(m-1);
		val.setDate(d);
		var S = hms & 0x1F; hms >>>= 5;
		var M = hms & 0x3F; hms >>>= 6;
		val.setHours(hms);
		val.setMinutes(M);
		val.setSeconds(S<<1);
		return val;
	}
	function parse_extra_field(blob) {
		prep_blob(blob, 0);
		var o = {};
		var flags = 0;
		while(blob.l <= blob.length - 4) {
			var type = blob.read_shift(2);
			var sz = blob.read_shift(2), tgt = blob.l + sz;
			var p = {};
			switch(type) {
				/* UNIX-style Timestamps */
				case 0x5455: {
					flags = blob.read_shift(1);
					if(flags & 1) p.mtime = blob.read_shift(4);
					/* for some reason, CD flag corresponds to LFH */
					if(sz > 5) {
						if(flags & 2) p.atime = blob.read_shift(4);
						if(flags & 4) p.ctime = blob.read_shift(4);
					}
					if(p.mtime) p.mt = new Date(p.mtime*1000);
				}
				break;
			}
			blob.l = tgt;
			o[type] = p;
		}
		return o;
	}
	var fs;
	function get_fs() { return fs || (fs = __webpack_require__(226)); }
	function parse(file, options) {
	if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
	if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
	if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
	var mver = 3;
	var ssz = 512;
	var nmfs = 0; // number of mini FAT sectors
	var difat_sec_cnt = 0;
	var dir_start = 0;
	var minifat_start = 0;
	var difat_start = 0;
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		case 0: if(mv[1] == 0) return parse_zip(file, options);
		/* falls through */
		default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var dir_cnt = blob.read_shift(4, 'i');
	if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
	
	// Number of FAT Sectors
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	difat_sec_cnt = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [];
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
	
	build_full_paths(FileIndex, FullPaths, Paths);
	Paths.shift();
	
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	
	// $FlowIgnore
	if(options && options.raw) o.raw = {header: header, sectors: sectors};
	return o;
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		//blob.chk(HEADER_CLSID, 'CLSID: ');
		blob.l += 16;
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
		blob.l += 2;
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
			case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
			default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = [];
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = [], q = [];
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
			if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
		}
		for(i=1; i < pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = i;
			if(j != dad[j]) do {
				j = dad[j];
				FP[i] = FP[j] + "/" + FP[i];
			} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
			dad[i] = -1;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
		}
	}
	
	function get_mfat_entry(entry, payload, mini) {
		var start = entry.start, size = entry.size;
		//return (payload.slice(start*MSSZ, start*MSSZ + size));
		var o = [];
		var idx = start;
		while(mini && size > 0 && idx >= 0) {
			o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
			size -= MSSZ;
			idx = __readInt32LE(mini, idx * 4);
		}
		if(o.length === 0) return (new_buf(0));
		return (bconcat(o).slice(0, entry.size));
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bits */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q = ENDOFCHAIN;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			if(!sector) return;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var buf = [], buf_chain = [];
		if(!chkd) chkd = [];
		var modulus = ssz - 1, j = 0, jj = 0;
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = ([]);
		var chkd = [], buf = [], buf_chain = [];
		var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
		for(i=0; i < sl; ++i) {
			buf = ([]);
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k]) continue;
			buf_chain = [];
			var seen = [];
			for(j=k; j>=0;) {
				seen[j] = true;
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
				if(!sectors[addr]) break;
				j = __readInt32LE(sectors[addr], jj);
				if(seen[j]) break;
			}
			sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name;
		for(; i < sector.length; i+= 128) {
			var blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			var o = ({
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i'),
				start: 0,
				size: 0
			});
			var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
			var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = (sector_list[o.start].data.slice(0,o.size));
			} else {
				o.storage = 'minifat';
				if(o.size < 0) o.size = 0;
				else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
					o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
				}
			}
			if(o.content) prep_blob(o.content, 0);
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	function read_file(filename, options) {
		get_fs();
		return parse(fs.readFileSync(filename), options);
	}
	
	function read(blob, options) {
		var type = options && options.type;
		if(!type) {
			if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
		}
		switch(type || "base64") {
			case "file": return read_file(blob, options);
			case "base64": return parse(s2a(Base64_decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob, options);
	}
	
	function init_cfb(cfb, opts) {
		var o = opts || {}, root = o.root || "Root Entry";
		if(!cfb.FullPaths) cfb.FullPaths = [];
		if(!cfb.FileIndex) cfb.FileIndex = [];
		if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
		if(cfb.FullPaths.length === 0) {
			cfb.FullPaths[0] = root + "/";
			cfb.FileIndex[0] = ({ name: root, type: 5 });
		}
		if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
		seed_cfb(cfb);
	}
	function seed_cfb(cfb) {
		var nm = "\u0001Sh33tJ5";
		if(CFB.find(cfb, "/" + nm)) return;
		var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
		cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
		cfb.FullPaths.push(cfb.FullPaths[0] + nm);
		rebuild_cfb(cfb);
	}
	function rebuild_cfb(cfb, f) {
		init_cfb(cfb);
		var gc = false, s = false;
		for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
			var _file = cfb.FileIndex[i];
			switch(_file.type) {
				case 0:
					if(s) gc = true;
					else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
					break;
				case 1: case 2: case 5:
					s = true;
					if(isNaN(_file.R * _file.L * _file.C)) gc = true;
					if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
					break;
				default: gc = true; break;
			}
		}
		if(!gc && !f) return;
	
		var now = new Date(1987, 1, 19), j = 0;
		// Track which names exist
		var fullPaths = Object.create ? Object.create(null) : {};
		var data = [];
		for(i = 0; i < cfb.FullPaths.length; ++i) {
			fullPaths[cfb.FullPaths[i]] = true;
			if(cfb.FileIndex[i].type === 0) continue;
			data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
		}
		for(i = 0; i < data.length; ++i) {
			var dad = dirname(data[i][0]);
			s = fullPaths[dad];
			if(!s) {
				data.push([dad, ({
					name: filename(dad).replace("/",""),
					type: 1,
					clsid: HEADER_CLSID,
					ct: now, mt: now,
					content: null
				})]);
				// Add name to set
				fullPaths[dad] = true;
			}
		}
	
		data.sort(function(x,y) { return namecmp(x[0], y[0]); });
		cfb.FullPaths = []; cfb.FileIndex = [];
		for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
		for(i = 0; i < data.length; ++i) {
			var elt = cfb.FileIndex[i];
			var nm = cfb.FullPaths[i];
	
			elt.name =  filename(nm).replace("/","");
			elt.L = elt.R = elt.C = -(elt.color = 1);
			elt.size = elt.content ? elt.content.length : 0;
			elt.start = 0;
			elt.clsid = (elt.clsid || HEADER_CLSID);
			if(i === 0) {
				elt.C = data.length > 1 ? 1 : -1;
				elt.size = 0;
				elt.type = 5;
			} else if(nm.slice(-1) == "/") {
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
				elt.C = j >= data.length ? -1 : j;
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
				elt.R = j >= data.length ? -1 : j;
				elt.type = 1;
			} else {
				if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
				elt.type = 2;
			}
		}
	
	}
	
	function _write(cfb, options) {
		var _opts = options || {};
		/* MAD is order-sensitive, skip rebuild and sort */
		if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
		rebuild_cfb(cfb);
		switch(_opts.fileType) {
			case 'zip': return write_zip(cfb, _opts);
			//case 'mad': return write_mad(cfb, _opts);
		}
		var L = (function(cfb){
			var mini_size = 0, fat_size = 0;
			for(var i = 0; i < cfb.FileIndex.length; ++i) {
				var file = cfb.FileIndex[i];
				if(!file.content) continue;
	var flen = file.content.length;
				if(flen > 0){
					if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
					else fat_size += (flen + 0x01FF) >> 9;
				}
			}
			var dir_cnt = (cfb.FullPaths.length +3) >> 2;
			var mini_cnt = (mini_size + 7) >> 3;
			var mfat_cnt = (mini_size + 0x7F) >> 7;
			var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
			var fat_cnt = (fat_base + 0x7F) >> 7;
			var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
			cfb.FileIndex[0].size = mini_size << 6;
			L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
			return L;
		})(cfb);
		var o = new_buf(L[7] << 9);
		var i = 0, T = 0;
		{
			for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
			for(i = 0; i < 8; ++i) o.write_shift(2, 0);
			o.write_shift(2, 0x003E);
			o.write_shift(2, 0x0003);
			o.write_shift(2, 0xFFFE);
			o.write_shift(2, 0x0009);
			o.write_shift(2, 0x0006);
			for(i = 0; i < 3; ++i) o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, L[2]);
			o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
			o.write_shift(4, 0);
			o.write_shift(4, 1<<12);
			o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
			o.write_shift(4, L[3]);
			o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
			o.write_shift(4, L[1]);
			for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
		}
		if(L[1]) {
			for(T = 0; T < L[1]; ++T) {
				for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
				o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
			}
		}
		var chainit = function(w) {
			for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
			if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
		};
		T = i = 0;
		for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
		for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
		chainit(L[3]);
		chainit(L[4]);
		var j = 0, flen = 0;
		var file = cfb.FileIndex[0];
		for(; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(flen < 0x1000) continue;
			file.start = T;
			chainit((flen + 0x01FF) >> 9);
		}
		chainit((L[6] + 7) >> 3);
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		T = i = 0;
		for(j = 0; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(!flen || flen >= 0x1000) continue;
			file.start = T;
			chainit((flen + 0x3F) >> 6);
		}
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		for(i = 0; i < L[4]<<2; ++i) {
			var nm = cfb.FullPaths[i];
			if(!nm || nm.length === 0) {
				for(j = 0; j < 17; ++j) o.write_shift(4, 0);
				for(j = 0; j < 3; ++j) o.write_shift(4, -1);
				for(j = 0; j < 12; ++j) o.write_shift(4, 0);
				continue;
			}
			file = cfb.FileIndex[i];
			if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
			var _nm = (i === 0 && _opts.root) || file.name;
			flen = 2*(_nm.length+1);
			o.write_shift(64, _nm, "utf16le");
			o.write_shift(2, flen);
			o.write_shift(1, file.type);
			o.write_shift(1, file.color);
			o.write_shift(-4, file.L);
			o.write_shift(-4, file.R);
			o.write_shift(-4, file.C);
			if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
			else o.write_shift(16, file.clsid, "hex");
			o.write_shift(4, file.state || 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, file.start);
			o.write_shift(4, file.size); o.write_shift(4, 0);
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size >= 0x1000) {
				o.l = (file.start+1) << 9;
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 511) & -512;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x1FF; ++j) o.write_shift(1, 0);
				}
			}
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size > 0 && file.size < 0x1000) {
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 63) & -64;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x3F; ++j) o.write_shift(1, 0);
				}
			}
		}
		if (has_buf) {
			o.l = o.length;
		} else {
			// When using Buffer, already 0-filled
			while(o.l < o.length) o.write_shift(1, 0);
		}
		return o;
	}
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	function find(cfb, path) {
		var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
		var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
		var k = false;
		if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
		else k = path.indexOf("/") !== -1;
		var UCPath = path.toUpperCase();
		var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
		if(w !== -1) return cfb.FileIndex[w];
	
		var m = !UCPath.match(chr1);
		UCPath = UCPath.replace(chr0,'');
		if(m) UCPath = UCPath.replace(chr1,'!');
		for(w = 0; w < UCFullPaths.length; ++w) {
			if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
			if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		}
		return null;
	}
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	function write_file(cfb, filename, options) {
		get_fs();
		var o = _write(cfb, options);
	fs.writeFileSync(filename, o);
	}
	
	function a2s(o) {
		var out = new Array(o.length);
		for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
		return out.join("");
	}
	
	function write(cfb, options) {
		var o = _write(cfb, options);
		switch(options && options.type || "buffer") {
			case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
			case "binary": return typeof o == "string" ? o : a2s(o);
			case "base64": return Base64_encode(typeof o == "string" ? o : a2s(o));
			case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
				/* falls through */
			case "array": return typeof o == "string" ? s2a(o) : o;
		}
		return o;
	}
	/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
	var _zlib;
	function use_zlib(zlib) { try {
		var InflateRaw = zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
		if(InflRaw.bytesRead) _zlib = zlib;
		else throw new Error("zlib does not expose bytesRead");
	} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }
	
	function _inflateRawSync(payload, usz) {
		if(!_zlib) return _inflate(payload, usz);
		var InflateRaw = _zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
		payload.l += InflRaw.bytesRead;
		return out;
	}
	
	function _deflateRawSync(payload) {
		return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
	}
	var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
	var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];
	
	/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
	var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];
	
	function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }
	
	var use_typed_arrays = typeof Uint8Array !== 'undefined';
	
	var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
	for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);
	
	function bit_swap_n(n, b) {
		var rev = bitswap8[n & 0xFF];
		if(b <= 8) return rev >>> (8-b);
		rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
		if(b <= 16) return rev >>> (16-b);
		rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
		return rev >>> (24-b);
	}
	
	/* helpers for unaligned bit reads */
	function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
	function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
	function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
	function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
	function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }
	
	/* works up to n = 3 * 8 + 1 = 25 */
	function read_bits_n(buf, bl, n) {
		var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
		var v = buf[h] >>> w;
		if(n < 8 - w) return v & f;
		v |= buf[h+1]<<(8-w);
		if(n < 16 - w) return v & f;
		v |= buf[h+2]<<(16-w);
		if(n < 24 - w) return v & f;
		v |= buf[h+3]<<(24-w);
		return v & f;
	}
	
	/* helpers for unaligned bit writes */
	function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
		if(w <= 5) buf[h] |= (v & 7) << w;
		else {
			buf[h] |= (v << w) & 0xFF;
			buf[h+1] = (v&7) >> (8-w);
		}
		return bl + 3;
	}
	
	function write_bits_1(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v = (v&1) << w;
		buf[h] |= v;
		return bl + 1;
	}
	function write_bits_8(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v;
		return bl + 8;
	}
	function write_bits_16(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v & 0xFF;
		buf[h+2] = v >>> 8;
		return bl + 16;
	}
	
	/* until ArrayBuffer#realloc is a thing, fake a realloc */
	function realloc(b, sz) {
		var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
		if(L >= sz) return b;
		if(has_buf) {
			var o = new_unsafe_buf(M);
			// $FlowIgnore
			if(b.copy) b.copy(o);
			else for(; i < b.length; ++i) o[i] = b[i];
			return o;
		} else if(use_typed_arrays) {
			var a = new Uint8Array(M);
			if(a.set) a.set(b);
			else for(; i < L; ++i) a[i] = b[i];
			return a;
		}
		b.length = M;
		return b;
	}
	
	/* zero-filled arrays for older browsers */
	function zero_fill_array(n) {
		var o = new Array(n);
		for(var i = 0; i < n; ++i) o[i] = 0;
		return o;
	}
	
	/* build tree (used for literals and lengths) */
	function build_tree(clens, cmap, MAX) {
		var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
	
		var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
		for(i = 0; i < 32; ++i) bl_count[i] = 0;
	
		for(i = L; i < MAX; ++i) clens[i] = 0;
		L = clens.length;
	
		var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
	
		/* build code tree */
		for(i = 0; i < L; ++i) {
			bl_count[(w = clens[i])]++;
			if(maxlen < w) maxlen = w;
			ctree[i] = 0;
		}
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
		for(i = 0; i < L; ++i) {
			ccode = clens[i];
			if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
		}
	
		/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
				for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
					cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
			}
		}
		return maxlen;
	}
	
	/* Fixed Huffman */
	var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
	var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
	if(!use_typed_arrays) {
		for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
		for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
	}
	(function() {
		var dlens = [];
		var i = 0;
		for(;i<32; i++) dlens.push(5);
		build_tree(dlens, fix_dmap, 32);
	
		var clens = [];
		i = 0;
		for(; i<=143; i++) clens.push(8);
		for(; i<=255; i++) clens.push(9);
		for(; i<=279; i++) clens.push(7);
		for(; i<=287; i++) clens.push(8);
		build_tree(clens, fix_lmap, 288);
	})();var _deflateRaw = (function _deflateRawIIFE() {
		var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
		var j = 0, k = 0;
		for(; j < DST_LN.length - 1; ++j) {
			for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
		}
		for(;k < 32768; ++k) DST_LN_RE[k] = 29;
	
		var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
		for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
			for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
		}
	
		function write_stored(data, out) {
			var boff = 0;
			while(boff < data.length) {
				var L = Math.min(0xFFFF, data.length - boff);
				var h = boff + L == data.length;
				out.write_shift(1, +h);
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
			}
			return out.l;
		}
	
		/* Fixed Huffman */
		function write_huff_fixed(data, out) {
			var bl = 0;
			var boff = 0;
			var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
			while(boff < data.length) {
				var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
	
				/* write a stored block for short data */
				if(L < 10) {
					bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
					if(bl & 7) bl += 8 - (bl & 7);
					out.l = (bl / 8) | 0;
					out.write_shift(2, L);
					out.write_shift(2, (~L) & 0xFFFF);
					while(L-- > 0) out[out.l++] = data[boff++];
					bl = out.l * 8;
					continue;
				}
	
				bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
				var hash = 0;
				while(L-- > 0) {
					var d = data[boff];
					hash = ((hash << 5) ^ d) & 0x7FFF;
	
					var match = -1, mlen = 0;
	
					if((match = addrs[hash])) {
						match |= boff & ~0x7FFF;
						if(match > boff) match -= 0x8000;
						if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
					}
	
					if(mlen > 2) {
						/* Copy Token  */
						d = LEN_LN_RE[mlen];
						if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
						else {
							write_bits_8(out, bl, 3);
							bl += 5;
							write_bits_8(out, bl, bitswap8[d-23]>>5);
							bl += 3;
						}
						var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
						if(len_eb > 0) {
							write_bits_16(out, bl, mlen - LEN_LN[d]);
							bl += len_eb;
						}
	
						d = DST_LN_RE[boff - match];
						bl = write_bits_8(out, bl, bitswap8[d]>>3);
						bl -= 3;
	
						var dst_eb = d < 4 ? 0 : (d-2)>>1;
						if(dst_eb > 0) {
							write_bits_16(out, bl, boff - match - DST_LN[d]);
							bl += dst_eb;
						}
						for(var q = 0; q < mlen; ++q) {
							addrs[hash] = boff & 0x7FFF;
							hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
							++boff;
						}
						L-= mlen - 1;
					} else {
						/* Literal Token */
						if(d <= 143) d = d + 48;
						else bl = write_bits_1(out, bl, 1);
						bl = write_bits_8(out, bl, bitswap8[d]);
						addrs[hash] = boff & 0x7FFF;
						++boff;
					}
				}
	
				bl = write_bits_8(out, bl, 0) - 1;
			}
			out.l = ((bl + 7)/8)|0;
			return out.l;
		}
		return function _deflateRaw(data, out) {
			if(data.length < 8) return write_stored(data, out);
			return write_huff_fixed(data, out);
		};
	})();
	
	function _deflate(data) {
		var buf = new_buf(50+Math.floor(data.length*1.1));
		var off = _deflateRaw(data, buf);
		return buf.slice(0, off);
	}
	/* modified inflate function also moves original read head */
	
	var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
	var dyn_len_1 = 1, dyn_len_2 = 1;
	
	/* 5.5.3 Expanding Huffman Codes */
	function dyn(data, boff) {
		/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
		var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
		var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
		var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
		var w = 0;
	
		/* grab and store code lengths */
		var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
		var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
		var maxlen = 1;
		var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var L = clens.length; /* 19 */
		for(var i = 0; i < _HCLEN; ++i) {
			clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
			if(maxlen < w) maxlen = w;
			bl_count[w]++;
			boff += 3;
		}
	
		/* build code tree */
		var ccode = 0;
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
		for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
		/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bitswap8[ctree[i]]>>(8-cleni);
				for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
			}
		}
	
		/* read literal and dist codes at once */
		var hcodes = [];
		maxlen = 1;
		for(; hcodes.length < _HLIT + _HDIST;) {
			ccode = dyn_cmap[read_bits_7(data, boff)];
			boff += ccode & 7;
			switch((ccode >>>= 3)) {
				case 16:
					w = 3 + read_bits_2(data, boff); boff += 2;
					ccode = hcodes[hcodes.length - 1];
					while(w-- > 0) hcodes.push(ccode);
					break;
				case 17:
					w = 3 + read_bits_3(data, boff); boff += 3;
					while(w-- > 0) hcodes.push(0);
					break;
				case 18:
					w = 11 + read_bits_7(data, boff); boff += 7;
					while(w -- > 0) hcodes.push(0);
					break;
				default:
					hcodes.push(ccode);
					if(maxlen < ccode) maxlen = ccode;
					break;
			}
		}
	
		/* build literal / length trees */
		var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
		for(i = _HLIT; i < 286; ++i) h1[i] = 0;
		for(i = _HDIST; i < 30; ++i) h2[i] = 0;
		dyn_len_1 = build_tree(h1, dyn_lmap, 286);
		dyn_len_2 = build_tree(h2, dyn_dmap, 30);
		return boff;
	}
	
	/* return [ data, bytesRead ] */
	function inflate(data, usz) {
		/* shortcircuit for empty buffer [0x03, 0x00] */
		if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }
	
		/* bit offset */
		var boff = 0;
	
		/* header includes final bit and type bits */
		var header = 0;
	
		var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
		var woff = 0;
		var OL = outbuf.length>>>0;
		var max_len_1 = 0, max_len_2 = 0;
	
		while((header&1) == 0) {
			header = read_bits_3(data, boff); boff += 3;
			if((header >>> 1) == 0) {
				/* Stored block */
				if(boff & 7) boff += 8 - (boff&7);
				/* 2 bytes sz, 2 bytes bit inverse */
				var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
				boff += 32;
				/* push sz bytes */
				if(sz > 0) {
					if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
					while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
				}
				continue;
			} else if((header >> 1) == 1) {
				/* Fixed Huffman */
				max_len_1 = 9; max_len_2 = 5;
			} else {
				/* Dynamic Huffman */
				boff = dyn(data, boff);
				max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
			}
			for(;;) { // while(true) is apparently out of vogue in modern JS circles
				if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
				/* ingest code and move read head */
				var bits = read_bits_n(data, boff, max_len_1);
				var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
				boff += code & 15; code >>>= 4;
				/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
				if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
				else if(code == 256) break;
				else {
					code -= 257;
					var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
					var tgt = woff + LEN_LN[code];
					/* length extra bits */
					if(len_eb > 0) {
						tgt += read_bits_n(data, boff, len_eb);
						boff += len_eb;
					}
	
					/* dist code */
					bits = read_bits_n(data, boff, max_len_2);
					code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
					boff += code & 15; code >>>= 4;
					var dst_eb = (code < 4 ? 0 : (code-2)>>1);
					var dst = DST_LN[code];
					/* dist extra bits */
					if(dst_eb > 0) {
						dst += read_bits_n(data, boff, dst_eb);
						boff += dst_eb;
					}
	
					/* in the common case, manual byte copy is faster than TA set / Buffer copy */
					if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
					while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
				}
			}
		}
		if(usz) return [outbuf, (boff+7)>>>3];
		return [outbuf.slice(0, woff), (boff+7)>>>3];
	}
	
	function _inflate(payload, usz) {
		var data = payload.slice(payload.l||0);
		var out = inflate(data, usz);
		payload.l += out[1];
		return out[0];
	}
	
	function warn_or_throw(wrn, msg) {
		if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
		else throw new Error(msg);
	}
	
	function parse_zip(file, options) {
		var blob = file;
		prep_blob(blob, 0);
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o, { root: options.root });
	
		/* find end of central directory, start just after signature */
		var i = blob.length - 4;
		while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
		blob.l = i + 4;
	
		/* parse end of central directory */
		blob.l += 4;
		var fcnt = blob.read_shift(2);
		blob.l += 6;
		var start_cd = blob.read_shift(4);
	
		/* parse central directory */
		blob.l = start_cd;
	
		for(i = 0; i < fcnt; ++i) {
			/* trust local file header instead of CD entry */
			blob.l += 20;
			var csz = blob.read_shift(4);
			var usz = blob.read_shift(4);
			var namelen = blob.read_shift(2);
			var efsz = blob.read_shift(2);
			var fcsz = blob.read_shift(2);
			blob.l += 8;
			var offset = blob.read_shift(4);
			var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
			blob.l += namelen + efsz + fcsz;
	
			var L = blob.l;
			blob.l = offset + 4;
			parse_local_file(blob, csz, usz, o, EF);
			blob.l = L;
		}
		return o;
	}
	
	
	/* head starts just after local file header signature */
	function parse_local_file(blob, csz, usz, o, EF) {
		/* [local file header] */
		blob.l += 2;
		var flags = blob.read_shift(2);
		var meth = blob.read_shift(2);
		var date = parse_dos_date(blob);
	
		if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
		var crc32 = blob.read_shift(4);
		var _csz = blob.read_shift(4);
		var _usz = blob.read_shift(4);
	
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
	
		// TODO: flags & (1<<11) // UTF8
		var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
		if(efsz) {
			var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
			if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
			if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
		}
		blob.l += efsz;
	
		/* [encryption header] */
	
		/* [file data] */
		var data = blob.slice(blob.l, blob.l + _csz);
		switch(meth) {
			case 8: data = _inflateRawSync(blob, _usz); break;
			case 0: break; // TODO: scan for magic number
			default: throw new Error("Unsupported ZIP Compression method " + meth);
		}
	
		/* [data descriptor] */
		var wrn = false;
		if(flags & 8) {
			crc32 = blob.read_shift(4);
			if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
			_csz = blob.read_shift(4);
			_usz = blob.read_shift(4);
		}
	
		if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
		if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
		//var _crc32 = CRC32.buf(data, 0);
		//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
		cfb_add(o, name, data, {unsafe: true, mt: date});
	}
	function write_zip(cfb, options) {
		var _opts = options || {};
		var out = [], cdirs = [];
		var o = new_buf(1);
		var method = (_opts.compression ? 8 : 0), flags = 0;
		var desc = false;
		if(desc) flags |= 8;
		var i = 0, j = 0;
	
		var start_cd = 0, fcnt = 0;
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		var crcs = [];
		var sz_cd = 0;
	
		for(i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
			var start = start_cd;
	
			/* TODO: CP437 filename */
			var namebuf = new_buf(fp.length);
			for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
			namebuf = namebuf.slice(0, namebuf.l);
			crcs[fcnt] = CRC32.buf(fi.content, 0);
	
			var outbuf = fi.content;
			if(method == 8) outbuf = _deflateRawSync(outbuf);
	
			/* local file header */
			o = new_buf(30);
			o.write_shift(4, 0x04034b50);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			/* TODO: last mod file time/date */
			if(fi.mt) write_dos_date(o, fi.mt);
			else o.write_shift(4, 0);
			o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
			o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
			o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
	
			start_cd += o.length;
			out.push(o);
			start_cd += namebuf.length;
			out.push(namebuf);
	
			/* TODO: extra fields? */
	
			/* TODO: encryption header ? */
	
			start_cd += outbuf.length;
			out.push(outbuf);
	
			/* data descriptor */
			if(flags & 8) {
				o = new_buf(12);
				o.write_shift(-4, crcs[fcnt]);
				o.write_shift(4, outbuf.length);
				o.write_shift(4, fi.content.length);
				start_cd += o.l;
				out.push(o);
			}
	
			/* central directory */
			o = new_buf(46);
			o.write_shift(4, 0x02014b50);
			o.write_shift(2, 0);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			o.write_shift(4, 0); /* TODO: last mod file time/date */
			o.write_shift(-4, crcs[fcnt]);
	
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, start);
	
			sz_cd += o.l;
			cdirs.push(o);
			sz_cd += namebuf.length;
			cdirs.push(namebuf);
			++fcnt;
		}
	
		/* end of central directory */
		o = new_buf(22);
		o.write_shift(4, 0x06054b50);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, fcnt);
		o.write_shift(2, fcnt);
		o.write_shift(4, sz_cd);
		o.write_shift(4, start_cd);
		o.write_shift(2, 0);
	
		return bconcat(([bconcat((out)), bconcat(cdirs), o]));
	}
	var ContentTypeMap = ({
		"htm": "text/html",
		"xml": "text/xml",
	
		"gif": "image/gif",
		"jpg": "image/jpeg",
		"png": "image/png",
	
		"mso": "application/x-mso",
		"thmx": "application/vnd.ms-officetheme",
		"sh33tj5": "application/octet-stream"
	});
	
	function get_content_type(fi, fp) {
		if(fi.ctype) return fi.ctype;
	
		var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
	
		if(fp) {
			m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
			if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
		}
	
		return "application/octet-stream";
	}
	
	/* 76 character chunks TODO: intertwine encoding */
	function write_base64_76(bstr) {
		var data = Base64_encode(bstr);
		var o = [];
		for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
		return o.join("\r\n") + "\r\n";
	}
	
	/*
	Rules for QP:
		- escape =## applies for all non-display characters and literal "="
		- space or tab at end of line must be encoded
		- \r\n newlines can be preserved, but bare \r and \n must be escaped
		- lines must not exceed 76 characters, use soft breaks =\r\n
	
	TODO: Some files from word appear to write line extensions with bare equals:
	
	```
	<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
	="70%"
	```
	*/
	function write_quoted_printable(text) {
		var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
			var w = c.charCodeAt(0).toString(16).toUpperCase();
			return "=" + (w.length == 1 ? "0" + w : w);
		});
	
		encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
	
		if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
		encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
	
		var o = [], split = encoded.split("\r\n");
		for(var si = 0; si < split.length; ++si) {
			var str = split[si];
			if(str.length == 0) { o.push(""); continue; }
			for(var i = 0; i < str.length;) {
				var end = 76;
				var tmp = str.slice(i, i + end);
				if(tmp.charAt(end - 1) == "=") end --;
				else if(tmp.charAt(end - 2) == "=") end -= 2;
				else if(tmp.charAt(end - 3) == "=") end -= 3;
				tmp = str.slice(i, i + end);
				i += end;
				if(i < str.length) tmp += "=";
				o.push(tmp);
			}
		}
	
		return o.join("\r\n");
	}
	function parse_quoted_printable(data) {
		var o = [];
	
		/* unify long lines */
		for(var di = 0; di < data.length; ++di) {
			var line = data[di];
			while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
			o.push(line);
		}
	
		/* decode */
		for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
		return s2a(o.join("\r\n"));
	}
	
	
	function parse_mime(cfb, data, root) {
		var fname = "", cte = "", ctype = "", fdata;
		var di = 0;
		for(;di < 10; ++di) {
			var line = data[di];
			if(!line || line.match(/^\s*$/)) break;
			var m = line.match(/^(.*?):\s*([^\s].*)$/);
			if(m) switch(m[1].toLowerCase()) {
				case "content-location": fname = m[2].trim(); break;
				case "content-type": ctype = m[2].trim(); break;
				case "content-transfer-encoding": cte = m[2].trim(); break;
			}
		}
		++di;
		switch(cte.toLowerCase()) {
			case 'base64': fdata = s2a(Base64_decode(data.slice(di).join(""))); break;
			case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
			default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
		}
		var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
		if(ctype) file.ctype = ctype;
	}
	
	function parse_mad(file, options) {
		if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
		var root = (options && options.root || "");
		// $FlowIgnore
		var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
		var di = 0, row = "";
	
		/* if root is not specified, scan for the common prefix */
		for(di = 0; di < data.length; ++di) {
			row = data[di];
			if(!/^Content-Location:/i.test(row)) continue;
			row = row.slice(row.indexOf("file"));
			if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
			if(row.slice(0, root.length) == root) continue;
			while(root.length > 0) {
				root = root.slice(0, root.length - 1);
				root = root.slice(0, root.lastIndexOf("/") + 1);
				if(row.slice(0,root.length) == root) break;
			}
		}
	
		var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
		if(!mboundary) throw new Error("MAD cannot find boundary");
		var boundary = "--" + (mboundary[1] || "");
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o);
		var start_di, fcnt = 0;
		for(di = 0; di < data.length; ++di) {
			var line = data[di];
			if(line !== boundary && line !== boundary + "--") continue;
			if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
			start_di = di;
		}
		return o;
	}
	
	function write_mad(cfb, options) {
		var opts = options || {};
		var boundary = opts.boundary || "SheetJS";
		boundary = '------=' + boundary;
	
		var out = [
			'MIME-Version: 1.0',
			'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
			'',
			'',
			''
		];
	
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		for(var i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length);
			fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
	
			/* Normalize filename */
			fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
				return "_x" + c.charCodeAt(0).toString(16) + "_";
			}).replace(/[\u0080-\uFFFF]/g, function(u) {
				return "_u" + u.charCodeAt(0).toString(16) + "_";
			});
	
			/* Extract content as binary string */
			var ca = fi.content;
			// $FlowIgnore
			var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
	
			/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
			var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
			for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
			var qp = dispcnt >= L * 4 / 5;
	
			out.push(boundary);
			out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
			out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
			out.push('Content-Type: ' + get_content_type(fi, fp));
			out.push('');
	
			out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
		}
		out.push(boundary + '--\r\n');
		return out.join("\r\n");
	}
	function cfb_new(opts) {
		var o = ({});
		init_cfb(o, opts);
		return o;
	}
	
	function cfb_add(cfb, name, content, opts) {
		var unsafe = opts && opts.unsafe;
		if(!unsafe) init_cfb(cfb);
		var file = !unsafe && CFB.find(cfb, name);
		if(!file) {
			var fpath = cfb.FullPaths[0];
			if(name.slice(0, fpath.length) == fpath) fpath = name;
			else {
				if(fpath.slice(-1) != "/") fpath += "/";
				fpath = (fpath + name).replace("//","/");
			}
			file = ({name: filename(name), type: 2});
			cfb.FileIndex.push(file);
			cfb.FullPaths.push(fpath);
			if(!unsafe) CFB.utils.cfb_gc(cfb);
		}
	file.content = (content);
		file.size = content ? content.length : 0;
		if(opts) {
			if(opts.CLSID) file.clsid = opts.CLSID;
			if(opts.mt) file.mt = opts.mt;
			if(opts.ct) file.ct = opts.ct;
		}
		return file;
	}
	
	function cfb_del(cfb, name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex.splice(j, 1);
			cfb.FullPaths.splice(j, 1);
			return true;
		}
		return false;
	}
	
	function cfb_mov(cfb, old_name, new_name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, old_name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex[j].name = filename(new_name);
			cfb.FullPaths[j] = new_name;
			return true;
		}
		return false;
	}
	
	function cfb_gc(cfb) { rebuild_cfb(cfb, true); }
	
	exports.find = find;
	exports.read = read;
	exports.parse = parse;
	exports.write = write;
	exports.writeFile = write_file;
	exports.utils = {
		cfb_new: cfb_new,
		cfb_add: cfb_add,
		cfb_del: cfb_del,
		cfb_mov: cfb_mov,
		cfb_gc: cfb_gc,
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		use_zlib: use_zlib,
		_deflateRaw: _deflate,
		_inflateRaw: _inflate,
		consts: consts
	};
	
	return exports;
	})();
	
	var _fs;
	if(true) try { _fs = __webpack_require__(226); } catch(e) {}
	
	/* normalize data for blob ctor */
	function blobify(data) {
		if(typeof data === "string") return s2ab(data);
		if(Array.isArray(data)) return a2u(data);
		return data;
	}
	/* write or download file */
	function write_dl(fname, payload, enc) {
		/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
		if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
		if(typeof Deno !== 'undefined') {
			/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */
			if(enc && typeof payload == "string") switch(enc) {
				case "utf8": payload = new TextEncoder(enc).encode(payload); break;
				case "binary": payload = s2ab(payload); break;
				/* TODO: binary equivalent */
				default: throw new Error("Unsupported encoding " + enc);
			}
			return Deno.writeFileSync(fname, payload);
		}
		var data = (enc == "utf8") ? utf8write(payload) : payload;
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
		if(typeof Blob !== 'undefined') {
			var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
	if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
	if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
			if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
				var url = URL.createObjectURL(blob);
	if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
				}
				var a = document.createElement("a");
				if(a.download != null) {
	a.download = fname; a.href = url; document.body.appendChild(a); a.click();
	document.body.removeChild(a);
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return url;
				}
			}
		}
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var out = File(fname); out.open("w"); out.encoding = "binary";
			if(Array.isArray(payload)) payload = a2s(payload);
			out.write(payload); out.close(); return payload;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("cannot save file " + fname);
	}
	
	/* read binary data from file */
	function read_binary(path) {
		if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
		if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var infile = File(path); infile.open("r"); infile.encoding = "binary";
			var data = infile.read(); infile.close();
			return data;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("Cannot access file " + path);
	}
	function keys(o) {
		var ks = Object.keys(o), o2 = [];
		for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
		return o2;
	}
	
	function evert_key(obj, key) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
	function datenum(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1462*24*60*60*1000;
		var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
		return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
	}
	var refdate = new Date();
	var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	var refoffset = refdate.getTimezoneOffset();
	function numdate(v) {
		var out = new Date();
		out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
		if (out.getTimezoneOffset() !== refoffset) {
			out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
		}
		return out;
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].slice(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	
	var good_pd_date_1 = new Date('2017-02-19T19:06:09.000Z');
	var good_pd_date = isNaN(good_pd_date_1.getFullYear()) ? new Date('2/19/17') : good_pd_date_1;
	var good_pd = good_pd_date.getFullYear() == 2017;
	/* parses a date as a local date */
	function parseDate(str, fixdate) {
		var d = new Date(str);
		if(good_pd) {
	if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
			return d;
		}
		if(str instanceof Date) return str;
		if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
			var s = d.getFullYear();
			if(str.indexOf("" + s) > -1) return d;
			d.setFullYear(d.getFullYear() + 100); return d;
		}
		var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
		var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
		if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
		return out;
	}
	
	function cc2str(arr, debomit) {
		if(has_buf && Buffer.isBuffer(arr)) {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
				if(arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
			}
			return arr.toString("binary");
		}
	
		if(typeof TextDecoder !== "undefined") try {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
				if(arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
			}
			var rev = {
				"\u20ac": "\x80", "\u201a": "\x82", "\u0192": "\x83", "\u201e": "\x84",
				"\u2026": "\x85", "\u2020": "\x86", "\u2021": "\x87", "\u02c6": "\x88",
				"\u2030": "\x89", "\u0160": "\x8a", "\u2039": "\x8b", "\u0152": "\x8c",
				"\u017d": "\x8e", "\u2018": "\x91", "\u2019": "\x92", "\u201c": "\x93",
				"\u201d": "\x94", "\u2022": "\x95", "\u2013": "\x96", "\u2014": "\x97",
				"\u02dc": "\x98", "\u2122": "\x99", "\u0161": "\x9a", "\u203a": "\x9b",
				"\u0153": "\x9c", "\u017e": "\x9e", "\u0178": "\x9f"
			};
			if(Array.isArray(arr)) arr = new Uint8Array(arr);
			return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) { return rev[c] || c; });
		} catch(e) {}
	
		var o = [];
		for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
		return o.join("");
	}
	
	function dup(o) {
		if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
		if(typeof o != 'object' || o == null) return o;
		if(o instanceof Date) return new Date(o.getTime());
		var out = {};
		for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
		return out;
	}
	
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	
	/* TODO: stress test */
	function fuzzynum(s) {
		var v = Number(s);
		if(!isNaN(v)) return isFinite(v) ? v : NaN;
		if(!/\d/.test(s)) return v;
		var wt = 1;
		var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
		if(!isNaN(v = Number(ss))) return v / wt;
		ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
		if(!isNaN(v = Number(ss))) return v / wt;
		return v;
	}
	var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
	function fuzzydate(s) {
		var o = new Date(s), n = new Date(NaN);
		var y = o.getYear(), m = o.getMonth(), d = o.getDate();
		if(isNaN(d)) return n;
		var lower = s.toLowerCase();
		if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
			lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
			if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
		} else if(lower.match(/[a-z]/)) return n;
		if(y < 0 || y > 8099) return n;
		if((m > 0 || d > 1) && y != 101) return o;
		if(s.match(/[^-0-9:,\/\\]/)) return n;
		return o;
	}
	
	var split_regex = (function() {
		var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
		return function split_regex(str, re, def) {
			if(safe_split_regex || typeof re == "string") return str.split(re);
			var p = str.split(re), o = [p[0]];
			for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
			return o;
		};
	})();
	function getdatastr(data) {
		if(!data) return null;
		if(data.content && data.type) return cc2str(data.content, true);
		if(data.data) return debom(data.data);
		if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
		if(data.asBinary) return debom(data.asBinary());
		if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		return null;
	}
	
	function getdatabin(data) {
		if(!data) return null;
		if(data.data) return char_codes(data.data);
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
		if(data._data && data._data.getContent) {
			var o = data._data.getContent();
			if(typeof o == "string") return char_codes(o);
			return Array.prototype.slice.call(o);
		}
		if(data.content && data.type) return data.content;
		return null;
	}
	
	function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }
	
	/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
	/* OASIS does not comment on filename case sensitivity */
	function safegetzipfile(zip, file) {
		var k = zip.FullPaths || keys(zip.files);
		var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
		for(var i=0; i<k.length; ++i) {
			var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
			if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
		}
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	function getzipstr(zip, file, safe) {
		if(!safe) return getdatastr(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipstr(zip, file); } catch(e) { return null; }
	}
	
	function getzipbin(zip, file, safe) {
		if(!safe) return getdatabin(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipbin(zip, file); } catch(e) { return null; }
	}
	
	function zipentries(zip) {
		var k = zip.FullPaths || keys(zip.files), o = [];
		for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
		return o.sort();
	}
	
	function zip_add_file(zip, path, content) {
		if(zip.FullPaths) {
			if(typeof content == "string") {
				var res;
				if(has_buf) res = Buffer_from(content);
				/* TODO: investigate performance in Edge 13 */
				//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
				else res = utf8decode(content);
				return CFB.utils.cfb_add(zip, path, res);
			}
			CFB.utils.cfb_add(zip, path, content);
		}
		else zip.file(path, content);
	}
	
	function zip_new() { return CFB.utils.cfb_new(); }
	
	function zip_read(d, o) {
		switch(o.type) {
			case "base64": return CFB.read(d, { type: "base64" });
			case "binary": return CFB.read(d, { type: "binary" });
			case "buffer": case "array": return CFB.read(d, { type: "buffer" });
		}
		throw new Error("Unrecognized type " + o.type);
	}
	
	function resolve_path(path, base) {
		if(path.charAt(0) == "/") return path.slice(1);
		var result = base.split('/');
		if(base.slice(-1) != "/") result.pop(); // folder path
		var target = path.split('/');
		while (target.length !== 0) {
			var step = target.shift();
			if (step === '..') result.pop();
			else if (step !== '.') result.push(step);
		}
		return result.join('/');
	}
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
	var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
	var tagregex = XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root, skip_LC) {
		var z = ({});
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.slice(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.slice(0,c).trim();
			while(cc.charCodeAt(c+1) == 32) ++c;
			quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
			v = cc.slice(c+1+quot, cc.length-quot);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) {
				if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
				z[q] = v;
				if(!skip_LC) z[q.toLowerCase()] = v;
			}
			else {
				var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
				if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
				z[k] = v;
				if(!skip_LC) z[k.toLowerCase()] = v;
			}
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	//var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		/* 22.4.2.4 bstr (Basic String) */
		var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
		return function unescapexml(text) {
			var s = text + '', i = s.indexOf("<![CDATA[");
			if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
			var j = s.indexOf("]]>");
			return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
	}
	function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }
	
	var htmlcharegex = /[\u0000-\u001f]/g;
	function escapehtml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
	}
	
	function escapexlml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); }
	
	function parsexmlbool(value) {
		switch(value) {
			case 1: case true: case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	}
	
	function utf8readb(data) {
		var out = new_raw_buf(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	}
	
	function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); }
	
	var utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	var utf8read = has_buf && (utf8readc(utf8corpus) == utf8reada(utf8corpus) && utf8readc || utf8readb(utf8corpus) == utf8reada(utf8corpus) && utf8readb) || utf8reada;
	
	var utf8write = has_buf ? function(data) { return Buffer_from(data, 'utf8').toString("binary"); } : function(orig) {
		var out = [], i = 0, c = 0, d = 0;
		while(i < orig.length) {
			c = orig.charCodeAt(i++);
			switch(true) {
				case c < 128: out.push(String.fromCharCode(c)); break;
				case c < 2048:
					out.push(String.fromCharCode(192 + (c >> 6)));
					out.push(String.fromCharCode(128 + (c & 63)));
					break;
				case c >= 55296 && c < 57344:
					c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
					out.push(String.fromCharCode(240 + ((d >>18) & 7)));
					out.push(String.fromCharCode(144 + ((d >>12) & 63)));
					out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
					out.push(String.fromCharCode(128 + (d & 63)));
					break;
				default:
					out.push(String.fromCharCode(224 + (c >> 12)));
					out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
					out.push(String.fromCharCode(128 + (c & 63)));
			}
		}
		return out.join("");
	};
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = ({});
		return function matchtag(f,g) {
			var t = f+"|"+(g||"");
			if(mtcache[t]) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
		};
	})();
	
	var htmldecode = (function() {
		var entities = [
			['nbsp', ' '], ['middot', '·'],
			['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
		].map(function(x) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
		return function htmldecode(str) {
			var o = str
					// Remove new lines and spaces from start of content
					.replace(/^[\t\n\r ]+/, "")
					// Remove new lines and spaces from end of content
					.replace(/[\t\n\r ]+$/,"")
					// Added line which removes any white space characters after and before html tags
					.replace(/>\s+/g,">").replace(/\s+</g,"<")
					// Replace remaining new lines and spaces with space
					.replace(/[\t\n\r ]+/g, " ")
					// Replace <br> tags with new lines
					.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
					// Strip HTML elements
					.replace(/<[^>]*>/g,"");
			for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
			return o;
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
	function parseVector(data, opts) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		var res = [];
		if(matches.length != h.size) {
			if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
			return res;
		}
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			if(v) res.push({v:utf8read(v[2]), t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }
	
	function write_vt(s, xlsx) {
		switch(typeof s) {
			case 'string':
				var o = writextag('vt:lpwstr', escapexml(s));
				if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
				return o;
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		/* duktape */
		if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
		throw new Error("Bad input format: expected Buffer or string");
	}
	/* UOS uses CJK in tags */
	var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
	//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	
	var XMLNS = ({
		CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
		CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
		EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
		CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
		RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
		TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	});
	
	var XMLNS_main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	var XLMLNS = ({
		'o':    'urn:schemas-microsoft-com:office:office',
		'x':    'urn:schemas-microsoft-com:office:excel',
		'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
		'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
		'mv':   'http://macVmlSchemaUri',
		'v':    'urn:schemas-microsoft-com:vml',
		'html': 'http://www.w3.org/TR/REC-html40'
	});
	function read_double_le(b, idx) {
		var s = 1 - 2 * (b[idx + 7] >>> 7);
		var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
		var m = (b[idx+6]&0x0f);
		for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
		if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
		if(e == 0) e = -1022;
		else { e -= 1023; m += Math.pow(2,52); }
		return s * Math.pow(2, e - 52) * m;
	}
	
	function write_double_le(b, v, idx) {
		var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
		var av = bs ? (-v) : v;
		if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
		else if(av == 0) e = m = 0;
		else {
			e = Math.floor(Math.log(av) / Math.LN2);
			m = av * Math.pow(2, 52 - e);
			if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
			else { m -= Math.pow(2,52); e+=1023; }
		}
		for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
		b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
		b[idx + 7] = (e >> 4) | bs;
	}
	
	var ___toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
	var __toBuffer = has_buf ? function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);} : ___toBuffer;
	
	var ___utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
	var __utf16le = has_buf ? function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; } : ___utf16le;
	
	var ___hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
	var __hexlify = has_buf ? function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); } : ___hexlify;
	
	var ___utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var __utf8 = has_buf ? function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); } : ___utf8;
	
	var ___lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpstr = ___lpstr;
	
	var ___cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __cpstr = ___cpstr;
	
	var ___lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpwstr = ___lpwstr;
	
	var ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
	var __lpp4 = ___lpp4;
	
	var ___8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
	var __8lpp4 = ___8lpp4;
	
	var ___double = function(b, idx) { return read_double_le(b, idx);};
	var __double = ___double;
	
	var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	
	if(has_buf) {
		__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
		__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
		__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	}
	
	/* from js-xls */
	function cpdoit() {
		__utf16le = function(b,s,e) { return $cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
		__utf8 = function(b,s,e) { return $cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
		__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
		__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
		__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
	}
	if(typeof $cptable !== 'undefined') cpdoit();
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			case 'wstr':
				if(typeof $cptable !== 'undefined') o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
				else return ReadShift.call(this, size, 'dbcs');
				size = 2 * size; break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
			/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
			case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
			/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
			case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case '_wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i < size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'cpstr':
				if(typeof $cptable !== 'undefined') {
					o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
					break;
				}
			/* falls through */
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4: case -4:
				if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
			case 8: case -8:
				if(t === 'f') {
					if(size == 8) oR = __double(this, this.l);
					else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
					this.l += 8; return oR;
				} else size = 8;
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
	var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
	var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };
	
	function WriteShift(t, val, f) {
		var size = 0, i = 0;
		if(f === 'dbcs') {
	for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else if(f === 'sbcs') {
			if(typeof $cptable !== 'undefined' && current_ansi == 874) {
				/* TODO: use tables directly, don't encode */
	for(i = 0; i != val.length; ++i) {
					var cppayload = $cptable.utils.encode(current_ansi, val.charAt(i));
					this[this.l + i] = cppayload[0];
				}
			} else {
	val = val.replace(/[^\x00-\x7F]/g, "_");
	for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
			}
			size = val.length;
		} else if(f === 'hex') {
			for(; i < t; ++i) {
	this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
			} return this;
		} else if(f === 'utf16le') {
	var end = Math.min(this.l + t, this.length);
				for(i = 0; i < Math.min(val.length, t); ++i) {
					var cc = val.charCodeAt(i);
					this[this.l++] = (cc & 0xff);
					this[this.l++] = (cc >> 8);
				}
				while(this.l < end) this[this.l++] = 0;
				return this;
		} else  switch(t) {
			case  1: size = 1; this[this.l] = val&0xFF; break;
			case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
			case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
			case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
			case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; __writeInt32LE(this, val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		if(!data) return;
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		var L = data.length, RT = 0, tgt = 0;
		while(data.l < L) {
			RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = has_buf ? 256 : 2048;
		var newblk = function ba_newblk(sz) {
			var o = (new_buf(sz));
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			if(!curbuf) return;
			if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return bconcat(bufs);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };
	
		return ({ next:next, push:push, end:end, _bufs:bufs });
	}
	
	function write_record(ba, type, payload, length) {
		var t = +type, l;
		if(isNaN(t)) return; // TODO: throw something here?
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt, opts) {
		var out = dup(cell);
		if(tgt.s) {
			if(out.cRel) out.c += tgt.s.c;
			if(out.rRel) out.r += tgt.s.r;
		} else {
			if(out.cRel) out.c += tgt.c;
			if(out.rRel) out.r += tgt.r;
		}
		if(!opts || opts.biff < 12) {
			while(out.c >= 0x100) out.c -= 0x100;
			while(out.r >= 0x10000) out.r -= 0x10000;
		}
		return out;
	}
	
	function shift_range_xls(cell, range, opts) {
		var out = dup(cell);
		out.s = shift_cell_xls(out.s, range.s, opts);
		out.e = shift_cell_xls(out.e, range.s, opts);
		return out;
	}
	
	function encode_cell_xls(c, biff) {
		if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
		if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
		var s = encode_cell(c);
		if(!c.cRel && c.cRel != null) s = fix_col(s);
		if(!c.rRel && c.rRel != null) s = fix_row(s);
		return s;
	}
	
	function encode_range_xls(r, opts) {
		if(r.s.r == 0 && !r.s.rRel) {
			if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
				return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
			}
		}
		if(r.s.c == 0 && !r.s.cRel) {
			if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
				return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
			}
		}
		return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
	}
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function decode_cell(cstr) {
		var R = 0, C = 0;
		for(var i = 0; i < cstr.length; ++i) {
			var cc = cstr.charCodeAt(i);
			if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
			else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
		}
		return { c: C - 1, r:R - 1 };
	}
	//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function encode_cell(cell) {
		var col = cell.c + 1;
		var s="";
		for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
		return s + (cell.r + 1);
	}
	function decode_range(range) {
		var idx = range.indexOf(":");
		if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
		return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
	}
	function encode_range(cs,ce) {
		if(typeof ce === 'undefined' || typeof ce === 'number') {
	return encode_range(cs.s, cs.e);
		}
	if(typeof cs !== 'string') cs = encode_cell((cs));
		if(typeof ce !== 'string') ce = encode_cell((ce));
	return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
		++i;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		var q = (cell.t == 'd' && v instanceof Date);
		if(cell.z != null) try { return (cell.w = SSF_format(cell.z, q ? datenum(v) : v)); } catch(e) { }
		try { return (cell.w = SSF_format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v, o) {
		if(cell == null || cell.t == null || cell.t == 'z') return "";
		if(cell.w !== undefined) return cell.w;
		if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
		if(cell.t == "e") return BErr[cell.v] || cell.v;
		if(v == undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_workbook(sheet, opts) {
		var n = opts && opts.sheet ? opts.sheet : "Sheet1";
		var sheets = {}; sheets[n] = sheet;
		return { SheetNames: [n], Sheets: sheets };
	}
	
	function sheet_add_aoa(_ws, data, opts) {
		var o = opts || {};
		var dense = _ws ? Array.isArray(_ws) : o.dense;
		if(DENSE != null && dense == null) dense = DENSE;
		var ws = _ws || (dense ? ([]) : ({}));
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
			if(!ws["!ref"]) ws["!ref"] = "A1:A1";
		}
		var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.s.c = _range.s.c;
			range.s.r = _range.s.r;
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) range.e.r = _R = _range.e.r + 1;
		}
		for(var R = 0; R != data.length; ++R) {
			if(!data[R]) continue;
			if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
			for(var C = 0; C != data[R].length; ++C) {
				if(typeof data[R][C] === 'undefined') continue;
				var cell = ({v: data[R][C] });
				var __R = _R + R, __C = _C + C;
				if(range.s.r > __R) range.s.r = __R;
				if(range.s.c > __C) range.s.c = __C;
				if(range.e.r < __R) range.e.r = __R;
				if(range.e.c < __C) range.e.c = __C;
				if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
				else {
					if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
					if(cell.v === null) {
						if(cell.f) cell.t = 'n';
						else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
						else if(!o.sheetStubs) continue;
						else cell.t = 'z';
					}
					else if(typeof cell.v === 'number') cell.t = 'n';
					else if(typeof cell.v === 'boolean') cell.t = 'b';
					else if(cell.v instanceof Date) {
						cell.z = o.dateNF || table_fmt[14];
						if(o.cellDates) { cell.t = 'd'; cell.w = SSF_format(cell.z, datenum(cell.v)); }
						else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF_format(cell.z, cell.v); }
					}
					else cell.t = 's';
				}
				if(dense) {
					if(!ws[__R]) ws[__R] = [];
					if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
					ws[__R][__C] = cell;
				} else {
					var cell_ref = encode_cell(({c:__C,r:__R}));
					if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
					ws[cell_ref] = cell;
				}
			}
		}
		if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
		return ws;
	}
	function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }
	
	function parse_Int32LE(data) {
		return data.read_shift(4, 'i');
	}
	function write_UInt32LE(x, o) {
		if (!o) o = new_buf(4);
		o.write_shift(4, x);
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
		o.write_shift(4, data.length);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.91 */
	//function parse_LPWideString(data) {
	//	var cchCharacters = data.read_shift(2);
	//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
	//}
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	function write_StrRun(run, o) {
		if (!o) o = new_buf(4);
		o.write_shift(2, run.ich || 0);
		o.write_shift(2, run.ifnt || 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = ({ t: str, h: str });
		if ((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = [{ ich: 0, ifnt: 0 }];
		//if((flags & 2) !== 0) { /* fExtStr */
		//	/* TODO: phonetic string */
		//}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
		o.write_shift(1, 0);
		write_XLWideString(str.t, o);
		return _null ? o.slice(0, o.l) : o;
	}
	/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
	var parse_BrtCommentText = parse_RichStr;
	function write_BrtCommentText(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
		o.write_shift(1, 1);
		write_XLWideString(str.t, o);
		o.write_shift(4, 1);
		write_StrRun({ ich: 0, ifnt: 0 }, o);
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) << 16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c: col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if (o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* Short XLSB Cell does not include column */
	function parse_XLSBShortCell(data) {
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c:-1, iStyleRef: iStyleRef };
	}
	function write_XLSBShortCell(cell, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* [MS-XLSB] 2.5.21 */
	var parse_XLSBCodeName = parse_XLWideString;
	var write_XLSBCodeName = write_XLWideString;
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(127); }
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.165 */
	var parse_XLNameWideString = parse_XLWideString;
	//var write_XLNameWideString = write_XLWideString;
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l + 4);
		var fX100 = (b[0] & 1), fInt = (b[0] & 2);
		data.l += 4;
		var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
		return fX100 ? (RK / 100) : RK;
	}
	function write_RkNumber(data, o) {
		if (o == null) o = new_buf(4);
		var fX100 = 0, fInt = 0, d100 = data * 100;
		if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
		else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
		if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
		else throw new Error("unsupported RkNumber " + data); // TODO
	}
	
	
	/* [MS-XLSB] 2.5.117 RfX */
	function parse_RfX(data ) {
		var cell = ({ s: {}, e: {} });
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	function write_RfX(r, o) {
		if (!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.153 UncheckedRfX */
	var parse_UncheckedRfX = parse_RfX;
	var write_UncheckedRfX = write_RfX;
	
	/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
	//function parse_UncheckedSqRfX(data) {
	//	var cnt = data.read_shift(4);
	//	var out = [];
	//	for(var i = 0; i < cnt; ++i) {
	//		var rng = parse_UncheckedRfX(data);
	//		out.push(encode_range(rng));
	//	}
	//	return out.join(",");
	//}
	//function write_UncheckedSqRfX(sqrfx) {
	//	var parts = sqrfx.split(/\s*,\s*/);
	//	var o = new_buf(4); o.write_shift(4, parts.length);
	//	var out = [o];
	//	parts.forEach(function(rng) {
	//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
	//	});
	//	return bconcat(out);
	//}
	
	/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
	/* TODO: error checking, NaN and Infinity values are not valid Xnum */
	function parse_Xnum(data) {
		if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
		return data.read_shift(8, 'f');
	}
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }
	
	/* [MS-XLSB] 2.4.324 BrtColor */
	function parse_BrtColor(data) {
		var out = {};
		var d = data.read_shift(1);
	
		//var fValidRGB = d & 1;
		var xColorType = d >>> 1;
	
		var index = data.read_shift(1);
		var nTS = data.read_shift(2, 'i');
		var bR = data.read_shift(1);
		var bG = data.read_shift(1);
		var bB = data.read_shift(1);
		data.l++; //var bAlpha = data.read_shift(1);
	
		switch (xColorType) {
			case 0: out.auto = 1; break;
			case 1:
				out.index = index;
				var icv = XLSIcv[index];
				/* automatic pseudo index 81 */
				if (icv) out.rgb = rgb2Hex(icv);
				break;
			case 2:
				/* if(!fValidRGB) throw new Error("invalid"); */
				out.rgb = rgb2Hex([bR, bG, bB]);
				break;
			case 3: out.theme = index; break;
		}
		if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
	
		return out;
	}
	function write_BrtColor(color, o) {
		if (!o) o = new_buf(8);
		if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
		if (color.index != null) {
			o.write_shift(1, 0x02);
			o.write_shift(1, color.index);
		} else if (color.theme != null) {
			o.write_shift(1, 0x06);
			o.write_shift(1, color.theme);
		} else {
			o.write_shift(1, 0x05);
			o.write_shift(1, 0);
		}
		var nTS = color.tint || 0;
		if (nTS > 0) nTS *= 32767;
		else if (nTS < 0) nTS *= 32768;
		o.write_shift(2, nTS);
		if (!color.rgb || color.theme != null) {
			o.write_shift(2, 0);
			o.write_shift(1, 0);
			o.write_shift(1, 0);
		} else {
			var rgb = (color.rgb || 'FFFFFF');
			if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
			o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
			o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
			o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
			o.write_shift(1, 0xFF);
		}
		return o;
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			fBold: d & 0x01,
			fItalic: d & 0x02,
			fUnderline: d & 0x04,
			fStrikeout: d & 0x08,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	function write_FontFlags(font, o) {
		if (!o) o = new_buf(2);
		var grbit =
			(font.italic ? 0x02 : 0) |
			(font.strike ? 0x08 : 0) |
			(font.outline ? 0x10 : 0) |
			(font.shadow ? 0x20 : 0) |
			(font.condense ? 0x40 : 0) |
			(font.extend ? 0x80 : 0);
		o.write_shift(1, grbit);
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-OLEDS] 2.3.1 and 2.3.2 */
	function parse_ClipboardFormatOrString(o, w) {
		// $FlowIgnore
		var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
		var m = o.read_shift(4);
		switch (m) {
			case 0x00000000: return "";
			case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
		}
		if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
		o.l -= 4;
		return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
	}
	function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
	function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }
	
	/* [MS-OLEPS] 2.2 PropertyType */
	// Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
	//var VT_EMPTY    = 0x0000;
	//var VT_NULL     = 0x0001;
	var VT_I2       = 0x0002;
	var VT_I4       = 0x0003;
	//var VT_R4       = 0x0004;
	//var VT_R8       = 0x0005;
	//var VT_CY       = 0x0006;
	//var VT_DATE     = 0x0007;
	//var VT_BSTR     = 0x0008;
	//var VT_ERROR    = 0x000A;
	var VT_BOOL     = 0x000B;
	var VT_VARIANT  = 0x000C;
	//var VT_DECIMAL  = 0x000E;
	//var VT_I1       = 0x0010;
	//var VT_UI1      = 0x0011;
	//var VT_UI2      = 0x0012;
	var VT_UI4      = 0x0013;
	//var VT_I8       = 0x0014;
	//var VT_UI8      = 0x0015;
	//var VT_INT      = 0x0016;
	//var VT_UINT     = 0x0017;
	var VT_LPSTR    = 0x001E;
	//var VT_LPWSTR   = 0x001F;
	var VT_FILETIME = 0x0040;
	var VT_BLOB     = 0x0041;
	//var VT_STREAM   = 0x0042;
	//var VT_STORAGE  = 0x0043;
	//var VT_STREAMED_Object  = 0x0044;
	//var VT_STORED_Object    = 0x0045;
	//var VT_BLOB_Object      = 0x0046;
	var VT_CF       = 0x0047;
	//var VT_CLSID    = 0x0048;
	//var VT_VERSIONED_STREAM = 0x0049;
	var VT_VECTOR   = 0x1000;
	var VT_VECTOR_VARIANT = 0x100C;
	var VT_VECTOR_LPSTR   = 0x101E;
	//var VT_ARRAY    = 0x2000;
	
	var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
	var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
	var VT_CUSTOM   = [VT_STRING, VT_USTR];
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Category', t: VT_STRING },
	0x03: { n: 'PresentationFormat', t: VT_STRING },
	0x04: { n: 'ByteCount', t: VT_I4 },
	0x05: { n: 'LineCount', t: VT_I4 },
	0x06: { n: 'ParagraphCount', t: VT_I4 },
	0x07: { n: 'SlideCount', t: VT_I4 },
	0x08: { n: 'NoteCount', t: VT_I4 },
	0x09: { n: 'HiddenCount', t: VT_I4 },
	0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
	0x0b: { n: 'ScaleCrop', t: VT_BOOL },
	0x0c: { n: 'HeadingPairs', t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ },
	0x0d: { n: 'TitlesOfParts', t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ },
	0x0e: { n: 'Manager', t: VT_STRING },
	0x0f: { n: 'Company', t: VT_STRING },
	0x10: { n: 'LinksUpToDate', t: VT_BOOL },
	0x11: { n: 'CharacterCount', t: VT_I4 },
	0x13: { n: 'SharedDoc', t: VT_BOOL },
	0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
	0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
	0x18: { n: 'DigSig', t: VT_BLOB },
	0x1A: { n: 'ContentType', t: VT_STRING },
	0x1B: { n: 'ContentStatus', t: VT_STRING },
	0x1C: { n: 'Language', t: VT_STRING },
	0x1D: { n: 'Version', t: VT_STRING },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Title', t: VT_STRING },
	0x03: { n: 'Subject', t: VT_STRING },
	0x04: { n: 'Author', t: VT_STRING },
	0x05: { n: 'Keywords', t: VT_STRING },
	0x06: { n: 'Comments', t: VT_STRING },
	0x07: { n: 'Template', t: VT_STRING },
	0x08: { n: 'LastAuthor', t: VT_STRING },
	0x09: { n: 'RevNumber', t: VT_STRING },
	0x0A: { n: 'EditTime', t: VT_FILETIME },
	0x0B: { n: 'LastPrinted', t: VT_FILETIME },
	0x0C: { n: 'CreatedDate', t: VT_FILETIME },
	0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
	0x0E: { n: 'PageCount', t: VT_I4 },
	0x0F: { n: 'WordCount', t: VT_I4 },
	0x10: { n: 'CharCount', t: VT_I4 },
	0x11: { n: 'Thumbnail', t: VT_CF },
	0x12: { n: 'Application', t: VT_STRING },
	0x13: { n: 'DocSecurity', t: VT_I4 },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
	0x0001: "US", // United States
	0x0002: "CA", // Canada
	0x0003: "", // Latin America (except Brazil)
	0x0007: "RU", // Russia
	0x0014: "EG", // Egypt
	0x001E: "GR", // Greece
	0x001F: "NL", // Netherlands
	0x0020: "BE", // Belgium
	0x0021: "FR", // France
	0x0022: "ES", // Spain
	0x0024: "HU", // Hungary
	0x0027: "IT", // Italy
	0x0029: "CH", // Switzerland
	0x002B: "AT", // Austria
	0x002C: "GB", // United Kingdom
	0x002D: "DK", // Denmark
	0x002E: "SE", // Sweden
	0x002F: "NO", // Norway
	0x0030: "PL", // Poland
	0x0031: "DE", // Germany
	0x0034: "MX", // Mexico
	0x0037: "BR", // Brazil
	0x003d: "AU", // Australia
	0x0040: "NZ", // New Zealand
	0x0042: "TH", // Thailand
	0x0051: "JP", // Japan
	0x0052: "KR", // Korea
	0x0054: "VN", // Viet Nam
	0x0056: "CN", // China
	0x005A: "TR", // Turkey
	0x0069: "JS", // Ramastan
	0x00D5: "DZ", // Algeria
	0x00D8: "MA", // Morocco
	0x00DA: "LY", // Libya
	0x015F: "PT", // Portugal
	0x0162: "IS", // Iceland
	0x0166: "FI", // Finland
	0x01A4: "CZ", // Czech Republic
	0x0376: "TW", // Taiwan
	0x03C1: "LB", // Lebanon
	0x03C2: "JO", // Jordan
	0x03C3: "SY", // Syria
	0x03C4: "IQ", // Iraq
	0x03C5: "KW", // Kuwait
	0x03C6: "SA", // Saudi Arabia
	0x03CB: "AE", // United Arab Emirates
	0x03CC: "IL", // Israel
	0x03CE: "QA", // Qatar
	0x03D5: "IR", // Iran
	0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	/* [MS-XLSB] 2.5.75 Icv */
	var _XLSIcv =  rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Overridable Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Other entries to appease BIFF8/12 */
		0xFFFFFF, /* 0x40 icvForeground ?? */
		0x000000, /* 0x41 icvBackground ?? */
		0x000000, /* 0x42 icvFrame ?? */
		0x000000, /* 0x43 icv3D ?? */
		0x000000, /* 0x44 icv3DText ?? */
		0x000000, /* 0x45 icv3DHilite ?? */
		0x000000, /* 0x46 icv3DShadow ?? */
		0x000000, /* 0x47 icvHilite ?? */
		0x000000, /* 0x48 icvCtlText ?? */
		0x000000, /* 0x49 icvCtlScrl ?? */
		0x000000, /* 0x4A icvCtlInv ?? */
		0x000000, /* 0x4B icvCtlBody ?? */
		0x000000, /* 0x4C icvCtlFrame ?? */
		0x000000, /* 0x4D icvCtlFore ?? */
		0x000000, /* 0x4E icvCtlBack ?? */
		0x000000, /* 0x4F icvCtlNeutral */
		0x000000, /* 0x50 icvInfoBk ?? */
		0x000000 /* 0x51 icvInfoText ?? */
	]);
	var XLSIcv = dup(_XLSIcv);
	
	/* [MS-XLSB] 2.5.97.2 */
	var BErr = {
	0x00: "#NULL!",
	0x07: "#DIV/0!",
	0x0F: "#VALUE!",
	0x17: "#REF!",
	0x1D: "#NAME?",
	0x24: "#NUM!",
	0x2A: "#N/A",
	0x2B: "#GETTING_DATA",
	0xFF: "#WTF?"
	};
	//var RBErr = evert_num(BErr);
	var RBErr = {
		"#NULL!":        0x00,
		"#DIV/0!":       0x07,
		"#VALUE!":       0x0F,
		"#REF!":         0x17,
		"#NAME?":        0x1D,
		"#NUM!":         0x24,
		"#N/A":          0x2A,
		"#GETTING_DATA": 0x2B,
		"#WTF?":         0xFF
	};
	
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type/*{[string]:string}*/ = ({
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
		"application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
		"application/vnd.ms-excel.worksheet": "sheets",
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Chartsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
		"application/vnd.ms-excel.chartsheet": "charts",
	
		/* Macrosheet */
		"application/vnd.ms-excel.macrosheet+xml": "macros",
		"application/vnd.ms-excel.macrosheet": "macros",
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* Dialogsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
		"application/vnd.ms-excel.dialogsheet": "dialogs",
	
		/* Shared Strings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
		"application/vnd.ms-excel.sharedStrings": "strs",
	
		/* Styles */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
		"application/vnd.ms-excel.styles": "styles",
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
	
		/* Comments */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
		"application/vnd.ms-excel.comments": "comments",
		"application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
		"application/vnd.ms-excel.person+xml": "people",
	
		/* Metadata (Stock/Geography and Dynamic Array) */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
		"application/vnd.ms-excel.sheetMetadata": "metadata",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Chart Objects */
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	
		/* Chart Colors */
		"application/vnd.ms-office.chartcolorstyle+xml": "TODO",
	
		/* Chart Style */
		"application/vnd.ms-office.chartstyle+xml": "TODO",
	
		/* Chart Advanced */
		"application/vnd.ms-office.chartex+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "links",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Theme Override */
		"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "TODO",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		/* Image */
		"image/png": "TODO",
	
		"sheet": "js"
	});
	
	var CT_LIST = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			comments: { /* Comments */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
				xlsb: "application/vnd.ms-excel.comments"
			},
			sheets: { /* Worksheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			charts: { /* Chartsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
				xlsb: "application/vnd.ms-excel.chartsheet"
			},
			dialogs: { /* Dialogsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
				xlsb: "application/vnd.ms-excel.dialogsheet"
			},
			macros: { /* Macrosheet (Excel 4.0 Macros) */
				xlsx: "application/vnd.ms-excel.macrosheet+xml",
				xlsb: "application/vnd.ms-excel.macrosheet"
			},
			metadata: { /* Metadata (Stock/Geography and Dynamic Array) */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
				xlsb: "application/vnd.ms-excel.sheetMetadata"
			},
			styles: { /* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
	};
	
	function new_ct() {
		return ({
			workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
			rels:[], strs:[], comments:[], threadedcomments:[], links:[],
			coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
			calcchains:[], vba: [], drawings: [], metadata: [], people:[],
			TODO:[], xmlns: "" });
	}
	
	function parse_ct(data) {
		var ct = new_ct();
		if(!data || !data.match) return ct;
		var ctext = {};
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	function write_ct(ct, opts) {
		var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);
	
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = writextag('Types', null, {
			'xmlns': XMLNS.CT,
			'xmlns:xsd': XMLNS.xsd,
			'xmlns:xsi': XMLNS.xsi
		});
	
		o = o.concat([
			['xml', 'application/xml'],
			['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
			['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
			['data', 'application/vnd.openxmlformats-officedocument.model+data'],
			/* from test files */
			['bmp', 'image/bmp'],
			['png', 'image/png'],
			['gif', 'image/gif'],
			['emf', 'image/x-emf'],
			['wmf', 'image/x-wmf'],
			['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
			['tif', 'image/tiff'], ['tiff', 'image/tiff'],
			['pdf', 'application/pdf'],
			['rels', 'application/vnd.openxmlformats-package.relationships+xml']
		].map(function(x) {
			return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
		}));
	
		/* only write first instance */
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			}
		};
	
		/* book type-specific */
		var f2 = function(w) {
			(ct[w]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			});
		};
	
		/* standard type */
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
	
		f1('workbooks');
		f2('sheets');
		f2('charts');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		f3('vba');
		f3('comments');
		f3('threadedcomments');
		f3('drawings');
		f2('metadata');
		f3('people');
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3 Relationships */
	var RELS = ({
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
		VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
		XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
		XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
		XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
		CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
		CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
		CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
		CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
		EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
		CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
		SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
		STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
		THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
		CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
		CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
		CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
		WS: [
			"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
			"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
		],
		DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
		MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
		IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
		DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
		XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
		TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
		PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
		VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
	});
	
	
	/* 9.3.3 Representing Relationships */
	function get_rels_path(file) {
		var n = file.lastIndexOf("/");
		return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
	}
	
	function parse_rels(data, currentFilePath) {
		var rels = {"!id":{}};
		if (!data) return rels;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var hash = {};
	
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	
	/* TODO */
	function write_rels(rels) {
		var o = [XML_HEADER, writextag('Relationships', null, {
			//'xmlns:ns0': XMLNS.RELS,
			'xmlns': XMLNS.RELS
		})];
		keys(rels['!id']).forEach(function(rid) {
			o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	function add_rels(rels, rId, f, type, relobj, targetmode) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		if(!rels['!idx']) rels['!idx'] = 1;
		if(rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId){/* empty */}
		rels['!idx'] = rId + 1;
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(targetmode) relobj.TargetMode = targetmode;
		else if([RELS.HLINK, RELS.XPATH, RELS.XMISS].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
		return rId;
	}
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	function parse_manifest(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0], false);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: if(opts && opts.WTF) throw Rn;
		}
	}
	
	function write_manifest(manifest) {
		var o = [XML_HEADER];
		o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
		o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
		for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
		o.push('</manifest:manifest>');
		return o.join("");
	}
	
	/* Part 3 Section 6 Metadata Manifest File */
	function write_rdf_type(file, res, tag) {
		return [
			'  <rdf:Description rdf:about="' + file + '">\n',
			'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf_has(base, file) {
		return [
			'  <rdf:Description rdf:about="' + base + '">\n',
			'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf(rdf) {
		var o = [XML_HEADER];
		o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
		for(var i = 0; i != rdf.length; ++i) {
			o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
			o.push(write_rdf_has("",rdf[i][0]));
		}
		o.push(write_rdf_type("","Document", "pkg"));
		o.push('</rdf:RDF>');
		return o.join("");
	}
	/* TODO: pull properties */
	function write_meta_ods() {
		return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	}
	
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
		data = utf8read(data);
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
		}
	
		return p;
	}
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		g = escapexml(g);
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, _opts) {
		var opts = _opts || {};
		var o = [XML_HEADER, writextag('cp:coreProperties', null, {
			//'xmlns': XMLNS.CORE_PROPS,
			'xmlns:cp': XMLNS.CORE_PROPS,
			'xmlns:dc': XMLNS.dc,
			'xmlns:dcterms': XMLNS.dcterms,
			'xmlns:dcmitype': XMLNS.dcmitype,
			'xmlns:xsi': XMLNS.xsi
		})], p = {};
		if(!cp && !opts.Props) return o.join("");
	
		if(cp) {
			if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
			if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		}
	
		for(var i = 0; i != CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
			if(v === true) v = "1";
			else if(v === false) v = "0";
			else if(typeof v == "number") v = String(v);
			if(v != null) cp_doit(f[0], v, null, o, p);
		}
		if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	var PseudoPropsPairs = [
		"Worksheets",  "SheetNames",
		"NamedRanges", "DefinedNames",
		"Chartsheets", "ChartNames"
	];
	function load_props_pairs(HP, TOP, props, opts) {
		var v = [];
		if(typeof HP == "string") v = parseVector(HP, opts);
		else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
		var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
		var idx = 0, len = 0;
		if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
			len = +(v[i+1].v);
			switch(v[i].v) {
				case "Worksheets":
				case "工作表":
				case "Листы":
				case "أوراق العمل":
				case "ワークシート":
				case "גליונות עבודה":
				case "Arbeitsblätter":
				case "Çalışma Sayfaları":
				case "Feuilles de calcul":
				case "Fogli di lavoro":
				case "Folhas de cálculo":
				case "Planilhas":
				case "Regneark":
				case "Hojas de cálculo":
				case "Werkbladen":
					props.Worksheets = len;
					props.SheetNames = parts.slice(idx, idx + len);
					break;
	
				case "Named Ranges":
				case "Rangos con nombre":
				case "名前付き一覧":
				case "Benannte Bereiche":
				case "Navngivne områder":
					props.NamedRanges = len;
					props.DefinedNames = parts.slice(idx, idx + len);
					break;
	
				case "Charts":
				case "Diagramme":
					props.Chartsheets = len;
					props.ChartNames = parts.slice(idx, idx + len);
					break;
			}
			idx += len;
		}
	}
	
	function parse_ext_props(data, p, opts) {
		var q = {}; if(!p) p = {};
		data = utf8read(data);
	
		EXT_PROPS.forEach(function(f) {
			var xml = (data.match(matchtag(f[0]))||[])[1];
			switch(f[2]) {
				case "string": if(xml) p[f[1]] = unescapexml(xml); break;
				case "bool": p[f[1]] = xml === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
	
		return p;
	}
	
	function write_ext_props(cp) {
		var o = [], W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (writextag('Properties', null, {
			'xmlns': XMLNS.EXT_PROPS,
			'xmlns:vt': XMLNS.vt
		}));
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = escapexml(String(cp[f[1]])); break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name = "";
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties': break;
				case '<property': name = unescapexml(y.name); break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].slice(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text);
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = parseDate(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(type.slice(-1) == '/') break;
							if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.slice(0,2) === "</") {/* empty */
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	function write_cust_props(cp) {
		var o = [XML_HEADER, writextag('Properties', null, {
			'xmlns': XMLNS.CUST_PROPS,
			'xmlns:vt': XMLNS.vt
		})];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			o[o.length] = (writextag('property', write_vt(cp[k], true), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': escapexml(k)
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* Common Name -> XLML Name */
	var XLMLDocPropsMap = {
		Title: 'Title',
		Subject: 'Subject',
		Author: 'Author',
		Keywords: 'Keywords',
		Comments: 'Description',
		LastAuthor: 'LastAuthor',
		RevNumber: 'Revision',
		Application: 'AppName',
		/* TotalTime: 'TotalTime', */
		LastPrinted: 'LastPrinted',
		CreatedDate: 'Created',
		ModifiedDate: 'LastSaved',
		/* Pages */
		/* Words */
		/* Characters */
		Category: 'Category',
		/* PresentationFormat */
		Manager: 'Manager',
		Company: 'Company',
		/* Guid */
		/* HyperlinkBase */
		/* Bytes */
		/* Lines */
		/* Paragraphs */
		/* CharactersWithSpaces */
		AppVersion: 'Version',
	
		ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
		Identifier: 'Identifier', /* NOTE: missing from schema */
		Language: 'Language' /* NOTE: missing from schema */
	};
	var evert_XLMLDPM;
	
	function xlml_set_prop(Props, tag, val) {
		if(!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
		tag = evert_XLMLDPM[tag] || tag;
		Props[tag] = val;
	}
	
	function xlml_write_docprops(Props, opts) {
		var o = [];
		keys(XLMLDocPropsMap).map(function(m) {
			for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
			for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
			throw m;
		}).forEach(function(p) {
			if(Props[p[1]] == null) return;
			var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
			switch(p[2]) {
				case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
			}
			if(typeof m == 'number') m = String(m);
			else if(m === true || m === false) { m = m ? "1" : "0"; }
			else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
			o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
		});
		return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
	}
	function xlml_write_custprops(Props, Custprops) {
		var BLACKLIST = ["Worksheets","SheetNames"];
		var T = 'CustomDocumentProperties';
		var o = [];
		if(Props) keys(Props).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
			for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
			for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
			for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;
	
			var m = Props[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		if(Custprops) keys(Custprops).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
			if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
			var m = Custprops[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
	}
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	function write_FILETIME(time) {
		var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
		var t = date.getTime() / 1000 + 11644473600;
		var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
		l *= 1e7; h *= 1e7;
		var w = (l / Math.pow(2,32)) | 0;
		if(w > 0) { l = l % Math.pow(2,32); h += w; }
		var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var start = blob.l;
		var str = blob.read_shift(0, 'lpstr-cp');
		if(pad) while((blob.l - start) & 3) ++blob.l;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
	function parse_VtVecLpwstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) {
			var start = blob.l;
			ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
			if((blob.l - start) & 0x02) blob.l += 2;
		}
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
		return ret;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var start = blob.l;
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = ({});
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
			if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		blob.l += size;
		if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size + 3 - (o.Size - 1) % 4;
		return o;
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
			case 0x101E /*VT_VECTOR|VT_LPSTR*/:
			case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
				return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	function write_TypedPropertyValue(type, value) {
		var o = new_buf(4), p = new_buf(4);
		o.write_shift(4, type == 0x50 ? 0x1F : type);
		switch(type) {
			case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
			case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
			case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
			case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
			case 0x1F /*VT_LPWSTR*/:
			case 0x50 /*VT_STRING*/:
	p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				p.write_shift(4, value.length + 1);
				p.write_shift(0, value, "dbcs");
				while(p.l != p.length) p.write_shift(1, 0);
				break;
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
		}
		return bconcat([o, p]);
	}
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj = ({});
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		Props.sort(function(x,y) { return x[1] - y[1]; });
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 874:
					case 932:
					case 936:
					case 949:
					case 950:
					case 1250:
					case 1251:
					case 1253:
					case 1254:
					case 1255:
					case 1256:
					case 1257:
					case 1258:
					case 10000:
					case 1200:
					case 1201:
					case 1252:
					case 65000: case -536:
					case 65001: case -535:
						set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ]; //.concat(PseudoPropsPairs);
	function guess_property_type(val) {
		switch(typeof val) {
			case "boolean": return 0x0B;
			case "number": return ((val|0)==val) ? 0x03 : 0x05;
			case "string": return 0x1F;
			case "object": if(val instanceof Date) return 0x40; break;
		}
		return -1;
	}
	function write_PropertySet(entries, RE, PIDSI) {
		var hdr = new_buf(8), piao = [], prop = [];
		var sz = 8, i = 0;
	
		var pr = new_buf(8), pio = new_buf(8);
		pr.write_shift(4, 0x0002);
		pr.write_shift(4, 0x04B0);
		pio.write_shift(4, 0x0001);
		prop.push(pr); piao.push(pio);
		sz += 8 + pr.length;
	
		if(!RE) {
			pio = new_buf(8);
			pio.write_shift(4, 0);
			piao.unshift(pio);
	
			var bufs = [new_buf(4)];
			bufs[0].write_shift(4, entries.length);
			for(i = 0; i < entries.length; ++i) {
				var value = entries[i][0];
				pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				pr.write_shift(4, i+2);
				pr.write_shift(4, value.length + 1);
				pr.write_shift(0, value, "dbcs");
				while(pr.l != pr.length) pr.write_shift(1, 0);
				bufs.push(pr);
			}
			pr = bconcat(bufs);
			prop.unshift(pr);
			sz += 8 + pr.length;
		}
	
		for(i = 0; i < entries.length; ++i) {
			if(RE && !RE[entries[i][0]]) continue;
			if(XLSPSSkip.indexOf(entries[i][0]) > -1 || PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
			if(entries[i][1] == null) continue;
	
			var val = entries[i][1], idx = 0;
			if(RE) {
				idx = +RE[entries[i][0]];
				var pinfo = (PIDSI)[idx];
				if(pinfo.p == "version" && typeof val == "string") {
	var arr = val.split(".");
					val = ((+arr[0])<<16) + ((+arr[1])||0);
				}
				pr = write_TypedPropertyValue(pinfo.t, val);
			} else {
				var T = guess_property_type(val);
				if(T == -1) { T = 0x1F; val = String(val); }
				pr = write_TypedPropertyValue(T, val);
			}
			prop.push(pr);
	
			pio = new_buf(8);
			pio.write_shift(4, !RE ? 2+i : idx);
			piao.push(pio);
	
			sz += 8 + pr.length;
		}
	
		var w = 8 * (prop.length + 1);
		for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
		hdr.write_shift(4, sz);
		hdr.write_shift(4, prop.length);
		return bconcat([hdr].concat(piao).concat(prop));
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI, clsid) {
		var blob = file.content;
		if(!blob) return ({});
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
		blob.chk('feff', 'Byte Order: ');
	
		/*var vers = */blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		var CLSID = blob.read_shift(16);
		if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = ({ SystemIdentifier: SystemIdentifier });
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(Offset1 - blob.l == 2) blob.l += 2;
		if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
		var hdr = new_buf(entries2 ? 68 : 48);
		var bufs = [hdr];
		hdr.write_shift(2, 0xFFFE);
		hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
		hdr.write_shift(4, 0x32363237);
		hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
		hdr.write_shift(4, (entries2 ? 2 : 1));
		hdr.write_shift(16, clsid, "hex");
		hdr.write_shift(4, (entries2 ? 68 : 48));
		var ps0 = write_PropertySet(entries, RE, PIDSI);
		bufs.push(ps0);
	
		if(entries2) {
			var ps1 = write_PropertySet(entries2, null, null);
			hdr.write_shift(16, clsid2, "hex");
			hdr.write_shift(4, 68 + ps0.length);
			bufs.push(ps1);
		}
		return bconcat(bufs);
	}
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	function write_Bes(v, t, o) {
		if(!o) o = new_buf(2);
		o.write_shift(1, ((t == 'e') ? +v : +!!v));
		o.write_shift(1, ((t == 'e') ? 1 : 0));
		return o;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
		var encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(!opts || opts.biff == 8 ) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { encoding = 'dbcs-cont'; }
		} else if(opts.biff == 12) {
			encoding = 'wstr';
		}
		if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun = 0, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	function write_XLUnicodeRichExtendedString(xlstr) {
		var str = (xlstr.t||""), nfmts = 1;
	
		var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
		hdr.write_shift(2, str.length);
		hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
		if(nfmts > 1) hdr.write_shift(2, nfmts);
	
		var otext = new_buf(2 * str.length);
		otext.write_shift(2 * str.length, str, 'utf16le');
	
		var out = [hdr, otext];
	
		return bconcat(out);
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
			if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
		}
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
	}
	/* TODO: BIFF5 and lower, codepage awareness */
	function write_XLUnicodeString(str, opts, o) {
		if(!o) o = new_buf(3 + 2 * str.length);
		o.write_shift(2, str.length);
		o.write_shift(1, 1);
		o.write_shift(31, str, 'utf16le');
		return o;
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	function parse_ControlInfo(blob) {
		var flags = blob.read_shift(1);
		blob.l++;
		var accel = blob.read_shift(2);
		blob.l += 2;
		return [flags, accel];
	}
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	function parse_URLMoniker(blob) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	}
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	function parse_FileMoniker(blob) {
		var cAnti = blob.read_shift(2);
		var preamble = ""; while(cAnti-- > 0) preamble += "../";
		var ansiPath = blob.read_shift(0, 'lpstr-ansi');
		blob.l += 2; //var endServer = blob.read_shift(2);
		if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
		var sz = blob.read_shift(4);
		if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
		var bytes = blob.read_shift(4);
		if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
		var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
		return preamble + unicodePath;
	}
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	function parse_HyperlinkMoniker(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw new Error("Unsupported Moniker " + clsid);
		}
	}
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	function parse_HyperlinkString(blob) {
		var len = blob.read_shift(4);
		var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
		return o;
	}
	function write_HyperlinkString(str, o) {
		if(!o) o = new_buf(6 + str.length * 2);
		o.write_shift(4, 1 + str.length);
		for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
	function parse_Hyperlink(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
		blob.l = end;
		var target = targetFrameName||moniker||oleMoniker||"";
		if(target && Loc) target+="#"+Loc;
		if(!target) target = "#" + Loc;
		if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
		var out = ({Target:target});
		if(guid) out.guid = guid;
		if(fileTime) out.time = fileTime;
		if(displayName) out.Tooltip = displayName;
		return out;
	}
	function write_Hyperlink(hl) {
		var out = new_buf(512), i = 0;
		var Target = hl.Target;
		if(Target.slice(0,7) == "file://") Target = Target.slice(7);
		var hashidx = Target.indexOf("#");
		var F = hashidx > -1 ? 0x1f : 0x17;
		switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
		out.write_shift(4,2); out.write_shift(4, F);
		var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
		if(F == 0x1C) {
			Target = Target.slice(1);
			write_HyperlinkString(Target, out);
		} else if(F & 0x02) {
			data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
			out.write_shift(4, 2*(Pretarget.length + 1));
			for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
			out.write_shift(2, 0);
			if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
		} else {
			data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var P = 0;
			while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
			out.write_shift(2, P);
			out.write_shift(4, Target.length - 3 * P + 1);
			for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
			out.write_shift(1, 0);
			out.write_shift(2, 0xFFFF);
			out.write_shift(2, 0xDEAD);
			for(i = 0; i < 6; ++i) out.write_shift(4, 0);
		}
		return out.slice(0, out.l);
	}
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* [MS-XLS] 2.5.19 */
	function parse_XLSCell(blob) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return ({r:rw, c:col, ixfe:ixfe});
	}
	function write_XLSCell(R, C, ixfe, o) {
		if(!o) o = new_buf(6);
		o.write_shift(2, R);
		o.write_shift(2, C);
		o.write_shift(2, ixfe||0);
		return o;
	}
	
	/* [MS-XLS] 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* [MS-XLS] 2.5.344 */
	function parse_XTI(blob, length, opts) {
		var w = opts.biff > 8 ? 4 : 2;
		var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* [MS-XLS] 2.5.218 */
	function parse_RkRec(blob) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		return [ixfe, RK];
	}
	
	/* [MS-XLS] 2.5.1 */
	function parse_AddinUdf(blob, length, opts) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length, opts);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
		blob.l += cb;
		return udfName;
	}
	
	/* [MS-XLS] 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	function write_Ref8U(r, o) {
		if(!o) o = new_buf(8);
		o.write_shift(2, r.s.r);
		o.write_shift(2, r.e.r);
		o.write_shift(2, r.s.c);
		o.write_shift(2, r.e.c);
		return o;
	}
	
	/* [MS-XLS] 2.5.211 */
	function parse_RefU(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* [MS-XLS] 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* [MS-XLS] 2.5.143 */
	function parse_FtCmo(blob) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* [MS-XLS] 2.5.149 */
	function parse_FtNts(blob) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* [MS-XLS] 2.5.142 */
	function parse_FtCf(blob) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
	function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
	var FtTab = {
	0x00: parse_FtSkip,      /* FtEnd */
	0x04: parse_FtSkip,      /* FtMacro */
	0x05: parse_FtSkip,      /* FtButton */
	0x06: parse_FtSkip,      /* FtGmo */
	0x07: parse_FtCf,        /* FtCf */
	0x08: parse_FtSkip,      /* FtPioGrbit */
	0x09: parse_FtSkip,      /* FtPictFmla */
	0x0A: parse_FtSkip,      /* FtCbls */
	0x0B: parse_FtSkip,      /* FtRbo */
	0x0C: parse_FtSkip,      /* FtSbs */
	0x0D: parse_FtNts,       /* FtNts */
	0x0E: parse_FtSkip,      /* FtSbsFmla */
	0x0F: parse_FtSkip,      /* FtGboData */
	0x10: parse_FtSkip,      /* FtEdoData */
	0x11: parse_FtSkip,      /* FtRboData */
	0x12: parse_FtSkip,      /* FtCblsData */
	0x13: parse_FtSkip,      /* FtLbsData */
	0x14: parse_FtSkip,      /* FtCblsFmla */
	0x15: parse_FtCmo
	};
	function parse_FtArray(blob, length) {
		var tgt = blob.l + length;
		var fts = [];
		while(blob.l < tgt) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, tgt - blob.l));
			} catch(e) { blob.l = tgt; return fts; }
		}
		if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
		return fts;
	}
	
	/* --- 2.4 Records --- */
	
	/* [MS-XLS] 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {BIFFVer:0, dt:0};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0400: /* BIFF4 */
			case 0x0300: /* BIFF3 */
			case 0x0200: /* BIFF2 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
		}
	
		blob.read_shift(length);
		return o;
	}
	function write_BOF(wb, t, o) {
		var h = 0x0600, w = 16;
		switch(o.bookType) {
			case 'biff8': break;
			case 'biff5': h = 0x0500; w = 8; break;
			case 'biff4': h = 0x0004; w = 6; break;
			case 'biff3': h = 0x0003; w = 6; break;
			case 'biff2': h = 0x0002; w = 4; break;
			case 'xla': break;
			default: throw new Error("unsupported BIFF version");
		}
		var out = new_buf(w);
		out.write_shift(2, h);
		out.write_shift(2, t);
		if(w > 4) out.write_shift(2, 0x7262);
		if(w > 6) out.write_shift(2, 0x07CD);
		if(w > 8) {
			out.write_shift(2, 0xC009);
			out.write_shift(2, 0x0001);
			out.write_shift(2, 0x0706);
			out.write_shift(2, 0x0000);
		}
		return out;
	}
	
	
	/* [MS-XLS] 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		if((blob.read_shift(2))!==0x04b0){/* empty */}
		return 0x04b0;
	}
	
	
	/* [MS-XLS] 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString2(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	function write_WriteAccess(s, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(b8 ? 112 : 54);
		o.write_shift(opts.biff == 8 ? 2 : 1, 7);
		if(b8) o.write_shift(1, 0);
		o.write_shift(4, 0x33336853);
		o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
		while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
		return o;
	}
	
	/* [MS-XLS] 2.4.351 */
	function parse_WsBool(blob, length, opts) {
		var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
		return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
	}
	
	/* [MS-XLS] 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) & 0x03;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	function write_BoundSheet8(data, opts) {
		var w = (!opts || opts.biff >= 8 ? 2 : 1);
		var o = new_buf(8 + w * data.name.length);
		o.write_shift(4, data.pos);
		o.write_shift(1, data.hs || 0);
		o.write_shift(1, data.dt);
		o.write_shift(1, data.name.length);
		if(opts.biff >= 8) o.write_shift(1, 1);
		o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
		var out = o.slice(0, o.l);
		out.l = o.l; return out;
	}
	
	/* [MS-XLS] 2.4.265 TODO */
	function parse_SST(blob, length) {
		var end = blob.l + length;
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = ([]);
		for(var i = 0; i != ucnt && blob.l < end; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	function write_SST(sst, opts) {
		var header = new_buf(8);
		header.write_shift(4, sst.Count);
		header.write_shift(4, sst.Unique);
		var strs = [];
		for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
		var o = bconcat([header].concat(strs));
	o.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
		return o;
	}
	
	/* [MS-XLS] 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
	function parse_Row(blob) {
		var z = ({});
		z.r = blob.read_shift(2);
		z.c = blob.read_shift(2);
		z.cnt = blob.read_shift(2) - z.c;
		var miyRw = blob.read_shift(2);
		blob.l += 4; // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.l += 3; // reserved(8), ixfe(12), flags(4)
		if(flags & 0x07) z.level = flags & 0x07;
		// collapsed: flags & 0x10
		if(flags & 0x20) z.hidden = true;
		if(flags & 0x40) z.hpt = miyRw / 20;
		return z;
	}
	
	
	/* [MS-XLS] 2.4.125 */
	function parse_ForceFullCalculation(blob) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	
	
	
	/* [MS-XLS] 2.4.215 rt */
	function parse_RecalcId(blob) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* [MS-XLS] 2.4.87 */
	function parse_DefaultRowHeight(blob, length, opts) {
		var f = 0;
		if(!(opts && opts.biff == 2)) {
			f = blob.read_shift(2);
		}
		var miyRw = blob.read_shift(2);
		if((opts && opts.biff == 2)) {
			f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
		}
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* [MS-XLS] 2.4.345 TODO */
	function parse_Window1(blob) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	function write_Window1() {
		var o = new_buf(18);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0x7260);
		o.write_shift(2, 0x44c0);
		o.write_shift(2, 0x38);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 1);
		o.write_shift(2, 0x01f4);
		return o;
	}
	/* [MS-XLS] 2.4.346 TODO */
	function parse_Window2(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff < 5) return {};
		var f = blob.read_shift(2);
		return { RTL: f & 0x40 };
	}
	function write_Window2(view) {
		var o = new_buf(18), f = 0x6b6;
		if(view && view.RTL) f |= 0x40;
		o.write_shift(2, f);
		o.write_shift(4, 0);
		o.write_shift(4, 64);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.189 TODO */
	function parse_Pane(/*blob, length, opts*/) {
	}
	
	/* [MS-XLS] 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		var o = {
			dyHeight: blob.read_shift(2),
			fl: blob.read_shift(2)
		};
		switch((opts && opts.biff) || 8) {
			case 2: break;
			case 3: case 4: blob.l += 2; break;
			default: blob.l += 10; break;
		}
		o.name = parse_ShortXLUnicodeString(blob, 0, opts);
		return o;
	}
	function write_Font(data, opts) {
		var name = data.name || "Arial";
		var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
		var o = new_buf(w);
		o.write_shift(2, (data.sz || 12) * 20);
		o.write_shift(4, 0);
		o.write_shift(2, 400);
		o.write_shift(4, 0);
		o.write_shift(2, 0);
		o.write_shift(1, name.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
		return o;
	}
	
	/* [MS-XLS] 2.4.149 */
	function parse_LabelSst(blob) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	function write_LabelSst(R, C, v, os ) {
		var o = new_buf(10);
		write_XLSCell(R, C, os, o);
		o.write_shift(4, v);
		return o;
	}
	
	/* [MS-XLS] 2.4.148 */
	function parse_Label(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var target = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) blob.l++;
		var str = parse_XLUnicodeString(blob, target - blob.l, opts);
		cell.val = str;
		return cell;
	}
	function write_Label(R, C, v, os, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
		write_XLSCell(R, C, os, o);
		o.write_shift(2, v.length);
		if(b8) o.write_shift(1, 1);
		o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
		return o;
	}
	
	
	/* [MS-XLS] 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var numFmtId = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [numFmtId, fmtstr];
	}
	function write_Format(i, f, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
		o.write_shift(2, i);
		o.write_shift((b5 ? 1 : 2), f.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(out.l == null) out.l = out.length;
		return out;
	}
	var parse_BIFF2Format = parse_XLUnicodeString2;
	
	/* [MS-XLS] 2.4.90 */
	function parse_Dimensions(blob, length, opts) {
		var end = blob.l + length;
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var r = blob.read_shift(w), R = blob.read_shift(w);
		var c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l = end;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	function write_Dimensions(range, opts) {
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var o = new_buf(2*w + 6);
		o.write_shift(w, range.s.r);
		o.write_shift(w, range.e.r + 1);
		o.write_shift(2, range.s.c);
		o.write_shift(2, range.e.c + 1);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.220 */
	function parse_RK(blob) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* [MS-XLS] 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw new Error("MulRK read error");
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	/* [MS-XLS] 2.4.174 */
	function parse_MulBlank(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var ixfes = [];
		while(blob.l < target) ixfes.push(blob.read_shift(2));
		if(blob.l !== target) throw new Error("MulBlank read error");
		var lastcol = blob.read_shift(2);
		if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
		return {r:rw, c:col, C:lastcol, ixfe:ixfes};
	}
	
	/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
	function parse_CellStyleXF(blob, length, style, opts) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
	
		if(!opts.cellStyles) return o;
		o.alc = a & 0x07;
		o.fWrap = (a >> 3) & 0x01;
		o.alcV = (a >> 4) & 0x07;
		o.fJustLast = (a >> 7) & 0x01;
		o.trot = (a >> 8) & 0xFF;
		o.cIndent = (a >> 16) & 0x0F;
		o.fShrinkToFit = (a >> 20) & 0x01;
		o.iReadOrder = (a >> 22) & 0x02;
		o.fAtrNum = (a >> 26) & 0x01;
		o.fAtrFnt = (a >> 27) & 0x01;
		o.fAtrAlc = (a >> 28) & 0x01;
		o.fAtrBdr = (a >> 29) & 0x01;
		o.fAtrPat = (a >> 30) & 0x01;
		o.fAtrProt = (a >> 31) & 0x01;
	
		o.dgLeft = b & 0x0F;
		o.dgRight = (b >> 4) & 0x0F;
		o.dgTop = (b >> 8) & 0x0F;
		o.dgBottom = (b >> 12) & 0x0F;
		o.icvLeft = (b >> 16) & 0x7F;
		o.icvRight = (b >> 23) & 0x7F;
		o.grbitDiag = (b >> 30) & 0x03;
	
		o.icvTop = c & 0x7F;
		o.icvBottom = (c >> 7) & 0x7F;
		o.icvDiag = (c >> 14) & 0x7F;
		o.dgDiag = (c >> 21) & 0x0F;
	
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		o.fsxButton = (d >> 14) & 0x01;
		return o;
	}
	//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
	//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
	
	/* [MS-XLS] 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length, opts) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
		return o;
	}
	function write_XF(data, ixfeP, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? 16 : 20);
		o.write_shift(2, 0);
		if(data.style) {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, 0xFFF4);
		} else {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, (ixfeP<<4));
		}
		var f = 0;
		if(data.numFmtId > 0 && b5) f |= 0x0400;
		o.write_shift(4, f);
		o.write_shift(4, 0);
		if(!b5) o.write_shift(4, 0);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.134 */
	function parse_Guts(blob) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
		return out;
	}
	function write_Guts(guts) {
		var o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
		o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.24 */
	function parse_BoolErr(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2 || length == 9) ++blob.l;
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	function write_BoolErr(R, C, v, os, opts, t) {
		var o = new_buf(8);
		write_XLSCell(R, C, os, o);
		write_Bes(v, t, o);
		return o;
	}
	
	/* [MS-XLS] 2.4.180 Number */
	function parse_Number(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	function write_Number(R, C, v, os) {
		var o = new_buf(14);
		write_XLSCell(R, C, os, o);
		write_Xnum(v, o);
		return o;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* [MS-XLS] 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		opts.sbcch = cch;
		if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
		if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
		var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		/* TODO: 2.5.277 Virtual Path */
		var rgst = [];
		while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
		return [cch, ctab, virtPath, rgst];
	}
	
	/* [MS-XLS] 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = ({
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		});
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		if(typeof body === "string") o.Name = body;
		return o;
	}
	
	/* [MS-XLS] 2.4.150 TODO */
	var XLSLblBuiltIn = [
		"_xlnm.Consolidate_Area",
		"_xlnm.Auto_Open",
		"_xlnm.Auto_Close",
		"_xlnm.Extract",
		"_xlnm.Database",
		"_xlnm.Criteria",
		"_xlnm.Print_Area",
		"_xlnm.Print_Titles",
		"_xlnm.Recorder",
		"_xlnm.Data_Form",
		"_xlnm.Auto_Activate",
		"_xlnm.Auto_Deactivate",
		"_xlnm.Sheet_Title",
		"_xlnm._FilterDatabase"
	];
	function parse_Lbl(blob, length, opts) {
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var itab = 0;
		if(!opts || opts.biff >= 5) {
			if(opts.biff != 5) blob.l += 2;
			itab = blob.read_shift(2);
			if(opts.biff == 5) blob.l += 2;
			blob.l += 4;
		}
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
		var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
		/*jshint -W018 */
		var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
		/*jshint +W018 */
		return {
			chKey: chKey,
			Name: name,
			itab: itab,
			rgce: rgce
		};
	}
	
	/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
		var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
		while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
			// [iSupBook, itabFirst, itabLast];
		if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
		return o;
	}
	function parse_BIFF5ExternSheet(blob, length, opts) {
		if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
		var o = parse_ShortXLUnicodeString(blob, length, opts);
		return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
	}
	
	/* [MS-XLS] 2.4.176 TODO: check older biff */
	function parse_NameCmt(blob, length, opts) {
		if(opts.biff < 8) { blob.l += length; return; }
		var cchName = blob.read_shift(2);
		var cchComment = blob.read_shift(2);
		var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
		var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
		return [name, comment];
	}
	
	/* [MS-XLS] 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
	}
	
	/* [MS-XLS] 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		/* TODO: fAlwaysCalc */
		switch(opts.biff) {
			case 2: blob.l ++; length -= 7; break;
			case 3: case 4: blob.l += 2; length -= 8; break;
			default: blob.l += 6; length -= 12;
		}
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* [MS-XLS] 2.4.173 */
	function parse_MTRSettings(blob) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* [MS-XLS] 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* [MS-XLS] 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* [MS-XLS] 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	function write_MergeCells(merges) {
		var o = new_buf(2 + merges.length * 8);
		o.write_shift(2, merges.length);
		for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
		return o;
	}
	
	/* [MS-XLS] 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length, opts) {
		if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	/* from older spec */
	var parse_BIFF5OT = {
	0x08: function(blob, length) {
		var tgt = blob.l + length;
		blob.l += 10; // todo
		var cf = blob.read_shift(2);
		blob.l += 4;
		blob.l += 2; //var cbPictFmla = blob.read_shift(2);
		blob.l += 2;
		blob.l += 2; //var grbit = blob.read_shift(2);
		blob.l += 4;
		var cchName = blob.read_shift(1);
		blob.l += cchName; // TODO: stName
		blob.l = tgt; // TODO: fmla
		return { fmt:cf };
	}
	};
	
	function parse_BIFF5Obj(blob, length, opts) {
		blob.l += 4; //var cnt = blob.read_shift(4);
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var grbit = blob.read_shift(2);
		blob.l += 2; //var colL = blob.read_shift(2);
		blob.l += 2; //var dxL = blob.read_shift(2);
		blob.l += 2; //var rwT = blob.read_shift(2);
		blob.l += 2; //var dyT = blob.read_shift(2);
		blob.l += 2; //var colR = blob.read_shift(2);
		blob.l += 2; //var dxR = blob.read_shift(2);
		blob.l += 2; //var rwB = blob.read_shift(2);
		blob.l += 2; //var dyB = blob.read_shift(2);
		blob.l += 2; //var cbMacro = blob.read_shift(2);
		blob.l += 6;
		length -= 36;
		var fts = [];
		fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
		return { cmo: [id, ot, grbit], ft:fts };
	}
	
	/* [MS-XLS] 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
		var texts = "";
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo; // eslint-disable-line no-unused-vars
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
		var cchText = blob.read_shift(2);
		/*var cbRuns = */blob.read_shift(2);
		/*var ifntEmpty = */parseuint16(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw new Error("cchText: " + cchText + " != " + texts.length);
		}
	
		blob.l = s + length;
		/* [MS-XLS] 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
	//	blob.l += 6;
	//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts }; }
	}
	
	/* [MS-XLS] 2.4.140 */
	function parse_HLink(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	}
	function write_HLink(hl) {
		var O = new_buf(24);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
		return bconcat([O, write_Hyperlink(hl[1])]);
	}
	
	
	/* [MS-XLS] 2.4.141 */
	function parse_HLinkTooltip(blob, length) {
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	}
	function write_HLinkTooltip(hl) {
		var TT = hl[1].Tooltip;
		var O = new_buf(10 + 2 * (TT.length + 1));
		O.write_shift(2, 0x0800);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
		O.write_shift(2, 0);
		return O;
	}
	
	/* [MS-XLS] 2.4.63 */
	function parse_Country(blob) {
		var o = [0,0], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	function write_Country(o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, 0x01);
		o.write_shift(2, 0x01);
		return o;
	}
	
	/* [MS-XLS] 2.4.50 ClrtClient */
	function parse_ClrtClient(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.188 */
	function parse_Palette(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.354 */
	function parse_XFCRC(blob) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	/* [MS-XLS] 2.4.53 TODO: parse flags */
	/* [MS-XLSB] 2.4.323 TODO: parse flags */
	function parse_ColInfo(blob, length, opts) {
		if(!opts.cellStyles) return parsenoop(blob, length);
		var w = opts && opts.biff >= 12 ? 4 : 2;
		var colFirst = blob.read_shift(w);
		var colLast = blob.read_shift(w);
		var coldx = blob.read_shift(w);
		var ixfe = blob.read_shift(w);
		var flags = blob.read_shift(2);
		if(w == 2) blob.l += 2;
		var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags});
		if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
		return o;
	}
	function write_ColInfo(col, idx) {
		var o = new_buf(12);
		o.write_shift(2, idx);
		o.write_shift(2, idx);
		o.write_shift(2, col.width * 256);
		o.write_shift(2, 0);
		var f = 0;
		if(col.hidden) f |= 1;
		o.write_shift(1, f);
		f = col.level || 0;
		o.write_shift(1, f);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.257 */
	function parse_Setup(blob, length) {
		var o = {};
		if(length < 32) return o;
		blob.l += 16;
		o.header = parse_Xnum(blob, 8);
		o.footer = parse_Xnum(blob, 8);
		blob.l += 2;
		return o;
	}
	
	/* [MS-XLS] 2.4.261 */
	function parse_ShtProps(blob, length, opts) {
		var def = {area:false};
		if(opts.biff != 5) { blob.l += length; return def; }
		var d = blob.read_shift(1); blob.l += 3;
		if((d & 0x10)) def.area = true;
		return def;
	}
	
	/* [MS-XLS] 2.4.241 */
	function write_RRTabId(n) {
		var out = new_buf(2 * n);
		for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
		return out;
	}
	
	var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
	var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_ImData(blob) {
		var cf = blob.read_shift(2);
		var env = blob.read_shift(2);
		var lcb = blob.read_shift(4);
		var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
		blob.l += lcb;
		return o;
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		if(opts.biffguess && opts.biff == 5) opts.biff = 2;
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2NUM(r, c, val) {
		var out = new_buf(15);
		write_BIFF2Cell(out, r, c);
		out.write_shift(8, val, 'f');
		return out;
	}
	
	function parse_BIFF2INT(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = blob.read_shift(2);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2INT(r, c, val) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		out.write_shift(2, val);
		return out;
	}
	
	function parse_BIFF2STRING(blob) {
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* TODO: convert to BIFF8 font struct */
	function parse_BIFF2FONTXTRA(blob, length) {
		blob.l += 6; // unknown
		blob.l += 2; // font weight "bls"
		blob.l += 1; // charset
		blob.l += 3; // unknown
		blob.l += 1; // font family
		blob.l += length - 13;
	}
	
	/* TODO: parse rich text runs */
	function parse_RString(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		var cch = blob.read_shift(2);
		var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
		blob.l = end;
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	/* from js-harb (C) 2014-present  SheetJS */
	var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
	var DBF = (function() {
	var dbf_codepage_map = {
		/* Code Pages Supported by Visual FoxPro */
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	
		/* shapefile DBF extension */
	0x00: 20127,           0x08:   865,
	0x09:   437,           0x0A:   850,
	0x0B:   437,           0x0D:   437,
	0x0E:   850,           0x0F:   437,
	0x10:   850,           0x11:   437,
	0x12:   850,           0x13:   932,
	0x14:   850,           0x15:   437,
	0x16:   850,           0x17:   865,
	0x18:   437,           0x19:   437,
	0x1A:   850,           0x1B:   437,
	0x1C:   863,           0x1D:   850,
	0x1F:   852,           0x22:   852,
	0x23:   852,           0x24:   860,
	0x25:   850,           0x26:   866,
	0x37:   850,           0x40:   852,
	0x4D:   936,           0x4E:   949,
	0x4F:   950,           0x50:   874,
	0x57:  1252,           0x58:  1252,
	0x59:  1252,           0x6C:   863,
	0x86:   737,           0x87:   852,
	0x88:   857,           0xCC:  1257,
	
	0xFF: 16969
	};
	var dbf_reverse_map = evert({
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	0x00: 20127
	});
	/* TODO: find an actual specification */
	function dbf_to_aoa(buf, opts) {
		var out = [];
		var d = (new_raw_buf(1));
		switch(opts.type) {
			case 'base64': d = s2a(Base64_decode(buf)); break;
			case 'binary': d = s2a(buf); break;
			case 'buffer':
			case 'array': d = buf; break;
		}
		prep_blob(d, 0);
	
		/* header */
		var ft = d.read_shift(1);
		var memo = !!(ft & 0x88);
		var vfp = false, l7 = false;
		switch(ft) {
			case 0x02: break; // dBASE II
			case 0x03: break; // dBASE III
			case 0x30: vfp = true; memo = true; break; // VFP
			case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
			// 0x43 dBASE IV SQL table files
			// 0x63 dBASE IV SQL system files
			case 0x83: break; // dBASE III with memo
			case 0x8B: break; // dBASE IV with memo
			case 0x8C: l7 = true; break; // dBASE Level 7 with memo
			// case 0xCB dBASE IV SQL table files with memo
			case 0xF5: break; // FoxPro 2.x with memo
			// case 0xFB FoxBASE
			default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
		}
	
		var nrow = 0, fpos = 0x0209;
		if(ft == 0x02) nrow = d.read_shift(2);
		d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
		if(ft != 0x02) nrow = d.read_shift(4);
		if(nrow > 1048576) nrow = 1e6;
	
		if(ft != 0x02) fpos = d.read_shift(2); // header length
		var rlen = d.read_shift(2); // record length
	
		var /*flags = 0,*/ current_cp = opts.codepage || 1252;
		if(ft != 0x02) { // 20 reserved bytes
			d.l+=16;
			/*flags = */d.read_shift(1);
			//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
	
			/* codepage present in FoxPro and dBASE Level 7 */
			if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
			d.l+=1;
	
			d.l+=2;
		}
		if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
	
	var fields = [], field = ({});
		var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
		var ww = l7 ? 32 : 11;
		while(d.l < hend && d[d.l] != 0x0d) {
			field = ({});
			field.name = $cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
			d.l += ww;
			field.type = String.fromCharCode(d.read_shift(1));
			if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
			field.len = d.read_shift(1);
			if(ft == 0x02) field.offset = d.read_shift(2);
			field.dec = d.read_shift(1);
			if(field.name.length) fields.push(field);
			if(ft != 0x02) d.l += l7 ? 13 : 14;
			switch(field.type) {
				case 'B': // Double (VFP) / Binary (dBASE L7)
					if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'G': // General (FoxPro and dBASE L7)
				case 'P': // Picture (FoxPro and dBASE L7)
					if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case '+': // Autoincrement (dBASE L7 only)
				case '0': // _NullFlags (VFP only)
				case '@': // Timestamp (dBASE L7 only)
				case 'C': // Character (dBASE II)
				case 'D': // Date (dBASE III)
				case 'F': // Float (dBASE IV)
				case 'I': // Long (VFP and dBASE L7)
				case 'L': // Logical (dBASE II)
				case 'M': // Memo (dBASE III)
				case 'N': // Number (dBASE II)
				case 'O': // Double (dBASE L7 only)
				case 'T': // Datetime (VFP only)
				case 'Y': // Currency (VFP only)
					break;
				default: throw new Error('Unknown Field Type: ' + field.type);
			}
		}
	
		if(d[d.l] !== 0x0D) d.l = fpos-1;
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	
		/* data */
		var R = 0, C = 0;
		out[0] = [];
		for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
		while(nrow-- > 0) {
			if(d[d.l] === 0x2A) {
				// TODO: record marked as deleted -- create a hidden row?
				d.l+=rlen;
				continue;
			}
			++d.l;
			out[++R] = []; C = 0;
			for(C = 0; C != fields.length; ++C) {
				var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
				prep_blob(dd, 0);
				var s = $cptable.utils.decode(current_cp, dd);
				switch(fields[C].type) {
					case 'C':
						// NOTE: it is conventional to write '  /  /  ' for empty dates
						if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
						break;
					case 'D':
						if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
						else out[R][C] = s;
						break;
					case 'F': out[R][C] = parseFloat(s.trim()); break;
					case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
					case 'L': switch(s.trim().toUpperCase()) {
						case 'Y': case 'T': out[R][C] = true; break;
						case 'N': case 'F': out[R][C] = false; break;
						case '': case '?': break;
						default: throw new Error("DBF Unrecognized L:|" + s + "|");
						} break;
					case 'M': /* TODO: handle memo files */
						if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
						out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
						break;
					case 'N':
						s = s.replace(/\u0000/g,"").trim();
						// NOTE: dBASE II interprets "  .  " as 0
						if(s && s != ".") out[R][C] = +s || 0; break;
					case '@':
						// NOTE: dBASE specs appear to be incorrect
						out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
						break;
					case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
					case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4 + (dd.read_shift(4, 'i')/1e4)*Math.pow(2,32); break;
					case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
					case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
						/* falls through */
					case 'G': case 'P': dd.l += fields[C].len; break;
					case '0':
						if(fields[C].name === '_NullFlags') break;
						/* falls through */
					default: throw new Error("DBF Unsupported data type " + fields[C].type);
				}
			}
		}
		if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
		if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
		opts.DBF = fields;
		return out;
	}
	
	function dbf_to_sheet(buf, opts) {
		var o = opts || {};
		if(!o.dateNF) o.dateNF = "yyyymmdd";
		var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
		ws["!cols"] = o.DBF.map(function(field) { return {
			wch: field.len,
			DBF: field
		};});
		delete o.DBF;
		return ws;
	}
	
	function dbf_to_workbook(buf, opts) {
		try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
		catch(e) { if(opts && opts.WTF) throw e; }
		return ({SheetNames:[],Sheets:{}});
	}
	
	var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
	function sheet_to_dbf(ws, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write DBF to JS string");
		var ba = buf_array();
		var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
		var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
		var i = 0, j = 0, hcnt = 0, rlen = 1;
		for(i = 0; i < headers.length; ++i) {
			if(((cols[i]||{}).DBF||{}).name) { headers[i] = cols[i].DBF.name; ++hcnt; continue; }
			if(headers[i] == null) continue;
			++hcnt;
			if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
			if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
			if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
				if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
		}
		var range = safe_decode_range(ws['!ref']);
		var coltypes = [];
		var colwidths = [];
		var coldecimals = [];
		for(i = 0; i <= range.e.c - range.s.c; ++i) {
			var guess = '', _guess = '', maxlen = 0;
			var col = [];
			for(j=0; j < data.length; ++j) {
				if(data[j][i] != null) col.push(data[j][i]);
			}
			if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
			for(j = 0; j < col.length; ++j) {
				switch(typeof col[j]) {
					/* TODO: check if L2 compat is desired */
					case 'number': _guess = 'B'; break;
					case 'string': _guess = 'C'; break;
					case 'boolean': _guess = 'L'; break;
					case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
					default: _guess = 'C';
				}
				maxlen = Math.max(maxlen, String(col[j]).length);
				guess = guess && guess != _guess ? 'C' : _guess;
				//if(guess == 'C') break;
			}
			if(maxlen > 250) maxlen = 250;
			_guess = ((cols[i]||{}).DBF||{}).type;
			/* TODO: more fine grained control over DBF type resolution */
			if(_guess == 'C') {
				if(cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
			}
			if(guess == 'B' && _guess == 'N') {
				guess = 'N';
				coldecimals[i] = cols[i].DBF.dec;
				maxlen = cols[i].DBF.len;
			}
			colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : (_RLEN[guess] || 0);
			rlen += colwidths[i];
			coltypes[i] = guess;
		}
	
		var h = ba.next(32);
		h.write_shift(4, 0x13021130);
		h.write_shift(4, data.length);
		h.write_shift(2, 296 + 32 * hcnt);
		h.write_shift(2, rlen);
		for(i=0; i < 4; ++i) h.write_shift(4, 0);
		h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[current_ansi] || 0x03)<<8));
	
		for(i = 0, j = 0; i < headers.length; ++i) {
			if(headers[i] == null) continue;
			var hf = ba.next(32);
			var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
			hf.write_shift(1, _f, "sbcs");
			hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
			hf.write_shift(4, j);
			hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
			hf.write_shift(1, coldecimals[i] || 0);
			hf.write_shift(1, 0x02);
			hf.write_shift(4, 0);
			hf.write_shift(1, 0);
			hf.write_shift(4, 0);
			hf.write_shift(4, 0);
			j += (colwidths[i] || _RLEN[coltypes[i]] || 0);
		}
	
		var hb = ba.next(264);
		hb.write_shift(4, 0x0000000D);
		for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
		for(i=0; i < data.length; ++i) {
			var rout = ba.next(rlen);
			rout.write_shift(1, 0);
			for(j=0; j<headers.length; ++j) {
				if(headers[j] == null) continue;
				switch(coltypes[j]) {
					case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
					case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
					case 'N':
						var _n = "0";
						if(typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j]||0);
						for(hcnt=0; hcnt < colwidths[j]-_n.length; ++hcnt) rout.write_shift(1, 0x20);
						rout.write_shift(1, _n, "sbcs");
						break;
					case 'D':
						if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
						else {
							rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
							rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
							rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
						} break;
					case 'C':
						var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
						rout.write_shift(1, _s, "sbcs");
						for(hcnt=0; hcnt < colwidths[j]-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
				}
			}
			// data
		}
		ba.next(1).write_shift(1, 0x1A);
		return ba.end();
	}
		return {
			to_workbook: dbf_to_workbook,
			to_sheet: dbf_to_sheet,
			from_sheet: sheet_to_dbf
		};
	})();
	
	var SYLK = (function() {
		/* TODO: stress test sequences */
		var sylk_escapes = ({
			AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
			AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
			AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
			AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
			AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
			Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
			Ae:'è', Be:'é', Ce:'ê',         He:'ë',
			Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
			Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
			Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
			KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
			DN:209, Dn:241, Hy:255,
			S:169,  c:170,  R:174,  "B ":180,
	0:176,    1:177,  2:178,
	3:179,    5:181,  6:182,
	7:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
			"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
			"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
		});
		var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
		var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
		var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
		sylk_escapes["|"] = 254;
		/* TODO: find an actual specification */
		function sylk_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return sylk_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return sylk_to_aoa_str(d, opts);
				case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return sylk_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function sylk_to_aoa_str(str, opts) {
			var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
			var formats = [];
			var next_cell_format = null;
			var sht = {}, rowinfo = [], colinfo = [], cw = [];
			var Mval = 0, j;
			if(+opts.codepage >= 0) set_cp(+opts.codepage);
			for (; ri !== records.length; ++ri) {
				Mval = 0;
				var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
				var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
				var RT=record[0], val;
				if(rstr.length > 0) switch(RT) {
				case 'ID': break; /* header */
				case 'E': break; /* EOF */
				case 'B': break; /* dimensions */
				case 'O': break; /* options? */
				case 'W': break; /* window? */
				case 'P':
					if(record[1].charAt(0) == 'P')
						formats.push(rstr.slice(3).replace(/;;/g, ";"));
					break;
				case 'C':
				var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'A': break; // TODO: comment
					case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'K':
						val = record[rj].slice(1);
						if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
						else if(val === 'TRUE') val = true;
						else if(val === 'FALSE') val = false;
						else if(!isNaN(fuzzynum(val))) {
							val = fuzzynum(val);
							if(next_cell_format !== null && fmt_is_date(next_cell_format)) val = numdate(val);
						} else if(!isNaN(fuzzydate(val).getDate())) {
							val = parseDate(val);
						}
						if(typeof $cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = $cptable.utils.decode(opts.codepage, val);
						C_seen_K = true;
						break;
					case 'E':
						C_seen_E = true;
						var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
						arr[R][C] = [arr[R][C], formula];
						break;
					case 'S':
						C_seen_S = true;
						arr[R][C] = [arr[R][C], "S5S"];
						break;
					case 'G': break; // unknown
					case 'R': _R = parseInt(record[rj].slice(1))-1; break;
					case 'C': _C = parseInt(record[rj].slice(1))-1; break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(C_seen_K) {
					if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
					else arr[R][C] = val;
					next_cell_format = null;
				}
				if(C_seen_S) {
					if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
					var shrbase = _R > -1 && arr[_R][_C];
					if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
					arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
				}
				break;
				case 'F':
				var F_seen = 0;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
					case 'F': break; /* ??? */
					case 'G': break; /* hide grid */
					case 'P':
						next_cell_format = formats[parseInt(record[rj].slice(1))];
						break;
					case 'S': break; /* cell style */
					case 'D': break; /* column */
					case 'N': break; /* font */
					case 'W':
						cw = record[rj].slice(1).split(" ");
						for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
							Mval = parseInt(cw[2], 10);
							colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
						} break;
					case 'C': /* default column format */
						C = parseInt(record[rj].slice(1))-1;
						if(!colinfo[C]) colinfo[C] = {};
						break;
					case 'R': /* row properties */
						R = parseInt(record[rj].slice(1))-1;
						if(!rowinfo[R]) rowinfo[R] = {};
						if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
						else if(Mval === 0) rowinfo[R].hidden = true;
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(F_seen < 1) next_cell_format = null; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
			}
			if(rowinfo.length > 0) sht['!rows'] = rowinfo;
			if(colinfo.length > 0) sht['!cols'] = colinfo;
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return [arr, sht];
		}
	
		function sylk_to_sheet(d, opts) {
			var aoasht = sylk_to_aoa(d, opts);
			var aoa = aoasht[0], ws = aoasht[1];
			var o = aoa_to_sheet(aoa, opts);
			keys(ws).forEach(function(k) { o[k] = ws[k]; });
			return o;
		}
	
		function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }
	
		function write_ws_cell_sylk(cell, ws, R, C) {
			var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
			switch(cell.t) {
				case 'n':
					o += (cell.v||0);
					if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
				case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
				case 'e': o += cell.w || cell.v; break;
				case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
				case 's': o += '"' + cell.v.replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
			}
			return o;
		}
	
		function write_ws_cols_sylk(out, cols) {
			cols.forEach(function(col, i) {
				var rec = "F;W" + (i+1) + " " + (i+1) + " ";
				if(col.hidden) rec += "0";
				else {
					if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
					if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
					if(typeof col.wch == 'number') rec += Math.round(col.wch);
				}
				if(rec.charAt(rec.length - 1) != " ") out.push(rec);
			});
		}
	
		function write_ws_rows_sylk(out, rows) {
			rows.forEach(function(row, i) {
				var rec = "F;";
				if(row.hidden) rec += "M0;";
				else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
				else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
				if(rec.length > 2) out.push(rec + "R" + (i+1));
			});
		}
	
		function sheet_to_sylk(ws, opts) {
			var preamble = ["ID;PWXL;N;E"], o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			var RS = "\r\n";
	
			preamble.push("P;PGeneral");
			preamble.push("F;P0;DG0G8;M255");
			if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
			if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
	
			preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
					o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
				}
			}
			return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
		}
	
		return {
			to_workbook: sylk_to_workbook,
			to_sheet: sylk_to_sheet,
			from_sheet: sheet_to_sylk
		};
	})();
	
	var DIF = (function() {
		function dif_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return dif_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return dif_to_aoa_str(d, opts);
				case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return dif_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function dif_to_aoa_str(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
				if (R < 0) continue;
				var metadata = records[ri].trim().split(",");
				var type = metadata[0], value = metadata[1];
				++ri;
				var data = records[ri] || "";
				while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
				data = data.trim();
				switch (+type) {
					case -1:
						if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
						else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
						break;
					case 0:
						if(data === 'TRUE') arr[R][C] = true;
						else if(data === 'FALSE') arr[R][C] = false;
						else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
						else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
						else arr[R][C] = value;
						++C; break;
					case 1:
						data = data.slice(1,data.length-1);
						data = data.replace(/""/g, '"');
						if(DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
						arr[R][C++] = data !== '' ? data : null;
						break;
				}
				if (data === 'EOD') break;
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
		function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }
	
		var sheet_to_dif = (function() {
			var push_field = function pf(o, topic, v, n, s) {
				o.push(topic);
				o.push(v + "," + n);
				o.push('"' + s.replace(/"/g,'""') + '"');
			};
			var push_value = function po(o, type, v, s) {
				o.push(type + "," + v);
				o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
			};
			return function sheet_to_dif(ws) {
				var o = [];
				var r = safe_decode_range(ws['!ref']), cell;
				var dense = Array.isArray(ws);
				push_field(o, "TABLE", 0, 1, "sheetjs");
				push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
				push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
				push_field(o, "DATA", 0, 0,"");
				for(var R = r.s.r; R <= r.e.r; ++R) {
					push_value(o, -1, 0, "BOT");
					for(var C = r.s.c; C <= r.e.c; ++C) {
						var coord = encode_cell({r:R,c:C});
						cell = dense ? (ws[R]||[])[C] : ws[coord];
						if(!cell) { push_value(o, 1, 0, ""); continue;}
						switch(cell.t) {
							case 'n':
								var val = DIF_XL ? cell.w : cell.v;
								if(!val && cell.v != null) val = cell.v;
								if(val == null) {
									if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
									else push_value(o, 1, 0, "");
								}
								else push_value(o, 0, val, "V");
								break;
							case 'b':
								push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
								break;
							case 's':
								push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
								break;
							case 'd':
								if(!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
								if(DIF_XL) push_value(o, 0, cell.w, "V");
								else push_value(o, 1, 0, cell.w);
								break;
							default: push_value(o, 1, 0, "");
						}
					}
				}
				push_value(o, -1, 0, "EOD");
				var RS = "\r\n";
				var oo = o.join(RS);
				//while((oo.length & 0x7F) != 0) oo += "\0";
				return oo;
			};
		})();
		return {
			to_workbook: dif_to_workbook,
			to_sheet: dif_to_sheet,
			from_sheet: sheet_to_dif
		};
	})();
	
	var ETH = (function() {
		function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
		function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }
	
		function eth_to_aoa(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				var record = records[ri].trim().split(":");
				if(record[0] !== 'cell') continue;
				var addr = decode_cell(record[1]);
				if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
				R = addr.r; C = addr.c;
				switch(record[2]) {
					case 't': arr[R][C] = decode(record[3]); break;
					case 'v': arr[R][C] = +record[3]; break;
					case 'vtf': var _f = record[record.length - 1];
						/* falls through */
					case 'vtc':
						switch(record[3]) {
							case 'nl': arr[R][C] = +record[4] ? true : false; break;
							default: arr[R][C] = +record[4]; break;
						}
						if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
				}
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
		function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }
	
		var header = [
			"socialcalc:version:1.5",
			"MIME-Version: 1.0",
			"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
		].join("\n");
	
		var sep = [
			"--SocialCalcSpreadsheetControlSave",
			"Content-type: text/plain; charset=UTF-8"
		].join("\n") + "\n";
	
		/* TODO: the other parts */
		var meta = [
			"# SocialCalc Spreadsheet Control Save",
			"part:sheet"
		].join("\n");
	
		var end = "--SocialCalcSpreadsheetControlSave--";
	
		function sheet_to_eth_data(ws) {
			if(!ws || !ws['!ref']) return "";
			var o = [], oo = [], cell, coord = "";
			var r = decode_range(ws['!ref']);
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null || cell.t === 'z') continue;
					oo = ["cell", coord, 't'];
					switch(cell.t) {
						case 's': case 'str': oo.push(encode(cell.v)); break;
						case 'n':
							if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
							else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
							break;
						case 'b':
							oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
							oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
							break;
						case 'd':
							var t = datenum(parseDate(cell.v));
							oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
							oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
							break;
						case 'e': continue;
					}
					o.push(oo.join(":"));
				}
			}
			o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
			o.push("valueformat:1:text-wiki");
			//o.push("copiedfrom:" + ws['!ref']); // clipboard only
			return o.join("\n");
		}
	
		function sheet_to_eth(ws) {
			return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
			// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
		}
	
		return {
			to_workbook: eth_to_workbook,
			to_sheet: eth_to_sheet,
			from_sheet: sheet_to_eth
		};
	})();
	
	var PRN = (function() {
		function set_text_arr(data, arr, R, C, o) {
			if(o.raw) arr[R][C] = data;
			else if(data === ""){/* empty */}
			else if(data === 'TRUE') arr[R][C] = true;
			else if(data === 'FALSE') arr[R][C] = false;
			else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
			else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
			else arr[R][C] = data;
		}
	
		function prn_to_aoa_str(f, opts) {
			var o = opts || {};
			var arr = ([]);
			if(!f || f.length === 0) return arr;
			var lines = f.split(/[\r\n]/);
			var L = lines.length - 1;
			while(L >= 0 && lines[L].length === 0) --L;
			var start = 10, idx = 0;
			var R = 0;
			for(; R <= L; ++R) {
				idx = lines[R].indexOf(" ");
				if(idx == -1) idx = lines[R].length; else idx++;
				start = Math.max(start, idx);
			}
			for(R = 0; R <= L; ++R) {
				arr[R] = [];
				/* TODO: confirm that widths are always 10 */
				var C = 0;
				set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
				for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
					set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
			}
			if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
			return arr;
		}
	
		// List of accepted CSV separators
		var guess_seps = {
	0x2C: ',',
	0x09: "\t",
	0x3B: ';',
	0x7C: '|'
		};
	
		// CSV separator weights to be used in case of equal numbers
		var guess_sep_weights = {
	0x2C: 3,
	0x09: 2,
	0x3B: 1,
	0x7C: 0
		};
	
		function guess_sep(str) {
			var cnt = {}, instr = false, end = 0, cc = 0;
			for(;end < str.length;++end) {
				if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
				else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
			}
	
			cc = [];
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
	
			if ( !cc.length ) {
				cnt = guess_sep_weights;
				for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
					cc.push([ cnt[end], end ]);
				}
			}
	
			cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });
	
			return guess_seps[cc.pop()[1]] || 0x2C;
		}
	
		function dsv_to_sheet_str(str, opts) {
			var o = opts || {};
			var sep = "";
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			if(str.slice(0,4) == "sep=") {
				// If the line ends in \r\n
				if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
					sep = str.charAt(4); str = str.slice(7);
				}
				// If line ends in \r OR \n
				else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
					sep = str.charAt(4); str = str.slice(6);
				}
				else sep = guess_sep(str.slice(0,1024));
			}
			else if(o && o.FS) sep = o.FS;
			else sep = guess_sep(str.slice(0,1024));
			var R = 0, C = 0, v = 0;
			var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
			str = str.replace(/\r\n/mg, "\n");
			var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
			function finish_cell() {
				var s = str.slice(start, end);
				var cell = ({});
				if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
				if(s.length === 0) cell.t = 'z';
				else if(o.raw) { cell.t = 's'; cell.v = s; }
				else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
				else if(s.charCodeAt(0) == 0x3D) {
					if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
					else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
					else { cell.t = 's'; cell.v = s; } }
				else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
				else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
				else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
				else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
					cell.z = o.dateNF || table_fmt[14];
					var k = 0;
					if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
					if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
					else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
					if(o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
					if(!o.cellNF) delete cell.z;
				} else {
					cell.t = 's';
					cell.v = s;
				}
				if(cell.t == 'z'){}
				else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
				else ws[encode_cell({c:C,r:R})] = cell;
				start = end+1; startcc = str.charCodeAt(start);
				if(range.e.c < C) range.e.c = C;
				if(range.e.r < R) range.e.r = R;
				if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
			}
			outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
				case 0x22: if(startcc === 0x22) instr = !instr; break;
				case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
				default: break;
			}
			if(end - start > 0) finish_cell();
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function prn_to_sheet_str(str, opts) {
			if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
			if(opts.FS) return dsv_to_sheet_str(str, opts);
			if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
			if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
			return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
		}
	
		function prn_to_sheet(d, opts) {
			var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
			switch(opts.type) {
				case 'base64': str = Base64_decode(d); break;
				case 'binary': str = d; break;
				case 'buffer':
					if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
					else if(opts.codepage && typeof $cptable !== 'undefined') str = $cptable.utils.decode(opts.codepage, d);
					else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
					break;
				case 'array': str = cc2str(d); break;
				case 'string': str = d; break;
				default: throw new Error("Unrecognized type " + opts.type);
			}
			if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
			else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
			else if((opts.type == 'binary') && typeof $cptable !== 'undefined' && opts.codepage)  str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591,str));
			if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
			return prn_to_sheet_str(str, opts);
		}
	
		function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }
	
		function sheet_to_prn(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				var oo = [];
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null) { oo.push("          "); continue; }
					var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
					while(w.length < 10) w += " ";
					oo.push(w + (C === 0 ? " " : ""));
				}
				o.push(oo.join(""));
			}
			return o.join("\n");
		}
	
		return {
			to_workbook: prn_to_workbook,
			to_sheet: prn_to_sheet,
			from_sheet: sheet_to_prn
		};
	})();
	
	/* Excel defaults to SYLK but warns if data is not valid */
	function read_wb_ID(d, opts) {
		var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
		try {
			var out = SYLK.to_workbook(d, o);
			o.WTF = OLD_WTF;
			return out;
		} catch(e) {
			o.WTF = OLD_WTF;
			if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
			return PRN.to_workbook(d, opts);
		}
	}
	
	var WK_ = (function() {
		function lotushopper(data, cb, opts) {
			if(!data) return;
			prep_blob(data, data.l || 0);
			var Enum = opts.Enum || WK1Enum;
			while(data.l < data.length) {
				var RT = data.read_shift(2);
				var R = Enum[RT] || Enum[0xFFFF];
				var length = data.read_shift(2);
				var tgt = data.l + length;
				var d = R.f && R.f(data, length, opts);
				data.l = tgt;
				if(cb(d, R, RT)) return;
			}
		}
	
		function lotus_to_workbook(d, opts) {
			switch(opts.type) {
				case 'base64': return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
				case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
				case 'buffer':
				case 'array': return lotus_to_workbook_buf(d, opts);
			}
			throw "Unsupported type " + opts.type;
		}
	
		function lotus_to_workbook_buf(d, opts) {
			if(!d) return d;
			var o = opts || {};
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var s = ((o.dense ? [] : {})), n = "Sheet1", next_n = "", sidx = 0;
			var sheets = {}, snames = [], realnames = [];
	
			var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
			var sheetRows = o.sheetRows || 0;
	
			if(d[2] == 0x00) {
				if(d[3] == 0x08 || d[3] == 0x09) {
					if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
				}
			}
	
			if(d[2] == 0x02) {
				o.Enum = WK1Enum;
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0x00: /* BOF */
						o.vers = val;
						if(val >= 0x1000) o.qpro = true;
						break;
					case 0x06: refguess = val; break; /* RANGE */
					case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
					case 0xDE: next_n = val; break; /* SHEETNAMELP */
					case 0x0F: /* LABEL */
					case 0x33: /* STRING */
						if(!o.qpro) val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x0D: /* INTEGER */
					case 0x0E: /* NUMBER */
					case 0x10: /* FORMULA */
						/* TODO: actual translation of the format code */
						if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
							val[1].z = o.dateNF || table_fmt[14];
							if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
						}
	
						if(o.qpro) {
							if(val[3] > sidx) {
								s["!ref"] = encode_range(refguess);
								sheets[n] = s;
								snames.push(n);
								s = (o.dense ? [] : {});
								refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
								sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
							}
						}
	
						var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
						if(tmpcell) {
							tmpcell.t = val[1].t; tmpcell.v = val[1].v;
							if(val[1].z != null) tmpcell.z = val[1].z;
							if(val[1].f != null) tmpcell.f = val[1].f;
							break;
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						break;
					default:
				}}, o);
			} else if(d[2] == 0x1A || d[2] == 0x0E) {
				o.Enum = WK3Enum;
				if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0xCC: n = val; break; /* SHEETNAMECS */
					case 0x16: /* LABEL16 */
						val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x17: /* NUMBER17 */
					case 0x18: /* NUMBER18 */
					case 0x19: /* FORMULA19 */
					case 0x25: /* NUMBER25 */
					case 0x27: /* NUMBER27 */
					case 0x28: /* FORMULA28 */
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = "Sheet" + (sidx + 1);
						}
						if(sheetRows > 0 && val[0].r >= sheetRows) break;
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
						if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
						break;
					case 0x1B: /* XFORMAT */
						if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
						break;
					case 0x0601: /* SHEETINFOQP */
						realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
					default: break;
				}}, o);
			} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
			s["!ref"] = encode_range(refguess);
			sheets[next_n || n] = s;
			snames.push(next_n || n);
			if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
			var osheets = {}, rnames = [];
			/* TODO: verify no collisions */
			for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
				rnames.push(realnames[i] || snames[i]);
				osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
			} else {
				rnames.push(realnames[i]);
				osheets[realnames[i]] = ({ "!ref": "A1" });
			}
			return { SheetNames: rnames, Sheets: osheets };
		}
	
		function sheet_to_wk1(ws, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
			var ba = buf_array();
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
	
			write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
			write_biff_rec(ba, 0x06, write_RANGE(range));
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: formula records */
					if(cell.t == "n") {
						if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
						else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
					} else {
						var str = format_cell(cell);
						write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
					}
				}
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
		function book_to_wk3(wb, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
			var ba = buf_array();
	
			write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
	
			for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
	
			var wsidx = 0;
			for(i = 0; i < wb.SheetNames.length; ++i) {
				var ws = wb.Sheets[wb.SheetNames[i]];
				if(!ws || !ws["!ref"]) continue;
				var range = safe_decode_range(ws["!ref"]);
				var dense = Array.isArray(ws);
				var cols = [];
				var max_R = Math.min(range.e.r, 8191);
				for(var R = range.s.r; R <= max_R; ++R) {
					var rr = encode_row(R);
					for(var C = range.s.c; C <= range.e.c; ++C) {
						if(R === range.s.r) cols[C] = encode_col(C);
						var ref = cols[C] + rr;
						var cell = dense ? (ws[R]||[])[C] : ws[ref];
						if(!cell || cell.t == "z") continue;
						/* TODO: FORMULA19 NUMBER18 records */
						if(cell.t == "n") {
							write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
						} else {
							var str = format_cell(cell);
							/* TODO: max len? */
							write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
						}
					}
				}
				++wsidx;
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
	
		function write_BOF_WK1(v) {
			var out = new_buf(2);
			out.write_shift(2, v);
			return out;
		}
	
		function write_BOF_WK3(wb) {
			var out = new_buf(26);
			out.write_shift(2, 0x1000);
			out.write_shift(2, 0x0004);
			out.write_shift(4, 0x0000);
			var rows = 0, cols = 0, wscnt = 0;
			for(var i = 0; i < wb.SheetNames.length; ++i) {
				var name = wb.SheetNames[i];
				var ws = wb.Sheets[name];
				if(!ws || !ws["!ref"]) continue;
				++wscnt;
				var range = decode_range(ws["!ref"]);
				if(rows < range.e.r) rows = range.e.r;
				if(cols < range.e.c) cols = range.e.c;
			}
			if(rows > 8191) rows = 8191;
			out.write_shift(2, rows);
			out.write_shift(1, wscnt);
			out.write_shift(1, cols);
			out.write_shift(2, 0x00);
			out.write_shift(2, 0x00);
			out.write_shift(1, 0x01);
			out.write_shift(1, 0x02);
			out.write_shift(4, 0);
			out.write_shift(4, 0);
			return out;
		}
	
		function parse_RANGE(blob, length, opts) {
			var o = {s:{c:0,r:0},e:{c:0,r:0}};
			if(length == 8 && opts.qpro) {
				o.s.c = blob.read_shift(1);
				blob.l++;
				o.s.r = blob.read_shift(2);
				o.e.c = blob.read_shift(1);
				blob.l++;
				o.e.r = blob.read_shift(2);
				return o;
			}
			o.s.c = blob.read_shift(2);
			o.s.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			o.e.c = blob.read_shift(2);
			o.e.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
			return o;
		}
		function write_RANGE(range) {
			var out = new_buf(8);
			out.write_shift(2, range.s.c);
			out.write_shift(2, range.s.r);
			out.write_shift(2, range.e.c);
			out.write_shift(2, range.e.r);
			return out;
		}
	
		function parse_cell(blob, length, opts) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
			if(opts.qpro && opts.vers != 0x5120) {
				o[0].c = blob.read_shift(1);
				o[3] = blob.read_shift(1);
				o[0].r = blob.read_shift(2);
				blob.l+=2;
			} else {
				o[2] = blob.read_shift(1);
				o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			}
			return o;
		}
	
		function parse_LABEL(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			o[1].t = 's';
			if(opts.vers == 0x5120) {
				blob.l++;
				var len = blob.read_shift(1);
				o[1].v = blob.read_shift(len, 'utf8');
				return o;
			}
			if(opts.qpro) blob.l++;
			o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
			return o;
		}
		function write_LABEL(R, C, s) {
			/* TODO: encoding */
			var o = new_buf(7 + s.length);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(1, 0x27); // ??
			for(var i = 0; i < o.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_INTEGER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(2, 'i');
			return o;
		}
		function write_INTEGER(R, C, v) {
			var o = new_buf(7);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(2, v, 'i');
			return o;
		}
	
		function parse_NUMBER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(8, 'f');
			return o;
		}
		function write_NUMBER(R, C, v) {
			var o = new_buf(13);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(8, v, 'f');
			return o;
		}
	
		function parse_FORMULA(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			/* TODO: formula */
			o[1].v = blob.read_shift(8, 'f');
			if(opts.qpro) blob.l = tgt;
			else {
				var flen = blob.read_shift(2);
				wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
				blob.l += flen;
			}
			return o;
		}
	
		function wk1_parse_rc(B, V, col) {
			var rel = V & 0x8000;
			V &= ~0x8000;
			V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
			return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
		}
		/* var oprec = [
			8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
			3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
		]; */
		/* TODO: flesh out */
		var FuncTab = {
			0x33: ["FALSE", 0],
			0x34: ["TRUE", 0],
			0x46: ["LEN", 1],
			0x50: ["SUM", 69],
			0x51: ["AVERAGEA", 69],
			0x52: ["COUNTA", 69],
			0x53: ["MINA", 69],
			0x54: ["MAXA", 69],
			0x6F: ["T", 1]
		};
		var BinOpTab = [
			  "",   "",   "",   "",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>", // eslint-disable-line no-mixed-spaces-and-tabs
			"<=", ">=",  "<",  ">",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			 "&",   "",   "",   "",   "",   "",   "",   ""  // eslint-disable-line no-mixed-spaces-and-tabs
		];
	
		function wk1_fmla_to_csf(blob, o) {
			prep_blob(blob, 0);
			var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
			while(blob.l < blob.length) {
				var cc = blob[blob.l++];
				switch(cc) {
					case 0x00: out.push(blob.read_shift(8, 'f')); break;
					case 0x01: {
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(C + R);
					} break;
					case 0x02: {
						var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(c + r + ":" + C + R);
					} break;
					case 0x03:
						if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
						break;
					case 0x04: out.push("(" + out.pop() + ")"); break;
					case 0x05: out.push(blob.read_shift(2)); break;
					case 0x06: {
						/* TODO: text encoding */
						var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
						out.push('"' + Z.replace(/"/g, '""') + '"');
					} break;
	
					case 0x08: out.push("-" + out.pop()); break;
					case 0x17: out.push("+" + out.pop()); break;
					case 0x16: out.push("NOT(" + out.pop() + ")"); break;
	
					case 0x14: case 0x15: {
						argR = out.pop(); argL = out.pop();
						out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
					} break;
	
					default:
						if(cc < 0x20 && BinOpTab[cc]) {
							argR = out.pop(); argL = out.pop();
							out.push(argL + BinOpTab[cc] + argR);
						} else if(FuncTab[cc]) {
							argc = FuncTab[cc][1];
							if(argc == 69) argc = blob[blob.l++];
							if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
							var args = out.slice(-argc);
							out.length -= argc;
							out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
						}
						else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
						else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
						// possible future functions ??
						else return console.error("WK1 unrecognized opcode " + cc.toString(16));
				}
			}
			if(out.length == 1) o[1].f = "" + out[0];
			else console.error("WK1 bad formula parse |" + out.join("|") + "|");
		}
	
	
		function parse_cell_3(blob) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
			return o;
		}
	
		function parse_LABEL_16(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].t = 's';
			o[1].v = blob.read_shift(length - 4, 'cstr');
			return o;
		}
		function write_LABEL_16(R, C, wsidx, s) {
			/* TODO: encoding */
			var o = new_buf(6 + s.length);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			o.write_shift(1, 0x27);
			for(var i = 0; i < s.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_NUMBER_18(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].v = blob.read_shift(2);
			var v = o[1].v >> 1;
			if(o[1].v & 0x1) {
				switch(v & 0x07) {
					case 0: v = (v >> 3) * 5000; break;
					case 1: v = (v >> 3) * 500; break;
					case 2: v = (v >> 3) / 20; break;
					case 3: v = (v >> 3) / 200; break;
					case 4: v = (v >> 3) / 2000; break;
					case 5: v = (v >> 3) / 20000; break;
					case 6: v = (v >> 3) / 16; break;
					case 7: v = (v >> 3) / 64; break;
				}
			}
			o[1].v = v;
			return o;
		}
	
		function parse_NUMBER_17(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			var v2 = blob.read_shift(4);
			var e = blob.read_shift(2);
			if(e == 0xFFFF) {
				if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
				else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
				else o[1].v = 0;
				return o;
			}
			var s = e & 0x8000; e = (e&0x7FFF) - 16446;
			o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
			return o;
		}
		function write_NUMBER_17(R, C, wsidx, v) {
			var o = new_buf(14);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			if(v == 0) {
				o.write_shift(4, 0);
				o.write_shift(4, 0);
				o.write_shift(2, 0xFFFF);
				return o;
			}
			var s = 0, e = 0, v1 = 0, v2 = 0;
			if(v < 0) { s = 1; v = -v; }
			e = Math.log2(v) | 0;
			v /= Math.pow(2, e-31);
			v2 = (v)>>>0;
			if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
			v -= v2;
			v2 |= 0x80000000;
			v2 >>>= 0;
			v *= Math.pow(2, 32);
			v1 = v>>>0;
			o.write_shift(4, v1);
			o.write_shift(4, v2);
			e += 0x3FFF + (s ? 0x8000 : 0);
			o.write_shift(2, e);
			return o;
		}
	
		function parse_FORMULA_19(blob, length) {
			var o = parse_NUMBER_17(blob, 14);
			blob.l += length - 14; /* TODO: WK3 formula */
			return o;
		}
	
		function parse_NUMBER_25(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			o[1].v = v1 >> 6;
			return o;
		}
	
		function parse_NUMBER_27(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(8,'f');
			o[1].v = v1;
			return o;
		}
	
		function parse_FORMULA_28(blob, length) {
			var o = parse_NUMBER_27(blob, 14);
			blob.l += length - 10; /* TODO: formula */
			return o;
		}
	
		function parse_SHEETNAMECS(blob, length) {
			return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
		}
	
		function parse_SHEETNAMELP(blob, length) {
			var len = blob[blob.l++];
			if(len > length - 1) len = length - 1;
			var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
			return o;
		}
	
		function parse_SHEETINFOQP(blob, length, opts) {
			if(!opts.qpro || length < 21) return;
			var id = blob.read_shift(1);
			blob.l += 17;
			blob.l += 1; //var len = blob.read_shift(1);
			blob.l += 2;
			var nm = blob.read_shift(length - 21, 'cstr');
			return [id, nm];
		}
	
		function parse_XFORMAT(blob, length) {
			var o = {}, tgt = blob.l + length;
			while(blob.l < tgt) {
				var dt = blob.read_shift(2);
				if(dt == 0x36b0) {
					o[dt] = [0, ""];
					o[dt][0] = blob.read_shift(2);
					while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
				}
				// TODO: 0x3a99 ??
			}
			return o;
		}
		function write_XFORMAT_SHEETNAME(name, wsidx) {
			var out = new_buf(5 + name.length);
			out.write_shift(2, 0x36b0);
			out.write_shift(2, wsidx);
			for(var i = 0; i < name.length; ++i) {
				var cc = name.charCodeAt(i);
				out[out.l++] = cc > 0x7F ? 0x5F : cc;
			}
			out[out.l++] = 0;
			return out;
		}
	
		var WK1Enum = {
	0x0000: { n:"BOF", f:parseuint16 },
	0x0001: { n:"EOF" },
	0x0002: { n:"CALCMODE" },
	0x0003: { n:"CALCORDER" },
	0x0004: { n:"SPLIT" },
	0x0005: { n:"SYNC" },
	0x0006: { n:"RANGE", f:parse_RANGE },
	0x0007: { n:"WINDOW1" },
	0x0008: { n:"COLW1" },
	0x0009: { n:"WINTWO" },
	0x000A: { n:"COLW2" },
	0x000B: { n:"NAME" },
	0x000C: { n:"BLANK" },
	0x000D: { n:"INTEGER", f:parse_INTEGER },
	0x000E: { n:"NUMBER", f:parse_NUMBER },
	0x000F: { n:"LABEL", f:parse_LABEL },
	0x0010: { n:"FORMULA", f:parse_FORMULA },
	0x0018: { n:"TABLE" },
	0x0019: { n:"ORANGE" },
	0x001A: { n:"PRANGE" },
	0x001B: { n:"SRANGE" },
	0x001C: { n:"FRANGE" },
	0x001D: { n:"KRANGE1" },
	0x0020: { n:"HRANGE" },
	0x0023: { n:"KRANGE2" },
	0x0024: { n:"PROTEC" },
	0x0025: { n:"FOOTER" },
	0x0026: { n:"HEADER" },
	0x0027: { n:"SETUP" },
	0x0028: { n:"MARGINS" },
	0x0029: { n:"LABELFMT" },
	0x002A: { n:"TITLES" },
	0x002B: { n:"SHEETJS" },
	0x002D: { n:"GRAPH" },
	0x002E: { n:"NGRAPH" },
	0x002F: { n:"CALCCOUNT" },
	0x0030: { n:"UNFORMATTED" },
	0x0031: { n:"CURSORW12" },
	0x0032: { n:"WINDOW" },
	0x0033: { n:"STRING", f:parse_LABEL },
	0x0037: { n:"PASSWORD" },
	0x0038: { n:"LOCKED" },
	0x003C: { n:"QUERY" },
	0x003D: { n:"QUERYNAME" },
	0x003E: { n:"PRINT" },
	0x003F: { n:"PRINTNAME" },
	0x0040: { n:"GRAPH2" },
	0x0041: { n:"GRAPHNAME" },
	0x0042: { n:"ZOOM" },
	0x0043: { n:"SYMSPLIT" },
	0x0044: { n:"NSROWS" },
	0x0045: { n:"NSCOLS" },
	0x0046: { n:"RULER" },
	0x0047: { n:"NNAME" },
	0x0048: { n:"ACOMM" },
	0x0049: { n:"AMACRO" },
	0x004A: { n:"PARSE" },
	0x0066: { n:"PRANGES??" },
	0x0067: { n:"RRANGES??" },
	0x0068: { n:"FNAME??" },
	0x0069: { n:"MRANGES??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00DE: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
	0xFFFF: { n:"" }
		};
	
		var WK3Enum = {
	0x0000: { n:"BOF" },
	0x0001: { n:"EOF" },
	0x0002: { n:"PASSWORD" },
	0x0003: { n:"CALCSET" },
	0x0004: { n:"WINDOWSET" },
	0x0005: { n:"SHEETCELLPTR" },
	0x0006: { n:"SHEETLAYOUT" },
	0x0007: { n:"COLUMNWIDTH" },
	0x0008: { n:"HIDDENCOLUMN" },
	0x0009: { n:"USERRANGE" },
	0x000A: { n:"SYSTEMRANGE" },
	0x000B: { n:"ZEROFORCE" },
	0x000C: { n:"SORTKEYDIR" },
	0x000D: { n:"FILESEAL" },
	0x000E: { n:"DATAFILLNUMS" },
	0x000F: { n:"PRINTMAIN" },
	0x0010: { n:"PRINTSTRING" },
	0x0011: { n:"GRAPHMAIN" },
	0x0012: { n:"GRAPHSTRING" },
	0x0013: { n:"??" },
	0x0014: { n:"ERRCELL" },
	0x0015: { n:"NACELL" },
	0x0016: { n:"LABEL16", f:parse_LABEL_16},
	0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
	0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
	0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
	0x001A: { n:"FORMULA1A" },
	0x001B: { n:"XFORMAT", f:parse_XFORMAT },
	0x001C: { n:"DTLABELMISC" },
	0x001D: { n:"DTLABELCELL" },
	0x001E: { n:"GRAPHWINDOW" },
	0x001F: { n:"CPA" },
	0x0020: { n:"LPLAUTO" },
	0x0021: { n:"QUERY" },
	0x0022: { n:"HIDDENSHEET" },
	0x0023: { n:"??" },
	0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
	0x0026: { n:"??" },
	0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
	0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
	0x008E: { n:"??" },
	0x0093: { n:"??" },
	0x0096: { n:"??" },
	0x0097: { n:"??" },
	0x0098: { n:"??" },
	0x0099: { n:"??" },
	0x009A: { n:"??" },
	0x009B: { n:"??" },
	0x009C: { n:"??" },
	0x00A3: { n:"??" },
	0x00AE: { n:"??" },
	0x00AF: { n:"??" },
	0x00B0: { n:"??" },
	0x00B1: { n:"??" },
	0x00B8: { n:"??" },
	0x00B9: { n:"??" },
	0x00BA: { n:"??" },
	0x00BB: { n:"??" },
	0x00BC: { n:"??" },
	0x00C3: { n:"??" },
	0x00C9: { n:"??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00CD: { n:"??" },
	0x00CE: { n:"??" },
	0x00CF: { n:"??" },
	0x00D0: { n:"??" },
	0x0100: { n:"??" },
	0x0103: { n:"??" },
	0x0104: { n:"??" },
	0x0105: { n:"??" },
	0x0106: { n:"??" },
	0x0107: { n:"??" },
	0x0109: { n:"??" },
	0x010A: { n:"??" },
	0x010B: { n:"??" },
	0x010C: { n:"??" },
	0x010E: { n:"??" },
	0x010F: { n:"??" },
	0x0180: { n:"??" },
	0x0185: { n:"??" },
	0x0186: { n:"??" },
	0x0189: { n:"??" },
	0x018C: { n:"??" },
	0x0200: { n:"??" },
	0x0202: { n:"??" },
	0x0201: { n:"??" },
	0x0204: { n:"??" },
	0x0205: { n:"??" },
	0x0280: { n:"??" },
	0x0281: { n:"??" },
	0x0282: { n:"??" },
	0x0283: { n:"??" },
	0x0284: { n:"??" },
	0x0285: { n:"??" },
	0x0286: { n:"??" },
	0x0287: { n:"??" },
	0x0288: { n:"??" },
	0x0292: { n:"??" },
	0x0293: { n:"??" },
	0x0294: { n:"??" },
	0x0295: { n:"??" },
	0x0296: { n:"??" },
	0x0299: { n:"??" },
	0x029A: { n:"??" },
	0x0300: { n:"??" },
	0x0304: { n:"??" },
	0x0601: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
	0x0640: { n:"??" },
	0x0642: { n:"??" },
	0x0701: { n:"??" },
	0x0702: { n:"??" },
	0x0703: { n:"??" },
	0x0704: { n:"??" },
	0x0780: { n:"??" },
	0x0800: { n:"??" },
	0x0801: { n:"??" },
	0x0804: { n:"??" },
	0x0A80: { n:"??" },
	0x2AF6: { n:"??" },
	0x3231: { n:"??" },
	0x6E49: { n:"??" },
	0x6F44: { n:"??" },
	0xFFFF: { n:"" }
		};
		return {
			sheet_to_wk1: sheet_to_wk1,
			book_to_wk3: book_to_wk3,
			to_workbook: lotus_to_workbook
		};
	})();
	/* 18.4.7 rPr CT_RPrElt */
	function parse_rpr(rpr) {
		var font = {}, m = rpr.match(tagregex), i = 0;
		var pass = false;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;
	
				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					font.cp = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;
	
				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;
	
				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;
	
				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;
	
				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;
				case '<color>': case '<color/>': case '</color>': break;
	
				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;
				case '<family>': case '<family/>': case '</family>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': font.valign = y.val; break;
				case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;
				case '<scheme>': case '<scheme/>': case '</scheme>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		return font;
	}
	
	var parse_rs = (function() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr");
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex)/*, cp = 65001*/;
			if(!t) return {t:"s", v:""};
	
			var o = ({t:'s', v:unescapexml(t[1])});
			var rpr = r.match(rpregex);
			if(rpr) o.s = parse_rpr(rpr[1]);
			return o;
		}
		var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
		};
	})();
	
	
	/* Parse a list of <r> tags */
	var rs_to_html = (function parse_rs_factory() {
		var nlregex = /(\r\n|\n)/g;
		function parse_rpr2(font, intro, outro) {
			var style = [];
	
			if(font.u) style.push("text-decoration: underline;");
			if(font.uval) style.push("text-underline-style:" + font.uval + ";");
			if(font.sz) style.push("font-size:" + font.sz + "pt;");
			if(font.outline) style.push("text-effect: outline;");
			if(font.shadow) style.push("text-shadow: auto;");
			intro.push('<span style="' + style.join("") + '">');
	
			if(font.b) { intro.push("<b>"); outro.push("</b>"); }
			if(font.i) { intro.push("<i>"); outro.push("</i>"); }
			if(font.strike) { intro.push("<s>"); outro.push("</s>"); }
	
			var align = font.valign || "";
			if(align == "superscript" || align == "super") align = "sup";
			else if(align == "subscript") align = "sub";
			if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }
	
			outro.push("</span>");
			return font;
		}
	
		/* 18.4.4 r CT_RElt */
		function r_to_html(r) {
			var terms = [[],r.v,[]];
			if(!r.v) return "";
	
			if(r.s) parse_rpr2(r.s, terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
	
		return function parse_rs(rs) {
			return rs.map(r_to_html).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
	var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return { t: "" };
		//var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		// TODO: is whitespace actually valid here?
		if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
			z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
			z.r = utf8read(x);
			if(html) z.h = escapehtml(z.t);
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((/*y = */x.match(sirregex))) {
			z.r = utf8read(x);
			z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
			if(html) z.h = rs_to_html(parse_rs(z.r));
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
	var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = ([]), ss = "";
		if(!data) return s;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(sst) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i].trim(), opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS_main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(!s.t) s.t = "";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.221 BrtBeginSst */
	function parse_BrtBeginSst(data) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = ([]);
		var pass = false;
		recordhopper(data, function hopper_sst(val, R, RT) {
			switch(RT) {
				case 0x009F: /* BrtBeginSst */
					s.Count = val[0]; s.Unique = val[1]; break;
				case 0x0013: /* BrtSSTItem */
					s.push(val); break;
				case 0x00A0: /* BrtEndSst */
					return true;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
	
				default:
					if(R.T){}
					if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst) {
		var ba = buf_array();
		write_record(ba, 0x009F /* BrtBeginSst */, write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, 0x0013 /* BrtSSTItem */, write_BrtSSTItem(sst[i]));
		/* FRTSST */
		write_record(ba, 0x00A0 /* BrtEndSst */);
		return ba.end();
	}
	function _JS2ANSI(str) {
		if(typeof $cptable !== 'undefined') return $cptable.utils.encode(current_ansi, str);
		var o = [], oo = str.split("");
		for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_CRYPTOVersion(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
	if(length >= 4) blob.l += length - 4;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
	function parse_DataSpaceVersionInfo(blob) {
		var o = {};
		o.id = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
	function parse_DataSpaceMapEntry(blob) {
		var len = blob.read_shift(4);
		var end = blob.l + len - 4;
		var o = {};
		var cnt = blob.read_shift(4);
		var comps = [];
		/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
		while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
		o.name = blob.read_shift(0, 'lpp4');
		o.comps = comps;
		if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
	function parse_DataSpaceMap(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
	function parse_DataSpaceDefinition(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
	function parse_TransformInfoHeader(blob) {
		var o = {};
		/*var len = */blob.read_shift(4);
		blob.l += 4; // must be 0x1
		o.id = blob.read_shift(0, 'lpp4');
		o.name = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	function parse_Primary(blob) {
		/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
		var hdr = parse_TransformInfoHeader(blob);
		/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
		hdr.ename = blob.read_shift(0, '8lpp4');
		hdr.blksz = blob.read_shift(4);
		hdr.cmode = blob.read_shift(4);
		if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
		return hdr;
	}
	
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var tgt = blob.l + length;
		var o = {};
		o.Flags = (blob.read_shift(4) & 0x3F);
		blob.l += 4;
		o.AlgID = blob.read_shift(4);
		var valid = false;
		switch(o.AlgID) {
			case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
			case 0x6801: valid = (o.Flags == 0x04); break;
			case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
		o.AlgIDHash = blob.read_shift(4);
		o.KeySize = blob.read_shift(4);
		o.ProviderType = blob.read_shift(4);
		blob.l += 8;
		o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
		blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		var o = {}, tgt = blob.l + length;
		blob.l += 4; // SaltSize must be 0x10
		o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
		o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
		/*var sz = */blob.read_shift(4);
		o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
	function parse_EncryptionInfo(blob) {
		var vers = parse_CRYPTOVersion(blob);
		switch(vers.Minor) {
			case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
			case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
			case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
		}
		throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
	function parse_EncInfoStd(blob) {
		var flags = blob.read_shift(4);
		if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
		var sz = blob.read_shift(4);
		//var tgt = blob.l + sz;
		var hdr = parse_EncryptionHeader(blob, sz);
		var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
		return { t:"Std", h:hdr, v:verifier };
	}
	/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
	function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
	/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
	function parse_EncInfoAgl(blob) {
		var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
		blob.l+=4;
		var xml = blob.read_shift(blob.length - blob.l, 'utf8');
		var o = {};
		xml.replace(tagregex, function xml_agile(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
				case '<encryption': case '</encryption>': break;
				case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
				case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
				case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
				case '</keyEncryptors>': break;
	
				case '<keyEncryptor': o.uri = y.uri; break;
				case '</keyEncryptor>': break;
				case '<encryptedKey': o.encs.push(y); break;
				default: throw y[0];
			}
		});
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
		if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
		if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
		return o;
	}
	
	
	var RTF = (function() {
		function rtf_to_sheet(d, opts) {
			switch(opts.type) {
				case 'base64': return rtf_to_sheet_str(Base64_decode(d), opts);
				case 'binary': return rtf_to_sheet_str(d, opts);
				case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
	
		/* TODO: this is a stub */
		function rtf_to_sheet_str(str, opts) {
			var o = opts || {};
			var ws = o.dense ? ([]) : ({});
	
			var rows = str.match(/\\trowd.*?\\row\b/g);
			if(!rows.length) throw new Error("RTF missing table");
			var range = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}});
			rows.forEach(function(rowtf, R) {
				if(Array.isArray(ws)) ws[R] = [];
				var rtfre = /\\\w+\b/g;
				var last_index = 0;
				var res;
				var C = -1;
				while((res = rtfre.exec(rowtf))) {
					switch(res[0]) {
						case "\\cell":
							var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
							if(data[0] == " ") data = data.slice(1);
							++C;
							if(data.length) {
								// TODO: value parsing, including codepage adjustments
								var cell = {v: data, t:"s"};
								if(Array.isArray(ws)) ws[R][C] = cell;
								else ws[encode_cell({r:R, c:C})] = cell;
							}
							break;
					}
					last_index = rtfre.lastIndex;
				}
				if(C > range.e.c) range.e.c = C;
			});
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }
	
		/* TODO: this is a stub */
		function sheet_to_rtf(ws) {
			var o = ["{\\rtf1\\ansi"];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				o.push("\\trowd\\trautofit1");
				for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
				o.push("\\pard\\intbl");
				for(C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(" " + (cell.w || (format_cell(cell), cell.w)));
					o.push("\\cell");
				}
				o.push("\\pard\\intbl\\row");
			}
			return o.join("") + "}";
		}
	
		return {
			to_workbook: rtf_to_workbook,
			to_sheet: rtf_to_sheet,
			from_sheet: sheet_to_rtf
		};
	})();
	function hex2RGB(h) {
		var o = h.slice(h[0]==="#"?1:0).slice(0,6);
		return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().slice(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint === 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
		return rgb2Hex(hsl2RGB(hsl));
	}
	
	/* 18.3.1.13 width calculations */
	/* [MS-OI29500] 2.1.595 Column Width & Formatting */
	var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
	function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
	function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
	//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
	//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	/* XLSX/XLSB/XLS specify width in units of MDW */
	function find_mdw_colw(collw) {
		var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
		if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
		MDW = _MDW;
	}
	/* XLML specifies width in terms of pixels */
	/*function find_mdw_wpx(wpx) {
		var delta = Infinity, guess = 0, _MDW = MIN_MDW;
		for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
			guess = char2width_(px2char_(wpx))*256;
			guess = (guess) % 1;
			if(guess > 0.5) guess--;
			if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
		}
		MDW = _MDW;
	}*/
	
	function process_col(coll) {
		if(coll.width) {
			coll.wpx = width2px(coll.width);
			coll.wch = px2char(coll.wpx);
			coll.MDW = MDW;
		} else if(coll.wpx) {
			coll.wch = px2char(coll.wpx);
			coll.width = char2width(coll.wch);
			coll.MDW = MDW;
		} else if(typeof coll.wch == 'number') {
			coll.width = char2width(coll.wch);
			coll.wpx = width2px(coll.width);
			coll.MDW = MDW;
		}
		if(coll.customWidth) delete coll.customWidth;
	}
	
	var DEF_PPI = 96, PPI = DEF_PPI;
	function px2pt(px) { return px * 96 / PPI; }
	function pt2px(pt) { return pt * PPI / 96; }
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	/* 18.8.5 borders CT_Borders */
	function parse_borders(t, styles, themes, opts) {
		styles.Borders = [];
		var border = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<borders': case '<borders>': case '</borders>': break;
	
				/* 18.8.4 border CT_Border */
				case '<border': case '<border>': case '<border/>':
					border = {};
					if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
					if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
					styles.Borders.push(border);
					break;
				case '</border>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<left/>': break;
				case '<left': case '<left>': break;
				case '</left>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<right/>': break;
				case '<right': case '<right>': break;
				case '</right>': break;
	
				/* 18.8.43 top CT_BorderPr */
				case '<top/>': break;
				case '<top': case '<top>': break;
				case '</top>': break;
	
				/* 18.8.6 bottom CT_BorderPr */
				case '<bottom/>': break;
				case '<bottom': case '<bottom>': break;
				case '</bottom>': break;
	
				/* 18.8.13 diagonal CT_BorderPr */
				case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
				case '</diagonal>': break;
	
				/* 18.8.25 horizontal CT_BorderPr */
				case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
				case '</horizontal>': break;
	
				/* 18.8.44 vertical CT_BorderPr */
				case '<vertical': case '<vertical>': case '<vertical/>': break;
				case '</vertical>': break;
	
				/* 18.8.37 start CT_BorderPr */
				case '<start': case '<start>': case '<start/>': break;
				case '</start>': break;
	
				/* 18.8.16 end CT_BorderPr */
				case '<end': case '<end>': case '<end/>': break;
				case '</end>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color>':
					break;
				case '<color/>': case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
				}
			}
		});
	}
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, styles, themes, opts) {
		styles.Fills = [];
		var fill = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fills': case '<fills>': case '</fills>': break;
	
				/* 18.8.20 fill CT_Fill */
				case '<fill>': case '<fill': case '<fill/>':
					fill = {}; styles.Fills.push(fill); break;
				case '</fill>': break;
	
				/* 18.8.24 gradientFill CT_GradientFill */
				case '<gradientFill>': break;
				case '<gradientFill':
				case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;
	
				/* 18.8.32 patternFill CT_PatternFill */
				case '<patternFill': case '<patternFill>':
					if(y.patternType) fill.patternType = y.patternType;
					break;
				case '<patternFill/>': case '</patternFill>': break;
	
				/* 18.8.3 bgColor CT_Color */
				case '<bgColor':
					if(!fill.bgColor) fill.bgColor = {};
					if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
					if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
					break;
				case '<bgColor/>': case '</bgColor>': break;
	
				/* 18.8.19 fgColor CT_Color */
				case '<fgColor':
					if(!fill.fgColor) fill.fgColor = {};
					if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
					break;
				case '<fgColor/>': case '</fgColor>': break;
	
				/* 18.8.38 stop CT_GradientStop */
				case '<stop': case '<stop/>': break;
				case '</stop>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color/>': break;
				case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
				}
			}
		});
	}
	
	/* 18.8.23 fonts CT_Fonts */
	function parse_fonts(t, styles, themes, opts) {
		styles.Fonts = [];
		var font = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fonts': case '<fonts>': case '</fonts>': break;
	
				/* 18.8.22 font CT_Font */
				case '<font': case '<font>': break;
				case '</font>': case '<font/>':
					styles.Fonts.push(font);
					font = {};
					break;
	
				/* 18.8.29 name CT_FontName */
				case '<name': if(y.val) font.name = utf8read(y.val); break;
				case '<name/>': case '</name>': break;
	
				/* 18.8.2  b CT_BooleanProperty */
				case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
				case '<b/>': font.bold = 1; break;
	
				/* 18.8.26 i CT_BooleanProperty */
				case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
				case '<i/>': font.italic = 1; break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					switch(y.val) {
						case "none": font.underline = 0x00; break;
						case "single": font.underline = 0x01; break;
						case "double": font.underline = 0x02; break;
						case "singleAccounting": font.underline = 0x21; break;
						case "doubleAccounting": font.underline = 0x22; break;
					} break;
				case '<u/>': font.underline = 1; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
				case '<strike/>': font.strike = 1; break;
	
				/* 18.4.2  outline CT_BooleanProperty */
				case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
				case '<outline/>': font.outline = 1; break;
	
				/* 18.8.36 shadow CT_BooleanProperty */
				case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
				case '<shadow/>': font.shadow = 1; break;
	
				/* 18.8.12 condense CT_BooleanProperty */
				case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
				case '<condense/>': font.condense = 1; break;
	
				/* 18.8.17 extend CT_BooleanProperty */
				case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
				case '<extend/>': font.extend = 1; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': if(y.val) font.sz = +y.val; break;
				case '<sz/>': case '</sz>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
				case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
				case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.18 family CT_FontFamily */
				case '<family': if(y.val) font.family = parseInt(y.val,10); break;
				case '<family/>': case '</family>': break;
	
				/* 18.8.35 scheme CT_FontScheme */
				case '<scheme': if(y.val) font.scheme = y.val; break;
				case '<scheme/>': case '</scheme>': break;
	
				/* 18.4.1 charset CT_IntProperty */
				case '<charset':
					if(y.val == '1') break;
					y.codepage = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.?.? color CT_Color */
				case '<color':
					if(!font.color) font.color = {};
					if(y.auto) font.color.auto = parsexmlbool(y.auto);
	
					if(y.rgb) font.color.rgb = y.rgb.slice(-6);
					else if(y.indexed) {
						font.color.index = parseInt(y.indexed, 10);
						var icv = XLSIcv[font.color.index];
						if(font.color.index == 81) icv = XLSIcv[1];
						if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
						font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
					} else if(y.theme) {
						font.color.theme = parseInt(y.theme, 10);
						if(y.tint) font.color.tint = parseFloat(y.tint);
						if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
							font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
						}
					}
	
					break;
				case '<color/>': case '</color>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
				}
			}
		});
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, styles, opts) {
		styles.NumberFmt = [];
		var k/*Array<number>*/ = (keys(table_fmt));
		for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = table_fmt[k[i]];
		var m = t[0].match(tagregex);
		if(!m) return;
		for(i=0; i < m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(strip_ns(y[0])) {
				case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
				case '<numFmt': {
					var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
					styles.NumberFmt[j] = f;
					if(j>0) {
						if(j > 0x188) {
							for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
							styles.NumberFmt[j] = f;
						}
						SSF_load(f,j);
					}
				} break;
				case '</numFmt>': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
			}
		}
	}
	
	function write_numFmts(NF) {
		var o = ["<numFmts>"];
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
			for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
		});
		if(o.length === 1) return "";
		o[o.length] = ("</numFmts>");
		o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
		return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
	var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
	function parse_cellXfs(t, styles, opts) {
		styles.CellXf = [];
		var xf;
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x), i = 0;
			switch(strip_ns(y[0])) {
				case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;
	
				/* 18.8.45 xf CT_Xf */
				case '<xf': case '<xf/>':
					xf = y;
					delete xf[0];
					for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
						xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
					for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
						xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
					if(styles.NumberFmt && xf.numFmtId > 0x188) {
						for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
					}
					styles.CellXf.push(xf); break;
				case '</xf>': break;
	
				/* 18.8.1 alignment CT_CellAlignment */
				case '<alignment': case '<alignment/>':
					var alignment = {};
					if(y.vertical) alignment.vertical = y.vertical;
					if(y.horizontal) alignment.horizontal = y.horizontal;
					if(y.textRotation != null) alignment.textRotation = y.textRotation;
					if(y.indent) alignment.indent = y.indent;
					if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
					xf.alignment = alignment;
					break;
				case '</alignment>': break;
	
				/* 18.8.33 protection CT_CellProtection */
				case '<protection':
					break;
				case '</protection>': case '<protection/>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
				}
			}
		});
	}
	
	function write_cellXfs(cellXfs) {
		var o = [];
		o[o.length] = (writextag('cellXfs',null));
		cellXfs.forEach(function(c) {
			o[o.length] = (writextag('xf', null, c));
		});
		o[o.length] = ("</cellXfs>");
		if(o.length === 2) return "";
		o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
		return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml= (function make_pstyx() {
	var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
	var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
	var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
	var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
	var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
	
	return function parse_sty_xml(data, themes, opts) {
		var styles = {};
		if(!data) return styles;
		data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		/* 18.8.39 styleSheet CT_Stylesheet */
		var t;
	
		/* 18.8.31 numFmts CT_NumFmts ? */
		if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);
	
		/* 18.8.23 fonts CT_Fonts ? */
		if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);
	
		/* 18.8.21 fills CT_Fills ? */
		if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);
	
		/* 18.8.5  borders CT_Borders ? */
		if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);
	
		/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
		/* 18.8.8  cellStyles CT_CellStyles ? */
	
		/* 18.8.10 cellXfs CT_CellXfs ? */
		if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);
	
		/* 18.8.15 dxfs CT_Dxfs ? */
		/* 18.8.42 tableStyles CT_TableStyles ? */
		/* 18.8.11 colors CT_Colors ? */
		/* 18.2.10 extLst CT_ExtensionList ? */
	
		return styles;
	};
	})();
	
	function write_sty_xml(wb, opts) {
		var o = [XML_HEADER, writextag('styleSheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:vt': XMLNS.vt
		})], w;
		if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
		o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
		o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
		o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
		o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
		if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
		o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
		o[o.length] = ('<dxfs count="0"/>');
		o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
		if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.657 BrtFmt */
	function parse_BrtFmt(data, length) {
		var numFmtId = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [numFmtId, stFmtCode];
	}
	function write_BrtFmt(i, f, o) {
		if(!o) o = new_buf(6 + 4 * f.length);
		o.write_shift(2, i);
		write_XLWideString(f, o);
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(o.l == null) o.l = o.length;
		return out;
	}
	
	/* [MS-XLSB] 2.4.659 BrtFont TODO */
	function parse_BrtFont(data, length, opts) {
		var out = ({});
	
		out.sz = data.read_shift(2) / 20;
	
		var grbit = parse_FontFlags(data, 2, opts);
		if(grbit.fItalic) out.italic = 1;
		if(grbit.fCondense) out.condense = 1;
		if(grbit.fExtend) out.extend = 1;
		if(grbit.fShadow) out.shadow = 1;
		if(grbit.fOutline) out.outline = 1;
		if(grbit.fStrikeout) out.strike = 1;
	
		var bls = data.read_shift(2);
		if(bls === 0x02BC) out.bold = 1;
	
		switch(data.read_shift(2)) {
			/* case 0: out.vertAlign = "baseline"; break; */
			case 1: out.vertAlign = "superscript"; break;
			case 2: out.vertAlign = "subscript"; break;
		}
	
		var underline = data.read_shift(1);
		if(underline != 0) out.underline = underline;
	
		var family = data.read_shift(1);
		if(family > 0) out.family = family;
	
		var bCharSet = data.read_shift(1);
		if(bCharSet > 0) out.charset = bCharSet;
	
		data.l++;
		out.color = parse_BrtColor(data, 8);
	
		switch(data.read_shift(1)) {
			/* case 0: out.scheme = "none": break; */
			case 1: out.scheme = "major"; break;
			case 2: out.scheme = "minor"; break;
		}
	
		out.name = parse_XLWideString(data, length - 21);
	
		return out;
	}
	function write_BrtFont(font, o) {
		if(!o) o = new_buf(25+4*32);
		o.write_shift(2, font.sz * 20);
		write_FontFlags(font, o);
		o.write_shift(2, font.bold ? 0x02BC : 0x0190);
		var sss = 0;
		if(font.vertAlign == "superscript") sss = 1;
		else if(font.vertAlign == "subscript") sss = 2;
		o.write_shift(2, sss);
		o.write_shift(1, font.underline || 0);
		o.write_shift(1, font.family || 0);
		o.write_shift(1, font.charset || 0);
		o.write_shift(1, 0);
		write_BrtColor(font.color, o);
		var scheme = 0;
		if(font.scheme == "major") scheme = 1;
		if(font.scheme == "minor") scheme = 2;
		o.write_shift(1, scheme);
		write_XLWideString(font.name, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFill */
	var XLSBFillPTNames = [
		"none",
		"solid",
		"mediumGray",
		"darkGray",
		"lightGray",
		"darkHorizontal",
		"darkVertical",
		"darkDown",
		"darkUp",
		"darkGrid",
		"darkTrellis",
		"lightHorizontal",
		"lightVertical",
		"lightDown",
		"lightUp",
		"lightGrid",
		"lightTrellis",
		"gray125",
		"gray0625"
	];
	var rev_XLSBFillPTNames;
	/* TODO: gradient fill representation */
	var parse_BrtFill = parsenoop;
	function write_BrtFill(fill, o) {
		if(!o) o = new_buf(4*3 + 8*7 + 16*1);
		if(!rev_XLSBFillPTNames) rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
		var fls = rev_XLSBFillPTNames[fill.patternType];
		if(fls == null) fls = 0x28;
		o.write_shift(4, fls);
		var j = 0;
		if(fls != 0x28) {
			/* TODO: custom FG Color */
			write_BrtColor({auto:1}, o);
			/* TODO: custom BG Color */
			write_BrtColor({auto:1}, o);
	
			for(; j < 12; ++j) o.write_shift(4, 0);
		} else {
			for(; j < 4; ++j) o.write_shift(4, 0);
	
			for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
			/* iGradientType */
			/* xnumDegree */
			/* xnumFillToLeft */
			/* xnumFillToRight */
			/* xnumFillToTop */
			/* xnumFillToBottom */
			/* cNumStop */
			/* xfillGradientStop */
		}
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.824 BrtXF */
	function parse_BrtXF(data, length) {
		var tgt = data.l + length;
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		data.l = tgt;
		return {ixfe:ixfeParent, numFmtId:ifmt };
	}
	function write_BrtXF(data, ixfeP, o) {
		if(!o) o = new_buf(16);
		o.write_shift(2, ixfeP||0);
		o.write_shift(2, data.numFmtId||0);
		o.write_shift(2, 0); /* iFont */
		o.write_shift(2, 0); /* iFill */
		o.write_shift(2, 0); /* ixBorder */
		o.write_shift(1, 0); /* trot */
		o.write_shift(1, 0); /* indent */
		var flow = 0;
		o.write_shift(1, flow); /* flags */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* xfGrbitAtr */
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.4 Blxf TODO */
	function write_Blxf(data, o) {
		if(!o) o = new_buf(10);
		o.write_shift(1, 0); /* dg */
		o.write_shift(1, 0);
		o.write_shift(4, 0); /* color */
		o.write_shift(4, 0); /* color */
		return o;
	}
	/* [MS-XLSB] 2.4.302 BrtBorder TODO */
	var parse_BrtBorder = parsenoop;
	function write_BrtBorder(border, o) {
		if(!o) o = new_buf(51);
		o.write_shift(1, 0); /* diagonal */
		write_Blxf(null, o); /* top */
		write_Blxf(null, o); /* bottom */
		write_Blxf(null, o); /* left */
		write_Blxf(null, o); /* right */
		write_Blxf(null, o); /* diag */
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.763 BrtStyle TODO */
	function write_BrtStyle(style, o) {
		if(!o) o = new_buf(12+4*10);
		o.write_shift(4, style.xfId);
		o.write_shift(2, 1);
		o.write_shift(1, +style.builtinId);
		o.write_shift(1, 0); /* iLevel */
		write_XLNullableWideString(style.name || "", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
	function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
		var o = new_buf(4+256*2*4);
		o.write_shift(4, cnt);
		write_XLNullableWideString(defTableStyle, o);
		write_XLNullableWideString(defPivotStyle, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, themes, opts) {
		var styles = {};
		styles.NumberFmt = ([]);
		for(var y in table_fmt) styles.NumberFmt[y] = table_fmt[y];
	
		styles.CellXf = [];
		styles.Fonts = [];
		var state = [];
		var pass = false;
		recordhopper(data, function hopper_sty(val, R, RT) {
			switch(RT) {
				case 0x002C: /* BrtFmt */
					styles.NumberFmt[val[0]] = val[1]; SSF_load(val[1], val[0]);
					break;
				case 0x002B: /* BrtFont */
					styles.Fonts.push(val);
					if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
						val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
					}
					break;
				case 0x0401: /* BrtKnownFonts */ break;
				case 0x002D: /* BrtFill */
					break;
				case 0x002E: /* BrtBorder */
					break;
				case 0x002F: /* BrtXF */
					if(state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */) {
						styles.CellXf.push(val);
					}
					break;
				case 0x0030: /* BrtStyle */
				case 0x01FB: /* BrtDXF */
				case 0x023C: /* BrtMRUColor */
				case 0x01DB: /* BrtIndexedColor */
					break;
	
				case 0x0493: /* BrtDXF14 */
				case 0x0836: /* BrtDXF15 */
				case 0x046A: /* BrtSlicerStyleElement */
				case 0x0200: /* BrtTableStyleElement */
				case 0x082F: /* BrtTimelineStyleElement */
				case 0x0C00: /* BrtUid */
					break;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
				case 0x0025: /* BrtACBegin */
					state.push(RT); pass = true; break;
				case 0x0026: /* BrtACEnd */
					state.pop(); pass = false; break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return styles;
	}
	
	function write_FMTS_bin(ba, NF) {
		if(!NF) return;
		var cnt = 0;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
		});
	
		if(cnt == 0) return;
		write_record(ba, 0x0267 /* BrtBeginFmts */, write_UInt32LE(cnt));
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, 0x002C /* BrtFmt */, write_BrtFmt(i, NF[i]));
		});
		write_record(ba, 0x0268 /* BrtEndFmts */);
	}
	
	function write_FONTS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0263 /* BrtBeginFonts */, write_UInt32LE(cnt));
		write_record(ba, 0x002B /* BrtFont */, write_BrtFont({
			sz:12,
			color: {theme:1},
			name: "Calibri",
			family: 2,
			scheme: "minor"
		}));
		/* 1*65491BrtFont [ACFONTS] */
		write_record(ba, 0x0264 /* BrtEndFonts */);
	}
	
	function write_FILLS_bin(ba) {
		var cnt = 2;
	
		if(cnt == 0) return;
		write_record(ba, 0x025B /* BrtBeginFills */, write_UInt32LE(cnt));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"none"}));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"gray125"}));
		/* 1*65431BrtFill */
		write_record(ba, 0x025C /* BrtEndFills */);
	}
	
	function write_BORDERS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0265 /* BrtBeginBorders */, write_UInt32LE(cnt));
		write_record(ba, 0x002E /* BrtBorder */, write_BrtBorder({}));
		/* 1*65430BrtBorder */
		write_record(ba, 0x0266 /* BrtEndBorders */);
	}
	
	function write_CELLSTYLEXFS_bin(ba) {
		var cnt = 1;
		write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */, write_UInt32LE(cnt));
		write_record(ba, 0x002F /* BrtXF */, write_BrtXF({
			numFmtId: 0,
			fontId:   0,
			fillId:   0,
			borderId: 0
		}, 0xFFFF));
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x0273 /* BrtEndCellStyleXFs */);
	}
	
	function write_CELLXFS_bin(ba, data) {
		write_record(ba, 0x0269 /* BrtBeginCellXFs */, write_UInt32LE(data.length));
		data.forEach(function(c) { write_record(ba, 0x002F /* BrtXF */, write_BrtXF(c,0)); });
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x026A /* BrtEndCellXFs */);
	}
	
	function write_STYLES_bin(ba) {
		var cnt = 1;
	
		write_record(ba, 0x026B /* BrtBeginStyles */, write_UInt32LE(cnt));
		write_record(ba, 0x0030 /* BrtStyle */, write_BrtStyle({
			xfId:0,
			builtinId:0,
			name:"Normal"
		}));
		/* 1*65430(BrtStyle *FRT) */
		write_record(ba, 0x026C /* BrtEndStyles */);
	}
	
	function write_DXFS_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01F9 /* BrtBeginDXFs */, write_UInt32LE(cnt));
		/* *2147483647(BrtDXF *FRT) */
		write_record(ba, 0x01FA /* BrtEndDXFs */);
	}
	
	function write_TABLESTYLES_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01FC /* BrtBeginTableStyles */, write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
		/* *TABLESTYLE */
		write_record(ba, 0x01FD /* BrtEndTableStyles */);
	}
	
	function write_COLORPALETTE_bin() {
		return;
		/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0116 /* BrtBeginStyleSheet */);
		write_FMTS_bin(ba, wb.SSF);
		write_FONTS_bin(ba, wb);
		write_FILLS_bin(ba, wb);
		write_BORDERS_bin(ba, wb);
		write_CELLSTYLEXFS_bin(ba, wb);
		write_CELLXFS_bin(ba, opts.cellXfs);
		write_STYLES_bin(ba, wb);
		write_DXFS_bin(ba, wb);
		write_TABLESTYLES_bin(ba, wb);
		write_COLORPALETTE_bin(ba, wb);
		/* FRTSTYLESHEET*/
		write_record(ba, 0x0117 /* BrtEndStyleSheet */);
		return ba.end();
	}
	/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
	var XLSXThemeClrScheme = [
		'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
		'</a:accent1>', '</a:accent2>', '</a:accent3>',
		'</a:accent4>', '</a:accent5>', '</a:accent6>',
		'</a:hlink>', '</a:folHlink>'
	];
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, themes, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr':
					color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr':
					color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.1 accent1 (Accent 1) */
				/* 20.1.4.1.2 accent2 (Accent 2) */
				/* 20.1.4.1.3 accent3 (Accent 3) */
				/* 20.1.4.1.4 accent4 (Accent 4) */
				/* 20.1.4.1.5 accent5 (Accent 5) */
				/* 20.1.4.1.6 accent6 (Accent 6) */
				/* 20.1.4.1.9 dk1 (Dark 1) */
				/* 20.1.4.1.10 dk2 (Dark 2) */
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				/* 20.1.4.1.19 hlink (Hyperlink) */
				/* 20.1.4.1.22 lt1 (Light 1) */
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:dk1>': case '</a:dk1>':
				case '<a:lt1>': case '</a:lt1>':
				case '<a:dk2>': case '</a:dk2>':
				case '<a:lt2>': case '</a:lt2>':
				case '<a:accent1>': case '</a:accent1>':
				case '<a:accent2>': case '</a:accent2>':
				case '<a:accent3>': case '</a:accent3>':
				case '<a:accent4>': case '</a:accent4>':
				case '<a:accent5>': case '</a:accent5>':
				case '<a:accent6>': case '</a:accent6>':
				case '<a:hlink>': case '</a:hlink>':
				case '<a:folHlink>': case '</a:folHlink>':
					if (y[0].charAt(1) === '/') {
						themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
						color = {};
					} else {
						color.name = y[0].slice(3, y[0].length - 1);
					}
					break;
	
				default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme() { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme() { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, themes, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
			m[2](t, themes, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) data = write_theme();
	
		var t;
		var themes = {};
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
		parse_themeElements(t[0], themes, opts);
		themes.raw = data;
		return themes;
	}
	
	function write_theme(Themes, opts) {
		if(opts && opts.themeXLSX) return opts.themeXLSX;
		if(Themes && typeof Themes.raw == "string") return Themes.raw;
		var o = [XML_HEADER];
		o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
		o[o.length] =  '<a:themeElements>';
	
		o[o.length] =   '<a:clrScheme name="Office">';
		o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
		o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
		o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
		o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
		o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
		o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
		o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
		o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
		o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
		o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
		o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
		o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
		o[o.length] =   '</a:clrScheme>';
	
		o[o.length] =   '<a:fontScheme name="Office">';
		o[o.length] =    '<a:majorFont>';
		o[o.length] =     '<a:latin typeface="Cambria"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:majorFont>';
		o[o.length] =    '<a:minorFont>';
		o[o.length] =     '<a:latin typeface="Calibri"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:minorFont>';
		o[o.length] =   '</a:fontScheme>';
	
		o[o.length] =   '<a:fmtScheme name="Office">';
		o[o.length] =    '<a:fillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:fillStyleLst>';
		o[o.length] =    '<a:lnStyleLst>';
		o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =    '</a:lnStyleLst>';
		o[o.length] =    '<a:effectStyleLst>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
		o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =    '</a:effectStyleLst>';
		o[o.length] =    '<a:bgFillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:bgFillStyleLst>';
		o[o.length] =   '</a:fmtScheme>';
		o[o.length] =  '</a:themeElements>';
	
		o[o.length] =  '<a:objectDefaults>';
		o[o.length] =   '<a:spDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:spDef>';
		o[o.length] =   '<a:lnDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:lnDef>';
		o[o.length] =  '</a:objectDefaults>';
		o[o.length] =  '<a:extraClrSchemeLst/>';
		o[o.length] = '</a:theme>';
		return o.join("");
	}
	/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length, opts) {
		var end = blob.l + length;
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		if(!opts.cellStyles) { blob.l = end; return; }
		var data = blob.slice(blob.l);
		blob.l = end;
		var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
		var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
		if(!themeXML) return;
		return parse_theme_xml(themeXML, opts);
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* [MS-XLS] 2.5.108 */
	function parse_ExtProp(blob) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2) - 4;
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x06: break; /* gradient fill */
				case 0x07: break; /* top cell border color */
				case 0x08: break; /* bottom cell border color */
				case 0x09: break; /* left cell border color */
				case 0x0a: break; /* right cell border color */
				case 0x0b: break; /* diagonal cell border color */
				case 0x0d: /* text color */
					break;
				case 0x0e: break; /* font scheme */
				case 0x0f: break; /* indentation level */
			}
		});
	}
	
	function parse_BrtMdtinfo(data, length) {
	  return {
	    flags: data.read_shift(4),
	    version: data.read_shift(4),
	    name: parse_XLWideString(data, length - 8)
	  };
	}
	function write_BrtMdtinfo(data) {
	  var o = new_buf(12 + 2 * data.name.length);
	  o.write_shift(4, data.flags);
	  o.write_shift(4, data.version);
	  write_XLWideString(data.name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtMdb(data) {
	  var out = [];
	  var cnt = data.read_shift(4);
	  while (cnt-- > 0)
	    out.push([data.read_shift(4), data.read_shift(4)]);
	  return out;
	}
	function write_BrtMdb(mdb) {
	  var o = new_buf(4 + 8 * mdb.length);
	  o.write_shift(4, mdb.length);
	  for (var i = 0; i < mdb.length; ++i) {
	    o.write_shift(4, mdb[i][0]);
	    o.write_shift(4, mdb[i][1]);
	  }
	  return o;
	}
	function write_BrtBeginEsfmd(cnt, name) {
	  var o = new_buf(8 + 2 * name.length);
	  o.write_shift(4, cnt);
	  write_XLWideString(name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtBeginEsmdb(data) {
	  data.l += 4;
	  return data.read_shift(4) != 0;
	}
	function write_BrtBeginEsmdb(cnt, cm) {
	  var o = new_buf(8);
	  o.write_shift(4, cnt);
	  o.write_shift(4, cm ? 1 : 0);
	  return o;
	}
	function parse_xlmeta_bin(data, name, _opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  var opts = _opts || {};
	  var state = [];
	  var pass = false;
	  var metatype = 2;
	  recordhopper(data, function(val, R, RT) {
	    switch (RT) {
	      case 335:
	        out.Types.push({ name: val.name });
	        break;
	      case 51:
	        val.forEach(function(r) {
	          if (metatype == 1)
	            out.Cell.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	          else if (metatype == 0)
	            out.Value.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	        });
	        break;
	      case 337:
	        metatype = val ? 1 : 0;
	        break;
	      case 338:
	        metatype = 2;
	        break;
	      case 35:
	        state.push(RT);
	        pass = true;
	        break;
	      case 36:
	        state.pop();
	        pass = false;
	        break;
	      default:
	        if (R.T) {
	        } else if (!pass || opts.WTF && state[state.length - 1] != 35)
	          throw new Error("Unexpected record 0x" + RT.toString(16));
	    }
	  });
	  return out;
	}
	function write_xlmeta_bin() {
	  var ba = buf_array();
	  write_record(ba, 332);
	  write_record(ba, 334, write_UInt32LE(1));
	  write_record(ba, 335, write_BrtMdtinfo({
	    name: "XLDAPR",
	    version: 12e4,
	    flags: 3496657072
	  }));
	  write_record(ba, 336);
	  write_record(ba, 339, write_BrtBeginEsfmd(1, "XLDAPR"));
	  write_record(ba, 52);
	  write_record(ba, 35, write_UInt32LE(514));
	  write_record(ba, 4096, write_UInt32LE(0));
	  write_record(ba, 4097, writeuint16(1));
	  write_record(ba, 36);
	  write_record(ba, 53);
	  write_record(ba, 340);
	  write_record(ba, 337, write_BrtBeginEsmdb(1, true));
	  write_record(ba, 51, write_BrtMdb([[1, 0]]));
	  write_record(ba, 338);
	  write_record(ba, 333);
	  return ba.end();
	}
	function parse_xlmeta_xml(data, name, opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  if (!data)
	    return out;
	  var pass = false;
	  var metatype = 2;
	  var lastmeta;
	  data.replace(tagregex, function(x) {
	    var y = parsexmltag(x);
	    switch (strip_ns(y[0])) {
	      case "<?xml":
	        break;
	      case "<metadata":
	      case "</metadata>":
	        break;
	      case "<metadataTypes":
	      case "</metadataTypes>":
	        break;
	      case "<metadataType":
	        out.Types.push({ name: y.name });
	        break;
	      case "</metadataType>":
	        break;
	      case "<futureMetadata":
	        for (var j = 0; j < out.Types.length; ++j)
	          if (out.Types[j].name == y.name)
	            lastmeta = out.Types[j];
	        break;
	      case "</futureMetadata>":
	        break;
	      case "<bk>":
	        break;
	      case "</bk>":
	        break;
	      case "<rc":
	        if (metatype == 1)
	          out.Cell.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        else if (metatype == 0)
	          out.Value.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        break;
	      case "</rc>":
	        break;
	      case "<cellMetadata":
	        metatype = 1;
	        break;
	      case "</cellMetadata>":
	        metatype = 2;
	        break;
	      case "<valueMetadata":
	        metatype = 0;
	        break;
	      case "</valueMetadata>":
	        metatype = 2;
	        break;
	      case "<extLst":
	      case "<extLst>":
	      case "</extLst>":
	      case "<extLst/>":
	        break;
	      case "<ext":
	        pass = true;
	        break;
	      case "</ext>":
	        pass = false;
	        break;
	      case "<rvb":
	        if (!lastmeta)
	          break;
	        if (!lastmeta.offsets)
	          lastmeta.offsets = [];
	        lastmeta.offsets.push(+y.i);
	        break;
	      default:
	        if (!pass && opts.WTF)
	          throw new Error("unrecognized " + y[0] + " in metadata");
	    }
	    return x;
	  });
	  return out;
	}
	function write_xlmeta_xml() {
	  var o = [XML_HEADER];
	  o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
	  return o.join("");
	}
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data) {
		var d = [];
		if(!data) return d;
		var i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	//function write_cc_xml(data, opts) { }
	
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, name, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R, RT) {
			switch(RT) {
				case 0x003F: /* 'BrtCalcChainItem$' */
					out.push(val); break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	//function write_cc_bin(data, opts) { }
	/* 18.14 Supplementary Workbook Data */
	function parse_xlink_xml() {
		//var opts = _opts || {};
		//if(opts.WTF) throw "XLSX External Link";
	}
	
	/* [MS-XLSB] 2.1.7.25 External Link */
	function parse_xlink_bin(data, rel, name, _opts) {
		if(!data) return data;
		var opts = _opts || {};
	
		var pass = false, end = false;
	
		recordhopper(data, function xlink_parse(val, R, RT) {
			if(end) return;
			switch(RT) {
				case 0x0167: /* 'BrtSupTabs' */
				case 0x016B: /* 'BrtExternTableStart' */
				case 0x016C: /* 'BrtExternTableEnd' */
				case 0x016E: /* 'BrtExternRowHdr' */
				case 0x016F: /* 'BrtExternCellBlank' */
				case 0x0170: /* 'BrtExternCellReal' */
				case 0x0171: /* 'BrtExternCellBool' */
				case 0x0172: /* 'BrtExternCellError' */
				case 0x0173: /* 'BrtExternCellString' */
				case 0x01D8: /* 'BrtExternValueMeta' */
				case 0x0241: /* 'BrtSupNameStart' */
				case 0x0242: /* 'BrtSupNameValueStart' */
				case 0x0243: /* 'BrtSupNameValueEnd' */
				case 0x0244: /* 'BrtSupNameNum' */
				case 0x0245: /* 'BrtSupNameErr' */
				case 0x0246: /* 'BrtSupNameSt' */
				case 0x0247: /* 'BrtSupNameNil' */
				case 0x0248: /* 'BrtSupNameBool' */
				case 0x0249: /* 'BrtSupNameFmla' */
				case 0x024A: /* 'BrtSupNameBits' */
				case 0x024B: /* 'BrtSupNameEnd' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	}
	/* 20.5 DrawingML - SpreadsheetML Drawing */
	/* 20.5.2.35 wsDr CT_Drawing */
	function parse_drawing(data, rels) {
		if(!data) return "??";
		/*
		  Chartsheet Drawing:
		   - 20.5.2.35 wsDr CT_Drawing
		    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
		     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
		      - 20.1.2.2.16 graphic CT_GraphicalObject
		       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
	          - chart reference
		   the actual type is based on the URI of the graphicData
			TODO: handle embedded charts and other types of graphics
		*/
		var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];
	
		return rels['!id'][id].Target;
	}
	
	/* L.5.5.2 SpreadsheetML Comments + VML Schema */
	var _shapeid = 1024;
	function write_comments_vml(rId, comments) {
		var csize = [21600, 21600];
		/* L.5.2.1.2 Path Attribute */
		var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
		var o = [
			writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
			writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
			writextag("v:shapetype", [
				writextag("v:stroke", null, {joinstyle:"miter"}),
				writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
			].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
		];
		while(_shapeid < rId * 1000) _shapeid += 1000;
	
		comments.forEach(function(x) {
		var c = decode_cell(x[0]);
		var fillopts = {'color2':"#BEFF82", 'type':"gradient"};
		if(fillopts.type == "gradient") fillopts.angle = "-180";
		var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
		var fillxml = writextag('v:fill', fillparm, fillopts);
	
		var shadata = ({on:"t", 'obscured':"t"});
		++_shapeid;
	
		o = o.concat([
		'<v:shape' + wxt_helper({
			id:'_x0000_s' + _shapeid,
			type:"#_x0000_t202",
			style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
			fillcolor:"#ECFAD4",
			strokecolor:"#edeaa1"
		}) + '>',
			fillxml,
			writextag("v:shadow", null, shadata),
			writextag("v:path", null, {'o:connecttype':"none"}),
			'<v:textbox><div style="text-align:left"></div></v:textbox>',
			'<x:ClientData ObjectType="Note">',
				'<x:MoveWithCells/>',
				'<x:SizeWithCells/>',
				/* Part 4 19.4.2.3 Anchor (Anchor) */
				writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
				writetag('x:AutoFill', "False"),
				writetag('x:Row', String(c.r)),
				writetag('x:Column', String(c.c)),
				x[1].hidden ? '' : '<x:Visible/>',
			'</x:ClientData>',
		'</v:shape>'
		]); });
		o.push('</xml>');
		return o.join("");
	}
	function sheet_insert_comments(sheet, comments, threaded, people) {
		var dense = Array.isArray(sheet);
		var cell;
		comments.forEach(function(comment) {
			var r = decode_cell(comment.ref);
			if(dense) {
				if(!sheet[r.r]) sheet[r.r] = [];
				cell = sheet[r.r][r.c];
			} else cell = sheet[comment.ref];
			if (!cell) {
				cell = ({t:"z"});
				if(dense) sheet[r.r][r.c] = cell;
				else sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				if(range.s.r > r.r) range.s.r = r.r;
				if(range.e.r < r.r) range.e.r = r.r;
				if(range.s.c > r.c) range.s.c = r.c;
				if(range.e.c < r.c) range.e.c = r.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = ({a: comment.author, t: comment.t, r: comment.r, T: threaded});
			if(comment.h) o.h = comment.h;
	
			/* threaded comments always override */
			for(var i = cell.c.length - 1; i >= 0; --i) {
				if(!threaded && cell.c[i].T) return;
				if(threaded && !cell.c[i].T) cell.c.splice(i, 1);
			}
			if(threaded && people) for(i = 0; i < people.length; ++i) {
				if(o.a == people[i].id) { o.a = people[i].name || o.a; break; }
			}
			cell.c.push(o);
		});
	}
	
	/* 18.7 Comments */
	function parse_comments_xml(data, opts) {
		/* 18.7.6 CT_Comments */
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
		if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
			if(a) authors.push(a[1]);
		});
		var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
		if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
			if(!cm) return;
			var y = parsexmltag(cm[0]);
			var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
			var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
			comment.r = rt.r;
			if(rt.r == "<t></t>") rt.t = rt.h = "";
			comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	function write_comments_xml(data) {
		var o = [XML_HEADER, writextag('comments', null, { 'xmlns': XMLNS_main[0] })];
	
		var iauthor = [];
		o.push("<authors>");
		data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
			if(iauthor.indexOf(a) == -1) {
				iauthor.push(a);
				o.push("<author>" + a + "</author>");
			}
			if(w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
				iauthor.push("tc=" + w.ID);
				o.push("<author>" + "tc=" + w.ID + "</author>");
			}
		}); });
		if(iauthor.length == 0) { iauthor.push("SheetJ5"); o.push("<author>SheetJ5</author>"); }
		o.push("</authors>");
		o.push("<commentList>");
		data.forEach(function(d) {
			/* 18.7.3 CT_Comment */
			var lastauthor = 0, ts = [];
			if(d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
			else d[1].forEach(function(c) {
				if(c.a) lastauthor = iauthor.indexOf(escapexml(c.a));
				ts.push(c.t||"");
			});
			o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
			if(ts.length <= 1) o.push(writetag("t", escapexml(ts[0]||"")));
			else {
				/* based on Threaded Comments -> Comments projection */
				var t = "Comment:\n    " + (ts[0]) + "\n";
				for(var i = 1; i < ts.length; ++i) t += "Reply:\n    " + ts[i] + "\n";
				o.push(writetag("t", escapexml(t)));
			}
			o.push('</text></comment>');
		});
		o.push("</commentList>");
		if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.17 */
	function parse_tcmnt_xml(data, opts) {
		var out = [];
		var pass = false, comment = {}, tidx = 0;
		data.replace(tagregex, function xml_tcmnt(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.6.207 ThreadedComments CT_ThreadedComments */
				case '<ThreadedComments': break;
				case '</ThreadedComments>': break;
	
				/* 2.6.205 threadedComment CT_ThreadedComment */
				case '<threadedComment': comment = {author: y.personId, guid: y.id, ref: y.ref, T: 1}; break;
				case '</threadedComment>': if(comment.t != null) out.push(comment); break;
	
				case '<text>': case '<text': tidx = idx + x.length; break;
				case '</text>': comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n"); break;
	
				/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
				case '<mentions': case '<mentions>': pass = true; break;
				case '</mentions>': pass = false; break;
	
				/* 2.6.202 mention CT_Mention TODO */
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	
	function write_tcmnt_xml(comments, people, opts) {
		var o = [XML_HEADER, writextag('ThreadedComments', null, { 'xmlns': XMLNS.TCMNT }).replace(/[\/]>/, ">")];
		comments.forEach(function(carr) {
			var rootid = "";
			(carr[1] || []).forEach(function(c, idx) {
				if(!c.T) { delete c.ID; return; }
				if(c.a && people.indexOf(c.a) == -1) people.push(c.a);
				var tcopts = {
					ref: carr[0],
					id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
				};
				if(idx == 0) rootid = tcopts.id;
				else tcopts.parentId = rootid;
				c.ID = tcopts.id;
				if(c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
				o.push(writextag('threadedComment', writetag('text', c.t||""), tcopts));
			});
		});
		o.push('</ThreadedComments>');
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.18 */
	function parse_people_xml(data, opts) {
		var out = [];
		var pass = false;
		data.replace(tagregex, function xml_tcmnt(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.4.85 personList CT_PersonList */
				case '<personList': break;
				case '</personList>': break;
	
				/* 2.6.203 person CT_Person TODO: providers */
				case '<person': out.push({name: y.displayname, id: y.id }); break;
				case '</person>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	function write_people_xml(people/*, opts*/) {
		var o = [XML_HEADER, writextag('personList', null, {
			'xmlns': XMLNS.TCMNT,
			'xmlns:x': XMLNS_main[0]
		}).replace(/[\/]>/, ">")];
		people.forEach(function(person, idx) {
			o.push(writextag('person', null, {
				displayName: person,
				id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
				userId: person,
				providerId: "None"
			}));
		});
		o.push("</personList>");
		return o.join("");
	}
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	function write_BrtBeginComment(data, o) {
		if(o == null) o = new_buf(36);
		o.write_shift(4, data[1].iauthor);
		write_UncheckedRfX((data[0]), o);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R, RT) {
			switch(RT) {
				case 0x0278: /* 'BrtCommentAuthor' */
					authors.push(val); break;
				case 0x027B: /* 'BrtBeginComment' */
					c = val; break;
				case 0x027D: /* 'BrtCommentText' */
					c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 0x027C: /* 'BrtEndComment' */
					c.author = authors[c.iauthor];
					delete (c).iauthor;
					if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
					if(!c.t) c.t = "";
					delete c.rfx; out.push(c); break;
	
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	function write_comments_bin(data) {
		var ba = buf_array();
		var iauthor = [];
		write_record(ba, 0x0274 /* BrtBeginComments */);
	
		write_record(ba, 0x0276 /* BrtBeginCommentAuthors */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				if(iauthor.indexOf(c.a) > -1) return;
				iauthor.push(c.a.slice(0,54));
				write_record(ba, 0x0278 /* BrtCommentAuthor */, write_BrtCommentAuthor(c.a));
			});
		});
		write_record(ba, 0x0277 /* BrtEndCommentAuthors */);
	
		write_record(ba, 0x0279 /* BrtBeginCommentList */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				c.iauthor = iauthor.indexOf(c.a);
				var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
				write_record(ba, 0x027B /* BrtBeginComment */, write_BrtBeginComment([range, c]));
				if(c.t && c.t.length > 0) write_record(ba, 0x027D /* BrtCommentText */, write_BrtCommentText(c));
				write_record(ba, 0x027C /* BrtEndComment */);
				delete c.iauthor;
			});
		});
		write_record(ba, 0x027A /* BrtEndCommentList */);
	
		write_record(ba, 0x0275 /* BrtEndComments */);
		return ba.end();
	}
	var CT_VBA = "application/vnd.ms-office.vbaProject";
	function make_vba_xls(cfb) {
	  var newcfb = CFB.utils.cfb_new({ root: "R" });
	  cfb.FullPaths.forEach(function(p, i) {
	    if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
	      return;
	    var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
	    CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
	  });
	  return CFB.write(newcfb);
	}
	function fill_vba_xls(cfb, vba) {
	  vba.FullPaths.forEach(function(p, i) {
	    if (i == 0)
	      return;
	    var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
	    if (newpath.slice(-1) !== "/")
	      CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
	  });
	}
	var VBAFMTS = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
	/* macro and dialog sheet stubs */
	function parse_ds_bin() { return {'!type':'dialog'}; }
	function parse_ds_xml() { return {'!type':'dialog'}; }
	function parse_ms_bin() { return {'!type':'macro'}; }
	function parse_ms_xml() { return {'!type':'macro'}; }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
		var rcbase = ({r:0,c:0});
		function rcfunc($$,$1,$2,$3) {
			var cRel = false, rRel = false;
	
			if($2.length == 0) rRel = true;
			else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }
	
			if($3.length == 0) cRel = true;
			else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }
	
			var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;
	
			if(cRel) C += rcbase.c; else --C;
			if(rRel) R += rcbase.r; else --R;
			return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
	var a1_to_rc = (function(){
		return function a1_to_rc(fstr, base) {
			return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
				var c = decode_col($3) - ($2 ? 0 : base.c);
				var r = decode_row($5) - ($4 ? 0 : base.r);
				var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
				var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
				return $1 + "R" + R + "C" + C;
			});
		};
	})();
	
	/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
	function shift_formula_str(f, delta) {
		return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
		});
	}
	
	function shift_formula_xlsx(f, range, cell) {
		var r = decode_range(range), s = r.s, c = decode_cell(cell);
		var delta = {r:c.r - s.r, c:c.c - s.c};
		return shift_formula_str(f, delta);
	}
	
	/* TODO: parse formula */
	function fuzzyfmla(f) {
		if(f.length == 1) return false;
		return true;
	}
	
	function _xlfn(f) {
		return f.replace(/_xlfn\./g,"");
	}
	function parseread1(blob) { blob.l+=1; return; }
	
	/* [MS-XLS] 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(length == 1 ? 1 : 2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
	function parse_RgceArea(blob, length, opts) {
		var w = 2;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
			else if(opts.biff == 12) w = 4;
		}
		var r=blob.read_shift(w), R=blob.read_shift(w);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	/* BIFF 2-5 encodes flags in the row field */
	function parse_RgceArea_BIFF2(blob) {
		var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
		var c=blob.read_shift(1);
		var C=blob.read_shift(1);
		return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
	function parse_RgceAreaRel(blob, length, opts) {
		if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
		var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
	function parse_RgceLoc(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
		var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	function parse_RgceLoc_BIFF2(blob) {
		var r = parse_ColRelU(blob, 2);
		var c = blob.read_shift(1);
		return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
	}
	
	/* [MS-XLS] 2.5.198.107, 2.5.47 */
	function parse_RgceElfLoc(blob) {
		var r = blob.read_shift(2);
		var c = blob.read_shift(2);
		return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
	}
	
	/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
	function parse_RgceLocRel(blob, length, opts) {
		var biff = opts && opts.biff ? opts.biff : 8;
		if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
		var r = blob.read_shift(biff >= 12 ? 4 : 2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
		cl &= 0x3FFF;
		if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
		if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	function parse_RgceLocRel_BIFF2(blob) {
		var rl = blob.read_shift(2);
		var c = blob.read_shift(1);
		var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
		rl &= 0x3FFF;
		if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
		if(cRel == 1 && c >= 0x80) c = c - 0x100;
		return {r:rl,c:c,cRel:cRel,rRel:rRel};
	}
	
	/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
	function parse_PtgArea(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
	function parse_PtgArea3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2, 'i');
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		var area = parse_RgceArea(blob, w, opts);
		return [type, ixti, area];
	}
	
	/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
	function parse_PtgAreaErr(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
		return [type];
	}
	/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
	function parse_PtgAreaErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
	function parse_PtgAreaN(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, length - 1, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
	function parse_PtgArray(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
	function parse_PtgAttrBaxcel(blob) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
	function parse_PtgAttrChoose(blob, length, opts) {
		blob.l +=2;
		var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
	function parse_PtgAttrGoto(blob, length, opts) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
	function parse_PtgAttrIf(blob, length, opts) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLSB] 2.5.97.28 */
	function parse_PtgAttrIfError(blob) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
	function parse_PtgAttrSemi(blob, length, opts) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += opts && opts.biff == 2 ? 3 : 4;
		return [bitSemi];
	}
	
	/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
	function parse_PtgAttrSpaceType(blob) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
	function parse_PtgAttrSpace(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
	function parse_PtgAttrSpaceSemi(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
	function parse_PtgRef(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
	function parse_PtgRefN(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
	function parse_PtgRef3d(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		if(opts && opts.biff == 5) blob.l += 12;
		var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
		return [type, ixti, loc];
	}
	
	
	/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
	function parse_PtgFunc(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
		return [FtabArgc[iftab], Ftab[iftab], type];
	}
	/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
	function parse_PtgFuncVar(blob, length, opts) {
		var type = blob[blob.l++];
		var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
	function parse_PtgAttrSum(blob, length, opts) {
		blob.l += opts && opts.biff == 2 ? 3 : 4; return;
	}
	
	/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
	function parse_PtgExp(blob, length, opts) {
		blob.l++;
		if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
		var row = blob.read_shift(2);
		var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [row, col];
	}
	
	/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
	function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
	function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }
	
	/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
	function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
	function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
	function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }
	
	/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
	function parse_SerAr(blob, biff) {
		var val = [blob.read_shift(1)];
		if(biff == 12) switch(val[0]) {
			case 0x02: val[0] = 0x04; break; /* SerBool */
			case 0x04: val[0] = 0x10; break; /* SerErr */
			case 0x00: val[0] = 0x01; break; /* SerNum */
			case 0x01: val[0] = 0x02; break; /* SerStr */
		}
		switch(val[0]) {
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				if(biff != 12) blob.l += 7; break;
			case 0x25: /* appears to be an alias */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += ((biff == 12) ? 4 : 8); break;
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
			default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
		}
		return val;
	}
	
	/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
	function parse_PtgExtraMem(blob, cce, opts) {
		var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
		return out;
	}
	
	/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
	function parse_PtgExtraArray(blob, length, opts) {
		var rows = 0, cols = 0;
		if(opts.biff == 12) {
			rows = blob.read_shift(4); // DRw
			cols = blob.read_shift(4); // DCol
		} else {
			cols = 1 + blob.read_shift(1); //DColByteU
			rows = 1 + blob.read_shift(2); //DRw
		}
		if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
		// $FlowIgnore
		for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
		return o;
	}
	
	/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
	function parse_PtgName(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
		var nameindex = blob.read_shift(w);
		switch(opts.biff) {
			case 2: blob.l += 5; break;
			case 3: case 4: blob.l += 8; break;
			case 5: blob.l += 12; break;
		}
		return [type, 0, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
	function parse_PtgNameX(blob, length, opts) {
		if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	function parse_PtgNameX_BIFF5(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2, 'i'); // XtiIndex
		blob.l += 8;
		var nameindex = blob.read_shift(2);
		blob.l += 12;
		return [type, ixti, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
	function parse_PtgMemArea(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += (opts && opts.biff == 2 ? 3 : 4);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
	function parse_PtgMemFunc(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	
	/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
	function parse_PtgRefErr(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		if(opts.biff < 8) blob.l--;
		if(opts.biff == 12) blob.l += 2;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
	function parse_PtgRefErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 4;
		if(opts) switch(opts.biff) {
			case 5: w = 15; break;
			case 12: w = 6; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
	var parse_PtgMemErr = parsenoop;
	/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
	var parse_PtgMemNoMem = parsenoop;
	/* [MS-XLS] 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	function parse_PtgElfLoc(blob, length, opts) {
		blob.l += 2;
		return [parse_RgceElfLoc(blob, 4, opts)];
	}
	function parse_PtgElfNoop(blob) {
		blob.l += 6;
		return [];
	}
	/* [MS-XLS] 2.5.198.46 */
	var parse_PtgElfCol = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.47 */
	var parse_PtgElfColS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.48 */
	var parse_PtgElfColSV = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.49 */
	var parse_PtgElfColV = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.50 */
	function parse_PtgElfLel(blob) {
		blob.l += 2;
		return [parseuint16(blob), blob.read_shift(2) & 0x01];
	}
	/* [MS-XLS] 2.5.198.51 */
	var parse_PtgElfRadical = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.52 */
	var parse_PtgElfRadicalLel = parse_PtgElfLel;
	/* [MS-XLS] 2.5.198.53 */
	var parse_PtgElfRadicalS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.54 */
	var parse_PtgElfRw = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.55 */
	var parse_PtgElfRwV = parse_PtgElfLoc;
	
	/* [MS-XLSB] 2.5.97.52 TODO */
	var PtgListRT = [
		"Data",
		"All",
		"Headers",
		"??",
		"?Data2",
		"??",
		"?DataHeaders",
		"??",
		"Totals",
		"??",
		"??",
		"??",
		"?DataTotals",
		"??",
		"??",
		"??",
		"?Current"
	];
	function parse_PtgList(blob) {
		blob.l += 2;
		var ixti = blob.read_shift(2);
		var flags = blob.read_shift(2);
		var idx = blob.read_shift(4);
		var c = blob.read_shift(2);
		var C = blob.read_shift(2);
		var rt = PtgListRT[(flags >> 2) & 0x1F];
		return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
	}
	/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
	function parse_PtgSxName(blob) {
		blob.l += 2;
		return [blob.read_shift(4)];
	}
	
	/* [XLS] old spec */
	function parse_PtgSheet(blob, length, opts) {
		blob.l += 5;
		blob.l += 2;
		blob.l += (opts.biff == 2 ? 1 : 4);
		return ["PTGSHEET"];
	}
	function parse_PtgEndSheet(blob, length, opts) {
		blob.l += (opts.biff == 2 ? 4 : 5);
		return ["PTGENDSHEET"];
	}
	function parse_PtgMemAreaN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgMemNoMemN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgAttrNoop(blob) {
		blob.l += 4;
		return [0, 0];
	}
	
	/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
	var PtgTypes = {
	0x01: { n:'PtgExp', f:parse_PtgExp },
	0x02: { n:'PtgTbl', f:parse_PtgTbl },
	0x03: { n:'PtgAdd', f:parseread1 },
	0x04: { n:'PtgSub', f:parseread1 },
	0x05: { n:'PtgMul', f:parseread1 },
	0x06: { n:'PtgDiv', f:parseread1 },
	0x07: { n:'PtgPower', f:parseread1 },
	0x08: { n:'PtgConcat', f:parseread1 },
	0x09: { n:'PtgLt', f:parseread1 },
	0x0A: { n:'PtgLe', f:parseread1 },
	0x0B: { n:'PtgEq', f:parseread1 },
	0x0C: { n:'PtgGe', f:parseread1 },
	0x0D: { n:'PtgGt', f:parseread1 },
	0x0E: { n:'PtgNe', f:parseread1 },
	0x0F: { n:'PtgIsect', f:parseread1 },
	0x10: { n:'PtgUnion', f:parseread1 },
	0x11: { n:'PtgRange', f:parseread1 },
	0x12: { n:'PtgUplus', f:parseread1 },
	0x13: { n:'PtgUminus', f:parseread1 },
	0x14: { n:'PtgPercent', f:parseread1 },
	0x15: { n:'PtgParen', f:parseread1 },
	0x16: { n:'PtgMissArg', f:parseread1 },
	0x17: { n:'PtgStr', f:parse_PtgStr },
	0x1A: { n:'PtgSheet', f:parse_PtgSheet },
	0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	0x1C: { n:'PtgErr', f:parse_PtgErr },
	0x1D: { n:'PtgBool', f:parse_PtgBool },
	0x1E: { n:'PtgInt', f:parse_PtgInt },
	0x1F: { n:'PtgNum', f:parse_PtgNum },
	0x20: { n:'PtgArray', f:parse_PtgArray },
	0x21: { n:'PtgFunc', f:parse_PtgFunc },
	0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	0x23: { n:'PtgName', f:parse_PtgName },
	0x24: { n:'PtgRef', f:parse_PtgRef },
	0x25: { n:'PtgArea', f:parse_PtgArea },
	0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
	0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
	0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
	0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	0x2C: { n:'PtgRefN', f:parse_PtgRefN },
	0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
	0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	0x39: { n:'PtgNameX', f:parse_PtgNameX },
	0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
	0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
	0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
	0x40: 0x20, 0x60: 0x20,
	0x41: 0x21, 0x61: 0x21,
	0x42: 0x22, 0x62: 0x22,
	0x43: 0x23, 0x63: 0x23,
	0x44: 0x24, 0x64: 0x24,
	0x45: 0x25, 0x65: 0x25,
	0x46: 0x26, 0x66: 0x26,
	0x47: 0x27, 0x67: 0x27,
	0x48: 0x28, 0x68: 0x28,
	0x49: 0x29, 0x69: 0x29,
	0x4A: 0x2A, 0x6A: 0x2A,
	0x4B: 0x2B, 0x6B: 0x2B,
	0x4C: 0x2C, 0x6C: 0x2C,
	0x4D: 0x2D, 0x6D: 0x2D,
	0x4E: 0x2E, 0x6E: 0x2E,
	0x4F: 0x2F, 0x6F: 0x2F,
	0x58: 0x22, 0x78: 0x22,
	0x59: 0x39, 0x79: 0x39,
	0x5A: 0x3A, 0x7A: 0x3A,
	0x5B: 0x3B, 0x7B: 0x3B,
	0x5C: 0x3C, 0x7C: 0x3C,
	0x5D: 0x3D, 0x7D: 0x3D
	};
	
	var Ptg18 = {
	0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
	0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
	0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
	0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
	0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
	0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	0x19: { n:'PtgList', f:parse_PtgList },
	0x1D: { n:'PtgSxName', f:parse_PtgSxName },
	0xFF: {}
	};
	var Ptg19 = {
	0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x21: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	0xFF: {}
	};
	
	/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
					o.push(rgce[i][2]);
					break;
				case 'PtgExp': /* PtgExp -> PtgExtraCol */
					if(opts && opts.biff == 12) {
						rgce[i][1][1] = blob.read_shift(4);
						o.push(rgce[i][1]);
					} break;
				case 'PtgList': /* TODO: PtgList -> PtgExtraList */
				case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
				case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
				case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
					throw "Unsupported " + rgce[i][0];
				default: break;
			}
		}
		length = target - blob.l;
		/* note: this is technically an error but Excel disregards */
		//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
	function parse_Rgce(blob, length, opts) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
			if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
			if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
			else { ptgs.push([R.n, R.f(blob, length, opts)]); }
		}
		return ptgs;
	}
	
	function stringify_array(f) {
		var o = [];
		for(var i = 0; i < f.length; ++i) {
			var x = f[i], r = [];
			for(var j = 0; j < x.length; ++j) {
				var y = x[j];
				if(y) switch(y[0]) {
					// TODO: handle embedded quotes
					case 0x02:
	r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
					default: r.push(y[1]);
				} else r.push("");
			}
			o.push(r.join(","));
		}
		return o.join(";");
	}
	
	/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
	var PtgBinOp = {
		PtgAdd: "+",
		PtgConcat: "&",
		PtgDiv: "/",
		PtgEq: "=",
		PtgGe: ">=",
		PtgGt: ">",
		PtgLe: "<=",
		PtgLt: "<",
		PtgMul: "*",
		PtgNe: "<>",
		PtgPower: "^",
		PtgSub: "-"
	};
	
	// List of invalid characters needs to be tested further
	function formula_quote_sheet_name(sname, opts) {
		if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
		if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
		return sname;
	}
	function get_ixti_raw(supbooks, ixti, opts) {
		if(!supbooks) return "SH33TJSERR0";
		if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
		if(!supbooks.XTI) return "SH33TJSERR6";
		var XTI = supbooks.XTI[ixti];
		if(opts.biff < 8) {
			if(ixti > 10000) ixti-= 65536;
			if(ixti < 0) ixti = -ixti;
			return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
		}
		if(!XTI) return "SH33TJSERR1";
		var o = "";
		if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
			case 0x0165: /* 'BrtSupSelf' */
				o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x0166: /* 'BrtSupSame' */
				if(opts.SID != null) return supbooks.SheetNames[opts.SID];
				return "SH33TJSSAME" + supbooks[XTI[0]][0];
			case 0x0163: /* 'BrtSupBookSrc' */
				/* falls through */
			default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
		}
		switch(supbooks[XTI[0]][0][0]) {
			case 0x0401:
				o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
			default:
				if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
				o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
		}
	}
	function get_ixti(supbooks, ixti, opts) {
		var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
		return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
	}
	function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
		var biff = (opts && opts.biff) || 8;
		var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
		var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
		if(!formula[0] || !formula[0][0]) return "";
		var last_sp = -1, sp = "";
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			switch(f[0]) {
				case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
					stack.push("-" + stack.pop()); break;
				case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
					stack.push("+" + stack.pop()); break;
				case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
					stack.push(stack.pop() + "%"); break;
	
				case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
				case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
				case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
				case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
				case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
				case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
				case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
				case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
				case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
				case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
				case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
				case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
					e1 = stack.pop(); e2 = stack.pop();
					if(last_sp >= 0) {
						switch(formula[0][last_sp][1][0]) {
							case 0:
								// $FlowIgnore
								sp = fill(" ", formula[0][last_sp][1][1]); break;
							case 1:
								// $FlowIgnore
								sp = fill("\r", formula[0][last_sp][1][1]); break;
							default:
								sp = "";
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						e2 = e2 + sp;
						last_sp = -1;
					}
					stack.push(e2+PtgBinOp[f[0]]+e1);
					break;
	
				case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+":"+e1);
					break;
	
				case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
					break;
				case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
					break;
				case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
					break;
				case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
					break;
	
	
				case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
	c = shift_cell_xls((f[1][1]), _range, opts);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
	c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
	ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
					sname = get_ixti(supbooks, ixti, opts);
					var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
					stack.push(sname + "!" + encode_cell_xls(c, biff));
					break;
	
				case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
				case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
					/* f[1] = [argc, func, type] */
					var argc = (f[1][0]), func = (f[1][1]);
					if(!argc) argc = 0;
					argc &= 0x7F;
					var args = argc == 0 ? [] : stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
					stack.push(f[1] ? "TRUE" : "FALSE"); break;
				case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
					stack.push(f[1]); break;
				case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
					stack.push(String(f[1])); break;
				case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
					// $FlowIgnore
					stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
				case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
					stack.push(f[1]); break;
				case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
	r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
	r = shift_range_xls(f[1][1], _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
	ixti = f[1][1]; r = f[1][2];
					sname = get_ixti(supbooks, ixti, opts);
					stack.push(sname + "!" + encode_range_xls((r), opts));
					break;
				case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
				case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
				case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
					break;
	
				case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
					/* f[1] = type, 0, nameindex */
					nameidx = (f[1][2]);
					var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
					var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
					/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
					if(name && name.slice(0,6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
					stack.push(name);
					break;
	
				case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
					/* f[1] = type, ixti, nameindex */
					var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
					/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
					if(opts.biff <= 5) {
						if(bookidx < 0) bookidx = -bookidx;
						if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
					} else {
						var o = "";
						if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
						else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
							if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
								o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
							}
						}
						else o = supbooks.SheetNames[nameidx-1]+ "!";
						if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
						else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
						else {
							var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
							if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
							else o += "SH33TJSERRX";
						}
						stack.push(o);
						break;
					}
					if(!externbook) externbook = {Name: "SH33TJSERRY"};
					stack.push(externbook.Name);
					break;
	
				case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
					var lp = '(', rp = ')';
					if(last_sp >= 0) {
						sp = "";
						switch(formula[0][last_sp][1][0]) {
							// $FlowIgnore
							case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
							// $FlowIgnore
							case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
							default:
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						last_sp = -1;
					}
					stack.push(lp + stack.pop() + rp); break;
	
				case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
					stack.push('#REF!'); break;
	
				case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
					stack.push('#REF!'); break;
	
				case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
					c = {c:(f[1][1]),r:(f[1][0])};
					var q = ({c: cell.c, r:cell.r});
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					} else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
							fnd = true;
							break;
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
					stack.push("{" + stringify_array(f[1]) + "}");
					break;
	
				case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
				case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
					last_sp = ff;
					break;
	
				case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
					break;
	
				case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
					break;
	
				case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
					stack.push("");
					break;
	
				case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
					stack.push("#REF!"); break;
	
				case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
					stack.push("#REF!"); break;
	
				case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
					// $FlowIgnore
					stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
					break;
	
				case 'PtgMemAreaN':
				case 'PtgMemNoMemN':
				case 'PtgAttrNoop':
				case 'PtgSheet':
				case 'PtgEndSheet':
					break;
	
				case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
					break;
				case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
					break;
	
				case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
				case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
				case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
				case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
				case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
				case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
				case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
				case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
				case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
				case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
					throw new Error("Unsupported ELFs");
	
				case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
				default: throw new Error('Unrecognized Formula Token: ' + String(f));
			}
			var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
			if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
				f = formula[0][last_sp];
				var _left = true;
				switch(f[1][0]) {
					/* note: some bad XLSB files omit the PtgParen */
					case 4: _left = false;
					/* falls through */
					case 0:
						// $FlowIgnore
						sp = fill(" ", f[1][1]); break;
					case 5: _left = false;
					/* falls through */
					case 1:
						// $FlowIgnore
						sp = fill("\r", f[1][1]); break;
					default:
						sp = "";
						// $FlowIgnore
						if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
				}
				stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
				last_sp = -1;
			}
		}
		if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
		return stack[0];
	}
	
	/* [MS-XLS] 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce, opts);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce, opts);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
		return [];
	}
	function write_FormulaValue(value) {
		if(value == null) {
			// Blank String Value
			var o = new_buf(8);
			o.write_shift(1, 0x03);
			o.write_shift(1, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		} else if(typeof value == "number") return write_Xnum(value);
		return write_Xnum(0);
	}
	
	/* [MS-XLS] 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		if(opts.biff != 2) {
			blob.read_shift(1);
			if(opts.biff >= 5) {
				/*var chn = */blob.read_shift(4);
			}
		}
		var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	function write_Formula(cell, R, C, opts, os) {
		// Cell
		var o1 = write_XLSCell(R, C, os);
	
		// FormulaValue
		var o2 = write_FormulaValue(cell.v);
	
		// flags + cache
		var o3 = new_buf(6);
		var flags = 0x01 | 0x20;
		o3.write_shift(2, flags);
		o3.write_shift(4, 0);
	
		// CellParsedFormula
		var bf = new_buf(cell.bf.length);
		for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];
	
		var out = bconcat([o1, o2, o3, bf]);
		return out;
	}
	
	
	/* XLSB Parsed Formula records have the same shape */
	function parse_XLSBParsedFormula(data, length, opts) {
		var cce = data.read_shift(4);
		var rgce = parse_Rgce(data, cce, opts);
		var cb = data.read_shift(4);
		var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
		return [rgce, rgcb];
	}
	
	/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
	var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
	var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
	//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
	//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
	/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
	var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
	var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
	var Cetab = {
	  0: "BEEP",
	  1: "OPEN",
	  2: "OPEN.LINKS",
	  3: "CLOSE.ALL",
	  4: "SAVE",
	  5: "SAVE.AS",
	  6: "FILE.DELETE",
	  7: "PAGE.SETUP",
	  8: "PRINT",
	  9: "PRINTER.SETUP",
	  10: "QUIT",
	  11: "NEW.WINDOW",
	  12: "ARRANGE.ALL",
	  13: "WINDOW.SIZE",
	  14: "WINDOW.MOVE",
	  15: "FULL",
	  16: "CLOSE",
	  17: "RUN",
	  22: "SET.PRINT.AREA",
	  23: "SET.PRINT.TITLES",
	  24: "SET.PAGE.BREAK",
	  25: "REMOVE.PAGE.BREAK",
	  26: "FONT",
	  27: "DISPLAY",
	  28: "PROTECT.DOCUMENT",
	  29: "PRECISION",
	  30: "A1.R1C1",
	  31: "CALCULATE.NOW",
	  32: "CALCULATION",
	  34: "DATA.FIND",
	  35: "EXTRACT",
	  36: "DATA.DELETE",
	  37: "SET.DATABASE",
	  38: "SET.CRITERIA",
	  39: "SORT",
	  40: "DATA.SERIES",
	  41: "TABLE",
	  42: "FORMAT.NUMBER",
	  43: "ALIGNMENT",
	  44: "STYLE",
	  45: "BORDER",
	  46: "CELL.PROTECTION",
	  47: "COLUMN.WIDTH",
	  48: "UNDO",
	  49: "CUT",
	  50: "COPY",
	  51: "PASTE",
	  52: "CLEAR",
	  53: "PASTE.SPECIAL",
	  54: "EDIT.DELETE",
	  55: "INSERT",
	  56: "FILL.RIGHT",
	  57: "FILL.DOWN",
	  61: "DEFINE.NAME",
	  62: "CREATE.NAMES",
	  63: "FORMULA.GOTO",
	  64: "FORMULA.FIND",
	  65: "SELECT.LAST.CELL",
	  66: "SHOW.ACTIVE.CELL",
	  67: "GALLERY.AREA",
	  68: "GALLERY.BAR",
	  69: "GALLERY.COLUMN",
	  70: "GALLERY.LINE",
	  71: "GALLERY.PIE",
	  72: "GALLERY.SCATTER",
	  73: "COMBINATION",
	  74: "PREFERRED",
	  75: "ADD.OVERLAY",
	  76: "GRIDLINES",
	  77: "SET.PREFERRED",
	  78: "AXES",
	  79: "LEGEND",
	  80: "ATTACH.TEXT",
	  81: "ADD.ARROW",
	  82: "SELECT.CHART",
	  83: "SELECT.PLOT.AREA",
	  84: "PATTERNS",
	  85: "MAIN.CHART",
	  86: "OVERLAY",
	  87: "SCALE",
	  88: "FORMAT.LEGEND",
	  89: "FORMAT.TEXT",
	  90: "EDIT.REPEAT",
	  91: "PARSE",
	  92: "JUSTIFY",
	  93: "HIDE",
	  94: "UNHIDE",
	  95: "WORKSPACE",
	  96: "FORMULA",
	  97: "FORMULA.FILL",
	  98: "FORMULA.ARRAY",
	  99: "DATA.FIND.NEXT",
	  100: "DATA.FIND.PREV",
	  101: "FORMULA.FIND.NEXT",
	  102: "FORMULA.FIND.PREV",
	  103: "ACTIVATE",
	  104: "ACTIVATE.NEXT",
	  105: "ACTIVATE.PREV",
	  106: "UNLOCKED.NEXT",
	  107: "UNLOCKED.PREV",
	  108: "COPY.PICTURE",
	  109: "SELECT",
	  110: "DELETE.NAME",
	  111: "DELETE.FORMAT",
	  112: "VLINE",
	  113: "HLINE",
	  114: "VPAGE",
	  115: "HPAGE",
	  116: "VSCROLL",
	  117: "HSCROLL",
	  118: "ALERT",
	  119: "NEW",
	  120: "CANCEL.COPY",
	  121: "SHOW.CLIPBOARD",
	  122: "MESSAGE",
	  124: "PASTE.LINK",
	  125: "APP.ACTIVATE",
	  126: "DELETE.ARROW",
	  127: "ROW.HEIGHT",
	  128: "FORMAT.MOVE",
	  129: "FORMAT.SIZE",
	  130: "FORMULA.REPLACE",
	  131: "SEND.KEYS",
	  132: "SELECT.SPECIAL",
	  133: "APPLY.NAMES",
	  134: "REPLACE.FONT",
	  135: "FREEZE.PANES",
	  136: "SHOW.INFO",
	  137: "SPLIT",
	  138: "ON.WINDOW",
	  139: "ON.DATA",
	  140: "DISABLE.INPUT",
	  142: "OUTLINE",
	  143: "LIST.NAMES",
	  144: "FILE.CLOSE",
	  145: "SAVE.WORKBOOK",
	  146: "DATA.FORM",
	  147: "COPY.CHART",
	  148: "ON.TIME",
	  149: "WAIT",
	  150: "FORMAT.FONT",
	  151: "FILL.UP",
	  152: "FILL.LEFT",
	  153: "DELETE.OVERLAY",
	  155: "SHORT.MENUS",
	  159: "SET.UPDATE.STATUS",
	  161: "COLOR.PALETTE",
	  162: "DELETE.STYLE",
	  163: "WINDOW.RESTORE",
	  164: "WINDOW.MAXIMIZE",
	  166: "CHANGE.LINK",
	  167: "CALCULATE.DOCUMENT",
	  168: "ON.KEY",
	  169: "APP.RESTORE",
	  170: "APP.MOVE",
	  171: "APP.SIZE",
	  172: "APP.MINIMIZE",
	  173: "APP.MAXIMIZE",
	  174: "BRING.TO.FRONT",
	  175: "SEND.TO.BACK",
	  185: "MAIN.CHART.TYPE",
	  186: "OVERLAY.CHART.TYPE",
	  187: "SELECT.END",
	  188: "OPEN.MAIL",
	  189: "SEND.MAIL",
	  190: "STANDARD.FONT",
	  191: "CONSOLIDATE",
	  192: "SORT.SPECIAL",
	  193: "GALLERY.3D.AREA",
	  194: "GALLERY.3D.COLUMN",
	  195: "GALLERY.3D.LINE",
	  196: "GALLERY.3D.PIE",
	  197: "VIEW.3D",
	  198: "GOAL.SEEK",
	  199: "WORKGROUP",
	  200: "FILL.GROUP",
	  201: "UPDATE.LINK",
	  202: "PROMOTE",
	  203: "DEMOTE",
	  204: "SHOW.DETAIL",
	  206: "UNGROUP",
	  207: "OBJECT.PROPERTIES",
	  208: "SAVE.NEW.OBJECT",
	  209: "SHARE",
	  210: "SHARE.NAME",
	  211: "DUPLICATE",
	  212: "APPLY.STYLE",
	  213: "ASSIGN.TO.OBJECT",
	  214: "OBJECT.PROTECTION",
	  215: "HIDE.OBJECT",
	  216: "SET.EXTRACT",
	  217: "CREATE.PUBLISHER",
	  218: "SUBSCRIBE.TO",
	  219: "ATTRIBUTES",
	  220: "SHOW.TOOLBAR",
	  222: "PRINT.PREVIEW",
	  223: "EDIT.COLOR",
	  224: "SHOW.LEVELS",
	  225: "FORMAT.MAIN",
	  226: "FORMAT.OVERLAY",
	  227: "ON.RECALC",
	  228: "EDIT.SERIES",
	  229: "DEFINE.STYLE",
	  240: "LINE.PRINT",
	  243: "ENTER.DATA",
	  249: "GALLERY.RADAR",
	  250: "MERGE.STYLES",
	  251: "EDITION.OPTIONS",
	  252: "PASTE.PICTURE",
	  253: "PASTE.PICTURE.LINK",
	  254: "SPELLING",
	  256: "ZOOM",
	  259: "INSERT.OBJECT",
	  260: "WINDOW.MINIMIZE",
	  265: "SOUND.NOTE",
	  266: "SOUND.PLAY",
	  267: "FORMAT.SHAPE",
	  268: "EXTEND.POLYGON",
	  269: "FORMAT.AUTO",
	  272: "GALLERY.3D.BAR",
	  273: "GALLERY.3D.SURFACE",
	  274: "FILL.AUTO",
	  276: "CUSTOMIZE.TOOLBAR",
	  277: "ADD.TOOL",
	  278: "EDIT.OBJECT",
	  279: "ON.DOUBLECLICK",
	  280: "ON.ENTRY",
	  281: "WORKBOOK.ADD",
	  282: "WORKBOOK.MOVE",
	  283: "WORKBOOK.COPY",
	  284: "WORKBOOK.OPTIONS",
	  285: "SAVE.WORKSPACE",
	  288: "CHART.WIZARD",
	  289: "DELETE.TOOL",
	  290: "MOVE.TOOL",
	  291: "WORKBOOK.SELECT",
	  292: "WORKBOOK.ACTIVATE",
	  293: "ASSIGN.TO.TOOL",
	  295: "COPY.TOOL",
	  296: "RESET.TOOL",
	  297: "CONSTRAIN.NUMERIC",
	  298: "PASTE.TOOL",
	  302: "WORKBOOK.NEW",
	  305: "SCENARIO.CELLS",
	  306: "SCENARIO.DELETE",
	  307: "SCENARIO.ADD",
	  308: "SCENARIO.EDIT",
	  309: "SCENARIO.SHOW",
	  310: "SCENARIO.SHOW.NEXT",
	  311: "SCENARIO.SUMMARY",
	  312: "PIVOT.TABLE.WIZARD",
	  313: "PIVOT.FIELD.PROPERTIES",
	  314: "PIVOT.FIELD",
	  315: "PIVOT.ITEM",
	  316: "PIVOT.ADD.FIELDS",
	  318: "OPTIONS.CALCULATION",
	  319: "OPTIONS.EDIT",
	  320: "OPTIONS.VIEW",
	  321: "ADDIN.MANAGER",
	  322: "MENU.EDITOR",
	  323: "ATTACH.TOOLBARS",
	  324: "VBAActivate",
	  325: "OPTIONS.CHART",
	  328: "VBA.INSERT.FILE",
	  330: "VBA.PROCEDURE.DEFINITION",
	  336: "ROUTING.SLIP",
	  338: "ROUTE.DOCUMENT",
	  339: "MAIL.LOGON",
	  342: "INSERT.PICTURE",
	  343: "EDIT.TOOL",
	  344: "GALLERY.DOUGHNUT",
	  350: "CHART.TREND",
	  352: "PIVOT.ITEM.PROPERTIES",
	  354: "WORKBOOK.INSERT",
	  355: "OPTIONS.TRANSITION",
	  356: "OPTIONS.GENERAL",
	  370: "FILTER.ADVANCED",
	  373: "MAIL.ADD.MAILER",
	  374: "MAIL.DELETE.MAILER",
	  375: "MAIL.REPLY",
	  376: "MAIL.REPLY.ALL",
	  377: "MAIL.FORWARD",
	  378: "MAIL.NEXT.LETTER",
	  379: "DATA.LABEL",
	  380: "INSERT.TITLE",
	  381: "FONT.PROPERTIES",
	  382: "MACRO.OPTIONS",
	  383: "WORKBOOK.HIDE",
	  384: "WORKBOOK.UNHIDE",
	  385: "WORKBOOK.DELETE",
	  386: "WORKBOOK.NAME",
	  388: "GALLERY.CUSTOM",
	  390: "ADD.CHART.AUTOFORMAT",
	  391: "DELETE.CHART.AUTOFORMAT",
	  392: "CHART.ADD.DATA",
	  393: "AUTO.OUTLINE",
	  394: "TAB.ORDER",
	  395: "SHOW.DIALOG",
	  396: "SELECT.ALL",
	  397: "UNGROUP.SHEETS",
	  398: "SUBTOTAL.CREATE",
	  399: "SUBTOTAL.REMOVE",
	  400: "RENAME.OBJECT",
	  412: "WORKBOOK.SCROLL",
	  413: "WORKBOOK.NEXT",
	  414: "WORKBOOK.PREV",
	  415: "WORKBOOK.TAB.SPLIT",
	  416: "FULL.SCREEN",
	  417: "WORKBOOK.PROTECT",
	  420: "SCROLLBAR.PROPERTIES",
	  421: "PIVOT.SHOW.PAGES",
	  422: "TEXT.TO.COLUMNS",
	  423: "FORMAT.CHARTTYPE",
	  424: "LINK.FORMAT",
	  425: "TRACER.DISPLAY",
	  430: "TRACER.NAVIGATE",
	  431: "TRACER.CLEAR",
	  432: "TRACER.ERROR",
	  433: "PIVOT.FIELD.GROUP",
	  434: "PIVOT.FIELD.UNGROUP",
	  435: "CHECKBOX.PROPERTIES",
	  436: "LABEL.PROPERTIES",
	  437: "LISTBOX.PROPERTIES",
	  438: "EDITBOX.PROPERTIES",
	  439: "PIVOT.REFRESH",
	  440: "LINK.COMBO",
	  441: "OPEN.TEXT",
	  442: "HIDE.DIALOG",
	  443: "SET.DIALOG.FOCUS",
	  444: "ENABLE.OBJECT",
	  445: "PUSHBUTTON.PROPERTIES",
	  446: "SET.DIALOG.DEFAULT",
	  447: "FILTER",
	  448: "FILTER.SHOW.ALL",
	  449: "CLEAR.OUTLINE",
	  450: "FUNCTION.WIZARD",
	  451: "ADD.LIST.ITEM",
	  452: "SET.LIST.ITEM",
	  453: "REMOVE.LIST.ITEM",
	  454: "SELECT.LIST.ITEM",
	  455: "SET.CONTROL.VALUE",
	  456: "SAVE.COPY.AS",
	  458: "OPTIONS.LISTS.ADD",
	  459: "OPTIONS.LISTS.DELETE",
	  460: "SERIES.AXES",
	  461: "SERIES.X",
	  462: "SERIES.Y",
	  463: "ERRORBAR.X",
	  464: "ERRORBAR.Y",
	  465: "FORMAT.CHART",
	  466: "SERIES.ORDER",
	  467: "MAIL.LOGOFF",
	  468: "CLEAR.ROUTING.SLIP",
	  469: "APP.ACTIVATE.MICROSOFT",
	  470: "MAIL.EDIT.MAILER",
	  471: "ON.SHEET",
	  472: "STANDARD.WIDTH",
	  473: "SCENARIO.MERGE",
	  474: "SUMMARY.INFO",
	  475: "FIND.FILE",
	  476: "ACTIVE.CELL.FONT",
	  477: "ENABLE.TIPWIZARD",
	  478: "VBA.MAKE.ADDIN",
	  480: "INSERTDATATABLE",
	  481: "WORKGROUP.OPTIONS",
	  482: "MAIL.SEND.MAILER",
	  485: "AUTOCORRECT",
	  489: "POST.DOCUMENT",
	  491: "PICKLIST",
	  493: "VIEW.SHOW",
	  494: "VIEW.DEFINE",
	  495: "VIEW.DELETE",
	  509: "SHEET.BACKGROUND",
	  510: "INSERT.MAP.OBJECT",
	  511: "OPTIONS.MENONO",
	  517: "MSOCHECKS",
	  518: "NORMAL",
	  519: "LAYOUT",
	  520: "RM.PRINT.AREA",
	  521: "CLEAR.PRINT.AREA",
	  522: "ADD.PRINT.AREA",
	  523: "MOVE.BRK",
	  545: "HIDECURR.NOTE",
	  546: "HIDEALL.NOTES",
	  547: "DELETE.NOTE",
	  548: "TRAVERSE.NOTES",
	  549: "ACTIVATE.NOTES",
	  620: "PROTECT.REVISIONS",
	  621: "UNPROTECT.REVISIONS",
	  647: "OPTIONS.ME",
	  653: "WEB.PUBLISH",
	  667: "NEWWEBQUERY",
	  673: "PIVOT.TABLE.CHART",
	  753: "OPTIONS.SAVE",
	  755: "OPTIONS.SPELL",
	  808: "HIDEALL.INKANNOTS"
	};
	var Ftab = {
	  0: "COUNT",
	  1: "IF",
	  2: "ISNA",
	  3: "ISERROR",
	  4: "SUM",
	  5: "AVERAGE",
	  6: "MIN",
	  7: "MAX",
	  8: "ROW",
	  9: "COLUMN",
	  10: "NA",
	  11: "NPV",
	  12: "STDEV",
	  13: "DOLLAR",
	  14: "FIXED",
	  15: "SIN",
	  16: "COS",
	  17: "TAN",
	  18: "ATAN",
	  19: "PI",
	  20: "SQRT",
	  21: "EXP",
	  22: "LN",
	  23: "LOG10",
	  24: "ABS",
	  25: "INT",
	  26: "SIGN",
	  27: "ROUND",
	  28: "LOOKUP",
	  29: "INDEX",
	  30: "REPT",
	  31: "MID",
	  32: "LEN",
	  33: "VALUE",
	  34: "TRUE",
	  35: "FALSE",
	  36: "AND",
	  37: "OR",
	  38: "NOT",
	  39: "MOD",
	  40: "DCOUNT",
	  41: "DSUM",
	  42: "DAVERAGE",
	  43: "DMIN",
	  44: "DMAX",
	  45: "DSTDEV",
	  46: "VAR",
	  47: "DVAR",
	  48: "TEXT",
	  49: "LINEST",
	  50: "TREND",
	  51: "LOGEST",
	  52: "GROWTH",
	  53: "GOTO",
	  54: "HALT",
	  55: "RETURN",
	  56: "PV",
	  57: "FV",
	  58: "NPER",
	  59: "PMT",
	  60: "RATE",
	  61: "MIRR",
	  62: "IRR",
	  63: "RAND",
	  64: "MATCH",
	  65: "DATE",
	  66: "TIME",
	  67: "DAY",
	  68: "MONTH",
	  69: "YEAR",
	  70: "WEEKDAY",
	  71: "HOUR",
	  72: "MINUTE",
	  73: "SECOND",
	  74: "NOW",
	  75: "AREAS",
	  76: "ROWS",
	  77: "COLUMNS",
	  78: "OFFSET",
	  79: "ABSREF",
	  80: "RELREF",
	  81: "ARGUMENT",
	  82: "SEARCH",
	  83: "TRANSPOSE",
	  84: "ERROR",
	  85: "STEP",
	  86: "TYPE",
	  87: "ECHO",
	  88: "SET.NAME",
	  89: "CALLER",
	  90: "DEREF",
	  91: "WINDOWS",
	  92: "SERIES",
	  93: "DOCUMENTS",
	  94: "ACTIVE.CELL",
	  95: "SELECTION",
	  96: "RESULT",
	  97: "ATAN2",
	  98: "ASIN",
	  99: "ACOS",
	  100: "CHOOSE",
	  101: "HLOOKUP",
	  102: "VLOOKUP",
	  103: "LINKS",
	  104: "INPUT",
	  105: "ISREF",
	  106: "GET.FORMULA",
	  107: "GET.NAME",
	  108: "SET.VALUE",
	  109: "LOG",
	  110: "EXEC",
	  111: "CHAR",
	  112: "LOWER",
	  113: "UPPER",
	  114: "PROPER",
	  115: "LEFT",
	  116: "RIGHT",
	  117: "EXACT",
	  118: "TRIM",
	  119: "REPLACE",
	  120: "SUBSTITUTE",
	  121: "CODE",
	  122: "NAMES",
	  123: "DIRECTORY",
	  124: "FIND",
	  125: "CELL",
	  126: "ISERR",
	  127: "ISTEXT",
	  128: "ISNUMBER",
	  129: "ISBLANK",
	  130: "T",
	  131: "N",
	  132: "FOPEN",
	  133: "FCLOSE",
	  134: "FSIZE",
	  135: "FREADLN",
	  136: "FREAD",
	  137: "FWRITELN",
	  138: "FWRITE",
	  139: "FPOS",
	  140: "DATEVALUE",
	  141: "TIMEVALUE",
	  142: "SLN",
	  143: "SYD",
	  144: "DDB",
	  145: "GET.DEF",
	  146: "REFTEXT",
	  147: "TEXTREF",
	  148: "INDIRECT",
	  149: "REGISTER",
	  150: "CALL",
	  151: "ADD.BAR",
	  152: "ADD.MENU",
	  153: "ADD.COMMAND",
	  154: "ENABLE.COMMAND",
	  155: "CHECK.COMMAND",
	  156: "RENAME.COMMAND",
	  157: "SHOW.BAR",
	  158: "DELETE.MENU",
	  159: "DELETE.COMMAND",
	  160: "GET.CHART.ITEM",
	  161: "DIALOG.BOX",
	  162: "CLEAN",
	  163: "MDETERM",
	  164: "MINVERSE",
	  165: "MMULT",
	  166: "FILES",
	  167: "IPMT",
	  168: "PPMT",
	  169: "COUNTA",
	  170: "CANCEL.KEY",
	  171: "FOR",
	  172: "WHILE",
	  173: "BREAK",
	  174: "NEXT",
	  175: "INITIATE",
	  176: "REQUEST",
	  177: "POKE",
	  178: "EXECUTE",
	  179: "TERMINATE",
	  180: "RESTART",
	  181: "HELP",
	  182: "GET.BAR",
	  183: "PRODUCT",
	  184: "FACT",
	  185: "GET.CELL",
	  186: "GET.WORKSPACE",
	  187: "GET.WINDOW",
	  188: "GET.DOCUMENT",
	  189: "DPRODUCT",
	  190: "ISNONTEXT",
	  191: "GET.NOTE",
	  192: "NOTE",
	  193: "STDEVP",
	  194: "VARP",
	  195: "DSTDEVP",
	  196: "DVARP",
	  197: "TRUNC",
	  198: "ISLOGICAL",
	  199: "DCOUNTA",
	  200: "DELETE.BAR",
	  201: "UNREGISTER",
	  204: "USDOLLAR",
	  205: "FINDB",
	  206: "SEARCHB",
	  207: "REPLACEB",
	  208: "LEFTB",
	  209: "RIGHTB",
	  210: "MIDB",
	  211: "LENB",
	  212: "ROUNDUP",
	  213: "ROUNDDOWN",
	  214: "ASC",
	  215: "DBCS",
	  216: "RANK",
	  219: "ADDRESS",
	  220: "DAYS360",
	  221: "TODAY",
	  222: "VDB",
	  223: "ELSE",
	  224: "ELSE.IF",
	  225: "END.IF",
	  226: "FOR.CELL",
	  227: "MEDIAN",
	  228: "SUMPRODUCT",
	  229: "SINH",
	  230: "COSH",
	  231: "TANH",
	  232: "ASINH",
	  233: "ACOSH",
	  234: "ATANH",
	  235: "DGET",
	  236: "CREATE.OBJECT",
	  237: "VOLATILE",
	  238: "LAST.ERROR",
	  239: "CUSTOM.UNDO",
	  240: "CUSTOM.REPEAT",
	  241: "FORMULA.CONVERT",
	  242: "GET.LINK.INFO",
	  243: "TEXT.BOX",
	  244: "INFO",
	  245: "GROUP",
	  246: "GET.OBJECT",
	  247: "DB",
	  248: "PAUSE",
	  251: "RESUME",
	  252: "FREQUENCY",
	  253: "ADD.TOOLBAR",
	  254: "DELETE.TOOLBAR",
	  255: "User",
	  256: "RESET.TOOLBAR",
	  257: "EVALUATE",
	  258: "GET.TOOLBAR",
	  259: "GET.TOOL",
	  260: "SPELLING.CHECK",
	  261: "ERROR.TYPE",
	  262: "APP.TITLE",
	  263: "WINDOW.TITLE",
	  264: "SAVE.TOOLBAR",
	  265: "ENABLE.TOOL",
	  266: "PRESS.TOOL",
	  267: "REGISTER.ID",
	  268: "GET.WORKBOOK",
	  269: "AVEDEV",
	  270: "BETADIST",
	  271: "GAMMALN",
	  272: "BETAINV",
	  273: "BINOMDIST",
	  274: "CHIDIST",
	  275: "CHIINV",
	  276: "COMBIN",
	  277: "CONFIDENCE",
	  278: "CRITBINOM",
	  279: "EVEN",
	  280: "EXPONDIST",
	  281: "FDIST",
	  282: "FINV",
	  283: "FISHER",
	  284: "FISHERINV",
	  285: "FLOOR",
	  286: "GAMMADIST",
	  287: "GAMMAINV",
	  288: "CEILING",
	  289: "HYPGEOMDIST",
	  290: "LOGNORMDIST",
	  291: "LOGINV",
	  292: "NEGBINOMDIST",
	  293: "NORMDIST",
	  294: "NORMSDIST",
	  295: "NORMINV",
	  296: "NORMSINV",
	  297: "STANDARDIZE",
	  298: "ODD",
	  299: "PERMUT",
	  300: "POISSON",
	  301: "TDIST",
	  302: "WEIBULL",
	  303: "SUMXMY2",
	  304: "SUMX2MY2",
	  305: "SUMX2PY2",
	  306: "CHITEST",
	  307: "CORREL",
	  308: "COVAR",
	  309: "FORECAST",
	  310: "FTEST",
	  311: "INTERCEPT",
	  312: "PEARSON",
	  313: "RSQ",
	  314: "STEYX",
	  315: "SLOPE",
	  316: "TTEST",
	  317: "PROB",
	  318: "DEVSQ",
	  319: "GEOMEAN",
	  320: "HARMEAN",
	  321: "SUMSQ",
	  322: "KURT",
	  323: "SKEW",
	  324: "ZTEST",
	  325: "LARGE",
	  326: "SMALL",
	  327: "QUARTILE",
	  328: "PERCENTILE",
	  329: "PERCENTRANK",
	  330: "MODE",
	  331: "TRIMMEAN",
	  332: "TINV",
	  334: "MOVIE.COMMAND",
	  335: "GET.MOVIE",
	  336: "CONCATENATE",
	  337: "POWER",
	  338: "PIVOT.ADD.DATA",
	  339: "GET.PIVOT.TABLE",
	  340: "GET.PIVOT.FIELD",
	  341: "GET.PIVOT.ITEM",
	  342: "RADIANS",
	  343: "DEGREES",
	  344: "SUBTOTAL",
	  345: "SUMIF",
	  346: "COUNTIF",
	  347: "COUNTBLANK",
	  348: "SCENARIO.GET",
	  349: "OPTIONS.LISTS.GET",
	  350: "ISPMT",
	  351: "DATEDIF",
	  352: "DATESTRING",
	  353: "NUMBERSTRING",
	  354: "ROMAN",
	  355: "OPEN.DIALOG",
	  356: "SAVE.DIALOG",
	  357: "VIEW.GET",
	  358: "GETPIVOTDATA",
	  359: "HYPERLINK",
	  360: "PHONETIC",
	  361: "AVERAGEA",
	  362: "MAXA",
	  363: "MINA",
	  364: "STDEVPA",
	  365: "VARPA",
	  366: "STDEVA",
	  367: "VARA",
	  368: "BAHTTEXT",
	  369: "THAIDAYOFWEEK",
	  370: "THAIDIGIT",
	  371: "THAIMONTHOFYEAR",
	  372: "THAINUMSOUND",
	  373: "THAINUMSTRING",
	  374: "THAISTRINGLENGTH",
	  375: "ISTHAIDIGIT",
	  376: "ROUNDBAHTDOWN",
	  377: "ROUNDBAHTUP",
	  378: "THAIYEAR",
	  379: "RTD",
	  380: "CUBEVALUE",
	  381: "CUBEMEMBER",
	  382: "CUBEMEMBERPROPERTY",
	  383: "CUBERANKEDMEMBER",
	  384: "HEX2BIN",
	  385: "HEX2DEC",
	  386: "HEX2OCT",
	  387: "DEC2BIN",
	  388: "DEC2HEX",
	  389: "DEC2OCT",
	  390: "OCT2BIN",
	  391: "OCT2HEX",
	  392: "OCT2DEC",
	  393: "BIN2DEC",
	  394: "BIN2OCT",
	  395: "BIN2HEX",
	  396: "IMSUB",
	  397: "IMDIV",
	  398: "IMPOWER",
	  399: "IMABS",
	  400: "IMSQRT",
	  401: "IMLN",
	  402: "IMLOG2",
	  403: "IMLOG10",
	  404: "IMSIN",
	  405: "IMCOS",
	  406: "IMEXP",
	  407: "IMARGUMENT",
	  408: "IMCONJUGATE",
	  409: "IMAGINARY",
	  410: "IMREAL",
	  411: "COMPLEX",
	  412: "IMSUM",
	  413: "IMPRODUCT",
	  414: "SERIESSUM",
	  415: "FACTDOUBLE",
	  416: "SQRTPI",
	  417: "QUOTIENT",
	  418: "DELTA",
	  419: "GESTEP",
	  420: "ISEVEN",
	  421: "ISODD",
	  422: "MROUND",
	  423: "ERF",
	  424: "ERFC",
	  425: "BESSELJ",
	  426: "BESSELK",
	  427: "BESSELY",
	  428: "BESSELI",
	  429: "XIRR",
	  430: "XNPV",
	  431: "PRICEMAT",
	  432: "YIELDMAT",
	  433: "INTRATE",
	  434: "RECEIVED",
	  435: "DISC",
	  436: "PRICEDISC",
	  437: "YIELDDISC",
	  438: "TBILLEQ",
	  439: "TBILLPRICE",
	  440: "TBILLYIELD",
	  441: "PRICE",
	  442: "YIELD",
	  443: "DOLLARDE",
	  444: "DOLLARFR",
	  445: "NOMINAL",
	  446: "EFFECT",
	  447: "CUMPRINC",
	  448: "CUMIPMT",
	  449: "EDATE",
	  450: "EOMONTH",
	  451: "YEARFRAC",
	  452: "COUPDAYBS",
	  453: "COUPDAYS",
	  454: "COUPDAYSNC",
	  455: "COUPNCD",
	  456: "COUPNUM",
	  457: "COUPPCD",
	  458: "DURATION",
	  459: "MDURATION",
	  460: "ODDLPRICE",
	  461: "ODDLYIELD",
	  462: "ODDFPRICE",
	  463: "ODDFYIELD",
	  464: "RANDBETWEEN",
	  465: "WEEKNUM",
	  466: "AMORDEGRC",
	  467: "AMORLINC",
	  468: "CONVERT",
	  724: "SHEETJS",
	  469: "ACCRINT",
	  470: "ACCRINTM",
	  471: "WORKDAY",
	  472: "NETWORKDAYS",
	  473: "GCD",
	  474: "MULTINOMIAL",
	  475: "LCM",
	  476: "FVSCHEDULE",
	  477: "CUBEKPIMEMBER",
	  478: "CUBESET",
	  479: "CUBESETCOUNT",
	  480: "IFERROR",
	  481: "COUNTIFS",
	  482: "SUMIFS",
	  483: "AVERAGEIF",
	  484: "AVERAGEIFS"
	};
	var FtabArgc = {
	  2: 1,
	  3: 1,
	  10: 0,
	  15: 1,
	  16: 1,
	  17: 1,
	  18: 1,
	  19: 0,
	  20: 1,
	  21: 1,
	  22: 1,
	  23: 1,
	  24: 1,
	  25: 1,
	  26: 1,
	  27: 2,
	  30: 2,
	  31: 3,
	  32: 1,
	  33: 1,
	  34: 0,
	  35: 0,
	  38: 1,
	  39: 2,
	  40: 3,
	  41: 3,
	  42: 3,
	  43: 3,
	  44: 3,
	  45: 3,
	  47: 3,
	  48: 2,
	  53: 1,
	  61: 3,
	  63: 0,
	  65: 3,
	  66: 3,
	  67: 1,
	  68: 1,
	  69: 1,
	  70: 1,
	  71: 1,
	  72: 1,
	  73: 1,
	  74: 0,
	  75: 1,
	  76: 1,
	  77: 1,
	  79: 2,
	  80: 2,
	  83: 1,
	  85: 0,
	  86: 1,
	  89: 0,
	  90: 1,
	  94: 0,
	  95: 0,
	  97: 2,
	  98: 1,
	  99: 1,
	  101: 3,
	  102: 3,
	  105: 1,
	  106: 1,
	  108: 2,
	  111: 1,
	  112: 1,
	  113: 1,
	  114: 1,
	  117: 2,
	  118: 1,
	  119: 4,
	  121: 1,
	  126: 1,
	  127: 1,
	  128: 1,
	  129: 1,
	  130: 1,
	  131: 1,
	  133: 1,
	  134: 1,
	  135: 1,
	  136: 2,
	  137: 2,
	  138: 2,
	  140: 1,
	  141: 1,
	  142: 3,
	  143: 4,
	  144: 4,
	  161: 1,
	  162: 1,
	  163: 1,
	  164: 1,
	  165: 2,
	  172: 1,
	  175: 2,
	  176: 2,
	  177: 3,
	  178: 2,
	  179: 1,
	  184: 1,
	  186: 1,
	  189: 3,
	  190: 1,
	  195: 3,
	  196: 3,
	  197: 1,
	  198: 1,
	  199: 3,
	  201: 1,
	  207: 4,
	  210: 3,
	  211: 1,
	  212: 2,
	  213: 2,
	  214: 1,
	  215: 1,
	  225: 0,
	  229: 1,
	  230: 1,
	  231: 1,
	  232: 1,
	  233: 1,
	  234: 1,
	  235: 3,
	  244: 1,
	  247: 4,
	  252: 2,
	  257: 1,
	  261: 1,
	  271: 1,
	  273: 4,
	  274: 2,
	  275: 2,
	  276: 2,
	  277: 3,
	  278: 3,
	  279: 1,
	  280: 3,
	  281: 3,
	  282: 3,
	  283: 1,
	  284: 1,
	  285: 2,
	  286: 4,
	  287: 3,
	  288: 2,
	  289: 4,
	  290: 3,
	  291: 3,
	  292: 3,
	  293: 4,
	  294: 1,
	  295: 3,
	  296: 1,
	  297: 3,
	  298: 1,
	  299: 2,
	  300: 3,
	  301: 3,
	  302: 4,
	  303: 2,
	  304: 2,
	  305: 2,
	  306: 2,
	  307: 2,
	  308: 2,
	  309: 3,
	  310: 2,
	  311: 2,
	  312: 2,
	  313: 2,
	  314: 2,
	  315: 2,
	  316: 4,
	  325: 2,
	  326: 2,
	  327: 2,
	  328: 2,
	  331: 2,
	  332: 2,
	  337: 2,
	  342: 1,
	  343: 1,
	  346: 2,
	  347: 1,
	  350: 4,
	  351: 3,
	  352: 1,
	  353: 2,
	  360: 1,
	  368: 1,
	  369: 1,
	  370: 1,
	  371: 1,
	  372: 1,
	  373: 1,
	  374: 1,
	  375: 1,
	  376: 1,
	  377: 1,
	  378: 1,
	  382: 3,
	  385: 1,
	  392: 1,
	  393: 1,
	  396: 2,
	  397: 2,
	  398: 2,
	  399: 1,
	  400: 1,
	  401: 1,
	  402: 1,
	  403: 1,
	  404: 1,
	  405: 1,
	  406: 1,
	  407: 1,
	  408: 1,
	  409: 1,
	  410: 1,
	  414: 4,
	  415: 1,
	  416: 1,
	  417: 2,
	  420: 1,
	  421: 1,
	  422: 2,
	  424: 1,
	  425: 2,
	  426: 2,
	  427: 2,
	  428: 2,
	  430: 3,
	  438: 3,
	  439: 3,
	  440: 3,
	  443: 2,
	  444: 2,
	  445: 2,
	  446: 2,
	  447: 6,
	  448: 6,
	  449: 2,
	  450: 2,
	  464: 2,
	  468: 3,
	  476: 2,
	  479: 1,
	  480: 2,
	  65535: 0
	};
	/* Part 3 TODO: actually parse formulae */
	function ods_to_csf_formula(f) {
		if(f.slice(0,3) == "of:") f = f.slice(3);
		/* 5.2 Basic Expressions */
		if(f.charCodeAt(0) == 61) {
			f = f.slice(1);
			if(f.charCodeAt(0) == 61) f = f.slice(1);
		}
		f = f.replace(/COM\.MICROSOFT\./g, "");
		/* Part 3 Section 5.8 References */
		f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
		/* TODO: something other than this */
		f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
		return f.replace(/[;~]/g,",").replace(/\|/g,";");
	}
	
	function csf_to_ods_formula(f) {
		var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
		/* TODO: something other than this */
		return o.replace(/;/g, "|").replace(/,/g,";");
	}
	
	function ods_to_csf_3D(r) {
		var a = r.split(":");
		var s = a[0].split(".")[0];
		return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
	}
	
	function csf_to_ods_3D(r) {
		return r.replace(/\./,"!");
	}
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	
	/*global Map */
	var browser_has_Map = typeof Map !== 'undefined';
	
	function get_sst_id(sst, str, rev) {
		var i = 0, len = sst.length;
		if(rev) {
			if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
				var revarr = browser_has_Map ? rev.get(str) : rev[str];
				for(; i < revarr.length; ++i) {
					if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
				}
			}
		} else for(; i < len; ++i) {
			if(sst[i].t === str) { sst.Count ++; return i; }
		}
		sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
		if(rev) {
			if(browser_has_Map) {
				if(!rev.has(str)) rev.set(str, []);
				rev.get(str).push(len);
			} else {
				if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
				rev[str].push(len);
			}
		}
		return len;
	}
	
	function col_obj_w(C, col) {
		var p = ({min:C+1,max:C+1});
		/* wch (chars), wpx (pixels) */
		var wch = -1;
		if(col.MDW) MDW = col.MDW;
		if(col.width != null) p.customWidth = 1;
		else if(col.wpx != null) wch = px2char(col.wpx);
		else if(col.wch != null) wch = col.wch;
		if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
		else if(col.width != null) p.width = col.width;
		if(col.hidden) p.hidden = true;
		if(col.level != null) { p.outlineLevel = p.level = col.level; }
		return p;
	}
	
	function default_margins(margins, mode) {
		if(!margins) return;
		var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
		if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
		if(margins.left   == null) margins.left   = defs[0];
		if(margins.right  == null) margins.right  = defs[1];
		if(margins.top    == null) margins.top    = defs[2];
		if(margins.bottom == null) margins.bottom = defs[3];
		if(margins.header == null) margins.header = defs[4];
		if(margins.footer == null) margins.footer = defs[5];
	}
	
	function get_cell_style(styles, cell, opts) {
		var z = opts.revssf[cell.z != null ? cell.z : "General"];
		var i = 0x3c, len = styles.length;
		if(z == null && opts.ssf) {
			for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
				SSF_load(cell.z, i);
				// $FlowIgnore
				opts.ssf[i] = cell.z;
				opts.revssf[cell.z] = z = i;
				break;
			}
		}
		for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
		styles[len] = {
			numFmtId:z,
			fontId:0,
			fillId:0,
			borderId:0,
			xfId:0,
			applyNumberFormat:1
		};
		return len;
	}
	
	function safe_format(p, fmtid, fillid, opts, themes, styles) {
		try {
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(p.t === 'z' && !opts.cellStyles) return;
		if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
		if((!opts || opts.cellText !== false) && p.t !== 'z') try {
			if(table_fmt[fmtid] == null) SSF_load(SSFImplicit[fmtid] || "General", fmtid);
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = dd.toString(10);
					else p.w = SSF_general_num(dd);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF_general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF_format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF_format(fmtid,p.v,_ssfopts);
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts.cellStyles) return;
		if(fillid != null) try {
			p.s = styles.Fills[fillid];
			if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
				p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
				if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
			}
			if (p.s.bgColor && p.s.bgColor.theme) {
				p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
				if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
			}
		} catch(e) { if(opts.WTF && styles.Fills) throw e; }
	}
	
	function check_ws(ws, sname, i) {
		if(ws && ws['!ref']) {
			var range = safe_decode_range(ws['!ref']);
			if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
		}
	}
	function parse_ws_xml_dim(ws, s) {
		var d = safe_decode_range(s);
		if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
	var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
	var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
	var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
	var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
	var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
	
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	
		/* 18.3.1.99 worksheet CT_Worksheet */
		var s = opts.dense ? ([]) : ({});
		var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });
	
		var data1 = "", data2 = "";
		var mtch = data.match(sheetdataregex);
		if(mtch) {
			data1 = data.slice(0, mtch.index);
			data2 = data.slice(mtch.index + mtch[0].length);
		} else data1 = data2 = data;
	
		/* 18.3.1.82 sheetPr CT_SheetPr */
		var sheetPr = data1.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
		else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx, styles, themes);
	
		/* 18.3.1.35 dimension CT_SheetDimension */
		var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
		if(ridx > 0) {
			var ref = data1.slice(ridx,ridx+50).match(dimregex);
			if(ref) parse_ws_xml_dim(s, ref[1]);
		}
	
		/* 18.3.1.88 sheetViews CT_SheetViews */
		var svs = data1.match(svsregex);
		if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
	
		/* 18.3.1.17 cols CT_Cols */
		var columns = [];
		if(opts.cellStyles) {
			/* 18.3.1.13 col CT_Col */
			var cols = data1.match(colregex);
			if(cols) parse_ws_xml_cols(columns, cols);
		}
	
		/* 18.3.1.80 sheetData CT_SheetData ? */
		if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
	
		/* 18.3.1.2  autoFilter CT_AutoFilter */
		var afilter = data2.match(afregex);
		if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
	
		/* 18.3.1.55 mergeCells CT_MergeCells */
		var merges = [];
		var _merge = data2.match(mergecregex);
		if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
			merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));
	
		/* 18.3.1.48 hyperlinks CT_Hyperlinks */
		var hlink = data2.match(hlinkregex);
		if(hlink) parse_ws_xml_hlinks(s, hlink, rels);
	
		/* 18.3.1.62 pageMargins CT_PageMargins */
		var margins = data2.match(marginregex);
		if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
	
		if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
		if(opts.sheetRows > 0 && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(columns.length > 0) s["!cols"] = columns;
		if(merges.length > 0) s["!merges"] = merges;
		return s;
	}
	
	function write_ws_xml_merges(merges) {
		if(merges.length === 0) return "";
		var o = '<mergeCells count="' + merges.length + '">';
		for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
		return o + '</mergeCells>';
	}
	
	/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
	function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
		var data = parsexmltag(sheetPr);
		if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
		if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
	}
	function parse_ws_xml_sheetpr2(sheetPr, body, s, wb, idx) {
		parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
	}
	function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
		var needed = false;
		var props = {}, payload = null;
		if(opts.bookType !== 'xlsx' && wb.vbaraw) {
			var cname = wb.SheetNames[idx];
			try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
			needed = true;
			props.codeName = utf8write(escapexml(cname));
		}
	
		if(ws && ws["!outline"]) {
			var outlineprops = {summaryBelow:1, summaryRight:1};
			if(ws["!outline"].above) outlineprops.summaryBelow = 0;
			if(ws["!outline"].left) outlineprops.summaryRight = 0;
			payload = (payload||"") + writextag('outlinePr', null, outlineprops);
		}
	
		if(!needed && !payload) return;
		o[o.length] = (writextag('sheetPr', payload, props));
	}
	
	/* 18.3.1.85 sheetProtection CT_SheetProtection */
	var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var sheetprot_deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	function write_ws_xml_protection(sp) {
		// algorithmName, hashValue, saltValue, spinCount
		var o = ({sheet:1});
		sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
		sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
		/* TODO: algorithm */
		if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
		return writextag('sheetProtection', null, o);
	}
	
	function parse_ws_xml_hlinks(s, data, rels) {
		var dense = Array.isArray(s);
		for(var i = 0; i != data.length; ++i) {
			var val = parsexmltag(utf8read(data[i]), true);
			if(!val.ref) return;
			var rel = ((rels || {})['!id']||[])[val.id];
			if(rel) {
				val.Target = rel.Target;
				if(val.location) val.Target += "#"+unescapexml(val.location);
			} else {
				val.Target = "#" + unescapexml(val.location);
				rel = {Target: val.Target, TargetMode: 'Internal'};
			}
			val.Rel = rel;
			if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
			var rng = safe_decode_range(val.ref);
			for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
				var addr = encode_cell({c:C,r:R});
				if(dense) {
					if(!s[R]) s[R] = [];
					if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
					s[R][C].l = val;
				} else {
					if(!s[addr]) s[addr] = {t:"z",v:undefined};
					s[addr].l = val;
				}
			}
		}
	}
	
	function parse_ws_xml_margins(margin) {
		var o = {};
		["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
			if(margin[k]) o[k] = parseFloat(margin[k]);
		});
		return o;
	}
	function write_ws_xml_margins(margin) {
		default_margins(margin);
		return writextag('pageMargins', null, margin);
	}
	
	function parse_ws_xml_cols(columns, cols) {
		var seencol = false;
		for(var coli = 0; coli != cols.length; ++coli) {
			var coll = parsexmltag(cols[coli], true);
			if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
			var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
			if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
			delete coll.min; delete coll.max; coll.width = +coll.width;
			if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
			process_col(coll);
			while(colm <= colM) columns[colm++] = dup(coll);
		}
	}
	function write_ws_xml_cols(ws, cols) {
		var o = ["<cols>"], col;
		for(var i = 0; i != cols.length; ++i) {
			if(!(col = cols[i])) continue;
			o[o.length] = (writextag('col', null, col_obj_w(i, col)));
		}
		o[o.length] = "</cols>";
		return o.join("");
	}
	
	function parse_ws_xml_autofilter(data) {
		var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
		return o;
	}
	function write_ws_xml_autofilter(data, ws, wb, idx) {
		var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
		return writextag("autoFilter", null, {ref:ref});
	}
	
	/* 18.3.1.88 sheetViews CT_SheetViews */
	/* 18.3.1.87 sheetView CT_SheetView */
	var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
	function parse_ws_xml_sheetviews(data, wb) {
		if(!wb.Views) wb.Views = [{}];
		(data.match(sviewregex)||[]).forEach(function(r, i) {
			var tag = parsexmltag(r);
			// $FlowIgnore
			if(!wb.Views[i]) wb.Views[i] = {};
			// $FlowIgnore
			if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
			// $FlowIgnore
			if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
		});
	}
	function write_ws_xml_sheetviews(ws, opts, idx, wb) {
		var sview = ({workbookViewId:"0"});
		// $FlowIgnore
		if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
		return writextag("sheetViews", writextag("sheetView", null, sview), {});
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts) {
		if(cell.c) ws['!comments'].push([ref, cell.c]);
		if(cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z' && !cell.f) return "";
		var vv = "";
		var oldt = cell.t, oldv = cell.v;
		if(cell.t !== "z") switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': vv = ''+cell.v; break;
			case 'e': vv = BErr[cell.v]; break;
			case 'd':
				if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
				else {
					cell = dup(cell);
					cell.t = 'n';
					vv = ''+(cell.v = datenum(parseDate(cell.v)));
				}
				if(typeof cell.z === 'undefined') cell.z = table_fmt[14];
				break;
			default: vv = cell.v; break;
		}
		var v = writetag('v', escapexml(vv)), o = ({r:ref});
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		if(os !== 0) o.s = os;
		switch(cell.t) {
			case 'n': break;
			case 'd': o.t = "d"; break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
			case 'z': break;
			default: if(cell.v == null) { delete cell.t; break; }
				if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
				if(opts && opts.bookSST) {
					v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
					o.t = "s"; break;
				}
				o.t = "str"; break;
		}
		if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
		if(typeof cell.f == "string" && cell.f) {
			var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
			v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
		}
		if(cell.l) ws['!links'].push([ref, cell.l]);
		if(cell.D) o.cm = 1;
		return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function() {
		var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
		var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
		var refregex = /ref=["']([^"']*)["']/;
		var match_v = matchtag("v"), match_f = matchtag("f");
	
	return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
		var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
		var tag, tagr = 0, tagc = 0;
		var sstr, ftag;
		var fmtid = 0, fillid = 0;
		var do_format = Array.isArray(styles.CellXf), cf;
		var arrayf = [];
		var sharedf = [];
		var dense = Array.isArray(s);
		var rows = [], rowobj = {}, rowrite = false;
		var sheetStubs = !!opts.sheetStubs;
		for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
			x = marr[mt].trim();
			var xlen = x.length;
			if(xlen === 0) continue;
	
			/* 18.3.1.73 row CT_Row */
			var rstarti = 0;
			outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
				case ">" /*62*/:
					if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
					if(opts && opts.cellStyles) {
						// TODO: avoid duplication
						tag = parsexmltag(x.slice(rstarti,ri), true);
						tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
						if(opts.sheetRows && opts.sheetRows < tagr) continue;
						rowobj = {}; rowrite = false;
						if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
						if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
						if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
						if(rowrite) rows[tagr-1] = rowobj;
					}
					break;
				case "<" /*60*/: rstarti = ri; break;
			}
			if(rstarti >= ri) break;
			tag = parsexmltag(x.slice(rstarti,ri), true);
			tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
			if(opts.sheetRows && opts.sheetRows < tagr) continue;
			if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
			if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
			if(opts && opts.cellStyles) {
				rowobj = {}; rowrite = false;
				if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
				if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
				if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
				if(rowrite) rows[tagr-1] = rowobj;
			}
	
			/* 18.3.1.4 c CT_Cell */
			cells = x.slice(ri).split(cellregex);
			for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
			cells = cells.slice(rslice);
			for(ri = 0; ri != cells.length; ++ri) {
				x = cells[ri].trim();
				if(x.length === 0) continue;
				cref = x.match(rregex); idx = ri; i=0; cc=0;
				x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
				if(cref != null && cref.length === 2) {
					idx = 0; d=cref[1];
					for(i=0; i != d.length; ++i) {
						if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
						idx = 26*idx + cc;
					}
					--idx;
					tagc = idx;
				} else ++tagc;
				for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
				tag = parsexmltag(x.slice(0,i), true);
				if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
				d = x.slice(i);
				p = ({t:""});
	
				if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
				if(opts.cellFormula) {
					if((cref=d.match(match_f))!= null && cref[1] !== '') {
						/* TODO: match against XLSXFutureFunctions */
						p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
						if(!opts.xlfn) p.f = _xlfn(p.f);
						if(cref[0].indexOf('t="array"') > -1) {
							p.F = (d.match(refregex)||[])[1];
							if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
						} else if(cref[0].indexOf('t="shared"') > -1) {
							// TODO: parse formula
							ftag = parsexmltag(cref[0]);
							var ___f = unescapexml(utf8read(cref[1]));
							if(!opts.xlfn) ___f = _xlfn(___f);
							sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
						}
					} else if((cref=d.match(/<f[^>]*\/>/))) {
						ftag = parsexmltag(cref[0]);
						if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
					}
					/* TODO: factor out contains logic */
					var _tag = decode_cell(tag.r);
					for(i = 0; i < arrayf.length; ++i)
						if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
							if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
								p.F = arrayf[i][1];
				}
	
				if(tag.t == null && p.v === undefined) {
					if(p.f || p.F) {
						p.v = 0; p.t = "n";
					} else if(!sheetStubs) continue;
					else p.t = "z";
				}
				else p.t = tag.t || "n";
				if(guess.s.c > tagc) guess.s.c = tagc;
				if(guess.e.c < tagc) guess.e.c = tagc;
				/* 18.18.11 t ST_CellType */
				switch(p.t) {
					case 'n':
						if(p.v == "" || p.v == null) {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else p.v = parseFloat(p.v);
						break;
					case 's':
						if(typeof p.v == 'undefined') {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else {
							sstr = strs[parseInt(p.v, 10)];
							p.v = sstr.t;
							p.r = sstr.r;
							if(opts.cellHTML) p.h = sstr.h;
						}
						break;
					case 'str':
						p.t = "s";
						p.v = (p.v!=null) ? utf8read(p.v) : '';
						if(opts.cellHTML) p.h = escapehtml(p.v);
						break;
					case 'inlineStr':
						cref = d.match(isregex);
						p.t = 's';
						if(cref != null && (sstr = parse_si(cref[1]))) {
							p.v = sstr.t;
							if(opts.cellHTML) p.h = sstr.h;
						} else p.v = "";
						break;
					case 'b': p.v = parsexmlbool(p.v); break;
					case 'd':
						if(opts.cellDates) p.v = parseDate(p.v, 1);
						else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
						break;
					/* error string in .w, number in .v */
					case 'e':
						if(!opts || opts.cellText !== false) p.w = p.v;
						p.v = RBErr[p.v]; break;
				}
				/* formatting */
				fmtid = fillid = 0;
				cf = null;
				if(do_format && tag.s !== undefined) {
					cf = styles.CellXf[tag.s];
					if(cf != null) {
						if(cf.numFmtId != null) fmtid = cf.numFmtId;
						if(opts.cellStyles) {
							if(cf.fillId != null) fillid = cf.fillId;
						}
					}
				}
				safe_format(p, fmtid, fillid, opts, themes, styles);
				if(opts.cellDates && do_format && p.t == 'n' && fmt_is_date(table_fmt[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
				if(tag.cm && opts.xlmeta) {
					var cm = (opts.xlmeta.Cell||[])[+tag.cm-1];
					if(cm && cm.type == 'XLDAPR') p.D = true;
				}
				if(dense) {
					var _r = decode_cell(tag.r);
					if(!s[_r.r]) s[_r.r] = [];
					s[_r.r][_r.c] = p;
				} else s[tag.r] = p;
			}
		}
		if(rows.length > 0) s['!rows'] = rows;
	}; })();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
		var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
		var dense = Array.isArray(ws);
		var params = ({r:rr}), row, height = -1;
		for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
		for(R = range.s.r; R <= range.e.r; ++R) {
			r = [];
			rr = encode_row(R);
			for(C = range.s.c; C <= range.e.c; ++C) {
				ref = cols[C] + rr;
				var _cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(_cell === undefined) continue;
				if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
			}
			if(r.length > 0 || (rows && rows[R])) {
				params = ({r:rr});
				if(rows && rows[R]) {
					row = rows[R];
					if(row.hidden) params.hidden = 1;
					height = -1;
					if(row.hpx) height = px2pt(row.hpx);
					else if(row.hpt) height = row.hpt;
					if(height > -1) { params.ht = height; params.customHeight = 1; }
					if(row.level) { params.outlineLevel = row.level; }
				}
				o[o.length] = (writextag('row', r.join(""), params));
			}
		}
		if(rows) for(; R < rows.length; ++R) {
			if(rows && rows[R]) {
				params = ({r:R+1});
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
				o[o.length] = (writextag('row', "", params));
			}
		}
		return o.join("");
	}
	
	function write_ws_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('worksheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		var s = wb.SheetNames[idx], sidx = 0, rdata = "";
		var ws = wb.Sheets[s];
		if(ws == null) ws = {};
		var ref = ws['!ref'] || 'A1';
		var range = safe_decode_range(ref);
		if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
			range.e.c = Math.min(range.e.c, 0x3FFF);
			range.e.r = Math.min(range.e.c, 0xFFFFF);
			ref = encode_range(range);
		}
		if(!rels) rels = {};
		ws['!comments'] = [];
		var _drawing = [];
	
		write_ws_xml_sheetpr(ws, wb, idx, opts, o);
	
		o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
		o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
	
		/* TODO: store in WB, process styles */
		if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
			defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
			baseColWidth:opts.sheetFormat.baseColWidth||'10',
			outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
		}));
	
		if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	
		o[sidx = o.length] = '<sheetData/>';
		ws['!links'] = [];
		if(ws['!ref'] != null) {
			rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
			if(rdata.length > 0) o[o.length] = (rdata);
		}
		if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }
	
		/* sheetCalcPr */
	
		if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);
	
		/* protectedRanges */
		/* scenarios */
	
		if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
	
		/* sortState */
		/* dataConsolidate */
		/* customSheetViews */
	
		if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
		/* phoneticPr */
		/* conditionalFormatting */
		/* dataValidations */
	
		var relc = -1, rel, rId = -1;
		if(ws['!links'].length > 0) {
			o[o.length] = "<hyperlinks>";
	ws['!links'].forEach(function(l) {
				if(!l[1].Target) return;
				rel = ({"ref":l[0]});
				if(l[1].Target.charAt(0) != "#") {
					rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
					rel["r:id"] = "rId"+rId;
				}
				if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
				if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
				o[o.length] = writextag("hyperlink",null,rel);
			});
			o[o.length] = "</hyperlinks>";
		}
		delete ws['!links'];
	
		/* printOptions */
	
		if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	
		/* pageSetup */
		/* headerFooter */
		/* rowBreaks */
		/* colBreaks */
		/* customProperties */
		/* cellWatches */
	
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));
	
		/* smartTags */
	
		if(_drawing.length > 0) {
			rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
			o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
			ws['!drawing'] = _drawing;
		}
	
		if(ws['!comments'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
			ws['!legacy'] = rId;
		}
	
		/* legacyDrawingHF */
		/* picture */
		/* oleObjects */
		/* controls */
		/* webPublishItems */
		/* tableParts */
		/* extLst */
	
		if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.726 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = ({});
		var tgt = data.l + length;
		z.r = data.read_shift(4);
		data.l += 4; // TODO: ixfe
		var miyRw = data.read_shift(2);
		data.l += 1; // TODO: top/bot padding
		var flags = data.read_shift(1);
		data.l = tgt;
		if(flags & 0x07) z.level = flags & 0x07;
		if(flags & 0x10) z.hidden = true;
		if(flags & 0x20) z.hpt = miyRw / 20;
		return z;
	}
	function write_BrtRowHdr(R, range, ws) {
		var o = new_buf(17+8*16);
		var row = (ws['!rows']||[])[R]||{};
		o.write_shift(4, R);
	
		o.write_shift(4, 0); /* TODO: ixfe */
	
		var miyRw = 0x0140;
		if(row.hpx) miyRw = px2pt(row.hpx) * 20;
		else if(row.hpt) miyRw = row.hpt * 20;
		o.write_shift(2, miyRw);
	
		o.write_shift(1, 0); /* top/bot padding */
	
		var flags = 0x0;
		if(row.level) flags |= row.level;
		if(row.hidden) flags |= 0x10;
		if(row.hpx || row.hpt) flags |= 0x20;
		o.write_shift(1, flags);
	
		o.write_shift(1, 0); /* phonetic guide */
	
		/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
		var ncolspan = 0, lcs = o.l;
		o.l += 4;
	
		var caddr = {r:R, c:0};
		for(var i = 0; i < 16; ++i) {
			if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
			var first = -1, last = -1;
			for(var j = (i<<10); j < ((i+1)<<10); ++j) {
				caddr.c = j;
				var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
				if(cell) { if(first < 0) first = j; last = j; }
			}
			if(first < 0) continue;
			++ncolspan;
			o.write_shift(4, first);
			o.write_shift(4, last);
		}
	
		var l = o.l;
		o.l = lcs;
		o.write_shift(4, ncolspan);
		o.l = l;
	
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function write_row_header(ba, ws, range, R) {
		var o = write_BrtRowHdr(R, range, ws);
		if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 0x0000 /* BrtRowHdr */, o);
	}
	
	/* [MS-XLSB] 2.4.820 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
	function parse_BrtWsFmtInfo() {
	}
	//function write_BrtWsFmtInfo(ws, o) { }
	
	/* [MS-XLSB] 2.4.823 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		var f = data[data.l]; ++data.l;
		z.above = !(f & 0x40);
		z.left  = !(f & 0x80);
		/* TODO: pull flags */
		data.l += 18;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	function write_BrtWsProp(str, outl, o) {
		if(o == null) o = new_buf(84+4*str.length);
		var f = 0xC0;
		if(outl) {
			if(outl.above) f &= ~0x40;
			if(outl.left)  f &= ~0x80;
		}
		o.write_shift(1, f);
		for(var i = 1; i < 3; ++i) o.write_shift(1,0);
		write_BrtColor({auto:1}, o);
		o.write_shift(-4,-1);
		o.write_shift(-4,-1);
		write_XLSBCodeName(str, o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.306 BrtCellBlank */
	function parse_BrtCellBlank(data) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(ncell, o);
	}
	function parse_BrtShortBlank(data) {
		var cell = parse_XLSBShortCell(data);
		return [cell];
	}
	function write_BrtShortBlank(cell, ncell, o) {
		if(o == null) o = new_buf(4);
		return write_XLSBShortCell(ncell, o);
	}
	
	/* [MS-XLSB] 2.4.307 BrtCellBool */
	function parse_BrtCellBool(data) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtCellBool(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	function parse_BrtShortBool(data) {
		var cell = parse_XLSBShortCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtShortBool(cell, ncell, o) {
		if(o == null) o = new_buf(5);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellError */
	function parse_BrtCellError(data) {
		var cell = parse_XLSBCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtCellError(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v);
		return o;
	}
	function parse_BrtShortError(data) {
		var cell = parse_XLSBShortCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtShortError(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v);
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.311 BrtCellIsst */
	function parse_BrtCellIsst(data) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtCellIsst(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	function parse_BrtShortIsst(data) {
		var cell = parse_XLSBShortCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtShortIsst(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	
	/* [MS-XLSB] 2.4.313 BrtCellReal */
	function parse_BrtCellReal(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellReal(cell, ncell, o) {
		if(o == null) o = new_buf(16);
		write_XLSBCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	function parse_BrtShortReal(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortReal(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBShortCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.314 BrtCellRk */
	function parse_BrtCellRk(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellRk(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	function parse_BrtShortRk(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortRk(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtCellRString */
	function parse_BrtCellRString(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RichStr(data);
		return [cell, value, 'is'];
	}
	
	/* [MS-XLSB] 2.4.317 BrtCellSt */
	function parse_BrtCellSt(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtCellSt(cell, ncell, o) {
		if(o == null) o = new_buf(12 + 4 * cell.v.length);
		write_XLSBCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function parse_BrtShortSt(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtShortSt(cell, ncell, o) {
		if(o == null) o = new_buf(8 + 4 * cell.v.length);
		write_XLSBShortCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.653 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.654 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.655 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.656 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.682 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	var write_BrtMergeCell = write_UncheckedRfX;
	/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
	function write_BrtBeginMergeCells(cnt, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(4, cnt);
		return o;
	}
	
	/* [MS-XLSB] 2.4.662 BrtHLink */
	function parse_BrtHLink(data, length) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
		if(tooltip) o.Tooltip = tooltip;
		return o;
	}
	function write_BrtHLink(l, rId) {
		var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
		write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
		write_RelID("rId" + rId, o);
		var locidx = l[1].Target.indexOf("#");
		var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
		write_XLWideString(loc || "", o);
		write_XLWideString(l[1].Tooltip || "", o);
		write_XLWideString("", o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.692 BrtPane */
	function parse_BrtPane(/*data, length, opts*/) {
	}
	
	/* [MS-XLSB] 2.4.6 BrtArrFmla */
	function parse_BrtArrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_RfX(data, 16);
		var fAlwaysCalc = data.read_shift(1);
		var o = [rfx]; o[2] = fAlwaysCalc;
		if(opts.cellFormula) {
			var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
			o[1] = formula;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.750 BrtShrFmla */
	function parse_BrtShrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var o = [rfx];
		if(opts.cellFormula) {
			var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
			o[1] = formula;
			data.l = end;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtColInfo */
	/* TODO: once XLS ColInfo is set, combine the functions */
	function write_BrtColInfo(C, col, o) {
		if(o == null) o = new_buf(18);
		var p = col_obj_w(C, col);
		o.write_shift(-4, C);
		o.write_shift(-4, C);
		o.write_shift(4, (p.width || 10) * 256);
		o.write_shift(4, 0/*ixfe*/); // style
		var flags = 0;
		if(col.hidden) flags |= 0x01;
		if(typeof p.width == 'number') flags |= 0x02;
		if(col.level) flags |= (col.level << 8);
		o.write_shift(2, flags); // bit flag
		return o;
	}
	
	/* [MS-XLSB] 2.4.678 BrtMargins */
	var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
	function parse_BrtMargins(data) {
		var margins = ({});
		BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
		return margins;
	}
	function write_BrtMargins(margins, o) {
		if(o == null) o = new_buf(6*8);
		default_margins(margins);
		BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
		return o;
	}
	
	/* [MS-XLSB] 2.4.299 BrtBeginWsView */
	function parse_BrtBeginWsView(data) {
		var f = data.read_shift(2);
		data.l += 28;
		return { RTL: f & 0x20 };
	}
	function write_BrtBeginWsView(ws, Workbook, o) {
		if(o == null) o = new_buf(30);
		var f = 0x39c;
		if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
		o.write_shift(2, f); // bit flag
		o.write_shift(4, 0);
		o.write_shift(4, 0); // view first row
		o.write_shift(4, 0); // view first col
		o.write_shift(1, 0); // gridline color ICV
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 100); // zoom scale
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0); // workbook view id
		return o;
	}
	
	/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
	function write_BrtCellIgnoreEC(ref) {
		var o = new_buf(24);
		o.write_shift(4, 4);
		o.write_shift(4, 1);
		write_UncheckedRfX(ref, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.748 BrtSheetProtection */
	function write_BrtSheetProtection(sp, o) {
		if(o == null) o = new_buf(16*4+2);
		o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
		o.write_shift(4, 1); // this record should not be written if no protection
		[
			["objects",             false], // fObjects
			["scenarios",           false], // fScenarios
			["formatCells",          true], // fFormatCells
			["formatColumns",        true], // fFormatColumns
			["formatRows",           true], // fFormatRows
			["insertColumns",        true], // fInsertColumns
			["insertRows",           true], // fInsertRows
			["insertHyperlinks",     true], // fInsertHyperlinks
			["deleteColumns",        true], // fDeleteColumns
			["deleteRows",           true], // fDeleteRows
			["selectLockedCells",   false], // fSelLockedCells
			["sort",                 true], // fSort
			["autoFilter",           true], // fAutoFilter
			["pivotTables",          true], // fPivotTables
			["selectUnlockedCells", false]  // fSelUnlockedCells
		].forEach(function(n) {
	if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
			else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
		});
		return o;
	}
	
	function parse_BrtDVal(/*data, length, opts*/) {
	}
	function parse_BrtDVal14(/*data, length, opts*/) {
	}
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		var opts = _opts || {};
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var s = (opts.dense ? [] : {});
	
		var ref;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		var state = [];
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr, cell;
		var merges = [];
		opts.biff = 12;
		opts['!row'] = 0;
	
		var ai = 0, af = false;
	
		var arrayf = [];
		var sharedf = {};
		var supbooks = opts.supbooks || wb.supbooks || ([[]]);
		supbooks.sharedf = sharedf;
		supbooks.arrayf = arrayf;
		supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
		if(!opts.supbooks) {
			opts.supbooks = supbooks;
			if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
		}
	
		var colinfo = [], rowinfo = [];
		var seencol = false;
	
		XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };
	
		var cm, vm;
	
		recordhopper(data, function ws_parse(val, RR, RT) {
			if(end) return;
			switch(RT) {
				case 0x0094: /* 'BrtWsDim' */
					ref = val; break;
				case 0x0000: /* 'BrtRowHdr' */
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(R = row.r);
					opts['!row'] = row.r;
					if(val.hidden || val.hpt || val.level != null) {
						if(val.hpt) val.hpx = pt2px(val.hpt);
						rowinfo[val.r] = val;
					}
					break;
	
				case 0x0002: /* 'BrtCellRk' */
				case 0x0003: /* 'BrtCellError' */
				case 0x0004: /* 'BrtCellBool' */
				case 0x0005: /* 'BrtCellReal' */
				case 0x0006: /* 'BrtCellSt' */
				case 0x0007: /* 'BrtCellIsst' */
				case 0x0008: /* 'BrtFmlaString' */
				case 0x0009: /* 'BrtFmlaNum' */
				case 0x000A: /* 'BrtFmlaBool' */
				case 0x000B: /* 'BrtFmlaError' */
				case 0x000D: /* 'BrtShortRk' */
				case 0x000E: /* 'BrtShortError' */
				case 0x000F: /* 'BrtShortBool' */
				case 0x0010: /* 'BrtShortReal' */
				case 0x0011: /* 'BrtShortSt' */
				case 0x0012: /* 'BrtShortIsst' */
				case 0x003E: /* 'BrtCellRString' */
					p = ({t:val[2]});
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = val[1]; break;
						case 'is': p.t = 's'; p.v = val[1].t; break;
					}
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(opts.cellFormula) {
						af = false;
						for(ai = 0; ai < arrayf.length; ++ai) {
							var aii = arrayf[ai];
							if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
								if(C >= aii[0].s.c && C <= aii[0].e.c) {
									p.F = encode_range(aii[0]); af = true;
								}
						}
						if(!af && val.length > 3) p.f = val[3];
					}
	
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(opts.cellDates && cf && p.t == 'n' && fmt_is_date(table_fmt[cf.numFmtId])) {
						var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
					}
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x0001: /* 'BrtCellBlank' */
				case 0x000C: /* 'BrtShortBlank' */
					if(!opts.sheetStubs || pass) break;
					p = ({t:'z',v:void 0});
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x00B0: /* 'BrtMergeCell' */
					merges.push(val); break;
	
				case 0x0031: { /* 'BrtCellMeta' */
					cm = ((opts.xlmeta||{}).Cell||[])[val-1];
				} break;
	
				case 0x01EE: /* 'BrtHLink' */
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					} else if(val.relId == '') {
						val.Target = "#" + val.loc;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						if(opts.dense) {
							if(!s[R]) s[R] = [];
							if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
							s[R][C].l = val;
						} else {
							addr = encode_cell({c:C,r:R});
							if(!s[addr]) s[addr] = {t:'z',v:undefined};
							s[addr].l = val;
						}
					}
					break;
	
				case 0x01AA: /* 'BrtArrFmla' */
					if(!opts.cellFormula) break;
					arrayf.push(val);
					cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					cell.F = encode_range(val[0]);
					break;
				case 0x01AB: /* 'BrtShrFmla' */
					if(!opts.cellFormula) break;
					sharedf[encode_cell(val[0].s)] = val[1];
					cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					break;
	
				/* identical to 'ColInfo' in XLS */
				case 0x003C: /* 'BrtColInfo' */
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
					break;
	
				case 0x00A1: /* 'BrtBeginAFilter' */
					s['!autofilter'] = { ref:encode_range(val) };
					break;
	
				case 0x01DC: /* 'BrtMargins' */
					s['!margins'] = val;
					break;
	
				case 0x0093: /* 'BrtWsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
					break;
	
				case 0x0089: /* 'BrtBeginWsView' */
					if(!wb.Views) wb.Views = [{}];
					if(!wb.Views[0]) wb.Views[0] = {};
					if(val.RTL) wb.Views[0].RTL = true;
					break;
	
				case 0x01E5: /* 'BrtWsFmtInfo' */
					break;
	
				case 0x0040: /* 'BrtDVal' */
				case 0x041D: /* 'BrtDVal14' */
					break;
	
				case 0x0097: /* 'BrtPane' */
					break;
				case 0x0098: /* 'BrtSel' */
				case 0x00AF: /* 'BrtAFilterDateGroupItem' */
				case 0x0284: /* 'BrtActiveX' */
				case 0x0271: /* 'BrtBigName' */
				case 0x0232: /* 'BrtBkHim' */
				case 0x018C: /* 'BrtBrk' */
				case 0x0458: /* 'BrtCFIcon' */
				case 0x047A: /* 'BrtCFRuleExt' */
				case 0x01D7: /* 'BrtCFVO' */
				case 0x041A: /* 'BrtCFVO14' */
				case 0x0289: /* 'BrtCellIgnoreEC' */
				case 0x0451: /* 'BrtCellIgnoreEC14' */
				case 0x024D: /* 'BrtCellSmartTagProperty' */
				case 0x025F: /* 'BrtCellWatch' */
				case 0x0234: /* 'BrtColor' */
				case 0x041F: /* 'BrtColor14' */
				case 0x00A8: /* 'BrtColorFilter' */
				case 0x00AE: /* 'BrtCustomFilter' */
				case 0x049C: /* 'BrtCustomFilter14' */
				case 0x01F3: /* 'BrtDRef' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x0226: /* 'BrtDrawing' */
				case 0x00AB: /* 'BrtDynamicFilter' */
				case 0x00A7: /* 'BrtFilter' */
				case 0x0499: /* 'BrtFilter14' */
				case 0x00A9: /* 'BrtIconFilter' */
				case 0x049D: /* 'BrtIconFilter14' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x0295: /* 'BrtListPart' */
				case 0x027F: /* 'BrtOleObject' */
				case 0x01DE: /* 'BrtPageSetup' */
				case 0x0219: /* 'BrtPhoneticInfo' */
				case 0x01DD: /* 'BrtPrintOptions' */
				case 0x0218: /* 'BrtRangeProtection' */
				case 0x044F: /* 'BrtRangeProtection14' */
				case 0x02A8: /* 'BrtRangeProtectionIso' */
				case 0x0450: /* 'BrtRangeProtectionIso14' */
				case 0x0400: /* 'BrtRwDescent' */
				case 0x0297: /* 'BrtSheetCalcProp' */
				case 0x0217: /* 'BrtSheetProtection' */
				case 0x02A6: /* 'BrtSheetProtectionIso' */
				case 0x01F8: /* 'BrtSlc' */
				case 0x0413: /* 'BrtSparkline' */
				case 0x01AC: /* 'BrtTable' */
				case 0x00AA: /* 'BrtTop10Filter' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0032: /* 'BrtValueMeta' */
				case 0x0816: /* 'BrtWebExtension' */
				case 0x0415: /* 'BrtWsFmtInfoEx14' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if(RR.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		delete opts.supbooks;
		delete opts['!row'];
	
		if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(merges.length > 0) s["!merges"] = merges;
		if(colinfo.length > 0) s["!cols"] = colinfo;
		if(rowinfo.length > 0) s["!rows"] = rowinfo;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen) {
		if(cell.v === undefined) return false;
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'd': // no BrtCellDate :(
				cell = dup(cell);
				cell.z = cell.z || table_fmt[14];
				cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
				break;
			/* falls through */
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = ({r:R, c:C});
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
		if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
					o.t = "s"; o.v = vv;
					if(last_seen) write_record(ba, 0x0012 /* BrtShortIsst */, write_BrtShortIsst(cell, o));
					else write_record(ba, 0x0007 /* BrtCellIsst */, write_BrtCellIsst(cell, o));
				} else {
					o.t = "str";
					if(last_seen) write_record(ba, 0x0011 /* BrtShortSt */, write_BrtShortSt(cell, o));
					else write_record(ba, 0x0006 /* BrtCellSt */, write_BrtCellSt(cell, o));
				}
				return true;
			case 'n':
				/* TODO: determine threshold for Real vs RK */
				if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
					if(last_seen) write_record(ba, 0x000D /* BrtShortRk */, write_BrtShortRk(cell, o));
					else write_record(ba, 0x0002 /* BrtCellRk */, write_BrtCellRk(cell, o));
				} else {
					if(last_seen) write_record(ba, 0x0010 /* BrtShortReal */, write_BrtShortReal(cell, o));
					else write_record(ba, 0x0005 /* BrtCellReal */, write_BrtCellReal(cell, o));
				} return true;
			case 'b':
				o.t = "b";
				if(last_seen) write_record(ba, 0x000F /* BrtShortBool */, write_BrtShortBool(cell, o));
				else write_record(ba, 0x0004 /* BrtCellBool */, write_BrtCellBool(cell, o));
				return true;
			case 'e':
				o.t = "e";
				if(last_seen) write_record(ba, 0x000E /* BrtShortError */, write_BrtShortError(cell, o));
				else write_record(ba, 0x0003 /* BrtCellError */, write_BrtCellError(cell, o));
				return true;
		}
		if(last_seen) write_record(ba, 0x000C /* BrtShortBlank */, write_BrtShortBlank(cell, o));
		else write_record(ba, 0x0001 /* BrtCellBlank */, write_BrtCellBlank(cell, o));
		return true;
	}
	
	function write_CELLTABLE(ba, ws, idx, opts) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 0x0091 /* BrtBeginSheetData */);
		var dense = Array.isArray(ws);
		var cap = range.e.r;
		if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
		for(var R = range.s.r; R <= cap; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			write_row_header(ba, ws, range, R);
			var last_seen = false;
			if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) { last_seen = false; continue; }
				/* write cell */
				last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
			}
		}
		write_record(ba, 0x0092 /* BrtEndSheetData */);
	}
	
	function write_MERGECELLS(ba, ws) {
		if(!ws || !ws['!merges']) return;
		write_record(ba, 0x00B1 /* BrtBeginMergeCells */, write_BrtBeginMergeCells(ws['!merges'].length));
		ws['!merges'].forEach(function(m) { write_record(ba, 0x00B0 /* BrtMergeCell */, write_BrtMergeCell(m)); });
		write_record(ba, 0x00B2 /* BrtEndMergeCells */);
	}
	
	function write_COLINFOS(ba, ws) {
		if(!ws || !ws['!cols']) return;
		write_record(ba, 0x0186 /* BrtBeginColInfos */);
		ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 0x003C /* 'BrtColInfo' */, write_BrtColInfo(i, m)); });
		write_record(ba, 0x0187 /* BrtEndColInfos */);
	}
	
	function write_IGNOREECS(ba, ws) {
		if(!ws || !ws['!ref']) return;
		write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */);
		write_record(ba, 0x0289 /* BrtCellIgnoreEC */, write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
		write_record(ba, 0x028A /* BrtEndCellIgnoreECs */);
	}
	
	function write_HLINKS(ba, ws, rels) {
		/* *BrtHLink */
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
			write_record(ba, 0x01EE /* BrtHLink */, write_BrtHLink(l, rId));
		});
		delete ws['!links'];
	}
	function write_LEGACYDRAWING(ba, ws, idx, rels) {
		/* [BrtLegacyDrawing] */
		if(ws['!comments'].length > 0) {
			var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			write_record(ba, 0x0227 /* BrtLegacyDrawing */, write_RelID("rId" + rId));
			ws['!legacy'] = rId;
		}
	}
	
	function write_AUTOFILTER(ba, ws, wb, idx) {
		if(!ws['!autofilter']) return;
		var data = ws['!autofilter'];
		var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
	
		/* Update FilterDatabase defined name for the worksheet */
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	
		write_record(ba, 0x00A1 /* BrtBeginAFilter */, write_UncheckedRfX(safe_decode_range(ref)));
		/* *FILTERCOLUMN */
		/* [SORTSTATE] */
		/* BrtEndAFilter */
		write_record(ba, 0x00A2 /* BrtEndAFilter */);
	}
	
	function write_WSVIEWS2(ba, ws, Workbook) {
		write_record(ba, 0x0085 /* BrtBeginWsViews */);
		{ /* 1*WSVIEW2 */
			/* [ACUID] */
			write_record(ba, 0x0089 /* BrtBeginWsView */, write_BrtBeginWsView(ws, Workbook));
			/* [BrtPane] */
			/* *4BrtSel */
			/* *4SXSELECT */
			/* *FRT */
			write_record(ba, 0x008A /* BrtEndWsView */);
		}
		/* *FRT */
		write_record(ba, 0x0086 /* BrtEndWsViews */);
	}
	
	function write_WSFMTINFO() {
		/* [ACWSFMTINFO] */
		// write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
	}
	
	function write_SHEETPROTECT(ba, ws) {
		if(!ws['!protect']) return;
		/* [BrtSheetProtectionIso] */
		write_record(ba, 0x0217 /* BrtSheetProtection */, write_BrtSheetProtection(ws['!protect']));
	}
	
	function write_ws_bin(idx, opts, wb, rels) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
		var r = safe_decode_range(ws['!ref'] || "A1");
		if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
			r.e.c = Math.min(r.e.c, 0x3FFF);
			r.e.r = Math.min(r.e.c, 0xFFFFF);
		}
		ws['!links'] = [];
		/* passed back to write_zip and removed there */
		ws['!comments'] = [];
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		if(wb.vbaraw || ws['!outline']) write_record(ba, 0x0093 /* BrtWsProp */, write_BrtWsProp(c, ws['!outline']));
		write_record(ba, 0x0094 /* BrtWsDim */, write_BrtWsDim(r));
		write_WSVIEWS2(ba, ws, wb.Workbook);
		write_WSFMTINFO(ba, ws);
		write_COLINFOS(ba, ws, idx, opts, wb);
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		write_SHEETPROTECT(ba, ws);
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		write_AUTOFILTER(ba, ws, wb, idx);
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		write_MERGECELLS(ba, ws);
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		write_HLINKS(ba, ws, rels);
		/* [BrtPrintOptions] */
		if(ws['!margins']) write_record(ba, 0x01DC /* BrtMargins */, write_BrtMargins(ws['!margins']));
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		write_LEGACYDRAWING(ba, ws, idx, rels);
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	function parse_Cache(data) {
		var col = [];
		var num = data.match(/^<c:numCache>/);
		var f;
	
		/* 21.2.2.150 pt CT_NumVal */
		(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
			var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
			if(!q) return;
			col[+q[1]] = num ? +q[2] : q[2];
		});
	
		/* 21.2.2.71 formatCode CT_Xstring */
		var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);
	
		(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });
	
		return [col, nf, f];
	}
	
	/* 21.2 DrawingML - Charts */
	function parse_chart(data, name, opts, rels, wb, csheet) {
		var cs = ((csheet || {"!type":"chart"}));
		if(!data) return csheet;
		/* 21.2.2.27 chart CT_Chart */
	
		var C = 0, R = 0, col = "A";
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		/* 21.2.2.120 numCache CT_NumData */
		(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
			var cache = parse_Cache(nc);
			refguess.s.r = refguess.s.c = 0;
			refguess.e.c = C;
			col = encode_col(C);
			cache[0].forEach(function(n,i) {
				cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
				R = i;
			});
			if(refguess.e.r < R) refguess.e.r = R;
			++C;
		});
		if(C > 0) cs["!ref"] = encode_range(refguess);
		return cs;
	}
	/* 18.3 Worksheets also covers Chartsheets */
	function parse_cs_xml(data, opts, idx, rels, wb) {
		if(!data) return data;
		/* 18.3.1.12 chartsheet CT_ChartSheet */
		if(!rels) rels = {'!id':{}};
		var s = ({'!type':"chart", '!drawel':null, '!rel':""});
		var m;
	
		/* 18.3.1.83 sheetPr CT_ChartsheetPr */
		var sheetPr = data.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.36 drawing CT_Drawing */
		if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('chartsheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
		add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.331 BrtCsProp */
	function parse_BrtCsProp(data, length) {
		data.l += 10;
		var name = parse_XLWideString(data, length - 10);
		return { name: name };
	}
	
	/* [MS-XLSB] 2.1.7.7 Chart Sheet */
	function parse_cs_bin(data, opts, idx, rels, wb) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!drawel':null, '!rel':""};
		var state = [];
		var pass = false;
		recordhopper(data, function cs_parse(val, R, RT) {
			switch(RT) {
	
				case 0x0226: /* 'BrtDrawing' */
					s['!rel'] = val; break;
	
				case 0x028B: /* 'BrtCsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0232: /* 'BrtBkHim' */
				case 0x028C: /* 'BrtCsPageSetup' */
				case 0x029D: /* 'BrtCsProtection' */
				case 0x02A7: /* 'BrtCsProtectionIso' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x01DC: /* 'BrtMargins' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_bin() {
		var ba = buf_array();
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		/* [BrtCsProp] */
		/* CSVIEWS */
		/* [[BrtCsProtectionIso] BrtCsProtection] */
		/* [USERCSVIEWS] */
		/* [BrtMargins] */
		/* [BrtCsPageSetup] */
		/* [HEADERFOOTER] */
		/* BrtDrawing */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [WEBPUBITEMS] */
		/* FRTCHARTSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery',           false, "bool"],
		['autoCompressPictures',        true,  "bool"],
		['backupFile',                  false, "bool"],
		['checkCompatibility',          false, "bool"],
		['CodeName',                    ''],
		['date1904',                    false, "bool"],
		['defaultThemeVersion',         0,      "int"],
		['filterPrivacy',               false, "bool"],
		['hidePivotFieldList',          false, "bool"],
		['promptedSolutions',           false, "bool"],
		['publishItems',                false, "bool"],
		['refreshAllConnections',       false, "bool"],
		['saveExternalLinkValues',      true,  "bool"],
		['showBorderUnselectedTables',  true,  "bool"],
		['showInkAnnotation',           true,  "bool"],
		['showObjects',                 'all'],
		['showPivotChartFilter',        false, "bool"],
		['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab',                   0,      "int"],
		['autoFilterDateGrouping',      true,  "bool"],
		['firstSheet',                  0,      "int"],
		['minimized',                   false, "bool"],
		['showHorizontalScroll',        true,  "bool"],
		['showSheetTabs',               true,  "bool"],
		['showVerticalScroll',          true,  "bool"],
		['tabRatio',                    600,    "int"],
		['visibility',                  'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		//['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	/*var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];*/
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
				else switch(z[2]) {
				case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
				case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
				}
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
			else switch(z[2]) {
				case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
				case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
			}
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
	}
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		if(!wb.Workbook) return "false";
		if(!wb.Workbook.WBProps) return "false";
		return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
	}
	
	var badchars = "][*?\/\\".split("");
	function check_ws_name(n, safe) {
		if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
		var _good = true;
		badchars.forEach(function(c) {
			if(n.indexOf(c) == -1) return;
			if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
			_good = false;
		});
		return _good;
	}
	function check_wb_names(N, S, codes) {
		N.forEach(function(n,i) {
			check_ws_name(n);
			for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
			if(codes) {
				var cn = (S && S[i] && S[i].CodeName) || n;
				if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
			}
		});
	}
	function check_wb(wb) {
		if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
		if(!wb.SheetNames.length) throw new Error("Workbook is empty");
		var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
		check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
		for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
		/* TODO: validate workbook */
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		if(!data) throw new Error("Could not find file");
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
		var pass = false, xmlns = "xmlns";
		var dname = {}, dnstart = 0;
		data.replace(tagregex, function xml_wb(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': case '</fileVersion>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing':
					break;
				case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr':
				case '<workbookPr/>':
					WBPropsDef.forEach(function(w) {
						if(y[w[0]] == null) return;
						switch(w[2]) {
							case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
							case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
							default: wb.WBProps[w[0]] = y[w[0]];
						}
					});
					if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
					break;
				case '</workbookPr>': break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection':
					break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews': case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
				case '</workbookView>': break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet':
					switch(y.state) {
						case "hidden": y.Hidden = 1; break;
						case "veryHidden": y.Hidden = 2; break;
						default: y.Hidden = 0;
					}
					delete y.state;
					y.name = unescapexml(utf8read(y.name));
					delete y[0]; wb.Sheets.push(y); break;
				case '</sheet>': break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': {
					dname = {};
					dname.Name = utf8read(y.name);
					if(y.comment) dname.Comment = y.comment;
					if(y.localSheetId) dname.Sheet = +y.localSheetId;
					if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
					dnstart = idx + x.length;
				}	break;
				case '</definedName>': {
					dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
					wb.Names.push(dname);
				} break;
				case '<definedName/>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
				case '</calcPr>': break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22 smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent':
				case '<AlternateContent>': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				/* TODO */
				case '<revisionPtr': break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
			}
			return x;
		});
		if(XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	function write_wb_xml(wb) {
		var o = [XML_HEADER];
		o[o.length] = writextag('workbook', null, {
			'xmlns': XMLNS_main[0],
			//'xmlns:mx': XMLNS.mx,
			//'xmlns:s': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		});
	
		var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);
	
		/* fileVersion */
		/* fileSharing */
	
		var workbookPr = ({codeName:"ThisWorkbook"});
		if(wb.Workbook && wb.Workbook.WBProps) {
			WBPropsDef.forEach(function(x) {
	if((wb.Workbook.WBProps[x[0]]) == null) return;
				if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
				workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
			});
	if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
		}
		o[o.length] = (writextag('workbookPr', null, workbookPr));
	
		/* workbookProtection */
	
		var sheets = wb.Workbook && wb.Workbook.Sheets || [];
		var i = 0;
	
		/* bookViews only written if first worksheet is hidden */
		if(sheets && sheets[0] && !!sheets[0].Hidden) {
			o[o.length] = "<bookViews>";
			for(i = 0; i != wb.SheetNames.length; ++i) {
				if(!sheets[i]) break;
				if(!sheets[i].Hidden) break;
			}
			if(i == wb.SheetNames.length) i = 0;
			o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
			o[o.length] = "</bookViews>";
		}
	
		o[o.length] = "<sheets>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
			sht.sheetId = ""+(i+1);
			sht["r:id"] = "rId"+(i+1);
			if(sheets[i]) switch(sheets[i].Hidden) {
				case 1: sht.state = "hidden"; break;
				case 2: sht.state = "veryHidden"; break;
			}
			o[o.length] = (writextag('sheet',null,sht));
		}
		o[o.length] = "</sheets>";
	
		/* functionGroups */
		/* externalReferences */
	
		if(write_names) {
			o[o.length] = "<definedNames>";
			if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
				var d = {name:n.Name};
				if(n.Comment) d.comment = n.Comment;
				if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
				if(n.Hidden) d.hidden = "1";
				if(!n.Ref) return;
				o[o.length] = writextag('definedName', escapexml(n.Ref), d);
			});
			o[o.length] = "</definedNames>";
		}
	
		/* calcPr */
		/* oleSize */
		/* customWorkbookViews */
		/* pivotCaches */
		/* smartTagPr */
		/* smartTagTypes */
		/* webPublishing */
		/* fileRecoveryPr */
		/* webPublishObjects */
		/* extLst */
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.304 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.Hidden = data.read_shift(4); //hsState ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.Hidden);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.slice(0,31), o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.815 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		var o = ({});
		var flags = data.read_shift(4);
		o.defaultThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		if(strName.length > 0) o.CodeName = strName;
		o.autoCompressPictures = !!(flags & 0x10000);
		o.backupFile = !!(flags & 0x40);
		o.checkCompatibility = !!(flags & 0x1000);
		o.date1904 = !!(flags & 0x01);
		o.filterPrivacy = !!(flags & 0x08);
		o.hidePivotFieldList = !!(flags & 0x400);
		o.promptedSolutions = !!(flags & 0x10);
		o.publishItems = !!(flags & 0x800);
		o.refreshAllConnections = !!(flags & 0x40000);
		o.saveExternalLinkValues = !!(flags & 0x80);
		o.showBorderUnselectedTables = !!(flags & 0x04);
		o.showInkAnnotation = !!(flags & 0x20);
		o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
		o.showPivotChartFilter = !!(flags & 0x8000);
		o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
		return o;
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(72);
		var flags = 0;
		if(data) {
			/* TODO: mirror parse_BrtWbProp fields */
			if(data.filterPrivacy) flags |= 0x08;
		}
		o.write_shift(4, flags);
		o.write_shift(4, 0);
		write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
		return o.slice(0, o.l);
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.4.687 BrtName */
	function parse_BrtName(data, length, opts) {
		var end = data.l + length;
		data.l += 4; //var flags = data.read_shift(4);
		data.l += 1; //var chKey = data.read_shift(1);
		var itab = data.read_shift(4);
		var name = parse_XLNameWideString(data);
		var formula = parse_XLSBNameParsedFormula(data, 0, opts);
		var comment = parse_XLNullableWideString(data);
		//if(0 /* fProc */) {
			// unusedstring1: XLNullableWideString
			// description: XLNullableWideString
			// helpTopic: XLNullableWideString
			// unusedstring2: XLNullableWideString
		//}
		data.l = end;
		var out = ({Name:name, Ptg:formula});
		if(itab < 0xFFFFFFF) out.Sheet = itab;
		if(comment) out.Comment = comment;
		return out;
	}
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var state = [];
		var pass = false;
	
		if(!opts) opts = {};
		opts.biff = 12;
	
		var Names = [];
		var supbooks = ([[]]);
		supbooks.SheetNames = [];
		supbooks.XTI = [];
	
		XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };
	
		recordhopper(data, function hopper_wb(val, R, RT) {
			switch(RT) {
				case 0x009C: /* 'BrtBundleSh' */
					supbooks.SheetNames.push(val.name);
					wb.Sheets.push(val); break;
	
				case 0x0099: /* 'BrtWbProp' */
					wb.WBProps = val; break;
	
				case 0x0027: /* 'BrtName' */
					if(val.Sheet != null) opts.SID = val.Sheet;
					val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
					delete opts.SID;
					delete val.Ptg;
					Names.push(val);
					break;
				case 0x040C: /* 'BrtNameExt' */ break;
	
				case 0x0165: /* 'BrtSupSelf' */
				case 0x0166: /* 'BrtSupSame' */
				case 0x0163: /* 'BrtSupBookSrc' */
				case 0x029B: /* 'BrtSupAddin' */
					if(!supbooks[0].length) supbooks[0] = [RT, val];
					else supbooks.push([RT, val]);
					supbooks[supbooks.length - 1].XTI = [];
					break;
				case 0x016A: /* 'BrtExternSheet' */
					if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
					supbooks.XTI = supbooks.XTI.concat(val);
					break;
				case 0x0169: /* 'BrtPlaceholderName' */
					break;
	
				case 0x0817: /* 'BrtAbsPath15' */
				case 0x009E: /* 'BrtBookView' */
				case 0x008F: /* 'BrtBeginBundleShs' */
				case 0x0298: /* 'BrtBeginFnGroup' */
				case 0x0161: /* 'BrtBeginExternals' */
					break;
	
				/* case 'BrtModelTimeGroupingCalcCol' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0C01: /* 'BrtRevisionPtr' */
				case 0x0216: /* 'BrtBookProtection' */
				case 0x02A5: /* 'BrtBookProtectionIso' */
				case 0x009D: /* 'BrtCalcProp' */
				case 0x0262: /* 'BrtCrashRecErr' */
				case 0x0802: /* 'BrtDecoupledPivotCacheID' */
				case 0x009B: /* 'BrtFileRecover' */
				case 0x0224: /* 'BrtFileSharing' */
				case 0x02A4: /* 'BrtFileSharingIso' */
				case 0x0080: /* 'BrtFileVersion' */
				case 0x0299: /* 'BrtFnGroup' */
				case 0x0850: /* 'BrtModelRelationship' */
				case 0x084D: /* 'BrtModelTable' */
				case 0x0225: /* 'BrtOleSize' */
				case 0x0805: /* 'BrtPivotTableRef' */
				case 0x0254: /* 'BrtSmartTagType' */
				case 0x081C: /* 'BrtTableSlicerCacheID' */
				case 0x081B: /* 'BrtTableSlicerCacheIDs' */
				case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
				case 0x018D: /* 'BrtUserBookView' */
				case 0x009A: /* 'BrtWbFactoid' */
				case 0x045D: /* 'BrtWbProp14' */
				case 0x0229: /* 'BrtWebOpt' */
				case 0x082B: /* 'BrtWorkBookPr15' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					state.push(RT); pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					state.pop(); pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				case 0x0010: /* 'BrtFRTArchID$' */ break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */ && state[state.length-1] != 0x0023 /* BrtFRTBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		parse_wb_defaults(wb);
	
		// $FlowIgnore
		wb.Names = Names;
	
		(wb).supbooks = supbooks;
		return wb;
	}
	
	function write_BUNDLESHS(ba, wb) {
		write_record(ba, 0x008F /* BrtBeginBundleShs */);
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
			var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, 0x009C /* BrtBundleSh */, write_BrtBundleSh(d));
		}
		write_record(ba, 0x0090 /* BrtEndBundleShs */);
	}
	
	/* [MS-XLSB] 2.4.649 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.301 BrtBookView */
	function write_BrtBookView(idx, o) {
		if(!o) o = new_buf(29);
		o.write_shift(-4, 0);
		o.write_shift(-4, 460);
		o.write_shift(4,  28800);
		o.write_shift(4,  17600);
		o.write_shift(4,  500);
		o.write_shift(4,  idx);
		o.write_shift(4,  idx);
		var flags = 0x78;
		o.write_shift(1,  flags);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	function write_BOOKVIEWS(ba, wb) {
		/* required if hidden tab appears before visible tab */
		if(!wb.Workbook || !wb.Workbook.Sheets) return;
		var sheets = wb.Workbook.Sheets;
		var i = 0, vistab = -1, hidden = -1;
		for(; i < sheets.length; ++i) {
			if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
			else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
		}
		if(hidden > vistab) return;
		write_record(ba, 0x0087 /* BrtBeginBookViews */);
		write_record(ba, 0x009E /* BrtBookView */, write_BrtBookView(vistab));
		/* 1*(BrtBookView *FRT) */
		write_record(ba, 0x0088 /* BrtEndBookViews */);
	}
	
	/* [MS-XLSB] 2.4.305 BrtCalcProp */
	/*function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); // force recalc
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}*/
	
	/* [MS-XLSB] 2.4.646 BrtFileRecover */
	/*function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}*/
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0083 /* BrtBeginBook */);
		write_record(ba, 0x0080 /* BrtFileVersion */, write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, 0x0099 /* BrtWbProp */, write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		/* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		/* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, 0x0084 /* BrtEndBook */);
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
		return parse_wb_xml((data), opts);
	}
	
	function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_sty(data, name, themes, opts) {
		if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
		return parse_sty_xml((data), themes, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
		return parse_sst_xml((data), opts);
	}
	
	function parse_cmnt(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
		return parse_comments_xml((data), opts);
	}
	
	function parse_cc(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
		return parse_cc_xml((data), name, opts);
	}
	
	function parse_xlink(data, rel, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlink_bin((data), rel, name, opts);
		return parse_xlink_xml((data), rel, name, opts);
	}
	
	function parse_xlmeta(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlmeta_bin((data), name, opts);
		return parse_xlmeta_xml((data), name, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
	}
	
	// eslint-disable-next-line no-unused-vars
	function write_cs(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
	}
	
	function write_sty(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	
	function write_cmnt(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	/*
	function write_cc(data, name:string, opts) {
		return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	
	function write_xlmeta(name) {
		return (name.slice(-4)===".bin" ? write_xlmeta_bin : write_xlmeta_xml)();
	}
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = ([]); if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	
	// ----
	
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap;
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF_general(value);
		return SSF_format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, key, cp, val) {
		var oval = val;
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": oval = parsexmlbool(val); break;
			case "i2": case "int": oval = parseInt(val, 10); break;
			case "r4": case "float": oval = parseFloat(val); break;
			case "date": case "dateTime.tz": oval = parseDate(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw new Error("bad custprop:" + cp[0]);
		}
		Custprops[unescapexml(key)] = oval;
	}
	
	function safe_format_xlml(cell, nf, o) {
		if(cell.t === 'z') return;
		if(!o || o.cellText !== false) try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = cell.v.toString(10);
					else cell.w = SSF_general_num(cell.v);
				}
				else cell.w = SSF_general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
		} catch(e) { if(o.WTF) throw e; }
		try {
			var z = XLMLFormatMap[nf]||nf||"General";
			if(o.cellNF) cell.z = z;
			if(o.cellDates && cell.t == 'n' && fmt_is_date(z)) {
				var _d = SSF_parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
			}
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		var i = 0;
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
				break;
			case 'DateTime':
				if(xml.slice(-1) != "Z") xml += "Z";
				cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
			default:
				if(xml == "" && ss == "") { cell.t = 'z'; }
				else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
				break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula !== false) {
			if(cell.Formula) {
				var fstr = unescapexml(cell.Formula);
				/* strictly speaking, the leading = is required but some writers omit */
				if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
				cell.f = rc_to_a1(fstr, base);
				delete cell.Formula;
				if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
				else if(cell.ArrayRange) {
					cell.F = rc_to_a1(cell.ArrayRange, base);
					arrayf.push([safe_decode_range(cell.F), cell.F]);
				}
			} else {
				for(i = 0; i < arrayf.length; ++i)
					if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
						if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
							cell.F = arrayf[i][1];
			}
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v || "";
		comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	/* TODO: Everything */
	function parse_xlml_xml(d, _opts) {
		var opts = _opts || {};
		make_ssf();
		var str = debom(xlml_normalize(d));
		if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
			if(typeof $cptable !== 'undefined') str = $cptable.utils.decode(65001, char_codes(str));
			else str = utf8read(str);
		}
		var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
		opening = opening.replace(/".*?"/g, "");
		if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
		if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
		if(ishtml) return html_to_workbook(str, opts);
	
		XLMLFormatMap = ({
			"General Number": "General",
			"General Date": table_fmt[22],
			"Long Date": "dddd, mmmm dd, yyyy",
			"Medium Date": table_fmt[15],
			"Short Date": table_fmt[14],
			"Long Time": table_fmt[19],
			"Medium Time": table_fmt[18],
			"Short Time": table_fmt[20],
			"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
			"Fixed": table_fmt[2],
			"Standard": table_fmt[4],
			"Percent": table_fmt[10],
			"Scientific": table_fmt[11],
			"Yes/No": '"Yes";"Yes";"No";@',
			"True/False": '"True";"True";"False";@',
			"On/Off": '"Yes";"Yes";"No";@'
		});
	
	
		var Rn;
		var state = [], tmp;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
		var cell = ({}), row = {};// eslint-disable-line no-unused-vars
		var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
		var c = 0, r = 0;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var merges = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = [];
		var comments = [], comment = ({});
		var cstys = [], csty, seencol = false;
		var arrayf = [];
		var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
		var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"");
		var raw_Rn3 = "";
		while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
			case 'data' /*case 'Data'*/:
				if(raw_Rn3 == "data") {
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
				}
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'cell' /*case 'Cell'*/:
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
						if(opts.dense) {
							if(!cursheet[r]) cursheet[r] = [];
							cursheet[r][c] = cell;
						} else cursheet[encode_col(c) + encode_row(r)] = cell;
					}
					if(cell.HRef) {
						cell.l = ({Target:unescapexml(cell.HRef)});
						if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
						delete cell.HRef; delete cell.HRefScreenTip;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						cc = c + (parseInt(cell.MergeAcross,10)|0);
						rr = r + (parseInt(cell.MergeDown,10)|0);
						merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
					else if(cell.MergeAcross || cell.MergeDown) {
	for(var cma = c; cma <= cc; ++cma) {
							for(var cmd = r; cmd <= rr; ++cmd) {
								if(cma > c || cmd > r) {
									if(opts.dense) {
										if(!cursheet[cmd]) cursheet[cmd] = [];
										cursheet[cmd][cma] = {t:'z'};
									} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
								}
							}
						}
						c = cc + 1;
					}
					else ++c;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].slice(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'row' /*case 'Row'*/:
				if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].slice(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
					rowobj = {};
					if(row.AutoFitHeight == "0" || row.Height) {
						rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
						rowinfo[r] = rowobj;
					}
					if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
				}
				break;
			case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
						cursheet["!ref"] = encode_range(refguess);
						if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
							cursheet["!fullref"] = cursheet["!ref"];
							refguess.e.r = opts.sheetRows - 1;
							cursheet["!ref"] = encode_range(refguess);
						}
					}
					if(merges.length) cursheet["!merges"] = merges;
					if(cstys.length > 0) cursheet["!cols"] = cstys;
					if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = unescapexml(tmp.Name);
					cursheet = (opts.dense ? [] : {});
					merges = [];
					arrayf = [];
					rowinfo = [];
					wsprops = {name:sheetname, Hidden:0};
					Workbook.Sheets.push(wsprops);
				}
				break;
			case 'table' /*case 'Table'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					state.push([Rn[3], false]);
					cstys = []; seencol = false;
				}
				break;
	
			case 'style' /*case 'Style'*/:
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'numberformat' /*case 'NumberFormat'*/:
				stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
				if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
				for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == stag.nf) break;
				if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == null) { SSF_load(stag.nf, ssfidx); break; }
				break;
	
			case 'column' /*case 'Column'*/:
				if(state[state.length-1][0] !== /*'Table'*/'table') break;
				csty = xlml_parsexmltag(Rn[0]);
				if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
				if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
				if(!seencol && csty.wpx > 10) {
					seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
					for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
				}
				if(seencol) process_col(csty);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
				break;
	
			case 'namedrange' /*case 'NamedRange'*/:
				if(Rn[1]==='/') break;
				if(!Workbook.Names) Workbook.Names = [];
				var _NamedRange = parsexmltag(Rn[0]);
				var _DefinedName = ({
					Name: _NamedRange.Name,
					Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
				});
				if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
	Workbook.Names.push(_DefinedName);
				break;
	
			case 'namedcell' /*case 'NamedCell'*/: break;
			case 'b' /*case 'B'*/: break;
			case 'i' /*case 'I'*/: break;
			case 'u' /*case 'U'*/: break;
			case 's' /*case 'S'*/: break;
			case 'em' /*case 'EM'*/: break;
			case 'h2' /*case 'H2'*/: break;
			case 'h3' /*case 'H3'*/: break;
			case 'sub' /*case 'Sub'*/: break;
			case 'sup' /*case 'Sup'*/: break;
			case 'span' /*case 'Span'*/: break;
			case 'alignment' /*case 'Alignment'*/:
				break;
			case 'borders' /*case 'Borders'*/: break;
			case 'border' /*case 'Border'*/: break;
			case 'font' /*case 'Font'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'interior' /*case 'Interior'*/:
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'protection' /*case 'Protection'*/: break;
	
			case 'author' /*case 'Author'*/:
			case 'title' /*case 'Title'*/:
			case 'description' /*case 'Description'*/:
			case 'created' /*case 'Created'*/:
			case 'keywords' /*case 'Keywords'*/:
			case 'subject' /*case 'Subject'*/:
			case 'category' /*case 'Category'*/:
			case 'company' /*case 'Company'*/:
			case 'lastauthor' /*case 'LastAuthor'*/:
			case 'lastsaved' /*case 'LastSaved'*/:
			case 'lastprinted' /*case 'LastPrinted'*/:
			case 'version' /*case 'Version'*/:
			case 'revision' /*case 'Revision'*/:
			case 'totaltime' /*case 'TotalTime'*/:
			case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
			case 'manager' /*case 'Manager'*/:
			case 'contentstatus' /*case 'ContentStatus'*/:
			case 'identifier' /*case 'Identifier'*/:
			case 'language' /*case 'Language'*/:
			case 'appname' /*case 'AppName'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'paragraphs' /*case 'Paragraphs'*/: break;
	
			case 'styles' /*case 'Styles'*/:
			case 'workbook' /*case 'Workbook'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else state.push([Rn[3], false]);
				break;
	
			case 'comment' /*case 'Comment'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = ({a:tmp.Author});
				}
				break;
	
			case 'autofilter' /*case 'AutoFilter'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					var AutoFilter = xlml_parsexmltag(Rn[0]);
					cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
					state.push([Rn[3], true]);
				}
				break;
	
			case 'name' /*case 'Name'*/: break;
	
			case 'datavalidation' /*case 'DataValidation'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				} else {
					if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				}
				break;
	
			case 'pixelsperinch' /*case 'PixelsPerInch'*/:
				break;
			case 'componentoptions' /*case 'ComponentOptions'*/:
			case 'documentproperties' /*case 'DocumentProperties'*/:
			case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
			case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
			case 'pivottable' /*case 'PivotTable'*/:
			case 'pivotcache' /*case 'PivotCache'*/:
			case 'names' /*case 'Names'*/:
			case 'mapinfo' /*case 'MapInfo'*/:
			case 'pagebreaks' /*case 'PageBreaks'*/:
			case 'querytable' /*case 'QueryTable'*/:
			case 'sorting' /*case 'Sorting'*/:
			case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
			case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
			case 'smarttagtype' /*case 'SmartTagType'*/:
			case 'smarttags' /*case 'SmartTags'*/:
			case 'excelworkbook' /*case 'ExcelWorkbook'*/:
			case 'workbookoptions' /*case 'WorkbookOptions'*/:
			case 'worksheetoptions' /*case 'WorksheetOptions'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			case 'null' /*case 'Null'*/: break;
	
			default:
				/* FODS file root is <office:document> */
				if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
				/* UOS file root is <uof:UOF> */
				if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);
	
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
						case 'allowpng' /*case 'AllowPNG'*/: break;
						case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
						case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
						case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
						case 'colors' /*case 'Colors'*/: break;
						case 'color' /*case 'Color'*/: break;
						case 'index' /*case 'Index'*/: break;
						case 'rgb' /*case 'RGB'*/: break;
						case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
						case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
						case 'toolbar' /*case 'Toolbar'*/: break;
						case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
						case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
						case 'label' /*case 'Label'*/: break;
						case 'caption' /*case 'Caption'*/: break;
						case 'maxheight' /*case 'MaxHeight'*/: break;
						case 'maxwidth' /*case 'MaxWidth'*/: break;
						case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
						case 'date1904' /*case 'Date1904'*/:
	Workbook.WBProps.date1904 = true;
							break;
						case 'windowheight' /*case 'WindowHeight'*/: break;
						case 'windowwidth' /*case 'WindowWidth'*/: break;
						case 'windowtopx' /*case 'WindowTopX'*/: break;
						case 'windowtopy' /*case 'WindowTopY'*/: break;
						case 'tabratio' /*case 'TabRatio'*/: break;
						case 'protectstructure' /*case 'ProtectStructure'*/: break;
						case 'protectwindow' /*case 'ProtectWindow'*/: break;
						case 'protectwindows' /*case 'ProtectWindows'*/: break;
						case 'activesheet' /*case 'ActiveSheet'*/: break;
						case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
						case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
						case 'supbook' /*case 'SupBook'*/: break;
						case 'sheetname' /*case 'SheetName'*/: break;
						case 'sheetindex' /*case 'SheetIndex'*/: break;
						case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
						case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
						case 'dll' /*case 'Dll'*/: break;
						case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
						case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
						case 'iteration' /*case 'Iteration'*/: break;
						case 'maxiterations' /*case 'MaxIterations'*/: break;
						case 'maxchange' /*case 'MaxChange'*/: break;
						case 'path' /*case 'Path'*/: break;
						case 'xct' /*case 'Xct'*/: break;
						case 'count' /*case 'Count'*/: break;
						case 'selectedsheets' /*case 'SelectedSheets'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						case 'uncalced' /*case 'Uncalced'*/: break;
						case 'startupprompt' /*case 'StartupPrompt'*/: break;
						case 'crn' /*case 'Crn'*/: break;
						case 'externname' /*case 'ExternName'*/: break;
						case 'formula' /*case 'Formula'*/: break;
						case 'colfirst' /*case 'ColFirst'*/: break;
						case 'collast' /*case 'ColLast'*/: break;
						case 'wantadvise' /*case 'WantAdvise'*/: break;
						case 'boolean' /*case 'Boolean'*/: break;
						case 'error' /*case 'Error'*/: break;
						case 'text' /*case 'Text'*/: break;
						case 'ole' /*case 'OLE'*/: break;
						case 'noautorecover' /*case 'NoAutoRecover'*/: break;
						case 'publishobjects' /*case 'PublishObjects'*/: break;
						case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
						case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
						case 'owcversion' /*case 'OWCVersion'*/: break;
						case 'height' /*case 'Height'*/: break;
						case 'width' /*case 'Width'*/: break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
						case 'visible' /*case 'Visible'*/:
							if(Rn[0].slice(-2) === "/>"){/* empty */}
							else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
								case "SheetHidden": wsprops.Hidden = 1; break;
								case "SheetVeryHidden": wsprops.Hidden = 2; break;
							}
							else pidx = Rn.index + Rn[0].length;
							break;
						case 'header' /*case 'Header'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
							break;
						case 'footer' /*case 'Footer'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
							break;
						case 'pagemargins' /*case 'PageMargins'*/:
							var pagemargins = parsexmltag(Rn[0]);
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
							if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
							if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
							if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
							if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
							break;
						case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
							if(!Workbook.Views) Workbook.Views = [];
							if(!Workbook.Views[0]) Workbook.Views[0] = {};
							Workbook.Views[0].RTL = true;
							break;
	
						case 'freezepanes' /*case 'FreezePanes'*/: break;
						case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;
	
						case 'splithorizontal' /*case 'SplitHorizontal'*/:
						case 'splitvertical' /*case 'SplitVertical'*/:
							break;
	
						case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
							break;
	
						case 'activerow' /*case 'ActiveRow'*/: break;
						case 'activecol' /*case 'ActiveCol'*/: break;
						case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
						case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;
	
						case 'unsynced' /*case 'Unsynced'*/: break;
						case 'print' /*case 'Print'*/: break;
						case 'printerrors' /*case 'PrintErrors'*/: break;
						case 'panes' /*case 'Panes'*/: break;
						case 'scale' /*case 'Scale'*/: break;
						case 'pane' /*case 'Pane'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'layout' /*case 'Layout'*/: break;
						case 'pagesetup' /*case 'PageSetup'*/: break;
						case 'selected' /*case 'Selected'*/: break;
						case 'protectobjects' /*case 'ProtectObjects'*/: break;
						case 'enableselection' /*case 'EnableSelection'*/: break;
						case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
						case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
						case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
						case 'verticalresolution' /*case 'VerticalResolution'*/: break;
						case 'numberofcopies' /*case 'NumberofCopies'*/: break;
						case 'activepane' /*case 'ActivePane'*/: break;
						case 'toprowvisible' /*case 'TopRowVisible'*/: break;
						case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
						case 'fittopage' /*case 'FitToPage'*/: break;
						case 'rangeselection' /*case 'RangeSelection'*/: break;
						case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
						case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
						case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'fitwidth' /*case 'FitWidth'*/: break;
						case 'fitheight' /*case 'FitHeight'*/: break;
						case 'commentslayout' /*case 'CommentsLayout'*/: break;
						case 'zoom' /*case 'Zoom'*/: break;
						case 'lefttoright' /*case 'LeftToRight'*/: break;
						case 'gridlines' /*case 'Gridlines'*/: break;
						case 'allowsort' /*case 'AllowSort'*/: break;
						case 'allowfilter' /*case 'AllowFilter'*/: break;
						case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
						case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
						case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
						case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
						case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
						case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
						case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
						case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
						case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].above = true;
							break;
						case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
						case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
						case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
						case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].left = true;
							break;
						case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
						case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
						case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
						case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
						case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
						case 'noorientation' /*case 'NoOrientation'*/: break;
						case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
						case 'zeroheight' /*case 'ZeroHeight'*/: break;
						case 'viewablerange' /*case 'ViewableRange'*/: break;
						case 'selection' /*case 'Selection'*/: break;
						case 'protectcontents' /*case 'ProtectContents'*/: break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
						case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
						case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
						case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
						case 'location' /*case 'Location'*/: break;
						case 'pivotfield' /*case 'PivotField'*/: break;
						case 'orientation' /*case 'Orientation'*/: break;
						case 'layoutform' /*case 'LayoutForm'*/: break;
						case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
						case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
						case 'position' /*case 'Position'*/: break;
						case 'pivotitem' /*case 'PivotItem'*/: break;
						case 'datatype' /*case 'DataType'*/: break;
						case 'datafield' /*case 'DataField'*/: break;
						case 'sourcename' /*case 'SourceName'*/: break;
						case 'parentfield' /*case 'ParentField'*/: break;
						case 'ptlineitems' /*case 'PTLineItems'*/: break;
						case 'ptlineitem' /*case 'PTLineItem'*/: break;
						case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
						case 'item' /*case 'Item'*/: break;
						case 'itemtype' /*case 'ItemType'*/: break;
						case 'ptsource' /*case 'PTSource'*/: break;
						case 'cacheindex' /*case 'CacheIndex'*/: break;
						case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
						case 'filename' /*case 'FileName'*/: break;
						case 'reference' /*case 'Reference'*/: break;
						case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
						case 'norowgrand' /*case 'NoRowGrand'*/: break;
						case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
						case 'hidden' /*case 'Hidden'*/: break;
						case 'subtotal' /*case 'Subtotal'*/: break;
						case 'basefield' /*case 'BaseField'*/: break;
						case 'mapchilditems' /*case 'MapChildItems'*/: break;
						case 'function' /*case 'Function'*/: break;
						case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
						case 'printsettitles' /*case 'PrintSetTitles'*/: break;
						case 'mergelabels' /*case 'MergeLabels'*/: break;
						case 'defaultversion' /*case 'DefaultVersion'*/: break;
						case 'refreshname' /*case 'RefreshName'*/: break;
						case 'refreshdate' /*case 'RefreshDate'*/: break;
						case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
						case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
						case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
						case 'colbreaks' /*case 'ColBreaks'*/: break;
						case 'colbreak' /*case 'ColBreak'*/: break;
						case 'rowbreaks' /*case 'RowBreaks'*/: break;
						case 'rowbreak' /*case 'RowBreak'*/: break;
						case 'colstart' /*case 'ColStart'*/: break;
						case 'colend' /*case 'ColEnd'*/: break;
						case 'rowend' /*case 'RowEnd'*/: break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
						case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
						case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
						case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
						case 'autofilteror' /*case 'AutoFilterOr'*/: break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
						case 'id' /*case 'Id'*/: break;
						case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
						case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
						case 'querysource' /*case 'QuerySource'*/: break;
						case 'querytype' /*case 'QueryType'*/: break;
						case 'enableredirections' /*case 'EnableRedirections'*/: break;
						case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
						case 'urlstring' /*case 'URLString'*/: break;
						case 'htmltables' /*case 'HTMLTables'*/: break;
						case 'connection' /*case 'Connection'*/: break;
						case 'commandtext' /*case 'CommandText'*/: break;
						case 'refreshinfo' /*case 'RefreshInfo'*/: break;
						case 'notitles' /*case 'NoTitles'*/: break;
						case 'nextid' /*case 'NextId'*/: break;
						case 'columninfo' /*case 'ColumnInfo'*/: break;
						case 'overwritecells' /*case 'OverwriteCells'*/: break;
						case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
						case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
						case 'source' /*case 'Source'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'decimal' /*case 'Decimal'*/: break;
						case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
						case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
						case 'formatsettings' /*case 'FormatSettings'*/: break;
						case 'fieldtype' /*case 'FieldType'*/: break;
						case 'delimiters' /*case 'Delimiters'*/: break;
						case 'tab' /*case 'Tab'*/: break;
						case 'comma' /*case 'Comma'*/: break;
						case 'autoformatname' /*case 'AutoFormatName'*/: break;
						case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						default: seen = false;
					} break;
	
					case 'datavalidation' /*case 'DataValidation'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
	
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
	
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						default: seen = false;
					} break;
	
					case 'sorting' /*case 'Sorting'*/:
					case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
						case 'map' /*case 'Map'*/: break;
						case 'entry' /*case 'Entry'*/: break;
						case 'range' /*case 'Range'*/: break;
						case 'xpath' /*case 'XPath'*/: break;
						case 'field' /*case 'Field'*/: break;
						case 'xsdtype' /*case 'XSDType'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'aggregate' /*case 'Aggregate'*/: break;
						case 'elementtype' /*case 'ElementType'*/: break;
						case 'attributetype' /*case 'AttributeType'*/: break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema' /*case 'schema'*/:
						case 'element' /*case 'element'*/:
						case 'complextype' /*case 'complexType'*/:
						case 'datatype' /*case 'datatype'*/:
						case 'all' /*case 'all'*/:
						case 'attribute' /*case 'attribute'*/:
						case 'extends' /*case 'extends'*/: break;
	
						case 'row' /*case 'row'*/: break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'smarttags' /*case 'SmartTags'*/: break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(Rn[3].match(/!\[CDATA/)) break;
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = ({});
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.Workbook = Workbook;
		out.SSF = dup(table_fmt);
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64_decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(a2s(data), opts);
		}
	}
	
	/* TODO */
	function write_props_xlml(wb, opts) {
		var o = [];
		/* DocumentProperties */
		if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
		/* CustomDocumentProperties */
		if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
		return o.join("");
	}
	/* TODO */
	function write_wb_xlml() {
		/* OfficeDocumentSettings */
		/* ExcelWorkbook */
		return "";
	}
	/* TODO */
	function write_sty_xlml(wb, opts) {
		/* Styles */
		var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
		opts.cellXfs.forEach(function(xf, id) {
			var payload = [];
			payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(table_fmt[xf.numFmtId])}));
	
			var o = {"ss:ID": "s" + (21+id)};
			styles.push(writextag('Style', payload.join(""), o));
		});
		return writextag("Styles", styles.join(""));
	}
	function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
	function write_names_xlml(wb) {
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != null) continue;
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return writextag("Names", out.join(""));
	}
	function write_ws_xlml_names(ws, opts, idx, wb) {
		if(!ws) return "";
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != idx) continue;
			/*switch(n.Name) {
				case "_": continue;
			}*/
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return out.join("");
	}
	/* WorksheetOptions */
	function write_ws_xlml_wsopts(ws, opts, idx, wb) {
		if(!ws) return "";
		var o = [];
		/* NOTE: spec technically allows any order, but stick with implied order */
	
		/* FitToPage */
		/* DoNotDisplayColHeaders */
		/* DoNotDisplayRowHeaders */
		/* ViewableRange */
		/* Selection */
		/* GridlineColor */
		/* Name */
		/* ExcelWorksheetType */
		/* IntlMacro */
		/* Unsynced */
		/* Selected */
		/* CodeName */
	
		if(ws['!margins']) {
			o.push("<PageSetup>");
			if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
			if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
			o.push(writextag("PageMargins", null, {
				'x:Bottom': ws['!margins'].bottom || "0.75",
				'x:Left': ws['!margins'].left || "0.7",
				'x:Right': ws['!margins'].right || "0.7",
				'x:Top': ws['!margins'].top || "0.75"
			}));
			o.push("</PageSetup>");
		}
	
		/* PageSetup */
		/* DisplayPageBreak */
		/* TransitionExpressionEvaluation */
		/* TransitionFormulaEntry */
		/* Print */
		/* Zoom */
		/* PageLayoutZoom */
		/* PageBreakZoom */
		/* ShowPageBreakZoom */
		/* DefaultRowHeight */
		/* DefaultColumnWidth */
		/* StandardWidth */
	
		if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
			/* Visible */
			if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
			else {
				/* Selected */
				for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
				if(i == idx) o.push("<Selected/>");
			}
		}
	
		/* LeftColumnVisible */
	
		if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");
	
		/* GridlineColorIndex */
		/* DisplayFormulas */
		/* DoNotDisplayGridlines */
		/* DoNotDisplayHeadings */
		/* DoNotDisplayOutline */
		/* ApplyAutomaticOutlineStyles */
		/* NoSummaryRowsBelowDetail */
		/* NoSummaryColumnsRightDetail */
		/* DoNotDisplayZeros */
		/* ActiveRow */
		/* ActiveColumn */
		/* FilterOn */
		/* RangeSelection */
		/* TopRowVisible */
		/* TopRowBottomPane */
		/* LeftColumnRightPane */
		/* ActivePane */
		/* SplitHorizontal */
		/* SplitVertical */
		/* FreezePanes */
		/* FrozenNoSplit */
		/* TabColorIndex */
		/* Panes */
	
		/* NOTE: Password not supported in XLML Format */
		if(ws['!protect']) {
			o.push(writetag("ProtectContents", "True"));
			if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
			if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
			if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
			else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
		[
			[ "formatCells", "AllowFormatCells" ],
			[ "formatColumns", "AllowSizeCols" ],
			[ "formatRows", "AllowSizeRows" ],
			[ "insertColumns", "AllowInsertCols" ],
			[ "insertRows", "AllowInsertRows" ],
			[ "insertHyperlinks", "AllowInsertHyperlinks" ],
			[ "deleteColumns", "AllowDeleteCols" ],
			[ "deleteRows", "AllowDeleteRows" ],
			[ "sort", "AllowSort" ],
			[ "autoFilter", "AllowFilter" ],
			[ "pivotTables", "AllowUsePivotTables" ]
		].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
		}
	
		if(o.length == 0) return "";
		return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
	}
	function write_ws_xlml_comment(comments) {
		return comments.map(function(c) {
			// TODO: formatted text
			var t = xlml_unfixstr(c.t||"");
			var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
			return writextag("Comment", d, {"ss:Author":c.a});
		}).join("");
	}
	function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
		if(!cell || (cell.v == undefined && cell.f == undefined)) return "";
	
		var attr = {};
		if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
		if(cell.F && cell.F.slice(0, ref.length) == ref) {
			var end = decode_cell(cell.F.slice(ref.length + 1));
			attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
		}
	
		if(cell.l && cell.l.Target) {
			attr["ss:HRef"] = escapexml(cell.l.Target);
			if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
		}
	
		if(ws['!merges']) {
			var marr = ws['!merges'];
			for(var mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
				if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
				if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
			}
		}
	
		var t = "", p = "";
		switch(cell.t) {
			case 'z': if(!opts.sheetStubs) return ""; break;
			case 'n': t = 'Number'; p = String(cell.v); break;
			case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
			case 'e': t = 'Error'; p = BErr[cell.v]; break;
			case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || table_fmt[14]; break;
			case 's': t = 'String'; p = escapexlml(cell.v||""); break;
		}
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		attr["ss:StyleID"] = "s" + (21+os);
		attr["ss:Index"] = addr.c + 1;
		var _v = (cell.v != null ? p : "");
		var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');
	
		if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);
	
		return writextag("Cell", m, attr);
	}
	function write_ws_xlml_row(R, row) {
		var o = '<Row ss:Index="' + (R+1) + '"';
		if(row) {
			if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
			if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
			if(row.hidden) o += ' ss:Hidden="1"';
		}
		return o + '>';
	}
	/* TODO */
	function write_ws_xlml_table(ws, opts, idx, wb) {
		if(!ws['!ref']) return "";
		var range = safe_decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var o = [];
		if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
			process_col(n);
			var w = !!n.width;
			var p = col_obj_w(i, n);
			var k = {"ss:Index":i+1};
			if(w) k['ss:Width'] = width2px(p.width);
			if(n.hidden) k['ss:Hidden']="1";
			o.push(writextag("Column",null,k));
		});
		var dense = Array.isArray(ws);
		for(var R = range.s.r; R <= range.e.r; ++R) {
			var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
			for(var C = range.s.c; C <= range.e.c; ++C) {
				var skip = false;
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					break;
				}
				if(skip) continue;
				var addr = {r:R,c:C};
				var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
				row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
			}
			row.push("</Row>");
			if(row.length > 2) o.push(row.join(""));
		}
		return o.join("");
	}
	function write_ws_xlml(idx, opts, wb) {
		var o = [];
		var s = wb.SheetNames[idx];
		var ws = wb.Sheets[s];
	
		var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Names>" + t + "</Names>");
	
		/* Table */
		t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Table>" + t + "</Table>");
	
		/* WorksheetOptions */
		o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
	
		return o.join("");
	}
	function write_xlml(wb, opts) {
		if(!opts) opts = {};
		if(!wb.SSF) wb.SSF = dup(table_fmt);
		if(wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
			opts.cellXfs = [];
			get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
		}
		var d = [];
		d.push(write_props_xlml(wb, opts));
		d.push(write_wb_xlml(wb, opts));
		d.push("");
		d.push("");
		for(var i = 0; i < wb.SheetNames.length; ++i)
			d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
		d[2] = write_sty_xlml(wb, opts);
		d[3] = write_names_xlml(wb, opts);
		return XML_HEADER + writextag("Workbook", d.join(""), {
			'xmlns':      XLMLNS.ss,
			'xmlns:o':    XLMLNS.o,
			'xmlns:x':    XLMLNS.x,
			'xmlns:ss':   XLMLNS.ss,
			'xmlns:dt':   XLMLNS.dt,
			'xmlns:html': XLMLNS.html
		});
	}
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		o.l = 28;
	
		v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
		v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
	
		if(o.length - o.l <= 4) return v;
	
		var m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");
	
		if(o.length - o.l <= 4) return v;
		m = o.read_shift(4);
		if(m !== 0x71b239f4) return v;
		v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
	
		m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
	}
	
	/*
		Continue logic for:
		- 2.4.58 Continue          0x003c
		- 2.4.59 ContinueBigName   0x043c
		- 2.4.60 ContinueFrt       0x0812
		- 2.4.61 ContinueFrt11     0x0875
		- 2.4.62 ContinueFrt12     0x087f
	*/
	var CONTINUE_RT = [ 0x003c, 0x043c, 0x0812, 0x0875, 0x087f ];
	function slurp(RecordType, R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType) {
		case 0x0009: case 0x0209: case 0x0409: case 0x0809/* BOF */: case 0x002f /* FilePass */: case 0x0195 /* FileLock */: case 0x00e1 /* InterfaceHdr */: case 0x0196 /* RRDInfo */: case 0x0138 /* RRDHead */: case 0x0194 /* UsrExcl */: case 0x000a /* EOF */:
			break;
		case 0x0085 /* BoundSheet8 */:
			break;
		default:
			opts.enc.insitu(d);
		}
		bufs.push(d);
		blob.l += l;
		var nextrt = __readUInt16LE(blob,blob.l), next = XLSRecordEnum[nextrt];
		var start = 0;
		while(next != null && CONTINUE_RT.indexOf(nextrt) > -1) {
			l = __readUInt16LE(blob,blob.l+2);
			start = blob.l + 4;
			if(nextrt == 0x0812 /* ContinueFrt */) start += 4;
			else if(nextrt == 0x0875 || nextrt == 0x087f) {
				start += 12;
			}
			d = blob.slice(start,blob.l+4+l);
			bufs.push(d);
			blob.l += 4+l;
			next = (XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)]);
		}
		var b = (bconcat(bufs));
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		if(b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(p.t === 'z') return;
		if(!p.XF) return;
		var fmtid = 0;
		try {
			fmtid = p.z || p.XF.numFmtId || 0;
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0 || fmtid == "General") {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else p.w = SSF_general(p.v);
			}
			else p.w = SSF_format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
		} catch(e) { if(opts.WTF) throw e; }
		if(opts.cellDates && fmtid && p.t == 'n' && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
			var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	}
	
	function make_cell(val, ixfe, t) {
		return ({v:val, ixfe:ixfe, t:t});
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = ({opts:{}});
		var Sheets = {};
		if(DENSE != null && options.dense == null) options.dense = DENSE;
		var out = ((options.dense ? [] : {}));
		var Directory = {};
		var range = ({});
		var last_formula = null;
		var sst = ([]);
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
		var sharedf = {};
		var arrayf = [];
		var temp_val;
		var country;
		var XFs = []; /* XF records */
		var palette = [];
		var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line, options) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
			line.s = ({});
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(file_depth > 1) return;
			if(options.sheetRows && cell.r >= options.sheetRows) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
			delete line.ixfe; delete line.XF;
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			if(options.cellFormula && line.f) {
				for(var afi = 0; afi < arrayf.length; ++afi) {
					if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
					if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
					line.F = encode_range(arrayf[afi][0]);
					if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
					if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
					break;
				}
			}
			{
				if(options.dense) {
					if(!out[cell.r]) out[cell.r] = [];
					out[cell.r][cell.c] = line;
				} else out[last_cell] = line;
			}
		};
		var opts = ({
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: sharedf, // shared formulae by address
			arrayf: arrayf, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			cellStyles: !!options && !!options.cellStyles,
			WTF: !!options && !!options.wtf
		});
		if(options.password) opts.password = options.password;
		var themes;
		var merges = [];
		var objects = [];
		var colinfo = [], rowinfo = [];
		var seencol = false;
		var supbooks = ([]); // 1-indexed, will hold extern names
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		supbooks.names = [];
		supbooks.XTI = [];
		var last_RT = 0;
		var file_depth = 0; /* TODO: make a real stack */
		var BIFF2Fmt = 0, BIFF2FmtTable = [];
		var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
		var last_lbl;
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
		var seen_codepage = false;
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_RT === 0x000a /* EOF */) break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
			var R = XLSRecordEnum[RecordType];
			//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
			//if(!R) console.log(blob.slice(blob.l, blob.l + length));
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_RT === 0x0085 /* BoundSheet8 */ && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */) break;
				}
				last_RT = RecordType;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
					if(R.r == 12){
						blob.l += 10; length -= 10;
					} // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val = ({});
				if(RecordType === 0x000a /* EOF */) val = R.f(blob, length, opts);
				else val = slurp(RecordType, R, blob, length, opts);
	if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(last_RT) === -1 /* 'BOF' */) continue;
				switch(RecordType) {
					case 0x0022 /* Date1904 */:
	wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
					case 0x0086 /* WriteProtect */: wb.opts.WriteProtect = true; break;
					case 0x002f /* FilePass */:
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(!options.password) throw new Error("File is password-protected");
						if(val.valid == null) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 0x005c /* WriteAccess */: opts.lastuser = val; break;
					case 0x0042 /* CodePage */:
						var cpval = Number(val);
						/* overrides based on test cases */
						switch(cpval) {
							case 0x5212: cpval =  1200; break;
							case 0x8000: cpval = 10000; break;
							case 0x8001: cpval =  1252; break;
						}
						set_cp(opts.codepage = cpval);
						seen_codepage = true;
						break;
					case 0x013d /* RRTabId */: opts.rrtabid = val; break;
					case 0x0019 /* WinProtect */: opts.winlocked = val; break;
					case 0x01b7 /* RefreshAll */: wb.opts["RefreshAll"] = val; break;
					case 0x000c /* CalcCount */: wb.opts["CalcCount"] = val; break;
					case 0x0010 /* CalcDelta */: wb.opts["CalcDelta"] = val; break;
					case 0x0011 /* CalcIter */: wb.opts["CalcIter"] = val; break;
					case 0x000d /* CalcMode */: wb.opts["CalcMode"] = val; break;
					case 0x000e /* CalcPrecision */: wb.opts["CalcPrecision"] = val; break;
					case 0x005f /* CalcSaveRecalc */: wb.opts["CalcSaveRecalc"] = val; break;
					case 0x000f /* CalcRefMode */: opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 0x08a3 /* ForceFullCalculation */: wb.opts.FullCalc = val; break;
					case 0x0081 /* WsBool */:
						if(val.fDialog) out["!type"] = "dialog";
						if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
						if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
						break; // TODO
					case 0x00e0 /* XF */:
						XFs.push(val); break;
					case 0x01ae /* SupBook */:
						supbooks.push([val]);
						supbooks[supbooks.length-1].XTI = [];
						break;
					case 0x0023: case 0x0223 /* ExternName */:
						supbooks[supbooks.length-1].push(val);
						break;
					case 0x0018: case 0x0218 /* Lbl */:
						last_lbl = ({
							Name: val.Name,
							Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
						});
						if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
						supbooks.names.push(last_lbl);
						if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length-1].push(val);
						if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
							if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
								FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
						break;
					case 0x0016 /* ExternCount */: opts.ExternCount = val; break;
					case 0x0017 /* ExternSheet */:
						if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
					case 0x0894 /* NameCmt */:
						/* TODO: search for correct name */
						if(opts.biff < 8) break;
						if(last_lbl != null) last_lbl.Comment = val[1];
						break;
					case 0x0012 /* Protect */: out["!protect"] = val; break; /* for sheet or book */
					case 0x0013 /* Password */: if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 0x0085 /* BoundSheet8 */: {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 0x000a /* EOF */: {
						if(--file_depth) break;
						if(range.e) {
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								if(options.sheetRows && options.sheetRows <= range.e.r) {
									var tmpri = range.e.r;
									range.e.r = options.sheetRows - 1;
									out["!fullref"] = out["!ref"];
									out["!ref"] = encode_range(range);
									range.e.r = tmpri;
								}
								range.e.r++; range.e.c++;
							}
							if(merges.length > 0) out["!merges"] = merges;
							if(objects.length > 0) out["!objects"] = objects;
							if(colinfo.length > 0) out["!cols"] = colinfo;
							if(rowinfo.length > 0) out["!rows"] = rowinfo;
							Workbook.Sheets.push(wsprops);
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = ((options.dense ? [] : {}));
					} break;
					case 0x0009: case 0x0209: case 0x0409: case 0x0809 /* BOF */: {
						if(opts.biff === 8) opts.biff = {
	0x0009:2,
	0x0209:3,
	0x0409:4
						}[RecordType] || {
	0x0200:2,
	0x0300:3,
	0x0400:4,
	0x0500:5,
	0x0600:8,
	0x0002:2,
	0x0007:2
						}[val.BIFFVer] || 8;
						opts.biffguess = val.BIFFVer == 0;
						if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
						if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
						if(file_depth++) break;
						out = ((options.dense ? [] : {}));
	
						if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
	
						if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
							/* fake BoundSheet8 */
							var fakebs8 = {pos: blob.l - length, name:cur_sheet};
							Directory[fakebs8.pos] = fakebs8;
							opts.snames.push(cur_sheet);
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						if(val.dt == 0x20) out["!type"] = "chart";
						if(val.dt == 0x40) out["!type"] = "macro";
						merges = [];
						objects = [];
						opts.arrayf = arrayf = [];
						colinfo = []; rowinfo = [];
						seencol = false;
						wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
					} break;
					case 0x0203 /* Number */: case 0x0003 /* BIFF2NUM */: case 0x0002 /* BIFF2INT */: {
						if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x0005: case 0x0205 /* BoolErr */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x027e /* RK */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00bd /* MulRk */: {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x0006: case 0x0206: case 0x0406 /* Formula */: {
						if(val.val == 'String') { last_formula = val; break; }
						temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							var _f = val.formula;
							if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
								var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
								var _fe = encode_cell({r:_fr, c:_fc});
								if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
							} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(val.cell, temp_val, options);
						last_formula = val;
					} break;
					case 0x0007: case 0x0207 /* String */: {
						if(last_formula) { /* technically always true */
							last_formula.val = val;
							temp_val = make_cell(val, last_formula.cell.ixfe, 's');
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) {
								temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							}
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						} else throw new Error("String record expects Formula");
					} break;
					case 0x0021: case 0x0221 /* Array */: {
						arrayf.push(val);
						var _arraystart = encode_cell(val[0].s);
						cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
						if(options.cellFormula && cc) {
							if(!last_formula) break; /* technically unreachable */
							if(!_arraystart || !cc) break;
							cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
							cc.F = encode_range(val[0]);
						}
					} break;
					case 0x04bc /* ShrFmla */: {
						if(!options.cellFormula) break;
						if(last_cell) {
							/* TODO: capture range */
							if(!last_formula) break; /* technically unreachable */
							sharedf[encode_cell(last_formula.cell)]= val[0];
							cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
							(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
						}
					} break;
					case 0x00fd /* LabelSst */:
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 0x0201 /* Blank */: if(options.sheetStubs) {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00be /* MulBlank */: if(options.sheetStubs) {
						for(var _j = val.c; _j <= val.C; ++_j) {
							var _ixfe = val.ixfe[_j-val.c];
							temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:_j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x00d6 /* RString */:
					case 0x0204 /* Label */: case 0x0004 /* BIFF2STR */:
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
	
					case 0x0000: case 0x0200 /* Dimensions */: {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 0x00fc /* SST */: {
						sst = val;
					} break;
					case 0x041e /* Format */: { /* val = [id, fmt] */
						if(opts.biff == 4) {
							BIFF2FmtTable[BIFF2Fmt++] = val[1];
							for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(table_fmt[b4idx] == val[1]) break;
							if(b4idx >= 163) SSF_load(val[1], BIFF2Fmt + 163);
						}
						else SSF_load(val[1], val[0]);
					} break;
					case 0x001e /* BIFF2FORMAT */: {
						BIFF2FmtTable[BIFF2Fmt++] = val;
						for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(table_fmt[b2idx] == val) break;
						if(b2idx >= 163) SSF_load(val, BIFF2Fmt + 163);
					} break;
	
					case 0x00e5 /* MergeCells */: merges = merges.concat(val); break;
	
					case 0x005d /* Obj */: objects[val.cmo[0]] = opts.lastobj = val; break;
					case 0x01b6 /* TxO */: opts.lastobj.TxO = val; break;
					case 0x007f /* ImData */: opts.lastobj.ImData = val; break;
	
					case 0x01b8 /* HLink */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l = val[1];
							}
					} break;
					case 0x0800 /* HLinkTooltip */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc && cc.l) cc.l.Tooltip = val[1];
								}
					} break;
					case 0x001c /* Note */: {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) {
							if(options.dense) {
								if(!out[val[0].r]) out[val[0].r] = [];
								cc = out[val[0].r][val[0].c] = ({t:"z"});
							} else {
								cc = out[encode_cell(val[0])] = ({t:"z"});
							}
							range.e.r = Math.max(range.e.r, val[0].r);
							range.s.r = Math.min(range.s.r, val[0].r);
							range.e.c = Math.max(range.e.c, val[0].c);
							range.s.c = Math.min(range.s.c, val[0].c);
						}
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
					case 0x087d /* XFExt */: update_xfext(XFs[val.ixfe], val.ext); break;
					case 0x007d /* ColInfo */: {
						if(!opts.cellStyles) break;
						while(val.e >= val.s) {
							colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
							if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
							process_col(colinfo[val.e+1]);
						}
					} break;
					case 0x0208 /* Row */: {
						var rowobj = {};
						if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
						if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
						if(val.hpt) {
							rowinfo[val.r] = rowobj;
							rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
						}
					} break;
					case 0x0026 /* LeftMargin */:
					case 0x0027 /* RightMargin */:
					case 0x0028 /* TopMargin */:
					case 0x0029 /* BottomMargin */:
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'][({0x26: "left", 0x27:"right", 0x28:"top", 0x29:"bottom"})[RecordType]] = val;
						break;
					case 0x00a1 /* Setup */: // TODO
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'].header = val.header;
						out['!margins'].footer = val.footer;
						break;
					case 0x023e /* Window2 */: // TODO
						// $FlowIgnore
						if(val.RTL) Workbook.Views[0].RTL = true;
						break;
					case 0x0092 /* Palette */: palette = val; break;
					case 0x0896 /* Theme */: themes = val; break;
					case 0x008c /* Country */: country = val; break;
					case 0x01ba /* CodeName */: {
	if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
						else wsprops.CodeName = val || wsprops.name;
					} break;
				}
			} else {
				if(!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
				blob.l += length;
			}
		}
		wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		if(!options.bookSheets) wb.Sheets=Sheets;
		if(!wb.SheetNames.length && Preamble["!ref"]) {
			wb.SheetNames.push("Sheet1");
			/*jshint -W069 */
			if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
			/*jshint +W069 */
		} else wb.Preamble=Preamble;
		if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
		wb.Strings = sst;
		wb.SSF = dup(table_fmt);
		if(opts.enc) wb.Encryption = opts.enc;
		if(themes) wb.Themes = themes;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
		wb.Workbook = Workbook;
		return wb;
	}
	
	/* TODO: split props*/
	var PSCLSID = {
		SI: "e0859ff2f94f6810ab9108002b27b3d9",
		DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
		UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
	};
	function parse_xls_props(cfb, props, o) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
		if(DSI && DSI.size > 0) try {
			var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
			for(var d in DocSummary) props[d] = DocSummary[d];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = CFB.find(cfb, '/!SummaryInformation');
		if(SI && SI.size > 0) try {
			var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
			for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		if(props.HeadingPairs && props.TitlesOfParts) {
			load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
			delete props.HeadingPairs; delete props.TitlesOfParts;
		}
	}
	function write_xls_props(wb, cfb) {
		var DSEntries = [], SEntries = [], CEntries = [];
		var i = 0, Keys;
		var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
		var SummaryRE = evert_key(SummaryPIDSI, "n");
		if(wb.Props) {
			Keys = keys(wb.Props);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
		}
		if(wb.Custprops) {
			Keys = keys(wb.Custprops);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
		}
		var CEntries2 = [];
		for(i = 0; i < CEntries.length; ++i) {
			if(XLSPSSkip.indexOf(CEntries[i][0]) > -1 || PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
			if(CEntries[i][1] == null) continue;
			CEntries2.push(CEntries[i]);
		}
		if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
		if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	if(options.codepage) set_ansi(options.codepage);
	var CompObj, WB;
	if(cfb.FullPaths) {
		if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
		CompObj = CFB.find(cfb, '!CompObj');
		WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
	} else {
		switch(options.type) {
			case 'base64': cfb = s2a(Base64_decode(cfb)); break;
			case 'binary': cfb = s2a(cfb); break;
			case 'buffer': break;
			case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
		}
		prep_blob(cfb, 0);
		WB = ({content: cfb});
	}
	var WorkbookP;
	
	var _data;
	if(CompObj) parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = ({});
	else {
		var T = has_buf ? 'buffer' : 'array';
		if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
		/* Quattro Pro 7-8 */
		else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Quattro Pro 9 */
		else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Works 4 for Mac */
		else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
		else throw new Error("Cannot find Workbook stream");
		if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
	}
	
	var props = {};
	if(cfb.FullPaths) parse_xls_props(cfb, props, options);
	
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
	return WorkbookP;
	}
	
	
	function write_xlscfb(wb, opts) {
		var o = opts || {};
		var cfb = CFB.utils.cfb_new({root:"R"});
		var wbpath = "/Workbook";
		switch(o.bookType || "xls") {
			case "xls": o.bookType = "biff8";
			/* falls through */
			case "xla": if(!o.bookType) o.bookType = "xla";
			/* falls through */
			case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
			case "biff5": wbpath = "/Book"; o.biff = 5; break;
			default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
		}
		CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
		if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
		// TODO: SI, DSI, CO
		if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
		return cfb;
	}
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
	0x0000: { /* n:"BrtRowHdr", */ f:parse_BrtRowHdr },
	0x0001: { /* n:"BrtCellBlank", */ f:parse_BrtCellBlank },
	0x0002: { /* n:"BrtCellRk", */ f:parse_BrtCellRk },
	0x0003: { /* n:"BrtCellError", */ f:parse_BrtCellError },
	0x0004: { /* n:"BrtCellBool", */ f:parse_BrtCellBool },
	0x0005: { /* n:"BrtCellReal", */ f:parse_BrtCellReal },
	0x0006: { /* n:"BrtCellSt", */ f:parse_BrtCellSt },
	0x0007: { /* n:"BrtCellIsst", */ f:parse_BrtCellIsst },
	0x0008: { /* n:"BrtFmlaString", */ f:parse_BrtFmlaString },
	0x0009: { /* n:"BrtFmlaNum", */ f:parse_BrtFmlaNum },
	0x000A: { /* n:"BrtFmlaBool", */ f:parse_BrtFmlaBool },
	0x000B: { /* n:"BrtFmlaError", */ f:parse_BrtFmlaError },
	0x000C: { /* n:"BrtShortBlank", */ f:parse_BrtShortBlank },
	0x000D: { /* n:"BrtShortRk", */ f:parse_BrtShortRk },
	0x000E: { /* n:"BrtShortError", */ f:parse_BrtShortError },
	0x000F: { /* n:"BrtShortBool", */ f:parse_BrtShortBool },
	0x0010: { /* n:"BrtShortReal", */ f:parse_BrtShortReal },
	0x0011: { /* n:"BrtShortSt", */ f:parse_BrtShortSt },
	0x0012: { /* n:"BrtShortIsst", */ f:parse_BrtShortIsst },
	0x0013: { /* n:"BrtSSTItem", */ f:parse_RichStr },
	0x0014: { /* n:"BrtPCDIMissing" */ },
	0x0015: { /* n:"BrtPCDINumber" */ },
	0x0016: { /* n:"BrtPCDIBoolean" */ },
	0x0017: { /* n:"BrtPCDIError" */ },
	0x0018: { /* n:"BrtPCDIString" */ },
	0x0019: { /* n:"BrtPCDIDatetime" */ },
	0x001A: { /* n:"BrtPCDIIndex" */ },
	0x001B: { /* n:"BrtPCDIAMissing" */ },
	0x001C: { /* n:"BrtPCDIANumber" */ },
	0x001D: { /* n:"BrtPCDIABoolean" */ },
	0x001E: { /* n:"BrtPCDIAError" */ },
	0x001F: { /* n:"BrtPCDIAString" */ },
	0x0020: { /* n:"BrtPCDIADatetime" */ },
	0x0021: { /* n:"BrtPCRRecord" */ },
	0x0022: { /* n:"BrtPCRRecordDt" */ },
	0x0023: { /* n:"BrtFRTBegin", */ T:1 },
	0x0024: { /* n:"BrtFRTEnd", */ T:-1 },
	0x0025: { /* n:"BrtACBegin", */ T:1 },
	0x0026: { /* n:"BrtACEnd", */ T:-1 },
	0x0027: { /* n:"BrtName", */ f:parse_BrtName },
	0x0028: { /* n:"BrtIndexRowBlock" */ },
	0x002A: { /* n:"BrtIndexBlock" */ },
	0x002B: { /* n:"BrtFont", */ f:parse_BrtFont },
	0x002C: { /* n:"BrtFmt", */ f:parse_BrtFmt },
	0x002D: { /* n:"BrtFill", */ f:parse_BrtFill },
	0x002E: { /* n:"BrtBorder", */ f:parse_BrtBorder },
	0x002F: { /* n:"BrtXF", */ f:parse_BrtXF },
	0x0030: { /* n:"BrtStyle" */ },
	0x0031: { /* n:"BrtCellMeta", */ f:parse_Int32LE },
	0x0032: { /* n:"BrtValueMeta" */ },
	0x0033: { /* n:"BrtMdb" */ f:parse_BrtMdb },
	0x0034: { /* n:"BrtBeginFmd", */ T:1 },
	0x0035: { /* n:"BrtEndFmd", */ T:-1 },
	0x0036: { /* n:"BrtBeginMdx", */ T:1 },
	0x0037: { /* n:"BrtEndMdx", */ T:-1 },
	0x0038: { /* n:"BrtBeginMdxTuple", */ T:1 },
	0x0039: { /* n:"BrtEndMdxTuple", */ T:-1 },
	0x003A: { /* n:"BrtMdxMbrIstr" */ },
	0x003B: { /* n:"BrtStr" */ },
	0x003C: { /* n:"BrtColInfo", */ f:parse_ColInfo },
	0x003E: { /* n:"BrtCellRString", */ f:parse_BrtCellRString },
	0x003F: { /* n:"BrtCalcChainItem$", */ f:parse_BrtCalcChainItem$ },
	0x0040: { /* n:"BrtDVal", */ f:parse_BrtDVal },
	0x0041: { /* n:"BrtSxvcellNum" */ },
	0x0042: { /* n:"BrtSxvcellStr" */ },
	0x0043: { /* n:"BrtSxvcellBool" */ },
	0x0044: { /* n:"BrtSxvcellErr" */ },
	0x0045: { /* n:"BrtSxvcellDate" */ },
	0x0046: { /* n:"BrtSxvcellNil" */ },
	0x0080: { /* n:"BrtFileVersion" */ },
	0x0081: { /* n:"BrtBeginSheet", */ T:1 },
	0x0082: { /* n:"BrtEndSheet", */ T:-1 },
	0x0083: { /* n:"BrtBeginBook", */ T:1, f:parsenoop, p:0 },
	0x0084: { /* n:"BrtEndBook", */ T:-1 },
	0x0085: { /* n:"BrtBeginWsViews", */ T:1 },
	0x0086: { /* n:"BrtEndWsViews", */ T:-1 },
	0x0087: { /* n:"BrtBeginBookViews", */ T:1 },
	0x0088: { /* n:"BrtEndBookViews", */ T:-1 },
	0x0089: { /* n:"BrtBeginWsView", */ T:1, f:parse_BrtBeginWsView },
	0x008A: { /* n:"BrtEndWsView", */ T:-1 },
	0x008B: { /* n:"BrtBeginCsViews", */ T:1 },
	0x008C: { /* n:"BrtEndCsViews", */ T:-1 },
	0x008D: { /* n:"BrtBeginCsView", */ T:1 },
	0x008E: { /* n:"BrtEndCsView", */ T:-1 },
	0x008F: { /* n:"BrtBeginBundleShs", */ T:1 },
	0x0090: { /* n:"BrtEndBundleShs", */ T:-1 },
	0x0091: { /* n:"BrtBeginSheetData", */ T:1 },
	0x0092: { /* n:"BrtEndSheetData", */ T:-1 },
	0x0093: { /* n:"BrtWsProp", */ f:parse_BrtWsProp },
	0x0094: { /* n:"BrtWsDim", */ f:parse_BrtWsDim, p:16 },
	0x0097: { /* n:"BrtPane", */ f:parse_BrtPane },
	0x0098: { /* n:"BrtSel" */ },
	0x0099: { /* n:"BrtWbProp", */ f:parse_BrtWbProp },
	0x009A: { /* n:"BrtWbFactoid" */ },
	0x009B: { /* n:"BrtFileRecover" */ },
	0x009C: { /* n:"BrtBundleSh", */ f:parse_BrtBundleSh },
	0x009D: { /* n:"BrtCalcProp" */ },
	0x009E: { /* n:"BrtBookView" */ },
	0x009F: { /* n:"BrtBeginSst", */ T:1, f:parse_BrtBeginSst },
	0x00A0: { /* n:"BrtEndSst", */ T:-1 },
	0x00A1: { /* n:"BrtBeginAFilter", */ T:1, f:parse_UncheckedRfX },
	0x00A2: { /* n:"BrtEndAFilter", */ T:-1 },
	0x00A3: { /* n:"BrtBeginFilterColumn", */ T:1 },
	0x00A4: { /* n:"BrtEndFilterColumn", */ T:-1 },
	0x00A5: { /* n:"BrtBeginFilters", */ T:1 },
	0x00A6: { /* n:"BrtEndFilters", */ T:-1 },
	0x00A7: { /* n:"BrtFilter" */ },
	0x00A8: { /* n:"BrtColorFilter" */ },
	0x00A9: { /* n:"BrtIconFilter" */ },
	0x00AA: { /* n:"BrtTop10Filter" */ },
	0x00AB: { /* n:"BrtDynamicFilter" */ },
	0x00AC: { /* n:"BrtBeginCustomFilters", */ T:1 },
	0x00AD: { /* n:"BrtEndCustomFilters", */ T:-1 },
	0x00AE: { /* n:"BrtCustomFilter" */ },
	0x00AF: { /* n:"BrtAFilterDateGroupItem" */ },
	0x00B0: { /* n:"BrtMergeCell", */ f:parse_BrtMergeCell },
	0x00B1: { /* n:"BrtBeginMergeCells", */ T:1 },
	0x00B2: { /* n:"BrtEndMergeCells", */ T:-1 },
	0x00B3: { /* n:"BrtBeginPivotCacheDef", */ T:1 },
	0x00B4: { /* n:"BrtEndPivotCacheDef", */ T:-1 },
	0x00B5: { /* n:"BrtBeginPCDFields", */ T:1 },
	0x00B6: { /* n:"BrtEndPCDFields", */ T:-1 },
	0x00B7: { /* n:"BrtBeginPCDField", */ T:1 },
	0x00B8: { /* n:"BrtEndPCDField", */ T:-1 },
	0x00B9: { /* n:"BrtBeginPCDSource", */ T:1 },
	0x00BA: { /* n:"BrtEndPCDSource", */ T:-1 },
	0x00BB: { /* n:"BrtBeginPCDSRange", */ T:1 },
	0x00BC: { /* n:"BrtEndPCDSRange", */ T:-1 },
	0x00BD: { /* n:"BrtBeginPCDFAtbl", */ T:1 },
	0x00BE: { /* n:"BrtEndPCDFAtbl", */ T:-1 },
	0x00BF: { /* n:"BrtBeginPCDIRun", */ T:1 },
	0x00C0: { /* n:"BrtEndPCDIRun", */ T:-1 },
	0x00C1: { /* n:"BrtBeginPivotCacheRecords", */ T:1 },
	0x00C2: { /* n:"BrtEndPivotCacheRecords", */ T:-1 },
	0x00C3: { /* n:"BrtBeginPCDHierarchies", */ T:1 },
	0x00C4: { /* n:"BrtEndPCDHierarchies", */ T:-1 },
	0x00C5: { /* n:"BrtBeginPCDHierarchy", */ T:1 },
	0x00C6: { /* n:"BrtEndPCDHierarchy", */ T:-1 },
	0x00C7: { /* n:"BrtBeginPCDHFieldsUsage", */ T:1 },
	0x00C8: { /* n:"BrtEndPCDHFieldsUsage", */ T:-1 },
	0x00C9: { /* n:"BrtBeginExtConnection", */ T:1 },
	0x00CA: { /* n:"BrtEndExtConnection", */ T:-1 },
	0x00CB: { /* n:"BrtBeginECDbProps", */ T:1 },
	0x00CC: { /* n:"BrtEndECDbProps", */ T:-1 },
	0x00CD: { /* n:"BrtBeginECOlapProps", */ T:1 },
	0x00CE: { /* n:"BrtEndECOlapProps", */ T:-1 },
	0x00CF: { /* n:"BrtBeginPCDSConsol", */ T:1 },
	0x00D0: { /* n:"BrtEndPCDSConsol", */ T:-1 },
	0x00D1: { /* n:"BrtBeginPCDSCPages", */ T:1 },
	0x00D2: { /* n:"BrtEndPCDSCPages", */ T:-1 },
	0x00D3: { /* n:"BrtBeginPCDSCPage", */ T:1 },
	0x00D4: { /* n:"BrtEndPCDSCPage", */ T:-1 },
	0x00D5: { /* n:"BrtBeginPCDSCPItem", */ T:1 },
	0x00D6: { /* n:"BrtEndPCDSCPItem", */ T:-1 },
	0x00D7: { /* n:"BrtBeginPCDSCSets", */ T:1 },
	0x00D8: { /* n:"BrtEndPCDSCSets", */ T:-1 },
	0x00D9: { /* n:"BrtBeginPCDSCSet", */ T:1 },
	0x00DA: { /* n:"BrtEndPCDSCSet", */ T:-1 },
	0x00DB: { /* n:"BrtBeginPCDFGroup", */ T:1 },
	0x00DC: { /* n:"BrtEndPCDFGroup", */ T:-1 },
	0x00DD: { /* n:"BrtBeginPCDFGItems", */ T:1 },
	0x00DE: { /* n:"BrtEndPCDFGItems", */ T:-1 },
	0x00DF: { /* n:"BrtBeginPCDFGRange", */ T:1 },
	0x00E0: { /* n:"BrtEndPCDFGRange", */ T:-1 },
	0x00E1: { /* n:"BrtBeginPCDFGDiscrete", */ T:1 },
	0x00E2: { /* n:"BrtEndPCDFGDiscrete", */ T:-1 },
	0x00E3: { /* n:"BrtBeginPCDSDTupleCache", */ T:1 },
	0x00E4: { /* n:"BrtEndPCDSDTupleCache", */ T:-1 },
	0x00E5: { /* n:"BrtBeginPCDSDTCEntries", */ T:1 },
	0x00E6: { /* n:"BrtEndPCDSDTCEntries", */ T:-1 },
	0x00E7: { /* n:"BrtBeginPCDSDTCEMembers", */ T:1 },
	0x00E8: { /* n:"BrtEndPCDSDTCEMembers", */ T:-1 },
	0x00E9: { /* n:"BrtBeginPCDSDTCEMember", */ T:1 },
	0x00EA: { /* n:"BrtEndPCDSDTCEMember", */ T:-1 },
	0x00EB: { /* n:"BrtBeginPCDSDTCQueries", */ T:1 },
	0x00EC: { /* n:"BrtEndPCDSDTCQueries", */ T:-1 },
	0x00ED: { /* n:"BrtBeginPCDSDTCQuery", */ T:1 },
	0x00EE: { /* n:"BrtEndPCDSDTCQuery", */ T:-1 },
	0x00EF: { /* n:"BrtBeginPCDSDTCSets", */ T:1 },
	0x00F0: { /* n:"BrtEndPCDSDTCSets", */ T:-1 },
	0x00F1: { /* n:"BrtBeginPCDSDTCSet", */ T:1 },
	0x00F2: { /* n:"BrtEndPCDSDTCSet", */ T:-1 },
	0x00F3: { /* n:"BrtBeginPCDCalcItems", */ T:1 },
	0x00F4: { /* n:"BrtEndPCDCalcItems", */ T:-1 },
	0x00F5: { /* n:"BrtBeginPCDCalcItem", */ T:1 },
	0x00F6: { /* n:"BrtEndPCDCalcItem", */ T:-1 },
	0x00F7: { /* n:"BrtBeginPRule", */ T:1 },
	0x00F8: { /* n:"BrtEndPRule", */ T:-1 },
	0x00F9: { /* n:"BrtBeginPRFilters", */ T:1 },
	0x00FA: { /* n:"BrtEndPRFilters", */ T:-1 },
	0x00FB: { /* n:"BrtBeginPRFilter", */ T:1 },
	0x00FC: { /* n:"BrtEndPRFilter", */ T:-1 },
	0x00FD: { /* n:"BrtBeginPNames", */ T:1 },
	0x00FE: { /* n:"BrtEndPNames", */ T:-1 },
	0x00FF: { /* n:"BrtBeginPName", */ T:1 },
	0x0100: { /* n:"BrtEndPName", */ T:-1 },
	0x0101: { /* n:"BrtBeginPNPairs", */ T:1 },
	0x0102: { /* n:"BrtEndPNPairs", */ T:-1 },
	0x0103: { /* n:"BrtBeginPNPair", */ T:1 },
	0x0104: { /* n:"BrtEndPNPair", */ T:-1 },
	0x0105: { /* n:"BrtBeginECWebProps", */ T:1 },
	0x0106: { /* n:"BrtEndECWebProps", */ T:-1 },
	0x0107: { /* n:"BrtBeginEcWpTables", */ T:1 },
	0x0108: { /* n:"BrtEndECWPTables", */ T:-1 },
	0x0109: { /* n:"BrtBeginECParams", */ T:1 },
	0x010A: { /* n:"BrtEndECParams", */ T:-1 },
	0x010B: { /* n:"BrtBeginECParam", */ T:1 },
	0x010C: { /* n:"BrtEndECParam", */ T:-1 },
	0x010D: { /* n:"BrtBeginPCDKPIs", */ T:1 },
	0x010E: { /* n:"BrtEndPCDKPIs", */ T:-1 },
	0x010F: { /* n:"BrtBeginPCDKPI", */ T:1 },
	0x0110: { /* n:"BrtEndPCDKPI", */ T:-1 },
	0x0111: { /* n:"BrtBeginDims", */ T:1 },
	0x0112: { /* n:"BrtEndDims", */ T:-1 },
	0x0113: { /* n:"BrtBeginDim", */ T:1 },
	0x0114: { /* n:"BrtEndDim", */ T:-1 },
	0x0115: { /* n:"BrtIndexPartEnd" */ },
	0x0116: { /* n:"BrtBeginStyleSheet", */ T:1 },
	0x0117: { /* n:"BrtEndStyleSheet", */ T:-1 },
	0x0118: { /* n:"BrtBeginSXView", */ T:1 },
	0x0119: { /* n:"BrtEndSXVI", */ T:-1 },
	0x011A: { /* n:"BrtBeginSXVI", */ T:1 },
	0x011B: { /* n:"BrtBeginSXVIs", */ T:1 },
	0x011C: { /* n:"BrtEndSXVIs", */ T:-1 },
	0x011D: { /* n:"BrtBeginSXVD", */ T:1 },
	0x011E: { /* n:"BrtEndSXVD", */ T:-1 },
	0x011F: { /* n:"BrtBeginSXVDs", */ T:1 },
	0x0120: { /* n:"BrtEndSXVDs", */ T:-1 },
	0x0121: { /* n:"BrtBeginSXPI", */ T:1 },
	0x0122: { /* n:"BrtEndSXPI", */ T:-1 },
	0x0123: { /* n:"BrtBeginSXPIs", */ T:1 },
	0x0124: { /* n:"BrtEndSXPIs", */ T:-1 },
	0x0125: { /* n:"BrtBeginSXDI", */ T:1 },
	0x0126: { /* n:"BrtEndSXDI", */ T:-1 },
	0x0127: { /* n:"BrtBeginSXDIs", */ T:1 },
	0x0128: { /* n:"BrtEndSXDIs", */ T:-1 },
	0x0129: { /* n:"BrtBeginSXLI", */ T:1 },
	0x012A: { /* n:"BrtEndSXLI", */ T:-1 },
	0x012B: { /* n:"BrtBeginSXLIRws", */ T:1 },
	0x012C: { /* n:"BrtEndSXLIRws", */ T:-1 },
	0x012D: { /* n:"BrtBeginSXLICols", */ T:1 },
	0x012E: { /* n:"BrtEndSXLICols", */ T:-1 },
	0x012F: { /* n:"BrtBeginSXFormat", */ T:1 },
	0x0130: { /* n:"BrtEndSXFormat", */ T:-1 },
	0x0131: { /* n:"BrtBeginSXFormats", */ T:1 },
	0x0132: { /* n:"BrtEndSxFormats", */ T:-1 },
	0x0133: { /* n:"BrtBeginSxSelect", */ T:1 },
	0x0134: { /* n:"BrtEndSxSelect", */ T:-1 },
	0x0135: { /* n:"BrtBeginISXVDRws", */ T:1 },
	0x0136: { /* n:"BrtEndISXVDRws", */ T:-1 },
	0x0137: { /* n:"BrtBeginISXVDCols", */ T:1 },
	0x0138: { /* n:"BrtEndISXVDCols", */ T:-1 },
	0x0139: { /* n:"BrtEndSXLocation", */ T:-1 },
	0x013A: { /* n:"BrtBeginSXLocation", */ T:1 },
	0x013B: { /* n:"BrtEndSXView", */ T:-1 },
	0x013C: { /* n:"BrtBeginSXTHs", */ T:1 },
	0x013D: { /* n:"BrtEndSXTHs", */ T:-1 },
	0x013E: { /* n:"BrtBeginSXTH", */ T:1 },
	0x013F: { /* n:"BrtEndSXTH", */ T:-1 },
	0x0140: { /* n:"BrtBeginISXTHRws", */ T:1 },
	0x0141: { /* n:"BrtEndISXTHRws", */ T:-1 },
	0x0142: { /* n:"BrtBeginISXTHCols", */ T:1 },
	0x0143: { /* n:"BrtEndISXTHCols", */ T:-1 },
	0x0144: { /* n:"BrtBeginSXTDMPS", */ T:1 },
	0x0145: { /* n:"BrtEndSXTDMPs", */ T:-1 },
	0x0146: { /* n:"BrtBeginSXTDMP", */ T:1 },
	0x0147: { /* n:"BrtEndSXTDMP", */ T:-1 },
	0x0148: { /* n:"BrtBeginSXTHItems", */ T:1 },
	0x0149: { /* n:"BrtEndSXTHItems", */ T:-1 },
	0x014A: { /* n:"BrtBeginSXTHItem", */ T:1 },
	0x014B: { /* n:"BrtEndSXTHItem", */ T:-1 },
	0x014C: { /* n:"BrtBeginMetadata", */ T:1 },
	0x014D: { /* n:"BrtEndMetadata", */ T:-1 },
	0x014E: { /* n:"BrtBeginEsmdtinfo", */ T:1 },
	0x014F: { /* n:"BrtMdtinfo", */ f:parse_BrtMdtinfo },
	0x0150: { /* n:"BrtEndEsmdtinfo", */ T:-1 },
	0x0151: { /* n:"BrtBeginEsmdb", */ f:parse_BrtBeginEsmdb, T:1 },
	0x0152: { /* n:"BrtEndEsmdb", */ T:-1 },
	0x0153: { /* n:"BrtBeginEsfmd", */ T:1 },
	0x0154: { /* n:"BrtEndEsfmd", */ T:-1 },
	0x0155: { /* n:"BrtBeginSingleCells", */ T:1 },
	0x0156: { /* n:"BrtEndSingleCells", */ T:-1 },
	0x0157: { /* n:"BrtBeginList", */ T:1 },
	0x0158: { /* n:"BrtEndList", */ T:-1 },
	0x0159: { /* n:"BrtBeginListCols", */ T:1 },
	0x015A: { /* n:"BrtEndListCols", */ T:-1 },
	0x015B: { /* n:"BrtBeginListCol", */ T:1 },
	0x015C: { /* n:"BrtEndListCol", */ T:-1 },
	0x015D: { /* n:"BrtBeginListXmlCPr", */ T:1 },
	0x015E: { /* n:"BrtEndListXmlCPr", */ T:-1 },
	0x015F: { /* n:"BrtListCCFmla" */ },
	0x0160: { /* n:"BrtListTrFmla" */ },
	0x0161: { /* n:"BrtBeginExternals", */ T:1 },
	0x0162: { /* n:"BrtEndExternals", */ T:-1 },
	0x0163: { /* n:"BrtSupBookSrc", */ f:parse_RelID},
	0x0165: { /* n:"BrtSupSelf" */ },
	0x0166: { /* n:"BrtSupSame" */ },
	0x0167: { /* n:"BrtSupTabs" */ },
	0x0168: { /* n:"BrtBeginSupBook", */ T:1 },
	0x0169: { /* n:"BrtPlaceholderName" */ },
	0x016A: { /* n:"BrtExternSheet", */ f:parse_ExternSheet },
	0x016B: { /* n:"BrtExternTableStart" */ },
	0x016C: { /* n:"BrtExternTableEnd" */ },
	0x016E: { /* n:"BrtExternRowHdr" */ },
	0x016F: { /* n:"BrtExternCellBlank" */ },
	0x0170: { /* n:"BrtExternCellReal" */ },
	0x0171: { /* n:"BrtExternCellBool" */ },
	0x0172: { /* n:"BrtExternCellError" */ },
	0x0173: { /* n:"BrtExternCellString" */ },
	0x0174: { /* n:"BrtBeginEsmdx", */ T:1 },
	0x0175: { /* n:"BrtEndEsmdx", */ T:-1 },
	0x0176: { /* n:"BrtBeginMdxSet", */ T:1 },
	0x0177: { /* n:"BrtEndMdxSet", */ T:-1 },
	0x0178: { /* n:"BrtBeginMdxMbrProp", */ T:1 },
	0x0179: { /* n:"BrtEndMdxMbrProp", */ T:-1 },
	0x017A: { /* n:"BrtBeginMdxKPI", */ T:1 },
	0x017B: { /* n:"BrtEndMdxKPI", */ T:-1 },
	0x017C: { /* n:"BrtBeginEsstr", */ T:1 },
	0x017D: { /* n:"BrtEndEsstr", */ T:-1 },
	0x017E: { /* n:"BrtBeginPRFItem", */ T:1 },
	0x017F: { /* n:"BrtEndPRFItem", */ T:-1 },
	0x0180: { /* n:"BrtBeginPivotCacheIDs", */ T:1 },
	0x0181: { /* n:"BrtEndPivotCacheIDs", */ T:-1 },
	0x0182: { /* n:"BrtBeginPivotCacheID", */ T:1 },
	0x0183: { /* n:"BrtEndPivotCacheID", */ T:-1 },
	0x0184: { /* n:"BrtBeginISXVIs", */ T:1 },
	0x0185: { /* n:"BrtEndISXVIs", */ T:-1 },
	0x0186: { /* n:"BrtBeginColInfos", */ T:1 },
	0x0187: { /* n:"BrtEndColInfos", */ T:-1 },
	0x0188: { /* n:"BrtBeginRwBrk", */ T:1 },
	0x0189: { /* n:"BrtEndRwBrk", */ T:-1 },
	0x018A: { /* n:"BrtBeginColBrk", */ T:1 },
	0x018B: { /* n:"BrtEndColBrk", */ T:-1 },
	0x018C: { /* n:"BrtBrk" */ },
	0x018D: { /* n:"BrtUserBookView" */ },
	0x018E: { /* n:"BrtInfo" */ },
	0x018F: { /* n:"BrtCUsr" */ },
	0x0190: { /* n:"BrtUsr" */ },
	0x0191: { /* n:"BrtBeginUsers", */ T:1 },
	0x0193: { /* n:"BrtEOF" */ },
	0x0194: { /* n:"BrtUCR" */ },
	0x0195: { /* n:"BrtRRInsDel" */ },
	0x0196: { /* n:"BrtRREndInsDel" */ },
	0x0197: { /* n:"BrtRRMove" */ },
	0x0198: { /* n:"BrtRREndMove" */ },
	0x0199: { /* n:"BrtRRChgCell" */ },
	0x019A: { /* n:"BrtRREndChgCell" */ },
	0x019B: { /* n:"BrtRRHeader" */ },
	0x019C: { /* n:"BrtRRUserView" */ },
	0x019D: { /* n:"BrtRRRenSheet" */ },
	0x019E: { /* n:"BrtRRInsertSh" */ },
	0x019F: { /* n:"BrtRRDefName" */ },
	0x01A0: { /* n:"BrtRRNote" */ },
	0x01A1: { /* n:"BrtRRConflict" */ },
	0x01A2: { /* n:"BrtRRTQSIF" */ },
	0x01A3: { /* n:"BrtRRFormat" */ },
	0x01A4: { /* n:"BrtRREndFormat" */ },
	0x01A5: { /* n:"BrtRRAutoFmt" */ },
	0x01A6: { /* n:"BrtBeginUserShViews", */ T:1 },
	0x01A7: { /* n:"BrtBeginUserShView", */ T:1 },
	0x01A8: { /* n:"BrtEndUserShView", */ T:-1 },
	0x01A9: { /* n:"BrtEndUserShViews", */ T:-1 },
	0x01AA: { /* n:"BrtArrFmla", */ f:parse_BrtArrFmla },
	0x01AB: { /* n:"BrtShrFmla", */ f:parse_BrtShrFmla },
	0x01AC: { /* n:"BrtTable" */ },
	0x01AD: { /* n:"BrtBeginExtConnections", */ T:1 },
	0x01AE: { /* n:"BrtEndExtConnections", */ T:-1 },
	0x01AF: { /* n:"BrtBeginPCDCalcMems", */ T:1 },
	0x01B0: { /* n:"BrtEndPCDCalcMems", */ T:-1 },
	0x01B1: { /* n:"BrtBeginPCDCalcMem", */ T:1 },
	0x01B2: { /* n:"BrtEndPCDCalcMem", */ T:-1 },
	0x01B3: { /* n:"BrtBeginPCDHGLevels", */ T:1 },
	0x01B4: { /* n:"BrtEndPCDHGLevels", */ T:-1 },
	0x01B5: { /* n:"BrtBeginPCDHGLevel", */ T:1 },
	0x01B6: { /* n:"BrtEndPCDHGLevel", */ T:-1 },
	0x01B7: { /* n:"BrtBeginPCDHGLGroups", */ T:1 },
	0x01B8: { /* n:"BrtEndPCDHGLGroups", */ T:-1 },
	0x01B9: { /* n:"BrtBeginPCDHGLGroup", */ T:1 },
	0x01BA: { /* n:"BrtEndPCDHGLGroup", */ T:-1 },
	0x01BB: { /* n:"BrtBeginPCDHGLGMembers", */ T:1 },
	0x01BC: { /* n:"BrtEndPCDHGLGMembers", */ T:-1 },
	0x01BD: { /* n:"BrtBeginPCDHGLGMember", */ T:1 },
	0x01BE: { /* n:"BrtEndPCDHGLGMember", */ T:-1 },
	0x01BF: { /* n:"BrtBeginQSI", */ T:1 },
	0x01C0: { /* n:"BrtEndQSI", */ T:-1 },
	0x01C1: { /* n:"BrtBeginQSIR", */ T:1 },
	0x01C2: { /* n:"BrtEndQSIR", */ T:-1 },
	0x01C3: { /* n:"BrtBeginDeletedNames", */ T:1 },
	0x01C4: { /* n:"BrtEndDeletedNames", */ T:-1 },
	0x01C5: { /* n:"BrtBeginDeletedName", */ T:1 },
	0x01C6: { /* n:"BrtEndDeletedName", */ T:-1 },
	0x01C7: { /* n:"BrtBeginQSIFs", */ T:1 },
	0x01C8: { /* n:"BrtEndQSIFs", */ T:-1 },
	0x01C9: { /* n:"BrtBeginQSIF", */ T:1 },
	0x01CA: { /* n:"BrtEndQSIF", */ T:-1 },
	0x01CB: { /* n:"BrtBeginAutoSortScope", */ T:1 },
	0x01CC: { /* n:"BrtEndAutoSortScope", */ T:-1 },
	0x01CD: { /* n:"BrtBeginConditionalFormatting", */ T:1 },
	0x01CE: { /* n:"BrtEndConditionalFormatting", */ T:-1 },
	0x01CF: { /* n:"BrtBeginCFRule", */ T:1 },
	0x01D0: { /* n:"BrtEndCFRule", */ T:-1 },
	0x01D1: { /* n:"BrtBeginIconSet", */ T:1 },
	0x01D2: { /* n:"BrtEndIconSet", */ T:-1 },
	0x01D3: { /* n:"BrtBeginDatabar", */ T:1 },
	0x01D4: { /* n:"BrtEndDatabar", */ T:-1 },
	0x01D5: { /* n:"BrtBeginColorScale", */ T:1 },
	0x01D6: { /* n:"BrtEndColorScale", */ T:-1 },
	0x01D7: { /* n:"BrtCFVO" */ },
	0x01D8: { /* n:"BrtExternValueMeta" */ },
	0x01D9: { /* n:"BrtBeginColorPalette", */ T:1 },
	0x01DA: { /* n:"BrtEndColorPalette", */ T:-1 },
	0x01DB: { /* n:"BrtIndexedColor" */ },
	0x01DC: { /* n:"BrtMargins", */ f:parse_BrtMargins },
	0x01DD: { /* n:"BrtPrintOptions" */ },
	0x01DE: { /* n:"BrtPageSetup" */ },
	0x01DF: { /* n:"BrtBeginHeaderFooter", */ T:1 },
	0x01E0: { /* n:"BrtEndHeaderFooter", */ T:-1 },
	0x01E1: { /* n:"BrtBeginSXCrtFormat", */ T:1 },
	0x01E2: { /* n:"BrtEndSXCrtFormat", */ T:-1 },
	0x01E3: { /* n:"BrtBeginSXCrtFormats", */ T:1 },
	0x01E4: { /* n:"BrtEndSXCrtFormats", */ T:-1 },
	0x01E5: { /* n:"BrtWsFmtInfo", */ f:parse_BrtWsFmtInfo },
	0x01E6: { /* n:"BrtBeginMgs", */ T:1 },
	0x01E7: { /* n:"BrtEndMGs", */ T:-1 },
	0x01E8: { /* n:"BrtBeginMGMaps", */ T:1 },
	0x01E9: { /* n:"BrtEndMGMaps", */ T:-1 },
	0x01EA: { /* n:"BrtBeginMG", */ T:1 },
	0x01EB: { /* n:"BrtEndMG", */ T:-1 },
	0x01EC: { /* n:"BrtBeginMap", */ T:1 },
	0x01ED: { /* n:"BrtEndMap", */ T:-1 },
	0x01EE: { /* n:"BrtHLink", */ f:parse_BrtHLink },
	0x01EF: { /* n:"BrtBeginDCon", */ T:1 },
	0x01F0: { /* n:"BrtEndDCon", */ T:-1 },
	0x01F1: { /* n:"BrtBeginDRefs", */ T:1 },
	0x01F2: { /* n:"BrtEndDRefs", */ T:-1 },
	0x01F3: { /* n:"BrtDRef" */ },
	0x01F4: { /* n:"BrtBeginScenMan", */ T:1 },
	0x01F5: { /* n:"BrtEndScenMan", */ T:-1 },
	0x01F6: { /* n:"BrtBeginSct", */ T:1 },
	0x01F7: { /* n:"BrtEndSct", */ T:-1 },
	0x01F8: { /* n:"BrtSlc" */ },
	0x01F9: { /* n:"BrtBeginDXFs", */ T:1 },
	0x01FA: { /* n:"BrtEndDXFs", */ T:-1 },
	0x01FB: { /* n:"BrtDXF" */ },
	0x01FC: { /* n:"BrtBeginTableStyles", */ T:1 },
	0x01FD: { /* n:"BrtEndTableStyles", */ T:-1 },
	0x01FE: { /* n:"BrtBeginTableStyle", */ T:1 },
	0x01FF: { /* n:"BrtEndTableStyle", */ T:-1 },
	0x0200: { /* n:"BrtTableStyleElement" */ },
	0x0201: { /* n:"BrtTableStyleClient" */ },
	0x0202: { /* n:"BrtBeginVolDeps", */ T:1 },
	0x0203: { /* n:"BrtEndVolDeps", */ T:-1 },
	0x0204: { /* n:"BrtBeginVolType", */ T:1 },
	0x0205: { /* n:"BrtEndVolType", */ T:-1 },
	0x0206: { /* n:"BrtBeginVolMain", */ T:1 },
	0x0207: { /* n:"BrtEndVolMain", */ T:-1 },
	0x0208: { /* n:"BrtBeginVolTopic", */ T:1 },
	0x0209: { /* n:"BrtEndVolTopic", */ T:-1 },
	0x020A: { /* n:"BrtVolSubtopic" */ },
	0x020B: { /* n:"BrtVolRef" */ },
	0x020C: { /* n:"BrtVolNum" */ },
	0x020D: { /* n:"BrtVolErr" */ },
	0x020E: { /* n:"BrtVolStr" */ },
	0x020F: { /* n:"BrtVolBool" */ },
	0x0210: { /* n:"BrtBeginCalcChain$", */ T:1 },
	0x0211: { /* n:"BrtEndCalcChain$", */ T:-1 },
	0x0212: { /* n:"BrtBeginSortState", */ T:1 },
	0x0213: { /* n:"BrtEndSortState", */ T:-1 },
	0x0214: { /* n:"BrtBeginSortCond", */ T:1 },
	0x0215: { /* n:"BrtEndSortCond", */ T:-1 },
	0x0216: { /* n:"BrtBookProtection" */ },
	0x0217: { /* n:"BrtSheetProtection" */ },
	0x0218: { /* n:"BrtRangeProtection" */ },
	0x0219: { /* n:"BrtPhoneticInfo" */ },
	0x021A: { /* n:"BrtBeginECTxtWiz", */ T:1 },
	0x021B: { /* n:"BrtEndECTxtWiz", */ T:-1 },
	0x021C: { /* n:"BrtBeginECTWFldInfoLst", */ T:1 },
	0x021D: { /* n:"BrtEndECTWFldInfoLst", */ T:-1 },
	0x021E: { /* n:"BrtBeginECTwFldInfo", */ T:1 },
	0x0224: { /* n:"BrtFileSharing" */ },
	0x0225: { /* n:"BrtOleSize" */ },
	0x0226: { /* n:"BrtDrawing", */ f:parse_RelID },
	0x0227: { /* n:"BrtLegacyDrawing" */ },
	0x0228: { /* n:"BrtLegacyDrawingHF" */ },
	0x0229: { /* n:"BrtWebOpt" */ },
	0x022A: { /* n:"BrtBeginWebPubItems", */ T:1 },
	0x022B: { /* n:"BrtEndWebPubItems", */ T:-1 },
	0x022C: { /* n:"BrtBeginWebPubItem", */ T:1 },
	0x022D: { /* n:"BrtEndWebPubItem", */ T:-1 },
	0x022E: { /* n:"BrtBeginSXCondFmt", */ T:1 },
	0x022F: { /* n:"BrtEndSXCondFmt", */ T:-1 },
	0x0230: { /* n:"BrtBeginSXCondFmts", */ T:1 },
	0x0231: { /* n:"BrtEndSXCondFmts", */ T:-1 },
	0x0232: { /* n:"BrtBkHim" */ },
	0x0234: { /* n:"BrtColor" */ },
	0x0235: { /* n:"BrtBeginIndexedColors", */ T:1 },
	0x0236: { /* n:"BrtEndIndexedColors", */ T:-1 },
	0x0239: { /* n:"BrtBeginMRUColors", */ T:1 },
	0x023A: { /* n:"BrtEndMRUColors", */ T:-1 },
	0x023C: { /* n:"BrtMRUColor" */ },
	0x023D: { /* n:"BrtBeginDVals", */ T:1 },
	0x023E: { /* n:"BrtEndDVals", */ T:-1 },
	0x0241: { /* n:"BrtSupNameStart" */ },
	0x0242: { /* n:"BrtSupNameValueStart" */ },
	0x0243: { /* n:"BrtSupNameValueEnd" */ },
	0x0244: { /* n:"BrtSupNameNum" */ },
	0x0245: { /* n:"BrtSupNameErr" */ },
	0x0246: { /* n:"BrtSupNameSt" */ },
	0x0247: { /* n:"BrtSupNameNil" */ },
	0x0248: { /* n:"BrtSupNameBool" */ },
	0x0249: { /* n:"BrtSupNameFmla" */ },
	0x024A: { /* n:"BrtSupNameBits" */ },
	0x024B: { /* n:"BrtSupNameEnd" */ },
	0x024C: { /* n:"BrtEndSupBook", */ T:-1 },
	0x024D: { /* n:"BrtCellSmartTagProperty" */ },
	0x024E: { /* n:"BrtBeginCellSmartTag", */ T:1 },
	0x024F: { /* n:"BrtEndCellSmartTag", */ T:-1 },
	0x0250: { /* n:"BrtBeginCellSmartTags", */ T:1 },
	0x0251: { /* n:"BrtEndCellSmartTags", */ T:-1 },
	0x0252: { /* n:"BrtBeginSmartTags", */ T:1 },
	0x0253: { /* n:"BrtEndSmartTags", */ T:-1 },
	0x0254: { /* n:"BrtSmartTagType" */ },
	0x0255: { /* n:"BrtBeginSmartTagTypes", */ T:1 },
	0x0256: { /* n:"BrtEndSmartTagTypes", */ T:-1 },
	0x0257: { /* n:"BrtBeginSXFilters", */ T:1 },
	0x0258: { /* n:"BrtEndSXFilters", */ T:-1 },
	0x0259: { /* n:"BrtBeginSXFILTER", */ T:1 },
	0x025A: { /* n:"BrtEndSXFilter", */ T:-1 },
	0x025B: { /* n:"BrtBeginFills", */ T:1 },
	0x025C: { /* n:"BrtEndFills", */ T:-1 },
	0x025D: { /* n:"BrtBeginCellWatches", */ T:1 },
	0x025E: { /* n:"BrtEndCellWatches", */ T:-1 },
	0x025F: { /* n:"BrtCellWatch" */ },
	0x0260: { /* n:"BrtBeginCRErrs", */ T:1 },
	0x0261: { /* n:"BrtEndCRErrs", */ T:-1 },
	0x0262: { /* n:"BrtCrashRecErr" */ },
	0x0263: { /* n:"BrtBeginFonts", */ T:1 },
	0x0264: { /* n:"BrtEndFonts", */ T:-1 },
	0x0265: { /* n:"BrtBeginBorders", */ T:1 },
	0x0266: { /* n:"BrtEndBorders", */ T:-1 },
	0x0267: { /* n:"BrtBeginFmts", */ T:1 },
	0x0268: { /* n:"BrtEndFmts", */ T:-1 },
	0x0269: { /* n:"BrtBeginCellXFs", */ T:1 },
	0x026A: { /* n:"BrtEndCellXFs", */ T:-1 },
	0x026B: { /* n:"BrtBeginStyles", */ T:1 },
	0x026C: { /* n:"BrtEndStyles", */ T:-1 },
	0x0271: { /* n:"BrtBigName" */ },
	0x0272: { /* n:"BrtBeginCellStyleXFs", */ T:1 },
	0x0273: { /* n:"BrtEndCellStyleXFs", */ T:-1 },
	0x0274: { /* n:"BrtBeginComments", */ T:1 },
	0x0275: { /* n:"BrtEndComments", */ T:-1 },
	0x0276: { /* n:"BrtBeginCommentAuthors", */ T:1 },
	0x0277: { /* n:"BrtEndCommentAuthors", */ T:-1 },
	0x0278: { /* n:"BrtCommentAuthor", */ f:parse_BrtCommentAuthor },
	0x0279: { /* n:"BrtBeginCommentList", */ T:1 },
	0x027A: { /* n:"BrtEndCommentList", */ T:-1 },
	0x027B: { /* n:"BrtBeginComment", */ T:1, f:parse_BrtBeginComment},
	0x027C: { /* n:"BrtEndComment", */ T:-1 },
	0x027D: { /* n:"BrtCommentText", */ f:parse_BrtCommentText },
	0x027E: { /* n:"BrtBeginOleObjects", */ T:1 },
	0x027F: { /* n:"BrtOleObject" */ },
	0x0280: { /* n:"BrtEndOleObjects", */ T:-1 },
	0x0281: { /* n:"BrtBeginSxrules", */ T:1 },
	0x0282: { /* n:"BrtEndSxRules", */ T:-1 },
	0x0283: { /* n:"BrtBeginActiveXControls", */ T:1 },
	0x0284: { /* n:"BrtActiveX" */ },
	0x0285: { /* n:"BrtEndActiveXControls", */ T:-1 },
	0x0286: { /* n:"BrtBeginPCDSDTCEMembersSortBy", */ T:1 },
	0x0288: { /* n:"BrtBeginCellIgnoreECs", */ T:1 },
	0x0289: { /* n:"BrtCellIgnoreEC" */ },
	0x028A: { /* n:"BrtEndCellIgnoreECs", */ T:-1 },
	0x028B: { /* n:"BrtCsProp", */ f:parse_BrtCsProp },
	0x028C: { /* n:"BrtCsPageSetup" */ },
	0x028D: { /* n:"BrtBeginUserCsViews", */ T:1 },
	0x028E: { /* n:"BrtEndUserCsViews", */ T:-1 },
	0x028F: { /* n:"BrtBeginUserCsView", */ T:1 },
	0x0290: { /* n:"BrtEndUserCsView", */ T:-1 },
	0x0291: { /* n:"BrtBeginPcdSFCIEntries", */ T:1 },
	0x0292: { /* n:"BrtEndPCDSFCIEntries", */ T:-1 },
	0x0293: { /* n:"BrtPCDSFCIEntry" */ },
	0x0294: { /* n:"BrtBeginListParts", */ T:1 },
	0x0295: { /* n:"BrtListPart" */ },
	0x0296: { /* n:"BrtEndListParts", */ T:-1 },
	0x0297: { /* n:"BrtSheetCalcProp" */ },
	0x0298: { /* n:"BrtBeginFnGroup", */ T:1 },
	0x0299: { /* n:"BrtFnGroup" */ },
	0x029A: { /* n:"BrtEndFnGroup", */ T:-1 },
	0x029B: { /* n:"BrtSupAddin" */ },
	0x029C: { /* n:"BrtSXTDMPOrder" */ },
	0x029D: { /* n:"BrtCsProtection" */ },
	0x029F: { /* n:"BrtBeginWsSortMap", */ T:1 },
	0x02A0: { /* n:"BrtEndWsSortMap", */ T:-1 },
	0x02A1: { /* n:"BrtBeginRRSort", */ T:1 },
	0x02A2: { /* n:"BrtEndRRSort", */ T:-1 },
	0x02A3: { /* n:"BrtRRSortItem" */ },
	0x02A4: { /* n:"BrtFileSharingIso" */ },
	0x02A5: { /* n:"BrtBookProtectionIso" */ },
	0x02A6: { /* n:"BrtSheetProtectionIso" */ },
	0x02A7: { /* n:"BrtCsProtectionIso" */ },
	0x02A8: { /* n:"BrtRangeProtectionIso" */ },
	0x02A9: { /* n:"BrtDValList" */ },
	0x0400: { /* n:"BrtRwDescent" */ },
	0x0401: { /* n:"BrtKnownFonts" */ },
	0x0402: { /* n:"BrtBeginSXTupleSet", */ T:1 },
	0x0403: { /* n:"BrtEndSXTupleSet", */ T:-1 },
	0x0404: { /* n:"BrtBeginSXTupleSetHeader", */ T:1 },
	0x0405: { /* n:"BrtEndSXTupleSetHeader", */ T:-1 },
	0x0406: { /* n:"BrtSXTupleSetHeaderItem" */ },
	0x0407: { /* n:"BrtBeginSXTupleSetData", */ T:1 },
	0x0408: { /* n:"BrtEndSXTupleSetData", */ T:-1 },
	0x0409: { /* n:"BrtBeginSXTupleSetRow", */ T:1 },
	0x040A: { /* n:"BrtEndSXTupleSetRow", */ T:-1 },
	0x040B: { /* n:"BrtSXTupleSetRowItem" */ },
	0x040C: { /* n:"BrtNameExt" */ },
	0x040D: { /* n:"BrtPCDH14" */ },
	0x040E: { /* n:"BrtBeginPCDCalcMem14", */ T:1 },
	0x040F: { /* n:"BrtEndPCDCalcMem14", */ T:-1 },
	0x0410: { /* n:"BrtSXTH14" */ },
	0x0411: { /* n:"BrtBeginSparklineGroup", */ T:1 },
	0x0412: { /* n:"BrtEndSparklineGroup", */ T:-1 },
	0x0413: { /* n:"BrtSparkline" */ },
	0x0414: { /* n:"BrtSXDI14" */ },
	0x0415: { /* n:"BrtWsFmtInfoEx14" */ },
	0x0416: { /* n:"BrtBeginConditionalFormatting14", */ T:1 },
	0x0417: { /* n:"BrtEndConditionalFormatting14", */ T:-1 },
	0x0418: { /* n:"BrtBeginCFRule14", */ T:1 },
	0x0419: { /* n:"BrtEndCFRule14", */ T:-1 },
	0x041A: { /* n:"BrtCFVO14" */ },
	0x041B: { /* n:"BrtBeginDatabar14", */ T:1 },
	0x041C: { /* n:"BrtBeginIconSet14", */ T:1 },
	0x041D: { /* n:"BrtDVal14", */ f: parse_BrtDVal14 },
	0x041E: { /* n:"BrtBeginDVals14", */ T:1 },
	0x041F: { /* n:"BrtColor14" */ },
	0x0420: { /* n:"BrtBeginSparklines", */ T:1 },
	0x0421: { /* n:"BrtEndSparklines", */ T:-1 },
	0x0422: { /* n:"BrtBeginSparklineGroups", */ T:1 },
	0x0423: { /* n:"BrtEndSparklineGroups", */ T:-1 },
	0x0425: { /* n:"BrtSXVD14" */ },
	0x0426: { /* n:"BrtBeginSXView14", */ T:1 },
	0x0427: { /* n:"BrtEndSXView14", */ T:-1 },
	0x0428: { /* n:"BrtBeginSXView16", */ T:1 },
	0x0429: { /* n:"BrtEndSXView16", */ T:-1 },
	0x042A: { /* n:"BrtBeginPCD14", */ T:1 },
	0x042B: { /* n:"BrtEndPCD14", */ T:-1 },
	0x042C: { /* n:"BrtBeginExtConn14", */ T:1 },
	0x042D: { /* n:"BrtEndExtConn14", */ T:-1 },
	0x042E: { /* n:"BrtBeginSlicerCacheIDs", */ T:1 },
	0x042F: { /* n:"BrtEndSlicerCacheIDs", */ T:-1 },
	0x0430: { /* n:"BrtBeginSlicerCacheID", */ T:1 },
	0x0431: { /* n:"BrtEndSlicerCacheID", */ T:-1 },
	0x0433: { /* n:"BrtBeginSlicerCache", */ T:1 },
	0x0434: { /* n:"BrtEndSlicerCache", */ T:-1 },
	0x0435: { /* n:"BrtBeginSlicerCacheDef", */ T:1 },
	0x0436: { /* n:"BrtEndSlicerCacheDef", */ T:-1 },
	0x0437: { /* n:"BrtBeginSlicersEx", */ T:1 },
	0x0438: { /* n:"BrtEndSlicersEx", */ T:-1 },
	0x0439: { /* n:"BrtBeginSlicerEx", */ T:1 },
	0x043A: { /* n:"BrtEndSlicerEx", */ T:-1 },
	0x043B: { /* n:"BrtBeginSlicer", */ T:1 },
	0x043C: { /* n:"BrtEndSlicer", */ T:-1 },
	0x043D: { /* n:"BrtSlicerCachePivotTables" */ },
	0x043E: { /* n:"BrtBeginSlicerCacheOlapImpl", */ T:1 },
	0x043F: { /* n:"BrtEndSlicerCacheOlapImpl", */ T:-1 },
	0x0440: { /* n:"BrtBeginSlicerCacheLevelsData", */ T:1 },
	0x0441: { /* n:"BrtEndSlicerCacheLevelsData", */ T:-1 },
	0x0442: { /* n:"BrtBeginSlicerCacheLevelData", */ T:1 },
	0x0443: { /* n:"BrtEndSlicerCacheLevelData", */ T:-1 },
	0x0444: { /* n:"BrtBeginSlicerCacheSiRanges", */ T:1 },
	0x0445: { /* n:"BrtEndSlicerCacheSiRanges", */ T:-1 },
	0x0446: { /* n:"BrtBeginSlicerCacheSiRange", */ T:1 },
	0x0447: { /* n:"BrtEndSlicerCacheSiRange", */ T:-1 },
	0x0448: { /* n:"BrtSlicerCacheOlapItem" */ },
	0x0449: { /* n:"BrtBeginSlicerCacheSelections", */ T:1 },
	0x044A: { /* n:"BrtSlicerCacheSelection" */ },
	0x044B: { /* n:"BrtEndSlicerCacheSelections", */ T:-1 },
	0x044C: { /* n:"BrtBeginSlicerCacheNative", */ T:1 },
	0x044D: { /* n:"BrtEndSlicerCacheNative", */ T:-1 },
	0x044E: { /* n:"BrtSlicerCacheNativeItem" */ },
	0x044F: { /* n:"BrtRangeProtection14" */ },
	0x0450: { /* n:"BrtRangeProtectionIso14" */ },
	0x0451: { /* n:"BrtCellIgnoreEC14" */ },
	0x0457: { /* n:"BrtList14" */ },
	0x0458: { /* n:"BrtCFIcon" */ },
	0x0459: { /* n:"BrtBeginSlicerCachesPivotCacheIDs", */ T:1 },
	0x045A: { /* n:"BrtEndSlicerCachesPivotCacheIDs", */ T:-1 },
	0x045B: { /* n:"BrtBeginSlicers", */ T:1 },
	0x045C: { /* n:"BrtEndSlicers", */ T:-1 },
	0x045D: { /* n:"BrtWbProp14" */ },
	0x045E: { /* n:"BrtBeginSXEdit", */ T:1 },
	0x045F: { /* n:"BrtEndSXEdit", */ T:-1 },
	0x0460: { /* n:"BrtBeginSXEdits", */ T:1 },
	0x0461: { /* n:"BrtEndSXEdits", */ T:-1 },
	0x0462: { /* n:"BrtBeginSXChange", */ T:1 },
	0x0463: { /* n:"BrtEndSXChange", */ T:-1 },
	0x0464: { /* n:"BrtBeginSXChanges", */ T:1 },
	0x0465: { /* n:"BrtEndSXChanges", */ T:-1 },
	0x0466: { /* n:"BrtSXTupleItems" */ },
	0x0468: { /* n:"BrtBeginSlicerStyle", */ T:1 },
	0x0469: { /* n:"BrtEndSlicerStyle", */ T:-1 },
	0x046A: { /* n:"BrtSlicerStyleElement" */ },
	0x046B: { /* n:"BrtBeginStyleSheetExt14", */ T:1 },
	0x046C: { /* n:"BrtEndStyleSheetExt14", */ T:-1 },
	0x046D: { /* n:"BrtBeginSlicerCachesPivotCacheID", */ T:1 },
	0x046E: { /* n:"BrtEndSlicerCachesPivotCacheID", */ T:-1 },
	0x046F: { /* n:"BrtBeginConditionalFormattings", */ T:1 },
	0x0470: { /* n:"BrtEndConditionalFormattings", */ T:-1 },
	0x0471: { /* n:"BrtBeginPCDCalcMemExt", */ T:1 },
	0x0472: { /* n:"BrtEndPCDCalcMemExt", */ T:-1 },
	0x0473: { /* n:"BrtBeginPCDCalcMemsExt", */ T:1 },
	0x0474: { /* n:"BrtEndPCDCalcMemsExt", */ T:-1 },
	0x0475: { /* n:"BrtPCDField14" */ },
	0x0476: { /* n:"BrtBeginSlicerStyles", */ T:1 },
	0x0477: { /* n:"BrtEndSlicerStyles", */ T:-1 },
	0x0478: { /* n:"BrtBeginSlicerStyleElements", */ T:1 },
	0x0479: { /* n:"BrtEndSlicerStyleElements", */ T:-1 },
	0x047A: { /* n:"BrtCFRuleExt" */ },
	0x047B: { /* n:"BrtBeginSXCondFmt14", */ T:1 },
	0x047C: { /* n:"BrtEndSXCondFmt14", */ T:-1 },
	0x047D: { /* n:"BrtBeginSXCondFmts14", */ T:1 },
	0x047E: { /* n:"BrtEndSXCondFmts14", */ T:-1 },
	0x0480: { /* n:"BrtBeginSortCond14", */ T:1 },
	0x0481: { /* n:"BrtEndSortCond14", */ T:-1 },
	0x0482: { /* n:"BrtEndDVals14", */ T:-1 },
	0x0483: { /* n:"BrtEndIconSet14", */ T:-1 },
	0x0484: { /* n:"BrtEndDatabar14", */ T:-1 },
	0x0485: { /* n:"BrtBeginColorScale14", */ T:1 },
	0x0486: { /* n:"BrtEndColorScale14", */ T:-1 },
	0x0487: { /* n:"BrtBeginSxrules14", */ T:1 },
	0x0488: { /* n:"BrtEndSxrules14", */ T:-1 },
	0x0489: { /* n:"BrtBeginPRule14", */ T:1 },
	0x048A: { /* n:"BrtEndPRule14", */ T:-1 },
	0x048B: { /* n:"BrtBeginPRFilters14", */ T:1 },
	0x048C: { /* n:"BrtEndPRFilters14", */ T:-1 },
	0x048D: { /* n:"BrtBeginPRFilter14", */ T:1 },
	0x048E: { /* n:"BrtEndPRFilter14", */ T:-1 },
	0x048F: { /* n:"BrtBeginPRFItem14", */ T:1 },
	0x0490: { /* n:"BrtEndPRFItem14", */ T:-1 },
	0x0491: { /* n:"BrtBeginCellIgnoreECs14", */ T:1 },
	0x0492: { /* n:"BrtEndCellIgnoreECs14", */ T:-1 },
	0x0493: { /* n:"BrtDxf14" */ },
	0x0494: { /* n:"BrtBeginDxF14s", */ T:1 },
	0x0495: { /* n:"BrtEndDxf14s", */ T:-1 },
	0x0499: { /* n:"BrtFilter14" */ },
	0x049A: { /* n:"BrtBeginCustomFilters14", */ T:1 },
	0x049C: { /* n:"BrtCustomFilter14" */ },
	0x049D: { /* n:"BrtIconFilter14" */ },
	0x049E: { /* n:"BrtPivotCacheConnectionName" */ },
	0x0800: { /* n:"BrtBeginDecoupledPivotCacheIDs", */ T:1 },
	0x0801: { /* n:"BrtEndDecoupledPivotCacheIDs", */ T:-1 },
	0x0802: { /* n:"BrtDecoupledPivotCacheID" */ },
	0x0803: { /* n:"BrtBeginPivotTableRefs", */ T:1 },
	0x0804: { /* n:"BrtEndPivotTableRefs", */ T:-1 },
	0x0805: { /* n:"BrtPivotTableRef" */ },
	0x0806: { /* n:"BrtSlicerCacheBookPivotTables" */ },
	0x0807: { /* n:"BrtBeginSxvcells", */ T:1 },
	0x0808: { /* n:"BrtEndSxvcells", */ T:-1 },
	0x0809: { /* n:"BrtBeginSxRow", */ T:1 },
	0x080A: { /* n:"BrtEndSxRow", */ T:-1 },
	0x080C: { /* n:"BrtPcdCalcMem15" */ },
	0x0813: { /* n:"BrtQsi15" */ },
	0x0814: { /* n:"BrtBeginWebExtensions", */ T:1 },
	0x0815: { /* n:"BrtEndWebExtensions", */ T:-1 },
	0x0816: { /* n:"BrtWebExtension" */ },
	0x0817: { /* n:"BrtAbsPath15" */ },
	0x0818: { /* n:"BrtBeginPivotTableUISettings", */ T:1 },
	0x0819: { /* n:"BrtEndPivotTableUISettings", */ T:-1 },
	0x081B: { /* n:"BrtTableSlicerCacheIDs" */ },
	0x081C: { /* n:"BrtTableSlicerCacheID" */ },
	0x081D: { /* n:"BrtBeginTableSlicerCache", */ T:1 },
	0x081E: { /* n:"BrtEndTableSlicerCache", */ T:-1 },
	0x081F: { /* n:"BrtSxFilter15" */ },
	0x0820: { /* n:"BrtBeginTimelineCachePivotCacheIDs", */ T:1 },
	0x0821: { /* n:"BrtEndTimelineCachePivotCacheIDs", */ T:-1 },
	0x0822: { /* n:"BrtTimelineCachePivotCacheID" */ },
	0x0823: { /* n:"BrtBeginTimelineCacheIDs", */ T:1 },
	0x0824: { /* n:"BrtEndTimelineCacheIDs", */ T:-1 },
	0x0825: { /* n:"BrtBeginTimelineCacheID", */ T:1 },
	0x0826: { /* n:"BrtEndTimelineCacheID", */ T:-1 },
	0x0827: { /* n:"BrtBeginTimelinesEx", */ T:1 },
	0x0828: { /* n:"BrtEndTimelinesEx", */ T:-1 },
	0x0829: { /* n:"BrtBeginTimelineEx", */ T:1 },
	0x082A: { /* n:"BrtEndTimelineEx", */ T:-1 },
	0x082B: { /* n:"BrtWorkBookPr15" */ },
	0x082C: { /* n:"BrtPCDH15" */ },
	0x082D: { /* n:"BrtBeginTimelineStyle", */ T:1 },
	0x082E: { /* n:"BrtEndTimelineStyle", */ T:-1 },
	0x082F: { /* n:"BrtTimelineStyleElement" */ },
	0x0830: { /* n:"BrtBeginTimelineStylesheetExt15", */ T:1 },
	0x0831: { /* n:"BrtEndTimelineStylesheetExt15", */ T:-1 },
	0x0832: { /* n:"BrtBeginTimelineStyles", */ T:1 },
	0x0833: { /* n:"BrtEndTimelineStyles", */ T:-1 },
	0x0834: { /* n:"BrtBeginTimelineStyleElements", */ T:1 },
	0x0835: { /* n:"BrtEndTimelineStyleElements", */ T:-1 },
	0x0836: { /* n:"BrtDxf15" */ },
	0x0837: { /* n:"BrtBeginDxfs15", */ T:1 },
	0x0838: { /* n:"BrtEndDxfs15", */ T:-1 },
	0x0839: { /* n:"BrtSlicerCacheHideItemsWithNoData" */ },
	0x083A: { /* n:"BrtBeginItemUniqueNames", */ T:1 },
	0x083B: { /* n:"BrtEndItemUniqueNames", */ T:-1 },
	0x083C: { /* n:"BrtItemUniqueName" */ },
	0x083D: { /* n:"BrtBeginExtConn15", */ T:1 },
	0x083E: { /* n:"BrtEndExtConn15", */ T:-1 },
	0x083F: { /* n:"BrtBeginOledbPr15", */ T:1 },
	0x0840: { /* n:"BrtEndOledbPr15", */ T:-1 },
	0x0841: { /* n:"BrtBeginDataFeedPr15", */ T:1 },
	0x0842: { /* n:"BrtEndDataFeedPr15", */ T:-1 },
	0x0843: { /* n:"BrtTextPr15" */ },
	0x0844: { /* n:"BrtRangePr15" */ },
	0x0845: { /* n:"BrtDbCommand15" */ },
	0x0846: { /* n:"BrtBeginDbTables15", */ T:1 },
	0x0847: { /* n:"BrtEndDbTables15", */ T:-1 },
	0x0848: { /* n:"BrtDbTable15" */ },
	0x0849: { /* n:"BrtBeginDataModel", */ T:1 },
	0x084A: { /* n:"BrtEndDataModel", */ T:-1 },
	0x084B: { /* n:"BrtBeginModelTables", */ T:1 },
	0x084C: { /* n:"BrtEndModelTables", */ T:-1 },
	0x084D: { /* n:"BrtModelTable" */ },
	0x084E: { /* n:"BrtBeginModelRelationships", */ T:1 },
	0x084F: { /* n:"BrtEndModelRelationships", */ T:-1 },
	0x0850: { /* n:"BrtModelRelationship" */ },
	0x0851: { /* n:"BrtBeginECTxtWiz15", */ T:1 },
	0x0852: { /* n:"BrtEndECTxtWiz15", */ T:-1 },
	0x0853: { /* n:"BrtBeginECTWFldInfoLst15", */ T:1 },
	0x0854: { /* n:"BrtEndECTWFldInfoLst15", */ T:-1 },
	0x0855: { /* n:"BrtBeginECTWFldInfo15", */ T:1 },
	0x0856: { /* n:"BrtFieldListActiveItem" */ },
	0x0857: { /* n:"BrtPivotCacheIdVersion" */ },
	0x0858: { /* n:"BrtSXDI15" */ },
	0x0859: { /* n:"BrtBeginModelTimeGroupings", */ T:1 },
	0x085A: { /* n:"BrtEndModelTimeGroupings", */ T:-1 },
	0x085B: { /* n:"BrtBeginModelTimeGrouping", */ T:1 },
	0x085C: { /* n:"BrtEndModelTimeGrouping", */ T:-1 },
	0x085D: { /* n:"BrtModelTimeGroupingCalcCol" */ },
	0x0C00: { /* n:"BrtUid" */ },
	0x0C01: { /* n:"BrtRevisionPtr" */ },
	0x1000: { /* n:"BrtBeginDynamicArrayPr", */ T:1 },
	0x1001: { /* n:"BrtEndDynamicArrayPr", */ T:-1 },
	0x138A: { /* n:"BrtBeginRichValueBlock", */ T:1 },
	0x138B: { /* n:"BrtEndRichValueBlock", */ T:-1 },
	0x13D9: { /* n:"BrtBeginRichFilters", */ T:1 },
	0x13DA: { /* n:"BrtEndRichFilters", */ T:-1 },
	0x13DB: { /* n:"BrtRichFilter" */ },
	0x13DC: { /* n:"BrtBeginRichFilterColumn", */ T:1 },
	0x13DD: { /* n:"BrtEndRichFilterColumn", */ T:-1 },
	0x13DE: { /* n:"BrtBeginCustomRichFilters", */ T:1 },
	0x13DF: { /* n:"BrtEndCustomRichFilters", */ T:-1 },
	0x13E0: { /* n:"BrtCustomRichFilter" */ },
	0x13E1: { /* n:"BrtTop10RichFilter" */ },
	0x13E2: { /* n:"BrtDynamicRichFilter" */ },
	0x13E4: { /* n:"BrtBeginRichSortCondition", */ T:1 },
	0x13E5: { /* n:"BrtEndRichSortCondition", */ T:-1 },
	0x13E6: { /* n:"BrtRichFilterDateGroupItem" */ },
	0x13E7: { /* n:"BrtBeginCalcFeatures", */ T:1 },
	0x13E8: { /* n:"BrtEndCalcFeatures", */ T:-1 },
	0x13E9: { /* n:"BrtCalcFeature" */ },
	0x13EB: { /* n:"BrtExternalLinksPr" */ },
	0xFFFF: { n:"" }
	};
	
	/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
	var XLSRecordEnum = {
		/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
	0x0006: { /* n:"Formula", */ f:parse_Formula },
	0x000a: { /* n:"EOF", */ f:parsenoop2 },
	0x000c: { /* n:"CalcCount", */ f:parseuint16 }, //
	0x000d: { /* n:"CalcMode", */ f:parseuint16 }, //
	0x000e: { /* n:"CalcPrecision", */ f:parsebool }, //
	0x000f: { /* n:"CalcRefMode", */ f:parsebool }, //
	0x0010: { /* n:"CalcDelta", */ f:parse_Xnum }, //
	0x0011: { /* n:"CalcIter", */ f:parsebool }, //
	0x0012: { /* n:"Protect", */ f:parsebool },
	0x0013: { /* n:"Password", */ f:parseuint16 },
	0x0014: { /* n:"Header", */ f:parse_XLHeaderFooter },
	0x0015: { /* n:"Footer", */ f:parse_XLHeaderFooter },
	0x0017: { /* n:"ExternSheet", */ f:parse_ExternSheet },
	0x0018: { /* n:"Lbl", */ f:parse_Lbl },
	0x0019: { /* n:"WinProtect", */ f:parsebool },
	0x001a: { /* n:"VerticalPageBreaks", */ },
	0x001b: { /* n:"HorizontalPageBreaks", */ },
	0x001c: { /* n:"Note", */ f:parse_Note },
	0x001d: { /* n:"Selection", */ },
	0x0022: { /* n:"Date1904", */ f:parsebool },
	0x0023: { /* n:"ExternName", */ f:parse_ExternName },
	0x0026: { /* n:"LeftMargin", */ f:parse_Xnum }, // *
	0x0027: { /* n:"RightMargin", */ f:parse_Xnum }, // *
	0x0028: { /* n:"TopMargin", */ f:parse_Xnum }, // *
	0x0029: { /* n:"BottomMargin", */ f:parse_Xnum }, // *
	0x002a: { /* n:"PrintRowCol", */ f:parsebool },
	0x002b: { /* n:"PrintGrid", */ f:parsebool },
	0x002f: { /* n:"FilePass", */ f:parse_FilePass },
	0x0031: { /* n:"Font", */ f:parse_Font },
	0x0033: { /* n:"PrintSize", */ f:parseuint16 },
	0x003c: { /* n:"Continue", */ },
	0x003d: { /* n:"Window1", */ f:parse_Window1 },
	0x0040: { /* n:"Backup", */ f:parsebool },
	0x0041: { /* n:"Pane", */ f:parse_Pane },
	0x0042: { /* n:"CodePage", */ f:parseuint16 },
	0x004d: { /* n:"Pls", */ },
	0x0050: { /* n:"DCon", */ },
	0x0051: { /* n:"DConRef", */ },
	0x0052: { /* n:"DConName", */ },
	0x0055: { /* n:"DefColWidth", */ f:parseuint16 },
	0x0059: { /* n:"XCT", */ },
	0x005a: { /* n:"CRN", */ },
	0x005b: { /* n:"FileSharing", */ },
	0x005c: { /* n:"WriteAccess", */ f:parse_WriteAccess },
	0x005d: { /* n:"Obj", */ f:parse_Obj },
	0x005e: { /* n:"Uncalced", */ },
	0x005f: { /* n:"CalcSaveRecalc", */ f:parsebool }, //
	0x0060: { /* n:"Template", */ },
	0x0061: { /* n:"Intl", */ },
	0x0063: { /* n:"ObjProtect", */ f:parsebool },
	0x007d: { /* n:"ColInfo", */ f:parse_ColInfo },
	0x0080: { /* n:"Guts", */ f:parse_Guts },
	0x0081: { /* n:"WsBool", */ f:parse_WsBool },
	0x0082: { /* n:"GridSet", */ f:parseuint16 },
	0x0083: { /* n:"HCenter", */ f:parsebool },
	0x0084: { /* n:"VCenter", */ f:parsebool },
	0x0085: { /* n:"BoundSheet8", */ f:parse_BoundSheet8 },
	0x0086: { /* n:"WriteProtect", */ },
	0x008c: { /* n:"Country", */ f:parse_Country },
	0x008d: { /* n:"HideObj", */ f:parseuint16 },
	0x0090: { /* n:"Sort", */ },
	0x0092: { /* n:"Palette", */ f:parse_Palette },
	0x0097: { /* n:"Sync", */ },
	0x0098: { /* n:"LPr", */ },
	0x0099: { /* n:"DxGCol", */ },
	0x009a: { /* n:"FnGroupName", */ },
	0x009b: { /* n:"FilterMode", */ },
	0x009c: { /* n:"BuiltInFnGroupCount", */ f:parseuint16 },
	0x009d: { /* n:"AutoFilterInfo", */ },
	0x009e: { /* n:"AutoFilter", */ },
	0x00a0: { /* n:"Scl", */ f:parse_Scl },
	0x00a1: { /* n:"Setup", */ f:parse_Setup },
	0x00ae: { /* n:"ScenMan", */ },
	0x00af: { /* n:"SCENARIO", */ },
	0x00b0: { /* n:"SxView", */ },
	0x00b1: { /* n:"Sxvd", */ },
	0x00b2: { /* n:"SXVI", */ },
	0x00b4: { /* n:"SxIvd", */ },
	0x00b5: { /* n:"SXLI", */ },
	0x00b6: { /* n:"SXPI", */ },
	0x00b8: { /* n:"DocRoute", */ },
	0x00b9: { /* n:"RecipName", */ },
	0x00bd: { /* n:"MulRk", */ f:parse_MulRk },
	0x00be: { /* n:"MulBlank", */ f:parse_MulBlank },
	0x00c1: { /* n:"Mms", */ f:parsenoop2 },
	0x00c5: { /* n:"SXDI", */ },
	0x00c6: { /* n:"SXDB", */ },
	0x00c7: { /* n:"SXFDB", */ },
	0x00c8: { /* n:"SXDBB", */ },
	0x00c9: { /* n:"SXNum", */ },
	0x00ca: { /* n:"SxBool", */ f:parsebool },
	0x00cb: { /* n:"SxErr", */ },
	0x00cc: { /* n:"SXInt", */ },
	0x00cd: { /* n:"SXString", */ },
	0x00ce: { /* n:"SXDtr", */ },
	0x00cf: { /* n:"SxNil", */ },
	0x00d0: { /* n:"SXTbl", */ },
	0x00d1: { /* n:"SXTBRGIITM", */ },
	0x00d2: { /* n:"SxTbpg", */ },
	0x00d3: { /* n:"ObProj", */ },
	0x00d5: { /* n:"SXStreamID", */ },
	0x00d7: { /* n:"DBCell", */ },
	0x00d8: { /* n:"SXRng", */ },
	0x00d9: { /* n:"SxIsxoper", */ },
	0x00da: { /* n:"BookBool", */ f:parseuint16 },
	0x00dc: { /* n:"DbOrParamQry", */ },
	0x00dd: { /* n:"ScenarioProtect", */ f:parsebool },
	0x00de: { /* n:"OleObjectSize", */ },
	0x00e0: { /* n:"XF", */ f:parse_XF },
	0x00e1: { /* n:"InterfaceHdr", */ f:parse_InterfaceHdr },
	0x00e2: { /* n:"InterfaceEnd", */ f:parsenoop2 },
	0x00e3: { /* n:"SXVS", */ },
	0x00e5: { /* n:"MergeCells", */ f:parse_MergeCells },
	0x00e9: { /* n:"BkHim", */ },
	0x00eb: { /* n:"MsoDrawingGroup", */ },
	0x00ec: { /* n:"MsoDrawing", */ },
	0x00ed: { /* n:"MsoDrawingSelection", */ },
	0x00ef: { /* n:"PhoneticInfo", */ },
	0x00f0: { /* n:"SxRule", */ },
	0x00f1: { /* n:"SXEx", */ },
	0x00f2: { /* n:"SxFilt", */ },
	0x00f4: { /* n:"SxDXF", */ },
	0x00f5: { /* n:"SxItm", */ },
	0x00f6: { /* n:"SxName", */ },
	0x00f7: { /* n:"SxSelect", */ },
	0x00f8: { /* n:"SXPair", */ },
	0x00f9: { /* n:"SxFmla", */ },
	0x00fb: { /* n:"SxFormat", */ },
	0x00fc: { /* n:"SST", */ f:parse_SST },
	0x00fd: { /* n:"LabelSst", */ f:parse_LabelSst },
	0x00ff: { /* n:"ExtSST", */ f:parse_ExtSST },
	0x0100: { /* n:"SXVDEx", */ },
	0x0103: { /* n:"SXFormula", */ },
	0x0122: { /* n:"SXDBEx", */ },
	0x0137: { /* n:"RRDInsDel", */ },
	0x0138: { /* n:"RRDHead", */ },
	0x013b: { /* n:"RRDChgCell", */ },
	0x013d: { /* n:"RRTabId", */ f:parseuint16a },
	0x013e: { /* n:"RRDRenSheet", */ },
	0x013f: { /* n:"RRSort", */ },
	0x0140: { /* n:"RRDMove", */ },
	0x014a: { /* n:"RRFormat", */ },
	0x014b: { /* n:"RRAutoFmt", */ },
	0x014d: { /* n:"RRInsertSh", */ },
	0x014e: { /* n:"RRDMoveBegin", */ },
	0x014f: { /* n:"RRDMoveEnd", */ },
	0x0150: { /* n:"RRDInsDelBegin", */ },
	0x0151: { /* n:"RRDInsDelEnd", */ },
	0x0152: { /* n:"RRDConflict", */ },
	0x0153: { /* n:"RRDDefName", */ },
	0x0154: { /* n:"RRDRstEtxp", */ },
	0x015f: { /* n:"LRng", */ },
	0x0160: { /* n:"UsesELFs", */ f:parsebool },
	0x0161: { /* n:"DSF", */ f:parsenoop2 },
	0x0191: { /* n:"CUsr", */ },
	0x0192: { /* n:"CbUsr", */ },
	0x0193: { /* n:"UsrInfo", */ },
	0x0194: { /* n:"UsrExcl", */ },
	0x0195: { /* n:"FileLock", */ },
	0x0196: { /* n:"RRDInfo", */ },
	0x0197: { /* n:"BCUsrs", */ },
	0x0198: { /* n:"UsrChk", */ },
	0x01a9: { /* n:"UserBView", */ },
	0x01aa: { /* n:"UserSViewBegin", */ },
	0x01ab: { /* n:"UserSViewEnd", */ },
	0x01ac: { /* n:"RRDUserView", */ },
	0x01ad: { /* n:"Qsi", */ },
	0x01ae: { /* n:"SupBook", */ f:parse_SupBook },
	0x01af: { /* n:"Prot4Rev", */ f:parsebool },
	0x01b0: { /* n:"CondFmt", */ },
	0x01b1: { /* n:"CF", */ },
	0x01b2: { /* n:"DVal", */ },
	0x01b5: { /* n:"DConBin", */ },
	0x01b6: { /* n:"TxO", */ f:parse_TxO },
	0x01b7: { /* n:"RefreshAll", */ f:parsebool }, //
	0x01b8: { /* n:"HLink", */ f:parse_HLink },
	0x01b9: { /* n:"Lel", */ },
	0x01ba: { /* n:"CodeName", */ f:parse_XLUnicodeString },
	0x01bb: { /* n:"SXFDBType", */ },
	0x01bc: { /* n:"Prot4RevPass", */ f:parseuint16 },
	0x01bd: { /* n:"ObNoMacros", */ },
	0x01be: { /* n:"Dv", */ },
	0x01c0: { /* n:"Excel9File", */ f:parsenoop2 },
	0x01c1: { /* n:"RecalcId", */ f:parse_RecalcId, r:2},
	0x01c2: { /* n:"EntExU2", */ f:parsenoop2 },
	0x0200: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0201: { /* n:"Blank", */ f:parse_Blank },
	0x0203: { /* n:"Number", */ f:parse_Number },
	0x0204: { /* n:"Label", */ f:parse_Label },
	0x0205: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0207: { /* n:"String", */ f:parse_String },
	0x0208: { /* n:"Row", */ f:parse_Row },
	0x020b: { /* n:"Index", */ },
	0x0221: { /* n:"Array", */ f:parse_Array },
	0x0225: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
	0x0236: { /* n:"Table", */ },
	0x023e: { /* n:"Window2", */ f:parse_Window2 },
	0x027e: { /* n:"RK", */ f:parse_RK },
	0x0293: { /* n:"Style", */ },
	0x0418: { /* n:"BigName", */ },
	0x041e: { /* n:"Format", */ f:parse_Format },
	0x043c: { /* n:"ContinueBigName", */ },
	0x04bc: { /* n:"ShrFmla", */ f:parse_ShrFmla },
	0x0800: { /* n:"HLinkTooltip", */ f:parse_HLinkTooltip },
	0x0801: { /* n:"WebPub", */ },
	0x0802: { /* n:"QsiSXTag", */ },
	0x0803: { /* n:"DBQueryExt", */ },
	0x0804: { /* n:"ExtString", */ },
	0x0805: { /* n:"TxtQry", */ },
	0x0806: { /* n:"Qsir", */ },
	0x0807: { /* n:"Qsif", */ },
	0x0808: { /* n:"RRDTQSIF", */ },
	0x0809: { /* n:"BOF", */ f:parse_BOF },
	0x080a: { /* n:"OleDbConn", */ },
	0x080b: { /* n:"WOpt", */ },
	0x080c: { /* n:"SXViewEx", */ },
	0x080d: { /* n:"SXTH", */ },
	0x080e: { /* n:"SXPIEx", */ },
	0x080f: { /* n:"SXVDTEx", */ },
	0x0810: { /* n:"SXViewEx9", */ },
	0x0812: { /* n:"ContinueFrt", */ },
	0x0813: { /* n:"RealTimeData", */ },
	0x0850: { /* n:"ChartFrtInfo", */ },
	0x0851: { /* n:"FrtWrapper", */ },
	0x0852: { /* n:"StartBlock", */ },
	0x0853: { /* n:"EndBlock", */ },
	0x0854: { /* n:"StartObject", */ },
	0x0855: { /* n:"EndObject", */ },
	0x0856: { /* n:"CatLab", */ },
	0x0857: { /* n:"YMult", */ },
	0x0858: { /* n:"SXViewLink", */ },
	0x0859: { /* n:"PivotChartBits", */ },
	0x085a: { /* n:"FrtFontList", */ },
	0x0862: { /* n:"SheetExt", */ },
	0x0863: { /* n:"BookExt", */ r:12},
	0x0864: { /* n:"SXAddl", */ },
	0x0865: { /* n:"CrErr", */ },
	0x0866: { /* n:"HFPicture", */ },
	0x0867: { /* n:"FeatHdr", */ f:parsenoop2 },
	0x0868: { /* n:"Feat", */ },
	0x086a: { /* n:"DataLabExt", */ },
	0x086b: { /* n:"DataLabExtContents", */ },
	0x086c: { /* n:"CellWatch", */ },
	0x0871: { /* n:"FeatHdr11", */ },
	0x0872: { /* n:"Feature11", */ },
	0x0874: { /* n:"DropDownObjIds", */ },
	0x0875: { /* n:"ContinueFrt11", */ },
	0x0876: { /* n:"DConn", */ },
	0x0877: { /* n:"List12", */ },
	0x0878: { /* n:"Feature12", */ },
	0x0879: { /* n:"CondFmt12", */ },
	0x087a: { /* n:"CF12", */ },
	0x087b: { /* n:"CFEx", */ },
	0x087c: { /* n:"XFCRC", */ f:parse_XFCRC, r:12 },
	0x087d: { /* n:"XFExt", */ f:parse_XFExt, r:12 },
	0x087e: { /* n:"AutoFilter12", */ },
	0x087f: { /* n:"ContinueFrt12", */ },
	0x0884: { /* n:"MDTInfo", */ },
	0x0885: { /* n:"MDXStr", */ },
	0x0886: { /* n:"MDXTuple", */ },
	0x0887: { /* n:"MDXSet", */ },
	0x0888: { /* n:"MDXProp", */ },
	0x0889: { /* n:"MDXKPI", */ },
	0x088a: { /* n:"MDB", */ },
	0x088b: { /* n:"PLV", */ },
	0x088c: { /* n:"Compat12", */ f:parsebool, r:12 },
	0x088d: { /* n:"DXF", */ },
	0x088e: { /* n:"TableStyles", */ r:12 },
	0x088f: { /* n:"TableStyle", */ },
	0x0890: { /* n:"TableStyleElement", */ },
	0x0892: { /* n:"StyleExt", */ },
	0x0893: { /* n:"NamePublish", */ },
	0x0894: { /* n:"NameCmt", */ f:parse_NameCmt, r:12 },
	0x0895: { /* n:"SortData", */ },
	0x0896: { /* n:"Theme", */ f:parse_Theme, r:12 },
	0x0897: { /* n:"GUIDTypeLib", */ },
	0x0898: { /* n:"FnGrp12", */ },
	0x0899: { /* n:"NameFnGrp12", */ },
	0x089a: { /* n:"MTRSettings", */ f:parse_MTRSettings, r:12 },
	0x089b: { /* n:"CompressPictures", */ f:parsenoop2 },
	0x089c: { /* n:"HeaderFooter", */ },
	0x089d: { /* n:"CrtLayout12", */ },
	0x089e: { /* n:"CrtMlFrt", */ },
	0x089f: { /* n:"CrtMlFrtContinue", */ },
	0x08a3: { /* n:"ForceFullCalculation", */ f:parse_ForceFullCalculation },
	0x08a4: { /* n:"ShapePropsStream", */ },
	0x08a5: { /* n:"TextPropsStream", */ },
	0x08a6: { /* n:"RichTextStream", */ },
	0x08a7: { /* n:"CrtLayout12A", */ },
	0x1001: { /* n:"Units", */ },
	0x1002: { /* n:"Chart", */ },
	0x1003: { /* n:"Series", */ },
	0x1006: { /* n:"DataFormat", */ },
	0x1007: { /* n:"LineFormat", */ },
	0x1009: { /* n:"MarkerFormat", */ },
	0x100a: { /* n:"AreaFormat", */ },
	0x100b: { /* n:"PieFormat", */ },
	0x100c: { /* n:"AttachedLabel", */ },
	0x100d: { /* n:"SeriesText", */ },
	0x1014: { /* n:"ChartFormat", */ },
	0x1015: { /* n:"Legend", */ },
	0x1016: { /* n:"SeriesList", */ },
	0x1017: { /* n:"Bar", */ },
	0x1018: { /* n:"Line", */ },
	0x1019: { /* n:"Pie", */ },
	0x101a: { /* n:"Area", */ },
	0x101b: { /* n:"Scatter", */ },
	0x101c: { /* n:"CrtLine", */ },
	0x101d: { /* n:"Axis", */ },
	0x101e: { /* n:"Tick", */ },
	0x101f: { /* n:"ValueRange", */ },
	0x1020: { /* n:"CatSerRange", */ },
	0x1021: { /* n:"AxisLine", */ },
	0x1022: { /* n:"CrtLink", */ },
	0x1024: { /* n:"DefaultText", */ },
	0x1025: { /* n:"Text", */ },
	0x1026: { /* n:"FontX", */ f:parseuint16 },
	0x1027: { /* n:"ObjectLink", */ },
	0x1032: { /* n:"Frame", */ },
	0x1033: { /* n:"Begin", */ },
	0x1034: { /* n:"End", */ },
	0x1035: { /* n:"PlotArea", */ },
	0x103a: { /* n:"Chart3d", */ },
	0x103c: { /* n:"PicF", */ },
	0x103d: { /* n:"DropBar", */ },
	0x103e: { /* n:"Radar", */ },
	0x103f: { /* n:"Surf", */ },
	0x1040: { /* n:"RadarArea", */ },
	0x1041: { /* n:"AxisParent", */ },
	0x1043: { /* n:"LegendException", */ },
	0x1044: { /* n:"ShtProps", */ f:parse_ShtProps },
	0x1045: { /* n:"SerToCrt", */ },
	0x1046: { /* n:"AxesUsed", */ },
	0x1048: { /* n:"SBaseRef", */ },
	0x104a: { /* n:"SerParent", */ },
	0x104b: { /* n:"SerAuxTrend", */ },
	0x104e: { /* n:"IFmtRecord", */ },
	0x104f: { /* n:"Pos", */ },
	0x1050: { /* n:"AlRuns", */ },
	0x1051: { /* n:"BRAI", */ },
	0x105b: { /* n:"SerAuxErrBar", */ },
	0x105c: { /* n:"ClrtClient", */ f:parse_ClrtClient },
	0x105d: { /* n:"SerFmt", */ },
	0x105f: { /* n:"Chart3DBarShape", */ },
	0x1060: { /* n:"Fbi", */ },
	0x1061: { /* n:"BopPop", */ },
	0x1062: { /* n:"AxcExt", */ },
	0x1063: { /* n:"Dat", */ },
	0x1064: { /* n:"PlotGrowth", */ },
	0x1065: { /* n:"SIIndex", */ },
	0x1066: { /* n:"GelFrame", */ },
	0x1067: { /* n:"BopPopCustom", */ },
	0x1068: { /* n:"Fbi2", */ },
	
	0x0000: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0001: { /* n:"BIFF2BLANK", */ },
	0x0002: { /* n:"BIFF2INT", */ f:parse_BIFF2INT },
	0x0003: { /* n:"BIFF2NUM", */ f:parse_BIFF2NUM },
	0x0004: { /* n:"BIFF2STR", */ f:parse_BIFF2STR },
	0x0005: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0007: { /* n:"String", */ f:parse_BIFF2STRING },
	0x0008: { /* n:"BIFF2ROW", */ },
	0x0009: { /* n:"BOF", */ f:parse_BOF },
	0x000b: { /* n:"Index", */ },
	0x0016: { /* n:"ExternCount", */ f:parseuint16 },
	0x001e: { /* n:"BIFF2FORMAT", */ f:parse_BIFF2Format },
	0x001f: { /* n:"BIFF2FMTCNT", */ }, /* 16-bit cnt of BIFF2FORMAT records */
	0x0020: { /* n:"BIFF2COLINFO", */ },
	0x0021: { /* n:"Array", */ f:parse_Array },
	0x0024: { /* n:"COLWIDTH", */ },
	0x0025: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
		// 0x2c ??
		// 0x2d ??
		// 0x2e ??
		// 0x30 FONTCOUNT: number of fonts
	0x0032: { /* n:"BIFF2FONTXTRA", */ f:parse_BIFF2FONTXTRA },
		// 0x35: INFOOPTS
		// 0x36: TABLE (BIFF2 only)
		// 0x37: TABLE2 (BIFF2 only)
		// 0x38: WNDESK
		// 0x39 ??
		// 0x3a: BEGINPREF
		// 0x3b: ENDPREF
	0x003e: { /* n:"BIFF2WINDOW2", */ },
		// 0x3f ??
		// 0x46: SHOWSCROLL
		// 0x47: SHOWFORMULA
		// 0x48: STATUSBAR
		// 0x49: SHORTMENUS
		// 0x4A:
		// 0x4B:
		// 0x4C:
		// 0x4E:
		// 0x4F:
		// 0x58: TOOLBAR (BIFF3)
	
		/* - - - */
	0x0034: { /* n:"DDEObjName", */ },
	0x0043: { /* n:"BIFF2XF", */ },
	0x0044: { /* n:"BIFF2XFINDEX", */ f:parseuint16 },
	0x0045: { /* n:"BIFF2FONTCLR", */ },
	0x0056: { /* n:"BIFF4FMTCNT", */ }, /* 16-bit cnt, similar to BIFF2 */
	0x007e: { /* n:"RK", */ }, /* Not necessarily same as 0x027e */
	0x007f: { /* n:"ImData", */ f:parse_ImData },
	0x0087: { /* n:"Addin", */ },
	0x0088: { /* n:"Edg", */ },
	0x0089: { /* n:"Pub", */ },
		// 0x8A
		// 0x8B LH: alternate menu key flag (BIFF3/4)
		// 0x8E
		// 0x8F
	0x0091: { /* n:"Sub", */ },
		// 0x93 STYLE
	0x0094: { /* n:"LHRecord", */ },
	0x0095: { /* n:"LHNGraph", */ },
	0x0096: { /* n:"Sound", */ },
		// 0xA2 FNPROTO: function prototypes (BIFF4)
		// 0xA3
		// 0xA8
	0x00a9: { /* n:"CoordList", */ },
	0x00ab: { /* n:"GCW", */ },
	0x00bc: { /* n:"ShrFmla", */ }, /* Not necessarily same as 0x04bc */
	0x00bf: { /* n:"ToolbarHdr", */ },
	0x00c0: { /* n:"ToolbarEnd", */ },
	0x00c2: { /* n:"AddMenu", */ },
	0x00c3: { /* n:"DelMenu", */ },
	0x00d6: { /* n:"RString", */ f:parse_RString },
	0x00df: { /* n:"UDDesc", */ },
	0x00ea: { /* n:"TabIdConf", */ },
	0x0162: { /* n:"XL5Modify", */ },
	0x01a5: { /* n:"FileSharing2", */ },
	0x0206: { /* n:"Formula", */ f:parse_Formula },
	0x0209: { /* n:"BOF", */ f:parse_BOF },
	0x0218: { /* n:"Lbl", */ f:parse_Lbl },
	0x0223: { /* n:"ExternName", */ f:parse_ExternName },
	0x0231: { /* n:"Font", */ },
	0x0243: { /* n:"BIFF3XF", */ },
	0x0406: { /* n:"Formula", */ f:parse_Formula },
	0x0409: { /* n:"BOF", */ f:parse_BOF },
	0x0443: { /* n:"BIFF4XF", */ },
	0x086d: { /* n:"FeatInfo", */ },
	0x0873: { /* n:"FeatInfo11", */ },
	0x0881: { /* n:"SXAddl12", */ },
	0x08c0: { /* n:"AutoWebPub", */ },
	0x08c1: { /* n:"ListObj", */ },
	0x08c2: { /* n:"ListField", */ },
	0x08c3: { /* n:"ListDV", */ },
	0x08c4: { /* n:"ListCondFmt", */ },
	0x08c5: { /* n:"ListCF", */ },
	0x08c6: { /* n:"FMQry", */ },
	0x08c7: { /* n:"FMSQry", */ },
	0x08c8: { /* n:"PLV", */ },
	0x08c9: { /* n:"LnExt", */ },
	0x08ca: { /* n:"MkrExt", */ },
	0x08cb: { /* n:"CrtCoopt", */ },
	0x08d6: { /* n:"FRTArchId$", */ r:12 },
	
	0x7262: {}
	};
	
	function write_biff_rec(ba, type, payload, length) {
		var t = type;
		if(isNaN(t)) return;
		var len = length || (payload||[]).length || 0;
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, len);
		if(len > 0 && is_buf(payload)) ba.push(payload);
	}
	
	function write_biff_continue(ba, type, payload, length) {
		var len = length || (payload||[]).length || 0;
		if(len <= 8224) return write_biff_rec(ba, type, payload, len);
		var t = type;
		if(isNaN(t)) return;
		var parts = payload.parts || [], sidx = 0;
		var i = 0, w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, w);
		ba.push(payload.slice(i, i + w));
		i += w;
		while(i < len) {
			o = ba.next(4);
			o.write_shift(2, 0x3c); // TODO: figure out correct continue type
			w = 0;
			while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
			o.write_shift(2, w);
			ba.push(payload.slice(i, i+w)); i+= w;
		}
	}
	
	function write_BIFF2Cell(out, r, c) {
		if(!out) out = new_buf(7);
		out.write_shift(2, r);
		out.write_shift(2, c);
		out.write_shift(2, 0);
		out.write_shift(1, 0);
		return out;
	}
	
	function write_BIFF2BERR(r, c, val, t) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		write_Bes(val, t || 'b', out);
		return out;
	}
	
	/* TODO: codepage, large strings */
	function write_BIFF2LABEL(r, c, val) {
		var out = new_buf(8 + 2*val.length);
		write_BIFF2Cell(out, r, c);
		out.write_shift(1, val.length);
		out.write_shift(val.length, val, 'sbcs');
		return out.l < out.length ? out.slice(0, out.l) : out;
	}
	
	function write_ws_biff2_cell(ba, cell, R, C) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				if((v == (v|0)) && (v >= 0) && (v < 65536))
					write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
				else
					write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
				return;
			case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v||"").slice(0,255)));
				return;
		}
		write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
	}
	
	function write_ws_biff2(ba, ws, idx, opts) {
		var dense = Array.isArray(ws);
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, 0x3FFF);
			ref = encode_range(range);
		}
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff2_cell(ba, cell, R, C, opts);
			}
		}
	}
	
	/* Based on test files */
	function write_biff2_buf(wb, opts) {
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ba = buf_array();
		var idx = 0;
		for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
		if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
		write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
		/* ... */
		write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
		/* ... */
		write_biff_rec(ba, 0x000A);
		return ba.end();
	}
	
	function write_FONTS_biff8(ba, data, opts) {
		write_biff_rec(ba, 0x0031 /* Font */, write_Font({
			sz:12,
			color: {theme:1},
			name: "Arial",
			family: 2,
			scheme: "minor"
		}, opts));
	}
	
	
	function write_FMTS_biff8(ba, NF, opts) {
		if(!NF) return;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, 0x041E /* Format */, write_Format(i, NF[i], opts));
		});
	}
	
	function write_FEAT(ba, ws) {
		/* [MS-XLS] 2.4.112 */
		var o = new_buf(19);
		o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
		write_biff_rec(ba, 0x0867 /* FeatHdr */, o);
		/* [MS-XLS] 2.4.111 */
		o = new_buf(39);
		o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
		o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
		write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
		o.write_shift(4, 4);
		write_biff_rec(ba, 0x0868 /* Feat */, o);
	}
	
	function write_CELLXFS_biff8(ba, opts) {
		for(var i = 0; i < 16; ++i) write_biff_rec(ba, 0x00e0 /* XF */, write_XF({numFmtId:0, style:true}, 0, opts));
		opts.cellXfs.forEach(function(c) {
			write_biff_rec(ba, 0x00e0 /* XF */, write_XF(c, 0, opts));
		});
	}
	
	function write_ws_biff8_hlinks(ba, ws) {
		for(var R=0; R<ws['!links'].length; ++R) {
			var HL = ws['!links'][R];
			write_biff_rec(ba, 0x01b8 /* HLink */, write_HLink(HL));
			if(HL[1].Tooltip) write_biff_rec(ba, 0x0800 /* HLinkTooltip */, write_HLinkTooltip(HL));
		}
		delete ws['!links'];
	}
	
	function write_ws_cols_biff8(ba, cols) {
		if(!cols) return;
		var cnt = 0;
		cols.forEach(function(col, idx) {
			if(++cnt <= 256 && col) {
				write_biff_rec(ba, 0x007d /* ColInfo */, write_ColInfo(col_obj_w(idx, col), idx));
			}
		});
	}
	
	function write_ws_biff8_cell(ba, cell, R, C, opts) {
		var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
		if(cell.v == null && !cell.bf) {
			write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
			return;
		}
		if(cell.bf) write_biff_rec(ba, 0x0006 /* Formula */, write_Formula(cell, R, C, opts, os));
		else switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				/* TODO: emit RK as appropriate */
				write_biff_rec(ba, 0x0203 /* Number */, write_Number(R, C, v, os, opts));
				break;
			case 'b': case 'e':
				write_biff_rec(ba, 0x0205 /* BoolErr */, write_BoolErr(R, C, cell.v, os, opts, cell.t));
				break;
			/* TODO: codepage, sst */
			case 's': case 'str':
				if(opts.bookSST) {
					var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
					write_biff_rec(ba, 0x00fd /* LabelSst */, write_LabelSst(R, C, isst, os, opts));
				} else write_biff_rec(ba, 0x0204 /* Label */, write_Label(R, C, (cell.v||"").slice(0,255), os, opts));
				break;
			default:
				write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
		}
	}
	
	/* [MS-XLS] 2.1.7.20.5 */
	function write_ws_biff8(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var _WB = ((wb||{}).Workbook||{});
		var _sheet = ((_WB.Sheets||[])[idx]||{});
		var dense = Array.isArray(ws);
		var b8 = opts.biff == 8;
		var ref, rr = "", cols = [];
		var range = safe_decode_range(ws['!ref'] || "A1");
		var MAX_ROWS = b8 ? 65536 : 16384;
		if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, MAX_ROWS-1);
		}
	
		write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
		/* [Uncalced] Index */
		write_biff_rec(ba, 0x000d /* CalcMode */, writeuint16(1));
		write_biff_rec(ba, 0x000c /* CalcCount */, writeuint16(100));
		write_biff_rec(ba, 0x000f /* CalcRefMode */, writebool(true));
		write_biff_rec(ba, 0x0011 /* CalcIter */, writebool(false));
		write_biff_rec(ba, 0x0010 /* CalcDelta */, write_Xnum(0.001));
		write_biff_rec(ba, 0x005f /* CalcSaveRecalc */, writebool(true));
		write_biff_rec(ba, 0x002a /* PrintRowCol */, writebool(false));
		write_biff_rec(ba, 0x002b /* PrintGrid */, writebool(false));
		write_biff_rec(ba, 0x0082 /* GridSet */, writeuint16(1));
		write_biff_rec(ba, 0x0080 /* Guts */, write_Guts([0,0]));
		/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
		/* Header (string) */
		/* Footer (string) */
		write_biff_rec(ba, 0x0083 /* HCenter */, writebool(false));
		write_biff_rec(ba, 0x0084 /* VCenter */, writebool(false));
		/* ... */
		if(b8) write_ws_cols_biff8(ba, ws["!cols"]);
		/* ... */
		write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
		/* ... */
	
		if(b8) ws['!links'] = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff8_cell(ba, cell, R, C, opts);
				if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			}
		}
		var cname = _sheet.CodeName || _sheet.name || s;
		/* ... */
		if(b8) write_biff_rec(ba, 0x023e /* Window2 */, write_Window2((_WB.Views||[])[0]));
		/* ... */
		if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, 0x00e5 /* MergeCells */, write_MergeCells(ws['!merges']));
		/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
		if(b8) write_ws_biff8_hlinks(ba, ws);
		/* [DVAL] */
		write_biff_rec(ba, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		/* *WebPub *CellWatch [SheetExt] */
		if(b8) write_FEAT(ba, ws);
		/* *FEAT11 *RECORD12 */
		write_biff_rec(ba, 0x000a /* EOF */);
		return ba.end();
	}
	
	/* [MS-XLS] 2.1.7.20.3 */
	function write_biff8_global(wb, bufs, opts) {
		var A = buf_array();
		var _WB = ((wb||{}).Workbook||{});
		var _sheets = (_WB.Sheets||[]);
		var _wb = _WB.WBProps||{};
		var b8 = opts.biff == 8, b5 = opts.biff == 5;
		write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
		if(opts.bookType == "xla") write_biff_rec(A, 0x0087 /* Addin */);
		write_biff_rec(A, 0x00e1 /* InterfaceHdr */, b8 ? writeuint16(0x04b0) : null);
		write_biff_rec(A, 0x00c1 /* Mms */, writezeroes(2));
		if(b5) write_biff_rec(A, 0x00bf /* ToolbarHdr */);
		if(b5) write_biff_rec(A, 0x00c0 /* ToolbarEnd */);
		write_biff_rec(A, 0x00e2 /* InterfaceEnd */);
		write_biff_rec(A, 0x005c /* WriteAccess */, write_WriteAccess("SheetJS", opts));
		/* [FileSharing] */
		write_biff_rec(A, 0x0042 /* CodePage */, writeuint16(b8 ? 0x04b0 : 0x04E4));
		/* *2047 Lel */
		if(b8) write_biff_rec(A, 0x0161 /* DSF */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01c0 /* Excel9File */);
		write_biff_rec(A, 0x013d /* RRTabId */, write_RRTabId(wb.SheetNames.length));
		if(b8 && wb.vbaraw) write_biff_rec(A, 0x00d3 /* ObProj */);
		/* [ObNoMacros] */
		if(b8 && wb.vbaraw) {
			var cname = _wb.CodeName || "ThisWorkbook";
			write_biff_rec(A, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		}
		write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */, writeuint16(0x11));
		/* *FnGroupName *FnGrp12 */
		/* *Lbl */
		/* [OleObjectSize] */
		write_biff_rec(A, 0x0019 /* WinProtect */, writebool(false));
		write_biff_rec(A, 0x0012 /* Protect */, writebool(false));
		write_biff_rec(A, 0x0013 /* Password */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01af /* Prot4Rev */, writebool(false));
		if(b8) write_biff_rec(A, 0x01bc /* Prot4RevPass */, writeuint16(0));
		write_biff_rec(A, 0x003d /* Window1 */, write_Window1(opts));
		write_biff_rec(A, 0x0040 /* Backup */, writebool(false));
		write_biff_rec(A, 0x008d /* HideObj */, writeuint16(0));
		write_biff_rec(A, 0x0022 /* Date1904 */, writebool(safe1904(wb)=="true"));
		write_biff_rec(A, 0x000e /* CalcPrecision */, writebool(true));
		if(b8) write_biff_rec(A, 0x01b7 /* RefreshAll */, writebool(false));
		write_biff_rec(A, 0x00DA /* BookBool */, writeuint16(0));
		/* ... */
		write_FONTS_biff8(A, wb, opts);
		write_FMTS_biff8(A, wb.SSF, opts);
		write_CELLXFS_biff8(A, opts);
		/* ... */
		if(b8) write_biff_rec(A, 0x0160 /* UsesELFs */, writebool(false));
		var a = A.end();
	
		var C = buf_array();
		/* METADATA [MTRSettings] [ForceFullCalculation] */
		if(b8) write_biff_rec(C, 0x008C, write_Country());
		/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */
	
		/* BIFF8: [SST *Continue] ExtSST */
		if(b8 && opts.Strings) write_biff_continue(C, 0x00FC, write_SST(opts.Strings, opts));
	
		/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
		write_biff_rec(C, 0x000A /* EOF */);
		var c = C.end();
	
		var B = buf_array();
		var blen = 0, j = 0;
		for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
		var start = a.length + blen + c.length;
		for(j = 0; j < wb.SheetNames.length; ++j) {
			var _sheet = _sheets[j] || ({});
			write_biff_rec(B, 0x0085 /* BoundSheet8 */, write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
			start += bufs[j].length;
		}
		/* 1*BoundSheet8 */
		var b = B.end();
		if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
	
		var out = [];
		if(a.length) out.push(a);
		if(b.length) out.push(b);
		if(c.length) out.push(c);
		return bconcat(out);
	}
	
	/* [MS-XLS] 2.1.7.20 Workbook Stream */
	function write_biff8_buf(wb, opts) {
		var o = opts || {};
		var bufs = [];
	
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
			o.ssf = wb.SSF;
		}
	
		o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
		fix_write_opts(o);
	
		o.cellXfs = [];
		get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
		bufs.unshift(write_biff8_global(wb, bufs, o));
		return bconcat(bufs);
	}
	
	function write_biff_buf(wb, opts) {
		for(var i = 0; i <= wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = decode_range(ws["!ref"]);
			if(range.e.c > 255) { // note: 255 is IV
			if(typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
			}
		}
	
		var o = opts || {};
		switch(o.biff || 2) {
			case 8: case 5: return write_biff8_buf(wb, opts);
			case 4: case 3: case 2: return write_biff2_buf(wb, opts);
		}
		throw new Error("invalid type " + o.bookType + " for BIFF");
	}
	/* note: browser DOM element cannot see mso- style attrs, must parse */
	function html_to_sheet(str, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		str = str.replace(/<!--.*?-->/g, "");
		var mtch = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2 = str.match(/<\/table/i);
		var i = mtch.index, j = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				for(var midx = 0; midx < merges.length; ++midx) {
					var _merge = merges[midx];
					if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
				}
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t = tag.t || tag["data-t"] || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(m);
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) { C += CS; continue; }
				var o = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's'){}
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || table_fmt[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		if(merges.length) ws["!merges"] = merges;
		return ws;
	}
	function make_html_row(ws, r, R, o) {
		var M = (ws['!merges'] ||[]);
		var oo = [];
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			/* TODO: html entities */
			var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
			var sp = ({});
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			else if(cell) {
				sp["data-t"] = cell && cell.t || 'z';
				if(cell.v != null) sp["data-v"] = cell.v;
				if(cell.z != null) sp["data-z"] = cell.z;
				if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
			}
			sp.id = (o.id || "sjs") + "-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	
	var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var HTML_END = '</body></html>';
	
	function html_to_workbook(str, opts) {
		var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
		if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
		if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
		var wb = book_new();
		mtch.forEach(function(s, idx) { book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
		return wb;
	}
	
	function make_html_preamble(ws, R, o) {
		var out = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	
	function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		var out = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");
	}
	
	function sheet_add_dom(ws, table, _opts) {
		var opts = _opts || {};
		if(DENSE != null) opts.dense = DENSE;
		var or_R = 0, or_C = 0;
		if(opts.origin != null) {
			if(typeof opts.origin == 'number') or_R = opts.origin;
			else {
				var _origin = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
				or_R = _origin.r; or_C = _origin.c;
			}
		}
	
		var rows = table.getElementsByTagName('tr');
		var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
		var range = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
		if(ws["!ref"]) {
			var _range = decode_range(ws["!ref"]);
			range.s.r = Math.min(range.s.r, _range.s.r);
			range.s.c = Math.min(range.s.c, _range.s.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			range.e.c = Math.max(range.e.c, _range.e.c);
			if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
		}
		var merges = [], midx = 0;
		var rowinfo = ws["!rows"] || (ws["!rows"] = []);
		var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
		if(!ws["!cols"]) ws['!cols'] = [];
		for(; _R < rows.length && R < sheetRows; ++_R) {
			var row = rows[_R];
			if (is_dom_element_hidden(row)) {
				if (opts.display) continue;
				rowinfo[R] = {hidden: true};
			}
			var elts = (row.children);
			for(_C = C = 0; _C < elts.length; ++_C) {
				var elt = elts[_C];
				if (opts.display && is_dom_element_hidden(elt)) continue;
				var v = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
				var z = elt.getAttribute('data-z') || elt.getAttribute('z');
				for(midx = 0; midx < merges.length; ++midx) {
					var m = merges[midx];
					if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
				}
				/* TODO: figure out how to extract nonstandard mso- style */
				CS = +elt.getAttribute("colspan") || 1;
				if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
				var o = {t:'s', v:v};
				var _t = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
				if(v != null) {
					if(v.length == 0) o.t = _t || 'z';
					else if(opts.raw || v.trim().length == 0 || _t == "s"){}
					else if(v === 'TRUE') o = {t:'b', v:true};
					else if(v === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
					else if(!isNaN(fuzzydate(v).getDate())) {
						o = ({t:'d', v:parseDate(v)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || table_fmt[14];
					}
				}
				if(o.z === undefined && z != null) o.z = z;
				/* The first link is used.  Links are assumed to be fully specified.
				 * TODO: The right way to process relative links is to make a new <a> */
				var l = "", Aelts = elt.getElementsByTagName("A");
				if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
					l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
				}
				if(l && l.charAt(0) != "#") o.l = ({ Target: l });
				if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
				else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
				if(range.e.c < C + or_C) range.e.c = C + or_C;
				C += CS;
			}
			++R;
		}
		if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
		range.e.r = Math.max(range.e.r, R - 1 + or_R);
		ws['!ref'] = encode_range(range);
		if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
		return ws;
	}
	
	function parse_dom_table(table, _opts) {
		var opts = _opts || {};
		var ws = opts.dense ? ([]) : ({});
		return sheet_add_dom(ws, table, _opts);
	}
	
	function table_to_book(table, opts) {
		return sheet_to_workbook(parse_dom_table(table, opts), opts);
	}
	
	function is_dom_element_hidden(element) {
		var display = '';
		var get_computed_style = get_get_computed_style_function(element);
		if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
		if(!display) display = element.style && element.style.display;
		return display === 'none';
	}
	
	/* global getComputedStyle */
	function get_get_computed_style_function(element) {
		// The proper getComputedStyle implementation is the one defined in the element window
		if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
		// If it is not available, try to get one from the global namespace
		if(typeof getComputedStyle === 'function') return getComputedStyle;
		return null;
	}
	/* OpenDocument */
	function parse_text_p(text) {
		/* 6.1.2 White Space Characters */
		var fixed = text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n");
		var v = unescapexml(fixed.replace(/<[^>]*>/g,""));
	
		return [v];
	}
	
	var number_formats_ods = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};
	
	
	function parse_content_xml(d, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag = {name:""}, NF = "", pidx = 0;
			var sheetag;
			var rowtag;
			var Sheets = {}, SheetNames = [];
			var ws = opts.dense ? ([]) : ({});
			var Rn, q;
			var ctag = ({value:""});
			var textp = "", textpidx = 0, textptag;
			var textR = [];
			var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var row_ol = 0;
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
			var rowinfo = [], rowpeat = 1, colpeat = 1;
			var arrayf = [];
			var WB = {Names:[]};
			var atag = ({});
			var _Ref = ["", ""];
			var comments = [], comment = ({});
			var creator = "", creatoridx = 0;
			var isstub = false, intable = false;
			var i = 0;
			xlmlregex.lastIndex = 0;
			str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
			while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
	
				case 'table': case '工作表': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
						else ws['!ref'] = "A1:A1";
						if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
							ws['!fullref'] = ws['!ref'];
							range.e.r = opts.sheetRows - 1;
							ws['!ref'] = encode_range(range);
						}
						if(merges.length) ws['!merges'] = merges;
						if(rowinfo.length) ws["!rows"] = rowinfo;
						sheetag.name = sheetag['名称'] || sheetag.name;
						if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
						intable = false;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0], false);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = opts.dense ? ([]) : ({}); merges = [];
						rowinfo = [];
						intable = true;
					}
					break;
	
				case 'table-row-group': // 9.1.9 <table:table-row-group>
					if(Rn[1] === "/") --row_ol; else ++row_ol;
					break;
				case 'table-row': case '行': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
					rowtag = parsexmltag(Rn[0], false);
					if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
					rowpeat = +rowtag['number-rows-repeated'] || 1;
					/* TODO: remove magic */
					if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
					C = -1; break;
				case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
					if(Rn[1] !== '/') ++C;
					if(opts.sheetStubs) {
						if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
						else ws[encode_cell({r:R,c:C})] = {t:'z'};
					}
					textp = ""; textR = [];
					break; /* stub */
				case 'table-cell': case '数据':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						++C;
						ctag = parsexmltag(Rn[0], false);
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						q = ({t:'z', v:null});
						if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
						if((ctag['数据类型'] || ctag['value-type']) == "string") {
							q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
							if(opts.dense) {
								if(!ws[R]) ws[R] = [];
								ws[R][C] = q;
							} else {
								ws[encode_cell({r:R,c:C})] = q;
							}
						}
						C+= colpeat-1;
					} else if(Rn[1]!=='/') {
						++C;
						textp = ""; textpidx = 0; textR = [];
						colpeat = 1;
						var rptR = rowpeat ? R + rowpeat - 1 : R;
						if(C > range.e.c) range.e.c = C;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						if(rptR > range.e.r) range.e.r = rptR;
						ctag = parsexmltag(Rn[0], false);
						comments = []; comment = ({});
						q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
						if(opts.cellFormula) {
							if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
							if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
								mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
								mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
								mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
								q.F = encode_range(mrange);
								arrayf.push([mrange, q.F]);
							}
							if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
							else for(i = 0; i < arrayf.length; ++i)
								if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
									if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
										q.F = arrayf[i][1];
						}
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
	
						/* 19.675.2 table:number-columns-repeated */
						if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
	
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
								if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
								q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
								if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
								q.z = 'HH:MM:SS'; break;
							case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
							default:
								if(q.t === 'string' || q.t === 'text' || !q.t) {
									q.t = 's';
									if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
								} else throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						isstub = false;
						if(q.t === 's') {
							q.v = textp || '';
							if(textR.length) q.R = textR;
							isstub = textpidx == 0;
						}
						if(atag.Target) q.l = atag;
						if(comments.length > 0) { q.c = comments; comments = []; }
						if(textp && opts.cellText !== false) q.w = textp;
						if(isstub) { q.t = "z"; delete q.v; }
						if(!isstub || opts.sheetStubs) {
							if(!(opts.sheetRows && opts.sheetRows <= R)) {
								for(var rpt = 0; rpt < rowpeat; ++rpt) {
									colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
									if(opts.dense) {
										if(!ws[R + rpt]) ws[R + rpt] = [];
										ws[R + rpt][C] = rpt == 0 ? q : dup(q);
										while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
									} else {
										ws[encode_cell({r:R + rpt,c:C})] = q;
										while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
									}
									if(range.e.c <= C) range.e.c = C;
								}
							}
						}
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						C += colpeat-1; colpeat = 0;
						q = {};
						textp = ""; textR = [];
					}
					atag = ({});
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document': // TODO: <office:document> is the root for FODS
				case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'styles': // TODO <office:styles>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
				case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				case 'annotation': // 14.1 <office:annotation>
					if(Rn[1]==='/'){
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
						comment.t = textp;
						if(textR.length) comment.R = textR;
						comment.a = creator;
						comments.push(comment);
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
					creator = ""; creatoridx = 0;
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'creator': // 4.3.2.7 <dc:creator>
					if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
					else creatoridx = Rn.index + Rn[0].length;
					break;
	
				/* ignore state */
				case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
				case 'settings': // TODO: <office:settings>
				case 'config-item-set': // TODO: <office:config-item-set>
				case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
				case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
				case 'config-item-map-named': // TODO: <office:config-item-map-entry>
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
				case 'text-box': // 10.4.3 <draw:text-box>
				case 'image': // 10.4.4 <draw:image>
				case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
				case 'list-style': // 16.30 <text:list-style>
				case 'form': // 13.13 <form:form>
				case 'dde-links': // 9.8 <table:dde-links>
				case 'event-listeners': // TODO
				case 'chart': // TODO
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'scientific-number': // TODO: <number:scientific-number>
					break;
				case 'currency-symbol': // TODO: <number:currency-symbol>
					break;
				case 'currency-style': // TODO: <number:currency-style>
					break;
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0], false);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'libraries': break; // TODO: <ooo:libraries>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
	
				case 'default-style': // TODO: <style:default-style>
				case 'page-layout': break; // TODO: <style:page-layout>
				case 'style': // 16.2 <style:style>
					break;
				case 'map': break; // 16.3 <style:map>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'fraction': break; // TODO 16.27.6 <number:fraction>
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
	
				case 'named-range': // 9.4.12 <table:named-range>
					tag = parsexmltag(Rn[0], false);
					_Ref = ods_to_csf_3D(tag['cell-range-address']);
					var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
					if(intable) nrange.Sheet = SheetNames.length;
					WB.Names.push(nrange);
					break;
	
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
				case 'embedded-text': break; // 16.27.4 <number:embedded-text>
	
				case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
				case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
				case 'table-rows': break; // 9.1.12 <table:table-rows>
				/* TODO: outline levels */
				case 'table-column-group': break; // 9.1.10 <table:table-column-group>
				case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
				case 'table-columns': break; // 9.1.12 <table:table-columns>
	
				case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904
	
				case 'graphic-properties': break; // 17.21 <style:graphic-properties>
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'label-range': break; // 9.4.9 <table:label-range>
				case 'label-ranges': break; // 9.4.10 <table:label-ranges>
				case 'named-expression': break; // 9.4.13 <table:named-expression>
				case 'sort': break; // 9.4.19 <table:sort>
				case 'sort-by': break; // 9.4.20 <table:sort-by>
				case 'sort-groups': break; // 9.4.22 <table:sort-groups>
	
				case 'tab': break; // 6.1.4 <text:tab>
				case 'line-break': break; // 6.1.5 <text:line-break>
				case 'span': break; // 6.1.7 <text:span>
				case 'p': case '文本串': // 5.1.3 <text:p>
					if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
					if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
						var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
						textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
					} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
	
				case 'database-range': // 9.4.15 <table:database-range>
					if(Rn[1]==='/') break;
					try {
						_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
						Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
					} catch(e) {/* empty */}
					break;
	
				case 'date': break; // <*:date>
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': case '标题': break; // <*:title> OR <uof:标题>
				case 'desc': break; // <*:desc>
				case 'binary-data': break; // 10.4.5 TODO: b64 blob
	
				/* 9.2 Advanced Tables */
				case 'table-source': break; // 9.2.6
				case 'scenario': break; // 9.2.6
	
				case 'iteration': break; // 9.4.3 <table:iteration>
				case 'content-validations': break; // 9.4.4 <table:
				case 'content-validation': break; // 9.4.5 <table:
				case 'help-message': break; // 9.4.6 <table:
				case 'error-message': break; // 9.4.7 <table:
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
	
				case 'list-level-style-bullet': break; // 16.31 <text:
				case 'list-level-style-number': break; // 16.32 <text:
				case 'list-level-properties': break; // 17.19 <style:
	
				/* 7.3 Document Fields */
				case 'sender-firstname': // 7.3.6.2
				case 'sender-lastname': // 7.3.6.3
				case 'sender-initials': // 7.3.6.4
				case 'sender-title': // 7.3.6.5
				case 'sender-position': // 7.3.6.6
				case 'sender-email': // 7.3.6.7
				case 'sender-phone-private': // 7.3.6.8
				case 'sender-fax': // 7.3.6.9
				case 'sender-company': // 7.3.6.10
				case 'sender-phone-work': // 7.3.6.11
				case 'sender-street': // 7.3.6.12
				case 'sender-city': // 7.3.6.13
				case 'sender-postal-code': // 7.3.6.14
				case 'sender-country': // 7.3.6.15
				case 'sender-state-or-province': // 7.3.6.16
				case 'author-name': // 7.3.7.1
				case 'author-initials': // 7.3.7.2
				case 'chapter': // 7.3.8
				case 'file-name': // 7.3.9
				case 'template-name': // 7.3.9
				case 'sheet-name': // 7.3.9
					break;
	
				case 'event-listener':
					break;
				/* TODO: FODS Properties */
				case 'initial-creator':
				case 'creation-date':
				case 'print-date':
				case 'generator':
				case 'document-statistic':
				case 'user-defined':
				case 'editing-duration':
				case 'editing-cycles':
					break;
	
				/* TODO: FODS Config */
				case 'config-item':
					break;
	
				/* TODO: style tokens */
				case 'page-number': break; // TODO <text:page-number>
				case 'page-count': break; // TODO <text:page-count>
				case 'time': break; // TODO <text:time>
	
				/* 9.3 Advanced Table Cells */
				case 'cell-range-source': break; // 9.3.1 <table:
				case 'detective': break; // 9.3.2 <table:
				case 'operation': break; // 9.3.3 <table:
				case 'highlighted-range': break; // 9.3.4 <table:
	
				/* 9.6 Data Pilot Tables <table: */
				case 'data-pilot-table': // 9.6.3
				case 'source-cell-range': // 9.6.5
				case 'source-service': // 9.6.6
				case 'data-pilot-field': // 9.6.7
				case 'data-pilot-level': // 9.6.8
				case 'data-pilot-subtotals': // 9.6.9
				case 'data-pilot-subtotal': // 9.6.10
				case 'data-pilot-members': // 9.6.11
				case 'data-pilot-member': // 9.6.12
				case 'data-pilot-display-info': // 9.6.13
				case 'data-pilot-sort-info': // 9.6.14
				case 'data-pilot-layout-info': // 9.6.15
				case 'data-pilot-field-reference': // 9.6.16
				case 'data-pilot-groups': // 9.6.17
				case 'data-pilot-group': // 9.6.18
				case 'data-pilot-group-member': // 9.6.19
					break;
	
				/* 10.3 Drawing Shapes */
				case 'rect': // 10.3.2
					break;
	
				/* 14.6 DDE Connections */
				case 'dde-connection-decls': // 14.6.2 <text:
				case 'dde-connection-decl': // 14.6.3 <text:
				case 'dde-link': // 14.6.4 <table:
				case 'dde-source': // 14.6.5 <office:
					break;
	
				case 'properties': break; // 13.7 <form:properties>
				case 'property': break; // 13.8 <form:property>
	
				case 'a': // 6.1.8 hyperlink
					if(Rn[1]!== '/') {
						atag = parsexmltag(Rn[0], false);
						if(!atag.href) break;
						atag.Target = unescapexml(atag.href); delete atag.href;
						if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
							_Ref = ods_to_csf_3D(atag.Target.slice(1));
							atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
						} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
					}
					break;
	
				/* non-standard */
				case 'table-protection': break;
				case 'data-pilot-grand-total': break; // <table:
				case 'office-document-common-attrs': break; // bare
				default: switch(Rn[2]) {
					case 'dc:':       // TODO: properties
					case 'calcext:':  // ignore undocumented extensions
					case 'loext:':    // ignore undocumented extensions
					case 'ooo:':      // ignore undocumented extensions
					case 'chartooo:': // ignore undocumented extensions
					case 'draw:':     // TODO: drawing
					case 'style:':    // TODO: styles
					case 'chart:':    // TODO: charts
					case 'form:':     // TODO: forms
					case 'uof:':      // TODO: uof
					case '表:':       // TODO: uof
					case '字:':       // TODO: uof
						break;
					default: if(opts.WTF) throw new Error(Rn);
				}
			}
			var out = ({
				Sheets: Sheets,
				SheetNames: SheetNames,
				Workbook: WB
			});
			if(opts.bookSheets) delete out.Sheets;
			return out;
	}
	
	function parse_ods(zip, opts) {
		opts = opts || ({});
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
		var content = getzipstr(zip, 'content.xml');
		if(!content) throw new Error("Missing content.xml in ODS / UOF file");
		var wb = parse_content_xml(utf8read(content), opts);
		if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
		return wb;
	}
	function parse_fods(data, opts) {
		return parse_content_xml(data, opts);
	}
	
	/* OpenDocument */
	var write_styles_ods = /* @__PURE__ */(function() {
		var master_styles = [
			'<office:master-styles>',
				'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
					'<style:header/>',
					'<style:header-left style:display="false"/>',
					'<style:footer/>',
					'<style:footer-left style:display="false"/>',
				'</style:master-page>',
			'</office:master-styles>'
		].join("");
	
		var payload = '<office:document-styles ' + wxt_helper({
			'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':    "http://www.w3.org/1999/xlink",
			'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
			'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'office:version': "1.2"
		}) + '>' + master_styles + '</office:document-styles>';
	
		return function wso() {
			return XML_HEADER + payload;
		};
	})();
	var write_content_ods = /* @__PURE__ */(function() {
		/* 6.1.2 White Space Characters */
		var write_text_p = function(text) {
			return escapexml(text)
				.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
				.replace(/\t/g, "<text:tab/>")
				.replace(/\n/g, "</text:p><text:p>")
				.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
		};
	
		var null_cell_xml = '          <table:table-cell />\n';
		var covered_cell_xml = '          <table:covered-table-cell/>\n';
		var write_ws = function(ws, wb, i) {
			/* Section 9 Tables */
			var o = [];
			o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
			var R=0,C=0, range = decode_range(ws['!ref']||"A1");
			var marr = ws['!merges'] || [], mi = 0;
			var dense = Array.isArray(ws);
			if(ws["!cols"]) {
				for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
			}
			var H = "", ROWS = ws["!rows"]||[];
			for(R = 0; R < range.s.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '></table:table-row>\n');
			}
			for(; R <= range.e.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '>\n');
				for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
				for(; C <= range.e.c; ++C) {
					var skip = false, ct = {}, textp = "";
					for(mi = 0; mi != marr.length; ++mi) {
						if(marr[mi].s.c > C) continue;
						if(marr[mi].s.r > R) continue;
						if(marr[mi].e.c < C) continue;
						if(marr[mi].e.r < R) continue;
						if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
						ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
						ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
						break;
					}
					if(skip) { o.push(covered_cell_xml); continue; }
					var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
					if(cell && cell.f) {
						ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
						if(cell.F) {
							if(cell.F.slice(0, ref.length) == ref) {
								var _Fref = decode_range(cell.F);
								ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
								ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
							}
						}
					}
					if(!cell) { o.push(null_cell_xml); continue; }
					switch(cell.t) {
						case 'b':
							textp = (cell.v ? 'TRUE' : 'FALSE');
							ct['office:value-type'] = "boolean";
							ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
							break;
						case 'n':
							textp = (cell.w||String(cell.v||0));
							ct['office:value-type'] = "float";
							ct['office:value'] = (cell.v||0);
							break;
						case 's': case 'str':
							textp = cell.v == null ? "" : cell.v;
							ct['office:value-type'] = "string";
							break;
						case 'd':
							textp = (cell.w||(parseDate(cell.v).toISOString()));
							ct['office:value-type'] = "date";
							ct['office:date-value'] = (parseDate(cell.v).toISOString());
							ct['table:style-name'] = "ce1";
							break;
						//case 'e':
						default: o.push(null_cell_xml); continue;
					}
					var text_p = write_text_p(textp);
					if(cell.l && cell.l.Target) {
						var _tgt = cell.l.Target;
						_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
						// TODO: choose correct parent path format based on link delimiters
						if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
						text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
					}
					o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
				}
				o.push('        </table:table-row>\n');
			}
			o.push('      </table:table>\n');
			return o.join("");
		};
	
		var write_automatic_styles_ods = function(o, wb) {
			o.push(' <office:automatic-styles>\n');
	
			o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
			o.push('   <number:month number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:day number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:year/>\n');
			o.push('  </number:date-style>\n');
	
			/* column styles */
			var cidx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!cols"]) {
					for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
						var colobj = ws["!cols"][C];
						if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
						process_col(colobj);
						colobj.ods = cidx;
						var w = ws["!cols"][C].wpx + "px";
						o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
						o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
						o.push('  </style:style>\n');
						++cidx;
					}
				}
			});
	
			/* row styles */
			var ridx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!rows"]) {
					for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
						ws["!rows"][R].ods = ridx;
						var h = ws["!rows"][R].hpx + "px";
						o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
						o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
						o.push('  </style:style>\n');
						++ridx;
					}
				}
			});
	
			/* table */
			o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
			o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
			o.push('  </style:style>\n');
	
			/* table cells, text */
			o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
	
			/* page-layout */
	
			o.push(' </office:automatic-styles>\n');
		};
	
		return function wcx(wb, opts) {
			var o = [XML_HEADER];
			/* 3.1.3.2 */
			var attr = wxt_helper({
				'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
				'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
				'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
				'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
				'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
				'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
				'xmlns:xlink':        "http://www.w3.org/1999/xlink",
				'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
				'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
				'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
				'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
				'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
				'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
				'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
				'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
				'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
				'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
				'xmlns:ooo':          "http://openoffice.org/2004/office",
				'xmlns:ooow':         "http://openoffice.org/2004/writer",
				'xmlns:oooc':         "http://openoffice.org/2004/calc",
				'xmlns:dom':          "http://www.w3.org/2001/xml-events",
				'xmlns:xforms':       "http://www.w3.org/2002/xforms",
				'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
				'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
				'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
				'xmlns:rpt':          "http://openoffice.org/2005/report",
				'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
				'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
				'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
				'xmlns:tableooo':     "http://openoffice.org/2009/table",
				'xmlns:drawooo':      "http://openoffice.org/2010/draw",
				'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
				'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
				'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
				'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
				'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
				'office:version':     "1.2"
			});
	
			var fods = wxt_helper({
				'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
				'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
			});
	
			if(opts.bookType == "fods") {
				o.push('<office:document' + attr + fods + '>\n');
				o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
				// TODO: settings (equiv of settings.xml for ODS)
			} else o.push('<office:document-content' + attr  + '>\n');
			// o.push('  <office:scripts/>\n');
			write_automatic_styles_ods(o, wb);
			o.push('  <office:body>\n');
			o.push('    <office:spreadsheet>\n');
			for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
			o.push('    </office:spreadsheet>\n');
			o.push('  </office:body>\n');
			if(opts.bookType == "fods") o.push('</office:document>');
			else o.push('</office:document-content>');
			return o.join("");
		};
	})();
	
	function write_ods(wb, opts) {
		if(opts.bookType == "fods") return write_content_ods(wb, opts);
	
		var zip = zip_new();
		var f = "";
	
		var manifest = [];
		var rdf = [];
	
		/* Part 3 Section 3.3 MIME Media Type */
		f = "mimetype";
		zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
	
		/* Part 1 Section 2.2 Documents */
		f = "content.xml";
		zip_add_file(zip, f, write_content_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "ContentFile"]);
	
		/* TODO: these are hard-coded styles to satiate excel */
		f = "styles.xml";
		zip_add_file(zip, f, write_styles_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "StylesFile"]);
	
		/* TODO: this is hard-coded to satiate excel */
		f = "meta.xml";
		zip_add_file(zip, f, XML_HEADER + write_meta_ods());
		manifest.push([f, "text/xml"]);
		rdf.push([f, "MetadataFile"]);
	
		/* Part 3 Section 6 Metadata Manifest File */
		f = "manifest.rdf";
		zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
		manifest.push([f, "application/rdf+xml"]);
	
		/* Part 3 Section 4 Manifest File */
		f = "META-INF/manifest.xml";
		zip_add_file(zip, f, write_manifest(manifest/*, opts*/));
	
		return zip;
	}
	
	/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
	function u8_to_dataview(array) {
	  return new DataView(array.buffer, array.byteOffset, array.byteLength);
	}
	function u8str(u8) {
	  return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
	}
	function stru8(str) {
	  return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : s2a(utf8write(str));
	}
	function u8contains(body, search) {
	  outer:
	    for (var L = 0; L <= body.length - search.length; ++L) {
	      for (var j = 0; j < search.length; ++j)
	        if (body[L + j] != search[j])
	          continue outer;
	      return true;
	    }
	  return false;
	}
	function u8concat(u8a) {
	  var len = u8a.reduce(function(acc, x) {
	    return acc + x.length;
	  }, 0);
	  var out = new Uint8Array(len);
	  var off = 0;
	  u8a.forEach(function(u8) {
	    out.set(u8, off);
	    off += u8.length;
	  });
	  return out;
	}
	function popcnt(x) {
	  x -= x >> 1 & 1431655765;
	  x = (x & 858993459) + (x >> 2 & 858993459);
	  return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
	}
	function readDecimal128LE(buf, offset) {
	  var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
	  var mantissa = buf[offset + 14] & 1;
	  for (var j = offset + 13; j >= offset; --j)
	    mantissa = mantissa * 256 + buf[j];
	  return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
	}
	function writeDecimal128LE(buf, offset, value) {
	  var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
	  var mantissa = value / Math.pow(10, exp - 6176);
	  buf[offset + 15] |= exp >> 7;
	  buf[offset + 14] |= (exp & 127) << 1;
	  for (var i = 0; mantissa >= 1; ++i, mantissa /= 256)
	    buf[offset + i] = mantissa & 255;
	  buf[offset + 15] |= value >= 0 ? 0 : 128;
	}
	function parse_varint49(buf, ptr) {
	  var l = ptr ? ptr[0] : 0;
	  var usz = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      usz |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 28);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 35);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 42);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	    }
	  if (ptr)
	    ptr[0] = l;
	  return usz;
	}
	function write_varint49(v) {
	  var usz = new Uint8Array(7);
	  usz[0] = v & 127;
	  var L = 1;
	  sz:
	    if (v > 127) {
	      usz[L - 1] |= 128;
	      usz[L] = v >> 7 & 127;
	      ++L;
	      if (v <= 16383)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 14 & 127;
	      ++L;
	      if (v <= 2097151)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 21 & 127;
	      ++L;
	      if (v <= 268435455)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 256 >>> 21 & 127;
	      ++L;
	      if (v <= 34359738367)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 65536 >>> 21 & 127;
	      ++L;
	      if (v <= 4398046511103)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 16777216 >>> 21 & 127;
	      ++L;
	    }
	  return usz.slice(0, L);
	}
	function varint_to_i32(buf) {
	  var l = 0, i32 = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      i32 |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 28;
	    }
	  return i32;
	}
	function parse_shallow(buf) {
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var off = ptr[0];
	    var num = parse_varint49(buf, ptr);
	    var type = num & 7;
	    num = Math.floor(num / 8);
	    var len = 0;
	    var res;
	    if (num == 0)
	      break;
	    switch (type) {
	      case 0:
	        {
	          var l = ptr[0];
	          while (buf[ptr[0]++] >= 128)
	            ;
	          res = buf.slice(l, ptr[0]);
	        }
	        break;
	      case 5:
	        len = 4;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 1:
	        len = 8;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 2:
	        len = parse_varint49(buf, ptr);
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 3:
	      case 4:
	      default:
	        throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
	    }
	    var v = { data: res, type: type };
	    if (out[num] == null)
	      out[num] = [v];
	    else
	      out[num].push(v);
	  }
	  return out;
	}
	function write_shallow(proto) {
	  var out = [];
	  proto.forEach(function(field, idx) {
	    field.forEach(function(item) {
	      if (!item.data)
	        return;
	      out.push(write_varint49(idx * 8 + item.type));
	      if (item.type == 2)
	        out.push(write_varint49(item.data.length));
	      out.push(item.data);
	    });
	  });
	  return u8concat(out);
	}
	function mappa(data, cb) {
	  return (data == null ? void 0 : data.map(function(d) {
	    return cb(d.data);
	  })) || [];
	}
	function parse_iwa_file(buf) {
	  var _a;
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var len = parse_varint49(buf, ptr);
	    var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
	    ptr[0] += len;
	    var res = {
	      id: varint_to_i32(ai[1][0].data),
	      messages: []
	    };
	    ai[2].forEach(function(b) {
	      var mi = parse_shallow(b.data);
	      var fl = varint_to_i32(mi[3][0].data);
	      res.messages.push({
	        meta: mi,
	        data: buf.slice(ptr[0], ptr[0] + fl)
	      });
	      ptr[0] += fl;
	    });
	    if ((_a = ai[3]) == null ? void 0 : _a[0])
	      res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
	    out.push(res);
	  }
	  return out;
	}
	function write_iwa_file(ias) {
	  var bufs = [];
	  ias.forEach(function(ia) {
	    var ai = [];
	    ai[1] = [{ data: write_varint49(ia.id), type: 0 }];
	    ai[2] = [];
	    if (ia.merge != null)
	      ai[3] = [{ data: write_varint49(+!!ia.merge), type: 0 }];
	    var midata = [];
	    ia.messages.forEach(function(mi) {
	      midata.push(mi.data);
	      mi.meta[3] = [{ type: 0, data: write_varint49(mi.data.length) }];
	      ai[2].push({ data: write_shallow(mi.meta), type: 2 });
	    });
	    var aipayload = write_shallow(ai);
	    bufs.push(write_varint49(aipayload.length));
	    bufs.push(aipayload);
	    midata.forEach(function(mid) {
	      return bufs.push(mid);
	    });
	  });
	  return u8concat(bufs);
	}
	function parse_snappy_chunk(type, buf) {
	  if (type != 0)
	    throw new Error("Unexpected Snappy chunk type ".concat(type));
	  var ptr = [0];
	  var usz = parse_varint49(buf, ptr);
	  var chunks = [];
	  while (ptr[0] < buf.length) {
	    var tag = buf[ptr[0]] & 3;
	    if (tag == 0) {
	      var len = buf[ptr[0]++] >> 2;
	      if (len < 60)
	        ++len;
	      else {
	        var c = len - 59;
	        len = buf[ptr[0]];
	        if (c > 1)
	          len |= buf[ptr[0] + 1] << 8;
	        if (c > 2)
	          len |= buf[ptr[0] + 2] << 16;
	        if (c > 3)
	          len |= buf[ptr[0] + 3] << 24;
	        len >>>= 0;
	        len++;
	        ptr[0] += c;
	      }
	      chunks.push(buf.slice(ptr[0], ptr[0] + len));
	      ptr[0] += len;
	      continue;
	    } else {
	      var offset = 0, length = 0;
	      if (tag == 1) {
	        length = (buf[ptr[0]] >> 2 & 7) + 4;
	        offset = (buf[ptr[0]++] & 224) << 3;
	        offset |= buf[ptr[0]++];
	      } else {
	        length = (buf[ptr[0]++] >> 2) + 1;
	        if (tag == 2) {
	          offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
	          ptr[0] += 2;
	        } else {
	          offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
	          ptr[0] += 4;
	        }
	      }
	      chunks = [u8concat(chunks)];
	      if (offset == 0)
	        throw new Error("Invalid offset 0");
	      if (offset > chunks[0].length)
	        throw new Error("Invalid offset beyond length");
	      if (length >= offset) {
	        chunks.push(chunks[0].slice(-offset));
	        length -= offset;
	        while (length >= chunks[chunks.length - 1].length) {
	          chunks.push(chunks[chunks.length - 1]);
	          length -= chunks[chunks.length - 1].length;
	        }
	      }
	      chunks.push(chunks[0].slice(-offset, -offset + length));
	    }
	  }
	  var o = u8concat(chunks);
	  if (o.length != usz)
	    throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
	  return o;
	}
	function decompress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var t = buf[l++];
	    var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
	    l += 3;
	    out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
	    l += len;
	  }
	  if (l !== buf.length)
	    throw new Error("data is not a valid framed stream!");
	  return u8concat(out);
	}
	function compress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var c = Math.min(buf.length - l, 268435455);
	    var frame = new Uint8Array(4);
	    out.push(frame);
	    var usz = write_varint49(c);
	    var L = usz.length;
	    out.push(usz);
	    if (c <= 60) {
	      L++;
	      out.push(new Uint8Array([c - 1 << 2]));
	    } else if (c <= 256) {
	      L += 2;
	      out.push(new Uint8Array([240, c - 1 & 255]));
	    } else if (c <= 65536) {
	      L += 3;
	      out.push(new Uint8Array([244, c - 1 & 255, c - 1 >> 8 & 255]));
	    } else if (c <= 16777216) {
	      L += 4;
	      out.push(new Uint8Array([248, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255]));
	    } else if (c <= 4294967296) {
	      L += 5;
	      out.push(new Uint8Array([252, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255, c - 1 >>> 24 & 255]));
	    }
	    out.push(buf.slice(l, l + c));
	    L += c;
	    frame[0] = 0;
	    frame[1] = L & 255;
	    frame[2] = L >> 8 & 255;
	    frame[3] = L >> 16 & 255;
	    l += c;
	  }
	  return u8concat(out);
	}
	function parse_old_storage(buf, sst, rsst, v) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(4, true);
	  var data_offset = (v > 1 ? 12 : 8) + popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
	  var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 512) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  data_offset += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
	  if (flags & 16) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 32) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 64) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  var ret;
	  switch (buf[2]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: ieee };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else if (sidx > -1)
	          ret = { t: "s", v: sst[sidx] };
	        else if (!isNaN(ieee))
	          ret = { t: "n", v: ieee };
	        else
	          throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	      }
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function parse_new_storage(buf, sst, rsst) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(8, true);
	  var data_offset = 12;
	  var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 1) {
	    d128 = readDecimal128LE(buf, data_offset);
	    data_offset += 16;
	  }
	  if (flags & 2) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 4) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  if (flags & 8) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 16) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  var ret;
	  switch (buf[1]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: d128 };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else
	          throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	      }
	      break;
	    case 10:
	      ret = { t: "n", v: d128 };
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function write_new_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 5;
	  switch (cell.t) {
	    case "n":
	      out[1] = 2;
	      writeDecimal128LE(out, l, cell.v);
	      flags |= 1;
	      l += 16;
	      break;
	    case "b":
	      out[1] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 2;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[1] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 8;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(8, flags, true);
	  return out.slice(0, l);
	}
	function write_old_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 3;
	  switch (cell.t) {
	    case "n":
	      out[2] = 2;
	      dv.setFloat64(l, cell.v, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "b":
	      out[2] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[2] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 16;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(4, flags, true);
	  return out.slice(0, l);
	}
	function parse_cell_storage(buf, sst, rsst) {
	  switch (buf[0]) {
	    case 0:
	    case 1:
	    case 2:
	    case 3:
	      return parse_old_storage(buf, sst, rsst, buf[0]);
	    case 5:
	      return parse_new_storage(buf, sst, rsst);
	    default:
	      throw new Error("Unsupported payload version ".concat(buf[0]));
	  }
	}
	function parse_TSP_Reference(buf) {
	  var pb = parse_shallow(buf);
	  return parse_varint49(pb[1][0].data);
	}
	function write_TSP_Reference(idx) {
	  var out = [];
	  out[1] = [{ type: 0, data: write_varint49(idx) }];
	  return write_shallow(out);
	}
	function parse_TST_TableDataList(M, root) {
	  var pb = parse_shallow(root.data);
	  var type = varint_to_i32(pb[1][0].data);
	  var entries = pb[3];
	  var data = [];
	  (entries || []).forEach(function(entry) {
	    var le = parse_shallow(entry.data);
	    var key = varint_to_i32(le[1][0].data) >>> 0;
	    switch (type) {
	      case 1:
	        data[key] = u8str(le[3][0].data);
	        break;
	      case 8:
	        {
	          var rt = M[parse_TSP_Reference(le[9][0].data)][0];
	          var rtp = parse_shallow(rt.data);
	          var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
	          var mtype = varint_to_i32(rtpref.meta[1][0].data);
	          if (mtype != 2001)
	            throw new Error("2000 unexpected reference to ".concat(mtype));
	          var tswpsa = parse_shallow(rtpref.data);
	          data[key] = tswpsa[3].map(function(x) {
	            return u8str(x.data);
	          }).join("");
	        }
	        break;
	    }
	  });
	  return data;
	}
	function parse_TST_TileRowInfo(u8, type) {
	  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
	  var pb = parse_shallow(u8);
	  var R = varint_to_i32(pb[1][0].data) >>> 0;
	  var cnt = varint_to_i32(pb[2][0].data) >>> 0;
	  var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
	  var used_storage_u8, used_storage;
	  if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
	    used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
	    used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
	  } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
	    used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
	    used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
	  } else
	    throw "NUMBERS Tile missing ".concat(type, " cell storage");
	  var width = wide_offsets ? 4 : 1;
	  var used_storage_offsets = u8_to_dataview(used_storage_u8);
	  var offsets = [];
	  for (var C = 0; C < used_storage_u8.length / 2; ++C) {
	    var off = used_storage_offsets.getUint16(C * 2, true);
	    if (off < 65535)
	      offsets.push([C, off]);
	  }
	  if (offsets.length != cnt)
	    throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
	  var cells = [];
	  for (C = 0; C < offsets.length - 1; ++C)
	    cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
	  if (offsets.length >= 1)
	    cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
	  return { R: R, cells: cells };
	}
	function parse_TST_Tile(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
	  var ri = mappa(pb[5], function(u8) {
	    return parse_TST_TileRowInfo(u8, storage);
	  });
	  return {
	    nrows: varint_to_i32(pb[4][0].data) >>> 0,
	    data: ri.reduce(function(acc, x) {
	      if (!acc[x.R])
	        acc[x.R] = [];
	      x.cells.forEach(function(cell, C) {
	        if (acc[x.R][C])
	          throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
	        acc[x.R][C] = cell;
	      });
	      return acc;
	    }, [])
	  };
	}
	function parse_TST_TableModelArchive(M, root, ws) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
	  range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
	  if (range.e.r < 0)
	    throw new Error("Invalid row varint ".concat(pb[6][0].data));
	  range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
	  if (range.e.c < 0)
	    throw new Error("Invalid col varint ".concat(pb[7][0].data));
	  ws["!ref"] = encode_range(range);
	  var store = parse_shallow(pb[4][0].data);
	  var sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
	  var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]) : [];
	  var tile = parse_shallow(store[3][0].data);
	  var _R = 0;
	  tile[1].forEach(function(t) {
	    var tl = parse_shallow(t.data);
	    var ref = M[parse_TSP_Reference(tl[2][0].data)][0];
	    var mtype = varint_to_i32(ref.meta[1][0].data);
	    if (mtype != 6002)
	      throw new Error("6001 unexpected reference to ".concat(mtype));
	    var _tile = parse_TST_Tile(M, ref);
	    _tile.data.forEach(function(row, R) {
	      row.forEach(function(buf, C) {
	        var addr = encode_cell({ r: _R + R, c: C });
	        var res = parse_cell_storage(buf, sst, rsst);
	        if (res)
	          ws[addr] = res;
	      });
	    });
	    _R += _tile.nrows;
	  });
	}
	function parse_TST_TableInfoArchive(M, root) {
	  var pb = parse_shallow(root.data);
	  var out = { "!ref": "A1" };
	  var tableref = M[parse_TSP_Reference(pb[2][0].data)];
	  var mtype = varint_to_i32(tableref[0].meta[1][0].data);
	  if (mtype != 6001)
	    throw new Error("6000 unexpected reference to ".concat(mtype));
	  parse_TST_TableModelArchive(M, tableref[0], out);
	  return out;
	}
	function parse_TN_SheetArchive(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var out = {
	    name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
	    sheets: []
	  };
	  var shapeoffs = mappa(pb[2], parse_TSP_Reference);
	  shapeoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 6e3)
	        out.sheets.push(parse_TST_TableInfoArchive(M, m));
	    });
	  });
	  return out;
	}
	function parse_TN_DocumentArchive(M, root) {
	  var out = book_new();
	  var pb = parse_shallow(root.data);
	  var sheetoffs = mappa(pb[1], parse_TSP_Reference);
	  sheetoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 2) {
	        var root2 = parse_TN_SheetArchive(M, m);
	        root2.sheets.forEach(function(sheet, idx) {
	          book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
	        });
	      }
	    });
	  });
	  if (out.SheetNames.length == 0)
	    throw new Error("Empty NUMBERS file");
	  return out;
	}
	function parse_numbers_iwa(cfb) {
	  var _a, _b, _c, _d;
	  var M = {}, indices = [];
	  cfb.FullPaths.forEach(function(p) {
	    if (p.match(/\.iwpv2/))
	      throw new Error("Unsupported password protection");
	  });
	  cfb.FileIndex.forEach(function(s) {
	    if (!s.name.match(/\.iwa$/))
	      return;
	    var o;
	    try {
	      o = decompress_iwa_file(s.content);
	    } catch (e) {
	      return console.log("?? " + s.content.length + " " + (e.message || e));
	    }
	    var packets;
	    try {
	      packets = parse_iwa_file(o);
	    } catch (e) {
	      return console.log("## " + (e.message || e));
	    }
	    packets.forEach(function(packet) {
	      M[packet.id] = packet.messages;
	      indices.push(packet.id);
	    });
	  });
	  if (!indices.length)
	    throw new Error("File has no messages");
	  var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
	  if (!docroot)
	    indices.forEach(function(idx) {
	      M[idx].forEach(function(iwam) {
	        var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
	        if (mtype == 1) {
	          if (!docroot)
	            docroot = iwam;
	          else
	            throw new Error("Document has multiple roots");
	        }
	      });
	    });
	  if (!docroot)
	    throw new Error("Cannot find Document root");
	  return parse_TN_DocumentArchive(M, docroot);
	}
	function write_tile_row(tri, data, SST) {
	  var _a, _b, _c, _d;
	  if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0]))
	    throw "Mutation only works on post-BNC storages!";
	  var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && varint_to_i32(tri[8][0].data) > 0 || false;
	  if (wide_offsets)
	    throw "Math only works with normal offsets";
	  var cnt = 0;
	  var dv = u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
	  var _dv = u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
	  for (var C = 0; C < data.length; ++C) {
	    if (data[C] == null) {
	      dv.setUint16(C * 2, 65535, true);
	      _dv.setUint16(C * 2, 65535);
	      continue;
	    }
	    dv.setUint16(C * 2, last_offset, true);
	    _dv.setUint16(C * 2, _last_offset, true);
	    var celload, _celload;
	    switch (typeof data[C]) {
	      case "string":
	        celload = write_new_storage({ t: "s", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "s", v: data[C] }, SST);
	        break;
	      case "number":
	        celload = write_new_storage({ t: "n", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "n", v: data[C] }, SST);
	        break;
	      case "boolean":
	        celload = write_new_storage({ t: "b", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "b", v: data[C] }, SST);
	        break;
	      default:
	        throw new Error("Unsupported value " + data[C]);
	    }
	    cell_storage.push(celload);
	    last_offset += celload.length;
	    _cell_storage.push(_celload);
	    _last_offset += _celload.length;
	    ++cnt;
	  }
	  tri[2][0].data = write_varint49(cnt);
	  for (; C < tri[7][0].data.length / 2; ++C) {
	    dv.setUint16(C * 2, 65535, true);
	    _dv.setUint16(C * 2, 65535, true);
	  }
	  tri[6][0].data = u8concat(cell_storage);
	  tri[3][0].data = u8concat(_cell_storage);
	  return cnt;
	}
	function write_numbers_iwa(wb, opts) {
	  if (!opts || !opts.numbers)
	    throw new Error("Must pass a `numbers` option -- check the README");
	  var ws = wb.Sheets[wb.SheetNames[0]];
	  if (wb.SheetNames.length > 1)
	    console.error("The Numbers writer currently writes only the first table");
	  var range = decode_range(ws["!ref"]);
	  range.s.r = range.s.c = 0;
	  var trunc = false;
	  if (range.e.c > 9) {
	    trunc = true;
	    range.e.c = 9;
	  }
	  if (range.e.r > 49) {
	    trunc = true;
	    range.e.r = 49;
	  }
	  if (trunc)
	    console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));
	  var data = sheet_to_json(ws, { range: range, header: 1 });
	  var SST = ["~Sh33tJ5~"];
	  data.forEach(function(row) {
	    return row.forEach(function(cell) {
	      if (typeof cell == "string")
	        SST.push(cell);
	    });
	  });
	  var dependents = {};
	  var indices = [];
	  var cfb = CFB.read(opts.numbers, { type: "base64" });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (fi.type != 2)
	      return;
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var old_content = fi.content;
	    var raw1 = decompress_iwa_file(old_content);
	    var x2 = parse_iwa_file(raw1);
	    x2.forEach(function(packet2) {
	      indices.push(packet2.id);
	      dependents[packet2.id] = { deps: [], location: fp, type: varint_to_i32(packet2.messages[0].meta[1][0].data) };
	    });
	  });
	  indices.sort(function(x2, y2) {
	    return x2 - y2;
	  });
	  var indices_varint = indices.filter(function(x2) {
	    return x2 > 1;
	  }).map(function(x2) {
	    return [x2, write_varint49(x2)];
	  });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var x2 = parse_iwa_file(decompress_iwa_file(fi.content));
	    x2.forEach(function(ia) {
	      ia.messages.forEach(function(m) {
	        indices_varint.forEach(function(ivi) {
	          if (ia.messages.some(function(mess) {
	            return varint_to_i32(mess.meta[1][0].data) != 11006 && u8contains(mess.data, ivi[1]);
	          })) {
	            dependents[ivi[0]].deps.push(ia.id);
	          }
	        });
	      });
	    });
	  });
	  function get_unique_msgid() {
	    for (var i = 927262; i < 2e6; ++i)
	      if (!dependents[i])
	        return i;
	    throw new Error("Too many messages");
	  }
	  var entry = CFB.find(cfb, dependents[1].location);
	  var x = parse_iwa_file(decompress_iwa_file(entry.content));
	  var docroot;
	  for (var xi = 0; xi < x.length; ++xi) {
	    var packet = x[xi];
	    if (packet.id == 1)
	      docroot = packet;
	  }
	  var sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  var pb = parse_shallow(docroot.messages[0].data);
	  {
	    pb[6][0].data = write_varint49(range.e.r + 1);
	    pb[7][0].data = write_varint49(range.e.c + 1);
	    var cruidsref = parse_TSP_Reference(pb[46][0].data);
	    var oldbucket = CFB.find(cfb, dependents[cruidsref].location);
	    var _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	    {
	      for (var j = 0; j < _x.length; ++j) {
	        if (_x[j].id == cruidsref)
	          break;
	      }
	      if (_x[j].id != cruidsref)
	        throw "Bad ColumnRowUIDMapArchive";
	      var cruids = parse_shallow(_x[j].messages[0].data);
	      cruids[1] = [];
	      cruids[2] = [], cruids[3] = [];
	      for (var C = 0; C <= range.e.c; ++C) {
	        var uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(C + 420690) }];
	        cruids[1].push({ type: 2, data: write_shallow(uuid) });
	        cruids[2].push({ type: 0, data: write_varint49(C) });
	        cruids[3].push({ type: 0, data: write_varint49(C) });
	      }
	      cruids[4] = [];
	      cruids[5] = [], cruids[6] = [];
	      for (var R = 0; R <= range.e.r; ++R) {
	        uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(R + 726270) }];
	        cruids[4].push({ type: 2, data: write_shallow(uuid) });
	        cruids[5].push({ type: 0, data: write_varint49(R) });
	        cruids[6].push({ type: 0, data: write_varint49(R) });
	      }
	      _x[j].messages[0].data = write_shallow(cruids);
	    }
	    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	    oldbucket.size = oldbucket.content.length;
	    delete pb[46];
	    var store = parse_shallow(pb[4][0].data);
	    {
	      store[7][0].data = write_varint49(range.e.r + 1);
	      var row_headers = parse_shallow(store[1][0].data);
	      var row_header_ref = parse_TSP_Reference(row_headers[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[row_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != row_header_ref)
	          throw "Bad HeaderStorageBucket";
	        var base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (R = 0; R < data.length; ++R) {
	          var _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(R);
	          _bucket[4][0].data = write_varint49(data[R].length);
	          base_bucket[2][R] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var col_header_ref = parse_TSP_Reference(store[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[col_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != col_header_ref)
	          throw "Bad HeaderStorageBucket";
	        base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (C = 0; C <= range.e.c; ++C) {
	          _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(C);
	          _bucket[4][0].data = write_varint49(range.e.r + 1);
	          base_bucket[2][C] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var sstref = parse_TSP_Reference(store[4][0].data);
	      (function() {
	        var sentry = CFB.find(cfb, dependents[sstref].location);
	        var sx = parse_iwa_file(decompress_iwa_file(sentry.content));
	        var sstroot;
	        for (var sxi = 0; sxi < sx.length; ++sxi) {
	          var packet2 = sx[sxi];
	          if (packet2.id == sstref)
	            sstroot = packet2;
	        }
	        var sstdata = parse_shallow(sstroot.messages[0].data);
	        {
	          sstdata[3] = [];
	          var newsst = [];
	          SST.forEach(function(str, i) {
	            newsst[1] = [{ type: 0, data: write_varint49(i) }];
	            newsst[2] = [{ type: 0, data: write_varint49(1) }];
	            newsst[3] = [{ type: 2, data: stru8(str) }];
	            sstdata[3].push({ type: 2, data: write_shallow(newsst) });
	          });
	        }
	        sstroot.messages[0].data = write_shallow(sstdata);
	        var sy = write_iwa_file(sx);
	        var raw32 = compress_iwa_file(sy);
	        sentry.content = raw32;
	        sentry.size = sentry.content.length;
	      })();
	      var tile = parse_shallow(store[3][0].data);
	      {
	        var t = tile[1][0];
	        delete tile[2];
	        var tl = parse_shallow(t.data);
	        {
	          var tileref = parse_TSP_Reference(tl[2][0].data);
	          (function() {
	            var tentry = CFB.find(cfb, dependents[tileref].location);
	            var tx = parse_iwa_file(decompress_iwa_file(tentry.content));
	            var tileroot;
	            for (var sxi = 0; sxi < tx.length; ++sxi) {
	              var packet2 = tx[sxi];
	              if (packet2.id == tileref)
	                tileroot = packet2;
	            }
	            var tiledata = parse_shallow(tileroot.messages[0].data);
	            {
	              delete tiledata[6];
	              delete tile[7];
	              var rowload = new Uint8Array(tiledata[5][0].data);
	              tiledata[5] = [];
	              var cnt = 0;
	              for (var R2 = 0; R2 <= range.e.r; ++R2) {
	                var tilerow = parse_shallow(rowload);
	                cnt += write_tile_row(tilerow, data[R2], SST);
	                tilerow[1][0].data = write_varint49(R2);
	                tiledata[5].push({ data: write_shallow(tilerow), type: 2 });
	              }
	              tiledata[1] = [{ type: 0, data: write_varint49(range.e.c + 1) }];
	              tiledata[2] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	              tiledata[3] = [{ type: 0, data: write_varint49(cnt) }];
	              tiledata[4] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	            }
	            tileroot.messages[0].data = write_shallow(tiledata);
	            var ty = write_iwa_file(tx);
	            var raw32 = compress_iwa_file(ty);
	            tentry.content = raw32;
	            tentry.size = tentry.content.length;
	          })();
	        }
	        t.data = write_shallow(tl);
	      }
	      store[3][0].data = write_shallow(tile);
	    }
	    pb[4][0].data = write_shallow(store);
	  }
	  docroot.messages[0].data = write_shallow(pb);
	  var y = write_iwa_file(x);
	  var raw3 = compress_iwa_file(y);
	  entry.content = raw3;
	  entry.size = entry.content.length;
	  return cfb;
	}
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	function fix_read_opts(opts) {
	fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellText', true], /* emit formatted text as .w */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	
	function fix_write_opts(opts) {
	fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['compression', false], /* Use file compression */
	
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	function get_sheet_type(n) {
		if(RELS.WS.indexOf(n) > -1) return "sheet";
		if(RELS.CS && n == RELS.CS) return "chart";
		if(RELS.DS && n == RELS.DS) return "dialog";
		if(RELS.MS && n == RELS.MS) return "macro";
		return (n && n.length) ? n : "sheet";
	}
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
		try {
			sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
			var data = getzipdata(zip, path);
			var _ws;
			switch(stype) {
				case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
					if(!_ws || !_ws['!drawel']) break;
					var dfile = resolve_path(_ws['!drawel'].Target, path);
					var drelsp = get_rels_path(dfile);
					var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
					var chartp = resolve_path(draw, dfile);
					var crelsp = get_rels_path(chartp);
					_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
					break;
				case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				default: throw new Error("Unrecognized sheet type " + stype);
			}
			sheets[sheet] = _ws;
	
			/* scan rels for comments and threaded comments */
			var tcomments = [];
			if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
				var dfile = "";
				if(sheetRels[sheet][n].Type == RELS.CMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					var comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
					if(!comments || !comments.length) return;
					sheet_insert_comments(_ws, comments, false);
				}
				if(sheetRels[sheet][n].Type == RELS.TCMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
				}
			});
			if(tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }
	
	function parse_zip(zip, opts) {
		make_ssf();
		opts = opts || {};
		fix_read_opts(opts);
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
		/* UOC */
		if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
		/* Numbers */
		if(safegetzipfile(zip, 'Index/Document.iwa')) {
			if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
			if(typeof parse_numbers_iwa != "undefined") {
				if(zip.FileIndex) return parse_numbers_iwa(zip);
				var _zip = CFB.utils.cfb_new();
				zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
				return parse_numbers_iwa(_zip);
			}
			throw new Error('Unsupported NUMBERS file');
		}
		if(!safegetzipfile(zip, '[Content_Types].xml')) {
			if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
			if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
			throw new Error('Unsupported ZIP file');
		}
	
		var entries = zipentries(zip);
		var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;
	
		var themes = ({});
		var styles = ({});
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }
	
			if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);
	
			if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
		}
	
		/*var externbooks = */dir.links.map(function(link) {
			try {
				var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
				return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
			} catch(e) {}
		});
	
		var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length) {
			propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
				if(propdata) parse_ext_props(propdata, props, opts);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = ({});
		if(opts.bookSheets || opts.bookProps) {
			if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = ({});
		var path, relsPath;
	
		{
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsi = dir.workbooks[0].lastIndexOf("/");
		var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
		if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
	
		if((dir.metadata || []).length >= 1) {
			/* TODO: MDX and other types of metadata */
			opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);
		}
	
		if((dir.people || []).length >= 1) {
			opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])),opts);
		}
	
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
	
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		wsloop: for(i = 0; i != props.Worksheets; ++i) {
			var stype = "sheet";
			if(wbrels && wbrels[i]) {
				path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
				if(!safegetzipfile(zip, path)) path = wbrels[i][1];
				if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
				stype = wbrels[i][2];
			} else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			if(opts && opts.sheets != null) switch(typeof opts.sheets) {
				case "number": if(i != opts.sheets) continue wsloop; break;
				case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
				default: if(Array.isArray && Array.isArray(opts.sheets)) {
					var snjseen = false;
					for(var snj = 0; snj != opts.sheets.length; ++snj) {
						if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
						if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
					}
					if(!snjseen) continue wsloop;
				}
			}
			safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
		}
	
		out = ({
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: dup(table_fmt)
		});
		if(opts && opts.bookFiles) {
			if(zip.files) {
				out.keys = entries;
				out.files = zip.files;
			} else {
				out.keys = [];
				out.files = {};
				zip.FullPaths.forEach(function(p, idx) {
					p = p.replace(/^Root Entry[\/]/, "");
					out.keys.push(p);
					out.files[p] = zip.FileIndex[idx];
				});
			}
		}
		if(opts && opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
			else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
		}
		return out;
	}
	
	/* [MS-OFFCRYPTO] 2.1.1 */
	function parse_xlsxcfb(cfb, _opts) {
		var opts = _opts || {};
		var f = 'Workbook', data = CFB.find(cfb, f);
		try {
		f = '/!DataSpaces/Version';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var version = */parse_DataSpaceVersionInfo(data.content);
	
		/* 2.3.4.1 */
		f = '/!DataSpaces/DataSpaceMap';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var dsm = parse_DataSpaceMap(data.content);
		if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.2 */
		f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var seds = parse_DataSpaceDefinition(data.content);
		if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.3 */
		f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var hdr = */parse_Primary(data.content);
		} catch(e) {}
	
		f = '/EncryptionInfo';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var einfo = parse_EncryptionInfo(data.content);
	
		/* 2.3.4.4 */
		f = '/EncryptedPackage';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	
	/*global decrypt_agile */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
	/*global decrypt_std76 */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
		throw new Error("File is password-protected");
	}
	
	function write_zip(wb, opts) {
		if(opts.bookType == "ods") return write_ods(wb, opts);
		if(opts.bookType == "numbers") return write_numbers_iwa(wb, opts);
		if(opts.bookType == "xlsb") return write_zip_xlsxb(wb, opts);
		return write_zip_xlsx(wb, opts);
	}
	
	/* XLSX and XLSB writing are very similar.  Originally they were unified in one
	   export function.  This is horrible for tree shaking in the common case (most
	   applications need to export files in one format) so this function supports
	   both formats while write_zip_xlsx only handles XLSX */
	function write_zip_xlsxb(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta(f));
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function write_zip_xlsx(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		var people = ["SheetJ5"];
		opts.tcid = 0;
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws_xml(rId-1, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					var needtc = false;
					comments.forEach(function(carr) {
						carr[1].forEach(function(c) { if(c.T == true) needtc = true; });
					});
					if(needtc) {
						cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
						zip_add_file(zip, cf, write_tcmnt_xml(comments, people, opts));
						ct.threadedcomments.push(cf);
						add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, RELS.TCMNT);
					}
	
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_comments_xml(comments, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb_xml(wb, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty_xml(wb, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta_xml());
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		if(people.length > 1) {
			f = "xl/persons/person.xml";
			zip_add_file(zip, f, write_people_xml(people, opts));
			ct.people.push(f);
			add_rels(opts.wbrels, -1, "persons/person.xml", RELS.PEOPLE);
		}
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function firstbyte(f,o) {
		var x = "";
		switch((o||{}).type || "base64") {
			case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			case 'base64': x = Base64_decode(f.slice(0,12)); break;
			case 'binary': x = f; break;
			case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
		}
		return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
	}
	
	function read_cfb(cfb, opts) {
		if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
		return parse_xlscfb(cfb, opts);
	}
	
	function read_zip(data, opts) {
		var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		zip = zip_read(d, o);
		return parse_zip(zip, o);
	}
	
	function read_plaintext(data, o) {
		var i = 0;
		main: while(i < data.length) switch(data.charCodeAt(i)) {
			case 0x0A: case 0x0D: case 0x20: ++i; break;
			case 0x3C: return parse_xlml(data.slice(i),o);
			default: break main;
		}
		return PRN.to_workbook(data, o);
	}
	
	function read_plaintext_raw(data, o) {
		var str = "", bytes = firstbyte(data, o);
		switch(o.type) {
			case 'base64': str = Base64_decode(data); break;
			case 'binary': str = data; break;
			case 'buffer': str = data.toString('binary'); break;
			case 'array': str = cc2str(data); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
		o.type = "binary";
		return read_plaintext(str, o);
	}
	
	function read_utf16(data, o) {
		var d = data;
		if(o.type == 'base64') d = Base64_decode(d);
		d = $cptable.utils.decode(1200, d.slice(2), 'str');
		o.type = "binary";
		return read_plaintext(d, o);
	}
	
	function bstrify(data) {
		return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
	}
	
	function read_prn(data, d, o, str) {
		if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
		return PRN.to_workbook(d, o);
	}
	
	function readSync(data, opts) {
		reset_cp();
		var o = opts||{};
		if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
		if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
		var d = data, n = [0,0,0,0], str = false;
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		_ssfopts = {};
		if(o.dateNF) _ssfopts.dateNF = o.dateNF;
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
		if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
		if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
			// $FlowIgnore
			var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
			// $FlowIgnore
			if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
		}
		switch((n = firstbyte(d, o))[0]) {
			case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
			case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
			case 0x3C: return parse_xlml(d, o);
			case 0x49:
				if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
				if(n[1] === 0x44) return read_wb_ID(d, o);
				break;
			case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
			case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
			case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
			case 0xFF:
				if(n[1] === 0xFE) { return read_utf16(d, o); }
				else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				break;
			case 0x00:
				if(n[1] === 0x00) {
					if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
					if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
				}
				break;
			case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
			case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
			case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
			case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
		}
		if(DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
		return read_prn(data, d, o, str);
	}
	
	function readFileSync(filename, opts) {
		var o = opts||{}; o.type = 'file';
		return readSync(filename, o);
	}
	function write_cfb_ctr(cfb, o) {
		switch(o.type) {
			case "base64": case "binary": break;
			case "buffer": case "array": o.type = ""; break;
			case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			default: throw new Error("Unrecognized type " + o.type);
		}
		return CFB.write(cfb, o);
	}
	
	function write_zip_type(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_typeXLSX(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip_xlsx(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_denouement(z, o) {
		var oopts = {};
		var ftype = has_buf ? "nodebuffer" : (typeof Uint8Array !== "undefined" ? "array" : "string");
		if(o.compression) oopts.compression = 'DEFLATE';
		if(o.password) oopts.type = ftype;
		else switch(o.type) {
			case "base64": oopts.type = "base64"; break;
			case "binary": oopts.type = "string"; break;
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			case "buffer":
			case "file": oopts.type = ftype; break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: {"nodebuffer": "buffer", "string": "binary"}[oopts.type] || oopts.type, compression: !!o.compression}) : z.generate(oopts);
		if(typeof Deno !== "undefined") {
			if(typeof out == "string") {
				if(o.type == "binary" || o.type == "base64") return out;
				out = new Uint8Array(s2ab(out));
			}
		}
	/*jshint -W083 */
		if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
	/*jshint +W083 */
		if(o.type === "file") return write_dl(o.file, out);
		return o.type == "string" ? utf8read(out) : out;
	}
	
	function write_cfb_type(wb, opts) {
		var o = opts||{};
		var cfb = write_xlscfb(wb, o);
		return write_cfb_ctr(cfb, o);
	}
	
	function write_string_type(out, opts, bom) {
		if(!bom) bom = "";
		var o = bom + out;
		switch(opts.type) {
			case "base64": return Base64_encode(utf8write(o));
			case "binary": return utf8write(o);
			case "string": return out;
			case "file": return write_dl(opts.file, o, 'utf8');
			case "buffer": {
				if(has_buf) return Buffer_from(o, 'utf8');
				else if(typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
				else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	function write_stxt_type(out, opts) {
		switch(opts.type) {
			case "base64": return Base64_encode(out);
			case "binary": return out;
			case "string": return out; /* override in sheet_to_txt */
			case "file": return write_dl(opts.file, out, 'binary');
			case "buffer": {
				if(has_buf) return Buffer_from(out, 'binary');
				else return out.split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	/* TODO: test consistency */
	function write_binary_type(out, opts) {
		switch(opts.type) {
			case "string":
			case "base64":
			case "binary":
				var bstr = "";
				// $FlowIgnore
				for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
				return opts.type == 'base64' ? Base64_encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
			case "file": return write_dl(opts.file, out);
			case "buffer": return out;
			default: throw new Error("Unrecognized type " + opts.type);
		}
	}
	
	function writeSyncXLSX(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSyncXLSX(wb, o)); o.type = "array"; return s2ab(out); }
		return write_zip_typeXLSX(wb, o);
	}
	
	function writeSync(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
		var idx = 0;
		if(o.sheet) {
			if(typeof o.sheet == "number") idx = o.sheet;
			else idx = wb.SheetNames.indexOf(o.sheet);
			if(!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + (typeof o.sheet));
		}
		switch(o.bookType || 'xlsb') {
			case 'xml':
			case 'xlml': return write_string_type(write_xlml(wb, o), o);
			case 'slk':
			case 'sylk': return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'htm':
			case 'html': return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'txt': return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'csv': return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
			case 'dif': return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'dbf': return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'prn': return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'rtf': return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'eth': return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'fods': return write_string_type(write_ods(wb, o), o);
			case 'wk1': return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
			case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
			case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
			case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
			case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
			case 'biff8':
			case 'xla':
			case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
			case 'xlsx':
			case 'xlsm':
			case 'xlam':
			case 'xlsb':
			case 'numbers':
			case 'ods': return write_zip_type(wb, o);
			default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
		}
	}
	
	function resolve_book_type(o) {
		if(o.bookType) return;
		var _BT = {
			"xls": "biff8",
			"htm": "html",
			"slk": "sylk",
			"socialcalc": "eth",
			"Sh33tJS": "WTF"
		};
		var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
		if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
		o.bookType = _BT[o.bookType] || o.bookType;
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSync(wb, o);
	}
	
	function writeFileSyncXLSX(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSyncXLSX(wb, o);
	}
	
	
	function writeFileAsync(filename, wb, opts, cb) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		o.type = 'buffer';
		var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
		return _fs.writeFile(filename, writeSync(wb, o), _cb);
	}
	function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
		var rr = encode_row(R);
		var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
		var isempty = true;
		var row = (header === 1) ? [] : {};
		if(header !== 1) {
			if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
			else row.__rowNum__ = R;
		}
		if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
			var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			if(val === undefined || val.t === undefined) {
				if(defval === undefined) continue;
				if(hdr[C] != null) { row[hdr[C]] = defval; }
				continue;
			}
			var v = val.v;
			switch(val.t){
				case 'z': if(v == null) break; continue;
				case 'e': v = (v == 0 ? null : void 0); break;
				case 's': case 'd': case 'b': case 'n': break;
				default: throw new Error('unrecognized type ' + val.t);
			}
			if(hdr[C] != null) {
				if(v == null) {
					if(val.t == "e" && v === null) row[hdr[C]] = null;
					else if(defval !== undefined) row[hdr[C]] = defval;
					else if(raw && v === null) row[hdr[C]] = null;
					else continue;
				} else {
					row[hdr[C]] = raw && (val.t !== "n" || (val.t === "n" && o.rawNumbers !== false)) ? v : format_cell(val,v,o);
				}
				if(v != null) isempty = false;
			}
		}
		return { row: row, isempty: isempty };
	}
	
	
	function sheet_to_json(sheet, opts) {
		if(sheet == null || sheet["!ref"] == null) return [];
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		else if(o.header == null) header = 0;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var out = [];
		var outi = 0, counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
		}
		out.length = outi;
		return out;
	}
	
	var qreg = /"/g;
	function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
		var isempty = true;
		var row = [], txt = "", rr = encode_row(R);
		for(var C = r.s.c; C <= r.e.c; ++C) {
			if (!cols[C]) continue;
			var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
			if(val == null) txt = "";
			else if(val.v != null) {
				isempty = false;
				txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
				for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				if(txt == "ID") txt = '"ID"';
			} else if(val.f != null && !val.F) {
				isempty = false;
				txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
			} else txt = "";
			/* NOTE: Excel CSV does not support array formulae */
			row.push(txt);
		}
		if(o.blankrows === false && isempty) return null;
		return row.join(FS);
	}
	
	function sheet_to_csv(sheet, opts) {
		var out = [];
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var w = 0;
		for(var R = r.s.r; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
			if(row == null) { continue; }
			if(o.strip) row = row.replace(endregex,"");
			if(row || (o.blankrows !== false)) out.push((w++ ? RS : "") + row);
		}
		delete o.dense;
		return out.join("");
	}
	
	function sheet_to_txt(sheet, opts) {
		if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
		var s = sheet_to_csv(sheet, opts);
		if(typeof $cptable == 'undefined' || opts.type == 'string') return s;
		var o = $cptable.utils.encode(1200, s, 'str');
		return String.fromCharCode(255) + String.fromCharCode(254) + o;
	}
	
	function sheet_to_formulae(sheet) {
		var y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return [];
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		var cmds = [];
		var dense = Array.isArray(sheet);
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = dense ? (sheet[R]||[])[C] : sheet[y];
				val = "";
				if(x === undefined) continue;
				else if(x.F != null) {
					y = x.F;
					if(!x.f) continue;
					val = x.f;
					if(y.indexOf(":") == -1) y = y + ":" + y;
				}
				if(x.f != null) val = x.f;
				else if(x.t == 'z') continue;
				else if(x.t == 'n' && x.v != null) val = "" + x.v;
				else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else if(x.t == 's') val = "'" + x.v;
				else val = ""+x.v;
				cmds[cmds.length] = y + "=" + val;
			}
		}
		return cmds;
	}
	
	function sheet_add_json(_ws, js, opts) {
		var o = opts || {};
		var offset = +!o.skipHeader;
		var ws = _ws || ({});
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var cell;
		var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
		} else {
			if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
		}
		var hdr = o.header || [], C = 0;
	
		js.forEach(function (JS, R) {
			keys(JS).forEach(function(k) {
				if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
				var v = JS[k];
				var t = 'z';
				var z = "";
				var ref = encode_cell({c:_C + C,r:_R + R + offset});
				cell = ws_get_cell_stub(ws, ref);
				if(v && typeof v === 'object' && !(v instanceof Date)){
					ws[ref] = v;
				} else {
					if(typeof v == 'number') t = 'n';
					else if(typeof v == 'boolean') t = 'b';
					else if(typeof v == 'string') t = 's';
					else if(v instanceof Date) {
						t = 'd';
						if(!o.cellDates) { t = 'n'; v = datenum(v); }
						z = (o.dateNF || table_fmt[14]);
					}
					else if(v === null && o.nullError) { t = 'e'; v = 0; }
					if(!cell) ws[ref] = cell = ({t:t, v:v});
					else {
						cell.t = t; cell.v = v;
						delete cell.w; delete cell.R;
						if(z) cell.z = z;
					}
					if(z) cell.z = z;
				}
			});
		});
		range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
		var __R = encode_row(_R);
		if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }
	
	/* get cell, creating a stub if necessary */
	function ws_get_cell_stub(ws, R, C) {
		/* A1 cell address */
		if(typeof R == "string") {
			/* dense */
			if(Array.isArray(ws)) {
				var RC = decode_cell(R);
				if(!ws[RC.r]) ws[RC.r] = [];
				return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
			}
			return ws[R] || (ws[R] = {t:'z'});
		}
		/* cell address object */
		if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
		/* R and C are 0-based indices */
		return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
	}
	
	/* find sheet index for given name / validate index */
	function wb_sheet_idx(wb, sh) {
		if(typeof sh == "number") {
			if(sh >= 0 && wb.SheetNames.length > sh) return sh;
			throw new Error("Cannot find sheet # " + sh);
		} else if(typeof sh == "string") {
			var idx = wb.SheetNames.indexOf(sh);
			if(idx > -1) return idx;
			throw new Error("Cannot find sheet name |" + sh + "|");
		} else throw new Error("Cannot find sheet |" + sh + "|");
	}
	
	/* simple blank workbook object */
	function book_new() {
		return { SheetNames: [], Sheets: {} };
	}
	
	/* add a worksheet to the end of a given workbook */
	function book_append_sheet(wb, ws, name, roll) {
		var i = 1;
		if(!name) for(; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
		if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
		if(roll && wb.SheetNames.indexOf(name) >= 0) {
			var m = name.match(/(^.*?)(\d+)$/);
			i = m && +m[2] || 0;
			var root = m && m[1] || name;
			for(++i; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = root + i) == -1) break;
		}
		check_ws_name(name);
		if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
	
		wb.SheetNames.push(name);
		wb.Sheets[name] = ws;
		return name;
	}
	
	/* set sheet visibility (visible/hidden/very hidden) */
	function book_set_sheet_visibility(wb, sh, vis) {
		if(!wb.Workbook) wb.Workbook = {};
		if(!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
	
		var idx = wb_sheet_idx(wb, sh);
		// $FlowIgnore
		if(!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
	
		switch(vis) {
			case 0: case 1: case 2: break;
			default: throw new Error("Bad sheet visibility setting " + vis);
		}
		// $FlowIgnore
		wb.Workbook.Sheets[idx].Hidden = vis;
	}
	
	/* set number format */
	function cell_set_number_format(cell, fmt) {
		cell.z = fmt;
		return cell;
	}
	
	/* set cell hyperlink */
	function cell_set_hyperlink(cell, target, tooltip) {
		if(!target) {
			delete cell.l;
		} else {
			cell.l = ({ Target: target });
			if(tooltip) cell.l.Tooltip = tooltip;
		}
		return cell;
	}
	function cell_set_internal_link(cell, range, tooltip) { return cell_set_hyperlink(cell, "#" + range, tooltip); }
	
	/* add to cell comments */
	function cell_add_comment(cell, text, author) {
		if(!cell.c) cell.c = [];
		cell.c.push({t:text, a:author||"SheetJS"});
	}
	
	/* set array formula and flush related cells */
	function sheet_set_array_formula(ws, range, formula, dynamic) {
		var rng = typeof range != "string" ? range : safe_decode_range(range);
		var rngstr = typeof range == "string" ? range : encode_range(range);
		for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
			var cell = ws_get_cell_stub(ws, R, C);
			cell.t = 'n';
			cell.F = rngstr;
			delete cell.v;
			if(R == rng.s.r && C == rng.s.c) {
				cell.f = formula;
				if(dynamic) cell.D = true;
			}
		}
		return ws;
	}
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		sheet_add_aoa: sheet_add_aoa,
		sheet_add_json: sheet_add_json,
		sheet_add_dom: sheet_add_dom,
		aoa_to_sheet: aoa_to_sheet,
		json_to_sheet: json_to_sheet,
		table_to_sheet: parse_dom_table,
		table_to_book: table_to_book,
		sheet_to_csv: sheet_to_csv,
		sheet_to_txt: sheet_to_txt,
		sheet_to_json: sheet_to_json,
		sheet_to_html: sheet_to_html,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_json,
		sheet_get_cell: ws_get_cell_stub,
		book_new: book_new,
		book_append_sheet: book_append_sheet,
		book_set_sheet_visibility: book_set_sheet_visibility,
		cell_set_number_format: cell_set_number_format,
		cell_set_hyperlink: cell_set_hyperlink,
		cell_set_internal_link: cell_set_internal_link,
		cell_add_comment: cell_add_comment,
		sheet_set_array_formula: sheet_set_array_formula,
		consts: {
			SHEET_VISIBLE: 0,
			SHEET_HIDDEN: 1,
			SHEET_VERY_HIDDEN: 2
		}
	};
	
	var _Readable;
	function set_readable(R) { _Readable = R; }
	
	function write_csv_stream(sheet, opts) {
		var stream = _Readable();
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var R = r.s.r;
		var BOM = false, w = 0;
		stream._read = function() {
			if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
			while(R <= r.e.r) {
				++R;
				if ((rowinfo[R-1]||{}).hidden) continue;
				row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
				if(row != null) {
					if(o.strip) row = row.replace(endregex,"");
					if(row || (o.blankrows !== false)) return stream.push((w++ ? RS : "") + row);
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	function write_html_stream(ws, opts) {
		var stream = _Readable();
	
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		stream.push(header);
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		stream.push(make_html_preamble(ws, r, o));
		var R = r.s.r;
		var end = false;
		stream._read = function() {
			if(R > r.e.r) {
				if(!end) { end = true; stream.push("</table>" + footer); }
				return stream.push(null);
			}
			while(R <= r.e.r) {
				stream.push(make_html_row(ws, r, R, o));
				++R;
				break;
			}
		};
		return stream;
	}
	
	function write_json_stream(sheet, opts) {
		var stream = _Readable({objectMode:true});
	
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		R = r.s.r + offset;
		stream._read = function() {
			while(R <= r.e.r) {
				if ((rowinfo[R-1]||{}).hidden) continue;
				var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
				++R;
				if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
					stream.push(row.row);
					return;
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	var __stream = {
		to_json: write_json_stream,
		to_html: write_html_stream,
		to_csv: write_csv_stream,
	  set_readable: set_readable
	};
	if(typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.writeFileAsync = writeFileAsync;
	XLSX.utils = utils;
	XLSX.writeXLSX = writeSyncXLSX;
	XLSX.writeFileXLSX = writeFileSyncXLSX;
	XLSX.SSF = SSF;
	if(typeof __stream !== "undefined") XLSX.stream = __stream;
	if(typeof CFB !== "undefined") XLSX.CFB = CFB;
	if(true) {
	  var strmod = __webpack_require__(717);
	  if((strmod||{}).Readable) set_readable(strmod.Readable);
	}
	}
	/*global define */
	if(true) make_xlsx_lib(exports);
	else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
	else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
	else make_xlsx_lib(XLSX);
	/* NOTE: the following extra line is needed for "Lightning Locker Service" */
	if(typeof window !== 'undefined' && !window.XLSX) try { window.XLSX = XLSX; } catch(e) {}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101).Buffer, __webpack_require__(63)))

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FormatNumericToString = void 0;
	var _262_1 = __webpack_require__(31);
	var ToRawPrecision_1 = __webpack_require__(131);
	var utils_1 = __webpack_require__(32);
	var ToRawFixed_1 = __webpack_require__(67);
	/**
	 * https://tc39.es/ecma402/#sec-formatnumberstring
	 */
	function FormatNumericToString(intlObject, x) {
	    var isNegative = x < 0 || (0, _262_1.SameValue)(x, -0);
	    if (isNegative) {
	        x = -x;
	    }
	    var result;
	    var rourndingType = intlObject.roundingType;
	    switch (rourndingType) {
	        case 'significantDigits':
	            result = (0, ToRawPrecision_1.ToRawPrecision)(x, intlObject.minimumSignificantDigits, intlObject.maximumSignificantDigits);
	            break;
	        case 'fractionDigits':
	            result = (0, ToRawFixed_1.ToRawFixed)(x, intlObject.minimumFractionDigits, intlObject.maximumFractionDigits);
	            break;
	        default:
	            result = (0, ToRawPrecision_1.ToRawPrecision)(x, 1, 2);
	            if (result.integerDigitsCount > 1) {
	                result = (0, ToRawFixed_1.ToRawFixed)(x, 0, 0);
	            }
	            break;
	    }
	    x = result.roundedNumber;
	    var string = result.formattedString;
	    var int = result.integerDigitsCount;
	    var minInteger = intlObject.minimumIntegerDigits;
	    if (int < minInteger) {
	        var forwardZeros = (0, utils_1.repeat)('0', minInteger - int);
	        string = forwardZeros + string;
	    }
	    if (isNegative) {
	        x = -x;
	    }
	    return { roundedNumber: x, formattedString: string };
	}
	exports.FormatNumericToString = FormatNumericToString;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ToRawFixed = void 0;
	var utils_1 = __webpack_require__(32);
	/**
	 * TODO: dedup with intl-pluralrules and support BigInt
	 * https://tc39.es/ecma402/#sec-torawfixed
	 * @param x a finite non-negative Number or BigInt
	 * @param minFraction and integer between 0 and 20
	 * @param maxFraction and integer between 0 and 20
	 */
	function ToRawFixed(x, minFraction, maxFraction) {
	    var f = maxFraction;
	    var n = Math.round(x * Math.pow(10, f));
	    var xFinal = n / Math.pow(10, f);
	    // n is a positive integer, but it is possible to be greater than 1e21.
	    // In such case we will go the slow path.
	    // See also: https://tc39.es/ecma262/#sec-numeric-types-number-tostring
	    var m;
	    if (n < 1e21) {
	        m = n.toString();
	    }
	    else {
	        m = n.toString();
	        var _a = m.split('e'), mantissa = _a[0], exponent = _a[1];
	        m = mantissa.replace('.', '');
	        m = m + (0, utils_1.repeat)('0', Math.max(+exponent - m.length + 1, 0));
	    }
	    var int;
	    if (f !== 0) {
	        var k = m.length;
	        if (k <= f) {
	            var z = (0, utils_1.repeat)('0', f + 1 - k);
	            m = z + m;
	            k = f + 1;
	        }
	        var a = m.slice(0, k - f);
	        var b = m.slice(k - f);
	        m = "".concat(a, ".").concat(b);
	        int = a.length;
	    }
	    else {
	        int = m.length;
	    }
	    var cut = maxFraction - minFraction;
	    while (cut > 0 && m[m.length - 1] === '0') {
	        m = m.slice(0, -1);
	        cut--;
	    }
	    if (m[m.length - 1] === '.') {
	        m = m.slice(0, -1);
	    }
	    return { formattedString: m, roundedNumber: xFinal, integerDigitsCount: int };
	}
	exports.ToRawFixed = ToRawFixed;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.invariant = exports.isMissingLocaleDataError = exports.defineProperty = exports.getMagnitude = exports.setMultiInternalSlots = exports.setInternalSlot = exports.isLiteralPart = exports.getMultiInternalSlots = exports.getInternalSlot = exports._formatToParts = void 0;
	var tslib_1 = __webpack_require__(69);
	(0, tslib_1.__exportStar)(__webpack_require__(118), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(230), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(119), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(121), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(54), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(231), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(122), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(232), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(123), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(124), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(125), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(126), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(127), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(233), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(66), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(234), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(128), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(129), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(130), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(67), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(131), exports);
	var format_to_parts_1 = __webpack_require__(132);
	Object.defineProperty(exports, "_formatToParts", { enumerable: true, get: function () { return (0, tslib_1.__importDefault)(format_to_parts_1).default; } });
	(0, tslib_1.__exportStar)(__webpack_require__(236), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(237), exports);
	var utils_1 = __webpack_require__(32);
	Object.defineProperty(exports, "getInternalSlot", { enumerable: true, get: function () { return utils_1.getInternalSlot; } });
	Object.defineProperty(exports, "getMultiInternalSlots", { enumerable: true, get: function () { return utils_1.getMultiInternalSlots; } });
	Object.defineProperty(exports, "isLiteralPart", { enumerable: true, get: function () { return utils_1.isLiteralPart; } });
	Object.defineProperty(exports, "setInternalSlot", { enumerable: true, get: function () { return utils_1.setInternalSlot; } });
	Object.defineProperty(exports, "setMultiInternalSlots", { enumerable: true, get: function () { return utils_1.setMultiInternalSlots; } });
	Object.defineProperty(exports, "getMagnitude", { enumerable: true, get: function () { return utils_1.getMagnitude; } });
	Object.defineProperty(exports, "defineProperty", { enumerable: true, get: function () { return utils_1.defineProperty; } });
	var data_1 = __webpack_require__(238);
	Object.defineProperty(exports, "isMissingLocaleDataError", { enumerable: true, get: function () { return data_1.isMissingLocaleDataError; } });
	(0, tslib_1.__exportStar)(__webpack_require__(245), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(240), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(242), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(244), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(243), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(241), exports);
	var utils_2 = __webpack_require__(32);
	Object.defineProperty(exports, "invariant", { enumerable: true, get: function () { return utils_2.invariant; } });
	(0, tslib_1.__exportStar)(__webpack_require__(31), exports);


/***/ },
/* 69 */
29,
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parse = void 0;
	var tslib_1 = __webpack_require__(135);
	var error_1 = __webpack_require__(134);
	var parser_1 = __webpack_require__(247);
	var types_1 = __webpack_require__(71);
	function pruneLocation(els) {
	    els.forEach(function (el) {
	        delete el.location;
	        if ((0, types_1.isSelectElement)(el) || (0, types_1.isPluralElement)(el)) {
	            for (var k in el.options) {
	                delete el.options[k].location;
	                pruneLocation(el.options[k].value);
	            }
	        }
	        else if ((0, types_1.isNumberElement)(el) && (0, types_1.isNumberSkeleton)(el.style)) {
	            delete el.style.location;
	        }
	        else if (((0, types_1.isDateElement)(el) || (0, types_1.isTimeElement)(el)) &&
	            (0, types_1.isDateTimeSkeleton)(el.style)) {
	            delete el.style.location;
	        }
	        else if ((0, types_1.isTagElement)(el)) {
	            pruneLocation(el.children);
	        }
	    });
	}
	function parse(message, opts) {
	    if (opts === void 0) { opts = {}; }
	    opts = (0, tslib_1.__assign)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
	    var result = new parser_1.Parser(message, opts).parse();
	    if (result.err) {
	        var error = SyntaxError(error_1.ErrorKind[result.err.kind]);
	        // @ts-expect-error Assign to error object
	        error.location = result.err.location;
	        // @ts-expect-error Assign to error object
	        error.originalMessage = result.err.message;
	        throw error;
	    }
	    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
	        pruneLocation(result.val);
	    }
	    return result.val;
	}
	exports.parse = parse;
	(0, tslib_1.__exportStar)(__webpack_require__(71), exports);


/***/ },
/* 71 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createNumberElement = exports.createLiteralElement = exports.isDateTimeSkeleton = exports.isNumberSkeleton = exports.isTagElement = exports.isPoundElement = exports.isPluralElement = exports.isSelectElement = exports.isTimeElement = exports.isDateElement = exports.isNumberElement = exports.isArgumentElement = exports.isLiteralElement = exports.SKELETON_TYPE = exports.TYPE = void 0;
	var TYPE;
	(function (TYPE) {
	    /**
	     * Raw text
	     */
	    TYPE[TYPE["literal"] = 0] = "literal";
	    /**
	     * Variable w/o any format, e.g `var` in `this is a {var}`
	     */
	    TYPE[TYPE["argument"] = 1] = "argument";
	    /**
	     * Variable w/ number format
	     */
	    TYPE[TYPE["number"] = 2] = "number";
	    /**
	     * Variable w/ date format
	     */
	    TYPE[TYPE["date"] = 3] = "date";
	    /**
	     * Variable w/ time format
	     */
	    TYPE[TYPE["time"] = 4] = "time";
	    /**
	     * Variable w/ select format
	     */
	    TYPE[TYPE["select"] = 5] = "select";
	    /**
	     * Variable w/ plural format
	     */
	    TYPE[TYPE["plural"] = 6] = "plural";
	    /**
	     * Only possible within plural argument.
	     * This is the `#` symbol that will be substituted with the count.
	     */
	    TYPE[TYPE["pound"] = 7] = "pound";
	    /**
	     * XML-like tag
	     */
	    TYPE[TYPE["tag"] = 8] = "tag";
	})(TYPE = exports.TYPE || (exports.TYPE = {}));
	var SKELETON_TYPE;
	(function (SKELETON_TYPE) {
	    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
	    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
	})(SKELETON_TYPE = exports.SKELETON_TYPE || (exports.SKELETON_TYPE = {}));
	/**
	 * Type Guards
	 */
	function isLiteralElement(el) {
	    return el.type === TYPE.literal;
	}
	exports.isLiteralElement = isLiteralElement;
	function isArgumentElement(el) {
	    return el.type === TYPE.argument;
	}
	exports.isArgumentElement = isArgumentElement;
	function isNumberElement(el) {
	    return el.type === TYPE.number;
	}
	exports.isNumberElement = isNumberElement;
	function isDateElement(el) {
	    return el.type === TYPE.date;
	}
	exports.isDateElement = isDateElement;
	function isTimeElement(el) {
	    return el.type === TYPE.time;
	}
	exports.isTimeElement = isTimeElement;
	function isSelectElement(el) {
	    return el.type === TYPE.select;
	}
	exports.isSelectElement = isSelectElement;
	function isPluralElement(el) {
	    return el.type === TYPE.plural;
	}
	exports.isPluralElement = isPluralElement;
	function isPoundElement(el) {
	    return el.type === TYPE.pound;
	}
	exports.isPoundElement = isPoundElement;
	function isTagElement(el) {
	    return el.type === TYPE.tag;
	}
	exports.isTagElement = isTagElement;
	function isNumberSkeleton(el) {
	    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
	}
	exports.isNumberSkeleton = isNumberSkeleton;
	function isDateTimeSkeleton(el) {
	    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
	}
	exports.isDateTimeSkeleton = isDateTimeSkeleton;
	function createLiteralElement(value) {
	    return {
	        type: TYPE.literal,
	        value: value,
	    };
	}
	exports.createLiteralElement = createLiteralElement;
	function createNumberElement(value, style) {
	    return {
	        type: TYPE.number,
	        value: value,
	        style: style,
	    };
	}
	exports.createNumberElement = createNumberElement;


/***/ },
/* 72 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BestAvailableLocale = void 0;
	/**
	 * https://tc39.es/ecma402/#sec-bestavailablelocale
	 * @param availableLocales
	 * @param locale
	 */
	function BestAvailableLocale(availableLocales, locale) {
	    var candidate = locale;
	    while (true) {
	        if (availableLocales.has(candidate)) {
	            return candidate;
	        }
	        var pos = candidate.lastIndexOf('-');
	        if (!~pos) {
	            return undefined;
	        }
	        if (pos >= 2 && candidate[pos - 2] === '-') {
	            pos -= 2;
	        }
	        candidate = candidate.slice(0, pos);
	    }
	}
	exports.BestAvailableLocale = BestAvailableLocale;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createIntl = exports.formatNumberToParts = exports.formatNumber = exports.formatRelativeTime = exports.formatPlural = exports.formatList = exports.formatDisplayName = exports.formatTimeToParts = exports.formatTime = exports.formatDateToParts = exports.formatDate = exports.formatMessage = exports.getNamedFormat = exports.createFormatters = exports.DEFAULT_INTL_CONFIG = exports.filterProps = exports.createIntlCache = exports.defineMessage = exports.defineMessages = void 0;
	var tslib_1 = __webpack_require__(35);
	(0, tslib_1.__exportStar)(__webpack_require__(260), exports);
	function defineMessages(msgs) {
	    return msgs;
	}
	exports.defineMessages = defineMessages;
	function defineMessage(msg) {
	    return msg;
	}
	exports.defineMessage = defineMessage;
	var utils_1 = __webpack_require__(33);
	Object.defineProperty(exports, "createIntlCache", { enumerable: true, get: function () { return utils_1.createIntlCache; } });
	Object.defineProperty(exports, "filterProps", { enumerable: true, get: function () { return utils_1.filterProps; } });
	Object.defineProperty(exports, "DEFAULT_INTL_CONFIG", { enumerable: true, get: function () { return utils_1.DEFAULT_INTL_CONFIG; } });
	Object.defineProperty(exports, "createFormatters", { enumerable: true, get: function () { return utils_1.createFormatters; } });
	Object.defineProperty(exports, "getNamedFormat", { enumerable: true, get: function () { return utils_1.getNamedFormat; } });
	(0, tslib_1.__exportStar)(__webpack_require__(25), exports);
	var message_1 = __webpack_require__(142);
	Object.defineProperty(exports, "formatMessage", { enumerable: true, get: function () { return message_1.formatMessage; } });
	var dateTime_1 = __webpack_require__(139);
	Object.defineProperty(exports, "formatDate", { enumerable: true, get: function () { return dateTime_1.formatDate; } });
	Object.defineProperty(exports, "formatDateToParts", { enumerable: true, get: function () { return dateTime_1.formatDateToParts; } });
	Object.defineProperty(exports, "formatTime", { enumerable: true, get: function () { return dateTime_1.formatTime; } });
	Object.defineProperty(exports, "formatTimeToParts", { enumerable: true, get: function () { return dateTime_1.formatTimeToParts; } });
	var displayName_1 = __webpack_require__(140);
	Object.defineProperty(exports, "formatDisplayName", { enumerable: true, get: function () { return displayName_1.formatDisplayName; } });
	var list_1 = __webpack_require__(141);
	Object.defineProperty(exports, "formatList", { enumerable: true, get: function () { return list_1.formatList; } });
	var plural_1 = __webpack_require__(144);
	Object.defineProperty(exports, "formatPlural", { enumerable: true, get: function () { return plural_1.formatPlural; } });
	var relativeTime_1 = __webpack_require__(145);
	Object.defineProperty(exports, "formatRelativeTime", { enumerable: true, get: function () { return relativeTime_1.formatRelativeTime; } });
	var number_1 = __webpack_require__(143);
	Object.defineProperty(exports, "formatNumber", { enumerable: true, get: function () { return number_1.formatNumber; } });
	Object.defineProperty(exports, "formatNumberToParts", { enumerable: true, get: function () { return number_1.formatNumberToParts; } });
	var create_intl_1 = __webpack_require__(259);
	Object.defineProperty(exports, "createIntl", { enumerable: true, get: function () { return create_intl_1.createIntl; } });


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	var parsers_1 = __webpack_require__(147);
	var tracekit_1 = __webpack_require__(76);
	/**
	 * Builds and Event from a Exception
	 * @hidden
	 */
	function eventFromException(options, exception, hint) {
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromUnknownInput(exception, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    utils_1.addExceptionMechanism(event, {
	        handled: true,
	        type: 'generic',
	    });
	    event.level = types_1.Severity.Error;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromException = eventFromException;
	/**
	 * Builds and Event from a Message
	 * @hidden
	 */
	function eventFromMessage(options, message, level, hint) {
	    if (level === void 0) { level = types_1.Severity.Info; }
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromString(message, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    event.level = level;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromMessage = eventFromMessage;
	/**
	 * @hidden
	 */
	function eventFromUnknownInput(exception, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event;
	    if (utils_1.isErrorEvent(exception) && exception.error) {
	        // If it is an ErrorEvent with `error` property, extract it to get actual Error
	        var errorEvent = exception;
	        // eslint-disable-next-line no-param-reassign
	        exception = errorEvent.error;
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
	        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
	        // then we just extract the name, code, and message, as they don't provide anything else
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	        var domException = exception;
	        var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
	        var message = domException.message ? name_1 + ": " + domException.message : name_1;
	        event = eventFromString(message, syntheticException, options);
	        utils_1.addExceptionTypeValue(event, message);
	        if ('code' in domException) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
	        }
	        return event;
	    }
	    if (utils_1.isError(exception)) {
	        // we have a real Error object, do nothing
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
	        // If it is plain Object or Event, serialize it manually and extract options
	        // This will allow us to group events based on top-level keys
	        // which is much better than creating new group when any key/value change
	        var objectException = exception;
	        event = parsers_1.eventFromPlainObject(objectException, syntheticException, options.rejection);
	        utils_1.addExceptionMechanism(event, {
	            synthetic: true,
	        });
	        return event;
	    }
	    // If none of previous checks were valid, then it means that it's not:
	    // - an instance of DOMError
	    // - an instance of DOMException
	    // - an instance of Event
	    // - an instance of Error
	    // - a valid ErrorEvent (one with an error property)
	    // - a plain Object
	    //
	    // So bail out and capture it as a simple message:
	    event = eventFromString(exception, syntheticException, options);
	    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
	    utils_1.addExceptionMechanism(event, {
	        synthetic: true,
	    });
	    return event;
	}
	exports.eventFromUnknownInput = eventFromUnknownInput;
	/**
	 * @hidden
	 */
	function eventFromString(input, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event = {
	        message: input,
	    };
	    if (options.attachStacktrace && syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = parsers_1.prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromString = eventFromString;
	//# sourceMappingURL=eventbuilder.js.map

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var globalhandlers_1 = __webpack_require__(264);
	exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
	var trycatch_1 = __webpack_require__(266);
	exports.TryCatch = trycatch_1.TryCatch;
	var breadcrumbs_1 = __webpack_require__(263);
	exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
	var linkederrors_1 = __webpack_require__(265);
	exports.LinkedErrors = linkederrors_1.LinkedErrors;
	var useragent_1 = __webpack_require__(267);
	exports.UserAgent = useragent_1.UserAgent;
	//# sourceMappingURL=index.js.map

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This was originally forked from https://github.com/occ/TraceKit, but has since been
	 * largely modified and is now maintained as part of Sentry JS SDK.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	// global reference to slice
	var UNKNOWN_FUNCTION = '?';
	// Chromium based browsers: Chrome, Brave, new Opera, new Edge
	var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
	// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
	// We need this specific case for now because we want no other regex to match.
	var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
	var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
	var reactMinifiedRegexp = /Minified React error #\d+;/i;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function computeStackTrace(ex) {
	    var stack = null;
	    var popSize = 0;
	    if (ex) {
	        if (typeof ex.framesToPop === 'number') {
	            popSize = ex.framesToPop;
	        }
	        else if (reactMinifiedRegexp.test(ex.message)) {
	            popSize = 1;
	        }
	    }
	    try {
	        // This must be tried first because Opera 10 *destroys*
	        // its stacktrace property if you try to access the stack
	        // property first!!
	        stack = computeStackTraceFromStacktraceProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        stack = computeStackTraceFromStackProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex && ex.name,
	        stack: [],
	        failed: true,
	    };
	}
	exports.computeStackTrace = computeStackTrace;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
	function computeStackTraceFromStackProp(ex) {
	    if (!ex || !ex.stack) {
	        return null;
	    }
	    var stack = [];
	    var lines = ex.stack.split('\n');
	    var isEval;
	    var submatch;
	    var parts;
	    var element;
	    for (var i = 0; i < lines.length; ++i) {
	        if ((parts = chrome.exec(lines[i]))) {
	            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	                // throw out eval line/column and use top-most line/column number
	                parts[2] = submatch[1]; // url
	                parts[3] = submatch[2]; // line
	                parts[4] = submatch[3]; // column
	            }
	            element = {
	                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
	                // prefix here seems like the quickest solution for now.
	                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: isNative ? [parts[2]] : [],
	                line: parts[3] ? +parts[3] : null,
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = winjs.exec(lines[i]))) {
	            element = {
	                url: parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: [],
	                line: +parts[3],
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = gecko.exec(lines[i]))) {
	            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	                // throw out eval line/column and use top-most line number
	                parts[1] = parts[1] || "eval";
	                parts[3] = submatch[1];
	                parts[4] = submatch[2];
	                parts[5] = ''; // no column when eval
	            }
	            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
	                // FireFox uses this awesome columnNumber property for its top frame
	                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	                // so adding 1
	                // NOTE: this hack doesn't work if top-most frame is eval
	                stack[0].column = ex.columnNumber + 1;
	            }
	            element = {
	                url: parts[3],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: parts[2] ? parts[2].split(',') : [],
	                line: parts[4] ? +parts[4] : null,
	                column: parts[5] ? +parts[5] : null,
	            };
	        }
	        else {
	            continue;
	        }
	        if (!element.func && element.line) {
	            element.func = UNKNOWN_FUNCTION;
	        }
	        stack.push(element);
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function computeStackTraceFromStacktraceProp(ex) {
	    if (!ex || !ex.stacktrace) {
	        return null;
	    }
	    // Access and store the stacktrace property before doing ANYTHING
	    // else to it because Opera is not very good at providing it
	    // reliably in other circumstances.
	    var stacktrace = ex.stacktrace;
	    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
	    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
	    var lines = stacktrace.split('\n');
	    var stack = [];
	    var parts;
	    for (var line = 0; line < lines.length; line += 2) {
	        var element = null;
	        if ((parts = opera10Regex.exec(lines[line]))) {
	            element = {
	                url: parts[2],
	                func: parts[3],
	                args: [],
	                line: +parts[1],
	                column: null,
	            };
	        }
	        else if ((parts = opera11Regex.exec(lines[line]))) {
	            element = {
	                url: parts[6],
	                func: parts[3] || parts[4],
	                args: parts[5] ? parts[5].split(',') : [],
	                line: +parts[1],
	                column: +parts[2],
	            };
	        }
	        if (element) {
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	            stack.push(element);
	        }
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** Remove N number of frames from the stack */
	function popFrames(stacktrace, popSize) {
	    try {
	        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
	    }
	    catch (e) {
	        return stacktrace;
	    }
	}
	/**
	 * There are cases where stacktrace.message is an Event object
	 * https://github.com/getsentry/sentry-javascript/issues/1949
	 * In this specific case we try to extract stacktrace.message.error.message
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function extractMessage(ex) {
	    var message = ex && ex.message;
	    if (!message) {
	        return 'No error message';
	    }
	    if (message.error && typeof message.error.message === 'string') {
	        return message.error.message;
	    }
	    return message;
	}
	//# sourceMappingURL=tracekit.js.map

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	/** Base Transport class implementation */
	var BaseTransport = /** @class */ (function () {
	    function BaseTransport(options) {
	        this.options = options;
	        /** A simple buffer holding all requests. */
	        this._buffer = new utils_1.PromiseBuffer(30);
	        /** Locks transport after receiving rate limits in a response */
	        this._rateLimits = {};
	        this._api = new core_1.API(this.options.dsn);
	        // eslint-disable-next-line deprecation/deprecation
	        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
	    }
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendEvent = function (_) {
	        throw new utils_1.SentryError('Transport Class has to implement `sendEvent` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.close = function (timeout) {
	        return this._buffer.drain(timeout);
	    };
	    /**
	     * Handle Sentry repsonse for promise-based transports.
	     */
	    BaseTransport.prototype._handleResponse = function (_a) {
	        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
	        var status = types_1.Status.fromHttpCode(response.status);
	        /**
	         * "The name is case-insensitive."
	         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
	         */
	        var limited = this._handleRateLimit(headers);
	        if (limited)
	            utils_1.logger.warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
	        if (status === types_1.Status.Success) {
	            resolve({ status: status });
	            return;
	        }
	        reject(response);
	    };
	    /**
	     * Gets the time that given category is disabled until for rate limiting
	     */
	    BaseTransport.prototype._disabledUntil = function (category) {
	        return this._rateLimits[category] || this._rateLimits.all;
	    };
	    /**
	     * Checks if a category is rate limited
	     */
	    BaseTransport.prototype._isRateLimited = function (category) {
	        return this._disabledUntil(category) > new Date(Date.now());
	    };
	    /**
	     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
	     */
	    BaseTransport.prototype._handleRateLimit = function (headers) {
	        var e_1, _a, e_2, _b;
	        var now = Date.now();
	        var rlHeader = headers['x-sentry-rate-limits'];
	        var raHeader = headers['retry-after'];
	        if (rlHeader) {
	            try {
	                // rate limit headers are of the form
	                //     <header>,<header>,..
	                // where each <header> is of the form
	                //     <retry_after>: <categories>: <scope>: <reason_code>
	                // where
	                //     <retry_after> is a delay in ms
	                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
	                //         <category>;<category>;...
	                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
	                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
	                for (var _c = tslib_1.__values(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var limit = _d.value;
	                    var parameters = limit.split(':', 2);
	                    var headerDelay = parseInt(parameters[0], 10);
	                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
	                    try {
	                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var category = _f.value;
	                            this._rateLimits[category || 'all'] = new Date(now + delay);
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return true;
	        }
	        else if (raHeader) {
	            this._rateLimits.all = new Date(now + utils_1.parseRetryAfterHeader(now, raHeader));
	            return true;
	        }
	        return false;
	    };
	    return BaseTransport;
	}());
	exports.BaseTransport = BaseTransport;
	//# sourceMappingURL=base.js.map

/***/ },
/* 78 */
/***/ function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindReporter = function (callback, metric, po, observeAllUpdates) {
	    var prevValue;
	    return function () {
	        if (po && metric.isFinal) {
	            po.disconnect();
	        }
	        if (metric.value >= 0) {
	            if (observeAllUpdates || metric.isFinal || document.visibilityState === 'hidden') {
	                metric.delta = metric.value - (prevValue || 0);
	                // Report the metric if there's a non-zero delta, if the metric is
	                // final, or if no previous value exists (which can happen in the case
	                // of the document becoming hidden when the metric value is 0).
	                // See: https://github.com/GoogleChrome/web-vitals/issues/14
	                if (metric.delta || metric.isFinal || prevValue === undefined) {
	                    callback(metric);
	                    prevValue = metric.value;
	                }
	            }
	        }
	    };
	};
	//# sourceMappingURL=bindReporter.js.map

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var onHidden_1 = __webpack_require__(56);
	var firstHiddenTime;
	exports.getFirstHidden = function () {
	    if (firstHiddenTime === undefined) {
	        // If the document is hidden when this code runs, assume it was hidden
	        // since navigation start. This isn't a perfect heuristic, but it's the
	        // best we can do until an API is available to support querying past
	        // visibilityState.
	        firstHiddenTime = document.visibilityState === 'hidden' ? 0 : Infinity;
	        // Update the time if/when the document becomes hidden.
	        onHidden_1.onHidden(function (_a) {
	            var timeStamp = _a.timeStamp;
	            return (firstHiddenTime = timeStamp);
	        }, true);
	    }
	    return {
	        get timeStamp() {
	            return firstHiddenTime;
	        },
	    };
	};
	//# sourceMappingURL=getFirstHidden.js.map

/***/ },
/* 80 */
/***/ function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Takes a performance entry type and a callback function, and creates a
	 * `PerformanceObserver` instance that will observe the specified entry type
	 * with buffering enabled and call the callback _for each entry_.
	 *
	 * This function also feature-detects entry support and wraps the logic in a
	 * try/catch to avoid errors in unsupporting browsers.
	 */
	exports.observe = function (type, callback) {
	    try {
	        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
	            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
	            po.observe({ type: type, buffered: true });
	            return po;
	        }
	    }
	    catch (e) {
	        // Do nothing.
	    }
	    return;
	};
	//# sourceMappingURL=observe.js.map

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var hub_1 = __webpack_require__(26);
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	var errors_1 = __webpack_require__(292);
	var idletransaction_1 = __webpack_require__(82);
	var transaction_1 = __webpack_require__(84);
	var utils_2 = __webpack_require__(36);
	/** Returns all trace headers that are currently on the top scope. */
	function traceHeaders() {
	    var scope = this.getScope();
	    if (scope) {
	        var span = scope.getSpan();
	        if (span) {
	            return {
	                'sentry-trace': span.toTraceparent(),
	            };
	        }
	    }
	    return {};
	}
	/**
	 * Makes a sampling decision for the given transaction and stores it on the transaction.
	 *
	 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
	 * sent to Sentry.
	 *
	 * @param hub: The hub off of which to read config options
	 * @param transaction: The transaction needing a sampling decision
	 * @param samplingContext: Default and user-provided data which may be used to help make the decision
	 *
	 * @returns The given transaction with its `sampled` value set
	 */
	function sample(hub, transaction, samplingContext) {
	    var _a;
	    var client = hub.getClient();
	    var options = (client && client.getOptions()) || {};
	    // nothing to do if there's no client or if tracing is disabled
	    if (!client || !utils_2.hasTracingEnabled(options)) {
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
	    if (transaction.sampled !== undefined) {
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Explicit });
	        return transaction;
	    }
	    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
	    // work; prefer the hook if so
	    var sampleRate;
	    if (typeof options.tracesSampler === 'function') {
	        sampleRate = options.tracesSampler(samplingContext);
	        // cast the rate to a number first in case it's a boolean
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Sampler, 
	            // TODO kmclb - once tag types are loosened, don't need to cast to string here
	            __sentry_sampleRate: String(Number(sampleRate)) });
	    }
	    else if (samplingContext.parentSampled !== undefined) {
	        sampleRate = samplingContext.parentSampled;
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Inheritance });
	    }
	    else {
	        sampleRate = options.tracesSampleRate;
	        // cast the rate to a number first in case it's a boolean
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Rate, 
	            // TODO kmclb - once tag types are loosened, don't need to cast to string here
	            __sentry_sampleRate: String(Number(sampleRate)) });
	    }
	    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
	    // only valid values are booleans or numbers between 0 and 1.)
	    if (!isValidSampleRate(sampleRate)) {
	        utils_1.logger.warn("[Tracing] Discarding transaction because of invalid sample rate.");
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
	    if (!sampleRate) {
	        utils_1.logger.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
	            ? 'tracesSampler returned 0 or false'
	            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
	        transaction.sampled = false;
	        return transaction;
	    }
	    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
	    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
	    transaction.sampled = Math.random() < sampleRate;
	    // if we're not going to keep it, we're done
	    if (!transaction.sampled) {
	        utils_1.logger.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
	        return transaction;
	    }
	    // at this point we know we're keeping the transaction, whether because of an inherited decision or because it got
	    // lucky with the dice roll
	    transaction.initSpanRecorder((_a = options._experiments) === null || _a === void 0 ? void 0 : _a.maxSpans);
	    utils_1.logger.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
	    return transaction;
	}
	/**
	 * Gets the correct context to pass to the tracesSampler, based on the environment (i.e., which SDK is being used)
	 *
	 * @returns The default sample context
	 */
	function getDefaultSamplingContext(transactionContext) {
	    // promote parent sampling decision (if any) for easy access
	    var parentSampled = transactionContext.parentSampled;
	    var defaultSamplingContext = { transactionContext: transactionContext, parentSampled: parentSampled };
	    if (utils_1.isNodeEnv()) {
	        var domain = hub_1.getActiveDomain();
	        if (domain) {
	            // for all node servers that we currently support, we store the incoming request object (which is an instance of
	            // http.IncomingMessage) on the domain
	            // the domain members are stored as an array, so our only way to find the request is to iterate through the array
	            // and compare types
	            var nodeHttpModule = utils_1.dynamicRequire(module, 'http');
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            var requestType_1 = nodeHttpModule.IncomingMessage;
	            var request = domain.members.find(function (member) { return utils_1.isInstanceOf(member, requestType_1); });
	            if (request) {
	                defaultSamplingContext.request = utils_1.extractNodeRequestData(request);
	            }
	        }
	    }
	    // we must be in browser-js (or some derivative thereof)
	    else {
	        // we use `getGlobalObject()` rather than `window` since service workers also have a `location` property on `self`
	        var globalObject = utils_1.getGlobalObject();
	        if ('location' in globalObject) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            defaultSamplingContext.location = tslib_1.__assign({}, globalObject.location);
	        }
	    }
	    return defaultSamplingContext;
	}
	/**
	 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
	 */
	function isValidSampleRate(rate) {
	    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
	        utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
	        return false;
	    }
	    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
	    if (rate < 0 || rate > 1) {
	        utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
	        return false;
	    }
	    return true;
	}
	/**
	 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
	 *
	 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
	 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
	 * "extension method."
	 *
	 * @param this: The Hub starting the transaction
	 * @param transactionContext: Data used to configure the transaction
	 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
	 *
	 * @returns The new transaction
	 *
	 * @see {@link Hub.startTransaction}
	 */
	function _startTransaction(transactionContext, customSamplingContext) {
	    var transaction = new transaction_1.Transaction(transactionContext, this);
	    return sample(this, transaction, tslib_1.__assign(tslib_1.__assign({}, getDefaultSamplingContext(transactionContext)), customSamplingContext));
	}
	/**
	 * Create new idle transaction.
	 */
	function startIdleTransaction(hub, transactionContext, idleTimeout, onScope) {
	    var transaction = new idletransaction_1.IdleTransaction(transactionContext, hub, idleTimeout, onScope);
	    return sample(hub, transaction, getDefaultSamplingContext(transactionContext));
	}
	exports.startIdleTransaction = startIdleTransaction;
	/**
	 * @private
	 */
	function _addTracingExtensions() {
	    var carrier = hub_1.getMainCarrier();
	    if (carrier.__SENTRY__) {
	        carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
	        if (!carrier.__SENTRY__.extensions.startTransaction) {
	            carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
	        }
	        if (!carrier.__SENTRY__.extensions.traceHeaders) {
	            carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
	        }
	    }
	}
	exports._addTracingExtensions = _addTracingExtensions;
	/**
	 * This patches the global object and injects the Tracing extensions methods
	 */
	function addExtensionMethods() {
	    _addTracingExtensions();
	    // If an error happens globally, we should make sure transaction status is set to error.
	    errors_1.registerErrorInstrumentation();
	}
	exports.addExtensionMethods = addExtensionMethods;
	//# sourceMappingURL=hubextensions.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)(module)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	var span_1 = __webpack_require__(83);
	var spanstatus_1 = __webpack_require__(41);
	var transaction_1 = __webpack_require__(84);
	exports.DEFAULT_IDLE_TIMEOUT = 1000;
	/**
	 * @inheritDoc
	 */
	var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransactionSpanRecorder, _super);
	    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
	        if (transactionSpanId === void 0) { transactionSpanId = ''; }
	        var _this = _super.call(this, maxlen) || this;
	        _this._pushActivity = _pushActivity;
	        _this._popActivity = _popActivity;
	        _this.transactionSpanId = transactionSpanId;
	        return _this;
	    }
	    /**
	     * @inheritDoc
	     */
	    IdleTransactionSpanRecorder.prototype.add = function (span) {
	        var _this = this;
	        // We should make sure we do not push and pop activities for
	        // the transaction that this span recorder belongs to.
	        if (span.spanId !== this.transactionSpanId) {
	            // We patch span.finish() to pop an activity after setting an endTimestamp.
	            span.finish = function (endTimestamp) {
	                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	                _this._popActivity(span.spanId);
	            };
	            // We should only push new activities if the span does not have an end timestamp.
	            if (span.endTimestamp === undefined) {
	                this._pushActivity(span.spanId);
	            }
	        }
	        _super.prototype.add.call(this, span);
	    };
	    return IdleTransactionSpanRecorder;
	}(span_1.SpanRecorder));
	exports.IdleTransactionSpanRecorder = IdleTransactionSpanRecorder;
	/**
	 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
	 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
	 * put itself on the scope on creation.
	 */
	var IdleTransaction = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransaction, _super);
	    function IdleTransaction(transactionContext, _idleHub, 
	    // The time to wait in ms until the idle transaction will be finished. Default: 1000
	    _idleTimeout, 
	    // If an idle transaction should be put itself on and off the scope automatically.
	    _onScope) {
	        if (_idleTimeout === void 0) { _idleTimeout = exports.DEFAULT_IDLE_TIMEOUT; }
	        if (_onScope === void 0) { _onScope = false; }
	        var _this = _super.call(this, transactionContext, _idleHub) || this;
	        _this._idleHub = _idleHub;
	        _this._idleTimeout = _idleTimeout;
	        _this._onScope = _onScope;
	        // Activities store a list of active spans
	        _this.activities = {};
	        // Stores reference to the timeout that calls _beat().
	        _this._heartbeatTimer = 0;
	        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
	        _this._heartbeatCounter = 0;
	        // We should not use heartbeat if we finished a transaction
	        _this._finished = false;
	        _this._beforeFinishCallbacks = [];
	        if (_idleHub && _onScope) {
	            // There should only be one active transaction on the scope
	            clearActiveTransaction(_idleHub);
	            // We set the transaction here on the scope so error events pick up the trace
	            // context and attach it to the error.
	            utils_1.logger.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
	            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
	        }
	        return _this;
	    }
	    /** {@inheritDoc} */
	    IdleTransaction.prototype.finish = function (endTimestamp) {
	        var e_1, _a;
	        var _this = this;
	        if (endTimestamp === void 0) { endTimestamp = utils_1.timestampWithMs(); }
	        this._finished = true;
	        this.activities = {};
	        if (this.spanRecorder) {
	            utils_1.logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
	            try {
	                for (var _b = tslib_1.__values(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var callback = _c.value;
	                    callback(this, endTimestamp);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
	                // If we are dealing with the transaction itself, we just return it
	                if (span.spanId === _this.spanId) {
	                    return true;
	                }
	                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
	                if (!span.endTimestamp) {
	                    span.endTimestamp = endTimestamp;
	                    span.setStatus(spanstatus_1.SpanStatus.Cancelled);
	                    utils_1.logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
	                }
	                var keepSpan = span.startTimestamp < endTimestamp;
	                if (!keepSpan) {
	                    utils_1.logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
	                }
	                return keepSpan;
	            });
	            // this._onScope is true if the transaction was previously on the scope.
	            if (this._onScope) {
	                clearActiveTransaction(this._idleHub);
	            }
	            utils_1.logger.log('[Tracing] flushing IdleTransaction');
	        }
	        else {
	            utils_1.logger.log('[Tracing] No active IdleTransaction');
	        }
	        return _super.prototype.finish.call(this, endTimestamp);
	    };
	    /**
	     * Register a callback function that gets excecuted before the transaction finishes.
	     * Useful for cleanup or if you want to add any additional spans based on current context.
	     *
	     * This is exposed because users have no other way of running something before an idle transaction
	     * finishes.
	     */
	    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
	        this._beforeFinishCallbacks.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
	        var _this = this;
	        if (!this.spanRecorder) {
	            this._initTimeout = setTimeout(function () {
	                if (!_this._finished) {
	                    _this.finish();
	                }
	            }, this._idleTimeout);
	            var pushActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._pushActivity(id);
	            };
	            var popActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._popActivity(id);
	            };
	            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
	            // Start heartbeat so that transactions do not run forever.
	            utils_1.logger.log('Starting heartbeat');
	            this._pingHeartbeat();
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Start tracking a specific activity.
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._pushActivity = function (spanId) {
	        if (this._initTimeout) {
	            clearTimeout(this._initTimeout);
	            this._initTimeout = undefined;
	        }
	        utils_1.logger.log("[Tracing] pushActivity: " + spanId);
	        this.activities[spanId] = true;
	        utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	    };
	    /**
	     * Remove an activity from usage
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._popActivity = function (spanId) {
	        var _this = this;
	        if (this.activities[spanId]) {
	            utils_1.logger.log("[Tracing] popActivity " + spanId);
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this.activities[spanId];
	            utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	        }
	        if (Object.keys(this.activities).length === 0) {
	            var timeout = this._idleTimeout;
	            // We need to add the timeout here to have the real endtimestamp of the transaction
	            // Remember timestampWithMs is in seconds, timeout is in ms
	            var end_1 = utils_1.timestampWithMs() + timeout / 1000;
	            setTimeout(function () {
	                if (!_this._finished) {
	                    _this.finish(end_1);
	                }
	            }, timeout);
	        }
	    };
	    /**
	     * Checks when entries of this.activities are not changing for 3 beats.
	     * If this occurs we finish the transaction.
	     */
	    IdleTransaction.prototype._beat = function () {
	        clearTimeout(this._heartbeatTimer);
	        // We should not be running heartbeat if the idle transaction is finished.
	        if (this._finished) {
	            return;
	        }
	        var keys = Object.keys(this.activities);
	        var heartbeatString = keys.length ? keys.reduce(function (prev, current) { return prev + current; }) : '';
	        if (heartbeatString === this._prevHeartbeatString) {
	            this._heartbeatCounter += 1;
	        }
	        else {
	            this._heartbeatCounter = 1;
	        }
	        this._prevHeartbeatString = heartbeatString;
	        if (this._heartbeatCounter >= 3) {
	            utils_1.logger.log("[Tracing] Transaction finished because of no change for 3 heart beats");
	            this.setStatus(spanstatus_1.SpanStatus.DeadlineExceeded);
	            this.setTag('heartbeat', 'failed');
	            this.finish();
	        }
	        else {
	            this._pingHeartbeat();
	        }
	    };
	    /**
	     * Pings the heartbeat
	     */
	    IdleTransaction.prototype._pingHeartbeat = function () {
	        var _this = this;
	        utils_1.logger.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
	        this._heartbeatTimer = setTimeout(function () {
	            _this._beat();
	        }, 5000);
	    };
	    return IdleTransaction;
	}(transaction_1.Transaction));
	exports.IdleTransaction = IdleTransaction;
	/**
	 * Reset active transaction on scope
	 */
	function clearActiveTransaction(hub) {
	    if (hub) {
	        var scope = hub.getScope();
	        if (scope) {
	            var transaction = scope.getTransaction();
	            if (transaction) {
	                scope.setSpan(undefined);
	            }
	        }
	    }
	}
	//# sourceMappingURL=idletransaction.js.map

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	var spanstatus_1 = __webpack_require__(41);
	/**
	 * Keeps track of finished spans for a given transaction
	 * @internal
	 * @hideconstructor
	 * @hidden
	 */
	var SpanRecorder = /** @class */ (function () {
	    function SpanRecorder(maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        this.spans = [];
	        this._maxlen = maxlen;
	    }
	    /**
	     * This is just so that we don't run out of memory while recording a lot
	     * of spans. At some point we just stop and flush out the start of the
	     * trace tree (i.e.the first n spans with the smallest
	     * start_timestamp).
	     */
	    SpanRecorder.prototype.add = function (span) {
	        if (this.spans.length > this._maxlen) {
	            span.spanRecorder = undefined;
	        }
	        else {
	            this.spans.push(span);
	        }
	    };
	    return SpanRecorder;
	}());
	exports.SpanRecorder = SpanRecorder;
	/**
	 * Span contains all data about a span
	 */
	var Span = /** @class */ (function () {
	    /**
	     * You should never call the constructor manually, always use `Sentry.startTransaction()`
	     * or call `startChild()` on an existing span.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Span(spanContext) {
	        /**
	         * @inheritDoc
	         */
	        this.traceId = utils_1.uuid4();
	        /**
	         * @inheritDoc
	         */
	        this.spanId = utils_1.uuid4().substring(16);
	        /**
	         * Timestamp in seconds when the span was created.
	         */
	        this.startTimestamp = utils_1.timestampWithMs();
	        /**
	         * @inheritDoc
	         */
	        this.tags = {};
	        /**
	         * @inheritDoc
	         */
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.data = {};
	        if (!spanContext) {
	            return this;
	        }
	        if (spanContext.traceId) {
	            this.traceId = spanContext.traceId;
	        }
	        if (spanContext.spanId) {
	            this.spanId = spanContext.spanId;
	        }
	        if (spanContext.parentSpanId) {
	            this.parentSpanId = spanContext.parentSpanId;
	        }
	        // We want to include booleans as well here
	        if ('sampled' in spanContext) {
	            this.sampled = spanContext.sampled;
	        }
	        if (spanContext.op) {
	            this.op = spanContext.op;
	        }
	        if (spanContext.description) {
	            this.description = spanContext.description;
	        }
	        if (spanContext.data) {
	            this.data = spanContext.data;
	        }
	        if (spanContext.tags) {
	            this.tags = spanContext.tags;
	        }
	        if (spanContext.status) {
	            this.status = spanContext.status;
	        }
	        if (spanContext.startTimestamp) {
	            this.startTimestamp = spanContext.startTimestamp;
	        }
	        if (spanContext.endTimestamp) {
	            this.endTimestamp = spanContext.endTimestamp;
	        }
	    }
	    /**
	     * @inheritDoc
	     * @deprecated
	     */
	    Span.prototype.child = function (spanContext) {
	        return this.startChild(spanContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.startChild = function (spanContext) {
	        var childSpan = new Span(tslib_1.__assign(tslib_1.__assign({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
	        childSpan.spanRecorder = this.spanRecorder;
	        if (childSpan.spanRecorder) {
	            childSpan.spanRecorder.add(childSpan);
	        }
	        childSpan.transaction = this.transaction;
	        return childSpan;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setTag = function (key, value) {
	        var _a;
	        this.tags = tslib_1.__assign(tslib_1.__assign({}, this.tags), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Span.prototype.setData = function (key, value) {
	        var _a;
	        this.data = tslib_1.__assign(tslib_1.__assign({}, this.data), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setStatus = function (value) {
	        this.status = value;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setHttpStatus = function (httpStatus) {
	        this.setTag('http.status_code', String(httpStatus));
	        var spanStatus = spanstatus_1.SpanStatus.fromHttpCode(httpStatus);
	        if (spanStatus !== spanstatus_1.SpanStatus.UnknownError) {
	            this.setStatus(spanStatus);
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.isSuccess = function () {
	        return this.status === spanstatus_1.SpanStatus.Ok;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.finish = function (endTimestamp) {
	        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toTraceparent = function () {
	        var sampledString = '';
	        if (this.sampled !== undefined) {
	            sampledString = this.sampled ? '-1' : '-0';
	        }
	        return this.traceId + "-" + this.spanId + sampledString;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.getTraceContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            trace_id: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            start_timestamp: this.startTimestamp,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            timestamp: this.endTimestamp,
	            trace_id: this.traceId,
	        });
	    };
	    return Span;
	}());
	exports.Span = Span;
	//# sourceMappingURL=span.js.map

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var hub_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(9);
	var span_1 = __webpack_require__(83);
	/** JSDoc */
	var Transaction = /** @class */ (function (_super) {
	    tslib_1.__extends(Transaction, _super);
	    /**
	     * This constructor should never be called manually. Those instrumenting tracing should use
	     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Transaction(transactionContext, hub) {
	        var _this = _super.call(this, transactionContext) || this;
	        _this._measurements = {};
	        /**
	         * The reference to the current hub.
	         */
	        _this._hub = hub_1.getCurrentHub();
	        if (utils_1.isInstanceOf(hub, hub_1.Hub)) {
	            _this._hub = hub;
	        }
	        _this.name = transactionContext.name ? transactionContext.name : '';
	        _this._trimEnd = transactionContext.trimEnd;
	        // this is because transactions are also spans, and spans have a transaction pointer
	        _this.transaction = _this;
	        return _this;
	    }
	    /**
	     * JSDoc
	     */
	    Transaction.prototype.setName = function (name) {
	        this.name = name;
	    };
	    /**
	     * Attaches SpanRecorder to the span itself
	     * @param maxlen maximum number of spans that can be recorded
	     */
	    Transaction.prototype.initSpanRecorder = function (maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        if (!this.spanRecorder) {
	            this.spanRecorder = new span_1.SpanRecorder(maxlen);
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Set observed measurements for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMeasurements = function (measurements) {
	        this._measurements = tslib_1.__assign({}, measurements);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.finish = function (endTimestamp) {
	        var _this = this;
	        // This transaction is already finished, so we should not flush it again.
	        if (this.endTimestamp !== undefined) {
	            return undefined;
	        }
	        if (!this.name) {
	            utils_1.logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
	            this.name = '<unlabeled transaction>';
	        }
	        // just sets the end timestamp
	        _super.prototype.finish.call(this, endTimestamp);
	        if (this.sampled !== true) {
	            // At this point if `sampled !== true` we want to discard the transaction.
	            utils_1.logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
	            return undefined;
	        }
	        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
	        if (this._trimEnd && finishedSpans.length > 0) {
	            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
	                if (prev.endTimestamp && current.endTimestamp) {
	                    return prev.endTimestamp > current.endTimestamp ? prev : current;
	                }
	                return prev;
	            }).endTimestamp;
	        }
	        var transaction = {
	            contexts: {
	                trace: this.getTraceContext(),
	            },
	            spans: finishedSpans,
	            start_timestamp: this.startTimestamp,
	            tags: this.tags,
	            timestamp: this.endTimestamp,
	            transaction: this.name,
	            type: 'transaction',
	        };
	        var hasMeasurements = Object.keys(this._measurements).length > 0;
	        if (hasMeasurements) {
	            utils_1.logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
	            transaction.measurements = this._measurements;
	        }
	        return this._hub.captureEvent(transaction);
	    };
	    return Transaction;
	}(span_1.Span));
	exports.Transaction = Transaction;
	//# sourceMappingURL=transaction.js.map

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var polyfill_1 = __webpack_require__(308);
	/** An error emitted by Sentry SDKs and related utilities. */
	var SentryError = /** @class */ (function (_super) {
	    tslib_1.__extends(SentryError, _super);
	    function SentryError(message) {
	        var _newTarget = this.constructor;
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _newTarget.prototype.constructor.name;
	        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
	        return _this;
	    }
	    return SentryError;
	}(Error));
	exports.SentryError = SentryError;
	//# sourceMappingURL=error.js.map

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var misc_1 = __webpack_require__(49);
	// TODO: Implement different loggers for different environments
	var global = misc_1.getGlobalObject();
	/** Prefix for logging strings */
	var PREFIX = 'Sentry Logger ';
	/** JSDoc */
	var Logger = /** @class */ (function () {
	    /** JSDoc */
	    function Logger() {
	        this._enabled = false;
	    }
	    /** JSDoc */
	    Logger.prototype.disable = function () {
	        this._enabled = false;
	    };
	    /** JSDoc */
	    Logger.prototype.enable = function () {
	        this._enabled = true;
	    };
	    /** JSDoc */
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.log(PREFIX + "[Log]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.error(PREFIX + "[Error]: " + args.join(' '));
	        });
	    };
	    return Logger;
	}());
	// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
	global.__SENTRY__ = global.__SENTRY__ || {};
	var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
	exports.logger = logger;
	//# sourceMappingURL=logger.js.map

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(37);
	var object_1 = __webpack_require__(88);
	/**
	 * Checks whether we're in the Node.js or Browser environment
	 *
	 * @returns Answer to given question
	 */
	function isNodeEnv() {
	    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
	}
	exports.isNodeEnv = isNodeEnv;
	/**
	 * Requires a module which is protected against bundler minification.
	 *
	 * @param request The module path to resolve
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function dynamicRequire(mod, request) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return mod.require(request);
	}
	exports.dynamicRequire = dynamicRequire;
	/** Default request keys that'll be used to extract data from the request */
	var DEFAULT_REQUEST_KEYS = ['cookies', 'data', 'headers', 'method', 'query_string', 'url'];
	/**
	 * Normalizes data from the request object, accounting for framework differences.
	 *
	 * @param req The request object from which to extract data
	 * @param keys An optional array of keys to include in the normalized data. Defaults to DEFAULT_REQUEST_KEYS if not
	 * provided.
	 * @returns An object containing normalized request data
	 */
	function extractNodeRequestData(req, keys) {
	    if (keys === void 0) { keys = DEFAULT_REQUEST_KEYS; }
	    // make sure we can safely use dynamicRequire below
	    if (!isNodeEnv()) {
	        throw new Error("Can't get node request data outside of a node environment");
	    }
	    var requestData = {};
	    // headers:
	    //   node, express: req.headers
	    //   koa: req.header
	    var headers = (req.headers || req.header || {});
	    // method:
	    //   node, express, koa: req.method
	    var method = req.method;
	    // host:
	    //   express: req.hostname in > 4 and req.host in < 4
	    //   koa: req.host
	    //   node: req.headers.host
	    var host = req.hostname || req.host || headers.host || '<no host>';
	    // protocol:
	    //   node: <n/a>
	    //   express, koa: req.protocol
	    var protocol = req.protocol === 'https' || req.secure || (req.socket || {}).encrypted
	        ? 'https'
	        : 'http';
	    // url (including path and query string):
	    //   node, express: req.originalUrl
	    //   koa: req.url
	    var originalUrl = (req.originalUrl || req.url || '');
	    // absolute url
	    var absoluteUrl = protocol + "://" + host + originalUrl;
	    keys.forEach(function (key) {
	        switch (key) {
	            case 'headers':
	                requestData.headers = headers;
	                break;
	            case 'method':
	                requestData.method = method;
	                break;
	            case 'url':
	                requestData.url = absoluteUrl;
	                break;
	            case 'cookies':
	                // cookies:
	                //   node, express, koa: req.headers.cookie
	                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.cookies = req.cookies || dynamicRequire(module, 'cookie').parse(headers.cookie || '');
	                break;
	            case 'query_string':
	                // query string:
	                //   node: req.url (raw)
	                //   express, koa: req.query
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.query_string = dynamicRequire(module, 'url').parse(originalUrl || '', false).query;
	                break;
	            case 'data':
	                if (method === 'GET' || method === 'HEAD') {
	                    break;
	                }
	                // body data:
	                //   node, express, koa: req.body
	                if (req.body !== undefined) {
	                    requestData.data = is_1.isString(req.body) ? req.body : JSON.stringify(object_1.normalize(req.body));
	                }
	                break;
	            default:
	                if ({}.hasOwnProperty.call(req, key)) {
	                    requestData[key] = req[key];
	                }
	        }
	    });
	    return requestData;
	}
	exports.extractNodeRequestData = extractNodeRequestData;
	//# sourceMappingURL=node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63), __webpack_require__(46)(module)))

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var browser_1 = __webpack_require__(155);
	var is_1 = __webpack_require__(37);
	var memo_1 = __webpack_require__(156);
	var stacktrace_1 = __webpack_require__(89);
	var string_1 = __webpack_require__(90);
	/**
	 * Wrap a given object method with a higher-order function
	 *
	 * @param source An object that contains a method to be wrapped.
	 * @param name A name of method to be wrapped.
	 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
	 * will be substituted in for `source[name]`.
	 * @returns void
	 */
	function fill(source, name, replacementFactory) {
	    if (!(name in source)) {
	        return;
	    }
	    var original = source[name];
	    var wrapped = replacementFactory(original);
	    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
	    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
	    if (typeof wrapped === 'function') {
	        try {
	            wrapped.prototype = wrapped.prototype || {};
	            Object.defineProperties(wrapped, {
	                __sentry_original__: {
	                    enumerable: false,
	                    value: original,
	                },
	            });
	        }
	        catch (_Oo) {
	            // This can throw if multiple fill happens on a global object like XMLHttpRequest
	            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
	        }
	    }
	    source[name] = wrapped;
	}
	exports.fill = fill;
	/**
	 * Encodes given object into url-friendly format
	 *
	 * @param object An object that contains serializable values
	 * @returns string Encoded
	 */
	function urlEncode(object) {
	    return Object.keys(object)
	        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
	        .join('&');
	}
	exports.urlEncode = urlEncode;
	/**
	 * Transforms any object into an object literal with all its attributes
	 * attached to it.
	 *
	 * @param value Initial source that we have to transform in order for it to be usable by the serializer
	 */
	function getWalkSource(value) {
	    if (is_1.isError(value)) {
	        var error = value;
	        var err = {
	            message: error.message,
	            name: error.name,
	            stack: error.stack,
	        };
	        for (var i in error) {
	            if (Object.prototype.hasOwnProperty.call(error, i)) {
	                err[i] = error[i];
	            }
	        }
	        return err;
	    }
	    if (is_1.isEvent(value)) {
	        var event_1 = value;
	        var source = {};
	        source.type = event_1.type;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            source.target = is_1.isElement(event_1.target)
	                ? browser_1.htmlTreeAsString(event_1.target)
	                : Object.prototype.toString.call(event_1.target);
	        }
	        catch (_oO) {
	            source.target = '<unknown>';
	        }
	        try {
	            source.currentTarget = is_1.isElement(event_1.currentTarget)
	                ? browser_1.htmlTreeAsString(event_1.currentTarget)
	                : Object.prototype.toString.call(event_1.currentTarget);
	        }
	        catch (_oO) {
	            source.currentTarget = '<unknown>';
	        }
	        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
	            source.detail = event_1.detail;
	        }
	        for (var i in event_1) {
	            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
	                source[i] = event_1;
	            }
	        }
	        return source;
	    }
	    return value;
	}
	/** Calculates bytes size of input string */
	function utf8Length(value) {
	    // eslint-disable-next-line no-bitwise
	    return ~-encodeURI(value).split(/%..|./).length;
	}
	/** Calculates bytes size of input object */
	function jsonSize(value) {
	    return utf8Length(JSON.stringify(value));
	}
	/** JSDoc */
	function normalizeToSize(object, 
	// Default Node.js REPL depth
	depth, 
	// 100kB, as 200kB is max payload size, so half sounds reasonable
	maxSize) {
	    if (depth === void 0) { depth = 3; }
	    if (maxSize === void 0) { maxSize = 100 * 1024; }
	    var serialized = normalize(object, depth);
	    if (jsonSize(serialized) > maxSize) {
	        return normalizeToSize(object, depth - 1, maxSize);
	    }
	    return serialized;
	}
	exports.normalizeToSize = normalizeToSize;
	/**
	 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
	 * booleans, null, and undefined.
	 *
	 * @param value The value to stringify
	 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
	 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
	 *  unchanged.
	 */
	function serializeValue(value) {
	    var type = Object.prototype.toString.call(value);
	    // Node.js REPL notation
	    if (typeof value === 'string') {
	        return value;
	    }
	    if (type === '[object Object]') {
	        return '[Object]';
	    }
	    if (type === '[object Array]') {
	        return '[Array]';
	    }
	    var normalized = normalizeValue(value);
	    return is_1.isPrimitive(normalized) ? normalized : type;
	}
	/**
	 * normalizeValue()
	 *
	 * Takes unserializable input and make it serializable friendly
	 *
	 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
	 * - serializes Error objects
	 * - filter global objects
	 */
	function normalizeValue(value, key) {
	    if (key === 'domain' && value && typeof value === 'object' && value._events) {
	        return '[Domain]';
	    }
	    if (key === 'domainEmitter') {
	        return '[DomainEmitter]';
	    }
	    if (typeof global !== 'undefined' && value === global) {
	        return '[Global]';
	    }
	    if (typeof window !== 'undefined' && value === window) {
	        return '[Window]';
	    }
	    if (typeof document !== 'undefined' && value === document) {
	        return '[Document]';
	    }
	    // React's SyntheticEvent thingy
	    if (is_1.isSyntheticEvent(value)) {
	        return '[SyntheticEvent]';
	    }
	    if (typeof value === 'number' && value !== value) {
	        return '[NaN]';
	    }
	    if (value === void 0) {
	        return '[undefined]';
	    }
	    if (typeof value === 'function') {
	        return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
	    }
	    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
	    if (typeof value === 'symbol') {
	        return "[" + String(value) + "]";
	    }
	    if (typeof value === 'bigint') {
	        return "[BigInt: " + String(value) + "]";
	    }
	    return value;
	}
	/**
	 * Walks an object to perform a normalization on it
	 *
	 * @param key of object that's walked in current iteration
	 * @param value object to be walked
	 * @param depth Optional number indicating how deep should walking be performed
	 * @param memo Optional Memo class handling decycling
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function walk(key, value, depth, memo) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (memo === void 0) { memo = new memo_1.Memo(); }
	    // If we reach the maximum depth, serialize whatever has left
	    if (depth === 0) {
	        return serializeValue(value);
	    }
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // If value implements `toJSON` method, call it and return early
	    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
	        return value.toJSON();
	    }
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
	    var normalized = normalizeValue(value, key);
	    if (is_1.isPrimitive(normalized)) {
	        return normalized;
	    }
	    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
	    var source = getWalkSource(value);
	    // Create an accumulator that will act as a parent for all future itterations of that branch
	    var acc = Array.isArray(value) ? [] : {};
	    // If we already walked that branch, bail out, as it's circular reference
	    if (memo.memoize(value)) {
	        return '[Circular ~]';
	    }
	    // Walk all keys of the source
	    for (var innerKey in source) {
	        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
	        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
	            continue;
	        }
	        // Recursively walk through all the child nodes
	        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
	    }
	    // Once walked through all the branches, remove the parent from memo storage
	    memo.unmemoize(value);
	    // Return accumulated values
	    return acc;
	}
	exports.walk = walk;
	/**
	 * normalize()
	 *
	 * - Creates a copy to prevent original input mutation
	 * - Skip non-enumerablers
	 * - Calls `toJSON` if implemented
	 * - Removes circular references
	 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
	 * - Translates known global objects/Classes to a string representations
	 * - Takes care of Error objects serialization
	 * - Optionally limit depth of final output
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function normalize(input, depth) {
	    try {
	        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
	    }
	    catch (_oO) {
	        return '**non-serializable**';
	    }
	}
	exports.normalize = normalize;
	/**
	 * Given any captured exception, extract its keys and create a sorted
	 * and truncated list that will be used inside the event message.
	 * eg. `Non-error exception captured with keys: foo, bar, baz`
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function extractExceptionKeysForMessage(exception, maxLength) {
	    if (maxLength === void 0) { maxLength = 40; }
	    var keys = Object.keys(getWalkSource(exception));
	    keys.sort();
	    if (!keys.length) {
	        return '[object has no keys]';
	    }
	    if (keys[0].length >= maxLength) {
	        return string_1.truncate(keys[0], maxLength);
	    }
	    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
	        var serialized = keys.slice(0, includedKeys).join(', ');
	        if (serialized.length > maxLength) {
	            continue;
	        }
	        if (includedKeys === keys.length) {
	            return serialized;
	        }
	        return string_1.truncate(serialized, maxLength);
	    }
	    return '';
	}
	exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
	/**
	 * Given any object, return the new object with removed keys that value was `undefined`.
	 * Works recursively on objects and arrays.
	 */
	function dropUndefinedKeys(val) {
	    var e_1, _a;
	    if (is_1.isPlainObject(val)) {
	        var obj = val;
	        var rv = {};
	        try {
	            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var key = _c.value;
	                if (typeof obj[key] !== 'undefined') {
	                    rv[key] = dropUndefinedKeys(obj[key]);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return rv;
	    }
	    if (Array.isArray(val)) {
	        return val.map(dropUndefinedKeys);
	    }
	    return val;
	}
	exports.dropUndefinedKeys = dropUndefinedKeys;
	//# sourceMappingURL=object.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 89 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var defaultFunctionName = '<anonymous>';
	/**
	 * Safely extract function name from itself
	 */
	function getFunctionName(fn) {
	    try {
	        if (!fn || typeof fn !== 'function') {
	            return defaultFunctionName;
	        }
	        return fn.name || defaultFunctionName;
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        return defaultFunctionName;
	    }
	}
	exports.getFunctionName = getFunctionName;
	//# sourceMappingURL=stacktrace.js.map

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(37);
	/**
	 * Truncates given string to the maximum characters count
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string (0 = unlimited)
	 * @returns string Encoded
	 */
	function truncate(str, max) {
	    if (max === void 0) { max = 0; }
	    if (typeof str !== 'string' || max === 0) {
	        return str;
	    }
	    return str.length <= max ? str : str.substr(0, max) + "...";
	}
	exports.truncate = truncate;
	/**
	 * This is basically just `trim_line` from
	 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string
	 * @returns string Encoded
	 */
	function snipLine(line, colno) {
	    var newLine = line;
	    var ll = newLine.length;
	    if (ll <= 150) {
	        return newLine;
	    }
	    if (colno > ll) {
	        // eslint-disable-next-line no-param-reassign
	        colno = ll;
	    }
	    var start = Math.max(colno - 60, 0);
	    if (start < 5) {
	        start = 0;
	    }
	    var end = Math.min(start + 140, ll);
	    if (end > ll - 5) {
	        end = ll;
	    }
	    if (end === ll) {
	        start = Math.max(end - 140, 0);
	    }
	    newLine = newLine.slice(start, end);
	    if (start > 0) {
	        newLine = "'{snip} " + newLine;
	    }
	    if (end < ll) {
	        newLine += ' {snip}';
	    }
	    return newLine;
	}
	exports.snipLine = snipLine;
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns Joined values
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function safeJoin(input, delimiter) {
	    if (!Array.isArray(input)) {
	        return '';
	    }
	    var output = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < input.length; i++) {
	        var value = input[i];
	        try {
	            output.push(String(value));
	        }
	        catch (e) {
	            output.push('[value cannot be serialized]');
	        }
	    }
	    return output.join(delimiter);
	}
	exports.safeJoin = safeJoin;
	/**
	 * Checks if the value matches a regex or includes the string
	 * @param value The string value to be checked against
	 * @param pattern Either a regex or a string that must be contained in value
	 */
	function isMatchingPattern(value, pattern) {
	    if (!is_1.isString(value)) {
	        return false;
	    }
	    if (is_1.isRegExp(pattern)) {
	        return pattern.test(value);
	    }
	    if (typeof pattern === 'string') {
	        return value.indexOf(pattern) !== -1;
	    }
	    return false;
	}
	exports.isMatchingPattern = isMatchingPattern;
	//# sourceMappingURL=string.js.map

/***/ },
/* 91 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Глобальный конфиг для API
	// Используется для хранения callback-функции logout и редиректа
	var ApiConfig = function () {
	    function ApiConfig() {
	        _classCallCheck(this, ApiConfig);
	
	        this.logoutCallback = null;
	        this.redirectCallback = null;
	    }
	
	    _createClass(ApiConfig, [{
	        key: 'setLogoutCallback',
	        value: function setLogoutCallback(callback) {
	            this.logoutCallback = callback;
	        }
	    }, {
	        key: 'setRedirectCallback',
	        value: function setRedirectCallback(callback) {
	            this.redirectCallback = callback;
	        }
	    }, {
	        key: 'getLogoutCallback',
	        value: function getLogoutCallback() {
	            return this.logoutCallback;
	        }
	    }, {
	        key: 'getRedirectCallback',
	        value: function getRedirectCallback() {
	            return this.redirectCallback;
	        }
	    }, {
	        key: 'executeLogout',
	        value: function executeLogout() {
	            if (typeof this.logoutCallback === 'function') {
	                this.logoutCallback();
	            }
	            // После logout перенаправляем на страницу входа
	            if (typeof this.redirectCallback === 'function') {
	                this.redirectCallback('/login');
	            }
	        }
	    }]);
	
	    return ApiConfig;
	}();
	
	exports.default = new ApiConfig();

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(527);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyChart = function EmptyChart() {
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.EmptyChart },
	        _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "EmptyChart.message", defaultMessage: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0433\u0440\u0430\u0444\u0438\u043A\u0430" })
	        )
	    );
	};
	
	exports.default = EmptyChart;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Header;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Logo = __webpack_require__(172);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _HeaderMenu = __webpack_require__(395);
	
	var _HeaderMenu2 = _interopRequireDefault(_HeaderMenu);
	
	var _stylesModule = __webpack_require__(553);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header(_ref) {
	    var menuConfig = _ref.menuConfig,
	        _ref$showMenu = _ref.showMenu,
	        showMenu = _ref$showMenu === undefined ? true : _ref$showMenu;
	
	    var brand = [{ bgColor: '' }, { copyText: '' }];
	
	    switch (("eclear")) {
	        case 'wl':
	            brand.bgColor = '#273246';
	            break;
	        case 'unlimco':
	            brand.bgColor = '#273246';
	            break;
	        case 'eclear':
	            brand.bgColor = '#074076';
	            break;
	        default:
	            brand.bgColor = '#273246';
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'header',
	            { className: _stylesModule2.default.Header, style: { backgroundColor: brand.bgColor } },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Container },
	                _react2.default.createElement(_Logo2.default, { style: { width: '180px', height: '35px', margin: '8px 0', top: '0' } }),
	                showMenu && _react2.default.createElement(_HeaderMenu2.default, { menuConfig: menuConfig, mode: 'top' })
	            )
	        ),
	        showMenu && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MenuRow },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Container },
	                _react2.default.createElement(_HeaderMenu2.default, { menuConfig: menuConfig, mode: 'nav' })
	            )
	        )
	    );
	}

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createUserHeaderMenuConfig = createUserHeaderMenuConfig;
	exports.createAdminHeaderMenuConfig = createAdminHeaderMenuConfig;
	exports.createDefaultHeaderMenuConfig = createDefaultHeaderMenuConfig;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var message = function message(id, defaultMessage) {
	    return { id: id, defaultMessage: defaultMessage };
	};
	
	var link = function link(_ref) {
	    var key = _ref.key,
	        to = _ref.to,
	        icon = _ref.icon,
	        title = _ref.title,
	        _ref$exact = _ref.exact,
	        exact = _ref$exact === undefined ? true : _ref$exact,
	        _ref$special = _ref.special,
	        special = _ref$special === undefined ? null : _ref$special,
	        _ref$access = _ref.access,
	        access = _ref$access === undefined ? null : _ref$access,
	        _ref$accessDenied = _ref.accessDenied,
	        accessDenied = _ref$accessDenied === undefined ? 'disable' : _ref$accessDenied;
	    return {
	        type: 'link',
	        key: key || to,
	        to: to,
	        icon: icon,
	        title: title,
	        exact: exact,
	        special: special,
	        access: access,
	        accessDenied: accessDenied
	    };
	};
	
	var dropdown = function dropdown(_ref2) {
	    var key = _ref2.key,
	        title = _ref2.title,
	        icon = _ref2.icon,
	        _ref2$items = _ref2.items,
	        items = _ref2$items === undefined ? [] : _ref2$items,
	        _ref2$isHeader = _ref2.isHeader,
	        isHeader = _ref2$isHeader === undefined ? false : _ref2$isHeader,
	        _ref2$isFullWidth = _ref2.isFullWidth,
	        isFullWidth = _ref2$isFullWidth === undefined ? false : _ref2$isFullWidth,
	        _ref2$useLocale = _ref2.useLocale,
	        useLocale = _ref2$useLocale === undefined ? false : _ref2$useLocale,
	        _ref2$content = _ref2.content,
	        content = _ref2$content === undefined ? null : _ref2$content;
	    return {
	        type: 'dropdown',
	        key: key,
	        title: title,
	        icon: icon,
	        items: items,
	        isHeader: isHeader,
	        isFullWidth: isFullWidth,
	        useLocale: useLocale,
	        content: content
	    };
	};
	
	var group = function group(_ref3) {
	    var key = _ref3.key,
	        title = _ref3.title,
	        icon = _ref3.icon,
	        _ref3$paths = _ref3.paths,
	        paths = _ref3$paths === undefined ? [] : _ref3$paths,
	        _ref3$items = _ref3.items,
	        items = _ref3$items === undefined ? [] : _ref3$items,
	        _ref3$content = _ref3.content,
	        content = _ref3$content === undefined ? null : _ref3$content,
	        _ref3$isHeader = _ref3.isHeader,
	        isHeader = _ref3$isHeader === undefined ? false : _ref3$isHeader,
	        _ref3$submenuVariant = _ref3.submenuVariant,
	        submenuVariant = _ref3$submenuVariant === undefined ? null : _ref3$submenuVariant,
	        _ref3$isFullWidth = _ref3.isFullWidth,
	        isFullWidth = _ref3$isFullWidth === undefined ? false : _ref3$isFullWidth;
	    return {
	        type: 'group',
	        key: key,
	        title: title,
	        icon: icon,
	        paths: paths,
	        items: items,
	        content: content,
	        isHeader: isHeader,
	        submenuVariant: submenuVariant,
	        isFullWidth: isFullWidth
	    };
	};
	
	var button = function button(_ref4) {
	    var key = _ref4.key,
	        title = _ref4.title,
	        icon = _ref4.icon,
	        action = _ref4.action;
	    return {
	        type: 'button',
	        key: key,
	        title: title,
	        icon: icon,
	        action: action
	    };
	};
	
	function createUserHeaderMenuConfig() {
	    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref5$adminPrivileges = _ref5.adminPrivileges,
	        adminPrivileges = _ref5$adminPrivileges === undefined ? false : _ref5$adminPrivileges;
	
	    var adminPanelLink = adminPrivileges ? link({
	        key: 'admin-panel',
	        to: '/console',
	        icon: 'console, command-line',
	        title: message('HeaderMenu.list.adminPanel', 'Админ-панель')
	    }) : null;
	
	    return {
	        desktop: {
	            leftItems: [link({
	                to: '/',
	                icon: 'home',
	                title: message('UserMenu.list.home', 'Главная')
	            }), link({
	                to: '/projects',
	                icon: 'file-text',
	                title: message('UserMenu.list.projects', 'Проекты')
	            }), dropdown({
	                key: 'transactions',
	                title: message('UserMenu.list.transactions', 'Транзакции'),
	                icon: 'stats-dots',
	                items: [link({
	                    to: '/transactions',
	                    icon: 'dollar',
	                    title: message('UserMenu.title.payments', 'Платежи')
	                }), link({
	                    to: '/payouts',
	                    icon: 'file-excel',
	                    title: message('UserMenu.title.registries', 'Реестры')
	                }), link({
	                    key: 'mobile-payouts',
	                    to: '/mobile-payouts',
	                    icon: 'mobile',
	                    title: message('UserMenu.title.mobileRegistries', 'Реестры (СБП)'),
	                    access: ['ACCESS_SBP_REGISTRY'],
	                    exact: false
	                })]
	            }), link({
	                key: 'statement',
	                to: '/statement',
	                icon: 'file-text',
	                title: message('UserMenu.title.statement', 'Выписка'),
	                access: ['ACCESS_STATEMENT'],
	                exact: false
	            }), dropdown({
	                key: 'antifraud',
	                title: message('UserMenu.title.antifraud', 'Антифрод'),
	                icon: 'shield',
	                paths: ['/antifraud-check', '/antifraud-single-check', '/antifraud-log'],
	                items: [link({
	                    key: 'antifraud-check',
	                    to: '/antifraud-check',
	                    icon: 'cloud-upload',
	                    title: message('UserMenu.title.antifraudFileCheck', 'Проверка файла'),
	                    access: ['ACCESS_ANTIFRAUD_FILE'],
	                    exact: false
	                }), link({
	                    key: 'antifraud-single-check',
	                    to: '/antifraud-single-check',
	                    icon: 'search',
	                    title: message('UserMenu.title.antifraudSingleCheck', 'Разовая проверка'),
	                    access: ['ACCESS_ANTIFRAUD_SINGLE'],
	                    exact: false
	                }), link({
	                    key: 'antifraud-log',
	                    to: '/antifraud-log',
	                    icon: 'history',
	                    title: message('UserMenu.title.antifraudLog', 'Лог проверок'),
	                    access: ['ACCESS_ANTIFRAUD_LOG'],
	                    exact: false
	                })]
	            }), dropdown({
	                key: 'finance',
	                title: message('UserMenu.title.finance', 'Финансы'),
	                icon: 'coin-dollar',
	                items: [link({
	                    key: 'registries',
	                    to: '/registry-upload',
	                    icon: 'share',
	                    title: message('UserMenu.title.registries', 'Реестры'),
	                    access: ['PAYOUT_REGISTRY_PROCESS'],
	                    exact: false
	                }), link({
	                    key: 'sbp-registries',
	                    to: '/mobile-registry-upload',
	                    icon: 'mobile',
	                    title: message('UserMenu.title.sbpRegistries', 'Реестры (СБП)'),
	                    access: ['ACCESS_SBP_REGISTRY'],
	                    exact: false
	                }), link({
	                    key: 'payouts',
	                    to: '/pay',
	                    icon: 'banknote',
	                    title: message('UserMenu.title.payouts', 'Выплаты'),
	                    access: ['ACCESS_PAYOUTS'],
	                    exact: false
	                }), link({
	                    key: 'sbp-payouts',
	                    to: '/sbp-pay',
	                    icon: 'mobile',
	                    title: message('UserMenu.title.sbpPayouts', 'Выплаты (СБП)'),
	                    access: ['ACCESS_SBP_PAYOUT'],
	                    exact: false
	                }), link({
	                    key: 'metal',
	                    to: '/metal',
	                    icon: 'dollar',
	                    title: message('UserMenu.title.metal', 'Металл'),
	                    access: ['ACCESS_METAL'],
	                    accessDenied: 'hide',
	                    exact: false
	                })]
	            }), link({
	                key: 'prepaid',
	                to: '/prepaid',
	                icon: 'credit-card',
	                title: message('UserMenu.title.prepaid', 'Предоплаченные карты'),
	                access: ['PREPAID_CARDS_VIEW'],
	                accessDenied: 'hide',
	                exact: false
	            })],
	            rightItems: [].concat(_toConsumableArray(adminPanelLink ? [adminPanelLink] : []), [group({
	                key: 'profile',
	                title: function title(ctx) {
	                    return ctx.profileName;
	                },
	                icon: 'user',
	                isHeader: true,
	                items: [link({
	                    to: '/profile',
	                    icon: 'user-tie',
	                    title: message('HeaderMenu.list.account', 'Мой профиль')
	                }), link({
	                    to: '/secret-chats',
	                    icon: 'lock',
	                    title: message('HeaderMenu.list.secretChats', 'Chats'),
	                    // Счётчик непрочитанного — тем же механизмом, что и остальные метки.
	                    badge: function badge(ctx) {
	                        return Number(ctx.secretChatUnread || 0) > 0 ? String(ctx.secretChatUnread) : null;
	                    }
	                }), button({
	                    key: 'logout',
	                    title: message('HeaderMenu.list.logout', 'Выход'),
	                    icon: 'stand-by',
	                    action: 'logout'
	                })]
	            })])
	        },
	        drawer: {
	            sections: [link({
	                to: '/',
	                icon: 'home',
	                title: message('UserMenu.list.home', 'Главная')
	            }), link({
	                to: '/projects',
	                icon: 'file-text',
	                title: message('UserMenu.list.projects', 'Проекты')
	            }), group({
	                key: 'transactions',
	                title: message('UserMenu.list.transactions', 'Транзакции'),
	                icon: 'stats-dots',
	                paths: ['/transactions', '/payouts', '/mobile-payouts'],
	                items: [link({
	                    to: '/transactions',
	                    icon: 'dollar',
	                    title: message('UserMenu.title.payments', 'Платежи')
	                }), link({
	                    to: '/payouts',
	                    icon: 'file-excel',
	                    title: message('UserMenu.title.registries', 'Реестры')
	                }), link({
	                    key: 'mobile-payouts',
	                    to: '/mobile-payouts',
	                    icon: 'mobile',
	                    title: message('UserMenu.title.mobileRegistries', 'Реестры (СБП)'),
	                    access: ['ACCESS_SBP_REGISTRY'],
	                    exact: false
	                })]
	            }), link({
	                key: 'statement',
	                to: '/statement',
	                icon: 'file-text',
	                title: message('UserMenu.title.statement', 'Выписка'),
	                access: ['ACCESS_STATEMENT'],
	                exact: false
	            }), group({
	                key: 'antifraud',
	                title: message('UserMenu.title.antifraud', 'Антифрод'),
	                icon: 'shield',
	                paths: ['/antifraud-check', '/antifraud-single-check', '/antifraud-log'],
	                items: [link({
	                    key: 'antifraud-check',
	                    to: '/antifraud-check',
	                    icon: 'cloud-upload',
	                    title: message('UserMenu.title.antifraudFileCheck', 'Проверка файла'),
	                    access: ['ACCESS_ANTIFRAUD_FILE'],
	                    exact: false
	                }), link({
	                    key: 'antifraud-single-check',
	                    to: '/antifraud-single-check',
	                    icon: 'search',
	                    title: message('UserMenu.title.antifraudSingleCheck', 'Разовая проверка'),
	                    access: ['ACCESS_ANTIFRAUD_SINGLE'],
	                    exact: false
	                }), link({
	                    key: 'antifraud-log',
	                    to: '/antifraud-log',
	                    icon: 'history',
	                    title: message('UserMenu.title.antifraudLog', 'Лог проверок'),
	                    access: ['ACCESS_ANTIFRAUD_LOG'],
	                    exact: false
	                })]
	            }), group({
	                key: 'finance',
	                title: message('UserMenu.title.finance', 'Финансы'),
	                icon: 'coin-dollar',
	                paths: ['/registry-upload', '/mobile-registry-upload', '/pay', '/sbp-pay', '/metal'],
	                items: [link({
	                    key: 'registries',
	                    to: '/registry-upload',
	                    icon: 'share',
	                    title: message('UserMenu.title.registries', 'Реестры'),
	                    access: ['PAYOUT_REGISTRY_PROCESS'],
	                    exact: false
	                }), link({
	                    key: 'sbp-registries',
	                    to: '/mobile-registry-upload',
	                    icon: 'mobile',
	                    title: message('UserMenu.title.sbpRegistries', 'Реестры (СБП)'),
	                    access: ['ACCESS_SBP_REGISTRY'],
	                    exact: false
	                }), link({
	                    key: 'payouts',
	                    to: '/pay',
	                    icon: 'banknote',
	                    title: message('UserMenu.title.payouts', 'Выплаты'),
	                    access: ['ACCESS_PAYOUTS'],
	                    exact: false
	                }), link({
	                    key: 'sbp-payouts',
	                    to: '/sbp-pay',
	                    icon: 'mobile',
	                    title: message('UserMenu.title.sbpPayouts', 'Выплаты (СБП)'),
	                    access: ['ACCESS_SBP_PAYOUT'],
	                    exact: false
	                }), link({
	                    key: 'metal',
	                    to: '/metal',
	                    icon: 'dollar',
	                    title: message('UserMenu.title.metal', 'Металл'),
	                    access: ['ACCESS_METAL'],
	                    accessDenied: 'hide',
	                    exact: false
	                })]
	            }), link({
	                key: 'prepaid',
	                to: '/prepaid',
	                icon: 'credit-card',
	                title: message('UserMenu.title.prepaid', 'Предоплаченные карты'),
	                access: ['PREPAID_CARDS_VIEW'],
	                accessDenied: 'hide',
	                exact: false
	            })],
	            footerTitle: function footerTitle(ctx) {
	                return ctx.profileName;
	            },
	            footerItems: [].concat(_toConsumableArray(adminPanelLink ? [adminPanelLink] : []), [link({
	                to: '/profile',
	                icon: 'user-tie',
	                title: message('HeaderMenu.list.account', 'Мой профиль')
	            }), link({
	                to: '/secret-chats',
	                icon: 'lock',
	                title: message('HeaderMenu.list.secretChats', 'Chats'),
	                // Счётчик непрочитанного — тем же механизмом, что и остальные метки.
	                badge: function badge(ctx) {
	                    return Number(ctx.secretChatUnread || 0) > 0 ? String(ctx.secretChatUnread) : null;
	                }
	            }), button({
	                key: 'logout',
	                title: message('HeaderMenu.list.logout', 'Выход'),
	                icon: 'stand-by',
	                action: 'logout'
	            })])
	        }
	    };
	}
	
	function createAdminHeaderMenuConfig() {
	    var homeLink = link({
	        key: 'client-home',
	        to: '/',
	        icon: 'home',
	        title: message('HeaderMenu.list.clientHome', 'На главную')
	    });
	
	    return {
	        desktop: {
	            leftItems: [link({
	                to: '/console',
	                icon: 'console, command-line',
	                title: message('AdministrationMenu.title.console', 'Админ-панель')
	            }), link({
	                to: '/transaction-audit',
	                icon: 'time',
	                title: message('AdministrationMenu.title.transactionAudit', 'Аудит транзакций')
	            }), dropdown({
	                key: 'settings',
	                title: message('AdministrationMenu.list.settings', 'Настройки'),
	                icon: 'user-group',
	                paths: ['/accounts-control', '/projects-control', '/terminals-control', '/profile-control'],
	                items: [link({
	                    to: '/accounts-control',
	                    icon: 'user-tie',
	                    title: message('AdministrationMenu.title.accountsList', 'Сотрудники')
	                }), link({
	                    to: '/projects-control',
	                    icon: 'store-front',
	                    title: message('AdministrationMenu.title.projectsList', 'Проекты')
	                }), link({
	                    to: '/terminals-control',
	                    icon: 'calculator',
	                    title: message('AdministrationMenu.title.terminalsList', 'Терминалы')
	                })]
	            }), dropdown({
	                key: 'finance',
	                title: message('AdministrationMenu.list.finance', 'Финансы'),
	                icon: 'dollar',
	                paths: ['/settlements', '/deposits', '/crm-payout-requests', '/crm-sbp-payout-requests', '/reconciliation'],
	                items: [link({
	                    to: '/settlements',
	                    icon: 'calculator',
	                    title: message('AdministrationMenu.title.settlements', 'Расчёты')
	                }), link({
	                    to: '/deposits',
	                    icon: 'wallet',
	                    title: message('AdministrationMenu.title.deposits', 'Депозиты')
	                }), link({
	                    to: '/crm-payout-requests',
	                    icon: 'banknote',
	                    title: message('AdministrationMenu.title.crmPayoutRequests', 'CRM-заявки')
	                }), link({
	                    to: '/crm-sbp-payout-requests',
	                    icon: 'banknote',
	                    title: message('AdministrationMenu.title.crmSbpPayoutRequests', 'CRM-заявки СБП')
	                }), link({
	                    to: '/reconciliation',
	                    icon: 'stats-dots',
	                    title: message('AdministrationMenu.title.reconciliation', 'Сверка')
	                })]
	            }), dropdown({
	                key: 'analytics',
	                title: message('AdministrationMenu.list.analytics', 'Аналитика'),
	                icon: 'stats-dots',
	                paths: ['/traffic-monitoring', '/admin-audit', '/antifraud', '/payout-holds', '/report-constructor'],
	                items: [link({
	                    to: '/traffic-monitoring',
	                    icon: 'stats-dots',
	                    title: message('AdministrationMenu.title.trafficMonitoring', 'Мониторинг трафика')
	                }), link({
	                    to: '/admin-audit',
	                    icon: 'history',
	                    title: message('AdministrationMenu.title.adminAudit', 'Журнал действий')
	                }), link({
	                    to: '/antifraud',
	                    icon: 'lock',
	                    title: message('AdministrationMenu.title.antifraud', 'Антифрод')
	                }), link({
	                    to: '/payout-holds',
	                    icon: 'warning',
	                    title: message('AdministrationMenu.title.payoutHolds', 'Остановленные выплаты')
	                }), link({
	                    to: '/report-constructor',
	                    icon: 'construction',
	                    title: message('AdministrationMenu.title.constructor', 'Конструктор')
	                })]
	            }), dropdown({
	                key: 'support',
	                title: message('AdministrationMenu.list.support', 'Поддержка'),
	                icon: 'message',
	                paths: ['/disputes', '/admin/tickets', '/api-console'],
	                items: [link({
	                    to: '/disputes',
	                    icon: 'warning',
	                    title: message('AdministrationMenu.title.disputes', 'Диспуты')
	                }), link({
	                    to: '/admin/tickets',
	                    icon: 'message',
	                    title: message('AdministrationMenu.title.tickets', 'Обращения')
	                }), link({
	                    to: '/admin/secret-chats',
	                    icon: 'lock',
	                    title: message('AdministrationMenu.title.secretChats', 'Секретные чаты'),
	                    // Счётчик непрочитанного — тем же механизмом, что и остальные метки.
	                    badge: function badge(ctx) {
	                        return Number(ctx.secretChatUnread || 0) > 0 ? String(ctx.secretChatUnread) : null;
	                    }
	                })]
	            })],
	            rightItems: [homeLink, group({
	                key: 'profile',
	                title: function title(ctx) {
	                    return ctx.profileName;
	                },
	                icon: 'user',
	                isHeader: true,
	                items: [link({
	                    to: '/profile-control',
	                    icon: 'user-tie',
	                    title: message('HeaderMenu.list.account', 'Мой профиль')
	                }), link({
	                    to: '/api-console',
	                    icon: 'code',
	                    title: message('HeaderMenu.list.apiconsole', 'API консоль')
	                }), button({
	                    key: 'logout',
	                    title: message('HeaderMenu.list.logout', 'Выход'),
	                    icon: 'stand-by',
	                    action: 'logout'
	                })]
	            })]
	        },
	        drawer: {
	            sections: [link({
	                to: '/console',
	                icon: 'console, command-line',
	                title: message('AdministrationMenu.title.console', 'Админ-панель')
	            }), link({
	                to: '/transaction-audit',
	                icon: 'time',
	                title: message('AdministrationMenu.title.transactionAudit', 'Аудит транзакций')
	            }), dropdown({
	                key: 'settings',
	                title: message('AdministrationMenu.list.settings', 'Настройки'),
	                icon: 'user-group',
	                items: [link({
	                    to: '/accounts-control',
	                    icon: 'user-tie',
	                    title: message('AdministrationMenu.title.accountsList', 'Сотрудники')
	                }), link({
	                    to: '/projects-control',
	                    icon: 'store-front',
	                    title: message('AdministrationMenu.title.projectsList', 'Проекты')
	                }), link({
	                    to: '/terminals-control',
	                    icon: 'calculator',
	                    title: message('AdministrationMenu.title.terminalsList', 'Терминалы')
	                })]
	            }), dropdown({
	                key: 'finance',
	                title: message('AdministrationMenu.list.finance', 'Финансы'),
	                icon: 'dollar',
	                items: [link({
	                    to: '/settlements',
	                    icon: 'calculator',
	                    title: message('AdministrationMenu.title.settlements', 'Расчёты')
	                }), link({
	                    to: '/deposits',
	                    icon: 'wallet',
	                    title: message('AdministrationMenu.title.deposits', 'Депозиты')
	                }), link({
	                    to: '/crm-payout-requests',
	                    icon: 'banknote',
	                    title: message('AdministrationMenu.title.crmPayoutRequests', 'CRM-заявки')
	                }), link({
	                    to: '/crm-sbp-payout-requests',
	                    icon: 'banknote',
	                    title: message('AdministrationMenu.title.crmSbpPayoutRequests', 'CRM-заявки СБП')
	                }), link({
	                    to: '/reconciliation',
	                    icon: 'stats-dots',
	                    title: message('AdministrationMenu.title.reconciliation', 'Сверка')
	                })]
	            }), dropdown({
	                key: 'analytics',
	                title: message('AdministrationMenu.list.analytics', 'Аналитика'),
	                icon: 'stats-dots',
	                items: [link({
	                    to: '/traffic-monitoring',
	                    icon: 'stats-dots',
	                    title: message('AdministrationMenu.title.trafficMonitoring', 'Мониторинг трафика')
	                }), link({
	                    to: '/admin-audit',
	                    icon: 'history',
	                    title: message('AdministrationMenu.title.adminAudit', 'Журнал действий')
	                }), link({
	                    to: '/antifraud',
	                    icon: 'lock',
	                    title: message('AdministrationMenu.title.antifraud', 'Антифрод')
	                }), link({
	                    to: '/payout-holds',
	                    icon: 'warning',
	                    title: message('AdministrationMenu.title.payoutHolds', 'Остановленные выплаты')
	                }), link({
	                    to: '/report-constructor',
	                    icon: 'construction',
	                    title: message('AdministrationMenu.title.constructor', 'Конструктор')
	                })]
	            }), dropdown({
	                key: 'support',
	                title: message('AdministrationMenu.list.support', 'Поддержка'),
	                icon: 'message',
	                items: [link({
	                    to: '/disputes',
	                    icon: 'warning',
	                    title: message('AdministrationMenu.title.disputes', 'Диспуты')
	                }), link({
	                    to: '/admin/tickets',
	                    icon: 'message',
	                    title: message('AdministrationMenu.title.tickets', 'Обращения')
	                }), link({
	                    to: '/admin/secret-chats',
	                    icon: 'lock',
	                    title: message('AdministrationMenu.title.secretChats', 'Секретные чаты'),
	                    // Счётчик непрочитанного — тем же механизмом, что и остальные метки.
	                    badge: function badge(ctx) {
	                        return Number(ctx.secretChatUnread || 0) > 0 ? String(ctx.secretChatUnread) : null;
	                    }
	                })]
	            })],
	            footerItems: [homeLink, link({
	                to: '/profile-control',
	                icon: 'user-tie',
	                title: message('HeaderMenu.list.account', 'Мой профиль')
	            }), link({
	                to: '/api-console',
	                icon: 'code',
	                title: message('HeaderMenu.list.apiconsole', 'API консоль')
	            }), button({
	                key: 'logout',
	                title: message('HeaderMenu.list.logout', 'Выход'),
	                icon: 'stand-by',
	                action: 'logout'
	            })]
	        }
	    };
	}
	
	function createDefaultHeaderMenuConfig() {
	    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        adminPrivileges = _ref6.adminPrivileges;
	
	    return adminPrivileges ? createAdminHeaderMenuConfig() : createUserHeaderMenuConfig();
	}

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _AccessControl = __webpack_require__(99);
	
	var _AccessControl2 = _interopRequireDefault(_AccessControl);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _xls = __webpack_require__(658);
	
	var _xls2 = _interopRequireDefault(_xls);
	
	var _C = __webpack_require__(657);
	
	var _C2 = _interopRequireDefault(_C);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(593);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function ReportWidget(_ref) {
	    var getReport = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var reportName;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!isLoading) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt("return");
	
	                        case 2:
	                            setIsLoading(true);
	
	                            _context.prev = 3;
	                            reportName = name.replace(".xls", "") + " - " + currentDate;
	                            _context.next = 7;
	                            return new _Api2.default({ token: token }).getReport(type, filter, reportName, format);
	
	                        case 7:
	                            _context.prev = 7;
	
	                            setIsLoading(false);
	                            return _context.finish(7);
	
	                        case 10:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[3,, 7, 10]]);
	        }));
	
	        return function getReport() {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    var hasAccess = _ref.hasAccess,
	        count = _ref.count,
	        type = _ref.type,
	        countLabel = _ref.countLabel,
	        name = _ref.name,
	        date = _ref.date,
	        filter = _ref.filter,
	        token = _ref.token,
	        disabled = _ref.disabled;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isLoading = _useState2[0],
	        setIsLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)("csv"),
	        _useState4 = _slicedToArray(_useState3, 2),
	        format = _useState4[0],
	        setFormat = _useState4[1];
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var currentDate = new Date().toLocaleString(intl.locale, {
	        day: "numeric",
	        month: "numeric",
	        year: "numeric",
	        hour: "numeric",
	        minute: "numeric"
	    });
	
	    var logo = _xls2.default;
	    var text = format;
	
	    if (type === "payout1C" || type === "transactions1C") {
	        logo = _C2.default;
	        text = "1C";
	    }
	
	    if (!hasAccess) return null;
	
	    var hasDate = date && Object.keys(date).length > 0;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Image },
	            _react2.default.createElement("img", {
	                src: logo,
	                width: "68",
	                height: "91",
	                alt: intl.formatMessage({ id: "ReportWidget.imageAlt", defaultMessage: "Сформировать отчет" })
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Ctrl },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Count },
	                countLabel ? countLabel : _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ReportWidget.operations", defaultMessage: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0439" }),
	                ": ",
	                count
	            ),
	            hasDate && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Date },
	                date.startDate.substring(0, 10),
	                " - ",
	                date.endDate.substring(0, 10)
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.SelectWrapper },
	                _react2.default.createElement(
	                    "label",
	                    { htmlFor: "formatSelect" },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ReportWidget.format", defaultMessage: "\u0424\u043E\u0440\u043C\u0430\u0442:" })
	                ),
	                _react2.default.createElement(
	                    "select",
	                    {
	                        id: "formatSelect",
	                        className: _stylesModule2.default.Select,
	                        value: format,
	                        onChange: function onChange(e) {
	                            return setFormat(e.target.value);
	                        },
	                        disabled: isLoading
	                    },
	                    _react2.default.createElement(
	                        "option",
	                        { value: "csv" },
	                        "CSV"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "xls" },
	                        "XLS"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "xlsx" },
	                        "XLSX"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "button",
	                { onClick: getReport, className: _stylesModule2.default.Btn, disabled: disabled || isLoading },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "document-download", size: "21px" }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "ReportWidget.generate",
	                    defaultMessage: "\u0421\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043E\u0442\u0447\u0435\u0442 {format}",
	                    values: { format: text.toUpperCase() }
	                })
	            )
	        )
	    );
	}
	
	exports.default = (0, _AccessControl2.default)(ReportWidget);

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(23);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TabBarItem = function TabBarItem(_ref) {
	    var children = _ref.children,
	        label = _ref.label,
	        navIcon = _ref.navIcon,
	        navIconSize = _ref.navIconSize,
	        activeTab = _ref.activeTab,
	        isVisible = _ref.isVisible,
	        attrs = _objectWithoutProperties(_ref, ["children", "label", "navIcon", "navIconSize", "activeTab", "isVisible"]);
	
	    var style = {
	        display: "none"
	    };
	
	    if (activeTab === label) {
	        style.display = "block";
	    }
	
	    return isVisible && _react2.default.createElement(
	        "div",
	        Object.assign({ style: style }, attrs),
	        children
	    );
	};
	
	TabBarItem.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    navIcon: _propTypes2.default.string,
	    navIconSize: _propTypes2.default.number,
	    children: _propTypes2.default.node,
	    activeTab: _propTypes2.default.string
	};
	
	TabBarItem.defaultProps = {
	    children: null,
	    navIcon: 'align-justified',
	    navIconSize: 14,
	    activeTab: ''
	};
	
	exports.default = TabBarItem;

/***/ },
/* 97 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ApiResponseValidator Service
	 * Validates API responses before processing to catch structure issues early
	 */
	
	var ApiResponseValidator = function () {
	  function ApiResponseValidator() {
	    _classCallCheck(this, ApiResponseValidator);
	  }
	
	  _createClass(ApiResponseValidator, null, [{
	    key: 'validatePayoutResponse',
	
	    /**
	     * Validate payment/payout response structure
	     * @param {Object} response - API response
	     * @throws {Error} If response structure is invalid
	     * @returns {Object} Validated response
	     */
	    value: function validatePayoutResponse(response) {
	      if (!response) {
	        throw new Error('Empty response from payout API');
	      }
	
	      // Check for error in response
	      if (response.error === true) {
	        var error = new Error(response.message || 'Payout operation failed');
	        error.apiResponse = response;
	        throw error;
	      }
	
	      // Validate transactionId or similar identifier
	      if (response.transactionId === undefined && response.transaction_id === undefined) {
	        console.warn('Warning: Payout response missing transaction identifier', response);
	      }
	
	      return response;
	    }
	
	    /**
	     * Validate registry upload response
	     * @param {Object} response - API response
	     * @throws {Error} If response structure is invalid
	     * @returns {Object} Validated response
	     */
	
	  }, {
	    key: 'validateRegistryUpload',
	    value: function validateRegistryUpload(response) {
	      if (!response) {
	        throw new Error('Empty response from registry upload');
	      }
	
	      if (response.error === true) {
	        var error = new Error(response.message || 'Registry upload failed');
	        error.apiResponse = response;
	        throw error;
	      }
	
	      if (!response.id && !response.uuid && !response.registryId) {
	        throw new Error('Invalid registry response: missing ID');
	      }
	
	      return response;
	    }
	
	    /**
	     * Validate registry validation response (after upload, before processing)
	     * @param {Object} response - API response
	     * @throws {Error} If response structure is invalid or has validation errors
	     * @returns {Object} Validated response
	     */
	
	  }, {
	    key: 'validateRegistryValidation',
	    value: function validateRegistryValidation(response) {
	      if (!response) {
	        throw new Error('Empty response from registry validation');
	      }
	
	      if (response.error === true) {
	        var error = new Error(response.message || 'Registry validation failed');
	        error.apiResponse = response;
	        error.validationErrors = response.errors || [];
	        throw error;
	      }
	
	      // If there are validation errors in the response, throw them
	      if (Array.isArray(response.errors) && response.errors.length > 0) {
	        var _error = new Error('Registry has validation errors');
	        _error.validationErrors = response.errors;
	        _error.apiResponse = response;
	        throw _error;
	      }
	
	      return response;
	    }
	
	    /**
	     * Validate registry process/reprocess response
	     * @param {Object} response - API response
	     * @throws {Error} If response structure is invalid
	     * @returns {Object} Validated response
	     */
	
	  }, {
	    key: 'validateRegistryProcess',
	    value: function validateRegistryProcess(response) {
	      if (!response) {
	        throw new Error('Empty response from registry process');
	      }
	
	      if (response.error === true) {
	        var error = new Error(response.message || 'Registry processing failed');
	        error.apiResponse = response;
	        throw error;
	      }
	
	      // Processing doesn't necessarily return data, but check for error indicators
	      return response;
	    }
	
	    /**
	     * Validate list/array response
	     * @param {Object} response - API response (typically { data: [...], count: N })
	     * @throws {Error} If response structure is invalid
	     * @returns {Object} Validated response
	     */
	
	  }, {
	    key: 'validateListResponse',
	    value: function validateListResponse(response) {
	      if (!response) {
	        throw new Error('Empty response from list API');
	      }
	
	      if (response.error === true) {
	        var error = new Error(response.message || 'Failed to fetch list');
	        error.apiResponse = response;
	        throw error;
	      }
	
	      // Validate structure
	      if (!Array.isArray(response.data) && !Array.isArray(response)) {
	        console.warn('Warning: List response missing data array', response);
	      }
	
	      return response;
	    }
	
	    /**
	     * Validate pagination response
	     * @param {Object} response - API response with pagination
	     * @throws {Error} If response structure is invalid
	     * @returns {Object} Validated response
	     */
	
	  }, {
	    key: 'validatePaginationResponse',
	    value: function validatePaginationResponse(response) {
	      if (!response) {
	        throw new Error('Empty response from pagination API');
	      }
	
	      if (response.error === true) {
	        var error = new Error(response.message || 'Failed to fetch paginated data');
	        error.apiResponse = response;
	        throw error;
	      }
	
	      // Check for required pagination fields
	      if (!Array.isArray(response.data)) {
	        console.warn('Warning: Pagination response missing data array', response);
	      }
	
	      if (response.count === undefined) {
	        console.warn('Warning: Pagination response missing count field', response);
	      }
	
	      return response;
	    }
	
	    /**
	     * Validate transaction response
	     * @param {Object} response - API response
	     * @throws {Error} If response structure is invalid
	     * @returns {Object} Validated response
	     */
	
	  }, {
	    key: 'validateTransactionResponse',
	    value: function validateTransactionResponse(response) {
	      if (!response) {
	        throw new Error('Empty response from transaction API');
	      }
	
	      if (response.error === true) {
	        var error = new Error(response.message || 'Transaction operation failed');
	        error.apiResponse = response;
	        throw error;
	      }
	
	      if (!response.id && !response.transactionId && !response.transaction_id) {
	        console.warn('Warning: Transaction response missing ID', response);
	      }
	
	      return response;
	    }
	
	    /**
	     * Validate generic response for common errors
	     * @param {Object} response - API response
	     * @throws {Error} If response contains error
	     * @returns {Object} Validated response
	     */
	
	  }, {
	    key: 'validateResponse',
	    value: function validateResponse(response) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!response) {
	        throw new Error(options.emptyMessage || 'Empty response from server');
	      }
	
	      // Check for error flag
	      if (response.error === true) {
	        var error = new Error(response.message || options.errorMessage || 'Operation failed');
	        error.apiResponse = response;
	        throw error;
	      }
	
	      // Check for error code
	      if (response.code && response.code !== 0 && response.code !== '0') {
	        var _error2 = new Error(response.message || options.errorMessage || 'Operation failed');
	        _error2.code = response.code;
	        _error2.apiResponse = response;
	        throw _error2;
	      }
	
	      // Check for success flag explicitly if provided
	      if (options.requireSuccess === true && response.success !== true) {
	        throw new Error(options.errorMessage || 'Operation was not successful');
	      }
	
	      return response;
	    }
	
	    /**
	     * Validate response and extract data field
	     * @param {Object} response - API response
	     * @param {string} dataPath - Path to data (e.g., 'data', 'payload.data')
	     * @returns {*} Extracted data
	     * @throws {Error} If data not found
	     */
	
	  }, {
	    key: 'validateAndExtractData',
	    value: function validateAndExtractData(response) {
	      var dataPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';
	
	      this.validateResponse(response);
	
	      var data = this.getNestedValue(response, dataPath);
	      if (data === undefined) {
	        throw new Error('Expected data at path \'' + dataPath + '\' not found in response');
	      }
	
	      return data;
	    }
	
	    /**
	     * Get nested value from object
	     * @param {Object} obj - Object to query
	     * @param {string} path - Path to value (e.g., 'user.profile.name')
	     * @returns {*} Value at path or undefined
	     */
	
	  }, {
	    key: 'getNestedValue',
	    value: function getNestedValue(obj, path) {
	      return path.split('.').reduce(function (current, prop) {
	        return current && current[prop];
	      }, obj);
	    }
	
	    /**
	     * Check if response indicates successful operation
	     * @param {Object} response - API response
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isSuccessResponse',
	    value: function isSuccessResponse(response) {
	      if (!response) return false;
	      return response.error !== true && (!response.code || response.code === 0 || response.code === '0');
	    }
	
	    /**
	     * Check if response indicates an error
	     * @param {Object} response - API response
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isErrorResponse',
	    value: function isErrorResponse(response) {
	      if (!response) return true;
	      return response.error === true || response.code && response.code !== 0 && response.code !== '0';
	    }
	  }]);
	
	  return ApiResponseValidator;
	}();
	
	exports.default = ApiResponseValidator;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ErrorHandler Service
	 * Centralized error categorization, formatting, and user-friendly messaging
	 */
	
	var ErrorHandler = function () {
	  function ErrorHandler() {
	    _classCallCheck(this, ErrorHandler);
	  }
	
	  _createClass(ErrorHandler, null, [{
	    key: 'categorizeError',
	
	    /**
	     * Categorize error into specific type for better handling
	     * @param {Error|Object} error - Error object from axios or custom
	     * @returns {Object} { type, code, message, isCritical, details }
	     */
	    value: function categorizeError(error) {
	      // Network error (no response from server)
	      if (!error.response) {
	        if (error.code === 'ECONNABORTED') {
	          return {
	            type: 'timeout',
	            code: 'TIMEOUT',
	            message: error.message || 'Request timeout',
	            isCritical: true,
	            details: error
	          };
	        }
	        return {
	          type: 'network',
	          code: 'NETWORK_ERROR',
	          message: error.message || 'Network error. Please check your connection.',
	          isCritical: true,
	          details: error
	        };
	      }
	
	      var _error$response = error.response,
	          status = _error$response.status,
	          data = _error$response.data;
	
	      // 401 Unauthorized - Token expired (handled by interceptor, but fallback here)
	
	      if (status === 401) {
	        return {
	          type: 'auth',
	          code: 'UNAUTHORIZED',
	          message: 'Your session has expired. Please login again.',
	          isCritical: true,
	          details: error
	        };
	      }
	
	      // 403 Forbidden - User doesn't have permission
	      if (status === 403) {
	        return {
	          type: 'permission_denied',
	          code: 'FORBIDDEN',
	          message: data && data.message || 'You don\'t have permission to perform this action',
	          isCritical: false,
	          details: data
	        };
	      }
	
	      // 400 Bad Request - Validation error or incorrect parameters
	      if (status === 400) {
	        return {
	          type: 'validation',
	          code: 'BAD_REQUEST',
	          message: data && data.message || 'Invalid request. Please check your input.',
	          isCritical: false,
	          details: data && data.errors || data
	        };
	      }
	
	      // 422 Unprocessable Entity - Business logic error
	      if (status === 422) {
	        return {
	          type: 'unprocessable',
	          code: 'UNPROCESSABLE',
	          message: data && data.message || 'Cannot process this request',
	          isCritical: false,
	          details: data
	        };
	      }
	
	      // 500+ Server error
	      if (status >= 500) {
	        return {
	          type: 'server_error',
	          code: 'SERVER_ERROR_' + status,
	          message: 'Server error. Please try again later.',
	          isCritical: true,
	          details: error
	        };
	      }
	
	      // Unknown error
	      return {
	        type: 'unknown',
	        code: 'ERROR_' + status,
	        message: data && data.message || 'An error occurred. Please try again.',
	        isCritical: status >= 500,
	        details: data || error
	      };
	    }
	
	    /**
	     * Check if response contains an error (for API responses that return errors in data)
	     * @param {Object} response - Response data
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'hasErrorInResponse',
	    value: function hasErrorInResponse(response) {
	      if (!response) return false;
	      return response.error === true || response.code !== undefined || response.message && response.message.includes('error');
	    }
	
	    /**
	     * Get user-friendly error message
	     * @param {Error|Object} error - Error object
	     * @param {string} context - Context (e.g., 'payout', 'registry', 'transaction')
	     * @returns {string} User-friendly message
	     */
	
	  }, {
	    key: 'getMessageForError',
	    value: function getMessageForError(error) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'operation';
	
	      var errorInfo = this.categorizeError(error);
	
	      // Context-specific messages
	      var contextMessages = {
	        payout: {
	          permission_denied: 'You don\'t have permission to perform payouts on this merchant',
	          timeout: 'Payment operation timed out. Please try again.',
	          network: 'Network error occurred during payment. Please check your connection and try again.',
	          validation: 'Payment details are invalid. Please check and try again.',
	          server_error: 'Payment server error. Please try again later.',
	          unprocessable: 'Cannot process this payment. The merchant may not be configured properly.'
	        },
	        registry: {
	          permission_denied: 'You don\'t have permission to work with this registry\'s merchant',
	          timeout: 'Registry operation timed out. Please try again.',
	          network: 'Network error occurred during registry operation.',
	          validation: 'Registry data is invalid. Please check the file and try again.',
	          server_error: 'Registry server error. Please try again later.',
	          unprocessable: 'Registry cannot be processed. Please contact support if this persists.'
	        },
	        transaction: {
	          permission_denied: 'You don\'t have permission to modify this transaction',
	          timeout: 'Transaction operation timed out.',
	          network: 'Network error occurred during transaction operation.',
	          validation: 'Transaction data is invalid.',
	          server_error: 'Transaction server error. Please try again later.',
	          unprocessable: 'Cannot process this transaction.'
	        },
	        download: {
	          permission_denied: 'You don\'t have permission to download this file',
	          timeout: 'Download timed out. Please try again.',
	          network: 'Network error occurred during download.',
	          server_error: 'Server error occurred during download. Please try again later.'
	        }
	      };
	
	      var messages = contextMessages[context] || {};
	      return messages[errorInfo.type] || errorInfo.message;
	    }
	
	    /**
	     * Handle merchant access error specifically
	     * @param {string} merchantUUID - Merchant UUID
	     * @returns {Error}
	     */
	
	  }, {
	    key: 'handleMerchantAccessError',
	    value: function handleMerchantAccessError(merchantUUID) {
	      var error = new Error('You don\'t have access to this merchant');
	      error.type = 'permission_denied';
	      error.merchantUUID = merchantUUID;
	      return error;
	    }
	
	    /**
	     * Check if user has specific permission for a merchant
	     * @param {string} permission - Permission code (e.g., 'PAYOUT_REGISTRY_PROCESS')
	     * @param {string} merchantUUID - Merchant UUID
	     * @param {Array} accountAccessSettings - User's account access settings from JWT
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'hasPermission',
	    value: function hasPermission(permission, merchantUUID) {
	      var accountAccessSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	      if (!accountAccessSettings || accountAccessSettings.length === 0) {
	        return false;
	      }
	
	      // Find merchant access settings
	      var merchantAccess = accountAccessSettings.find(function (access) {
	        return access.merchantUUID === merchantUUID;
	      });
	
	      if (!merchantAccess) {
	        return false;
	      }
	
	      // Permission bitmasks (from PermissionsEditor)
	      var PERMISSIONS = {
	        TRANSACTION_CANCELLING: 1,
	        TRANSACTION_LIMIT_SETTING: 2,
	        STATISTICS_ACCESS: 4,
	        MAIL_ALERT_SETTING: 8,
	        PAYOUT_REGISTRY_PROCESS: 16,
	        PAYOUT_REGISTRY_VIEW: 32,
	        PAYOUT_REGISTRY_REPORT: 64,
	        PAYOUT_REGISTRIES_LIST: 128
	        // Add more as needed
	      };
	
	      var permissionBit = PERMISSIONS[permission];
	      if (!permissionBit) return false;
	
	      return (merchantAccess.privileges & permissionBit) === permissionBit;
	    }
	
	    /**
	     * Log error for debugging (can be extended to send to monitoring service)
	     * @param {Error} error - Error object
	     * @param {Object} context - Additional context { action, userId, merchantId, etc. }
	     */
	
	  }, {
	    key: 'logError',
	    value: function logError(error) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var errorInfo = this.categorizeError(error);
	      var timestamp = new Date().toISOString();
	
	      var logData = {
	        timestamp: timestamp,
	        type: errorInfo.type,
	        code: errorInfo.code,
	        message: errorInfo.message,
	        context: context,
	        details: errorInfo.details
	      };
	
	      // Log to console in development
	      if (false) {
	        console.error('[ErrorHandler]', logData);
	      }
	
	      // Send errors to Sentry
	      if (errorInfo.isCritical) {
	        Sentry.captureException(error, {
	          extra: logData,
	          tags: {
	            error_type: errorInfo.type,
	            error_code: errorInfo.code,
	            context: context.action || 'unknown'
	          }
	        });
	      }
	    }
	
	    /**
	     * Format error for API response validation
	     * @param {Object} apiResponse - Response from API
	     * @returns {Object|null} Error object or null if no error
	     */
	
	  }, {
	    key: 'extractApiError',
	    value: function extractApiError(apiResponse) {
	      if (!apiResponse) return null;
	
	      // Pattern 1: error flag
	      if (apiResponse.error === true) {
	        return {
	          type: 'api_error',
	          code: apiResponse.code,
	          message: apiResponse.message || 'API error occurred',
	          details: apiResponse
	        };
	      }
	
	      // Pattern 2: code field indicates error
	      if (apiResponse.code && apiResponse.code !== 0 && apiResponse.code !== '0') {
	        return {
	          type: 'api_error',
	          code: apiResponse.code,
	          message: apiResponse.message || 'API error occurred',
	          details: apiResponse
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return ErrorHandler;
	}();
	
	exports.default = ErrorHandler;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AccessControl(Component) {
	
	    var AccessList = {
	        "TRANSACTION_CANCELLING": 1, // Отмена операции
	        "TRANSACTION_LIMIT_SETTING": 2, // Установка лимита на размер  операции
	        "STATISTICS_ACCESS": 4, // Доступ к статистике
	        "MAIL_ALERT_SETTING": 8, // Настройка оповещений по почте
	        "PAYOUT_REGISTRY_PROCESS": 16, // Загрузка реестра на выплаты или разовые операции
	        "PAYOUT_REGISTRY_VIEW": 32, // Просмотр реестра
	        "PAYOUT_REGISTRY_REPORT": 64, // Выгрузка отчета по реестру
	        "PAYOUT_REGISTRIES_LIST": 128, // Просмотр списка реестров
	        "PREPAID_CARDS_VIEW": 256, // Просмотр раздела пре-активированных карт
	        "PREPAID_CARDS_ACTIVATE": 512, // Активация пре-активированной карты
	        "STATISTICS_REPORT_1C_VIEW": 1024, // Просмотр виджета выгрузки 1С
	        "ACCESS_PAYOUTS": 2048,
	        "ACCESS_METAL": 4096,
	        "ACCESS_SBP_REGISTRY": 8192,
	        "ACCESS_SBP_PAYOUT": 16384,
	        "ACCESS_ANTIFRAUD_FILE": 32768,
	        "ACCESS_ANTIFRAUD_SINGLE": 65536
	    };
	
	    return (0, _Auth.withAuth)(function (props) {
	
	        if (props.access !== undefined && props.access === true) return _react2.default.createElement(Component, Object.assign({}, props, { hasAccess: true }));
	
	        var accessCount = 0;
	
	        if (props.access) {
	            props.access.map(function (el) {
	                return accessCount += AccessList[el];
	            });
	        }
	
	        // Глобальные права: если включены, проверяем по глобальной маске
	        if (props.globalPrivileges !== null && props.globalPrivileges !== undefined) {
	            var _hasAccess = (accessCount & props.globalPrivileges) > 0;
	            return _react2.default.createElement(Component, Object.assign({}, props, { hasAccess: _hasAccess }));
	        }
	
	        // Per-merchant права
	        var currentAccess = 0;
	
	        if (props.accountAccessSettings) {
	            props.accountAccessSettings.map(function (el) {
	
	                if (props.hasOwnProperty('merchantUUID')) {
	                    if (el.merchantUUID === props.merchantUUID) currentAccess = el.privileges;
	                } else {
	                    if ((accessCount & el.privileges) > 0) {
	                        currentAccess = el.privileges;
	                    }
	                }
	
	                return null;
	            });
	        }
	
	        var hasAccess = (accessCount & currentAccess) > 0;
	
	        return _react2.default.createElement(Component, Object.assign({}, props, { hasAccess: hasAccess }));
	    });
	}
	
	exports.default = AccessControl;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _LayoutScopeContext = __webpack_require__(193);
	
	var _Header = __webpack_require__(93);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(171);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SupportWidget = __webpack_require__(426);
	
	var _SupportWidget2 = _interopRequireDefault(_SupportWidget);
	
	var _stylesModule = __webpack_require__(113);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RoleLayoutBase(_ref) {
	    var children = _ref.children,
	        scope = _ref.scope,
	        menuConfig = _ref.menuConfig,
	        adminPrivileges = _ref.adminPrivileges,
	        isAuthorized = _ref.isAuthorized,
	        footerProps = _ref.footerProps,
	        fallbackPath = _ref.fallbackPath;
	
	    if (!isAuthorized) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
	    }
	
	    var isAdminScope = scope === 'admin';
	    var resolvedMenuConfig = typeof menuConfig === 'function' ? menuConfig({ adminPrivileges: adminPrivileges }) : menuConfig;
	
	    if (isAdminScope && !adminPrivileges) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: fallbackPath });
	    }
	
	    var contentClassName = '' + _stylesModule2.default.Content + (scope === 'user' ? ' ' + _stylesModule2.default.UserContent : '');
	
	    return _react2.default.createElement(
	        _LayoutScopeContext.LayoutScopeProvider,
	        { value: { scope: scope, hideLegacyMenus: true } },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Wrapper },
	            _react2.default.createElement(_Header2.default, { menuConfig: resolvedMenuConfig }),
	            _react2.default.createElement(
	                'div',
	                { className: contentClassName },
	                _react2.default.createElement(
	                    _reactRouterDom.Switch,
	                    null,
	                    children
	                )
	            ),
	            _react2.default.createElement(_Footer2.default, footerProps),
	            _react2.default.createElement(_SupportWidget2.default, null)
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(RoleLayoutBase);

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(521)
	var ieee754 = __webpack_require__(661)
	var isArray = __webpack_require__(522)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 102 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_14Rrp_qbkCU4DhxdBYlaSl","Table":"_3PQgexxm44BnmL_zWinqRL","CellLeft":"soI7VENlKZE2GnMmUp1fc","Success":"_1ePEcLESJSYnUWYqTUQrHF","Decline":"_2lNbclOY5TYOMEMNz-WIri","MobileList":"_3cn_kMQpze5LIcEs4UDxis","Empty":"_35dPrzYeFDxxaHBWS2iXmY","EmptyRow":"_1rndDsPtDmXexxJONbmOgc","DesktopTable":"_3sWqHtonmGx6sMhUNeGasy","MobileCard":"slXGcfCo9QVQ9w4ZVV0r_","MobileHeader":"_3S9d1zhfNnH1yA3piJw5Kt","MobileCountry":"_9uUVDrC2EA9Fdkwz_eJAl","MobileTurnover":"_3onta4Bjmhmf1f0lV9PzFF","MobileStats":"_3d5BVSwtKS6x-hmnBQtawl"};

/***/ },
/* 103 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Scroll":"lwFpyKhYgmG9GOkfifmq0","Table":"_3qXhPxCkvEzkC6HTnheBFP","HeaderCell":"_5KdUfxA5g9WZqKIfYvDc1","HeaderCenter":"_1jneIaW73M6LkRfFZwJVo","Row":"_3PKfcOE0zdK0HqcHkqfVQJ","Cell":"_3vO73yACMpdP6_Bg0HD00z","CellCenter":"_1KZpLm-MVFsjp_wNV3O6q_","Empty":"_1gVMErSYa9kNSKB9ahI-nO","EmptyRow":"EtBX1BrRXHl5sFJf0uxBG","MobileCard":"Y18kM6-lRsGS_U8FVifut","MobilePrimary":"LAKmVphnaZkoOk3T8Eo87","MobileStatus":"_2u3DKIVGFVgm8y1U9E5tOQ","MobileMetaRow":"H3AfW4mblIFgZbqWSqc-d","MobileSecondaryRow":"_1hpHZTujT4lseO4tMY4LNh","MobileName":"_3Bzwg3NF-zBki5gq4lNRh-","MobileValue":"_3T9zUX-limglA3ymFl1k_1","MobileMeta":"_2hqeDm2QSHKzQ8PZY-_EDt"};

/***/ },
/* 104 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"_2_hlOyAZD47Fkrt1cGxD5Q","Row":"_1oQa_dJF4lc1D3U97mCjzZ","Link":"_4yPYJYs2ftqHqxGPGKHH-","Enables":"_2OgzD2kokXrzRZqoiaCRMF","Disabled":"vhia6sT1Qcx4CDxces86L","Process":"w2vTEjZKgcSvwpkkxkxqo","Error":"_2oCnYlNTzxnGZOMDPQGXDR","NameID":"_1MqDmw26oaHjheG8RgUpFg","CellMenu":"_2FIVSzImIJ4rzpo_Zv3T6D","MenuItem":"_2LNlYi3N4F8PwPaeDVCb6c","ActivateLink":"_3754AocMtjuO5TQZ0xR1HV","defaultLink":"_1s5pYcO9OERgXfcwqNDxQ8","Empty":"_1OaPuKu_2B2Te3qblAiCgk","EmptyRow":"_2v334CayBegkiq_OsRrZlT"};

/***/ },
/* 105 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1rDzrA8AWEOym8hadk9BA2","Table":"rNzFuNmS5x_HqiM1RJ_Rv","ToggleCell":"ZeLiDBpJvVnsDat-r-d8-","Empty":"_1XXqP6xliICOkTMQ8vDCLb","EmptyRow":"_2PPDfxvafT-9oMTqdafAdG","Row":"_1D3dquo2xE5feEj9rloeKW","InnerRow":"_2TiihyeTt8ukSNjR3ZasQa","Status":"_2cOQU-BL808hAIJ-0nrPaV","Purchase":"_1daWdeTksOm3ygRZwNwEaE","Icon":"_39yzLZRq0Mfm9NWnT7wyVg","TabTable":"_3IZY3FkTxOjEufGHXqodRG","TabIcon":"_3ZJW8_20lQUieHsXUduKpw"};

/***/ },
/* 106 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"Vd_MI8ZH0OMhgt9R6H2hj","Row":"_2UWDkjt2BOhBikxkFF4YKu","Link":"HGOL1LcW0RL4HSELyzXO","Enables":"_3zIxDYCez7by24gnOm8tLW","Disabled":"_2zYUuWI4848eWMKO-l5Sa5","Process":"_22Bf_DJwbyEVw1Lnp0yhcW","Error":"_3cyvLqT6QAbzMGum3I48vI","NameID":"_3ayd-VLPb4cneWJu7CB7sA","CellMenu":"d-yGORZftwXIXUho3fa7m","MenuItem":"_3YpNDsB-WNhb4JdrSec7I5","ActivateLink":"qIrmT1T5-2h3XvW4iksJK","defaultLink":"AoTRqEKr8ylEDkDZW02yg","Empty":"_3xK-t6P2DzgJx0mPrusgFZ","EmptyRow":"_38glllH66-s6xxoFmlL_Rw"};

/***/ },
/* 107 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"_3I37QlH4IBVqxShvzODUUJ","Row":"_1uQyM3Zw0nCMSDQJcmTZs-","Link":"_3Y5Q6rOD1wHJsyUsSC8bm9","Enables":"_d_6fVQsA4D430R6WZ2ZC","Disabled":"E1Sfyf0N3CRdHjlbm2sTm","Process":"_16xgihb7HBIvA_qq6K23zX","Error":"_38TZWpp2brPb8_tc97KGKx","NameID":"_1rw7TUdCvV9vdiPqKd8Wh3","CellMenu":"_1K_1JEppfMph5AYVBjBRjJ","MenuItem":"_2zFD-NlkHKYhga6fvlvuPu","ActivateLink":"_1iJGs8itRCaXwk5_mouzoQ","defaultLink":"_983A-_hMjha5TAkzmziQm","Empty":"_1s3BEIUunNC3UAHhicTi4V","EmptyRow":"_4xcPTw3_wsiu1_BUCW-TY","MobileList":"_3F_Wir-w8k5gKvp5q-o1C","MobileCard":"d9LKPwhz0FXfpC3_G8Dha","MobileCardHeader":"_3FRDxyBfxaqOpb66bFM6KB","MobileCardTitle":"_2DW8XA0CWvwbllRc66uFfY","MobileEan":"_3aWZJQT01PNz4zOshKghm-","MobileStatus":"_3iMPqW91_Sk7ike8dMyIOg","MobileFields":"GuVKl3rPivCO_o9cRVMqf","MobileField":"_13z8m6MbTVVEZRMHOFBGrz","MobileLabel":"_2xrfIPlRKdVdtNacJvDfbB","MobileValue":"_3G8skrxAt2fO0tFY7CBDlK","MobileActions":"_1gxnzMSaIMBNHgVBJlqlJ8","MobileDetailsLink":"_3DsO1shiByv1q70fp0FyFZ","MobileActivateLink":"_3nAq_GzUAfCbISPrZcfCdN","MobileEmpty":"_1LfxBi-6p_xkMSJ8NwMmss"};

/***/ },
/* 108 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3twLev6ojT3k02HtCImiJf","Header":"eIM2Rbjx7c54nfELyDT0G","Project":"_34-ru_85DgJ5gB5a_SqsKr","Controls":"Nm7KXTU8yFrLPdz5q6Z4t","ProjectInfo":"_2yc3Jx_qlhbZMgWe5spHlZ","FavoriteIcon":"CuWuBcyKmy_f1yQNc6XQn","Link":"_1ARChG7Ta2aVJv5YYcgBf7","Enables":"_2-aK8Ajo0ms1-9GkyEjdj2","Disabled":"m9LZ-PQAsOXIyS6KUxBs","Footer":"_1GFRMfmWsATC27QQVi4dr6","SettingsIcon":"xl5oew2PUxz7-UgQWc8UD","Table":"_3makAYQVe5plc5qn0qGgGY","TableScroll":"NZJFr15RIf0Vsc20B3p3l","MobileList":"_2WbGtBIPOKK9dS7pyZxRso","CellLeft":"_29SeB_jnutkQHJY5sCzp-0","Empty":"_2eUl8-buIrOoZY-z1Nbz40","EmptyRow":"pDcLIgQioCX1WBCFgFRWQ","AmountCell":"_3YLNhHHCJTXRQpUXPBI-8O","MobileEmpty":"_2swGZx-xs7s_3MneBPHf6V"};

/***/ },
/* 109 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_23BAzwGZcCdPu2WvQ-Hf2W","Table":"_194k2hzYVxgHzyI3Gy4cFU","Empty":"_2tLXHh_GvfZlvz-pvPQGAo","EmptyRow":"_1yqudB_sRF-n6Gx3eUlnsR","Row":"_2L_5_FM4AlJJDbd9YFDQnb","InnerRow":"_18Iu53El8NxXq12mPrVs1x","Status":"_2r9pLehX_gdax_ZB-EWsUn","Purchase":"_3sSH6FK2LJb8Pg2eD_hKOo","Icon":"_1lyoHVKnU5LnYw_xW-u0aP","TabTable":"_32dcUP0rYBq12yw6zv6ZJ8","CardIcon":"_3SwCm-p4ePmkq4-ZI4me-5","RefundStatus":"_1-k-g1_wg9Wo7WT8C4-C75","LinkBtn":"TFUB5GnOVNDw1eWoWpzkZ","Bold":"_2FQZSvhuaXguR8k3mZ6yVD","StatusTable":"_6CAeELPHhlT5CnvKwiKEO","ModalText":"_3ZWAqWgesTjjHbkiVRwOjX","CancelWrap":"_3dT0sejZFlJB4wSzBQSMbX","jsonBlock":"uG13wy6QancDtRrNLZlE6","AmountEditRow":"GdJmnFiwNpbqzXrwtmhE4","AmountEditInput":"r-qlSpNFUWbxl_HZwc0wB"};

/***/ },
/* 110 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_25g_K59RItSahnswImtRAw","Nav":"_2gjWyLCKsL7yP9c87VVua3","Tab":"_2pggPXjIjJGFLmam3F5xBe","TabAmount":"_14eszfcUSNH-TJYklDUy4a","Content":"L1NKo9NTKyLk-B1jqQNUr"};

/***/ },
/* 111 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_1RYEtptZqK4QThb7s-tH1f","header":"_3G_ybZMqEk60OgREH9_UgA","brand":"R1Wx7n4y021LQA-4iNmpp","brandLogo":"MuKUYudKUk47XdWQun-v1","breadcrumb":"_1xCBsBPAVT4AhniCy2qMWE","container":"kBigVPlsBSJZxbhsVhXul","h1":"_1sxfBkACoVvfAxbiQtN7DU","h2":"_1VxPlQvbmvm7RkjQ81liDM","h3":"_3_2YVLjghUEbSjEsI3cCnU","h4":"_1B2ARun6oiWqh_1nSZilKp","lead":"_3HiCrgiaZvA4wBl34bFcNp","note":"_2ulLIt9k9ohnjBuLBGNuVp","smallNote":"_1EfVmSqzFgXDbqjPdcJmt4","hero":"_2b2-YtPSVNOBlS1Y4m37ay","apiV3Banner":"GpTBLuSTWK5iRvcudLRU3","apiV3Link":"_2FQVCDvbj29-vHRFEJxkEI","meta":"_2DyiTpxO1cXbi4QC_jr51","tabs":"_33RNnqJQobu4MHAwXlP2qY","tab":"_3u2qHx0BuT7pezX46533dG","tabActive":"_1u9js5a0RfY2_Y7hG08zyY","card":"_37LfVVoI531j7qavUVOatE","grid2":"_1zP7Wfphw5WEyGsiQcDtrX","ol":"_10H9btwHE_SbwPphnd5tes","form":"_2flM3Oc3z-0rKu-VyQB_le","formGrid":"_2yS205JwsGcWhG2n7z8mUs","field":"_1tARJrAyv8Gbz0NIMqj4LT","fieldHead":"_1Yriv15iOUERoN9-3hZBlG","fieldLabel":"_12ETP5eqBpwpr_kYJ5k3IX","req":"vrybreH4H_wMPMZGoMDEJ","fieldHint":"_1T34fKNQjguQd6txIqp_Mu","input":"_1LCNC0sXAFLqR07zTUTLMc","actions":"_1NXSlP-u9LUPmq7lRZNp-r","button":"_1pt8GsQtQf4Jtj4kLi_pbV","split":"_2_yL4VrT_ogtFVcXzp02Ci","code":"_22EjGUnlWuIQRk2SBD19L1","codeBar":"_2xCOdFk7dzOldH9-7hLGmF","codeLang":"_2eT5G0XLBBHaz0PgcP5dn4","copyBtn":"TSRQr1gBYtgM6iP5Ca1oN","kv":"_1_P0Hc4TWifdhsawzyhWfo","errorBox":"mIt6M_CSuXf6MnsniAVvb","link":"_1RsTp4z69FY2c5IT5MaseJ","kbd":"_2hvBL8g0t6bfHpnf6UPHHu","table":"yiLWOb8T2B3dWbYIhUM_d","footer":"_34kbH_RlQQov7YDwwLwQmZ","dot":"t7F8fPteYRtvLomxzq3sH"};

/***/ },
/* 112 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_301j095MxJVNUw8RCOH3sW","Column":"IDRyKdAvCDwqIxnhWxxq0","Title":"_3AmAGhITnezL8rM5ajH09L","Text":"_2StimX5gULCBxNFrVhxMXO","InputWrap":"qe6XhjtXQbrz7lXdGGLQV","InputHeader":"_2T8xlJoIkmDoXmCTAl96cr","Label":"emhWkBMKIxE7G4PjqQlS","InputLink":"_1IcE-GPbU6AGRXDCyoWoXg","LinkIcon":"_15PF9bEHE2SoTE6T-Cw1mu","Input":"OmSYXqYoCAxKxuGa5auY-","Btn":"_2K1i1YlCXaWIa6pK9RXtSS","SaveBtn":"_26rqHtEBaHbXtfWFqtTsbD","Footer":"_4QMWsjeG-MnW8GC6FXiaV","ModalText":"_2TpnVGxCwIO4IFgriwJfQQ","Confirm":"_3ecp2avZbZtlUd_Efrs6wh","BtnIcon":"_1ZXdsG_nD-0_robLS-h6Nu","Attention":"_3e9qs6lpfRvRpFC4kiRAWL","AttentionIcon":"jYTr0hk_5p8EyFlKHNZfr","Card":"Q9IY37s0xTzKqQforw9KA","CardHeader":"_38tPRf2JAJKu517SjtiV9Q","ModalInputWrap":"_1dbBZRMH4pFowC34wbIKYd","GAuthWrap":"_1FJVQ737k2RHwsd8crLCb7","WarningBanner":"_1S4LbKccu8Vk_fzalj8wSR","container-fluid":"_12fZG5bzWXKvScaIkc0fsm"};

/***/ },
/* 113 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"_3h3Il9uNLr5fbwO3sY7dE5","Content":"_2ZditHgRFZOC1a2dK983p0","UserContent":"_24Utn3qteGS9vBmDj9SJZk","PublicContent":"_2v5rjHUE8sZf28JRpbjiaZ","Container":"_1xsS7UDm5p6NfPXyPFifEr","Column":"_2qs3oPPV8cb1v7cTe8QAKQ"};

/***/ },
/* 114 */
29,
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = global || self, factory(global.json2csv = {}));
	}(this, function (exports) { 'use strict';
	
	  var domain;
	
	  // This constructor is used to store event handlers. Instantiating this is
	  // faster than explicitly calling `Object.create(null)` to get a "clean" empty
	  // object (tested with v8 v4.9).
	  function EventHandlers() {}
	  EventHandlers.prototype = Object.create(null);
	
	  function EventEmitter() {
	    EventEmitter.init.call(this);
	  }
	
	  // nodejs oddity
	  // require('events') === require('events').EventEmitter
	  EventEmitter.EventEmitter = EventEmitter;
	
	  EventEmitter.usingDomains = false;
	
	  EventEmitter.prototype.domain = undefined;
	  EventEmitter.prototype._events = undefined;
	  EventEmitter.prototype._maxListeners = undefined;
	
	  // By default EventEmitters will print a warning if more than 10 listeners are
	  // added to it. This is a useful default which helps finding memory leaks.
	  EventEmitter.defaultMaxListeners = 10;
	
	  EventEmitter.init = function() {
	    this.domain = null;
	    if (EventEmitter.usingDomains) {
	      // if there is an active domain, then attach to it.
	      if (domain.active && !(this instanceof domain.Domain)) ;
	    }
	
	    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
	      this._events = new EventHandlers();
	      this._eventsCount = 0;
	    }
	
	    this._maxListeners = this._maxListeners || undefined;
	  };
	
	  // Obviously not all Emitters should be limited to 10. This function allows
	  // that to be increased. Set to zero for unlimited.
	  EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	    if (typeof n !== 'number' || n < 0 || isNaN(n))
	      throw new TypeError('"n" argument must be a positive number');
	    this._maxListeners = n;
	    return this;
	  };
	
	  function $getMaxListeners(that) {
	    if (that._maxListeners === undefined)
	      return EventEmitter.defaultMaxListeners;
	    return that._maxListeners;
	  }
	
	  EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	    return $getMaxListeners(this);
	  };
	
	  // These standalone emit* functions are used to optimize calling of event
	  // handlers for fast cases because emit() itself often has a variable number of
	  // arguments and can be deoptimized because of that. These functions always have
	  // the same number of arguments and thus do not get deoptimized, so the code
	  // inside them can execute faster.
	  function emitNone(handler, isFn, self) {
	    if (isFn)
	      handler.call(self);
	    else {
	      var len = handler.length;
	      var listeners = arrayClone(handler, len);
	      for (var i = 0; i < len; ++i)
	        listeners[i].call(self);
	    }
	  }
	  function emitOne(handler, isFn, self, arg1) {
	    if (isFn)
	      handler.call(self, arg1);
	    else {
	      var len = handler.length;
	      var listeners = arrayClone(handler, len);
	      for (var i = 0; i < len; ++i)
	        listeners[i].call(self, arg1);
	    }
	  }
	  function emitTwo(handler, isFn, self, arg1, arg2) {
	    if (isFn)
	      handler.call(self, arg1, arg2);
	    else {
	      var len = handler.length;
	      var listeners = arrayClone(handler, len);
	      for (var i = 0; i < len; ++i)
	        listeners[i].call(self, arg1, arg2);
	    }
	  }
	  function emitThree(handler, isFn, self, arg1, arg2, arg3) {
	    if (isFn)
	      handler.call(self, arg1, arg2, arg3);
	    else {
	      var len = handler.length;
	      var listeners = arrayClone(handler, len);
	      for (var i = 0; i < len; ++i)
	        listeners[i].call(self, arg1, arg2, arg3);
	    }
	  }
	
	  function emitMany(handler, isFn, self, args) {
	    if (isFn)
	      handler.apply(self, args);
	    else {
	      var len = handler.length;
	      var listeners = arrayClone(handler, len);
	      for (var i = 0; i < len; ++i)
	        listeners[i].apply(self, args);
	    }
	  }
	
	  EventEmitter.prototype.emit = function emit(type) {
	    var er, handler, len, args, i, events, domain;
	    var doError = (type === 'error');
	
	    events = this._events;
	    if (events)
	      doError = (doError && events.error == null);
	    else if (!doError)
	      return false;
	
	    domain = this.domain;
	
	    // If there is no 'error' event listener then throw.
	    if (doError) {
	      er = arguments[1];
	      if (domain) {
	        if (!er)
	          er = new Error('Uncaught, unspecified "error" event');
	        er.domainEmitter = this;
	        er.domain = domain;
	        er.domainThrown = false;
	        domain.emit('error', er);
	      } else if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	      return false;
	    }
	
	    handler = events[type];
	
	    if (!handler)
	      return false;
	
	    var isFn = typeof handler === 'function';
	    len = arguments.length;
	    switch (len) {
	      // fast cases
	      case 1:
	        emitNone(handler, isFn, this);
	        break;
	      case 2:
	        emitOne(handler, isFn, this, arguments[1]);
	        break;
	      case 3:
	        emitTwo(handler, isFn, this, arguments[1], arguments[2]);
	        break;
	      case 4:
	        emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
	        break;
	      // slower
	      default:
	        args = new Array(len - 1);
	        for (i = 1; i < len; i++)
	          args[i - 1] = arguments[i];
	        emitMany(handler, isFn, this, args);
	    }
	
	    return true;
	  };
	
	  function _addListener(target, type, listener, prepend) {
	    var m;
	    var events;
	    var existing;
	
	    if (typeof listener !== 'function')
	      throw new TypeError('"listener" argument must be a function');
	
	    events = target._events;
	    if (!events) {
	      events = target._events = new EventHandlers();
	      target._eventsCount = 0;
	    } else {
	      // To avoid recursion in the case that type === "newListener"! Before
	      // adding it to the listeners, first emit "newListener".
	      if (events.newListener) {
	        target.emit('newListener', type,
	                    listener.listener ? listener.listener : listener);
	
	        // Re-assign `events` because a newListener handler could have caused the
	        // this._events to be assigned to a new object
	        events = target._events;
	      }
	      existing = events[type];
	    }
	
	    if (!existing) {
	      // Optimize the case of one listener. Don't need the extra array object.
	      existing = events[type] = listener;
	      ++target._eventsCount;
	    } else {
	      if (typeof existing === 'function') {
	        // Adding the second element, need to change to array.
	        existing = events[type] = prepend ? [listener, existing] :
	                                            [existing, listener];
	      } else {
	        // If we've already got an array, just append.
	        if (prepend) {
	          existing.unshift(listener);
	        } else {
	          existing.push(listener);
	        }
	      }
	
	      // Check for listener leak
	      if (!existing.warned) {
	        m = $getMaxListeners(target);
	        if (m && m > 0 && existing.length > m) {
	          existing.warned = true;
	          var w = new Error('Possible EventEmitter memory leak detected. ' +
	                              existing.length + ' ' + type + ' listeners added. ' +
	                              'Use emitter.setMaxListeners() to increase limit');
	          w.name = 'MaxListenersExceededWarning';
	          w.emitter = target;
	          w.type = type;
	          w.count = existing.length;
	          emitWarning(w);
	        }
	      }
	    }
	
	    return target;
	  }
	  function emitWarning(e) {
	    typeof console.warn === 'function' ? console.warn(e) : console.log(e);
	  }
	  EventEmitter.prototype.addListener = function addListener(type, listener) {
	    return _addListener(this, type, listener, false);
	  };
	
	  EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	  EventEmitter.prototype.prependListener =
	      function prependListener(type, listener) {
	        return _addListener(this, type, listener, true);
	      };
	
	  function _onceWrap(target, type, listener) {
	    var fired = false;
	    function g() {
	      target.removeListener(type, g);
	      if (!fired) {
	        fired = true;
	        listener.apply(target, arguments);
	      }
	    }
	    g.listener = listener;
	    return g;
	  }
	
	  EventEmitter.prototype.once = function once(type, listener) {
	    if (typeof listener !== 'function')
	      throw new TypeError('"listener" argument must be a function');
	    this.on(type, _onceWrap(this, type, listener));
	    return this;
	  };
	
	  EventEmitter.prototype.prependOnceListener =
	      function prependOnceListener(type, listener) {
	        if (typeof listener !== 'function')
	          throw new TypeError('"listener" argument must be a function');
	        this.prependListener(type, _onceWrap(this, type, listener));
	        return this;
	      };
	
	  // emits a 'removeListener' event iff the listener was removed
	  EventEmitter.prototype.removeListener =
	      function removeListener(type, listener) {
	        var list, events, position, i, originalListener;
	
	        if (typeof listener !== 'function')
	          throw new TypeError('"listener" argument must be a function');
	
	        events = this._events;
	        if (!events)
	          return this;
	
	        list = events[type];
	        if (!list)
	          return this;
	
	        if (list === listener || (list.listener && list.listener === listener)) {
	          if (--this._eventsCount === 0)
	            this._events = new EventHandlers();
	          else {
	            delete events[type];
	            if (events.removeListener)
	              this.emit('removeListener', type, list.listener || listener);
	          }
	        } else if (typeof list !== 'function') {
	          position = -1;
	
	          for (i = list.length; i-- > 0;) {
	            if (list[i] === listener ||
	                (list[i].listener && list[i].listener === listener)) {
	              originalListener = list[i].listener;
	              position = i;
	              break;
	            }
	          }
	
	          if (position < 0)
	            return this;
	
	          if (list.length === 1) {
	            list[0] = undefined;
	            if (--this._eventsCount === 0) {
	              this._events = new EventHandlers();
	              return this;
	            } else {
	              delete events[type];
	            }
	          } else {
	            spliceOne(list, position);
	          }
	
	          if (events.removeListener)
	            this.emit('removeListener', type, originalListener || listener);
	        }
	
	        return this;
	      };
	
	  EventEmitter.prototype.removeAllListeners =
	      function removeAllListeners(type) {
	        var listeners, events;
	
	        events = this._events;
	        if (!events)
	          return this;
	
	        // not listening for removeListener, no need to emit
	        if (!events.removeListener) {
	          if (arguments.length === 0) {
	            this._events = new EventHandlers();
	            this._eventsCount = 0;
	          } else if (events[type]) {
	            if (--this._eventsCount === 0)
	              this._events = new EventHandlers();
	            else
	              delete events[type];
	          }
	          return this;
	        }
	
	        // emit removeListener for all listeners on all events
	        if (arguments.length === 0) {
	          var keys = Object.keys(events);
	          for (var i = 0, key; i < keys.length; ++i) {
	            key = keys[i];
	            if (key === 'removeListener') continue;
	            this.removeAllListeners(key);
	          }
	          this.removeAllListeners('removeListener');
	          this._events = new EventHandlers();
	          this._eventsCount = 0;
	          return this;
	        }
	
	        listeners = events[type];
	
	        if (typeof listeners === 'function') {
	          this.removeListener(type, listeners);
	        } else if (listeners) {
	          // LIFO order
	          do {
	            this.removeListener(type, listeners[listeners.length - 1]);
	          } while (listeners[0]);
	        }
	
	        return this;
	      };
	
	  EventEmitter.prototype.listeners = function listeners(type) {
	    var evlistener;
	    var ret;
	    var events = this._events;
	
	    if (!events)
	      ret = [];
	    else {
	      evlistener = events[type];
	      if (!evlistener)
	        ret = [];
	      else if (typeof evlistener === 'function')
	        ret = [evlistener.listener || evlistener];
	      else
	        ret = unwrapListeners(evlistener);
	    }
	
	    return ret;
	  };
	
	  EventEmitter.listenerCount = function(emitter, type) {
	    if (typeof emitter.listenerCount === 'function') {
	      return emitter.listenerCount(type);
	    } else {
	      return listenerCount.call(emitter, type);
	    }
	  };
	
	  EventEmitter.prototype.listenerCount = listenerCount;
	  function listenerCount(type) {
	    var events = this._events;
	
	    if (events) {
	      var evlistener = events[type];
	
	      if (typeof evlistener === 'function') {
	        return 1;
	      } else if (evlistener) {
	        return evlistener.length;
	      }
	    }
	
	    return 0;
	  }
	
	  EventEmitter.prototype.eventNames = function eventNames() {
	    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
	  };
	
	  // About 1.5x faster than the two-arg version of Array#splice().
	  function spliceOne(list, index) {
	    for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
	      list[i] = list[k];
	    list.pop();
	  }
	
	  function arrayClone(arr, i) {
	    var copy = new Array(i);
	    while (i--)
	      copy[i] = arr[i];
	    return copy;
	  }
	
	  function unwrapListeners(arr) {
	    var ret = new Array(arr.length);
	    for (var i = 0; i < ret.length; ++i) {
	      ret[i] = arr[i].listener || arr[i];
	    }
	    return ret;
	  }
	
	  var global$1 = (typeof global !== "undefined" ? global :
	              typeof self !== "undefined" ? self :
	              typeof window !== "undefined" ? window : {});
	
	  var lookup = [];
	  var revLookup = [];
	  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	  var inited = false;
	  function init () {
	    inited = true;
	    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    for (var i = 0, len = code.length; i < len; ++i) {
	      lookup[i] = code[i];
	      revLookup[code.charCodeAt(i)] = i;
	    }
	
	    revLookup['-'.charCodeAt(0)] = 62;
	    revLookup['_'.charCodeAt(0)] = 63;
	  }
	
	  function toByteArray (b64) {
	    if (!inited) {
	      init();
	    }
	    var i, j, l, tmp, placeHolders, arr;
	    var len = b64.length;
	
	    if (len % 4 > 0) {
	      throw new Error('Invalid string. Length must be a multiple of 4')
	    }
	
	    // the number of equal signs (place holders)
	    // if there are two placeholders, than the two characters before it
	    // represent one byte
	    // if there is only one, then the three characters before it represent 2 bytes
	    // this is just a cheap hack to not do indexOf twice
	    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
	
	    // base64 is 4/3 + up to two characters of the original data
	    arr = new Arr(len * 3 / 4 - placeHolders);
	
	    // if there are placeholders, only get up to the last complete 4 chars
	    l = placeHolders > 0 ? len - 4 : len;
	
	    var L = 0;
	
	    for (i = 0, j = 0; i < l; i += 4, j += 3) {
	      tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
	      arr[L++] = (tmp >> 16) & 0xFF;
	      arr[L++] = (tmp >> 8) & 0xFF;
	      arr[L++] = tmp & 0xFF;
	    }
	
	    if (placeHolders === 2) {
	      tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
	      arr[L++] = tmp & 0xFF;
	    } else if (placeHolders === 1) {
	      tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
	      arr[L++] = (tmp >> 8) & 0xFF;
	      arr[L++] = tmp & 0xFF;
	    }
	
	    return arr
	  }
	
	  function tripletToBase64 (num) {
	    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	  }
	
	  function encodeChunk (uint8, start, end) {
	    var tmp;
	    var output = [];
	    for (var i = start; i < end; i += 3) {
	      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
	      output.push(tripletToBase64(tmp));
	    }
	    return output.join('')
	  }
	
	  function fromByteArray (uint8) {
	    if (!inited) {
	      init();
	    }
	    var tmp;
	    var len = uint8.length;
	    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	    var output = '';
	    var parts = [];
	    var maxChunkLength = 16383; // must be multiple of 3
	
	    // go through the array every three bytes, we'll deal with trailing stuff later
	    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	      parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
	    }
	
	    // pad the end with zeros, but make sure to not forget the extra bytes
	    if (extraBytes === 1) {
	      tmp = uint8[len - 1];
	      output += lookup[tmp >> 2];
	      output += lookup[(tmp << 4) & 0x3F];
	      output += '==';
	    } else if (extraBytes === 2) {
	      tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
	      output += lookup[tmp >> 10];
	      output += lookup[(tmp >> 4) & 0x3F];
	      output += lookup[(tmp << 2) & 0x3F];
	      output += '=';
	    }
	
	    parts.push(output);
	
	    return parts.join('')
	  }
	
	  function read (buffer, offset, isLE, mLen, nBytes) {
	    var e, m;
	    var eLen = nBytes * 8 - mLen - 1;
	    var eMax = (1 << eLen) - 1;
	    var eBias = eMax >> 1;
	    var nBits = -7;
	    var i = isLE ? (nBytes - 1) : 0;
	    var d = isLE ? -1 : 1;
	    var s = buffer[offset + i];
	
	    i += d;
	
	    e = s & ((1 << (-nBits)) - 1);
	    s >>= (-nBits);
	    nBits += eLen;
	    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	    m = e & ((1 << (-nBits)) - 1);
	    e >>= (-nBits);
	    nBits += mLen;
	    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	    if (e === 0) {
	      e = 1 - eBias;
	    } else if (e === eMax) {
	      return m ? NaN : ((s ? -1 : 1) * Infinity)
	    } else {
	      m = m + Math.pow(2, mLen);
	      e = e - eBias;
	    }
	    return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	  }
	
	  function write (buffer, value, offset, isLE, mLen, nBytes) {
	    var e, m, c;
	    var eLen = nBytes * 8 - mLen - 1;
	    var eMax = (1 << eLen) - 1;
	    var eBias = eMax >> 1;
	    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
	    var i = isLE ? 0 : (nBytes - 1);
	    var d = isLE ? 1 : -1;
	    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
	
	    value = Math.abs(value);
	
	    if (isNaN(value) || value === Infinity) {
	      m = isNaN(value) ? 1 : 0;
	      e = eMax;
	    } else {
	      e = Math.floor(Math.log(value) / Math.LN2);
	      if (value * (c = Math.pow(2, -e)) < 1) {
	        e--;
	        c *= 2;
	      }
	      if (e + eBias >= 1) {
	        value += rt / c;
	      } else {
	        value += rt * Math.pow(2, 1 - eBias);
	      }
	      if (value * c >= 2) {
	        e++;
	        c /= 2;
	      }
	
	      if (e + eBias >= eMax) {
	        m = 0;
	        e = eMax;
	      } else if (e + eBias >= 1) {
	        m = (value * c - 1) * Math.pow(2, mLen);
	        e = e + eBias;
	      } else {
	        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	        e = 0;
	      }
	    }
	
	    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	    e = (e << mLen) | m;
	    eLen += mLen;
	    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	    buffer[offset + i - d] |= s * 128;
	  }
	
	  var toString = {}.toString;
	
	  var isArray = Array.isArray || function (arr) {
	    return toString.call(arr) == '[object Array]';
	  };
	
	  var INSPECT_MAX_BYTES = 50;
	
	  /**
	   * If `Buffer.TYPED_ARRAY_SUPPORT`:
	   *   === true    Use Uint8Array implementation (fastest)
	   *   === false   Use Object implementation (most compatible, even IE6)
	   *
	   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	   * Opera 11.6+, iOS 4.2+.
	   *
	   * Due to various browser bugs, sometimes the Object implementation will be used even
	   * when the browser supports typed arrays.
	   *
	   * Note:
	   *
	   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	   *
	   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	   *
	   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	   *     incorrect length in some situations.
	
	   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	   * get the Object implementation, which is slower but behaves correctly.
	   */
	  Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
	    ? global$1.TYPED_ARRAY_SUPPORT
	    : true;
	
	  function kMaxLength () {
	    return Buffer.TYPED_ARRAY_SUPPORT
	      ? 0x7fffffff
	      : 0x3fffffff
	  }
	
	  function createBuffer (that, length) {
	    if (kMaxLength() < length) {
	      throw new RangeError('Invalid typed array length')
	    }
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      // Return an augmented `Uint8Array` instance, for best performance
	      that = new Uint8Array(length);
	      that.__proto__ = Buffer.prototype;
	    } else {
	      // Fallback: Return an object instance of the Buffer class
	      if (that === null) {
	        that = new Buffer(length);
	      }
	      that.length = length;
	    }
	
	    return that
	  }
	
	  /**
	   * The Buffer constructor returns instances of `Uint8Array` that have their
	   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	   * returns a single octet.
	   *
	   * The `Uint8Array` prototype remains unmodified.
	   */
	
	  function Buffer (arg, encodingOrOffset, length) {
	    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	      return new Buffer(arg, encodingOrOffset, length)
	    }
	
	    // Common case.
	    if (typeof arg === 'number') {
	      if (typeof encodingOrOffset === 'string') {
	        throw new Error(
	          'If encoding is specified then the first argument must be a string'
	        )
	      }
	      return allocUnsafe(this, arg)
	    }
	    return from(this, arg, encodingOrOffset, length)
	  }
	
	  Buffer.poolSize = 8192; // not used by this implementation
	
	  // TODO: Legacy, not needed anymore. Remove in next major version.
	  Buffer._augment = function (arr) {
	    arr.__proto__ = Buffer.prototype;
	    return arr
	  };
	
	  function from (that, value, encodingOrOffset, length) {
	    if (typeof value === 'number') {
	      throw new TypeError('"value" argument must not be a number')
	    }
	
	    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, value, encodingOrOffset, length)
	    }
	
	    if (typeof value === 'string') {
	      return fromString(that, value, encodingOrOffset)
	    }
	
	    return fromObject(that, value)
	  }
	
	  /**
	   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	   * if value is a number.
	   * Buffer.from(str[, encoding])
	   * Buffer.from(array)
	   * Buffer.from(buffer)
	   * Buffer.from(arrayBuffer[, byteOffset[, length]])
	   **/
	  Buffer.from = function (value, encodingOrOffset, length) {
	    return from(null, value, encodingOrOffset, length)
	  };
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    Buffer.prototype.__proto__ = Uint8Array.prototype;
	    Buffer.__proto__ = Uint8Array;
	  }
	
	  function assertSize (size) {
	    if (typeof size !== 'number') {
	      throw new TypeError('"size" argument must be a number')
	    } else if (size < 0) {
	      throw new RangeError('"size" argument must not be negative')
	    }
	  }
	
	  function alloc (that, size, fill, encoding) {
	    assertSize(size);
	    if (size <= 0) {
	      return createBuffer(that, size)
	    }
	    if (fill !== undefined) {
	      // Only pay attention to encoding if it's a string. This
	      // prevents accidentally sending in a number that would
	      // be interpretted as a start offset.
	      return typeof encoding === 'string'
	        ? createBuffer(that, size).fill(fill, encoding)
	        : createBuffer(that, size).fill(fill)
	    }
	    return createBuffer(that, size)
	  }
	
	  /**
	   * Creates a new filled Buffer instance.
	   * alloc(size[, fill[, encoding]])
	   **/
	  Buffer.alloc = function (size, fill, encoding) {
	    return alloc(null, size, fill, encoding)
	  };
	
	  function allocUnsafe (that, size) {
	    assertSize(size);
	    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
	    if (!Buffer.TYPED_ARRAY_SUPPORT) {
	      for (var i = 0; i < size; ++i) {
	        that[i] = 0;
	      }
	    }
	    return that
	  }
	
	  /**
	   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	   * */
	  Buffer.allocUnsafe = function (size) {
	    return allocUnsafe(null, size)
	  };
	  /**
	   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	   */
	  Buffer.allocUnsafeSlow = function (size) {
	    return allocUnsafe(null, size)
	  };
	
	  function fromString (that, string, encoding) {
	    if (typeof encoding !== 'string' || encoding === '') {
	      encoding = 'utf8';
	    }
	
	    if (!Buffer.isEncoding(encoding)) {
	      throw new TypeError('"encoding" must be a valid string encoding')
	    }
	
	    var length = byteLength(string, encoding) | 0;
	    that = createBuffer(that, length);
	
	    var actual = that.write(string, encoding);
	
	    if (actual !== length) {
	      // Writing a hex string, for example, that contains invalid characters will
	      // cause everything after the first invalid character to be ignored. (e.g.
	      // 'abxxcd' will be treated as 'ab')
	      that = that.slice(0, actual);
	    }
	
	    return that
	  }
	
	  function fromArrayLike (that, array) {
	    var length = array.length < 0 ? 0 : checked(array.length) | 0;
	    that = createBuffer(that, length);
	    for (var i = 0; i < length; i += 1) {
	      that[i] = array[i] & 255;
	    }
	    return that
	  }
	
	  function fromArrayBuffer (that, array, byteOffset, length) {
	    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
	
	    if (byteOffset < 0 || array.byteLength < byteOffset) {
	      throw new RangeError('\'offset\' is out of bounds')
	    }
	
	    if (array.byteLength < byteOffset + (length || 0)) {
	      throw new RangeError('\'length\' is out of bounds')
	    }
	
	    if (byteOffset === undefined && length === undefined) {
	      array = new Uint8Array(array);
	    } else if (length === undefined) {
	      array = new Uint8Array(array, byteOffset);
	    } else {
	      array = new Uint8Array(array, byteOffset, length);
	    }
	
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      // Return an augmented `Uint8Array` instance, for best performance
	      that = array;
	      that.__proto__ = Buffer.prototype;
	    } else {
	      // Fallback: Return an object instance of the Buffer class
	      that = fromArrayLike(that, array);
	    }
	    return that
	  }
	
	  function fromObject (that, obj) {
	    if (internalIsBuffer(obj)) {
	      var len = checked(obj.length) | 0;
	      that = createBuffer(that, len);
	
	      if (that.length === 0) {
	        return that
	      }
	
	      obj.copy(that, 0, 0, len);
	      return that
	    }
	
	    if (obj) {
	      if ((typeof ArrayBuffer !== 'undefined' &&
	          obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	        if (typeof obj.length !== 'number' || isnan(obj.length)) {
	          return createBuffer(that, 0)
	        }
	        return fromArrayLike(that, obj)
	      }
	
	      if (obj.type === 'Buffer' && isArray(obj.data)) {
	        return fromArrayLike(that, obj.data)
	      }
	    }
	
	    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	  }
	
	  function checked (length) {
	    // Note: cannot use `length < kMaxLength()` here because that fails when
	    // length is NaN (which is otherwise coerced to zero.)
	    if (length >= kMaxLength()) {
	      throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                           'size: 0x' + kMaxLength().toString(16) + ' bytes')
	    }
	    return length | 0
	  }
	  Buffer.isBuffer = isBuffer;
	  function internalIsBuffer (b) {
	    return !!(b != null && b._isBuffer)
	  }
	
	  Buffer.compare = function compare (a, b) {
	    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
	      throw new TypeError('Arguments must be Buffers')
	    }
	
	    if (a === b) return 0
	
	    var x = a.length;
	    var y = b.length;
	
	    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	      if (a[i] !== b[i]) {
	        x = a[i];
	        y = b[i];
	        break
	      }
	    }
	
	    if (x < y) return -1
	    if (y < x) return 1
	    return 0
	  };
	
	  Buffer.isEncoding = function isEncoding (encoding) {
	    switch (String(encoding).toLowerCase()) {
	      case 'hex':
	      case 'utf8':
	      case 'utf-8':
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	      case 'base64':
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return true
	      default:
	        return false
	    }
	  };
	
	  Buffer.concat = function concat (list, length) {
	    if (!isArray(list)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	
	    if (list.length === 0) {
	      return Buffer.alloc(0)
	    }
	
	    var i;
	    if (length === undefined) {
	      length = 0;
	      for (i = 0; i < list.length; ++i) {
	        length += list[i].length;
	      }
	    }
	
	    var buffer = Buffer.allocUnsafe(length);
	    var pos = 0;
	    for (i = 0; i < list.length; ++i) {
	      var buf = list[i];
	      if (!internalIsBuffer(buf)) {
	        throw new TypeError('"list" argument must be an Array of Buffers')
	      }
	      buf.copy(buffer, pos);
	      pos += buf.length;
	    }
	    return buffer
	  };
	
	  function byteLength (string, encoding) {
	    if (internalIsBuffer(string)) {
	      return string.length
	    }
	    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	        (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	      return string.byteLength
	    }
	    if (typeof string !== 'string') {
	      string = '' + string;
	    }
	
	    var len = string.length;
	    if (len === 0) return 0
	
	    // Use a for loop to avoid recursion
	    var loweredCase = false;
	    for (;;) {
	      switch (encoding) {
	        case 'ascii':
	        case 'latin1':
	        case 'binary':
	          return len
	        case 'utf8':
	        case 'utf-8':
	        case undefined:
	          return utf8ToBytes(string).length
	        case 'ucs2':
	        case 'ucs-2':
	        case 'utf16le':
	        case 'utf-16le':
	          return len * 2
	        case 'hex':
	          return len >>> 1
	        case 'base64':
	          return base64ToBytes(string).length
	        default:
	          if (loweredCase) return utf8ToBytes(string).length // assume utf8
	          encoding = ('' + encoding).toLowerCase();
	          loweredCase = true;
	      }
	    }
	  }
	  Buffer.byteLength = byteLength;
	
	  function slowToString (encoding, start, end) {
	    var loweredCase = false;
	
	    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	    // property of a typed array.
	
	    // This behaves neither like String nor Uint8Array in that we set start/end
	    // to their upper/lower bounds if the value passed is out of range.
	    // undefined is handled specially as per ECMA-262 6th Edition,
	    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	    if (start === undefined || start < 0) {
	      start = 0;
	    }
	    // Return early if start > this.length. Done here to prevent potential uint32
	    // coercion fail below.
	    if (start > this.length) {
	      return ''
	    }
	
	    if (end === undefined || end > this.length) {
	      end = this.length;
	    }
	
	    if (end <= 0) {
	      return ''
	    }
	
	    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	    end >>>= 0;
	    start >>>= 0;
	
	    if (end <= start) {
	      return ''
	    }
	
	    if (!encoding) encoding = 'utf8';
	
	    while (true) {
	      switch (encoding) {
	        case 'hex':
	          return hexSlice(this, start, end)
	
	        case 'utf8':
	        case 'utf-8':
	          return utf8Slice(this, start, end)
	
	        case 'ascii':
	          return asciiSlice(this, start, end)
	
	        case 'latin1':
	        case 'binary':
	          return latin1Slice(this, start, end)
	
	        case 'base64':
	          return base64Slice(this, start, end)
	
	        case 'ucs2':
	        case 'ucs-2':
	        case 'utf16le':
	        case 'utf-16le':
	          return utf16leSlice(this, start, end)
	
	        default:
	          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	          encoding = (encoding + '').toLowerCase();
	          loweredCase = true;
	      }
	    }
	  }
	
	  // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	  // Buffer instances.
	  Buffer.prototype._isBuffer = true;
	
	  function swap (b, n, m) {
	    var i = b[n];
	    b[n] = b[m];
	    b[m] = i;
	  }
	
	  Buffer.prototype.swap16 = function swap16 () {
	    var len = this.length;
	    if (len % 2 !== 0) {
	      throw new RangeError('Buffer size must be a multiple of 16-bits')
	    }
	    for (var i = 0; i < len; i += 2) {
	      swap(this, i, i + 1);
	    }
	    return this
	  };
	
	  Buffer.prototype.swap32 = function swap32 () {
	    var len = this.length;
	    if (len % 4 !== 0) {
	      throw new RangeError('Buffer size must be a multiple of 32-bits')
	    }
	    for (var i = 0; i < len; i += 4) {
	      swap(this, i, i + 3);
	      swap(this, i + 1, i + 2);
	    }
	    return this
	  };
	
	  Buffer.prototype.swap64 = function swap64 () {
	    var len = this.length;
	    if (len % 8 !== 0) {
	      throw new RangeError('Buffer size must be a multiple of 64-bits')
	    }
	    for (var i = 0; i < len; i += 8) {
	      swap(this, i, i + 7);
	      swap(this, i + 1, i + 6);
	      swap(this, i + 2, i + 5);
	      swap(this, i + 3, i + 4);
	    }
	    return this
	  };
	
	  Buffer.prototype.toString = function toString () {
	    var length = this.length | 0;
	    if (length === 0) return ''
	    if (arguments.length === 0) return utf8Slice(this, 0, length)
	    return slowToString.apply(this, arguments)
	  };
	
	  Buffer.prototype.equals = function equals (b) {
	    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
	    if (this === b) return true
	    return Buffer.compare(this, b) === 0
	  };
	
	  Buffer.prototype.inspect = function inspect () {
	    var str = '';
	    var max = INSPECT_MAX_BYTES;
	    if (this.length > 0) {
	      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	      if (this.length > max) str += ' ... ';
	    }
	    return '<Buffer ' + str + '>'
	  };
	
	  Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	    if (!internalIsBuffer(target)) {
	      throw new TypeError('Argument must be a Buffer')
	    }
	
	    if (start === undefined) {
	      start = 0;
	    }
	    if (end === undefined) {
	      end = target ? target.length : 0;
	    }
	    if (thisStart === undefined) {
	      thisStart = 0;
	    }
	    if (thisEnd === undefined) {
	      thisEnd = this.length;
	    }
	
	    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	      throw new RangeError('out of range index')
	    }
	
	    if (thisStart >= thisEnd && start >= end) {
	      return 0
	    }
	    if (thisStart >= thisEnd) {
	      return -1
	    }
	    if (start >= end) {
	      return 1
	    }
	
	    start >>>= 0;
	    end >>>= 0;
	    thisStart >>>= 0;
	    thisEnd >>>= 0;
	
	    if (this === target) return 0
	
	    var x = thisEnd - thisStart;
	    var y = end - start;
	    var len = Math.min(x, y);
	
	    var thisCopy = this.slice(thisStart, thisEnd);
	    var targetCopy = target.slice(start, end);
	
	    for (var i = 0; i < len; ++i) {
	      if (thisCopy[i] !== targetCopy[i]) {
	        x = thisCopy[i];
	        y = targetCopy[i];
	        break
	      }
	    }
	
	    if (x < y) return -1
	    if (y < x) return 1
	    return 0
	  };
	
	  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	  //
	  // Arguments:
	  // - buffer - a Buffer to search
	  // - val - a string, Buffer, or number
	  // - byteOffset - an index into `buffer`; will be clamped to an int32
	  // - encoding - an optional encoding, relevant is val is a string
	  // - dir - true for indexOf, false for lastIndexOf
	  function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	    // Empty buffer means no match
	    if (buffer.length === 0) return -1
	
	    // Normalize byteOffset
	    if (typeof byteOffset === 'string') {
	      encoding = byteOffset;
	      byteOffset = 0;
	    } else if (byteOffset > 0x7fffffff) {
	      byteOffset = 0x7fffffff;
	    } else if (byteOffset < -0x80000000) {
	      byteOffset = -0x80000000;
	    }
	    byteOffset = +byteOffset;  // Coerce to Number.
	    if (isNaN(byteOffset)) {
	      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	      byteOffset = dir ? 0 : (buffer.length - 1);
	    }
	
	    // Normalize byteOffset: negative offsets start from the end of the buffer
	    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	    if (byteOffset >= buffer.length) {
	      if (dir) return -1
	      else byteOffset = buffer.length - 1;
	    } else if (byteOffset < 0) {
	      if (dir) byteOffset = 0;
	      else return -1
	    }
	
	    // Normalize val
	    if (typeof val === 'string') {
	      val = Buffer.from(val, encoding);
	    }
	
	    // Finally, search either indexOf (if dir is true) or lastIndexOf
	    if (internalIsBuffer(val)) {
	      // Special case: looking for empty string/buffer always fails
	      if (val.length === 0) {
	        return -1
	      }
	      return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	    } else if (typeof val === 'number') {
	      val = val & 0xFF; // Search for a byte value [0-255]
	      if (Buffer.TYPED_ARRAY_SUPPORT &&
	          typeof Uint8Array.prototype.indexOf === 'function') {
	        if (dir) {
	          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	        } else {
	          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	        }
	      }
	      return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	    }
	
	    throw new TypeError('val must be string, number or Buffer')
	  }
	
	  function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	    var indexSize = 1;
	    var arrLength = arr.length;
	    var valLength = val.length;
	
	    if (encoding !== undefined) {
	      encoding = String(encoding).toLowerCase();
	      if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	          encoding === 'utf16le' || encoding === 'utf-16le') {
	        if (arr.length < 2 || val.length < 2) {
	          return -1
	        }
	        indexSize = 2;
	        arrLength /= 2;
	        valLength /= 2;
	        byteOffset /= 2;
	      }
	    }
	
	    function read (buf, i) {
	      if (indexSize === 1) {
	        return buf[i]
	      } else {
	        return buf.readUInt16BE(i * indexSize)
	      }
	    }
	
	    var i;
	    if (dir) {
	      var foundIndex = -1;
	      for (i = byteOffset; i < arrLength; i++) {
	        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	          if (foundIndex === -1) foundIndex = i;
	          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	        } else {
	          if (foundIndex !== -1) i -= i - foundIndex;
	          foundIndex = -1;
	        }
	      }
	    } else {
	      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	      for (i = byteOffset; i >= 0; i--) {
	        var found = true;
	        for (var j = 0; j < valLength; j++) {
	          if (read(arr, i + j) !== read(val, j)) {
	            found = false;
	            break
	          }
	        }
	        if (found) return i
	      }
	    }
	
	    return -1
	  }
	
	  Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	    return this.indexOf(val, byteOffset, encoding) !== -1
	  };
	
	  Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	    return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	  };
	
	  Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	    return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	  };
	
	  function hexWrite (buf, string, offset, length) {
	    offset = Number(offset) || 0;
	    var remaining = buf.length - offset;
	    if (!length) {
	      length = remaining;
	    } else {
	      length = Number(length);
	      if (length > remaining) {
	        length = remaining;
	      }
	    }
	
	    // must be an even number of digits
	    var strLen = string.length;
	    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	    if (length > strLen / 2) {
	      length = strLen / 2;
	    }
	    for (var i = 0; i < length; ++i) {
	      var parsed = parseInt(string.substr(i * 2, 2), 16);
	      if (isNaN(parsed)) return i
	      buf[offset + i] = parsed;
	    }
	    return i
	  }
	
	  function utf8Write (buf, string, offset, length) {
	    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	  }
	
	  function asciiWrite (buf, string, offset, length) {
	    return blitBuffer(asciiToBytes(string), buf, offset, length)
	  }
	
	  function latin1Write (buf, string, offset, length) {
	    return asciiWrite(buf, string, offset, length)
	  }
	
	  function base64Write (buf, string, offset, length) {
	    return blitBuffer(base64ToBytes(string), buf, offset, length)
	  }
	
	  function ucs2Write (buf, string, offset, length) {
	    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	  }
	
	  Buffer.prototype.write = function write (string, offset, length, encoding) {
	    // Buffer#write(string)
	    if (offset === undefined) {
	      encoding = 'utf8';
	      length = this.length;
	      offset = 0;
	    // Buffer#write(string, encoding)
	    } else if (length === undefined && typeof offset === 'string') {
	      encoding = offset;
	      length = this.length;
	      offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	    } else if (isFinite(offset)) {
	      offset = offset | 0;
	      if (isFinite(length)) {
	        length = length | 0;
	        if (encoding === undefined) encoding = 'utf8';
	      } else {
	        encoding = length;
	        length = undefined;
	      }
	    // legacy write(string, encoding, offset, length) - remove in v0.13
	    } else {
	      throw new Error(
	        'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	      )
	    }
	
	    var remaining = this.length - offset;
	    if (length === undefined || length > remaining) length = remaining;
	
	    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	      throw new RangeError('Attempt to write outside buffer bounds')
	    }
	
	    if (!encoding) encoding = 'utf8';
	
	    var loweredCase = false;
	    for (;;) {
	      switch (encoding) {
	        case 'hex':
	          return hexWrite(this, string, offset, length)
	
	        case 'utf8':
	        case 'utf-8':
	          return utf8Write(this, string, offset, length)
	
	        case 'ascii':
	          return asciiWrite(this, string, offset, length)
	
	        case 'latin1':
	        case 'binary':
	          return latin1Write(this, string, offset, length)
	
	        case 'base64':
	          // Warning: maxLength not taken into account in base64Write
	          return base64Write(this, string, offset, length)
	
	        case 'ucs2':
	        case 'ucs-2':
	        case 'utf16le':
	        case 'utf-16le':
	          return ucs2Write(this, string, offset, length)
	
	        default:
	          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	          encoding = ('' + encoding).toLowerCase();
	          loweredCase = true;
	      }
	    }
	  };
	
	  Buffer.prototype.toJSON = function toJSON () {
	    return {
	      type: 'Buffer',
	      data: Array.prototype.slice.call(this._arr || this, 0)
	    }
	  };
	
	  function base64Slice (buf, start, end) {
	    if (start === 0 && end === buf.length) {
	      return fromByteArray(buf)
	    } else {
	      return fromByteArray(buf.slice(start, end))
	    }
	  }
	
	  function utf8Slice (buf, start, end) {
	    end = Math.min(buf.length, end);
	    var res = [];
	
	    var i = start;
	    while (i < end) {
	      var firstByte = buf[i];
	      var codePoint = null;
	      var bytesPerSequence = (firstByte > 0xEF) ? 4
	        : (firstByte > 0xDF) ? 3
	        : (firstByte > 0xBF) ? 2
	        : 1;
	
	      if (i + bytesPerSequence <= end) {
	        var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	        switch (bytesPerSequence) {
	          case 1:
	            if (firstByte < 0x80) {
	              codePoint = firstByte;
	            }
	            break
	          case 2:
	            secondByte = buf[i + 1];
	            if ((secondByte & 0xC0) === 0x80) {
	              tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
	              if (tempCodePoint > 0x7F) {
	                codePoint = tempCodePoint;
	              }
	            }
	            break
	          case 3:
	            secondByte = buf[i + 1];
	            thirdByte = buf[i + 2];
	            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
	              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	                codePoint = tempCodePoint;
	              }
	            }
	            break
	          case 4:
	            secondByte = buf[i + 1];
	            thirdByte = buf[i + 2];
	            fourthByte = buf[i + 3];
	            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
	              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	                codePoint = tempCodePoint;
	              }
	            }
	        }
	      }
	
	      if (codePoint === null) {
	        // we did not generate a valid codePoint so insert a
	        // replacement char (U+FFFD) and advance only 1 byte
	        codePoint = 0xFFFD;
	        bytesPerSequence = 1;
	      } else if (codePoint > 0xFFFF) {
	        // encode to utf16 (surrogate pair dance)
	        codePoint -= 0x10000;
	        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	        codePoint = 0xDC00 | codePoint & 0x3FF;
	      }
	
	      res.push(codePoint);
	      i += bytesPerSequence;
	    }
	
	    return decodeCodePointsArray(res)
	  }
	
	  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
	  // the lowest limit is Chrome, with 0x10000 args.
	  // We go 1 magnitude less, for safety
	  var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	  function decodeCodePointsArray (codePoints) {
	    var len = codePoints.length;
	    if (len <= MAX_ARGUMENTS_LENGTH) {
	      return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	    }
	
	    // Decode in chunks to avoid "call stack size exceeded".
	    var res = '';
	    var i = 0;
	    while (i < len) {
	      res += String.fromCharCode.apply(
	        String,
	        codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	      );
	    }
	    return res
	  }
	
	  function asciiSlice (buf, start, end) {
	    var ret = '';
	    end = Math.min(buf.length, end);
	
	    for (var i = start; i < end; ++i) {
	      ret += String.fromCharCode(buf[i] & 0x7F);
	    }
	    return ret
	  }
	
	  function latin1Slice (buf, start, end) {
	    var ret = '';
	    end = Math.min(buf.length, end);
	
	    for (var i = start; i < end; ++i) {
	      ret += String.fromCharCode(buf[i]);
	    }
	    return ret
	  }
	
	  function hexSlice (buf, start, end) {
	    var len = buf.length;
	
	    if (!start || start < 0) start = 0;
	    if (!end || end < 0 || end > len) end = len;
	
	    var out = '';
	    for (var i = start; i < end; ++i) {
	      out += toHex(buf[i]);
	    }
	    return out
	  }
	
	  function utf16leSlice (buf, start, end) {
	    var bytes = buf.slice(start, end);
	    var res = '';
	    for (var i = 0; i < bytes.length; i += 2) {
	      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	    }
	    return res
	  }
	
	  Buffer.prototype.slice = function slice (start, end) {
	    var len = this.length;
	    start = ~~start;
	    end = end === undefined ? len : ~~end;
	
	    if (start < 0) {
	      start += len;
	      if (start < 0) start = 0;
	    } else if (start > len) {
	      start = len;
	    }
	
	    if (end < 0) {
	      end += len;
	      if (end < 0) end = 0;
	    } else if (end > len) {
	      end = len;
	    }
	
	    if (end < start) end = start;
	
	    var newBuf;
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      newBuf = this.subarray(start, end);
	      newBuf.__proto__ = Buffer.prototype;
	    } else {
	      var sliceLen = end - start;
	      newBuf = new Buffer(sliceLen, undefined);
	      for (var i = 0; i < sliceLen; ++i) {
	        newBuf[i] = this[i + start];
	      }
	    }
	
	    return newBuf
	  };
	
	  /*
	   * Need to make sure that buffer isn't trying to write out of bounds.
	   */
	  function checkOffset (offset, ext, length) {
	    if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	  }
	
	  Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	    offset = offset | 0;
	    byteLength = byteLength | 0;
	    if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	    var val = this[offset];
	    var mul = 1;
	    var i = 0;
	    while (++i < byteLength && (mul *= 0x100)) {
	      val += this[offset + i] * mul;
	    }
	
	    return val
	  };
	
	  Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	    offset = offset | 0;
	    byteLength = byteLength | 0;
	    if (!noAssert) {
	      checkOffset(offset, byteLength, this.length);
	    }
	
	    var val = this[offset + --byteLength];
	    var mul = 1;
	    while (byteLength > 0 && (mul *= 0x100)) {
	      val += this[offset + --byteLength] * mul;
	    }
	
	    return val
	  };
	
	  Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 1, this.length);
	    return this[offset]
	  };
	
	  Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 2, this.length);
	    return this[offset] | (this[offset + 1] << 8)
	  };
	
	  Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 2, this.length);
	    return (this[offset] << 8) | this[offset + 1]
	  };
	
	  Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 4, this.length);
	
	    return ((this[offset]) |
	        (this[offset + 1] << 8) |
	        (this[offset + 2] << 16)) +
	        (this[offset + 3] * 0x1000000)
	  };
	
	  Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 4, this.length);
	
	    return (this[offset] * 0x1000000) +
	      ((this[offset + 1] << 16) |
	      (this[offset + 2] << 8) |
	      this[offset + 3])
	  };
	
	  Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	    offset = offset | 0;
	    byteLength = byteLength | 0;
	    if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	    var val = this[offset];
	    var mul = 1;
	    var i = 0;
	    while (++i < byteLength && (mul *= 0x100)) {
	      val += this[offset + i] * mul;
	    }
	    mul *= 0x80;
	
	    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	    return val
	  };
	
	  Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	    offset = offset | 0;
	    byteLength = byteLength | 0;
	    if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	    var i = byteLength;
	    var mul = 1;
	    var val = this[offset + --i];
	    while (i > 0 && (mul *= 0x100)) {
	      val += this[offset + --i] * mul;
	    }
	    mul *= 0x80;
	
	    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	    return val
	  };
	
	  Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 1, this.length);
	    if (!(this[offset] & 0x80)) return (this[offset])
	    return ((0xff - this[offset] + 1) * -1)
	  };
	
	  Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 2, this.length);
	    var val = this[offset] | (this[offset + 1] << 8);
	    return (val & 0x8000) ? val | 0xFFFF0000 : val
	  };
	
	  Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 2, this.length);
	    var val = this[offset + 1] | (this[offset] << 8);
	    return (val & 0x8000) ? val | 0xFFFF0000 : val
	  };
	
	  Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 4, this.length);
	
	    return (this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16) |
	      (this[offset + 3] << 24)
	  };
	
	  Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 4, this.length);
	
	    return (this[offset] << 24) |
	      (this[offset + 1] << 16) |
	      (this[offset + 2] << 8) |
	      (this[offset + 3])
	  };
	
	  Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 4, this.length);
	    return read(this, offset, true, 23, 4)
	  };
	
	  Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 4, this.length);
	    return read(this, offset, false, 23, 4)
	  };
	
	  Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 8, this.length);
	    return read(this, offset, true, 52, 8)
	  };
	
	  Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	    if (!noAssert) checkOffset(offset, 8, this.length);
	    return read(this, offset, false, 52, 8)
	  };
	
	  function checkInt (buf, value, offset, ext, max, min) {
	    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	    if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  }
	
	  Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    byteLength = byteLength | 0;
	    if (!noAssert) {
	      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	      checkInt(this, value, offset, byteLength, maxBytes, 0);
	    }
	
	    var mul = 1;
	    var i = 0;
	    this[offset] = value & 0xFF;
	    while (++i < byteLength && (mul *= 0x100)) {
	      this[offset + i] = (value / mul) & 0xFF;
	    }
	
	    return offset + byteLength
	  };
	
	  Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    byteLength = byteLength | 0;
	    if (!noAssert) {
	      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	      checkInt(this, value, offset, byteLength, maxBytes, 0);
	    }
	
	    var i = byteLength - 1;
	    var mul = 1;
	    this[offset + i] = value & 0xFF;
	    while (--i >= 0 && (mul *= 0x100)) {
	      this[offset + i] = (value / mul) & 0xFF;
	    }
	
	    return offset + byteLength
	  };
	
	  Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	    this[offset] = (value & 0xff);
	    return offset + 1
	  };
	
	  function objectWriteUInt16 (buf, value, offset, littleEndian) {
	    if (value < 0) value = 0xffff + value + 1;
	    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	      buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	        (littleEndian ? i : 1 - i) * 8;
	    }
	  }
	
	  Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset] = (value & 0xff);
	      this[offset + 1] = (value >>> 8);
	    } else {
	      objectWriteUInt16(this, value, offset, true);
	    }
	    return offset + 2
	  };
	
	  Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset] = (value >>> 8);
	      this[offset + 1] = (value & 0xff);
	    } else {
	      objectWriteUInt16(this, value, offset, false);
	    }
	    return offset + 2
	  };
	
	  function objectWriteUInt32 (buf, value, offset, littleEndian) {
	    if (value < 0) value = 0xffffffff + value + 1;
	    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	      buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
	    }
	  }
	
	  Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset + 3] = (value >>> 24);
	      this[offset + 2] = (value >>> 16);
	      this[offset + 1] = (value >>> 8);
	      this[offset] = (value & 0xff);
	    } else {
	      objectWriteUInt32(this, value, offset, true);
	    }
	    return offset + 4
	  };
	
	  Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset] = (value >>> 24);
	      this[offset + 1] = (value >>> 16);
	      this[offset + 2] = (value >>> 8);
	      this[offset + 3] = (value & 0xff);
	    } else {
	      objectWriteUInt32(this, value, offset, false);
	    }
	    return offset + 4
	  };
	
	  Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) {
	      var limit = Math.pow(2, 8 * byteLength - 1);
	
	      checkInt(this, value, offset, byteLength, limit - 1, -limit);
	    }
	
	    var i = 0;
	    var mul = 1;
	    var sub = 0;
	    this[offset] = value & 0xFF;
	    while (++i < byteLength && (mul *= 0x100)) {
	      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	        sub = 1;
	      }
	      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
	    }
	
	    return offset + byteLength
	  };
	
	  Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) {
	      var limit = Math.pow(2, 8 * byteLength - 1);
	
	      checkInt(this, value, offset, byteLength, limit - 1, -limit);
	    }
	
	    var i = byteLength - 1;
	    var mul = 1;
	    var sub = 0;
	    this[offset + i] = value & 0xFF;
	    while (--i >= 0 && (mul *= 0x100)) {
	      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	        sub = 1;
	      }
	      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
	    }
	
	    return offset + byteLength
	  };
	
	  Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	    if (value < 0) value = 0xff + value + 1;
	    this[offset] = (value & 0xff);
	    return offset + 1
	  };
	
	  Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset] = (value & 0xff);
	      this[offset + 1] = (value >>> 8);
	    } else {
	      objectWriteUInt16(this, value, offset, true);
	    }
	    return offset + 2
	  };
	
	  Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset] = (value >>> 8);
	      this[offset + 1] = (value & 0xff);
	    } else {
	      objectWriteUInt16(this, value, offset, false);
	    }
	    return offset + 2
	  };
	
	  Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset] = (value & 0xff);
	      this[offset + 1] = (value >>> 8);
	      this[offset + 2] = (value >>> 16);
	      this[offset + 3] = (value >>> 24);
	    } else {
	      objectWriteUInt32(this, value, offset, true);
	    }
	    return offset + 4
	  };
	
	  Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	    value = +value;
	    offset = offset | 0;
	    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	    if (value < 0) value = 0xffffffff + value + 1;
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      this[offset] = (value >>> 24);
	      this[offset + 1] = (value >>> 16);
	      this[offset + 2] = (value >>> 8);
	      this[offset + 3] = (value & 0xff);
	    } else {
	      objectWriteUInt32(this, value, offset, false);
	    }
	    return offset + 4
	  };
	
	  function checkIEEE754 (buf, value, offset, ext, max, min) {
	    if (offset + ext > buf.length) throw new RangeError('Index out of range')
	    if (offset < 0) throw new RangeError('Index out of range')
	  }
	
	  function writeFloat (buf, value, offset, littleEndian, noAssert) {
	    if (!noAssert) {
	      checkIEEE754(buf, value, offset, 4);
	    }
	    write(buf, value, offset, littleEndian, 23, 4);
	    return offset + 4
	  }
	
	  Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	    return writeFloat(this, value, offset, true, noAssert)
	  };
	
	  Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	    return writeFloat(this, value, offset, false, noAssert)
	  };
	
	  function writeDouble (buf, value, offset, littleEndian, noAssert) {
	    if (!noAssert) {
	      checkIEEE754(buf, value, offset, 8);
	    }
	    write(buf, value, offset, littleEndian, 52, 8);
	    return offset + 8
	  }
	
	  Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	    return writeDouble(this, value, offset, true, noAssert)
	  };
	
	  Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	    return writeDouble(this, value, offset, false, noAssert)
	  };
	
	  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	  Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	    if (!start) start = 0;
	    if (!end && end !== 0) end = this.length;
	    if (targetStart >= target.length) targetStart = target.length;
	    if (!targetStart) targetStart = 0;
	    if (end > 0 && end < start) end = start;
	
	    // Copy 0 bytes; we're done
	    if (end === start) return 0
	    if (target.length === 0 || this.length === 0) return 0
	
	    // Fatal error conditions
	    if (targetStart < 0) {
	      throw new RangeError('targetStart out of bounds')
	    }
	    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	    if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	    // Are we oob?
	    if (end > this.length) end = this.length;
	    if (target.length - targetStart < end - start) {
	      end = target.length - targetStart + start;
	    }
	
	    var len = end - start;
	    var i;
	
	    if (this === target && start < targetStart && targetStart < end) {
	      // descending copy from end
	      for (i = len - 1; i >= 0; --i) {
	        target[i + targetStart] = this[i + start];
	      }
	    } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	      // ascending copy from start
	      for (i = 0; i < len; ++i) {
	        target[i + targetStart] = this[i + start];
	      }
	    } else {
	      Uint8Array.prototype.set.call(
	        target,
	        this.subarray(start, start + len),
	        targetStart
	      );
	    }
	
	    return len
	  };
	
	  // Usage:
	  //    buffer.fill(number[, offset[, end]])
	  //    buffer.fill(buffer[, offset[, end]])
	  //    buffer.fill(string[, offset[, end]][, encoding])
	  Buffer.prototype.fill = function fill (val, start, end, encoding) {
	    // Handle string cases:
	    if (typeof val === 'string') {
	      if (typeof start === 'string') {
	        encoding = start;
	        start = 0;
	        end = this.length;
	      } else if (typeof end === 'string') {
	        encoding = end;
	        end = this.length;
	      }
	      if (val.length === 1) {
	        var code = val.charCodeAt(0);
	        if (code < 256) {
	          val = code;
	        }
	      }
	      if (encoding !== undefined && typeof encoding !== 'string') {
	        throw new TypeError('encoding must be a string')
	      }
	      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	        throw new TypeError('Unknown encoding: ' + encoding)
	      }
	    } else if (typeof val === 'number') {
	      val = val & 255;
	    }
	
	    // Invalid ranges are not set to a default, so can range check early.
	    if (start < 0 || this.length < start || this.length < end) {
	      throw new RangeError('Out of range index')
	    }
	
	    if (end <= start) {
	      return this
	    }
	
	    start = start >>> 0;
	    end = end === undefined ? this.length : end >>> 0;
	
	    if (!val) val = 0;
	
	    var i;
	    if (typeof val === 'number') {
	      for (i = start; i < end; ++i) {
	        this[i] = val;
	      }
	    } else {
	      var bytes = internalIsBuffer(val)
	        ? val
	        : utf8ToBytes(new Buffer(val, encoding).toString());
	      var len = bytes.length;
	      for (i = 0; i < end - start; ++i) {
	        this[i + start] = bytes[i % len];
	      }
	    }
	
	    return this
	  };
	
	  // HELPER FUNCTIONS
	  // ================
	
	  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
	  function base64clean (str) {
	    // Node strips out invalid characters like \n and \t from the string, base64-js does not
	    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	    // Node converts strings with length < 2 to ''
	    if (str.length < 2) return ''
	    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	    while (str.length % 4 !== 0) {
	      str = str + '=';
	    }
	    return str
	  }
	
	  function stringtrim (str) {
	    if (str.trim) return str.trim()
	    return str.replace(/^\s+|\s+$/g, '')
	  }
	
	  function toHex (n) {
	    if (n < 16) return '0' + n.toString(16)
	    return n.toString(16)
	  }
	
	  function utf8ToBytes (string, units) {
	    units = units || Infinity;
	    var codePoint;
	    var length = string.length;
	    var leadSurrogate = null;
	    var bytes = [];
	
	    for (var i = 0; i < length; ++i) {
	      codePoint = string.charCodeAt(i);
	
	      // is surrogate component
	      if (codePoint > 0xD7FF && codePoint < 0xE000) {
	        // last char was a lead
	        if (!leadSurrogate) {
	          // no lead yet
	          if (codePoint > 0xDBFF) {
	            // unexpected trail
	            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	            continue
	          } else if (i + 1 === length) {
	            // unpaired lead
	            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	            continue
	          }
	
	          // valid lead
	          leadSurrogate = codePoint;
	
	          continue
	        }
	
	        // 2 leads in a row
	        if (codePoint < 0xDC00) {
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          leadSurrogate = codePoint;
	          continue
	        }
	
	        // valid surrogate pair
	        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	      } else if (leadSurrogate) {
	        // valid bmp char, but last char was a lead
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	      }
	
	      leadSurrogate = null;
	
	      // encode utf8
	      if (codePoint < 0x80) {
	        if ((units -= 1) < 0) break
	        bytes.push(codePoint);
	      } else if (codePoint < 0x800) {
	        if ((units -= 2) < 0) break
	        bytes.push(
	          codePoint >> 0x6 | 0xC0,
	          codePoint & 0x3F | 0x80
	        );
	      } else if (codePoint < 0x10000) {
	        if ((units -= 3) < 0) break
	        bytes.push(
	          codePoint >> 0xC | 0xE0,
	          codePoint >> 0x6 & 0x3F | 0x80,
	          codePoint & 0x3F | 0x80
	        );
	      } else if (codePoint < 0x110000) {
	        if ((units -= 4) < 0) break
	        bytes.push(
	          codePoint >> 0x12 | 0xF0,
	          codePoint >> 0xC & 0x3F | 0x80,
	          codePoint >> 0x6 & 0x3F | 0x80,
	          codePoint & 0x3F | 0x80
	        );
	      } else {
	        throw new Error('Invalid code point')
	      }
	    }
	
	    return bytes
	  }
	
	  function asciiToBytes (str) {
	    var byteArray = [];
	    for (var i = 0; i < str.length; ++i) {
	      // Node's code seems to be doing this and not & 0x7F..
	      byteArray.push(str.charCodeAt(i) & 0xFF);
	    }
	    return byteArray
	  }
	
	  function utf16leToBytes (str, units) {
	    var c, hi, lo;
	    var byteArray = [];
	    for (var i = 0; i < str.length; ++i) {
	      if ((units -= 2) < 0) break
	
	      c = str.charCodeAt(i);
	      hi = c >> 8;
	      lo = c % 256;
	      byteArray.push(lo);
	      byteArray.push(hi);
	    }
	
	    return byteArray
	  }
	
	
	  function base64ToBytes (str) {
	    return toByteArray(base64clean(str))
	  }
	
	  function blitBuffer (src, dst, offset, length) {
	    for (var i = 0; i < length; ++i) {
	      if ((i + offset >= dst.length) || (i >= src.length)) break
	      dst[i + offset] = src[i];
	    }
	    return i
	  }
	
	  function isnan (val) {
	    return val !== val // eslint-disable-line no-self-compare
	  }
	
	
	  // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
	  // The _isBuffer check is for Safari 5-7 support, because it's missing
	  // Object.prototype.constructor. Remove this eventually
	  function isBuffer(obj) {
	    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
	  }
	
	  function isFastBuffer (obj) {
	    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	  }
	
	  // For Node v0.10 support. Remove this eventually.
	  function isSlowBuffer (obj) {
	    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
	  }
	
	  // shim for using process in browser
	  // based off https://github.com/defunctzombie/node-process/blob/master/browser.js
	
	  function defaultSetTimout() {
	      throw new Error('setTimeout has not been defined');
	  }
	  function defaultClearTimeout () {
	      throw new Error('clearTimeout has not been defined');
	  }
	  var cachedSetTimeout = defaultSetTimout;
	  var cachedClearTimeout = defaultClearTimeout;
	  if (typeof global$1.setTimeout === 'function') {
	      cachedSetTimeout = setTimeout;
	  }
	  if (typeof global$1.clearTimeout === 'function') {
	      cachedClearTimeout = clearTimeout;
	  }
	
	  function runTimeout(fun) {
	      if (cachedSetTimeout === setTimeout) {
	          //normal enviroments in sane situations
	          return setTimeout(fun, 0);
	      }
	      // if setTimeout wasn't available but was latter defined
	      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	          cachedSetTimeout = setTimeout;
	          return setTimeout(fun, 0);
	      }
	      try {
	          // when when somebody has screwed with setTimeout but no I.E. maddness
	          return cachedSetTimeout(fun, 0);
	      } catch(e){
	          try {
	              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	              return cachedSetTimeout.call(null, fun, 0);
	          } catch(e){
	              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	              return cachedSetTimeout.call(this, fun, 0);
	          }
	      }
	
	
	  }
	  function runClearTimeout(marker) {
	      if (cachedClearTimeout === clearTimeout) {
	          //normal enviroments in sane situations
	          return clearTimeout(marker);
	      }
	      // if clearTimeout wasn't available but was latter defined
	      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	          cachedClearTimeout = clearTimeout;
	          return clearTimeout(marker);
	      }
	      try {
	          // when when somebody has screwed with setTimeout but no I.E. maddness
	          return cachedClearTimeout(marker);
	      } catch (e){
	          try {
	              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	              return cachedClearTimeout.call(null, marker);
	          } catch (e){
	              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	              return cachedClearTimeout.call(this, marker);
	          }
	      }
	
	
	
	  }
	  var queue = [];
	  var draining = false;
	  var currentQueue;
	  var queueIndex = -1;
	
	  function cleanUpNextTick() {
	      if (!draining || !currentQueue) {
	          return;
	      }
	      draining = false;
	      if (currentQueue.length) {
	          queue = currentQueue.concat(queue);
	      } else {
	          queueIndex = -1;
	      }
	      if (queue.length) {
	          drainQueue();
	      }
	  }
	
	  function drainQueue() {
	      if (draining) {
	          return;
	      }
	      var timeout = runTimeout(cleanUpNextTick);
	      draining = true;
	
	      var len = queue.length;
	      while(len) {
	          currentQueue = queue;
	          queue = [];
	          while (++queueIndex < len) {
	              if (currentQueue) {
	                  currentQueue[queueIndex].run();
	              }
	          }
	          queueIndex = -1;
	          len = queue.length;
	      }
	      currentQueue = null;
	      draining = false;
	      runClearTimeout(timeout);
	  }
	  function nextTick(fun) {
	      var args = new Array(arguments.length - 1);
	      if (arguments.length > 1) {
	          for (var i = 1; i < arguments.length; i++) {
	              args[i - 1] = arguments[i];
	          }
	      }
	      queue.push(new Item(fun, args));
	      if (queue.length === 1 && !draining) {
	          runTimeout(drainQueue);
	      }
	  }
	  // v8 likes predictible objects
	  function Item(fun, array) {
	      this.fun = fun;
	      this.array = array;
	  }
	  Item.prototype.run = function () {
	      this.fun.apply(null, this.array);
	  };
	
	  // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
	  var performance = global$1.performance || {};
	  var performanceNow =
	    performance.now        ||
	    performance.mozNow     ||
	    performance.msNow      ||
	    performance.oNow       ||
	    performance.webkitNow  ||
	    function(){ return (new Date()).getTime() };
	
	  var inherits;
	  if (typeof Object.create === 'function'){
	    inherits = function inherits(ctor, superCtor) {
	      // implementation from standard node.js 'util' module
	      ctor.super_ = superCtor;
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	    };
	  } else {
	    inherits = function inherits(ctor, superCtor) {
	      ctor.super_ = superCtor;
	      var TempCtor = function () {};
	      TempCtor.prototype = superCtor.prototype;
	      ctor.prototype = new TempCtor();
	      ctor.prototype.constructor = ctor;
	    };
	  }
	  var inherits$1 = inherits;
	
	  var formatRegExp = /%[sdj%]/g;
	  function format(f) {
	    if (!isString(f)) {
	      var objects = [];
	      for (var i = 0; i < arguments.length; i++) {
	        objects.push(inspect(arguments[i]));
	      }
	      return objects.join(' ');
	    }
	
	    var i = 1;
	    var args = arguments;
	    var len = args.length;
	    var str = String(f).replace(formatRegExp, function(x) {
	      if (x === '%%') return '%';
	      if (i >= len) return x;
	      switch (x) {
	        case '%s': return String(args[i++]);
	        case '%d': return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	        default:
	          return x;
	      }
	    });
	    for (var x = args[i]; i < len; x = args[++i]) {
	      if (isNull(x) || !isObject(x)) {
	        str += ' ' + x;
	      } else {
	        str += ' ' + inspect(x);
	      }
	    }
	    return str;
	  }
	
	  // Mark that a method should not be used.
	  // Returns a modified function which warns once by default.
	  // If --no-deprecation is set, then it is a no-op.
	  function deprecate(fn, msg) {
	    // Allow for deprecating things in the process of starting up.
	    if (isUndefined(global$1.process)) {
	      return function() {
	        return deprecate(fn, msg).apply(this, arguments);
	      };
	    }
	
	    var warned = false;
	    function deprecated() {
	      if (!warned) {
	        {
	          console.error(msg);
	        }
	        warned = true;
	      }
	      return fn.apply(this, arguments);
	    }
	
	    return deprecated;
	  }
	
	  var debugs = {};
	  var debugEnviron;
	  function debuglog(set) {
	    if (isUndefined(debugEnviron))
	      debugEnviron =  '';
	    set = set.toUpperCase();
	    if (!debugs[set]) {
	      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	        var pid = 0;
	        debugs[set] = function() {
	          var msg = format.apply(null, arguments);
	          console.error('%s %d: %s', set, pid, msg);
	        };
	      } else {
	        debugs[set] = function() {};
	      }
	    }
	    return debugs[set];
	  }
	
	  /**
	   * Echos the value of a value. Trys to print the value out
	   * in the best way possible given the different types.
	   *
	   * @param {Object} obj The object to print out.
	   * @param {Object} opts Optional options object that alters the output.
	   */
	  /* legacy: obj, showHidden, depth, colors*/
	  function inspect(obj, opts) {
	    // default options
	    var ctx = {
	      seen: [],
	      stylize: stylizeNoColor
	    };
	    // legacy...
	    if (arguments.length >= 3) ctx.depth = arguments[2];
	    if (arguments.length >= 4) ctx.colors = arguments[3];
	    if (isBoolean(opts)) {
	      // legacy...
	      ctx.showHidden = opts;
	    } else if (opts) {
	      // got an "options" object
	      _extend(ctx, opts);
	    }
	    // set default options
	    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	    if (isUndefined(ctx.depth)) ctx.depth = 2;
	    if (isUndefined(ctx.colors)) ctx.colors = false;
	    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	    if (ctx.colors) ctx.stylize = stylizeWithColor;
	    return formatValue(ctx, obj, ctx.depth);
	  }
	
	  // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	  inspect.colors = {
	    'bold' : [1, 22],
	    'italic' : [3, 23],
	    'underline' : [4, 24],
	    'inverse' : [7, 27],
	    'white' : [37, 39],
	    'grey' : [90, 39],
	    'black' : [30, 39],
	    'blue' : [34, 39],
	    'cyan' : [36, 39],
	    'green' : [32, 39],
	    'magenta' : [35, 39],
	    'red' : [31, 39],
	    'yellow' : [33, 39]
	  };
	
	  // Don't use 'blue' not visible on cmd.exe
	  inspect.styles = {
	    'special': 'cyan',
	    'number': 'yellow',
	    'boolean': 'yellow',
	    'undefined': 'grey',
	    'null': 'bold',
	    'string': 'green',
	    'date': 'magenta',
	    // "name": intentionally not styling
	    'regexp': 'red'
	  };
	
	
	  function stylizeWithColor(str, styleType) {
	    var style = inspect.styles[styleType];
	
	    if (style) {
	      return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	             '\u001b[' + inspect.colors[style][1] + 'm';
	    } else {
	      return str;
	    }
	  }
	
	
	  function stylizeNoColor(str, styleType) {
	    return str;
	  }
	
	
	  function arrayToHash(array) {
	    var hash = {};
	
	    array.forEach(function(val, idx) {
	      hash[val] = true;
	    });
	
	    return hash;
	  }
	
	
	  function formatValue(ctx, value, recurseTimes) {
	    // Provide a hook for user-specified inspect functions.
	    // Check that value is an object with an inspect function on it
	    if (ctx.customInspect &&
	        value &&
	        isFunction(value.inspect) &&
	        // Filter out the util module, it's inspect function is special
	        value.inspect !== inspect &&
	        // Also filter out any prototype objects using the circular check.
	        !(value.constructor && value.constructor.prototype === value)) {
	      var ret = value.inspect(recurseTimes, ctx);
	      if (!isString(ret)) {
	        ret = formatValue(ctx, ret, recurseTimes);
	      }
	      return ret;
	    }
	
	    // Primitive types cannot have properties
	    var primitive = formatPrimitive(ctx, value);
	    if (primitive) {
	      return primitive;
	    }
	
	    // Look up the keys of the object.
	    var keys = Object.keys(value);
	    var visibleKeys = arrayToHash(keys);
	
	    if (ctx.showHidden) {
	      keys = Object.getOwnPropertyNames(value);
	    }
	
	    // IE doesn't make error fields non-enumerable
	    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	    if (isError(value)
	        && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	      return formatError(value);
	    }
	
	    // Some type of object without properties can be shortcutted.
	    if (keys.length === 0) {
	      if (isFunction(value)) {
	        var name = value.name ? ': ' + value.name : '';
	        return ctx.stylize('[Function' + name + ']', 'special');
	      }
	      if (isRegExp(value)) {
	        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	      }
	      if (isDate(value)) {
	        return ctx.stylize(Date.prototype.toString.call(value), 'date');
	      }
	      if (isError(value)) {
	        return formatError(value);
	      }
	    }
	
	    var base = '', array = false, braces = ['{', '}'];
	
	    // Make Array say that they are Array
	    if (isArray$1(value)) {
	      array = true;
	      braces = ['[', ']'];
	    }
	
	    // Make functions say that they are functions
	    if (isFunction(value)) {
	      var n = value.name ? ': ' + value.name : '';
	      base = ' [Function' + n + ']';
	    }
	
	    // Make RegExps say that they are RegExps
	    if (isRegExp(value)) {
	      base = ' ' + RegExp.prototype.toString.call(value);
	    }
	
	    // Make dates with properties first say the date
	    if (isDate(value)) {
	      base = ' ' + Date.prototype.toUTCString.call(value);
	    }
	
	    // Make error with message first say the error
	    if (isError(value)) {
	      base = ' ' + formatError(value);
	    }
	
	    if (keys.length === 0 && (!array || value.length == 0)) {
	      return braces[0] + base + braces[1];
	    }
	
	    if (recurseTimes < 0) {
	      if (isRegExp(value)) {
	        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	      } else {
	        return ctx.stylize('[Object]', 'special');
	      }
	    }
	
	    ctx.seen.push(value);
	
	    var output;
	    if (array) {
	      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	    } else {
	      output = keys.map(function(key) {
	        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	      });
	    }
	
	    ctx.seen.pop();
	
	    return reduceToSingleString(output, base, braces);
	  }
	
	
	  function formatPrimitive(ctx, value) {
	    if (isUndefined(value))
	      return ctx.stylize('undefined', 'undefined');
	    if (isString(value)) {
	      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                               .replace(/'/g, "\\'")
	                                               .replace(/\\"/g, '"') + '\'';
	      return ctx.stylize(simple, 'string');
	    }
	    if (isNumber(value))
	      return ctx.stylize('' + value, 'number');
	    if (isBoolean(value))
	      return ctx.stylize('' + value, 'boolean');
	    // For some reason typeof null is "object", so special case here.
	    if (isNull(value))
	      return ctx.stylize('null', 'null');
	  }
	
	
	  function formatError(value) {
	    return '[' + Error.prototype.toString.call(value) + ']';
	  }
	
	
	  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	    var output = [];
	    for (var i = 0, l = value.length; i < l; ++i) {
	      if (hasOwnProperty(value, String(i))) {
	        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	            String(i), true));
	      } else {
	        output.push('');
	      }
	    }
	    keys.forEach(function(key) {
	      if (!key.match(/^\d+$/)) {
	        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	            key, true));
	      }
	    });
	    return output;
	  }
	
	
	  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	    var name, str, desc;
	    desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	    if (desc.get) {
	      if (desc.set) {
	        str = ctx.stylize('[Getter/Setter]', 'special');
	      } else {
	        str = ctx.stylize('[Getter]', 'special');
	      }
	    } else {
	      if (desc.set) {
	        str = ctx.stylize('[Setter]', 'special');
	      }
	    }
	    if (!hasOwnProperty(visibleKeys, key)) {
	      name = '[' + key + ']';
	    }
	    if (!str) {
	      if (ctx.seen.indexOf(desc.value) < 0) {
	        if (isNull(recurseTimes)) {
	          str = formatValue(ctx, desc.value, null);
	        } else {
	          str = formatValue(ctx, desc.value, recurseTimes - 1);
	        }
	        if (str.indexOf('\n') > -1) {
	          if (array) {
	            str = str.split('\n').map(function(line) {
	              return '  ' + line;
	            }).join('\n').substr(2);
	          } else {
	            str = '\n' + str.split('\n').map(function(line) {
	              return '   ' + line;
	            }).join('\n');
	          }
	        }
	      } else {
	        str = ctx.stylize('[Circular]', 'special');
	      }
	    }
	    if (isUndefined(name)) {
	      if (array && key.match(/^\d+$/)) {
	        return str;
	      }
	      name = JSON.stringify('' + key);
	      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	        name = name.substr(1, name.length - 2);
	        name = ctx.stylize(name, 'name');
	      } else {
	        name = name.replace(/'/g, "\\'")
	                   .replace(/\\"/g, '"')
	                   .replace(/(^"|"$)/g, "'");
	        name = ctx.stylize(name, 'string');
	      }
	    }
	
	    return name + ': ' + str;
	  }
	
	
	  function reduceToSingleString(output, base, braces) {
	    var length = output.reduce(function(prev, cur) {
	      if (cur.indexOf('\n') >= 0) ;
	      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	    }, 0);
	
	    if (length > 60) {
	      return braces[0] +
	             (base === '' ? '' : base + '\n ') +
	             ' ' +
	             output.join(',\n  ') +
	             ' ' +
	             braces[1];
	    }
	
	    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	  }
	
	
	  // NOTE: These type checking functions intentionally don't use `instanceof`
	  // because it is fragile and can be easily faked with `Object.create()`.
	  function isArray$1(ar) {
	    return Array.isArray(ar);
	  }
	
	  function isBoolean(arg) {
	    return typeof arg === 'boolean';
	  }
	
	  function isNull(arg) {
	    return arg === null;
	  }
	
	  function isNumber(arg) {
	    return typeof arg === 'number';
	  }
	
	  function isString(arg) {
	    return typeof arg === 'string';
	  }
	
	  function isUndefined(arg) {
	    return arg === void 0;
	  }
	
	  function isRegExp(re) {
	    return isObject(re) && objectToString(re) === '[object RegExp]';
	  }
	
	  function isObject(arg) {
	    return typeof arg === 'object' && arg !== null;
	  }
	
	  function isDate(d) {
	    return isObject(d) && objectToString(d) === '[object Date]';
	  }
	
	  function isError(e) {
	    return isObject(e) &&
	        (objectToString(e) === '[object Error]' || e instanceof Error);
	  }
	
	  function isFunction(arg) {
	    return typeof arg === 'function';
	  }
	
	  function objectToString(o) {
	    return Object.prototype.toString.call(o);
	  }
	
	  function _extend(origin, add) {
	    // Don't do anything if add isn't an object
	    if (!add || !isObject(add)) return origin;
	
	    var keys = Object.keys(add);
	    var i = keys.length;
	    while (i--) {
	      origin[keys[i]] = add[keys[i]];
	    }
	    return origin;
	  }
	  function hasOwnProperty(obj, prop) {
	    return Object.prototype.hasOwnProperty.call(obj, prop);
	  }
	
	  function BufferList() {
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function (v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function (v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function () {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function () {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function (s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function (n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      p.data.copy(ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  // Copyright Joyent, Inc. and other Node contributors.
	  var isBufferEncoding = Buffer.isEncoding
	    || function(encoding) {
	         switch (encoding && encoding.toLowerCase()) {
	           case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	           default: return false;
	         }
	       };
	
	
	  function assertEncoding(encoding) {
	    if (encoding && !isBufferEncoding(encoding)) {
	      throw new Error('Unknown encoding: ' + encoding);
	    }
	  }
	
	  // StringDecoder provides an interface for efficiently splitting a series of
	  // buffers into a series of JS strings without breaking apart multi-byte
	  // characters. CESU-8 is handled as part of the UTF-8 encoding.
	  //
	  // @TODO Handling all encodings inside a single object makes it very difficult
	  // to reason about this code, so it should be split up in the future.
	  // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	  // points as used by CESU-8.
	  function StringDecoder(encoding) {
	    this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	    assertEncoding(encoding);
	    switch (this.encoding) {
	      case 'utf8':
	        // CESU-8 represents each of Surrogate Pair by 3-bytes
	        this.surrogateSize = 3;
	        break;
	      case 'ucs2':
	      case 'utf16le':
	        // UTF-16 represents each of Surrogate Pair by 2-bytes
	        this.surrogateSize = 2;
	        this.detectIncompleteChar = utf16DetectIncompleteChar;
	        break;
	      case 'base64':
	        // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	        this.surrogateSize = 3;
	        this.detectIncompleteChar = base64DetectIncompleteChar;
	        break;
	      default:
	        this.write = passThroughWrite;
	        return;
	    }
	
	    // Enough space to store all bytes of a single character. UTF-8 needs 4
	    // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	    this.charBuffer = new Buffer(6);
	    // Number of bytes received for the current incomplete multi-byte character.
	    this.charReceived = 0;
	    // Number of bytes expected for the current incomplete multi-byte character.
	    this.charLength = 0;
	  }
	
	  // write decodes the given buffer and returns it as JS string that is
	  // guaranteed to not contain any partial multi-byte characters. Any partial
	  // character found at the end of the buffer is buffered up, and will be
	  // returned when calling write again with the remaining bytes.
	  //
	  // Note: Converting a Buffer containing an orphan surrogate to a String
	  // currently works, but converting a String to a Buffer (via `new Buffer`, or
	  // Buffer#write) will replace incomplete surrogates with the unicode
	  // replacement character. See https://codereview.chromium.org/121173009/ .
	  StringDecoder.prototype.write = function(buffer) {
	    var charStr = '';
	    // if our last write ended with an incomplete multibyte character
	    while (this.charLength) {
	      // determine how many remaining bytes this buffer has to offer for this char
	      var available = (buffer.length >= this.charLength - this.charReceived) ?
	          this.charLength - this.charReceived :
	          buffer.length;
	
	      // add the new bytes to the char buffer
	      buffer.copy(this.charBuffer, this.charReceived, 0, available);
	      this.charReceived += available;
	
	      if (this.charReceived < this.charLength) {
	        // still not enough chars in this buffer? wait for more ...
	        return '';
	      }
	
	      // remove bytes belonging to the current character from the buffer
	      buffer = buffer.slice(available, buffer.length);
	
	      // get the character that was split
	      charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	      // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	      var charCode = charStr.charCodeAt(charStr.length - 1);
	      if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	        this.charLength += this.surrogateSize;
	        charStr = '';
	        continue;
	      }
	      this.charReceived = this.charLength = 0;
	
	      // if there are no more bytes in this buffer, just emit our char
	      if (buffer.length === 0) {
	        return charStr;
	      }
	      break;
	    }
	
	    // determine and set charLength / charReceived
	    this.detectIncompleteChar(buffer);
	
	    var end = buffer.length;
	    if (this.charLength) {
	      // buffer the incomplete character bytes we got
	      buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	      end -= this.charReceived;
	    }
	
	    charStr += buffer.toString(this.encoding, 0, end);
	
	    var end = charStr.length - 1;
	    var charCode = charStr.charCodeAt(end);
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      var size = this.surrogateSize;
	      this.charLength += size;
	      this.charReceived += size;
	      this.charBuffer.copy(this.charBuffer, size, 0, size);
	      buffer.copy(this.charBuffer, 0, 0, size);
	      return charStr.substring(0, end);
	    }
	
	    // or just emit the charStr
	    return charStr;
	  };
	
	  // detectIncompleteChar determines if there is an incomplete UTF-8 character at
	  // the end of the given buffer. If so, it sets this.charLength to the byte
	  // length that character, and sets this.charReceived to the number of bytes
	  // that are available for this character.
	  StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	    // determine how many bytes we have to check at the end of this buffer
	    var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	    // Figure out if one of the last i bytes of our buffer announces an
	    // incomplete char.
	    for (; i > 0; i--) {
	      var c = buffer[buffer.length - i];
	
	      // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	      // 110XXXXX
	      if (i == 1 && c >> 5 == 0x06) {
	        this.charLength = 2;
	        break;
	      }
	
	      // 1110XXXX
	      if (i <= 2 && c >> 4 == 0x0E) {
	        this.charLength = 3;
	        break;
	      }
	
	      // 11110XXX
	      if (i <= 3 && c >> 3 == 0x1E) {
	        this.charLength = 4;
	        break;
	      }
	    }
	    this.charReceived = i;
	  };
	
	  StringDecoder.prototype.end = function(buffer) {
	    var res = '';
	    if (buffer && buffer.length)
	      res = this.write(buffer);
	
	    if (this.charReceived) {
	      var cr = this.charReceived;
	      var buf = this.charBuffer;
	      var enc = this.encoding;
	      res += buf.slice(0, cr).toString(enc);
	    }
	
	    return res;
	  };
	
	  function passThroughWrite(buffer) {
	    return buffer.toString(this.encoding);
	  }
	
	  function utf16DetectIncompleteChar(buffer) {
	    this.charReceived = buffer.length % 2;
	    this.charLength = this.charReceived ? 2 : 0;
	  }
	
	  function base64DetectIncompleteChar(buffer) {
	    this.charReceived = buffer.length % 3;
	    this.charLength = this.charReceived ? 3 : 0;
	  }
	
	  Readable.ReadableState = ReadableState;
	
	  var debug = debuglog('stream');
	  inherits$1(Readable, EventEmitter);
	
	  function prependListener(emitter, event, fn) {
	    // Sadly this is not cacheable as some libraries bundle their own
	    // event emitter implementation with them.
	    if (typeof emitter.prependListener === 'function') {
	      return emitter.prependListener(event, fn);
	    } else {
	      // This is a hack to make sure that our error handler is attached before any
	      // userland ones.  NEVER DO THIS. This is here only because this code needs
	      // to continue to work with older versions of Node.js that do not include
	      // the prependListener() method. The goal is to eventually remove this hack.
	      if (!emitter._events || !emitter._events[event])
	        emitter.on(event, fn);
	      else if (Array.isArray(emitter._events[event]))
	        emitter._events[event].unshift(fn);
	      else
	        emitter._events[event] = [fn, emitter._events[event]];
	    }
	  }
	  function listenerCount$1 (emitter, type) {
	    return emitter.listeners(type).length;
	  }
	  function ReadableState(options, stream) {
	
	    options = options || {};
	
	    // object stream flag. Used to make read(n) ignore n and to
	    // make all the buffer merging and length checks go away
	    this.objectMode = !!options.objectMode;
	
	    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	    // the point at which it stops calling _read() to fill the buffer
	    // Note: 0 is a valid value, means "don't call _read preemptively ever"
	    var hwm = options.highWaterMark;
	    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	    // cast to ints.
	    this.highWaterMark = ~ ~this.highWaterMark;
	
	    // A linked list is used to store data chunks instead of an array because the
	    // linked list can remove elements from the beginning faster than
	    // array.shift()
	    this.buffer = new BufferList();
	    this.length = 0;
	    this.pipes = null;
	    this.pipesCount = 0;
	    this.flowing = null;
	    this.ended = false;
	    this.endEmitted = false;
	    this.reading = false;
	
	    // a flag to be able to tell if the onwrite cb is called immediately,
	    // or on a later tick.  We set this to true at first, because any
	    // actions that shouldn't happen until "later" should generally also
	    // not happen before the first write call.
	    this.sync = true;
	
	    // whenever we return null, then we set a flag to say
	    // that we're awaiting a 'readable' event emission.
	    this.needReadable = false;
	    this.emittedReadable = false;
	    this.readableListening = false;
	    this.resumeScheduled = false;
	
	    // Crypto is kind of old and crusty.  Historically, its default string
	    // encoding is 'binary' so we have to make this configurable.
	    // Everything else in the universe uses 'utf8', though.
	    this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	    // when piping, we only care about 'readable' events that happen
	    // after read()ing all the bytes and not getting any pushback.
	    this.ranOut = false;
	
	    // the number of writers that are awaiting a drain event in .pipe()s
	    this.awaitDrain = 0;
	
	    // if true, a maybeReadMore has been scheduled
	    this.readingMore = false;
	
	    this.decoder = null;
	    this.encoding = null;
	    if (options.encoding) {
	      this.decoder = new StringDecoder(options.encoding);
	      this.encoding = options.encoding;
	    }
	  }
	  function Readable(options) {
	
	    if (!(this instanceof Readable)) return new Readable(options);
	
	    this._readableState = new ReadableState(options, this);
	
	    // legacy
	    this.readable = true;
	
	    if (options && typeof options.read === 'function') this._read = options.read;
	
	    EventEmitter.call(this);
	  }
	
	  // Manually shove something into the read() buffer.
	  // This returns true if the highWaterMark has not been hit yet,
	  // similar to how Writable.write() returns true if you should
	  // write() some more.
	  Readable.prototype.push = function (chunk, encoding) {
	    var state = this._readableState;
	
	    if (!state.objectMode && typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	    }
	
	    return readableAddChunk(this, state, chunk, encoding, false);
	  };
	
	  // Unshift should *always* be something directly out of read()
	  Readable.prototype.unshift = function (chunk) {
	    var state = this._readableState;
	    return readableAddChunk(this, state, chunk, '', true);
	  };
	
	  Readable.prototype.isPaused = function () {
	    return this._readableState.flowing === false;
	  };
	
	  function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	    var er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (chunk === null) {
	      state.reading = false;
	      onEofChunk(stream, state);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (state.ended && !addToFront) {
	        var e = new Error('stream.push() after EOF');
	        stream.emit('error', e);
	      } else if (state.endEmitted && addToFront) {
	        var _e = new Error('stream.unshift() after end event');
	        stream.emit('error', _e);
	      } else {
	        var skipAdd;
	        if (state.decoder && !addToFront && !encoding) {
	          chunk = state.decoder.write(chunk);
	          skipAdd = !state.objectMode && chunk.length === 0;
	        }
	
	        if (!addToFront) state.reading = false;
	
	        // Don't add to the buffer if we've decoded to an empty string chunk and
	        // we're not in object mode
	        if (!skipAdd) {
	          // if we want the data now, just emit it.
	          if (state.flowing && state.length === 0 && !state.sync) {
	            stream.emit('data', chunk);
	            stream.read(0);
	          } else {
	            // update the buffer info.
	            state.length += state.objectMode ? 1 : chunk.length;
	            if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	            if (state.needReadable) emitReadable(stream);
	          }
	        }
	
	        maybeReadMore(stream, state);
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	
	    return needMoreData(state);
	  }
	
	  // if it's past the high water mark, we can push in some more.
	  // Also, if we have no data yet, we can stand some
	  // more bytes.  This is to work around cases where hwm=0,
	  // such as the repl.  Also, if the push() triggered a
	  // readable event, and the user called read(largeNumber) such that
	  // needReadable was set, then we ought to push more, so that another
	  // 'readable' event will be triggered.
	  function needMoreData(state) {
	    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	  }
	
	  // backwards compatibility.
	  Readable.prototype.setEncoding = function (enc) {
	    this._readableState.decoder = new StringDecoder(enc);
	    this._readableState.encoding = enc;
	    return this;
	  };
	
	  // Don't raise the hwm > 8MB
	  var MAX_HWM = 0x800000;
	  function computeNewHighWaterMark(n) {
	    if (n >= MAX_HWM) {
	      n = MAX_HWM;
	    } else {
	      // Get the next highest power of 2 to prevent increasing hwm excessively in
	      // tiny amounts
	      n--;
	      n |= n >>> 1;
	      n |= n >>> 2;
	      n |= n >>> 4;
	      n |= n >>> 8;
	      n |= n >>> 16;
	      n++;
	    }
	    return n;
	  }
	
	  // This function is designed to be inlinable, so please take care when making
	  // changes to the function body.
	  function howMuchToRead(n, state) {
	    if (n <= 0 || state.length === 0 && state.ended) return 0;
	    if (state.objectMode) return 1;
	    if (n !== n) {
	      // Only flow one buffer at a time
	      if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	    }
	    // If we're asking for more than the current hwm, then raise the hwm.
	    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	    if (n <= state.length) return n;
	    // Don't have enough
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    }
	    return state.length;
	  }
	
	  // you can override either this method, or the async _read(n) below.
	  Readable.prototype.read = function (n) {
	    debug('read', n);
	    n = parseInt(n, 10);
	    var state = this._readableState;
	    var nOrig = n;
	
	    if (n !== 0) state.emittedReadable = false;
	
	    // if we're doing read(0) to trigger a readable event, but we
	    // already have a bunch of data in the buffer, then just trigger
	    // the 'readable' event and move on.
	    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	      debug('read: emitReadable', state.length, state.ended);
	      if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	      return null;
	    }
	
	    n = howMuchToRead(n, state);
	
	    // if we've ended, and we're now clear, then finish it up.
	    if (n === 0 && state.ended) {
	      if (state.length === 0) endReadable(this);
	      return null;
	    }
	
	    // All the actual chunk generation logic needs to be
	    // *below* the call to _read.  The reason is that in certain
	    // synthetic stream cases, such as passthrough streams, _read
	    // may be a completely synchronous operation which may change
	    // the state of the read buffer, providing enough data when
	    // before there was *not* enough.
	    //
	    // So, the steps are:
	    // 1. Figure out what the state of things will be after we do
	    // a read from the buffer.
	    //
	    // 2. If that resulting state will trigger a _read, then call _read.
	    // Note that this may be asynchronous, or synchronous.  Yes, it is
	    // deeply ugly to write APIs this way, but that still doesn't mean
	    // that the Readable class should behave improperly, as streams are
	    // designed to be sync/async agnostic.
	    // Take note if the _read call is sync or async (ie, if the read call
	    // has returned yet), so that we know whether or not it's safe to emit
	    // 'readable' etc.
	    //
	    // 3. Actually pull the requested chunks out of the buffer and return.
	
	    // if we need a readable event, then we need to do some reading.
	    var doRead = state.needReadable;
	    debug('need readable', doRead);
	
	    // if we currently have less than the highWaterMark, then also read some
	    if (state.length === 0 || state.length - n < state.highWaterMark) {
	      doRead = true;
	      debug('length less than watermark', doRead);
	    }
	
	    // however, if we've ended, then there's no point, and if we're already
	    // reading, then it's unnecessary.
	    if (state.ended || state.reading) {
	      doRead = false;
	      debug('reading or ended', doRead);
	    } else if (doRead) {
	      debug('do read');
	      state.reading = true;
	      state.sync = true;
	      // if the length is currently zero, then we *need* a readable event.
	      if (state.length === 0) state.needReadable = true;
	      // call internal read method
	      this._read(state.highWaterMark);
	      state.sync = false;
	      // If _read pushed data synchronously, then `reading` will be false,
	      // and we need to re-evaluate how much data we can return to the user.
	      if (!state.reading) n = howMuchToRead(nOrig, state);
	    }
	
	    var ret;
	    if (n > 0) ret = fromList(n, state);else ret = null;
	
	    if (ret === null) {
	      state.needReadable = true;
	      n = 0;
	    } else {
	      state.length -= n;
	    }
	
	    if (state.length === 0) {
	      // If we have nothing in the buffer, then we want to know
	      // as soon as we *do* get something into the buffer.
	      if (!state.ended) state.needReadable = true;
	
	      // If we tried to read() past the EOF, then emit end on the next tick.
	      if (nOrig !== n && state.ended) endReadable(this);
	    }
	
	    if (ret !== null) this.emit('data', ret);
	
	    return ret;
	  };
	
	  function chunkInvalid(state, chunk) {
	    var er = null;
	    if (!isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	      er = new TypeError('Invalid non-string/buffer chunk');
	    }
	    return er;
	  }
	
	  function onEofChunk(stream, state) {
	    if (state.ended) return;
	    if (state.decoder) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) {
	        state.buffer.push(chunk);
	        state.length += state.objectMode ? 1 : chunk.length;
	      }
	    }
	    state.ended = true;
	
	    // emit 'readable' now to make sure it gets picked up.
	    emitReadable(stream);
	  }
	
	  // Don't emit readable right away in sync mode, because this can trigger
	  // another read() call => stack overflow.  This way, it might trigger
	  // a nextTick recursion warning, but that's not so bad.
	  function emitReadable(stream) {
	    var state = stream._readableState;
	    state.needReadable = false;
	    if (!state.emittedReadable) {
	      debug('emitReadable', state.flowing);
	      state.emittedReadable = true;
	      if (state.sync) nextTick(emitReadable_, stream);else emitReadable_(stream);
	    }
	  }
	
	  function emitReadable_(stream) {
	    debug('emit readable');
	    stream.emit('readable');
	    flow(stream);
	  }
	
	  // at this point, the user has presumably seen the 'readable' event,
	  // and called read() to consume some data.  that may have triggered
	  // in turn another _read(n) call, in which case reading = true if
	  // it's in progress.
	  // However, if we're not ended, or reading, and the length < hwm,
	  // then go ahead and try to read some more preemptively.
	  function maybeReadMore(stream, state) {
	    if (!state.readingMore) {
	      state.readingMore = true;
	      nextTick(maybeReadMore_, stream, state);
	    }
	  }
	
	  function maybeReadMore_(stream, state) {
	    var len = state.length;
	    while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	      debug('maybeReadMore read 0');
	      stream.read(0);
	      if (len === state.length)
	        // didn't get any data, stop spinning.
	        break;else len = state.length;
	    }
	    state.readingMore = false;
	  }
	
	  // abstract method.  to be overridden in specific implementation classes.
	  // call cb(er, data) where data is <= n in length.
	  // for virtual (non-string, non-buffer) streams, "length" is somewhat
	  // arbitrary, and perhaps not very meaningful.
	  Readable.prototype._read = function (n) {
	    this.emit('error', new Error('not implemented'));
	  };
	
	  Readable.prototype.pipe = function (dest, pipeOpts) {
	    var src = this;
	    var state = this._readableState;
	
	    switch (state.pipesCount) {
	      case 0:
	        state.pipes = dest;
	        break;
	      case 1:
	        state.pipes = [state.pipes, dest];
	        break;
	      default:
	        state.pipes.push(dest);
	        break;
	    }
	    state.pipesCount += 1;
	    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	    var doEnd = (!pipeOpts || pipeOpts.end !== false);
	
	    var endFn = doEnd ? onend : cleanup;
	    if (state.endEmitted) nextTick(endFn);else src.once('end', endFn);
	
	    dest.on('unpipe', onunpipe);
	    function onunpipe(readable) {
	      debug('onunpipe');
	      if (readable === src) {
	        cleanup();
	      }
	    }
	
	    function onend() {
	      debug('onend');
	      dest.end();
	    }
	
	    // when the dest drains, it reduces the awaitDrain counter
	    // on the source.  This would be more elegant with a .once()
	    // handler in flow(), but adding and removing repeatedly is
	    // too slow.
	    var ondrain = pipeOnDrain(src);
	    dest.on('drain', ondrain);
	
	    var cleanedUp = false;
	    function cleanup() {
	      debug('cleanup');
	      // cleanup event handlers once the pipe is broken
	      dest.removeListener('close', onclose);
	      dest.removeListener('finish', onfinish);
	      dest.removeListener('drain', ondrain);
	      dest.removeListener('error', onerror);
	      dest.removeListener('unpipe', onunpipe);
	      src.removeListener('end', onend);
	      src.removeListener('end', cleanup);
	      src.removeListener('data', ondata);
	
	      cleanedUp = true;
	
	      // if the reader is waiting for a drain event from this
	      // specific writer, then it would cause it to never start
	      // flowing again.
	      // So, if this is awaiting a drain, then we just call it now.
	      // If we don't know, then assume that we are waiting for one.
	      if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	    }
	
	    // If the user pushes more data while we're writing to dest then we'll end up
	    // in ondata again. However, we only want to increase awaitDrain once because
	    // dest will only emit one 'drain' event for the multiple writes.
	    // => Introduce a guard on increasing awaitDrain.
	    var increasedAwaitDrain = false;
	    src.on('data', ondata);
	    function ondata(chunk) {
	      debug('ondata');
	      increasedAwaitDrain = false;
	      var ret = dest.write(chunk);
	      if (false === ret && !increasedAwaitDrain) {
	        // If the user unpiped during `dest.write()`, it is possible
	        // to get stuck in a permanently paused state if that write
	        // also returned false.
	        // => Check whether `dest` is still a piping destination.
	        if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	          debug('false write response, pause', src._readableState.awaitDrain);
	          src._readableState.awaitDrain++;
	          increasedAwaitDrain = true;
	        }
	        src.pause();
	      }
	    }
	
	    // if the dest has an error, then stop piping into it.
	    // however, don't suppress the throwing behavior for this.
	    function onerror(er) {
	      debug('onerror', er);
	      unpipe();
	      dest.removeListener('error', onerror);
	      if (listenerCount$1(dest, 'error') === 0) dest.emit('error', er);
	    }
	
	    // Make sure our error handler is attached before userland ones.
	    prependListener(dest, 'error', onerror);
	
	    // Both close and finish should trigger unpipe, but only once.
	    function onclose() {
	      dest.removeListener('finish', onfinish);
	      unpipe();
	    }
	    dest.once('close', onclose);
	    function onfinish() {
	      debug('onfinish');
	      dest.removeListener('close', onclose);
	      unpipe();
	    }
	    dest.once('finish', onfinish);
	
	    function unpipe() {
	      debug('unpipe');
	      src.unpipe(dest);
	    }
	
	    // tell the dest that it's being piped to
	    dest.emit('pipe', src);
	
	    // start the flow if it hasn't been started already.
	    if (!state.flowing) {
	      debug('pipe resume');
	      src.resume();
	    }
	
	    return dest;
	  };
	
	  function pipeOnDrain(src) {
	    return function () {
	      var state = src._readableState;
	      debug('pipeOnDrain', state.awaitDrain);
	      if (state.awaitDrain) state.awaitDrain--;
	      if (state.awaitDrain === 0 && src.listeners('data').length) {
	        state.flowing = true;
	        flow(src);
	      }
	    };
	  }
	
	  Readable.prototype.unpipe = function (dest) {
	    var state = this._readableState;
	
	    // if we're not piping anywhere, then do nothing.
	    if (state.pipesCount === 0) return this;
	
	    // just one destination.  most common case.
	    if (state.pipesCount === 1) {
	      // passed in one, but it's not the right one.
	      if (dest && dest !== state.pipes) return this;
	
	      if (!dest) dest = state.pipes;
	
	      // got a match.
	      state.pipes = null;
	      state.pipesCount = 0;
	      state.flowing = false;
	      if (dest) dest.emit('unpipe', this);
	      return this;
	    }
	
	    // slow case. multiple pipe destinations.
	
	    if (!dest) {
	      // remove all.
	      var dests = state.pipes;
	      var len = state.pipesCount;
	      state.pipes = null;
	      state.pipesCount = 0;
	      state.flowing = false;
	
	      for (var _i = 0; _i < len; _i++) {
	        dests[_i].emit('unpipe', this);
	      }return this;
	    }
	
	    // try to find the right one.
	    var i = indexOf(state.pipes, dest);
	    if (i === -1) return this;
	
	    state.pipes.splice(i, 1);
	    state.pipesCount -= 1;
	    if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	    dest.emit('unpipe', this);
	
	    return this;
	  };
	
	  // set up data events if they are asked for
	  // Ensure readable listeners eventually get something
	  Readable.prototype.on = function (ev, fn) {
	    var res = EventEmitter.prototype.on.call(this, ev, fn);
	
	    if (ev === 'data') {
	      // Start flowing on next tick if stream isn't explicitly paused
	      if (this._readableState.flowing !== false) this.resume();
	    } else if (ev === 'readable') {
	      var state = this._readableState;
	      if (!state.endEmitted && !state.readableListening) {
	        state.readableListening = state.needReadable = true;
	        state.emittedReadable = false;
	        if (!state.reading) {
	          nextTick(nReadingNextTick, this);
	        } else if (state.length) {
	          emitReadable(this);
	        }
	      }
	    }
	
	    return res;
	  };
	  Readable.prototype.addListener = Readable.prototype.on;
	
	  function nReadingNextTick(self) {
	    debug('readable nexttick read 0');
	    self.read(0);
	  }
	
	  // pause() and resume() are remnants of the legacy readable stream API
	  // If the user uses them, then switch into old mode.
	  Readable.prototype.resume = function () {
	    var state = this._readableState;
	    if (!state.flowing) {
	      debug('resume');
	      state.flowing = true;
	      resume(this, state);
	    }
	    return this;
	  };
	
	  function resume(stream, state) {
	    if (!state.resumeScheduled) {
	      state.resumeScheduled = true;
	      nextTick(resume_, stream, state);
	    }
	  }
	
	  function resume_(stream, state) {
	    if (!state.reading) {
	      debug('resume read 0');
	      stream.read(0);
	    }
	
	    state.resumeScheduled = false;
	    state.awaitDrain = 0;
	    stream.emit('resume');
	    flow(stream);
	    if (state.flowing && !state.reading) stream.read(0);
	  }
	
	  Readable.prototype.pause = function () {
	    debug('call pause flowing=%j', this._readableState.flowing);
	    if (false !== this._readableState.flowing) {
	      debug('pause');
	      this._readableState.flowing = false;
	      this.emit('pause');
	    }
	    return this;
	  };
	
	  function flow(stream) {
	    var state = stream._readableState;
	    debug('flow', state.flowing);
	    while (state.flowing && stream.read() !== null) {}
	  }
	
	  // wrap an old-style stream as the async data source.
	  // This is *not* part of the readable stream interface.
	  // It is an ugly unfortunate mess of history.
	  Readable.prototype.wrap = function (stream) {
	    var state = this._readableState;
	    var paused = false;
	
	    var self = this;
	    stream.on('end', function () {
	      debug('wrapped end');
	      if (state.decoder && !state.ended) {
	        var chunk = state.decoder.end();
	        if (chunk && chunk.length) self.push(chunk);
	      }
	
	      self.push(null);
	    });
	
	    stream.on('data', function (chunk) {
	      debug('wrapped data');
	      if (state.decoder) chunk = state.decoder.write(chunk);
	
	      // don't skip over falsy values in objectMode
	      if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	      var ret = self.push(chunk);
	      if (!ret) {
	        paused = true;
	        stream.pause();
	      }
	    });
	
	    // proxy all the other methods.
	    // important when wrapping filters and duplexes.
	    for (var i in stream) {
	      if (this[i] === undefined && typeof stream[i] === 'function') {
	        this[i] = function (method) {
	          return function () {
	            return stream[method].apply(stream, arguments);
	          };
	        }(i);
	      }
	    }
	
	    // proxy certain important events.
	    var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	    forEach(events, function (ev) {
	      stream.on(ev, self.emit.bind(self, ev));
	    });
	
	    // when we try to consume some more bytes, simply unpause the
	    // underlying stream.
	    self._read = function (n) {
	      debug('wrapped _read', n);
	      if (paused) {
	        paused = false;
	        stream.resume();
	      }
	    };
	
	    return self;
	  };
	
	  // exposed for testing purposes only.
	  Readable._fromList = fromList;
	
	  // Pluck off n bytes from an array of buffers.
	  // Length is the combined lengths of all the buffers in the list.
	  // This function is designed to be inlinable, so please take care when making
	  // changes to the function body.
	  function fromList(n, state) {
	    // nothing buffered
	    if (state.length === 0) return null;
	
	    var ret;
	    if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	      // read it all, truncate the list
	      if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	      state.buffer.clear();
	    } else {
	      // read part of list
	      ret = fromListPartial(n, state.buffer, state.decoder);
	    }
	
	    return ret;
	  }
	
	  // Extracts only enough buffered data to satisfy the amount requested.
	  // This function is designed to be inlinable, so please take care when making
	  // changes to the function body.
	  function fromListPartial(n, list, hasStrings) {
	    var ret;
	    if (n < list.head.data.length) {
	      // slice is the same for buffers and strings
	      ret = list.head.data.slice(0, n);
	      list.head.data = list.head.data.slice(n);
	    } else if (n === list.head.data.length) {
	      // first chunk is a perfect match
	      ret = list.shift();
	    } else {
	      // result spans more than one buffer
	      ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	    }
	    return ret;
	  }
	
	  // Copies a specified amount of characters from the list of buffered data
	  // chunks.
	  // This function is designed to be inlinable, so please take care when making
	  // changes to the function body.
	  function copyFromBufferString(n, list) {
	    var p = list.head;
	    var c = 1;
	    var ret = p.data;
	    n -= ret.length;
	    while (p = p.next) {
	      var str = p.data;
	      var nb = n > str.length ? str.length : n;
	      if (nb === str.length) ret += str;else ret += str.slice(0, n);
	      n -= nb;
	      if (n === 0) {
	        if (nb === str.length) {
	          ++c;
	          if (p.next) list.head = p.next;else list.head = list.tail = null;
	        } else {
	          list.head = p;
	          p.data = str.slice(nb);
	        }
	        break;
	      }
	      ++c;
	    }
	    list.length -= c;
	    return ret;
	  }
	
	  // Copies a specified amount of bytes from the list of buffered data chunks.
	  // This function is designed to be inlinable, so please take care when making
	  // changes to the function body.
	  function copyFromBuffer(n, list) {
	    var ret = Buffer.allocUnsafe(n);
	    var p = list.head;
	    var c = 1;
	    p.data.copy(ret);
	    n -= p.data.length;
	    while (p = p.next) {
	      var buf = p.data;
	      var nb = n > buf.length ? buf.length : n;
	      buf.copy(ret, ret.length - n, 0, nb);
	      n -= nb;
	      if (n === 0) {
	        if (nb === buf.length) {
	          ++c;
	          if (p.next) list.head = p.next;else list.head = list.tail = null;
	        } else {
	          list.head = p;
	          p.data = buf.slice(nb);
	        }
	        break;
	      }
	      ++c;
	    }
	    list.length -= c;
	    return ret;
	  }
	
	  function endReadable(stream) {
	    var state = stream._readableState;
	
	    // If we get here before consuming all the bytes, then that is a
	    // bug in node.  Should never happen.
	    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	    if (!state.endEmitted) {
	      state.ended = true;
	      nextTick(endReadableNT, state, stream);
	    }
	  }
	
	  function endReadableNT(state, stream) {
	    // Check that we didn't get one last unshift.
	    if (!state.endEmitted && state.length === 0) {
	      state.endEmitted = true;
	      stream.readable = false;
	      stream.emit('end');
	    }
	  }
	
	  function forEach(xs, f) {
	    for (var i = 0, l = xs.length; i < l; i++) {
	      f(xs[i], i);
	    }
	  }
	
	  function indexOf(xs, x) {
	    for (var i = 0, l = xs.length; i < l; i++) {
	      if (xs[i] === x) return i;
	    }
	    return -1;
	  }
	
	  // A bit simpler than readable streams.
	  Writable.WritableState = WritableState;
	  inherits$1(Writable, EventEmitter);
	
	  function nop() {}
	
	  function WriteReq(chunk, encoding, cb) {
	    this.chunk = chunk;
	    this.encoding = encoding;
	    this.callback = cb;
	    this.next = null;
	  }
	
	  function WritableState(options, stream) {
	    Object.defineProperty(this, 'buffer', {
	      get: deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	    });
	    options = options || {};
	
	    // object stream flag to indicate whether or not this stream
	    // contains buffers or objects.
	    this.objectMode = !!options.objectMode;
	
	    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	    // the point at which write() starts returning false
	    // Note: 0 is a valid value, means that we always return false if
	    // the entire buffer is not flushed immediately on write()
	    var hwm = options.highWaterMark;
	    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	    // cast to ints.
	    this.highWaterMark = ~ ~this.highWaterMark;
	
	    this.needDrain = false;
	    // at the start of calling end()
	    this.ending = false;
	    // when end() has been called, and returned
	    this.ended = false;
	    // when 'finish' is emitted
	    this.finished = false;
	
	    // should we decode strings into buffers before passing to _write?
	    // this is here so that some node-core streams can optimize string
	    // handling at a lower level.
	    var noDecode = options.decodeStrings === false;
	    this.decodeStrings = !noDecode;
	
	    // Crypto is kind of old and crusty.  Historically, its default string
	    // encoding is 'binary' so we have to make this configurable.
	    // Everything else in the universe uses 'utf8', though.
	    this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	    // not an actual buffer we keep track of, but a measurement
	    // of how much we're waiting to get pushed to some underlying
	    // socket or file.
	    this.length = 0;
	
	    // a flag to see when we're in the middle of a write.
	    this.writing = false;
	
	    // when true all writes will be buffered until .uncork() call
	    this.corked = 0;
	
	    // a flag to be able to tell if the onwrite cb is called immediately,
	    // or on a later tick.  We set this to true at first, because any
	    // actions that shouldn't happen until "later" should generally also
	    // not happen before the first write call.
	    this.sync = true;
	
	    // a flag to know if we're processing previously buffered items, which
	    // may call the _write() callback in the same tick, so that we don't
	    // end up in an overlapped onwrite situation.
	    this.bufferProcessing = false;
	
	    // the callback that's passed to _write(chunk,cb)
	    this.onwrite = function (er) {
	      onwrite(stream, er);
	    };
	
	    // the callback that the user supplies to write(chunk,encoding,cb)
	    this.writecb = null;
	
	    // the amount that is being written when _write is called.
	    this.writelen = 0;
	
	    this.bufferedRequest = null;
	    this.lastBufferedRequest = null;
	
	    // number of pending user-supplied write callbacks
	    // this must be 0 before 'finish' can be emitted
	    this.pendingcb = 0;
	
	    // emit prefinish if the only thing we're waiting for is _write cbs
	    // This is relevant for synchronous Transform streams
	    this.prefinished = false;
	
	    // True if the error was already emitted and should not be thrown again
	    this.errorEmitted = false;
	
	    // count buffered requests
	    this.bufferedRequestCount = 0;
	
	    // allocate the first CorkedRequest, there is always
	    // one allocated and free to use, and we maintain at most two
	    this.corkedRequestsFree = new CorkedRequest(this);
	  }
	
	  WritableState.prototype.getBuffer = function writableStateGetBuffer() {
	    var current = this.bufferedRequest;
	    var out = [];
	    while (current) {
	      out.push(current);
	      current = current.next;
	    }
	    return out;
	  };
	  function Writable(options) {
	
	    // Writable ctor is applied to Duplexes, though they're not
	    // instanceof Writable, they're instanceof Readable.
	    if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);
	
	    this._writableState = new WritableState(options, this);
	
	    // legacy.
	    this.writable = true;
	
	    if (options) {
	      if (typeof options.write === 'function') this._write = options.write;
	
	      if (typeof options.writev === 'function') this._writev = options.writev;
	    }
	
	    EventEmitter.call(this);
	  }
	
	  // Otherwise people can pipe Writable streams, which is just wrong.
	  Writable.prototype.pipe = function () {
	    this.emit('error', new Error('Cannot pipe, not readable'));
	  };
	
	  function writeAfterEnd(stream, cb) {
	    var er = new Error('write after end');
	    // TODO: defer error events consistently everywhere, not just the cb
	    stream.emit('error', er);
	    nextTick(cb, er);
	  }
	
	  // If we get something that is not a buffer, string, null, or undefined,
	  // and we're not in objectMode, then that's an error.
	  // Otherwise stream chunks are all considered to be of length=1, and the
	  // watermarks determine how many objects to keep in the buffer, rather than
	  // how many bytes or characters.
	  function validChunk(stream, state, chunk, cb) {
	    var valid = true;
	    var er = false;
	    // Always throw error if a null is written
	    // if we are not in object mode then throw
	    // if it is not a buffer, string, or undefined.
	    if (chunk === null) {
	      er = new TypeError('May not write null values to stream');
	    } else if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	      er = new TypeError('Invalid non-string/buffer chunk');
	    }
	    if (er) {
	      stream.emit('error', er);
	      nextTick(cb, er);
	      valid = false;
	    }
	    return valid;
	  }
	
	  Writable.prototype.write = function (chunk, encoding, cb) {
	    var state = this._writableState;
	    var ret = false;
	
	    if (typeof encoding === 'function') {
	      cb = encoding;
	      encoding = null;
	    }
	
	    if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	    if (typeof cb !== 'function') cb = nop;
	
	    if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
	      state.pendingcb++;
	      ret = writeOrBuffer(this, state, chunk, encoding, cb);
	    }
	
	    return ret;
	  };
	
	  Writable.prototype.cork = function () {
	    var state = this._writableState;
	
	    state.corked++;
	  };
	
	  Writable.prototype.uncork = function () {
	    var state = this._writableState;
	
	    if (state.corked) {
	      state.corked--;
	
	      if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	    }
	  };
	
	  Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	    // node::ParseEncoding() requires lower case.
	    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	    if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	    this._writableState.defaultEncoding = encoding;
	    return this;
	  };
	
	  function decodeChunk(state, chunk, encoding) {
	    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	      chunk = Buffer.from(chunk, encoding);
	    }
	    return chunk;
	  }
	
	  // if we're already writing something, then just put this
	  // in the queue, and wait our turn.  Otherwise, call _write
	  // If we return false, then we need a drain event, so set that flag.
	  function writeOrBuffer(stream, state, chunk, encoding, cb) {
	    chunk = decodeChunk(state, chunk, encoding);
	
	    if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	    var len = state.objectMode ? 1 : chunk.length;
	
	    state.length += len;
	
	    var ret = state.length < state.highWaterMark;
	    // we must ensure that previous needDrain will not be reset to false.
	    if (!ret) state.needDrain = true;
	
	    if (state.writing || state.corked) {
	      var last = state.lastBufferedRequest;
	      state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	      if (last) {
	        last.next = state.lastBufferedRequest;
	      } else {
	        state.bufferedRequest = state.lastBufferedRequest;
	      }
	      state.bufferedRequestCount += 1;
	    } else {
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	    }
	
	    return ret;
	  }
	
	  function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	    state.writelen = len;
	    state.writecb = cb;
	    state.writing = true;
	    state.sync = true;
	    if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	    state.sync = false;
	  }
	
	  function onwriteError(stream, state, sync, er, cb) {
	    --state.pendingcb;
	    if (sync) nextTick(cb, er);else cb(er);
	
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  }
	
	  function onwriteStateUpdate(state) {
	    state.writing = false;
	    state.writecb = null;
	    state.length -= state.writelen;
	    state.writelen = 0;
	  }
	
	  function onwrite(stream, er) {
	    var state = stream._writableState;
	    var sync = state.sync;
	    var cb = state.writecb;
	
	    onwriteStateUpdate(state);
	
	    if (er) onwriteError(stream, state, sync, er, cb);else {
	      // Check if we're actually ready to finish, but don't emit yet
	      var finished = needFinish(state);
	
	      if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	        clearBuffer(stream, state);
	      }
	
	      if (sync) {
	        /*<replacement>*/
	          nextTick(afterWrite, stream, state, finished, cb);
	        /*</replacement>*/
	      } else {
	          afterWrite(stream, state, finished, cb);
	        }
	    }
	  }
	
	  function afterWrite(stream, state, finished, cb) {
	    if (!finished) onwriteDrain(stream, state);
	    state.pendingcb--;
	    cb();
	    finishMaybe(stream, state);
	  }
	
	  // Must force callback to be called on nextTick, so that we don't
	  // emit 'drain' before the write() consumer gets the 'false' return
	  // value, and has a chance to attach a 'drain' listener.
	  function onwriteDrain(stream, state) {
	    if (state.length === 0 && state.needDrain) {
	      state.needDrain = false;
	      stream.emit('drain');
	    }
	  }
	
	  // if there's something in the buffer waiting, then process it
	  function clearBuffer(stream, state) {
	    state.bufferProcessing = true;
	    var entry = state.bufferedRequest;
	
	    if (stream._writev && entry && entry.next) {
	      // Fast case, write everything using _writev()
	      var l = state.bufferedRequestCount;
	      var buffer = new Array(l);
	      var holder = state.corkedRequestsFree;
	      holder.entry = entry;
	
	      var count = 0;
	      while (entry) {
	        buffer[count] = entry;
	        entry = entry.next;
	        count += 1;
	      }
	
	      doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	      // doWrite is almost always async, defer these to save a bit of time
	      // as the hot path ends with doWrite
	      state.pendingcb++;
	      state.lastBufferedRequest = null;
	      if (holder.next) {
	        state.corkedRequestsFree = holder.next;
	        holder.next = null;
	      } else {
	        state.corkedRequestsFree = new CorkedRequest(state);
	      }
	    } else {
	      // Slow case, write chunks one-by-one
	      while (entry) {
	        var chunk = entry.chunk;
	        var encoding = entry.encoding;
	        var cb = entry.callback;
	        var len = state.objectMode ? 1 : chunk.length;
	
	        doWrite(stream, state, false, len, chunk, encoding, cb);
	        entry = entry.next;
	        // if we didn't call the onwrite immediately, then
	        // it means that we need to wait until it does.
	        // also, that means that the chunk and cb are currently
	        // being processed, so move the buffer counter past them.
	        if (state.writing) {
	          break;
	        }
	      }
	
	      if (entry === null) state.lastBufferedRequest = null;
	    }
	
	    state.bufferedRequestCount = 0;
	    state.bufferedRequest = entry;
	    state.bufferProcessing = false;
	  }
	
	  Writable.prototype._write = function (chunk, encoding, cb) {
	    cb(new Error('not implemented'));
	  };
	
	  Writable.prototype._writev = null;
	
	  Writable.prototype.end = function (chunk, encoding, cb) {
	    var state = this._writableState;
	
	    if (typeof chunk === 'function') {
	      cb = chunk;
	      chunk = null;
	      encoding = null;
	    } else if (typeof encoding === 'function') {
	      cb = encoding;
	      encoding = null;
	    }
	
	    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	    // .end() fully uncorks
	    if (state.corked) {
	      state.corked = 1;
	      this.uncork();
	    }
	
	    // ignore unnecessary end() calls.
	    if (!state.ending && !state.finished) endWritable(this, state, cb);
	  };
	
	  function needFinish(state) {
	    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	  }
	
	  function prefinish(stream, state) {
	    if (!state.prefinished) {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	
	  function finishMaybe(stream, state) {
	    var need = needFinish(state);
	    if (need) {
	      if (state.pendingcb === 0) {
	        prefinish(stream, state);
	        state.finished = true;
	        stream.emit('finish');
	      } else {
	        prefinish(stream, state);
	      }
	    }
	    return need;
	  }
	
	  function endWritable(stream, state, cb) {
	    state.ending = true;
	    finishMaybe(stream, state);
	    if (cb) {
	      if (state.finished) nextTick(cb);else stream.once('finish', cb);
	    }
	    state.ended = true;
	    stream.writable = false;
	  }
	
	  // It seems a linked list but it is not
	  // there will be only 2 of these for each stream
	  function CorkedRequest(state) {
	    var _this = this;
	
	    this.next = null;
	    this.entry = null;
	
	    this.finish = function (err) {
	      var entry = _this.entry;
	      _this.entry = null;
	      while (entry) {
	        var cb = entry.callback;
	        state.pendingcb--;
	        cb(err);
	        entry = entry.next;
	      }
	      if (state.corkedRequestsFree) {
	        state.corkedRequestsFree.next = _this;
	      } else {
	        state.corkedRequestsFree = _this;
	      }
	    };
	  }
	
	  inherits$1(Duplex, Readable);
	
	  var keys = Object.keys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	  function Duplex(options) {
	    if (!(this instanceof Duplex)) return new Duplex(options);
	
	    Readable.call(this, options);
	    Writable.call(this, options);
	
	    if (options && options.readable === false) this.readable = false;
	
	    if (options && options.writable === false) this.writable = false;
	
	    this.allowHalfOpen = true;
	    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	    this.once('end', onend);
	  }
	
	  // the no-half-open enforcer
	  function onend() {
	    // if we allow half-open state, or if the writable side ended,
	    // then we're ok.
	    if (this.allowHalfOpen || this._writableState.ended) return;
	
	    // no more data can be written.
	    // But allow more writes to happen in this tick.
	    nextTick(onEndNT, this);
	  }
	
	  function onEndNT(self) {
	    self.end();
	  }
	
	  // a transform stream is a readable/writable stream where you do
	  inherits$1(Transform, Duplex);
	
	  function TransformState(stream) {
	    this.afterTransform = function (er, data) {
	      return afterTransform(stream, er, data);
	    };
	
	    this.needTransform = false;
	    this.transforming = false;
	    this.writecb = null;
	    this.writechunk = null;
	    this.writeencoding = null;
	  }
	
	  function afterTransform(stream, er, data) {
	    var ts = stream._transformState;
	    ts.transforming = false;
	
	    var cb = ts.writecb;
	
	    if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
	
	    ts.writechunk = null;
	    ts.writecb = null;
	
	    if (data !== null && data !== undefined) stream.push(data);
	
	    cb(er);
	
	    var rs = stream._readableState;
	    rs.reading = false;
	    if (rs.needReadable || rs.length < rs.highWaterMark) {
	      stream._read(rs.highWaterMark);
	    }
	  }
	  function Transform(options) {
	    if (!(this instanceof Transform)) return new Transform(options);
	
	    Duplex.call(this, options);
	
	    this._transformState = new TransformState(this);
	
	    // when the writable side finishes, then flush out anything remaining.
	    var stream = this;
	
	    // start out asking for a readable event once data is transformed.
	    this._readableState.needReadable = true;
	
	    // we have implemented the _read method, and done the other things
	    // that Readable wants before the first _read call, so unset the
	    // sync guard flag.
	    this._readableState.sync = false;
	
	    if (options) {
	      if (typeof options.transform === 'function') this._transform = options.transform;
	
	      if (typeof options.flush === 'function') this._flush = options.flush;
	    }
	
	    this.once('prefinish', function () {
	      if (typeof this._flush === 'function') this._flush(function (er) {
	        done(stream, er);
	      });else done(stream);
	    });
	  }
	
	  Transform.prototype.push = function (chunk, encoding) {
	    this._transformState.needTransform = false;
	    return Duplex.prototype.push.call(this, chunk, encoding);
	  };
	
	  // This is the part where you do stuff!
	  // override this function in implementation classes.
	  // 'chunk' is an input chunk.
	  //
	  // Call `push(newChunk)` to pass along transformed output
	  // to the readable side.  You may call 'push' zero or more times.
	  //
	  // Call `cb(err)` when you are done with this chunk.  If you pass
	  // an error, then that'll put the hurt on the whole operation.  If you
	  // never call cb(), then you'll never get another chunk.
	  Transform.prototype._transform = function (chunk, encoding, cb) {
	    throw new Error('Not implemented');
	  };
	
	  Transform.prototype._write = function (chunk, encoding, cb) {
	    var ts = this._transformState;
	    ts.writecb = cb;
	    ts.writechunk = chunk;
	    ts.writeencoding = encoding;
	    if (!ts.transforming) {
	      var rs = this._readableState;
	      if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	    }
	  };
	
	  // Doesn't matter what the args are here.
	  // _transform does all the work.
	  // That we got here means that the readable side wants more data.
	  Transform.prototype._read = function (n) {
	    var ts = this._transformState;
	
	    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	      ts.transforming = true;
	      this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	    } else {
	      // mark that we need a transform, so that any data that comes in
	      // will get processed, now that we've asked for it.
	      ts.needTransform = true;
	    }
	  };
	
	  function done(stream, er) {
	    if (er) return stream.emit('error', er);
	
	    // if there's nothing in the write buffer, then that means
	    // that nothing more will ever be provided
	    var ws = stream._writableState;
	    var ts = stream._transformState;
	
	    if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	    if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	    return stream.push(null);
	  }
	
	  inherits$1(PassThrough, Transform);
	  function PassThrough(options) {
	    if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	    Transform.call(this, options);
	  }
	
	  PassThrough.prototype._transform = function (chunk, encoding, cb) {
	    cb(null, chunk);
	  };
	
	  inherits$1(Stream, EventEmitter);
	  Stream.Readable = Readable;
	  Stream.Writable = Writable;
	  Stream.Duplex = Duplex;
	  Stream.Transform = Transform;
	  Stream.PassThrough = PassThrough;
	
	  // Backwards-compat with node 0.4.x
	  Stream.Stream = Stream;
	
	  // old-style streams.  Note that the pipe method (the only relevant
	  // part of this class) is overridden in the Readable class.
	
	  function Stream() {
	    EventEmitter.call(this);
	  }
	
	  Stream.prototype.pipe = function(dest, options) {
	    var source = this;
	
	    function ondata(chunk) {
	      if (dest.writable) {
	        if (false === dest.write(chunk) && source.pause) {
	          source.pause();
	        }
	      }
	    }
	
	    source.on('data', ondata);
	
	    function ondrain() {
	      if (source.readable && source.resume) {
	        source.resume();
	      }
	    }
	
	    dest.on('drain', ondrain);
	
	    // If the 'end' option is not supplied, dest.end() will be called when
	    // source gets the 'end' or 'close' events.  Only dest.end() once.
	    if (!dest._isStdio && (!options || options.end !== false)) {
	      source.on('end', onend);
	      source.on('close', onclose);
	    }
	
	    var didOnEnd = false;
	    function onend() {
	      if (didOnEnd) return;
	      didOnEnd = true;
	
	      dest.end();
	    }
	
	
	    function onclose() {
	      if (didOnEnd) return;
	      didOnEnd = true;
	
	      if (typeof dest.destroy === 'function') dest.destroy();
	    }
	
	    // don't leave dangling pipes when there are errors.
	    function onerror(er) {
	      cleanup();
	      if (EventEmitter.listenerCount(this, 'error') === 0) {
	        throw er; // Unhandled stream error in pipe.
	      }
	    }
	
	    source.on('error', onerror);
	    dest.on('error', onerror);
	
	    // remove all the event listeners that were added.
	    function cleanup() {
	      source.removeListener('data', ondata);
	      dest.removeListener('drain', ondrain);
	
	      source.removeListener('end', onend);
	      source.removeListener('close', onclose);
	
	      source.removeListener('error', onerror);
	      dest.removeListener('error', onerror);
	
	      source.removeListener('end', cleanup);
	      source.removeListener('close', cleanup);
	
	      dest.removeListener('close', cleanup);
	    }
	
	    source.on('end', cleanup);
	    source.on('close', cleanup);
	
	    dest.on('close', cleanup);
	
	    dest.emit('pipe', source);
	
	    // Allow for unix-like usage: A.pipe(B).pipe(C)
	    return dest;
	  };
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	      var ownKeys = Object.keys(source);
	
	      if (typeof Object.getOwnPropertySymbols === 'function') {
	        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	        }));
	      }
	
	      ownKeys.forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    }
	
	    return target;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _toArray(arr) {
	    return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _arrayWithHoles(arr) {
	    if (Array.isArray(arr)) return arr;
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  function _nonIterableRest() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	
	  /*
	  The MIT License (MIT)
	
	  Copyright (c) 2016 CoderPuppy
	
	  Permission is hereby granted, free of charge, to any person obtaining a copy
	  of this software and associated documentation files (the "Software"), to deal
	  in the Software without restriction, including without limitation the rights
	  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	  copies of the Software, and to permit persons to whom the Software is
	  furnished to do so, subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be included in all
	  copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	
	  */
	  var _endianness;
	  function endianness() {
	    if (typeof _endianness === 'undefined') {
	      var a = new ArrayBuffer(2);
	      var b = new Uint8Array(a);
	      var c = new Uint16Array(a);
	      b[0] = 1;
	      b[1] = 2;
	      if (c[0] === 258) {
	        _endianness = 'BE';
	      } else if (c[0] === 513){
	        _endianness = 'LE';
	      } else {
	        throw new Error('unable to figure out endianess');
	      }
	    }
	    return _endianness;
	  }
	
	  function hostname() {
	    if (typeof global$1.location !== 'undefined') {
	      return global$1.location.hostname
	    } else return '';
	  }
	
	  function loadavg() {
	    return [];
	  }
	
	  function uptime() {
	    return 0;
	  }
	
	  function freemem() {
	    return Number.MAX_VALUE;
	  }
	
	  function totalmem() {
	    return Number.MAX_VALUE;
	  }
	
	  function cpus() {
	    return [];
	  }
	
	  function type() {
	    return 'Browser';
	  }
	
	  function release () {
	    if (typeof global$1.navigator !== 'undefined') {
	      return global$1.navigator.appVersion;
	    }
	    return '';
	  }
	
	  function networkInterfaces(){}
	  function getNetworkInterfaces(){}
	
	  function tmpDir() {
	    return '/tmp';
	  }
	  var tmpdir = tmpDir;
	
	  var EOL = '\n';
	  var os = {
	    EOL: EOL,
	    tmpdir: tmpdir,
	    tmpDir: tmpDir,
	    networkInterfaces:networkInterfaces,
	    getNetworkInterfaces: getNetworkInterfaces,
	    release: release,
	    type: type,
	    cpus: cpus,
	    totalmem: totalmem,
	    freemem: freemem,
	    uptime: uptime,
	    loadavg: loadavg,
	    hostname: hostname,
	    endianness: endianness,
	  };
	
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  /**
	   * lodash (Custom Build) <https://lodash.com/>
	   * Build: `lodash modularize exports="npm" -o ./`
	   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	   * Released under MIT license <https://lodash.com/license>
	   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	   */
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0;
	
	  /** `Object#toString` result references. */
	  var funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      symbolTag = '[object Symbol]';
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /** Used for built-in method references. */
	  var arrayProto = Array.prototype,
	      funcProto = Function.prototype,
	      objectProto = Object.prototype;
	
	  /** Used to detect overreaching core-js shims. */
	  var coreJsData = root['__core-js_shared__'];
	
	  /** Used to detect methods masquerading as native. */
	  var maskSrcKey = (function() {
	    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	    return uid ? ('Symbol(src)_1.' + uid) : '';
	  }());
	
	  /** Used to resolve the decompiled source of functions. */
	  var funcToString = funcProto.toString;
	
	  /** Used to check objects for own properties. */
	  var hasOwnProperty$1 = objectProto.hasOwnProperty;
	
	  /**
	   * Used to resolve the
	   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objectToString$1 = objectProto.toString;
	
	  /** Used to detect if a method is native. */
	  var reIsNative = RegExp('^' +
	    funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
	    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	  );
	
	  /** Built-in value references. */
	  var Symbol$1 = root.Symbol,
	      splice = arrayProto.splice;
	
	  /* Built-in method references that are verified to be native. */
	  var Map = getNative(root, 'Map'),
	      nativeCreate = getNative(Object, 'create');
	
	  /** Used to convert symbols to primitives and strings. */
	  var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	      symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	  /**
	   * Creates a hash object.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function Hash(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the hash.
	   *
	   * @private
	   * @name clear
	   * @memberOf Hash
	   */
	  function hashClear() {
	    this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  }
	
	  /**
	   * Removes `key` and its value from the hash.
	   *
	   * @private
	   * @name delete
	   * @memberOf Hash
	   * @param {Object} hash The hash to modify.
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function hashDelete(key) {
	    return this.has(key) && delete this.__data__[key];
	  }
	
	  /**
	   * Gets the hash value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf Hash
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function hashGet(key) {
	    var data = this.__data__;
	    if (nativeCreate) {
	      var result = data[key];
	      return result === HASH_UNDEFINED ? undefined : result;
	    }
	    return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
	  }
	
	  /**
	   * Checks if a hash value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf Hash
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function hashHas(key) {
	    var data = this.__data__;
	    return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
	  }
	
	  /**
	   * Sets the hash `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf Hash
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the hash instance.
	   */
	  function hashSet(key, value) {
	    var data = this.__data__;
	    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	    return this;
	  }
	
	  // Add methods to `Hash`.
	  Hash.prototype.clear = hashClear;
	  Hash.prototype['delete'] = hashDelete;
	  Hash.prototype.get = hashGet;
	  Hash.prototype.has = hashHas;
	  Hash.prototype.set = hashSet;
	
	  /**
	   * Creates an list cache object.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function ListCache(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the list cache.
	   *
	   * @private
	   * @name clear
	   * @memberOf ListCache
	   */
	  function listCacheClear() {
	    this.__data__ = [];
	  }
	
	  /**
	   * Removes `key` and its value from the list cache.
	   *
	   * @private
	   * @name delete
	   * @memberOf ListCache
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function listCacheDelete(key) {
	    var data = this.__data__,
	        index = assocIndexOf(data, key);
	
	    if (index < 0) {
	      return false;
	    }
	    var lastIndex = data.length - 1;
	    if (index == lastIndex) {
	      data.pop();
	    } else {
	      splice.call(data, index, 1);
	    }
	    return true;
	  }
	
	  /**
	   * Gets the list cache value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf ListCache
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function listCacheGet(key) {
	    var data = this.__data__,
	        index = assocIndexOf(data, key);
	
	    return index < 0 ? undefined : data[index][1];
	  }
	
	  /**
	   * Checks if a list cache value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf ListCache
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function listCacheHas(key) {
	    return assocIndexOf(this.__data__, key) > -1;
	  }
	
	  /**
	   * Sets the list cache `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf ListCache
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the list cache instance.
	   */
	  function listCacheSet(key, value) {
	    var data = this.__data__,
	        index = assocIndexOf(data, key);
	
	    if (index < 0) {
	      data.push([key, value]);
	    } else {
	      data[index][1] = value;
	    }
	    return this;
	  }
	
	  // Add methods to `ListCache`.
	  ListCache.prototype.clear = listCacheClear;
	  ListCache.prototype['delete'] = listCacheDelete;
	  ListCache.prototype.get = listCacheGet;
	  ListCache.prototype.has = listCacheHas;
	  ListCache.prototype.set = listCacheSet;
	
	  /**
	   * Creates a map cache object to store key-value pairs.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function MapCache(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the map.
	   *
	   * @private
	   * @name clear
	   * @memberOf MapCache
	   */
	  function mapCacheClear() {
	    this.__data__ = {
	      'hash': new Hash,
	      'map': new (Map || ListCache),
	      'string': new Hash
	    };
	  }
	
	  /**
	   * Removes `key` and its value from the map.
	   *
	   * @private
	   * @name delete
	   * @memberOf MapCache
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function mapCacheDelete(key) {
	    return getMapData(this, key)['delete'](key);
	  }
	
	  /**
	   * Gets the map value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf MapCache
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function mapCacheGet(key) {
	    return getMapData(this, key).get(key);
	  }
	
	  /**
	   * Checks if a map value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf MapCache
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function mapCacheHas(key) {
	    return getMapData(this, key).has(key);
	  }
	
	  /**
	   * Sets the map `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf MapCache
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the map cache instance.
	   */
	  function mapCacheSet(key, value) {
	    getMapData(this, key).set(key, value);
	    return this;
	  }
	
	  // Add methods to `MapCache`.
	  MapCache.prototype.clear = mapCacheClear;
	  MapCache.prototype['delete'] = mapCacheDelete;
	  MapCache.prototype.get = mapCacheGet;
	  MapCache.prototype.has = mapCacheHas;
	  MapCache.prototype.set = mapCacheSet;
	
	  /**
	   * Gets the index at which the `key` is found in `array` of key-value pairs.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} key The key to search for.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function assocIndexOf(array, key) {
	    var length = array.length;
	    while (length--) {
	      if (eq(array[length][0], key)) {
	        return length;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.get` without support for default values.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array|string} path The path of the property to get.
	   * @returns {*} Returns the resolved value.
	   */
	  function baseGet(object, path) {
	    path = isKey(path, object) ? [path] : castPath(path);
	
	    var index = 0,
	        length = path.length;
	
	    while (object != null && index < length) {
	      object = object[toKey(path[index++])];
	    }
	    return (index && index == length) ? object : undefined;
	  }
	
	  /**
	   * The base implementation of `_.isNative` without bad shim checks.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a native function,
	   *  else `false`.
	   */
	  function baseIsNative(value) {
	    if (!isObject$1(value) || isMasked(value)) {
	      return false;
	    }
	    var pattern = (isFunction$1(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	    return pattern.test(toSource(value));
	  }
	
	  /**
	   * The base implementation of `_.toString` which doesn't convert nullish
	   * values to empty strings.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    // Exit early for strings to avoid a performance hit in some environments.
	    if (typeof value == 'string') {
	      return value;
	    }
	    if (isSymbol(value)) {
	      return symbolToString ? symbolToString.call(value) : '';
	    }
	    var result = (value + '');
	    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	  }
	
	  /**
	   * Casts `value` to a path array if it's not one.
	   *
	   * @private
	   * @param {*} value The value to inspect.
	   * @returns {Array} Returns the cast property path array.
	   */
	  function castPath(value) {
	    return isArray$2(value) ? value : stringToPath(value);
	  }
	
	  /**
	   * Gets the data for `map`.
	   *
	   * @private
	   * @param {Object} map The map to query.
	   * @param {string} key The reference key.
	   * @returns {*} Returns the map data.
	   */
	  function getMapData(map, key) {
	    var data = map.__data__;
	    return isKeyable(key)
	      ? data[typeof key == 'string' ? 'string' : 'hash']
	      : data.map;
	  }
	
	  /**
	   * Gets the native function at `key` of `object`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the method to get.
	   * @returns {*} Returns the function if it's native, else `undefined`.
	   */
	  function getNative(object, key) {
	    var value = getValue(object, key);
	    return baseIsNative(value) ? value : undefined;
	  }
	
	  /**
	   * Checks if `value` is a property name and not a property path.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {Object} [object] The object to query keys on.
	   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	   */
	  function isKey(value, object) {
	    if (isArray$2(value)) {
	      return false;
	    }
	    var type = typeof value;
	    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	        value == null || isSymbol(value)) {
	      return true;
	    }
	    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	      (object != null && value in Object(object));
	  }
	
	  /**
	   * Checks if `value` is suitable for use as unique object key.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	   */
	  function isKeyable(value) {
	    var type = typeof value;
	    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	      ? (value !== '__proto__')
	      : (value === null);
	  }
	
	  /**
	   * Checks if `func` has its source masked.
	   *
	   * @private
	   * @param {Function} func The function to check.
	   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	   */
	  function isMasked(func) {
	    return !!maskSrcKey && (maskSrcKey in func);
	  }
	
	  /**
	   * Converts `string` to a property path array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the property path array.
	   */
	  var stringToPath = memoize(function(string) {
	    string = toString$1(string);
	
	    var result = [];
	    if (reLeadingDot.test(string)) {
	      result.push('');
	    }
	    string.replace(rePropName, function(match, number, quote, string) {
	      result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	    });
	    return result;
	  });
	
	  /**
	   * Converts `value` to a string key if it's not a string or symbol.
	   *
	   * @private
	   * @param {*} value The value to inspect.
	   * @returns {string|symbol} Returns the key.
	   */
	  function toKey(value) {
	    if (typeof value == 'string' || isSymbol(value)) {
	      return value;
	    }
	    var result = (value + '');
	    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	  }
	
	  /**
	   * Converts `func` to its source code.
	   *
	   * @private
	   * @param {Function} func The function to process.
	   * @returns {string} Returns the source code.
	   */
	  function toSource(func) {
	    if (func != null) {
	      try {
	        return funcToString.call(func);
	      } catch (e) {}
	      try {
	        return (func + '');
	      } catch (e) {}
	    }
	    return '';
	  }
	
	  /**
	   * Creates a function that memoizes the result of `func`. If `resolver` is
	   * provided, it determines the cache key for storing the result based on the
	   * arguments provided to the memoized function. By default, the first argument
	   * provided to the memoized function is used as the map cache key. The `func`
	   * is invoked with the `this` binding of the memoized function.
	   *
	   * **Note:** The cache is exposed as the `cache` property on the memoized
	   * function. Its creation may be customized by replacing the `_.memoize.Cache`
	   * constructor with one whose instances implement the
	   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	   * method interface of `delete`, `get`, `has`, and `set`.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Function
	   * @param {Function} func The function to have its output memoized.
	   * @param {Function} [resolver] The function to resolve the cache key.
	   * @returns {Function} Returns the new memoized function.
	   * @example
	   *
	   * var object = { 'a': 1, 'b': 2 };
	   * var other = { 'c': 3, 'd': 4 };
	   *
	   * var values = _.memoize(_.values);
	   * values(object);
	   * // => [1, 2]
	   *
	   * values(other);
	   * // => [3, 4]
	   *
	   * object.a = 2;
	   * values(object);
	   * // => [1, 2]
	   *
	   * // Modify the result cache.
	   * values.cache.set(object, ['a', 'b']);
	   * values(object);
	   * // => ['a', 'b']
	   *
	   * // Replace `_.memoize.Cache`.
	   * _.memoize.Cache = WeakMap;
	   */
	  function memoize(func, resolver) {
	    if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	      throw new TypeError(FUNC_ERROR_TEXT);
	    }
	    var memoized = function() {
	      var args = arguments,
	          key = resolver ? resolver.apply(this, args) : args[0],
	          cache = memoized.cache;
	
	      if (cache.has(key)) {
	        return cache.get(key);
	      }
	      var result = func.apply(this, args);
	      memoized.cache = cache.set(key, result);
	      return result;
	    };
	    memoized.cache = new (memoize.Cache || MapCache);
	    return memoized;
	  }
	
	  // Assign cache to `_.memoize`.
	  memoize.Cache = MapCache;
	
	  /**
	   * Performs a
	   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	   * comparison between two values to determine if they are equivalent.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	   * @example
	   *
	   * var object = { 'a': 1 };
	   * var other = { 'a': 1 };
	   *
	   * _.eq(object, object);
	   * // => true
	   *
	   * _.eq(object, other);
	   * // => false
	   *
	   * _.eq('a', 'a');
	   * // => true
	   *
	   * _.eq('a', Object('a'));
	   * // => false
	   *
	   * _.eq(NaN, NaN);
	   * // => true
	   */
	  function eq(value, other) {
	    return value === other || (value !== value && other !== other);
	  }
	
	  /**
	   * Checks if `value` is classified as an `Array` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	   * @example
	   *
	   * _.isArray([1, 2, 3]);
	   * // => true
	   *
	   * _.isArray(document.body.children);
	   * // => false
	   *
	   * _.isArray('abc');
	   * // => false
	   *
	   * _.isArray(_.noop);
	   * // => false
	   */
	  var isArray$2 = Array.isArray;
	
	  /**
	   * Checks if `value` is classified as a `Function` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	   * @example
	   *
	   * _.isFunction(_);
	   * // => true
	   *
	   * _.isFunction(/abc/);
	   * // => false
	   */
	  function isFunction$1(value) {
	    // The use of `Object#toString` avoids issues with the `typeof` operator
	    // in Safari 8-9 which returns 'object' for typed array and other constructors.
	    var tag = isObject$1(value) ? objectToString$1.call(value) : '';
	    return tag == funcTag || tag == genTag;
	  }
	
	  /**
	   * Checks if `value` is the
	   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	   * @example
	   *
	   * _.isObject({});
	   * // => true
	   *
	   * _.isObject([1, 2, 3]);
	   * // => true
	   *
	   * _.isObject(_.noop);
	   * // => true
	   *
	   * _.isObject(null);
	   * // => false
	   */
	  function isObject$1(value) {
	    var type = typeof value;
	    return !!value && (type == 'object' || type == 'function');
	  }
	
	  /**
	   * Checks if `value` is object-like. A value is object-like if it's not `null`
	   * and has a `typeof` result of "object".
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   * @example
	   *
	   * _.isObjectLike({});
	   * // => true
	   *
	   * _.isObjectLike([1, 2, 3]);
	   * // => true
	   *
	   * _.isObjectLike(_.noop);
	   * // => false
	   *
	   * _.isObjectLike(null);
	   * // => false
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Checks if `value` is classified as a `Symbol` primitive or object.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	   * @example
	   *
	   * _.isSymbol(Symbol.iterator);
	   * // => true
	   *
	   * _.isSymbol('abc');
	   * // => false
	   */
	  function isSymbol(value) {
	    return typeof value == 'symbol' ||
	      (isObjectLike(value) && objectToString$1.call(value) == symbolTag);
	  }
	
	  /**
	   * Converts `value` to a string. An empty string is returned for `null`
	   * and `undefined` values. The sign of `-0` is preserved.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   * @example
	   *
	   * _.toString(null);
	   * // => ''
	   *
	   * _.toString(-0);
	   * // => '-0'
	   *
	   * _.toString([1, 2, 3]);
	   * // => '1,2,3'
	   */
	  function toString$1(value) {
	    return value == null ? '' : baseToString(value);
	  }
	
	  /**
	   * Gets the value at `path` of `object`. If the resolved value is
	   * `undefined`, the `defaultValue` is returned in its place.
	   *
	   * @static
	   * @memberOf _
	   * @since 3.7.0
	   * @category Object
	   * @param {Object} object The object to query.
	   * @param {Array|string} path The path of the property to get.
	   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	   * @returns {*} Returns the resolved value.
	   * @example
	   *
	   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	   *
	   * _.get(object, 'a[0].b.c');
	   * // => 3
	   *
	   * _.get(object, ['a', '0', 'b', 'c']);
	   * // => 3
	   *
	   * _.get(object, 'a.b.c', 'default');
	   * // => 'default'
	   */
	  function get(object, path, defaultValue) {
	    var result = object == null ? undefined : baseGet(object, path);
	    return result === undefined ? defaultValue : result;
	  }
	
	  var lodash_get = get;
	
	  function getProp(obj, path, defaultValue) {
	    return obj[path] === undefined ? defaultValue : obj[path];
	  }
	
	  function setProp(obj, path, value) {
	    var pathArray = Array.isArray(path) ? path : path.split('.');
	
	    var _pathArray = _toArray(pathArray),
	        key = _pathArray[0],
	        restPath = _pathArray.slice(1);
	
	    return _objectSpread({}, obj, _defineProperty({}, key, pathArray.length > 1 ? setProp(obj[key] || {}, restPath, value) : value));
	  }
	
	  function unsetProp(obj, path) {
	    var pathArray = Array.isArray(path) ? path : path.split('.');
	
	    var _pathArray2 = _toArray(pathArray),
	        key = _pathArray2[0],
	        restPath = _pathArray2.slice(1);
	
	    if (_typeof(obj[key]) !== 'object') {
	      // This will never be hit in the current code because unwind does the check before calling unsetProp
	
	      /* istanbul ignore next */
	      return obj;
	    }
	
	    if (pathArray.length === 1) {
	      return Object.keys(obj).filter(function (prop) {
	        return prop !== key;
	      }).reduce(function (acc, prop) {
	        return Object.assign(acc, _defineProperty({}, prop, obj[prop]));
	      }, {});
	    }
	
	    return Object.keys(obj).reduce(function (acc, prop) {
	      return _objectSpread({}, acc, _defineProperty({}, prop, prop !== key ? obj[prop] : unsetProp(obj[key], restPath)));
	    }, {});
	  }
	
	  function flattenReducer(acc, arr) {
	    try {
	      // This is faster but susceptible to `RangeError: Maximum call stack size exceeded`
	      acc.push.apply(acc, _toConsumableArray(arr));
	      return acc;
	    } catch (err) {
	      // Fallback to a slower but safer option
	      return acc.concat(arr);
	    }
	  }
	
	  function fastJoin(arr, separator) {
	    var isFirst = true;
	    return arr.reduce(function (acc, elem) {
	      if (elem === null || elem === undefined) {
	        elem = '';
	      }
	
	      if (isFirst) {
	        isFirst = false;
	        return "".concat(elem);
	      }
	
	      return "".concat(acc).concat(separator).concat(elem);
	    }, '');
	  }
	
	  var utils = {
	    getProp: getProp,
	    setProp: setProp,
	    unsetProp: unsetProp,
	    fastJoin: fastJoin,
	    flattenReducer: flattenReducer
	  };
	
	  var getProp$1 = utils.getProp,
	      fastJoin$1 = utils.fastJoin,
	      flattenReducer$1 = utils.flattenReducer;
	
	  var JSON2CSVBase =
	  /*#__PURE__*/
	  function () {
	    function JSON2CSVBase(opts) {
	      _classCallCheck(this, JSON2CSVBase);
	
	      this.opts = this.preprocessOpts(opts);
	    }
	    /**
	     * Check passing opts and set defaults.
	     *
	     * @param {Json2CsvOptions} opts Options object containing fields,
	     * delimiter, default value, quote mark, header, etc.
	     */
	
	
	    _createClass(JSON2CSVBase, [{
	      key: "preprocessOpts",
	      value: function preprocessOpts(opts) {
	        var processedOpts = Object.assign({}, opts);
	        processedOpts.transforms = !Array.isArray(processedOpts.transforms) ? processedOpts.transforms ? [processedOpts.transforms] : [] : processedOpts.transforms;
	        processedOpts.delimiter = processedOpts.delimiter || ',';
	        processedOpts.eol = processedOpts.eol || os.EOL;
	        processedOpts.quote = typeof processedOpts.quote === 'string' ? processedOpts.quote : '"';
	        processedOpts.escapedQuote = typeof processedOpts.escapedQuote === 'string' ? processedOpts.escapedQuote : "".concat(processedOpts.quote).concat(processedOpts.quote);
	        processedOpts.header = processedOpts.header !== false;
	        processedOpts.includeEmptyRows = processedOpts.includeEmptyRows || false;
	        processedOpts.withBOM = processedOpts.withBOM || false;
	        return processedOpts;
	      }
	      /**
	       * Check and normalize the fields configuration.
	       *
	       * @param {(string|object)[]} fields Fields configuration provided by the user
	       * or inferred from the data
	       * @returns {object[]} preprocessed FieldsInfo array
	       */
	
	    }, {
	      key: "preprocessFieldsInfo",
	      value: function preprocessFieldsInfo(fields) {
	        var _this = this;
	
	        return fields.map(function (fieldInfo) {
	          if (typeof fieldInfo === 'string') {
	            return {
	              label: fieldInfo,
	              value: fieldInfo.includes('.') || fieldInfo.includes('[') ? function (row) {
	                return lodash_get(row, fieldInfo, _this.opts.defaultValue);
	              } : function (row) {
	                return getProp$1(row, fieldInfo, _this.opts.defaultValue);
	              }
	            };
	          }
	
	          if (_typeof(fieldInfo) === 'object') {
	            var defaultValue = 'default' in fieldInfo ? fieldInfo.default : _this.opts.defaultValue;
	
	            if (typeof fieldInfo.value === 'string') {
	              return {
	                label: fieldInfo.label || fieldInfo.value,
	                value: fieldInfo.value.includes('.') || fieldInfo.value.includes('[') ? function (row) {
	                  return lodash_get(row, fieldInfo.value, defaultValue);
	                } : function (row) {
	                  return getProp$1(row, fieldInfo.value, defaultValue);
	                }
	              };
	            }
	
	            if (typeof fieldInfo.value === 'function') {
	              var label = fieldInfo.label || fieldInfo.value.name || '';
	              var field = {
	                label: label,
	                default: defaultValue
	              };
	              return {
	                label: label,
	                value: function value(row) {
	                  var value = fieldInfo.value(row, field);
	                  return value === null || value === undefined ? defaultValue : value;
	                }
	              };
	            }
	          }
	
	          throw new Error('Invalid field info option. ' + JSON.stringify(fieldInfo));
	        });
	      }
	      /**
	       * Create the title row with all the provided fields as column headings
	       *
	       * @returns {String} titles as a string
	       */
	
	    }, {
	      key: "getHeader",
	      value: function getHeader() {
	        var _this2 = this;
	
	        return fastJoin$1(this.opts.fields.map(function (fieldInfo) {
	          return _this2.processValue(fieldInfo.label);
	        }), this.opts.delimiter);
	      }
	      /**
	       * Preprocess each object according to the given transforms (unwind, flatten, etc.).
	       * @param {Object} row JSON object to be converted in a CSV row
	       */
	
	    }, {
	      key: "preprocessRow",
	      value: function preprocessRow(row) {
	        return this.opts.transforms.reduce(function (rows, transform) {
	          return rows.map(function (row) {
	            return transform(row);
	          }).reduce(flattenReducer$1, []);
	        }, [row]);
	      }
	      /**
	       * Create the content of a specific CSV row
	       *
	       * @param {Object} row JSON object to be converted in a CSV row
	       * @returns {String} CSV string (row)
	       */
	
	    }, {
	      key: "processRow",
	      value: function processRow(row) {
	        var _this3 = this;
	
	        if (!row) {
	          return undefined;
	        }
	
	        var processedRow = this.opts.fields.map(function (fieldInfo) {
	          return _this3.processCell(row, fieldInfo);
	        });
	
	        if (!this.opts.includeEmptyRows && processedRow.every(function (field) {
	          return field === undefined;
	        })) {
	          return undefined;
	        }
	
	        return fastJoin$1(processedRow, this.opts.delimiter);
	      }
	      /**
	       * Create the content of a specfic CSV row cell
	       *
	       * @param {Object} row JSON object representing the  CSV row that the cell belongs to
	       * @param {FieldInfo} fieldInfo Details of the field to process to be a CSV cell
	       * @returns {String} CSV string (cell)
	       */
	
	    }, {
	      key: "processCell",
	      value: function processCell(row, fieldInfo) {
	        return this.processValue(fieldInfo.value(row));
	      }
	      /**
	       * Create the content of a specfic CSV row cell
	       *
	       * @param {Any} value Value to be included in a CSV cell
	       * @returns {String} Value stringified and processed
	       */
	
	    }, {
	      key: "processValue",
	      value: function processValue(value) {
	        if (value === null || value === undefined) {
	          return undefined;
	        }
	
	        var valueType = _typeof(value);
	
	        if (valueType !== 'boolean' && valueType !== 'number' && valueType !== 'string') {
	          value = JSON.stringify(value);
	
	          if (value === undefined) {
	            return undefined;
	          }
	
	          if (value[0] === '"') {
	            value = value.replace(/^"(.+)"$/, '$1');
	          }
	        }
	
	        if (typeof value === 'string') {
	          if (this.opts.excelStrings) {
	            if (value.includes(this.opts.quote)) {
	              value = value.replace(new RegExp(this.opts.quote, 'g'), "".concat(this.opts.escapedQuote).concat(this.opts.escapedQuote));
	            }
	
	            value = "\"=\"\"".concat(value, "\"\"\"");
	          } else {
	            if (value.includes(this.opts.quote)) {
	              value = value.replace(new RegExp(this.opts.quote, 'g'), this.opts.escapedQuote);
	            }
	
	            value = "".concat(this.opts.quote).concat(value).concat(this.opts.quote);
	          }
	        }
	
	        return value;
	      }
	    }]);
	
	    return JSON2CSVBase;
	  }();
	
	  var JSON2CSVBase_1 = JSON2CSVBase;
	
	  var fastJoin$2 = utils.fastJoin,
	      flattenReducer$2 = utils.flattenReducer;
	
	  var JSON2CSVParser =
	  /*#__PURE__*/
	  function (_JSON2CSVBase) {
	    _inherits(JSON2CSVParser, _JSON2CSVBase);
	
	    function JSON2CSVParser(opts) {
	      var _this;
	
	      _classCallCheck(this, JSON2CSVParser);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVParser).call(this, opts));
	
	      if (_this.opts.fields) {
	        _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);
	      }
	
	      return _this;
	    }
	    /**
	     * Main function that converts json to csv.
	     *
	     * @param {Array|Object} data Array of JSON objects to be converted to CSV
	     * @returns {String} The CSV formated data as a string
	     */
	
	
	    _createClass(JSON2CSVParser, [{
	      key: "parse",
	      value: function parse(data) {
	        var processedData = this.preprocessData(data);
	
	        if (!this.opts.fields) {
	          this.opts.fields = processedData.reduce(function (fields, item) {
	            Object.keys(item).forEach(function (field) {
	              if (!fields.includes(field)) {
	                fields.push(field);
	              }
	            });
	            return fields;
	          }, []);
	          this.opts.fields = this.preprocessFieldsInfo(this.opts.fields);
	        }
	
	        var header = this.opts.header ? this.getHeader() : '';
	        var rows = this.processData(processedData);
	        var csv = (this.opts.withBOM ? "\uFEFF" : '') + header + (header && rows ? this.opts.eol : '') + rows;
	        return csv;
	      }
	      /**
	       * Preprocess the data according to the give opts (unwind, flatten, etc.)
	        and calculate the fields and field names if they are not provided.
	       *
	       * @param {Array|Object} data Array or object to be converted to CSV
	       */
	
	    }, {
	      key: "preprocessData",
	      value: function preprocessData(data) {
	        var _this2 = this;
	
	        var processedData = Array.isArray(data) ? data : [data];
	
	        if (!this.opts.fields && (processedData.length === 0 || _typeof(processedData[0]) !== 'object')) {
	          throw new Error('Data should not be empty or the "fields" option should be included');
	        }
	
	        if (this.opts.transforms.length === 0) return processedData;
	        return processedData.map(function (row) {
	          return _this2.preprocessRow(row);
	        }).reduce(flattenReducer$2, []);
	      }
	      /**
	       * Create the content row by row below the header
	       *
	       * @param {Array} data Array of JSON objects to be converted to CSV
	       * @returns {String} CSV string (body)
	       */
	
	    }, {
	      key: "processData",
	      value: function processData(data) {
	        var _this3 = this;
	
	        return fastJoin$2(data.map(function (row) {
	          return _this3.processRow(row);
	        }).filter(function (row) {
	          return row;
	        }), // Filter empty rows
	        this.opts.eol);
	      }
	    }]);
	
	    return JSON2CSVParser;
	  }(JSON2CSVBase_1);
	
	  var JSON2CSVParser_1 = JSON2CSVParser;
	
	  /*global Buffer*/
	  // Named constants with unique integer values
	  var C = {};
	  // Tokens
	  var LEFT_BRACE    = C.LEFT_BRACE    = 0x1;
	  var RIGHT_BRACE   = C.RIGHT_BRACE   = 0x2;
	  var LEFT_BRACKET  = C.LEFT_BRACKET  = 0x3;
	  var RIGHT_BRACKET = C.RIGHT_BRACKET = 0x4;
	  var COLON         = C.COLON         = 0x5;
	  var COMMA         = C.COMMA         = 0x6;
	  var TRUE          = C.TRUE          = 0x7;
	  var FALSE         = C.FALSE         = 0x8;
	  var NULL          = C.NULL          = 0x9;
	  var STRING        = C.STRING        = 0xa;
	  var NUMBER        = C.NUMBER        = 0xb;
	  // Tokenizer States
	  var START   = C.START   = 0x11;
	  var STOP    = C.STOP    = 0x12;
	  var TRUE1   = C.TRUE1   = 0x21;
	  var TRUE2   = C.TRUE2   = 0x22;
	  var TRUE3   = C.TRUE3   = 0x23;
	  var FALSE1  = C.FALSE1  = 0x31;
	  var FALSE2  = C.FALSE2  = 0x32;
	  var FALSE3  = C.FALSE3  = 0x33;
	  var FALSE4  = C.FALSE4  = 0x34;
	  var NULL1   = C.NULL1   = 0x41;
	  var NULL2   = C.NULL2   = 0x42;
	  var NULL3   = C.NULL3   = 0x43;
	  var NUMBER1 = C.NUMBER1 = 0x51;
	  var NUMBER3 = C.NUMBER3 = 0x53;
	  var STRING1 = C.STRING1 = 0x61;
	  var STRING2 = C.STRING2 = 0x62;
	  var STRING3 = C.STRING3 = 0x63;
	  var STRING4 = C.STRING4 = 0x64;
	  var STRING5 = C.STRING5 = 0x65;
	  var STRING6 = C.STRING6 = 0x66;
	  // Parser States
	  var VALUE   = C.VALUE   = 0x71;
	  var KEY     = C.KEY     = 0x72;
	  // Parser Modes
	  var OBJECT  = C.OBJECT  = 0x81;
	  var ARRAY   = C.ARRAY   = 0x82;
	  // Character constants
	  var BACK_SLASH =      "\\".charCodeAt(0);
	  var FORWARD_SLASH =   "\/".charCodeAt(0);
	  var BACKSPACE =       "\b".charCodeAt(0);
	  var FORM_FEED =       "\f".charCodeAt(0);
	  var NEWLINE =         "\n".charCodeAt(0);
	  var CARRIAGE_RETURN = "\r".charCodeAt(0);
	  var TAB =             "\t".charCodeAt(0);
	
	  var STRING_BUFFER_SIZE = 64 * 1024;
	
	  function Parser() {
	    this.tState = START;
	    this.value = undefined;
	
	    this.string = undefined; // string data
	    this.stringBuffer = Buffer.alloc ? Buffer.alloc(STRING_BUFFER_SIZE) : new Buffer(STRING_BUFFER_SIZE);
	    this.stringBufferOffset = 0;
	    this.unicode = undefined; // unicode escapes
	    this.highSurrogate = undefined;
	
	    this.key = undefined;
	    this.mode = undefined;
	    this.stack = [];
	    this.state = VALUE;
	    this.bytes_remaining = 0; // number of bytes remaining in multi byte utf8 char to read after split boundary
	    this.bytes_in_sequence = 0; // bytes in multi byte utf8 char to read
	    this.temp_buffs = { "2": new Buffer(2), "3": new Buffer(3), "4": new Buffer(4) }; // for rebuilding chars split before boundary is reached
	
	    // Stream offset
	    this.offset = -1;
	  }
	
	  // Slow code to string converter (only used when throwing syntax errors)
	  Parser.toknam = function (code) {
	    var keys = Object.keys(C);
	    for (var i = 0, l = keys.length; i < l; i++) {
	      var key = keys[i];
	      if (C[key] === code) { return key; }
	    }
	    return code && ("0x" + code.toString(16));
	  };
	
	  var proto = Parser.prototype;
	  proto.onError = function (err) { throw err; };
	  proto.charError = function (buffer, i) {
	    this.tState = STOP;
	    this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(buffer[i])) + " at position " + i + " in state " + Parser.toknam(this.tState)));
	  };
	  proto.appendStringChar = function (char) {
	    if (this.stringBufferOffset >= STRING_BUFFER_SIZE) {
	      this.string += this.stringBuffer.toString('utf8');
	      this.stringBufferOffset = 0;
	    }
	
	    this.stringBuffer[this.stringBufferOffset++] = char;
	  };
	  proto.appendStringBuf = function (buf, start, end) {
	    var size = buf.length;
	    if (typeof start === 'number') {
	      if (typeof end === 'number') {
	        if (end < 0) {
	          // adding a negative end decreeses the size
	          size = buf.length - start + end;
	        } else {
	          size = end - start;
	        }
	      } else {
	        size = buf.length - start;
	      }
	    }
	
	    if (size < 0) {
	      size = 0;
	    }
	
	    if (this.stringBufferOffset + size > STRING_BUFFER_SIZE) {
	      this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
	      this.stringBufferOffset = 0;
	    }
	
	    buf.copy(this.stringBuffer, this.stringBufferOffset, start, end);
	    this.stringBufferOffset += size;
	  };
	  proto.write = function (buffer) {
	    if (typeof buffer === "string") buffer = new Buffer(buffer);
	    var n;
	    for (var i = 0, l = buffer.length; i < l; i++) {
	      if (this.tState === START){
	        n = buffer[i];
	        this.offset++;
	        if(n === 0x7b){ this.onToken(LEFT_BRACE, "{"); // {
	        }else if(n === 0x7d){ this.onToken(RIGHT_BRACE, "}"); // }
	        }else if(n === 0x5b){ this.onToken(LEFT_BRACKET, "["); // [
	        }else if(n === 0x5d){ this.onToken(RIGHT_BRACKET, "]"); // ]
	        }else if(n === 0x3a){ this.onToken(COLON, ":");  // :
	        }else if(n === 0x2c){ this.onToken(COMMA, ","); // ,
	        }else if(n === 0x74){ this.tState = TRUE1;  // t
	        }else if(n === 0x66){ this.tState = FALSE1;  // f
	        }else if(n === 0x6e){ this.tState = NULL1; // n
	        }else if(n === 0x22){ // "
	          this.string = "";
	          this.stringBufferOffset = 0;
	          this.tState = STRING1;
	        }else if(n === 0x2d){ this.string = "-"; this.tState = NUMBER1; // -
	        }else{
	          if (n >= 0x30 && n < 0x40) { // 1-9
	            this.string = String.fromCharCode(n); this.tState = NUMBER3;
	          } else if (n === 0x20 || n === 0x09 || n === 0x0a || n === 0x0d) ; else {
	            return this.charError(buffer, i);
	          }
	        }
	      }else if (this.tState === STRING1){ // After open quote
	        n = buffer[i]; // get current byte from buffer
	        // check for carry over of a multi byte char split between data chunks
	        // & fill temp buffer it with start of this data chunk up to the boundary limit set in the last iteration
	        if (this.bytes_remaining > 0) {
	          for (var j = 0; j < this.bytes_remaining; j++) {
	            this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + j] = buffer[j];
	          }
	
	          this.appendStringBuf(this.temp_buffs[this.bytes_in_sequence]);
	          this.bytes_in_sequence = this.bytes_remaining = 0;
	          i = i + j - 1;
	        } else if (this.bytes_remaining === 0 && n >= 128) { // else if no remainder bytes carried over, parse multi byte (>=128) chars one at a time
	          if (n <= 193 || n > 244) {
	            return this.onError(new Error("Invalid UTF-8 character at position " + i + " in state " + Parser.toknam(this.tState)));
	          }
	          if ((n >= 194) && (n <= 223)) this.bytes_in_sequence = 2;
	          if ((n >= 224) && (n <= 239)) this.bytes_in_sequence = 3;
	          if ((n >= 240) && (n <= 244)) this.bytes_in_sequence = 4;
	          if ((this.bytes_in_sequence + i) > buffer.length) { // if bytes needed to complete char fall outside buffer length, we have a boundary split
	            for (var k = 0; k <= (buffer.length - 1 - i); k++) {
	              this.temp_buffs[this.bytes_in_sequence][k] = buffer[i + k]; // fill temp buffer of correct size with bytes available in this chunk
	            }
	            this.bytes_remaining = (i + this.bytes_in_sequence) - buffer.length;
	            i = buffer.length - 1;
	          } else {
	            this.appendStringBuf(buffer, i, i + this.bytes_in_sequence);
	            i = i + this.bytes_in_sequence - 1;
	          }
	        } else if (n === 0x22) {
	          this.tState = START;
	          this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
	          this.stringBufferOffset = 0;
	          this.onToken(STRING, this.string);
	          this.offset += Buffer.byteLength(this.string, 'utf8') + 1;
	          this.string = undefined;
	        }
	        else if (n === 0x5c) {
	          this.tState = STRING2;
	        }
	        else if (n >= 0x20) { this.appendStringChar(n); }
	        else {
	            return this.charError(buffer, i);
	        }
	      }else if (this.tState === STRING2){ // After backslash
	        n = buffer[i];
	        if(n === 0x22){ this.appendStringChar(n); this.tState = STRING1;
	        }else if(n === 0x5c){ this.appendStringChar(BACK_SLASH); this.tState = STRING1;
	        }else if(n === 0x2f){ this.appendStringChar(FORWARD_SLASH); this.tState = STRING1;
	        }else if(n === 0x62){ this.appendStringChar(BACKSPACE); this.tState = STRING1;
	        }else if(n === 0x66){ this.appendStringChar(FORM_FEED); this.tState = STRING1;
	        }else if(n === 0x6e){ this.appendStringChar(NEWLINE); this.tState = STRING1;
	        }else if(n === 0x72){ this.appendStringChar(CARRIAGE_RETURN); this.tState = STRING1;
	        }else if(n === 0x74){ this.appendStringChar(TAB); this.tState = STRING1;
	        }else if(n === 0x75){ this.unicode = ""; this.tState = STRING3;
	        }else{
	          return this.charError(buffer, i);
	        }
	      }else if (this.tState === STRING3 || this.tState === STRING4 || this.tState === STRING5 || this.tState === STRING6){ // unicode hex codes
	        n = buffer[i];
	        // 0-9 A-F a-f
	        if ((n >= 0x30 && n < 0x40) || (n > 0x40 && n <= 0x46) || (n > 0x60 && n <= 0x66)) {
	          this.unicode += String.fromCharCode(n);
	          if (this.tState++ === STRING6) {
	            var intVal = parseInt(this.unicode, 16);
	            this.unicode = undefined;
	            if (this.highSurrogate !== undefined && intVal >= 0xDC00 && intVal < (0xDFFF + 1)) { //<56320,57343> - lowSurrogate
	              this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate, intVal)));
	              this.highSurrogate = undefined;
	            } else if (this.highSurrogate === undefined && intVal >= 0xD800 && intVal < (0xDBFF + 1)) { //<55296,56319> - highSurrogate
	              this.highSurrogate = intVal;
	            } else {
	              if (this.highSurrogate !== undefined) {
	                this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate)));
	                this.highSurrogate = undefined;
	              }
	              this.appendStringBuf(new Buffer(String.fromCharCode(intVal)));
	            }
	            this.tState = STRING1;
	          }
	        } else {
	          return this.charError(buffer, i);
	        }
	      } else if (this.tState === NUMBER1 || this.tState === NUMBER3) {
	          n = buffer[i];
	
	          switch (n) {
	            case 0x30: // 0
	            case 0x31: // 1
	            case 0x32: // 2
	            case 0x33: // 3
	            case 0x34: // 4
	            case 0x35: // 5
	            case 0x36: // 6
	            case 0x37: // 7
	            case 0x38: // 8
	            case 0x39: // 9
	            case 0x2e: // .
	            case 0x65: // e
	            case 0x45: // E
	            case 0x2b: // +
	            case 0x2d: // -
	              this.string += String.fromCharCode(n);
	              this.tState = NUMBER3;
	              break;
	            default:
	              this.tState = START;
	              var result = Number(this.string);
	
	              if (isNaN(result)){
	                return this.charError(buffer, i);
	              }
	
	              if ((this.string.match(/[0-9]+/) == this.string) && (result.toString() != this.string)) {
	                // Long string of digits which is an ID string and not valid and/or safe JavaScript integer Number
	                this.onToken(STRING, this.string);
	              } else {
	                this.onToken(NUMBER, result);
	              }
	
	              this.offset += this.string.length - 1;
	              this.string = undefined;
	              i--;
	              break;
	          }
	      }else if (this.tState === TRUE1){ // r
	        if (buffer[i] === 0x72) { this.tState = TRUE2; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === TRUE2){ // u
	        if (buffer[i] === 0x75) { this.tState = TRUE3; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === TRUE3){ // e
	        if (buffer[i] === 0x65) { this.tState = START; this.onToken(TRUE, true); this.offset+= 3; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === FALSE1){ // a
	        if (buffer[i] === 0x61) { this.tState = FALSE2; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === FALSE2){ // l
	        if (buffer[i] === 0x6c) { this.tState = FALSE3; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === FALSE3){ // s
	        if (buffer[i] === 0x73) { this.tState = FALSE4; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === FALSE4){ // e
	        if (buffer[i] === 0x65) { this.tState = START; this.onToken(FALSE, false); this.offset+= 4; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === NULL1){ // u
	        if (buffer[i] === 0x75) { this.tState = NULL2; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === NULL2){ // l
	        if (buffer[i] === 0x6c) { this.tState = NULL3; }
	        else { return this.charError(buffer, i); }
	      }else if (this.tState === NULL3){ // l
	        if (buffer[i] === 0x6c) { this.tState = START; this.onToken(NULL, null); this.offset += 3; }
	        else { return this.charError(buffer, i); }
	      }
	    }
	  };
	  proto.onToken = function (token, value) {
	    // Override this to get events
	  };
	
	  proto.parseError = function (token, value) {
	    this.tState = STOP;
	    this.onError(new Error("Unexpected " + Parser.toknam(token) + (value ? ("(" + JSON.stringify(value) + ")") : "") + " in state " + Parser.toknam(this.state)));
	  };
	  proto.push = function () {
	    this.stack.push({value: this.value, key: this.key, mode: this.mode});
	  };
	  proto.pop = function () {
	    var value = this.value;
	    var parent = this.stack.pop();
	    this.value = parent.value;
	    this.key = parent.key;
	    this.mode = parent.mode;
	    this.emit(value);
	    if (!this.mode) { this.state = VALUE; }
	  };
	  proto.emit = function (value) {
	    if (this.mode) { this.state = COMMA; }
	    this.onValue(value);
	  };
	  proto.onValue = function (value) {
	    // Override me
	  };
	  proto.onToken = function (token, value) {
	    if(this.state === VALUE){
	      if(token === STRING || token === NUMBER || token === TRUE || token === FALSE || token === NULL){
	        if (this.value) {
	          this.value[this.key] = value;
	        }
	        this.emit(value);
	      }else if(token === LEFT_BRACE){
	        this.push();
	        if (this.value) {
	          this.value = this.value[this.key] = {};
	        } else {
	          this.value = {};
	        }
	        this.key = undefined;
	        this.state = KEY;
	        this.mode = OBJECT;
	      }else if(token === LEFT_BRACKET){
	        this.push();
	        if (this.value) {
	          this.value = this.value[this.key] = [];
	        } else {
	          this.value = [];
	        }
	        this.key = 0;
	        this.mode = ARRAY;
	        this.state = VALUE;
	      }else if(token === RIGHT_BRACE){
	        if (this.mode === OBJECT) {
	          this.pop();
	        } else {
	          return this.parseError(token, value);
	        }
	      }else if(token === RIGHT_BRACKET){
	        if (this.mode === ARRAY) {
	          this.pop();
	        } else {
	          return this.parseError(token, value);
	        }
	      }else{
	        return this.parseError(token, value);
	      }
	    }else if(this.state === KEY){
	      if (token === STRING) {
	        this.key = value;
	        this.state = COLON;
	      } else if (token === RIGHT_BRACE) {
	        this.pop();
	      } else {
	        return this.parseError(token, value);
	      }
	    }else if(this.state === COLON){
	      if (token === COLON) { this.state = VALUE; }
	      else { return this.parseError(token, value); }
	    }else if(this.state === COMMA){
	      if (token === COMMA) {
	        if (this.mode === ARRAY) { this.key++; this.state = VALUE; }
	        else if (this.mode === OBJECT) { this.state = KEY; }
	
	      } else if (token === RIGHT_BRACKET && this.mode === ARRAY || token === RIGHT_BRACE && this.mode === OBJECT) {
	        this.pop();
	      } else {
	        return this.parseError(token, value);
	      }
	    }else{
	      return this.parseError(token, value);
	    }
	  };
	
	  Parser.C = C;
	
	  var jsonparse = Parser;
	
	  var Transform$1 = Stream.Transform;
	
	  var JSON2CSVTransform =
	  /*#__PURE__*/
	  function (_Transform) {
	    _inherits(JSON2CSVTransform, _Transform);
	
	    function JSON2CSVTransform(opts, transformOpts) {
	      var _this;
	
	      _classCallCheck(this, JSON2CSVTransform);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVTransform).call(this, transformOpts)); // Inherit methods from JSON2CSVBase since extends doesn't
	      // allow multiple inheritance and manually preprocess opts
	
	      Object.getOwnPropertyNames(JSON2CSVBase_1.prototype).forEach(function (key) {
	        return _this[key] = JSON2CSVBase_1.prototype[key];
	      });
	      _this.opts = _this.preprocessOpts(opts);
	      _this._data = '';
	      _this._hasWritten = false;
	
	      if (_this._readableState.objectMode) {
	        _this.initObjectModeParse();
	      } else if (_this.opts.ndjson) {
	        _this.initNDJSONParse();
	      } else {
	        _this.initJSONParser();
	      }
	
	      if (_this.opts.withBOM) {
	        _this.push("\uFEFF");
	      }
	
	      if (_this.opts.fields) {
	        _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);
	
	        _this.pushHeader();
	      }
	
	      return _this;
	    }
	    /**
	     * Init the transform with a parser to process data in object mode.
	     * It receives JSON objects one by one and send them to `pushLine for processing.
	     */
	
	
	    _createClass(JSON2CSVTransform, [{
	      key: "initObjectModeParse",
	      value: function initObjectModeParse() {
	        var transform = this;
	        this.parser = {
	          write: function write(line) {
	            transform.pushLine(line);
	          },
	          getPendingData: function getPendingData() {
	            return undefined;
	          }
	        };
	      }
	      /**
	       * Init the transform with a parser to process NDJSON data.
	       * It maintains a buffer of received data, parses each line
	       * as JSON and send it to `pushLine for processing.
	       */
	
	    }, {
	      key: "initNDJSONParse",
	      value: function initNDJSONParse() {
	        var transform = this;
	        this.parser = {
	          _data: '',
	          write: function write(chunk) {
	            this._data += chunk.toString();
	
	            var lines = this._data.split('\n').map(function (line) {
	              return line.trim();
	            }).filter(function (line) {
	              return line !== '';
	            });
	
	            var pendingData = false;
	            lines.forEach(function (line, i) {
	              try {
	                transform.pushLine(JSON.parse(line));
	              } catch (e) {
	                if (i === lines.length - 1) {
	                  pendingData = true;
	                } else {
	                  e.message = "Invalid JSON (".concat(line, ")");
	                  transform.emit('error', e);
	                }
	              }
	            });
	            this._data = pendingData ? this._data.slice(this._data.lastIndexOf('\n')) : '';
	          },
	          getPendingData: function getPendingData() {
	            return this._data;
	          }
	        };
	      }
	      /**
	       * Init the transform with a parser to process JSON data.
	       * It maintains a buffer of received data, parses each as JSON 
	       * item if the data is an array or the data itself otherwise
	       * and send it to `pushLine` for processing.
	       */
	
	    }, {
	      key: "initJSONParser",
	      value: function initJSONParser() {
	        var transform = this;
	        this.parser = new jsonparse();
	
	        this.parser.onValue = function (value) {
	          if (this.stack.length !== this.depthToEmit) return;
	          transform.pushLine(value);
	        };
	
	        this.parser._onToken = this.parser.onToken;
	
	        this.parser.onToken = function (token, value) {
	          transform.parser._onToken(token, value);
	
	          if (this.stack.length === 0 && !transform.opts.fields && this.mode !== jsonparse.C.ARRAY && this.mode !== jsonparse.C.OBJECT) {
	            this.onError(new Error('Data should not be empty or the "fields" option should be included'));
	          }
	
	          if (this.stack.length === 1) {
	            if (this.depthToEmit === undefined) {
	              // If Array emit its content, else emit itself
	              this.depthToEmit = this.mode === jsonparse.C.ARRAY ? 1 : 0;
	            }
	
	            if (this.depthToEmit !== 0 && this.stack.length === 1) {
	              // No need to store the whole root array in memory
	              this.value = undefined;
	            }
	          }
	        };
	
	        this.parser.getPendingData = function () {
	          return this.value;
	        };
	
	        this.parser.onError = function (err) {
	          if (err.message.includes('Unexpected')) {
	            err.message = "Invalid JSON (".concat(err.message, ")");
	          }
	
	          transform.emit('error', err);
	        };
	      }
	      /**
	       * Main function that send data to the parse to be processed.
	       *
	       * @param {Buffer} chunk Incoming data
	       * @param {String} encoding Encoding of the incoming data. Defaults to 'utf8'
	       * @param {Function} done Called when the proceesing of the supplied chunk is done
	       */
	
	    }, {
	      key: "_transform",
	      value: function _transform(chunk, encoding, done) {
	        this.parser.write(chunk);
	        done();
	      }
	    }, {
	      key: "_flush",
	      value: function _flush(done) {
	        if (this.parser.getPendingData()) {
	          done(new Error('Invalid data received from stdin', this.parser.getPendingData()));
	        }
	
	        done();
	      }
	      /**
	       * Generate the csv header and pushes it downstream.
	       */
	
	    }, {
	      key: "pushHeader",
	      value: function pushHeader() {
	        if (this.opts.header) {
	          var header = this.getHeader();
	          this.emit('header', header);
	          this.push(header);
	          this._hasWritten = true;
	        }
	      }
	      /**
	       * Transforms an incoming json data to csv and pushes it downstream.
	       *
	       * @param {Object} data JSON object to be converted in a CSV row
	       */
	
	    }, {
	      key: "pushLine",
	      value: function pushLine(data) {
	        var _this2 = this;
	
	        var processedData = this.preprocessRow(data);
	
	        if (!this._hasWritten) {
	          this.opts.fields = this.opts.fields || this.preprocessFieldsInfo(Object.keys(processedData[0]));
	          this.pushHeader();
	        }
	
	        processedData.forEach(function (row) {
	          var line = _this2.processRow(row, _this2.opts);
	
	          if (line === undefined) return;
	
	          _this2.emit('line', line);
	
	          _this2.push(_this2._hasWritten ? _this2.opts.eol + line : line);
	
	          _this2._hasWritten = true;
	        });
	      }
	    }]);
	
	    return JSON2CSVTransform;
	  }(Transform$1);
	
	  var JSON2CSVTransform_1 = JSON2CSVTransform;
	
	  var Transform$2 = Stream.Transform;
	  var fastJoin$3 = utils.fastJoin;
	
	  var JSON2CSVAsyncParser =
	  /*#__PURE__*/
	  function () {
	    function JSON2CSVAsyncParser(opts, transformOpts) {
	      _classCallCheck(this, JSON2CSVAsyncParser);
	
	      this.input = new Transform$2(transformOpts);
	
	      this.input._read = function () {};
	
	      this.transform = new JSON2CSVTransform_1(opts, transformOpts);
	      this.processor = this.input.pipe(this.transform);
	    }
	
	    _createClass(JSON2CSVAsyncParser, [{
	      key: "fromInput",
	      value: function fromInput(input) {
	        if (this._input) {
	          throw new Error('Async parser already has an input.');
	        }
	
	        this._input = input;
	        this.input = this._input.pipe(this.processor);
	        return this;
	      }
	    }, {
	      key: "throughTransform",
	      value: function throughTransform(transform) {
	        if (this._output) {
	          throw new Error('Can\'t add transforms once an output has been added.');
	        }
	
	        this.processor = this.processor.pipe(transform);
	        return this;
	      }
	    }, {
	      key: "toOutput",
	      value: function toOutput(output) {
	        if (this._output) {
	          throw new Error('Async parser already has an output.');
	        }
	
	        this._output = output;
	        this.processor = this.processor.pipe(output);
	        return this;
	      }
	    }, {
	      key: "promise",
	      value: function promise() {
	        var _this = this;
	
	        var returnCSV = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        return new Promise(function (resolve, reject) {
	          if (!returnCSV) {
	            _this.processor.on('finish', function () {
	              return resolve();
	            }).on('error', function (err) {
	              return reject(err);
	            });
	
	            return;
	          }
	
	          var csvBuffer = [];
	
	          _this.processor.on('data', function (chunk) {
	            return csvBuffer.push(chunk.toString());
	          }).on('finish', function () {
	            return resolve(fastJoin$3(csvBuffer, ''));
	          }).on('error', function (err) {
	            return reject(err);
	          });
	        });
	      }
	    }]);
	
	    return JSON2CSVAsyncParser;
	  }();
	
	  var JSON2CSVAsyncParser_1 = JSON2CSVAsyncParser;
	
	  /**
	   * Performs the flattening of a data row recursively
	   *
	   * @param {String} separator Separator to be used as the flattened field name
	   * @returns {Object => Object} Flattened object
	   */
	  function flatten() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$objects = _ref.objects,
	        objects = _ref$objects === void 0 ? true : _ref$objects,
	        _ref$arrays = _ref.arrays,
	        arrays = _ref$arrays === void 0 ? false : _ref$arrays,
	        _ref$separator = _ref.separator,
	        separator = _ref$separator === void 0 ? '.' : _ref$separator;
	
	    function step(obj, flatDataRow, currentPath) {
	      Object.keys(obj).forEach(function (key) {
	        var newPath = currentPath ? "".concat(currentPath).concat(separator).concat(key) : key;
	        var value = obj[key];
	
	        if (objects && _typeof(value) === 'object' && value !== null && !Array.isArray(value) && Object.prototype.toString.call(value.toJSON) !== '[object Function]' && Object.keys(value).length) {
	          step(value, flatDataRow, newPath);
	          return;
	        }
	
	        if (arrays && Array.isArray(value)) {
	          step(value, flatDataRow, newPath);
	          return;
	        }
	
	        flatDataRow[newPath] = value;
	      });
	      return flatDataRow;
	    }
	
	    return function (dataRow) {
	      return step(dataRow, {});
	    };
	  }
	
	  var flatten_1 = flatten;
	
	  var setProp$1 = utils.setProp,
	      unsetProp$1 = utils.unsetProp,
	      flattenReducer$3 = utils.flattenReducer;
	
	  function getUnwindablePaths(obj, currentPath) {
	    return Object.keys(obj).reduce(function (unwindablePaths, key) {
	      var newPath = currentPath ? "".concat(currentPath, ".").concat(key) : key;
	      var value = obj[key];
	
	      if (_typeof(value) === 'object' && value !== null && !Array.isArray(value) && Object.prototype.toString.call(value.toJSON) !== '[object Function]' && Object.keys(value).length) {
	        unwindablePaths = unwindablePaths.concat(getUnwindablePaths(value, newPath));
	      } else if (Array.isArray(value)) {
	        unwindablePaths.push(newPath);
	        unwindablePaths = unwindablePaths.concat(value.map(function (arrObj) {
	          return getUnwindablePaths(arrObj, newPath);
	        }).reduce(flattenReducer$3, []).filter(function (item, index, arr) {
	          return arr.indexOf(item) !== index;
	        }));
	      }
	
	      return unwindablePaths;
	    }, []);
	  }
	  /**
	   * Performs the unwind recursively in specified sequence
	   *
	   * @param {String[]} unwindPaths The paths as strings to be used to deconstruct the array
	   * @returns {Object => Array} Array of objects containing all rows after unwind of chosen paths
	  */
	
	
	  function unwind() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$paths = _ref.paths,
	        paths = _ref$paths === void 0 ? undefined : _ref$paths,
	        _ref$blankOut = _ref.blankOut,
	        blankOut = _ref$blankOut === void 0 ? false : _ref$blankOut;
	
	    function unwindReducer(rows, unwindPath) {
	      return rows.map(function (row) {
	        var unwindArray = lodash_get(row, unwindPath);
	
	        if (!Array.isArray(unwindArray)) {
	          return row;
	        }
	
	        if (!unwindArray.length) {
	          return unsetProp$1(row, unwindPath);
	        }
	
	        return unwindArray.map(function (unwindRow, index) {
	          var clonedRow = blankOut && index > 0 ? {} : row;
	          return setProp$1(clonedRow, unwindPath, unwindRow);
	        });
	      }).reduce(flattenReducer$3, []);
	    }
	
	    paths = Array.isArray(paths) ? paths : paths ? [paths] : undefined;
	    return function (dataRow) {
	      return (paths || getUnwindablePaths(dataRow)).reduce(unwindReducer, [dataRow]);
	    };
	  }
	
	  var unwind_1 = unwind;
	
	  var Readable$1 = Stream.Readable;
	  var Parser$1 = JSON2CSVParser_1;
	  var AsyncParser = JSON2CSVAsyncParser_1;
	  var Transform$3 = JSON2CSVTransform_1; // Convenience method to keep the API similar to version 3.X
	
	  var parse = function parse(data, opts) {
	    return new JSON2CSVParser_1(opts).parse(data);
	  };
	
	  var parseAsync = function parseAsync(data, opts, transformOpts) {
	    try {
	      if (!(data instanceof Readable$1)) {
	        transformOpts = Object.assign({}, transformOpts, {
	          objectMode: true
	        });
	      }
	
	      var asyncParser = new JSON2CSVAsyncParser_1(opts, transformOpts);
	      var promise = asyncParser.promise();
	
	      if (Array.isArray(data)) {
	        data.forEach(function (item) {
	          return asyncParser.input.push(item);
	        });
	        asyncParser.input.push(null);
	      } else if (data instanceof Readable$1) {
	        asyncParser.fromInput(data);
	      } else {
	        asyncParser.input.push(data);
	        asyncParser.input.push(null);
	      }
	
	      return promise;
	    } catch (err) {
	      return Promise.reject(err);
	    }
	  };
	
	  var transforms = {
	    flatten: flatten_1,
	    unwind: unwind_1
	  };
	  var json2csv = {
	    Parser: Parser$1,
	    AsyncParser: AsyncParser,
	    Transform: Transform$3,
	    parse: parse,
	    parseAsync: parseAsync,
	    transforms: transforms
	  };
	
	  exports.AsyncParser = AsyncParser;
	  exports.Parser = Parser$1;
	  exports.Transform = Transform$3;
	  exports.default = json2csv;
	  exports.parse = parse;
	  exports.parseAsync = parseAsync;
	  exports.transforms = transforms;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(101).Buffer))

/***/ },
/* 116 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Context = exports.Provider = void 0;
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var hoist_non_react_statics_1 = (0, tslib_1.__importDefault)(__webpack_require__(212));
	var utils_1 = __webpack_require__(64);
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	// TODO: We should provide initial value here
	var IntlContext = React.createContext(null);
	var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
	exports.Provider = IntlProvider;
	exports.Context = IntlContext;
	function injectIntl(WrappedComponent, options) {
	    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
	    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
	        var _a;
	        if (enforceContext) {
	            (0, utils_1.invariantIntlContext)(intl);
	        }
	        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
	        return (React.createElement(WrappedComponent, (0, tslib_1.__assign)({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
	    })); };
	    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
	    WithIntl.WrappedComponent = WrappedComponent;
	    if (forwardRef) {
	        return (0, hoist_non_react_statics_1.default)(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, (0, tslib_1.__assign)({}, props, { forwardedRef: ref }))); }), WrappedComponent);
	    }
	    return (0, hoist_non_react_statics_1.default)(WithIntl, WrappedComponent);
	}
	exports.default = injectIntl;


/***/ },
/* 118 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CanonicalizeLocaleList = void 0;
	/**
	 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
	 * @param locales
	 */
	function CanonicalizeLocaleList(locales) {
	    // TODO
	    return Intl.getCanonicalLocales(locales);
	}
	exports.CanonicalizeLocaleList = CanonicalizeLocaleList;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CoerceOptionsToObject = void 0;
	var _262_1 = __webpack_require__(31);
	/**
	 * https://tc39.es/ecma402/#sec-coerceoptionstoobject
	 * @param options
	 * @returns
	 */
	function CoerceOptionsToObject(options) {
	    if (typeof options === 'undefined') {
	        return Object.create(null);
	    }
	    return (0, _262_1.ToObject)(options);
	}
	exports.CoerceOptionsToObject = CoerceOptionsToObject;


/***/ },
/* 120 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DefaultNumberOption = void 0;
	function DefaultNumberOption(val, min, max, fallback) {
	    if (val !== undefined) {
	        val = Number(val);
	        if (isNaN(val) || val < min || val > max) {
	            throw new RangeError("".concat(val, " is outside of range [").concat(min, ", ").concat(max, "]"));
	        }
	        return Math.floor(val);
	    }
	    return fallback;
	}
	exports.DefaultNumberOption = DefaultNumberOption;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * https://tc39.es/ecma402/#sec-getnumberoption
	 * @param options
	 * @param property
	 * @param min
	 * @param max
	 * @param fallback
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GetNumberOption = void 0;
	var DefaultNumberOption_1 = __webpack_require__(120);
	function GetNumberOption(options, property, minimum, maximum, fallback) {
	    var val = options[property];
	    // @ts-expect-error
	    return (0, DefaultNumberOption_1.DefaultNumberOption)(val, minimum, maximum, fallback);
	}
	exports.GetNumberOption = GetNumberOption;


/***/ },
/* 122 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.IsSanctionedSimpleUnitIdentifier = exports.SIMPLE_UNITS = exports.removeUnitNamespace = exports.SANCTIONED_UNITS = void 0;
	/**
	 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
	 */
	exports.SANCTIONED_UNITS = [
	    'angle-degree',
	    'area-acre',
	    'area-hectare',
	    'concentr-percent',
	    'digital-bit',
	    'digital-byte',
	    'digital-gigabit',
	    'digital-gigabyte',
	    'digital-kilobit',
	    'digital-kilobyte',
	    'digital-megabit',
	    'digital-megabyte',
	    'digital-petabyte',
	    'digital-terabit',
	    'digital-terabyte',
	    'duration-day',
	    'duration-hour',
	    'duration-millisecond',
	    'duration-minute',
	    'duration-month',
	    'duration-second',
	    'duration-week',
	    'duration-year',
	    'length-centimeter',
	    'length-foot',
	    'length-inch',
	    'length-kilometer',
	    'length-meter',
	    'length-mile-scandinavian',
	    'length-mile',
	    'length-millimeter',
	    'length-yard',
	    'mass-gram',
	    'mass-kilogram',
	    'mass-ounce',
	    'mass-pound',
	    'mass-stone',
	    'temperature-celsius',
	    'temperature-fahrenheit',
	    'volume-fluid-ounce',
	    'volume-gallon',
	    'volume-liter',
	    'volume-milliliter',
	];
	// In CLDR, the unit name always follows the form `namespace-unit` pattern.
	// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
	function removeUnitNamespace(unit) {
	    return unit.slice(unit.indexOf('-') + 1);
	}
	exports.removeUnitNamespace = removeUnitNamespace;
	/**
	 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
	 */
	exports.SIMPLE_UNITS = exports.SANCTIONED_UNITS.map(removeUnitNamespace);
	/**
	 * https://tc39.es/ecma402/#sec-issanctionedsimpleunitidentifier
	 */
	function IsSanctionedSimpleUnitIdentifier(unitIdentifier) {
	    return exports.SIMPLE_UNITS.indexOf(unitIdentifier) > -1;
	}
	exports.IsSanctionedSimpleUnitIdentifier = IsSanctionedSimpleUnitIdentifier;


/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.IsWellFormedCurrencyCode = void 0;
	/**
	 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
	 * @param str string to convert
	 */
	function toUpperCase(str) {
	    return str.replace(/([a-z])/g, function (_, c) { return c.toUpperCase(); });
	}
	var NOT_A_Z_REGEX = /[^A-Z]/;
	/**
	 * https://tc39.es/ecma402/#sec-iswellformedcurrencycode
	 */
	function IsWellFormedCurrencyCode(currency) {
	    currency = toUpperCase(currency);
	    if (currency.length !== 3) {
	        return false;
	    }
	    if (NOT_A_Z_REGEX.test(currency)) {
	        return false;
	    }
	    return true;
	}
	exports.IsWellFormedCurrencyCode = IsWellFormedCurrencyCode;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.IsWellFormedUnitIdentifier = void 0;
	var IsSanctionedSimpleUnitIdentifier_1 = __webpack_require__(122);
	/**
	 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
	 * @param str string to convert
	 */
	function toLowerCase(str) {
	    return str.replace(/([A-Z])/g, function (_, c) { return c.toLowerCase(); });
	}
	/**
	 * https://tc39.es/ecma402/#sec-iswellformedunitidentifier
	 * @param unit
	 */
	function IsWellFormedUnitIdentifier(unit) {
	    unit = toLowerCase(unit);
	    if ((0, IsSanctionedSimpleUnitIdentifier_1.IsSanctionedSimpleUnitIdentifier)(unit)) {
	        return true;
	    }
	    var units = unit.split('-per-');
	    if (units.length !== 2) {
	        return false;
	    }
	    var numerator = units[0], denominator = units[1];
	    if (!(0, IsSanctionedSimpleUnitIdentifier_1.IsSanctionedSimpleUnitIdentifier)(numerator) ||
	        !(0, IsSanctionedSimpleUnitIdentifier_1.IsSanctionedSimpleUnitIdentifier)(denominator)) {
	        return false;
	    }
	    return true;
	}
	exports.IsWellFormedUnitIdentifier = IsWellFormedUnitIdentifier;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComputeExponent = void 0;
	var utils_1 = __webpack_require__(32);
	var ComputeExponentForMagnitude_1 = __webpack_require__(126);
	var FormatNumericToString_1 = __webpack_require__(66);
	/**
	 * The abstract operation ComputeExponent computes an exponent (power of ten) by which to scale x
	 * according to the number formatting settings. It handles cases such as 999 rounding up to 1000,
	 * requiring a different exponent.
	 *
	 * NOT IN SPEC: it returns [exponent, magnitude].
	 */
	function ComputeExponent(numberFormat, x, _a) {
	    var getInternalSlots = _a.getInternalSlots;
	    if (x === 0) {
	        return [0, 0];
	    }
	    if (x < 0) {
	        x = -x;
	    }
	    var magnitude = (0, utils_1.getMagnitude)(x);
	    var exponent = (0, ComputeExponentForMagnitude_1.ComputeExponentForMagnitude)(numberFormat, magnitude, {
	        getInternalSlots: getInternalSlots,
	    });
	    // Preserve more precision by doing multiplication when exponent is negative.
	    x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
	    var formatNumberResult = (0, FormatNumericToString_1.FormatNumericToString)(getInternalSlots(numberFormat), x);
	    if (formatNumberResult.roundedNumber === 0) {
	        return [exponent, magnitude];
	    }
	    var newMagnitude = (0, utils_1.getMagnitude)(formatNumberResult.roundedNumber);
	    if (newMagnitude === magnitude - exponent) {
	        return [exponent, magnitude];
	    }
	    return [
	        (0, ComputeExponentForMagnitude_1.ComputeExponentForMagnitude)(numberFormat, magnitude + 1, {
	            getInternalSlots: getInternalSlots,
	        }),
	        magnitude + 1,
	    ];
	}
	exports.ComputeExponent = ComputeExponent;


/***/ },
/* 126 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComputeExponentForMagnitude = void 0;
	/**
	 * The abstract operation ComputeExponentForMagnitude computes an exponent by which to scale a
	 * number of the given magnitude (power of ten of the most significant digit) according to the
	 * locale and the desired notation (scientific, engineering, or compact).
	 */
	function ComputeExponentForMagnitude(numberFormat, magnitude, _a) {
	    var getInternalSlots = _a.getInternalSlots;
	    var internalSlots = getInternalSlots(numberFormat);
	    var notation = internalSlots.notation, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
	    switch (notation) {
	        case 'standard':
	            return 0;
	        case 'scientific':
	            return magnitude;
	        case 'engineering':
	            return Math.floor(magnitude / 3) * 3;
	        default: {
	            // Let exponent be an implementation- and locale-dependent (ILD) integer by which to scale a
	            // number of the given magnitude in compact notation for the current locale.
	            var compactDisplay = internalSlots.compactDisplay, style = internalSlots.style, currencyDisplay = internalSlots.currencyDisplay;
	            var thresholdMap = void 0;
	            if (style === 'currency' && currencyDisplay !== 'name') {
	                var currency = dataLocaleData.numbers.currency[numberingSystem] ||
	                    dataLocaleData.numbers.currency[dataLocaleData.numbers.nu[0]];
	                thresholdMap = currency.short;
	            }
	            else {
	                var decimal = dataLocaleData.numbers.decimal[numberingSystem] ||
	                    dataLocaleData.numbers.decimal[dataLocaleData.numbers.nu[0]];
	                thresholdMap = compactDisplay === 'long' ? decimal.long : decimal.short;
	            }
	            if (!thresholdMap) {
	                return 0;
	            }
	            var num = String(Math.pow(10, magnitude));
	            var thresholds = Object.keys(thresholdMap); // TODO: this can be pre-processed
	            if (num < thresholds[0]) {
	                return 0;
	            }
	            if (num > thresholds[thresholds.length - 1]) {
	                return thresholds[thresholds.length - 1].length - 1;
	            }
	            var i = thresholds.indexOf(num);
	            if (i === -1) {
	                return 0;
	            }
	            // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
	            // Special handling if the pattern is precisely `0`.
	            var magnitudeKey = thresholds[i];
	            // TODO: do we need to handle plural here?
	            var compactPattern = thresholdMap[magnitudeKey].other;
	            if (compactPattern === '0') {
	                return 0;
	            }
	            // Example: in zh-TW, `10000000` maps to `0000萬`. So we need to return 8 - 4 = 4 here.
	            return (magnitudeKey.length -
	                thresholdMap[magnitudeKey].other.match(/0+/)[0].length);
	        }
	    }
	}
	exports.ComputeExponentForMagnitude = ComputeExponentForMagnitude;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CurrencyDigits = void 0;
	var _262_1 = __webpack_require__(31);
	/**
	 * https://tc39.es/ecma402/#sec-currencydigits
	 */
	function CurrencyDigits(c, _a) {
	    var currencyDigitsData = _a.currencyDigitsData;
	    return (0, _262_1.HasOwnProperty)(currencyDigitsData, c)
	        ? currencyDigitsData[c]
	        : 2;
	}
	exports.CurrencyDigits = CurrencyDigits;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PartitionNumberPattern = void 0;
	var tslib_1 = __webpack_require__(69);
	var FormatNumericToString_1 = __webpack_require__(66);
	var _262_1 = __webpack_require__(31);
	var ComputeExponent_1 = __webpack_require__(125);
	var format_to_parts_1 = (0, tslib_1.__importDefault)(__webpack_require__(132));
	/**
	 * https://tc39.es/ecma402/#sec-formatnumberstring
	 */
	function PartitionNumberPattern(numberFormat, x, _a) {
	    var _b;
	    var getInternalSlots = _a.getInternalSlots;
	    var internalSlots = getInternalSlots(numberFormat);
	    var pl = internalSlots.pl, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
	    var symbols = dataLocaleData.numbers.symbols[numberingSystem] ||
	        dataLocaleData.numbers.symbols[dataLocaleData.numbers.nu[0]];
	    var magnitude = 0;
	    var exponent = 0;
	    var n;
	    if (isNaN(x)) {
	        n = symbols.nan;
	    }
	    else if (!isFinite(x)) {
	        n = symbols.infinity;
	    }
	    else {
	        if (internalSlots.style === 'percent') {
	            x *= 100;
	        }
	        ;
	        _b = (0, ComputeExponent_1.ComputeExponent)(numberFormat, x, {
	            getInternalSlots: getInternalSlots,
	        }), exponent = _b[0], magnitude = _b[1];
	        // Preserve more precision by doing multiplication when exponent is negative.
	        x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
	        var formatNumberResult = (0, FormatNumericToString_1.FormatNumericToString)(internalSlots, x);
	        n = formatNumberResult.formattedString;
	        x = formatNumberResult.roundedNumber;
	    }
	    // Based on https://tc39.es/ecma402/#sec-getnumberformatpattern
	    // We need to do this before `x` is rounded.
	    var sign;
	    var signDisplay = internalSlots.signDisplay;
	    switch (signDisplay) {
	        case 'never':
	            sign = 0;
	            break;
	        case 'auto':
	            if ((0, _262_1.SameValue)(x, 0) || x > 0 || isNaN(x)) {
	                sign = 0;
	            }
	            else {
	                sign = -1;
	            }
	            break;
	        case 'always':
	            if ((0, _262_1.SameValue)(x, 0) || x > 0 || isNaN(x)) {
	                sign = 1;
	            }
	            else {
	                sign = -1;
	            }
	            break;
	        default:
	            // x === 0 -> x is 0 or x is -0
	            if (x === 0 || isNaN(x)) {
	                sign = 0;
	            }
	            else if (x > 0) {
	                sign = 1;
	            }
	            else {
	                sign = -1;
	            }
	    }
	    return (0, format_to_parts_1.default)({ roundedNumber: x, formattedString: n, exponent: exponent, magnitude: magnitude, sign: sign }, internalSlots.dataLocaleData, pl, internalSlots);
	}
	exports.PartitionNumberPattern = PartitionNumberPattern;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SetNumberFormatDigitOptions = void 0;
	var GetNumberOption_1 = __webpack_require__(121);
	var DefaultNumberOption_1 = __webpack_require__(120);
	/**
	 * https://tc39.es/ecma402/#sec-setnfdigitoptions
	 */
	function SetNumberFormatDigitOptions(internalSlots, opts, mnfdDefault, mxfdDefault, notation) {
	    var mnid = (0, GetNumberOption_1.GetNumberOption)(opts, 'minimumIntegerDigits', 1, 21, 1);
	    var mnfd = opts.minimumFractionDigits;
	    var mxfd = opts.maximumFractionDigits;
	    var mnsd = opts.minimumSignificantDigits;
	    var mxsd = opts.maximumSignificantDigits;
	    internalSlots.minimumIntegerDigits = mnid;
	    if (mnsd !== undefined || mxsd !== undefined) {
	        internalSlots.roundingType = 'significantDigits';
	        mnsd = (0, DefaultNumberOption_1.DefaultNumberOption)(mnsd, 1, 21, 1);
	        mxsd = (0, DefaultNumberOption_1.DefaultNumberOption)(mxsd, mnsd, 21, 21);
	        internalSlots.minimumSignificantDigits = mnsd;
	        internalSlots.maximumSignificantDigits = mxsd;
	    }
	    else if (mnfd !== undefined || mxfd !== undefined) {
	        internalSlots.roundingType = 'fractionDigits';
	        mnfd = (0, DefaultNumberOption_1.DefaultNumberOption)(mnfd, 0, 20, mnfdDefault);
	        var mxfdActualDefault = Math.max(mnfd, mxfdDefault);
	        mxfd = (0, DefaultNumberOption_1.DefaultNumberOption)(mxfd, mnfd, 20, mxfdActualDefault);
	        internalSlots.minimumFractionDigits = mnfd;
	        internalSlots.maximumFractionDigits = mxfd;
	    }
	    else if (notation === 'compact') {
	        internalSlots.roundingType = 'compactRounding';
	    }
	    else {
	        internalSlots.roundingType = 'fractionDigits';
	        internalSlots.minimumFractionDigits = mnfdDefault;
	        internalSlots.maximumFractionDigits = mxfdDefault;
	    }
	}
	exports.SetNumberFormatDigitOptions = SetNumberFormatDigitOptions;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SetNumberFormatUnitOptions = void 0;
	var GetOption_1 = __webpack_require__(54);
	var IsWellFormedCurrencyCode_1 = __webpack_require__(123);
	var IsWellFormedUnitIdentifier_1 = __webpack_require__(124);
	/**
	 * https://tc39.es/ecma402/#sec-setnumberformatunitoptions
	 */
	function SetNumberFormatUnitOptions(nf, options, _a) {
	    if (options === void 0) { options = Object.create(null); }
	    var getInternalSlots = _a.getInternalSlots;
	    var internalSlots = getInternalSlots(nf);
	    var style = (0, GetOption_1.GetOption)(options, 'style', 'string', ['decimal', 'percent', 'currency', 'unit'], 'decimal');
	    internalSlots.style = style;
	    var currency = (0, GetOption_1.GetOption)(options, 'currency', 'string', undefined, undefined);
	    if (currency !== undefined && !(0, IsWellFormedCurrencyCode_1.IsWellFormedCurrencyCode)(currency)) {
	        throw RangeError('Malformed currency code');
	    }
	    if (style === 'currency' && currency === undefined) {
	        throw TypeError('currency cannot be undefined');
	    }
	    var currencyDisplay = (0, GetOption_1.GetOption)(options, 'currencyDisplay', 'string', ['code', 'symbol', 'narrowSymbol', 'name'], 'symbol');
	    var currencySign = (0, GetOption_1.GetOption)(options, 'currencySign', 'string', ['standard', 'accounting'], 'standard');
	    var unit = (0, GetOption_1.GetOption)(options, 'unit', 'string', undefined, undefined);
	    if (unit !== undefined && !(0, IsWellFormedUnitIdentifier_1.IsWellFormedUnitIdentifier)(unit)) {
	        throw RangeError('Invalid unit argument for Intl.NumberFormat()');
	    }
	    if (style === 'unit' && unit === undefined) {
	        throw TypeError('unit cannot be undefined');
	    }
	    var unitDisplay = (0, GetOption_1.GetOption)(options, 'unitDisplay', 'string', ['short', 'narrow', 'long'], 'short');
	    if (style === 'currency') {
	        internalSlots.currency = currency.toUpperCase();
	        internalSlots.currencyDisplay = currencyDisplay;
	        internalSlots.currencySign = currencySign;
	    }
	    if (style === 'unit') {
	        internalSlots.unit = unit;
	        internalSlots.unitDisplay = unitDisplay;
	    }
	}
	exports.SetNumberFormatUnitOptions = SetNumberFormatUnitOptions;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ToRawPrecision = void 0;
	var utils_1 = __webpack_require__(32);
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    var p = maxPrecision;
	    var m;
	    var e;
	    var xFinal;
	    if (x === 0) {
	        m = (0, utils_1.repeat)('0', p);
	        e = 0;
	        xFinal = 0;
	    }
	    else {
	        var xToString = x.toString();
	        // If xToString is formatted as scientific notation, the number is either very small or very
	        // large. If the precision of the formatted string is lower that requested max precision, we
	        // should still infer them from the formatted string, otherwise the formatted result might have
	        // precision loss (e.g. 1e41 will not have 0 in every trailing digits).
	        var xToStringExponentIndex = xToString.indexOf('e');
	        var _a = xToString.split('e'), xToStringMantissa = _a[0], xToStringExponent = _a[1];
	        var xToStringMantissaWithoutDecimalPoint = xToStringMantissa.replace('.', '');
	        if (xToStringExponentIndex >= 0 &&
	            xToStringMantissaWithoutDecimalPoint.length <= p) {
	            e = +xToStringExponent;
	            m =
	                xToStringMantissaWithoutDecimalPoint +
	                    (0, utils_1.repeat)('0', p - xToStringMantissaWithoutDecimalPoint.length);
	            xFinal = x;
	        }
	        else {
	            e = (0, utils_1.getMagnitude)(x);
	            var decimalPlaceOffset = e - p + 1;
	            // n is the integer containing the required precision digits. To derive the formatted string,
	            // we will adjust its decimal place in the logic below.
	            var n = Math.round(adjustDecimalPlace(x, decimalPlaceOffset));
	            // The rounding caused the change of magnitude, so we should increment `e` by 1.
	            if (adjustDecimalPlace(n, p - 1) >= 10) {
	                e = e + 1;
	                // Divide n by 10 to swallow one precision.
	                n = Math.floor(n / 10);
	            }
	            m = n.toString();
	            // Equivalent of n * 10 ** (e - p + 1)
	            xFinal = adjustDecimalPlace(n, p - 1 - e);
	        }
	    }
	    var int;
	    if (e >= p - 1) {
	        m = m + (0, utils_1.repeat)('0', e - p + 1);
	        int = e + 1;
	    }
	    else if (e >= 0) {
	        m = "".concat(m.slice(0, e + 1), ".").concat(m.slice(e + 1));
	        int = e + 1;
	    }
	    else {
	        m = "0.".concat((0, utils_1.repeat)('0', -e - 1)).concat(m);
	        int = 1;
	    }
	    if (m.indexOf('.') >= 0 && maxPrecision > minPrecision) {
	        var cut = maxPrecision - minPrecision;
	        while (cut > 0 && m[m.length - 1] === '0') {
	            m = m.slice(0, -1);
	            cut--;
	        }
	        if (m[m.length - 1] === '.') {
	            m = m.slice(0, -1);
	        }
	    }
	    return { formattedString: m, roundedNumber: xFinal, integerDigitsCount: int };
	    // x / (10 ** magnitude), but try to preserve as much floating point precision as possible.
	    function adjustDecimalPlace(x, magnitude) {
	        return magnitude < 0 ? x * Math.pow(10, -magnitude) : x / Math.pow(10, magnitude);
	    }
	}
	exports.ToRawPrecision = ToRawPrecision;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ToRawFixed_1 = __webpack_require__(67);
	var digit_mapping_generated_1 = __webpack_require__(235);
	var regex_generated_1 = __webpack_require__(239);
	// This is from: unicode-12.1.0/General_Category/Symbol/regex.js
	// IE11 does not support unicode flag, otherwise this is just /\p{S}/u.
	// /^\p{S}/u
	var CARET_S_UNICODE_REGEX = new RegExp("^".concat(regex_generated_1.S_UNICODE_REGEX.source));
	// /\p{S}$/u
	var S_DOLLAR_UNICODE_REGEX = new RegExp("".concat(regex_generated_1.S_UNICODE_REGEX.source, "$"));
	var CLDR_NUMBER_PATTERN = /[#0](?:[\.,][#0]+)*/g;
	function formatToParts(numberResult, data, pl, options) {
	    var sign = numberResult.sign, exponent = numberResult.exponent, magnitude = numberResult.magnitude;
	    var notation = options.notation, style = options.style, numberingSystem = options.numberingSystem;
	    var defaultNumberingSystem = data.numbers.nu[0];
	    // #region Part 1: partition and interpolate the CLDR number pattern.
	    // ----------------------------------------------------------
	    var compactNumberPattern = null;
	    if (notation === 'compact' && magnitude) {
	        compactNumberPattern = getCompactDisplayPattern(numberResult, pl, data, style, options.compactDisplay, options.currencyDisplay, numberingSystem);
	    }
	    // This is used multiple times
	    var nonNameCurrencyPart;
	    if (style === 'currency' && options.currencyDisplay !== 'name') {
	        var byCurrencyDisplay = data.currencies[options.currency];
	        if (byCurrencyDisplay) {
	            switch (options.currencyDisplay) {
	                case 'code':
	                    nonNameCurrencyPart = options.currency;
	                    break;
	                case 'symbol':
	                    nonNameCurrencyPart = byCurrencyDisplay.symbol;
	                    break;
	                default:
	                    nonNameCurrencyPart = byCurrencyDisplay.narrow;
	                    break;
	            }
	        }
	        else {
	            // Fallback for unknown currency
	            nonNameCurrencyPart = options.currency;
	        }
	    }
	    var numberPattern;
	    if (!compactNumberPattern) {
	        // Note: if the style is unit, or is currency and the currency display is name,
	        // its unit parts will be interpolated in part 2. So here we can fallback to decimal.
	        if (style === 'decimal' ||
	            style === 'unit' ||
	            (style === 'currency' && options.currencyDisplay === 'name')) {
	            // Shortcut for decimal
	            var decimalData = data.numbers.decimal[numberingSystem] ||
	                data.numbers.decimal[defaultNumberingSystem];
	            numberPattern = getPatternForSign(decimalData.standard, sign);
	        }
	        else if (style === 'currency') {
	            var currencyData = data.numbers.currency[numberingSystem] ||
	                data.numbers.currency[defaultNumberingSystem];
	            // We replace number pattern part with `0` for easier postprocessing.
	            numberPattern = getPatternForSign(currencyData[options.currencySign], sign);
	        }
	        else {
	            // percent
	            var percentPattern = data.numbers.percent[numberingSystem] ||
	                data.numbers.percent[defaultNumberingSystem];
	            numberPattern = getPatternForSign(percentPattern, sign);
	        }
	    }
	    else {
	        numberPattern = compactNumberPattern;
	    }
	    // Extract the decimal number pattern string. It looks like "#,##0,00", which will later be
	    // used to infer decimal group sizes.
	    var decimalNumberPattern = CLDR_NUMBER_PATTERN.exec(numberPattern)[0];
	    // Now we start to substitute patterns
	    // 1. replace strings like `0` and `#,##0.00` with `{0}`
	    // 2. unquote characters (invariant: the quoted characters does not contain the special tokens)
	    numberPattern = numberPattern
	        .replace(CLDR_NUMBER_PATTERN, '{0}')
	        .replace(/'(.)'/g, '$1');
	    // Handle currency spacing (both compact and non-compact).
	    if (style === 'currency' && options.currencyDisplay !== 'name') {
	        var currencyData = data.numbers.currency[numberingSystem] ||
	            data.numbers.currency[defaultNumberingSystem];
	        // See `currencySpacing` substitution rule in TR-35.
	        // Here we always assume the currencyMatch is "[:^S:]" and surroundingMatch is "[:digit:]".
	        //
	        // Example 1: for pattern "#,##0.00¤" with symbol "US$", we replace "¤" with the symbol,
	        // but insert an extra non-break space before the symbol, because "[:^S:]" matches "U" in
	        // "US$" and "[:digit:]" matches the latn numbering system digits.
	        //
	        // Example 2: for pattern "¤#,##0.00" with symbol "US$", there is no spacing between symbol
	        // and number, because `$` does not match "[:^S:]".
	        //
	        // Implementation note: here we do the best effort to infer the insertion.
	        // We also assume that `beforeInsertBetween` and `afterInsertBetween` will never be `;`.
	        var afterCurrency = currencyData.currencySpacing.afterInsertBetween;
	        if (afterCurrency && !S_DOLLAR_UNICODE_REGEX.test(nonNameCurrencyPart)) {
	            numberPattern = numberPattern.replace('¤{0}', "\u00A4".concat(afterCurrency, "{0}"));
	        }
	        var beforeCurrency = currencyData.currencySpacing.beforeInsertBetween;
	        if (beforeCurrency && !CARET_S_UNICODE_REGEX.test(nonNameCurrencyPart)) {
	            numberPattern = numberPattern.replace('{0}¤', "{0}".concat(beforeCurrency, "\u00A4"));
	        }
	    }
	    // The following tokens are special: `{0}`, `¤`, `%`, `-`, `+`, `{c:...}.
	    var numberPatternParts = numberPattern.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g);
	    var numberParts = [];
	    var symbols = data.numbers.symbols[numberingSystem] ||
	        data.numbers.symbols[defaultNumberingSystem];
	    for (var _i = 0, numberPatternParts_1 = numberPatternParts; _i < numberPatternParts_1.length; _i++) {
	        var part = numberPatternParts_1[_i];
	        if (!part) {
	            continue;
	        }
	        switch (part) {
	            case '{0}': {
	                // We only need to handle scientific and engineering notation here.
	                numberParts.push.apply(numberParts, paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, 
	                // If compact number pattern exists, do not insert group separators.
	                !compactNumberPattern && options.useGrouping, decimalNumberPattern));
	                break;
	            }
	            case '-':
	                numberParts.push({ type: 'minusSign', value: symbols.minusSign });
	                break;
	            case '+':
	                numberParts.push({ type: 'plusSign', value: symbols.plusSign });
	                break;
	            case '%':
	                numberParts.push({ type: 'percentSign', value: symbols.percentSign });
	                break;
	            case '¤':
	                // Computed above when handling currency spacing.
	                numberParts.push({ type: 'currency', value: nonNameCurrencyPart });
	                break;
	            default:
	                if (/^\{c:/.test(part)) {
	                    numberParts.push({
	                        type: 'compact',
	                        value: part.substring(3, part.length - 1),
	                    });
	                }
	                else {
	                    // literal
	                    numberParts.push({ type: 'literal', value: part });
	                }
	                break;
	        }
	    }
	    // #endregion
	    // #region Part 2: interpolate unit pattern if necessary.
	    // ----------------------------------------------
	    switch (style) {
	        case 'currency': {
	            // `currencyDisplay: 'name'` has similar pattern handling as units.
	            if (options.currencyDisplay === 'name') {
	                var unitPattern = (data.numbers.currency[numberingSystem] ||
	                    data.numbers.currency[defaultNumberingSystem]).unitPattern;
	                // Select plural
	                var unitName = void 0;
	                var currencyNameData = data.currencies[options.currency];
	                if (currencyNameData) {
	                    unitName = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), currencyNameData.displayName);
	                }
	                else {
	                    // Fallback for unknown currency
	                    unitName = options.currency;
	                }
	                // Do {0} and {1} substitution
	                var unitPatternParts = unitPattern.split(/(\{[01]\})/g);
	                var result = [];
	                for (var _a = 0, unitPatternParts_1 = unitPatternParts; _a < unitPatternParts_1.length; _a++) {
	                    var part = unitPatternParts_1[_a];
	                    switch (part) {
	                        case '{0}':
	                            result.push.apply(result, numberParts);
	                            break;
	                        case '{1}':
	                            result.push({ type: 'currency', value: unitName });
	                            break;
	                        default:
	                            if (part) {
	                                result.push({ type: 'literal', value: part });
	                            }
	                            break;
	                    }
	                }
	                return result;
	            }
	            else {
	                return numberParts;
	            }
	        }
	        case 'unit': {
	            var unit = options.unit, unitDisplay = options.unitDisplay;
	            var unitData = data.units.simple[unit];
	            var unitPattern = void 0;
	            if (unitData) {
	                // Simple unit pattern
	                unitPattern = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[unit][unitDisplay]);
	            }
	            else {
	                // See: http://unicode.org/reports/tr35/tr35-general.html#perUnitPatterns
	                // If cannot find unit in the simple pattern, it must be "per" compound pattern.
	                // Implementation note: we are not following TR-35 here because we need to format to parts!
	                var _b = unit.split('-per-'), numeratorUnit = _b[0], denominatorUnit = _b[1];
	                unitData = data.units.simple[numeratorUnit];
	                var numeratorUnitPattern = selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[numeratorUnit][unitDisplay]);
	                var perUnitPattern = data.units.simple[denominatorUnit].perUnit[unitDisplay];
	                if (perUnitPattern) {
	                    // perUnitPattern exists, combine it with numeratorUnitPattern
	                    unitPattern = perUnitPattern.replace('{0}', numeratorUnitPattern);
	                }
	                else {
	                    // get compoundUnit pattern (e.g. "{0} per {1}"), repalce {0} with numerator pattern and {1} with
	                    // the denominator pattern in singular form.
	                    var perPattern = data.units.compound.per[unitDisplay];
	                    var denominatorPattern = selectPlural(pl, 1, data.units.simple[denominatorUnit][unitDisplay]);
	                    unitPattern = unitPattern = perPattern
	                        .replace('{0}', numeratorUnitPattern)
	                        .replace('{1}', denominatorPattern.replace('{0}', ''));
	                }
	            }
	            var result = [];
	            // We need spacing around "{0}" because they are not treated as "unit" parts, but "literal".
	            for (var _c = 0, _d = unitPattern.split(/(\s*\{0\}\s*)/); _c < _d.length; _c++) {
	                var part = _d[_c];
	                var interpolateMatch = /^(\s*)\{0\}(\s*)$/.exec(part);
	                if (interpolateMatch) {
	                    // Space before "{0}"
	                    if (interpolateMatch[1]) {
	                        result.push({ type: 'literal', value: interpolateMatch[1] });
	                    }
	                    // "{0}" itself
	                    result.push.apply(result, numberParts);
	                    // Space after "{0}"
	                    if (interpolateMatch[2]) {
	                        result.push({ type: 'literal', value: interpolateMatch[2] });
	                    }
	                }
	                else if (part) {
	                    result.push({ type: 'unit', value: part });
	                }
	            }
	            return result;
	        }
	        default:
	            return numberParts;
	    }
	    // #endregion
	}
	exports.default = formatToParts;
	// A subset of https://tc39.es/ecma402/#sec-partitionnotationsubpattern
	// Plus the exponent parts handling.
	function paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, useGrouping, 
	/**
	 * This is the decimal number pattern without signs or symbols.
	 * It is used to infer the group size when `useGrouping` is true.
	 *
	 * A typical value looks like "#,##0.00" (primary group size is 3).
	 * Some locales like Hindi has secondary group size of 2 (e.g. "#,##,##0.00").
	 */
	decimalNumberPattern) {
	    var result = [];
	    // eslint-disable-next-line prefer-const
	    var n = numberResult.formattedString, x = numberResult.roundedNumber;
	    if (isNaN(x)) {
	        return [{ type: 'nan', value: n }];
	    }
	    else if (!isFinite(x)) {
	        return [{ type: 'infinity', value: n }];
	    }
	    var digitReplacementTable = digit_mapping_generated_1.digitMapping[numberingSystem];
	    if (digitReplacementTable) {
	        n = n.replace(/\d/g, function (digit) { return digitReplacementTable[+digit] || digit; });
	    }
	    // TODO: Else use an implementation dependent algorithm to map n to the appropriate
	    // representation of n in the given numbering system.
	    var decimalSepIndex = n.indexOf('.');
	    var integer;
	    var fraction;
	    if (decimalSepIndex > 0) {
	        integer = n.slice(0, decimalSepIndex);
	        fraction = n.slice(decimalSepIndex + 1);
	    }
	    else {
	        integer = n;
	    }
	    // #region Grouping integer digits
	    // The weird compact and x >= 10000 check is to ensure consistency with Node.js and Chrome.
	    // Note that `de` does not have compact form for thousands, but Node.js does not insert grouping separator
	    // unless the rounded number is greater than 10000:
	    //   NumberFormat('de', {notation: 'compact', compactDisplay: 'short'}).format(1234) //=> "1234"
	    //   NumberFormat('de').format(1234) //=> "1.234"
	    if (useGrouping && (notation !== 'compact' || x >= 10000)) {
	        var groupSepSymbol = symbols.group;
	        var groups = [];
	        // > There may be two different grouping sizes: The primary grouping size used for the least
	        // > significant integer group, and the secondary grouping size used for more significant groups.
	        // > If a pattern contains multiple grouping separators, the interval between the last one and the
	        // > end of the integer defines the primary grouping size, and the interval between the last two
	        // > defines the secondary grouping size. All others are ignored.
	        var integerNumberPattern = decimalNumberPattern.split('.')[0];
	        var patternGroups = integerNumberPattern.split(',');
	        var primaryGroupingSize = 3;
	        var secondaryGroupingSize = 3;
	        if (patternGroups.length > 1) {
	            primaryGroupingSize = patternGroups[patternGroups.length - 1].length;
	        }
	        if (patternGroups.length > 2) {
	            secondaryGroupingSize = patternGroups[patternGroups.length - 2].length;
	        }
	        var i = integer.length - primaryGroupingSize;
	        if (i > 0) {
	            // Slice the least significant integer group
	            groups.push(integer.slice(i, i + primaryGroupingSize));
	            // Then iteratively push the more signicant groups
	            // TODO: handle surrogate pairs in some numbering system digits
	            for (i -= secondaryGroupingSize; i > 0; i -= secondaryGroupingSize) {
	                groups.push(integer.slice(i, i + secondaryGroupingSize));
	            }
	            groups.push(integer.slice(0, i + secondaryGroupingSize));
	        }
	        else {
	            groups.push(integer);
	        }
	        while (groups.length > 0) {
	            var integerGroup = groups.pop();
	            result.push({ type: 'integer', value: integerGroup });
	            if (groups.length > 0) {
	                result.push({ type: 'group', value: groupSepSymbol });
	            }
	        }
	    }
	    else {
	        result.push({ type: 'integer', value: integer });
	    }
	    // #endregion
	    if (fraction !== undefined) {
	        result.push({ type: 'decimal', value: symbols.decimal }, { type: 'fraction', value: fraction });
	    }
	    if ((notation === 'scientific' || notation === 'engineering') &&
	        isFinite(x)) {
	        result.push({ type: 'exponentSeparator', value: symbols.exponential });
	        if (exponent < 0) {
	            result.push({ type: 'exponentMinusSign', value: symbols.minusSign });
	            exponent = -exponent;
	        }
	        var exponentResult = (0, ToRawFixed_1.ToRawFixed)(exponent, 0, 0);
	        result.push({
	            type: 'exponentInteger',
	            value: exponentResult.formattedString,
	        });
	    }
	    return result;
	}
	function getPatternForSign(pattern, sign) {
	    if (pattern.indexOf(';') < 0) {
	        pattern = "".concat(pattern, ";-").concat(pattern);
	    }
	    var _a = pattern.split(';'), zeroPattern = _a[0], negativePattern = _a[1];
	    switch (sign) {
	        case 0:
	            return zeroPattern;
	        case -1:
	            return negativePattern;
	        default:
	            return negativePattern.indexOf('-') >= 0
	                ? negativePattern.replace(/-/g, '+')
	                : "+".concat(zeroPattern);
	    }
	}
	// Find the CLDR pattern for compact notation based on the magnitude of data and style.
	//
	// Example return value: "¤ {c:laki}000;¤{c:laki} -0" (`sw` locale):
	// - Notice the `{c:...}` token that wraps the compact literal.
	// - The consecutive zeros are normalized to single zero to match CLDR_NUMBER_PATTERN.
	//
	// Returning null means the compact display pattern cannot be found.
	function getCompactDisplayPattern(numberResult, pl, data, style, compactDisplay, currencyDisplay, numberingSystem) {
	    var _a;
	    var roundedNumber = numberResult.roundedNumber, sign = numberResult.sign, magnitude = numberResult.magnitude;
	    var magnitudeKey = String(Math.pow(10, magnitude));
	    var defaultNumberingSystem = data.numbers.nu[0];
	    var pattern;
	    if (style === 'currency' && currencyDisplay !== 'name') {
	        var byNumberingSystem = data.numbers.currency;
	        var currencyData = byNumberingSystem[numberingSystem] ||
	            byNumberingSystem[defaultNumberingSystem];
	        // NOTE: compact notation ignores currencySign!
	        var compactPluralRules = (_a = currencyData.short) === null || _a === void 0 ? void 0 : _a[magnitudeKey];
	        if (!compactPluralRules) {
	            return null;
	        }
	        pattern = selectPlural(pl, roundedNumber, compactPluralRules);
	    }
	    else {
	        var byNumberingSystem = data.numbers.decimal;
	        var byCompactDisplay = byNumberingSystem[numberingSystem] ||
	            byNumberingSystem[defaultNumberingSystem];
	        var compactPlaralRule = byCompactDisplay[compactDisplay][magnitudeKey];
	        if (!compactPlaralRule) {
	            return null;
	        }
	        pattern = selectPlural(pl, roundedNumber, compactPlaralRule);
	    }
	    // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
	    // > If the value is precisely “0”, either explicit or defaulted, then the normal number format
	    // > pattern for that sort of object is supplied.
	    if (pattern === '0') {
	        return null;
	    }
	    pattern = getPatternForSign(pattern, sign)
	        // Extract compact literal from the pattern
	        .replace(/([^\s;\-\+\d¤]+)/g, '{c:$1}')
	        // We replace one or more zeros with a single zero so it matches `CLDR_NUMBER_PATTERN`.
	        .replace(/0+/, '0');
	    return pattern;
	}
	function selectPlural(pl, x, rules) {
	    return rules[pl.select(x)] || rules.other;
	}


/***/ },
/* 133 */
/***/ function(module, exports) {

	"use strict";
	//
	// Main
	//
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.strategies = void 0;
	function memoize(fn, options) {
	    var cache = options && options.cache ? options.cache : cacheDefault;
	    var serializer = options && options.serializer ? options.serializer : serializerDefault;
	    var strategy = options && options.strategy ? options.strategy : strategyDefault;
	    return strategy(fn, {
	        cache: cache,
	        serializer: serializer,
	    });
	}
	exports.default = memoize;
	//
	// Strategy
	//
	function isPrimitive(value) {
	    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
	}
	function monadic(fn, cache, serializer, arg) {
	    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	    var computedValue = cache.get(cacheKey);
	    if (typeof computedValue === 'undefined') {
	        computedValue = fn.call(this, arg);
	        cache.set(cacheKey, computedValue);
	    }
	    return computedValue;
	}
	function variadic(fn, cache, serializer) {
	    var args = Array.prototype.slice.call(arguments, 3);
	    var cacheKey = serializer(args);
	    var computedValue = cache.get(cacheKey);
	    if (typeof computedValue === 'undefined') {
	        computedValue = fn.apply(this, args);
	        cache.set(cacheKey, computedValue);
	    }
	    return computedValue;
	}
	function assemble(fn, context, strategy, cache, serialize) {
	    return strategy.bind(context, fn, cache, serialize);
	}
	function strategyDefault(fn, options) {
	    var strategy = fn.length === 1 ? monadic : variadic;
	    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
	}
	function strategyVariadic(fn, options) {
	    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
	}
	function strategyMonadic(fn, options) {
	    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
	}
	//
	// Serializer
	//
	var serializerDefault = function () {
	    return JSON.stringify(arguments);
	};
	//
	// Cache
	//
	function ObjectWithoutPrototypeCache() {
	    this.cache = Object.create(null);
	}
	ObjectWithoutPrototypeCache.prototype.get = function (key) {
	    return this.cache[key];
	};
	ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	    this.cache[key] = value;
	};
	var cacheDefault = {
	    create: function create() {
	        // @ts-ignore
	        return new ObjectWithoutPrototypeCache();
	    },
	};
	exports.strategies = {
	    variadic: strategyVariadic,
	    monadic: strategyMonadic,
	};


/***/ },
/* 134 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ErrorKind = void 0;
	var ErrorKind;
	(function (ErrorKind) {
	    /** Argument is unclosed (e.g. `{0`) */
	    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
	    /** Argument is empty (e.g. `{}`). */
	    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
	    /** Argument is malformed (e.g. `{foo!}``) */
	    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
	    /** Expect an argument type (e.g. `{foo,}`) */
	    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
	    /** Unsupported argument type (e.g. `{foo,foo}`) */
	    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
	    /** Expect an argument style (e.g. `{foo, number, }`) */
	    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
	    /** The number skeleton is invalid. */
	    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
	    /** The date time skeleton is invalid. */
	    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
	    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
	    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
	    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
	    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
	    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
	    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
	    /** Missing select argument options (e.g. `{foo, select}`) */
	    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
	    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
	    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
	    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
	    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
	    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
	    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
	    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
	    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
	    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
	    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
	    /**
	     * Expecting a message fragment after the `plural` or `selectordinal` selector
	     * (e.g. `{foo, plural, one}`)
	     */
	    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
	    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
	    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
	    /**
	     * Duplicate selectors in `plural` or `selectordinal` argument.
	     * (e.g. {foo, plural, one {#} one {#}})
	     */
	    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
	    /** Duplicate selectors in `select` argument.
	     * (e.g. {foo, select, apple {apple} apple {apple}})
	     */
	    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
	    /** Plural or select argument option must have `other` clause. */
	    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
	    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
	    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
	    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
	    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
	    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
	    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
	    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
	    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
	})(ErrorKind = exports.ErrorKind || (exports.ErrorKind = {}));


/***/ },
/* 135 */
29,
/* 136 */
29,
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResolveLocale = void 0;
	var LookupMatcher_1 = __webpack_require__(256);
	var BestFitMatcher_1 = __webpack_require__(254);
	var utils_1 = __webpack_require__(47);
	var UnicodeExtensionValue_1 = __webpack_require__(258);
	/**
	 * https://tc39.es/ecma402/#sec-resolvelocale
	 */
	function ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
	    var matcher = options.localeMatcher;
	    var r;
	    if (matcher === 'lookup') {
	        r = (0, LookupMatcher_1.LookupMatcher)(availableLocales, requestedLocales, getDefaultLocale);
	    }
	    else {
	        r = (0, BestFitMatcher_1.BestFitMatcher)(availableLocales, requestedLocales, getDefaultLocale);
	    }
	    var foundLocale = r.locale;
	    var result = { locale: '', dataLocale: foundLocale };
	    var supportedExtension = '-u';
	    for (var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++) {
	        var key = relevantExtensionKeys_1[_i];
	        (0, utils_1.invariant)(foundLocale in localeData, "Missing locale data for ".concat(foundLocale));
	        var foundLocaleData = localeData[foundLocale];
	        (0, utils_1.invariant)(typeof foundLocaleData === 'object' && foundLocaleData !== null, "locale data ".concat(key, " must be an object"));
	        var keyLocaleData = foundLocaleData[key];
	        (0, utils_1.invariant)(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
	        var value = keyLocaleData[0];
	        (0, utils_1.invariant)(typeof value === 'string' || value === null, "value must be string or null but got ".concat(typeof value, " in key ").concat(key));
	        var supportedExtensionAddition = '';
	        if (r.extension) {
	            var requestedValue = (0, UnicodeExtensionValue_1.UnicodeExtensionValue)(r.extension, key);
	            if (requestedValue !== undefined) {
	                if (requestedValue !== '') {
	                    if (~keyLocaleData.indexOf(requestedValue)) {
	                        value = requestedValue;
	                        supportedExtensionAddition = "-".concat(key, "-").concat(value);
	                    }
	                }
	                else if (~requestedValue.indexOf('true')) {
	                    value = 'true';
	                    supportedExtensionAddition = "-".concat(key);
	                }
	            }
	        }
	        if (key in options) {
	            var optionsValue = options[key];
	            (0, utils_1.invariant)(typeof optionsValue === 'string' ||
	                typeof optionsValue === 'undefined' ||
	                optionsValue === null, 'optionsValue must be String, Undefined or Null');
	            if (~keyLocaleData.indexOf(optionsValue)) {
	                if (optionsValue !== value) {
	                    value = optionsValue;
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        result[key] = value;
	        supportedExtension += supportedExtensionAddition;
	    }
	    if (supportedExtension.length > 2) {
	        var privateIndex = foundLocale.indexOf('-x-');
	        if (privateIndex === -1) {
	            foundLocale = foundLocale + supportedExtension;
	        }
	        else {
	            var preExtension = foundLocale.slice(0, privateIndex);
	            var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
	            foundLocale = preExtension + supportedExtension + postExtension;
	        }
	        foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
	    }
	    result.locale = foundLocale;
	    return result;
	}
	exports.ResolveLocale = ResolveLocale;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResolveLocale = exports.LookupSupportedLocales = exports.match = void 0;
	var CanonicalizeLocaleList_1 = __webpack_require__(255);
	var ResolveLocale_1 = __webpack_require__(137);
	function match(requestedLocales, availableLocales, defaultLocale, opts) {
	    var locales = availableLocales.reduce(function (all, l) {
	        all.add(l);
	        return all;
	    }, new Set());
	    return (0, ResolveLocale_1.ResolveLocale)(locales, (0, CanonicalizeLocaleList_1.CanonicalizeLocaleList)(requestedLocales), {
	        localeMatcher: (opts === null || opts === void 0 ? void 0 : opts.algorithm) || 'best fit',
	    }, [], {}, function () { return defaultLocale; }).locale;
	}
	exports.match = match;
	var LookupSupportedLocales_1 = __webpack_require__(257);
	Object.defineProperty(exports, "LookupSupportedLocales", { enumerable: true, get: function () { return LookupSupportedLocales_1.LookupSupportedLocales; } });
	var ResolveLocale_2 = __webpack_require__(137);
	Object.defineProperty(exports, "ResolveLocale", { enumerable: true, get: function () { return ResolveLocale_2.ResolveLocale; } });


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatTimeToParts = exports.formatDateToParts = exports.formatDateTimeRange = exports.formatTime = exports.formatDate = exports.getFormatter = void 0;
	var tslib_1 = __webpack_require__(35);
	var utils_1 = __webpack_require__(33);
	var error_1 = __webpack_require__(25);
	var DATE_TIME_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'formatMatcher',
	    'timeZone',
	    'hour12',
	    'weekday',
	    'era',
	    'year',
	    'month',
	    'day',
	    'hour',
	    'minute',
	    'second',
	    'timeZoneName',
	    'hourCycle',
	    'dateStyle',
	    'timeStyle',
	    'calendar',
	    // 'dayPeriod',
	    'numberingSystem',
	];
	function getFormatter(_a, type, getDateTimeFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, (timeZone && { timeZone: timeZone })), (format && (0, utils_1.getNamedFormat)(formats, type, format, onError)));
	    var filteredOptions = (0, utils_1.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	    if (type === 'time' &&
	        !filteredOptions.hour &&
	        !filteredOptions.minute &&
	        !filteredOptions.second &&
	        !filteredOptions.timeStyle &&
	        !filteredOptions.dateStyle) {
	        // Add default formatting options if hour, minute, or second isn't defined.
	        filteredOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
	    }
	    return getDateTimeFormat(locale, filteredOptions);
	}
	exports.getFormatter = getFormatter;
	function formatDate(config, getDateTimeFormat) {
	    var _a = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        _a[_i - 2] = arguments[_i];
	    }
	    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'date', getDateTimeFormat, options).format(date);
	    }
	    catch (e) {
	        config.onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting date.', e));
	    }
	    return String(date);
	}
	exports.formatDate = formatDate;
	function formatTime(config, getDateTimeFormat) {
	    var _a = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        _a[_i - 2] = arguments[_i];
	    }
	    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'time', getDateTimeFormat, options).format(date);
	    }
	    catch (e) {
	        config.onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting time.', e));
	    }
	    return String(date);
	}
	exports.formatTime = formatTime;
	function formatDateTimeRange(config, getDateTimeFormat) {
	    var _a = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        _a[_i - 2] = arguments[_i];
	    }
	    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
	    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
	    var filteredOptions = (0, utils_1.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
	    try {
	        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
	    }
	    catch (e) {
	        onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting date time range.', e));
	    }
	    return String(from);
	}
	exports.formatDateTimeRange = formatDateTimeRange;
	function formatDateToParts(config, getDateTimeFormat) {
	    var _a = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        _a[_i - 2] = arguments[_i];
	    }
	    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
	    }
	    catch (e) {
	        config.onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting date.', e));
	    }
	    return [];
	}
	exports.formatDateToParts = formatDateToParts;
	function formatTimeToParts(config, getDateTimeFormat) {
	    var _a = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        _a[_i - 2] = arguments[_i];
	    }
	    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
	    }
	    catch (e) {
	        config.onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting time.', e));
	    }
	    return [];
	}
	exports.formatTimeToParts = formatTimeToParts;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatDisplayName = void 0;
	var utils_1 = __webpack_require__(33);
	var intl_messageformat_1 = __webpack_require__(39);
	var error_1 = __webpack_require__(25);
	var DISPLAY_NAMES_OPTONS = [
	    'localeMatcher',
	    'style',
	    'type',
	    'fallback',
	];
	function formatDisplayName(_a, getDisplayNames, value, options) {
	    var locale = _a.locale, onError = _a.onError;
	    var DisplayNames = Intl.DisplayNames;
	    if (!DisplayNames) {
	        onError(new intl_messageformat_1.FormatError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", intl_messageformat_1.ErrorCode.MISSING_INTL_API));
	    }
	    var filteredOptions = (0, utils_1.filterProps)(options, DISPLAY_NAMES_OPTONS);
	    try {
	        return getDisplayNames(locale, filteredOptions).of(value);
	    }
	    catch (e) {
	        onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting display name.', e));
	    }
	}
	exports.formatDisplayName = formatDisplayName;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatListToParts = exports.formatList = void 0;
	var tslib_1 = __webpack_require__(35);
	var utils_1 = __webpack_require__(33);
	var intl_messageformat_1 = __webpack_require__(39);
	var error_1 = __webpack_require__(25);
	var LIST_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'type',
	    'style',
	];
	var now = Date.now();
	function generateToken(i) {
	    return "".concat(now, "_").concat(i, "_").concat(now);
	}
	function formatList(opts, getListFormat, values, options) {
	    if (options === void 0) { options = {}; }
	    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
	        var val = el.value;
	        if (typeof val !== 'string') {
	            all.push(val);
	        }
	        else if (typeof all[all.length - 1] === 'string') {
	            all[all.length - 1] += val;
	        }
	        else {
	            all.push(val);
	        }
	        return all;
	    }, []);
	    return results.length === 1 ? results[0] : results;
	}
	exports.formatList = formatList;
	function formatListToParts(_a, getListFormat, values, options) {
	    var locale = _a.locale, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var ListFormat = Intl.ListFormat;
	    if (!ListFormat) {
	        onError(new intl_messageformat_1.FormatError("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", intl_messageformat_1.ErrorCode.MISSING_INTL_API));
	    }
	    var filteredOptions = (0, utils_1.filterProps)(options, LIST_FORMAT_OPTIONS);
	    try {
	        var richValues_1 = {};
	        var serializedValues = values.map(function (v, i) {
	            if (typeof v === 'object') {
	                var id = generateToken(i);
	                richValues_1[id] = v;
	                return id;
	            }
	            return String(v);
	        });
	        return getListFormat(locale, filteredOptions)
	            .formatToParts(serializedValues)
	            .map(function (part) {
	            return part.type === 'literal'
	                ? part
	                : (0, tslib_1.__assign)((0, tslib_1.__assign)({}, part), { value: richValues_1[part.value] || part.value });
	        });
	    }
	    catch (e) {
	        onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting list.', e));
	    }
	    // @ts-ignore
	    return values;
	}
	exports.formatListToParts = formatListToParts;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatMessage = void 0;
	var tslib_1 = __webpack_require__(35);
	var ecma402_abstract_1 = __webpack_require__(68);
	var intl_messageformat_1 = __webpack_require__(39);
	var error_1 = __webpack_require__(25);
	var icu_messageformat_parser_1 = __webpack_require__(70);
	function setTimeZoneInOptions(opts, timeZone) {
	    return Object.keys(opts).reduce(function (all, k) {
	        all[k] = (0, tslib_1.__assign)({ timeZone: timeZone }, opts[k]);
	        return all;
	    }, {});
	}
	function deepMergeOptions(opts1, opts2) {
	    var keys = Object.keys((0, tslib_1.__assign)((0, tslib_1.__assign)({}, opts1), opts2));
	    return keys.reduce(function (all, k) {
	        all[k] = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, (opts1[k] || {})), (opts2[k] || {}));
	        return all;
	    }, {});
	}
	function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
	    if (!timeZone) {
	        return f1;
	    }
	    var mfFormats = intl_messageformat_1.IntlMessageFormat.formats;
	    return (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
	}
	function formatMessage(_a, state, messageDescriptor, values, opts) {
	    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
	    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
	    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
	    // `id` is a required field of a Message Descriptor.
	    (0, ecma402_abstract_1.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
	    var id = String(msgId);
	    var message = 
	    // In case messages is Object.create(null)
	    // e.g import('foo.json') from webpack)
	    // See https://github.com/formatjs/formatjs/issues/1914
	    messages &&
	        Object.prototype.hasOwnProperty.call(messages, id) &&
	        messages[id];
	    // IMPORTANT: Hot path if `message` is AST with a single literal node
	    if (Array.isArray(message) &&
	        message.length === 1 &&
	        message[0].type === icu_messageformat_parser_1.TYPE.literal) {
	        return message[0].value;
	    }
	    // IMPORTANT: Hot path straight lookup for performance
	    if (!values &&
	        message &&
	        typeof message === 'string' &&
	        !defaultRichTextElements) {
	        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
	    }
	    values = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, defaultRichTextElements), (values || {}));
	    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
	    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
	    if (!message) {
	        if (fallbackOnEmptyString === false && message === '') {
	            return message;
	        }
	        if (!defaultMessage ||
	            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale.
	            onError(new error_1.MissingTranslationError(messageDescriptor, locale));
	        }
	        if (defaultMessage) {
	            try {
	                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
	                return formatter.format(values);
	            }
	            catch (e) {
	                onError(new error_1.MessageFormatError("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
	                return typeof defaultMessage === 'string' ? defaultMessage : id;
	            }
	        }
	        return id;
	    }
	    // We have the translated message
	    try {
	        var formatter = state.getMessageFormat(message, locale, formats, (0, tslib_1.__assign)({ formatters: state }, (opts || {})));
	        return formatter.format(values);
	    }
	    catch (e) {
	        onError(new error_1.MessageFormatError("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
	    }
	    if (defaultMessage) {
	        try {
	            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
	            return formatter.format(values);
	        }
	        catch (e) {
	            onError(new error_1.MessageFormatError("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
	        }
	    }
	    if (typeof message === 'string') {
	        return message;
	    }
	    if (typeof defaultMessage === 'string') {
	        return defaultMessage;
	    }
	    return id;
	}
	exports.formatMessage = formatMessage;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatNumberToParts = exports.formatNumber = exports.getFormatter = void 0;
	var utils_1 = __webpack_require__(33);
	var error_1 = __webpack_require__(25);
	var NUMBER_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'style',
	    'currency',
	    'currencyDisplay',
	    'unit',
	    'unitDisplay',
	    'useGrouping',
	    'minimumIntegerDigits',
	    'minimumFractionDigits',
	    'maximumFractionDigits',
	    'minimumSignificantDigits',
	    'maximumSignificantDigits',
	    // ES2020 NumberFormat
	    'compactDisplay',
	    'currencyDisplay',
	    'currencySign',
	    'notation',
	    'signDisplay',
	    'unit',
	    'unitDisplay',
	    'numberingSystem',
	];
	function getFormatter(_a, getNumberFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = ((format &&
	        (0, utils_1.getNamedFormat)(formats, 'number', format, onError)) ||
	        {});
	    var filteredOptions = (0, utils_1.filterProps)(options, NUMBER_FORMAT_OPTIONS, defaults);
	    return getNumberFormat(locale, filteredOptions);
	}
	exports.getFormatter = getFormatter;
	function formatNumber(config, getNumberFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    try {
	        return getFormatter(config, getNumberFormat, options).format(value);
	    }
	    catch (e) {
	        config.onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting number.', e));
	    }
	    return String(value);
	}
	exports.formatNumber = formatNumber;
	function formatNumberToParts(config, getNumberFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    try {
	        return getFormatter(config, getNumberFormat, options).formatToParts(value);
	    }
	    catch (e) {
	        config.onError(new error_1.IntlError(error_1.IntlErrorCode.FORMAT_ERROR, 'Error formatting number.', e));
	    }
	    return [];
	}
	exports.formatNumberToParts = formatNumberToParts;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatPlural = void 0;
	var utils_1 = __webpack_require__(33);
	var error_1 = __webpack_require__(25);
	var intl_messageformat_1 = __webpack_require__(39);
	var PLURAL_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'type',
	];
	function formatPlural(_a, getPluralRules, value, options) {
	    var locale = _a.locale, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    if (!Intl.PluralRules) {
	        onError(new intl_messageformat_1.FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", intl_messageformat_1.ErrorCode.MISSING_INTL_API));
	    }
	    var filteredOptions = (0, utils_1.filterProps)(options, PLURAL_FORMAT_OPTIONS);
	    try {
	        return getPluralRules(locale, filteredOptions).select(value);
	    }
	    catch (e) {
	        onError(new error_1.IntlFormatError('Error formatting plural.', locale, e));
	    }
	    return 'other';
	}
	exports.formatPlural = formatPlural;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatRelativeTime = void 0;
	var utils_1 = __webpack_require__(33);
	var intl_messageformat_1 = __webpack_require__(39);
	var error_1 = __webpack_require__(25);
	var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
	function getFormatter(_a, getRelativeTimeFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = (!!format && (0, utils_1.getNamedFormat)(formats, 'relative', format, onError)) || {};
	    var filteredOptions = (0, utils_1.filterProps)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
	    return getRelativeTimeFormat(locale, filteredOptions);
	}
	function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
	    if (options === void 0) { options = {}; }
	    if (!unit) {
	        unit = 'second';
	    }
	    var RelativeTimeFormat = Intl.RelativeTimeFormat;
	    if (!RelativeTimeFormat) {
	        config.onError(new intl_messageformat_1.FormatError("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", intl_messageformat_1.ErrorCode.MISSING_INTL_API));
	    }
	    try {
	        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
	    }
	    catch (e) {
	        config.onError(new error_1.IntlFormatError('Error formatting relative time.', config.locale, e));
	    }
	    return String(value);
	}
	exports.formatRelativeTime = formatRelativeTime;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var backend_1 = __webpack_require__(261);
	var helpers_1 = __webpack_require__(48);
	var integrations_1 = __webpack_require__(75);
	var version_1 = __webpack_require__(149);
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * @see BrowserOptions for documentation on configuration options.
	 * @see SentryClient for usage documentation.
	 */
	var BrowserClient = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserClient, _super);
	    /**
	     * Creates a new Browser SDK instance.
	     *
	     * @param options Configuration options for this SDK.
	     */
	    function BrowserClient(options) {
	        if (options === void 0) { options = {}; }
	        return _super.call(this, backend_1.BrowserBackend, options) || this;
	    }
	    /**
	     * Show a report dialog to the user to send feedback to a specific event.
	     *
	     * @param options Set individual options for the dialog
	     */
	    BrowserClient.prototype.showReportDialog = function (options) {
	        if (options === void 0) { options = {}; }
	        // doesn't work without a document (React Native)
	        var document = utils_1.getGlobalObject().document;
	        if (!document) {
	            return;
	        }
	        if (!this._isEnabled()) {
	            utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
	            return;
	        }
	        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
	        event.platform = event.platform || 'javascript';
	        event.sdk = tslib_1.__assign(tslib_1.__assign({}, event.sdk), { name: version_1.SDK_NAME, packages: tslib_1.__spread(((event.sdk && event.sdk.packages) || []), [
	                {
	                    name: 'npm:@sentry/browser',
	                    version: version_1.SDK_VERSION,
	                },
	            ]), version: version_1.SDK_VERSION });
	        return _super.prototype._prepareEvent.call(this, event, scope, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._sendEvent = function (event) {
	        var integration = this.getIntegration(integrations_1.Breadcrumbs);
	        if (integration) {
	            integration.addSentryBreadcrumb(event);
	        }
	        _super.prototype._sendEvent.call(this, event);
	    };
	    return BrowserClient;
	}(core_1.BaseClient));
	exports.BrowserClient = BrowserClient;
	//# sourceMappingURL=client.js.map

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	var tracekit_1 = __webpack_require__(76);
	var STACKTRACE_LIMIT = 50;
	/**
	 * This function creates an exception from an TraceKitStackTrace
	 * @param stacktrace TraceKitStackTrace that will be converted to an exception
	 * @hidden
	 */
	function exceptionFromStacktrace(stacktrace) {
	    var frames = prepareFramesForEvent(stacktrace.stack);
	    var exception = {
	        type: stacktrace.name,
	        value: stacktrace.message,
	    };
	    if (frames && frames.length) {
	        exception.stacktrace = { frames: frames };
	    }
	    if (exception.type === undefined && exception.value === '') {
	        exception.value = 'Unrecoverable error caught';
	    }
	    return exception;
	}
	exports.exceptionFromStacktrace = exceptionFromStacktrace;
	/**
	 * @hidden
	 */
	function eventFromPlainObject(exception, syntheticException, rejection) {
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: utils_1.isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
	                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
	                },
	            ],
	        },
	        extra: {
	            __serialized__: utils_1.normalizeToSize(exception),
	        },
	    };
	    if (syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromPlainObject = eventFromPlainObject;
	/**
	 * @hidden
	 */
	function eventFromStacktrace(stacktrace) {
	    var exception = exceptionFromStacktrace(stacktrace);
	    return {
	        exception: {
	            values: [exception],
	        },
	    };
	}
	exports.eventFromStacktrace = eventFromStacktrace;
	/**
	 * @hidden
	 */
	function prepareFramesForEvent(stack) {
	    if (!stack || !stack.length) {
	        return [];
	    }
	    var localStack = stack;
	    var firstFrameFunction = localStack[0].func || '';
	    var lastFrameFunction = localStack[localStack.length - 1].func || '';
	    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
	    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
	        localStack = localStack.slice(1);
	    }
	    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
	    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
	        localStack = localStack.slice(0, -1);
	    }
	    // The frame where the crash happened, should be the last entry in the array
	    return localStack
	        .slice(0, STACKTRACE_LIMIT)
	        .map(function (frame) { return ({
	        colno: frame.column === null ? undefined : frame.column,
	        filename: frame.url || localStack[0].url,
	        function: frame.func || '?',
	        in_app: true,
	        lineno: frame.line === null ? undefined : frame.line,
	    }); })
	        .reverse();
	}
	exports.prepareFramesForEvent = prepareFramesForEvent;
	//# sourceMappingURL=parsers.js.map

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var base_1 = __webpack_require__(77);
	exports.BaseTransport = base_1.BaseTransport;
	var fetch_1 = __webpack_require__(269);
	exports.FetchTransport = fetch_1.FetchTransport;
	var xhr_1 = __webpack_require__(270);
	exports.XHRTransport = xhr_1.XHRTransport;
	//# sourceMappingURL=index.js.map

/***/ },
/* 149 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SDK_NAME = 'sentry.javascript.browser';
	exports.SDK_VERSION = '5.30.0';
	//# sourceMappingURL=version.js.map

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	/** Noop transport */
	var NoopTransport = /** @class */ (function () {
	    function NoopTransport() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.sendEvent = function (_) {
	        return utils_1.SyncPromise.resolve({
	            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
	            status: types_1.Status.Skipped,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.close = function (_) {
	        return utils_1.SyncPromise.resolve(true);
	    };
	    return NoopTransport;
	}());
	exports.NoopTransport = NoopTransport;
	//# sourceMappingURL=noop.js.map

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	/**
	 * Holds additional event information. {@link Scope.applyToEvent} will be
	 * called by the client before an event will be sent.
	 */
	var Scope = /** @class */ (function () {
	    function Scope() {
	        /** Flag if notifiying is happening. */
	        this._notifyingListeners = false;
	        /** Callback for client to receive scope changes. */
	        this._scopeListeners = [];
	        /** Callback list that will be called after {@link applyToEvent}. */
	        this._eventProcessors = [];
	        /** Array of breadcrumbs. */
	        this._breadcrumbs = [];
	        /** User */
	        this._user = {};
	        /** Tags */
	        this._tags = {};
	        /** Extra */
	        this._extra = {};
	        /** Contexts */
	        this._contexts = {};
	    }
	    /**
	     * Inherit values from the parent scope.
	     * @param scope to clone.
	     */
	    Scope.clone = function (scope) {
	        var newScope = new Scope();
	        if (scope) {
	            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
	            newScope._tags = tslib_1.__assign({}, scope._tags);
	            newScope._extra = tslib_1.__assign({}, scope._extra);
	            newScope._contexts = tslib_1.__assign({}, scope._contexts);
	            newScope._user = scope._user;
	            newScope._level = scope._level;
	            newScope._span = scope._span;
	            newScope._session = scope._session;
	            newScope._transactionName = scope._transactionName;
	            newScope._fingerprint = scope._fingerprint;
	            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
	        }
	        return newScope;
	    };
	    /**
	     * Add internal on change listener. Used for sub SDKs that need to store the scope.
	     * @hidden
	     */
	    Scope.prototype.addScopeListener = function (callback) {
	        this._scopeListeners.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addEventProcessor = function (callback) {
	        this._eventProcessors.push(callback);
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setUser = function (user) {
	        this._user = user || {};
	        if (this._session) {
	            this._session.update({ user: user });
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getUser = function () {
	        return this._user;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTags = function (tags) {
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTag = function (key, value) {
	        var _a;
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtras = function (extras) {
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtra = function (key, extra) {
	        var _a;
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setFingerprint = function (fingerprint) {
	        this._fingerprint = fingerprint;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setLevel = function (level) {
	        this._level = level;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTransactionName = function (name) {
	        this._transactionName = name;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Can be removed in major version.
	     * @deprecated in favor of {@link this.setTransactionName}
	     */
	    Scope.prototype.setTransaction = function (name) {
	        return this.setTransactionName(name);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setContext = function (key, context) {
	        var _a;
	        if (context === null) {
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this._contexts[key];
	        }
	        else {
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSpan = function (span) {
	        this._span = span;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSpan = function () {
	        return this._span;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getTransaction = function () {
	        var _a, _b, _c, _d;
	        // often, this span will be a transaction, but it's not guaranteed to be
	        var span = this.getSpan();
	        // try it the new way first
	        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
	            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
	        }
	        // fallback to the old way (known bug: this only finds transactions with sampled = true)
	        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
	            return span.spanRecorder.spans[0];
	        }
	        // neither way found a transaction
	        return undefined;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSession = function (session) {
	        if (!session) {
	            delete this._session;
	        }
	        else {
	            this._session = session;
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSession = function () {
	        return this._session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.update = function (captureContext) {
	        if (!captureContext) {
	            return this;
	        }
	        if (typeof captureContext === 'function') {
	            var updatedScope = captureContext(this);
	            return updatedScope instanceof Scope ? updatedScope : this;
	        }
	        if (captureContext instanceof Scope) {
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
	            if (captureContext._user && Object.keys(captureContext._user).length) {
	                this._user = captureContext._user;
	            }
	            if (captureContext._level) {
	                this._level = captureContext._level;
	            }
	            if (captureContext._fingerprint) {
	                this._fingerprint = captureContext._fingerprint;
	            }
	        }
	        else if (utils_1.isPlainObject(captureContext)) {
	            // eslint-disable-next-line no-param-reassign
	            captureContext = captureContext;
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
	            if (captureContext.user) {
	                this._user = captureContext.user;
	            }
	            if (captureContext.level) {
	                this._level = captureContext.level;
	            }
	            if (captureContext.fingerprint) {
	                this._fingerprint = captureContext.fingerprint;
	            }
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clear = function () {
	        this._breadcrumbs = [];
	        this._tags = {};
	        this._extra = {};
	        this._user = {};
	        this._contexts = {};
	        this._level = undefined;
	        this._transactionName = undefined;
	        this._fingerprint = undefined;
	        this._span = undefined;
	        this._session = undefined;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
	        this._breadcrumbs =
	            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
	                ? tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
	                : tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clearBreadcrumbs = function () {
	        this._breadcrumbs = [];
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Applies the current context and fingerprint to the event.
	     * Note that breadcrumbs will be added by the client.
	     * Also if the event has already breadcrumbs on it, we do not merge them.
	     * @param event Event
	     * @param hint May contain additional informartion about the original exception.
	     * @hidden
	     */
	    Scope.prototype.applyToEvent = function (event, hint) {
	        var _a;
	        if (this._extra && Object.keys(this._extra).length) {
	            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
	        }
	        if (this._tags && Object.keys(this._tags).length) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
	        }
	        if (this._user && Object.keys(this._user).length) {
	            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
	        }
	        if (this._contexts && Object.keys(this._contexts).length) {
	            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
	        }
	        if (this._level) {
	            event.level = this._level;
	        }
	        if (this._transactionName) {
	            event.transaction = this._transactionName;
	        }
	        // We want to set the trace context for normal events only if there isn't already
	        // a trace context on the event. There is a product feature in place where we link
	        // errors with transaction and it relys on that.
	        if (this._span) {
	            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
	            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
	            if (transactionName) {
	                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
	            }
	        }
	        this._applyFingerprint(event);
	        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
	        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
	        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
	    };
	    /**
	     * This will be called after {@link applyToEvent} is finished.
	     */
	    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
	        var _this = this;
	        if (index === void 0) { index = 0; }
	        return new utils_1.SyncPromise(function (resolve, reject) {
	            var processor = processors[index];
	            if (event === null || typeof processor !== 'function') {
	                resolve(event);
	            }
	            else {
	                var result = processor(tslib_1.__assign({}, event), hint);
	                if (utils_1.isThenable(result)) {
	                    result
	                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
	                        .then(null, reject);
	                }
	                else {
	                    _this._notifyEventProcessors(processors, result, hint, index + 1)
	                        .then(resolve)
	                        .then(null, reject);
	                }
	            }
	        });
	    };
	    /**
	     * This will be called on every set call.
	     */
	    Scope.prototype._notifyScopeListeners = function () {
	        var _this = this;
	        // We need this check for this._notifyingListeners to be able to work on scope during updates
	        // If this check is not here we'll produce endless recursion when something is done with the scope
	        // during the callback.
	        if (!this._notifyingListeners) {
	            this._notifyingListeners = true;
	            this._scopeListeners.forEach(function (callback) {
	                callback(_this);
	            });
	            this._notifyingListeners = false;
	        }
	    };
	    /**
	     * Applies fingerprint from the scope to the event if there's one,
	     * uses message if there's one instead or get rid of empty fingerprint
	     */
	    Scope.prototype._applyFingerprint = function (event) {
	        // Make sure it's an array first and we actually have something in place
	        event.fingerprint = event.fingerprint
	            ? Array.isArray(event.fingerprint)
	                ? event.fingerprint
	                : [event.fingerprint]
	            : [];
	        // If we have something on the scope, then merge it with event
	        if (this._fingerprint) {
	            event.fingerprint = event.fingerprint.concat(this._fingerprint);
	        }
	        // If we have no data at all, remove empty array default
	        if (event.fingerprint && !event.fingerprint.length) {
	            delete event.fingerprint;
	        }
	    };
	    return Scope;
	}());
	exports.Scope = Scope;
	/**
	 * Retruns the global event processors.
	 */
	function getGlobalEventProcessors() {
	    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
	    var global = utils_1.getGlobalObject();
	    global.__SENTRY__ = global.__SENTRY__ || {};
	    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
	    return global.__SENTRY__.globalEventProcessors;
	    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
	}
	/**
	 * Add a EventProcessor to be kept globally.
	 * @param callback EventProcessor to add
	 */
	function addGlobalEventProcessor(callback) {
	    getGlobalEventProcessors().push(callback);
	}
	exports.addGlobalEventProcessor = addGlobalEventProcessor;
	//# sourceMappingURL=scope.js.map

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	/**
	 * @inheritdoc
	 */
	var Session = /** @class */ (function () {
	    function Session(context) {
	        this.errors = 0;
	        this.sid = utils_1.uuid4();
	        this.timestamp = Date.now();
	        this.started = Date.now();
	        this.duration = 0;
	        this.status = types_1.SessionStatus.Ok;
	        if (context) {
	            this.update(context);
	        }
	    }
	    /** JSDoc */
	    // eslint-disable-next-line complexity
	    Session.prototype.update = function (context) {
	        if (context === void 0) { context = {}; }
	        if (context.user) {
	            if (context.user.ip_address) {
	                this.ipAddress = context.user.ip_address;
	            }
	            if (!context.did) {
	                this.did = context.user.id || context.user.email || context.user.username;
	            }
	        }
	        this.timestamp = context.timestamp || Date.now();
	        if (context.sid) {
	            // Good enough uuid validation. — Kamil
	            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
	        }
	        if (context.did) {
	            this.did = "" + context.did;
	        }
	        if (typeof context.started === 'number') {
	            this.started = context.started;
	        }
	        if (typeof context.duration === 'number') {
	            this.duration = context.duration;
	        }
	        else {
	            this.duration = this.timestamp - this.started;
	        }
	        if (context.release) {
	            this.release = context.release;
	        }
	        if (context.environment) {
	            this.environment = context.environment;
	        }
	        if (context.ipAddress) {
	            this.ipAddress = context.ipAddress;
	        }
	        if (context.userAgent) {
	            this.userAgent = context.userAgent;
	        }
	        if (typeof context.errors === 'number') {
	            this.errors = context.errors;
	        }
	        if (context.status) {
	            this.status = context.status;
	        }
	    };
	    /** JSDoc */
	    Session.prototype.close = function (status) {
	        if (status) {
	            this.update({ status: status });
	        }
	        else if (this.status === types_1.SessionStatus.Ok) {
	            this.update({ status: types_1.SessionStatus.Exited });
	        }
	        else {
	            this.update();
	        }
	    };
	    /** JSDoc */
	    Session.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            sid: "" + this.sid,
	            init: true,
	            started: new Date(this.started).toISOString(),
	            timestamp: new Date(this.timestamp).toISOString(),
	            status: this.status,
	            errors: this.errors,
	            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
	            duration: this.duration,
	            attrs: utils_1.dropUndefinedKeys({
	                release: this.release,
	                environment: this.environment,
	                ip_address: this.ipAddress,
	                user_agent: this.userAgent,
	            }),
	        });
	    };
	    return Session;
	}());
	exports.Session = Session;
	//# sourceMappingURL=session.js.map

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var browsertracing_1 = __webpack_require__(283);
	exports.BrowserTracing = browsertracing_1.BrowserTracing;
	var request_1 = __webpack_require__(154);
	exports.registerRequestInstrumentation = request_1.registerRequestInstrumentation;
	exports.defaultRequestInstrumentationOptions = request_1.defaultRequestInstrumentationOptions;
	//# sourceMappingURL=index.js.map

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var hub_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(9);
	var utils_2 = __webpack_require__(36);
	exports.DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
	exports.defaultRequestInstrumentationOptions = {
	    traceFetch: true,
	    traceXHR: true,
	    tracingOrigins: exports.DEFAULT_TRACING_ORIGINS,
	};
	/** Registers span creators for xhr and fetch requests  */
	function registerRequestInstrumentation(_options) {
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    var _a = tslib_1.__assign(tslib_1.__assign({}, exports.defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	    // We should cache url -> decision so that we don't have to compute
	    // regexp everytime we create a request.
	    var urlMap = {};
	    var defaultShouldCreateSpan = function (url) {
	        if (urlMap[url]) {
	            return urlMap[url];
	        }
	        var origins = tracingOrigins;
	        urlMap[url] =
	            origins.some(function (origin) { return utils_1.isMatchingPattern(url, origin); }) &&
	                !utils_1.isMatchingPattern(url, 'sentry_key');
	        return urlMap[url];
	    };
	    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
	    // That's why we filter out already unwanted Spans from tracingOrigins
	    var shouldCreateSpan = defaultShouldCreateSpan;
	    if (typeof shouldCreateSpanForRequest === 'function') {
	        shouldCreateSpan = function (url) {
	            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
	        };
	    }
	    var spans = {};
	    if (traceFetch) {
	        utils_1.addInstrumentationHandler({
	            callback: function (handlerData) {
	                fetchCallback(handlerData, shouldCreateSpan, spans);
	            },
	            type: 'fetch',
	        });
	    }
	    if (traceXHR) {
	        utils_1.addInstrumentationHandler({
	            callback: function (handlerData) {
	                xhrCallback(handlerData, shouldCreateSpan, spans);
	            },
	            type: 'xhr',
	        });
	    }
	}
	exports.registerRequestInstrumentation = registerRequestInstrumentation;
	/**
	 * Create and track fetch request spans
	 */
	function fetchCallback(handlerData, shouldCreateSpan, spans) {
	    var _a;
	    var currentClientOptions = (_a = hub_1.getCurrentHub()
	        .getClient()) === null || _a === void 0 ? void 0 : _a.getOptions();
	    if (!(currentClientOptions && utils_2.hasTracingEnabled(currentClientOptions)) ||
	        !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
	        return;
	    }
	    if (handlerData.endTimestamp && handlerData.fetchData.__span) {
	        var span = spans[handlerData.fetchData.__span];
	        if (span) {
	            var response = handlerData.response;
	            if (response) {
	                // TODO (kmclb) remove this once types PR goes through
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                span.setHttpStatus(response.status);
	            }
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[handlerData.fetchData.__span];
	        }
	        return;
	    }
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { type: 'fetch' }),
	            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
	            op: 'http',
	        });
	        handlerData.fetchData.__span = span.spanId;
	        spans[span.spanId] = span;
	        var request = (handlerData.args[0] = handlerData.args[0]);
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var options = (handlerData.args[1] = handlerData.args[1] || {});
	        var headers = options.headers;
	        if (utils_1.isInstanceOf(request, Request)) {
	            headers = request.headers;
	        }
	        if (headers) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (typeof headers.append === 'function') {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                headers.append('sentry-trace', span.toTraceparent());
	            }
	            else if (Array.isArray(headers)) {
	                headers = tslib_1.__spread(headers, [['sentry-trace', span.toTraceparent()]]);
	            }
	            else {
	                headers = tslib_1.__assign(tslib_1.__assign({}, headers), { 'sentry-trace': span.toTraceparent() });
	            }
	        }
	        else {
	            headers = { 'sentry-trace': span.toTraceparent() };
	        }
	        options.headers = headers;
	    }
	}
	exports.fetchCallback = fetchCallback;
	/**
	 * Create and track xhr request spans
	 */
	function xhrCallback(handlerData, shouldCreateSpan, spans) {
	    var _a;
	    var currentClientOptions = (_a = hub_1.getCurrentHub()
	        .getClient()) === null || _a === void 0 ? void 0 : _a.getOptions();
	    if (!(currentClientOptions && utils_2.hasTracingEnabled(currentClientOptions)) ||
	        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url)) ||
	        handlerData.xhr.__sentry_own_request__) {
	        return;
	    }
	    var xhr = handlerData.xhr.__sentry_xhr__;
	    // check first if the request has finished and is tracked by an existing span which should now end
	    if (handlerData.endTimestamp && handlerData.xhr.__sentry_xhr_span_id__) {
	        var span = spans[handlerData.xhr.__sentry_xhr_span_id__];
	        if (span) {
	            span.setHttpStatus(xhr.status_code);
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[handlerData.xhr.__sentry_xhr_span_id__];
	        }
	        return;
	    }
	    // if not, create a new span to track it
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
	            description: xhr.method + " " + xhr.url,
	            op: 'http',
	        });
	        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
	        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
	        if (handlerData.xhr.setRequestHeader) {
	            try {
	                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
	            }
	            catch (_) {
	                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
	            }
	        }
	    }
	}
	exports.xhrCallback = xhrCallback;
	//# sourceMappingURL=request.js.map

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(37);
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function htmlTreeAsString(elem) {
	    // try/catch both:
	    // - accessing event.target (see getsentry/raven-js#838, #768)
	    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	    // - can throw an exception in some circumstances.
	    try {
	        var currentElem = elem;
	        var MAX_TRAVERSE_HEIGHT = 5;
	        var MAX_OUTPUT_LEN = 80;
	        var out = [];
	        var height = 0;
	        var len = 0;
	        var separator = ' > ';
	        var sepLength = separator.length;
	        var nextStr = void 0;
	        // eslint-disable-next-line no-plusplus
	        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
	            nextStr = _htmlElementAsString(currentElem);
	            // bail out if
	            // - nextStr is the 'html' element
	            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	            //   (ignore this limit if we are on the first iteration)
	            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
	                break;
	            }
	            out.push(nextStr);
	            len += nextStr.length;
	            currentElem = currentElem.parentNode;
	        }
	        return out.reverse().join(separator);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	exports.htmlTreeAsString = htmlTreeAsString;
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function _htmlElementAsString(el) {
	    var elem = el;
	    var out = [];
	    var className;
	    var classes;
	    var key;
	    var attr;
	    var i;
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push("#" + elem.id);
	    }
	    // eslint-disable-next-line prefer-const
	    className = elem.className;
	    if (className && is_1.isString(className)) {
	        classes = className.split(/\s+/);
	        for (i = 0; i < classes.length; i++) {
	            out.push("." + classes[i]);
	        }
	    }
	    var allowedAttrs = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < allowedAttrs.length; i++) {
	        key = allowedAttrs[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push("[" + key + "=\"" + attr + "\"]");
	        }
	    }
	    return out.join('');
	}
	//# sourceMappingURL=browser.js.map

/***/ },
/* 156 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/**
	 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
	 */
	var Memo = /** @class */ (function () {
	    function Memo() {
	        this._hasWeakSet = typeof WeakSet === 'function';
	        this._inner = this._hasWeakSet ? new WeakSet() : [];
	    }
	    /**
	     * Sets obj to remember.
	     * @param obj Object to remember
	     */
	    Memo.prototype.memoize = function (obj) {
	        if (this._hasWeakSet) {
	            if (this._inner.has(obj)) {
	                return true;
	            }
	            this._inner.add(obj);
	            return false;
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var i = 0; i < this._inner.length; i++) {
	            var value = this._inner[i];
	            if (value === obj) {
	                return true;
	            }
	        }
	        this._inner.push(obj);
	        return false;
	    };
	    /**
	     * Removes object from internal storage.
	     * @param obj Object to forget
	     */
	    Memo.prototype.unmemoize = function (obj) {
	        if (this._hasWeakSet) {
	            this._inner.delete(obj);
	        }
	        else {
	            for (var i = 0; i < this._inner.length; i++) {
	                if (this._inner[i] === obj) {
	                    this._inner.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    };
	    return Memo;
	}());
	exports.Memo = Memo;
	//# sourceMappingURL=memo.js.map

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(86);
	var misc_1 = __webpack_require__(49);
	/**
	 * Tells whether current environment supports ErrorEvent objects
	 * {@link supportsErrorEvent}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsErrorEvent() {
	    try {
	        new ErrorEvent('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsErrorEvent = supportsErrorEvent;
	/**
	 * Tells whether current environment supports DOMError objects
	 * {@link supportsDOMError}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMError() {
	    try {
	        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
	        // 1 argument required, but only 0 present.
	        // @ts-ignore It really needs 1 argument, not 0.
	        new DOMError('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMError = supportsDOMError;
	/**
	 * Tells whether current environment supports DOMException objects
	 * {@link supportsDOMException}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMException() {
	    try {
	        new DOMException('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMException = supportsDOMException;
	/**
	 * Tells whether current environment supports Fetch API
	 * {@link supportsFetch}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsFetch() {
	    if (!('fetch' in misc_1.getGlobalObject())) {
	        return false;
	    }
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsFetch = supportsFetch;
	/**
	 * isNativeFetch checks if the given function is a native implementation of fetch()
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isNativeFetch(func) {
	    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
	}
	/**
	 * Tells whether current environment supports Fetch API natively
	 * {@link supportsNativeFetch}.
	 *
	 * @returns true if `window.fetch` is natively implemented, false otherwise
	 */
	function supportsNativeFetch() {
	    if (!supportsFetch()) {
	        return false;
	    }
	    var global = misc_1.getGlobalObject();
	    // Fast path to avoid DOM I/O
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    if (isNativeFetch(global.fetch)) {
	        return true;
	    }
	    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
	    // so create a "pure" iframe to see if that has native fetch
	    var result = false;
	    var doc = global.document;
	    // eslint-disable-next-line deprecation/deprecation
	    if (doc && typeof doc.createElement === "function") {
	        try {
	            var sandbox = doc.createElement('iframe');
	            sandbox.hidden = true;
	            doc.head.appendChild(sandbox);
	            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                result = isNativeFetch(sandbox.contentWindow.fetch);
	            }
	            doc.head.removeChild(sandbox);
	        }
	        catch (err) {
	            logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
	        }
	    }
	    return result;
	}
	exports.supportsNativeFetch = supportsNativeFetch;
	/**
	 * Tells whether current environment supports ReportingObserver API
	 * {@link supportsReportingObserver}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReportingObserver() {
	    return 'ReportingObserver' in misc_1.getGlobalObject();
	}
	exports.supportsReportingObserver = supportsReportingObserver;
	/**
	 * Tells whether current environment supports Referrer Policy API
	 * {@link supportsReferrerPolicy}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReferrerPolicy() {
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    if (!supportsFetch()) {
	        return false;
	    }
	    try {
	        new Request('_', {
	            referrerPolicy: 'origin',
	        });
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsReferrerPolicy = supportsReferrerPolicy;
	/**
	 * Tells whether current environment supports History API
	 * {@link supportsHistory}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsHistory() {
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var global = misc_1.getGlobalObject();
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var chrome = global.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
	    return !isChromePackagedApp && hasHistoryApi;
	}
	exports.supportsHistory = supportsHistory;
	//# sourceMappingURL=supports.js.map

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
	/* eslint-disable @typescript-eslint/typedef */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var is_1 = __webpack_require__(37);
	/** SyncPromise internal states */
	var States;
	(function (States) {
	    /** Pending */
	    States["PENDING"] = "PENDING";
	    /** Resolved / OK */
	    States["RESOLVED"] = "RESOLVED";
	    /** Rejected / Error */
	    States["REJECTED"] = "REJECTED";
	})(States || (States = {}));
	/**
	 * Thenable class that behaves like a Promise and follows it's interface
	 * but is not async internally
	 */
	var SyncPromise = /** @class */ (function () {
	    function SyncPromise(executor) {
	        var _this = this;
	        this._state = States.PENDING;
	        this._handlers = [];
	        /** JSDoc */
	        this._resolve = function (value) {
	            _this._setResult(States.RESOLVED, value);
	        };
	        /** JSDoc */
	        this._reject = function (reason) {
	            _this._setResult(States.REJECTED, reason);
	        };
	        /** JSDoc */
	        this._setResult = function (state, value) {
	            if (_this._state !== States.PENDING) {
	                return;
	            }
	            if (is_1.isThenable(value)) {
	                value.then(_this._resolve, _this._reject);
	                return;
	            }
	            _this._state = state;
	            _this._value = value;
	            _this._executeHandlers();
	        };
	        // TODO: FIXME
	        /** JSDoc */
	        this._attachHandler = function (handler) {
	            _this._handlers = _this._handlers.concat(handler);
	            _this._executeHandlers();
	        };
	        /** JSDoc */
	        this._executeHandlers = function () {
	            if (_this._state === States.PENDING) {
	                return;
	            }
	            var cachedHandlers = _this._handlers.slice();
	            _this._handlers = [];
	            cachedHandlers.forEach(function (handler) {
	                if (handler.done) {
	                    return;
	                }
	                if (_this._state === States.RESOLVED) {
	                    if (handler.onfulfilled) {
	                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	                        handler.onfulfilled(_this._value);
	                    }
	                }
	                if (_this._state === States.REJECTED) {
	                    if (handler.onrejected) {
	                        handler.onrejected(_this._value);
	                    }
	                }
	                handler.done = true;
	            });
	        };
	        try {
	            executor(this._resolve, this._reject);
	        }
	        catch (e) {
	            this._reject(e);
	        }
	    }
	    /** JSDoc */
	    SyncPromise.resolve = function (value) {
	        return new SyncPromise(function (resolve) {
	            resolve(value);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.reject = function (reason) {
	        return new SyncPromise(function (_, reject) {
	            reject(reason);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.all = function (collection) {
	        return new SyncPromise(function (resolve, reject) {
	            if (!Array.isArray(collection)) {
	                reject(new TypeError("Promise.all requires an array as input."));
	                return;
	            }
	            if (collection.length === 0) {
	                resolve([]);
	                return;
	            }
	            var counter = collection.length;
	            var resolvedCollection = [];
	            collection.forEach(function (item, index) {
	                SyncPromise.resolve(item)
	                    .then(function (value) {
	                    resolvedCollection[index] = value;
	                    counter -= 1;
	                    if (counter !== 0) {
	                        return;
	                    }
	                    resolve(resolvedCollection);
	                })
	                    .then(null, reject);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            _this._attachHandler({
	                done: false,
	                onfulfilled: function (result) {
	                    if (!onfulfilled) {
	                        // TODO: ¯\_(ツ)_/¯
	                        // TODO: FIXME
	                        resolve(result);
	                        return;
	                    }
	                    try {
	                        resolve(onfulfilled(result));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	                onrejected: function (reason) {
	                    if (!onrejected) {
	                        reject(reason);
	                        return;
	                    }
	                    try {
	                        resolve(onrejected(reason));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.catch = function (onrejected) {
	        return this.then(function (val) { return val; }, onrejected);
	    };
	    /** JSDoc */
	    SyncPromise.prototype.finally = function (onfinally) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            var val;
	            var isRejected;
	            return _this.then(function (value) {
	                isRejected = false;
	                val = value;
	                if (onfinally) {
	                    onfinally();
	                }
	            }, function (reason) {
	                isRejected = true;
	                val = reason;
	                if (onfinally) {
	                    onfinally();
	                }
	            }).then(function () {
	                if (isRejected) {
	                    reject(val);
	                    return;
	                }
	                resolve(val);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.toString = function () {
	        return '[object SyncPromise]';
	    };
	    return SyncPromise;
	}());
	exports.SyncPromise = SyncPromise;
	//# sourceMappingURL=syncpromise.js.map

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	var settle = __webpack_require__(320);
	var buildURL = __webpack_require__(166);
	var buildFullPath = __webpack_require__(317);
	var parseHeaders = __webpack_require__(327);
	var isURLSameOrigin = __webpack_require__(325);
	var createError = __webpack_require__(162);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(323);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 161 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(319);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
	    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath'
	  ];
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
	    if (utils.isObject(config2[prop])) {
	      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
	    } else if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (utils.isObject(config1[prop])) {
	      config[prop] = utils.deepMerge(config1[prop]);
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys);
	
	  var otherKeys = Object
	    .keys(config2)
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	
	  return config;
	};


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(21);
	var normalizeHeaderName = __webpack_require__(326);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(159);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(159);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ },
/* 165 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 167 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Конфигурация колонок канбан-доски
	// status < 100 — колонки заявок (по PayoutRequest.status)
	// status >= 100 — виртуальные реестровые колонки (фильтрация по registry.status)
	var STATUS_COLUMNS = [{ status: 0, label: "Создана", color: "#546e7a", bg: "#eceff1" }, { status: 1, label: "Антифрод", color: "#f57f17", bg: "#fff9c4" }, { status: 7, label: "Ожидает выплаты", color: "#0277bd", bg: "#e1f5fe" }, { status: 100, label: "Реестр создан", color: "#7b1fa2", bg: "#f3e5f5", isRegistry: true, registryStatus: [0] }, { status: 101, label: "В работе", color: "#e65100", bg: "#fff3e0", isRegistry: true, registryStatus: [1] }, { status: 102, label: "Обработан", color: "#2e7d32", bg: "#e8f5e9", isRegistry: true, registryStatus: [2, 3] }, { status: 5, label: "Успех", color: "#2e7d32", bg: "#e8f5e9" }, { status: 2, label: "Отклонена", color: "#c62828", bg: "#ffebee" }, { status: 6, label: "Ошибка", color: "#ad1457", bg: "#fce4ec" }];
	
	// Разрешённые переходы при drag & drop: fromStatus → [допустимые toStatus]
	var ALLOWED_TRANSITIONS = {
	    0: [7, 2], // Создана → Ожидает (через антифрод) или Отклонена
	    3: [7], // Реестр → Ожидает (вернуть из реестра)
	    6: [7, 2], // Ошибка → Ожидает или Отклонена
	    7: [2] // Ожидает → Отклонена
	};
	
	function isTransitionAllowed(fromStatus, toStatus) {
	    var allowed = ALLOWED_TRANSITIONS[fromStatus];
	    if (!allowed) return false;
	    return allowed.indexOf(toStatus) >= 0;
	}
	
	function formatAmount(amount) {
	    if (amount === null || amount === undefined) return "-";
	    var value = Number(amount);
	    return value.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20BD";
	}
	
	function formatDate(dateStr) {
	    if (!dateStr) return "";
	    var d = new Date(dateStr);
	    return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
	}
	
	// Проверить, попадает ли реестр в колонку по статусу
	function matchRegistryStatus(registryStatus, allowedStatuses) {
	    return allowedStatuses.indexOf(registryStatus) >= 0;
	}
	
	// Статусы заявок, у которых есть своя колонка (без виртуальных реестровых)
	function boardRequestStatuses() {
	    return STATUS_COLUMNS.filter(function (col) {
	        return !col.isRegistry;
	    }).map(function (col) {
	        return col.status;
	    });
	}
	
	// Клик по бейджу статуса -> какие колонки показать.
	// Статус 3 ("В реестре") своей колонки не имеет: такие заявки лежат в реестрах,
	// поэтому показываем все три реестровые колонки.
	function columnsForQuickStatus(status) {
	    if (status === null || status === undefined) return null;
	    if (Number(status) === 3) return [100, 101, 102];
	    return [Number(status)];
	}
	
	exports.STATUS_COLUMNS = STATUS_COLUMNS;
	exports.ALLOWED_TRANSITIONS = ALLOWED_TRANSITIONS;
	exports.isTransitionAllowed = isTransitionAllowed;
	exports.formatAmount = formatAmount;
	exports.formatDate = formatDate;
	exports.matchRegistryStatus = matchRegistryStatus;
	exports.boardRequestStatuses = boardRequestStatuses;
	exports.columnsForQuickStatus = columnsForQuickStatus;
	exports.default = {
	    STATUS_COLUMNS: STATUS_COLUMNS,
	    ALLOWED_TRANSITIONS: ALLOWED_TRANSITIONS,
	    isTransitionAllowed: isTransitionAllowed,
	    formatAmount: formatAmount,
	    formatDate: formatDate,
	    matchRegistryStatus: matchRegistryStatus,
	    boardRequestStatuses: boardRequestStatuses,
	    columnsForQuickStatus: columnsForQuickStatus
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(544);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Права с битовыми значениями (должны совпадать с бэкендом)
	var PERMISSIONS = {
	    TRANSACTION_CANCELLING: 1,
	    TRANSACTION_LIMIT_SETTING: 2,
	    STATISTICS_ACCESS: 4,
	    MAIL_ALERT_SETTING: 8,
	    PAYOUT_REGISTRY_PROCESS: 16,
	    PAYOUT_REGISTRY_VIEW: 32,
	    PAYOUT_REGISTRY_REPORT: 64,
	    PAYOUT_REGISTRIES_LIST: 128,
	    PREPAID_CARDS_VIEW: 256,
	    PREPAID_CARDS_ACTIVATE: 512,
	    STATISTICS_REPORT_1C_VIEW: 1024,
	    ACCESS_PAYOUTS: 2048,
	    ACCESS_METAL: 4096,
	    ACCESS_SBP_REGISTRY: 8192,
	    ACCESS_SBP_PAYOUT: 16384,
	    ACCESS_ANTIFRAUD_FILE: 32768,
	    ACCESS_ANTIFRAUD_SINGLE: 65536,
	    ACCESS_STATEMENT: 131072
	};
	
	// Названия прав на русском
	var PERMISSION_LABELS = {
	    TRANSACTION_CANCELLING: 'Отмена операции',
	    TRANSACTION_LIMIT_SETTING: 'Лимиты операций',
	    STATISTICS_ACCESS: 'Статистика и аналитика',
	    MAIL_ALERT_SETTING: 'Email-уведомления',
	    PAYOUT_REGISTRY_PROCESS: 'Загрузка реестров',
	    PAYOUT_REGISTRY_VIEW: 'Просмотр реестра',
	    PAYOUT_REGISTRY_REPORT: 'Выгрузка отчёта',
	    PAYOUT_REGISTRIES_LIST: 'Список реестров',
	    PREPAID_CARDS_VIEW: 'Предоплаченные карты',
	    PREPAID_CARDS_ACTIVATE: 'Активация карт',
	    STATISTICS_REPORT_1C_VIEW: 'Выгрузка 1С',
	    ACCESS_PAYOUTS: 'Разовые выплаты',
	    ACCESS_METAL: 'Драгоценные металлы (ПСА)',
	    ACCESS_SBP_REGISTRY: 'Реестры СБП',
	    ACCESS_SBP_PAYOUT: 'Выплаты СБП',
	    ACCESS_ANTIFRAUD_FILE: 'Антифрод: проверка файла',
	    ACCESS_ANTIFRAUD_SINGLE: 'Антифрод: разовая проверка',
	    ACCESS_STATEMENT: 'Выписка по балансу'
	};
	
	// Описания прав — что именно они открывают в интерфейсе
	var PERMISSION_DESCRIPTIONS = {
	    TRANSACTION_CANCELLING: 'Кнопка «Отправить» в разделе разовых выплат',
	    TRANSACTION_LIMIT_SETTING: 'Настройка лимитов на размер операции (в разработке)',
	    STATISTICS_ACCESS: 'Доступ к разделу статистики и аналитических данных',
	    MAIL_ALERT_SETTING: 'Настройка уведомлений по электронной почте (в разработке)',
	    PAYOUT_REGISTRY_PROCESS: '\u041C\u0435\u043D\u044E \xAB\u0424\u0438\u043D\u0430\u043D\u0441\u044B \u2192 \u0420\u0435\u0435\u0441\u0442\u0440\u044B\xBB. \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0444\u0430\u0439\u043B\u043E\u0432 \u0434\u043B\u044F \u043C\u0430\u0441\u0441\u043E\u0432\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442',
	    PAYOUT_REGISTRY_VIEW: 'Детальный просмотр содержимого реестра и его транзакций',
	    PAYOUT_REGISTRY_REPORT: 'Скачивание отчёта по реестру в Excel',
	    PAYOUT_REGISTRIES_LIST: 'Страница «Выплаты» со списком всех реестров',
	    PREPAID_CARDS_VIEW: 'Меню «Предоплаченные карты». Просмотр списка карт и их статусов',
	    PREPAID_CARDS_ACTIVATE: 'Активация предоплаченной карты через заполнение KYC-данных',
	    STATISTICS_REPORT_1C_VIEW: 'Виджет выгрузки отчёта в формате 1С на страницах транзакций и выплат',
	    ACCESS_PAYOUTS: '\u041C\u0435\u043D\u044E \xAB\u0424\u0438\u043D\u0430\u043D\u0441\u044B \u2192 \u0420\u0430\u0437\u043E\u0432\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B\xBB. \u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043E\u0434\u0438\u043D\u043E\u0447\u043D\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442',
	    ACCESS_METAL: '\u041C\u0435\u043D\u044E \xAB\u0424\u0438\u043D\u0430\u043D\u0441\u044B \u2192 \u0414\u0440\u0430\u0433\u043E\u0446\u0435\u043D\u043D\u044B\u0435 \u043C\u0435\u0442\u0430\u043B\u043B\u044B\xBB. \u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C\u0438 \u041F\u0421\u0410',
	    ACCESS_SBP_REGISTRY: 'Меню «Мобильные реестры» и «Реестры СБП». Загрузка реестров через СБП',
	    ACCESS_SBP_PAYOUT: '\u041C\u0435\u043D\u044E \xAB\u0424\u0438\u043D\u0430\u043D\u0441\u044B \u2192 \u0412\u044B\u043F\u043B\u0430\u0442\u044B \u0421\u0411\u041F\xBB. \u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043E\u0434\u0438\u043D\u043E\u0447\u043D\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442 \u0447\u0435\u0440\u0435\u0437 \u0421\u0411\u041F',
	    ACCESS_ANTIFRAUD_FILE: '\u041C\u0435\u043D\u044E \xAB\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434 \u2192 \u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0444\u0430\u0439\u043B\u0430\xBB. \u041F\u0430\u043A\u0435\u0442\u043D\u0430\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0438\u0437 CSV/XLSX',
	    ACCESS_ANTIFRAUD_SINGLE: '\u041C\u0435\u043D\u044E \xAB\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434 \u2192 \u0420\u0430\u0437\u043E\u0432\u0430\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\xBB. \u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043E\u0434\u043D\u043E\u0433\u043E PAN/\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430/\u0418\u041D\u041D',
	    ACCESS_STATEMENT: 'Меню «Выписка». Просмотр журнала операций по балансу и экспорт в Excel'
	};
	
	// Группы прав для каскадных переключателей
	var PERMISSION_GROUPS = [{
	    code: 'TRANSACTIONS',
	    label: 'Транзакции',
	    permissions: ['TRANSACTION_CANCELLING', 'TRANSACTION_LIMIT_SETTING']
	}, {
	    code: 'STATISTICS',
	    label: 'Статистика',
	    permissions: ['STATISTICS_ACCESS', 'STATISTICS_REPORT_1C_VIEW']
	}, {
	    code: 'PAYOUT_REGISTRY',
	    label: 'Реестры выплат',
	    permissions: ['PAYOUT_REGISTRY_PROCESS', 'PAYOUT_REGISTRY_VIEW', 'PAYOUT_REGISTRY_REPORT', 'PAYOUT_REGISTRIES_LIST']
	}, {
	    code: 'PREPAID_CARDS',
	    label: 'Предоплаченные карты',
	    permissions: ['PREPAID_CARDS_VIEW', 'PREPAID_CARDS_ACTIVATE']
	}, {
	    code: 'SBP',
	    label: 'СБП (Система быстрых платежей)',
	    permissions: ['ACCESS_SBP_REGISTRY', 'ACCESS_SBP_PAYOUT']
	}, {
	    code: 'ANTIFRAUD',
	    label: 'Антифрод система',
	    permissions: ['ACCESS_ANTIFRAUD_FILE', 'ACCESS_ANTIFRAUD_SINGLE']
	}, {
	    code: 'BALANCE',
	    label: 'Баланс и выписка',
	    permissions: ['ACCESS_STATEMENT']
	}, {
	    code: 'OTHER',
	    label: 'Прочее',
	    permissions: ['MAIL_ALERT_SETTING', 'ACCESS_PAYOUTS', 'ACCESS_METAL']
	}];
	
	function PermissionsEditor(_ref) {
	    var _this = this;
	
	    var token = _ref.token,
	        accountId = _ref.accountId,
	        merchantUuid = _ref.merchantUuid,
	        onClose = _ref.onClose,
	        onSaved = _ref.onSaved,
	        isGlobal = _ref.isGlobal,
	        readOnly = _ref.readOnly,
	        readOnlyMessage = _ref.readOnlyMessage,
	        initialPrivileges = _ref.initialPrivileges;
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)(initialPrivileges || 0),
	        _useState2 = _slicedToArray(_useState, 2),
	        privileges = _useState2[0],
	        setPrivileges = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isLoading = _useState4[0],
	        setIsLoading = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        isSaving = _useState6[0],
	        setIsSaving = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({}),
	        _useState8 = _slicedToArray(_useState7, 2),
	        expandedGroups = _useState8[0],
	        setExpandedGroups = _useState8[1];
	
	    // Загрузка текущих прав
	
	
	    (0, _react.useEffect)(function () {
	        if (!accountId) return;
	
	        if (isGlobal) {
	            // Глобальные права: загрузка из /account/{id}/global-permissions
	            setIsLoading(true);
	            new _Api2.default({ token: token }).getGlobalPermissions(accountId).then(function (data) {
	                setPrivileges(data.privileges || 0);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                console.error('Failed to load global permissions:', err);
	                onMessage({ type: 'error', message: 'Не удалось загрузить глобальные права' });
	            }).finally(function () {
	                return setIsLoading(false);
	            });
	        } else if (merchantUuid) {
	            // Per-merchant права
	            setIsLoading(true);
	            new _Api2.default({ token: token }).getAccountMerchantPermissions(accountId, merchantUuid).then(function (data) {
	                setPrivileges(data.privileges || 0);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                console.error('Failed to load permissions:', err);
	                onMessage({ type: 'error', message: 'Не удалось загрузить права' });
	            }).finally(function () {
	                return setIsLoading(false);
	            });
	        } else {
	            // Если нет merchantUuid и не isGlobal - используем initialPrivileges
	            setPrivileges(initialPrivileges || 0);
	            setIsLoading(false);
	        }
	    }, [token, accountId, merchantUuid, isGlobal, onMessage, initialPrivileges]);
	
	    // Проверка, включено ли право
	    var hasPermission = (0, _react.useCallback)(function (permCode) {
	        var bit = PERMISSIONS[permCode];
	        return (privileges & bit) === bit;
	    }, [privileges]);
	
	    // Проверка состояния группы: all, some, none
	    var getGroupState = (0, _react.useCallback)(function (group) {
	        var enabledCount = group.permissions.filter(function (p) {
	            return hasPermission(p);
	        }).length;
	        if (enabledCount === 0) return 'none';
	        if (enabledCount === group.permissions.length) return 'all';
	        return 'some';
	    }, [hasPermission]);
	
	    // Переключение одного права
	    var togglePermission = function togglePermission(permCode) {
	        if (readOnly) return;
	        var bit = PERMISSIONS[permCode];
	        setPrivileges(function (prev) {
	            return (prev & bit) === bit ? prev & ~bit : prev | bit;
	        });
	    };
	
	    // Переключение всей группы (каскад)
	    var toggleGroup = function toggleGroup(group) {
	        if (readOnly) return;
	        var state = getGroupState(group);
	        var newPriv = privileges;
	
	        if (state === 'all') {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = group.permissions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var p = _step.value;
	
	                    newPriv &= ~PERMISSIONS[p];
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        } else {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = group.permissions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _p = _step2.value;
	
	                    newPriv |= PERMISSIONS[_p];
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	
	        setPrivileges(newPriv);
	    };
	
	    // Развернуть/свернуть группу
	    var toggleExpand = function toggleExpand(groupCode) {
	        setExpandedGroups(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, groupCode, !prev[groupCode]));
	        });
	    };
	
	    // Сохранение
	    var savePermissions = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!readOnly) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            setIsSaving(true);
	                            _context.prev = 3;
	
	                            if (!isGlobal) {
	                                _context.next = 10;
	                                break;
	                            }
	
	                            _context.next = 7;
	                            return new _Api2.default({ token: token }).updateGlobalPermissions(accountId, true, privileges);
	
	                        case 7:
	                            onMessage({ type: 'success', message: 'Глобальные права сохранены' });
	                            _context.next = 13;
	                            break;
	
	                        case 10:
	                            _context.next = 12;
	                            return new _Api2.default({ token: token }).updateAccountMerchantPermissions(accountId, merchantUuid, privileges);
	
	                        case 12:
	                            onMessage({ type: 'success', message: 'Права успешно сохранены' });
	
	                        case 13:
	                            if (onSaved) onSaved(privileges);
	                            if (onClose) onClose();
	                            _context.next = 21;
	                            break;
	
	                        case 17:
	                            _context.prev = 17;
	                            _context.t0 = _context['catch'](3);
	
	                            console.error('Failed to save permissions:', _context.t0);
	                            onMessage({ type: 'error', message: 'Не удалось сохранить права' });
	
	                        case 21:
	                            _context.prev = 21;
	
	                            setIsSaving(false);
	                            return _context.finish(21);
	
	                        case 24:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this, [[3, 17, 21, 24]]);
	        }));
	
	        return function savePermissions() {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    // Выбрать все / снять все
	    var selectAll = function selectAll() {
	        if (readOnly) return;
	        var allBits = 0;
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = Object.values(PERMISSIONS)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var bit = _step3.value;
	
	                allBits |= bit;
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        setPrivileges(allBits);
	    };
	
	    var clearAll = function clearAll() {
	        if (readOnly) return;
	        setPrivileges(0);
	    };
	
	    if (isLoading) {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Container },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Loading },
	                '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u0440\u0430\u0432...'
	            )
	        );
	    }
	
	    var title = isGlobal ? 'Глобальные права пользователя' : readOnly ? 'Права пользователя на проекте (только чтение)' : 'Права пользователя на проекте';
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Container },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Header },
	            _react2.default.createElement(
	                'h4',
	                { className: _stylesModule2.default.Title },
	                title
	            ),
	            !readOnly && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.QuickActions },
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: _stylesModule2.default.BtnLink, onClick: selectAll },
	                    '\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435'
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.Separator },
	                    '|'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: _stylesModule2.default.BtnLink, onClick: clearAll },
	                    '\u0421\u043D\u044F\u0442\u044C \u0432\u0441\u0435'
	                )
	            )
	        ),
	        readOnly && readOnlyMessage && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.ReadOnlyBanner },
	            readOnlyMessage
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.GroupsList },
	            PERMISSION_GROUPS.map(function (group) {
	                var state = getGroupState(group);
	                var isExpanded = expandedGroups[group.code] !== false; // по умолчанию развернуты
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: group.code, className: _stylesModule2.default.Group },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.GroupHeader, onClick: function onClick() {
	                                return toggleExpand(group.code);
	                            } },
	                        _react2.default.createElement(
	                            'label',
	                            { className: _stylesModule2.default.GroupToggle, onClick: function onClick(e) {
	                                    return e.stopPropagation();
	                                } },
	                            _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                checked: state === 'all',
	                                ref: function ref(el) {
	                                    if (el) el.indeterminate = state === 'some';
	                                },
	                                onChange: function onChange() {
	                                    return toggleGroup(group);
	                                },
	                                disabled: readOnly
	                            }),
	                            _react2.default.createElement('span', { className: _stylesModule2.default.Checkbox })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.GroupLabel },
	                            group.label
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.GroupCount },
	                            '(',
	                            group.permissions.filter(function (p) {
	                                return hasPermission(p);
	                            }).length,
	                            '/',
	                            group.permissions.length,
	                            ')'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.ExpandIcon + ' ' + (isExpanded ? _stylesModule2.default.Expanded : '') },
	                            '\u25BC'
	                        )
	                    ),
	                    isExpanded && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.PermissionsList },
	                        group.permissions.map(function (permCode) {
	                            return _react2.default.createElement(
	                                'label',
	                                {
	                                    key: permCode,
	                                    className: _stylesModule2.default.PermissionItem + ' ' + (readOnly ? _stylesModule2.default.PermissionItemReadOnly : '')
	                                },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: hasPermission(permCode),
	                                    onChange: function onChange() {
	                                        return togglePermission(permCode);
	                                    },
	                                    disabled: readOnly
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.Checkbox }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.PermissionText },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _stylesModule2.default.PermissionLabel },
	                                        PERMISSION_LABELS[permCode] || permCode
	                                    ),
	                                    PERMISSION_DESCRIPTIONS[permCode] && _react2.default.createElement(
	                                        'span',
	                                        { className: _stylesModule2.default.PermissionDescription },
	                                        PERMISSION_DESCRIPTIONS[permCode]
	                                    )
	                                )
	                            );
	                        })
	                    )
	                );
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Footer },
	            !readOnly && _react2.default.createElement(
	                'button',
	                { type: 'button', className: _stylesModule2.default.BtnPrimary, onClick: savePermissions, disabled: isSaving },
	                isSaving ? 'Сохранение...' : 'Сохранить права'
	            ),
	            onClose && _react2.default.createElement(
	                'button',
	                { type: 'button', className: _stylesModule2.default.BtnSecondary, onClick: onClose, disabled: isSaving },
	                readOnly ? 'Закрыть' : 'Отмена'
	            )
	        )
	    );
	}
	
	exports.default = PermissionsEditor;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _stylesModule = __webpack_require__(548);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _authSchemas = __webpack_require__(378);
	
	var _capabilities = __webpack_require__(379);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Рендерит секцию "Ключи интеграции" для терминала.
	 *
	 * Если для протокола есть схема в authSchemas — рендерим поля с русскими лейблами,
	 * textarea для PEM-ключей, поддержка двух источников (processingAuth vs nodaBank).
	 *
	 * Если протокол неизвестен — fallback на старый flat-вью processingAuth
	 * (все ключи как plain input). Это даёт обратную совместимость для старых
	 * протоколов которые не добавлены в схему.
	 */
	function renderAuthFields(terminal, form, onAuthFieldChange, isSaving) {
	    var protocol = terminal && terminal.processingProtocol;
	    var schema = (0, _authSchemas.getAuthSchema)(protocol);
	
	    if (schema) {
	        return renderSchemaAuth(schema, form, onAuthFieldChange, isSaving);
	    }
	    return renderLegacyAuth(form, onAuthFieldChange, isSaving);
	}
	
	function renderSchemaAuth(schema, form, onAuthFieldChange, isSaving) {
	    // Делим схему на основную часть и "advanced" (свёрнутая секция).
	    // Advanced включает тестовые fallback-значения (ФИО получателя default,
	    // счёт отправителя default), которые мешают в основном UI.
	    var main = [];
	    var advanced = [];
	    var advancedSection = null;
	    schema.forEach(function (item) {
	        if (item.advanced) {
	            if (item.section) {
	                advancedSection = item;
	            } else {
	                advanced.push(item);
	            }
	        } else {
	            main.push(item);
	        }
	    });
	    return _react2.default.createElement(
	        'div',
	        null,
	        renderSchemaGrid(main, form, onAuthFieldChange, isSaving, 'main'),
	        advanced.length > 0 && _react2.default.createElement(
	            'details',
	            { style: { marginTop: 12 } },
	            _react2.default.createElement(
	                'summary',
	                {
	                    style: {
	                        fontSize: 13,
	                        fontWeight: 600,
	                        color: '#2479E0',
	                        cursor: 'pointer',
	                        padding: '6px 0'
	                    }
	                },
	                advancedSection && advancedSection.section || 'Дополнительные настройки'
	            ),
	            advancedSection && advancedSection.advancedHint && _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        fontSize: 12,
	                        color: '#666',
	                        margin: '4px 0 10px',
	                        lineHeight: 1.5
	                    }
	                },
	                advancedSection.advancedHint
	            ),
	            renderSchemaGrid(advanced, form, onAuthFieldChange, isSaving, 'adv')
	        )
	    );
	}
	
	function renderSchemaGrid(schemaItems, form, onAuthFieldChange, isSaving, keyPrefix) {
	    var items = [];
	    var idx = 0;
	    schemaItems.forEach(function (item) {
	        if (item.section) {
	            items.push(_react2.default.createElement(
	                'div',
	                {
	                    key: keyPrefix + '-section-' + idx++,
	                    style: {
	                        gridColumn: '1 / -1',
	                        fontSize: 13,
	                        fontWeight: 600,
	                        color: '#2479E0',
	                        marginTop: 8,
	                        marginBottom: 4
	                    }
	                },
	                item.section
	            ));
	            return;
	        }
	        var source = item.source || 'processingAuth';
	        var bucket = form && form[source] || {};
	        var value = bucket[item.key] != null ? bucket[item.key] : '';
	        var inputProps = {
	            value: value,
	            onChange: function onChange(e) {
	                onAuthFieldChange(source, item.key, e.target.value);
	            },
	            placeholder: item.placeholder || '',
	            disabled: isSaving,
	            style: { width: '100%' }
	        };
	        items.push(_react2.default.createElement(
	            'label',
	            {
	                key: keyPrefix + '-' + source + '.' + item.key,
	                style: item.multiline ? { gridColumn: '1 / -1' } : {}
	            },
	            _react2.default.createElement(
	                'span',
	                { style: { display: 'block', fontSize: 12, color: '#444', marginBottom: 2 } },
	                item.label
	            ),
	            item.multiline ? _react2.default.createElement('textarea', Object.assign({}, inputProps, {
	                rows: 6,
	                style: {
	                    width: '100%',
	                    fontFamily: 'monospace',
	                    fontSize: 11,
	                    resize: 'vertical'
	                }
	            })) : _react2.default.createElement('input', Object.assign({ type: 'text' }, inputProps)),
	            item.hint && _react2.default.createElement(
	                'span',
	                { style: { display: 'block', fontSize: 11, color: '#888', marginTop: 2 } },
	                item.hint
	            )
	        ));
	    });
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 } },
	        items
	    );
	}
	
	function renderLegacyAuth(form, onAuthFieldChange, isSaving) {
	    var keys = Object.keys(form && form.processingAuth || {});
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 } },
	        keys.length === 0 && _react2.default.createElement(
	            'div',
	            { style: { gridColumn: '1 / -1', opacity: 0.7 } },
	            '\u041D\u0435\u0442 \u043A\u043B\u044E\u0447\u0435\u0439 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438'
	        ),
	        keys.map(function (k) {
	            return _react2.default.createElement(
	                'label',
	                { key: k },
	                k,
	                _react2.default.createElement('input', {
	                    type: 'text',
	                    value: form.processingAuth && form.processingAuth[k] || '',
	                    onChange: function onChange(e) {
	                        onAuthFieldChange('processingAuth', k, e.target.value);
	                    },
	                    style: { width: '100%' },
	                    disabled: isSaving
	                })
	            );
	        })
	    );
	}
	
	function TerminalEditing(props) {
	    var _this = this;
	
	    var save = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var api, payload;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(!form.id || !form.projectUuid)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            setIsSaving(true);
	                            api = new _Api2.default({ token: token });
	                            _context.prev = 4;
	                            payload = {
	                                name: form.name,
	                                status: parseInt(form.status, 10),
	                                processingAuth: form.processingAuth || {},
	                                data: {
	                                    isSBP: !!form.isSBP,
	                                    preAuth: !!form.preAuth,
	                                    recurring: !!form.recurring,
	                                    partialRefund: !!form.partialRefund,
	                                    partialReversal: !!form.partialReversal,
	                                    paymentMethod: form.paymentMethod || null,
	                                    h2h: !!form.h2h,
	                                    crmPayoutEnabled: !!form.crmPayoutEnabled,
	                                    crmSbpPayoutEnabled: !!form.crmSbpPayoutEnabled,
	                                    returnUrl: form.returnUrl || null,
	                                    webhookUrl: form.webhookUrl || null,
	                                    exchangeRate: form.exchangeRate !== '' ? form.exchangeRate : null,
	                                    bankAccount: form.bankAccount || null,
	                                    nodaBank: form.nodaBank && Object.keys(form.nodaBank).length > 0 ? form.nodaBank : undefined
	                                }
	                            };
	                            _context.next = 8;
	                            return api.updateTerminal(form.projectUuid, form.id, payload);
	
	                        case 8:
	                            if (!(form.providerUuid && terminal && terminal.providerUuid !== form.providerUuid)) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.next = 11;
	                            return api.updateServiceProvider(form.projectUuid, form.id, form.providerUuid);
	
	                        case 11:
	
	                            onMessage({
	                                type: 'success',
	                                message: intl.formatMessage({ id: 'TerminalEditing.success.saved' })
	                            });
	                            if (typeof props.onSaved === 'function') props.onSaved();
	                            _context.next = 19;
	                            break;
	
	                        case 15:
	                            _context.prev = 15;
	                            _context.t0 = _context['catch'](4);
	
	                            Sentry.captureException(_context.t0);
	                            onMessage({
	                                type: 'error',
	                                message: intl.formatMessage({ id: 'TerminalEditing.error.save' })
	                            });
	
	                        case 19:
	                            _context.prev = 19;
	
	                            setIsSaving(false);
	                            return _context.finish(19);
	
	                        case 22:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[4, 15, 19, 22]]);
	        }));
	
	        return function save() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    var saveLimits = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var api, payload;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (!(!form.id || !form.projectUuid)) {
	                                _context2.next = 2;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 2:
	                            setIsLimitsSaving(true);
	                            api = new _Api2.default({ token: token });
	                            payload = {
	                                limits: {
	                                    payment: Object.fromEntries(Object.entries(limits.payment).map(function (_ref3) {
	                                        var _ref4 = _slicedToArray(_ref3, 2),
	                                            k = _ref4[0],
	                                            v = _ref4[1];
	
	                                        return [k, v === null ? null : Number(v)];
	                                    })),
	                                    payout: Object.fromEntries(Object.entries(limits.payout).map(function (_ref5) {
	                                        var _ref6 = _slicedToArray(_ref5, 2),
	                                            k = _ref6[0],
	                                            v = _ref6[1];
	
	                                        return [k, v === null ? null : Number(v)];
	                                    })),
	                                    velocity: Object.fromEntries(Object.entries(limits.velocity).map(function (_ref7) {
	                                        var _ref8 = _slicedToArray(_ref7, 2),
	                                            k = _ref8[0],
	                                            v = _ref8[1];
	
	                                        return [k, v === null ? null : Number(v)];
	                                    }))
	                                },
	                                payoutLimit: payoutLimit === null || payoutLimit === '' ? null : Number(payoutLimit)
	                            };
	                            _context2.prev = 5;
	                            _context2.next = 8;
	                            return api.updateTerminalLimits(form.projectUuid, form.id, payload);
	
	                        case 8:
	                            onMessage({
	                                type: 'success',
	                                message: intl.formatMessage({ id: 'TerminalEditing.success.limitsSaved' })
	                            });
	                            _context2.next = 15;
	                            break;
	
	                        case 11:
	                            _context2.prev = 11;
	                            _context2.t0 = _context2['catch'](5);
	
	                            Sentry.captureException(_context2.t0);
	                            onMessage({
	                                type: 'error',
	                                message: intl.formatMessage({ id: 'TerminalEditing.error.saveLimits' })
	                            });
	
	                        case 15:
	                            _context2.prev = 15;
	
	                            setIsLimitsSaving(false);
	                            return _context2.finish(15);
	
	                        case 18:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[5, 11, 15, 18]]);
	        }));
	
	        return function saveLimits() {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    var intl = (0, _reactIntl.useIntl)();
	    var terminal = props.terminal || null;
	    var token = props.token;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isSaving = _useState2[0],
	        setIsSaving = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isLimitsSaving = _useState4[0],
	        setIsLimitsSaving = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        isLimitsLoading = _useState6[0],
	        setIsLimitsLoading = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({}),
	        _useState8 = _slicedToArray(_useState7, 2),
	        form = _useState8[0],
	        setForm = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({
	        payment: { min: null, max: null, daily: null, monthly: null },
	        payout: { min: null, max: null, daily: null, monthly: null },
	        velocity: { perMinute: null, perHour: null, perDay: null }
	    }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        limits = _useState10[0],
	        setLimits = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        payoutLimit = _useState12[0],
	        setPayoutLimit = _useState12[1];
	
	    var mounted = (0, _react.useRef)(true);
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState13 = (0, _react.useState)([]),
	        _useState14 = _slicedToArray(_useState13, 2),
	        providers = _useState14[0],
	        setProviders = _useState14[1];
	
	    (0, _react.useEffect)(function () {
	        mounted.current = true;
	
	        if (terminal && terminal.id) {
	            var raw = terminal.rawData || terminal.data || {};
	            setForm({
	                id: terminal.id,
	                projectUuid: terminal.merchantUuid || terminal.projectUuid || '',
	                name: terminal.name || '',
	                status: typeof terminal.status === 'number' ? terminal.status : 1,
	                processingAuth: raw.processingAuth || terminal.processingAuth || {},
	                nodaBank: raw.nodaBank || {},
	                bankAccount: raw.bankAccount || terminal.bankAccount || '',
	                paymentMethod: raw.paymentMethod || terminal.paymentMethod || '',
	                returnUrl: raw.returnUrl || terminal.returnUrl || '',
	                webhookUrl: raw.webhookUrl || terminal.webhookUrl || '',
	                exchangeRate: raw.exchangeRate !== undefined ? raw.exchangeRate : typeof terminal.exchangeRate === 'number' || terminal.exchangeRate === null ? terminal.exchangeRate : null,
	                isSBP: !!(raw.isSBP !== undefined ? raw.isSBP : terminal.isSBP),
	                preAuth: !!(raw.preAuth !== undefined ? raw.preAuth : terminal.preAuth),
	                recurring: !!(raw.recurring !== undefined ? raw.recurring : terminal.recurring),
	                partialRefund: !!(raw.partialRefund !== undefined ? raw.partialRefund : terminal.partialRefund),
	                partialReversal: !!(raw.partialReversal !== undefined ? raw.partialReversal : terminal.partialReversal),
	                h2h: !!(raw.h2h !== undefined ? raw.h2h : terminal.h2h),
	                crmPayoutEnabled: !!raw.crmPayoutEnabled,
	                crmSbpPayoutEnabled: !!raw.crmSbpPayoutEnabled,
	                providerUuid: terminal.providerUuid || ''
	            });
	
	            setIsLimitsLoading(true);
	            new _Api2.default({ token: token }).getTerminalLimits(terminal.merchantUuid || terminal.projectUuid, terminal.id).then(function (r) {
	                if (mounted.current && r && r.data && r.data.success) {
	                    var defaultLimits = {
	                        payment: { min: null, max: null, daily: null, monthly: null },
	                        payout: { min: null, max: null, daily: null, monthly: null },
	                        velocity: { perMinute: null, perHour: null, perDay: null }
	                    };
	
	                    var loaded = r.data.limits || {};
	                    var merged = {
	                        payment: Object.assign({}, defaultLimits.payment, loaded.payment || {}),
	                        payout: Object.assign({}, defaultLimits.payout, loaded.payout || {}),
	                        velocity: Object.assign({}, defaultLimits.velocity, loaded.velocity || {})
	                    };
	
	                    setLimits(merged);
	                    setPayoutLimit(r.data.payoutLimit != null ? r.data.payoutLimit : null);
	                }
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                onMessage({
	                    type: 'error',
	                    message: intl.formatMessage({ id: 'TerminalEditing.error.loadLimits' })
	                });
	            }).finally(function () {
	                if (mounted.current) {
	                    setIsLimitsLoading(false);
	                }
	            });
	        } else {
	            setForm({});
	            setLimits({
	                payment: { min: null, max: null, daily: null, monthly: null },
	                payout: { min: null, max: null, daily: null, monthly: null },
	                velocity: { perMinute: null, perHour: null, perDay: null }
	            });
	            setPayoutLimit(null);
	            setIsLimitsLoading(false);
	        }
	
	        new _Api2.default({ token: token }).getAvailableProviders().then(function (r) {
	            var items = r && r.data ? r.data : [];
	            setProviders(items);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setProviders([]);
	        });
	
	        return function () {
	            mounted.current = false;
	        };
	    }, [terminal, token]);
	
	    function _onChange(name, value) {
	        setForm(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, name, value));
	        });
	    }
	
	    /**
	     * Обновление поля auth по source ('processingAuth' или 'nodaBank').
	     * Используется секцией "Ключи интеграции" с per-protocol схемой.
	     */
	    function onAuthFieldChange(source, key, value) {
	        setForm(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, source, Object.assign({}, prev[source] || {}, _defineProperty({}, key, value))));
	        });
	    }
	
	    function onLimitChange(section, field, value) {
	        var num = value === '' ? null : Number(value);
	        setLimits(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, section, Object.assign({}, prev[section], _defineProperty({}, field, num))));
	        });
	    }
	
	    var isSelected = !!(terminal && terminal.id);
	
	    var renderLimitInput = function renderLimitInput(section, field, labelId) {
	        var sectionData = limits[section] || {};
	        var value = sectionData[field];
	        var displayValue = value == null || value === 0 ? '' : value;
	
	        return _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: labelId }),
	            _react2.default.createElement('input', {
	                type: 'number',
	                min: '0',
	                step: '0.01',
	                value: displayValue,
	                onChange: function onChange(e) {
	                    return onLimitChange(section, field, e.target.value);
	                },
	                placeholder: intl.formatMessage({ id: 'TerminalEditing.placeholder.notSet' }),
	                style: { width: '100%' },
	                disabled: isLimitsSaving || isLimitsLoading
	            })
	        );
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        isLimitsLoading && isSelected && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.SavingOverlay },
	            _react2.default.createElement('div', { className: _stylesModule2.default.SavingSpinner }),
	            _react2.default.createElement(
	                'span',
	                null,
	                '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...'
	            )
	        ),
	        isSaving && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.SavingOverlay },
	            _react2.default.createElement('div', { className: _stylesModule2.default.SavingSpinner }),
	            _react2.default.createElement(
	                'span',
	                null,
	                '\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435...'
	            )
	        ),
	        isSelected ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.TerminalHeader },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.TerminalHeaderLeft },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: _stylesModule2.default.TerminalHeaderTitle },
	                            terminal && (terminal.name || form.name) || 'Терминал'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.TerminalHeaderMeta },
	                            terminal && terminal.processingProtocol && _react2.default.createElement(
	                                'span',
	                                { className: _stylesModule2.default.ProtocolBadge },
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ProtocolBadgeDot }),
	                                terminal.processingName || terminal.processingProtocol
	                            ),
	                            terminal && terminal.id && _react2.default.createElement(
	                                'span',
	                                { className: _stylesModule2.default.TerminalIdLabel },
	                                'ID: ',
	                                terminal.id
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ProjectFields },
	                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                        onChange: _onChange,
	                        value: form.name || '',
	                        fieldName: 'name',
	                        label: 'TerminalEditing.field.name',
	                        isDisabled: isSaving
	                    }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalEditing.field.status', defaultMessage: '\u0421\u0442\u0430\u0442\u0443\u0441' }),
	                        _react2.default.createElement(
	                            'select',
	                            {
	                                value: typeof form.status === 'number' ? form.status : 1,
	                                onChange: function onChange(e) {
	                                    return _onChange('status', parseInt(e.target.value, 10));
	                                },
	                                style: { width: '100%' },
	                                disabled: isSaving
	                            },
	                            _react2.default.createElement(
	                                'option',
	                                { value: 1 },
	                                '\u0410\u043A\u0442\u0438\u0432\u0435\u043D'
	                            ),
	                            _react2.default.createElement(
	                                'option',
	                                { value: 0 },
	                                '\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D'
	                            )
	                        )
	                    ),
	                    (0, _capabilities.shouldShowMethodsBlock)(terminal) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                        _react2.default.createElement(
	                            'h5',
	                            { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'TerminalEditing.section.methods',
	                                defaultMessage: '\u041C\u0435\u0442\u043E\u0434\u044B'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.MethodsGrid },
	                            _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.isSBP,
	                                    onChange: function onChange(e) {
	                                        return _onChange('isSBP', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    '\u0421\u0411\u041F'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.crmPayoutEnabled,
	                                    onChange: function onChange(e) {
	                                        return _onChange('crmPayoutEnabled', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    'CRM \u0432\u044B\u043F\u043B\u0430\u0442\u044B'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.crmSbpPayoutEnabled,
	                                    disabled: !form.crmPayoutEnabled,
	                                    onChange: function onChange(e) {
	                                        return _onChange('crmSbpPayoutEnabled', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    'CRM \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0421\u0411\u041F'
	                                )
	                            ),
	                            (0, _capabilities.capabilityAllows)(terminal, 'preAuth') && _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.preAuth,
	                                    onChange: function onChange(e) {
	                                        return _onChange('preAuth', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    '\u041F\u0440\u0435\u0434\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F'
	                                )
	                            ),
	                            (0, _capabilities.capabilityAllows)(terminal, 'partialRefund') && _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.partialRefund,
	                                    onChange: function onChange(e) {
	                                        return _onChange('partialRefund', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    '\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442'
	                                )
	                            ),
	                            (0, _capabilities.capabilityAllows)(terminal, 'partialReversal') && _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.partialReversal,
	                                    onChange: function onChange(e) {
	                                        return _onChange('partialReversal', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    '\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u0430\u044F \u043E\u0442\u043C\u0435\u043D\u0430'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.recurring,
	                                    onChange: function onChange(e) {
	                                        return _onChange('recurring', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    '\u0420\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.ToggleLabel },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: !!form.h2h,
	                                    onChange: function onChange(e) {
	                                        return _onChange('h2h', e.target.checked);
	                                    }
	                                }),
	                                _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ToggleText },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'TerminalEditing.method.h2h',
	                                        defaultMessage: '\u0427\u0435\u043B\u043E\u0432\u0435\u043A \u043A \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0443'
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'h5',
	                        { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'TerminalEditing.section.provider',
	                            defaultMessage: '\u041F\u0440\u0438\u0432\u044F\u0437\u043A\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'select',
	                            {
	                                value: form.providerUuid || '',
	                                onChange: function onChange(e) {
	                                    return _onChange('providerUuid', e.target.value);
	                                },
	                                disabled: isSaving
	                            },
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                intl.formatMessage({ id: 'TerminalEditing.provider.noChange' })
	                            ),
	                            providers.map(function (p) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: p && p.uuid, value: p && p.uuid },
	                                    p && p.name || ''
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: 12, opacity: 0.7, marginTop: 6 } },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'TerminalEditing.provider.current',
	                                defaultMessage: '\u0422\u0435\u043A\u0443\u0449\u0438\u0439: {name}',
	                                values: { name: terminal && terminal.providerName || '—' }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'h5',
	                        { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                        '\u041A\u043B\u044E\u0447\u0438 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438'
	                    ),
	                    renderAuthFields(terminal, form, onAuthFieldChange, isSaving),
	                    (0, _capabilities.shouldShowMethodsBlock)(terminal) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                        _react2.default.createElement(
	                            'h5',
	                            { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalEditing.section.other', defaultMessage: '\u041F\u0440\u043E\u0447\u0435\u0435' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                '\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u0441\u0447\u0451\u0442',
	                                _react2.default.createElement('input', {
	                                    type: 'text',
	                                    value: form.bankAccount || '',
	                                    onChange: function onChange(e) {
	                                        return _onChange('bankAccount', e.target.value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                '\u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B',
	                                _react2.default.createElement('input', {
	                                    type: 'text',
	                                    value: form.paymentMethod || '',
	                                    onChange: function onChange(e) {
	                                        return _onChange('paymentMethod', e.target.value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                '\u0410\u0434\u0440\u0435\u0441 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430',
	                                _react2.default.createElement('input', {
	                                    type: 'text',
	                                    value: form.returnUrl || '',
	                                    onChange: function onChange(e) {
	                                        return _onChange('returnUrl', e.target.value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                '\u0410\u0434\u0440\u0435\u0441 \u043A\u043E\u043B\u0431\u0435\u043A\u0430',
	                                _react2.default.createElement('input', {
	                                    type: 'text',
	                                    value: form.webhookUrl || '',
	                                    onChange: function onChange(e) {
	                                        return _onChange('webhookUrl', e.target.value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                '\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0435\u043D\u0430',
	                                _react2.default.createElement('input', {
	                                    type: 'number',
	                                    step: '0.0001',
	                                    value: form.exchangeRate === null ? '' : form.exchangeRate,
	                                    onChange: function onChange(e) {
	                                        var val = e.target.value;
	                                        _onChange('exchangeRate', val === '' ? null : parseFloat(val));
	                                    }
	                                })
	                            )
	                        )
	                    ),
	                    terminal && terminal.processingProtocol === 'Psb' && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                        _react2.default.createElement(
	                            'h5',
	                            { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                            '\u041F\u0421\u0411 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' } },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                                        var r, result, status, err;
	                                        return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                            while (1) {
	                                                switch (_context3.prev = _context3.next) {
	                                                    case 0:
	                                                        _context3.prev = 0;
	                                                        _context3.next = 3;
	                                                        return new _Api2.default({ token: token }).registerPsbMirAccept([terminal.id]);
	
	                                                    case 3:
	                                                        r = _context3.sent;
	                                                        result = r && r.data && r.data[terminal.id];
	
	                                                        if (result && result.ok) {
	                                                            status = result.response && result.response.status;
	
	                                                            onMessage({
	                                                                type: 'success',
	                                                                message: 'MirAccept: ' + (status === 'already exists' ? 'уже зарегистрирован' : 'отправлено в очередь регистрации (НСПК отправит в 23:00 МСК)')
	                                                            });
	                                                        } else {
	                                                            err = result ? result.err || JSON.stringify(result) : 'unknown error';
	
	                                                            onMessage({
	                                                                type: 'error',
	                                                                message: 'MirAccept ошибка: ' + err
	                                                            });
	                                                        }
	                                                        _context3.next = 12;
	                                                        break;
	
	                                                    case 8:
	                                                        _context3.prev = 8;
	                                                        _context3.t0 = _context3['catch'](0);
	
	                                                        Sentry.captureException(_context3.t0);
	                                                        onMessage({
	                                                            type: 'error',
	                                                            message: 'MirAccept: ' + (_context3.t0.message || 'request failed')
	                                                        });
	
	                                                    case 12:
	                                                    case 'end':
	                                                        return _context3.stop();
	                                                }
	                                            }
	                                        }, _callee3, _this, [[0, 8]]);
	                                    })),
	                                    disabled: isSaving,
	                                    style: { padding: '0.5rem 1rem' }
	                                },
	                                '\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 MirAccept 2.0'
	                            ),
	                            form.processingAuth && form.processingAuth.psb_miraccept_registered_at && _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: 12, opacity: 0.7 } },
	                                '\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F: ',
	                                form.processingAuth.psb_miraccept_registered_at,
	                                form.processingAuth.psb_miraccept_status ? ' (' + form.processingAuth.psb_miraccept_status + ')' : ''
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: 12, opacity: 0.7, marginTop: 6 } },
	                            '\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0443\u0436\u043D\u0430 \u043E\u0434\u0438\u043D \u0440\u0430\u0437. \u0411\u0435\u0437 \u043D\u0435\u0451 \u043D\u0435 \u043F\u0440\u043E\u0439\u0434\u0443\u0442 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043A\u0430\u0440\u0442\u043E\u0439 \u041C\u0418\u0420 \u0447\u0435\u0440\u0435\u0437 \u041F\u0421\u0411. \u041D\u0421\u041F\u041A \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 2 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439.'
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'h5',
	                        { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalEditing.section.limits', defaultMessage: '\u041B\u0438\u043C\u0438\u0442\u044B' })
	                    ),
	                    isLimitsLoading ? _react2.default.createElement(
	                        'div',
	                        { style: { padding: '1.5rem', textAlign: 'center', color: '#999' } },
	                        _react2.default.createElement('div', {
	                            className: _stylesModule2.default.Spinner,
	                            style: {
	                                display: 'inline-block',
	                                width: '20px',
	                                height: '20px',
	                                border: '2px solid #f3f3f3',
	                                borderTop: '2px solid #2196f3',
	                                borderRadius: '50%',
	                                animation: 'spin 1s linear infinite',
	                                margin: '0 auto 8px'
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'TerminalEditing.loading.limits',
	                                defaultMessage: '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043B\u0438\u043C\u0438\u0442\u043E\u0432...'
	                            })
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.LimitsGrid },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'TerminalEditing.limits.payment.title',
	                                        defaultMessage: '\u041F\u043B\u0430\u0442\u0435\u0436\u0438'
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.LimitsSubGrid2 },
	                                    renderLimitInput('payment', 'min', 'TerminalEditing.limits.min'),
	                                    renderLimitInput('payment', 'max', 'TerminalEditing.limits.max'),
	                                    renderLimitInput('payment', 'daily', 'TerminalEditing.limits.daily'),
	                                    renderLimitInput('payment', 'monthly', 'TerminalEditing.limits.monthly')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'TerminalEditing.limits.payout.title',
	                                        defaultMessage: '\u0412\u044B\u043F\u043B\u0430\u0442\u044B'
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.LimitsSubGrid2 },
	                                    renderLimitInput('payout', 'min', 'TerminalEditing.limits.min'),
	                                    renderLimitInput('payout', 'max', 'TerminalEditing.limits.max'),
	                                    renderLimitInput('payout', 'daily', 'TerminalEditing.limits.daily'),
	                                    renderLimitInput('payout', 'monthly', 'TerminalEditing.limits.monthly')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'TerminalEditing.limits.velocity.title',
	                                        defaultMessage: '\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C'
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.LimitsSubGrid3 },
	                                    renderLimitInput('velocity', 'perMinute', 'TerminalEditing.limits.perMinute'),
	                                    renderLimitInput('velocity', 'perHour', 'TerminalEditing.limits.perHour'),
	                                    renderLimitInput('velocity', 'perDay', 'TerminalEditing.limits.perDay')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'TerminalEditing.limits.payoutLimit.title',
	                                        defaultMessage: '\u041E\u0431\u0449\u0438\u0439 \u043B\u0438\u043C\u0438\u0442 \u0432\u044B\u043F\u043B\u0430\u0442'
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { marginTop: 6 } },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'TerminalEditing.limits.amount',
	                                            defaultMessage: '\u0421\u0443\u043C\u043C\u0430'
	                                        }),
	                                        _react2.default.createElement('input', {
	                                            type: 'number',
	                                            min: '0',
	                                            step: '0.01',
	                                            value: payoutLimit == null || payoutLimit === 0 ? '' : payoutLimit,
	                                            onChange: function onChange(e) {
	                                                return setPayoutLimit(e.target.value === '' ? null : Number(e.target.value));
	                                            },
	                                            placeholder: intl.formatMessage({
	                                                id: 'TerminalEditing.placeholder.notSet'
	                                            }),
	                                            style: { width: '100%' },
	                                            disabled: isLimitsSaving
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { marginTop: 16, textAlign: 'right' } },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.BtnPrimary,
	                                    onClick: saveLimits,
	                                    disabled: isLimitsSaving
	                                },
	                                isLimitsSaving ? 'Сохранение...' : 'Сохранить лимиты'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.CardFooter },
	                _react2.default.createElement(
	                    'button',
	                    { className: _stylesModule2.default.BtnPrimary, onClick: save, disabled: isSaving },
	                    isSaving ? 'Сохранение...' : 'Сохранить'
	                )
	            )
	        ) : _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Content },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Empty },
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalEditing.empty', defaultMessage: '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D' })
	                )
	            )
	        )
	    );
	}
	
	exports.default = TerminalEditing;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBoundary = function (_React$Component) {
	    _inherits(ErrorBoundary, _React$Component);
	
	    function ErrorBoundary(props) {
	        _classCallCheck(this, ErrorBoundary);
	
	        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));
	
	        _this.state = { hasError: false };
	        return _this;
	    }
	
	    _createClass(ErrorBoundary, [{
	        key: 'componentDidCatch',
	        value: function componentDidCatch(error, errorInfo) {
	            Sentry.captureException(error, {
	                extra: { componentStack: errorInfo.componentStack }
	            });
	            console.error('React Error Boundary caught:', error, errorInfo);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.hasError) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { padding: '40px', textAlign: 'center' } },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        '\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'An unexpected error occurred. Please reload the page.'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            onClick: function onClick() {
	                                window.location.reload();
	                            },
	                            style: { padding: '10px 20px', cursor: 'pointer' }
	                        },
	                        'Reload'
	                    )
	                );
	            }
	
	            return this.props.children;
	        }
	    }], [{
	        key: 'getDerivedStateFromError',
	        value: function getDerivedStateFromError() {
	            return { hasError: true };
	        }
	    }]);
	
	    return ErrorBoundary;
	}(_react2.default.Component);
	
	exports.default = ErrorBoundary;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Footer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LanguageSelect = __webpack_require__(396);
	
	var _LanguageSelect2 = _interopRequireDefault(_LanguageSelect);
	
	var _stylesModule = __webpack_require__(552);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer(_ref) {
	    var lang = _ref.lang,
	        onChangeLanguage = _ref.onChangeLanguage;
	
	
	    var brand = [{ bgColor: '' }, { copyText: '' }];
	
	    switch (("eclear")) {
	        case "wl":
	            brand.bgColor = "#273246";
	            brand.copyText = "GNU General Public License, GPL";
	            break;
	        case "unlimco":
	            brand.bgColor = "#273246";
	            brand.copyText = "«Unlimco Group» LLC ©";
	            break;
	        case "eclear":
	            brand.bgColor = "#152A44";
	            brand.copyText = "«E-Clear Group» LLC ©";
	            break;
	        default:
	            brand.bgColor = "#273246";
	            brand.copyText = "GNU General Public License, GPL";
	    }
	
	    return _react2.default.createElement(
	        'footer',
	        { className: _stylesModule2.default.Footer, style: { backgroundColor: brand.bgColor } },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Container },
	            _react2.default.createElement(_LanguageSelect2.default, { lang: lang, onChangeLanguage: onChangeLanguage }),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.Copy },
	                brand.copyText
	            )
	        )
	    );
	}

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Logo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(556);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logo(_ref) {
	    var style = _ref.style;
	
	    function renderLogo(val) {
	        switch (val) {
	            case 'wl':
	                return _react2.default.createElement('div', { className: _stylesModule2.default.WL, style: style });
	            case 'unlimco':
	                return _react2.default.createElement('div', { className: _stylesModule2.default.Unlimco, style: style });
	            case 'eclear':
	                return _react2.default.createElement('div', { className: _stylesModule2.default.Eclear, style: style });
	            default:
	                return _react2.default.createElement('div', { className: _stylesModule2.default.Eclear, style: style });
	        }
	    }
	
	    return renderLogo(typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","API_URL":"https://api.test.e-clear.cc","BRAND":"eclear","REACT_APP_SENTRY_TRACES_SAMPLE_RATE":"0.2","REACT_APP_SENTRY_DSN":""}) && ("eclear") || 'eclear');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _stylesModule = __webpack_require__(559);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PayControls(_ref) {
	    var pan = _ref.pan,
	        cardHolder = _ref.cardHolder,
	        phone = _ref.phone,
	        email = _ref.email,
	        amount = _ref.amount,
	        commission = _ref.commission,
	        balance = _ref.balance,
	        onSendForm = _ref.onSendForm,
	        isLoading = _ref.isLoading;
	
	    var total = Number(amount) + Number(commission);
	    var isInsufficient = balance && balance.balance !== undefined && Number(balance.balance) < total;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Content },
	            _react2.default.createElement(
	                "h5",
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.title", defaultMessage: "\u0414\u0430\u043D\u043D\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B" })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Grid },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Item },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.label.card", defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Value },
	                        pan || ""
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Item },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.label.holder", defaultMessage: "\u0414\u0435\u0440\u0436\u0430\u0442\u0435\u043B\u044C" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Value },
	                        cardHolder || ""
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Item },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.label.email", defaultMessage: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Value },
	                        email || ""
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Item },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.label.phone", defaultMessage: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Value },
	                        phone || ""
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Item },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.label.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Value },
	                        _react2.default.createElement(_Amount2.default, { amount: amount, currency: balance && balance.currency })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Item },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.label.commission", defaultMessage: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Value },
	                        _react2.default.createElement(_Amount2.default, { amount: commission, currency: balance && balance.currency })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Item },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayControls.label.balance", defaultMessage: "\u0411\u0430\u043B\u0430\u043D\u0441" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Value + " " + (isInsufficient ? _stylesModule2.default.Error : _stylesModule2.default.Success) },
	                        balance && balance.balance !== undefined ? _react2.default.createElement(_Amount2.default, { amount: balance.balance, currency: balance.currency }) : _react2.default.createElement(_Amount2.default, { amount: 0, currency: balance && balance.currency })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(_Button2.default, {
	                onClick: onSendForm,
	                isLoading: isLoading,
	                label: "PayControls.btn.send",
	                icon: "banknote",
	                accessRight: "TRANSACTION_CANCELLING"
	            })
	        )
	    );
	}
	
	exports.default = PayControls;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _StatisticTag = __webpack_require__(425);
	
	var _StatisticTag2 = _interopRequireDefault(_StatisticTag);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(566);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PayoutsFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        onSelectFilter = _ref.onSelectFilter,
	        onSelectedTag = _ref.onSelectedTag,
	        tagsList = _ref.tagsList,
	        filterProjects = _ref.filterProjects,
	        isLoading = _ref.isLoading;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.title.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "created", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ created: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "created", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.PendingIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.status.created",
	                                    defaultMessage: "\u0421\u043E\u0437\u0434\u0430\u043D" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "inProgress", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ inProgress: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "inProgress", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.InProgressIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.status.inProgress",
	                                    defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "processed", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ processed: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "processed", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.ProcessedIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.status.processed", defaultMessage: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "processedWithErrors", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ processedWithErrors: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "processedWithErrors", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.processedWithErrorsIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.status.processedWithErrors",
	                                    defaultMessage: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D \u0441 \u043E\u0448\u0438\u0431\u043A\u0430\u043C\u0438" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "delayed", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ delayed: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "delayed", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.DelayedIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.status.delayed",
	                                    defaultMessage: "\u041E\u0442\u043B\u043E\u0436\u0435\u043D" })
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.title.tags", defaultMessage: "\u041C\u0435\u0442\u043A\u0438" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(_StatisticTag2.default, { tagsList: tagsList, filterProjects: filterProjects,
	                        onSelectedTag: onSelectedTag })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(
	                "button",
	                { onClick: onApplyFilters, className: _stylesModule2.default.Submit, disabled: !isLoading },
	                isLoading ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.buttonIcon, icon: "filter", size: "17px" }) : _react2.default.createElement(_Loader2.default, { isString: true }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsFilters.btn.filter", defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C" })
	            )
	        )
	    );
	}
	
	exports.default = PayoutsFilters;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TableRow = __webpack_require__(410);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Empty = __webpack_require__(409);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(106);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PcaTable(_ref) {
	    var contractsList = _ref.contractsList,
	        contracts = _ref.contracts,
	        terminals = _ref.terminals,
	        loading = _ref.loading;
	
	    return loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	        "table",
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.table.id", defaultMessage: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.table.name", defaultMessage: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u041F\u0421\u0410" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.table.contract", defaultMessage: "\u041A\u043E\u043D\u0442\u0440\u0430\u043A\u0442" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.table.provider", defaultMessage: "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.table.date", defaultMessage: "\u0414\u0430\u0442\u0430 \u041F\u0421\u0410" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.table.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.table.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement("th", null)
	            )
	        ),
	        _react2.default.createElement(
	            "tbody",
	            null,
	            !loading && contractsList && contractsList.length > 0 ? contractsList.map(function (el, i) {
	                return _react2.default.createElement(_TableRow2.default, { key: i, data: el, contracts: contracts, terminals: terminals });
	            }) : _react2.default.createElement(_Empty2.default, null)
	        )
	    );
	}
	
	exports.default = PcaTable;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _stylesModule = __webpack_require__(568);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatKopecks(value) {
	    if (value === null || value === undefined) {
	        return "—";
	    }
	    var floatVal = Number(value) / 100;
	    return floatVal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₽";
	}
	
	function ProjectMobileCard(_ref) {
	    var data = _ref.data,
	        hasExtendedBalances = _ref.hasExtendedBalances,
	        hasCrm = _ref.hasCrm,
	        showAverageBill = _ref.showAverageBill;
	
	    var safeData = data || {};
	    var balance = Array.isArray(safeData.balance) ? safeData.balance : [];
	    var averageBill = Array.isArray(safeData.averageBill) ? safeData.averageBill : [];
	
	    function renderBalance() {
	        if (!balance.length) return _react2.default.createElement(
	            "span",
	            null,
	            "\u2014"
	        );
	
	        return balance.map(function (el, index) {
	            var currency = Object.keys(el)[0];
	            return _react2.default.createElement(
	                "span",
	                { key: index },
	                _react2.default.createElement(_Amount2.default, { amount: el[currency], currency: currency })
	            );
	        });
	    }
	
	    function renderAverageBill(type) {
	        if (!averageBill.length) return _react2.default.createElement(
	            "span",
	            null,
	            "\u2014"
	        );
	
	        return averageBill.map(function (v, index) {
	            var currency = Object.keys(v)[0];
	            var value = v[currency] && v[currency][type];
	            return value ? _react2.default.createElement(_Amount2.default, { key: index, currency: currency, amount: value.toFixed(2) }) : _react2.default.createElement(
	                "span",
	                { key: index },
	                "\u2014"
	            );
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.MobileCard },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileCardHeader },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileProjectName },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.FavoriteIcon, color: "#f44336", icon: "star-full", size: "12px" }),
	                safeData.displayName
	            ),
	            _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/projects/settings/" + safeData.uuid, className: _stylesModule2.default.MobileSettingsLink },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.SettingsIcon, color: "#2479E0", icon: "settings", size: "16px" }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsWidget.table.settings", defaultMessage: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438" })
	            )
	        ),
	        _react2.default.createElement(
	            "a",
	            { className: _stylesModule2.default.MobileWebsite, target: "_blank", rel: "noopener noreferrer", href: safeData.url },
	            safeData.url ? safeData.url.replace(/^([a-zA-Z]+):\/\//, "") : "—"
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileMetrics },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.balance", defaultMessage: "\u0411\u0430\u043B\u0430\u043D\u0441" })
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileValue },
	                    renderBalance()
	                )
	            ),
	            hasExtendedBalances ? _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileLabel },
	                        hasCrm ? "Резервный" : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "ProjectsTable.table.settlementBalance",
	                            defaultMessage: "\u0412\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435"
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileValue },
	                        formatKopecks(safeData.settlementBalance)
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileLabel },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "ProjectsTable.table.actualBalance",
	                            defaultMessage: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439"
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileValue },
	                        formatKopecks(safeData.actualBalance)
	                    )
	                )
	            ) : null,
	            showAverageBill ? _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileLabel },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsWidget.table.payments", defaultMessage: "\u041F\u043B\u0430\u0442\u0435\u0436\u0438" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileValue },
	                        renderAverageBill("payment")
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileLabel },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsWidget.table.payouts", defaultMessage: "\u0412\u044B\u043F\u043B\u0430\u0442\u044B" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.MobileValue },
	                        renderAverageBill("payout")
	                    )
	                )
	            ) : null,
	            !hasExtendedBalances && !showAverageBill ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileValue },
	                    safeData.status === 1 ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.status.active", defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u0435\u043D" }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.status.blocked", defaultMessage: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" })
	                )
	            ) : null
	        )
	    );
	}
	
	exports.default = ProjectMobileCard;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(570);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Что должно быть в файле реестра — по выбранному провайдеру.
	 *
	 * Описание колонок приходит с бэкенда (`/merchant/payout/registry/columns`),
	 * оттуда же собирается xlsx-образец. Держать список здесь, на фронте, нельзя:
	 * он неизбежно расходится с парсером — так в этой же странице жила проверка
	 * документов под FinStar, хотя arMax документ получателя вовсе не смотрит.
	 */
	function RegistryColumnsHelp(props) {
	    var intl = (0, _reactIntl.useIntl)();
	    var type = props.type === "sbp" ? "sbp" : "card";
	    var provider = props.provider || null;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        open = _useState2[0],
	        setOpen = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({ loading: true, columns: [], notes: [], providerLabel: "" }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        state = _useState4[0],
	        setState = _useState4[1];
	
	    (0, _react.useEffect)(function () {
	        // Пока терминал не выбран, показывать нечего: требования у банков
	        // разные, а «средний» список только запутает — мерчант заполнит файл
	        // не по своему провайдеру.
	        if (!provider) {
	            setState({ loading: false, columns: [], notes: [], providerLabel: "" });
	
	            return undefined;
	        }
	
	        var alive = true;
	        setState(function (prev) {
	            return Object.assign({}, prev, { loading: true });
	        });
	
	        new _Api2.default({ token: props.token }).getRegistryColumns(type, provider).then(function (data) {
	            if (!alive) return;
	
	            setState({
	                loading: false,
	                columns: data && data.columns || [],
	                notes: data && data.notes || [],
	                providerLabel: data && data.providerLabel || ""
	            });
	        }).catch(function (error) {
	            if (!alive) return;
	
	            Sentry.captureException(error);
	            setState({ loading: false, columns: [], notes: [], providerLabel: "" });
	        });
	
	        return function () {
	            alive = false;
	        };
	    }, [type, provider, props.token]);
	
	    var required = state.columns.filter(function (column) {
	        return column.requirement === "required";
	    });
	    var optional = state.columns.filter(function (column) {
	        return column.requirement !== "required";
	    });
	
	    var templateUrl = (({"NODE_ENV":"production","PUBLIC_URL":"","API_URL":"https://api.test.e-clear.cc","BRAND":"eclear","REACT_APP_SENTRY_TRACES_SAMPLE_RATE":"0.2","REACT_APP_SENTRY_DSN":""}).REACT_APP_API_URL || ("https://api.test.e-clear.cc") || "") + "/merchant/payout/registry/template?type=" + encodeURIComponent(type) + (provider ? "&provider=" + encodeURIComponent(provider) : "");
	
	    function renderGroup(title, columns) {
	        if (columns.length === 0) return null;
	
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Group },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.GroupTitle },
	                title
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Columns },
	                columns.map(function (column) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: column.name, className: _stylesModule2.default.Column },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.ColumnHead },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.ColName },
	                                column.name
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.Example },
	                                column.example
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.ColumnText },
	                            column.description
	                        )
	                    );
	                })
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "button",
	            { type: "button", className: _stylesModule2.default.Toggle, onClick: function onClick() {
	                    return setOpen(!open);
	                }, "aria-expanded": open },
	            _react2.default.createElement("span", { className: open ? _stylesModule2.default.ChevronOpen : _stylesModule2.default.Chevron }),
	            _react2.default.createElement(
	                "span",
	                null,
	                state.providerLabel ? intl.formatMessage({
	                    id: "RegistryColumnsHelp.titleProvider",
	                    defaultMessage: "Как заполнить файл для {provider}"
	                }, { provider: state.providerLabel }) : intl.formatMessage({
	                    id: "RegistryColumnsHelp.title",
	                    defaultMessage: "Как заполнить файл"
	                })
	            )
	        ),
	        open && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Content },
	            !provider ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Placeholder },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "RegistryColumnsHelp.selectTerminal",
	                    defaultMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442 \u0438 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u2014 \u043F\u043E\u043A\u0430\u0436\u0435\u043C, \u043A\u0430\u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0444\u0430\u0439\u043B \u0438\u043C\u0435\u043D\u043D\u043E \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430."
	                })
	            ) : state.loading ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Loading },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryColumnsHelp.loading", defaultMessage: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u043C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u2026" })
	            ) : state.columns.length === 0 ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Loading },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "RegistryColumnsHelp.empty",
	                    defaultMessage: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043B\u043E\u043D\u043E\u043A."
	                })
	            ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                renderGroup(intl.formatMessage({
	                    id: "RegistryColumnsHelp.group.required",
	                    defaultMessage: "Обязательные колонки"
	                }), required),
	                renderGroup(intl.formatMessage({
	                    id: "RegistryColumnsHelp.group.optional",
	                    defaultMessage: "Необязательные колонки"
	                }), optional),
	                state.notes.length > 0 && _react2.default.createElement(
	                    "ul",
	                    { className: _stylesModule2.default.Notes },
	                    state.notes.map(function (note, index) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: index },
	                            note
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    "a",
	                    { className: _stylesModule2.default.TemplateLink, href: templateUrl, download: true },
	                    state.providerLabel ? intl.formatMessage({
	                        id: "RegistryColumnsHelp.templateProvider",
	                        defaultMessage: "Скачать образец файла для {provider}"
	                    }, { provider: state.providerLabel }) : intl.formatMessage({
	                        id: "RegistryColumnsHelp.template",
	                        defaultMessage: "Скачать образец файла"
	                    })
	                )
	            )
	        )
	    );
	}
	
	exports.default = RegistryColumnsHelp;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(23);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tags = __webpack_require__(441);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _RegistryChangeName = __webpack_require__(419);
	
	var _RegistryChangeName2 = _interopRequireDefault(_RegistryChangeName);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _stylesModule = __webpack_require__(571);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RegistryControls(_ref) {
	    var errorsCount = _ref.errorsCount,
	        suggestionsTag = _ref.suggestionsTag,
	        registryFileName = _ref.registryFileName,
	        amount = _ref.amount,
	        fee = _ref.fee,
	        balance = _ref.balance,
	        isLoading = _ref.isLoading;
	
	    var _useContext = (0, _react.useContext)(_Context2.default),
	        setFilterErrors = _useContext.setFilterErrors,
	        submitRegistry = _useContext.submitRegistry,
	        clearRegistry = _useContext.clearRegistry,
	        onChangeRegistryName = _useContext.onChangeRegistryName,
	        onSelectedTag = _useContext.onSelectedTag;
	
	    var hasSufficientBalance = balance && balance.balance !== undefined && amount <= balance.balance + fee;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "h5",
	            { className: _stylesModule2.default.Title },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryControls.title", defaultMessage: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0440\u0435\u0435\u0441\u0442\u0440\u043E\u043C" })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Filters },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Col },
	                    errorsCount > 0 && _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Checkbox },
	                        _react2.default.createElement("input", {
	                            id: "showErrors",
	                            type: "checkbox",
	                            onChange: function onChange(e) {
	                                return setFilterErrors(e.target.checked);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "showErrors" },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryControls.checkbox.showErrors", defaultMessage: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043E\u0448\u0438\u0431\u043A\u0438" })
	                        )
	                    )
	                )
	            ),
	            errorsCount === 0 && _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(_RegistryChangeName2.default, { registryFileName: registryFileName, onChangeRegistryName: onChangeRegistryName }),
	                _react2.default.createElement(_Tags2.default, {
	                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryControls.tags.label", defaultMessage: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0435\u0442\u043A\u0438" }),
	                    placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryControls.tags.placeholder", defaultMessage: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0435\u0442\u043A\u0438 \u043A \u0440\u0435\u0435\u0441\u0442\u0440\u0443" }),
	                    suggestions: suggestionsTag || [],
	                    onChange: onSelectedTag,
	                    isDisabled: !suggestionsTag || suggestionsTag.length === 0
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(_Button2.default, {
	                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUpload.btn.sendRegistry", defaultMessage: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0440\u0435\u0435\u0441\u0442\u0440" }),
	                onClick: submitRegistry,
	                isLoading: errorsCount > 0 || isLoading || !hasSufficientBalance
	            }),
	            _react2.default.createElement(
	                "button",
	                { className: _stylesModule2.default.LinkBtn, onClick: clearRegistry, disabled: isLoading },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryControls.btn.clear", defaultMessage: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C" })
	            )
	        )
	    );
	}
	
	RegistryControls.propTypes = {
	    errorsCount: _propTypes2.default.number.isRequired
	};
	
	exports.default = RegistryControls;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(572);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RegistryDADUpload(_ref) {
	    var token = _ref.token,
	        onRegistryUpload = _ref.onRegistryUpload,
	        merchantUuid = _ref.merchantUuid;
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        drag = _useState2[0],
	        setDrag = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        loading = _useState4[0],
	        setLoading = _useState4[1];
	
	    function uploadRegistry(file) {
	        if (!file) return;
	
	        setLoading(true);
	        var formData = new FormData();
	        formData.append("file", file);
	
	        new _Api2.default({ token: token }).registryUpload(formData, merchantUuid).then(function (r) {
	            var hasFormatError = !!(r && r.errors && r.errors.formatError);
	
	            if (r && !hasFormatError && !r.code) {
	                onRegistryUpload(file, r);
	                return;
	            }
	
	            var code = r && r.code ? r.code : "formatError";
	            onMessage({
	                type: "error",
	                message: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "RegistryDADUpload.error.format",
	                    defaultMessage: "(\u043A\u043E\u0434: {code}) \u041E\u0448\u0438\u0431\u043A\u0430! \u0420\u0435\u0435\u0441\u0442\u0440 \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0444\u043E\u0440\u043C\u0430\u0442\u0443. \u0423\u0441\u0442\u0440\u0430\u043D\u0438\u0442\u0435 \u043E\u0448\u0438\u0431\u043A\u0438 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
	                    values: { code: code }
	                })
	            });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({
	                type: "error",
	                message: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "RegistryDADUpload.error.network",
	                    defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430."
	                })
	            });
	        }).finally(function () {
	            return setLoading(false);
	        });
	    }
	
	    function onDragStartHandler(e) {
	        e.preventDefault();
	        setDrag(true);
	    }
	
	    function onDragLeaveHandler(e) {
	        e.preventDefault();
	        setDrag(false);
	    }
	
	    function onDropHandler(e) {
	        e.preventDefault();
	        setDrag(false);
	        var files = e.dataTransfer && e.dataTransfer.files;
	        if (files && files.length > 0) {
	            uploadRegistry(files[0]);
	        }
	    }
	
	    function onAddingFileHandler() {
	        var input = document.createElement("input");
	        input.type = "file";
	        input.onchange = function (e) {
	            var target = e.target;
	            if (target && target.files && target.files.length > 0) {
	                uploadRegistry(target.files[0]);
	            }
	        };
	        input.click();
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: drag ? _stylesModule2.default.Wrap + " " + _stylesModule2.default.IsDrag : _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "div",
	            {
	                onClick: onAddingFileHandler,
	                onDrop: onDropHandler,
	                onDragStart: onDragStartHandler,
	                onDragLeave: onDragLeaveHandler,
	                onDragOver: onDragStartHandler,
	                style: { cursor: 'pointer' }
	            },
	            _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "cloud-upload", size: "40px" }),
	                loading ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryDADUpload.loading", defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430..." }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "RegistryDADUpload.hint",
	                    defaultMessage: "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0440\u0435\u0435\u0441\u0442\u0440 \u0432 \u044D\u0442\u0443 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430"
	                })
	            )
	        )
	    );
	}
	
	exports.default = RegistryDADUpload;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NoTerminalsForMethod = NoTerminalsForMethod;
	exports.RegistryCrossLink = RegistryCrossLink;
	exports.WrongRegistryTypeHint = WrongRegistryTypeHint;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _feeCalculator = __webpack_require__(512);
	
	var _stylesModule = __webpack_require__(573);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Информеры под выбором проекта и терминала на страницах реестров.
	 *
	 * variant="project"  — общий остаток по терминалам проекта.
	 * variant="terminal" — сколько реально можно выплатить через выбранный
	 *                      терминал с учётом комиссии.
	 *
	 * Отдельно живут подсказки про соседний раздел: у карточных реестров и реестров
	 * СБП разные требования к файлу, и мерчант регулярно приходит не туда.
	 */
	function RegistryInfoCard(props) {
	    var intl = (0, _reactIntl.useIntl)();
	
	    if (props.variant === "project") {
	        return renderProjectCard(props, intl);
	    }
	
	    if (props.variant === "terminal") {
	        return renderTerminalCard(props, intl);
	    }
	
	    return null;
	}
	
	/**
	 * Пустое состояние: у проекта нет ни одного терминала под нужный способ
	 * выплаты. Раньше такого сообщения не было, потому что список терминалов не
	 * фильтровался вовсе. Теперь неподходящие скрыты, и без объяснения человек
	 * упирался бы в пустой выпадающий список.
	 */
	function NoTerminalsForMethod(props) {
	    var intl = (0, _reactIntl.useIntl)();
	    var currentMethod = props.currentMethod;
	
	    if (currentMethod !== "card" && currentMethod !== "sbp") {
	        return null;
	    }
	
	    var text = currentMethod === "card" ? intl.formatMessage({
	        id: "RegistryInfoCard.noTerminals.card",
	        defaultMessage: "У этого проекта нет терминалов для выплат на банковские карты."
	    }) : intl.formatMessage({
	        id: "RegistryInfoCard.noTerminals.sbp",
	        defaultMessage: "У этого проекта нет терминалов для выплат через СБП."
	    });
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Title },
	            text
	        ),
	        _react2.default.createElement(RegistryCrossLink, { currentMethod: currentMethod })
	    );
	}
	
	/**
	 * Кнопка перехода в соседний раздел.
	 */
	function RegistryCrossLink(props) {
	    var intl = (0, _reactIntl.useIntl)();
	    var currentMethod = props.currentMethod;
	
	    var to = void 0;
	    var label = void 0;
	    var hint = void 0;
	
	    if (currentMethod === "card") {
	        to = "/mobile-registry-upload";
	        label = intl.formatMessage({
	            id: "RegistryInfoCard.crossLink.sbpLabel",
	            defaultMessage: "Перейти к реестру СБП →"
	        });
	        hint = intl.formatMessage({
	            id: "RegistryInfoCard.crossLink.sbpHint",
	            defaultMessage: "Нужно выплатить по номерам телефонов через СБП?"
	        });
	    } else if (currentMethod === "sbp") {
	        to = "/registry-upload";
	        label = intl.formatMessage({
	            id: "RegistryInfoCard.crossLink.cardLabel",
	            defaultMessage: "Перейти к карточному реестру →"
	        });
	        hint = intl.formatMessage({
	            id: "RegistryInfoCard.crossLink.cardHint",
	            defaultMessage: "Нужно выплатить на банковские карты?"
	        });
	    } else {
	        return null;
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.CrossLinkBlock },
	        _react2.default.createElement(
	            "span",
	            { className: _stylesModule2.default.CrossLinkHint },
	            hint
	        ),
	        _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: to, className: _stylesModule2.default.CrossLink },
	            label
	        )
	    );
	}
	
	/**
	 * «Похоже, это реестр из другого раздела».
	 *
	 * Текст подсказки приходит с бэкенда вместе с ошибкой формата: там же лежит
	 * разбор шапки файла, и держать второе такое знание в кабинете значило бы
	 * разойтись с загрузчиком в первый же день.
	 */
	function WrongRegistryTypeHint(props) {
	    var intl = (0, _reactIntl.useIntl)();
	    var wrongType = props.wrongType;
	
	    if (wrongType !== "card" && wrongType !== "sbp") {
	        return null;
	    }
	
	    var to = wrongType === "sbp" ? "/mobile-registry-upload" : "/registry-upload";
	    var label = wrongType === "sbp" ? intl.formatMessage({
	        id: "RegistryInfoCard.crossLink.sbpLabel",
	        defaultMessage: "Перейти к реестру СБП →"
	    }) : intl.formatMessage({
	        id: "RegistryInfoCard.crossLink.cardLabel",
	        defaultMessage: "Перейти к карточному реестру →"
	    });
	
	    var text = props.hint || (wrongType === "sbp" ? intl.formatMessage({
	        id: "RegistryInfoCard.wrongType.sbp",
	        defaultMessage: "Похоже, это реестр СБП: в файле телефон и банк получателя."
	    }) : intl.formatMessage({
	        id: "RegistryInfoCard.wrongType.card",
	        defaultMessage: "Похоже, это карточный реестр: в файле номера карт."
	    }));
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.WrongType },
	        _react2.default.createElement(
	            "span",
	            { className: _stylesModule2.default.WrongTypeText },
	            text
	        ),
	        _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: to, className: _stylesModule2.default.CrossLink },
	            label
	        )
	    );
	}
	
	function renderProjectCard(props, intl) {
	    var project = props.project;
	    var terminals = Array.isArray(props.terminals) ? props.terminals : [];
	
	    if (!project) {
	        return null;
	    }
	
	    var totalBalance = 0;
	    terminals.forEach(function (t) {
	        var b = t && t.balance ? Number(t.balance.confirmed) : 0;
	
	        if (isFinite(b)) {
	            totalBalance += b;
	        }
	    });
	
	    var label = project.displayName || project.name || intl.formatMessage({ id: "RegistryInfoCard.projectFallback", defaultMessage: "Проект" });
	
	    var currency = terminals.length > 0 && terminals[0].currency ? terminals[0].currency : "RUB";
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Title },
	            intl.formatMessage({ id: "RegistryInfoCard.projectBalance", defaultMessage: "Баланс проекта" })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Row },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.RowLabel },
	                label
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.RowValue },
	                formatAmount(totalBalance, currency, intl.locale)
	            )
	        )
	    );
	}
	
	function renderTerminalCard(props, intl) {
	    var terminal = props.terminal;
	
	    if (!terminal) {
	        return null;
	    }
	
	    var balance = terminal.balance ? Number(terminal.balance.confirmed) : 0;
	    if (!isFinite(balance)) {
	        balance = 0;
	    }
	
	    var fee = (0, _feeCalculator.getPayoutFee)(terminal);
	    var available = (0, _feeCalculator.calcAvailableForTerminal)(terminal, balance);
	    var cost = fee && fee.cost != null ? Number(fee.cost) : 0;
	    var min = fee && fee.costFixedMinimum != null ? Number(fee.costFixedMinimum) : 0;
	    var currency = terminal.currency || "RUB";
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Title },
	                intl.formatMessage({
	                    id: "RegistryInfoCard.availableForPayouts",
	                    defaultMessage: "Доступно к выплатам"
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MethodBody },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.MethodAmount },
	                    formatAmount(available, currency, intl.locale)
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.MethodFee },
	                    intl.formatMessage({
	                        id: "RegistryInfoCard.fee",
	                        defaultMessage: "(комиссия {percent}, минимум {minimum})"
	                    }, {
	                        percent: formatPct(cost),
	                        minimum: formatAmount(min, currency, intl.locale)
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Disclaimer },
	            intl.formatMessage({
	                id: "RegistryInfoCard.disclaimer",
	                defaultMessage: "Сумма, доступная к выплатам, расчётная и может отличаться, если применяется минимальная комиссия. Точная сумма считается при загрузке реестра."
	            })
	        )
	    );
	}
	
	function formatAmount(value, currency, locale) {
	    var n = Number(value) || 0;
	
	    try {
	        return new Intl.NumberFormat(locale || "ru", {
	            style: "currency",
	            currency: currency || "RUB",
	            minimumFractionDigits: 2,
	            maximumFractionDigits: 2
	        }).format(n);
	    } catch (e) {
	        // Незнакомый код валюты Intl роняет исключением — цифру всё равно
	        // показываем, без неё карточка бессмысленна.
	        return n.toFixed(2) + " " + (currency || "");
	    }
	}
	
	function formatPct(value) {
	    var n = Number(value) || 0;
	
	    return (Number.isInteger(n) ? n.toFixed(0) : n.toFixed(2)) + "%";
	}
	
	exports.default = RegistryInfoCard;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TableRow = __webpack_require__(422);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Empty = __webpack_require__(420);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(51);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RegistryList(_ref) {
	    var token = _ref.token,
	        data = _ref.data,
	        isLoading = _ref.isLoading;
	
	    return isLoading ? data && data.length > 0 ? _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.TableWrap },
	        _react2.default.createElement(
	            "table",
	            { className: _stylesModule2.default.FixedTable },
	            _react2.default.createElement(
	                "colgroup",
	                null,
	                _react2.default.createElement("col", { style: { width: "9%" } }),
	                _react2.default.createElement("col", { style: { width: "23%" } }),
	                _react2.default.createElement("col", { style: { width: "13%" } }),
	                _react2.default.createElement("col", { style: { width: "12%" } }),
	                _react2.default.createElement("col", { style: { width: "12%" } }),
	                _react2.default.createElement("col", { style: { width: "12%" } }),
	                _react2.default.createElement("col", { style: { width: "11%" } }),
	                _react2.default.createElement("col", { style: { width: "8%" } })
	            ),
	            _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                        "th",
	                        { className: _stylesModule2.default.HeaderCell + " " + _stylesModule2.default.HeaderCenter },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.table.id", defaultMessage: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { className: _stylesModule2.default.HeaderCell },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.table.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { className: _stylesModule2.default.HeaderCell },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.table.merchant", defaultMessage: "\u041C\u0435\u0440\u0447\u0430\u043D\u0442" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { className: _stylesModule2.default.HeaderCell },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.table.date", defaultMessage: "\u0414\u0430\u0442\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { className: _stylesModule2.default.HeaderCell },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.table.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { className: _stylesModule2.default.HeaderCell },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.table.fee", defaultMessage: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { className: _stylesModule2.default.HeaderCell },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.table.tags", defaultMessage: "\u041C\u0435\u0442\u043A\u0438" })
	                    ),
	                    _react2.default.createElement("th", { className: _stylesModule2.default.HeaderCell })
	                )
	            ),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                data.length > 0 ? data.map(function (el) {
	                    return _react2.default.createElement(_TableRow2.default, {
	                        key: el.id,
	                        token: token,
	                        retry: el.retry,
	                        id: el.id,
	                        name: el.name,
	                        date: el.date,
	                        amount: el.total,
	                        totalFee: el.totalFee,
	                        currency: el.currencyCode,
	                        status: el.status,
	                        success: el.success,
	                        failed: el.failed,
	                        other: el.other,
	                        tags: el.tags,
	                        merchantUUID: el.merchantUUID,
	                        merchantName: el.merchantName,
	                        count: el.transactions_count
	                    });
	                }) : _react2.default.createElement(
	                    "tr",
	                    { className: _stylesModule2.default.EmptyTR },
	                    _react2.default.createElement(
	                        "td",
	                        { colSpan: 8 },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.EmptyCell },
	                            _react2.default.createElement(
	                                "h5",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.empty", defaultMessage: "\u0420\u0435\u0435\u0441\u0442\u0440\u043E\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    ) : _react2.default.createElement(_Empty2.default, null) : _react2.default.createElement(_Loader2.default, null);
	}
	
	exports.default = RegistryList;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _xls = __webpack_require__(650);
	
	var _xls2 = _interopRequireDefault(_xls);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Help = __webpack_require__(59);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _stylesModule = __webpack_require__(575);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RegistryUploadInfo(_ref) {
	    var name = _ref.name,
	        balance = _ref.balance,
	        amount = _ref.amount,
	        errorsCount = _ref.errorsCount,
	        fee = _ref.fee,
	        errorsList = _ref.errorsList,
	        errorsFormat = _ref.errorsFormat;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        errors = _useState2[0],
	        setErrors = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        errorsLoading = _useState4[0],
	        setErrorsLoading = _useState4[1];
	
	    function showErrorsCount(count) {
	        if (name && count > 0) {
	            return _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.Error },
	                count
	            );
	        }
	        return name ? 0 : "—";
	    }
	
	    function showCommission(fee) {
	        if (!name) return "—";
	        var currency = balance && balance.currency ? balance.currency : "";
	
	        var safeFee = Number.isFinite(Number(fee)) ? Number(fee) : 0;
	        return _react2.default.createElement(_Amount2.default, { amount: safeFee, currency: currency });
	    }
	
	    (0, _react.useEffect)(function () {
	        if (errorsCount > 0 && errorsList) {
	            setErrorsLoading(true);
	            var errorsArr = [];
	
	            for (var key in errorsList) {
	                if (key !== "count" && key !== "formatError" && errorsList[key] && errorsList[key].expected) {
	                    errorsArr.push(errorsList[key].expected);
	                }
	            }
	
	            setErrors(errorsArr);
	            setErrorsLoading(false);
	        }
	    }, [errorsCount, errorsList]);
	
	    var hasBalance = balance && balance.balance !== undefined;
	    var totalCost = (amount || 0) + (fee || 0);
	    var hasSufficientBalance = hasBalance && balance.balance >= totalCost;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Upload },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.BlockImage },
	            _react2.default.createElement("img", { src: _xls2.default, width: "68", height: "91", alt: "XLS" })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.BlockInfo },
	            _react2.default.createElement(
	                "table",
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    "tbody",
	                    null,
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUploadInfo.table.registry", defaultMessage: "\u0420\u0435\u0435\u0441\u0442\u0440:" })
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            name || "—"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUploadInfo.table.errors", defaultMessage: "\u041E\u0448\u0438\u0431\u043E\u043A:" })
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            showErrorsCount(errorsCount)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUploadInfo.table.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430:" })
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            amount && balance && balance.currency ? _react2.default.createElement(_Amount2.default, { amount: amount, currency: balance.currency }) : "—"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUploadInfo.table.fee", defaultMessage: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F:" })
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            showCommission(fee)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUploadInfo.table.balance", defaultMessage: "\u0411\u0430\u043B\u0430\u043D\u0441:" })
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            null,
	                            hasBalance ? _react2.default.createElement(
	                                "span",
	                                { className: hasSufficientBalance ? _stylesModule2.default.Success : _stylesModule2.default.Error },
	                                _react2.default.createElement(_Amount2.default, { amount: balance.balance, currency: balance.currency })
	                            ) : "—"
	                        )
	                    )
	                )
	            ),
	            errorsFormat && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ErrorsList },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ErrorsTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUploadInfo.errors.format", defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0444\u043E\u0440\u043C\u0430\u0442\u0430 \u0444\u0430\u0439\u043B\u0430" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.ErrorsHelp },
	                        _react2.default.createElement(
	                            _Help2.default,
	                            { width: 140 },
	                            !errorsLoading && errors.map(function (err, i) {
	                                return _react2.default.createElement(
	                                    "div",
	                                    { key: i, className: _stylesModule2.default.ErrorsHelpTitle },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: "RegistryUploadInfo.errors.missingColumn",
	                                        defaultMessage: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446: {column}",
	                                        values: { column: err }
	                                    })
	                                );
	                            })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = RegistryUploadInfo;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.avatarColor = avatarColor;
	exports.initials = initials;
	exports.formatFileSize = formatFileSize;
	exports.isImage = isImage;
	exports.Avatar = Avatar;
	exports.ChatList = ChatList;
	exports.default = SecretChat;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(576);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Секретный чат — окно переписки и список разговоров.
	 *
	 * Компонент один на обе стороны: клиент и сотрудник видят одну переписку и
	 * ходят в разные ручки, поэтому загрузка и отправка приходят пропсами, а про
	 * сторону компонент знает ровно одно — какие сообщения считать своими.
	 *
	 * Сообщения живут сутки и исчезают у обеих сторон, поэтому лента ничего не
	 * копит: она перечитывается по таймеру, иначе на экране оставалось бы то,
	 * чего на сервере уже нет.
	 */
	var REFRESH_MS = 7000;
	
	/** Палитра аватаров: цвет закреплён за собеседником, а не пляшет от сортировки. */
	var AVATAR_COLORS = ['#4a7dd6', '#2e9e83', '#c2683a', '#7b5fc4', '#3d8bb5', '#b4557f'];
	
	function avatarColor(seed) {
	    var key = String(seed || '');
	    var sum = 0;
	
	    for (var i = 0; i < key.length; i += 1) {
	        sum += key.charCodeAt(i);
	    }
	
	    return AVATAR_COLORS[sum % AVATAR_COLORS.length];
	}
	
	function initials(name) {
	    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
	
	    if (parts.length === 0) return '#';
	    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	
	    return (parts[0][0] + parts[1][0]).toUpperCase();
	}
	
	/** Размер файла человеческими словами. */
	function formatFileSize(bytes) {
	    var size = Number(bytes || 0);
	
	    if (size < 1024) return size + ' Б';
	    if (size < 1024 * 1024) return Math.round(size / 1024) + ' КБ';
	
	    return (size / 1024 / 1024).toFixed(size < 10 * 1024 * 1024 ? 1 : 0) + ' МБ';
	}
	
	/** Картинку показываем прямо в ленте, остальное — карточкой с именем. */
	function isImage(mime) {
	    return String(mime || '').indexOf('image/') === 0;
	}
	
	function timeOf(value) {
	    var date = new Date(value);
	
	    return isNaN(date.getTime()) ? '' : date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
	}
	
	function dayOf(value) {
	    var date = new Date(value);
	
	    return isNaN(date.getTime()) ? '' : date.toDateString();
	}
	
	/**
	 * Аватар собеседника: инициалы в круге. Картинок у аккаунтов нет, а список
	 * из одинаковых строк читается плохо.
	 */
	function Avatar(_ref) {
	    var name = _ref.name,
	        seed = _ref.seed,
	        size = _ref.size;
	
	    var style = {
	        background: avatarColor(seed),
	        width: size || 40,
	        height: size || 40,
	        fontSize: (size || 40) / 2.6
	    };
	
	    return _react2.default.createElement(
	        'span',
	        { className: _styles2.default.Avatar, style: style },
	        initials(name)
	    );
	}
	
	/** Левая колонка: разговоры, свежие сверху. */
	function ChatList(_ref2) {
	    var chats = _ref2.chats,
	        activeId = _ref2.activeId,
	        onPick = _ref2.onPick,
	        onNew = _ref2.onNew,
	        isLoading = _ref2.isLoading,
	        titleOf = _ref2.titleOf,
	        subtitleOf = _ref2.subtitleOf;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.List },
	        _react2.default.createElement(
	            'div',
	            { className: _styles2.default.ListHead },
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.ListTitle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.list.title', defaultMessage: '\u0420\u0430\u0437\u0433\u043E\u0432\u043E\u0440\u044B' })
	            ),
	            _react2.default.createElement(
	                'button',
	                {
	                    type: 'button',
	                    className: _styles2.default.NewButton,
	                    onClick: onNew,
	                    title: intl.formatMessage({
	                        id: 'SecretChat.button.new',
	                        defaultMessage: 'Новый чат'
	                    })
	                },
	                _react2.default.createElement(_Icon2.default, { icon: 'plus', size: '14px' }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.button.new', defaultMessage: '\u041D\u043E\u0432\u044B\u0439 \u0447\u0430\u0442' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _styles2.default.ListBody },
	            isLoading ? _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Muted },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.loading', defaultMessage: '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026' })
	            ) : null,
	            !isLoading && chats.length === 0 ? _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Muted },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChats.empty', defaultMessage: '\u0427\u0430\u0442\u043E\u0432 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442' })
	            ) : null,
	            chats.map(function (chat) {
	                var title = titleOf ? titleOf(chat) : chat.subject;
	                var subtitle = subtitleOf ? subtitleOf(chat) : chat.subject;
	
	                return _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        key: chat.id,
	                        className: chat.id === activeId ? _styles2.default.Row + ' ' + _styles2.default.RowActive : _styles2.default.Row,
	                        onClick: function onClick() {
	                            return onPick(chat.id);
	                        }
	                    },
	                    _react2.default.createElement(Avatar, { name: title, seed: chat.id }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _styles2.default.RowText },
	                        _react2.default.createElement(
	                            'span',
	                            { className: _styles2.default.RowTop },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _styles2.default.RowTitle },
	                                title
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _styles2.default.RowTime },
	                                timeOf(chat.lastMessageAt)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _styles2.default.RowBottom },
	                            _react2.default.createElement(
	                                'span',
	                                { className: _styles2.default.RowSubtitle },
	                                subtitle
	                            ),
	                            chat.unread > 0 ? _react2.default.createElement(
	                                'span',
	                                { className: _styles2.default.Badge },
	                                chat.unread
	                            ) : null
	                        )
	                    )
	                );
	            })
	        )
	    );
	}
	
	/** Правая колонка: сама переписка. */
	function SecretChat(_ref3) {
	    var onSubmit = function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	            var body, data, serverMessage;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (e && e.preventDefault) e.preventDefault();
	
	                            body = text.trim();
	                            // С файлом текст необязателен: «вот выписка» без подписи — нормально.
	
	                            if (!(!body && files.length === 0 || isSending || !chatId)) {
	                                _context2.next = 4;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 4:
	
	                            setIsSending(true);
	                            _context2.prev = 5;
	                            _context2.next = 8;
	                            return sendMessage(chatId, body, files);
	
	                        case 8:
	                            data = _context2.sent;
	
	                            if (mountedRef.current) {
	                                _context2.next = 11;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 11:
	                            setMessages(data && data.items || []);
	                            setText('');
	                            setFiles([]);
	                            if (fileInputRef.current) fileInputRef.current.value = '';
	                            setError(null);
	                            _context2.next = 24;
	                            break;
	
	                        case 18:
	                            _context2.prev = 18;
	                            _context2.t0 = _context2['catch'](5);
	
	                            if (mountedRef.current) {
	                                _context2.next = 22;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 22:
	                            // Сервер объясняет отказ по файлу словами («больше 50 МБ»,
	                            // «исполняемые файлы через чат не передаются») — показываем их,
	                            // иначе человек не поймёт, почему сообщение не ушло.
	                            serverMessage = _context2.t0 && _context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message;
	
	                            setError(serverMessage || intl.formatMessage({ id: 'SecretChat.error.send', defaultMessage: 'Сообщение не отправлено' }));
	
	                        case 24:
	                            _context2.prev = 24;
	
	                            if (mountedRef.current) setIsSending(false);
	                            return _context2.finish(24);
	
	                        case 27:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[5, 18, 24, 27]]);
	        }));
	
	        return function onSubmit(_x2) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	
	    /**
	     * Скачивание идёт запросом с токеном, а не обычной ссылкой: у ссылки нет
	     * заголовка авторизации, и сервер ответил бы отказом.
	     */
	
	
	    var onDownload = function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(file) {
	            var blob, url, link;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (!(!chatId || !downloadFile)) {
	                                _context3.next = 2;
	                                break;
	                            }
	
	                            return _context3.abrupt('return');
	
	                        case 2:
	                            _context3.prev = 2;
	                            _context3.next = 5;
	                            return downloadFile(chatId, file.id);
	
	                        case 5:
	                            blob = _context3.sent;
	                            url = window.URL.createObjectURL(blob);
	                            link = document.createElement('a');
	
	
	                            link.href = url;
	                            link.download = file.name || 'file';
	                            document.body.appendChild(link);
	                            link.click();
	                            document.body.removeChild(link);
	                            window.URL.revokeObjectURL(url);
	                            _context3.next = 21;
	                            break;
	
	                        case 16:
	                            _context3.prev = 16;
	                            _context3.t0 = _context3['catch'](2);
	
	                            if (mountedRef.current) {
	                                _context3.next = 20;
	                                break;
	                            }
	
	                            return _context3.abrupt('return');
	
	                        case 20:
	                            setError(intl.formatMessage({
	                                id: 'SecretChat.error.download',
	                                defaultMessage: 'Файл не скачался — возможно, он уже удалён'
	                            }));
	
	                        case 21:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[2, 16]]);
	        }));
	
	        return function onDownload(_x3) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	
	    /** Сколько сообщению осталось жить — подсказкой, чтобы не мусорить в ленте. */
	
	
	    var chat = _ref3.chat,
	        side = _ref3.side,
	        loadMessages = _ref3.loadMessages,
	        sendMessage = _ref3.sendMessage,
	        onRead = _ref3.onRead,
	        ttlHours = _ref3.ttlHours,
	        titleOf = _ref3.titleOf,
	        downloadFile = _ref3.downloadFile;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        messages = _useState2[0],
	        setMessages = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(''),
	        _useState4 = _slicedToArray(_useState3, 2),
	        text = _useState4[0],
	        setText = _useState4[1];
	    // Выбранные, но ещё не отправленные файлы. Держим здесь, а не в форме:
	    // человек может передумать и убрать файл до отправки.
	
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        files = _useState6[0],
	        setFiles = _useState6[1];
	
	    var fileInputRef = (0, _react.useRef)(null);
	
	    var _useState7 = (0, _react.useState)(true),
	        _useState8 = _slicedToArray(_useState7, 2),
	        isLoading = _useState8[0],
	        setIsLoading = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        isSending = _useState10[0],
	        setIsSending = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        error = _useState12[0],
	        setError = _useState12[1];
	
	    var bottomRef = (0, _react.useRef)(null);
	    var mountedRef = (0, _react.useRef)(true);
	    var chatId = chat && chat.id;
	
	    (0, _react.useEffect)(function () {
	        mountedRef.current = true;
	        return function () {
	            mountedRef.current = false;
	        };
	    }, []);
	
	    var refresh = (0, _react.useCallback)(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee(silent) {
	            var data;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (chatId) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            if (!silent) setIsLoading(true);
	
	                            _context.prev = 3;
	                            _context.next = 6;
	                            return loadMessages(chatId);
	
	                        case 6:
	                            data = _context.sent;
	
	                            if (mountedRef.current) {
	                                _context.next = 9;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 9:
	                            setMessages(data && data.items || []);
	                            setError(null);
	                            _context.next = 18;
	                            break;
	
	                        case 13:
	                            _context.prev = 13;
	                            _context.t0 = _context['catch'](3);
	
	                            if (mountedRef.current) {
	                                _context.next = 17;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 17:
	                            setError(intl.formatMessage({
	                                id: 'SecretChat.error.load',
	                                defaultMessage: 'Не удалось загрузить переписку'
	                            }));
	
	                        case 18:
	                            _context.prev = 18;
	
	                            if (mountedRef.current && !silent) setIsLoading(false);
	                            return _context.finish(18);
	
	                        case 21:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[3, 13, 18, 21]]);
	        }));
	
	        return function (_x) {
	            return _ref4.apply(this, arguments);
	        };
	    }(), [chatId, loadMessages, intl]);
	
	    (0, _react.useEffect)(function () {
	        if (!chatId) return undefined;
	
	        refresh(false);
	        if (onRead) onRead(chatId);
	
	        var timer = setInterval(function () {
	            return refresh(true);
	        }, REFRESH_MS);
	        return function () {
	            return clearInterval(timer);
	        };
	    }, [chatId, refresh, onRead]);
	
	    (0, _react.useEffect)(function () {
	        if (bottomRef.current && bottomRef.current.scrollIntoView) {
	            bottomRef.current.scrollIntoView({ block: 'end' });
	        }
	    }, [messages]);
	
	    /** Лента с разделителями дат — как в мессенджере. */
	    var feed = (0, _react.useMemo)(function () {
	        var rows = [];
	        var lastDay = null;
	
	        messages.forEach(function (message) {
	            var day = dayOf(message.createdAt);
	
	            if (day && day !== lastDay) {
	                rows.push({ kind: 'day', id: 'day-' + day, value: message.createdAt });
	                lastDay = day;
	            }
	
	            rows.push({ kind: 'message', id: message.id, value: message });
	        });
	
	        return rows;
	    }, [messages]);
	
	    function leftHint(expiresAt) {
	        var left = new Date(expiresAt).getTime() - Date.now();
	        if (isNaN(left) || left <= 0) return '';
	
	        var hours = Math.floor(left / 3600000);
	        var minutes = Math.floor(left % 3600000 / 60000);
	
	        return hours > 0 ? intl.formatMessage({ id: 'SecretChat.left.hours', defaultMessage: 'исчезнет через {hours} ч {minutes} мин' }, { hours: hours, minutes: minutes }) : intl.formatMessage({ id: 'SecretChat.left.minutes', defaultMessage: 'исчезнет через {minutes} мин' }, { minutes: minutes });
	    }
	
	    function formatDay(value) {
	        var date = new Date(value);
	        if (isNaN(date.getTime())) return '';
	
	        var today = new Date().toDateString();
	        if (date.toDateString() === today) {
	            return intl.formatMessage({ id: 'SecretChat.day.today', defaultMessage: 'Сегодня' });
	        }
	
	        return date.toLocaleDateString();
	    }
	
	    if (!chat) {
	        return _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Empty },
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.EmptyIcon },
	                _react2.default.createElement(_Icon2.default, { icon: 'lock', size: '26px' })
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.EmptyTitle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.empty.pick', defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0447\u0430\u0442 \u0438\u043B\u0438 \u043D\u0430\u0447\u043D\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439' })
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.EmptyNote },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: 'SecretChat.note.ttl',
	                    defaultMessage: '\u041F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0430 \u0437\u0430\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0430 \u0438 \u0443\u0434\u0430\u043B\u044F\u0435\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 {hours} \u0447',
	                    values: { hours: ttlHours || 24 }
	                })
	            )
	        );
	    }
	
	    var title = titleOf ? titleOf(chat) : chat.subject;
	
	    return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.Chat },
	        _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Head },
	            _react2.default.createElement(Avatar, { name: title, seed: chat.id, size: 36 }),
	            _react2.default.createElement(
	                'span',
	                { className: _styles2.default.HeadText },
	                _react2.default.createElement(
	                    'span',
	                    { className: _styles2.default.Subject },
	                    title
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: _styles2.default.Note },
	                    _react2.default.createElement(_Icon2.default, { icon: 'lock', size: '11px' }),
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'SecretChat.note.ttl',
	                        defaultMessage: '\u041F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0430 \u0437\u0430\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0430 \u0438 \u0443\u0434\u0430\u043B\u044F\u0435\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 {hours} \u0447',
	                        values: { hours: ttlHours || 24 }
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Messages },
	            isLoading ? _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Muted },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.loading', defaultMessage: '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026' })
	            ) : null,
	            !isLoading && messages.length === 0 ? _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Muted },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.empty.messages', defaultMessage: '\u041F\u043E\u043A\u0430 \u043F\u0443\u0441\u0442\u043E \u2014 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0435\u0440\u0432\u044B\u043C' })
	            ) : null,
	            feed.map(function (row) {
	                if (row.kind === 'day') {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: row.id, className: _styles2.default.Day },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            formatDay(row.value)
	                        )
	                    );
	                }
	
	                var message = row.value;
	                var mine = message.author === side;
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: row.id, className: mine ? _styles2.default.Line + ' ' + _styles2.default.LineMine : _styles2.default.Line },
	                    mine ? null : _react2.default.createElement(Avatar, { name: message.authorName, seed: message.authorName, size: 28 }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: mine ? _styles2.default.Bubble + ' ' + _styles2.default.BubbleMine : _styles2.default.Bubble,
	                            title: leftHint(message.expiresAt)
	                        },
	                        mine ? null : _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.Author },
	                            message.authorName
	                        ),
	                        message.body ? _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.Body },
	                            message.body
	                        ) : null,
	                        (message.files || []).map(function (file) {
	                            return _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    key: file.id,
	                                    className: _styles2.default.File,
	                                    onClick: function onClick() {
	                                        return onDownload(file);
	                                    },
	                                    title: intl.formatMessage({
	                                        id: 'SecretChat.file.download',
	                                        defaultMessage: 'Скачать файл'
	                                    })
	                                },
	                                _react2.default.createElement(_Icon2.default, { icon: 'document-download', size: '14px' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _styles2.default.FileName },
	                                    file.name
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _styles2.default.FileSize },
	                                    formatFileSize(file.size)
	                                )
	                            );
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.Time },
	                            timeOf(message.createdAt)
	                        )
	                    )
	                );
	            }),
	            _react2.default.createElement('div', { ref: bottomRef })
	        ),
	        error ? _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Error },
	            error
	        ) : null,
	        files.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Picked },
	            files.map(function (file, index) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _styles2.default.PickedItem, key: file.name + index },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _styles2.default.FileName },
	                        file.name
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _styles2.default.FileSize },
	                        formatFileSize(file.size)
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: _styles2.default.PickedRemove,
	                            onClick: function onClick() {
	                                return setFiles(files.filter(function (_, i) {
	                                    return i !== index;
	                                }));
	                            }
	                        },
	                        '\xD7'
	                    )
	                );
	            })
	        ) : null,
	        _react2.default.createElement(
	            'form',
	            { className: _styles2.default.Form, onSubmit: onSubmit },
	            _react2.default.createElement('input', {
	                ref: fileInputRef,
	                type: 'file',
	                multiple: true,
	                className: _styles2.default.HiddenInput,
	                onChange: function onChange(e) {
	                    setFiles(files.concat(Array.prototype.slice.call(e.target.files || [])));
	                }
	            }),
	            _react2.default.createElement(
	                'button',
	                {
	                    type: 'button',
	                    className: _styles2.default.Attach,
	                    onClick: function onClick() {
	                        return fileInputRef.current && fileInputRef.current.click();
	                    },
	                    title: intl.formatMessage({
	                        id: 'SecretChat.file.attach',
	                        defaultMessage: 'Приложить файл'
	                    })
	                },
	                _react2.default.createElement(_Icon2.default, { icon: 'cloud-upload', size: '16px' })
	            ),
	            _react2.default.createElement('textarea', {
	                className: _styles2.default.Input,
	                value: text,
	                rows: 1,
	                maxLength: 20000,
	                placeholder: intl.formatMessage({
	                    id: 'SecretChat.placeholder',
	                    defaultMessage: 'Сообщение…'
	                }),
	                onChange: function onChange(e) {
	                    return setText(e.target.value);
	                },
	                onKeyDown: function onKeyDown(e) {
	                    // Enter отправляет, Shift+Enter — перенос строки.
	                    if (e.key === 'Enter' && !e.shiftKey) {
	                        e.preventDefault();
	                        onSubmit(e);
	                    }
	                }
	            }),
	            _react2.default.createElement(
	                'button',
	                {
	                    className: _styles2.default.Send,
	                    type: 'submit',
	                    disabled: isSending || !text.trim() && files.length === 0,
	                    title: intl.formatMessage({ id: 'SecretChat.button.send', defaultMessage: 'Отправить' })
	                },
	                _react2.default.createElement(_Icon2.default, { icon: 'share', size: '14px' })
	            )
	        )
	    );
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(203);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EVENT_TYPE_LABELS = {
	    MERCHANT_REQUEST: { ru: "Запрос от мерчанта", en: "Merchant Request", icon: "📥", color: "#35C98E" },
	    MERCHANT_RESPONSE: { ru: "Ответ мерчанту", en: "Merchant Response", icon: "📤", color: "#2479E0" },
	    MERCHANT_CALLBACK: { ru: "Callback мерчанту", en: "Callback to Merchant", icon: "🔔", color: "#9c27b0" },
	    MERCHANT_CALLBACK_MISSING: { ru: "Callback не настроен", en: "Callback Missing", icon: "⚠️", color: "#ff9800" },
	    PROVIDER_REQUEST: { ru: "Запрос к провайдеру", en: "Provider Request", icon: "➡️", color: "#2479E0" },
	    PROVIDER_RESPONSE: { ru: "Ответ от провайдера", en: "Provider Response", icon: "⬅️", color: "#35C98E" },
	    PROVIDER_CALLBACK: { ru: "Callback от провайдера", en: "Provider Callback", icon: "📨", color: "#35C98E" },
	    PROVIDER_EVENT: { ru: "Событие провайдера", en: "Provider Event", icon: "📋", color: "#607d8b" },
	    STATUS_CHANGE: { ru: "Изменение статуса", en: "Status Change", icon: "🔄", color: "#ff9800" },
	    FRAUD_CHECK: { ru: "Проверка антифрода", en: "Fraud Check", icon: "🛡️", color: "#607d8b" },
	    FRAUD_BLOCK: { ru: "Блокировка антифродом", en: "Fraud Block", icon: "🚫", color: "#f44336" },
	    ADMIN_ACTION: { ru: "Действие админа", en: "Admin Action", icon: "👤", color: "#673ab7" },
	    SYSTEM_NOTE: { ru: "Системная заметка", en: "System Note", icon: "📝", color: "#9e9e9e" }
	};
	
	var DIRECTION_STYLES = {
	    IN: { icon: "arrow-right", color: "#35C98E" },
	    OUT: { icon: "arrow-left", color: "#2479E0" }
	};
	
	function TimelineEvent(_ref) {
	    var event = _ref.event,
	        isLast = _ref.isLast;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        expanded = _useState2[0],
	        setExpanded = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        copied = _useState4[0],
	        setCopied = _useState4[1];
	
	    var eventType = event.eventType,
	        direction = event.direction,
	        actor = event.actor,
	        statusFrom = event.statusFrom,
	        statusTo = event.statusTo,
	        httpCode = event.httpCode,
	        errorCode = event.errorCode,
	        errorMessage = event.errorMessage,
	        payload = event.payload,
	        meta = event.meta,
	        clientIp = event.clientIp,
	        createdAt = event.createdAt;
	
	
	    var label = EVENT_TYPE_LABELS[eventType] || { ru: eventType, en: eventType, icon: "📋", color: "#9e9e9e" };
	    var dirStyle = DIRECTION_STYLES[direction] || {};
	    var time = createdAt ? new Date(createdAt).toLocaleTimeString() : "";
	    var date = createdAt ? new Date(createdAt).toLocaleDateString() : "";
	
	    var hasDetails = payload || meta || errorMessage;
	
	    // Извлекаем callbackUrl из meta для MERCHANT_CALLBACK
	    var callbackUrl = meta && meta.callbackUrl || null;
	
	    // Функция копирования
	    var handleCopy = function handleCopy(data) {
	        navigator.clipboard.writeText(JSON.stringify(data, null, 2));
	        setCopied(true);
	        setTimeout(function () {
	            return setCopied(false);
	        }, 1500);
	    };
	
	    // Определяем цвет точки: приоритет у типа события, затем направление
	    var dotColor = label.color || dirStyle.color || "#9e9e9e";
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.EventContainer },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.EventLine },
	            _react2.default.createElement("div", { className: _stylesModule2.default.EventDot, style: { backgroundColor: dotColor } }),
	            !isLast && _react2.default.createElement("div", { className: _stylesModule2.default.EventConnector })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.EventContent },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.EventHeader, onClick: function onClick() {
	                        return hasDetails && setExpanded(!expanded);
	                    } },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.EventTime },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Time },
	                        time
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Date },
	                        date
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.EventTitle },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.EventIcon },
	                        label.icon
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.EventLabel },
	                        label.ru
	                    ),
	                    direction && _react2.default.createElement(
	                        "span",
	                        {
	                            className: _stylesModule2.default.DirectionBadge,
	                            style: { backgroundColor: dirStyle.color }
	                        },
	                        direction
	                    ),
	                    actor && actor !== "system" && actor !== "merchant" && _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.ActorBadge },
	                        actor
	                    )
	                ),
	                httpCode !== null && httpCode !== undefined && _react2.default.createElement(
	                    "span",
	                    { className: httpCode >= 200 && httpCode < 300 ? _stylesModule2.default.HttpOk : _stylesModule2.default.HttpError },
	                    "HTTP ",
	                    httpCode
	                ),
	                hasDetails && _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.ExpandIcon },
	                    expanded ? "▼" : "▶"
	                )
	            ),
	            callbackUrl && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.CallbackUrl },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.CallbackLabel },
	                    "\u0410\u0434\u0440\u0435\u0441:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.CallbackValue },
	                    callbackUrl
	                )
	            ),
	            eventType === "STATUS_CHANGE" && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.StatusChange },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.StatusFrom },
	                    statusFrom || "?"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.StatusArrow },
	                    "\u2192"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.StatusTo },
	                    statusTo || "?"
	                )
	            ),
	            errorCode && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ErrorInfo },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.ErrorCode },
	                    errorCode
	                ),
	                errorMessage && _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.ErrorMessage },
	                    errorMessage
	                )
	            ),
	            clientIp && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ClientIp },
	                "IP: ",
	                clientIp
	            ),
	            expanded && hasDetails && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Details },
	                meta && Object.keys(meta).length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.MetaSection },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.SectionHeader },
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.SectionTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.meta", defaultMessage: "\u0414\u0435\u0442\u0430\u043B\u0438" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.CopyButton,
	                                onClick: function onClick(e) {
	                                    e.stopPropagation();
	                                    handleCopy(meta);
	                                },
	                                title: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
	                            },
	                            copied ? "✓" : "📋"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "pre",
	                        { className: _stylesModule2.default.JsonPre },
	                        JSON.stringify(meta, null, 2)
	                    )
	                ),
	                payload && Object.keys(payload).length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.PayloadSection },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.SectionHeader },
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.SectionTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.payload", defaultMessage: "\u0414\u0430\u043D\u043D\u044B\u0435" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.CopyButton,
	                                onClick: function onClick(e) {
	                                    e.stopPropagation();
	                                    handleCopy(payload);
	                                },
	                                title: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
	                            },
	                            copied ? "✓" : "📋"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "pre",
	                        { className: _stylesModule2.default.JsonPre },
	                        JSON.stringify(payload, null, 2)
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TimelineEvent;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(588);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * FilterPanel — выдвижная панель фильтров справа.
	 *
	 * Использование:
	 *   <FilterPanel isOpen={bool} onClose={fn} title="Фильтры"
	 *                content={<div>...основной контент страницы...</div>}>
	 *     {children — содержимое фильтров}
	 *   </FilterPanel>
	 *
	 * Когда панель открыта, content сжимается (margin-right), панель не перекрывает контент.
	 */
	function FilterPanel(_ref) {
	    var children = _ref.children,
	        isOpen = _ref.isOpen,
	        onClose = _ref.onClose,
	        title = _ref.title,
	        content = _ref.content;
	
	    // display:none когда закрыта — сохраняем state дочерних компонентов
	    var panelStyle = isOpen ? {} : { display: "none" };
	
	    var contentClass = _stylesModule2.default.ContentShift + (isOpen ? " " + _stylesModule2.default.ContentShiftOpen : "");
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: contentClass },
	            content
	        ),
	        _react2.default.createElement(
	            "div",
	            {
	                className: _stylesModule2.default.Panel + (isOpen ? " " + _stylesModule2.default.PanelOpen : ""),
	                style: panelStyle
	            },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    "h3",
	                    { className: _stylesModule2.default.Title },
	                    title
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.CloseBtn, onClick: onClose, type: "button" },
	                    _react2.default.createElement(_Icon2.default, { icon: "close", size: "15px" })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Body },
	                children
	            )
	        )
	    );
	}
	
	exports.default = FilterPanel;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(23);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylesModule = __webpack_require__(110);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TabBarItem = function TabBarItem(_ref) {
	    var children = _ref.children,
	        label = _ref.label,
	        labelColor = _ref.labelColor,
	        count = _ref.count,
	        activeTab = _ref.activeTab,
	        isVisible = _ref.isVisible,
	        attrs = _objectWithoutProperties(_ref, ["children", "label", "labelColor", "count", "activeTab", "isVisible"]);
	
	    var style = {
	        display: "none"
	    };
	
	    if (activeTab === label) {
	        style.display = "block";
	    }
	
	    return _react2.default.createElement(
	        "div",
	        Object.assign({ className: _stylesModule2.default.Content, style: style }, attrs),
	        children
	    );
	};
	
	TabBarItem.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    labelColor: _propTypes2.default.string,
	    count: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    activeTab: _propTypes2.default.string
	};
	
	TabBarItem.defaultProps = {
	    children: null,
	    labelColor: '#777',
	    count: null,
	    activeTab: ''
	};
	
	exports.default = TabBarItem;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabBarNav = __webpack_require__(438);
	
	var _TabBarNav2 = _interopRequireDefault(_TabBarNav);
	
	var _stylesModule = __webpack_require__(110);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HTabBar = function (_Component) {
	    _inherits(HTabBar, _Component);
	
	    function HTabBar() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, HTabBar);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HTabBar.__proto__ || Object.getPrototypeOf(HTabBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            activeTab: null
	        }, _this.scrollToActiveTab = function () {
	            var activeTabElement = document.querySelector("." + _stylesModule2.default.Tab + "[data-label=\"" + _this.state.activeTab + "\"]");
	            if (activeTabElement && activeTabElement.parentElement) {
	                var navContainer = activeTabElement.parentElement;
	                var offsetLeft = activeTabElement.offsetLeft;
	                var offsetWidth = activeTabElement.offsetWidth;
	                var containerWidth = navContainer.offsetWidth;
	
	                navContainer.scrollTo({
	                    left: offsetLeft - containerWidth / 2 + offsetWidth / 2,
	                    behavior: 'smooth'
	                });
	            }
	        }, _this.getChildrenLabels = function (children) {
	            return _react2.default.Children.toArray(children).filter(Boolean).map(function (child) {
	                return child.props.label;
	            });
	        }, _this.setActiveTab = function (activeTab) {
	            var currentTab = _this.state.activeTab;
	
	
	            if (currentTab !== activeTab) {
	                _this.setState({ activeTab: activeTab }, function () {
	                    _this.scrollToActiveTab();
	                });
	            }
	        }, _this.renderTabs = function () {
	            var children = _this.props.children;
	            var activeTab = _this.state.activeTab;
	
	
	            return _react2.default.Children.toArray(children).filter(Boolean).map(function (tab) {
	                if (!tab || !tab.props) return null;
	                return _react2.default.createElement(_TabBarNav2.default, {
	                    key: tab.props.label,
	                    navLabel: tab.props.label,
	                    navLabelColor: tab.props.labelColor,
	                    navCount: tab.props.count,
	                    isActive: activeTab === tab.props.label,
	                    isVisible: tab.props.isVisible,
	                    onChangeActiveTab: _this.setActiveTab
	                });
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(HTabBar, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props = this.props,
	                children = _props.children,
	                defaultActiveTab = _props.defaultActiveTab;
	
	            var childrenArray = _react2.default.Children.toArray(children).filter(Boolean);
	
	            if (childrenArray.length > 0) {
	                // Фильтруем только видимые вкладки
	                var visibleChildren = childrenArray.filter(function (child) {
	                    return child.props.isVisible !== false;
	                });
	                var visibleLabels = this.getChildrenLabels(visibleChildren);
	
	                var activeTab = void 0;
	                if (typeof defaultActiveTab === 'number' && visibleLabels[defaultActiveTab]) {
	                    activeTab = visibleLabels[defaultActiveTab];
	                } else {
	                    activeTab = visibleLabels[0];
	                }
	
	                if (activeTab) {
	                    this.setActiveTab(activeTab);
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var activeTab = this.state.activeTab;
	
	            var _props2 = this.props,
	                children = _props2.children,
	                attrs = _objectWithoutProperties(_props2, ["children"]);
	
	            var childrenArray = _react2.default.Children.toArray(children).filter(Boolean);
	
	            return _react2.default.createElement(
	                "div",
	                Object.assign({ className: _stylesModule2.default.Wrap }, attrs),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Nav },
	                    this.renderTabs()
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Content },
	                    childrenArray.map(function (child) {
	                        return _react2.default.cloneElement(child, { activeTab: activeTab });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return HTabBar;
	}(_react.Component);
	
	exports.default = HTabBar;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(23);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(591);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Message(_ref) {
	    var value = _ref.value;
	
	    if (!value || !value.type || !value.message) {
	        return null; // ничего не показываем, если нет сообщения
	    }
	
	    var style = "";
	    var icon = null;
	
	    switch (value.type) {
	        case "error":
	            style = _stylesModule2.default.Error;
	            icon = _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'close', size: '22px' });
	            break;
	
	        case "warning":
	            style = _stylesModule2.default.Warning;
	            icon = _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'warning', size: '20px' });
	            break;
	
	        case "success":
	            style = _stylesModule2.default.Success;
	            icon = _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'checkmark', size: '20px' });
	            break;
	
	        case "info":
	            style = _stylesModule2.default.Info;
	            icon = _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'info', size: '20px' });
	            break;
	
	        default:
	            break;
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: style },
	        icon,
	        _react2.default.createElement(
	            'span',
	            null,
	            value.message
	        )
	    );
	}
	
	Message.propTypes = {
	    value: _propTypes2.default.shape({
	        type: _propTypes2.default.string,
	        message: _propTypes2.default.string
	    })
	};
	
	exports.default = Message;

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var uuid = function () {
	    function uuid() {
	        _classCallCheck(this, uuid);
	    }
	
	    _createClass(uuid, [{
	        key: 'v4',
	        value: function v4() {
	            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.trunc(Math.random() * 16);
	                var v = c === 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        }
	    }]);
	
	    return uuid;
	}();
	
	exports.default = new uuid();

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _reactIntl = __webpack_require__(2);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _SearchTags = __webpack_require__(38);
	
	var _SearchTags2 = _interopRequireDefault(_SearchTags);
	
	var _CrmPayoutBoard = __webpack_require__(360);
	
	var _CrmPayoutBoard2 = _interopRequireDefault(_CrmPayoutBoard);
	
	var _CrmPayoutFilters = __webpack_require__(363);
	
	var _CrmPayoutFilters2 = _interopRequireDefault(_CrmPayoutFilters);
	
	var _CrmPayoutDetails = __webpack_require__(362);
	
	var _CrmPayoutDetails2 = _interopRequireDefault(_CrmPayoutDetails);
	
	var _CrmPayoutActions = __webpack_require__(359);
	
	var _CrmPayoutActions2 = _interopRequireDefault(_CrmPayoutActions);
	
	var _CrmRegistryModal = __webpack_require__(365);
	
	var _CrmRegistryModal2 = _interopRequireDefault(_CrmRegistryModal);
	
	var _CrmPayoutCreateModal = __webpack_require__(361);
	
	var _CrmPayoutCreateModal2 = _interopRequireDefault(_CrmPayoutCreateModal);
	
	var _stylesModule = __webpack_require__(607);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _FilterPanel = __webpack_require__(185);
	
	var _FilterPanel2 = _interopRequireDefault(_FilterPanel);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CrmPayoutRequestsUtils = __webpack_require__(448);
	
	var _CrmPayoutBoardUtils = __webpack_require__(167);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CrmPayoutRequestsPage = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	    var payoutType = props.payoutType || "card";
	    var isSbp = payoutType === "sbp";
	    var _msg = (0, _react.useContext)(_MessageContext2.default);
	    var onMessage = _msg.onMessage;
	
	    // Data — карточки хранятся по колонкам: { [status]: { items, total, page } }
	    var _columns = (0, _react.useState)({});
	    var columns = _columns[0];
	    var setColumns = _columns[1];
	
	    var _loadingStatuses = (0, _react.useState)({});
	    var loadingStatuses = _loadingStatuses[0];
	    var setLoadingStatuses = _loadingStatuses[1];
	
	    var _selected = (0, _react.useState)(null);
	    var selected = _selected[0];
	    var setSelected = _selected[1];
	
	    var _stats = (0, _react.useState)(null);
	    var stats = _stats[0];
	    var setStats = _stats[1];
	
	    var _selectedIds = (0, _react.useState)([]);
	    var selectedIds = _selectedIds[0];
	    var setSelectedIds = _selectedIds[1];
	
	    // Merchants для фильтров
	    var _merchants = (0, _react.useState)([]);
	    var merchants = _merchants[0];
	    var setMerchants = _merchants[1];
	
	    // Filters — объект из CrmPayoutFilters
	    var _appliedFilters = (0, _react.useState)({ filters: {} });
	    var appliedFilters = _appliedFilters[0];
	    var setAppliedFilters = _appliedFilters[1];
	
	    var _searchTags = (0, _react.useState)([]);
	    var searchTags = _searchTags[0];
	    var setSearchTags = _searchTags[1];
	
	    var _loading = (0, _react.useState)(true);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    // UI state
	    var _filtersOpen = (0, _react.useState)(false);
	    var filtersOpen = _filtersOpen[0];
	    var setFiltersOpen = _filtersOpen[1];
	
	    var _createOpen = (0, _react.useState)(false);
	    var createOpen = _createOpen[0];
	    var setCreateOpen = _createOpen[1];
	
	    // Registries data (для колонки "Реестр" в канбане)
	    var _registries = (0, _react.useState)([]);
	    var registries = _registries[0];
	    var setRegistries = _registries[1];
	
	    // Registry modal
	    var _registryId = (0, _react.useState)(null);
	    var registryId = _registryId[0];
	    var setRegistryId = _registryId[1];
	
	    // Быстрый фильтр по статусу (клик по бейджу StatsBar)
	    var _quickStatus = (0, _react.useState)(null);
	    var quickStatus = _quickStatus[0];
	    var setQuickStatus = _quickStatus[1];
	
	    // Счётчик обновлений для перезагрузки после bulk-действий
	    var _refreshKey = (0, _react.useState)(0);
	    var refreshKey = _refreshKey[0];
	    var setRefreshKey = _refreshKey[1];
	
	    // "На сумму" modal state
	    var _byAmountOpen = (0, _react.useState)(false);
	    var byAmountOpen = _byAmountOpen[0];
	    var setByAmountOpen = _byAmountOpen[1];
	
	    var _byAmountStep = (0, _react.useState)(1);
	    var byAmountStep = _byAmountStep[0];
	    var setByAmountStep = _byAmountStep[1];
	
	    var _byAmountMerchant = (0, _react.useState)("");
	    var byAmountMerchant = _byAmountMerchant[0];
	    var setByAmountMerchant = _byAmountMerchant[1];
	
	    var _byAmountValue = (0, _react.useState)("");
	    var byAmountValue = _byAmountValue[0];
	    var setByAmountValue = _byAmountValue[1];
	
	    var _byAmountPreview = (0, _react.useState)(null);
	    var byAmountPreview = _byAmountPreview[0];
	    var setByAmountPreview = _byAmountPreview[1];
	
	    var _byAmountName = (0, _react.useState)("");
	    var byAmountName = _byAmountName[0];
	    var setByAmountName = _byAmountName[1];
	
	    var _byAmountLoading = (0, _react.useState)(false);
	    var byAmountLoading = _byAmountLoading[0];
	    var setByAmountLoading = _byAmountLoading[1];
	
	    var _byAmountError = (0, _react.useState)("");
	    var byAmountError = _byAmountError[0];
	    var setByAmountError = _byAmountError[1];
	
	    // Load merchants для фильтров
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjects().then(function (r) {
	            if (Array.isArray(r)) {
	                var mapped = r.map(function (p) {
	                    return { uuid: p.uuid, displayName: p.displayName || p.name || p.uuid };
	                });
	                setMerchants(mapped);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	        });
	    }, [token]);
	
	    // Load stats
	    (0, _react.useEffect)(function () {
	        var projects = appliedFilters.projects || undefined;
	        new _Api2.default({ token: token }).getCrmPayoutStats(projects, payoutType).then(function (r) {
	            setStats(r || null);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setStats(null);
	        });
	    }, [token, refreshKey, appliedFilters, payoutType]);
	
	    // Load registries (для колонки "Реестр" в канбане)
	    (0, _react.useEffect)(function () {
	        var projects = appliedFilters.projects || undefined;
	        new _Api2.default({ token: token }).getCrmRegistries(projects, payoutType).then(function (r) {
	            setRegistries(Array.isArray(r.items) ? r.items : []);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setRegistries([]);
	        });
	    }, [token, refreshKey, appliedFilters, payoutType]);
	
	    // Load board — по запросу на каждую колонку.
	    // Раньше грузился ОДИН список на 200 записей и раскладывался по колонкам:
	    // как только в одном статусе набиралось 200 свежих заявок, остальные колонки
	    // оставались пустыми, хотя счётчики сверху считали их правильно.
	    (0, _react.useEffect)(function () {
	        var cancelled = false;
	        var api = new _Api2.default({ token: token });
	        var baseFilters = (0, _CrmPayoutRequestsUtils.buildRequestFilters)(appliedFilters, searchTags);
	        baseFilters.payoutType = payoutType;
	        var projects = appliedFilters.projects && appliedFilters.projects.length > 0 ? appliedFilters.projects : null;
	        var targetAmount = appliedFilters.filters ? appliedFilters.filters.targetAmount : null;
	
	        setLoading(true);
	        setColumns({});
	
	        // Подбор "на сумму" — набор заявок формирует сервер, разбивать по статусам нечего
	        if (targetAmount) {
	            var payload = {
	                page: 1,
	                itemsPerPage: 200,
	                filters: Object.assign({}, baseFilters, { targetAmount: targetAmount })
	            };
	            if (projects) payload.projects = projects;
	
	            api.getCrmPayoutRequests(payload).then(function (r) {
	                if (cancelled) return;
	                var items = Array.isArray(r.items) ? r.items.map(_CrmPayoutRequestsUtils.normalizeListItem) : [];
	                var grouped = {};
	                items.forEach(function (item) {
	                    var s = Number(item.status);
	                    if (!grouped[s]) grouped[s] = { items: [], total: 0, page: 1 };
	                    grouped[s].items.push(item);
	                    grouped[s].total += 1;
	                });
	                setColumns(grouped);
	                setLoading(false);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                if (cancelled) return;
	                setColumns({});
	                setLoading(false);
	            });
	
	            return function () {
	                cancelled = true;
	            };
	        }
	
	        var statuses = (0, _CrmPayoutRequestsUtils.statusesToLoad)(appliedFilters, (0, _CrmPayoutBoardUtils.boardRequestStatuses)());
	
	        if (statuses.length === 0) {
	            setLoading(false);
	            return function () {
	                cancelled = true;
	            };
	        }
	
	        var pending = statuses.length;
	
	        function columnDone() {
	            if (cancelled) return;
	            pending -= 1;
	            if (pending <= 0) setLoading(false);
	        }
	
	        statuses.forEach(function (status) {
	            var columnPayload = {
	                page: 1,
	                itemsPerPage: _CrmPayoutRequestsUtils.COLUMN_PAGE_SIZE,
	                filters: Object.assign({}, baseFilters, { status: [status] })
	            };
	            if (projects) columnPayload.projects = projects;
	
	            api.getCrmPayoutRequests(columnPayload).then(function (r) {
	                if (cancelled) return;
	                var items = Array.isArray(r.items) ? r.items.map(_CrmPayoutRequestsUtils.normalizeListItem) : [];
	                setColumns(function (prev) {
	                    var next = Object.assign({}, prev);
	                    next[status] = {
	                        items: items,
	                        total: typeof r.total === "number" ? r.total : items.length,
	                        page: 1
	                    };
	                    return next;
	                });
	                columnDone();
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                if (cancelled) return;
	                setColumns(function (prev) {
	                    var next = Object.assign({}, prev);
	                    next[status] = { items: [], total: 0, page: 1 };
	                    return next;
	                });
	                columnDone();
	            });
	        });
	
	        return function () {
	            cancelled = true;
	        };
	    }, [appliedFilters, searchTags, token, refreshKey, payoutType]);
	
	    // Подгрузка следующей страницы конкретной колонки
	    function handleLoadMore(status) {
	        var col = columns[status];
	        if (!col || loadingStatuses[status]) return;
	        if (col.items.length >= col.total) return;
	
	        var nextPage = (col.page || 1) + 1;
	        var payload = {
	            page: nextPage,
	            itemsPerPage: _CrmPayoutRequestsUtils.COLUMN_PAGE_SIZE,
	            filters: Object.assign({}, (0, _CrmPayoutRequestsUtils.buildRequestFilters)(appliedFilters, searchTags), {
	                status: [Number(status)], payoutType: payoutType
	            })
	        };
	        if (appliedFilters.projects && appliedFilters.projects.length > 0) {
	            payload.projects = appliedFilters.projects;
	        }
	
	        setLoadingStatuses(function (prev) {
	            var next = Object.assign({}, prev);
	            next[status] = true;
	            return next;
	        });
	
	        new _Api2.default({ token: token }).getCrmPayoutRequests(payload).then(function (r) {
	            var items = Array.isArray(r.items) ? r.items.map(_CrmPayoutRequestsUtils.normalizeListItem) : [];
	            setColumns(function (prev) {
	                var next = Object.assign({}, prev);
	                var current = prev[status] || { items: [], total: 0, page: 1 };
	                next[status] = {
	                    items: (0, _CrmPayoutRequestsUtils.mergeColumnItems)(current.items, items),
	                    total: typeof r.total === "number" ? r.total : current.total,
	                    page: nextPage
	                };
	                return next;
	            });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({ type: "error", message: "Не удалось загрузить ещё заявки" });
	        }).then(function () {
	            setLoadingStatuses(function (prev) {
	                var next = Object.assign({}, prev);
	                delete next[status];
	                return next;
	            });
	        });
	    }
	
	    var list = (0, _CrmPayoutRequestsUtils.flattenColumns)(columns);
	    var totals = (0, _CrmPayoutRequestsUtils.columnTotals)(columns);
	
	    function onChangeSearch(tags) {
	        setSearchTags(tags);
	    }
	
	    function onSelectRequest(row) {
	        if (row && row.id) {
	            new _Api2.default({ token: token }).getCrmPayoutRequest(row.id).then(function (full) {
	                setSelected(full || row);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                setSelected(row);
	            });
	        } else {
	            setSelected(null);
	        }
	    }
	
	    function onRequestUpdate(updatedRequest) {
	        setSelected(updatedRequest);
	        setRefreshKey(function (k) {
	            return k + 1;
	        });
	    }
	
	    function onApplyFilters(newFilters) {
	        setAppliedFilters(newFilters || { filters: {} });
	        setQuickStatus(null);
	    }
	
	    // Checkbox handlers
	    function handleCheck(id, checked) {
	        if (checked) {
	            setSelectedIds(function (prev) {
	                return prev.concat([id]);
	            });
	        } else {
	            setSelectedIds(function (prev) {
	                return prev.filter(function (x) {
	                    return x !== id;
	                });
	            });
	        }
	    }
	
	    function handleBulkComplete() {
	        setSelectedIds([]);
	        setSelected(null);
	        setRefreshKey(function (k) {
	            return k + 1;
	        });
	    }
	
	    // "Выбрать все" в колонке канбана
	    function handleCheckAllInColumn(status, checked, columnItemIds) {
	        if (checked) {
	            setSelectedIds(function (prev) {
	                var newIds = prev.slice();
	                columnItemIds.forEach(function (id) {
	                    if (newIds.indexOf(id) === -1) {
	                        newIds.push(id);
	                    }
	                });
	                return newIds;
	            });
	        } else {
	            setSelectedIds(function (prev) {
	                return prev.filter(function (id) {
	                    return columnItemIds.indexOf(id) === -1;
	                });
	            });
	        }
	    }
	
	    // Быстрый фильтр по статусу — клик по бейджу
	    function handleQuickStatusFilter(statusValue) {
	        if (quickStatus === statusValue) {
	            setQuickStatus(null);
	        } else {
	            setQuickStatus(statusValue);
	        }
	    }
	
	    // Registry modal
	    function handleRegistryClick(regId) {
	        setRegistryId(regId);
	    }
	
	    // Drag & Drop — перемещение карточки между колонками
	    function handleDragDrop(requestId, fromStatus, toStatus) {
	        var api = new _Api2.default({ token: token });
	
	        // Отклонение (→ status 2)
	        if (toStatus === 2) {
	            api.declineCrmPayoutRequest(requestId, "Перемещено вручную").then(function () {
	                setRefreshKey(function (k) {
	                    return k + 1;
	                });
	            }).catch(function (e) {
	                Sentry.captureException(e);
	                var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	                onMessage({ type: "error", message: "Ошибка перемещения: " + msg });
	            });
	            return;
	        }
	
	        // Отправить на антифрод (Создана → Ожидает, status 0 → 7)
	        if (fromStatus === 0 && toStatus === 7) {
	            api.sendToAntifraudCrmPayoutRequests([requestId]).then(function () {
	                setRefreshKey(function (k) {
	                    return k + 1;
	                });
	            }).catch(function (e) {
	                Sentry.captureException(e);
	                var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	                onMessage({ type: "error", message: "Ошибка отправки на антифрод: " + msg });
	            });
	            return;
	        }
	
	        // Вернуть в ожидание (→ status 7, из реестра или ошибки)
	        if (toStatus === 7) {
	            api.moveBackToAwaitingCrmPayoutRequests([requestId]).then(function () {
	                setRefreshKey(function (k) {
	                    return k + 1;
	                });
	            }).catch(function (e) {
	                Sentry.captureException(e);
	                var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	                onMessage({ type: "error", message: "Ошибка перемещения: " + msg });
	            });
	            return;
	        }
	
	        // Перевести в успех (→ status 5)
	        if (toStatus === 5) {
	            api.moveToSuccessCrmPayoutRequest(requestId, null).then(function () {
	                setRefreshKey(function (k) {
	                    return k + 1;
	                });
	            }).catch(function (e) {
	                Sentry.captureException(e);
	                var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	                onMessage({ type: "error", message: "Ошибка перемещения: " + msg });
	            });
	            return;
	        }
	    }
	
	    // "На сумму" handlers
	    function openByAmountModal() {
	        setByAmountOpen(true);
	        setByAmountStep(1);
	        setByAmountMerchant("");
	        setByAmountValue("");
	        setByAmountPreview(null);
	        setByAmountName("");
	        setByAmountError("");
	    }
	
	    function closeByAmountModal() {
	        setByAmountOpen(false);
	    }
	
	    function handleByAmountPreview() {
	        if (!byAmountMerchant || !byAmountValue || Number(byAmountValue) <= 0) {
	            setByAmountError("Выберите мерчанта и укажите сумму");
	            return;
	        }
	        setByAmountLoading(true);
	        setByAmountError("");
	        new _Api2.default({ token: token }).formCrmRegistryByAmount(byAmountMerchant, Number(byAmountValue), null, payoutType).then(function (r) {
	            setByAmountPreview(r);
	            setByAmountStep(2);
	            setByAmountLoading(false);
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            setByAmountError(msg);
	            setByAmountLoading(false);
	        });
	    }
	
	    function handleByAmountForm() {
	        if (!byAmountName.trim()) {
	            setByAmountError("Введите название реестра");
	            return;
	        }
	        setByAmountLoading(true);
	        setByAmountError("");
	        new _Api2.default({ token: token }).formCrmRegistryByAmount(byAmountMerchant, Number(byAmountValue), byAmountName.trim(), payoutType).then(function (r) {
	            setByAmountLoading(false);
	            setByAmountOpen(false);
	            setRefreshKey(function (k) {
	                return k + 1;
	            });
	            onMessage({ type: "success", message: "Реестр \"" + byAmountName.trim() + "\" сформирован (" + r.count + " заявок на " + r.totalAmount.toLocaleString("ru-RU", { minimumFractionDigits: 2 }) + " \u20BD)" });
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            setByAmountError(msg);
	            setByAmountLoading(false);
	        });
	    }
	
	    // Подсчёт сводки из статистики
	    var totalAmount = 0;
	    var totalRequests = 0;
	    var statsMap = {};
	    if (stats && stats.stats) {
	        stats.stats.forEach(function (s) {
	            totalRequests += s.count;
	            totalAmount += s.totalAmount;
	            statsMap[s.status] = s;
	        });
	    }
	
	    // Определяем, какие статусы показывать в канбане
	    var visibleStatuses = (0, _CrmPayoutBoardUtils.columnsForQuickStatus)(quickStatus);
	
	    var pageContent = _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.PageContainer + " d-flex flex-column min-vh-100" },
	        _react2.default.createElement(
	            "div",
	            { className: "row flex-grow-1" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-12 pt-2" },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.PageHeader },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _stylesModule2.default.PageTitle },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: isSbp ? "CrmSbpPayout.title" : "CrmPayout.title",
	                            defaultMessage: isSbp ? "CRM-заявки СБП" : "CRM-заявки на выплаты"
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.HeaderButtons },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: "btn btn-sm btn-success",
	                                onClick: function onClick() {
	                                    setCreateOpen(true);
	                                }
	                            },
	                            "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: "btn btn-sm " + (filtersOpen ? "btn-primary" : "btn-outline-primary"),
	                                onClick: function onClick() {
	                                    setFiltersOpen(!filtersOpen);
	                                }
	                            },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CrmPayout.filters.title", defaultMessage: "\\u0424\\u0438\\u043B\\u044C\\u0442\\u0440\\u044B" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: "btn btn-sm btn-outline-success",
	                                onClick: openByAmountModal
	                            },
	                            "\u041D\u0430 \u0441\u0443\u043C\u043C\u0443"
	                        )
	                    )
	                ),
	                _react2.default.createElement(_SearchTags2.default, {
	                    onChangeSearch: onChangeSearch,
	                    isDisabled: false,
	                    defaultSearch: {
	                        key: "fullName",
	                        locale: "CrmPayout.search.fullName",
	                        placeholder: "CrmPayout.search.fullName.placeholder"
	                    },
	                    searchBy: [{
	                        key: "fullName",
	                        locale: "CrmPayout.search.fullName",
	                        placeholder: "CrmPayout.search.fullName.placeholder"
	                    }, {
	                        key: "phone",
	                        locale: "CrmPayout.search.phone",
	                        placeholder: "CrmPayout.search.phone.placeholder"
	                    }, !isSbp && {
	                        key: "cardMask",
	                        locale: "CrmPayout.search.cardMask",
	                        placeholder: "CrmPayout.search.cardMask.placeholder"
	                    }, {
	                        key: "merchantName",
	                        locale: "CrmPayout.search.merchantName",
	                        placeholder: "CrmPayout.search.merchantName.placeholder"
	                    }, {
	                        key: "transactionId",
	                        locale: "CrmPayout.search.transactionId",
	                        placeholder: "CrmPayout.search.transactionId.placeholder"
	                    }, {
	                        key: "externalReference",
	                        locale: "CrmPayout.search.externalReference",
	                        placeholder: "CrmPayout.search.externalReference.placeholder"
	                    }].filter(Boolean)
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.StatsBar },
	                    _CrmPayoutRequestsUtils.STATUS_CONFIG.map(function (sc) {
	                        var s = statsMap[sc.status];
	                        var count = s ? s.count : 0;
	                        var isActive = quickStatus === sc.status;
	                        var badgeStyle = isActive ? { background: sc.color, color: "#fff", borderColor: sc.color } : { background: sc.bg, color: sc.color, borderColor: "transparent" };
	
	                        return _react2.default.createElement(
	                            "button",
	                            {
	                                key: sc.status,
	                                className: _stylesModule2.default.StatsBadge,
	                                style: badgeStyle,
	                                onClick: function onClick() {
	                                    handleQuickStatusFilter(sc.status);
	                                },
	                                type: "button",
	                                title: sc.label
	                            },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.StatsBadgeLabel },
	                                sc.label
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.StatsBadgeCount },
	                                count
	                            )
	                        );
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.StatsTotalBadge },
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.StatsBadgeLabel },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CrmPayout.stats.total", defaultMessage: "\\u0412\\u0441\\u0435\\u0433\\u043E" })
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.StatsBadgeCount },
	                            totalRequests
	                        ),
	                        totalAmount > 0 && _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.StatsTotalAmount },
	                            totalAmount.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
	                            " ",
	                            "\u20BD"
	                        )
	                    )
	                ),
	                _react2.default.createElement(_CrmPayoutActions2.default, {
	                    selectedIds: selectedIds,
	                    token: token,
	                    data: list,
	                    registries: registries,
	                    onComplete: handleBulkComplete,
	                    onClearSelection: function onClearSelection() {
	                        setSelectedIds([]);
	                    },
	                    onMessage: onMessage
	                }),
	                _react2.default.createElement(_CrmPayoutBoard2.default, {
	                    isLoading: loading,
	                    data: list,
	                    registries: registries,
	                    currentId: selected ? selected.id : null,
	                    selectedIds: selectedIds,
	                    visibleStatuses: visibleStatuses,
	                    totals: totals,
	                    loadingStatuses: loadingStatuses,
	                    onLoadMore: handleLoadMore,
	                    onSelect: onSelectRequest,
	                    onCheck: handleCheck,
	                    onCheckAllInColumn: handleCheckAllInColumn,
	                    onRegistryClick: handleRegistryClick,
	                    onDragDrop: handleDragDrop
	                }),
	                selected && _react2.default.createElement(_CrmPayoutDetails2.default, {
	                    request: selected,
	                    token: token,
	                    onUpdate: onRequestUpdate,
	                    onClose: function onClose() {
	                        setSelected(null);
	                    },
	                    onRegistryClick: handleRegistryClick,
	                    onMessage: onMessage
	                }),
	                registryId && _react2.default.createElement(_CrmRegistryModal2.default, {
	                    registryId: registryId,
	                    payoutType: payoutType,
	                    registryInfo: registries.find(function (r) {
	                        return r.id === registryId;
	                    }) || null,
	                    token: token,
	                    onClose: function onClose() {
	                        setRegistryId(null);
	                    },
	                    onComplete: function onComplete() {
	                        setRefreshKey(function (k) {
	                            return k + 1;
	                        });
	                    },
	                    onMessage: onMessage
	                }),
	                createOpen && _react2.default.createElement(_CrmPayoutCreateModal2.default, {
	                    token: token,
	                    payoutType: payoutType,
	                    merchants: merchants,
	                    onClose: function onClose() {
	                        setCreateOpen(false);
	                    },
	                    onCreated: function onCreated() {
	                        setCreateOpen(false);
	                        setRefreshKey(function (k) {
	                            return k + 1;
	                        });
	                    },
	                    onMessage: onMessage
	                }),
	                byAmountOpen && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ModalBackdrop, onClick: closeByAmountModal },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Modal, onClick: function onClick(e) {
	                                e.stopPropagation();
	                            } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.ModalHeader },
	                            _react2.default.createElement(
	                                "h5",
	                                { style: { margin: 0, fontSize: 16, fontWeight: 600 } },
	                                "\u0421\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0435\u0441\u0442\u0440 \u043D\u0430 \u0441\u0443\u043C\u043C\u0443"
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                { type: "button", className: _stylesModule2.default.ModalClose, onClick: closeByAmountModal },
	                                _react2.default.createElement(_Icon2.default, { icon: "close", size: "15px" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.ModalBody },
	                            byAmountError && _react2.default.createElement(
	                                "div",
	                                { className: "alert alert-danger py-1 mb-2" },
	                                byAmountError
	                            ),
	                            byAmountStep === 1 && _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mb-2" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        {
	                                            className: "form-control",
	                                            value: byAmountMerchant,
	                                            onChange: function onChange(e) {
	                                                setByAmountMerchant(e.target.value);
	                                            }
	                                        },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "-- \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 --"
	                                        ),
	                                        merchants.map(function (m) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: m.uuid, value: m.uuid },
	                                                m.displayName
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mb-2" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "\u0426\u0435\u043B\u0435\u0432\u0430\u044F \u0441\u0443\u043C\u043C\u0430 (\u0440\u0443\u0431.)"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "number",
	                                        className: "form-control",
	                                        value: byAmountValue,
	                                        onChange: function onChange(e) {
	                                            setByAmountValue(e.target.value);
	                                        },
	                                        min: "1",
	                                        step: "0.01",
	                                        placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 2000000"
	                                    })
	                                )
	                            ),
	                            byAmountStep === 2 && byAmountPreview && _react2.default.createElement(
	                                "div",
	                                null,
	                                byAmountPreview.count === 0 ? _react2.default.createElement(
	                                    "div",
	                                    { className: "alert alert-warning py-2" },
	                                    "\u041D\u0435\u0442 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0437\u0430\u044F\u0432\u043E\u043A \u0434\u043B\u044F \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0441\u0443\u043C\u043C\u044B"
	                                ) : _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "alert alert-info py-2 mb-2" },
	                                        _react2.default.createElement(
	                                            "strong",
	                                            null,
	                                            byAmountPreview.merchantName
	                                        ),
	                                        _react2.default.createElement("br", null),
	                                        "\u0411\u0443\u0434\u0435\u0442 \u0432\u044B\u0431\u0440\u0430\u043D\u043E: ",
	                                        _react2.default.createElement(
	                                            "strong",
	                                            null,
	                                            byAmountPreview.count
	                                        ),
	                                        " \u0437\u0430\u044F\u0432\u043E\u043A",
	                                        _react2.default.createElement("br", null),
	                                        "\u041D\u0430 \u0441\u0443\u043C\u043C\u0443: ",
	                                        _react2.default.createElement(
	                                            "strong",
	                                            null,
	                                            byAmountPreview.totalAmount.toLocaleString("ru-RU", { minimumFractionDigits: 2 }),
	                                            " ",
	                                            "\u20BD"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "form-group mb-2" },
	                                        _react2.default.createElement(
	                                            "label",
	                                            null,
	                                            "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0435\u0441\u0442\u0440\u0430"
	                                        ),
	                                        _react2.default.createElement("input", {
	                                            type: "text",
	                                            className: "form-control",
	                                            value: byAmountName,
	                                            onChange: function onChange(e) {
	                                                setByAmountName(e.target.value);
	                                            },
	                                            placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0435\u0441\u0442\u0440\u0430"
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.ModalFooter },
	                            _react2.default.createElement(
	                                "button",
	                                { className: "btn btn-secondary", onClick: closeByAmountModal },
	                                "\u041E\u0442\u043C\u0435\u043D\u0430"
	                            ),
	                            byAmountStep === 1 && _react2.default.createElement(
	                                "button",
	                                {
	                                    className: "btn btn-primary",
	                                    onClick: handleByAmountPreview,
	                                    disabled: byAmountLoading
	                                },
	                                byAmountLoading ? "Загрузка..." : "Подобрать"
	                            ),
	                            byAmountStep === 2 && byAmountPreview && byAmountPreview.count > 0 && _react2.default.createElement(
	                                "div",
	                                { style: { display: "flex", gap: 8 } },
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: "btn btn-outline-primary",
	                                        onClick: function onClick() {
	                                            setByAmountStep(1);setByAmountPreview(null);setByAmountError("");
	                                        }
	                                    },
	                                    "\u041D\u0430\u0437\u0430\u0434"
	                                ),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: "btn btn-success",
	                                        onClick: handleByAmountForm,
	                                        disabled: byAmountLoading
	                                    },
	                                    byAmountLoading ? "Формирование..." : "Сформировать"
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	
	    return _react2.default.createElement(
	        _FilterPanel2.default,
	        { title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B", isOpen: filtersOpen, onClose: function onClose() {
	                setFiltersOpen(false);
	            }, content: pageContent },
	        _react2.default.createElement(_CrmPayoutFilters2.default, {
	            payoutType: payoutType,
	            isOpen: filtersOpen,
	            onClose: function onClose() {
	                setFiltersOpen(false);
	            },
	            onApplyFilters: onApplyFilters,
	            merchants: merchants,
	            isLoading: loading
	        })
	    );
	});
	
	exports.default = CrmPayoutRequestsPage;

/***/ },
/* 191 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * MessageFormatter Service
	 * Standardizes error and success message formatting and types
	 */
	
	var MessageFormatter = function () {
	  function MessageFormatter() {
	    _classCallCheck(this, MessageFormatter);
	  }
	
	  _createClass(MessageFormatter, null, [{
	    key: 'error',
	
	    /**
	     * Format error message for user display
	     * @param {string|Error} error - Error message or Error object
	     * @param {Object} options - Formatting options
	     * @returns {Object} { type: 'error', message: string }
	     */
	    value: function error(_error) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var message = void 0;
	
	      if (_error instanceof Error) {
	        message = _error.message;
	      } else if (typeof _error === 'string') {
	        message = _error;
	      } else {
	        message = 'An error occurred';
	      }
	
	      return Object.assign({
	        type: 'error',
	        message: message
	      }, options);
	    }
	
	    /**
	     * Format success message
	     * @param {string} message - Success message
	     * @param {Object} options - Formatting options
	     * @returns {Object} { type: 'success', message: string }
	     */
	
	  }, {
	    key: 'success',
	    value: function success() {
	      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Operation completed successfully';
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return Object.assign({
	        type: 'success',
	        message: message
	      }, options);
	    }
	
	    /**
	     * Format warning message
	     * @param {string} message - Warning message
	     * @param {Object} options - Formatting options
	     * @returns {Object} { type: 'warning', message: string }
	     */
	
	  }, {
	    key: 'warning',
	    value: function warning(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return Object.assign({
	        type: 'warning',
	        message: message || 'Warning: Please check your action'
	      }, options);
	    }
	
	    /**
	     * Format info message
	     * @param {string} message - Info message
	     * @param {Object} options - Formatting options
	     * @returns {Object} { type: 'info', message: string }
	     */
	
	  }, {
	    key: 'info',
	    value: function info(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return Object.assign({
	        type: 'info',
	        message: message || 'Information'
	      }, options);
	    }
	
	    /**
	     * Format generic message object
	     * @param {string} type - Message type (error, success, warning, info)
	     * @param {string} message - Message text
	     * @param {Object} options - Additional options
	     * @returns {Object} Formatted message
	     */
	
	  }, {
	    key: 'message',
	    value: function message(type, _message) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (!['error', 'success', 'warning', 'info'].includes(type)) {
	        console.warn('Unknown message type: ' + type);
	        return Object.assign({ type: 'info', message: _message }, options);
	      }
	
	      return Object.assign({ type: type, message: _message }, options);
	    }
	
	    /**
	     * Format validation error messages
	     * @param {Object|Array} errors - Validation errors
	     * @param {Object} options - Formatting options
	     * @returns {Object} { type: 'error', message: string }
	     */
	
	  }, {
	    key: 'validationError',
	    value: function validationError(errors) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var message = void 0;
	
	      if (Array.isArray(errors)) {
	        if (errors.length === 0) {
	          message = 'Validation error';
	        } else if (errors.length === 1) {
	          message = errors[0] && errors[0].message || errors[0] || 'Validation error';
	        } else {
	          message = errors.length + ' validation errors found. Please check your input.';
	        }
	      } else if ((typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) === 'object') {
	        var errorMessages = Object.values(errors).flat().filter(function (e) {
	          return e;
	        }).slice(0, 2); // Show first 2 errors
	
	        if (errorMessages.length > 0) {
	          message = errorMessages.join('. ') + (Object.keys(errors).length > 2 ? '...' : '');
	        } else {
	          message = 'Validation error';
	        }
	      } else {
	        message = errors || 'Validation error';
	      }
	
	      return Object.assign({
	        type: 'error',
	        message: message
	      }, options);
	    }
	
	    /**
	     * Format permission/authorization error
	     * @param {string} action - Action that was denied
	     * @param {string} resource - Resource being accessed
	     * @returns {Object} Formatted error message
	     */
	
	  }, {
	    key: 'permissionError',
	    value: function permissionError() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'perform this action';
	      var resource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var message = 'You don\'t have permission to ' + action;
	      if (resource) {
	        message += ' on ' + resource;
	      }
	
	      return {
	        type: 'error',
	        message: message
	      };
	    }
	
	    /**
	     * Format network/connectivity error
	     * @returns {Object} Formatted error message
	     */
	
	  }, {
	    key: 'networkError',
	    value: function networkError() {
	      return {
	        type: 'error',
	        message: 'Network error. Please check your connection and try again.'
	      };
	    }
	
	    /**
	     * Format timeout error
	     * @param {string} operation - Operation that timed out
	     * @returns {Object} Formatted error message
	     */
	
	  }, {
	    key: 'timeoutError',
	    value: function timeoutError() {
	      var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Operation';
	
	      return {
	        type: 'error',
	        message: operation + ' timed out. Please try again.'
	      };
	    }
	
	    /**
	     * Format server error
	     * @param {string} operation - Operation that failed
	     * @returns {Object} Formatted error message
	     */
	
	  }, {
	    key: 'serverError',
	    value: function serverError() {
	      var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Operation';
	
	      return {
	        type: 'error',
	        message: operation + ' failed due to server error. Please try again later.'
	      };
	    }
	
	    /**
	     * Format payment-specific messages
	     */
	
	
	    /**
	     * Format registry-specific messages
	     */
	
	
	    /**
	     * Format transaction-specific messages
	     */
	
	  }, {
	    key: 'merge',
	
	
	    /**
	     * Merge multiple messages into one
	     * @param {Array<Object>} messages - Messages to merge
	     * @returns {Object} Merged message
	     */
	    value: function merge() {
	      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      if (messages.length === 0) return { type: 'info', message: '' };
	      if (messages.length === 1) return messages[0];
	
	      // Prioritize error > warning > info > success
	      var priority = { error: 0, warning: 1, info: 2, success: 3 };
	      var sorted = [].concat(_toConsumableArray(messages)).sort(function (a, b) {
	        return priority[a.type] - priority[b.type];
	      });
	
	      var merged = sorted[0];
	      var additionalCount = messages.length - 1;
	
	      if (additionalCount > 0) {
	        merged.message += ' (and ' + additionalCount + ' more message' + (additionalCount > 1 ? 's' : '') + ')';
	      }
	
	      return merged;
	    }
	  }]);
	
	  return MessageFormatter;
	}();
	
	MessageFormatter.payment = {
	  success: function success() {
	    return {
	      type: 'success',
	      message: 'Payment processed successfully'
	    };
	  },
	  error: function error() {
	    var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return {
	      type: 'error',
	      message: 'Payment failed' + (details ? ': ' + details : '')
	    };
	  },
	  pending: function pending() {
	    return {
	      type: 'info',
	      message: 'Payment is being processed...'
	    };
	  },
	  invalid: function invalid() {
	    return {
	      type: 'error',
	      message: 'Invalid payment details. Please check and try again.'
	    };
	  }
	};
	MessageFormatter.registry = {
	  uploadSuccess: function uploadSuccess() {
	    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    return {
	      type: 'success',
	      message: count > 0 ? 'Registry uploaded successfully (' + count + ' transactions)' : 'Registry uploaded successfully'
	    };
	  },
	  uploadError: function uploadError() {
	    var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    return {
	      type: 'error',
	      message: 'Registry upload failed' + (details ? ': ' + details : '')
	    };
	  },
	  processing: function processing() {
	    return {
	      type: 'info',
	      message: 'Registry is being processed...'
	    };
	  },
	  reprocessing: function reprocessing() {
	    return {
	      type: 'info',
	      message: 'Registry is being reprocessed...'
	    };
	  },
	  validationError: function validationError() {
	    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    return {
	      type: 'error',
	      message: 'Registry validation failed' + (errors.length > 0 ? ': ' + errors.slice(0, 2).join(', ') + (errors.length > 2 ? '...' : '') : '')
	    };
	  }
	};
	MessageFormatter.transaction = {
	  success: function success() {
	    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Operation';
	    return {
	      type: 'success',
	      message: action + ' completed successfully'
	    };
	  },
	  error: function error() {
	    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Operation';
	    var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    return {
	      type: 'error',
	      message: action + ' failed' + (details ? ': ' + details : '')
	    };
	  },
	  declined: function declined() {
	    return {
	      type: 'warning',
	      message: 'Transaction was declined'
	    };
	  },
	  timeout: function timeout() {
	    return {
	      type: 'warning',
	      message: 'Transaction is pending. Please check status later.'
	    };
	  }
	};
	exports.default = MessageFormatter;

/***/ },
/* 192 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.terminalSupportsMethod = terminalSupportsMethod;
	exports.filterTerminalsByMethod = filterTerminalsByMethod;
	/**
	 * Способы выплаты, доступные через терминал.
	 *
	 * Бэкенд отдаёт их в `payoutMethods` каждого терминала (`GET /merchant/{uuid}`).
	 * Список считается по настройкам терминала: флаг «терминал под СБП», типы
	 * заявок CRM и протокол процессинга — выплату по СБП умеют не все.
	 *
	 * Зачем это на фронте: кабинет метода терминала не знал вовсе и в карточном
	 * реестре предлагал в том числе СБП-терминалы. Мерчант выбирал «arMax Тест —
	 * выплаты по СБП», а страница просила у него номера карт — при том, что через
	 * этот терминал платят по номеру телефона. Проверка на бэкенде такой файл
	 * отобьёт, но уже после того, как человек его собрал и загрузил.
	 */
	
	var PAYOUT_METHOD_CARD = exports.PAYOUT_METHOD_CARD = "card";
	var PAYOUT_METHOD_SBP = exports.PAYOUT_METHOD_SBP = "sbp";
	
	/**
	 * Доступен ли способ выплаты через этот терминал.
	 *
	 * Пустой или отсутствующий `payoutMethods` означает «не знаем» и пропускает
	 * терминал: кабинет и бэкенд выкатываются порознь, и пока поле не приехало,
	 * скрывать терминалы нельзя — мерчант останется без списка вообще.
	 *
	 * @param {object|null} terminal
	 * @param {string} method PAYOUT_METHOD_CARD | PAYOUT_METHOD_SBP
	 * @returns {boolean}
	 */
	function terminalSupportsMethod(terminal, method) {
	    if (!terminal) {
	        return false;
	    }
	
	    var methods = terminal.payoutMethods;
	    if (!Array.isArray(methods) || methods.length === 0) {
	        return true;
	    }
	
	    var wanted = String(method).toLowerCase();
	
	    return methods.some(function (m) {
	        return String(m).toLowerCase() === wanted;
	    });
	}
	
	/**
	 * Терминалы, через которые можно выплатить этим способом.
	 *
	 * @param {Array|null} terminals
	 * @param {string} method PAYOUT_METHOD_CARD | PAYOUT_METHOD_SBP
	 * @returns {Array}
	 */
	function filterTerminalsByMethod(terminals, method) {
	    if (!Array.isArray(terminals)) {
	        return [];
	    }
	
	    return terminals.filter(function (t) {
	        return terminalSupportsMethod(t, method);
	    });
	}

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LayoutScopeProvider = undefined;
	exports.useLayoutScope = useLayoutScope;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayoutScopeContext = _react2.default.createContext({
	    scope: null,
	    hideLegacyMenus: false
	});
	
	var LayoutScopeProvider = exports.LayoutScopeProvider = LayoutScopeContext.Provider;
	
	function useLayoutScope() {
	    return _react2.default.useContext(LayoutScopeContext);
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 195 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"gRn9toV7fywWDS22xkDSv","Chart":"_3umU2haLQMkoxEreMkqz-e","Card":"_1Cl8Gk7yJzz59wfUTOx8d4","Header":"_2jKyzwwH4DN1B9qmu3ZVkO","Content":"_2TWBGB6uLpzV1aGMivfZ5k","Wrapper":"_37aC3IbM6aVTTWvbprpL6a","Table":"_2jMWX2q4HJ8r5wQ3_kgZ2H","Empty":"_1_KxPX5W4gOBZs6I_-Yh7T","EmptyRow":"_3092Ded0WzkyVj-gajWlJO"};

/***/ },
/* 196 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2Y7srKoMi8irRZA9Km-PJ8","Content":"_3aWODGUDycXtRLqPM2z8VS","CardFooter":"_2B4b6QjtKS7zlIipwbhrsW","Block":"mTfoawhTRk_-GaNkwTEDP","Col_1":"_1pC2e15dbfcVELfeMlo8-0","Col_2":"_1ZIpjVfJmAIK49A6nbTxDS","Col_3":"_3ypaWxfcAXdZJMTkdWU4ZF","ColFullWidth":"_1FsGe-a5oieA3w2x1RvHXw","Divider":"_2fogiHzZLgMrOx6MWJr2XS","BlockTitle":"_16CTmS9X27RCYuFo_PfIWa","List":"_25E-9hGT2BdZVINkFTfwAz","Status":"_1BKcmHbGjKMo9JkJVmHc8i","CurrentStatus":"_22HE5-PDEHs0JIrzS6kcNk","StatusSelect":"_1m9EbSPFbbObKfCpPDKKVV","AdminBlock":"_1V4L7zmRlI6SiF40MyX7Pm","AdminCheckbox":"_6Bv7SnhIO-SAtzlbMoAGT","GlobalPermissionsBlock":"w9SKgZDd1-mw63Wc-Fbvp","GlobalPermissionsHeader":"_2ESon-_zd5qoz1Z9NYIxDH","GlobalPermissionsHint":"_1J9gslZ5eRzhZr0RuYlQ2c","GlobalPermissionsActions":"_1adR30m9tstoW43H_Hce9g","GlobalPermissionsToggle":"_3yLG4Aez1pcut3d2__5UFA","Btn":"_2FJdsQmbBPq3mhnQfPhKrp","inputWrap":"_2ijR5YKNjI2cv2oNsx0OBo","IconPassword":"_3gHgIYNXNBrmD9p7MXwCAA","Empty":"_1ELRg8zgI98nh-Q5ezJrL7","InputHeader":"DezLzMId5raBg1XV2yz4r","Label":"_1luQcr_LwMQoZ_cp6bD9hH","InputLink":"_1ulnIOSZ5_tJwDSK95-BP","LinkIcon":"_38UMEWVkfvYOJ-9_zGEofk","ModalOverlay":"_2yn6UJ1hecrZYCfaGoBvxa","PermissionsModal":"_1noBLkAZAufMAl4Bb-5Bcn","ModalHeader":"_IA7BK9Zf_civQif2W29K","ModalClose":"_26xtht1B_7bGV5PZlNz20Q","ModalBody":"_3GBcTEkmFy8tiQYwBv7ouo","BtnPrimary":"_3WXd8KFjkIU7k1-gyujyWS","SavingOverlay":"_1sYIrxViGZqugqAlELqwl0","SavingSpinner":"Y_AWAYw-o-CysonxGZvFC","spin":"_14KxU0XCmANCp1zY294_U4"};

/***/ },
/* 197 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TableScroll":"_2hqXik9kzeng_ixBFgLQ-v","Table":"_34fkPk5hI0Y2Y4dwLgvyWS","HeaderCell":"_3wglD5QV7n3JRX97srMWIk","HeaderCenter":"_1efQU9B50hWVpJzV02LU9W","Row":"tplawdN48TpiofI_65-29","Active":"_1cm1r8p8JZ-OpSMInBdhru","Cell":"_2Z4nJCMMizymItLs67gZz7","CellCenter":"_2im9eZLpf4UWl6IpxN7_0X","Empty":"_2ATN76YGxX597rnViqDR7O","EmptyRow":"_2QsCy8TISKBOm-bAsNaIxg","MobileList":"_1i8ON_YqnqtXaeflHU0XDe","MobileCard":"_2HelFDOrtGLnJ4nQnSea5N","MobileCardActive":"r46jnb5uUbbnHq-DNrcB2","MobileRow":"Dn_LaiVaiYjkqFxSwoHJu","MobileFooter":"_1OQdIVkUeroJ3TagEPqZtK","MobilePrimary":"_351KZiSw-q_J7P1nasS5GT","MobileValue":"_5WKRwfyonhu_2CDdlMb9H","MobileReason":"_3Zdhj1wtlP6-WmiRJmSYr1"};

/***/ },
/* 198 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"M5LkUiA3k5EFw4r8jUrI_","Content":"_3oa_Xfxv8G2nGcGXH4mdmk","CardFooter":"Lty0hrnvQm9rXR3Q-YSzM","Block":"_3fLgwBrEIuG3FQYugqMPQ","Col_1":"_3XtBAKHek_2l_MqfhOSM-y","Col_2":"_1oOCUNZqWZCaKVV7cC9KCy","Col_3":"_33oonF7VPaBtHvAIAfRfri","ColFullWidth":"_2BXMeD6VWxrt7x9XIxn_aN","Divider":"_1Pj3Kk8cVvBhN7vvyarrt8","BlockTitle":"NAHwv8T-eWLSVmyW2o3RB","List":"_1ecGGcLa7FrrPaY7YDlcfi","Status":"c9hjFoO8aG9qiq-iBr-6L","CurrentStatus":"_2FYFyxf-MOB9H7rH5wxI3P","StatusSelect":"_2rMbf7mbE0mQDdsYLrav6e","Btn":"_1_JzHog3SEKWSRM5NKLtkx","Empty":"_184W_lYef1c-Df-L0-8NhA","ProjectFields":"_37zeKBA9PnW0ZAcO0-LfC0","ServiceCard":"_2EFmND6vQfk_I6kg8kZuXn","SubBlock":"_1Ozg5MHZoQXS_qgVQbTNaT","ServiceActions":"_2GTMnX73uvrvTBMak1MqNl","btn-delete":"_1P-tbz8Q_Len8x0ptyTwWw","NewService":"_3MB6T7-jmWukGLo3xanVe6","btn-change":"_3L0g4uNO8EpYPDtEX6ZoyN","ServicesWrapper":"_2TkobYC22c2DHy_-Z8-V4C","ModalOverlay":"_2CYllZm1NMLpvZddn56dva","Modal":"_3MWgSOMH1Ml847aIvuF8p1","ModalHeader":"_1VBSCwSc5tyZMXuqgOiZSj","ModalClose":"wMXWt4qzTO9-RLOdYsLaQ","ModalBody":"_1ycqGCsOZ4xdHwxEASzFRK","WidgetField":"_1qDB1UV6z3HlAK1p55yzbB","WidgetLabel":"_336_RVZ5KxtM_9KTzjIJYx","WidgetInputGroup":"_14XotE-SvxdYaTWFNEkD_f","WidgetInput":"_3Br8xZGmhOXU3Ojtji0sPd","WidgetBtnGenerate":"_1PsQAjYPKgPsTrcSRq-dkb","HintText":"_2Y3hnNUtNNFJIYKYUGiZr5","KeyTextarea":"_1u1yIW2oIKmtEShDWi8mu5","StyledSelect":"_3ImxhqLp0gkePNLTz9y7WG","StyledInput":"_2Eb0JxvHLv__JpVFpb7trK","BtnPrimary":"_2kD6xd7sqQk_e0hN5moJIv","BtnSecondary":"_3YOR6VcH1Mo7h5p1T4UloD","BtnDanger":"gCCUOqtvYXD_v_H5_L6U3","BtnSuccess":"ztf3ARp5XFHNk2YuQRa8x","MethodsGrid":"_2hRAAiwJQvvs6zI3rlayOm","ToggleLabel":"_3RqQHWTA38rU5-REcdfdZ1","FeeCard":"_1Kc6ZDbNYx5OvNmvHSnbxl","FeeCardHeader":"_2UoVROaPUkINPdkwrOUGE_","FeeCardTitle":"_3V6-t_OXlC9c-mj3S0m97J","FeeInputs":"_3s390br-C0KhEHZfZpt6LK","FeeInputGroup":"_1tFUr2Qb2OG8Adiz2g84j1","CardHeader":"_1cF3bLvM1_RithqRd-o_Rw","CardActions":"_15YnZhocokIImZTVoThxDp","ProviderSection":"_3-_SYQnsAGpOMr0VdKQ4MR","ProviderLabel":"QqhRGBO5mMAiw-LPjuF9S","ProviderCurrent":"_2QPdVnOuZZHDq0NTASfIKK","InfoRow":"_1cHLugJbbwet8hFnzrHHuH","InfoLabel":"_3FnXSULdd00P8xwaASZoFM","InfoValue":"RglZOhlxIHMzvJX8-aSDh","ToggleSwitch":"_33LVpxAC1TR8-_IbQXUfrG","ToggleText":"_2b-geAXniizpQoraqujXJ5","AntifraudToggle":"QktKVCrvNCmAk4CJDwWh-","MerchantKeyGroup":"jADRS5T0PuLeOSVcGokgT","MerchantKeyInput":"_3JJMwja__1qt2ZBWQX0pSv","BtnCopy":"_2Cf92Ny3CFI8RE6mV7Kudv","LoadingOverlay":"WuJ-T-e3lroIYmICNHg5t","SavingOverlay":"_1ei1PvMQk5RSbm2O2_krLA","LoadingSpinner":"_1lAH7tXL7YHH_ucERT7aeR","SavingSpinner":"_2Z4bSkZPbEGbAYjBI9_fMr","spin":"bHJRtABefCTOScPjm-qtf","PermissionsModal":"_2R6Yh9U2ZoRCvDvPV8FoCm"};

/***/ },
/* 199 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"_3LPmkI0eQs2K9TzqfrRHxm","ChartColumn":"_2h3zkYLWUG_wLogqOVGJYN","TableColumn":"kvQOzuMsVY9tQ2hN3xFZe","Table":"_1jIZZSkp-ZIqpUSUXNAMzc","Empty":"_3NqkcR8vaEG-_nYfcLS4fG"};

/***/ },
/* 200 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2MV9TuGkNu3Q2ZguqRENLb","Header":"_2EGthnd8IJzJ1nt3pdtR3B","Content":"_15RxDjY_4cN2AZ0krIkt87","Button":"_3JoNiUcbC1pRhBvpBtA8Xa","Empty":"_14ZxbGNxg4ElMXbhLt6lJg","EmptyText":"_1-K18JPa84zbHnihzbwJWb"};

/***/ },
/* 201 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Menu":"_3p1OVG6IY7WRhi7dyJYOUP","Link":"_1DM4M_HED8FxpVOIOf9D-A","LinkDisabled":"_3MLgT1VQQqQcgcbQzigDCI","Root":"_2AoJ06wVdE484sn8aa4skd","NavMode":"_3ZmPTfsdSRqoTb8_IRFpN3","TicketsLink":"_21hzNnVToaIGsAcJGsJsri","AdminMode":"_3VhFCr2r7l3T0klJyVDJfw","MenuText":"_3Sgdq5QsMUGqHNKxvjISIt","LinkText":"inb9Cvrvpzh3bRpze0wOj","ProfileText":"l2NB3PKBqR0kQ2IIfeLXg","ProfileTitle":"_1MWDFGhNGzYfS0_alZK89w","DesktopActions":"q_gDU9R6EEbcRjSb_Mkge","BurgerItem":"_3w1aw5yLtGCSSlbugo3m2H","BurgerButton":"_1qVyXK2XWd7MRBpZVQ4kon","MobileActions":"sNDJ4WprCaY2IANQ2Y9-6","BurgerIcon":"_1D_IZdFil5zl1rCj1Fy_zg","Overlay":"_3gXTMkcAmwW2L5M6fDAVEz","Drawer":"_2wp8_2jJT-G1di9Jrqu6nV","DrawerSection":"_2bugduzVHL-wH3tnrJBM3O","DrawerProfileName":"uMlOVT0vl3lSG5vGsYrr7","AdminDrawerContent":"um6LEi-jauOG27-87M0Dd","AdminTopBlock":"_3gbbd2Mc0j_Ix9U-sPSi9j","AdminFooter":"yxjo4_4JnuP6gwULm3BVt","AdminSections":"_29FwcrVFnF_nrqVMJXHksd","AdminTopLinks":"_1YKALIsagoxhY2Q14ksRWG","DrawerFooterLinks":"N3IhNOyA9HcPa1jj_Ag9l","DrawerToggle":"_2kq8lrDckRgIxWyZ0t1DKb","DrawerToggleActive":"_3pW5LZRo-BzmIELltRy_J_","DrawerToggleLabel":"_1DeZLMjr6gZthbJkbex5rw","DrawerSubmenu":"_1-m6Frxvt7BqheVqV6x_O2","DrawerLink":"_2GZMeI2C43qtin4vZlOU0E","IconLeft":"_3M2ZBbFLuIqqYAie2qg3rT","DrawerButton":"_2AaCTlo-NKbK8eE9CQtKPA","DrawerMenu":"_3uQt0liWKqEEChJqr_aUsm","IconRight":"c4BZFxUoas67V4Y4IIyU4","Active":"_3E5DZuFUQPkxq9rMgRdatx","TicketsActive":"_1QzldJLe7ZD4dnFwQqQwmX","SupportWrap":"_36Z76ZzMVqTKtKwFyZjib9","SupportManagers":"LGmEW1x5V0v5QSfiKyttO","SupportTicket":"_3kMZZI-yHE9qi5OWlPjhKr","SupportTitle":"_19mrLhLlrfphDtPdc4U2xj","TicketTitle":"_1pKDECg5nvA79l96Uc0x9j","Icon":"_1q631hK4jFyt_IxqcR9kT6","IconMessage":"_2F7v9Q3HAv9KhiBdeBbEqm","SupportList":"_13h4Iy14_tX41oAVOBKenw","SupportLink":"_3hsLacg-ckASbM8Yemu2uY","Btn":"_3Aeb5tQ8oPXPW3MiKhHxMW","Submenu":"_1uP3Ykcs7cIQ50273ORBEU","UnreadDot":"bOIlE7eY8fG5IR_JAohhs","Badge":"_2xZ2ORTbuaOULnfIuYRQW3"};

/***/ },
/* 202 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"_1t2D5jK8vuyLYDlHORWUEH","Row":"_3dYMVWt_pzHWCyMrnHzjIC","Link":"_3zhpTwD2zK1DLbuzc9Zjp","Enables":"HtwhtGO75NOVAXfRg7BC4","Disabled":"QJFeZ9TCkgempFY_kOuvS","Payout":"_3xDJwsXDqbZLTdXnoL8wi0","Settings":"_3NLBQZkFDsKArnuBWs0knb","Icon":"_1-afCTDUFNMqElt6Gq5m0C","CellLeft":"_1hD00nfzcDOTu8WbLvp2ip","AmountCell":"_2x1XDiHnG6AoFck6HIoKWC","MobileList":"jZAmjTXl3TErrzoHXBVF6"};

/***/ },
/* 203 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"CB1K0mgrRP8VvT7W_yunS","Header":"_3fQEOerj3IeFT2B7f63WS0","TransactionId":"_1tV_0XH1b19M3tYCr88Q05","Loading":"_2-y0McuWtglh2p3O4Qi_hk","Error":"lV5-bRj3KouccSRqPoZNC","Empty":"_3Xk42lTzhn48oC34QNu_D9","Timeline":"_3VlViSxxjD2hBg5E7W5cfM","EventContainer":"_1NGAuT6kvYsbiVodWUgSTr","EventLine":"_1_yVxXXplJ0CgLlDMdTgYA","EventDot":"_3RbNdekfnERO9lvOxSfAMX","EventConnector":"_2ZCj_9ereVs-JxAmErKSVF","EventContent":"_1S_3E3C9DsulKzdc-C1zAV","EventHeader":"_3mIG-0xN-OFkG6tK3B35_R","EventTime":"_1qPy9OOBEuRSqUDIkfxh62","Time":"_2D3oW6GbMjputFiNaiulzV","Date":"_3RCZlxsey16XN1tUmc80Mb","EventTitle":"_3tmIbrqyXWIyTKhQyOpWlr","EventIcon":"VP55Q37EonjvrnzniTcmH","EventLabel":"_2O6igJqKEX1pp-TO6JJNqp","DirectionBadge":"_2reLSCeVTq0h7Z5nP3CXtN","ActorBadge":"_2ldCg3DVUvY2SfXDAiO66k","HttpOk":"q6dxLV-pzbCsaPnIBZ_m5","HttpError":"_3TQ6fv5bTc7YguFB97L4xx","ExpandIcon":"BCd-nct99C-AYA-Ltuikd","StatusChange":"_14It2AFvbIsvXDXvLq5sS3","StatusFrom":"_1d_cj5IJgG1pnKicEuZmRi","StatusArrow":"q21DNVjSU231rSEW-ZXAQ","StatusTo":"J0nnpaVXhIbXEEdjlySav","ErrorInfo":"_2D1BuVcgDN5GGdNDMnS80p","ErrorCode":"a1kC2UWM010JdlBv1gXgC","ErrorMessage":"Ed6bI5PoSwCKM2PK42532","ClientIp":"_2rxkfWl_NhNUmGsv8q1-qE","CallbackUrl":"_2k8R2DVhANQ3Elj3LjvCYh","CallbackLabel":"_3RBkGmtTm0zTCGY5L2lwsQ","CallbackValue":"BYvgcWxQFefsHmZlHi-Xq","Details":"_2GY6JgdkXQALsSoArBvKJG","SectionHeader":"_2TDZI2Xx3cO1o2knWkRAzo","SectionTitle":"_1UhNBuQcSaG4CMc4jvcCrD","CopyButton":"_1C-H8J5FSmk2SaW5HqqMpv","MetaSection":"_1vI-vJ1WCwacx9Mcd-e55k","PayloadSection":"Gqv6DhtP-ZXL0VgAvlYHY","JsonPre":"_3gDLS3k5v7i1g4949nDotL","FraudSection":"PtX16AnuIoEFnG4yY38_6","FraudHeader":"_3GBS_rK1aXxtWlX2MrWvu9","FraudOk":"_13r8w7i5_rvwYEQfIH86n2","FraudBlocked":"_23JOywf8gFEigGEEfV2vIf","BlockType":"HcpEoTVXIjYxGc_ogXBNC","FraudAttempts":"vJbUyvXkx_U_KOPLStWXz","FraudAttempt":"_7SCEJJrwRcqpLreA7P3L-","FraudStatus":"_36ah6-6IOUQSwDmERE24GD","FraudIp":"_2g5ZoHULx46HgL5s8K7yB3","FraudReason":"_2rX2cftJXJKN-yU7MNiPrj","FraudTime":"_3YRsE84qtKoayarMXC125o","HeaderActions":"_2aGdmZcbM51uiE5qQeMAw0","FilterToggle":"XEiofWqGIxvtFb1TYw5KO","FilterActive":"VoHZoaNDr3upJskOpUegY","FilterBadge":"_1TvoN3odfEkcH4DSE0s_DL","ExportBtn":"_2vrGN3jW0U-4gB0eFenZp5","FiltersPanel":"_2fOF_k3kV9d86azR_G5baG","FilterGroup":"_2aPtghZJMDDNbqPZsXNYrn","FilterLabel":"_3pMhWFELT2zGPXC6HMOzd_","FilterChips":"Zr8_etWRwNVtpuFpjeORi","FilterChip":"jrMwoJ3LbikwcT-7YJCFy","FilterChipActive":"_1ZliwcbmQEltrDTa-RqxH9","ClearFilters":"_3xZvH5Tmx07HO7SDyBe-3J"};

/***/ },
/* 204 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_36r9t_R-kB5oEZmqf4IHwH","Header":"_2X41huhpiubEJeycvSP6A-","Title":"_1yK-xXXPdSxuJrV8JMQiAv","Btn":"_2iVj78hRPKLUxnbRri_Zcd","IconLeft":"_3hYWA8-30cK_nPCdo_ayAR","PaginationWrap":"_2TomVDKBf89XPTe3d-LkJ9","ActiveLink":"_1xe1nLV_c6wl3-KvbGxxMo","Tabs":"m84pbCluZWHwUTW9QNiRe","Tab":"_3egKq7CtYkw3W6nRWio-FU","TabActive":"_3Mgcb1xs1YMHkTU9-k1zHE","TabsBar":"VhQjGcvCWIjM2GUBHwNLQ","TabPane":"_1-94QgXx169e7CuFQ8ION3","HintBox":"_1lf6Brc8AFftWAZAlNQepm"};

/***/ },
/* 205 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Page":"_3nv9hNp5t11KfAZ9UW1eYG","Card":"_1T_eXskpj_BQWEsDVz8nH3","CardHeader":"c_ep4EYrdSOSNLV7cTTnN","Title":"_3yJM2taf97At89ZQDDTnE3","Subtitle":"qcB70VO5Fp0_AO2h4ZBQf","FormGroup":"_2lPVzqmtmwDja2hCorWhjK","Hint":"_1f8j_JlYpZlIwrxCS52lrl","CreateBtn":"_3RCYq4GLmIHiYwdNokAgK9","SecondaryBtn":"J7DI6cU63mVbrtj6vHwIq","PaymentBlock":"_2Hr-PtV-Lz1hdWNtu723dP","OrderBadge":"_12jJvIjn93S2mC6D9kbkbY","OrderBadgeLabel":"FgS8LcXuEZzAkRUqhWpcb","OrderBadgeValue":"LfoLg2O56usijPTXEdlef","BanksTitle":"_22iJB7sR1PQ34SB2Rswsv","CommissionBanner":"PQeinSVNSuauF7agDDY4x","CommissionBannerText":"tdjNQbyrQt9nO4ZHi3o-0","PayBtnVTB":"_1gGwk_TLegDrnA2V7fFeVM","PayBtnTinkoff":"MYLbNn4yRAO0D8KD4Kmt-","PayBtnSber":"_2840UnayNdOZu5W_65XsiJ","PayBtnSberPay":"_3OAYSsHpDOV9V4XUQTs5w2","PayBtnSbp":"_3NDh8phCKHm3LLq38PJQjn","BtnLabel":"_1HIkgAkKlBg_79NP2GJ5Oo","PayIcon":"SP9WYDyV3WA8WP3-HgOtk","PayIconTinkoff":"_2z9SJ6xZax6WY0B-7ftCq7","SmallNote":"_1qn6sBaKC74zg95kqLPLSB","LoadingOverlay":"_3F8ZJLCZ3jfvUKxcOoIeuh","LoadingBox":"_1QeTR9mkqF5Flu-i5PXWWg","ModalOverlay":"_38KaSZoaf5jXTaXO1zXTcy","ModalContent":"_1SOXBk_T4yAqNDy7gqzETS","QrCodeContainer":"_32lyqG9XDNGNMxOmdh15FB","QrCodeImage":"_3B4t600PR9pmKwkF7ME681","LoadingSpinner":"_1plbvYqOy70oLrooVQFdwn","pay3-spin":"_2OR8P9qlfz7jzDde3GLWL3","LoadingText":"_1NCkSjdlxV_2H1XXLH1EER","LoadingSubtext":"_17az9jneKgX1iPGlCxm2HR","QrDetails":"_2WVvIz0577XcgZ7vDpk0RQ","QrDetailsTitle":"AADOg2CJSs3VHY3GaQIdz","QrRow":"_1kzlTHiLeX4p3SgwfolKs1","QrRowMain":"_2iltO3WC4rtGgC_RRnIf91","QrRowLabel":"_1vZe0kkd3tcg-EeaILNz7J","QrRowValue":"_3xUIgj-ffQA_CjegM0A2jp","QrRowValueMono":"_3JG3O7Y2RFHsenaYiT94J5","QrRowValueStrong":"_2YF1yPOcvoAATKWrP87Fuj","QrRowHint":"_2Hc62CgP-HuUcMaOQklhV6","QrCopyBtn":"_2Fpb4IlakUpEfiRqKX3TQE","QrCopyBtnDisabled":"_18SkzcWlnEaW5YcWxyDkHE","CompactTimer":"_1kHuBAG7P2LjGx_XWQfmTs","CompactTimerText":"_1CNtW-kyI-2vmMQ-3yu3Sb","CompactTimerValue":"_3ebSLjE-KfvO_xgAU-ZAti","CarouselContainer":"_2wxjKdXmVHZS-1ZBxnNK5_","CarouselHeader":"_1gWdOGcG0H5Mz2jFLzxCTT","CarouselTitle":"_23CxWmggKGIusM4eqcIOce","CarouselStepText":"_3BkGmdRV6GanhqO-Fgmzx2","CarouselImageWrapper":"_31NX8wR3MPh_fufTYBVcUD","CarouselImage":"E1Y-wbBR_WFhL1UWidC0B","CarouselControls":"_2RAUKnuYB0CcDpQBf3dei0","CarouselArrow":"_3uba_aF1QLZ2mHF1X1VeCt","CarouselDots":"_3_19Owv6QD8vqkFg5PbUX","CarouselDot":"d_wF_UidO2-a6ekOwWmH1","CarouselDotActive":"_2GrGoK-b3K74wqnL3oES_3","Container":"_16xDAoZ2t08hSLzKKpYVz2"};

/***/ },
/* 206 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Block":"_3fm7YovCYzkg5wUfvrU0KV","Col_1":"_2s6dcOeI1nGuJv2MlOXcJ3","Col_2":"_11rH0WKOjVp3GJG0IkEcMf","Col_3":"_2RBRH8Ta8MSo4Cyj3HAVlc","Divider":"_3pJlUAqedg8VsGfN_d6A7_","BlockTitle":"_1yFrxG81-Ok_-Fbvou7FnD","MainColumn":"_31vyjkCouVcRXuC97pJ8U2","SideColumn":"agHP5DtXd_gSfE0yJxprh","StackOnMobile":"_1twLPCdBpTcTvo2YaDyN34","container-fluid":"_3b7BW8kjryQsv6OxuySc3u","Col_2_3":"_3eCOeVdzoGjlDB-Yg3T5vO"};

/***/ },
/* 207 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"n_97McMNOkw1tpKNiDP3a","Header":"_22dZAExuxON8zoJsn52SHj","Title":"_2t___ZYW1HZR_7OOdteK_d","TableWrap":"QGqbTwMopyGMREzAV1QMe","container-fluid":"_3S0IDgqBrhpWwxLrXihol_"};

/***/ },
/* 208 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Head":"iU1W4f-VYYIALHNa0-h0l","Title":"_3OnMY_Sf0JMX0Y-zKH1u1l","Subtitle":"_367v1udhDiLyz7_977xhQI","Board":"_3hLWpYVvl7D6e974ZS1Wbp","Error":"_3bH-RzWxnE7_64OvXrooRB","Overlay":"_1ZzioI93mj_irrlJefmuVg","Dialog":"_2ZWIn_lIenAt98QPzgaUKR","DialogTitle":"_1iIIDUoEtR9KWpFsIq-TmD","Field":"_2eKJenS2aLG3RcXNzy9hVS","DialogButtons":"_1RHTPeDrRLBnjb9mttw49W","Create":"_3-OESHQMqgYpZKOA_pKBHh","Cancel":"_7V_PfYJbczhodgt0yznDD","Picker":"_3DmubYrNsVI6_nTQeQ9KOF","PickerClear":"_1q0QNmNm1Q3dkZ6DUQ4dkq","Suggestions":"_2gX1ZbPev8ZFw7KT27we7-","Suggestion":"_2CTN26Vjl5NJM80lKamyKl","SuggestionName":"_1ri8EYASFtCUG0CiaetIW4","SuggestionLogin":"H4Nju8d4i1iLNMM7g_wlU"};

/***/ },
/* 209 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PaginationWrap":"_2cdOWLVh1FE9dEpwcwyLlw","CategoryGroup":"_1QSowMw_u_LBtEsj_P6ECg","SubCategory":"QnmhUZsrtr3PMmffTtUHS","ActiveLink":"_2aZtl1y6moeXzrSmLDmcOe","FiltersToggle":"_1Rbr3VZ1v7kYonp9roTziu","MainColumn":"_2DkP5gO4_nMGgfmH99Afdh","SidebarColumn":"_2ZjoROPZlSIHflHh5p-nCu","Card":"_2xVlI5h8Ll2UacRmUhRRCD","EmptyChart":"_21Pcsaq3Ef1p-wc73ln874","containerFluid":"fwlpGxaUzr7LhFvg0vurV","container-fluid":"_1lXIWfqonpDFt9RMuC5zbb"};

/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var defaultTimestep = (1 / 60) * 1000;
	var getCurrentTime = typeof performance !== "undefined"
	    ? function () { return performance.now(); }
	    : function () { return Date.now(); };
	var onNextFrame = typeof window !== "undefined"
	    ? function (callback) {
	        return window.requestAnimationFrame(callback);
	    }
	    : function (callback) {
	        return setTimeout(function () { return callback(getCurrentTime()); }, defaultTimestep);
	    };
	
	function createRenderStep(runNextFrame) {
	    var toRun = [];
	    var toRunNextFrame = [];
	    var numToRun = 0;
	    var isProcessing = false;
	    var toKeepAlive = new WeakSet();
	    var step = {
	        schedule: function (callback, keepAlive, immediate) {
	            if (keepAlive === void 0) { keepAlive = false; }
	            if (immediate === void 0) { immediate = false; }
	            var addToCurrentFrame = immediate && isProcessing;
	            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
	            if (keepAlive)
	                toKeepAlive.add(callback);
	            if (buffer.indexOf(callback) === -1) {
	                buffer.push(callback);
	                if (addToCurrentFrame && isProcessing)
	                    numToRun = toRun.length;
	            }
	            return callback;
	        },
	        cancel: function (callback) {
	            var index = toRunNextFrame.indexOf(callback);
	            if (index !== -1)
	                toRunNextFrame.splice(index, 1);
	            toKeepAlive.delete(callback);
	        },
	        process: function (frameData) {
	            var _a;
	            isProcessing = true;
	            _a = [toRunNextFrame, toRun], toRun = _a[0], toRunNextFrame = _a[1];
	            toRunNextFrame.length = 0;
	            numToRun = toRun.length;
	            if (numToRun) {
	                for (var i = 0; i < numToRun; i++) {
	                    var callback = toRun[i];
	                    callback(frameData);
	                    if (toKeepAlive.has(callback)) {
	                        step.schedule(callback);
	                        runNextFrame();
	                    }
	                }
	            }
	            isProcessing = false;
	        },
	    };
	    return step;
	}
	
	var maxElapsed = 40;
	var useDefaultElapsed = true;
	var runNextFrame = false;
	var isProcessing = false;
	var frame = {
	    delta: 0,
	    timestamp: 0,
	};
	var stepsOrder = [
	    "read",
	    "update",
	    "preRender",
	    "render",
	    "postRender",
	];
	var steps = stepsOrder.reduce(function (acc, key) {
	    acc[key] = createRenderStep(function () { return (runNextFrame = true); });
	    return acc;
	}, {});
	var sync = stepsOrder.reduce(function (acc, key) {
	    var step = steps[key];
	    acc[key] = function (process, keepAlive, immediate) {
	        if (keepAlive === void 0) { keepAlive = false; }
	        if (immediate === void 0) { immediate = false; }
	        if (!runNextFrame)
	            startLoop();
	        return step.schedule(process, keepAlive, immediate);
	    };
	    return acc;
	}, {});
	var cancelSync = stepsOrder.reduce(function (acc, key) {
	    acc[key] = steps[key].cancel;
	    return acc;
	}, {});
	var flushSync = stepsOrder.reduce(function (acc, key) {
	    acc[key] = function () { return steps[key].process(frame); };
	    return acc;
	}, {});
	var processStep = function (stepId) { return steps[stepId].process(frame); };
	var processFrame = function (timestamp) {
	    runNextFrame = false;
	    frame.delta = useDefaultElapsed
	        ? defaultTimestep
	        : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
	    frame.timestamp = timestamp;
	    isProcessing = true;
	    stepsOrder.forEach(processStep);
	    isProcessing = false;
	    if (runNextFrame) {
	        useDefaultElapsed = false;
	        onNextFrame(processFrame);
	    }
	};
	var startLoop = function () {
	    runNextFrame = true;
	    useDefaultElapsed = true;
	    if (!isProcessing)
	        onNextFrame(processFrame);
	};
	var getFrameData = function () { return frame; };
	
	exports.cancelSync = cancelSync;
	exports.default = sync;
	exports.flushSync = flushSync;
	exports.getFrameData = getFrameData;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	exports.warning = function () { };
	exports.invariant = function () { };
	if (false) {
	    exports.warning = function (check, message) {
	        if (!check && typeof console !== 'undefined') {
	            console.warn(message);
	        }
	    };
	    exports.invariant = function (check, message) {
	        if (!check) {
	            throw new Error(message);
	        }
	    };
	}


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(219);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.IntlMessageFormat = void 0;
	var tslib_1 = __webpack_require__(114);
	var icu_messageformat_parser_1 = __webpack_require__(70);
	var fast_memoize_1 = (0, tslib_1.__importStar)(__webpack_require__(133));
	var formatters_1 = __webpack_require__(215);
	// -- MessageFormat --------------------------------------------------------
	function mergeConfig(c1, c2) {
	    if (!c2) {
	        return c1;
	    }
	    return (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
	        all[k] = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, c1[k]), (c2[k] || {}));
	        return all;
	    }, {}));
	}
	function mergeConfigs(defaultConfig, configs) {
	    if (!configs) {
	        return defaultConfig;
	    }
	    return Object.keys(defaultConfig).reduce(function (all, k) {
	        all[k] = mergeConfig(defaultConfig[k], configs[k]);
	        return all;
	    }, (0, tslib_1.__assign)({}, defaultConfig));
	}
	function createFastMemoizeCache(store) {
	    return {
	        create: function () {
	            return {
	                get: function (key) {
	                    return store[key];
	                },
	                set: function (key, value) {
	                    store[key] = value;
	                },
	            };
	        },
	    };
	}
	function createDefaultFormatters(cache) {
	    if (cache === void 0) { cache = {
	        number: {},
	        dateTime: {},
	        pluralRules: {},
	    }; }
	    return {
	        getNumberFormat: (0, fast_memoize_1.default)(function () {
	            var _a;
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	        }, {
	            cache: createFastMemoizeCache(cache.number),
	            strategy: fast_memoize_1.strategies.variadic,
	        }),
	        getDateTimeFormat: (0, fast_memoize_1.default)(function () {
	            var _a;
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	        }, {
	            cache: createFastMemoizeCache(cache.dateTime),
	            strategy: fast_memoize_1.strategies.variadic,
	        }),
	        getPluralRules: (0, fast_memoize_1.default)(function () {
	            var _a;
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, tslib_1.__spreadArray)([void 0], args, false)))();
	        }, {
	            cache: createFastMemoizeCache(cache.pluralRules),
	            strategy: fast_memoize_1.strategies.variadic,
	        }),
	    };
	}
	var IntlMessageFormat = /** @class */ (function () {
	    function IntlMessageFormat(message, locales, overrideFormats, opts) {
	        var _this = this;
	        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
	        this.formatterCache = {
	            number: {},
	            dateTime: {},
	            pluralRules: {},
	        };
	        this.format = function (values) {
	            var parts = _this.formatToParts(values);
	            // Hot path for straight simple msg translations
	            if (parts.length === 1) {
	                return parts[0].value;
	            }
	            var result = parts.reduce(function (all, part) {
	                if (!all.length ||
	                    part.type !== formatters_1.PART_TYPE.literal ||
	                    typeof all[all.length - 1] !== 'string') {
	                    all.push(part.value);
	                }
	                else {
	                    all[all.length - 1] += part.value;
	                }
	                return all;
	            }, []);
	            if (result.length <= 1) {
	                return result[0] || '';
	            }
	            return result;
	        };
	        this.formatToParts = function (values) {
	            return (0, formatters_1.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
	        };
	        this.resolvedOptions = function () { return ({
	            locale: _this.resolvedLocale.toString(),
	        }); };
	        this.getAst = function () { return _this.ast; };
	        // Defined first because it's used to build the format pattern.
	        this.locales = locales;
	        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
	        if (typeof message === 'string') {
	            this.message = message;
	            if (!IntlMessageFormat.__parse) {
	                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
	            }
	            // Parse string messages into an AST.
	            this.ast = IntlMessageFormat.__parse(message, {
	                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
	                locale: this.resolvedLocale,
	            });
	        }
	        else {
	            this.ast = message;
	        }
	        if (!Array.isArray(this.ast)) {
	            throw new TypeError('A message must be provided as a String or AST.');
	        }
	        // Creates a new object with the specified `formats` merged with the default
	        // formats.
	        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
	        this.formatters =
	            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
	    }
	    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
	        get: function () {
	            if (!IntlMessageFormat.memoizedDefaultLocale) {
	                IntlMessageFormat.memoizedDefaultLocale =
	                    new Intl.NumberFormat().resolvedOptions().locale;
	            }
	            return IntlMessageFormat.memoizedDefaultLocale;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    IntlMessageFormat.memoizedDefaultLocale = null;
	    IntlMessageFormat.resolveLocale = function (locales) {
	        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
	        if (supportedLocales.length > 0) {
	            return new Intl.Locale(supportedLocales[0]);
	        }
	        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
	    };
	    IntlMessageFormat.__parse = icu_messageformat_parser_1.parse;
	    // Default format options used as the prototype of the `formats` provided to the
	    // constructor. These are used when constructing the internal Intl.NumberFormat
	    // and Intl.DateTimeFormat instances.
	    IntlMessageFormat.formats = {
	        number: {
	            integer: {
	                maximumFractionDigits: 0,
	            },
	            currency: {
	                style: 'currency',
	            },
	            percent: {
	                style: 'percent',
	            },
	        },
	        date: {
	            short: {
	                month: 'numeric',
	                day: 'numeric',
	                year: '2-digit',
	            },
	            medium: {
	                month: 'short',
	                day: 'numeric',
	                year: 'numeric',
	            },
	            long: {
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric',
	            },
	            full: {
	                weekday: 'long',
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric',
	            },
	        },
	        time: {
	            short: {
	                hour: 'numeric',
	                minute: 'numeric',
	            },
	            medium: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	            },
	            long: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short',
	            },
	            full: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short',
	            },
	        },
	    };
	    return IntlMessageFormat;
	}());
	exports.IntlMessageFormat = IntlMessageFormat;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MissingValueError = exports.InvalidValueTypeError = exports.InvalidValueError = exports.FormatError = exports.ErrorCode = void 0;
	var tslib_1 = __webpack_require__(114);
	var ErrorCode;
	(function (ErrorCode) {
	    // When we have a placeholder but no value to format
	    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
	    // When value supplied is invalid
	    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
	    // When we need specific Intl API but it's not available
	    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
	})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
	var FormatError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(FormatError, _super);
	    function FormatError(msg, code, originalMessage) {
	        var _this = _super.call(this, msg) || this;
	        _this.code = code;
	        _this.originalMessage = originalMessage;
	        return _this;
	    }
	    FormatError.prototype.toString = function () {
	        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
	    };
	    return FormatError;
	}(Error));
	exports.FormatError = FormatError;
	var InvalidValueError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(InvalidValueError, _super);
	    function InvalidValueError(variableId, value, options, originalMessage) {
	        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
	    }
	    return InvalidValueError;
	}(FormatError));
	exports.InvalidValueError = InvalidValueError;
	var InvalidValueTypeError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(InvalidValueTypeError, _super);
	    function InvalidValueTypeError(value, type, originalMessage) {
	        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
	    }
	    return InvalidValueTypeError;
	}(FormatError));
	exports.InvalidValueTypeError = InvalidValueTypeError;
	var MissingValueError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(MissingValueError, _super);
	    function MissingValueError(variableId, originalMessage) {
	        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
	    }
	    return MissingValueError;
	}(FormatError));
	exports.MissingValueError = MissingValueError;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatToParts = exports.isFormatXMLElementFn = exports.PART_TYPE = void 0;
	var icu_messageformat_parser_1 = __webpack_require__(70);
	var error_1 = __webpack_require__(214);
	var PART_TYPE;
	(function (PART_TYPE) {
	    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
	    PART_TYPE[PART_TYPE["object"] = 1] = "object";
	})(PART_TYPE = exports.PART_TYPE || (exports.PART_TYPE = {}));
	function mergeLiteral(parts) {
	    if (parts.length < 2) {
	        return parts;
	    }
	    return parts.reduce(function (all, part) {
	        var lastPart = all[all.length - 1];
	        if (!lastPart ||
	            lastPart.type !== PART_TYPE.literal ||
	            part.type !== PART_TYPE.literal) {
	            all.push(part);
	        }
	        else {
	            lastPart.value += part.value;
	        }
	        return all;
	    }, []);
	}
	function isFormatXMLElementFn(el) {
	    return typeof el === 'function';
	}
	exports.isFormatXMLElementFn = isFormatXMLElementFn;
	// TODO(skeleton): add skeleton support
	function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
	// For debugging
	originalMessage) {
	    // Hot path for straight simple msg translations
	    if (els.length === 1 && (0, icu_messageformat_parser_1.isLiteralElement)(els[0])) {
	        return [
	            {
	                type: PART_TYPE.literal,
	                value: els[0].value,
	            },
	        ];
	    }
	    var result = [];
	    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	        var el = els_1[_i];
	        // Exit early for string parts.
	        if ((0, icu_messageformat_parser_1.isLiteralElement)(el)) {
	            result.push({
	                type: PART_TYPE.literal,
	                value: el.value,
	            });
	            continue;
	        }
	        // TODO: should this part be literal type?
	        // Replace `#` in plural rules with the actual numeric value.
	        if ((0, icu_messageformat_parser_1.isPoundElement)(el)) {
	            if (typeof currentPluralValue === 'number') {
	                result.push({
	                    type: PART_TYPE.literal,
	                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
	                });
	            }
	            continue;
	        }
	        var varName = el.value;
	        // Enforce that all required values are provided by the caller.
	        if (!(values && varName in values)) {
	            throw new error_1.MissingValueError(varName, originalMessage);
	        }
	        var value = values[varName];
	        if ((0, icu_messageformat_parser_1.isArgumentElement)(el)) {
	            if (!value || typeof value === 'string' || typeof value === 'number') {
	                value =
	                    typeof value === 'string' || typeof value === 'number'
	                        ? String(value)
	                        : '';
	            }
	            result.push({
	                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                value: value,
	            });
	            continue;
	        }
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if ((0, icu_messageformat_parser_1.isDateElement)(el)) {
	            var style = typeof el.style === 'string'
	                ? formats.date[el.style]
	                : (0, icu_messageformat_parser_1.isDateTimeSkeleton)(el.style)
	                    ? el.style.parsedOptions
	                    : undefined;
	            result.push({
	                type: PART_TYPE.literal,
	                value: formatters
	                    .getDateTimeFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if ((0, icu_messageformat_parser_1.isTimeElement)(el)) {
	            var style = typeof el.style === 'string'
	                ? formats.time[el.style]
	                : (0, icu_messageformat_parser_1.isDateTimeSkeleton)(el.style)
	                    ? el.style.parsedOptions
	                    : formats.time.medium;
	            result.push({
	                type: PART_TYPE.literal,
	                value: formatters
	                    .getDateTimeFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if ((0, icu_messageformat_parser_1.isNumberElement)(el)) {
	            var style = typeof el.style === 'string'
	                ? formats.number[el.style]
	                : (0, icu_messageformat_parser_1.isNumberSkeleton)(el.style)
	                    ? el.style.parsedOptions
	                    : undefined;
	            if (style && style.scale) {
	                value =
	                    value *
	                        (style.scale || 1);
	            }
	            result.push({
	                type: PART_TYPE.literal,
	                value: formatters
	                    .getNumberFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if ((0, icu_messageformat_parser_1.isTagElement)(el)) {
	            var children = el.children, value_1 = el.value;
	            var formatFn = values[value_1];
	            if (!isFormatXMLElementFn(formatFn)) {
	                throw new error_1.InvalidValueTypeError(value_1, 'function', originalMessage);
	            }
	            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
	            var chunks = formatFn(parts.map(function (p) { return p.value; }));
	            if (!Array.isArray(chunks)) {
	                chunks = [chunks];
	            }
	            result.push.apply(result, chunks.map(function (c) {
	                return {
	                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
	                    value: c,
	                };
	            }));
	        }
	        if ((0, icu_messageformat_parser_1.isSelectElement)(el)) {
	            var opt = el.options[value] || el.options.other;
	            if (!opt) {
	                throw new error_1.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	            }
	            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
	            continue;
	        }
	        if ((0, icu_messageformat_parser_1.isPluralElement)(el)) {
	            var opt = el.options["=".concat(value)];
	            if (!opt) {
	                if (!Intl.PluralRules) {
	                    throw new error_1.FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", error_1.ErrorCode.MISSING_INTL_API, originalMessage);
	                }
	                var rule = formatters
	                    .getPluralRules(locales, { type: el.pluralType })
	                    .select(value - (el.offset || 0));
	                opt = el.options[rule] || el.options.other;
	            }
	            if (!opt) {
	                throw new error_1.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
	            }
	            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
	            continue;
	        }
	    }
	    return mergeLiteral(result);
	}
	exports.formatToParts = formatToParts;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(311);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(677);
	} else {
	  module.exports = require('./lib/react-input-mask.development.js');
	}


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createFormattedComponent = exports.createFormattedDateTimePartsComponent = exports.FormattedListParts = exports.FormattedNumberParts = void 0;
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var useIntl_1 = (0, tslib_1.__importDefault)(__webpack_require__(45));
	var DisplayName;
	(function (DisplayName) {
	    DisplayName["formatDate"] = "FormattedDate";
	    DisplayName["formatTime"] = "FormattedTime";
	    DisplayName["formatNumber"] = "FormattedNumber";
	    DisplayName["formatList"] = "FormattedList";
	    // Note that this DisplayName is the locale display name, not to be confused with
	    // the name of the enum, which is for React component display name in dev tools.
	    DisplayName["formatDisplayName"] = "FormattedDisplayName";
	})(DisplayName || (DisplayName = {}));
	var DisplayNameParts;
	(function (DisplayNameParts) {
	    DisplayNameParts["formatDate"] = "FormattedDateParts";
	    DisplayNameParts["formatTime"] = "FormattedTimeParts";
	    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
	    DisplayNameParts["formatList"] = "FormattedListParts";
	})(DisplayNameParts || (DisplayNameParts = {}));
	var FormattedNumberParts = function (props) {
	    var intl = (0, useIntl_1.default)();
	    var value = props.value, children = props.children, formatProps = (0, tslib_1.__rest)(props, ["value", "children"]);
	    return children(intl.formatNumberToParts(value, formatProps));
	};
	exports.FormattedNumberParts = FormattedNumberParts;
	exports.FormattedNumberParts.displayName = 'FormattedNumberParts';
	var FormattedListParts = function (props) {
	    var intl = (0, useIntl_1.default)();
	    var value = props.value, children = props.children, formatProps = (0, tslib_1.__rest)(props, ["value", "children"]);
	    return children(intl.formatListToParts(value, formatProps));
	};
	exports.FormattedListParts = FormattedListParts;
	exports.FormattedNumberParts.displayName = 'FormattedNumberParts';
	function createFormattedDateTimePartsComponent(name) {
	    var ComponentParts = function (props) {
	        var intl = (0, useIntl_1.default)();
	        var value = props.value, children = props.children, formatProps = (0, tslib_1.__rest)(props, ["value", "children"]);
	        var date = typeof value === 'string' ? new Date(value || 0) : value;
	        var formattedParts = name === 'formatDate'
	            ? intl.formatDateToParts(date, formatProps)
	            : intl.formatTimeToParts(date, formatProps);
	        return children(formattedParts);
	    };
	    ComponentParts.displayName = DisplayNameParts[name];
	    return ComponentParts;
	}
	exports.createFormattedDateTimePartsComponent = createFormattedDateTimePartsComponent;
	function createFormattedComponent(name) {
	    var Component = function (props) {
	        var intl = (0, useIntl_1.default)();
	        var value = props.value, children = props.children, formatProps = (0, tslib_1.__rest)(props
	        // TODO: fix TS type definition for localeMatcher upstream
	        , ["value", "children"]);
	        // TODO: fix TS type definition for localeMatcher upstream
	        var formattedValue = intl[name](value, formatProps);
	        if (typeof children === 'function') {
	            return children(formattedValue);
	        }
	        var Text = intl.textComponent || React.Fragment;
	        return React.createElement(Text, null, formattedValue);
	    };
	    Component.displayName = DisplayName[name];
	    return Component;
	}
	exports.createFormattedComponent = createFormattedComponent;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(683);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 220 */
[718, 688],
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(689);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var React = __webpack_require__(1)
	var PropTypes = __webpack_require__(23)
	var Tag = __webpack_require__(694)
	var Input = __webpack_require__(692)
	var Suggestions = __webpack_require__(693)
	
	var KEYS = {
	  ENTER: 13,
	  TAB: 9,
	  BACKSPACE: 8,
	  UP_ARROW: 38,
	  DOWN_ARROW: 40
	}
	
	var CLASS_NAMES = {
	  root: 'react-tags',
	  rootFocused: 'is-focused',
	  selected: 'react-tags__selected',
	  selectedTag: 'react-tags__selected-tag',
	  selectedTagName: 'react-tags__selected-tag-name',
	  search: 'react-tags__search',
	  searchInput: 'react-tags__search-input',
	  suggestions: 'react-tags__suggestions',
	  suggestionActive: 'is-active',
	  suggestionDisabled: 'is-disabled'
	}
	
	var ReactTags = /*@__PURE__*/(function (superclass) {
	  function ReactTags (props) {
	    superclass.call(this, props)
	
	    this.state = {
	      query: '',
	      focused: false,
	      expandable: false,
	      selectedIndex: -1,
	      classNames: Object.assign({}, CLASS_NAMES, this.props.classNames)
	    }
	
	    this.inputEventHandlers = {
	      // Provide a no-op function to the input component to avoid warnings
	      // <https://github.com/i-like-robots/react-tags/issues/135>
	      // <https://github.com/facebook/react/issues/13835>
	      onChange: function () { },
	      onBlur: this.handleBlur.bind(this),
	      onFocus: this.handleFocus.bind(this),
	      onInput: this.handleInput.bind(this),
	      onKeyDown: this.handleKeyDown.bind(this)
	    }
	
	    this.container = React.createRef()
	  }
	
	  if ( superclass ) ReactTags.__proto__ = superclass;
	  ReactTags.prototype = Object.create( superclass && superclass.prototype );
	  ReactTags.prototype.constructor = ReactTags;
	
	  ReactTags.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
	    this.setState({
	      classNames: Object.assign({}, CLASS_NAMES, newProps.classNames)
	    })
	  };
	
	  ReactTags.prototype.handleInput = function handleInput (e) {
	    var query = e.target.value
	
	    if (this.props.handleInputChange) {
	      this.props.handleInputChange(query)
	    }
	
	    this.setState({ query: query })
	  };
	
	  ReactTags.prototype.handleKeyDown = function handleKeyDown (e) {
	    var ref = this.state;
	    var query = ref.query;
	    var selectedIndex = ref.selectedIndex;
	    var ref$1 = this.props;
	    var delimiters = ref$1.delimiters;
	    var delimiterChars = ref$1.delimiterChars;
	
	    // when one of the terminating keys is pressed, add current query to the tags.
	    if (delimiters.indexOf(e.keyCode) > -1 || delimiterChars.indexOf(e.key) > -1) {
	      if (query || selectedIndex > -1) {
	        e.preventDefault()
	      }
	
	      this.handleDelimiter()
	    }
	
	    // when backspace key is pressed and query is blank, delete the last tag
	    if (e.keyCode === KEYS.BACKSPACE && query.length === 0 && this.props.allowBackspace) {
	      this.deleteTag(this.props.tags.length - 1)
	    }
	
	    if (e.keyCode === KEYS.UP_ARROW) {
	      e.preventDefault()
	
	      // if last item, cycle to the bottom
	      if (selectedIndex <= 0) {
	        this.setState({ selectedIndex: this.suggestions.state.options.length - 1 })
	      } else {
	        this.setState({ selectedIndex: selectedIndex - 1 })
	      }
	    }
	
	    if (e.keyCode === KEYS.DOWN_ARROW) {
	      e.preventDefault()
	
	      this.setState({ selectedIndex: (selectedIndex + 1) % this.suggestions.state.options.length })
	    }
	  };
	
	  ReactTags.prototype.handleDelimiter = function handleDelimiter () {
	    var ref = this.state;
	    var query = ref.query;
	    var selectedIndex = ref.selectedIndex;
	
	    if (query.length >= this.props.minQueryLength) {
	      // Check if the user typed in an existing suggestion.
	      var match = this.suggestions.state.options.findIndex(function (suggestion) {
	        return suggestion.name.search(new RegExp(("^" + query + "$"), 'i')) === 0
	      })
	
	      var index = selectedIndex === -1 ? match : selectedIndex
	
	      if (index > -1 && this.suggestions.state.options[index]) {
	        this.addTag(this.suggestions.state.options[index])
	      } else if (this.props.allowNew) {
	        this.addTag({ name: query })
	      }
	    }
	  };
	
	  ReactTags.prototype.handleClick = function handleClick (e) {
	    if (document.activeElement !== e.target) {
	      this.input.input.focus()
	    }
	  };
	
	  ReactTags.prototype.handleBlur = function handleBlur () {
	    this.setState({ focused: false, selectedIndex: -1 })
	
	    if (this.props.handleBlur) {
	      this.props.handleBlur()
	    }
	
	    if (this.props.addOnBlur) {
	      this.handleDelimiter()
	    }
	  };
	
	  ReactTags.prototype.handleFocus = function handleFocus () {
	    this.setState({ focused: true })
	
	    if (this.props.handleFocus) {
	      this.props.handleFocus()
	    }
	  };
	
	  ReactTags.prototype.handleDeleteTag = function handleDeleteTag (index, event) {
	    // Because we'll destroy the element with cursor focus we need to ensure
	    // it does not get lost and move it to the next interactive element
	    if (this.container.current) {
	      var interactiveEls = this.container.current.querySelectorAll('a,button,input')
	
	      var currentEl = Array.prototype.findIndex.call(interactiveEls, function (element) {
	        return element === event.currentTarget
	      })
	
	      var nextEl = interactiveEls[currentEl - 1] || interactiveEls[currentEl + 1]
	
	      if (nextEl) {
	        nextEl.focus()
	      }
	    }
	
	    this.deleteTag(index)
	  };
	
	  ReactTags.prototype.addTag = function addTag (tag) {
	    if (tag.disabled) {
	      return
	    }
	
	    if (typeof this.props.handleValidate === 'function' && !this.props.handleValidate(tag)) {
	      return
	    }
	
	    this.props.handleAddition(tag)
	
	    // reset the state
	    this.setState({
	      query: '',
	      selectedIndex: -1
	    })
	  };
	
	  ReactTags.prototype.deleteTag = function deleteTag (i) {
	    this.props.handleDelete(i)
	
	    if (this.props.clearInputOnDelete && this.state.query !== '') {
	      this.setState({ query: '' })
	    }
	  };
	
	  ReactTags.prototype.render = function render () {
	    var this$1 = this;
	
	    var listboxId = 'ReactTags-listbox'
	
	    var TagComponent = this.props.tagComponent || Tag
	
	    var tags = this.props.tags.map(function (tag, i) { return (
	      React.createElement( TagComponent, {
	        key: i, tag: tag, classNames: this$1.state.classNames, onDelete: this$1.handleDeleteTag.bind(this$1, i) })
	    ); })
	
	    var expandable = this.state.focused && this.state.query.length >= this.props.minQueryLength
	    var classNames = [this.state.classNames.root]
	
	    this.state.focused && classNames.push(this.state.classNames.rootFocused)
	
	    return (
	      React.createElement( 'div', { ref: this.container, className: classNames.join(' '), onClick: this.handleClick.bind(this) },
	        React.createElement( 'div', { className: this.state.classNames.selected, 'aria-live': 'polite', 'aria-relevant': 'additions removals' },
	          tags
	        ),
	        React.createElement( 'div', { className: this.state.classNames.search },
	          React.createElement( Input, Object.assign({},
	            this.state, { inputAttributes: this.props.inputAttributes, inputEventHandlers: this.inputEventHandlers, ref: function (c) { this$1.input = c }, listboxId: listboxId, autofocus: this.props.autofocus, autoresize: this.props.autoresize, expandable: expandable, placeholder: this.props.placeholder, ariaLabel: this.props.ariaLabel })),
	          React.createElement( Suggestions, Object.assign({},
	            this.state, { ref: function (c) { this$1.suggestions = c }, listboxId: listboxId, expandable: expandable, noSuggestionsText: this.props.noSuggestionsText, suggestions: this.props.suggestions, suggestionsFilter: this.props.suggestionsFilter, addTag: this.addTag.bind(this), maxSuggestionsLength: this.props.maxSuggestionsLength }))
	        )
	      )
	    )
	  };
	
	  return ReactTags;
	}(React.Component));
	
	ReactTags.defaultProps = {
	  tags: [],
	  placeholder: 'Add new tag',
	  noSuggestionsText: null,
	  suggestions: [],
	  suggestionsFilter: null,
	  autofocus: true,
	  autoresize: true,
	  delimiters: [KEYS.TAB, KEYS.ENTER],
	  delimiterChars: [],
	  minQueryLength: 2,
	  maxSuggestionsLength: 6,
	  allowNew: false,
	  allowBackspace: true,
	  tagComponent: null,
	  inputAttributes: {},
	  addOnBlur: false,
	  clearInputOnDelete: true
	}
	
	ReactTags.propTypes = {
	  tags: PropTypes.arrayOf(PropTypes.object),
	  placeholder: PropTypes.string,
	  ariaLabel: PropTypes.string,
	  noSuggestionsText: PropTypes.string,
	  suggestions: PropTypes.arrayOf(PropTypes.object),
	  suggestionsFilter: PropTypes.func,
	  autofocus: PropTypes.bool,
	  autoresize: PropTypes.bool,
	  delimiters: PropTypes.arrayOf(PropTypes.number),
	  delimiterChars: PropTypes.arrayOf(PropTypes.string),
	  handleDelete: PropTypes.func.isRequired,
	  handleAddition: PropTypes.func.isRequired,
	  handleInputChange: PropTypes.func,
	  handleFocus: PropTypes.func,
	  handleBlur: PropTypes.func,
	  handleValidate: PropTypes.func,
	  minQueryLength: PropTypes.number,
	  maxSuggestionsLength: PropTypes.number,
	  classNames: PropTypes.object,
	  allowNew: PropTypes.bool,
	  allowBackspace: PropTypes.bool,
	  tagComponent: PropTypes.oneOfType([
	    PropTypes.func,
	    PropTypes.element
	  ]),
	  inputAttributes: PropTypes.object,
	  addOnBlur: PropTypes.bool,
	  clearInputOnDelete: PropTypes.bool
	}
	
	module.exports = ReactTags


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(697);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(700);
	
	var clamp = function (min, max) { return function (v) {
	    return Math.max(Math.min(v, max), min);
	}; };
	var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };
	var floatRegex = /(-)?([\d]*\.?[\d])+/g;
	var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
	var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
	function isString(v) {
	    return typeof v === 'string';
	}
	
	var number = {
	    test: function (v) { return typeof v === 'number'; },
	    parse: parseFloat,
	    transform: function (v) { return v; },
	};
	var alpha = tslib.__assign(tslib.__assign({}, number), { transform: clamp(0, 1) });
	var scale = tslib.__assign(tslib.__assign({}, number), { default: 1 });
	
	var createUnitType = function (unit) { return ({
	    test: function (v) {
	        return isString(v) && v.endsWith(unit) && v.split(' ').length === 1;
	    },
	    parse: parseFloat,
	    transform: function (v) { return "" + v + unit; },
	}); };
	var degrees = createUnitType('deg');
	var percent = createUnitType('%');
	var px = createUnitType('px');
	var vh = createUnitType('vh');
	var vw = createUnitType('vw');
	var progressPercentage = tslib.__assign(tslib.__assign({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });
	
	var isColorString = function (type, testProp) { return function (v) {
	    return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
	        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
	}; };
	var splitColor = function (aName, bName, cName) { return function (v) {
	    var _a;
	    if (!isString(v))
	        return v;
	    var _b = v.match(floatRegex), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
	    return _a = {},
	        _a[aName] = parseFloat(a),
	        _a[bName] = parseFloat(b),
	        _a[cName] = parseFloat(c),
	        _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1,
	        _a;
	}; };
	
	var hsla = {
	    test: isColorString('hsl', 'hue'),
	    parse: splitColor('hue', 'saturation', 'lightness'),
	    transform: function (_a) {
	        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
	        return ('hsla(' +
	            Math.round(hue) +
	            ', ' +
	            percent.transform(sanitize(saturation)) +
	            ', ' +
	            percent.transform(sanitize(lightness)) +
	            ', ' +
	            sanitize(alpha.transform(alpha$1)) +
	            ')');
	    },
	};
	
	var clampRgbUnit = clamp(0, 255);
	var rgbUnit = tslib.__assign(tslib.__assign({}, number), { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
	var rgba = {
	    test: isColorString('rgb', 'red'),
	    parse: splitColor('red', 'green', 'blue'),
	    transform: function (_a) {
	        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
	        return 'rgba(' +
	            rgbUnit.transform(red) +
	            ', ' +
	            rgbUnit.transform(green) +
	            ', ' +
	            rgbUnit.transform(blue) +
	            ', ' +
	            sanitize(alpha.transform(alpha$1)) +
	            ')';
	    },
	};
	
	function parseHex(v) {
	    var r = '';
	    var g = '';
	    var b = '';
	    var a = '';
	    if (v.length > 5) {
	        r = v.substr(1, 2);
	        g = v.substr(3, 2);
	        b = v.substr(5, 2);
	        a = v.substr(7, 2);
	    }
	    else {
	        r = v.substr(1, 1);
	        g = v.substr(2, 1);
	        b = v.substr(3, 1);
	        a = v.substr(4, 1);
	        r += r;
	        g += g;
	        b += b;
	        a += a;
	    }
	    return {
	        red: parseInt(r, 16),
	        green: parseInt(g, 16),
	        blue: parseInt(b, 16),
	        alpha: a ? parseInt(a, 16) / 255 : 1,
	    };
	}
	var hex = {
	    test: isColorString('#'),
	    parse: parseHex,
	    transform: rgba.transform,
	};
	
	var color = {
	    test: function (v) { return rgba.test(v) || hex.test(v) || hsla.test(v); },
	    parse: function (v) {
	        if (rgba.test(v)) {
	            return rgba.parse(v);
	        }
	        else if (hsla.test(v)) {
	            return hsla.parse(v);
	        }
	        else {
	            return hex.parse(v);
	        }
	    },
	    transform: function (v) {
	        return isString(v)
	            ? v
	            : v.hasOwnProperty('red')
	                ? rgba.transform(v)
	                : hsla.transform(v);
	    },
	};
	
	var colorToken = '${c}';
	var numberToken = '${n}';
	function test(v) {
	    var _a, _b, _c, _d;
	    return (isNaN(v) &&
	        isString(v) &&
	        ((_b = (_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0);
	}
	function analyse(v) {
	    var values = [];
	    var numColors = 0;
	    var colors = v.match(colorRegex);
	    if (colors) {
	        numColors = colors.length;
	        v = v.replace(colorRegex, colorToken);
	        values.push.apply(values, colors.map(color.parse));
	    }
	    var numbers = v.match(floatRegex);
	    if (numbers) {
	        v = v.replace(floatRegex, numberToken);
	        values.push.apply(values, numbers.map(number.parse));
	    }
	    return { values: values, numColors: numColors, tokenised: v };
	}
	function parse(v) {
	    return analyse(v).values;
	}
	function createTransformer(v) {
	    var _a = analyse(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
	    var numValues = values.length;
	    return function (v) {
	        var output = tokenised;
	        for (var i = 0; i < numValues; i++) {
	            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
	        }
	        return output;
	    };
	}
	var convertNumbersToZero = function (v) {
	    return typeof v === 'number' ? 0 : v;
	};
	function getAnimatableNone(v) {
	    var parsed = parse(v);
	    var transformer = createTransformer(v);
	    return transformer(parsed.map(convertNumbersToZero));
	}
	var complex = { test: test, parse: parse, createTransformer: createTransformer, getAnimatableNone: getAnimatableNone };
	
	var maxDefaults = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
	function applyDefaultFilter(v) {
	    var _a = v.slice(0, -1).split('('), name = _a[0], value = _a[1];
	    if (name === 'drop-shadow')
	        return v;
	    var number = (value.match(floatRegex) || [])[0];
	    if (!number)
	        return v;
	    var unit = value.replace(number, '');
	    var defaultValue = maxDefaults.has(name) ? 1 : 0;
	    if (number !== value)
	        defaultValue *= 100;
	    return name + '(' + defaultValue + unit + ')';
	}
	var functionRegex = /([a-z-]*)\(.*?\)/g;
	var filter = tslib.__assign(tslib.__assign({}, complex), { getAnimatableNone: function (v) {
	        var functions = v.match(functionRegex);
	        return functions ? functions.map(applyDefaultFilter).join(' ') : v;
	    } });
	
	exports.alpha = alpha;
	exports.color = color;
	exports.complex = complex;
	exports.degrees = degrees;
	exports.filter = filter;
	exports.hex = hex;
	exports.hsla = hsla;
	exports.number = number;
	exports.percent = percent;
	exports.progressPercentage = progressPercentage;
	exports.px = px;
	exports.rgbUnit = rgbUnit;
	exports.rgba = rgba;
	exports.scale = scale;
	exports.vh = vh;
	exports.vw = vw;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(714);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 226 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(672).enable();
	  window.Promise = __webpack_require__(671);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(715);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(116);
	
	// Polyfill localStorage/sessionStorage for node test environment
	if (typeof localStorage === 'undefined') {
	  var _storage = {};
	  global.localStorage = {
	    getItem: function(key) { return _storage.hasOwnProperty(key) ? _storage[key] : null; },
	    setItem: function(key, value) { _storage[key] = String(value); },
	    removeItem: function(key) { delete _storage[key]; },
	    clear: function() { _storage = {}; },
	  };
	}
	if (typeof sessionStorage === 'undefined') {
	  var _sessionStore = {};
	  global.sessionStorage = {
	    getItem: function(key) { return _sessionStore.hasOwnProperty(key) ? _sessionStore[key] : null; },
	    setItem: function(key, value) { _sessionStore[key] = String(value); },
	    removeItem: function(key) { delete _sessionStore[key]; },
	    clear: function() { _sessionStore = {}; },
	  };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(229));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports.default = index;


/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ },
/* 230 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CanonicalizeTimeZoneName = void 0;
	/**
	 * https://tc39.es/ecma402/#sec-canonicalizetimezonename
	 * @param tz
	 */
	function CanonicalizeTimeZoneName(tz, _a) {
	    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
	    var uppercasedTz = tz.toUpperCase();
	    var uppercasedZones = Object.keys(tzData).reduce(function (all, z) {
	        all[z.toUpperCase()] = z;
	        return all;
	    }, {});
	    var ianaTimeZone = uppercaseLinks[uppercasedTz] || uppercasedZones[uppercasedTz];
	    if (ianaTimeZone === 'Etc/UTC' || ianaTimeZone === 'Etc/GMT') {
	        return 'UTC';
	    }
	    return ianaTimeZone;
	}
	exports.CanonicalizeTimeZoneName = CanonicalizeTimeZoneName;


/***/ },
/* 231 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GetOptionsObject = void 0;
	/**
	 * https://tc39.es/ecma402/#sec-getoptionsobject
	 * @param options
	 * @returns
	 */
	function GetOptionsObject(options) {
	    if (typeof options === 'undefined') {
	        return Object.create(null);
	    }
	    if (typeof options === 'object') {
	        return options;
	    }
	    throw new TypeError('Options must be an object');
	}
	exports.GetOptionsObject = GetOptionsObject;


/***/ },
/* 232 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.IsValidTimeZoneName = void 0;
	/**
	 * https://tc39.es/ecma402/#sec-isvalidtimezonename
	 * @param tz
	 * @param implDetails implementation details
	 */
	function IsValidTimeZoneName(tz, _a) {
	    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
	    var uppercasedTz = tz.toUpperCase();
	    var zoneNames = new Set();
	    var linkNames = new Set();
	    Object.keys(tzData)
	        .map(function (z) { return z.toUpperCase(); })
	        .forEach(function (z) { return zoneNames.add(z); });
	    Object.keys(uppercaseLinks).forEach(function (linkName) {
	        linkNames.add(linkName.toUpperCase());
	        zoneNames.add(uppercaseLinks[linkName].toUpperCase());
	    });
	    return zoneNames.has(uppercasedTz) || linkNames.has(uppercasedTz);
	}
	exports.IsValidTimeZoneName = IsValidTimeZoneName;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FormatNumericToParts = void 0;
	var PartitionNumberPattern_1 = __webpack_require__(128);
	var _262_1 = __webpack_require__(31);
	function FormatNumericToParts(nf, x, implDetails) {
	    var parts = (0, PartitionNumberPattern_1.PartitionNumberPattern)(nf, x, implDetails);
	    var result = (0, _262_1.ArrayCreate)(0);
	    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
	        var part = parts_1[_i];
	        result.push({
	            type: part.type,
	            value: part.value,
	        });
	    }
	    return result;
	}
	exports.FormatNumericToParts = FormatNumericToParts;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.InitializeNumberFormat = void 0;
	var CanonicalizeLocaleList_1 = __webpack_require__(118);
	var GetOption_1 = __webpack_require__(54);
	var intl_localematcher_1 = __webpack_require__(138);
	var SetNumberFormatUnitOptions_1 = __webpack_require__(130);
	var CurrencyDigits_1 = __webpack_require__(127);
	var SetNumberFormatDigitOptions_1 = __webpack_require__(129);
	var utils_1 = __webpack_require__(32);
	var CoerceOptionsToObject_1 = __webpack_require__(119);
	/**
	 * https://tc39.es/ecma402/#sec-initializenumberformat
	 */
	function InitializeNumberFormat(nf, locales, opts, _a) {
	    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, availableLocales = _a.availableLocales, numberingSystemNames = _a.numberingSystemNames, getDefaultLocale = _a.getDefaultLocale, currencyDigitsData = _a.currencyDigitsData;
	    // @ts-ignore
	    var requestedLocales = (0, CanonicalizeLocaleList_1.CanonicalizeLocaleList)(locales);
	    var options = (0, CoerceOptionsToObject_1.CoerceOptionsToObject)(opts);
	    var opt = Object.create(null);
	    var matcher = (0, GetOption_1.GetOption)(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
	    opt.localeMatcher = matcher;
	    var numberingSystem = (0, GetOption_1.GetOption)(options, 'numberingSystem', 'string', undefined, undefined);
	    if (numberingSystem !== undefined &&
	        numberingSystemNames.indexOf(numberingSystem) < 0) {
	        // 8.a. If numberingSystem does not match the Unicode Locale Identifier type nonterminal,
	        // throw a RangeError exception.
	        throw RangeError("Invalid numberingSystems: ".concat(numberingSystem));
	    }
	    opt.nu = numberingSystem;
	    var r = (0, intl_localematcher_1.ResolveLocale)(availableLocales, requestedLocales, opt, 
	    // [[RelevantExtensionKeys]] slot, which is a constant
	    ['nu'], localeData, getDefaultLocale);
	    var dataLocaleData = localeData[r.dataLocale];
	    (0, utils_1.invariant)(!!dataLocaleData, "Missing locale data for ".concat(r.dataLocale));
	    var internalSlots = getInternalSlots(nf);
	    internalSlots.locale = r.locale;
	    internalSlots.dataLocale = r.dataLocale;
	    internalSlots.numberingSystem = r.nu;
	    internalSlots.dataLocaleData = dataLocaleData;
	    (0, SetNumberFormatUnitOptions_1.SetNumberFormatUnitOptions)(nf, options, { getInternalSlots: getInternalSlots });
	    var style = internalSlots.style;
	    var mnfdDefault;
	    var mxfdDefault;
	    if (style === 'currency') {
	        var currency = internalSlots.currency;
	        var cDigits = (0, CurrencyDigits_1.CurrencyDigits)(currency, { currencyDigitsData: currencyDigitsData });
	        mnfdDefault = cDigits;
	        mxfdDefault = cDigits;
	    }
	    else {
	        mnfdDefault = 0;
	        mxfdDefault = style === 'percent' ? 0 : 3;
	    }
	    var notation = (0, GetOption_1.GetOption)(options, 'notation', 'string', ['standard', 'scientific', 'engineering', 'compact'], 'standard');
	    internalSlots.notation = notation;
	    (0, SetNumberFormatDigitOptions_1.SetNumberFormatDigitOptions)(internalSlots, options, mnfdDefault, mxfdDefault, notation);
	    var compactDisplay = (0, GetOption_1.GetOption)(options, 'compactDisplay', 'string', ['short', 'long'], 'short');
	    if (notation === 'compact') {
	        internalSlots.compactDisplay = compactDisplay;
	    }
	    var useGrouping = (0, GetOption_1.GetOption)(options, 'useGrouping', 'boolean', undefined, true);
	    internalSlots.useGrouping = useGrouping;
	    var signDisplay = (0, GetOption_1.GetOption)(options, 'signDisplay', 'string', ['auto', 'never', 'always', 'exceptZero'], 'auto');
	    internalSlots.signDisplay = signDisplay;
	    return nf;
	}
	exports.InitializeNumberFormat = InitializeNumberFormat;


/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.digitMapping = void 0;
	exports.digitMapping = { "adlm": ["𞥐", "𞥑", "𞥒", "𞥓", "𞥔", "𞥕", "𞥖", "𞥗", "𞥘", "𞥙"], "ahom": ["𑜰", "𑜱", "𑜲", "𑜳", "𑜴", "𑜵", "𑜶", "𑜷", "𑜸", "𑜹"], "arab": ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"], "arabext": ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"], "bali": ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"], "beng": ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"], "bhks": ["𑱐", "𑱑", "𑱒", "𑱓", "𑱔", "𑱕", "𑱖", "𑱗", "𑱘", "𑱙"], "brah": ["𑁦", "𑁧", "𑁨", "𑁩", "𑁪", "𑁫", "𑁬", "𑁭", "𑁮", "𑁯"], "cakm": ["𑄶", "𑄷", "𑄸", "𑄹", "𑄺", "𑄻", "𑄼", "𑄽", "𑄾", "𑄿"], "cham": ["꩐", "꩑", "꩒", "꩓", "꩔", "꩕", "꩖", "꩗", "꩘", "꩙"], "deva": ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"], "diak": ["𑥐", "𑥑", "𑥒", "𑥓", "𑥔", "𑥕", "𑥖", "𑥗", "𑥘", "𑥙"], "fullwide": ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"], "gong": ["𑶠", "𑶡", "𑶢", "𑶣", "𑶤", "𑶥", "𑶦", "𑶧", "𑶨", "𑶩"], "gonm": ["𑵐", "𑵑", "𑵒", "𑵓", "𑵔", "𑵕", "𑵖", "𑵗", "𑵘", "𑵙"], "gujr": ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"], "guru": ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"], "hanidec": ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"], "hmng": ["𖭐", "𖭑", "𖭒", "𖭓", "𖭔", "𖭕", "𖭖", "𖭗", "𖭘", "𖭙"], "hmnp": ["𞅀", "𞅁", "𞅂", "𞅃", "𞅄", "𞅅", "𞅆", "𞅇", "𞅈", "𞅉"], "java": ["꧐", "꧑", "꧒", "꧓", "꧔", "꧕", "꧖", "꧗", "꧘", "꧙"], "kali": ["꤀", "꤁", "꤂", "꤃", "꤄", "꤅", "꤆", "꤇", "꤈", "꤉"], "khmr": ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"], "knda": ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"], "lana": ["᪀", "᪁", "᪂", "᪃", "᪄", "᪅", "᪆", "᪇", "᪈", "᪉"], "lanatham": ["᪐", "᪑", "᪒", "᪓", "᪔", "᪕", "᪖", "᪗", "᪘", "᪙"], "laoo": ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"], "lepc": ["᪐", "᪑", "᪒", "᪓", "᪔", "᪕", "᪖", "᪗", "᪘", "᪙"], "limb": ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"], "mathbold": ["𝟎", "𝟏", "𝟐", "𝟑", "𝟒", "𝟓", "𝟔", "𝟕", "𝟖", "𝟗"], "mathdbl": ["𝟘", "𝟙", "𝟚", "𝟛", "𝟜", "𝟝", "𝟞", "𝟟", "𝟠", "𝟡"], "mathmono": ["𝟶", "𝟷", "𝟸", "𝟹", "𝟺", "𝟻", "𝟼", "𝟽", "𝟾", "𝟿"], "mathsanb": ["𝟬", "𝟭", "𝟮", "𝟯", "𝟰", "𝟱", "𝟲", "𝟳", "𝟴", "𝟵"], "mathsans": ["𝟢", "𝟣", "𝟤", "𝟥", "𝟦", "𝟧", "𝟨", "𝟩", "𝟪", "𝟫"], "mlym": ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"], "modi": ["𑙐", "𑙑", "𑙒", "𑙓", "𑙔", "𑙕", "𑙖", "𑙗", "𑙘", "𑙙"], "mong": ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"], "mroo": ["𖩠", "𖩡", "𖩢", "𖩣", "𖩤", "𖩥", "𖩦", "𖩧", "𖩨", "𖩩"], "mtei": ["꯰", "꯱", "꯲", "꯳", "꯴", "꯵", "꯶", "꯷", "꯸", "꯹"], "mymr": ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"], "mymrshan": ["႐", "႑", "႒", "႓", "႔", "႕", "႖", "႗", "႘", "႙"], "mymrtlng": ["꧰", "꧱", "꧲", "꧳", "꧴", "꧵", "꧶", "꧷", "꧸", "꧹"], "newa": ["𑑐", "𑑑", "𑑒", "𑑓", "𑑔", "𑑕", "𑑖", "𑑗", "𑑘", "𑑙"], "nkoo": ["߀", "߁", "߂", "߃", "߄", "߅", "߆", "߇", "߈", "߉"], "olck": ["᱐", "᱑", "᱒", "᱓", "᱔", "᱕", "᱖", "᱗", "᱘", "᱙"], "orya": ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"], "osma": ["𐒠", "𐒡", "𐒢", "𐒣", "𐒤", "𐒥", "𐒦", "𐒧", "𐒨", "𐒩"], "rohg": ["𐴰", "𐴱", "𐴲", "𐴳", "𐴴", "𐴵", "𐴶", "𐴷", "𐴸", "𐴹"], "saur": ["꣐", "꣑", "꣒", "꣓", "꣔", "꣕", "꣖", "꣗", "꣘", "꣙"], "segment": ["🯰", "🯱", "🯲", "🯳", "🯴", "🯵", "🯶", "🯷", "🯸", "🯹"], "shrd": ["𑇐", "𑇑", "𑇒", "𑇓", "𑇔", "𑇕", "𑇖", "𑇗", "𑇘", "𑇙"], "sind": ["𑋰", "𑋱", "𑋲", "𑋳", "𑋴", "𑋵", "𑋶", "𑋷", "𑋸", "𑋹"], "sinh": ["෦", "෧", "෨", "෩", "෪", "෫", "෬", "෭", "෮", "෯"], "sora": ["𑃰", "𑃱", "𑃲", "𑃳", "𑃴", "𑃵", "𑃶", "𑃷", "𑃸", "𑃹"], "sund": ["᮰", "᮱", "᮲", "᮳", "᮴", "᮵", "᮶", "᮷", "᮸", "᮹"], "takr": ["𑛀", "𑛁", "𑛂", "𑛃", "𑛄", "𑛅", "𑛆", "𑛇", "𑛈", "𑛉"], "talu": ["᧐", "᧑", "᧒", "᧓", "᧔", "᧕", "᧖", "᧗", "᧘", "᧙"], "tamldec": ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"], "telu": ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"], "thai": ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"], "tibt": ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"], "tirh": ["𑓐", "𑓑", "𑓒", "𑓓", "𑓔", "𑓕", "𑓖", "𑓗", "𑓘", "𑓙"], "vaii": ["ᘠ", "ᘡ", "ᘢ", "ᘣ", "ᘤ", "ᘥ", "ᘦ", "ᘧ", "ᘨ", "ᘩ"], "wara": ["𑣠", "𑣡", "𑣢", "𑣣", "𑣤", "𑣥", "𑣦", "𑣧", "𑣨", "𑣩"], "wcho": ["𞋰", "𞋱", "𞋲", "𞋳", "𞋴", "𞋵", "𞋶", "𞋷", "𞋸", "𞋹"] };


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PartitionPattern = void 0;
	var utils_1 = __webpack_require__(32);
	/**
	 * https://tc39.es/ecma402/#sec-partitionpattern
	 * @param pattern
	 */
	function PartitionPattern(pattern) {
	    var result = [];
	    var beginIndex = pattern.indexOf('{');
	    var endIndex = 0;
	    var nextIndex = 0;
	    var length = pattern.length;
	    while (beginIndex < pattern.length && beginIndex > -1) {
	        endIndex = pattern.indexOf('}', beginIndex);
	        (0, utils_1.invariant)(endIndex > beginIndex, "Invalid pattern ".concat(pattern));
	        if (beginIndex > nextIndex) {
	            result.push({
	                type: 'literal',
	                value: pattern.substring(nextIndex, beginIndex),
	            });
	        }
	        result.push({
	            type: pattern.substring(beginIndex + 1, endIndex),
	            value: undefined,
	        });
	        nextIndex = endIndex + 1;
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    if (nextIndex < length) {
	        result.push({
	            type: 'literal',
	            value: pattern.substring(nextIndex, length),
	        });
	    }
	    return result;
	}
	exports.PartitionPattern = PartitionPattern;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SupportedLocales = void 0;
	var _262_1 = __webpack_require__(31);
	var GetOption_1 = __webpack_require__(54);
	var intl_localematcher_1 = __webpack_require__(138);
	/**
	 * https://tc39.es/ecma402/#sec-supportedlocales
	 * @param availableLocales
	 * @param requestedLocales
	 * @param options
	 */
	function SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = 'best fit';
	    if (options !== undefined) {
	        options = (0, _262_1.ToObject)(options);
	        matcher = (0, GetOption_1.GetOption)(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
	    }
	    if (matcher === 'best fit') {
	        return (0, intl_localematcher_1.LookupSupportedLocales)(availableLocales, requestedLocales);
	    }
	    return (0, intl_localematcher_1.LookupSupportedLocales)(availableLocales, requestedLocales);
	}
	exports.SupportedLocales = SupportedLocales;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isMissingLocaleDataError = void 0;
	var tslib_1 = __webpack_require__(69);
	var MissingLocaleDataError = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(MissingLocaleDataError, _super);
	    function MissingLocaleDataError() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = 'MISSING_LOCALE_DATA';
	        return _this;
	    }
	    return MissingLocaleDataError;
	}(Error));
	function isMissingLocaleDataError(e) {
	    return e.type === 'MISSING_LOCALE_DATA';
	}
	exports.isMissingLocaleDataError = isMissingLocaleDataError;


/***/ },
/* 239 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.S_UNICODE_REGEX = void 0;
	// @generated from regex-gen.ts
	exports.S_UNICODE_REGEX = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/;


/***/ },
/* 240 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.RangePatternType = void 0;
	var RangePatternType;
	(function (RangePatternType) {
	    RangePatternType["startRange"] = "startRange";
	    RangePatternType["shared"] = "shared";
	    RangePatternType["endRange"] = "endRange";
	})(RangePatternType = exports.RangePatternType || (exports.RangePatternType = {}));


/***/ },
/* 241 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });


/***/ },
/* 242 */
241,
/* 243 */
241,
/* 244 */
241,
/* 245 */
241,
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getBestPattern = void 0;
	var time_data_generated_1 = __webpack_require__(249);
	/**
	 * Returns the best matching date time pattern if a date time skeleton
	 * pattern is provided with a locale. Follows the Unicode specification:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
	 * @param skeleton date time skeleton pattern that possibly includes j, J or C
	 * @param locale
	 */
	function getBestPattern(skeleton, locale) {
	    var skeletonCopy = '';
	    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
	        var patternChar = skeleton.charAt(patternPos);
	        if (patternChar === 'j') {
	            var extraLength = 0;
	            while (patternPos + 1 < skeleton.length &&
	                skeleton.charAt(patternPos + 1) === patternChar) {
	                extraLength++;
	                patternPos++;
	            }
	            var hourLen = 1 + (extraLength & 1);
	            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
	            var dayPeriodChar = 'a';
	            var hourChar = getDefaultHourSymbolFromLocale(locale);
	            if (hourChar == 'H' || hourChar == 'k') {
	                dayPeriodLen = 0;
	            }
	            while (dayPeriodLen-- > 0) {
	                skeletonCopy += dayPeriodChar;
	            }
	            while (hourLen-- > 0) {
	                skeletonCopy = hourChar + skeletonCopy;
	            }
	        }
	        else if (patternChar === 'J') {
	            skeletonCopy += 'H';
	        }
	        else {
	            skeletonCopy += patternChar;
	        }
	    }
	    return skeletonCopy;
	}
	exports.getBestPattern = getBestPattern;
	/**
	 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
	 * of the given `locale` to the corresponding time pattern.
	 * @param locale
	 */
	function getDefaultHourSymbolFromLocale(locale) {
	    var hourCycle = locale.hourCycle;
	    if (hourCycle === undefined &&
	        // @ts-ignore hourCycle(s) is not identified yet
	        locale.hourCycles &&
	        // @ts-ignore
	        locale.hourCycles.length) {
	        // @ts-ignore
	        hourCycle = locale.hourCycles[0];
	    }
	    if (hourCycle) {
	        switch (hourCycle) {
	            case 'h24':
	                return 'k';
	            case 'h23':
	                return 'H';
	            case 'h12':
	                return 'h';
	            case 'h11':
	                return 'K';
	            default:
	                throw new Error('Invalid hourCycle');
	        }
	    }
	    // TODO: Once hourCycle is fully supported remove the following with data generation
	    var languageTag = locale.language;
	    var regionTag;
	    if (languageTag !== 'root') {
	        regionTag = locale.maximize().region;
	    }
	    var hourCycles = time_data_generated_1.timeData[regionTag || ''] ||
	        time_data_generated_1.timeData[languageTag || ''] ||
	        time_data_generated_1.timeData["".concat(languageTag, "-001")] ||
	        time_data_generated_1.timeData['001'];
	    return hourCycles[0];
	}


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Parser = void 0;
	var tslib_1 = __webpack_require__(135);
	var error_1 = __webpack_require__(134);
	var types_1 = __webpack_require__(71);
	var regex_generated_1 = __webpack_require__(248);
	var icu_skeleton_parser_1 = __webpack_require__(251);
	var date_time_pattern_generator_1 = __webpack_require__(246);
	var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(regex_generated_1.SPACE_SEPARATOR_REGEX.source, "*"));
	var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(regex_generated_1.SPACE_SEPARATOR_REGEX.source, "*$"));
	function createLocation(start, end) {
	    return { start: start, end: end };
	}
	// #region Ponyfills
	// Consolidate these variables up top for easier toggling during debugging
	var hasNativeStartsWith = !!String.prototype.startsWith;
	var hasNativeFromCodePoint = !!String.fromCodePoint;
	var hasNativeFromEntries = !!Object.fromEntries;
	var hasNativeCodePointAt = !!String.prototype.codePointAt;
	var hasTrimStart = !!String.prototype.trimStart;
	var hasTrimEnd = !!String.prototype.trimEnd;
	var hasNativeIsSafeInteger = !!Number.isSafeInteger;
	var isSafeInteger = hasNativeIsSafeInteger
	    ? Number.isSafeInteger
	    : function (n) {
	        return (typeof n === 'number' &&
	            isFinite(n) &&
	            Math.floor(n) === n &&
	            Math.abs(n) <= 0x1fffffffffffff);
	    };
	// IE11 does not support y and u.
	var REGEX_SUPPORTS_U_AND_Y = true;
	try {
	    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	    /**
	     * legacy Edge or Xbox One browser
	     * Unicode flag support: supported
	     * Pattern_Syntax support: not supported
	     * See https://github.com/formatjs/formatjs/issues/2822
	     */
	    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
	}
	catch (_) {
	    REGEX_SUPPORTS_U_AND_Y = false;
	}
	var startsWith = hasNativeStartsWith
	    ? // Native
	        function startsWith(s, search, position) {
	            return s.startsWith(search, position);
	        }
	    : // For IE11
	        function startsWith(s, search, position) {
	            return s.slice(position, position + search.length) === search;
	        };
	var fromCodePoint = hasNativeFromCodePoint
	    ? String.fromCodePoint
	    : // IE11
	        function fromCodePoint() {
	            var codePoints = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                codePoints[_i] = arguments[_i];
	            }
	            var elements = '';
	            var length = codePoints.length;
	            var i = 0;
	            var code;
	            while (length > i) {
	                code = codePoints[i++];
	                if (code > 0x10ffff)
	                    throw RangeError(code + ' is not a valid code point');
	                elements +=
	                    code < 0x10000
	                        ? String.fromCharCode(code)
	                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
	            }
	            return elements;
	        };
	var fromEntries = 
	// native
	hasNativeFromEntries
	    ? Object.fromEntries
	    : // Ponyfill
	        function fromEntries(entries) {
	            var obj = {};
	            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                var _a = entries_1[_i], k = _a[0], v = _a[1];
	                obj[k] = v;
	            }
	            return obj;
	        };
	var codePointAt = hasNativeCodePointAt
	    ? // Native
	        function codePointAt(s, index) {
	            return s.codePointAt(index);
	        }
	    : // IE 11
	        function codePointAt(s, index) {
	            var size = s.length;
	            if (index < 0 || index >= size) {
	                return undefined;
	            }
	            var first = s.charCodeAt(index);
	            var second;
	            return first < 0xd800 ||
	                first > 0xdbff ||
	                index + 1 === size ||
	                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
	                second > 0xdfff
	                ? first
	                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
	        };
	var trimStart = hasTrimStart
	    ? // Native
	        function trimStart(s) {
	            return s.trimStart();
	        }
	    : // Ponyfill
	        function trimStart(s) {
	            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
	        };
	var trimEnd = hasTrimEnd
	    ? // Native
	        function trimEnd(s) {
	            return s.trimEnd();
	        }
	    : // Ponyfill
	        function trimEnd(s) {
	            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
	        };
	// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
	function RE(s, flag) {
	    return new RegExp(s, flag);
	}
	// #endregion
	var matchIdentifierAtIndex;
	if (REGEX_SUPPORTS_U_AND_Y) {
	    // Native
	    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
	    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	        var _a;
	        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
	        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
	        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
	    };
	}
	else {
	    // IE11
	    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
	        var match = [];
	        while (true) {
	            var c = codePointAt(s, index);
	            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
	                break;
	            }
	            match.push(c);
	            index += c >= 0x10000 ? 2 : 1;
	        }
	        return fromCodePoint.apply(void 0, match);
	    };
	}
	var Parser = /** @class */ (function () {
	    function Parser(message, options) {
	        if (options === void 0) { options = {}; }
	        this.message = message;
	        this.position = { offset: 0, line: 1, column: 1 };
	        this.ignoreTag = !!options.ignoreTag;
	        this.locale = options.locale;
	        this.requiresOtherClause = !!options.requiresOtherClause;
	        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
	    }
	    Parser.prototype.parse = function () {
	        if (this.offset() !== 0) {
	            throw Error('parser can only be used once');
	        }
	        return this.parseMessage(0, '', false);
	    };
	    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
	        var elements = [];
	        while (!this.isEOF()) {
	            var char = this.char();
	            if (char === 123 /* `{` */) {
	                var result = this.parseArgument(nestingLevel, expectingCloseTag);
	                if (result.err) {
	                    return result;
	                }
	                elements.push(result.val);
	            }
	            else if (char === 125 /* `}` */ && nestingLevel > 0) {
	                break;
	            }
	            else if (char === 35 /* `#` */ &&
	                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
	                var position = this.clonePosition();
	                this.bump();
	                elements.push({
	                    type: types_1.TYPE.pound,
	                    location: createLocation(position, this.clonePosition()),
	                });
	            }
	            else if (char === 60 /* `<` */ &&
	                !this.ignoreTag &&
	                this.peek() === 47 // char code for '/'
	            ) {
	                if (expectingCloseTag) {
	                    break;
	                }
	                else {
	                    return this.error(error_1.ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
	                }
	            }
	            else if (char === 60 /* `<` */ &&
	                !this.ignoreTag &&
	                _isAlpha(this.peek() || 0)) {
	                var result = this.parseTag(nestingLevel, parentArgType);
	                if (result.err) {
	                    return result;
	                }
	                elements.push(result.val);
	            }
	            else {
	                var result = this.parseLiteral(nestingLevel, parentArgType);
	                if (result.err) {
	                    return result;
	                }
	                elements.push(result.val);
	            }
	        }
	        return { val: elements, err: null };
	    };
	    /**
	     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	     * are accepted:
	     *
	     * ```
	     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	     * tagName ::= [a-z] (PENChar)*
	     * PENChar ::=
	     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	     * ```
	     *
	     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	     * since other tag-based engines like React allow it
	     */
	    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
	        var startPosition = this.clonePosition();
	        this.bump(); // `<`
	        var tagName = this.parseTagName();
	        this.bumpSpace();
	        if (this.bumpIf('/>')) {
	            // Self closing tag
	            return {
	                val: {
	                    type: types_1.TYPE.literal,
	                    value: "<".concat(tagName, "/>"),
	                    location: createLocation(startPosition, this.clonePosition()),
	                },
	                err: null,
	            };
	        }
	        else if (this.bumpIf('>')) {
	            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
	            if (childrenResult.err) {
	                return childrenResult;
	            }
	            var children = childrenResult.val;
	            // Expecting a close tag
	            var endTagStartPosition = this.clonePosition();
	            if (this.bumpIf('</')) {
	                if (this.isEOF() || !_isAlpha(this.char())) {
	                    return this.error(error_1.ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                }
	                var closingTagNameStartPosition = this.clonePosition();
	                var closingTagName = this.parseTagName();
	                if (tagName !== closingTagName) {
	                    return this.error(error_1.ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
	                }
	                this.bumpSpace();
	                if (!this.bumpIf('>')) {
	                    return this.error(error_1.ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
	                }
	                return {
	                    val: {
	                        type: types_1.TYPE.tag,
	                        value: tagName,
	                        children: children,
	                        location: createLocation(startPosition, this.clonePosition()),
	                    },
	                    err: null,
	                };
	            }
	            else {
	                return this.error(error_1.ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
	            }
	        }
	        else {
	            return this.error(error_1.ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
	        }
	    };
	    /**
	     * This method assumes that the caller has peeked ahead for the first tag character.
	     */
	    Parser.prototype.parseTagName = function () {
	        var startOffset = this.offset();
	        this.bump(); // the first tag name character
	        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
	            this.bump();
	        }
	        return this.message.slice(startOffset, this.offset());
	    };
	    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
	        var start = this.clonePosition();
	        var value = '';
	        while (true) {
	            var parseQuoteResult = this.tryParseQuote(parentArgType);
	            if (parseQuoteResult) {
	                value += parseQuoteResult;
	                continue;
	            }
	            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
	            if (parseUnquotedResult) {
	                value += parseUnquotedResult;
	                continue;
	            }
	            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
	            if (parseLeftAngleResult) {
	                value += parseLeftAngleResult;
	                continue;
	            }
	            break;
	        }
	        var location = createLocation(start, this.clonePosition());
	        return {
	            val: { type: types_1.TYPE.literal, value: value, location: location },
	            err: null,
	        };
	    };
	    Parser.prototype.tryParseLeftAngleBracket = function () {
	        if (!this.isEOF() &&
	            this.char() === 60 /* `<` */ &&
	            (this.ignoreTag ||
	                // If at the opening tag or closing tag position, bail.
	                !_isAlphaOrSlash(this.peek() || 0))) {
	            this.bump(); // `<`
	            return '<';
	        }
	        return null;
	    };
	    /**
	     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	     * a character that requires quoting (that is, "only where needed"), and works the same in
	     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	     */
	    Parser.prototype.tryParseQuote = function (parentArgType) {
	        if (this.isEOF() || this.char() !== 39 /* `'` */) {
	            return null;
	        }
	        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
	        // Check if is valid escaped character
	        switch (this.peek()) {
	            case 39 /* `'` */:
	                // double quote, should return as a single quote.
	                this.bump();
	                this.bump();
	                return "'";
	            // '{', '<', '>', '}'
	            case 123:
	            case 60:
	            case 62:
	            case 125:
	                break;
	            case 35: // '#'
	                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
	                    break;
	                }
	                return null;
	            default:
	                return null;
	        }
	        this.bump(); // apostrophe
	        var codePoints = [this.char()]; // escaped char
	        this.bump();
	        // read chars until the optional closing apostrophe is found
	        while (!this.isEOF()) {
	            var ch = this.char();
	            if (ch === 39 /* `'` */) {
	                if (this.peek() === 39 /* `'` */) {
	                    codePoints.push(39);
	                    // Bump one more time because we need to skip 2 characters.
	                    this.bump();
	                }
	                else {
	                    // Optional closing apostrophe.
	                    this.bump();
	                    break;
	                }
	            }
	            else {
	                codePoints.push(ch);
	            }
	            this.bump();
	        }
	        return fromCodePoint.apply(void 0, codePoints);
	    };
	    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
	        if (this.isEOF()) {
	            return null;
	        }
	        var ch = this.char();
	        if (ch === 60 /* `<` */ ||
	            ch === 123 /* `{` */ ||
	            (ch === 35 /* `#` */ &&
	                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
	            (ch === 125 /* `}` */ && nestingLevel > 0)) {
	            return null;
	        }
	        else {
	            this.bump();
	            return fromCodePoint(ch);
	        }
	    };
	    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
	        var openingBracePosition = this.clonePosition();
	        this.bump(); // `{`
	        this.bumpSpace();
	        if (this.isEOF()) {
	            return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	        }
	        if (this.char() === 125 /* `}` */) {
	            this.bump();
	            return this.error(error_1.ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	        }
	        // argument name
	        var value = this.parseIdentifierIfPossible().value;
	        if (!value) {
	            return this.error(error_1.ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	        }
	        this.bumpSpace();
	        if (this.isEOF()) {
	            return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	        }
	        switch (this.char()) {
	            // Simple argument: `{name}`
	            case 125 /* `}` */: {
	                this.bump(); // `}`
	                return {
	                    val: {
	                        type: types_1.TYPE.argument,
	                        // value does not include the opening and closing braces.
	                        value: value,
	                        location: createLocation(openingBracePosition, this.clonePosition()),
	                    },
	                    err: null,
	                };
	            }
	            // Argument with options: `{name, format, ...}`
	            case 44 /* `,` */: {
	                this.bump(); // `,`
	                this.bumpSpace();
	                if (this.isEOF()) {
	                    return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	                }
	                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
	            }
	            default:
	                return this.error(error_1.ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
	        }
	    };
	    /**
	     * Advance the parser until the end of the identifier, if it is currently on
	     * an identifier character. Return an empty string otherwise.
	     */
	    Parser.prototype.parseIdentifierIfPossible = function () {
	        var startingPosition = this.clonePosition();
	        var startOffset = this.offset();
	        var value = matchIdentifierAtIndex(this.message, startOffset);
	        var endOffset = startOffset + value.length;
	        this.bumpTo(endOffset);
	        var endPosition = this.clonePosition();
	        var location = createLocation(startingPosition, endPosition);
	        return { value: value, location: location };
	    };
	    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
	        var _a;
	        // Parse this range:
	        // {name, type, style}
	        //        ^---^
	        var typeStartPosition = this.clonePosition();
	        var argType = this.parseIdentifierIfPossible().value;
	        var typeEndPosition = this.clonePosition();
	        switch (argType) {
	            case '':
	                // Expecting a style string number, date, time, plural, selectordinal, or select.
	                return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	            case 'number':
	            case 'date':
	            case 'time': {
	                // Parse this range:
	                // {name, number, style}
	                //              ^-------^
	                this.bumpSpace();
	                var styleAndLocation = null;
	                if (this.bumpIf(',')) {
	                    this.bumpSpace();
	                    var styleStartPosition = this.clonePosition();
	                    var result = this.parseSimpleArgStyleIfPossible();
	                    if (result.err) {
	                        return result;
	                    }
	                    var style = trimEnd(result.val);
	                    if (style.length === 0) {
	                        return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
	                    }
	                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
	                    styleAndLocation = { style: style, styleLocation: styleLocation };
	                }
	                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                if (argCloseResult.err) {
	                    return argCloseResult;
	                }
	                var location_1 = createLocation(openingBracePosition, this.clonePosition());
	                // Extract style or skeleton
	                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
	                    // Skeleton starts with `::`.
	                    var skeleton = trimStart(styleAndLocation.style.slice(2));
	                    if (argType === 'number') {
	                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
	                        if (result.err) {
	                            return result;
	                        }
	                        return {
	                            val: { type: types_1.TYPE.number, value: value, location: location_1, style: result.val },
	                            err: null,
	                        };
	                    }
	                    else {
	                        if (skeleton.length === 0) {
	                            return this.error(error_1.ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
	                        }
	                        var dateTimePattern = skeleton;
	                        // Get "best match" pattern only if locale is passed, if not, let it
	                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
	                        // for unsupported patterns.
	                        if (this.locale) {
	                            dateTimePattern = (0, date_time_pattern_generator_1.getBestPattern)(skeleton, this.locale);
	                        }
	                        var style = {
	                            type: types_1.SKELETON_TYPE.dateTime,
	                            pattern: dateTimePattern,
	                            location: styleAndLocation.styleLocation,
	                            parsedOptions: this.shouldParseSkeletons
	                                ? (0, icu_skeleton_parser_1.parseDateTimeSkeleton)(dateTimePattern)
	                                : {},
	                        };
	                        var type = argType === 'date' ? types_1.TYPE.date : types_1.TYPE.time;
	                        return {
	                            val: { type: type, value: value, location: location_1, style: style },
	                            err: null,
	                        };
	                    }
	                }
	                // Regular style or no style.
	                return {
	                    val: {
	                        type: argType === 'number'
	                            ? types_1.TYPE.number
	                            : argType === 'date'
	                                ? types_1.TYPE.date
	                                : types_1.TYPE.time,
	                        value: value,
	                        location: location_1,
	                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
	                    },
	                    err: null,
	                };
	            }
	            case 'plural':
	            case 'selectordinal':
	            case 'select': {
	                // Parse this range:
	                // {name, plural, options}
	                //              ^---------^
	                var typeEndPosition_1 = this.clonePosition();
	                this.bumpSpace();
	                if (!this.bumpIf(',')) {
	                    return this.error(error_1.ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0, tslib_1.__assign)({}, typeEndPosition_1)));
	                }
	                this.bumpSpace();
	                // Parse offset:
	                // {name, plural, offset:1, options}
	                //                ^-----^
	                //
	                // or the first option:
	                //
	                // {name, plural, one {...} other {...}}
	                //                ^--^
	                var identifierAndLocation = this.parseIdentifierIfPossible();
	                var pluralOffset = 0;
	                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
	                    if (!this.bumpIf(':')) {
	                        return this.error(error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
	                    }
	                    this.bumpSpace();
	                    var result = this.tryParseDecimalInteger(error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, error_1.ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
	                    if (result.err) {
	                        return result;
	                    }
	                    // Parse another identifier for option parsing
	                    this.bumpSpace();
	                    identifierAndLocation = this.parseIdentifierIfPossible();
	                    pluralOffset = result.val;
	                }
	                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
	                if (optionsResult.err) {
	                    return optionsResult;
	                }
	                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	                if (argCloseResult.err) {
	                    return argCloseResult;
	                }
	                var location_2 = createLocation(openingBracePosition, this.clonePosition());
	                if (argType === 'select') {
	                    return {
	                        val: {
	                            type: types_1.TYPE.select,
	                            value: value,
	                            options: fromEntries(optionsResult.val),
	                            location: location_2,
	                        },
	                        err: null,
	                    };
	                }
	                else {
	                    return {
	                        val: {
	                            type: types_1.TYPE.plural,
	                            value: value,
	                            options: fromEntries(optionsResult.val),
	                            offset: pluralOffset,
	                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
	                            location: location_2,
	                        },
	                        err: null,
	                    };
	                }
	            }
	            default:
	                return this.error(error_1.ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
	        }
	    };
	    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
	        // Parse: {value, number, ::currency/GBP }
	        //
	        if (this.isEOF() || this.char() !== 125 /* `}` */) {
	            return this.error(error_1.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
	        }
	        this.bump(); // `}`
	        return { val: true, err: null };
	    };
	    /**
	     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	     */
	    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
	        var nestedBraces = 0;
	        var startPosition = this.clonePosition();
	        while (!this.isEOF()) {
	            var ch = this.char();
	            switch (ch) {
	                case 39 /* `'` */: {
	                    // Treat apostrophe as quoting but include it in the style part.
	                    // Find the end of the quoted literal text.
	                    this.bump();
	                    var apostrophePosition = this.clonePosition();
	                    if (!this.bumpUntil("'")) {
	                        return this.error(error_1.ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
	                    }
	                    this.bump();
	                    break;
	                }
	                case 123 /* `{` */: {
	                    nestedBraces += 1;
	                    this.bump();
	                    break;
	                }
	                case 125 /* `}` */: {
	                    if (nestedBraces > 0) {
	                        nestedBraces -= 1;
	                    }
	                    else {
	                        return {
	                            val: this.message.slice(startPosition.offset, this.offset()),
	                            err: null,
	                        };
	                    }
	                    break;
	                }
	                default:
	                    this.bump();
	                    break;
	            }
	        }
	        return {
	            val: this.message.slice(startPosition.offset, this.offset()),
	            err: null,
	        };
	    };
	    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
	        var tokens = [];
	        try {
	            tokens = (0, icu_skeleton_parser_1.parseNumberSkeletonFromString)(skeleton);
	        }
	        catch (e) {
	            return this.error(error_1.ErrorKind.INVALID_NUMBER_SKELETON, location);
	        }
	        return {
	            val: {
	                type: types_1.SKELETON_TYPE.number,
	                tokens: tokens,
	                location: location,
	                parsedOptions: this.shouldParseSkeletons
	                    ? (0, icu_skeleton_parser_1.parseNumberSkeleton)(tokens)
	                    : {},
	            },
	            err: null,
	        };
	    };
	    /**
	     * @param nesting_level The current nesting level of messages.
	     *     This can be positive when parsing message fragment in select or plural argument options.
	     * @param parent_arg_type The parent argument's type.
	     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
	     *     the argument. It is a by-product of a previous parsing attempt.
	     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
	     *     between a pair of opening and closing tags. The nested message will not parse beyond
	     *     the closing tag boundary.
	     */
	    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
	        var _a;
	        var hasOtherClause = false;
	        var options = [];
	        var parsedSelectors = new Set();
	        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
	        // Parse:
	        // one {one apple}
	        // ^--^
	        while (true) {
	            if (selector.length === 0) {
	                var startPosition = this.clonePosition();
	                if (parentArgType !== 'select' && this.bumpIf('=')) {
	                    // Try parse `={number}` selector
	                    var result = this.tryParseDecimalInteger(error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, error_1.ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
	                    if (result.err) {
	                        return result;
	                    }
	                    selectorLocation = createLocation(startPosition, this.clonePosition());
	                    selector = this.message.slice(startPosition.offset, this.offset());
	                }
	                else {
	                    break;
	                }
	            }
	            // Duplicate selector clauses
	            if (parsedSelectors.has(selector)) {
	                return this.error(parentArgType === 'select'
	                    ? error_1.ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
	                    : error_1.ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
	            }
	            if (selector === 'other') {
	                hasOtherClause = true;
	            }
	            // Parse:
	            // one {one apple}
	            //     ^----------^
	            this.bumpSpace();
	            var openingBracePosition = this.clonePosition();
	            if (!this.bumpIf('{')) {
	                return this.error(parentArgType === 'select'
	                    ? error_1.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
	                    : error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
	            }
	            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
	            if (fragmentResult.err) {
	                return fragmentResult;
	            }
	            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
	            if (argCloseResult.err) {
	                return argCloseResult;
	            }
	            options.push([
	                selector,
	                {
	                    value: fragmentResult.val,
	                    location: createLocation(openingBracePosition, this.clonePosition()),
	                },
	            ]);
	            // Keep track of the existing selectors
	            parsedSelectors.add(selector);
	            // Prep next selector clause.
	            this.bumpSpace();
	            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
	        }
	        if (options.length === 0) {
	            return this.error(parentArgType === 'select'
	                ? error_1.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
	                : error_1.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
	        }
	        if (this.requiresOtherClause && !hasOtherClause) {
	            return this.error(error_1.ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
	        }
	        return { val: options, err: null };
	    };
	    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
	        var sign = 1;
	        var startingPosition = this.clonePosition();
	        if (this.bumpIf('+')) {
	        }
	        else if (this.bumpIf('-')) {
	            sign = -1;
	        }
	        var hasDigits = false;
	        var decimal = 0;
	        while (!this.isEOF()) {
	            var ch = this.char();
	            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
	                hasDigits = true;
	                decimal = decimal * 10 + (ch - 48);
	                this.bump();
	            }
	            else {
	                break;
	            }
	        }
	        var location = createLocation(startingPosition, this.clonePosition());
	        if (!hasDigits) {
	            return this.error(expectNumberError, location);
	        }
	        decimal *= sign;
	        if (!isSafeInteger(decimal)) {
	            return this.error(invalidNumberError, location);
	        }
	        return { val: decimal, err: null };
	    };
	    Parser.prototype.offset = function () {
	        return this.position.offset;
	    };
	    Parser.prototype.isEOF = function () {
	        return this.offset() === this.message.length;
	    };
	    Parser.prototype.clonePosition = function () {
	        // This is much faster than `Object.assign` or spread.
	        return {
	            offset: this.position.offset,
	            line: this.position.line,
	            column: this.position.column,
	        };
	    };
	    /**
	     * Return the code point at the current position of the parser.
	     * Throws if the index is out of bound.
	     */
	    Parser.prototype.char = function () {
	        var offset = this.position.offset;
	        if (offset >= this.message.length) {
	            throw Error('out of bound');
	        }
	        var code = codePointAt(this.message, offset);
	        if (code === undefined) {
	            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
	        }
	        return code;
	    };
	    Parser.prototype.error = function (kind, location) {
	        return {
	            val: null,
	            err: {
	                kind: kind,
	                message: this.message,
	                location: location,
	            },
	        };
	    };
	    /** Bump the parser to the next UTF-16 code unit. */
	    Parser.prototype.bump = function () {
	        if (this.isEOF()) {
	            return;
	        }
	        var code = this.char();
	        if (code === 10 /* '\n' */) {
	            this.position.line += 1;
	            this.position.column = 1;
	            this.position.offset += 1;
	        }
	        else {
	            this.position.column += 1;
	            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
	            this.position.offset += code < 0x10000 ? 1 : 2;
	        }
	    };
	    /**
	     * If the substring starting at the current position of the parser has
	     * the given prefix, then bump the parser to the character immediately
	     * following the prefix and return true. Otherwise, don't bump the parser
	     * and return false.
	     */
	    Parser.prototype.bumpIf = function (prefix) {
	        if (startsWith(this.message, prefix, this.offset())) {
	            for (var i = 0; i < prefix.length; i++) {
	                this.bump();
	            }
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Bump the parser until the pattern character is found and return `true`.
	     * Otherwise bump to the end of the file and return `false`.
	     */
	    Parser.prototype.bumpUntil = function (pattern) {
	        var currentOffset = this.offset();
	        var index = this.message.indexOf(pattern, currentOffset);
	        if (index >= 0) {
	            this.bumpTo(index);
	            return true;
	        }
	        else {
	            this.bumpTo(this.message.length);
	            return false;
	        }
	    };
	    /**
	     * Bump the parser to the target offset.
	     * If target offset is beyond the end of the input, bump the parser to the end of the input.
	     */
	    Parser.prototype.bumpTo = function (targetOffset) {
	        if (this.offset() > targetOffset) {
	            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
	        }
	        targetOffset = Math.min(targetOffset, this.message.length);
	        while (true) {
	            var offset = this.offset();
	            if (offset === targetOffset) {
	                break;
	            }
	            if (offset > targetOffset) {
	                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
	            }
	            this.bump();
	            if (this.isEOF()) {
	                break;
	            }
	        }
	    };
	    /** advance the parser through all whitespace to the next non-whitespace code unit. */
	    Parser.prototype.bumpSpace = function () {
	        while (!this.isEOF() && _isWhiteSpace(this.char())) {
	            this.bump();
	        }
	    };
	    /**
	     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
	     * If the input has been exhausted, then this returns null.
	     */
	    Parser.prototype.peek = function () {
	        if (this.isEOF()) {
	            return null;
	        }
	        var code = this.char();
	        var offset = this.offset();
	        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
	        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
	    };
	    return Parser;
	}());
	exports.Parser = Parser;
	/**
	 * This check if codepoint is alphabet (lower & uppercase)
	 * @param codepoint
	 * @returns
	 */
	function _isAlpha(codepoint) {
	    return ((codepoint >= 97 && codepoint <= 122) ||
	        (codepoint >= 65 && codepoint <= 90));
	}
	function _isAlphaOrSlash(codepoint) {
	    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
	}
	/** See `parseTag` function docs. */
	function _isPotentialElementNameChar(c) {
	    return (c === 45 /* '-' */ ||
	        c === 46 /* '.' */ ||
	        (c >= 48 && c <= 57) /* 0..9 */ ||
	        c === 95 /* '_' */ ||
	        (c >= 97 && c <= 122) /** a..z */ ||
	        (c >= 65 && c <= 90) /* A..Z */ ||
	        c == 0xb7 ||
	        (c >= 0xc0 && c <= 0xd6) ||
	        (c >= 0xd8 && c <= 0xf6) ||
	        (c >= 0xf8 && c <= 0x37d) ||
	        (c >= 0x37f && c <= 0x1fff) ||
	        (c >= 0x200c && c <= 0x200d) ||
	        (c >= 0x203f && c <= 0x2040) ||
	        (c >= 0x2070 && c <= 0x218f) ||
	        (c >= 0x2c00 && c <= 0x2fef) ||
	        (c >= 0x3001 && c <= 0xd7ff) ||
	        (c >= 0xf900 && c <= 0xfdcf) ||
	        (c >= 0xfdf0 && c <= 0xfffd) ||
	        (c >= 0x10000 && c <= 0xeffff));
	}
	/**
	 * Code point equivalent of regex `\p{White_Space}`.
	 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	 */
	function _isWhiteSpace(c) {
	    return ((c >= 0x0009 && c <= 0x000d) ||
	        c === 0x0020 ||
	        c === 0x0085 ||
	        (c >= 0x200e && c <= 0x200f) ||
	        c === 0x2028 ||
	        c === 0x2029);
	}
	/**
	 * Code point equivalent of regex `\p{Pattern_Syntax}`.
	 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
	 */
	function _isPatternSyntax(c) {
	    return ((c >= 0x0021 && c <= 0x0023) ||
	        c === 0x0024 ||
	        (c >= 0x0025 && c <= 0x0027) ||
	        c === 0x0028 ||
	        c === 0x0029 ||
	        c === 0x002a ||
	        c === 0x002b ||
	        c === 0x002c ||
	        c === 0x002d ||
	        (c >= 0x002e && c <= 0x002f) ||
	        (c >= 0x003a && c <= 0x003b) ||
	        (c >= 0x003c && c <= 0x003e) ||
	        (c >= 0x003f && c <= 0x0040) ||
	        c === 0x005b ||
	        c === 0x005c ||
	        c === 0x005d ||
	        c === 0x005e ||
	        c === 0x0060 ||
	        c === 0x007b ||
	        c === 0x007c ||
	        c === 0x007d ||
	        c === 0x007e ||
	        c === 0x00a1 ||
	        (c >= 0x00a2 && c <= 0x00a5) ||
	        c === 0x00a6 ||
	        c === 0x00a7 ||
	        c === 0x00a9 ||
	        c === 0x00ab ||
	        c === 0x00ac ||
	        c === 0x00ae ||
	        c === 0x00b0 ||
	        c === 0x00b1 ||
	        c === 0x00b6 ||
	        c === 0x00bb ||
	        c === 0x00bf ||
	        c === 0x00d7 ||
	        c === 0x00f7 ||
	        (c >= 0x2010 && c <= 0x2015) ||
	        (c >= 0x2016 && c <= 0x2017) ||
	        c === 0x2018 ||
	        c === 0x2019 ||
	        c === 0x201a ||
	        (c >= 0x201b && c <= 0x201c) ||
	        c === 0x201d ||
	        c === 0x201e ||
	        c === 0x201f ||
	        (c >= 0x2020 && c <= 0x2027) ||
	        (c >= 0x2030 && c <= 0x2038) ||
	        c === 0x2039 ||
	        c === 0x203a ||
	        (c >= 0x203b && c <= 0x203e) ||
	        (c >= 0x2041 && c <= 0x2043) ||
	        c === 0x2044 ||
	        c === 0x2045 ||
	        c === 0x2046 ||
	        (c >= 0x2047 && c <= 0x2051) ||
	        c === 0x2052 ||
	        c === 0x2053 ||
	        (c >= 0x2055 && c <= 0x205e) ||
	        (c >= 0x2190 && c <= 0x2194) ||
	        (c >= 0x2195 && c <= 0x2199) ||
	        (c >= 0x219a && c <= 0x219b) ||
	        (c >= 0x219c && c <= 0x219f) ||
	        c === 0x21a0 ||
	        (c >= 0x21a1 && c <= 0x21a2) ||
	        c === 0x21a3 ||
	        (c >= 0x21a4 && c <= 0x21a5) ||
	        c === 0x21a6 ||
	        (c >= 0x21a7 && c <= 0x21ad) ||
	        c === 0x21ae ||
	        (c >= 0x21af && c <= 0x21cd) ||
	        (c >= 0x21ce && c <= 0x21cf) ||
	        (c >= 0x21d0 && c <= 0x21d1) ||
	        c === 0x21d2 ||
	        c === 0x21d3 ||
	        c === 0x21d4 ||
	        (c >= 0x21d5 && c <= 0x21f3) ||
	        (c >= 0x21f4 && c <= 0x22ff) ||
	        (c >= 0x2300 && c <= 0x2307) ||
	        c === 0x2308 ||
	        c === 0x2309 ||
	        c === 0x230a ||
	        c === 0x230b ||
	        (c >= 0x230c && c <= 0x231f) ||
	        (c >= 0x2320 && c <= 0x2321) ||
	        (c >= 0x2322 && c <= 0x2328) ||
	        c === 0x2329 ||
	        c === 0x232a ||
	        (c >= 0x232b && c <= 0x237b) ||
	        c === 0x237c ||
	        (c >= 0x237d && c <= 0x239a) ||
	        (c >= 0x239b && c <= 0x23b3) ||
	        (c >= 0x23b4 && c <= 0x23db) ||
	        (c >= 0x23dc && c <= 0x23e1) ||
	        (c >= 0x23e2 && c <= 0x2426) ||
	        (c >= 0x2427 && c <= 0x243f) ||
	        (c >= 0x2440 && c <= 0x244a) ||
	        (c >= 0x244b && c <= 0x245f) ||
	        (c >= 0x2500 && c <= 0x25b6) ||
	        c === 0x25b7 ||
	        (c >= 0x25b8 && c <= 0x25c0) ||
	        c === 0x25c1 ||
	        (c >= 0x25c2 && c <= 0x25f7) ||
	        (c >= 0x25f8 && c <= 0x25ff) ||
	        (c >= 0x2600 && c <= 0x266e) ||
	        c === 0x266f ||
	        (c >= 0x2670 && c <= 0x2767) ||
	        c === 0x2768 ||
	        c === 0x2769 ||
	        c === 0x276a ||
	        c === 0x276b ||
	        c === 0x276c ||
	        c === 0x276d ||
	        c === 0x276e ||
	        c === 0x276f ||
	        c === 0x2770 ||
	        c === 0x2771 ||
	        c === 0x2772 ||
	        c === 0x2773 ||
	        c === 0x2774 ||
	        c === 0x2775 ||
	        (c >= 0x2794 && c <= 0x27bf) ||
	        (c >= 0x27c0 && c <= 0x27c4) ||
	        c === 0x27c5 ||
	        c === 0x27c6 ||
	        (c >= 0x27c7 && c <= 0x27e5) ||
	        c === 0x27e6 ||
	        c === 0x27e7 ||
	        c === 0x27e8 ||
	        c === 0x27e9 ||
	        c === 0x27ea ||
	        c === 0x27eb ||
	        c === 0x27ec ||
	        c === 0x27ed ||
	        c === 0x27ee ||
	        c === 0x27ef ||
	        (c >= 0x27f0 && c <= 0x27ff) ||
	        (c >= 0x2800 && c <= 0x28ff) ||
	        (c >= 0x2900 && c <= 0x2982) ||
	        c === 0x2983 ||
	        c === 0x2984 ||
	        c === 0x2985 ||
	        c === 0x2986 ||
	        c === 0x2987 ||
	        c === 0x2988 ||
	        c === 0x2989 ||
	        c === 0x298a ||
	        c === 0x298b ||
	        c === 0x298c ||
	        c === 0x298d ||
	        c === 0x298e ||
	        c === 0x298f ||
	        c === 0x2990 ||
	        c === 0x2991 ||
	        c === 0x2992 ||
	        c === 0x2993 ||
	        c === 0x2994 ||
	        c === 0x2995 ||
	        c === 0x2996 ||
	        c === 0x2997 ||
	        c === 0x2998 ||
	        (c >= 0x2999 && c <= 0x29d7) ||
	        c === 0x29d8 ||
	        c === 0x29d9 ||
	        c === 0x29da ||
	        c === 0x29db ||
	        (c >= 0x29dc && c <= 0x29fb) ||
	        c === 0x29fc ||
	        c === 0x29fd ||
	        (c >= 0x29fe && c <= 0x2aff) ||
	        (c >= 0x2b00 && c <= 0x2b2f) ||
	        (c >= 0x2b30 && c <= 0x2b44) ||
	        (c >= 0x2b45 && c <= 0x2b46) ||
	        (c >= 0x2b47 && c <= 0x2b4c) ||
	        (c >= 0x2b4d && c <= 0x2b73) ||
	        (c >= 0x2b74 && c <= 0x2b75) ||
	        (c >= 0x2b76 && c <= 0x2b95) ||
	        c === 0x2b96 ||
	        (c >= 0x2b97 && c <= 0x2bff) ||
	        (c >= 0x2e00 && c <= 0x2e01) ||
	        c === 0x2e02 ||
	        c === 0x2e03 ||
	        c === 0x2e04 ||
	        c === 0x2e05 ||
	        (c >= 0x2e06 && c <= 0x2e08) ||
	        c === 0x2e09 ||
	        c === 0x2e0a ||
	        c === 0x2e0b ||
	        c === 0x2e0c ||
	        c === 0x2e0d ||
	        (c >= 0x2e0e && c <= 0x2e16) ||
	        c === 0x2e17 ||
	        (c >= 0x2e18 && c <= 0x2e19) ||
	        c === 0x2e1a ||
	        c === 0x2e1b ||
	        c === 0x2e1c ||
	        c === 0x2e1d ||
	        (c >= 0x2e1e && c <= 0x2e1f) ||
	        c === 0x2e20 ||
	        c === 0x2e21 ||
	        c === 0x2e22 ||
	        c === 0x2e23 ||
	        c === 0x2e24 ||
	        c === 0x2e25 ||
	        c === 0x2e26 ||
	        c === 0x2e27 ||
	        c === 0x2e28 ||
	        c === 0x2e29 ||
	        (c >= 0x2e2a && c <= 0x2e2e) ||
	        c === 0x2e2f ||
	        (c >= 0x2e30 && c <= 0x2e39) ||
	        (c >= 0x2e3a && c <= 0x2e3b) ||
	        (c >= 0x2e3c && c <= 0x2e3f) ||
	        c === 0x2e40 ||
	        c === 0x2e41 ||
	        c === 0x2e42 ||
	        (c >= 0x2e43 && c <= 0x2e4f) ||
	        (c >= 0x2e50 && c <= 0x2e51) ||
	        c === 0x2e52 ||
	        (c >= 0x2e53 && c <= 0x2e7f) ||
	        (c >= 0x3001 && c <= 0x3003) ||
	        c === 0x3008 ||
	        c === 0x3009 ||
	        c === 0x300a ||
	        c === 0x300b ||
	        c === 0x300c ||
	        c === 0x300d ||
	        c === 0x300e ||
	        c === 0x300f ||
	        c === 0x3010 ||
	        c === 0x3011 ||
	        (c >= 0x3012 && c <= 0x3013) ||
	        c === 0x3014 ||
	        c === 0x3015 ||
	        c === 0x3016 ||
	        c === 0x3017 ||
	        c === 0x3018 ||
	        c === 0x3019 ||
	        c === 0x301a ||
	        c === 0x301b ||
	        c === 0x301c ||
	        c === 0x301d ||
	        (c >= 0x301e && c <= 0x301f) ||
	        c === 0x3020 ||
	        c === 0x3030 ||
	        c === 0xfd3e ||
	        c === 0xfd3f ||
	        (c >= 0xfe45 && c <= 0xfe46));
	}


/***/ },
/* 248 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.WHITE_SPACE_REGEX = exports.SPACE_SEPARATOR_REGEX = void 0;
	// @generated from regex-gen.ts
	exports.SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
	exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/***/ },
/* 249 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.timeData = void 0;
	// @generated from time-data-gen.ts
	// prettier-ignore  
	exports.timeData = {
	    "AX": [
	        "H"
	    ],
	    "BQ": [
	        "H"
	    ],
	    "CP": [
	        "H"
	    ],
	    "CZ": [
	        "H"
	    ],
	    "DK": [
	        "H"
	    ],
	    "FI": [
	        "H"
	    ],
	    "ID": [
	        "H"
	    ],
	    "IS": [
	        "H"
	    ],
	    "ML": [
	        "H"
	    ],
	    "NE": [
	        "H"
	    ],
	    "RU": [
	        "H"
	    ],
	    "SE": [
	        "H"
	    ],
	    "SJ": [
	        "H"
	    ],
	    "SK": [
	        "H"
	    ],
	    "AS": [
	        "h",
	        "H"
	    ],
	    "BT": [
	        "h",
	        "H"
	    ],
	    "DJ": [
	        "h",
	        "H"
	    ],
	    "ER": [
	        "h",
	        "H"
	    ],
	    "GH": [
	        "h",
	        "H"
	    ],
	    "IN": [
	        "h",
	        "H"
	    ],
	    "LS": [
	        "h",
	        "H"
	    ],
	    "PG": [
	        "h",
	        "H"
	    ],
	    "PW": [
	        "h",
	        "H"
	    ],
	    "SO": [
	        "h",
	        "H"
	    ],
	    "TO": [
	        "h",
	        "H"
	    ],
	    "VU": [
	        "h",
	        "H"
	    ],
	    "WS": [
	        "h",
	        "H"
	    ],
	    "001": [
	        "H",
	        "h"
	    ],
	    "AL": [
	        "h",
	        "H",
	        "hB"
	    ],
	    "TD": [
	        "h",
	        "H",
	        "hB"
	    ],
	    "ca-ES": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "CF": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "CM": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "fr-CA": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "gl-ES": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "it-CH": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "it-IT": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "LU": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "NP": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "PF": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "SC": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "SM": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "SN": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "TF": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "VA": [
	        "H",
	        "h",
	        "hB"
	    ],
	    "CY": [
	        "h",
	        "H",
	        "hb",
	        "hB"
	    ],
	    "GR": [
	        "h",
	        "H",
	        "hb",
	        "hB"
	    ],
	    "CO": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "DO": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "KP": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "KR": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "NA": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "PA": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "PR": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "VE": [
	        "h",
	        "H",
	        "hB",
	        "hb"
	    ],
	    "AC": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "AI": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "BW": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "BZ": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "CC": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "CK": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "CX": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "DG": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "FK": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "GB": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "GG": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "GI": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "IE": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "IM": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "IO": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "JE": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "LT": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "MK": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "MN": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "MS": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "NF": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "NG": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "NR": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "NU": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "PN": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "SH": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "SX": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "TA": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "ZA": [
	        "H",
	        "h",
	        "hb",
	        "hB"
	    ],
	    "af-ZA": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "AR": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "CL": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "CR": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "CU": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "EA": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "es-BO": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "es-BR": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "es-EC": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "es-ES": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "es-GQ": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "es-PE": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "GT": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "HN": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "IC": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "KG": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "KM": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "LK": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "MA": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "MX": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "NI": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "PY": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "SV": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "UY": [
	        "H",
	        "h",
	        "hB",
	        "hb"
	    ],
	    "JP": [
	        "H",
	        "h",
	        "K"
	    ],
	    "AD": [
	        "H",
	        "hB"
	    ],
	    "AM": [
	        "H",
	        "hB"
	    ],
	    "AO": [
	        "H",
	        "hB"
	    ],
	    "AT": [
	        "H",
	        "hB"
	    ],
	    "AW": [
	        "H",
	        "hB"
	    ],
	    "BE": [
	        "H",
	        "hB"
	    ],
	    "BF": [
	        "H",
	        "hB"
	    ],
	    "BJ": [
	        "H",
	        "hB"
	    ],
	    "BL": [
	        "H",
	        "hB"
	    ],
	    "BR": [
	        "H",
	        "hB"
	    ],
	    "CG": [
	        "H",
	        "hB"
	    ],
	    "CI": [
	        "H",
	        "hB"
	    ],
	    "CV": [
	        "H",
	        "hB"
	    ],
	    "DE": [
	        "H",
	        "hB"
	    ],
	    "EE": [
	        "H",
	        "hB"
	    ],
	    "FR": [
	        "H",
	        "hB"
	    ],
	    "GA": [
	        "H",
	        "hB"
	    ],
	    "GF": [
	        "H",
	        "hB"
	    ],
	    "GN": [
	        "H",
	        "hB"
	    ],
	    "GP": [
	        "H",
	        "hB"
	    ],
	    "GW": [
	        "H",
	        "hB"
	    ],
	    "HR": [
	        "H",
	        "hB"
	    ],
	    "IL": [
	        "H",
	        "hB"
	    ],
	    "IT": [
	        "H",
	        "hB"
	    ],
	    "KZ": [
	        "H",
	        "hB"
	    ],
	    "MC": [
	        "H",
	        "hB"
	    ],
	    "MD": [
	        "H",
	        "hB"
	    ],
	    "MF": [
	        "H",
	        "hB"
	    ],
	    "MQ": [
	        "H",
	        "hB"
	    ],
	    "MZ": [
	        "H",
	        "hB"
	    ],
	    "NC": [
	        "H",
	        "hB"
	    ],
	    "NL": [
	        "H",
	        "hB"
	    ],
	    "PM": [
	        "H",
	        "hB"
	    ],
	    "PT": [
	        "H",
	        "hB"
	    ],
	    "RE": [
	        "H",
	        "hB"
	    ],
	    "RO": [
	        "H",
	        "hB"
	    ],
	    "SI": [
	        "H",
	        "hB"
	    ],
	    "SR": [
	        "H",
	        "hB"
	    ],
	    "ST": [
	        "H",
	        "hB"
	    ],
	    "TG": [
	        "H",
	        "hB"
	    ],
	    "TR": [
	        "H",
	        "hB"
	    ],
	    "WF": [
	        "H",
	        "hB"
	    ],
	    "YT": [
	        "H",
	        "hB"
	    ],
	    "BD": [
	        "h",
	        "hB",
	        "H"
	    ],
	    "PK": [
	        "h",
	        "hB",
	        "H"
	    ],
	    "AZ": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "BA": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "BG": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "CH": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "GE": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "LI": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "ME": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "RS": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "UA": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "UZ": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "XK": [
	        "H",
	        "hB",
	        "h"
	    ],
	    "AG": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "AU": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "BB": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "BM": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "BS": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "CA": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "DM": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "en-001": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "FJ": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "FM": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "GD": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "GM": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "GU": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "GY": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "JM": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "KI": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "KN": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "KY": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "LC": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "LR": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "MH": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "MP": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "MW": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "NZ": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "SB": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "SG": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "SL": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "SS": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "SZ": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "TC": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "TT": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "UM": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "US": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "VC": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "VG": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "VI": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "ZM": [
	        "h",
	        "hb",
	        "H",
	        "hB"
	    ],
	    "BO": [
	        "H",
	        "hB",
	        "h",
	        "hb"
	    ],
	    "EC": [
	        "H",
	        "hB",
	        "h",
	        "hb"
	    ],
	    "ES": [
	        "H",
	        "hB",
	        "h",
	        "hb"
	    ],
	    "GQ": [
	        "H",
	        "hB",
	        "h",
	        "hb"
	    ],
	    "PE": [
	        "H",
	        "hB",
	        "h",
	        "hb"
	    ],
	    "AE": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "ar-001": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "BH": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "DZ": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "EG": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "EH": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "HK": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "IQ": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "JO": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "KW": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "LB": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "LY": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "MO": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "MR": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "OM": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "PH": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "PS": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "QA": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "SA": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "SD": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "SY": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "TN": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "YE": [
	        "h",
	        "hB",
	        "hb",
	        "H"
	    ],
	    "AF": [
	        "H",
	        "hb",
	        "hB",
	        "h"
	    ],
	    "LA": [
	        "H",
	        "hb",
	        "hB",
	        "h"
	    ],
	    "CN": [
	        "H",
	        "hB",
	        "hb",
	        "h"
	    ],
	    "LV": [
	        "H",
	        "hB",
	        "hb",
	        "h"
	    ],
	    "TL": [
	        "H",
	        "hB",
	        "hb",
	        "h"
	    ],
	    "zu-ZA": [
	        "H",
	        "hB",
	        "hb",
	        "h"
	    ],
	    "CD": [
	        "hB",
	        "H"
	    ],
	    "IR": [
	        "hB",
	        "H"
	    ],
	    "hi-IN": [
	        "hB",
	        "h",
	        "H"
	    ],
	    "kn-IN": [
	        "hB",
	        "h",
	        "H"
	    ],
	    "ml-IN": [
	        "hB",
	        "h",
	        "H"
	    ],
	    "te-IN": [
	        "hB",
	        "h",
	        "H"
	    ],
	    "KH": [
	        "hB",
	        "h",
	        "H",
	        "hb"
	    ],
	    "ta-IN": [
	        "hB",
	        "h",
	        "hb",
	        "H"
	    ],
	    "BN": [
	        "hb",
	        "hB",
	        "h",
	        "H"
	    ],
	    "MY": [
	        "hb",
	        "hB",
	        "h",
	        "H"
	    ],
	    "ET": [
	        "hB",
	        "hb",
	        "h",
	        "H"
	    ],
	    "gu-IN": [
	        "hB",
	        "hb",
	        "h",
	        "H"
	    ],
	    "mr-IN": [
	        "hB",
	        "hb",
	        "h",
	        "H"
	    ],
	    "pa-IN": [
	        "hB",
	        "hb",
	        "h",
	        "H"
	    ],
	    "TW": [
	        "hB",
	        "hb",
	        "h",
	        "H"
	    ],
	    "KE": [
	        "hB",
	        "hb",
	        "H",
	        "h"
	    ],
	    "MM": [
	        "hB",
	        "hb",
	        "H",
	        "h"
	    ],
	    "TZ": [
	        "hB",
	        "hb",
	        "H",
	        "h"
	    ],
	    "UG": [
	        "hB",
	        "hb",
	        "H",
	        "h"
	    ]
	};


/***/ },
/* 250 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parseDateTimeSkeleton = void 0;
	/**
	 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
	 * with some tweaks
	 */
	var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	/**
	 * Parse Date time skeleton into Intl.DateTimeFormatOptions
	 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * @public
	 * @param skeleton skeleton string
	 */
	function parseDateTimeSkeleton(skeleton) {
	    var result = {};
	    skeleton.replace(DATE_TIME_REGEX, function (match) {
	        var len = match.length;
	        switch (match[0]) {
	            // Era
	            case 'G':
	                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
	                break;
	            // Year
	            case 'y':
	                result.year = len === 2 ? '2-digit' : 'numeric';
	                break;
	            case 'Y':
	            case 'u':
	            case 'U':
	            case 'r':
	                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
	            // Quarter
	            case 'q':
	            case 'Q':
	                throw new RangeError('`q/Q` (quarter) patterns are not supported');
	            // Month
	            case 'M':
	            case 'L':
	                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
	                break;
	            // Week
	            case 'w':
	            case 'W':
	                throw new RangeError('`w/W` (week) patterns are not supported');
	            case 'd':
	                result.day = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'D':
	            case 'F':
	            case 'g':
	                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
	            // Weekday
	            case 'E':
	                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
	                break;
	            case 'e':
	                if (len < 4) {
	                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
	                }
	                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                break;
	            case 'c':
	                if (len < 4) {
	                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
	                }
	                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                break;
	            // Period
	            case 'a': // AM, PM
	                result.hour12 = true;
	                break;
	            case 'b': // am, pm, noon, midnight
	            case 'B': // flexible day periods
	                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
	            // Hour
	            case 'h':
	                result.hourCycle = 'h12';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'H':
	                result.hourCycle = 'h23';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'K':
	                result.hourCycle = 'h11';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'k':
	                result.hourCycle = 'h24';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'j':
	            case 'J':
	            case 'C':
	                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
	            // Minute
	            case 'm':
	                result.minute = ['numeric', '2-digit'][len - 1];
	                break;
	            // Second
	            case 's':
	                result.second = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'S':
	            case 'A':
	                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
	            // Zone
	            case 'z': // 1..3, 4: specific non-location format
	                result.timeZoneName = len < 4 ? 'short' : 'long';
	                break;
	            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	            case 'O': // 1, 4: miliseconds in day short, long
	            case 'v': // 1, 4: generic non-location format
	            case 'V': // 1, 2, 3, 4: time zone ID or city
	            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
	                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
	        }
	        return '';
	    });
	    return result;
	}
	exports.parseDateTimeSkeleton = parseDateTimeSkeleton;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(136);
	(0, tslib_1.__exportStar)(__webpack_require__(250), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(252), exports);


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parseNumberSkeleton = exports.parseNumberSkeletonFromString = void 0;
	var tslib_1 = __webpack_require__(136);
	var regex_generated_1 = __webpack_require__(253);
	function parseNumberSkeletonFromString(skeleton) {
	    if (skeleton.length === 0) {
	        throw new Error('Number skeleton cannot be empty');
	    }
	    // Parse the skeleton
	    var stringTokens = skeleton
	        .split(regex_generated_1.WHITE_SPACE_REGEX)
	        .filter(function (x) { return x.length > 0; });
	    var tokens = [];
	    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
	        var stringToken = stringTokens_1[_i];
	        var stemAndOptions = stringToken.split('/');
	        if (stemAndOptions.length === 0) {
	            throw new Error('Invalid number skeleton');
	        }
	        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
	        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
	            var option = options_1[_a];
	            if (option.length === 0) {
	                throw new Error('Invalid number skeleton');
	            }
	        }
	        tokens.push({ stem: stem, options: options });
	    }
	    return tokens;
	}
	exports.parseNumberSkeletonFromString = parseNumberSkeletonFromString;
	function icuUnitToEcma(unit) {
	    return unit.replace(/^(.*?)-/, '');
	}
	var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
	var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
	var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
	var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
	function parseSignificantPrecision(str) {
	    var result = {};
	    if (str[str.length - 1] === 'r') {
	        result.roundingPriority = 'morePrecision';
	    }
	    else if (str[str.length - 1] === 's') {
	        result.roundingPriority = 'lessPrecision';
	    }
	    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
	        // @@@ case
	        if (typeof g2 !== 'string') {
	            result.minimumSignificantDigits = g1.length;
	            result.maximumSignificantDigits = g1.length;
	        }
	        // @@@+ case
	        else if (g2 === '+') {
	            result.minimumSignificantDigits = g1.length;
	        }
	        // .### case
	        else if (g1[0] === '#') {
	            result.maximumSignificantDigits = g1.length;
	        }
	        // .@@## or .@@@ case
	        else {
	            result.minimumSignificantDigits = g1.length;
	            result.maximumSignificantDigits =
	                g1.length + (typeof g2 === 'string' ? g2.length : 0);
	        }
	        return '';
	    });
	    return result;
	}
	function parseSign(str) {
	    switch (str) {
	        case 'sign-auto':
	            return {
	                signDisplay: 'auto',
	            };
	        case 'sign-accounting':
	        case '()':
	            return {
	                currencySign: 'accounting',
	            };
	        case 'sign-always':
	        case '+!':
	            return {
	                signDisplay: 'always',
	            };
	        case 'sign-accounting-always':
	        case '()!':
	            return {
	                signDisplay: 'always',
	                currencySign: 'accounting',
	            };
	        case 'sign-except-zero':
	        case '+?':
	            return {
	                signDisplay: 'exceptZero',
	            };
	        case 'sign-accounting-except-zero':
	        case '()?':
	            return {
	                signDisplay: 'exceptZero',
	                currencySign: 'accounting',
	            };
	        case 'sign-never':
	        case '+_':
	            return {
	                signDisplay: 'never',
	            };
	    }
	}
	function parseConciseScientificAndEngineeringStem(stem) {
	    // Engineering
	    var result;
	    if (stem[0] === 'E' && stem[1] === 'E') {
	        result = {
	            notation: 'engineering',
	        };
	        stem = stem.slice(2);
	    }
	    else if (stem[0] === 'E') {
	        result = {
	            notation: 'scientific',
	        };
	        stem = stem.slice(1);
	    }
	    if (result) {
	        var signDisplay = stem.slice(0, 2);
	        if (signDisplay === '+!') {
	            result.signDisplay = 'always';
	            stem = stem.slice(2);
	        }
	        else if (signDisplay === '+?') {
	            result.signDisplay = 'exceptZero';
	            stem = stem.slice(2);
	        }
	        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
	            throw new Error('Malformed concise eng/scientific notation');
	        }
	        result.minimumIntegerDigits = stem.length;
	    }
	    return result;
	}
	function parseNotationOptions(opt) {
	    var result = {};
	    var signOpts = parseSign(opt);
	    if (signOpts) {
	        return signOpts;
	    }
	    return result;
	}
	/**
	 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
	 */
	function parseNumberSkeleton(tokens) {
	    var result = {};
	    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
	        var token = tokens_1[_i];
	        switch (token.stem) {
	            case 'percent':
	            case '%':
	                result.style = 'percent';
	                continue;
	            case '%x100':
	                result.style = 'percent';
	                result.scale = 100;
	                continue;
	            case 'currency':
	                result.style = 'currency';
	                result.currency = token.options[0];
	                continue;
	            case 'group-off':
	            case ',_':
	                result.useGrouping = false;
	                continue;
	            case 'precision-integer':
	            case '.':
	                result.maximumFractionDigits = 0;
	                continue;
	            case 'measure-unit':
	            case 'unit':
	                result.style = 'unit';
	                result.unit = icuUnitToEcma(token.options[0]);
	                continue;
	            case 'compact-short':
	            case 'K':
	                result.notation = 'compact';
	                result.compactDisplay = 'short';
	                continue;
	            case 'compact-long':
	            case 'KK':
	                result.notation = 'compact';
	                result.compactDisplay = 'long';
	                continue;
	            case 'scientific':
	                result = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, all), parseNotationOptions(opt))); }, {}));
	                continue;
	            case 'engineering':
	                result = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, all), parseNotationOptions(opt))); }, {}));
	                continue;
	            case 'notation-simple':
	                result.notation = 'standard';
	                continue;
	            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
	            case 'unit-width-narrow':
	                result.currencyDisplay = 'narrowSymbol';
	                result.unitDisplay = 'narrow';
	                continue;
	            case 'unit-width-short':
	                result.currencyDisplay = 'code';
	                result.unitDisplay = 'short';
	                continue;
	            case 'unit-width-full-name':
	                result.currencyDisplay = 'name';
	                result.unitDisplay = 'long';
	                continue;
	            case 'unit-width-iso-code':
	                result.currencyDisplay = 'symbol';
	                continue;
	            case 'scale':
	                result.scale = parseFloat(token.options[0]);
	                continue;
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	            case 'integer-width':
	                if (token.options.length > 1) {
	                    throw new RangeError('integer-width stems only accept a single optional option');
	                }
	                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
	                    if (g1) {
	                        result.minimumIntegerDigits = g2.length;
	                    }
	                    else if (g3 && g4) {
	                        throw new Error('We currently do not support maximum integer digits');
	                    }
	                    else if (g5) {
	                        throw new Error('We currently do not support exact integer digits');
	                    }
	                    return '';
	                });
	                continue;
	        }
	        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
	        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
	            result.minimumIntegerDigits = token.stem.length;
	            continue;
	        }
	        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
	            // Precision
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
	            // precision-integer case
	            if (token.options.length > 1) {
	                throw new RangeError('Fraction-precision stems only accept a single optional option');
	            }
	            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
	                // .000* case (before ICU67 it was .000+)
	                if (g2 === '*') {
	                    result.minimumFractionDigits = g1.length;
	                }
	                // .### case
	                else if (g3 && g3[0] === '#') {
	                    result.maximumFractionDigits = g3.length;
	                }
	                // .00## case
	                else if (g4 && g5) {
	                    result.minimumFractionDigits = g4.length;
	                    result.maximumFractionDigits = g4.length + g5.length;
	                }
	                else {
	                    result.minimumFractionDigits = g1.length;
	                    result.maximumFractionDigits = g1.length;
	                }
	                return '';
	            });
	            var opt = token.options[0];
	            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
	            if (opt === 'w') {
	                result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
	            }
	            else if (opt) {
	                result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), parseSignificantPrecision(opt));
	            }
	            continue;
	        }
	        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
	        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
	            result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), parseSignificantPrecision(token.stem));
	            continue;
	        }
	        var signOpts = parseSign(token.stem);
	        if (signOpts) {
	            result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), signOpts);
	        }
	        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
	        if (conciseScientificAndEngineeringOpts) {
	            result = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), conciseScientificAndEngineeringOpts);
	        }
	    }
	    return result;
	}
	exports.parseNumberSkeleton = parseNumberSkeleton;


/***/ },
/* 253 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.WHITE_SPACE_REGEX = void 0;
	// @generated from regex-gen.ts
	exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BestFitMatcher = void 0;
	var BestAvailableLocale_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(47);
	/**
	 * https://tc39.es/ecma402/#sec-bestfitmatcher
	 * @param availableLocales
	 * @param requestedLocales
	 * @param getDefaultLocale
	 */
	function BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
	    var minimizedAvailableLocaleMap = {};
	    var availableLocaleMap = {};
	    var canonicalizedLocaleMap = {};
	    var minimizedAvailableLocales = new Set();
	    availableLocales.forEach(function (locale) {
	        var minimizedLocale = new Intl.Locale(locale)
	            .minimize()
	            .toString();
	        var canonicalizedLocale = Intl.getCanonicalLocales(locale)[0] || locale;
	        minimizedAvailableLocaleMap[minimizedLocale] = locale;
	        availableLocaleMap[locale] = locale;
	        canonicalizedLocaleMap[canonicalizedLocale] = locale;
	        minimizedAvailableLocales.add(minimizedLocale);
	        minimizedAvailableLocales.add(locale);
	        minimizedAvailableLocales.add(canonicalizedLocale);
	    });
	    var foundLocale;
	    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
	        var l = requestedLocales_1[_i];
	        if (foundLocale) {
	            break;
	        }
	        var noExtensionLocale = l.replace(utils_1.UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	        if (availableLocales.has(noExtensionLocale)) {
	            foundLocale = noExtensionLocale;
	            break;
	        }
	        if (minimizedAvailableLocales.has(noExtensionLocale)) {
	            foundLocale = noExtensionLocale;
	            break;
	        }
	        var locale = new Intl.Locale(noExtensionLocale);
	        var maximizedRequestedLocale = locale.maximize().toString();
	        var minimizedRequestedLocale = locale.minimize().toString();
	        // Check minimized locale
	        if (minimizedAvailableLocales.has(minimizedRequestedLocale)) {
	            foundLocale = minimizedRequestedLocale;
	            break;
	        }
	        // Lookup algo on maximized locale
	        foundLocale = (0, BestAvailableLocale_1.BestAvailableLocale)(minimizedAvailableLocales, maximizedRequestedLocale);
	    }
	    if (!foundLocale) {
	        return { locale: getDefaultLocale() };
	    }
	    return {
	        locale: availableLocaleMap[foundLocale] ||
	            canonicalizedLocaleMap[foundLocale] ||
	            minimizedAvailableLocaleMap[foundLocale] ||
	            foundLocale,
	    };
	}
	exports.BestFitMatcher = BestFitMatcher;


/***/ },
/* 255 */
118,
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LookupMatcher = void 0;
	var utils_1 = __webpack_require__(47);
	var BestAvailableLocale_1 = __webpack_require__(72);
	/**
	 * https://tc39.es/ecma402/#sec-lookupmatcher
	 * @param availableLocales
	 * @param requestedLocales
	 * @param getDefaultLocale
	 */
	function LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
	    var result = { locale: '' };
	    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
	        var locale = requestedLocales_1[_i];
	        var noExtensionLocale = locale.replace(utils_1.UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	        var availableLocale = (0, BestAvailableLocale_1.BestAvailableLocale)(availableLocales, noExtensionLocale);
	        if (availableLocale) {
	            result.locale = availableLocale;
	            if (locale !== noExtensionLocale) {
	                result.extension = locale.slice(noExtensionLocale.length + 1, locale.length);
	            }
	            return result;
	        }
	    }
	    result.locale = getDefaultLocale();
	    return result;
	}
	exports.LookupMatcher = LookupMatcher;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LookupSupportedLocales = void 0;
	var utils_1 = __webpack_require__(47);
	var BestAvailableLocale_1 = __webpack_require__(72);
	/**
	 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
	 * @param availableLocales
	 * @param requestedLocales
	 */
	function LookupSupportedLocales(availableLocales, requestedLocales) {
	    var subset = [];
	    for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
	        var locale = requestedLocales_1[_i];
	        var noExtensionLocale = locale.replace(utils_1.UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	        var availableLocale = (0, BestAvailableLocale_1.BestAvailableLocale)(availableLocales, noExtensionLocale);
	        if (availableLocale) {
	            subset.push(availableLocale);
	        }
	    }
	    return subset;
	}
	exports.LookupSupportedLocales = LookupSupportedLocales;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UnicodeExtensionValue = void 0;
	var utils_1 = __webpack_require__(47);
	/**
	 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
	 * @param extension
	 * @param key
	 */
	function UnicodeExtensionValue(extension, key) {
	    (0, utils_1.invariant)(key.length === 2, 'key must have 2 elements');
	    var size = extension.length;
	    var searchValue = "-".concat(key, "-");
	    var pos = extension.indexOf(searchValue);
	    if (pos !== -1) {
	        var start = pos + 4;
	        var end = start;
	        var k = start;
	        var done = false;
	        while (!done) {
	            var e = extension.indexOf('-', k);
	            var len = void 0;
	            if (e === -1) {
	                len = size - k;
	            }
	            else {
	                len = e - k;
	            }
	            if (len === 2) {
	                done = true;
	            }
	            else if (e === -1) {
	                end = size;
	                done = true;
	            }
	            else {
	                end = e;
	                k = e + 1;
	            }
	        }
	        return extension.slice(start, end);
	    }
	    searchValue = "-".concat(key);
	    pos = extension.indexOf(searchValue);
	    if (pos !== -1 && pos + 3 === size) {
	        return '';
	    }
	    return undefined;
	}
	exports.UnicodeExtensionValue = UnicodeExtensionValue;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createIntl = void 0;
	var tslib_1 = __webpack_require__(35);
	var utils_1 = __webpack_require__(33);
	var error_1 = __webpack_require__(25);
	var number_1 = __webpack_require__(143);
	var relativeTime_1 = __webpack_require__(145);
	var dateTime_1 = __webpack_require__(139);
	var plural_1 = __webpack_require__(144);
	var message_1 = __webpack_require__(142);
	var list_1 = __webpack_require__(141);
	var displayName_1 = __webpack_require__(140);
	function messagesContainString(messages) {
	    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
	    return typeof firstMessage === 'string';
	}
	function verifyConfigMessages(config) {
	    if (config.onWarn &&
	        config.defaultRichTextElements &&
	        messagesContainString(config.messages || {})) {
	        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
	    }
	}
	/**
	 * Create intl object
	 * @param config intl config
	 * @param cache cache for formatter instances to prevent memory leak
	 */
	function createIntl(config, cache) {
	    var formatters = (0, utils_1.createFormatters)(cache);
	    var resolvedConfig = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, utils_1.DEFAULT_INTL_CONFIG), config);
	    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
	    if (!locale) {
	        if (onError) {
	            onError(new error_1.InvalidConfigError("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
	        }
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
	    }
	    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
	        onError(new error_1.MissingDataError("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
	    }
	    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
	        onError) {
	        onError(new error_1.MissingDataError("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
	    }
	    verifyConfigMessages(resolvedConfig);
	    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, resolvedConfig), { formatters: formatters, formatNumber: number_1.formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: number_1.formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: relativeTime_1.formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: dateTime_1.formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: dateTime_1.formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: dateTime_1.formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: dateTime_1.formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: dateTime_1.formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: plural_1.formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: message_1.formatMessage.bind(null, resolvedConfig, formatters), $t: message_1.formatMessage.bind(null, resolvedConfig, formatters), formatList: list_1.formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: list_1.formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: displayName_1.formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
	}
	exports.createIntl = createIntl;


/***/ },
/* 260 */
241,
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	var eventbuilder_1 = __webpack_require__(74);
	var transports_1 = __webpack_require__(148);
	/**
	 * The Sentry Browser SDK Backend.
	 * @hidden
	 */
	var BrowserBackend = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserBackend, _super);
	    function BrowserBackend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromException = function (exception, hint) {
	        return eventbuilder_1.eventFromException(this._options, exception, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
	        if (level === void 0) { level = types_1.Severity.Info; }
	        return eventbuilder_1.eventFromMessage(this._options, message, level, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype._setupTransport = function () {
	        if (!this._options.dsn) {
	            // We return the noop transport here in case there is no Dsn.
	            return _super.prototype._setupTransport.call(this);
	        }
	        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn });
	        if (this._options.transport) {
	            return new this._options.transport(transportOptions);
	        }
	        if (utils_1.supportsFetch()) {
	            return new transports_1.FetchTransport(transportOptions);
	        }
	        return new transports_1.XHRTransport(transportOptions);
	    };
	    return BrowserBackend;
	}(core_1.BaseBackend));
	exports.BrowserBackend = BrowserBackend;
	//# sourceMappingURL=backend.js.map

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(27);
	exports.Severity = types_1.Severity;
	exports.Status = types_1.Status;
	var core_1 = __webpack_require__(20);
	exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
	exports.addBreadcrumb = core_1.addBreadcrumb;
	exports.captureException = core_1.captureException;
	exports.captureEvent = core_1.captureEvent;
	exports.captureMessage = core_1.captureMessage;
	exports.configureScope = core_1.configureScope;
	exports.getHubFromCarrier = core_1.getHubFromCarrier;
	exports.getCurrentHub = core_1.getCurrentHub;
	exports.Hub = core_1.Hub;
	exports.makeMain = core_1.makeMain;
	exports.Scope = core_1.Scope;
	exports.startTransaction = core_1.startTransaction;
	exports.setContext = core_1.setContext;
	exports.setExtra = core_1.setExtra;
	exports.setExtras = core_1.setExtras;
	exports.setTag = core_1.setTag;
	exports.setTags = core_1.setTags;
	exports.setUser = core_1.setUser;
	exports.withScope = core_1.withScope;
	var client_1 = __webpack_require__(146);
	exports.BrowserClient = client_1.BrowserClient;
	var helpers_1 = __webpack_require__(48);
	exports.injectReportDialog = helpers_1.injectReportDialog;
	var eventbuilder_1 = __webpack_require__(74);
	exports.eventFromException = eventbuilder_1.eventFromException;
	exports.eventFromMessage = eventbuilder_1.eventFromMessage;
	var sdk_1 = __webpack_require__(268);
	exports.defaultIntegrations = sdk_1.defaultIntegrations;
	exports.forceLoad = sdk_1.forceLoad;
	exports.init = sdk_1.init;
	exports.lastEventId = sdk_1.lastEventId;
	exports.onLoad = sdk_1.onLoad;
	exports.showReportDialog = sdk_1.showReportDialog;
	exports.flush = sdk_1.flush;
	exports.close = sdk_1.close;
	exports.wrap = sdk_1.wrap;
	var version_1 = __webpack_require__(149);
	exports.SDK_NAME = version_1.SDK_NAME;
	exports.SDK_VERSION = version_1.SDK_VERSION;
	//# sourceMappingURL=exports.js.map

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable max-lines */
	var core_1 = __webpack_require__(20);
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	/**
	 * Default Breadcrumbs instrumentations
	 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
	 */
	var Breadcrumbs = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Breadcrumbs(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Breadcrumbs.id;
	        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
	    }
	    /**
	     * Create a breadcrumb of `sentry` from the events themselves
	     */
	    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
	        if (!this._options.sentry) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
	            event_id: event.event_id,
	            level: event.level,
	            message: utils_1.getEventDescription(event),
	        }, {
	            event: event,
	        });
	    };
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - Console API
	     *  - DOM API (click/typing)
	     *  - XMLHttpRequest API
	     *  - Fetch API
	     *  - History API
	     */
	    Breadcrumbs.prototype.setupOnce = function () {
	        var _this = this;
	        if (this._options.console) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._consoleBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'console',
	            });
	        }
	        if (this._options.dom) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._domBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'dom',
	            });
	        }
	        if (this._options.xhr) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._xhrBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'xhr',
	            });
	        }
	        if (this._options.fetch) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._fetchBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'fetch',
	            });
	        }
	        if (this._options.history) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._historyBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'history',
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from console API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
	        var breadcrumb = {
	            category: 'console',
	            data: {
	                arguments: handlerData.args,
	                logger: 'console',
	            },
	            level: types_1.Severity.fromString(handlerData.level),
	            message: utils_1.safeJoin(handlerData.args, ' '),
	        };
	        if (handlerData.level === 'assert') {
	            if (handlerData.args[0] === false) {
	                breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
	                breadcrumb.data.arguments = handlerData.args.slice(1);
	            }
	            else {
	                // Don't capture a breadcrumb for passed assertions
	                return;
	            }
	        }
	        core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
	            input: handlerData.args,
	            level: handlerData.level,
	        });
	    };
	    /**
	     * Creates breadcrumbs from DOM API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
	        var target;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            target = handlerData.event.target
	                ? utils_1.htmlTreeAsString(handlerData.event.target)
	                : utils_1.htmlTreeAsString(handlerData.event);
	        }
	        catch (e) {
	            target = '<unknown>';
	        }
	        if (target.length === 0) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "ui." + handlerData.name,
	            message: target,
	        }, {
	            event: handlerData.event,
	            name: handlerData.name,
	        });
	    };
	    /**
	     * Creates breadcrumbs from XHR API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
	        if (handlerData.endTimestamp) {
	            // We only capture complete, non-sentry requests
	            if (handlerData.xhr.__sentry_own_request__) {
	                return;
	            }
	            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'xhr',
	                data: {
	                    method: method,
	                    url: url,
	                    status_code: status_code,
	                },
	                type: 'http',
	            }, {
	                xhr: handlerData.xhr,
	                input: body,
	            });
	            return;
	        }
	    };
	    /**
	     * Creates breadcrumbs from fetch API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
	        // We only capture complete fetch requests
	        if (!handlerData.endTimestamp) {
	            return;
	        }
	        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
	            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
	            return;
	        }
	        if (handlerData.error) {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: handlerData.fetchData,
	                level: types_1.Severity.Error,
	                type: 'http',
	            }, {
	                data: handlerData.error,
	                input: handlerData.args,
	            });
	        }
	        else {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
	                type: 'http',
	            }, {
	                input: handlerData.args,
	                response: handlerData.response,
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from history API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
	        var global = utils_1.getGlobalObject();
	        var from = handlerData.from;
	        var to = handlerData.to;
	        var parsedLoc = utils_1.parseUrl(global.location.href);
	        var parsedFrom = utils_1.parseUrl(from);
	        var parsedTo = utils_1.parseUrl(to);
	        // Initial pushState doesn't provide `from` information
	        if (!parsedFrom.path) {
	            parsedFrom = parsedLoc;
	        }
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
	            to = parsedTo.relative;
	        }
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
	            from = parsedFrom.relative;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'navigation',
	            data: {
	                from: from,
	                to: to,
	            },
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Breadcrumbs.id = 'Breadcrumbs';
	    return Breadcrumbs;
	}());
	exports.Breadcrumbs = Breadcrumbs;
	//# sourceMappingURL=breadcrumbs.js.map

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	var core_1 = __webpack_require__(20);
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	var eventbuilder_1 = __webpack_require__(74);
	var helpers_1 = __webpack_require__(48);
	/** Global handlers */
	var GlobalHandlers = /** @class */ (function () {
	    /** JSDoc */
	    function GlobalHandlers(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = GlobalHandlers.id;
	        /** JSDoc */
	        this._onErrorHandlerInstalled = false;
	        /** JSDoc */
	        this._onUnhandledRejectionHandlerInstalled = false;
	        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.prototype.setupOnce = function () {
	        Error.stackTraceLimit = 50;
	        if (this._options.onerror) {
	            utils_1.logger.log('Global Handler attached: onerror');
	            this._installGlobalOnErrorHandler();
	        }
	        if (this._options.onunhandledrejection) {
	            utils_1.logger.log('Global Handler attached: onunhandledrejection');
	            this._installGlobalOnUnhandledRejectionHandler();
	        }
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
	        var _this = this;
	        if (this._onErrorHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (data) {
	                var error = data.error;
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
	                    : _this._enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: false,
	                    }), data.url, data.line, data.column);
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onerror',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	            },
	            type: 'error',
	        });
	        this._onErrorHandlerInstalled = true;
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
	        var _this = this;
	        if (this._onUnhandledRejectionHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (e) {
	                var error = e;
	                // dig the object of the rejection out of known event types
	                try {
	                    // PromiseRejectionEvents store the object of the rejection under 'reason'
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	                    if ('reason' in e) {
	                        error = e.reason;
	                    }
	                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	                    // https://github.com/getsentry/sentry-javascript/issues/2380
	                    else if ('detail' in e && 'reason' in e.detail) {
	                        error = e.detail.reason;
	                    }
	                }
	                catch (_oO) {
	                    // no-empty
	                }
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return true;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromRejectionWithPrimitive(error)
	                    : eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: true,
	                    });
	                event.level = types_1.Severity.Error;
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onunhandledrejection',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	                return;
	            },
	            type: 'unhandledrejection',
	        });
	        this._onUnhandledRejectionHandlerInstalled = true;
	    };
	    /**
	     * This function creates a stack from an old, error-less onerror handler.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
	        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
	        // If 'message' is ErrorEvent, get real message from inside
	        var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
	        var name;
	        if (utils_1.isString(message)) {
	            var groups = message.match(ERROR_TYPES_RE);
	            if (groups) {
	                name = groups[1];
	                message = groups[2];
	            }
	        }
	        var event = {
	            exception: {
	                values: [
	                    {
	                        type: name || 'Error',
	                        value: message,
	                    },
	                ],
	            },
	        };
	        return this._enhanceEventWithInitialFrame(event, url, line, column);
	    };
	    /**
	     * Create an event from a promise rejection where the `reason` is a primitive.
	     *
	     * @param reason: The `reason` property of the promise rejection
	     * @returns An Event object with an appropriate `exception` value
	     */
	    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
	        return {
	            exception: {
	                values: [
	                    {
	                        type: 'UnhandledRejection',
	                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
	                        value: "Non-Error promise rejection captured with value: " + String(reason),
	                    },
	                ],
	            },
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
	        event.exception = event.exception || {};
	        event.exception.values = event.exception.values || [];
	        event.exception.values[0] = event.exception.values[0] || {};
	        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
	        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
	        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
	        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
	        var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
	        if (event.exception.values[0].stacktrace.frames.length === 0) {
	            event.exception.values[0].stacktrace.frames.push({
	                colno: colno,
	                filename: filename,
	                function: '?',
	                in_app: true,
	                lineno: lineno,
	            });
	        }
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.id = 'GlobalHandlers';
	    return GlobalHandlers;
	}());
	exports.GlobalHandlers = GlobalHandlers;
	//# sourceMappingURL=globalhandlers.js.map

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var parsers_1 = __webpack_require__(147);
	var tracekit_1 = __webpack_require__(76);
	var DEFAULT_KEY = 'cause';
	var DEFAULT_LIMIT = 5;
	/** Adds SDK info to an event. */
	var LinkedErrors = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function LinkedErrors(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = LinkedErrors.id;
	        this._key = options.key || DEFAULT_KEY;
	        this._limit = options.limit || DEFAULT_LIMIT;
	    }
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event, hint) {
	            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
	            if (self) {
	                return self._handler(event, hint);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._handler = function (event, hint) {
	        if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
	            return event;
	        }
	        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
	        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
	        if (stack === void 0) { stack = []; }
	        if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= this._limit) {
	            return stack;
	        }
	        var stacktrace = tracekit_1.computeStackTrace(error[key]);
	        var exception = parsers_1.exceptionFromStacktrace(stacktrace);
	        return this._walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.id = 'LinkedErrors';
	    return LinkedErrors;
	}());
	exports.LinkedErrors = LinkedErrors;
	//# sourceMappingURL=linkederrors.js.map

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	var helpers_1 = __webpack_require__(48);
	var DEFAULT_EVENT_TARGET = [
	    'EventTarget',
	    'Window',
	    'Node',
	    'ApplicationCache',
	    'AudioTrackList',
	    'ChannelMergerNode',
	    'CryptoOperation',
	    'EventSource',
	    'FileReader',
	    'HTMLUnknownElement',
	    'IDBDatabase',
	    'IDBRequest',
	    'IDBTransaction',
	    'KeyOperation',
	    'MediaController',
	    'MessagePort',
	    'ModalWindow',
	    'Notification',
	    'SVGElementInstance',
	    'Screen',
	    'TextTrack',
	    'TextTrackCue',
	    'TextTrackList',
	    'WebSocket',
	    'WebSocketWorker',
	    'Worker',
	    'XMLHttpRequest',
	    'XMLHttpRequestEventTarget',
	    'XMLHttpRequestUpload',
	];
	/** Wrap timer functions and event targets to catch errors and provide better meta data */
	var TryCatch = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function TryCatch(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = TryCatch.id;
	        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
	    }
	    /**
	     * Wrap timer functions and event targets to catch errors
	     * and provide better metadata.
	     */
	    TryCatch.prototype.setupOnce = function () {
	        var global = utils_1.getGlobalObject();
	        if (this._options.setTimeout) {
	            utils_1.fill(global, 'setTimeout', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.setInterval) {
	            utils_1.fill(global, 'setInterval', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.requestAnimationFrame) {
	            utils_1.fill(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
	        }
	        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
	            utils_1.fill(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
	        }
	        if (this._options.eventTarget) {
	            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
	            eventTarget.forEach(this._wrapEventTarget.bind(this));
	        }
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapTimeFunction = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var originalCallback = args[0];
	            args[0] = helpers_1.wrap(originalCallback, {
	                mechanism: {
	                    data: { function: utils_1.getFunctionName(original) },
	                    handled: true,
	                    type: 'instrument',
	                },
	            });
	            return original.apply(this, args);
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    TryCatch.prototype._wrapRAF = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function (callback) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return original.call(this, helpers_1.wrap(callback, {
	                mechanism: {
	                    data: {
	                        function: 'requestAnimationFrame',
	                        handler: utils_1.getFunctionName(original),
	                    },
	                    handled: true,
	                    type: 'instrument',
	                },
	            }));
	        };
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapEventTarget = function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var global = utils_1.getGlobalObject();
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        utils_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    if (typeof fn.handleEvent === 'function') {
	                        fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
	                            mechanism: {
	                                data: {
	                                    function: 'handleEvent',
	                                    handler: utils_1.getFunctionName(fn),
	                                    target: target,
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        });
	                    }
	                }
	                catch (err) {
	                    // can sometimes get 'Permission denied to access property "handle Event'
	                }
	                return original.call(this, eventName, 
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                helpers_1.wrap(fn, {
	                    mechanism: {
	                        data: {
	                            function: 'addEventListener',
	                            handler: utils_1.getFunctionName(fn),
	                            target: target,
	                        },
	                        handled: true,
	                        type: 'instrument',
	                    },
	                }), options);
	            };
	        });
	        utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (eventName, fn, options) {
	                var _a;
	                /**
	                 * There are 2 possible scenarios here:
	                 *
	                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
	                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
	                 * as a pass-through, and call original `removeEventListener` with it.
	                 *
	                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
	                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
	                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
	                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
	                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
	                 *
	                 * When someone adds a handler prior to initialization, and then do it again, but after,
	                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
	                 * to get rid of the initial handler and it'd stick there forever.
	                 */
	                var wrappedEventHandler = fn;
	                try {
	                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
	                    if (originalEventHandler) {
	                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
	                    }
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
	            };
	        });
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapXHR = function (originalSend) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
	            xmlHttpRequestProps.forEach(function (prop) {
	                if (prop in xhr && typeof xhr[prop] === 'function') {
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    utils_1.fill(xhr, prop, function (original) {
	                        var wrapOptions = {
	                            mechanism: {
	                                data: {
	                                    function: prop,
	                                    handler: utils_1.getFunctionName(original),
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        };
	                        // If Instrument integration has been called before TryCatch, get the name of original function
	                        if (original.__sentry_original__) {
	                            wrapOptions.mechanism.data.handler = utils_1.getFunctionName(original.__sentry_original__);
	                        }
	                        // Otherwise wrap directly
	                        return helpers_1.wrap(original, wrapOptions);
	                    });
	                }
	            });
	            return originalSend.apply(this, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    TryCatch.id = 'TryCatch';
	    return TryCatch;
	}());
	exports.TryCatch = TryCatch;
	//# sourceMappingURL=trycatch.js.map

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var global = utils_1.getGlobalObject();
	/** UserAgent */
	var UserAgent = /** @class */ (function () {
	    function UserAgent() {
	        /**
	         * @inheritDoc
	         */
	        this.name = UserAgent.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    UserAgent.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event) {
	            var _a, _b, _c;
	            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
	                // if none of the information we want exists, don't bother
	                if (!global.navigator && !global.location && !global.document) {
	                    return event;
	                }
	                // grab as much info as exists and add it to the event
	                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
	                var referrer = (global.document || {}).referrer;
	                var userAgent = (global.navigator || {}).userAgent;
	                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
	                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
	                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    UserAgent.id = 'UserAgent';
	    return UserAgent;
	}());
	exports.UserAgent = UserAgent;
	//# sourceMappingURL=useragent.js.map

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var client_1 = __webpack_require__(146);
	var helpers_1 = __webpack_require__(48);
	var integrations_1 = __webpack_require__(75);
	exports.defaultIntegrations = [
	    new core_1.Integrations.InboundFilters(),
	    new core_1.Integrations.FunctionToString(),
	    new integrations_1.TryCatch(),
	    new integrations_1.Breadcrumbs(),
	    new integrations_1.GlobalHandlers(),
	    new integrations_1.LinkedErrors(),
	    new integrations_1.UserAgent(),
	];
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * To use this SDK, call the {@link init} function as early as possible when
	 * loading the web page. To set context information or send manual events, use
	 * the provided methods.
	 *
	 * @example
	 *
	 * ```
	 *
	 * import { init } from '@sentry/browser';
	 *
	 * init({
	 *   dsn: '__DSN__',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { configureScope } from '@sentry/browser';
	 * configureScope((scope: Scope) => {
	 *   scope.setExtra({ battery: 0.7 });
	 *   scope.setTag({ user_mode: 'admin' });
	 *   scope.setUser({ id: '4711' });
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { addBreadcrumb } from '@sentry/browser';
	 * addBreadcrumb({
	 *   message: 'My Breadcrumb',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 *
	 * ```
	 *
	 * import * as Sentry from '@sentry/browser';
	 * Sentry.captureMessage('Hello, world!');
	 * Sentry.captureException(new Error('Good bye'));
	 * Sentry.captureEvent({
	 *   message: 'Manual',
	 *   stacktrace: [
	 *     // ...
	 *   ],
	 * });
	 * ```
	 *
	 * @see {@link BrowserOptions} for documentation on configuration options.
	 */
	function init(options) {
	    if (options === void 0) { options = {}; }
	    if (options.defaultIntegrations === undefined) {
	        options.defaultIntegrations = exports.defaultIntegrations;
	    }
	    if (options.release === undefined) {
	        var window_1 = utils_1.getGlobalObject();
	        // This supports the variable that sentry-webpack-plugin injects
	        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
	            options.release = window_1.SENTRY_RELEASE.id;
	        }
	    }
	    if (options.autoSessionTracking === undefined) {
	        options.autoSessionTracking = false;
	    }
	    core_1.initAndBind(client_1.BrowserClient, options);
	    if (options.autoSessionTracking) {
	        startSessionTracking();
	    }
	}
	exports.init = init;
	/**
	 * Present the user with a report dialog.
	 *
	 * @param options Everything is optional, we try to fetch all info need from the global scope.
	 */
	function showReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        options.eventId = core_1.getCurrentHub().lastEventId();
	    }
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        client.showReportDialog(options);
	    }
	}
	exports.showReportDialog = showReportDialog;
	/**
	 * This is the getter for lastEventId.
	 *
	 * @returns The last event id of a captured event.
	 */
	function lastEventId() {
	    return core_1.getCurrentHub().lastEventId();
	}
	exports.lastEventId = lastEventId;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function forceLoad() {
	    // Noop
	}
	exports.forceLoad = forceLoad;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function onLoad(callback) {
	    callback();
	}
	exports.onLoad = onLoad;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function flush(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.flush(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.flush = flush;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function close(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.close(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.close = close;
	/**
	 * Wrap code within a try/catch block so the SDK is able to capture errors.
	 *
	 * @param fn A function to wrap.
	 *
	 * @returns The result of wrapped function call.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function wrap(fn) {
	    return helpers_1.wrap(fn)();
	}
	exports.wrap = wrap;
	/**
	 * Enable automatic Session Tracking for the initial page load.
	 */
	function startSessionTracking() {
	    var window = utils_1.getGlobalObject();
	    var hub = core_1.getCurrentHub();
	    /**
	     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
	     * but, as always, it's not available in the IE10-11. Thanks IE.
	     */
	    var loadResolved = document.readyState === 'complete';
	    var fcpResolved = false;
	    var possiblyEndSession = function () {
	        if (fcpResolved && loadResolved) {
	            hub.endSession();
	        }
	    };
	    var resolveWindowLoaded = function () {
	        loadResolved = true;
	        possiblyEndSession();
	        window.removeEventListener('load', resolveWindowLoaded);
	    };
	    hub.startSession();
	    if (!loadResolved) {
	        // IE doesn't support `{ once: true }` for event listeners, so we have to manually
	        // attach and then detach it once completed.
	        window.addEventListener('load', resolveWindowLoaded);
	    }
	    try {
	        var po = new PerformanceObserver(function (entryList, po) {
	            entryList.getEntries().forEach(function (entry) {
	                if (entry.name === 'first-contentful-paint' && entry.startTime < firstHiddenTime_1) {
	                    po.disconnect();
	                    fcpResolved = true;
	                    possiblyEndSession();
	                }
	            });
	        });
	        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
	        // so we do it below here.
	        var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
	        document.addEventListener('visibilitychange', function (event) {
	            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
	        }, { once: true });
	        po.observe({
	            type: 'paint',
	            buffered: true,
	        });
	    }
	    catch (e) {
	        fcpResolved = true;
	        possiblyEndSession();
	    }
	}
	//# sourceMappingURL=sdk.js.map

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var base_1 = __webpack_require__(77);
	var global = utils_1.getGlobalObject();
	/** `fetch` based transport */
	var FetchTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(FetchTransport, _super);
	    function FetchTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        var options = {
	            body: sentryRequest.body,
	            method: 'POST',
	            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	            // https://caniuse.com/#feat=referrer-policy
	            // It doesn't. And it throw exception instead of ignoring this parameter...
	            // REF: https://github.com/getsentry/raven-js/issues/1233
	            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
	        };
	        if (this.options.fetchParameters !== undefined) {
	            Object.assign(options, this.options.fetchParameters);
	        }
	        if (this.options.headers !== undefined) {
	            options.headers = this.options.headers;
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            global
	                .fetch(sentryRequest.url, options)
	                .then(function (response) {
	                var headers = {
	                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                    'retry-after': response.headers.get('Retry-After'),
	                };
	                _this._handleResponse({
	                    requestType: sentryRequest.type,
	                    response: response,
	                    headers: headers,
	                    resolve: resolve,
	                    reject: reject,
	                });
	            })
	                .catch(reject);
	        }));
	    };
	    return FetchTransport;
	}(base_1.BaseTransport));
	exports.FetchTransport = FetchTransport;
	//# sourceMappingURL=fetch.js.map

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var core_1 = __webpack_require__(20);
	var utils_1 = __webpack_require__(9);
	var base_1 = __webpack_require__(77);
	/** `XHR` based transport */
	var XHRTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(XHRTransport, _super);
	    function XHRTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            var request = new XMLHttpRequest();
	            request.onreadystatechange = function () {
	                if (request.readyState === 4) {
	                    var headers = {
	                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
	                        'retry-after': request.getResponseHeader('Retry-After'),
	                    };
	                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
	                }
	            };
	            request.open('POST', sentryRequest.url);
	            for (var header in _this.options.headers) {
	                if (_this.options.headers.hasOwnProperty(header)) {
	                    request.setRequestHeader(header, _this.options.headers[header]);
	                }
	            }
	            request.send(sentryRequest.body);
	        }));
	    };
	    return XHRTransport;
	}(base_1.BaseTransport));
	exports.XHRTransport = XHRTransport;
	//# sourceMappingURL=xhr.js.map

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	var SENTRY_API_VERSION = '7';
	/** Helper class to provide urls to different Sentry endpoints. */
	var API = /** @class */ (function () {
	    /** Create a new instance of API */
	    function API(dsn) {
	        this.dsn = dsn;
	        this._dsnObject = new utils_1.Dsn(dsn);
	    }
	    /** Returns the Dsn object. */
	    API.prototype.getDsn = function () {
	        return this._dsnObject;
	    };
	    /** Returns the prefix to construct Sentry ingestion API endpoints. */
	    API.prototype.getBaseApiEndpoint = function () {
	        var dsn = this._dsnObject;
	        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
	        var port = dsn.port ? ":" + dsn.port : '';
	        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
	    };
	    /** Returns the store endpoint URL. */
	    API.prototype.getStoreEndpoint = function () {
	        return this._getIngestEndpoint('store');
	    };
	    /**
	     * Returns the store endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
	        return this.getStoreEndpoint() + "?" + this._encodedAuth();
	    };
	    /**
	     * Returns the envelope endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
	        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
	    };
	    /** Returns only the path component for the store endpoint. */
	    API.prototype.getStoreEndpointPath = function () {
	        var dsn = this._dsnObject;
	        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
	    };
	    /**
	     * Returns an object that can be used in request headers.
	     * This is needed for node and the old /store endpoint in sentry
	     */
	    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
	        var dsn = this._dsnObject;
	        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
	        header.push("sentry_client=" + clientName + "/" + clientVersion);
	        header.push("sentry_key=" + dsn.user);
	        if (dsn.pass) {
	            header.push("sentry_secret=" + dsn.pass);
	        }
	        return {
	            'Content-Type': 'application/json',
	            'X-Sentry-Auth': header.join(', '),
	        };
	    };
	    /** Returns the url to the report dialog endpoint. */
	    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
	        if (dialogOptions === void 0) { dialogOptions = {}; }
	        var dsn = this._dsnObject;
	        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
	        var encodedOptions = [];
	        encodedOptions.push("dsn=" + dsn.toString());
	        for (var key in dialogOptions) {
	            if (key === 'dsn') {
	                continue;
	            }
	            if (key === 'user') {
	                if (!dialogOptions.user) {
	                    continue;
	                }
	                if (dialogOptions.user.name) {
	                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
	                }
	                if (dialogOptions.user.email) {
	                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
	                }
	            }
	            else {
	                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
	            }
	        }
	        if (encodedOptions.length) {
	            return endpoint + "?" + encodedOptions.join('&');
	        }
	        return endpoint;
	    };
	    /** Returns the envelope endpoint URL. */
	    API.prototype._getEnvelopeEndpoint = function () {
	        return this._getIngestEndpoint('envelope');
	    };
	    /** Returns the ingest API endpoint for target. */
	    API.prototype._getIngestEndpoint = function (target) {
	        var base = this.getBaseApiEndpoint();
	        var dsn = this._dsnObject;
	        return "" + base + dsn.projectId + "/" + target + "/";
	    };
	    /** Returns a URL-encoded string with auth config suitable for a query string. */
	    API.prototype._encodedAuth = function () {
	        var dsn = this._dsnObject;
	        var auth = {
	            // We send only the minimum set of required information. See
	            // https://github.com/getsentry/sentry-javascript/issues/2572.
	            sentry_key: dsn.user,
	            sentry_version: SENTRY_API_VERSION,
	        };
	        return utils_1.urlEncode(auth);
	    };
	    return API;
	}());
	exports.API = API;
	//# sourceMappingURL=api.js.map

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	var noop_1 = __webpack_require__(150);
	/**
	 * This is the base implemention of a Backend.
	 * @hidden
	 */
	var BaseBackend = /** @class */ (function () {
	    /** Creates a new backend instance. */
	    function BaseBackend(options) {
	        this._options = options;
	        if (!this._options.dsn) {
	            utils_1.logger.warn('No DSN provided, backend will not do anything.');
	        }
	        this._transport = this._setupTransport();
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendEvent = function (event) {
	        this._transport.sendEvent(event).then(null, function (reason) {
	            utils_1.logger.error("Error while sending event: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendSession = function (session) {
	        if (!this._transport.sendSession) {
	            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        this._transport.sendSession(session).then(null, function (reason) {
	            utils_1.logger.error("Error while sending session: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.getTransport = function () {
	        return this._transport;
	    };
	    /**
	     * Sets up the transport so it can be used later to send requests.
	     */
	    BaseBackend.prototype._setupTransport = function () {
	        return new noop_1.NoopTransport();
	    };
	    return BaseBackend;
	}());
	exports.BaseBackend = BaseBackend;
	//# sourceMappingURL=basebackend.js.map

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	/* eslint-disable max-lines */
	var hub_1 = __webpack_require__(26);
	var types_1 = __webpack_require__(27);
	var utils_1 = __webpack_require__(9);
	var integration_1 = __webpack_require__(274);
	/**
	 * Base implementation for all JavaScript SDK clients.
	 *
	 * Call the constructor with the corresponding backend constructor and options
	 * specific to the client subclass. To access these options later, use
	 * {@link Client.getOptions}. Also, the Backend instance is available via
	 * {@link Client.getBackend}.
	 *
	 * If a Dsn is specified in the options, it will be parsed and stored. Use
	 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
	 * invalid, the constructor will throw a {@link SentryException}. Note that
	 * without a valid Dsn, the SDK will not send any events to Sentry.
	 *
	 * Before sending an event via the backend, it is passed through
	 * {@link BaseClient.prepareEvent} to add SDK information and scope data
	 * (breadcrumbs and context). To add more custom information, override this
	 * method and extend the resulting prepared event.
	 *
	 * To issue automatically created events (e.g. via instrumentation), use
	 * {@link Client.captureEvent}. It will prepare the event and pass it through
	 * the callback lifecycle. To issue auto-breadcrumbs, use
	 * {@link Client.addBreadcrumb}.
	 *
	 * @example
	 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
	 *   public constructor(options: NodeOptions) {
	 *     super(NodeBackend, options);
	 *   }
	 *
	 *   // ...
	 * }
	 */
	var BaseClient = /** @class */ (function () {
	    /**
	     * Initializes this client instance.
	     *
	     * @param backendClass A constructor function to create the backend.
	     * @param options Options for the client.
	     */
	    function BaseClient(backendClass, options) {
	        /** Array of used integrations. */
	        this._integrations = {};
	        /** Number of call being processed */
	        this._processing = 0;
	        this._backend = new backendClass(options);
	        this._options = options;
	        if (options.dsn) {
	            this._dsn = new utils_1.Dsn(options.dsn);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseClient.prototype.captureException = function (exception, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        this._process(this._getBackend()
	            .eventFromException(exception, hint)
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        var promisedEvent = utils_1.isPrimitive(message)
	            ? this._getBackend().eventFromMessage(String(message), level, hint)
	            : this._getBackend().eventFromException(message, hint);
	        this._process(promisedEvent
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureEvent = function (event, hint, scope) {
	        var eventId = hint && hint.event_id;
	        this._process(this._captureEvent(event, hint, scope).then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureSession = function (session) {
	        if (!session.release) {
	            utils_1.logger.warn('Discarded session because of missing release');
	        }
	        else {
	            this._sendSession(session);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getDsn = function () {
	        return this._dsn;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getOptions = function () {
	        return this._options;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.flush = function (timeout) {
	        var _this = this;
	        return this._isClientProcessing(timeout).then(function (ready) {
	            return _this._getBackend()
	                .getTransport()
	                .close(timeout)
	                .then(function (transportFlushed) { return ready && transportFlushed; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.close = function (timeout) {
	        var _this = this;
	        return this.flush(timeout).then(function (result) {
	            _this.getOptions().enabled = false;
	            return result;
	        });
	    };
	    /**
	     * Sets up the integrations
	     */
	    BaseClient.prototype.setupIntegrations = function () {
	        if (this._isEnabled()) {
	            this._integrations = integration_1.setupIntegrations(this._options);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getIntegration = function (integration) {
	        try {
	            return this._integrations[integration.id] || null;
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
	            return null;
	        }
	    };
	    /** Updates existing session based on the provided event */
	    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
	        var e_1, _a;
	        var crashed = false;
	        var errored = false;
	        var userAgent;
	        var exceptions = event.exception && event.exception.values;
	        if (exceptions) {
	            errored = true;
	            try {
	                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
	                    var ex = exceptions_1_1.value;
	                    var mechanism = ex.mechanism;
	                    if (mechanism && mechanism.handled === false) {
	                        crashed = true;
	                        break;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        var user = event.user;
	        if (!session.userAgent) {
	            var headers = event.request ? event.request.headers : {};
	            for (var key in headers) {
	                if (key.toLowerCase() === 'user-agent') {
	                    userAgent = headers[key];
	                    break;
	                }
	            }
	        }
	        session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: types_1.SessionStatus.Crashed })), { user: user,
	            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
	    };
	    /** Deliver captured session to Sentry */
	    BaseClient.prototype._sendSession = function (session) {
	        this._getBackend().sendSession(session);
	    };
	    /** Waits for the client to be done with processing. */
	    BaseClient.prototype._isClientProcessing = function (timeout) {
	        var _this = this;
	        return new utils_1.SyncPromise(function (resolve) {
	            var ticked = 0;
	            var tick = 1;
	            var interval = setInterval(function () {
	                if (_this._processing == 0) {
	                    clearInterval(interval);
	                    resolve(true);
	                }
	                else {
	                    ticked += tick;
	                    if (timeout && ticked >= timeout) {
	                        clearInterval(interval);
	                        resolve(false);
	                    }
	                }
	            }, tick);
	        });
	    };
	    /** Returns the current backend. */
	    BaseClient.prototype._getBackend = function () {
	        return this._backend;
	    };
	    /** Determines whether this SDK is enabled and a valid Dsn is present. */
	    BaseClient.prototype._isEnabled = function () {
	        return this.getOptions().enabled !== false && this._dsn !== undefined;
	    };
	    /**
	     * Adds common information to events.
	     *
	     * The information includes release and environment from `options`,
	     * breadcrumbs and context (extra, tags and user) from the scope.
	     *
	     * Information that is already present in the event is never overwritten. For
	     * nested objects, such as the context, keys are merged.
	     *
	     * @param event The original event.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A new event with more information.
	     */
	    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
	        var _this = this;
	        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
	        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
	        this._applyClientOptions(prepared);
	        this._applyIntegrationsMetadata(prepared);
	        // If we have scope given to us, use it as the base for further modifications.
	        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
	        var finalScope = scope;
	        if (hint && hint.captureContext) {
	            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
	        }
	        // We prepare the result here with a resolved Event.
	        var result = utils_1.SyncPromise.resolve(prepared);
	        // This should be the last thing called, since we want that
	        // {@link Hub.addEventProcessor} gets the finished prepared event.
	        if (finalScope) {
	            // In case we have a hub we reassign it.
	            result = finalScope.applyToEvent(prepared, hint);
	        }
	        return result.then(function (evt) {
	            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
	                return _this._normalizeEvent(evt, normalizeDepth);
	            }
	            return evt;
	        });
	    };
	    /**
	     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
	     * Normalized keys:
	     * - `breadcrumbs.data`
	     * - `user`
	     * - `contexts`
	     * - `extra`
	     * @param event Event
	     * @returns Normalized event
	     */
	    BaseClient.prototype._normalizeEvent = function (event, depth) {
	        if (!event) {
	            return null;
	        }
	        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
	            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
	                data: utils_1.normalize(b.data, depth),
	            }))); }),
	        })), (event.user && {
	            user: utils_1.normalize(event.user, depth),
	        })), (event.contexts && {
	            contexts: utils_1.normalize(event.contexts, depth),
	        })), (event.extra && {
	            extra: utils_1.normalize(event.extra, depth),
	        }));
	        // event.contexts.trace stores information about a Transaction. Similarly,
	        // event.spans[] stores information about child Spans. Given that a
	        // Transaction is conceptually a Span, normalization should apply to both
	        // Transactions and Spans consistently.
	        // For now the decision is to skip normalization of Transactions and Spans,
	        // so this block overwrites the normalized event to add back the original
	        // Transaction information prior to normalization.
	        if (event.contexts && event.contexts.trace) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            normalized.contexts.trace = event.contexts.trace;
	        }
	        return normalized;
	    };
	    /**
	     *  Enhances event using the client configuration.
	     *  It takes care of all "static" values like environment, release and `dist`,
	     *  as well as truncating overly long values.
	     * @param event event instance to be enhanced
	     */
	    BaseClient.prototype._applyClientOptions = function (event) {
	        var options = this.getOptions();
	        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
	        if (!('environment' in event)) {
	            event.environment = 'environment' in options ? environment : 'production';
	        }
	        if (event.release === undefined && release !== undefined) {
	            event.release = release;
	        }
	        if (event.dist === undefined && dist !== undefined) {
	            event.dist = dist;
	        }
	        if (event.message) {
	            event.message = utils_1.truncate(event.message, maxValueLength);
	        }
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        if (exception && exception.value) {
	            exception.value = utils_1.truncate(exception.value, maxValueLength);
	        }
	        var request = event.request;
	        if (request && request.url) {
	            request.url = utils_1.truncate(request.url, maxValueLength);
	        }
	    };
	    /**
	     * This function adds all used integrations to the SDK info in the event.
	     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
	     */
	    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
	        var sdkInfo = event.sdk;
	        var integrationsArray = Object.keys(this._integrations);
	        if (sdkInfo && integrationsArray.length > 0) {
	            sdkInfo.integrations = integrationsArray;
	        }
	    };
	    /**
	     * Tells the backend to send this event
	     * @param event The Sentry event to send
	     */
	    BaseClient.prototype._sendEvent = function (event) {
	        this._getBackend().sendEvent(event);
	    };
	    /**
	     * Processes the event and logs an error in case of rejection
	     * @param event
	     * @param hint
	     * @param scope
	     */
	    BaseClient.prototype._captureEvent = function (event, hint, scope) {
	        return this._processEvent(event, hint, scope).then(function (finalEvent) {
	            return finalEvent.event_id;
	        }, function (reason) {
	            utils_1.logger.error(reason);
	            return undefined;
	        });
	    };
	    /**
	     * Processes an event (either error or message) and sends it to Sentry.
	     *
	     * This also adds breadcrumbs and context information to the event. However,
	     * platform specific meta data (such as the User's IP address) must be added
	     * by the SDK implementor.
	     *
	     *
	     * @param event The event to send to Sentry.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
	     */
	    BaseClient.prototype._processEvent = function (event, hint, scope) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
	        if (!this._isEnabled()) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError('SDK not enabled, will not send event.'));
	        }
	        var isTransaction = event.type === 'transaction';
	        // 1.0 === 100% events are sent
	        // 0.0 === 0% events are sent
	        // Sampling for transaction happens somewhere else
	        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
	        }
	        return this._prepareEvent(event, scope, hint)
	            .then(function (prepared) {
	            if (prepared === null) {
	                throw new utils_1.SentryError('An event processor returned null, will not send event.');
	            }
	            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
	            if (isInternalException || isTransaction || !beforeSend) {
	                return prepared;
	            }
	            var beforeSendResult = beforeSend(prepared, hint);
	            if (typeof beforeSendResult === 'undefined') {
	                throw new utils_1.SentryError('`beforeSend` method has to return `null` or a valid event.');
	            }
	            else if (utils_1.isThenable(beforeSendResult)) {
	                return beforeSendResult.then(function (event) { return event; }, function (e) {
	                    throw new utils_1.SentryError("beforeSend rejected with " + e);
	                });
	            }
	            return beforeSendResult;
	        })
	            .then(function (processedEvent) {
	            if (processedEvent === null) {
	                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
	            }
	            var session = scope && scope.getSession && scope.getSession();
	            if (!isTransaction && session) {
	                _this._updateSessionFromEvent(session, processedEvent);
	            }
	            _this._sendEvent(processedEvent);
	            return processedEvent;
	        })
	            .then(null, function (reason) {
	            if (reason instanceof utils_1.SentryError) {
	                throw reason;
	            }
	            _this.captureException(reason, {
	                data: {
	                    __sentry__: true,
	                },
	                originalException: reason,
	            });
	            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
	        });
	    };
	    /**
	     * Occupies the client with processing and event
	     */
	    BaseClient.prototype._process = function (promise) {
	        var _this = this;
	        this._processing += 1;
	        promise.then(function (value) {
	            _this._processing -= 1;
	            return value;
	        }, function (reason) {
	            _this._processing -= 1;
	            return reason;
	        });
	    };
	    return BaseClient;
	}());
	exports.BaseClient = BaseClient;
	//# sourceMappingURL=baseclient.js.map

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var hub_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(9);
	exports.installedIntegrations = [];
	/** Gets integration to install */
	function getIntegrationsToSetup(options) {
	    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
	    var userIntegrations = options.integrations;
	    var integrations = [];
	    if (Array.isArray(userIntegrations)) {
	        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
	        var pickedIntegrationsNames_1 = [];
	        // Leave only unique default integrations, that were not overridden with provided user integrations
	        defaultIntegrations.forEach(function (defaultIntegration) {
	            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
	                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
	                integrations.push(defaultIntegration);
	                pickedIntegrationsNames_1.push(defaultIntegration.name);
	            }
	        });
	        // Don't add same user integration twice
	        userIntegrations.forEach(function (userIntegration) {
	            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
	                integrations.push(userIntegration);
	                pickedIntegrationsNames_1.push(userIntegration.name);
	            }
	        });
	    }
	    else if (typeof userIntegrations === 'function') {
	        integrations = userIntegrations(defaultIntegrations);
	        integrations = Array.isArray(integrations) ? integrations : [integrations];
	    }
	    else {
	        integrations = tslib_1.__spread(defaultIntegrations);
	    }
	    // Make sure that if present, `Debug` integration will always run last
	    var integrationsNames = integrations.map(function (i) { return i.name; });
	    var alwaysLastToRun = 'Debug';
	    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
	        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
	    }
	    return integrations;
	}
	exports.getIntegrationsToSetup = getIntegrationsToSetup;
	/** Setup given integration */
	function setupIntegration(integration) {
	    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
	        return;
	    }
	    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
	    exports.installedIntegrations.push(integration.name);
	    utils_1.logger.log("Integration installed: " + integration.name);
	}
	exports.setupIntegration = setupIntegration;
	/**
	 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
	 * integrations are added unless they were already provided before.
	 * @param integrations array of integration instances
	 * @param withDefault should enable default integrations
	 */
	function setupIntegrations(options) {
	    var integrations = {};
	    getIntegrationsToSetup(options).forEach(function (integration) {
	        integrations[integration.name] = integration;
	        setupIntegration(integration);
	    });
	    return integrations;
	}
	exports.setupIntegrations = setupIntegrations;
	//# sourceMappingURL=integration.js.map

/***/ },
/* 275 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var originalFunctionToString;
	/** Patch toString calls to return proper name for wrapped functions */
	var FunctionToString = /** @class */ (function () {
	    function FunctionToString() {
	        /**
	         * @inheritDoc
	         */
	        this.name = FunctionToString.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.prototype.setupOnce = function () {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        originalFunctionToString = Function.prototype.toString;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Function.prototype.toString = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var context = this.__sentry_original__ || this;
	            return originalFunctionToString.apply(context, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.id = 'FunctionToString';
	    return FunctionToString;
	}());
	exports.FunctionToString = FunctionToString;
	//# sourceMappingURL=functiontostring.js.map

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var hub_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(9);
	// "Script error." is hard coded into browsers for errors that it can't read.
	// this is the result of a script being pulled in from an external domain and CORS.
	var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
	/** Inbound filters configurable by the user */
	var InboundFilters = /** @class */ (function () {
	    function InboundFilters(_options) {
	        if (_options === void 0) { _options = {}; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = InboundFilters.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.prototype.setupOnce = function () {
	        hub_1.addGlobalEventProcessor(function (event) {
	            var hub = hub_1.getCurrentHub();
	            if (!hub) {
	                return event;
	            }
	            var self = hub.getIntegration(InboundFilters);
	            if (self) {
	                var client = hub.getClient();
	                var clientOptions = client ? client.getOptions() : {};
	                var options = self._mergeOptions(clientOptions);
	                if (self._shouldDropEvent(event, options)) {
	                    return null;
	                }
	            }
	            return event;
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._shouldDropEvent = function (event, options) {
	        if (this._isSentryError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isIgnoredError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isDeniedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        if (!this._isAllowedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        return false;
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isSentryError = function (event, options) {
	        if (!options.ignoreInternal) {
	            return false;
	        }
	        try {
	            return ((event &&
	                event.exception &&
	                event.exception.values &&
	                event.exception.values[0] &&
	                event.exception.values[0].type === 'SentryError') ||
	                false);
	        }
	        catch (_oO) {
	            return false;
	        }
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isIgnoredError = function (event, options) {
	        if (!options.ignoreErrors || !options.ignoreErrors.length) {
	            return false;
	        }
	        return this._getPossibleEventMessages(event).some(function (message) {
	            // Not sure why TypeScript complains here...
	            return options.ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isDeniedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.denyUrls || !options.denyUrls.length) {
	            return false;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? false : options.denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isAllowedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.allowUrls || !options.allowUrls.length) {
	            return true;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? true : options.allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._mergeOptions = function (clientOptions) {
	        if (clientOptions === void 0) { clientOptions = {}; }
	        return {
	            allowUrls: tslib_1.__spread((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
	            denyUrls: tslib_1.__spread((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
	            ignoreErrors: tslib_1.__spread((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
	            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
	        };
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getPossibleEventMessages = function (event) {
	        if (event.message) {
	            return [event.message];
	        }
	        if (event.exception) {
	            try {
	                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
	                return ["" + value, type + ": " + value];
	            }
	            catch (oO) {
	                utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
	                return [];
	            }
	        }
	        return [];
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getEventFilterUrl = function (event) {
	        try {
	            if (event.stacktrace) {
	                var frames_1 = event.stacktrace.frames;
	                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
	            }
	            if (event.exception) {
	                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
	                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
	            }
	            return null;
	        }
	        catch (oO) {
	            utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.id = 'InboundFilters';
	    return InboundFilters;
	}());
	exports.InboundFilters = InboundFilters;
	//# sourceMappingURL=inboundfilters.js.map

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var functiontostring_1 = __webpack_require__(275);
	exports.FunctionToString = functiontostring_1.FunctionToString;
	var inboundfilters_1 = __webpack_require__(276);
	exports.InboundFilters = inboundfilters_1.InboundFilters;
	//# sourceMappingURL=index.js.map

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	/** Creates a SentryRequest from an event. */
	function sessionToSentryRequest(session, api) {
	    var envelopeHeaders = JSON.stringify({
	        sent_at: new Date().toISOString(),
	    });
	    var itemHeaders = JSON.stringify({
	        type: 'session',
	    });
	    return {
	        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
	        type: 'session',
	        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
	    };
	}
	exports.sessionToSentryRequest = sessionToSentryRequest;
	/** Creates a SentryRequest from an event. */
	function eventToSentryRequest(event, api) {
	    // since JS has no Object.prototype.pop()
	    var _a = event.tags || {}, samplingMethod = _a.__sentry_samplingMethod, sampleRate = _a.__sentry_sampleRate, otherTags = tslib_1.__rest(_a, ["__sentry_samplingMethod", "__sentry_sampleRate"]);
	    event.tags = otherTags;
	    var useEnvelope = event.type === 'transaction';
	    var req = {
	        body: JSON.stringify(event),
	        type: event.type || 'event',
	        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
	    };
	    // https://develop.sentry.dev/sdk/envelopes/
	    // Since we don't need to manipulate envelopes nor store them, there is no
	    // exported concept of an Envelope with operations including serialization and
	    // deserialization. Instead, we only implement a minimal subset of the spec to
	    // serialize events inline here.
	    if (useEnvelope) {
	        var envelopeHeaders = JSON.stringify({
	            event_id: event.event_id,
	            sent_at: new Date().toISOString(),
	        });
	        var itemHeaders = JSON.stringify({
	            type: event.type,
	            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
	            // explicitly-set sampling decisions). Are we good with that?
	            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	        });
	        // The trailing newline is optional. We intentionally don't send it to avoid
	        // sending unnecessary bytes.
	        //
	        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
	        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
	        req.body = envelope;
	    }
	    return req;
	}
	exports.eventToSentryRequest = eventToSentryRequest;
	//# sourceMappingURL=request.js.map

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(26);
	var utils_1 = __webpack_require__(9);
	/**
	 * Internal function to create a new SDK client instance. The client is
	 * installed and then bound to the current scope.
	 *
	 * @param clientClass The client class to instantiate.
	 * @param options Options to pass to the client.
	 */
	function initAndBind(clientClass, options) {
	    if (options.debug === true) {
	        utils_1.logger.enable();
	    }
	    var hub = hub_1.getCurrentHub();
	    var client = new clientClass(options);
	    hub.bindClient(client);
	}
	exports.initAndBind = initAndBind;
	//# sourceMappingURL=sdk.js.map

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	var scope_1 = __webpack_require__(151);
	var session_1 = __webpack_require__(152);
	/**
	 * API compatibility version of this hub.
	 *
	 * WARNING: This number should only be increased when the global interface
	 * changes and new methods are introduced.
	 *
	 * @hidden
	 */
	exports.API_VERSION = 3;
	/**
	 * Default maximum number of breadcrumbs added to an event. Can be overwritten
	 * with {@link Options.maxBreadcrumbs}.
	 */
	var DEFAULT_BREADCRUMBS = 100;
	/**
	 * Absolute maximum number of breadcrumbs added to an event. The
	 * `maxBreadcrumbs` option cannot be higher than this value.
	 */
	var MAX_BREADCRUMBS = 100;
	/**
	 * @inheritDoc
	 */
	var Hub = /** @class */ (function () {
	    /**
	     * Creates a new instance of the hub, will push one {@link Layer} into the
	     * internal stack on creation.
	     *
	     * @param client bound to the hub.
	     * @param scope bound to the hub.
	     * @param version number, higher number means higher priority.
	     */
	    function Hub(client, scope, _version) {
	        if (scope === void 0) { scope = new scope_1.Scope(); }
	        if (_version === void 0) { _version = exports.API_VERSION; }
	        this._version = _version;
	        /** Is a {@link Layer}[] containing the client and scope */
	        this._stack = [{}];
	        this.getStackTop().scope = scope;
	        this.bindClient(client);
	    }
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.isOlderThan = function (version) {
	        return this._version < version;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.bindClient = function (client) {
	        var top = this.getStackTop();
	        top.client = client;
	        if (client && client.setupIntegrations) {
	            client.setupIntegrations();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.pushScope = function () {
	        // We want to clone the content of prev scope
	        var scope = scope_1.Scope.clone(this.getScope());
	        this.getStack().push({
	            client: this.getClient(),
	            scope: scope,
	        });
	        return scope;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.popScope = function () {
	        if (this.getStack().length <= 1)
	            return false;
	        return !!this.getStack().pop();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.withScope = function (callback) {
	        var scope = this.pushScope();
	        try {
	            callback(scope);
	        }
	        finally {
	            this.popScope();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getClient = function () {
	        return this.getStackTop().client;
	    };
	    /** Returns the scope of the top stack. */
	    Hub.prototype.getScope = function () {
	        return this.getStackTop().scope;
	    };
	    /** Returns the scope stack for domains or the process. */
	    Hub.prototype.getStack = function () {
	        return this._stack;
	    };
	    /** Returns the topmost scope layer in the order domain > local > process. */
	    Hub.prototype.getStackTop = function () {
	        return this._stack[this._stack.length - 1];
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Hub.prototype.captureException = function (exception, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error('Sentry syntheticException');
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: exception,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureMessage = function (message, level, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error(message);
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: message,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureEvent = function (event, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.lastEventId = function () {
	        return this._lastEventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope || !client)
	            return;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
	        if (maxBreadcrumbs <= 0)
	            return;
	        var timestamp = utils_1.dateTimestampInSeconds();
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
	        var finalBreadcrumb = beforeBreadcrumb
	            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
	            : mergedBreadcrumb;
	        if (finalBreadcrumb === null)
	            return;
	        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setUser = function (user) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setUser(user);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTags = function (tags) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTags(tags);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtras = function (extras) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtras(extras);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTag = function (key, value) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTag(key, value);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtra = function (key, extra) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtra(key, extra);
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype.setContext = function (name, context) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setContext(name, context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.configureScope = function (callback) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (scope && client) {
	            callback(scope);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.run = function (callback) {
	        var oldHub = makeMain(this);
	        try {
	            callback(this);
	        }
	        finally {
	            makeMain(oldHub);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getIntegration = function (integration) {
	        var client = this.getClient();
	        if (!client)
	            return null;
	        try {
	            return client.getIntegration(integration);
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSpan = function (context) {
	        return this._callExtensionMethod('startSpan', context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startTransaction = function (context, customSamplingContext) {
	        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.traceHeaders = function () {
	        return this._callExtensionMethod('traceHeaders');
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSession = function (context) {
	        // End existing session if there's one
	        this.endSession();
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
	        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign({ release: release,
	            environment: environment }, (scope && { user: scope.getUser() })), context));
	        if (scope) {
	            scope.setSession(session);
	        }
	        return session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.endSession = function () {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope)
	            return;
	        var session = scope.getSession && scope.getSession();
	        if (session) {
	            session.close();
	            if (client && client.captureSession) {
	                client.captureSession(session);
	            }
	            scope.setSession();
	        }
	    };
	    /**
	     * Internal helper function to call a method on the top client if it exists.
	     *
	     * @param method The method to call on the client.
	     * @param args Arguments to pass to the client function.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._invokeClient = function (method) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
	        if (client && client[method]) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
	        }
	    };
	    /**
	     * Calls global extension method and binding current instance to the function call
	     */
	    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._callExtensionMethod = function (method) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var carrier = getMainCarrier();
	        var sentry = carrier.__SENTRY__;
	        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
	            return sentry.extensions[method].apply(this, args);
	        }
	        utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
	    };
	    return Hub;
	}());
	exports.Hub = Hub;
	/** Returns the global shim registry. */
	function getMainCarrier() {
	    var carrier = utils_1.getGlobalObject();
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {
	        extensions: {},
	        hub: undefined,
	    };
	    return carrier;
	}
	exports.getMainCarrier = getMainCarrier;
	/**
	 * Replaces the current main hub with the passed one on the global object
	 *
	 * @returns The old replaced hub
	 */
	function makeMain(hub) {
	    var registry = getMainCarrier();
	    var oldHub = getHubFromCarrier(registry);
	    setHubOnCarrier(registry, hub);
	    return oldHub;
	}
	exports.makeMain = makeMain;
	/**
	 * Returns the default hub instance.
	 *
	 * If a hub is already registered in the global carrier but this module
	 * contains a more recent version, it replaces the registered version.
	 * Otherwise, the currently registered hub will be returned.
	 */
	function getCurrentHub() {
	    // Get main carrier (global for every environment)
	    var registry = getMainCarrier();
	    // If there's no hub, or its an old API, assign a new one
	    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
	        setHubOnCarrier(registry, new Hub());
	    }
	    // Prefer domains over global if they are there (applicable only to Node environment)
	    if (utils_1.isNodeEnv()) {
	        return getHubFromActiveDomain(registry);
	    }
	    // Return hub that lives on a global object
	    return getHubFromCarrier(registry);
	}
	exports.getCurrentHub = getCurrentHub;
	/**
	 * Returns the active domain, if one exists
	 *
	 * @returns The domain, or undefined if there is no active domain
	 */
	function getActiveDomain() {
	    var sentry = getMainCarrier().__SENTRY__;
	    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	}
	exports.getActiveDomain = getActiveDomain;
	/**
	 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
	 * @returns discovered hub
	 */
	function getHubFromActiveDomain(registry) {
	    try {
	        var activeDomain = getActiveDomain();
	        // If there's no active domain, just return global hub
	        if (!activeDomain) {
	            return getHubFromCarrier(registry);
	        }
	        // If there's no hub on current domain, or it's an old API, assign a new one
	        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
	            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
	            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
	        }
	        // Return hub that lives on a domain
	        return getHubFromCarrier(activeDomain);
	    }
	    catch (_Oo) {
	        // Return hub that lives on a global object
	        return getHubFromCarrier(registry);
	    }
	}
	/**
	 * This will tell whether a carrier has a hub on it or not
	 * @param carrier object
	 */
	function hasHubOnCarrier(carrier) {
	    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
	}
	/**
	 * This will create a new {@link Hub} and add to the passed object on
	 * __SENTRY__.hub.
	 * @param carrier object
	 * @hidden
	 */
	function getHubFromCarrier(carrier) {
	    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
	        return carrier.__SENTRY__.hub;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = new Hub();
	    return carrier.__SENTRY__.hub;
	}
	exports.getHubFromCarrier = getHubFromCarrier;
	/**
	 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
	 * @param carrier object
	 * @param hub Hub
	 */
	function setHubOnCarrier(carrier, hub) {
	    if (!carrier)
	        return false;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = hub;
	    return true;
	}
	exports.setHubOnCarrier = setHubOnCarrier;
	//# sourceMappingURL=hub.js.map

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var hub_1 = __webpack_require__(26);
	/**
	 * This calls a function on the current hub.
	 * @param method function to call on hub.
	 * @param args to pass to function.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function callOnHub(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var hub = hub_1.getCurrentHub();
	    if (hub && hub[method]) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return hub[method].apply(hub, tslib_1.__spread(args));
	    }
	    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
	}
	/**
	 * Captures an exception event and sends it to Sentry.
	 *
	 * @param exception An exception-like object.
	 * @returns The generated eventId.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function captureException(exception, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error('Sentry syntheticException');
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    return callOnHub('captureException', exception, {
	        captureContext: captureContext,
	        originalException: exception,
	        syntheticException: syntheticException,
	    });
	}
	exports.captureException = captureException;
	/**
	 * Captures a message event and sends it to Sentry.
	 *
	 * @param message The message to send to Sentry.
	 * @param level Define the level of the message.
	 * @returns The generated eventId.
	 */
	function captureMessage(message, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error(message);
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    // This is necessary to provide explicit scopes upgrade, without changing the original
	    // arity of the `captureMessage(message, level)` method.
	    var level = typeof captureContext === 'string' ? captureContext : undefined;
	    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
	    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
	}
	exports.captureMessage = captureMessage;
	/**
	 * Captures a manually created event and sends it to Sentry.
	 *
	 * @param event The event to send to Sentry.
	 * @returns The generated eventId.
	 */
	function captureEvent(event) {
	    return callOnHub('captureEvent', event);
	}
	exports.captureEvent = captureEvent;
	/**
	 * Callback to set context information onto the scope.
	 * @param callback Callback function that receives Scope.
	 */
	function configureScope(callback) {
	    callOnHub('configureScope', callback);
	}
	exports.configureScope = configureScope;
	/**
	 * Records a new breadcrumb which will be attached to future events.
	 *
	 * Breadcrumbs will be added to subsequent events to provide more context on
	 * user's actions prior to an error or crash.
	 *
	 * @param breadcrumb The breadcrumb to record.
	 */
	function addBreadcrumb(breadcrumb) {
	    callOnHub('addBreadcrumb', breadcrumb);
	}
	exports.addBreadcrumb = addBreadcrumb;
	/**
	 * Sets context data with the given name.
	 * @param name of the context
	 * @param context Any kind of data. This data will be normalized.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function setContext(name, context) {
	    callOnHub('setContext', name, context);
	}
	exports.setContext = setContext;
	/**
	 * Set an object that will be merged sent as extra data with the event.
	 * @param extras Extras object to merge into current context.
	 */
	function setExtras(extras) {
	    callOnHub('setExtras', extras);
	}
	exports.setExtras = setExtras;
	/**
	 * Set an object that will be merged sent as tags data with the event.
	 * @param tags Tags context object to merge into current context.
	 */
	function setTags(tags) {
	    callOnHub('setTags', tags);
	}
	exports.setTags = setTags;
	/**
	 * Set key:value that will be sent as extra data with the event.
	 * @param key String of extra
	 * @param extra Any kind of data. This data will be normalized.
	 */
	function setExtra(key, extra) {
	    callOnHub('setExtra', key, extra);
	}
	exports.setExtra = setExtra;
	/**
	 * Set key:value that will be sent as tags data with the event.
	 *
	 * Can also be used to unset a tag, by passing `undefined`.
	 *
	 * @param key String key of tag
	 * @param value Value of tag
	 */
	function setTag(key, value) {
	    callOnHub('setTag', key, value);
	}
	exports.setTag = setTag;
	/**
	 * Updates user context information for future events.
	 *
	 * @param user User context object to be set in the current context. Pass `null` to unset the user.
	 */
	function setUser(user) {
	    callOnHub('setUser', user);
	}
	exports.setUser = setUser;
	/**
	 * Creates a new scope with and executes the given operation within.
	 * The scope is automatically removed once the operation
	 * finishes or throws.
	 *
	 * This is essentially a convenience function for:
	 *
	 *     pushScope();
	 *     callback();
	 *     popScope();
	 *
	 * @param callback that will be enclosed into push/popScope.
	 */
	function withScope(callback) {
	    callOnHub('withScope', callback);
	}
	exports.withScope = withScope;
	/**
	 * Calls a function on the latest client. Use this with caution, it's meant as
	 * in "internal" helper so we don't need to expose every possible function in
	 * the shim. It is not guaranteed that the client actually implements the
	 * function.
	 *
	 * @param method The method to call on the client/client.
	 * @param args Arguments to pass to the client/fontend.
	 * @hidden
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _callOnClient(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
	}
	exports._callOnClient = _callOnClient;
	/**
	 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
	 *
	 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
	 * new child span within the transaction or any span, call the respective `.startChild()` method.
	 *
	 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
	 *
	 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
	 * finished child spans will be sent to Sentry.
	 *
	 * @param context Properties of the new `Transaction`.
	 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
	 * default values). See {@link Options.tracesSampler}.
	 *
	 * @returns The transaction which was just started
	 */
	function startTransaction(context, customSamplingContext) {
	    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
	}
	exports.startTransaction = startTransaction;
	//# sourceMappingURL=index.js.map

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	var spanstatus_1 = __webpack_require__(41);
	var utils_2 = __webpack_require__(36);
	var global = utils_1.getGlobalObject();
	/**
	 * Add a listener that cancels and finishes a transaction when the global
	 * document is hidden.
	 */
	function registerBackgroundTabDetection() {
	    if (global && global.document) {
	        global.document.addEventListener('visibilitychange', function () {
	            var activeTransaction = utils_2.getActiveTransaction();
	            if (global.document.hidden && activeTransaction) {
	                utils_1.logger.log("[Tracing] Transaction: " + spanstatus_1.SpanStatus.Cancelled + " -> since tab moved to the background, op: " + activeTransaction.op);
	                // We should not set status if it is already set, this prevent important statuses like
	                // error or data loss from being overwritten on transaction.
	                if (!activeTransaction.status) {
	                    activeTransaction.setStatus(spanstatus_1.SpanStatus.Cancelled);
	                }
	                activeTransaction.setTag('visibilitychange', 'document.hidden');
	                activeTransaction.finish();
	            }
	        });
	    }
	    else {
	        utils_1.logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
	    }
	}
	exports.registerBackgroundTabDetection = registerBackgroundTabDetection;
	//# sourceMappingURL=backgroundtab.js.map

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	var hubextensions_1 = __webpack_require__(81);
	var idletransaction_1 = __webpack_require__(82);
	var spanstatus_1 = __webpack_require__(41);
	var utils_2 = __webpack_require__(36);
	var backgroundtab_1 = __webpack_require__(282);
	var metrics_1 = __webpack_require__(284);
	var request_1 = __webpack_require__(154);
	var router_1 = __webpack_require__(285);
	exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
	var DEFAULT_BROWSER_TRACING_OPTIONS = tslib_1.__assign({ idleTimeout: idletransaction_1.DEFAULT_IDLE_TIMEOUT, markBackgroundTransactions: true, maxTransactionDuration: exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: router_1.defaultRoutingInstrumentation, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, request_1.defaultRequestInstrumentationOptions);
	/**
	 * The Browser Tracing integration automatically instruments browser pageload/navigation
	 * actions as transactions, and captures requests, metrics and errors as spans.
	 *
	 * The integration can be configured with a variety of options, and can be extended to use
	 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
	 */
	var BrowserTracing = /** @class */ (function () {
	    function BrowserTracing(_options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = BrowserTracing.id;
	        this._metrics = new metrics_1.MetricsInstrumentation();
	        this._emitOptionsWarning = false;
	        var tracingOrigins = request_1.defaultRequestInstrumentationOptions.tracingOrigins;
	        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
	        if (_options &&
	            _options.tracingOrigins &&
	            Array.isArray(_options.tracingOrigins) &&
	            _options.tracingOrigins.length !== 0) {
	            tracingOrigins = _options.tracingOrigins;
	        }
	        else {
	            this._emitOptionsWarning = true;
	        }
	        this.options = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        this._getCurrentHub = getCurrentHub;
	        if (this._emitOptionsWarning) {
	            utils_1.logger.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
	            utils_1.logger.warn("[Tracing] We added a reasonable default for you: " + request_1.defaultRequestInstrumentationOptions.tracingOrigins);
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, routingInstrumentation = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	        routingInstrumentation(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
	        if (markBackgroundTransactions) {
	            backgroundtab_1.registerBackgroundTabDetection();
	        }
	        request_1.registerRequestInstrumentation({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
	    };
	    /** Create routing idle transaction. */
	    BrowserTracing.prototype._createRouteTransaction = function (context) {
	        var _this = this;
	        if (!this._getCurrentHub) {
	            utils_1.logger.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
	            return undefined;
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
	        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
	        var expandedContext = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, context), parentContextFromHeader), { trimEnd: true });
	        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
	        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
	        // from being sent to Sentry).
	        var finalContext = modifiedContext === undefined ? tslib_1.__assign(tslib_1.__assign({}, expandedContext), { sampled: false }) : modifiedContext;
	        if (finalContext.sampled === false) {
	            utils_1.logger.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
	        }
	        var hub = this._getCurrentHub();
	        var idleTransaction = hubextensions_1.startIdleTransaction(hub, finalContext, idleTimeout, true);
	        utils_1.logger.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
	        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
	            _this._metrics.addPerformanceEntries(transaction);
	            adjustTransactionDuration(utils_2.secToMs(maxTransactionDuration), transaction, endTimestamp);
	        });
	        return idleTransaction;
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.id = 'BrowserTracing';
	    return BrowserTracing;
	}());
	exports.BrowserTracing = BrowserTracing;
	/**
	 * Gets transaction context from a sentry-trace meta.
	 *
	 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
	 */
	function getHeaderContext() {
	    var header = getMetaContent('sentry-trace');
	    if (header) {
	        return utils_2.extractTraceparentData(header);
	    }
	    return undefined;
	}
	exports.getHeaderContext = getHeaderContext;
	/** Returns the value of a meta tag */
	function getMetaContent(metaName) {
	    var el = document.querySelector("meta[name=" + metaName + "]");
	    return el ? el.getAttribute('content') : null;
	}
	exports.getMetaContent = getMetaContent;
	/** Adjusts transaction value based on max transaction duration */
	function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
	    var diff = endTimestamp - transaction.startTimestamp;
	    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
	    if (isOutdatedTransaction) {
	        transaction.setStatus(spanstatus_1.SpanStatus.DeadlineExceeded);
	        transaction.setTag('maxTransactionDurationExceeded', 'true');
	    }
	}
	//# sourceMappingURL=browsertracing.js.map

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	var utils_2 = __webpack_require__(36);
	var getCLS_1 = __webpack_require__(286);
	var getFID_1 = __webpack_require__(287);
	var getLCP_1 = __webpack_require__(288);
	var getTTFB_1 = __webpack_require__(289);
	var getFirstHidden_1 = __webpack_require__(79);
	var global = utils_1.getGlobalObject();
	/** Class tracking metrics  */
	var MetricsInstrumentation = /** @class */ (function () {
	    function MetricsInstrumentation() {
	        this._measurements = {};
	        this._performanceCursor = 0;
	        if (global && global.performance) {
	            if (global.performance.mark) {
	                global.performance.mark('sentry-tracing-init');
	            }
	            this._trackCLS();
	            this._trackLCP();
	            this._trackFID();
	            this._trackTTFB();
	        }
	    }
	    /** Add performance related spans to a transaction */
	    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
	        var _this = this;
	        if (!global || !global.performance || !global.performance.getEntries || !utils_1.browserPerformanceTimeOrigin) {
	            // Gatekeeper if performance API not available
	            return;
	        }
	        utils_1.logger.log('[Tracing] Adding & adjusting spans using Performance API');
	        var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	        var entryScriptSrc;
	        if (global.document) {
	            // eslint-disable-next-line @typescript-eslint/prefer-for-of
	            for (var i = 0; i < document.scripts.length; i++) {
	                // We go through all scripts on the page and look for 'data-entry'
	                // We remember the name and measure the time between this script finished loading and
	                // our mark 'sentry-tracing-init'
	                if (document.scripts[i].dataset.entry === 'true') {
	                    entryScriptSrc = document.scripts[i].src;
	                    break;
	                }
	            }
	        }
	        var entryScriptStartTimestamp;
	        var tracingInitMarkStartTime;
	        global.performance
	            .getEntries()
	            .slice(this._performanceCursor)
	            .forEach(function (entry) {
	            var startTime = utils_2.msToSec(entry.startTime);
	            var duration = utils_2.msToSec(entry.duration);
	            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
	                return;
	            }
	            switch (entry.entryType) {
	                case 'navigation':
	                    addNavigationSpans(transaction, entry, timeOrigin);
	                    break;
	                case 'mark':
	                case 'paint':
	                case 'measure': {
	                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
	                    if (tracingInitMarkStartTime === undefined && entry.name === 'sentry-tracing-init') {
	                        tracingInitMarkStartTime = startTimestamp;
	                    }
	                    // capture web vitals
	                    var firstHidden = getFirstHidden_1.getFirstHidden();
	                    // Only report if the page wasn't hidden prior to the web vital.
	                    var shouldRecord = entry.startTime < firstHidden.timeStamp;
	                    if (entry.name === 'first-paint' && shouldRecord) {
	                        utils_1.logger.log('[Measurements] Adding FP');
	                        _this._measurements['fp'] = { value: entry.startTime };
	                        _this._measurements['mark.fp'] = { value: startTimestamp };
	                    }
	                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
	                        utils_1.logger.log('[Measurements] Adding FCP');
	                        _this._measurements['fcp'] = { value: entry.startTime };
	                        _this._measurements['mark.fcp'] = { value: startTimestamp };
	                    }
	                    break;
	                }
	                case 'resource': {
	                    var resourceName = entry.name.replace(window.location.origin, '');
	                    var endTimestamp = addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
	                    // We remember the entry script end time to calculate the difference to the first init mark
	                    if (entryScriptStartTimestamp === undefined && (entryScriptSrc || '').indexOf(resourceName) > -1) {
	                        entryScriptStartTimestamp = endTimestamp;
	                    }
	                    break;
	                }
	                default:
	                // Ignore other entry types.
	            }
	        });
	        if (entryScriptStartTimestamp !== undefined && tracingInitMarkStartTime !== undefined) {
	            _startChild(transaction, {
	                description: 'evaluation',
	                endTimestamp: tracingInitMarkStartTime,
	                op: 'script',
	                startTimestamp: entryScriptStartTimestamp,
	            });
	        }
	        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
	        this._trackNavigator(transaction);
	        // Measurements are only available for pageload transactions
	        if (transaction.op === 'pageload') {
	            // normalize applicable web vital values to be relative to transaction.startTimestamp
	            var timeOrigin_1 = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            ['fcp', 'fp', 'lcp', 'ttfb'].forEach(function (name) {
	                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
	                    return;
	                }
	                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
	                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
	                // to be adjusted to be relative to transaction.startTimestamp.
	                var oldValue = _this._measurements[name].value;
	                var measurementTimestamp = timeOrigin_1 + utils_2.msToSec(oldValue);
	                // normalizedValue should be in milliseconds
	                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
	                var delta = normalizedValue - oldValue;
	                utils_1.logger.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
	                _this._measurements[name].value = normalizedValue;
	            });
	            if (this._measurements['mark.fid'] && this._measurements['fid']) {
	                // create span for FID
	                _startChild(transaction, {
	                    description: 'first input delay',
	                    endTimestamp: this._measurements['mark.fid'].value + utils_2.msToSec(this._measurements['fid'].value),
	                    op: 'web.vitals',
	                    startTimestamp: this._measurements['mark.fid'].value,
	                });
	            }
	            transaction.setMeasurements(this._measurements);
	        }
	    };
	    /** Starts tracking the Cumulative Layout Shift on the current page. */
	    MetricsInstrumentation.prototype._trackCLS = function () {
	        var _this = this;
	        getCLS_1.getCLS(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            utils_1.logger.log('[Measurements] Adding CLS');
	            _this._measurements['cls'] = { value: metric.value };
	        });
	    };
	    /**
	     * Capture the information of the user agent.
	     */
	    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
	        var navigator = global.navigator;
	        if (!navigator) {
	            return;
	        }
	        // track network connectivity
	        var connection = navigator.connection;
	        if (connection) {
	            if (connection.effectiveType) {
	                transaction.setTag('effectiveConnectionType', connection.effectiveType);
	            }
	            if (connection.type) {
	                transaction.setTag('connectionType', connection.type);
	            }
	            if (isMeasurementValue(connection.rtt)) {
	                this._measurements['connection.rtt'] = { value: connection.rtt };
	            }
	            if (isMeasurementValue(connection.downlink)) {
	                this._measurements['connection.downlink'] = { value: connection.downlink };
	            }
	        }
	        if (isMeasurementValue(navigator.deviceMemory)) {
	            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
	        }
	        if (isMeasurementValue(navigator.hardwareConcurrency)) {
	            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
	        }
	    };
	    /** Starts tracking the Largest Contentful Paint on the current page. */
	    MetricsInstrumentation.prototype._trackLCP = function () {
	        var _this = this;
	        getLCP_1.getLCP(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(performance.timeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            utils_1.logger.log('[Measurements] Adding LCP');
	            _this._measurements['lcp'] = { value: metric.value };
	            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
	        });
	    };
	    /** Starts tracking the First Input Delay on the current page. */
	    MetricsInstrumentation.prototype._trackFID = function () {
	        var _this = this;
	        getFID_1.getFID(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(performance.timeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            utils_1.logger.log('[Measurements] Adding FID');
	            _this._measurements['fid'] = { value: metric.value };
	            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
	        });
	    };
	    /** Starts tracking the Time to First Byte on the current page. */
	    MetricsInstrumentation.prototype._trackTTFB = function () {
	        var _this = this;
	        getTTFB_1.getTTFB(function (metric) {
	            var _a;
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            utils_1.logger.log('[Measurements] Adding TTFB');
	            _this._measurements['ttfb'] = { value: metric.value };
	            // Capture the time spent making the request and receiving the first byte of the response
	            var requestTime = metric.value - (_a = metric.entries[0], (_a !== null && _a !== void 0 ? _a : entry)).requestStart;
	            _this._measurements['ttfb.requestTime'] = { value: requestTime };
	        });
	    };
	    return MetricsInstrumentation;
	}());
	exports.MetricsInstrumentation = MetricsInstrumentation;
	/** Instrument navigation entries */
	function addNavigationSpans(transaction, entry, timeOrigin) {
	    addPerformanceNavigationTiming(transaction, entry, 'unloadEvent', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'redirect', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'domContentLoadedEvent', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'loadEvent', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'connect', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'connectEnd');
	    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'domainLookupStart');
	    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin);
	    addRequest(transaction, entry, timeOrigin);
	}
	/** Create measure related spans */
	function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
	    var measureStartTimestamp = timeOrigin + startTime;
	    var measureEndTimestamp = measureStartTimestamp + duration;
	    _startChild(transaction, {
	        description: entry.name,
	        endTimestamp: measureEndTimestamp,
	        op: entry.entryType,
	        startTimestamp: measureStartTimestamp,
	    });
	    return measureStartTimestamp;
	}
	/** Create resource-related spans */
	function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
	    // we already instrument based on fetch and xhr, so we don't need to
	    // duplicate spans here.
	    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
	        return undefined;
	    }
	    var data = {};
	    if ('transferSize' in entry) {
	        data['Transfer Size'] = entry.transferSize;
	    }
	    if ('encodedBodySize' in entry) {
	        data['Encoded Body Size'] = entry.encodedBodySize;
	    }
	    if ('decodedBodySize' in entry) {
	        data['Decoded Body Size'] = entry.decodedBodySize;
	    }
	    var startTimestamp = timeOrigin + startTime;
	    var endTimestamp = startTimestamp + duration;
	    _startChild(transaction, {
	        description: resourceName,
	        endTimestamp: endTimestamp,
	        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
	        startTimestamp: startTimestamp,
	        data: data,
	    });
	    return endTimestamp;
	}
	exports.addResourceSpans = addResourceSpans;
	/** Create performance navigation related spans */
	function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, eventEnd) {
	    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
	    var start = entry[event + "Start"];
	    if (!start || !end) {
	        return;
	    }
	    _startChild(transaction, {
	        op: 'browser',
	        description: event,
	        startTimestamp: timeOrigin + utils_2.msToSec(start),
	        endTimestamp: timeOrigin + utils_2.msToSec(end),
	    });
	}
	/** Create request and response related spans */
	function addRequest(transaction, entry, timeOrigin) {
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'request',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.requestStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'response',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.responseStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	}
	/**
	 * Helper function to start child on transactions. This function will make sure that the transaction will
	 * use the start timestamp of the created child span if it is earlier than the transactions actual
	 * start timestamp.
	 */
	function _startChild(transaction, _a) {
	    var startTimestamp = _a.startTimestamp, ctx = tslib_1.__rest(_a, ["startTimestamp"]);
	    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
	        transaction.startTimestamp = startTimestamp;
	    }
	    return transaction.startChild(tslib_1.__assign({ startTimestamp: startTimestamp }, ctx));
	}
	exports._startChild = _startChild;
	/**
	 * Checks if a given value is a valid measurement value.
	 */
	function isMeasurementValue(value) {
	    return typeof value === 'number' && isFinite(value);
	}
	//# sourceMappingURL=metrics.js.map

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	var global = utils_1.getGlobalObject();
	/**
	 * Default function implementing pageload and navigation transactions
	 */
	function defaultRoutingInstrumentation(startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
	    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
	    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
	    if (!global || !global.location) {
	        utils_1.logger.warn('Could not initialize routing instrumentation due to invalid location');
	        return;
	    }
	    var startingUrl = global.location.href;
	    var activeTransaction;
	    if (startTransactionOnPageLoad) {
	        activeTransaction = startTransaction({ name: global.location.pathname, op: 'pageload' });
	    }
	    if (startTransactionOnLocationChange) {
	        utils_1.addInstrumentationHandler({
	            callback: function (_a) {
	                var to = _a.to, from = _a.from;
	                /**
	                 * This early return is there to account for some cases where a navigation transaction starts right after
	                 * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
	                 * create an uneccessary navigation transaction.
	                 *
	                 * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
	                 * only be caused in certain development environments where the usage of a hot module reloader is causing
	                 * errors.
	                 */
	                if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
	                    startingUrl = undefined;
	                    return;
	                }
	                if (from !== to) {
	                    startingUrl = undefined;
	                    if (activeTransaction) {
	                        utils_1.logger.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
	                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
	                        activeTransaction.finish();
	                    }
	                    activeTransaction = startTransaction({ name: global.location.pathname, op: 'navigation' });
	                }
	            },
	            type: 'history',
	        });
	    }
	}
	exports.defaultRoutingInstrumentation = defaultRoutingInstrumentation;
	//# sourceMappingURL=router.js.map

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(78);
	var initMetric_1 = __webpack_require__(55);
	var observe_1 = __webpack_require__(80);
	var onHidden_1 = __webpack_require__(56);
	exports.getCLS = function (onReport, reportAllChanges) {
	    if (reportAllChanges === void 0) { reportAllChanges = false; }
	    var metric = initMetric_1.initMetric('CLS', 0);
	    var report;
	    var entryHandler = function (entry) {
	        // Only count layout shifts without recent user input.
	        if (!entry.hadRecentInput) {
	            metric.value += entry.value;
	            metric.entries.push(entry);
	            report();
	        }
	    };
	    var po = observe_1.observe('layout-shift', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, po, reportAllChanges);
	        onHidden_1.onHidden(function (_a) {
	            var isUnloading = _a.isUnloading;
	            po.takeRecords().map(entryHandler);
	            if (isUnloading) {
	                metric.isFinal = true;
	            }
	            report();
	        });
	    }
	};
	//# sourceMappingURL=getCLS.js.map

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(78);
	var getFirstHidden_1 = __webpack_require__(79);
	var initMetric_1 = __webpack_require__(55);
	var observe_1 = __webpack_require__(80);
	var onHidden_1 = __webpack_require__(56);
	exports.getFID = function (onReport) {
	    var metric = initMetric_1.initMetric('FID');
	    var firstHidden = getFirstHidden_1.getFirstHidden();
	    var entryHandler = function (entry) {
	        // Only report if the page wasn't hidden prior to the first input.
	        if (entry.startTime < firstHidden.timeStamp) {
	            metric.value = entry.processingStart - entry.startTime;
	            metric.entries.push(entry);
	            metric.isFinal = true;
	            report();
	        }
	    };
	    var po = observe_1.observe('first-input', entryHandler);
	    var report = bindReporter_1.bindReporter(onReport, metric, po);
	    if (po) {
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            po.disconnect();
	        }, true);
	    }
	    else {
	        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
	            window.perfMetrics.onFirstInputDelay(function (value, event) {
	                // Only report if the page wasn't hidden prior to the first input.
	                if (event.timeStamp < firstHidden.timeStamp) {
	                    metric.value = value;
	                    metric.isFinal = true;
	                    metric.entries = [
	                        {
	                            entryType: 'first-input',
	                            name: event.type,
	                            target: event.target,
	                            cancelable: event.cancelable,
	                            startTime: event.timeStamp,
	                            processingStart: event.timeStamp + value,
	                        },
	                    ];
	                    report();
	                }
	            });
	        }
	    }
	};
	//# sourceMappingURL=getFID.js.map

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(78);
	var getFirstHidden_1 = __webpack_require__(79);
	var initMetric_1 = __webpack_require__(55);
	var observe_1 = __webpack_require__(80);
	var onHidden_1 = __webpack_require__(56);
	var whenInput_1 = __webpack_require__(291);
	exports.getLCP = function (onReport, reportAllChanges) {
	    if (reportAllChanges === void 0) { reportAllChanges = false; }
	    var metric = initMetric_1.initMetric('LCP');
	    var firstHidden = getFirstHidden_1.getFirstHidden();
	    var report;
	    var entryHandler = function (entry) {
	        // The startTime attribute returns the value of the renderTime if it is not 0,
	        // and the value of the loadTime otherwise.
	        var value = entry.startTime;
	        // If the page was hidden prior to paint time of the entry,
	        // ignore it and mark the metric as final, otherwise add the entry.
	        if (value < firstHidden.timeStamp) {
	            metric.value = value;
	            metric.entries.push(entry);
	        }
	        else {
	            metric.isFinal = true;
	        }
	        report();
	    };
	    var po = observe_1.observe('largest-contentful-paint', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, po, reportAllChanges);
	        var onFinal = function () {
	            if (!metric.isFinal) {
	                po.takeRecords().map(entryHandler);
	                metric.isFinal = true;
	                report();
	            }
	        };
	        void whenInput_1.whenInput().then(onFinal);
	        onHidden_1.onHidden(onFinal, true);
	    }
	};
	//# sourceMappingURL=getLCP.js.map

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	var initMetric_1 = __webpack_require__(55);
	var global = utils_1.getGlobalObject();
	var afterLoad = function (callback) {
	    if (document.readyState === 'complete') {
	        // Queue a task so the callback runs after `loadEventEnd`.
	        setTimeout(callback, 0);
	    }
	    else {
	        // Use `pageshow` so the callback runs after `loadEventEnd`.
	        addEventListener('pageshow', callback);
	    }
	};
	var getNavigationEntryFromPerformanceTiming = function () {
	    // Really annoying that TypeScript errors when using `PerformanceTiming`.
	    // eslint-disable-next-line deprecation/deprecation
	    var timing = global.performance.timing;
	    var navigationEntry = {
	        entryType: 'navigation',
	        startTime: 0,
	    };
	    for (var key in timing) {
	        if (key !== 'navigationStart' && key !== 'toJSON') {
	            navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
	        }
	    }
	    return navigationEntry;
	};
	exports.getTTFB = function (onReport) {
	    var metric = initMetric_1.initMetric('TTFB');
	    afterLoad(function () {
	        try {
	            // Use the NavigationTiming L2 entry if available.
	            var navigationEntry = global.performance.getEntriesByType('navigation')[0] || getNavigationEntryFromPerformanceTiming();
	            metric.value = metric.delta = navigationEntry.responseStart;
	            metric.entries = [navigationEntry];
	            onReport(metric);
	        }
	        catch (error) {
	            // Do nothing.
	        }
	    });
	};
	//# sourceMappingURL=getTTFB.js.map

/***/ },
/* 290 */
/***/ function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Performantly generate a unique, 27-char string by combining the current
	 * timestamp with a 13-digit random number.
	 * @return {string}
	 */
	exports.generateUniqueID = function () {
	    return Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
	};
	//# sourceMappingURL=generateUniqueID.js.map

/***/ },
/* 291 */
/***/ function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var inputPromise;
	exports.whenInput = function () {
	    if (!inputPromise) {
	        inputPromise = new Promise(function (r) {
	            return ['scroll', 'keydown', 'pointerdown'].map(function (type) {
	                addEventListener(type, r, {
	                    once: true,
	                    passive: true,
	                    capture: true,
	                });
	            });
	        });
	    }
	    return inputPromise;
	};
	//# sourceMappingURL=whenInput.js.map

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	var spanstatus_1 = __webpack_require__(41);
	var utils_2 = __webpack_require__(36);
	/**
	 * Configures global error listeners
	 */
	function registerErrorInstrumentation() {
	    utils_1.addInstrumentationHandler({
	        callback: errorCallback,
	        type: 'error',
	    });
	    utils_1.addInstrumentationHandler({
	        callback: errorCallback,
	        type: 'unhandledrejection',
	    });
	}
	exports.registerErrorInstrumentation = registerErrorInstrumentation;
	/**
	 * If an error or unhandled promise occurs, we mark the active transaction as failed
	 */
	function errorCallback() {
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        utils_1.logger.log("[Tracing] Transaction: " + spanstatus_1.SpanStatus.InternalError + " -> Global error occured");
	        activeTransaction.setStatus(spanstatus_1.SpanStatus.InternalError);
	    }
	}
	//# sourceMappingURL=errors.js.map

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var browser_1 = __webpack_require__(153);
	var hubextensions_1 = __webpack_require__(81);
	exports.addExtensionMethods = hubextensions_1.addExtensionMethods;
	var TracingIntegrations = __webpack_require__(295);
	var Integrations = tslib_1.__assign(tslib_1.__assign({}, TracingIntegrations), { BrowserTracing: browser_1.BrowserTracing });
	exports.Integrations = Integrations;
	var span_1 = __webpack_require__(83);
	exports.Span = span_1.Span;
	var transaction_1 = __webpack_require__(84);
	exports.Transaction = transaction_1.Transaction;
	var browser_2 = __webpack_require__(153);
	exports.registerRequestInstrumentation = browser_2.registerRequestInstrumentation;
	exports.defaultRequestInstrumentationOptions = browser_2.defaultRequestInstrumentationOptions;
	var spanstatus_1 = __webpack_require__(41);
	exports.SpanStatus = spanstatus_1.SpanStatus;
	var idletransaction_1 = __webpack_require__(82);
	exports.IdleTransaction = idletransaction_1.IdleTransaction;
	var hubextensions_2 = __webpack_require__(81);
	exports.startIdleTransaction = hubextensions_2.startIdleTransaction;
	// We are patching the global object with our hub extension methods
	hubextensions_1.addExtensionMethods();
	var utils_1 = __webpack_require__(36);
	exports.extractTraceparentData = utils_1.extractTraceparentData;
	exports.getActiveTransaction = utils_1.getActiveTransaction;
	exports.hasTracingEnabled = utils_1.hasTracingEnabled;
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	exports.TRACEPARENT_REGEXP = utils_1.TRACEPARENT_REGEXP;
	//# sourceMappingURL=index.js.map

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	/**
	 * Express integration
	 *
	 * Provides an request and error handler for Express framework as well as tracing capabilities
	 */
	var Express = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Express(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Express.id;
	        this._router = options.router || options.app;
	        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
	    }
	    /**
	     * @inheritDoc
	     */
	    Express.prototype.setupOnce = function () {
	        if (!this._router) {
	            utils_1.logger.error('ExpressIntegration is missing an Express instance');
	            return;
	        }
	        instrumentMiddlewares(this._router, this._methods);
	    };
	    /**
	     * @inheritDoc
	     */
	    Express.id = 'Express';
	    return Express;
	}());
	exports.Express = Express;
	/**
	 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
	 * and finishes it once the middleware is done invoking.
	 *
	 * Express middlewares have 3 various forms, thus we have to take care of all of them:
	 * // sync
	 * app.use(function (req, res) { ... })
	 * // async
	 * app.use(function (req, res, next) { ... })
	 * // error handler
	 * app.use(function (err, req, res, next) { ... })
	 *
	 * They all internally delegate to the `router[method]` of the given application instance.
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
	function wrap(fn, method) {
	    var arity = fn.length;
	    switch (arity) {
	        case 2: {
	            return function (req, res) {
	                var transaction = res.__sentry_transaction;
	                if (transaction) {
	                    var span_1 = transaction.startChild({
	                        description: fn.name,
	                        op: "middleware." + method,
	                    });
	                    res.once('finish', function () {
	                        span_1.finish();
	                    });
	                }
	                return fn.call(this, req, res);
	            };
	        }
	        case 3: {
	            return function (req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "middleware." + method,
	                });
	                fn.call(this, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        case 4: {
	            return function (err, req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "middleware." + method,
	                });
	                fn.call(this, err, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        default: {
	            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
	        }
	    }
	}
	/**
	 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
	 * and wraps every function, as well as array of functions with a call to our `wrap` method.
	 * We have to take care of the arrays as well as iterate over all of the arguments,
	 * as `app.use` can accept middlewares in few various forms.
	 *
	 * app.use([<path>], <fn>)
	 * app.use([<path>], <fn>, ...<fn>)
	 * app.use([<path>], ...<fn>[])
	 */
	function wrapMiddlewareArgs(args, method) {
	    return args.map(function (arg) {
	        if (typeof arg === 'function') {
	            return wrap(arg, method);
	        }
	        if (Array.isArray(arg)) {
	            return arg.map(function (a) {
	                if (typeof a === 'function') {
	                    return wrap(a, method);
	                }
	                return a;
	            });
	        }
	        return arg;
	    });
	}
	/**
	 * Patches original router to utilize our tracing functionality
	 */
	function patchMiddleware(router, method) {
	    var originalCallback = router[method];
	    router[method] = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return originalCallback.call.apply(originalCallback, tslib_1.__spread([this], wrapMiddlewareArgs(args, method)));
	    };
	    return router;
	}
	/**
	 * Patches original router methods
	 */
	function instrumentMiddlewares(router, methods) {
	    if (methods === void 0) { methods = []; }
	    methods.forEach(function (method) { return patchMiddleware(router, method); });
	}
	//# sourceMappingURL=express.js.map

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var express_1 = __webpack_require__(294);
	exports.Express = express_1.Express;
	var postgres_1 = __webpack_require__(298);
	exports.Postgres = postgres_1.Postgres;
	var mysql_1 = __webpack_require__(297);
	exports.Mysql = mysql_1.Mysql;
	var mongo_1 = __webpack_require__(296);
	exports.Mongo = mongo_1.Mongo;
	//# sourceMappingURL=index.js.map

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var utils_1 = __webpack_require__(9);
	var OPERATIONS = [
	    'aggregate',
	    'bulkWrite',
	    'countDocuments',
	    'createIndex',
	    'createIndexes',
	    'deleteMany',
	    'deleteOne',
	    'distinct',
	    'drop',
	    'dropIndex',
	    'dropIndexes',
	    'estimatedDocumentCount',
	    'findOne',
	    'findOneAndDelete',
	    'findOneAndReplace',
	    'findOneAndUpdate',
	    'indexes',
	    'indexExists',
	    'indexInformation',
	    'initializeOrderedBulkOp',
	    'insertMany',
	    'insertOne',
	    'isCapped',
	    'mapReduce',
	    'options',
	    'parallelCollectionScan',
	    'rename',
	    'replaceOne',
	    'stats',
	    'updateMany',
	    'updateOne',
	];
	// All of the operations above take `options` and `callback` as their final parameters, but some of them
	// take additional parameters as well. For those operations, this is a map of
	// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
	// positional arguments when we add them to the span's `data` object later
	var OPERATION_SIGNATURES = {
	    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
	    // see https://github.com/getsentry/sentry-javascript/pull/3102
	    bulkWrite: ['operations'],
	    countDocuments: ['query'],
	    createIndex: ['fieldOrSpec'],
	    createIndexes: ['indexSpecs'],
	    deleteMany: ['filter'],
	    deleteOne: ['filter'],
	    distinct: ['key', 'query'],
	    dropIndex: ['indexName'],
	    findOne: ['query'],
	    findOneAndDelete: ['filter'],
	    findOneAndReplace: ['filter', 'replacement'],
	    findOneAndUpdate: ['filter', 'update'],
	    indexExists: ['indexes'],
	    insertMany: ['docs'],
	    insertOne: ['doc'],
	    mapReduce: ['map', 'reduce'],
	    rename: ['newName'],
	    replaceOne: ['filter', 'doc'],
	    updateMany: ['filter', 'update'],
	    updateOne: ['filter', 'update'],
	};
	/** Tracing integration for mongo package */
	var Mongo = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Mongo(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Mongo.id;
	        this._operations = Array.isArray(options.operations)
	            ? options.operations
	            : OPERATIONS;
	        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mongo.prototype.setupOnce = function (_, getCurrentHub) {
	        var collection;
	        try {
	            var mongodbModule = utils_1.dynamicRequire(module, 'mongodb');
	            collection = mongodbModule.Collection;
	        }
	        catch (e) {
	            utils_1.logger.error('Mongo Integration was unable to require `mongodb` package.');
	            return;
	        }
	        this._instrumentOperations(collection, this._operations, getCurrentHub);
	    };
	    /**
	     * Patches original collection methods
	     */
	    Mongo.prototype._instrumentOperations = function (collection, operations, getCurrentHub) {
	        var _this = this;
	        operations.forEach(function (operation) { return _this._patchOperation(collection, operation, getCurrentHub); });
	    };
	    /**
	     * Patches original collection to utilize our tracing functionality
	     */
	    Mongo.prototype._patchOperation = function (collection, operation, getCurrentHub) {
	        if (!(operation in collection.prototype))
	            return;
	        var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
	        utils_1.fill(collection.prototype, operation, function (orig) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a, _b, _c;
	                var lastArg = args[args.length - 1];
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                // Check if the operation was passed a callback. (mapReduce requires a different check, as
	                // its (non-callback) arguments can also be functions.)
	                if (typeof lastArg !== 'function' || (operation === 'mapReduce' && args.length === 2)) {
	                    var span_1 = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild(getSpanContext(this, operation, args));
	                    return orig.call.apply(orig, tslib_1.__spread([this], args)).then(function (res) {
	                        var _a;
	                        (_a = span_1) === null || _a === void 0 ? void 0 : _a.finish();
	                        return res;
	                    });
	                }
	                var span = (_c = parentSpan) === null || _c === void 0 ? void 0 : _c.startChild(getSpanContext(this, operation, args.slice(0, -1)));
	                return orig.call.apply(orig, tslib_1.__spread([this], args.slice(0, -1), [function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        lastArg(err, result);
	                    }]));
	            };
	        });
	    };
	    /**
	     * Form a SpanContext based on the user input to a given operation.
	     */
	    Mongo.prototype._getSpanContextFromOperationArguments = function (collection, operation, args) {
	        var data = {
	            collectionName: collection.collectionName,
	            dbName: collection.dbName,
	            namespace: collection.namespace,
	        };
	        var spanContext = {
	            op: "db",
	            description: operation,
	            data: data,
	        };
	        // If the operation takes no arguments besides `options` and `callback`, or if argument
	        // collection is disabled for this operation, just return early.
	        var signature = OPERATION_SIGNATURES[operation];
	        var shouldDescribe = Array.isArray(this._describeOperations)
	            ? this._describeOperations.includes(operation)
	            : this._describeOperations;
	        if (!signature || !shouldDescribe) {
	            return spanContext;
	        }
	        try {
	            // Special case for `mapReduce`, as the only one accepting functions as arguments.
	            if (operation === 'mapReduce') {
	                var _a = tslib_1.__read(args, 2), map = _a[0], reduce = _a[1];
	                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
	                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
	            }
	            else {
	                for (var i = 0; i < signature.length; i++) {
	                    data[signature[i]] = JSON.stringify(args[i]);
	                }
	            }
	        }
	        catch (_oO) {
	            // no-empty
	        }
	        return spanContext;
	    };
	    /**
	     * @inheritDoc
	     */
	    Mongo.id = 'Mongo';
	    return Mongo;
	}());
	exports.Mongo = Mongo;
	//# sourceMappingURL=mongo.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)(module)))

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	/** Tracing integration for node-mysql package */
	var Mysql = /** @class */ (function () {
	    function Mysql() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Mysql.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mysql.prototype.setupOnce = function (_, getCurrentHub) {
	        var connection;
	        try {
	            // Unfortunatelly mysql is using some custom loading system and `Connection` is not exported directly.
	            connection = utils_1.dynamicRequire(module, 'mysql/lib/Connection.js');
	        }
	        catch (e) {
	            utils_1.logger.error('Mysql Integration was unable to require `mysql` package.');
	            return;
	        }
	        // The original function will have one of these signatures:
	        //    function (callback) => void
	        //    function (options, callback) => void
	        //    function (options, values, callback) => void
	        utils_1.fill(connection.prototype, 'query', function (orig) {
	            return function (options, values, callback) {
	                var _a, _b;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof options === 'string' ? options : options.sql,
	                    op: "db",
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, options, values, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result, fields);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, options, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result, fields);
	                    });
	                }
	                return orig.call(this, options, values, callback);
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Mysql.id = 'Mysql';
	    return Mysql;
	}());
	exports.Mysql = Mysql;
	//# sourceMappingURL=mysql.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)(module)))

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(9);
	/** Tracing integration for node-postgres package */
	var Postgres = /** @class */ (function () {
	    function Postgres() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Postgres.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Postgres.prototype.setupOnce = function (_, getCurrentHub) {
	        var client;
	        try {
	            var pgModule = utils_1.dynamicRequire(module, 'pg');
	            client = pgModule.Client;
	        }
	        catch (e) {
	            utils_1.logger.error('Postgres Integration was unable to require `pg` package.');
	            return;
	        }
	        /**
	         * function (query, callback) => void
	         * function (query, params, callback) => void
	         * function (query) => Promise
	         * function (query, params) => Promise
	         */
	        utils_1.fill(client.prototype, 'query', function (orig) {
	            return function (config, values, callback) {
	                var _a, _b;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof config === 'string' ? config : config.text,
	                    op: "db",
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, config, values, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, config, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result);
	                    });
	                }
	                return orig.call(this, config, values).then(function (res) {
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    return res;
	                });
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Postgres.id = 'Postgres';
	    return Postgres;
	}());
	exports.Postgres = Postgres;
	//# sourceMappingURL=postgres.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)(module)))

/***/ },
/* 299 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** Console logging verbosity for the SDK. */
	var LogLevel;
	(function (LogLevel) {
	    /** No logs will be generated. */
	    LogLevel[LogLevel["None"] = 0] = "None";
	    /** Only SDK internal errors will be logged. */
	    LogLevel[LogLevel["Error"] = 1] = "Error";
	    /** Information useful for debugging the SDK will be logged. */
	    LogLevel[LogLevel["Debug"] = 2] = "Debug";
	    /** All SDK actions will be logged. */
	    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
	//# sourceMappingURL=loglevel.js.map

/***/ },
/* 300 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Session Status
	 */
	var SessionStatus;
	(function (SessionStatus) {
	    /** JSDoc */
	    SessionStatus["Ok"] = "ok";
	    /** JSDoc */
	    SessionStatus["Exited"] = "exited";
	    /** JSDoc */
	    SessionStatus["Crashed"] = "crashed";
	    /** JSDoc */
	    SessionStatus["Abnormal"] = "abnormal";
	})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
	//# sourceMappingURL=session.js.map

/***/ },
/* 301 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	// eslint-disable-next-line import/export
	var Severity;
	(function (Severity) {
	    /** JSDoc */
	    Severity["Fatal"] = "fatal";
	    /** JSDoc */
	    Severity["Error"] = "error";
	    /** JSDoc */
	    Severity["Warning"] = "warning";
	    /** JSDoc */
	    Severity["Log"] = "log";
	    /** JSDoc */
	    Severity["Info"] = "info";
	    /** JSDoc */
	    Severity["Debug"] = "debug";
	    /** JSDoc */
	    Severity["Critical"] = "critical";
	})(Severity = exports.Severity || (exports.Severity = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Severity) {
	    /**
	     * Converts a string-based level into a {@link Severity}.
	     *
	     * @param level string representation of Severity
	     * @returns Severity
	     */
	    function fromString(level) {
	        switch (level) {
	            case 'debug':
	                return Severity.Debug;
	            case 'info':
	                return Severity.Info;
	            case 'warn':
	            case 'warning':
	                return Severity.Warning;
	            case 'error':
	                return Severity.Error;
	            case 'fatal':
	                return Severity.Fatal;
	            case 'critical':
	                return Severity.Critical;
	            case 'log':
	            default:
	                return Severity.Log;
	        }
	    }
	    Severity.fromString = fromString;
	})(Severity = exports.Severity || (exports.Severity = {}));
	//# sourceMappingURL=severity.js.map

/***/ },
/* 302 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an event. */
	// eslint-disable-next-line import/export
	var Status;
	(function (Status) {
	    /** The status could not be determined. */
	    Status["Unknown"] = "unknown";
	    /** The event was skipped due to configuration or callbacks. */
	    Status["Skipped"] = "skipped";
	    /** The event was sent to Sentry successfully. */
	    Status["Success"] = "success";
	    /** The client is currently rate limited and will try again later. */
	    Status["RateLimit"] = "rate_limit";
	    /** The event could not be processed. */
	    Status["Invalid"] = "invalid";
	    /** A server-side error ocurred during submission. */
	    Status["Failed"] = "failed";
	})(Status = exports.Status || (exports.Status = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Status) {
	    /**
	     * Converts a HTTP status code into a {@link Status}.
	     *
	     * @param code The HTTP response status code.
	     * @returns The send status or {@link Status.Unknown}.
	     */
	    function fromHttpCode(code) {
	        if (code >= 200 && code < 300) {
	            return Status.Success;
	        }
	        if (code === 429) {
	            return Status.RateLimit;
	        }
	        if (code >= 400 && code < 500) {
	            return Status.Invalid;
	        }
	        if (code >= 500) {
	            return Status.Failed;
	        }
	        return Status.Unknown;
	    }
	    Status.fromHttpCode = fromHttpCode;
	})(Status = exports.Status || (exports.Status = {}));
	//# sourceMappingURL=status.js.map

/***/ },
/* 303 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var TransactionSamplingMethod;
	(function (TransactionSamplingMethod) {
	    TransactionSamplingMethod["Explicit"] = "explicitly_set";
	    TransactionSamplingMethod["Sampler"] = "client_sampler";
	    TransactionSamplingMethod["Rate"] = "client_rate";
	    TransactionSamplingMethod["Inheritance"] = "inheritance";
	})(TransactionSamplingMethod = exports.TransactionSamplingMethod || (exports.TransactionSamplingMethod = {}));
	//# sourceMappingURL=transaction.js.map

/***/ },
/* 304 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Consumes the promise and logs the error when it rejects.
	 * @param promise A promise to forget.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function forget(promise) {
	    promise.then(null, function (e) {
	        // TODO: Use a better logging mechanism
	        // eslint-disable-next-line no-console
	        console.error(e);
	    });
	}
	exports.forget = forget;
	//# sourceMappingURL=async.js.map

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var error_1 = __webpack_require__(85);
	/** Regular expression used to parse a Dsn. */
	var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
	/** Error message */
	var ERROR_MESSAGE = 'Invalid Dsn';
	/** The Sentry Dsn, identifying a Sentry instance and project. */
	var Dsn = /** @class */ (function () {
	    /** Creates a new Dsn component */
	    function Dsn(from) {
	        if (typeof from === 'string') {
	            this._fromString(from);
	        }
	        else {
	            this._fromComponents(from);
	        }
	        this._validate();
	    }
	    /**
	     * Renders the string representation of this Dsn.
	     *
	     * By default, this will render the public representation without the password
	     * component. To get the deprecated private representation, set `withPassword`
	     * to true.
	     *
	     * @param withPassword When set to true, the password will be included.
	     */
	    Dsn.prototype.toString = function (withPassword) {
	        if (withPassword === void 0) { withPassword = false; }
	        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
	        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
	            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
	    };
	    /** Parses a string into this Dsn. */
	    Dsn.prototype._fromString = function (str) {
	        var match = DSN_REGEX.exec(str);
	        if (!match) {
	            throw new error_1.SentryError(ERROR_MESSAGE);
	        }
	        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
	        var path = '';
	        var projectId = lastPath;
	        var split = projectId.split('/');
	        if (split.length > 1) {
	            path = split.slice(0, -1).join('/');
	            projectId = split.pop();
	        }
	        if (projectId) {
	            var projectMatch = projectId.match(/^\d+/);
	            if (projectMatch) {
	                projectId = projectMatch[0];
	            }
	        }
	        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
	    };
	    /** Maps Dsn components into this instance. */
	    Dsn.prototype._fromComponents = function (components) {
	        this.protocol = components.protocol;
	        this.user = components.user;
	        this.pass = components.pass || '';
	        this.host = components.host;
	        this.port = components.port || '';
	        this.path = components.path || '';
	        this.projectId = components.projectId;
	    };
	    /** Validates this Dsn and throws on error. */
	    Dsn.prototype._validate = function () {
	        var _this = this;
	        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
	            if (!_this[component]) {
	                throw new error_1.SentryError(ERROR_MESSAGE + ": " + component + " missing");
	            }
	        });
	        if (!this.projectId.match(/^\d+$/)) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
	        }
	        if (this.protocol !== 'http' && this.protocol !== 'https') {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
	        }
	        if (this.port && isNaN(parseInt(this.port, 10))) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
	        }
	    };
	    return Dsn;
	}());
	exports.Dsn = Dsn;
	//# sourceMappingURL=dsn.js.map

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(11);
	var is_1 = __webpack_require__(37);
	var logger_1 = __webpack_require__(86);
	var misc_1 = __webpack_require__(49);
	var object_1 = __webpack_require__(88);
	var stacktrace_1 = __webpack_require__(89);
	var supports_1 = __webpack_require__(157);
	var global = misc_1.getGlobalObject();
	/**
	 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
	 *  - Console API
	 *  - Fetch API
	 *  - XHR API
	 *  - History API
	 *  - DOM API (click/typing)
	 *  - Error API
	 *  - UnhandledRejection API
	 */
	var handlers = {};
	var instrumented = {};
	/** Instruments given API */
	function instrument(type) {
	    if (instrumented[type]) {
	        return;
	    }
	    instrumented[type] = true;
	    switch (type) {
	        case 'console':
	            instrumentConsole();
	            break;
	        case 'dom':
	            instrumentDOM();
	            break;
	        case 'xhr':
	            instrumentXHR();
	            break;
	        case 'fetch':
	            instrumentFetch();
	            break;
	        case 'history':
	            instrumentHistory();
	            break;
	        case 'error':
	            instrumentError();
	            break;
	        case 'unhandledrejection':
	            instrumentUnhandledRejection();
	            break;
	        default:
	            logger_1.logger.warn('unknown instrumentation type:', type);
	    }
	}
	/**
	 * Add handler that will be called when given type of instrumentation triggers.
	 * Use at your own risk, this might break without changelog notice, only used internally.
	 * @hidden
	 */
	function addInstrumentationHandler(handler) {
	    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
	        return;
	    }
	    handlers[handler.type] = handlers[handler.type] || [];
	    handlers[handler.type].push(handler.callback);
	    instrument(handler.type);
	}
	exports.addInstrumentationHandler = addInstrumentationHandler;
	/** JSDoc */
	function triggerHandlers(type, data) {
	    var e_1, _a;
	    if (!type || !handlers[type]) {
	        return;
	    }
	    try {
	        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var handler = _c.value;
	            try {
	                handler(data);
	            }
	            catch (e) {
	                logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError: " + e);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/** JSDoc */
	function instrumentConsole() {
	    if (!('console' in global)) {
	        return;
	    }
	    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
	        if (!(level in global.console)) {
	            return;
	        }
	        object_1.fill(global.console, level, function (originalConsoleLevel) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                triggerHandlers('console', { args: args, level: level });
	                // this fails for some browsers. :(
	                if (originalConsoleLevel) {
	                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
	                }
	            };
	        });
	    });
	}
	/** JSDoc */
	function instrumentFetch() {
	    if (!supports_1.supportsNativeFetch()) {
	        return;
	    }
	    object_1.fill(global, 'fetch', function (originalFetch) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var handlerData = {
	                args: args,
	                fetchData: {
	                    method: getFetchMethod(args),
	                    url: getFetchUrl(args),
	                },
	                startTimestamp: Date.now(),
	            };
	            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return originalFetch.apply(global, args).then(function (response) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
	                return response;
	            }, function (error) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
	                //       it means the sentry.javascript SDK caught an error invoking your application code.
	                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
	                throw error;
	            });
	        };
	    });
	}
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/** Extract `method` from fetch call arguments */
	function getFetchMethod(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
	        return String(fetchArgs[0].method).toUpperCase();
	    }
	    if (fetchArgs[1] && fetchArgs[1].method) {
	        return String(fetchArgs[1].method).toUpperCase();
	    }
	    return 'GET';
	}
	/** Extract `url` from fetch call arguments */
	function getFetchUrl(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if (typeof fetchArgs[0] === 'string') {
	        return fetchArgs[0];
	    }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
	        return fetchArgs[0].url;
	    }
	    return String(fetchArgs[0]);
	}
	/* eslint-enable @typescript-eslint/no-unsafe-member-access */
	/** JSDoc */
	function instrumentXHR() {
	    if (!('XMLHttpRequest' in global)) {
	        return;
	    }
	    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
	    var requestKeys = [];
	    var requestValues = [];
	    var xhrproto = XMLHttpRequest.prototype;
	    object_1.fill(xhrproto, 'open', function (originalOpen) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var url = args[1];
	            xhr.__sentry_xhr__ = {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
	                url: args[1],
	            };
	            // if Sentry key appears in URL, don't capture it as a request
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (is_1.isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
	                xhr.__sentry_own_request__ = true;
	            }
	            var onreadystatechangeHandler = function () {
	                if (xhr.readyState === 4) {
	                    try {
	                        // touching statusCode in some platforms throws
	                        // an exception
	                        if (xhr.__sentry_xhr__) {
	                            xhr.__sentry_xhr__.status_code = xhr.status;
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    try {
	                        var requestPos = requestKeys.indexOf(xhr);
	                        if (requestPos !== -1) {
	                            // Make sure to pop both key and value to keep it in sync.
	                            requestKeys.splice(requestPos);
	                            var args_1 = requestValues.splice(requestPos)[0];
	                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
	                                xhr.__sentry_xhr__.body = args_1[0];
	                            }
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    triggerHandlers('xhr', {
	                        args: args,
	                        endTimestamp: Date.now(),
	                        startTimestamp: Date.now(),
	                        xhr: xhr,
	                    });
	                }
	            };
	            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                object_1.fill(xhr, 'onreadystatechange', function (original) {
	                    return function () {
	                        var readyStateArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            readyStateArgs[_i] = arguments[_i];
	                        }
	                        onreadystatechangeHandler();
	                        return original.apply(xhr, readyStateArgs);
	                    };
	                });
	            }
	            else {
	                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
	            }
	            return originalOpen.apply(xhr, args);
	        };
	    });
	    object_1.fill(xhrproto, 'send', function (originalSend) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            requestKeys.push(this);
	            requestValues.push(args);
	            triggerHandlers('xhr', {
	                args: args,
	                startTimestamp: Date.now(),
	                xhr: this,
	            });
	            return originalSend.apply(this, args);
	        };
	    });
	}
	var lastHref;
	/** JSDoc */
	function instrumentHistory() {
	    if (!supports_1.supportsHistory()) {
	        return;
	    }
	    var oldOnPopState = global.onpopstate;
	    global.onpopstate = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var to = global.location.href;
	        // keep track of the current URL state, as we always receive only the updated state
	        var from = lastHref;
	        lastHref = to;
	        triggerHandlers('history', {
	            from: from,
	            to: to,
	        });
	        if (oldOnPopState) {
	            return oldOnPopState.apply(this, args);
	        }
	    };
	    /** @hidden */
	    function historyReplacementFunction(originalHistoryFunction) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var url = args.length > 2 ? args[2] : undefined;
	            if (url) {
	                // coerce to string (this is what pushState does)
	                var from = lastHref;
	                var to = String(url);
	                // keep track of the current URL state, as we always receive only the updated state
	                lastHref = to;
	                triggerHandlers('history', {
	                    from: from,
	                    to: to,
	                });
	            }
	            return originalHistoryFunction.apply(this, args);
	        };
	    }
	    object_1.fill(global.history, 'pushState', historyReplacementFunction);
	    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
	}
	/** JSDoc */
	function instrumentDOM() {
	    if (!('document' in global)) {
	        return;
	    }
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
	    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
	    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
	    ['EventTarget', 'Node'].forEach(function (target) {
	        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	        object_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                if (fn && fn.handleEvent) {
	                    if (eventName === 'click') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                    if (eventName === 'keypress') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                }
	                else {
	                    if (eventName === 'click') {
	                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
	                    }
	                    if (eventName === 'keypress') {
	                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
	                    }
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	        object_1.fill(proto, 'removeEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    original.call(this, eventName, fn.__sentry_wrapped__, options);
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	    });
	}
	var debounceDuration = 1000;
	var debounceTimer = 0;
	var keypressTimeout;
	var lastCapturedEvent;
	/**
	 * Wraps addEventListener to capture UI breadcrumbs
	 * @param name the event name (e.g. "click")
	 * @param handler function that will be triggered
	 * @param debounce decides whether it should wait till another event loop
	 * @returns wrapped breadcrumb events handler
	 * @hidden
	 */
	function domEventHandler(name, handler, debounce) {
	    if (debounce === void 0) { debounce = false; }
	    return function (event) {
	        // reset keypress timeout; e.g. triggering a 'click' after
	        // a 'keypress' will reset the keypress debounce so that a new
	        // set of keypresses can be recorded
	        keypressTimeout = undefined;
	        // It's possible this handler might trigger multiple times for the same
	        // event (e.g. event propagation through node ancestors). Ignore if we've
	        // already captured the event.
	        if (!event || lastCapturedEvent === event) {
	            return;
	        }
	        lastCapturedEvent = event;
	        if (debounceTimer) {
	            clearTimeout(debounceTimer);
	        }
	        if (debounce) {
	            debounceTimer = setTimeout(function () {
	                handler({ event: event, name: name });
	            });
	        }
	        else {
	            handler({ event: event, name: name });
	        }
	    };
	}
	/**
	 * Wraps addEventListener to capture keypress UI events
	 * @param handler function that will be triggered
	 * @returns wrapped keypress events handler
	 * @hidden
	 */
	function keypressEventHandler(handler) {
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function (event) {
	        var target;
	        try {
	            target = event.target;
	        }
	        catch (e) {
	            // just accessing event properties can throw an exception in some rare circumstances
	            // see: https://github.com/getsentry/raven-js/issues/838
	            return;
	        }
	        var tagName = target && target.tagName;
	        // only consider keypress events on actual input elements
	        // this will disregard keypresses targeting body (e.g. tabbing
	        // through elements, hotkeys, etc)
	        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
	            return;
	        }
	        // record first keypress in a series, but ignore subsequent
	        // keypresses until debounce clears
	        if (!keypressTimeout) {
	            domEventHandler('input', handler)(event);
	        }
	        clearTimeout(keypressTimeout);
	        keypressTimeout = setTimeout(function () {
	            keypressTimeout = undefined;
	        }, debounceDuration);
	    };
	}
	var _oldOnErrorHandler = null;
	/** JSDoc */
	function instrumentError() {
	    _oldOnErrorHandler = global.onerror;
	    global.onerror = function (msg, url, line, column, error) {
	        triggerHandlers('error', {
	            column: column,
	            error: error,
	            line: line,
	            msg: msg,
	            url: url,
	        });
	        if (_oldOnErrorHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnErrorHandler.apply(this, arguments);
	        }
	        return false;
	    };
	}
	var _oldOnUnhandledRejectionHandler = null;
	/** JSDoc */
	function instrumentUnhandledRejection() {
	    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
	    global.onunhandledrejection = function (e) {
	        triggerHandlers('unhandledrejection', e);
	        if (_oldOnUnhandledRejectionHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
	        }
	        return true;
	    };
	}
	//# sourceMappingURL=instrument.js.map

/***/ },
/* 307 */
/***/ function(module, exports) {

	// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
	// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	function normalizeArray(parts, allowAboveRoot) {
	    // if the path tries to go above the root, `up` ends up > 0
	    var up = 0;
	    for (var i = parts.length - 1; i >= 0; i--) {
	        var last = parts[i];
	        if (last === '.') {
	            parts.splice(i, 1);
	        }
	        else if (last === '..') {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up++;
	        }
	        else if (up) {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up--;
	        }
	    }
	    // if the path is allowed to go above the root, restore leading ..s
	    if (allowAboveRoot) {
	        // eslint-disable-next-line no-plusplus
	        for (; up--; up) {
	            parts.unshift('..');
	        }
	    }
	    return parts;
	}
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
	/** JSDoc */
	function splitPath(filename) {
	    var parts = splitPathRe.exec(filename);
	    return parts ? parts.slice(1) : [];
	}
	// path.resolve([from ...], to)
	// posix version
	/** JSDoc */
	function resolve() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resolvedPath = '';
	    var resolvedAbsolute = false;
	    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	        var path = i >= 0 ? args[i] : '/';
	        // Skip empty entries
	        if (!path) {
	            continue;
	        }
	        resolvedPath = path + "/" + resolvedPath;
	        resolvedAbsolute = path.charAt(0) === '/';
	    }
	    // At this point the path should be resolved to a full absolute path, but
	    // handle relative paths to be safe (might happen when process.cwd() fails)
	    // Normalize the path
	    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
	    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
	}
	exports.resolve = resolve;
	/** JSDoc */
	function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	        if (arr[start] !== '') {
	            break;
	        }
	    }
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	        if (arr[end] !== '') {
	            break;
	        }
	    }
	    if (start > end) {
	        return [];
	    }
	    return arr.slice(start, end - start + 1);
	}
	// path.relative(from, to)
	// posix version
	/** JSDoc */
	function relative(from, to) {
	    /* eslint-disable no-param-reassign */
	    from = resolve(from).substr(1);
	    to = resolve(to).substr(1);
	    /* eslint-enable no-param-reassign */
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	}
	exports.relative = relative;
	// path.normalize(path)
	// posix version
	/** JSDoc */
	function normalizePath(path) {
	    var isPathAbsolute = isAbsolute(path);
	    var trailingSlash = path.substr(-1) === '/';
	    // Normalize the path
	    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
	    if (!normalizedPath && !isPathAbsolute) {
	        normalizedPath = '.';
	    }
	    if (normalizedPath && trailingSlash) {
	        normalizedPath += '/';
	    }
	    return (isPathAbsolute ? '/' : '') + normalizedPath;
	}
	exports.normalizePath = normalizePath;
	// posix version
	/** JSDoc */
	function isAbsolute(path) {
	    return path.charAt(0) === '/';
	}
	exports.isAbsolute = isAbsolute;
	// posix version
	/** JSDoc */
	function join() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return normalizePath(args.join('/'));
	}
	exports.join = join;
	/** JSDoc */
	function dirname(path) {
	    var result = splitPath(path);
	    var root = result[0];
	    var dir = result[1];
	    if (!root && !dir) {
	        // No dirname whatsoever
	        return '.';
	    }
	    if (dir) {
	        // It has a dirname, strip trailing slash
	        dir = dir.substr(0, dir.length - 1);
	    }
	    return root + dir;
	}
	exports.dirname = dirname;
	/** JSDoc */
	function basename(path, ext) {
	    var f = splitPath(path)[2];
	    if (ext && f.substr(ext.length * -1) === ext) {
	        f = f.substr(0, f.length - ext.length);
	    }
	    return f;
	}
	exports.basename = basename;
	//# sourceMappingURL=path.js.map

/***/ },
/* 308 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
	/**
	 * setPrototypeOf polyfill using __proto__
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function setProtoOf(obj, proto) {
	    // @ts-ignore __proto__ does not exist on obj
	    obj.__proto__ = proto;
	    return obj;
	}
	/**
	 * setPrototypeOf polyfill using mixin
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function mixinProperties(obj, proto) {
	    for (var prop in proto) {
	        // eslint-disable-next-line no-prototype-builtins
	        if (!obj.hasOwnProperty(prop)) {
	            // @ts-ignore typescript complains about indexing so we remove
	            obj[prop] = proto[prop];
	        }
	    }
	    return obj;
	}
	//# sourceMappingURL=polyfill.js.map

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(85);
	var syncpromise_1 = __webpack_require__(158);
	/** A simple queue that holds promises. */
	var PromiseBuffer = /** @class */ (function () {
	    function PromiseBuffer(_limit) {
	        this._limit = _limit;
	        /** Internal set of queued Promises */
	        this._buffer = [];
	    }
	    /**
	     * Says if the buffer is ready to take more requests
	     */
	    PromiseBuffer.prototype.isReady = function () {
	        return this._limit === undefined || this.length() < this._limit;
	    };
	    /**
	     * Add a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns The original promise.
	     */
	    PromiseBuffer.prototype.add = function (task) {
	        var _this = this;
	        if (!this.isReady()) {
	            return syncpromise_1.SyncPromise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
	        }
	        if (this._buffer.indexOf(task) === -1) {
	            this._buffer.push(task);
	        }
	        task
	            .then(function () { return _this.remove(task); })
	            .then(null, function () {
	            return _this.remove(task).then(null, function () {
	                // We have to add this catch here otherwise we have an unhandledPromiseRejection
	                // because it's a new Promise chain.
	            });
	        });
	        return task;
	    };
	    /**
	     * Remove a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns Removed promise.
	     */
	    PromiseBuffer.prototype.remove = function (task) {
	        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
	        return removedTask;
	    };
	    /**
	     * This function returns the number of unresolved promises in the queue.
	     */
	    PromiseBuffer.prototype.length = function () {
	        return this._buffer.length;
	    };
	    /**
	     * This will drain the whole queue, returns true if queue is empty or drained.
	     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
	     *
	     * @param timeout Number in ms to wait until it resolves with false.
	     */
	    PromiseBuffer.prototype.drain = function (timeout) {
	        var _this = this;
	        return new syncpromise_1.SyncPromise(function (resolve) {
	            var capturedSetTimeout = setTimeout(function () {
	                if (timeout && timeout > 0) {
	                    resolve(false);
	                }
	            }, timeout);
	            syncpromise_1.SyncPromise.all(_this._buffer)
	                .then(function () {
	                clearTimeout(capturedSetTimeout);
	                resolve(true);
	            })
	                .then(null, function () {
	                resolve(true);
	            });
	        });
	    };
	    return PromiseBuffer;
	}());
	exports.PromiseBuffer = PromiseBuffer;
	//# sourceMappingURL=promisebuffer.js.map

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var misc_1 = __webpack_require__(49);
	var node_1 = __webpack_require__(87);
	/**
	 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
	 *
	 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
	 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
	 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
	 */
	var dateTimestampSource = {
	    nowSeconds: function () { return Date.now() / 1000; },
	};
	/**
	 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
	 * support the API.
	 *
	 * Wrapping the native API works around differences in behavior from different browsers.
	 */
	function getBrowserPerformance() {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        return undefined;
	    }
	    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
	    //
	    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
	    // performance.now() gives a date arbitrarily in the past.
	    //
	    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
	    // undefined.
	    //
	    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
	    // interact with data coming out of performance entries.
	    //
	    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
	    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
	    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
	    // observed skews that can be as long as days, weeks or months.
	    //
	    // See https://github.com/getsentry/sentry-javascript/issues/2590.
	    //
	    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
	    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
	    // transactions of long-lived web pages.
	    var timeOrigin = Date.now() - performance.now();
	    return {
	        now: function () { return performance.now(); },
	        timeOrigin: timeOrigin,
	    };
	}
	/**
	 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
	 * implement the API.
	 */
	function getNodePerformance() {
	    try {
	        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
	        return perfHooks.performance;
	    }
	    catch (_) {
	        return undefined;
	    }
	}
	/**
	 * The Performance API implementation for the current platform, if available.
	 */
	var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
	var timestampSource = platformPerformance === undefined
	    ? dateTimestampSource
	    : {
	        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
	    };
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
	 */
	exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
	 * availability of the Performance API.
	 *
	 * See `usingPerformanceAPI` to test whether the Performance API is used.
	 *
	 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
	 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
	 * skew can grow to arbitrary amounts like days, weeks or months.
	 * See https://github.com/getsentry/sentry-javascript/issues/2590.
	 */
	exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
	// Re-exported with an old name for backwards-compatibility.
	exports.timestampWithMs = exports.timestampInSeconds;
	/**
	 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
	 */
	exports.usingPerformanceAPI = platformPerformance !== undefined;
	/**
	 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
	 * performance API is available.
	 */
	exports.browserPerformanceTimeOrigin = (function () {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance) {
	        return undefined;
	    }
	    if (performance.timeOrigin) {
	        return performance.timeOrigin;
	    }
	    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
	    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
	    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
	    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
	    // Date API.
	    // eslint-disable-next-line deprecation/deprecation
	    return (performance.timing && performance.timing.navigationStart) || Date.now();
	})();
	//# sourceMappingURL=time.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)(module)))

/***/ },
/* 311 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(313);

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	var bind = __webpack_require__(165);
	var Axios = __webpack_require__(315);
	var mergeConfig = __webpack_require__(163);
	var defaults = __webpack_require__(164);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(160);
	axios.CancelToken = __webpack_require__(314);
	axios.isCancel = __webpack_require__(161);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(328);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(160);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	var buildURL = __webpack_require__(166);
	var InterceptorManager = __webpack_require__(316);
	var dispatchRequest = __webpack_require__(318);
	var mergeConfig = __webpack_require__(163);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(324);
	var combineURLs = __webpack_require__(322);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	var transformData = __webpack_require__(321);
	var isCancel = __webpack_require__(161);
	var defaults = __webpack_require__(164);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 319 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(162);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 322 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 324 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(21);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 328 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	// Public pages
	
	
	// Users pages
	
	
	// Administrator pages
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _ErrorBoundary = __webpack_require__(170);
	
	var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);
	
	var _PrivateRoute = __webpack_require__(510);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _ApiConfig = __webpack_require__(91);
	
	var _ApiConfig2 = _interopRequireDefault(_ApiConfig);
	
	var _publicPaths = __webpack_require__(513);
	
	var _Header = __webpack_require__(93);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _message = __webpack_require__(188);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _Layout = __webpack_require__(6);
	
	var _Login = __webpack_require__(468);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _onfirmation = __webpack_require__(477);
	
	var _onfirmation2 = _interopRequireDefault(_onfirmation);
	
	var _wiki = __webpack_require__(476);
	
	var _wiki2 = _interopRequireDefault(_wiki);
	
	var _index = __webpack_require__(475);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ApiV3DocsRedirect = __webpack_require__(467);
	
	var _ApiV3DocsRedirect2 = _interopRequireDefault(_ApiV3DocsRedirect);
	
	var _Pay = __webpack_require__(471);
	
	var _Pay2 = _interopRequireDefault(_Pay);
	
	var _Pay3 = __webpack_require__(472);
	
	var _Pay4 = _interopRequireDefault(_Pay3);
	
	var _PayTransfer = __webpack_require__(473);
	
	var _PayTransfer2 = _interopRequireDefault(_PayTransfer);
	
	var _NPay = __webpack_require__(469);
	
	var _NPay2 = _interopRequireDefault(_NPay);
	
	var _Widget = __webpack_require__(474);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	var _Dashboard = __webpack_require__(479);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _RegistryUpload = __webpack_require__(502);
	
	var _RegistryUpload2 = _interopRequireDefault(_RegistryUpload);
	
	var _Pay5 = __webpack_require__(490);
	
	var _Pay6 = _interopRequireDefault(_Pay5);
	
	var _Projects = __webpack_require__(500);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _ProjectSettings = __webpack_require__(499);
	
	var _ProjectSettings2 = _interopRequireDefault(_ProjectSettings);
	
	var _Transactions = __webpack_require__(507);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	var _Payouts = __webpack_require__(491);
	
	var _Payouts2 = _interopRequireDefault(_Payouts);
	
	var _PayoutsDetail = __webpack_require__(492);
	
	var _PayoutsDetail2 = _interopRequireDefault(_PayoutsDetail);
	
	var _Refills = __webpack_require__(501);
	
	var _Refills2 = _interopRequireDefault(_Refills);
	
	var _Statement = __webpack_require__(505);
	
	var _Statement2 = _interopRequireDefault(_Statement);
	
	var _Profile = __webpack_require__(498);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _SecretChats = __webpack_require__(504);
	
	var _SecretChats2 = _interopRequireDefault(_SecretChats);
	
	var _Prepaid = __webpack_require__(493);
	
	var _Prepaid2 = _interopRequireDefault(_Prepaid);
	
	var _PrepaidActivate = __webpack_require__(494);
	
	var _PrepaidActivate2 = _interopRequireDefault(_PrepaidActivate);
	
	var _PrepaidDetails = __webpack_require__(495);
	
	var _PrepaidDetails2 = _interopRequireDefault(_PrepaidDetails);
	
	var _UserAntiFraudCheck = __webpack_require__(508);
	
	var _UserAntiFraudCheck2 = _interopRequireDefault(_UserAntiFraudCheck);
	
	var _UserAntiFraudSingleCheck = __webpack_require__(509);
	
	var _UserAntiFraudSingleCheck2 = _interopRequireDefault(_UserAntiFraudSingleCheck);
	
	var _AntiFraudLog = __webpack_require__(478);
	
	var _AntiFraudLog2 = _interopRequireDefault(_AntiFraudLog);
	
	var _MobilePayouts = __webpack_require__(488);
	
	var _MobilePayouts2 = _interopRequireDefault(_MobilePayouts);
	
	var _MobileRegistryUpload = __webpack_require__(489);
	
	var _MobileRegistryUpload2 = _interopRequireDefault(_MobileRegistryUpload);
	
	var _SbpPay = __webpack_require__(503);
	
	var _SbpPay2 = _interopRequireDefault(_SbpPay);
	
	var _Console = __webpack_require__(446);
	
	var _Console2 = _interopRequireDefault(_Console);
	
	var _Accounts = __webpack_require__(443);
	
	var _Accounts2 = _interopRequireDefault(_Accounts);
	
	var _Ptojects = __webpack_require__(457);
	
	var _Ptojects2 = _interopRequireDefault(_Ptojects);
	
	var _Terminals = __webpack_require__(463);
	
	var _Terminals2 = _interopRequireDefault(_Terminals);
	
	var _Profile3 = __webpack_require__(456);
	
	var _Profile4 = _interopRequireDefault(_Profile3);
	
	var _Payouts3 = __webpack_require__(454);
	
	var _Payouts4 = _interopRequireDefault(_Payouts3);
	
	var _ReportConstructor = __webpack_require__(459);
	
	var _ReportConstructor2 = _interopRequireDefault(_ReportConstructor);
	
	var _Frod = __webpack_require__(452);
	
	var _Frod2 = _interopRequireDefault(_Frod);
	
	var _Postman = __webpack_require__(455);
	
	var _Postman2 = _interopRequireDefault(_Postman);
	
	var _AdminAudit = __webpack_require__(444);
	
	var _AdminAudit2 = _interopRequireDefault(_AdminAudit);
	
	var _TransactionAudit = __webpack_require__(466);
	
	var _TransactionAudit2 = _interopRequireDefault(_TransactionAudit);
	
	var _AntiFraud = __webpack_require__(445);
	
	var _AntiFraud2 = _interopRequireDefault(_AntiFraud);
	
	var _PayoutHolds = __webpack_require__(453);
	
	var _PayoutHolds2 = _interopRequireDefault(_PayoutHolds);
	
	var _Disputes = __webpack_require__(451);
	
	var _Disputes2 = _interopRequireDefault(_Disputes);
	
	var _CrmPayoutRequests = __webpack_require__(190);
	
	var _CrmPayoutRequests2 = _interopRequireDefault(_CrmPayoutRequests);
	
	var _CrmSbpPayoutRequests = __webpack_require__(449);
	
	var _CrmSbpPayoutRequests2 = _interopRequireDefault(_CrmSbpPayoutRequests);
	
	var _Settlement = __webpack_require__(461);
	
	var _Settlement2 = _interopRequireDefault(_Settlement);
	
	var _Deposit = __webpack_require__(450);
	
	var _Deposit2 = _interopRequireDefault(_Deposit);
	
	var _Reconciliation = __webpack_require__(458);
	
	var _Reconciliation2 = _interopRequireDefault(_Reconciliation);
	
	var _TrafficMonitoring = __webpack_require__(465);
	
	var _TrafficMonitoring2 = _interopRequireDefault(_TrafficMonitoring);
	
	var _Tickets = __webpack_require__(464);
	
	var _Tickets2 = _interopRequireDefault(_Tickets);
	
	var _SecretChats3 = __webpack_require__(460);
	
	var _SecretChats4 = _interopRequireDefault(_SecretChats3);
	
	var _CraftliteLimit = __webpack_require__(447);
	
	var _CraftliteLimit2 = _interopRequireDefault(_CraftliteLimit);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _ru = __webpack_require__(665);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	var _en = __webpack_require__(664);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _ContractsList = __webpack_require__(483);
	
	var _ContractsList2 = _interopRequireDefault(_ContractsList);
	
	var _ContractCreate = __webpack_require__(480);
	
	var _ContractCreate2 = _interopRequireDefault(_ContractCreate);
	
	var _ContractEdit = __webpack_require__(481);
	
	var _ContractEdit2 = _interopRequireDefault(_ContractEdit);
	
	var _PcaList = __webpack_require__(487);
	
	var _PcaList2 = _interopRequireDefault(_PcaList);
	
	var _PcaEdit = __webpack_require__(486);
	
	var _PcaEdit2 = _interopRequireDefault(_PcaEdit);
	
	var _ContractPca = __webpack_require__(482);
	
	var _ContractPca2 = _interopRequireDefault(_ContractPca);
	
	var _PcaCreate = __webpack_require__(484);
	
	var _PcaCreate2 = _interopRequireDefault(_PcaCreate);
	
	var _PcaDuplicate = __webpack_require__(485);
	
	var _PcaDuplicate2 = _interopRequireDefault(_PcaDuplicate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAYMENT_PATHS = ['/pay3', '/pay4', '/PayTransfer', '/npay'];
	
	var USER_CONTOUR_PATHS = ['/registry-upload', '/mobile-registry-upload', '/mobile-payouts', '/pay', '/sbp-pay', '/metal', '/antifraud-check', '/antifraud-single-check', '/antifraud-log', '/prepaid', '/transactions', '/payouts', '/projects', '/refills', '/profile', '/secret-chats', '/statement'];
	
	var ADMIN_CONTOUR_PATHS = ['/console', '/admin-audit', '/accounts-control', '/projects-control', '/terminals-control', '/profile-control', '/payouts-statistic', '/report-constructor', '/frod', '/antifraud', '/payout-holds', '/disputes', '/transaction-audit', '/settlements', '/deposits', '/reconciliation', '/traffic-monitoring', '/admin/tickets', '/admin/secret-chats', '/api-console', '/crm-payout-requests', '/crm-sbp-payout-requests', '/craftlite-limit'];
	
	function UserRoutes(_ref) {
	    var footerProps = _ref.footerProps;
	
	    return _react2.default.createElement(
	        _Layout.UserLayout,
	        { footerProps: footerProps },
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/registry-upload', component: _RegistryUpload2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/mobile-registry-upload', component: _MobileRegistryUpload2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/mobile-payouts', component: _MobilePayouts2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/pay', component: _Pay6.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/pay/:data', component: _Pay6.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/sbp-pay', component: _SbpPay2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal', component: _ContractsList2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal/contract/create', component: _ContractCreate2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal/contract/:ID', component: _ContractEdit2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal/pca', component: _PcaList2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal/pca/:ID', component: _PcaEdit2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal/contract/:ID/pca', component: _ContractPca2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal/contract/:ID/pca/create', component: _PcaCreate2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/metal/pca/duplicate/:ID', component: _PcaDuplicate2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/antifraud-check', component: _UserAntiFraudCheck2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/antifraud-single-check', component: _UserAntiFraudSingleCheck2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/antifraud-log', component: _AntiFraudLog2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/prepaid', component: _Prepaid2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/prepaid/activate/:EAN', component: _PrepaidActivate2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/prepaid/details/:EAN', component: _PrepaidDetails2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/transactions', component: _Transactions2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/transactions/:filters', component: _Transactions2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/payouts', component: _Payouts2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/payouts/registry/:id', component: _PayoutsDetail2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/projects', component: _Projects2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/projects/settings/:uuid', component: _ProjectSettings2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/refills', component: _Refills2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/profile', component: _Profile2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/statement', component: _Statement2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/', component: _Dashboard2.default }),
	        _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' })
	    );
	}
	
	function AdminRoutes(_ref2) {
	    var footerProps = _ref2.footerProps;
	
	    return _react2.default.createElement(
	        _Layout.AdminLayout,
	        { footerProps: footerProps },
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/console', component: _Console2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/admin-audit', component: _AdminAudit2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/accounts-control', component: _Accounts2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/projects-control', component: _Ptojects2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/terminals-control', component: _Terminals2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/profile-control', component: _Profile4.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/payouts-statistic', component: _Payouts4.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/report-constructor', component: _ReportConstructor2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/frod', component: _Frod2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/antifraud', component: _AntiFraud2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/payout-holds', component: _PayoutHolds2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/disputes', component: _Disputes2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/transaction-audit', component: _TransactionAudit2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/settlements', component: _Settlement2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/deposits', component: _Deposit2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/reconciliation', component: _Reconciliation2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/traffic-monitoring', component: _TrafficMonitoring2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { path: '/secret-chats', component: _SecretChats2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/admin/secret-chats', component: _SecretChats4.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/admin/tickets', component: _Tickets2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/admin/tickets/:id', component: _Tickets2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/api-console', component: _Postman2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/crm-payout-requests', component: _CrmPayoutRequests2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/crm-sbp-payout-requests', component: _CrmSbpPayoutRequests2.default }),
	        _react2.default.createElement(_PrivateRoute.PrivateRout, { exact: true, path: '/craftlite-limit', component: _CraftliteLimit2.default }),
	        _react2.default.createElement(_reactRouterDom.Redirect, { to: '/console' })
	    );
	}
	
	function App() {
	    var _useState = (0, _react.useState)('ru'),
	        _useState2 = _slicedToArray(_useState, 2),
	        lang = _useState2[0],
	        setLang = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(_ru2.default),
	        _useState4 = _slicedToArray(_useState3, 2),
	        translate = _useState4[0],
	        setTranslate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)({ type: null, message: '' }),
	        _useState6 = _slicedToArray(_useState5, 2),
	        message = _useState6[0],
	        setMessage = _useState6[1];
	
	    var location = (0, _reactRouterDom.useLocation)();
	    var history = (0, _reactRouterDom.useHistory)();
	    var footerProps = { lang: lang, onChangeLanguage: onChangeLanguage };
	
	    var isPaymentLayout = PAYMENT_PATHS.some(function (path) {
	        return location.pathname.startsWith(path);
	    });
	    var isWidgetPage = location.pathname.startsWith('/pay3') || location.pathname.startsWith('/npay');
	
	    (0, _react.useEffect)(function () {
	        _ApiConfig2.default.setRedirectCallback(function (path) {
	            // С открытых страниц не уводим: протухшая сессия гасится, но человек
	            // остаётся там, куда пришёл (например, на подтверждении почты).
	            if ((0, _publicPaths.isPublicPath)(history.location.pathname)) {
	                return;
	            }
	            history.push(path);
	        });
	    }, [history]);
	
	    (0, _react.useEffect)(function () {
	        var language = window.navigator && (window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage);
	
	        if (!localStorage.getItem('language')) {
	            switch (language.substr(0, 2).toLowerCase()) {
	                case 'ru':
	                    localStorage.setItem('language', 'ru');
	                    setLang('ru');
	                    setTranslate(_ru2.default);
	                    break;
	                default:
	                    localStorage.setItem('language', 'en');
	                    setLang('en');
	                    setTranslate(_en2.default);
	            }
	        } else {
	            switch (localStorage.getItem('language')) {
	                case 'ru':
	                    setLang('ru');
	                    setTranslate(_ru2.default);
	                    break;
	                default:
	                    setLang('en');
	                    setTranslate(_en2.default);
	            }
	        }
	    }, [lang]);
	
	    function onChangeLanguage(selectedLang) {
	        if (selectedLang === 'ru') {
	            setLang('ru');
	            setTranslate(_ru2.default);
	            localStorage.setItem('language', 'ru');
	        } else {
	            setLang('en');
	            setTranslate(_en2.default);
	            localStorage.setItem('language', 'en');
	        }
	    }
	
	    var onMessage = (0, _react.useCallback)(function (value) {
	        setMessage(value);
	        setTimeout(function () {
	            setMessage({ type: null, message: '' });
	        }, 7000);
	    }, []);
	
	    return _react2.default.createElement(
	        _ErrorBoundary2.default,
	        null,
	        _react2.default.createElement(
	            _reactIntl.IntlProvider,
	            { key: lang, locale: lang, messages: translate, defaultLocale: 'ru' },
	            _react2.default.createElement(_message2.default, { value: message }),
	            _react2.default.createElement(
	                _MessageContext2.default.Provider,
	                { value: { onMessage: onMessage } },
	                _react2.default.createElement(
	                    _Auth.AuthProvider,
	                    null,
	                    isPaymentLayout ? _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        !isWidgetPage && _react2.default.createElement(_Header2.default, null),
	                        _react2.default.createElement(
	                            _reactRouterDom.Switch,
	                            null,
	                            _react2.default.createElement(_reactRouterDom.Route, { path: '/pay3', component: _Pay2.default }),
	                            _react2.default.createElement(_reactRouterDom.Route, { path: '/pay4', component: _Pay4.default }),
	                            _react2.default.createElement(_reactRouterDom.Route, { path: '/PayTransfer', component: _PayTransfer2.default }),
	                            _react2.default.createElement(_reactRouterDom.Route, { path: '/npay/:token', component: _NPay2.default }),
	                            _react2.default.createElement(_reactRouterDom.Redirect, { to: '/pay3' })
	                        )
	                    ) : _react2.default.createElement(
	                        _reactRouterDom.Switch,
	                        null,
	                        _react2.default.createElement(_reactRouterDom.Route, {
	                            path: '/login',
	                            component: _Login2.default
	                        }),
	                        _react2.default.createElement(_reactRouterDom.Route, {
	                            path: '/confirmation/:code',
	                            render: function render() {
	                                return _react2.default.createElement(
	                                    _Layout.PublicLayout,
	                                    { footerProps: footerProps },
	                                    _react2.default.createElement(_reactRouterDom.Route, { path: '/confirmation/:code', component: _onfirmation2.default })
	                                );
	                            }
	                        }),
	                        _react2.default.createElement(_reactRouterDom.Route, {
	                            path: '/widget',
	                            render: function render() {
	                                return _react2.default.createElement(
	                                    _Layout.PublicLayout,
	                                    { footerProps: footerProps },
	                                    _react2.default.createElement(_reactRouterDom.Route, { path: '/widget', component: _Widget2.default })
	                                );
	                            }
	                        }),
	                        _react2.default.createElement(_reactRouterDom.Route, {
	                            exact: true,
	                            path: '/wiki',
	                            component: _ApiV3DocsRedirect2.default
	                        }),
	                        _react2.default.createElement(_reactRouterDom.Route, {
	                            path: '/wiki/',
	                            render: function render() {
	                                return _react2.default.createElement(
	                                    _Layout.PublicLayout,
	                                    { footerProps: footerProps },
	                                    lang === 'ru' ? _react2.default.createElement(_wiki2.default, null) : _react2.default.createElement(_index2.default, null)
	                                );
	                            }
	                        }),
	                        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: function render() {
	                                return _react2.default.createElement(UserRoutes, { footerProps: footerProps });
	                            } }),
	                        _react2.default.createElement(_PrivateRoute.PrivateRout, {
	                            path: USER_CONTOUR_PATHS,
	                            component: function component(routeProps) {
	                                return _react2.default.createElement(UserRoutes, Object.assign({}, routeProps, { footerProps: footerProps }));
	                            }
	                        }),
	                        _react2.default.createElement(_PrivateRoute.PrivateRout, {
	                            path: ADMIN_CONTOUR_PATHS,
	                            component: function component(routeProps) {
	                                return _react2.default.createElement(AdminRoutes, Object.assign({}, routeProps, { footerProps: footerProps }));
	                            }
	                        }),
	                        _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' })
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = App;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(523);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AntiFraudConfigTab — настройка антифрод каскада для мерчанта.
	 *
	 * Props:
	 *   token (string)
	 *   terminal (object) — { id, projectUuid, ... }
	 */
	function AntiFraudConfigTab(props) {
	    var token = props.token;
	    var terminal = props.terminal;
	
	    var _frodEnabled = (0, _react.useState)(false);
	    var frodEnabled = _frodEnabled[0];
	    var setFrodEnabled = _frodEnabled[1];
	
	    var _antifraud = (0, _react.useState)({
	        payment: { database: false, client: false, scanfraud: false },
	        payout: { database: false, client: false, scanfraud: false }
	    });
	    var antifraud = _antifraud[0];
	    var setAntifraud = _antifraud[1];
	
	    var _saving = (0, _react.useState)(false);
	    var saving = _saving[0];
	    var setSaving = _saving[1];
	
	    var _loading = (0, _react.useState)(true);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _status = (0, _react.useState)(null);
	    var status = _status[0];
	    var setStatus = _status[1];
	
	    // Загрузить текущие настройки из /merchant/{uuid}/full
	    (0, _react.useEffect)(function () {
	        if (!terminal || !terminal.id || !terminal.projectUuid) return;
	        setLoading(true);
	        setStatus(null);
	
	        var api = new _Api2.default({ token: token });
	        api.getFullMerchant(terminal.projectUuid).then(function (data) {
	            var settings = data && data.settings || [];
	            // Берём первый MS привязанный к этому терминалу
	            var ms = null;
	            for (var i = 0; i < settings.length; i++) {
	                if (settings[i].terminalId === terminal.id) {
	                    ms = settings[i];
	                    break;
	                }
	            }
	
	            if (ms) {
	                setFrodEnabled(!!ms.frod);
	                var af = ms.antifraud || {};
	                setAntifraud({
	                    payment: {
	                        database: !!(af.payment && af.payment.database),
	                        client: !!(af.payment && af.payment.client),
	                        scanfraud: !!(af.payment && af.payment.scanfraud)
	                    },
	                    payout: {
	                        database: !!(af.payout && af.payout.database),
	                        client: !!(af.payout && af.payout.client),
	                        scanfraud: !!(af.payout && af.payout.scanfraud)
	                    }
	                });
	            }
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setLoading(false);
	            setStatus({ type: "error", text: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438" });
	        });
	    }, [terminal && terminal.id, terminal && terminal.projectUuid, token]);
	
	    function onToggle(group, key) {
	        setAntifraud(function (prev) {
	            var next = {
	                payment: Object.assign({}, prev.payment),
	                payout: Object.assign({}, prev.payout)
	            };
	            next[group][key] = !next[group][key];
	            return next;
	        });
	    }
	
	    function onSave() {
	        if (!terminal.projectUuid) return;
	        setSaving(true);
	        setStatus(null);
	
	        var api = new _Api2.default({ token: token });
	        api.setFrodData(terminal.projectUuid, {
	            frod: frodEnabled,
	            antifraud: antifraud
	        }).then(function () {
	            setSaving(false);
	            setStatus({ type: "success", text: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B" });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setSaving(false);
	            var msg = err && err.response && err.response.data && err.response.data.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F";
	            setStatus({ type: "error", text: msg });
	        });
	    }
	
	    function renderToggle(group, key, label, desc, paid) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Toggle, key: group + "_" + key }, _react2.default.createElement("input", {
	            type: "checkbox",
	            checked: antifraud[group][key],
	            onChange: function onChange() {
	                onToggle(group, key);
	            }
	        }), _react2.default.createElement("div", { className: _stylesModule2.default.ToggleInfo }, _react2.default.createElement("div", { className: _stylesModule2.default.ToggleLabel }, label), _react2.default.createElement("div", { className: _stylesModule2.default.ToggleDesc }, desc)), _react2.default.createElement("span", {
	            className: paid ? _stylesModule2.default.PaidBadge : _stylesModule2.default.FreeBadge
	        }, paid ? "\u041F\u043B\u0430\u0442\u043D\u043E" : "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"));
	    }
	
	    function renderGroup(title, group) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Group + (!frodEnabled ? " " + _stylesModule2.default.Disabled : "") }, _react2.default.createElement("div", { className: _stylesModule2.default.GroupTitle }, title), renderToggle(group, "database", "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0431\u0430\u0437\u0430 (\u0422\u041A\u0411, FinStar)", "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u043E \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u0432", false), renderToggle(group, "client", "NX \u0441\u0445\u0435\u043C\u0430", "\u0411\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E\u0441\u043B\u0435 \u043D\u0435\u0443\u0434\u0430\u0447\u043D\u044B\u0445 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 (NX blocks)", false), renderToggle(group, "scanfraud", "ScanFraud API", "\u0412\u043D\u0435\u0448\u043D\u0438\u0439 \u0441\u0435\u0440\u0432\u0438\u0441 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u0430", true));
	    }
	
	    if (loading) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
	    }
	
	    return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, _react2.default.createElement("div", { className: _stylesModule2.default.Title }, "\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434 \u043A\u0430\u0441\u043A\u0430\u0434"), _react2.default.createElement("div", { className: _stylesModule2.default.MasterToggle }, _react2.default.createElement("input", {
	        type: "checkbox",
	        checked: frodEnabled,
	        onChange: function onChange() {
	            setFrodEnabled(!frodEnabled);
	        },
	        id: "frod-master-toggle"
	    }), _react2.default.createElement("label", { htmlFor: "frod-master-toggle" }, "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434")), renderGroup("\u041E\u043F\u043B\u0430\u0442\u0430 (Payment)", "payment"), renderGroup("\u0412\u044B\u043F\u043B\u0430\u0442\u044B (Payout)", "payout"),
	    // Выплаты по API проверяются и по блоку антифрода терминала, которого
	    // на этой вкладке нет: без подсказки оператор видит неполную картину.
	    _react2.default.createElement("div", { className: _stylesModule2.default.ToggleDesc }, "\u0414\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442 \u043F\u043E API \u043A \u044D\u0442\u0438\u043C \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u043C \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0440\u0443\u0447\u043D\u044B\u0435 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438 \u0438 ScanFraud, \u0432\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u0435 \u043D\u0430 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0435 (\u0431\u043B\u043E\u043A \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u0430 CRM-\u0437\u0430\u044F\u0432\u043E\u043A)."), _react2.default.createElement("button", {
	        className: _stylesModule2.default.SaveBtn,
	        onClick: onSave,
	        disabled: saving
	    }, saving ? "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..." : "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"), status && _react2.default.createElement("div", {
	        className: _stylesModule2.default.StatusMsg + " " + (status.type === "success" ? _stylesModule2.default.StatusSuccess : _stylesModule2.default.StatusError)
	    }, status.text));
	}
	
	exports.default = AntiFraudConfigTab;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _antiFraudFiltersModule = __webpack_require__(524);
	
	var _antiFraudFiltersModule2 = _interopRequireDefault(_antiFraudFiltersModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AntiFraudFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        accountAccessSettings = _ref.accountAccessSettings,
	        isLoading = _ref.isLoading,
	        token = _ref.token;
	
	    var _useState = (0, _react.useState)({}),
	        _useState2 = _slicedToArray(_useState, 2),
	        dateRange = _useState2[0],
	        setDateRange = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        project = _useState4[0],
	        setProject = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(""),
	        _useState6 = _slicedToArray(_useState5, 2),
	        result = _useState6[0],
	        setResult = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(""),
	        _useState8 = _slicedToArray(_useState7, 2),
	        checkType = _useState8[0],
	        setCheckType = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(""),
	        _useState10 = _slicedToArray(_useState9, 2),
	        clientIp = _useState10[0],
	        setClientIp = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(""),
	        _useState12 = _slicedToArray(_useState11, 2),
	        phone = _useState12[0],
	        setPhone = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(""),
	        _useState14 = _slicedToArray(_useState13, 2),
	        card = _useState14[0],
	        setCard = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        merchants = _useState16[0],
	        setMerchants = _useState16[1];
	
	    // Загружаем список мерчантов через getProjects (как в Transactions)
	
	
	    (0, _react.useEffect)(function () {
	        if (!token) return;
	        var api = new _Api2.default({ token: token });
	        api.getProjects().then(function (data) {
	            if (Array.isArray(data)) {
	                var list = data.map(function (p) {
	                    return { uuid: p.uuid, name: p.displayName || p.name || p.uuid };
	                });
	                setMerchants(list);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	        });
	    }, [token]);
	
	    function handleApply() {
	        var filters = {
	            dateRange: dateRange
	        };
	        if (project) {
	            filters.projects = [project];
	        }
	        if (result) {
	            filters.result = result;
	        }
	        if (checkType) {
	            filters.checkType = checkType;
	        }
	        if (clientIp.trim()) {
	            filters.clientIp = clientIp.trim();
	        }
	        if (phone.trim()) {
	            filters.phone = phone.trim();
	        }
	        if (card.trim()) {
	            filters.card = card.trim();
	        }
	        onApplyFilters(filters);
	    }
	
	    function handleReset() {
	        setProject("");
	        setResult("");
	        setCheckType("");
	        setClientIp("");
	        setPhone("");
	        setCard("");
	        setDateRange({});
	        onApplyFilters({});
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _antiFraudFiltersModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _antiFraudFiltersModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _antiFraudFiltersModule2.default.Group },
	                _react2.default.createElement(
	                    "span",
	                    { className: _antiFraudFiltersModule2.default.Label },
	                    "\u041F\u0435\u0440\u0438\u043E\u0434"
	                ),
	                _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                        setDateRange(range);
	                    }, defaultPeriod: "week" })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _antiFraudFiltersModule2.default.Row },
	                _react2.default.createElement(
	                    "div",
	                    { className: _antiFraudFiltersModule2.default.Group },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _antiFraudFiltersModule2.default.Label },
	                        "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                    ),
	                    _react2.default.createElement(
	                        "select",
	                        {
	                            className: _antiFraudFiltersModule2.default.Select,
	                            value: project,
	                            onChange: function onChange(e) {
	                                setProject(e.target.value);
	                            }
	                        },
	                        _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "\u0412\u0441\u0435"
	                        ),
	                        merchants.map(function (m) {
	                            return _react2.default.createElement(
	                                "option",
	                                { key: m.uuid, value: m.uuid },
	                                m.name
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _antiFraudFiltersModule2.default.Group },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _antiFraudFiltersModule2.default.Label },
	                        "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442"
	                    ),
	                    _react2.default.createElement(
	                        "select",
	                        {
	                            className: _antiFraudFiltersModule2.default.Select,
	                            value: result,
	                            onChange: function onChange(e) {
	                                setResult(e.target.value);
	                            }
	                        },
	                        _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "\u0412\u0441\u0435"
	                        ),
	                        _react2.default.createElement(
	                            "option",
	                            { value: "ok" },
	                            "\u041E\u041A"
	                        ),
	                        _react2.default.createElement(
	                            "option",
	                            { value: "blocked" },
	                            "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E"
	                        ),
	                        _react2.default.createElement(
	                            "option",
	                            { value: "error" },
	                            "\u041E\u0448\u0438\u0431\u043A\u0430"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _antiFraudFiltersModule2.default.Group },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _antiFraudFiltersModule2.default.Label },
	                        "\u0422\u0438\u043F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438"
	                    ),
	                    _react2.default.createElement(
	                        "select",
	                        {
	                            className: _antiFraudFiltersModule2.default.Select,
	                            value: checkType,
	                            onChange: function onChange(e) {
	                                setCheckType(e.target.value);
	                            }
	                        },
	                        _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "\u0412\u0441\u0435"
	                        ),
	                        _react2.default.createElement(
	                            "option",
	                            { value: "payment" },
	                            "\u041F\u043B\u0430\u0442\u0451\u0436"
	                        ),
	                        _react2.default.createElement(
	                            "option",
	                            { value: "payout" },
	                            "\u0412\u044B\u043F\u043B\u0430\u0442\u0430"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _antiFraudFiltersModule2.default.Row },
	                _react2.default.createElement(
	                    "div",
	                    { className: _antiFraudFiltersModule2.default.Group },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _antiFraudFiltersModule2.default.Label },
	                        "IP"
	                    ),
	                    _react2.default.createElement("input", {
	                        className: _antiFraudFiltersModule2.default.Input,
	                        type: "text",
	                        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 IP",
	                        value: clientIp,
	                        onChange: function onChange(e) {
	                            setClientIp(e.target.value);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _antiFraudFiltersModule2.default.Group },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _antiFraudFiltersModule2.default.Label },
	                        "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
	                    ),
	                    _react2.default.createElement("input", {
	                        className: _antiFraudFiltersModule2.default.Input,
	                        type: "text",
	                        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
	                        value: phone,
	                        onChange: function onChange(e) {
	                            setPhone(e.target.value);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _antiFraudFiltersModule2.default.Group },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _antiFraudFiltersModule2.default.Label },
	                        "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B"
	                    ),
	                    _react2.default.createElement("input", {
	                        className: _antiFraudFiltersModule2.default.Input,
	                        type: "text",
	                        placeholder: "\u041C\u0430\u0441\u043A\u0430 \u043A\u0430\u0440\u0442\u044B",
	                        value: card,
	                        onChange: function onChange(e) {
	                            setCard(e.target.value);
	                        }
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _antiFraudFiltersModule2.default.Footer },
	            _react2.default.createElement(
	                "button",
	                {
	                    className: _antiFraudFiltersModule2.default.Btn,
	                    onClick: handleApply,
	                    disabled: isLoading
	                },
	                "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"
	            ),
	            _react2.default.createElement(
	                "button",
	                {
	                    className: _antiFraudFiltersModule2.default.BtnReset,
	                    onClick: handleReset
	                },
	                "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"
	            )
	        )
	    );
	}
	
	exports.default = AntiFraudFilters;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _antiFraudTableModule = __webpack_require__(525);
	
	var _antiFraudTableModule2 = _interopRequireDefault(_antiFraudTableModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDate(dateStr) {
	    if (!dateStr) return "—";
	    try {
	        var d = new Date(dateStr);
	        var pad = function pad(n) {
	            return n < 10 ? "0" + n : "" + n;
	        };
	        return pad(d.getDate()) + "." + pad(d.getMonth() + 1) + "." + d.getFullYear() + " " + pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
	    } catch (e) {
	        Sentry.captureException(e);
	        return dateStr;
	    }
	}
	
	function getCheckTypeLabel(checkType) {
	    switch (checkType) {
	        case "payment":
	            return "Платёж";
	        case "payout":
	            return "Выплата";
	        default:
	            return checkType || "—";
	    }
	}
	
	function getResultClass(result) {
	    switch (result) {
	        case "ok":
	            return _antiFraudTableModule2.default.ResultOk;
	        case "blocked":
	            return _antiFraudTableModule2.default.ResultBlocked;
	        case "error":
	            return _antiFraudTableModule2.default.ResultError;
	        default:
	            return "";
	    }
	}
	
	function getResultLabel(result) {
	    switch (result) {
	        case "ok":
	            return "ОК";
	        case "blocked":
	            return "Заблокировано";
	        case "error":
	            return "Ошибка";
	        default:
	            return result || "—";
	    }
	}
	
	function getPhoneOrCard(row) {
	    if (row.checkContext) {
	        if (row.checkContext.phoneMasked) return row.checkContext.phoneMasked;
	        if (row.checkContext.cardPanMasked) return row.checkContext.cardPanMasked;
	    }
	    return "—";
	}
	
	function AntiFraudTableRow(_ref) {
	    var row = _ref.row;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            "tr",
	            { className: _antiFraudTableModule2.default.Row, onClick: function onClick() {
	                    setIsOpened(!isOpened);
	                } },
	            _react2.default.createElement(
	                "td",
	                null,
	                row.id
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                formatDate(row.createdAt)
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                row.merchantName || "—"
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                getCheckTypeLabel(row.checkType)
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                getPhoneOrCard(row)
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                row.clientIp || "—"
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                    "span",
	                    { className: getResultClass(row.result) },
	                    getResultLabel(row.result)
	                )
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                row.blockedReason || "—"
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                row.totalTimeMs != null ? row.totalTimeMs + " мс" : "—"
	            )
	        ),
	        isOpened && _react2.default.createElement(
	            "tr",
	            { className: _antiFraudTableModule2.default.DetailRow },
	            _react2.default.createElement(
	                "td",
	                { colSpan: 9 },
	                _react2.default.createElement(
	                    "table",
	                    { className: _antiFraudTableModule2.default.DetailTable },
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        row.blockedBy && _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                { className: _antiFraudTableModule2.default.DetailLabel },
	                                "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u043C:"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                row.blockedBy
	                            )
	                        ),
	                        row.blockedKind && _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                { className: _antiFraudTableModule2.default.DetailLabel },
	                                "\u0422\u0438\u043F \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438:"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                row.blockedKind
	                            )
	                        ),
	                        row.transactionId && _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                { className: _antiFraudTableModule2.default.DetailLabel },
	                                "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438:"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                row.transactionId
	                            )
	                        ),
	                        row.terminalName && _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                { className: _antiFraudTableModule2.default.DetailLabel },
	                                "\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B:"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                row.terminalName
	                            )
	                        )
	                    )
	                ),
	                row.providersChecked && row.providersChecked.length > 0 && _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "strong",
	                        { style: { fontSize: ".8125rem", display: "block", marginTop: 10, marginBottom: 4 } },
	                        "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438:"
	                    ),
	                    _react2.default.createElement(
	                        "table",
	                        { className: _antiFraudTableModule2.default.ProvidersTable },
	                        _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0412\u0440\u0435\u043C\u044F (\u043C\u0441)"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tbody",
	                            null,
	                            row.providersChecked.map(function (p, i) {
	                                return _react2.default.createElement(
	                                    "tr",
	                                    { key: i },
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        p.provider || "—"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: getResultClass(p.result) },
	                                            getResultLabel(p.result)
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        p.timeMs != null ? p.timeMs : "—"
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	function AntiFraudTable(_ref2) {
	    var data = _ref2.data,
	        isLoading = _ref2.isLoading;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _antiFraudTableModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _antiFraudTableModule2.default.Table },
	            _react2.default.createElement(
	                "table",
	                null,
	                _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u0414\u0430\u0442\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u0422\u0438\u043F"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u0422\u0435\u043B\u0435\u0444\u043E\u043D/\u041A\u0430\u0440\u0442\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "IP"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u041F\u0440\u0438\u0447\u0438\u043D\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            "\u0412\u0440\u0435\u043C\u044F"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "tbody",
	                    null,
	                    data && data.length > 0 ? isLoading ? data.map(function (row) {
	                        return _react2.default.createElement(AntiFraudTableRow, { key: row.id, row: row });
	                    }) : _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            { colSpan: 9, style: { textAlign: "center" } },
	                            _react2.default.createElement(_Loader2.default, null)
	                        )
	                    ) : _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "td",
	                            { colSpan: 9 },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _antiFraudTableModule2.default.Empty },
	                                _react2.default.createElement(
	                                    "h5",
	                                    null,
	                                    "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = AntiFraudTable;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(526);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatBalance(value) {
	    if (value === null || value === undefined) {
	        return '0';
	    }
	    return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
	
	function BalanceSection(_ref) {
	    var section = _ref.section,
	        sectionTitle = _ref.sectionTitle;
	
	    if (!section) return null;
	    var labels = section.labels || {};
	    var hints = section.hints || {};
	    var intl = (0, _reactIntl.useIntl)();
	    var transactionLabel = labels.transactionBalance || intl.formatMessage({ id: 'BalanceWidget.transactionBalance', defaultMessage: 'Транзакционный баланс' });
	    var settlementLabel = labels.settlementBalance || intl.formatMessage({ id: 'BalanceWidget.settlementLabel.reimbursement', defaultMessage: 'Возмещение' });
	    var actualLabel = labels.actualBalance || intl.formatMessage({ id: 'BalanceWidget.actualBalance', defaultMessage: 'Действительный баланс' });
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.ExtendedBalances },
	        sectionTitle && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.SectionTitle, style: { fontWeight: 600, fontSize: 13, color: '#555', padding: '4px 0' } },
	            sectionTitle
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.BalanceRow + ' ' + _stylesModule2.default.TransactionBalance, title: hints.transactionBalance || '' },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceLabel },
	                transactionLabel
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceValue },
	                formatBalance(section.transactionBalanceFloat),
	                ' \u20BD'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.BalanceRow + ' ' + _stylesModule2.default.SettlementBalance, title: hints.settlementBalance || '' },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceLabel },
	                settlementLabel
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceValue },
	                formatBalance(section.settlementBalanceFloat),
	                ' \u20BD'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.BalanceRow + ' ' + _stylesModule2.default.ActualBalance, title: hints.actualBalance || '' },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceLabel },
	                actualLabel
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceValue },
	                formatBalance(section.actualBalanceFloat),
	                ' \u20BD'
	            )
	        )
	    );
	}
	
	function ExtendedBalancesView(_ref2) {
	    var totals = _ref2.totals;
	
	    var intl = (0, _reactIntl.useIntl)();
	    // Новый формат: разделённые payin / payout секции. Для mixed-мерчантов — обе.
	    var hasPayin = totals.payin && totals.payin.count > 0;
	    var hasPayout = totals.payout && totals.payout.count > 0;
	    var isMixed = totals.hasMixed || hasPayin && hasPayout;
	
	    if (isMixed) {
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(BalanceSection, { section: totals.payin, sectionTitle: intl.formatMessage({ id: 'BalanceWidget.section.payin', defaultMessage: 'Приём платежей' }) }),
	            _react2.default.createElement('div', { style: { height: 8 } }),
	            _react2.default.createElement(BalanceSection, { section: totals.payout, sectionTitle: intl.formatMessage({ id: 'BalanceWidget.section.payout', defaultMessage: 'Выплаты' }) })
	        );
	    }
	
	    if (hasPayout) {
	        return _react2.default.createElement(BalanceSection, { section: totals.payout });
	    }
	    if (hasPayin) {
	        return _react2.default.createElement(BalanceSection, { section: totals.payin });
	    }
	
	    // Fallback для старого формата ответа (без payin/payout секций)
	    var legacyLabels = totals.labels || {};
	    var legacyHints = totals.hints || {};
	    var settlementLabel = legacyLabels.settlementBalance || intl.formatMessage({
	        id: totals.hasCrm ? 'BalanceWidget.settlementLabel.reserve' : 'BalanceWidget.settlementLabel.reimbursement',
	        defaultMessage: totals.hasCrm ? 'Reserve' : 'Reimbursement'
	    });
	    var transactionLabel = legacyLabels.transactionBalance || intl.formatMessage({ id: 'BalanceWidget.transactionBalance', defaultMessage: 'Транзакционный баланс' });
	    var actualLabel = legacyLabels.actualBalance || intl.formatMessage({ id: 'BalanceWidget.actualBalance', defaultMessage: 'Действительный баланс' });
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.ExtendedBalances },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.BalanceRow + ' ' + _stylesModule2.default.TransactionBalance, title: legacyHints.transactionBalance || '' },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceLabel },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'BalanceWidget.transactionBalance', defaultMessage: transactionLabel })
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceValue },
	                formatBalance(totals.transactionBalanceFloat),
	                ' \u20BD'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.BalanceRow + ' ' + _stylesModule2.default.SettlementBalance, title: legacyHints.settlementBalance || '' },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceLabel },
	                settlementLabel
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceValue },
	                formatBalance(totals.settlementBalanceFloat),
	                ' \u20BD'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.BalanceRow + ' ' + _stylesModule2.default.ActualBalance, title: legacyHints.actualBalance || '' },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceLabel },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'BalanceWidget.actualBalance', defaultMessage: actualLabel })
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.BalanceValue },
	                formatBalance(totals.actualBalanceFloat),
	                ' \u20BD'
	            )
	        )
	    );
	}
	
	function BalanceWidget(_ref3) {
	    var data = _ref3.data,
	        extendedBalances = _ref3.extendedBalances,
	        selectedProject = _ref3.selectedProject,
	        refillsLinkInHeader = _ref3.refillsLinkInHeader,
	        isLoading = _ref3.isLoading;
	
	    var _useState = (0, _react.useState)(data ? data.count : 0),
	        _useState2 = _slicedToArray(_useState, 1),
	        count = _useState2[0];
	
	    var hasExtended = extendedBalances && extendedBalances.totals;
	
	    var fontSize = '1.4375rem';
	    switch (count) {
	        case 1:
	            fontSize = '1.4375rem';
	            break;
	        case 2:
	            fontSize = '1.3375rem';
	            break;
	        case 3:
	            fontSize = '1.2375rem';
	            break;
	        default:
	            fontSize = '1.4375rem';
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.CardHeader },
	            _react2.default.createElement(
	                'h6',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Dashboard.title.balance', defaultMessage: '\u0411\u0430\u043B\u0430\u043D\u0441' })
	            ),
	            refillsLinkInHeader && _react2.default.createElement(
	                _reactRouterDom.Link,
	                { className: _stylesModule2.default.HeaderLink, to: '/refills' },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.HeaderIcon, icon: 'history', size: '20px' }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Dashboard.title.refills', defaultMessage: '\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F' })
	                )
	            )
	        ),
	        isLoading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.CardBody },
	            hasExtended ? _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ExtendedMediaIcon },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.IconCircle + ' ' + _stylesModule2.default.IconCircleGreen },
	                        _react2.default.createElement(_Icon2.default, { color: '#35C98E', icon: 'wallet', size: '20px' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.MediaBody },
	                    _react2.default.createElement(ExtendedBalancesView, { totals: extendedBalances.totals }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.MediaMore },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Desc },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'Dashboard.title.balanceOnDate',
	                                defaultMessage: '\u0411\u0430\u043B\u0430\u043D\u0441 \u043D\u0430 {date}',
	                                values: {
	                                    date: _react2.default.createElement(_FormatDate2.default, { format: { day: 'numeric', month: 'numeric', year: 'numeric' } })
	                                }
	                            })
	                        ),
	                        !refillsLinkInHeader && _react2.default.createElement(
	                            'div',
	                            { style: { display: "none" } },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { className: _stylesModule2.default.Link, to: '/refills' },
	                                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'history', size: '20px' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Dashboard.title.refills', defaultMessage: '\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F' })
	                                )
	                            )
	                        )
	                    )
	                )
	            ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.MediaIcon },
	                    _react2.default.createElement(_Icon2.default, { color: '#35C98E', icon: 'wallet', size: '20px' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.MediaBody },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Balances },
	                        selectedProject ? selectedProject.balance.map(function (el, index) {
	                            var currency = Object.keys(el)[0];
	                            return _react2.default.createElement(
	                                'h2',
	                                { style: { fontSize: fontSize }, key: index },
	                                _react2.default.createElement(_Amount2.default, { amount: el[currency], currency: currency })
	                            );
	                        }) : data && data.map ? data.map(function (el, index) {
	                            var currency = Object.keys(el)[0];
	                            return _react2.default.createElement(
	                                'h2',
	                                { style: { fontSize: fontSize }, key: index },
	                                _react2.default.createElement(_Amount2.default, { amount: el[currency], currency: currency })
	                            );
	                        }) : null
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.MediaMore },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Desc },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'Dashboard.title.balanceOnDate',
	                                defaultMessage: '\u0411\u0430\u043B\u0430\u043D\u0441 \u043D\u0430 {date}',
	                                values: {
	                                    date: _react2.default.createElement(_FormatDate2.default, { format: { day: 'numeric', month: 'numeric', year: 'numeric' } })
	                                }
	                            })
	                        ),
	                        !refillsLinkInHeader && _react2.default.createElement(
	                            'div',
	                            { style: { display: "none" } },
	                            _react2.default.createElement(
	                                _reactRouterDom.Link,
	                                { className: _stylesModule2.default.Link, to: '/refills' },
	                                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'history', size: '20px' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Dashboard.title.refills', defaultMessage: '\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F' })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = BalanceWidget;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(195);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrapper },
	        _react2.default.createElement(
	            "table",
	            { className: _stylesModule2.default.Table },
	            _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    { className: _stylesModule2.default.EmptyRow },
	                    _react2.default.createElement(
	                        "td",
	                        { colSpan: "5" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Empty },
	                            _react2.default.createElement(
	                                "h5",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "Empty.message.dataSoon",
	                                    defaultMessage: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0433\u0440\u0430\u0444\u0438\u043A\u0430"
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Empty = __webpack_require__(334);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(195);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _useIsMobile = __webpack_require__(50);
	
	var _useIsMobile2 = _interopRequireDefault(_useIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function CountryChart(_ref) {
	    var data = _ref.data;
	
	    var isMobile = (0, _useIsMobile2.default)();
	
	    var normalized = _react2.default.useMemo(function () {
	        if (!Array.isArray(data) || data.length <= 1) return []; // нет строк данных
	
	        var header = data[0] || [];
	        var rows = data.slice(1);
	
	        if (header.length >= 3) {
	            return [["Country", "Value", { role: "tooltip", type: "string" }]].concat(_toConsumableArray(rows.map(function (r) {
	                var country = String(r[0]);
	                var value = Number(r[1]); // чем красим карту
	                // что показать в подсказке
	                return [country, value, "Transactions: " + r[1] + "\nSUM: " + r[2]];
	            })));
	        }
	
	        // только две колонки
	        return [["Country", "Value"]].concat(_toConsumableArray(rows.map(function (r) {
	            return [String(r[0]), Number(r[1])];
	        })));
	    }, [data]);
	
	    if (normalized.length <= 1) return _react2.default.createElement(_Empty2.default, null);
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Chart },
	            _react2.default.createElement(_reactGoogleCharts2.default, {
	                width: "100%",
	                height: isMobile ? "230px" : "350px",
	                chartType: "GeoChart",
	                loader: _react2.default.createElement(_Loader2.default, null),
	                data: normalized,
	                options: {
	                    colorAxis: { colors: ["#86a2c1", "#273246"] }
	                }
	            })
	        )
	    );
	}
	
	exports.default = CountryChart;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(102);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "table",
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	                "tr",
	                { className: _stylesModule2.default.EmptyRow },
	                _react2.default.createElement(
	                    "td",
	                    { colSpan: "5" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Empty },
	                        _react2.default.createElement(
	                            "h5",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: "Empty.message.dataSoon",
	                                defaultMessage: "\u0414\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u043E\u0440\u043E \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F"
	                            })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(102);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data;
	
	
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellLeft },
	            data[0]
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            data[1]
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            data[2]
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Success },
	            data[3]
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Decline },
	            data[4]
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TableRow = __webpack_require__(337);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Empty = __webpack_require__(336);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(102);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CountryTop(_ref) {
	    var data = _ref.data;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        Boolean(data.length) ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                "table",
	                { className: _stylesModule2.default.Table + " " + _stylesModule2.default.DesktopTable },
	                _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.CellLeft },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CountryTop.table.country", defaultMessage: "\u0421\u0442\u0440\u0430\u043D\u0430" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CountryTop.table.turnover", defaultMessage: "\u041E\u0431\u043E\u0440\u043E\u0442" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CountryTop.table.transactions", defaultMessage: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CountryTop.table.successful", defaultMessage: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0435" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CountryTop.table.declined", defaultMessage: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043D\u044B\u0435" })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "tbody",
	                    null,
	                    data.map(function (row, index) {
	                        return _react2.default.createElement(_TableRow2.default, { key: index, data: row });
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileList },
	                data.map(function (row, index) {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.MobileCard, key: index },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.MobileHeader },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.MobileCountry },
	                                row[0]
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.MobileTurnover },
	                                row[1]
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.MobileStats },
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: "CountryTop.table.transactions",
	                                        defaultMessage: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    row[2]
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: "CountryTop.table.successful",
	                                        defaultMessage: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0435"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "strong",
	                                    { className: _stylesModule2.default.Success },
	                                    row[3]
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: "CountryTop.table.declined",
	                                        defaultMessage: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043D\u044B\u0435"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "strong",
	                                    { className: _stylesModule2.default.Decline },
	                                    row[4]
	                                )
	                            )
	                        )
	                    );
	                })
	            )
	        ) : _react2.default.createElement(_Empty2.default, null)
	    );
	}
	
	exports.default = CountryTop;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _useIsMobile = __webpack_require__(50);
	
	var _useIsMobile2 = _interopRequireDefault(_useIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MainTransactionsChart(_ref) {
	    var data = _ref.data;
	
	    var isMobile = (0, _useIsMobile2.default)();
	
	    var colors = {};
	
	    if (Boolean(data)) {
	
	        var cols = Object.assign({}, data.cols);
	        delete cols[0];
	
	        Object.values(cols).map(function (el, index) {
	
	            switch (el.label) {
	                case "Payout Pending":
	                    colors[index] = { color: '#3b1a1a' };
	                    break;
	                case "Purchase Pending":
	                    colors[index] = { color: '#498183' };
	                    break;
	                case "Payout Decline":
	                    colors[index] = { color: '#DC3912' };
	                    break;
	                case "Refund Decline":
	                    colors[index] = { color: '#782ad4' };
	                    break;
	                case "Reversal Decline":
	                    colors[index] = { color: '#a9218e' };
	                    break;
	                case "Recurrent Decline":
	                    colors[index] = { color: '#c35624' };
	                    break;
	                case "Purchase Decline":
	                    colors[index] = { color: '#a1c324' };
	                    break;
	                case "Purchase":
	                    colors[index] = { color: '#3366CC' };
	                    break;
	                case "Recurrent":
	                    colors[index] = { color: '#a0e720' };
	                    break;
	                case "Reversal":
	                    colors[index] = { color: '#1eba8e' };
	                    break;
	                case "Refund":
	                    colors[index] = { color: '#518cea' };
	                    break;
	                case "Payout":
	                    colors[index] = { color: '#109618' };
	                    break;
	                case "Chargeback":
	                    colors[index] = { color: '#644f0b' };
	                    break;
	                case "Created":
	                    colors[index] = { color: '#3a828c' };
	                    break;
	                case "Pending 3DS Authentication":
	                    colors[index] = { color: '#581b1b' };
	                    break;
	                case "Refund Pending":
	                    colors[index] = { color: '#82afef' };
	                    break;
	                case "Reversal Pending":
	                    colors[index] = { color: '#02ecab' };
	                    break;
	                case "Recurrent Pending":
	                    colors[index] = { color: '#638b1a' };
	                    break;
	                case "Payout Created":
	                    colors[index] = { color: '#5de6f8' };
	                    break;
	                case "Refund Created":
	                    colors[index] = { color: '#0468f5' };
	                    break;
	                case "Reversal Created":
	                    colors[index] = { color: '#058b66' };
	                    break;
	                case "Recurrent Created":
	                    colors[index] = { color: '#3b5702' };
	                    break;
	                case "Purchase Created":
	                    colors[index] = { color: '#5977b3' };
	                    break;
	                case "Оборот":
	                    colors[index] = { color: '#990099', type: 'line', targetAxisIndex: 1 };
	                    break;
	                default:
	                    break;
	            }
	
	            return true;
	        });
	    }
	
	    return _react2.default.createElement(_reactGoogleCharts2.default, {
	        width: '100%',
	        height: isMobile ? '360px' : '300px',
	        chartType: "ComboChart",
	        loader: _react2.default.createElement(_Loader2.default, null),
	        data: data,
	        options: {
	            legend: isMobile ? { position: 'bottom', textStyle: { fontSize: 11 }, maxLines: 4 } : { textStyle: { fontSize: 11 } },
	            chartArea: {
	                width: isMobile ? '84%' : '75%',
	                height: isMobile ? '50%' : '62%',
	                top: isMobile ? 24 : undefined
	            },
	            vAxis: {
	                title: 'Количество операций',
	                titleTextStyle: { italic: false }
	            },
	            hAxis: {
	                direction: 1,
	                slantedText: true,
	                slantedTextAngle: 90,
	                titleTextStyle: { italic: false },
	                textStyle: {
	                    fontSize: 12
	                }
	            },
	            vAxes: { 1: { title: 'Оборот', textStyle: { color: 'red' } } },
	            seriesType: 'bars',
	            series: colors,
	            width: '100%',
	            height: isMobile ? 360 : 300
	        }
	    });
	}
	
	exports.default = MainTransactionsChart;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _EmptyChart = __webpack_require__(92);
	
	var _EmptyChart2 = _interopRequireDefault(_EmptyChart);
	
	var _useIsMobile = __webpack_require__(50);
	
	var _useIsMobile2 = _interopRequireDefault(_useIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        chartData = _useState2[0],
	        setChartData = _useState2[1];
	
	    var isMobile = (0, _useIsMobile2.default)();
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getMpsChart().then(function (response) {
	            if (Boolean(response.rows.length)) setChartData(response);else setChartData(false);
	        });
	    }, []);
	
	    return Boolean(chartData) ? _react2.default.createElement(_reactGoogleCharts2.default, {
	        width: '100%',
	        height: isMobile ? '340px' : '300px',
	        chartType: "PieChart",
	        loader: _react2.default.createElement(_Loader2.default, null),
	        data: chartData,
	        options: {
	            pieHole: 0.5,
	            legend: isMobile ? { position: 'bottom', textStyle: { fontSize: 12 }, maxLines: 4 } : { position: 'right', textStyle: { fontSize: 15 } },
	            chartArea: isMobile ? { width: '94%', height: '62%', top: 16 } : { width: '90%', height: '80%' }
	        },
	        rootProps: { 'data-testid': '3' }
	    }) : _react2.default.createElement(_EmptyChart2.default, null);
	});

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _EmptyChart = __webpack_require__(92);
	
	var _EmptyChart2 = _interopRequireDefault(_EmptyChart);
	
	var _useIsMobile = __webpack_require__(50);
	
	var _useIsMobile2 = _interopRequireDefault(_useIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        chartData = _useState2[0],
	        setChartData = _useState2[1];
	
	    var isMobile = (0, _useIsMobile2.default)();
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getTopErrorsDiffChart().then(function (response) {
	            if (Boolean(response.new.length) && Boolean(response.old.length)) setChartData(response);else setChartData(false);
	        });
	    }, []);
	
	    return chartData ? _react2.default.createElement(_reactGoogleCharts2.default, {
	        width: '100%',
	        height: isMobile ? '340px' : '300px',
	        chartType: "PieChart",
	        loader: _react2.default.createElement(_Loader2.default, null),
	        diffdata: chartData,
	        options: {
	            pieSliceText: 'none',
	            legend: isMobile ? { position: 'bottom', textStyle: { fontSize: 12 }, maxLines: 4 } : { position: 'right', textStyle: { fontSize: 15 } },
	            chartArea: isMobile ? { width: '94%', height: '62%', top: 16 } : { width: '90%', height: '80%' },
	            diff: { innerCircle: { borderFactor: 0.08 } }
	        },
	        rootProps: { 'data-testid': '2' }
	    }) : _react2.default.createElement(_EmptyChart2.default, null);
	});

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _EmptyChart = __webpack_require__(92);
	
	var _EmptyChart2 = _interopRequireDefault(_EmptyChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransactionsLineChart = function (_Component) {
	    _inherits(TransactionsLineChart, _Component);
	
	    function TransactionsLineChart(props) {
	        _classCallCheck(this, TransactionsLineChart);
	
	        var _this = _possibleConstructorReturn(this, (TransactionsLineChart.__proto__ || Object.getPrototypeOf(TransactionsLineChart)).call(this, props));
	
	        _this.state = {};
	
	        _this.data = props.data;
	        _this.vAxisLabel = props.vAxisLabel;
	        _this.lineColor = props.lineColor;
	        return _this;
	    }
	
	    _createClass(TransactionsLineChart, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.setState({ charData: this.data });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return this.state.count ? _react2.default.createElement(_reactGoogleCharts2.default, {
	                width: '100%',
	                height: 300,
	                chartType: "LineChart",
	                loader: _react2.default.createElement(_Loader2.default, null),
	                data: this.state.charData,
	                options: {
	                    curveType: 'none',
	                    interpolateNulls: true,
	                    chartArea: {
	                        width: '80%',
	                        height: '70%'
	                    },
	                    vAxis: {
	                        title: this.vAxisLabel,
	                        titleTextStyle: { italic: false },
	                        textPosition: 'out',
	                        textStyle: {
	                            fontSize: 12
	                        }
	                    },
	                    hAxis: {
	                        textPosition: 'out',
	                        slantedText: true,
	                        titleTextStyle: { italic: false },
	                        textStyle: {
	                            fontSize: 12
	                        }
	                    },
	                    legend: 'none',
	                    height: 300,
	                    width: '100%',
	                    series: {
	                        0: { color: this.lineColor }
	                    }
	                }
	            }) : _react2.default.createElement(_EmptyChart2.default, null);
	        }
	    }], [{
	        key: "getDerivedStateFromProps",
	        value: function getDerivedStateFromProps(nextProps, state) {
	
	            if (nextProps.data !== state.charData) {
	                return {
	                    charData: nextProps.data
	                };
	            }
	
	            if (nextProps.count !== state.count) {
	                return {
	                    count: nextProps.count
	                };
	            }
	
	            return null;
	        }
	    }]);
	
	    return TransactionsLineChart;
	}(_react.Component);
	
	exports.default = TransactionsLineChart;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(528);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function AccountAdd(_ref) {
	    var token = _ref.token,
	        onAccountAdd = _ref.onAccountAdd;
	
	    var _useState = (0, _react.useState)({ username: "", email: "", password: "" }),
	        _useState2 = _slicedToArray(_useState, 2),
	        form = _useState2[0],
	        setForm = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isLoading = _useState4[0],
	        setIsLoading = _useState4[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    function onChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function normalizeError(msg) {
	        return msg.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
	    }
	
	    function addAccount() {
	        setIsLoading(true);
	
	        new _Api2.default({ token: token }).addAccount(form).then(function (r) {
	            if (r.status === 422 && r.errors) {
	                var localizedErrors = [];
	
	                Object.entries(r.errors).forEach(function (_ref2) {
	                    var _ref3 = _slicedToArray(_ref2, 2),
	                        field = _ref3[0],
	                        messages = _ref3[1];
	
	                    messages.forEach(function (errorMsg) {
	                        var translationKey = "AccountAdd.validation." + field + "." + normalizeError(errorMsg);
	
	                        var localized = intl.formatMessage({ id: translationKey, defaultMessage: errorMsg });
	
	                        localizedErrors.push(localized);
	                    });
	                });
	
	                onMessage({
	                    type: "error",
	                    message: localizedErrors.join(" ")
	                });
	            } else if (!r.errors) {
	                onMessage({
	                    type: "success",
	                    message: intl.formatMessage({ id: "AccountAdd.success.message.created" })
	                });
	                setForm({ username: "", email: "", password: "" });
	                onAccountAdd();
	            } else {
	                var errors = Object.values(r.errors).flat().join(" ");
	                onMessage({
	                    type: "error",
	                    message: intl.formatMessage({ id: "AccountAdd.error.message.create" }, { errors: errors })
	                });
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({
	                type: "error",
	                message: intl.formatMessage({ id: "AccountAdd.error.server" })
	            });
	        }).finally(function () {
	            return setIsLoading(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.username,
	            placeholder: "john777",
	            fieldName: "username",
	            label: "FieldsHelper.label.username",
	            changeRegexp: /[^A-Za-z0-9]+/g,
	            blurRegexp: /^[A-Za-z0-9]{4,10}$/,
	            changeMessage: "FieldsHelper.error.onlyLatinUsername",
	            blurMessage: "FieldsHelper.error.onlyLatinUsername",
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.email,
	            placeholder: "example@email.ru",
	            fieldName: "email",
	            label: "FieldsHelper.label.email",
	            changeRegexp: /[^A-Za-z0-9\s_@.-]+/g,
	            blurRegexp: /^(([^<>()[/\]\\.,;:\s@"]+(\.[^<>()[/\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	            changeMessage: "FieldsHelper.error.charactersEmail",
	            blurMessage: "FieldsHelper.error.checkEmail",
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.PasswordInputHelper, { onChange: onChange, value: form.password, isDisabled: isLoading }),
	        _react2.default.createElement(
	            "button",
	            { className: _stylesModule2.default.Btn, onClick: addAccount, disabled: isLoading },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountAdd.btn.add", defaultMessage: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442" })
	        )
	    );
	}
	
	exports.default = AccountAdd;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(196);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Status(_ref) {
	    var currentStatus = _ref.currentStatus,
	        setCurrentStatus = _ref.setCurrentStatus,
	        isDisabled = _ref.isDisabled;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    var status = {
	        id: currentStatus,
	        name: null,
	        color: null
	    };
	
	    switch (currentStatus) {
	        case -1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.inactive', defaultMessage: '\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430' });
	            status.color = '#ff9900';
	            break;
	        case -2:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.closed', defaultMessage: '\u0417\u0430\u043A\u0440\u044B\u0442' });
	            status.color = '#d4d4d4';
	            break;
	        case -3:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.blocked', defaultMessage: '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D' });
	            status.color = 'rgb(220, 57, 18)';
	            break;
	        case 1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' });
	            status.color = 'rgb(16, 150, 24)';
	            break;
	        default:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' });
	            status.color = 'rgb(16, 150, 24)';
	    }
	
	    var statusWrap = (0, _react.useRef)(null);
	    var statusSelect = (0, _react.useRef)(null);
	
	    function onStatusClick() {
	        setIsOpened(!isOpened);
	    }
	
	    function onselectStatus(id) {
	        setCurrentStatus(id);
	        setIsOpened(false);
	    }
	
	    function handleClickOutside(e) {
	        if (!!statusWrap.current && !statusWrap.current.contains(e.target)) {
	            setIsOpened(false);
	        } else if (!!statusSelect.current && !!statusSelect.current.contains(e.target)) {
	            setIsOpened(true);
	        }
	    }
	
	    (0, _react.useEffect)(function () {
	        document.addEventListener('mousedown', handleClickOutside);
	
	        return function () {
	            document.removeEventListener('mousedown', handleClickOutside);
	        };
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { ref: statusWrap, className: _stylesModule2.default.Status },
	        _react2.default.createElement(
	            'div',
	            {
	                onClick: function onClick() {
	                    !isDisabled && onStatusClick();
	                },
	                className: _stylesModule2.default.CurrentStatus,
	                style: { backgroundColor: status.color }
	            },
	            status.name
	        ),
	        isOpened && _react2.default.createElement(
	            'ul',
	            { ref: statusSelect, className: _stylesModule2.default.StatusSelect },
	            _react2.default.createElement(
	                'li',
	                { style: status.id === 1 ? { fontWeight: 'bold' } : null, onClick: function onClick() {
	                        return onselectStatus(1);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' })
	            ),
	            _react2.default.createElement(
	                'li',
	                { style: status.id === -1 ? { fontWeight: 'bold' } : null, onClick: function onClick() {
	                        return onselectStatus(-1);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.inactive', defaultMessage: '\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430' })
	            ),
	            _react2.default.createElement(
	                'li',
	                { style: status.id === -2 ? { fontWeight: 'bold' } : null, onClick: function onClick() {
	                        return onselectStatus(-2);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.closed', defaultMessage: '\u0417\u0430\u043A\u0440\u044B\u0442' })
	            ),
	            _react2.default.createElement(
	                'li',
	                { style: status.id === -3 ? { fontWeight: 'bold' } : null, onClick: function onClick() {
	                        return onselectStatus(-3);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.blocked', defaultMessage: '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D' })
	            )
	        )
	    );
	}
	
	exports.default = Status;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _Status = __webpack_require__(344);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ProjectSearchList = __webpack_require__(372);
	
	var _ProjectSearchList2 = _interopRequireDefault(_ProjectSearchList);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _PermissionsEditor = __webpack_require__(168);
	
	var _PermissionsEditor2 = _interopRequireDefault(_PermissionsEditor);
	
	var _stylesModule = __webpack_require__(196);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function AccountEditing(_ref) {
	    var sendForm = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var api, payload, r, errors, currentIsAdmin, adminCall;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setIsLoading(true);
	                            setIsModalOpen(false);
	
	                            api = new _Api2.default({ token: token });
	                            _context.prev = 3;
	                            payload = Object.assign({}, form, {
	                                projects: form.projects.map(function (p) {
	                                    return { id: p.id, uuid: p.uuid };
	                                })
	                            });
	                            _context.next = 7;
	                            return api.setAccountData(data.id, payload);
	
	                        case 7:
	                            r = _context.sent;
	
	                            if (!(r && r.errors)) {
	                                _context.next = 13;
	                                break;
	                            }
	
	                            errors = Object.values(r.errors).join(' ');
	
	                            onMessage({ type: 'error', message: r.message + ' ' + errors });
	                            setIsLoading(false);
	                            return _context.abrupt('return');
	
	                        case 13:
	                            currentIsAdmin = data.privileges === 63 ? 1 : 0;
	
	                            if (!(isAdmin !== currentIsAdmin)) {
	                                _context.next = 18;
	                                break;
	                            }
	
	                            adminCall = isAdmin === 1 ? api.grantAdmin(data.id) : api.revokeAdmin(data.id);
	                            _context.next = 18;
	                            return adminCall;
	
	                        case 18:
	                            if (!(globalPermissionsEnabled !== initialGlobalEnabled)) {
	                                _context.next = 21;
	                                break;
	                            }
	
	                            _context.next = 21;
	                            return api.updateGlobalPermissions(data.id, globalPermissionsEnabled, globalPermissionsEnabled ? globalPrivileges : 0);
	
	                        case 21:
	
	                            onChangeAccountData(payload, data.id);
	                            onMessage({
	                                type: 'success',
	                                message: intl.formatMessage({ id: 'AccountEditing.success.saved' })
	                            });
	                            setForm(Object.assign({}, form, { password: '' }));
	                            _context.next = 30;
	                            break;
	
	                        case 26:
	                            _context.prev = 26;
	                            _context.t0 = _context['catch'](3);
	
	                            Sentry.captureException(_context.t0);
	                            onMessage({
	                                type: 'error',
	                                message: intl.formatMessage({ id: 'AccountEditing.error.save' })
	                            });
	
	                        case 30:
	                            _context.prev = 30;
	
	                            setIsLoading(false);
	                            return _context.finish(30);
	
	                        case 33:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[3, 26, 30, 33]]);
	        }));
	
	        return function sendForm() {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    var data = _ref.data,
	        token = _ref.token,
	        onChangeAccountData = _ref.onChangeAccountData,
	        projectsList = _ref.projectsList,
	        isDataLoading = _ref.isDataLoading;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isLoading = _useState2[0],
	        setIsLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({}),
	        _useState4 = _slicedToArray(_useState3, 2),
	        form = _useState4[0],
	        setForm = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        isModalOpen = _useState6[0],
	        setIsModalOpen = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(-1),
	        _useState8 = _slicedToArray(_useState7, 2),
	        isAdmin = _useState8[0],
	        setIsAdmin = _useState8[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        globalPermissionsEnabled = _useState10[0],
	        setGlobalPermissionsEnabled = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(0),
	        _useState12 = _slicedToArray(_useState11, 2),
	        globalPrivileges = _useState12[0],
	        setGlobalPrivileges = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        globalPermissionsModal = _useState14[0],
	        setGlobalPermissionsModal = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        initialGlobalEnabled = _useState16[0],
	        setInitialGlobalEnabled = _useState16[1];
	
	    var _useState17 = (0, _react.useState)({
	        open: false,
	        project: null,
	        accountId: null
	    }),
	        _useState18 = _slicedToArray(_useState17, 2),
	        permissionsModal = _useState18[0],
	        setPermissionsModal = _useState18[1];
	
	    (0, _react.useEffect)(function () {
	        if (Object.keys(data).length) {
	            setForm({
	                status: data.status,
	                username: data.username || '',
	                password: '',
	                firstName: data.firstName || '',
	                lastName: data.lastName || '',
	                patronymic: data.patronymic || '',
	                email: data.email || '',
	                projects: data.projects || []
	            });
	            setIsAdmin(data.privileges === 63 ? 1 : 0);
	
	            var gpEnabled = data.globalPrivileges !== null && data.globalPrivileges !== undefined;
	            setGlobalPermissionsEnabled(gpEnabled);
	            setGlobalPrivileges(data.globalPrivileges != null ? data.globalPrivileges : 0);
	            setInitialGlobalEnabled(gpEnabled);
	        }
	    }, [data]);
	
	    function onChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function setCurrentStatus(id) {
	        setForm(Object.assign({}, form, { status: id }));
	    }
	
	    function onSaveAccountData() {
	        if (form.password) {
	            setIsModalOpen(true);
	        } else {
	            sendForm();
	        }
	    }
	
	    function onEditPermissions(project, accountId) {
	        setPermissionsModal({
	            open: true,
	            project: project,
	            accountId: accountId
	        });
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                title: intl.formatMessage({ id: 'AccountEditing.status.passwordConfirm' }, { account: form.username }),
	                isOpen: isModalOpen,
	                onClose: function onClose() {
	                    return setIsModalOpen(false);
	                },
	                onConfirm: sendForm,
	                isConfirm: true
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.passwordConfirm', values: { account: form.username } })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Card },
	            isDataLoading && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.SavingOverlay },
	                _react2.default.createElement('div', { className: _stylesModule2.default.SavingSpinner }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.loading.data' })
	                )
	            ),
	            isLoading && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.SavingOverlay },
	                _react2.default.createElement('div', { className: _stylesModule2.default.SavingSpinner }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.loading.saving' })
	                )
	            ),
	            Object.keys(data).length ? _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Content },
	                    _react2.default.createElement(_Status2.default, {
	                        currentStatus: form.status || data.status,
	                        setCurrentStatus: setCurrentStatus,
	                        isDisabled: isLoading
	                    }),
	                    _react2.default.createElement(
	                        'dl',
	                        { className: _stylesModule2.default.List },
	                        _react2.default.createElement(
	                            'dt',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.label.id' })
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            null,
	                            data.id
	                        ),
	                        _react2.default.createElement(
	                            'dt',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.label.createdAt' })
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            null,
	                            _react2.default.createElement(_FormatDate2.default, {
	                                setDate: data.createdAt,
	                                format: {
	                                    day: 'numeric',
	                                    month: 'numeric',
	                                    year: 'numeric',
	                                    hour: 'numeric',
	                                    minute: 'numeric'
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'dt',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.label.lastLoginAt' })
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            null,
	                            data.lastLoginAt ? _react2.default.createElement(_FormatDate2.default, {
	                                setDate: data.lastLoginAt,
	                                format: {
	                                    day: 'numeric',
	                                    month: 'numeric',
	                                    year: 'numeric',
	                                    hour: 'numeric',
	                                    minute: 'numeric'
	                                }
	                            }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.label.neverLoggedIn' })
	                        ),
	                        _react2.default.createElement(
	                            'dt',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.label.updatedAt' })
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            null,
	                            _react2.default.createElement(_FormatDate2.default, {
	                                setDate: data.updatedAt,
	                                format: {
	                                    day: 'numeric',
	                                    month: 'numeric',
	                                    year: 'numeric',
	                                    hour: 'numeric',
	                                    minute: 'numeric'
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.AdminBlock },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.AdminCheckbox },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: isAdmin === 1,
	                                    onChange: function onChange(e) {
	                                        return setIsAdmin(e.target.checked ? 1 : 0);
	                                    },
	                                    disabled: isLoading
	                                }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.admin.label' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.GlobalPermissionsBlock },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.GlobalPermissionsHeader },
	                            _react2.default.createElement(
	                                'h4',
	                                { className: _stylesModule2.default.BlockTitle },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.global.title' })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _stylesModule2.default.GlobalPermissionsHint },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.global.hint' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.GlobalPermissionsActions },
	                            _react2.default.createElement(
	                                'label',
	                                { className: _stylesModule2.default.GlobalPermissionsToggle },
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: globalPermissionsEnabled,
	                                    onChange: function onChange(e) {
	                                        setGlobalPermissionsEnabled(e.target.checked);
	                                        if (!e.target.checked) {
	                                            setGlobalPrivileges(0);
	                                        }
	                                    },
	                                    disabled: isLoading
	                                }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.global.enable' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.Btn,
	                                    onClick: function onClick() {
	                                        return setGlobalPermissionsModal(true);
	                                    },
	                                    disabled: !globalPermissionsEnabled || isLoading
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.global.configure' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_1 },
	                            _react2.default.createElement(
	                                'h4',
	                                { className: _stylesModule2.default.BlockTitle },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.title.account' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_2 },
	                            _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                value: form.username,
	                                fieldName: 'username',
	                                label: 'FieldsHelper.label.username',
	                                isDisabled: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_3 },
	                            _react2.default.createElement(_FieldsHelper.PasswordInputHelper, {
	                                onChange: onChange,
	                                value: form.password,
	                                isDisabled: isLoading,
	                                label: intl.formatMessage({ id: 'FieldsHelper.password.generate' })
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: _stylesModule2.default.Btn,
	                            onClick: function onClick() {
	                                new _Api2.default({ token: token }).sendNewPassword(data.id).then(function () {
	                                    return onMessage({
	                                        type: 'success',
	                                        message: intl.formatMessage({
	                                            id: 'AccountEditing.success.passwordSent'
	                                        })
	                                    });
	                                }).catch(function (err) {
	                                    Sentry.captureException(err);
	                                    onMessage({
	                                        type: 'error',
	                                        message: intl.formatMessage({
	                                            id: 'AccountEditing.error.sendPassword'
	                                        })
	                                    });
	                                });
	                            }
	                        },
	                        _react2.default.createElement(_Icon2.default, { icon: 'mail', size: '16px' }),
	                        ' ',
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.btn.sendNewPassword' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: _stylesModule2.default.Btn,
	                            onClick: function onClick() {
	                                new _Api2.default({ token: token }).resetTwoFactor(data.id).then(function (r) {
	                                    var msgId = r.message === '2FA has been reset for account' ? 'AccountEditing.2FA.resetSuccess' : r.message === '2FA was not enabled for account' ? 'AccountEditing.2FA.notEnabled' : null;
	                                    onMessage({
	                                        type: msgId ? msgId.includes('notEnabled') ? 'error' : 'success' : 'error',
	                                        message: msgId ? intl.formatMessage({ id: msgId }) : r.message
	                                    });
	                                }).catch(function (err) {
	                                    Sentry.captureException(err);
	                                    onMessage({
	                                        type: 'error',
	                                        message: intl.formatMessage({ id: 'AccountEditing.error.reset2FA' })
	                                    });
	                                });
	                            }
	                        },
	                        _react2.default.createElement(_Icon2.default, { icon: 'shield-off', size: '16px' }),
	                        ' ',
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.btn.reset2FA' })
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_1 },
	                            _react2.default.createElement(
	                                'h4',
	                                { className: _stylesModule2.default.BlockTitle },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.title.contacts' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_2 },
	                            _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                value: form.firstName,
	                                fieldName: 'firstName',
	                                label: 'FieldsHelper.label.firstName',
	                                isDisabled: true
	                            }),
	                            _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                value: form.patronymic,
	                                fieldName: 'patronymic',
	                                label: 'FieldsHelper.label.patronymic',
	                                isDisabled: true
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_3 },
	                            _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                value: form.lastName,
	                                fieldName: 'lastName',
	                                label: 'FieldsHelper.label.lastName',
	                                isDisabled: true
	                            }),
	                            _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                value: form.email,
	                                fieldName: 'email',
	                                label: 'FieldsHelper.label.email',
	                                isDisabled: true
	                            })
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_1 },
	                            _react2.default.createElement(
	                                'h4',
	                                { className: _stylesModule2.default.BlockTitle },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.title.merchants' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.ColFullWidth },
	                            _react2.default.createElement(_ProjectSearchList2.default, {
	                                token: token,
	                                projectsList: projectsList,
	                                projects: form.projects,
	                                onProjectsChange: function onProjectsChange(projects) {
	                                    return setForm(Object.assign({}, form, { projects: projects }));
	                                },
	                                onEditPermissions: onEditPermissions,
	                                accountId: data.id,
	                                globalPermissionsEnabled: globalPermissionsEnabled
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.CardFooter },
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.BtnPrimary, onClick: onSaveAccountData, disabled: isLoading },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: isLoading ? 'AccountEditing.btn.saving' : 'AccountEditing.btn.save'
	                        })
	                    )
	                )
	            ) : _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Empty },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.empty' })
	                    )
	                )
	            )
	        ),
	        permissionsModal.open && permissionsModal.project && _react2.default.createElement(
	            'div',
	            {
	                className: _stylesModule2.default.ModalOverlay,
	                onClick: function onClick() {
	                    return setPermissionsModal({ open: false, project: null, accountId: null });
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.PermissionsModal, onClick: function onClick(e) {
	                        return e.stopPropagation();
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalHeader },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        globalPermissionsEnabled ? _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'AccountEditing.modal.permissionsGlobal',
	                                values: {
	                                    project: permissionsModal.project.name || permissionsModal.project.displayName || ''
	                                }
	                            })
	                        ) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'AccountEditing.modal.permissions',
	                            values: {
	                                project: permissionsModal.project.name || permissionsModal.project.displayName || ''
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.ModalClose,
	                            onClick: function onClick() {
	                                return setPermissionsModal({ open: false, project: null, accountId: null });
	                            }
	                        },
	                        '\xD7'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalBody },
	                    globalPermissionsEnabled ? _react2.default.createElement(_PermissionsEditor2.default, {
	                        token: token,
	                        accountId: permissionsModal.accountId,
	                        isGlobal: true,
	                        readOnly: true,
	                        readOnlyMessage: intl.formatMessage({
	                            id: 'AccountEditing.global.readOnlyMessage'
	                        }),
	                        onClose: function onClose() {
	                            return setPermissionsModal({ open: false, project: null, accountId: null });
	                        }
	                    }) : _react2.default.createElement(_PermissionsEditor2.default, {
	                        token: token,
	                        accountId: permissionsModal.accountId,
	                        merchantUuid: permissionsModal.project.uuid,
	                        onClose: function onClose() {
	                            return setPermissionsModal({ open: false, project: null, accountId: null });
	                        },
	                        onSaved: function onSaved() {
	                            setPermissionsModal({ open: false, project: null, accountId: null });
	                        }
	                    })
	                )
	            )
	        ),
	        globalPermissionsModal && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.ModalOverlay, onClick: function onClick() {
	                    return setGlobalPermissionsModal(false);
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.PermissionsModal, onClick: function onClick(e) {
	                        return e.stopPropagation();
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalHeader },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.global.modalTitle' })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.ModalClose, onClick: function onClick() {
	                                return setGlobalPermissionsModal(false);
	                            } },
	                        '\xD7'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalBody },
	                    _react2.default.createElement(_PermissionsEditor2.default, {
	                        token: token,
	                        accountId: data.id,
	                        isGlobal: true,
	                        onClose: function onClose() {
	                            return setGlobalPermissionsModal(false);
	                        },
	                        onSaved: function onSaved(newPrivileges) {
	                            setGlobalPrivileges(newPrivileges);
	                            setGlobalPermissionsModal(false);
	                        }
	                    })
	                )
	            )
	        )
	    );
	}
	
	exports.default = AccountEditing;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(529);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AccountsFilters(_ref) {
	    var onSelectFilter = _ref.onSelectFilter,
	        onApplyFilters = _ref.onApplyFilters,
	        isLoading = _ref.isLoading;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsFilters.title.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", {
	                            id: "active",
	                            type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ active: e.target.checked });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "active", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.ActiveIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsFilters.status.active", defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u0435\u043D" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", {
	                            id: "inactive",
	                            type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ inactive: e.target.checked });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "inactive", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.InactiveIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "AccountsFilters.status.inactive",
	                                    defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D"
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", {
	                            id: "closed",
	                            type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ closed: e.target.checked });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "closed", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.ClosedIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsFilters.status.closed", defaultMessage: "\u0417\u0430\u043A\u0440\u044B\u0442" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", {
	                            id: "blocked",
	                            type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ blocked: e.target.checked });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "blocked", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.BlockIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "AccountsFilters.status.blocked",
	                                    defaultMessage: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(
	                "button",
	                { onClick: onApplyFilters, className: _stylesModule2.default.Submit, disabled: isLoading },
	                !isLoading ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.buttonIcon, icon: "filter", size: "17px" }) : _react2.default.createElement(_Loader2.default, { isString: true }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsFilters.btn.filter", defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C" })
	            )
	        )
	    );
	}
	
	exports.default = AccountsFilters;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(61);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        'table',
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	                'tr',
	                { className: _stylesModule2.default.EmptyRow },
	                _react2.default.createElement(
	                    'td',
	                    { colSpan: '6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Empty },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.empty', defaultMessage: '\u0423\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E' })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _stylesModule = __webpack_require__(61);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobileCard(_ref) {
	    var data = _ref.data,
	        currentId = _ref.currentId;
	
	    var safeData = data || {};
	    var isSelected = currentId === safeData.id;
	    var status = {
	        name: "",
	        color: ""
	    };
	
	    switch (safeData.status) {
	        case -1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsList.status.inactive", defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430" });
	            status.color = "#ff9900";
	            break;
	        case -2:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsList.status.closed", defaultMessage: "\u0417\u0430\u043A\u0440\u044B\u0442" });
	            status.color = "#d4d4d4";
	            break;
	        case -3:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsList.status.blocked", defaultMessage: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" });
	            status.color = "rgb(220, 57, 18)";
	            break;
	        case 1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AccountsList.status.active", defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u0435\u043D" });
	            status.color = "rgb(16, 150, 24)";
	            break;
	        default:
	            break;
	    }
	
	    var _useContext = (0, _react.useContext)(_Context2.default),
	        onSelectAccountId = _useContext.onSelectAccountId;
	
	    return _react2.default.createElement(
	        "div",
	        {
	            className: _stylesModule2.default.MobileCard,
	            onClick: function onClick() {
	                return onSelectAccountId(safeData.id);
	            },
	            role: "button",
	            style: isSelected ? { borderBottomColor: status.color } : null
	        },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobilePrimary },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.MobileName },
	                ((safeData.firstName || "") + " " + (safeData.patronymic || "") + " " + (safeData.lastName || "")).trim() || "-"
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.MobileStatus, style: { color: status.color } },
	                status.name || "-"
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileMetaRow },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.MobileMeta },
	                "#",
	                safeData.id
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.MobileMeta },
	                _react2.default.createElement(_FormatDate2.default, {
	                    setDate: safeData.date,
	                    format: {
	                        day: "numeric",
	                        month: "numeric",
	                        year: "numeric",
	                        hour: "numeric",
	                        minute: "numeric"
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileField },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.MobileValue },
	                safeData.email || "-"
	            )
	        )
	    );
	}
	
	exports.default = MobileCard;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _stylesModule = __webpack_require__(61);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data,
	        currentId = _ref.currentId;
	
	    var status = {
	        name: '',
	        color: ''
	    };
	
	    switch (data.status) {
	        case -1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.status.inactive', defaultMessage: '\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D' });
	            status.color = '#ff9900';
	            break;
	        case -2:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.status.closed', defaultMessage: '\u0417\u0430\u043A\u0440\u044B\u0442' });
	            status.color = '#d4d4d4';
	            break;
	        case -3:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.status.blocked', defaultMessage: '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D' });
	            status.color = 'rgb(220, 57, 18)';
	            break;
	        case 1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' });
	            status.color = 'rgb(16, 150, 24)';
	            break;
	        default:
	            break;
	    }
	
	    var _useContext = (0, _react.useContext)(_Context2.default),
	        onSelectAccountId = _useContext.onSelectAccountId;
	
	    var styles = {};
	
	    if (currentId === data.id) styles = { backgroundColor: '#e3f2fd' };
	
	    return _react2.default.createElement(
	        'tr',
	        { style: styles, className: _stylesModule2.default.Row, onClick: function onClick() {
	                return onSelectAccountId(data.id);
	            } },
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.CellCenter },
	            data.id
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(_FormatDate2.default, {
	                setDate: data.date,
	                format: {
	                    day: 'numeric',
	                    month: 'numeric',
	                    year: 'numeric',
	                    hour: 'numeric',
	                    minute: 'numeric'
	                }
	            })
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.Cell },
	            data.firstName,
	            ' ',
	            data.patronymic,
	            ' ',
	            data.lastName
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.Cell },
	            data.email
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.CellCenter },
	            _react2.default.createElement(
	                'span',
	                { style: { color: status.color } },
	                status.name
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TableRow = __webpack_require__(349);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Empty = __webpack_require__(347);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _MobileCard = __webpack_require__(348);
	
	var _MobileCard2 = _interopRequireDefault(_MobileCard);
	
	var _stylesModule = __webpack_require__(61);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AccountsList(_ref) {
	    var data = _ref.data,
	        currentId = _ref.currentId,
	        isLoading = _ref.isLoading;
	
	    if (isLoading) return _react2.default.createElement(_Loader2.default, null);
	
	    if (!Boolean(data.length)) return _react2.default.createElement(_Empty2.default, null);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Scroll },
	            _react2.default.createElement(
	                'table',
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCenter },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.table.id', defaultMessage: 'no translate' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.table.createdAt', defaultMessage: 'no translate' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.table.user', defaultMessage: 'no translate' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.table.email', defaultMessage: 'no translate' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCenter },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountsList.table.status', defaultMessage: 'no translate' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    data.map(function (el) {
	                        return _react2.default.createElement(_TableRow2.default, { key: el.id, data: el, currentId: currentId });
	                    })
	                )
	            )
	        ),
	        data.map(function (el) {
	            return _react2.default.createElement(_MobileCard2.default, { key: el.id, data: el, currentId: currentId });
	        })
	    );
	}
	
	exports.default = AccountsList;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(530);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AntiFraudDetails(_ref) {
	    var record = _ref.record,
	        reference = _ref.reference,
	        onUnblock = _ref.onUnblock,
	        onDelete = _ref.onDelete;
	
	    if (!record) return null;
	
	    var sourceItem = (reference.sources || []).find(function (s) {
	        return s.value === record.source;
	    });
	    var kindItem = (reference.kinds || []).find(function (k) {
	        return k.value === record.kind;
	    });
	
	    var formatDate = function formatDate(dateStr) {
	        if (!dateStr) return "—";
	        var d = new Date(dateStr);
	        return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU");
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Header },
	            _react2.default.createElement(
	                "h5",
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudDetails.title", defaultMessage: "\u0414\u0435\u0442\u0430\u043B\u0438 \u0437\u0430\u043F\u0438\u0441\u0438" }),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.RecordId },
	                    "#",
	                    record.id
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    sourceItem && sourceItem.label || record.source
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u0422\u0438\u043F:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    kindItem && kindItem.label || record.kind
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 (\u043C\u0430\u0441\u043A\u0430):"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.ValueMono },
	                    record.valueMasked || "—"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: record.isBlocked ? _stylesModule2.default.StatusBlocked : _stylesModule2.default.StatusOk },
	                    record.isBlocked ? "Заблокирован" : "Разблокирован"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u041A\u043E\u0434 \u043F\u0440\u0438\u0447\u0438\u043D\u044B:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    record.reasonCode || "—"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    record.reasonMessage || "—"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u041F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    record.hits || 0
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    record.expiresAt ? formatDate(record.expiresAt) : "Бессрочно"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u041F\u0435\u0440\u0432\u043E\u0435 \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u0435:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    formatDate(record.firstSeenAt)
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u0435:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    formatDate(record.lastSeenAt)
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Row },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u0421\u043E\u0437\u0434\u0430\u043D\u043E:"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Value },
	                    record.createdBy || "—"
	                )
	            ),
	            record.meta && Object.keys(record.meta).length > 0 && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MetaSection },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Label },
	                    "\u041C\u0435\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0435:"
	                ),
	                _react2.default.createElement(
	                    "pre",
	                    { className: _stylesModule2.default.Meta },
	                    JSON.stringify(record.meta, null, 2)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Actions },
	            record.isBlocked && _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.UnblockBtn,
	                    onClick: function onClick() {
	                        return onUnblock(record.id);
	                    }
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudDetails.unblock", defaultMessage: "\u0420\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C" })
	            ),
	            _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.DeleteBtn,
	                    onClick: function onClick() {
	                        return onDelete(record.id);
	                    }
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudDetails.delete", defaultMessage: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })
	            )
	        )
	    );
	}
	
	AntiFraudDetails.defaultProps = {
	    reference: { sources: [], kinds: [] },
	    onUnblock: function onUnblock() {},
	    onDelete: function onDelete() {}
	};
	
	exports.default = AntiFraudDetails;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(531);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function AntiFraudFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        reference = _ref.reference,
	        isLoading = _ref.isLoading;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        selectedSources = _useState2[0],
	        setSelectedSources = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        selectedKinds = _useState4[0],
	        setSelectedKinds = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        isBlocked = _useState6[0],
	        setIsBlocked = _useState6[1];
	
	    function handleSourceChange(code, checked) {
	        if (checked) {
	            setSelectedSources([].concat(_toConsumableArray(selectedSources), [code]));
	        } else {
	            setSelectedSources(selectedSources.filter(function (s) {
	                return s !== code;
	            }));
	        }
	    }
	
	    function handleKindChange(code, checked) {
	        if (checked) {
	            setSelectedKinds([].concat(_toConsumableArray(selectedKinds), [code]));
	        } else {
	            setSelectedKinds(selectedKinds.filter(function (k) {
	                return k !== code;
	            }));
	        }
	    }
	
	    function handleApply() {
	        var filters = [];
	
	        selectedSources.forEach(function (source) {
	            filters.push({ key: "source", value: source });
	        });
	
	        selectedKinds.forEach(function (kind) {
	            filters.push({ key: "kind", value: kind });
	        });
	
	        if (isBlocked !== null) {
	            filters.push({ key: "isBlocked", value: isBlocked ? "true" : "false" });
	        }
	
	        onApplyFilters(filters);
	    }
	
	    function handleReset() {
	        setSelectedSources([]);
	        setSelectedKinds([]);
	        setIsBlocked(null);
	        onApplyFilters([]);
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudFilters.title.source", defaultMessage: "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    (reference.sources || []).map(function (source) {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.CheckboxWrap, key: source.value },
	                            _react2.default.createElement("input", {
	                                id: "source-" + source.value,
	                                type: "checkbox",
	                                checked: selectedSources.includes(source.value),
	                                onChange: function onChange(e) {
	                                    return handleSourceChange(source.value, e.target.checked);
	                                }
	                            }),
	                            _react2.default.createElement(
	                                "label",
	                                { htmlFor: "source-" + source.value, className: _stylesModule2.default.CustomCheckbox },
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    source.label
	                                )
	                            )
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudFilters.title.kind", defaultMessage: "\u0422\u0438\u043F \u0434\u0430\u043D\u043D\u044B\u0445" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    (reference.kinds || []).map(function (kind) {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.CheckboxWrap, key: kind.value },
	                            _react2.default.createElement("input", {
	                                id: "kind-" + kind.value,
	                                type: "checkbox",
	                                checked: selectedKinds.includes(kind.value),
	                                onChange: function onChange(e) {
	                                    return handleKindChange(kind.value, e.target.checked);
	                                }
	                            }),
	                            _react2.default.createElement(
	                                "label",
	                                { htmlFor: "kind-" + kind.value, className: _stylesModule2.default.CustomCheckbox },
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    kind.label
	                                )
	                            )
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudFilters.title.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", {
	                            id: "status-blocked",
	                            type: "checkbox",
	                            checked: isBlocked === true,
	                            onChange: function onChange(e) {
	                                return setIsBlocked(e.target.checked ? true : null);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "status-blocked", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.BlockIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudFilters.status.blocked",
	                                    defaultMessage: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", {
	                            id: "status-unblocked",
	                            type: "checkbox",
	                            checked: isBlocked === false,
	                            onChange: function onChange(e) {
	                                return setIsBlocked(e.target.checked ? false : null);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "status-unblocked", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.ActiveIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudFilters.status.unblocked",
	                                    defaultMessage: "\u0420\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(
	                "button",
	                { onClick: handleApply, className: _stylesModule2.default.Submit, disabled: isLoading },
	                !isLoading ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.buttonIcon, icon: "filter", size: "17px" }) : _react2.default.createElement(_Loader2.default, { isString: true }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudFilters.btn.filter", defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { onClick: handleReset, className: _stylesModule2.default.Reset },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudFilters.btn.reset", defaultMessage: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C" })
	            )
	        )
	    );
	}
	
	AntiFraudFilters.defaultProps = {
	    reference: { sources: [], kinds: [] },
	    isLoading: false,
	    onApplyFilters: function onApplyFilters() {}
	};
	
	exports.default = AntiFraudFilters;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(532);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function AntiFraudForm(_ref) {
	    var handleSubmit = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	            var payload;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            e.preventDefault();
	                            setError(null);
	
	                            if (kind) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            setError(intl.formatMessage({ id: 'AntiFraudForm.error.kindRequired' }));
	                            return _context.abrupt('return');
	
	                        case 5:
	                            if (value) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            setError(intl.formatMessage({ id: 'AntiFraudForm.error.valueRequired' }));
	                            return _context.abrupt('return');
	
	                        case 8:
	
	                            setLoading(true);
	
	                            _context.prev = 9;
	                            payload = {
	                                kind: kind,
	                                value: value,
	                                reasonMessage: reasonMessage || intl.formatMessage({ id: 'AntiFraudForm.reason.default' })
	                            };
	
	
	                            if (expiresAt) {
	                                payload.expiresAt = expiresAt;
	                            }
	
	                            _context.next = 14;
	                            return new _Api2.default({ token: token }).addAntiFraudRecord(payload);
	
	                        case 14:
	                            onAdded();
	                            _context.next = 20;
	                            break;
	
	                        case 17:
	                            _context.prev = 17;
	                            _context.t0 = _context['catch'](9);
	
	                            setError(_context.t0 && _context.t0.response && _context.t0.response.data && _context.t0.response.data.message || intl.formatMessage({ id: 'AntiFraudForm.error.create' }));
	
	                        case 20:
	                            _context.prev = 20;
	
	                            setLoading(false);
	                            return _context.finish(20);
	
	                        case 23:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[9, 17, 20, 23]]);
	        }));
	
	        return function handleSubmit(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    var token = _ref.token,
	        reference = _ref.reference,
	        onAdded = _ref.onAdded;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        kind = _useState2[0],
	        setKind = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(''),
	        _useState4 = _slicedToArray(_useState3, 2),
	        value = _useState4[0],
	        setValue = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(''),
	        _useState6 = _slicedToArray(_useState5, 2),
	        reasonMessage = _useState6[0],
	        setReasonMessage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(''),
	        _useState8 = _slicedToArray(_useState7, 2),
	        expiresAt = _useState8[0],
	        setExpiresAt = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        loading = _useState10[0],
	        setLoading = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        error = _useState12[0],
	        setError = _useState12[1];
	
	    return _react2.default.createElement(
	        'form',
	        { className: _stylesModule2.default.Form, onSubmit: handleSubmit },
	        error && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Error },
	            error
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Field },
	            _react2.default.createElement(
	                'label',
	                { className: _stylesModule2.default.Label },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraudForm.kind' })
	            ),
	            _react2.default.createElement(
	                'select',
	                { className: _stylesModule2.default.Select, value: kind, onChange: function onChange(e) {
	                        return setKind(e.target.value);
	                    } },
	                _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    intl.formatMessage({ id: 'AntiFraudForm.kind.placeholder' })
	                ),
	                (reference.kinds || []).map(function (k) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: k.value, value: k.value },
	                        k.label
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Field },
	            _react2.default.createElement(
	                'label',
	                { className: _stylesModule2.default.Label },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraudForm.value' })
	            ),
	            _react2.default.createElement('input', {
	                type: 'text',
	                className: _stylesModule2.default.Input,
	                value: value,
	                onChange: function onChange(e) {
	                    return setValue(e.target.value);
	                },
	                placeholder: kind === 'card_pan' ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.cardPan', defaultMessage: '4111111111111111' }) : kind === 'phone' || kind === 'sbp_phone' ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.phone', defaultMessage: '79001234567' }) : kind === 'ip' ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.ip', defaultMessage: '192.168.1.1' }) : kind === 'inn' ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.inn', defaultMessage: '1234567890' }) : intl.formatMessage({ id: 'AntiFraudForm.value.placeholder' })
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Hint },
	                kind === 'card_pan' && intl.formatMessage({ id: 'AntiFraudForm.hint.card_pan' }),
	                kind === 'phone' && intl.formatMessage({ id: 'AntiFraudForm.hint.phone' }),
	                kind === 'sbp_phone' && intl.formatMessage({ id: 'AntiFraudForm.hint.sbp_phone' }),
	                kind === 'ip' && intl.formatMessage({ id: 'AntiFraudForm.hint.ip' }),
	                kind === 'inn' && intl.formatMessage({ id: 'AntiFraudForm.hint.inn' }),
	                kind === 'name' && intl.formatMessage({ id: 'AntiFraudForm.hint.name' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Field },
	            _react2.default.createElement(
	                'label',
	                { className: _stylesModule2.default.Label },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraudForm.reason' })
	            ),
	            _react2.default.createElement('input', {
	                type: 'text',
	                className: _stylesModule2.default.Input,
	                value: reasonMessage,
	                onChange: function onChange(e) {
	                    return setReasonMessage(e.target.value);
	                },
	                placeholder: intl.formatMessage({ id: 'AntiFraudForm.reason.default' })
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Field },
	            _react2.default.createElement(
	                'label',
	                { className: _stylesModule2.default.Label },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraudForm.expiresAt' })
	            ),
	            _react2.default.createElement('input', {
	                type: 'datetime-local',
	                className: _stylesModule2.default.Input,
	                value: expiresAt,
	                onChange: function onChange(e) {
	                    return setExpiresAt(e.target.value);
	                }
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Hint },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraudForm.expiresAt.hint' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Actions },
	            _react2.default.createElement(
	                'button',
	                { type: 'submit', className: _stylesModule2.default.Submit, disabled: loading },
	                loading ? _react2.default.createElement(_Loader2.default, { isString: true }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraudForm.submit' })
	            )
	        )
	    );
	}
	
	AntiFraudForm.defaultProps = {
	    reference: { sources: [], kinds: [] },
	    onAdded: function onAdded() {}
	};
	
	exports.default = AntiFraudForm;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(197);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Empty() {
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Empty },
	        _react2.default.createElement(
	            "h5",
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.empty", defaultMessage: "\u041D\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0435\u0439" })
	        )
	    );
	}
	
	exports.default = Empty;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(197);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Empty = __webpack_require__(354);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status pill
	function StatusPill(_ref) {
	    var isBlocked = _ref.isBlocked;
	
	    var text = isBlocked ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.status.blocked", defaultMessage: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.status.unblocked", defaultMessage: "\u0420\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" });
	    var bg = isBlocked ? "#fde8e8" : "#e8f8ef";
	    var color = isBlocked ? "#a43232" : "#1b8356";
	
	    return _react2.default.createElement(
	        "span",
	        { style: { padding: "2px 8px", borderRadius: 12, background: bg, color: color, fontSize: 12 } },
	        text
	    );
	}
	
	// Source label
	function SourceLabel(_ref2) {
	    var source = _ref2.source,
	        reference = _ref2.reference;
	
	    var sourceItem = (reference.sources || []).find(function (s) {
	        return s.value === source;
	    });
	    var label = sourceItem ? sourceItem.label : source;
	
	    var colors = {
	        tkb: { bg: "#e3f2fd", color: "#1565c0" },
	        finstar: { bg: "#fff3e0", color: "#e65100" },
	        scanfraud: { bg: "#f3e5f5", color: "#7b1fa2" },
	        nx: { bg: "#e8eaf6", color: "#3949ab" },
	        manual: { bg: "#fce4ec", color: "#c2185b" }
	    };
	
	    var style = colors[source] || { bg: "#f5f5f5", color: "#666" };
	
	    return _react2.default.createElement(
	        "span",
	        { style: { padding: "2px 8px", borderRadius: 8, background: style.bg, color: style.color, fontSize: 11 } },
	        label
	    );
	}
	
	// Kind label
	function KindLabel(_ref3) {
	    var kind = _ref3.kind,
	        reference = _ref3.reference;
	
	    var kindItem = (reference.kinds || []).find(function (k) {
	        return k.value === kind;
	    });
	    var label = kindItem ? kindItem.label : kind;
	
	    return _react2.default.createElement(
	        "span",
	        { style: { fontSize: 12, opacity: 0.8 } },
	        label
	    );
	}
	
	function formatDate(dateStr, locale) {
	    if (!dateStr) return "—";
	    var d = new Date(dateStr);
	    return d.toLocaleDateString(locale) + " " + d.toLocaleTimeString(locale, {
	        hour: "2-digit",
	        minute: "2-digit"
	    });
	}
	
	function TableRow(_ref4) {
	    var row = _ref4.row,
	        isActive = _ref4.isActive,
	        _onClick = _ref4.onClick,
	        reference = _ref4.reference,
	        locale = _ref4.locale;
	
	    var trClass = isActive ? _stylesModule2.default.Row + " " + _stylesModule2.default.Active : _stylesModule2.default.Row;
	
	    return _react2.default.createElement(
	        "tr",
	        { className: trClass, onClick: function onClick() {
	                return _onClick(row);
	            }, style: { cursor: "pointer" } },
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellCenter },
	            "#",
	            row.id
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(SourceLabel, { source: row.source, reference: reference })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(KindLabel, { kind: row.kind, reference: reference })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { style: { fontFamily: "monospace", fontSize: 13 } },
	                row.valueMasked || "—"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { style: { fontSize: 12 } },
	                row.reasonMessage || row.reasonCode || "—"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellCenter },
	            _react2.default.createElement(
	                "span",
	                { style: { fontWeight: 600 } },
	                row.hits || 0
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { style: { fontSize: 11, opacity: 0.7 } },
	                formatDate(row.lastSeenAt, locale)
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellCenter },
	            _react2.default.createElement(StatusPill, { isBlocked: row.isBlocked })
	        )
	    );
	}
	
	function MobileCard(_ref5) {
	    var row = _ref5.row,
	        isActive = _ref5.isActive,
	        _onClick2 = _ref5.onClick,
	        reference = _ref5.reference,
	        locale = _ref5.locale;
	
	    var cardClass = isActive ? _stylesModule2.default.MobileCard + " " + _stylesModule2.default.MobileCardActive : _stylesModule2.default.MobileCard;
	
	    return _react2.default.createElement(
	        "button",
	        { type: "button", className: cardClass, onClick: function onClick() {
	                return _onClick2(row);
	            } },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileRow },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobilePrimary },
	                "#",
	                row.id
	            ),
	            _react2.default.createElement(StatusPill, { isBlocked: row.isBlocked })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileRow },
	            _react2.default.createElement(SourceLabel, { source: row.source, reference: reference }),
	            _react2.default.createElement(KindLabel, { kind: row.kind, reference: reference })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileValue },
	            row.valueMasked || "—"
	        ),
	        (row.reasonMessage || row.reasonCode) && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileReason },
	            row.reasonMessage || row.reasonCode
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileFooter },
	            _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.hits", defaultMessage: "\u041F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F" }),
	                ": ",
	                row.hits || 0
	            ),
	            _react2.default.createElement(
	                "span",
	                null,
	                formatDate(row.lastSeenAt, locale)
	            )
	        )
	    );
	}
	
	function AntiFraudList(_ref6) {
	    var data = _ref6.data,
	        currentId = _ref6.currentId,
	        isLoading = _ref6.isLoading,
	        onSelect = _ref6.onSelect,
	        reference = _ref6.reference;
	
	    var intl = (0, _reactIntl.useIntl)();
	    var rows = Array.isArray(data) ? data : [];
	
	    if (isLoading) return _react2.default.createElement(_Loader2.default, null);
	    if (!rows.length) return _react2.default.createElement(_Empty2.default, null);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.TableScroll },
	            _react2.default.createElement(
	                "table",
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.id", defaultMessage: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.source", defaultMessage: "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.kind", defaultMessage: "\u0422\u0438\u043F" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.value", defaultMessage: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.reason", defaultMessage: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.hits", defaultMessage: "\u041F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.lastSeen", defaultMessage: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0440\u0430\u0437" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "AntiFraudList.table.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "tbody",
	                    null,
	                    rows.map(function (row) {
	                        return _react2.default.createElement(TableRow, {
	                            key: row.id,
	                            row: row,
	                            isActive: currentId === row.id,
	                            onClick: onSelect,
	                            reference: reference,
	                            locale: intl.locale
	                        });
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileList },
	            rows.map(function (row) {
	                return _react2.default.createElement(MobileCard, {
	                    key: row.id,
	                    row: row,
	                    isActive: currentId === row.id,
	                    onClick: onSelect,
	                    reference: reference,
	                    locale: intl.locale
	                });
	            })
	        )
	    );
	}
	
	AntiFraudList.defaultProps = {
	    data: [],
	    isLoading: false,
	    onSelect: function onSelect() {},
	    reference: { sources: [], kinds: [] }
	};
	
	exports.default = AntiFraudList;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(533);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Маппинг действий на русский язык
	var ACTION_LABELS = {
	    account_create: 'AuditLogs.action.account_create',
	    account_update: 'AuditLogs.action.account_update',
	    account_delete: 'AuditLogs.action.account_delete',
	    account_login: 'AuditLogs.action.account_login',
	    account_logout: 'AuditLogs.action.account_logout',
	    account_grant_admin: 'AuditLogs.action.account_grant_admin',
	    account_revoke_admin: 'AuditLogs.action.account_revoke_admin',
	    account_reset_2fa: 'AuditLogs.action.account_reset_2fa',
	    account_password_reset: 'AuditLogs.action.account_password_reset',
	    account_project_add: 'AuditLogs.action.account_project_add',
	    account_project_remove: 'AuditLogs.action.account_project_remove',
	    merchant_create: 'AuditLogs.action.merchant_create',
	    merchant_update: 'AuditLogs.action.merchant_update',
	    merchant_delete: 'AuditLogs.action.merchant_delete',
	    merchant_block: 'AuditLogs.action.merchant_block',
	    merchant_unblock: 'AuditLogs.action.merchant_unblock',
	    merchant_frod_update: 'AuditLogs.action.merchant_frod_update',
	    merchant_widget_update: 'AuditLogs.action.merchant_widget_update',
	    merchant_user_add: 'AuditLogs.action.merchant_user_add',
	    merchant_user_remove: 'AuditLogs.action.merchant_user_remove',
	    terminal_create: 'AuditLogs.action.terminal_create',
	    terminal_update: 'AuditLogs.action.terminal_update',
	    terminal_delete: 'AuditLogs.action.terminal_delete',
	    terminal_balance_sync: 'AuditLogs.action.terminal_balance_sync',
	    terminal_status_change: 'AuditLogs.action.terminal_status_change',
	    settings_create: 'AuditLogs.action.settings_create',
	    settings_update: 'AuditLogs.action.settings_update',
	    settings_delete: 'AuditLogs.action.settings_delete',
	    permission_update: 'AuditLogs.action.permission_update',
	    transaction_callback_resend: 'AuditLogs.action.transaction_callback_resend',
	    transaction_decline: 'AuditLogs.action.transaction_decline',
	    transaction_payout: 'AuditLogs.action.transaction_payout',
	    transaction_amount_change: 'AuditLogs.action.transaction_amount_change'
	};
	
	// Маппинг типов объектов на русский
	var ENTITY_TYPE_LABELS = {
	    account: 'AuditLogs.entity.account',
	    Account: 'AuditLogs.entity.Account',
	    merchant: 'AuditLogs.entity.merchant',
	    Merchant: 'AuditLogs.entity.Merchant',
	    terminal: 'AuditLogs.entity.terminal',
	    Terminal: 'AuditLogs.entity.Terminal',
	    settings: 'AuditLogs.entity.settings',
	    MerchantSettings: 'AuditLogs.entity.MerchantSettings',
	    permission: 'AuditLogs.entity.permission',
	    AccountAccess: 'AuditLogs.entity.AccountAccess',
	    Transaction: 'AuditLogs.entity.Transaction'
	};
	
	var AuditLogsFilters = function AuditLogsFilters(_ref) {
	    var _ref$actions = _ref.actions,
	        actions = _ref$actions === undefined ? [] : _ref$actions,
	        _ref$entityTypes = _ref.entityTypes,
	        entityTypes = _ref$entityTypes === undefined ? [] : _ref$entityTypes,
	        _ref$admins = _ref.admins,
	        admins = _ref$admins === undefined ? [] : _ref$admins,
	        onApplyFilters = _ref.onApplyFilters,
	        isLoading = _ref.isLoading;
	
	    var intl = (0, _reactIntl.useIntl)();
	    // Гарантируем, что это массивы
	    var safeActions = Array.isArray(actions) ? actions : [];
	    var safeEntityTypes = Array.isArray(entityTypes) ? entityTypes : [];
	    var safeAdmins = Array.isArray(admins) ? admins : [];
	
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        selectedAdmin = _useState2[0],
	        setSelectedAdmin = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(''),
	        _useState4 = _slicedToArray(_useState3, 2),
	        selectedAction = _useState4[0],
	        setSelectedAction = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(''),
	        _useState6 = _slicedToArray(_useState5, 2),
	        selectedEntityType = _useState6[0],
	        setSelectedEntityType = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(''),
	        _useState8 = _slicedToArray(_useState7, 2),
	        startDate = _useState8[0],
	        setStartDate = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(''),
	        _useState10 = _slicedToArray(_useState9, 2),
	        endDate = _useState10[0],
	        setEndDate = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(''),
	        _useState12 = _slicedToArray(_useState11, 2),
	        searchTerm = _useState12[0],
	        setSearchTerm = _useState12[1];
	
	    function handleApply() {
	        var filters = {
	            actorId: selectedAdmin ? parseInt(selectedAdmin, 10) : null,
	            action: selectedAction || null,
	            entityType: selectedEntityType || null,
	            startDate: startDate || null,
	            endDate: endDate || null,
	            search: searchTerm || null
	        };
	        onApplyFilters(filters);
	    }
	
	    function handleReset() {
	        setSelectedAdmin('');
	        setSelectedAction('');
	        setSelectedEntityType('');
	        setStartDate('');
	        setEndDate('');
	        setSearchTerm('');
	        onApplyFilters({
	            actorId: null,
	            action: null,
	            entityType: null,
	            startDate: null,
	            endDate: null,
	            search: null
	        });
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.CardBody },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.FiltersRow },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FilterGroup },
	                    _react2.default.createElement(
	                        'label',
	                        { className: _stylesModule2.default.Label },
	                        intl.formatMessage({ id: 'AuditLogsFilters.label.admin' })
	                    ),
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            className: _stylesModule2.default.Select,
	                            value: selectedAdmin,
	                            onChange: function onChange(e) {
	                                return setSelectedAdmin(e.target.value);
	                            },
	                            disabled: isLoading
	                        },
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            intl.formatMessage({ id: 'AuditLogsFilters.option.all' })
	                        ),
	                        safeAdmins.map(function (admin) {
	                            return _react2.default.createElement(
	                                'option',
	                                { key: admin.id, value: admin.id },
	                                admin.username,
	                                ' (',
	                                admin.email,
	                                ')'
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FilterGroup },
	                    _react2.default.createElement(
	                        'label',
	                        { className: _stylesModule2.default.Label },
	                        intl.formatMessage({ id: 'AuditLogsFilters.label.action' })
	                    ),
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            className: _stylesModule2.default.Select,
	                            value: selectedAction,
	                            onChange: function onChange(e) {
	                                return setSelectedAction(e.target.value);
	                            },
	                            disabled: isLoading
	                        },
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            intl.formatMessage({ id: 'AuditLogsFilters.option.allActions' })
	                        ),
	                        safeActions.map(function (action, idx) {
	                            // action может быть объектом {code, name} или строкой
	                            var code = (typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object' ? action.code : action;
	                            var name = (typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object' ? action.name : ACTION_LABELS[action] ? intl.formatMessage({ id: ACTION_LABELS[action] }) : action;
	                            return _react2.default.createElement(
	                                'option',
	                                { key: code || idx, value: code },
	                                name
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FilterGroup },
	                    _react2.default.createElement(
	                        'label',
	                        { className: _stylesModule2.default.Label },
	                        intl.formatMessage({ id: 'AuditLogsFilters.label.entityType' })
	                    ),
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            className: _stylesModule2.default.Select,
	                            value: selectedEntityType,
	                            onChange: function onChange(e) {
	                                return setSelectedEntityType(e.target.value);
	                            },
	                            disabled: isLoading
	                        },
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            intl.formatMessage({ id: 'AuditLogsFilters.option.allTypes' })
	                        ),
	                        safeEntityTypes.map(function (type, idx) {
	                            // type может быть объектом {code, name} или строкой
	                            var code = (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' ? type.code : type;
	                            var name = (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' ? type.name : ENTITY_TYPE_LABELS[type] ? intl.formatMessage({ id: ENTITY_TYPE_LABELS[type] }) : type;
	                            return _react2.default.createElement(
	                                'option',
	                                { key: code || idx, value: code },
	                                name
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FilterGroup },
	                    _react2.default.createElement(
	                        'label',
	                        { className: _stylesModule2.default.Label },
	                        intl.formatMessage({ id: 'AuditLogsFilters.label.periodFrom' })
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'date',
	                        className: _stylesModule2.default.Input,
	                        value: startDate,
	                        onChange: function onChange(e) {
	                            return setStartDate(e.target.value);
	                        },
	                        disabled: isLoading
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FilterGroup },
	                    _react2.default.createElement(
	                        'label',
	                        { className: _stylesModule2.default.Label },
	                        intl.formatMessage({ id: 'AuditLogsFilters.label.periodTo' })
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'date',
	                        className: _stylesModule2.default.Input,
	                        value: endDate,
	                        onChange: function onChange(e) {
	                            return setEndDate(e.target.value);
	                        },
	                        disabled: isLoading
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FilterGroup },
	                    _react2.default.createElement(
	                        'label',
	                        { className: _stylesModule2.default.Label },
	                        intl.formatMessage({ id: 'AuditLogsFilters.label.search' })
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'text',
	                        className: _stylesModule2.default.Input,
	                        placeholder: intl.formatMessage({ id: 'AuditLogsFilters.placeholder.search' }),
	                        value: searchTerm,
	                        onChange: function onChange(e) {
	                            return setSearchTerm(e.target.value);
	                        },
	                        disabled: isLoading
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Actions },
	                _react2.default.createElement(
	                    'button',
	                    { className: _stylesModule2.default.BtnPrimary, onClick: handleApply, disabled: isLoading },
	                    intl.formatMessage({ id: 'AuditLogsFilters.button.apply' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: _stylesModule2.default.BtnSecondary, onClick: handleReset, disabled: isLoading },
	                    intl.formatMessage({ id: 'AuditLogsFilters.button.reset' })
	                )
	            )
	        )
	    );
	};
	
	exports.default = AuditLogsFilters;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(534);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ACTION_LABELS = {
	    account_create: 'Создание аккаунта',
	    account_update: 'Изменение аккаунта',
	    account_delete: 'Удаление аккаунта',
	    account_login: 'Вход в систему',
	    account_logout: 'Выход из системы',
	    account_grant_admin: 'Назначение администратором',
	    account_revoke_admin: 'Снятие прав администратора',
	    account_reset_2fa: 'Сброс 2FA',
	    account_password_reset: 'Сброс пароля',
	    account_project_add: 'Добавление к проекту',
	    account_project_remove: 'Удаление из проекта',
	    merchant_create: 'Создание проекта',
	    merchant_update: 'Изменение проекта',
	    merchant_delete: 'Удаление проекта',
	    merchant_block: 'Блокировка проекта',
	    merchant_unblock: 'Разблокировка проекта',
	    merchant_frod_update: 'Изменение антифрода',
	    merchant_widget_update: 'Изменение виджета',
	    merchant_user_add: 'Добавление пользователя',
	    merchant_user_remove: 'Удаление пользователя',
	    terminal_create: 'Создание терминала',
	    terminal_update: 'Изменение терминала',
	    terminal_delete: 'Удаление терминала',
	    terminal_balance_sync: 'Синхронизация баланса',
	    terminal_status_change: 'Изменение статуса терминала',
	    settings_create: 'Создание настройки',
	    settings_update: 'Изменение настройки',
	    settings_delete: 'Удаление настройки',
	    permission_update: 'Изменение прав',
	    transaction_callback_resend: 'Повторная отправка уведомления мерчанту',
	    transaction_decline: 'Перевод транзакции в отклонение',
	    transaction_payout: 'Перевод транзакции в выплату',
	    transaction_amount_change: 'Изменение суммы транзакции'
	};
	
	var ENTITY_TYPE_LABELS = {
	    account: 'Аккаунт',
	    Account: 'Учетная запись',
	    merchant: 'Проект',
	    Merchant: 'Проект',
	    terminal: 'Терминал',
	    Terminal: 'Терминал',
	    settings: 'Настройка',
	    MerchantSettings: 'Настройка MID',
	    permission: 'Права',
	    AccountAccess: 'Права доступа',
	    Transaction: 'Транзакция'
	};
	
	var FIELD_LABELS = {
	    name: 'Название',
	    description: 'Описание',
	    url: 'Адрес',
	    status: 'Статус',
	    inn: 'ИНН',
	    kpp: 'КПП',
	    ogrn: 'ОГРН',
	    enabled: 'Активна',
	    priority: 'Приоритет',
	    providerUuid: 'UUID провайдера',
	    providerName: 'Провайдер',
	    terminalId: 'ID терминала',
	    isSBP: 'СБП',
	    isMP2P: 'Р2Р',
	    preAuth: 'Предавторизация',
	    partialRefund: 'Частичный возврат',
	    partialReversal: 'Частичная отмена',
	    recurring: 'Рекуррент',
	    payoutBalanceCheck: 'Проверка баланса',
	    h2h: 'Человек к человеку',
	    fee: 'Комиссии',
	    frod: 'Антифрод',
	    antifraud: 'Настройки антифрода',
	    widget: 'Ключ виджета',
	    widgetCallback: 'Адрес колбека виджета',
	    balance: 'Баланс',
	    username: 'Логин',
	    email: 'Email',
	    privileges: 'Привилегии',
	    firstName: 'Имя',
	    lastName: 'Фамилия',
	    userId: 'ID пользователя',
	    projectUuid: 'UUID проекта',
	    projectName: 'Проект',
	    returnUrl: 'Адрес возврата',
	    webhookUrl: 'Адрес колбека',
	    exchangeRate: 'Курс обмена',
	    bankAccount: 'Банковский счёт',
	    paymentMethod: 'Способ оплаты',
	    processingId: 'ID процессинга',
	    currencyCode: 'Валюта'
	};
	
	var PROJECT_PERMISSIONS = {
	    1: 'Отмена операции',
	    2: 'Установка лимита',
	    4: 'Доступ к статистике',
	    8: 'Настройка оповещений',
	    16: 'Загрузка реестра',
	    32: 'Просмотр реестра',
	    64: 'Выгрузка отчёта',
	    128: 'Список реестров',
	    256: 'Просмотр карт',
	    512: 'Активация карт',
	    1024: 'Отчёт 1С',
	    2048: 'Доступ к платежам',
	    4096: 'Доступ к ПСА'
	};
	
	var ADMIN_PERMISSIONS = {
	    1: 'Просмотр аккаунтов',
	    2: 'Создание аккаунтов',
	    4: 'Список аккаунтов',
	    8: 'Редактирование аккаунтов',
	    16: 'Создание проектов',
	    32: 'Редактирование проектов'
	};
	
	function decodePermissions(mask, permMap) {
	    if (mask === null || mask === undefined) return [];
	    var num = Number(mask);
	    var result = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = Object.entries(permMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ref = _step.value;
	
	            var _ref2 = _slicedToArray(_ref, 2);
	
	            var bit = _ref2[0];
	            var label = _ref2[1];
	
	            if (num & Number(bit)) result.push(label);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return result;
	}
	
	function formatPrivilegesChange(oldVal, newVal, entityType) {
	    var permMap = entityType === 'Account' ? ADMIN_PERMISSIONS : PROJECT_PERMISSIONS;
	    var oldPerms = decodePermissions(oldVal, permMap);
	    var newPerms = decodePermissions(newVal, permMap);
	
	    var added = newPerms.filter(function (p) {
	        return !oldPerms.includes(p);
	    });
	    var removed = oldPerms.filter(function (p) {
	        return !newPerms.includes(p);
	    });
	
	    var parts = [];
	    if (added.length > 0) parts.push('+ ' + added.join(', '));
	    if (removed.length > 0) parts.push('− ' + removed.join(', '));
	    return parts.length > 0 ? parts.join('; ') : '(без изменений)';
	}
	
	function formatFieldValue(value) {
	    if (value === null || value === undefined) return '(пусто)';
	    if (value === true) return 'включено';
	    if (value === false) return 'выключено';
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') return JSON.stringify(value);
	    return String(value);
	}
	
	var ACTION_COLORS = {
	    create: '#4caf50',
	    update: '#2196f3',
	    delete: '#f44336',
	    login: '#9c27b0',
	    logout: '#607d8b',
	    block: '#ff9800',
	    unblock: '#4caf50',
	    grant: '#4caf50',
	    revoke: '#ff9800',
	    reset: '#ff9800',
	    sync: '#00bcd4',
	    add: '#4caf50',
	    remove: '#f44336'
	};
	
	function getActionColor(action) {
	    if (!action) return '#9e9e9e';
	
	    var actionLower = action.toLowerCase();
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = Object.entries(ACTION_COLORS)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _ref3 = _step2.value;
	
	            var _ref4 = _slicedToArray(_ref3, 2);
	
	            var key = _ref4[0];
	            var color = _ref4[1];
	
	            if (actionLower.includes(key)) {
	                return color;
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return '#9e9e9e';
	}
	
	function formatDate(dateString) {
	    if (!dateString) return '—';
	
	    var date = new Date(dateString);
	    var day = date.getDate().toString().padStart(2, '0');
	    var month = (date.getMonth() + 1).toString().padStart(2, '0');
	    var year = date.getFullYear();
	    var hours = date.getHours().toString().padStart(2, '0');
	    var minutes = date.getMinutes().toString().padStart(2, '0');
	
	    return day + '.' + month + '.' + year + ' ' + hours + ':' + minutes;
	}
	
	function formatChanges(oldData, newData) {
	    if (!oldData && !newData) return null;
	
	    var changes = [];
	    var allKeys = new Set([].concat(_toConsumableArray(oldData ? Object.keys(oldData) : []), _toConsumableArray(newData ? Object.keys(newData) : [])));
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = allKeys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var key = _step3.value;
	
	            var oldVal = oldData ? oldData[key] : undefined;
	            var newVal = newData ? newData[key] : undefined;
	
	            if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
	                changes.push({
	                    field: key,
	                    old: oldVal,
	                    new: newVal
	                });
	            }
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    return changes.length > 0 ? changes : null;
	}
	
	var AuditLogRow = function AuditLogRow(_ref5) {
	    var log = _ref5.log;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        isExpanded = _React$useState2[0],
	        setIsExpanded = _React$useState2[1];
	
	    var actionKey = log.action ? log.action.toLowerCase() : '';
	    var actionLabel = ACTION_LABELS[actionKey] || log.action || '—';
	    var entityTypeLabel = ENTITY_TYPE_LABELS[log.entityType] || log.entityType || '—';
	    var actionColor = getActionColor(log.action);
	    var changes = formatChanges(log.oldData, log.newData);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'tr',
	            {
	                className: _stylesModule2.default.Row,
	                onClick: function onClick() {
	                    return changes && setIsExpanded(!isExpanded);
	                },
	                style: { cursor: changes ? 'pointer' : 'default' }
	            },
	            _react2.default.createElement(
	                'td',
	                { className: _stylesModule2.default.Cell },
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.DateTime },
	                    formatDate(log.createdAt)
	                )
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: _stylesModule2.default.Cell },
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.Actor },
	                    log.actorUsername || 'ID: ' + log.actorId
	                )
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: _stylesModule2.default.Cell },
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.ActionBadge, style: { backgroundColor: actionColor } },
	                    actionLabel
	                )
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: _stylesModule2.default.Cell },
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.EntityType },
	                    entityTypeLabel
	                )
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: _stylesModule2.default.Cell },
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.EntityName },
	                    log.entityName || log.entityUuid || log.entityId || '—'
	                )
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: _stylesModule2.default.CellCenter },
	                changes && _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.ExpandIcon },
	                    isExpanded ? '▼' : '▶'
	                )
	            )
	        ),
	        isExpanded && changes && _react2.default.createElement(
	            'tr',
	            { className: _stylesModule2.default.DetailsRow },
	            _react2.default.createElement(
	                'td',
	                { colSpan: '6', className: _stylesModule2.default.DetailsCell },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Changes },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.ChangesHeader },
	                        '\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F:'
	                    ),
	                    changes.map(function (change, idx) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: idx, className: _stylesModule2.default.ChangeItem },
	                            change.field === 'privileges' ? _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ChangeField },
	                                    '\u041F\u0440\u0430\u0432\u0430:'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ChangeNew },
	                                    formatPrivilegesChange(change.old, change.new, log.entityType)
	                                )
	                            ) : _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ChangeField },
	                                    FIELD_LABELS[change.field] || change.field,
	                                    ':'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ChangeOld },
	                                    formatFieldValue(change.old)
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ChangeArrow },
	                                    '\u2192'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.ChangeNew },
	                                    formatFieldValue(change.new)
	                                )
	                            )
	                        );
	                    }),
	                    log.ipAddress && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.MetaInfo },
	                        'IP: ',
	                        log.ipAddress
	                    )
	                )
	            )
	        )
	    );
	};
	
	var MobileAuditLogCard = function MobileAuditLogCard(_ref6) {
	    var log = _ref6.log;
	
	    var _React$useState3 = _react2.default.useState(false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        isExpanded = _React$useState4[0],
	        setIsExpanded = _React$useState4[1];
	
	    var actionKey = log.action ? log.action.toLowerCase() : '';
	    var actionLabel = ACTION_LABELS[actionKey] || log.action || '—';
	    var entityTypeLabel = ENTITY_TYPE_LABELS[log.entityType] || log.entityType || '—';
	    var actionColor = getActionColor(log.action);
	    var changes = formatChanges(log.oldData, log.newData);
	
	    return _react2.default.createElement(
	        'button',
	        {
	            type: 'button',
	            className: _stylesModule2.default.MobileCard,
	            onClick: function onClick() {
	                return changes && setIsExpanded(!isExpanded);
	            },
	            style: { cursor: changes ? 'pointer' : 'default' }
	        },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileRow },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.DateTime },
	                formatDate(log.createdAt)
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.ActionBadge, style: { backgroundColor: actionColor } },
	                actionLabel
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileRow },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.Actor },
	                log.actorUsername || 'ID: ' + log.actorId
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.EntityType },
	                entityTypeLabel
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileEntityRow },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.EntityName },
	                log.entityName || log.entityUuid || log.entityId || '—'
	            ),
	            changes && _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.ExpandIcon },
	                isExpanded ? '▼' : '▶'
	            )
	        ),
	        isExpanded && changes && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileDetails },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.ChangesHeader },
	                '\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F:'
	            ),
	            changes.map(function (change, idx) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: idx, className: _stylesModule2.default.ChangeItem },
	                    change.field === 'privileges' ? _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.ChangeField },
	                            '\u041F\u0440\u0430\u0432\u0430:'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.ChangeNew },
	                            formatPrivilegesChange(change.old, change.new, log.entityType)
	                        )
	                    ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.ChangeField },
	                            FIELD_LABELS[change.field] || change.field,
	                            ':'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.ChangeOld },
	                            formatFieldValue(change.old)
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.ChangeArrow },
	                            '\u2192'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.ChangeNew },
	                            formatFieldValue(change.new)
	                        )
	                    )
	                );
	            }),
	            log.ipAddress && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.MetaInfo },
	                'IP: ',
	                log.ipAddress
	            )
	        )
	    );
	};
	
	var AuditLogsList = function AuditLogsList(_ref7) {
	    var logs = _ref7.logs,
	        isLoading = _ref7.isLoading;
	
	    if (isLoading) {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Loading },
	            _react2.default.createElement('div', { className: _stylesModule2.default.Spinner }),
	            _react2.default.createElement(
	                'span',
	                null,
	                '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0436\u0443\u0440\u043D\u0430\u043B\u0430...'
	            )
	        );
	    }
	
	    if (!logs || logs.length === 0) {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Empty },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.EmptyIcon },
	                '\uD83D\uDCCB'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.EmptyText },
	                '\u0417\u0430\u043F\u0438\u0441\u0438 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B'
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TableScroll },
	            _react2.default.createElement(
	                'table',
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell, style: { width: '140px' } },
	                            '\u0414\u0430\u0442\u0430/\u0432\u0440\u0435\u043C\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell, style: { width: '140px' } },
	                            '\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell, style: { width: '200px' } },
	                            '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell, style: { width: '100px' } },
	                            '\u0422\u0438\u043F'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            '\u041E\u0431\u044A\u0435\u043A\u0442'
	                        ),
	                        _react2.default.createElement('th', { className: _stylesModule2.default.HeaderCellCenter, style: { width: '50px' } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    logs.map(function (log) {
	                        return _react2.default.createElement(AuditLogRow, { key: log.id, log: log });
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileList },
	            logs.map(function (log) {
	                return _react2.default.createElement(MobileAuditLogCard, { key: log.id, log: log });
	            })
	        )
	    );
	};
	
	exports.default = AuditLogsList;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = MerchantsTurnoverChart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _useIsMobile = __webpack_require__(50);
	
	var _useIsMobile2 = _interopRequireDefault(_useIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatRub = function formatRub(value) {
	    var num = Number(value) || 0;
	    return num.toLocaleString('ru-RU', { maximumFractionDigits: 2 }) + ' ₽';
	};
	
	function MerchantsTurnoverChart(_ref) {
	    var data = _ref.data,
	        loading = _ref.loading;
	
	    var isMobile = (0, _useIsMobile2.default)();
	
	    if (loading) {
	        return _react2.default.createElement(_Loader2.default, null);
	    }
	
	    var rows = Array.isArray(data && data.rows) ? data.rows : [];
	    var total = data && data.total || { successAmount: 0, successCount: 0, failCount: 0 };
	    var successAmount = Number(total.successAmount || total.amount || 0);
	    var successCount = Number(total.successCount || total.count || 0);
	    var failCount = Number(total.failCount || 0);
	
	    if (rows.length === 0) {
	        return _react2.default.createElement(
	            'div',
	            { style: { padding: 20, textAlign: 'center', color: '#888' } },
	            '\u041D\u0435\u0442 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 \u0437\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434'
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '0 16px 8px 16px', color: '#555', fontSize: 14 } },
	            '\u0418\u0442\u043E\u0433\u043E: ',
	            _react2.default.createElement(
	                'b',
	                null,
	                formatRub(successAmount)
	            ),
	            ' \xB7 \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0445 ',
	            _react2.default.createElement(
	                'b',
	                null,
	                successCount
	            ),
	            ' \xB7 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0445 ',
	            _react2.default.createElement(
	                'b',
	                null,
	                failCount
	            )
	        ),
	        _react2.default.createElement(_reactGoogleCharts2.default, {
	            width: '100%',
	            height: isMobile ? '360px' : '320px',
	            chartType: 'PieChart',
	            loader: _react2.default.createElement(_Loader2.default, null),
	            data: data,
	            options: {
	                pieHole: 0.5,
	                legend: isMobile ? { position: 'bottom', textStyle: { fontSize: 11 }, maxLines: 4 } : { position: 'right', textStyle: { fontSize: 14 } },
	                chartArea: {
	                    width: isMobile ? '92%' : '95%',
	                    height: isMobile ? '62%' : '85%',
	                    top: isMobile ? 24 : undefined
	                },
	                tooltip: { isHtml: false, text: 'value' },
	                sliceVisibilityThreshold: 0.005
	            }
	        })
	    );
	}

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _stylesModule = __webpack_require__(535);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CrmPayoutActions(props) {
	    var selectedIds = props.selectedIds;
	    var token = props.token;
	    var onComplete = props.onComplete;
	    var onClearSelection = props.onClearSelection;
	    var data = props.data; // весь список заявок — нужен для определения статусов выбранных
	    var registries = props.registries || []; // реестры для "Добавить в реестр"
	    var onMessage = props.onMessage || function () {};
	
	    var _isLoading = (0, _react.useState)(false);
	    var isLoading = _isLoading[0];
	    var setIsLoading = _isLoading[1];
	
	    // Decline modal
	    var _showDeclineModal = (0, _react.useState)(false);
	    var showDeclineModal = _showDeclineModal[0];
	    var setShowDeclineModal = _showDeclineModal[1];
	
	    var _declineReason = (0, _react.useState)("");
	    var declineReason = _declineReason[0];
	    var setDeclineReason = _declineReason[1];
	
	    // Registry modal (новый реестр)
	    var _showRegistryModal = (0, _react.useState)(false);
	    var showRegistryModal = _showRegistryModal[0];
	    var setShowRegistryModal = _showRegistryModal[1];
	
	    var _registryName = (0, _react.useState)("");
	    var registryName = _registryName[0];
	    var setRegistryName = _registryName[1];
	
	    // Add to registry modal (существующий реестр)
	    var _showAddToRegistryModal = (0, _react.useState)(false);
	    var showAddToRegistryModal = _showAddToRegistryModal[0];
	    var setShowAddToRegistryModal = _showAddToRegistryModal[1];
	
	    var _selectedRegistryId = (0, _react.useState)(null);
	    var selectedRegistryId = _selectedRegistryId[0];
	    var setSelectedRegistryId = _selectedRegistryId[1];
	
	    // Success modal
	    var _showSuccessModal = (0, _react.useState)(false);
	    var showSuccessModal = _showSuccessModal[0];
	    var setShowSuccessModal = _showSuccessModal[1];
	
	    var _successFee = (0, _react.useState)("");
	    var successFee = _successFee[0];
	    var setSuccessFee = _successFee[1];
	
	    if (!selectedIds || selectedIds.length === 0) return null;
	
	    // Определяем статусы выбранных заявок
	    var selectedStatuses = [];
	    var allData = Array.isArray(data) ? data : [];
	    selectedIds.forEach(function (id) {
	        for (var i = 0; i < allData.length; i++) {
	            if (allData[i].id === id) {
	                var s = Number(allData[i].status);
	                if (selectedStatuses.indexOf(s) === -1) {
	                    selectedStatuses.push(s);
	                }
	                break;
	            }
	        }
	    });
	
	    // Определяем, какие кнопки показывать
	    var allAwaiting = selectedStatuses.length === 1 && selectedStatuses[0] === 7;
	    var allInRegistry = selectedStatuses.length === 1 && selectedStatuses[0] === 3;
	    var allFailed = selectedStatuses.length === 1 && selectedStatuses[0] === 6;
	    var allCreated = selectedStatuses.length === 1 && selectedStatuses[0] === 0;
	
	    // Можно ли отклонить — все выбранные должны быть в статусах 6 или 7
	    var canDeclineStatuses = [0, 6, 7];
	    var canDecline = selectedStatuses.every(function (s) {
	        return canDeclineStatuses.indexOf(s) >= 0;
	    });
	
	    var showFormRegistry = allAwaiting;
	    var showMoveBack = allInRegistry || allFailed;
	    var showSendToAntifraud = allCreated;
	
	    // Можно ли перевести в успех — все выбранные в статусах 3, 4 или 6
	    var canMoveToSuccessStatuses = [3, 4, 6, 7];
	    var canMoveToSuccess = selectedStatuses.every(function (s) {
	        return canMoveToSuccessStatuses.indexOf(s) >= 0;
	    });
	
	    // Реестры в статусе Created (0) — можно добавлять заявки
	    var availableRegistries = registries.filter(function (r) {
	        return Number(r.status) === 0;
	    });
	    var showAddToRegistry = allAwaiting && availableRegistries.length > 0;
	
	    // Отправить на антифрод
	    function handleSendToAntifraud() {
	        setIsLoading(true);
	        new _Api2.default({ token: token }).sendToAntifraudCrmPayoutRequests(selectedIds).then(function (result) {
	            if (result.errors && result.errors.length > 0) {
	                var msg = "Отправлено: " + result.sent + ", ошибок: " + result.errors.length;
	                onMessage({ type: "warning", message: msg });
	            } else {
	                onMessage({ type: "success", message: "Отправлено на антифрод: " + result.sent });
	            }
	            onComplete();
	        }).catch(function (e) {
	            onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Массовое отклонение
	    function handleBulkDecline() {
	        if (!declineReason) {
	            onMessage({ type: "warning", message: "Укажите причину отклонения" });
	            return;
	        }
	        setIsLoading(true);
	        new _Api2.default({ token: token }).bulkDeclineCrmPayoutRequests(selectedIds, declineReason).then(function (result) {
	            var msg = "Отклонено: " + result.declined;
	            if (result.errors && result.errors.length > 0) {
	                msg += ", ошибок: " + result.errors.length;
	            }
	            onMessage({ type: result.errors && result.errors.length > 0 ? "warning" : "success", message: msg });
	            setShowDeclineModal(false);
	            setDeclineReason("");
	            onComplete();
	        }).catch(function (e) {
	            onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Вернуть в ожидание
	    function handleMoveBack() {
	        setIsLoading(true);
	        new _Api2.default({ token: token }).moveBackToAwaitingCrmPayoutRequests(selectedIds).then(function (result) {
	            var msg = "Возвращено: " + result.moved;
	            if (result.errors && result.errors.length > 0) {
	                msg += ", ошибок: " + result.errors.length;
	            }
	            onMessage({ type: result.errors && result.errors.length > 0 ? "warning" : "success", message: msg });
	            onComplete();
	        }).catch(function (e) {
	            onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Массовый перевод в успех
	    function handleBulkMoveToSuccess() {
	        setIsLoading(true);
	        var fee = successFee ? parseFloat(successFee) : null;
	        new _Api2.default({ token: token }).bulkMoveToSuccessCrmPayoutRequests(selectedIds, fee).then(function (result) {
	            var msg = "Переведено в успех: " + result.moved;
	            if (result.errors && result.errors.length > 0) {
	                msg += ", ошибок: " + result.errors.length;
	                result.errors.forEach(function (err) {
	                    msg += "\n#" + err.id + ": " + err.error;
	                });
	            }
	            onMessage({ type: result.errors && result.errors.length > 0 ? "warning" : "success", message: msg });
	            setShowSuccessModal(false);
	            setSuccessFee("");
	            onComplete();
	        }).catch(function (e) {
	            onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Формирование нового реестра
	    function handleFormRegistry() {
	        if (!registryName) {
	            onMessage({ type: "warning", message: "Укажите название реестра" });
	            return;
	        }
	        setIsLoading(true);
	        new _Api2.default({ token: token }).formCrmRegistry(selectedIds, registryName, null).then(function (result) {
	            onMessage({ type: "success", message: "Реестр #" + result.registryId + " создан. Заявок: " + result.requestCount });
	            setShowRegistryModal(false);
	            setRegistryName("");
	            onComplete();
	        }).catch(function (e) {
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            onMessage({ type: "error", message: "Ошибка: " + msg });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Добавить в существующий реестр
	    function handleAddToRegistry() {
	        if (!selectedRegistryId) {
	            onMessage({ type: "warning", message: "Выберите реестр" });
	            return;
	        }
	        setIsLoading(true);
	        new _Api2.default({ token: token }).addToCrmRegistry(selectedRegistryId, selectedIds).then(function (result) {
	            onMessage({ type: "success", message: "Добавлено " + result.addedCount + " заявок в реестр #" + result.registryId });
	            setShowAddToRegistryModal(false);
	            setSelectedRegistryId(null);
	            onComplete();
	        }).catch(function (e) {
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            onMessage({ type: "error", message: "Ошибка: " + msg });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Bar },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.Count },
	                "\u0412\u044B\u0431\u0440\u0430\u043D\u043E: ",
	                selectedIds.length
	            ),
	            showFormRegistry && _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.BtnRegistry,
	                    onClick: function onClick() {
	                        setShowRegistryModal(true);
	                    },
	                    disabled: isLoading
	                },
	                "\u0421\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0435\u0441\u0442\u0440"
	            ),
	            showAddToRegistry && _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.BtnAddToRegistry,
	                    onClick: function onClick() {
	                        setShowAddToRegistryModal(true);
	                    },
	                    disabled: isLoading
	                },
	                "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u0440\u0435\u0435\u0441\u0442\u0440"
	            ),
	            showMoveBack && _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.BtnMoveBack,
	                    onClick: handleMoveBack,
	                    disabled: isLoading
	                },
	                isLoading ? "..." : "Вернуть в ожидание"
	            ),
	            canMoveToSuccess && _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.BtnSuccess,
	                    onClick: function onClick() {
	                        setShowSuccessModal(true);
	                    },
	                    disabled: isLoading
	                },
	                "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0432 \u0443\u0441\u043F\u0435\u0445"
	            ),
	            showSendToAntifraud && _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.BtnMoveBack,
	                    onClick: handleSendToAntifraud,
	                    disabled: isLoading
	                },
	                isLoading ? "..." : "На антифрод"
	            ),
	            canDecline && _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.BtnDecline,
	                    onClick: function onClick() {
	                        setShowDeclineModal(true);
	                    },
	                    disabled: isLoading
	                },
	                "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C"
	            ),
	            _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.BtnClear,
	                    onClick: onClearSelection
	                },
	                "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435"
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                isOpen: showSuccessModal,
	                onClose: function onClose() {
	                    setShowSuccessModal(false);
	                },
	                title: "Перевод в успех (" + selectedIds.length + " заявок)"
	            },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ModalContent },
	                _react2.default.createElement("input", {
	                    className: _stylesModule2.default.Input,
	                    type: "number",
	                    step: "0.01",
	                    placeholder: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
	                    value: successFee,
	                    onChange: function onChange(e) {
	                        setSuccessFee(e.target.value);
	                    }
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ModalFooter },
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnClear, onClick: function onClick() {
	                                setShowSuccessModal(false);
	                            } },
	                        "\u041E\u0442\u043C\u0435\u043D\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnSuccess, onClick: handleBulkMoveToSuccess, disabled: isLoading },
	                        isLoading ? "..." : "Подтвердить"
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                isOpen: showDeclineModal,
	                onClose: function onClose() {
	                    setShowDeclineModal(false);
	                },
	                title: "Массовое отклонение (" + selectedIds.length + " заявок)"
	            },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ModalContent },
	                _react2.default.createElement("input", {
	                    className: _stylesModule2.default.Input,
	                    placeholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u044F...",
	                    value: declineReason,
	                    onChange: function onChange(e) {
	                        setDeclineReason(e.target.value);
	                    }
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ModalFooter },
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnClear, onClick: function onClick() {
	                                setShowDeclineModal(false);
	                            } },
	                        "\u041E\u0442\u043C\u0435\u043D\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnDecline, onClick: handleBulkDecline, disabled: isLoading || !declineReason },
	                        isLoading ? "..." : "Отклонить"
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                isOpen: showRegistryModal,
	                onClose: function onClose() {
	                    setShowRegistryModal(false);
	                },
	                title: "Сформировать реестр (" + selectedIds.length + " заявок)"
	            },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ModalContent },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.ModalLabel },
	                    "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0435\u0441\u0442\u0440\u0430"
	                ),
	                _react2.default.createElement("input", {
	                    className: _stylesModule2.default.Input,
	                    placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0435\u0441\u0442\u0440\u0430...",
	                    value: registryName,
	                    onChange: function onChange(e) {
	                        setRegistryName(e.target.value);
	                    }
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ModalFooter },
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnClear, onClick: function onClick() {
	                                setShowRegistryModal(false);
	                            } },
	                        "\u041E\u0442\u043C\u0435\u043D\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnRegistry, onClick: handleFormRegistry, disabled: isLoading || !registryName },
	                        isLoading ? "..." : "Создать реестр"
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                isOpen: showAddToRegistryModal,
	                onClose: function onClose() {
	                    setShowAddToRegistryModal(false);setSelectedRegistryId(null);
	                },
	                title: "Добавить в реестр (" + selectedIds.length + " заявок)"
	            },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ModalContent },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.ModalLabel },
	                    "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0435\u0435\u0441\u0442\u0440"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.RegistryList },
	                    availableRegistries.map(function (reg) {
	                        var isSelected = selectedRegistryId === reg.id;
	                        return _react2.default.createElement(
	                            "div",
	                            {
	                                key: reg.id,
	                                className: _stylesModule2.default.RegistryOption + (isSelected ? " " + _stylesModule2.default.RegistryOptionSelected : ""),
	                                onClick: function onClick() {
	                                    setSelectedRegistryId(reg.id);
	                                }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.RegistryOptionName },
	                                reg.name || "Реестр #" + reg.id
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.RegistryOptionInfo },
	                                reg.requestCount,
	                                " \u0437\u0430\u044F\u0432\u043E\u043A, ",
	                                (reg.totalAmount || 0).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
	                                " \u20BD"
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ModalFooter },
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnClear, onClick: function onClick() {
	                                setShowAddToRegistryModal(false);setSelectedRegistryId(null);
	                            } },
	                        "\u041E\u0442\u043C\u0435\u043D\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnAddToRegistry, onClick: handleAddToRegistry, disabled: isLoading || !selectedRegistryId },
	                        isLoading ? "..." : "Добавить"
	                    )
	                )
	            )
	        )
	    );
	}
	
	CrmPayoutActions.defaultProps = {
	    selectedIds: [],
	    data: [],
	    registries: [],
	    onComplete: function onComplete() {},
	    onClearSelection: function onClearSelection() {}
	};
	
	exports.default = CrmPayoutActions;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(536);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _CrmPayoutBoardUtils = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function KanbanCard(props) {
	    var row = props.row;
	    var isActive = props.isActive;
	    var isSelected = props.isSelected;
	    var onSelect = props.onSelect;
	    var onCheck = props.onCheck;
	    var onCardDragStart = props.onCardDragStart;
	
	    var cardClass = _stylesModule2.default.KanbanCard;
	    if (isActive) cardClass = cardClass + " " + _stylesModule2.default.KanbanCardActive;
	    if (isSelected) cardClass = cardClass + " " + _stylesModule2.default.KanbanCardSelected;
	
	    var requisites = row.payoutType === "sbp" ? [row.sbpPhone, row.sbpBankName].filter(Boolean).join(" · ") || "-" : row.cardPanMasked || "-";
	
	    function handleDragStart(e) {
	        e.dataTransfer.setData("requestId", String(row.id));
	        e.dataTransfer.setData("fromStatus", String(Number(row.status)));
	        e.dataTransfer.effectAllowed = "move";
	        if (onCardDragStart) onCardDragStart(Number(row.status));
	    }
	
	    return _react2.default.createElement(
	        "div",
	        {
	            className: cardClass,
	            onClick: function onClick() {
	                onSelect(row);
	            },
	            draggable: "true",
	            onDragStart: handleDragStart
	        },
	        _react2.default.createElement("input", {
	            type: "checkbox",
	            className: _stylesModule2.default.CardCheckbox,
	            checked: isSelected,
	            onClick: function onClick(e) {
	                e.stopPropagation();
	            },
	            onChange: function onChange(e) {
	                onCheck(row.id, e.target.checked);
	            }
	        }),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardName },
	            row.fullName || "-"
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardAmount },
	            (0, _CrmPayoutBoardUtils.formatAmount)(row.amount)
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardMeta },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.TypeBadge + " " + _stylesModule2.default.TypeCard },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: row.payoutType === "sbp" ? "CrmPayoutBoard.type.sbp" : "CrmPayoutBoard.type.card",
	                    defaultMessage: row.payoutType === "sbp" ? "СБП" : "Карта"
	                })
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.CardRequisites },
	                requisites
	            )
	        ),
	        (row.externalReference || row.documentDate) && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardDoc },
	            row.externalReference && _react2.default.createElement(
	                "span",
	                null,
	                row.externalReference
	            ),
	            row.externalReference && row.documentDate && _react2.default.createElement(
	                "span",
	                null,
	                " "
	            ),
	            row.documentDate && _react2.default.createElement(
	                "span",
	                null,
	                row.documentDate
	            )
	        )
	    );
	}
	
	// Карточка реестра (для реестровых колонок)
	function RegistryCard(props) {
	    var registry = props.registry;
	    var onRegistryClick = props.onRegistryClick;
	
	    var statusLabels = {
	        0: { label: "Создан", bg: "#e3f2fd", color: "#1565c0" },
	        1: { label: "В обработке", bg: "#fff3e0", color: "#e65100" },
	        2: { label: "Обработан", bg: "#e8f5e9", color: "#2e7d32" },
	        3: { label: "Ошибки", bg: "#fce4ec", color: "#ad1457" },
	        4: { label: "Отложен", bg: "#f5f5f5", color: "#616161" }
	    };
	    var statusInfo = statusLabels[registry.status] || statusLabels[0];
	
	    return _react2.default.createElement(
	        "div",
	        {
	            className: _stylesModule2.default.RegistryCard,
	            onClick: function onClick() {
	                if (onRegistryClick) onRegistryClick(registry.id);
	            }
	        },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.RegistryCardName },
	            registry.name || "Реестр #" + registry.id
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.RegistryCardAmount },
	            (0, _CrmPayoutBoardUtils.formatAmount)(registry.totalAmount)
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.RegistryCardCount },
	            registry.requestCount,
	            " \u0437\u0430\u044F\u0432\u043E\u043A"
	        ),
	        registry.date && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.RegistryCardDate },
	            (0, _CrmPayoutBoardUtils.formatDate)(registry.date)
	        ),
	        _react2.default.createElement(
	            "span",
	            {
	                className: _stylesModule2.default.RegistryCardStatus,
	                style: { background: statusInfo.bg, color: statusInfo.color }
	            },
	            statusInfo.label
	        )
	    );
	}
	
	function KanbanColumn(props) {
	    var column = props.column;
	    var items = props.items;
	    var registries = props.registries;
	    var currentId = props.currentId;
	    var selectedIds = props.selectedIds;
	    var onSelect = props.onSelect;
	    var onCheck = props.onCheck;
	    var onCheckAllInColumn = props.onCheckAllInColumn;
	    var onRegistryClick = props.onRegistryClick;
	    var onDragDrop = props.onDragDrop;
	    var onCardDragStart = props.onCardDragStart;
	    var draggingFromStatus = props.draggingFromStatus;
	    var total = props.total;
	    var isColumnLoading = props.isColumnLoading;
	    var onLoadMore = props.onLoadMore;
	
	    var _dragOver = (0, _react.useState)(false);
	    var dragOver = _dragOver[0];
	    var setDragOver = _dragOver[1];
	
	    var isValidTarget = draggingFromStatus !== null && (0, _CrmPayoutBoardUtils.isTransitionAllowed)(draggingFromStatus, column.status);
	
	    // Реестровая колонка: фильтруем реестры по registryStatus
	    var isRegistryColumn = !!column.isRegistry;
	    var displayItems;
	    if (isRegistryColumn) {
	        displayItems = (registries || []).filter(function (reg) {
	            return (0, _CrmPayoutBoardUtils.matchRegistryStatus)(reg.status, column.registryStatus);
	        });
	    } else {
	        displayItems = items;
	    }
	
	    // Сколько всего заявок в колонке на сервере (карточек может быть загружено меньше)
	    var columnTotal = isRegistryColumn || total === null || total === undefined ? displayItems.length : Number(total);
	    var hasMore = columnTotal > displayItems.length;
	
	    // Сумма колонки
	    var totalAmount = 0;
	    displayItems.forEach(function (item) {
	        totalAmount += Number(isRegistryColumn ? item.totalAmount : item.amount) || 0;
	    });
	
	    // Чекбокс "Выбрать все" (только для не-реестровых колонок)
	    var columnItemIds = isRegistryColumn ? [] : displayItems.map(function (r) {
	        return r.id;
	    });
	    var allInColumnSelected = !isRegistryColumn && columnItemIds.length > 0 && columnItemIds.every(function (id) {
	        return selectedIds && selectedIds.indexOf(id) >= 0;
	    });
	
	    function handleCheckAllColumn(e) {
	        if (onCheckAllInColumn) {
	            onCheckAllInColumn(column.status, e.target.checked, columnItemIds);
	        }
	    }
	
	    function handleDragOver(e) {
	        if (!isValidTarget) return;
	        e.preventDefault();
	        e.dataTransfer.dropEffect = "move";
	        setDragOver(true);
	    }
	
	    function handleDragLeave(e) {
	        var rect = e.currentTarget.getBoundingClientRect();
	        var x = e.clientX;
	        var y = e.clientY;
	        if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
	            setDragOver(false);
	        }
	    }
	
	    function handleDrop(e) {
	        e.preventDefault();
	        setDragOver(false);
	
	        var requestId = parseInt(e.dataTransfer.getData("requestId"), 10);
	        var fromStatus = parseInt(e.dataTransfer.getData("fromStatus"), 10);
	        var toStatus = column.status;
	
	        if (isNaN(requestId) || isNaN(fromStatus)) return;
	        if (fromStatus === toStatus) return;
	        if (!(0, _CrmPayoutBoardUtils.isTransitionAllowed)(fromStatus, toStatus)) return;
	
	        if (onDragDrop) {
	            onDragDrop(requestId, fromStatus, toStatus);
	        }
	    }
	
	    var columnBodyClass = _stylesModule2.default.ColumnBody;
	    if (isValidTarget) {
	        columnBodyClass = columnBodyClass + " " + _stylesModule2.default.ColumnDropTarget;
	    }
	    if (dragOver && isValidTarget) {
	        columnBodyClass = columnBodyClass + " " + _stylesModule2.default.ColumnDragOver;
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.KanbanColumn },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.ColumnHeader, style: { borderBottomColor: column.color } },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ColumnHeaderTop },
	                !isRegistryColumn && columnItemIds.length > 0 && _react2.default.createElement("input", {
	                    type: "checkbox",
	                    className: _stylesModule2.default.ColumnCheckbox,
	                    checked: allInColumnSelected,
	                    onChange: handleCheckAllColumn,
	                    title: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435 \u0432 \u043A\u043E\u043B\u043E\u043D\u043A\u0435"
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ColumnTitle, style: { color: column.color } },
	                    column.label
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ColumnMeta },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.ColumnCount },
	                    displayItems.length,
	                    hasMore && _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.ColumnTotal },
	                        " \u0438\u0437 ",
	                        columnTotal
	                    )
	                ),
	                totalAmount > 0 && _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.ColumnSum },
	                    (0, _CrmPayoutBoardUtils.formatAmount)(totalAmount)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            {
	                className: columnBodyClass,
	                onDragOver: handleDragOver,
	                onDragLeave: handleDragLeave,
	                onDrop: handleDrop
	            },
	            displayItems.length === 0 && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.EmptyColumn },
	                isColumnLoading ? "Загрузка…" : "—"
	            ),
	            isRegistryColumn ? displayItems.map(function (reg) {
	                return _react2.default.createElement(RegistryCard, {
	                    key: "reg-" + reg.id,
	                    registry: reg,
	                    onRegistryClick: onRegistryClick
	                });
	            }) : displayItems.map(function (row) {
	                return _react2.default.createElement(KanbanCard, {
	                    key: row.id,
	                    row: row,
	                    isActive: currentId === row.id,
	                    isSelected: selectedIds && selectedIds.indexOf(row.id) >= 0,
	                    onSelect: onSelect,
	                    onCheck: onCheck,
	                    onCardDragStart: onCardDragStart
	                });
	            }),
	            !isRegistryColumn && hasMore && _react2.default.createElement(
	                "button",
	                {
	                    type: "button",
	                    className: _stylesModule2.default.LoadMoreButton,
	                    disabled: !!isColumnLoading,
	                    onClick: function onClick() {
	                        if (onLoadMore) onLoadMore(column.status);
	                    }
	                },
	                isColumnLoading ? "Загрузка…" : "Показать ещё (" + (columnTotal - displayItems.length) + ")"
	            )
	        )
	    );
	}
	
	function CrmPayoutBoard(props) {
	    var data = props.data;
	    var registries = props.registries;
	    var currentId = props.currentId;
	    var selectedIds = props.selectedIds;
	    var isLoading = props.isLoading;
	    var onSelect = props.onSelect;
	    var onCheck = props.onCheck;
	    var onCheckAllInColumn = props.onCheckAllInColumn;
	    var onRegistryClick = props.onRegistryClick;
	    var onDragDrop = props.onDragDrop;
	    var visibleStatuses = props.visibleStatuses;
	    var totals = props.totals || {};
	    var loadingStatuses = props.loadingStatuses || {};
	    var onLoadMore = props.onLoadMore;
	
	    var _draggingFrom = (0, _react.useState)(null);
	    var draggingFromStatus = _draggingFrom[0];
	    var setDraggingFromStatus = _draggingFrom[1];
	
	    var rows = Array.isArray(data) ? data : [];
	
	    function handleCardDragStart(status) {
	        setDraggingFromStatus(status);
	    }
	
	    function handleDragEnd() {
	        setDraggingFromStatus(null);
	    }
	
	    if (isLoading) {
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.LoadingWrap },
	            _react2.default.createElement(_Loader2.default, null)
	        );
	    }
	
	    // Группировка заявок по статусу
	    var grouped = {};
	    _CrmPayoutBoardUtils.STATUS_COLUMNS.forEach(function (col) {
	        if (!col.isRegistry) {
	            grouped[col.status] = [];
	        }
	    });
	    rows.forEach(function (row) {
	        var s = Number(row.status);
	        if (grouped[s]) {
	            grouped[s].push(row);
	        }
	    });
	
	    // Фильтрация колонок по visibleStatuses
	    var columnsToShow = _CrmPayoutBoardUtils.STATUS_COLUMNS;
	    if (visibleStatuses && visibleStatuses.length > 0) {
	        columnsToShow = _CrmPayoutBoardUtils.STATUS_COLUMNS.filter(function (col) {
	            return visibleStatuses.indexOf(col.status) >= 0;
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.KanbanBoard, onDragEnd: handleDragEnd },
	        columnsToShow.map(function (column) {
	            return _react2.default.createElement(KanbanColumn, {
	                key: column.status,
	                column: column,
	                items: grouped[column.status] || [],
	                registries: registries,
	                currentId: currentId,
	                selectedIds: selectedIds,
	                onSelect: onSelect,
	                onCheck: onCheck,
	                onCheckAllInColumn: onCheckAllInColumn,
	                onRegistryClick: onRegistryClick,
	                onDragDrop: onDragDrop,
	                onCardDragStart: handleCardDragStart,
	                draggingFromStatus: draggingFromStatus,
	                total: totals[column.status],
	                isColumnLoading: !!loadingStatuses[column.status],
	                onLoadMore: onLoadMore
	            });
	        })
	    );
	}
	
	CrmPayoutBoard.defaultProps = {
	    data: [],
	    registries: [],
	    selectedIds: [],
	    isLoading: false,
	    visibleStatuses: null,
	    totals: {},
	    loadingStatuses: {},
	    onLoadMore: function onLoadMore() {},
	    onSelect: function onSelect() {},
	    onCheck: function onCheck() {},
	    onCheckAllInColumn: function onCheckAllInColumn() {},
	    onRegistryClick: function onRegistryClick() {},
	    onDragDrop: function onDragDrop() {}
	};
	
	exports.default = CrmPayoutBoard;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = CrmPayoutCreateModal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(537);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function emptyForm(payoutType) {
	    return {
	        merchantUuid: "",
	        type: payoutType,
	        amount: "",
	        fullName: "",
	        externalReference: "",
	        description: "",
	        cardPan: "",
	        phone: "",
	        bankMemberId: "",
	        bankName: ""
	    };
	}
	
	function CrmPayoutCreateModal(props) {
	    var token = props.token;
	    var payoutType = props.payoutType || "card";
	    var isSbp = payoutType === "sbp";
	    var merchants = props.merchants || [];
	    var _form = (0, _react.useState)(emptyForm(payoutType));
	    var form = _form[0];
	    var setForm = _form[1];
	    var _error = (0, _react.useState)("");
	    var error = _error[0];
	    var setError = _error[1];
	    var _saving = (0, _react.useState)(false);
	    var saving = _saving[0];
	    var setSaving = _saving[1];
	
	    function change(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function validate() {
	        if (!form.merchantUuid) return "Выберите мерчанта";
	        if (!form.amount || Number(form.amount) <= 0) return "Укажите положительную сумму";
	        if (form.externalReference.length > 64) return "PayCrmID должен быть не длиннее 64 символов";
	        if (isSbp) {
	            if (!form.phone.trim()) return "Укажите телефон получателя";
	            if (!form.bankMemberId.trim() && !form.bankName.trim()) {
	                return "Укажите код НСПК или название банка";
	            }
	            if (form.bankMemberId.trim() && !/^\d{12}$/.test(form.bankMemberId.trim())) {
	                return "Код НСПК должен состоять из 12 цифр";
	            }
	        } else {
	            var pan = form.cardPan.replace(/\D/g, "");
	            if (pan.length < 13 || pan.length > 19) return "Номер карты должен содержать от 13 до 19 цифр";
	        }
	        return "";
	    }
	
	    function submit() {
	        var validationError = validate();
	        if (validationError) {
	            setError(validationError);
	            return;
	        }
	
	        var payload = {
	            merchantUuid: form.merchantUuid,
	            type: payoutType,
	            amount: Number(form.amount)
	        };
	        ["fullName", "externalReference", "description"].forEach(function (key) {
	            if (form[key].trim()) payload[key] = form[key].trim();
	        });
	        if (isSbp) {
	            payload.phone = form.phone.trim();
	            if (form.bankMemberId.trim()) payload.bankMemberId = form.bankMemberId.trim();
	            if (form.bankName.trim()) payload.bankName = form.bankName.trim();
	        } else {
	            payload.cardPan = form.cardPan.replace(/\D/g, "");
	        }
	
	        setSaving(true);
	        setError("");
	        new _Api2.default({ token: token }).createCrmPayoutRequest(payload).then(function (response) {
	            setSaving(false);
	            if (props.onCreated) props.onCreated(response.request);
	            if (props.onMessage) {
	                props.onMessage({ type: "success", message: "CRM-заявка создана" });
	            }
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var message = e.response && e.response.data && e.response.data.message || e.message || "Ошибка создания";
	            setError(message);
	            setSaving(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Backdrop, onClick: props.onClose },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Modal, onClick: function onClick(e) {
	                    e.stopPropagation();
	                } },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    "\u0421\u043E\u0437\u0434\u0430\u0442\u044C CRM-\u0437\u0430\u044F\u0432\u043A\u0443 ",
	                    isSbp ? "СБП" : "на карту"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { type: "button", className: _stylesModule2.default.Close, onClick: props.onClose },
	                    _react2.default.createElement(_Icon2.default, { icon: "close", size: "15px" })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Body },
	                error && _react2.default.createElement(
	                    "div",
	                    { className: "alert alert-danger py-1 mb-2" },
	                    error
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "form-group mb-2" },
	                    _react2.default.createElement(
	                        "label",
	                        null,
	                        "\u041C\u0435\u0440\u0447\u0430\u043D\u0442 *"
	                    ),
	                    _react2.default.createElement(
	                        "select",
	                        { className: "form-control", value: form.merchantUuid, onChange: function onChange(e) {
	                                change("merchantUuid", e.target.value);
	                            } },
	                        _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "-- \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 --"
	                        ),
	                        merchants.map(function (merchant) {
	                            return _react2.default.createElement(
	                                "option",
	                                { key: merchant.uuid, value: merchant.uuid },
	                                merchant.displayName
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Grid },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "form-group mb-2" },
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            "\u0421\u0443\u043C\u043C\u0430, \u20BD *"
	                        ),
	                        _react2.default.createElement("input", { type: "number", min: "0.01", step: "0.01", className: "form-control", value: form.amount, onChange: function onChange(e) {
	                                change("amount", e.target.value);
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "form-group mb-2" },
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            "\u0424\u0418\u041E"
	                        ),
	                        _react2.default.createElement("input", { type: "text", maxLength: "255", className: "form-control", value: form.fullName, onChange: function onChange(e) {
	                                change("fullName", e.target.value);
	                            }, placeholder: "\u041D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E" })
	                    )
	                ),
	                isSbp ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "form-group mb-2" },
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            "\u0422\u0435\u043B\u0435\u0444\u043E\u043D *"
	                        ),
	                        _react2.default.createElement("input", { type: "text", className: "form-control", value: form.phone, onChange: function onChange(e) {
	                                change("phone", e.target.value);
	                            }, placeholder: "9101234567" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Grid },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "form-group mb-2" },
	                            _react2.default.createElement(
	                                "label",
	                                null,
	                                "\u041A\u043E\u0434 \u041D\u0421\u041F\u041A"
	                            ),
	                            _react2.default.createElement("input", { type: "text", maxLength: "12", className: "form-control", value: form.bankMemberId, onChange: function onChange(e) {
	                                    change("bankMemberId", e.target.value.replace(/\D/g, ""));
	                                }, placeholder: "100000000111" })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "form-group mb-2" },
	                            _react2.default.createElement(
	                                "label",
	                                null,
	                                "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430"
	                            ),
	                            _react2.default.createElement("input", { type: "text", className: "form-control", value: form.bankName, onChange: function onChange(e) {
	                                    change("bankName", e.target.value);
	                                }, placeholder: "\u041C\u043E\u0436\u043D\u043E \u0432\u043C\u0435\u0441\u0442\u043E \u043A\u043E\u0434\u0430" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "small",
	                        { className: "text-muted" },
	                        "\u0414\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u043A\u043E\u0434 \u041D\u0421\u041F\u041A \u0438\u043B\u0438 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430. \u0415\u0441\u043B\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u044B \u043E\u0431\u0430, \u043E\u043D\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0434\u0440\u0443\u0433 \u0434\u0440\u0443\u0433\u0443."
	                    )
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: "form-group mb-2" },
	                    _react2.default.createElement(
	                        "label",
	                        null,
	                        "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B *"
	                    ),
	                    _react2.default.createElement("input", { type: "text", maxLength: "23", className: "form-control", value: form.cardPan, onChange: function onChange(e) {
	                            change("cardPan", e.target.value);
	                        }, placeholder: "\u041D\u043E\u043C\u0435\u0440 \u0431\u0435\u0437 \u043C\u0430\u0441\u043A\u0438" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-2 mb-2" },
	                    _react2.default.createElement(
	                        "label",
	                        null,
	                        "PayCrmID / \u0432\u043D\u0435\u0448\u043D\u0438\u0439 ID"
	                    ),
	                    _react2.default.createElement("input", { type: "text", maxLength: "64", className: "form-control", value: form.externalReference, onChange: function onChange(e) {
	                            change("externalReference", e.target.value);
	                        }, placeholder: "\u041D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E, \u0434\u043E 64 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "form-group mb-0" },
	                    _react2.default.createElement(
	                        "label",
	                        null,
	                        "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                    ),
	                    _react2.default.createElement("input", { type: "text", className: "form-control", value: form.description, onChange: function onChange(e) {
	                            change("description", e.target.value);
	                        }, placeholder: "\u041D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E" })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Footer },
	                _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-secondary", onClick: props.onClose },
	                    "\u041E\u0442\u043C\u0435\u043D\u0430"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-success", disabled: saving, onClick: submit },
	                    saving ? "Создание..." : "Создать заявку"
	                )
	            )
	        )
	    );
	}

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(538);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StatusPill(props) {
	    var intl = (0, _reactIntl.useIntl)();
	    var status = props.status;
	    var configMap = {
	        0: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.created" }), bg: "#e3f2fd", color: "#1565c0" },
	        1: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.antifraud" }), bg: "#ffebee", color: "#c62828" },
	        2: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.rejected" }), bg: "#ffebee", color: "#c62828" },
	        3: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.registry" }), bg: "#f3e5f5", color: "#7b1fa2" },
	        5: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.success" }), bg: "#e8f5e9", color: "#2e7d32" },
	        6: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.error" }), bg: "#fce4ec", color: "#ad1457" },
	        7: { label: intl.formatMessage({ id: "CrmPayoutDetails.status.awaitingPayout" }), bg: "#e1f5fe", color: "#0277bd" }
	    };
	    var config = configMap[status] || { label: "?" + status, bg: "#f5f5f5", color: "#666" };
	
	    return _react2.default.createElement(
	        "span",
	        { className: _stylesModule2.default.StatusPill, style: { background: config.bg, color: config.color } },
	        config.label
	    );
	}
	
	function formatDate(dateStr) {
	    if (!dateStr) return "-";
	    var d = new Date(dateStr);
	    return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
	}
	
	function formatAmount(amount, currency) {
	    if (amount === null || amount === undefined) return "-";
	    var value = Number(amount);
	    return value.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + (currency || "RUB");
	}
	
	function CrmPayoutDetails(props) {
	    var intl = (0, _reactIntl.useIntl)();
	    var request = props.request;
	    var token = props.token;
	    var onUpdate = props.onUpdate;
	    var onClose = props.onClose;
	    var onRegistryClick = props.onRegistryClick;
	    var onMessage = props.onMessage || function () {};
	
	    var _declineReason = (0, _react.useState)("");
	    var declineReason = _declineReason[0];
	    var setDeclineReason = _declineReason[1];
	
	    var _showDeclineInput = (0, _react.useState)(false);
	    var showDeclineInput = _showDeclineInput[0];
	    var setShowDeclineInput = _showDeclineInput[1];
	
	    var _isLoading = (0, _react.useState)(false);
	    var isLoading = _isLoading[0];
	    var setIsLoading = _isLoading[1];
	
	    var _showAntifraud = (0, _react.useState)(false);
	    var showAntifraud = _showAntifraud[0];
	    var setShowAntifraud = _showAntifraud[1];
	
	    var _showSuccessInput = (0, _react.useState)(false);
	    var showSuccessInput = _showSuccessInput[0];
	    var setShowSuccessInput = _showSuccessInput[1];
	
	    var _successFee = (0, _react.useState)("");
	    var successFee = _successFee[0];
	    var setSuccessFee = _successFee[1];
	
	    // Сброс при переключении заявки
	    (0, _react.useEffect)(function () {
	        setDeclineReason("");
	        setShowDeclineInput(false);
	        setShowAntifraud(false);
	        setShowSuccessInput(false);
	        setSuccessFee("");
	    }, [request ? request.id : null]);
	
	    if (!request) return null;
	
	    var status = Number(request.status);
	
	    // Контекстные действия по статусу
	    var canSendToAntifraud = status === 0;
	    var canDecline = status === 0 || status === 6 || status === 7;
	    var canMoveBack = status === 3 || status === 6;
	    var canMoveToSuccess = status === 3 || status === 4 || status === 6 || status === 7;
	    var hasActions = canSendToAntifraud || canDecline || canMoveBack || canMoveToSuccess;
	
	    // Отклонить заявку
	    function handleDecline() {
	        if (!declineReason) {
	            onMessage({ type: "warning", message: intl.formatMessage({ id: "CrmPayoutDetails.error.declineReasonRequired" }) });
	            return;
	        }
	        setIsLoading(true);
	        var api = new _Api2.default({ token: token });
	        api.declineCrmPayoutRequest(request.id, declineReason).then(function () {
	            return api.getCrmPayoutRequest(request.id);
	        }).then(function (updated) {
	            onUpdate(updated);
	            setShowDeclineInput(false);
	            setDeclineReason("");
	        }).catch(function (e) {
	            var msg = e.response && e.response.data && e.response.data.message || e.message || intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
	            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Отправить на антифрод
	    function handleSendToAntifraud() {
	        setIsLoading(true);
	        var api = new _Api2.default({ token: token });
	        api.sendToAntifraudCrmPayoutRequests([request.id]).then(function (result) {
	            if (result.errors && result.errors.length > 0) {
	                onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: result.errors[0].error }) });
	            } else {
	                onMessage({ type: "success", message: intl.formatMessage({ id: "CrmPayoutDetails.success.sentToAntifraud" }) });
	            }
	            return api.getCrmPayoutRequest(request.id);
	        }).then(function (updated) {
	            onUpdate(updated);
	        }).catch(function (e) {
	            var msg = e.response && e.response.data && e.response.data.message || e.message || intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
	            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Перевести в успех
	    function handleMoveToSuccess() {
	        setIsLoading(true);
	        var api = new _Api2.default({ token: token });
	        var fee = successFee ? parseFloat(successFee) : null;
	        api.moveToSuccessCrmPayoutRequest(request.id, fee).then(function () {
	            return api.getCrmPayoutRequest(request.id);
	        }).then(function (updated) {
	            onUpdate(updated);
	            setShowSuccessInput(false);
	            setSuccessFee("");
	            onMessage({ type: "success", message: intl.formatMessage({ id: "CrmPayoutDetails.success.movedToSuccess" }) });
	        }).catch(function (e) {
	            var msg = e.response && e.response.data && e.response.data.message || e.message || intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
	            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    // Вернуть в ожидание
	    function handleMoveBack() {
	        setIsLoading(true);
	        var api = new _Api2.default({ token: token });
	        api.moveBackToAwaitingCrmPayoutRequests([request.id]).then(function () {
	            return api.getCrmPayoutRequest(request.id);
	        }).then(function (updated) {
	            onUpdate(updated);
	        }).catch(function (e) {
	            var msg = e.response && e.response.data && e.response.data.message || e.message || intl.formatMessage({ id: "CrmPayoutDetails.error.unknown" });
	            onMessage({ type: "error", message: intl.formatMessage({ id: "CrmPayoutDetails.error.generic" }, { msg: msg }) });
	        }).then(function () {
	            setIsLoading(false);
	        });
	    }
	
	    var title = intl.formatMessage({ id: "CrmPayoutDetails.title" }, { id: request.id });
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        { isOpen: true, onClose: onClose, title: title },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.ModalBody },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.StatusRow },
	                _react2.default.createElement(StatusPill, { status: status })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.AmountBlock },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.AmountValue },
	                    formatAmount(request.amount, request.currency)
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InfoGrid },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.fullName" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        request.fullName || "-"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.merchant" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        request.merchantName || "-"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.createdAt" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        formatDate(request.createdAt)
	                    )
	                ),
	                request.payoutType === "sbp" ? _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.InfoItem },
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.InfoLabel },
	                            "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0421\u0411\u041F"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.InfoValueMono },
	                            request.sbpPhone || "-"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.InfoItem },
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.InfoLabel },
	                            "\u0411\u0430\u043D\u043A"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.InfoValue },
	                            request.sbpBankName || "-"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.InfoItem },
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.InfoLabel },
	                            "\u041A\u043E\u0434 \u0431\u0430\u043D\u043A\u0430 \u0421\u0411\u041F"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.InfoValueMono },
	                            request.sbpBankCode || request.sbpBankBic || "-"
	                        )
	                    )
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.card" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValueMono },
	                        request.cardPanMasked || "-"
	                    )
	                ),
	                request.phone && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.phone" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        request.phone
	                    )
	                ),
	                request.email && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.email" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        request.email
	                    )
	                ),
	                request.transactionId && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.transaction" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValueLink },
	                        "#",
	                        request.transactionId
	                    )
	                ),
	                request.registryId && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.registry" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        {
	                            className: _stylesModule2.default.InfoValueLink,
	                            onClick: function onClick() {
	                                if (onRegistryClick) onRegistryClick(request.registryId);
	                            }
	                        },
	                        "#",
	                        request.registryId
	                    )
	                ),
	                request.externalReference && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.documentNumber" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValueMono },
	                        request.externalReference
	                    )
	                ),
	                request.documentDate && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.documentDate" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        request.documentDate
	                    )
	                ),
	                request.description && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem + " " + _stylesModule2.default.InfoItemFull },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.description" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        request.description
	                    )
	                ),
	                request.updatedAt && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InfoItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoLabel },
	                        intl.formatMessage({ id: "CrmPayoutDetails.info.updatedAt" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InfoValue },
	                        formatDate(request.updatedAt)
	                    )
	                )
	            ),
	            request.declineReason && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.DeclineBox },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.DeclineLabel },
	                    intl.formatMessage({ id: "CrmPayoutDetails.decline.title" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.DeclineText },
	                    request.declineReason
	                )
	            ),
	            request.antifraudDetails && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.AntifraudSection },
	                _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.AntifraudToggle,
	                        onClick: function onClick() {
	                            setShowAntifraud(!showAntifraud);
	                        },
	                        type: "button"
	                    },
	                    intl.formatMessage({ id: "CrmPayoutDetails.antifraud.toggle" }),
	                    " ",
	                    showAntifraud ? "\u25B2" : "\u25BC"
	                ),
	                showAntifraud && _react2.default.createElement(
	                    "pre",
	                    { className: _stylesModule2.default.AntifraudPre },
	                    JSON.stringify(request.antifraudDetails, null, 2)
	                )
	            ),
	            hasActions && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ActionsSection },
	                showDeclineInput && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.DeclineInputWrap },
	                    _react2.default.createElement("input", {
	                        className: _stylesModule2.default.Input,
	                        placeholder: intl.formatMessage({ id: "CrmPayoutDetails.decline.placeholder" }),
	                        value: declineReason,
	                        onChange: function onChange(e) {
	                            setDeclineReason(e.target.value);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ActionButtons },
	                    canSendToAntifraud && _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnPrimary,
	                            onClick: handleSendToAntifraud,
	                            disabled: isLoading
	                        },
	                        isLoading ? _react2.default.createElement(_Loader2.default, { isString: true }) : intl.formatMessage({ id: "CrmPayoutDetails.action.sendToAntifraud" })
	                    ),
	                    canMoveBack && _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnWarning,
	                            onClick: handleMoveBack,
	                            disabled: isLoading
	                        },
	                        isLoading ? _react2.default.createElement(_Loader2.default, { isString: true }) : intl.formatMessage({ id: "CrmPayoutDetails.action.moveBack" })
	                    ),
	                    canMoveToSuccess && !showSuccessInput && _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnSuccess,
	                            onClick: function onClick() {
	                                setShowSuccessInput(true);
	                            },
	                            disabled: isLoading
	                        },
	                        intl.formatMessage({ id: "CrmPayoutDetails.action.moveToSuccess" })
	                    ),
	                    canMoveToSuccess && showSuccessInput && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement("input", {
	                            className: _stylesModule2.default.Input,
	                            type: "number",
	                            step: "0.01",
	                            placeholder: intl.formatMessage({ id: "CrmPayoutDetails.success.feePlaceholder" }),
	                            value: successFee,
	                            onChange: function onChange(e) {
	                                setSuccessFee(e.target.value);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnSuccess,
	                                onClick: handleMoveToSuccess,
	                                disabled: isLoading
	                            },
	                            isLoading ? _react2.default.createElement(_Loader2.default, { isString: true }) : intl.formatMessage({ id: "CrmPayoutDetails.action.confirm" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnSecondary,
	                                onClick: function onClick() {
	                                    setShowSuccessInput(false);setSuccessFee("");
	                                }
	                            },
	                            intl.formatMessage({ id: "CrmPayoutDetails.action.cancel" })
	                        )
	                    ),
	                    canDecline && !showDeclineInput && _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnDanger,
	                            onClick: function onClick() {
	                                setShowDeclineInput(true);
	                            },
	                            disabled: isLoading
	                        },
	                        intl.formatMessage({ id: "CrmPayoutDetails.action.decline" })
	                    ),
	                    canDecline && showDeclineInput && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnDanger,
	                                onClick: handleDecline,
	                                disabled: isLoading || !declineReason
	                            },
	                            isLoading ? _react2.default.createElement(_Loader2.default, { isString: true }) : intl.formatMessage({ id: "CrmPayoutDetails.action.confirmDecline" })
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnSecondary,
	                                onClick: function onClick() {
	                                    setShowDeclineInput(false);setDeclineReason("");
	                                }
	                            },
	                            intl.formatMessage({ id: "CrmPayoutDetails.action.cancel" })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	CrmPayoutDetails.defaultProps = {
	    onUpdate: function onUpdate() {},
	    onClose: function onClose() {},
	    onRegistryClick: function onRegistryClick() {},
	    onMessage: function onMessage() {}
	};
	
	exports.default = CrmPayoutDetails;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(539);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _FieldsHelper = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATUSES = [{ value: 0, label: "Создана", color: "#1565c0" }, { value: 1, label: "Антифрод", color: "#c62828" }, { value: 2, label: "Отклонена", color: "#c62828" }, { value: 7, label: "Ожидает выплаты", color: "#0277bd" }, { value: 3, label: "Реестр", color: "#7b1fa2" }, { value: 5, label: "Успех", color: "#2e7d32" }, { value: 6, label: "Ошибка", color: "#ad1457" }];
	
	function CrmPayoutFilters(props) {
	    var onClose = props.onClose;
	    var onApplyFilters = props.onApplyFilters;
	    var merchants = props.merchants; // [{uuid, displayName}]
	    var isLoading = props.isLoading;
	
	    var _selectedStatuses = (0, _react.useState)([]);
	    var selectedStatuses = _selectedStatuses[0];
	    var setSelectedStatuses = _selectedStatuses[1];
	
	    var _selectedMerchants = (0, _react.useState)([]);
	    var selectedMerchants = _selectedMerchants[0];
	    var setSelectedMerchants = _selectedMerchants[1];
	
	    var _dateRange = (0, _react.useState)({});
	    var dateRange = _dateRange[0];
	    var setDateRange = _dateRange[1];
	
	    var _amountMin = (0, _react.useState)("");
	    var amountMin = _amountMin[0];
	    var setAmountMin = _amountMin[1];
	
	    var _amountMax = (0, _react.useState)("");
	    var amountMax = _amountMax[0];
	    var setAmountMax = _amountMax[1];
	
	    var _targetAmount = (0, _react.useState)("");
	    var targetAmount = _targetAmount[0];
	    var setTargetAmount = _targetAmount[1];
	
	    function handleStatusChange(value, checked) {
	        if (checked) {
	            setSelectedStatuses(selectedStatuses.concat([value]));
	        } else {
	            setSelectedStatuses(selectedStatuses.filter(function (s) {
	                return s !== value;
	            }));
	        }
	    }
	
	    function handleApply() {
	        var filters = {};
	
	        if (selectedStatuses.length > 0) {
	            filters.status = selectedStatuses;
	        }
	        if (dateRange && dateRange.startDate) {
	            filters.dateFrom = dateRange.startDate;
	        }
	        if (dateRange && dateRange.endDate) {
	            filters.dateTo = dateRange.endDate;
	        }
	        if (amountMin) {
	            filters.amountMin = parseFloat(amountMin);
	        }
	        if (amountMax) {
	            filters.amountMax = parseFloat(amountMax);
	        }
	        if (targetAmount) {
	            filters.targetAmount = parseFloat(targetAmount);
	        }
	
	        onApplyFilters({
	            filters: filters,
	            projects: selectedMerchants.length > 0 ? selectedMerchants : undefined
	        });
	        onClose();
	    }
	
	    function handleReset() {
	        setSelectedStatuses([]);
	        setSelectedMerchants([]);
	        setDateRange({});
	        setAmountMin("");
	        setAmountMax("");
	        setTargetAmount("");
	        onApplyFilters({ filters: {} });
	        onClose();
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.FilterSection },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterLabel },
	                "\u041F\u0435\u0440\u0438\u043E\u0434"
	            ),
	            _react2.default.createElement(_DateRange2.default, {
	                onSelectDate: function onSelectDate(range) {
	                    setDateRange(range || {});
	                },
	                defaultPeriod: "zero"
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.FilterSection },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterLabel },
	                "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	            ),
	            _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                label: "Merchant.title",
	                placeholder: "Merchant.select",
	                isLoading: false,
	                selectedValues: selectedMerchants,
	                values: merchants || [],
	                onChange: setSelectedMerchants
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.FilterSection },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterLabel },
	                "\u0421\u0442\u0430\u0442\u0443\u0441"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.StatusList },
	                STATUSES.map(function (status) {
	                    var isChecked = selectedStatuses.indexOf(status.value) >= 0;
	                    return _react2.default.createElement(
	                        "label",
	                        { key: status.value, className: _stylesModule2.default.StatusCheckbox },
	                        _react2.default.createElement("input", {
	                            type: "checkbox",
	                            checked: isChecked,
	                            onChange: function onChange(e) {
	                                handleStatusChange(status.value, e.target.checked);
	                            }
	                        }),
	                        _react2.default.createElement("div", {
	                            className: _stylesModule2.default.StatusDot,
	                            style: { backgroundColor: status.color }
	                        }),
	                        _react2.default.createElement(
	                            "span",
	                            { className: isChecked ? _stylesModule2.default.StatusLabelActive : "" },
	                            status.label
	                        )
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.FilterSection },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterLabel },
	                "\u0421\u0443\u043C\u043C\u0430"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.AmountRow },
	                _react2.default.createElement("input", {
	                    className: _stylesModule2.default.AmountInput,
	                    type: "number",
	                    placeholder: "\u043E\u0442",
	                    value: amountMin,
	                    onChange: function onChange(e) {
	                        setAmountMin(e.target.value);
	                    }
	                }),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.AmountDash },
	                    "\u2014"
	                ),
	                _react2.default.createElement("input", {
	                    className: _stylesModule2.default.AmountInput,
	                    type: "number",
	                    placeholder: "\u0434\u043E",
	                    value: amountMax,
	                    onChange: function onChange(e) {
	                        setAmountMax(e.target.value);
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.FilterSection },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterLabel },
	                "\u0426\u0435\u043B\u0435\u0432\u0430\u044F \u0441\u0443\u043C\u043C\u0430"
	            ),
	            _react2.default.createElement("input", {
	                className: _stylesModule2.default.TargetAmountInput,
	                type: "number",
	                placeholder: "\u0426\u0435\u043B\u0435\u0432\u0430\u044F \u0441\u0443\u043C\u043C\u0430",
	                value: targetAmount,
	                onChange: function onChange(e) {
	                    setTargetAmount(e.target.value);
	                },
	                min: "0",
	                step: "0.01"
	            }),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterHint },
	                "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0438 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443, \u043E\u0436\u0438\u0434\u0430\u044E\u0449\u0438\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442 \u043F\u043E \u0441\u0443\u043C\u043C\u0435"
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.FilterActions },
	            _react2.default.createElement(
	                "button",
	                { onClick: handleApply, className: _stylesModule2.default.ApplyBtn, disabled: isLoading, type: "button" },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CrmPayout.filters.apply", defaultMessage: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { onClick: handleReset, className: _stylesModule2.default.ResetBtn, type: "button" },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "CrmPayout.filters.reset", defaultMessage: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C" })
	            )
	        )
	    );
	}
	
	CrmPayoutFilters.defaultProps = {
	    isOpen: false,
	    isLoading: false,
	    merchants: [],
	    onClose: function onClose() {},
	    onApplyFilters: function onApplyFilters() {}
	};
	
	exports.default = CrmPayoutFilters;

/***/ },
/* 364 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function formatAmount(amount) {
	    if (amount === null || amount === undefined) return "-";
	    var value = Number(amount);
	    return value.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20BD";
	}
	
	function normalizeItem(raw) {
	    return {
	        id: raw.id,
	        status: raw.status,
	        amount: Number(raw.amount) / 100,
	        fullName: raw.full_name,
	        cardPanMasked: raw.card_pan_masked,
	        payoutType: raw.payout_type,
	        sbpPhone: raw.sbp_phone,
	        sbpBankCode: raw.sbp_bank_code || raw.sbp_bank_bic,
	        sbpBankName: raw.sbp_bank_name,
	        documentDate: raw.document_date,
	        externalReference: raw.external_reference
	    };
	}
	
	var STATUS_NAMES = {
	    0: "Создана",
	    1: "Антифрод",
	    2: "Отклонена",
	    3: "Реестр",
	    4: "В работе",
	    5: "Успех",
	    6: "Ошибка",
	    7: "Ожидает"
	};
	
	var REGISTRY_STATUS = {
	    0: { label: "Создан", bg: "#e3f2fd", color: "#1565c0" },
	    1: { label: "В обработке", bg: "#fff3e0", color: "#e65100" },
	    2: { label: "Обработан", bg: "#e8f5e9", color: "#2e7d32" },
	    3: { label: "Ошибки", bg: "#fce4ec", color: "#ad1457" },
	    4: { label: "Отложен", bg: "#f5f5f5", color: "#616161" }
	};
	
	exports.formatAmount = formatAmount;
	exports.normalizeItem = normalizeItem;
	exports.STATUS_NAMES = STATUS_NAMES;
	exports.REGISTRY_STATUS = REGISTRY_STATUS;
	exports.default = { formatAmount: formatAmount, normalizeItem: normalizeItem, STATUS_NAMES: STATUS_NAMES, REGISTRY_STATUS: REGISTRY_STATUS };

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(540);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _CrmRegistryModalUtils = __webpack_require__(364);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDate(dateStr) {
	    if (!dateStr) return "";
	    var d = new Date(dateStr);
	    return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
	}
	
	function CrmRegistryModal(props) {
	    var registryId = props.registryId;
	    var registryInfo = props.registryInfo;
	    var token = props.token;
	    var onClose = props.onClose;
	    var onComplete = props.onComplete;
	    var onMessage = props.onMessage || function () {};
	    var payoutType = props.payoutType || "card";
	    var isSbp = payoutType === "sbp";
	
	    var _requests = (0, _react.useState)([]);
	    var requests = _requests[0];
	    var setRequests = _requests[1];
	
	    var _loading = (0, _react.useState)(false);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _uploading = (0, _react.useState)(false);
	    var uploading = _uploading[0];
	    var setUploading = _uploading[1];
	
	    var _uploadResult = (0, _react.useState)(null);
	    var uploadResult = _uploadResult[0];
	    var setUploadResult = _uploadResult[1];
	
	    // Предпросмотр отчёта: что произойдёт, если применить выбранный файл.
	    // Файл держим в состоянии — применяем ровно тот, цифры по которому показали.
	    var _preview = (0, _react.useState)(null);
	    var preview = _preview[0];
	    var setPreview = _preview[1];
	
	    var _pendingFile = (0, _react.useState)(null);
	    var pendingFile = _pendingFile[0];
	    var setPendingFile = _pendingFile[1];
	
	    // Чекбоксы для выбора заявок
	    var _checkedIds = (0, _react.useState)([]);
	    var checkedIds = _checkedIds[0];
	    var setCheckedIds = _checkedIds[1];
	
	    // Состояние для "Реестр из неуспешных"
	    var _showRetryModal = (0, _react.useState)(false);
	    var showRetryModal = _showRetryModal[0];
	    var setShowRetryModal = _showRetryModal[1];
	
	    var _retryRegistryName = (0, _react.useState)("");
	    var retryRegistryName = _retryRegistryName[0];
	    var setRetryRegistryName = _retryRegistryName[1];
	
	    var _retrying = (0, _react.useState)(false);
	    var retrying = _retrying[0];
	    var setRetrying = _retrying[1];
	
	    // Подтверждение удаления из реестра
	    var _showRemoveConfirm = (0, _react.useState)(false);
	    var showRemoveConfirm = _showRemoveConfirm[0];
	    var setShowRemoveConfirm = _showRemoveConfirm[1];
	
	    // Подтверждение расформирования
	    var _showDisbandConfirm = (0, _react.useState)(false);
	    var showDisbandConfirm = _showDisbandConfirm[0];
	    var setShowDisbandConfirm = _showDisbandConfirm[1];
	
	    var _disbanding = (0, _react.useState)(false);
	    var disbanding = _disbanding[0];
	    var setDisbanding = _disbanding[1];
	
	    // Остаток в новый реестр
	    var _showSplitModal = (0, _react.useState)(false);
	    var showSplitModal = _showSplitModal[0];
	    var setShowSplitModal = _showSplitModal[1];
	
	    var _splitRegistryName = (0, _react.useState)("");
	    var splitRegistryName = _splitRegistryName[0];
	    var setSplitRegistryName = _splitRegistryName[1];
	
	    var _splitting = (0, _react.useState)(false);
	    var splitting = _splitting[0];
	    var setSplitting = _splitting[1];
	
	    // Ref для скрытого file input
	    var fileInputRef = _react2.default.useRef(null);
	
	    // Загрузка заявок реестра
	    (0, _react.useEffect)(function () {
	        if (!registryId) return;
	
	        setLoading(true);
	        setUploadResult(null);
	        setCheckedIds([]);
	
	        new _Api2.default({ token: token }).getCrmPayoutRequests({
	            page: 1,
	            itemsPerPage: 200,
	            filters: { registryId: registryId }
	        }).then(function (r) {
	            var items = Array.isArray(r.items) ? r.items.map(_CrmRegistryModalUtils.normalizeItem) : [];
	            setRequests(items);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setRequests([]);
	        }).then(function () {
	            setLoading(false);
	        });
	    }, [registryId, token]);
	
	    if (!registryId) return null;
	
	    // Сумма заявок
	    var totalAmount = 0;
	    requests.forEach(function (r) {
	        totalAmount += Number(r.amount) || 0;
	    });
	
	    // Неуспешные заявки (статус 6 = Ошибка)
	    var failedRequests = requests.filter(function (r) {
	        return Number(r.status) === 6;
	    });
	    var hasFailedRequests = failedRequests.length > 0;
	
	    // Выплаченные (5) и ещё ожидающие ответа (3 «В реестре» + 4 «В работе»).
	    // Без этой разбивки по реестру не понять, сколько выплат ещё не отвечено:
	    // видно было только «Заявок» и «Неуспешных».
	    var paidRequests = requests.filter(function (r) {
	        return Number(r.status) === 5;
	    });
	    var awaitingRequests = requests.filter(function (r) {
	        var s = Number(r.status);
	        return s === 3 || s === 4;
	    });
	    var paidAmount = 0;
	    paidRequests.forEach(function (r) {
	        paidAmount += Number(r.amount) || 0;
	    });
	
	    // Заявки в статусе "В реестре" (3) — только их можно вытащить
	    var inRegistryRequests = requests.filter(function (r) {
	        return Number(r.status) === 3;
	    });
	    var canDisband = inRegistryRequests.length > 0;
	
	    // Выбранные заявки, которые в статусе "В реестре"
	    var checkedInRegistry = checkedIds.filter(function (id) {
	        var req = requests.find(function (r) {
	            return r.id === id;
	        });
	        return req && Number(req.status) === 3;
	    });
	
	    // Незавершённые заявки (IN_REGISTRY=3 или PROCESSING=4)
	    var remainingRequests = requests.filter(function (r) {
	        var s = Number(r.status);
	        return s === 3 || s === 4;
	    });
	
	    // Завершённые заявки (SUCCESS=5 или FAILED=6)
	    var finishedRequests = requests.filter(function (r) {
	        var s = Number(r.status);
	        return s === 5 || s === 6;
	    });
	
	    // Показывать "Остаток в новый реестр" — есть незавершённые И есть завершённые (частично обработан)
	    var canSplitRemaining = remainingRequests.length > 0 && finishedRequests.length > 0;
	
	    // Все ли заявки в статусе SUCCESS (5) — скрываем кнопку загрузки отчёта
	    var allSuccess = requests.length > 0 && requests.every(function (r) {
	        return Number(r.status) === 5;
	    });
	
	    // Все ли выбраны
	    var allChecked = requests.length > 0 && checkedIds.length === requests.length;
	
	    function handleCheckAll(e) {
	        if (e.target.checked) {
	            setCheckedIds(requests.map(function (r) {
	                return r.id;
	            }));
	        } else {
	            setCheckedIds([]);
	        }
	    }
	
	    function handleCheckOne(id, checked) {
	        if (checked) {
	            setCheckedIds(function (prev) {
	                return prev.concat([id]);
	            });
	        } else {
	            setCheckedIds(function (prev) {
	                return prev.filter(function (x) {
	                    return x !== id;
	                });
	            });
	        }
	    }
	
	    // Скачать Excel. format: 'yupay' — реестр в формате Юпэй, без него — обычный
	    function handleDownloadExcel(format) {
	        setLoading(true);
	        new _Api2.default({ token: token }).downloadCrmRegistryExcel(registryId, format).then(function (blob) {
	            var url = window.URL.createObjectURL(blob);
	            var a = document.createElement("a");
	            a.href = url;
	            a.download = "crm_registry_" + registryId + ".xlsx";
	            document.body.appendChild(a);
	            a.click();
	            document.body.removeChild(a);
	            window.URL.revokeObjectURL(url);
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            // responseType: 'blob' — при ошибке response.data может быть Blob с JSON
	            if (e.response && e.response.data instanceof Blob) {
	                e.response.data.text().then(function (text) {
	                    try {
	                        var data = JSON.parse(text);
	                        alert(data.message);
	                    } catch (parseErr) {
	                        onMessage({ type: "error", message: "Ошибка скачивания: " + (e.message || "Неизвестная ошибка") });
	                    }
	                });
	            } else if (e.responseData) {
	                alert(e.responseData.message);
	            } else {
	                onMessage({ type: "error", message: "Ошибка скачивания: " + (e.message || "Неизвестная ошибка") });
	            }
	        }).then(function () {
	            setLoading(false);
	        });
	    }
	
	    // Загрузить отчёт — по клику на кнопку открываем file picker
	    function handleUploadClick() {
	        if (fileInputRef.current) {
	            fileInputRef.current.value = "";
	            fileInputRef.current.click();
	        }
	    }
	
	    // Файл выбран — сначала показываем предпросмотр, ничего не записывая
	    function handleFileSelected(e) {
	        var file = e.target.files && e.target.files[0];
	        if (!file) return;
	
	        setUploading(true);
	        setUploadResult(null);
	        setPreview(null);
	        setPendingFile(null);
	
	        var formData = new FormData();
	        formData.append("file", file);
	
	        new _Api2.default({ token: token }).previewCrmRegistryReport(registryId, formData).then(function (result) {
	            setPreview(result);
	            setPendingFile(file);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            var msg = err.response && err.response.data && err.response.data.message || err.message || "Ошибка";
	            onMessage({ type: "error", message: "Не удалось прочитать отчёт: " + msg });
	        }).then(function () {
	            setUploading(false);
	        });
	    }
	
	    // Отменить предпросмотр — файл не применяется
	    function handlePreviewCancel() {
	        setPreview(null);
	        setPendingFile(null);
	        if (fileInputRef.current) fileInputRef.current.value = "";
	    }
	
	    // Применить показанный отчёт
	    function handlePreviewApply() {
	        if (!pendingFile) return;
	
	        setUploading(true);
	
	        var formData = new FormData();
	        formData.append("file", pendingFile);
	
	        new _Api2.default({ token: token }).uploadCrmRegistryReport(registryId, formData).then(function (result) {
	            setUploadResult(result);
	            // Перезагружаем список заявок
	            return new _Api2.default({ token: token }).getCrmPayoutRequests({
	                page: 1,
	                itemsPerPage: 200,
	                filters: { registryId: registryId }
	            });
	        }).then(function (r) {
	            var items = Array.isArray(r.items) ? r.items.map(_CrmRegistryModalUtils.normalizeItem) : [];
	            setRequests(items);
	            setCheckedIds([]);
	            setPreview(null);
	            setPendingFile(null);
	            if (fileInputRef.current) fileInputRef.current.value = "";
	            if (onComplete) onComplete();
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            onMessage({ type: "error", message: "Ошибка загрузки: " + msg });
	        }).then(function () {
	            setUploading(false);
	        });
	    }
	
	    // Убрать выбранные из реестра — шаг 1: проверить и показать подтверждение
	    function handleRemoveFromRegistry() {
	        if (checkedInRegistry.length === 0) {
	            onMessage({ type: "warning", message: "Выберите заявки в статусе \"В реестре\" для удаления" });
	            return;
	        }
	        setShowRemoveConfirm(true);
	    }
	
	    // Убрать выбранные из реестра — шаг 2: подтверждённое удаление
	    function handleRemoveConfirmed() {
	        setShowRemoveConfirm(false);
	        setLoading(true);
	        new _Api2.default({ token: token }).removeFromCrmRegistry(checkedInRegistry).then(function (result) {
	            var msg = "Убрано из реестра: " + (result.removed || 0);
	            if (result.errors && result.errors.length > 0) {
	                msg += ". Ошибки: " + result.errors.map(function (e) {
	                    return "#" + e.id + ": " + e.error;
	                }).join(", ");
	            }
	            onMessage({ type: result.errors && result.errors.length > 0 ? "warning" : "success", message: msg });
	
	            // Перезагружаем
	            return new _Api2.default({ token: token }).getCrmPayoutRequests({
	                page: 1,
	                itemsPerPage: 200,
	                filters: { registryId: registryId }
	            });
	        }).then(function (r) {
	            var items = Array.isArray(r.items) ? r.items.map(_CrmRegistryModalUtils.normalizeItem) : [];
	            setRequests(items);
	            setCheckedIds([]);
	            if (onComplete) onComplete();
	
	            // Если заявок не осталось — закрываем модалку
	            if (items.length === 0) {
	                onClose();
	            }
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            onMessage({ type: "error", message: "Ошибка: " + msg });
	        }).then(function () {
	            setLoading(false);
	        });
	    }
	
	    // Расформировать реестр
	    function handleDisbandRegistry() {
	        setShowDisbandConfirm(false);
	        setDisbanding(true);
	
	        new _Api2.default({ token: token }).disbandCrmRegistry(registryId).then(function (result) {
	            onMessage({ type: "success", message: "Реестр расформирован. Заявок возвращено: " + (result.requestsReturned || 0) });
	            if (onComplete) onComplete();
	            onClose();
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            onMessage({ type: "error", message: "Ошибка: " + msg });
	        }).then(function () {
	            setDisbanding(false);
	        });
	    }
	
	    // Реестр из неуспешных — два шага: вернуть в ожидание + создать реестр
	    function handleRetryFailed() {
	        if (!retryRegistryName) {
	            onMessage({ type: "warning", message: "Укажите название реестра" });
	            return;
	        }
	
	        var failedIds = failedRequests.map(function (r) {
	            return r.id;
	        });
	        if (failedIds.length === 0) return;
	
	        var api = new _Api2.default({ token: token });
	        setRetrying(true);
	
	        // Шаг 1: вернуть неуспешные в ожидание
	        api.moveBackToAwaitingCrmPayoutRequests(failedIds).then(function () {
	            // Шаг 2: создать новый реестр из них
	            return api.formCrmRegistry(failedIds, retryRegistryName, null);
	        }).then(function (result) {
	            onMessage({ type: "success", message: "Реестр #" + result.registryId + " создан. Заявок: " + result.requestCount });
	            setShowRetryModal(false);
	            setRetryRegistryName("");
	            // Перезагружаем текущий реестр
	            return new _Api2.default({ token: token }).getCrmPayoutRequests({
	                page: 1,
	                itemsPerPage: 200,
	                filters: { registryId: registryId }
	            });
	        }).then(function (r) {
	            var items = Array.isArray(r.items) ? r.items.map(_CrmRegistryModalUtils.normalizeItem) : [];
	            setRequests(items);
	            setCheckedIds([]);
	            if (onComplete) onComplete();
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            onMessage({ type: "error", message: "Ошибка: " + msg });
	        }).then(function () {
	            setRetrying(false);
	        });
	    }
	
	    // Остаток в новый реестр
	    function handleSplitRemaining() {
	        if (!splitRegistryName) {
	            onMessage({ type: "warning", message: "Укажите название реестра" });
	            return;
	        }
	
	        setSplitting(true);
	        new _Api2.default({ token: token }).splitCrmRegistryRemaining(registryId, splitRegistryName).then(function (result) {
	            onMessage({ type: "success", message: "Создан реестр #" + result.newRegistryId + ". Перенесено заявок: " + result.movedCount });
	            setShowSplitModal(false);
	            setSplitRegistryName("");
	            // Перезагружаем текущий реестр
	            return new _Api2.default({ token: token }).getCrmPayoutRequests({
	                page: 1,
	                itemsPerPage: 200,
	                filters: { registryId: registryId }
	            });
	        }).then(function (r) {
	            var items = Array.isArray(r.items) ? r.items.map(_CrmRegistryModalUtils.normalizeItem) : [];
	            setRequests(items);
	            setCheckedIds([]);
	            if (onComplete) onComplete();
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка";
	            onMessage({ type: "error", message: "Ошибка: " + msg });
	        }).then(function () {
	            setSplitting(false);
	        });
	    }
	
	    // Информация о реестре из props
	    var regName = registryInfo && registryInfo.name || "Реестр #" + registryId;
	    var regStatus = registryInfo ? Number(registryInfo.status) : null;
	    var regStatusInfo = regStatus !== null ? _CrmRegistryModalUtils.REGISTRY_STATUS[regStatus] || null : null;
	    var regDate = registryInfo ? registryInfo.date : null;
	
	    var title = regName;
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        { isOpen: true, onClose: onClose, title: title },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.RegistryBody },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.RegistryStatusBar },
	                regStatusInfo && _react2.default.createElement(
	                    "span",
	                    {
	                        className: _stylesModule2.default.RegistryStatusBadge,
	                        style: { background: regStatusInfo.bg, color: regStatusInfo.color }
	                    },
	                    regStatusInfo.label
	                ),
	                regDate && _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.RegistryDateText },
	                    formatDate(regDate)
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.RegistryIdText },
	                    "ID: ",
	                    registryId
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.SummaryRow },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SummaryItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryLabel },
	                        "\u0417\u0430\u044F\u0432\u043E\u043A"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryValue },
	                        requests.length
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SummaryItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryLabel },
	                        "\u0421\u0443\u043C\u043C\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryValue },
	                        (0, _CrmRegistryModalUtils.formatAmount)(totalAmount)
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SummaryItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryLabel },
	                        "\u0412\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043E"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryValue + " " + _stylesModule2.default.SuccessText },
	                        paidRequests.length
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SummaryItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryLabel },
	                        "\u0412\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043E \u043D\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryValue },
	                        (0, _CrmRegistryModalUtils.formatAmount)(paidAmount)
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SummaryItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryLabel, title: "\u041E\u0442\u0432\u0435\u0442\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u043F\u043E \u044D\u0442\u0438\u043C \u0432\u044B\u043F\u043B\u0430\u0442\u0430\u043C \u0435\u0449\u0451 \u043D\u0435\u0442" },
	                        "\u0416\u0434\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryValue },
	                        awaitingRequests.length
	                    )
	                ),
	                hasFailedRequests && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SummaryItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryLabel },
	                        "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0445"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryValue + " " + _stylesModule2.default.FailText },
	                        failedRequests.length
	                    )
	                ),
	                checkedIds.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SummaryItem },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryLabel },
	                        "\u0412\u044B\u0431\u0440\u0430\u043D\u043E"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SummaryValue + " " + _stylesModule2.default.SelectedText },
	                        checkedIds.length
	                    )
	                )
	            ),
	            loading ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.LoadingWrap },
	                _react2.default.createElement(_Loader2.default, null)
	            ) : _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.TableWrap },
	                _react2.default.createElement(
	                    "table",
	                    { className: _stylesModule2.default.Table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                { className: _stylesModule2.default.CheckboxCol },
	                                _react2.default.createElement("input", {
	                                    type: "checkbox",
	                                    checked: allChecked,
	                                    onChange: handleCheckAll,
	                                    title: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0424\u0418\u041E"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0443\u043C\u043C\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                isSbp ? "Телефон / банк" : "Карта"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        requests.map(function (r) {
	                            var requisites = isSbp ? [r.sbpPhone, r.sbpBankName].filter(Boolean).join(" · ") || "-" : r.cardPanMasked || "-";
	                            var statusName = _CrmRegistryModalUtils.STATUS_NAMES[Number(r.status)] || "?";
	                            var isFailed = Number(r.status) === 6;
	                            var isChecked = checkedIds.indexOf(r.id) >= 0;
	                            var docInfo = "";
	                            if (r.externalReference) docInfo += r.externalReference;
	                            if (r.externalReference && r.documentDate) docInfo += " ";
	                            if (r.documentDate) docInfo += r.documentDate;
	
	                            return _react2.default.createElement(
	                                "tr",
	                                { key: r.id, className: isFailed ? _stylesModule2.default.FailedRow : "" },
	                                _react2.default.createElement(
	                                    "td",
	                                    { className: _stylesModule2.default.CheckboxCol },
	                                    _react2.default.createElement("input", {
	                                        type: "checkbox",
	                                        checked: isChecked,
	                                        onChange: function onChange(e) {
	                                            handleCheckOne(r.id, e.target.checked);
	                                        }
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    r.fullName || "-"
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    (0, _CrmRegistryModalUtils.formatAmount)(r.amount)
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    { className: _stylesModule2.default.MonoCell },
	                                    requisites
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    { className: _stylesModule2.default.DocCell },
	                                    docInfo || "-"
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    statusName
	                                )
	                            );
	                        }),
	                        requests.length === 0 && _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                { colSpan: "6", className: _stylesModule2.default.EmptyRow },
	                                "\u041D\u0435\u0442 \u0437\u0430\u044F\u0432\u043E\u043A"
	                            )
	                        )
	                    )
	                )
	            ),
	            preview && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.UploadResult },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.UploadResultTitle },
	                    "\u0427\u0442\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0441\u044F, \u0435\u0441\u043B\u0438 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u0442\u0447\u0451\u0442"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.UploadResultRow },
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SuccessText },
	                        "\u0412\u044B\u043F\u043B\u0430\u0442\u0438\u0442\u044C: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            preview.success || 0
	                        ),
	                        preview.successAmount ? " на " + (0, _CrmRegistryModalUtils.formatAmount)(Number(preview.successAmount) / 100) : ""
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.FailText },
	                        "\u041E\u0442\u043A\u0430\u0437\u0430\u0442\u044C: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            preview.failed || 0
	                        ),
	                        preview.failedAmount ? " на " + (0, _CrmRegistryModalUtils.formatAmount)(Number(preview.failedAmount) / 100) : ""
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { title: "\u0421\u0442\u0440\u043E\u043A\u0438 \u0431\u0435\u0437 \u043E\u0442\u0432\u0435\u0442\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u2014 \u0441\u0442\u0430\u0442\u0443\u0441 \u043D\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0441\u044F" },
	                        "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0432 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            preview.pending || 0
	                        )
	                    ),
	                    preview.skipped > 0 && _react2.default.createElement(
	                        "span",
	                        { title: "\u0421\u0442\u0440\u043E\u043A\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0435\u043B\u044C\u0437\u044F \u2014 \u043F\u0440\u0438\u0447\u0438\u043D\u0430 \u043D\u0438\u0436\u0435" },
	                        "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            preview.skipped
	                        )
	                    )
	                ),
	                preview.errors && preview.errors.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.UploadErrors },
	                    preview.errors.map(function (err, i) {
	                        return _react2.default.createElement(
	                            "div",
	                            { key: i, className: _stylesModule2.default.ErrorLine },
	                            err.transactionId ? "tx " + err.transactionId + ": " : "",
	                            err.error || err
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.PreviewActions },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnUpload,
	                            onClick: handlePreviewApply,
	                            disabled: uploading
	                        },
	                        uploading ? "Применяю..." : "Применить отчёт"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnCancelPreview,
	                            onClick: handlePreviewCancel,
	                            disabled: uploading
	                        },
	                        "\u041E\u0442\u043C\u0435\u043D\u0430"
	                    )
	                )
	            ),
	            uploadResult && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.UploadResult },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.UploadResultTitle },
	                    "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043E\u0442\u0447\u0451\u0442\u0430"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.UploadResultRow },
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043E: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            uploadResult.processed || 0
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.SuccessText },
	                        "\u0423\u0441\u043F\u0435\u0445: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            uploadResult.success || 0
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.FailText },
	                        "\u041E\u0448\u0438\u0431\u043E\u043A: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            uploadResult.failed || 0
	                        )
	                    ),
	                    uploadResult.pending > 0 && _react2.default.createElement(
	                        "span",
	                        { title: "\u0412 \u043E\u0442\u0447\u0451\u0442\u0435 \u043D\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0430 \u043F\u043E \u044D\u0442\u0438\u043C \u0432\u044B\u043F\u043B\u0430\u0442\u0430\u043C \u2014 \u0441\u0442\u0430\u0442\u0443\u0441 \u043D\u0435 \u043C\u0435\u043D\u044F\u043B\u0441\u044F, \u0436\u0434\u0451\u043C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E \u0447\u0430\u0441\u0442\u044C \u043E\u0442\u0447\u0451\u0442\u0430" },
	                        "\u0411\u0435\u0437 \u043E\u0442\u0432\u0435\u0442\u0430: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            uploadResult.pending
	                        )
	                    ),
	                    uploadResult.skipped > 0 && _react2.default.createElement(
	                        "span",
	                        { title: "\u0421\u0442\u0440\u043E\u043A\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043D\u044F\u0442\u044C \u2014 \u0441\u0442\u0430\u0442\u0443\u0441 \u043D\u0435 \u043C\u0435\u043D\u044F\u043B\u0441\u044F" },
	                        "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E: ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            uploadResult.skipped
	                        )
	                    )
	                ),
	                uploadResult.errors && uploadResult.errors.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.UploadErrors },
	                    uploadResult.errors.map(function (err, i) {
	                        return _react2.default.createElement(
	                            "div",
	                            { key: i, className: _stylesModule2.default.ErrorLine },
	                            err.id ? "#" + err.id + ": " : "",
	                            err.transactionId ? "tx " + err.transactionId + ": " : "",
	                            err.error || err
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Actions },
	                _react2.default.createElement("input", {
	                    type: "file",
	                    accept: ".csv,.xlsx,.xls",
	                    ref: fileInputRef,
	                    onChange: handleFileSelected,
	                    style: { display: "none" }
	                }),
	                !isSbp && _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.BtnDownload,
	                        onClick: function onClick() {
	                            handleDownloadExcel();
	                        },
	                        disabled: loading || requests.length === 0
	                    },
	                    "\u0421\u043A\u0430\u0447\u0430\u0442\u044C Excel"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.BtnDownload,
	                        onClick: function onClick() {
	                            handleDownloadExcel("yupay");
	                        },
	                        disabled: loading || requests.length === 0
	                    },
	                    "\u0421\u043A\u0430\u0447\u0430\u0442\u044C Excel (\u042E\u043F\u044D\u0439)"
	                ),
	                !allSuccess && _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.BtnUpload,
	                        onClick: handleUploadClick,
	                        disabled: uploading || loading
	                    },
	                    uploading ? "Загрузка..." : "Загрузить отчёт"
	                ),
	                checkedInRegistry.length > 0 && _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.BtnRemove,
	                        onClick: handleRemoveFromRegistry,
	                        disabled: loading || disbanding
	                    },
	                    "\u0423\u0431\u0440\u0430\u0442\u044C \u0438\u0437 \u0440\u0435\u0435\u0441\u0442\u0440\u0430 (",
	                    checkedInRegistry.length,
	                    ")"
	                ),
	                canDisband && _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.BtnDisband,
	                        onClick: function onClick() {
	                            setShowDisbandConfirm(true);
	                        },
	                        disabled: loading || disbanding
	                    },
	                    disbanding ? "Расформирование..." : "Расформировать"
	                ),
	                hasFailedRequests && _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.BtnRetry,
	                        onClick: function onClick() {
	                            setShowRetryModal(true);
	                        },
	                        disabled: loading || retrying
	                    },
	                    "\u0420\u0435\u0435\u0441\u0442\u0440 \u0438\u0437 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0445 (",
	                    failedRequests.length,
	                    ")"
	                ),
	                canSplitRemaining && _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.BtnSplit,
	                        onClick: function onClick() {
	                            setShowSplitModal(true);
	                        },
	                        disabled: loading || splitting
	                    },
	                    "\u041E\u0441\u0442\u0430\u0442\u043E\u043A \u0432 \u043D\u043E\u0432\u044B\u0439 \u0440\u0435\u0435\u0441\u0442\u0440 (",
	                    remainingRequests.length,
	                    ")"
	                )
	            ),
	            showRemoveConfirm && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.RetryOverlay },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.RetryModal },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryTitle },
	                        "\u0423\u0431\u0440\u0430\u0442\u044C \u0438\u0437 \u0440\u0435\u0435\u0441\u0442\u0440\u0430?"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.DisbandText },
	                        checkedInRegistry.length,
	                        " \u0437\u0430\u044F\u0432\u043E\u043A \u0431\u0443\u0434\u0443\u0442 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u044B \u0432 \u0441\u0442\u0430\u0442\u0443\u0441 \"\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0442\u044B\"."
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryActions },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnRetryCancel,
	                                onClick: function onClick() {
	                                    setShowRemoveConfirm(false);
	                                }
	                            },
	                            "\u041E\u0442\u043C\u0435\u043D\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnDisbandConfirm,
	                                onClick: handleRemoveConfirmed,
	                                disabled: loading
	                            },
	                            "\u0423\u0431\u0440\u0430\u0442\u044C"
	                        )
	                    )
	                )
	            ),
	            showDisbandConfirm && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.RetryOverlay },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.RetryModal },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryTitle },
	                        "\u0420\u0430\u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0435\u0441\u0442\u0440?"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.DisbandText },
	                        "\u0412\u0441\u0435 ",
	                        inRegistryRequests.length,
	                        " \u0437\u0430\u044F\u0432\u043E\u043A \u0438\u0437 \u0440\u0435\u0435\u0441\u0442\u0440\u0430 \u0431\u0443\u0434\u0443\u0442 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u044B \u0432 \u0441\u0442\u0430\u0442\u0443\u0441 \"\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0442\u044B\". \u0420\u0435\u0435\u0441\u0442\u0440 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0451\u043D. \u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C."
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryActions },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnRetryCancel,
	                                onClick: function onClick() {
	                                    setShowDisbandConfirm(false);
	                                }
	                            },
	                            "\u041E\u0442\u043C\u0435\u043D\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnDisbandConfirm,
	                                onClick: handleDisbandRegistry,
	                                disabled: disbanding
	                            },
	                            disbanding ? "Расформирование..." : "Расформировать"
	                        )
	                    )
	                )
	            ),
	            showRetryModal && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.RetryOverlay },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.RetryModal },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryTitle },
	                        "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0440\u0435\u0435\u0441\u0442\u0440 \u0438\u0437 ",
	                        failedRequests.length,
	                        " \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0445 \u0437\u0430\u044F\u0432\u043E\u043A"
	                    ),
	                    _react2.default.createElement("input", {
	                        className: _stylesModule2.default.RetryInput,
	                        placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0440\u0435\u0435\u0441\u0442\u0440\u0430...",
	                        value: retryRegistryName,
	                        onChange: function onChange(e) {
	                            setRetryRegistryName(e.target.value);
	                        },
	                        autoFocus: true
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryActions },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnRetryCancel,
	                                onClick: function onClick() {
	                                    setShowRetryModal(false);
	                                }
	                            },
	                            "\u041E\u0442\u043C\u0435\u043D\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnRetryConfirm,
	                                onClick: handleRetryFailed,
	                                disabled: retrying || !retryRegistryName
	                            },
	                            retrying ? "Создание..." : "Создать"
	                        )
	                    )
	                )
	            ),
	            showSplitModal && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.RetryOverlay },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.RetryModal },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryTitle },
	                        "\u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0442\u0438 ",
	                        remainingRequests.length,
	                        " \u043D\u0435\u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D\u043D\u044B\u0445 \u0437\u0430\u044F\u0432\u043E\u043A \u0432 \u043D\u043E\u0432\u044B\u0439 \u0440\u0435\u0435\u0441\u0442\u0440"
	                    ),
	                    _react2.default.createElement("input", {
	                        className: _stylesModule2.default.RetryInput,
	                        placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0440\u0435\u0435\u0441\u0442\u0440\u0430...",
	                        value: splitRegistryName,
	                        onChange: function onChange(e) {
	                            setSplitRegistryName(e.target.value);
	                        },
	                        autoFocus: true
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.RetryActions },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnRetryCancel,
	                                onClick: function onClick() {
	                                    setShowSplitModal(false);
	                                }
	                            },
	                            "\u041E\u0442\u043C\u0435\u043D\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnRetryConfirm,
	                                onClick: handleSplitRemaining,
	                                disabled: splitting || !splitRegistryName
	                            },
	                            splitting ? "Перенос..." : "Перенести"
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	CrmRegistryModal.defaultProps = {
	    onClose: function onClose() {},
	    onComplete: function onComplete() {},
	    onMessage: function onMessage() {},
	    registryInfo: null,
	    payoutType: "card"
	};
	
	exports.default = CrmRegistryModal;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(541);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Status pill
	function StatusPill(_ref) {
	    var status = _ref.status;
	
	    var intl = (0, _reactIntl.useIntl)();
	    var statusConfig = {
	        new: { label: intl.formatMessage({ id: 'Disputes.status.new' }), bg: '#e3f2fd', color: '#1565c0' },
	        in_progress: {
	            label: intl.formatMessage({ id: 'Disputes.status.inProgress' }),
	            bg: '#fff3e0',
	            color: '#e65100'
	        },
	        resolved: { label: intl.formatMessage({ id: 'Disputes.status.resolved' }), bg: '#e8f5e9', color: '#2e7d32' },
	        archived: { label: intl.formatMessage({ id: 'Disputes.status.archived' }), bg: '#f5f5f5', color: '#757575' }
	    };
	
	    var config = statusConfig[status] || { label: status, bg: '#f5f5f5', color: '#666' };
	
	    return _react2.default.createElement(
	        'span',
	        { className: _stylesModule2.default.StatusPill, style: { background: config.bg, color: config.color } },
	        config.label
	    );
	}
	
	function AttachmentsList(_ref2) {
	    var handleOpenAttachment = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(att, idx) {
	            var api, attDisputeId, attIndex, result;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setLoadingIndex(idx);
	                            _context.prev = 1;
	                            api = new _Api2.default({ token: token });
	                            // Каждое вложение может принадлежать другому disputeId (медиагруппа)
	
	                            attDisputeId = att.disputeId || disputeId;
	                            // Находим индекс этого вложения внутри его dispute
	
	                            attIndex = att.indexInDispute != null ? att.indexInDispute : 0;
	                            _context.next = 7;
	                            return api.getDisputeAttachmentUrl(attDisputeId, attIndex);
	
	                        case 7:
	                            result = _context.sent;
	
	                            if (result.error) {
	                                alert(result.message || intl.formatMessage({ id: 'DisputeDetails.error.fileLoad' }));
	                            } else {
	                                window.open(result.url, '_blank');
	                            }
	                            _context.next = 14;
	                            break;
	
	                        case 11:
	                            _context.prev = 11;
	                            _context.t0 = _context['catch'](1);
	
	                            alert(intl.formatMessage({ id: 'DisputeDetails.error.generic' }, { message: _context.t0.message || intl.formatMessage({ id: 'DisputeDetails.error.fileOpen' }) }));
	
	                        case 14:
	                            setLoadingIndex(null);
	
	                        case 15:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[1, 11]]);
	        }));
	
	        return function handleOpenAttachment(_x, _x2) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    var attachments = _ref2.attachments,
	        disputeId = _ref2.disputeId,
	        token = _ref2.token;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        loadingIndex = _useState2[0],
	        setLoadingIndex = _useState2[1];
	
	    function formatFileSize(bytes) {
	        if (!bytes) return '';
	        if (bytes < 1024) return bytes + ' B';
	        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
	        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.AttachmentsSection },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.AttachmentsTitle },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.attachments.title', values: { count: attachments.length } })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.AttachmentsList },
	            attachments.map(function (att, idx) {
	                var isPhoto = att.type === 'photo';
	                var name = att.file_name || (isPhoto ? intl.formatMessage({ id: 'DisputeDetails.attachments.photo' }) : intl.formatMessage({ id: 'DisputeDetails.attachments.file' }));
	                var sizeStr = formatFileSize(att.file_size);
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: idx, className: _stylesModule2.default.AttachmentItem },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.AttachmentIcon },
	                        isPhoto ? '\uD83D\uDDBC' : '\uD83D\uDCCE'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.AttachmentInfo },
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.AttachmentName },
	                            name
	                        ),
	                        sizeStr && _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.AttachmentSize },
	                            sizeStr
	                        ),
	                        att.mime_type && _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.AttachmentMime },
	                            att.mime_type
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnAttachment,
	                            onClick: function onClick() {
	                                handleOpenAttachment(att, idx);
	                            },
	                            disabled: loadingIndex === idx
	                        },
	                        loadingIndex === idx ? '...' : intl.formatMessage({ id: 'DisputeDetails.attachments.open' })
	                    )
	                );
	            })
	        )
	    );
	}
	
	function DisputeDetails(_ref4) {
	
	    // Check transaction status (without linking)
	    var handleCheckTransaction = function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var api, result;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (transactionInput) {
	                                _context2.next = 2;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 2:
	
	                            setIsCheckingProvider(true);
	                            setCheckResult(null);
	                            _context2.prev = 4;
	                            api = new _Api2.default({ token: token });
	                            _context2.next = 8;
	                            return api.checkDisputeTransaction(parseInt(transactionInput, 10));
	
	                        case 8:
	                            result = _context2.sent;
	
	                            setCheckResult(result);
	                            _context2.next = 15;
	                            break;
	
	                        case 12:
	                            _context2.prev = 12;
	                            _context2.t0 = _context2['catch'](4);
	
	                            setCheckResult({ error: true, message: _context2.t0.message || intl.formatMessage({ id: 'DisputeDetails.error.check' }) });
	
	                        case 15:
	                            setIsCheckingProvider(false);
	
	                        case 16:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[4, 12]]);
	        }));
	
	        return function handleCheckTransaction() {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	
	    // Check provider status (for linked transaction)
	
	
	    var handleCheckProvider = function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	            var api, result;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            setIsCheckingProvider(true);
	                            setProviderStatus(null);
	                            _context3.prev = 2;
	                            api = new _Api2.default({ token: token });
	                            _context3.next = 6;
	                            return api.checkDisputeProvider(dispute.id);
	
	                        case 6:
	                            result = _context3.sent;
	
	                            setProviderStatus(result);
	                            if (!result.error) {
	                                onUpdate && onUpdate(Object.assign({}, dispute, { providerStatus: result.providerStatus }));
	                            }
	                            _context3.next = 14;
	                            break;
	
	                        case 11:
	                            _context3.prev = 11;
	                            _context3.t0 = _context3['catch'](2);
	
	                            setProviderStatus({ error: true, message: _context3.t0.message || intl.formatMessage({ id: 'DisputeDetails.error.check' }) });
	
	                        case 14:
	                            setIsCheckingProvider(false);
	
	                        case 15:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[2, 11]]);
	        }));
	
	        return function handleCheckProvider() {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	
	    // Update status
	
	
	    var handleStatusChange = function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(newStatus) {
	            var api, payload, result;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            setIsLoading(true);
	                            _context4.prev = 1;
	                            api = new _Api2.default({ token: token });
	                            payload = { status: newStatus };
	
	
	                            if (newStatus === 'resolved' && noteInput) {
	                                payload.note = noteInput;
	                            }
	
	                            _context4.next = 7;
	                            return api.updateDispute(dispute.id, payload);
	
	                        case 7:
	                            result = _context4.sent;
	
	
	                            if (result.error) {
	                                alert(result.message || intl.formatMessage({ id: 'DisputeDetails.error.updateStatus' }));
	                            } else {
	                                onUpdate && onUpdate(result.dispute);
	                            }
	                            _context4.next = 14;
	                            break;
	
	                        case 11:
	                            _context4.prev = 11;
	                            _context4.t0 = _context4['catch'](1);
	
	                            alert(intl.formatMessage({ id: 'DisputeDetails.error.generic' }, { message: _context4.t0.message || intl.formatMessage({ id: 'DisputeDetails.error.unknown' }) }));
	
	                        case 14:
	                            setIsLoading(false);
	
	                        case 15:
	                        case 'end':
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this, [[1, 11]]);
	        }));
	
	        return function handleStatusChange(_x3) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	
	    // Save note
	
	
	    var handleSaveNote = function () {
	        var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	            var api, result;
	            return _regenerator2.default.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            setIsLoading(true);
	                            _context5.prev = 1;
	                            api = new _Api2.default({ token: token });
	                            _context5.next = 5;
	                            return api.updateDispute(dispute.id, { note: noteInput });
	
	                        case 5:
	                            result = _context5.sent;
	
	
	                            if (result.error) {
	                                alert(result.message || intl.formatMessage({ id: 'DisputeDetails.error.saveNote' }));
	                            } else {
	                                onUpdate && onUpdate(result.dispute);
	                            }
	                            _context5.next = 12;
	                            break;
	
	                        case 9:
	                            _context5.prev = 9;
	                            _context5.t0 = _context5['catch'](1);
	
	                            alert(intl.formatMessage({ id: 'DisputeDetails.error.generic' }, { message: _context5.t0.message || intl.formatMessage({ id: 'DisputeDetails.error.unknown' }) }));
	
	                        case 12:
	                            setIsLoading(false);
	
	                        case 13:
	                        case 'end':
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this, [[1, 9]]);
	        }));
	
	        return function handleSaveNote() {
	            return _ref8.apply(this, arguments);
	        };
	    }();
	
	    var dispute = _ref4.dispute,
	        token = _ref4.token,
	        onUpdate = _ref4.onUpdate,
	        _onClose = _ref4.onClose;
	
	    var intl = (0, _reactIntl.useIntl)();
	    // Функция извлечения ID транзакции из текста сообщения
	    var extractTransactionId = function extractTransactionId(messageText) {
	        if (!messageText) return '';
	        // Ищем 7-значное число в тексте (например: 2415234, 2425157)
	        var match = messageText.match(/\b\d{7}\b/);
	        return match ? match[0] : '';
	    };
	
	    var _useState3 = (0, _react.useState)(dispute.transactionId || extractTransactionId(dispute.messageText)),
	        _useState4 = _slicedToArray(_useState3, 2),
	        transactionInput = _useState4[0],
	        setTransactionInput = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(dispute.resolutionNote || ''),
	        _useState6 = _slicedToArray(_useState5, 2),
	        noteInput = _useState6[0],
	        setNoteInput = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        providerStatus = _useState8[0],
	        setProviderStatus = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        isCheckingProvider = _useState10[0],
	        setIsCheckingProvider = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        checkResult = _useState12[0],
	        setCheckResult = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        isLoading = _useState14[0],
	        setIsLoading = _useState14[1];
	
	    // Сброс состояния при переключении между диспутами
	
	
	    (0, _react.useEffect)(function () {
	        var extractedId = extractTransactionId(dispute.messageText);
	        setTransactionInput(dispute.transactionId || extractedId);
	        setNoteInput(dispute.resolutionNote || '');
	        setProviderStatus(null);
	        setCheckResult(null);
	    }, [dispute.id]);
	
	    // Автоматическая проверка транзакции при открытии диспута
	    (0, _react.useEffect)(function () {
	        var extractedId = extractTransactionId(dispute.messageText);
	        var txId = dispute.transactionId || extractedId;
	
	        if (txId) {
	            // Автоматически проверяем транзакцию
	            setIsCheckingProvider(true);
	            setCheckResult(null);
	
	            var api = new _Api2.default({ token: token });
	            api.checkDisputeTransaction(parseInt(txId, 10)).then(function (result) {
	                setCheckResult(result);
	            }).catch(function (e) {
	                setCheckResult({ error: true, message: e.message || intl.formatMessage({ id: 'DisputeDetails.error.check' }) });
	            }).finally(function () {
	                setIsCheckingProvider(false);
	            });
	        }
	    }, [dispute.id]);
	
	    var formatDate = function formatDate(dateStr) {
	        if (!dateStr) return '-';
	        var d = new Date(dateStr);
	        return d.toLocaleDateString(intl.locale) + ' ' + d.toLocaleTimeString(intl.locale, { hour: '2-digit', minute: '2-digit' });
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Header },
	            _react2.default.createElement(
	                'h5',
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.title' }),
	                ' #',
	                dispute.id
	            ),
	            _react2.default.createElement(StatusPill, { status: dispute.status })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Section },
	                _react2.default.createElement(
	                    'h6',
	                    { className: _stylesModule2.default.SectionTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.section.message' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.InfoGrid },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.InfoItem },
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoLabel },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.label.chat' })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoValue },
	                            dispute.chatTitle || '-'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.InfoItem },
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoLabel },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.label.sender' })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoValue },
	                            dispute.senderName || '-'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.InfoItem },
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoLabel },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.label.date' })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoValue },
	                            formatDate(dispute.createdAt)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.InfoItem },
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoLabel },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.label.attachment' })
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _stylesModule2.default.InfoValue },
	                            dispute.hasAttachment ? intl.formatMessage({ id: 'DisputeDetails.value.yes' }) : intl.formatMessage({ id: 'DisputeDetails.value.no' })
	                        )
	                    )
	                ),
	                dispute.messageText && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.MessageBox },
	                    dispute.messageText
	                ),
	                dispute.attachments && dispute.attachments.length > 0 && _react2.default.createElement(AttachmentsList, { attachments: dispute.attachments, disputeId: dispute.id, token: token })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Section },
	                _react2.default.createElement(
	                    'h6',
	                    { className: _stylesModule2.default.SectionTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.section.transaction' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.TransactionRow },
	                    _react2.default.createElement('input', {
	                        type: 'text',
	                        className: _stylesModule2.default.Input,
	                        placeholder: intl.formatMessage({ id: 'DisputeDetails.transaction.placeholder' }),
	                        value: transactionInput,
	                        onChange: function onChange(e) {
	                            return setTransactionInput(e.target.value);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnSecondary,
	                            onClick: handleCheckTransaction,
	                            disabled: isCheckingProvider || !transactionInput
	                        },
	                        isCheckingProvider ? _react2.default.createElement(_Loader2.default, { isString: true }) : intl.formatMessage({ id: 'DisputeDetails.transaction.check' })
	                    )
	                ),
	                checkResult && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ProviderResult },
	                    checkResult.error ? _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.ErrorBox },
	                        checkResult.message
	                    ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.StatusRow },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.transaction.ourStatus' })
	                            ),
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                checkResult.ourStatusLabel || checkResult.ourStatus
	                            )
	                        ),
	                        checkResult.merchantName && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.StatusRow },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.transaction.merchant' })
	                            ),
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                checkResult.merchantName
	                            )
	                        ),
	                        checkResult.amount && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.StatusRow },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.transaction.amount' })
	                            ),
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                checkResult.amount,
	                                ' ',
	                                checkResult.currency
	                            )
	                        ),
	                        checkResult.providerStatus && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.ProviderBox },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatusRow },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.transaction.provider' })
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    checkResult.providerStatus.provider
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatusRow },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.transaction.providerStatus' })
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    checkResult.providerStatus.statusHuman || checkResult.providerStatus.providerStatus
	                                )
	                            )
	                        )
	                    )
	                ),
	                dispute.transactionId && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.LinkedTransaction },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.StatusRow },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.linked.transaction' })
	                        ),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '#',
	                            dispute.transactionId
	                        )
	                    ),
	                    dispute.merchantName && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.StatusRow },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.linked.merchant' })
	                        ),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            dispute.merchantName
	                        )
	                    ),
	                    dispute.ourStatus && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.StatusRow },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.linked.statusAtCreation' })
	                        ),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            dispute.ourStatus
	                        )
	                    ),
	                    dispute.ourStatusCurrent && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.StatusRow },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.linked.currentStatus' })
	                        ),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            dispute.ourStatusCurrent
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnCheck,
	                            onClick: handleCheckProvider,
	                            disabled: isCheckingProvider
	                        },
	                        isCheckingProvider ? _react2.default.createElement(_Loader2.default, { isString: true }) : intl.formatMessage({ id: 'DisputeDetails.linked.checkProvider' })
	                    ),
	                    (providerStatus || dispute.providerStatus) && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.ProviderBox },
	                        _react2.default.createElement(
	                            'h6',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.linked.providerResponse' })
	                        ),
	                        (providerStatus || dispute.providerStatus).error ? _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.ErrorBox },
	                            (providerStatus || dispute.providerStatus).message
	                        ) : _react2.default.createElement(
	                            'pre',
	                            { className: _stylesModule2.default.JsonBox },
	                            JSON.stringify(providerStatus || dispute.providerStatus, null, 2)
	                        ),
	                        dispute.providerCheckedAt && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.CheckedAt },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'DisputeDetails.linked.lastCheck',
	                                values: { date: formatDate(dispute.providerCheckedAt) }
	                            })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Section },
	                _react2.default.createElement(
	                    'h6',
	                    { className: _stylesModule2.default.SectionTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.section.resolution' })
	                ),
	                _react2.default.createElement('textarea', {
	                    className: _stylesModule2.default.Textarea,
	                    placeholder: intl.formatMessage({ id: 'DisputeDetails.resolution.placeholder' }),
	                    value: noteInput,
	                    onChange: function onChange(e) {
	                        return setNoteInput(e.target.value);
	                    },
	                    rows: 3
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ActionButtons },
	                    dispute.status === 'new' && _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnOrange,
	                            onClick: function onClick() {
	                                return handleStatusChange('in_progress');
	                            },
	                            disabled: isLoading
	                        },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.action.toWork' })
	                    ),
	                    (dispute.status === 'new' || dispute.status === 'in_progress') && _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnGreen,
	                            onClick: function onClick() {
	                                return handleStatusChange('resolved');
	                            },
	                            disabled: isLoading
	                        },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.action.resolved' })
	                    ),
	                    dispute.status === 'resolved' && _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnGray,
	                            onClick: function onClick() {
	                                return handleStatusChange('archived');
	                            },
	                            disabled: isLoading
	                        },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.action.archive' })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.BtnSecondary, onClick: handleSaveNote, disabled: isLoading },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DisputeDetails.action.saveNote' })
	                    )
	                ),
	                dispute.resolvedByName && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ResolvedInfo },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: 'DisputeDetails.resolution.resolvedBy',
	                        values: { name: dispute.resolvedByName, date: formatDate(dispute.resolvedAt) }
	                    })
	                )
	            )
	        )
	    );
	}
	
	DisputeDetails.defaultProps = {
	    onUpdate: function onUpdate() {},
	    onClose: function onClose() {}
	};
	
	exports.default = DisputeDetails;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(542);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var STATUSES = [{ value: "new", label: "Новый", color: "#1565c0" }, { value: "in_progress", label: "В работе", color: "#e65100" }, { value: "resolved", label: "Решен", color: "#2e7d32" }, { value: "archived", label: "Архив", color: "#757575" }];
	
	function DisputeFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        isLoading = _ref.isLoading;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        selectedStatuses = _useState2[0],
	        setSelectedStatuses = _useState2[1];
	
	    function handleStatusChange(value, checked) {
	        if (checked) {
	            setSelectedStatuses([].concat(_toConsumableArray(selectedStatuses), [value]));
	        } else {
	            setSelectedStatuses(selectedStatuses.filter(function (s) {
	                return s !== value;
	            }));
	        }
	    }
	
	    function handleApply() {
	        var filters = [];
	
	        selectedStatuses.forEach(function (status) {
	            filters.push(_defineProperty({}, status, true));
	        });
	
	        onApplyFilters({
	            filters: filters.length > 0 ? filters : []
	        });
	    }
	
	    function handleReset() {
	        setSelectedStatuses([]);
	        onApplyFilters({
	            filters: []
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputeFilters.title.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    STATUSES.map(function (status) {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.CheckboxWrap, key: status.value },
	                            _react2.default.createElement("input", {
	                                id: "status-" + status.value,
	                                type: "checkbox",
	                                checked: selectedStatuses.includes(status.value),
	                                onChange: function onChange(e) {
	                                    return handleStatusChange(status.value, e.target.checked);
	                                }
	                            }),
	                            _react2.default.createElement(
	                                "label",
	                                { htmlFor: "status-" + status.value, className: _stylesModule2.default.CustomCheckbox },
	                                _react2.default.createElement("div", {
	                                    className: _stylesModule2.default.StatusDot,
	                                    style: { backgroundColor: status.color }
	                                }),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    status.label
	                                )
	                            )
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(
	                "button",
	                { onClick: handleApply, className: _stylesModule2.default.Submit, disabled: isLoading },
	                !isLoading ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.buttonIcon, icon: "filter", size: "17px" }) : _react2.default.createElement(_Loader2.default, { isString: true }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputeFilters.btn.filter", defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C" })
	            ),
	            _react2.default.createElement(
	                "button",
	                { onClick: handleReset, className: _stylesModule2.default.Reset },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputeFilters.btn.reset", defaultMessage: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C" })
	            )
	        )
	    );
	}
	
	DisputeFilters.defaultProps = {
	    isLoading: false,
	    onApplyFilters: function onApplyFilters() {}
	};
	
	exports.default = DisputeFilters;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(543);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status pill
	function StatusPill(_ref) {
	    var status = _ref.status;
	
	    var statusConfig = {
	        new: { label: "Новый", bg: "#e3f2fd", color: "#1565c0" },
	        in_progress: { label: "В работе", bg: "#fff3e0", color: "#e65100" },
	        resolved: { label: "Решен", bg: "#e8f5e9", color: "#2e7d32" },
	        archived: { label: "Архив", bg: "#f5f5f5", color: "#757575" }
	    };
	
	    var config = statusConfig[status] || { label: status, bg: "#f5f5f5", color: "#666" };
	
	    return _react2.default.createElement(
	        "span",
	        { style: { padding: "2px 8px", borderRadius: 12, background: config.bg, color: config.color, fontSize: 12 } },
	        config.label
	    );
	}
	
	// Empty state
	function Empty() {
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Empty },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.empty", defaultMessage: "\u0414\u0438\u0441\u043F\u0443\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" })
	    );
	}
	
	function TableRow(_ref2) {
	    var row = _ref2.row,
	        isActive = _ref2.isActive,
	        _onClick = _ref2.onClick;
	
	    var intl = (0, _reactIntl.useIntl)();
	    var trClass = isActive ? _stylesModule2.default.Row + " " + _stylesModule2.default.Active : _stylesModule2.default.Row;
	
	    var formatDate = function formatDate(dateStr) {
	        if (!dateStr) return "-";
	        var d = new Date(dateStr);
	        return d.toLocaleDateString(intl.locale) + " " + d.toLocaleTimeString(intl.locale, { hour: "2-digit", minute: "2-digit" });
	    };
	
	    var truncateText = function truncateText(text) {
	        var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	        if (!text) return "-";
	        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
	    };
	
	    return _react2.default.createElement(
	        "tr",
	        { className: trClass, onClick: function onClick() {
	                return _onClick(row);
	            }, style: { cursor: "pointer" } },
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellCenter },
	            "#",
	            row.id
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.ChatInfo },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ChatTitle },
	                    truncateText(row.chatTitle, 20)
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SenderName },
	                    truncateText(row.senderName, 25)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { style: { fontFamily: "monospace", fontSize: 13 } },
	                row.transactionId ? "#" + row.transactionId : "-"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MessagePreview },
	                truncateText(row.messageText, 40)
	            ),
	            row.hasAttachment && _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.AttachmentBadge },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.attachment", defaultMessage: "\u0412\u043B\u043E\u0436\u0435\u043D\u0438\u0435" })
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { style: { fontSize: 12 } },
	                row.merchantName || "-"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellCenter },
	            _react2.default.createElement(StatusPill, { status: row.status })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "div",
	                { style: { fontSize: 11, opacity: 0.7 } },
	                formatDate(row.createdAt)
	            )
	        )
	    );
	}
	
	function DisputesList(_ref3) {
	    var data = _ref3.data,
	        currentId = _ref3.currentId,
	        isLoading = _ref3.isLoading,
	        onSelect = _ref3.onSelect;
	
	    var rows = Array.isArray(data) ? data : [];
	
	    if (isLoading) return _react2.default.createElement(_Loader2.default, null);
	    if (!rows.length) return _react2.default.createElement(Empty, null);
	
	    return _react2.default.createElement(
	        "table",
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "th",
	                    { className: _stylesModule2.default.HeaderCenter },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.table.id", defaultMessage: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    { className: _stylesModule2.default.HeaderCell },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.table.chat", defaultMessage: "\u0427\u0430\u0442 / \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    { className: _stylesModule2.default.HeaderCell },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.table.transaction", defaultMessage: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    { className: _stylesModule2.default.HeaderCell },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.table.message", defaultMessage: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    { className: _stylesModule2.default.HeaderCell },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.table.merchant", defaultMessage: "\u041C\u0435\u0440\u0447\u0430\u043D\u0442" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    { className: _stylesModule2.default.HeaderCenter },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.table.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    { className: _stylesModule2.default.HeaderCell },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "DisputesList.table.date", defaultMessage: "\u0414\u0430\u0442\u0430" })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "tbody",
	            null,
	            rows.map(function (row) {
	                return _react2.default.createElement(TableRow, {
	                    key: row.id,
	                    row: row,
	                    isActive: currentId === row.id,
	                    onClick: onSelect
	                });
	            })
	        )
	    );
	}
	
	DisputesList.defaultProps = {
	    data: [],
	    isLoading: false,
	    onSelect: function onSelect() {}
	};
	
	exports.default = DisputesList;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(545);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ProjectAdd(_ref) {
	    var token = _ref.token,
	        onProjectAdd = _ref.onProjectAdd;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isLoading = _useState2[0],
	        setIsLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({
	        name: '',
	        description: '',
	        url: '',
	        legalName: '',
	        inn: '',
	        kpp: '',
	        ogrn: ''
	    }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        form = _useState4[0],
	        setForm = _useState4[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    function onChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function addProject() {
	        setIsLoading(true);
	
	        new _Api2.default({ token: token }).addProject(form).then(function (r) {
	            if (!r.errors) {
	                onMessage({ type: 'success', message: intl.formatMessage({ id: 'ProjectAdd.success.created' }) });
	                setForm({
	                    name: '',
	                    description: '',
	                    url: '',
	                    legalName: '',
	                    inn: '',
	                    kpp: '',
	                    ogrn: ''
	                });
	                onProjectAdd();
	            } else {
	                var errors = Object.values(r.errors).join(' ');
	                onMessage({
	                    type: 'error',
	                    message: intl.formatMessage({ id: 'ProjectAdd.error.create' }, { errors: errors })
	                });
	            }
	            setIsLoading(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.name,
	            placeholder: 'Alphabet Inc.',
	            fieldName: 'name',
	            label: 'FieldsHelper.label.projectName',
	            changeRegexp: /[^A-Za-zА-Яа-я0-9\s".]+/g,
	            blurRegexp: /^[A-Za-zА-Яа-я0-9\s".]{4,10}/,
	            changeMessage: 'FieldsHelper.error.onlyLettersProjectName',
	            blurMessage: 'FieldsHelper.error.onlyLettersProjectName',
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.url,
	            placeholder: 'https://yandex.ru/',
	            fieldName: 'url',
	            label: 'FieldsHelper.label.websiteUrl',
	            changeRegexp: /[^A-Za-z0-9\s/:.-]+/g,
	            blurRegexp: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
	            changeMessage: 'FieldsHelper.error.onlyUrlWebsite',
	            blurMessage: 'FieldsHelper.error.checkUrlWebsite',
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.description,
	            placeholder: '',
	            fieldName: 'description',
	            label: 'FieldsHelper.label.description',
	            changeRegexp: /[^A-Za-zА-Яа-я0-9\s".]+/g,
	            blurRegexp: /^[A-Za-zА-Яа-я0-9\s".]{4,10}/,
	            changeMessage: 'FieldsHelper.error.onlyLettersProjectName',
	            blurMessage: 'FieldsHelper.error.onlyLettersProjectName',
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.legalName,
	            placeholder: '\u041E\u041E\u041E \u0420\u043E\u043C\u0430\u0448\u043A\u0430',
	            fieldName: 'legalName',
	            label: 'FieldsHelper.label.legalName',
	            changeRegexp: /^$/,
	            blurRegexp: /^$/,
	            changeMessage: 'FieldsHelper.error.noValidation',
	            blurMessage: 'FieldsHelper.error.noValidation',
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.inn,
	            placeholder: '7707083893',
	            fieldName: 'inn',
	            label: 'FieldsHelper.label.inn',
	            changeRegexp: /^$/,
	            blurRegexp: /^$/,
	            changeMessage: 'FieldsHelper.error.noValidation',
	            blurMessage: 'FieldsHelper.error.noValidation',
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.kpp,
	            placeholder: '770701001',
	            fieldName: 'kpp',
	            label: 'FieldsHelper.label.kpp',
	            changeRegexp: /^$/,
	            blurRegexp: /^$/,
	            changeMessage: 'FieldsHelper.error.noValidation',
	            blurMessage: 'FieldsHelper.error.noValidation',
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(_FieldsHelper.InputHelper, {
	            onChange: onChange,
	            value: form.ogrn,
	            placeholder: '1027700132195',
	            fieldName: 'ogrn',
	            label: 'FieldsHelper.label.ogrn',
	            changeRegexp: /^$/,
	            blurRegexp: /^$/,
	            changeMessage: 'FieldsHelper.error.noValidation',
	            blurMessage: 'FieldsHelper.error.noValidation',
	            isDisabled: isLoading
	        }),
	        _react2.default.createElement(
	            'button',
	            { className: _stylesModule2.default.Btn, onClick: addProject, disabled: isLoading },
	            isLoading ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectAdd.btn.saving', defaultMessage: '\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u043C...' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectAdd.btn.add', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442' })
	        )
	    );
	}
	
	exports.default = ProjectAdd;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(198);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Status(_ref) {
	    var currentStatus = _ref.currentStatus,
	        setCurrentStatus = _ref.setCurrentStatus,
	        isDisabled = _ref.isDisabled;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    var status = {
	        id: currentStatus,
	        name: null,
	        color: null
	    };
	
	    switch (currentStatus) {
	        case -1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.blocked', defaultMessage: '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D' });
	            status.color = 'rgb(220, 57, 18)';
	            break;
	        case 1:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' });
	            status.color = 'rgb(16, 150, 24)';
	            break;
	        default:
	            status.name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' });
	            status.color = 'rgb(16, 150, 24)';
	    }
	
	    var statusWrap = (0, _react.useRef)(null);
	    var statusSelect = (0, _react.useRef)(null);
	
	    function onStatusClick() {
	        setIsOpened(!isOpened);
	    }
	
	    function onselectStatus(id) {
	        setCurrentStatus(id);
	    }
	
	    function handleClickOutside(e) {
	        if (!!statusWrap.current && !statusWrap.current.contains(e.target)) {
	            setIsOpened(false);
	        } else if (!!statusSelect.current && !!statusSelect.current.contains(e.target)) {
	            setIsOpened(false);
	        }
	    }
	
	    (0, _react.useEffect)(function () {
	        document.addEventListener('click', handleClickOutside, false);
	    }, []);
	
	    return _react2.default.createElement(
	        'div',
	        { ref: statusWrap, className: _stylesModule2.default.Status },
	        _react2.default.createElement(
	            'div',
	            {
	                onClick: function onClick() {
	                    !isDisabled && onStatusClick();
	                },
	                className: _stylesModule2.default.CurrentStatus,
	                style: { backgroundColor: status.color }
	            },
	            status.name
	        ),
	        isOpened && _react2.default.createElement(
	            'ul',
	            { ref: statusSelect, className: _stylesModule2.default.StatusSelect },
	            _react2.default.createElement(
	                'li',
	                { style: status.id === 1 ? { fontWeight: 'bold' } : null, onClick: function onClick() {
	                        return onselectStatus(1);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' })
	            ),
	            _react2.default.createElement(
	                'li',
	                { style: status.id === -1 ? { fontWeight: 'bold' } : null, onClick: function onClick() {
	                        return onselectStatus(-1);
	                    } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AccountEditing.status.blocked', defaultMessage: '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D' })
	            )
	        )
	    );
	}
	
	exports.default = Status;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Status = __webpack_require__(370);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _stylesModule = __webpack_require__(198);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _reactIntl = __webpack_require__(2);
	
	var _UserSearchList = __webpack_require__(386);
	
	var _UserSearchList2 = _interopRequireDefault(_UserSearchList);
	
	var _TerminalEditing = __webpack_require__(169);
	
	var _TerminalEditing2 = _interopRequireDefault(_TerminalEditing);
	
	var _PermissionsEditor = __webpack_require__(168);
	
	var _PermissionsEditor2 = _interopRequireDefault(_PermissionsEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ProjectEditing(_ref) {
	    var _this = this;
	
	    var saveAll = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var api, payload, origAccountIds, newAccountIds, usersToAdd, usersToRemove, origSettings, newSettings, origById, deleteSettingsIds, createSettings, updateSettings, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, s, before, payloadBefore, payloadNow;
	
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            setIsSaving(true);
	                            api = new _Api2.default({ token: token });
	                            _context2.prev = 2;
	
	                            // Собираем все данные для единого запроса
	                            payload = {
	                                // Базовые данные проекта
	                                basic: {
	                                    name: form.name,
	                                    description: form.description,
	                                    url: form.url,
	                                    status: form.status,
	                                    inn: form.inn,
	                                    kpp: form.kpp,
	                                    ogrn: form.ogrn
	                                },
	                                // Настройки антифрода
	                                fraud: {
	                                    frod: isAntifraud,
	                                    antifraud: isAntifraud ? antifraudSettings : null,
	                                    antifraudCheckAccess: isAntifraud ? antifraudCheckAccess : false
	                                }
	                                // Widget settings are now saved per MerchantSettings (in settings.update[].widget and settings.update[].widgetCallback)
	                            };
	
	                            // Вычисляем изменения пользователей
	
	                            origAccountIds = new Set(originalProjectUsers.map(function (a) {
	                                return a && a.id;
	                            }).filter(Boolean));
	                            newAccountIds = new Set(projectUsers.map(function (u) {
	                                return u && u.id;
	                            }).filter(Boolean));
	                            usersToAdd = projectUsers.filter(function (u) {
	                                return u && u.id && !origAccountIds.has(u.id);
	                            }).map(function (u) {
	                                return u.id;
	                            });
	                            usersToRemove = originalProjectUsers.filter(function (a) {
	                                return a && a.id && !newAccountIds.has(a.id);
	                            }).map(function (a) {
	                                return a.id;
	                            });
	
	
	                            if (usersToAdd.length > 0 || usersToRemove.length > 0) {
	                                payload.users = {
	                                    add: usersToAdd,
	                                    remove: usersToRemove
	                                };
	                            }
	
	                            // Вычисляем изменения настроек (MID)
	
	                            if (!(fullMerchant && editFull)) {
	                                _context2.next = 36;
	                                break;
	                            }
	
	                            origSettings = Array.isArray(fullMerchant.settings) ? fullMerchant.settings : [];
	                            newSettings = Array.isArray(editFull.settings) ? editFull.settings : [];
	                            origById = new Map(origSettings.filter(function (s) {
	                                return isServerId(s && s.id);
	                            }).map(function (s) {
	                                return [s.id, s];
	                            }));
	                            deleteSettingsIds = origSettings.filter(function (s) {
	                                return isServerId(s && s.id) && !newSettings.find(function (ns) {
	                                    return ns && ns.id === s.id;
	                                });
	                            }).map(function (s) {
	                                return s.id;
	                            });
	                            createSettings = [];
	                            updateSettings = [];
	                            _iteratorNormalCompletion2 = true;
	                            _didIteratorError2 = false;
	                            _iteratorError2 = undefined;
	                            _context2.prev = 19;
	
	
	                            for (_iterator2 = newSettings[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                s = _step2.value;
	
	                                if (!isServerId(s && s.id)) {
	                                    createSettings.push(pickSettingPayload(Object.assign({}, s, { terminalId: null })));
	                                } else {
	                                    before = origById.get(s.id) || {};
	                                    payloadBefore = pickSettingPayload(before);
	                                    payloadNow = pickSettingPayload(s);
	
	                                    if (!shallowEqual(JSON.parse(JSON.stringify(payloadBefore)), JSON.parse(JSON.stringify(payloadNow)))) {
	                                        updateSettings.push(Object.assign({ id: s.id }, payloadNow));
	                                    }
	                                }
	                            }
	
	                            _context2.next = 27;
	                            break;
	
	                        case 23:
	                            _context2.prev = 23;
	                            _context2.t0 = _context2['catch'](19);
	                            _didIteratorError2 = true;
	                            _iteratorError2 = _context2.t0;
	
	                        case 27:
	                            _context2.prev = 27;
	                            _context2.prev = 28;
	
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	
	                        case 30:
	                            _context2.prev = 30;
	
	                            if (!_didIteratorError2) {
	                                _context2.next = 33;
	                                break;
	                            }
	
	                            throw _iteratorError2;
	
	                        case 33:
	                            return _context2.finish(30);
	
	                        case 34:
	                            return _context2.finish(27);
	
	                        case 35:
	                            if (deleteSettingsIds.length > 0 || createSettings.length > 0 || updateSettings.length > 0) {
	                                payload.settings = {
	                                    create: createSettings,
	                                    update: updateSettings,
	                                    delete: deleteSettingsIds
	                                };
	                            }
	
	                        case 36:
	                            _context2.next = 38;
	                            return api.saveProjectAll(uuid, payload);
	
	                        case 38:
	
	                            // Обновляем оригинальные данные пользователей после успешного сохранения
	                            setOriginalProjectUsers([].concat(_toConsumableArray(projectUsers)));
	
	                            // Обновляем данные (оверлей isSaving остаётся активным)
	                            _context2.next = 41;
	                            return refreshFull(true);
	
	                        case 41:
	
	                            // Тост только после полного завершения сохранения и обновления
	                            onMessage({ type: 'success', message: intl.formatMessage({ id: 'ProjectEditing.success.allSaved' }) });
	                            _context2.next = 48;
	                            break;
	
	                        case 44:
	                            _context2.prev = 44;
	                            _context2.t1 = _context2['catch'](2);
	
	                            console.error(_context2.t1);
	                            onMessage({ type: 'error', message: intl.formatMessage({ id: 'ProjectEditing.error.save' }) });
	
	                        case 48:
	                            _context2.prev = 48;
	
	                            setIsSaving(false);
	                            return _context2.finish(48);
	
	                        case 51:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[2, 44, 48, 51], [19, 23, 27, 35], [28,, 30, 34]]);
	        }));
	
	        return function saveAll() {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    var refreshFull = function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(skipLoadingState) {
	            var data;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (uuid) {
	                                _context3.next = 2;
	                                break;
	                            }
	
	                            return _context3.abrupt('return');
	
	                        case 2:
	                            _context3.prev = 2;
	
	                            if (!skipLoadingState) setIsFullLoading(true);
	                            _context3.next = 6;
	                            return new _Api2.default({ token: token }).getFullMerchant(uuid);
	
	                        case 6:
	                            data = _context3.sent;
	
	                            if (mounted.current) {
	                                _context3.next = 9;
	                                break;
	                            }
	
	                            return _context3.abrupt('return');
	
	                        case 9:
	                            setFullMerchant(data);
	                            setEditFull(JSON.parse(JSON.stringify(data)));
	
	                            // Обновляем форму из полных данных мерчанта
	                            if (data.merchant) {
	                                setForm(function (prev) {
	                                    return Object.assign({}, prev, {
	                                        name: data.merchant.name || prev.name || '',
	                                        description: data.merchant.description || prev.description || '',
	                                        url: data.merchant.url || prev.url || '',
	                                        inn: data.merchant.inn || prev.inn || '',
	                                        kpp: data.merchant.kpp || prev.kpp || '',
	                                        ogrn: data.merchant.ogrn || prev.ogrn || '',
	                                        status: data.merchant.status != null ? data.merchant.status : prev.status
	                                    });
	                                });
	                            }
	                            _context3.next = 17;
	                            break;
	
	                        case 14:
	                            _context3.prev = 14;
	                            _context3.t0 = _context3['catch'](2);
	
	                            onMessage({ type: 'error', message: intl.formatMessage({ id: 'ProjectEditing.error.refresh' }) });
	
	                        case 17:
	                            _context3.prev = 17;
	
	                            if (mounted.current && !skipLoadingState) setIsFullLoading(false);
	                            return _context3.finish(17);
	
	                        case 20:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[2, 14, 17, 20]]);
	        }));
	
	        return function refreshFull(_x2) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	
	    var project = _ref.project,
	        uuid = _ref.uuid,
	        token = _ref.token,
	        usersList = _ref.usersList,
	        _onProjectSaved = _ref.onProjectSaved;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isSaving = _useState2[0],
	        setIsSaving = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({}),
	        _useState4 = _slicedToArray(_useState3, 2),
	        form = _useState4[0],
	        setForm = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        fullMerchant = _useState6[0],
	        setFullMerchant = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        editFull = _useState8[0],
	        setEditFull = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        isFullLoading = _useState10[0],
	        setIsFullLoading = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isAntifraud = _useState12[0],
	        setIsAntifraud = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        antifraudCheckAccess = _useState14[0],
	        setAntifraudCheckAccess = _useState14[1];
	
	    var _useState15 = (0, _react.useState)({
	        payment: { database: true, client: true, scanfraud: false },
	        payout: { database: true, client: true, scanfraud: false }
	    }),
	        _useState16 = _slicedToArray(_useState15, 2),
	        antifraudSettings = _useState16[0],
	        setAntifraudSettings = _useState16[1];
	
	    // Widget settings removed - now stored per MerchantSettings in editFull.settings[].widget and editFull.settings[].widgetCallback
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var mounted = (0, _react.useRef)(true);
	    var onMessageRef = (0, _react.useRef)(onMessage);
	    var intlRef = (0, _react.useRef)(intl);
	    onMessageRef.current = onMessage;
	    intlRef.current = intl;
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        projectUsers = _useState18[0],
	        setProjectUsers = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        originalProjectUsers = _useState20[0],
	        setOriginalProjectUsers = _useState20[1];
	
	    var _useState21 = (0, _react.useState)({}),
	        _useState22 = _slicedToArray(_useState21, 2),
	        terminalIdToTerminal = _useState22[0],
	        setTerminalIdToTerminal = _useState22[1];
	
	    var _useState23 = (0, _react.useState)({
	        open: false,
	        terminal: null,
	        settingIndex: null
	    }),
	        _useState24 = _slicedToArray(_useState23, 2),
	        terminalModal = _useState24[0],
	        setTerminalModal = _useState24[1];
	
	    var _useState25 = (0, _react.useState)({
	        open: false,
	        user: null
	    }),
	        _useState26 = _slicedToArray(_useState25, 2),
	        permissionsModal = _useState26[0],
	        setPermissionsModal = _useState26[1];
	
	    function onChange(name, value) {
	        setForm(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, name, value));
	        });
	    }
	
	    function setCurrentStatus(id) {
	        setForm(function (prev) {
	            return Object.assign({}, prev, { status: id });
	        });
	    }
	
	    (0, _react.useEffect)(function () {
	        mounted.current = true;
	
	        setForm({
	            status: project && project.status,
	            name: project && project.name || '',
	            description: project && project.description || '',
	            url: project && project.url || '',
	            inn: project && project.inn || '',
	            kpp: project && project.kpp || '',
	            ogrn: project && project.ogrn || ''
	        });
	
	        function deepClone(obj) {
	            try {
	                return JSON.parse(JSON.stringify(obj));
	            } catch (e) {
	                return null;
	            }
	        }
	
	        var fetchFull = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var api, data, terminalMap, terminals, projectData, existingUsers;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (uuid) {
	                                    _context.next = 5;
	                                    break;
	                                }
	
	                                setFullMerchant(null);
	                                setEditFull(null);
	                                setProjectUsers([]);
	                                return _context.abrupt('return');
	
	                            case 5:
	                                _context.prev = 5;
	
	                                setIsFullLoading(true);
	                                api = new _Api2.default({ token: token });
	                                _context.next = 10;
	                                return api.getFullMerchant(uuid);
	
	                            case 10:
	                                data = _context.sent;
	
	                                if (mounted.current) {
	                                    _context.next = 13;
	                                    break;
	                                }
	
	                                return _context.abrupt('return');
	
	                            case 13:
	
	                                setFullMerchant(data);
	                                setEditFull(deepClone(data));
	
	                                // Обновляем форму из полных данных мерчанта
	                                if (data.merchant) {
	                                    setForm(function (prev) {
	                                        return Object.assign({}, prev, {
	                                            name: data.merchant.name || prev.name || '',
	                                            description: data.merchant.description || prev.description || '',
	                                            url: data.merchant.url || prev.url || '',
	                                            inn: data.merchant.inn || prev.inn || '',
	                                            kpp: data.merchant.kpp || prev.kpp || '',
	                                            ogrn: data.merchant.ogrn || prev.ogrn || '',
	                                            status: data.merchant.status != null ? data.merchant.status : prev.status
	                                        });
	                                    });
	                                }
	
	                                setIsAntifraud(data.settings.length > 0 ? !(data.settings[0].frod === null || data.settings[0].frod === false) : false);
	                                setAntifraudCheckAccess(data.settings.length > 0 ? !!data.settings[0].antifraudCheckAccess : false);
	
	                                // Load antifraud category settings
	                                if (data.settings && data.settings.length > 0 && data.settings[0].antifraud) {
	                                    setAntifraudSettings(data.settings[0].antifraud);
	                                } else {
	                                    setAntifraudSettings({
	                                        payment: { database: true, client: true, scanfraud: false },
	                                        payout: { database: true, client: true, scanfraud: false }
	                                    });
	                                }
	
	                                // Widget settings are now loaded per MerchantSettings (stored in each settings[].widget and settings[].widgetCallback)
	
	                                terminalMap = {};
	                                terminals = data && data.terminals || [];
	
	                                if (Array.isArray(terminals)) {
	                                    terminals.forEach(function (ta) {
	                                        if (ta && ta.id != null) {
	                                            terminalMap[ta.id] = ta;
	                                        }
	                                    });
	                                }
	                                setTerminalIdToTerminal(terminalMap);
	
	                                _context.prev = 23;
	                                _context.next = 26;
	                                return api.getProjectData(uuid);
	
	                            case 26:
	                                projectData = _context.sent;
	                                existingUsers = projectData && Array.isArray(projectData.accounts) && projectData.accounts || [];
	
	
	                                if (mounted.current) {
	                                    setProjectUsers(existingUsers);
	                                    setOriginalProjectUsers(existingUsers);
	                                }
	                                _context.next = 34;
	                                break;
	
	                            case 31:
	                                _context.prev = 31;
	                                _context.t0 = _context['catch'](23);
	
	                                console.warn('Не удалось получить пользователей проекта:', _context.t0);
	
	                            case 34:
	                                _context.next = 39;
	                                break;
	
	                            case 36:
	                                _context.prev = 36;
	                                _context.t1 = _context['catch'](5);
	
	                                onMessageRef.current({
	                                    type: 'error',
	                                    message: intlRef.current.formatMessage({ id: 'ProjectEditing.error.load' })
	                                });
	
	                            case 39:
	                                _context.prev = 39;
	
	                                if (mounted.current) setIsFullLoading(false);
	                                return _context.finish(39);
	
	                            case 42:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this, [[5, 36, 39, 42], [23, 31]]);
	            }));
	
	            return function fetchFull() {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        fetchFull();
	
	        return function () {
	            mounted.current = false;
	        };
	    }, [uuid, token]);
	
	    // -------- helpers for diffing & payloads (без терминалов) --------
	    function shallowEqual(a, b) {
	        var ka = Object.keys(a || {});
	        var kb = Object.keys(b || {});
	        if (ka.length !== kb.length) return false;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = ka[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var k = _step.value;
	
	                if (a[k] !== b[k]) return false;
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isServerId(id) {
	        return typeof id === 'number' && Number.isFinite(id);
	    }
	
	    function pickSettingPayload(s) {
	        return {
	            providerUuid: s && s.providerUuid ? s.providerUuid : null,
	            terminalId: s && s.terminalId != null ? s.terminalId : null,
	            enabled: !!s.enabled,
	            priority: s && s.priority != null ? s.priority : 1,
	            fee: s && s.fee || {},
	            isSBP: !!s.isSBP,
	            isMP2P: !!s.isMP2P,
	            preAuth: !!s.preAuth,
	            partialRefund: !!s.partialRefund,
	            partialReversal: !!s.partialReversal,
	            recurring: !!s.recurring,
	            payoutBalanceCheck: !!s.payoutBalanceCheck,
	            transactionRules: Array.isArray(s && s.transactionRules) ? s.transactionRules : [],
	            widget: s && s.widget || '',
	            widgetCallback: s && s.widgetCallback || ''
	        };
	    }
	
	    function updateAntifraud(antifraudValue) {
	        setIsAntifraud(antifraudValue);
	    }
	
	    function updateAntifraudCategory(type, category, value) {
	        setAntifraudSettings(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, type, Object.assign({}, prev[type], _defineProperty({}, category, value))));
	        });
	    }
	
	    function generateRandomKey() {
	        var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 64;
	
	        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	        var result = '';
	        for (var i = 0; i < length; i++) {
	            result += chars.charAt(Math.floor(Math.random() * chars.length));
	        }
	        return result;
	    }
	
	    var updateSetting = function updateSetting(index, patch) {
	        setEditFull(function (prev) {
	            var next = Object.assign({}, prev || {});
	            var list = Array.isArray(next.settings) ? next.settings.slice() : [];
	            var merged = Object.assign({}, list[index] || {}, patch || {});
	            list[index] = merged;
	            next.settings = list;
	            return next;
	        });
	    };
	
	    function generateWidgetKeyForSetting(idx) {
	        var newKey = generateRandomKey(64);
	        updateSetting(idx, { widget: newKey });
	        onMessage({ type: 'info', message: 'Ключ виджета сгенерирован. Не забудьте сохранить.' });
	    }
	
	    var isProjectSelected = !!uuid && project && Object.keys(project).length > 0;
	
	    var ef = editFull || {};
	    var efMerchant = ef.merchant || null;
	    var efProviders = Array.isArray(ef.providers) ? ef.providers : [];
	    var efSettings = Array.isArray(ef.settings) ? ef.settings : [];
	
	    var providersByUuid = efProviders.reduce(function (acc, p) {
	        if (p && p.uuid) acc[p.uuid] = p;
	        return acc;
	    }, {});
	
	    var updateSettingFee = function updateSettingFee(index, feeKey, field, value) {
	        setEditFull(function (prev) {
	            var next = Object.assign({}, prev || {});
	            var list = Array.isArray(next.settings) ? next.settings.slice() : [];
	            var s = Object.assign({}, list[index] || {});
	            var fee = Object.assign({}, s.fee || {});
	            var sub = Object.assign({}, fee[feeKey] || {});
	            sub[field] = value;
	            fee[feeKey] = sub;
	            s.fee = fee;
	            list[index] = s;
	            next.settings = list;
	            return next;
	        });
	    };
	
	    var onUsersChange = function onUsersChange(user) {
	        setProjectUsers(user);
	    };
	
	    var onEditPermissions = function onEditPermissions(user) {
	        // Если юзер только добавлен в локальный список, но проект ещё не сохранён —
	        // в БД ещё нет account_access_settings записи, и API get-permissions упадёт 404.
	        // Просим сохранить проект сначала.
	        var isPersistedUser = user && user.id && originalProjectUsers.some(function (u) {
	            return u && String(u.id) === String(user.id);
	        });
	        if (!isPersistedUser) {
	            onMessage({
	                type: 'warning',
	                message: 'Сначала сохраните проект, чтобы настроить права пользователя'
	            });
	            return;
	        }
	        setPermissionsModal({
	            open: true,
	            user: user
	        });
	    };
	
	    var addSettingFeeType = function addSettingFeeType(index, feeKey) {
	        setEditFull(function (prev) {
	            var next = Object.assign({}, prev || {});
	            var list = Array.isArray(next.settings) ? next.settings.slice() : [];
	            var s = Object.assign({}, list[index] || {});
	            var fee = Object.assign({}, s.fee || {});
	            if (!fee[feeKey]) {
	                fee[feeKey] = { cost: 0, fixedPerTransaction: 0, costFixedMinimum: 0 };
	            }
	            s.fee = fee;
	            list[index] = s;
	            next.settings = list;
	            return next;
	        });
	    };
	
	    var removeSetting = function removeSetting(index) {
	        setEditFull(function (prev) {
	            var next = Object.assign({}, prev || {});
	            var list = Array.isArray(next.settings) ? next.settings.slice() : [];
	            list.splice(index, 1);
	            next.settings = list;
	            return next;
	        });
	    };
	
	    var addSetting = function addSetting() {
	        setEditFull(function (prev) {
	            var next = Object.assign({}, prev || {});
	            var list = Array.isArray(next.settings) ? next.settings.slice() : [];
	            var firstProvider = efProviders.length > 0 ? efProviders[0].uuid : '';
	            list.push({
	                id: Date.now(),
	                providerUuid: firstProvider,
	                providerName: firstProvider && providersByUuid[firstProvider] ? providersByUuid[firstProvider].name : '',
	                terminalId: null,
	                enabled: true,
	                priority: 1,
	                balance: 0,
	                currency: { code: 'RUB', name: 'Russian Ruble' },
	                fee: {},
	                isSBP: false,
	                isMP2P: false,
	                preAuth: false,
	                partialRefund: false,
	                partialReversal: false,
	                recurring: false,
	                payoutBalanceCheck: false,
	                transactionRules: []
	            });
	            next.settings = list;
	            return next;
	        });
	    };
	
	    function currencyToStr(c) {
	        if (!c) return '—';
	        var name = c.name || '';
	        var code = c.code || '';
	        return '' + (name ? name : '—') + (code ? ' (' + code + ')' : '');
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Card },
	            isSaving && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.SavingOverlay },
	                _react2.default.createElement('div', { className: _stylesModule2.default.SavingSpinner }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435...'
	                )
	            ),
	            isProjectSelected ? _react2.default.createElement(
	                _react.Fragment,
	                null,
	                isFullLoading && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.LoadingOverlay },
	                    _react2.default.createElement('div', { className: _stylesModule2.default.LoadingSpinner }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445...'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Content },
	                    _react2.default.createElement(_Status2.default, {
	                        currentStatus: form.status,
	                        setCurrentStatus: setCurrentStatus,
	                        isDisabled: isSaving || isFullLoading
	                    }),
	                    _react2.default.createElement(
	                        'dl',
	                        { className: _stylesModule2.default.List },
	                        _react2.default.createElement(
	                            'dt',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'ProjectEditing.field.id',
	                                defaultMessage: '\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            null,
	                            uuid
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.ProjectFields },
	                        _react2.default.createElement(_FieldsHelper.InputHelper, {
	                            onChange: onChange,
	                            value: form.name,
	                            fieldName: 'name',
	                            label: 'ProjectEditing.field.name',
	                            isDisabled: isSaving || isFullLoading
	                        }),
	                        _react2.default.createElement(_FieldsHelper.InputHelper, {
	                            onChange: onChange,
	                            value: form.description,
	                            fieldName: 'description',
	                            label: 'ProjectEditing.field.description',
	                            isDisabled: isSaving || isFullLoading
	                        }),
	                        _react2.default.createElement(_FieldsHelper.InputHelper, {
	                            onChange: onChange,
	                            value: form.url,
	                            fieldName: 'url',
	                            label: 'ProjectEditing.field.url',
	                            isDisabled: isSaving || isFullLoading
	                        }),
	                        _react2.default.createElement(_FieldsHelper.InputHelper, {
	                            onChange: onChange,
	                            value: form.inn,
	                            fieldName: 'inn',
	                            label: 'ProjectEditing.field.inn',
	                            isDisabled: isSaving || isFullLoading
	                        }),
	                        _react2.default.createElement(_FieldsHelper.InputHelper, {
	                            onChange: onChange,
	                            value: form.kpp,
	                            fieldName: 'kpp',
	                            label: 'ProjectEditing.field.kpp',
	                            isDisabled: isSaving || isFullLoading
	                        }),
	                        _react2.default.createElement(_FieldsHelper.InputHelper, {
	                            onChange: onChange,
	                            value: form.ogrn,
	                            fieldName: 'ogrn',
	                            label: 'ProjectEditing.field.ogrn',
	                            isDisabled: isSaving || isFullLoading
	                        })
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: _stylesModule2.default.BlockTitle },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectEditing.antifraud.title', defaultMessage: '\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.ServiceCard },
	                        _react2.default.createElement(
	                            'label',
	                            { className: _stylesModule2.default.AntifraudToggle },
	                            _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                checked: isAntifraud,
	                                onChange: function onChange(e) {
	                                    return updateAntifraud(e.target.checked);
	                                }
	                            }),
	                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: _stylesModule2.default.ToggleText },
	                                '\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434'
	                            )
	                        ),
	                        isAntifraud && _react2.default.createElement(
	                            'div',
	                            { style: { marginTop: 16 } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.HintText, style: { marginBottom: 12 } },
	                                '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0442\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u0434\u043B\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u0438 \u0432\u044B\u043F\u043B\u0430\u0442'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.SubBlock },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '\u041F\u0440\u0438\u0451\u043C \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439:'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.MethodsGrid, style: { marginTop: 8 } },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: _stylesModule2.default.ToggleLabel },
	                                        _react2.default.createElement('input', {
	                                            type: 'checkbox',
	                                            checked: antifraudSettings.payment && antifraudSettings.payment.database,
	                                            onChange: function onChange(e) {
	                                                return updateAntifraudCategory('payment', 'database', e.target.checked);
	                                            }
	                                        }),
	                                        _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _stylesModule2.default.ToggleText },
	                                            '\u041F\u043E \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: _stylesModule2.default.ToggleLabel },
	                                        _react2.default.createElement('input', {
	                                            type: 'checkbox',
	                                            checked: antifraudSettings.payment && antifraudSettings.payment.client,
	                                            onChange: function onChange(e) {
	                                                return updateAntifraudCategory('payment', 'client', e.target.checked);
	                                            }
	                                        }),
	                                        _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _stylesModule2.default.ToggleText },
	                                            '\u041F\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0443'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: _stylesModule2.default.ToggleLabel },
	                                        _react2.default.createElement('input', {
	                                            type: 'checkbox',
	                                            checked: antifraudSettings.payment && antifraudSettings.payment.scanfraud,
	                                            onChange: function onChange(e) {
	                                                return updateAntifraudCategory('payment', 'scanfraud', e.target.checked);
	                                            }
	                                        }),
	                                        _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _stylesModule2.default.ToggleText },
	                                            '\u0412\u043D\u0435\u0448\u043D\u044F\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.SubBlock },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '\u0412\u044B\u043F\u043B\u0430\u0442\u044B:'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.MethodsGrid, style: { marginTop: 8 } },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: _stylesModule2.default.ToggleLabel },
	                                        _react2.default.createElement('input', {
	                                            type: 'checkbox',
	                                            checked: antifraudSettings.payout && antifraudSettings.payout.database,
	                                            onChange: function onChange(e) {
	                                                return updateAntifraudCategory('payout', 'database', e.target.checked);
	                                            }
	                                        }),
	                                        _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _stylesModule2.default.ToggleText },
	                                            '\u041F\u043E \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: _stylesModule2.default.ToggleLabel },
	                                        _react2.default.createElement('input', {
	                                            type: 'checkbox',
	                                            checked: antifraudSettings.payout && antifraudSettings.payout.client,
	                                            onChange: function onChange(e) {
	                                                return updateAntifraudCategory('payout', 'client', e.target.checked);
	                                            }
	                                        }),
	                                        _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _stylesModule2.default.ToggleText },
	                                            '\u041F\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0443'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: _stylesModule2.default.ToggleLabel },
	                                        _react2.default.createElement('input', {
	                                            type: 'checkbox',
	                                            checked: antifraudSettings.payout && antifraudSettings.payout.scanfraud,
	                                            onChange: function onChange(e) {
	                                                return updateAntifraudCategory('payout', 'scanfraud', e.target.checked);
	                                            }
	                                        }),
	                                        _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _stylesModule2.default.ToggleText },
	                                            '\u0412\u043D\u0435\u0448\u043D\u044F\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginTop: 16, paddingTop: 12, borderTop: '1px solid #eee' } },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: _stylesModule2.default.ToggleLabel },
	                                    _react2.default.createElement('input', {
	                                        type: 'checkbox',
	                                        checked: antifraudCheckAccess,
	                                        onChange: function onChange(e) {
	                                            return setAntifraudCheckAccess(e.target.checked);
	                                        }
	                                    }),
	                                    _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _stylesModule2.default.ToggleText },
	                                        '\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434 (\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u0440\u0430\u0437\u0434\u0435\u043B)'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: _stylesModule2.default.BlockTitle },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'ProjectEditing.merchantKey.title',
	                            defaultMessage: '\u041A\u043B\u044E\u0447 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.ServiceCard, style: { padding: 16 } },
	                        isFullLoading ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectEditing.loading', defaultMessage: '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...' }) : efMerchant ? _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.MerchantKeyGroup },
	                            _react2.default.createElement('input', {
	                                type: 'text',
	                                readOnly: true,
	                                value: efMerchant && efMerchant.key || '',
	                                className: _stylesModule2.default.MerchantKeyInput
	                            }),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: _stylesModule2.default.BtnCopy,
	                                    onClick: function onClick() {
	                                        navigator.clipboard.writeText(efMerchant && efMerchant.key || '');
	                                        onMessage({ type: 'success', message: 'Ключ скопирован' });
	                                    }
	                                },
	                                '\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C'
	                            )
	                        ) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectEditing.noData', defaultMessage: '\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.HintText },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'ProjectEditing.merchantKey.hint',
	                                defaultMessage: '\u042D\u0442\u043E\u0442 \u043A\u043B\u044E\u0447 \u043C\u0435\u0440\u0447\u0430\u043D\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0434\u043B\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u0438/\u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432.'
	                            })
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: _stylesModule2.default.BlockTitle },
	                        '\u041F\u043B\u0430\u0442\u0451\u0436\u043D\u044B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438',
	                        _react2.default.createElement(
	                            'span',
	                            { style: { fontSize: 12, fontWeight: 400, color: '#6b7280', marginLeft: 8 } },
	                            '\u2014 \u043E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435',
	                            ' ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/terminals-control', style: { color: '#2563eb' } },
	                                '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u044B'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.ServicesWrapper },
	                        isFullLoading && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Empty },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectEditing.loading', defaultMessage: '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...' })
	                        ),
	                        !isFullLoading && efSettings.length === 0 && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Empty },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: 'ProjectEditing.settings.empty',
	                                defaultMessage: '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B'
	                            })
	                        ),
	                        !isFullLoading && efSettings.map(function (s, idx) {
	                            var currentProvider = s && s.providerUuid && providersByUuid[s.providerUuid] ? providersByUuid[s.providerUuid] : null;
	                            var providerName = currentProvider ? currentProvider.name : s && s.providerName || '—';
	                            var currencyStr = currencyToStr(s && s.currency);
	
	                            return _react2.default.createElement(
	                                'div',
	                                { key: s && s.id || 'new-' + idx, className: _stylesModule2.default.ServiceCard },
	                                _react2.default.createElement(
	                                    'div',
	                                    {
	                                        style: {
	                                            display: 'flex',
	                                            justifyContent: 'space-between',
	                                            alignItems: 'center',
	                                            marginBottom: 16
	                                        }
	                                    },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        { style: { margin: 0 } },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.title',
	                                            values: {
	                                                id: s && s.id || intl.formatMessage({
	                                                    id: 'ProjectEditing.mid.new'
	                                                })
	                                            },
	                                            defaultMessage: '\u041C\u0418\u0414 #{id}'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _stylesModule2.default.CardActions },
	                                        s && s.terminalId && terminalIdToTerminal[s.terminalId] ? _react2.default.createElement(
	                                            'button',
	                                            {
	                                                className: _stylesModule2.default.BtnSecondary,
	                                                onClick: function onClick() {
	                                                    var term = terminalIdToTerminal[s.terminalId];
	                                                    if (term) {
	                                                        setTerminalModal({
	                                                            open: true,
	                                                            terminal: term,
	                                                            settingIndex: idx
	                                                        });
	                                                    }
	                                                }
	                                            },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'ProjectEditing.mid.openTerminal',
	                                                defaultMessage: '\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430'
	                                            })
	                                        ) : _react2.default.createElement(
	                                            'span',
	                                            {
	                                                style: {
	                                                    color: '#999',
	                                                    fontSize: '0.875rem',
	                                                    padding: '0.5rem'
	                                                }
	                                            },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'ProjectEditing.mid.terminalNotLinked',
	                                                defaultMessage: '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043D\u0435 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D'
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'button',
	                                            {
	                                                className: _stylesModule2.default.BtnDanger,
	                                                onClick: function onClick() {
	                                                    return removeSetting(idx);
	                                                },
	                                                title: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443'
	                                            },
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: 'ProjectEditing.mid.delete',
	                                                defaultMessage: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C'
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.ProviderSection },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _stylesModule2.default.ProviderLabel },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.provider',
	                                            defaultMessage: '\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'select',
	                                        {
	                                            className: _stylesModule2.default.StyledSelect,
	                                            value: s && s.providerUuid || '',
	                                            onChange: function onChange(e) {
	                                                var pu = e.target.value;
	                                                updateSetting(idx, {
	                                                    providerUuid: pu,
	                                                    providerName: providersByUuid[pu] ? providersByUuid[pu].name : ''
	                                                });
	                                            }
	                                        },
	                                        efProviders.length === 0 && _react2.default.createElement(
	                                            'option',
	                                            { value: '' },
	                                            '\u2014 \u043D\u0435\u0442 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u0432 \u2014'
	                                        ),
	                                        efProviders.map(function (p) {
	                                            return _react2.default.createElement(
	                                                'option',
	                                                { key: p.uuid, value: p.uuid },
	                                                p.name
	                                            );
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _stylesModule2.default.ProviderCurrent },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.currentProvider',
	                                            defaultMessage: '\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440:'
	                                        }),
	                                        ' ',
	                                        _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            providerName
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.SubBlock },
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.currencyBalance',
	                                            defaultMessage: '\u0412\u0430\u043B\u044E\u0442\u0430 \u0438 \u0431\u0430\u043B\u0430\u043D\u0441:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { marginTop: 6 } },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.currency',
	                                            defaultMessage: '\u0412\u0430\u043B\u044E\u0442\u0430:'
	                                        }),
	                                        ' ',
	                                        currencyStr,
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.balance',
	                                            defaultMessage: '\u0411\u0430\u043B\u0430\u043D\u0441:'
	                                        }),
	                                        ' ',
	                                        s && s.balance
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.SubBlock },
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.methods',
	                                            defaultMessage: '\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u043C\u0435\u0442\u043E\u0434\u044B:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _stylesModule2.default.MethodsGrid },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: _stylesModule2.default.ToggleLabel },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !!s.isSBP,
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, { isSBP: e.target.checked });
	                                                }
	                                            }),
	                                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _stylesModule2.default.ToggleText },
	                                                '\u0421\u0411\u041F'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: _stylesModule2.default.ToggleLabel },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !!s.isMP2P,
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, { isMP2P: e.target.checked });
	                                                }
	                                            }),
	                                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _stylesModule2.default.ToggleText },
	                                                '\u04202\u0420'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: _stylesModule2.default.ToggleLabel },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !!s.preAuth,
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, { preAuth: e.target.checked });
	                                                }
	                                            }),
	                                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _stylesModule2.default.ToggleText },
	                                                '\u041F\u0440\u0435\u0434\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: _stylesModule2.default.ToggleLabel },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !!s.partialRefund,
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, {
	                                                        partialRefund: e.target.checked
	                                                    });
	                                                }
	                                            }),
	                                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _stylesModule2.default.ToggleText },
	                                                '\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: _stylesModule2.default.ToggleLabel },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !!s.partialReversal,
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, {
	                                                        partialReversal: e.target.checked
	                                                    });
	                                                }
	                                            }),
	                                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _stylesModule2.default.ToggleText },
	                                                '\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u0430\u044F \u043E\u0442\u043C\u0435\u043D\u0430'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: _stylesModule2.default.ToggleLabel },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !!s.recurring,
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, { recurring: e.target.checked });
	                                                }
	                                            }),
	                                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _stylesModule2.default.ToggleText },
	                                                '\u0420\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: _stylesModule2.default.ToggleLabel },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !!s.payoutBalanceCheck,
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, {
	                                                        payoutBalanceCheck: e.target.checked
	                                                    });
	                                                }
	                                            }),
	                                            _react2.default.createElement('span', { className: _stylesModule2.default.ToggleSwitch }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: _stylesModule2.default.ToggleText },
	                                                '\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u0430'
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.SubBlock },
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.fees',
	                                            defaultMessage: '\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { marginTop: 8 } },
	                                        function () {
	                                            // Для UnlimcoBank-терминала показываем раздельные комиссии
	                                            // payout_card / payout_sbp вместо одной payout.
	                                            var term = s && s.terminalId ? terminalIdToTerminal[s.terminalId] : null;
	                                            var isUnlimcoMs = term && term.processingProtocol === 'UnlimcoBank';
	                                            var feeKeys = isUnlimcoMs ? ['payment', 'payout_card', 'payout_sbp'] : ['payment', 'payout'];
	                                            return feeKeys;
	                                        }().map(function (feeKey) {
	                                            var fee = s && s.fee && s.fee[feeKey] ? s.fee[feeKey] : null;
	                                            var feeLabel = function () {
	                                                if (feeKey === 'payment') return _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.mid.fee.payment',
	                                                    defaultMessage: '\u041F\u043B\u0430\u0442\u0451\u0436'
	                                                });
	                                                if (feeKey === 'payout_card') return _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.mid.fee.payout_card',
	                                                    defaultMessage: '\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443'
	                                                });
	                                                if (feeKey === 'payout_sbp') return _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.mid.fee.payout_sbp',
	                                                    defaultMessage: '\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043F\u043E \u0421\u0411\u041F'
	                                                });
	                                                return _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.mid.fee.payout',
	                                                    defaultMessage: '\u0412\u044B\u043F\u043B\u0430\u0442\u0430'
	                                                });
	                                            }();
	                                            return _react2.default.createElement(
	                                                'div',
	                                                { key: feeKey, className: _stylesModule2.default.FeeCard },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: _stylesModule2.default.FeeInputs },
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        { className: _stylesModule2.default.FeeCardTitle },
	                                                        feeLabel
	                                                    ),
	                                                    fee ? _react2.default.createElement(
	                                                        _react.Fragment,
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: _stylesModule2.default.FeeInputGroup },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: 'ProjectEditing.mid.fee.percent',
	                                                                    defaultMessage: '%:'
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement('input', {
	                                                                type: 'number',
	                                                                step: '0.01',
	                                                                className: _stylesModule2.default.StyledInput,
	                                                                value: fee.cost != null ? fee.cost : 0,
	                                                                onChange: function onChange(e) {
	                                                                    return updateSettingFee(idx, feeKey, 'cost', parseFloat(e.target.value || '0'));
	                                                                }
	                                                            })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: _stylesModule2.default.FeeInputGroup },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: 'ProjectEditing.mid.fee.fixed',
	                                                                    defaultMessage: '\u0424\u0438\u043A\u0441.:'
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement('input', {
	                                                                type: 'number',
	                                                                step: '0.01',
	                                                                className: _stylesModule2.default.StyledInput,
	                                                                value: fee.fixedPerTransaction != null ? fee.fixedPerTransaction : 0,
	                                                                onChange: function onChange(e) {
	                                                                    return updateSettingFee(idx, feeKey, 'fixedPerTransaction', parseFloat(e.target.value || '0'));
	                                                                }
	                                                            })
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: _stylesModule2.default.FeeInputGroup },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: 'ProjectEditing.mid.fee.minFixed',
	                                                                    defaultMessage: '\u041C\u0438\u043D. \u0444\u0438\u043A\u0441.:'
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement('input', {
	                                                                type: 'number',
	                                                                step: '0.01',
	                                                                className: _stylesModule2.default.StyledInput,
	                                                                value: fee.costFixedMinimum != null ? fee.costFixedMinimum : 0,
	                                                                onChange: function onChange(e) {
	                                                                    return updateSettingFee(idx, feeKey, 'costFixedMinimum', parseFloat(e.target.value || '0'));
	                                                                }
	                                                            })
	                                                        )
	                                                    ) : _react2.default.createElement(
	                                                        'button',
	                                                        {
	                                                            className: _stylesModule2.default.BtnSecondary,
	                                                            onClick: function onClick() {
	                                                                return addSettingFeeType(idx, feeKey);
	                                                            }
	                                                        },
	                                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                            id: 'ProjectEditing.mid.fee.add',
	                                                            defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044E'
	                                                        })
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.SubBlock },
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'ProjectEditing.mid.widget',
	                                            defaultMessage: '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0438\u0434\u0436\u0435\u0442\u0430:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { marginTop: 8 } },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _stylesModule2.default.WidgetField },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: _stylesModule2.default.WidgetLabel },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.widget.key',
	                                                    defaultMessage: '\u041A\u043B\u044E\u0447 \u0432\u0438\u0434\u0436\u0435\u0442\u0430'
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _stylesModule2.default.WidgetInputGroup },
	                                                _react2.default.createElement('input', {
	                                                    type: 'text',
	                                                    value: s && s.widget || '',
	                                                    onChange: function onChange(e) {
	                                                        return updateSetting(idx, { widget: e.target.value });
	                                                    },
	                                                    className: _stylesModule2.default.WidgetInput,
	                                                    placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043B\u0438 \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043B\u044E\u0447'
	                                                }),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    {
	                                                        type: 'button',
	                                                        className: _stylesModule2.default.WidgetBtnGenerate,
	                                                        onClick: function onClick() {
	                                                            return generateWidgetKeyForSetting(idx);
	                                                        }
	                                                    },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: 'ProjectEditing.widget.generate',
	                                                        defaultMessage: '\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C'
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _stylesModule2.default.HintText },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.widget.keyHint',
	                                                    defaultMessage: '\u041A\u043B\u044E\u0447 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0432\u0438\u0434\u0436\u0435\u0442\u0430'
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _stylesModule2.default.WidgetField },
	                                            _react2.default.createElement(
	                                                'label',
	                                                { className: _stylesModule2.default.WidgetLabel },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.widget.callback',
	                                                    defaultMessage: '\u0410\u0434\u0440\u0435\u0441 \u043A\u043E\u043B\u0431\u0435\u043A\u0430'
	                                                })
	                                            ),
	                                            _react2.default.createElement('input', {
	                                                type: 'text',
	                                                value: s && s.widgetCallback || '',
	                                                onChange: function onChange(e) {
	                                                    return updateSetting(idx, {
	                                                        widgetCallback: e.target.value
	                                                    });
	                                                },
	                                                className: _stylesModule2.default.WidgetInput,
	                                                placeholder: 'https://example.com/callback'
	                                            }),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _stylesModule2.default.HintText },
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: 'ProjectEditing.widget.callbackHint',
	                                                    defaultMessage: '\u0410\u0434\u0440\u0435\u0441 \u0434\u043B\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u043A\u043E\u043B\u0431\u0435\u043A\u043E\u0432 \u043E\u0442 \u0432\u0438\u0434\u0436\u0435\u0442\u0430'
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            );
	                        }),
	                        !isFullLoading && _react2.default.createElement(
	                            'div',
	                            { style: { marginTop: 16, marginBottom: 8 } },
	                            _react2.default.createElement(
	                                'button',
	                                { className: _stylesModule2.default.BtnSuccess, onClick: addSetting },
	                                '+ \u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u0443\u044E \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443'
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Block },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.Col_1 },
	                                _react2.default.createElement(
	                                    'h4',
	                                    { className: _stylesModule2.default.BlockTitle },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                        id: 'ProjectEditing.users.title',
	                                        defaultMessage: '\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430'
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.ColFullWidth },
	                                _react2.default.createElement(_UserSearchList2.default, {
	                                    isLoading: isFullLoading,
	                                    token: token,
	                                    usersList: usersList,
	                                    users: projectUsers,
	                                    onUsersChange: onUsersChange,
	                                    onEditPermissions: onEditPermissions
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.CardFooter },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnPrimary,
	                            onClick: saveAll,
	                            disabled: isSaving || isFullLoading
	                        },
	                        isSaving ? 'Сохранение...' : 'Сохранить'
	                    )
	                )
	            ) : _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Empty },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectEditing.empty', defaultMessage: '\u041F\u0440\u043E\u0435\u043A\u0442 \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D' })
	                    )
	                )
	            )
	        ),
	        terminalModal.open && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.ModalOverlay, onClick: function onClick() {
	                    return setTerminalModal({ open: false, terminal: null });
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Modal, onClick: function onClick(e) {
	                        return e.stopPropagation();
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalHeader },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'ProjectEditing.modal.terminalSettings',
	                            defaultMessage: '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.ModalClose,
	                            onClick: function onClick() {
	                                return setTerminalModal({ open: false, terminal: null });
	                            }
	                        },
	                        '\xD7'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalBody },
	                    _react2.default.createElement(_TerminalEditing2.default, {
	                        terminal: terminalModal.terminal,
	                        token: token,
	                        onSaved: function onSaved() {
	                            refreshFull();
	                            setTerminalModal(function (prev) {
	                                return Object.assign({}, prev, { open: false });
	                            });
	                        }
	                    })
	                )
	            )
	        ),
	        permissionsModal.open && permissionsModal.user && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.ModalOverlay, onClick: function onClick() {
	                    return setPermissionsModal({ open: false, user: null });
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Modal, onClick: function onClick(e) {
	                        return e.stopPropagation();
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalHeader },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'ProjectEditing.modal.userPermissions',
	                            defaultMessage: '\u041F\u0440\u0430\u0432\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F {username}',
	                            values: { username: permissionsModal.user.username || '' }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.ModalClose,
	                            onClick: function onClick() {
	                                return setPermissionsModal({ open: false, user: null });
	                            }
	                        },
	                        '\xD7'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.ModalBody },
	                    _react2.default.createElement(_PermissionsEditor2.default, {
	                        token: token,
	                        accountId: permissionsModal.user.id,
	                        merchantUuid: uuid,
	                        onClose: function onClose() {
	                            return setPermissionsModal({ open: false, user: null });
	                        },
	                        onSaved: function onSaved() {
	                            setPermissionsModal({ open: false, user: null });
	                        }
	                    })
	                )
	            )
	        )
	    );
	}
	
	exports.default = ProjectEditing;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(546);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function ProjectSearchList(_ref) {
	    var _ref$projects = _ref.projects,
	        projects = _ref$projects === undefined ? [] : _ref$projects,
	        onProjectsChange = _ref.onProjectsChange,
	        _ref$projectsList = _ref.projectsList,
	        projectsList = _ref$projectsList === undefined ? [] : _ref$projectsList,
	        _ref$onEditPermission = _ref.onEditPermissions,
	        onEditPermissions = _ref$onEditPermission === undefined ? null : _ref$onEditPermission,
	        _ref$accountId = _ref.accountId,
	        accountId = _ref$accountId === undefined ? null : _ref$accountId,
	        _ref$globalPermission = _ref.globalPermissionsEnabled,
	        globalPermissionsEnabled = _ref$globalPermission === undefined ? false : _ref$globalPermission;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        searchTerm = _useState2[0],
	        setSearchTerm = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isDropdownOpen = _useState4[0],
	        setIsDropdownOpen = _useState4[1];
	
	    var containerRef = (0, _react.useRef)(null);
	    var inputRef = (0, _react.useRef)(null);
	
	    var safeLowerCase = function safeLowerCase(str) {
	        return (typeof str === 'string' ? str : '').toLowerCase();
	    };
	
	    var filteredProjects = projectsList.filter(function (project) {
	        var displayName = project && project.displayName || '';
	        var name = project && project.name || '';
	        var uuid = project && project.uuid || '';
	        var lowerSearch = safeLowerCase(searchTerm);
	
	        return safeLowerCase(displayName).includes(lowerSearch) || safeLowerCase(name).includes(lowerSearch) || safeLowerCase(uuid).includes(lowerSearch);
	    });
	
	    function addProject(uuid) {
	        var project = projectsList.find(function (p) {
	            return p && p.uuid === uuid;
	        });
	        if (project && !projects.find(function (p) {
	            return p && p.uuid === project.uuid;
	        })) {
	            onProjectsChange([].concat(_toConsumableArray(projects), [project]));
	            setSearchTerm('');
	            setIsDropdownOpen(false);
	            if (inputRef.current) {
	                inputRef.current.focus();
	            }
	        }
	    }
	
	    function removeProject(uuid) {
	        onProjectsChange(projects.filter(function (p) {
	            return p && p.uuid !== uuid;
	        }));
	    }
	
	    (0, _react.useEffect)(function () {
	        function handleClickOutside(event) {
	            if (containerRef.current && !containerRef.current.contains(event.target)) {
	                setIsDropdownOpen(false);
	            }
	        }
	
	        document.addEventListener('mousedown', handleClickOutside);
	        return function () {
	            document.removeEventListener('mousedown', handleClickOutside);
	        };
	    }, []);
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Wrapper, ref: containerRef },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.SearchContainer },
	            _react2.default.createElement('input', {
	                ref: inputRef,
	                type: 'text',
	                className: _stylesModule2.default.SearchInput,
	                placeholder: intl.formatMessage({ id: 'ProjectSearchList.placeholder' }),
	                value: searchTerm,
	                onChange: function onChange(e) {
	                    return setSearchTerm(e.target.value);
	                },
	                onFocus: function onFocus() {
	                    return setIsDropdownOpen(true);
	                }
	            }),
	            isDropdownOpen && filteredProjects.length > 0 && _react2.default.createElement(
	                'ul',
	                { className: _stylesModule2.default.DropdownList },
	                filteredProjects.filter(function (p) {
	                    return p && !projects.find(function (selected) {
	                        return selected && selected.uuid === p.uuid;
	                    });
	                }).map(function (project) {
	                    var displayName = project && project.displayName || project && project.name || '';
	                    return _react2.default.createElement(
	                        'li',
	                        {
	                            key: project && project.uuid,
	                            className: _stylesModule2.default.DropdownItem,
	                            onClick: function onClick() {
	                                return addProject(project && project.uuid);
	                            }
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DropdownItemTitle },
	                            displayName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DropdownItemUuid },
	                            project && project.uuid || ''
	                        )
	                    );
	                })
	            ),
	            isDropdownOpen && filteredProjects.length === 0 && searchTerm && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.DropdownEmpty },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectSearchList.empty', defaultMessage: '\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E' })
	            )
	        ),
	        projects.length > 0 && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	                'h5',
	                { className: _stylesModule2.default.SelectedTitle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectSearchList.selected.title', defaultMessage: '\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B' })
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: _stylesModule2.default.SelectedList },
	                projects.map(function (p) {
	                    var displayName = p && p.displayName || p && p.name || '';
	                    return _react2.default.createElement(
	                        'li',
	                        { key: p && p.uuid, className: _stylesModule2.default.SelectedItem },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            displayName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.ItemActions },
	                            onEditPermissions && accountId && _react2.default.createElement(
	                                'button',
	                                {
	                                    className: globalPermissionsEnabled ? _stylesModule2.default.PermissionsBtnLocked : _stylesModule2.default.PermissionsBtn,
	                                    onClick: function onClick() {
	                                        return onEditPermissions(p, accountId);
	                                    },
	                                    title: globalPermissionsEnabled ? 'Global permissions are enabled' : intl.formatMessage({
	                                        id: 'ProjectSearchList.permissions.title',
	                                        defaultMessage: 'Настроить права'
	                                    })
	                                },
	                                globalPermissionsEnabled ? '\uD83D\uDD12 Permissions' : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'ProjectSearchList.permissions.btn',
	                                    defaultMessage: '\u041F\u0440\u0430\u0432\u0430'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.RemoveBtn,
	                                    onClick: function onClick() {
	                                        return removeProject(p && p.uuid);
	                                    },
	                                    'aria-label': intl.formatMessage({ id: 'ProjectSearchList.remove.aria' }, { name: displayName })
	                                },
	                                'X'
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	}
	
	exports.default = ProjectSearchList;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(547);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ProjectsFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        isLoading = _ref.isLoading;
	
	    var _useState = (0, _react.useState)({
	        active: false,
	        inactive: false,
	        blocked: false
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        filters = _useState2[0],
	        setFilters = _useState2[1];
	
	    function toggleFilter(key, value) {
	        setFilters(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, key, value));
	        });
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    'h6',
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsFilters.title.status', defaultMessage: '\u0421\u0442\u0430\u0442\u0443\u0441' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement('input', {
	                            id: 'active',
	                            type: 'checkbox',
	                            checked: filters.active,
	                            onChange: function onChange(e) {
	                                return toggleFilter('active', e.target.checked);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'active', className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement('div', { className: _stylesModule2.default.ActiveIcon }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsFilters.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement('input', {
	                            id: 'inactive',
	                            type: 'checkbox',
	                            checked: filters.inactive,
	                            onChange: function onChange(e) {
	                                return toggleFilter('inactive', e.target.checked);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'inactive', className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement('div', { className: _stylesModule2.default.InactiveIcon }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'ProjectsFilters.status.inactive',
	                                    defaultMessage: '\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D'
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement('input', {
	                            id: 'blocked',
	                            type: 'checkbox',
	                            checked: filters.blocked,
	                            onChange: function onChange(e) {
	                                return toggleFilter('blocked', e.target.checked);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'blocked', className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement('div', { className: _stylesModule2.default.BlockIcon }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'ProjectsFilters.status.blocked',
	                                    defaultMessage: '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D'
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(
	                'button',
	                { onClick: function onClick() {
	                        return onApplyFilters(filters);
	                    }, className: _stylesModule2.default.Submit, disabled: isLoading },
	                !isLoading ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.buttonIcon, icon: 'filter', size: '17px' }) : _react2.default.createElement(_Loader2.default, { isString: true }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsFilters.btn.filter', defaultMessage: '\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C' })
	            )
	        )
	    );
	}
	
	exports.default = ProjectsFilters;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(62);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        'table',
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	                'tr',
	                { className: _stylesModule2.default.EmptyRow },
	                _react2.default.createElement(
	                    'td',
	                    { colSpan: '6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Empty },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsList.empty', defaultMessage: '\u0423\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E' })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _stylesModule = __webpack_require__(62);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobileCard(_ref) {
	    var _ref$data = _ref.data,
	        data = _ref$data === undefined ? {} : _ref$data,
	        currentUuid = _ref.currentUuid;
	
	    var _useContext = (0, _react.useContext)(_Context2.default),
	        onSelectProjectUuid = _useContext.onSelectProjectUuid;
	
	    var statusId = void 0;
	    var statusDefault = void 0;
	    var color = void 0;
	
	    if (typeof data.status === 'string') {
	        switch (data.status) {
	            case 'Status.active':
	                statusId = 'Status.active';
	                statusDefault = 'Активен';
	                color = 'rgb(16,150,24)';
	                break;
	            case 'Status.inactive':
	                statusId = 'Status.inactive';
	                statusDefault = 'Не активна';
	                color = '#ff9900';
	                break;
	            case 'Status.blocked':
	                statusId = 'Status.blocked';
	                statusDefault = 'Заблокирован';
	                color = 'rgb(220,57,18)';
	                break;
	            default:
	                statusId = 'Status.unknown';
	                statusDefault = 'Неизвестно';
	                color = '#999';
	        }
	    } else {
	        switch (data.status) {
	            case 1:
	                statusId = 'AccountsList.status.active';
	                statusDefault = 'Активен';
	                color = 'rgb(16,150,24)';
	                break;
	            case -1:
	                statusId = 'AccountsList.status.inactive';
	                statusDefault = 'Не активна';
	                color = '#ff9900';
	                break;
	            case -2:
	                statusId = 'AccountsList.status.closed';
	                statusDefault = 'Закрыт';
	                color = '#d4d4d4';
	                break;
	            case -3:
	                statusId = 'AccountsList.status.blocked';
	                statusDefault = 'Заблокирован';
	                color = 'rgb(220,57,18)';
	                break;
	            default:
	                statusId = 'Status.unknown';
	                statusDefault = 'Неизвестно';
	                color = '#999';
	        }
	    }
	
	    var identity = data.uuid || data.id || '-';
	    var isActive = currentUuid === data.uuid;
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: _stylesModule2.default.MobileCard,
	            onClick: function onClick() {
	                return data.uuid && onSelectProjectUuid && onSelectProjectUuid(data.uuid);
	            },
	            role: 'button',
	            style: isActive ? { borderBottomColor: color } : null
	        },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobilePrimary },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileName },
	                data.name || '-'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileStatus, style: { color: color } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: statusId, defaultMessage: statusDefault })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileMetaRow },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileMeta },
	                identity
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileMeta },
	                _react2.default.createElement(_FormatDate2.default, {
	                    setDate: data.createdAt,
	                    format: { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileField },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileValue },
	                data.url || '-'
	            )
	        )
	    );
	}
	
	exports.default = MobileCard;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _stylesModule = __webpack_require__(62);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var _ref$data = _ref.data,
	        data = _ref$data === undefined ? {} : _ref$data,
	        currentUuid = _ref.currentUuid;
	
	    var _useContext = (0, _react.useContext)(_Context2.default),
	        onSelectProjectUuid = _useContext.onSelectProjectUuid;
	
	    // --- Аккаунты: поддержка строк и объектов ---
	
	
	    var accountsText = (0, _react.useMemo)(function () {
	        var list = Array.isArray(data.accounts) ? data.accounts : [];
	        if (!list.length) return '-';
	        var names = list.map(function (a) {
	            if (typeof a === 'string') return a;
	            if (a && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	                if (a.username && typeof a.username === 'string') return a.username;
	                if (a.name && typeof a.name === 'string') return a.name;
	            }
	            return '';
	        }).filter(function (x) {
	            return x;
	        });
	        return names.length ? names.join(', ') : '-';
	    }, [data.accounts]);
	
	    // --- Статус: поддержка чисел и i18n-ключей ---
	    var statusId = void 0,
	        statusDefault = void 0,
	        color = void 0;
	
	    if (typeof data.status === 'string') {
	        switch (data.status) {
	            case 'Status.active':
	                statusId = 'Status.active';
	                statusDefault = 'Активен';
	                color = 'rgb(16,150,24)';
	                break;
	            case 'Status.inactive':
	                statusId = 'Status.inactive';
	                statusDefault = 'Не активна';
	                color = '#ff9900';
	                break;
	            case 'Status.blocked':
	                statusId = 'Status.blocked';
	                statusDefault = 'Заблокирован';
	                color = 'rgb(220,57,18)';
	                break;
	            default:
	                statusId = 'Status.unknown';
	                statusDefault = 'Неизвестно';
	                color = '#999';
	        }
	    } else {
	        switch (data.status) {
	            case 1:
	                statusId = 'AccountsList.status.active';
	                statusDefault = 'Активен';
	                color = 'rgb(16,150,24)';
	                break;
	            case -1:
	                statusId = 'AccountsList.status.inactive';
	                statusDefault = 'Не активна';
	                color = '#ff9900';
	                break;
	            case -2:
	                statusId = 'AccountsList.status.closed';
	                statusDefault = 'Закрыт';
	                color = '#d4d4d4';
	                break;
	            case -3:
	                statusId = 'AccountsList.status.blocked';
	                statusDefault = 'Заблокирован';
	                color = 'rgb(220,57,18)';
	                break;
	            default:
	                statusId = 'Status.unknown';
	                statusDefault = 'Неизвестно';
	                color = '#999';
	        }
	    }
	
	    var isActive = currentUuid === data.uuid;
	    var rowStyle = isActive ? { backgroundColor: '#e3f2fd' } : undefined;
	
	    return _react2.default.createElement(
	        'tr',
	        {
	            style: rowStyle,
	            className: _stylesModule2.default.Row,
	            onClick: function onClick() {
	                return data.uuid && onSelectProjectUuid && onSelectProjectUuid(data.uuid);
	            }
	        },
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.CellCenter },
	            _react2.default.createElement(_FormatDate2.default, {
	                setDate: data.createdAt,
	                format: { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }
	            })
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.Cell },
	            data.name || '-'
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.Cell },
	            data.url || '-'
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.Cell },
	            accountsText
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.CellCenter },
	            _react2.default.createElement(
	                'span',
	                { style: { color: color } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: statusId, defaultMessage: statusDefault })
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TableRow = __webpack_require__(376);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Empty = __webpack_require__(374);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _MobileCard = __webpack_require__(375);
	
	var _MobileCard2 = _interopRequireDefault(_MobileCard);
	
	var _stylesModule = __webpack_require__(62);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProjectsList(_ref) {
	    var _ref$data = _ref.data,
	        data = _ref$data === undefined ? [] : _ref$data,
	        currentUuid = _ref.currentUuid,
	        isLoading = _ref.isLoading;
	
	    if (isLoading) return _react2.default.createElement(_Loader2.default, null);
	    if (!data.length) return _react2.default.createElement(_Empty2.default, null);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Scroll },
	            _react2.default.createElement(
	                'table',
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCenter },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsList.table.createdAt', defaultMessage: '\u0414\u0430\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsList.table.name', defaultMessage: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsList.table.website', defaultMessage: '\u0421\u0430\u0439\u0442' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsList.table.accounts', defaultMessage: '\u0423\u0447\u0435\u0442\u043D\u044B\u0435 \u0437\u0430\u043F\u0438\u0441\u0438' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCenter },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsList.table.status', defaultMessage: '\u0421\u0442\u0430\u0442\u0443\u0441' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    data.map(function (el) {
	                        return _react2.default.createElement(_TableRow2.default, { key: el && (el.uuid || el.id), data: el, currentUuid: currentUuid });
	                    })
	                )
	            )
	        ),
	        data.map(function (el) {
	            return _react2.default.createElement(_MobileCard2.default, { key: el && (el.uuid || el.id), data: el, currentUuid: currentUuid });
	        })
	    );
	}
	
	exports.default = ProjectsList;

/***/ },
/* 378 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAuthSchema = getAuthSchema;
	/**
	 * Схемы полей "Ключи интеграции" по протоколам процессинга.
	 *
	 * Каждое поле имеет:
	 *   key       — ключ внутри terminal.data[source]
	 *   label     — лейбл для админа (русский)
	 *   source    — куда сохранять/откуда читать в terminal.data:
	 *                 'processingAuth' (по умолчанию) — terminal.data.processingAuth[key]
	 *                 'nodaBank' — terminal.data.nodaBank[key] (UnlimcoBank фасад)
	 *   multiline — textarea вместо input (для PEM-ключей)
	 *   placeholder — подсказка
	 *   hint      — пояснение под полем
	 *
	 * Если protocol не в этом списке — рендерим старый flat-вью processingAuth как есть.
	 */
	
	var PROCESSING_AUTH = 'processingAuth';
	var NODA_BANK = 'nodaBank';
	
	var AUTH_SCHEMAS = exports.AUTH_SCHEMAS = {
	    TransCapitalBank: [{ key: 'login', label: 'Логин', source: PROCESSING_AUTH }, { key: 'secret', label: 'Секретный ключ', source: PROCESSING_AUTH }],
	
	    Hydracode: [{ key: 'baseUrl', label: 'Адрес API Hydracode', source: PROCESSING_AUTH, placeholder: 'https://...' }, { key: 'apiKey', label: 'API ключ', source: PROCESSING_AUTH }, { key: 'signingKey', label: 'Ключ подписи', source: PROCESSING_AUTH }],
	
	    PayCraft: [{ key: 'baseUrl', label: 'Адрес API PayCraft', source: PROCESSING_AUTH, placeholder: 'https://...' }, { key: 'apiKey', label: 'API ключ', source: PROCESSING_AUTH }, { key: 'signingKey', label: 'Ключ подписи', source: PROCESSING_AUTH }],
	
	    FinStar: [{ key: 'baseUrl', label: 'Адрес API FinStar', source: PROCESSING_AUTH, placeholder: 'https://...' }, { key: 'apiKey', label: 'API ключ', source: PROCESSING_AUTH }, { key: 'signingKey', label: 'Ключ подписи', source: PROCESSING_AUTH }],
	
	    NodaBank: [{ key: 'baseUrl', label: 'Адрес API NodaBank', source: NODA_BANK, placeholder: 'https://payservice.nodabank.ru' }, { key: 'partnerId', label: 'ID партнёра', source: NODA_BANK, placeholder: 'unlimco001' }, { key: 'secret', label: 'Секрет API', source: NODA_BANK }, {
	        key: 'publicKey',
	        label: 'Публичный ключ NodaBank (PEM)',
	        source: NODA_BANK,
	        multiline: true,
	        placeholder: '-----BEGIN PUBLIC KEY-----\n...'
	    }, {
	        key: 'privateKey',
	        label: 'Наш приватный ключ (PEM)',
	        source: NODA_BANK,
	        multiline: true,
	        placeholder: '-----BEGIN PRIVATE KEY-----\n...'
	    }, {
	        key: 'account',
	        label: 'Расчётный счёт NodaBank',
	        source: NODA_BANK,
	        hint: 'Куда NodaBank нам зачисляет деньги'
	    }],
	
	    // UnlimcoBank — фасад: карты идут через NodaBank, СБП через PSB B2C.
	    // Поэтому показываем И NodaBank-поля, И PSB-СБП-поля. Все хранятся в processingAuth кроме nodaBank-секции.
	    UnlimcoBank: [{ section: 'NodaBank (выплаты на карты)' }, { key: 'baseUrl', label: 'Адрес API NodaBank', source: NODA_BANK, placeholder: 'https://payservice.nodabank.ru' }, { key: 'partnerId', label: 'ID партнёра', source: NODA_BANK, placeholder: 'unlimco001' }, { key: 'secret', label: 'Секрет API', source: NODA_BANK }, {
	        key: 'publicKey',
	        label: 'Публичный ключ NodaBank (PEM)',
	        source: NODA_BANK,
	        multiline: true,
	        placeholder: '-----BEGIN PUBLIC KEY-----\n...'
	    }, {
	        key: 'privateKey',
	        label: 'Наш приватный ключ (PEM)',
	        source: NODA_BANK,
	        multiline: true,
	        placeholder: '-----BEGIN PRIVATE KEY-----\n...'
	    }, {
	        key: 'account',
	        label: 'Расчётный счёт NodaBank',
	        source: NODA_BANK,
	        hint: 'Куда NodaBank нам зачисляет деньги'
	    }, { section: 'ПСБ (выплаты по СБП)' }, { key: 'sbp_id', label: 'ID СБП (LB...)', source: PROCESSING_AUTH, placeholder: 'LB0000005837' }, { key: 'merchant', label: 'ID мерчанта ПСБ', source: PROCESSING_AUTH }, { key: 'terminal', label: 'Терминал ПСБ', source: PROCESSING_AUTH }, { key: 'sbp_account_number', label: 'Счёт СБП в ПСБ', source: PROCESSING_AUTH }, { key: 'filial_bic', label: 'БИК филиала ПСБ', source: PROCESSING_AUTH }, { key: 'merch_inn', label: 'ИНН мерчанта', source: PROCESSING_AUTH }, { key: 'merch_name', label: 'Название мерчанта (для ПСБ)', source: PROCESSING_AUTH }, { key: 'merch_city', label: 'Город мерчанта', source: PROCESSING_AUTH }, { key: 'key_component_1', label: 'Компонент ключа 1', source: PROCESSING_AUTH }, { key: 'key_component_2', label: 'Компонент ключа 2', source: PROCESSING_AUTH }, {
	        key: 'rsa_private_key_pem',
	        label: 'Наш приватный RSA-ключ (PEM)',
	        source: PROCESSING_AUTH,
	        multiline: true,
	        placeholder: '-----BEGIN RSA PRIVATE KEY-----\n...'
	    }, {
	        key: 'rsa_psb_public_key_pem',
	        label: 'Публичный RSA-ключ ПСБ (PEM)',
	        source: PROCESSING_AUTH,
	        multiline: true,
	        placeholder: '-----BEGIN PUBLIC KEY-----\n...'
	    }],
	
	    Psb: [{ section: 'ПСБ карточная интеграция' }, { key: 'cpid', label: 'CPID', source: PROCESSING_AUTH, hint: 'Договор интернет-эквайринга' }, { key: 'cps', label: 'CPS (терминал)', source: PROCESSING_AUTH }, { key: 'email', label: 'Email кабинета', source: PROCESSING_AUTH }, { key: 'password', label: 'Пароль кабинета', source: PROCESSING_AUTH }, { key: 'secret', label: 'Секрет подписи', source: PROCESSING_AUTH }]
	};
	
	/**
	 * Возвращает список полей для протокола. Если протокол неизвестен — null
	 * (UI откатывается на старый flat-вью processingAuth).
	 */
	function getAuthSchema(processingProtocol) {
	    if (!processingProtocol) return null;
	    return AUTH_SCHEMAS[processingProtocol] || null;
	}
	
	var SOURCE_PROCESSING_AUTH = exports.SOURCE_PROCESSING_AUTH = PROCESSING_AUTH;
	var SOURCE_NODA_BANK = exports.SOURCE_NODA_BANK = NODA_BANK;

/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shouldShowMethodsBlock = shouldShowMethodsBlock;
	exports.capabilityAllows = capabilityAllows;
	/**
	 * Чтение capabilities терминала (отдаёт backend в /terminals/{id} → resp.capabilities).
	 *
	 * Семантика:
	 *   - true  — протокол явно умеет (показываем тоггл/блок);
	 *   - false — протокол явно не умеет (скрываем);
	 *   - null  — backend не знает (legacy / нет в ProtocolResolver) — fallback: показываем,
	 *     иначе мы внезапно потеряем тогглы у легаси-терминалов после деплоя.
	 */
	
	var KNOWN_CAPABILITIES = ['preAuth', 'partialRefund', 'partialReversal', 'isPayoutOnly'];
	
	/**
	 * Должен ли быть виден целиком блок "Методы"?
	 *
	 * Скрываем только для protocols, которые явно payout-only (UnlimcoBank, FinStar,
	 * NodaBank, TransCapitalBank). Для всех остальных — показываем.
	 *
	 * Fallback: если capabilities не пришли, показываем — лучше лишний блок чем
	 * потерянная настройка у легаси-терминала.
	 */
	function shouldShowMethodsBlock(terminal) {
	  if (!terminal) return false;
	  var caps = terminal.capabilities;
	  if (!caps) return true;
	  if (caps.isPayoutOnly === true) return false;
	  return true;
	}
	
	/**
	 * Разрешён ли конкретный capability-тоггл (preAuth/partialRefund/partialReversal)?
	 *
	 * Возвращает true если backend сказал что протокол умеет, ИЛИ если capabilities
	 * нет вовсе (fallback). Не показываем только при явном false.
	 */
	function capabilityAllows(terminal, capability) {
	  if (!terminal) return false;
	  var caps = terminal.capabilities;
	  if (!caps) return true;
	  if (!KNOWN_CAPABILITIES.includes(capability)) return true;
	  return caps[capability] !== false;
	}

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = useTabFromUrl;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Тонкий хук «таб, синхронизированный с ?tab=" в URL».
	 *
	 * Не тянем react-router и не вешаем history.push — используем
	 * window.history.replaceState чтобы не плодить записи в браузерной истории
	 * (переключение таба = шум, навигация назад от него бессмысленна).
	 *
	 * При прямом открытии страницы с ?tab=keys — таб подхватывается из URL,
	 * это нужно для ссылок «открой такому-то админу ключи такого-то терминала».
	 */
	function useTabFromUrl(defaultTab, validTabs) {
	    var readFromUrl = function readFromUrl() {
	        try {
	            var params = new URLSearchParams(window.location.search);
	            var t = params.get('tab');
	            if (t && validTabs.includes(t)) return t;
	        } catch (e) {
	            // SSR / тестовая среда без window — молча отдаём default.
	        }
	        return defaultTab;
	    };
	
	    var _useState = (0, _react.useState)(readFromUrl),
	        _useState2 = _slicedToArray(_useState, 2),
	        tab = _useState2[0],
	        setTab = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        try {
	            var params = new URLSearchParams(window.location.search);
	            if (tab === defaultTab) {
	                params.delete('tab');
	            } else {
	                params.set('tab', tab);
	            }
	            var qs = params.toString();
	            var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
	            window.history.replaceState(window.history.state, '', url);
	        } catch (e) {
	            // тестовая среда — пропускаем
	        }
	    }, [tab, defaultTab]);
	
	    return [tab, setTab];
	}

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(549);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TerminalsFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        isLoading = _ref.isLoading;
	
	    var _useState = (0, _react.useState)({
	        active: true,
	        inactive: false
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        filters = _useState2[0],
	        setFilters = _useState2[1];
	
	    function apply() {
	        var list = [];
	
	        if (filters.active) list.push({ active: true });
	        if (filters.inactive) list.push({ inactive: true });
	
	        if (typeof onApplyFilters === 'function') {
	            onApplyFilters(list);
	        }
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    'h6',
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsFilters.title', defaultMessage: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement('input', {
	                            id: 'terminals-active',
	                            type: 'checkbox',
	                            checked: filters.active,
	                            onChange: function onChange(e) {
	                                return setFilters(function (prev) {
	                                    return Object.assign({}, prev, { active: e.target.checked });
	                                });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'terminals-active', className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement('div', { className: _stylesModule2.default.ActiveIcon }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'TerminalsFilters.status.active',
	                                    defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435'
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement('input', {
	                            id: 'terminals-inactive',
	                            type: 'checkbox',
	                            checked: filters.inactive,
	                            onChange: function onChange(e) {
	                                return setFilters(function (prev) {
	                                    return Object.assign({}, prev, { inactive: e.target.checked });
	                                });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'terminals-inactive', className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement('div', { className: _stylesModule2.default.BlockIcon }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'TerminalsFilters.status.inactive',
	                                    defaultMessage: '\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435'
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(
	                'button',
	                { onClick: apply, className: _stylesModule2.default.Submit, disabled: isLoading },
	                !isLoading ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.buttonIcon, icon: 'filter', size: '17px' }) : _react2.default.createElement(_Loader2.default, { isString: true }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsFilters.btn.filter', defaultMessage: '\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C' })
	            )
	        )
	    );
	}
	
	exports.default = TerminalsFilters;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(103);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Empty() {
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Empty },
	        _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.empty', defaultMessage: '\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E' })
	        )
	    );
	}
	
	exports.default = Empty;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(103);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobileCard(_ref) {
	    var row = _ref.row,
	        currentId = _ref.currentId,
	        _onClick = _ref.onClick;
	
	    var safeRow = row || {};
	    var isActive = currentId === safeRow.id;
	    var isEnabled = safeRow.status === 1;
	
	    var status = {
	        id: isEnabled ? 'TerminalsList.status.active' : 'TerminalsList.status.inactive',
	        defaultMessage: isEnabled ? 'Active' : 'Inactive',
	        color: isEnabled ? '#1b8356' : '#a43232'
	    };
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: _stylesModule2.default.MobileCard,
	            onClick: function onClick() {
	                return _onClick(safeRow);
	            },
	            role: 'button',
	            style: isActive ? { borderBottomColor: status.color } : null
	        },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobilePrimary },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileName },
	                safeRow.name || '-'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileStatus, style: { color: status.color } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: status.id, defaultMessage: status.defaultMessage })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileMetaRow },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileMeta },
	                '#',
	                safeRow.id || '-'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileMeta },
	                safeRow.projectName || '—'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileSecondaryRow },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileValue },
	                safeRow.providerName || '—'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.MobileValue },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.balance', defaultMessage: '\u0411\u0430\u043B\u0430\u043D\u0441' }),
	                ':',
	                ' ',
	                typeof safeRow.balance === 'number' ? safeRow.balance : 0
	            )
	        )
	    );
	}
	
	exports.default = MobileCard;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(103);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Empty = __webpack_require__(382);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _MobileCard = __webpack_require__(383);
	
	var _MobileCard2 = _interopRequireDefault(_MobileCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Status pill
	function StatusPill(_ref) {
	    var value = _ref.value;
	
	    var text = value === 1 ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.status.active', defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0435\u043D' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.status.inactive', defaultMessage: '\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D' });
	    var bg = value === 1 ? '#e8f8ef' : '#f6e8e8';
	    var color = value === 1 ? '#1b8356' : '#a43232';
	
	    return _react2.default.createElement(
	        'span',
	        { style: { padding: '2px 8px', borderRadius: 12, background: bg, color: color, fontSize: 12 } },
	        text
	    );
	}
	
	function TableRow(_ref2) {
	    var row = _ref2.row,
	        isActive = _ref2.isActive,
	        _onClick = _ref2.onClick;
	
	    var methods = [];
	    if (row && row.isSBP) methods.push(_react2.default.createElement(_reactIntl.FormattedMessage, { key: 'sbp', id: 'TerminalsList.method.sbp', defaultMessage: '\u0421\u0411\u041F' }));
	    if (row && row.isMP2P) methods.push(_react2.default.createElement(_reactIntl.FormattedMessage, { key: 'p2p', id: 'TerminalsList.method.p2p', defaultMessage: '\u04202\u0420' }));
	    if (row && row.preAuth) methods.push(_react2.default.createElement(_reactIntl.FormattedMessage, { key: 'preAuth', id: 'TerminalsList.method.preAuth', defaultMessage: '\u041F\u0440\u0435\u0434\u0430\u0432\u0442.' }));
	    if (row && row.partialRefund) methods.push(_react2.default.createElement(_reactIntl.FormattedMessage, {
	        key: 'partialRefund',
	        id: 'TerminalsList.method.partialRefund',
	        defaultMessage: '\u0427\u0430\u0441\u0442. \u0432\u043E\u0437\u0432\u0440\u0430\u0442'
	    }));
	    if (row && row.partialReversal) methods.push(_react2.default.createElement(_reactIntl.FormattedMessage, {
	        key: 'partialReversal',
	        id: 'TerminalsList.method.partialReversal',
	        defaultMessage: '\u0427\u0430\u0441\u0442. \u043E\u0442\u043C\u0435\u043D\u0430'
	    }));
	    if (row && row.recurring) methods.push(_react2.default.createElement(_reactIntl.FormattedMessage, { key: 'recurring', id: 'TerminalsList.method.recurring', defaultMessage: '\u0420\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442' }));
	
	    var trClass = isActive ? _stylesModule2.default.Active : '';
	
	    return _react2.default.createElement(
	        'tr',
	        { className: trClass, onClick: function onClick() {
	                return _onClick(row);
	            }, style: { cursor: 'pointer' } },
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.HeaderCenter },
	            '#',
	            row && row.id
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.HeaderCell },
	            _react2.default.createElement(
	                'div',
	                { style: { fontWeight: 600 } },
	                row && row.name || '-'
	            )
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.HeaderCell },
	            _react2.default.createElement(
	                'div',
	                { style: { fontWeight: 600 } },
	                row && row.projectName || '—'
	            )
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.HeaderCell },
	            _react2.default.createElement(
	                'div',
	                null,
	                row && row.providerName || '—'
	            )
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.HeaderCenter },
	            typeof (row && row.balance) === 'number' ? row.balance : 0
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.HeaderCell },
	            _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexWrap: 'wrap', gap: 6 } },
	                methods.length === 0 ? _react2.default.createElement(
	                    'span',
	                    { style: { opacity: 0.6 } },
	                    '\u2014'
	                ) : methods.map(function (m, i) {
	                    return _react2.default.createElement(
	                        'span',
	                        {
	                            key: i,
	                            style: { fontSize: 12, background: '#f3f4f6', padding: '2px 6px', borderRadius: 8 }
	                        },
	                        m
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: _stylesModule2.default.HeaderCenter },
	            _react2.default.createElement(StatusPill, { value: row && row.status })
	        )
	    );
	}
	
	function TerminalsList(_ref3) {
	    var data = _ref3.data,
	        currentId = _ref3.currentId,
	        isLoading = _ref3.isLoading,
	        onSelect = _ref3.onSelect;
	
	    var rows = Array.isArray(data) ? data : [];
	
	    if (isLoading) return _react2.default.createElement(_Loader2.default, null);
	    if (!rows.length) return _react2.default.createElement(_Empty2.default, null);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Scroll },
	            _react2.default.createElement(
	                'table',
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCenter },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.id', defaultMessage: '\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.terminal', defaultMessage: '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.project', defaultMessage: '\u041F\u0440\u043E\u0435\u043A\u0442' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.provider', defaultMessage: '\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCenter },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.balance', defaultMessage: '\u0411\u0430\u043B\u0430\u043D\u0441' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.methods', defaultMessage: '\u041C\u0435\u0442\u043E\u0434\u044B' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.HeaderCenter },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TerminalsList.table.status', defaultMessage: '\u0421\u0442\u0430\u0442\u0443\u0441' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rows.map(function (row) {
	                        return _react2.default.createElement(TableRow, {
	                            key: row && row.id ? row.id : Math.random(),
	                            row: row,
	                            isActive: currentId === (row && row.id),
	                            onClick: onSelect
	                        });
	                    })
	                )
	            )
	        ),
	        rows.map(function (row) {
	            return _react2.default.createElement(_MobileCard2.default, {
	                key: row && row.id ? row.id : Math.random(),
	                row: row,
	                currentId: currentId,
	                onClick: onSelect
	            });
	        })
	    );
	}
	
	TerminalsList.defaultProps = {
	    data: [],
	    isLoading: false,
	    onSelect: function onSelect() {}
	};
	
	exports.default = TerminalsList;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = TrafficMonitoringTable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(550);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fmt(kopecks) {
	    if (!kopecks) return "0";
	    var rub = kopecks / 100;
	    if (rub >= 1000000) return (rub / 1000000).toFixed(1) + "M";
	    if (rub >= 1000) return Math.round(rub / 1000) + "K";
	    return Math.round(rub).toLocaleString("ru-RU");
	}
	
	function fmtC(n) {
	    if (!n) return "0";
	    if (n >= 1000) return (n / 1000).toFixed(1) + "K";
	    return String(n);
	}
	
	function T(props) {
	    if (props.v === "up") return _react2.default.createElement("span", { className: _stylesModule2.default.Up }, "\u2191");
	    if (props.v === "down") return _react2.default.createElement("span", { className: _stylesModule2.default.Dn }, "\u2193");
	    return null;
	}
	
	function Cell(props) {
	    return _react2.default.createElement(
	        "td",
	        { className: props.cls },
	        _react2.default.createElement(
	            "span",
	            null,
	            props.sum
	        ),
	        props.trend && _react2.default.createElement(T, { v: props.trend }),
	        _react2.default.createElement(
	            "span",
	            { className: _stylesModule2.default.Sep },
	            "/"
	        ),
	        _react2.default.createElement(
	            "span",
	            { className: _stylesModule2.default.Cnt },
	            props.cnt
	        )
	    );
	}
	
	// Combine payments+payouts into success/decline totals
	function combine(merchant, status) {
	    var pay = merchant.payments && merchant.payments[status];
	    var out = merchant.payouts && merchant.payouts[status];
	    var result = {};
	    var periods = ["24h", "7d", "30d"];
	    for (var i = 0; i < periods.length; i++) {
	        var p = periods[i];
	        var pa = pay && pay[p] ? pay[p] : { amount: 0, count: 0 };
	        var oa = out && out[p] ? out[p] : { amount: 0, count: 0 };
	        result[p] = {
	            amount: (pa.amount || 0) + (oa.amount || 0),
	            count: (pa.count || 0) + (oa.count || 0),
	            trend_amount: pa.trend_amount || oa.trend_amount || "same",
	            trend_count: pa.trend_count || oa.trend_count || "same"
	        };
	    }
	    return result;
	}
	
	function combinePrev(merchant, status) {
	    var prev = merchant.previous;
	    if (!prev) return null;
	    var pay = prev.payments && prev.payments[status];
	    var out = prev.payouts && prev.payouts[status];
	    var result = {};
	    var periods = ["24h", "7d", "30d"];
	    for (var i = 0; i < periods.length; i++) {
	        var p = periods[i];
	        var pa = pay && pay[p] ? pay[p] : { amount: 0, count: 0 };
	        var oa = out && out[p] ? out[p] : { amount: 0, count: 0 };
	        result[p] = {
	            amount: (pa.amount || 0) + (oa.amount || 0),
	            count: (pa.count || 0) + (oa.count || 0)
	        };
	    }
	    return result;
	}
	
	function hasTraffic(m) {
	    var s = combine(m, "success");
	    var d = combine(m, "decline");
	    return s["24h"].amount > 0 || s["24h"].count > 0 || s["7d"].amount > 0 || s["7d"].count > 0 || s["30d"].amount > 0 || s["30d"].count > 0 || d["24h"].count > 0 || d["7d"].count > 0 || d["30d"].count > 0;
	}
	
	function exportCSV(merchants) {
	    var rows = [["Merchant", "Type", "24h Sum", "24h Count", "7d Sum", "7d Count", "30d Sum", "30d Count"]];
	    merchants.forEach(function (m) {
	        ["success", "decline"].forEach(function (st) {
	            var c = combine(m, st);
	            rows.push([m.name, st, c["24h"].amount / 100, c["24h"].count, c["7d"].amount / 100, c["7d"].count, c["30d"].amount / 100, c["30d"].count]);
	        });
	    });
	    var csv = rows.map(function (r) {
	        return r.join(";");
	    }).join("\n");
	    var blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
	    var url = URL.createObjectURL(blob);
	    var a = document.createElement("a");
	    a.href = url;
	    a.setAttribute("download", "traffic_" + new Date().toISOString().slice(0, 10) + ".csv");
	    document.body.appendChild(a);
	    a.click();
	    a.remove();
	    URL.revokeObjectURL(url);
	}
	
	function MerchantBlock(props) {
	    var m = props.merchant;
	    var idx = props.index;
	    var isOdd = idx % 2 === 1;
	    var suc = combine(m, "success");
	    var dec = combine(m, "decline");
	    var prevSuc = combinePrev(m, "success");
	    var prevDec = combinePrev(m, "decline");
	    var bg = isOdd ? _stylesModule2.default.Odd : "";
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "tr",
	            { className: bg },
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.Name, rowSpan: 2 },
	                m.name
	            ),
	            _react2.default.createElement("td", { className: _stylesModule2.default.BarOk }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.Val, sum: fmt(suc["24h"].amount), cnt: fmtC(suc["24h"].count), trend: suc["24h"].trend_amount }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.Val, sum: fmt(suc["7d"].amount), cnt: fmtC(suc["7d"].count), trend: suc["7d"].trend_amount }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.Val30, sum: fmt(suc["30d"].amount), cnt: fmtC(suc["30d"].count) }),
	            _react2.default.createElement("td", { className: _stylesModule2.default.PDiv, rowSpan: 2 }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.PVal, sum: prevSuc ? fmt(prevSuc["24h"].amount) : "0", cnt: prevSuc ? fmtC(prevSuc["24h"].count) : "0" }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.PVal, sum: prevSuc ? fmt(prevSuc["7d"].amount) : "0", cnt: prevSuc ? fmtC(prevSuc["7d"].count) : "0" }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.PVal30, sum: prevSuc ? fmt(prevSuc["30d"].amount) : "0", cnt: prevSuc ? fmtC(prevSuc["30d"].count) : "0" })
	        ),
	        _react2.default.createElement(
	            "tr",
	            { className: bg },
	            _react2.default.createElement("td", { className: _stylesModule2.default.BarFail }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.Val, sum: fmt(dec["24h"].amount), cnt: fmtC(dec["24h"].count), trend: dec["24h"].trend_amount }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.Val, sum: fmt(dec["7d"].amount), cnt: fmtC(dec["7d"].count), trend: dec["7d"].trend_amount }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.Val30, sum: fmt(dec["30d"].amount), cnt: fmtC(dec["30d"].count) }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.PVal, sum: prevDec ? fmt(prevDec["24h"].amount) : "0", cnt: prevDec ? fmtC(prevDec["24h"].count) : "0" }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.PVal, sum: prevDec ? fmt(prevDec["7d"].amount) : "0", cnt: prevDec ? fmtC(prevDec["7d"].count) : "0" }),
	            _react2.default.createElement(Cell, { cls: _stylesModule2.default.PVal30, sum: prevDec ? fmt(prevDec["30d"].amount) : "0", cnt: prevDec ? fmtC(prevDec["30d"].count) : "0" })
	        )
	    );
	}
	
	function TrafficMonitoringTable(props) {
	    var merchants = props.merchants || [];
	    var updatedAt = props.updatedAt;
	    var onRefresh = props.onRefresh;
	    var loading = props.loading;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isFocus = _useState2[0],
	        setIsFocus = _useState2[1];
	
	    var toggleFocus = (0, _react.useCallback)(function () {
	        setIsFocus(function (v) {
	            return !v;
	        });
	    }, []);
	
	    var updatedTime = updatedAt ? new Date(updatedAt).toLocaleTimeString("ru-RU") : "";
	    var active = merchants.filter(hasTraffic);
	
	    return _react2.default.createElement(
	        "div",
	        { className: [_stylesModule2.default.Wrap, isFocus ? _stylesModule2.default.Focus : ""].join(" ") },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Header },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.HL },
	                _react2.default.createElement(
	                    "h5",
	                    { className: _stylesModule2.default.Title },
	                    "\u041C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433 \u0442\u0440\u0430\u0444\u0438\u043A\u0430"
	                ),
	                updatedAt && _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Upd },
	                    updatedTime,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Live },
	                        " \u25CF live"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.HR },
	                onRefresh && _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.Btn, onClick: onRefresh, disabled: loading },
	                    "\u21BB"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.Btn, onClick: function onClick() {
	                            exportCSV(active);
	                        } },
	                    "CSV"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.Btn, onClick: toggleFocus, title: isFocus ? "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C" : "\u0422\u043E\u043B\u044C\u043A\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0430" },
	                    isFocus ? "\u2716" : "\u26F6"
	                )
	            )
	        ),
	        loading && merchants.length === 0 && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Empty },
	            "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
	        ),
	        !loading && active.length === 0 && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Empty },
	            "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"
	        ),
	        active.length > 0 && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.TW },
	            _react2.default.createElement(
	                "table",
	                { className: _stylesModule2.default.Tbl },
	                _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.Th, rowSpan: 2 },
	                            "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                        ),
	                        _react2.default.createElement("th", { className: _stylesModule2.default.ThBar, rowSpan: 2 }),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.Th },
	                            "24\u0447"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.Th },
	                            "7\u0434"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.Th30 },
	                            "30\u0434"
	                        ),
	                        _react2.default.createElement("th", { className: _stylesModule2.default.ThPDiv, rowSpan: 2 }),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThP2 },
	                            "24\u0447"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThP2 },
	                            "7\u0434"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThP30 },
	                            "30\u0434"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThS },
	                            "\u0441\u0443\u043C / \u043A\u043E\u043B"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThS },
	                            "\u0441\u0443\u043C / \u043A\u043E\u043B"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThS30 },
	                            "\u0441\u0443\u043C / \u043A\u043E\u043B"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThSP },
	                            "\u0441\u0443\u043C / \u043A\u043E\u043B"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThSP },
	                            "\u0441\u0443\u043C / \u043A\u043E\u043B"
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            { className: _stylesModule2.default.ThSP30 },
	                            "\u0441\u0443\u043C / \u043A\u043E\u043B"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "tbody",
	                    null,
	                    active.map(function (m, i) {
	                        return _react2.default.createElement(MerchantBlock, { key: m.id, merchant: m, index: i });
	                    })
	                )
	            )
	        )
	    );
	}

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(551);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function UserSearchList(_ref) {
	    var _ref$users = _ref.users,
	        users = _ref$users === undefined ? [] : _ref$users,
	        onUsersChange = _ref.onUsersChange,
	        _ref$usersList = _ref.usersList,
	        usersList = _ref$usersList === undefined ? [] : _ref$usersList,
	        _ref$isLoading = _ref.isLoading,
	        isLoading = _ref$isLoading === undefined ? true : _ref$isLoading,
	        _ref$onEditPermission = _ref.onEditPermissions,
	        onEditPermissions = _ref$onEditPermission === undefined ? null : _ref$onEditPermission;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        searchTerm = _useState2[0],
	        setSearchTerm = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isDropdownOpen = _useState4[0],
	        setIsDropdownOpen = _useState4[1];
	
	    var containerRef = (0, _react.useRef)(null);
	    var inputRef = (0, _react.useRef)(null);
	
	    var safeLowerCase = function safeLowerCase(str) {
	        return (typeof str === 'string' ? str : '').toLowerCase();
	    };
	
	    var filteredUsers = usersList.filter(function (user) {
	        var username = user && user.username || '';
	        var email = user && user.email || '';
	        var id = String(user && user.id || '');
	        var lowerSearch = safeLowerCase(searchTerm);
	
	        return safeLowerCase(username).includes(lowerSearch) || safeLowerCase(email).includes(lowerSearch) || safeLowerCase(id).includes(lowerSearch);
	    });
	
	    function addUser(id) {
	        var user = usersList.find(function (u) {
	            return u && String(u.id) === id;
	        });
	        if (user && !users.find(function (u) {
	            return u && u.username === user.username;
	        })) {
	            onUsersChange([].concat(_toConsumableArray(users), [user]));
	            setSearchTerm('');
	            setIsDropdownOpen(false);
	            if (inputRef.current) inputRef.current.focus();
	        }
	    }
	
	    function removeUser(id) {
	        onUsersChange(users.filter(function (u) {
	            return u && String(u.id) !== id;
	        }));
	    }
	
	    (0, _react.useEffect)(function () {
	        function handleClickOutside(event) {
	            if (containerRef.current && !containerRef.current.contains(event.target)) {
	                setIsDropdownOpen(false);
	            }
	        }
	
	        document.addEventListener('mousedown', handleClickOutside);
	        return function () {
	            return document.removeEventListener('mousedown', handleClickOutside);
	        };
	    }, []);
	
	    if (isLoading) {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Wrapper, ref: containerRef },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.LoadingWrapper },
	                _react2.default.createElement('div', { className: _stylesModule2.default.Spinner }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'UserSearchList.loading', defaultMessage: '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439...' })
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Wrapper, ref: containerRef },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.SearchContainer },
	            _react2.default.createElement('input', {
	                ref: inputRef,
	                type: 'text',
	                className: _stylesModule2.default.SearchInput,
	                placeholder: intl.formatMessage({ id: 'UserSearchList.placeholder' }),
	                value: searchTerm,
	                onChange: function onChange(e) {
	                    return setSearchTerm(e.target.value);
	                },
	                onFocus: function onFocus() {
	                    return setIsDropdownOpen(true);
	                }
	            }),
	            isDropdownOpen && filteredUsers.length > 0 && _react2.default.createElement(
	                'ul',
	                { className: _stylesModule2.default.DropdownList },
	                filteredUsers.filter(function (u) {
	                    return u && !users.find(function (selected) {
	                        return selected && selected.username === u.username;
	                    });
	                }).map(function (user) {
	                    var displayName = user && user.username || '';
	                    return _react2.default.createElement(
	                        'li',
	                        {
	                            key: user && user.id,
	                            className: _stylesModule2.default.DropdownItem,
	                            onClick: function onClick() {
	                                return addUser(String(user && user.id));
	                            }
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DropdownItemTitle },
	                            displayName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DropdownItemUuid },
	                            user && user.id || '',
	                            ' \u2022 ',
	                            user && user.email || '—'
	                        )
	                    );
	                })
	            ),
	            isDropdownOpen && filteredUsers.length === 0 && searchTerm && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.DropdownEmpty },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'UserSearchList.empty', defaultMessage: '\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E' })
	            )
	        ),
	        users.length > 0 && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	                'h5',
	                { className: _stylesModule2.default.SelectedTitle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'UserSearchList.selected.title', defaultMessage: '\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438' })
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: _stylesModule2.default.SelectedList },
	                users.map(function (u) {
	                    var displayName = u && u.username || '';
	                    return _react2.default.createElement(
	                        'li',
	                        { key: u && u.id, className: _stylesModule2.default.SelectedItem },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            displayName,
	                            ' (',
	                            u && u.email || '—',
	                            ')'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.ItemActions },
	                            onEditPermissions && _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.PermissionsBtn,
	                                    onClick: function onClick() {
	                                        return onEditPermissions(u);
	                                    },
	                                    title: intl.formatMessage({
	                                        id: 'UserSearchList.permissions.title',
	                                        defaultMessage: 'Настроить права'
	                                    })
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'UserSearchList.permissions.btn',
	                                    defaultMessage: '\u041F\u0440\u0430\u0432\u0430'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.RemoveBtn,
	                                    onClick: function onClick() {
	                                        return removeUser(String(u && u.id));
	                                    },
	                                    'aria-label': intl.formatMessage({ id: 'UserSearchList.remove.aria' }, { name: displayName })
	                                },
	                                'X'
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	}
	
	exports.default = UserSearchList;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(104);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "tr",
	        { className: _stylesModule2.default.EmptyRow },
	        _react2.default.createElement(
	            "td",
	            { colSpan: "6" },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Empty },
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.empty", defaultMessage: "\u041D\u0435\u0442 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u043E\u0432" })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _ContextMenu = __webpack_require__(58);
	
	var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
	
	var _stylesModule = __webpack_require__(104);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data,
	        project = _ref.project;
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            "tr",
	            { className: _stylesModule2.default.Row },
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.name || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.date || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                project && project.displayName ? project.displayName : data && data.merchantId || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.psaCount || 0
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.psaProcessingCount || 0
	            ),
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.CellMenu },
	                _react2.default.createElement(
	                    _ContextMenu2.default,
	                    { icon: "menu" },
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { className: _stylesModule2.default.ActivateLink,
	                                    to: "/metal/contract/" + (data && data.id || "") + "/pca/create" },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.menu.newPSA",
	                                    defaultMessage: "\u041D\u043E\u0432\u044B\u0439 \u041F\u0421\u0410 \u0434\u043B\u044F \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { className: _stylesModule2.default.defaultLink,
	                                    to: "/metal/pca?psaContractId=" + (data && data.id || "") },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.menu.psaList", defaultMessage: "\u0421\u043F\u0438\u0441\u043E\u043A \u041F\u0421\u0410" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { className: _stylesModule2.default.defaultLink,
	                                    to: "/metal/contract/" + (data && data.id || "") },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.menu.edit", defaultMessage: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Auth = __webpack_require__(4);
	
	var _TableRow = __webpack_require__(388);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Empty = __webpack_require__(387);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(104);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContractsTable(_ref) {
	    var token = _ref.token,
	        data = _ref.data,
	        projects = _ref.projects;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 1),
	        loading = _useState2[0];
	
	    return loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	        "table",
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.table.name", defaultMessage: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.table.date", defaultMessage: "\u0414\u0430\u0442\u0430" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.table.project", defaultMessage: "\u041F\u0440\u043E\u0435\u043A\u0442" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.table.psaCount", defaultMessage: "\u041A\u043E\u043B-\u0432\u043E \u041F\u0421\u0410" })
	                ),
	                _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ContractsTable.table.psaProcessing", defaultMessage: "\u041F\u0421\u0410 \u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435" })
	                ),
	                _react2.default.createElement("th", null)
	            )
	        ),
	        _react2.default.createElement(
	            "tbody",
	            null,
	            !loading && data && data.length > 0 ? data.map(function (el, i) {
	                var project = projects && projects.find(function (p) {
	                    return p && p.uuid === el.merchantId;
	                });
	                return _react2.default.createElement(_TableRow2.default, { key: i, data: el, project: project });
	            }) : _react2.default.createElement(_Empty2.default, null)
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(ContractsTable);

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(199);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "table",
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Empty },
	                        _react2.default.createElement(
	                            "h5",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Empty.message.dataSoon", defaultMessage: "\u0414\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u043E\u0440\u043E \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F" })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _CountryChart = __webpack_require__(335);
	
	var _CountryChart2 = _interopRequireDefault(_CountryChart);
	
	var _CountryTop = __webpack_require__(338);
	
	var _CountryTop2 = _interopRequireDefault(_CountryTop);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Empty = __webpack_require__(390);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(199);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        chartData = _useState2[0],
	        setChartData = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        tableData = _useState4[0],
	        setTableData = _useState4[1];
	
	    var parseMoney = function parseMoney(v) {
	        if (typeof v !== 'string') return Number(v) || 0;
	        return Number(v.replace(/[\s$,]/g, "")) || 0;
	    };
	
	    (0, _react.useEffect)(function () {
	        var api = new _Api2.default({ token: token });
	
	        Promise.all([api.getCountryMapChart(), api.getCountryTopData()]).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                map = _ref3[0],
	                top = _ref3[1];
	
	            setTableData(Array.isArray(top) ? top : []);
	
	            // Если в карте нет строк — строим из top
	            var preparedMap = Array.isArray(map) ? map : [];
	            if (!(preparedMap.length > 1) && Array.isArray(top) && top.length > 0) {
	                preparedMap = [['Country', 'Transactions', 'SUM']].concat(_toConsumableArray(top.map(function (row) {
	                    return [row[0], Number(row[2]) || 0, parseMoney(row[1])];
	                })));
	            }
	
	            setChartData(preparedMap);
	        });
	    }, [token]);
	
	    return _react2.default.createElement(
	        _EmptyCard2.default,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Container },
	            chartData.length > 1 && tableData.length > 0 ? _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ChartColumn },
	                    _react2.default.createElement(_CountryChart2.default, { data: chartData })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.TableColumn },
	                    _react2.default.createElement(_CountryTop2.default, { data: tableData })
	                )
	            ) : _react2.default.createElement(_Empty2.default, null)
	        )
	    );
	});

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(200);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Empty() {
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Empty },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.EmptyText },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "EventsWidget.empty.message", defaultMessage: "\u0417\u0434\u0435\u0441\u044C \u0431\u0443\u0434\u0443\u0442 \u0432\u0430\u0436\u043D\u044B\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F" })
	        )
	    );
	}
	
	exports.default = Empty;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Empty = __webpack_require__(392);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(200);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EventsWidget() {
	    var openSupportWidget = function openSupportWidget(e) {
	        e.preventDefault();
	        window.dispatchEvent(new CustomEvent('open-support-widget'));
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Header },
	            _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "EventsWidget.title", defaultMessage: "\u0421\u043E\u0431\u044B\u0442\u0438\u044F" })
	            ),
	            _react2.default.createElement(
	                "a",
	                { className: _stylesModule2.default.Button, href: "#", onClick: openSupportWidget },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "EventsWidget.btn.createTicket", defaultMessage: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435" })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Content },
	            _react2.default.createElement(_Empty2.default, null)
	        )
	    );
	}
	
	exports.default = EventsWidget;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(201);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Support(_ref) {
	    var data = _ref.data;
	
	    var openSupportWidget = function openSupportWidget(e) {
	        e.preventDefault();
	        window.dispatchEvent(new CustomEvent('open-support-widget'));
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.SupportWrap },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.SupportManagers },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SupportTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Support.manager.title", defaultMessage: "\u0412\u0430\u0448 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440" })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _stylesModule2.default.SupportList },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "user-tie", size: "18px" }),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            data && data.display_name || ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "envelop", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink, href: "mailto:" + (data && data.email || "") },
	                            data && data.email || ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "phone1", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink,
	                                href: "tel:" + (data && data.phone && data.phone.replace(/[^\d;+]/g, "") || "") },
	                            data && data.phone || ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "mobile", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink, href: "tel:+79330922891" },
	                            "+7 (933) 092-28-91"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SupportTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Support.tech.title", defaultMessage: "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B" })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _stylesModule2.default.SupportList },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "envelop", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink, href: "mailto:support@unlimco.ru" },
	                            "support@unlimco.ru"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "phone1", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink, href: "tel:+79330922891" },
	                            "+7 (933) 092-28-91"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "lifebuoy", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink, href: "#", onClick: openSupportWidget },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Support.chat.button", defaultMessage: "\u0427\u0430\u0442 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "telegram", size: "20px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink,
	                                href: "https://t.me/sup_fintech",
	                                target: "_blank",
	                                rel: "noopener noreferrer" },
	                            "@sup_fintech"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SupportTitle },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Support.general.title", defaultMessage: "\u041E\u0431\u0449\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B" })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _stylesModule2.default.SupportList },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "phone1", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink, href: "tel:+79330922891" },
	                            "+7 (933) 092-28-91"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "lifebuoy", size: "18px" }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: _stylesModule2.default.SupportLink, href: "#", onClick: openSupportWidget },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Support.chat.button", defaultMessage: "\u0427\u0430\u0442 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438" })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.SupportTicket },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.TicketTitle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Support.ticket.title", defaultMessage: "\u041D\u0443\u0436\u043D\u0430 \u043F\u043E\u043C\u043E\u0449\u044C?" })
	            ),
	            _react2.default.createElement(
	                "a",
	                { className: _stylesModule2.default.Btn, href: "#", onClick: openSupportWidget },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: "add-outline", size: "16px" }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Support.ticket.create", defaultMessage: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435" })
	            )
	        )
	    );
	}
	
	exports.default = Support;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Dropdown = __webpack_require__(437);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Support = __webpack_require__(394);
	
	var _Support2 = _interopRequireDefault(_Support);
	
	var _menuConfig = __webpack_require__(94);
	
	var _stylesModule = __webpack_require__(201);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACCESS_LIST = {
	    TRANSACTION_CANCELLING: 1,
	    TRANSACTION_LIMIT_SETTING: 2,
	    STATISTICS_ACCESS: 4,
	    MAIL_ALERT_SETTING: 8,
	    PAYOUT_REGISTRY_PROCESS: 16,
	    PAYOUT_REGISTRY_VIEW: 32,
	    PAYOUT_REGISTRY_REPORT: 64,
	    PAYOUT_REGISTRIES_LIST: 128,
	    PREPAID_CARDS_VIEW: 256,
	    PREPAID_CARDS_ACTIVATE: 512,
	    STATISTICS_REPORT_1C_VIEW: 1024,
	    ACCESS_PAYOUTS: 2048,
	    ACCESS_METAL: 4096,
	    ACCESS_SBP_REGISTRY: 8192,
	    ACCESS_SBP_PAYOUT: 16384,
	    ACCESS_ANTIFRAUD_FILE: 32768,
	    ACCESS_ANTIFRAUD_SINGLE: 65536
	};
	
	function matchesPath(pathname, target) {
	    return pathname === target || pathname.startsWith(target + '/');
	}
	
	function useViewportWidth() {
	    var _useState = (0, _react.useState)(function () {
	        if (typeof window === 'undefined') return 0;
	        return window.innerWidth;
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        viewportWidth = _useState2[0],
	        setViewportWidth = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        function update() {
	            if (typeof window === 'undefined') return;
	            setViewportWidth(window.innerWidth);
	        }
	
	        update();
	        window.addEventListener('resize', update);
	        return function () {
	            return window.removeEventListener('resize', update);
	        };
	    }, []);
	
	    return viewportWidth;
	}
	
	function resolveTitle(title, context) {
	    if (typeof title === 'function') {
	        return resolveTitle(title(context), context);
	    }
	
	    if (_react2.default.isValidElement(title)) {
	        return title;
	    }
	
	    if (title && (typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object' && title.id) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: title.id, defaultMessage: title.defaultMessage || title.id });
	    }
	
	    return title;
	}
	
	/**
	 * Приписка у пункта меню: «бета» или число непрочитанных.
	 *
	 * Значение считается заранее: `item.badge` — функция, то есть всегда
	 * истинна, и проверка «есть ли badge» рисовала пустой кружок даже когда
	 * считать нечего. Отсюда прочерк рядом с пунктом «Чаты».
	 */
	function renderBadge(item, context) {
	    if (!item.badge) return null;
	
	    var value = resolveTitle(item.badge, context);
	    if (value === null || value === undefined || value === '') return null;
	
	    return _react2.default.createElement(
	        'span',
	        { className: _stylesModule2.default.Badge },
	        value
	    );
	}
	
	function getAccessMask(access) {
	    if (!Array.isArray(access)) return 0;
	    return access.reduce(function (sum, permission) {
	        return sum + ACCESS_LIST[permission];
	    }, 0);
	}
	
	function hasAccess(item, context) {
	    if (item.access === undefined || item.access === null || item.access === true) return true;
	
	    var accessMask = getAccessMask(item.access);
	
	    if (context.globalPrivileges !== null && context.globalPrivileges !== undefined) {
	        return (accessMask & context.globalPrivileges) > 0;
	    }
	
	    var currentAccess = 0;
	    if (context.accountAccessSettings) {
	        context.accountAccessSettings.forEach(function (setting) {
	            if (item.merchantUUID !== undefined) {
	                if (setting.merchantUUID === item.merchantUUID) currentAccess = setting.privileges;
	            } else if ((accessMask & setting.privileges) > 0) {
	                currentAccess = setting.privileges;
	            }
	        });
	    }
	
	    return (accessMask & currentAccess) > 0;
	}
	
	function renderNavContent(item, context, variant, onClick) {
	    if (item.type === 'link') {
	        var isTicketsLink = item.special === 'tickets';
	        var itemHasAccess = hasAccess(item, context);
	
	        if (!itemHasAccess && item.accessDenied === 'hide') {
	            return null;
	        }
	
	        var baseClassName = isTicketsLink ? _stylesModule2.default.TicketsLink : variant === 'drawer' ? _stylesModule2.default.DrawerLink : _stylesModule2.default.Link;
	        var linkClassName = itemHasAccess ? baseClassName : baseClassName + ' ' + _stylesModule2.default.LinkDisabled;
	        var handleClick = function handleClick(event) {
	            if (!itemHasAccess) {
	                event.preventDefault();
	                return;
	            }
	
	            if (onClick) onClick(event);
	        };
	
	        return _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            {
	                activeClassName: isTicketsLink ? _stylesModule2.default.TicketsActive : variant === 'drawer' ? _stylesModule2.default.Active : _stylesModule2.default.Active,
	                className: linkClassName,
	                exact: item.exact !== false,
	                to: item.to,
	                onClick: handleClick
	            },
	            _react2.default.createElement(_Icon2.default, {
	                className: isTicketsLink ? _stylesModule2.default.IconMessage : _stylesModule2.default.IconLeft,
	                icon: itemHasAccess ? item.icon : 'lock',
	                size: isTicketsLink ? '20px' : variant === 'drawer' ? '15px' : '16px'
	            }),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.LinkText },
	                item.title ? resolveTitle(item.title, context) : null
	            ),
	            renderBadge(item, context)
	        );
	    }
	
	    if (item.type === 'button') {
	        var _handleClick = item.action === 'logout' ? context.logout : onClick;
	
	        if (variant === 'desktop') {
	            return _react2.default.createElement(
	                'li',
	                { key: item.key, className: _stylesModule2.default.Link, onClick: _handleClick },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: item.icon, size: '18px' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.LinkText + ' ' + _stylesModule2.default.ProfileText },
	                    resolveTitle(item.title, context)
	                )
	            );
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { type: 'button', className: variant === 'drawer' ? _stylesModule2.default.DrawerButton : _stylesModule2.default.Link, onClick: _handleClick },
	            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: item.icon, size: variant === 'drawer' ? '18px' : '16px' }),
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.LinkText + ' ' + _stylesModule2.default.ProfileText },
	                resolveTitle(item.title, context)
	            )
	        );
	    }
	
	    if (item.type === 'custom') {
	        return item.render(context);
	    }
	
	    return null;
	}
	
	function renderListItem(item, context, variant, onClick) {
	    if (!item) return null;
	
	    if (item.type === 'link') {
	        var content = renderNavContent(item, context, variant, onClick);
	        return content ? _react2.default.createElement(
	            'li',
	            { key: item.key },
	            content
	        ) : null;
	    }
	
	    if (item.type === 'button') {
	        return _react2.default.createElement(
	            'li',
	            { key: item.key },
	            renderNavContent(item, context, variant, onClick)
	        );
	    }
	
	    if (item.type === 'custom') {
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            { key: item.key },
	            renderNavContent(item, context, variant, onClick)
	        );
	    }
	
	    return null;
	}
	
	function renderDropdownChildren(items, context, onClick, variant) {
	    return items.map(function (item) {
	        return renderListItem(item, context, variant, onClick);
	    });
	}
	
	function renderGroupContent(group, context, onClick, variant) {
	    if (group.content === 'support') {
	        return _react2.default.createElement(_Support2.default, { data: context.manager });
	    }
	
	    return _react2.default.createElement(
	        'ul',
	        { className: _stylesModule2.default.DrawerSubmenu },
	        renderDropdownChildren(group.items || [], context, onClick, variant)
	    );
	}
	
	function getActiveGroupKey(pathname, groups) {
	    var activeGroup = groups.find(function (group) {
	        return Array.isArray(group.paths) && group.paths.some(function (path) {
	            return matchesPath(pathname, path);
	        });
	    });
	    return activeGroup ? activeGroup.key : null;
	}
	
	function renderDesktopGroup(group, context, onClick) {
	    var resolvedTitle = resolveTitle(group.title, context);
	    // Точка у профиля: раздел чатов спрятан внутри этого меню, и без метки
	    // снаружи новое сообщение остаётся незамеченным.
	    var hasChatMark = group.key === 'profile' && Number(context.secretChatUnread || 0) > 0;
	    var titleNode = group.key === 'profile' ? _react2.default.createElement(
	        'span',
	        { className: _stylesModule2.default.ProfileTitle },
	        resolvedTitle,
	        hasChatMark ? _react2.default.createElement('span', { className: _stylesModule2.default.UnreadDot }) : null
	    ) : resolvedTitle;
	
	    return _react2.default.createElement(
	        _Dropdown2.default,
	        {
	            key: group.key,
	            title: titleNode,
	            icon: group.icon,
	            isHeader: group.isHeader,
	            isFullWidth: group.isFullWidth,
	            submenuVariant: group.submenuVariant,
	            useLocale: false
	        },
	        group.content === 'support' ? renderGroupContent(group, context, onClick, 'desktop') : renderDropdownChildren(group.items || [], context, onClick, 'desktop')
	    );
	}
	
	function getTicketsItem(items) {
	    return items.find(function (item) {
	        return item.type === 'link' && item.special === 'tickets';
	    }) || null;
	}
	
	function renderDrawerGroup(group, context, openedSection, setOpenedSection, onClick) {
	    var isOpen = openedSection === group.key;
	    var isActive = Array.isArray(group.paths) && group.paths.some(function (path) {
	        return matchesPath(context.pathname, path);
	    });
	
	    return _react2.default.createElement(
	        'li',
	        { key: group.key },
	        _react2.default.createElement(
	            'button',
	            {
	                type: 'button',
	                className: '' + _stylesModule2.default.DrawerToggle + (isActive ? ' ' + _stylesModule2.default.DrawerToggleActive : ''),
	                onClick: function onClick() {
	                    return setOpenedSection(function (current) {
	                        return current === group.key ? null : group.key;
	                    });
	                },
	                'aria-expanded': isOpen
	            },
	            _react2.default.createElement(
	                'span',
	                { className: _stylesModule2.default.DrawerToggleLabel },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: group.icon, size: '15px' }),
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.LinkText },
	                    resolveTitle(group.title, context)
	                )
	            ),
	            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconRight, icon: 'cheveron-down', size: '16px' })
	        ),
	        isOpen && renderGroupContent(group, context, onClick, 'drawer')
	    );
	}
	
	function HeaderMenu(_ref) {
	    var token = _ref.token,
	        logout = _ref.logout,
	        isAuthorized = _ref.isAuthorized,
	        adminPrivileges = _ref.adminPrivileges,
	        accountAccessSettings = _ref.accountAccessSettings,
	        globalPrivileges = _ref.globalPrivileges,
	        menuConfig = _ref.menuConfig,
	        _ref$mode = _ref.mode,
	        mode = _ref$mode === undefined ? 'top' : _ref$mode;
	
	    var location = (0, _reactRouterDom.useLocation)();
	    var intl = (0, _reactIntl.useIntl)();
	    var viewportWidth = useViewportWidth();
	    var isMobile = viewportWidth > 0 ? viewportWidth <= 768 : false;
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        user = _useState4[0],
	        setUser = _useState4[1];
	
	    var _useState5 = (0, _react.useState)({}),
	        _useState6 = _slicedToArray(_useState5, 2),
	        manager = _useState6[0],
	        setManager = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(true),
	        _useState8 = _slicedToArray(_useState7, 2),
	        setLoading = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        setError = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isBurgerOpen = _useState12[0],
	        setIsBurgerOpen = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(null),
	        _useState14 = _slicedToArray(_useState13, 2),
	        openedSection = _useState14[0],
	        setOpenedSection = _useState14[1];
	
	    var resolvedMenuConfig = (0, _react.useMemo)(function () {
	        return menuConfig || (0, _menuConfig.createDefaultHeaderMenuConfig)({ adminPrivileges: adminPrivileges });
	    }, [adminPrivileges, menuConfig]);
	
	    var isTopMode = mode !== 'nav';
	
	    (0, _react.useEffect)(function () {
	        if (!isTopMode || !isAuthorized) return undefined;
	
	        var users = new _Api2.default({ token: token }).getUserData();
	
	        if (adminPrivileges) {
	            users.then(function (data) {
	                setUser(data);
	                setLoading(false);
	                setError(false);
	            }).catch(function (err) {
	                console.error('Error loading admin data:', err);
	                setLoading(false);
	                setError(true);
	            });
	
	            return undefined;
	        }
	
	        var managerPromise = new _Api2.default({ token: token }).getPersonalManager();
	
	        Promise.all([users, managerPromise]).then(function (data) {
	            setUser(data[0]);
	            setManager(data[1]);
	            setLoading(false);
	            setError(false);
	        }).catch(function (err) {
	            console.error('Error loading user data:', err);
	            setLoading(false);
	            setError(true);
	        });
	
	        return undefined;
	    }, [adminPrivileges, isAuthorized, isTopMode, token]);
	    // Непрочитанные сообщения секретного чата. Раздел лежит внутри меню
	    // профиля, поэтому без пометки человек узнавал бы об ответе, только
	    // заглянув туда сам, — а переписка живёт сутки и исчезает.
	
	    var _useState15 = (0, _react.useState)(0),
	        _useState16 = _slicedToArray(_useState15, 2),
	        secretChatUnread = _useState16[0],
	        setSecretChatUnread = _useState16[1];
	
	    (0, _react.useEffect)(function () {
	        if (!isAuthorized || !token) return undefined;
	
	        var cancelled = false;
	
	        var load = function load() {
	            var api = new _Api2.default({ token: token });
	            // Сотрудник тоже бывает собеседником: у него есть и свои чаты, и
	            // чужие. Спрашиваем обе стороны и складываем — иначе админ видел
	            // только клиентские сообщения и пропускал ответы на свои.
	            var requests = [api.getSecretChatsUnreadCount().catch(function () {
	                return null;
	            })];
	
	            if (adminPrivileges) {
	                requests.push(api.getAdminSecretChatsUnreadCount().catch(function () {
	                    return null;
	                }));
	            }
	
	            Promise.all(requests).then(function (answers) {
	                if (cancelled) return;
	                setSecretChatUnread(answers.reduce(function (sum, data) {
	                    return sum + Number(data && data.count || 0);
	                }, 0));
	            }).catch(function () {
	                // Молча: пометка вспомогательная, ронять шапку из-за неё нельзя.
	            });
	        };
	
	        load();
	        var timer = setInterval(load, 15000);
	
	        return function () {
	            cancelled = true;
	            clearInterval(timer);
	        };
	    }, [adminPrivileges, isAuthorized, token]);
	
	    (0, _react.useEffect)(function () {
	        if (!isTopMode) return undefined;
	        setIsBurgerOpen(false);
	        setOpenedSection(null);
	    }, [isTopMode, location.pathname]);
	
	    var drawerSections = resolvedMenuConfig.drawer.sections || [];
	    var drawerFooterItems = resolvedMenuConfig.drawer.footerItems || [];
	    var drawerFooterTitle = resolvedMenuConfig.drawer.footerTitle;
	
	    (0, _react.useEffect)(function () {
	        if (!isTopMode) return undefined;
	        if (!isBurgerOpen || !isMobile) return undefined;
	
	        setOpenedSection(getActiveGroupKey(location.pathname, drawerSections));
	        return undefined;
	    }, [drawerSections, isBurgerOpen, isMobile, isTopMode, location.pathname]);
	
	    (0, _react.useEffect)(function () {
	        if (!isTopMode) return undefined;
	        if (!isBurgerOpen || !isMobile) {
	            document.body.style.overflow = '';
	            return undefined;
	        }
	
	        document.body.style.overflow = 'hidden';
	
	        var handleKeyDown = function handleKeyDown(event) {
	            if (event.key === 'Escape') {
	                setIsBurgerOpen(false);
	            }
	        };
	
	        document.addEventListener('keydown', handleKeyDown);
	
	        return function () {
	            document.body.style.overflow = '';
	            document.removeEventListener('keydown', handleKeyDown);
	        };
	    }, [isBurgerOpen, isMobile, isTopMode]);
	
	    if (isTopMode && !isAuthorized) {
	        return null;
	    }
	
	    var closeDrawer = function closeDrawer() {
	        return setIsBurgerOpen(false);
	    };
	    if (!isTopMode) {
	        var desktopLeftItems = resolvedMenuConfig.desktop.leftItems || [];
	        var navContext = {
	            pathname: location.pathname,
	            logout: logout,
	            adminPrivileges: adminPrivileges,
	            accountAccessSettings: accountAccessSettings,
	            globalPrivileges: globalPrivileges,
	            secretChatUnread: secretChatUnread
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { className: '' + _stylesModule2.default.Root + (adminPrivileges ? ' ' + _stylesModule2.default.AdminMode : '') + ' ' + _stylesModule2.default.NavMode },
	            _react2.default.createElement(
	                'ul',
	                { className: _stylesModule2.default.Menu },
	                desktopLeftItems.map(function (item) {
	                    if (item.type === 'group' || item.type === 'dropdown') {
	                        return renderDesktopGroup(item, navContext, closeDrawer);
	                    }
	
	                    return renderListItem(item, navContext, 'desktop', closeDrawer);
	                })
	            )
	        );
	    }
	
	    var safeUser = user || {};
	    var profileName = [safeUser.firstName, safeUser.lastName].filter(Boolean).join(' ') || intl.formatMessage({ id: 'HeaderMenu.list.profile', defaultMessage: 'Профиль' });
	    var desktopRightItems = resolvedMenuConfig.desktop.rightItems || [];
	    var ticketsItem = getTicketsItem(desktopRightItems);
	    var context = {
	        user: safeUser,
	        manager: manager,
	        profileName: profileName,
	        pathname: location.pathname,
	        logout: logout,
	        adminPrivileges: adminPrivileges,
	        accountAccessSettings: accountAccessSettings,
	        globalPrivileges: globalPrivileges,
	        secretChatUnread: secretChatUnread
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: '' + _stylesModule2.default.Root + (adminPrivileges ? ' ' + _stylesModule2.default.AdminMode : '') },
	        desktopRightItems.length > 0 && _react2.default.createElement(
	            'ul',
	            { className: _stylesModule2.default.DesktopActions },
	            desktopRightItems.map(function (item) {
	                if (item.type === 'group' || item.type === 'dropdown') {
	                    return renderDesktopGroup(item, context, closeDrawer);
	                }
	
	                return renderListItem(item, context, 'desktop', closeDrawer);
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.MobileActions },
	            ticketsItem && renderNavContent(ticketsItem, context, 'desktop', closeDrawer),
	            _react2.default.createElement(
	                'button',
	                {
	                    type: 'button',
	                    className: _stylesModule2.default.BurgerButton,
	                    onClick: function onClick() {
	                        return setIsBurgerOpen(function (value) {
	                            return !value;
	                        });
	                    },
	                    'aria-label': isBurgerOpen ? intl.formatMessage({ id: 'HeaderMenu.list.closeMenu', defaultMessage: 'Закрыть меню' }) : intl.formatMessage({ id: 'HeaderMenu.list.openMenu', defaultMessage: 'Открыть меню' }),
	                    'aria-expanded': isBurgerOpen
	                },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.BurgerIcon, icon: isBurgerOpen ? 'close' : 'menu', size: '20px' })
	            )
	        ),
	        isMobile && isBurgerOpen && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Overlay, onClick: closeDrawer },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Drawer, onClick: function onClick(event) {
	                        return event.stopPropagation();
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.DrawerSection },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _stylesModule2.default.DrawerMenu },
	                        resolvedMenuConfig.drawer.sections.map(function (item) {
	                            if (item.type === 'group' || item.type === 'dropdown') {
	                                return renderDrawerGroup(item, context, openedSection, setOpenedSection, closeDrawer);
	                            }
	
	                            return renderListItem(item, context, 'drawer', closeDrawer);
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.DrawerSection },
	                    drawerFooterTitle && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.DrawerProfileName },
	                        resolveTitle(drawerFooterTitle, context)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.DrawerFooterLinks },
	                        drawerFooterItems.map(function (item) {
	                            if (item.type === 'group' || item.type === 'dropdown') {
	                                return renderDesktopGroup(item, context, closeDrawer);
	                            }
	
	                            if (item.type === 'button') {
	                                return _react2.default.createElement(
	                                    'button',
	                                    {
	                                        key: item.key,
	                                        type: 'button',
	                                        className: _stylesModule2.default.DrawerButton,
	                                        onClick: logout
	                                    },
	                                    _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: item.icon, size: '18px' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _stylesModule2.default.LinkText + ' ' + _stylesModule2.default.ProfileText },
	                                        resolveTitle(item.title, context)
	                                    )
	                                );
	                            }
	
	                            return _react2.default.createElement(
	                                _react2.default.Fragment,
	                                { key: item.key },
	                                renderNavContent(item, context, 'drawer', closeDrawer)
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(HeaderMenu);

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(554);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LanguageSelect = function (_Component) {
	    _inherits(LanguageSelect, _Component);
	
	    function LanguageSelect(props) {
	        _classCallCheck(this, LanguageSelect);
	
	        var _this = _possibleConstructorReturn(this, (LanguageSelect.__proto__ || Object.getPrototypeOf(LanguageSelect)).call(this, props));
	
	        _this.handleClickOutside = function (e) {
	            if (!_this.langSelect.current || !_this.langWrap.current.contains(e.target)) {
	                _this.setState({
	                    isOpened: false
	                });
	            }
	        };
	
	        _this.state = {
	            isOpened: false
	        };
	
	        _this.toggleState = _this.toggleState.bind(_this);
	        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	
	        _this.langWrap = (0, _react.createRef)();
	        _this.langSelect = (0, _react.createRef)();
	        return _this;
	    }
	
	    _createClass(LanguageSelect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(_prevProps, _prevState, _snapshot) {
	            document.addEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: 'toggleState',
	        value: function toggleState() {
	            this.setState({ isOpened: !this.state.isOpened });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var intl = this.props.intl;
	
	            var currentLanguage = void 0;
	            var langClass = void 0;
	
	            switch (this.props.lang) {
	                case 'ru':
	                    currentLanguage = intl.formatMessage({ id: 'LanguageSelect.language.ru', defaultMessage: 'Русский' });
	                    langClass = _stylesModule2.default.Ru;
	                    break;
	                case 'en':
	                    currentLanguage = intl.formatMessage({ id: 'LanguageSelect.language.en', defaultMessage: 'English' });
	                    langClass = _stylesModule2.default.En;
	                    break;
	                default:
	                    currentLanguage = intl.formatMessage({ id: 'LanguageSelect.language.en', defaultMessage: 'English' });
	                    langClass = _stylesModule2.default.En;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { ref: this.langWrap, className: _stylesModule2.default.Lang },
	                _react2.default.createElement(
	                    'div',
	                    { onClick: this.toggleState, className: _stylesModule2.default.Current + ' ' + langClass },
	                    currentLanguage
	                ),
	                this.state.isOpened && _react2.default.createElement(
	                    'div',
	                    { ref: this.langSelect, className: _stylesModule2.default.Select },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            onClick: function onClick() {
	                                _this2.props.onChangeLanguage('ru');
	                                _this2.toggleState();
	                            },
	                            className: _stylesModule2.default.Element + ' ' + _stylesModule2.default.Ru
	                        },
	                        intl.formatMessage({ id: 'LanguageSelect.language.ru', defaultMessage: 'Русский' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            onClick: function onClick() {
	                                _this2.props.onChangeLanguage('en');
	                                _this2.toggleState();
	                            },
	                            className: _stylesModule2.default.Element + ' ' + _stylesModule2.default.En
	                        },
	                        intl.formatMessage({ id: 'LanguageSelect.language.en', defaultMessage: 'English' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LanguageSelect;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(LanguageSelect);

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(555);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _cacheClear = __webpack_require__(701);
	
	var _cacheClear2 = _interopRequireDefault(_cacheClear);
	
	var _eClear_logo = __webpack_require__(702);
	
	var _eClear_logo2 = _interopRequireDefault(_eClear_logo);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginForm = (0, _Auth.withAuth)(function (_ref) {
	    var isAuthorized = _ref.isAuthorized,
	        adminPrivileges = _ref.adminPrivileges,
	        forcedPasswordChange = _ref.forcedPasswordChange,
	        isRemember = _ref.isRemember,
	        authorize = _ref.authorize,
	        remember = _ref.remember;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)(""),
	        _useState2 = _slicedToArray(_useState, 2),
	        email = _useState2[0],
	        setEmail = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        psw = _useState4[0],
	        setPsw = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(""),
	        _useState6 = _slicedToArray(_useState5, 2),
	        code = _useState6[0],
	        setCode = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        isMFA = _useState8[0],
	        setIsMFA = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({ OTPProvider: "", OTPEmail: "", OTPPhoneNumber: "" }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        mfaData = _useState10[0],
	        setMFAData = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(0),
	        _useState12 = _slicedToArray(_useState11, 2),
	        validTime = _useState12[0],
	        setValidTime = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        isTimeLeft = _useState14[0],
	        setIsTimeLeft = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(null),
	        _useState16 = _slicedToArray(_useState15, 2),
	        modalType = _useState16[0],
	        setModalType = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(""),
	        _useState18 = _slicedToArray(_useState17, 2),
	        recoveryEmail = _useState18[0],
	        setRecoveryEmail = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(""),
	        _useState20 = _slicedToArray(_useState19, 2),
	        recoveryCode = _useState20[0],
	        setRecoveryCode = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(1),
	        _useState22 = _slicedToArray(_useState21, 2),
	        recoveryStep = _useState22[0],
	        setRecoveryStep = _useState22[1]; // 1-email, 2-code
	
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        loading = _useState24[0],
	        setLoading = _useState24[1];
	
	    (0, _react.useEffect)(function () {
	        var timer;
	        if (isMFA && validTime > 0) {
	            timer = setTimeout(function () {
	                setValidTime(validTime - 1);
	            }, 1000);
	        } else if (isMFA && validTime === 0) {
	            setIsTimeLeft(true);
	        }
	        return function () {
	            clearTimeout(timer);
	        };
	    }, [validTime, isMFA]);
	
	    function login() {
	        if (!email.trim() || !psw.trim()) {
	            onMessage({
	                type: "warning",
	                message: intl.formatMessage({ id: "LoginForm.error.empty" })
	            });
	            return;
	        }
	
	        new _Api2.default().login({ username: email, password: psw, code: code }).then(function (r) {
	            if (r && r.token) {
	                authorize(r.token, isRemember);
	            } else if (r && r.mfa) {
	                setIsMFA(true);
	                setMFAData(r);
	                setValidTime(r.OTPCodeTimeLeft || 120);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            // Заблокированной учётке честно говорим, в чём дело: иначе
	            // человек будет без конца перебирать верный пароль.
	            var reason = err && err.response && err.response.data && err.response.data.reason;
	            onMessage({
	                type: "error",
	                message: intl.formatMessage({
	                    id: reason === "account_blocked" ? "LoginForm.error.blocked" : "LoginForm.error.credentials"
	                })
	            });
	        });
	    }
	
	    function submitHandler(e) {
	        e.preventDefault();
	        login();
	    }
	
	    function sendPasswordRecovery() {
	        if (!recoveryEmail.trim()) {
	            onMessage({
	                type: "warning",
	                message: intl.formatMessage({ id: "LoginForm.recovery.error.emailRequired" })
	            });
	            return;
	        }
	
	        setLoading(true);
	
	        new _Api2.default().passwordResetRequest(recoveryEmail).then(function () {
	            onMessage({
	                type: "success",
	                message: intl.formatMessage({ id: "LoginForm.recovery.success.codeSent" })
	            });
	            setRecoveryStep(2);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({
	                type: "error",
	                message: intl.formatMessage({ id: "LoginForm.recovery.error.sendCode" })
	            });
	        }).finally(function () {
	            setLoading(false);
	        });
	    }
	
	    function verifyRecoveryCode() {
	        if (!recoveryCode.trim()) {
	            onMessage({
	                type: "warning",
	                message: intl.formatMessage({ id: "LoginForm.recovery.error.codeRequired" })
	            });
	            return;
	        }
	
	        setLoading(true);
	
	        new _Api2.default().passwordResetVerify(recoveryEmail, recoveryCode).then(function (r) {
	            if (r && r.success) {
	                onMessage({
	                    type: "success",
	                    message: intl.formatMessage({ id: "LoginForm.recovery.success.passwordSent" })
	                });
	                setModalType(null);
	                setRecoveryStep(1);
	                setRecoveryEmail("");
	                setRecoveryCode("");
	            } else {
	                onMessage({
	                    type: "error",
	                    message: r.message || intl.formatMessage({ id: "LoginForm.recovery.error.invalidCode" })
	                });
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({
	                type: "error",
	                message: intl.formatMessage({ id: "LoginForm.recovery.error.verifyCode" })
	            });
	        }).finally(function () {
	            setLoading(false);
	        });
	    }
	
	    function sendAgain() {
	        setIsTimeLeft(false);
	        setValidTime(120);
	        login();
	    }
	
	    if (isAuthorized) {
	        if (adminPrivileges) return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/console" });
	        if (forcedPasswordChange) return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/profile" });
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/" });
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            "form",
	            { onSubmit: submitHandler },
	            _react2.default.createElement("img", {
	                className: _stylesModule2.default.Logo,
	                width: "90",
	                height: "90",
	                src: _eClear_logo2.default,
	                alt: intl.formatMessage({ id: "LoginForm.logo.alt" })
	            }),
	            _react2.default.createElement(
	                "h2",
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "LoginForm.title.login", defaultMessage: "\u0412\u0445\u043E\u0434 \u0432 \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442" })
	            ),
	            isMFA && (!isTimeLeft ? _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.Text },
	                    mfaData.OTPProvider === "email" && _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "LoginForm.text.mfaEmailMessage",
	                        values: {
	                            type: _react2.default.createElement(
	                                "b",
	                                null,
	                                mfaData.OTPProvider
	                            ),
	                            email: _react2.default.createElement(
	                                "b",
	                                null,
	                                mfaData.OTPEmail
	                            )
	                        },
	                        defaultMessage: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0438\u0437 {type}-\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u043D\u0430 {email}"
	                    }),
	                    mfaData.OTPProvider === "sms" && _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "LoginForm.text.mfaPhoneMessage",
	                        values: {
	                            type: _react2.default.createElement(
	                                "b",
	                                null,
	                                mfaData.OTPProvider
	                            ),
	                            phone: _react2.default.createElement(
	                                "b",
	                                null,
	                                mfaData.OTPPhoneNumber
	                            )
	                        },
	                        defaultMessage: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0438\u0437 {type}-\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u043D\u0430 \u043D\u043E\u043C\u0435\u0440 {phone}"
	                    }),
	                    mfaData.OTPProvider === "gauth" && _react2.default.createElement(_reactIntl.FormattedMessage, { id: "LoginForm.text.mfaGAuthMessage",
	                        defaultMessage: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0438\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F Google Authenticator" })
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: "LoginForm.placeholder.code", defaultMessage: "\u041A\u043E\u0434" },
	                    function (placeholder) {
	                        return _react2.default.createElement("input", {
	                            type: "text",
	                            className: _stylesModule2.default.Input,
	                            autoComplete: "off",
	                            placeholder: placeholder,
	                            value: code,
	                            onChange: function onChange(e) {
	                                return setCode(e.target.value);
	                            }
	                        });
	                    }
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.Btn },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "LoginForm.btn.continue", defaultMessage: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C" })
	                ),
	                validTime > 0 && _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Time },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "LoginForm.text.codeValid",
	                        defaultMessage: "\u041A\u043E\u0434 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0435\u0449\u0435 {seconds} \u0441\u0435\u043A\u0443\u043D\u0434",
	                        values: { seconds: validTime }
	                    })
	                )
	            ) : _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.TimeLeft },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "LoginForm.text.codeExpired",
	                        defaultMessage: "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u043E\u0434\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0438\u0441\u0442\u0435\u043A." })
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { onClick: sendAgain, className: _stylesModule2.default.Btn },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "LoginForm.btn.sendAgain", defaultMessage: "\u0412\u044B\u0441\u043B\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437" })
	                )
	            )),
	            !isMFA && _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: "LoginForm.placeholder.email", defaultMessage: "\u0418\u043C\u044F \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438" },
	                    function (placeholder) {
	                        return _react2.default.createElement("input", {
	                            className: _stylesModule2.default.Input,
	                            placeholder: placeholder,
	                            value: email,
	                            onChange: function onChange(e) {
	                                setEmail(e.target.value);
	                            }
	                        });
	                    }
	                ),
	                _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: "LoginForm.placeholder.password", defaultMessage: "\u041F\u0430\u0440\u043E\u043B\u044C" },
	                    function (placeholder) {
	                        return _react2.default.createElement("input", {
	                            type: "password",
	                            className: _stylesModule2.default.Input,
	                            placeholder: placeholder,
	                            value: psw,
	                            onChange: function onChange(e) {
	                                setPsw(e.target.value);
	                            }
	                        });
	                    }
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Row },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormCheck },
	                        _react2.default.createElement("input", {
	                            id: "rememberMe",
	                            type: "checkbox",
	                            checked: !!isRemember,
	                            onChange: remember
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "rememberMe", className: _stylesModule2.default.Checkbox },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Square },
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    _react2.default.createElement(_Icon2.default, { icon: "checkmark", size: "13px" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                intl.formatMessage({ id: "LoginForm.label.remember" })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.Btn },
	                    intl.formatMessage({ id: "LoginForm.btn.login" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.HelpLinks },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button",
	                            onClick: function onClick() {
	                                setModalType("forgot");
	                            },
	                            className: _stylesModule2.default.LinkBtn
	                        },
	                        intl.formatMessage({ id: "LoginForm.link.forgotPassword" })
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button",
	                            onClick: function onClick() {
	                                setModalType("cant");
	                            },
	                            className: _stylesModule2.default.LinkBtn
	                        },
	                        intl.formatMessage({ id: "LoginForm.link.cantLogin" })
	                    )
	                )
	            )
	        ),
	        modalType && _react2.default.createElement(
	            "div",
	            {
	                className: _stylesModule2.default.ModalOverlay,
	                onClick: function onClick() {
	                    setModalType(null);
	                }
	            },
	            _react2.default.createElement(
	                "div",
	                {
	                    className: _stylesModule2.default.Modal,
	                    onClick: function onClick(e) {
	                        e.stopPropagation();
	                    }
	                },
	                _react2.default.createElement(
	                    "button",
	                    {
	                        type: "button",
	                        className: _stylesModule2.default.ModalClose,
	                        onClick: function onClick() {
	                            setModalType(null);
	                        },
	                        "aria-label": intl.formatMessage({ id: "LoginForm.modal.close" })
	                    },
	                    "\xD7"
	                ),
	                modalType === "cant" && _react2.default.createElement(
	                    _react.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        intl.formatMessage({ id: "LoginForm.modal.cantLogin.title" })
	                    ),
	                    _react2.default.createElement(
	                        "ol",
	                        { className: _stylesModule2.default.ModalList },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            intl.formatMessage({ id: "LoginForm.modal.cantLogin.step.clearCache" })
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            intl.formatMessage({ id: "LoginForm.modal.cantLogin.step.clearSiteData" }),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.ScreenshotPlaceholder },
	                                _react2.default.createElement("img", {
	                                    src: _cacheClear2.default,
	                                    alt: intl.formatMessage({ id: "LoginForm.modal.cantLogin.alt.clearSiteData" })
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            intl.formatMessage({ id: "LoginForm.modal.cantLogin.step.contactSupport" }),
	                            " ",
	                            _react2.default.createElement(
	                                "a",
	                                { href: "https://t.me/sup_fintech", target: "_blank", rel: "noreferrer" },
	                                "https://t.me/sup_fintech"
	                            )
	                        )
	                    )
	                ),
	                modalType === "forgot" && _react2.default.createElement(
	                    _react.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        intl.formatMessage({ id: "LoginForm.modal.forgotPassword.title" })
	                    ),
	                    recoveryStep === 1 && _react2.default.createElement(
	                        _react.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            _reactIntl.FormattedMessage,
	                            {
	                                id: "LoginForm.modal.forgotPassword.placeholder.email",
	                                defaultMessage: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430"
	                            },
	                            function (placeholder) {
	                                return _react2.default.createElement("input", {
	                                    className: _stylesModule2.default.Input,
	                                    placeholder: placeholder,
	                                    value: recoveryEmail,
	                                    onChange: function onChange(e) {
	                                        setRecoveryEmail(e.target.value);
	                                    }
	                                });
	                            }
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                className: _stylesModule2.default.Btn,
	                                disabled: loading,
	                                onClick: sendPasswordRecovery
	                            },
	                            intl.formatMessage({ id: "LoginForm.modal.forgotPassword.btn.sendCode" })
	                        )
	                    ),
	                    recoveryStep === 2 && _react2.default.createElement(
	                        _react.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            _reactIntl.FormattedMessage,
	                            {
	                                id: "LoginForm.modal.forgotPassword.placeholder.code",
	                                defaultMessage: "\u041A\u043E\u0434 \u0438\u0437 \u043F\u0438\u0441\u044C\u043C\u0430"
	                            },
	                            function (placeholder) {
	                                return _react2.default.createElement("input", {
	                                    className: _stylesModule2.default.Input,
	                                    placeholder: placeholder,
	                                    value: recoveryCode,
	                                    onChange: function onChange(e) {
	                                        setRecoveryCode(e.target.value);
	                                    }
	                                });
	                            }
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                className: _stylesModule2.default.Btn,
	                                disabled: loading,
	                                onClick: verifyRecoveryCode
	                            },
	                            intl.formatMessage({ id: "LoginForm.modal.forgotPassword.btn.verifyCode" })
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = LoginForm;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(557);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * MerchantSettingsFeesTab — комиссии на уровне MerchantSettings.
	 *
	 * Отдельно от Terminal fees. MS fees — это комиссия для конкретного мерчанта,
	 * Terminal fees — для провайдера.
	 *
	 * Props:
	 *   token (string)
	 *   terminal (object) — { id, projectUuid, ... }
	 */
	function MerchantSettingsFeesTab(props) {
	    var token = props.token;
	    var terminal = props.terminal;
	
	    var _msList = (0, _react.useState)([]);
	    var msList = _msList[0];
	    var setMsList = _msList[1];
	
	    var _selectedMsId = (0, _react.useState)(null);
	    var selectedMsId = _selectedMsId[0];
	    var setSelectedMsId = _selectedMsId[1];
	
	    var _payment = (0, _react.useState)({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
	    var payment = _payment[0];
	    var setPayment = _payment[1];
	
	    var _payout = (0, _react.useState)({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
	    var payout = _payout[0];
	    var setPayout = _payout[1];
	
	    var _refund = (0, _react.useState)({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
	    var refund = _refund[0];
	    var setRefund = _refund[1];
	
	    var _saving = (0, _react.useState)(false);
	    var saving = _saving[0];
	    var setSaving = _saving[1];
	
	    var _loading = (0, _react.useState)(true);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _status = (0, _react.useState)(null);
	    var status = _status[0];
	    var setStatus = _status[1];
	
	    // Загрузить MS список через /merchant/{uuid}/full
	    (0, _react.useEffect)(function () {
	        if (!terminal || !terminal.id || !terminal.projectUuid) return;
	        setLoading(true);
	        setStatus(null);
	
	        var api = new _Api2.default({ token: token });
	        api.getFullMerchant(terminal.projectUuid).then(function (data) {
	            var settings = data && data.settings || [];
	            // Фильтруем только MS привязанные к этому терминалу
	            var filtered = settings.filter(function (s) {
	                return s.terminalId === terminal.id;
	            });
	            setMsList(filtered);
	
	            if (filtered.length > 0) {
	                setSelectedMsId(filtered[0].id);
	                loadFeesFromMs(filtered[0]);
	            }
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setLoading(false);
	            setStatus({ type: "error", text: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A" });
	        });
	    }, [terminal && terminal.id, terminal && terminal.projectUuid, token]);
	
	    function loadFeesFromMs(ms) {
	        var fee = ms.fee || {};
	        setPayment({
	            cost: String(fee.payment && fee.payment.cost != null ? fee.payment.cost : ""),
	            fixedPerTransaction: String(fee.payment && fee.payment.fixedPerTransaction != null ? fee.payment.fixedPerTransaction : ""),
	            costFixedMinimum: String(fee.payment && fee.payment.costFixedMinimum != null ? fee.payment.costFixedMinimum : "")
	        });
	        setPayout({
	            cost: String(fee.payout && fee.payout.cost != null ? fee.payout.cost : ""),
	            fixedPerTransaction: String(fee.payout && fee.payout.fixedPerTransaction != null ? fee.payout.fixedPerTransaction : ""),
	            costFixedMinimum: String(fee.payout && fee.payout.costFixedMinimum != null ? fee.payout.costFixedMinimum : "")
	        });
	        setRefund({
	            cost: String(fee.refund && fee.refund.cost != null ? fee.refund.cost : ""),
	            fixedPerTransaction: String(fee.refund && fee.refund.fixedPerTransaction != null ? fee.refund.fixedPerTransaction : ""),
	            costFixedMinimum: String(fee.refund && fee.refund.costFixedMinimum != null ? fee.refund.costFixedMinimum : "")
	        });
	    }
	
	    function onMsChange(e) {
	        var id = parseInt(e.target.value, 10);
	        setSelectedMsId(id);
	        setStatus(null);
	        var ms = msList.find(function (s) {
	            return s.id === id;
	        });
	        if (ms) loadFeesFromMs(ms);
	    }
	
	    function onFieldChange(group, field, value) {
	        if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;
	
	        if (group === "payment") {
	            var next = {};
	            for (var k in payment) {
	                next[k] = payment[k];
	            }
	            next[field] = value;
	            setPayment(next);
	        } else if (group === "payout") {
	            var next2 = {};
	            for (var k2 in payout) {
	                next2[k2] = payout[k2];
	            }
	            next2[field] = value;
	            setPayout(next2);
	        } else if (group === "refund") {
	            var next3 = {};
	            for (var k3 in refund) {
	                next3[k3] = refund[k3];
	            }
	            next3[field] = value;
	            setRefund(next3);
	        }
	    }
	
	    function onSave() {
	        if (!selectedMsId || !terminal.projectUuid) return;
	        setSaving(true);
	        setStatus(null);
	
	        var fee = {
	            payment: {
	                cost: payment.cost !== "" ? parseFloat(payment.cost) : 0,
	                fixedPerTransaction: payment.fixedPerTransaction !== "" ? parseFloat(payment.fixedPerTransaction) : 0,
	                costFixedMinimum: payment.costFixedMinimum !== "" ? parseFloat(payment.costFixedMinimum) : 0
	            },
	            payout: {
	                cost: payout.cost !== "" ? parseFloat(payout.cost) : 0,
	                fixedPerTransaction: payout.fixedPerTransaction !== "" ? parseFloat(payout.fixedPerTransaction) : 0,
	                costFixedMinimum: payout.costFixedMinimum !== "" ? parseFloat(payout.costFixedMinimum) : 0
	            },
	            refund: {
	                cost: refund.cost !== "" ? parseFloat(refund.cost) : 0,
	                fixedPerTransaction: refund.fixedPerTransaction !== "" ? parseFloat(refund.fixedPerTransaction) : 0,
	                costFixedMinimum: refund.costFixedMinimum !== "" ? parseFloat(refund.costFixedMinimum) : 0
	            }
	        };
	
	        var api = new _Api2.default({ token: token });
	        api.updateMerchantSetting(terminal.projectUuid, selectedMsId, { fee: fee }).then(function () {
	            setSaving(false);
	            setStatus({ type: "success", text: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B" });
	            // Обновить локальный список
	            setMsList(function (prev) {
	                return prev.map(function (ms) {
	                    if (ms.id === selectedMsId) {
	                        return Object.assign({}, ms, { fee: fee });
	                    }
	                    return ms;
	                });
	            });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setSaving(false);
	            var msg = err && err.response && err.response.data && err.response.data.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F";
	            setStatus({ type: "error", text: msg });
	        });
	    }
	
	    function renderFeeGroup(title, operations, group, state) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.FeeGroup }, _react2.default.createElement("div", { className: _stylesModule2.default.FeeGroupTitle }, title), _react2.default.createElement("div", { className: _stylesModule2.default.FeeGroupDescription }, operations), _react2.default.createElement("div", { className: _stylesModule2.default.FieldRow }, _react2.default.createElement("div", { className: _stylesModule2.default.Field }, _react2.default.createElement("div", { className: _stylesModule2.default.FieldLabel }, "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 (%)"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.FieldInput,
	            type: "text",
	            value: state.cost,
	            onChange: function onChange(e) {
	                onFieldChange(group, "cost", e.target.value);
	            },
	            placeholder: "0"
	        })), _react2.default.createElement("div", { className: _stylesModule2.default.Field }, _react2.default.createElement("div", { className: _stylesModule2.default.FieldLabel }, "\u0424\u0438\u043A\u0441. \u0437\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E (\u0440\u0443\u0431)"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.FieldInput,
	            type: "text",
	            value: state.fixedPerTransaction,
	            onChange: function onChange(e) {
	                onFieldChange(group, "fixedPerTransaction", e.target.value);
	            },
	            placeholder: "0"
	        })), _react2.default.createElement("div", { className: _stylesModule2.default.Field }, _react2.default.createElement("div", { className: _stylesModule2.default.FieldLabel }, "\u041C\u0438\u043D. \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F (\u0440\u0443\u0431)"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.FieldInput,
	            type: "text",
	            value: state.costFixedMinimum,
	            onChange: function onChange(e) {
	                onFieldChange(group, "costFixedMinimum", e.target.value);
	            },
	            placeholder: "0"
	        }))));
	    }
	
	    if (loading) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
	    }
	
	    if (msList.length === 0) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, _react2.default.createElement("div", { className: _stylesModule2.default.Title }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430"), _react2.default.createElement("div", { className: _stylesModule2.default.Empty }, "\u041D\u0435\u0442 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430"));
	    }
	
	    return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, _react2.default.createElement("div", { className: _stylesModule2.default.Title }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 (MerchantSettings)"), msList.length > 1 && _react2.default.createElement("div", { className: _stylesModule2.default.MsSelector }, _react2.default.createElement("div", { className: _stylesModule2.default.MsLabel }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443:"), _react2.default.createElement("select", { value: selectedMsId || "", onChange: onMsChange }, msList.map(function (ms) {
	        return _react2.default.createElement("option", { key: ms.id, value: ms.id }, "MS #" + ms.id + " \u2014 " + (ms.providerName || "?") + " (" + (ms.currency && ms.currency.code || "RUB") + ")");
	    }))), renderFeeGroup("\u041E\u043F\u043B\u0430\u0442\u0430 (Payment)", "Purchase, Recurrent, SBP, P2P, QR", "payment", payment), renderFeeGroup("\u0412\u044B\u043F\u043B\u0430\u0442\u044B (Payout)", "Payout, Mobile Payout", "payout", payout), renderFeeGroup("\u0412\u043E\u0437\u0432\u0440\u0430\u0442\u044B (Refund)", "Refund", "refund", refund), _react2.default.createElement("div", { style: { marginTop: "10px", padding: "8px", background: "#fff3e0", borderRadius: "4px", fontSize: "12px", color: "#e65100" } }, "\u042D\u0442\u043E \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 (MerchantSettings). \u041E\u043D\u0438 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u043B\u0438\u0447\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430 (Terminal fees)."), _react2.default.createElement("button", {
	        className: _stylesModule2.default.SaveBtn,
	        onClick: onSave,
	        disabled: saving
	    }, saving ? "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..." : "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"), status && _react2.default.createElement("div", {
	        className: _stylesModule2.default.StatusMsg + " " + (status.type === "success" ? _stylesModule2.default.StatusSuccess : _stylesModule2.default.StatusError)
	    }, status.text));
	}
	
	exports.default = MerchantSettingsFeesTab;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Help = __webpack_require__(59);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _stylesModule = __webpack_require__(560);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentsOnMonth(_ref) {
	    var data = _ref.data,
	        isLoading = _ref.isLoading;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardHeader },
	            _react2.default.createElement(
	                "h6",
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "Dashboard.title.paymentsThisMonth",
	                    defaultMessage: "\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u0437\u0430 {month}",
	                    values: {
	                        month: _react2.default.createElement(_FormatDate2.default, { format: { month: 'long' } })
	                    }
	                })
	            )
	        ),
	        isLoading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardBody },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MediaIcon },
	                _react2.default.createElement(_Icon2.default, { color: '#2479E0', icon: "calendar", size: '20px' })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MediaBody },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    data.payout.count + data.purchase.count + data.recurrent.count
	                ),
	                _react2.default.createElement(
	                    _Help2.default,
	                    { width: 120 },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "Dashboard.help.payout",
	                            defaultMessage: "\u0412\u044B\u043F\u043B\u0430\u0442\u044B: {count}",
	                            values: { count: data.payout.count }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "Dashboard.help.purchase",
	                            defaultMessage: "\u041F\u043E\u043A\u0443\u043F\u043A\u0438: {count}",
	                            values: { count: data.purchase.count }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "Dashboard.help.recurrent",
	                            defaultMessage: "\u0420\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442\u043D\u044B\u0435: {count}",
	                            values: { count: data.recurrent.count }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.MediaMore },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Desc },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Dashboard.title.successful", defaultMessage: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0445" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { className: _stylesModule2.default.Link, to: '/transactions/{"period": "month"}' },
	                            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "pie-chart", size: '18px' }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Dashboard.title.statistics", defaultMessage: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = PaymentsOnMonth;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Help = __webpack_require__(59);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _stylesModule = __webpack_require__(561);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentsTotalToday(_ref) {
	    var data = _ref.data,
	        isLoading = _ref.isLoading;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardHeader },
	            _react2.default.createElement(
	                "h6",
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Dashboard.title.paymentsToday", defaultMessage: "\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u0437\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F" })
	            )
	        ),
	        isLoading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.CardBody },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MediaIcon },
	                _react2.default.createElement(_Icon2.default, { color: '#5e35b1', icon: "time", size: '20px' })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MediaBody },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    data.payout.count + data.purchase.count + data.recurrent.count
	                ),
	                _react2.default.createElement(
	                    _Help2.default,
	                    { width: 100 },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "Dashboard.help.payout",
	                            defaultMessage: "\u0412\u044B\u043F\u043B\u0430\u0442\u044B: {count}",
	                            values: { count: data.payout.count }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "Dashboard.help.purchase",
	                            defaultMessage: "\u041F\u043E\u043A\u0443\u043F\u043A\u0438: {count}",
	                            values: { count: data.purchase.count }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "Dashboard.help.recurrent",
	                            defaultMessage: "\u0420\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442\u043D\u044B\u0435: {count}",
	                            values: { count: data.recurrent.count }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.MediaMore },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Desc },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Dashboard.title.successful", defaultMessage: "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0445" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { className: _stylesModule2.default.Link, to: '/transactions/{"period": "today"}' },
	                            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "pie-chart", size: '18px' }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Dashboard.title.statistics", defaultMessage: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = PaymentsTotalToday;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(562);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PayoutsDetailAmounts(_ref) {
	    var _ref$success = _ref.success,
	        success = _ref$success === undefined ? 0 : _ref$success,
	        _ref$failed = _ref.failed,
	        failed = _ref$failed === undefined ? 0 : _ref$failed,
	        _ref$other = _ref.other,
	        other = _ref$other === undefined ? 0 : _ref$other,
	        _ref$currency = _ref.currency,
	        currency = _ref$currency === undefined ? "RUB" : _ref$currency;
	
	    return _react2.default.createElement(
	        _EmptyCard2.default,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Row },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Success },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SuccessIcon },
	                    _react2.default.createElement(_Icon2.default, { icon: "checkmark1", size: "20px" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailAmounts.label.success",
	                            defaultMessage: "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445:" })
	                    ),
	                    _react2.default.createElement(_Amount2.default, { amount: success, currency: currency })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Failed },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.FailedIcon },
	                    _react2.default.createElement(_Icon2.default, { icon: "cross", size: "20px" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailAmounts.label.failed",
	                            defaultMessage: "\u0421\u0443\u043C\u043C\u0430 \u043D\u0435\u0432\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445:" })
	                    ),
	                    _react2.default.createElement(_Amount2.default, { amount: failed, currency: currency })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Other },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.OtherIcon },
	                    _react2.default.createElement(_Icon2.default, { icon: "stopwatch", size: "20px" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.Label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailAmounts.label.other", defaultMessage: "\u0421\u0443\u043C\u043C\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445:" })
	                    ),
	                    _react2.default.createElement(_Amount2.default, { amount: other, currency: currency })
	                )
	            )
	        )
	    );
	}
	
	exports.default = PayoutsDetailAmounts;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _PayoutsDetailTags = __webpack_require__(404);
	
	var _PayoutsDetailTags2 = _interopRequireDefault(_PayoutsDetailTags);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _stylesModule = __webpack_require__(563);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function PayoutsDetailEditing(_ref) {
	    var token = _ref.token,
	        name = _ref.name,
	        tags = _ref.tags,
	        suggestionsTags = _ref.suggestionsTags,
	        registryId = _ref.registryId;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)({
	        name: name || "",
	        tags: tags || []
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        form = _useState2[0],
	        setForm = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isRequest = _useState4[0],
	        setIsRequest = _useState4[1];
	
	    // храним предыдущие пропсы, чтобы видеть, реально ли что-то поменялось
	
	
	    var prevPropsRef = (0, _react.useRef)({ name: name, tags: tags });
	
	    (0, _react.useEffect)(function () {
	        var prev = prevPropsRef.current;
	        var nextName = name || "";
	        var nextTags = tags || [];
	
	        var nameChanged = prev.name !== nextName;
	        var tagsChanged = prev.tags !== nextTags;
	
	        // обновляем форму ТОЛЬКО если реально поменялись входные пропсы
	        if (nameChanged || tagsChanged) {
	            setForm(function (prevForm) {
	
	                return Object.assign({}, prevForm, {
	                    name: nextName,
	                    tags: nextTags
	                });
	            });
	
	            prevPropsRef.current = { name: nextName, tags: nextTags };
	        }
	    }, [name, tags]);
	
	    function onChangeName(field, value) {
	
	        setForm(function (prev) {
	            if (prev[field] === value) {
	                return prev;
	            }
	
	            var next = Object.assign({}, prev, _defineProperty({}, field, value));
	            return next;
	        });
	    }
	
	    function onSelectedTag(nextTags) {
	
	        setForm(function (prev) {
	            // простая проверка, изменился ли состав тегов
	            var prevTags = prev.tags || [];
	            var sameLength = prevTags.length === nextTags.length;
	            var sameItems = sameLength && prevTags.every(function (t, i) {
	                return t === nextTags[i];
	            });
	
	            if (sameItems) {
	                return prev;
	            }
	
	            var out = Object.assign({}, prev, { tags: nextTags });
	            return out;
	        });
	    }
	
	    function save() {
	
	        if (!form.name.trim()) {
	            onMessage({
	                type: "error",
	                message: intl.formatMessage({ id: "PayoutsDetailEditing.error.emptyName" })
	            });
	            return;
	        }
	
	        setIsRequest(true);
	
	        new _Api2.default({ token: token }).updateRegistryData(registryId, form).then(function (r) {
	
	            if (r && r.error) {
	                onMessage({
	                    type: "error",
	                    message: intl.formatMessage({ id: "PayoutsDetailEditing.error.generic" })
	                });
	            } else if (r && r.code) {
	                onMessage({
	                    type: "error",
	                    message: "code " + r.code + ": " + r.message
	                });
	            } else {
	                onMessage({
	                    type: "success",
	                    message: intl.formatMessage({ id: "PayoutsDetailEditing.success.saved" })
	                });
	            }
	        }).catch(function (e) {
	            onMessage({
	                type: "error",
	                message: intl.formatMessage({ id: "PayoutsDetailEditing.error.network" })
	            });
	        }).finally(function () {
	            setIsRequest(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "PayoutsDetailEditing.title",
	                        defaultMessage: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0435\u0435\u0441\u0442\u0440\u0430"
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Input },
	                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                        onChange: onChangeName,
	                        value: form.name,
	                        placeholder: intl.formatMessage({
	                            id: "PayoutsDetailEditing.placeholder.name"
	                        }),
	                        fieldName: "name",
	                        label: "FieldsHelper.label.registryName",
	                        changeRegexp: /[^А-Яа-яA-Za-z0-9_().\s]+/g,
	                        blurRegexp: /[А-Яа-яA-Za-z0-9_().]+/gi,
	                        changeMessage: "FieldsHelper.error.onlyCyrLatinRegisterName",
	                        blurMessage: "FieldsHelper.error.checkRegisterName",
	                        isDisabled: isRequest
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Input },
	                    _react2.default.createElement(
	                        "h5",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "PayoutsDetailEditing.label.tags",
	                            defaultMessage: "\u041C\u0435\u0442\u043A\u0438"
	                        })
	                    ),
	                    _react2.default.createElement(_PayoutsDetailTags2.default, {
	                        tags: form.tags,
	                        suggestionsTags: suggestionsTags,
	                        onSelectedTag: onSelectedTag
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(_Button2.default, {
	                onClick: save,
	                label: "PayoutsDetailEditing.btn.save",
	                color: "#35C98E",
	                icon: "floppy-o",
	                isLoading: isRequest
	            })
	        )
	    );
	}
	
	exports.default = PayoutsDetailEditing;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _stylesModule = __webpack_require__(564);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function PayoutsDetailFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        onSelectFilter = _ref.onSelectFilter,
	        isLoading = _ref.isLoading,
	        filters = _ref.filters;
	
	
	    // FIX: обновляем объект фильтров корректно
	    var handleChange = function handleChange(filterName, isChecked) {
	        onSelectFilter(function (prev) {
	            return Object.assign({}, prev, _defineProperty({}, filterName, isChecked));
	        });
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "h6",
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailFilters.title.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Column },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.CheckboxWrap },
	                    _react2.default.createElement("input", {
	                        id: "Payout",
	                        type: "checkbox",
	                        checked: filters.payout // FIX
	                        , onChange: function onChange(e) {
	                            return handleChange("payout", e.target.checked);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "label",
	                        { htmlFor: "Payout", className: _stylesModule2.default.CustomCheckbox },
	                        _react2.default.createElement("div", { className: _stylesModule2.default.Payout }),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailFilters.status.paid", defaultMessage: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D" })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.CheckboxWrap },
	                    _react2.default.createElement("input", {
	                        id: "PayoutDecline",
	                        type: "checkbox",
	                        checked: filters.payoutDecline // FIX
	                        , onChange: function onChange(e) {
	                            return handleChange("payoutDecline", e.target.checked);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "label",
	                        { htmlFor: "PayoutDecline", className: _stylesModule2.default.CustomCheckbox },
	                        _react2.default.createElement("div", { className: _stylesModule2.default.PayoutDecline }),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailFilters.status.error", defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430" })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.CheckboxWrap },
	                    _react2.default.createElement("input", {
	                        id: "Created",
	                        type: "checkbox",
	                        checked: filters.created // FIX
	                        , onChange: function onChange(e) {
	                            return handleChange("created", e.target.checked);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "label",
	                        { htmlFor: "Created", className: _stylesModule2.default.CustomCheckbox },
	                        _react2.default.createElement("div", { className: _stylesModule2.default.Created }),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailFilters.status.delayed", defaultMessage: "\u041E\u0442\u043B\u043E\u0436\u0435\u043D" })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.CheckboxWrap },
	                    _react2.default.createElement("input", {
	                        id: "Filtered",
	                        type: "checkbox",
	                        checked: filters.filtered // FIX
	                        , onChange: function onChange(e) {
	                            return handleChange("filtered", e.target.checked);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "label",
	                        { htmlFor: "Filtered", className: _stylesModule2.default.CustomCheckbox },
	                        _react2.default.createElement("div", { className: _stylesModule2.default.Filtered }),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetailFilters.status.filtered", defaultMessage: "\u041E\u0442\u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u043D" })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(_Button2.default, {
	                onClick: onApplyFilters,
	                label: "PayoutsDetailFilters.btn.setFilters",
	                icon: "filter",
	                isLoading: !isLoading
	            })
	        )
	    );
	}
	
	exports.default = PayoutsDetailFilters;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTagAutocomplete = __webpack_require__(222);
	
	var _reactTagAutocomplete2 = _interopRequireDefault(_reactTagAutocomplete);
	
	var _stylesModule = __webpack_require__(565);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function PayoutsDetailTags(_ref) {
	    var _ref$tags = _ref.tags,
	        propTags = _ref$tags === undefined ? [] : _ref$tags,
	        _ref$suggestionsTags = _ref.suggestionsTags,
	        suggestionsTags = _ref$suggestionsTags === undefined ? [] : _ref$suggestionsTags,
	        onSelectedTag = _ref.onSelectedTag;
	
	    var _useState = (0, _react.useState)(propTags),
	        _useState2 = _slicedToArray(_useState, 2),
	        tags = _useState2[0],
	        setTags = _useState2[1];
	
	    var reactTagsRef = (0, _react.useRef)();
	
	    (0, _react.useEffect)(function () {
	        setTags(propTags);
	    }, [propTags]);
	
	    (0, _react.useEffect)(function () {
	        if (onSelectedTag) onSelectedTag(tags);
	    }, [tags, onSelectedTag]);
	
	    function handleDelete(i) {
	        var newTags = tags.slice(0);
	        newTags.splice(i, 1);
	        setTags(newTags);
	    }
	
	    function handleAddition(tag) {
	        var newTags = [].concat(_toConsumableArray(tags), [tag]);
	        setTags(newTags);
	    }
	
	    return _react2.default.createElement(_reactTagAutocomplete2.default, {
	        ref: reactTagsRef,
	        tags: tags,
	        suggestions: suggestionsTags,
	        handleDelete: handleDelete,
	        handleAddition: handleAddition,
	        allowNew: true,
	        autoresize: false,
	        placeholder: "Добавить метку",
	        noSuggestionsText: "Меток не найдено",
	        addOnBlur: true,
	        minQueryLength: 1,
	        classNames: {
	            root: _stylesModule2.default.Wrap,
	            rootFocused: _stylesModule2.default.isFocused,
	            selected: _stylesModule2.default.Selected,
	            selectedTag: _stylesModule2.default.SelectedTag,
	            selectedTagName: "react-tags__selected-tag-name",
	            search: _stylesModule2.default.TagSearchWrap,
	            searchInput: _stylesModule2.default.Input,
	            suggestions: _stylesModule2.default.Suggestions,
	            suggestionActive: "is-active",
	            suggestionDisabled: "is-disabled"
	        }
	    });
	}
	
	exports.default = PayoutsDetailTags;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(105);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        'tr',
	        { className: _stylesModule2.default.EmptyRow },
	        _react2.default.createElement(
	            'td',
	            { colSpan: '6' },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Empty },
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.empty', defaultMessage: '\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u044F\u044E\u0449\u0438\u0445 \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u043C' })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _VTabBar = __webpack_require__(60);
	
	var _VTabBar2 = _interopRequireDefault(_VTabBar);
	
	var _TabBarItem = __webpack_require__(96);
	
	var _TabBarItem2 = _interopRequireDefault(_TabBarItem);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(105);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    var type = {
	        styles: { color: '#ff9800', borderColor: '#ff9800' },
	        locale: null
	    };
	
	    if (data && data.type) {
	        switch (data.type) {
	            case 'payoutDecline':
	            case 'mobilePayoutDecline':
	                type.styles = { color: '#dc3912', borderColor: '#dc3912' };
	                type.locale = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.status.payoutDecline', defaultMessage: '\u041E\u0448\u0438\u0431\u043A\u0430' });
	                break;
	            case 'created':
	            case 'payoutCreated':
	            case 'mobilePayoutCreated':
	            case 'payoutPending':
	            case 'mobilePayoutPending':
	                type.styles = { color: '#2196f3', borderColor: '#2196f3' };
	                type.locale = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.status.created', defaultMessage: '\u041E\u0442\u043B\u043E\u0436\u0435\u043D' });
	                break;
	            case 'payout':
	            case 'mobilePayout':
	                type.styles = { color: '#109618', borderColor: '#109618' };
	                type.locale = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.status.payout', defaultMessage: '\u041E\u043F\u043B\u0430\u0447\u0435\u043D' });
	                break;
	            case 'filtered':
	                type.styles = { color: '#eca87a', borderColor: '#eca87a' };
	                type.locale = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.status.filtered', defaultMessage: '\u041E\u0442\u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u043D' });
	                break;
	            default:
	                break;
	        }
	    }
	
	    function toggleOpened() {
	        setIsOpened(function (prev) {
	            return !prev;
	        });
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            'tr',
	            { onClick: toggleOpened, className: _stylesModule2.default.Row },
	            _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: type.styles, className: _stylesModule2.default.Status },
	                    _react2.default.createElement('span', { style: type.styles }),
	                    type.locale
	                )
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                data && data.recipient || ''
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                data && data.phone || ''
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(_Amount2.default, { amount: data && data.amount, currency: data && data.currencyCode })
	            ),
	            _react2.default.createElement(
	                'td',
	                null,
	                data && data.firstPart || '',
	                ' \u2022\u2022\u2022 ',
	                data && data.lastPart || ''
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: _stylesModule2.default.ToggleCell },
	                isOpened ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'cheveron-up', size: '18px' }) : _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: 'cheveron-down', size: '18px' })
	            )
	        ),
	        isOpened && _react2.default.createElement(
	            'tr',
	            { className: _stylesModule2.default.InnerRow },
	            _react2.default.createElement(
	                'td',
	                { colSpan: 6 },
	                _react2.default.createElement(
	                    _VTabBar2.default,
	                    null,
	                    _react2.default.createElement(
	                        _TabBarItem2.default,
	                        {
	                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.tab.params', defaultMessage: '\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0432\u044B\u043F\u043B\u0430\u0442\u044B' }),
	                            isVisible: true
	                        },
	                        _react2.default.createElement(
	                            'table',
	                            { className: _stylesModule2.default.TabTable },
	                            _react2.default.createElement(
	                                'tbody',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.id',
	                                            defaultMessage: '\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        data && data.id || ''
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.fee',
	                                            defaultMessage: '\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        data && data.fee ? _react2.default.createElement(_Amount2.default, { amount: data.fee, currency: data.currencyCode }) : '—'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.extStatus',
	                                            defaultMessage: '\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        data && data.status || '—'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.created',
	                                            defaultMessage: '\u0421\u043E\u0437\u0434\u0430\u043D:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_FormatDate2.default, {
	                                            setDate: data && data.date,
	                                            format: {
	                                                day: 'numeric',
	                                                month: 'numeric',
	                                                year: 'numeric',
	                                                hour: 'numeric',
	                                                minute: 'numeric'
	                                            }
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.processed',
	                                            defaultMessage: '\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        data && data.accountingDate ? _react2.default.createElement(_FormatDate2.default, {
	                                            setDate: data.accountingDate,
	                                            format: {
	                                                day: 'numeric',
	                                                month: 'numeric',
	                                                year: 'numeric',
	                                                hour: 'numeric',
	                                                minute: 'numeric'
	                                            }
	                                        }) : '—'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.bank',
	                                            defaultMessage: '\u0411\u0430\u043D\u043A \u043A\u0430\u0440\u0442\u044B:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        data && data.cardBankName || '—'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.country',
	                                            defaultMessage: '\u0421\u0442\u0440\u0430\u043D\u0430 \u043A\u0430\u0440\u0442\u044B:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        data && data.cardBankCountryCode ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'binBase.country.' + data.cardBankCountryCode,
	                                            defaultMessage: data.cardBankCountryCode
	                                        }) : '—'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: 'PayoutsTable.tab.system',
	                                            defaultMessage: '\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430:'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        data && data.cardBrand || '—'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Empty = __webpack_require__(405);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _TableRow = __webpack_require__(406);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _stylesModule = __webpack_require__(105);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PayoutsTable(_ref) {
	    var payouts = _ref.payouts,
	        loading = _ref.loading;
	
	
	    var list = Array.isArray(payouts) ? payouts : [];
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Table },
	            _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.table.status', defaultMessage: '\u0421\u0442\u0430\u0442\u0443\u0441' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.table.recipient', defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.table.phone', defaultMessage: '\u0422\u0435\u043B\u0435\u0444\u043E\u043D' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.table.amount', defaultMessage: '\u0421\u0443\u043C\u043C\u0430' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PayoutsTable.table.pan', defaultMessage: 'PAN' })
	                        ),
	                        _react2.default.createElement('th', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    loading && list.length > 0 ? list.map(function (el, idx) {
	                        return _react2.default.createElement(_TableRow2.default, {
	                            key: el.id != null ? 'tx-' + el.id : 'nci-' + idx + '-' + (el.firstPart || '') + '-' + (el.lastPart || '') + '-' + (el.amount || ''),
	                            data: el
	                        });
	                    }) : _react2.default.createElement(_Empty2.default, null)
	                )
	            )
	        )
	    );
	}
	
	exports.default = PayoutsTable;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(567);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PsaStatuses = {
	    created: 0,
	    inprogess: 1,
	    processed: 2,
	    paymentDeclined: 3,
	    error: 4
	};
	
	function PcaFilters(_ref) {
	    var onSelectFilter = _ref.onSelectFilter;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaFilters.title.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "inactive", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter(_defineProperty({}, PsaStatuses.created, e.target.checked));
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "inactive", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.InProgressIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaFilters.status.inactive",
	                                    defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "inProgress", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter(_defineProperty({}, PsaStatuses.inprogess, e.target.checked));
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "inProgress", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.PendingIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaFilters.status.inProgress",
	                                    defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "processed", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter(_defineProperty({}, PsaStatuses.processed, e.target.checked));
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "processed", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.ProcessedIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaFilters.status.processed",
	                                    defaultMessage: "\u0412\u044B\u043F\u043B\u0430\u0447\u0435\u043D" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", {
	                            id: "processedWithErrors",
	                            type: "checkbox",
	                            onChange: function onChange(e) {
	                                var _onSelectFilter4;
	
	                                return onSelectFilter((_onSelectFilter4 = {}, _defineProperty(_onSelectFilter4, PsaStatuses.error, e.target.checked), _defineProperty(_onSelectFilter4, PsaStatuses.paymentDeclined, e.target.checked), _onSelectFilter4));
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "processedWithErrors", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement("div", { className: _stylesModule2.default.processedWithErrorsIcon }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaFilters.status.error",
	                                    defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430 / \u041F\u043B\u0430\u0442\u0435\u0436 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = PcaFilters;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(106);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "tr",
	        { className: _stylesModule2.default.EmptyRow },
	        _react2.default.createElement(
	            "td",
	            { colSpan: "6" },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Empty },
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.empty", defaultMessage: "\u041D\u0435\u0442 \u041F\u0421\u0410" })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _ContextMenu = __webpack_require__(58);
	
	var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
	
	var _stylesModule = __webpack_require__(106);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data,
	        contracts = _ref.contracts,
	        terminals = _ref.terminals;
	
	    var status = function status() {
	        if (!data || data.status === undefined) return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Disabled },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: "PcaTable.status.inactive", defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D" })
	        );
	        switch (data.status) {
	            case 0:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Disabled },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.status.inactive",
	                        defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D" })
	                );
	            case 1:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Process },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.status.inProgress",
	                        defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F" })
	                );
	            case 2:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Enables },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.status.paid",
	                        defaultMessage: "\u0412\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043E" })
	                );
	            case 3:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Error },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.status.declined",
	                        defaultMessage: "\u041F\u043B\u0430\u0442\u0435\u0436 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D" })
	                );
	            case 4:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Error },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.status.error",
	                        defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430" })
	                );
	            default:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Disabled },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.status.inactive",
	                        defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D" })
	                );
	        }
	    };
	
	    var contract = (0, _react.useMemo)(function () {
	        return contracts ? contracts.find(function (c) {
	            return c && c.id === (data && data.psaContractId);
	        }) : null;
	    }, [contracts, data]);
	    var provider = (0, _react.useMemo)(function () {
	        return terminals ? terminals.find(function (t) {
	            return t && t.uuid === (data && data.providerId);
	        }) : null;
	    }, [terminals, data]);
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            "tr",
	            { className: _stylesModule2.default.Row },
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.id || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.name || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                contract ? contract.name : ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                provider ? provider.displayName : ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.date || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.amount || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                status()
	            ),
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.CellMenu },
	                _react2.default.createElement(
	                    _ContextMenu2.default,
	                    { icon: "menu" },
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { className: _stylesModule2.default.ActivateLink, to: "/metal/pca/" + (data && data.id || "") },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.menu.view", defaultMessage: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u041F\u0421\u0410" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { className: _stylesModule2.default.defaultLink,
	                                    to: "/metal/pca/duplicate/" + (data && data.id || "") },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PcaTable.menu.duplicate", defaultMessage: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u041F\u0421\u0410" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(107);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "tr",
	        { className: _stylesModule2.default.EmptyRow },
	        _react2.default.createElement(
	            "td",
	            { colSpan: "6" },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Empty },
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.empty", defaultMessage: "\u041D\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442" })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _ContextMenu = __webpack_require__(58);
	
	var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
	
	var _stylesModule = __webpack_require__(107);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data;
	
	    function status() {
	        if (!data || data.status === undefined) return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Disabled },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: "PrepaidTable.status.inactive", defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430" })
	        );
	        switch (data.status) {
	            case 0:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Disabled },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.inactive",
	                        defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430" })
	                );
	            case 1:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Process },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.processing",
	                        defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F" })
	                );
	            case 2:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Enables },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.active",
	                        defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430" })
	                );
	            case 3:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Error },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.error",
	                        defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430" })
	                );
	            default:
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Disabled },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.inactive",
	                        defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430" })
	                );
	        }
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            "tr",
	            { className: _stylesModule2.default.Row },
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.ean || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.part ? data.part.replace(/[*]{6}/g, " •••• ") : ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data && data.merchantName || ""
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    data && data.fio || "—"
	                )
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                status()
	            ),
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.CellMenu },
	                _react2.default.createElement(
	                    _ContextMenu2.default,
	                    { icon: "menu" },
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { className: _stylesModule2.default.defaultLink,
	                                    to: "/prepaid/details/" + (data && data.ean || "") },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.menu.details", defaultMessage: "\u0414\u0435\u0442\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F" })
	                            )
	                        ),
	                        data && (data.status === 0 || data.status === 3) && _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                { className: _stylesModule2.default.ActivateLink,
	                                    to: "/prepaid/activate/" + (data && data.ean || "") },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.menu.activate", defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u044F" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _TableRow = __webpack_require__(412);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Empty = __webpack_require__(411);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _stylesModule = __webpack_require__(107);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderStatus(data) {
	    if (!data || data.status === undefined) return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Disabled },
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: "PrepaidTable.status.inactive", defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430" })
	    );
	    switch (data.status) {
	        case 0:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Disabled },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.inactive",
	                    defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430" })
	            );
	        case 1:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Process },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.processing",
	                    defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F" })
	            );
	        case 2:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Enables },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.active",
	                    defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430" })
	            );
	        case 3:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Error },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.error",
	                    defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430" })
	            );
	        default:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Disabled },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.status.inactive",
	                    defaultMessage: "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0430" })
	            );
	    }
	}
	
	function PrepaidMobileCard(_ref) {
	    var data = _ref.data;
	
	    var safeData = data || {};
	    var cardPart = safeData.part ? safeData.part.replace(/[*]{6}/g, " •••• ") : "";
	    var canActivate = safeData.status === 0 || safeData.status === 3;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.MobileCard },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileCardHeader },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileCardTitle },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.ean", defaultMessage: "EAN" })
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileEan },
	                    safeData.ean || "-"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileStatus },
	                renderStatus(safeData)
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileFields },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileField },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.card", defaultMessage: "\u041A\u0430\u0440\u0442\u0430" })
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileValue },
	                    cardPart || "-"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileField },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.project", defaultMessage: "\u041F\u0440\u043E\u0435\u043A\u0442" })
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileValue },
	                    safeData.merchantName || "-"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileField },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.client", defaultMessage: "\u041A\u043B\u0438\u0435\u043D\u0442" })
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.MobileValue },
	                    safeData.fio || "—"
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileActions },
	            _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                { className: _stylesModule2.default.MobileDetailsLink, to: "/prepaid/details/" + (safeData.ean || "") },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.menu.details", defaultMessage: "\u0414\u0435\u0442\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F" })
	            ),
	            canActivate && _react2.default.createElement(
	                _reactRouterDom.NavLink,
	                { className: _stylesModule2.default.MobileActivateLink, to: "/prepaid/activate/" + (safeData.ean || "") },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.menu.activate", defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u044F" })
	            )
	        )
	    );
	}
	
	function PrepaidTable(_ref2) {
	    var token = _ref2.token;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        cardList = _useState2[0],
	        setCardList = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        loading = _useState4[0],
	        setLoading = _useState4[1];
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getPreActivatedCardsList().then(function (r) {
	            setCardList(r || []);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);setLoading(false);
	        });
	    }, [token]);
	
	    return loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "table",
	            { className: _stylesModule2.default.Table },
	            _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.ean", defaultMessage: "EAN" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.card", defaultMessage: "\u041A\u0430\u0440\u0442\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.project", defaultMessage: "\u041F\u0440\u043E\u0435\u043A\u0442" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.client", defaultMessage: "\u041A\u043B\u0438\u0435\u043D\u0442" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.table.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                    ),
	                    _react2.default.createElement("th", null)
	                )
	            ),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                !loading && cardList && cardList.length > 0 ? cardList.map(function (el, i) {
	                    return _react2.default.createElement(_TableRow2.default, { key: i, data: el });
	                }) : _react2.default.createElement(_Empty2.default, null)
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileList },
	            cardList && cardList.length > 0 ? cardList.map(function (el, i) {
	                return _react2.default.createElement(PrepaidMobileCard, { key: el && el.ean || i, data: el });
	            }) : _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.MobileEmpty },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidTable.empty", defaultMessage: "\u041D\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442" })
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(PrepaidTable);

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = TableRow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _stylesModule = __webpack_require__(202);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatKopecks(value) {
	    if (value === null || value === undefined) {
	        return '0.00';
	    }
	    var floatVal = Number(value) / 100;
	    return floatVal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
	
	function TableRow(_ref) {
	    var data = _ref.data,
	        hasExtendedBalances = _ref.hasExtendedBalances;
	
	    return _react2.default.createElement(
	        "tr",
	        { className: _stylesModule2.default.Row },
	        _react2.default.createElement(
	            "td",
	            null,
	            data && data.displayName || ""
	        ),
	        hasExtendedBalances ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.AmountCell },
	                data && data.balance && data.balance.length > 0 ? data.balance.map(function (el, index) {
	                    var currency = Object.keys(el)[0];
	                    var amount = el[currency];
	                    return _react2.default.createElement(
	                        "span",
	                        { key: index },
	                        _react2.default.createElement(_Amount2.default, { amount: amount, currency: currency })
	                    );
	                }) : _react2.default.createElement(
	                    "span",
	                    null,
	                    "\u2014"
	                )
	            ),
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.AmountCell },
	                data && data.settlementBalance !== undefined ? _react2.default.createElement(
	                    "span",
	                    null,
	                    formatKopecks(data.settlementBalance),
	                    " \u20BD"
	                ) : _react2.default.createElement(
	                    "span",
	                    null,
	                    "\u2014"
	                )
	            ),
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.AmountCell },
	                data && data.actualBalance !== undefined ? _react2.default.createElement(
	                    "span",
	                    null,
	                    formatKopecks(data.actualBalance),
	                    " \u20BD"
	                ) : _react2.default.createElement(
	                    "span",
	                    null,
	                    "\u2014"
	                )
	            )
	        ) : _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.AmountCell },
	            data && data.balance && data.balance.length > 0 ? data.balance.map(function (el, index) {
	                var currency = Object.keys(el)[0];
	                var amount = el[currency];
	                return _react2.default.createElement(
	                    "span",
	                    { key: index },
	                    _react2.default.createElement(_Amount2.default, { amount: amount, currency: currency })
	                );
	            }) : _react2.default.createElement(
	                "span",
	                null,
	                "\u2014"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            data && data.status === 1 ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Enables },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.status.active", defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u0435\u043D" })
	            ) : _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Disabled },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.status.blocked", defaultMessage: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" })
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	                "a",
	                {
	                    target: "_blank",
	                    rel: "noopener noreferrer",
	                    className: _stylesModule2.default.Link,
	                    href: data && data.url
	                },
	                data && data.url && data.url.replace(/^([a-zA-Z]+):\/\//, "") || ""
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellLeft },
	            _react2.default.createElement(
	                _reactRouterDom.Link,
	                { className: _stylesModule2.default.Settings, to: '/projects/settings/' + (data && data.uuid || "") },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "settings", size: "14px" }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.link.settings", defaultMessage: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438" })
	            )
	        )
	    );
	}

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _TableRow = __webpack_require__(414);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _ProjectMobileCard = __webpack_require__(176);
	
	var _ProjectMobileCard2 = _interopRequireDefault(_ProjectMobileCard);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(202);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectsTable = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        projects = _useState2[0],
	        setProjects = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        loading = _useState4[0],
	        setLoading = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        hasCrm = _useState6[0],
	        setHasCrm = _useState6[1];
	
	    var hasExtendedBalances = projects.some(function (p) {
	        return p && (p.settlementBalance !== undefined || p.actualBalance !== undefined);
	    });
	
	    (0, _react.useEffect)(function () {
	        var api = new _Api2.default({ token: token });
	        api.getProjects().then(function (r) {
	            setProjects(r || []);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);setLoading(false);
	        });
	        api.getMerchantBalances().then(function (r) {
	            if (r && r.totals && r.totals.hasCrm) setHasCrm(true);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	        });
	    }, [token]);
	
	    return loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "table",
	            { className: _stylesModule2.default.Table },
	            _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.project", defaultMessage: "\u041F\u0440\u043E\u0435\u043A\u0442" })
	                    ),
	                    hasExtendedBalances ? _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.transactionBalance", defaultMessage: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u043E\u043D\u043D\u044B\u0439" })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            hasCrm ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: "ProjectsTable.table.reservedBalance",
	                                defaultMessage: "\u0420\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439"
	                            }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: "ProjectsTable.table.settlementBalance",
	                                defaultMessage: "\u0412\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435"
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.actualBalance", defaultMessage: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439" })
	                        )
	                    ) : _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.balance", defaultMessage: "\u0411\u0430\u043B\u0430\u043D\u0441" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.status", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsTable.table.site", defaultMessage: "\u0421\u0430\u0439\u0442" })
	                    ),
	                    _react2.default.createElement("th", null)
	                )
	            ),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                projects.map(function (row) {
	                    return _react2.default.createElement(_TableRow2.default, { key: row && row.uuid, data: row, hasExtendedBalances: hasExtendedBalances });
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.MobileList },
	            projects.map(function (row) {
	                return _react2.default.createElement(_ProjectMobileCard2.default, {
	                    key: row && row.uuid,
	                    data: row,
	                    hasExtendedBalances: hasExtendedBalances,
	                    hasCrm: hasCrm
	                });
	            })
	        )
	    );
	});
	
	exports.default = ProjectsTable;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(108);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "tr",
	        { className: _stylesModule2.default.EmptyRow },
	        _react2.default.createElement(
	            "td",
	            { colSpan: "6" },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Empty },
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsWidget.empty.title", defaultMessage: "\u041D\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432" })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _stylesModule = __webpack_require__(108);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data;
	
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellLeft },
	            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.FavoriteIcon, color: "#f44336", icon: "star-full", size: '12px' }),
	            data.displayName
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	                "a",
	                { className: _stylesModule2.default.Link, target: "_blank", rel: "noopener noreferrer", href: data.url },
	                data.url ? data.url.replace(/^([a-zA-Z]+):\/\//, '') : "-"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.AmountCell },
	            data.balance.map(function (el, index) {
	                var currency = Object.keys(el)[0];
	                return _react2.default.createElement(
	                    "span",
	                    { key: index },
	                    _react2.default.createElement(_Amount2.default, { amount: el[currency], currency: currency })
	                );
	            })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.AmountCell },
	            Boolean(data.averageBill.length) ? data.averageBill.map(function (v, i) {
	                var currency = Object.keys(v)[i];
	                return v[currency].payment ? _react2.default.createElement(_Amount2.default, { key: i, currency: currency, amount: v[currency].payment.toFixed(2) }) : _react2.default.createElement(
	                    "span",
	                    { key: i },
	                    "\u2014"
	                );
	            }) : _react2.default.createElement(
	                "span",
	                null,
	                "\u2014"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.AmountCell },
	            Boolean(data.averageBill.length) ? data.averageBill.map(function (v, i) {
	                var currency = Object.keys(v)[i];
	                return v[currency].payout ? _react2.default.createElement(_Amount2.default, { key: i, currency: currency, amount: v[currency].payout.toFixed(2) }) : _react2.default.createElement(
	                    "span",
	                    { key: i },
	                    "\u2014"
	                );
	            }) : _react2.default.createElement(
	                "span",
	                null,
	                "\u2014"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/projects/settings/' + data.uuid, className: _stylesModule2.default.Link },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.SettingsIcon, color: "#2479E0", icon: "settings", size: '18px' }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "ProjectsWidget.table.settings", defaultMessage: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438" })
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Empty = __webpack_require__(416);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _TableRow = __webpack_require__(417);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _ProjectMobileCard = __webpack_require__(176);
	
	var _ProjectMobileCard2 = _interopRequireDefault(_ProjectMobileCard);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Help = __webpack_require__(59);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _ErrorHandler = __webpack_require__(98);
	
	var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);
	
	var _ApiResponseValidator = __webpack_require__(97);
	
	var _ApiResponseValidator2 = _interopRequireDefault(_ApiResponseValidator);
	
	var _stylesModule = __webpack_require__(108);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _React$useState = _react2.default.useState([]),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        projects = _React$useState2[0],
	        setProjects = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(true),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        loading = _React$useState4[0],
	        setLoading = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(null),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        error = _React$useState6[0],
	        setError = _React$useState6[1];
	
	    var activeProjects = projects.filter(function (project) {
	        return project.status === 1;
	    });
	
	    (0, _react.useEffect)(function () {
	        var loadProjects = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var response;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	
	                                if (!cancelled) {
	                                    setLoading(true);
	                                    setError(null);
	                                }
	
	                                _context.next = 4;
	                                return new _Api2.default({ token: token }).getProjects();
	
	                            case 4:
	                                response = _context.sent;
	
	                                if (!cancelled) {
	                                    _context.next = 7;
	                                    break;
	                                }
	
	                                return _context.abrupt('return');
	
	                            case 7:
	                                if (_ApiResponseValidator2.default.validateListResponse(response)) {
	                                    _context.next = 9;
	                                    break;
	                                }
	
	                                throw new Error('Invalid projects response');
	
	                            case 9:
	
	                                setProjects(Array.isArray(response) ? response : []);
	                                _context.next = 16;
	                                break;
	
	                            case 12:
	                                _context.prev = 12;
	                                _context.t0 = _context['catch'](0);
	
	                                _ErrorHandler2.default.logError(_context.t0, { action: 'getProjects', context: 'widget' });
	                                if (!cancelled) {
	                                    setError('ProjectsWidget.error.load');
	                                    setProjects([]);
	                                }
	
	                            case 16:
	                                _context.prev = 16;
	
	                                if (!cancelled) setLoading(false);
	                                return _context.finish(16);
	
	                            case 19:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 12, 16, 19]]);
	            }));
	
	            return function loadProjects() {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        var cancelled = false;
	
	        loadProjects();
	        return function () {
	            cancelled = true;
	        };
	    }, [token]);
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Header },
	            _react2.default.createElement(
	                'h5',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.title', defaultMessage: '\u041F\u0440\u043E\u0435\u043A\u0442\u044B' })
	            )
	        ),
	        loading ? _react2.default.createElement(_Loader2.default, null) : error ? _react2.default.createElement(
	            'div',
	            {
	                style: {
	                    padding: '16px',
	                    backgroundColor: '#2c1414',
	                    border: '1px solid #8b5555',
	                    borderRadius: '4px',
	                    color: '#ff9999',
	                    textAlign: 'center'
	                }
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: error, defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442\u044B' })
	        ) : _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TableScroll },
	            _react2.default.createElement(
	                'table',
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: _stylesModule2.default.CellLeft },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.table.project', defaultMessage: '\u041F\u0440\u043E\u0435\u043A\u0442' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.table.website', defaultMessage: '\u0421\u0430\u0439\u0442' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.table.balance', defaultMessage: '\u0411\u0430\u043B\u0430\u043D\u0441' })
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.table.payments', defaultMessage: '\u041F\u043B\u0430\u0442\u0435\u0436\u0438' }),
	                            _react2.default.createElement(
	                                _Help2.default,
	                                { marginTop: 3, marginLeft: 5, placement: 'bottom' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.help.avgBill', defaultMessage: '\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u0447\u0435\u043A' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.table.payouts', defaultMessage: '\u0412\u044B\u043F\u043B\u0430\u0442\u044B' }),
	                            _react2.default.createElement(
	                                _Help2.default,
	                                { marginTop: 3, marginLeft: 5, placement: 'bottom' },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.help.avgBill', defaultMessage: '\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u0447\u0435\u043A' })
	                            )
	                        ),
	                        _react2.default.createElement('th', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    Boolean(activeProjects.length) ? activeProjects.map(function (project) {
	                        return _react2.default.createElement(_TableRow2.default, { key: project.uuid, data: project });
	                    }) : _react2.default.createElement(_Empty2.default, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.MobileList },
	                Boolean(activeProjects.length) ? activeProjects.map(function (project) {
	                    return _react2.default.createElement(_ProjectMobileCard2.default, { key: project.uuid, data: project });
	                }) : _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.MobileEmpty },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.empty.title', defaultMessage: '\u041D\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(
	                _reactRouterDom.Link,
	                { className: _stylesModule2.default.Link, to: '/projects' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsWidget.link.viewAll', defaultMessage: '\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435' })
	            )
	        )
	    );
	});

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(569);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RegistryChangeName(_ref) {
	    var registryFileName = _ref.registryFileName,
	        onChangeRegistryName = _ref.onChangeRegistryName;
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Row },
	        _react2.default.createElement(
	            'h5',
	            { className: _stylesModule2.default.Title },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'RegistryChangeName.title', defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u043C\u044F' })
	        ),
	        _react2.default.createElement('input', {
	            className: _stylesModule2.default.Input,
	            type: 'text',
	            value: registryFileName,
	            onChange: function onChange(e) {
	                return onChangeRegistryName(e.target.value);
	            },
	            maxLength: 45
	        })
	    );
	}
	
	exports.default = RegistryChangeName;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(574);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "table",
	        { className: _stylesModule2.default.Table },
	        _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	                "tr",
	                { className: _stylesModule2.default.EmptyRow },
	                _react2.default.createElement(
	                    "td",
	                    { colSpan: "6" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Empty },
	                        _react2.default.createElement(
	                            "h5",
	                            null,
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.empty", defaultMessage: "\u0420\u0435\u0435\u0441\u0442\u0440\u043E\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AccessControl = __webpack_require__(99);
	
	var _AccessControl2 = _interopRequireDefault(_AccessControl);
	
	var _stylesModule = __webpack_require__(51);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MenuItem(_ref) {
	    var handleClickDetail = _ref.handleClickDetail,
	        hasAccess = _ref.hasAccess,
	        merchantUUID = _ref.merchantUUID;
	
	    return _react2.default.createElement(
	        "li",
	        {
	            className: hasAccess ? _stylesModule2.default.MenuItem : _stylesModule2.default.MenuItem + " " + _stylesModule2.default.MenuItemDisables,
	            onClick: function onClick() {
	                return hasAccess && handleClickDetail();
	            }
	        },
	        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.MenuIcon, icon: "eye", size: "14px" }),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.menu.view", defaultMessage: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440" })
	    );
	}
	
	exports.default = (0, _AccessControl2.default)(MenuItem);

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _ContextMenu = __webpack_require__(58);
	
	var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
	
	var _MenuItem = __webpack_require__(421);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(51);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var token = _ref.token,
	        id = _ref.id,
	        name = _ref.name,
	        date = _ref.date,
	        status = _ref.status,
	        tags = _ref.tags,
	        success = _ref.success,
	        failed = _ref.failed,
	        other = _ref.other,
	        retry = _ref.retry,
	        amount = _ref.amount,
	        totalFee = _ref.totalFee,
	        currency = _ref.currency,
	        merchantUUID = _ref.merchantUUID,
	        merchantName = _ref.merchantName;
	
	    var intl = (0, _reactIntl.useIntl)();
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isRetry = _useState2[0],
	        setIsRetry = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(status),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currentStatus = _useState4[0],
	        setCurrentStatus = _useState4[1];
	
	    var _useState5 = (0, _react.useState)({ success: success, failed: failed, other: other }),
	        _useState6 = _slicedToArray(_useState5, 2),
	        transactions = _useState6[0],
	        setTransactions = _useState6[1];
	
	    var handleClickDetail = function handleClickDetail() {
	        history.push("/payouts/registry/" + id);
	    };
	
	    var regStatus = function () {
	        switch (currentStatus) {
	            case "created":
	                return {
	                    name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.status.created", defaultMessage: "\u0421\u043E\u0437\u0434\u0430\u043D" }),
	                    color: "#ff9800"
	                };
	            case "inProgress":
	                return {
	                    name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.status.inProcessing", defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F" }),
	                    color: "#a29d9d"
	                };
	            case "processed":
	                return {
	                    name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.status.processed", defaultMessage: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D" }),
	                    color: "#35C98E"
	                };
	            case "processedWithErrors":
	                return {
	                    name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.status.processedWithErrors",
	                        defaultMessage: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D \u0441 \u043E\u0448\u0438\u0431\u043A\u0430\u043C\u0438" }), color: "#f44336"
	                };
	            case "delayed":
	                return {
	                    name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.status.delayed", defaultMessage: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435" }),
	                    color: "#2479E0"
	                };
	            default:
	                return {
	                    name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.status.reprocess", defaultMessage: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430" }),
	                    color: "#ff9800"
	                };
	        }
	    }();
	
	    function Reprocess() {
	        if (!window.confirm(intl.formatMessage({
	            id: "RegistryList.confirm.reprocess",
	            defaultMessage: 'Обработать повторно реестр "{name}"?'
	        }, { name: name }))) return;
	
	        new _Api2.default({ token: token }).setRegistryReprocess(id).then(function (r) {
	            if (!r.error) {
	                setIsRetry(true);
	                setCurrentStatus("reprocess");
	
	                setTimeout(function () {
	                    new _Api2.default({ token: token }).getRegistryStatus(id).then(function (res) {
	                        if (retry) setIsRetry(false);
	                        setTransactions({ success: res.success, failed: res.failed, other: res.other });
	                        setCurrentStatus(res.status);
	                    });
	                }, 3000);
	            }
	        });
	    }
	
	    function getReport(id) {
	        var fileName = name.replace(".xls", "") + " - " + date;
	        new _Api2.default({ token: token }).getReport("singleRegistry", id, fileName);
	    }
	
	    function downloadRegistry(id) {
	        var base = (name || "registry_" + id).replace(/\.xlsx$/i, "").replace(/\.xls$/i, "");
	        new _Api2.default({ token: token }).downloadRegistryFile(id, base);
	    }
	
	    return _react2.default.createElement(
	        "tr",
	        { className: _stylesModule2.default.Row },
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellCenter },
	            id
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            name,
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Status, style: { color: regStatus.color } },
	                    regStatus.name
	                ),
	                "\xA0(",
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Success },
	                    transactions.success
	                ),
	                "/",
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Failed },
	                    transactions.failed
	                ),
	                "/",
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Other },
	                    transactions.other
	                ),
	                ")"
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            merchantName
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.Date },
	                _react2.default.createElement(_FormatDate2.default, { setDate: date, format: { day: "numeric", month: "numeric", year: "numeric" } }),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(_FormatDate2.default, { setDate: date, format: { hour: "numeric", minute: "numeric" } })
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(_Amount2.default, { amount: amount, currency: currency })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            _react2.default.createElement(_Amount2.default, { amount: totalFee, currency: currency })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.Cell },
	            tags && tags.map(function (tag, index) {
	                return _react2.default.createElement(
	                    "span",
	                    { key: index, className: _stylesModule2.default.Tag },
	                    tag.name
	                );
	            })
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: _stylesModule2.default.CellMenu },
	            _react2.default.createElement(
	                _ContextMenu2.default,
	                { icon: "menu" },
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    _react2.default.createElement(_MenuItem2.default, { handleClickDetail: handleClickDetail, access: ["PAYOUT_REGISTRY_VIEW"],
	                        merchantUUID: merchantUUID }),
	                    retry && _react2.default.createElement(
	                        "li",
	                        {
	                            className: _stylesModule2.default.MenuItem + " " + (isRetry && _stylesModule2.default.MenuItemDisabled),
	                            onClick: function onClick() {
	                                return !isRetry && Reprocess();
	                            }
	                        },
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.MenuIcon, icon: "spinner11", size: "14px" }),
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.menu.reprocess",
	                            defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E" })
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: _stylesModule2.default.MenuItem, onClick: function onClick() {
	                                return getReport(id);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.MenuIcon, icon: "file-excel", size: "14px" }),
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.menu.report", defaultMessage: "\u0412\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043E\u0442\u0447\u0435\u0442" })
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: _stylesModule2.default.MenuItem, onClick: function onClick() {
	                                return downloadRegistry(id);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.MenuIcon, icon: "file-excel", size: "14px" }),
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryList.menu.downloadRegistry",
	                            defaultMessage: "\u0412\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0435\u0435\u0441\u0442\u0440" })
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(51);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableRow(_ref) {
	    var data = _ref.data,
	        hasError = _ref.hasError,
	        errors = _ref.errors;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    var rowStyle = hasError ? { backgroundColor: "#fde1df", cursor: "pointer" } : {};
	
	    function toggleOpened() {
	        setIsOpened(function (prev) {
	            return !prev;
	        });
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "tr",
	            { style: rowStyle, onClick: toggleOpened, className: _stylesModule2.default.Row },
	            Object.keys(data).map(function (key) {
	                return key !== "id" && _react2.default.createElement(
	                    "td",
	                    { key: key, className: _stylesModule2.default.Cell },
	                    data[key]
	                );
	            }),
	            _react2.default.createElement(
	                "td",
	                { className: _stylesModule2.default.DropdownCell },
	                hasError && (isOpened ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "cheveron-up", size: "18px" }) : _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "cheveron-down", size: "18px" }))
	            )
	        ),
	        hasError && isOpened && _react2.default.createElement(
	            "tr",
	            { className: _stylesModule2.default.InfoRow },
	            _react2.default.createElement(
	                "td",
	                { colSpan: "5" },
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    errors && errors.map(function (error, index) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: index },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUpload.error.field",
	                                defaultMessage: "\u041F\u043E\u043B\u0435" }),
	                            ": ",
	                            error.field,
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUpload.error.value",
	                                defaultMessage: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435" }),
	                            ": ",
	                            error.value,
	                            _react2.default.createElement("br", null),
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUpload.error.message",
	                                defaultMessage: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435" }),
	                            ": ",
	                            error.message
	                        );
	                    })
	                )
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Table;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TableRow = __webpack_require__(423);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _stylesModule = __webpack_require__(51);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function isEmptyValue(v) {
	    return v === null || v === undefined || String(v).trim() === "";
	}
	
	function addFieldError(errors, fieldKey, message) {
	    // Поддержим 2 распространённых формата:
	    // 1) errors как объект: { phoneNumber: "msg", ... }
	    // 2) errors как массив строк: ["msg", ...]
	    if (!errors) {
	        return _defineProperty({}, fieldKey, message);
	    }
	
	    if (Array.isArray(errors)) {
	        // Не ломаем текущий формат, если он уже массив
	        return [].concat(_toConsumableArray(errors), [message]);
	    }
	
	    // Если объект — добавляем по ключу поля (для подсветки ячейки)
	    var next = Object.assign({}, errors);
	    if (!next[fieldKey]) {
	        next[fieldKey] = message;
	    }
	    return next;
	}
	
	function Table(_ref2) {
	    var data = _ref2.data,
	        processing = _ref2.processing,
	        requiresDocuments = _ref2.requiresDocuments;
	
	    var intl = (0, _reactIntl.useIntl)();
	    if (!data || data.length === 0) return null;
	
	    var isFinStar = typeof requiresDocuments === "boolean" ? requiresDocuments : String(processing || "").toLowerCase() === "finstar";
	
	    // Если FinStar — колонки документов показываем всегда
	    var hasDocNumber = isFinStar || data.some(function (el) {
	        return el && el.row && !isEmptyValue(el.row.documentNumber);
	    });
	    var hasDocDate = isFinStar || data.some(function (el) {
	        return el && el.row && !isEmptyValue(el.row.documentDate);
	    });
	
	    var columns = [{ key: "creditCard", labelId: "RegistryUpload.table.creditCard", defaultMessage: "Номер карты" }, { key: "cardHolderRu", labelId: "RegistryUpload.table.cardHolderRu", defaultMessage: "Имя держателя карты" }, { key: "amount", labelId: "RegistryUpload.table.amount", defaultMessage: "Сумма" }, { key: "phoneNumber", labelId: "RegistryUpload.table.phoneNumber", defaultMessage: "Телефон" }].concat(_toConsumableArray(hasDocNumber ? [{
	        key: "documentNumber",
	        labelId: "RegistryUpload.table.documentNumber",
	        defaultMessage: "Номер документа"
	    }] : []), _toConsumableArray(hasDocDate ? [{ key: "documentDate", labelId: "RegistryUpload.table.documentDate", defaultMessage: "Дата документа" }] : []));
	
	    var normalizedData = data.map(function (el) {
	        var row = el && el.row ? el.row : {};
	        var hasError = Boolean(el && el.hasError);
	        var errors = el ? el.errors : undefined;
	
	        if (isFinStar) {
	            if (isEmptyValue(row.documentNumber)) {
	                hasError = true;
	                errors = addFieldError(errors, "documentNumber", intl.formatMessage({
	                    id: "RegistryUpload.error.documentNumberRequired",
	                    defaultMessage: "Номер документа обязателен для FinStar."
	                }));
	            }
	
	            if (isEmptyValue(row.documentDate)) {
	                hasError = true;
	                errors = addFieldError(errors, "documentDate", intl.formatMessage({
	                    id: "RegistryUpload.error.documentDateRequired",
	                    defaultMessage: "Дата документа обязательна для FinStar."
	                }));
	            }
	        }
	
	        return Object.assign({}, el, { row: row, hasError: hasError, errors: errors });
	    });
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.TableWrap },
	        _react2.default.createElement(
	            "table",
	            { className: _stylesModule2.default.Table },
	            _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    null,
	                    columns.map(function (c) {
	                        return _react2.default.createElement(
	                            "th",
	                            { key: c.key, className: _stylesModule2.default.HeaderCell },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: c.labelId, defaultMessage: c.defaultMessage })
	                        );
	                    }),
	                    _react2.default.createElement("th", { className: _stylesModule2.default.HeadCellToggle })
	                )
	            ),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                normalizedData.map(function (el, index) {
	                    return _react2.default.createElement(_TableRow2.default, {
	                        key: index,
	                        data: el.row,
	                        hasError: el.hasError,
	                        errors: el.errors,
	                        columns: columns
	                    });
	                })
	            )
	        )
	    );
	}

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTagAutocomplete = __webpack_require__(222);
	
	var _reactTagAutocomplete2 = _interopRequireDefault(_reactTagAutocomplete);
	
	var _stylesModule = __webpack_require__(577);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatisticTag = function (_Component) {
	    _inherits(StatisticTag, _Component);
	
	    function StatisticTag(props) {
	        _classCallCheck(this, StatisticTag);
	
	        var _this = _possibleConstructorReturn(this, (StatisticTag.__proto__ || Object.getPrototypeOf(StatisticTag)).call(this, props));
	
	        _this.state = {
	            tags: [],
	            initSuggestions: [],
	            suggestions: [],
	            filterProjects: props.filterProjects
	        };
	
	        _this.tagsList = props.tagsList;
	        _this.reactTags = _react2.default.createRef();
	        return _this;
	    }
	
	    _createClass(StatisticTag, [{
	        key: "handleDelete",
	        value: function handleDelete(i) {
	            var tags = this.state.tags.slice(0);
	            tags.splice(i, 1);
	            this.setState({ tags: tags });
	            this.props.onSelectedTag(tags);
	        }
	    }, {
	        key: "handleAddition",
	        value: function handleAddition(tag) {
	            this.setState({ tags: [].concat(_toConsumableArray(this.state.tags), [tag]) });
	            this.props.onSelectedTag([].concat(_toConsumableArray(this.state.tags), [tag]));
	        }
	    }, {
	        key: "onInput",
	        value: function onInput() {
	            var _this2 = this;
	
	            if (this.state.initSuggestions.length && this.state.filterProjects.length) {
	
	                var result = [];
	
	                this.state.filterProjects.map(function (project) {
	                    _this2.state.initSuggestions.forEach(function (tag) {
	                        if (String(tag.merchantUUID) === String(project)) {
	                            result.push(tag);
	                        }
	                    });
	
	                    return true;
	                });
	
	                this.setState({ suggestions: result });
	            } else {
	                this.setState({ suggestions: this.state.initSuggestions });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_reactTagAutocomplete2.default, {
	                ref: this.reactTags,
	                tags: this.state.tags,
	                suggestions: this.state.suggestions,
	                handleDelete: this.handleDelete.bind(this),
	                handleAddition: this.handleAddition.bind(this),
	                handleInputChange: this.onInput.bind(this),
	                allowNew: false,
	                autoresize: false,
	                placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043C\u0435\u0442\u043A\u0438 \u0434\u043B\u044F \u0444\u0438\u043B\u044C\u0440\u0430",
	                noSuggestionsText: "\u041C\u0435\u0442\u043E\u043A \u043D\u0435 \u043D\u0430\u0439\u043B\u0435\u043D\u043E",
	                addOnBlur: true,
	                minQueryLength: 1,
	                classNames: {
	                    root: _stylesModule2.default.Wrap,
	                    rootFocused: _stylesModule2.default.isFocused,
	                    selected: _stylesModule2.default.Selected,
	                    selectedTag: _stylesModule2.default.SelectedTag,
	                    selectedTagName: 'react-tags__selected-tag-name',
	                    search: _stylesModule2.default.Wrap,
	                    searchInput: _stylesModule2.default.Input,
	                    suggestions: _stylesModule2.default.Suggestions,
	                    suggestionActive: 'is-active',
	                    suggestionDisabled: 'is-disabled'
	                }
	            });
	        }
	    }], [{
	        key: "getDerivedStateFromProps",
	        value: function getDerivedStateFromProps(nextProps) {
	
	            return {
	                initSuggestions: nextProps.tagsList,
	                filterProjects: nextProps.filterProjects
	            };
	        }
	    }]);
	
	    return StatisticTag;
	}(_react.Component);
	
	exports.default = StatisticTag;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _styles = __webpack_require__(578);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var POLL_OPEN_MS = 7000;
	var POLL_MIN_MS = 30000;
	var VIEW_LIST = 'list';
	var VIEW_CHAT = 'chat';
	var VIEW_NEW = 'new';
	var EDIT_WINDOW_SEC = 15 * 60;
	
	/* ---------- icons (inline SVG, currentColor for theming) ---------- */
	
	var IconChat = function IconChat(_ref) {
	    var _ref$size = _ref.size,
	        size = _ref$size === undefined ? 26 : _ref$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', {
	            d: 'M4 5.5C4 4.12 5.12 3 6.5 3h11C18.88 3 20 4.12 20 5.5v8c0 1.38-1.12 2.5-2.5 2.5H10l-4 4v-4h-1.5C5.12 16 4 14.88 4 13.5v-8z',
	            stroke: 'currentColor',
	            strokeWidth: '1.8',
	            strokeLinejoin: 'round',
	            fill: 'rgba(255,255,255,0.04)'
	        }),
	        _react2.default.createElement('circle', { cx: '9', cy: '9.5', r: '1', fill: 'currentColor' }),
	        _react2.default.createElement('circle', { cx: '12', cy: '9.5', r: '1', fill: 'currentColor' }),
	        _react2.default.createElement('circle', { cx: '15', cy: '9.5', r: '1', fill: 'currentColor' })
	    );
	};
	
	var IconChevronDown = function IconChevronDown(_ref2) {
	    var _ref2$size = _ref2.size,
	        size = _ref2$size === undefined ? 22 : _ref2$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M6 9l6 6 6-6', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconArrowLeft = function IconArrowLeft(_ref3) {
	    var _ref3$size = _ref3.size,
	        size = _ref3$size === undefined ? 18 : _ref3$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M15 6l-6 6 6 6', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconPaperclip = function IconPaperclip(_ref4) {
	    var _ref4$size = _ref4.size,
	        size = _ref4$size === undefined ? 18 : _ref4$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', {
	            d: 'M21.44 11.05l-9.19 9.19a5.5 5.5 0 01-7.78-7.78l9.19-9.19a3.5 3.5 0 014.95 4.95l-8.83 8.83a1.5 1.5 0 01-2.12-2.12l7.41-7.41',
	            stroke: 'currentColor',
	            strokeWidth: '1.8',
	            strokeLinecap: 'round',
	            strokeLinejoin: 'round'
	        })
	    );
	};
	
	var IconSend = function IconSend(_ref5) {
	    var _ref5$size = _ref5.size,
	        size = _ref5$size === undefined ? 16 : _ref5$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M22 2L11 13', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	        _react2.default.createElement('path', { d: 'M22 2l-7 20-4-9-9-4 20-7z', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconPlus = function IconPlus(_ref6) {
	    var _ref6$size = _ref6.size,
	        size = _ref6$size === undefined ? 16 : _ref6$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M12 5v14M5 12h14', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round' })
	    );
	};
	
	var IconHeader = function IconHeader() {
	    return _react2.default.createElement(
	        'svg',
	        { width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', {
	            d: 'M4 5.5C4 4.12 5.12 3 6.5 3h11C18.88 3 20 4.12 20 5.5v8c0 1.38-1.12 2.5-2.5 2.5H10l-4 4v-4h-1.5C5.12 16 4 14.88 4 13.5v-8z',
	            stroke: '#fff',
	            strokeWidth: '1.6',
	            strokeLinejoin: 'round',
	            fill: 'rgba(255,255,255,0.12)'
	        })
	    );
	};
	
	var IconFile = function IconFile(_ref7) {
	    var _ref7$size = _ref7.size,
	        size = _ref7$size === undefined ? 14 : _ref7$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	        _react2.default.createElement('path', { d: 'M14 2v6h6', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconEmptyChat = function IconEmptyChat() {
	    return _react2.default.createElement(
	        'svg',
	        { width: '48', height: '48', viewBox: '0 0 48 48', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', {
	            d: 'M8 13.5C8 11.01 10.01 9 12.5 9h23C37.99 9 40 11.01 40 13.5v17C40 33 37.99 35 35.5 35H22l-8 8v-8h-1.5C10.01 35 8 33 8 30.5v-17z',
	            fill: '#6366f1',
	            opacity: '0.18'
	        }),
	        _react2.default.createElement('path', {
	            d: 'M8 13.5C8 11.01 10.01 9 12.5 9h23C37.99 9 40 11.01 40 13.5v17C40 33 37.99 35 35.5 35H22l-8 8v-8h-1.5C10.01 35 8 33 8 30.5v-17z',
	            stroke: '#6366f1',
	            strokeWidth: '2',
	            strokeLinejoin: 'round'
	        }),
	        _react2.default.createElement('circle', { cx: '17', cy: '22', r: '1.6', fill: '#6366f1' }),
	        _react2.default.createElement('circle', { cx: '24', cy: '22', r: '1.6', fill: '#6366f1' }),
	        _react2.default.createElement('circle', { cx: '31', cy: '22', r: '1.6', fill: '#6366f1' })
	    );
	};
	
	/* ---------- helpers ---------- */
	
	function statusLabel(status, intl) {
	    if (status === 'open') return intl.formatMessage({ id: 'SupportWidget.status.open', defaultMessage: 'Открыто' });
	    if (status === 'pending_user') return intl.formatMessage({ id: 'SupportWidget.status.pendingUser', defaultMessage: 'Ожидает ответа' });
	    if (status === 'closed') return intl.formatMessage({ id: 'SupportWidget.status.closed', defaultMessage: 'Закрыто' });
	    return status;
	}
	
	function statusClass(status) {
	    if (status === 'open') return _styles2.default.StatusOpen;
	    if (status === 'pending_user') return _styles2.default.StatusPendingUser;
	    if (status === 'closed') return _styles2.default.StatusClosed;
	    return _styles2.default.StatusOpen;
	}
	
	function timeAgo(iso, intl) {
	    if (!iso) return '';
	    var dt = new Date(iso);
	    var sec = Math.max(1, Math.floor((Date.now() - dt.getTime()) / 1000));
	    if (sec < 60) return intl.formatMessage({ id: 'SupportWidget.time.justNow', defaultMessage: 'только что' });
	    if (sec < 3600) return intl.formatMessage({ id: 'SupportWidget.time.minutesAgo', defaultMessage: '{count} мин назад' }, { count: Math.floor(sec / 60) });
	    if (sec < 86400) return intl.formatMessage({ id: 'SupportWidget.time.hoursAgo', defaultMessage: '{count} ч назад' }, { count: Math.floor(sec / 3600) });
	    if (sec < 86400 * 7) return intl.formatMessage({ id: 'SupportWidget.time.daysAgo', defaultMessage: '{count} д назад' }, { count: Math.floor(sec / 86400) });
	    return intl.formatDate(dt);
	}
	
	function fmtSize(bytes, intl) {
	    if (!bytes) return '';
	    if (bytes < 1024) return intl.formatMessage({ id: 'SupportWidget.size.bytes', defaultMessage: '{count} б' }, { count: bytes });
	    if (bytes < 1024 * 1024) return intl.formatMessage({ id: 'SupportWidget.size.kb', defaultMessage: '{count} КБ' }, { count: (bytes / 1024).toFixed(1) });
	    return intl.formatMessage({ id: 'SupportWidget.size.mb', defaultMessage: '{count} МБ' }, { count: (bytes / 1024 / 1024).toFixed(1) });
	}
	
	function avatarInitials(name) {
	    if (!name) return '?';
	    var parts = String(name).trim().split(/\s+/);
	    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	    return (parts[0][0] + parts[1][0]).toUpperCase();
	}
	
	/* ---------- main ---------- */
	
	var SupportWidget = function SupportWidget(_ref8) {
	    var token = _ref8.token,
	        isAuthorized = _ref8.isAuthorized,
	        adminPrivileges = _ref8.adminPrivileges;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        open = _useState2[0],
	        setOpen = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(VIEW_LIST),
	        _useState4 = _slicedToArray(_useState3, 2),
	        view = _useState4[0],
	        setView = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        tickets = _useState6[0],
	        setTickets = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        activeTicket = _useState8[0],
	        setActiveTicket = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        messages = _useState10[0],
	        setMessages = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(''),
	        _useState12 = _slicedToArray(_useState11, 2),
	        draftBody = _useState12[0],
	        setDraftBody = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(''),
	        _useState14 = _slicedToArray(_useState13, 2),
	        draftSubject = _useState14[0],
	        setDraftSubject = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        draftFiles = _useState16[0],
	        setDraftFiles = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0),
	        _useState18 = _slicedToArray(_useState17, 2),
	        unreadCount = _useState18[0],
	        setUnreadCount = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(false),
	        _useState20 = _slicedToArray(_useState19, 2),
	        sending = _useState20[0],
	        setSending = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(null),
	        _useState22 = _slicedToArray(_useState21, 2),
	        editingId = _useState22[0],
	        setEditingId = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(''),
	        _useState24 = _slicedToArray(_useState23, 2),
	        editingBody = _useState24[0],
	        setEditingBody = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(null),
	        _useState26 = _slicedToArray(_useState25, 2),
	        error = _useState26[0],
	        setError = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(false),
	        _useState28 = _slicedToArray(_useState27, 2),
	        dragging = _useState28[0],
	        setDragging = _useState28[1];
	
	    var fileInputRef = (0, _react.useRef)(null);
	    var lastUpdatedRef = (0, _react.useRef)(null);
	    var bodyRef = (0, _react.useRef)(null);
	    var location = (0, _reactRouterDom.useLocation)();
	
	    var api = (0, _react.useMemo)(function () {
	        return token ? new _Api2.default({ token: token }) : null;
	    }, [token]);
	    var isMerchantAuth = isAuthorized && !adminPrivileges;
	
	    /* ----- data loading ----- */
	
	    var loadTickets = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        if (api) {
	                            _context.next = 2;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 2:
	                        _context.prev = 2;
	                        _context.next = 5;
	                        return api.listMerchantTickets();
	
	                    case 5:
	                        data = _context.sent;
	
	                        setTickets(data.items || []);
	                        _context.next = 11;
	                        break;
	
	                    case 9:
	                        _context.prev = 9;
	                        _context.t0 = _context['catch'](2);
	
	                    case 11:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[2, 9]]);
	    })), [api]);
	
	    var loadMessages = (0, _react.useCallback)(function () {
	        var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(ticketId, useSince) {
	            var since, data, newest;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (api) {
	                                _context2.next = 2;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 2:
	                            _context2.prev = 2;
	                            since = useSince ? lastUpdatedRef.current : null;
	                            _context2.next = 6;
	                            return api.getMerchantTicketMessages(ticketId, since);
	
	                        case 6:
	                            data = _context2.sent;
	
	                            if (since) {
	                                if ((data.messages || []).length > 0) {
	                                    setMessages(function (prev) {
	                                        var map = new Map();
	                                        prev.forEach(function (m) {
	                                            return map.set(m.id, m);
	                                        });
	                                        (data.messages || []).forEach(function (m) {
	                                            return map.set(m.id, m);
	                                        });
	                                        return Array.from(map.values()).sort(function (a, b) {
	                                            return a.id - b.id;
	                                        });
	                                    });
	                                }
	                            } else {
	                                setMessages(data.messages || []);
	                            }
	                            newest = (data.messages || []).reduce(function (acc, m) {
	                                return acc && acc > m.updated_at ? acc : m.updated_at;
	                            }, lastUpdatedRef.current);
	
	                            if (newest) lastUpdatedRef.current = newest;
	                            _context2.next = 14;
	                            break;
	
	                        case 12:
	                            _context2.prev = 12;
	                            _context2.t0 = _context2['catch'](2);
	
	                        case 14:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[2, 12]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref10.apply(this, arguments);
	        };
	    }(), [api]);
	
	    var loadUnreadCount = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        if (api) {
	                            _context3.next = 2;
	                            break;
	                        }
	
	                        return _context3.abrupt('return');
	
	                    case 2:
	                        _context3.prev = 2;
	                        _context3.next = 5;
	                        return api.getMerchantTicketsUnreadCount();
	
	                    case 5:
	                        data = _context3.sent;
	
	                        setUnreadCount(data.count || 0);
	                        _context3.next = 11;
	                        break;
	
	                    case 9:
	                        _context3.prev = 9;
	                        _context3.t0 = _context3['catch'](2);
	
	                    case 11:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, undefined, [[2, 9]]);
	    })), [api]);
	
	    (0, _react.useEffect)(function () {
	        if (!isMerchantAuth) return undefined;
	        loadUnreadCount();
	        var i = setInterval(loadUnreadCount, POLL_MIN_MS);
	        return function () {
	            return clearInterval(i);
	        };
	    }, [isMerchantAuth, loadUnreadCount]);
	
	    (0, _react.useEffect)(function () {
	        if (!open || !activeTicket) return undefined;
	        loadMessages(activeTicket.id, false);
	        var i = setInterval(function () {
	            return loadMessages(activeTicket.id, true);
	        }, POLL_OPEN_MS);
	        return function () {
	            return clearInterval(i);
	        };
	    }, [open, activeTicket, loadMessages]);
	
	    (0, _react.useEffect)(function () {
	        if (!open || view !== VIEW_LIST) return;
	        loadTickets();
	    }, [open, view, loadTickets]);
	
	    // auto-scroll chat to bottom when messages change
	    (0, _react.useEffect)(function () {
	        if (view === VIEW_CHAT && bodyRef.current) {
	            bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
	        }
	    }, [messages, view]);
	
	    // listen for global event to open widget (from Support menu button)
	    (0, _react.useEffect)(function () {
	        if (!isMerchantAuth) return;
	        var handler = function handler() {
	            setOpen(true);
	            setView(VIEW_LIST);
	        };
	        window.addEventListener('open-support-widget', handler);
	        return function () {
	            return window.removeEventListener('open-support-widget', handler);
	        };
	    }, [isMerchantAuth]);
	
	    // deep-link from email: ?ticket=ID auto-opens that ticket
	    (0, _react.useEffect)(function () {
	        if (!isMerchantAuth) return;
	        var search = new URLSearchParams(location.search);
	        var tid = search.get('ticket');
	        if (!tid) return;
	        var ticketId = parseInt(tid, 10);
	        if (!ticketId) return;
	        _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	            var data;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            if (api) {
	                                _context4.next = 2;
	                                break;
	                            }
	
	                            return _context4.abrupt('return');
	
	                        case 2:
	                            _context4.prev = 2;
	                            _context4.next = 5;
	                            return api.getMerchantTicket(ticketId);
	
	                        case 5:
	                            data = _context4.sent;
	
	                            if (data && data.ticket) {
	                                setOpen(true);
	                                setView(VIEW_CHAT);
	                                setActiveTicket(data.ticket);
	                                setMessages(data.messages || []);
	                                lastUpdatedRef.current = (data.messages || []).reduce(function (acc, m) {
	                                    return acc && acc > m.updated_at ? acc : m.updated_at;
	                                }, null);
	                                api.markMerchantTicketRead(ticketId).catch(function () {});
	                            }
	                            _context4.next = 11;
	                            break;
	
	                        case 9:
	                            _context4.prev = 9;
	                            _context4.t0 = _context4['catch'](2);
	
	                        case 11:
	                        case 'end':
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined, [[2, 9]]);
	        }))();
	    }, [isMerchantAuth, api, location.search]);
	
	    if (!isMerchantAuth) return null;
	
	    /* ----- actions ----- */
	
	    var openTicket = function () {
	        var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(ticket) {
	            return _regenerator2.default.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            setView(VIEW_CHAT);
	                            setActiveTicket(ticket);
	                            setMessages([]);
	                            lastUpdatedRef.current = null;
	                            _context5.next = 6;
	                            return loadMessages(ticket.id, false);
	
	                        case 6:
	                            _context5.prev = 6;
	                            _context5.next = 9;
	                            return api.markMerchantTicketRead(ticket.id);
	
	                        case 9:
	                            loadUnreadCount();
	                            _context5.next = 14;
	                            break;
	
	                        case 12:
	                            _context5.prev = 12;
	                            _context5.t0 = _context5['catch'](6);
	
	                        case 14:
	                        case 'end':
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined, [[6, 12]]);
	        }));
	
	        return function openTicket(_x3) {
	            return _ref13.apply(this, arguments);
	        };
	    }();
	
	    var backToList = function backToList() {
	        setView(VIEW_LIST);
	        setActiveTicket(null);
	        setMessages([]);
	        lastUpdatedRef.current = null;
	        setEditingId(null);
	        setError(null);
	        loadTickets();
	        loadUnreadCount();
	    };
	
	    var startNewTicket = function startNewTicket() {
	        setView(VIEW_NEW);
	        setDraftSubject('');
	        setDraftBody('');
	        setDraftFiles([]);
	        setError(null);
	    };
	
	    var onPickFiles = function onPickFiles(filesList) {
	        var arr = Array.from(filesList || []);
	        var total = draftFiles.length + arr.length;
	        if (total > 10) {
	            setError(intl.formatMessage({ id: 'SupportWidget.error.maxFiles', defaultMessage: 'Не более 10 файлов на сообщение.' }));
	            return;
	        }
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var f = _step.value;
	
	                if (f.size > 25 * 1024 * 1024) {
	                    setError(intl.formatMessage({ id: 'SupportWidget.error.fileTooLarge', defaultMessage: 'Файл "{name}" больше 25 МБ.' }, { name: f.name }));
	                    return;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        setError(null);
	        setDraftFiles([].concat(_toConsumableArray(draftFiles), _toConsumableArray(arr)));
	    };
	
	    var removeDraftFile = function removeDraftFile(idx) {
	        var next = [].concat(_toConsumableArray(draftFiles));
	        next.splice(idx, 1);
	        setDraftFiles(next);
	    };
	
	    var submitNewTicket = function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	            var data;
	            return _regenerator2.default.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            if (draftSubject.trim()) {
	                                _context6.next = 3;
	                                break;
	                            }
	
	                            setError(intl.formatMessage({ id: 'SupportWidget.error.subjectRequired', defaultMessage: 'Укажите тему обращения.' }));
	                            return _context6.abrupt('return');
	
	                        case 3:
	                            if (!(!draftBody.trim() && draftFiles.length === 0)) {
	                                _context6.next = 6;
	                                break;
	                            }
	
	                            setError(intl.formatMessage({
	                                id: 'SupportWidget.error.bodyOrFileRequired',
	                                defaultMessage: 'Опишите ваш вопрос или прикрепите файл.'
	                            }));
	                            return _context6.abrupt('return');
	
	                        case 6:
	                            setSending(true);
	                            setError(null);
	                            _context6.prev = 8;
	                            _context6.next = 11;
	                            return api.createMerchantTicket(draftSubject.trim(), draftBody, draftFiles);
	
	                        case 11:
	                            data = _context6.sent;
	
	                            setDraftSubject('');
	                            setDraftBody('');
	                            setDraftFiles([]);
	                            _context6.next = 17;
	                            return loadTickets();
	
	                        case 17:
	                            if (data && data.ticket) {
	                                openTicket(data.ticket);
	                            } else {
	                                setView(VIEW_LIST);
	                            }
	                            _context6.next = 23;
	                            break;
	
	                        case 20:
	                            _context6.prev = 20;
	                            _context6.t0 = _context6['catch'](8);
	
	                            setError(_context6.t0.response && _context6.t0.response.data && _context6.t0.response.data.message || intl.formatMessage({ id: 'SupportWidget.error.send', defaultMessage: 'Не удалось отправить.' }));
	
	                        case 23:
	                            _context6.prev = 23;
	
	                            setSending(false);
	                            return _context6.finish(23);
	
	                        case 26:
	                        case 'end':
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined, [[8, 20, 23, 26]]);
	        }));
	
	        return function submitNewTicket() {
	            return _ref14.apply(this, arguments);
	        };
	    }();
	
	    var submitMessage = function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	            return _regenerator2.default.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            if (activeTicket) {
	                                _context7.next = 2;
	                                break;
	                            }
	
	                            return _context7.abrupt('return');
	
	                        case 2:
	                            if (!(!draftBody.trim() && draftFiles.length === 0)) {
	                                _context7.next = 4;
	                                break;
	                            }
	
	                            return _context7.abrupt('return');
	
	                        case 4:
	                            setSending(true);
	                            setError(null);
	                            _context7.prev = 6;
	                            _context7.next = 9;
	                            return api.postMerchantTicketMessage(activeTicket.id, draftBody, draftFiles);
	
	                        case 9:
	                            setDraftBody('');
	                            setDraftFiles([]);
	                            _context7.next = 13;
	                            return loadMessages(activeTicket.id, false);
	
	                        case 13:
	                            _context7.next = 18;
	                            break;
	
	                        case 15:
	                            _context7.prev = 15;
	                            _context7.t0 = _context7['catch'](6);
	
	                            setError(_context7.t0.response && _context7.t0.response.data && _context7.t0.response.data.message || intl.formatMessage({ id: 'SupportWidget.error.send', defaultMessage: 'Не удалось отправить.' }));
	
	                        case 18:
	                            _context7.prev = 18;
	
	                            setSending(false);
	                            return _context7.finish(18);
	
	                        case 21:
	                        case 'end':
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined, [[6, 15, 18, 21]]);
	        }));
	
	        return function submitMessage() {
	            return _ref15.apply(this, arguments);
	        };
	    }();
	
	    var startEdit = function startEdit(m) {
	        setEditingId(m.id);setEditingBody(m.body);
	    };
	    var cancelEdit = function cancelEdit() {
	        setEditingId(null);setEditingBody('');
	    };
	    var saveEdit = function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	            return _regenerator2.default.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            if (!(!editingId || !activeTicket)) {
	                                _context8.next = 2;
	                                break;
	                            }
	
	                            return _context8.abrupt('return');
	
	                        case 2:
	                            _context8.prev = 2;
	                            _context8.next = 5;
	                            return api.editMerchantTicketMessage(activeTicket.id, editingId, editingBody);
	
	                        case 5:
	                            cancelEdit();
	                            _context8.next = 8;
	                            return loadMessages(activeTicket.id, false);
	
	                        case 8:
	                            _context8.next = 13;
	                            break;
	
	                        case 10:
	                            _context8.prev = 10;
	                            _context8.t0 = _context8['catch'](2);
	
	                            setError(_context8.t0.response && _context8.t0.response.data && _context8.t0.response.data.message || intl.formatMessage({ id: 'SupportWidget.error.save', defaultMessage: 'Не удалось сохранить.' }));
	
	                        case 13:
	                        case 'end':
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, undefined, [[2, 10]]);
	        }));
	
	        return function saveEdit() {
	            return _ref16.apply(this, arguments);
	        };
	    }();
	
	    var downloadAttachment = function downloadAttachment(att) {
	        if (att.purged || !activeTicket) return;
	        api.downloadMerchantTicketAttachment(activeTicket.id, att.id, att.filename).catch(function () {});
	    };
	
	    var onDrop = function onDrop(e) {
	        e.preventDefault();
	        setDragging(false);
	        if (e.dataTransfer && e.dataTransfer.files) {
	            onPickFiles(e.dataTransfer.files);
	        }
	    };
	
	    /* ----- renderers ----- */
	
	    var renderMessage = function renderMessage(m, lastOwnId) {
	        var isMine = m.author_type === 'user';
	        var isLastMine = isMine && m.id === lastOwnId;
	        var ageSec = (Date.now() - new Date(m.created_at).getTime()) / 1000;
	        var editable = isLastMine && !m.deleted && ageSec <= EDIT_WINDOW_SEC;
	
	        return _react2.default.createElement(
	            'div',
	            { key: m.id, className: _styles2.default.MsgRow + ' ' + (isMine ? _styles2.default.MsgRowMine : '') },
	            !isMine && _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Avatar + ' ' + _styles2.default.AvatarSupport },
	                'S'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.MsgGroup },
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.MsgBubble + ' ' + (isMine ? _styles2.default.MsgBubbleMine : '') + ' ' + (m.deleted ? _styles2.default.MsgBubbleDeleted : '') },
	                    editingId === m.id ? _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EditForm },
	                        _react2.default.createElement('textarea', {
	                            className: _styles2.default.EditFormArea,
	                            value: editingBody,
	                            onChange: function onChange(e) {
	                                return setEditingBody(e.target.value);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.EditActions },
	                            _react2.default.createElement(
	                                'button',
	                                { className: _styles2.default.EditSave, onClick: saveEdit },
	                                intl.formatMessage({ id: 'SupportWidget.edit.save', defaultMessage: 'Сохранить' })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: _styles2.default.EditCancel, onClick: cancelEdit },
	                                intl.formatMessage({ id: 'SupportWidget.edit.cancel', defaultMessage: 'Отмена' })
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        _react.Fragment,
	                        null,
	                        m.deleted ? intl.formatMessage({ id: 'SupportWidget.message.deleted', defaultMessage: 'сообщение удалено' }) : m.body,
	                        (m.attachments || []).map(function (a) {
	                            return a.purged ? _react2.default.createElement(
	                                'span',
	                                { key: a.id, className: _styles2.default.AttachmentPurged },
	                                _react2.default.createElement(IconFile, null),
	                                ' ',
	                                intl.formatMessage({
	                                    id: 'SupportWidget.attachment.purged',
	                                    defaultMessage: 'файл удалён по сроку хранения'
	                                })
	                            ) : _react2.default.createElement(
	                                'button',
	                                {
	                                    key: a.id,
	                                    type: 'button',
	                                    className: _styles2.default.AttachmentChip,
	                                    onClick: function onClick() {
	                                        return downloadAttachment(a);
	                                    },
	                                    title: a.filename + ' \xB7 ' + fmtSize(a.size_bytes, intl)
	                                },
	                                _react2.default.createElement(IconFile, null),
	                                ' ',
	                                a.filename
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.MsgFooter },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        timeAgo(m.created_at, intl)
	                    ),
	                    m.edited && _react2.default.createElement(
	                        'span',
	                        { className: _styles2.default.MsgEditedTag },
	                        '\xB7 ',
	                        intl.formatMessage({ id: 'SupportWidget.message.edited', defaultMessage: 'изменено' })
	                    ),
	                    editable && _react2.default.createElement(
	                        'button',
	                        {
	                            className: _styles2.default.EditMsgBtn,
	                            onClick: function onClick() {
	                                return startEdit(m);
	                            },
	                            title: intl.formatMessage({ id: 'SupportWidget.edit.title', defaultMessage: 'Редактировать' })
	                        },
	                        '\u270E'
	                    )
	                )
	            )
	        );
	    };
	
	    var lastOwnId = function () {
	        for (var i = messages.length - 1; i >= 0; i--) {
	            if (messages[i].author_type === 'user' && !messages[i].deleted) return messages[i].id;
	        }
	        return null;
	    }();
	
	    var headerTitle = view === VIEW_LIST ? intl.formatMessage({ id: 'SupportWidget.header.listTitle', defaultMessage: 'Поддержка' }) : view === VIEW_CHAT && activeTicket ? activeTicket.subject : intl.formatMessage({ id: 'SupportWidget.header.newTitle', defaultMessage: 'Новое обращение' });
	
	    var headerSubtitle = view === VIEW_LIST ? intl.formatMessage({ id: 'SupportWidget.header.listSubtitle', defaultMessage: 'Мы обычно отвечаем в течение часа' }) : view === VIEW_CHAT ? null : intl.formatMessage({ id: 'SupportWidget.header.newSubtitle', defaultMessage: 'Опишите ваш вопрос, мы поможем' });
	
	    var showComposer = view === VIEW_NEW || view === VIEW_CHAT && activeTicket && activeTicket.status !== 'closed';
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            'button',
	            {
	                className: _styles2.default.Fab,
	                onClick: function onClick() {
	                    return setOpen(!open);
	                },
	                title: open ? intl.formatMessage({ id: 'SupportWidget.action.collapse', defaultMessage: 'Свернуть' }) : intl.formatMessage({ id: 'SupportWidget.header.listTitle', defaultMessage: 'Поддержка' }),
	                'aria-label': intl.formatMessage({ id: 'SupportWidget.header.listTitle', defaultMessage: 'Поддержка' })
	            },
	            open ? _react2.default.createElement(IconChevronDown, null) : _react2.default.createElement(IconChat, null),
	            !open && unreadCount > 0 && _react2.default.createElement(
	                'span',
	                { className: _styles2.default.Badge },
	                unreadCount
	            )
	        ),
	        open && _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Panel },
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Header },
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.HeaderTopRow },
	                    view === VIEW_CHAT || view === VIEW_NEW ? _react2.default.createElement(
	                        'button',
	                        {
	                            className: _styles2.default.HeaderBtn,
	                            onClick: view === VIEW_NEW ? function () {
	                                return setView(VIEW_LIST);
	                            } : backToList,
	                            title: intl.formatMessage({ id: 'SupportWidget.action.back', defaultMessage: 'Назад' })
	                        },
	                        _react2.default.createElement(IconArrowLeft, null)
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.HeaderIcon },
	                        _react2.default.createElement(IconHeader, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.HeaderTitleBlock },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.HeaderTitle },
	                            headerTitle
	                        ),
	                        headerSubtitle && _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.HeaderSubtitle },
	                            headerSubtitle
	                        ),
	                        view === VIEW_CHAT && activeTicket && _react2.default.createElement(
	                            'span',
	                            { className: _styles2.default.StatusChipHeader, style: { marginTop: 6 } },
	                            statusLabel(activeTicket.status, intl)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _styles2.default.HeaderBtn,
	                            onClick: function onClick() {
	                                return setOpen(false);
	                            },
	                            title: intl.formatMessage({ id: 'SupportWidget.action.collapse', defaultMessage: 'Свернуть' })
	                        },
	                        _react2.default.createElement(IconChevronDown, { size: 18 })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                {
	                    ref: bodyRef,
	                    className: _styles2.default.Body + ' ' + (dragging ? _styles2.default.BodyDropActive : ''),
	                    onDragOver: function onDragOver(e) {
	                        if (view !== VIEW_LIST) {
	                            e.preventDefault();setDragging(true);
	                        }
	                    },
	                    onDragLeave: function onDragLeave() {
	                        return setDragging(false);
	                    },
	                    onDrop: onDrop
	                },
	                view === VIEW_LIST && (tickets.length === 0 ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Empty },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EmptyIllustration },
	                        _react2.default.createElement(IconEmptyChat, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EmptyTitle },
	                        intl.formatMessage({ id: 'SupportWidget.empty.listTitle', defaultMessage: 'Задайте вопрос поддержке' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EmptyText },
	                        intl.formatMessage({
	                            id: 'SupportWidget.empty.listText',
	                            defaultMessage: 'Опишите проблему, прикрепите скриншоты или документы — мы ответим как можно быстрее.'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _styles2.default.NewBtn, onClick: startNewTicket },
	                        _react2.default.createElement(IconPlus, null),
	                        intl.formatMessage({ id: 'SupportWidget.action.createTicket', defaultMessage: 'Создать обращение' })
	                    )
	                ) : _react2.default.createElement(
	                    _react.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _styles2.default.NewBtn + ' ' + _styles2.default.NewBtnFull,
	                            onClick: startNewTicket
	                        },
	                        _react2.default.createElement(IconPlus, null),
	                        intl.formatMessage({ id: 'SupportWidget.action.createTicket', defaultMessage: 'Создать обращение' })
	                    ),
	                    tickets.map(function (t) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.TicketCard, key: t.id, onClick: function onClick() {
	                                    return openTicket(t);
	                                } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _styles2.default.TicketCardTop },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _styles2.default.TicketCardSubject + ' ' + (t.unread ? _styles2.default.TicketCardSubjectUnread : '') },
	                                    t.subject
	                                ),
	                                t.unread && _react2.default.createElement('span', { className: _styles2.default.UnreadDot })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _styles2.default.TicketCardMeta },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _styles2.default.StatusChip + ' ' + statusClass(t.status) },
	                                    statusLabel(t.status, intl)
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    timeAgo(t.last_message_at || t.updated_at, intl)
	                                )
	                            )
	                        );
	                    })
	                )),
	                view === VIEW_CHAT && (messages.length === 0 ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Empty },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EmptyIllustration },
	                        _react2.default.createElement(IconEmptyChat, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EmptyText },
	                        intl.formatMessage({ id: 'SupportWidget.empty.chat', defaultMessage: 'Начните диалог — сообщения появятся здесь.' })
	                    )
	                ) : _react2.default.createElement(
	                    _react.Fragment,
	                    null,
	                    messages.map(function (m) {
	                        return renderMessage(m, lastOwnId);
	                    })
	                )),
	                view === VIEW_NEW && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.NewForm },
	                    _react2.default.createElement('input', {
	                        className: _styles2.default.SubjectInput,
	                        placeholder: intl.formatMessage({ id: 'SupportWidget.placeholder.subject', defaultMessage: 'Тема обращения' }),
	                        value: draftSubject,
	                        onChange: function onChange(e) {
	                            return setDraftSubject(e.target.value.slice(0, 120));
	                        },
	                        maxLength: 120,
	                        autoFocus: true
	                    }),
	                    _react2.default.createElement('textarea', {
	                        className: _styles2.default.NewBodyArea,
	                        placeholder: intl.formatMessage({ id: 'SupportWidget.placeholder.details', defaultMessage: 'Опишите ваш вопрос подробнее...' }),
	                        value: draftBody,
	                        onChange: function onChange(e) {
	                            return setDraftBody(e.target.value);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.FormHint },
	                        intl.formatMessage({
	                            id: 'SupportWidget.hint.attachments',
	                            defaultMessage: 'Можно прикрепить до 10 файлов (до 25 МБ каждый): скриншоты, документы, видео.'
	                        })
	                    )
	                )
	            ),
	            showComposer && _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Composer },
	                error && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.ErrorMsg },
	                    error
	                ),
	                draftFiles.length > 0 && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.AttachPreviewList },
	                    draftFiles.map(function (f, idx) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: idx, className: _styles2.default.AttachPreview },
	                            _react2.default.createElement(IconFile, null),
	                            ' ',
	                            f.name,
	                            ' \xB7 ',
	                            fmtSize(f.size, intl),
	                            _react2.default.createElement(
	                                'button',
	                                { className: _styles2.default.AttachRemove, onClick: function onClick() {
	                                        return removeDraftFile(idx);
	                                    } },
	                                '\xD7'
	                            )
	                        );
	                    })
	                ),
	                view === VIEW_CHAT && _react2.default.createElement('textarea', {
	                    className: _styles2.default.ComposerArea,
	                    placeholder: intl.formatMessage({ id: 'SupportWidget.placeholder.message', defaultMessage: 'Сообщение...' }),
	                    value: draftBody,
	                    onChange: function onChange(e) {
	                        return setDraftBody(e.target.value);
	                    },
	                    rows: 2
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.ComposerToolbar },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: _styles2.default.IconBtn,
	                            onClick: function onClick() {
	                                return fileInputRef.current && fileInputRef.current.click();
	                            },
	                            title: intl.formatMessage({ id: 'SupportWidget.action.attachFile', defaultMessage: 'Прикрепить файл' })
	                        },
	                        _react2.default.createElement(IconPaperclip, null)
	                    ),
	                    _react2.default.createElement('input', {
	                        ref: fileInputRef,
	                        type: 'file',
	                        multiple: true,
	                        className: _styles2.default.HiddenFile,
	                        onChange: function onChange(e) {
	                            return onPickFiles(e.target.files);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _styles2.default.SendBtn,
	                            disabled: sending,
	                            onClick: view === VIEW_NEW ? submitNewTicket : submitMessage
	                        },
	                        _react2.default.createElement(IconSend, null),
	                        sending ? intl.formatMessage({ id: 'SupportWidget.action.sending', defaultMessage: 'Отправка...' }) : view === VIEW_NEW ? intl.formatMessage({
	                            id: 'SupportWidget.action.createTicket',
	                            defaultMessage: 'Создать обращение'
	                        }) : intl.formatMessage({
	                            id: 'SupportWidget.action.send',
	                            defaultMessage: 'Отправить'
	                        })
	                    )
	                )
	            ),
	            view === VIEW_CHAT && activeTicket && activeTicket.status === 'closed' && _react2.default.createElement(
	                'div',
	                { className: _styles2.default.ComposerClosedNote },
	                intl.formatMessage({
	                    id: 'SupportWidget.closedNote',
	                    defaultMessage: 'Обращение закрыто. Создайте новое, если нужна помощь.'
	                })
	            )
	        )
	    );
	};
	
	exports.default = (0, _Auth.withAuth)(SupportWidget);

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(579);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PROVIDER_CONFIGS = {
	    hydracode: {
	        label: "Hydracode",
	        description: "Шлюз Hydracode",
	        processingId: 25,
	        dataKey: "processingAuth",
	        namePattern: /hydra/i,
	        fields: [{ key: "baseUrl", label: "Адрес API", type: "text", required: true, defaultValue: "https://engine.hydracode.com", placeholder: "https://engine.hydracode.com", hint: "Только домен, без пути (например https://engine.hydracode.com)" }, { key: "apiKey", label: "API ключ", type: "text", required: true, sensitive: true, placeholder: "API ключ" }, { key: "signingKey", label: "Ключ подписи", type: "text", required: false, sensitive: true, placeholder: "Ключ подписи" }]
	    },
	    paycraft: {
	        label: "Paycraft",
	        description: "Обработка Paycraft",
	        processingId: 27,
	        dataKey: "paycraft",
	        namePattern: /paycraft|craft/i,
	        fields: [{ key: "baseUrl", label: "Адрес API", type: "text", required: true, placeholder: "https://api.example.com", hint: "Только домен, без пути" }, { key: "h2hPoint", label: "Точка H2H", type: "text", required: true, placeholder: "ID точки H2H" }, { key: "widgetPoint", label: "Точка виджета", type: "text", required: true, placeholder: "ID точки виджета" }, { key: "privateKeyH2H", label: "Приватный ключ H2H", type: "textarea", required: true, sensitive: true, placeholder: "-----BEGIN PRIVATE KEY-----" }, { key: "privateKeyWidget", label: "Приватный ключ виджета", type: "textarea", required: true, sensitive: true, placeholder: "-----BEGIN PRIVATE KEY-----" }, { key: "h2hEndpoint", label: "Адрес H2H", type: "text", required: false, placeholder: "По умолчанию: не задан" }, { key: "widgetEndpoint", label: "Адрес виджета", type: "text", required: false, placeholder: "По умолчанию: не задан" }, { key: "serviceH2H", label: "Сервис H2H", type: "number", required: false, defaultValue: 2, placeholder: "По умолчанию: 2" }, { key: "serviceWidget", label: "Сервис виджета", type: "number", required: false, defaultValue: 3, placeholder: "По умолчанию: 3" }, { key: "sourceCode", label: "Код источника", type: "text", required: false, defaultValue: "ELQR", placeholder: "По умолчанию: ELQR" }]
	    },
	    finstar: {
	        label: "FinStar",
	        description: "FinStar (4pmts)",
	        processingId: 26,
	        dataKey: "finstar",
	        namePattern: /fin/i,
	        fields: [{ key: "merchantId", label: "ID мерчанта", type: "text", required: true, placeholder: "ID мерчанта" }, { key: "pubKeyId", label: "ID публичного ключа", type: "text", required: true, placeholder: "ID публичного ключа" }, { key: "privateKey", label: "Приватный ключ", type: "textarea", required: true, sensitive: true, placeholder: "-----BEGIN PRIVATE KEY-----" }, { key: "baseUrl", label: "Адрес API", type: "text", required: false, defaultValue: "https://api.4pmts.com", placeholder: "По умолчанию: https://api.4pmts.com" }, { key: "shopIdCard", label: "ID магазина для карт", type: "number", required: false, defaultValue: 302, placeholder: "По умолчанию: 302" }, { key: "shopIdSbp", label: "ID магазина для СБП", type: "number", required: false, defaultValue: 303, placeholder: "По умолчанию: 303" }, { key: "pointId", label: "ID точки", type: "text", required: false, placeholder: "По умолчанию: не задан" }, { key: "recipientType", label: "Тип получателя", type: "number", required: false, defaultValue: 1, placeholder: "По умолчанию: 1" }]
	    },
	    tkb: {
	        label: "TransCapitalBank",
	        description: "Обработка TKB",
	        processingId: 8,
	        dataKey: "processingAuth",
	        namePattern: /tkb|transcapital/i,
	        fields: [{ key: "login", label: "Логин", type: "text", required: true, placeholder: "Логин" }, { key: "secret", label: "Секрет", type: "text", required: true, sensitive: true, placeholder: "Секрет" }]
	    },
	    crm: {
	        label: "CRM",
	        description: "Только CRM выплаты (внутренний API)",
	        dataKey: null,
	        namePattern: /crm/i,
	        fields: []
	    }
	};
	
	var PROVIDER_KEYS = ["hydracode", "paycraft", "finstar", "tkb", "crm"];
	
	function maskSensitive(value) {
	    if (!value || typeof value !== "string") return "";
	    if (value.length <= 8) return "****";
	    return value.substring(0, 4) + "..." + value.substring(value.length - 4);
	}
	
	/**
	 * TerminalAddWizard — 6-шаговый визард создания терминала.
	 *
	 * Props:
	 *   token (string)
	 *   onCreated (function) — вызывается после успешного создания
	 *   onClose (function) — закрыть визард
	 */
	function TerminalAddWizard(props) {
	    var token = props.token;
	    var onCreated = props.onCreated;
	    var onClose = props.onClose;
	
	    var _msg = (0, _react.useContext)(_MessageContext2.default);
	    var onMessage = _msg.onMessage;
	
	    // Current step (1-6)
	    var _step = (0, _react.useState)(1);
	    var step = _step[0];
	    var setStep = _step[1];
	
	    // Data sources
	    var _projects = (0, _react.useState)([]);
	    var projects = _projects[0];
	    var setProjects = _projects[1];
	
	    var _loading = (0, _react.useState)(true);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _creating = (0, _react.useState)(false);
	    var creating = _creating[0];
	    var setCreating = _creating[1];
	
	    // Project search
	    var _projectSearch = (0, _react.useState)("");
	    var projectSearch = _projectSearch[0];
	    var setProjectSearch = _projectSearch[1];
	
	    var _projectDropOpen = (0, _react.useState)(false);
	    var projectDropOpen = _projectDropOpen[0];
	    var setProjectDropOpen = _projectDropOpen[1];
	
	    // Form data
	    var _form = (0, _react.useState)({
	        projectUuid: "",
	        name: "",
	        status: 1,
	        providerKey: "",
	        providerName: "",
	        providerAuth: {},
	        isSBP: false,
	        h2h: false,
	        preAuth: false,
	        recurring: false,
	        partialRefund: false,
	        partialReversal: false,
	        crmPayoutEnabled: false,
	        crmSbpPayoutEnabled: false,
	        unlimcoPayoutEnabled: false,
	        paymentMethod: "",
	        feePaymentCost: "",
	        feePaymentFixed: "",
	        feePaymentMin: "",
	        feePayoutCost: "",
	        feePayoutFixed: "",
	        feePayoutMin: "",
	        feeRefundCost: "",
	        feeRefundFixed: "",
	        feeRefundMin: ""
	    });
	    var form = _form[0];
	    var setForm = _form[1];
	
	    // Load projects and providers on mount
	    (0, _react.useEffect)(function () {
	        var api = new _Api2.default({ token: token });
	
	        api.getProjectsList({ page: 1, itemsPerPage: 10000, order: "DESC", filters: [] }).then(function (result) {
	            setProjects(result && result.data ? result.data : []);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setLoading(false);
	        });
	    }, [token]);
	
	    function _onChange(field, value) {
	        var next = {};
	        for (var k in form) {
	            next[k] = form[k];
	        }
	        next[field] = value;
	        setForm(next);
	    }
	
	    function onProviderSelect(key) {
	        var next = {};
	        for (var k in form) {
	            next[k] = form[k];
	        }
	        next.providerKey = key;
	        next.providerAuth = {};
	        if (key === "crm") {
	            next.crmPayoutEnabled = true;
	        }
	        setForm(next);
	    }
	
	    function onAuthChange(fieldKey, value) {
	        var next = {};
	        for (var k in form) {
	            next[k] = form[k];
	        }
	        var authCopy = {};
	        for (var ak in form.providerAuth) {
	            authCopy[ak] = form.providerAuth[ak];
	        }
	        authCopy[fieldKey] = value;
	        next.providerAuth = authCopy;
	        setForm(next);
	    }
	
	    function canGoNext() {
	        if (step === 1) {
	            return form.projectUuid !== "" && form.name.trim() !== "";
	        }
	        if (step === 2) {
	            return form.providerKey !== "" && form.providerName.trim() !== "";
	        }
	        if (step === 3) {
	            var cfg = PROVIDER_CONFIGS[form.providerKey];
	            if (!cfg) return false;
	            if (cfg.fields.length === 0) return true;
	            for (var i = 0; i < cfg.fields.length; i++) {
	                var f = cfg.fields[i];
	                if (f.required) {
	                    var val = form.providerAuth[f.key];
	                    if (val === undefined || val === null || String(val).trim() === "") {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        if (step === 4) {
	            if (form.providerKey === "crm") return true;
	            return form.paymentMethod !== "";
	        }
	        // step 5 (fees) — always OK (optional)
	        return true;
	    }
	
	    function goNext() {
	        if (step < 6) setStep(step + 1);
	    }
	
	    function goBack() {
	        if (step > 1) setStep(step - 1);
	    }
	
	    function getProjectName() {
	        for (var i = 0; i < projects.length; i++) {
	            if (projects[i] && projects[i].uuid === form.projectUuid) {
	                return projects[i].name || projects[i].uuid;
	            }
	        }
	        return form.projectUuid || "\u2014";
	    }
	
	    function buildAuthData() {
	        var cfg = PROVIDER_CONFIGS[form.providerKey];
	        if (!cfg) return {};
	        var authData = {};
	        for (var i = 0; i < cfg.fields.length; i++) {
	            var f = cfg.fields[i];
	            var val = form.providerAuth[f.key];
	            if (val !== undefined && val !== null && String(val).trim() !== "") {
	                if (f.type === "number") {
	                    authData[f.key] = Number(val);
	                } else {
	                    authData[f.key] = val;
	                }
	            } else if (f.defaultValue !== undefined) {
	                authData[f.key] = f.defaultValue;
	            }
	        }
	        return authData;
	    }
	
	    function create() {
	        if (creating) return;
	        setCreating(true);
	
	        var api = new _Api2.default({ token: token });
	        var data = {
	            isSBP: form.paymentMethod === "SBP_CROSS_BORDER",
	            h2h: !!form.h2h,
	            preAuth: !!form.preAuth,
	            recurring: !!form.recurring,
	            partialRefund: !!form.partialRefund,
	            partialReversal: !!form.partialReversal,
	            crmPayoutEnabled: !!form.crmPayoutEnabled,
	            crmSbpPayoutEnabled: !!form.crmSbpPayoutEnabled,
	            unlimcoPayoutEnabled: !!form.unlimcoPayoutEnabled,
	            paymentMethod: form.paymentMethod || null
	        };
	
	        // Auto-set payout mode for payout-only providers (TKB, FinStar, CRM)
	        var payoutOnlyProviderKeys = ["finstar", "tkb", "crm"];
	        if (payoutOnlyProviderKeys.indexOf(form.providerKey) !== -1) {
	            data.payoutOnly = true;
	            data.crmPayout = { enabled: true };
	        }
	
	        // Add fees if any were entered
	        var hasFees = form.feePaymentCost || form.feePaymentFixed || form.feePaymentMin || form.feePayoutCost || form.feePayoutFixed || form.feePayoutMin || form.feeRefundCost || form.feeRefundFixed || form.feeRefundMin;
	        if (hasFees) {
	            data.fee = {
	                payment: {
	                    cost: form.feePaymentCost ? parseFloat(form.feePaymentCost) : 0,
	                    fixedPerTransaction: form.feePaymentFixed ? parseFloat(form.feePaymentFixed) : 0,
	                    costFixedMinimum: form.feePaymentMin ? parseFloat(form.feePaymentMin) : 0
	                },
	                payout: {
	                    cost: form.feePayoutCost ? parseFloat(form.feePayoutCost) : 0,
	                    fixedPerTransaction: form.feePayoutFixed ? parseFloat(form.feePayoutFixed) : 0,
	                    costFixedMinimum: form.feePayoutMin ? parseFloat(form.feePayoutMin) : 0
	                },
	                refund: {
	                    cost: form.feeRefundCost ? parseFloat(form.feeRefundCost) : 0,
	                    fixedPerTransaction: form.feeRefundFixed ? parseFloat(form.feeRefundFixed) : 0,
	                    costFixedMinimum: form.feeRefundMin ? parseFloat(form.feeRefundMin) : 0
	                }
	            };
	        }
	
	        // Inject provider auth into data
	        var cfg = PROVIDER_CONFIGS[form.providerKey];
	        if (cfg && cfg.dataKey) {
	            data[cfg.dataKey] = buildAuthData();
	        }
	
	        var payload = {
	            name: form.name,
	            status: parseInt(form.status, 10),
	            data: data,
	            providerName: form.providerName.trim()
	        };
	
	        // Привязка к processing по выбранному провайдеру
	        if (cfg && cfg.processingId) {
	            payload.processing_id = cfg.processingId;
	        }
	
	        api.createTerminal(form.projectUuid, payload).then(function (created) {
	            onMessage({
	                type: "success",
	                message: "\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u0441\u043E\u0437\u0434\u0430\u043D"
	            });
	            if (typeof onCreated === "function") onCreated(created);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({
	                type: "error",
	                message: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430"
	            });
	            setCreating(false);
	        });
	    }
	
	    // Methods definitions (isSBP убран — управляется через "Способ оплаты")
	    var methods = [{ key: "h2h", label: "Человек к человеку", desc: "Прямое подключение без платёжной формы (host-to-host)" }, { key: "preAuth", label: "\u041F\u0440\u0435\u0434\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F", desc: "\u0411\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u0443\u043C\u043C\u044B \u043D\u0430 \u043A\u0430\u0440\u0442\u0435 \u0431\u0435\u0437 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u2014 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043E\u0437\u0436\u0435 \u0432\u0440\u0443\u0447\u043D\u0443\u044E" }, { key: "recurring", label: "\u0420\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442", desc: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0435 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043F\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0451\u043D\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435 \u0431\u0435\u0437 \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430" }, { key: "partialRefund", label: "\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442", desc: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u0447\u0430\u0441\u0442\u0438 \u0441\u0443\u043C\u043C\u044B \u043F\u043E\u0441\u043B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430" }, { key: "partialReversal", label: "\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u0430\u044F \u043E\u0442\u043C\u0435\u043D\u0430", desc: "\u041E\u0442\u043C\u0435\u043D\u0430 \u0447\u0430\u0441\u0442\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u0434\u043E \u0435\u0433\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F" }, { key: "crmPayoutEnabled", label: "CRM выплаты", desc: "Выплаты через CRM-систему (API заявки, реестры)" }, { key: "crmSbpPayoutEnabled", label: "CRM выплаты СБП", desc: "Приём заявок СБП по телефону и названию банка" }, { key: "unlimcoPayoutEnabled", label: "\u0412\u044B\u043F\u043B\u0430\u0442\u044B \u0432 Unlimco", desc: "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0432\u044B\u043F\u043B\u0430\u0442 \u0447\u0435\u0440\u0435\u0437 Unlimco-\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443" }];
	
	    var enabledMethods = methods.filter(function (m) {
	        return !!form[m.key];
	    });
	
	    if (loading) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Overlay }, _react2.default.createElement("div", { className: _stylesModule2.default.WizardCard }, _react2.default.createElement("div", { className: _stylesModule2.default.Loading }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...")));
	    }
	
	    // Progress bar
	    var stepLabels = ["\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0435", "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440", "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F", "\u041C\u0435\u0442\u043E\u0434\u044B", "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438", "\u041E\u0431\u0437\u043E\u0440"];
	    var progressBar = _react2.default.createElement("div", { className: _stylesModule2.default.ProgressBar }, [1, 2, 3, 4, 5, 6].map(function (s) {
	        var stepClass = _stylesModule2.default.ProgressStep;
	        if (s === step) stepClass += " " + _stylesModule2.default.ProgressStepActive;
	        if (s < step) stepClass += " " + _stylesModule2.default.ProgressStepDone;
	        return _react2.default.createElement("div", { key: s, className: stepClass }, _react2.default.createElement("div", { className: _stylesModule2.default.ProgressCircle }, s < step ? "\u2713" : s), _react2.default.createElement("div", { className: _stylesModule2.default.ProgressLabel }, stepLabels[s - 1]));
	    }));
	
	    // Step content
	    var stepContent = null;
	
	    if (step === 1) {
	        stepContent = _react2.default.createElement("div", { className: _stylesModule2.default.StepContent }, _react2.default.createElement("h3", { className: _stylesModule2.default.StepTitle }, "\u0428\u0430\u0433 1: \u041F\u0440\u043E\u0435\u043A\u0442 \u0438 \u043E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"), _react2.default.createElement("p", { className: _stylesModule2.default.StepDescription }, "\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043F\u0440\u0438\u0432\u044F\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 (\u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0443). \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442, \u0434\u0430\u0439\u0442\u0435 \u043F\u043E\u043D\u044F\u0442\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0438 \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441. \u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0438."), _react2.default.createElement("div", { className: _stylesModule2.default.FormGroup }, _react2.default.createElement("label", { className: _stylesModule2.default.Label }, "\u041F\u0440\u043E\u0435\u043A\u0442 *"), _react2.default.createElement("div", { className: _stylesModule2.default.SearchSelect }, _react2.default.createElement("input", {
	            className: _stylesModule2.default.Input,
	            type: "text",
	            value: projectDropOpen ? projectSearch : function () {
	                for (var i = 0; i < projects.length; i++) {
	                    if (projects[i] && projects[i].uuid === form.projectUuid) {
	                        return (projects[i].name || "") + " \u2014 " + projects[i].uuid;
	                    }
	                }
	                return "";
	            }(),
	            placeholder: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430...",
	            onFocus: function onFocus() {
	                setProjectDropOpen(true);
	                setProjectSearch("");
	            },
	            onChange: function onChange(e) {
	                setProjectSearch(e.target.value);
	                if (!projectDropOpen) setProjectDropOpen(true);
	            },
	            onBlur: function onBlur() {
	                setProjectDropOpen(false);
	            }
	        }), form.projectUuid && !projectDropOpen ? _react2.default.createElement("span", {
	            className: _stylesModule2.default.SearchSelectClear,
	            onClick: function onClick() {
	                _onChange("projectUuid", "");
	                setProjectSearch("");
	            }
	        }, "\u2715") : null, projectDropOpen ? _react2.default.createElement("div", { className: _stylesModule2.default.SearchSelectDropdown }, function () {
	            var query = projectSearch.toLowerCase();
	            var filtered = projects.filter(function (p) {
	                if (!p) return false;
	                var text = ((p.name || "") + " " + (p.uuid || "")).toLowerCase();
	                return !query || text.indexOf(query) !== -1;
	            });
	            if (filtered.length === 0) {
	                return _react2.default.createElement("div", { className: _stylesModule2.default.SearchSelectEmpty }, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
	            }
	            return filtered.map(function (p) {
	                return _react2.default.createElement("div", {
	                    key: p.uuid,
	                    className: _stylesModule2.default.SearchSelectOption + (form.projectUuid === p.uuid ? " " + _stylesModule2.default.SearchSelectOptionActive : ""),
	                    onMouseDown: function onMouseDown(e) {
	                        e.preventDefault();
	                        _onChange("projectUuid", p.uuid);
	                        setProjectDropOpen(false);
	                        setProjectSearch("");
	                    }
	                }, _react2.default.createElement("div", { className: _stylesModule2.default.SearchSelectName }, p.name || p.uuid), _react2.default.createElement("div", { className: _stylesModule2.default.SearchSelectUuid }, p.uuid));
	            });
	        }()) : null), _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "\u041C\u0435\u0440\u0447\u0430\u043D\u0442, \u043A \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B")), _react2.default.createElement("div", { className: _stylesModule2.default.FormGroup }, _react2.default.createElement("label", { className: _stylesModule2.default.Label }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430 *"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.Input,
	            type: "text",
	            value: form.name,
	            onChange: function onChange(e) {
	                _onChange("name", e.target.value);
	            },
	            placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: Hydra P2P \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439"
	        }), _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "\u041F\u043E\u043D\u044F\u0442\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0434\u043B\u044F \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435")), _react2.default.createElement("div", { className: _stylesModule2.default.FormGroup }, _react2.default.createElement("label", { className: _stylesModule2.default.Label }, "\u0421\u0442\u0430\u0442\u0443\u0441"), _react2.default.createElement("select", {
	            className: _stylesModule2.default.Select,
	            value: form.status,
	            onChange: function onChange(e) {
	                _onChange("status", parseInt(e.target.value, 10));
	            }
	        }, _react2.default.createElement("option", { value: 1 }, "\u0410\u043A\u0442\u0438\u0432\u0435\u043D"), _react2.default.createElement("option", { value: 0 }, "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D")), _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0438")));
	    }
	
	    if (step === 2) {
	        stepContent = _react2.default.createElement("div", { className: _stylesModule2.default.StepContent }, _react2.default.createElement("h3", { className: _stylesModule2.default.StepTitle }, "\u0428\u0430\u0433 2: \u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440"), _react2.default.createElement("p", { className: _stylesModule2.default.StepDescription }, "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u2014 \u044D\u0442\u043E \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u044B\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0438\u043D\u0433, \u0447\u0435\u0440\u0435\u0437 \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430. \u041A\u0430\u0436\u0434\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u0438\u043C\u0435\u0435\u0442 \u0441\u0432\u043E\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u044B \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0448\u0430\u0433\u0435. \u0412\u044B\u0431\u043E\u0440 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u0435\u043D."), _react2.default.createElement("div", { className: _stylesModule2.default.ProviderGrid }, PROVIDER_KEYS.map(function (key) {
	            var cfg = PROVIDER_CONFIGS[key];
	            var isSelected = form.providerKey === key;
	            return _react2.default.createElement("div", {
	                key: key,
	                className: isSelected ? _stylesModule2.default.ProviderCardSelected : _stylesModule2.default.ProviderCard,
	                onClick: function onClick() {
	                    onProviderSelect(key);
	                }
	            }, _react2.default.createElement("div", { className: _stylesModule2.default.ProviderCardTitle }, cfg.label), _react2.default.createElement("div", { className: _stylesModule2.default.ProviderCardDesc }, cfg.description));
	        })), _react2.default.createElement("div", { className: _stylesModule2.default.FormGroup, style: { marginTop: 20 } }, _react2.default.createElement("label", { className: _stylesModule2.default.Label }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 *"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.Input,
	            type: "text",
	            value: form.providerName,
	            onChange: function onChange(e) {
	                _onChange("providerName", e.target.value);
	            },
	            placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: Hydra P2P \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439"
	        }), _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "\u0411\u0443\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u0441 \u044D\u0442\u0438\u043C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C")));
	    }
	
	    if (step === 3) {
	        var providerCfg = PROVIDER_CONFIGS[form.providerKey];
	        var authFields = providerCfg ? providerCfg.fields : [];
	
	        stepContent = _react2.default.createElement("div", { className: _stylesModule2.default.StepContent }, _react2.default.createElement("h3", { className: _stylesModule2.default.StepTitle }, "\u0428\u0430\u0433 3: \u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F " + (providerCfg ? providerCfg.label : "")), authFields.length === 0 ? _react2.default.createElement("p", { className: _stylesModule2.default.StepDescription }, "CRM-\u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445. \u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0435\u0440\u0435\u0437 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0439 CRM API. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u0414\u0430\u043B\u0435\u0435\xBB \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F.") : _react2.default.createElement("p", { className: _stylesModule2.default.StepDescription }, "\u042D\u0442\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u043D\u0443\u0436\u043D\u044B \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A API \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430. \u041F\u043E\u043B\u044F \u0441\u043E \u0437\u0432\u0451\u0437\u0434\u043E\u0447\u043A\u043E\u0439 (*) \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B. \u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u0438\u043C\u0435\u044E\u0442 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B \u043F\u0443\u0441\u0442\u044B\u043C\u0438."), authFields.map(function (f) {
	            var val = form.providerAuth[f.key];
	            if (val === undefined || val === null) val = "";
	
	            var inputEl;
	            if (f.type === "textarea") {
	                inputEl = _react2.default.createElement("textarea", {
	                    className: _stylesModule2.default.Textarea,
	                    value: val,
	                    onChange: function onChange(e) {
	                        onAuthChange(f.key, e.target.value);
	                    },
	                    placeholder: f.placeholder || "",
	                    rows: 4
	                });
	            } else if (f.type === "number") {
	                inputEl = _react2.default.createElement("input", {
	                    className: _stylesModule2.default.Input,
	                    type: "number",
	                    value: val,
	                    onChange: function onChange(e) {
	                        onAuthChange(f.key, e.target.value);
	                    },
	                    placeholder: f.placeholder || ""
	                });
	            } else {
	                inputEl = _react2.default.createElement("input", {
	                    className: _stylesModule2.default.Input,
	                    type: "text",
	                    value: val,
	                    onChange: function onChange(e) {
	                        onAuthChange(f.key, e.target.value);
	                    },
	                    placeholder: f.placeholder || ""
	                });
	            }
	
	            return _react2.default.createElement("div", { key: f.key, className: _stylesModule2.default.FormGroup }, _react2.default.createElement("label", { className: _stylesModule2.default.Label }, f.label + (f.required ? " *" : "")), inputEl, f.hint ? _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, f.hint) : f.defaultValue !== undefined && !f.required ? _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E: " + f.defaultValue) : null);
	        }));
	    }
	
	    if (step === 4) {
	        stepContent = _react2.default.createElement("div", { className: _stylesModule2.default.StepContent }, _react2.default.createElement("h3", { className: _stylesModule2.default.StepTitle }, "\u0428\u0430\u0433 4: \u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043E\u043F\u0446\u0438\u0438"), _react2.default.createElement("p", { className: _stylesModule2.default.StepDescription }, "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B (\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E), \u0437\u0430\u0442\u0435\u043C \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043E\u043F\u0446\u0438\u0438 \u0435\u0441\u043B\u0438 \u043D\u0443\u0436\u043D\u043E. \u041E\u043F\u0446\u0438\u0438 \u043C\u043E\u0436\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0437\u0436\u0435 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430."),
	
	        // === Способ оплаты ===
	        _react2.default.createElement("div", { className: _stylesModule2.default.SectionLabel }, "\u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B", form.providerKey !== "crm" ? _react2.default.createElement("span", { className: _stylesModule2.default.SectionRequired }, "*") : null), _react2.default.createElement("p", { className: _stylesModule2.default.SectionHint }, form.providerKey === "crm" ? "\u0414\u043B\u044F CRM-\u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B \u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u0435\u043D. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435, \u0435\u0441\u043B\u0438 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u043F\u043B\u0430\u0442\u0435\u0436\u0438." : "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u043A\u0430\u043A\u0438\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u043A\u043B\u0438\u0435\u043D\u0442 \u0431\u0443\u0434\u0435\u0442 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C: \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u043E\u043C \u043D\u0430 \u043A\u0430\u0440\u0442\u0443 (P2P) \u0438\u043B\u0438 \u0447\u0435\u0440\u0435\u0437 \u0421\u0411\u041F. \u0412\u044B\u0431\u043E\u0440 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u0435\u043D."), _react2.default.createElement("div", { className: _stylesModule2.default.ProviderGrid }, _react2.default.createElement("div", {
	            className: form.paymentMethod === "P2P_CROSS_BORDER" ? _stylesModule2.default.ProviderCardSelected : _stylesModule2.default.ProviderCard,
	            onClick: function onClick() {
	                _onChange("paymentMethod", form.paymentMethod === "P2P_CROSS_BORDER" ? "" : "P2P_CROSS_BORDER");
	            }
	        }, _react2.default.createElement("div", { className: _stylesModule2.default.ProviderCardTitle }, "P2P"), _react2.default.createElement("div", { className: _stylesModule2.default.ProviderCardDesc }, "\u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443 (card-to-card)")), _react2.default.createElement("div", {
	            className: form.paymentMethod === "SBP_CROSS_BORDER" ? _stylesModule2.default.ProviderCardSelected : _stylesModule2.default.ProviderCard,
	            onClick: function onClick() {
	                _onChange("paymentMethod", form.paymentMethod === "SBP_CROSS_BORDER" ? "" : "SBP_CROSS_BORDER");
	            }
	        }, _react2.default.createElement("div", { className: _stylesModule2.default.ProviderCardTitle }, "\u0421\u0411\u041F"), _react2.default.createElement("div", { className: _stylesModule2.default.ProviderCardDesc }, "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0431\u044B\u0441\u0442\u0440\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 (\u043F\u043E QR-\u043A\u043E\u0434\u0443)"))),
	
	        // === Дополнительные опции ===
	        _react2.default.createElement("div", { className: _stylesModule2.default.SectionLabel, style: { marginTop: 24 } }, "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043E\u043F\u0446\u0438\u0438"), _react2.default.createElement("p", { className: _stylesModule2.default.SectionHint }, "\u041D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430. \u0412\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E, \u0447\u0442\u043E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0432\u0430\u0448 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440."), methods.map(function (m) {
	            return _react2.default.createElement("div", { key: m.key, style: { marginBottom: 8 } }, _react2.default.createElement("label", { className: _stylesModule2.default.ToggleLabel }, _react2.default.createElement("input", {
	                type: "checkbox",
	                checked: !!form[m.key],
	                onChange: function onChange(e) {
	                    _onChange(m.key, e.target.checked);
	                }
	            }), _react2.default.createElement("span", { className: _stylesModule2.default.ToggleSwitch }), _react2.default.createElement("span", { className: _stylesModule2.default.ToggleText }, m.label)), _react2.default.createElement("div", { className: _stylesModule2.default.ToggleDesc }, m.desc));
	        }));
	    }
	
	    // ===== STEP 5: Fees =====
	    if (step === 5) {
	        var onFeeChange = function onFeeChange(field, value) {
	            if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;
	            _onChange(field, value);
	        };
	
	        var renderFeeFields = function renderFeeFields(title, desc, costField, fixedField, minField) {
	            return _react2.default.createElement("div", { style: { border: "1px solid #e0e0e0", borderRadius: "6px", padding: "15px", marginBottom: "15px" } }, _react2.default.createElement("div", { style: { fontSize: "14px", fontWeight: 600, marginBottom: "6px" } }, title), _react2.default.createElement("div", { style: { fontSize: "12px", color: "#888", marginBottom: "12px" } }, desc), _react2.default.createElement("div", { style: { display: "flex", gap: "15px" } }, _react2.default.createElement("div", { style: { flex: 1 } }, _react2.default.createElement("div", { style: { fontSize: "12px", color: "#666", marginBottom: "4px" } }, "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 (%)"), _react2.default.createElement("input", {
	                className: _stylesModule2.default.Input,
	                type: "text",
	                value: form[costField],
	                onChange: function onChange(e) {
	                    onFeeChange(costField, e.target.value);
	                },
	                placeholder: "0"
	            })), _react2.default.createElement("div", { style: { flex: 1 } }, _react2.default.createElement("div", { style: { fontSize: "12px", color: "#666", marginBottom: "4px" } }, "\u0424\u0438\u043A\u0441. (\u0440\u0443\u0431)"), _react2.default.createElement("input", {
	                className: _stylesModule2.default.Input,
	                type: "text",
	                value: form[fixedField],
	                onChange: function onChange(e) {
	                    onFeeChange(fixedField, e.target.value);
	                },
	                placeholder: "0"
	            })), _react2.default.createElement("div", { style: { flex: 1 } }, _react2.default.createElement("div", { style: { fontSize: "12px", color: "#666", marginBottom: "4px" } }, "\u041C\u0438\u043D. (\u0440\u0443\u0431)"), _react2.default.createElement("input", {
	                className: _stylesModule2.default.Input,
	                type: "text",
	                value: form[minField],
	                onChange: function onChange(e) {
	                    onFeeChange(minField, e.target.value);
	                },
	                placeholder: "0"
	            }))));
	        };
	
	        var payoutOnlyProviders = ["finstar", "tkb", "crm"];
	        var isPayoutOnly = payoutOnlyProviders.indexOf(form.providerKey) !== -1;
	
	        stepContent = _react2.default.createElement("div", { className: _stylesModule2.default.StepContent }, _react2.default.createElement("h3", { className: _stylesModule2.default.StepTitle }, "\u0428\u0430\u0433 5: \u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438"), _react2.default.createElement("p", { className: _stylesModule2.default.StepDescription }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u0434\u043B\u044F \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430. \u041C\u043E\u0436\u043D\u043E \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C\u0438 \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043F\u043E\u0437\u0436\u0435."), !isPayoutOnly && renderFeeFields("\u041E\u043F\u043B\u0430\u0442\u0430 (Payment)", "Purchase, Recurrent, SBP, P2P, QR", "feePaymentCost", "feePaymentFixed", "feePaymentMin"), renderFeeFields("\u0412\u044B\u043F\u043B\u0430\u0442\u044B (Payout)", "Payout, Mobile Payout", "feePayoutCost", "feePayoutFixed", "feePayoutMin"), !isPayoutOnly && renderFeeFields("\u0412\u043E\u0437\u0432\u0440\u0430\u0442\u044B (Refund)", "Refund", "feeRefundCost", "feeRefundFixed", "feeRefundMin"), _react2.default.createElement("div", { style: { fontSize: "12px", color: "#888", marginTop: "10px", padding: "8px", background: "#f5f5f5", borderRadius: "4px" } }, "\u0424\u043E\u0440\u043C\u0443\u043B\u0430: \u0424\u0438\u043A\u0441. + max(\u0421\u0443\u043C\u043C\u0430 \xD7 \u041F\u0440\u043E\u0446\u0435\u043D\u0442%, \u041C\u0438\u043D.). \u0412\u0441\u0435 \u0441\u0443\u043C\u043C\u044B \u0432 \u0440\u0443\u0431\u043B\u044F\u0445."), isPayoutOnly && _react2.default.createElement("div", { style: { fontSize: "12px", color: "#e65100", marginTop: "8px", padding: "8px", background: "#fff3e0", borderRadius: "4px" } }, "\u042D\u0442\u043E\u0442 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u044B. \u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 Payment \u0438 Refund \u043D\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F."));
	    }
	
	    // ===== STEP 6: Review =====
	    if (step === 6) {
	        var reviewProviderCfg = PROVIDER_CONFIGS[form.providerKey];
	        var reviewAuthData = buildAuthData();
	
	        var authReviewRows = [];
	        if (reviewProviderCfg) {
	            for (var ri = 0; ri < reviewProviderCfg.fields.length; ri++) {
	                var rf = reviewProviderCfg.fields[ri];
	                var rv = reviewAuthData[rf.key];
	                if (rv !== undefined && rv !== null && String(rv) !== "") {
	                    var displayVal = rf.sensitive ? maskSensitive(String(rv)) : String(rv);
	                    authReviewRows.push(_react2.default.createElement("tr", { key: "auth-" + rf.key }, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, rf.label), _react2.default.createElement("td", null, _react2.default.createElement("span", { className: _stylesModule2.default.AuthValue }, displayVal))));
	                }
	            }
	        }
	
	        stepContent = _react2.default.createElement("div", { className: _stylesModule2.default.StepContent }, _react2.default.createElement("h3", { className: _stylesModule2.default.StepTitle }, "\u0428\u0430\u0433 6: \u041E\u0431\u0437\u043E\u0440"), _react2.default.createElement("p", { className: _stylesModule2.default.StepDescription }, "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u0435\u0440\u0435\u0434 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043C. \u0415\u0441\u043B\u0438 \u0447\u0442\u043E-\u0442\u043E \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u2014 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u041D\u0430\u0437\u0430\u0434\xBB \u0434\u043B\u044F \u0438\u0441\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F. \u041A\u043B\u044E\u0447\u0438 \u0438 \u0441\u0435\u043A\u0440\u0435\u0442\u044B \u0437\u0430\u043C\u0430\u0441\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0434\u043B\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438."), _react2.default.createElement("table", { className: _stylesModule2.default.ReviewTable }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u041F\u0440\u043E\u0435\u043A\u0442"), _react2.default.createElement("td", null, getProjectName())), _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"), _react2.default.createElement("td", null, form.name)), _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u0421\u0442\u0430\u0442\u0443\u0441"), _react2.default.createElement("td", null, _react2.default.createElement("span", {
	            className: _stylesModule2.default.StatusBadge + " " + (form.status === 1 ? _stylesModule2.default.StatusActive : _stylesModule2.default.StatusInactive)
	        }, form.status === 1 ? "\u0410\u043A\u0442\u0438\u0432\u0435\u043D" : "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D"))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u0422\u0438\u043F \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430"), _react2.default.createElement("td", null, reviewProviderCfg ? reviewProviderCfg.label : "\u2014")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440"), _react2.default.createElement("td", null, form.providerName || "\u2014")), authReviewRows, _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u041C\u0435\u0442\u043E\u0434\u044B"), _react2.default.createElement("td", null, enabledMethods.length === 0 ? _react2.default.createElement("span", { className: _stylesModule2.default.ReviewMuted }, "\u041D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u044B") : enabledMethods.map(function (m) {
	            return _react2.default.createElement("span", { key: m.key, className: _stylesModule2.default.MethodBadge }, m.label);
	        }))), form.paymentMethod ? _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B"), _react2.default.createElement("td", null, _react2.default.createElement("span", { className: _stylesModule2.default.MethodBadge }, form.paymentMethod === "SBP_CROSS_BORDER" ? "\u0421\u0411\u041F" : "P2P"))) : null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { className: _stylesModule2.default.ReviewLabel }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438"), _react2.default.createElement("td", null, form.feePaymentCost || form.feePaymentFixed || form.feePayoutCost || form.feePayoutFixed || form.feeRefundCost || form.feeRefundFixed ? _react2.default.createElement("span", null, form.feePaymentCost || form.feePaymentFixed ? "Payment: " + (form.feePaymentCost || "0") + "% + " + (form.feePaymentFixed || "0") + "\u20BD. " : "", form.feePayoutCost || form.feePayoutFixed ? "Payout: " + (form.feePayoutCost || "0") + "% + " + (form.feePayoutFixed || "0") + "\u20BD. " : "", form.feeRefundCost || form.feeRefundFixed ? "Refund: " + (form.feeRefundCost || "0") + "% + " + (form.feeRefundFixed || "0") + "\u20BD" : "") : _react2.default.createElement("span", { className: _stylesModule2.default.ReviewMuted }, "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u044B"))))), _react2.default.createElement("div", { className: _stylesModule2.default.ReviewNote }, "\u041F\u043E\u0441\u043B\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438, \u043B\u0438\u043C\u0438\u0442\u044B \u0438 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044E \u0432\u043E \u0432\u043A\u043B\u0430\u0434\u043A\u0430\u0445 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430."));
	    }
	
	    // Navigation buttons
	    var navButtons = _react2.default.createElement("div", { className: _stylesModule2.default.NavButtons }, step > 1 ? _react2.default.createElement("button", {
	        className: _stylesModule2.default.BtnBack,
	        onClick: goBack,
	        disabled: creating
	    }, "\u2190 \u041D\u0430\u0437\u0430\u0434") : _react2.default.createElement("div", null), _react2.default.createElement("div", { className: _stylesModule2.default.NavRight }, step < 6 ? _react2.default.createElement("button", {
	        className: _stylesModule2.default.BtnNext,
	        onClick: goNext,
	        disabled: !canGoNext()
	    }, "\u0414\u0430\u043B\u0435\u0435 \u2192") : null, step === 6 ? _react2.default.createElement("button", {
	        className: _stylesModule2.default.BtnCreate,
	        onClick: create,
	        disabled: creating
	    }, creating ? "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435..." : "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B") : null));
	
	    return _react2.default.createElement("div", {
	        className: _stylesModule2.default.Overlay,
	        onClick: function onClick(e) {
	            if (e.target === e.currentTarget && !creating) onClose();
	        }
	    }, _react2.default.createElement("div", { className: _stylesModule2.default.WizardCard }, _react2.default.createElement("div", { className: _stylesModule2.default.WizardHeader }, _react2.default.createElement("h2", { className: _stylesModule2.default.WizardTitle }, "\u041D\u043E\u0432\u044B\u0439 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B"), _react2.default.createElement("button", {
	        className: _stylesModule2.default.CloseBtn,
	        onClick: onClose,
	        disabled: creating
	    }, "\u2715")), progressBar, stepContent, navButtons));
	}
	
	exports.default = TerminalAddWizard;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(580);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEDGER_TYPE_LABELS = {
	    1: "Зачисление",
	    2: "Комиссия",
	    3: "Выплата мерчанту",
	    4: "Отмена выплаты",
	    5: "Ручная корректировка",
	    6: "Возврат",
	    7: "Чарджбэк",
	    8: "Пополнение"
	};
	
	function getLedgerTypeClass(type) {
	    switch (type) {
	        case 8:
	            return _stylesModule2.default.TypeTopup;
	        case 5:
	            return _stylesModule2.default.TypeAdjustment;
	        case 1:
	            return _stylesModule2.default.TypeTransaction;
	        case 3:case 4:
	            return _stylesModule2.default.TypeSettlement;
	        case 2:
	            return _stylesModule2.default.TypeCommission;
	        case 6:case 7:
	            return _stylesModule2.default.TypeSettlement;
	        default:
	            return _stylesModule2.default.TypeBadge;
	    }
	}
	
	function formatAmount(amountInKopecks) {
	    if (amountInKopecks === null || amountInKopecks === undefined) return "0.00";
	    return (Number(amountInKopecks) / 100).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
	
	function formatDate(dateStr) {
	    if (!dateStr) return "\u2014";
	    try {
	        var d = new Date(dateStr);
	        return d.toLocaleString("ru-RU");
	    } catch (e) {
	        return dateStr;
	    }
	}
	
	function TerminalBalanceTab(props) {
	    var token = props.token;
	    var terminal = props.terminal;
	    var terminalId = terminal && terminal.id ? terminal.id : null;
	    var onMessage = (0, _react.useContext)(_MessageContext2.default).onMessage;
	    var mounted = (0, _react.useRef)(true);
	
	    // Balances
	    var _balances = (0, _react.useState)(null);
	    var balances = _balances[0];
	    var setBalances = _balances[1];
	
	    var _balancesLoading = (0, _react.useState)(false);
	    var balancesLoading = _balancesLoading[0];
	    var setBalancesLoading = _balancesLoading[1];
	
	    // MerchantSettings list and selected
	    var _msList = (0, _react.useState)([]);
	    var msList = _msList[0];
	    var setMsList = _msList[1];
	
	    var _selectedMsId = (0, _react.useState)("");
	    var selectedMsId = _selectedMsId[0];
	    var setSelectedMsId = _selectedMsId[1];
	
	    // Ledger
	    var _ledger = (0, _react.useState)([]);
	    var ledger = _ledger[0];
	    var setLedger = _ledger[1];
	
	    var _ledgerCount = (0, _react.useState)(0);
	    var ledgerCount = _ledgerCount[0];
	    var setLedgerCount = _ledgerCount[1];
	
	    var _ledgerPage = (0, _react.useState)(1);
	    var ledgerPage = _ledgerPage[0];
	    var setLedgerPage = _ledgerPage[1];
	
	    var _ledgerTypeFilter = (0, _react.useState)("");
	    var ledgerTypeFilter = _ledgerTypeFilter[0];
	    var setLedgerTypeFilter = _ledgerTypeFilter[1];
	
	    var _ledgerLoading = (0, _react.useState)(false);
	    var ledgerLoading = _ledgerLoading[0];
	    var setLedgerLoading = _ledgerLoading[1];
	
	    // Manual entry form (adjustment only)
	    var _entryAmount = (0, _react.useState)("");
	    var entryAmount = _entryAmount[0];
	    var setEntryAmount = _entryAmount[1];
	
	    var _entryDescription = (0, _react.useState)("");
	    var entryDescription = _entryDescription[0];
	    var setEntryDescription = _entryDescription[1];
	
	    var _entrySubmitting = (0, _react.useState)(false);
	    var entrySubmitting = _entrySubmitting[0];
	    var setEntrySubmitting = _entrySubmitting[1];
	
	    var ledgerPerPage = 15;
	
	    (0, _react.useEffect)(function () {
	        mounted.current = true;
	        return function () {
	            mounted.current = false;
	        };
	    }, []);
	
	    // Load data when terminal changes
	    (0, _react.useEffect)(function () {
	        if (terminalId) {
	            loadBalances();
	            loadLedger();
	        }
	    }, [terminalId, token]);
	
	    // Reload ledger when page, filter or selected MS changes
	    (0, _react.useEffect)(function () {
	        if (terminalId && selectedMsId) {
	            loadLedger();
	        }
	    }, [ledgerPage, ledgerTypeFilter, selectedMsId]);
	
	    function loadBalances() {
	        setBalancesLoading(true);
	        new _Api2.default({ token: token }).getTerminalBalances(terminalId).then(function (r) {
	            if (mounted.current) {
	                var data = r.data || r;
	                setBalances(data);
	
	                // Save MerchantSettings list from balances response
	                var balancesList = Array.isArray(data.balances) ? data.balances : [];
	                setMsList(balancesList);
	                // Auto-select first if none selected
	                if (balancesList.length > 0 && !selectedMsId) {
	                    setSelectedMsId(String(balancesList[0].merchantSettingsId));
	                }
	
	                setBalancesLoading(false);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            if (mounted.current) {
	                setBalancesLoading(false);
	                onMessage({ type: "error", message: "Ошибка загрузки балансов" });
	            }
	        });
	    }
	
	    function loadLedger() {
	        if (!selectedMsId) return;
	        setLedgerLoading(true);
	        var filters = {
	            merchant_settings_id: selectedMsId,
	            page: ledgerPage,
	            limit: ledgerPerPage
	        };
	        if (ledgerTypeFilter) filters.type = ledgerTypeFilter;
	
	        new _Api2.default({ token: token }).getTerminalLedger(terminalId, filters).then(function (r) {
	            if (mounted.current) {
	                setLedger(Array.isArray(r.data) ? r.data : []);
	                setLedgerCount(typeof r.count === "number" ? r.count : 0);
	                setLedgerLoading(false);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            if (mounted.current) {
	                setLedger([]);
	                setLedgerCount(0);
	                setLedgerLoading(false);
	            }
	        });
	    }
	
	    function onCreateEntry() {
	        if (!entryAmount || isNaN(Number(entryAmount)) || Number(entryAmount) === 0) {
	            onMessage({ type: "error", message: "Укажите сумму" });
	            return;
	        }
	        if (!selectedMsId) {
	            onMessage({ type: "error", message: "Выберите MerchantSettings" });
	            return;
	        }
	        setEntrySubmitting(true);
	        var data = {
	            merchant_settings_id: Number(selectedMsId),
	            type: "adjustment",
	            amount: Math.round(Number(entryAmount) * 100), // convert to kopecks
	            description: entryDescription || ""
	        };
	
	        new _Api2.default({ token: token }).createTerminalLedgerEntry(terminalId, data).then(function () {
	            if (mounted.current) {
	                setEntrySubmitting(false);
	                setEntryAmount("");
	                setEntryDescription("");
	                loadBalances();
	                loadLedger();
	                onMessage({ type: "success", message: "Запись создана" });
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            if (mounted.current) {
	                setEntrySubmitting(false);
	                onMessage({ type: "error", message: "Ошибка при создании записи" });
	            }
	        });
	    }
	
	    if (!terminalId) {
	        return null;
	    }
	
	    var totals = balances && balances.totals ? balances.totals : null;
	    var transactionBalance = totals && totals.transactionBalance != null ? totals.transactionBalance : null;
	    var settlementBalance = totals && totals.settlementBalance != null ? totals.settlementBalance : null;
	    var actualBalance = totals && totals.actualBalance != null ? totals.actualBalance : null;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Content },
	            balancesLoading && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.LoadingOverlay },
	                _react2.default.createElement("div", { className: _stylesModule2.default.Spinner }),
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
	                )
	            ),
	            _react2.default.createElement(
	                "h4",
	                { className: _stylesModule2.default.BlockTitle },
	                "\u0411\u0430\u043B\u0430\u043D\u0441"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.BalancesRow },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.BalanceCard },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.BalanceLabel },
	                        totals && totals.labels ? totals.labels.transactionBalance : "Баланс"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: transactionBalance !== null && transactionBalance >= 0 ? _stylesModule2.default.BalanceValuePositive : _stylesModule2.default.BalanceValueNegative },
	                        transactionBalance !== null ? formatAmount(transactionBalance) : "\u2014",
	                        " \u20BD"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.BalanceCard },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.BalanceLabel },
	                        totals && totals.labels ? totals.labels.settlementBalance : "Выплачено мерчанту"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.BalanceValue },
	                        settlementBalance !== null ? formatAmount(settlementBalance) : "\u2014",
	                        " \u20BD"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.BalanceCard },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.BalanceLabel },
	                        totals && totals.labels ? totals.labels.actualBalance : "Доступный баланс"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: actualBalance !== null && actualBalance >= 0 ? _stylesModule2.default.BalanceValuePositive : _stylesModule2.default.BalanceValueNegative },
	                        actualBalance !== null ? formatAmount(actualBalance) : "\u2014",
	                        " \u20BD"
	                    )
	                )
	            ),
	            _react2.default.createElement("div", { className: _stylesModule2.default.Divider }),
	            msList.length > 1 && _react2.default.createElement(
	                "div",
	                { style: { marginBottom: 16 } },
	                _react2.default.createElement(
	                    "label",
	                    { style: { fontWeight: 600, fontSize: "0.875rem", marginBottom: 4, display: "block" } },
	                    "\u041C\u0435\u0440\u0447\u0430\u043D\u0442 (MerchantSettings)"
	                ),
	                _react2.default.createElement(
	                    "select",
	                    {
	                        className: "form-select",
	                        value: selectedMsId,
	                        onChange: function onChange(e) {
	                            setSelectedMsId(e.target.value);setLedgerPage(1);
	                        }
	                    },
	                    msList.map(function (ms) {
	                        return _react2.default.createElement(
	                            "option",
	                            { key: ms.merchantSettingsId, value: ms.merchantSettingsId },
	                            "MS #" + ms.merchantSettingsId + " (баланс: " + formatAmount(ms.transactionBalance) + " \u20BD)"
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "h5",
	                { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                "\u0416\u0443\u0440\u043D\u0430\u043B \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterBar },
	                _react2.default.createElement(
	                    "select",
	                    {
	                        value: ledgerTypeFilter,
	                        onChange: function onChange(e) {
	                            setLedgerTypeFilter(e.target.value);setLedgerPage(1);
	                        }
	                    },
	                    _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "\u0412\u0441\u0435 \u0442\u0438\u043F\u044B"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "1" },
	                        "\u0417\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "2" },
	                        "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "3" },
	                        "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0443"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "4" },
	                        "\u041E\u0442\u043C\u0435\u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u044B"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "5" },
	                        "\u0420\u0443\u0447\u043D\u0430\u044F \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u043A\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "6" },
	                        "\u0412\u043E\u0437\u0432\u0440\u0430\u0442"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "7" },
	                        "\u0427\u0430\u0440\u0434\u0436\u0431\u044D\u043A"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "8" },
	                        "\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435"
	                    )
	                )
	            ),
	            ledgerLoading ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.EmptyText },
	                "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
	            ) : ledger.length === 0 ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.EmptyText },
	                "\u0417\u0430\u043F\u0438\u0441\u0438 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B"
	            ) : _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.TableScroll },
	                    _react2.default.createElement(
	                        "table",
	                        { className: _stylesModule2.default.Table },
	                        _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0414\u0430\u0442\u0430"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0422\u0438\u043F"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0421\u0443\u043C\u043C\u0430"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0421\u043E\u0437\u0434\u0430\u043B"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tbody",
	                            null,
	                            ledger.map(function (entry) {
	                                var entryId = entry.id || entry.created_at + "_" + entry.amount;
	                                return _react2.default.createElement(
	                                    "tr",
	                                    { key: entryId },
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        formatDate(entry.created_at || entry.createdAt)
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: getLedgerTypeClass(entry.type) },
	                                            entry.type_name || LEDGER_TYPE_LABELS[entry.type] || entry.type || "\u2014"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        { style: { fontWeight: 500 } },
	                                        formatAmount(entry.amount),
	                                        " \u20BD"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        formatAmount(entry.balance_after || entry.balanceAfter),
	                                        " \u20BD"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        entry.description || "\u2014"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        entry.created_by && _typeof(entry.created_by) === 'object' ? entry.created_by.username : entry.created_by || entry.createdBy || "\u2014"
	                                    )
	                                );
	                            })
	                        )
	                    )
	                ),
	                ledgerPerPage < ledgerCount && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.PaginationWrap },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                        firstPageText: "\u21E4",
	                        prevPageText: "\u21E0",
	                        lastPageText: "\u21E5",
	                        nextPageText: "\u21E2",
	                        activeLinkClass: _stylesModule2.default.ActiveLink,
	                        activePage: ledgerPage,
	                        itemsCountPerPage: ledgerPerPage,
	                        totalItemsCount: ledgerCount,
	                        pageRangeDisplayed: 5,
	                        onChange: function onChange(p) {
	                            setLedgerPage(p);
	                        }
	                    })
	                )
	            ),
	            _react2.default.createElement("div", { className: _stylesModule2.default.Divider }),
	            _react2.default.createElement(
	                "h5",
	                { className: _stylesModule2.default.BlockTitle, style: { marginTop: 0 } },
	                "\u0420\u0443\u0447\u043D\u0430\u044F \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u043A\u0430"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Section },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.FormGrid },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormGroup },
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            "\u0421\u0443\u043C\u043C\u0430 (\u0432 \u0440\u0443\u0431\u043B\u044F\u0445)"
	                        ),
	                        _react2.default.createElement("input", {
	                            type: "number",
	                            step: "0.01",
	                            value: entryAmount,
	                            onChange: function onChange(e) {
	                                setEntryAmount(e.target.value);
	                            },
	                            placeholder: "0.00",
	                            disabled: entrySubmitting
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormGroup },
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                        ),
	                        _react2.default.createElement("input", {
	                            type: "text",
	                            value: entryDescription,
	                            onChange: function onChange(e) {
	                                setEntryDescription(e.target.value);
	                            },
	                            placeholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u043A\u0438",
	                            disabled: entrySubmitting
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { style: { textAlign: "right", marginTop: 8 } },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnSuccess,
	                            onClick: onCreateEntry,
	                            disabled: entrySubmitting || !entryAmount
	                        },
	                        entrySubmitting ? "Создание..." : "Создать корректировку"
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TerminalBalanceTab;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(581);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * TerminalFeesTab — вкладка «Комиссии» в админке терминалов.
	 *
	 * Props:
	 *   token (string) — JWT-токен
	 *   terminal (object) — { id, projectUuid, ... }
	 */
	function TerminalFeesTab(props) {
	    var token = props.token;
	    var terminal = props.terminal;
	
	    // Состояние комиссий
	    var _payment = (0, _react.useState)({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
	    var payment = _payment[0];
	    var setPayment = _payment[1];
	
	    var _payout = (0, _react.useState)({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
	    var payout = _payout[0];
	    var setPayout = _payout[1];
	
	    var _refund = (0, _react.useState)({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
	    var refund = _refund[0];
	    var setRefund = _refund[1];
	
	    var _saving = (0, _react.useState)(false);
	    var saving = _saving[0];
	    var setSaving = _saving[1];
	
	    var _loading = (0, _react.useState)(true);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _status = (0, _react.useState)(null); // {type: 'success'|'error', text: '...'}
	    var status = _status[0];
	    var setStatus = _status[1];
	
	    // Загрузка комиссий
	    (0, _react.useEffect)(function () {
	        if (!terminal || !terminal.id) return;
	        setLoading(true);
	        setStatus(null);
	
	        var api = new _Api2.default({ token: token });
	        api.getAdminTerminalFees(terminal.id).then(function (data) {
	            var fees = data.fees || {};
	            setPayment({
	                cost: String(fees.payment && fees.payment.cost != null ? fees.payment.cost : ""),
	                fixedPerTransaction: String(fees.payment && fees.payment.fixedPerTransaction != null ? fees.payment.fixedPerTransaction : ""),
	                costFixedMinimum: String(fees.payment && fees.payment.costFixedMinimum != null ? fees.payment.costFixedMinimum : "")
	            });
	            setPayout({
	                cost: String(fees.payout && fees.payout.cost != null ? fees.payout.cost : ""),
	                fixedPerTransaction: String(fees.payout && fees.payout.fixedPerTransaction != null ? fees.payout.fixedPerTransaction : ""),
	                costFixedMinimum: String(fees.payout && fees.payout.costFixedMinimum != null ? fees.payout.costFixedMinimum : "")
	            });
	            setRefund({
	                cost: String(fees.refund && fees.refund.cost != null ? fees.refund.cost : ""),
	                fixedPerTransaction: String(fees.refund && fees.refund.fixedPerTransaction != null ? fees.refund.fixedPerTransaction : ""),
	                costFixedMinimum: String(fees.refund && fees.refund.costFixedMinimum != null ? fees.refund.costFixedMinimum : "")
	            });
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setLoading(false);
	            setStatus({ type: "error", text: "Ошибка загрузки комиссий" });
	        });
	    }, [terminal && terminal.id, token]);
	
	    function onFieldChange(group, field, value) {
	        // Разрешаем только числа с точкой
	        if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;
	
	        if (group === "payment") {
	            var next = {};
	            for (var k in payment) {
	                next[k] = payment[k];
	            }
	            next[field] = value;
	            setPayment(next);
	        } else if (group === "payout") {
	            var next2 = {};
	            for (var k2 in payout) {
	                next2[k2] = payout[k2];
	            }
	            next2[field] = value;
	            setPayout(next2);
	        } else if (group === "refund") {
	            var next3 = {};
	            for (var k3 in refund) {
	                next3[k3] = refund[k3];
	            }
	            next3[field] = value;
	            setRefund(next3);
	        }
	    }
	
	    function onSave() {
	        setSaving(true);
	        setStatus(null);
	
	        var fees = {
	            payment: {
	                cost: payment.cost !== "" ? parseFloat(payment.cost) : 0,
	                fixedPerTransaction: payment.fixedPerTransaction !== "" ? parseFloat(payment.fixedPerTransaction) : 0,
	                costFixedMinimum: payment.costFixedMinimum !== "" ? parseFloat(payment.costFixedMinimum) : 0
	            },
	            payout: {
	                cost: payout.cost !== "" ? parseFloat(payout.cost) : 0,
	                fixedPerTransaction: payout.fixedPerTransaction !== "" ? parseFloat(payout.fixedPerTransaction) : 0,
	                costFixedMinimum: payout.costFixedMinimum !== "" ? parseFloat(payout.costFixedMinimum) : 0
	            },
	            refund: {
	                cost: refund.cost !== "" ? parseFloat(refund.cost) : 0,
	                fixedPerTransaction: refund.fixedPerTransaction !== "" ? parseFloat(refund.fixedPerTransaction) : 0,
	                costFixedMinimum: refund.costFixedMinimum !== "" ? parseFloat(refund.costFixedMinimum) : 0
	            }
	        };
	
	        var api = new _Api2.default({ token: token });
	        api.updateAdminTerminalFees(terminal.id, fees).then(function () {
	            setSaving(false);
	            setStatus({ type: "success", text: "Комиссии сохранены" });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setSaving(false);
	            var msg = err && err.response && err.response.data && err.response.data.message || "Ошибка сохранения";
	            setStatus({ type: "error", text: msg });
	        });
	    }
	
	    function renderFeeGroup(title, description, operations, group, state) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.FeeGroup }, _react2.default.createElement("div", { className: _stylesModule2.default.FeeGroupTitle }, title), _react2.default.createElement("div", { className: _stylesModule2.default.FeeGroupDescription }, operations), _react2.default.createElement("div", { className: _stylesModule2.default.FieldRow }, _react2.default.createElement("div", { className: _stylesModule2.default.Field }, _react2.default.createElement("div", { className: _stylesModule2.default.FieldLabel }, "Процент (%)"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.FieldInput,
	            type: "text",
	            value: state.cost,
	            onChange: function onChange(e) {
	                onFieldChange(group, "cost", e.target.value);
	            },
	            placeholder: "0"
	        }), _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "Процент от суммы транзакции")), _react2.default.createElement("div", { className: _stylesModule2.default.Field }, _react2.default.createElement("div", { className: _stylesModule2.default.FieldLabel }, "Фикс. за транзакцию (руб)"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.FieldInput,
	            type: "text",
	            value: state.fixedPerTransaction,
	            onChange: function onChange(e) {
	                onFieldChange(group, "fixedPerTransaction", e.target.value);
	            },
	            placeholder: "0"
	        }), _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "Фиксированная сумма за каждую транзакцию")), _react2.default.createElement("div", { className: _stylesModule2.default.Field }, _react2.default.createElement("div", { className: _stylesModule2.default.FieldLabel }, "Мин. комиссия (руб)"), _react2.default.createElement("input", {
	            className: _stylesModule2.default.FieldInput,
	            type: "text",
	            value: state.costFixedMinimum,
	            onChange: function onChange(e) {
	                onFieldChange(group, "costFixedMinimum", e.target.value);
	            },
	            placeholder: "0"
	        }), _react2.default.createElement("div", { className: _stylesModule2.default.FieldHint }, "Минимальная сумма процентной комиссии"))));
	    }
	
	    if (loading) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, "Загрузка комиссий...");
	    }
	
	    return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, _react2.default.createElement("div", { className: _stylesModule2.default.Title }, "Комиссии терминала"), renderFeeGroup("Оплата (Payment)", "Применяется к входящим платежам", "Purchase, Recurrent, SBP, M_P2P, P2P, QR", "payment", payment), renderFeeGroup("Выплаты (Payout)", "Применяется к выплатам", "Payout, Mobile Payout", "payout", payout), renderFeeGroup("Возвраты (Refund)", "Применяется к возвратам", "Refund", "refund", refund), _react2.default.createElement("div", { style: { marginTop: "15px", padding: "10px", background: "#f5f5f5", borderRadius: "4px", fontSize: "12px", color: "#666" } }, "\u0424\u043E\u0440\u043C\u0443\u043B\u0430: fixedPerTransaction + max(amount \xD7 cost%, costFixedMinimum). \u0424\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0438 \u043C\u0438\u043D. \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0440\u0443\u0431\u043B\u044F\u0445."), _react2.default.createElement("button", {
	        className: _stylesModule2.default.SaveBtn,
	        onClick: onSave,
	        disabled: saving
	    }, saving ? "Сохранение..." : "Сохранить комиссии"), status && _react2.default.createElement("div", {
	        className: _stylesModule2.default.StatusMsg + " " + (status.type === "success" ? _stylesModule2.default.StatusSuccess : _stylesModule2.default.StatusError)
	    }, status.text));
	}
	
	exports.default = TerminalFeesTab;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(582);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * TerminalSettlementTab — вкладка «Расчёты» в детальном виде терминала.
	 * Settlement config + последние settlement батчи.
	 *
	 * Props:
	 *   token (string)
	 *   terminal (object) — { id, ... }
	 */
	function TerminalSettlementTab(props) {
	    var token = props.token;
	    var terminal = props.terminal;
	
	    // Settlement config
	    var _config = (0, _react.useState)({
	        enabled: false,
	        commissionTransactionEnabled: false
	    });
	    var config = _config[0];
	    var setConfig = _config[1];
	
	    var _configLoading = (0, _react.useState)(true);
	    var configLoading = _configLoading[0];
	    var setConfigLoading = _configLoading[1];
	
	    var _configSaving = (0, _react.useState)(false);
	    var configSaving = _configSaving[0];
	    var setConfigSaving = _configSaving[1];
	
	    var _configStatus = (0, _react.useState)(null);
	    var configStatus = _configStatus[0];
	    var setConfigStatus = _configStatus[1];
	
	    // Settlements list
	    var _settlements = (0, _react.useState)([]);
	    var settlements = _settlements[0];
	    var setSettlements = _settlements[1];
	
	    var _settlementsLoading = (0, _react.useState)(true);
	    var settlementsLoading = _settlementsLoading[0];
	    var setSettlementsLoading = _settlementsLoading[1];
	
	    // Load config from balances endpoint
	    (0, _react.useEffect)(function () {
	        if (!terminal || !terminal.id) return;
	        setConfigLoading(true);
	        setConfigStatus(null);
	
	        var api = new _Api2.default({ token: token });
	        api.getTerminalBalances(terminal.id).then(function (data) {
	            var sc = data && data.settlementConfig || {};
	            setConfig({
	                enabled: !!sc.enabled,
	                commissionTransactionEnabled: !!sc.commissionTransactionEnabled
	            });
	            setConfigLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setConfigLoading(false);
	        });
	    }, [terminal && terminal.id, token]);
	
	    // Load settlements
	    (0, _react.useEffect)(function () {
	        if (!terminal || !terminal.id) return;
	        setSettlementsLoading(true);
	
	        var api = new _Api2.default({ token: token });
	        api.getSettlements({ terminal_id: terminal.id, limit: 10, page: 1 }).then(function (data) {
	            setSettlements(Array.isArray(data.data) ? data.data : []);
	            setSettlementsLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setSettlementsLoading(false);
	        });
	    }, [terminal && terminal.id, token]);
	
	    function onConfigChange(field, value) {
	        var next = {};
	        for (var k in config) {
	            next[k] = config[k];
	        }
	        next[field] = value;
	        setConfig(next);
	    }
	
	    function onSaveConfig() {
	        setConfigSaving(true);
	        setConfigStatus(null);
	
	        var api = new _Api2.default({ token: token });
	        api.updateTerminalSettlementConfig(terminal.id, config).then(function () {
	            setConfigSaving(false);
	            setConfigStatus({ type: "success", text: "Настройки сохранены" });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setConfigSaving(false);
	            var msg = err && err.response && err.response.data && err.response.data.message || "Ошибка сохранения";
	            setConfigStatus({ type: "error", text: msg });
	        });
	    }
	
	    function formatDate(dateStr) {
	        if (!dateStr) return "\u2014";
	        try {
	            var d = new Date(dateStr);
	            return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
	        } catch (e) {
	            return dateStr;
	        }
	    }
	
	    function formatAmount(kopecks) {
	        if (kopecks == null) return "\u2014";
	        return (Number(kopecks) / 100).toLocaleString("ru-RU", { minimumFractionDigits: 2 }) + " \u20BD";
	    }
	
	    function getStatusLabel(st) {
	        if (st === 1) return _react2.default.createElement("span", { className: _stylesModule2.default.StatusBadge + " " + _stylesModule2.default.StatusConfirmed }, "Подтверждён");
	        if (st === 2) return _react2.default.createElement("span", { className: _stylesModule2.default.StatusBadge + " " + _stylesModule2.default.StatusCancelled }, "Отменён");
	        return _react2.default.createElement("span", { className: _stylesModule2.default.StatusBadge }, "Создан");
	    }
	
	    if (configLoading) {
	        return _react2.default.createElement("div", { className: _stylesModule2.default.Container }, "Загрузка...");
	    }
	
	    return _react2.default.createElement("div", { className: _stylesModule2.default.Container },
	    // Settlement Config
	    _react2.default.createElement("div", { className: _stylesModule2.default.Title }, "Настройки расчётов"), _react2.default.createElement("div", { className: _stylesModule2.default.ConfigSection }, _react2.default.createElement("div", { className: _stylesModule2.default.ToggleRow }, _react2.default.createElement("input", {
	        type: "checkbox",
	        checked: config.enabled,
	        onChange: function onChange(e) {
	            onConfigChange("enabled", e.target.checked);
	        }
	    }), _react2.default.createElement("span", { className: _stylesModule2.default.ToggleLabel }, "Settlement включён")), _react2.default.createElement("div", { className: _stylesModule2.default.ToggleRow }, _react2.default.createElement("input", {
	        type: "checkbox",
	        checked: config.commissionTransactionEnabled,
	        onChange: function onChange(e) {
	            onConfigChange("commissionTransactionEnabled", e.target.checked);
	        }
	    }), _react2.default.createElement("span", { className: _stylesModule2.default.ToggleLabel }, "Создавать транзакции комиссии")), _react2.default.createElement("button", {
	        className: _stylesModule2.default.SaveBtn,
	        onClick: onSaveConfig,
	        disabled: configSaving
	    }, configSaving ? "Сохранение..." : "Сохранить настройки"), configStatus && _react2.default.createElement("div", {
	        className: _stylesModule2.default.StatusMsg + " " + (configStatus.type === "success" ? _stylesModule2.default.StatusSuccess : _stylesModule2.default.StatusError)
	    }, configStatus.text)),
	
	    // Recent Settlements
	    _react2.default.createElement("hr", { className: _stylesModule2.default.Divider }), _react2.default.createElement("div", { className: _stylesModule2.default.SettlementsTitle }, "Последние расчёты"), settlementsLoading ? _react2.default.createElement("div", null, "Загрузка...") : settlements.length === 0 ? _react2.default.createElement("div", { className: _stylesModule2.default.EmptyText }, "Нет расчётов для этого терминала") : _react2.default.createElement("div", { className: _stylesModule2.default.TableScroll }, _react2.default.createElement("table", { className: _stylesModule2.default.Table }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "ID"), _react2.default.createElement("th", null, "Дата"), _react2.default.createElement("th", null, "Сумма"), _react2.default.createElement("th", null, "Транзакций"), _react2.default.createElement("th", null, "Статус"), _react2.default.createElement("th", null, "Комментарий"))), _react2.default.createElement("tbody", null, settlements.map(function (s) {
	        return _react2.default.createElement("tr", { key: s.id }, _react2.default.createElement("td", null, s.id), _react2.default.createElement("td", null, formatDate(s.created_at)), _react2.default.createElement("td", null, formatAmount(s.amount)), _react2.default.createElement("td", null, s.transactions_count), _react2.default.createElement("td", null, getStatusLabel(s.status)), _react2.default.createElement("td", null, s.comment || "\u2014"));
	    })))), _react2.default.createElement("div", { style: { marginTop: "15px", fontSize: "12px", color: "#888" } }, "Полное управление расчётами доступно в разделе ", _react2.default.createElement("strong", null, "Расчёты"), " в меню слева."));
	}
	
	exports.default = TerminalSettlementTab;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _TimelineEvent = __webpack_require__(184);
	
	var _TimelineEvent2 = _interopRequireDefault(_TimelineEvent);
	
	var _stylesModule = __webpack_require__(203);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var EVENT_TYPES = [{ value: 'MERCHANT_REQUEST', label: 'Запрос от мерчанта' }, { value: 'MERCHANT_RESPONSE', label: 'Ответ мерчанту' }, { value: 'MERCHANT_CALLBACK', label: 'Callback мерчанту' }, { value: 'MERCHANT_CALLBACK_MISSING', label: 'Callback не настроен' }, { value: 'PROVIDER_REQUEST', label: 'Запрос к провайдеру' }, { value: 'PROVIDER_RESPONSE', label: 'Ответ от провайдера' }, { value: 'PROVIDER_CALLBACK', label: 'Callback от провайдера' }, { value: 'STATUS_CHANGE', label: 'Изменение статуса' }, { value: 'FRAUD_CHECK', label: 'Проверка антифрода' }, { value: 'FRAUD_BLOCK', label: 'Блокировка' }, { value: 'SYSTEM_NOTE', label: 'Системная заметка' }];
	
	var DIRECTIONS = [{ value: '', label: 'Все' }, { value: 'IN', label: 'Входящие (IN)' }, { value: 'OUT', label: 'Исходящие (OUT)' }];
	
	function TransactionAudit(_ref) {
	    var _this = this;
	
	    var transactionId = _ref.transactionId,
	        token = _ref.token,
	        initialData = _ref.initialData;
	
	    var _useState = (0, _react.useState)(!initialData),
	        _useState2 = _slicedToArray(_useState, 2),
	        loading = _useState2[0],
	        setLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        error = _useState4[0],
	        setError = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(initialData || null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        data = _useState6[0],
	        setData = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        exporting = _useState8[0],
	        setExporting = _useState8[1];
	
	    // Filters state
	
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        selectedEventTypes = _useState10[0],
	        setSelectedEventTypes = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(''),
	        _useState12 = _slicedToArray(_useState11, 2),
	        selectedDirection = _useState12[0],
	        setSelectedDirection = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        filtersOpen = _useState14[0],
	        setFiltersOpen = _useState14[1];
	
	    var fetchData = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var filters, result;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        if (!(!transactionId || !token)) {
	                            _context.next = 3;
	                            break;
	                        }
	
	                        setLoading(false);
	                        return _context.abrupt("return");
	
	                    case 3:
	
	                        setLoading(true);
	                        setError(null);
	
	                        _context.prev = 5;
	                        filters = {};
	
	                        if (selectedEventTypes.length > 0) {
	                            filters.eventTypes = selectedEventTypes;
	                        }
	                        if (selectedDirection) {
	                            filters.direction = selectedDirection;
	                        }
	
	                        _context.next = 11;
	                        return new _Api2.default({ token: token }).getTransactionAudit(transactionId, filters);
	
	                    case 11:
	                        result = _context.sent;
	
	                        setData(result);
	                        _context.next = 19;
	                        break;
	
	                    case 15:
	                        _context.prev = 15;
	                        _context.t0 = _context["catch"](5);
	
	                        Sentry.captureException(_context.t0);
	                        setError(_context.t0.message || "Не удалось загрузить данные аудита");
	
	                    case 19:
	                        _context.prev = 19;
	
	                        setLoading(false);
	                        return _context.finish(19);
	
	                    case 22:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, _this, [[5, 15, 19, 22]]);
	    })), [transactionId, token, selectedEventTypes, selectedDirection]);
	
	    // Перезапрашиваем только при изменении фильтров (не при первом монтировании, если есть initialData)
	    (0, _react.useEffect)(function () {
	        var hasFilters = selectedEventTypes.length > 0 || selectedDirection;
	        if (hasFilters || !initialData) {
	            fetchData();
	        }
	    }, [fetchData, initialData, selectedEventTypes, selectedDirection]);
	
	    var handleEventTypeToggle = function handleEventTypeToggle(eventType) {
	        setSelectedEventTypes(function (prev) {
	            return prev.includes(eventType) ? prev.filter(function (t) {
	                return t !== eventType;
	            }) : [].concat(_toConsumableArray(prev), [eventType]);
	        });
	    };
	
	    var handleClearFilters = function handleClearFilters() {
	        setSelectedEventTypes([]);
	        setSelectedDirection('');
	    };
	
	    var handleExport = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(format) {
	            var blob, url, a;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (!(!transactionId || !token)) {
	                                _context2.next = 2;
	                                break;
	                            }
	
	                            return _context2.abrupt("return");
	
	                        case 2:
	
	                            setExporting(true);
	                            _context2.prev = 3;
	                            _context2.next = 6;
	                            return new _Api2.default({ token: token }).exportTransactionAudit(transactionId, format);
	
	                        case 6:
	                            blob = _context2.sent;
	                            url = window.URL.createObjectURL(blob);
	                            a = document.createElement('a');
	
	                            a.href = url;
	                            a.download = "audit_" + transactionId + "." + format;
	                            document.body.appendChild(a);
	                            a.click();
	                            window.URL.revokeObjectURL(url);
	                            document.body.removeChild(a);
	                            _context2.next = 22;
	                            break;
	
	                        case 17:
	                            _context2.prev = 17;
	                            _context2.t0 = _context2["catch"](3);
	
	                            Sentry.captureException(_context2.t0);
	                            console.error('Export failed:', _context2.t0);
	                            alert('Export failed: ' + (_context2.t0.message || 'Unknown error'));
	
	                        case 22:
	                            _context2.prev = 22;
	
	                            setExporting(false);
	                            return _context2.finish(22);
	
	                        case 25:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this, [[3, 17, 22, 25]]);
	        }));
	
	        return function handleExport(_x) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    if (loading) {
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Loading },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.loading", defaultMessage: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445..." })
	        );
	    }
	
	    if (error) {
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Error },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.error", defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430: {error}", values: { error: error } })
	        );
	    }
	
	    if (!data) {
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Empty },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.empty", defaultMessage: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0430\u0443\u0434\u0438\u0442\u0430" })
	        );
	    }
	
	    var _data$events = data.events,
	        events = _data$events === undefined ? [] : _data$events;
	
	    // events уже содержат все данные в нужном формате от API
	
	    var allEvents = events.map(function (e) {
	        return Object.assign({}, e, { source: 'timeline' });
	    }).sort(function (a, b) {
	        return new Date(a.createdAt) - new Date(b.createdAt);
	    });
	
	    var hasActiveFilters = selectedEventTypes.length > 0 || selectedDirection;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Container },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Header },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.title", defaultMessage: "\u0410\u0443\u0434\u0438\u0442 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439" }),
	            _react2.default.createElement(
	                "span",
	                { className: _stylesModule2.default.TransactionId },
	                "#",
	                transactionId
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.HeaderActions },
	                _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.FilterToggle + " " + (hasActiveFilters ? _stylesModule2.default.FilterActive : ''),
	                        onClick: function onClick() {
	                            return setFiltersOpen(!filtersOpen);
	                        }
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.filters", defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B" }),
	                    hasActiveFilters && _react2.default.createElement(
	                        "span",
	                        {
	                            className: _stylesModule2.default.FilterBadge },
	                        selectedEventTypes.length + (selectedDirection ? 1 : 0)
	                    )
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.ExportBtn,
	                        onClick: function onClick() {
	                            return handleExport('json');
	                        },
	                        disabled: exporting,
	                        title: "Export JSON"
	                    },
	                    "JSON"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        className: _stylesModule2.default.ExportBtn,
	                        onClick: function onClick() {
	                            return handleExport('csv');
	                        },
	                        disabled: exporting,
	                        title: "Export CSV"
	                    },
	                    "CSV"
	                )
	            )
	        ),
	        filtersOpen && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.FiltersPanel },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterGroup },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.FilterLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.eventTypes", defaultMessage: "\u0422\u0438\u043F\u044B \u0441\u043E\u0431\u044B\u0442\u0438\u0439" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.FilterChips },
	                    EVENT_TYPES.map(function (_ref4) {
	                        var value = _ref4.value,
	                            label = _ref4.label;
	                        return _react2.default.createElement(
	                            "button",
	                            {
	                                key: value,
	                                className: _stylesModule2.default.FilterChip + " " + (selectedEventTypes.includes(value) ? _stylesModule2.default.FilterChipActive : ''),
	                                onClick: function onClick() {
	                                    return handleEventTypeToggle(value);
	                                }
	                            },
	                            label
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterGroup },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.FilterLabel },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.direction", defaultMessage: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.FilterChips },
	                    DIRECTIONS.map(function (_ref5) {
	                        var value = _ref5.value,
	                            label = _ref5.label;
	                        return _react2.default.createElement(
	                            "button",
	                            {
	                                key: value,
	                                className: _stylesModule2.default.FilterChip + " " + (selectedDirection === value ? _stylesModule2.default.FilterChipActive : ''),
	                                onClick: function onClick() {
	                                    return setSelectedDirection(value);
	                                }
	                            },
	                            label
	                        );
	                    })
	                )
	            ),
	            hasActiveFilters && _react2.default.createElement(
	                "button",
	                { className: _stylesModule2.default.ClearFilters, onClick: handleClearFilters },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.clearFilters", defaultMessage: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B" })
	            )
	        ),
	        allEvents.length === 0 ? _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Empty },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.noEvents", defaultMessage: "\u0421\u043E\u0431\u044B\u0442\u0438\u044F \u043F\u043E\u043A\u0430 \u043D\u0435 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u044B" })
	        ) : _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Timeline },
	            allEvents.map(function (event, index) {
	                return _react2.default.createElement(_TimelineEvent2.default, { key: event.id || index, event: event, isLast: index === allEvents.length - 1 });
	            })
	        )
	    );
	}
	
	exports.default = TransactionAudit;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TransactionAudit = __webpack_require__(431);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransactionAudit).default;
	  }
	});
	
	var _TimelineEvent = __webpack_require__(184);
	
	Object.defineProperty(exports, "TimelineEvent", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TimelineEvent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _StatusCheckbox = __webpack_require__(442);
	
	var _StatusCheckbox2 = _interopRequireDefault(_StatusCheckbox);
	
	var _stylesModule = __webpack_require__(583);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var STATUS_GROUPS = {
	    payInOnly: ["purchase", "purchaseDecline", "recurrent", "recurrentDecline", "recurrentCreated", "recurrentPending", "reversal", "reversalDecline", "reversalCreated", "reversalPending", "refund", "refundDecline", "refundCreated", "refundPending", "threeDSPending", "created"],
	    payOutOnly: ["payout", "payoutCreated", "payoutPending", "payoutDecline", "mobilePayout", "mobilePayoutCreated", "mobilePayoutPending", "mobilePayoutDecline"],
	    p2pOnly: ["mP2P", "mP2PCreated", "mP2PPending", "mP2PDecline", "successfulP2P"],
	    sbpOnly: ["sbp", "sbpCreated", "sbpPending", "sbpDecline", "successfulSBP"],
	    qrOnly: ["qr", "qrCreated", "qrPending", "qrDecline"],
	    any: ["purchaseCreated", "purchasePending", "chargeback"]
	};
	
	var ALL_STATUSES = ["mP2P", "mP2PCreated", "mP2PPending", "mP2PDecline", "successfulP2P", "sbp", "sbpCreated", "sbpPending", "sbpDecline", "successfulSBP", "qr", "qrCreated", "qrPending", "qrDecline", "purchase", "purchaseDecline", "recurrent", "recurrentDecline", "recurrentCreated", "recurrentPending", "reversal", "reversalDecline", "reversalCreated", "reversalPending", "refund", "refundDecline", "refundCreated", "refundPending", "threeDSPending", "payout", "payoutCreated", "payoutPending", "payoutDecline", "mobilePayout", "mobilePayoutCreated", "mobilePayoutPending", "mobilePayoutDecline", "purchaseCreated", "purchasePending", "chargeback", "created"].sort();
	
	var CATEGORY_NAMES = {
	    payments: { id: "TransactionsFilters.category.payments", defaultMessage: "Платежи" },
	    p2p: { id: "TransactionsFilters.category.p2p", defaultMessage: "P2P операции" },
	    SBP: { id: "TransactionsFilters.category.SBP", defaultMessage: "СБП операции" },
	    QR: { id: "TransactionsFilters.category.QR", defaultMessage: "QR операции" },
	    payout: { id: "TransactionsFilters.category.payout", defaultMessage: "Выплаты" }
	};
	
	var CATEGORY_ICONS = {
	    payments: "banknote",
	    p2p: "coin-dollar",
	    SBP: "mobile",
	    QR: "mobile",
	    payout: "dollar"
	};
	
	function TransactionsFilters(_ref) {
	    var onApplyFilters = _ref.onApplyFilters,
	        onSelectFilter = _ref.onSelectFilter,
	        isLoading = _ref.isLoading,
	        token = _ref.token,
	        adminPrivileges = _ref.adminPrivileges;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)({}),
	        _useState2 = _slicedToArray(_useState, 2),
	        paymentsStatus = _useState2[0],
	        setPaymentsStatus = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({
	        payments: false,
	        p2p: false,
	        SBP: false,
	        QR: false,
	        payout: false
	    }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        topCategories = _useState4[0],
	        setTopCategories = _useState4[1];
	
	    var isStatusSelected = function isStatusSelected(statusName) {
	        if (!paymentsStatus[statusName]) return false;
	        return paymentsStatus[statusName].selected === true;
	    };
	
	    (0, _react.useEffect)(function () {
	        var newTop = Object.assign({}, topCategories);
	
	        if (topCategories.payments) {
	            var allPayInSelected = STATUS_GROUPS.payInOnly.every(isStatusSelected);
	            var anyAnySelected = STATUS_GROUPS.any.some(isStatusSelected);
	            if (!allPayInSelected && !anyAnySelected) {
	                newTop.payments = false;
	            }
	        }
	        if (topCategories.p2p) {
	            var allP2pSelected = STATUS_GROUPS.p2pOnly.every(isStatusSelected);
	            var _anyAnySelected = STATUS_GROUPS.any.some(isStatusSelected);
	            if (!allP2pSelected && !_anyAnySelected) newTop.p2p = false;
	        }
	        if (topCategories.SBP) {
	            var allSbpSelected = STATUS_GROUPS.sbpOnly.every(isStatusSelected);
	            var _anyAnySelected2 = STATUS_GROUPS.any.some(isStatusSelected);
	            if (!allSbpSelected && !_anyAnySelected2) newTop.SBP = false;
	        }
	        if (topCategories.QR) {
	            var allQrSelected = STATUS_GROUPS.qrOnly.every(isStatusSelected);
	            var _anyAnySelected3 = STATUS_GROUPS.any.some(isStatusSelected);
	            if (!allQrSelected && !_anyAnySelected3) newTop.QR = false;
	        }
	        if (topCategories.payout) {
	            var allPayoutSelected = STATUS_GROUPS.payOutOnly.every(isStatusSelected);
	            var _anyAnySelected4 = STATUS_GROUPS.any.some(isStatusSelected);
	            if (!allPayoutSelected && !_anyAnySelected4) newTop.payout = false;
	        }
	
	        setTopCategories(newTop);
	    }, [paymentsStatus]);
	
	    var handleTopCategoryChange = function handleTopCategoryChange(category, checked) {
	        var updated = Object.assign({}, paymentsStatus);
	        var newTop = Object.assign({}, topCategories, _defineProperty({}, category, checked));
	
	        STATUS_GROUPS.any.forEach(function (name) {
	            var current = updated[name] || {};
	            updated[name] = Object.assign({}, current, { selected: checked });
	        });
	
	        if (category === "payments") {
	            STATUS_GROUPS.payInOnly.forEach(function (name) {
	                var current = updated[name] || {};
	                updated[name] = Object.assign({}, current, { selected: checked });
	            });
	        } else if (category === "payout") {
	            STATUS_GROUPS.payOutOnly.forEach(function (name) {
	                var current = updated[name] || {};
	                updated[name] = Object.assign({}, current, { selected: checked });
	            });
	        } else if (category === "p2p") {
	            STATUS_GROUPS.p2pOnly.forEach(function (name) {
	                var current = updated[name] || {};
	                updated[name] = Object.assign({}, current, { selected: checked });
	            });
	        } else if (category === "SBP") {
	            STATUS_GROUPS.sbpOnly.forEach(function (name) {
	                var current = updated[name] || {};
	                updated[name] = Object.assign({}, current, { selected: checked });
	            });
	        } else if (category === "QR") {
	            STATUS_GROUPS.qrOnly.forEach(function (name) {
	                var current = updated[name] || {};
	                updated[name] = Object.assign({}, current, { selected: checked });
	            });
	        }
	
	        setPaymentsStatus(updated);
	        setTopCategories(newTop);
	        triggerOnSelectFilter(updated);
	    };
	
	    var handleStatusSelect = function handleStatusSelect(statusName, checked) {
	        var current = paymentsStatus[statusName] || {};
	        var updated = Object.assign({}, paymentsStatus, _defineProperty({}, statusName, Object.assign({}, current, { selected: checked })));
	        setPaymentsStatus(updated);
	        triggerOnSelectFilter(updated);
	    };
	
	    function triggerOnSelectFilter(statusObj) {
	        var selected = [];
	        for (var key in statusObj) {
	            if (statusObj[key] && statusObj[key].selected) {
	                var item = {};
	                item[key] = true;
	                selected.push(item);
	            }
	        }
	        onSelectFilter(selected);
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Body },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsFilters.title.acquiring",
	                        defaultMessage: "\u042D\u043A\u0432\u0430\u0439\u0440\u0438\u043D\u0433" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "aCard", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ aCard: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "aCard", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.InputIcon, icon: "credit-card", size: "17px" }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsFilters.acquiring.card",
	                                    defaultMessage: "\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435 \u043A\u0430\u0440\u0442\u044B" })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "aPhone", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ aPhone: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "aPhone", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.InputIcon, icon: "mobile", size: "17px" }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsFilters.acquiring.phone",
	                                    defaultMessage: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B" })
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsFilters.title.filters",
	                        defaultMessage: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckboxWrap },
	                        _react2.default.createElement("input", { id: "onlyRegistry", type: "checkbox",
	                            onChange: function onChange(e) {
	                                return onSelectFilter({ onlyRegistry: e.target.checked });
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "onlyRegistry", className: _stylesModule2.default.CustomCheckbox },
	                            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.InputIcon, icon: "share", size: "17px" }),
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsFilters.filters.registry",
	                                    defaultMessage: "\u0412\u044B\u043F\u043B\u0430\u0442\u044B \u043F\u043E \u0440\u0435\u0435\u0441\u0442\u0440\u0430\u043C" })
	                            )
	                        )
	                    ),
	                    ["payments", "p2p", "SBP", "QR", "payout"].map(function (cat) {
	                        return _react2.default.createElement(
	                            "div",
	                            { key: cat, className: _stylesModule2.default.CheckboxWrap },
	                            _react2.default.createElement("input", {
	                                id: "top-" + cat,
	                                type: "checkbox",
	                                checked: topCategories[cat] === true,
	                                onChange: function onChange(e) {
	                                    return handleTopCategoryChange(cat, e.target.checked);
	                                }
	                            }),
	                            _react2.default.createElement(
	                                "label",
	                                { htmlFor: "top-" + cat, className: _stylesModule2.default.CustomCheckbox },
	                                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.InputIcon, icon: CATEGORY_ICONS[cat], size: "17px" }),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    intl.formatMessage(CATEGORY_NAMES[cat])
	                                )
	                            )
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Group },
	                _react2.default.createElement(
	                    "h6",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsFilters.title.statuses", defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441\u044B" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Column },
	                    ALL_STATUSES.map(function (statusName) {
	                        var statusData = paymentsStatus[statusName];
	                        var selected = statusData ? statusData.selected === true : false;
	                        var count = statusData ? statusData.count || 0 : 0;
	
	                        if (!adminPrivileges && count === 0) return null;
	
	                        return _react2.default.createElement(_StatusCheckbox2.default, {
	                            key: statusName,
	                            category: "",
	                            name: statusName,
	                            count: count,
	                            isSelected: selected,
	                            isDisabled: false,
	                            onChange: function onChange(obj) {
	                                var value = Object.values(obj)[0];
	                                handleStatusSelect(statusName, value);
	                            }
	                        });
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Footer },
	            _react2.default.createElement(_Button2.default, {
	                onClick: onApplyFilters,
	                label: "TransactionsFilters.btn.setFilters",
	                icon: "filter",
	                iconSize: "17px",
	                isLoading: !isLoading
	            })
	        )
	    );
	}
	
	exports.default = TransactionsFilters;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(109);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empty = function Empty() {
	    return _react2.default.createElement(
	        "tr",
	        { className: _stylesModule2.default.EmptyRow },
	        _react2.default.createElement(
	            "td",
	            { colSpan: "5" },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Empty },
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.empty", defaultMessage: "\u041F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u043D\u0435\u0442" })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Empty;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _VTabBar = __webpack_require__(60);
	
	var _VTabBar2 = _interopRequireDefault(_VTabBar);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(109);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _card = __webpack_require__(651);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _visa = __webpack_require__(656);
	
	var _visa2 = _interopRequireDefault(_visa);
	
	var _mastercard = __webpack_require__(654);
	
	var _mastercard2 = _interopRequireDefault(_mastercard);
	
	var _maestro = __webpack_require__(653);
	
	var _maestro2 = _interopRequireDefault(_maestro);
	
	var _jcb = __webpack_require__(652);
	
	var _jcb2 = _interopRequireDefault(_jcb);
	
	var _mir = __webpack_require__(655);
	
	var _mir2 = _interopRequireDefault(_mir);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function TableRow(_ref) {
	    var _this = this;
	
	    var handleDeclineClick = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	            var newType;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            e.preventDefault();
	                            e.stopPropagation();
	
	                            if (window.confirm(intl.formatMessage({
	                                id: "TransactionsTable.confirm.decline",
	                                defaultMessage: "Перевести транзакцию {id} в статус Decline?"
	                            }, { id: data.id }))) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            return _context.abrupt("return");
	
	                        case 4:
	                            _context.prev = 4;
	                            _context.next = 7;
	                            return new _Api2.default({ token: token }).declineTransaction(data.id);
	
	                        case 7:
	                            newType = toDeclineType(txType);
	
	                            setTxType(newType);
	                            setTxStatusText("decline");
	                            alert(intl.formatMessage({
	                                id: "TransactionsTable.success.decline",
	                                defaultMessage: "Статус транзакции обновлён на Decline"
	                            }));
	                            _context.next = 16;
	                            break;
	
	                        case 13:
	                            _context.prev = 13;
	                            _context.t0 = _context["catch"](4);
	
	                            alert(intl.formatMessage({
	                                id: "TransactionsTable.error.decline",
	                                defaultMessage: "Не удалось перевести транзакцию в статус Decline"
	                            }));
	
	                        case 16:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[4, 13]]);
	        }));
	
	        return function handleDeclineClick(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    var handlePayoutClick = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	            var newType;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            e.preventDefault();
	                            e.stopPropagation();
	
	                            if (window.confirm(intl.formatMessage({
	                                id: "TransactionsTable.confirm.payout",
	                                defaultMessage: "Перевести транзакцию {id} в статус Payout?"
	                            }, { id: data.id }))) {
	                                _context2.next = 4;
	                                break;
	                            }
	
	                            return _context2.abrupt("return");
	
	                        case 4:
	                            _context2.prev = 4;
	                            _context2.next = 7;
	                            return new _Api2.default({ token: token }).payoutTransaction(data.id);
	
	                        case 7:
	                            newType = toPayoutType(txType);
	
	                            setTxType(newType);
	                            setTxStatusText("payout");
	                            alert(intl.formatMessage({
	                                id: "TransactionsTable.success.payout",
	                                defaultMessage: "Статус транзакции обновлён на Payout"
	                            }));
	                            _context2.next = 16;
	                            break;
	
	                        case 13:
	                            _context2.prev = 13;
	                            _context2.t0 = _context2["catch"](4);
	
	                            alert(intl.formatMessage({
	                                id: "TransactionsTable.error.payout",
	                                defaultMessage: "Не удалось перевести транзакцию в статус Payout"
	                            }));
	
	                        case 16:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[4, 13]]);
	        }));
	
	        return function handlePayoutClick(_x2) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    // === Повторная отправка мерчанту ===
	
	
	    var handleResendClick = function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	            var api, res, _status, body, confirmed, _res;
	
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            e.preventDefault();
	                            e.stopPropagation();
	
	                            if (window.confirm(isAgentDeposit ? intl.formatMessage({
	                                id: "TransactionsTable.resend.confirmDeposit",
	                                defaultMessage: "Повторить доставку депозита {id} мерчанту?"
	                            }, { id: data.id }) : intl.formatMessage({
	                                id: "TransactionsTable.resend.confirm",
	                                defaultMessage: "Отправить мерчанту уведомление по транзакции {id} повторно?"
	                            }, { id: data.id }))) {
	                                _context3.next = 4;
	                                break;
	                            }
	
	                            return _context3.abrupt("return");
	
	                        case 4:
	                            api = new _Api2.default({ token: token });
	
	                            setIsResending(true);
	                            _context3.prev = 6;
	                            _context3.next = 9;
	                            return api.resendTransactionCallback(data.id);
	
	                        case 9:
	                            res = _context3.sent;
	
	                            applyDepositStatus(res);
	                            alert(resendResultText(res));
	                            _context3.next = 35;
	                            break;
	
	                        case 14:
	                            _context3.prev = 14;
	                            _context3.t0 = _context3["catch"](6);
	                            _status = _context3.t0 && _context3.t0.response && _context3.t0.response.status;
	                            body = _context3.t0 && _context3.t0.response && _context3.t0.response.data;
	
	                            if (!(_status === 409 && body && body.needsConfirmation)) {
	                                _context3.next = 34;
	                                break;
	                            }
	
	                            // Отклонённый депозит: деньги мерчанту — только после отдельного подтверждения.
	                            confirmed = window.confirm(intl.formatMessage({
	                                id: "TransactionsTable.resend.confirmReopen",
	                                defaultMessage: "Депозит {id} закрыт отказом мерчанта. Он будет отправлен мерчанту заново и, если мерчант его примет, зачислен на баланс мерчанта (сумма за вычетом комиссии). Продолжить?"
	                            }, { id: data.id }));
	
	                            if (!confirmed) {
	                                _context3.next = 32;
	                                break;
	                            }
	
	                            _context3.prev = 21;
	                            _context3.next = 24;
	                            return api.resendTransactionCallback(data.id, { reopenDeclined: true });
	
	                        case 24:
	                            _res = _context3.sent;
	
	                            applyDepositStatus(_res);
	                            alert(resendResultText(_res));
	                            _context3.next = 32;
	                            break;
	
	                        case 29:
	                            _context3.prev = 29;
	                            _context3.t1 = _context3["catch"](21);
	
	                            alert(resendErrorText(_context3.t1));
	
	                        case 32:
	                            _context3.next = 35;
	                            break;
	
	                        case 34:
	                            alert(resendErrorText(_context3.t0));
	
	                        case 35:
	                            _context3.prev = 35;
	
	                            setIsResending(false);
	                            return _context3.finish(35);
	
	                        case 38:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[6, 14, 35, 38], [21, 29]]);
	        }));
	
	        return function handleResendClick(_x3) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	
	    // === NEW: изменить сумму ===
	
	
	    var handleAmountChangeSave = function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	            var normalized, res, msg;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            e.preventDefault();
	                            e.stopPropagation();
	
	                            normalized = String(editAmount || "").trim().replace(",", ".");
	
	                            if (normalized) {
	                                _context4.next = 6;
	                                break;
	                            }
	
	                            alert(intl.formatMessage({
	                                id: "TransactionsTable.amount.error.required",
	                                defaultMessage: "Введите сумму"
	                            }));
	                            return _context4.abrupt("return");
	
	                        case 6:
	                            if (/^\d+(\.\d+)?$/.test(normalized)) {
	                                _context4.next = 9;
	                                break;
	                            }
	
	                            alert(intl.formatMessage({
	                                id: "TransactionsTable.amount.error.invalid",
	                                defaultMessage: "Некорректный формат суммы. Пример: 1000 или 1000.50"
	                            }));
	                            return _context4.abrupt("return");
	
	                        case 9:
	                            if (window.confirm(intl.formatMessage({
	                                id: "TransactionsTable.amount.confirm",
	                                defaultMessage: "Изменить сумму транзакции {id} на {amount}?"
	                            }, { id: data.id, amount: normalized }))) {
	                                _context4.next = 11;
	                                break;
	                            }
	
	                            return _context4.abrupt("return");
	
	                        case 11:
	
	                            setIsAmountSaving(true);
	                            _context4.prev = 12;
	                            _context4.next = 15;
	                            return new _Api2.default({ token: token }).changeTransactionAmount(data.id, normalized);
	
	                        case 15:
	                            res = _context4.sent;
	
	                            if (!(res && res.error)) {
	                                _context4.next = 19;
	                                break;
	                            }
	
	                            alert(res.message || intl.formatMessage({
	                                id: "TransactionsTable.amount.error.save",
	                                defaultMessage: "Не удалось изменить сумму транзакции"
	                            }));
	                            return _context4.abrupt("return");
	
	                        case 19:
	
	                            // сервер вернёт newAmount (major units), используем её
	                            if (res && res.newAmount !== undefined && res.newAmount !== null) {
	                                setDisplayAmount(res.newAmount);
	                                setEditAmount(String(res.newAmount));
	                            } else {
	                                // fallback
	                                setDisplayAmount(Number(normalized));
	                            }
	
	                            alert(intl.formatMessage({
	                                id: "TransactionsTable.amount.success",
	                                defaultMessage: "Сумма транзакции обновлена"
	                            }));
	                            _context4.next = 27;
	                            break;
	
	                        case 23:
	                            _context4.prev = 23;
	                            _context4.t0 = _context4["catch"](12);
	                            msg = _context4.t0 && _context4.t0.response && _context4.t0.response.data && _context4.t0.response.data.message || intl.formatMessage({
	                                id: "TransactionsTable.amount.error.save",
	                                defaultMessage: "Не удалось изменить сумму транзакции"
	                            });
	
	                            alert(msg);
	
	                        case 27:
	                            _context4.prev = 27;
	
	                            setIsAmountSaving(false);
	                            return _context4.finish(27);
	
	                        case 30:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this, [[12, 23, 27, 30]]);
	        }));
	
	        return function handleAmountChangeSave(_x4) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	
	    var data = _ref.data,
	        token = _ref.token,
	        onTransactionCancel = _ref.onTransactionCancel,
	        cancelTransactionData = _ref.cancelTransactionData,
	        cancelInProcess = _ref.cancelInProcess,
	        adminPrivileges = _ref.adminPrivileges;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        status = _useState4[0],
	        setStatus = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(data.accountingDate),
	        _useState6 = _slicedToArray(_useState5, 2),
	        accountingDate = _useState6[0],
	        setAccountingDate = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        setInProcessCancel = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        checkResult = _useState10[0],
	        setCheckResult = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isChecking = _useState12[0],
	        setIsChecking = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(data.type),
	        _useState14 = _slicedToArray(_useState13, 2),
	        txType = _useState14[0],
	        setTxType = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(data.status),
	        _useState16 = _slicedToArray(_useState15, 2),
	        txStatusText = _useState16[0],
	        setTxStatusText = _useState16[1];
	
	    // === NEW: локально отображаемая сумма ===
	
	
	    var _useState17 = (0, _react.useState)(data.amount),
	        _useState18 = _slicedToArray(_useState17, 2),
	        displayAmount = _useState18[0],
	        setDisplayAmount = _useState18[1];
	
	    // === NEW: управление изменением суммы ===
	
	
	    var _useState19 = (0, _react.useState)(data.amount !== undefined && data.amount !== null ? String(data.amount) : ""),
	        _useState20 = _slicedToArray(_useState19, 2),
	        editAmount = _useState20[0],
	        setEditAmount = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(false),
	        _useState22 = _slicedToArray(_useState21, 2),
	        isAmountSaving = _useState22[0],
	        setIsAmountSaving = _useState22[1];
	
	    // Повторная отправка мерчанту. Для депозита агента это повтор зачисления.
	
	
	    var isAgentDeposit = data.isAgentDeposit === true;
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        isResending = _useState24[0],
	        setIsResending = _useState24[1];
	
	    (0, _react.useEffect)(function () {
	        if (cancelInProcess.id === data.id) {
	            setInProcessCancel(cancelInProcess.inProcess);
	        }
	    }, [cancelInProcess, data.id]);
	
	    (0, _react.useEffect)(function () {
	        if (cancelTransactionData.currentId === data.id) {
	            new _Api2.default({ token: token }).getTransactionStatus(data.id).then(function (r) {
	                setAccountingDate(r.accountingDate || data.accountingDate);
	                setInProcessCancel(false);
	                setStatus(r);
	            });
	        }
	    }, [cancelTransactionData, data.id, token]);
	
	    // если раскрыли строку — подставим текущую сумму в инпут
	    (0, _react.useEffect)(function () {
	        if (isOpened) {
	            setEditAmount(displayAmount !== undefined && displayAmount !== null ? String(displayAmount) : "");
	        }
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, [isOpened]);
	
	    var styles = { transaction: { color: "#d4d4d4", borderColor: "#d4d4d4" } };
	
	    var cardLogo = function () {
	        switch (data.cardBrand) {
	            case "VISA":
	                return _react2.default.createElement("img", { src: _visa2.default, width: "39", height: "18", alt: "VISA" });
	            case "MASTERCARD":
	                return _react2.default.createElement("img", { src: _mastercard2.default, width: "36", height: "20", alt: "MASTERCARD" });
	            case "MAESTRO":
	                return _react2.default.createElement("img", { src: _maestro2.default, width: "36", height: "20", alt: "MAESTRO" });
	            case "NSPK MIR":
	                return _react2.default.createElement("img", { src: _mir2.default, width: "39", height: "20", alt: "MIR" });
	            case "JCB":
	                return _react2.default.createElement("img", { src: _jcb2.default, width: "39", height: "20", alt: "JCB" });
	            case "DINERS CLUB INTERNATIONAL":
	                return _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CardIcon, icon: "cc-diners-club", size: "22px" });
	            case "AMERICAN EXPRESS":
	                return _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CardIcon, icon: "americanexpress", size: "18px" });
	            case "CHINA UNION PAY":
	                return _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CardIcon, icon: "americanexpress", size: "18px" });
	            case "DISCOVER":
	                return _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.CardIcon, icon: "discover", size: "18px" });
	            default:
	                return _react2.default.createElement("img", { src: _card2.default, width: "28", height: "20", alt: "CARD" });
	        }
	    }();
	
	    var updateStyle = function updateStyle() {
	        var successColor = "#109618"; // зелёный — успешные
	        var declineColor = "#DC3912"; // красный — ошибки
	        var createdColor = "#000000"; // чёрный — созданные/pending
	
	        var map = {
	            // Успешные — зелёные
	            purchase: successColor,
	            recurrent: successColor,
	            reversal: successColor,
	            refund: successColor,
	            payout: successColor,
	            sbp: successColor,
	            mP2P: successColor,
	            successfulP2P: successColor,
	            successfulSBP: successColor,
	            mobilePayout: successColor,
	            qr: successColor,
	            chargeback: "#644f0b",
	
	            // Decline — красные
	            payoutDecline: declineColor,
	            purchaseDecline: declineColor,
	            refundDecline: declineColor,
	            reversalDecline: declineColor,
	            recurrentDecline: declineColor,
	            mP2PDecline: declineColor,
	            sbpDecline: declineColor,
	            mobilePayoutDecline: declineColor,
	            qrDecline: declineColor,
	
	            // Created / Pending — чёрные
	            created: createdColor,
	            payoutCreated: createdColor,
	            purchaseCreated: createdColor,
	            refundCreated: createdColor,
	            reversalCreated: createdColor,
	            recurrentCreated: createdColor,
	            mP2PCreated: createdColor,
	            sbpCreated: createdColor,
	            mobilePayoutCreated: createdColor,
	            qrCreated: createdColor,
	            payoutPending: createdColor,
	            purchasePending: createdColor,
	            refundPending: createdColor,
	            reversalPending: createdColor,
	            recurrentPending: createdColor,
	            mP2PPending: createdColor,
	            sbpPending: createdColor,
	            mobilePayoutPending: createdColor,
	            threeDSPending: createdColor,
	            qrPending: createdColor
	        };
	        var color = map[txType] || createdColor;
	        styles.transaction = { color: color, borderColor: color };
	    };
	    updateStyle();
	
	    function toggleOpened(e) {
	        e.stopPropagation();
	        setIsOpened(function (prev) {
	            return !prev;
	        });
	        if (!status && (txType === "purchase" || txType === "recurrent")) {
	            new _Api2.default({ token: token }).getTransactionStatus(data.id).then(setStatus);
	        }
	    }
	
	    var isPendingOrCreated = function isPendingOrCreated(type) {
	        return typeof type === "string" && (type.indexOf("Pending") !== -1 || type.indexOf("Created") !== -1 || type === "created");
	    };
	
	    function toDeclineType(type) {
	        if (!type || typeof type !== "string") return type;
	        if (type.indexOf("Pending") !== -1) return type.replace("Pending", "Decline");
	        if (type.indexOf("Created") !== -1) return type.replace("Created", "Decline");
	        if (type === "created") return "purchaseDecline";
	        return type;
	    }
	
	    function toPayoutType(type) {
	        if (!type || typeof type !== "string") return type;
	        if (type.indexOf("Pending") !== -1) return "payoutPending";
	        if (type.indexOf("Created") !== -1) return "payoutCreated";
	        if (type === "created") return "payoutCreated";
	        return "payout";
	    }
	
	    var resendFlowLabel = function resendFlowLabel(flow) {
	        return intl.formatMessage({
	            id: "TransactionsTable.resend.flow." + flow,
	            defaultMessage: flow || "—"
	        });
	    };
	
	    function resendResultText(res) {
	        var lines = [res.message || ""];
	        lines.push(intl.formatMessage({ id: "TransactionsTable.resend.result.flow", defaultMessage: "Формат: {flow}" }, { flow: resendFlowLabel(res.flow) }));
	        if (res.urlHost) {
	            lines.push(intl.formatMessage({ id: "TransactionsTable.resend.result.host", defaultMessage: "Адрес: {host}" }, { host: res.urlHost }));
	        }
	        if (res.httpCode !== undefined && res.httpCode !== null) {
	            lines.push(intl.formatMessage({ id: "TransactionsTable.resend.result.httpCode", defaultMessage: "Ответ мерчанта: HTTP {code}" }, { code: res.httpCode }));
	        }
	        return lines.filter(Boolean).join("\n");
	    }
	
	    function resendErrorText(err) {
	        var body = err && err.response && err.response.data;
	        return body && body.message || intl.formatMessage({
	            id: "TransactionsTable.resend.error",
	            defaultMessage: "Не удалось отправить мерчанту повторно"
	        });
	    }
	
	    // Депозит агента после повтора мог сменить статус (зачислен / снова отказ).
	    function applyDepositStatus(res) {
	        var map = { success: "purchase", declined: "purchaseDecline", processing: "purchasePending" };
	        if (res && res.depositStatus && map[res.depositStatus]) {
	            setTxType(map[res.depositStatus]);
	        }
	    }
	
	    var fixServerTime = function fixServerTime(date) {
	        if (!date) return null;
	        var d = new Date(date);
	        return new Date(d.getTime() - 3 * 60 * 60 * 1000);
	    };
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            "tr",
	            { onClick: toggleOpened, className: _stylesModule2.default.Row },
	            _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(_FormatDate2.default, {
	                        setDate: data.date,
	                        format: {
	                            day: "numeric",
	                            month: "numeric",
	                            year: "numeric",
	                            hour: "numeric",
	                            minute: "numeric"
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { style: styles.transaction, className: _stylesModule2.default.Status },
	                    _react2.default.createElement("span", { style: styles.transaction }),
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.label." + txType, defaultMessage: txType })
	                )
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data.firstPart,
	                " \u2022\u2022\u2022\u2022 ",
	                data.lastPart,
	                _react2.default.createElement("br", null),
	                cardLogo
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_Amount2.default, { amount: displayAmount, currency: data.currencyCode })
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                data.merchantName
	            ),
	            _react2.default.createElement(
	                "td",
	                null,
	                isOpened ? _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "cheveron-up", size: "18px" }) : _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, icon: "cheveron-down", size: "18px" })
	            )
	        ),
	        isOpened && _react2.default.createElement(
	            "tr",
	            { className: _stylesModule2.default.InnerRow },
	            _react2.default.createElement(
	                "td",
	                { colSpan: 5, onClick: function onClick(e) {
	                        return e.stopPropagation();
	                    } },
	                _react2.default.createElement(
	                    "div",
	                    { onClick: function onClick(e) {
	                            return e.stopPropagation();
	                        } },
	                    _react2.default.createElement(
	                        _VTabBar2.default,
	                        {
	                            defaultActiveTab: intl.formatMessage({
	                                id: "TransactionsTable.tab.paymentData",
	                                defaultMessage: "Данные платежа"
	                            })
	                        },
	                        _react2.default.createElement(
	                            _VTabBar2.default.Tab,
	                            {
	                                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "TransactionsTable.tab.paymentData",
	                                    defaultMessage: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                                }),
	                                navIcon: "align-justified",
	                                isVisible: true
	                            },
	                            _react2.default.createElement(
	                                "table",
	                                { className: _stylesModule2.default.TabTable },
	                                _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.amount",
	                                                defaultMessage: "\u0421\u0443\u043C\u043C\u0430:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_Amount2.default, { amount: displayAmount, currency: data.currencyCode })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.fee",
	                                                defaultMessage: "\u041A\u043E\u043C\u043C\u0438\u0441\u0441\u0438\u044F:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_Amount2.default, { amount: data.fee, currency: data.currencyCode })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.email",
	                                                defaultMessage: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.customerMail || _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                "\u2014"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.cardHolder",
	                                                defaultMessage: "\u0414\u0435\u0440\u0436\u0430\u0442\u0435\u043B\u044C \u043A\u0430\u0440\u0442\u044B:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.cardHolder
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.phone",
	                                                defaultMessage: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.customerPhone || _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                "\u2014"
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _VTabBar2.default.Tab,
	                            {
	                                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "TransactionsTable.tab.parameters",
	                                    defaultMessage: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                                }),
	                                navIcon: "file-text",
	                                navIconSize: 16,
	                                isVisible: true
	                            },
	                            _react2.default.createElement(
	                                "table",
	                                { className: _stylesModule2.default.TabTable },
	                                _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.id",
	                                                defaultMessage: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.id
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.processId",
	                                                defaultMessage: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.processingOrderId ? data.processingOrderId.replace(/^(\d+\|)/, "") : "—"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.extendedStatus",
	                                                defaultMessage: "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            txStatusText || _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                "\u2014"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.processed",
	                                                defaultMessage: "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_FormatDate2.default, {
	                                                setDate: fixServerTime(accountingDate || data.accountingDate),
	                                                format: {
	                                                    day: "numeric",
	                                                    month: "numeric",
	                                                    year: "numeric",
	                                                    hour: "numeric",
	                                                    minute: "numeric"
	                                                }
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.bank",
	                                                defaultMessage: "\u0411\u0430\u043D\u043A \u043A\u0430\u0440\u0442\u044B:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.cardBankName || _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                "\u2014"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.country",
	                                                defaultMessage: "\u0421\u0442\u0440\u0430\u043D\u0430 \u043A\u0430\u0440\u0442\u044B:"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.cardBankCountryCode ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "binBase.country." + data.cardBankCountryCode,
	                                                defaultMessage: data.cardBankCountryCode
	                                            }) : _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                "\u2014"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.tab.rrn", defaultMessage: "RRN:" })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            data.rrn || _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                "\u2014"
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _VTabBar2.default.Tab,
	                            {
	                                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "TransactionsTable.tab.management",
	                                    defaultMessage: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435"
	                                }),
	                                navIcon: "settings",
	                                navIconSize: 16,
	                                isVisible: adminPrivileges
	                            },
	                            _react2.default.createElement(
	                                "table",
	                                { className: _stylesModule2.default.TabTable },
	                                _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                id: "TransactionsTable.tab.actions",
	                                                defaultMessage: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0438"
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            !checkResult && _react2.default.createElement(
	                                                "button",
	                                                {
	                                                    type: "button",
	                                                    className: _stylesModule2.default.LinkBtn,
	                                                    onClick: function () {
	                                                        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(e) {
	                                                            var result;
	                                                            return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                                                while (1) {
	                                                                    switch (_context5.prev = _context5.next) {
	                                                                        case 0:
	                                                                            e.preventDefault();
	                                                                            e.stopPropagation();
	                                                                            setIsChecking(true);
	                                                                            _context5.prev = 3;
	                                                                            _context5.next = 6;
	                                                                            return new _Api2.default({ token: token }).checkTransaction(data.id);
	
	                                                                        case 6:
	                                                                            result = _context5.sent;
	
	                                                                            setCheckResult(result.data);
	                                                                            _context5.next = 13;
	                                                                            break;
	
	                                                                        case 10:
	                                                                            _context5.prev = 10;
	                                                                            _context5.t0 = _context5["catch"](3);
	
	                                                                            setCheckResult({
	                                                                                error: true,
	                                                                                message: intl.formatMessage({
	                                                                                    id: "TransactionsTable.check.error",
	                                                                                    defaultMessage: "Ошибка при проверке транзакции"
	                                                                                })
	                                                                            });
	
	                                                                        case 13:
	                                                                            _context5.prev = 13;
	
	                                                                            setIsChecking(false);
	                                                                            return _context5.finish(13);
	
	                                                                        case 16:
	                                                                        case "end":
	                                                                            return _context5.stop();
	                                                                    }
	                                                                }
	                                                            }, _callee5, _this, [[3, 10, 13, 16]]);
	                                                        }));
	
	                                                        return function (_x5) {
	                                                            return _ref6.apply(this, arguments);
	                                                        };
	                                                    }(),
	                                                    disabled: isChecking
	                                                },
	                                                isChecking ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: "TransactionsTable.check.loading",
	                                                    defaultMessage: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430..."
	                                                }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                    id: "TransactionsTable.check.button",
	                                                    defaultMessage: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E"
	                                                })
	                                            ),
	                                            checkResult && _react2.default.createElement(
	                                                "div",
	                                                { onClick: function onClick(e) {
	                                                        return e.stopPropagation();
	                                                    } },
	                                                _react2.default.createElement(
	                                                    "p",
	                                                    null,
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.check.result",
	                                                        defaultMessage: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438:"
	                                                    })
	                                                ),
	                                                checkResult && !checkResult.error ? _react2.default.createElement(
	                                                    "table",
	                                                    { className: _stylesModule2.default.TabTable },
	                                                    _react2.default.createElement(
	                                                        "tbody",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            "tr",
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: "TransactionsTable.check.provider",
	                                                                    defaultMessage: "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440:"
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                checkResult.provider
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "tr",
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: "TransactionsTable.check.status",
	                                                                    defaultMessage: "\u0421\u0442\u0430\u0442\u0443\u0441:"
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                checkResult.statusHuman
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "tr",
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: "TransactionsTable.check.amount",
	                                                                    defaultMessage: "\u0421\u0443\u043C\u043C\u0430:"
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(_Amount2.default, { amount: checkResult.amount,
	                                                                    currency: checkResult.currency })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "tr",
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: "TransactionsTable.check.orderId",
	                                                                    defaultMessage: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043A\u0430\u0437\u0430:"
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                checkResult.orderId
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "tr",
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: "TransactionsTable.check.rrn",
	                                                                    defaultMessage: "RRN:"
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                checkResult.rrn || "—"
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "tr",
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                                    id: "TransactionsTable.check.message",
	                                                                    defaultMessage: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435:"
	                                                                })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                checkResult.message || "—"
	                                                            )
	                                                        )
	                                                    )
	                                                ) : _react2.default.createElement(
	                                                    "pre",
	                                                    {
	                                                        className: _stylesModule2.default.jsonBlock },
	                                                    JSON.stringify(checkResult, null, 2)
	                                                ),
	                                                _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        type: "button",
	                                                        className: _stylesModule2.default.LinkBtn,
	                                                        onClick: handleDeclineClick,
	                                                        disabled: !isPendingOrCreated(txType)
	                                                    },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.check.decline",
	                                                        defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0432 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u0435"
	                                                    })
	                                                ),
	                                                _react2.default.createElement("br", null),
	                                                _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        type: "button",
	                                                        className: _stylesModule2.default.LinkBtn,
	                                                        onClick: handlePayoutClick,
	                                                        disabled: !isPendingOrCreated(txType)
	                                                    },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.check.payout",
	                                                        defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0432 \u0432\u044B\u043F\u043B\u0430\u0442\u0443"
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { style: { marginTop: 12 }, onClick: function onClick(e) {
	                                                        return e.stopPropagation();
	                                                    } },
	                                                _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        type: "button",
	                                                        className: _stylesModule2.default.LinkBtn,
	                                                        onClick: handleResendClick,
	                                                        disabled: isResending
	                                                    },
	                                                    isResending ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.resend.sending",
	                                                        defaultMessage: "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430..."
	                                                    }) : isAgentDeposit ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.resend.buttonDeposit",
	                                                        defaultMessage: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435"
	                                                    }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.resend.button",
	                                                        defaultMessage: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0443 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E"
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { style: { marginTop: 12 }, onClick: function onClick(e) {
	                                                        return e.stopPropagation();
	                                                    } },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { style: { marginBottom: 6, fontWeight: 600 } },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.amount.section",
	                                                        defaultMessage: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0443\u043C\u043C\u0443"
	                                                    })
	                                                ),
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: _stylesModule2.default.AmountEditRow },
	                                                    _react2.default.createElement("input", {
	                                                        type: "text",
	                                                        value: editAmount,
	                                                        onChange: function onChange(e) {
	                                                            return setEditAmount(e.target.value);
	                                                        },
	                                                        onClick: function onClick(e) {
	                                                            return e.stopPropagation();
	                                                        },
	                                                        placeholder: intl.formatMessage({
	                                                            id: "TransactionsTable.amount.placeholder",
	                                                            defaultMessage: "Например: 1000 или 1000.50"
	                                                        }),
	                                                        className: _stylesModule2.default.AmountEditInput,
	                                                        disabled: isAmountSaving
	                                                    }),
	                                                    _react2.default.createElement(
	                                                        "button",
	                                                        {
	                                                            type: "button",
	                                                            className: _stylesModule2.default.LinkBtn,
	                                                            onClick: handleAmountChangeSave,
	                                                            disabled: isAmountSaving
	                                                        },
	                                                        isAmountSaving ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                            id: "TransactionsTable.amount.saving",
	                                                            defaultMessage: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..."
	                                                        }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                            id: "TransactionsTable.amount.save",
	                                                            defaultMessage: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"
	                                                        })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { style: { marginTop: 6, opacity: 0.8, fontSize: 12 } },
	                                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                                        id: "TransactionsTable.amount.note",
	                                                        defaultMessage: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445, \u0432 \u0411\u0414 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F \u0432 \u043A\u043E\u043F\u0435\u0439\u043A\u0430\u0445."
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TableRow;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Empty = __webpack_require__(434);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _TableRow = __webpack_require__(435);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(109);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransactionsTable(_ref) {
	    var transactions = _ref.transactions,
	        isLoading = _ref.isLoading,
	        token = _ref.token,
	        adminPrivileges = _ref.adminPrivileges;
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpened = _useState2[0],
	        setIsOpened = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({
	        id: null,
	        accountingDate: null,
	        amount: null,
	        currency: null,
	        canUsePartialRefund: null,
	        canUsePartialReversal: null
	    }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        transactionData = _useState4[0],
	        setTransactionData = _useState4[1];
	
	    var _useState5 = (0, _react.useState)({ currentId: null, cancelId: null }),
	        _useState6 = _slicedToArray(_useState5, 2),
	        cancelTransactionData = _useState6[0],
	        setCancelTransactionData = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({ inProcess: false, id: null }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        cancelInProcess = _useState8[0],
	        setCancelInProcess = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(0),
	        _useState10 = _slicedToArray(_useState9, 2),
	        amount = _useState10[0],
	        setAmount = _useState10[1];
	
	    function onTransactionCancel(id, accountingDate, amount, currency, canUsePartialRefund, canUsePartialReversal) {
	        setIsOpened(true);
	        setTransactionData({ id: id, accountingDate: accountingDate, amount: amount, currency: currency, canUsePartialRefund: canUsePartialRefund, canUsePartialReversal: canUsePartialReversal });
	        setAmount(amount);
	        setCancelInProcess(Object.assign({}, cancelInProcess, { id: id }));
	    }
	
	    function onCancelConfirm() {
	        setIsOpened(false);
	        setCancelInProcess(Object.assign({}, cancelInProcess, { inProcess: true }));
	
	        new _Api2.default({ token: token }).makeTransactionCancel(transactionData.id, amount).then(function (r) {
	            if (r.error) {
	                onMessage({
	                    type: "error",
	                    message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.cancel.error",
	                        defaultMessage: "\u041E\u0442\u043C\u0435\u043D\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430" })
	                });
	            } else if (r.code) {
	                onMessage({ type: "error", message: "(Code: " + r.code + "): " + r.message });
	            } else {
	                onMessage({
	                    type: "success",
	                    message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.cancel.success",
	                        defaultMessage: "\u041E\u0442\u043C\u0435\u043D\u0430 \u0438\u043D\u0438\u0446\u0438\u0438\u0440\u043E\u0432\u0430\u043D\u0430" })
	                });
	                setCancelTransactionData({ currentId: transactionData.id, cancelId: r.id });
	            }
	        }).finally(function () {
	            return setCancelInProcess(Object.assign({}, cancelInProcess, { inProcess: false }));
	        });
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.modal.title", defaultMessage: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435" }),
	                isOpen: isOpened,
	                onClose: function onClose() {
	                    return setIsOpened(false);
	                },
	                onConfirm: onCancelConfirm,
	                isConfirm: true
	            },
	            transactionData.accountingDate ? transactionData.canUsePartialRefund ? _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.ModalText },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "TransactionsTable.text.paymentPartialRefund",
	                        values: {
	                            amount: _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(_Amount2.default, { amount: transactionData.amount,
	                                    currency: transactionData.currency })
	                            )
	                        },
	                        defaultMessage: "\u041F\u043E \u0434\u0430\u043D\u043D\u043E\u0439 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442. \u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 {amount}. \u0412\u0440\u0435\u043C\u044F \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0431\u0430\u043D\u043A\u0430-\u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430 \u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043E\u0442 1 \u0434\u043E 7 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439."
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.CancelWrap },
	                    _react2.default.createElement(_FieldsHelper.InputAmountCurrencyHelper, {
	                        onChange: function onChange(val) {
	                            return setAmount(val.amount);
	                        },
	                        value: amount,
	                        currency: [transactionData.currency],
	                        maxValue: transactionData.amount,
	                        placeholder: transactionData.amount,
	                        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "FieldsHelper.label.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" }),
	                        changeMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "FieldsHelper.error.onlyNumbersAmount",
	                            defaultMessage: "\u0421\u0443\u043C\u043C\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0446\u0438\u0444\u0440\u044B \u0438 \u0437\u043D\u0430\u043A \xAB.\xBB. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 100.20" }),
	                        blurMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "FieldsHelper.error.checkAmount",
	                            defaultMessage: "\u0421 \u0441\u0443\u043C\u043C\u043E\u0439 \u0447\u0442\u043E-\u0442\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 100.20" }),
	                        isDisabled: cancelInProcess.inProcess
	                    })
	                )
	            ) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: "TransactionsTable.text.paymentRefund",
	                values: {
	                    amount: _react2.default.createElement(
	                        "b",
	                        null,
	                        _react2.default.createElement(_Amount2.default, { amount: transactionData.amount, currency: transactionData.currency })
	                    )
	                },
	                defaultMessage: "\u0411\u0443\u0434\u0435\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D \u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u043D\u0430 \u0441\u0443\u043C\u043C\u0443 {amount}. \u0412\u0440\u0435\u043C\u044F \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0431\u0430\u043D\u043A\u0430-\u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430 \u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043E\u0442 1 \u0434\u043E 7 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439."
	            }) : transactionData.canUsePartialReversal ? _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.ModalText },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "TransactionsTable.text.paymentPartialReversal",
	                        values: {
	                            amount: _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(_Amount2.default, { amount: transactionData.amount,
	                                    currency: transactionData.currency })
	                            )
	                        },
	                        defaultMessage: "\u041F\u043E \u0434\u0430\u043D\u043D\u043E\u0439 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u0430\u044F \u043E\u0442\u043C\u0435\u043D\u0430. \u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 {amount}. \u0412\u0440\u0435\u043C\u044F \u043E\u0442\u043C\u0435\u043D\u044B \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0431\u0430\u043D\u043A\u0430-\u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430 \u0438, \u043A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0447\u0430\u0441\u0430."
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.CancelWrap },
	                    _react2.default.createElement(_FieldsHelper.InputAmountCurrencyHelper, {
	                        onChange: function onChange(val) {
	                            return setAmount(val.amount);
	                        },
	                        value: amount,
	                        currency: [transactionData.currency],
	                        maxValue: transactionData.amount,
	                        placeholder: transactionData.amount,
	                        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "FieldsHelper.label.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" }),
	                        changeMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "FieldsHelper.error.onlyNumbersAmount",
	                            defaultMessage: "\u0421\u0443\u043C\u043C\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0446\u0438\u0444\u0440\u044B \u0438 \u0437\u043D\u0430\u043A \xAB.\xBB. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 100.20" }),
	                        blurMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "FieldsHelper.error.checkAmount",
	                            defaultMessage: "\u0421 \u0441\u0443\u043C\u043C\u043E\u0439 \u0447\u0442\u043E-\u0442\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 100.20" }),
	                        isDisabled: cancelInProcess.inProcess
	                    })
	                )
	            ) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: "TransactionsTable.text.paymentReversal",
	                values: {
	                    amount: _react2.default.createElement(
	                        "b",
	                        null,
	                        _react2.default.createElement(_Amount2.default, { amount: transactionData.amount, currency: transactionData.currency })
	                    )
	                },
	                defaultMessage: "\u0411\u0443\u0434\u0435\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0430 \u043E\u0442\u043C\u0435\u043D\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0430 \u0441\u0443\u043C\u043C\u0443 {amount}. \u0412\u0440\u0435\u043C\u044F \u043E\u0442\u043C\u0435\u043D\u044B \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0431\u0430\u043D\u043A\u0430-\u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430 \u0438, \u043A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0447\u0430\u0441\u0430."
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    "table",
	                    null,
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.table.date", defaultMessage: "\u0414\u0430\u0442\u0430" })
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.table.payer", defaultMessage: "\u041F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A" })
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.table.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsTable.table.project", defaultMessage: "\u041F\u0440\u043E\u0435\u043A\u0442" })
	                            ),
	                            _react2.default.createElement("th", null)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        transactions && transactions.length > 0 ? isLoading ? transactions.map(function (row) {
	                            return _react2.default.createElement(_TableRow2.default, {
	                                key: row.id,
	                                token: token,
	                                data: row,
	                                adminPrivileges: adminPrivileges,
	                                onTransactionCancel: onTransactionCancel,
	                                cancelTransactionData: cancelTransactionData,
	                                cancelInProcess: cancelInProcess
	                            });
	                        }) : _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                { colSpan: 5, style: { textAlign: "center" } },
	                                _react2.default.createElement(_Loader2.default, null)
	                            )
	                        ) : _react2.default.createElement(_Empty2.default, null)
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = TransactionsTable;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(40);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(586);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _reactIntl = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	    _inherits(Dropdown, _Component);
	
	    function Dropdown(props) {
	        _classCallCheck(this, Dropdown);
	
	        var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));
	
	        _this.state = {};
	
	        _this.toggleState = _this.toggleState.bind(_this);
	        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	        return _this;
	    }
	
	    _createClass(Dropdown, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('click', this.handleClickOutside, false);
	
	            this.setState({
	                isOpened: false
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(_prevProps, _prevState, _snapshot) {
	            document.addEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.handleClickOutside, false);
	        }
	    }, {
	        key: 'handleClickOutside',
	        value: function handleClickOutside(e) {
	            var node = _reactDom2.default.findDOMNode(this);
	
	            if (!node || !node.contains(e.target)) {
	                this.setState({
	                    isOpened: false
	                });
	            }
	        }
	    }, {
	        key: 'toggleState',
	        value: function toggleState() {
	            this.setState({ isOpened: !this.state.isOpened });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // Пропсы читаются при каждом рендере, а не запоминаются в
	            // конструкторе: заголовок бывает живым (например, с числом
	            // непрочитанных сообщений), и запомненный однажды он больше
	            // никогда не обновлялся.
	            var _props = this.props,
	                title = _props.title,
	                icon = _props.icon,
	                isHeader = _props.isHeader,
	                isFullWidth = _props.isFullWidth,
	                hideArrow = _props.hideArrow;
	
	            var useLocale = typeof this.props.useLocale === 'undefined' ? true : this.props.useLocale;
	            var headerStyle = isHeader ? { color: 'hsla(0,0%,100%,.8)', lineHeight: '48px' } : undefined;
	
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    {
	                        onClick: this.toggleState,
	                        style: headerStyle,
	                        className: this.state.isOpened ? _stylesModule2.default.Link + ' ' + _stylesModule2.default.Active : _stylesModule2.default.Link
	                    },
	                    _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: icon, size: '16px' }),
	                    useLocale ? title && _react2.default.createElement(_reactIntl.FormattedMessage, { id: title, defaultMessage: title }) : title,
	                    !hideArrow && _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconRight, icon: 'cheveron-down', size: '18px' })
	                ),
	                this.state.isOpened && _react2.default.createElement(
	                    'ul',
	                    { datatype: 'submenu', className: isFullWidth ? _stylesModule2.default.FullSubmenu : _stylesModule2.default.Submenu },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Dropdown;
	}(_react.Component);
	
	exports.default = Dropdown;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(110);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabBarNav = function TabBarNav(_ref) {
	    var navLabel = _ref.navLabel,
	        navLabelColor = _ref.navLabelColor,
	        navCount = _ref.navCount,
	        onChangeActiveTab = _ref.onChangeActiveTab,
	        isActive = _ref.isActive,
	        isVisible = _ref.isVisible;
	
	
	    var style = {
	        active: {},
	        hide: {}
	    };
	
	    if (isActive) {
	        style.active = {
	            color: "#333",
	            backgroundColor: "#fff",
	            borderColor: "#ddd #ddd #fff"
	        };
	    }
	
	    if (!isVisible) return null;
	
	    return _react2.default.createElement(
	        "button",
	        { style: style.active,
	            className: _stylesModule2.default.Tab,
	            "data-label": navLabel,
	            onClick: function onClick() {
	                onChangeActiveTab(navLabel);
	            } },
	        _react2.default.createElement(
	            "span",
	            { className: _stylesModule2.default.TabAmount },
	            navCount
	        ),
	        _react2.default.createElement(
	            "span",
	            { style: { color: navLabelColor } },
	            navLabel
	        )
	    );
	};
	
	// TabBarNav.PropTypes = {
	//     navLabel: PropTypes.string,
	//     onChangeActiveTab: PropTypes.func,
	//     isActive: PropTypes.bool
	// }
	
	// TabBarNav.defaultProps = {
	//     navLabel: 'Tab',
	//     onChangeActiveTab: () => {},
	// }
	
	// import PropTypes from "prop-types";
	exports.default = TabBarNav;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isEmpty(val) {
	
	    if (val !== undefined) {
	        if (!!val) return val;else return _react2.default.createElement(
	            "span",
	            null,
	            "\u2014"
	        );
	    } else {
	        return _react2.default.createElement(
	            "span",
	            null,
	            "\u2014"
	        );
	    }
	}
	
	exports.default = isEmpty;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(595);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchString(_ref) {
	    var placeholder = _ref.placeholder,
	        searchString = _ref.searchString,
	        isDisabled = _ref.isDisabled,
	        onChangeSearch = _ref.onChangeSearch;
	
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Card },
	        _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: placeholder },
	            function (placeholder) {
	                return _react2.default.createElement("input", { className: _stylesModule2.default.Input,
	                    type: "text",
	                    value: searchString,
	                    onChange: function onChange(e) {
	                        return onChangeSearch(e.target.value);
	                    },
	                    placeholder: placeholder,
	                    disabled: isDisabled
	                });
	            }
	        ),
	        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.Icon, color: '#999', icon: "search", size: '20px' })
	    );
	}
	
	exports.default = SearchString;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(598);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function Tags(_ref) {
	    var label = _ref.label,
	        placeholder = _ref.placeholder,
	        suggestions = _ref.suggestions,
	        onChange = _ref.onChange,
	        isDisabled = _ref.isDisabled;
	
	
	    var excludeColumns = ["id"];
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        tags = _useState2[0],
	        setTags = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        inputString = _useState4[0],
	        setInputString = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(suggestions),
	        _useState6 = _slicedToArray(_useState5, 2),
	        filteredSuggestions = _useState6[0],
	        setFilteredSuggestions = _useState6[1];
	
	    var search = function search(string, tags) {
	        var lowercasedValue = string.toLowerCase().trim();
	
	        var searchedData = [];
	        var result = [];
	
	        searchedData = suggestions.filter(function (item) {
	            return Object.keys(item).some(function (key) {
	                return excludeColumns.includes(key) ? false : item[key].toString().toLowerCase().includes(lowercasedValue);
	            });
	        });
	
	        result = searchedData.filter(function (el) {
	            return tags.filter(function (tag) {
	                return tag.id === el.id;
	            }).length === 0;
	        });
	
	        return result;
	    };
	
	    function handlerChangeString(val) {
	        setInputString(val);
	        setFilteredSuggestions(search(val, tags));
	    }
	
	    function handlerDelete(index, tag) {
	
	        var arrTags = tags.filter(function (_, i) {
	            return i !== index;
	        });
	
	        setTags(arrTags);
	        onChange(arrTags);
	
	        if (tag.hasOwnProperty("id")) setFilteredSuggestions([tag].concat(_toConsumableArray(filteredSuggestions)));
	    }
	
	    function handlerAddition(tag) {
	
	        if (typeof tag === "string") {
	
	            var lowercasedValue = tag.toLowerCase().trim();
	            var hasTag = filteredSuggestions.filter(function (tag) {
	                return tag.name.toLowerCase().trim() === lowercasedValue;
	            });
	
	            if (hasTag.length) {
	
	                var arrTags = [].concat(_toConsumableArray(tags), [hasTag[0]]);
	
	                setTags(arrTags);
	                onChange(arrTags);
	                setFilteredSuggestions(search(inputString, arrTags));
	            } else {
	
	                var _arrTags = [].concat(_toConsumableArray(tags), [{ name: tag }]);
	
	                setTags(_arrTags);
	                onChange(_arrTags);
	                setInputString("");
	            }
	        } else {
	
	            var _arrTags2 = [].concat(_toConsumableArray(tags), [tag]);
	
	            setTags(_arrTags2);
	            onChange(_arrTags2);
	            setFilteredSuggestions(search(inputString, _arrTags2));
	        }
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.Wrap },
	        _react2.default.createElement(
	            "label",
	            { className: _stylesModule2.default.Label },
	            label
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.TagsBox },
	            tags.map(function (tag, i) {
	                return _react2.default.createElement(
	                    "span",
	                    { key: i, className: _stylesModule2.default.Tag },
	                    tag.name,
	                    _react2.default.createElement(_Icon2.default, { onClick: function onClick() {
	                            return handlerDelete(i, tag);
	                        }, className: _stylesModule2.default.CloseIcon, icon: "close",
	                        size: '9px' })
	                );
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.InputWrap },
	            _react2.default.createElement("input", {
	                className: _stylesModule2.default.Input,
	                type: "text",
	                placeholder: placeholder,
	                value: inputString,
	                onChange: function onChange(e) {
	                    return handlerChangeString(e.target.value);
	                },
	                onKeyPress: function onKeyPress(e) {
	                    return e.key === "Enter" ? handlerAddition(e.target.value) : false;
	                },
	                disabled: isDisabled ? isDisabled : false
	            }),
	            isDisabled && _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.LockIcon, icon: "lock", size: "16px" }),
	            inputString.length > 2 && _react2.default.createElement(
	                "button",
	                { onClick: function onClick() {
	                        return handlerAddition(inputString);
	                    }, className: _stylesModule2.default.Button },
	                "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"
	            ),
	            inputString.length > 2 && Boolean(filteredSuggestions.length) && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Suggestions },
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    filteredSuggestions.map(function (el, i) {
	                        return _react2.default.createElement(
	                            "li",
	                            { onClick: function onClick() {
	                                    return handlerAddition(el);
	                                }, key: i },
	                            el.name
	                        );
	                    })
	                )
	            )
	        )
	    );
	}
	
	exports.default = Tags;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(600);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var StatusCheckbox = function StatusCheckbox(_ref) {
	    var category = _ref.category,
	        name = _ref.name,
	        count = _ref.count,
	        _onChange2 = _ref.onChange,
	        isDisabled = _ref.isDisabled,
	        isSelected = _ref.isSelected;
	
	    var _useState = (0, _react.useState)(!!isSelected),
	        _useState2 = _slicedToArray(_useState, 2),
	        checked = _useState2[0],
	        setChecked = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        setChecked(!!isSelected);
	    }, [isSelected]);
	
	    // Уникальный id
	    var inputId = category + "_" + name;
	
	    var color = void 0;
	    var title = _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionsFilters.label." + name, defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442" });
	
	    switch (name) {
	        case "successfulP2P":
	            color = "#1abc9c";
	            break;
	        case "successfulSbp":
	            color = "#16a085";
	            break;
	        case "sbp":
	            color = "#27ae60";
	            break;
	        case "mP2P":
	            color = "#2ecc71";
	            break;
	
	        case "payoutPending":
	            color = "#3b1a1a";
	            break;
	        case "purchasePending":
	            color = "#498183";
	            break;
	        case "threeDSPending":
	            color = "#581b1b";
	            break;
	        case "refundPending":
	            color = "#82afef";
	            break;
	        case "reversalPending":
	            color = "#02ecab";
	            break;
	        case "recurrentPending":
	            color = "#638b1a";
	            break;
	        case "mP2PPending":
	            color = "#6b4c3e";
	            break;
	        case "sbpPending":
	            color = "#2a6b6b";
	            break;
	
	        case "payoutCreated":
	            color = "#5de6f8";
	            break;
	        case "refundCreated":
	            color = "#0468f5";
	            break;
	        case "reversalCreated":
	            color = "#058b66";
	            break;
	        case "recurrentCreated":
	            color = "#3b5702";
	            break;
	        case "purchaseCreated":
	            color = "#5977b3";
	            break;
	        case "mP2PCreated":
	            color = "#8fa0d4";
	            break;
	        case "sbpCreated":
	            color = "#6ab7c8";
	            break;
	
	        case "payoutDecline":
	            color = "#DC3912";
	            break;
	        case "refundDecline":
	            color = "#782ad4";
	            break;
	        case "reversalDecline":
	            color = "#a9218e";
	            break;
	        case "recurrentDecline":
	            color = "#c35624";
	            break;
	        case "purchaseDecline":
	            color = "#a1c324";
	            break;
	        case "mP2PDecline":
	            color = "#d4385b";
	            break;
	        case "sbpDecline":
	            color = "#e67e22";
	            break;
	
	        case "qr":
	            color = "#9b59b6";
	            break;
	        case "qrCreated":
	            color = "#8e44ad";
	            break;
	        case "qrPending":
	            color = "#6c3483";
	            break;
	        case "qrDecline":
	            color = "#c0392b";
	            break;
	
	        case "mobilePayout":
	            color = "#e74c3c";
	            break;
	        case "mobilePayoutCreated":
	            color = "#c0392b";
	            break;
	        case "mobilePayoutPending":
	            color = "#922b21";
	            break;
	        case "mobilePayoutDecline":
	            color = "#641e16";
	            break;
	
	        case "purchase":
	            color = "#3366CC";
	            break;
	        case "recurrent":
	            color = "#a0e720";
	            break;
	        case "reversal":
	            color = "#1eba8e";
	            break;
	        case "refund":
	            color = "#518cea";
	            break;
	        case "payout":
	            color = "#109618";
	            break;
	
	        case "chargeback":
	            color = "#644f0b";
	            break;
	        case "created":
	            color = "#3a828c";
	            break;
	
	        default:
	            color = "#d4d4d4";
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { key: inputId, className: _stylesModule2.default.Wrap },
	        _react2.default.createElement("input", {
	            id: inputId,
	            type: "checkbox",
	            onChange: function onChange(e) {
	                _onChange2(_defineProperty({}, name, e.target.checked));
	                setChecked(e.target.checked);
	            },
	            disabled: isDisabled,
	            checked: checked
	        }),
	        _react2.default.createElement(
	            "label",
	            { htmlFor: inputId, className: _stylesModule2.default.Checkbox },
	            _react2.default.createElement("div", { style: { backgroundColor: color }, className: _stylesModule2.default.Icon }),
	            _react2.default.createElement(
	                "span",
	                null,
	                title
	            )
	        )
	    );
	};
	
	exports.default = StatusCheckbox;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Layout = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(2);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _AdminFiltersToggle = __webpack_require__(42);
	
	var _AdminFiltersToggle2 = _interopRequireDefault(_AdminFiltersToggle);
	
	var _AccountsList = __webpack_require__(350);
	
	var _AccountsList2 = _interopRequireDefault(_AccountsList);
	
	var _AccountsFilters = __webpack_require__(346);
	
	var _AccountsFilters2 = _interopRequireDefault(_AccountsFilters);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _AccountEditing = __webpack_require__(345);
	
	var _AccountEditing2 = _interopRequireDefault(_AccountEditing);
	
	var _AccountAdd = __webpack_require__(343);
	
	var _AccountAdd2 = _interopRequireDefault(_AccountAdd);
	
	var _SearchTags = __webpack_require__(38);
	
	var _SearchTags2 = _interopRequireDefault(_SearchTags);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _stylesModule = __webpack_require__(602);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _stylesModule3 = __webpack_require__(44);
	
	var _stylesModule4 = _interopRequireDefault(_stylesModule3);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Accounts = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpenModal = _useState2[0],
	        setIsOpenModal = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isFiltersOpen = _useState4[0],
	        setIsFiltersOpen = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(1),
	        _useState6 = _slicedToArray(_useState5, 2),
	        currentAccountsPage = _useState6[0],
	        setCurrentAccountsPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(10),
	        _useState8 = _slicedToArray(_useState7, 2),
	        postsPerAccountsPage = _useState8[0],
	        setPostsPerAccountsPage = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(10),
	        _useState10 = _slicedToArray(_useState9, 2),
	        accountsListCount = _useState10[0],
	        setAccountsListCount = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        currentAccountId = _useState12[0],
	        setCurrentAccountId = _useState12[1];
	
	    var _useState13 = (0, _react.useState)('DESC'),
	        _useState14 = _slicedToArray(_useState13, 1),
	        accountsSort = _useState14[0];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        filterDate = _useState16[0],
	        setFilterDate = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        filters = _useState18[0],
	        setFilters = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        filtersTags = _useState20[0],
	        setFiltersTags = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        accountsList = _useState22[0],
	        setAccountsList = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        accountInfo = _useState24[0],
	        setAccountInfo = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        loadingAccountInfo = _useState26[0],
	        setLoadingAccountInfo = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(true),
	        _useState28 = _slicedToArray(_useState27, 2),
	        loadingAccountsList = _useState28[0],
	        setLoadingAccountsList = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(null),
	        _useState30 = _slicedToArray(_useState29, 2),
	        projects = _useState30[0],
	        setProjects = _useState30[1];
	
	    var location = (0, _reactRouterDom.useLocation)();
	
	    (0, _react.useEffect)(function () {
	        var params = new URLSearchParams(location.search);
	        var tid = params.get('account');
	        if (!tid) return;
	        var id = parseInt(tid, 10);
	        if (!id) return;
	        setCurrentAccountId(id);
	        setLoadingAccountInfo(true);
	        new _Api2.default({ token: token }).getAccountData(id).then(function (r) {
	            return setAccountInfo(r);
	        }).finally(function () {
	            return setLoadingAccountInfo(false);
	        });
	    }, [location.search, token]);
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjectsList({ page: 1, itemsPerPage: 10000, order: 'DESC' }).then(function (r) {
	            setProjects(r.data);
	        });
	
	        new _Api2.default({ token: token }).getAccountsList({ itemsPerPage: postsPerAccountsPage, page: currentAccountsPage, order: accountsSort }).then(function (r) {
	            setAccountsList(r.data);
	            setAccountsListCount(r.count);
	            setLoadingAccountsList(false);
	        });
	    }, []);
	
	    function setPage(page, itemsPerPage) {
	        if (page) setCurrentAccountsPage(page);else setCurrentAccountsPage(1);
	
	        if (itemsPerPage) setPostsPerAccountsPage(itemsPerPage);
	
	        var accountsFilters = {
	            dateRange: filterDate,
	            filters: filters,
	            order: accountsSort,
	            page: page,
	            itemsPerPage: itemsPerPage
	        };
	
	        new _Api2.default({ token: token }).getAccountsList(accountsFilters).then(function (r) {
	            setAccountsList(r.data);
	        });
	    }
	
	    function onSelectAccountId(id) {
	        setCurrentAccountId(id);
	        setLoadingAccountInfo(true);
	
	        new _Api2.default({ token: token }).getAccountData(id).then(function (r) {
	            setAccountInfo(r);
	        }).finally(function () {
	            setLoadingAccountInfo(false);
	        });
	    }
	
	    function onToggleModal() {
	        setIsOpenModal(!isOpenModal);
	    }
	
	    function selectFilter(filter) {
	        var key = Object.keys(filter)[0];
	        var value = Object.values(filter)[0];
	
	        if (value) {
	            setFilters([].concat(_toConsumableArray(filters), [filter]));
	        } else {
	            filters.map(function (el, index) {
	                if (Object.keys(el)[0] === key) {
	                    filters.splice(index, 1);
	                    setFilters(filters);
	                }
	                return true;
	            });
	        }
	    }
	
	    function applyFilters() {
	        setLoadingAccountsList(true);
	        setCurrentAccountsPage(1);
	        setIsFiltersOpen(false);
	
	        var searchFilters = {};
	        filtersTags.forEach(function (tag) {
	            var key = Object.keys(tag)[0];
	            var value = Object.values(tag)[0];
	            searchFilters[key] = value;
	        });
	
	        if (Object.keys(searchFilters).length > 0) {
	            new _Api2.default({ token: token }).makeAccountSearch(searchFilters).then(function (r) {
	                setAccountsList(r);
	                setAccountsListCount(r.length);
	                setLoadingAccountsList(false);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                setAccountsList([]);
	                setAccountsListCount(0);
	                setLoadingAccountsList(false);
	            });
	        } else {
	            var accountsFilters = {
	                dateRange: filterDate,
	                filters: filters,
	                order: accountsSort,
	                page: 1,
	                itemsPerPage: postsPerAccountsPage
	            };
	
	            new _Api2.default({ token: token }).getAccountsList(accountsFilters).then(function (r) {
	                setAccountsList(r.data);
	                setAccountsListCount(r.count);
	                setLoadingAccountsList(false);
	            });
	        }
	    }
	
	    function onAccountAdd() {
	        setCurrentAccountsPage(1);
	
	        new _Api2.default({ token: token }).getAccountsList({ itemsPerPage: postsPerAccountsPage, page: currentAccountsPage, order: accountsSort }).then(function (r) {
	            setAccountsList(r.data);
	            setAccountsListCount(r.count);
	        });
	    }
	
	    function onChangeAccountData(data, id) {
	        setAccountsList(accountsList.map(function (el) {
	            if (el.id === id) {
	                el.firstName = data.firstName;
	                el.lastName = data.lastName;
	                el.patronymic = data.patronymic;
	                el.status = data.status;
	            }
	            return el;
	        }));
	    }
	
	    function onModalClose() {
	        setIsOpenModal(false);
	    }
	
	    function onChangeSearch(tags) {
	        setFiltersTags(tags);
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Accounts.modal.addTitle', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C' }),
	                isOpen: isOpenModal,
	                onClose: onModalClose
	            },
	            _react2.default.createElement(_AccountAdd2.default, { token: token, onAccountAdd: onAccountAdd })
	        ),
	        _react2.default.createElement(
	            _Context2.default.Provider,
	            { value: { onSelectAccountId: onSelectAccountId } },
	            _react2.default.createElement(
	                _Layout.Container,
	                null,
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: '780', className: _stylesModule4.default.MainColumn },
	                    _react2.default.createElement(_AdminFiltersToggle2.default, { onClick: function onClick() {
	                            return setIsFiltersOpen(true);
	                        } }),
	                    _react2.default.createElement(_SearchTags2.default, {
	                        onChangeSearch: onChangeSearch,
	                        onSearch: applyFilters,
	                        isDisabled: false,
	                        defaultSearch: {
	                            key: 'accountId',
	                            locale: 'Search.label.accountId',
	                            placeholder: 'Search.placeholder.accountId'
	                        },
	                        searchBy: [{
	                            key: 'accountId',
	                            locale: 'Search.label.accountId',
	                            placeholder: 'Search.placeholder.accountId'
	                        }, { key: 'email', locale: 'Search.label.email', placeholder: 'Search.placeholder.email' }, { key: 'fio', locale: 'Search.label.fio', placeholder: 'Search.placeholder.fio' }, {
	                            key: 'username',
	                            locale: 'Search.label.username',
	                            placeholder: 'Search.placeholder.username'
	                        }]
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Card },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Header },
	                            _react2.default.createElement(
	                                'h5',
	                                { className: _stylesModule2.default.Title },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: 'Accounts.title.accountsList',
	                                    defaultMessage: '\u0423\u0447\u0435\u0442\u043D\u044B\u0435 \u0437\u0430\u043F\u0438\u0441\u0438'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.Btn, onClick: onToggleModal },
	                                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: 'user-plus', size: '16px' }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Accounts.button.add', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C' })
	                            )
	                        ),
	                        _react2.default.createElement(_AccountsList2.default, {
	                            isLoading: loadingAccountsList,
	                            data: accountsList,
	                            currentId: currentAccountId
	                        }),
	                        postsPerAccountsPage < accountsListCount && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Pagination },
	                            _react2.default.createElement(_reactJsPagination2.default, {
	                                firstPageText: '\u21E4',
	                                prevPageText: '\u21E0',
	                                lastPageText: '\u21E5',
	                                nextPageText: '\u21E2',
	                                activeLinkClass: _stylesModule2.default.ActiveLink,
	                                activePage: currentAccountsPage,
	                                itemsCountPerPage: postsPerAccountsPage,
	                                totalItemsCount: accountsListCount,
	                                pageRangeDisplayed: 5,
	                                onChange: function onChange(page) {
	                                    return setPage(page, postsPerAccountsPage);
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(_AccountEditing2.default, {
	                        data: accountInfo,
	                        token: token,
	                        onChangeAccountData: onChangeAccountData,
	                        projectsList: projects,
	                        isDataLoading: loadingAccountInfo
	                    })
	                ),
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: '350', className: _stylesModule4.default.SidebarColumn },
	                    _react2.default.createElement(
	                        _ResponsiveSidebarFilters2.default,
	                        {
	                            title: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B',
	                            isOpen: isFiltersOpen,
	                            onClose: function onClose() {
	                                return setIsFiltersOpen(false);
	                            },
	                            onApplyFilters: applyFilters,
	                            isApplyDisabled: loadingAccountsList
	                        },
	                        _react2.default.createElement(
	                            _EmptyCard2.default,
	                            null,
	                            _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                                    return setFilterDate(range);
	                                }, defaultPeriod: 'zero' })
	                        ),
	                        _react2.default.createElement(_AccountsFilters2.default, {
	                            isLoading: loadingAccountsList,
	                            onSelectFilter: selectFilter,
	                            onApplyFilters: applyFilters
	                        })
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = Accounts;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _AuditLogsList = __webpack_require__(357);
	
	var _AuditLogsList2 = _interopRequireDefault(_AuditLogsList);
	
	var _AuditLogsFilters = __webpack_require__(356);
	
	var _AuditLogsFilters2 = _interopRequireDefault(_AuditLogsFilters);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _AdminFiltersToggle = __webpack_require__(42);
	
	var _AdminFiltersToggle2 = _interopRequireDefault(_AdminFiltersToggle);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _stylesModule = __webpack_require__(603);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminAudit = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        logs = _useState2[0],
	        setLogs = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(0),
	        _useState4 = _slicedToArray(_useState3, 2),
	        totalCount = _useState4[0],
	        setTotalCount = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(1),
	        _useState6 = _slicedToArray(_useState5, 2),
	        currentPage = _useState6[0],
	        setCurrentPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(25),
	        _useState8 = _slicedToArray(_useState7, 1),
	        itemsPerPage = _useState8[0];
	
	    var _useState9 = (0, _react.useState)(true),
	        _useState10 = _slicedToArray(_useState9, 2),
	        isLoading = _useState10[0],
	        setIsLoading = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isFiltersOpen = _useState12[0],
	        setIsFiltersOpen = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({
	        actorId: null,
	        action: null,
	        entityType: null,
	        startDate: null,
	        endDate: null,
	        search: null
	    }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        filters = _useState14[0],
	        setFilters = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        actions = _useState16[0],
	        setActions = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        entityTypes = _useState18[0],
	        setEntityTypes = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        admins = _useState20[0],
	        setAdmins = _useState20[1];
	
	    (0, _react.useEffect)(function () {
	        var api = new _Api2.default({ token: token });
	
	        api.getAuditActions().then(function (data) {
	            setActions(data && data.actions ? data.actions : []);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setActions([]);
	        });
	
	        api.getAuditEntityTypes().then(function (data) {
	            setEntityTypes(data && data.entityTypes ? data.entityTypes : []);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setEntityTypes([]);
	        });
	
	        api.getAccountsList({ itemsPerPage: 1000, page: 1, filters: [] }).then(function (r) {
	            var all = Array.isArray(r) ? r : r && r.data ? r.data : [];
	            setAdmins(all.filter(function (a) {
	                return a.privileges && a.privileges > 0;
	            }));
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setAdmins([]);
	        });
	    }, [token]);
	
	    (0, _react.useEffect)(function () {
	        loadLogs();
	    }, [currentPage, filters]);
	
	    function loadLogs() {
	        setIsLoading(true);
	
	        var api = new _Api2.default({ token: token });
	        var params = {
	            page: currentPage,
	            itemsPerPage: itemsPerPage,
	            actorId: filters.actorId || undefined,
	            action: filters.action || undefined,
	            entityType: filters.entityType || undefined,
	            search: filters.search || undefined
	        };
	
	        if (filters.startDate || filters.endDate) {
	            params.dateRange = {};
	            if (filters.startDate) params.dateRange.startDate = filters.startDate;
	            if (filters.endDate) params.dateRange.endDate = filters.endDate;
	        }
	
	        Object.keys(params).forEach(function (key) {
	            if (params[key] === null || params[key] === '' || params[key] === undefined) {
	                delete params[key];
	            }
	        });
	
	        api.getAuditLogs(params).then(function (data) {
	            setLogs(data.data || []);
	            setTotalCount(data.count || 0);
	            setIsLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            console.error('Failed to load audit logs:', err);
	            setLogs([]);
	            setTotalCount(0);
	            setIsLoading(false);
	        });
	    }
	
	    function handleApplyFilters(newFilters) {
	        setFilters(newFilters);
	        setCurrentPage(1);
	    }
	
	    function handlePageChange(page) {
	        setCurrentPage(page);
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 'full' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.PageHeader },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: _stylesModule2.default.PageTitle },
	                        '\u0416\u0443\u0440\u043D\u0430\u043B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u0432'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _stylesModule2.default.PageSubtitle },
	                        '\u0412\u0441\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0444\u0438\u043A\u0441\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.MobileFiltersToggle },
	                    _react2.default.createElement(_AdminFiltersToggle2.default, { onClick: function onClick() {
	                            return setIsFiltersOpen(true);
	                        } })
	                ),
	                _react2.default.createElement(
	                    _ResponsiveSidebarFilters2.default,
	                    {
	                        title: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B',
	                        isOpen: isFiltersOpen,
	                        onClose: function onClose() {
	                            return setIsFiltersOpen(false);
	                        }
	                    },
	                    _react2.default.createElement(_AuditLogsFilters2.default, {
	                        actions: actions,
	                        entityTypes: entityTypes,
	                        admins: admins,
	                        onApplyFilters: function onApplyFilters(newFilters) {
	                            handleApplyFilters(newFilters);
	                            setIsFiltersOpen(false);
	                        },
	                        isLoading: isLoading
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(_AuditLogsList2.default, { logs: logs, isLoading: isLoading }),
	                    totalCount > itemsPerPage && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.PaginationWrap },
	                        _react2.default.createElement(_reactJsPagination2.default, {
	                            activePage: currentPage,
	                            itemsCountPerPage: itemsPerPage,
	                            totalItemsCount: totalCount,
	                            pageRangeDisplayed: 5,
	                            onChange: handlePageChange,
	                            itemClass: _stylesModule2.default.PaginationItem,
	                            linkClass: _stylesModule2.default.PaginationLink,
	                            activeClass: _stylesModule2.default.PaginationActive
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Summary },
	                    '\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E ',
	                    logs.length,
	                    ' \u0438\u0437 ',
	                    totalCount,
	                    ' \u0437\u0430\u043F\u0438\u0441\u0435\u0439'
	                )
	            )
	        )
	    );
	});
	
	exports.default = AdminAudit;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _AdminFiltersToggle = __webpack_require__(42);
	
	var _AdminFiltersToggle2 = _interopRequireDefault(_AdminFiltersToggle);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _SearchTags = __webpack_require__(38);
	
	var _SearchTags2 = _interopRequireDefault(_SearchTags);
	
	var _AntiFraudList = __webpack_require__(355);
	
	var _AntiFraudList2 = _interopRequireDefault(_AntiFraudList);
	
	var _AntiFraudFilters = __webpack_require__(352);
	
	var _AntiFraudFilters2 = _interopRequireDefault(_AntiFraudFilters);
	
	var _AntiFraudForm = __webpack_require__(353);
	
	var _AntiFraudForm2 = _interopRequireDefault(_AntiFraudForm);
	
	var _AntiFraudDetails = __webpack_require__(351);
	
	var _AntiFraudDetails2 = _interopRequireDefault(_AntiFraudDetails);
	
	var _stylesModule = __webpack_require__(604);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _stylesModule3 = __webpack_require__(44);
	
	var _stylesModule4 = _interopRequireDefault(_stylesModule3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MODE_RECORDS = 'records';
	var MODE_LOGS = 'logs';
	
	var AntiFraudPage = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(MODE_RECORDS),
	        _useState2 = _slicedToArray(_useState, 2),
	        mode = _useState2[0],
	        setMode = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isOpenModal = _useState4[0],
	        setIsOpenModal = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(1),
	        _useState6 = _slicedToArray(_useState5, 2),
	        currentPage = _useState6[0],
	        setCurrentPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(20),
	        _useState8 = _slicedToArray(_useState7, 2),
	        perPage = _useState8[0],
	        setPerPage = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(0),
	        _useState10 = _slicedToArray(_useState9, 2),
	        totalCount = _useState10[0],
	        setTotalCount = _useState10[1];
	
	    var _useState11 = (0, _react.useState)([]),
	        _useState12 = _slicedToArray(_useState11, 2),
	        list = _useState12[0],
	        setList = _useState12[1];
	
	    var _useState13 = (0, _react.useState)([]),
	        _useState14 = _slicedToArray(_useState13, 2),
	        logs = _useState14[0],
	        setLogs = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(null),
	        _useState16 = _slicedToArray(_useState15, 2),
	        selected = _useState16[0],
	        setSelected = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(null),
	        _useState18 = _slicedToArray(_useState17, 2),
	        stats = _useState18[0],
	        setStats = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({ sources: [], kinds: [] }),
	        _useState20 = _slicedToArray(_useState19, 2),
	        reference = _useState20[0],
	        setReference = _useState20[1];
	
	    var _useState21 = (0, _react.useState)('DESC'),
	        _useState22 = _slicedToArray(_useState21, 1),
	        sort = _useState22[0];
	
	    var _useState23 = (0, _react.useState)({}),
	        _useState24 = _slicedToArray(_useState23, 2),
	        filterDate = _useState24[0],
	        setFilterDate = _useState24[1];
	
	    var _useState25 = (0, _react.useState)([]),
	        _useState26 = _slicedToArray(_useState25, 2),
	        filters = _useState26[0],
	        setFilters = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(true),
	        _useState28 = _slicedToArray(_useState27, 2),
	        loading = _useState28[0],
	        setLoading = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(false),
	        _useState30 = _slicedToArray(_useState29, 2),
	        isFiltersOpen = _useState30[0],
	        setIsFiltersOpen = _useState30[1];
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getAntiFraudReference().then(function (r) {
	            setReference(r || { sources: [], kinds: [] });
	        });
	    }, [token]);
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getAntiFraudStats().then(function (r) {
	            setStats(r.data || null);
	        });
	    }, [token]);
	
	    (0, _react.useEffect)(function () {
	        var payload = {
	            page: currentPage,
	            itemsPerPage: perPage,
	            order: sort,
	            dateRange: filterDate
	        };
	
	        if (mode === MODE_RECORDS) {
	            var sources = [];
	            var kinds = [];
	
	            filters.forEach(function (f) {
	                if (f.key === 'source') sources.push(f.value);else if (f.key === 'kind') kinds.push(f.value);else if (f.key === 'search') payload.search = f.value;else if (f.key === 'isBlocked') payload.isBlocked = f.value === 'true';
	            });
	
	            if (sources.length > 0) payload.source = sources;
	            if (kinds.length > 0) payload.kind = kinds;
	
	            setLoading(true);
	            new _Api2.default({ token: token }).getAntiFraudRecords(payload).then(function (r) {
	                setList(Array.isArray(r.data) ? r.data : []);
	                setTotalCount(typeof r.count === 'number' ? r.count : 0);
	                setLoading(false);
	            });
	        } else {
	            filters.forEach(function (f) {
	                if (f.key === 'result') payload.result = f.value;
	            });
	
	            setLoading(true);
	            new _Api2.default({ token: token }).getAntiFraudLogs(payload).then(function (r) {
	                setLogs(Array.isArray(r.data) ? r.data : []);
	                setTotalCount(typeof r.count === 'number' ? r.count : 0);
	                setLoading(false);
	            });
	        }
	    }, [mode, filters, filterDate, currentPage, perPage, sort, token]);
	
	    function setPage(page, itemsPerPage) {
	        setCurrentPage(page || 1);
	        if (itemsPerPage) setPerPage(itemsPerPage);
	    }
	
	    function onChangeSearch(tags) {
	        setFilters(tags);
	    }
	
	    function onAdded() {
	        setCurrentPage(1);
	        setIsOpenModal(false);
	        setFilters([].concat(_toConsumableArray(filters)));
	    }
	
	    function onSelectRecord(row) {
	        setSelected(row || null);
	    }
	
	    function handleUnblock(id) {
	        new _Api2.default({ token: token }).unblockAntiFraudRecord(id).then(function () {
	            setFilters([].concat(_toConsumableArray(filters)));
	            setSelected(null);
	        });
	    }
	
	    function handleDelete(id) {
	        if (window.confirm('Удалить запись?')) {
	            new _Api2.default({ token: token }).deleteAntiFraudRecord(id).then(function () {
	                setFilters([].concat(_toConsumableArray(filters)));
	                setSelected(null);
	            });
	        }
	    }
	
	    function switchMode(newMode) {
	        if (newMode === mode) return;
	        setMode(newMode);
	        setCurrentPage(1);
	        setSelected(null);
	        setFilters([]);
	    }
	
	    function formatDate(iso) {
	        if (!iso) return '—';
	        var d = new Date(iso);
	        if (Number.isNaN(d.getTime())) return iso;
	        return d.toLocaleString('ru-RU');
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraud.modal.addTitle', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443' }),
	                onToggleModal: function onToggleModal() {
	                    return setIsOpenModal(!isOpenModal);
	                },
	                isOpen: isOpenModal,
	                onClose: function onClose() {
	                    return setIsOpenModal(false);
	                }
	            },
	            _react2.default.createElement(_AntiFraudForm2.default, { token: token, reference: reference, onAdded: onAdded })
	        ),
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '780', className: _stylesModule4.default.MainColumn },
	                _react2.default.createElement(_AdminFiltersToggle2.default, { onClick: function onClick() {
	                        return setIsFiltersOpen(true);
	                    } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Tabs },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: _stylesModule2.default.Tab + ' ' + (mode === MODE_RECORDS ? _stylesModule2.default.TabActive : ''),
	                            onClick: function onClick() {
	                                return switchMode(MODE_RECORDS);
	                            }
	                        },
	                        '\u0427\u0451\u0440\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: _stylesModule2.default.Tab + ' ' + (mode === MODE_LOGS ? _stylesModule2.default.TabActive : ''),
	                            onClick: function onClick() {
	                                return switchMode(MODE_LOGS);
	                            }
	                        },
	                        '\u0416\u0443\u0440\u043D\u0430\u043B \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u043A'
	                    )
	                ),
	                mode === MODE_RECORDS && _react2.default.createElement(_SearchTags2.default, {
	                    onChangeSearch: onChangeSearch,
	                    onSearch: function onSearch() {
	                        setFilters(function (prev) {
	                            return [].concat(_toConsumableArray(prev));
	                        });
	                        setCurrentPage(1);
	                    },
	                    isDisabled: false,
	                    defaultSearch: {
	                        key: 'search',
	                        locale: 'AntiFraud.search.mask',
	                        placeholder: 'AntiFraud.search.maskPlaceholder'
	                    },
	                    searchBy: [{
	                        key: 'search',
	                        locale: 'AntiFraud.search.mask',
	                        placeholder: 'AntiFraud.search.maskPlaceholder'
	                    }]
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            'h5',
	                            { className: _stylesModule2.default.Title },
	                            mode === MODE_RECORDS ? _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraud.title', defaultMessage: '\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434 \u0437\u0430\u043F\u0438\u0441\u0438' }),
	                                stats && _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.StatsInfo },
	                                    '(',
	                                    stats.totalBlocked || 0,
	                                    ' \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E)'
	                                )
	                            ) : _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                '\u0416\u0443\u0440\u043D\u0430\u043B \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u043A',
	                                stats && stats.checksLast24h && _react2.default.createElement(
	                                    'span',
	                                    { className: _stylesModule2.default.StatsInfo },
	                                    '(\u0437\u0430 24\u0447: ',
	                                    stats.checksLast24h.total || 0,
	                                    ' \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u043A,',
	                                    ' ',
	                                    stats.checksLast24h.blocked || 0,
	                                    ' \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E)'
	                                )
	                            )
	                        ),
	                        mode === MODE_RECORDS && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Btn, onClick: function onClick() {
	                                    return setIsOpenModal(!isOpenModal);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: 'add-outline', size: '16px' }),
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraud.add', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C' })
	                        )
	                    ),
	                    mode === MODE_RECORDS ? _react2.default.createElement(_AntiFraudList2.default, {
	                        isLoading: loading,
	                        data: list,
	                        currentId: selected ? selected.id : null,
	                        onSelect: onSelectRecord,
	                        reference: reference
	                    }) : _react2.default.createElement(LogsTable, { loading: loading, logs: logs, formatDate: formatDate }),
	                    perPage < totalCount && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.PaginationWrap },
	                        _react2.default.createElement(_reactJsPagination2.default, {
	                            firstPageText: '\u21E4',
	                            prevPageText: '\u21E0',
	                            lastPageText: '\u21E5',
	                            nextPageText: '\u21E2',
	                            activeLinkClass: _stylesModule2.default.ActiveLink,
	                            activePage: currentPage,
	                            itemsCountPerPage: perPage,
	                            totalItemsCount: totalCount,
	                            pageRangeDisplayed: 5,
	                            onChange: function onChange(page) {
	                                return setPage(page, perPage);
	                            }
	                        })
	                    )
	                ),
	                mode === MODE_RECORDS && selected && _react2.default.createElement(_AntiFraudDetails2.default, {
	                    record: selected,
	                    reference: reference,
	                    onUnblock: handleUnblock,
	                    onDelete: handleDelete
	                })
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '350', className: _stylesModule4.default.SidebarColumn },
	                _react2.default.createElement(
	                    _ResponsiveSidebarFilters2.default,
	                    {
	                        title: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B',
	                        isOpen: isFiltersOpen,
	                        onClose: function onClose() {
	                            return setIsFiltersOpen(false);
	                        }
	                    },
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_DateRange2.default, {
	                            onSelectDate: function onSelectDate(range) {
	                                setFilterDate(range || {});
	                                setCurrentPage(1);
	                            },
	                            defaultPeriod: 'zero'
	                        })
	                    ),
	                    mode === MODE_RECORDS && _react2.default.createElement(_AntiFraudFilters2.default, {
	                        isLoading: loading,
	                        reference: reference,
	                        onApplyFilters: function onApplyFilters(newFilters) {
	                            setFilters(newFilters || []);
	                            setCurrentPage(1);
	                            setIsFiltersOpen(false);
	                        }
	                    }),
	                    mode === MODE_LOGS && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.StatsCard },
	                        _react2.default.createElement(
	                            'h6',
	                            { className: _stylesModule2.default.StatsTitle },
	                            '\u0424\u0438\u043B\u044C\u0442\u0440 \u043F\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0443'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.LogsFilterButtons },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.LogsFilterBtn + ' ' + (filters.find(function (f) {
	                                        return f.key === 'result';
	                                    }) ? '' : _stylesModule2.default.LogsFilterBtnActive),
	                                    onClick: function onClick() {
	                                        setFilters([]);
	                                        setCurrentPage(1);
	                                    }
	                                },
	                                '\u0412\u0441\u0435'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.LogsFilterBtn + ' ' + (filters.some(function (f) {
	                                        return f.key === 'result' && f.value === 'ok';
	                                    }) ? _stylesModule2.default.LogsFilterBtnActive : ''),
	                                    onClick: function onClick() {
	                                        setFilters([{ key: 'result', value: 'ok' }]);
	                                        setCurrentPage(1);
	                                    }
	                                },
	                                '\u0422\u043E\u043B\u044C\u043A\u043E OK'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: _stylesModule2.default.LogsFilterBtn + ' ' + (filters.some(function (f) {
	                                        return f.key === 'result' && f.value === 'blocked';
	                                    }) ? _stylesModule2.default.LogsFilterBtnActive : ''),
	                                    onClick: function onClick() {
	                                        setFilters([{ key: 'result', value: 'blocked' }]);
	                                        setCurrentPage(1);
	                                    }
	                                },
	                                '\u0422\u043E\u043B\u044C\u043A\u043E \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435'
	                            )
	                        )
	                    ),
	                    stats && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.StatsCard },
	                        _react2.default.createElement(
	                            'h6',
	                            { className: _stylesModule2.default.StatsTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AntiFraud.stats.title', defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.StatsList },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0412\u0441\u0435\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0435\u0439:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    stats.total || 0
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    stats.totalBlocked || 0
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u041F\u0440\u043E\u0432\u0435\u0440\u043E\u043A \u0437\u0430 24\u0447:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    stats.checksLast24h && stats.checksLast24h.total || 0
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0411\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043E\u043A \u0437\u0430 24\u0447:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    stats.checksLast24h && stats.checksLast24h.blocked || 0
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	function LogsTable(_ref2) {
	    var loading = _ref2.loading,
	        logs = _ref2.logs,
	        formatDate = _ref2.formatDate;
	
	    if (loading) {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.LogsEmpty },
	            '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...'
	        );
	    }
	    if (!logs || logs.length === 0) {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.LogsEmpty },
	            '\u041D\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u043A \u0437\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434'
	        );
	    }
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TableScroll },
	            _react2.default.createElement(
	                'table',
	                { className: _stylesModule2.default.LogsTable },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u0414\u0430\u0442\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u0422\u0438\u043F'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Tx'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u041F\u0440\u0438\u0447\u0438\u043D\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u0412\u0440\u0435\u043C\u044F (\u043C\u0441)'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    logs.map(function (log) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: log.id },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                formatDate(log.createdAt)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                log.checkType || '—'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    {
	                                        className: log.result === 'blocked' ? _stylesModule2.default.ResultBlocked : log.result === 'ok' ? _stylesModule2.default.ResultOk : _stylesModule2.default.ResultOther
	                                    },
	                                    log.result || '—'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                log.transactionId || '—'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { title: log.blockedReason || '' },
	                                log.blockedReason ? ((log.blockedBy || '') + ': ' + log.blockedReason).slice(0, 80) : '—'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                log.totalTimeMs != null ? log.totalTimeMs : '—'
	                            )
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.LogsMobileList },
	            logs.map(function (log) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: log.id, className: _stylesModule2.default.LogsMobileCard },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.LogsMobileRow },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.LogsMobilePrimary },
	                            formatDate(log.createdAt)
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            {
	                                className: log.result === 'blocked' ? _stylesModule2.default.ResultBlocked : log.result === 'ok' ? _stylesModule2.default.ResultOk : _stylesModule2.default.ResultOther
	                            },
	                            log.result || '—'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.LogsMobileRow },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.LogsMobileSecondary },
	                            log.checkType || '—'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.LogsMobileMuted },
	                            log.totalTimeMs != null ? log.totalTimeMs + ' \u043C\u0441' : '—'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.LogsMobileValue },
	                        log.transactionId || '—'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.LogsMobileReason },
	                        log.blockedReason ? (log.blockedBy || '') + ': ' + log.blockedReason : '—'
	                    )
	                );
	            })
	        )
	    );
	}
	
	exports.default = AntiFraudPage;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _Layout = __webpack_require__(6);
	
	var _stylesModule = __webpack_require__(605);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STUCK_MINUTES = 30;
	
	var isCreatedType = function isCreatedType(t) {
	    return t === "created" || /Created$/i.test(t);
	};
	var isPendingType = function isPendingType(t) {
	    return (/Pending$/i.test(t)
	    );
	};
	
	var minutesDiffFromNow = function minutesDiffFromNow(iso) {
	    var d = Date.parse(iso);
	    if (Number.isNaN(d)) return Infinity;
	    return (Date.now() - d) / 60000;
	};
	
	function formatNumber(num) {
	    return new Intl.NumberFormat("ru-RU").format(Math.round(num));
	}
	
	function getProgressColor(percent) {
	    if (percent >= 100) return "#f44336";
	    if (percent >= 90) return "#ff5722";
	    if (percent >= 75) return "#ff9800";
	    return "#4caf50";
	}
	
	var Console = function Console(_ref) {
	    var token = _ref.token;
	
	    var _txState = (0, _react.useState)([]);
	    var tx = _txState[0];
	    var setTx = _txState[1];
	    var _loadingState = (0, _react.useState)(true);
	    var loading = _loadingState[0];
	    var setLoading = _loadingState[1];
	    var _errState = (0, _react.useState)(null);
	    var loadErr = _errState[0];
	    var setLoadErr = _errState[1];
	
	    var _clData = (0, _react.useState)(null);
	    var clData = _clData[0];
	    var setClData = _clData[1];
	    var _clLoading = (0, _react.useState)(true);
	    var clLoading = _clLoading[0];
	    var setClLoading = _clLoading[1];
	    var _clError = (0, _react.useState)(null);
	    var clError = _clError[0];
	    var setClError = _clError[1];
	
	    (0, _react.useEffect)(function () {
	        var mounted = true;
	        (function load() {
	            setLoading(true);
	            setLoadErr(null);
	            var filters = {
	                filters: [{ purchasePending: true }, { payoutPending: true }, { refundPending: true }, { reversalPending: true }, { recurrentPending: true }, { sbpPending: true }, { mP2PPending: true }, { qrPending: true }, { mobilePayoutPending: true }, { threeDSPending: true }, { purchaseCreated: true }, { payoutCreated: true }, { refundCreated: true }, { reversalCreated: true }, { recurrentCreated: true }, { sbpCreated: true }, { mP2PCreated: true }, { qrCreated: true }, { mobilePayoutCreated: true }, { created: true }],
	                page: 1,
	                itemsPerPage: 10000
	            };
	
	            new _Api2.default({ token: token }).setTransactionsFilters(filters).then(function (data) {
	                if (!mounted) return;
	                var arr = data && Array.isArray(data.data) ? data.data : [];
	                setTx(arr);
	                setLoading(false);
	            }).catch(function (e) {
	                Sentry.captureException(e);
	                if (mounted) {
	                    setLoadErr("Не удалось загрузить данные");
	                    setLoading(false);
	                }
	                console.error(e);
	            });
	        })();
	        return function () {
	            mounted = false;
	        };
	    }, [token]);
	
	    (0, _react.useEffect)(function () {
	        var cancelled = false;
	
	        function loadCraftlite() {
	            setClLoading(true);
	            new _Api2.default({ token: token }).getCraftliteLimitStats().then(function (result) {
	                if (!cancelled) {
	                    setClData(result);
	                    setClError(null);
	                    setClLoading(false);
	                }
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                if (!cancelled) {
	                    setClError(err.message || "Failed to load data");
	                    setClLoading(false);
	                }
	            });
	        }
	
	        loadCraftlite();
	        var interval = setInterval(loadCraftlite, 30000);
	        return function () {
	            cancelled = true;
	            clearInterval(interval);
	        };
	    }, [token]);
	
	    var counts = (0, _react.useMemo)(function () {
	        var pending = 0;
	        var created = 0;
	        var stuck = 0;
	
	        for (var i = 0; i < tx.length; i++) {
	            var t = tx[i];
	            var type = String(t && t.type || "").trim();
	            var isP = isPendingType(type);
	            var isC = isCreatedType(type);
	            if (!isP && !isC) continue;
	
	            var ageMin = minutesDiffFromNow(t && t.date);
	            var isStuck = ageMin >= STUCK_MINUTES;
	
	            if (isStuck) {
	                stuck++;
	            } else if (isP) {
	                pending++;
	            } else if (isC) {
	                created++;
	            }
	        }
	
	        return { pending: pending, created: created, error: stuck };
	    }, [tx]);
	
	    var pieData = clData ? [["Segment", "Amount"], ["Использовано", clData.usedRub], ["Остаток", clData.remainingRub]] : null;
	
	    var barData = clData && clData.merchants && clData.merchants.length > 0 ? [["Мерчант", "Сумма (RUB)", { role: "style" }]].concat(clData.merchants.map(function (m, i) {
	        var colors = ["#2196f3", "#4caf50", "#ff9800", "#9c27b0", "#f44336", "#00bcd4"];
	        return [m.merchantName, m.sumRub, colors[i % colors.length]];
	    })) : null;
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: "center" } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 1180 },
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.Console },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Console.title", defaultMessage: "\u0410\u0434\u043C\u0438\u043D-\u043F\u0430\u043D\u0435\u043B\u044C" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.AlarmBlock },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Console.transactionsTitle",
	                            defaultMessage: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u0442\u0440\u0435\u0431\u0443\u044E\u0449\u0438\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u044F" })
	                    ),
	                    loading ? _react2.default.createElement(
	                        "p",
	                        null,
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Console.loading", defaultMessage: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026" })
	                    ) : loadErr ? _react2.default.createElement(
	                        "p",
	                        { className: _stylesModule2.default.ErrorText },
	                        loadErr
	                    ) : _react2.default.createElement(
	                        "table",
	                        { className: _stylesModule2.default.SimpleTable },
	                        _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Console.pending", defaultMessage: "Pending" })
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Console.created", defaultMessage: "Created" })
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Console.error", defaultMessage: "Error" })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tbody",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    _react2.default.createElement(
	                                        "strong",
	                                        null,
	                                        counts.pending
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    _react2.default.createElement(
	                                        "strong",
	                                        null,
	                                        counts.created
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    _react2.default.createElement(
	                                        "strong",
	                                        null,
	                                        counts.error
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.AlarmBlock },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        "\u0414\u043D\u0435\u0432\u043D\u043E\u0439 \u043B\u0438\u043C\u0438\u0442 Craftlite"
	                    ),
	                    clLoading && !clData ? _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.ClLoadingWrap },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "spinner-border text-primary", role: "status" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "visually-hidden" },
	                                "Loading..."
	                            )
	                        )
	                    ) : clError ? _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.ClErrorCard },
	                        clError
	                    ) : _react2.default.createElement(
	                        "div",
	                        { className: "row " + _stylesModule2.default.ClRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-md-8 " + _stylesModule2.default.ClCol },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.ClCard },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClCardHeader },
	                                    _react2.default.createElement(
	                                        "h5",
	                                        { className: _stylesModule2.default.ClCardTitle },
	                                        "\u041E\u0431\u0449\u0438\u0439 \u043B\u0438\u043C\u0438\u0442"
	                                    ),
	                                    clData && _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.ClDateLabel },
	                                        clData.date
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClCardBody },
	                                    pieData && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClChartWrap },
	                                        _react2.default.createElement(_reactGoogleCharts2.default, {
	                                            width: "100%",
	                                            height: "300px",
	                                            chartType: "PieChart",
	                                            data: pieData,
	                                            options: {
	                                                pieHole: 0.5,
	                                                colors: [getProgressColor(clData.usedPercent), "#e0e0e0"],
	                                                legend: { position: "bottom", textStyle: { fontSize: 13 } },
	                                                chartArea: { width: "90%", height: "80%" },
	                                                pieSliceText: "value",
	                                                tooltip: { text: "both" }
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            barData && _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.ClCard },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClCardHeader },
	                                    _react2.default.createElement(
	                                        "h5",
	                                        { className: _stylesModule2.default.ClCardTitle },
	                                        "\u041F\u043E \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\u043C"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClCardBody },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClChartWrap },
	                                        _react2.default.createElement(_reactGoogleCharts2.default, {
	                                            width: "100%",
	                                            height: "300px",
	                                            chartType: "BarChart",
	                                            data: barData,
	                                            options: {
	                                                legend: "none",
	                                                chartArea: { width: "60%", height: "80%" },
	                                                hAxis: { title: "RUB", minValue: 0 }
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            clData && clData.merchants && clData.merchants.length > 0 && _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.ClCard },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClCardHeader },
	                                    _react2.default.createElement(
	                                        "h5",
	                                        { className: _stylesModule2.default.ClCardTitle },
	                                        "\u0414\u0435\u0442\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClCardBody },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: _stylesModule2.default.ClMerchantTable },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    null,
	                                                    "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { className: _stylesModule2.default.ClAlignRight },
	                                                    "\u0421\u0443\u043C\u043C\u0430 (RUB)"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { className: _stylesModule2.default.ClAlignRight },
	                                                    "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            clData.merchants.map(function (m) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    { key: m.merchantId },
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        m.merchantName
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        { className: _stylesModule2.default.ClAlignRight },
	                                                        formatNumber(m.sumRub)
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        { className: _stylesModule2.default.ClAlignRight },
	                                                        m.count
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-md-4 " + _stylesModule2.default.ClCol },
	                            clData && _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClSummaryCard },
	                                    _react2.default.createElement(
	                                        "h6",
	                                        { className: _stylesModule2.default.ClSummaryTitle },
	                                        "\u041E\u0431\u0449\u0438\u0439 \u043B\u0438\u043C\u0438\u0442"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClProgressWrap },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.ClProgressBar },
	                                            _react2.default.createElement("div", {
	                                                className: _stylesModule2.default.ClProgressFill,
	                                                style: {
	                                                    width: Math.min(clData.usedPercent, 100) + "%",
	                                                    backgroundColor: getProgressColor(clData.usedPercent)
	                                                }
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.ClProgressInfo },
	                                            _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                clData.usedPercent.toFixed(1),
	                                                "%"
	                                            ),
	                                            _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                clData.date
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClSummaryRow },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryLabel },
	                                            "\u041B\u0438\u043C\u0438\u0442"
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryValue },
	                                            formatNumber(clData.limitRub),
	                                            " RUB"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClSummaryRow },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryLabel },
	                                            "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043E"
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryValue },
	                                            formatNumber(clData.usedRub),
	                                            " RUB"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClSummaryRow },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryLabel },
	                                            "\u041E\u0441\u0442\u0430\u0442\u043E\u043A"
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryValue },
	                                            formatNumber(clData.remainingRub),
	                                            " RUB"
	                                        )
	                                    ),
	                                    clData.isBlocked ? _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClBlockedBadge },
	                                        "\u041B\u0418\u041C\u0418\u0422 \u0414\u041E\u0421\u0422\u0418\u0413\u041D\u0423\u0422"
	                                    ) : _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClActiveBadge },
	                                        "\u0410\u043A\u0442\u0438\u0432\u0435\u043D"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ClSummaryCard },
	                                    _react2.default.createElement(
	                                        "h6",
	                                        { className: _stylesModule2.default.ClSummaryTitle },
	                                        "\u041F\u043E\u0440\u043E\u0433\u0438 \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0439"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClSummaryRow },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryLabel },
	                                            "1 000 000 RUB"
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryValue },
	                                            clData.usedRub >= 1000000 ? "+" : "-"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClSummaryRow },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryLabel },
	                                            "1 250 000 RUB"
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryValue },
	                                            clData.usedRub >= 1250000 ? "+" : "-"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ClSummaryRow },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryLabel },
	                                            "1 500 000 RUB"
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _stylesModule2.default.ClSummaryValue },
	                                            clData.usedRub >= 1500000 ? "+" : "-"
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _Auth.withAuth)(Console);

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactGoogleCharts = __webpack_require__(34);
	
	var _reactGoogleCharts2 = _interopRequireDefault(_reactGoogleCharts);
	
	var _stylesModule = __webpack_require__(606);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function formatNumber(num) {
	    return new Intl.NumberFormat("ru-RU").format(Math.round(num));
	}
	
	function getProgressColor(percent) {
	    if (percent >= 100) return "#f44336";
	    if (percent >= 90) return "#ff5722";
	    if (percent >= 75) return "#ff9800";
	    return "#4caf50";
	}
	
	var CraftliteLimitPage = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        data = _useState2[0],
	        setData = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        loading = _useState4[0],
	        setLoading = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        error = _useState6[0],
	        setError = _useState6[1];
	
	    (0, _react.useEffect)(function () {
	        var loadStats = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	
	                                setLoading(true);
	                                _context.next = 4;
	                                return new _Api2.default({ token: token }).getCraftliteLimitStats();
	
	                            case 4:
	                                result = _context.sent;
	
	                                if (!cancelled) {
	                                    setData(result);
	                                    setError(null);
	                                }
	                                _context.next = 11;
	                                break;
	
	                            case 8:
	                                _context.prev = 8;
	                                _context.t0 = _context["catch"](0);
	
	                                if (!cancelled) {
	                                    setError(_context.t0.message || "Failed to load data");
	                                }
	
	                            case 11:
	                                _context.prev = 11;
	
	                                if (!cancelled) setLoading(false);
	                                return _context.finish(11);
	
	                            case 14:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 8, 11, 14]]);
	            }));
	
	            return function loadStats() {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        var cancelled = false;
	
	        loadStats();
	
	        var interval = setInterval(loadStats, 30000);
	        return function () {
	            cancelled = true;
	            clearInterval(interval);
	        };
	    }, [token]);
	
	    // Pie chart data
	    var pieData = data ? [["Segment", "Amount"], ["Использовано", data.usedRub], ["Остаток", data.remainingRub]] : null;
	
	    // Bar chart data (merchants)
	    var barData = data && data.merchants && data.merchants.length > 0 ? [["Мерчант", "Сумма (RUB)", { role: "style" }]].concat(_toConsumableArray(data.merchants.map(function (m, i) {
	        var colors = ["#2196f3", "#4caf50", "#ff9800", "#9c27b0", "#f44336", "#00bcd4"];
	        return [m.merchantName, m.sumRub, colors[i % colors.length]];
	    }))) : null;
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 1180 },
	                _react2.default.createElement(
	                    "h4",
	                    { className: "mb-3" },
	                    "\u0414\u043D\u0435\u0432\u043D\u043E\u0439 \u043B\u0438\u043C\u0438\u0442 Craftlite"
	                ),
	                loading && !data ? _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.LoadingWrap },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "spinner-border text-primary", role: "status" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "visually-hidden" },
	                            "Loading..."
	                        )
	                    )
	                ) : error ? _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ErrorCard },
	                    error
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ContentGrid },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.MainColumn },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Card },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Header },
	                                _react2.default.createElement(
	                                    "h5",
	                                    { className: _stylesModule2.default.Title },
	                                    "\u041E\u0431\u0449\u0438\u0439 \u043B\u0438\u043C\u0438\u0442"
	                                ),
	                                data && _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.DateLabel },
	                                    data.date
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Body },
	                                pieData && _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ChartWrap },
	                                    _react2.default.createElement(_reactGoogleCharts2.default, {
	                                        width: "100%",
	                                        height: "300px",
	                                        chartType: "PieChart",
	                                        data: pieData,
	                                        options: {
	                                            pieHole: 0.5,
	                                            colors: [getProgressColor(data.usedPercent), "#e0e0e0"],
	                                            legend: { position: "bottom", textStyle: { fontSize: 13 } },
	                                            chartArea: { width: "90%", height: "80%" },
	                                            pieSliceText: "value",
	                                            tooltip: { text: "both" }
	                                        }
	                                    })
	                                )
	                            )
	                        ),
	                        barData && _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Card },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Header },
	                                _react2.default.createElement(
	                                    "h5",
	                                    { className: _stylesModule2.default.Title },
	                                    "\u041F\u043E \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\u043C"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Body },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ChartWrap },
	                                    _react2.default.createElement(_reactGoogleCharts2.default, {
	                                        width: "100%",
	                                        height: "300px",
	                                        chartType: "BarChart",
	                                        data: barData,
	                                        options: {
	                                            legend: "none",
	                                            chartArea: { width: "60%", height: "80%" },
	                                            hAxis: { title: "RUB", minValue: 0 }
	                                        }
	                                    })
	                                )
	                            )
	                        ),
	                        data && data.merchants && data.merchants.length > 0 && _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Card },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Header },
	                                _react2.default.createElement(
	                                    "h5",
	                                    { className: _stylesModule2.default.Title },
	                                    "\u0414\u0435\u0442\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Body + " " + _stylesModule2.default.TableBody },
	                                _react2.default.createElement(
	                                    "table",
	                                    { className: _stylesModule2.default.MerchantTable },
	                                    _react2.default.createElement(
	                                        "thead",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { className: _stylesModule2.default.AlignRight },
	                                                "\u0421\u0443\u043C\u043C\u0430 (RUB)"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                { className: _stylesModule2.default.AlignRight },
	                                                "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        data.merchants.map(function (m) {
	                                            return _react2.default.createElement(
	                                                "tr",
	                                                { key: m.merchantId },
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    m.merchantName
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    { className: _stylesModule2.default.AlignRight },
	                                                    formatNumber(m.sumRub)
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    { className: _stylesModule2.default.AlignRight },
	                                                    m.count
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.SideColumn },
	                        data && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.SummaryCard },
	                                _react2.default.createElement(
	                                    "h6",
	                                    { className: _stylesModule2.default.SummaryTitle },
	                                    "\u041E\u0431\u0449\u0438\u0439 \u043B\u0438\u043C\u0438\u0442"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ProgressWrap },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ProgressBar },
	                                        _react2.default.createElement("div", {
	                                            className: _stylesModule2.default.ProgressFill,
	                                            style: {
	                                                width: Math.min(data.usedPercent, 100) + "%",
	                                                backgroundColor: getProgressColor(data.usedPercent)
	                                            }
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ProgressInfo },
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            data.usedPercent.toFixed(1),
	                                            "%"
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            data.date
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryRow },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryLabel },
	                                        "\u041B\u0438\u043C\u0438\u0442"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryValue },
	                                        formatNumber(data.limitRub),
	                                        " RUB"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryRow },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryLabel },
	                                        "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043E"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryValue },
	                                        formatNumber(data.usedRub),
	                                        " RUB"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryRow },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryLabel },
	                                        "\u041E\u0441\u0442\u0430\u0442\u043E\u043A"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryValue },
	                                        formatNumber(data.remainingRub),
	                                        " RUB"
	                                    )
	                                ),
	                                data.isBlocked ? _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.BlockedBadge },
	                                    "\u041B\u0418\u041C\u0418\u0422 \u0414\u041E\u0421\u0422\u0418\u0413\u041D\u0423\u0422"
	                                ) : _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.ActiveBadge },
	                                    "\u0410\u043A\u0442\u0438\u0432\u0435\u043D"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.SummaryCard },
	                                _react2.default.createElement(
	                                    "h6",
	                                    { className: _stylesModule2.default.SummaryTitle },
	                                    "\u041F\u043E\u0440\u043E\u0433\u0438 \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0439"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryRow },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryLabel },
	                                        "\u26A0\uFE0F 1 000 000 RUB"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryValue },
	                                        data.usedRub >= 1000000 ? "✅" : "⭕"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryRow },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryLabel },
	                                        "\uD83D\uDD34 1 250 000 RUB"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryValue },
	                                        data.usedRub >= 1250000 ? "✅" : "⭕"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryRow },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryLabel },
	                                        "\uD83D\uDED1 1 500 000 RUB"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _stylesModule2.default.SummaryValue },
	                                        data.usedRub >= 1500000 ? "✅" : "⭕"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = CraftliteLimitPage;

/***/ },
/* 448 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function normalizeListItem(raw) {
	    return {
	        id: raw.id,
	        uuid: raw.uuid,
	        status: raw.status,
	        amount: Number(raw.amount) / 100,
	        currency: raw.currency,
	        cardPanMasked: raw.card_pan_masked,
	        fullName: raw.full_name,
	        email: raw.email,
	        phone: raw.phone,
	        externalReference: raw.external_reference,
	        documentDate: raw.document_date,
	        description: raw.description,
	        declineReason: raw.decline_reason,
	        registryId: raw.registry_id,
	        transactionId: raw.transaction_id,
	        createdAt: raw.created_at,
	        updatedAt: raw.updated_at,
	        merchantName: raw.merchant_name,
	        merchantUuid: raw.merchant_uuid,
	        payoutType: raw.payout_type,
	        sbpPhone: raw.sbp_phone,
	        sbpBankBic: raw.sbp_bank_bic,
	        sbpBankCode: raw.sbp_bank_code || raw.sbp_bank_bic,
	        sbpBankName: raw.sbp_bank_name
	    };
	}
	
	var STATUS_CONFIG = [{ status: 0, label: "Создана", color: "#546e7a", bg: "#eceff1" }, { status: 1, label: "Антифрод", color: "#f57f17", bg: "#fff9c4" }, { status: 7, label: "Ожидает выплаты", color: "#0277bd", bg: "#e1f5fe" }, { status: 3, label: "В реестре", color: "#7b1fa2", bg: "#f3e5f5" }, { status: 5, label: "Успех", color: "#2e7d32", bg: "#e8f5e9" }, { status: 2, label: "Отклонена", color: "#c62828", bg: "#ffebee" }, { status: 6, label: "Ошибка", color: "#ad1457", bg: "#fce4ec" }];
	
	// Сколько карточек грузим в колонку за один запрос
	var COLUMN_PAGE_SIZE = 50;
	
	/**
	 * Собрать фильтры запроса из состояния страницы.
	 * Статус сюда НЕ попадает: колонка доски задаёт его сама.
	 */
	function buildRequestFilters(appliedFilters, searchTags) {
	    var f = {};
	    var af = appliedFilters && appliedFilters.filters || {};
	
	    if (af.dateFrom) f.dateFrom = af.dateFrom;
	    if (af.dateTo) f.dateTo = af.dateTo;
	    if (af.amountMin) f.amountMin = af.amountMin;
	    if (af.amountMax) f.amountMax = af.amountMax;
	
	    if (Array.isArray(searchTags)) {
	        searchTags.forEach(function (tag) {
	            if (tag.fullName) f.fullName = tag.fullName;
	            if (tag.externalReference) f.externalReference = tag.externalReference;
	            if (tag.cardMask) f.cardMask = tag.cardMask;
	            if (tag.phone) f.phone = tag.phone;
	            if (tag.merchantName) f.merchantName = tag.merchantName;
	            if (tag.transactionId) f.transactionId = tag.transactionId;
	        });
	    }
	
	    return f;
	}
	
	/**
	 * Какие статусы грузить с сервера: все колонки доски либо только выбранные в фильтрах.
	 */
	function statusesToLoad(appliedFilters, boardStatuses) {
	    var af = appliedFilters && appliedFilters.filters || {};
	    var all = boardStatuses || [];
	
	    if (af.status && af.status.length > 0) {
	        var wanted = af.status.map(Number);
	        return all.filter(function (s) {
	            return wanted.indexOf(Number(s)) >= 0;
	        });
	    }
	
	    return all.slice();
	}
	
	/**
	 * Дописать страницу к уже загруженным карточкам колонки, без дублей по id.
	 */
	function mergeColumnItems(existing, incoming) {
	    var result = (existing || []).slice();
	    var seen = {};
	    result.forEach(function (item) {
	        seen[item.id] = true;
	    });
	
	    (incoming || []).forEach(function (item) {
	        if (!seen[item.id]) {
	            seen[item.id] = true;
	            result.push(item);
	        }
	    });
	
	    return result;
	}
	
	/**
	 * Все загруженные карточки одним списком — для массовых действий и группировки на доске.
	 */
	function flattenColumns(columns) {
	    var result = [];
	    Object.keys(columns || {}).forEach(function (status) {
	        var col = columns[status];
	        if (col && Array.isArray(col.items)) {
	            result = result.concat(col.items);
	        }
	    });
	    return result;
	}
	
	/**
	 * Сколько заявок в каждой колонке всего на сервере.
	 */
	function columnTotals(columns) {
	    var totals = {};
	    Object.keys(columns || {}).forEach(function (status) {
	        var col = columns[status];
	        totals[status] = col && typeof col.total === "number" ? col.total : col && Array.isArray(col.items) ? col.items.length : 0;
	    });
	    return totals;
	}
	
	exports.normalizeListItem = normalizeListItem;
	exports.STATUS_CONFIG = STATUS_CONFIG;
	exports.COLUMN_PAGE_SIZE = COLUMN_PAGE_SIZE;
	exports.buildRequestFilters = buildRequestFilters;
	exports.statusesToLoad = statusesToLoad;
	exports.mergeColumnItems = mergeColumnItems;
	exports.flattenColumns = flattenColumns;
	exports.columnTotals = columnTotals;
	exports.default = {
	    normalizeListItem: normalizeListItem,
	    STATUS_CONFIG: STATUS_CONFIG,
	    COLUMN_PAGE_SIZE: COLUMN_PAGE_SIZE,
	    buildRequestFilters: buildRequestFilters,
	    statusesToLoad: statusesToLoad,
	    mergeColumnItems: mergeColumnItems,
	    flattenColumns: flattenColumns,
	    columnTotals: columnTotals
	};

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CrmPayoutRequests = __webpack_require__(190);
	
	var _CrmPayoutRequests2 = _interopRequireDefault(_CrmPayoutRequests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CrmSbpPayoutRequests(props) {
	    return _react2.default.createElement(_CrmPayoutRequests2.default, Object.assign({}, props, { payoutType: "sbp" }));
	}
	
	exports.default = CrmSbpPayoutRequests;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _MerchantTerminalSelect = __webpack_require__(57);
	
	var _MerchantTerminalSelect2 = _interopRequireDefault(_MerchantTerminalSelect);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(608);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATUS_LABELS = {
	    0: 'Создан',
	    1: 'Подтверждён',
	    2: 'Отменён'
	};
	
	function getStatusBadgeClass(status) {
	    switch (status) {
	        case 0:
	            return _stylesModule2.default.BadgeCreated;
	        case 1:
	            return _stylesModule2.default.BadgeConfirmed;
	        case 2:
	            return _stylesModule2.default.BadgeCancelled;
	        default:
	            return _stylesModule2.default.Badge;
	    }
	}
	
	function formatAmount(amountInKopecks) {
	    if (amountInKopecks === null || amountInKopecks === undefined) return '0.00';
	    return (Number(amountInKopecks) / 100).toLocaleString('ru-RU', {
	        minimumFractionDigits: 2,
	        maximumFractionDigits: 2
	    });
	}
	
	function formatDate(dateStr) {
	    if (!dateStr) return '\u2014';
	    try {
	        var d = new Date(dateStr);
	        return d.toLocaleString('ru-RU');
	    } catch (e) {
	        return dateStr;
	    }
	}
	
	var Deposit = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	    var onMessage = (0, _react.useContext)(_MessageContext2.default).onMessage;
	
	    // List state
	    var _deposits = (0, _react.useState)([]);
	    var deposits = _deposits[0];
	    var setDeposits = _deposits[1];
	
	    var _count = (0, _react.useState)(0);
	    var count = _count[0];
	    var setCount = _count[1];
	
	    var _loading = (0, _react.useState)(false);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _page = (0, _react.useState)(1);
	    var page = _page[0];
	    var setPage = _page[1];
	
	    var _terminalId = (0, _react.useState)('');
	    var terminalId = _terminalId[0];
	    var setTerminalId = _terminalId[1];
	
	    var _statusFilter = (0, _react.useState)('');
	    var statusFilter = _statusFilter[0];
	    var setStatusFilter = _statusFilter[1];
	
	    // Detail state
	    var _selectedDeposit = (0, _react.useState)(null);
	    var selectedDeposit = _selectedDeposit[0];
	    var setSelectedDeposit = _selectedDeposit[1];
	
	    // Create form state
	    var _showCreate = (0, _react.useState)(false);
	    var showCreate = _showCreate[0];
	    var setShowCreate = _showCreate[1];
	
	    var _createTerminalId = (0, _react.useState)('');
	    var createTerminalId = _createTerminalId[0];
	    var setCreateTerminalId = _createTerminalId[1];
	
	    var _createMerchantUuid = (0, _react.useState)('');
	    var createMerchantUuid = _createMerchantUuid[0];
	    var setCreateMerchantUuid = _createMerchantUuid[1];
	
	    var _merchantSettingsList = (0, _react.useState)([]);
	    var merchantSettingsList = _merchantSettingsList[0];
	    var setMerchantSettingsList = _merchantSettingsList[1];
	
	    var _createMsId = (0, _react.useState)('');
	    var createMsId = _createMsId[0];
	    var setCreateMsId = _createMsId[1];
	
	    var _createAmount = (0, _react.useState)('');
	    var createAmount = _createAmount[0];
	    var setCreateAmount = _createAmount[1];
	
	    var _createComment = (0, _react.useState)('');
	    var createComment = _createComment[0];
	    var setCreateComment = _createComment[1];
	
	    var _createFile = (0, _react.useState)(null);
	    var createFile = _createFile[0];
	    var setCreateFile = _createFile[1];
	
	    var _creating = (0, _react.useState)(false);
	    var creating = _creating[0];
	    var setCreating = _creating[1];
	
	    // Cancel state
	    var _cancelId = (0, _react.useState)(null);
	    var cancelId = _cancelId[0];
	    var setCancelId = _cancelId[1];
	
	    var _cancelReason = (0, _react.useState)('');
	    var cancelReason = _cancelReason[0];
	    var setCancelReason = _cancelReason[1];
	
	    var _cancelling = (0, _react.useState)(false);
	    var cancelling = _cancelling[0];
	    var setCancelling = _cancelling[1];
	
	    var perPage = 20;
	
	    // Load deposits list
	    (0, _react.useEffect)(function () {
	        loadDeposits();
	    }, [page, terminalId, statusFilter, token]);
	
	    // Load merchant settings when terminal changes in create form
	    (0, _react.useEffect)(function () {
	        if (!createTerminalId || !createMerchantUuid) {
	            setMerchantSettingsList([]);
	            setCreateMsId('');
	            return;
	        }
	        new _Api2.default({ token: token }).getTerminalBalances(createTerminalId, createMerchantUuid).then(function (r) {
	            var balances = r && r.balances ? r.balances : Array.isArray(r.data) ? r.data : [];
	            setMerchantSettingsList(balances);
	            if (balances.length === 1) {
	                setCreateMsId(String(balances[0].merchantSettingsId));
	            } else {
	                setCreateMsId('');
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setMerchantSettingsList([]);
	            setCreateMsId('');
	        });
	    }, [createTerminalId, createMerchantUuid, token]);
	
	    function loadDeposits() {
	        setLoading(true);
	        var filters = {
	            page: page,
	            limit: perPage
	        };
	        if (terminalId) filters.terminal_id = terminalId;
	        if (statusFilter !== '') filters.status = statusFilter;
	
	        new _Api2.default({ token: token }).getDeposits(filters).then(function (r) {
	            setDeposits(Array.isArray(r.data) ? r.data : []);
	            setCount(typeof r.count === 'number' ? r.count : 0);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setDeposits([]);
	            setCount(0);
	            setLoading(false);
	            onMessage({ type: 'error', message: 'Ошибка загрузки списка депозитов' });
	        });
	    }
	
	    function loadDetail(id) {
	        new _Api2.default({ token: token }).getDepositDetail(id).then(function (r) {
	            setSelectedDeposit(r.data || r);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({ type: 'error', message: 'Ошибка загрузки деталей депозита' });
	        });
	    }
	
	    function onCreate() {
	        if (!createTerminalId || !createMsId || !createAmount || !createComment) {
	            onMessage({ type: 'error', message: 'Заполните все обязательные поля' });
	            return;
	        }
	
	        var amountKopecks = Math.round(Number(createAmount) * 100);
	        if (isNaN(amountKopecks) || amountKopecks <= 0) {
	            onMessage({ type: 'error', message: 'Сумма должна быть положительным числом' });
	            return;
	        }
	
	        setCreating(true);
	        var api = new _Api2.default({ token: token });
	        var promise = void 0;
	
	        if (createFile) {
	            var formData = new FormData();
	            formData.append('terminal_id', Number(createTerminalId));
	            formData.append('merchant_settings_id', Number(createMsId));
	            formData.append('amount', amountKopecks);
	            formData.append('comment', createComment);
	            formData.append('payment_proof', createFile);
	            promise = api.createDepositMultipart(formData);
	        } else {
	            var data = {
	                terminal_id: Number(createTerminalId),
	                merchant_settings_id: Number(createMsId),
	                amount: amountKopecks,
	                comment: createComment
	            };
	            promise = api.createDeposit(data);
	        }
	
	        promise.then(function () {
	            setCreating(false);
	            setShowCreate(false);
	            resetCreateForm();
	            setPage(1);
	            loadDeposits();
	            onMessage({ type: 'success', message: 'Депозит успешно создан' });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setCreating(false);
	            var msg = 'Ошибка при создании депозита';
	            if (err && err.response && err.response.data && err.response.data.message) {
	                msg = err.response.data.message;
	            }
	            onMessage({ type: 'error', message: msg });
	        });
	    }
	
	    function onCancel() {
	        if (!cancelId) return;
	        setCancelling(true);
	        var currentCancelId = cancelId;
	        new _Api2.default({ token: token }).cancelDeposit(currentCancelId, { reason: cancelReason }).then(function () {
	            setCancelling(false);
	            setCancelId(null);
	            setCancelReason('');
	            if (selectedDeposit && selectedDeposit.id === currentCancelId) {
	                loadDetail(currentCancelId);
	            }
	            loadDeposits();
	            onMessage({ type: 'success', message: 'Депозит отменён' });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setCancelling(false);
	            onMessage({ type: 'error', message: 'Ошибка при отмене депозита' });
	        });
	    }
	
	    function resetCreateForm() {
	        setCreateTerminalId('');
	        setCreateMerchantUuid('');
	        setCreateMsId('');
	        setCreateAmount('');
	        setCreateComment('');
	        setCreateFile(null);
	        setMerchantSettingsList([]);
	    }
	
	    function onRowClick(deposit) {
	        loadDetail(deposit.id);
	    }
	
	    function onBackToList() {
	        setSelectedDeposit(null);
	    }
	
	    function openCreateForm() {
	        setShowCreate(true);
	        resetCreateForm();
	    }
	
	    function closeCreateForm() {
	        setShowCreate(false);
	        resetCreateForm();
	    }
	
	    // Render detail view
	    function renderDetail() {
	        if (!selectedDeposit) return null;
	        var d = selectedDeposit;
	
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: _stylesModule2.default.BackLink, onClick: onBackToList },
	                        '\u2190 \u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443'
	                    ),
	                    _react2.default.createElement(
	                        'h5',
	                        { className: _stylesModule2.default.Title, style: { marginTop: 8 } },
	                        'Депозит #' + d.id
	                    )
	                ),
	                d.status === 1 && _react2.default.createElement(
	                    'button',
	                    {
	                        className: _stylesModule2.default.BtnDanger,
	                        onClick: function onClick() {
	                            setCancelId(d.id);
	                            setCancelReason('');
	                        }
	                    },
	                    '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.DetailGrid },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailLabel },
	                            '\u041C\u0435\u0440\u0447\u0430\u043D\u0442'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailValue },
	                            d.merchant_name || '\u2014'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailLabel },
	                            '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailValue },
	                            d.terminal_name ? d.terminal_name + ' (#' + d.terminal_id + ')' : d.terminal_id || '\u2014'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailLabel },
	                            '\u0421\u0442\u0430\u0442\u0443\u0441'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailValue },
	                            _react2.default.createElement(
	                                'span',
	                                { className: getStatusBadgeClass(d.status) },
	                                STATUS_LABELS[d.status] || 'Неизвестно'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailLabel },
	                            '\u0421\u0443\u043C\u043C\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailValue },
	                            formatAmount(d.amount),
	                            ' \u20BD'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailLabel },
	                            '\u0414\u0430\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailValue },
	                            formatDate(d.created_at)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailLabel },
	                            '\u0421\u043E\u0437\u0434\u0430\u043B'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailValue },
	                            d.created_by && d.created_by.username || '\u2014'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailLabel },
	                            '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.DetailValue },
	                            d.merchant_settings_id || '\u2014'
	                        )
	                    )
	                ),
	                d.has_payment_proof && _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 12 } },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnOutline,
	                            onClick: function onClick() {
	                                new _Api2.default({ token: token }).downloadDepositPaymentProof(d.id);
	                            }
	                        },
	                        '\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 (',
	                        d.payment_proof_original_name || 'файл',
	                        ')'
	                    )
	                ),
	                d.comment && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.DetailCard },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.DetailLabel },
	                        '\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 4 } },
	                        d.comment
	                    )
	                ),
	                d.cancelled_reason && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.DetailCard, style: { background: '#fff3cd', borderColor: '#ffc107' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.DetailLabel },
	                        '\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0442\u043C\u0435\u043D\u044B'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 4 } },
	                        d.cancelled_reason
	                    ),
	                    d.cancelled_by && _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 4, fontSize: '.75rem', color: '#666' } },
	                        'Отменил: ' + d.cancelled_by.username + ' (' + formatDate(d.cancelled_at) + ')'
	                    )
	                ),
	                cancelId === d.id && _react2.default.createElement(
	                    'div',
	                    {
	                        className: _stylesModule2.default.DetailCard,
	                        style: { marginTop: 16, background: '#fff3cd', borderColor: '#ffc107' }
	                    },
	                    _react2.default.createElement(
	                        'h6',
	                        { style: { margin: '0 0 8px 0', fontWeight: 600, color: '#856404' } },
	                        '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043E\u0442\u043C\u0435\u043D\u044B'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.CancelInput },
	                        _react2.default.createElement(
	                            'label',
	                            { style: { display: 'block', fontSize: '.8125rem', marginBottom: 4 } },
	                            '\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0442\u043C\u0435\u043D\u044B:'
	                        ),
	                        _react2.default.createElement('textarea', {
	                            value: cancelReason,
	                            onChange: function onChange(e) {
	                                setCancelReason(e.target.value);
	                            },
	                            placeholder: '\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043E\u0442\u043C\u0435\u043D\u044B...'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 8, display: 'flex', gap: 8 } },
	                        _react2.default.createElement(
	                            'button',
	                            { className: _stylesModule2.default.BtnDanger, onClick: onCancel, disabled: cancelling },
	                            cancelling ? 'Отмена...' : 'Подтвердить отмену'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: _stylesModule2.default.BtnOutline,
	                                onClick: function onClick() {
	                                    setCancelId(null);
	                                    setCancelReason('');
	                                }
	                            },
	                            '\u041E\u0442\u043C\u0435\u043D\u0430'
	                        )
	                    )
	                )
	            )
	        );
	    }
	
	    // Render create form
	    function renderCreateForm() {
	        var amountFloat = Number(createAmount) || 0;
	        var amountKopecks = Math.round(amountFloat * 100);
	
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    'h5',
	                    { className: _stylesModule2.default.Title },
	                    '\u041D\u043E\u0432\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: _stylesModule2.default.BtnOutline, onClick: closeCreateForm },
	                    '\u0417\u0430\u043A\u0440\u044B\u0442\u044C'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FormRow },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.FormGroup, style: { flex: 2 } },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B *'
	                        ),
	                        _react2.default.createElement(_MerchantTerminalSelect2.default, {
	                            mode: 'admin',
	                            token: token,
	                            stackOnMobile: true,
	                            onMerchantSelect: function onMerchantSelect(uuid) {
	                                setCreateMerchantUuid(uuid);
	                            },
	                            onSelect: function onSelect(val) {
	                                setCreateTerminalId(val);
	                            }
	                        })
	                    )
	                ),
	                merchantSettingsList.length > 1 && _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FormGroup },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 *'
	                    ),
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            value: createMsId,
	                            onChange: function onChange(e) {
	                                setCreateMsId(e.target.value);
	                            }
	                        },
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435...'
	                        ),
	                        merchantSettingsList.map(function (ms) {
	                            return _react2.default.createElement(
	                                'option',
	                                { key: ms.merchantSettingsId, value: ms.merchantSettingsId },
	                                (ms.providerName || 'Провайдер не указан') + ' / ' + (ms.currencyCode || 'валюта не указана') + ' (ID: ' + ms.merchantSettingsId + ')'
	                            );
	                        })
	                    )
	                ),
	                merchantSettingsList.length === 1 && _react2.default.createElement(
	                    'div',
	                    { style: { fontSize: '.8125rem', color: '#666', marginBottom: 12 } },
	                    'Настройка мерчанта: ' + (merchantSettingsList[0].providerName || 'провайдер не указан') + ' / ' + (merchantSettingsList[0].currencyCode || 'валюта не указана') + ' (ID: ' + merchantSettingsList[0].merchantSettingsId + ')'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FormRow },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.FormGroup },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            '\u0421\u0443\u043C\u043C\u0430 (\u0440\u0443\u0431.) *'
	                        ),
	                        _react2.default.createElement('input', {
	                            type: 'number',
	                            step: '0.01',
	                            min: '0.01',
	                            value: createAmount,
	                            onChange: function onChange(e) {
	                                setCreateAmount(e.target.value);
	                            },
	                            placeholder: '\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 10000.00'
	                        }),
	                        amountKopecks > 0 && _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: '.75rem', color: '#6c757d', marginTop: 4 } },
	                            '= ' + amountKopecks + ' копеек'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FormGroup },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        '\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 *'
	                    ),
	                    _react2.default.createElement('textarea', {
	                        rows: 3,
	                        value: createComment,
	                        onChange: function onChange(e) {
	                            setCreateComment(e.target.value);
	                        },
	                        placeholder: '\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0430',
	                        style: { width: '100%' }
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.FormGroup },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        '\u0424\u0430\u0439\u043B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F'
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'file',
	                        onChange: function onChange(e) {
	                            setCreateFile(e.target.files[0] || null);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: 16, display: 'flex', gap: 8 } },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: _stylesModule2.default.BtnPrimary,
	                            onClick: onCreate,
	                            disabled: creating || !createTerminalId || !createMsId || !createAmount || !createComment
	                        },
	                        creating ? 'Создание...' : 'Создать депозит'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _stylesModule2.default.BtnOutline, onClick: closeCreateForm },
	                        '\u041E\u0442\u043C\u0435\u043D\u0430'
	                    )
	                )
	            )
	        );
	    }
	
	    // Render list view
	    function renderList() {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    'h5',
	                    { className: _stylesModule2.default.Title },
	                    '\u0414\u0435\u043F\u043E\u0437\u0438\u0442\u044B'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: _stylesModule2.default.Btn, onClick: openCreateForm },
	                    '+ \u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u0435\u043F\u043E\u0437\u0438\u0442'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.FilterBar },
	                _react2.default.createElement(
	                    'div',
	                    { style: { flex: 1 } },
	                    _react2.default.createElement(_MerchantTerminalSelect2.default, {
	                        mode: 'admin',
	                        token: token,
	                        stackOnMobile: true,
	                        onSelect: function onSelect(val) {
	                            setTerminalId(val);
	                            setPage(1);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    'select',
	                    {
	                        value: statusFilter,
	                        onChange: function onChange(e) {
	                            setStatusFilter(e.target.value);
	                            setPage(1);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '\u0412\u0441\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044B'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: '0' },
	                        '\u0421\u043E\u0437\u0434\u0430\u043D'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: '1' },
	                        '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: '2' },
	                        '\u041E\u0442\u043C\u0435\u043D\u0451\u043D'
	                    )
	                )
	            ),
	            loading ? _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Empty },
	                '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...'
	            ) : deposits.length === 0 ? _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Empty },
	                '\u0414\u0435\u043F\u043E\u0437\u0438\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B'
	            ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'table',
	                    { className: _stylesModule2.default.Table },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'ID'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u041C\u0435\u0440\u0447\u0430\u043D\u0442'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u0421\u0443\u043C\u043C\u0430'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u0421\u0442\u0430\u0442\u0443\u0441'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u0414\u0430\u0442\u0430'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u0421\u043E\u0437\u0434\u0430\u043B'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        deposits.map(function (d) {
	                            return _react2.default.createElement(
	                                'tr',
	                                {
	                                    key: d.id,
	                                    onClick: function onClick() {
	                                        onRowClick(d);
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    d.id
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    d.merchant_name || '\u2014'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    d.terminal_name ? d.terminal_name + ' (#' + d.terminal_id + ')' : d.terminal_id || '\u2014'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    formatAmount(d.amount),
	                                    ' \u20BD'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: getStatusBadgeClass(d.status) },
	                                        STATUS_LABELS[d.status] || '?'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    {
	                                        style: {
	                                            maxWidth: 200,
	                                            overflow: 'hidden',
	                                            textOverflow: 'ellipsis',
	                                            whiteSpace: 'nowrap'
	                                        }
	                                    },
	                                    d.comment || '\u2014'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    formatDate(d.created_at)
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    d.created_by && d.created_by.username || '\u2014'
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.MobileList },
	                    deposits.map(function (d) {
	                        return _react2.default.createElement(
	                            'button',
	                            {
	                                key: d.id,
	                                type: 'button',
	                                className: _stylesModule2.default.MobileCard,
	                                onClick: function onClick() {
	                                    onRowClick(d);
	                                }
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.MobileCardRow },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.MobilePrimary },
	                                    '#',
	                                    d.id
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: getStatusBadgeClass(d.status) },
	                                    STATUS_LABELS[d.status] || '?'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.MobileCardRow },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.MobileSecondary },
	                                    d.merchant_name || '\u2014'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.MobileMuted },
	                                    formatDate(d.created_at)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.MobileCardRow },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.MobileTertiary },
	                                    d.terminal_name ? d.terminal_name + ' (#' + d.terminal_id + ')' : d.terminal_id || '\u2014'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.MobileAmount },
	                                    formatAmount(d.amount),
	                                    ' \u20BD'
	                                )
	                            ),
	                            d.comment ? _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.MobileComment },
	                                d.comment
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.MobileCardFooter },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    d.created_by && d.created_by.username || '\u2014'
	                                )
	                            )
	                        );
	                    })
	                )
	            ),
	            perPage < count && _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.PaginationWrap },
	                _react2.default.createElement(_reactJsPagination2.default, {
	                    firstPageText: '\u21E4',
	                    prevPageText: '\u21E0',
	                    lastPageText: '\u21E5',
	                    nextPageText: '\u21E2',
	                    activeLinkClass: _stylesModule2.default.ActiveLink,
	                    activePage: page,
	                    itemsCountPerPage: perPage,
	                    totalItemsCount: count,
	                    pageRangeDisplayed: 5,
	                    onChange: function onChange(p) {
	                        setPage(p);
	                    }
	                })
	            )
	        );
	    }
	
	    // Determine which view to show
	    var content = void 0;
	    if (showCreate) {
	        content = renderCreateForm();
	    } else if (selectedDeposit) {
	        content = renderDetail();
	    } else {
	        content = renderList();
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 'full' },
	                content
	            )
	        )
	    );
	});
	
	exports.default = Deposit;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _AdminFiltersToggle = __webpack_require__(42);
	
	var _AdminFiltersToggle2 = _interopRequireDefault(_AdminFiltersToggle);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _SearchTags = __webpack_require__(38);
	
	var _SearchTags2 = _interopRequireDefault(_SearchTags);
	
	var _DisputesList = __webpack_require__(368);
	
	var _DisputesList2 = _interopRequireDefault(_DisputesList);
	
	var _DisputeFilters = __webpack_require__(367);
	
	var _DisputeFilters2 = _interopRequireDefault(_DisputeFilters);
	
	var _DisputeDetails = __webpack_require__(366);
	
	var _DisputeDetails2 = _interopRequireDefault(_DisputeDetails);
	
	var _stylesModule = __webpack_require__(609);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _stylesModule3 = __webpack_require__(44);
	
	var _stylesModule4 = _interopRequireDefault(_stylesModule3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DisputesPage = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(1),
	        _useState2 = _slicedToArray(_useState, 2),
	        currentPage = _useState2[0],
	        setCurrentPage = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(5),
	        _useState4 = _slicedToArray(_useState3, 2),
	        perPage = _useState4[0],
	        setPerPage = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(0),
	        _useState6 = _slicedToArray(_useState5, 2),
	        totalCount = _useState6[0],
	        setTotalCount = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        list = _useState8[0],
	        setList = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        selected = _useState10[0],
	        setSelected = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        stats = _useState12[0],
	        setStats = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({}),
	        _useState14 = _slicedToArray(_useState13, 2),
	        filterDate = _useState14[0],
	        setFilterDate = _useState14[1];
	
	    var _useState15 = (0, _react.useState)({ filters: [] }),
	        _useState16 = _slicedToArray(_useState15, 2),
	        filters = _useState16[0],
	        setFilters = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        searchTags = _useState18[0],
	        setSearchTags = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(true),
	        _useState20 = _slicedToArray(_useState19, 2),
	        loading = _useState20[0],
	        setLoading = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(false),
	        _useState22 = _slicedToArray(_useState21, 2),
	        isFiltersOpen = _useState22[0],
	        setIsFiltersOpen = _useState22[1];
	
	    (0, _react.useEffect)(function () {
	        var statsPayload = {
	            filters: filters.filters || [],
	            dateRange: filterDate
	        };
	
	        if (filters.merchantId) {
	            statsPayload.merchantId = filters.merchantId;
	        }
	
	        new _Api2.default({ token: token }).getDisputeStats(statsPayload).then(function (r) {
	            setStats(r || null);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setStats(null);
	        });
	    }, [token, filters, filterDate]);
	
	    (0, _react.useEffect)(function () {
	        var payload = {
	            page: currentPage,
	            itemsPerPage: perPage,
	            dateRange: filterDate,
	            filters: filters.filters || []
	        };
	
	        if (filters.merchantId) {
	            payload.merchantId = filters.merchantId;
	        }
	
	        searchTags.forEach(function (tag) {
	            if (tag.transactionId) payload.transactionId = tag.transactionId;
	            if (tag.merchantName) payload.merchantName = tag.merchantName;
	            if (tag.senderName) payload.senderName = tag.senderName;
	            if (tag.messageText) payload.messageText = tag.messageText;
	            if (tag.uuidOrOrderId) payload.uuidOrOrderId = tag.uuidOrOrderId;
	        });
	
	        setLoading(true);
	        new _Api2.default({ token: token }).getDisputesList(payload).then(function (r) {
	            setList(Array.isArray(r.data) ? r.data : []);
	            setTotalCount(typeof r.count === 'number' ? r.count : 0);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setList([]);
	            setTotalCount(0);
	            setLoading(false);
	        });
	    }, [filters, filterDate, currentPage, perPage, searchTags, token]);
	
	    function setPage(page, itemsPerPage) {
	        setCurrentPage(page || 1);
	        if (itemsPerPage) setPerPage(itemsPerPage);
	    }
	
	    function onChangeSearch(tags) {
	        setSearchTags(tags);
	        setCurrentPage(1);
	    }
	
	    function onSelectDispute(row) {
	        if (row && row.id) {
	            new _Api2.default({ token: token }).getDispute(row.id).then(function (full) {
	                setSelected(full || row);
	            }).catch(function (err) {
	                Sentry.captureException(err);
	                setSelected(row);
	            });
	        } else {
	            setSelected(null);
	        }
	    }
	
	    function onDisputeUpdate(updatedDispute) {
	        setSelected(updatedDispute);
	        setList(function (prev) {
	            return prev.map(function (d) {
	                return d.id === updatedDispute.id ? Object.assign({}, d, updatedDispute) : d;
	            });
	        });
	
	        var statsPayload = {
	            filters: filters.filters || [],
	            dateRange: filterDate
	        };
	
	        if (filters.merchantId) {
	            statsPayload.merchantId = filters.merchantId;
	        }
	
	        new _Api2.default({ token: token }).getDisputeStats(statsPayload).then(function (r) {
	            setStats(r || null);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setStats(null);
	        });
	    }
	
	    function _onApplyFilters(newFilters) {
	        setFilters(newFilters || { filters: [] });
	        setCurrentPage(1);
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '780', className: _stylesModule4.default.MainColumn },
	                _react2.default.createElement(_AdminFiltersToggle2.default, { onClick: function onClick() {
	                        return setIsFiltersOpen(true);
	                    } }),
	                _react2.default.createElement(_SearchTags2.default, {
	                    onChangeSearch: onChangeSearch,
	                    onSearch: function onSearch() {
	                        setSearchTags(function (prev) {
	                            return [].concat(_toConsumableArray(prev));
	                        });
	                        setCurrentPage(1);
	                    },
	                    isDisabled: false,
	                    defaultSearch: {
	                        key: 'transactionId',
	                        locale: 'Search.label.transactionId',
	                        placeholder: 'Search.placeholder.transactionId'
	                    },
	                    searchBy: [{
	                        key: 'transactionId',
	                        locale: 'Search.label.transactionId',
	                        placeholder: 'Search.placeholder.transactionId'
	                    }, {
	                        key: 'merchantName',
	                        locale: 'Search.label.merchantName',
	                        placeholder: 'Search.placeholder.merchantName'
	                    }, {
	                        key: 'senderName',
	                        locale: 'Search.label.senderName',
	                        placeholder: 'Search.placeholder.senderName'
	                    }, {
	                        key: 'messageText',
	                        locale: 'Search.label.messageText',
	                        placeholder: 'Search.placeholder.messageText'
	                    }, {
	                        key: 'uuidOrOrderId',
	                        locale: 'Search.label.uuidOrOrderId',
	                        placeholder: 'Search.placeholder.uuidOrOrderId'
	                    }]
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            'h5',
	                            { className: _stylesModule2.default.Title },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Disputes.title', defaultMessage: '\u0414\u0438\u0441\u043F\u0443\u0442\u044B' }),
	                            stats && _react2.default.createElement(
	                                'span',
	                                { className: _stylesModule2.default.StatsInfo },
	                                '(',
	                                stats.total || 0,
	                                ' \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445)'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_DisputesList2.default, {
	                        isLoading: loading,
	                        data: list,
	                        currentId: selected ? selected.id : null,
	                        onSelect: onSelectDispute
	                    }),
	                    perPage < totalCount && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.PaginationWrap },
	                        _react2.default.createElement(_reactJsPagination2.default, {
	                            firstPageText: '\u21E4',
	                            prevPageText: '\u21E0',
	                            lastPageText: '\u21E5',
	                            nextPageText: '\u21E2',
	                            activeLinkClass: _stylesModule2.default.ActiveLink,
	                            activePage: currentPage,
	                            itemsCountPerPage: perPage,
	                            totalItemsCount: totalCount,
	                            pageRangeDisplayed: 5,
	                            onChange: function onChange(page) {
	                                return setPage(page, perPage);
	                            }
	                        })
	                    )
	                ),
	                selected && _react2.default.createElement(_DisputeDetails2.default, {
	                    dispute: selected,
	                    token: token,
	                    onUpdate: onDisputeUpdate,
	                    onClose: function onClose() {
	                        return setSelected(null);
	                    }
	                })
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '350', className: _stylesModule4.default.SidebarColumn },
	                _react2.default.createElement(
	                    _ResponsiveSidebarFilters2.default,
	                    {
	                        title: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B',
	                        isOpen: isFiltersOpen,
	                        onClose: function onClose() {
	                            return setIsFiltersOpen(false);
	                        }
	                    },
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_DateRange2.default, {
	                            onSelectDate: function onSelectDate(range) {
	                                setFilterDate(range || {});
	                                setCurrentPage(1);
	                            },
	                            defaultPeriod: 'zero'
	                        })
	                    ),
	                    _react2.default.createElement(_DisputeFilters2.default, {
	                        isLoading: loading,
	                        onApplyFilters: function onApplyFilters(newFilters) {
	                            _onApplyFilters(newFilters);
	                            setIsFiltersOpen(false);
	                        },
	                        token: token
	                    }),
	                    stats && _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.StatsCard },
	                        _react2.default.createElement(
	                            'h6',
	                            { className: _stylesModule2.default.StatsTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Disputes.stats.title', defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.StatsList },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u041D\u043E\u0432\u044B\u0445:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    { className: _stylesModule2.default.StatsNew },
	                                    stats.new || 0
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0412 \u0440\u0430\u0431\u043E\u0442\u0435:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    { className: _stylesModule2.default.StatsProgress },
	                                    stats.in_progress || 0
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0420\u0435\u0448\u0451\u043D\u043D\u044B\u0445:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    { className: _stylesModule2.default.StatsResolved },
	                                    stats.resolved || 0
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0412 \u0430\u0440\u0445\u0438\u0432\u0435:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    { className: _stylesModule2.default.StatsArchived },
	                                    stats.archived || 0
	                                )
	                            ),
	                            _react2.default.createElement('div', { className: _stylesModule2.default.StatsDivider }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0421\u0435\u0433\u043E\u0434\u043D\u044F:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    stats.today || 0
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.StatsItem },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0412\u0441\u0435\u0433\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445:'
	                                ),
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    stats.total || 0
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = DisputesPage;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _stylesModule = __webpack_require__(610);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ALL_PROJECT_OPTION = { uuid: "all", name: "Все мерчанты" };
	
	var Frod = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        projects = _useState2[0],
	        setProjects = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        selectedProject = _useState4[0],
	        setSelectedProject = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        filterDate = _useState6[0],
	        setFilterDate = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(""),
	        _useState8 = _slicedToArray(_useState7, 2),
	        idFilter = _useState8[0],
	        setIdFilter = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(""),
	        _useState10 = _slicedToArray(_useState9, 2),
	        transactionFilter = _useState10[0],
	        setTransactionFilter = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(""),
	        _useState12 = _slicedToArray(_useState11, 2),
	        statusFilter = _useState12[0],
	        setStatusFilter = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(""),
	        _useState14 = _slicedToArray(_useState13, 2),
	        ipFilter = _useState14[0],
	        setIpFilter = _useState14[1];
	
	    var _useState15 = (0, _react.useState)({ items: [], total: 0 }),
	        _useState16 = _slicedToArray(_useState15, 2),
	        frodData = _useState16[0],
	        setFrodData = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        loading = _useState18[0],
	        setLoading = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(1),
	        _useState20 = _slicedToArray(_useState19, 2),
	        page = _useState20[0],
	        setPage = _useState20[1];
	
	    var itemsPerPage = 10;
	
	    var dateInitHandledRef = (0, _react.useRef)(false);
	
	    var STATUS_LABELS = {
	        ATTEMPT_CREATED: "Попытка создана",
	        BLOCK_TEMP: "Временная блок.",
	        BLOCK_PERM: "Перманентная блок.",
	        BLOCK_ACTIVE_PERM: "Активная перм. блок."
	    };
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjectsList({ page: 1, itemsPerPage: 1000, order: "DESC" }).then(function (r) {
	            if (r && r.data) {
	                var list = [ALL_PROJECT_OPTION].concat(_toConsumableArray(r.data));
	                setProjects(list);
	                setSelectedProject(function (prev) {
	                    return prev || ALL_PROJECT_OPTION;
	                });
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);console.error(err);
	        });
	    }, [token]);
	
	    var buildRequestBody = function buildRequestBody() {
	        var filters = [];
	
	        if (ipFilter.trim()) {
	            filters.push({ field: "clientIp", value: ipFilter.trim() });
	        }
	        if (idFilter.trim()) {
	            filters.push({ field: "id", value: idFilter.trim() });
	        }
	        if (transactionFilter.trim()) {
	            filters.push({ field: "transactionId", value: transactionFilter.trim() });
	        }
	        if (statusFilter) {
	            filters.push({ field: "status", value: statusFilter });
	        }
	
	        var body = {
	            filters: filters,
	            itemsPerPage: itemsPerPage,
	            page: page
	        };
	
	        if (filterDate && filterDate.startDate && filterDate.endDate) {
	            body.dateRange = {
	                startDate: filterDate.startDate,
	                endDate: filterDate.endDate
	            };
	        }
	
	        return body;
	    };
	
	    var isAllMerchants = selectedProject && selectedProject.uuid === ALL_PROJECT_OPTION.uuid;
	
	    var handleDateChange = function handleDateChange(range) {
	        if (!dateInitHandledRef.current) {
	            dateInitHandledRef.current = true;
	            return;
	        }
	        setFilterDate(range);
	    };
	
	    (0, _react.useEffect)(function () {
	        if (!selectedProject) {
	            return;
	        }
	
	        var cancelled = false;
	        setLoading(true);
	
	        var body = buildRequestBody();
	        var api = new _Api2.default({ token: token });
	        var uuid = isAllMerchants ? ALL_PROJECT_OPTION.uuid : selectedProject.uuid;
	
	        api.postFrodList(uuid, body).then(function (res) {
	            if (cancelled) return;
	
	            if (res && res.items !== undefined && res.total !== undefined) {
	                setFrodData({ items: res.items, total: res.total });
	            } else {
	                setFrodData({ items: [], total: 0 });
	            }
	        }).catch(function (err) {
	            if (cancelled) return;
	            Sentry.captureException(err);
	            console.error(err);
	            setFrodData({ items: [], total: 0 });
	        }).finally(function () {
	            if (cancelled) return;
	            setLoading(false);
	        });
	
	        return function () {
	            cancelled = true;
	        };
	    }, [selectedProject, token, page, filterDate, idFilter, transactionFilter, statusFilter, ipFilter]);
	
	    (0, _react.useEffect)(function () {
	        setPage(1);
	    }, [filterDate, idFilter, transactionFilter, statusFilter, ipFilter, selectedProject]);
	
	    var formatDate = function formatDate(date) {
	        if (!date) return "—";
	        return new Date(date).toLocaleString("ru-RU");
	    };
	
	    var projectName = selectedProject ? selectedProject.name || selectedProject.uuid : "";
	
	    var statusOptions = [{ value: "", label: "Все статусы" }, { value: "ATTEMPT_CREATED", label: STATUS_LABELS["ATTEMPT_CREATED"] }, { value: "BLOCK_TEMP", label: STATUS_LABELS["BLOCK_TEMP"] }, { value: "BLOCK_PERM", label: STATUS_LABELS["BLOCK_PERM"] }, { value: "BLOCK_ACTIVE_PERM", label: STATUS_LABELS["BLOCK_ACTIVE_PERM"] }];
	
	    var projectMap = (0, _react.useMemo)(function () {
	        var map = {};
	        projects.forEach(function (proj) {
	            if (proj.uuid && proj.uuid !== "all") {
	                map[proj.id] = proj.name || proj.id;
	            }
	        });
	        return map;
	    }, [projects]);
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 1180 },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.PageContent },
	                    _react2.default.createElement(
	                        "div",
	                        {
	                            className: _stylesModule2.default.FiltersGrid
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(_DateRange2.default, {
	                                onSelectDate: handleDateChange
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h6",
	                                { className: _stylesModule2.default.Title },
	                                "ID \u0437\u0430\u043F\u0438\u0441\u0438"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                value: idFilter,
	                                onChange: function onChange(e) {
	                                    return setIdFilter(e.target.value);
	                                },
	                                placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 12345",
	                                style: {
	                                    width: "100%",
	                                    padding: "8px 12px",
	                                    border: "1px solid #ddd",
	                                    borderRadius: "4px"
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h6",
	                                { className: _stylesModule2.default.Title },
	                                "ID \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                value: transactionFilter,
	                                onChange: function onChange(e) {
	                                    return setTransactionFilter(e.target.value);
	                                },
	                                placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: trx_abc123",
	                                style: {
	                                    width: "100%",
	                                    padding: "8px 12px",
	                                    border: "1px solid #ddd",
	                                    borderRadius: "4px"
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h6",
	                                { className: _stylesModule2.default.Title },
	                                "IP-\u0430\u0434\u0440\u0435\u0441"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                value: ipFilter,
	                                onChange: function onChange(e) {
	                                    return setIpFilter(e.target.value);
	                                },
	                                placeholder: "185.123.45.67",
	                                style: {
	                                    width: "100%",
	                                    padding: "8px 12px",
	                                    border: "1px solid #ddd",
	                                    borderRadius: "4px"
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h6",
	                                { className: _stylesModule2.default.Title },
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "select",
	                                {
	                                    value: statusFilter,
	                                    onChange: function onChange(e) {
	                                        return setStatusFilter(e.target.value);
	                                    },
	                                    style: {
	                                        width: "100%",
	                                        padding: "8px 12px",
	                                        border: "1px solid #ddd",
	                                        borderRadius: "4px"
	                                    }
	                                },
	                                statusOptions.map(function (opt) {
	                                    return _react2.default.createElement(
	                                        "option",
	                                        { key: opt.value, value: opt.value },
	                                        opt.label
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(_FieldsHelper.Select, {
	                                label: "FieldsHelper.label.project",
	                                placeholder: "FieldsHelper.label.selectProject",
	                                values: projects,
	                                onChange: function onChange(project) {
	                                    setSelectedProject(project || ALL_PROJECT_OPTION);
	                                    setFilterDate(null);
	                                    setIdFilter("");
	                                    setTransactionFilter("");
	                                    setStatusFilter("");
	                                    setIpFilter("");
	                                },
	                                selectedValue: selectedProject,
	                                fieldName: "name",
	                                isLoading: projects.length === 0
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FilterAction },
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    onClick: function onClick() {
	                                        setFilterDate(null);
	                                        setIdFilter("");
	                                        setTransactionFilter("");
	                                        setIpFilter("");
	                                        setStatusFilter("");
	                                    },
	                                    className: _stylesModule2.default.ClearButton
	                                },
	                                "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u044B"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Card },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Header },
	                            _react2.default.createElement(
	                                "h5",
	                                { className: _stylesModule2.default.Title },
	                                "\u041B\u043E\u0433\u0438 \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u0430 ",
	                                projectName && ": " + projectName
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { style: { fontSize: "14px", color: "#555" } },
	                                "\u041D\u0430\u0439\u0434\u0435\u043D\u043E: ",
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    frodData.total.toLocaleString("ru-RU")
	                                )
	                            )
	                        ),
	                        loading ? _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Loader },
	                            "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445..."
	                        ) : frodData.items.length === 0 ? _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Empty },
	                            "\u041D\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043F\u043E \u0437\u0430\u0434\u0430\u043D\u043D\u044B\u043C \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u043C"
	                        ) : _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.TableScroll },
	                                _react2.default.createElement(
	                                    "table",
	                                    {
	                                        className: _stylesModule2.default.FrodTable
	                                    },
	                                    _react2.default.createElement(
	                                        "colgroup",
	                                        null,
	                                        _react2.default.createElement("col", { style: { width: "70px" } }),
	                                        _react2.default.createElement("col", { style: { width: "140px" } }),
	                                        _react2.default.createElement("col", { style: { width: "110px" } }),
	                                        _react2.default.createElement("col", { style: { width: "90px" } }),
	                                        _react2.default.createElement("col", { style: { width: "auto" } }),
	                                        _react2.default.createElement("col", { style: { width: "160px" } }),
	                                        _react2.default.createElement("col", { style: { width: "160px" } })
	                                    ),
	                                    _react2.default.createElement(
	                                        "thead",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "ID"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "IP \u043A\u043B\u0438\u0435\u043D\u0442\u0430"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041F\u0440\u043E\u0435\u043A\u0442"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041F\u0440\u0438\u0447\u0438\u043D\u0430"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D \u0434\u043E"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0421\u043E\u0437\u0434\u0430\u043D\u043E"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        frodData.items.map(function (row) {
	                                            var reason = row.reason || "";
	                                            var shortReason = reason.length > 120 ? reason.substring(0, 120) + "..." : reason || "—";
	
	                                            var projectDisplayName = row.merchantId ? projectMap[row.merchantId] || row.merchantId : "—";
	
	                                            return _react2.default.createElement(
	                                                "tr",
	                                                { key: row.id },
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    row.id
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    row.clientIp || "—"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    projectDisplayName
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    row.transactionId || "—"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "span",
	                                                        {
	                                                            className: _stylesModule2.default.Status + " " + (_stylesModule2.default[row.status] || "")
	                                                        },
	                                                        STATUS_LABELS[row.status] || "—"
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    { title: reason },
	                                                    shortReason
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    formatDate(row.blockedUntil)
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    formatDate(row.createdAt)
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            ),
	                            frodData.total > itemsPerPage && _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.PaginationWrap },
	                                _react2.default.createElement(_reactJsPagination2.default, {
	                                    activePage: page,
	                                    itemsCountPerPage: itemsPerPage,
	                                    totalItemsCount: frodData.total,
	                                    pageRangeDisplayed: 5,
	                                    onChange: setPage,
	                                    firstPageText: "\u21E4",
	                                    prevPageText: "\u21E0",
	                                    nextPageText: "\u21E2",
	                                    lastPageText: "\u21E5",
	                                    activeLinkClass: _stylesModule2.default.ActiveLink
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = Frod;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _stylesModule = __webpack_require__(611);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_HELD = 'held';
	var TAB_HISTORY = 'history';
	var TAB_CARDS = 'cards';
	
	var STATUS_LABELS = {
	    held: 'Ждёт решения',
	    finalized: 'Проведена без провайдера',
	    released: 'Передана провайдеру',
	    declined: 'Отклонена'
	};
	
	function formatDate(iso) {
	    if (!iso) return '—';
	    var d = new Date(iso);
	    return Number.isNaN(d.getTime()) ? iso : d.toLocaleString('ru-RU');
	}
	
	function errorText(error) {
	    var data = error && error.response && error.response.data;
	    if (data && data.message) return data.message;
	    return 'Не удалось выполнить действие. Попробуйте ещё раз.';
	}
	
	/**
	 * Выплаты, остановленные по списку карт.
	 *
	 * Выплату на карту из списка система не отправляет провайдеру: она висит
	 * «в обработке», пока администратор не решит здесь — провести без провайдера,
	 * передать провайдеру или отклонить. Больше нигде с такой выплатой ничего
	 * сделать нельзя.
	 */
	var PayoutHoldsPage = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(TAB_HELD),
	        _useState2 = _slicedToArray(_useState, 2),
	        tab = _useState2[0],
	        setTab = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        holds = _useState4[0],
	        setHolds = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        summary = _useState6[0],
	        setSummary = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        cards = _useState8[0],
	        setCards = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        showRemoved = _useState10[0],
	        setShowRemoved = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(true),
	        _useState12 = _slicedToArray(_useState11, 2),
	        loading = _useState12[0],
	        setLoading = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(null),
	        _useState14 = _slicedToArray(_useState13, 2),
	        busyId = _useState14[0],
	        setBusyId = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(null),
	        _useState16 = _slicedToArray(_useState15, 2),
	        message = _useState16[0],
	        setMessage = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(''),
	        _useState18 = _slicedToArray(_useState17, 2),
	        cardsText = _useState18[0],
	        setCardsText = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(''),
	        _useState20 = _slicedToArray(_useState19, 2),
	        cardsComment = _useState20[0],
	        setCardsComment = _useState20[1];
	
	    var requestedTab = (0, _react.useRef)(tab);
	
	    var loadHolds = (0, _react.useCallback)(function () {
	        requestedTab.current = tab;
	        setLoading(true);
	        new _Api2.default({ token: token }).getPayoutHolds(tab === TAB_HELD ? 'held' : 'resolved').then(function (r) {
	            // ответ на запрос прошлой вкладки, пришедший позже, не показываем
	            if (requestedTab.current !== tab) return;
	            setHolds(Array.isArray(r.items) ? r.items : []);
	            setSummary(r.summary || null);
	        }).catch(function (e) {
	            return setMessage({ type: 'error', text: errorText(e) });
	        }).finally(function () {
	            return setLoading(false);
	        });
	    }, [token, tab]);
	
	    var loadCards = (0, _react.useCallback)(function () {
	        requestedTab.current = TAB_CARDS;
	        setLoading(true);
	        new _Api2.default({ token: token }).getPayoutHoldCards(showRemoved).then(function (r) {
	            if (requestedTab.current !== TAB_CARDS) return;
	            setCards(Array.isArray(r.items) ? r.items : []);
	        }).catch(function (e) {
	            return setMessage({ type: 'error', text: errorText(e) });
	        }).finally(function () {
	            return setLoading(false);
	        });
	    }, [token, showRemoved]);
	
	    (0, _react.useEffect)(function () {
	        if (tab === TAB_CARDS) {
	            loadCards();
	        } else {
	            loadHolds();
	        }
	    }, [tab, loadHolds, loadCards]);
	
	    function target(hold) {
	        return hold.transactionId ? '\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F #' + hold.transactionId : 'CRM-\u0437\u0430\u044F\u0432\u043A\u0430 #' + hold.payoutRequestId;
	    }
	
	    function decide(hold, action) {
	        var what = target(hold) + ', ' + hold.amount + ' ' + (hold.currency || '') + ', \u043A\u0430\u0440\u0442\u0430 ' + hold.cardMasked;
	        var texts = {
	            finalize: '\u041F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u0431\u0435\u0437 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0443?\n' + what + '\n\n\u0421 \u0431\u0430\u043B\u0430\u043D\u0441\u0430 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 \u0431\u0443\u0434\u0435\u0442 \u0441\u043F\u0438\u0441\u0430\u043D\u0430 \u0441\u0443\u043C\u043C\u0430 \u0441 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0435\u0439, \u043C\u0435\u0440\u0447\u0430\u043D\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \xAB\u0443\u0441\u043F\u0435\u0445\xBB.',
	            release: '\u041F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0443?\n' + what + '\n\n\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0443\u0439\u0434\u0451\u0442 \u0432 \u0431\u0430\u043D\u043A \u043E\u0431\u044B\u0447\u043D\u044B\u043C \u043F\u0443\u0442\u0451\u043C.',
	            decline: '\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443?\n' + what + '\n\n\u0414\u0435\u043D\u044C\u0433\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0443 \u043D\u0435 \u0441\u043F\u0438\u0441\u044B\u0432\u0430\u044E\u0442\u0441\u044F, \u043E\u043D \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043E\u0431 \u043E\u0442\u043A\u0430\u0437\u0435.'
	        };
	        if (!window.confirm(texts[action])) return;
	
	        var comment = window.prompt(action === 'decline' ? 'Причина отказа (её увидит мерчант):' : 'Комментарий (для журнала):', action === 'decline' ? 'Выплата на эту карту недоступна' : '');
	        if (comment === null) return;
	
	        var api = new _Api2.default({ token: token });
	        var call = {
	            finalize: function finalize() {
	                return api.finalizePayoutHold(hold.id, comment);
	            },
	            release: function release() {
	                return api.releasePayoutHold(hold.id, comment);
	            },
	            decline: function decline() {
	                return api.declinePayoutHold(hold.id, comment);
	            }
	        }[action];
	
	        setBusyId(hold.id);
	        setMessage(null);
	        call().then(function () {
	            setMessage({ type: 'success', text: '\u0413\u043E\u0442\u043E\u0432\u043E: ' + target(hold) + ' \u2014 ' + STATUS_LABELS[{ finalize: 'finalized', release: 'released', decline: 'declined' }[action]].toLowerCase() + '.' });
	            loadHolds();
	        }).catch(function (e) {
	            setMessage({ type: 'error', text: errorText(e) });
	            loadHolds();
	        }).finally(function () {
	            return setBusyId(null);
	        });
	    }
	
	    function addCards() {
	        if (cardsText.trim() === '') {
	            setMessage({ type: 'error', text: 'Вставьте номера карт, по одному на строку.' });
	            return;
	        }
	        setBusyId('cards');
	        setMessage(null);
	        new _Api2.default({ token: token }).addPayoutHoldCards(cardsText, cardsComment).then(function (r) {
	            var parts = [];
	            if (r.added && r.added.length) parts.push('\u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E: ' + r.added.join(', '));
	            if (r.reactivated && r.reactivated.length) parts.push('\u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u043E \u0432 \u0441\u043F\u0438\u0441\u043E\u043A: ' + r.reactivated.join(', '));
	            if (r.existing && r.existing.length) parts.push('\u0443\u0436\u0435 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435: ' + r.existing.join(', '));
	            if (r.invalid && r.invalid.length) parts.push('\u043E\u0448\u0438\u0431\u043A\u0438: ' + r.invalid.map(function (i) {
	                return '\u0441\u0442\u0440\u043E\u043A\u0430 ' + i.line + ' \u2014 ' + i.reason;
	            }).join('; '));
	            if (r.heldRequests) parts.push('\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0445 CRM-\u0437\u0430\u044F\u0432\u043E\u043A: ' + r.heldRequests);
	            setMessage({ type: r.invalid && r.invalid.length ? 'error' : 'success', text: parts.join('. ') || 'Ничего не изменилось.' });
	            setCardsText('');
	            loadCards();
	        }).catch(function (e) {
	            return setMessage({ type: 'error', text: errorText(e) });
	        }).finally(function () {
	            return setBusyId(null);
	        });
	    }
	
	    function removeCard(card) {
	        if (!window.confirm('\u0421\u043D\u044F\u0442\u044C \u043A\u0430\u0440\u0442\u0443 ' + card.cardMasked + ' \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430?\n\u041D\u043E\u0432\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043D\u0430 \u043D\u0435\u0451 \u043F\u043E\u0439\u0434\u0443\u0442 \u043E\u0431\u044B\u0447\u043D\u044B\u043C \u043F\u0443\u0442\u0451\u043C. \u0423\u0436\u0435 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0442 \u0436\u0434\u0430\u0442\u044C \u0440\u0435\u0448\u0435\u043D\u0438\u044F.')) return;
	        setBusyId('card-' + card.id);
	        new _Api2.default({ token: token }).removePayoutHoldCard(card.id).then(function () {
	            setMessage({ type: 'success', text: '\u041A\u0430\u0440\u0442\u0430 ' + card.cardMasked + ' \u0441\u043D\u044F\u0442\u0430 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430.' });
	            loadCards();
	        }).catch(function (e) {
	            return setMessage({ type: 'error', text: errorText(e) });
	        }).finally(function () {
	            return setBusyId(null);
	        });
	    }
	
	    function renderHolds() {
	        if (loading) return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Empty },
	            '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...'
	        );
	        if (holds.length === 0) {
	            return _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Empty },
	                tab === TAB_HELD ? 'Остановленных выплат нет.' : 'Решений пока нет.'
	            );
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TableScroll },
	            _react2.default.createElement(
	                'table',
	                { className: _stylesModule2.default.Table },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u041C\u0435\u0440\u0447\u0430\u043D\u0442'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u0421\u0443\u043C\u043C\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            '\u041A\u0430\u0440\u0442\u0430'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            tab === TAB_HELD ? 'Решение' : 'Итог'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    holds.map(function (hold) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: hold.id },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                formatDate(hold.heldAt)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                hold.merchantName || '—',
	                                hold.merchantId ? ' (#' + hold.merchantId + ')' : ''
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                target(hold)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _stylesModule2.default.Nowrap },
	                                hold.amount,
	                                ' ',
	                                hold.currency || ''
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: _stylesModule2.default.Nowrap },
	                                hold.cardMasked
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                hold.status === 'held' ? _react2.default.createElement(
	                                    'div',
	                                    { className: _stylesModule2.default.Actions },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', className: _stylesModule2.default.BtnPrimary, disabled: busyId !== null, onClick: function onClick() {
	                                                return decide(hold, 'finalize');
	                                            } },
	                                        '\u041F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u0431\u0435\u0437 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430'
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            type: 'button',
	                                            className: _stylesModule2.default.BtnSecondary,
	                                            disabled: busyId !== null || !hold.canRelease,
	                                            title: hold.canRelease ? '' : 'Номер карты не сохранён — можно только провести или отклонить',
	                                            onClick: function onClick() {
	                                                return decide(hold, 'release');
	                                            }
	                                        },
	                                        '\u041F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0443'
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', className: _stylesModule2.default.BtnDanger, disabled: busyId !== null, onClick: function onClick() {
	                                                return decide(hold, 'decline');
	                                            } },
	                                        '\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C'
	                                    )
	                                ) : _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        STATUS_LABELS[hold.status] || hold.status
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _stylesModule2.default.Muted },
	                                        formatDate(hold.resolvedAt)
	                                    ),
	                                    hold.resolutionComment ? _react2.default.createElement(
	                                        'div',
	                                        { className: _stylesModule2.default.Muted },
	                                        hold.resolutionComment
	                                    ) : null
	                                )
	                            )
	                        );
	                    })
	                )
	            )
	        );
	    }
	
	    function renderCards() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Form },
	                _react2.default.createElement(
	                    'label',
	                    { className: _stylesModule2.default.Label, htmlFor: 'hold-cards' },
	                    '\u041D\u043E\u043C\u0435\u0440\u0430 \u043A\u0430\u0440\u0442 \u2014 \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443 \u043D\u0430 \u0441\u0442\u0440\u043E\u043A\u0443 (\u043F\u0440\u043E\u0431\u0435\u043B\u044B \u0438 \u0434\u0435\u0444\u0438\u0441\u044B \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B)'
	                ),
	                _react2.default.createElement('textarea', {
	                    id: 'hold-cards',
	                    className: _stylesModule2.default.Textarea,
	                    rows: 5,
	                    value: cardsText,
	                    onChange: function onChange(e) {
	                        return setCardsText(e.target.value);
	                    },
	                    autoComplete: 'off'
	                }),
	                _react2.default.createElement(
	                    'label',
	                    { className: _stylesModule2.default.Label, htmlFor: 'hold-comment' },
	                    '\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439'
	                ),
	                _react2.default.createElement('input', {
	                    id: 'hold-comment',
	                    className: _stylesModule2.default.Input,
	                    value: cardsComment,
	                    onChange: function onChange(e) {
	                        return setCardsComment(e.target.value);
	                    },
	                    placeholder: '\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0434\u043E\u043B\u0433 \u043F\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0430\u043C 26.08'
	                }),
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: _stylesModule2.default.BtnPrimary, disabled: busyId !== null, onClick: addCards },
	                    '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u0441\u043F\u0438\u0441\u043E\u043A'
	                )
	            ),
	            _react2.default.createElement(
	                'label',
	                { className: _stylesModule2.default.Checkbox },
	                _react2.default.createElement('input', { type: 'checkbox', checked: showRemoved, onChange: function onChange() {
	                        return setShowRemoved(!showRemoved);
	                    } }),
	                ' \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043D\u044F\u0442\u044B\u0435'
	            ),
	            loading ? _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Empty },
	                '\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...'
	            ) : cards.length === 0 ? _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Empty },
	                '\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442.'
	            ) : _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.TableScroll },
	                _react2.default.createElement(
	                    'table',
	                    { className: _stylesModule2.default.Table },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u041A\u0430\u0440\u0442\u0430'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                '\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430'
	                            ),
	                            _react2.default.createElement('th', null)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        cards.map(function (card) {
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: card.id, className: card.isActive ? '' : _stylesModule2.default.Removed },
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: _stylesModule2.default.Nowrap },
	                                    card.cardMasked
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    card.comment || '—'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    formatDate(card.createdAt)
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    card.isActive ? _react2.default.createElement(
	                                        'button',
	                                        { type: 'button', className: _stylesModule2.default.BtnDanger, disabled: busyId !== null, onClick: function onClick() {
	                                                return removeCard(card);
	                                            } },
	                                        '\u0421\u043D\u044F\u0442\u044C'
	                                    ) : _react2.default.createElement(
	                                        'span',
	                                        { className: _stylesModule2.default.Muted },
	                                        '\u0441\u043D\u044F\u0442\u0430 ',
	                                        formatDate(card.removedAt)
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '1100' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Tabs },
	                    [[TAB_HELD, 'Ожидают решения'], [TAB_HISTORY, 'История решений'], [TAB_CARDS, 'Список карт']].map(function (_ref2) {
	                        var _ref3 = _slicedToArray(_ref2, 2),
	                            key = _ref3[0],
	                            title = _ref3[1];
	
	                        return _react2.default.createElement(
	                            'div',
	                            {
	                                key: key,
	                                className: _stylesModule2.default.Tab + ' ' + (tab === key ? _stylesModule2.default.TabActive : ''),
	                                onClick: function onClick() {
	                                    setMessage(null);
	                                    setTab(key);
	                                }
	                            },
	                            title
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            'h5',
	                            { className: _stylesModule2.default.Title },
	                            '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B',
	                            summary && summary.count > 0 ? _react2.default.createElement(
	                                'span',
	                                { className: _stylesModule2.default.StatsInfo },
	                                '(\u0436\u0434\u0443\u0442 \u0440\u0435\u0448\u0435\u043D\u0438\u044F: ',
	                                summary.count,
	                                Array.isArray(summary.byCurrency) && summary.byCurrency.length > 0 ? ' \u043D\u0430 ' + summary.byCurrency.map(function (c) {
	                                    return (c.amount / 100).toFixed(2) + ' ' + (c.currency || '');
	                                }).join(' + ') : '',
	                                ')'
	                            ) : null
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Body },
	                        _react2.default.createElement(
	                            'p',
	                            { className: _stylesModule2.default.Hint },
	                            '\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0443 \u0438 \u0432\u0438\u0441\u0438\u0442 \xAB\u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435\xBB, \u043F\u043E\u043A\u0430 \u0437\u0434\u0435\u0441\u044C \u043D\u0435 \u043F\u0440\u0438\u043D\u044F\u0442\u043E \u0440\u0435\u0448\u0435\u043D\u0438\u0435. \u0411\u043E\u043B\u044C\u0448\u0435 \u043D\u0438\u0433\u0434\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0435\u0451 \u043D\u0435\u043B\u044C\u0437\u044F.'
	                        ),
	                        message ? _react2.default.createElement(
	                            'div',
	                            { className: message.type === 'error' ? _stylesModule2.default.MessageError : _stylesModule2.default.MessageSuccess },
	                            message.text
	                        ) : null,
	                        tab === TAB_CARDS ? renderCards() : renderHolds()
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = PayoutHoldsPage;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _stylesModule = __webpack_require__(612);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Payouts = (0, _Auth.withAuth)(function (_ref) {
	    var _token = _ref.token;
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '780', className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    'span',
	                    { className: _stylesModule2.default.Payouts },
	                    'Payouts Statistic'
	                )
	            ),
	            _react2.default.createElement(_Layout.Column, { width: '350', className: _stylesModule2.default.SideColumn })
	        )
	    );
	});
	
	exports.default = Payouts;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(613);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _require = __webpack_require__(659),
	    motion = _require.motion,
	    AnimatePresence = _require.AnimatePresence;
	
	/* ------------------ helpers ------------------ */
	
	function get(obj, path, def) {
	    try {
	        var parts = path.split(".");
	        var cur = obj;
	        for (var i = 0; i < parts.length; i++) {
	            if (!cur || (typeof cur === "undefined" ? "undefined" : _typeof(cur)) !== "object") return def;
	            cur = cur[parts[i]];
	        }
	        return typeof cur === "undefined" ? def : cur;
	    } catch (e) {
	        return def;
	    }
	}
	
	function pretty(obj) {
	    try {
	        return JSON.stringify(obj, null, 2);
	    } catch (e) {
	        return String(obj);
	    }
	}
	
	/* ------------------ UI schema ------------------ */
	
	function buildLocalSchema(currencyOptions) {
	    var authRequired = [{
	        name: "merchantUuid",
	        label: "UUID мерчанта",
	        type: "text",
	        required: true,
	        hint: "Подставится из списка ниже"
	    }, { name: "apiKey", label: "API ключ", type: "text", required: true, hint: "Подставится из списка ниже" }];
	
	    var currencyField = {
	        name: "currency",
	        label: "Валюта",
	        type: "select",
	        options: currencyOptions && currencyOptions.length ? currencyOptions : ["RUB", "USD", "EUR"],
	        required: true
	    };
	
	    return {
	        providers: [{ key: "hydracode", label: "Гидрокод" }, { key: "tkb", label: "ТКБ" }, { key: "finstar", label: "Финстар" }],
	        operations: [{
	            key: "get_balance",
	            label: "Проверить баланс",
	            hint: "Нужны только UUID мерчанта и его API ключ.",
	            fields: authRequired
	        }, {
	            key: "get_tx_status",
	            label: "Проверить статус транзакции",
	            hint: "Укажите либо ID транзакции, либо внешний номер заказа.",
	            fields: authRequired.concat([{
	                name: "transactionId",
	                label: "ID транзакции",
	                type: "text",
	                required: false,
	                placeholder: "Напр. 123456"
	            }, {
	                name: "externalReference",
	                label: "Внешний номер заказа",
	                type: "text",
	                required: false,
	                placeholder: "Напр. order_123"
	            }])
	        },
	        // Платёж/выплата картой
	        {
	            key: "create_tx_card",
	            label: "Создать платеж (КАРТА)",
	            hint: "Введите сумму и валюту. Для Hydracode номер карты не требуется (будет редирект/реквизиты).",
	            fields: authRequired.concat([{ name: "amount", label: "Сумма", type: "number", required: true, placeholder: "Напр. 1000" }, currencyField, {
	                name: "cardPan",
	                label: "Номер карты",
	                type: "text",
	                required: true,
	                placeholder: "4111111111111111"
	            }, {
	                name: "phone",
	                label: "Телефон клиента",
	                type: "text",
	                required: false,
	                placeholder: "+79990000000"
	            }, {
	                name: "email",
	                label: "Email клиента",
	                type: "text",
	                required: false,
	                placeholder: "ivan@example.com"
	            }, {
	                name: "externalReference",
	                label: "Внешний номер заказа",
	                type: "text",
	                required: false,
	                placeholder: "order_123456"
	            }, {
	                name: "description",
	                label: "Описание",
	                type: "text",
	                required: false,
	                placeholder: "Тестовый платёж"
	            }, {
	                name: "callbackUrl",
	                label: "Callback URL",
	                type: "text",
	                required: false,
	                placeholder: "https://example.com/cb"
	            }])
	        },
	        // Платёж/выплата СБП
	        {
	            key: "create_tx_sbp",
	            label: "Создать платеж (СБП)",
	            hint: "Введите сумму и валюту. Для FinStar понадобится Bank Member ID и телефон.",
	            fields: authRequired.concat([{ name: "amount", label: "Сумма", type: "number", required: true, placeholder: "Напр. 1000" }, currencyField,
	            // будет обязательным только для FinStar (динамически)
	            {
	                name: "sbpBankMemberId",
	                label: "SBP Bank Member ID",
	                type: "text",
	                required: false,
	                placeholder: "Напр. 100000000111"
	            }, {
	                name: "phone",
	                label: "Телефон клиента (СБП)",
	                type: "text",
	                required: false,
	                placeholder: "+79990000000"
	            }, {
	                name: "email",
	                label: "Email клиента",
	                type: "text",
	                required: false,
	                placeholder: "ivan@example.com"
	            }, {
	                name: "externalReference",
	                label: "Внешний номер заказа",
	                type: "text",
	                required: false,
	                placeholder: "order_123456"
	            }, {
	                name: "description",
	                label: "Описание",
	                type: "text",
	                required: false,
	                placeholder: "Тестовый платёж"
	            }, {
	                name: "callbackUrl",
	                label: "Callback URL",
	                type: "text",
	                required: false,
	                placeholder: "https://example.com/cb"
	            }])
	        }]
	    };
	}
	
	/* ------------------ page ------------------ */
	
	function Console(props) {
	    var api = new _Api2.default({ token: props.token });
	
	    // currencies, merchants loading before rendering the form
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        currencies = _useState2[0],
	        setCurrencies = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currLoading = _useState4[0],
	        setCurrLoading = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        allMerchants = _useState6[0],
	        setAllMerchants = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(true),
	        _useState8 = _slicedToArray(_useState7, 2),
	        merchantsLoading = _useState8[0],
	        setMerchantsLoading = _useState8[1];
	
	    // schema based on loaded currencies
	
	
	    var _useState9 = (0, _react.useState)(buildLocalSchema([])),
	        _useState10 = _slicedToArray(_useState9, 2),
	        schema = _useState10[0],
	        setSchema = _useState10[1];
	
	    // selections
	
	
	    var _useState11 = (0, _react.useState)("hydracode"),
	        _useState12 = _slicedToArray(_useState11, 2),
	        provider = _useState12[0],
	        setProvider = _useState12[1];
	
	    var _useState13 = (0, _react.useState)("get_balance"),
	        _useState14 = _slicedToArray(_useState13, 2),
	        operation = _useState14[0],
	        setOperation = _useState14[1];
	
	    // form & ui
	
	
	    var _useState15 = (0, _react.useState)({}),
	        _useState16 = _slicedToArray(_useState15, 2),
	        form = _useState16[0],
	        setForm = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        sending = _useState18[0],
	        setSending = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(null),
	        _useState20 = _slicedToArray(_useState19, 2),
	        resp = _useState20[0],
	        setResp = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(null),
	        _useState22 = _slicedToArray(_useState21, 2),
	        err = _useState22[0],
	        setErr = _useState22[1];
	
	    // merchant picker state
	
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        mList = _useState24[0],
	        setMList = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(""),
	        _useState26 = _slicedToArray(_useState25, 2),
	        mQuery = _useState26[0],
	        setMQuery = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(false),
	        _useState28 = _slicedToArray(_useState27, 2),
	        pickerOpen = _useState28[0],
	        setPickerOpen = _useState28[1];
	
	    var pickerRef = (0, _react.useRef)(null);
	
	    // recent tx for selected merchant
	
	    var _useState29 = (0, _react.useState)([]),
	        _useState30 = _slicedToArray(_useState29, 2),
	        recentTx = _useState30[0],
	        setRecentTx = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(false),
	        _useState32 = _slicedToArray(_useState31, 2),
	        txLoading = _useState32[0],
	        setTxLoading = _useState32[1];
	
	    // center content container size
	
	
	    var centerWrapStyle = {
	        minHeight: "calc(100vh - 120px)",
	        display: "flex",
	        alignItems: "center",
	        justifyContent: "center"
	    };
	
	    // load currencies from backend (graceful fallback)
	    (0, _react.useEffect)(function () {
	        var mounted = true;
	        setCurrLoading(true);
	        api.client.get("/api/ui/currencies", { params: { limit: 500 } }).then(function (_ref) {
	            var data = _ref.data;
	
	            if (!mounted) return;
	            var items = Array.isArray(data) ? data : Array.isArray(get(data, "items", [])) ? data.items : [];
	            var opts = items.map(function (c) {
	                return c && (c.code || c.Code || c.CODE);
	            }).filter(function (v) {
	                return !!v;
	            });
	            setCurrencies(opts);
	            setSchema(buildLocalSchema(opts));
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setCurrencies(["RUB", "USD", "EUR"]);
	            setSchema(buildLocalSchema(["RUB", "USD", "EUR"]));
	        }).finally(function () {
	            if (mounted) setCurrLoading(false);
	        });
	        return function () {
	            mounted = false;
	        };
	    }, []);
	
	    // load merchants once
	    (0, _react.useEffect)(function () {
	        var cancelled = false;
	        setMerchantsLoading(true);
	        api.client.get("/api/ui/merchants", { params: { limit: 2000 } }).then(function (_ref2) {
	            var data = _ref2.data;
	
	            if (cancelled) return;
	            var items = Array.isArray(data && data.items) ? data.items : [];
	            setAllMerchants(items);
	            setMList(items.slice(0, 15));
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setAllMerchants([]);
	            setMList([]);
	        }).finally(function () {
	            if (!cancelled) setMerchantsLoading(false);
	        });
	        return function () {
	            cancelled = true;
	        };
	    }, []);
	
	    // outside-click to close picker
	    (0, _react.useEffect)(function () {
	        function onDoc(e) {
	            try {
	                if (pickerRef.current && !pickerRef.current.contains(e.target)) {
	                    setPickerOpen(false);
	                }
	            } catch (e2) {}
	        }
	
	        document.addEventListener("mousedown", onDoc);
	        return function () {
	            document.removeEventListener("mousedown", onDoc);
	        };
	    }, []);
	
	    // computed
	    function fieldsForCurrent() {
	        var ops = get(schema, "operations", []);
	        for (var i = 0; i < ops.length; i++) {
	            if (ops[i].key === operation) return ops[i];
	        }return { fields: [] };
	    }
	
	    var current = fieldsForCurrent();
	    var baseFields = current.fields || [];
	
	    // динамическая адаптация полей под провайдера:
	    function activeFields() {
	        var fs = baseFields.slice();
	
	        // Для Hydracode не нужен cardPan (он вводится на стороне провайдера)
	        if (provider === "hydracode") {
	            fs = fs.filter(function (f) {
	                return f.name !== "cardPan";
	            });
	        }
	
	        // Для FinStar/СБП — поле bank_member_id обязательно;
	        // для других провайдеров прячем его.
	        if (operation === "create_tx_sbp") {
	            if (provider !== "finstar") {
	                fs = fs.filter(function (f) {
	                    return f.name !== "sbpBankMemberId";
	                });
	            } else {
	                fs = fs.map(function (f) {
	                    if (f.name === "sbpBankMemberId") {
	                        var g = Object.assign({}, f);
	                        g.required = true;
	                        g.hint = g.hint || "Обязательное поле для выплат СБП через Финстар.";
	                        return g;
	                    }
	                    if (f.name === "phone") {
	                        var p = Object.assign({}, f);
	                        p.required = true;
	                        p.hint = p.hint || "Телефон получателя в формате +7… (цифры будут нормализованы).";
	                        return p;
	                    }
	                    return f;
	                });
	            }
	        }
	
	        return fs;
	    }
	
	    var fields = activeFields();
	    var isCreateOp = operation === "create_tx_card" || operation === "create_tx_sbp";
	    var hasCurrencyField = fields.some(function (f) {
	        return f.name === "currency";
	    });
	
	    function onChangeField(name, value) {
	        if (name === "cardPan" && typeof value === "string") value = value.replace(/\s+/g, "");
	        if (name === "currency" && typeof value === "string") value = value.toUpperCase();
	        setForm(function (p) {
	            var c = {};
	            for (var k in p) {
	                if (Object.prototype.hasOwnProperty.call(p, k)) c[k] = p[k];
	            }c[name] = value;
	            return c;
	        });
	    }
	
	    function validate() {
	        var miss = [];
	        for (var i = 0; i < fields.length; i++) {
	            var f = fields[i];
	            if (f.required) {
	                var v = form[f.name];
	                if (v === undefined || v === null || v === "") miss.push(f.label || f.name);
	            }
	        }
	        return miss;
	    }
	
	    function buildPayload() {
	        var base = { provider: provider, action: operation, data: Object.assign({}, form) };
	        if (operation === "create_tx_card") base.data.direction = "card";
	        if (operation === "create_tx_sbp") base.data.direction = "sbp";
	
	        // Для Hydracode не отправляем cardPan
	        if (provider === "hydracode" && base.data.cardPan) {
	            try {
	                delete base.data.cardPan;
	            } catch (e) {}
	        }
	
	        // числовая сумма
	        if (typeof base.data.amount === "string" && base.data.amount.trim() !== "") {
	            var n = Number(base.data.amount.replace(",", "."));
	            if (!Number.isNaN(n)) base.data.amount = n;
	        }
	        // дефолт валюты, если нужна
	        if (!base.data.currency && hasCurrencyField) base.data.currency = currencies && currencies[0] || "RUB";
	        return base;
	    }
	
	    function submit() {
	        setErr(null);
	        setResp(null);
	        var miss = validate();
	        if (miss.length) {
	            setErr("Заполните обязательные поля: " + miss.join(", "));
	            return;
	        }
	        setSending(true);
	        api.uiExecute(buildPayload()).then(function (data) {
	            setResp(data);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setErr("Ошибка запроса");
	        }).finally(function () {
	            setSending(false);
	        });
	    }
	
	    // merchant picker (локальный фильтр)
	    function onMerchantInput(v) {
	        setMQuery(v);
	        var t = (v || "").toLowerCase().trim();
	        var src = allMerchants;
	        var out = !t ? src.slice(0, 15) : src.filter(function (m) {
	            return (m.name || "").toLowerCase().includes(t) || (m.uuid || "").toLowerCase().includes(t);
	        }).slice(0, 15);
	        setMList(out);
	    }
	
	    function pickMerchant(m) {
	        setMQuery(m.name);
	        setMList([]);
	        setPickerOpen(false);
	        onChangeField("merchantUuid", m.uuid);
	        onChangeField("apiKey", m.apiKey);
	        // авто-подстановка валюты из бэка (если доступна)
	        fetchPreferredCurrency(m.uuid);
	        // подгрузить последние транзакции мерчанта (для быстрой проверки)
	        loadRecentTx(m.uuid);
	        // автофокус на следующем обязательном поле
	        setTimeout(function () {
	            try {
	                var firstReq = fields.find(function (f) {
	                    return f.required && f.name !== "merchantUuid" && f.name !== "apiKey";
	                });
	                if (firstReq) {
	                    var el = document.querySelector('[data-field="' + firstReq.name + '"]');
	                    if (el) el.focus();
	                }
	            } catch (e) {}
	        }, 0);
	    }
	
	    function randomRef() {
	        var r = "order_" + Date.now();
	        onChangeField("externalReference", r);
	    }
	
	    function clearForm(keepCreds) {
	        setResp(null);
	        setErr(null);
	        setForm(function (p) {
	            var next = {};
	            if (keepCreds) {
	                if (p.merchantUuid) next.merchantUuid = p.merchantUuid;
	                if (p.apiKey) next.apiKey = p.apiKey;
	            }
	            return next;
	        });
	    }
	
	    function onOperationChange(v) {
	        setOperation(v);
	        setForm(function (p) {
	            var next = {};
	            if (p.merchantUuid) next.merchantUuid = p.merchantUuid;
	            if (p.apiKey) next.apiKey = p.apiKey;
	            return next;
	        });
	        setErr(null);
	        setResp(null);
	    }
	
	    function renderFields() {
	        if (!fields.length) {
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FormInfo },
	                "\u041F\u043E\u043B\u044F \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u044E\u0442\u0441\u044F."
	            );
	        }
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Grid },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Field, key: "merchantPicker", ref: pickerRef },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.Label },
	                    "1) \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 \u043F\u043E \u0438\u043C\u0435\u043D\u0438"
	                ),
	                _react2.default.createElement("input", {
	                    className: _stylesModule2.default.Input,
	                    type: "text",
	                    value: mQuery,
	                    placeholder: allMerchants.length ? "Начните вводить… (доступно: " + allMerchants.length + ")" : merchantsLoading ? "Идет загрузка…" : "Мерчанты не найдены",
	                    onChange: function onChange(e) {
	                        onMerchantInput(e.target.value);
	                    },
	                    onFocus: function onFocus() {
	                        setPickerOpen(true);
	                    },
	                    onClick: function onClick() {
	                        if (!pickerOpen) setPickerOpen(true);
	                    }
	                }),
	                _react2.default.createElement(
	                    AnimatePresence,
	                    null,
	                    pickerOpen && mList.length ? _react2.default.createElement(
	                        motion.div,
	                        {
	                            key: "drop",
	                            initial: { opacity: 0, y: -6 },
	                            animate: { opacity: 1, y: 0 },
	                            exit: { opacity: 0, y: -6 },
	                            transition: { duration: 0.18 },
	                            className: _stylesModule2.default.Drop
	                        },
	                        mList.map(function (m) {
	                            return _react2.default.createElement(
	                                "div",
	                                { key: m.id, className: _stylesModule2.default.DropItem, onClick: function onClick() {
	                                        pickMerchant(m);
	                                    } },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.DropTitle },
	                                    m.name
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.DropSub },
	                                    m.uuid
	                                )
	                            );
	                        })
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.FormInfo },
	                    "\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 \u0435\u0433\u043E UUID \u0438 API \u043A\u043B\u044E\u0447 \u043F\u043E\u0434\u0441\u0442\u0430\u0432\u044F\u0442\u0441\u044F \u0432 \u0444\u043E\u0440\u043C\u0443."
	                )
	            ),
	            fields.map(function (f) {
	                var v = Object.prototype.hasOwnProperty.call(form, f.name) ? form[f.name] : "";
	                var label = f.label || f.name;
	                var isSelect = f.type === "select";
	                var isNum = f.type === "number";
	                var req = !!f.required;
	                var placeholder = f.placeholder || (f.name === "merchantUuid" ? "uuid будет подставлен" : f.name === "apiKey" ? "apiKey будет подставлен" : "");
	
	                return _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Field, key: f.name },
	                    _react2.default.createElement(
	                        "label",
	                        { className: _stylesModule2.default.Label },
	                        label,
	                        req ? _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.Required },
	                            " *"
	                        ) : null
	                    ),
	                    isSelect ? _react2.default.createElement(
	                        "select",
	                        {
	                            className: _stylesModule2.default.Select,
	                            "data-field": f.name,
	                            value: v || "",
	                            onChange: function onChange(e) {
	                                onChangeField(f.name, e.target.value);
	                            }
	                        },
	                        _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435\u2026"
	                        ),
	                        (f.options || []).map(function (opt) {
	                            return _react2.default.createElement(
	                                "option",
	                                { key: opt, value: opt },
	                                opt
	                            );
	                        })
	                    ) : _react2.default.createElement("input", {
	                        className: _stylesModule2.default.Input,
	                        "data-field": f.name,
	                        type: isNum ? "number" : "text",
	                        value: v,
	                        placeholder: placeholder,
	                        onChange: function onChange(e) {
	                            onChangeField(f.name, e.target.value);
	                        }
	                    }),
	                    f.hint ? _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormInfo },
	                        f.hint
	                    ) : null
	                );
	            }),
	            provider === "hydracode" && isCreateOp ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FormInfo, style: { gridColumn: "1 / -1" } },
	                "\u0414\u043B\u044F Hydracode \u0432\u0432\u043E\u0434 \u043D\u043E\u043C\u0435\u0440\u0430 \u043A\u0430\u0440\u0442\u044B \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u2014 \u043F\u043E\u0441\u043B\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u0431\u0443\u0434\u0435\u0442 \u0440\u0435\u0434\u0438\u0440\u0435\u043A\u0442/\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u043E\u043F\u043B\u0430\u0442\u044B."
	            ) : null,
	            provider === "finstar" && operation === "create_tx_sbp" ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FormInfo, style: { gridColumn: "1 / -1" } },
	                "\u0414\u043B\u044F FinStar/\u0421\u0411\u041F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 ",
	                _react2.default.createElement(
	                    "b",
	                    null,
	                    "SBP Bank Member ID"
	                ),
	                " \u0438 ",
	                _react2.default.createElement(
	                    "b",
	                    null,
	                    "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
	                ),
	                "."
	            ) : null
	        );
	    }
	
	    // Ответ (нормализованный + raw)
	    var normalized = (0, _react.useMemo)(function () {
	        return resp && resp.normalized ? resp.normalized : null;
	    }, [resp]);
	    var raw = (0, _react.useMemo)(function () {
	        return resp && resp.raw ? resp.raw : resp;
	    }, [resp]);
	
	    // ready to show form only when base data loaded
	    var ready = !currLoading && !merchantsLoading;
	
	    // --------- helper loaders ---------
	    function LoaderCard() {
	        return _react2.default.createElement(
	            motion.div,
	            { initial: { opacity: 0, y: 6 }, animate: { opacity: 1, y: 0 }, className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Pre },
	                "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u043C \u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u043B\u044F \u0444\u043E\u0440\u043C\u044B\u2026"
	            )
	        );
	    }
	
	    // --------- backend helpers ---------
	    function fetchPreferredCurrency(uuid) {
	        if (!uuid) return;
	        api.client.get("/api/ui/merchant/" + uuid + "/preferred-currency").then(function (_ref3) {
	            var data = _ref3.data;
	
	            var c = data && (data.code || data.currency || data.Currency);
	            if (c) onChangeField("currency", String(c).toUpperCase());
	        }).catch(function (err) {
	            Sentry.captureException(err);
	        });
	    }
	
	    function loadRecentTx(uuid) {
	        if (!uuid) return;
	        setTxLoading(true);
	        api.client.get("/api/ui/transactions/latest", { params: { merchant: uuid, limit: 5 } }).then(function (_ref4) {
	            var data = _ref4.data;
	
	            var items = Array.isArray(data && data.items) ? data.items : [];
	            setRecentTx(items);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setRecentTx([]);
	        }).finally(function () {
	            setTxLoading(false);
	        });
	    }
	
	    function selectTx(t) {
	        var id = t && (t.id != null ? t.id : t.transactionId != null ? t.transactionId : "");
	        var ext = t && (t.externalReference != null ? t.externalReference : t.extRef != null ? t.extRef : "");
	        onChangeField("transactionId", id);
	        onChangeField("externalReference", ext);
	        setResp({ normalized: { message: "Транзакция выбрана из списка", id: id, externalReference: ext } });
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 1180 },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Wrap, style: centerWrapStyle },
	                        _react2.default.createElement(
	                            motion.div,
	                            {
	                                initial: { opacity: 0, scale: 0.98 },
	                                animate: { opacity: 1, scale: 1 },
	                                style: { width: "100%", maxWidth: 980 }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: _stylesModule2.default.PageTitle,
	                                    style: { textAlign: "center", marginBottom: 16 }
	                                },
	                                "Manager API Console"
	                            ),
	                            !ready ? _react2.default.createElement(LoaderCard, null) : _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                    motion.div,
	                                    {
	                                        className: _stylesModule2.default.Card,
	                                        initial: { opacity: 0, y: 8 },
	                                        animate: { opacity: 1, y: 0 }
	                                    },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.Row2 },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Field },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: _stylesModule2.default.Label },
	                                                "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440"
	                                            ),
	                                            _react2.default.createElement(
	                                                "select",
	                                                {
	                                                    className: _stylesModule2.default.Select,
	                                                    value: provider,
	                                                    onChange: function onChange(e) {
	                                                        setProvider(e.target.value);
	                                                    }
	                                                },
	                                                get(schema, "providers", []).map(function (p) {
	                                                    return _react2.default.createElement(
	                                                        "option",
	                                                        { key: p.key, value: p.key },
	                                                        p.label || p.key
	                                                    );
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Field },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: _stylesModule2.default.Label },
	                                                "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"
	                                            ),
	                                            _react2.default.createElement(
	                                                "select",
	                                                {
	                                                    className: _stylesModule2.default.Select,
	                                                    value: operation,
	                                                    onChange: function onChange(e) {
	                                                        onOperationChange(e.target.value);
	                                                    }
	                                                },
	                                                get(schema, "operations", []).map(function (op) {
	                                                    return _react2.default.createElement(
	                                                        "option",
	                                                        { key: op.key, value: op.key },
	                                                        op.label || op.key
	                                                    );
	                                                })
	                                            ),
	                                            current && current.hint ? _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.FormInfo, style: { marginTop: 6 } },
	                                                current.hint
	                                            ) : null
	                                        )
	                                    ),
	                                    _react2.default.createElement("div", { className: _stylesModule2.default.Separator }),
	                                    renderFields(),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.Actions },
	                                        _react2.default.createElement(
	                                            "button",
	                                            {
	                                                className: _stylesModule2.default.SecondaryBtn,
	                                                type: "button",
	                                                onClick: function onClick() {
	                                                    clearForm(true);
	                                                }
	                                            },
	                                            "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 (\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430)"
	                                        ),
	                                        isCreateOp ? _react2.default.createElement(
	                                            "button",
	                                            {
	                                                className: _stylesModule2.default.SecondaryBtn,
	                                                type: "button",
	                                                onClick: randomRef
	                                            },
	                                            "\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0439 reference"
	                                        ) : null,
	                                        _react2.default.createElement("div", { className: _stylesModule2.default.ActionsSpacer }),
	                                        _react2.default.createElement(
	                                            "button",
	                                            {
	                                                className: _stylesModule2.default.PrimaryBtn,
	                                                disabled: sending,
	                                                type: "button",
	                                                onClick: submit
	                                            },
	                                            sending ? "Отправка…" : "Отправить"
	                                        )
	                                    ),
	                                    err ? _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.Error },
	                                        err
	                                    ) : null
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.Row2, style: { marginTop: 16 } },
	                                    _react2.default.createElement(
	                                        motion.div,
	                                        {
	                                            className: _stylesModule2.default.Card,
	                                            style: { flex: 1 },
	                                            initial: { opacity: 0, y: 8 },
	                                            animate: { opacity: 1, y: 0 }
	                                        },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.BlockTitle },
	                                            "\u041E\u0442\u0432\u0435\u0442"
	                                        ),
	                                        !resp ? _react2.default.createElement(
	                                            "pre",
	                                            { className: _stylesModule2.default.Pre },
	                                            "\u041E\u0442\u0432\u0435\u0442 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0434\u0435\u0441\u044C"
	                                        ) : _react2.default.createElement(
	                                            "div",
	                                            null,
	                                            _react2.default.createElement(
	                                                "pre",
	                                                {
	                                                    className: _stylesModule2.default.Pre,
	                                                    style: { borderRadius: 8, padding: 12, fontSize: 13, overflow: "auto" }
	                                                },
	                                                pretty(normalized || resp)
	                                            ),
	                                            _react2.default.createElement(
	                                                "details",
	                                                { className: _stylesModule2.default.Details },
	                                                _react2.default.createElement(
	                                                    "summary",
	                                                    null,
	                                                    "RAW JSON"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "pre",
	                                                    {
	                                                        className: _stylesModule2.default.Pre,
	                                                        style: {
	                                                            borderRadius: 8,
	                                                            padding: 12,
	                                                            fontSize: 13,
	                                                            overflow: "auto"
	                                                        }
	                                                    },
	                                                    pretty(raw)
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    operation === "get_tx_status" ? _react2.default.createElement(
	                                        motion.div,
	                                        {
	                                            className: _stylesModule2.default.Card,
	                                            style: { flex: 1 },
	                                            initial: { opacity: 0, y: 8 },
	                                            animate: { opacity: 1, y: 0 }
	                                        },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.BlockTitle },
	                                            "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430"
	                                        ),
	                                        txLoading ? _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Pre },
	                                            "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026"
	                                        ) : !recentTx.length ? _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.FormInfo },
	                                            "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C 5 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0445 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439."
	                                        ) : _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.TableWrap },
	                                            _react2.default.createElement(
	                                                "table",
	                                                { className: _stylesModule2.default.Table },
	                                                _react2.default.createElement(
	                                                    "thead",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "tr",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            "th",
	                                                            null,
	                                                            "\u0414\u0430\u0442\u0430"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "th",
	                                                            null,
	                                                            "\u0421\u0443\u043C\u043C\u0430"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "th",
	                                                            null,
	                                                            "\u0412\u0430\u043B\u044E\u0442\u0430"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "th",
	                                                            null,
	                                                            "\u0422\u0438\u043F"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "th",
	                                                            null,
	                                                            "ID"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "th",
	                                                            null,
	                                                            "Reference"
	                                                        ),
	                                                        _react2.default.createElement("th", null)
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    "tbody",
	                                                    null,
	                                                    recentTx.map(function (t, idx) {
	                                                        var dt = (t.date || t.Date || "").toString();
	                                                        var amount = t.amountFloat != null ? t.amountFloat : t.amount;
	                                                        var curr = t.currency && (t.currency.code || t.currency) || "";
	                                                        var type = t.type && (t.type.name || t.type) || "";
	                                                        var id = t.id != null ? t.id : t.transactionId != null ? t.transactionId : "";
	                                                        var ext = t.externalReference != null ? t.externalReference : t.extRef != null ? t.extRef : "";
	                                                        return _react2.default.createElement(
	                                                            "tr",
	                                                            { key: idx },
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                dt
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                amount
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                curr
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                type
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                id
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                ext
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "td",
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    "button",
	                                                                    {
	                                                                        className: _stylesModule2.default.SecondaryBtn,
	                                                                        type: "button",
	                                                                        onClick: function onClick() {
	                                                                            selectTx(t);
	                                                                        }
	                                                                    },
	                                                                    "\u0412\u044B\u0431\u0440\u0430\u0442\u044C"
	                                                                )
	                                                            )
	                                                        );
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    ) : null
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(Console);

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _message = __webpack_require__(188);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _stylesModule = __webpack_require__(614);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var generator = {
	    generate: function generate(opts) {
	        var length = opts && opts.length || 10;
	        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
	        if (opts && opts.numbers) chars += "0123456789";
	        if (opts && opts.symbols) chars += "!@#$%^&*()_+-=";
	        var result = "";
	        var array = new Uint32Array(length);
	        window.crypto.getRandomValues(array);
	        for (var i = 0; i < length; i++) {
	            result += chars[array[i] % chars.length];
	        }
	        return result;
	    }
	};
	
	
	var Profile = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token,
	        logout = _ref.logout;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isLoading = _useState2[0],
	        setIsLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isOpenModal = _useState4[0],
	        setIsOpenModal = _useState4[1];
	
	    var _useState5 = (0, _react.useState)({}),
	        _useState6 = _slicedToArray(_useState5, 2),
	        message = _useState6[0],
	        setMessage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({ email: "", password: "", firstName: "", lastName: "", patronymic: "" }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        form = _useState8[0],
	        setForm = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        initEmail = _useState10[0],
	        setInitEmail = _useState10[1];
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getUserData().then(function (r) {
	            setForm(Object.assign({}, form, { email: r.email, firstName: r.firstName, lastName: r.lastName, patronymic: r.patronymic }));
	            setInitEmail(r.email);
	        });
	    }, [token]);
	
	    function generatePassword() {
	        setForm(Object.assign({}, form, {
	            password: generator.generate({
	                length: 10,
	                numbers: true,
	                symbols: true
	            })
	        }));
	    }
	
	    function cleanPassword() {
	        setForm(Object.assign({}, form, { password: "" }));
	    }
	
	    function onChangeForm(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function onModalClose() {
	        setIsOpenModal(false);
	        setIsLoading(false);
	    }
	
	    function confirmChanges() {
	        if (form.password || form.email !== initEmail) {
	            setIsOpenModal(true);
	        }
	    }
	
	    function saveChanges() {
	        setIsOpenModal(false);
	        setIsLoading(true);
	
	        new _Api2.default({ token: token }).setUserData(form).then(function (r) {
	            if (!r.error) {
	                if (form.password) {
	                    logout();
	                } else {
	                    setMessage({ type: "success",
	                        message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.success.save",
	                            defaultMessage: "\u0423\u0441\u043F\u0435\u0445. \u0412\u044B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438 \u0444\u043E\u0440\u043C\u0443." })
	                    });
	                    setIsLoading(false);
	                }
	            } else {
	                setMessage({ type: "error",
	                    message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.error.save",
	                        defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430. \u0412 \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u043E\u0448\u0438\u0431\u043A\u0438. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430." })
	                });
	                setIsLoading(false);
	            }
	        }).catch(function () {
	            // Ответ 422 раньше не ловился, и форма навсегда оставалась в загрузке.
	            setMessage({ type: "error",
	                message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.error.save",
	                    defaultMessage: "\u041E\u0448\u0438\u0431\u043A\u0430. \u0412 \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u043E\u0448\u0438\u0431\u043A\u0438. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430." })
	            });
	            setIsLoading(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.modal.title", defaultMessage: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445" }),
	                isOpen: isOpenModal,
	                onClose: onModalClose,
	                onConfirm: saveChanges,
	                isConfirm: true
	            },
	            form.password && _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.ModalText },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "Profile.text.changePassword",
	                    values: { password: _react2.default.createElement(
	                            "b",
	                            null,
	                            form.password
	                        ) },
	                    defaultMessage: "\u041F\u0430\u0440\u043E\u043B\u044C \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0412\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u0440\u0430\u0437\u043B\u043E\u0433\u0438\u043D\u0435\u043D\u044B \u043D\u0430 \u0432\u0441\u0435\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445. \u041F\u0435\u0440\u0435\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435\u043C \u0437\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0432 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C: {password}"
	                })
	            ),
	            form.email !== initEmail && _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.ModalText },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "Profile.text.changeEmail",
	                    values: { email: _react2.default.createElement(
	                            "b",
	                            null,
	                            form.email
	                        ) },
	                    defaultMessage: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 {email} \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u0441\u043B\u0430\u043D\u043E \u043F\u0438\u0441\u044C\u043C\u043E \u0441 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0438\u043C\u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F\u043C\u0438."
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: "center" } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: "Profile.title.myProfile" },
	                    _react2.default.createElement(_message2.default, { value: message }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.section.personal", defaultMessage: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" })
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.text.support",
	                                    defaultMessage: "\u0414\u043B\u044F \u0441\u043C\u0435\u043D\u044B \u0424\u0418\u041E \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443." })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: onChangeForm,
	                                    value: form.email,
	                                    placeholder: "example@email.ru",
	                                    fieldName: "email",
	                                    label: "FieldsHelper.label.email",
	                                    changeRegexp: /[^A-Za-z0-9\s_@.]+/g,
	                                    blurRegexp: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	                                    changeMessage: "FieldsHelper.error.charactersEmail",
	                                    blurMessage: "FieldsHelper.error.checkEmail",
	                                    isDisabled: isLoading
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: _stylesModule2.default.Label },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.label.lastName", defaultMessage: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F" })
	                                ),
	                                _react2.default.createElement("input", { className: _stylesModule2.default.Input, defaultValue: form.lastName, readOnly: true,
	                                    disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: _stylesModule2.default.Label },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.label.firstName", defaultMessage: "\u0418\u043C\u044F" })
	                                ),
	                                _react2.default.createElement("input", { className: _stylesModule2.default.Input, defaultValue: form.firstName, readOnly: true,
	                                    disabled: true })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: _stylesModule2.default.Label },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.label.patronymic", defaultMessage: "\u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E" })
	                                ),
	                                _react2.default.createElement("input", { className: _stylesModule2.default.Input, defaultValue: form.patronymic, readOnly: true,
	                                    disabled: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.section.password", defaultMessage: "\u0421\u043C\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F" })
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.text.logout",
	                                    defaultMessage: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043C\u0435\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044F \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0451\u0442 \u0432\u044B\u0445\u043E\u0434 \u0438\u0437 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043D\u0430 \u0432\u0441\u0435\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445." })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputHeader },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.label.password", defaultMessage: "\u041F\u0430\u0440\u043E\u043B\u044C" })
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        {
	                                            className: _stylesModule2.default.InputLink,
	                                            onClick: function onClick() {
	                                                return !isLoading && cleanPassword();
	                                            }
	                                        },
	                                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.LinkIcon, icon: "close", size: "12px" }),
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.link.cancel",
	                                            defaultMessage: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F" })
	                                    )
	                                ),
	                                _react2.default.createElement("input", {
	                                    className: _stylesModule2.default.Input,
	                                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
	                                    value: form.password,
	                                    readOnly: true,
	                                    disabled: isLoading
	                                }),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: _stylesModule2.default.Btn,
	                                        onClick: function onClick() {
	                                            return !isLoading && generatePassword();
	                                        }
	                                    },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.button.changePassword",
	                                        defaultMessage: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C" })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.SaveBtn,
	                            onClick: confirmChanges,
	                            disabled: isLoading
	                        },
	                        isLoading ? _react2.default.createElement(_Loader2.default, { isString: true }) : _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.BtnIcon, icon: "document-edit", size: "20px" }),
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.button.save",
	                                defaultMessage: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F" })
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = Profile;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _ProjectsFilters = __webpack_require__(373);
	
	var _ProjectsFilters2 = _interopRequireDefault(_ProjectsFilters);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _AdminFiltersToggle = __webpack_require__(42);
	
	var _AdminFiltersToggle2 = _interopRequireDefault(_AdminFiltersToggle);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ProjectsList = __webpack_require__(377);
	
	var _ProjectsList2 = _interopRequireDefault(_ProjectsList);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ProjectEditing = __webpack_require__(371);
	
	var _ProjectEditing2 = _interopRequireDefault(_ProjectEditing);
	
	var _ProjectAdd = __webpack_require__(369);
	
	var _ProjectAdd2 = _interopRequireDefault(_ProjectAdd);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _SearchTags = __webpack_require__(38);
	
	var _SearchTags2 = _interopRequireDefault(_SearchTags);
	
	var _stylesModule = __webpack_require__(615);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _stylesModule3 = __webpack_require__(44);
	
	var _stylesModule4 = _interopRequireDefault(_stylesModule3);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isOpenModal = _useState2[0],
	        setIsOpenModal = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(1),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currentProjectsPage = _useState4[0],
	        setCurrentProjectsPage = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(10),
	        _useState6 = _slicedToArray(_useState5, 2),
	        postsPerProjectsPage = _useState6[0],
	        setPostsPerProjectsPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(0),
	        _useState8 = _slicedToArray(_useState7, 2),
	        projectsListCount = _useState8[0],
	        setProjectsListCount = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        projectsList = _useState10[0],
	        setProjectsList = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({}),
	        _useState12 = _slicedToArray(_useState11, 2),
	        projectData = _useState12[0],
	        setProjectData = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(null),
	        _useState14 = _slicedToArray(_useState13, 2),
	        currentProjectUuid = _useState14[0],
	        setCurrentProjectUuid = _useState14[1];
	
	    var _useState15 = (0, _react.useState)('DESC'),
	        _useState16 = _slicedToArray(_useState15, 1),
	        projectsSort = _useState16[0];
	
	    var _useState17 = (0, _react.useState)({}),
	        _useState18 = _slicedToArray(_useState17, 2),
	        filterDate = _useState18[0],
	        setFilterDate = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        filters = _useState20[0],
	        setFilters = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(false),
	        _useState22 = _slicedToArray(_useState21, 2),
	        isFiltersOpen = _useState22[0],
	        setIsFiltersOpen = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(true),
	        _useState24 = _slicedToArray(_useState23, 2),
	        loadingProjectsList = _useState24[0],
	        setLoadingProjectsList = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(null),
	        _useState26 = _slicedToArray(_useState25, 2),
	        users = _useState26[0],
	        setUsers = _useState26[1];
	
	    var loadProjectsList = function loadProjectsList() {
	        var payload = {
	            page: currentProjectsPage,
	            itemsPerPage: postsPerProjectsPage,
	            order: projectsSort,
	            dateRange: filterDate,
	            filters: filters
	        };
	
	        setLoadingProjectsList(true);
	
	        new _Api2.default({ token: token }).getAccountsList({
	            page: 1,
	            itemsPerPage: 1000,
	            order: 'DESC'
	        }).then(function (r) {
	            setUsers(r.data);
	        });
	
	        new _Api2.default({ token: token }).getProjectsList(payload).then(function (r) {
	            setProjectsList(r.data);
	            setProjectsListCount(r.count);
	            setLoadingProjectsList(false);
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        loadProjectsList();
	    }, [filters, filterDate, currentProjectsPage, postsPerProjectsPage, projectsSort]);
	
	    function setPage(page, itemsPerPage) {
	        setCurrentProjectsPage(page || 1);
	        if (itemsPerPage) {
	            setPostsPerProjectsPage(itemsPerPage);
	        }
	    }
	
	    function onSelectProjectUuid(uuid) {
	        setCurrentProjectUuid(uuid);
	
	        new _Api2.default({ token: token }).getProjectData(uuid).then(function (r) {
	            setProjectData(r.info);
	        });
	    }
	
	    function onProjectAdd() {
	        setCurrentProjectsPage(1);
	        setIsOpenModal(false);
	        loadProjectsList();
	    }
	
	    var handleProjectSaved = function handleProjectSaved() {
	        loadProjectsList();
	    };
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Projects.modal.addTitle', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442' }),
	                onToggleModal: function onToggleModal() {
	                    return setIsOpenModal(!isOpenModal);
	                },
	                isOpen: isOpenModal,
	                onClose: function onClose() {
	                    return setIsOpenModal(false);
	                }
	            },
	            _react2.default.createElement(_ProjectAdd2.default, { token: token, onProjectAdd: onProjectAdd })
	        ),
	        _react2.default.createElement(
	            _Context2.default.Provider,
	            { value: { onSelectProjectUuid: onSelectProjectUuid } },
	            _react2.default.createElement(
	                _Layout.Container,
	                null,
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: '780', className: _stylesModule4.default.MainColumn },
	                    _react2.default.createElement(_AdminFiltersToggle2.default, { onClick: function onClick() {
	                            return setIsFiltersOpen(true);
	                        } }),
	                    _react2.default.createElement(_SearchTags2.default, {
	                        onChangeSearch: function onChangeSearch(tags) {
	                            var clean = tags.map(function (tag) {
	                                var clone = Object.assign({}, tag);
	                                delete clone.locale;
	                                return clone;
	                            });
	                            setFilters(clean);
	                            setCurrentProjectsPage(1);
	                        },
	                        onSearch: function onSearch() {
	                            return loadProjectsList();
	                        },
	                        isDisabled: false,
	                        defaultSearch: {
	                            key: 'name',
	                            locale: 'Search.label.projectName',
	                            placeholder: 'Search.placeholder.projectName'
	                        },
	                        searchBy: [{
	                            key: 'name',
	                            locale: 'Search.label.projectName',
	                            placeholder: 'Search.placeholder.projectName'
	                        }, { key: 'url', locale: 'Search.label.url', placeholder: 'Search.placeholder.url' }, {
	                            key: 'description',
	                            locale: 'Search.label.description',
	                            placeholder: 'Search.placeholder.description'
	                        }, { key: 'uuid', locale: 'Search.label.uuid', placeholder: 'Search.placeholder.uuid' }]
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Card },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Header },
	                            _react2.default.createElement(
	                                'h5',
	                                { className: _stylesModule2.default.Title },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ProjectsControl.title.projects', defaultMessage: '\u041F\u0440\u043E\u0435\u043A\u0442\u044B' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.Btn, onClick: function onClick() {
	                                        return setIsOpenModal(!isOpenModal);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: 'add-outline', size: '16px' }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Projects.button.add', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C' })
	                            )
	                        ),
	                        _react2.default.createElement(_ProjectsList2.default, {
	                            isLoading: loadingProjectsList,
	                            data: projectsList,
	                            currentUuid: currentProjectUuid
	                        }),
	                        postsPerProjectsPage < projectsListCount && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.PaginationWrap },
	                            _react2.default.createElement(_reactJsPagination2.default, {
	                                firstPageText: '\u21E4',
	                                prevPageText: '\u21E0',
	                                lastPageText: '\u21E5',
	                                nextPageText: '\u21E2',
	                                activeLinkClass: _stylesModule2.default.ActiveLink,
	                                activePage: currentProjectsPage,
	                                itemsCountPerPage: postsPerProjectsPage,
	                                totalItemsCount: projectsListCount,
	                                pageRangeDisplayed: 5,
	                                onChange: function onChange(page) {
	                                    return setPage(page, postsPerProjectsPage);
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(_ProjectEditing2.default, {
	                        project: projectData,
	                        token: token,
	                        uuid: currentProjectUuid,
	                        usersList: users,
	                        onProjectSaved: handleProjectSaved
	                    })
	                ),
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: '350', className: _stylesModule4.default.SidebarColumn },
	                    _react2.default.createElement(
	                        _ResponsiveSidebarFilters2.default,
	                        {
	                            title: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B',
	                            isOpen: isFiltersOpen,
	                            onClose: function onClose() {
	                                return setIsFiltersOpen(false);
	                            }
	                        },
	                        _react2.default.createElement(
	                            _EmptyCard2.default,
	                            null,
	                            _react2.default.createElement(_DateRange2.default, {
	                                onSelectDate: function onSelectDate(range) {
	                                    setFilterDate(range || {});
	                                    setCurrentProjectsPage(1);
	                                },
	                                defaultPeriod: 'zero'
	                            })
	                        ),
	                        _react2.default.createElement(_ProjectsFilters2.default, {
	                            isLoading: loadingProjectsList,
	                            onApplyFilters: function onApplyFilters(newFilters) {
	                                setFilters(newFilters || []);
	                                setCurrentProjectsPage(1);
	                                setIsFiltersOpen(false);
	                            }
	                        })
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = Projects;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _xlsx = __webpack_require__(65);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _stylesModule = __webpack_require__(616);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// --- Auto-detect provider format by column names ---
	// NX (PayCraft/CraftLite) — файлы с колонкой "ID операции мерчанта"
	// Flacon (Hydracode/HydraLite) — два формата:
	//   - формат с "Reference id" + "amount" (lowercase) — матчим по provider order ID
	//   - формат с "Reference id" + "Amount" (capital) + payment_NNNNN — матчим по нашему ID
	
	function detectFormat(workbook) {
	    for (var i = 0; i < workbook.SheetNames.length; i++) {
	        var sheet = workbook.Sheets[workbook.SheetNames[i]];
	        var data = XLSX.utils.sheet_to_json(sheet, { defval: "", header: 1 });
	        if (data.length === 0) continue;
	        var headers = data[0];
	        if (!headers) continue;
	        var headerStr = headers.join("|");
	
	        // NX: has "ID операции мерчанта"
	        if (headerStr.indexOf("ID операции мерчанта") !== -1) return "nx";
	        // Flacon format 2: has "Reference id" + "Amount" (capital A) — Platon/PAY2 terminal
	        if (headerStr.indexOf("Reference id") !== -1 && headerStr.indexOf("Amount") !== -1) return "flacon_pay2";
	        // Flacon format 1: has "Reference id" + "amount" (lowercase)
	        if (headerStr.indexOf("Reference id") !== -1 && headerStr.indexOf("amount") !== -1) return "flacon_ref";
	    }
	    return null;
	}
	
	var FORMAT_LABELS = {
	    nx: "NX (PayCraft)",
	    flacon_ref: "Flacon (Hydracode)",
	    flacon_pay2: "Flacon (Hydracode / PAY2)"
	};
	
	function parseNX(workbook) {
	    var rows = [];
	    for (var i = 0; i < workbook.SheetNames.length; i++) {
	        var sheet = workbook.Sheets[workbook.SheetNames[i]];
	        var data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
	        for (var j = 0; j < data.length; j++) {
	            var r = data[j];
	            var id = r["ID операции мерчанта"];
	            var amount = parseFloat(r["Сумма в RUB"]);
	            if (id && !isNaN(amount)) {
	                rows.push({ id: String(id), amount: amount, date: r["Дата и время"] || "" });
	            }
	        }
	    }
	    return rows;
	}
	
	function parseFlaconRef(workbook) {
	    var rows = [];
	    for (var i = 0; i < workbook.SheetNames.length; i++) {
	        var sheet = workbook.Sheets[workbook.SheetNames[i]];
	        var data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
	        for (var j = 0; j < data.length; j++) {
	            var r = data[j];
	            var refId = r["Reference id"];
	            var amount = parseFloat(r["amount"]);
	            if (refId && !isNaN(amount)) {
	                rows.push({ id: String(refId), amount: amount, date: r["date"] || "" });
	            }
	        }
	    }
	    return rows;
	}
	
	function parseFlaconPay2(workbook) {
	    var rows = [];
	    var sheetNames = workbook.SheetNames;
	    var targetSheets = [];
	    for (var i = 0; i < sheetNames.length; i++) {
	        if (sheetNames[i].toLowerCase().indexOf("transaction") !== -1) {
	            targetSheets.push(sheetNames[i]);
	        }
	    }
	    if (targetSheets.length === 0) targetSheets = sheetNames;
	
	    for (var si = 0; si < targetSheets.length; si++) {
	        var sheet = workbook.Sheets[targetSheets[si]];
	        var data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
	        for (var j = 0; j < data.length; j++) {
	            var r = data[j];
	            var refId = r["Reference id"] || "";
	            var amount = parseFloat(r["Amount"]);
	            var match = String(refId).match(/payment_(\d+)/);
	            var id = match ? match[1] : "";
	            if (id && !isNaN(amount)) {
	                rows.push({ id: id, amount: amount, date: r["Created"] || "" });
	            }
	        }
	    }
	    return rows;
	}
	
	var PARSERS = {
	    nx: parseNX,
	    flacon_ref: parseFlaconRef,
	    flacon_pay2: parseFlaconPay2
	};
	
	// NX и Flacon PAY2 — матчим по нашему transaction ID
	// Flacon ref — матчим по provider order ID (вторая часть processingOrderId)
	function buildOurIndex(transactions, format) {
	    var index = {};
	    for (var i = 0; i < transactions.length; i++) {
	        var tx = transactions[i];
	        if (format === "flacon_ref") {
	            // processingOrderId = "ourId|providerOrderId"
	            var parts = (tx.processingOrderId || "").split("|");
	            var key = parts.length > 1 ? parts[1] : "";
	            if (key) {
	                index[key] = tx;
	            }
	        } else {
	            // NX, Flacon PAY2 — match by our transaction ID
	            if (tx.id) {
	                index[String(tx.id)] = tx;
	            }
	        }
	    }
	    return index;
	}
	
	function reconcile(providerRows, ourTransactions, format) {
	    var ourIndex = buildOurIndex(ourTransactions, format);
	
	    var matched = [];
	    var onlyInFile = [];
	    var amountMismatch = [];
	
	    var matchedOurKeys = {};
	
	    for (var i = 0; i < providerRows.length; i++) {
	        var row = providerRows[i];
	        var ourTx = ourIndex[row.id];
	        if (!ourTx) {
	            onlyInFile.push({ providerRow: row });
	        } else {
	            var key = format === "flacon_ref" ? function () {
	                var p = (ourTx.processingOrderId || "").split("|");return p.length > 1 ? p[1] : "";
	            }() : String(ourTx.id);
	            matchedOurKeys[key] = true;
	
	            var ourAmount = parseFloat(ourTx.amount) || 0;
	            var theirAmount = row.amount;
	            if (Math.abs(ourAmount - theirAmount) > 0.01) {
	                amountMismatch.push({ providerRow: row, ourTx: ourTx, ourAmount: ourAmount, theirAmount: theirAmount });
	            } else {
	                matched.push({ providerRow: row, ourTx: ourTx });
	            }
	        }
	    }
	
	    // Transactions we have but not in file
	    var onlyInOurs = [];
	    var keys = Object.keys(ourIndex);
	    for (var k = 0; k < keys.length; k++) {
	        if (!matchedOurKeys[keys[k]]) {
	            onlyInOurs.push({ ourTx: ourIndex[keys[k]] });
	        }
	    }
	
	    return {
	        matched: matched,
	        onlyInOurs: onlyInOurs,
	        onlyInFile: onlyInFile,
	        amountMismatch: amountMismatch
	    };
	}
	
	// Load all pages of transactions
	function loadAllTransactions(api, dateRange, page, accumulated, callback, onError) {
	    var ITEMS_PER_PAGE = 500;
	    var payload = {
	        filters: [],
	        dateRange: {
	            startDate: dateRange.startDate,
	            endDate: dateRange.endDate
	        },
	        page: page,
	        itemsPerPage: ITEMS_PER_PAGE
	    };
	
	    api.setTransactionsFilters(payload).then(function (r) {
	        var data = r && r.data ? r.data : [];
	        var all = accumulated.concat(data);
	        var totalCount = r && r.count && r.count.total ? Number(r.count.total.count) : 0;
	
	        if (all.length < totalCount && data.length > 0) {
	            loadAllTransactions(api, dateRange, page + 1, all, callback, onError);
	        } else {
	            callback(all);
	        }
	    }).catch(function (err) {
	        onError(err);
	    });
	}
	
	var Reconciliation = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	    var onMessage = (0, _react.useContext)(_MessageContext2.default).onMessage;
	
	    var _filterDate = (0, _react.useState)({});
	    var filterDate = _filterDate[0];
	    var setFilterDate = _filterDate[1];
	
	    var _file = (0, _react.useState)(null);
	    var file = _file[0];
	    var setFile = _file[1];
	
	    var _drag = (0, _react.useState)(false);
	    var drag = _drag[0];
	    var setDrag = _drag[1];
	
	    var _loading = (0, _react.useState)(false);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _result = (0, _react.useState)(null);
	    var result = _result[0];
	    var setResult = _result[1];
	
	    var _activeTab = (0, _react.useState)("onlyInOurs");
	    var activeTab = _activeTab[0];
	    var setActiveTab = _activeTab[1];
	
	    var _detectedProvider = (0, _react.useState)(null);
	    var detectedProvider = _detectedProvider[0];
	    var setDetectedProvider = _detectedProvider[1];
	
	    var dateFrom = filterDate.startDate || "";
	    var dateTo = filterDate.endDate || "";
	
	    // File handling
	    function handleFile(f) {
	        if (!f) return;
	        var ext = f.name.split(".").pop().toLowerCase();
	        if (ext !== "xlsx" && ext !== "xls") {
	            onMessage({ type: "error", message: "Поддерживаются только файлы .xlsx / .xls" });
	            return;
	        }
	        setFile(f);
	        setResult(null);
	    }
	
	    function onDragStart(e) {
	        e.preventDefault();setDrag(true);
	    }
	    function onDragLeave(e) {
	        e.preventDefault();setDrag(false);
	    }
	    function onDrop(e) {
	        e.preventDefault();
	        setDrag(false);
	        var files = e.dataTransfer && e.dataTransfer.files;
	        if (files && files.length > 0) handleFile(files[0]);
	    }
	    function onClickUpload() {
	        var input = document.createElement("input");
	        input.type = "file";
	        input.accept = ".xlsx,.xls";
	        input.onchange = function (e) {
	            if (e.target && e.target.files && e.target.files.length > 0) {
	                handleFile(e.target.files[0]);
	            }
	        };
	        input.click();
	    }
	
	    function removeFile() {
	        setFile(null);
	        setResult(null);
	        setDetectedProvider(null);
	    }
	
	    // Reconciliation
	    function handleReconcile() {
	        if (!file) {
	            onMessage({ type: "error", message: "Загрузите файл" });
	            return;
	        }
	        if (!dateFrom || !dateTo) {
	            onMessage({ type: "error", message: "Выберите период" });
	            return;
	        }
	
	        setLoading(true);
	        setResult(null);
	
	        // 1. Parse Excel
	        var reader = new FileReader();
	        reader.onload = function (e) {
	            var data = new Uint8Array(e.target.result);
	            var workbook;
	            try {
	                workbook = XLSX.read(data, { type: "array" });
	            } catch (err) {
	                setLoading(false);
	                onMessage({ type: "error", message: "Ошибка чтения файла: " + err.message });
	                return;
	            }
	
	            var format = detectFormat(workbook);
	            if (!format) {
	                setLoading(false);
	                onMessage({ type: "error", message: "Не удалось определить формат файла. Поддерживаются: NX, Flacon." });
	                return;
	            }
	            setDetectedProvider(format);
	
	            var parser = PARSERS[format];
	            var providerRows;
	            try {
	                providerRows = parser(workbook);
	            } catch (err) {
	                setLoading(false);
	                onMessage({ type: "error", message: "Ошибка парсинга: " + err.message });
	                return;
	            }
	
	            if (providerRows.length === 0) {
	                setLoading(false);
	                onMessage({ type: "warning", message: "Не найдено транзакций в файле. Проверьте формат." });
	                return;
	            }
	
	            // 2. Load our transactions
	            var api = new _Api2.default({ token: token });
	            loadAllTransactions(api, { startDate: dateFrom, endDate: dateTo }, 1, [], function (ourTransactions) {
	                // 3. Reconcile
	                var res = reconcile(providerRows, ourTransactions, format);
	                setResult(res);
	                setActiveTab(res.onlyInOurs.length > 0 ? "onlyInOurs" : res.onlyInFile.length > 0 ? "onlyInFile" : res.amountMismatch.length > 0 ? "amountMismatch" : "matched");
	                setLoading(false);
	            }, function () {
	                setLoading(false);
	                onMessage({ type: "error", message: "Ошибка загрузки транзакций" });
	            });
	        };
	        reader.readAsArrayBuffer(file);
	    }
	
	    var _search = (0, _react.useState)("");
	    var search = _search[0];
	    var setSearch = _search[1];
	
	    var TAB_DESCRIPTIONS = {
	        matched: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438, \u043D\u0430\u0439\u0434\u0435\u043D\u043D\u044B\u0435 \u0438 \u0443 \u043D\u0430\u0441, \u0438 \u0432 \u0444\u0430\u0439\u043B\u0435 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430. \u0421\u0443\u043C\u043C\u044B \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442 (\u0434\u043E\u043F\u0443\u0441\u043A \xB10.01).",
	        onlyInOurs: "Транзакции, которые есть в нашей системе за выбранный период, но отсутствуют в загруженном файле провайдера. Возможная причина: провайдер не учёл транзакцию или она прошла через другой канал.",
	        onlyInFile: "Транзакции из файла провайдера, которые не найдены в нашей системе. Возможная причина: транзакция не была зарегистрирована у нас или ID не совпадает.",
	        amountMismatch: "Транзакции найдены с обеих сторон, но суммы отличаются. Требуется ручная проверка."
	    };
	
	    function filterItems(items) {
	        if (!search) return items;
	        var q = search.toLowerCase();
	        return items.filter(function (item) {
	            var parts = [];
	            if (item.ourTx) {
	                parts.push(String(item.ourTx.id));
	                parts.push(String(item.ourTx.amount));
	                parts.push(item.ourTx.merchantName || "");
	                parts.push(item.ourTx.status || "");
	            }
	            if (item.providerRow) {
	                parts.push(String(item.providerRow.id));
	                parts.push(String(item.providerRow.amount));
	                parts.push(item.providerRow.date || "");
	            }
	            if (item.ourAmount != null) parts.push(String(item.ourAmount));
	            if (item.theirAmount != null) parts.push(String(item.theirAmount));
	            return parts.join(" ").toLowerCase().indexOf(q) !== -1;
	        });
	    }
	
	    function handleExportExcel() {
	        if (!result) return;
	        var wb = XLSX.utils.book_new();
	
	        // Sheet 1: Совпало
	        if (result.matched.length > 0) {
	            var matchedData = result.matched.map(function (item) {
	                return {
	                    "Наш ID": item.ourTx.id,
	                    "ID в файле": item.providerRow.id,
	                    "Сумма": (parseFloat(item.ourTx.amount) || 0).toFixed(2),
	                    "Мерчант": item.ourTx.merchantName || "",
	                    "Дата (файл)": item.providerRow.date
	                };
	            });
	            XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(matchedData), "Совпало (" + result.matched.length + ")");
	        }
	
	        // Sheet 2: Только у нас
	        if (result.onlyInOurs.length > 0) {
	            var onlyOursData = result.onlyInOurs.map(function (item) {
	                var tx = item.ourTx;
	                return {
	                    "ID": tx.id,
	                    "Сумма": (parseFloat(tx.amount) || 0).toFixed(2),
	                    "Дата": tx.date || "",
	                    "Статус": tx.status || "",
	                    "Мерчант": tx.merchantName || ""
	                };
	            });
	            XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(onlyOursData), "Только у нас (" + result.onlyInOurs.length + ")");
	        }
	
	        // Sheet 3: Только в реестре
	        if (result.onlyInFile.length > 0) {
	            var onlyFileData = result.onlyInFile.map(function (item) {
	                return {
	                    "ID в файле": item.providerRow.id,
	                    "Сумма": item.providerRow.amount.toFixed(2),
	                    "Дата": item.providerRow.date
	                };
	            });
	            XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(onlyFileData), "Только в реестре (" + result.onlyInFile.length + ")");
	        }
	
	        // Sheet 4: Расхождение суммы
	        if (result.amountMismatch.length > 0) {
	            var mismatchData = result.amountMismatch.map(function (item) {
	                return {
	                    "ID": item.ourTx.id,
	                    "Наша сумма": item.ourAmount.toFixed(2),
	                    "Сумма в файле": item.theirAmount.toFixed(2),
	                    "Разница": (item.ourAmount - item.theirAmount).toFixed(2),
	                    "Мерчант": item.ourTx.merchantName || "",
	                    "Дата (файл)": item.providerRow.date
	                };
	            });
	            XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(mismatchData), "Расхождение (" + result.amountMismatch.length + ")");
	        }
	
	        // Summary sheet
	        var summaryData = [{ "Категория": "Совпало", "Количество": result.matched.length }, { "Категория": "Только у нас", "Количество": result.onlyInOurs.length }, { "Категория": "Только в реестре", "Количество": result.onlyInFile.length }, { "Категория": "Расхождение суммы", "Количество": result.amountMismatch.length }, { "Категория": "", "Количество": "" }, { "Категория": "Провайдер", "Количество": FORMAT_LABELS[detectedProvider] || "" }, { "Категория": "Период", "Количество": dateFrom + " — " + dateTo }, { "Категория": "Файл", "Количество": file ? file.name : "" }];
	        var summarySheet = XLSX.utils.json_to_sheet(summaryData);
	        XLSX.utils.book_append_sheet(wb, summarySheet, "Итого");
	
	        var filename = "Сверка_" + (dateFrom || "").replace(/[^0-9]/g, "") + "_" + (dateTo || "").replace(/[^0-9]/g, "") + ".xlsx";
	        XLSX.writeFile(wb, filename);
	    }
	
	    function renderTable() {
	        if (!result) return null;
	
	        var items = filterItems(result[activeTab] || []);
	
	        if (items.length === 0 && !search) {
	            return _react2.default.createElement("div", { className: "text-center text-muted py-4" }, "Нет записей");
	        }
	        if (items.length === 0 && search) {
	            return _react2.default.createElement("div", { className: "text-center text-muted py-4" }, "Ничего не найдено по запросу \"" + search + "\"");
	        }
	
	        if (activeTab === "matched") {
	            return _react2.default.createElement("div", { style: { overflowX: "auto" } }, _react2.default.createElement("table", { className: "table table-hover table-sm" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "Наш ID"), _react2.default.createElement("th", null, "ID в файле"), _react2.default.createElement("th", null, "Сумма"), _react2.default.createElement("th", null, "Мерчант"), _react2.default.createElement("th", null, "Дата (файл)"))), _react2.default.createElement("tbody", null, items.map(function (item, idx) {
	                return _react2.default.createElement("tr", { key: idx }, _react2.default.createElement("td", null, item.ourTx.id), _react2.default.createElement("td", null, item.providerRow.id), _react2.default.createElement("td", null, (parseFloat(item.ourTx.amount) || 0).toFixed(2)), _react2.default.createElement("td", null, item.ourTx.merchantName || ""), _react2.default.createElement("td", { style: { whiteSpace: "nowrap" } }, item.providerRow.date));
	            }))));
	        }
	
	        if (activeTab === "onlyInOurs") {
	            return _react2.default.createElement("div", { style: { overflowX: "auto" } }, _react2.default.createElement("table", { className: "table table-hover table-sm" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "ID"), _react2.default.createElement("th", null, "Сумма"), _react2.default.createElement("th", null, "Дата"), _react2.default.createElement("th", null, "Статус"), _react2.default.createElement("th", null, "Мерчант"))), _react2.default.createElement("tbody", null, items.map(function (item, idx) {
	                var tx = item.ourTx;
	                return _react2.default.createElement("tr", { key: idx }, _react2.default.createElement("td", null, tx.id), _react2.default.createElement("td", null, (parseFloat(tx.amount) || 0).toFixed(2)), _react2.default.createElement("td", { style: { whiteSpace: "nowrap" } }, tx.date ? new Date(tx.date).toLocaleString("ru-RU") : ""), _react2.default.createElement("td", null, tx.status || ""), _react2.default.createElement("td", null, tx.merchantName || ""));
	            }))));
	        }
	
	        if (activeTab === "onlyInFile") {
	            return _react2.default.createElement("div", { style: { overflowX: "auto" } }, _react2.default.createElement("table", { className: "table table-hover table-sm" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "ID в файле"), _react2.default.createElement("th", null, "Сумма"), _react2.default.createElement("th", null, "Дата"))), _react2.default.createElement("tbody", null, items.map(function (item, idx) {
	                return _react2.default.createElement("tr", { key: idx }, _react2.default.createElement("td", null, item.providerRow.id), _react2.default.createElement("td", null, item.providerRow.amount.toFixed(2)), _react2.default.createElement("td", null, item.providerRow.date));
	            }))));
	        }
	
	        if (activeTab === "amountMismatch") {
	            return _react2.default.createElement("div", { style: { overflowX: "auto" } }, _react2.default.createElement("table", { className: "table table-hover table-sm" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "ID"), _react2.default.createElement("th", null, "Наша сумма"), _react2.default.createElement("th", null, "Сумма в файле"), _react2.default.createElement("th", null, "Разница"), _react2.default.createElement("th", null, "Мерчант"), _react2.default.createElement("th", null, "Дата (файл)"))), _react2.default.createElement("tbody", null, items.map(function (item, idx) {
	                var diff = item.ourAmount - item.theirAmount;
	                return _react2.default.createElement("tr", { key: idx }, _react2.default.createElement("td", null, item.ourTx.id), _react2.default.createElement("td", null, item.ourAmount.toFixed(2)), _react2.default.createElement("td", null, item.theirAmount.toFixed(2)), _react2.default.createElement("td", { className: diff > 0 ? "text-success" : "text-danger" }, (diff > 0 ? "+" : "") + diff.toFixed(2)), _react2.default.createElement("td", null, item.ourTx.merchantName || ""), _react2.default.createElement("td", { style: { whiteSpace: "nowrap" } }, item.providerRow.date));
	            }))));
	        }
	
	        return null;
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.ReconciliationWrapper },
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.containerFluid },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-12 pt-2" },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        "\u0421\u0432\u0435\u0440\u043A\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-muted mb-3", style: { fontSize: ".85rem" } },
	                        "\u0421\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u043C\u0435\u0436\u0434\u0443 \u043D\u0430\u0448\u0435\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439 \u0438 \u0440\u0435\u0435\u0441\u0442\u0440\u043E\u043C \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430. \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 Excel-\u0444\u0430\u0439\u043B \u043E\u0442 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0435\u0440\u0438\u043E\u0434 \u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u0421\u0432\u0435\u0440\u0438\u0442\u044C\xBB. \u0424\u043E\u0440\u043C\u0430\u0442 \u0444\u0430\u0439\u043B\u0430 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 (NX, Flacon)."
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FiltersCard },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FiltersRow },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.FilterGroup },
	                                _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                                        setFilterDate(range);setResult(null);
	                                    }, defaultPeriod: "week" })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.FilterGroup },
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: "btn btn-primary " + _stylesModule2.default.ReconcileBtn,
	                                        onClick: handleReconcile,
	                                        disabled: loading || !file || !dateFrom || !dateTo
	                                    },
	                                    loading ? "Сверка..." : "Сверить"
	                                )
	                            )
	                        )
	                    ),
	                    !file ? _react2.default.createElement(
	                        "div",
	                        {
	                            className: _stylesModule2.default.UploadZone + (drag ? " " + _stylesModule2.default.UploadZoneDrag : ""),
	                            onClick: onClickUpload,
	                            onDrop: onDrop,
	                            onDragStart: onDragStart,
	                            onDragLeave: onDragLeave,
	                            onDragOver: onDragStart
	                        },
	                        "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 Excel-\u0444\u0430\u0439\u043B \u043E\u0442 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430"
	                    ) : _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FileName },
	                        file.name,
	                        _react2.default.createElement(
	                            "span",
	                            { className: _stylesModule2.default.FileRemove, onClick: removeFile, title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" },
	                            "\xD7"
	                        )
	                    ),
	                    loading && _react2.default.createElement(_Loader2.default, null),
	                    result && !loading && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "d-flex justify-content-between align-items-center mb-2" },
	                            detectedProvider && _react2.default.createElement(
	                                "span",
	                                { className: "text-muted", style: { fontSize: ".85rem" } },
	                                "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440: ",
	                                _react2.default.createElement(
	                                    "b",
	                                    null,
	                                    FORMAT_LABELS[detectedProvider] || detectedProvider
	                                ),
	                                " \xB7 ",
	                                "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0432 \u0444\u0430\u0439\u043B\u0435: ",
	                                _react2.default.createElement(
	                                    "b",
	                                    null,
	                                    result.matched.length + result.onlyInFile.length + result.amountMismatch.length
	                                ),
	                                " \xB7 ",
	                                "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0443 \u043D\u0430\u0441: ",
	                                _react2.default.createElement(
	                                    "b",
	                                    null,
	                                    result.matched.length + result.onlyInOurs.length + result.amountMismatch.length
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: "btn btn-outline-success btn-sm",
	                                    onClick: handleExportExcel,
	                                    style: { whiteSpace: "nowrap" }
	                                },
	                                "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 Excel"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SummaryRow },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: _stylesModule2.default.summaryCard + (activeTab === "matched" ? " " + _stylesModule2.default.summaryCardActive : ""),
	                                    onClick: function onClick() {
	                                        setActiveTab("matched");setSearch("");
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "small",
	                                    null,
	                                    "\u0421\u043E\u0432\u043F\u0430\u043B\u043E"
	                                ),
	                                _react2.default.createElement(
	                                    "h5",
	                                    { className: "text-success" },
	                                    result.matched.length
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: _stylesModule2.default.summaryCard + (activeTab === "onlyInOurs" ? " " + _stylesModule2.default.summaryCardActive : ""),
	                                    onClick: function onClick() {
	                                        setActiveTab("onlyInOurs");setSearch("");
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "small",
	                                    null,
	                                    "\u0422\u043E\u043B\u044C\u043A\u043E \u0443 \u043D\u0430\u0441"
	                                ),
	                                _react2.default.createElement(
	                                    "h5",
	                                    { className: result.onlyInOurs.length > 0 ? "text-danger" : "" },
	                                    result.onlyInOurs.length
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: _stylesModule2.default.summaryCard + (activeTab === "onlyInFile" ? " " + _stylesModule2.default.summaryCardActive : ""),
	                                    onClick: function onClick() {
	                                        setActiveTab("onlyInFile");setSearch("");
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "small",
	                                    null,
	                                    "\u0422\u043E\u043B\u044C\u043A\u043E \u0432 \u0440\u0435\u0435\u0441\u0442\u0440\u0435"
	                                ),
	                                _react2.default.createElement(
	                                    "h5",
	                                    { className: result.onlyInFile.length > 0 ? "text-danger" : "" },
	                                    result.onlyInFile.length
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: _stylesModule2.default.summaryCard + (activeTab === "amountMismatch" ? " " + _stylesModule2.default.summaryCardActive : ""),
	                                    onClick: function onClick() {
	                                        setActiveTab("amountMismatch");setSearch("");
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "small",
	                                    null,
	                                    "\u0420\u0430\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0435 \u0441\u0443\u043C\u043C\u044B"
	                                ),
	                                _react2.default.createElement(
	                                    "h5",
	                                    { className: result.amountMismatch.length > 0 ? "text-warning" : "" },
	                                    result.amountMismatch.length
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.tabDescription },
	                            TAB_DESCRIPTIONS[activeTab]
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "mb-2" },
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                className: "form-control form-control-sm",
	                                placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E ID, \u0441\u0443\u043C\u043C\u0435, \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0443...",
	                                value: search,
	                                onChange: function onChange(e) {
	                                    setSearch(e.target.value);
	                                },
	                                style: { maxWidth: 350 }
	                            })
	                        ),
	                        renderTable()
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = Reconciliation;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _stylesModule = __webpack_require__(617);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _json2csv = __webpack_require__(115);
	
	var _xlsx = __webpack_require__(65);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportConstructor = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        filterDate = _useState2[0],
	        setFilterDate = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        projects = _useState4[0],
	        setProjects = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        selectedProject = _useState6[0],
	        setSelectedProject = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        isLoading = _useState8[0],
	        setIsLoading = _useState8[1];
	
	    var _useState9 = (0, _react.useState)('csv'),
	        _useState10 = _slicedToArray(_useState9, 2),
	        format = _useState10[0],
	        setFormat = _useState10[1];
	
	    // Комиссия провайдера
	
	
	    var _useState11 = (0, _react.useState)('0.3'),
	        _useState12 = _slicedToArray(_useState11, 2),
	        providerCost = _useState12[0],
	        setProviderCost = _useState12[1];
	
	    var _useState13 = (0, _react.useState)('30'),
	        _useState14 = _slicedToArray(_useState13, 2),
	        providerCostFixedMinimum = _useState14[0],
	        setProviderCostFixedMinimum = _useState14[1];
	
	    // Тип отчёта
	
	
	    var _useState15 = (0, _react.useState)('transaction'),
	        _useState16 = _slicedToArray(_useState15, 2),
	        reportType = _useState16[0],
	        setReportType = _useState16[1]; // transaction | merchant
	
	    (0, _react.useEffect)(function () {
	        setIsLoading(true);
	        new _Api2.default({ token: token }).getProjectsList({ page: 1, itemsPerPage: 10000 }).then(function (data) {
	            var items = data.items || data.data || [];
	            var list = items.map(function (p) {
	                return {
	                    uuid: p.uuid,
	                    displayName: p.name
	                };
	            });
	            setProjects(list);
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            console.error(e);
	        }).finally(function () {
	            return setIsLoading(false);
	        });
	    }, []);
	
	    function formatMoney(n) {
	        if (typeof n !== 'number') n = Number(n || 0);
	        return n.toFixed(2).replace('.', ',');
	    }
	
	    function formatPercent(p) {
	        if (typeof p !== 'number') p = Number(p || 0);
	        return String(p).replace('.', ',');
	    }
	
	    function makeCSV(data, name) {
	        if (!Array.isArray(data) || data.length === 0) {
	            alert('Данных для отчёта нет');
	            return;
	        }
	
	        var universalBOM = '\uFEFF';
	        var fields = reportType === 'transaction' ? ['Мерчант', 'Терминал', 'id транзакции', 'Сумма транзакции', 'Комиссия', 'Прибыль (%)', 'Прибыль(рубли)'] : ['Мерчант', 'Терминал', 'Кол-во транзакций', 'Сумма транзакций', 'Сумма комиссии', 'Прибыль (%)', 'Прибыль(рубли)'];
	
	        var parser = new _json2csv.Parser({ delimiter: ';', fields: fields });
	        var csv = parser.parse(data);
	
	        var a = document.createElement('a');
	        a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csv);
	        a.download = (name || 'report') + '.csv';
	        a.click();
	    }
	
	    function makeExcel(data, name, fmt) {
	        if (!Array.isArray(data) || data.length === 0) {
	            alert('Данных для отчёта нет');
	            return;
	        }
	
	        var worksheet = XLSX.utils.json_to_sheet(data);
	        var workbook = XLSX.utils.book_new();
	        XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
	
	        var wbout = XLSX.write(workbook, { bookType: fmt, type: 'array' });
	        var blob = new Blob([wbout], {
	            type: fmt === 'xlsx' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/vnd.ms-excel'
	        });
	
	        var a = document.createElement('a');
	        a.href = URL.createObjectURL(blob);
	        a.download = (name || 'report') + '.' + fmt;
	        a.click();
	        URL.revokeObjectURL(a.href);
	    }
	
	    function onCreateReport() {
	        if (!filterDate || Array.isArray(filterDate) && filterDate.length < 2) {
	            alert('Выберите период');
	            return;
	        }
	        if (!selectedProject || selectedProject.length === 0) {
	            alert('Выберите проекты');
	            return;
	        }
	
	        var from = filterDate.from || filterDate.startDate || filterDate[0];
	        var to = filterDate.to || filterDate.endDate || filterDate[1];
	        var projectUuids = selectedProject;
	
	        var cost = parseFloat(providerCost);
	        var minCost = parseFloat(providerCostFixedMinimum);
	
	        if (isNaN(cost) || isNaN(minCost) || cost < 0 || minCost < 0) {
	            alert('Введите корректные значения комиссии провайдера');
	            return;
	        }
	
	        var filter = {
	            from: from,
	            to: to,
	            projectUuids: projectUuids,
	            providerCost: cost,
	            providerCostFixedMinimum: minCost
	        };
	
	        setIsLoading(true);
	
	        if (reportType === 'transaction') {
	            new _Api2.default({ token: token }).getProviderSummary(filter).then(function (data) {
	                if (!Array.isArray(data)) {
	                    console.error('Invalid response format:', data);
	                    alert('Ошибка при формировании отчёта');
	                    return;
	                }
	
	                var rows = data.map(function (item) {
	                    return {
	                        Мерчант: item.merchant || 'Не указан',
	                        Терминал: item.terminal || 'Не указан',
	                        'id транзакции': item.tx_id,
	                        'Сумма транзакции': formatMoney(item.amount),
	                        Комиссия: formatMoney(item.fee),
	                        'Прибыль (%)': formatPercent(item.profit_percent),
	                        'Прибыль(рубли)': formatMoney(item.profit)
	                    };
	                });
	
	                var fileName = 'provider_report_transaction';
	
	                if (format === 'csv') {
	                    makeCSV(rows, fileName);
	                } else {
	                    makeExcel(rows, fileName, format);
	                }
	            }).catch(function (error) {
	                Sentry.captureException(error);
	                console.error('Ошибка при получении отчёта:', error);
	                alert('Ошибка при формировании отчёта');
	            }).finally(function () {
	                return setIsLoading(false);
	            });
	        } else {
	            new _Api2.default({ token: token }).getProviderSummaryMerchant(filter).then(function (data) {
	                if (!Array.isArray(data)) {
	                    console.error('Invalid response format:', data);
	                    alert('Ошибка при формировании отчёта');
	                    return;
	                }
	
	                var rows = data.map(function (item) {
	                    return {
	                        Мерчант: item.merchant || 'Не указан',
	                        Терминал: item.terminal || 'Не указан',
	                        'Кол-во транзакций': item.tx_count,
	                        'Сумма транзакций': formatMoney(item.amount),
	                        'Сумма комиссии': formatMoney(item.fee),
	                        'Прибыль (%)': formatPercent(item.profit_percent),
	                        'Прибыль(рубли)': formatMoney(item.profit)
	                    };
	                });
	
	                var fileName = 'provider_report_merchant';
	
	                if (format === 'csv') {
	                    makeCSV(rows, fileName);
	                } else {
	                    makeExcel(rows, fileName, format);
	                }
	            }).catch(function (error) {
	                Sentry.captureException(error);
	                console.error('Ошибка при получении отчёта:', error);
	                alert('Ошибка при формировании отчёта');
	            }).finally(function () {
	                return setIsLoading(false);
	            });
	        }
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '1150' },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: 'ReportConstructor.label.reportConstructor' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_10per },
	                            _react2.default.createElement(_Button2.default, {
	                                label: 'ReportConstructor.label.period',
	                                isDisabled: true,
	                                type: 'text',
	                                style: { fontWeight: 'bold', cursor: 'default' }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_30per },
	                            _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                                    return setFilterDate(range);
	                                }, defaultPeriod: 'month' })
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_10per },
	                            _react2.default.createElement(_Button2.default, {
	                                label: 'ReportConstructor.label.merchant',
	                                isDisabled: true,
	                                type: 'text',
	                                style: { fontWeight: 'bold', cursor: 'default' }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_30per },
	                            _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                                label: 'ReportConstructor.label.selectMerchant',
	                                placeholder: 'ReportConstructor.label.selectMerchant',
	                                values: projects,
	                                selectedValues: selectedProject,
	                                isLoading: isLoading,
	                                onChange: setSelectedProject,
	                                excludeSearchColumn: []
	                            })
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_10per },
	                            _react2.default.createElement(_Button2.default, {
	                                label: 'ReportConstructor.label.reportType',
	                                isDisabled: true,
	                                type: 'text',
	                                style: { fontWeight: 'bold', cursor: 'default' }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_30per },
	                            _react2.default.createElement(
	                                'select',
	                                {
	                                    value: reportType,
	                                    onChange: function onChange(e) {
	                                        return setReportType(e.target.value);
	                                    },
	                                    className: _stylesModule2.default.Select,
	                                    disabled: isLoading
	                                },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'transaction' },
	                                    '\u041F\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F\u043C'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'merchant' },
	                                    '\u041F\u043E \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\u043C'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_10per },
	                            _react2.default.createElement(_Button2.default, {
	                                label: 'ReportConstructor.label.providerFee',
	                                isDisabled: true,
	                                type: 'text',
	                                style: { fontWeight: 'bold', cursor: 'default', whiteSpace: 'nowrap' }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_30per },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { display: 'flex', gap: '8px', alignItems: 'center' } },
	                                _react2.default.createElement('input', {
	                                    type: 'number',
	                                    step: '0.01',
	                                    min: '0',
	                                    value: providerCost,
	                                    onChange: function onChange(e) {
	                                        return setProviderCost(e.target.value);
	                                    },
	                                    placeholder: '0.3',
	                                    style: {
	                                        width: '80px',
	                                        padding: '6px 8px',
	                                        border: '1px solid #ccc',
	                                        borderRadius: '4px',
	                                        fontSize: '14px'
	                                    },
	                                    disabled: isLoading
	                                }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '% \u043E\u0442 \u0441\u0443\u043C\u043C\u044B'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_10per },
	                            _react2.default.createElement(_Button2.default, {
	                                label: 'ReportConstructor.label.minFee',
	                                isDisabled: true,
	                                type: 'text',
	                                style: { fontWeight: 'bold', cursor: 'default', whiteSpace: 'nowrap' }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_30per },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { display: 'flex', gap: '8px', alignItems: 'center' } },
	                                _react2.default.createElement('input', {
	                                    type: 'number',
	                                    step: '0.01',
	                                    min: '0',
	                                    value: providerCostFixedMinimum,
	                                    onChange: function onChange(e) {
	                                        return setProviderCostFixedMinimum(e.target.value);
	                                    },
	                                    placeholder: '30',
	                                    style: {
	                                        width: '80px',
	                                        padding: '6px 8px',
	                                        border: '1px solid #ccc',
	                                        borderRadius: '4px',
	                                        fontSize: '14px'
	                                    },
	                                    disabled: isLoading
	                                }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\u0440\u0443\u0431\u043B\u0435\u0439'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_10per },
	                            _react2.default.createElement(_Button2.default, {
	                                label: 'ReportConstructor.label.format',
	                                isDisabled: true,
	                                type: 'text',
	                                style: { fontWeight: 'bold', cursor: 'default' }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Col_30per },
	                            _react2.default.createElement(
	                                'select',
	                                {
	                                    value: format,
	                                    onChange: function onChange(e) {
	                                        return setFormat(e.target.value);
	                                    },
	                                    className: _stylesModule2.default.Select,
	                                    disabled: isLoading
	                                },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'csv' },
	                                    'CSV'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'xls' },
	                                    'XLS'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'xlsx' },
	                                    'XLSX'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Footer },
	                        _react2.default.createElement(_Button2.default, {
	                            onClick: onCreateReport,
	                            label: 'ReportConstructor.btn.createReport',
	                            icon: 'file-excel',
	                            iconSize: '17px',
	                            isLoading: isLoading
	                        })
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = ReportConstructor;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _SecretChat = __webpack_require__(183);
	
	var _SecretChat2 = _interopRequireDefault(_SecretChat);
	
	var _styles = __webpack_require__(208);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Секретные чаты со стороны сотрудника.
	 *
	 * Отличий от клиентской страницы два: видны разговоры всех клиентов, и в
	 * списке первым идёт имя клиента — сотруднику важно, с кем говорит, а не
	 * только о чём. Переписка та же: шифруется на сервере и живёт сутки.
	 */
	function AdminSecretChats(_ref) {
	    var onCreate = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	            var topic, created;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            e.preventDefault();
	
	                            topic = subject.trim();
	
	                            if (!(!topic || !accountId || isCreating)) {
	                                _context2.next = 4;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 4:
	
	                            setIsCreating(true);
	                            _context2.prev = 5;
	                            _context2.next = 8;
	                            return new _Api2.default({ token: token }).createAdminSecretChat(Number(accountId), topic, firstMessage.trim() || undefined);
	
	                        case 8:
	                            created = _context2.sent;
	
	                            if (mountedRef.current) {
	                                _context2.next = 11;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 11:
	                            setSubject('');
	                            setFirstMessage('');
	                            setAccountId('');
	                            setSelected(null);
	                            setQuery('');
	                            setError(null);
	                            setIsFormOpen(false);
	                            _context2.next = 20;
	                            return loadChats();
	
	                        case 20:
	                            if (created && created.id) setActiveId(created.id);
	                            _context2.next = 28;
	                            break;
	
	                        case 23:
	                            _context2.prev = 23;
	                            _context2.t0 = _context2['catch'](5);
	
	                            if (mountedRef.current) {
	                                _context2.next = 27;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 27:
	                            setError(intl.formatMessage({ id: 'SecretChats.error.create', defaultMessage: 'Не удалось создать чат' }));
	
	                        case 28:
	                            _context2.prev = 28;
	
	                            if (mountedRef.current) setIsCreating(false);
	                            return _context2.finish(28);
	
	                        case 31:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[5, 23, 28, 31]]);
	        }));
	
	        return function onCreate(_x) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    var token = _ref.token;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        chats = _useState2[0],
	        setChats = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(24),
	        _useState4 = _slicedToArray(_useState3, 2),
	        ttlHours = _useState4[0],
	        setTtlHours = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activeId = _useState6[0],
	        setActiveId = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(true),
	        _useState8 = _slicedToArray(_useState7, 2),
	        isLoading = _useState8[0],
	        setIsLoading = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        error = _useState10[0],
	        setError = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isFormOpen = _useState12[0],
	        setIsFormOpen = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(''),
	        _useState14 = _slicedToArray(_useState13, 2),
	        query = _useState14[0],
	        setQuery = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        accounts = _useState16[0],
	        setAccounts = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(''),
	        _useState18 = _slicedToArray(_useState17, 2),
	        accountId = _useState18[0],
	        setAccountId = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(null),
	        _useState20 = _slicedToArray(_useState19, 2),
	        selected = _useState20[0],
	        setSelected = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(''),
	        _useState22 = _slicedToArray(_useState21, 2),
	        subject = _useState22[0],
	        setSubject = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(''),
	        _useState24 = _slicedToArray(_useState23, 2),
	        firstMessage = _useState24[0],
	        setFirstMessage = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        isCreating = _useState26[0],
	        setIsCreating = _useState26[1];
	
	    var mountedRef = (0, _react.useRef)(true);
	
	    (0, _react.useEffect)(function () {
	        mountedRef.current = true;
	        return function () {
	            mountedRef.current = false;
	        };
	    }, []);
	
	    var loadChats = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return new _Api2.default({ token: token }).listAdminSecretChats();
	
	                    case 3:
	                        data = _context.sent;
	
	                        if (mountedRef.current) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 6:
	                        setChats(data && data.items || []);
	                        if (data && data.ttlHours) setTtlHours(data.ttlHours);
	                        setError(null);
	                        _context.next = 16;
	                        break;
	
	                    case 11:
	                        _context.prev = 11;
	                        _context.t0 = _context['catch'](0);
	
	                        if (mountedRef.current) {
	                            _context.next = 15;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 15:
	                        setError(intl.formatMessage({
	                            id: 'SecretChats.error.list',
	                            defaultMessage: 'Не удалось загрузить список чатов'
	                        }));
	
	                    case 16:
	                        _context.prev = 16;
	
	                        if (mountedRef.current) setIsLoading(false);
	                        return _context.finish(16);
	
	                    case 19:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[0, 11, 16, 19]]);
	    })), [token, intl]);
	
	    (0, _react.useEffect)(function () {
	        loadChats();
	        var timer = setInterval(loadChats, 15000);
	        return function () {
	            return clearInterval(timer);
	        };
	    }, [loadChats]);
	
	    (0, _react.useEffect)(function () {
	        if (!isFormOpen) return undefined;
	
	        var cancelled = false;
	
	        // Поиск клиента ждёт паузы в наборе: без задержки запрос уходил бы
	        // на каждую букву.
	        var timer = setTimeout(function () {
	            new _Api2.default({ token: token }).listAdminSecretChatAccounts(query.trim()).then(function (data) {
	                if (cancelled || !mountedRef.current) return;
	                setAccounts(data && data.items || []);
	            }).catch(function () {});
	        }, 300);
	
	        return function () {
	            cancelled = true;
	            clearTimeout(timer);
	        };
	    }, [token, query, isFormOpen]);
	
	    var loadMessages = (0, _react.useCallback)(function (id) {
	        return new _Api2.default({ token: token }).getAdminSecretChatMessages(id);
	    }, [token]);
	    var sendMessage = (0, _react.useCallback)(function (id, body, files) {
	        return new _Api2.default({ token: token }).postAdminSecretChatMessage(id, body, files).then(function (data) {
	            loadChats();
	            return data;
	        });
	    }, [token, loadChats]);
	    // Файл скачивается запросом с токеном: у простой ссылки нет заголовка
	    // авторизации, и сервер ответил бы отказом.
	    var downloadFile = (0, _react.useCallback)(function (chatId, fileId) {
	        return new _Api2.default({ token: token }).downloadSecretChatFile(chatId, fileId, true);
	    }, [token]);
	
	    var markRead = (0, _react.useCallback)(function (id) {
	        new _Api2.default({ token: token }).readAdminSecretChat(id).then(loadChats).catch(function () {});
	    }, [token, loadChats]);
	
	    var active = chats.find(function (c) {
	        return c.id === activeId;
	    }) || null;
	    // У части аккаунтов имя и фамилия не заполнены — тогда в списке
	    // показывается логин, иначе строка выглядела бы пустой.
	    var clientName = function clientName(chat) {
	        return chat.client ? chat.client.name || chat.client.username : '';
	    };
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '1180' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Head },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: _styles2.default.Title },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChats.admin.title', defaultMessage: '\u0421\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0447\u0430\u0442\u044B' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _styles2.default.Subtitle },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'SecretChats.subtitle',
	                            defaultMessage: '\u041F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0430 \u0448\u0438\u0444\u0440\u0443\u0435\u0442\u0441\u044F \u0438 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0443\u0434\u0430\u043B\u044F\u0435\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 {hours} \u0447\u0430\u0441\u0430',
	                            values: { hours: ttlHours }
	                        })
	                    )
	                ),
	                error ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Error },
	                    error
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Board },
	                    _react2.default.createElement(_SecretChat.ChatList, {
	                        chats: chats,
	                        activeId: activeId,
	                        isLoading: isLoading,
	                        onPick: setActiveId,
	                        onNew: function onNew() {
	                            return setIsFormOpen(true);
	                        },
	                        titleOf: clientName,
	                        subtitleOf: function subtitleOf(chat) {
	                            return chat.subject;
	                        }
	                    }),
	                    _react2.default.createElement(_SecretChat2.default, {
	                        chat: active,
	                        side: 'admin',
	                        ttlHours: ttlHours,
	                        loadMessages: loadMessages,
	                        sendMessage: sendMessage,
	                        onRead: markRead,
	                        downloadFile: downloadFile,
	                        titleOf: function titleOf(chat) {
	                            return clientName(chat) + ' \u2014 ' + chat.subject;
	                        }
	                    })
	                ),
	                isFormOpen ? _react2.default.createElement(
	                    'div',
	                    {
	                        className: _styles2.default.Overlay,
	                        onClick: function onClick(e) {
	                            if (e.target === e.currentTarget) setIsFormOpen(false);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'form',
	                        { className: _styles2.default.Dialog, onSubmit: onCreate },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.DialogTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.button.new', defaultMessage: '\u041D\u043E\u0432\u044B\u0439 \u0447\u0430\u0442' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.Picker },
	                            _react2.default.createElement('input', {
	                                className: _styles2.default.Field,
	                                value: selected ? selected.name ? selected.name + ' (' + selected.username + ')' : selected.username : query,
	                                autoFocus: true,
	                                placeholder: intl.formatMessage({
	                                    id: 'SecretChats.field.client',
	                                    defaultMessage: 'Клиент: начните вводить имя или логин'
	                                }),
	                                onChange: function onChange(e) {
	                                    setSelected(null);
	                                    setAccountId('');
	                                    setQuery(e.target.value);
	                                }
	                            }),
	                            selected ? _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: _styles2.default.PickerClear,
	                                    title: intl.formatMessage({
	                                        id: 'SecretChats.button.clearClient',
	                                        defaultMessage: 'Выбрать другого'
	                                    }),
	                                    onClick: function onClick() {
	                                        setSelected(null);
	                                        setAccountId('');
	                                        setQuery('');
	                                    }
	                                },
	                                '\xD7'
	                            ) : null,
	                            !selected && accounts.length > 0 ? _react2.default.createElement(
	                                'div',
	                                { className: _styles2.default.Suggestions },
	                                accounts.map(function (account) {
	                                    return _react2.default.createElement(
	                                        'button',
	                                        {
	                                            type: 'button',
	                                            key: account.id,
	                                            className: _styles2.default.Suggestion,
	                                            onClick: function onClick() {
	                                                setSelected(account);
	                                                setAccountId(String(account.id));
	                                            }
	                                        },
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _styles2.default.SuggestionName },
	                                            account.name || account.username
	                                        ),
	                                        account.name ? _react2.default.createElement(
	                                            'span',
	                                            { className: _styles2.default.SuggestionLogin },
	                                            account.username
	                                        ) : null
	                                    );
	                                })
	                            ) : null
	                        ),
	                        _react2.default.createElement('input', {
	                            className: _styles2.default.Field,
	                            value: subject,
	                            maxLength: 200,
	                            placeholder: intl.formatMessage({
	                                id: 'SecretChats.field.subject',
	                                defaultMessage: 'Тема разговора'
	                            }),
	                            onChange: function onChange(e) {
	                                return setSubject(e.target.value);
	                            }
	                        }),
	                        _react2.default.createElement('textarea', {
	                            className: _styles2.default.Field,
	                            value: firstMessage,
	                            rows: 3,
	                            maxLength: 20000,
	                            placeholder: intl.formatMessage({
	                                id: 'SecretChats.field.first',
	                                defaultMessage: 'Первое сообщение (необязательно)'
	                            }),
	                            onChange: function onChange(e) {
	                                return setFirstMessage(e.target.value);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.DialogButtons },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: _styles2.default.Cancel,
	                                    onClick: function onClick() {
	                                        return setIsFormOpen(false);
	                                    }
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChats.button.cancel', defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0430' })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: _styles2.default.Create,
	                                    disabled: isCreating || !subject.trim() || !accountId
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChats.button.create', defaultMessage: '\u041D\u0430\u0447\u0430\u0442\u044C \u0447\u0430\u0442' })
	                            )
	                        )
	                    )
	                ) : null
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(AdminSecretChats);

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _MerchantTerminalSelect = __webpack_require__(57);
	
	var _MerchantTerminalSelect2 = _interopRequireDefault(_MerchantTerminalSelect);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(618);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATUS_LABELS = {
	    0: "Создан",
	    1: "Подтверждён",
	    2: "Отменён"
	};
	
	function getStatusBadgeClass(status) {
	    switch (status) {
	        case 0:
	            return _stylesModule2.default.BadgeCreated;
	        case 1:
	            return _stylesModule2.default.BadgeConfirmed;
	        case 2:
	            return _stylesModule2.default.BadgeCancelled;
	        default:
	            return _stylesModule2.default.Badge;
	    }
	}
	
	function formatAmount(amountInKopecks) {
	    if (amountInKopecks === null || amountInKopecks === undefined) return "0.00";
	    return (Number(amountInKopecks) / 100).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
	
	function formatDate(dateStr) {
	    if (!dateStr) return "\u2014";
	    try {
	        var d = new Date(dateStr);
	        return d.toLocaleString("ru-RU");
	    } catch (e) {
	        return dateStr;
	    }
	}
	
	var Settlement = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	    var onMessage = (0, _react.useContext)(_MessageContext2.default).onMessage;
	
	    // List state
	    var _settlements = (0, _react.useState)([]);
	    var settlements = _settlements[0];
	    var setSettlements = _settlements[1];
	
	    var _count = (0, _react.useState)(0);
	    var count = _count[0];
	    var setCount = _count[1];
	
	    var _loading = (0, _react.useState)(false);
	    var loading = _loading[0];
	    var setLoading = _loading[1];
	
	    var _page = (0, _react.useState)(1);
	    var page = _page[0];
	    var setPage = _page[1];
	
	    var _terminalId = (0, _react.useState)("");
	    var terminalId = _terminalId[0];
	    var setTerminalId = _terminalId[1];
	
	    var _statusFilter = (0, _react.useState)("");
	    var statusFilter = _statusFilter[0];
	    var setStatusFilter = _statusFilter[1];
	
	    // Detail state
	    var _selectedSettlement = (0, _react.useState)(null);
	    var selectedSettlement = _selectedSettlement[0];
	    var setSelectedSettlement = _selectedSettlement[1];
	
	    var _detailLoading = (0, _react.useState)(false);
	    var detailLoading = _detailLoading[0];
	    var setDetailLoading = _detailLoading[1];
	
	    // Create wizard state
	    var _showCreate = (0, _react.useState)(false);
	    var showCreate = _showCreate[0];
	    var setShowCreate = _showCreate[1];
	
	    var _createTerminalId = (0, _react.useState)("");
	    var createTerminalId = _createTerminalId[0];
	    var setCreateTerminalId = _createTerminalId[1];
	
	    var _createDateRange = (0, _react.useState)({});
	    var createDateRange = _createDateRange[0];
	    var setCreateDateRange = _createDateRange[1];
	
	    var _createComment = (0, _react.useState)("");
	    var createComment = _createComment[0];
	    var setCreateComment = _createComment[1];
	
	    var _previewData = (0, _react.useState)(null);
	    var previewData = _previewData[0];
	    var setPreviewData = _previewData[1];
	
	    var _previewLoading = (0, _react.useState)(false);
	    var previewLoading = _previewLoading[0];
	    var setPreviewLoading = _previewLoading[1];
	
	    var _creating = (0, _react.useState)(false);
	    var creating = _creating[0];
	    var setCreating = _creating[1];
	
	    var _createUsdtRate = (0, _react.useState)("");
	    var createUsdtRate = _createUsdtRate[0];
	    var setCreateUsdtRate = _createUsdtRate[1];
	
	    var _createFile = (0, _react.useState)(null);
	    var createFile = _createFile[0];
	    var setCreateFile = _createFile[1];
	
	    // Excluded transaction IDs
	    var _excludedIds = (0, _react.useState)({});
	    var excludedIds = _excludedIds[0];
	    var setExcludedIds = _excludedIds[1];
	
	    // Add/remove transactions state
	    var _selectedTxIds = (0, _react.useState)({});
	    var selectedTxIds = _selectedTxIds[0];
	    var setSelectedTxIds = _selectedTxIds[1];
	
	    var _removeLoading = (0, _react.useState)(false);
	    var removeLoading = _removeLoading[0];
	    var setRemoveLoading = _removeLoading[1];
	
	    var _showAddModal = (0, _react.useState)(false);
	    var showAddModal = _showAddModal[0];
	    var setShowAddModal = _showAddModal[1];
	
	    var _addMode = (0, _react.useState)("id");
	    var addMode = _addMode[0];
	    var setAddMode = _addMode[1];
	
	    var _addIdInput = (0, _react.useState)("");
	    var addIdInput = _addIdInput[0];
	    var setAddIdInput = _addIdInput[1];
	
	    var _addSearchFilters = (0, _react.useState)({ dateFrom: "", dateTo: "", amountMin: "", amountMax: "" });
	    var addSearchFilters = _addSearchFilters[0];
	    var setAddSearchFilters = _addSearchFilters[1];
	
	    var _addSearchResults = (0, _react.useState)([]);
	    var addSearchResults = _addSearchResults[0];
	    var setAddSearchResults = _addSearchResults[1];
	
	    var _addSelectedIds = (0, _react.useState)({});
	    var addSelectedIds = _addSelectedIds[0];
	    var setAddSelectedIds = _addSelectedIds[1];
	
	    var _addLoading = (0, _react.useState)(false);
	    var addLoading = _addLoading[0];
	    var setAddLoading = _addLoading[1];
	
	    // Cancel state
	    var _cancelId = (0, _react.useState)(null);
	    var cancelId = _cancelId[0];
	    var setCancelId = _cancelId[1];
	
	    var _cancelReason = (0, _react.useState)("");
	    var cancelReason = _cancelReason[0];
	    var setCancelReason = _cancelReason[1];
	
	    var _cancelling = (0, _react.useState)(false);
	    var cancelling = _cancelling[0];
	    var setCancelling = _cancelling[1];
	
	    var perPage = 20;
	
	    // Load settlements list
	    (0, _react.useEffect)(function () {
	        loadSettlements();
	    }, [page, terminalId, statusFilter, token]);
	
	    function loadSettlements() {
	        setLoading(true);
	        var filters = {
	            page: page,
	            limit: perPage
	        };
	        if (terminalId) filters.terminal_id = terminalId;
	        if (statusFilter !== "") filters.status = statusFilter;
	
	        new _Api2.default({ token: token }).getSettlements(filters).then(function (r) {
	            setSettlements(Array.isArray(r.data) ? r.data : []);
	            setCount(typeof r.count === "number" ? r.count : 0);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setSettlements([]);
	            setCount(0);
	            setLoading(false);
	            onMessage({ type: "error", message: "Ошибка загрузки списка расчётов" });
	        });
	    }
	
	    function loadDetail(id) {
	        setDetailLoading(true);
	        new _Api2.default({ token: token }).getSettlementDetail(id).then(function (r) {
	            setSelectedSettlement(r.data || r);
	            setDetailLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setDetailLoading(false);
	            onMessage({ type: "error", message: "Ошибка загрузки деталей расчёта" });
	        });
	    }
	
	    function onPreview() {
	        if (!createTerminalId) {
	            onMessage({ type: "error", message: "Укажите ID терминала" });
	            return;
	        }
	        setPreviewLoading(true);
	        setExcludedIds({});
	        var data = {
	            terminal_id: Number(createTerminalId)
	        };
	        if (createDateRange.startDate) data.date_from = createDateRange.startDate;
	        if (createDateRange.endDate) data.date_to = createDateRange.endDate;
	
	        new _Api2.default({ token: token }).previewSettlement(data).then(function (r) {
	            setPreviewData(r.data || r);
	            setPreviewLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setPreviewLoading(false);
	            onMessage({ type: "error", message: "Ошибка при превью расчёта" });
	        });
	    }
	
	    function onCreate() {
	        if (!createTerminalId) return;
	        if (!previewData || !Array.isArray(previewData.transactions) || previewData.transactions.length === 0) {
	            onMessage({ type: "error", message: "Сначала выполните предпросмотр" });
	            return;
	        }
	        setCreating(true);
	        var transactionIds = previewData.transactions.filter(function (tx) {
	            return !excludedIds[tx.id];
	        }).map(function (tx) {
	            return tx.id;
	        });
	        if (transactionIds.length === 0) {
	            onMessage({ type: "error", message: "Все транзакции исключены" });
	            setCreating(false);
	            return;
	        }
	        var api = new _Api2.default({ token: token });
	        var promise;
	
	        if (createFile) {
	            var formData = new FormData();
	            formData.append("terminal_id", Number(createTerminalId));
	            formData.append("transaction_ids", JSON.stringify(transactionIds));
	            formData.append("comment", createComment || "");
	            if (createUsdtRate) formData.append("usdt_rate", createUsdtRate);
	            formData.append("payment_proof", createFile);
	            promise = api.createSettlementMultipart(formData);
	        } else {
	            var data = {
	                terminal_id: Number(createTerminalId),
	                transaction_ids: transactionIds,
	                comment: createComment || ""
	            };
	            if (createUsdtRate) data.usdt_rate = createUsdtRate;
	            promise = api.createSettlement(data);
	        }
	
	        promise.then(function () {
	            setCreating(false);
	            setShowCreate(false);
	            setPreviewData(null);
	            setCreateTerminalId("");
	            setCreateDateRange({});
	            setCreateComment("");
	            setCreateUsdtRate("");
	            setCreateFile(null);
	            setExcludedIds({});
	            setPage(1);
	            loadSettlements();
	            onMessage({ type: "success", message: "Расчёт успешно создан" });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setCreating(false);
	            onMessage({ type: "error", message: "Ошибка при создании расчёта" });
	        });
	    }
	
	    function onCancel() {
	        if (!cancelId) return;
	        setCancelling(true);
	        var currentCancelId = cancelId;
	        new _Api2.default({ token: token }).cancelSettlement(currentCancelId, { reason: cancelReason }).then(function () {
	            setCancelling(false);
	            setCancelId(null);
	            setCancelReason("");
	            if (selectedSettlement && selectedSettlement.id === currentCancelId) {
	                loadDetail(currentCancelId);
	            }
	            loadSettlements();
	            onMessage({ type: "success", message: "Расчёт отменён" });
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setCancelling(false);
	            onMessage({ type: "error", message: "Ошибка при отмене расчёта" });
	        });
	    }
	
	    function onRowClick(settlement) {
	        loadDetail(settlement.id);
	    }
	
	    function onBackToList() {
	        setSelectedSettlement(null);
	        setSelectedTxIds({});
	    }
	
	    function onRemoveTransactions(ids) {
	        if (!selectedSettlement) return;
	        setRemoveLoading(true);
	        new _Api2.default({ token: token }).removeSettlementTransactions(selectedSettlement.id, ids).then(function (r) {
	            setSelectedSettlement(r);
	            setSelectedTxIds({});
	            setRemoveLoading(false);
	            loadSettlements();
	            onMessage({ type: "success", message: "Транзакции удалены из расчёта" });
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            setRemoveLoading(false);
	            var msg = e.response && e.response.data && e.response.data.message || "Ошибка при удалении";
	            onMessage({ type: "error", message: msg });
	        });
	    }
	
	    function onAddTransactions(ids) {
	        if (!selectedSettlement) return;
	        setAddLoading(true);
	        new _Api2.default({ token: token }).addSettlementTransactions(selectedSettlement.id, ids).then(function (r) {
	            setSelectedSettlement(r);
	            setShowAddModal(false);
	            setAddLoading(false);
	            loadSettlements();
	            onMessage({ type: "success", message: "Транзакции добавлены в расчёт" });
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            setAddLoading(false);
	            var msg = e.response && e.response.data && e.response.data.message || "Ошибка при добавлении";
	            onMessage({ type: "error", message: msg });
	        });
	    }
	
	    function onSearchForAdd() {
	        if (!selectedSettlement) return;
	        setAddLoading(true);
	        var data = {
	            terminal_id: Number(selectedSettlement.terminal_id)
	        };
	        if (addSearchFilters.dateFrom) data.date_from = addSearchFilters.dateFrom;
	        if (addSearchFilters.dateTo) data.date_to = addSearchFilters.dateTo;
	
	        new _Api2.default({ token: token }).previewSettlement(data).then(function (r) {
	            var txs = (r.data || r).transactions || [];
	            if (addSearchFilters.amountMin) {
	                var min = Number(addSearchFilters.amountMin) * 100;
	                txs = txs.filter(function (t) {
	                    return t.amount >= min;
	                });
	            }
	            if (addSearchFilters.amountMax) {
	                var max = Number(addSearchFilters.amountMax) * 100;
	                txs = txs.filter(function (t) {
	                    return t.amount <= max;
	                });
	            }
	            setAddSearchResults(txs);
	            setAddLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setAddLoading(false);
	            onMessage({ type: "error", message: "Ошибка поиска транзакций" });
	        });
	    }
	
	    function openCreateWizard() {
	        setShowCreate(true);
	        setPreviewData(null);
	        setCreateTerminalId("");
	        setCreateDateRange({});
	        setCreateComment("");
	        setCreateUsdtRate("");
	        setCreateFile(null);
	        setExcludedIds({});
	    }
	
	    function closeCreateWizard() {
	        setShowCreate(false);
	        setPreviewData(null);
	    }
	
	    // Render detail view
	    function renderDetail() {
	        if (!selectedSettlement) return null;
	        var s = selectedSettlement;
	        var transactions = Array.isArray(s.transactions) ? s.transactions : [];
	
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Card },
	            detailLoading && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Overlay },
	                "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.BackLink, onClick: onBackToList },
	                        "\u2190 \u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443"
	                    ),
	                    _react2.default.createElement(
	                        "h5",
	                        { className: _stylesModule2.default.Title, style: { marginTop: 8 } },
	                        "Расчёт #" + s.id
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { style: { display: "flex", gap: 8 } },
	                    s.status !== 2 && _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnOutline,
	                            onClick: function onClick() {
	                                setShowAddModal(true);
	                                setAddMode("id");
	                                setAddIdInput("");
	                                setAddSearchResults([]);
	                                setAddSelectedIds({});
	                                setAddSearchFilters({ dateFrom: "", dateTo: "", amountMin: "", amountMax: "" });
	                            }
	                        },
	                        "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                    ),
	                    s.status === 1 && _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnDanger,
	                            onClick: function onClick() {
	                                setCancelId(s.id);
	                                setCancelReason("");
	                            }
	                        },
	                        "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.DetailGrid },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            s.merchant_name || "\u2014"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            s.terminal_name ? s.terminal_name + " (#" + (s.terminal_id || s.terminalId) + ")" : s.terminal_id || s.terminalId || "\u2014"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u0421\u0442\u0430\u0442\u0443\u0441"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            _react2.default.createElement(
	                                "span",
	                                { className: getStatusBadgeClass(s.status) },
	                                STATUS_LABELS[s.status] || "Неизвестно"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u0421\u0443\u043C\u043C\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            formatAmount(s.amount),
	                            " \u20BD"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            s.transactions_count || s.transactionsCount || 0
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u0414\u0430\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            formatDate(s.created_at || s.createdAt)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u0421\u043E\u0437\u0434\u0430\u043B"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            s.created_by && s.created_by.username || s.createdBy || "\u2014"
	                        )
	                    ),
	                    s.usdt_rate && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u041A\u0443\u0440\u0441 USDT"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            s.usdt_rate
	                        )
	                    ),
	                    s.amount_usdt != null && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailLabel },
	                            "\u0421\u0443\u043C\u043C\u0430 USDT"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DetailValue },
	                            Number(s.amount_usdt).toFixed(2)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { style: { display: "flex", gap: 8, marginBottom: 12 } },
	                    s.has_payment_proof && _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnOutline,
	                            onClick: function onClick() {
	                                new _Api2.default({ token: token }).downloadSettlementPaymentProof(s.id);
	                            }
	                        },
	                        "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 (",
	                        s.payment_proof_original_name || "файл",
	                        ")"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.BtnOutline,
	                            onClick: function onClick() {
	                                new _Api2.default({ token: token }).downloadSettlementExcel(s.id);
	                            }
	                        },
	                        "\u0421\u043A\u0430\u0447\u0430\u0442\u044C Excel"
	                    )
	                ),
	                s.comment && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.DetailCard },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.DetailLabel },
	                        "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { style: { marginTop: 4 } },
	                        s.comment
	                    )
	                ),
	                s.cancelled_reason && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.DetailCard, style: { background: "#fff3cd", borderColor: "#ffc107" } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.DetailLabel },
	                        "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0442\u043C\u0435\u043D\u044B"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { style: { marginTop: 4 } },
	                        s.cancelled_reason
	                    )
	                ),
	                transactions.length > 0 && _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { style: { display: "flex", alignItems: "center", gap: 12, marginBottom: 8 } },
	                        _react2.default.createElement(
	                            "h6",
	                            { style: { margin: 0, fontWeight: 600 } },
	                            "Транзакции (" + transactions.length + ")"
	                        ),
	                        s.status !== 2 && Object.keys(selectedTxIds).length > 0 && _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnDanger,
	                                style: { fontSize: ".75rem", padding: "2px 10px" },
	                                disabled: removeLoading,
	                                onClick: function onClick() {
	                                    if (!window.confirm("Удалить " + Object.keys(selectedTxIds).length + " транзакций из расчёта?")) return;
	                                    onRemoveTransactions(Object.keys(selectedTxIds).map(Number));
	                                }
	                            },
	                            removeLoading ? "Удаление..." : "Удалить выбранные (" + Object.keys(selectedTxIds).length + ")"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "table",
	                        { className: _stylesModule2.default.Table },
	                        _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                s.status !== 2 && _react2.default.createElement(
	                                    "th",
	                                    { style: { width: 32 } },
	                                    _react2.default.createElement("input", {
	                                        type: "checkbox",
	                                        checked: transactions.length > 0 && transactions.every(function (t) {
	                                            return !!selectedTxIds[t.id];
	                                        }),
	                                        onChange: function onChange(e) {
	                                            var next = {};
	                                            if (e.target.checked) {
	                                                transactions.forEach(function (t) {
	                                                    next[t.id] = true;
	                                                });
	                                            }
	                                            setSelectedTxIds(next);
	                                        }
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "ID"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0421\u0443\u043C\u043C\u0430"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0414\u0430\u0442\u0430"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0422\u0438\u043F"
	                                ),
	                                s.status !== 2 && _react2.default.createElement("th", { style: { width: 40 } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tbody",
	                            null,
	                            transactions.map(function (tx) {
	                                return _react2.default.createElement(
	                                    "tr",
	                                    { key: tx.id },
	                                    s.status !== 2 && _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement("input", {
	                                            type: "checkbox",
	                                            checked: !!selectedTxIds[tx.id],
	                                            onChange: function onChange(e) {
	                                                setSelectedTxIds(function (prev) {
	                                                    var next = Object.assign({}, prev);
	                                                    if (e.target.checked) next[tx.id] = true;else delete next[tx.id];
	                                                    return next;
	                                                });
	                                            }
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        tx.id
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        formatAmount(tx.amount),
	                                        " \u20BD"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        formatAmount(tx.fee),
	                                        " \u20BD"
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        formatDate(tx.date)
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        tx.type_name || tx.typeName || tx.type || "\u2014"
	                                    ),
	                                    s.status !== 2 && _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                            "button",
	                                            {
	                                                className: _stylesModule2.default.BtnDanger,
	                                                style: { fontSize: ".7rem", padding: "1px 6px", lineHeight: 1.4 },
	                                                title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0440\u0430\u0441\u0447\u0451\u0442\u0430",
	                                                disabled: removeLoading,
	                                                onClick: function onClick() {
	                                                    if (!window.confirm("Удалить транзакцию #" + tx.id + " из расчёта?")) return;
	                                                    onRemoveTransactions([tx.id]);
	                                                }
	                                            },
	                                            "\u2715"
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    )
	                ),
	                showAddModal && _react2.default.createElement(
	                    "div",
	                    { style: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" } },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { background: "#fff", borderRadius: 8, width: 700, maxHeight: "80vh", overflow: "auto", padding: 20 } },
	                        _react2.default.createElement(
	                            "div",
	                            { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 } },
	                            _react2.default.createElement(
	                                "h5",
	                                { style: { margin: 0 } },
	                                "Добавить транзакции в расчёт #" + s.id
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                { className: _stylesModule2.default.BtnOutline, onClick: function onClick() {
	                                        setShowAddModal(false);
	                                    } },
	                                "\xD7"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { style: { display: "flex", gap: 12, marginBottom: 16 } },
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: addMode === "id" ? _stylesModule2.default.BtnPrimary : _stylesModule2.default.BtnOutline,
	                                    style: { fontSize: ".8125rem" },
	                                    onClick: function onClick() {
	                                        setAddMode("id");
	                                    }
	                                },
	                                "\u041F\u043E ID"
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: addMode === "search" ? _stylesModule2.default.BtnPrimary : _stylesModule2.default.BtnOutline,
	                                    style: { fontSize: ".8125rem" },
	                                    onClick: function onClick() {
	                                        setAddMode("search");
	                                    }
	                                },
	                                "\u041F\u043E\u0438\u0441\u043A"
	                            )
	                        ),
	                        addMode === "id" && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "label",
	                                { style: { display: "block", fontSize: ".8125rem", marginBottom: 4 } },
	                                "ID \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 (\u0447\u0435\u0440\u0435\u0437 \u0437\u0430\u043F\u044F\u0442\u0443\u044E):"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                value: addIdInput,
	                                onChange: function onChange(e) {
	                                    setAddIdInput(e.target.value);
	                                },
	                                placeholder: "12345, 12346, 12347",
	                                style: { width: "100%", padding: "6px 10px", border: "1px solid #ced4da", borderRadius: 4 }
	                            })
	                        ),
	                        addMode === "search" && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                { style: { display: "flex", gap: 8, marginBottom: 8 } },
	                                _react2.default.createElement(
	                                    "div",
	                                    { style: { flex: 1 } },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { style: { fontSize: ".75rem" } },
	                                        "\u0414\u0430\u0442\u0430 \u043E\u0442"
	                                    ),
	                                    _react2.default.createElement("input", { type: "date", value: addSearchFilters.dateFrom,
	                                        onChange: function onChange(e) {
	                                            setAddSearchFilters(function (p) {
	                                                return Object.assign({}, p, { dateFrom: e.target.value });
	                                            });
	                                        },
	                                        style: { width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4 } })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { style: { flex: 1 } },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { style: { fontSize: ".75rem" } },
	                                        "\u0414\u0430\u0442\u0430 \u0434\u043E"
	                                    ),
	                                    _react2.default.createElement("input", { type: "date", value: addSearchFilters.dateTo,
	                                        onChange: function onChange(e) {
	                                            setAddSearchFilters(function (p) {
	                                                return Object.assign({}, p, { dateTo: e.target.value });
	                                            });
	                                        },
	                                        style: { width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4 } })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { style: { flex: 1 } },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { style: { fontSize: ".75rem" } },
	                                        "\u0421\u0443\u043C\u043C\u0430 \u043E\u0442 (\u0440\u0443\u0431)"
	                                    ),
	                                    _react2.default.createElement("input", { type: "number", value: addSearchFilters.amountMin,
	                                        onChange: function onChange(e) {
	                                            setAddSearchFilters(function (p) {
	                                                return Object.assign({}, p, { amountMin: e.target.value });
	                                            });
	                                        },
	                                        style: { width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4 } })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { style: { flex: 1 } },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { style: { fontSize: ".75rem" } },
	                                        "\u0421\u0443\u043C\u043C\u0430 \u0434\u043E (\u0440\u0443\u0431)"
	                                    ),
	                                    _react2.default.createElement("input", { type: "number", value: addSearchFilters.amountMax,
	                                        onChange: function onChange(e) {
	                                            setAddSearchFilters(function (p) {
	                                                return Object.assign({}, p, { amountMax: e.target.value });
	                                            });
	                                        },
	                                        style: { width: "100%", padding: "4px 8px", border: "1px solid #ced4da", borderRadius: 4 } })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                { className: _stylesModule2.default.BtnOutline, style: { fontSize: ".8125rem", marginBottom: 12 }, disabled: addLoading, onClick: onSearchForAdd },
	                                addLoading ? "Поиск..." : "Найти"
	                            ),
	                            addSearchResults.length > 0 && _react2.default.createElement(
	                                "div",
	                                { style: { maxHeight: 300, overflow: "auto" } },
	                                _react2.default.createElement(
	                                    "table",
	                                    { className: _stylesModule2.default.Table },
	                                    _react2.default.createElement(
	                                        "thead",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "th",
	                                                { style: { width: 32 } },
	                                                _react2.default.createElement("input", { type: "checkbox",
	                                                    checked: addSearchResults.length > 0 && addSearchResults.every(function (t) {
	                                                        return !!addSelectedIds[t.id];
	                                                    }),
	                                                    onChange: function onChange(e) {
	                                                        var sel = {};
	                                                        if (e.target.checked) addSearchResults.forEach(function (t) {
	                                                            sel[t.id] = true;
	                                                        });
	                                                        setAddSelectedIds(sel);
	                                                    } })
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "ID"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0414\u0430\u0442\u0430"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0421\u0443\u043C\u043C\u0430"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0422\u0438\u043F"
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        addSearchResults.map(function (tx) {
	                                            return _react2.default.createElement(
	                                                "tr",
	                                                { key: tx.id },
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    _react2.default.createElement("input", { type: "checkbox",
	                                                        checked: !!addSelectedIds[tx.id],
	                                                        onChange: function onChange(e) {
	                                                            setAddSelectedIds(function (p) {
	                                                                var n = Object.assign({}, p);
	                                                                if (e.target.checked) n[tx.id] = true;else delete n[tx.id];
	                                                                return n;
	                                                            });
	                                                        } })
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    tx.id
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    formatDate(tx.date)
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    formatAmount(tx.amount),
	                                                    " \u20BD"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    tx.type || "\u2014"
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            ),
	                            addSearchResults.length === 0 && !addLoading && _react2.default.createElement(
	                                "div",
	                                { style: { color: "#6c757d", fontSize: ".8125rem" } },
	                                "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432. \u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u0435\u0440\u0438\u043E\u0434 \u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u041D\u0430\u0439\u0442\u0438."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { style: { marginTop: 16, display: "flex", gap: 8, justifyContent: "flex-end" } },
	                            _react2.default.createElement(
	                                "button",
	                                { className: _stylesModule2.default.BtnOutline, onClick: function onClick() {
	                                        setShowAddModal(false);
	                                    } },
	                                "\u041E\u0442\u043C\u0435\u043D\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: _stylesModule2.default.BtnPrimary || _stylesModule2.default.BtnOutline,
	                                    disabled: addLoading,
	                                    onClick: function onClick() {
	                                        var ids = [];
	                                        if (addMode === "id") {
	                                            ids = addIdInput.split(",").map(function (s) {
	                                                return parseInt(s.trim(), 10);
	                                            }).filter(function (n) {
	                                                return !isNaN(n) && n > 0;
	                                            });
	                                        } else {
	                                            ids = Object.keys(addSelectedIds).map(Number);
	                                        }
	                                        if (ids.length === 0) {
	                                            onMessage({ type: "error", message: "Не выбрано ни одной транзакции" });
	                                            return;
	                                        }
	                                        onAddTransactions(ids);
	                                    }
	                                },
	                                addLoading ? "Добавление..." : "Добавить"
	                            )
	                        )
	                    )
	                ),
	                cancelId === s.id && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.DetailCard, style: { marginTop: 16, background: "#fff3cd", borderColor: "#ffc107" } },
	                    _react2.default.createElement(
	                        "h6",
	                        { style: { margin: "0 0 8px 0", fontWeight: 600, color: "#856404" } },
	                        "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043E\u0442\u043C\u0435\u043D\u044B"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CancelInput },
	                        _react2.default.createElement(
	                            "label",
	                            { style: { display: "block", fontSize: ".8125rem", marginBottom: 4 } },
	                            "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0442\u043C\u0435\u043D\u044B:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                            value: cancelReason,
	                            onChange: function onChange(e) {
	                                setCancelReason(e.target.value);
	                            },
	                            placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043E\u0442\u043C\u0435\u043D\u044B..."
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { style: { marginTop: 8, display: "flex", gap: 8 } },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnDanger,
	                                onClick: onCancel,
	                                disabled: cancelling
	                            },
	                            cancelling ? "Отмена..." : "Подтвердить отмену"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnOutline,
	                                onClick: function onClick() {
	                                    setCancelId(null);setCancelReason("");
	                                }
	                            },
	                            "\u041E\u0442\u043C\u0435\u043D\u0430"
	                        )
	                    )
	                )
	            )
	        );
	    }
	
	    // Render create wizard
	    function renderCreateWizard() {
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    "h5",
	                    { className: _stylesModule2.default.Title },
	                    "\u041D\u043E\u0432\u044B\u0439 \u0440\u0430\u0441\u0447\u0451\u0442"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.BtnOutline, onClick: closeCreateWizard },
	                    "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Content },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.WizardStep },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.WizardStepTitle },
	                        "\u0428\u0430\u0433 1: \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u0438 \u043F\u0435\u0440\u0438\u043E\u0434"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FormGroup, style: { flex: 2 } },
	                            _react2.default.createElement(_MerchantTerminalSelect2.default, {
	                                mode: "admin",
	                                token: token,
	                                onSelect: function onSelect(val) {
	                                    setCreateTerminalId(val);
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FormGroup, style: { flex: 2 } },
	                            _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                                    setCreateDateRange(range);
	                                }, defaultPeriod: null })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { style: { fontSize: ".75rem", color: "#6c757d", marginBottom: 8 } },
	                        "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u043E \u0434\u0430\u0442\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FormGroup, style: { flex: 2 } },
	                            _react2.default.createElement(
	                                "label",
	                                null,
	                                "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439"
	                            ),
	                            _react2.default.createElement("textarea", {
	                                rows: 3,
	                                value: createComment,
	                                onChange: function onChange(e) {
	                                    setCreateComment(e.target.value);
	                                },
	                                placeholder: "\u041D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439",
	                                style: { width: "100%" }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FormGroup },
	                            _react2.default.createElement(
	                                "label",
	                                null,
	                                "\u041A\u0443\u0440\u0441 USDT"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "number",
	                                step: "0.01",
	                                value: createUsdtRate,
	                                onChange: function onChange(e) {
	                                    setCreateUsdtRate(e.target.value);
	                                },
	                                placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: 92.50"
	                            }),
	                            createUsdtRate && previewData && previewData.transactions && function () {
	                                var net = 0;
	                                previewData.transactions.forEach(function (tx) {
	                                    if (!excludedIds[tx.id]) net += tx.amount - (tx.fee || 0);
	                                });
	                                return net > 0 ? _react2.default.createElement(
	                                    "div",
	                                    { style: { fontSize: ".75rem", color: "#6c757d", marginTop: 4 } },
	                                    "Сумма USDT: " + (net / 100 / Number(createUsdtRate)).toFixed(2)
	                                ) : null;
	                            }()
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FormGroup },
	                            _react2.default.createElement(
	                                "label",
	                                null,
	                                "\u0424\u0430\u0439\u043B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "file",
	                                onChange: function onChange(e) {
	                                    setCreateFile(e.target.files[0] || null);
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { style: { marginTop: 12 } },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnPrimary,
	                                onClick: onPreview,
	                                disabled: previewLoading || !createTerminalId
	                            },
	                            previewLoading ? "Загрузка..." : "Предпросмотр"
	                        )
	                    )
	                ),
	                previewData && function () {
	                    var allTxs = Array.isArray(previewData.transactions) ? previewData.transactions : [];
	                    var excludedCount = Object.keys(excludedIds).filter(function (k) {
	                        return excludedIds[k];
	                    }).length;
	                    var includedTxs = allTxs.filter(function (tx) {
	                        return !excludedIds[tx.id];
	                    });
	                    var calcAmount = 0;
	                    var calcFee = 0;
	                    includedTxs.forEach(function (tx) {
	                        calcAmount += tx.amount;
	                        calcFee += tx.fee || 0;
	                    });
	                    var allChecked = excludedCount === 0;
	
	                    return _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.WizardStep },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.WizardStepTitle },
	                            "\u0428\u0430\u0433 2: \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.PreviewSummary },
	                            _react2.default.createElement(
	                                "h6",
	                                null,
	                                "\u0418\u0442\u043E\u0433\u043E"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DetailGrid },
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.DetailLabel },
	                                        "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.DetailValue },
	                                        includedTxs.length,
	                                        excludedCount > 0 && _react2.default.createElement(
	                                            "span",
	                                            { style: { fontSize: ".75rem", color: "#999", marginLeft: 6 } },
	                                            "(исключено: " + excludedCount + ")"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.DetailLabel },
	                                        "\u0421\u0443\u043C\u043C\u0430"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.DetailValue },
	                                        formatAmount(calcAmount),
	                                        " \u20BD"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.DetailLabel },
	                                        "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.DetailValue },
	                                        formatAmount(calcFee),
	                                        " \u20BD"
	                                    )
	                                )
	                            )
	                        ),
	                        allTxs.length > 0 && _react2.default.createElement(
	                            "div",
	                            { style: { maxHeight: 400, overflowY: "auto", marginBottom: 16 } },
	                            _react2.default.createElement(
	                                "table",
	                                { className: _stylesModule2.default.Table },
	                                _react2.default.createElement(
	                                    "thead",
	                                    null,
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "th",
	                                            { style: { width: 40, textAlign: "center" } },
	                                            _react2.default.createElement("input", {
	                                                type: "checkbox",
	                                                checked: allChecked,
	                                                onChange: function onChange() {
	                                                    if (allChecked) {
	                                                        var newExcluded = {};
	                                                        allTxs.forEach(function (tx) {
	                                                            newExcluded[tx.id] = true;
	                                                        });
	                                                        setExcludedIds(newExcluded);
	                                                    } else {
	                                                        setExcludedIds({});
	                                                    }
	                                                }
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "ID"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0421\u0443\u043C\u043C\u0430"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0414\u0430\u0442\u0430"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    allTxs.map(function (tx) {
	                                        var isExcluded = !!excludedIds[tx.id];
	                                        return _react2.default.createElement(
	                                            "tr",
	                                            { key: tx.id, className: isExcluded ? _stylesModule2.default.ExcludedRow : "" },
	                                            _react2.default.createElement(
	                                                "td",
	                                                { style: { textAlign: "center" } },
	                                                _react2.default.createElement("input", {
	                                                    type: "checkbox",
	                                                    checked: !isExcluded,
	                                                    onChange: function onChange() {
	                                                        var updated = Object.assign({}, excludedIds);
	                                                        if (isExcluded) {
	                                                            delete updated[tx.id];
	                                                        } else {
	                                                            updated[tx.id] = true;
	                                                        }
	                                                        setExcludedIds(updated);
	                                                    }
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                tx.id
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                formatAmount(tx.amount),
	                                                " \u20BD"
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                formatAmount(tx.fee),
	                                                " \u20BD"
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                formatDate(tx.date)
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { style: { display: "flex", gap: 8 } },
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: _stylesModule2.default.Btn,
	                                    onClick: onCreate,
	                                    disabled: creating || includedTxs.length === 0
	                                },
	                                creating ? "Создание..." : "Создать расчёт"
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: _stylesModule2.default.BtnOutline,
	                                    onClick: function onClick() {
	                                        setPreviewData(null);setExcludedIds({});
	                                    }
	                                },
	                                "\u041D\u0430\u0437\u0430\u0434"
	                            )
	                        )
	                    );
	                }()
	            )
	        );
	    }
	
	    // Render list view
	    function renderList() {
	        return _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Header },
	                _react2.default.createElement(
	                    "h5",
	                    { className: _stylesModule2.default.Title },
	                    "\u0420\u0430\u0441\u0447\u0451\u0442\u044B"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.Btn, onClick: openCreateWizard },
	                    "+ \u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0440\u0430\u0441\u0447\u0451\u0442"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.FilterBar },
	                _react2.default.createElement(
	                    "div",
	                    { style: { flex: 1 } },
	                    _react2.default.createElement(_MerchantTerminalSelect2.default, {
	                        mode: "admin",
	                        token: token,
	                        stackOnMobile: true,
	                        onSelect: function onSelect(val) {
	                            setTerminalId(val);setPage(1);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    "select",
	                    {
	                        value: statusFilter,
	                        onChange: function onChange(e) {
	                            setStatusFilter(e.target.value);setPage(1);
	                        }
	                    },
	                    _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "\u0412\u0441\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044B"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "0" },
	                        "\u0421\u043E\u0437\u0434\u0430\u043D"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "1" },
	                        "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D"
	                    ),
	                    _react2.default.createElement(
	                        "option",
	                        { value: "2" },
	                        "\u041E\u0442\u043C\u0435\u043D\u0451\u043D"
	                    )
	                )
	            ),
	            loading ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Empty },
	                "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
	            ) : settlements.length === 0 ? _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Empty },
	                "\u0420\u0430\u0441\u0447\u0451\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B"
	            ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    "table",
	                    { className: _stylesModule2.default.Table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "ID"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041C\u0435\u0440\u0447\u0430\u043D\u0442"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0443\u043C\u043C\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0414\u0430\u0442\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u043E\u0437\u0434\u0430\u043B"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        settlements.map(function (s) {
	                            return _react2.default.createElement(
	                                "tr",
	                                { key: s.id, onClick: function onClick() {
	                                        onRowClick(s);
	                                    } },
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    s.id
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    s.merchant_name || "\u2014"
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    s.terminal_name ? s.terminal_name + " (#" + (s.terminal_id || s.terminalId) + ")" : s.terminal_id || s.terminalId || "\u2014"
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    formatAmount(s.amount),
	                                    " \u20BD"
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    s.transactions_count || s.transactionsCount || 0
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: getStatusBadgeClass(s.status) },
	                                        STATUS_LABELS[s.status] || "?"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    formatDate(s.created_at || s.createdAt)
	                                ),
	                                _react2.default.createElement(
	                                    "td",
	                                    null,
	                                    s.created_by && s.created_by.username || s.createdBy || "\u2014"
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.MobileList },
	                    settlements.map(function (s) {
	                        return _react2.default.createElement(
	                            "button",
	                            {
	                                key: s.id,
	                                type: "button",
	                                className: _stylesModule2.default.MobileCard,
	                                onClick: function onClick() {
	                                    onRowClick(s);
	                                }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.MobileCardRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.MobilePrimary },
	                                    "#",
	                                    s.id
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: getStatusBadgeClass(s.status) },
	                                    STATUS_LABELS[s.status] || '?'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.MobileCardRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.MobileSecondary },
	                                    s.merchant_name || "\u2014"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.MobileMuted },
	                                    formatDate(s.created_at || s.createdAt)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.MobileCardRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.MobileTertiary },
	                                    s.terminal_name ? s.terminal_name + ' (#' + (s.terminal_id || s.terminalId) + ')' : s.terminal_id || s.terminalId || "\u2014"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.MobileAmount },
	                                    formatAmount(s.amount),
	                                    " \u20BD"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.MobileCardFooter },
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439: ",
	                                    s.transactions_count || s.transactionsCount || 0
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    null,
	                                    s.created_by && s.created_by.username || s.createdBy || "\u2014"
	                                )
	                            )
	                        );
	                    })
	                )
	            ),
	            perPage < count && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.PaginationWrap },
	                _react2.default.createElement(_reactJsPagination2.default, {
	                    firstPageText: "\u21E4",
	                    prevPageText: "\u21E0",
	                    lastPageText: "\u21E5",
	                    nextPageText: "\u21E2",
	                    activeLinkClass: _stylesModule2.default.ActiveLink,
	                    activePage: page,
	                    itemsCountPerPage: perPage,
	                    totalItemsCount: count,
	                    pageRangeDisplayed: 5,
	                    onChange: function onChange(p) {
	                        setPage(p);
	                    }
	                })
	            )
	        );
	    }
	
	    // Determine which view to show
	    var content;
	    if (showCreate) {
	        content = renderCreateWizard();
	    } else if (selectedSettlement) {
	        content = renderDetail();
	    } else {
	        content = renderList();
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "full" },
	                content
	            )
	        )
	    );
	});
	
	exports.default = Settlement;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = TerminalDetailsTabs;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _useTabFromUrl3 = __webpack_require__(380);
	
	var _useTabFromUrl4 = _interopRequireDefault(_useTabFromUrl3);
	
	var _TerminalEditing = __webpack_require__(169);
	
	var _TerminalEditing2 = _interopRequireDefault(_TerminalEditing);
	
	var _TerminalBalanceTab = __webpack_require__(428);
	
	var _TerminalBalanceTab2 = _interopRequireDefault(_TerminalBalanceTab);
	
	var _TerminalSettlementTab = __webpack_require__(430);
	
	var _TerminalSettlementTab2 = _interopRequireDefault(_TerminalSettlementTab);
	
	var _TerminalFeesTab = __webpack_require__(429);
	
	var _TerminalFeesTab2 = _interopRequireDefault(_TerminalFeesTab);
	
	var _MerchantSettingsFeesTab = __webpack_require__(398);
	
	var _MerchantSettingsFeesTab2 = _interopRequireDefault(_MerchantSettingsFeesTab);
	
	var _AntiFraudConfigTab = __webpack_require__(330);
	
	var _AntiFraudConfigTab2 = _interopRequireDefault(_AntiFraudConfigTab);
	
	var _stylesModule = __webpack_require__(204);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Группирует все секции страницы выбранного терминала в 5 вкладок вместо
	 * длинного скролла на 1500px.
	 *
	 * Распределение:
	 *   - "Общее" → TerminalEditing (название, статус, ключи, методы, провайдер)
	 *   - "Балансы" → TerminalBalanceTab + TerminalSettlementTab
	 *   - "Комиссии" → TerminalFeesTab + MerchantSettingsFeesTab + MCC-подсказка
	 *   - "Antifraud" → AntiFraudConfigTab
	 *   - "Раздел избранного" → пока пусто, зарезервирован под будущие PSB-инструменты
	 *
	 * URL ?tab=... синхронизирован через useTabFromUrl: можно дать ссылку
	 * другому админу прямо на нужный таб открытого терминала.
	 *
	 * Если терминал не выбран — показываем плейсхолдер (внутри TerminalEditing уже
	 * есть own empty-state, но он сидит во вкладке "Общее"; вместо него — пустая
	 * подсказка).
	 */
	var TABS = ['general', 'balances', 'fees', 'antifraud'];
	
	function TerminalDetailsTabs(_ref) {
	    var token = _ref.token,
	        terminal = _ref.terminal,
	        onSaved = _ref.onSaved;
	
	    var _useTabFromUrl = (0, _useTabFromUrl4.default)('general', TABS),
	        _useTabFromUrl2 = _slicedToArray(_useTabFromUrl, 2),
	        tab = _useTabFromUrl2[0],
	        setTab = _useTabFromUrl2[1];
	
	    var hasSelected = !!(terminal && terminal.id);
	
	    var tabButton = function tabButton(id, labelId, fallback) {
	        return _react2.default.createElement(
	            'button',
	            {
	                key: id,
	                type: 'button',
	                className: tab === id ? _stylesModule2.default.Tab + ' ' + _stylesModule2.default.TabActive : _stylesModule2.default.Tab,
	                onClick: function onClick() {
	                    return setTab(id);
	                }
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: labelId, defaultMessage: fallback })
	        );
	    };
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        hasSelected && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TabsBar },
	            tabButton('general', 'Terminals.tab.general', 'Общее'),
	            tabButton('balances', 'Terminals.tab.balances', 'Балансы'),
	            tabButton('fees', 'Terminals.tab.fees', 'Комиссии'),
	            tabButton('antifraud', 'Terminals.tab.antifraud', 'Антифрод')
	        ),
	        (tab === 'general' || !hasSelected) && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TabPane },
	            _react2.default.createElement(_TerminalEditing2.default, { token: token, terminal: terminal, onSaved: onSaved })
	        ),
	        hasSelected && tab === 'balances' && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TabPane },
	            _react2.default.createElement(_TerminalBalanceTab2.default, { token: token, terminal: terminal }),
	            _react2.default.createElement(_TerminalSettlementTab2.default, { token: token, terminal: terminal })
	        ),
	        hasSelected && tab === 'fees' && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TabPane },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.HintBox },
	                '\uD83D\uDCA1',
	                ' ',
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: 'Terminals.hint.mcc',
	                    defaultMessage: 'MCC \u043D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 Merchant Settings (\u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0430 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430 \u043A \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0443), \u0430 \u043D\u0435 \u043D\u0430 \u0441\u0430\u043C\u043E\u043C \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0435. \u041E\u0434\u0438\u043D \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D \u043A \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\u043C \u0441 \u0440\u0430\u0437\u043D\u044B\u043C MCC.'
	                })
	            ),
	            _react2.default.createElement(_TerminalFeesTab2.default, { token: token, terminal: terminal }),
	            _react2.default.createElement(_MerchantSettingsFeesTab2.default, { token: token, terminal: terminal })
	        ),
	        hasSelected && tab === 'antifraud' && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.TabPane },
	            _react2.default.createElement(_AntiFraudConfigTab2.default, { token: token, terminal: terminal })
	        )
	    );
	}

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _AdminFiltersToggle = __webpack_require__(42);
	
	var _AdminFiltersToggle2 = _interopRequireDefault(_AdminFiltersToggle);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _SearchTags = __webpack_require__(38);
	
	var _SearchTags2 = _interopRequireDefault(_SearchTags);
	
	var _TerminalsList = __webpack_require__(384);
	
	var _TerminalsList2 = _interopRequireDefault(_TerminalsList);
	
	var _TerminalAddWizard = __webpack_require__(427);
	
	var _TerminalAddWizard2 = _interopRequireDefault(_TerminalAddWizard);
	
	var _TerminalsFilters = __webpack_require__(381);
	
	var _TerminalsFilters2 = _interopRequireDefault(_TerminalsFilters);
	
	var _TerminalDetailsTabs = __webpack_require__(462);
	
	var _TerminalDetailsTabs2 = _interopRequireDefault(_TerminalDetailsTabs);
	
	var _stylesModule = __webpack_require__(204);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _stylesModule3 = __webpack_require__(44);
	
	var _stylesModule4 = _interopRequireDefault(_stylesModule3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TerminalsPage = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    // modal
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isWizardOpen = _useState2[0],
	        setIsWizardOpen = _useState2[1];
	
	    // paging
	
	
	    var _useState3 = (0, _react.useState)(1),
	        _useState4 = _slicedToArray(_useState3, 2),
	        currentPage = _useState4[0],
	        setCurrentPage = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(10),
	        _useState6 = _slicedToArray(_useState5, 2),
	        perPage = _useState6[0],
	        setPerPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(0),
	        _useState8 = _slicedToArray(_useState7, 2),
	        totalCount = _useState8[0],
	        setTotalCount = _useState8[1];
	
	    // data
	
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        list = _useState10[0],
	        setList = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        selected = _useState12[0],
	        setSelected = _useState12[1]; // { id, projectUuid, ... }
	
	    // filters & search & dates
	
	
	    var _useState13 = (0, _react.useState)('DESC'),
	        _useState14 = _slicedToArray(_useState13, 1),
	        sort = _useState14[0];
	
	    var _useState15 = (0, _react.useState)({}),
	        _useState16 = _slicedToArray(_useState15, 2),
	        filterDate = _useState16[0],
	        setFilterDate = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        searchFilters = _useState18[0],
	        setSearchFilters = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        sidebarFilters = _useState20[0],
	        setSidebarFilters = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(true),
	        _useState22 = _slicedToArray(_useState21, 2),
	        loading = _useState22[0],
	        setLoading = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        isFiltersOpen = _useState24[0],
	        setIsFiltersOpen = _useState24[1];
	
	    // load list
	
	
	    (0, _react.useEffect)(function () {
	        var filters = [].concat(_toConsumableArray(searchFilters), _toConsumableArray(sidebarFilters));
	        var payload = {
	            page: currentPage,
	            itemsPerPage: perPage,
	            order: sort,
	            dateRange: filterDate,
	            filters: [].concat(_toConsumableArray(filters))
	        };
	
	        setLoading(true);
	        new _Api2.default({ token: token }).getTerminalsList(payload).then(function (r) {
	            setList(Array.isArray(r.data) ? r.data : []);
	            setTotalCount(typeof r.count === 'number' ? r.count : 0);
	            setLoading(false);
	        });
	    }, [searchFilters, sidebarFilters, filterDate, currentPage, perPage, sort, token]);
	
	    function setPage(page, itemsPerPage) {
	        setCurrentPage(page || 1);
	        if (itemsPerPage) setPerPage(itemsPerPage);
	    }
	
	    function onChangeSearch(tags) {
	        setSearchFilters(Array.isArray(tags) ? tags : []);
	    }
	
	    function onSelectTerminal(row) {
	        if (!row || !row.id) {
	            setSelected(null);
	            return;
	        }
	        // Список приходит с урезанным набором полей; терминал-детали
	        // (включая capabilities) — отдельным эндпоинтом. Объединяем,
	        // чтобы дочерние компоненты сразу получили capabilities и не
	        // показывали методы, недоступные для protocol'а.
	        setSelected(Object.assign({}, row, { _detailLoading: true }));
	        new _Api2.default({ token: token }).getTerminalData(row.id).then(function (detail) {
	            return setSelected(Object.assign({}, row, detail, { _detailLoading: false }));
	        }).catch(function () {
	            return setSelected(Object.assign({}, row, { _detailLoading: false }));
	        });
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        isWizardOpen && _react2.default.createElement(_TerminalAddWizard2.default, {
	            token: token,
	            onClose: function onClose() {
	                setIsWizardOpen(false);
	            },
	            onCreated: function onCreated() {
	                setIsWizardOpen(false);
	                setCurrentPage(1);
	                setSidebarFilters(function (prev) {
	                    return [].concat(prev);
	                });
	            }
	        }),
	        _react2.default.createElement(
	            _Layout.Wrapper,
	            null,
	            _react2.default.createElement(
	                _Layout.Container,
	                null,
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: '780', className: _stylesModule4.default.MainColumn },
	                    _react2.default.createElement(_AdminFiltersToggle2.default, { onClick: function onClick() {
	                            return setIsFiltersOpen(true);
	                        } }),
	                    _react2.default.createElement(_SearchTags2.default, {
	                        onChangeSearch: onChangeSearch,
	                        onSearch: function onSearch() {
	                            setSearchFilters(function (prev) {
	                                return [].concat(_toConsumableArray(prev));
	                            });
	                            setCurrentPage(1);
	                        },
	                        isDisabled: false,
	                        defaultSearch: {
	                            key: 'merchantUuid',
	                            locale: 'Search.label.projectUuid',
	                            placeholder: 'Search.placeholder.projectUuid'
	                        },
	                        searchBy: [{
	                            key: 'merchantUuid',
	                            locale: 'Search.label.projectUuid',
	                            placeholder: 'Search.placeholder.projectUuid'
	                        }, {
	                            key: 'merchantName',
	                            locale: 'Search.label.projectName',
	                            placeholder: 'Search.placeholder.projectName'
	                        }, {
	                            key: 'terminalId',
	                            locale: 'Search.label.terminalId',
	                            placeholder: 'Search.placeholder.terminalId'
	                        }, {
	                            key: 'terminalName',
	                            locale: 'Search.label.terminalName',
	                            placeholder: 'Search.placeholder.terminalName'
	                        }, {
	                            key: 'providerName',
	                            locale: 'Search.label.providerName',
	                            placeholder: 'Search.placeholder.providerName'
	                        }, {
	                            key: 'currencyCode',
	                            locale: 'Search.label.currency',
	                            placeholder: 'Search.placeholder.currency'
	                        }]
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.Card },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.Header },
	                            _react2.default.createElement(
	                                'h5',
	                                { className: _stylesModule2.default.Title },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Terminals.title', defaultMessage: '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u044B' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _stylesModule2.default.Btn, onClick: function onClick() {
	                                        return setIsWizardOpen(true);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: 'add-outline', size: '16px' }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Terminals.add', defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C' })
	                            )
	                        ),
	                        _react2.default.createElement(_TerminalsList2.default, {
	                            isLoading: loading,
	                            data: list,
	                            currentId: selected ? selected.id : null,
	                            onSelect: onSelectTerminal
	                        }),
	                        perPage < totalCount && _react2.default.createElement(
	                            'div',
	                            { className: _stylesModule2.default.PaginationWrap },
	                            _react2.default.createElement(_reactJsPagination2.default, {
	                                firstPageText: '\u21E4',
	                                prevPageText: '\u21E0',
	                                lastPageText: '\u21E5',
	                                nextPageText: '\u21E2',
	                                activeLinkClass: _stylesModule2.default.ActiveLink,
	                                activePage: currentPage,
	                                itemsCountPerPage: perPage,
	                                totalItemsCount: totalCount,
	                                pageRangeDisplayed: 5,
	                                onChange: function onChange(page) {
	                                    return setPage(page, perPage);
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(_TerminalDetailsTabs2.default, {
	                        token: token,
	                        terminal: selected,
	                        onSaved: function onSaved() {
	                            setCurrentPage(1);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: '350', className: _stylesModule4.default.SidebarColumn },
	                    _react2.default.createElement(
	                        _ResponsiveSidebarFilters2.default,
	                        {
	                            title: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B',
	                            isOpen: isFiltersOpen,
	                            onClose: function onClose() {
	                                return setIsFiltersOpen(false);
	                            }
	                        },
	                        _react2.default.createElement(
	                            _EmptyCard2.default,
	                            null,
	                            _react2.default.createElement(_DateRange2.default, {
	                                onSelectDate: function onSelectDate(range) {
	                                    setFilterDate(range || {});
	                                    setCurrentPage(1);
	                                },
	                                defaultPeriod: 'zero'
	                            })
	                        ),
	                        _react2.default.createElement(_TerminalsFilters2.default, {
	                            isLoading: loading,
	                            token: token,
	                            onApplyFilters: function onApplyFilters(newFilters) {
	                                setSidebarFilters(Array.isArray(newFilters) ? newFilters : []);
	                                setCurrentPage(1);
	                                setIsFiltersOpen(false);
	                            }
	                        })
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = TerminalsPage;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _styles = __webpack_require__(619);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var POLL_MS = 7000;
	
	var STATUSES = [{ value: '', label: 'Все статусы' }, { value: 'open', label: 'Открыто' }, { value: 'pending_user', label: 'Ожидает ответа' }, { value: 'closed', label: 'Закрыто' }];
	
	/* ---------- icons ---------- */
	
	var IconChevronDown = function IconChevronDown(_ref) {
	    var _ref$size = _ref.size,
	        size = _ref$size === undefined ? 16 : _ref$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M6 9l6 6 6-6', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconChevronUp = function IconChevronUp(_ref2) {
	    var _ref2$size = _ref2.size,
	        size = _ref2$size === undefined ? 16 : _ref2$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M18 15l-6-6-6 6', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconPaperclip = function IconPaperclip(_ref3) {
	    var _ref3$size = _ref3.size,
	        size = _ref3$size === undefined ? 18 : _ref3$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', {
	            d: 'M21.44 11.05l-9.19 9.19a5.5 5.5 0 01-7.78-7.78l9.19-9.19a3.5 3.5 0 014.95 4.95l-8.83 8.83a1.5 1.5 0 01-2.12-2.12l7.41-7.41',
	            stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round'
	        })
	    );
	};
	
	var IconSend = function IconSend(_ref4) {
	    var _ref4$size = _ref4.size,
	        size = _ref4$size === undefined ? 16 : _ref4$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M22 2L11 13', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	        _react2.default.createElement('path', { d: 'M22 2l-7 20-4-9-9-4 20-7z', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconFile = function IconFile(_ref5) {
	    var _ref5$size = _ref5.size,
	        size = _ref5$size === undefined ? 14 : _ref5$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	        _react2.default.createElement('path', { d: 'M14 2v6h6', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconEdit = function IconEdit(_ref6) {
	    var _ref6$size = _ref6.size,
	        size = _ref6$size === undefined ? 14 : _ref6$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	        _react2.default.createElement('path', { d: 'M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconTrash = function IconTrash(_ref7) {
	    var _ref7$size = _ref7.size,
	        size = _ref7$size === undefined ? 14 : _ref7$size;
	    return _react2.default.createElement(
	        'svg',
	        { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' })
	    );
	};
	
	var IconEmptyChat = function IconEmptyChat() {
	    return _react2.default.createElement(
	        'svg',
	        { width: '56', height: '56', viewBox: '0 0 48 48', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', {
	            d: 'M8 13.5C8 11.01 10.01 9 12.5 9h23C37.99 9 40 11.01 40 13.5v17C40 33 37.99 35 35.5 35H22l-8 8v-8h-1.5C10.01 35 8 33 8 30.5v-17z',
	            fill: '#6366f1', opacity: '0.18'
	        }),
	        _react2.default.createElement('path', {
	            d: 'M8 13.5C8 11.01 10.01 9 12.5 9h23C37.99 9 40 11.01 40 13.5v17C40 33 37.99 35 35.5 35H22l-8 8v-8h-1.5C10.01 35 8 33 8 30.5v-17z',
	            stroke: '#6366f1', strokeWidth: '2', strokeLinejoin: 'round'
	        }),
	        _react2.default.createElement('circle', { cx: '17', cy: '22', r: '1.6', fill: '#6366f1' }),
	        _react2.default.createElement('circle', { cx: '24', cy: '22', r: '1.6', fill: '#6366f1' }),
	        _react2.default.createElement('circle', { cx: '31', cy: '22', r: '1.6', fill: '#6366f1' })
	    );
	};
	
	/* ---------- helpers ---------- */
	
	function statusLabel(s) {
	    if (s === 'open') return 'Открыто';
	    if (s === 'pending_user') return 'Ожидает ответа';
	    if (s === 'closed') return 'Закрыто';
	    return s;
	}
	
	function statusClass(s) {
	    if (s === 'open') return _styles2.default.StatusOpen;
	    if (s === 'pending_user') return _styles2.default.StatusPendingUser;
	    if (s === 'closed') return _styles2.default.StatusClosed;
	    return _styles2.default.StatusOpen;
	}
	
	function fmtFull(iso) {
	    if (!iso) return '—';
	    return new Date(iso).toLocaleString('ru-RU', {
	        day: '2-digit', month: '2-digit', year: '2-digit',
	        hour: '2-digit', minute: '2-digit'
	    });
	}
	
	function fmtRelative(iso) {
	    if (!iso) return '';
	    var dt = new Date(iso);
	    var sec = Math.max(1, Math.floor((Date.now() - dt.getTime()) / 1000));
	    if (sec < 60) return sec + '\u0441';
	    if (sec < 3600) return Math.floor(sec / 60) + '\u043C';
	    if (sec < 86400) return Math.floor(sec / 3600) + '\u0447';
	    if (sec < 86400 * 7) return Math.floor(sec / 86400) + '\u0434';
	    return dt.toLocaleDateString('ru-RU');
	}
	
	function fmtSize(b) {
	    if (!b) return '';
	    if (b < 1024) return b + ' \u0431';
	    if (b < 1024 * 1024) return (b / 1024).toFixed(1) + ' \u041A\u0411';
	    return (b / 1024 / 1024).toFixed(1) + ' \u041C\u0411';
	}
	
	function avatarInitials(name) {
	    if (!name) return '?';
	    var parts = String(name).trim().split(/\s+/);
	    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	    return (parts[0][0] + parts[1][0]).toUpperCase();
	}
	
	function pickLatestUpdated(messages, fallback) {
	    var latest = fallback;
	    (messages || []).forEach(function (m) {
	        if (!latest || m.updated_at > latest) latest = m.updated_at;
	    });
	    return latest;
	}
	
	/* ---------- main ---------- */
	
	var TicketsAdminPage = (0, _Auth.withAuth)(function (_ref8) {
	    var token = _ref8.token;
	
	    var api = (0, _react.useMemo)(function () {
	        return token ? new _Api2.default({ token: token }) : null;
	    }, [token]);
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var _useParams = (0, _reactRouterDom.useParams)(),
	        routeId = _useParams.id;
	
	    var activeId = routeId ? parseInt(routeId, 10) : null;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        items = _useState2[0],
	        setItems = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(0),
	        _useState4 = _slicedToArray(_useState3, 2),
	        total = _useState4[0],
	        setTotal = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(1),
	        _useState6 = _slicedToArray(_useState5, 2),
	        page = _useState6[0],
	        setPage = _useState6[1];
	
	    var pageSize = 30;
	
	    var _useState7 = (0, _react.useState)({ status: '', q: '', only_unread: false }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        filters = _useState8[0],
	        setFilters = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        ticket = _useState10[0],
	        setTicket = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        merchant = _useState12[0],
	        setMerchant = _useState12[1];
	
	    var _useState13 = (0, _react.useState)([]),
	        _useState14 = _slicedToArray(_useState13, 2),
	        messages = _useState14[0],
	        setMessages = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(''),
	        _useState16 = _slicedToArray(_useState15, 2),
	        draftBody = _useState16[0],
	        setDraftBody = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        draftFiles = _useState18[0],
	        setDraftFiles = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(null),
	        _useState20 = _slicedToArray(_useState19, 2),
	        editingId = _useState20[0],
	        setEditingId = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(''),
	        _useState22 = _slicedToArray(_useState21, 2),
	        editingBody = _useState22[0],
	        setEditingBody = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        sending = _useState24[0],
	        setSending = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(null),
	        _useState26 = _slicedToArray(_useState25, 2),
	        error = _useState26[0],
	        setError = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(false),
	        _useState28 = _slicedToArray(_useState27, 2),
	        showTerminals = _useState28[0],
	        setShowTerminals = _useState28[1];
	
	    var lastUpdatedRef = (0, _react.useRef)(null);
	    var fileInputRef = (0, _react.useRef)(null);
	    var chatBodyRef = (0, _react.useRef)(null);
	
	    var loadList = (0, _react.useCallback)(function () {
	        if (!api) return;
	        var params = {
	            status: filters.status || undefined,
	            q: filters.q || undefined,
	            only_unread: filters.only_unread ? 1 : undefined,
	            page: page,
	            page_size: pageSize
	        };
	        api.adminListTickets(params).then(function (data) {
	            setItems(data.items || []);
	            setTotal(data.total || 0);
	        }).catch(function () {});
	    }, [api, page, filters]);
	
	    (0, _react.useEffect)(function () {
	        loadList();
	    }, [loadList]);
	
	    (0, _react.useEffect)(function () {
	        if (!api) return undefined;
	        var i = setInterval(loadList, 30000);
	        return function () {
	            return clearInterval(i);
	        };
	    }, [api, loadList]);
	
	    var loadTicketInitial = (0, _react.useCallback)(function () {
	        var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee(id) {
	            var data;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(!api || !id)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	                            _context.next = 5;
	                            return api.adminGetTicket(id);
	
	                        case 5:
	                            data = _context.sent;
	
	                            setTicket(data.ticket);
	                            setMerchant(data.merchant);
	                            setMessages(data.messages || []);
	                            lastUpdatedRef.current = pickLatestUpdated(data.messages, null);
	                            api.adminMarkTicketRead(id).catch(function () {});
	                            _context.next = 16;
	                            break;
	
	                        case 13:
	                            _context.prev = 13;
	                            _context.t0 = _context['catch'](2);
	
	                            setError('Не удалось загрузить обращение.');
	
	                        case 16:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 13]]);
	        }));
	
	        return function (_x) {
	            return _ref9.apply(this, arguments);
	        };
	    }(), [api]);
	
	    (0, _react.useEffect)(function () {
	        if (!activeId) {
	            setTicket(null);setMerchant(null);setMessages([]);
	            lastUpdatedRef.current = null;
	            return;
	        }
	        loadTicketInitial(activeId);
	    }, [activeId, loadTicketInitial]);
	
	    (0, _react.useEffect)(function () {
	        if (!api || !activeId) return undefined;
	        var poll = function () {
	            var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var data;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.prev = 0;
	                                _context2.next = 3;
	                                return api.adminGetTicketMessages(activeId, lastUpdatedRef.current);
	
	                            case 3:
	                                data = _context2.sent;
	
	                                if ((data.messages || []).length) {
	                                    _context2.next = 6;
	                                    break;
	                                }
	
	                                return _context2.abrupt('return');
	
	                            case 6:
	                                setMessages(function (prev) {
	                                    var map = new Map();
	                                    prev.forEach(function (m) {
	                                        return map.set(m.id, m);
	                                    });
	                                    (data.messages || []).forEach(function (m) {
	                                        return map.set(m.id, m);
	                                    });
	                                    return Array.from(map.values()).sort(function (a, b) {
	                                        return a.id - b.id;
	                                    });
	                                });
	                                lastUpdatedRef.current = pickLatestUpdated(data.messages, lastUpdatedRef.current);
	                                _context2.next = 12;
	                                break;
	
	                            case 10:
	                                _context2.prev = 10;
	                                _context2.t0 = _context2['catch'](0);
	
	                            case 12:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, undefined, [[0, 10]]);
	            }));
	
	            return function poll() {
	                return _ref10.apply(this, arguments);
	            };
	        }();
	        var i = setInterval(poll, POLL_MS);
	        return function () {
	            return clearInterval(i);
	        };
	    }, [api, activeId]);
	
	    (0, _react.useEffect)(function () {
	        if (chatBodyRef.current) chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
	    }, [messages]);
	
	    var openTicket = function openTicket(t) {
	        if (activeId === t.id) return;
	        setError(null);
	        setEditingId(null);setEditingBody('');
	        setDraftBody('');setDraftFiles([]);
	        setShowTerminals(false);
	        history.push('/admin/tickets/' + t.id);
	    };
	
	    var onPickFiles = function onPickFiles(filesList) {
	        var arr = Array.from(filesList || []);
	        if (draftFiles.length + arr.length > 10) {
	            setError('Не более 10 файлов.');return;
	        }
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var f = _step.value;
	
	                if (f.size > 25 * 1024 * 1024) {
	                    setError('"' + f.name + '" \u0431\u043E\u043B\u044C\u0448\u0435 25 \u041C\u0411.');return;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        setError(null);
	        setDraftFiles([].concat(_toConsumableArray(draftFiles), _toConsumableArray(arr)));
	    };
	
	    var removeDraftFile = function removeDraftFile(idx) {
	        var next = [].concat(_toConsumableArray(draftFiles));next.splice(idx, 1);setDraftFiles(next);
	    };
	
	    var submitMessage = function () {
	        var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (ticket) {
	                                _context3.next = 2;
	                                break;
	                            }
	
	                            return _context3.abrupt('return');
	
	                        case 2:
	                            if (!(!draftBody.trim() && draftFiles.length === 0)) {
	                                _context3.next = 4;
	                                break;
	                            }
	
	                            return _context3.abrupt('return');
	
	                        case 4:
	                            setSending(true);setError(null);
	                            _context3.prev = 6;
	                            _context3.next = 9;
	                            return api.adminPostTicketMessage(ticket.id, draftBody, draftFiles);
	
	                        case 9:
	                            setDraftBody('');setDraftFiles([]);
	                            _context3.next = 13;
	                            return loadTicketInitial(ticket.id);
	
	                        case 13:
	                            loadList();
	                            _context3.next = 19;
	                            break;
	
	                        case 16:
	                            _context3.prev = 16;
	                            _context3.t0 = _context3['catch'](6);
	
	                            setError(_context3.t0.response && _context3.t0.response.data && _context3.t0.response.data.message || 'Не удалось отправить.');
	
	                        case 19:
	                            _context3.prev = 19;
	                            setSending(false);return _context3.finish(19);
	
	                        case 22:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[6, 16, 19, 22]]);
	        }));
	
	        return function submitMessage() {
	            return _ref11.apply(this, arguments);
	        };
	    }();
	
	    var startEdit = function startEdit(m) {
	        setEditingId(m.id);setEditingBody(m.body);
	    };
	    var cancelEdit = function cancelEdit() {
	        setEditingId(null);setEditingBody('');
	    };
	    var saveEdit = function () {
	        var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	                            _context4.next = 3;
	                            return api.adminEditTicketMessage(ticket.id, editingId, editingBody);
	
	                        case 3:
	                            cancelEdit();
	                            _context4.next = 6;
	                            return loadTicketInitial(ticket.id);
	
	                        case 6:
	                            _context4.next = 11;
	                            break;
	
	                        case 8:
	                            _context4.prev = 8;
	                            _context4.t0 = _context4['catch'](0);
	                            setError('Не удалось сохранить.');
	                        case 11:
	                        case 'end':
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined, [[0, 8]]);
	        }));
	
	        return function saveEdit() {
	            return _ref12.apply(this, arguments);
	        };
	    }();
	
	    var deleteMsg = function () {
	        var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(m) {
	            return _regenerator2.default.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            if (window.confirm('Удалить это сообщение?')) {
	                                _context5.next = 2;
	                                break;
	                            }
	
	                            return _context5.abrupt('return');
	
	                        case 2:
	                            _context5.prev = 2;
	                            _context5.next = 5;
	                            return api.adminDeleteTicketMessage(ticket.id, m.id);
	
	                        case 5:
	                            _context5.next = 7;
	                            return loadTicketInitial(ticket.id);
	
	                        case 7:
	                            _context5.next = 12;
	                            break;
	
	                        case 9:
	                            _context5.prev = 9;
	                            _context5.t0 = _context5['catch'](2);
	                            setError('Не удалось удалить.');
	                        case 12:
	                        case 'end':
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined, [[2, 9]]);
	        }));
	
	        return function deleteMsg(_x2) {
	            return _ref13.apply(this, arguments);
	        };
	    }();
	
	    var deleteAttachment = function () {
	        var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(a) {
	            return _regenerator2.default.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            if (window.confirm('\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u043B\u043E\u0436\u0435\u043D\u0438\u0435 "' + a.filename + '"?')) {
	                                _context6.next = 2;
	                                break;
	                            }
	
	                            return _context6.abrupt('return');
	
	                        case 2:
	                            _context6.prev = 2;
	                            _context6.next = 5;
	                            return api.adminDeleteTicketAttachment(ticket.id, a.id);
	
	                        case 5:
	                            _context6.next = 7;
	                            return loadTicketInitial(ticket.id);
	
	                        case 7:
	                            _context6.next = 12;
	                            break;
	
	                        case 9:
	                            _context6.prev = 9;
	                            _context6.t0 = _context6['catch'](2);
	                            setError('Не удалось удалить вложение.');
	                        case 12:
	                        case 'end':
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined, [[2, 9]]);
	        }));
	
	        return function deleteAttachment(_x3) {
	            return _ref14.apply(this, arguments);
	        };
	    }();
	
	    var changeStatus = function () {
	        var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(newStatus) {
	            return _regenerator2.default.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _context7.prev = 0;
	                            _context7.next = 3;
	                            return api.adminChangeTicketStatus(ticket.id, newStatus);
	
	                        case 3:
	                            _context7.next = 5;
	                            return loadTicketInitial(ticket.id);
	
	                        case 5:
	                            loadList();
	                            _context7.next = 11;
	                            break;
	
	                        case 8:
	                            _context7.prev = 8;
	                            _context7.t0 = _context7['catch'](0);
	                            setError('Не удалось изменить статус.');
	                        case 11:
	                        case 'end':
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined, [[0, 8]]);
	        }));
	
	        return function changeStatus(_x4) {
	            return _ref15.apply(this, arguments);
	        };
	    }();
	
	    var deleteTicket = function () {
	        var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	            return _regenerator2.default.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            if (window.confirm('Удалить обращение полностью? Пользователь его больше не увидит.')) {
	                                _context8.next = 2;
	                                break;
	                            }
	
	                            return _context8.abrupt('return');
	
	                        case 2:
	                            _context8.prev = 2;
	                            _context8.next = 5;
	                            return api.adminDeleteTicket(ticket.id);
	
	                        case 5:
	                            history.push('/admin/tickets');
	                            loadList();
	                            _context8.next = 12;
	                            break;
	
	                        case 9:
	                            _context8.prev = 9;
	                            _context8.t0 = _context8['catch'](2);
	                            setError('Не удалось удалить.');
	                        case 12:
	                        case 'end':
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, undefined, [[2, 9]]);
	        }));
	
	        return function deleteTicket() {
	            return _ref16.apply(this, arguments);
	        };
	    }();
	
	    /* ---------- render ---------- */
	
	    var renderEmpty = function renderEmpty() {
	        return _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Empty },
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.EmptyIllustration },
	                _react2.default.createElement(IconEmptyChat, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.EmptyTitle },
	                '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.EmptyText },
	                '\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u043B\u044E\u0431\u0443\u044E \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443 \u0441\u043F\u0440\u0430\u0432\u0430, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0443 \u0441 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u043E\u043C.'
	            )
	        );
	    };
	
	    var renderChat = function renderChat() {
	        if (!ticket) return renderEmpty();
	        var terminals = merchant && merchant.terminals || [];
	        var isClosed = ticket.status === 'closed';
	        var merchantName = merchant && merchant.username || 'Пользователь';
	
	        return _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.ChatHeader },
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.ChatHeaderTop },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.ChatTitle },
	                        ticket.subject
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _styles2.default.StatusChip + ' ' + _styles2.default.StatusChipBig + ' ' + _styles2.default.StatusChipHeader },
	                        statusLabel(ticket.status)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.HeaderActions },
	                        isClosed ? _react2.default.createElement(
	                            'button',
	                            { className: _styles2.default.HeaderBtn + ' ' + _styles2.default.HeaderBtnPrimary, onClick: function onClick() {
	                                    return changeStatus('open');
	                                } },
	                            '\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0437\u0430\u043D\u043E\u0432\u043E'
	                        ) : _react2.default.createElement(
	                            'button',
	                            { className: _styles2.default.HeaderBtn, onClick: function onClick() {
	                                    return changeStatus('closed');
	                                } },
	                            '\u0417\u0430\u043A\u0440\u044B\u0442\u044C'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: _styles2.default.HeaderBtn + ' ' + _styles2.default.HeaderBtnDanger, onClick: deleteTicket },
	                            '\u0423\u0434\u0430\u043B\u0438\u0442\u044C'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.MerchantBar },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.MerchantAvatar },
	                        avatarInitials(merchantName)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.MerchantInfo },
	                        _react2.default.createElement(
	                            'span',
	                            { className: _styles2.default.Name },
	                            merchantName
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _styles2.default.Email },
	                            merchant && merchant.email
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.HeaderMeta },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D ',
	                            merchant && merchant.registered_at ? fmtFull(merchant.registered_at) : '—'
	                        ),
	                        merchant && merchant.profile_url && _react2.default.createElement(
	                            _react.Fragment,
	                            null,
	                            _react2.default.createElement('span', { className: _styles2.default.HeaderMetaSep }),
	                            _react2.default.createElement(
	                                'a',
	                                { className: _styles2.default.ProfileLink, href: merchant.profile_url },
	                                '\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C'
	                            )
	                        ),
	                        terminals.length > 0 && _react2.default.createElement(
	                            _react.Fragment,
	                            null,
	                            _react2.default.createElement('span', { className: _styles2.default.HeaderMetaSep }),
	                            _react2.default.createElement(
	                                'button',
	                                { className: _styles2.default.TerminalsToggle, onClick: function onClick() {
	                                        return setShowTerminals(!showTerminals);
	                                    } },
	                                terminals.length,
	                                ' ',
	                                terminals.length === 1 ? 'терминал' : 'терминалов / проектов',
	                                showTerminals ? _react2.default.createElement(IconChevronUp, { size: 12 }) : _react2.default.createElement(IconChevronDown, { size: 12 })
	                            )
	                        )
	                    )
	                ),
	                showTerminals && terminals.length > 0 && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.TerminalsPopup },
	                    terminals.map(function (t) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: t.terminal_id },
	                            t.terminal_name || '\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B #' + t.terminal_id,
	                            t.merchant_name && _react2.default.createElement(
	                                'span',
	                                { style: { opacity: 0.6 } },
	                                ' \xB7 ',
	                                t.merchant_name
	                            )
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { ref: chatBodyRef, className: _styles2.default.ChatBody },
	                messages.length === 0 ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Empty },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EmptyIllustration },
	                        _react2.default.createElement(IconEmptyChat, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.EmptyText },
	                        '\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442.'
	                    )
	                ) : messages.map(function (m) {
	                    var isMine = m.author_type === 'admin';
	                    return _react2.default.createElement(
	                        'div',
	                        { key: m.id, className: _styles2.default.MsgRow + ' ' + (isMine ? _styles2.default.MsgRowMine : '') },
	                        !isMine && _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.Avatar + ' ' + _styles2.default.AvatarUser },
	                            avatarInitials(merchantName)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.MsgGroup },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _styles2.default.MsgBubble + ' ' + (isMine ? _styles2.default.MsgBubbleMine : '') + ' ' + (m.deleted ? _styles2.default.MsgBubbleDeleted : '') },
	                                !m.deleted && _react2.default.createElement(
	                                    'div',
	                                    { className: _styles2.default.MsgActions },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: _styles2.default.MsgActionBtn, onClick: function onClick() {
	                                                return startEdit(m);
	                                            }, title: '\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C' },
	                                        _react2.default.createElement(IconEdit, null)
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: _styles2.default.MsgActionBtn + ' ' + _styles2.default.Danger, onClick: function onClick() {
	                                                return deleteMsg(m);
	                                            }, title: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C' },
	                                        _react2.default.createElement(IconTrash, null)
	                                    )
	                                ),
	                                editingId === m.id ? _react2.default.createElement(
	                                    'div',
	                                    { className: _styles2.default.EditForm },
	                                    _react2.default.createElement('textarea', {
	                                        className: _styles2.default.EditFormArea,
	                                        value: editingBody,
	                                        onChange: function onChange(e) {
	                                            return setEditingBody(e.target.value);
	                                        }
	                                    }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _styles2.default.EditActions },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: _styles2.default.EditSave, onClick: saveEdit },
	                                            '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C'
	                                        ),
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: _styles2.default.EditCancel, onClick: cancelEdit },
	                                            '\u041E\u0442\u043C\u0435\u043D\u0430'
	                                        )
	                                    )
	                                ) : _react2.default.createElement(
	                                    _react.Fragment,
	                                    null,
	                                    m.deleted ? 'сообщение удалено' : m.body,
	                                    (m.attachments || []).map(function (a) {
	                                        return a.purged ? _react2.default.createElement(
	                                            'span',
	                                            { key: a.id, className: _styles2.default.AttachmentPurged },
	                                            _react2.default.createElement(IconFile, null),
	                                            ' \u0444\u0430\u0439\u043B \u0443\u0434\u0430\u043B\u0451\u043D \u043F\u043E \u0441\u0440\u043E\u043A\u0443'
	                                        ) : _react2.default.createElement(
	                                            'span',
	                                            { key: a.id, className: _styles2.default.AttachmentInline },
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    type: 'button',
	                                                    className: _styles2.default.AttachmentChip,
	                                                    onClick: function onClick() {
	                                                        return api.adminDownloadTicketAttachment(ticket.id, a.id, a.filename);
	                                                    },
	                                                    title: a.filename + ' \xB7 ' + fmtSize(a.size_bytes)
	                                                },
	                                                _react2.default.createElement(IconFile, null),
	                                                ' ',
	                                                a.filename
	                                            ),
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    type: 'button',
	                                                    className: _styles2.default.AttachmentDelete,
	                                                    onClick: function onClick() {
	                                                        return deleteAttachment(a);
	                                                    },
	                                                    title: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u043B\u043E\u0436\u0435\u043D\u0438\u0435'
	                                                },
	                                                '\xD7'
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _styles2.default.MsgFooter },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _styles2.default.AuthorTag + ' ' + (isMine ? _styles2.default.AuthorTagAdmin : '') },
	                                    isMine ? 'Поддержка' : merchantName
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '\xB7'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    fmtFull(m.created_at)
	                                ),
	                                m.edited && _react2.default.createElement(
	                                    'span',
	                                    { className: _styles2.default.MsgEditedTag },
	                                    '\xB7 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E'
	                                )
	                            )
	                        ),
	                        isMine && _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.Avatar + ' ' + _styles2.default.AvatarSupport },
	                            'S'
	                        )
	                    );
	                })
	            ),
	            isClosed ? _react2.default.createElement(
	                'div',
	                { className: _styles2.default.ClosedNote },
	                '\u041E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u043E. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0437\u0430\u043D\u043E\u0432\u043E\xBB, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0443.'
	            ) : _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Composer },
	                error && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.ComposerError },
	                    error
	                ),
	                draftFiles.length > 0 && _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.AttachPreviewList },
	                    draftFiles.map(function (f, idx) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: idx, className: _styles2.default.AttachPreview },
	                            _react2.default.createElement(IconFile, null),
	                            ' ',
	                            f.name,
	                            ' \xB7 ',
	                            fmtSize(f.size),
	                            _react2.default.createElement(
	                                'button',
	                                { className: _styles2.default.AttachRemove, onClick: function onClick() {
	                                        return removeDraftFile(idx);
	                                    } },
	                                '\xD7'
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement('textarea', {
	                    className: _styles2.default.ComposerArea,
	                    placeholder: '\u041E\u0442\u0432\u0435\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E...',
	                    value: draftBody,
	                    onChange: function onChange(e) {
	                        return setDraftBody(e.target.value);
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.ComposerToolbar },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: _styles2.default.IconBtn,
	                            onClick: function onClick() {
	                                return fileInputRef.current && fileInputRef.current.click();
	                            },
	                            title: '\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B'
	                        },
	                        _react2.default.createElement(IconPaperclip, null)
	                    ),
	                    _react2.default.createElement('input', {
	                        ref: fileInputRef,
	                        type: 'file',
	                        multiple: true,
	                        className: _styles2.default.HiddenFile,
	                        onChange: function onChange(e) {
	                            return onPickFiles(e.target.files);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'button',
	                        { className: _styles2.default.SendBtn, disabled: sending, onClick: submitMessage },
	                        _react2.default.createElement(IconSend, null),
	                        sending ? 'Отправка...' : 'Отправить'
	                    )
	                )
	            )
	        );
	    };
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: _styles2.default.Outer },
	            _react2.default.createElement(
	                'div',
	                { className: _styles2.default.Page },
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.MainPanel },
	                    activeId ? renderChat() : renderEmpty()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.SidePanel },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.SideHeader },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.SideTitle },
	                            '\u041E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.SideSubtitle },
	                            '\u0412\u0441\u0435\u0433\u043E: ',
	                            total
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.Filters },
	                        _react2.default.createElement(
	                            'select',
	                            {
	                                value: filters.status,
	                                onChange: function onChange(e) {
	                                    setPage(1);setFilters(Object.assign({}, filters, { status: e.target.value }));
	                                }
	                            },
	                            STATUSES.map(function (s) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    { key: s.value, value: s.value },
	                                    s.label
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.SearchWrap },
	                            _react2.default.createElement('input', {
	                                type: 'text',
	                                placeholder: '\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0435\u043C\u0435...',
	                                value: filters.q,
	                                onChange: function onChange(e) {
	                                    setPage(1);setFilters(Object.assign({}, filters, { q: e.target.value }));
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'label',
	                            { className: _styles2.default.FiltersRow },
	                            _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                checked: filters.only_unread,
	                                onChange: function onChange(e) {
	                                    setPage(1);setFilters(Object.assign({}, filters, { only_unread: e.target.checked }));
	                                }
	                            }),
	                            '\u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.ListLabel },
	                        '\u0421\u043F\u0438\u0441\u043E\u043A \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.TicketList },
	                        items.length === 0 ? _react2.default.createElement(
	                            'div',
	                            { style: { textAlign: 'center', color: '#94a3b8', fontSize: 12, padding: 24 } },
	                            '\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
	                        ) : items.map(function (t) {
	                            var isActive = activeId === t.id;
	                            var accountName = t.account && t.account.username || '';
	                            var accountEmail = t.account && t.account.email || '';
	                            return _react2.default.createElement(
	                                'div',
	                                {
	                                    key: t.id,
	                                    className: _styles2.default.TicketCard + ' ' + (isActive ? _styles2.default.TicketCardActive : ''),
	                                    onClick: function onClick() {
	                                        return openTicket(t);
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _styles2.default.TicketCardTop },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _styles2.default.TicketCardSubject + ' ' + (t.unread_for_admin ? _styles2.default.TicketCardSubjectUnread : '') },
	                                        t.subject
	                                    ),
	                                    t.unread_for_admin && _react2.default.createElement('span', { className: _styles2.default.UnreadDot })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _styles2.default.TicketCardEmail },
	                                    accountName,
	                                    accountName && accountEmail ? ' · ' : '',
	                                    accountEmail
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _styles2.default.TicketCardMeta },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _styles2.default.StatusChip + ' ' + statusClass(t.status) },
	                                        statusLabel(t.status)
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        fmtRelative(t.last_user_message_at || t.last_admin_message_at || t.updated_at)
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _styles2.default.Pagination },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u0441\u0442\u0440. ',
	                            page
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.PageNav },
	                            _react2.default.createElement(
	                                'button',
	                                { className: _styles2.default.PageBtn, disabled: page === 1, onClick: function onClick() {
	                                        return setPage(page - 1);
	                                    } },
	                                '\u2190'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { className: _styles2.default.PageBtn, disabled: page * pageSize >= total, onClick: function onClick() {
	                                        return setPage(page + 1);
	                                    } },
	                                '\u2192'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = TicketsAdminPage;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _TrafficMonitoringTable = __webpack_require__(385);
	
	var _TrafficMonitoringTable2 = _interopRequireDefault(_TrafficMonitoringTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REFRESH_INTERVAL_MS = 30000;
	
	var TrafficMonitoringPage = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        merchants = _useState2[0],
	        setMerchants = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        updatedAt = _useState4[0],
	        setUpdatedAt = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(true),
	        _useState6 = _slicedToArray(_useState5, 2),
	        loading = _useState6[0],
	        setLoading = _useState6[1];
	
	    var loadingRef = (0, _react.useRef)(false);
	
	    var fetchData = (0, _react.useCallback)(function (isInitial) {
	        if (loadingRef.current) return;
	        loadingRef.current = true;
	        if (isInitial) setLoading(true);
	
	        new _Api2.default({ token: token }).getTrafficMonitoring().then(function (data) {
	            if (data && data.merchants) {
	                setMerchants(data.merchants);
	                setUpdatedAt(data.updated_at || null);
	            }
	        }).catch(function (e) {
	            console.error("TrafficMonitoring fetch error", e);
	        }).finally(function () {
	            loadingRef.current = false;
	            if (isInitial) setLoading(false);
	        });
	    }, [token]);
	
	    (0, _react.useEffect)(function () {
	        fetchData(true);
	        var interval = setInterval(function () {
	            fetchData(false);
	        }, REFRESH_INTERVAL_MS);
	        return function () {
	            clearInterval(interval);
	        };
	    }, [fetchData]);
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "full" },
	                _react2.default.createElement(_TrafficMonitoringTable2.default, {
	                    merchants: merchants,
	                    updatedAt: updatedAt,
	                    loading: loading,
	                    onRefresh: function onRefresh() {
	                        fetchData(false);
	                    }
	                })
	            )
	        )
	    );
	});
	
	exports.default = TrafficMonitoringPage;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TransactionAudit = __webpack_require__(432);
	
	var _TransactionAudit2 = _interopRequireDefault(_TransactionAudit);
	
	var _stylesModule = __webpack_require__(620);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var SEARCH_TYPES = [{ value: 'id', label: 'ID транзакции', placeholder: 'Например: 2399782', description: 'Внутренний числовой ID транзакции в системе' }, { value: 'uuid', label: 'UUID транзакции', placeholder: 'Например: 45525d9b-5e5b-40c5-ad3d-1e7afbc6e0a5', description: 'UUID транзакции (поле uuid)' }, { value: 'externalRef', label: 'External Reference', placeholder: 'Внешний идентификатор мерчанта', description: 'Идентификатор, переданный мерчантом при создании транзакции' }, { value: 'hydraId', label: 'Processing Order ID', placeholder: 'Например: c68f72a6a73944ad882202cb7fe5ff10', description: 'ID заказа в процессинге (Hydra, FinStar и др.)' }, { value: 'unlid', label: 'UNLID / Description', placeholder: 'Description транзакции', description: 'Поле description транзакции (UNLID или произвольное описание)' }, { value: 'payoutRequestUuid', label: 'Payout Request UUID', placeholder: 'Например: 49c2c20b-db2e-4a57-86f4-b831f8cc996d', description: 'UUID заявки на выплату из CRM (PayoutRequest)' }, { value: 'payload', label: 'Поиск по событиям', placeholder: 'Имя получателя, номер карты, любой текст...', description: 'Полнотекстовый поиск по payload и meta событий транзакции' }];
	
	var EVENT_TYPES = [{ value: 'MERCHANT_REQUEST', label: 'Входящие запросы' }, { value: 'MERCHANT_RESPONSE', label: 'Ответы мерчанту' }, { value: 'PROVIDER_REQUEST', label: 'Запросы к провайдерам' }, { value: 'PROVIDER_RESPONSE', label: 'Ответы от провайдеров' }, { value: 'STATUS_CHANGE', label: 'Изменения статуса' }, { value: 'MERCHANT_CALLBACK', label: 'Callbacks мерчанту' }, { value: 'SYSTEM_NOTE', label: 'Системные заметки' }];
	
	var TransactionAudit = function TransactionAudit(_ref) {
	    var token = _ref.token;
	
	    // Режимы: 'transaction' = поиск по транзакции, 'events' = поиск по событиям
	    var _useState = (0, _react.useState)('transaction'),
	        _useState2 = _slicedToArray(_useState, 2),
	        searchMode = _useState2[0],
	        setSearchMode = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        searchValue = _useState4[0],
	        setSearchValue = _useState4[1];
	
	    var _useState5 = (0, _react.useState)("id"),
	        _useState6 = _slicedToArray(_useState5, 2),
	        searchType = _useState6[0],
	        setSearchType = _useState6[1];
	
	    // Для режима 'events'
	
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        selectedEventTypes = _useState8[0],
	        setSelectedEventTypes = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        selectedMerchantId = _useState10[0],
	        setSelectedMerchantId = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(""),
	        _useState12 = _slicedToArray(_useState11, 2),
	        merchantSearch = _useState12[0],
	        setMerchantSearch = _useState12[1];
	
	    var _useState13 = (0, _react.useState)([]),
	        _useState14 = _slicedToArray(_useState13, 2),
	        merchantsList = _useState14[0],
	        setMerchantsList = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        setLoadingMerchants = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(""),
	        _useState18 = _slicedToArray(_useState17, 2),
	        selectedProvider = _useState18[0],
	        setSelectedProvider = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        providersList = _useState20[0],
	        setProvidersList = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(""),
	        _useState22 = _slicedToArray(_useState21, 2),
	        dateFrom = _useState22[0],
	        setDateFrom = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(""),
	        _useState24 = _slicedToArray(_useState23, 2),
	        dateTo = _useState24[0],
	        setDateTo = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        errorOnly = _useState26[0],
	        setErrorOnly = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(null),
	        _useState28 = _slicedToArray(_useState27, 2),
	        setSearchId = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(false),
	        _useState30 = _slicedToArray(_useState29, 2),
	        loading = _useState30[0],
	        setLoading = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(null),
	        _useState32 = _slicedToArray(_useState31, 2),
	        error = _useState32[0],
	        setError = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(null),
	        _useState34 = _slicedToArray(_useState33, 2),
	        auditData = _useState34[0],
	        setAuditData = _useState34[1];
	
	    var _useState35 = (0, _react.useState)([]),
	        _useState36 = _slicedToArray(_useState35, 2),
	        eventsList = _useState36[0],
	        setEventsList = _useState36[1];
	
	    var _useState37 = (0, _react.useState)([]),
	        _useState38 = _slicedToArray(_useState37, 2),
	        recentSearches = _useState38[0],
	        setRecentSearches = _useState38[1];
	
	    var _useState39 = (0, _react.useState)(null),
	        _useState40 = _slicedToArray(_useState39, 2),
	        expandedEventId = _useState40[0],
	        setExpandedEventId = _useState40[1];
	
	    var handleSearchTransaction = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var value, id, data, trxId, newSearch, errorMsg;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        value = searchValue.trim();
	
	                        if (value) {
	                            _context.next = 4;
	                            break;
	                        }
	
	                        setError("Введите значение для поиска");
	                        return _context.abrupt("return");
	
	                    case 4:
	                        if (!(searchType === 'id')) {
	                            _context.next = 9;
	                            break;
	                        }
	
	                        id = parseInt(value, 10);
	
	                        if (!(!id || isNaN(id))) {
	                            _context.next = 9;
	                            break;
	                        }
	
	                        setError("ID должен быть числом");
	                        return _context.abrupt("return");
	
	                    case 9:
	
	                        setLoading(true);
	                        setError(null);
	                        setEventsList([]);
	
	                        _context.prev = 12;
	                        _context.next = 15;
	                        return new _Api2.default({ token: token }).getTransactionAudit(value, { searchType: searchType });
	
	                    case 15:
	                        data = _context.sent;
	
	                        setAuditData(data);
	                        trxId = data && data.transaction && data.transaction.id;
	
	                        setSearchId(trxId || value);
	
	                        // Сохраняем в историю поиска
	                        newSearch = { type: searchType, value: value, id: trxId, time: new Date() };
	
	                        setRecentSearches(function (prev) {
	                            return [newSearch].concat(_toConsumableArray(prev.filter(function (s) {
	                                return s.value !== value;
	                            }).slice(0, 4)));
	                        });
	                        _context.next = 29;
	                        break;
	
	                    case 23:
	                        _context.prev = 23;
	                        _context.t0 = _context["catch"](12);
	
	                        Sentry.captureException(_context.t0);
	                        errorMsg = _context.t0.response && _context.t0.response.data && _context.t0.response.data.message || _context.t0.message || "Не удалось загрузить данные";
	
	                        setError(errorMsg);
	                        setAuditData(null);
	
	                    case 29:
	                        _context.prev = 29;
	
	                        setLoading(false);
	                        return _context.finish(29);
	
	                    case 32:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[12, 23, 29, 32]]);
	    })), [searchValue, searchType, token]);
	
	    var handleSearchEvents = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var filters, data, errorMsg;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        if (!(selectedEventTypes.length === 0)) {
	                            _context2.next = 3;
	                            break;
	                        }
	
	                        setError("Выберите тип события");
	                        return _context2.abrupt("return");
	
	                    case 3:
	
	                        setLoading(true);
	                        setError(null);
	                        setAuditData(null);
	
	                        _context2.prev = 6;
	                        filters = {
	                            eventTypes: selectedEventTypes
	                        };
	
	
	                        if (selectedMerchantId) {
	                            filters.merchantId = selectedMerchantId; // Отправляем ID (число)
	                        }
	                        if (selectedProvider) {
	                            filters.actors = [selectedProvider]; // Отправляем массив
	                        }
	                        if (dateFrom) {
	                            filters.dateRange = filters.dateRange || {};
	                            filters.dateRange.startDate = dateFrom;
	                        }
	                        if (dateTo) {
	                            filters.dateRange = filters.dateRange || {};
	                            filters.dateRange.endDate = dateTo;
	                        }
	                        if (errorOnly) {
	                            filters.hasError = true;
	                        }
	
	                        _context2.next = 15;
	                        return new _Api2.default({ token: token }).getTransactionEvents(filters);
	
	                    case 15:
	                        data = _context2.sent;
	
	                        setEventsList(data.data || []);
	
	                        if ((data.data || []).length === 0) {
	                            setError("События не найдены");
	                        }
	                        _context2.next = 26;
	                        break;
	
	                    case 20:
	                        _context2.prev = 20;
	                        _context2.t0 = _context2["catch"](6);
	
	                        Sentry.captureException(_context2.t0);
	                        errorMsg = _context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message || _context2.t0.message || "Не удалось загрузить данные";
	
	                        setError(errorMsg);
	                        setEventsList([]);
	
	                    case 26:
	                        _context2.prev = 26;
	
	                        setLoading(false);
	                        return _context2.finish(26);
	
	                    case 29:
	                    case "end":
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined, [[6, 20, 26, 29]]);
	    })), [selectedEventTypes, selectedMerchantId, selectedProvider, dateFrom, dateTo, errorOnly, token]);
	
	    var handleKeyPress = function handleKeyPress(e) {
	        if (e.key === "Enter") {
	            if (searchMode === 'transaction') {
	                handleSearchTransaction();
	            }
	        }
	    };
	
	    // Загрузить провайдеров при монтировании
	    (0, _react.useEffect)(function () {
	        var loadProviders = function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                var data, providers;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.prev = 0;
	                                _context3.next = 3;
	                                return new _Api2.default({ token: token }).getTransactionEventActors();
	
	                            case 3:
	                                data = _context3.sent;
	
	                                // Фильтруем только провайдеров (не merchant, system, admin)
	                                providers = data.actors.filter(function (a) {
	                                    return !['merchant', 'system', 'admin'].includes(a.code);
	                                });
	
	                                setProvidersList(providers.map(function (p) {
	                                    return p.code;
	                                }));
	                                _context3.next = 12;
	                                break;
	
	                            case 8:
	                                _context3.prev = 8;
	                                _context3.t0 = _context3["catch"](0);
	
	                                Sentry.captureException(_context3.t0);
	                                console.error('Failed to load providers:', _context3.t0);
	
	                            case 12:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, undefined, [[0, 8]]);
	            }));
	
	            return function loadProviders() {
	                return _ref4.apply(this, arguments);
	            };
	        }();
	        loadProviders();
	    }, [token]);
	
	    // Функция для загрузки мерчантов при поиске
	    var handleMerchantSearch = (0, _react.useCallback)(function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(query) {
	            var data;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            setMerchantSearch(query);
	
	                            if (!(query.length < 2 && query.length > 0)) {
	                                _context4.next = 3;
	                                break;
	                            }
	
	                            return _context4.abrupt("return");
	
	                        case 3:
	
	                            setLoadingMerchants(true);
	                            _context4.prev = 4;
	                            _context4.next = 7;
	                            return new _Api2.default({ token: token }).getMerchants(query);
	
	                        case 7:
	                            data = _context4.sent;
	
	                            setMerchantsList(data.merchants || []);
	                            _context4.next = 16;
	                            break;
	
	                        case 11:
	                            _context4.prev = 11;
	                            _context4.t0 = _context4["catch"](4);
	
	                            Sentry.captureException(_context4.t0);
	                            console.error('Failed to load merchants:', _context4.t0);
	                            setMerchantsList([]);
	
	                        case 16:
	                            _context4.prev = 16;
	
	                            setLoadingMerchants(false);
	                            return _context4.finish(16);
	
	                        case 19:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined, [[4, 11, 16, 19]]);
	        }));
	
	        return function (_x) {
	            return _ref5.apply(this, arguments);
	        };
	    }(), [token]);
	
	    // Загрузить первые 100 мерчантов при монтировании
	    (0, _react.useEffect)(function () {
	        handleMerchantSearch('');
	    }, [handleMerchantSearch]);
	
	    var handleRecentClick = function handleRecentClick(search) {
	        setSearchValue(search.value);
	        setSearchType(search.type);
	        setSearchMode('transaction');
	    };
	
	    var clearFilters = function clearFilters() {
	        setSelectedEventTypes([]);
	        setSelectedMerchantId(null);
	        setMerchantSearch("");
	        setSelectedProvider("");
	        setDateFrom("");
	        setDateTo("");
	        setErrorOnly(false);
	        setEventsList([]);
	        handleMerchantSearch(''); // Перезагрузить список
	    };
	
	    var currentSearchType = SEARCH_TYPES.find(function (t) {
	        return t.value === searchType;
	    });
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 1180 },
	                _react2.default.createElement(
	                    "h1",
	                    { className: _stylesModule2.default.Title },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.page.title", defaultMessage: "Transaction Audit" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ModeSelector },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.ModeBtn + " " + (searchMode === 'transaction' ? _stylesModule2.default.ModeBtnActive : ''),
	                            onClick: function onClick() {
	                                return setSearchMode('transaction');
	                            }
	                        },
	                        "\u041F\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _stylesModule2.default.ModeBtn + " " + (searchMode === 'events' ? _stylesModule2.default.ModeBtnActive : ''),
	                            onClick: function onClick() {
	                                return setSearchMode('events');
	                            }
	                        },
	                        "\u041F\u043E \u0441\u043E\u0431\u044B\u0442\u0438\u044F\u043C"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SearchSection },
	                    searchMode === 'transaction' ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SearchTypeSelector },
	                            SEARCH_TYPES.map(function (type) {
	                                return _react2.default.createElement(
	                                    "button",
	                                    {
	                                        key: type.value,
	                                        className: _stylesModule2.default.SearchTypeBtn + " " + (searchType === type.value ? _stylesModule2.default.SearchTypeBtnActive : ''),
	                                        onClick: function onClick() {
	                                            return setSearchType(type.value);
	                                        },
	                                        title: type.description
	                                    },
	                                    type.label
	                                );
	                            })
	                        ),
	                        currentSearchType && currentSearchType.description && _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SearchTypeHint },
	                            currentSearchType.description
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SearchBox },
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                className: _stylesModule2.default.SearchInput,
	                                placeholder: currentSearchType && currentSearchType.placeholder || 'Введите значение',
	                                value: searchValue,
	                                onChange: function onChange(e) {
	                                    return setSearchValue(e.target.value);
	                                },
	                                onKeyPress: handleKeyPress
	                            }),
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: _stylesModule2.default.SearchButton,
	                                    onClick: handleSearchTransaction,
	                                    disabled: loading
	                                },
	                                loading ? "Поиск..." : "Найти"
	                            )
	                        ),
	                        recentSearches.length > 0 && _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.RecentSearches },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.RecentLabel },
	                                "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435:"
	                            ),
	                            recentSearches.map(function (search, idx) {
	                                return _react2.default.createElement(
	                                    "button",
	                                    {
	                                        key: idx,
	                                        className: _stylesModule2.default.RecentItem,
	                                        onClick: function onClick() {
	                                            return handleRecentClick(search);
	                                        },
	                                        title: function () {
	                                            var found = SEARCH_TYPES.find(function (t) {
	                                                return t.value === search.type;
	                                            });return (found && found.label || search.type) + ': ' + search.value;
	                                        }()
	                                    },
	                                    "#",
	                                    search.id || search.value.substring(0, 8)
	                                );
	                            })
	                        )
	                    ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.EventsFilters },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.FilterGroup },
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: _stylesModule2.default.FilterLabel },
	                                    "\u0422\u0438\u043F \u0441\u043E\u0431\u044B\u0442\u0438\u044F:"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.FilterChips },
	                                    EVENT_TYPES.map(function (type) {
	                                        return _react2.default.createElement(
	                                            "button",
	                                            {
	                                                key: type.value,
	                                                className: _stylesModule2.default.FilterChip + " " + (selectedEventTypes.includes(type.value) ? _stylesModule2.default.FilterChipActive : ''),
	                                                onClick: function onClick() {
	                                                    return setSelectedEventTypes(function (prev) {
	                                                        return prev.includes(type.value) ? prev.filter(function (t) {
	                                                            return t !== type.value;
	                                                        }) : [].concat(_toConsumableArray(prev), [type.value]);
	                                                    });
	                                                }
	                                            },
	                                            type.label
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.FilterRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.FilterItem },
	                                    _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "\u041C\u0435\u0440\u0447\u0430\u043D\u0442:"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ComboBox },
	                                        _react2.default.createElement("input", {
	                                            type: "text",
	                                            placeholder: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435...",
	                                            value: merchantSearch,
	                                            onChange: function onChange(e) {
	                                                return handleMerchantSearch(e.target.value);
	                                            },
	                                            className: _stylesModule2.default.ComboBoxInput
	                                        }),
	                                        merchantsList.length > 0 && _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.ComboBoxDropdown },
	                                            merchantsList.map(function (merchant) {
	                                                return _react2.default.createElement(
	                                                    "div",
	                                                    {
	                                                        key: merchant.id,
	                                                        className: _stylesModule2.default.ComboBoxOption + " " + (selectedMerchantId === merchant.id ? _stylesModule2.default.ComboBoxOptionActive : ''),
	                                                        onClick: function onClick() {
	                                                            setSelectedMerchantId(merchant.id);
	                                                            setMerchantSearch(merchant.name);
	                                                            setMerchantsList([]);
	                                                        }
	                                                    },
	                                                    merchant.name,
	                                                    " ",
	                                                    _react2.default.createElement(
	                                                        "span",
	                                                        { className: _stylesModule2.default.MerchantId },
	                                                        "#",
	                                                        merchant.id
	                                                    )
	                                                );
	                                            })
	                                        ),
	                                        selectedMerchantId && _react2.default.createElement(
	                                            "button",
	                                            {
	                                                className: _stylesModule2.default.ClearButton,
	                                                onClick: function onClick() {
	                                                    setSelectedMerchantId(null);
	                                                    setMerchantSearch('');
	                                                    handleMerchantSearch('');
	                                                },
	                                                title: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C"
	                                            },
	                                            "\xD7"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.FilterItem },
	                                    _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440:"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        {
	                                            value: selectedProvider,
	                                            onChange: function onChange(e) {
	                                                return setSelectedProvider(e.target.value);
	                                            },
	                                            className: _stylesModule2.default.SelectInput
	                                        },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "-- \u0412\u0441\u0435 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u044B --"
	                                        ),
	                                        providersList.map(function (provider) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: provider, value: provider },
	                                                provider
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.FilterItem },
	                                    _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "\u041E\u0442 (\u0434\u0430\u0442\u0430/\u0432\u0440\u0435\u043C\u044F):"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "datetime-local",
	                                        value: dateFrom,
	                                        onChange: function onChange(e) {
	                                            return setDateFrom(e.target.value);
	                                        }
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.FilterItem },
	                                    _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        "\u0414\u043E (\u0434\u0430\u0442\u0430/\u0432\u0440\u0435\u043C\u044F):"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "datetime-local",
	                                        value: dateTo,
	                                        onChange: function onChange(e) {
	                                            return setDateTo(e.target.value);
	                                        }
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.FilterItem },
	                                    _react2.default.createElement(
	                                        "label",
	                                        null,
	                                        _react2.default.createElement("input", {
	                                            type: "checkbox",
	                                            checked: errorOnly,
	                                            onChange: function onChange(e) {
	                                                return setErrorOnly(e.target.checked);
	                                            }
	                                        }),
	                                        "\u0422\u043E\u043B\u044C\u043A\u043E \u043E\u0448\u0438\u0431\u043A\u0438"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.FilterActions },
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: _stylesModule2.default.SearchButton,
	                                        onClick: handleSearchEvents,
	                                        disabled: loading || selectedEventTypes.length === 0
	                                    },
	                                    loading ? "Поиск..." : "Поиск событий"
	                                ),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: _stylesModule2.default.ClearButton,
	                                        onClick: clearFilters
	                                    },
	                                    "\u0421\u0431\u0440\u043E\u0441"
	                                )
	                            )
	                        )
	                    )
	                ),
	                error && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ErrorBox },
	                    error
	                ),
	                searchMode === 'events' && eventsList.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ResultSection },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: _stylesModule2.default.SectionTitle },
	                        "\u0421\u043E\u0431\u044B\u0442\u0438\u044F (",
	                        eventsList.length,
	                        ")"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.EventsList },
	                        eventsList.map(function (event) {
	                            return _react2.default.createElement(
	                                "div",
	                                { key: event.id, className: _stylesModule2.default.EventItem },
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: _stylesModule2.default.EventItemHeader,
	                                        onClick: function onClick() {
	                                            return setExpandedEventId(expandedEventId === event.id ? null : event.id);
	                                        }
	                                    },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.EventItemTime },
	                                        new Date(event.createdAt).toLocaleString()
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.EventItemType },
	                                        event.eventType
	                                    ),
	                                    event.actor && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.EventItemActor },
	                                        event.actor
	                                    ),
	                                    event.direction && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.EventItemDirection },
	                                        event.direction
	                                    ),
	                                    event.httpCode && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.EventItemHttpCode + " " + (event.httpCode >= 200 && event.httpCode < 300 ? _stylesModule2.default.HttpOk : _stylesModule2.default.HttpError) },
	                                        "HTTP ",
	                                        event.httpCode
	                                    ),
	                                    event.errorCode && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.EventItemError },
	                                        "\u274C ",
	                                        event.errorCode
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.EventItemTransactionId },
	                                        "\u0422\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u044F: #",
	                                        event.transactionId
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ExpandIcon },
	                                        expandedEventId === event.id ? '▼' : '▶'
	                                    )
	                                ),
	                                expandedEventId === event.id && _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.EventItemDetails },
	                                    event.errorMessage && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.ErrorDetails },
	                                        _react2.default.createElement(
	                                            "strong",
	                                            null,
	                                            "\u041E\u0448\u0438\u0431\u043A\u0430:"
	                                        ),
	                                        " ",
	                                        event.errorMessage
	                                    ),
	                                    event.payload && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.PayloadDetails },
	                                        _react2.default.createElement(
	                                            "strong",
	                                            null,
	                                            "Payload:"
	                                        ),
	                                        _react2.default.createElement(
	                                            "pre",
	                                            null,
	                                            JSON.stringify(event.payload, null, 2)
	                                        )
	                                    ),
	                                    event.meta && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.MetaDetails },
	                                        _react2.default.createElement(
	                                            "strong",
	                                            null,
	                                            "Meta:"
	                                        ),
	                                        _react2.default.createElement(
	                                            "pre",
	                                            null,
	                                            JSON.stringify(event.meta, null, 2)
	                                        )
	                                    ),
	                                    event.statusFrom && event.statusTo && _react2.default.createElement(
	                                        "div",
	                                        { className: _stylesModule2.default.StatusChange },
	                                        _react2.default.createElement(
	                                            "strong",
	                                            null,
	                                            "\u0421\u0442\u0430\u0442\u0443\u0441:"
	                                        ),
	                                        " ",
	                                        event.statusFrom,
	                                        " \u2192 ",
	                                        event.statusTo
	                                    )
	                                )
	                            );
	                        })
	                    )
	                ),
	                searchMode === 'transaction' && auditData && auditData.transaction && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ResultSection },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.TransactionInfo },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: _stylesModule2.default.SectionTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.transaction", defaultMessage: "Transaction" }),
	                            " #",
	                            auditData.transaction.id
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.InfoGrid },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.status", defaultMessage: "Status" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.status || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.amount", defaultMessage: "Amount" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.amount,
	                                    " ",
	                                    auditData.transaction.currency
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.fee", defaultMessage: "Fee" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.fee != null ? auditData.transaction.fee : "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.merchant", defaultMessage: "Merchant" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.merchantName || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.terminalId", defaultMessage: "Terminal ID" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.terminalId || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.cardMask", defaultMessage: "Card" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.cardMask || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.cardHolder", defaultMessage: "Card Holder" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.cardHolder || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.rrn", defaultMessage: "RRN" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.rrn || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.authcode", defaultMessage: "Auth Code" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.authcode || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.processingId", defaultMessage: "Processing ID" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.processingOrderId || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.externalRef", defaultMessage: "External Ref" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.externalReference || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.clientIp", defaultMessage: "Client IP" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.clientIp || "—"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InfoItem },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoLabel },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.createdAt", defaultMessage: "Created" })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: _stylesModule2.default.InfoValue },
	                                    auditData.transaction.createdAt ? new Date(auditData.transaction.createdAt).toLocaleString() : "—"
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.TimelineSection },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: _stylesModule2.default.SectionTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "TransactionAudit.timeline", defaultMessage: "Event Timeline" })
	                        ),
	                        _react2.default.createElement(_TransactionAudit2.default, { key: auditData.transaction.id, transactionId: auditData.transaction.id, token: token, initialData: auditData })
	                    )
	                ),
	                !auditData && eventsList.length === 0 && !loading && !error && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.EmptyState },
	                    searchMode === 'transaction' ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "TransactionAudit.hint",
	                        defaultMessage: "Enter a transaction ID to view its complete audit history"
	                    }) : "Выберите тип события и нажмите 'Поиск событий' чтобы найти события"
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _Auth.withAuth)(TransactionAudit);

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getApiV3DocsUrl = getApiV3DocsUrl;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getApiV3DocsUrl() {
	    var apiBaseUrl = (({"NODE_ENV":"production","PUBLIC_URL":"","API_URL":"https://api.test.e-clear.cc","BRAND":"eclear","REACT_APP_SENTRY_TRACES_SAMPLE_RATE":"0.2","REACT_APP_SENTRY_DSN":""}).REACT_APP_API_URL || ("https://api.test.e-clear.cc") || '').replace(/\/+$/, '');
	
	    return apiBaseUrl + '/api/v3/docs';
	}
	
	var ApiV3DocsRedirect = function ApiV3DocsRedirect() {
	    var docsUrl = getApiV3DocsUrl();
	
	    (0, _react.useEffect)(function () {
	        window.location.replace(docsUrl);
	    }, [docsUrl]);
	
	    return _react2.default.createElement(
	        'p',
	        null,
	        '\u041F\u0435\u0440\u0435\u0445\u043E\u0434\u0438\u043C \u0432 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E API v3. \u0415\u0441\u043B\u0438 \u043F\u0435\u0440\u0435\u0445\u043E\u0434 \u043D\u0435 \u043D\u0430\u0447\u0430\u043B\u0441\u044F,',
	        ' ',
	        _react2.default.createElement(
	            'a',
	            { href: docsUrl },
	            '\u043E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0435\u0451 \u0432\u0440\u0443\u0447\u043D\u0443\u044E'
	        ),
	        '.'
	    );
	};
	
	exports.default = ApiV3DocsRedirect;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = LoginPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoginForm = __webpack_require__(397);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _styleModule = __webpack_require__(621);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoginPage() {
	
	    function setLoginBG(val) {
	        switch (val) {
	            case "wl":
	                return _styleModule2.default.WLLoginBG;
	            case "unlimco":
	                return _styleModule2.default.UnlimcoLoginBG;
	            case "eclear":
	                return _styleModule2.default.EclearLoginBG;
	            default:
	                return _styleModule2.default.WLLoginBG;
	        }
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _styleModule2.default.LoginPage + ' ' + setLoginBG(("eclear")) },
	        _react2.default.createElement(
	            'div',
	            { className: _styleModule2.default.Container },
	            _react2.default.createElement(
	                'div',
	                { className: _styleModule2.default.LoginWrap },
	                _react2.default.createElement(_LoginForm2.default, null)
	            )
	        )
	    );
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = NPay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _npayModule = __webpack_require__(622);
	
	var _npayModule2 = _interopRequireDefault(_npayModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Интервал поллинга статуса оплаты.
	var STATUS_POLL_INTERVAL_MS = 5000;
	
	// Финальные статусы — на них останавливаем таймер и поллинг.
	var FINAL_STATUSES = ["SUCCESS", "DECLINED", "EXPIRED"];
	
	function formatTime(totalSeconds) {
	    if (totalSeconds == null || totalSeconds < 0) {
	        return "00:00";
	    }
	    var m = Math.floor(totalSeconds / 60);
	    var s = totalSeconds % 60;
	    return (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
	}
	
	function formatMoney(value) {
	    if (value == null || isNaN(value)) {
	        return null;
	    }
	    return Number(value).toLocaleString("ru-RU", {
	        minimumFractionDigits: 2,
	        maximumFractionDigits: 2
	    });
	}
	
	// Публичная страница оплаты NPay: QR + таймер + сумма (₽ и KGS) + инструкция по Сберу.
	// Открывается плательщиком по ссылке {front}/npay/{token} (token — неугадываемый).
	function NPay() {
	    var _this = this;
	
	    var _useParams = (0, _reactRouterDom.useParams)(),
	        token = _useParams.token;
	
	    var api = new _Api2.default({});
	
	    var _useState = (0, _react.useState)(true),
	        _useState2 = _slicedToArray(_useState, 2),
	        loading = _useState2[0],
	        setLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        error = _useState4[0],
	        setError = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        data = _useState6[0],
	        setData = _useState6[1];
	
	    var _useState7 = (0, _react.useState)("PROCESSING"),
	        _useState8 = _slicedToArray(_useState7, 2),
	        status = _useState8[0],
	        setStatus = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        remainingSeconds = _useState10[0],
	        setRemainingSeconds = _useState10[1];
	
	    var timerIntervalRef = (0, _react.useRef)(null);
	    var pollIntervalRef = (0, _react.useRef)(null);
	    var expireTsRef = (0, _react.useRef)(null);
	
	    var stopTimer = (0, _react.useCallback)(function () {
	        if (timerIntervalRef.current) {
	            clearInterval(timerIntervalRef.current);
	            timerIntervalRef.current = null;
	        }
	    }, []);
	
	    var stopPolling = (0, _react.useCallback)(function () {
	        if (pollIntervalRef.current) {
	            clearInterval(pollIntervalRef.current);
	            pollIntervalRef.current = null;
	        }
	    }, []);
	
	    // Тикаем обратный отсчёт до expireTs (если задан).
	    var recomputeRemaining = (0, _react.useCallback)(function () {
	        if (expireTsRef.current == null) {
	            setRemainingSeconds(null);
	            return;
	        }
	        var now = Math.floor(Date.now() / 1000);
	        var left = expireTsRef.current - now;
	        setRemainingSeconds(left > 0 ? left : 0);
	        if (left <= 0) {
	            stopTimer();
	            setStatus(function (prev) {
	                return FINAL_STATUSES.includes(prev) ? prev : "EXPIRED";
	            });
	        }
	    }, [stopTimer]);
	
	    var applyResponse = (0, _react.useCallback)(function (resp) {
	        if (!resp || resp.ok === false) {
	            setError(resp && resp.error && resp.error.message || "Ошибка загрузки платежа");
	            return;
	        }
	        setData(resp);
	        if (resp.status) {
	            setStatus(resp.status);
	        }
	        expireTsRef.current = resp.expireAtTs != null ? resp.expireAtTs : null;
	        recomputeRemaining();
	
	        if (resp.status && FINAL_STATUSES.includes(resp.status)) {
	            stopPolling();
	            stopTimer();
	        }
	    }, [recomputeRemaining, stopPolling, stopTimer]);
	
	    var fetchData = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var resp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return api.getNpayPage(token);
	
	                    case 3:
	                        resp = _context.sent;
	
	                        applyResponse(resp);
	                        _context.next = 10;
	                        break;
	
	                    case 7:
	                        _context.prev = 7;
	                        _context.t0 = _context["catch"](0);
	
	                        setError("Не удалось загрузить данные оплаты");
	
	                    case 10:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, _this, [[0, 7]]);
	    })), [token, applyResponse]); // eslint-disable-line react-hooks/exhaustive-deps
	
	    // Первичная загрузка + запуск таймера и поллинга.
	    (0, _react.useEffect)(function () {
	        var cancelled = false;
	        _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var resp;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return api.getNpayPage(token);
	
	                        case 3:
	                            resp = _context2.sent;
	
	                            if (!cancelled) {
	                                _context2.next = 6;
	                                break;
	                            }
	
	                            return _context2.abrupt("return");
	
	                        case 6:
	                            applyResponse(resp);
	                            _context2.next = 12;
	                            break;
	
	                        case 9:
	                            _context2.prev = 9;
	                            _context2.t0 = _context2["catch"](0);
	
	                            if (!cancelled) {
	                                setError("Не удалось загрузить данные оплаты");
	                            }
	
	                        case 12:
	                            _context2.prev = 12;
	
	                            if (!cancelled) {
	                                setLoading(false);
	                            }
	                            return _context2.finish(12);
	
	                        case 15:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this, [[0, 9, 12, 15]]);
	        }))();
	
	        timerIntervalRef.current = setInterval(recomputeRemaining, 1000);
	        pollIntervalRef.current = setInterval(fetchData, STATUS_POLL_INTERVAL_MS);
	
	        return function () {
	            cancelled = true;
	            stopTimer();
	            stopPolling();
	        };
	    }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
	
	    if (loading) {
	        return _react2.default.createElement(
	            "div",
	            { className: _npayModule2.default.Wrapper },
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Card },
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.Muted },
	                    "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026"
	                )
	            )
	        );
	    }
	
	    if (error) {
	        return _react2.default.createElement(
	            "div",
	            { className: _npayModule2.default.Wrapper },
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Card },
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.StatusTitle },
	                    "\u041E\u0448\u0438\u0431\u043A\u0430"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.Muted },
	                    error
	                )
	            )
	        );
	    }
	
	    var amountRub = data ? formatMoney(data.amountRub) : null;
	    var amountKgs = data ? formatMoney(data.amountKgs) : null;
	    var showTimer = remainingSeconds != null && !FINAL_STATUSES.includes(status);
	
	    // Финальные состояния — короткий экран результата.
	    if (status === "SUCCESS") {
	        return _react2.default.createElement(
	            "div",
	            { className: _npayModule2.default.Wrapper },
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Card },
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.StatusSuccess },
	                    "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u043E\u0448\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E"
	                ),
	                amountRub && _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.Amount },
	                    amountRub,
	                    " \u20BD"
	                )
	            )
	        );
	    }
	    if (status === "DECLINED") {
	        return _react2.default.createElement(
	            "div",
	            { className: _npayModule2.default.Wrapper },
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Card },
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.StatusDeclined },
	                    "\u041E\u043F\u043B\u0430\u0442\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.Muted },
	                    "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043B\u0430\u0442\u0451\u0436 \u0437\u0430\u043D\u043E\u0432\u043E."
	                )
	            )
	        );
	    }
	    if (status === "EXPIRED") {
	        return _react2.default.createElement(
	            "div",
	            { className: _npayModule2.default.Wrapper },
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Card },
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.StatusDeclined },
	                    "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441\u0441\u044B\u043B\u043A\u0438 \u0438\u0441\u0442\u0451\u043A"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.Muted },
	                    "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u043D\u043E\u0432\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B."
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _npayModule2.default.Wrapper },
	        _react2.default.createElement(
	            "div",
	            { className: _npayModule2.default.Card },
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Title },
	                "\u041E\u043F\u043B\u0430\u0442\u0430 \u0447\u0435\u0440\u0435\u0437 \u0421\u0431\u0435\u0440\u0431\u0430\u043D\u043A \u043F\u043E QR-\u043A\u043E\u0434\u0443"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Amounts },
	                amountRub && _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.Amount },
	                    amountRub,
	                    " \u20BD"
	                ),
	                amountKgs && _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.AmountKgs },
	                    "\u2248 ",
	                    amountKgs,
	                    " KGS"
	                )
	            ),
	            data && data.qrDataUri ? _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.QrBox },
	                _react2.default.createElement("img", { className: _npayModule2.default.Qr, src: data.qrDataUri, alt: "QR-\u043A\u043E\u0434 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B" })
	            ) : _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Muted },
	                "QR-\u043A\u043E\u0434 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D"
	            ),
	            showTimer && _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Timer },
	                _react2.default.createElement(
	                    "span",
	                    { className: _npayModule2.default.TimerLabel },
	                    "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u0432\u0440\u0435\u043C\u0435\u043D\u0438:"
	                ),
	                " ",
	                _react2.default.createElement(
	                    "span",
	                    {
	                        className: remainingSeconds <= 60 ? _npayModule2.default.TimerValueDanger : _npayModule2.default.TimerValue
	                    },
	                    formatTime(remainingSeconds)
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Instruction },
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.InstructionTitle },
	                    "\u041A\u0430\u043A \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C:"
	                ),
	                _react2.default.createElement(
	                    "ol",
	                    { className: _npayModule2.default.Steps },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 ",
	                        _react2.default.createElement(
	                            "b",
	                            null,
	                            "\u0421\u0431\u0435\u0440\u0431\u0430\u043D\u043A \u041E\u043D\u043B\u0430\u0439\u043D"
	                        ),
	                        " \u043D\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "b",
	                            null,
	                            "\xAB\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u043E QR \u0438\u043B\u0438 \u0448\u0442\u0440\u0438\u0445\u043A\u043E\u0434\u0443\xBB"
	                        ),
	                        " (\u0437\u043D\u0430\u0447\u043E\u043A QR \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435 \u0438\u043B\u0438 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \xAB\u041F\u043B\u0430\u0442\u0435\u0436\u0438\xBB)."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041D\u0430\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u0430\u043C\u0435\u0440\u0443 \u043D\u0430 QR-\u043A\u043E\u0434 \u0432\u044B\u0448\u0435."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u0443\u043C\u043C\u0443 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443."
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _npayModule2.default.Note },
	                    "\u041E\u043F\u043B\u0430\u0442\u0430 \u0441 \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430: \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u043A\u0430\u043C\u0435\u0440\u043E\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430."
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _npayModule2.default.Waiting },
	                "\u041E\u0436\u0438\u0434\u0430\u0435\u043C \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u043E\u043F\u043B\u0430\u0442\u044B\u2026"
	            )
	        )
	    );
	}

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InstructionCarousel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pay3Module = __webpack_require__(205);
	
	var _pay3Module2 = _interopRequireDefault(_pay3Module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Тексты инструкций для каждого шага
	var instructionSteps = {
	    sber: ["Нажмите 'Платежи' в нижнем меню приложения", "В поле перевести выберите 'В другую страну'", "Выберите старну перевода", "Нажмите на пункт 'На карту или счёт'", "Укажите номер карты", "Укажите ФИО и сумму для перевода", "Нажмите оплатить"],
	    tbank: ["Нажмите 'Платежи' на главном экране", "Выберите 'По номеру карты' в разделе переводов", "Введите имя получателя и выберите валюту перевода", "Проверьте данные и нажмите 'Перевести'"]
	};
	
	function InstructionCarousel(_ref) {
	    var bank = _ref.bank,
	        images = _ref.images;
	
	    var _useState = (0, _react.useState)(0),
	        _useState2 = _slicedToArray(_useState, 2),
	        currentStep = _useState2[0],
	        setCurrentStep = _useState2[1];
	
	    var steps = instructionSteps[bank] || [];
	
	    if (!images || !images.length || !steps.length) {
	        return null;
	    }
	
	    var goToNext = function goToNext() {
	        setCurrentStep(function (prev) {
	            return (prev + 1) % images.length;
	        });
	    };
	
	    var goToPrev = function goToPrev() {
	        setCurrentStep(function (prev) {
	            return (prev - 1 + images.length) % images.length;
	        });
	    };
	
	    var goToStep = function goToStep(index) {
	        setCurrentStep(index);
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: _pay3Module2.default.CarouselContainer },
	        _react2.default.createElement(
	            "div",
	            { className: _pay3Module2.default.CarouselHeader },
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.CarouselTitle },
	                "\u0428\u0430\u0433 ",
	                currentStep + 1,
	                " \u0438\u0437 ",
	                images.length
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.CarouselStepText },
	                steps[currentStep]
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _pay3Module2.default.CarouselImageWrapper },
	            _react2.default.createElement("img", {
	                src: images[currentStep],
	                alt: "\u0428\u0430\u0433 " + (currentStep + 1),
	                className: _pay3Module2.default.CarouselImage
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _pay3Module2.default.CarouselControls },
	            _react2.default.createElement(
	                "button",
	                {
	                    type: "button",
	                    onClick: goToPrev,
	                    className: _pay3Module2.default.CarouselArrow,
	                    disabled: images.length <= 1
	                },
	                _react2.default.createElement(
	                    "svg",
	                    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
	                    _react2.default.createElement("path", {
	                        d: "M15 18l-6-6 6-6",
	                        stroke: "currentColor",
	                        strokeWidth: "2",
	                        strokeLinecap: "round",
	                        strokeLinejoin: "round"
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.CarouselDots },
	                images.map(function (_, idx) {
	                    return _react2.default.createElement("button", {
	                        key: idx,
	                        type: "button",
	                        onClick: function onClick() {
	                            return goToStep(idx);
	                        },
	                        className: idx === currentStep ? _pay3Module2.default.CarouselDotActive : _pay3Module2.default.CarouselDot,
	                        "aria-label": "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0448\u0430\u0433\u0443 " + (idx + 1)
	                    });
	                })
	            ),
	            _react2.default.createElement(
	                "button",
	                {
	                    type: "button",
	                    onClick: goToNext,
	                    className: _pay3Module2.default.CarouselArrow,
	                    disabled: images.length <= 1
	                },
	                _react2.default.createElement(
	                    "svg",
	                    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
	                    _react2.default.createElement("path", {
	                        d: "M9 18l6-6-6-6",
	                        stroke: "currentColor",
	                        strokeWidth: "2",
	                        strokeLinecap: "round",
	                        strokeLinejoin: "round"
	                    })
	                )
	            )
	        )
	    );
	}

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = Pay3;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactInputMask = __webpack_require__(217);
	
	var _reactInputMask2 = _interopRequireDefault(_reactInputMask);
	
	var _pay3Module = __webpack_require__(205);
	
	var _pay3Module2 = _interopRequireDefault(_pay3Module);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _InstructionCarousel = __webpack_require__(470);
	
	var _InstructionCarousel2 = _interopRequireDefault(_InstructionCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var api = new _Api2.default({
	    token: localStorage.getItem("AUTH_TOKEN")
	});
	
	var PAYMENT_TIMEOUT_SECONDS = 15 * 60; // 15 минут
	var STATUS_POLL_INTERVAL_MS = 10000; // 10 секунд
	
	function getUrlParams() {
	    if (typeof window === "undefined") return {
	        widg: null,
	        unlid: null,
	        email: null,
	        phone: null,
	        amount: null
	    };
	    var params = new URLSearchParams(window.location.search);
	    return {
	        widg: params.get("widg"),
	        unlid: params.get("unlid"),
	        email: params.get("email"),
	        phone: params.get("phone"),
	        amount: params.get("amount")
	    };
	}
	
	var isIOS = function isIOS() {
	    return typeof navigator !== "undefined" && /iPhone|iPad|iPod/i.test(navigator.userAgent);
	};
	
	var isAndroid = function isAndroid() {
	    return typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
	};
	
	var bankLabels = {
	    tbank: "T-Bank",
	    sber: "Сбербанк",
	    sber_hydra: "Сбербанк",
	    sber_craftlite: "Сбербанк"
	};
	
	// Дефолтные лимиты (переопределяются из конфига виджета)
	// NX (Hydra): 1000-110000, Флакон (Craftlite): 500-20000, NX+Флакон: 1000-20000
	var DEFAULT_minAmount = 1000;
	var DEFAULT_maxAmount = 110000;
	
	var normalizeAmount = function normalizeAmount(amt) {
	    var num = parseFloat(String(amt).replace(/\s/g, ""));
	    if (Number.isNaN(num)) return NaN;
	    return Math.round(num);
	};
	
	var TRANSFER_PATH = "/PayTransfer";
	
	function buildTransferUrl(bank, card, amt, recipientName) {
	    var params = new URLSearchParams();
	    if (bank) params.set("bank", bank);
	    if (card) params.set("card", card);
	    if (amt) params.set("amount", amt);
	    if (recipientName) params.set("name", recipientName);
	
	    var qs = params.toString();
	    var suffix = qs ? "?" + qs : "";
	
	    if (typeof window !== "undefined" && window.location && window.location.origin) {
	        return window.location.origin + TRANSFER_PATH + suffix;
	    }
	
	    return TRANSFER_PATH + suffix;
	}
	
	function CopyIcon() {
	    return _react2.default.createElement(
	        "svg",
	        {
	            width: "16",
	            height: "16",
	            viewBox: "0 0 16 16",
	            "aria-hidden": "true",
	            focusable: "false"
	        },
	        _react2.default.createElement("rect", {
	            x: "5",
	            y: "3",
	            width: "8",
	            height: "10",
	            rx: "2",
	            ry: "2",
	            fill: "none",
	            stroke: "#4b5563",
	            strokeWidth: "1.2"
	        }),
	        _react2.default.createElement("rect", {
	            x: "3",
	            y: "5",
	            width: "8",
	            height: "8",
	            rx: "2",
	            ry: "2",
	            fill: "none",
	            stroke: "#9ca3af",
	            strokeWidth: "1.2"
	        })
	    );
	}
	
	function buildBankDeepLinks(bank, platform, card, amt) {
	    if (!card) {
	        return { primaryUrl: "", allUrls: [] };
	    }
	
	    if (bank === "tbank") {
	        var params = "amount=" + encodeURIComponent(amt) + "&targetCardNumber=" + encodeURIComponent(card);
	
	        if (platform === "ios") {
	            var _url = "bank100000000004://Main/Pay/C2C?" + params;
	            return { primaryUrl: _url, allUrls: [_url] };
	        }
	
	        var url = "tinkoffbank://Main/Pay/C2C?" + params;
	        return { primaryUrl: url, allUrls: [url] };
	    }
	
	    if (bank === "sber") {
	        if (platform === "ios") {
	            var _params = "amount=" + encodeURIComponent(amt) + "&isNeedToOpenNextScreen=true" + "&skipContactsScreen=true" + "&to=" + encodeURIComponent(card) + "&type=cardNumber";
	
	            var _paramsP2P = "type=card_number" + "&requisiteNumber=" + encodeURIComponent(card);
	
	            var urls = ["sberbankonline://payments/p2ptransfer?" + _params, "sberbankidlogin://payments/p2ptransfer?" + _params, "sbolonline://payments/p2ptransfer?" + _params, "onlineappmobile://sbolonline/p2ptransfer?" + _params, "onlineios-app://sbolonline/p2ptransfer?" + _params, "budgetonline-ios://sbolonline/p2ptransfer?" + _params, "ios-app-smartonline://sbolonline/p2ptransfer?" + _params, "sberbankonline://payments/p2p?" + _paramsP2P, "sberbankidlogin://payments/p2p?" + _paramsP2P, "sbolonline://payments/p2p?" + _paramsP2P];
	
	            return { primaryUrl: urls[0], allUrls: urls };
	        }
	
	        if (platform === "android") {
	            var _params2 = "type=card_number" + "&requisiteNumber=" + encodeURIComponent(card);
	
	            var _urls = ["intent://ru.sberbankmobile/payments/p2p?" + _params2, "intent://ru.sberbankmobile/android-app/payments/p2p?" + _params2, "android-app://ru.sberbankmobile/payments/p2p?" + _params2, "android-app://ru.sberbankmobile_alpha/payments/p2p?" + _params2, "sberbankonline://payments/p2p?" + _params2];
	
	            return { primaryUrl: _urls[0], allUrls: _urls };
	        }
	
	        var paramsP2P = "type=card_number" + "&requisiteNumber=" + encodeURIComponent(card);
	
	        var _url2 = "sberbankonline://payments/p2p?" + paramsP2P;
	
	        return { primaryUrl: _url2, allUrls: [_url2] };
	    }
	
	    return { primaryUrl: "", allUrls: [] };
	}
	
	function attemptOpenDeepLinks(urls) {
	    if (!urls || !urls.length) return;
	
	    var index = 0;
	
	    var openNext = function openNext() {
	        var url = urls[index];
	
	        try {
	            window.location.href = url;
	        } catch (e) {
	            console.error("Failed to open deeplink", url, e);
	        }
	
	        index += 1;
	        if (index < urls.length) {
	            setTimeout(openNext, 1200);
	        }
	    };
	
	    openNext();
	}
	
	function SuccessIcon() {
	    return _react2.default.createElement(
	        "svg",
	        {
	            width: "64",
	            height: "64",
	            viewBox: "0 0 64 64",
	            fill: "none",
	            style: { display: "block", margin: "0 auto 16px" }
	        },
	        _react2.default.createElement("circle", { cx: "32", cy: "32", r: "30", fill: "#22c55e" }),
	        _react2.default.createElement("path", {
	            d: "M20 32l8 8 16-16",
	            stroke: "#fff",
	            strokeWidth: "4",
	            strokeLinecap: "round",
	            strokeLinejoin: "round",
	            fill: "none"
	        })
	    );
	}
	
	function ErrorIcon() {
	    return _react2.default.createElement(
	        "svg",
	        {
	            width: "64",
	            height: "64",
	            viewBox: "0 0 64 64",
	            fill: "none",
	            style: { display: "block", margin: "0 auto 16px" }
	        },
	        _react2.default.createElement("circle", { cx: "32", cy: "32", r: "30", fill: "#ef4444" }),
	        _react2.default.createElement("path", {
	            d: "M22 22l20 20M42 22l-20 20",
	            stroke: "#fff",
	            strokeWidth: "4",
	            strokeLinecap: "round",
	            fill: "none"
	        })
	    );
	}
	
	function formatTime(seconds) {
	    var mins = Math.floor(seconds / 60);
	    var secs = seconds % 60;
	    return mins.toString().padStart(2, "0") + ":" + secs.toString().padStart(2, "0");
	}
	
	function Pay3() {
	    var _this = this;
	
	    var handlePay = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(buttonConfig) {
	            var bank, provider, buttonId, amtNumber, reqBody, resp, card, amt, ext, recipientName, platform, _buildBankDeepLinks, primaryUrl, allUrls, transferUrl, msg, _resp;
	
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            // buttonConfig = { id, bank, provider, label }
	                            bank = buttonConfig.bank;
	                            provider = buttonConfig.provider;
	                            buttonId = buttonConfig.id;
	
	                            if (!(!widg || !unlid)) {
	                                _context3.next = 6;
	                                break;
	                            }
	
	                            setErrorMessage("Отсутствуют обязательные параметры в URL (widg, unlid)");
	                            return _context3.abrupt("return");
	
	                        case 6:
	                            if (orderId) {
	                                _context3.next = 9;
	                                break;
	                            }
	
	                            setErrorMessage("Сначала создайте заказ");
	                            return _context3.abrupt("return");
	
	                        case 9:
	                            if (validateAmount(amount)) {
	                                _context3.next = 12;
	                                break;
	                            }
	
	                            setErrorMessage("\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043E\u0442 " + minAmount.toLocaleString("ru-RU") + " \u0434\u043E " + maxAmount.toLocaleString("ru-RU") + " \u20BD");
	                            return _context3.abrupt("return");
	
	                        case 12:
	                            amtNumber = normalizeAmount(amount);
	
	                            if (Number.isFinite(amtNumber)) {
	                                _context3.next = 16;
	                                break;
	                            }
	
	                            setErrorMessage("Некорректная сумма");
	                            return _context3.abrupt("return");
	
	                        case 16:
	                            _context3.prev = 16;
	
	                            setLoadingBank(buttonId);
	                            setErrorMessage("");
	                            setQrModal(null);
	
	                            reqBody = {
	                                amount: amtNumber,
	                                currency: "RUB",
	                                bank: bank,
	                                widg: widg,
	                                unlid: unlid,
	                                provider: provider
	                            };
	                            _context3.next = 23;
	                            return api.createMobilePay(reqBody);
	
	                        case 23:
	                            resp = _context3.sent;
	
	                            if (!(resp && resp.provider === "craftlite")) {
	                                _context3.next = 31;
	                                break;
	                            }
	
	                            if (resp.qrUrl) {
	                                _context3.next = 28;
	                                break;
	                            }
	
	                            setErrorMessage("Не удалось получить ссылку для оплаты");
	                            return _context3.abrupt("return");
	
	                        case 28:
	
	                            setQrModal({
	                                provider: "craftlite",
	                                url: resp.qrUrl,
	                                amount: amtNumber,
	                                card: null,
	                                recipientName: null,
	                                bank: null
	                            });
	
	                            startPaymentTracking();
	                            return _context3.abrupt("return");
	
	                        case 31:
	                            if (!(!resp || !resp.cardNumber)) {
	                                _context3.next = 34;
	                                break;
	                            }
	
	                            setErrorMessage("Не удалось получить реквизиты для оплаты");
	                            return _context3.abrupt("return");
	
	                        case 34:
	                            card = resp.cardNumber;
	                            amt = String(amtNumber);
	                            ext = resp.externalRefs || {};
	                            recipientName = ext.name || resp.recipientName || resp.cardHolder || resp.holderName || resp.name || "";
	                            platform = isIOS() ? "ios" : isAndroid() ? "android" : "other";
	                            _buildBankDeepLinks = buildBankDeepLinks(bank, platform, card, amt), primaryUrl = _buildBankDeepLinks.primaryUrl, allUrls = _buildBankDeepLinks.allUrls;
	                            transferUrl = buildTransferUrl(bank, card, amt, recipientName);
	
	
	                            setQrModal({
	                                provider: "hydra",
	                                bank: bank,
	                                url: transferUrl,
	                                amount: amtNumber,
	                                card: card,
	                                recipientName: recipientName
	                            });
	
	                            startPaymentTracking();
	
	                            if ((platform === "ios" || platform === "android") && primaryUrl) {
	                                setTimeout(function () {
	                                    attemptOpenDeepLinks(allUrls);
	                                }, 500);
	                            }
	                            _context3.next = 52;
	                            break;
	
	                        case 46:
	                            _context3.prev = 46;
	                            _context3.t0 = _context3["catch"](16);
	
	                            console.error(_context3.t0);
	
	                            msg = "Неизвестная ошибка";
	
	                            if (_context3.t0) {
	                                _resp = _context3.t0.response;
	
	                                if (_resp && _resp.data) {
	                                    if (_resp.data.message) {
	                                        msg = _resp.data.message;
	                                    } else if (_resp.data.error) {
	                                        msg = _resp.data.error;
	                                    } else if (_context3.t0.message) {
	                                        msg = _context3.t0.message;
	                                    }
	                                } else if (_context3.t0.message) {
	                                    msg = _context3.t0.message;
	                                }
	                            }
	
	                            setErrorMessage("Ошибка при создании платежа: " + msg);
	
	                        case 52:
	                            _context3.prev = 52;
	
	                            setLoadingBank(null);
	                            return _context3.finish(52);
	
	                        case 55:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[16, 46, 52, 55]]);
	        }));
	
	        return function handlePay(_x) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    var _useMemo = (0, _react.useMemo)(function () {
	        return getUrlParams();
	    }, []),
	        widg = _useMemo.widg,
	        unlid = _useMemo.unlid,
	        urlEmail = _useMemo.email,
	        urlPhone = _useMemo.phone,
	        urlAmount = _useMemo.amount;
	
	    var _useState = (0, _react.useState)(urlEmail || ""),
	        _useState2 = _slicedToArray(_useState, 2),
	        email = _useState2[0],
	        setEmail = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(urlPhone || ""),
	        _useState4 = _slicedToArray(_useState3, 2),
	        phone = _useState4[0],
	        setPhone = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(urlAmount || ""),
	        _useState6 = _slicedToArray(_useState5, 2),
	        amount = _useState6[0],
	        setAmount = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        orderId = _useState8[0],
	        setOrderId = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        loadingBank = _useState10[0],
	        setLoadingBank = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(""),
	        _useState12 = _slicedToArray(_useState11, 2),
	        errorMessage = _useState12[0],
	        setErrorMessage = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(null),
	        _useState14 = _slicedToArray(_useState13, 2),
	        qrModal = _useState14[0],
	        setQrModal = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(null),
	        _useState16 = _slicedToArray(_useState15, 2),
	        paymentStatus = _useState16[0],
	        setPaymentStatus = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(PAYMENT_TIMEOUT_SECONDS),
	        _useState18 = _slicedToArray(_useState17, 2),
	        remainingSeconds = _useState18[0],
	        setRemainingSeconds = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(false),
	        _useState20 = _slicedToArray(_useState19, 2),
	        setIsPolling = _useState20[1];
	
	    // Конфигурация кнопок виджета
	
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        widgetButtons = _useState22[0],
	        setWidgetButtons = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(true),
	        _useState24 = _slicedToArray(_useState23, 2),
	        configLoading = _useState24[0],
	        setConfigLoading = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(null),
	        _useState26 = _slicedToArray(_useState25, 2),
	        setConfigError = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(DEFAULT_minAmount),
	        _useState28 = _slicedToArray(_useState27, 2),
	        minAmount = _useState28[0],
	        setMinAmount = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(DEFAULT_maxAmount),
	        _useState30 = _slicedToArray(_useState29, 2),
	        maxAmount = _useState30[0],
	        setMaxAmount = _useState30[1];
	
	    var timerIntervalRef = (0, _react.useRef)(null);
	    var pollingIntervalRef = (0, _react.useRef)(null);
	    var paymentStartTimeRef = (0, _react.useRef)(null);
	    var serverTimeOffsetRef = (0, _react.useRef)(0);
	
	    var stopTimer = (0, _react.useCallback)(function () {
	        if (timerIntervalRef.current) {
	            clearInterval(timerIntervalRef.current);
	            timerIntervalRef.current = null;
	        }
	    }, []);
	
	    var stopPolling = (0, _react.useCallback)(function () {
	        if (pollingIntervalRef.current) {
	            clearInterval(pollingIntervalRef.current);
	            pollingIntervalRef.current = null;
	        }
	        setIsPolling(false);
	    }, []);
	
	    var checkPaymentStatus = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var resp, serverRemaining, elapsed, clientRemaining;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        if (!(!widg || !unlid)) {
	                            _context.next = 2;
	                            break;
	                        }
	
	                        return _context.abrupt("return");
	
	                    case 2:
	                        _context.prev = 2;
	                        _context.next = 5;
	                        return api.checkWidgetStatus({ widg: widg, unlid: unlid });
	
	                    case 5:
	                        resp = _context.sent;
	
	
	                        if (resp && resp.status) {
	                            setPaymentStatus(resp.status);
	
	                            if (typeof resp.remainingSeconds === "number") {
	                                serverRemaining = resp.remainingSeconds;
	                                elapsed = Math.floor((Date.now() - paymentStartTimeRef.current) / 1000);
	                                clientRemaining = Math.max(0, PAYMENT_TIMEOUT_SECONDS - elapsed);
	
	                                serverTimeOffsetRef.current = serverRemaining - clientRemaining;
	                                setRemainingSeconds(serverRemaining);
	                            }
	
	                            if (["COMPLETED", "DECLINED", "EXPIRED"].includes(resp.status)) {
	                                stopPolling();
	                                stopTimer();
	                            }
	                        }
	                        _context.next = 12;
	                        break;
	
	                    case 9:
	                        _context.prev = 9;
	                        _context.t0 = _context["catch"](2);
	
	                        console.error("Status check error:", _context.t0);
	
	                    case 12:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, _this, [[2, 9]]);
	    })), [widg, unlid, stopPolling, stopTimer]);
	
	    var startPaymentTracking = (0, _react.useCallback)(function () {
	        paymentStartTimeRef.current = Date.now();
	        serverTimeOffsetRef.current = 0;
	        setRemainingSeconds(PAYMENT_TIMEOUT_SECONDS);
	        setPaymentStatus("PENDING");
	        setIsPolling(true);
	
	        timerIntervalRef.current = setInterval(function () {
	            var elapsed = Math.floor((Date.now() - paymentStartTimeRef.current) / 1000);
	            var clientRemaining = Math.max(0, PAYMENT_TIMEOUT_SECONDS - elapsed);
	            var syncedRemaining = Math.max(0, clientRemaining + serverTimeOffsetRef.current);
	            setRemainingSeconds(syncedRemaining);
	
	            if (syncedRemaining <= 0) {
	                setPaymentStatus("EXPIRED");
	                stopTimer();
	                stopPolling();
	            }
	        }, 1000);
	
	        pollingIntervalRef.current = setInterval(function () {
	            checkPaymentStatus();
	        }, STATUS_POLL_INTERVAL_MS);
	
	        checkPaymentStatus();
	    }, [checkPaymentStatus, stopTimer, stopPolling]);
	
	    (0, _react.useEffect)(function () {
	        return function () {
	            stopTimer();
	            stopPolling();
	        };
	    }, [stopTimer, stopPolling]);
	
	    // Загрузка конфигурации виджета при старте
	    (0, _react.useEffect)(function () {
	        var loadWidgetConfig = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var config;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (widg) {
	                                    _context2.next = 4;
	                                    break;
	                                }
	
	                                setConfigLoading(false);
	                                setConfigError("Отсутствует параметр widg в URL");
	                                return _context2.abrupt("return");
	
	                            case 4:
	                                _context2.prev = 4;
	                                _context2.next = 7;
	                                return api.getWidgetConfig({ widg: widg });
	
	                            case 7:
	                                config = _context2.sent;
	
	                                if (config && Array.isArray(config.buttons)) {
	                                    setWidgetButtons(config.buttons);
	                                    // Устанавливаем лимиты из конфига
	                                    if (config.minAmount) setMinAmount(config.minAmount);
	                                    if (config.maxAmount) setMaxAmount(config.maxAmount);
	                                } else {
	                                    // Фоллбек: если кнопки не пришли - показываем стандартные
	                                    setWidgetButtons([{ id: 'sber', bank: 'sber', provider: 'hydra', label: 'Сбербанк' }, { id: 'tbank', bank: 'tbank', provider: 'hydra', label: 'T-Bank' }]);
	                                }
	                                _context2.next = 15;
	                                break;
	
	                            case 11:
	                                _context2.prev = 11;
	                                _context2.t0 = _context2["catch"](4);
	
	                                console.error("Failed to load widget config:", _context2.t0);
	                                // Фоллбек на стандартную конфигурацию
	                                setWidgetButtons([{ id: 'sber', bank: 'sber', provider: 'hydra', label: 'Сбербанк' }, { id: 'tbank', bank: 'tbank', provider: 'hydra', label: 'T-Bank' }]);
	
	                            case 15:
	                                _context2.prev = 15;
	
	                                setConfigLoading(false);
	                                return _context2.finish(15);
	
	                            case 18:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[4, 11, 15, 18]]);
	            }));
	
	            return function loadWidgetConfig() {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        loadWidgetConfig();
	    }, [widg]);
	
	    var validateEmail = function validateEmail(emailValue) {
	        return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)
	        );
	    };
	
	    var validatePhone = function validatePhone(phoneValue) {
	        return phoneValue.replace(/\D/g, "").length === 11;
	    };
	
	    var validateAmount = function validateAmount(amt) {
	        var num = normalizeAmount(amt);
	        return num >= minAmount && num <= maxAmount;
	    };
	
	    var formatAmount = function formatAmount(value) {
	        return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	    };
	
	    function createOrder() {
	        if (!validateEmail(email)) {
	            setErrorMessage("Введите корректный email");
	            return;
	        }
	        if (!validatePhone(phone)) {
	            setErrorMessage("Введите корректный телефон");
	            return;
	        }
	        if (!validateAmount(amount)) {
	            setErrorMessage("\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043E\u0442 " + minAmount.toLocaleString("ru-RU") + " \u0434\u043E " + maxAmount.toLocaleString("ru-RU") + " \u20BD");
	            return;
	        }
	
	        var id = Math.floor(100000 + Math.random() * 900000);
	        setOrderId(id);
	        setErrorMessage("");
	    }
	
	    function copyToClipboard(text) {
	        if (!text) return;
	        try {
	            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
	                navigator.clipboard.writeText(text).catch(function (e) {
	                    console.error("Clipboard write failed", e);
	                });
	            } else {
	                var el = document.createElement("textarea");
	                el.value = text;
	                document.body.appendChild(el);
	                el.select();
	                try {
	                    document.execCommand("copy");
	                } catch (err) {
	                    console.error("execCommand copy failed", err);
	                }
	                document.body.removeChild(el);
	            }
	        } catch (e) {
	            console.error("Copy error", e);
	        }
	    }
	
	    var instructionImages = {
	        sber: [__webpack_require__(703), __webpack_require__(704), __webpack_require__(705), __webpack_require__(706), __webpack_require__(707), __webpack_require__(708), __webpack_require__(709)],
	        tbank: [__webpack_require__(710), __webpack_require__(711), __webpack_require__(712), __webpack_require__(713)]
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: _pay3Module2.default.Page },
	        _react2.default.createElement(
	            "div",
	            { className: _pay3Module2.default.Card },
	            _react2.default.createElement(
	                "header",
	                { className: _pay3Module2.default.CardHeader },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _pay3Module2.default.Title },
	                    "\u041E\u043F\u043B\u0430\u0442\u0430 \u0447\u0435\u0440\u0435\u0437 \u0431\u0430\u043D\u043A"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.FormGroup },
	                _react2.default.createElement(
	                    "label",
	                    null,
	                    "Email"
	                ),
	                _react2.default.createElement("input", {
	                    type: "email",
	                    placeholder: "example@mail.com",
	                    value: email,
	                    onChange: function onChange(e) {
	                        return setEmail(e.target.value);
	                    }
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.FormGroup },
	                _react2.default.createElement(
	                    "label",
	                    null,
	                    "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
	                ),
	                _react2.default.createElement(
	                    _reactInputMask2.default,
	                    {
	                        mask: "+7 999 999-99-99",
	                        value: phone,
	                        onChange: function onChange(e) {
	                            return setPhone(e.target.value);
	                        }
	                    },
	                    function (props) {
	                        return _react2.default.createElement("input", Object.assign({}, props, {
	                            type: "text",
	                            placeholder: "+7 900 000-00-00"
	                        }));
	                    }
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.FormGroup },
	                _react2.default.createElement(
	                    "label",
	                    null,
	                    "\u0421\u0443\u043C\u043C\u0430 (\u20BD)"
	                ),
	                _react2.default.createElement("input", {
	                    type: "text",
	                    value: amount,
	                    onChange: function onChange(e) {
	                        return setAmount(formatAmount(e.target.value));
	                    },
	                    placeholder: String(minAmount)
	                }),
	                _react2.default.createElement(
	                    "span",
	                    { className: _pay3Module2.default.Hint },
	                    "\u0421\u0443\u043C\u043C\u0430 \u043E\u0442 ",
	                    minAmount.toLocaleString("ru-RU"),
	                    " \u0434\u043E ",
	                    maxAmount.toLocaleString("ru-RU"),
	                    " \u20BD"
	                )
	            ),
	            !orderId && _react2.default.createElement(
	                "button",
	                {
	                    type: "button",
	                    className: _pay3Module2.default.CreateBtn,
	                    onClick: createOrder,
	                    disabled: !!loadingBank
	                },
	                "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u043A\u0430\u0437"
	            ),
	            orderId && _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.PaymentBlock },
	                _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.BanksTitle },
	                    "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B"
	                ),
	                configLoading ? _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.LoadingText },
	                    "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
	                ) : widgetButtons.length === 0 ? _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.LoadingText },
	                    "\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u044B \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B"
	                ) : widgetButtons.map(function (btn) {
	                    // Определяем класс кнопки и иконку по bank
	                    var btnClass = _pay3Module2.default.PayBtnSber;
	                    var iconSrc = "/img/sber-logo-eng.svg";
	                    var iconClass = _pay3Module2.default.PayIcon;
	
	                    if (btn.bank === 'tbank') {
	                        btnClass = _pay3Module2.default.PayBtnTinkoff;
	                        iconSrc = "/img/t-bank-logo-en.svg";
	                        iconClass = _pay3Module2.default.PayIcon + " " + _pay3Module2.default.PayIconTinkoff;
	                    }
	                    // Все кнопки sber используют стандартный зеленый стиль
	
	                    return _react2.default.createElement(
	                        "button",
	                        {
	                            key: btn.id,
	                            type: "button",
	                            className: btnClass,
	                            onClick: function onClick() {
	                                return handlePay(btn);
	                            },
	                            disabled: !!loadingBank
	                        },
	                        _react2.default.createElement("img", {
	                            src: iconSrc,
	                            alt: bankLabels[btn.bank] || btn.bank,
	                            className: iconClass
	                        })
	                    );
	                }),
	                _react2.default.createElement(
	                    "p",
	                    { className: _pay3Module2.default.SmallNote },
	                    "\u041F\u043E\u0441\u043B\u0435 \u0432\u044B\u0431\u043E\u0440\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u044B \u043F\u0435\u0440\u0435\u0434\u0430\u0434\u0438\u043C \u0441\u0443\u043C\u043C\u0443 \u0438 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0438\u043B\u0438 \u043F\u043E\u043A\u0430\u0436\u0435\u043C QR-\u043A\u043E\u0434. \u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0441 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u2014 \u043E\u043D \u043E\u0442\u043A\u0440\u043E\u0435\u0442 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043E\u043F\u043B\u0430\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430."
	                )
	            )
	        ),
	        loadingBank && _react2.default.createElement(
	            "div",
	            { className: _pay3Module2.default.LoadingOverlay },
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.LoadingBox },
	                _react2.default.createElement("div", { className: _pay3Module2.default.LoadingSpinner }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.LoadingText },
	                    "\u0421\u043E\u0437\u0434\u0430\u0451\u043C \u043F\u043B\u0430\u0442\u0451\u0436 \u0432 ",
	                    bankLabels[loadingBank],
	                    "\u2026"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.LoadingSubtext },
	                    "\u041D\u0435 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u2014 \u0441\u0435\u0439\u0447\u0430\u0441 \u043E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430 \u0438\u043B\u0438 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F QR-\u043A\u043E\u0434."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.LoadingSubtext },
	                    "\u0412\u0430\u0436\u043D\u043E: \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u043E\u0447\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0437\u0430\u043A\u0430\u0437\u0430 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0431\u0430\u043D\u043A\u0430."
	                )
	            )
	        ),
	        errorMessage && _react2.default.createElement(
	            "div",
	            { className: _pay3Module2.default.LoadingOverlay },
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.LoadingBox },
	                _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.LoadingText },
	                    "\u041E\u0448\u0438\u0431\u043A\u0430"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _pay3Module2.default.LoadingSubtext },
	                    errorMessage
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        type: "button",
	                        className: _pay3Module2.default.CreateBtn,
	                        onClick: function onClick() {
	                            return setErrorMessage("");
	                        }
	                    },
	                    "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"
	                )
	            )
	        ),
	        qrModal && _react2.default.createElement(
	            "div",
	            { className: _pay3Module2.default.ModalOverlay },
	            _react2.default.createElement(
	                "div",
	                { className: _pay3Module2.default.ModalContent },
	                paymentStatus === "COMPLETED" ? _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(SuccessIcon, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _pay3Module2.default.LoadingText, style: { color: "#22c55e" } },
	                        "\u041E\u043F\u043B\u0430\u0442\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430!"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _pay3Module2.default.LoadingSubtext },
	                        "\u0421\u043F\u0430\u0441\u0438\u0431\u043E \u0437\u0430 \u043E\u043F\u043B\u0430\u0442\u0443. \u0412\u0430\u0448 \u043F\u043B\u0430\u0442\u0451\u0436 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D."
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button",
	                            className: _pay3Module2.default.CreateBtn,
	                            style: { background: "#22c55e" },
	                            onClick: function onClick() {
	                                setQrModal(null);
	                                setPaymentStatus(null);
	                                stopPolling();
	                                stopTimer();
	                            }
	                        },
	                        "\u0413\u043E\u0442\u043E\u0432\u043E"
	                    )
	                ) : paymentStatus === "DECLINED" ? _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(ErrorIcon, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _pay3Module2.default.LoadingText, style: { color: "#ef4444" } },
	                        "\u041F\u043B\u0430\u0442\u0451\u0436 \u043E\u0442\u043A\u043B\u043E\u043D\u0451\u043D"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _pay3Module2.default.LoadingSubtext },
	                        "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043F\u043B\u0430\u0442\u0451\u0436 \u043D\u0435 \u0431\u044B\u043B \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437."
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button",
	                            className: _pay3Module2.default.CreateBtn,
	                            onClick: function onClick() {
	                                setQrModal(null);
	                                setPaymentStatus(null);
	                                stopPolling();
	                                stopTimer();
	                            }
	                        },
	                        "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
	                    )
	                ) : paymentStatus === "EXPIRED" ? _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(ErrorIcon, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _pay3Module2.default.LoadingText, style: { color: "#ef4444" } },
	                        "\u0412\u0440\u0435\u043C\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u0442\u0435\u043A\u043B\u043E"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _pay3Module2.default.LoadingSubtext },
	                        "\u0412\u0440\u0435\u043C\u044F, \u043E\u0442\u0432\u0435\u0434\u0451\u043D\u043D\u043E\u0435 \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443 (15 \u043C\u0438\u043D\u0443\u0442), \u0438\u0441\u0442\u0435\u043A\u043B\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u043B\u0430\u0442\u0451\u0436."
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button",
	                            className: _pay3Module2.default.CreateBtn,
	                            onClick: function onClick() {
	                                setQrModal(null);
	                                setPaymentStatus(null);
	                                stopPolling();
	                                stopTimer();
	                            }
	                        },
	                        "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
	                    )
	                ) : _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: _pay3Module2.default.CompactTimer },
	                        _react2.default.createElement(
	                            "svg",
	                            {
	                                width: "18",
	                                height: "18",
	                                viewBox: "0 0 24 24",
	                                fill: "none",
	                                style: { flexShrink: 0 }
	                            },
	                            _react2.default.createElement("circle", {
	                                cx: "12",
	                                cy: "12",
	                                r: "9",
	                                stroke: remainingSeconds < 60 ? "#ef4444" : remainingSeconds < 180 ? "#f59e0b" : "#22c55e",
	                                strokeWidth: "2"
	                            }),
	                            _react2.default.createElement("path", {
	                                d: "M12 6v6l4 2",
	                                stroke: remainingSeconds < 60 ? "#ef4444" : remainingSeconds < 180 ? "#f59e0b" : "#22c55e",
	                                strokeWidth: "2",
	                                strokeLinecap: "round"
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: _pay3Module2.default.CompactTimerText },
	                            "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C:"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            {
	                                className: _pay3Module2.default.CompactTimerValue,
	                                style: {
	                                    color: remainingSeconds < 60 ? "#ef4444" : remainingSeconds < 180 ? "#f59e0b" : "#22c55e"
	                                }
	                            },
	                            formatTime(remainingSeconds)
	                        )
	                    ),
	                    qrModal.provider === "craftlite" ? _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.LoadingText },
	                            "\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.QrCodeContainer },
	                            _react2.default.createElement("img", {
	                                src: "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=" + encodeURIComponent(qrModal.url),
	                                alt: "QR \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B",
	                                className: _pay3Module2.default.QrCodeImage
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.QrDetails },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _pay3Module2.default.QrRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _pay3Module2.default.QrRowMain },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowLabel },
	                                        "\u0421\u0443\u043C\u043C\u0430 \u043A \u043E\u043F\u043B\u0430\u0442\u0435"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowValueStrong },
	                                        qrModal.amount.toLocaleString("ru-RU"),
	                                        " \u20BD"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                            return copyToClipboard(String(qrModal.amount));
	                                        },
	                                        className: _pay3Module2.default.QrCopyBtn
	                                    },
	                                    _react2.default.createElement(CopyIcon, null)
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.LoadingSubtext },
	                            "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430 \u0438 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \u043D\u0438\u0436\u0435."
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                className: _pay3Module2.default.CreateBtn,
	                                onClick: function onClick() {
	                                    window.location.href = qrModal.url;
	                                }
	                            },
	                            "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043E\u043F\u043B\u0430\u0442\u044B"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                className: _pay3Module2.default.SecondaryBtn,
	                                onClick: function onClick() {
	                                    setQrModal(null);
	                                    setPaymentStatus(null);
	                                    stopPolling();
	                                    stopTimer();
	                                }
	                            },
	                            "\u041E\u0442\u043C\u0435\u043D\u0430"
	                        )
	                    ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.LoadingText },
	                            "\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0432 ",
	                            bankLabels[qrModal.bank]
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.QrCodeContainer },
	                            _react2.default.createElement("img", {
	                                src: "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=" + encodeURIComponent(qrModal.url),
	                                alt: "QR \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B",
	                                className: _pay3Module2.default.QrCodeImage
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.QrDetails },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _pay3Module2.default.QrDetailsTitle },
	                                "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _pay3Module2.default.QrRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _pay3Module2.default.QrRowMain },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowLabel },
	                                        "\u2116"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowValueMono },
	                                        qrModal.card
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                            return copyToClipboard(qrModal.card);
	                                        },
	                                        className: _pay3Module2.default.QrCopyBtn
	                                    },
	                                    _react2.default.createElement(CopyIcon, null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _pay3Module2.default.QrRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _pay3Module2.default.QrRowMain },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowLabel },
	                                        "\u0424\u0418\u041E"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowValue },
	                                        qrModal.recipientName ? qrModal.recipientName : "ФИО будет показано в приложении банка"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                            return qrModal.recipientName && copyToClipboard(qrModal.recipientName);
	                                        },
	                                        disabled: !qrModal.recipientName,
	                                        className: qrModal.recipientName ? _pay3Module2.default.QrCopyBtn : _pay3Module2.default.QrCopyBtnDisabled
	                                    },
	                                    _react2.default.createElement(CopyIcon, null)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _pay3Module2.default.QrRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _pay3Module2.default.QrRowMain },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowLabel },
	                                        "\u20BD"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: _pay3Module2.default.QrRowValueStrong },
	                                        qrModal.amount.toLocaleString("ru-RU"),
	                                        " \u20BD"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        type: "button",
	                                        onClick: function onClick() {
	                                            return copyToClipboard(String(qrModal.amount));
	                                        },
	                                        className: _pay3Module2.default.QrCopyBtn
	                                    },
	                                    _react2.default.createElement(CopyIcon, null)
	                                )
	                            )
	                        ),
	                        qrModal.bank && instructionImages[qrModal.bank] && _react2.default.createElement(_InstructionCarousel2.default, {
	                            bank: qrModal.bank,
	                            images: instructionImages[qrModal.bank]
	                        }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _pay3Module2.default.LoadingSubtext },
	                            "\u0418\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043E\u043F\u043B\u0430\u0442\u044B \u043D\u0430 \u044D\u0442\u043E\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435."
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                className: _pay3Module2.default.CreateBtn,
	                                onClick: function onClick() {
	                                    window.location.href = qrModal.url;
	                                }
	                            },
	                            "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043E\u043F\u043B\u0430\u0442\u044B"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                className: _pay3Module2.default.SecondaryBtn,
	                                onClick: function onClick() {
	                                    setQrModal(null);
	                                    setPaymentStatus(null);
	                                    stopPolling();
	                                    stopTimer();
	                                }
	                            },
	                            "\u041E\u0442\u043C\u0435\u043D\u0430"
	                        )
	                    )
	                )
	            )
	        )
	    );
	}

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SberDeeplinkPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layout = __webpack_require__(6);
	
	var _SberDeeplinkPageModule = __webpack_require__(623);
	
	var _SberDeeplinkPageModule2 = _interopRequireDefault(_SberDeeplinkPageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SberDeeplinkPage() {
	    // тестовые данные из переписки
	    var card = "5469380076360360"; // при желании можешь вернуть свою 5469...
	    var amount = 4242;
	
	    var androidLinks = [{
	        label: "android-app://ru.sberbankmobile_alpha/payments/p2p",
	        url: "android-app://ru.sberbankmobile_alpha/payments/p2p?type=card_number&requisiteNumber=" + card
	    }, {
	        label: "android-app://ru.sberbankmobile/payments/p2p",
	        url: "android-app://ru.sberbankmobile/payments/p2p?type=card_number&requisiteNumber=" + card
	    }, {
	        label: "sberbankonline://payments/p2p",
	        url: "sberbankonline://payments/p2p?type=card_number&requisiteNumber=" + card
	    }, {
	        label: "intent://ru.sberbankmobile/android-app/payments/p2p",
	        url: "intent://ru.sberbankmobile/android-app/payments/p2p?type=card_number&requisiteNumber=" + card
	    }, {
	        label: "intent://ru.sberbankmobile/payments/p2p",
	        url: "intent://ru.sberbankmobile/payments/p2p?type=card_number&requisiteNumber=" + card
	    }];
	
	    var iosLinks = [{
	        label: "onlineios-app://sbolonline/p2ptransfer",
	        url: "onlineios-app://sbolonline/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }, {
	        label: "onlineappmobile://sbolonline/p2ptransfer",
	        url: "onlineappmobile://sbolonline/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }, {
	        label: "app-online-ios://payments/p2ptransfer",
	        url: "app-online-ios://payments/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }, {
	        label: "budgetonline-ios://sbolonline/p2ptransfer",
	        url: "budgetonline-ios://sbolonline/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }, {
	        label: "ios-app-smartonline://sbolonline/p2ptransfer",
	        url: "ios-app-smartonline://sbolonline/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }, {
	        label: "btripsexpenses://sbolonline/p2ptransfer",
	        url: "btripsexpenses://sbolonline/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }, {
	        label: "sbolonline://payments/p2ptransfer",
	        url: "sbolonline://payments/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }, {
	        label: "sberbankonline://payments/p2ptransfer",
	        url: "sberbankonline://payments/p2ptransfer?amount=" + amount + "&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=" + card + "&type=cardNumber"
	    }];
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: _SberDeeplinkPageModule2.default.sberPage },
	            _react2.default.createElement(
	                _Layout.Container,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: _SberDeeplinkPageModule2.default.sberCard },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _SberDeeplinkPageModule2.default.sberHeader },
	                        _react2.default.createElement(
	                            "h1",
	                            { className: _SberDeeplinkPageModule2.default.sberTitle },
	                            "Sber Deeplink \u0422\u0435\u0441\u0442"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { className: _SberDeeplinkPageModule2.default.sberSubtitle },
	                            "\u0411\u044B\u0441\u0442\u0440\u044B\u0435 \u0441\u0441\u044B\u043B\u043A\u0438 \u0434\u043B\u044F \u0442\u0435\u0441\u0442\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0421\u0431\u0435\u0440\u0430"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _SberDeeplinkPageModule2.default.sberInfo },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _SberDeeplinkPageModule2.default.sberInfoBlock },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _SberDeeplinkPageModule2.default.sberInfoLabel },
	                                "\u041A\u0430\u0440\u0442\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                {
	                                    className: _SberDeeplinkPageModule2.default.sberInfoValue + " " + _SberDeeplinkPageModule2.default.sberInfoValueMono
	                                },
	                                card
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _SberDeeplinkPageModule2.default.sberInfoBlock },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _SberDeeplinkPageModule2.default.sberInfoLabel },
	                                "\u0421\u0443\u043C\u043C\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                {
	                                    className: _SberDeeplinkPageModule2.default.sberInfoValue + " " + _SberDeeplinkPageModule2.default.sberInfoValueAccent
	                                },
	                                amount.toLocaleString("ru-RU"),
	                                " \u20BD"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "section",
	                        { className: _SberDeeplinkPageModule2.default.sberSection },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: _SberDeeplinkPageModule2.default.sberSectionHeader + " " + _SberDeeplinkPageModule2.default.sberSectionHeaderAndroid
	                            },
	                            _react2.default.createElement("span", { className: _SberDeeplinkPageModule2.default.sberSectionIcon }),
	                            _react2.default.createElement(
	                                "h2",
	                                { className: _SberDeeplinkPageModule2.default.sberSectionTitle },
	                                "Android"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _SberDeeplinkPageModule2.default.sberSectionCount },
	                                androidLinks.length,
	                                " \u0441\u0441\u044B\u043B\u043A",
	                                androidLinks.length === 1 ? "а" : "и"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _SberDeeplinkPageModule2.default.sberLinks },
	                            androidLinks.map(function (l) {
	                                return _react2.default.createElement(
	                                    "a",
	                                    {
	                                        key: l.url,
	                                        href: l.url,
	                                        className: _SberDeeplinkPageModule2.default.sberLink + " " + _SberDeeplinkPageModule2.default.sberLinkAndroid
	                                    },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _SberDeeplinkPageModule2.default.sberLinkLabel },
	                                        l.label
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _SberDeeplinkPageModule2.default.sberLinkTag },
	                                        "deeplink"
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "section",
	                        { className: _SberDeeplinkPageModule2.default.sberSection },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: _SberDeeplinkPageModule2.default.sberSectionHeader + " " + _SberDeeplinkPageModule2.default.sberSectionHeaderIos
	                            },
	                            _react2.default.createElement("span", { className: _SberDeeplinkPageModule2.default.sberSectionIcon }),
	                            _react2.default.createElement(
	                                "h2",
	                                { className: _SberDeeplinkPageModule2.default.sberSectionTitle },
	                                "iOS"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _SberDeeplinkPageModule2.default.sberSectionCount },
	                                iosLinks.length,
	                                " \u0441\u0441\u044B\u043B\u043A",
	                                iosLinks.length === 1 ? "а" : "и"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _SberDeeplinkPageModule2.default.sberLinks },
	                            iosLinks.map(function (l) {
	                                return _react2.default.createElement(
	                                    "a",
	                                    {
	                                        key: l.url,
	                                        href: l.url,
	                                        className: _SberDeeplinkPageModule2.default.sberLink + " " + _SberDeeplinkPageModule2.default.sberLinkIos
	                                    },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _SberDeeplinkPageModule2.default.sberLinkLabel },
	                                        l.label
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: _SberDeeplinkPageModule2.default.sberLinkTag },
	                                        "deeplink"
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = PayTransfer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layout = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Те же хелперы, что и в Pay3
	var isIOS = function isIOS() {
	    return typeof navigator !== "undefined" && /iPhone|iPad|iPod/i.test(navigator.userAgent);
	};
	
	var isAndroid = function isAndroid() {
	    return typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
	};
	
	var bankLabels = {
	    tbank: "T-Bank",
	    sber: "Сбербанк"
	};
	
	// Собираем диплинки по банку/платформе
	function buildBankDeepLinks(bank, platform, card, amt) {
	    if (!card) return { primaryUrl: "", allUrls: [] };
	
	    // T-Bank
	    if (bank === "tbank") {
	        var params = "amount=" + encodeURIComponent(amt) + "&targetCardNumber=" + encodeURIComponent(card);
	
	        if (platform === "ios") {
	            var _url = "bank100000000004://Main/Pay/C2C?" + params;
	            return { primaryUrl: _url, allUrls: [_url] };
	        }
	
	        var url = "tinkoffbank://Main/Pay/C2C?" + params;
	        return { primaryUrl: url, allUrls: [url] };
	    }
	
	    // Сбербанк
	    if (bank === "sber") {
	        if (platform === "ios") {
	            // iOS deeplinks для Сбера - расширенный список для максимальной совместимости
	            var _params = "amount=" + encodeURIComponent(amt) + "&isNeedToOpenNextScreen=true" + "&skipContactsScreen=true" + "&to=" + encodeURIComponent(card) + "&type=cardNumber";
	
	            var _paramsP2P = "type=card_number" + "&requisiteNumber=" + encodeURIComponent(card);
	
	            var urls = ["sberbankonline://payments/p2ptransfer?" + _params, "sberbankidlogin://payments/p2ptransfer?" + _params, "sbolonline://payments/p2ptransfer?" + _params, "onlineappmobile://sbolonline/p2ptransfer?" + _params, "onlineios-app://sbolonline/p2ptransfer?" + _params, "budgetonline-ios://sbolonline/p2ptransfer?" + _params, "ios-app-smartonline://sbolonline/p2ptransfer?" + _params, "sberbankonline://payments/p2p?" + _paramsP2P, "sberbankidlogin://payments/p2p?" + _paramsP2P, "sbolonline://payments/p2p?" + _paramsP2P];
	
	            return { primaryUrl: urls[0], allUrls: urls };
	        }
	
	        if (platform === "android") {
	            // Android deeplinks для Сбера - расширенный список
	            var _params2 = "type=card_number" + "&requisiteNumber=" + encodeURIComponent(card);
	
	            var _urls = ["intent://ru.sberbankmobile/payments/p2p?" + _params2, "intent://ru.sberbankmobile/android-app/payments/p2p?" + _params2, "android-app://ru.sberbankmobile/payments/p2p?" + _params2, "android-app://ru.sberbankmobile_alpha/payments/p2p?" + _params2, "sberbankonline://payments/p2p?" + _params2];
	
	            return { primaryUrl: _urls[0], allUrls: _urls };
	        }
	
	        var paramsP2P = "type=card_number" + "&requisiteNumber=" + encodeURIComponent(card);
	
	        var _url2 = "intent://ru.sberbankmobile/payments/p2p?" + paramsP2P;
	
	        return { primaryUrl: _url2, allUrls: [_url2] };
	    }
	
	    return { primaryUrl: "", allUrls: [] };
	}
	
	// Запуск нескольких диплинков подряд
	function attemptOpenDeepLinks(urls) {
	    if (!urls || !urls.length) return;
	
	    var index = 0;
	
	    var openNext = function openNext() {
	        var url = urls[index];
	        try {
	            window.location.href = url;
	        } catch (e) {
	            console.error("Failed to open deeplink", url, e);
	        }
	        index += 1;
	        if (index < urls.length) {
	            setTimeout(openNext, 1200);
	        }
	    };
	
	    openNext();
	}
	
	function copyToClipboard(text) {
	    if (!text) return;
	    try {
	        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
	            navigator.clipboard.writeText(text).catch(function (e) {
	                console.error("Clipboard write failed", e);
	            });
	        } else {
	            var el = document.createElement("textarea");
	            el.value = text;
	            document.body.appendChild(el);
	            el.select();
	            try {
	                document.execCommand("copy");
	            } catch (err) {
	                console.error("execCommand copy failed", err);
	            }
	            document.body.removeChild(el);
	        }
	    } catch (e) {
	        console.error("Copy error", e);
	    }
	}
	
	function PayTransfer() {
	    var _useState = (0, _react.useState)({
	        bank: "",
	        card: "",
	        amount: null,
	        recipientName: "",
	        error: ""
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        data = _useState2[0],
	        setData = _useState2[1];
	
	    var mobile = isIOS() || isAndroid();
	
	    // При заходе по ссылке — читаем параметры и пробуем открыть приложение
	    (0, _react.useEffect)(function () {
	        if (typeof window === "undefined") return;
	
	        var search = window.location.search || "";
	        var qs = new URLSearchParams(search);
	
	        var bank = qs.get("bank") || "";
	        var card = qs.get("card") || "";
	        var amountStr = qs.get("amount") || "";
	        var name = qs.get("name") || "";
	
	        if (!bank || !card || !amountStr) {
	            setData(function (prev) {
	                return Object.assign({}, prev, {
	                    error: "Некорректная ссылка для оплаты."
	                });
	            });
	            return;
	        }
	
	        var platform = isIOS() ? "ios" : isAndroid() ? "android" : "other";
	
	        var _buildBankDeepLinks = buildBankDeepLinks(bank, platform, card, amountStr),
	            primaryUrl = _buildBankDeepLinks.primaryUrl,
	            allUrls = _buildBankDeepLinks.allUrls;
	
	        if (!primaryUrl) {
	            setData({
	                bank: bank,
	                card: card,
	                amount: Number(amountStr) || null,
	                recipientName: name,
	                error: "Для этого банка пока нет автоматического открытия приложения. Используйте реквизиты ниже."
	            });
	            return;
	        }
	
	        setData({
	            bank: bank,
	            card: card,
	            amount: Number(amountStr) || null,
	            recipientName: name,
	            error: ""
	        });
	
	        // На телефоне пробуем открыть приложение сразу
	        if (platform === "ios" || platform === "android") {
	            attemptOpenDeepLinks(allUrls);
	        }
	    }, []);
	
	    var handleOpenAgain = function handleOpenAgain() {
	        if (!data.bank || !data.card || !data.amount) return;
	
	        var platform = isIOS() ? "ios" : isAndroid() ? "android" : "other";
	
	        var _buildBankDeepLinks2 = buildBankDeepLinks(data.bank, platform, data.card, String(data.amount)),
	            allUrls = _buildBankDeepLinks2.allUrls;
	
	        if (allUrls && allUrls.length) {
	            attemptOpenDeepLinks(allUrls);
	        }
	    };
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                "div",
	                {
	                    style: {
	                        maxWidth: 520,
	                        margin: "40px auto",
	                        padding: "24px 20px",
	                        borderRadius: 16,
	                        background: "linear-gradient(135deg, #f9fafb 0%, #eef2ff 80%)",
	                        border: "1px solid #e5e7eb",
	                        boxShadow: "0 18px 30px rgba(15,23,42,0.08), 0 0 1px rgba(15,23,42,0.06)",
	                        fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",system-ui,sans-serif'
	                    }
	                },
	                _react2.default.createElement(
	                    "h1",
	                    {
	                        style: {
	                            fontSize: 20,
	                            fontWeight: 700,
	                            margin: "0 0 8px",
	                            color: "#111827"
	                        }
	                    },
	                    "\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0431\u0430\u043D\u043A\u0430"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    {
	                        style: {
	                            fontSize: 14,
	                            margin: "0 0 12px",
	                            color: "#4b5563"
	                        }
	                    },
	                    data.bank ? "\u0411\u0430\u043D\u043A: " + (bankLabels[data.bank] || data.bank) : "Проверяем данные платежа…"
	                ),
	                data.error && _react2.default.createElement(
	                    "div",
	                    {
	                        style: {
	                            background: "#fef2f2",
	                            border: "1px solid #fecaca",
	                            color: "#b91c1c",
	                            padding: "10px 12px",
	                            borderRadius: 10,
	                            fontSize: 13,
	                            marginBottom: 12
	                        }
	                    },
	                    data.error
	                ),
	                mobile ? _react2.default.createElement(
	                    "p",
	                    {
	                        style: {
	                            fontSize: 14,
	                            margin: "0 0 12px",
	                            color: "#374151"
	                        }
	                    },
	                    "\u041C\u044B \u043F\u044B\u0442\u0430\u0435\u043C\u0441\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430 \u0441 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u043F\u043B\u0430\u0442\u0435\u0436\u043E\u043C. \u0415\u0441\u043B\u0438 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0441\u0435\u043A\u0443\u043D\u0434, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u043D\u0438\u0436\u0435."
	                ) : _react2.default.createElement(
	                    "p",
	                    {
	                        style: {
	                            fontSize: 14,
	                            margin: "0 0 12px",
	                            color: "#374151"
	                        }
	                    },
	                    "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u044D\u0442\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043D\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435, \u0433\u0434\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0431\u0430\u043D\u043A\u0430. \u041F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E \u043C\u044B \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0435\u043C \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0441 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u043F\u043B\u0430\u0442\u0435\u0436\u043E\u043C."
	                ),
	                data.bank && _react2.default.createElement(
	                    "button",
	                    {
	                        type: "button",
	                        onClick: handleOpenAgain,
	                        style: {
	                            width: "100%",
	                            border: "none",
	                            borderRadius: 9999,
	                            padding: "10px 16px",
	                            fontSize: 15,
	                            fontWeight: 600,
	                            background: "linear-gradient(135deg,#4f46e5,#6366f1)",
	                            color: "#fff",
	                            cursor: "pointer",
	                            marginBottom: 16
	                        }
	                    },
	                    "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043B\u0430\u0442\u0451\u0436 \u0432",
	                    " ",
	                    bankLabels[data.bank] || data.bank
	                ),
	                (data.card || data.amount) && _react2.default.createElement(
	                    "div",
	                    {
	                        style: {
	                            marginTop: 8,
	                            padding: "12px 14px",
	                            background: "#ffffff",
	                            borderRadius: 12,
	                            border: "1px solid #e5e7eb",
	                            fontSize: 14
	                        }
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        {
	                            style: {
	                                fontWeight: 600,
	                                marginBottom: 10,
	                                color: "#111827"
	                            }
	                        },
	                        "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u0434\u043B\u044F \u0440\u0443\u0447\u043D\u043E\u0433\u043E \u0432\u0432\u043E\u0434\u0430"
	                    ),
	                    data.card && _react2.default.createElement(
	                        "div",
	                        {
	                            style: {
	                                display: "flex",
	                                alignItems: "center",
	                                justifyContent: "space-between",
	                                gap: 8,
	                                padding: "8px 10px",
	                                borderRadius: 10,
	                                background: "#f9fafb",
	                                marginBottom: 6
	                            }
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                style: {
	                                    display: "flex",
	                                    alignItems: "center",
	                                    gap: 8
	                                }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    style: {
	                                        fontSize: 12,
	                                        fontWeight: 600,
	                                        color: "#111827",
	                                        minWidth: 24
	                                    }
	                                },
	                                "\u2116"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    style: {
	                                        fontFamily: "monospace",
	                                        wordBreak: "break-all",
	                                        fontSize: 13
	                                    }
	                                },
	                                data.card
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                onClick: function onClick() {
	                                    return copyToClipboard(data.card);
	                                },
	                                style: {
	                                    border: "none",
	                                    background: "transparent",
	                                    padding: 4,
	                                    cursor: "pointer",
	                                    fontSize: 12,
	                                    color: "#4b5563"
	                                }
	                            },
	                            "\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
	                        )
	                    ),
	                    data.recipientName && _react2.default.createElement(
	                        "div",
	                        {
	                            style: {
	                                display: "flex",
	                                alignItems: "center",
	                                justifyContent: "space-between",
	                                gap: 8,
	                                padding: "8px 10px",
	                                borderRadius: 10,
	                                background: "#f9fafb",
	                                marginBottom: 6
	                            }
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                style: {
	                                    display: "flex",
	                                    alignItems: "center",
	                                    gap: 8
	                                }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    style: {
	                                        fontSize: 12,
	                                        fontWeight: 600,
	                                        color: "#111827",
	                                        minWidth: 32
	                                    }
	                                },
	                                "\u0424\u0418\u041E"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    style: {
	                                        wordBreak: "break-word",
	                                        fontSize: 13
	                                    }
	                                },
	                                data.recipientName
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                type: "button",
	                                onClick: function onClick() {
	                                    return copyToClipboard(data.recipientName);
	                                },
	                                style: {
	                                    border: "none",
	                                    background: "transparent",
	                                    padding: 4,
	                                    cursor: "pointer",
	                                    fontSize: 12,
	                                    color: "#4b5563"
	                                }
	                            },
	                            "\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
	                        )
	                    ),
	                    data.amount && _react2.default.createElement(
	                        "div",
	                        {
	                            style: {
	                                display: "flex",
	                                alignItems: "center",
	                                justifyContent: "space-between",
	                                gap: 8,
	                                padding: "8px 10px",
	                                borderRadius: 10,
	                                background: "#f9fafb"
	                            }
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                style: {
	                                    display: "flex",
	                                    alignItems: "center",
	                                    gap: 8
	                                }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    style: {
	                                        fontSize: 12,
	                                        fontWeight: 600,
	                                        color: "#111827",
	                                        minWidth: 24
	                                    }
	                                },
	                                "\u20BD"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                style: {
	                                    fontWeight: 600,
	                                    fontSize: 15
	                                }
	                            },
	                            data.amount.toLocaleString("ru-RU"),
	                            " \u20BD"
	                        )
	                    )
	                )
	            )
	        )
	    );
	}

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WikiModule = __webpack_require__(111);
	
	var _WikiModule2 = _interopRequireDefault(_WikiModule);
	
	var _WidgetModule = __webpack_require__(624);
	
	var _WidgetModule2 = _interopRequireDefault(_WidgetModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var WIDGET_URL = "https://my.unlimco.io";
	
	var CopyBtn = function CopyBtn(_ref) {
	    var getText = _ref.getText,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "Скопировать" : _ref$title;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        ok = _useState2[0],
	        setOk = _useState2[1];
	
	    return _react2.default.createElement(
	        "button",
	        {
	            type: "button",
	            className: _WikiModule2.default.copyBtn,
	            title: title,
	            onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return navigator.clipboard.writeText(getText());
	
	                            case 3:
	                                setOk(true);
	                                setTimeout(function () {
	                                    return setOk(false);
	                                }, 1200);
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                console.error("Ошибка копирования:", _context.t0);
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined, [[0, 7]]);
	            }))
	        },
	        ok ? "✓" : "⧉"
	    );
	};
	
	var Code = function Code(_ref3) {
	    var _ref3$lang = _ref3.lang,
	        lang = _ref3$lang === undefined ? "html" : _ref3$lang,
	        children = _ref3.children;
	
	    var pre = (0, _react.useRef)(null);
	    var getText = function getText() {
	        return pre.current ? pre.current.innerText : "";
	    };
	    return _react2.default.createElement(
	        "div",
	        { className: _WikiModule2.default.code },
	        _react2.default.createElement(
	            "div",
	            { className: _WikiModule2.default.codeBar },
	            _react2.default.createElement(
	                "span",
	                { className: _WikiModule2.default.codeLang },
	                lang
	            ),
	            _react2.default.createElement(CopyBtn, { getText: getText })
	        ),
	        _react2.default.createElement(
	            "pre",
	            { ref: pre },
	            _react2.default.createElement(
	                "code",
	                null,
	                children
	            )
	        )
	    );
	};
	
	var Kbd = function Kbd(_ref4) {
	    var children = _ref4.children;
	    return _react2.default.createElement(
	        "kbd",
	        { className: _WikiModule2.default.kbd },
	        children
	    );
	};
	
	var WidgetDocs = function WidgetDocs() {
	    var _useState3 = (0, _react.useState)("1245"),
	        _useState4 = _slicedToArray(_useState3, 1),
	        demoWidg = _useState4[0];
	
	    var _useState5 = (0, _react.useState)("demo-user-123"),
	        _useState6 = _slicedToArray(_useState5, 1),
	        demoUnlid = _useState6[0];
	
	    // Добавляем класс на body для мобильной адаптации только этой страницы
	
	
	    (0, _react.useEffect)(function () {
	        document.body.classList.add("widget-page");
	
	        // Добавляем стили для мобильной адаптации
	        var styleId = "widget-mobile-styles";
	        var styleElement = document.getElementById(styleId);
	
	        if (!styleElement) {
	            styleElement = document.createElement("style");
	            styleElement.id = styleId;
	            styleElement.textContent = "\n                @media (max-width: 640px) {\n                    body.widget-page {\n                        overflow-x: hidden !important;\n                    }\n                    body.widget-page > div > div {\n                        min-width: auto !important;\n                    }\n                    body.widget-page header > div,\n                    body.widget-page footer > div,\n                    body.widget-page > div > div > div,\n                    body.widget-page main {\n                        width: 100% !important;\n                        max-width: 100% !important;\n                        padding: 0 12px !important;\n                        box-sizing: border-box !important;\n                    }\n                    body.widget-page footer span {\n                        font-size: 12px !important;\n                    }\n                }\n            ";
	            document.head.appendChild(styleElement);
	        }
	
	        return function () {
	            document.body.classList.remove("widget-page");
	            var el = document.getElementById(styleId);
	            if (el) {
	                el.remove();
	            }
	        };
	    }, []);
	
	    // Загружаем скрипт виджета для демо
	    (0, _react.useEffect)(function () {
	        var existingScript = document.querySelector('script[src*="widget.js"]');
	        if (!existingScript) {
	            var script = document.createElement("script");
	            script.src = WIDGET_URL + "/widget.js";
	            script.async = true;
	            document.body.appendChild(script);
	        }
	    }, []);
	
	    return _react2.default.createElement(
	        "div",
	        { className: _WikiModule2.default.page },
	        _react2.default.createElement(
	            "main",
	            { className: _WikiModule2.default.container },
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.hero },
	                _react2.default.createElement(
	                    "h1",
	                    { className: _WikiModule2.default.h1 },
	                    "\u0412\u0438\u0434\u0436\u0435\u0442 \u043E\u043F\u043B\u0430\u0442\u044B"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.lead },
	                    "\u0412\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0435\u043C\u0430\u044F \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u0430\u0439\u0442\u0430. \u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0443\u0434\u043E\u0431\u043D\u043E \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0431\u0435\u0437 \u0441\u043B\u043E\u0436\u043D\u043E\u0439 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438 \u2014 \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043E\u0434\u043D\u0443 \u0441\u0442\u0440\u043E\u043A\u0443 \u043A\u043E\u0434\u0430."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.meta },
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "\u0421\u043A\u0440\u0438\u043F\u0442: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            WIDGET_URL,
	                            "/widget.js"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "\u041C\u0435\u0442\u043E\u0434: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "iframe"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041A\u0430\u043A \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C"
	                ),
	                _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u0421\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043E\u043C"
	                        ),
	                        " \u2014 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u044E\u0449\u0435\u043C\u0443 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0443 \u0438 \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u0435:",
	                        _react2.default.createElement(
	                            "ul",
	                            { style: { marginTop: 8, marginLeft: 20 } },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "URL \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u0430\u0439\u0442\u0430, \u0433\u0434\u0435 \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0437\u043C\u0435\u0449\u0451\u043D \u0432\u0438\u0434\u0436\u0435\u0442"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    Kbd,
	                                    null,
	                                    "callbackUrl"
	                                ),
	                                " \u2014 \u0430\u0434\u0440\u0435\u0441 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043E \u0441\u0442\u0430\u0442\u0443\u0441\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 (webhook)"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043A\u043B\u044E\u0447 \u0432\u0438\u0434\u0436\u0435\u0442\u0430"
	                        ),
	                        " \u2014 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0432\u044B\u0434\u0430\u0441\u0442 \u0432\u0430\u043C \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 ",
	                        _react2.default.createElement(
	                            Kbd,
	                            null,
	                            "widg"
	                        ),
	                        " (ID \u0432\u0438\u0434\u0436\u0435\u0442\u0430), \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043C\u0435\u0440\u0447\u0430\u043D\u0442-\u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0443 \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u043C."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u043A\u0440\u0438\u043F\u0442 \u043D\u0430 \u0441\u0430\u0439\u0442"
	                        ),
	                        " \u2014 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u0434 \u043F\u0435\u0440\u0435\u0434 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0438\u043C \u0442\u0435\u0433\u043E\u043C ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "</body>"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u043E\u043F\u043B\u0430\u0442\u044B"
	                        ),
	                        " \u2014 \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u0441 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430\u043C\u0438 ",
	                        _react2.default.createElement(
	                            Kbd,
	                            null,
	                            "widg"
	                        ),
	                        " \u0438 ",
	                        _react2.default.createElement(
	                            Kbd,
	                            null,
	                            "unlid"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0441\u0442\u0430\u0440\u0442"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "1. \u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0441\u043A\u0440\u0438\u043F\u0442"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u043A\u0440\u0438\u043F\u0442 \u0432\u0438\u0434\u0436\u0435\u0442\u0430 \u043F\u0435\u0440\u0435\u0434 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0438\u043C \u0442\u0435\u0433\u043E\u043C ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "</body>"
	                    )
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "html" },
	                    "<script src=\"" + WIDGET_URL + "/widget.js\"></script>"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 24 } },
	                    "2. \u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u043E\u043F\u043B\u0430\u0442\u044B"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 (\u0438\u043B\u0438 \u043B\u044E\u0431\u043E\u0439 \u0434\u0440\u0443\u0433\u043E\u0439 \u044D\u043B\u0435\u043C\u0435\u043D\u0442) \u0441 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430\u043C\u0438 ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "widg"
	                    ),
	                    " \u0438 ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "unlid"
	                    )
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "html" },
	                    "<button widg=\"\u0412\u0410\u0428_\u041A\u041B\u042E\u0427_\u0412\u0418\u0414\u0416\u0415\u0422\u0410\" unlid=\"ID_\u0417\u0410\u041A\u0410\u0417\u0410_\u0418\u041B\u0418_\u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F\">\n    \u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C\n</button>"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note, style: { marginTop: 16 } },
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "\u0413\u043E\u0442\u043E\u0432\u043E!"
	                    ),
	                    " \u041F\u0440\u0438 \u043A\u043B\u0438\u043A\u0435 \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \u043E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u043A\u043D\u043E \u0441 \u0444\u043E\u0440\u043C\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B."
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WidgetModule2.default.paramsTable },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "widg"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439."
	                            ),
	                            " ID \u0432\u0438\u0434\u0436\u0435\u0442\u0430, \u0432\u044B\u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043E\u043C. \u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043C\u0435\u0440\u0447\u0430\u043D\u0442-\u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0443 \u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u0440\u0438\u0451\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 (\u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438, \u043B\u0438\u043C\u0438\u0442\u044B, callback URL)."
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "unlid"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439."
	                            ),
	                            " \u0412\u0430\u0448 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u2014 \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, ID \u0437\u0430\u043A\u0430\u0437\u0430, ID \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043B\u044E\u0431\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430 \u0434\u043B\u044F \u0441\u0432\u044F\u0437\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u0441 \u0432\u0430\u0448\u0435\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439. \u041F\u0435\u0440\u0435\u0434\u0430\u0451\u0442\u0441\u044F \u0432 callback \u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0430."
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0414\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u044F"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0432\u0438\u0434\u0436\u0435\u0442 \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0438. \u042D\u0442\u043E \u0440\u0435\u0430\u043B\u044C\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u0441 \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u043C\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C\u0438."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WidgetModule2.default.demoArea },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _WidgetModule2.default.demoButton,
	                            widg: demoWidg,
	                            unlid: demoUnlid
	                        },
	                        _react2.default.createElement(
	                            "svg",
	                            { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2" },
	                            _react2.default.createElement("rect", { x: "1", y: "4", width: "22", height: "16", rx: "2" }),
	                            _react2.default.createElement("line", { x1: "1", y1: "10", x2: "23", y2: "10" })
	                        ),
	                        "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0437\u0430\u043A\u0430\u0437"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.demoParams },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "widg=\"",
	                                demoWidg,
	                                "\""
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "unlid=\"",
	                                demoUnlid,
	                                "\""
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 24 } },
	                    "\u041A\u043E\u0434 \u044D\u0442\u043E\u0439 \u043A\u043D\u043E\u043F\u043A\u0438"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "html" },
	                    "<button widg=\"" + demoWidg + "\" unlid=\"" + demoUnlid + "\">\n    \u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0437\u0430\u043A\u0430\u0437\n</button>"
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u0439 \u0432\u044B\u0437\u043E\u0432 (JavaScript API)"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041F\u043E\u043C\u0438\u043C\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0438 \u043A \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043C \u0441 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430\u043C\u0438, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u0432\u0438\u0434\u0436\u0435\u0442 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 JavaScript."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432\u0438\u0434\u0436\u0435\u0442"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "javascript" },
	                    "UnlimcoWidget.open({\n    widg: '\u0412\u0410\u0428_\u041A\u041B\u042E\u0427_\u0412\u0418\u0414\u0416\u0415\u0422\u0410',\n    unlid: 'ID_\u0417\u0410\u041A\u0410\u0417\u0410_\u0418\u041B\u0418_\u041F\u041E\u041B\u042C\u0417\u041E\u0412\u0410\u0422\u0415\u041B\u042F'\n});"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0432\u0438\u0434\u0436\u0435\u0442"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "javascript" },
	                    "UnlimcoWidget.close();"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u041F\u0440\u0438\u043C\u0435\u0440 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "html" },
	                    "<button onclick=\"openPayment()\">\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0447\u0435\u0440\u0435\u0437 JS</button>\n\n<script src=\"" + WIDGET_URL + "/widget.js\"></script>\n<script>\nfunction openPayment() {\n    // \u041F\u043E\u043B\u0443\u0447\u0430\u0435\u043C ID \u0437\u0430\u043A\u0430\u0437\u0430 \u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B\n    const orderId = document.getElementById('order-id').value;\n\n    UnlimcoWidget.open({\n        widg: '\u0412\u0410\u0428_\u041A\u041B\u042E\u0427_\u0412\u0418\u0414\u0416\u0415\u0422\u0410',\n        unlid: 'order-' + orderId\n    });\n}\n</script>"
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430\u0445 (Callback)"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430 (\u0443\u0441\u043F\u0435\u0448\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E\u0433\u043E) \u043D\u0430 \u0432\u0430\u0448",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "callbackUrl"
	                    ),
	                    " \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D POST-\u0437\u0430\u043F\u0440\u043E\u0441 \u0441 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0435\u0439 \u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u0424\u043E\u0440\u043C\u0430\u0442 callback"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "json" },
	                    "{\n  \"transactionId\": 2316512,\n  \"externalReference\": null,\n  \"state\": \"COMPLETED\",\n  \"amount\": 5000,\n  \"currency\": \"RUB\",\n  \"processingId\": \"5849a1b2-c3d4-5e6f-7890-abcdef123456\",\n  \"createdAt\": \"2025-12-17T14:30:00+00:00\",\n  \"unlid\": \"order-12345\"\n}"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F state"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WidgetModule2.default.paramsTable },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "COMPLETED"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            "\u041F\u043B\u0430\u0442\u0451\u0436 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D. \u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B."
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "DECLINED"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            "\u041F\u043B\u0430\u0442\u0451\u0436 \u043E\u0442\u043A\u043B\u043E\u043D\u0451\u043D (\u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432, \u043E\u0448\u0438\u0431\u043A\u0430 \u0431\u0430\u043D\u043A\u0430 \u0438 \u0442.\u0434.)"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "CANCELED"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            "\u041F\u043B\u0430\u0442\u0451\u0436 \u043E\u0442\u043C\u0435\u043D\u0451\u043D \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043B\u0438 \u0438\u0441\u0442\u0451\u043A \u0441\u0440\u043E\u043A \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F."
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note, style: { marginTop: 16 } },
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "\u0412\u0430\u0436\u043D\u043E:"
	                    ),
	                    " Callback \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u043C\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0430\u043C\u0438 \u043F\u0440\u0438 \u043E\u0448\u0438\u0431\u043A\u0430\u0445 \u0441\u0435\u0442\u0438 \u0438\u043B\u0438 5xx \u043E\u0442\u0432\u0435\u0442\u0430\u0445. \u0412\u0430\u0448 \u0441\u0435\u0440\u0432\u0435\u0440 \u0434\u043E\u043B\u0436\u0435\u043D \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0442\u044C HTTP 200 \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F."
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0447\u0435\u0440\u0435\u0437 API. \u042D\u0442\u043E \u043F\u043E\u043B\u0435\u0437\u043D\u043E, \u0435\u0441\u043B\u0438 callback \u043D\u0435 \u0434\u043E\u0448\u0451\u043B \u0438\u043B\u0438 \u043D\u0443\u0436\u043D\u043E \u043F\u0435\u0440\u0435\u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u0417\u0430\u043F\u0440\u043E\u0441 \u043F\u043E transactionId"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "bash" },
	                    "curl -X GET 'https://api.unlimco.io/api/hydra/status/{transactionId}' \\\n  -H 'X-Merchant-UUID: \u0412\u0410\u0428_UUID' \\\n  -H 'X-Merchant-Key: \u0412\u0410\u0428_KEY'"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u0417\u0430\u043F\u0440\u043E\u0441 \u043F\u043E unlid"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041C\u043E\u0436\u043D\u043E \u0442\u0430\u043A\u0436\u0435 \u0438\u0441\u043A\u0430\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u043F\u043E \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u043C\u0443 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u0443 ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "unlid"
	                    )
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "bash" },
	                    "curl -X GET 'https://api.unlimco.io/api/hydra/status/{unlid}' \\\n  -H 'X-Merchant-UUID: \u0412\u0410\u0428_UUID' \\\n  -H 'X-Merchant-Key: \u0412\u0410\u0428_KEY'"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u041F\u0440\u0438\u043C\u0435\u0440 \u043E\u0442\u0432\u0435\u0442\u0430"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "json" },
	                    "{\n  \"transactionId\": 2316512,\n  \"externalReference\": null,\n  \"amount\": 5000,\n  \"currency\": \"RUB\",\n  \"processingId\": \"5849a1b2-c3d4-5e6f-7890-abcdef123456\",\n  \"hydraStatus\": \"success\",\n  \"hydraState\": \"COMPLETED\",\n  \"synced\": true,\n  \"createdAt\": \"2025-12-17T14:30:00+00:00\",\n  \"unlid\": \"order-12345\"\n}"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note, style: { marginTop: 16 } },
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435:"
	                    ),
	                    " \u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Merchant-UUID"
	                    ),
	                    " \u0438",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Merchant-Key"
	                    ),
	                    " \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0443."
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041F\u043E\u043B\u043D\u044B\u0439 \u043F\u0440\u0438\u043C\u0435\u0440 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "html" },
	                    "<!DOCTYPE html>\n<html lang=\"ru\">\n<head>\n    <meta charset=\"UTF-8\">\n    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n    <title>\u041C\u043E\u0439 \u043C\u0430\u0433\u0430\u0437\u0438\u043D \u2014 \u041E\u043F\u043B\u0430\u0442\u0430</title>\n    <style>\n        .pay-btn {\n            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n            color: white;\n            border: none;   \n            padding: 16px 32px;\n            font-size: 16px;\n            font-weight: 600;\n            border-radius: 12px;\n            cursor: pointer;\n        }\n        .pay-btn:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n        }\n    </style>\n</head>\n<body>\n    <h1>\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u043A\u0430\u0437\u0430 #12345</h1>\n    <p>\u0421\u0443\u043C\u043C\u0430 \u043A \u043E\u043F\u043B\u0430\u0442\u0435: <strong>5 000 \u20BD</strong></p>\n\n    <!-- \u0421\u043F\u043E\u0441\u043E\u0431 1: \u041A\u043D\u043E\u043F\u043A\u0430 \u0441 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430\u043C\u0438 -->\n    <button class=\"pay-btn\" widg=\"\u0412\u0410\u0428_\u041A\u041B\u042E\u0427\" unlid=\"order-12345\">\n        \u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C 5 000 \u20BD\n    </button>\n\n    <!-- \u0421\u043F\u043E\u0441\u043E\u0431 2: \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u044B\u0439 \u0432\u044B\u0437\u043E\u0432 -->\n    <button class=\"pay-btn\" onclick=\"payOrder()\">\n        \u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0447\u0435\u0440\u0435\u0437 JS\n    </button>\n\n    <!-- \u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0430\u0435\u043C \u0432\u0438\u0434\u0436\u0435\u0442 -->\n    <script src=\"" + WIDGET_URL + "/widget.js\"></script>\n    <script>\n        function payOrder() {\n            UnlimcoWidget.open({\n                widg: '\u0412\u0410\u0428_\u041A\u041B\u042E\u0427',\n                unlid: 'order-12345'\n            });\n        }\n    </script>\n</body>\n</html>"
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041B\u0438\u043C\u0438\u0442\u044B \u0438 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WidgetModule2.default.paramsTable },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "1 000 \u20BD"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "75 000 \u20BD"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            "\u0412\u0430\u043B\u044E\u0442\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "RUB"
	                            ),
	                            " (\u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u0439 \u0440\u0443\u0431\u043B\u044C)"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            "\u0412\u0440\u0435\u043C\u044F \u0436\u0438\u0437\u043D\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "30 \u043C\u0438\u043D\u0443\u0442"
	                            ),
	                            " \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WidgetModule2.default.paramRow },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramName },
	                            "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u0431\u0430\u043D\u043A\u0438"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WidgetModule2.default.paramDesc },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "T-Bank"
	                            ),
	                            " (\u0422\u0438\u043D\u044C\u043A\u043E\u0444\u0444)"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0427\u0430\u0441\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B"
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u041A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043B\u044E\u0447 \u0432\u0438\u0434\u0436\u0435\u0442\u0430?"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0443 \u0438 \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u0435 URL \u0441\u0430\u0439\u0442\u0430 \u0438 \u0430\u0434\u0440\u0435\u0441 \u0434\u043B\u044F callback. \u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "widg"
	                    ),
	                    "."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u041C\u043E\u0436\u043D\u043E \u043B\u0438 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434 \u0432\u0438\u0434\u0436\u0435\u0442\u0430?"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u043A\u043D\u043E \u0432\u0438\u0434\u0436\u0435\u0442\u0430 \u0438\u043C\u0435\u0435\u0442 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0437\u0430\u0439\u043D \u0434\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0443\u0437\u043D\u0430\u0432\u0430\u0435\u043C\u043E\u0441\u0442\u0438 \u0438 \u0434\u043E\u0432\u0435\u0440\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439. \u0421\u0442\u0438\u043B\u0438 \u043A\u043D\u043E\u043F\u043A\u0438 \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0441\u0430\u0439\u0442\u0435 \u0432\u044B \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0435 \u0441\u0430\u043C\u0438."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u041A\u0430\u043A \u0442\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044E?"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0443 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430 \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u0439 \u043A\u043B\u044E\u0447 \u0432\u0438\u0434\u0436\u0435\u0442\u0430. \u0422\u0435\u0441\u0442\u043E\u0432\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0441\u043F\u0438\u0441\u044B\u0432\u0430\u0442\u044C \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0435\u043D\u044C\u0433\u0438."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3, style: { marginTop: 16 } },
	                    "\u0427\u0442\u043E \u0434\u0435\u043B\u0430\u0442\u044C, \u0435\u0441\u043B\u0438 callback \u043D\u0435 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442?"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435, \u0447\u0442\u043E \u0432\u0430\u0448 \u0441\u0435\u0440\u0432\u0435\u0440 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0438\u0437 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0430 \u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 HTTP 200. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0440\u0443\u0447\u043D\u0443\u044E \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u0447\u0435\u0440\u0435\u0437 API. \u0415\u0441\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F \u2014 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443."
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438 \u0438 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430\u043C \u043E\u0431\u0440\u0430\u0449\u0430\u0439\u0442\u0435\u0441\u044C \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0443 \u0438\u043B\u0438 \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443."
	                )
	            ),
	            _react2.default.createElement(
	                "footer",
	                { className: _WikiModule2.default.footer },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    "\xA9 unlimco"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _WikiModule2.default.dot },
	                    "\u2022"
	                ),
	                _react2.default.createElement(
	                    "a",
	                    { className: _WikiModule2.default.link, href: "#top" },
	                    "\u041D\u0430\u0432\u0435\u0440\u0445"
	                )
	            )
	        )
	    );
	};
	
	exports.default = WidgetDocs;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // src/PagesOfCommon/wiki/index.en.js
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WikiModule = __webpack_require__(111);
	
	var _WikiModule2 = _interopRequireDefault(_WikiModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/** Small utilities */
	var Kbd = function Kbd(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        "kbd",
	        { className: _WikiModule2.default.kbd },
	        children
	    );
	};
	
	var apiBaseUrl = (({"NODE_ENV":"production","PUBLIC_URL":"","API_URL":"https://api.test.e-clear.cc","BRAND":"eclear","REACT_APP_SENTRY_TRACES_SAMPLE_RATE":"0.2","REACT_APP_SENTRY_DSN":""}).REACT_APP_API_URL || ("https://api.test.e-clear.cc") || "").replace(/\/$/, "");
	var API_V3_DOCS_URL = apiBaseUrl + "/api/v3/docs";
	
	var CopyBtn = function CopyBtn(_ref2) {
	    var getText = _ref2.getText,
	        _ref2$title = _ref2.title,
	        title = _ref2$title === undefined ? "Copy" : _ref2$title;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        ok = _useState2[0],
	        setOk = _useState2[1];
	
	    return _react2.default.createElement(
	        "button",
	        {
	            type: "button",
	            className: _WikiModule2.default.copyBtn,
	            title: title,
	            onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return navigator.clipboard.writeText(getText());
	
	                            case 3:
	                                setOk(true);
	                                setTimeout(function () {
	                                    return setOk(false);
	                                }, 1200);
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                console.error("Copy error:", _context.t0);
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined, [[0, 7]]);
	            }))
	        },
	        ok ? "✓" : "⧉"
	    );
	};
	
	var Code = function Code(_ref4) {
	    var _ref4$lang = _ref4.lang,
	        lang = _ref4$lang === undefined ? "json" : _ref4$lang,
	        children = _ref4.children;
	
	    var pre = (0, _react.useRef)(null);
	    var getText = function getText() {
	        return pre.current ? pre.current.innerText : "";
	    };
	    return _react2.default.createElement(
	        "div",
	        { className: _WikiModule2.default.code },
	        _react2.default.createElement(
	            "div",
	            { className: _WikiModule2.default.codeBar },
	            _react2.default.createElement(
	                "span",
	                { className: _WikiModule2.default.codeLang },
	                lang
	            ),
	            _react2.default.createElement(CopyBtn, { getText: getText })
	        ),
	        _react2.default.createElement(
	            "pre",
	            { ref: pre },
	            _react2.default.createElement(
	                "code",
	                null,
	                children
	            )
	        )
	    );
	};
	
	/** cURL builders */
	var buildCurlPOST = function buildCurlPOST(base, path, headers, body) {
	    var lines = [];
	    lines.push("curl -X POST '" + base + path + "' \\");
	    headers.forEach(function (h) {
	        return lines.push("  -H '" + h.name + ": " + h.value + "' \\");
	    });
	    lines.push("  -d '" + String(body).replace(/'/g, "'\\''") + "'");
	    return lines.join("\n");
	};
	var buildCurlGET = function buildCurlGET(base, path, headers) {
	    var lines = [];
	    lines.push("curl -X GET '" + base + path + "' \\");
	    headers.forEach(function (h, i) {
	        var isLast = i === headers.length - 1;
	        lines.push("  -H '" + h.name + ": " + h.value + "'" + (isLast ? "" : " \\"));
	    });
	    return lines.join("\n");
	};
	
	/** Providers config (for merchants) */
	var PROVIDERS = {
	    /* === CRAFT (Paycraft) === */
	    craft: {
	        key: "craft",
	        label: "Craft",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: true,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "h2h",
	            label: "H2H (QR code)",
	            path: "/craft/payment",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"client\": \"+79001234567\",\n  \"product\": \"Product name\",\n  \"sum\": 1000,\n  \"h2h\": true,\n  \"externalReference\": \"order-123\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"transactionId\": 2317170,\n  \"trxUuid\": \"c09d5d68-8065-4770-...\",\n  \"processingId\": 1030674,\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalRefs\": {\n    \"payload\": \"https://v1.npay.kg/#00020101...\",\n    \"expire-at\": \"2025-12-24T09:03:04.409Z\"\n  },\n  \"createdAt\": \"2025-12-24T08:54:04+00:00\",\n  \"expiresAt\": \"2025-12-24T09:24:04+00:00\"\n}"
	        }, {
	            key: "widget",
	            label: "Widget (redirect)",
	            path: "/craft/payment",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"client\": \"+79001234567\",\n  \"product\": \"Product name\",\n  \"sum\": 1000,\n  \"externalReference\": \"order-123\",\n  \"redirectUrlSuccess\": \"https://merchant.example/success\",\n  \"redirectUrlError\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"transactionId\": 2316512,\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-...\",\n  \"processingId\": \"abc123...\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"redirectUrl\": \"https://paycraftpayment.com/checkout/...\"\n}"
	        }],
	        status: {
	            path: function path(id) {
	                return "/craft/status/" + (id || "<transactionId>");
	            },
	            success: "{\n  \"transactionId\": 2317170,\n  \"trxUuid\": \"c09d5d68-8065-4770-...\",\n  \"externalReference\": \"order-123\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"pspState\": \"SUCCESS\",\n  \"synced\": true\n}"
	        },
	        callbackSample: "{\n  \"transactionId\": 2317170,\n  \"externalReference\": \"order-123\",\n  \"state\": \"SUCCESS\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\"\n}"
	    },
	
	    /* === HYDRA === */
	    hydra: {
	        key: "hydra",
	        label: "Hydra",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: true,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "p2p",
	            label: "Create payment (P2P)",
	            path: "/hydra/p2p",
	            bodyWithIp: function bodyWithIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\",\n  \"customerIp\": \"203.0.113.17\"\n}";
	            },
	            bodyWithoutIp: function bodyWithoutIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalRefs\": [ /* array of payment details */ ],\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\",\n  \"expiresAt\": \"2025-10-02T21:43:24+00:00\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\"\n}",
	            successLink: "{\n  \"redirectUrl\": \"https://hydra.example/checkout/abc123\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\"\n// or\n// \"paymentUrl\": \"https://pay.e-clear.cc/<uuid>\"\n}"
	        }, {
	            key: "sbp",
	            label: "Create payment (SBP)",
	            path: "/hydra/sbp",
	            bodyWithIp: function bodyWithIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\",\n  \"customerIp\": \"203.0.113.17\"\n}";
	            },
	            bodyWithoutIp: function bodyWithoutIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalRefs\": [ /* array of payment details */ ],\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\",\n  \"expiresAt\": \"2025-10-02T21:43:24+00:00\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\"\n}",
	            successLink: "{\n  \"redirectUrl\": \"https://hydra.example/checkout/abc123\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\"\n// or\n// \"paymentUrl\": \"https://pay.e-clear.cc/<uuid>\"\n}"
	        }],
	        status: {
	            path: function path(id) {
	                return "/hydra/status/" + (id || "<transactionId>");
	            },
	            success: "{\n  \"transactionId\": 2316512,\n  \"externalReference\": \"order-123\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"processingId\": \"5849...8bd9\",\n  \"hydraStatus\": \"COMPLETED\",\n  \"hydraState\": \"COMPLETED\",\n  \"synced\": true,\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\"\n}"
	        },
	        callbackSample: "{\n  \"transactionId\": 2316512,\n  \"externalReference\": \"order-123\",\n  \"state\": \"COMPLETED\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"processingId\": \"5849...8bd9\",\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\"\n}"
	    },
	
	    /* === INTERNAL (Internal methods) === */
	    internal: {
	        key: "internal",
	        label: "Internal",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: false,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "terminals",
	            label: "Terminals list",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"balance\", \"direction\": \"terminals\" }\n}";
	            },
	            successManual: "{\n  \"terminals\": [\n    {\n      \"terminalId\": 123,\n      \"name\": \"Terminal SBP\",\n      \"currency\": \"RUB\",\n      \"balance\": 15000.50,\n      \"transactionBalance\": 1500050,\n      \"transactionBalanceFloat\": 15000.50,\n      \"settlementBalance\": 500000,\n      \"settlementBalanceFloat\": 5000.00,\n      \"actualBalance\": 1000050,\n      \"actualBalanceFloat\": 10000.50\n    },\n    {\n      \"terminalId\": 456,\n      \"name\": \"Terminal Card\",\n      \"currency\": \"RUB\",\n      \"balance\": 8500.00,\n      \"transactionBalance\": 850000,\n      \"transactionBalanceFloat\": 8500.00,\n      \"settlementBalance\": 200000,\n      \"settlementBalanceFloat\": 2000.00,\n      \"actualBalance\": 650000,\n      \"actualBalanceFloat\": 6500.00\n    }\n  ]\n}"
	        }, {
	            key: "terminal_balance",
	            label: "Terminal balance",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"balance\", \"direction\": \"terminal\" },\n  \"terminalId\": 123\n}";
	            },
	            successManual: "{\n  \"terminal\": {\n    \"terminalId\": 123,\n    \"name\": \"Terminal SBP\",\n    \"currency\": \"RUB\",\n    \"balance\": 15000.50,\n    \"transactionBalance\": 1500050,\n    \"transactionBalanceFloat\": 15000.50,\n    \"settlementBalance\": 500000,\n    \"settlementBalanceFloat\": 5000.00,\n    \"actualBalance\": 1000050,\n    \"actualBalanceFloat\": 10000.50\n  }\n}"
	        }, {
	            key: "balance_total",
	            label: "Total balance",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"balance\" }\n}";
	            },
	            successManual: "{\n  \"balance\": [\n    { \"currency\": \"RUB\", \"value\": 23500.50 }\n  ],\n  \"providers\": {\n    \"a1b2c3d4-e5f6-...\": [\n      { \"currency\": \"RUB\", \"value\": 15000.50 }\n    ],\n    \"b2c3d4e5-f6g7-...\": [\n      { \"currency\": \"RUB\", \"value\": 8500.00 }\n    ]\n  },\n  \"balances\": {\n    \"items\": [\n      {\n        \"terminal_id\": 123,\n        \"terminal_name\": \"Terminal SBP\",\n        \"merchant_settings_id\": 456,\n        \"transactionBalance\": 1500050,\n        \"transactionBalanceFloat\": 15000.50,\n        \"settlementBalance\": 500000,\n        \"settlementBalanceFloat\": 5000.00,\n        \"actualBalance\": 1000050,\n        \"actualBalanceFloat\": 10000.50\n      },\n      {\n        \"terminal_id\": 789,\n        \"terminal_name\": \"Terminal Card\",\n        \"merchant_settings_id\": 101,\n        \"transactionBalance\": 850000,\n        \"transactionBalanceFloat\": 8500.00,\n        \"settlementBalance\": 200000,\n        \"settlementBalanceFloat\": 2000.00,\n        \"actualBalance\": 650000,\n        \"actualBalanceFloat\": 6500.00\n      }\n    ],\n    \"totals\": {\n      \"transactionBalance\": 2350050,\n      \"transactionBalanceFloat\": 23500.50,\n      \"settlementBalance\": 700000,\n      \"settlementBalanceFloat\": 7000.00,\n      \"actualBalance\": 1650050,\n      \"actualBalanceFloat\": 16500.50\n    }\n  }\n}"
	        }],
	        callbackSample: null
	    },
	
	    /* === NPAY — QR payments (Kyrgyzstan, npay.kg) === */
	    npay: {
	        key: "npay",
	        label: "NPay (QR)",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: true,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "payment",
	            label: "Create payment",
	            path: "/npay/payments",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"amount\": 100,\n  \"external_reference\": \"order-123\",\n  \"comment\": \"Order #123 payment\",\n  \"redirect_url\": \"https://merchant.example/success\",\n  \"callback_url\": \"https://merchant.example/callback\",\n  \"amount_can_be_changed\": false,\n  \"expire_at\": \"2026-06-25T18:00:00+03:00\"\n}";
	            },
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 281,\n  \"npayGuid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n  \"payload\": \"https://pay.namba.kg/#00020101...6304XXXX\",\n  \"paymentUrl\": \"https://pay.namba.kg/#00020101...6304XXXX\",\n  \"qrBase64\": \"iVBORw0KGgoAAAANSUhEUg...\",\n  \"qrDataUri\": \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUg...\",\n  \"paymentPageUrl\": \"https://my.e-clear.cc/npay/3f8c9a1b...d21\",\n  \"amount\": 100,\n  \"amountRub\": 100,\n  \"amountKgs\": 112.45,\n  \"rate\": 1.1245,\n  \"currency\": \"RUB\",\n  \"expireAt\": \"2026-06-25T18:00:00+03:00\",\n  \"status\": \"PROCESSING\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "payment_status",
	            label: "Payment status",
	            path: "/npay/payments/<transactionId>",
	            bodyWithIp: null,
	            bodyWithoutIp: null,
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 281,\n  \"npayGuid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n  \"status\": \"SUCCESS\",\n  \"providerStatus\": null,\n  \"amount\": 100,\n  \"currency\": \"RUB\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "page",
	            label: "Payment page data",
	            path: "/npay/page/<token>",
	            bodyWithIp: null,
	            bodyWithoutIp: null,
	            successManual: "{\n  \"ok\": true,\n  \"status\": \"PROCESSING\",\n  \"payload\": \"https://pay.namba.kg/#00020101...6304XXXX\",\n  \"qrBase64\": \"iVBORw0KGgoAAAANSUhEUg...\",\n  \"qrDataUri\": \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUg...\",\n  \"amountRub\": 100,\n  \"amountKgs\": 112.45,\n  \"currency\": \"RUB\",\n  \"expireAt\": \"2026-06-25T18:00:00+03:00\",\n  \"expireAtTs\": 1782313080,\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "refund",
	            label: "Create refund",
	            path: "/npay/refunds",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"transaction_id\": 281,\n  \"amount\": 100,\n  \"comment\": \"Refund on customer request\",\n  \"callback_url\": \"https://merchant.example/refund-callback\"\n}";
	            },
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 282,\n  \"parentTransactionId\": 281,\n  \"npayRefundGuid\": \"b2c3d4e5-f6a7-8901-bcde-f12345678901\",\n  \"amount\": 100,\n  \"amountRub\": 100,\n  \"amountKgs\": 112.45,\n  \"rate\": 1.1245,\n  \"currency\": \"RUB\",\n  \"status\": \"pending\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "refund_status",
	            label: "Refund status",
	            path: "/npay/refunds/<transactionId>",
	            bodyWithIp: null,
	            bodyWithoutIp: null,
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 282,\n  \"status\": \"SUCCESS\",\n  \"providerStatus\": \"COMPLETED\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }],
	        status: {
	            path: function path(id) {
	                return "/npay/payments/" + (id || "<transactionId>");
	            },
	            success: "{\n  \"ok\": true,\n  \"transactionId\": 281,\n  \"npayGuid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n  \"status\": \"SUCCESS\",\n  \"providerStatus\": null,\n  \"amount\": 100,\n  \"currency\": \"RUB\",\n  \"request_id\": \"abc123...\"\n}"
	        },
	        callbackSample: "// POST to your callback_url when the payment status changes.\n// Amount is in RUB (the currency of your payment), same as on creation.\n{\n  \"transactionId\": 281,\n  \"externalReference\": \"order-123\",\n  \"state\": \"SUCCESS\",\n  \"providerStatus\": \"COMPLETED\",\n  \"amount\": 100,\n  \"amountRub\": 100,\n  \"currency\": \"RUB\",\n  \"createdAt\": \"2026-06-25T10:30:00+03:00\"\n}\n\n// state: SUCCESS | DECLINED | PENDING",
	        webhookSample: "// This is a webhook FROM NPay TO our server \u2014 handled by us, nothing to do on your side.\n// Shown for reference only. You receive a callback instead (see left).\n// POST /webhooks/npay/{token}\n// Type PAYMENT_ORDER:\n{\n  \"type\": \"PAYMENT_ORDER\",\n  \"data\": {\n    \"externalId\": \"281\",\n    \"status\": \"COMPLETED\",\n    \"guid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n    \"amount\": 11245\n  }\n}\n\n// Type REFUND_ORDER:\n{\n  \"type\": \"REFUND_ORDER\",\n  \"data\": {\n    \"externalId\": \"282\",\n    \"status\": \"COMPLETED\",\n    \"guid\": \"b2c3d4e5-f6a7-8901-bcde-f12345678901\",\n    \"amount\": 11245\n  }\n}",
	        errorSamples: "// 400 \u2014 missing/invalid fields\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"bad_request\", \"message\": \"amount is required and must be numeric\" }\n}\n\n// 400 \u2014 no NPay settings for this merchant\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"bad_request\", \"message\": \"No NPay settings found for this merchant.\" }\n}\n\n// 403 \u2014 invalid credentials\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"access_denied\", \"message\": \"Merchant auth failed.\" }\n}\n\n// 404 \u2014 payment page not found (invalid/expired token)\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"not_found\", \"message\": \"Payment not found\" }\n}\n\n// 500 \u2014 NPay provider error\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"internal_error\", \"message\": \"NPay createOneTimeLink failed: ...\" }\n}"
	    }
	};
	
	/** Page */
	var MerchantsDocsEn = function MerchantsDocsEn() {
	    var _useState3 = (0, _react.useState)("hydra"),
	        _useState4 = _slicedToArray(_useState3, 2),
	        providerKey = _useState4[0],
	        setProviderKey = _useState4[1];
	
	    var _useState5 = (0, _react.useState)("p2p"),
	        _useState6 = _slicedToArray(_useState5, 2),
	        methodKey = _useState6[0],
	        setMethodKey = _useState6[1];
	
	    var provider = PROVIDERS[providerKey];
	
	    var method = (0, _react.useMemo)(function () {
	        var list = provider && provider.methods ? provider.methods : [];
	        var found = null;
	        for (var i = 0; i < list.length; i++) {
	            if (list[i].key === methodKey) {
	                found = list[i];
	                break;
	            }
	        }
	        if (!found && list.length > 0) found = list[0];
	        return found;
	    }, [providerKey, methodKey, provider]);
	
	    var createCurlWithIp = (0, _react.useMemo)(function () {
	        if (!provider || !method || !method.bodyWithIp) return "";
	        var base = provider.baseUrlTest;
	        var bodyStr = method.bodyWithIp(method.label) || "";
	        return buildCurlPOST(base, method.path, provider.headers, bodyStr);
	    }, [provider, method]);
	
	    var createCurlWithoutIp = (0, _react.useMemo)(function () {
	        if (!provider || !method || !method.bodyWithoutIp) return "";
	        var base = provider.baseUrlTest;
	        var bodyStr = method.bodyWithoutIp(method.label) || "";
	        return buildCurlPOST(base, method.path, provider.headers, bodyStr);
	    }, [provider, method]);
	
	    var statusCurl = (0, _react.useMemo)(function () {
	        if (!provider || !provider.supportsStatus) return "";
	        var base = provider.baseUrlTest;
	        var path = provider.status.path("<id>");
	        return buildCurlGET(base, path, provider.headers);
	    }, [provider]);
	
	    // Public GET of the NPay payment page — WITHOUT auth headers.
	    var npayPageCurl = (0, _react.useMemo)(function () {
	        if (!provider || providerKey !== "npay") return "";
	        return buildCurlGET(provider.baseUrlTest, "/npay/page/<token>", []);
	    }, [provider, providerKey]);
	
	    return _react2.default.createElement(
	        "div",
	        { className: _WikiModule2.default.page },
	        _react2.default.createElement(
	            "main",
	            { className: _WikiModule2.default.container },
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.hero },
	                _react2.default.createElement(
	                    "h1",
	                    { className: _WikiModule2.default.h1 },
	                    "API for merchants"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.lead },
	                    "Payments: ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Craft"
	                    ),
	                    " (QR),",
	                    " ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Hydra"
	                    ),
	                    " (P2P, SBP),",
	                    " ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "NPay"
	                    ),
	                    " (QR, Kyrgyzstan). Payouts: ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "TKB"
	                    ),
	                    ", ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "FINS"
	                    ),
	                    ". Card check: ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Antifraud"
	                    ),
	                    "."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.apiV3Banner },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Unified API v3"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "The recommended integration: all methods, consistent formats and request testing."
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "a",
	                        { className: _WikiModule2.default.apiV3Link, href: API_V3_DOCS_URL },
	                        "Open interactive documentation"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.meta },
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Prod: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            provider ? provider.baseUrlProd : ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Test: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            provider ? provider.baseUrlTest : ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Content-Type: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "application/json"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Auth: ",
	                        provider ? provider.authHelp : null
	                    )
	                ),
	                providerKey === "craft" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Craft"
	                    ),
	                    " \u2014 accepting payments via QR code."
	                ),
	                providerKey === "fins" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "Idempotency is handled by the adapter \u2014 you don't need to send a separate ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Idempotency-Key"
	                    ),
	                    ". For your own duplicates use the ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "external_reference"
	                    ),
	                    " field."
	                ),
	                providerKey === "tkb" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "All operations go through a single POST",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "/api/v1"
	                    ),
	                    " with ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "method.type"
	                    ),
	                    ". For TKB payouts it's enough to pass",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "card.number"
	                    ),
	                    "; ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "exp"
	                    ),
	                    "/",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "cvv"
	                    ),
	                    " are not required."
	                ),
	                providerKey === "npay" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "QR payments (Kyrgyzstan, ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "npay.kg"
	                    ),
	                    "). You send the amount ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "in rubles"
	                    ),
	                    " ",
	                    "(",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "amount"
	                    ),
	                    ", ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "currency: RUB"
	                    ),
	                    ") \u2014 we automatically convert it to soms (KGS) at the current rate and build the QR. The customer pays by scanning the QR in their bank app. You get the result on your",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "callback_url"
	                    ),
	                    "; the status is also available via",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "GET /npay/payments/",
	                        "<transactionId>"
	                    ),
	                    "."
	                )
	            ),
	            _react2.default.createElement(
	                "nav",
	                { className: _WikiModule2.default.tabs, role: "tablist", "aria-label": "Integration" },
	                Object.keys(PROVIDERS).map(function (k) {
	                    var active = providerKey === k;
	                    var classes = active ? _WikiModule2.default.tab + " " + _WikiModule2.default.tabActive : _WikiModule2.default.tab;
	                    return _react2.default.createElement(
	                        "button",
	                        {
	                            key: k,
	                            role: "tab",
	                            "aria-selected": active,
	                            className: classes,
	                            onClick: function onClick() {
	                                setProviderKey(k);
	                                var list = PROVIDERS[k] && PROVIDERS[k].methods ? PROVIDERS[k].methods : [];
	                                var first = list.length > 0 ? list[0].key : null;
	                                if (first) setMethodKey(first);
	                            }
	                        },
	                        PROVIDERS[k].label
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                "nav",
	                { className: _WikiModule2.default.tabs, role: "tablist", "aria-label": "Methods" },
	                (provider && provider.methods ? provider.methods : []).map(function (m) {
	                    var active = method && method.key === m.key;
	                    var classes = active ? _WikiModule2.default.tab + " " + _WikiModule2.default.tabActive : _WikiModule2.default.tab;
	                    return _react2.default.createElement(
	                        "button",
	                        {
	                            key: m.key,
	                            role: "tab",
	                            "aria-selected": active,
	                            className: classes,
	                            onClick: function onClick() {
	                                return setMethodKey(m.key);
	                            }
	                        },
	                        m.label
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "How it works"
	                ),
	                providerKey === "craft" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /craft/payment"
	                        ),
	                        " \u2014 create payment."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "H2H"
	                        ),
	                        " (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "h2h: true"
	                        ),
	                        "): returns QR link in ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "externalRefs.payload"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Widget"
	                        ),
	                        " (without ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "h2h"
	                        ),
	                        "): returns ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "redirectUrl"
	                        ),
	                        " to checkout page."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /craft/status/",
	                            "{transactionId}"
	                        ),
	                        " \u2014 check status."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Callback is sent to ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " on status change."
	                    )
	                ) : providerKey === "hydra" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Send ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST ",
	                            method ? method.path : ""
	                        ),
	                        " with body and headers."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "If ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        ),
	                        " is provided \u2014 we return",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "externalRefs"
	                        ),
	                        " and identifiers."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Without ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        ),
	                        " \u2014 we return a payment link (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "redirectUrl"
	                        ),
	                        " or ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentUrl"
	                        ),
	                        ")."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Status check:",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            provider ? provider.status.path("{transactionId}") : ""
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "If ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " is provided \u2014 we send a server callback."
	                    )
	                ) : providerKey === "tkb" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Single route: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v1"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "In the request specify ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "method.type"
	                        ),
	                        ":",
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "payout"
	                                ),
	                                " \u2014 create payout (provider",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "tkb"
	                                ),
	                                ")."
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "balance"
	                                ),
	                                " \u2014 get merchant balance."
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "status"
	                                ),
	                                " \u2014 get status(es) by",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "transactionId"
	                                ),
	                                " or",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "externalReference"
	                                ),
	                                "."
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Callback results are sent to your ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " (if specified)."
	                    )
	                ) : providerKey === "npay" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Create a payment: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /npay/payments"
	                        ),
	                        " with the amount in rubles. The response contains",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionId"
	                        ),
	                        ", a ready-made QR (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "qrDataUri"
	                        ),
	                        " / ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "qrBase64"
	                        ),
	                        ") and the payment-page link ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentPageUrl"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Show the QR to the customer in one of two ways:",
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "Easiest:"
	                                ),
	                                " give them",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "paymentPageUrl"
	                                ),
	                                " \u2014 our ready-made page with the QR, amount and a timer."
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "Your own page:"
	                                ),
	                                " embed the QR as an image \u2014 ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    '<img src="{qrDataUri}">'
	                                ),
	                                ". Or render the QR yourself from the ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "payload"
	                                ),
	                                " string."
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "The customer scans the QR in their bank app and pays."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Get the result: we POST to your ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callback_url"
	                        ),
	                        " ",
	                        "(if provided), and/or poll",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /npay/payments/",
	                            "<transactionId>"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Refund: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /npay/refunds"
	                        ),
	                        " with",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transaction_id"
	                        ),
	                        " and ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "amount"
	                        ),
	                        " (also in rubles)."
	                    )
	                ) : _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Creating payouts (through our adapter):",
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "card: ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "POST /fins/payouts/card"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "SBP: ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "POST /fins/payouts/sbp"
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Idempotency is handled inside the adapter;",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Idempotency-Key"
	                        ),
	                        " is not required. Use",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "external_reference"
	                        ),
	                        " for your own duplicates."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "In ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "recipient"
	                        ),
	                        " you MUST specify:",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "last_name"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "first_name"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "type"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_number"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_date"
	                        ),
	                        " and ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "middle_name"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "em",
	                            null,
	                            "or"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "has_middle_name=false"
	                        ),
	                        " (if there is no middle name)."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Status check:",
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /fins/payouts/status/<transactionId|payoutId>"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Balance check: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /fins/balance"
	                        ),
	                        "."
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "Request body"
	                ),
	                providerKey === "craft" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Required fields"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: _WikiModule2.default.ul },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "client"
	                            ),
	                            " \u2014 client identifier (phone, email, etc.)"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "product"
	                            ),
	                            " \u2014 product/service name"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "sum"
	                            ),
	                            " \u2014 amount in rubles"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Optional fields"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: _WikiModule2.default.ul },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "h2h"
	                            ),
	                            " \u2014 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "true"
	                            ),
	                            " to get QR link, otherwise redirect"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "description"
	                            ),
	                            " \u2014 payment description"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "externalReference"
	                            ),
	                            " \u2014 your external order ID"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "callbackUrl"
	                            ),
	                            " \u2014 URL for status notifications"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "redirectUrlSuccess"
	                            ),
	                            " \u2014 success redirect URL (for Widget)"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "redirectUrlError"
	                            ),
	                            " \u2014 error redirect URL (for Widget)"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "hydra" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "Currency ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "RUB"
	                        ),
	                        ". ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "amount"
	                        ),
	                        " is an integer in rubles.",
	                        _react2.default.createElement("br", null),
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "successUrl"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "declineUrl"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " are optional."
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Option A with ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WikiModule2.default.note },
	                        "Returns ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "externalRefs"
	                        ),
	                        " and identifiers."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithIp(method.label) : "{}"
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Option B without ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WikiModule2.default.note },
	                        "Returns a payment link (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "redirectUrl"
	                        ),
	                        " or",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentUrl"
	                        ),
	                        ")."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "tkb" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "All operations go through ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v1"
	                        ),
	                        ". The body must contain ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "method.type"
	                        ),
	                        ". For payouts use",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "{ method: { type: \"payout\", provider: \"tkb\" } }"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "npay" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    methodKey === "payment_status" || methodKey === "refund_status" ? _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "GET request \u2014 no body needed. Pass",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionId"
	                        ),
	                        " in the URL."
	                    ) : methodKey === "page" ? _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Public"
	                        ),
	                        " GET request \u2014 ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "no"
	                        ),
	                        " ",
	                        "auth headers. ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "token"
	                        ),
	                        " in the URL is the last segment of ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentPageUrl"
	                        ),
	                        " from the create-payment response. The same endpoint is used by our payment page. It does ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "not"
	                        ),
	                        " work with the numeric ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionId"
	                        ),
	                        " (protection against guessing other merchants' payments)."
	                    ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: _WikiModule2.default.note },
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "amount"
	                            ),
	                            " is in ",
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "rubles"
	                            ),
	                            " ",
	                            "(number, e.g. ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "100"
	                            ),
	                            " or ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "100.50"
	                            ),
	                            "). We convert it to soms; ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "currency"
	                            ),
	                            " in the response is ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "RUB"
	                            ),
	                            ".",
	                            methodKey === "payment" && _react2.default.createElement(
	                                "span",
	                                null,
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "redirect_url"
	                                ),
	                                ",",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "callback_url"
	                                ),
	                                ", ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "comment"
	                                ),
	                                ",",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "expire_at"
	                                ),
	                                ",",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "amount_can_be_changed"
	                                ),
	                                " are optional (link lifetime defaults to 30 minutes)."
	                            ),
	                            methodKey === "refund" && _react2.default.createElement(
	                                "span",
	                                null,
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "transaction_id"
	                                ),
	                                " is required (the original payment id). ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "comment"
	                                ),
	                                ",",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "callback_url"
	                                ),
	                                " are optional."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method && method.bodyWithoutIp ? method.bodyWithoutIp(method.label) : "{}"
	                        )
	                    )
	                ) : _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "Currency ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "RUB"
	                        ),
	                        ". ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "amount"
	                        ),
	                        " \u2014 value in rubles. ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "external_reference"
	                        ),
	                        " \u2014 string for your own correlation.",
	                        _react2.default.createElement("br", null),
	                        "For the recipient the following are required:",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "last_name"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "first_name"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "type"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_number"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_date"
	                        ),
	                        " and ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "middle_name"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "em",
	                            null,
	                            "or"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "has_middle_name=false"
	                        ),
	                        ". Fields",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "inn"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "purpose"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "reason"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "email"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "phone"
	                        ),
	                        " are optional (for SBP, phone is required in ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "sbp.phone"
	                        ),
	                        ").",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_date"
	                        ),
	                        " allows formats",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "YYYY-MM-DD"
	                        ),
	                        " and ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "DD.MM.YYYY"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.grid2 },
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.card },
	                    _react2.default.createElement(
	                        "h3",
	                        { className: _WikiModule2.default.h3 },
	                        "Successful response"
	                    ),
	                    providerKey === "npay" ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successManual : "{}"
	                        ),
	                        (methodKey === "payment" || methodKey === "refund") && createCurlWithoutIp && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _WikiModule2.default.h4 },
	                                "cURL example"
	                            ),
	                            _react2.default.createElement(
	                                Code,
	                                { lang: "bash" },
	                                createCurlWithoutIp
	                            )
	                        ),
	                        (methodKey === "payment_status" || methodKey === "refund_status") && statusCurl && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _WikiModule2.default.h4 },
	                                "cURL example"
	                            ),
	                            _react2.default.createElement(
	                                Code,
	                                { lang: "bash" },
	                                statusCurl
	                            )
	                        ),
	                        methodKey === "page" && npayPageCurl && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _WikiModule2.default.h4 },
	                                "cURL example"
	                            ),
	                            _react2.default.createElement(
	                                Code,
	                                { lang: "bash" },
	                                npayPageCurl
	                            )
	                        )
	                    ) : providerKey === "hydra" ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "If ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "customerIp"
	                            ),
	                            " is provided (manual)"
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successManual : "{}"
	                        ),
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "If not provided (redirect)"
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successLink : "{}"
	                        ),
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "cURL example"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WikiModule2.default.note },
	                            "Option A with ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "customerIp"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "bash" },
	                            createCurlWithIp
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WikiModule2.default.note },
	                            "Option B without ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "customerIp"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "bash" },
	                            createCurlWithoutIp
	                        )
	                    ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successManual : "{}"
	                        ),
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "cURL example"
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "bash" },
	                            createCurlWithoutIp
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.card },
	                    _react2.default.createElement(
	                        "h3",
	                        { className: _WikiModule2.default.h3 },
	                        "Errors"
	                    ),
	                    provider && provider.errorSamples ? _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        provider.errorSamples
	                    ) : _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        "// 400 Bad Request \u2014 invalid/missing fields\n{ \"message\": \"error explanation\" }\n\n// 401 or 403 \u2014 authentication errors"
	                    )
	                )
	            ),
	            providerKey === "fins" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Balance check"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "Aggregated CARD+SBP balance. Fields",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "amount_minor"
	                    ),
	                    " / ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "overdraft_minor"
	                    ),
	                    " are in minor units (kopecks). For humans \u2014",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "amount"
	                    ),
	                    "/",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "overdraft"
	                    ),
	                    " in rubles (2 decimals)."
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "Sample response"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "json" },
	                    "{\n  \"ok\": true,\n  \"provider\": \"finstar\",\n  \"balance\": {\n    \"amount\": \"123.45\",\n    \"overdraft\": \"0.00\",\n    \"currency\": \"RUB\",\n    \"amount_minor\": 12345,\n    \"overdraft_minor\": 0\n  },\n  \"request_id\": \"...\"\n}"
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "cURL example"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "bash" },
	                    buildCurlGET(PROVIDERS.fins.baseUrlTest, "/fins/balance", PROVIDERS.fins.headers)
	                )
	            ),
	            provider && provider.supportsStatus && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Status check"
	                ),
	                providerKey === "craft" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            PROVIDERS.craft.status.path("{transactionId}")
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Statuses: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "PROCESSING"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "SUCCESS"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "DECLINED"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.craft.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "cURL"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "bash" },
	                        statusCurl
	                    )
	                ) : providerKey === "hydra" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "Route",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            PROVIDERS.hydra.status.path("{transactionId}")
	                        ),
	                        _react2.default.createElement("br", null),
	                        " Auth headers are the same as for creation."
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Sample response"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.hydra.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "cURL example"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "bash" },
	                        statusCurl
	                    )
	                ) : providerKey === "npay" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "Payment: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            PROVIDERS.npay.status.path("{transactionId}")
	                        ),
	                        _react2.default.createElement("br", null),
	                        "Refund: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /npay/refunds/",
	                            "<transactionId>"
	                        ),
	                        _react2.default.createElement("br", null),
	                        "Same auth headers."
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Sample response"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.npay.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Statuses"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        "// status (ours)  <- providerStatus (NPay)\n\"SUCCESS\"        <- \"COMPLETED\"\n\"DECLINED\"       <- \"CANCELED\" / \"FAILED\" / \"EXPIRED\"\n\"PENDING\"        <- \"ACTIVE\" / \"NEW\"\n\"PROCESSING\"     <- payment just created"
	                    )
	                ) : _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "Single route:",
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET",
	                            " ",
	                            PROVIDERS.fins.status.path("{transactionId|payoutId}")
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "Sample response"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.fins.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "cURL example"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "bash" },
	                        statusCurl
	                    )
	                )
	            ),
	            (providerKey === "craft" || providerKey === "hydra" || providerKey === "tkb" || providerKey === "npay" || providerKey === "fins") && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "Callback (if ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "callbackUrl"
	                    ),
	                    " is set)"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "json" },
	                    providerKey === "craft" ? PROVIDERS.craft.callbackSample : providerKey === "hydra" ? PROVIDERS.hydra.callbackSample : providerKey === "tkb" ? PROVIDERS.tkb.callbackSample : providerKey === "npay" ? PROVIDERS.npay.callbackSample : PROVIDERS.fins.callbackSample
	                ),
	                providerKey === "npay" && PROVIDERS.npay.webhookSample && _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "How the status is updated (reference)"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.npay.webhookSample
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "POST JSON to your callback",
	                    providerKey === "tkb" ? "." : " with retries on network/5xx errors.",
	                    providerKey === "tkb" && _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        "Only HTTP 200 counts as delivered: any other status, a timeout or a broken connection is retried with growing pauses - up to 24 attempts over about 31 hours."
	                    ),
	                    providerKey === "payouts" && _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        "Network errors, 5xx, 408 and 429 are retried for up to three days; other 4xx are treated as final."
	                    ),
	                    providerKey === "payouts" && _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        "Signature in header ",
	                        _react2.default.createElement(
	                            Kbd,
	                            null,
	                            "Sign"
	                        ),
	                        ": HMAC-SHA256 of body, key is your merchant key."
	                    )
	                )
	            ),
	            providerKey === "craft" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Payment statuses (pspState)"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "Statuses returned in the ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "pspState"
	                    ),
	                    " field when checking payment status (",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "GET /craft/status/",
	                        "{id}"
	                    ),
	                    ") or in webhook callback:"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Status"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Type"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "SUCCESS"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Final"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment completed successfully"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "DECLINED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Final"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment declined or cancelled"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PROCESSING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Intermediate"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment is being processed, awaiting confirmation"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "ERROR"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Final"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Error during payment processing"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "ALREADY_EXISTS"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Error"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment with this ID has already been submitted (duplicate)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "NOT_FOUND"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Critical error"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment not found in the provider system"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "null"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "No data"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Status unavailable, no information from provider"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "hydra" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Transaction statuses"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "Statuses that may be returned in ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "state"
	                    ),
	                    " / ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "hydraState"
	                    ),
	                    " fields:"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Status"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PENDING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment created, awaiting payment"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PROCESSING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment is being processed"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "COMPLETED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment completed successfully"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "AUTHORIZED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment authorized (success)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "DECLINED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment declined"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "CANCELED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment cancelled by user or system"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "EXPIRED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment time expired"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "ERROR"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Error during payment processing"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "tkb" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Transaction statuses"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "Statuses that may be returned in the ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "transactionType"
	                    ),
	                    " field:"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Status"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT_CREATED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout created, awaiting processing"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT_PENDING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout is being processed"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout completed successfully"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT_DECLINE"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout declined"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "fins" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Transaction statuses"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "Normalized statuses in the ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "status"
	                    ),
	                    " field of the response:"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Status"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "success"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout completed successfully"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "pending"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout is being processed"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "declined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout declined"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note, style: { marginTop: "1rem" } },
	                    "Original provider statuses (",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "last_operation_status"
	                    ),
	                    " field):"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Status"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "approve"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation approved (success)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "approved"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation approved (success)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "pending"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation awaiting processing"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "processing"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation in progress"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "created"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation created"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "decline"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation declined"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "declined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation declined"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "failed"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Execution error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "canceled"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation cancelled"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "expired"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation time expired"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "payouts" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Request statuses"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "Statuses returned in the ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "status"
	                    ),
	                    " / ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "statusCode"
	                    ),
	                    " fields:"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Status"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "0"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "created"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Request created"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "7"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "awaitingPayout"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Awaiting payout (antifraud passed)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "3"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "inRegistry"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Included in payout registry"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "4"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "processing"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout is being processed"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "5"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "success"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout completed successfully"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "6"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "failed"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payout failed"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "1"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "antifraudDeclined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Blocked by antifraud"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "2"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "declined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Declined"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "payouts" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Authentication"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "Two authentication methods are supported:"
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "Method 1: Simple authentication"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _WikiModule2.default.ul },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Merchant-UUID"
	                        ),
	                        " \u2014 Merchant UUID"
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Merchant-Key"
	                        ),
	                        " \u2014 Merchant API key"
	                    )
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "Method 2: HMAC signature"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _WikiModule2.default.ul },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "Merchant"
	                        ),
	                        " \u2014 Merchant UUID"
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "Sign"
	                        ),
	                        " \u2014 HMAC-SHA256 signature of the request body with your key"
	                    )
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "bash" },
	                    "# Signature generation example\nSIGN=$(echo -n '$JSON_BODY' | openssl dgst -sha256 -hmac '$MERCHANT_KEY' | awk '{print $2}')\ncurl -X POST 'https://api.e-clear.cc/api/v2/payout-request' \\\n  -H 'Content-Type: application/json' \\\n  -H 'Merchant: <YOUR-UUID>' \\\n  -H 'Sign: '$SIGN \\\n  -d '$JSON_BODY'"
	                )
	            ),
	            providerKey === "fins" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "Provider error codes (4PMTS)"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "When a payout is declined, the provider returns a numeric ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "error_code"
	                    ),
	                    " and text description. Below is the complete reference of codes grouped by category. The error code is returned in the ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "error.details.error_code"
	                    ),
	                    " field of the response."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "System errors (100\u2013114)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "100"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Unknown system error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "101"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Resource not found (transaction/payout does not exist)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "102"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation unavailable for this order"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "103"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Method not allowed for this order"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "104"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Duplicate request (idempotency key)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "105"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Input parameter validation error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "106"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid request format"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "107"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Rate limit exceeded"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "108"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Authorization error (invalid token/key)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "109"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Access denied (no permissions for operation)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "110"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation temporarily unavailable (maintenance)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "111"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Provider request timeout"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "112"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Provider connection error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "113"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Internal processing error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "114"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Unsupported currency"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "Antifraud (200\u2013280)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "200"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Transaction declined by antifraud system"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "201"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Suspected fraud"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "202"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card is blacklisted"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "203"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "IP address is blacklisted"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "204"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card country not allowed"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "205"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Amount limit exceeded"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "206"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Transaction count limit exceeded"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "207"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card expired"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "210"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Declined by 3D-Secure check"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "250"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid recipient data"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "260"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient is on sanctions list"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "270"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient bank not supported"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "280"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient account closed or blocked"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "3D-Secure (300\u2013308)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "300"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3D-Secure authentication error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "301"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3D-Secure unavailable"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "302"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "User failed 3D-Secure"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "303"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3D-Secure timeout"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "304"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3D-Secure redirect error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "305"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid 3DS server response"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "306"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3DS required but not supported by card"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "307"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Declined by issuer during 3DS check"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "308"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3DS verification not completed"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "Provider/bank errors (400\u2013503)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "400"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "General provider error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "401"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Insufficient funds on sender account"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "402"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Transaction declined by bank"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "403"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card limit exceeded"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "404"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card not found / invalid card number"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "405"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card blocked"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "406"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card expired"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "407"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid CVV/CVC"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "408"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card type not supported"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "409"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Issuing bank unavailable"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "410"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Duplicate transaction"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "411"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid transaction amount"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "412"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid currency"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "420"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Provider technical error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "430"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Acquirer bank response timeout"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "440"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation not supported by terminal"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "450"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Insufficient funds for payout"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "500"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Internal payment service error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "501"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Service temporarily unavailable"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "502"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Gateway error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "503"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Service overloaded"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "Issuer bank responses (601\u2013699)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "601"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Issuer declined without explanation"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "602"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Suspected fraud (issuer)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "603"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card restricted for this type of operation"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "604"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card seized / lost / stolen"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "605"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid PIN"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "606"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "PIN attempt limit exceeded"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "607"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Cardholder should contact issuer"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "610"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Amount exceeds allowed limit"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "620"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Insufficient funds"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "630"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Account closed"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "640"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Transaction declined: country restrictions"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "650"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid card details"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "660"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Issuer response timeout"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "699"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Other issuer decline"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "Extended codes (720\u2013779)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "720"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Payment routing error"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "721"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid recurring payment parameters"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "722"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Subscription cancelled"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "723"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Card token is invalid"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "730"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Refund not possible (period expired)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "731"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Partial refund not supported"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "740"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Operation requires user confirmation"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "750"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid phone number format"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "760"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid email format"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "770"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid recipient personal data"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "779"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Other validation errors"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "SBP codes (801\u2013854)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Code"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Description"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "801"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient bank is not an SBP participant"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "802"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient not found in SBP system"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "803"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient account not linked to SBP"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "804"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "SBP transfer timeout"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "805"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "SBP transfer declined by recipient bank"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "806"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid phone number format for SBP"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "807"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid bank_member_id"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "808"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "SBP transfer limit exceeded"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "810"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "SBP technical failure"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "820"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "SBP unavailable (maintenance)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "830"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient restricted SBP transfers"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "840"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Invalid SBP QR code parameters"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "850"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Declined by SBP antifraud system"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "851"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Suspicious operation (SBP)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "852"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Recipient is on SBP stop list"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "853"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Amount below SBP minimum"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "854"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "Amount exceeds SBP maximum"
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "footer",
	                { className: _WikiModule2.default.footer },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    "\xA9 E-clear"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _WikiModule2.default.dot },
	                    "\u2022"
	                ),
	                _react2.default.createElement(
	                    "a",
	                    { className: _WikiModule2.default.link, href: "#top" },
	                    "Back to top"
	                )
	            )
	        )
	    );
	};
	
	exports.default = MerchantsDocsEn;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WikiModule = __webpack_require__(111);
	
	var _WikiModule2 = _interopRequireDefault(_WikiModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/** Мелкие утилиты */
	var Kbd = function Kbd(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        "kbd",
	        { className: _WikiModule2.default.kbd },
	        children
	    );
	};
	
	var apiBaseUrl = (({"NODE_ENV":"production","PUBLIC_URL":"","API_URL":"https://api.test.e-clear.cc","BRAND":"eclear","REACT_APP_SENTRY_TRACES_SAMPLE_RATE":"0.2","REACT_APP_SENTRY_DSN":""}).REACT_APP_API_URL || ("https://api.test.e-clear.cc") || "").replace(/\/$/, "");
	var API_V3_DOCS_URL = apiBaseUrl + "/api/v3/docs";
	
	var CopyBtn = function CopyBtn(_ref2) {
	    var getText = _ref2.getText,
	        _ref2$title = _ref2.title,
	        title = _ref2$title === undefined ? "Скопировать" : _ref2$title;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        ok = _useState2[0],
	        setOk = _useState2[1];
	
	    return _react2.default.createElement(
	        "button",
	        {
	            type: "button",
	            className: _WikiModule2.default.copyBtn,
	            title: title,
	            onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return navigator.clipboard.writeText(getText());
	
	                            case 3:
	                                setOk(true);
	                                setTimeout(function () {
	                                    return setOk(false);
	                                }, 1200);
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                console.error("Ошибка копирования:", _context.t0);
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined, [[0, 7]]);
	            }))
	        },
	        ok ? "✓" : "⧉"
	    );
	};
	
	var Code = function Code(_ref4) {
	    var _ref4$lang = _ref4.lang,
	        lang = _ref4$lang === undefined ? "json" : _ref4$lang,
	        children = _ref4.children;
	
	    var pre = (0, _react.useRef)(null);
	    var getText = function getText() {
	        return pre.current ? pre.current.innerText : "";
	    };
	    return _react2.default.createElement(
	        "div",
	        { className: _WikiModule2.default.code },
	        _react2.default.createElement(
	            "div",
	            { className: _WikiModule2.default.codeBar },
	            _react2.default.createElement(
	                "span",
	                { className: _WikiModule2.default.codeLang },
	                lang
	            ),
	            _react2.default.createElement(CopyBtn, { getText: getText })
	        ),
	        _react2.default.createElement(
	            "pre",
	            { ref: pre },
	            _react2.default.createElement(
	                "code",
	                null,
	                children
	            )
	        )
	    );
	};
	
	/** Вспомогательные генераторы cURL */
	var buildCurlPOST = function buildCurlPOST(base, path, headers, body) {
	    var lines = [];
	    lines.push("curl -X POST '" + base + path + "' \\");
	    headers.forEach(function (h) {
	        return lines.push("  -H '" + h.name + ": " + h.value + "' \\");
	    });
	    lines.push("  -d '" + String(body).replace(/'/g, "'\\''") + "'");
	    return lines.join("\n");
	};
	var buildCurlGET = function buildCurlGET(base, path, headers) {
	    var lines = [];
	    lines.push("curl -X GET '" + base + path + "' \\");
	    headers.forEach(function (h, i) {
	        var isLast = i === headers.length - 1;
	        lines.push("  -H '" + h.name + ": " + h.value + "'" + (isLast ? "" : " \\"));
	    });
	    return lines.join("\n");
	};
	
	/** Конфиги провайдеров (для мерчанта) */
	var PROVIDERS = {
	    /* === CRAFT (Paycraft) === */
	    craft: {
	        key: "craft",
	        label: "Craft",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: true,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "h2h",
	            label: "H2H (QR-код)",
	            path: "/craft/payment",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"client\": \"+79001234567\",\n  \"product\": \"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0432\u0430\u0440\u0430\",\n  \"sum\": 1000,\n  \"h2h\": true,\n  \"externalReference\": \"order-123\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"transactionId\": 2317170,\n  \"trxUuid\": \"c09d5d68-8065-4770-...\",\n  \"processingId\": 1030674,\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalRefs\": {\n    \"payload\": \"https://v1.npay.kg/#00020101...\",\n    \"expire-at\": \"2025-12-24T09:03:04.409Z\"\n  },\n  \"createdAt\": \"2025-12-24T08:54:04+00:00\",\n  \"expiresAt\": \"2025-12-24T09:24:04+00:00\"\n}"
	        }, {
	            key: "widget",
	            label: "Widget (редирект)",
	            path: "/craft/payment",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"client\": \"+79001234567\",\n  \"product\": \"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0432\u0430\u0440\u0430\",\n  \"sum\": 1000,\n  \"externalReference\": \"order-123\",\n  \"redirectUrlSuccess\": \"https://merchant.example/success\",\n  \"redirectUrlError\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"transactionId\": 2316512,\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-...\",\n  \"processingId\": \"abc123...\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"redirectUrl\": \"https://paycraftpayment.com/checkout/...\"\n}"
	        }],
	        status: {
	            path: function path(id) {
	                return "/craft/status/" + (id || "<transactionId>");
	            },
	            success: "{\n  \"transactionId\": 2317170,\n  \"trxUuid\": \"c09d5d68-8065-4770-...\",\n  \"externalReference\": \"order-123\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"pspState\": \"SUCCESS\",\n  \"synced\": true\n}"
	        },
	        callbackSample: "{\n  \"transactionId\": 2317170,\n  \"externalReference\": \"order-123\",\n  \"state\": \"SUCCESS\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\"\n}",
	        errorSamples: "// 400 Bad Request \u2014 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F\n{\n  \"code\": \"200\",\n  \"message\": \"client is required\"\n}\n\n// 400 Bad Request \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435\n{\n  \"code\": \"200\",\n  \"message\": \"amount must be > 0\"\n}\n\n// 403 Forbidden \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0443\u0447\u0451\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\n{\n  \"code\": \"200\",\n  \"message\": \"Merchant auth failed.\"\n}\n\n// 500 Internal Server Error \u2014 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430\n// Craft \u043F\u0435\u0440\u0435\u0434\u0430\u0451\u0442 \u043E\u0448\u0438\u0431\u043A\u0443 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u043A\u0430\u043A \u0441\u0435\u0440\u0432\u0435\u0440\u043D\u0443\u044E\n{\n  \"code\": \"100\",\n  \"message\": \"Internal server error\"\n}"
	    },
	
	    /* === HYDRA — как было === */
	    hydra: {
	        key: "hydra",
	        label: "Hydra",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: true,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "p2p",
	            label: "Создать платёж (P2P)",
	            path: "/hydra/p2p",
	            bodyWithIp: function bodyWithIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\",\n  \"customerIp\": \"203.0.113.17\"\n}";
	            },
	            bodyWithoutIp: function bodyWithoutIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalRefs\": [ /* \u043C\u0430\u0441\u0441\u0438\u0432 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B */ ],\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\",\n  \"expiresAt\": \"2025-10-02T21:43:24+00:00\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\"\n}",
	            successLink: "{\n  \"redirectUrl\": \"https://hydra.example/checkout/abc123\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\"\n// \u043B\u0438\u0431\u043E\n// \"paymentUrl\": \"https://pay.e-clear.cc/<uuid>\"\n}"
	        }, {
	            key: "sbp",
	            label: "Создать платёж (СБП)",
	            path: "/hydra/sbp",
	            bodyWithIp: function bodyWithIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\",\n  \"customerIp\": \"203.0.113.17\"\n}";
	            },
	            bodyWithoutIp: function bodyWithoutIp(label) {
	                return "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalReference\": \"order-123\",\n  \"description\": \"" + label + " test\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"externalRefs\": [ /* \u043C\u0430\u0441\u0441\u0438\u0432 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B */ ],\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\",\n  \"expiresAt\": \"2025-10-02T21:43:24+00:00\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\"\n}",
	            successLink: "{\n  \"redirectUrl\": \"https://hydra.example/checkout/abc123\",\n  \"trxUuid\": \"3a3b8b56-5b8a-4a4e-8b2b-1f6e8d2a1cde\",\n  \"localTransactionId\": 2316512,\n  \"transactionId\": 2316512,\n  \"hydraId\": \"5849...8bd9\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"successUrl\": \"https://merchant.example/success\",\n  \"declineUrl\": \"https://merchant.example/decline\"\n// \u043B\u0438\u0431\u043E\n// \"paymentUrl\": \"https://pay.e-clear.cc/<uuid>\"\n}"
	        }],
	        status: {
	            path: function path(id) {
	                return "/hydra/status/" + (id || "<transactionId>");
	            },
	            success: "{\n  \"transactionId\": 2316512,\n  \"externalReference\": \"order-123\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"processingId\": \"5849...8bd9\",\n  \"hydraStatus\": \"COMPLETED\",\n  \"hydraState\": \"COMPLETED\",\n  \"synced\": true,\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\"\n}"
	        },
	        errorSamples: "// 400 Bad Request \u2014 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F\n{\n  \"code\": \"200\",\n  \"message\": \"amount is required and must be > 0\"\n}\n\n// 400 Bad Request \u2014 \u043E\u0448\u0438\u0431\u043A\u0430 \u043E\u0442 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 Hydracode\n{\n  \"code\": \"200\",\n  \"message\": \"Hydracode request failed: Deposit declined\"\n}\n\n// 403 Forbidden \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0443\u0447\u0451\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\n{\n  \"code\": \"200\",\n  \"message\": \"Merchant auth failed.\"\n}\n\n// 400 Bad Request \u2014 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430\n{\n  \"code\": \"200\",\n  \"message\": \"Transaction not found.\"\n}\n\n// 500 Internal Server Error\n{\n  \"code\": \"100\",\n  \"message\": \"Internal server error\"\n}",
	        callbackSample: "{\n  \"transactionId\": 2316512,\n  \"externalReference\": \"order-123\",\n  \"state\": \"COMPLETED\",\n  \"amount\": 1000,\n  \"currency\": \"RUB\",\n  \"processingId\": \"5849...8bd9\",\n  \"createdAt\": \"2025-10-02T21:28:24+00:00\"\n}"
	    },
	
	    /** === TKB — единый эндпоинт /api/v1 и выбор операции через method.type === */
	    tkb: {
	        key: "tkb",
	        label: "TKB (выплаты)",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: false,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "payout",
	            label: "Выплата (card → TKB)",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"payout\", \"provider\": \"tkb\" },\n  \"amount\": { \"value\": 1000, \"currency\": \"RUB\" },\n  \"card\": { \"number\": \"4762085995973998\" },\n  \"recipient\": {\n    \"phone\": \"+79991112233\",\n    \"email\": \"user@example.com\"\n  },\n  \"description\": \"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F\",\n  \"externalReference\": \"po-200700\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"data\": {\n    \"transactionId\": 123456,\n    \"transactionType\": \"PAYOUT_CREATED\",\n    \"date\": \"2025-10-02 21:28:24+00:00\",\n    \"accountingDate\": null,\n    \"amount\": 1000,\n    \"currency\": \"RUB\",\n    \"authCode\": null,\n    \"pan\": \"476208******3998\"\n  },\n  \"additionalData\": {\n    \"externalReference\": \"po-200700\",\n    \"description\": \"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F\"\n  }\n}",
	            successLink: null
	        }, {
	            key: "balance",
	            label: "Баланс мерчанта",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"balance\" }\n}";
	            },
	            successManual: "{\n  \"balance\": [\n    { \"currency\": \"RUB\", \"value\": 12345.67 }\n  ],\n  \"providers\": {\n    \"a1b2c3d4-e5f6-...\" : [\n      { \"currency\": \"RUB\", \"value\": 12345.67 }\n    ]\n  },\n  \"balances\": {\n    \"items\": [\n      {\n        \"terminal_id\": 123,\n        \"terminal_name\": \"Terminal SBP\",\n        \"merchant_settings_id\": 456,\n        \"transactionBalance\": 1234567,\n        \"transactionBalanceFloat\": 12345.67,\n        \"settlementBalance\": 500000,\n        \"settlementBalanceFloat\": 5000.00,\n        \"actualBalance\": 734567,\n        \"actualBalanceFloat\": 7345.67\n      }\n    ],\n    \"totals\": {\n      \"transactionBalance\": 1234567,\n      \"transactionBalanceFloat\": 12345.67,\n      \"settlementBalance\": 500000,\n      \"settlementBalanceFloat\": 5000.00,\n      \"actualBalance\": 734567,\n      \"actualBalanceFloat\": 7345.67\n    }\n  }\n}",
	            successLink: null
	        }, {
	            key: "status",
	            label: "Статус операции",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"status\" },\n  \"transactionId\": 123456\n  // \u043B\u0438\u0431\u043E \u0432\u043C\u0435\u0441\u0442\u043E transactionId:\n  // \"externalReference\": \"po-200700\"\n}";
	            },
	            successManual: "[\n  {\n    \"data\": {\n      \"transactionId\": 123456,\n      \"transactionType\": \"PAYOUT\",\n      \"date\": \"2025-10-02 21:28:24+00:00\",\n      \"accountingDate\": \"2025-10-02 21:42:07+00:00\",\n      \"amount\": 1000,\n      \"currency\": \"RUB\",\n      \"authCode\": \"123456\",\n      \"pan\": \"476208******3998\"\n    },\n    \"additionalData\": {\n      \"externalReference\": \"po-200700\",\n      \"description\": \"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F\"\n    }\n  }\n]",
	            successLink: null
	        }],
	        callbackSample: "{\n  \"data\": {\n    \"transactionId\": 123456,\n    \"transactionType\": \"PAYOUT\",\n    \"date\": \"2025-10-02 21:28:24+00:00\",\n    \"accountingDate\": \"2025-10-02 21:42:07+00:00\",\n    \"amount\": 1000,\n    \"currency\": \"RUB\",\n    \"authCode\": \"123456\",\n    \"pan\": \"476208******3998\"\n  },\n  \"additionalData\": {\n    \"externalReference\": \"po-200700\",\n    \"description\": \"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F\"\n  }\n}",
	        errorSamples: "// 400 Bad Request \u2014 \u043E\u0448\u0438\u0431\u043A\u0430 \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0435\u0439\n// \u0412\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u043E\u0431\u044A\u0435\u043A\u0442 fields \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435\u043C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u043D\u044B\u0445 \u043F\u043E\u043B\u0435\u0439\n{\n  \"code\": \"200\",\n  \"message\": \"Validation failed\",\n  \"fields\": {\n    \"payload.amount.value\": {\n      \"code\": \"300\",\n      \"message\": \"This value should not be blank.\"\n    },\n    \"payload.card.pan\": {\n      \"code\": \"300\",\n      \"message\": \"Invalid card number format.\"\n    }\n  }\n}\n\n// 400 Bad Request \u2014 \u0434\u0443\u0431\u043B\u0438\u043A\u0430\u0442 externalReference\n{\n  \"code\": \"200\",\n  \"message\": \"Reference po-200700 is not unique.\"\n}\n\n// 400 Bad Request \u2014 \u043D\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\n{\n  \"code\": \"200\",\n  \"message\": \"No active merchant settings available.\"\n}\n\n// 404 Not Found \u2014 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 (\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430)\n{\n  \"code\": \"200\",\n  \"message\": \"Not found.\"\n}\n\n// 401 Unauthorized \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 UUID \u0438\u043B\u0438 \u043A\u043B\u044E\u0447 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\n{\n  \"message\": \"Invalid merchant credentials\"\n}\n\n// 500 Internal Server Error\n{\n  \"code\": \"100\",\n  \"message\": \"Internal server error\"\n}"
	    },
	
	    /** === ФИНС — выплаты с обязательными паспортными реквизитами === */
	    fins: {
	        key: "fins",
	        label: "ФИНС (выплаты)",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: true,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "payout_card",
	            label: "Создать выплату (карта)",
	            path: "/fins/payouts/card",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"amount\": 3000,\n  \"currency\": \"RUB\",\n  \"card\": { \"number\": \"4762085995973998\" },\n  \"recipient\": {\n    \"last_name\": \"\u041F\u0435\u0442\u0440\u043E\u0432\",\n    \"first_name\": \"\u041F\u0435\u0442\u0440\",\n    \"middle_name\": \"\u041F\u0435\u0442\u0440\u043E\u0432\u0438\u0447\",\n    \"document_number\": \"RNxZ 6791\", // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u043B\u044E\u0431\u043E\u0435 \u0431\u0443\u043A\u0432\u0435\u043D\u043D\u043E\u0435 \u0438 \u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ( \u043D\u043E\u043C\u0435\u0440 \u041F\u0421\u0410 )\n    \"document_date\": \"2025-05-15\",  // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u0442\u0430\u043A\u0436\u0435 DD.MM.YYYY ( \u0434\u0430\u0442\u0430 \u041F\u0421\u0410 )\n    \"phone\": \"+79001234567\",\n    \"email\": \"example@test.com\",\n    \"inn\": \"123456789012\"\n  },\n  \"external_reference\": \"po-200700\",\n  \"description\": \"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F\",\n  \"callback_url\": \"https://merchant.example/callback\"\n\n// \u0415\u0441\u043B\u0438 \u043E\u0442\u0447\u0435\u0441\u0442\u0432\u0430 \u041D\u0415\u0422, \u0432\u043C\u0435\u0441\u0442\u043E middle_name \u0443\u043A\u0430\u0436\u0438\u0442\u0435:\n// \"recipient\": {\n//   \"last_name\": \"\u041F\u0435\u0442\u0440\u043E\u0432\",\n//   \"first_name\": \"\u041F\u0435\u0442\u0440\",\n//   \"has_middle_name\": false,         // \u041E\u0411\u042F\u0417\u0410\u0422\u0415\u041B\u042C\u041D\u041E, \u0435\u0441\u043B\u0438 \u043E\u0442\u0447\u0435\u0441\u0442\u0432\u0430 \u043D\u0435\u0442\n//   \"document_number\": \"RNxZ 6791\",   // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u043B\u044E\u0431\u043E\u0435 \u0431\u0443\u043A\u0432\u0435\u043D\u043D\u043E\u0435 \u0438 \u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ( \u043D\u043E\u043C\u0435\u0440 \u041F\u0421\u0410 )\n//   \"document_date\": \"15.05.2025\"     // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u0442\u0430\u043A\u0436\u0435 DD.MM.YYYY ( \u0434\u0430\u0442\u0430 \u041F\u0421\u0410 )\n// }\n}";
	            },
	            successManual: "{\n  \"ok\": true,\n  \"data\": {\n    \"created_at\": \"2025-12-17 12:47:16.036595 +0000 UTC\",\n    \"description\": \"\u041E\u0431\u0449\u0430\u044F\",\n    \"id\": \"d2a099aa-14c8-4f80-8cee-dda895a70635\",\n    \"last_operation_completed_at\": \"2025-12-17 12:47:18.40332 +0000 UTC\",\n    \"last_operation_status\": \"approve\",\n    \"last_operation_type\": \"credit\",\n    \"operations\": [\n      {\n        \"amount\": {\n          \"currency\": \"RUB\",\n          \"value\": 3000\n        },\n        \"completed_at\": \"2025-12-17 12:47:18.40332 +0000 UTC\",\n        \"created_at\": \"2025-12-17 12:47:16.036595 +0000 UTC\",\n        \"external_transaction_id\": \"167590\",\n        \"id\": \"1277b0b6-3710-4215-991d-3d18d8fc7832\",\n        \"payout_method\": {\n          \"card\": {\n            \"number\": \"220015|1371\"\n          }\n        },\n        \"rrn\": \"535146065319\",\n        \"status\": \"approve\",\n        \"type\": \"credit\"\n      }\n    ],\n    \"request_id\": \"18acdb1f-c9be-4e55-82cf-271272faf148\",\n    \"shop_order_id\": \"2317149\"\n  },\n  \"request_id\": \"035869c8bc882ce2-a92adcb3f8cf2977\"\n}"
	        }, {
	            key: "payout_sbp",
	            label: "Создать выплату (СБП)",
	            path: "/fins/payouts/sbp",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"amount\": 3000,\n  \"currency\": \"RUB\",\n  \"sbp\": {\n    \"bank_member_id\": \"100000000011\",\n    \"phone\": \"+79001234567\"          // \u0434\u043B\u044F \u0421\u0411\u041F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0432 \u044D\u0442\u043E\u043C \u0431\u043B\u043E\u043A\u0435\n  },\n  \"recipient\": {\n    \"last_name\": \"\u041F\u0435\u0442\u0440\u043E\u0432\",\n    \"first_name\": \"\u041F\u0435\u0442\u0440\",\n    \"middle_name\": \"\u041F\u0435\u0442\u0440\u043E\u0432\u0438\u0447\",\n    \"document_number\": \"RNxZ 6791\", // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u043B\u044E\u0431\u043E\u0435 \u0431\u0443\u043A\u0432\u0435\u043D\u043D\u043E\u0435 \u0438 \u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ( \u043D\u043E\u043C\u0435\u0440 \u041F\u0421\u0410 )\n    \"document_date\": \"2025-05-15\",  // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u0442\u0430\u043A\u0436\u0435 DD.MM.YYYY ( \u0434\u0430\u0442\u0430 \u041F\u0421\u0410 )\n    \"email\": \"example@test.com\",\n    \"inn\": \"123456789012\"\n    // phone \u043C\u043E\u0436\u043D\u043E \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u043E\u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 recipient (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)\n  },\n  \"external_reference\": \"po-200700\",\n  \"description\": \"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F\",\n  \"callback_url\": \"https://merchant.example/callback\"\n\n// \u0415\u0441\u043B\u0438 \u043E\u0442\u0447\u0435\u0441\u0442\u0432\u0430 \u041D\u0415\u0422, \u0432\u043C\u0435\u0441\u0442\u043E middle_name \u0443\u043A\u0430\u0436\u0438\u0442\u0435:\n// \"recipient\": {\n//   \"last_name\": \"\u041F\u0435\u0442\u0440\u043E\u0432\",\n//   \"first_name\": \"\u041F\u0435\u0442\u0440\",\n//   \"has_middle_name\": false,         // \u041E\u0411\u042F\u0417\u0410\u0422\u0415\u041B\u042C\u041D\u041E, \u0435\u0441\u043B\u0438 \u043E\u0442\u0447\u0435\u0441\u0442\u0432\u0430 \u043D\u0435\u0442\n//   \"document_number\": \"RNxZ 6791\",   // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u043B\u044E\u0431\u043E\u0435 \u0431\u0443\u043A\u0432\u0435\u043D\u043D\u043E\u0435 \u0438 \u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ( \u043D\u043E\u043C\u0435\u0440 \u041F\u0421\u0410 )\n//   \"document_date\": \"15.05.2025\"     // \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C \u0442\u0430\u043A\u0436\u0435 DD.MM.YYYY ( \u0434\u0430\u0442\u0430 \u041F\u0421\u0410 )\n// }\n}";
	            },
	            successManual: "{\n  \"ok\": true,\n  \"data\": {\n    \"created_at\": \"2025-12-17 12:47:16.036595 +0000 UTC\",\n    \"description\": \"\u041E\u0431\u0449\u0430\u044F\",\n    \"id\": \"c4a9d1d2-aaaa-bbbb-cccc-efefefefefef\",\n    \"last_operation_completed_at\": \"2025-12-17 12:47:18.40332 +0000 UTC\",\n    \"last_operation_status\": \"approve\",\n    \"last_operation_type\": \"credit\",\n    \"operations\": [\n      {\n        \"amount\": {\n          \"currency\": \"RUB\",\n          \"value\": 3000\n        },\n        \"completed_at\": \"2025-12-15 13:47:18.40332 +0000 UTC\",\n        \"created_at\": \"2025-12-15 13:57:16.036595 +0000 UTC\",\n        \"external_transaction_id\": \"167590\",\n        \"id\": \"1fsdfb0b6-fsdf10-4215-99asd-3d18dsdfc7832\",\n        \"payout_method\": {\n          \"sbp\": {\n            \"bank_member_id\": \"100000000011\"\n          }\n        },\n        \"rrn\": \"535146065319\",\n        \"status\": \"approve\",\n        \"type\": \"credit\"\n      }\n    ],\n    \"request_id\": \"1asdfdb1f-c9be-4e55-12cf-2hgf172faf148\",\n    \"shop_order_id\": \"2317149\"\n  },\n  \"request_id\": \"0359458gdhc882ce2-asdfgds8cf2977\"\n}"
	        }],
	        status: {
	            path: function path(id) {
	                return "/fins/payouts/status/" + (id || "<transactionId|payoutId>");
	            },
	            success: "{\n  \"ok\": true,\n  \"data\": {\n    \"status\": \"success\",\n    \"payout_id\": \"b0c28d56-3b3c-4d2b-8c5a-0d33d4a0cb41\",\n    \"shop_order_id\": \"123456\",\n    \"operations\": [\n      { \"status\": \"success\", \"created_at\": \"2025-10-02T12:42:07+00:00\", \"rrn\": \"123456789012\" }\n    ]\n  }\n}"
	        },
	        callbackSample: "{\n  \"ok\": true,\n  \"transactionId\": 123456,\n  \"payoutId\": \"b0c28d56-3b3c-4d2b-8c5a-0d33d4a0cb41\",\n  \"status\": \"success\",\n  \"provider\": \"finstar\",\n  \"data\": { /* claims \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 */ }\n}",
	        errorSamples: "// \u041E\u0448\u0438\u0431\u043A\u0438 \u0430\u0434\u0430\u043F\u0442\u0435\u0440\u0430 \u0424\u0418\u041D\u0421\n\n// 400 \u2014 \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043F\u043E\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F/\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\n{\n  \"ok\": false,\n  \"error\": {\n    \"code\": \"bad_request\",\n    \"message\": \"recipient.document_number and recipient.document_date are required\",\n    \"where\": \"local\"\n  }\n}\n// \u041F\u0440\u0438\u043C\u0435\u0440 \u0434\u043B\u044F \u043E\u0442\u0447\u0435\u0441\u0442\u0432\u0430:\n{\n  \"ok\": false,\n  \"error\": {\n    \"code\": \"bad_request\",\n    \"message\": \"recipient.has_middle_name is required (must be false) when recipient.middle_name is absent\",\n    \"where\": \"local\"\n  }\n}\n\n// 402 \u2014 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0432 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0435\n{\n  \"ok\": false,\n  \"error\": {\n    \"code\": \"insufficient_provider_balance\",\n    \"message\": \"Insufficient provider balance for card payout.\",\n    \"where\": \"provider\",\n    \"details\": { \"available\": 1000, \"requested\": 3000 }\n  }\n}\n\n// 502 \u2014 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 (\u0434\u0435\u0442\u0430\u043B\u0438 \u0432 error.details)\n{\n  \"ok\": false,\n  \"error\": {\n    \"code\": \"provider_error\",\n    \"message\": \"...\",\n    \"where\": \"provider\",\n    \"provider_http_code\": 422,\n    \"details\": { /* \u0442\u0435\u043B\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 */ }\n  }\n}\n\n// 401/403 \u2014 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F\n{\n  \"ok\": false,\n  \"error\": {\n    \"code\": \"access_denied\",\n    \"message\": \"Merchant auth failed.\",\n    \"where\": \"local\"\n  }\n}"
	    },
	
	    /* === ВЫПЛАТЫ (CRM Payout Requests) === */
	    payouts: {
	        key: "payouts",
	        label: "Выплаты",
	        baseUrlProd: "https://api.e-clear.cc",
	        baseUrlTest: "https://api.test.e-clear.cc",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            ),
	            " ",
	            "\u0438\u043B\u0438 HMAC (",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "Merchant"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "Sign"
	            ),
	            ")"
	        ),
	        supportsStatus: false,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "create_card",
	            label: "Создать заявку (карта)",
	            path: "/api/v2/payout-request",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"amount\": 1235.00,\n  \"currency\": \"RUB\",\n  \"type\": \"card\",\n  \"cardPan\": \"5469380076360360\",\n  \"fullName\": \"\u0418\u0432\u0430\u043D\u043E\u0432 \u041C\u0438\u0445\u0430\u0438\u043B \u0418\u0432\u0430\u043D\u043E\u0432\u0438\u0447\",\n  \"email\": \"test@example.com\",\n  \"phone\": \"+79001234567\",\n  \"externalReference\": \"TEST-001\",\n  \"callbackUrl\": \"https://merchant.example/callback\",\n  \"description\": \"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F\",\n  \"documentDate\": \"19.02.2026\",\n  \"documentNumber\": \"PSA-12345\"\n}";
	            },
	            successManual: "{\n  \"id\": \"6d19dc25-3213-4165-b0f7-834e995dbb50\",\n  \"status\": \"created\",\n  \"statusCode\": 0,\n  \"transactionId\": 1224,\n  \"message\": \"Request accepted\"\n}"
	        }, {
	            key: "create_sbp",
	            label: "Создать заявку (СБП)",
	            path: "/api/v2/payout-request",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"amount\": 1235.00,\n  \"currency\": \"RUB\",\n  \"type\": \"sbp\",\n  \"phone\": \"+79001234567\",\n  \"bankMemberId\": \"100000000111\",\n  \"externalReference\": \"SBP-TEST-001\",\n  \"callbackUrl\": \"https://merchant.example/callback\"\n}";
	            },
	            successManual: "{\n  \"id\": \"6d19dc25-3213-4165-b0f7-834e995dbb50\",\n  \"status\": \"created\",\n  \"statusCode\": 0,\n  \"payoutType\": \"sbp\",\n  \"transactionId\": 1224,\n  \"message\": \"Request accepted\"\n}"
	        }, {
	            key: "status",
	            label: "Проверить статус",
	            path: "/api/v2/payout-request/status",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"id\": \"6d19dc25-3213-4165-b0f7-834e995dbb50\"\n  // \u0438\u043B\u0438 \u043F\u043E externalReference:\n  // \"externalReference\": \"TEST-001\"\n}";
	            },
	            successManual: "{\n  \"id\": \"6d19dc25-3213-4165-b0f7-834e995dbb50\",\n  \"status\": \"awaitingPayout\",\n  \"statusCode\": 7,\n  \"amount\": 1235.00,\n  \"currency\": \"RUB\",\n  \"payoutType\": \"sbp\",\n  \"bankName\": \"\u0421\u0431\u0435\u0440 \u0411\u0430\u043D\u043A\",\n  \"bankCode\": \"100000000111\",\n  \"externalReference\": \"TEST-001\",\n  \"transactionId\": 1224,\n  \"declineReason\": null,\n  \"createdAt\": \"2026-02-19T12:00:00+00:00\",\n  \"updatedAt\": \"2026-02-19T12:01:15+00:00\"\n}"
	        }],
	        callbackSample: "// POST \u043D\u0430 \u0432\u0430\u0448 callbackUrl\n// \u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A Sign: HMAC-SHA256 \u043E\u0442 \u0442\u0435\u043B\u0430, \u043A\u043B\u044E\u0447 \u2014 \u0432\u0430\u0448 merchant key\n{\n  \"data\": {\n    \"payoutRequestId\": \"6d19dc25-3213-4165-b0f7-834e995dbb50\",\n    \"status\": \"success\",\n    \"statusCode\": 5,\n    \"amount\": 1235.00,\n    \"currency\": \"RUB\",\n    \"externalReference\": \"TEST-001\",\n    \"transactionId\": 1224,\n    \"declineReason\": null\n  }\n}",
	        errorSamples: "// 400 Bad Request \u2014 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F\n{\n  \"status\": \"error\",\n  \"message\": \"amount is required\"\n}\n\n// 400 Bad Request \u2014 \u043D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430\n{\n  \"status\": \"error\",\n  \"message\": \"Invalid card number\"\n}\n\n// 400 Bad Request \u2014 \u0434\u0443\u0431\u043B\u0438\u043A\u0430\u0442 externalReference\n{\n  \"status\": \"error\",\n  \"message\": \"Payout request with this externalReference already exists\"\n}\n\n// 400 Bad Request \u2014 \u0431\u0430\u043D\u043A \u0421\u0411\u041F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u0438\u043B\u0438 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043D\u0435\u043E\u0434\u043D\u043E\u0437\u043D\u0430\u0447\u043D\u043E\n{\n  \"status\": \"error\",\n  \"message\": \"Unknown or ambiguous SBP bank name: \u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 \u0431\u0430\u043D\u043A\"\n}\n\n// 400 Bad Request \u2014 \u043D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u044B\u0439 JSON\n{\n  \"status\": \"error\",\n  \"message\": \"Invalid JSON body\"\n}\n\n// 401 Unauthorized \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0443\u0447\u0451\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435\n{\n  \"message\": \"Authentication Required\"\n}\n\n// 404 Not Found \u2014 \u0437\u0430\u044F\u0432\u043A\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 (\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430)\n{\n  \"status\": \"error\",\n  \"message\": \"Payout request not found\"\n}\n\n// 200 OK \u2014 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u043E\u043C\n{\n  \"id\": \"6d19dc25-3213-4165-b0f7-834e995dbb50\",\n  \"status\": \"declined\",\n  \"statusCode\": 2,\n  \"transactionId\": null,\n  \"message\": \"Blocked by antifraud check\",\n  \"antifraudCode\": \"card_pan\",\n  \"antifraudProvider\": \"internal\"\n}"
	    },
	
	    /* === INTERNAL (Внутренние методы) === */
	    internal: {
	        key: "internal",
	        label: "Внутренние",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: false,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "terminals",
	            label: "Список терминалов",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"balance\", \"direction\": \"terminals\" }\n}";
	            },
	            successManual: "{\n  \"terminals\": [\n    {\n      \"terminalId\": 123,\n      \"name\": \"Terminal SBP\",\n      \"currency\": \"RUB\",\n      \"balance\": 15000.50,\n      \"transactionBalance\": 1500050,\n      \"transactionBalanceFloat\": 15000.50,\n      \"settlementBalance\": 500000,\n      \"settlementBalanceFloat\": 5000.00,\n      \"actualBalance\": 1000050,\n      \"actualBalanceFloat\": 10000.50\n    },\n    {\n      \"terminalId\": 456,\n      \"name\": \"Terminal Card\",\n      \"currency\": \"RUB\",\n      \"balance\": 8500.00,\n      \"transactionBalance\": 850000,\n      \"transactionBalanceFloat\": 8500.00,\n      \"settlementBalance\": 200000,\n      \"settlementBalanceFloat\": 2000.00,\n      \"actualBalance\": 650000,\n      \"actualBalanceFloat\": 6500.00\n    }\n  ]\n}"
	        }, {
	            key: "terminal_balance",
	            label: "Баланс терминала",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"balance\", \"direction\": \"terminal\" },\n  \"terminalId\": 123\n}";
	            },
	            successManual: "{\n  \"terminal\": {\n    \"terminalId\": 123,\n    \"name\": \"Terminal SBP\",\n    \"currency\": \"RUB\",\n    \"balance\": 15000.50,\n    \"transactionBalance\": 1500050,\n    \"transactionBalanceFloat\": 15000.50,\n    \"settlementBalance\": 500000,\n    \"settlementBalanceFloat\": 5000.00,\n    \"actualBalance\": 1000050,\n    \"actualBalanceFloat\": 10000.50\n  }\n}"
	        }, {
	            key: "balance_total",
	            label: "Общий баланс",
	            path: "/v1",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"method\": { \"type\": \"balance\" }\n}";
	            },
	            successManual: "{\n  \"balance\": [\n    { \"currency\": \"RUB\", \"value\": 23500.50 }\n  ],\n  \"providers\": {\n    \"a1b2c3d4-e5f6-...\": [\n      { \"currency\": \"RUB\", \"value\": 15000.50 }\n    ],\n    \"b2c3d4e5-f6g7-...\": [\n      { \"currency\": \"RUB\", \"value\": 8500.00 }\n    ]\n  },\n  \"balances\": {\n    \"items\": [\n      {\n        \"terminal_id\": 123,\n        \"terminal_name\": \"Terminal SBP\",\n        \"merchant_settings_id\": 456,\n        \"transactionBalance\": 1500050,\n        \"transactionBalanceFloat\": 15000.50,\n        \"settlementBalance\": 500000,\n        \"settlementBalanceFloat\": 5000.00,\n        \"actualBalance\": 1000050,\n        \"actualBalanceFloat\": 10000.50\n      },\n      {\n        \"terminal_id\": 789,\n        \"terminal_name\": \"Terminal Card\",\n        \"merchant_settings_id\": 101,\n        \"transactionBalance\": 850000,\n        \"transactionBalanceFloat\": 8500.00,\n        \"settlementBalance\": 200000,\n        \"settlementBalanceFloat\": 2000.00,\n        \"actualBalance\": 650000,\n        \"actualBalanceFloat\": 6500.00\n      }\n    ],\n    \"totals\": {\n      \"transactionBalance\": 2350050,\n      \"transactionBalanceFloat\": 23500.50,\n      \"settlementBalance\": 700000,\n      \"settlementBalanceFloat\": 7000.00,\n      \"actualBalance\": 1650050,\n      \"actualBalanceFloat\": 16500.50\n    }\n  }\n}"
	        }],
	        callbackSample: null,
	        errorSamples: "// 400 Bad Request \u2014 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435 terminalId\n{ \"code\": \"200\", \"message\": \"terminalId is required\" }\n\n// 404 Not Found \u2014 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u0438\u043B\u0438 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0438\u0442 \u0434\u0440\u0443\u0433\u043E\u043C\u0443 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0443\n{ \"code\": \"200\", \"message\": \"Terminal not found.\" }\n\n// 401 Unauthorized \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 UUID \u0438\u043B\u0438 \u043A\u043B\u044E\u0447 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\n{ \"message\": \"Invalid merchant credentials\" }\n\n// 500 Internal Server Error\n{ \"code\": \"100\", \"message\": \"Internal server error\" }"
	    },
	
	    /* === ANTIFRAUD (Проверка на фрод) === */
	    antifraud: {
	        key: "antifraud",
	        label: "Антифрод",
	        baseUrlProd: "https://api.e-clear.cc/api/v2/antifraud",
	        baseUrlTest: "https://api.test.e-clear.cc/api/v2/antifraud",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: false,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "check",
	            label: "Проверка на фрод",
	            path: "/check",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"cardPan\": \"4111111111111111\",\n  \"phone\": \"79001234567\",\n  \"clientIp\": \"203.0.113.17\"\n}";
	            },
	            successManual: "// \u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u0430 (HTTP 200)\n{\n  \"status\": \"ok\",\n  \"checkTimeMs\": 45\n}\n\n// \u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E (HTTP 422)\n{\n  \"status\": \"blocked\",\n  \"reason\": \"\u041A\u0430\u0440\u0442\u0430 \u0432 \u0447\u0451\u0440\u043D\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435\",\n  \"blockedKind\": \"card_pan\"\n}"
	        }],
	        callbackSample: null,
	        errorSamples: "// 400 Bad Request \u2014 \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u043E \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438\n{ \"error\": \"validation_error\", \"message\": \"At least one of cardPan, phone, clientIp is required\" }\n\n// 401 Unauthorized \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 UUID \u0438\u043B\u0438 \u043A\u043B\u044E\u0447 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\n{ \"error\": \"unauthorized\", \"message\": \"Invalid merchant credentials\" }\n\n// 422 Unprocessable Entity \u2014 \u043A\u0430\u0440\u0442\u0430/\u0442\u0435\u043B\u0435\u0444\u043E\u043D/IP \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\n{\n  \"status\": \"blocked\",\n  \"reason\": \"\u041A\u0430\u0440\u0442\u0430 \u0432 \u0447\u0451\u0440\u043D\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435\",\n  \"blockedKind\": \"card_pan\"\n}\n\n// 500 Internal Server Error\n{ \"error\": \"internal_error\", \"message\": \"Internal server error\" }"
	    },
	
	    /** === NPAY — приём платежей по QR (Кыргызстан, npay.kg) === */
	    npay: {
	        key: "npay",
	        label: "NPay (QR)",
	        baseUrlProd: "https://api.e-clear.cc/api",
	        baseUrlTest: "https://api.test.e-clear.cc/api",
	        authHelp: _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-UUID"
	            ),
	            " + ",
	            _react2.default.createElement(
	                Kbd,
	                null,
	                "X-Merchant-Key"
	            )
	        ),
	        supportsStatus: true,
	        headers: [{ name: "Content-Type", value: "application/json" }, { name: "X-Merchant-UUID", value: "<YOUR-UUID>" }, { name: "X-Merchant-Key", value: "<YOUR-KEY>" }],
	        methods: [{
	            key: "payment",
	            label: "Создать платёж",
	            path: "/npay/payments",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"amount\": 100,\n  \"external_reference\": \"order-123\",\n  \"comment\": \"\u041E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430\u043A\u0430\u0437\u0430 #123\",\n  \"redirect_url\": \"https://merchant.example/success\",\n  \"callback_url\": \"https://merchant.example/callback\",\n  \"amount_can_be_changed\": false,\n  \"expire_at\": \"2026-06-25T18:00:00+03:00\"\n}";
	            },
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 281,\n  \"npayGuid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n  \"payload\": \"https://pay.namba.kg/#00020101...6304XXXX\",\n  \"paymentUrl\": \"https://pay.namba.kg/#00020101...6304XXXX\",\n  \"qrBase64\": \"iVBORw0KGgoAAAANSUhEUg...\",\n  \"qrDataUri\": \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUg...\",\n  \"paymentPageUrl\": \"https://my.e-clear.cc/npay/3f8c9a1b...d21\",\n  \"amount\": 100,\n  \"amountRub\": 100,\n  \"amountKgs\": 112.45,\n  \"rate\": 1.1245,\n  \"currency\": \"RUB\",\n  \"expireAt\": \"2026-06-25T18:00:00+03:00\",\n  \"status\": \"PROCESSING\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "payment_status",
	            label: "Статус платежа",
	            path: "/npay/payments/<transactionId>",
	            bodyWithIp: null,
	            bodyWithoutIp: null,
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 281,\n  \"npayGuid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n  \"status\": \"SUCCESS\",\n  \"providerStatus\": null,\n  \"amount\": 100,\n  \"currency\": \"RUB\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "page",
	            label: "Данные страницы оплаты",
	            path: "/npay/page/<token>",
	            bodyWithIp: null,
	            bodyWithoutIp: null,
	            successManual: "{\n  \"ok\": true,\n  \"status\": \"PROCESSING\",\n  \"payload\": \"https://pay.namba.kg/#00020101...6304XXXX\",\n  \"qrBase64\": \"iVBORw0KGgoAAAANSUhEUg...\",\n  \"qrDataUri\": \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUg...\",\n  \"amountRub\": 100,\n  \"amountKgs\": 112.45,\n  \"currency\": \"RUB\",\n  \"expireAt\": \"2026-06-25T18:00:00+03:00\",\n  \"expireAtTs\": 1782313080,\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "refund",
	            label: "Создать возврат",
	            path: "/npay/refunds",
	            bodyWithIp: null,
	            bodyWithoutIp: function bodyWithoutIp() {
	                return "{\n  \"transaction_id\": 281,\n  \"amount\": 100,\n  \"comment\": \"\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\",\n  \"callback_url\": \"https://merchant.example/refund-callback\"\n}";
	            },
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 282,\n  \"parentTransactionId\": 281,\n  \"npayRefundGuid\": \"b2c3d4e5-f6a7-8901-bcde-f12345678901\",\n  \"amount\": 100,\n  \"amountRub\": 100,\n  \"amountKgs\": 112.45,\n  \"rate\": 1.1245,\n  \"currency\": \"RUB\",\n  \"status\": \"pending\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }, {
	            key: "refund_status",
	            label: "Статус возврата",
	            path: "/npay/refunds/<transactionId>",
	            bodyWithIp: null,
	            bodyWithoutIp: null,
	            successManual: "{\n  \"ok\": true,\n  \"transactionId\": 282,\n  \"status\": \"SUCCESS\",\n  \"providerStatus\": \"COMPLETED\",\n  \"request_id\": \"abc123...\"\n}",
	            successLink: null
	        }],
	        status: {
	            path: function path(id) {
	                return "/npay/payments/" + (id || "<transactionId>");
	            },
	            success: "{\n  \"ok\": true,\n  \"transactionId\": 281,\n  \"npayGuid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n  \"status\": \"SUCCESS\",\n  \"providerStatus\": null,\n  \"amount\": 100,\n  \"currency\": \"RUB\",\n  \"request_id\": \"abc123...\"\n}"
	        },
	        callbackSample: "// POST \u043D\u0430 \u0432\u0430\u0448 callback_url \u043F\u0440\u0438 \u0441\u043C\u0435\u043D\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0430.\n// \u0421\u0443\u043C\u043C\u0430 \u2014 \u0432 \u0420\u0423\u0411\u041B\u042F\u0425 (\u0432\u0430\u043B\u044E\u0442\u0430 \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430), \u043A\u0430\u043A \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438.\n{\n  \"transactionId\": 281,\n  \"externalReference\": \"order-123\",\n  \"state\": \"SUCCESS\",\n  \"providerStatus\": \"COMPLETED\",\n  \"amount\": 100,\n  \"amountRub\": 100,\n  \"currency\": \"RUB\",\n  \"createdAt\": \"2026-06-25T10:30:00+03:00\"\n}\n\n// state: SUCCESS | DECLINED | PENDING",
	        webhookSample: "// \u042D\u0442\u043E \u0432\u0435\u0431\u0445\u0443\u043A \u041E\u0422 NPay \u041D\u0410 \u041D\u0410\u0428 \u0441\u0435\u0440\u0432\u0435\u0440 \u2014 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u043C \u043C\u044B, \u0432\u0430\u043C \u0434\u0435\u043B\u0430\u0442\u044C \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0443\u0436\u043D\u043E.\n// \u041F\u0440\u0438\u0432\u0435\u0434\u0451\u043D \u0434\u043B\u044F \u043F\u043E\u043D\u0438\u043C\u0430\u043D\u0438\u044F, \u043A\u0430\u043A \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u0442\u0443\u0441. \u0412\u0430\u043C \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 callback (\u0441\u043C. \u0441\u043B\u0435\u0432\u0430).\n// POST /webhooks/npay/{token}\n// \u0422\u0438\u043F PAYMENT_ORDER (\u043F\u043B\u0430\u0442\u0451\u0436):\n{\n  \"type\": \"PAYMENT_ORDER\",\n  \"data\": {\n    \"externalId\": \"281\",\n    \"status\": \"COMPLETED\",\n    \"guid\": \"6a4cd87f-d1c8-4e55-8928-17cd37ce1a07\",\n    \"amount\": 11245\n  }\n}\n\n// \u0422\u0438\u043F REFUND_ORDER (\u0432\u043E\u0437\u0432\u0440\u0430\u0442):\n{\n  \"type\": \"REFUND_ORDER\",\n  \"data\": {\n    \"externalId\": \"282\",\n    \"status\": \"COMPLETED\",\n    \"guid\": \"b2c3d4e5-f6a7-8901-bcde-f12345678901\",\n    \"amount\": 11245\n  }\n}",
	        errorSamples: "// 400 \u2014 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442/\u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0435 \u043F\u043E\u043B\u044F\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"bad_request\", \"message\": \"amount is required and must be numeric\" }\n}\n\n// 400 \u2014 \u043D\u0435\u0442 NPay \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0434\u043B\u044F \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"bad_request\", \"message\": \"No NPay settings found for this merchant.\" }\n}\n\n// 403 \u2014 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0443\u0447\u0451\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"access_denied\", \"message\": \"Merchant auth failed.\" }\n}\n\n// 404 \u2014 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 (\u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439/\u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043D\u044B\u0439 token)\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"not_found\", \"message\": \"Payment not found\" }\n}\n\n// 500 \u2014 \u043E\u0448\u0438\u0431\u043A\u0430 NPay \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430\n{\n  \"ok\": false,\n  \"error\": { \"code\": \"internal_error\", \"message\": \"NPay createOneTimeLink failed: ...\" }\n}"
	    }
	};
	
	/** Страница */
	var MerchantsDocs = function MerchantsDocs() {
	    var _useState3 = (0, _react.useState)("hydra"),
	        _useState4 = _slicedToArray(_useState3, 2),
	        providerKey = _useState4[0],
	        setProviderKey = _useState4[1];
	
	    var _useState5 = (0, _react.useState)("p2p"),
	        _useState6 = _slicedToArray(_useState5, 2),
	        methodKey = _useState6[0],
	        setMethodKey = _useState6[1];
	
	    var provider = PROVIDERS[providerKey];
	
	    var method = (0, _react.useMemo)(function () {
	        var list = provider && provider.methods ? provider.methods : [];
	        var found = null;
	        for (var i = 0; i < list.length; i++) {
	            if (list[i].key === methodKey) {
	                found = list[i];
	                break;
	            }
	        }
	        if (!found && list.length > 0) found = list[0];
	        return found;
	    }, [providerKey, methodKey, provider]);
	
	    var createCurlWithIp = (0, _react.useMemo)(function () {
	        if (!provider || !method || !method.bodyWithIp) return "";
	        var base = provider.baseUrlTest;
	        var bodyStr = method.bodyWithIp(method.label) || "";
	        return buildCurlPOST(base, method.path, provider.headers, bodyStr);
	    }, [provider, method]);
	
	    var createCurlWithoutIp = (0, _react.useMemo)(function () {
	        if (!provider || !method || !method.bodyWithoutIp) return "";
	        var base = provider.baseUrlTest;
	        var bodyStr = method.bodyWithoutIp(method.label) || "";
	        return buildCurlPOST(base, method.path, provider.headers, bodyStr);
	    }, [provider, method]);
	
	    var statusCurl = (0, _react.useMemo)(function () {
	        if (!provider || !provider.supportsStatus) return "";
	        var base = provider.baseUrlTest;
	        var path = provider.status.path("<id>");
	        return buildCurlGET(base, path, provider.headers);
	    }, [provider]);
	
	    // Публичный GET страницы оплаты (NPay) — БЕЗ заголовков аутентификации.
	    var npayPageCurl = (0, _react.useMemo)(function () {
	        if (!provider || providerKey !== "npay") return "";
	        return buildCurlGET(provider.baseUrlTest, "/npay/page/<token>", []);
	    }, [provider, providerKey]);
	
	    return _react2.default.createElement(
	        "div",
	        { className: _WikiModule2.default.page },
	        _react2.default.createElement(
	            "main",
	            { className: _WikiModule2.default.container },
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.hero },
	                _react2.default.createElement(
	                    "h1",
	                    { className: _WikiModule2.default.h1 },
	                    "API \u0434\u043B\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.lead },
	                    "\u041F\u0440\u0438\u0451\u043C \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439: ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Craft"
	                    ),
	                    " (QR),",
	                    " ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Hydra"
	                    ),
	                    " (P2P, \u0421\u0411\u041F).",
	                    " ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "\u0412\u044B\u043F\u043B\u0430\u0442\u044B"
	                    ),
	                    " \u043D\u0430 \u043A\u0430\u0440\u0442\u0443.",
	                    " ",
	                    "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043A\u0430\u0440\u0442: ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434"
	                    ),
	                    "."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.apiV3Banner },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u0415\u0434\u0438\u043D\u044B\u0439 API v3"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "\u041D\u043E\u0432\u0430\u044F \u044D\u0442\u0430\u043B\u043E\u043D\u043D\u0430\u044F \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044F: \u0432\u0441\u0435 \u043C\u0435\u0442\u043E\u0434\u044B, \u0435\u0434\u0438\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B \u0438 \u0442\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432."
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "a",
	                        { className: _WikiModule2.default.apiV3Link, href: API_V3_DOCS_URL },
	                        "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0443\u044E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.meta },
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Prod: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            provider ? provider.baseUrlProd : ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Test: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            provider ? provider.baseUrlTest : ""
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Content-Type: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "application/json"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        "Auth: ",
	                        provider ? provider.authHelp : null
	                    )
	                ),
	                providerKey === "craft" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "Craft"
	                    ),
	                    " \u2014 \u043F\u0440\u0438\u0451\u043C \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u0447\u0435\u0440\u0435\u0437 QR-\u043A\u043E\u0434."
	                ),
	                providerKey === "fins" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "\u0418\u0434\u0435\u043C\u043F\u043E\u0442\u0435\u043D\u0442\u043D\u043E\u0441\u0442\u044C \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u0442 \u0430\u0434\u0430\u043F\u0442\u0435\u0440 \u2014 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0439",
	                    " ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Idempotency-Key"
	                    ),
	                    " \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u0435 \u043D\u0443\u0436\u043D\u043E. \u0414\u043B\u044F \u0432\u0430\u0448\u0438\u0445 \u0434\u0443\u0431\u043B\u0435\u0439 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043F\u043E\u043B\u0435 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "external_reference"
	                    ),
	                    "."
	                ),
	                providerKey === "tkb" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "\u0412\u0441\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u044E\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 \u0435\u0434\u0438\u043D\u044B\u0439 POST",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "/api/v1"
	                    ),
	                    " \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435\u043C ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "method.type"
	                    ),
	                    ". \u0414\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442 TKB \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "card.number"
	                    ),
	                    "; \u0434\u0430\u043D\u043D\u044B\u0435",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "exp"
	                    ),
	                    "/",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "cvv"
	                    ),
	                    " \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u044E\u0442\u0441\u044F."
	                ),
	                providerKey === "payouts" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0437\u0430\u044F\u0432\u043E\u043A \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u043D\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0443\u044E \u043A\u0430\u0440\u0442\u0443 \u0438\u043B\u0438 \u043F\u043E \u0421\u0411\u041F. \u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0447\u0435\u0440\u0435\u0437 ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Merchant-UUID"
	                    ),
	                    " + ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Merchant-Key"
	                    ),
	                    " ",
	                    "\u0438\u043B\u0438 HMAC (",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "Merchant"
	                    ),
	                    " + ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "Sign"
	                    ),
	                    "). \u041F\u0440\u0438 \u0441\u043C\u0435\u043D\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u043D\u0430 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "callbackUrl"
	                    ),
	                    " \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0441 \u043F\u043E\u0434\u043F\u0438\u0441\u044C\u044E ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "Sign"
	                    ),
	                    "."
	                ),
	                providerKey === "internal" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u043C\u0435\u0442\u043E\u0434\u044B \u0434\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430\u043C\u0438 \u0438 \u0431\u0430\u043B\u0430\u043D\u0441\u0430\u043C\u0438. \u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0447\u0435\u0440\u0435\u0437 ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Merchant-UUID"
	                    ),
	                    " \u0438 ",
	                    _react2.default.createElement(
	                        Kbd,
	                        null,
	                        "X-Merchant-Key"
	                    ),
	                    ". \u0412\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435"
	                    ),
	                    " \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u044B."
	                ),
	                providerKey === "npay" && _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "\u041F\u0440\u0438\u0451\u043C \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u043F\u043E QR-\u043A\u043E\u0434\u0443 (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D, ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "npay.kg"
	                    ),
	                    "). \u0412\u044B \u043F\u0435\u0440\u0435\u0434\u0430\u0451\u0442\u0435 \u0441\u0443\u043C\u043C\u0443 ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        "\u0432 \u0440\u0443\u0431\u043B\u044F\u0445"
	                    ),
	                    " (",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "amount"
	                    ),
	                    ", ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "currency: RUB"
	                    ),
	                    ") \u2014 \u043C\u044B \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043A\u043E\u043D\u0432\u0435\u0440\u0442\u0438\u0440\u0443\u0435\u043C \u0435\u0451 \u0432 \u0441\u043E\u043C\u044B (KGS) \u043F\u043E \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043A\u0443\u0440\u0441\u0443 \u0438 \u0444\u043E\u0440\u043C\u0438\u0440\u0443\u0435\u043C QR. \u041A\u043B\u0438\u0435\u043D\u0442 \u043F\u043B\u0430\u0442\u0438\u0442, \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0432 QR \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0431\u0430\u043D\u043A\u0430 (\u0421\u0431\u0435\u0440\u0431\u0430\u043D\u043A, \u0422\u0438\u043D\u044C\u043A\u043E\u0444\u0444 \u0438 \u0434\u0440.). \u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442\u0435 \u043D\u0430 \u0441\u0432\u043E\u0439",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "callback_url"
	                    ),
	                    "; \u0441\u0442\u0430\u0442\u0443\u0441 \u0442\u0430\u043A\u0436\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u043F\u043E",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "GET /npay/payments/",
	                        "<transactionId>"
	                    ),
	                    "."
	                )
	            ),
	            _react2.default.createElement(
	                "nav",
	                { className: _WikiModule2.default.tabs, role: "tablist", "aria-label": "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044F" },
	                Object.keys(PROVIDERS).filter(function (k) {
	                    return !['tkb', 'fins'].includes(k);
	                }).map(function (k) {
	                    var active = providerKey === k;
	                    var classes = active ? _WikiModule2.default.tab + " " + _WikiModule2.default.tabActive : _WikiModule2.default.tab;
	                    return _react2.default.createElement(
	                        "button",
	                        {
	                            key: k,
	                            role: "tab",
	                            "aria-selected": active,
	                            className: classes,
	                            onClick: function onClick() {
	                                setProviderKey(k);
	                                var list = PROVIDERS[k] && PROVIDERS[k].methods ? PROVIDERS[k].methods : [];
	                                var first = list.length > 0 ? list[0].key : null;
	                                if (first) setMethodKey(first);
	                            }
	                        },
	                        PROVIDERS[k].label
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                "nav",
	                { className: _WikiModule2.default.tabs, role: "tablist", "aria-label": "\u041C\u0435\u0442\u043E\u0434\u044B" },
	                (provider && provider.methods ? provider.methods : []).map(function (m) {
	                    var active = method && method.key === m.key;
	                    var classes = active ? _WikiModule2.default.tab + " " + _WikiModule2.default.tabActive : _WikiModule2.default.tab;
	                    return _react2.default.createElement(
	                        "button",
	                        {
	                            key: m.key,
	                            role: "tab",
	                            "aria-selected": active,
	                            className: classes,
	                            onClick: function onClick() {
	                                return setMethodKey(m.key);
	                            }
	                        },
	                        m.label
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041A\u0430\u043A \u044D\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442"
	                ),
	                providerKey === "craft" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /craft/payment"
	                        ),
	                        " \u2014 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0430."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "H2H"
	                        ),
	                        " (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "h2h: true"
	                        ),
	                        "): \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 QR-\u0441\u0441\u044B\u043B\u043A\u0443 \u0432 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "externalRefs.payload"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Widget"
	                        ),
	                        " (\u0431\u0435\u0437 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "h2h"
	                        ),
	                        "): \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "redirectUrl"
	                        ),
	                        " \u043D\u0430 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /craft/status/",
	                            "{transactionId}"
	                        ),
	                        " \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "Callback \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " \u043F\u0440\u0438 \u0441\u043C\u0435\u043D\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0430."
	                    )
	                ) : providerKey === "hydra" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST ",
	                            method ? method.path : ""
	                        ),
	                        " \u0441 \u0442\u0435\u043B\u043E\u043C \u0438 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u043C\u0438."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0415\u0441\u043B\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u043D ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        ),
	                        " \u2014 \u0432\u0435\u0440\u043D\u0451\u043C",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "externalRefs"
	                        ),
	                        " \u0438 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0411\u0435\u0437 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        ),
	                        " \u2014 \u0432\u0435\u0440\u043D\u0451\u043C \u0441\u0441\u044B\u043B\u043A\u0443 (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "redirectUrl"
	                        ),
	                        " \u0438\u043B\u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentUrl"
	                        ),
	                        ")."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F:",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            provider ? provider.status.path("{transactionId}") : ""
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0415\u0441\u043B\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u043D ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " \u2014 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u0441\u0435\u0440\u0432\u0435\u0440\u043D\u043E\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435."
	                    )
	                ) : providerKey === "tkb" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0415\u0434\u0438\u043D\u044B\u0439 \u0440\u043E\u0443\u0442: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v1"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412 \u0437\u0430\u043F\u0440\u043E\u0441\u0435 \u0443\u043A\u0430\u0436\u0438\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "method.type"
	                        ),
	                        ":",
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "payout"
	                                ),
	                                " \u2014 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B (\u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "tkb"
	                                ),
	                                ")."
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "balance"
	                                ),
	                                " \u2014 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u0430\u043B\u0430\u043D\u0441 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430."
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "status"
	                                ),
	                                " \u2014 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441/\u044B \u043F\u043E",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "transactionId"
	                                ),
	                                " \u0438\u043B\u0438",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "externalReference"
	                                ),
	                                "."
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043A\u043E\u043B\u0431\u044D\u043A\u043E\u0432 \u043F\u0440\u0438\u0445\u043E\u0434\u044F\u0442 \u043D\u0430 \u0432\u0430\u0448",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " (\u0435\u0441\u043B\u0438 \u0437\u0430\u0434\u0430\u043D)."
	                    )
	                ) : providerKey === "fins" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B (\u0447\u0435\u0440\u0435\u0437 \u043D\u0430\u0448 \u0430\u0434\u0430\u043F\u0442\u0435\u0440):",
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "\u043A\u0430\u0440\u0442\u0430: ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "POST /fins/payouts/card"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                "\u0421\u0411\u041F: ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "POST /fins/payouts/sbp"
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0418\u0434\u0435\u043C\u043F\u043E\u0442\u0435\u043D\u0442\u043D\u043E\u0441\u0442\u044C \u2014 \u0432\u043D\u0443\u0442\u0440\u0438 \u0430\u0434\u0430\u043F\u0442\u0435\u0440\u0430;",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Idempotency-Key"
	                        ),
	                        " \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u0435 \u043D\u0443\u0436\u043D\u043E. \u0414\u043B\u044F \u0441\u0432\u043E\u0438\u0445 \u0434\u0443\u0431\u043B\u0435\u0439 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "external_reference"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "recipient"
	                        ),
	                        " \u041E\u0411\u042F\u0417\u0410\u0422\u0415\u041B\u042C\u041D\u041E \u0443\u043A\u0430\u0436\u0438\u0442\u0435:",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "last_name"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "first_name"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_number"
	                        ),
	                        " (\u043D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u2014 \u043D\u043E\u043C\u0435\u0440 \u041F\u0421\u0410),",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_date"
	                        ),
	                        " (\u0434\u0430\u0442\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 YYYY-MM-DD \u0438\u043B\u0438 DD.MM.YYYY) \u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "middle_name"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "em",
	                            null,
	                            "\u0438\u043B\u0438"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "has_middle_name=false"
	                        ),
	                        " (\u0435\u0441\u043B\u0438 \u043E\u0442\u0447\u0435\u0441\u0442\u0432\u0430 \u043D\u0435\u0442)."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430:",
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /fins/payouts/status/<transactionId|payoutId>"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u0430: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /fins/balance"
	                        ),
	                        "."
	                    )
	                ) : providerKey === "payouts" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v2/payout-request"
	                        ),
	                        " \u0441 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u0438 \u0441\u0443\u043C\u043C\u043E\u0439."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412 \u043E\u0442\u0432\u0435\u0442\u0435 \u2014 UUID \u0437\u0430\u044F\u0432\u043A\u0438, \u0441\u0442\u0430\u0442\u0443\u0441 \u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionId"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0417\u0430\u044F\u0432\u043A\u0430 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434-\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443. \u0415\u0441\u043B\u0438 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u2014 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "status: \"declined\""
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v2/payout-request/status"
	                        ),
	                        " \u043F\u043E ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "id"
	                        ),
	                        " \u0438\u043B\u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "externalReference"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0415\u0441\u043B\u0438 \u0437\u0430\u0434\u0430\u043D ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " \u2014 \u043F\u0440\u0438 \u043A\u0430\u0436\u0434\u043E\u0439 \u0441\u043C\u0435\u043D\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u043D\u0430 \u0432\u0430\u0448 URL \u043F\u0440\u0438\u0434\u0451\u0442 POST \u0441 \u043F\u043E\u0434\u043F\u0438\u0441\u044C\u044E ",
	                        _react2.default.createElement(
	                            Kbd,
	                            null,
	                            "Sign"
	                        ),
	                        " (HMAC-SHA256)."
	                    )
	                ) : providerKey === "internal" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412\u0441\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u044B \u0447\u0435\u0440\u0435\u0437 \u0435\u0434\u0438\u043D\u044B\u0439 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v1"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Merchant-UUID"
	                        ),
	                        " + ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Merchant-Key"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "method.direction: \"terminals\""
	                        ),
	                        " \u2014 \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u0441\u0435\u0445 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u043E\u0432 \u0441 \u0431\u0430\u043B\u0430\u043D\u0441\u0430\u043C\u0438."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "method.direction: \"terminal\""
	                        ),
	                        " + ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "terminalId"
	                        ),
	                        " \u2014 \u0431\u0430\u043B\u0430\u043D\u0441 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0411\u0435\u0437 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "direction"
	                        ),
	                        " \u2014 \u043E\u0431\u0449\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441 \u043F\u043E \u0432\u0441\u0435\u043C \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430\u043C."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435"
	                        ),
	                        " \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u044B (enabled + status=active)."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412\u043E \u0432\u0441\u0435\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430\u0445 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u0442\u0440\u0438 \u0431\u0430\u043B\u0430\u043D\u0441\u0430"
	                        ),
	                        ":",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionBalance"
	                        ),
	                        " (\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u043E\u043D\u043D\u044B\u0439),",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "settlementBalance"
	                        ),
	                        " (\u0432\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0439),",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "actualBalance"
	                        ),
	                        " (\u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439). \u0421\u0443\u043C\u043C\u044B \u0432 \u043A\u043E\u043F\u0435\u0439\u043A\u0430\u0445, ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "*Float"
	                        ),
	                        "-\u0432\u0435\u0440\u0441\u0438\u0438 \u2014 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445."
	                    )
	                ) : providerKey === "antifraud" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /check"
	                        ),
	                        " \u0441 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E \u0438\u0437: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "cardPan"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "phone"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "clientIp"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "HTTP 200 \u2014 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u0430, HTTP 422 \u2014 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E."
	                    )
	                ) : providerKey === "npay" ? _react2.default.createElement(
	                    "ol",
	                    { className: _WikiModule2.default.ol },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043F\u043B\u0430\u0442\u0451\u0436: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /npay/payments"
	                        ),
	                        " \u0441 \u0441\u0443\u043C\u043C\u043E\u0439 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445. \u0412 \u043E\u0442\u0432\u0435\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionId"
	                        ),
	                        ", \u0433\u043E\u0442\u043E\u0432\u044B\u0439 QR (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "qrDataUri"
	                        ),
	                        " / ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "qrBase64"
	                        ),
	                        ") \u0438 \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043E\u043F\u043B\u0430\u0442\u044B ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentPageUrl"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041F\u043E\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0443 QR \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u0432:",
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "\u041F\u0440\u043E\u0449\u0435 \u0432\u0441\u0435\u0433\u043E:"
	                                ),
	                                " \u0434\u0430\u0439\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0443",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "paymentPageUrl"
	                                ),
	                                " \u2014 \u044D\u0442\u043E \u043D\u0430\u0448\u0430 \u0433\u043E\u0442\u043E\u0432\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0441 QR-\u043A\u043E\u0434\u043E\u043C, \u0441\u0443\u043C\u043C\u043E\u0439 \u0438 \u0442\u0430\u0439\u043C\u0435\u0440\u043E\u043C."
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "\u0421\u0432\u043E\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430:"
	                                ),
	                                " \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 QR \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u043E\u0439 \u2014",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    '<img src="{qrDataUri}">'
	                                ),
	                                ". \u041B\u0438\u0431\u043E \u043D\u0430\u0440\u0438\u0441\u0443\u0439\u0442\u0435 QR \u0441\u0430\u043C\u0438 \u0438\u0437 \u0441\u0442\u0440\u043E\u043A\u0438 ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "payload"
	                                ),
	                                "."
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u041A\u043B\u0438\u0435\u043D\u0442 \u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0435\u0442 QR \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0431\u0430\u043D\u043A\u0430 \u0438 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0423\u0437\u043D\u0430\u0442\u044C \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442: \u043D\u0430 \u0432\u0430\u0448 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callback_url"
	                        ),
	                        " \u043F\u0440\u0438\u0434\u0451\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 (\u0435\u0441\u043B\u0438 \u0437\u0430\u0434\u0430\u043D), \u0438/\u0438\u043B\u0438 \u043E\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0439\u0442\u0435",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /npay/payments/",
	                            "<transactionId>"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        "\u0412\u043E\u0437\u0432\u0440\u0430\u0442: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /npay/refunds"
	                        ),
	                        " \u0441",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transaction_id"
	                        ),
	                        " \u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "amount"
	                        ),
	                        " (\u0442\u043E\u0436\u0435 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445)."
	                    )
	                ) : null
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u0422\u0435\u043B\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0430"
	                ),
	                providerKey === "craft" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: _WikiModule2.default.ul },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "client"
	                            ),
	                            " \u2014 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 (\u0442\u0435\u043B\u0435\u0444\u043E\u043D, email \u0438 \u0442.\u043F.)"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "product"
	                            ),
	                            " \u2014 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0432\u0430\u0440\u0430/\u0443\u0441\u043B\u0443\u0433\u0438"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "sum"
	                            ),
	                            " \u2014 \u0441\u0443\u043C\u043C\u0430 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u041E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: _WikiModule2.default.ul },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "h2h"
	                            ),
	                            " \u2014 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "true"
	                            ),
	                            " \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F QR-\u0441\u0441\u044B\u043B\u043A\u0438, \u0438\u043D\u0430\u0447\u0435 \u0440\u0435\u0434\u0438\u0440\u0435\u043A\u0442"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "description"
	                            ),
	                            " \u2014 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "externalReference"
	                            ),
	                            " \u2014 \u0432\u0430\u0448 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043A\u0430\u0437\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "callbackUrl"
	                            ),
	                            " \u2014 URL \u0434\u043B\u044F \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043E \u0441\u0442\u0430\u0442\u0443\u0441\u0435"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "redirectUrlSuccess"
	                            ),
	                            " \u2014 URL \u0440\u0435\u0434\u0438\u0440\u0435\u043A\u0442\u0430 \u043F\u0440\u0438 \u0443\u0441\u043F\u0435\u0445\u0435 (\u0434\u043B\u044F Widget)"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "redirectUrlError"
	                            ),
	                            " \u2014 URL \u0440\u0435\u0434\u0438\u0440\u0435\u043A\u0442\u0430 \u043F\u0440\u0438 \u043E\u0448\u0438\u0431\u043A\u0435 (\u0434\u043B\u044F Widget)"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "hydra" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u0412\u0430\u043B\u044E\u0442\u0430 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "RUB"
	                        ),
	                        ". ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "amount"
	                        ),
	                        " \u2014 \u0446\u0435\u043B\u043E\u0435 \u0447\u0438\u0441\u043B\u043E \u0432 \u0440\u0443\u0431\u043B\u044F\u0445.",
	                        _react2.default.createElement("br", null),
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "successUrl"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "declineUrl"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callbackUrl"
	                        ),
	                        " \u2014 \u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B."
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 A \u0441 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WikiModule2.default.note },
	                        "\u0412\u0435\u0440\u043D\u0443\u0442\u0441\u044F \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B externalRefs \u0438 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithIp(method.label) : "{}"
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 B \u0431\u0435\u0437 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "customerIp"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _WikiModule2.default.note },
	                        "\u0412\u0435\u0440\u043D\u0451\u0442\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443 (",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "redirectUrl"
	                        ),
	                        " \u0438\u043B\u0438",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentUrl"
	                        ),
	                        ")."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "tkb" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u0412\u0441\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u0435\u0437 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v1"
	                        ),
	                        ". \u0412 \u0442\u0435\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "method.type"
	                        ),
	                        ". \u0414\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "{ method: { type: \"payout\", provider: \"tkb\" } }"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "fins" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u0412\u0430\u043B\u044E\u0442\u0430 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "RUB"
	                        ),
	                        ". ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "amount"
	                        ),
	                        " \u2014 \u0447\u0438\u0441\u043B\u043E \u0432 \u0440\u0443\u0431\u043B\u044F\u0445.",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "external_reference"
	                        ),
	                        " \u2014 \u0441\u0442\u0440\u043E\u043A\u0430 \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u0440\u0440\u0435\u043B\u044F\u0446\u0438\u0438.",
	                        _react2.default.createElement("br", null),
	                        "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B:",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "last_name"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "first_name"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_number"
	                        ),
	                        " (\u043D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E\u0449\u0435\u0433\u043E \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u2014 \u043D\u043E\u043C\u0435\u0440 \u041F\u0421\u0410),",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_date"
	                        ),
	                        " (\u0434\u0430\u0442\u0430 \u041F\u0421\u0410) \u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "middle_name"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "em",
	                            null,
	                            "\u0438\u043B\u0438"
	                        ),
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "has_middle_name=false"
	                        ),
	                        ". \u041F\u043E\u043B\u044F",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "inn"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "purpose"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "reason"
	                        ),
	                        ",",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "email"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "phone"
	                        ),
	                        " \u2014 \u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 (\u0434\u043B\u044F \u0421\u0411\u041F \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u0435\u043D \u0432 \u0431\u043B\u043E\u043A\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "sbp.phone"
	                        ),
	                        ").",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "document_date"
	                        ),
	                        " \u0434\u043E\u043F\u0443\u0441\u043A\u0430\u0435\u0442 \u0444\u043E\u0440\u043C\u0430\u0442\u044B",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "YYYY-MM-DD"
	                        ),
	                        " (ISO 8601) \u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "DD.MM.YYYY"
	                        ),
	                        " \u2014 \u043A\u043E\u043D\u0432\u0435\u0440\u0442\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0432\u043E \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 API."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "payouts" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    methodKey === "status" ? _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u043E\u0438\u0441\u043A\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { className: _WikiModule2.default.note },
	                            "\u041F\u0435\u0440\u0435\u0434\u0430\u0439\u0442\u0435 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "id"
	                            ),
	                            " \u0437\u0430\u044F\u0432\u043A\u0438 \u0438\u043B\u0438 \u0435\u0451 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "externalReference"
	                            ),
	                            "."
	                        )
	                    ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F"
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "amount"
	                                ),
	                                " \u2014 \u0441\u0443\u043C\u043C\u0430 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445 (\u0447\u0438\u0441\u043B\u043E, \u043D\u0430\u043F\u0440. ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "1235.00"
	                                ),
	                                ")"
	                            ),
	                            methodKey === "create_sbp" ? _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    _react2.default.createElement(
	                                        "code",
	                                        null,
	                                        "type"
	                                    ),
	                                    " \u2014 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 ",
	                                    _react2.default.createElement(
	                                        "code",
	                                        null,
	                                        "\"sbp\""
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    _react2.default.createElement(
	                                        "code",
	                                        null,
	                                        "phone"
	                                    ),
	                                    " \u2014 \u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u0439 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "\u0431\u0430\u043D\u043A \u2014 ",
	                                    _react2.default.createElement(
	                                        "code",
	                                        null,
	                                        "bankName"
	                                    ),
	                                    " (\u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435) \u043B\u0438\u0431\u043E ",
	                                    _react2.default.createElement(
	                                        "code",
	                                        null,
	                                        "bankMemberId"
	                                    ),
	                                    " (12-\u0437\u043D\u0430\u0447\u043D\u044B\u0439 \u043A\u043E\u0434 \u041D\u0421\u041F\u041A)"
	                                )
	                            ) : _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "cardPan"
	                                ),
	                                " \u2014 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B (13-19 \u0446\u0438\u0444\u0440, \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u0442\u0441\u044F \u043F\u043E Luhn)"
	                            )
	                        ),
	                        methodKey === "create_sbp" && _react2.default.createElement(
	                            "p",
	                            { className: _WikiModule2.default.note },
	                            "\u041C\u043E\u0436\u043D\u043E \u043F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430 \u0438\u043B\u0438 \u0441\u0440\u0430\u0437\u0443 \u043A\u043E\u0434 \u041D\u0421\u041F\u041A. \u0415\u0441\u043B\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u044B \u043E\u0431\u0430 \u043F\u043E\u043B\u044F, \u043E\u043D\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u043E\u0431\u043E\u0437\u043D\u0430\u0447\u0430\u0442\u044C \u043E\u0434\u0438\u043D \u0431\u0430\u043D\u043A; \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0435\u0440\u043D\u0451\u0442 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "400 Bad Request"
	                            ),
	                            "."
	                        ),
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "\u041E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F"
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            { className: _WikiModule2.default.ul },
	                            methodKey !== "create_sbp" && _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "type"
	                                ),
	                                " \u2014 \u0442\u0438\u043F \u0432\u044B\u043F\u043B\u0430\u0442\u044B (",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "\"card\""
	                                ),
	                                ", \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "\"card\""
	                                ),
	                                ")"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "currency"
	                                ),
	                                " \u2014 \u0432\u0430\u043B\u044E\u0442\u0430 (",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "\"RUB\""
	                                ),
	                                ", \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "\"RUB\""
	                                ),
	                                ")"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "fullName"
	                                ),
	                                " \u2014 \u0424\u0418\u041E \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F; \u043F\u0443\u0441\u0442\u043E\u0435 \u0438\u043B\u0438 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F \u043A\u0430\u043A ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "\"0\""
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "email"
	                                ),
	                                " \u2014 email \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"
	                            ),
	                            methodKey !== "create_sbp" && _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "phone"
	                                ),
	                                " \u2014 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "externalReference"
	                                ),
	                                " \u2014 \u0432\u0430\u0448 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 ID (\u0434\u043E 64 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432, \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439)"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "callbackUrl"
	                                ),
	                                " \u2014 URL \u0434\u043B\u044F \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043E \u0441\u043C\u0435\u043D\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 (\u0434\u043E 512 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432)"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "description"
	                                ),
	                                " \u2014 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 (\u0434\u043E 512 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432)"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "documentDate"
	                                ),
	                                " \u2014 \u0434\u0430\u0442\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 (\u0434\u043E 20 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432)"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "documentNumber"
	                                ),
	                                " \u2014 \u043D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 (\u0434\u043E 64 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.bodyWithoutIp(method.label) : "{}"
	                        )
	                    ),
	                    methodKey === "status" && _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "internal" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u0412\u0441\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u0435\u0437 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "POST /api/v1"
	                        ),
	                        ". \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "method.type: \"balance\""
	                        ),
	                        " \u0441 \u0440\u0430\u0437\u043D\u044B\u043C\u0438 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "direction"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: _WikiModule2.default.ul },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "X-Merchant-UUID"
	                            ),
	                            " \u2014 UUID"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "X-Merchant-Key"
	                            ),
	                            " \u2014 \u043A\u043B\u044E\u0447"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "1. \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u0441\u0435\u0445 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u043E\u0432"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        "{\n  \"method\": { \"type\": \"balance\", \"direction\": \"terminals\" }\n}"
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "2. \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u0430\u043B\u0430\u043D\u0441 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        "{\n  \"method\": { \"type\": \"balance\", \"direction\": \"terminal\" },\n  \"terminalId\": 123\n}"
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "3. \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        "{\n  \"method\": { \"type\": \"balance\" }\n}"
	                    )
	                ) : providerKey === "antifraud" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u041F\u0435\u0440\u0435\u0434\u0430\u0439\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E \u0438\u0437 \u043F\u043E\u043B\u0435\u0439:"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: _WikiModule2.default.ul },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "cardPan"
	                            ),
	                            " \u2014 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B (13-19 \u0446\u0438\u0444\u0440)"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "phone"
	                            ),
	                            " \u2014 \u0442\u0435\u043B\u0435\u0444\u043E\u043D (\u0442\u043E\u043B\u044C\u043A\u043E \u0446\u0438\u0444\u0440\u044B)"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "clientIp"
	                            ),
	                            " \u2014 IP \u0430\u0434\u0440\u0435\u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        method ? method.bodyWithoutIp(method.label) : "{}"
	                    )
	                ) : providerKey === "npay" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    methodKey === "payment_status" || methodKey === "refund_status" ? _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "GET-\u0437\u0430\u043F\u0440\u043E\u0441 \u2014 \u0442\u0435\u043B\u043E \u043D\u0435 \u043D\u0443\u0436\u043D\u043E. \u041F\u0435\u0440\u0435\u0434\u0430\u0439\u0442\u0435 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionId"
	                        ),
	                        " \u0432 URL."
	                    ) : methodKey === "page" ? _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439"
	                        ),
	                        " GET-\u0437\u0430\u043F\u0440\u043E\u0441 \u2014 ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u0431\u0435\u0437"
	                        ),
	                        " \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u043E\u0432 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438. ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "token"
	                        ),
	                        " \u0432 URL \u2014 \u044D\u0442\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u0435\u0433\u043C\u0435\u043D\u0442",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "paymentPageUrl"
	                        ),
	                        " \u0438\u0437 \u043E\u0442\u0432\u0435\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430. \u0422\u043E\u0442 \u0436\u0435 \u044D\u043D\u0434\u043F\u043E\u0438\u043D\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u043D\u0430\u0448\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043E\u043F\u043B\u0430\u0442\u044B. \u041F\u043E \u0447\u0438\u0441\u043B\u043E\u0432\u043E\u043C\u0443 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "transactionId"
	                        ),
	                        " ",
	                        "\u043E\u043D ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\u043D\u0435"
	                        ),
	                        " \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 (\u0437\u0430\u0449\u0438\u0442\u0430 \u043E\u0442 \u043F\u043E\u0434\u0431\u043E\u0440\u0430 \u0447\u0443\u0436\u0438\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)."
	                    ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: _WikiModule2.default.note },
	                            "\u0421\u0443\u043C\u043C\u0430 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "amount"
	                            ),
	                            " \u2014 \u0432 ",
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                "\u0440\u0443\u0431\u043B\u044F\u0445"
	                            ),
	                            " (\u0447\u0438\u0441\u043B\u043E, \u043D\u0430\u043F\u0440.",
	                            " ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "100"
	                            ),
	                            " \u0438\u043B\u0438 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "100.50"
	                            ),
	                            "). \u041A\u043E\u043D\u0432\u0435\u0440\u0442\u0430\u0446\u0438\u044E \u0432 \u0441\u043E\u043C\u044B \u0434\u0435\u043B\u0430\u0435\u043C \u043C\u044B; ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "currency"
	                            ),
	                            " \u0432 \u043E\u0442\u0432\u0435\u0442\u0435 \u2014 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "RUB"
	                            ),
	                            ".",
	                            methodKey === "payment" && _react2.default.createElement(
	                                "span",
	                                null,
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "redirect_url"
	                                ),
	                                ", ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "callback_url"
	                                ),
	                                ",",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "comment"
	                                ),
	                                ", ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "expire_at"
	                                ),
	                                ",",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "amount_can_be_changed"
	                                ),
	                                " \u2014 \u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B (\u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0441\u0440\u043E\u043A \u0436\u0438\u0437\u043D\u0438 \u0441\u0441\u044B\u043B\u043A\u0438 \u2014 30 \u043C\u0438\u043D\u0443\u0442)."
	                            ),
	                            methodKey === "refund" && _react2.default.createElement(
	                                "span",
	                                null,
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "transaction_id"
	                                ),
	                                " \u2014 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 (id \u0438\u0441\u0445\u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430).",
	                                " ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "comment"
	                                ),
	                                ", ",
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "callback_url"
	                                ),
	                                " \u2014 \u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method && method.bodyWithoutIp ? method.bodyWithoutIp(method.label) : "{}"
	                        )
	                    )
	                ) : null
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.grid2 },
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.card },
	                    _react2.default.createElement(
	                        "h3",
	                        { className: _WikiModule2.default.h3 },
	                        "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0439 \u043E\u0442\u0432\u0435\u0442"
	                    ),
	                    providerKey === "npay" ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successManual : "{}"
	                        ),
	                        (methodKey === "payment" || methodKey === "refund") && createCurlWithoutIp && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _WikiModule2.default.h4 },
	                                "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                            ),
	                            _react2.default.createElement(
	                                Code,
	                                { lang: "bash" },
	                                createCurlWithoutIp
	                            )
	                        ),
	                        (methodKey === "payment_status" || methodKey === "refund_status") && statusCurl && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _WikiModule2.default.h4 },
	                                "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                            ),
	                            _react2.default.createElement(
	                                Code,
	                                { lang: "bash" },
	                                statusCurl
	                            )
	                        ),
	                        methodKey === "page" && npayPageCurl && _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _WikiModule2.default.h4 },
	                                "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                            ),
	                            _react2.default.createElement(
	                                Code,
	                                { lang: "bash" },
	                                npayPageCurl
	                            )
	                        )
	                    ) : providerKey === "hydra" ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "\u0415\u0441\u043B\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u043D ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "customerIp"
	                            ),
	                            " (manual)"
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successManual : "{}"
	                        ),
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "\u0415\u0441\u043B\u0438 \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u043D (redirect)"
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successLink : "{}"
	                        ),
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WikiModule2.default.note },
	                            "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 A \u0441 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "customerIp"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "bash" },
	                            createCurlWithIp
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _WikiModule2.default.note },
	                            "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 B \u0431\u0435\u0437 ",
	                            _react2.default.createElement(
	                                "code",
	                                null,
	                                "customerIp"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "bash" },
	                            createCurlWithoutIp
	                        )
	                    ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "json" },
	                            method ? method.successManual : "{}"
	                        ),
	                        _react2.default.createElement(
	                            "h4",
	                            { className: _WikiModule2.default.h4 },
	                            "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                        ),
	                        _react2.default.createElement(
	                            Code,
	                            { lang: "bash" },
	                            createCurlWithoutIp
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.card },
	                    _react2.default.createElement(
	                        "h3",
	                        { className: _WikiModule2.default.h3 },
	                        "\u041E\u0448\u0438\u0431\u043A\u0438"
	                    ),
	                    provider && provider.errorSamples ? _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        provider.errorSamples
	                    ) : _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        "// 400 Bad Request \u2014 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0435/\u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043F\u043E\u043B\u044F\n{ \"message\": \"\u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u043E\u0448\u0438\u0431\u043A\u0438\" }\n\n// 401 \u0438\u043B\u0438 403 \u2014 \u043E\u0448\u0438\u0431\u043A\u0438 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438"
	                    )
	                )
	            ),
	            providerKey === "fins" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u0430"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0410\u0433\u0440\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0431\u0430\u043B\u0430\u043D\u0441 \u043F\u043E CARD+SBP. \u041F\u043E\u043B\u044F",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "amount_minor"
	                    ),
	                    " / ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "overdraft_minor"
	                    ),
	                    " \u2014 \u0432 \u043C\u0438\u043D\u043E\u0440\u043D\u044B\u0445 \u0435\u0434\u0438\u043D\u0438\u0446\u0430\u0445 (\u043A\u043E\u043F\u0435\u0439\u043A\u0430\u0445). \u0414\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u2014",
	                    " ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "amount"
	                    ),
	                    "/",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "overdraft"
	                    ),
	                    " \u0432 \u0440\u0443\u0431\u043B\u044F\u0445 (2 \u0437\u043D\u0430\u043A\u0430)."
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "\u041F\u0440\u0438\u043C\u0435\u0440 \u043E\u0442\u0432\u0435\u0442\u0430"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "json" },
	                    "{\n  \"ok\": true,\n  \"provider\": \"finstar\",\n  \"balance\": {\n    \"amount\": \"123.45\",\n    \"overdraft\": \"0.00\",\n    \"currency\": \"RUB\",\n    \"amount_minor\": 12345,\n    \"overdraft_minor\": 0\n  },\n  \"request_id\": \"...\"\n}"
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "bash" },
	                    buildCurlGET(PROVIDERS.fins.baseUrlTest, "/fins/balance", PROVIDERS.fins.headers)
	                )
	            ),
	            provider && provider.supportsStatus && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430"
	                ),
	                providerKey === "craft" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            PROVIDERS.craft.status.path("{transactionId}")
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u0421\u0442\u0430\u0442\u0443\u0441\u044B: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "PROCESSING"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "SUCCESS"
	                        ),
	                        ", ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "DECLINED"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.craft.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "cURL"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "bash" },
	                        statusCurl
	                    )
	                ) : providerKey === "npay" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u041F\u043B\u0430\u0442\u0451\u0436: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            PROVIDERS.npay.status.path("{transactionId}")
	                        ),
	                        _react2.default.createElement("br", null),
	                        "\u0412\u043E\u0437\u0432\u0440\u0430\u0442: ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET /npay/refunds/",
	                            "<transactionId>"
	                        ),
	                        _react2.default.createElement("br", null),
	                        "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0438 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0442\u0435 \u0436\u0435."
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u041F\u0440\u0438\u043C\u0435\u0440 \u043E\u0442\u0432\u0435\u0442\u0430"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.npay.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u0421\u0442\u0430\u0442\u0443\u0441\u044B"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        "// status (\u043D\u0430\u0448)  \u2190 providerStatus (NPay)\n\"SUCCESS\"        \u2190 \"COMPLETED\"\n\"DECLINED\"       \u2190 \"CANCELED\" / \"FAILED\" / \"EXPIRED\"\n\"PENDING\"        \u2190 \"ACTIVE\" / \"NEW\"\n\"PROCESSING\"     \u2190 \u043F\u043B\u0430\u0442\u0451\u0436 \u0442\u043E\u043B\u044C\u043A\u043E \u0441\u043E\u0437\u0434\u0430\u043D"
	                    )
	                ) : providerKey === "hydra" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u0420\u043E\u0443\u0442",
	                        " ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            PROVIDERS.hydra.status.path("{transactionId}")
	                        ),
	                        _react2.default.createElement("br", null),
	                        " \u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0438 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0442\u0435 \u0436\u0435, \u0447\u0442\u043E \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438."
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u041F\u0440\u0438\u043C\u0435\u0440 \u043E\u0442\u0432\u0435\u0442\u0430"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.hydra.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "bash" },
	                        statusCurl
	                    )
	                ) : _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u0415\u0434\u0438\u043D\u044B\u0439 \u0440\u043E\u0443\u0442:",
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "GET ",
	                            PROVIDERS.fins.status.path("{transactionId|payoutId}")
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u041F\u0440\u0438\u043C\u0435\u0440 \u043E\u0442\u0432\u0435\u0442\u0430"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.fins.status.success
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u041F\u0440\u0438\u043C\u0435\u0440 cURL"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "bash" },
	                        statusCurl
	                    )
	                )
	            ),
	            (providerKey === "craft" || providerKey === "hydra" || providerKey === "tkb" || providerKey === "fins" || providerKey === "payouts" || providerKey === "npay") && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "Callback (\u0435\u0441\u043B\u0438 \u0437\u0430\u0434\u0430\u043D ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "callback_url"
	                    ),
	                    ")"
	                ),
	                providerKey === "npay" ? _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: _WikiModule2.default.note },
	                        "\u041A\u043E\u0433\u0434\u0430 NPay \u043F\u0440\u0438\u0441\u044B\u043B\u0430\u0435\u0442 \u0432\u0435\u0431\u0445\u0443\u043A \u0441 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u043C \u2014 \u043C\u044B \u043F\u0435\u0440\u0435\u0441\u044B\u043B\u0430\u0435\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448 ",
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "callback_url"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.npay.callbackSample
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _WikiModule2.default.h4 },
	                        "\u0424\u043E\u0440\u043C\u0430\u0442 \u0432\u0435\u0431\u0445\u0443\u043A\u0430 \u043E\u0442 NPay"
	                    ),
	                    _react2.default.createElement(
	                        Code,
	                        { lang: "json" },
	                        PROVIDERS.npay.webhookSample
	                    )
	                ) : _react2.default.createElement(
	                    Code,
	                    { lang: "json" },
	                    providerKey === "craft" ? PROVIDERS.craft.callbackSample : providerKey === "hydra" ? PROVIDERS.hydra.callbackSample : providerKey === "tkb" ? PROVIDERS.tkb.callbackSample : providerKey === "payouts" ? PROVIDERS.payouts.callbackSample : PROVIDERS.fins.callbackSample
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _WikiModule2.default.note },
	                    "POST JSON \u043D\u0430 \u0432\u0430\u0448 \u043A\u043E\u043B\u0431\u044D\u043A",
	                    providerKey === "tkb" ? "." : " с повторными попытками при ошибках сети/5xx.",
	                    providerKey === "tkb" && _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        "\u0414\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0442\u0432\u0435\u0442 HTTP 200: \u043F\u0440\u0438 \u043B\u044E\u0431\u043E\u043C \u0434\u0440\u0443\u0433\u043E\u043C \u043A\u043E\u0434\u0435, \u0442\u0430\u0439\u043C\u0430\u0443\u0442\u0435 \u0438\u043B\u0438 \u043E\u0431\u0440\u044B\u0432\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u0435\u0442\u0441\u044F \u0441 \u043D\u0430\u0440\u0430\u0441\u0442\u0430\u044E\u0449\u0438\u043C\u0438 \u043F\u0430\u0443\u0437\u0430\u043C\u0438 \u2014 \u0434\u043E 24 \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0437\u0430 31 \u0447\u0430\u0441."
	                    ),
	                    providerKey === "payouts" && _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        "\u041E\u0448\u0438\u0431\u043A\u0438 \u0441\u0435\u0442\u0438, 5xx, 408 \u0438 429 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0442\u0441\u044F \u0434\u043E \u0442\u0440\u0451\u0445 \u0441\u0443\u0442\u043E\u043A; \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 4xx \u0441\u0447\u0438\u0442\u0430\u044E\u0442\u0441\u044F \u043E\u043A\u043E\u043D\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u043E\u0442\u043A\u0430\u0437\u043E\u043C."
	                    ),
	                    providerKey === "payouts" && _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        "\u041F\u043E\u0434\u043F\u0438\u0441\u044C \u0432 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0435 ",
	                        _react2.default.createElement(
	                            Kbd,
	                            null,
	                            "Sign"
	                        ),
	                        ": HMAC-SHA256 \u043E\u0442 \u0442\u0435\u043B\u0430, \u043A\u043B\u044E\u0447 \u2014 \u0432\u0430\u0448 merchant key."
	                    )
	                )
	            ),
	            providerKey === "craft" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B \u043F\u043B\u0430\u0442\u0435\u0436\u0430 (pspState)"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0432 \u043F\u043E\u043B\u0435 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "pspState"
	                    ),
	                    " \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 (",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "GET /craft/status/",
	                        "{id}"
	                    ),
	                    ") \u0438\u043B\u0438 \u0432 webhook callback:"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0422\u0438\u043F"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "SUCCESS"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0424\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0439"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "DECLINED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0424\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0439"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u043E\u0442\u043A\u043B\u043E\u043D\u0451\u043D \u0438\u043B\u0438 \u043E\u0442\u043C\u0435\u043D\u0451\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PROCESSING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u043E\u043C\u0435\u0436\u0443\u0442\u043E\u0447\u043D\u044B\u0439"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438, \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "ERROR"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0424\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0439"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "ALREADY_EXISTS"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u0441 \u0442\u0430\u043A\u0438\u043C ID \u0443\u0436\u0435 \u0431\u044B\u043B \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D (\u0434\u0443\u0431\u043B\u0438\u043A\u0430\u0442)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "NOT_FOUND"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0440\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "null"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D, \u043D\u0435\u0442 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E\u0442 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "hydra" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u044B \u0432 \u043F\u043E\u043B\u044F\u0445 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "state"
	                    ),
	                    " / ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "hydraState"
	                    ),
	                    ":"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PENDING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u0441\u043E\u0437\u0434\u0430\u043D, \u043E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u043F\u043B\u0430\u0442\u044B"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PROCESSING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "COMPLETED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "AUTHORIZED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D (\u0443\u0441\u043F\u0435\u0445)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "DECLINED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u043E\u0442\u043A\u043B\u043E\u043D\u0451\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "CANCELED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043B\u0430\u0442\u0451\u0436 \u043E\u0442\u043C\u0435\u043D\u0451\u043D \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043B\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "EXPIRED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u0440\u0435\u043C\u044F \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443 \u0438\u0441\u0442\u0435\u043A\u043B\u043E"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "ERROR"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "tkb" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u044B \u0432 \u043F\u043E\u043B\u0435 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "transactionType"
	                    ),
	                    ":"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT_CREATED"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430, \u043E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT_PENDING"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "PAYOUT_DECLINE"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "fins" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041D\u043E\u0440\u043C\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044B \u0432 \u043F\u043E\u043B\u0435 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "status"
	                    ),
	                    " \u043E\u0442\u0432\u0435\u0442\u0430:"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "success"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "pending"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "declined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note, style: { marginTop: "1rem" } },
	                    "\u041E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044B \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 (\u043F\u043E\u043B\u0435 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "last_operation_status"
	                    ),
	                    "):"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "approve"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0430 (\u0443\u0441\u043F\u0435\u0445)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "approved"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0430 (\u0443\u0441\u043F\u0435\u0445)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "pending"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "processing"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "created"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "decline"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "declined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "failed"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "canceled"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "expired"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u0440\u0435\u043C\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0438\u0441\u0442\u0435\u043A\u043B\u043E"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "payouts" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B \u0437\u0430\u044F\u0432\u043A\u0438"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u0421\u0442\u0430\u0442\u0443\u0441\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0432 \u043F\u043E\u043B\u044F\u0445 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "status"
	                    ),
	                    " / ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "statusCode"
	                    ),
	                    ":"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u0421\u0442\u0430\u0442\u0443\u0441"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "0"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "created"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0417\u0430\u044F\u0432\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "7"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "awaitingPayout"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0442\u044B (\u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434 \u043F\u0440\u043E\u0439\u0434\u0435\u043D)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "3"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "inRegistry"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u0430 \u0432 \u0440\u0435\u0435\u0441\u0442\u0440 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "4"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "processing"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "5"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "success"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "6"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "failed"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043D\u0435 \u0443\u0434\u0430\u043B\u0430\u0441\u044C"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "1"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "antifraudDeclined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u043E\u043C"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "2"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "declined"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E"
	                            )
	                        )
	                    )
	                )
	            ),
	            providerKey === "payouts" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u0434\u0432\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u0430 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438:"
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "\u0421\u043F\u043E\u0441\u043E\u0431 1: \u041F\u0440\u043E\u0441\u0442\u0430\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _WikiModule2.default.ul },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Merchant-UUID"
	                        ),
	                        " \u2014 UUID \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "X-Merchant-Key"
	                        ),
	                        " \u2014 API \u043A\u043B\u044E\u0447 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430"
	                    )
	                ),
	                _react2.default.createElement(
	                    "h4",
	                    { className: _WikiModule2.default.h4 },
	                    "\u0421\u043F\u043E\u0441\u043E\u0431 2: HMAC-\u043F\u043E\u0434\u043F\u0438\u0441\u044C"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _WikiModule2.default.ul },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "Merchant"
	                        ),
	                        " \u2014 UUID \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "code",
	                            null,
	                            "Sign"
	                        ),
	                        " \u2014 HMAC-SHA256 \u043F\u043E\u0434\u043F\u0438\u0441\u044C \u0442\u0435\u043B\u0430 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0432\u0430\u0448\u0438\u043C \u043A\u043B\u044E\u0447\u043E\u043C"
	                    )
	                ),
	                _react2.default.createElement(
	                    Code,
	                    { lang: "bash" },
	                    "# \u041F\u0440\u0438\u043C\u0435\u0440 \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0438\nSIGN=$(echo -n '$JSON_BODY' | openssl dgst -sha256 -hmac '$MERCHANT_KEY' | awk '{print $2}')\ncurl -X POST 'https://api.e-clear.cc/api/v2/payout-request' \\\n  -H 'Content-Type: application/json' \\\n  -H 'Merchant: <YOUR-UUID>' \\\n  -H 'Sign: '$SIGN \\\n  -d '$JSON_BODY'"
	                )
	            ),
	            providerKey === "fins" && _react2.default.createElement(
	                "section",
	                { className: _WikiModule2.default.card },
	                _react2.default.createElement(
	                    "h2",
	                    { className: _WikiModule2.default.h2 },
	                    "\u041A\u043E\u0434\u044B \u043E\u0448\u0438\u0431\u043E\u043A \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 (4PMTS)"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _WikiModule2.default.note },
	                    "\u041F\u0440\u0438 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u0438 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0439 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "error_code"
	                    ),
	                    " \u0438 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435. \u041D\u0438\u0436\u0435 \u2014 \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u043A\u043E\u0434\u043E\u0432, \u0441\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043C. \u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0451\u0442\u0441\u044F \u0432 \u043F\u043E\u043B\u0435 ",
	                    _react2.default.createElement(
	                        "code",
	                        null,
	                        "error.details.error_code"
	                    ),
	                    " \u043E\u0442\u0432\u0435\u0442\u0430."
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0435 \u043E\u0448\u0438\u0431\u043A\u0438 (100\u2013114)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "100"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "101"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0420\u0435\u0441\u0443\u0440\u0441 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D (\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F/\u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "102"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u043B\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u0430\u0437\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "103"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041C\u0435\u0442\u043E\u0434 \u043D\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0451\u043D \u0434\u043B\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u0430\u0437\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "104"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 (idempotency key)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "105"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438 \u0432\u0445\u043E\u0434\u043D\u044B\u0445 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "106"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "107"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 (rate limit)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "108"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 (\u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0442\u043E\u043A\u0435\u043D/\u043A\u043B\u044E\u0447)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "109"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0414\u043E\u0441\u0442\u0443\u043F \u0437\u0430\u043F\u0440\u0435\u0449\u0451\u043D (\u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u043D\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044E)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "110"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 (\u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "111"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0430\u0439\u043C-\u0430\u0443\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043A \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0443"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "112"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0443"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "113"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "114"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434 (200\u2013280)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "200"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430 \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434-\u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "201"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u0434\u043E\u0437\u0440\u0435\u043D\u0438\u0435 \u043D\u0430 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u043E"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "202"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0430\u0440\u0442\u0430 \u0432 \u0447\u0451\u0440\u043D\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "203"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "IP-\u0430\u0434\u0440\u0435\u0441 \u0432 \u0447\u0451\u0440\u043D\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "204"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0442\u0440\u0430\u043D\u0430 \u043A\u0430\u0440\u0442\u044B \u043D\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "205"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u043F\u043E \u0441\u0443\u043C\u043C\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "206"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "207"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0430\u0440\u0442\u0430 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "210"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E 3D-Secure \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u043E\u0439"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "250"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "260"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C \u0432 \u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u043D\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "270"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0411\u0430\u043D\u043A \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "280"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0447\u0451\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u043A\u0440\u044B\u0442 \u0438\u043B\u0438 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "3D-Secure (300\u2013308)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "300"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 3D-Secure \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "301"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3D-Secure \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "302"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043F\u0440\u043E\u0448\u0451\u043B 3D-Secure"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "303"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0430\u0439\u043C-\u0430\u0443\u0442 3D-Secure"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "304"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F 3D-Secure"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "305"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043E\u0442\u0432\u0435\u0442 \u043E\u0442 \u0441\u0435\u0440\u0432\u0435\u0440\u0430 3DS"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "306"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3DS \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u0435\u043D, \u043D\u043E \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043A\u0430\u0440\u0442\u043E\u0439"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "307"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E \u0438\u0437\u0434\u0430\u0442\u0435\u043B\u0435\u043C \u043F\u0440\u0438 3DS \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "308"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "3DS \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u041E\u0448\u0438\u0431\u043A\u0438 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430/\u0431\u0430\u043D\u043A\u0430 (400\u2013503)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "400"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0431\u0449\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "401"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u0441\u0447\u0451\u0442\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "402"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430 \u0431\u0430\u043D\u043A\u043E\u043C"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "403"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u043F\u043E \u043A\u0430\u0440\u0442\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "404"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0430\u0440\u0442\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 / \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "405"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0430\u0440\u0442\u0430 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "406"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0430\u0440\u0442\u0430 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "407"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 CVV/CVC"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "408"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0438\u043F \u043A\u0430\u0440\u0442\u044B \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "409"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0411\u0430\u043D\u043A-\u044D\u043C\u0438\u0442\u0435\u043D\u0442 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "410"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F (\u0434\u0443\u0431\u043B\u0438\u043A\u0430\u0442)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "411"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "412"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "420"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "430"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0430\u0439\u043C-\u0430\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0430 \u043E\u0442 \u0431\u0430\u043D\u043A\u0430-\u044D\u043A\u0432\u0430\u0439\u0435\u0440\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "440"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u043E\u043C"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "450"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0434\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u044B"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "500"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0438\u0441\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "501"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0435\u0440\u0432\u0438\u0441 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "502"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u0448\u043B\u044E\u0437\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "503"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0435\u0440\u0432\u0438\u0441 \u043F\u0435\u0440\u0435\u0433\u0440\u0443\u0436\u0435\u043D"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u041E\u0442\u0432\u0435\u0442\u044B \u0431\u0430\u043D\u043A\u0430-\u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430 (601\u2013699)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "601"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0442\u043A\u0430\u0437 \u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430 \u0431\u0435\u0437 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0447\u0438\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "602"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u0434\u043E\u0437\u0440\u0435\u043D\u0438\u0435 \u043D\u0430 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u043E (\u044D\u043C\u0438\u0442\u0435\u043D\u0442)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "603"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0430\u0440\u0442\u0430 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0430 \u0434\u043B\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "604"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041A\u0430\u0440\u0442\u0430 \u0438\u0437\u044A\u044F\u0442\u0430 / \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u0430 / \u0443\u043A\u0440\u0430\u0434\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "605"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 PIN"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "606"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0432\u0432\u043E\u0434\u0430 PIN"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "607"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0414\u0435\u0440\u0436\u0430\u0442\u0435\u043B\u044E \u043A\u0430\u0440\u0442\u044B \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u043A \u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0443"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "610"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0443\u043C\u043C\u0430 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439 \u043B\u0438\u043C\u0438\u0442"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "620"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "630"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0447\u0451\u0442 \u0437\u0430\u043A\u0440\u044B\u0442"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "640"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430: \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u043F\u043E \u0441\u0442\u0440\u0430\u043D\u0435"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "650"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u043A\u0430\u0440\u0442\u044B"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "660"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0430\u0439\u043C-\u0430\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0430 \u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "699"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u043E\u0447\u0438\u0439 \u043E\u0442\u043A\u0430\u0437 \u044D\u043C\u0438\u0442\u0435\u043D\u0442\u0430"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0435 \u043A\u043E\u0434\u044B (720\u2013779)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "720"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0448\u0438\u0431\u043A\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "721"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0440\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "722"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "723"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u043E\u043A\u0435\u043D \u043A\u0430\u0440\u0442\u044B \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "730"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D (\u0438\u0441\u0442\u0451\u043A \u0441\u0440\u043E\u043A)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "731"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0427\u0430\u0441\u0442\u0438\u0447\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "740"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "750"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "760"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 email"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "770"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "779"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u043E\u0447\u0438\u0435 \u043E\u0448\u0438\u0431\u043A\u0438 \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { className: _WikiModule2.default.h3 },
	                    "\u0421\u0411\u041F-\u043A\u043E\u0434\u044B (801\u2013854)"
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: _WikiModule2.default.table },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041A\u043E\u0434"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "801"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0411\u0430\u043D\u043A \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u043C \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "802"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "803"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0447\u0451\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u043D\u0435 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D \u043A \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "804"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0430\u0439\u043C-\u0430\u0443\u0442 \u0421\u0411\u041F-\u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "805"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0411\u041F-\u043F\u0435\u0440\u0435\u0432\u043E\u0434 \u043E\u0442\u043A\u043B\u043E\u043D\u0451\u043D \u0431\u0430\u043D\u043A\u043E\u043C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "806"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043B\u044F \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "807"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 bank_member_id"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "808"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u0421\u0411\u041F-\u043F\u0435\u0440\u0435\u0432\u043E\u0434\u043E\u0432"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "810"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0441\u0431\u043E\u0439 \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "820"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0411\u041F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 (\u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "830"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u043B \u043F\u0440\u0438\u0451\u043C \u0421\u0411\u041F-\u043F\u0435\u0440\u0435\u0432\u043E\u0434\u043E\u0432"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "840"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B QR-\u043A\u043E\u0434\u0430 \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "850"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434-\u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439 \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "851"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u0434\u043E\u0437\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F (\u0421\u0411\u041F)"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "852"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C \u0432 \u0441\u0442\u043E\u043F-\u043B\u0438\u0441\u0442\u0435 \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "853"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0443\u043C\u043C\u0430 \u043D\u0438\u0436\u0435 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439 \u0434\u043B\u044F \u0421\u0411\u041F"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement(
	                                    "code",
	                                    null,
	                                    "854"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "td",
	                                null,
	                                "\u0421\u0443\u043C\u043C\u0430 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E \u0434\u043B\u044F \u0421\u0411\u041F"
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "footer",
	                { className: _WikiModule2.default.footer },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    "\xA9 E-Clear"
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: _WikiModule2.default.dot },
	                    "\u2022"
	                ),
	                _react2.default.createElement(
	                    "a",
	                    { className: _WikiModule2.default.link, href: "#top" },
	                    "\u041D\u0430\u0432\u0435\u0440\u0445"
	                )
	            )
	        )
	    );
	};
	
	exports.default = MerchantsDocs;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STATUS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.confirmEmailCode = confirmEmailCode;
	exports.ConfirmationView = ConfirmationView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Auth = __webpack_require__(4);
	
	var _stylesModule = __webpack_require__(625);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATUS = exports.STATUS = {
	    LOADING: 'loading',
	    SUCCESS: 'success',
	    INVALID: 'invalid',
	    FAILED: 'failed'
	};
	
	/**
	 * Подтверждение кода из письма. Отказ запроса (сеть, 5xx) — отдельный исход:
	 * раньше его не ловили, и страница навсегда оставалась на загрузчике.
	 */
	function confirmEmailCode(api, code) {
	    return api.sendConfirmationEmailCode(code).then(function (r) {
	        if (r && r.error === false) {
	            return STATUS.SUCCESS;
	        }
	        if (r && r.error === true) {
	            return STATUS.INVALID;
	        }
	        return STATUS.FAILED;
	    }, function () {
	        return STATUS.FAILED;
	    });
	}
	
	function ConfirmationView(_ref) {
	    var status = _ref.status,
	        isAuthorized = _ref.isAuthorized;
	
	    if (status === STATUS.LOADING) {
	        return _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.ConfirmPage },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Container },
	                _react2.default.createElement(_Loader2.default, null)
	            )
	        );
	    }
	
	    // Уже вошедшего ведём в кабинет, остальных — на вход.
	    var cabinetLink = isAuthorized ? _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/', className: _stylesModule2.default.Btn },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Confirmation.btn.cabinet', defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043A\u0430\u0431\u0438\u043D\u0435\u0442' })
	    ) : _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/login', className: _stylesModule2.default.Btn },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Confirmation.btn.login', defaultMessage: '\u0412\u043E\u0439\u0442\u0438 \u0432 \u043A\u0430\u0431\u0438\u043D\u0435\u0442' })
	    );
	
	    var content = void 0;
	    if (status === STATUS.SUCCESS) {
	        content = _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement('div', { className: _stylesModule2.default.SuccessIcon }),
	            _react2.default.createElement(
	                'h2',
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Confirmation.title.success', defaultMessage: '\u041F\u043E\u0447\u0442\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0430' })
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: _stylesModule2.default.Text },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: 'Confirmation.text.success',
	                    defaultMessage: '\u041D\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0441\u043E\u0445\u0440\u0430\u043D\u0451\u043D \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0435. \u041F\u0438\u0441\u044C\u043C\u0430 \u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0442\u0435\u043F\u0435\u0440\u044C \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u043D\u0430 \u043D\u0435\u0433\u043E.'
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Actions },
	                cabinetLink
	            )
	        );
	    } else if (status === STATUS.INVALID) {
	        content = _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement('div', { className: _stylesModule2.default.ErrorIcon }),
	            _react2.default.createElement(
	                'h2',
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Confirmation.title.error', defaultMessage: '\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430' })
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: _stylesModule2.default.Text },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: 'Confirmation.text.error',
	                    defaultMessage: '\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0430\u0434\u0440\u0435\u0441 \u0443\u0436\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D \u043F\u043E \u044D\u0442\u043E\u0439 \u0441\u0441\u044B\u043B\u043A\u0435 \u0438\u043B\u0438 \u0441\u043C\u0435\u043D\u0443 \u043F\u043E\u0447\u0442\u044B \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u043B\u0438 \u0437\u0430\u043D\u043E\u0432\u043E. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u043E\u0447\u0442\u0443 \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0435 \u0438 \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0441\u043C\u0435\u043D\u0443 \u0435\u0449\u0451 \u0440\u0430\u0437.'
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Actions },
	                cabinetLink
	            )
	        );
	    } else {
	        content = _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement('div', { className: _stylesModule2.default.ErrorIcon }),
	            _react2.default.createElement(
	                'h2',
	                { className: _stylesModule2.default.Title },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Confirmation.title.failed', defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043F\u043E\u0447\u0442\u0443' })
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: _stylesModule2.default.Text },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: 'Confirmation.text.failed',
	                    defaultMessage: '\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437. \u0415\u0441\u043B\u0438 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0441\u044F, \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.'
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.Actions },
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: _stylesModule2.default.Btn, onClick: function onClick() {
	                            return window.location.reload();
	                        } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Confirmation.btn.retry', defaultMessage: '\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0451 \u0440\u0430\u0437' })
	                ),
	                _react2.default.cloneElement(cabinetLink, { className: _stylesModule2.default.Btn + ' ' + _stylesModule2.default.BtnSecondary })
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.ConfirmPage },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Container },
	            content
	        )
	    );
	}
	
	function Confirmation(_ref2) {
	    var isAuthorized = _ref2.isAuthorized;
	
	    var _useParams = (0, _reactRouterDom.useParams)(),
	        code = _useParams.code;
	
	    var _useState = (0, _react.useState)(STATUS.LOADING),
	        _useState2 = _slicedToArray(_useState, 2),
	        status = _useState2[0],
	        setStatus = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        var active = true;
	        confirmEmailCode(new _Api2.default(), code).then(function (result) {
	            if (active) {
	                setStatus(result);
	            }
	        });
	        return function () {
	            active = false;
	        };
	    }, [code]);
	
	    return _react2.default.createElement(ConfirmationView, { status: status, isAuthorized: isAuthorized });
	}
	
	exports.default = (0, _Auth.withAuth)(Confirmation);

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _json2csv = __webpack_require__(115);
	
	var _xlsx = __webpack_require__(65);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _AntiFraudFilters = __webpack_require__(331);
	
	var _AntiFraudFilters2 = _interopRequireDefault(_AntiFraudFilters);
	
	var _AntiFraudTable = __webpack_require__(332);
	
	var _AntiFraudTable2 = _interopRequireDefault(_AntiFraudTable);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _antifraudLogModule = __webpack_require__(626);
	
	var _antifraudLogModule2 = _interopRequireDefault(_antifraudLogModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACCESS_ANTIFRAUD_LOG = 262144;
	
	function checkAccess(accountAccessSettings, globalPrivileges, bitMask) {
	    if (globalPrivileges !== null && globalPrivileges !== undefined) {
	        return (globalPrivileges & bitMask) > 0;
	    }
	    if (Array.isArray(accountAccessSettings)) {
	        return accountAccessSettings.some(function (el) {
	            return (el.privileges & bitMask) > 0;
	        });
	    }
	    return false;
	}
	
	var AntiFraudLog = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	    var accountAccessSettings = props.accountAccessSettings;
	    var globalPrivileges = props.globalPrivileges;
	
	    var mountedRef = (0, _react.useRef)(true);
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        data = _useState2[0],
	        setData = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(0),
	        _useState4 = _slicedToArray(_useState3, 2),
	        count = _useState4[0],
	        setCount = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(1),
	        _useState6 = _slicedToArray(_useState5, 2),
	        currentPage = _useState6[0],
	        setCurrentPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(20),
	        _useState8 = _slicedToArray(_useState7, 1),
	        itemsPerPage = _useState8[0];
	
	    var _useState9 = (0, _react.useState)({}),
	        _useState10 = _slicedToArray(_useState9, 2),
	        filters = _useState10[0],
	        setFilters = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isLoading = _useState12[0],
	        setIsLoading = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        isExporting = _useState14[0],
	        setIsExporting = _useState14[1];
	
	    (0, _react.useEffect)(function () {
	        return function () {
	            mountedRef.current = false;
	        };
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        loadData(1, filters);
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, []);
	
	    function loadData(page, filtersOverride) {
	        setIsLoading(false);
	        var payload = Object.assign({}, filtersOverride || filters, {
	            page: page || currentPage,
	            itemsPerPage: itemsPerPage
	        });
	
	        new _Api2.default({ token: token }).getAntiFraudMerchantLogs(payload).then(function (r) {
	            if (!mountedRef.current) return;
	            setData(r && r.data ? r.data : []);
	            setCount(r && r.count ? Number(r.count) : 0);
	            setIsLoading(true);
	        }).catch(function (err) {
	            if (!mountedRef.current) return;
	            Sentry.captureException(err);
	            setData([]);
	            setCount(0);
	            setIsLoading(true);
	        });
	    }
	
	    function handleApplyFilters(newFilters) {
	        setFilters(newFilters);
	        setCurrentPage(1);
	        loadData(1, newFilters);
	    }
	
	    function handlePageChange(page) {
	        setCurrentPage(page);
	        loadData(page, filters);
	    }
	
	    function handleExportCsv() {
	        if (isExporting) return;
	        setIsExporting(true);
	
	        var payload = Object.assign({}, filters);
	
	        new _Api2.default({ token: token }).exportAntiFraudLogs(payload).then(function (r) {
	            if (!mountedRef.current) return;
	            try {
	                var universalBOM = "\uFEFF";
	                var rows = r.data.map(function (row) {
	                    var obj = {};
	                    r.fields.forEach(function (field, i) {
	                        obj[field] = row[i];
	                    });
	                    return obj;
	                });
	                var json2csv = new _json2csv.Parser({ delimiter: ";", fields: r.fields });
	                var csv = json2csv.parse(rows);
	
	                var a = document.createElement("a");
	                var date = new Date().toISOString().slice(0, 10);
	                a.setAttribute("href", "data:text/csv; charset=utf-8," + encodeURIComponent(universalBOM + csv));
	                a.setAttribute("download", "antifraud_log_" + date + ".csv");
	                document.body.appendChild(a);
	                a.click();
	                document.body.removeChild(a);
	            } catch (e) {
	                Sentry.captureException(e);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	        }).finally(function () {
	            setIsExporting(false);
	        });
	    }
	
	    function handleExportExcel() {
	        if (isExporting) return;
	        setIsExporting(true);
	
	        var payload = Object.assign({}, filters);
	
	        new _Api2.default({ token: token }).exportAntiFraudLogs(payload).then(function (r) {
	            if (!mountedRef.current) return;
	            try {
	                var sheetData = [r.fields].concat(r.data);
	                var worksheet = XLSX.utils.aoa_to_sheet(sheetData);
	                var workbook = XLSX.utils.book_new();
	                XLSX.utils.book_append_sheet(workbook, worksheet, "Antifraud Log");
	
	                var wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
	                var blob = new Blob([wbout], {
	                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
	                });
	
	                var a = document.createElement("a");
	                var date = new Date().toISOString().slice(0, 10);
	                a.href = URL.createObjectURL(blob);
	                a.download = "antifraud_log_" + date + ".xlsx";
	                document.body.appendChild(a);
	                a.click();
	                document.body.removeChild(a);
	                URL.revokeObjectURL(a.href);
	            } catch (e) {
	                Sentry.captureException(e);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	        }).finally(function () {
	            setIsExporting(false);
	        });
	    }
	
	    if (!checkAccess(accountAccessSettings, globalPrivileges, ACCESS_ANTIFRAUD_LOG)) {
	        return _react2.default.createElement(
	            "div",
	            { className: _antifraudLogModule2.default["container-fluid"] + " d-flex flex-column min-vh-100" },
	            _react2.default.createElement(
	                "div",
	                { className: "row flex-grow-1" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-12 pt-2" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "d-flex justify-content-center align-items-center", style: { minHeight: "60vh" } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "h4",
	                                null,
	                                "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-muted" },
	                                "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430"
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _antifraudLogModule2.default["container-fluid"] + " d-flex flex-column min-vh-100" },
	        _react2.default.createElement(
	            "div",
	            { className: "row flex-grow-1" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-12 pt-2" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-between align-items-center mb-3" },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        "\u041B\u043E\u0433 \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434-\u043F\u0440\u043E\u0432\u0435\u0440\u043E\u043A"
	                    )
	                ),
	                _react2.default.createElement(_AntiFraudFilters2.default, {
	                    onApplyFilters: handleApplyFilters,
	                    accountAccessSettings: accountAccessSettings,
	                    isLoading: !isLoading,
	                    token: token
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _antifraudLogModule2.default.ExportBar },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _antifraudLogModule2.default.ExportBtn,
	                            onClick: handleExportCsv,
	                            disabled: isExporting || count === 0
	                        },
	                        "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 CSV"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: _antifraudLogModule2.default.ExportBtn,
	                            onClick: handleExportExcel,
	                            disabled: isExporting || count === 0
	                        },
	                        "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 Excel"
	                    )
	                ),
	                _react2.default.createElement(_AntiFraudTable2.default, {
	                    data: data,
	                    isLoading: isLoading
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _antifraudLogModule2.default.PaginationWrap },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                        firstPageText: "⇤",
	                        prevPageText: "⇠",
	                        lastPageText: "⇥",
	                        nextPageText: "⇢",
	                        activeLinkClass: _antifraudLogModule2.default.ActiveLink,
	                        activePage: currentPage,
	                        itemsCountPerPage: itemsPerPage,
	                        totalItemsCount: count,
	                        pageRangeDisplayed: 10,
	                        onChange: handlePageChange
	                    })
	                )
	            )
	        )
	    );
	});
	
	exports.default = AntiFraudLog;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _PaymentsTotalToday = __webpack_require__(400);
	
	var _PaymentsTotalToday2 = _interopRequireDefault(_PaymentsTotalToday);
	
	var _PaymentsOnMonth = __webpack_require__(399);
	
	var _PaymentsOnMonth2 = _interopRequireDefault(_PaymentsOnMonth);
	
	var _BalanceWidget = __webpack_require__(333);
	
	var _BalanceWidget2 = _interopRequireDefault(_BalanceWidget);
	
	var _ProjectsWidget = __webpack_require__(418);
	
	var _ProjectsWidget2 = _interopRequireDefault(_ProjectsWidget);
	
	var _CountryWidget = __webpack_require__(391);
	
	var _CountryWidget2 = _interopRequireDefault(_CountryWidget);
	
	var _EventsWidget = __webpack_require__(393);
	
	var _EventsWidget2 = _interopRequireDefault(_EventsWidget);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _MpsChart = __webpack_require__(340);
	
	var _MpsChart2 = _interopRequireDefault(_MpsChart);
	
	var _TopErrorsDiffChart = __webpack_require__(341);
	
	var _TopErrorsDiffChart2 = _interopRequireDefault(_TopErrorsDiffChart);
	
	var _stylesModule = __webpack_require__(627);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dashboard = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _React$useState = _react2.default.useState([]),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        data = _React$useState2[0],
	        setData = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(true),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        loading = _React$useState4[0],
	        setLoading = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(null),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        extendedBalances = _React$useState6[0],
	        setExtendedBalances = _React$useState6[1];
	
	    (0, _react.useEffect)(function () {
	
	        var api = new _Api2.default({ token: token });
	
	        api.getDashboard().then(function (r) {
	            setData(r);
	            setLoading(false);
	        });
	
	        api.getMerchantBalances().then(function (r) {
	            setExtendedBalances(r);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            // Silently ignore — old balance will show
	        });
	    }, []);
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.DashboardWrapper + ' ' + _stylesModule2.default.FullBleed },
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Container },
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.FlexRow + ' ' + _stylesModule2.default.SummaryRow },
	                _react2.default.createElement(_PaymentsTotalToday2.default, { data: data.today, isLoading: loading }),
	                _react2.default.createElement(_PaymentsOnMonth2.default, { data: data.total, isLoading: loading }),
	                _react2.default.createElement(_BalanceWidget2.default, {
	                    data: data.balance_total,
	                    extendedBalances: extendedBalances,
	                    isLoading: loading
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.FlexRow },
	                _react2.default.createElement(_CountryWidget2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.FlexRow },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: 'Dashboard.title.errors' },
	                    _react2.default.createElement(_TopErrorsDiffChart2.default, null)
	                ),
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: 'Dashboard.title.paymentSystems' },
	                    _react2.default.createElement(_MpsChart2.default, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.FlexRow },
	                _react2.default.createElement(_ProjectsWidget2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.FlexRow },
	                _react2.default.createElement(_EventsWidget2.default, null)
	            )
	        )
	    );
	});
	
	exports.default = Dashboard;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _SingleDatePicker = __webpack_require__(43);
	
	var _SingleDatePicker2 = _interopRequireDefault(_SingleDatePicker);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(628);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _reactRouterDom = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ContractCreate(_ref) {
	    var token = _ref.token;
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)({
	        name: "",
	        date: "",
	        passportSeries: "",
	        passportNumber: "",
	        passportIssuedBy: "",
	        passportIssuedAt: "",
	        passportIssuedByCode: "",
	        lastName: "",
	        firstName: "",
	        patronymic: "",
	        gender: null,
	        birthDate: "",
	        birthPlace: "",
	        phone: "",
	        inn: "",
	        addressFact: { value: "" },
	        addressRegistered: { value: "" },
	        merchant: null
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        form = _useState2[0],
	        setForm = _useState2[1];
	
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isRequest = _useState4[0],
	        setIsRequest = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        projects = _useState6[0],
	        setProjects = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(true),
	        _useState8 = _slicedToArray(_useState7, 2),
	        isLoadingProjects = _useState8[0],
	        setIsLoadingProjects = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        viewMode = _useState10[0],
	        setViewMode = _useState10[1];
	
	    var genderList = [{ displayName: 'Мужской', isEnabled: true, id: "0" }, { displayName: 'Женский', isEnabled: true, id: "1" }];
	
	    var countryList = [{ displayName: 'Россия', isEnabled: true, id: 'Россия' }];
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjects().then(function (res) {
	            setProjects(res);
	            setIsLoadingProjects(false);
	        });
	    }, []);
	
	    function handleChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function handleActivate() {
	
	        setIsRequest(true);
	
	        for (var key in form) {
	            if (form[key] === null || form[key].length === 0) {
	                onMessage({ type: 'warning', message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.' });
	                return setIsRequest(false);
	            }
	        }
	        var formClone = {
	            name: form.name,
	            date: form.date.toISOString().split('T')[0],
	            passportSeries: form.passportSeries,
	            passportNumber: form.passportNumber,
	            passportIssuedBy: form.passportIssuedBy,
	            passportIssuedAt: form.passportIssuedAt.toISOString().split('T')[0],
	            passportIssuedByCode: form.passportIssuedByCode,
	            phone: form.phone,
	            inn: form.inn,
	            addressRegistered: form.addressRegistered.value,
	            addressFact: form.addressFact.value,
	            firstName: form.firstName,
	            lastName: form.lastName,
	            patronymic: form.patronymic,
	            gender: form.gender.displayName,
	            birthCountryCode: 643,
	            birthDate: form.birthDate.toISOString().split('T')[0],
	            birthPlace: form.birthPlace,
	            merchantId: form.merchant.id
	
	        };
	        new _Api2.default({ token: token }).createMetalContract(formClone).then(function (r) {
	            if (r.status === 200 || r.status === 201) {
	                setViewMode(true);
	                onMessage({ type: 'success', message: 'Контракт успешно создан!' });
	                history.push('/metal');
	            } else {
	                onMessage({ type: "error", message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова." });
	            }
	        }).finally(function () {
	            setIsRequest(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: "FieldsHelper.label.contractCreate" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.name,
	                                        placeholder: "SAMPLE_01",
	                                        fieldName: "name",
	                                        label: "FieldsHelper.label.ContractName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.ContractName",
	                                        blurMessage: "FieldsHelper.label.ContractName",
	                                        isDisabled: isRequest || viewMode,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.date,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { date: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "yyyy-MM-dd",
	                                        placeholderText: "0000-00-00",
	                                        disabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.project",
	                                    placeholder: "FieldsHelper.label.project",
	                                    values: projects,
	                                    onChange: function onChange(value) {
	                                        return handleChange("merchant", value);
	                                    },
	                                    selectedValue: form.merchant,
	                                    fieldName: "displayName",
	                                    fieldStatus: "status",
	                                    isLoading: isLoadingProjects || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041F\u0430\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        fieldName: "passportSeries",
	                                        value: form.passportSeries,
	                                        label: "FieldsHelper.label.docSerial",
	                                        blurMessage: "FieldsHelper.error.docSerial",
	                                        placeholder: "00 00",
	                                        mask: [/\d/, /\d/, " ", /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        fieldName: "passportNumber",
	                                        value: form.passportNumber,
	                                        label: "FieldsHelper.label.docNumber",
	                                        blurMessage: "FieldsHelper.error.docNumber",
	                                        placeholder: "000000",
	                                        mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.passportIssuedBy,
	                                    placeholder: "Например: Отделом внутренних дел Г. МОСКВЫ",
	                                    fieldName: "passportIssuedBy",
	                                    label: "FieldsHelper.label.Issued",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.passportIssuedAt,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { passportIssuedAt: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "yyyy-MM-dd",
	                                        placeholderText: "0000-00-00",
	                                        disabled: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        value: form.passportIssuedByCode,
	                                        fieldName: "passportIssuedByCode",
	                                        label: "FieldsHelper.label.departmentCode",
	                                        blurMessage: "FieldsHelper.error.docIssuerCode",
	                                        placeholder: "000-000",
	                                        mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.lastName,
	                                    placeholder: "Например: Курчатов",
	                                    fieldName: "lastName",
	                                    label: "FieldsHelper.label.lastName",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersLastName",
	                                    blurMessage: "FieldsHelper.error.onlyLettersLastName",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.firstName,
	                                    placeholder: "Например: Игорь",
	                                    fieldName: "firstName",
	                                    label: "FieldsHelper.label.firstName",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersFirstName",
	                                    blurMessage: "FieldsHelper.error.onlyLettersFirstName",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.patronymic,
	                                    placeholder: "Например: Васильевич",
	                                    fieldName: "patronymic",
	                                    label: "FieldsHelper.label.patronymic",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersPatronymic",
	                                    blurMessage: "FieldsHelper.error.onlyLettersPatronymic",
	                                    isDisabled: isRequest || viewMode,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.Select, {
	                                        label: "FieldsHelper.label.gender",
	                                        placeholder: "FieldsHelper.placeholder.gender",
	                                        values: genderList,
	                                        onChange: function onChange(value) {
	                                            return handleChange("gender", value);
	                                        },
	                                        selectedValue: form.gender,
	                                        fieldName: "displayName",
	                                        fieldStatus: "isEnabled",
	                                        isLoading: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.birthDate,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { birthDate: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "yyyy-MM-dd",
	                                        placeholderText: "0000-00-00",
	                                        disabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.birthPlace,
	                                        placeholder: "",
	                                        fieldName: "birthPlace",
	                                        label: "FieldsHelper.label.birthPlace",
	                                        changeRegexp: /[^A-Za-zА-Яа-я\-\s".]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я\-\s".]/,
	                                        changeMessage: "FieldsHelper.error.onlyLatinBirthPlace",
	                                        blurMessage: "FieldsHelper.error.checkBirthPlace",
	                                        isDisabled: isRequest || viewMode,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.Select, {
	                                        label: "FieldsHelper.label.birthCountry",
	                                        placeholder: "FieldsHelper.placeholder.birthCountry",
	                                        values: countryList,
	                                        onChange: function onChange(value) {
	                                            return handleChange("birthCountry", value);
	                                        },
	                                        selectedValue: form.birthCountry,
	                                        fieldName: "displayName",
	                                        fieldStatus: "isEnabled",
	                                        isLoading: isRequest || viewMode
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        value: form.phone,
	                                        fieldName: "phone",
	                                        label: "FieldsHelper.label.phone",
	                                        changeMessage: "FieldsHelper.error.onlyNumbersPhone",
	                                        blurMessage: "FieldsHelper.error.checkPhone",
	                                        placeholder: "+7 (917) 574-4444",
	                                        mask: ['+', '7', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.inn,
	                                        fieldName: "inn",
	                                        label: "FieldsHelper.label.inn",
	                                        placeholder: "0000000000",
	                                        changeRegexp: /[^0-9]+/g,
	                                        blurRegexp: /^[0-9]{12}/,
	                                        changeMessage: "FieldsHelper.error.onlyNumbersInn",
	                                        blurMessage: "FieldsHelper.error.checkNumbersInn",
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.AddressDaData, {
	                                    onChange: handleChange,
	                                    label: "FieldsHelper.label.legalAddress",
	                                    placeholder: "Начните вводить адрес",
	                                    value: form.addressRegistered.value,
	                                    fieldName: "addressRegistered",
	                                    changeRegexp: /[^А-Яа-я0-9\s.,]+/g,
	                                    blurRegexp: /^[А-Яа-я0-9\s.,]+$/g,
	                                    changeMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    isDisabled: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.AddressDaData, {
	                                    onChange: handleChange,
	                                    label: "FieldsHelper.label.residenceAddress",
	                                    placeholder: "Начните вводить адрес",
	                                    value: form.addressFact.value,
	                                    fieldName: "addressFact",
	                                    changeRegexp: /[^А-Яа-я0-9\s.,]+/g,
	                                    blurRegexp: /^[А-Яа-я0-9\s.,]+$/g,
	                                    changeMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    blurMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    isDisabled: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, { label: "FieldsHelper.label.contractBtn", color: "#4caf50",
	                                    onClick: handleActivate, icon: "checkmark", isDisabled: viewMode, isLoading: isRequest })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(ContractCreate);

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _SingleDatePicker = __webpack_require__(43);
	
	var _SingleDatePicker2 = _interopRequireDefault(_SingleDatePicker);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(629);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ContractEdit(_ref) {
	    var token = _ref.token;
	
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)((0, _reactRouterDom.useParams)().ID),
	        _useState2 = _slicedToArray(_useState, 1),
	        contractID = _useState2[0];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        contract = _useState4[0],
	        setContract = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        viewMode = _useState6[0],
	        setViewMode = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        id: null,
	        name: "",
	        date: "",
	        passportSeries: "",
	        passportNumber: "",
	        passportIssuedBy: "",
	        passportIssuedAt: "",
	        passportIssuedByCode: "",
	        lastName: "",
	        firstName: "",
	        patronymic: "",
	        gender: null,
	        birthDate: "",
	        birthPlace: "",
	        birthCountryCode: "",
	        phone: "",
	        inn: "",
	        addressFact: { value: "" },
	        addressRegistered: { value: "" },
	        merchant: null
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        form = _useState8[0],
	        setForm = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        deleteModalActive = _useState10[0],
	        setIsDeleteModalActive = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isRequest = _useState12[0],
	        setIsRequest = _useState12[1];
	
	    var _useState13 = (0, _react.useState)([]),
	        _useState14 = _slicedToArray(_useState13, 2),
	        projects = _useState14[0],
	        setProjects = _useState14[1];
	
	    var genderList = [{ displayName: 'Мужской', isEnabled: true, id: "0" }, { displayName: 'Женский', isEnabled: true, id: "1" }];
	
	    var countryList = [{ displayName: 'Россия', isEnabled: true, id: 'Россия' }];
	
	    (0, _react.useEffect)(function () {
	        setIsRequest(true);
	        new _Api2.default({ token: token }).getMetalContract(contractID).then(function (data) {
	            setContract(data.data);
	            setForm({
	                id: data.data.id,
	                name: data.data.name,
	                date: new Date(Date.parse(data.data.date)),
	                passportSeries: data.data.passportSeries,
	                passportNumber: data.data.passportNumber,
	                passportIssuedBy: data.data.passportIssuedBy,
	                passportIssuedAt: new Date(Date.parse(data.data.passportIssuedAt)),
	                passportIssuedByCode: data.data.passportIssuedByCode,
	                lastName: data.data.lastName,
	                firstName: data.data.firstName,
	                patronymic: data.data.patronymic,
	                gender: { "displayName": data.data.gender },
	                birthDate: new Date(Date.parse(data.data.birthDate)),
	                birthPlace: data.data.birthPlace,
	                birthCountryCode: { "displayName": data.data.birthCountry.name },
	                phone: data.data.phone,
	                inn: data.data.inn,
	                addressFact: { "value": data.data.addressFact },
	                addressRegistered: { "value": data.data.addressRegistered },
	                merchant: { "displayName": data.data.merchantId }
	            });
	            setIsRequest(false);
	        });
	
	        new _Api2.default({ token: token }).getProjects().then(function (res) {
	            setProjects(res);
	        });
	    }, []);
	
	    function handleChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function handleDelete() {
	        new _Api2.default({ token: token }).deleteMetalContract(form.id).then(function (r) {
	            if (r.status === 200 || r.status === 201 || r.status === 204) {
	                setIsDeleteModalActive(false);
	                setViewMode(true);
	                onMessage({ type: 'success', message: 'Контракт успешно удалён!' });
	                history.push('/metal');
	            } else {
	                onMessage({ type: "error", message: "Ошибка" });
	            }
	        }).finally(function () {
	            setIsRequest(false);
	        });
	    }
	
	    function handleActivate() {
	
	        setIsRequest(true);
	
	        for (var key in form) {
	            if (form[key] === null || form[key].length === 0) {
	                onMessage({ type: 'warning', message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.' });
	                return setIsRequest(false);
	            }
	        }
	        var formClone = {
	            name: form.name,
	            date: form.date.toISOString().split('T')[0],
	            passportSeries: form.passportSeries,
	            passportNumber: form.passportNumber,
	            passportIssuedBy: form.passportIssuedBy,
	            passportIssuedAt: form.passportIssuedAt.toISOString().split('T')[0],
	            passportIssuedByCode: form.passportIssuedByCode,
	            phone: form.phone,
	            inn: form.inn,
	            addressRegistered: form.addressRegistered.value,
	            addressFact: form.addressFact.value,
	            firstName: form.firstName,
	            lastName: form.lastName,
	            patronymic: form.patronymic,
	            gender: form.gender.displayName,
	            birthCountryCode: 643,
	            birthDate: form.birthDate.toISOString().split('T')[0],
	            birthPlace: form.birthPlace,
	            merchantId: form.merchant.id
	
	        };
	        new _Api2.default({ token: token }).updateMetalContract(form.id, formClone).then(function (r) {
	            if (r.status === 200 || r.status === 201) {
	                onMessage({ type: 'success', message: 'Контракт успешно обновлён! Можете покинуть данную страницу' });
	            } else {
	                onMessage({ type: "error", message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова." });
	            }
	        }).finally(function () {
	            setIsRequest(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: "FieldsHelper.label.contractEdit" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.name,
	                                        placeholder: "SAMPLE_01",
	                                        fieldName: "name",
	                                        label: "FieldsHelper.label.ContractName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.ContractName",
	                                        blurMessage: "FieldsHelper.label.ContractName",
	                                        isDisabled: isRequest || viewMode,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.date,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { date: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "yyyy-MM-dd",
	                                        placeholderText: "0000-00-00",
	                                        disabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.project",
	                                    placeholder: "FieldsHelper.label.project",
	                                    values: projects,
	                                    onChange: function onChange(value) {
	                                        return handleChange("merchant", value);
	                                    },
	                                    selectedValue: form.merchant,
	                                    fieldName: "displayName",
	                                    fieldStatus: "status",
	                                    isLoading: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041F\u0430\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        fieldName: "passportSeries",
	                                        value: form.passportSeries,
	                                        label: "FieldsHelper.label.docSerial",
	                                        blurMessage: "FieldsHelper.error.docSerial",
	                                        placeholder: "00 00",
	                                        mask: [/\d/, /\d/, " ", /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        fieldName: "passportNumber",
	                                        value: form.passportNumber,
	                                        label: "FieldsHelper.label.docNumber",
	                                        blurMessage: "FieldsHelper.error.docNumber",
	                                        placeholder: "000000",
	                                        mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.passportIssuedBy,
	                                    placeholder: "Например: Отделом внутренних дел Г. МОСКВЫ",
	                                    fieldName: "passportIssuedBy",
	                                    label: "FieldsHelper.label.Issued",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.passportIssuedAt,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { passportIssuedAt: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "yyyy-MM-dd",
	                                        placeholderText: "0000-00-00",
	                                        disabled: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        value: form.passportIssuedByCode,
	                                        fieldName: "passportIssuedByCode",
	                                        label: "FieldsHelper.label.departmentCode",
	                                        blurMessage: "FieldsHelper.error.docIssuerCode",
	                                        placeholder: "000-000",
	                                        mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.lastName,
	                                    placeholder: "Например: Курчатов",
	                                    fieldName: "lastName",
	                                    label: "FieldsHelper.label.lastName",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersLastName",
	                                    blurMessage: "FieldsHelper.error.onlyLettersLastName",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.firstName,
	                                    placeholder: "Например: Игорь",
	                                    fieldName: "firstName",
	                                    label: "FieldsHelper.label.firstName",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersFirstName",
	                                    blurMessage: "FieldsHelper.error.onlyLettersFirstName",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.patronymic,
	                                    placeholder: "Например: Васильевич",
	                                    fieldName: "patronymic",
	                                    label: "FieldsHelper.label.patronymic",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersPatronymic",
	                                    blurMessage: "FieldsHelper.error.onlyLettersPatronymic",
	                                    isDisabled: isRequest || viewMode,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.Select, {
	                                        label: "FieldsHelper.label.gender",
	                                        placeholder: "FieldsHelper.placeholder.gender",
	                                        values: genderList,
	                                        onChange: function onChange(value) {
	                                            return handleChange("gender", value);
	                                        },
	                                        selectedValue: form.gender,
	                                        fieldName: "displayName",
	                                        fieldStatus: "isEnabled",
	                                        isLoading: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.birthDate,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { birthDate: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "yyyy-MM-dd",
	                                        placeholderText: "0000-00-00",
	                                        disabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.birthPlace,
	                                        placeholder: "",
	                                        fieldName: "birthPlace",
	                                        label: "FieldsHelper.label.birthPlace",
	                                        changeRegexp: /[^A-Za-zА-Яа-я\s".]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я\s".]/,
	                                        changeMessage: "FieldsHelper.error.onlyLatinBirthPlace",
	                                        blurMessage: "FieldsHelper.error.checkBirthPlace",
	                                        isDisabled: isRequest || viewMode,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.Select, {
	                                        label: "FieldsHelper.label.birthCountry",
	                                        placeholder: "FieldsHelper.placeholder.birthCountry",
	                                        values: countryList,
	                                        onChange: function onChange(value) {
	                                            return handleChange("birthCountryCode", value);
	                                        },
	                                        selectedValue: form.birthCountryCode,
	                                        fieldName: "displayName",
	                                        fieldStatus: "isEnabled",
	                                        isLoading: isRequest || viewMode
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        value: form.phone,
	                                        fieldName: "phone",
	                                        label: "FieldsHelper.label.phone",
	                                        changeMessage: "FieldsHelper.error.onlyNumbersPhone",
	                                        blurMessage: "FieldsHelper.error.checkPhone",
	                                        placeholder: "+7 (917) 574-4444",
	                                        mask: ['+', '7', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.inn,
	                                        fieldName: "inn",
	                                        label: "FieldsHelper.label.inn",
	                                        placeholder: "0000000000",
	                                        changeRegexp: /[^0-9]+/g,
	                                        blurRegexp: /^[0-9]{12}/,
	                                        changeMessage: "FieldsHelper.error.onlyNumbersInn",
	                                        blurMessage: "FieldsHelper.error.checkNumbersInn",
	                                        isDisabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.AddressDaData, {
	                                    onChange: handleChange,
	                                    label: "FieldsHelper.label.legalAddress",
	                                    placeholder: "Начните вводить адрес",
	                                    value: form.addressRegistered.value,
	                                    fieldName: "addressRegistered",
	                                    changeRegexp: /[^А-Яа-я0-9\s.,]+/g,
	                                    blurRegexp: /^[А-Яа-я0-9\s.,]+$/g,
	                                    changeMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    isDisabled: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.AddressDaData, {
	                                    onChange: handleChange,
	                                    label: "FieldsHelper.label.residenceAddress",
	                                    placeholder: "Начните вводить адрес",
	                                    value: form.addressFact.value,
	                                    fieldName: "addressFact",
	                                    changeRegexp: /[^А-Яа-я0-9\s.,]+/g,
	                                    blurRegexp: /^[А-Яа-я0-9\s.,]+$/g,
	                                    changeMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    blurMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    isDisabled: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, { label: "FieldsHelper.label.contractSave", color: "#4caf50",
	                                    onClick: handleActivate, icon: "checkmark", isDisabled: viewMode,
	                                    isLoading: isRequest })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, {
	                                    label: "FieldsHelper.label.contractDelete",
	                                    color: "#c23a3aff",
	                                    onClick: function onClick() {
	                                        return setIsDeleteModalActive(function (prev) {
	                                            return !prev;
	                                        });
	                                    },
	                                    icon: "checkmark",
	                                    isDisabled: viewMode || !contract || contract.psaProcessingCount > 0,
	                                    isLoading: isRequest
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _Modal2.default,
	                                {
	                                    onConfirm: handleDelete,
	                                    onClose: function onClose() {
	                                        return setIsDeleteModalActive(false);
	                                    },
	                                    isConfirm: true,
	                                    isOpen: deleteModalActive,
	                                    title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F"
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442?"
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(ContractEdit);

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(630);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Layout = __webpack_require__(6);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _PcaTable = __webpack_require__(175);
	
	var _PcaTable2 = _interopRequireDefault(_PcaTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContractPca() {
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { className: _stylesModule2.default.StackOnMobile },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            "h5",
	                            { className: _stylesModule2.default.Title },
	                            "\u0421\u043F\u0438\u0441\u043E\u043A \u041F\u0421\u0410 \u0434\u043B\u044F \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.TableWrap },
	                        _react2.default.createElement(_PcaTable2.default, null)
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SideColumn },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                {
	                                    to: "/metal/contract/1/pca/create" },
	                                _react2.default.createElement(_Button2.default, {
	                                    onClick: null,
	                                    isLoading: false,
	                                    label: "FieldsHelper.label.pcaCreate",
	                                    icon: "share",
	                                    color: "#3cc23a"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                {
	                                    to: "/metal" },
	                                _react2.default.createElement(_Button2.default, {
	                                    onClick: null,
	                                    isLoading: false,
	                                    label: "FieldsHelper.label.contractsList",
	                                    icon: "share",
	                                    color: "#474545"
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = ContractPca;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(631);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Layout = __webpack_require__(6);
	
	var _ContractsTable = __webpack_require__(389);
	
	var _ContractsTable2 = _interopRequireDefault(_ContractsTable);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _FieldsHelper = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContractsList(_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(1),
	        _useState2 = _slicedToArray(_useState, 2),
	        currentPage = _useState2[0],
	        setCurrentPage = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(10),
	        _useState4 = _slicedToArray(_useState3, 2),
	        itemsPerPage = _useState4[0],
	        setItemsPerPage = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        filteredProjects = _useState6[0],
	        setFilteredProjects = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        contracts = _useState8[0],
	        setContracts = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(0),
	        _useState10 = _slicedToArray(_useState9, 2),
	        contractsCount = _useState10[0],
	        setContractsCount = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(true),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isLoading = _useState12[0],
	        setIsLoading = _useState12[1];
	
	    var _useState13 = (0, _react.useState)([]),
	        _useState14 = _slicedToArray(_useState13, 2),
	        projects = _useState14[0],
	        setProjects = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(true),
	        _useState16 = _slicedToArray(_useState15, 2),
	        isLoadingProjects = _useState16[0],
	        setIsLoadingProjects = _useState16[1];
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjects().then(function (r) {
	            setProjects(r);
	            setIsLoadingProjects(false);
	        });
	
	        new _Api2.default({ token: token }).getListMetalContracts({
	            projects: filteredProjects,
	            page: currentPage,
	            itemsPerPage: itemsPerPage
	        }).then(function (data) {
	            setContracts(data.data ? data.data : []);
	            setContractsCount(data.count ? data.count : 0);
	            setIsLoading(false);
	        });
	    }, []);
	
	    function setPage(page, itemsPerPage) {
	        if (page) setCurrentPage(page);else setCurrentPage(1);
	
	        if (itemsPerPage) setItemsPerPage(itemsPerPage);
	
	        new _Api2.default({ token: token }).getListMetalContracts({
	            projects: filteredProjects,
	            page: page,
	            itemsPerPage: itemsPerPage
	        }).then(function (data) {
	            setContracts(data.data ? data.data : []);
	            setContractsCount(data.count ? data.count : 0);
	        });
	    }
	
	    function applyFilters() {
	        setIsLoading(true);
	        new _Api2.default({ token: token }).getListMetalContracts({
	            projects: filteredProjects,
	            page: currentPage,
	            itemsPerPage: itemsPerPage
	        }).then(function (data) {
	            setContracts(data.data ? data.data : []);
	            setContractsCount(data.count ? data.count : 0);
	        }).finally(function () {
	            setIsLoading(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { className: _stylesModule2.default.StackOnMobile },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            "h5",
	                            { className: _stylesModule2.default.Title },
	                            "\u0421\u043F\u0438\u0441\u043E\u043A \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u043E\u0432"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.TableWrap },
	                        _react2.default.createElement(_ContractsTable2.default, { data: contracts, projects: projects, isLoading: isLoading })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.PaginationWrap },
	                        _react2.default.createElement(_reactJsPagination2.default, {
	                            firstPageText: "\u21E4",
	                            prevPageText: "\u21E0",
	                            lastPageText: "\u21E5",
	                            nextPageText: "\u21E2",
	                            activeLinkClass: _stylesModule2.default.ActiveLink,
	                            activePage: currentPage,
	                            itemsCountPerPage: itemsPerPage,
	                            totalItemsCount: contractsCount,
	                            pageRangeDisplayed: 10,
	                            onChange: function onChange(page) {
	                                return setPage(page, itemsPerPage);
	                            }
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SideColumn },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                {
	                                    to: "/metal/contract/create" },
	                                _react2.default.createElement(_Button2.default, {
	                                    onClick: null,
	                                    isLoading: false,
	                                    label: "FieldsHelper.label.contractCreate",
	                                    icon: "share",
	                                    color: "#3cc23a"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                {
	                                    to: "/metal/pca" },
	                                _react2.default.createElement(_Button2.default, {
	                                    onClick: null,
	                                    isLoading: false,
	                                    label: "FieldsHelper.label.pcaList",
	                                    icon: "share",
	                                    color: "#474545"
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                        label: "FieldsHelper.label.project",
	                        placeholder: "FieldsHelper.label.selectProject",
	                        values: projects,
	                        selectedValues: filteredProjects,
	                        isLoading: isLoadingProjects,
	                        onChange: function onChange(data) {
	                            return setFilteredProjects(data);
	                        },
	                        excludeSearchColumn: []
	                    })
	                ),
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(_Button2.default, { onClick: applyFilters, label: "TransactionsFilters.btn.setFilters", icon: "filter",
	                        iconSize: '17px', isLoading: isLoading })
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(ContractsList);

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _SingleDatePicker = __webpack_require__(43);
	
	var _SingleDatePicker2 = _interopRequireDefault(_SingleDatePicker);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _stylesModule = __webpack_require__(632);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Uuid = __webpack_require__(189);
	
	var _Uuid2 = _interopRequireDefault(_Uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function PcaCreate(_ref) {
	    var token = _ref.token;
	
	    var contractId = (0, _reactRouterDom.useParams)().ID;
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        contract = _useState2[0],
	        setContract = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        terminals = _useState4[0],
	        setTerminals = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(_Uuid2.default.v4()),
	        _useState6 = _slicedToArray(_useState5, 1),
	        uuid = _useState6[0];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState7 = (0, _react.useState)({
	        docPcaName: "",
	        docPcaDate: "",
	        metalType: "",
	        description: "",
	        source: "",
	        transport: "",
	        pan: "",
	        //comment: "",
	        providerId: "",
	        cardHolder: ""
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        form = _useState8[0],
	        setForm = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        viewMode = _useState10[0],
	        setViewMode = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isRequest = _useState12[0],
	        setIsRequest = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        isTerminalsLoading = _useState14[0],
	        setIsTerminalsLoading = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([{ type: "", weight: "", price: "", grossWeight: "", tareWeight: "", contamination: "" }]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        tableRows = _useState16[0],
	        setTableRows = _useState16[1];
	
	    var amount = (0, _react.useMemo)(function () {
	        return tableRows.reduce(function (acc, curr) {
	            return acc += Number(curr.price) * Number(curr.weight);
	        }, 0).toFixed(2);
	    }, [tableRows]);
	
	    var metalTypeList = [{ displayName: 'Чёрный', isEnabled: true, id: "0" }, { displayName: 'Цветной', isEnabled: true, id: "1" }];
	
	    function handleChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    var handleRowChange = function handleRowChange(index, field, value) {
	        var updatedRows = [].concat(_toConsumableArray(tableRows));
	        updatedRows[index][field] = value;
	        setTableRows(updatedRows);
	    };
	
	    var handleFloatChange = function handleFloatChange(index, field, value) {
	        if (!value.match(/^\d+\.?(\d{1,3})?$/)) {
	            return;
	        }
	        var updatedRows = [].concat(_toConsumableArray(tableRows));
	        updatedRows[index][field] = value;
	        setTableRows(updatedRows);
	    };
	
	    var handlePriceChange = function handlePriceChange(index, field, value) {
	        if (!value.match(/^\d+\.?(\d{1,2})?$/)) {
	            return;
	        }
	        var updatedRows = [].concat(_toConsumableArray(tableRows));
	        updatedRows[index][field] = value;
	        setTableRows(updatedRows);
	    };
	
	    var addRow = function addRow() {
	        setTableRows([].concat(_toConsumableArray(tableRows), [{ type: "", weight: "", price: "", grossWeight: "", tareWeight: "", contamination: "" }]));
	    };
	
	    var removeRow = function removeRow(index) {
	        var updatedRows = tableRows.filter(function (_, i) {
	            return i !== index;
	        });
	        setTableRows(updatedRows);
	    };
	
	    function handleActivate() {
	
	        if (!contract) {
	            onMessage({ type: "error", message: "Ошибка. Не удалось получись сведения о контракте. Попробуйте перезагрузить страницу." });
	            return;
	        }
	
	        setIsRequest(true);
	
	        for (var key in form) {
	            if (form[key] === null || form[key].length === 0) {
	                onMessage({ type: 'warning', message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.' });
	                return setIsRequest(false);
	            }
	        }
	
	        var formClone = {
	            name: form.docPcaName,
	            date: form.docPcaDate.toISOString().split('T')[0],
	            pan: form.pan.trim().split(' ').join(''),
	            cardHolder: form.cardHolder,
	            positions: tableRows.map(function (row) {
	                return {
	                    type: row.type,
	                    weight: row.weight,
	                    price: row.price,
	                    grossWeight: row.grossWeight,
	                    tareWeight: row.tareWeight,
	                    contamination: row.contamination
	                };
	            }),
	            providerId: form.providerId.uuid,
	            psaContractId: contract.id,
	            type: form.metalType.id,
	            description: form.description,
	            source: form.source,
	            vehicle: form.transport,
	            uuid: uuid
	        };
	
	        new _Api2.default({ token: token }).createPsa(formClone).then(function (r) {
	            if (r.status === 200 || r.status === 201) {
	                setViewMode(true);
	                onMessage({ type: 'success', message: 'ПСА успешно создан!' });
	                history.replace("/metal/pca/" + r.data.data.id);
	            } else {
	                onMessage({ type: "error", message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова." });
	            }
	        }).finally(function () {
	            setIsRequest(false);
	        });
	    }
	
	    (0, _react.useEffect)(function () {
	        setIsRequest(true);
	        new _Api2.default({ token: token }).getMetalContract(contractId).then(function (data) {
	            setContract(data.data);
	            setIsRequest(false);
	        });
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        setIsTerminalsLoading(true);
	        new _Api2.default({ token: token }).getProjects().then(function (data) {
	            var providers = [];
	            data.map(function (p) {
	                return p.providers.map(function (t) {
	                    return providers.push(t);
	                });
	            });
	            setTerminals(providers);
	            setIsTerminalsLoading(false);
	        });
	    }, []);
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: "FieldsHelper.label.pcaCreate" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041D\u043E\u043C\u0435\u0440 \u0438 \u0434\u0430\u0442\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: contract ? contract.name : '',
	                                        placeholder: "SAMPLE_01",
	                                        fieldName: "name",
	                                        label: "FieldsHelper.label.ContractName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.ContractName",
	                                        blurMessage: "FieldsHelper.label.ContractName",
	                                        isDisabled: true,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: contract ? new Date(contract.date) : '',
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: true
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041D\u043E\u043C\u0435\u0440 \u0438 \u0434\u0430\u0442\u0430 \u041F\u0421\u0410"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.docPcaName,
	                                        placeholder: "SAMPLE_PCA_01",
	                                        fieldName: "docPcaName",
	                                        label: "FieldsHelper.label.PcaName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.PcaName",
	                                        blurMessage: "FieldsHelper.label.PcaName",
	                                        isDisabled: isRequest || viewMode,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u041F\u0421\u0410"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.docPcaDate,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { docPcaDate: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.PcaTypeMetal",
	                                    placeholder: "FieldsHelper.label.PcaTypeMetal",
	                                    values: metalTypeList,
	                                    onChange: function onChange(value) {
	                                        return handleChange("metalType", value);
	                                    },
	                                    selectedValue: form.metalType,
	                                    fieldName: "displayName",
	                                    fieldStatus: "isEnabled",
	                                    isLoading: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.description,
	                                    placeholder: "Описание лома и отходов",
	                                    fieldName: "description",
	                                    label: "FieldsHelper.label.pcaDescriptionMetal",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.source,
	                                    placeholder: "Источник лома",
	                                    fieldName: "source",
	                                    label: "FieldsHelper.label.pcaSourceMetal",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.transport,
	                                    placeholder: "Марка и номер ТС",
	                                    fieldName: "transport",
	                                    label: "FieldsHelper.label.pcaTransportMetal",
	                                    changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s".№]+/g,
	                                    blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputAmountCurrencyHelper, {
	                                    value: amount,
	                                    currency: ["RUB"],
	                                    placeholder: "1960.20",
	                                    label: "FieldsHelper.label.amount",
	                                    changeMessage: "FieldsHelper.error.onlyNumbersAmount",
	                                    blurMessage: "FieldsHelper.error.checkAmount",
	                                    isDisabled: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.CardNumberInputHelper, {
	                                    onChange: handleChange,
	                                    value: form.pan,
	                                    placeholder: "0000 0000 0000 0000 000",
	                                    isDisabled: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.cardHolder,
	                                    placeholder: "IVAN IVANOV",
	                                    fieldName: "cardHolder",
	                                    label: "FieldsHelper.label.cardholder",
	                                    changeRegexp: /[^A-Za-z\s]+/g,
	                                    blurRegexp: /([A-Z]+\s)+([A-Z]+)/ig,
	                                    changeMessage: "FieldsHelper.error.onlyLatinCardholder",
	                                    blurMessage: "FieldsHelper.error.checkCardholderName",
	                                    isUppercase: true,
	                                    isDisabled: isRequest || viewMode,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.terminal",
	                                    placeholder: "FieldsHelper.label.selectTerminal",
	                                    values: terminals,
	                                    onChange: function onChange(value) {
	                                        return handleChange("providerId", value);
	                                    },
	                                    selectedValue: form.providerId,
	                                    fieldName: "displayName",
	                                    fieldStatus: "enabled",
	                                    isLoading: isTerminalsLoading || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _EmptyCard2.default,
	                                { title: "FieldsHelper.label.pcaDescription" },
	                                _react2.default.createElement(
	                                    "button",
	                                    { className: _stylesModule2.default.AddRowButton, disabled: viewMode, onClick: addRow },
	                                    "+"
	                                ),
	                                tableRows.map(function (row, index) {
	                                    return _react2.default.createElement(
	                                        "div",
	                                        { key: index, className: _stylesModule2.default.TableRow },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Row },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleRowChange,
	                                                    value: row.type,
	                                                    placeholder: "Вид металла",
	                                                    fieldName: "type",
	                                                    label: "FieldsHelper.label.metalType",
	                                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                                    changeMessage: "FieldsHelper.error.onlyLettersMetalType",
	                                                    blurMessage: "FieldsHelper.error.onlyLettersMetalType",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleFloatChange,
	                                                    value: row.weight,
	                                                    placeholder: "Вес (тн)",
	                                                    fieldName: "weight",
	                                                    label: "FieldsHelper.label.metalWeight",
	                                                    changeRegexp: /[^0-9./]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,3})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handlePriceChange,
	                                                    value: row.price,
	                                                    placeholder: "Цена (руб)",
	                                                    fieldName: "price",
	                                                    label: "FieldsHelper.label.metalPrice",
	                                                    changeRegexp: /[^0-9.]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,2})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalPrice",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalPrice",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Row },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleFloatChange,
	                                                    value: row.grossWeight,
	                                                    placeholder: "Вес брутто (тн)",
	                                                    fieldName: "grossWeight",
	                                                    label: "FieldsHelper.label.metalGrossWeight",
	                                                    changeRegexp: /[^0-9.]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,3})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleFloatChange,
	                                                    value: row.tareWeight,
	                                                    placeholder: "Вес тары (тн)",
	                                                    fieldName: "tareWeight",
	                                                    label: "FieldsHelper.label.metalTareWeight",
	                                                    changeRegexp: /[^0-9.]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,3})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleRowChange,
	                                                    value: row.contamination,
	                                                    placeholder: "Засоренность (%)",
	                                                    fieldName: "contamination",
	                                                    label: "FieldsHelper.label.metalImpurity",
	                                                    changeRegexp: /[^0-9]+/g,
	                                                    blurRegexp: /^[0-9]{3}/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalImpurity",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalImpurity",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.RemoveButton },
	                                            _react2.default.createElement(
	                                                "button",
	                                                { disabled: viewMode, onClick: function onClick() {
	                                                        return removeRow(index);
	                                                    } },
	                                                "-"
	                                            )
	                                        )
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, { label: "FieldsHelper.label.pcaBtn", color: "#4caf50",
	                                    onClick: handleActivate, icon: "checkmark", isDisabled: viewMode,
	                                    isLoading: isRequest })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(PcaCreate);

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _SingleDatePicker = __webpack_require__(43);
	
	var _SingleDatePicker2 = _interopRequireDefault(_SingleDatePicker);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _stylesModule = __webpack_require__(633);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Uuid = __webpack_require__(189);
	
	var _Uuid2 = _interopRequireDefault(_Uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function PcaDuplicate(_ref) {
	    var token = _ref.token;
	
	    var psaID = (0, _reactRouterDom.useParams)().ID;
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        contract = _useState2[0],
	        setContract = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        terminals = _useState4[0],
	        setTerminals = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(_Uuid2.default.v4()),
	        _useState6 = _slicedToArray(_useState5, 1),
	        uuid = _useState6[0];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        psa = _useState8[0],
	        setPsa = _useState8[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState9 = (0, _react.useState)({
	        docPcaName: "",
	        docPcaDate: "",
	        metalType: "",
	        description: "",
	        source: "",
	        transport: "",
	        pan: "",
	        //comment: "",
	        providerId: "",
	        cardHolder: ""
	    }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        form = _useState10[0],
	        setForm = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        viewMode = _useState12[0],
	        setViewMode = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        isRequest = _useState14[0],
	        setIsRequest = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        isTerminalsLoading = _useState16[0],
	        setIsTerminalsLoading = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([{ type: "", weight: "", price: "", grossWeight: "", tareWeight: "", contamination: "" }]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        tableRows = _useState18[0],
	        setTableRows = _useState18[1];
	
	    var amount = (0, _react.useMemo)(function () {
	        return tableRows.reduce(function (acc, curr) {
	            return acc += Number(curr.price) * Number(curr.weight);
	        }, 0).toFixed(2);
	    }, [tableRows]);
	
	    var metalTypeList = [{ displayName: 'Чёрный', isEnabled: true, id: "0" }, { displayName: 'Цветной', isEnabled: true, id: "1" }];
	
	    function handleChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    var handleRowChange = function handleRowChange(index, field, value) {
	        var updatedRows = [].concat(_toConsumableArray(tableRows));
	        updatedRows[index][field] = value;
	        setTableRows(updatedRows);
	    };
	
	    var handleFloatChange = function handleFloatChange(index, field, value) {
	        if (!value.match(/^\d+\.?(\d{1,3})?$/)) {
	            return;
	        }
	        var updatedRows = [].concat(_toConsumableArray(tableRows));
	        updatedRows[index][field] = value;
	        setTableRows(updatedRows);
	    };
	
	    var handlePriceChange = function handlePriceChange(index, field, value) {
	        if (!value.match(/^\d+\.?(\d{1,2})?$/)) {
	            return;
	        }
	        var updatedRows = [].concat(_toConsumableArray(tableRows));
	        updatedRows[index][field] = value;
	        setTableRows(updatedRows);
	    };
	
	    var addRow = function addRow() {
	        setTableRows([].concat(_toConsumableArray(tableRows), [{ type: "", weight: "", price: "", grossWeight: "", tareWeight: "", contamination: "" }]));
	    };
	
	    var removeRow = function removeRow(index) {
	        var updatedRows = tableRows.filter(function (_, i) {
	            return i !== index;
	        });
	        setTableRows(updatedRows);
	    };
	
	    function handleActivate() {
	
	        if (!contract) {
	            onMessage({ type: "error", message: "Ошибка. Не удалось получись сведения о контракте. Попробуйте перезагрузить страницу." });
	            return;
	        }
	
	        setIsRequest(true);
	
	        for (var key in form) {
	            if (form[key] === null || form[key].length === 0) {
	                onMessage({ type: 'warning', message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.' });
	                return setIsRequest(false);
	            }
	        }
	
	        var formClone = {
	            name: form.docPcaName,
	            date: form.docPcaDate.toISOString().split('T')[0],
	            pan: form.pan.trim().split(' ').join(''),
	            cardHolder: form.cardHolder,
	            positions: tableRows.map(function (row) {
	                return {
	                    type: row.type,
	                    weight: row.weight,
	                    price: row.price,
	                    grossWeight: row.grossWeight,
	                    tareWeight: row.tareWeight,
	                    contamination: row.contamination
	                };
	            }),
	            providerId: form.providerId.uuid,
	            psaContractId: contract.id,
	            type: form.metalType.id,
	            description: form.description,
	            source: form.source,
	            vehicle: form.transport,
	            uuid: uuid
	        };
	
	        new _Api2.default({ token: token }).createPsa(formClone).then(function (r) {
	            if (r.status === 200 || r.status === 201) {
	                setViewMode(true);
	                onMessage({ type: 'success', message: 'ПСА успешно создан!' });
	                history.replace("/metal/pca/" + r.data.data.id);
	            } else {
	                onMessage({ type: "error", message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова." });
	            }
	        }).finally(function () {
	            setIsRequest(false);
	        });
	    }
	
	    (0, _react.useEffect)(function () {
	        setIsRequest(true);
	        setIsTerminalsLoading(true);
	        new _Api2.default({ token: token }).getProjects().then(function (data) {
	            var providers = [];
	            data.map(function (p) {
	                return p.providers.map(function (t) {
	                    return providers.push(t);
	                });
	            });
	            setTerminals(providers);
	            setIsTerminalsLoading(false);
	        });
	        new _Api2.default({ token: token }).getPsa(psaID).then(function (data) {
	            var psa = data.data;
	            setPsa(psa);
	            setForm(function (prev) {
	                return Object.assign({}, prev, {
	                    docPcaName: psa.name,
	                    docPcaDate: new Date(psa.date),
	                    metalType: metalTypeList.find(function (type) {
	                        return type.id === psa.type;
	                    }) || "",
	                    description: psa.description,
	                    source: psa.source,
	                    transport: psa.vehicle,
	                    amount: psa.amount,
	                    pan: psa.pan,
	                    //comment: "",
	                    providerId: "",
	                    cardHolder: psa.cardHolder
	                });
	            });
	            setTableRows(psa.positions);
	            setIsRequest(false);
	        });
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        if (psa) {
	            new _Api2.default({ token: token }).getMetalContract(psa.psaContractId).then(function (data) {
	                setContract(data.data);
	            });
	        }
	    }, [psa]);
	
	    (0, _react.useEffect)(function () {
	        if (psa) {
	            setForm(function (prev) {
	                return Object.assign({}, prev, {
	                    providerId: terminals.find(function (terminal) {
	                        return terminal.uuid === psa.providerId;
	                    })
	                });
	            });
	        }
	    }, [terminals, psa]);
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: "FieldsHelper.label.pcaCreate" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041D\u043E\u043C\u0435\u0440 \u0438 \u0434\u0430\u0442\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: contract ? contract.name : '',
	                                        placeholder: "SAMPLE_01",
	                                        fieldName: "name",
	                                        label: "FieldsHelper.label.ContractName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.ContractName",
	                                        blurMessage: "FieldsHelper.label.ContractName",
	                                        isDisabled: true,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: contract ? new Date(contract.date) : '',
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: true
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041D\u043E\u043C\u0435\u0440 \u0438 \u0434\u0430\u0442\u0430 \u041F\u0421\u0410"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.docPcaName,
	                                        placeholder: "SAMPLE_PCA_01",
	                                        fieldName: "docPcaName",
	                                        label: "FieldsHelper.label.PcaName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.PcaName",
	                                        blurMessage: "FieldsHelper.label.PcaName",
	                                        isDisabled: isRequest || viewMode,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u041F\u0421\u0410"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.docPcaDate,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { docPcaDate: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: isRequest || viewMode
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.PcaTypeMetal",
	                                    placeholder: "FieldsHelper.label.PcaTypeMetal",
	                                    values: metalTypeList,
	                                    onChange: function onChange(value) {
	                                        return handleChange("metalType", value);
	                                    },
	                                    selectedValue: form.metalType,
	                                    fieldName: "displayName",
	                                    fieldStatus: "isEnabled",
	                                    isLoading: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.description,
	                                    placeholder: "Описание лома и отходов",
	                                    fieldName: "description",
	                                    label: "FieldsHelper.label.pcaDescriptionMetal",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.source,
	                                    placeholder: "Источник лома",
	                                    fieldName: "source",
	                                    label: "FieldsHelper.label.pcaSourceMetal",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.transport,
	                                    placeholder: "Марка и номер ТС",
	                                    fieldName: "transport",
	                                    label: "FieldsHelper.label.pcaTransportMetal",
	                                    changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s".№]+/g,
	                                    blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest || viewMode,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputAmountCurrencyHelper, {
	                                    value: amount,
	                                    currency: ["RUB"],
	                                    placeholder: "1960.20",
	                                    label: "FieldsHelper.label.amount",
	                                    changeMessage: "FieldsHelper.error.onlyNumbersAmount",
	                                    blurMessage: "FieldsHelper.error.checkAmount",
	                                    isDisabled: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.CardNumberInputHelper, {
	                                    onChange: handleChange,
	                                    value: form.pan,
	                                    placeholder: "0000 0000 0000 0000 000",
	                                    isDisabled: isRequest || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.cardHolder,
	                                    placeholder: "IVAN IVANOV",
	                                    fieldName: "cardHolder",
	                                    label: "FieldsHelper.label.cardholder",
	                                    changeRegexp: /[^A-Za-z\s]+/g,
	                                    blurRegexp: /([A-Z]+\s)+([A-Z]+)/ig,
	                                    changeMessage: "FieldsHelper.error.onlyLatinCardholder",
	                                    blurMessage: "FieldsHelper.error.checkCardholderName",
	                                    isUppercase: true,
	                                    isDisabled: isRequest || viewMode,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.terminal",
	                                    placeholder: "FieldsHelper.label.selectTerminal",
	                                    values: terminals,
	                                    onChange: function onChange(value) {
	                                        return handleChange("providerId", value);
	                                    },
	                                    selectedValue: form.providerId,
	                                    fieldName: "displayName",
	                                    fieldStatus: "enabled",
	                                    isLoading: isTerminalsLoading || viewMode
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _EmptyCard2.default,
	                                { title: "FieldsHelper.label.pcaDescription" },
	                                _react2.default.createElement(
	                                    "button",
	                                    { className: _stylesModule2.default.AddRowButton, disabled: viewMode, onClick: addRow },
	                                    "+"
	                                ),
	                                tableRows.map(function (row, index) {
	                                    return _react2.default.createElement(
	                                        "div",
	                                        { key: index, className: _stylesModule2.default.TableRow },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Row },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleRowChange,
	                                                    value: row.type,
	                                                    placeholder: "Вид металла",
	                                                    fieldName: "type",
	                                                    label: "FieldsHelper.label.metalType",
	                                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                                    changeMessage: "FieldsHelper.error.onlyLettersMetalType",
	                                                    blurMessage: "FieldsHelper.error.onlyLettersMetalType",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleFloatChange,
	                                                    value: row.weight,
	                                                    placeholder: "Вес (тн)",
	                                                    fieldName: "weight",
	                                                    label: "FieldsHelper.label.metalWeight",
	                                                    changeRegexp: /[^0-9./]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,3})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handlePriceChange,
	                                                    value: row.price,
	                                                    placeholder: "Цена (руб)",
	                                                    fieldName: "price",
	                                                    label: "FieldsHelper.label.metalPrice",
	                                                    changeRegexp: /[^0-9.]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,2})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalPrice",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalPrice",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Row },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleFloatChange,
	                                                    value: row.grossWeight,
	                                                    placeholder: "Вес брутто (тн)",
	                                                    fieldName: "grossWeight",
	                                                    label: "FieldsHelper.label.metalGrossWeight",
	                                                    changeRegexp: /[^0-9.]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,3})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleFloatChange,
	                                                    value: row.tareWeight,
	                                                    placeholder: "Вес тары (тн)",
	                                                    fieldName: "tareWeight",
	                                                    label: "FieldsHelper.label.metalTareWeight",
	                                                    changeRegexp: /[^0-9.]+/g,
	                                                    blurRegexp: /^\d+(\.\d{1,3})?$/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    onChange: handleRowChange,
	                                                    value: row.contamination,
	                                                    placeholder: "Засоренность (%)",
	                                                    fieldName: "contamination",
	                                                    label: "FieldsHelper.label.metalImpurity",
	                                                    changeRegexp: /[^0-9]+/g,
	                                                    blurRegexp: /^[0-9]{3}/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalImpurity",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalImpurity",
	                                                    isDisabled: isRequest || viewMode,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.RemoveButton },
	                                            _react2.default.createElement(
	                                                "button",
	                                                { disabled: viewMode, onClick: function onClick() {
	                                                        return removeRow(index);
	                                                    } },
	                                                "-"
	                                            )
	                                        )
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, { label: "FieldsHelper.label.pcaBtn", color: "#4caf50",
	                                    onClick: handleActivate, icon: "checkmark", isDisabled: viewMode,
	                                    isLoading: isRequest })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(PcaDuplicate);

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _SingleDatePicker = __webpack_require__(43);
	
	var _SingleDatePicker2 = _interopRequireDefault(_SingleDatePicker);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _stylesModule = __webpack_require__(634);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _reactRouterDom = __webpack_require__(686);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactRouterDom2 = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPsaStatus(status) {
	    switch (status) {
	        case "loading":
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Disabled },
	                "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442\u0441\u044F..."
	            );
	        case 0:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Disabled },
	                "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D"
	            );
	        case 1:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Process },
	                "\u041E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F"
	            );
	        case 2:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Enabled },
	                "\u0412\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043E"
	            );
	        case 3:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Error },
	                "\u041F\u043B\u0430\u0442\u0435\u0436 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D"
	            );
	        case 4:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Error },
	                "\u041E\u0448\u0438\u0431\u043A\u0430"
	            );
	        default:
	            return _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Disabled },
	                "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D"
	            );
	    }
	}
	
	function PcaEdit(_ref) {
	    var token = _ref.token;
	
	    var psaID = (0, _reactRouterDom.useParams)().ID;
	    var history = (0, _reactRouterDom2.useHistory)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        contract = _useState2[0],
	        setContract = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        terminals = _useState4[0],
	        setTerminals = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        psa = _useState6[0],
	        setPsa = _useState6[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        deleteModalActive = _useState8[0],
	        setIsDeleteModalActive = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({
	        docPcaName: "",
	        docPcaDate: "",
	        metalType: "",
	        description: "",
	        source: "",
	        transport: "",
	        amount: "",
	        pan: "",
	        //comment: "",
	        providerId: "",
	        cardHolder: ""
	    }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        form = _useState10[0],
	        setForm = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        viewMode = _useState12[0],
	        setViewMode = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        isRequest = _useState14[0],
	        setIsRequest = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        _ = _useState16[0],
	        setIsDownloading = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([{ type: "", weight: "", price: "", grossWeight: "", tareWeight: "", impurity: "" }]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        tableRows = _useState18[0],
	        setTableRows = _useState18[1];
	
	    var metalTypeList = [{ displayName: 'Чёрный', isEnabled: true, id: "0" }, { displayName: 'Цветной', isEnabled: true, id: "1" }];
	
	    function handleDelete() {
	        setIsRequest(true);
	        new _Api2.default({ token: token }).deletePsa(psaID).then(function (r) {
	            if (r.status === 200 || r.status === 201 || r.status === 204) {
	                setViewMode(true);
	                setIsDeleteModalActive(false);
	                onMessage({ type: 'success', message: 'ПСА успешно удален!' });
	                history.push('/metal/pca');
	            } else if (r.status === 400) {
	                onMessage({ type: 'warning', message: 'Вы не можете удалить ПСА в статусе "Обрабатывается"' });
	            } else {
	                onMessage({ type: 'error', message: 'Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова.' });
	            }
	        }).finally(function () {
	            setIsRequest(false);
	        });
	    }
	
	    function handleDownload() {
	        setIsDownloading(true);
	        new _Api2.default({ token: token }).downloadPsa(psaID).then(function (r) {
	            if (r.status === 200) {
	                var url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
	                var link = document.createElement('a');
	                link.href = url;
	                link.setAttribute('download', psa.name + "-" + psa.date + ".xlsx");
	                document.body.appendChild(link);
	                link.click();
	                link.parentNode.removeChild(link);
	            }
	            if (r.status !== 200) {
	                onMessage({ type: 'error', message: 'Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова.' });
	            }
	        }).finally(function () {
	            setIsDownloading(false);
	        });
	    }
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjects().then(function (data) {
	            var providers = [];
	            data.map(function (p) {
	                return p.providers.map(function (t) {
	                    return providers.push(t);
	                });
	            });
	            setTerminals(providers);
	        });
	        new _Api2.default({ token: token }).getPsa(psaID).then(function (data) {
	            setPsa(data.data);
	        });
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        if (psa) {
	            new _Api2.default({ token: token }).getMetalContract(psa.psaContractId).then(function (data) {
	                setContract(data.data);
	            });
	            setForm(function (prev) {
	                return Object.assign({}, prev, {
	                    docPcaName: psa.name,
	                    docPcaDate: new Date(psa.date),
	                    metalType: metalTypeList.find(function (type) {
	                        return type.id === psa.type;
	                    }) || "",
	                    description: psa.description,
	                    source: psa.source,
	                    transport: psa.vehicle,
	                    amount: parseFloat(psa.amount).toFixed(2),
	                    pan: psa.pan,
	                    //comment: "",
	                    providerId: "",
	                    cardHolder: psa.cardHolder
	                });
	            });
	            setTableRows(psa.positions);
	        }
	    }, [psa]);
	
	    (0, _react.useEffect)(function () {
	        if (psa) {
	            setForm(function (prev) {
	                return Object.assign({}, prev, {
	                    providerId: terminals.find(function (terminal) {
	                        return terminal.uuid === psa.providerId;
	                    })
	                });
	            });
	        }
	    }, [terminals, psa]);
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    {
	                        title: "FieldsHelper.label.pcaEdit",
	                        subtitle: getPsaStatus(psa ? psa.status : "loading")
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        value: contract ? contract.name : '',
	                                        placeholder: "SAMPLE_01",
	                                        fieldName: "name",
	                                        label: "FieldsHelper.label.ContractName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.ContractName",
	                                        blurMessage: "FieldsHelper.label.ContractName",
	                                        isDisabled: true,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: contract ? new Date(contract.date) : '',
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: true
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041D\u043E\u043C\u0435\u0440 \u0438 \u0434\u0430\u0442\u0430 \u041F\u0421\u0410"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        value: form.docPcaName,
	                                        placeholder: "SAMPLE_PCA_01",
	                                        fieldName: "docPcaName",
	                                        label: "FieldsHelper.label.PcaName",
	                                        changeRegexp: /[^A-Za-zА-Яа-я0-9\-\s"_№]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я0-9\-\s"_№]/,
	                                        changeMessage: "FieldsHelper.label.PcaName",
	                                        blurMessage: "FieldsHelper.label.PcaName",
	                                        isDisabled: true,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u041F\u0421\u0410"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.docPcaDate,
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: true
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.PcaTypeMetal",
	                                    placeholder: "FieldsHelper.label.PcaTypeMetal",
	                                    values: metalTypeList,
	                                    selectedValue: form.metalType,
	                                    fieldName: "displayName",
	                                    fieldStatus: "isEnabled",
	                                    isLoading: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    value: form.description,
	                                    placeholder: "Описание лома и отходов",
	                                    fieldName: "description",
	                                    label: "FieldsHelper.label.pcaDescriptionMetal",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: true,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    value: form.source,
	                                    placeholder: "Источник лома",
	                                    fieldName: "source",
	                                    label: "FieldsHelper.label.pcaSourceMetal",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: true,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    value: form.transport,
	                                    placeholder: "Марка и номер ТС",
	                                    fieldName: "transport",
	                                    label: "FieldsHelper.label.pcaTransportMetal",
	                                    changeRegexp: /[^А-Яа-я0-9\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я0-9\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: true,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputAmountCurrencyHelper, {
	                                    value: form.amount,
	                                    currency: ["RUB"],
	                                    placeholder: "1960.20",
	                                    label: "FieldsHelper.label.amount",
	                                    changeMessage: "FieldsHelper.error.onlyNumbersAmount",
	                                    blurMessage: "FieldsHelper.error.checkAmount",
	                                    isDisabled: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.CardNumberInputHelper, {
	                                    value: form.pan,
	                                    placeholder: "0000 0000 0000 0000 000",
	                                    isDisabled: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    value: form.cardHolder,
	                                    placeholder: "IVAN IVANOV",
	                                    fieldName: "cardHolder",
	                                    label: "FieldsHelper.label.cardholder",
	                                    changeRegexp: /[^A-Za-z\s]+/g,
	                                    blurRegexp: /([A-Z]+\s)+([A-Z]+)/ig,
	                                    changeMessage: "FieldsHelper.error.onlyLatinCardholder",
	                                    blurMessage: "FieldsHelper.error.checkCardholderName",
	                                    isUppercase: true,
	                                    isDisabled: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.Select, {
	                                    label: "FieldsHelper.label.terminal",
	                                    placeholder: "FieldsHelper.label.selectTerminal",
	                                    values: terminals,
	                                    selectedValue: form.providerId,
	                                    fieldName: "displayName",
	                                    fieldStatus: "enabled",
	                                    isLoading: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _EmptyCard2.default,
	                                { title: "FieldsHelper.label.pcaDescription" },
	                                tableRows.map(function (row, index) {
	                                    return _react2.default.createElement(
	                                        "div",
	                                        { key: index, className: _stylesModule2.default.TableRow },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Row },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    value: row.type,
	                                                    placeholder: "Вид металла",
	                                                    fieldName: "type",
	                                                    label: "FieldsHelper.label.metalType",
	                                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                                    changeMessage: "FieldsHelper.error.onlyLettersMetalType",
	                                                    blurMessage: "FieldsHelper.error.onlyLettersMetalType",
	                                                    isDisabled: true,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    value: row.weight,
	                                                    placeholder: "Вес (тн)",
	                                                    fieldName: "weight",
	                                                    label: "FieldsHelper.label.metalWeight",
	                                                    changeRegexp: /[^0-9]+/g,
	                                                    blurRegexp: /^[0-9]{5}/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: true,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    value: row.price,
	                                                    placeholder: "Цена (руб)",
	                                                    fieldName: "price",
	                                                    label: "FieldsHelper.label.metalPrice",
	                                                    changeRegexp: /[^0-9]+/g,
	                                                    blurRegexp: /^[0-9]{5}/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalPrice",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalPrice",
	                                                    isDisabled: true,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: _stylesModule2.default.Row },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    value: row.grossWeight,
	                                                    placeholder: "Вес брутто (тн)",
	                                                    fieldName: "grossWeight",
	                                                    label: "FieldsHelper.label.metalGrossWeight",
	                                                    changeRegexp: /[^0-9]+/g,
	                                                    blurRegexp: /^[0-9]{5}/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: true,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    value: row.tareWeight,
	                                                    placeholder: "Вес тары (тн)",
	                                                    fieldName: "tareWeight",
	                                                    label: "FieldsHelper.label.metalTareWeight",
	                                                    changeRegexp: /[^0-9]+/g,
	                                                    blurRegexp: /^[0-9]{5}/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalWeight",
	                                                    isDisabled: true,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: _stylesModule2.default.InputWrap },
	                                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                                    value: row.impurity,
	                                                    placeholder: "Засоренность (%)",
	                                                    fieldName: "impurity",
	                                                    label: "FieldsHelper.label.metalImpurity",
	                                                    changeRegexp: /[^0-9]+/g,
	                                                    blurRegexp: /^[0-9]{3}/,
	                                                    changeMessage: "FieldsHelper.error.onlyNumbersMetalImpurity",
	                                                    blurMessage: "FieldsHelper.error.onlyNumbersMetalImpurity",
	                                                    isDisabled: true,
	                                                    isRequired: true,
	                                                    autoComplete: "off",
	                                                    index: index
	                                                })
	                                            )
	                                        )
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, { label: "FieldsHelper.label.pcaDelete", color: "#c23a3aff",
	                                    onClick: function onClick() {
	                                        return setIsDeleteModalActive(function (prev) {
	                                            return !prev;
	                                        });
	                                    }, icon: "checkmark",
	                                    isDisabled: viewMode || !psa || psa.status === 1, isLoading: isRequest })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, { label: "FieldsHelper.label.pcaDownload", color: "#3a80c2",
	                                    onClick: handleDownload, icon: "checkmark", isDisabled: viewMode,
	                                    isLoading: isRequest })
	                            ),
	                            _react2.default.createElement(
	                                _Modal2.default,
	                                {
	                                    onConfirm: handleDelete,
	                                    onClose: function onClose() {
	                                        return setIsDeleteModalActive(false);
	                                    },
	                                    isConfirm: true,
	                                    isOpen: deleteModalActive,
	                                    title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F"
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u041F\u0421\u0410?"
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(PcaEdit);

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(635);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Layout = __webpack_require__(6);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _PcaTable = __webpack_require__(175);
	
	var _PcaTable2 = _interopRequireDefault(_PcaTable);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _PcaFilters = __webpack_require__(408);
	
	var _PcaFilters2 = _interopRequireDefault(_PcaFilters);
	
	var _Auth = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function PcaList(_ref) {
	    var token = _ref.token;
	
	    var _useLocation = (0, _reactRouterDom.useLocation)(),
	        search = _useLocation.search;
	
	    var searchParams = new URLSearchParams(search);
	    var psaContractId = searchParams.get('psaContractId');
	
	    var _useState = (0, _react.useState)({
	        psaContracts: psaContractId ? [psaContractId] : []
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        requestFilters = _useState2[0],
	        setRequestFilters = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        contracts = _useState4[0],
	        setContracts = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        contractsList = _useState6[0],
	        setContractsList = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        terminals = _useState8[0],
	        setTerminals = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(true),
	        _useState10 = _slicedToArray(_useState9, 2),
	        isContactsListLoading = _useState10[0],
	        setIsContractsListLoading = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(true),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isLoadingContracts = _useState12[0],
	        setIsLoadingContracts = _useState12[1];
	
	    var _useState13 = (0, _react.useState)('week'),
	        _useState14 = _slicedToArray(_useState13, 1),
	        defaultPeriod = _useState14[0];
	
	    var _useState15 = (0, _react.useState)({}),
	        _useState16 = _slicedToArray(_useState15, 2),
	        filterDate = _useState16[0],
	        setFilterDate = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        filteredContracts = _useState18[0],
	        setFilteredContracts = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({}),
	        _useState20 = _slicedToArray(_useState19, 2),
	        filteredStatuses = _useState20[0],
	        setFilteredStatuses = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(1),
	        _useState22 = _slicedToArray(_useState21, 2),
	        currentPage = _useState22[0],
	        setCurrentPage = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(10),
	        _useState24 = _slicedToArray(_useState23, 2),
	        itemsPerPage = _useState24[0],
	        setItemsPerPage = _useState24[1];
	
	    var handleStatusFilter = function handleStatusFilter(data) {
	        Object.entries(data).forEach(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                k = _ref3[0],
	                v = _ref3[1];
	
	            setFilteredStatuses(Object.assign({}, filteredStatuses, _defineProperty({}, k, v)));
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjects().then(function (data) {
	            var providers = [];
	            data.map(function (p) {
	                return p.providers.map(function (t) {
	                    return providers.push(t);
	                });
	            });
	            setTerminals(providers);
	        });
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getMetalContracts().then(function (data) {
	            setContracts(data.data ? data.data.map(function (i) {
	                return Object.assign({}, i, {
	                    // MultipleSelect Support
	                    displayName: i.name,
	                    uuid: i.id
	                });
	            }) : []);
	            setIsLoadingContracts(false);
	            if (psaContractId) {
	                setFilteredContracts([Number(psaContractId)]);
	            }
	        });
	
	        new _Api2.default({ token: token }).getPsaItems(Object.assign({
	            page: currentPage,
	            itemsPerPage: itemsPerPage
	        }, requestFilters)).then(function (data) {
	            setContractsList(data.data);
	            setIsContractsListLoading(false);
	        });
	    }, []);
	
	    function setPage(page, itemsPerPage) {
	        if (page) setCurrentPage(page);else setCurrentPage(1);
	
	        if (itemsPerPage) setItemsPerPage(itemsPerPage);
	
	        new _Api2.default({ token: token }).getPsaItems(Object.assign({
	            page: currentPage,
	            itemsPerPage: itemsPerPage
	        }, requestFilters)).then(function (data) {
	            setContractsList(data.data);
	        });
	    }
	
	    function applyFilters() {
	        setIsContractsListLoading(true);
	
	        var filters = {
	            psaContracts: filteredContracts.length ? filteredContracts : undefined,
	            'dateRange{}': filterDate,
	            statuses: Object.entries(filteredStatuses).length ? Object.entries(filteredStatuses).filter(function (_ref4) {
	                var _ref5 = _slicedToArray(_ref4, 2),
	                    _ = _ref5[0],
	                    v = _ref5[1];
	
	                return v;
	            }).map(function (_ref6) {
	                var _ref7 = _slicedToArray(_ref6, 1),
	                    k = _ref7[0];
	
	                return k;
	            }) : undefined
	        };
	        setRequestFilters(filters);
	        new _Api2.default({ token: token }).getPsaItems(Object.assign({
	            page: currentPage,
	            itemsPerPage: itemsPerPage
	        }, filters)).then(function (data) {
	            setContractsList(data.data);
	        }).finally(function () {
	            setIsContractsListLoading(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { className: _stylesModule2.default.StackOnMobile },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            "h5",
	                            { className: _stylesModule2.default.Title },
	                            "\u0421\u043F\u0438\u0441\u043E\u043A \u041F\u0421\u0410"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.TableWrap },
	                        _react2.default.createElement(_PcaTable2.default, { terminals: terminals, contracts: contracts, contractsList: contractsList,
	                            isLoading: isContactsListLoading })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.PaginationWrap },
	                        _react2.default.createElement(_reactJsPagination2.default, {
	                            firstPageText: "\u21E4",
	                            prevPageText: "\u21E0",
	                            lastPageText: "\u21E5",
	                            nextPageText: "\u21E2",
	                            activeLinkClass: _stylesModule2.default.ActiveLink,
	                            activePage: currentPage,
	                            itemsCountPerPage: itemsPerPage,
	                            totalItemsCount: 2,
	                            pageRangeDisplayed: 10,
	                            onChange: function onChange(page) {
	                                return setPage(page, itemsPerPage);
	                            }
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SideColumn },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                {
	                                    to: "/metal/contract/create" },
	                                _react2.default.createElement(_Button2.default, {
	                                    onClick: null,
	                                    isLoading: false,
	                                    label: "FieldsHelper.label.contractCreate",
	                                    icon: "share",
	                                    color: "#3cc23a"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            { className: _stylesModule2.default.MenuItem },
	                            _react2.default.createElement(
	                                _reactRouterDom.NavLink,
	                                {
	                                    to: "/metal" },
	                                _react2.default.createElement(_Button2.default, {
	                                    onClick: null,
	                                    isLoading: false,
	                                    label: "FieldsHelper.label.contractsList",
	                                    icon: "share",
	                                    color: "#474545"
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                        label: "FieldsHelper.label.contract",
	                        placeholder: "FieldsHelper.label.contract",
	                        values: contracts,
	                        selectedValues: filteredContracts,
	                        isLoading: isLoadingContracts,
	                        onChange: function onChange(data) {
	                            return setFilteredContracts(data);
	                        },
	                        excludeSearchColumn: []
	                    })
	                ),
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                            return setFilterDate(range);
	                        }, defaultPeriod: defaultPeriod })
	                ),
	                _react2.default.createElement(_PcaFilters2.default, {
	                    onSelectFilter: handleStatusFilter
	                }),
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(_Button2.default, { onClick: applyFilters, label: "TransactionsFilters.btn.setFilters", icon: "filter",
	                        iconSize: '17px', isLoading: isContactsListLoading })
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(PcaList);

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Layout = __webpack_require__(6);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _PayoutsFilters = __webpack_require__(174);
	
	var _PayoutsFilters2 = _interopRequireDefault(_PayoutsFilters);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _RegistryList = __webpack_require__(181);
	
	var _RegistryList2 = _interopRequireDefault(_RegistryList);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _ErrorHandler = __webpack_require__(98);
	
	var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);
	
	var _ApiResponseValidator = __webpack_require__(97);
	
	var _ApiResponseValidator2 = _interopRequireDefault(_ApiResponseValidator);
	
	var _MessageFormatter = __webpack_require__(191);
	
	var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _stylesModule = __webpack_require__(636);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var ACCESS_SBP_REGISTRY = 8192;
	
	function checkAccess(accountAccessSettings, globalPrivileges, bitMask) {
	    if (globalPrivileges !== null && globalPrivileges !== undefined) {
	        return (globalPrivileges & bitMask) > 0;
	    }
	    if (Array.isArray(accountAccessSettings)) {
	        return accountAccessSettings.some(function (el) {
	            return (el.privileges & bitMask) > 0;
	        });
	    }
	    return false;
	}
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var applyFilters = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(registryPage) {
	            var page, registryFilters, response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	
	                            setLoadingRegistryList(false);
	
	                            page = registryPage || 1;
	
	                            setCurrentRegistryPage(page);
	
	                            registryFilters = {
	                                projects: filterProjects,
	                                providers: filterTerminals,
	                                tags: filterTagsList,
	                                filters: filters,
	                                dateRange: filterDate,
	                                page: page,
	                                itemsPerPage: postsPerRegistryPage
	                            };
	                            _context2.next = 7;
	                            return new _Api2.default({ token: token }).setMobileRegistryList(registryFilters);
	
	                        case 7:
	                            response = _context2.sent;
	
	                            _ApiResponseValidator2.default.validatePaginationResponse(response);
	
	                            setRegistryList(response.data || []);
	                            setRegistryListCount(response.count || 0);
	
	                            _context2.next = 18;
	                            break;
	
	                        case 13:
	                            _context2.prev = 13;
	                            _context2.t0 = _context2["catch"](0);
	
	                            _ErrorHandler2.default.logError(_context2.t0, {
	                                action: 'applyFilters',
	                                filterProjects: filterProjects,
	                                page: registryPage
	                            });
	                            onMessage(_MessageFormatter2.default.error('Failed to apply filters'));
	                            setRegistryList([]);
	
	                        case 18:
	                            _context2.prev = 18;
	
	                            setLoadingRegistryList(true);
	                            return _context2.finish(18);
	
	                        case 21:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[0, 13, 18, 21]]);
	        }));
	
	        return function applyFilters(_x) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    var setRegistryPage = function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(page, itemsPerPage) {
	            var nextPage, nextItemsPerPage, registryFilters, response;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            nextPage = page || 1;
	                            nextItemsPerPage = itemsPerPage || postsPerRegistryPage;
	
	
	                            setCurrentRegistryPage(nextPage);
	                            setPostsPerRegistryPage(nextItemsPerPage);
	
	                            registryFilters = {
	                                projects: filterProjects,
	                                providers: filterTerminals,
	                                filters: filters,
	                                dateRange: filterDate,
	                                page: nextPage,
	                                itemsPerPage: nextItemsPerPage
	                            };
	                            _context3.next = 8;
	                            return new _Api2.default({ token: token }).setMobileRegistryList(registryFilters);
	
	                        case 8:
	                            response = _context3.sent;
	
	                            _ApiResponseValidator2.default.validatePaginationResponse(response);
	
	                            setRegistryList(response.data || []);
	                            setRegistryListCount(response.count || 0);
	
	                            _context3.next = 18;
	                            break;
	
	                        case 14:
	                            _context3.prev = 14;
	                            _context3.t0 = _context3["catch"](0);
	
	                            _ErrorHandler2.default.logError(_context3.t0, {
	                                action: 'setRegistryPage',
	                                page: page
	                            });
	                            onMessage(_MessageFormatter2.default.error('Failed to load page'));
	
	                        case 18:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[0, 14]]);
	        }));
	
	        return function setRegistryPage(_x2, _x3) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	
	    var token = _ref.token,
	        accountAccessSettings = _ref.accountAccessSettings,
	        globalPrivileges = _ref.globalPrivileges;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        projects = _useState2[0],
	        setProjects = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        terminals = _useState4[0],
	        setTerminals = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(1),
	        _useState6 = _slicedToArray(_useState5, 2),
	        currentRegistryPage = _useState6[0],
	        setCurrentRegistryPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(15),
	        _useState8 = _slicedToArray(_useState7, 2),
	        postsPerRegistryPage = _useState8[0],
	        setPostsPerRegistryPage = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        registryList = _useState10[0],
	        setRegistryList = _useState10[1];
	
	    var _useState11 = (0, _react.useState)([]),
	        _useState12 = _slicedToArray(_useState11, 2),
	        tagsList = _useState12[0],
	        setTagsList = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0),
	        _useState14 = _slicedToArray(_useState13, 2),
	        registryListCount = _useState14[0],
	        setRegistryListCount = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        filterProjects = _useState16[0],
	        setFilterProjects = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        filterTerminals = _useState18[0],
	        setFilterTerminals = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({}),
	        _useState20 = _slicedToArray(_useState19, 2),
	        filterDate = _useState20[0],
	        setFilterDate = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        filterTagsList = _useState22[0],
	        setFilterTagsList = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        filters = _useState24[0],
	        setFilters = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(true),
	        _useState26 = _slicedToArray(_useState25, 2),
	        isLoadingProjects = _useState26[0],
	        setIsLoadingProjects = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(false),
	        _useState28 = _slicedToArray(_useState27, 2),
	        loadingRegistryList = _useState28[0],
	        setLoadingRegistryList = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(false),
	        _useState30 = _slicedToArray(_useState29, 2),
	        loadingTagsList = _useState30[0],
	        setLoadingTagsList = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(false),
	        _useState32 = _slicedToArray(_useState31, 2),
	        isOpenModal = _useState32[0],
	        setIsOpenModal = _useState32[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    (0, _react.useEffect)(function () {
	        var loadInitialData = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var projectsList, registryResponse, allTags;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.prev = 1;
	                                _context.next = 4;
	                                return new _Api2.default({ token: token }).getProjects();
	
	                            case 4:
	                                projectsList = _context.sent;
	
	                                _ApiResponseValidator2.default.validateListResponse({ data: projectsList });
	                                setProjects(projectsList);
	                                _context.next = 14;
	                                break;
	
	                            case 9:
	                                _context.prev = 9;
	                                _context.t0 = _context["catch"](1);
	
	                                _ErrorHandler2.default.logError(_context.t0, { action: 'loadProjects' });
	                                onMessage(_MessageFormatter2.default.error('Failed to load projects'));
	                                setProjects([]);
	
	                            case 14:
	                                _context.prev = 14;
	                                _context.next = 17;
	                                return new _Api2.default({ token: token }).setMobileRegistryList({
	                                    itemsPerPage: postsPerRegistryPage,
	                                    page: currentRegistryPage
	                                });
	
	                            case 17:
	                                registryResponse = _context.sent;
	
	                                _ApiResponseValidator2.default.validatePaginationResponse(registryResponse);
	                                setRegistryList(registryResponse.data || []);
	                                setRegistryListCount(registryResponse.count || 0);
	                                _context.next = 28;
	                                break;
	
	                            case 23:
	                                _context.prev = 23;
	                                _context.t1 = _context["catch"](14);
	
	                                _ErrorHandler2.default.logError(_context.t1, { action: 'loadMobileRegistryList' });
	                                onMessage(_MessageFormatter2.default.error('Failed to load registry list'));
	                                setRegistryList([]);
	
	                            case 28:
	                                _context.prev = 28;
	                                _context.next = 31;
	                                return new _Api2.default({ token: token }).getAllTags();
	
	                            case 31:
	                                allTags = _context.sent;
	
	                                setTagsList(Array.isArray(allTags) ? allTags : []);
	                                _context.next = 39;
	                                break;
	
	                            case 35:
	                                _context.prev = 35;
	                                _context.t2 = _context["catch"](28);
	
	                                _ErrorHandler2.default.logError(_context.t2, { action: 'loadAllTags' });
	                                // Don't show error for tags - non-critical
	                                setTagsList([]);
	
	                            case 39:
	                                _context.prev = 39;
	
	                                setIsLoadingProjects(false);
	                                setLoadingRegistryList(true);
	                                setLoadingTagsList(true);
	                                return _context.finish(39);
	
	                            case 44:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined, [[0,, 39, 44], [1, 9], [14, 23], [28, 35]]);
	            }));
	
	            return function loadInitialData() {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        loadInitialData();
	    }, [token, onMessage]);
	
	    (0, _react.useEffect)(function () {
	        if (!projects) return;
	
	        var terminals = [];
	        var cleanFilterTerminals = [];
	
	        filterProjects.forEach(function (projectUUID) {
	            var result = projects.find(function (el) {
	                return el.uuid === projectUUID;
	            });
	            if (result && result.providers) {
	                result.providers.forEach(function (el) {
	                    terminals.push(el);
	                });
	            }
	        });
	
	        filterTerminals.forEach(function (uuid) {
	            var result = terminals.find(function (el) {
	                return el.uuid !== uuid;
	            });
	            if (result !== undefined) cleanFilterTerminals.push(result.uuid);
	        });
	
	        setFilterTerminals(cleanFilterTerminals);
	        setTerminals(terminals);
	    }, [filterProjects, projects]);
	
	    function onSelectProjects(data) {
	        setFilterProjects(data);
	    }
	
	    function selectFilter(filter) {
	        var key = Object.keys(filter)[0];
	        var value = Object.values(filter)[0];
	
	        if (value) {
	            setFilters([].concat(_toConsumableArray(filters), [filter]));
	        } else {
	            var newFilters = filters.filter(function (el) {
	                return Object.keys(el)[0] !== key;
	            });
	            setFilters(newFilters);
	        }
	    }
	
	    function onSelectedTag(tags) {
	        var filterTags = [];
	
	        tags.forEach(function (tag) {
	            if (!filterTags.includes(tag.id)) filterTags.push(tag.id);
	        });
	
	        setFilterTagsList(filterTags);
	    }
	
	    function onSelectTerminals(data) {
	        setFilterTerminals(data);
	    }
	
	    if (!checkAccess(accountAccessSettings, globalPrivileges, ACCESS_SBP_REGISTRY)) {
	        return _react2.default.createElement(
	            _Layout.Wrapper,
	            null,
	            _react2.default.createElement(
	                _Layout.Container,
	                { style: { justifyContent: "center" } },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: 1180 },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "d-flex justify-content-center align-items-center", style: { minHeight: '60vh' } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "h4",
	                                null,
	                                "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-muted" },
	                                "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430"
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "button",
	                    { type: "button", className: _stylesModule2.default.FiltersToggle, onClick: function onClick() {
	                            return setIsOpenModal(true);
	                        } },
	                    "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(_RegistryList2.default, { token: token, data: registryList, isLoading: loadingRegistryList }),
	                    postsPerRegistryPage < registryListCount && _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.PaginationWrap },
	                        _react2.default.createElement(_reactJsPagination2.default, {
	                            firstPageText: "\u21E4",
	                            prevPageText: "\u21E0",
	                            lastPageText: "\u21E5",
	                            nextPageText: "\u21E2",
	                            activeLinkClass: _stylesModule2.default.ActiveLink,
	                            activePage: currentRegistryPage,
	                            itemsCountPerPage: postsPerRegistryPage,
	                            totalItemsCount: registryListCount,
	                            pageRangeDisplayed: 5,
	                            onChange: function onChange(page) {
	                                return setRegistryPage(page, postsPerRegistryPage);
	                            }
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SidebarColumn },
	                _react2.default.createElement(
	                    _ResponsiveSidebarFilters2.default,
	                    { title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B", isOpen: isOpenModal, onClose: function onClose() {
	                            return setIsOpenModal(false);
	                        } },
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                            label: "FieldsHelper.label.project",
	                            placeholder: "FieldsHelper.label.selectProject",
	                            values: projects,
	                            selectedValues: filterProjects,
	                            isLoading: isLoadingProjects,
	                            onChange: onSelectProjects,
	                            excludeSearchColumn: []
	                        }),
	                        _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                            label: "FieldsHelper.label.terminal",
	                            placeholder: "FieldsHelper.label.selectTerminal",
	                            values: terminals,
	                            selectedValues: filterTerminals,
	                            isLoading: isLoadingProjects,
	                            onChange: onSelectTerminals,
	                            excludeSearchColumn: []
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                                return setFilterDate(range);
	                            }, defaultPeriod: 'halfYear' })
	                    ),
	                    _react2.default.createElement(_PayoutsFilters2.default, { loadingTagsList: loadingTagsList,
	                        tagsList: tagsList,
	                        onSelectFilter: selectFilter,
	                        filterProjects: filterProjects,
	                        onApplyFilters: applyFilters,
	                        onSelectedTag: onSelectedTag,
	                        isLoading: loadingRegistryList
	                    })
	                )
	            )
	        )
	    );
	});

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _RegistryControls = __webpack_require__(178);
	
	var _RegistryControls2 = _interopRequireDefault(_RegistryControls);
	
	var _RegistryUploadInfo = __webpack_require__(182);
	
	var _RegistryUploadInfo2 = _interopRequireDefault(_RegistryUploadInfo);
	
	var _RegistryDADUpload = __webpack_require__(179);
	
	var _RegistryDADUpload2 = _interopRequireDefault(_RegistryDADUpload);
	
	var _RegistryColumnsHelp = __webpack_require__(177);
	
	var _RegistryColumnsHelp2 = _interopRequireDefault(_RegistryColumnsHelp);
	
	var _RegistryInfoCard = __webpack_require__(180);
	
	var _RegistryInfoCard2 = _interopRequireDefault(_RegistryInfoCard);
	
	var _payoutMethods = __webpack_require__(192);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _stylesModule = __webpack_require__(637);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileRegistryUpload = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        projectUUID = _useState2[0],
	        setProjectUUID = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        providerUUID = _useState4[0],
	        setProviderUUID = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        selectedProject = _useState6[0],
	        setSelectedProject = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        selectedTerminal = _useState8[0],
	        setSelectedTerminal = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        initRegistry = _useState10[0],
	        setInitRegistry = _useState10[1];
	
	    var _useState11 = (0, _react.useState)([]),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filteredRegistry = _useState12[0],
	        setFilteredRegistry = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(''),
	        _useState14 = _slicedToArray(_useState13, 2),
	        initRegistryName = _useState14[0],
	        setInitRegistryName = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(''),
	        _useState16 = _slicedToArray(_useState15, 2),
	        registryName = _useState16[0],
	        setRegistryName = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0),
	        _useState18 = _slicedToArray(_useState17, 2),
	        registryAmount = _useState18[0],
	        setRegistryAmount = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        projects = _useState20[0],
	        setProjects = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        terminals = _useState22[0],
	        setTerminals = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(0),
	        _useState24 = _slicedToArray(_useState23, 2),
	        commission = _useState24[0],
	        setCommission = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(0),
	        _useState26 = _slicedToArray(_useState25, 2),
	        errorsCount = _useState26[0],
	        setErrorsCount = _useState26[1];
	
	    var _useState27 = (0, _react.useState)([]),
	        _useState28 = _slicedToArray(_useState27, 2),
	        errorsList = _useState28[0],
	        setErrorsList = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(false),
	        _useState30 = _slicedToArray(_useState29, 2),
	        errorsFormat = _useState30[0],
	        setErrorsFormat = _useState30[1];
	    // «Похоже, это карточный реестр» — подсказка приходит с бэкенда
	    // вместе с ошибкой формата, разбор шапки живёт рядом с загрузчиком.
	
	
	    var _useState31 = (0, _react.useState)(null),
	        _useState32 = _slicedToArray(_useState31, 2),
	        wrongRegistryType = _useState32[0],
	        setWrongRegistryType = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(null),
	        _useState34 = _slicedToArray(_useState33, 2),
	        wrongRegistryHint = _useState34[0],
	        setWrongRegistryHint = _useState34[1];
	
	    var _useState35 = (0, _react.useState)([]),
	        _useState36 = _slicedToArray(_useState35, 2),
	        tags = _useState36[0],
	        setTags = _useState36[1];
	
	    var _useState37 = (0, _react.useState)([]),
	        _useState38 = _slicedToArray(_useState37, 2),
	        suggestionsTags = _useState38[0],
	        setSuggestionsTags = _useState38[1];
	
	    var _useState39 = (0, _react.useState)({ balance: 0, currency: "RUB" }),
	        _useState40 = _slicedToArray(_useState39, 2),
	        terminalBalance = _useState40[0],
	        setTerminalBalance = _useState40[1];
	
	    var _useState41 = (0, _react.useState)(false),
	        _useState42 = _slicedToArray(_useState41, 2),
	        loadingRegistry = _useState42[0],
	        setLoadingRegistry = _useState42[1];
	
	    var _useState43 = (0, _react.useState)(true),
	        _useState44 = _slicedToArray(_useState43, 2),
	        loadingProjects = _useState44[0],
	        setLoadingProjects = _useState44[1];
	
	    var _useState45 = (0, _react.useState)(false),
	        _useState46 = _slicedToArray(_useState45, 2),
	        loadingTerminals = _useState46[0],
	        setLoadingTerminals = _useState46[1];
	
	    var _useState47 = (0, _react.useState)(false),
	        _useState48 = _slicedToArray(_useState47, 2),
	        isRequest = _useState48[0],
	        setIsRequest = _useState48[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    (0, _react.useEffect)(function () {
	        setLoadingProjects(true);
	
	        new _Api2.default({ token: token }).getProjects().then(function (r) {
	            setProjects(Array.isArray(r) ? r : []);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setProjects([]);
	            onMessage({ type: "error", message: "Не удалось загрузить список проектов." });
	        }).finally(function () {
	            setLoadingProjects(false);
	        });
	    }, [token]);
	
	    function calcCommission(rows, payoutFee) {
	        if (!Array.isArray(rows) || rows.length === 0) {
	            setCommission(0);
	            return;
	        }
	
	        if (!payoutFee || (typeof payoutFee === "undefined" ? "undefined" : _typeof(payoutFee)) !== "object") {
	            setCommission(0);
	            return;
	        }
	
	        var cost = Number(payoutFee.cost != null ? payoutFee.cost : 0);
	        var min = Number(payoutFee.costFixedMinimum != null ? payoutFee.costFixedMinimum : 0);
	        var fixed = Number(payoutFee.fixedPerTransaction != null ? payoutFee.fixedPerTransaction : 0);
	
	        var total = 0;
	
	        rows.forEach(function (el) {
	            var amountRaw = el && el.row ? el.row.amount : 0;
	            var a = Number(amountRaw);
	
	            if (!isFinite(a) || a <= 0) return;
	
	            var pct = a * (cost / 100);
	            total += (pct < min ? min : pct) + fixed;
	        });
	
	        setCommission(total);
	    }
	
	    function onChangeRegistryName(value) {
	        setRegistryName(value.replace(/[^A-Za-zА-Яа-я0-9\s-_!?=.]+/g, ''));
	    }
	
	    function onSelectProject(project) {
	        setProjectUUID(project.uuid);
	        setSelectedTerminal(null);
	        setProviderUUID(null);
	        setSelectedProject(project);
	        setLoadingTerminals(true);
	
	        if (project.uuid) {
	            new _Api2.default({ token: token }).getTags(project.uuid).then(function (r) {
	                setSuggestionsTags(r);
	            });
	        }
	
	        new _Api2.default({ token: token }).getProjectData(project.uuid).then(function (r) {
	            // Только терминалы, умеющие выплату через СБП: карточный
	            // терминал по номеру телефона не заплатит, а страница до
	            // отказа успеет попросить у мерчанта телефоны и банки.
	            // Фильтруем ДО проверки «терминал единственный».
	            var usableTerminals = (0, _payoutMethods.filterTerminalsByMethod)(r.terminals, _payoutMethods.PAYOUT_METHOD_SBP);
	
	            if (usableTerminals.length === 1) {
	                var t = usableTerminals[0];
	                setTerminalBalance({ balance: t.balance.confirmed, currency: t.currency });
	                setProviderUUID(t.uuid);
	                setSelectedTerminal(t);
	
	                if (Array.isArray(initRegistry) && initRegistry.length > 0) {
	                    calcCommission(initRegistry, t.fee ? t.fee.payout : null);
	                } else {
	                    setCommission(0);
	                }
	            } else {
	                setCommission(0);
	            }
	
	            setTerminals(usableTerminals);
	            setLoadingTerminals(false);
	        });
	    }
	
	    function onSelectTerminal(terminal) {
	        setSelectedTerminal(terminal);
	        setProviderUUID(terminal.uuid);
	        setTerminalBalance({ balance: terminal.balance.confirmed, currency: terminal.currency });
	
	        if (Array.isArray(initRegistry) && initRegistry.length > 0) {
	            calcCommission(initRegistry, terminal.fee ? terminal.fee.payout : null);
	        } else {
	            setCommission(0);
	        }
	    }
	
	    function onSelectedTag(tags) {
	        setTags(tags);
	    }
	
	    function setFilterErrors(val) {
	        if (val) {
	            var filteredData = initRegistry.filter(function (e) {
	                return e.hasError;
	            });
	            setFilteredRegistry(filteredData);
	        } else {
	            setFilteredRegistry([]);
	        }
	    }
	
	    function submitRegistry() {
	        if (!providerUUID || !projectUUID) {
	            onMessage({ type: 'warning', message: 'Для отправки реестра выберите терминал.' });
	            return false;
	        }
	
	        setIsRequest(true);
	
	        var registry = [];
	        var name = void 0;
	
	        initRegistry.forEach(function (item) {
	            registry.push(item.row);
	        });
	
	        if (registryName) {
	            name = registryName;
	        } else {
	            name = initRegistryName;
	        }
	
	        new _Api2.default({ token: token }).mobileRegistryProcess({ registry: registry, tags: tags, name: name, providerUUID: providerUUID }, projectUUID).then(function (r) {
	            if (r.result === "ok") {
	                clearRegistry();
	                setIsRequest(false);
	                onMessage({ type: "success", message: "Мобильный реестр отправлен в очередь выплат." });
	            } else {
	                onMessage({ type: "error", message: +('code: ' + r.code) });
	                setLoadingRegistry(false);
	            }
	        });
	    }
	
	    function clearRegistry() {
	        setInitRegistry([]);
	        setFilteredRegistry([]);
	        setLoadingRegistry(false);
	        setRegistryAmount(0);
	        setCommission(0);
	        setRegistryName('');
	        setInitRegistryName('');
	    }
	
	    function processUploadedData(file, data) {
	        var cleanName = file.name.replace(/[^A-Za-zА-Яа-я0-9\s-_!?=.]|\.xlsx+/g, '');
	        setInitRegistryName(cleanName);
	        setRegistryName(cleanName);
	
	        var rows = data && Array.isArray(data.data) ? data.data : [];
	
	        if (rows.length > 0) {
	            var amount = 0;
	            rows.forEach(function (el) {
	                var v = el && el.row ? el.row.amount : 0;
	                amount += Number(v) || 0;
	            });
	
	            setRegistryAmount(amount);
	            setInitRegistry(rows);
	            setFilteredRegistry(rows);
	            setLoadingRegistry(true);
	
	            var payoutFee = selectedTerminal && selectedTerminal.fee ? selectedTerminal.fee.payout : null;
	            calcCommission(rows, payoutFee);
	        } else {
	            setLoadingRegistry(false);
	            setRegistryAmount(0);
	            setInitRegistry([]);
	            setFilteredRegistry([]);
	            setCommission(0);
	        }
	
	        if (data && data.errors) {
	            if (data.errors.count) {
	                setErrorsCount(data.errors.count);
	                setErrorsList(data.errors);
	            } else {
	                setErrorsCount(0);
	            }
	            if (data.errors.formatError) {
	                setErrorsFormat(true);
	            }
	
	            setWrongRegistryType(data.errors.wrongRegistryType || null);
	            setWrongRegistryHint(data.errors.wrongRegistryHint || null);
	        } else {
	            setWrongRegistryType(null);
	            setWrongRegistryHint(null);
	        }
	    }
	
	    function mobileUploadFn(file) {
	        var formData = new FormData();
	        formData.append("file", file);
	        return new _Api2.default({ token: token }).mobileRegistryUpload(formData, projectUUID);
	    }
	
	    function onMobileRegistryUpload(file, data) {
	        processUploadedData(file, data);
	    }
	
	    // Таблица мобильного реестра
	    function renderMobileTable(data) {
	        if (!data || data.length === 0) return null;
	
	        return _react2.default.createElement(
	            "table",
	            { style: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' } },
	            _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    { style: { borderBottom: '2px solid #ddd', textAlign: 'left' } },
	                    _react2.default.createElement(
	                        "th",
	                        { style: { padding: '8px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "MobileRegistry.table.phone", defaultMessage: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { style: { padding: '8px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "MobileRegistry.table.bic", defaultMessage: "\u0411\u0418\u041A / ID \u0431\u0430\u043D\u043A\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { style: { padding: '8px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "MobileRegistry.table.cardHolderRu", defaultMessage: "\u0424\u0418\u041E" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { style: { padding: '8px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "MobileRegistry.table.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { style: { padding: '8px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "MobileRegistry.table.documentNumber", defaultMessage: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A." })
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        { style: { padding: '8px' } },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "MobileRegistry.table.documentDate", defaultMessage: "\u0414\u0430\u0442\u0430 \u0434\u043E\u043A." })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                data.map(function (el, index) {
	                    var row = el.row || {};
	                    var rowStyle = el.hasError ? { backgroundColor: '#fde1df' } : {};
	
	                    return _react2.default.createElement(
	                        "tr",
	                        { key: index, style: Object.assign({}, rowStyle, { borderBottom: '1px solid #eee' }) },
	                        _react2.default.createElement(
	                            "td",
	                            { style: { padding: '8px' } },
	                            row.phone
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            { style: { padding: '8px' } },
	                            row.bic
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            { style: { padding: '8px' } },
	                            row.cardHolderRu || row.cardholder_name
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            { style: { padding: '8px' } },
	                            row.amount
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            { style: { padding: '8px' } },
	                            row.documentNumber || row.document_number || ''
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            { style: { padding: '8px' } },
	                            row.documentDate || row.document_date || ''
	                        )
	                    );
	                })
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Context2.default.Provider,
	            { value: {
	                    setFilterErrors: setFilterErrors,
	                    onSelectedTag: onSelectedTag,
	                    onChangeRegistryName: onChangeRegistryName,
	                    submitRegistry: submitRegistry,
	                    clearRegistry: clearRegistry
	                } },
	            _react2.default.createElement(
	                _Layout.Container,
	                { className: _stylesModule2.default.StackOnMobile },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "780", className: _stylesModule2.default.MainColumn },
	                    loadingRegistry ? _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Card },
	                        renderMobileTable(filteredRegistry.length > 0 ? filteredRegistry : initRegistry)
	                    ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(_RegistryDADUpload2.default, {
	                            token: token,
	                            onRegistryUpload: onMobileRegistryUpload,
	                            merchantUuid: projectUUID,
	                            hint: "\u0424\u043E\u0440\u043C\u0430\u0442: \u0442\u0435\u043B\u0435\u0444\u043E\u043D, \u0431\u0430\u043D\u043A, \u0424\u0418\u041E, \u0441\u0443\u043C\u043C\u0430 (XLSX/CSV)",
	                            uploadFn: mobileUploadFn
	                        }),
	                        _react2.default.createElement(_RegistryInfoCard.WrongRegistryTypeHint, {
	                            wrongType: wrongRegistryType,
	                            hint: wrongRegistryHint
	                        }),
	                        _react2.default.createElement(_RegistryColumnsHelp2.default, {
	                            token: token,
	                            type: "sbp",
	                            provider: selectedTerminal ? selectedTerminal.processing : null
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "350", className: _stylesModule2.default.SideColumn },
	                    _react2.default.createElement(_RegistryUploadInfo2.default, { name: initRegistryName, errorsCount: errorsCount,
	                        errorsList: errorsList, errorsFormat: errorsFormat,
	                        balance: terminalBalance, amount: registryAmount, fee: commission }),
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_FieldsHelper.Select, {
	                            label: "FieldsHelper.label.project",
	                            placeholder: "FieldsHelper.label.selectProject",
	                            isLoading: loadingProjects,
	                            values: projects,
	                            onChange: onSelectProject,
	                            selectedValue: selectedProject,
	                            isClean: false,
	                            fieldName: "displayName",
	                            fieldStatus: "status"
	                        }),
	                        selectedProject && _react2.default.createElement(_RegistryInfoCard2.default, {
	                            variant: "project",
	                            project: selectedProject,
	                            terminals: terminals
	                        }),
	                        _react2.default.createElement(_FieldsHelper.Select, {
	                            label: "FieldsHelper.label.terminal",
	                            placeholder: "FieldsHelper.label.selectTerminal",
	                            isLoading: loadingProjects || !selectedProject || loadingTerminals,
	                            values: terminals,
	                            onChange: onSelectTerminal,
	                            selectedValue: selectedTerminal,
	                            isClean: false,
	                            fieldName: "name",
	                            fieldStatus: "enabled"
	                        }),
	                        selectedTerminal && _react2.default.createElement(_RegistryInfoCard2.default, {
	                            variant: "terminal",
	                            terminal: selectedTerminal,
	                            currentMethod: "sbp"
	                        }),
	                        selectedProject && !loadingTerminals && terminals.length === 0 && _react2.default.createElement(_RegistryInfoCard.NoTerminalsForMethod, { currentMethod: "sbp" })
	                    ),
	                    loadingRegistry && _react2.default.createElement(_RegistryControls2.default, {
	                        errorsCount: errorsCount,
	                        suggestionsTag: suggestionsTags,
	                        registryFileName: registryName,
	                        amount: registryAmount,
	                        fee: commission,
	                        balance: terminalBalance,
	                        isLoading: isRequest
	                    })
	                )
	            )
	        )
	    );
	});
	
	exports.default = MobileRegistryUpload;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _PayControls = __webpack_require__(173);
	
	var _PayControls2 = _interopRequireDefault(_PayControls);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(206);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)((0, _reactRouterDom.useParams)().uuid),
	        _useState2 = _slicedToArray(_useState, 2),
	        projectUUID = _useState2[0],
	        setProjectUUID = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        providerUUID = _useState4[0],
	        setProviderUUID = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        projects = _useState6[0],
	        setProjects = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        terminals = _useState8[0],
	        setTerminals = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        selectedProject = _useState10[0],
	        setSelectedProject = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        selectedTerminal = _useState12[0],
	        setSelectedTerminal = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ fixedPerTransaction: 0, cost: 1, costFixedMinimum: 40 }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        totalFee = _useState14[0],
	        setTotalFee = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(0),
	        _useState16 = _slicedToArray(_useState15, 2),
	        commission = _useState16[0],
	        setCommission = _useState16[1];
	
	    var _useState17 = (0, _react.useState)({ balance: 0, currency: "RUB" }),
	        _useState18 = _slicedToArray(_useState17, 2),
	        terminalBalance = _useState18[0],
	        setTerminalBalance = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({ pan: '', cardHolder: '', email: '', phone: '', amount: '' }),
	        _useState20 = _slicedToArray(_useState19, 2),
	        form = _useState20[0],
	        setForm = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(true),
	        _useState22 = _slicedToArray(_useState21, 2),
	        loadingProjects = _useState22[0],
	        setLoadingProjects = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        loadingTerminals = _useState24[0],
	        setLoadingTerminals = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        isRequest = _useState26[0],
	        setIsRequest = _useState26[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    (0, _react.useEffect)(function () {
	
	        new _Api2.default({ token: token }).getProjects().then(function (r) {
	            setProjects(r);
	            setLoadingProjects(false);
	        });
	    }, []);
	
	    function calcCommission(amount, fee) {
	
	        if (amount.length !== 0 && fee) {
	            if (Number(amount) * (fee.cost / 100) < fee.costFixedMinimum) return Number(fee.costFixedMinimum) + Number(fee.fixedPerTransaction);else return Number(amount) * (fee.cost / 100) + fee.fixedPerTransaction;
	        } else {
	            return 0;
	        }
	    }
	
	    function onSelectProject(project) {
	        setProjectUUID(project.uuid);
	        setSelectedTerminal(null);
	        setProviderUUID(null);
	        setSelectedProject(project);
	        setLoadingTerminals(true);
	        setCommission(0);
	        setTerminalBalance({ balance: 0, currency: "RUB" });
	
	        new _Api2.default({ token: token }).getProjectData(project.uuid).then(function (r) {
	            if (r.terminals.length === 1) {
	                setTerminalBalance({ balance: r.terminals[0].balance.confirmed, currency: r.terminals[0].currency });
	                setProviderUUID(r.terminals[0].uuid);
	                setSelectedTerminal(r.terminals[0]);
	                setCommission(calcCommission(form.amount, r.terminals[0].fee.payout));
	                setTotalFee(r.terminals[0].fee.payout);
	            }
	
	            setTerminals(r.terminals);
	            setLoadingTerminals(false);
	        });
	    }
	
	    function onSelectTerminal(terminal) {
	        setSelectedTerminal(terminal);
	        setProviderUUID(terminal.uuid);
	        setTerminalBalance({ balance: terminal.balance.confirmed, currency: terminal.currency });
	        setTotalFee(terminal.fee.payout);
	
	        if (form.amount.length > 0) setCommission(calcCommission(form.amount, terminal.fee.payout));
	    }
	
	    function onChangeForm(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	
	        if (name === "amount") setCommission(calcCommission(value, totalFee));
	    }
	
	    function onSendForm() {
	
	        if (projectUUID && providerUUID) {
	
	            if (Number(terminalBalance.balance) < Number(form.amount) + Number(commission)) {
	                onMessage({ type: 'warning', message: 'Недостаточно средств для выполнения операции.' });
	                return false;
	            }
	
	            if (form.pan && form.cardHolder && form.amount && (form.email || form.phone)) {
	                setIsRequest(true);
	
	                new _Api2.default({ token: token }).makeSinglePayout(projectUUID, Object.assign({}, form, { providerUUID: providerUUID })).then(function (r) {
	                    if (r.error && r.transactionId) {
	
	                        onMessage({
	                            type: 'warning',
	                            message: 'Операция создана. ID операции для отслеживания: ' + r.transactionId
	                        });
	                        setForm({ pan: '', cardHolder: '', email: '', phone: '', amount: '' });
	                        setCommission(0);
	                    } else if (!r.error && r.transactionId) {
	
	                        onMessage({
	                            type: 'success',
	                            message: 'Успех! Денежные средства отправлены получателю. ID операции для отслеживания: ' + r.transactionId
	                        });
	                        setForm({ pan: '', cardHolder: '', email: '', phone: '', amount: '' });
	                        setCommission(0);
	                    } else if (r.code) {
	
	                        onMessage({ type: 'error', message: 'code ' + r.code + ': ' + r.message });
	                    } else {
	                        onMessage({
	                            type: 'error',
	                            message: "Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова."
	                        });
	                    }
	
	                    setIsRequest(false);
	                });
	            } else {
	                onMessage({ type: 'warning', message: 'Заполните все поля и укажите телефон или email получателя чека.' });
	            }
	        } else {
	            onMessage({
	                type: 'warning',
	                message: 'Для отправки платежа выберите проект и терминал с баланса которого будут списаны средства.'
	            });
	        }
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { className: _stylesModule2.default.StackOnMobile },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: "Pay.title.oneTimePayment" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_1 },
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _stylesModule2.default.BlockTitle },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "Pay.label.transferRecipient", defaultMessage: "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_2 },
	                            _react2.default.createElement(_FieldsHelper.CardNumberInputHelper, { onChange: onChangeForm, value: form.pan,
	                                placeholder: "0000 0000 0000 0000 000",
	                                isDisabled: isRequest })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_3 },
	                            _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                onChange: onChangeForm,
	                                value: form.cardHolder,
	                                placeholder: "IVAN IVANOV",
	                                fieldName: "cardHolder",
	                                label: "FieldsHelper.label.cardholder",
	                                changeRegexp: /[^A-Za-z\s]+/g,
	                                blurRegexp: /([A-Z]+\s)+([A-Z]+)/ig,
	                                changeMessage: "FieldsHelper.error.onlyLatinCardholder",
	                                blurMessage: "FieldsHelper.error.checkCardholderName",
	                                isUppercase: true,
	                                isDisabled: isRequest,
	                                autoComplete: "off"
	                            })
	                        )
	                    ),
	                    _react2.default.createElement("div", { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_1 },
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _stylesModule2.default.BlockTitle },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                    id: "Pay.label.receiverCheck", defaultMessage: "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C \u0447\u0435\u043A\u0430" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_2 },
	                            _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                onChange: onChangeForm,
	                                value: form.email,
	                                placeholder: "example@email.ru",
	                                fieldName: "email",
	                                label: "FieldsHelper.label.email",
	                                changeRegexp: /[^A-Za-z0-9\s_@.]+/g,
	                                blurRegexp: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	                                changeMessage: "FieldsHelper.error.charactersEmail",
	                                blurMessage: "FieldsHelper.error.checkEmail",
	                                isDisabled: isRequest,
	                                autoComplete: "off"
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_3 },
	                            _react2.default.createElement(_FieldsHelper.InputHelper, { onChange: onChangeForm,
	                                value: form.phone,
	                                placeholder: "+79175744444",
	                                fieldName: "phone",
	                                label: "FieldsHelper.label.phone",
	                                changeRegexp: /[^0-9+]+/g,
	                                blurRegexp: /^[+]\d+$/g,
	                                changeMessage: "FieldsHelper.error.onlyNumbersPhone",
	                                blurMessage: "FieldsHelper.error.checkPhone",
	                                isDisabled: isRequest,
	                                autoComplete: "off"
	                            })
	                        )
	                    ),
	                    _react2.default.createElement("div", { className: _stylesModule2.default.Divider }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Block },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_1 },
	                            _react2.default.createElement(
	                                "h4",
	                                { className: _stylesModule2.default.BlockTitle },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Pay.label.amount",
	                                    defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Col_2 },
	                            _react2.default.createElement(_FieldsHelper.InputAmountCurrencyHelper, {
	                                onChange: onChangeForm,
	                                value: form.amount,
	                                currency: [terminalBalance.currency],
	                                placeholder: "1960.20",
	                                label: "FieldsHelper.label.amount",
	                                changeMessage: "FieldsHelper.error.onlyNumbersAmount",
	                                blurMessage: "FieldsHelper.error.checkAmount",
	                                isDisabled: isRequest,
	                                autoComplete: "off"
	                            })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SideColumn },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    null,
	                    _react2.default.createElement(_FieldsHelper.Select, {
	                        label: "FieldsHelper.label.project",
	                        placeholder: "FieldsHelper.label.selectProject",
	                        isLoading: loadingProjects || isRequest,
	                        values: projects,
	                        onChange: onSelectProject,
	                        selectedValue: selectedProject,
	                        fieldName: "displayName",
	                        fieldStatus: "status"
	                    }),
	                    _react2.default.createElement(_FieldsHelper.Select, {
	                        label: "FieldsHelper.label.terminal",
	                        placeholder: "FieldsHelper.label.selectTerminal",
	                        isLoading: loadingProjects || !selectedProject || loadingTerminals,
	                        values: terminals,
	                        onChange: onSelectTerminal,
	                        selectedValue: selectedTerminal,
	                        isClean: false,
	                        fieldName: "name",
	                        fieldStatus: "enabled"
	                    })
	                ),
	                _react2.default.createElement(_PayControls2.default, {
	                    pan: form.pan,
	                    name: name,
	                    cardHolder: form.cardHolder,
	                    phone: form.phone,
	                    email: form.email,
	                    amount: form.amount ? form.amount : 0,
	                    commission: commission,
	                    balance: terminalBalance,
	                    onSendForm: onSendForm,
	                    isLoading: isRequest
	                })
	            )
	        )
	    );
	});

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Layout = __webpack_require__(6);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _PayoutsFilters = __webpack_require__(174);
	
	var _PayoutsFilters2 = _interopRequireDefault(_PayoutsFilters);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _RegistryList = __webpack_require__(181);
	
	var _RegistryList2 = _interopRequireDefault(_RegistryList);
	
	var _ReportWidget = __webpack_require__(95);
	
	var _ReportWidget2 = _interopRequireDefault(_ReportWidget);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _stylesModule = __webpack_require__(638);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PAYOUT_REGISTRIES_LIST = 128;
	
	function checkAccess(accountAccessSettings, globalPrivileges, bitMask) {
	    if (globalPrivileges !== null && globalPrivileges !== undefined) {
	        return (globalPrivileges & bitMask) > 0;
	    }
	    if (Array.isArray(accountAccessSettings)) {
	        return accountAccessSettings.some(function (el) {
	            return (el.privileges & bitMask) > 0;
	        });
	    }
	    return false;
	}
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token,
	        accountAccessSettings = _ref.accountAccessSettings,
	        globalPrivileges = _ref.globalPrivileges;
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        projects = _useState2[0],
	        setProjects = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        terminals = _useState4[0],
	        setTerminals = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(1),
	        _useState6 = _slicedToArray(_useState5, 2),
	        currentRegistryPage = _useState6[0],
	        setCurrentRegistryPage = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(15),
	        _useState8 = _slicedToArray(_useState7, 2),
	        postsPerRegistryPage = _useState8[0],
	        setPostsPerRegistryPage = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        registryList = _useState10[0],
	        setRegistryList = _useState10[1];
	
	    var _useState11 = (0, _react.useState)([]),
	        _useState12 = _slicedToArray(_useState11, 2),
	        tagsList = _useState12[0],
	        setTagsList = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0),
	        _useState14 = _slicedToArray(_useState13, 2),
	        registryListCount = _useState14[0],
	        setRegistryListCount = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        filterProjects = _useState16[0],
	        setFilterProjects = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        filterTerminals = _useState18[0],
	        setFilterTerminals = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({}),
	        _useState20 = _slicedToArray(_useState19, 2),
	        filterDate = _useState20[0],
	        setFilterDate = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        filterTagsList = _useState22[0],
	        setFilterTagsList = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        filters = _useState24[0],
	        setFilters = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(true),
	        _useState26 = _slicedToArray(_useState25, 2),
	        isLoadingProjects = _useState26[0],
	        setIsLoadingProjects = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(false),
	        _useState28 = _slicedToArray(_useState27, 2),
	        loadingRegistryList = _useState28[0],
	        setLoadingRegistryList = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(false),
	        _useState30 = _slicedToArray(_useState29, 2),
	        loadingTagsList = _useState30[0],
	        setLoadingTagsList = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(false),
	        _useState32 = _slicedToArray(_useState31, 2),
	        isOpenModal = _useState32[0],
	        setIsOpenModal = _useState32[1];
	
	    (0, _react.useEffect)(function () {
	
	        new _Api2.default({ token: token }).getProjects().then(function (response) {
	            setProjects(response);
	            setIsLoadingProjects(false);
	        });
	
	        new _Api2.default({ token: token }).setRegistryList({ itemsPerPage: postsPerRegistryPage, page: currentRegistryPage }).then(function (r) {
	            setRegistryList(r.data);
	            setRegistryListCount(r.count);
	            setLoadingRegistryList(true);
	        });
	
	        new _Api2.default({ token: token }).getAllTags().then(function (response) {
	            setTagsList(response);
	            setLoadingTagsList(true);
	        });
	    }, []);
	
	    (0, _react.useEffect)(function () {
	
	        var terminals = [];
	        var cleanFilterTerminals = [];
	
	        filterProjects.map(function (projectUUID) {
	            var result = projects.find(function (el) {
	                return el.uuid === projectUUID;
	            });
	
	            result.providers.map(function (el) {
	                return terminals.push(el);
	            });
	
	            return true;
	        });
	
	        filterTerminals.map(function (uuid) {
	            var result = terminals.find(function (el) {
	                return el.uuid !== uuid;
	            });
	
	            if (result !== undefined) cleanFilterTerminals.push(result.uuid);
	
	            return true;
	        });
	
	        setFilterTerminals(cleanFilterTerminals);
	        setTerminals(terminals);
	    }, [filterProjects]);
	
	    function onSelectProjects(data) {
	        setFilterProjects(data);
	    }
	
	    function selectFilter(filter) {
	
	        var key = Object.keys(filter)[0];
	        var value = Object.values(filter)[0];
	
	        if (value) {
	            setFilters([].concat(_toConsumableArray(filters), [filter]));
	        } else {
	
	            filters.map(function (el, index) {
	
	                if (Object.keys(el)[0] === key) {
	                    filters.splice(index, 1);
	                    setFilters(filters);
	                }
	
	                return true;
	            });
	        }
	    }
	
	    function applyFilters(registryPage) {
	
	        if (registryPage) setCurrentRegistryPage(registryPage);else setCurrentRegistryPage(1);
	
	        if (postsPerRegistryPage) setPostsPerRegistryPage(postsPerRegistryPage);
	
	        var registryFilters = {
	            projects: filterProjects,
	            providers: filterTerminals,
	            tags: filterTagsList,
	            filters: filters,
	            dateRange: filterDate,
	            page: registryPage,
	            itemsPerPage: postsPerRegistryPage
	        };
	
	        setLoadingRegistryList(false);
	
	        new _Api2.default({ token: token }).setRegistryList(registryFilters).then(function (r) {
	            setRegistryList(r.data);
	            setRegistryListCount(r.count);
	            setLoadingRegistryList(true);
	        });
	    }
	
	    function setRegistryPage(page, itemsPerPage) {
	
	        if (page) setCurrentRegistryPage(page);else setCurrentRegistryPage(1);
	
	        if (itemsPerPage) setPostsPerRegistryPage(itemsPerPage);
	
	        var registryFilters = {
	            projects: filterProjects,
	            providers: filterTerminals,
	            filters: filters,
	            dateRange: filterDate,
	            page: page,
	            itemsPerPage: itemsPerPage
	        };
	
	        new _Api2.default({ token: token }).setRegistryListFilters(registryFilters).then(function (response) {
	            setRegistryList(response.data);
	        });
	    }
	
	    function onSelectedTag(tags) {
	
	        var filterTags = [];
	
	        tags.map(function (tag) {
	            if (!filterTags.includes(tag.id)) return filterTags.push(tag.id);else return false;
	        });
	
	        setFilterTagsList(filterTags);
	    }
	
	    function onSelectTerminals(data) {
	        setFilterTerminals(data);
	    }
	
	    if (!checkAccess(accountAccessSettings, globalPrivileges, PAYOUT_REGISTRIES_LIST)) {
	        return _react2.default.createElement(
	            _Layout.Wrapper,
	            null,
	            _react2.default.createElement(
	                _Layout.Container,
	                { style: { justifyContent: "center" } },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: 1180 },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "d-flex justify-content-center align-items-center", style: { minHeight: '60vh' } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "h4",
	                                null,
	                                "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-muted" },
	                                "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430"
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "button",
	                    { type: "button", className: _stylesModule2.default.FiltersToggle, onClick: function onClick() {
	                            return setIsOpenModal(true);
	                        } },
	                    "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(_RegistryList2.default, { token: token, data: registryList, isLoading: loadingRegistryList }),
	                    postsPerRegistryPage < registryListCount && _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.PaginationWrap },
	                        _react2.default.createElement(_reactJsPagination2.default, {
	                            firstPageText: "\u21E4",
	                            prevPageText: "\u21E0",
	                            lastPageText: "\u21E5",
	                            nextPageText: "\u21E2",
	                            activeLinkClass: _stylesModule2.default.ActiveLink,
	                            activePage: currentRegistryPage,
	                            itemsCountPerPage: postsPerRegistryPage,
	                            totalItemsCount: registryListCount,
	                            pageRangeDisplayed: 5,
	                            onChange: function onChange(page) {
	                                return setRegistryPage(page, postsPerRegistryPage);
	                            }
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SidebarColumn },
	                _react2.default.createElement(
	                    _ResponsiveSidebarFilters2.default,
	                    { title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B", isOpen: isOpenModal, onClose: function onClose() {
	                            return setIsOpenModal(false);
	                        } },
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                            label: "FieldsHelper.label.project",
	                            placeholder: "FieldsHelper.label.selectProject",
	                            values: projects,
	                            selectedValues: filterProjects,
	                            isLoading: isLoadingProjects,
	                            onChange: onSelectProjects,
	                            excludeSearchColumn: []
	                        }),
	                        _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                            label: "FieldsHelper.label.terminal",
	                            placeholder: "FieldsHelper.label.selectTerminal",
	                            values: terminals,
	                            selectedValues: filterTerminals,
	                            isLoading: isLoadingProjects,
	                            onChange: onSelectTerminals,
	                            excludeSearchColumn: []
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                                return setFilterDate(range);
	                            }, defaultPeriod: 'halfYear' })
	                    ),
	                    _react2.default.createElement(_PayoutsFilters2.default, { loadingTagsList: loadingTagsList,
	                        tagsList: tagsList,
	                        onSelectFilter: selectFilter,
	                        filterProjects: filterProjects,
	                        onApplyFilters: applyFilters,
	                        onSelectedTag: onSelectedTag,
	                        isLoading: loadingRegistryList
	                    }),
	                    _react2.default.createElement(_ReportWidget2.default, { access: true, token: token, type: "payout", filter: {
	                            projects: filterProjects,
	                            tags: filterTagsList,
	                            filters: filters,
	                            dateRange: filterDate
	                        }, count: registryListCount, countLabel: "Реестров", date: filterDate, name: "payout_report" }),
	                    _react2.default.createElement(_ReportWidget2.default, { access: ["STATISTICS_REPORT_1C_VIEW"], token: token, type: "payout1C", filter: {
	                            projects: filterProjects,
	                            tags: filterTagsList,
	                            filters: filters,
	                            dateRange: filterDate
	                        }, count: registryListCount, countLabel: "Реестров", date: filterDate, name: "payout_report" })
	                )
	            )
	        )
	    );
	});

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _PayoutsTable = __webpack_require__(407);
	
	var _PayoutsTable2 = _interopRequireDefault(_PayoutsTable);
	
	var _SearchString = __webpack_require__(440);
	
	var _SearchString2 = _interopRequireDefault(_SearchString);
	
	var _PayoutsDetailFilters = __webpack_require__(403);
	
	var _PayoutsDetailFilters2 = _interopRequireDefault(_PayoutsDetailFilters);
	
	var _PayoutsDetailEditing = __webpack_require__(402);
	
	var _PayoutsDetailEditing2 = _interopRequireDefault(_PayoutsDetailEditing);
	
	var _PayoutsDetailAmounts = __webpack_require__(401);
	
	var _PayoutsDetailAmounts2 = _interopRequireDefault(_PayoutsDetailAmounts);
	
	var _ReportWidget = __webpack_require__(95);
	
	var _ReportWidget2 = _interopRequireDefault(_ReportWidget);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FilterPanel = __webpack_require__(185);
	
	var _FilterPanel2 = _interopRequireDefault(_FilterPanel);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(639);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PayoutsDetail = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	    var _useParams = (0, _reactRouterDom.useParams)(),
	        id = _useParams.id;
	
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var excludeColumns = ["date", "type", "accountingDate", "status", "currencyCode", "cardBrand", "cardBankName", "cardBankCountryCode"];
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        dataList = _useState2[0],
	        setDataList = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        filteredDataList = _useState4[0],
	        setFilteredDataList = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        isOpenModal = _useState6[0],
	        setIsOpenModal = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        name: "", tags: [], successAmount: 0, failedAmount: 0, otherAmount: 0, currencyCode: "RUB", merchantUuid: null
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        info = _useState8[0],
	        setInfo = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        suggestionsTags = _useState10[0],
	        setSuggestionsTags = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({
	        payout: false, payoutDecline: false, created: false, filtered: false
	    }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filters = _useState12[0],
	        setFilters = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(""),
	        _useState14 = _slicedToArray(_useState13, 2),
	        searchString = _useState14[0],
	        setSearchString = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        loading = _useState16[0],
	        setLoading = _useState16[1];
	
	    // Состояние для модального окна предупреждения о pending транзакциях
	
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        pendingWarningModal = _useState18[0],
	        setPendingWarningModal = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        pendingTransactions = _useState20[0],
	        setPendingTransactions = _useState20[1];
	
	    var matchItem = (0, _react.useCallback)(function (item, lower) {
	        return Object.keys(item).some(function (key) {
	            if (excludeColumns.includes(key)) return false;
	
	            var val = item[key];
	
	            if (val === null || val === undefined) return false;
	            if (typeof val !== "string" && typeof val !== "number") return false;
	
	            return val.toString().toLowerCase().includes(lower);
	        });
	    }, []);
	
	    var filterData = (0, _react.useCallback)(function (value) {
	
	        var lower = value.toLowerCase().trim();
	
	        var anyFiltersActive = Object.values(filters).some(Boolean);
	
	        if (!lower && !anyFiltersActive) {
	            setFilteredDataList(dataList);
	            return;
	        }
	
	        var result = dataList.filter(function (item) {
	            if (anyFiltersActive) {
	                if (filters.created && item.type === "created") return matchItem(item, lower);
	                if (filters.payoutDecline && item.type === "payoutDecline") return matchItem(item, lower);
	                if (filters.payout && item.type === "payout") return matchItem(item, lower);
	                if (filters.filtered && item.type === "filtered") return matchItem(item, lower);
	
	                return false;
	            }
	
	            return matchItem(item, lower);
	        });
	
	        setFilteredDataList(result);
	    }, [dataList, filters, matchItem]);
	
	    var onChangeSearch = function onChangeSearch(value) {
	        setSearchString(value);
	        filterData(value);
	    };
	
	    (0, _react.useEffect)(function () {
	
	        var api = new _Api2.default({ token: token });
	
	        api.setPayoutsList(id).then(function (r) {
	
	            if (!r) return;
	
	            setDataList(r.data || []);
	            setFilteredDataList(r.data || []);
	
	            setInfo({
	                name: r.info && r.info.name ? r.info.name : "",
	                merchantUuid: r.info && r.info.merchantUuid ? r.info.merchantUuid : null,
	                tags: r.info && r.info.tags ? r.info.tags : [],
	                successAmount: r.info && r.info.successAmount ? r.info.successAmount : 0,
	                failedAmount: r.info && r.info.failedAmount ? r.info.failedAmount : 0,
	                otherAmount: r.info && r.info.otherAmount ? r.info.otherAmount : 0,
	                currencyCode: r.info && r.info.currencyCode ? r.info.currencyCode : "RUB"
	            });
	
	            setLoading(true);
	        }).catch(function (err) {});
	    }, [id, token]);
	
	    (0, _react.useEffect)(function () {
	
	        if (!info.merchantUuid) {
	            return;
	        }
	
	        new _Api2.default({ token: token }).getTags(info.merchantUuid).then(function (r) {
	            setSuggestionsTags(r || []);
	        });
	    }, [info.merchantUuid, token]);
	
	    // Получить неуспешные транзакции (payoutDecline)
	    var getFailedTransactions = (0, _react.useCallback)(function () {
	        return dataList.filter(function (item) {
	            return item.type === "payoutDecline";
	        });
	    }, [dataList]);
	
	    // Получить pending транзакции (created)
	    var getPendingTransactions = (0, _react.useCallback)(function () {
	        return dataList.filter(function (item) {
	            return item.type === "created";
	        });
	    }, [dataList]);
	
	    // Форматировать PAN для отображения
	    var formatPan = function formatPan(item) {
	        return (item.firstPart || '****') + " \u2022\u2022\u2022\u2022 " + (item.lastPart || '****');
	    };
	
	    // Преобразовать неуспешные транзакции в формат реестра
	    var convertToRegistryFormat = (0, _react.useCallback)(function (transactions) {
	        return transactions.map(function (item, index) {
	            return {
	                row: {
	                    pan: item.firstPart && item.lastPart ? item.firstPart + "******" + item.lastPart : '',
	                    amount: item.amount || 0,
	                    recipient: item.recipient || '',
	                    phone: item.phone || ''
	                },
	                hasError: false,
	                errors: null,
	                index: index
	            };
	        });
	    }, []);
	
	    // Навигация на страницу загрузки реестра
	    var navigateToRegistryUpload = (0, _react.useCallback)(function (failedTransactions) {
	        var registryData = convertToRegistryFormat(failedTransactions);
	        var registryName = "\u041F\u043E\u0432\u0442\u043E\u0440_" + (info.name || 'реестра') + "_" + new Date().toLocaleDateString('ru-RU');
	
	        history.push('/registry-upload', {
	            preloadedRegistry: registryData,
	            preloadedName: registryName,
	            sourceRegistryId: id
	        });
	    }, [convertToRegistryFormat, info.name, history, id]);
	
	    // Обработчик клика на кнопку "Повторить неуспешные"
	    var handleRetryFailed = (0, _react.useCallback)(function () {
	        var failed = getFailedTransactions();
	
	        if (failed.length === 0) {
	            return;
	        }
	
	        var pending = getPendingTransactions();
	
	        if (pending.length > 0) {
	            // Проверяем совпадения по карте и сумме
	            var matchingPending = pending.filter(function (pendingItem) {
	                return failed.some(function (failedItem) {
	                    return pendingItem.firstPart === failedItem.firstPart && pendingItem.lastPart === failedItem.lastPart && pendingItem.amount === failedItem.amount;
	                });
	            });
	
	            if (matchingPending.length > 0) {
	                setPendingTransactions(matchingPending);
	                setPendingWarningModal(true);
	                return;
	            }
	        }
	
	        // Нет pending или нет совпадений - переходим сразу
	        navigateToRegistryUpload(failed);
	    }, [getFailedTransactions, getPendingTransactions, navigateToRegistryUpload]);
	
	    // Подтверждение в модальном окне - продолжить несмотря на pending
	    var handleConfirmRetry = (0, _react.useCallback)(function () {
	        setPendingWarningModal(false);
	        var failed = getFailedTransactions();
	        navigateToRegistryUpload(failed);
	    }, [getFailedTransactions, navigateToRegistryUpload]);
	
	    // Количество неуспешных транзакций
	    var failedCount = dataList.filter(function (item) {
	        return item.type === "payoutDecline";
	    }).length;
	
	    var pageContent = _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 1180 },
	                _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-between align-items-center mb-3" },
	                    _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { to: "/payouts" },
	                        _react2.default.createElement(
	                            "button",
	                            { type: "button", className: "btn btn-outline-primary" },
	                            "\u041D\u0430\u0437\u0430\u0434"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        "\u0420\u0435\u0435\u0441\u0442\u0440: ",
	                        info.name
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: "btn btn-outline-primary", onClick: function onClick() {
	                                return setIsOpenModal(true);
	                            } },
	                        "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u0434\u043E\u043F. \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F"
	                    )
	                ),
	                _react2.default.createElement(_PayoutsDetailAmounts2.default, {
	                    success: info.successAmount,
	                    failed: info.failedAmount,
	                    other: info.otherAmount,
	                    currency: info.currencyCode
	                }),
	                _react2.default.createElement(_SearchString2.default, {
	                    searchString: searchString,
	                    onChangeSearch: onChangeSearch,
	                    isDisabled: false,
	                    placeholder: "Search.label.registryData"
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(_PayoutsTable2.default, {
	                        payouts: filteredDataList,
	                        loading: loading
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                isOpen: pendingWarningModal,
	                onClose: function onClose() {
	                    return setPendingWarningModal(false);
	                },
	                onConfirm: handleConfirmRetry,
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetail.modal.warningTitle", defaultMessage: "\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435" }),
	                isConfirm: true
	            },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.WarningContent },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.WarningIcon },
	                    _react2.default.createElement(_Icon2.default, { icon: "warning", size: "48px", color: "#ff9800" })
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.WarningText },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "PayoutsDetail.modal.pendingWarning",
	                        defaultMessage: "\u0412 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0443\u0436\u0435 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u043A\u0430\u0440\u0442\u044B \u0438\u0437 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0435\u0441\u0442\u0440\u0430. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u044B\u043F\u043B\u0430\u0442."
	                    })
	                ),
	                pendingTransactions.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.PendingList },
	                    _react2.default.createElement(
	                        "p",
	                        { className: _stylesModule2.default.PendingListTitle },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "PayoutsDetail.modal.pendingListTitle",
	                            defaultMessage: "\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0449\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435:"
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.PendingTableWrap },
	                        _react2.default.createElement(
	                            "table",
	                            { className: _stylesModule2.default.PendingTable },
	                            _react2.default.createElement(
	                                "thead",
	                                null,
	                                _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetail.modal.card", defaultMessage: "\u041A\u0430\u0440\u0442\u0430" })
	                                    ),
	                                    _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetail.modal.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                                    ),
	                                    _react2.default.createElement(
	                                        "th",
	                                        null,
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PayoutsDetail.modal.recipient",
	                                            defaultMessage: "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C" })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "tbody",
	                                null,
	                                pendingTransactions.slice(0, 5).map(function (item, idx) {
	                                    return _react2.default.createElement(
	                                        "tr",
	                                        { key: idx },
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            formatPan(item)
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            item.amount,
	                                            " ",
	                                            item.currencyCode || info.currencyCode
	                                        ),
	                                        _react2.default.createElement(
	                                            "td",
	                                            null,
	                                            item.recipient || '—'
	                                        )
	                                    );
	                                }),
	                                pendingTransactions.length > 5 && _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                        "td",
	                                        { colSpan: 3, className: _stylesModule2.default.MoreItems },
	                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                            id: "PayoutsDetail.modal.moreItems",
	                                            defaultMessage: "... \u0438 \u0435\u0449\u0451 {count}",
	                                            values: { count: pendingTransactions.length - 5 }
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	
	    return _react2.default.createElement(
	        _FilterPanel2.default,
	        { title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u0434\u043E\u043F. \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F", isOpen: isOpenModal, onClose: function onClose() {
	                return setIsOpenModal(false);
	            }, content: pageContent },
	        _react2.default.createElement(_PayoutsDetailFilters2.default, {
	            filters: filters,
	            isLoading: loading,
	            onSelectFilter: function onSelectFilter(updater) {
	                setFilters(updater);
	            },
	            onApplyFilters: function onApplyFilters() {
	                filterData(searchString);
	            }
	        }),
	        _react2.default.createElement(_PayoutsDetailEditing2.default, {
	            token: token,
	            registryId: id,
	            name: info.name,
	            tags: info.tags,
	            suggestionsTags: suggestionsTags
	        }),
	        _react2.default.createElement(_ReportWidget2.default, {
	            access: true,
	            token: token,
	            type: "singleRegistry",
	            filter: Number(id),
	            count: dataList.length,
	            countLabel: "\u041F\u043B\u0430\u0442\u0435\u0436\u0435\u0439",
	            name: info.name,
	            date: false
	        }),
	        failedCount > 0 && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.RetryCard },
	            _react2.default.createElement(
	                "button",
	                {
	                    className: _stylesModule2.default.RetryBtn,
	                    onClick: handleRetryFailed
	                },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.RetryIcon, icon: "refresh", size: "18px" }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "PayoutsDetail.btn.retryFailed",
	                    defaultMessage: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0435"
	                }),
	                _react2.default.createElement(
	                    "span",
	                    { className: _stylesModule2.default.RetryCount },
	                    "(",
	                    failedCount,
	                    ")"
	                )
	            )
	        )
	    );
	});
	
	exports.default = PayoutsDetail;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layout = __webpack_require__(6);
	
	var _PrepaidTable = __webpack_require__(413);
	
	var _PrepaidTable2 = _interopRequireDefault(_PrepaidTable);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(207);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Prepaid() {
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            "h5",
	                            { className: _stylesModule2.default.Title },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: "Prepaid.title",
	                                defaultMessage: "\u041F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B"
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.TableWrap },
	                        _react2.default.createElement(_PrepaidTable2.default, null)
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = Prepaid;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _SingleDatePicker = __webpack_require__(43);
	
	var _SingleDatePicker2 = _interopRequireDefault(_SingleDatePicker);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _stylesModule = __webpack_require__(640);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function PrepaidActivate(_ref) {
	    var token = _ref.token;
	
	
	    var EAN = (0, _reactRouterDom.useParams)().EAN;
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    var _useState = (0, _react.useState)({
	        docSerial: "",
	        docNumber: "",
	        docIssuer: "",
	        docIssuedDate: "",
	        docIssuerCode: "",
	        secondName: "",
	        firstName: "",
	        patronymic: "",
	        gender: null,
	        birthday: "",
	        birthPlace: "",
	        birthCountry: "",
	        codeWord: "",
	        phone: "",
	        inn: "",
	        legalAddress: { value: "" },
	        residenceAddress: { value: "" }
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        form = _useState2[0],
	        setForm = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isRequest = _useState4[0],
	        setIsRequest = _useState4[1];
	
	    var genderList = [{ displayName: 'Мужской', isEnabled: true, id: "0" }, { displayName: 'Женский', isEnabled: true, id: "1" }];
	
	    var countryList = [{ displayName: 'Россия', isEnabled: true, id: 'Россия' }];
	
	    (0, _react.useEffect)(function () {
	        setIsRequest(true);
	
	        new _Api2.default({ token: token }).getPreActivatedCardDetails(EAN).then(function (r) {
	
	            if (r.activationData) {
	                setForm(Object.assign({}, r.activationData, {
	                    docIssuedDate: Date.parse(r.activationData.docIssuedDate),
	                    birthday: Date.parse(r.activationData.birthday),
	                    gender: genderList.find(function (val) {
	                        return val.id === r.activationData.gender;
	                    }),
	                    birthCountry: countryList.find(function (val) {
	                        return val.id === r.activationData.birthCountry;
	                    })
	                }));
	            }
	
	            setIsRequest(false);
	        });
	    }, [EAN]);
	
	    function handleChange(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function handleActivate() {
	
	        setIsRequest(true);
	
	        for (var key in form) {
	            if (form[key] === null || form[key].length === 0) {
	                onMessage({
	                    type: 'warning',
	                    message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.'
	                });
	                return setIsRequest(false);
	            }
	        }
	
	        new _Api2.default({ token: token }).setPreActivatedCardActivate(EAN, form).then(function (r) {
	            if (!r.error && r.result === "success") {
	                return onMessage({
	                    type: 'success',
	                    message: 'Карта проходить процесс активации. Отслеживать состояние можно в разделе "Детализация"'
	                });
	            } else {
	                onMessage({
	                    type: "error",
	                    message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова."
	                });
	                return setIsRequest(false);
	            }
	        });
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.containerFluid + " d-flex flex-column min-vh-100" },
	        _react2.default.createElement(
	            "div",
	            { className: "row flex-grow-1" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-12 pt-2" },
	                _react2.default.createElement(
	                    _EmptyCard2.default,
	                    { title: "Prepaid.title.activate", subtitle: "EAN: " + EAN },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041F\u0430\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        fieldName: "docSerial",
	                                        value: form.docSerial,
	                                        label: "FieldsHelper.label.docSerial",
	                                        blurMessage: "FieldsHelper.error.docSerial",
	                                        placeholder: "00 00",
	                                        mask: [/\d/, /\d/, " ", /\d/, /\d/],
	                                        isDisabled: isRequest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        fieldName: "docNumber",
	                                        value: form.docNumber,
	                                        label: "FieldsHelper.label.docNumber",
	                                        blurMessage: "FieldsHelper.error.docNumber",
	                                        placeholder: "000000",
	                                        mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.docIssuer,
	                                    placeholder: "Например: Отделом внутренних дел Г. МОСКВЫ",
	                                    fieldName: "docIssuer",
	                                    label: "FieldsHelper.label.Issued",
	                                    changeRegexp: /[^А-Яа-я\-\s".№]+/g,
	                                    blurRegexp: /^[А-Яа-я\-\s".№]/,
	                                    changeMessage: "FieldsHelper.error.onlyLatinIssued",
	                                    blurMessage: "FieldsHelper.error.checkIssued",
	                                    isDisabled: isRequest,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.docIssuedDate,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { docIssuedDate: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: isRequest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        value: form.docIssuerCode,
	                                        fieldName: "docIssuerCode",
	                                        label: "FieldsHelper.label.departmentCode",
	                                        blurMessage: "FieldsHelper.error.docIssuerCode",
	                                        placeholder: "000-000",
	                                        mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.secondName,
	                                    placeholder: "Например: Курчатов",
	                                    fieldName: "secondName",
	                                    label: "FieldsHelper.label.lastName",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersLastName",
	                                    blurMessage: "FieldsHelper.error.onlyLettersLastName",
	                                    isDisabled: isRequest,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.firstName,
	                                    placeholder: "Например: Игорь",
	                                    fieldName: "firstName",
	                                    label: "FieldsHelper.label.firstName",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersFirstName",
	                                    blurMessage: "FieldsHelper.error.onlyLettersFirstName",
	                                    isDisabled: isRequest,
	                                    isRequired: true,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.patronymic,
	                                    placeholder: "Например: Васильевич",
	                                    fieldName: "patronymic",
	                                    label: "FieldsHelper.label.patronymic",
	                                    changeRegexp: /[^A-Za-zА-Яа-я]+/g,
	                                    blurRegexp: /^[A-ZА-Я][A-Za-zА-Яа-я]*/,
	                                    changeMessage: "FieldsHelper.error.onlyLettersPatronymic",
	                                    blurMessage: "FieldsHelper.error.onlyLettersPatronymic",
	                                    isDisabled: isRequest,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.Select, {
	                                        label: "FieldsHelper.label.gender",
	                                        placeholder: "FieldsHelper.placeholder.gender",
	                                        values: genderList,
	                                        onChange: function onChange(value) {
	                                            return handleChange("gender", value);
	                                        },
	                                        selectedValue: form.gender,
	                                        fieldName: "displayName",
	                                        fieldStatus: "isEnabled",
	                                        isLoading: isRequest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: _stylesModule2.default.Label },
	                                        "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F"
	                                    ),
	                                    _react2.default.createElement(_SingleDatePicker2.default, {
	                                        selected: form.birthday,
	                                        onChange: function onChange(date) {
	                                            setForm(Object.assign({}, form, { birthday: date }));
	                                        },
	                                        className: _stylesModule2.default.Input,
	                                        dateFormat: "dd.MM.yyyy",
	                                        placeholderText: "00.00.0000",
	                                        disabled: isRequest
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.birthPlace,
	                                        placeholder: "",
	                                        fieldName: "birthPlace",
	                                        label: "FieldsHelper.label.birthPlace",
	                                        changeRegexp: /[^A-Za-zА-Яа-я\s".]+/g,
	                                        blurRegexp: /^[A-Za-zА-Яа-я\s".]/,
	                                        changeMessage: "FieldsHelper.error.onlyLatinBirthPlace",
	                                        blurMessage: "FieldsHelper.error.checkBirthPlace",
	                                        isDisabled: isRequest,
	                                        isRequired: true,
	                                        autoComplete: "off"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.Select, {
	                                        label: "FieldsHelper.label.birthCountry",
	                                        placeholder: "FieldsHelper.placeholder.birthCountry",
	                                        values: countryList,
	                                        onChange: function onChange(value) {
	                                            return handleChange("birthCountry", value);
	                                        },
	                                        selectedValue: form.birthCountry,
	                                        fieldName: "displayName",
	                                        fieldStatus: "isEnabled",
	                                        isLoading: isRequest
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Column },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u041A\u043E\u0434\u043E\u0432\u043E\u0435 \u0441\u043B\u043E\u0432\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u043B\u044F \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u0432 \u0431\u0430\u043D\u043A."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: handleChange,
	                                    value: form.codeWord,
	                                    placeholder: "",
	                                    fieldName: "codeWord",
	                                    label: "FieldsHelper.label.codeWord",
	                                    changeRegexp: /[^A-Za-zА-Яа-я\s]+/g,
	                                    blurRegexp: /([A-Z]+\s)+([A-Z]+)/ig,
	                                    changeMessage: "FieldsHelper.error.onlyLatinCardholder",
	                                    blurMessage: "FieldsHelper.error.checkCardholderName",
	                                    isUppercase: true,
	                                    isDisabled: isRequest,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: _stylesModule2.default.Title },
	                                "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: _stylesModule2.default.Text },
	                                "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E."
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DoubleCell },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.MaskedIH, {
	                                        onChange: handleChange,
	                                        value: form.phone,
	                                        fieldName: "phone",
	                                        label: "FieldsHelper.label.phone",
	                                        changeMessage: "FieldsHelper.error.onlyNumbersPhone",
	                                        blurMessage: "FieldsHelper.error.checkPhone",
	                                        placeholder: "+7 (917) 574-4444",
	                                        mask: ['+', '7', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	                                        isDisabled: isRequest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.InputWrap },
	                                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                        onChange: handleChange,
	                                        value: form.inn,
	                                        fieldName: "inn",
	                                        label: "FieldsHelper.label.inn",
	                                        placeholder: "0000000000",
	                                        changeRegexp: /[^0-9]+/g,
	                                        blurRegexp: /^[0-9]{12}/,
	                                        changeMessage: "FieldsHelper.error.onlyNumbersInn",
	                                        blurMessage: "FieldsHelper.error.checkNumbersInn",
	                                        isDisabled: isRequest
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.AddressDaData, {
	                                    onChange: handleChange,
	                                    label: "FieldsHelper.label.legalAddress",
	                                    placeholder: "Начните вводить адрес",
	                                    value: form.legalAddress.value,
	                                    fieldName: "legalAddress",
	                                    changeRegexp: /[^А-Яа-я0-9\s.,]+/g,
	                                    blurRegexp: /^[А-Яа-я0-9\s.,]+$/g,
	                                    changeMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    isDisabled: isRequest
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_FieldsHelper.AddressDaData, {
	                                    onChange: handleChange,
	                                    label: "FieldsHelper.label.residenceAddress",
	                                    placeholder: "Начните вводить адрес",
	                                    value: form.residenceAddress.value,
	                                    fieldName: "residenceAddress",
	                                    changeRegexp: /[^А-Яа-я0-9\s.,]+/g,
	                                    blurRegexp: /^[А-Яа-я0-9\s.,]+$/g,
	                                    changeMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    blurMessage: "FieldsHelper.error.onlyLettersAddress",
	                                    isDisabled: isRequest
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.InputWrap },
	                                _react2.default.createElement(_Button2.default, { label: "Profile.btn.activate", color: "#35C98E", onClick: handleActivate,
	                                    icon: "checkmark", isLoading: isRequest })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(PrepaidActivate);

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _VTabBar = __webpack_require__(60);
	
	var _VTabBar2 = _interopRequireDefault(_VTabBar);
	
	var _TabBarItem = __webpack_require__(96);
	
	var _TabBarItem2 = _interopRequireDefault(_TabBarItem);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _FormatDate = __webpack_require__(24);
	
	var _FormatDate2 = _interopRequireDefault(_FormatDate);
	
	var _IsEmpty = __webpack_require__(439);
	
	var _IsEmpty2 = _interopRequireDefault(_IsEmpty);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(641);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PrepaidDetails(_ref) {
	    var token = _ref.token;
	
	    var EAN = (0, _reactRouterDom.useParams)().EAN;
	    var history = (0, _reactRouterDom.useHistory)();
	
	    var _useState = (0, _react.useState)({}),
	        _useState2 = _slicedToArray(_useState, 2),
	        details = _useState2[0],
	        setDetails = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        loading = _useState4[0],
	        setLoading = _useState4[1];
	
	    var gender = function gender(val) {
	        switch (val) {
	            case "0":
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.gender.female", defaultMessage: "\u0416\u0435\u043D\u0441\u043A\u0438\u0439" });
	            case "1":
	                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.gender.male", defaultMessage: "\u041C\u0443\u0436\u0441\u043A\u043E\u0439" });
	            default:
	                return (0, _IsEmpty2.default)();
	        }
	    };
	
	    var handleActivate = function handleActivate() {
	        history.push("/prepaid/activate/" + EAN);
	    };
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getPreActivatedCardDetails(EAN).then(function (r) {
	            if (r.activationData != null) {
	                setDetails(r);
	            } else {
	                setDetails(Object.assign({}, r, {
	                    activationData: {
	                        legalAddress: { value: "" },
	                        residenceAddress: { value: "" }
	                    }
	                }));
	            }
	            setLoading(false);
	        });
	    }, [EAN, token]);
	
	    // Безопасное получение значений
	    var getValue = function getValue(obj, path) {
	        var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	        return path.reduce(function (acc, key) {
	            return acc && acc[key] != null ? acc[key] : fallback;
	        }, obj);
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.containerFluid + " d-flex flex-column min-vh-100" },
	        _react2.default.createElement(
	            "div",
	            { className: "row flex-grow-1" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-12 pt-2" },
	                loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	                    _EmptyCard2.default,
	                    {
	                        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Prepaid.title.details", defaultMessage: "\u0414\u0435\u0442\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u043A\u0430\u0440\u0442\u044B" }),
	                        subtitle: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: "PrepaidDetails.subtitle.ean",
	                            defaultMessage: "EAN: {ean} ({part})",
	                            values: {
	                                ean: EAN,
	                                part: (details.part || "").replace(/[*]{6}/g, " •••• ")
	                            }
	                        })
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Card },
	                        _react2.default.createElement(
	                            _VTabBar2.default,
	                            { className: _stylesModule2.default.TabBar },
	                            _react2.default.createElement(
	                                _TabBarItem2.default,
	                                {
	                                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.tab.passport",
	                                        defaultMessage: "\u041F\u0430\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }),
	                                    navIcon: "file-text",
	                                    isVisible: true
	                                },
	                                _react2.default.createElement(
	                                    "table",
	                                    { className: _stylesModule2.default.TabTable },
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.docSerial",
	                                                    defaultMessage: "\u0421\u0435\u0440\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'docSerial']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.docNumber",
	                                                    defaultMessage: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'docNumber']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.docIssuer",
	                                                    defaultMessage: "\u041A\u0435\u043C \u0432\u044B\u0434\u0430\u043D:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'docIssuer']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.docIssuedDate",
	                                                    defaultMessage: "\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_FormatDate2.default, {
	                                                    setDate: getValue(details, ['activationData', 'docIssuedDate']),
	                                                    format: { day: "numeric", month: "numeric", year: "numeric" },
	                                                    isEmpty: true
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.docIssuerCode",
	                                                    defaultMessage: "\u041A\u043E\u0434 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'docIssuerCode']))
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _TabBarItem2.default,
	                                {
	                                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.tab.personal",
	                                        defaultMessage: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }),
	                                    navIcon: "user",
	                                    isVisible: true
	                                },
	                                _react2.default.createElement(
	                                    "table",
	                                    { className: _stylesModule2.default.TabTable },
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.lastName",
	                                                    defaultMessage: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'secondName']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.firstName",
	                                                    defaultMessage: "\u0418\u043C\u044F:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'firstName']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.patronymic",
	                                                    defaultMessage: "\u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'patronymic']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.gender",
	                                                    defaultMessage: "\u041F\u043E\u043B:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                gender(getValue(details, ['activationData', 'gender']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.birthday",
	                                                    defaultMessage: "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_FormatDate2.default, {
	                                                    setDate: getValue(details, ['activationData', 'birthday']),
	                                                    format: { day: "numeric", month: "numeric", year: "numeric" },
	                                                    isEmpty: true
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.birthPlace",
	                                                    defaultMessage: "\u041C\u0435\u0441\u0442\u043E \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'birthPlace']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.birthCountry",
	                                                    defaultMessage: "\u0421\u0442\u0440\u0430\u043D\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'birthCountry']))
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _TabBarItem2.default,
	                                {
	                                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.tab.contacts",
	                                        defaultMessage: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F" }),
	                                    navIcon: "envelop",
	                                    isVisible: true
	                                },
	                                _react2.default.createElement(
	                                    "table",
	                                    { className: _stylesModule2.default.TabTable },
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.phone",
	                                                    defaultMessage: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'phone']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.legalAddress",
	                                                    defaultMessage: "\u0410\u0434\u0440\u0435\u0441 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'legalAddress', 'value']))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.label.residenceAddress",
	                                                    defaultMessage: "\u0410\u0434\u0440\u0435\u0441 \u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u044F:" })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (0, _IsEmpty2.default)(getValue(details, ['activationData', 'residenceAddress', 'value']))
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        (details.status === 0 || details.status === 3) && _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Footer },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Btn, onClick: handleActivate },
	                                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.IconLeft, icon: "checkmark", size: "16px" }),
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "PrepaidDetails.button.activate",
	                                    defaultMessage: "\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C" })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(PrepaidDetails);

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactIntl = __webpack_require__(2);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _stylesModule = __webpack_require__(112);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var generator = {
	    generate: function generate(opts) {
	        var length = opts && opts.length || 10;
	        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
	        if (opts && opts.numbers) chars += "0123456789";
	        if (opts && opts.symbols) chars += "!@#$%^&*()_+-=";
	        var result = "";
	        var array = new Uint32Array(length);
	        window.crypto.getRandomValues(array);
	        for (var i = 0; i < length; i++) {
	            result += chars[array[i] % chars.length];
	        }
	        return result;
	    }
	};
	
	function General(_ref) {
	    var token = _ref.token,
	        logout = _ref.logout,
	        forcedPasswordChange = _ref.forcedPasswordChange,
	        onMessage = _ref.onMessage;
	
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isLoading = _useState2[0],
	        setIsLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isOpenModal = _useState4[0],
	        setIsOpenModal = _useState4[1];
	
	    var _useState5 = (0, _react.useState)({ email: "", password: "", firstName: "", lastName: "", patronymic: "" }),
	        _useState6 = _slicedToArray(_useState5, 2),
	        form = _useState6[0],
	        setForm = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        initEmail = _useState8[0],
	        setInitEmail = _useState8[1];
	
	    function onModalClose() {
	        setIsOpenModal(false);
	        setIsLoading(false);
	    }
	
	    function confirmChanges() {
	        if (form.password || form.email !== initEmail) setIsOpenModal(true);
	    }
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getUserData().then(function (r) {
	            setForm(Object.assign({}, form, { email: r.email, firstName: r.firstName, lastName: r.lastName, patronymic: r.patronymic }));
	            setInitEmail(r.email);
	        });
	    }, []);
	
	    function onChangeForm(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	    }
	
	    function cleanPassword() {
	        setForm(Object.assign({}, form, { password: "" }));
	    }
	
	    function generatePassword() {
	        setForm(Object.assign({}, form, { password: generator.generate({
	                length: 10,
	                numbers: true,
	                symbols: true
	            })
	        }));
	    }
	
	    function saveChanges() {
	
	        setIsOpenModal(false);
	        setIsLoading(true);
	
	        var email = form.email;
	
	        new _Api2.default({ token: token }).setUserData(form).then(function (r) {
	
	            if (r.error) {
	                onMessage({
	                    type: "error",
	                    message: "Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова."
	                });
	                setIsLoading(false);
	                return;
	            }
	
	            if (form.password) {
	                logout();
	                return;
	            }
	
	            // Смена почты не применяется сразу: сервер шлёт письмо на новый адрес
	            // и ждёт перехода по ссылке. Писать «Успех» было бы неправдой — адрес
	            // пока прежний.
	            if (r.emailConfirmationPending) {
	                onMessage(r.emailConfirmationSent === false ? {
	                    type: "error",
	                    message: intl.formatMessage({
	                        id: "Profile.error.emailConfirmationNotSent",
	                        defaultMessage: "Не удалось отправить письмо на {email}. Почта пока прежняя — попробуйте сменить её позже или напишите в поддержку."
	                    }, { email: email })
	                } : {
	                    type: "success",
	                    message: intl.formatMessage({
	                        id: "Profile.success.emailConfirmationPending",
	                        defaultMessage: "Мы отправили письмо на {email}. Адрес сменится после перехода по ссылке из письма."
	                    }, { email: email })
	                });
	
	                // Без этого следующее «Сохранить» снова считало бы почту
	                // изменённой и отправляло новое письмо.
	                setInitEmail(email);
	            } else {
	                onMessage({ type: "success", message: "Успех. Вы успешно сохранили форму." });
	            }
	
	            setIsLoading(false);
	        }).catch(function () {
	            // Ответ 422 (например, короткий пароль) раньше не ловился, и форма
	            // навсегда оставалась в загрузке.
	            onMessage({
	                type: "error",
	                message: "Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова."
	            });
	            setIsLoading(false);
	        });
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            { title: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445", isOpen: isOpenModal, onClose: function onClose() {
	                    return onModalClose();
	                },
	                onConfirm: function onConfirm() {
	                    return saveChanges();
	                }, isConfirm: true },
	            form.password && _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.ModalText },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "Profile.text.changePassword",
	                    values: { password: _react2.default.createElement(
	                            "b",
	                            null,
	                            form.password
	                        ) },
	                    defaultMessage: "\u041F\u0430\u0440\u043E\u043B\u044C \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0412\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u0440\u0430\u0437\u043B\u043E\u0433\u0438\u043D\u0435\u043D\u044B \u043D\u0430 \u0432\u0441\u0435\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445. \u041F\u0435\u0440\u0435\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435\u043C \u0437\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0432 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C: {password}"
	                })
	            ),
	            form.email !== initEmail && _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.ModalText },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "Profile.text.changeEmail",
	                    values: { email: _react2.default.createElement(
	                            "b",
	                            null,
	                            form.email
	                        ) },
	                    defaultMessage: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 {email} \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u0441\u043B\u0430\u043D\u043E \u043F\u0438\u0441\u044C\u043C\u043E \u0441 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0438\u043C\u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F\u043C\u0438."
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Column },
	            _react2.default.createElement(
	                "h3",
	                { className: _stylesModule2.default.Title },
	                "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
	            ),
	            _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.Text },
	                "\u0414\u043B\u044F \u0441\u043C\u0435\u043D\u044B \u0424\u0418\u041E \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443."
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                    onChange: onChangeForm,
	                    value: form.email,
	                    placeholder: "example@email.ru",
	                    fieldName: "email",
	                    label: "FieldsHelper.label.email",
	                    changeRegexp: /[^A-Za-z0-9\s_@.]+/g,
	                    blurRegexp: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	                    changeMessage: "FieldsHelper.error.charactersEmail",
	                    blurMessage: "FieldsHelper.error.checkEmail",
	                    isDisabled: isLoading,
	                    autoComplete: "off"
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.Label },
	                    "\u0424\u0430\u043C\u0438\u043B\u0438\u044F"
	                ),
	                _react2.default.createElement("input", { className: _stylesModule2.default.Input, defaultValue: form.lastName, readOnly: true, disabled: true })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.Label },
	                    "\u0418\u043C\u044F"
	                ),
	                _react2.default.createElement("input", { className: _stylesModule2.default.Input, defaultValue: form.firstName, readOnly: true, disabled: true })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                _react2.default.createElement(
	                    "label",
	                    { className: _stylesModule2.default.Label },
	                    "\u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E"
	                ),
	                _react2.default.createElement("input", { className: _stylesModule2.default.Input, defaultValue: form.patronymic, readOnly: true, disabled: true })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Column },
	            forcedPasswordChange && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.Attention },
	                _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.AttentionIcon, icon: "warning", size: '25px' }),
	                "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438. \u0412\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u043E\u043C \u043F\u0430\u0440\u043E\u043B\u044F \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0432 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435."
	            ),
	            _react2.default.createElement(
	                "h3",
	                { className: _stylesModule2.default.Title },
	                "C\u043C\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F"
	            ),
	            _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.Text },
	                "\u041F\u043E\u0441\u043B\u0435 \u0441\u043C\u0435\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044F \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0451\u0442 \u0432\u044B\u0445\u043E\u0434 \u0438\u0437 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043D\u0430 \u0432\u0441\u0435\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445."
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.InputHeader },
	                    _react2.default.createElement(
	                        "label",
	                        { className: _stylesModule2.default.Label },
	                        "\u041F\u0430\u0440\u043E\u043B\u044C"
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _stylesModule2.default.InputLink, onClick: function onClick() {
	                                !isLoading && cleanPassword();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { className: _stylesModule2.default.LinkIcon, icon: "close", size: "12px" }),
	                        "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"
	                    )
	                ),
	                _react2.default.createElement("input", { className: _stylesModule2.default.Input, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", value: form.password, readOnly: true,
	                    disabled: isLoading }),
	                _react2.default.createElement(
	                    "button",
	                    { className: _stylesModule2.default.Btn, onClick: function onClick() {
	                            !isLoading && generatePassword();
	                        } },
	                    "\u0413\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440 \u043F\u0430\u0440\u043E\u043B\u044F"
	                )
	            )
	        ),
	        _react2.default.createElement(_Button2.default, { label: "Profile.btn.save", onClick: confirmChanges, icon: "document-edit", isLoading: isLoading })
	    );
	}
	
	exports.default = General;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(112);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Security(_ref) {
	    var token = _ref.token,
	        onMessage = _ref.onMessage,
	        requires2FASetup = _ref.requires2FASetup,
	        clear2FASetupFlag = _ref.clear2FASetupFlag,
	        authorize = _ref.authorize,
	        isRemember = _ref.isRemember;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        isLoading = _useState2[0],
	        setIsLoading = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        isOpenModal = _useState4[0],
	        setIsOpenModal = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([""]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        ipAccessList = _useState6[0],
	        setIpAccessList = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([""]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        initIpAccessList = _useState8[0],
	        setInitIpAccessList = _useState8[1];
	
	    var allAuthTypes = [{ displayName: "E-mail", isEnabled: true, id: "email" }, { displayName: "Google Authenticator", isEnabled: true, id: "gauth" }, { displayName: "SMS", isEnabled: true, id: "sms" }];
	
	    var _useState9 = (0, _react.useState)(allAuthTypes),
	        _useState10 = _slicedToArray(_useState9, 2),
	        authTypeList = _useState10[0],
	        setAuthTypeList = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        currentAuthType = _useState12[0],
	        setCurrentAuthType = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ isMFAEnabled: false, OTPEmail: "", OTPPhoneNumber: "" }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        currentOTPData = _useState14[0],
	        setCurrentOTPData = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(null),
	        _useState16 = _slicedToArray(_useState15, 2),
	        updateOTPData = _useState16[0],
	        setUpdateOTPData = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        otpCodeSend = _useState18[0],
	        setOTPCodeSend = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(""),
	        _useState20 = _slicedToArray(_useState19, 2),
	        otpCode = _useState20[0],
	        setOTPCode = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(""),
	        _useState22 = _slicedToArray(_useState21, 2),
	        otpText = _useState22[0],
	        setOTPText = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(""),
	        _useState24 = _slicedToArray(_useState23, 2),
	        otpEmail = _useState24[0],
	        setOTPEmail = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(""),
	        _useState26 = _slicedToArray(_useState25, 2),
	        otpPhoneNumber = _useState26[0],
	        setOTPPhoneNumber = _useState26[1];
	
	    var _useState27 = (0, _react.useState)({ qrCode: null, secret: null }),
	        _useState28 = _slicedToArray(_useState27, 2),
	        gAuth = _useState28[0],
	        setGAuth = _useState28[1];
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getUserData().then(function (r) {
	            setIpAccessList(r.ipAccessList.length ? r.ipAccessList : [""]);
	            setInitIpAccessList(r.ipAccessList.length ? r.ipAccessList : [""]);
	        });
	
	        new _Api2.default({ token: token }).getOTPData().then(function (r) {
	            // Фильтруем доступные провайдеры на основе ответа сервера
	            if (r.availableProviders && Array.isArray(r.availableProviders)) {
	                setAuthTypeList(allAuthTypes.filter(function (type) {
	                    return r.availableProviders.includes(type.id);
	                }));
	            }
	            setCurrentAuthType(allAuthTypes.find(function (type) {
	                return type.id === r.OTPProvider;
	            }));
	            setCurrentOTPData(r);
	        });
	    }, []);
	
	    function onSetAuthType(type) {
	        setCurrentAuthType(type);
	
	        if (type.id === "gauth") {
	
	            setIsLoading(true);
	
	            new _Api2.default({ token: token }).setOTPUpdate({ isMFAEnabled: true, OTPProvider: "gauth" }).then(function (r) {
	
	                if (r.status === 200) {
	                    setGAuth(r.data);
	                    setIsLoading(false);
	                }
	            });
	        }
	    }
	
	    function onAuthAction(options) {
	
	        var provider = currentOTPData.OTPProvider ? currentOTPData.OTPProvider : options.OTPProvider;
	
	        switch (provider) {
	            case "email":
	                setOTPText(function () {
	                    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.text.changeOTPEmail",
	                        values: { email: _react2.default.createElement(
	                                "b",
	                                null,
	                                currentOTPData.OTPEmail
	                            ) },
	                        defaultMessage: "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C." });
	                });
	                break;
	            case "gauth":
	                setOTPText(function () {
	                    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.text.changeOTPGAuth",
	                        defaultMessage: "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C." });
	                });
	                break;
	            case "sms":
	                setOTPText(function () {
	                    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Profile.text.changeOTPPhone",
	                        values: { phone: _react2.default.createElement(
	                                "b",
	                                null,
	                                currentOTPData.OTPPhoneNumber
	                            ) },
	                        defaultMessage: "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C." });
	                });
	                break;
	            default:
	        }
	
	        if (options.OTPProvider === "gauth") {
	            setIsOpenModal(true);
	            setOTPCodeSend(true);
	            setUpdateOTPData(options);
	
	            return null;
	        }
	
	        new _Api2.default({ token: token }).setOTPUpdate(options).then(function (r) {
	
	            if (r.status === 400) {
	                if (r.data.code === "200") {
	                    onMessage({ type: "error", message: r.data.message });
	                    setUpdateOTPData(options);
	                } else {
	                    onMessage({ type: "error", message: r.statusText });
	                }
	
	                return null;
	            }
	
	            if (r.status === 200) {
	                setIsOpenModal(true);
	                setOTPCodeSend(true);
	                setUpdateOTPData(options);
	            }
	        });
	    }
	
	    function onModalClose() {
	        setIsOpenModal(false);
	        setIsLoading(false);
	    }
	
	    function saveChanges() {
	
	        if (otpCode) {
	            new _Api2.default({ token: token }).setOTPUpdate(Object.assign({}, updateOTPData, { code: otpCode })).then(function (r) {
	
	                setIsLoading(true);
	                setOTPCode("");
	
	                if (r.status === 400) {
	                    onMessage({ type: "error", message: r.statusText });
	                    setIsLoading(false);
	                    return null;
	                }
	
	                if (r.status === 200) {
	                    if (r.data.isMFAEnabled) {
	                        onMessage({ type: "success", message: "Двухфакторная аутентификация подключена" });
	                        setCurrentOTPData(r.data);
	                        setOTPEmail("");
	                        setOTPPhoneNumber("");
	                        setGAuth({ qrCode: null, secret: null });
	                        setIsLoading(false);
	                        setIsOpenModal(false);
	
	                        // Если сервер вернул новый токен (после сброса requires2FASetup) — обновляем
	                        if (r.data.token && authorize) {
	                            authorize(r.data.token, isRemember);
	                        } else if (requires2FASetup && clear2FASetupFlag) {
	                            // Fallback: сбрасываем флаг только в React state
	                            clear2FASetupFlag();
	                        }
	                    } else {
	                        onMessage({ type: "success", message: "Двухфакторная аутентификация отключена" });
	                        setCurrentAuthType(null);
	                        setCurrentOTPData(Object.assign({}, currentOTPData, {
	                            isMFAEnabled: r.isMFAEnabled,
	                            OTPEmail: "",
	                            OTPPhoneNumber: ""
	                        }));
	                        setIsLoading(false);
	                        setIsOpenModal(false);
	                    }
	                }
	            });
	        }
	    }
	
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            _Modal2.default,
	            { title: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445", isOpen: isOpenModal, onClose: function onClose() {
	                    return onModalClose();
	                },
	                onConfirm: function onConfirm() {
	                    return saveChanges();
	                }, isConfirm: true },
	            ipAccessList.length !== initIpAccessList.length && _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.ModalText },
	                ipAccessList.join('').replace(/[\s.,%]/g, '').length !== 0 ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "Profile.text.changeIpAccessList",
	                    values: { ipAccessList: _react2.default.createElement(
	                            "b",
	                            null,
	                            ipAccessList.join(', ')
	                        ) },
	                    defaultMessage: "\u0421\u043F\u0438\u0441\u043E\u043A \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043D\u044B\u0445 IP-\u0430\u0434\u0440\u0435\u0441\u043E\u0432 \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0441 \u0430\u0434\u0440\u0435\u0441\u043E\u0432: {ipAccessList}."
	                }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "Profile.text.changeIpAccessListClean",
	                    defaultMessage: "\u0421\u043F\u0438\u0441\u043E\u043A \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043D\u044B\u0445 IP-\u0430\u0434\u0440\u0435\u0441\u043E\u0432 \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0441\u043E \u0432\u0441\u0435\u0445 \u0430\u0434\u0440\u0435\u0441\u043E\u0432 \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439."
	                })
	            ),
	            otpCodeSend && _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.ModalText },
	                    otpText
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.ModalInputWrap },
	                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                        onChange: function onChange(name, value) {
	                            return setOTPCode(value);
	                        },
	                        value: otpCode,
	                        placeholder: "••••••",
	                        fieldName: "otpCode",
	                        label: "FieldsHelper.label.otpCode",
	                        changeRegexp: /[^0-9A-Za-z]+/g,
	                        blurRegexp: /^[0-9A-Za-z]+$/g,
	                        changeMessage: "FieldsHelper.error.onlyLettersNumbersOTPCode",
	                        blurMessage: "FieldsHelper.error.checkOTPCode",
	                        isDisabled: isLoading,
	                        autoComplete: "off",
	                        isUppercase: true
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Column },
	            _react2.default.createElement(
	                "h3",
	                { className: _stylesModule2.default.Title },
	                "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F"
	            ),
	            _react2.default.createElement(
	                "p",
	                { className: _stylesModule2.default.Text },
	                "\u041F\u0440\u0438 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0439 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u043F\u0440\u0438 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0431\u0443\u0434\u0443\u0442 \u0437\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u044B \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435."
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                _react2.default.createElement(_FieldsHelper.Select, {
	                    onChange: onSetAuthType,
	                    onCleanCurrentValue: function onCleanCurrentValue() {
	                        return onAuthAction({ isMFAEnabled: false });
	                    },
	                    values: authTypeList,
	                    selectedValue: currentAuthType,
	                    label: "FieldsHelper.label.authentication",
	                    placeholder: "FieldsHelper.label.authenticationSelect",
	                    isLoading: isLoading || currentOTPData.isMFAEnabled,
	                    isClean: currentOTPData.isMFAEnabled,
	                    isCleanLabel: "Отключить",
	                    fieldStatus: "isEnabled",
	                    fieldName: "displayName"
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                _react2.default.createElement(_FieldsHelper.MultipleField, {
	                    label: 'FieldsHelper.label.IPAccessRestriction',
	                    width: 230,
	                    placeholder: "0.0.0.0",
	                    fieldName: "ipAccessList",
	                    values: ipAccessList,
	                    onChange: function onChange(name, value) {
	                        return setIpAccessList(value);
	                    },
	                    changeRegexp: /[^0-9./]+/g,
	                    blurRegexp: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}[/]*\d{1,2}$/,
	                    changeMessage: "FieldsHelper.error.onlyIpSymbols",
	                    blurMessage: "FieldsHelper.error.checkIpSymbols",
	                    autoComplete: "off"
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Column },
	            currentAuthType && _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.InputWrap },
	                currentAuthType.id === "email" && _react2.default.createElement(
	                    _react.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "h3",
	                        { className: _stylesModule2.default.Title },
	                        "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: _stylesModule2.default.Text },
	                        "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u043D\u0430 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 email-\u0430\u0434\u0440\u0435\u0441. \u041F\u0440\u0438 \u0447\u0430\u0441\u0442\u044B\u0445 \u0437\u0430\u043F\u0440\u043E\u0441\u0430\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043F\u0430\u0434\u0430\u0442\u044C \u0432 SPAM."
	                    ),
	                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                        onChange: function onChange(name, value) {
	                            return setOTPEmail(value);
	                        },
	                        value: otpEmail,
	                        placeholder: Boolean(currentOTPData.OTPEmail) ? currentOTPData.OTPEmail : "example@email.ru",
	                        fieldName: "authEmail",
	                        label: "FieldsHelper.label.email",
	                        changeRegexp: /[^A-Za-z0-9\s_@.]+/g,
	                        blurRegexp: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	                        changeMessage: "FieldsHelper.error.charactersEmail",
	                        blurMessage: "FieldsHelper.error.checkEmail",
	                        isDisabled: isLoading,
	                        readonly: currentOTPData.isMFAEnabled,
	                        autoComplete: "off"
	                    }),
	                    !currentOTPData.isMFAEnabled && _react2.default.createElement(_Button2.default, { label: "Profile.btn.connectOTP", onClick: function onClick() {
	                            return onAuthAction({
	                                isMFAEnabled: true,
	                                OTPProvider: "email",
	                                OTPEmail: otpEmail
	                            });
	                        }, icon: "document-edit", isLoading: isLoading })
	                ),
	                currentAuthType.id === "sms" && _react2.default.createElement(
	                    _react.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "h3",
	                        { className: _stylesModule2.default.Title },
	                        "SMS \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: _stylesModule2.default.Text },
	                        "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u0432 SMS-\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0438 \u043D\u0430 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430."
	                    ),
	                    _react2.default.createElement(_FieldsHelper.InputHelper, {
	                        onChange: function onChange(name, value) {
	                            return setOTPPhoneNumber(value);
	                        },
	                        value: otpPhoneNumber,
	                        placeholder: Boolean(currentOTPData.OTPPhoneNumber) ? "+" + currentOTPData.OTPPhoneNumber : "+79175744444",
	                        fieldName: "authPhone",
	                        label: "FieldsHelper.label.phone",
	                        changeRegexp: /[^0-9+]+/g,
	                        blurRegexp: /^[+]\d+$/g,
	                        changeMessage: "FieldsHelper.error.onlyNumbersPhone",
	                        blurMessage: "FieldsHelper.error.checkPhone",
	                        isDisabled: isLoading,
	                        autoComplete: "off",
	                        readonly: currentOTPData.isMFAEnabled
	                    }),
	                    !currentOTPData.isMFAEnabled && _react2.default.createElement(_Button2.default, { label: "Profile.btn.connectOTP", onClick: function onClick() {
	                            return onAuthAction({
	                                isMFAEnabled: true,
	                                OTPProvider: "sms",
	                                OTPPhoneNumber: otpPhoneNumber
	                            });
	                        }, icon: "document-edit", isLoading: isLoading })
	                ),
	                currentAuthType.id === "gauth" && _react2.default.createElement(
	                    _react.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        "h3",
	                        { className: _stylesModule2.default.Title },
	                        "Google Authenticator"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: _stylesModule2.default.Text },
	                        "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Google Authenticator \u0438\u0437 Google Play \u0438\u043B\u0438 App Store \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0435 \u043F\u0430\u0440\u043E\u043B\u0438 \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0432 \u043D\u0435\u043C."
	                    ),
	                    isLoading ? _react2.default.createElement(_Loader2.default, null) : gAuth.qrCode && _react2.default.createElement(
	                        _react.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.GAuthWrap },
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement("img", { src: gAuth.qrCode, alt: "qrCode", title: "qrCode", width: 150,
	                                    height: 150 })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                !currentOTPData.isMFAEnabled && _react2.default.createElement(_Button2.default, { label: "Profile.btn.connectOTP",
	                                    onClick: function onClick() {
	                                        return onAuthAction({
	                                            isMFAEnabled: true,
	                                            OTPProvider: "gauth"
	                                        });
	                                    }, icon: "document-edit", isLoading: isLoading })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            "\u0421\u0435\u043A\u0440\u043A\u0442\u043D\u044B\u0439 \u043A\u043E\u0434"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            gAuth.secret
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = Security;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(2);
	
	var _TabBarItem = __webpack_require__(186);
	
	var _TabBarItem2 = _interopRequireDefault(_TabBarItem);
	
	var _HTabBar = __webpack_require__(187);
	
	var _HTabBar2 = _interopRequireDefault(_HTabBar);
	
	var _General = __webpack_require__(496);
	
	var _General2 = _interopRequireDefault(_General);
	
	var _Security = __webpack_require__(497);
	
	var _Security2 = _interopRequireDefault(_Security);
	
	var _stylesModule = __webpack_require__(112);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _Logo = __webpack_require__(172);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Profile = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token,
	        logout = _ref.logout,
	        forcedPasswordChange = _ref.forcedPasswordChange,
	        requires2FASetup = _ref.requires2FASetup,
	        clear2FASetupFlag = _ref.clear2FASetupFlag,
	        authorize = _ref.authorize,
	        isRemember = _ref.isRemember;
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        _onMessage = _useContext.onMessage;
	
	    // Определяем режим ограниченного доступа (смена пароля или настройка 2FA)
	
	
	    var isRestrictedMode = forcedPasswordChange || requires2FASetup;
	    // Определяем нужно ли показывать только Security вкладку (только 2FA без смены пароля)
	    var showOnlySecurity = requires2FASetup && !forcedPasswordChange;
	
	    var content = _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        requires2FASetup && !forcedPasswordChange && _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.WarningBanner },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'Profile.warning.requires2FASetup',
	                defaultMessage: 'Для продолжения работы необходимо настроить двухфакторную аутентификацию'
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _stylesModule2.default.Card },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.CardHeader },
	                _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Profile.title.myProfile', defaultMessage: 'no translate' })
	                )
	            ),
	            _react2.default.createElement(
	                _HTabBar2.default,
	                { defaultActiveTab: showOnlySecurity ? 1 : 0 },
	                _react2.default.createElement(
	                    _TabBarItem2.default,
	                    { label: "\u041E\u0431\u0449\u0438\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438", isVisible: !showOnlySecurity },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(_General2.default, { token: token, logout: logout,
	                            forcedPasswordChange: forcedPasswordChange,
	                            onMessage: function onMessage(val) {
	                                return _onMessage(val);
	                            } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _TabBarItem2.default,
	                    { label: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
	                        isVisible: !forcedPasswordChange || showOnlySecurity },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(_Security2.default, {
	                            token: token,
	                            logout: logout,
	                            forcedPasswordChange: forcedPasswordChange,
	                            requires2FASetup: requires2FASetup,
	                            clear2FASetupFlag: clear2FASetupFlag,
	                            authorize: authorize,
	                            isRemember: isRemember,
	                            onMessage: function onMessage(val) {
	                                return _onMessage(val);
	                            }
	                        })
	                    )
	                )
	            )
	        )
	    );
	
	    if (isRestrictedMode) {
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: "d-flex justify-content-between align-items-center px-4 py-3",
	                    style: { background: 'rgb(21, 42, 68)' } },
	                _react2.default.createElement(_Logo2.default, null),
	                _react2.default.createElement(
	                    "button",
	                    { onClick: logout, className: "btn btn-outline-light btn-sm" },
	                    "\u0412\u044B\u0439\u0442\u0438"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "mx-auto", style: { maxWidth: '800px', padding: '0 15px' } },
	                _react2.default.createElement(
	                    _Layout.Container,
	                    { style: { paddingTop: "1.25rem" } },
	                    _react2.default.createElement(
	                        _Layout.Column,
	                        { width: 780 },
	                        content
	                    )
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: "center" } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                content
	            )
	        )
	    );
	});
	
	exports.default = Profile;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sumSections = sumSections;
	exports.projectTerminalsToBalances = projectTerminalsToBalances;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Amount = __webpack_require__(22);
	
	var _Amount2 = _interopRequireDefault(_Amount);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _VTabBar = __webpack_require__(60);
	
	var _VTabBar2 = _interopRequireDefault(_VTabBar);
	
	var _TabBarItem = __webpack_require__(96);
	
	var _TabBarItem2 = _interopRequireDefault(_TabBarItem);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(642);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatBalance(value) {
	    if (value === null || value === undefined) return "0,00";
	    return Number(value).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
	
	/** Строка терминала с раскрытием комиссий */
	/**
	 * Суммирует балансы терминалов проекта по режимам.
	 *
	 * Приём и выплаты складываются раздельно — они несовместимы по смыслу.
	 *
	 * Главное: деньги общего счёта провайдера входят в сумму ОДИН раз. У части
	 * провайдеров счёт один на точку входа, а терминалов у нас на неё несколько:
	 * каждый показывает остаток целиком и показывает верно, но сложение придумывает
	 * деньги, которых нет. Бэкенд помечает такие строки полем sharedBalanceGroup —
	 * одинаковое значение означает одни и те же деньги. 10.09.2026 боевой кабинет
	 * PAG показал «доступно для выплат 1 190 354,51 ₽» вместо 796 555,36 ₽.
	 *
	 * Общие у связок ТОЛЬКО деньги. Оборот и «в обработке» у каждой свои,
	 * настоящие, и складываются как обычно: первая версия правки пропускала у
	 * повторной связки все три числа и потеряла оборот целого терминала.
	 *
	 * Из группы берётся самый осторожный остаток: наименьший остаток счёта минус
	 * все резервы группы. Остатки связок одного счёта на секунды расходятся, и
	 * завышать «доступно для выплат» нельзя — мерчант на эти деньги рассчитывает.
	 */
	function sumSections(projectBalances) {
	    var sections = {
	        payin: { transactionBalance: 0, settlementBalance: 0, actualBalance: 0, count: 0, labels: null, hints: null },
	        payout: { transactionBalance: 0, settlementBalance: 0, actualBalance: 0, count: 0, labels: null, hints: null }
	    };
	    var groups = {};
	
	    for (var i = 0; i < projectBalances.length; i++) {
	        var b = projectBalances[i];
	        var key = b.mode === 'payout' || b.isCrm ? 'payout' : 'payin';
	        var turnover = b.transactionBalance || 0;
	        var reserve = b.settlementBalance || 0;
	        var actual = b.actualBalance || 0;
	
	        // Собственные числа связки — всегда как есть.
	        sections[key].transactionBalance += turnover;
	        sections[key].settlementBalance += reserve;
	
	        var group = b.sharedBalanceGroup ? key + '|' + b.sharedBalanceGroup : null;
	        if (group === null) {
	            sections[key].actualBalance += actual;
	        } else {
	            var raw = actual + reserve;
	            if (!groups[group]) {
	                groups[group] = { raw: raw, reserve: reserve, counted: actual };
	                sections[key].actualBalance += actual;
	            } else {
	                var g = groups[group];
	                g.raw = Math.min(g.raw, raw);
	                g.reserve += reserve;
	                var groupActual = g.raw - g.reserve;
	                sections[key].actualBalance += groupActual - g.counted;
	                g.counted = groupActual;
	            }
	        }
	
	        // Терминал в счётчике учитывается всегда: он у мерчанта есть,
	        // даже если его деньги уже посчитаны соседней строкой.
	        sections[key].count++;
	        if (b.labels && !sections[key].labels) sections[key].labels = b.labels;
	        if (b.hints && !sections[key].hints) sections[key].hints = b.hints;
	    }
	
	    return sections;
	}
	
	/**
	 * Администратор может открыть любой проект, хотя /merchant/balances возвращает
	 * только проекты, явно привязанные к его аккаунту. В таком случае используем
	 * те же рассчитанные поля из /merchant/{uuid}, а не показываем нули и оборот
	 * выплаты вместо доступного остатка.
	 */
	function projectTerminalsToBalances(terminals) {
	    return (terminals || []).map(function (terminal) {
	        return {
	            terminal_id: terminal.terminalId,
	            terminal_name: terminal.terminalName || terminal.name,
	            mode: terminal.mode,
	            isCrm: terminal.isCrm,
	            labels: terminal.labels,
	            hints: terminal.hints,
	            transactionBalance: Math.round(Number(terminal.transactionBalance || 0) * 100),
	            settlementBalance: Math.round(Number(terminal.settlementBalance || 0) * 100),
	            actualBalance: Math.round(Number(terminal.actualBalance || 0) * 100),
	            transactionBalanceFloat: Number(terminal.transactionBalance || 0),
	            settlementBalanceFloat: Number(terminal.settlementBalance || 0),
	            actualBalanceFloat: Number(terminal.actualBalance || 0),
	            sharedBalanceGroup: terminal.sharedBalanceGroup || null
	        };
	    });
	}
	
	function TerminalRow(_ref) {
	    var data = _ref.data,
	        balanceData = _ref.balanceData,
	        sharedWith = _ref.sharedWith;
	
	    var _s = (0, _react.useState)(false);
	    var isOpened = _s[0];
	    var setIsOpened = _s[1];
	
	    var hasPaymentFee = data.fee && data.fee.payment;
	    var hasPayoutFee = data.fee && data.fee.payout;
	    var hasFees = hasPaymentFee || hasPayoutFee;
	
	    return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement("tr", {
	        className: _stylesModule2.default.TableRow,
	        onClick: function onClick() {
	            if (hasFees || balanceData) setIsOpened(!isOpened);
	        }
	    }, _react2.default.createElement("td", null, data.name + (data.terminalId ? " (ID: " + data.terminalId + ")" : "")), _react2.default.createElement("td", null, data.enabled ? _react2.default.createElement("span", { className: _stylesModule2.default.Enabled }, "Активен") : _react2.default.createElement("span", { className: _stylesModule2.default.Disabled }, "Заблокирован")), _react2.default.createElement("td", null, balanceData ? _react2.default.createElement(_react.Fragment, null, formatBalance(balanceData.actualBalanceFloat) + " \u20BD",
	    // У части провайдеров счёт один на несколько наших
	    // терминалов: они показывают ОДНИ И ТЕ ЖЕ деньги.
	    // Без подписи это выглядит как удвоенный остаток, а
	    // в итог такая сумма входит один раз.
	    sharedWith && sharedWith.length > 0 ? _react2.default.createElement("span", {
	        className: _stylesModule2.default.SharedBalanceNote,
	        title: "Общий счёт провайдера с терминалом " + (sharedWith.length > 1 ? "ами " : "") + sharedWith.join(", ") + ". Это одни и те же деньги, в итог они входят один раз."
	    }, " общий счёт") : null) : data.balance && data.balance.confirmed !== undefined ? _react2.default.createElement(_Amount2.default, { amount: data.balance.confirmed, currency: data.currency }) : "\u2014"), _react2.default.createElement("td", null, data.currency || "\u2014"), _react2.default.createElement("td", null, hasFees || balanceData ? _react2.default.createElement(_Icon2.default, {
	        className: _stylesModule2.default.ChevronIcon,
	        icon: isOpened ? "cheveron-up" : "cheveron-down",
	        size: "18px"
	    }) : null)), isOpened ? _react2.default.createElement("tr", null, _react2.default.createElement("td", { colSpan: 5, style: { padding: 0 } },
	    // Три баланса
	    balanceData ? _react2.default.createElement("div", { className: _stylesModule2.default.TerminalBalanceDetail }, _react2.default.createElement("div", { className: _stylesModule2.default.TerminalBalanceItem }, _react2.default.createElement("span", { className: _stylesModule2.default.TerminalBalanceItemLabel, title: balanceData.hints ? balanceData.hints.transactionBalance : "" }, balanceData.labels ? balanceData.labels.transactionBalance : "Оборот", balanceData.hints ? _react2.default.createElement("span", { style: { cursor: "help", opacity: 0.5, marginLeft: 4 } }, "ℹ") : null), _react2.default.createElement("span", {
	        className: _stylesModule2.default.TerminalBalanceItemValue,
	        style: { color: "#35C98E" }
	    }, formatBalance(balanceData.transactionBalanceFloat) + " \u20BD")), _react2.default.createElement("div", { className: _stylesModule2.default.TerminalBalanceItem }, _react2.default.createElement("span", { className: _stylesModule2.default.TerminalBalanceItemLabel, title: balanceData.hints ? balanceData.hints.settlementBalance : "" }, balanceData.labels ? balanceData.labels.settlementBalance : "Выведено", balanceData.hints ? _react2.default.createElement("span", { style: { cursor: "help", opacity: 0.5, marginLeft: 4 } }, "ℹ") : null), _react2.default.createElement("span", {
	        className: _stylesModule2.default.TerminalBalanceItemValue,
	        style: { color: "#2479E0" }
	    }, formatBalance(balanceData.settlementBalanceFloat) + " \u20BD")), _react2.default.createElement("div", { className: _stylesModule2.default.TerminalBalanceItem }, _react2.default.createElement("span", { className: _stylesModule2.default.TerminalBalanceItemLabel, title: balanceData.hints ? balanceData.hints.actualBalance : "" }, balanceData.labels ? balanceData.labels.actualBalance : "Доступно к выводу", balanceData.hints ? _react2.default.createElement("span", { style: { cursor: "help", opacity: 0.5, marginLeft: 4 } }, "ℹ") : null), _react2.default.createElement("span", {
	        className: _stylesModule2.default.TerminalBalanceItemValue,
	        style: { color: "#E8A317" }
	    }, formatBalance(balanceData.actualBalanceFloat) + " \u20BD"))) : null,
	    // Комиссии
	    hasFees ? _react2.default.createElement("div", { style: { padding: "12px 20px" } }, _react2.default.createElement(_VTabBar2.default, null, hasPaymentFee ? _react2.default.createElement(_TabBarItem2.default, {
	        label: "Платежи",
	        navIcon: "percent",
	        navIconSize: 16,
	        isVisible: true
	    }, _react2.default.createElement("table", { className: _stylesModule2.default.FeeTable }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.fixed",
	        defaultMessage: "Комиссия за операцию:"
	    })), _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.fixedValue",
	        defaultMessage: "фикс. {value}",
	        values: { value: data.fee.payment.fixedPerTransaction }
	    }))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.percent",
	        defaultMessage: "Процент:"
	    })), _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.percentValue",
	        defaultMessage: "{percent}% (\u043C\u0438\u043D\u0438\u043C\u0443\u043C {min}\u0440)",
	        values: {
	            percent: data.fee.payment.cost,
	            min: data.fee.payment.costFixedMinimum
	        }
	    })))))) : null, hasPayoutFee ? _react2.default.createElement(_TabBarItem2.default, {
	        label: "Выплаты",
	        navIcon: "wallet",
	        navIconSize: 16,
	        isVisible: true
	    }, _react2.default.createElement("table", { className: _stylesModule2.default.FeeTable }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.fixed",
	        defaultMessage: "Комиссия за операцию:"
	    })), _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.fixedValue",
	        defaultMessage: "фикс. {value}",
	        values: { value: data.fee.payout.fixedPerTransaction }
	    }))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.percent",
	        defaultMessage: "Процент:"
	    })), _react2.default.createElement("td", null, _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "TerminalsTable.fee.percentValue",
	        defaultMessage: "{percent}% (\u043C\u0438\u043D\u0438\u043C\u0443\u043C {min}\u0440)",
	        values: {
	            percent: data.fee.payout.cost,
	            min: data.fee.payout.costFixedMinimum
	        }
	    })))))) : null)) : null)) : null);
	}
	
	var ProjectSettings = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	    var uuid = (0, _reactRouterDom.useParams)().uuid;
	
	    var _project = (0, _react.useState)(null);
	    var project = _project[0];
	    var setProject = _project[1];
	
	    var _balances = (0, _react.useState)(null);
	    var balances = _balances[0];
	    var setBalances = _balances[1];
	
	    var _loading = (0, _react.useState)(true);
	    var isLoading = _loading[0];
	    var setIsLoading = _loading[1];
	
	    (0, _react.useEffect)(function () {
	        setIsLoading(true);
	        var api = new _Api2.default({ token: token });
	
	        Promise.all([api.getProjectData(uuid), api.getMerchantBalances()]).then(function (results) {
	            setProject(results[0]);
	
	            // Фильтруем балансы только по этому проекту
	            var allBalances = results[1];
	            if (allBalances && allBalances.balances) {
	                var buildSection = function buildSection(s) {
	                    if (s.count === 0) return null;
	                    return {
	                        count: s.count,
	                        transactionBalance: s.transactionBalance,
	                        settlementBalance: s.settlementBalance,
	                        actualBalance: s.actualBalance,
	                        transactionBalanceFloat: Math.round(s.transactionBalance / 100 * 100) / 100,
	                        settlementBalanceFloat: Math.round(s.settlementBalance / 100 * 100) / 100,
	                        actualBalanceFloat: Math.round(s.actualBalance / 100 * 100) / 100,
	                        labels: s.labels,
	                        hints: s.hints
	                    };
	                };
	
	                var projectBalances = allBalances.balances.filter(function (b) {
	                    return b.merchant_uuid === uuid;
	                });
	
	                if (projectBalances.length === 0 && results[0] && results[0].terminals) {
	                    projectBalances = projectTerminalsToBalances(results[0].terminals);
	                }
	
	                var sections = sumSections(projectBalances);
	
	                var payinT = buildSection(sections.payin);
	                var payoutT = buildSection(sections.payout);
	                var isMixed = !!(payinT && payoutT);
	                var legacy = payinT || payoutT || {
	                    transactionBalanceFloat: 0, settlementBalanceFloat: 0, actualBalanceFloat: 0,
	                    labels: null, hints: null
	                };
	
	                var totals = {
	                    mode: isMixed ? 'mixed' : payoutT ? 'payout' : 'payin',
	                    hasCrm: !!payoutT,
	                    hasMixed: isMixed,
	                    payin: payinT,
	                    payout: payoutT,
	                    transactionBalanceFloat: legacy.transactionBalanceFloat,
	                    settlementBalanceFloat: legacy.settlementBalanceFloat,
	                    actualBalanceFloat: legacy.actualBalanceFloat,
	                    labels: legacy.labels,
	                    hints: legacy.hints
	                };
	                setBalances({ balances: projectBalances, totals: totals });
	            }
	            setIsLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setIsLoading(false);
	        });
	    }, [uuid, token]);
	
	    if (isLoading || !project) {
	        return _react2.default.createElement(_Layout.Wrapper, null, _react2.default.createElement(_Layout.Container, { style: { justifyContent: 'center' } }, _react2.default.createElement(_Layout.Column, { width: '100%' }, _react2.default.createElement(_Loader2.default, null))));
	    }
	
	    var info = project.info || {};
	    var terminals = project.terminals || [];
	    var hasTotals = balances && balances.totals;
	    var totals = hasTotals ? balances.totals : null;
	
	    // Маппинг terminal_id → balanceData для сопоставления терминалов
	    var balanceByTerminalId = {};
	    var balanceByTerminalName = {};
	    // Кто с кем делит счёт провайдера: ключ sharedBalanceGroup → список наших
	    // терминалов. Нужен, чтобы подписать одинаковые суммы в таблице.
	    var terminalsBySharedGroup = {};
	    if (balances && balances.balances) {
	        for (var i = 0; i < balances.balances.length; i++) {
	            var b = balances.balances[i];
	            if (b.terminal_id) {
	                balanceByTerminalId[b.terminal_id] = b;
	            }
	            if (b.terminal_name) {
	                balanceByTerminalName[b.terminal_name] = b;
	            }
	            if (b.sharedBalanceGroup && b.terminal_id) {
	                if (!terminalsBySharedGroup[b.sharedBalanceGroup]) {
	                    terminalsBySharedGroup[b.sharedBalanceGroup] = [];
	                }
	                terminalsBySharedGroup[b.sharedBalanceGroup].push(b.terminal_id);
	            }
	        }
	    }
	
	    function sharedWithFor(balanceData) {
	        if (!balanceData || !balanceData.sharedBalanceGroup) return [];
	        var group = terminalsBySharedGroup[balanceData.sharedBalanceGroup] || [];
	        return group.filter(function (id) {
	            return id !== balanceData.terminal_id;
	        });
	    }
	
	    return _react2.default.createElement(_Layout.Wrapper, null, _react2.default.createElement(_Layout.Container, { style: { justifyContent: 'center' } }, _react2.default.createElement(_Layout.Column, { width: '100%' },
	
	    // === Project Header ===
	    _react2.default.createElement("div", { className: _stylesModule2.default.ProjectHeader }, _react2.default.createElement("span", { className: _stylesModule2.default.ProjectName }, info.name), _react2.default.createElement("span", {
	        className: info.status === 1 ? _stylesModule2.default.StatusActive : _stylesModule2.default.StatusBlocked
	    }, info.status === 1 ? "Активен" : "Заблокирован"), info.url ? _react2.default.createElement(_react.Fragment, null, _react2.default.createElement("span", { className: _stylesModule2.default.HeaderSep }), _react2.default.createElement("a", {
	        href: info.url,
	        target: "_blank",
	        rel: "noopener noreferrer",
	        className: _stylesModule2.default.HeaderUrl
	    }, info.url)) : null),
	
	    // === Balance Cards ===
	    hasTotals ? function () {
	        function renderSection(section, title) {
	            var labels = section && section.labels || {};
	            var hints = section && section.hints || {};
	            var rowChildren = [_react2.default.createElement("div", { key: "t", className: _stylesModule2.default.BalanceCard, title: hints.transactionBalance || "" }, _react2.default.createElement("div", { className: _stylesModule2.default.BalanceLabel + " " + _stylesModule2.default.TransactionLabel }, labels.transactionBalance || "Оборот"), _react2.default.createElement("div", { className: _stylesModule2.default.BalanceValue + " " + _stylesModule2.default.TransactionValue }, formatBalance(section.transactionBalanceFloat) + " \u20BD")), _react2.default.createElement("div", { key: "s", className: _stylesModule2.default.BalanceCard, title: hints.settlementBalance || "" }, _react2.default.createElement("div", { className: _stylesModule2.default.BalanceLabel + " " + _stylesModule2.default.SettlementLabel }, labels.settlementBalance || "Выведено"), _react2.default.createElement("div", { className: _stylesModule2.default.BalanceValue + " " + _stylesModule2.default.SettlementValue }, formatBalance(section.settlementBalanceFloat) + " \u20BD")), _react2.default.createElement("div", { key: "a", className: _stylesModule2.default.BalanceCard, title: hints.actualBalance || "" }, _react2.default.createElement("div", { className: _stylesModule2.default.BalanceLabel + " " + _stylesModule2.default.ActualLabel }, labels.actualBalance || "Доступно к выводу"), _react2.default.createElement("div", { className: _stylesModule2.default.BalanceValue + " " + _stylesModule2.default.ActualValue }, formatBalance(section.actualBalanceFloat) + " \u20BD"))];
	            var block = _react2.default.createElement("div", { className: _stylesModule2.default.BalanceRow }, rowChildren);
	            if (!title) return block;
	            return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement("div", { style: { fontWeight: 600, fontSize: 13, color: "#555", margin: "8px 0 4px" } }, title), block);
	        }
	        if (totals.hasMixed && totals.payin && totals.payout) {
	            return _react2.default.createElement(_react.Fragment, null, renderSection(totals.payin, "Приём платежей"), renderSection(totals.payout, "Выплаты"));
	        }
	        if (totals.payout && !totals.payin) return renderSection(totals.payout);
	        if (totals.payin && !totals.payout) return renderSection(totals.payin);
	        return renderSection(totals);
	    }() : _react2.default.createElement("div", { className: _stylesModule2.default.BalanceRow }, _react2.default.createElement("div", { className: _stylesModule2.default.BalanceCard }, _react2.default.createElement("div", { className: _stylesModule2.default.BalanceLabel + " " + _stylesModule2.default.TransactionLabel }, "Баланс"), _react2.default.createElement("div", { className: _stylesModule2.default.BalanceValue + " " + _stylesModule2.default.TransactionValue }, formatBalance(project.balance) + " \u20BD"))),
	
	    // === Project Info ===
	    _react2.default.createElement("div", { className: _stylesModule2.default.Card }, _react2.default.createElement("div", { className: _stylesModule2.default.CardHeader }, _react2.default.createElement("h5", { className: _stylesModule2.default.CardTitle }, "Информация о проекте")), _react2.default.createElement("div", { className: _stylesModule2.default.CardBody }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoGrid }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoItem }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemLabel }, "ID проекта"), _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemValue }, uuid)), info.name ? _react2.default.createElement("div", { className: _stylesModule2.default.InfoItem }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemLabel }, "Название"), _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemValue }, info.name)) : null, info.inn ? _react2.default.createElement("div", { className: _stylesModule2.default.InfoItem }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemLabel }, "ИНН"), _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemValue }, info.inn)) : null, info.description ? _react2.default.createElement("div", { className: _stylesModule2.default.InfoItem }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemLabel }, "Описание"), _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemValue }, info.description)) : null, info.url ? _react2.default.createElement("div", { className: _stylesModule2.default.InfoItem }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemLabel }, "Сайт"), _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemValue }, _react2.default.createElement("a", {
	        href: info.url,
	        target: "_blank",
	        rel: "noopener noreferrer",
	        className: _stylesModule2.default.HeaderUrl
	    }, info.url))) : null, info.createdAt ? _react2.default.createElement("div", { className: _stylesModule2.default.InfoItem }, _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemLabel }, "Дата создания"), _react2.default.createElement("div", { className: _stylesModule2.default.InfoItemValue }, info.createdAt)) : null))),
	
	    // === Terminals ===
	    _react2.default.createElement("div", { className: _stylesModule2.default.Card }, _react2.default.createElement("div", { className: _stylesModule2.default.CardHeader }, _react2.default.createElement("h5", { className: _stylesModule2.default.CardTitle }, "Терминалы")), terminals.length > 0 ? _react2.default.createElement("div", { className: _stylesModule2.default.TableWrap }, _react2.default.createElement("table", { className: _stylesModule2.default.Table }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "Название"), _react2.default.createElement("th", null, "Статус"), _react2.default.createElement("th", null, "Баланс"), _react2.default.createElement("th", null, "Валюта"), _react2.default.createElement("th", null))), _react2.default.createElement("tbody", null, terminals.map(function (t) {
	        // Сопоставляем балансы: сначала по terminal_id, потом по имени
	        var bd = null;
	        if (t.terminalId && balanceByTerminalId[t.terminalId]) {
	            bd = balanceByTerminalId[t.terminalId];
	        } else if (t.terminalName && balanceByTerminalName[t.terminalName]) {
	            bd = balanceByTerminalName[t.terminalName];
	        } else if (t.name && balanceByTerminalName[t.name]) {
	            bd = balanceByTerminalName[t.name];
	        }
	        return _react2.default.createElement(TerminalRow, {
	            key: t.uuid,
	            data: t,
	            balanceData: bd,
	            sharedWith: sharedWithFor(bd)
	        });
	    })))) : _react2.default.createElement("div", { className: _stylesModule2.default.Empty }, "Нет подключённых терминалов")))));
	});
	
	exports.default = ProjectSettings;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Payouts;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectsTable = __webpack_require__(415);
	
	var _ProjectsTable2 = _interopRequireDefault(_ProjectsTable);
	
	var _Layout = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(207);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Payouts() {
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '100%' },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            "h5",
	                            { className: _stylesModule2.default.Title },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, {
	                                id: "Payouts.title",
	                                defaultMessage: "\u041F\u0440\u043E\u0435\u043A\u0442\u044B"
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.TableWrap },
	                        _react2.default.createElement(_ProjectsTable2.default, null)
	                    )
	                )
	            )
	        )
	    );
	}

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _MerchantTerminalSelect = __webpack_require__(57);
	
	var _MerchantTerminalSelect2 = _interopRequireDefault(_MerchantTerminalSelect);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(643);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Refills = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	
	    var stateEntries = (0, _react.useState)([]);
	    var entries = stateEntries[0];
	    var setEntries = stateEntries[1];
	
	    var stateLoading = (0, _react.useState)(true);
	    var loading = stateLoading[0];
	    var setLoading = stateLoading[1];
	
	    var stateSelectedMs = (0, _react.useState)("");
	    var setSelectedMs = stateSelectedMs[1];
	
	    function loadRefills(api, msId) {
	        setLoading(true);
	        var now = new Date();
	        var from = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
	        var dateFrom = from.toISOString().split('T')[0];
	        var dateTo = now.toISOString().split('T')[0];
	        api.getMerchantStatement({
	            merchant_settings_id: msId,
	            date_from: dateFrom,
	            date_to: dateTo,
	            limit: 200
	        }).then(function (r) {
	            // Filter only TOPUP(8) and SETTLEMENT_PAYOUT(3) entries
	            var filtered = (r.entries || []).filter(function (e) {
	                return e.type === 8 || e.type === 3;
	            });
	            setEntries(filtered);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setLoading(false);
	        });
	    }
	
	    function handleMsSelect(msId) {
	        setSelectedMs(msId);
	        if (msId) {
	            var api = new _Api2.default({ token: token });
	            loadRefills(api, msId);
	        }
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { style: { justifyContent: 'center' } },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: 1180 },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            "h5",
	                            { className: _stylesModule2.default.Title },
	                            "\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SelectorBlock },
	                            _react2.default.createElement(_MerchantTerminalSelect2.default, {
	                                mode: "user",
	                                token: token,
	                                stackOnMobile: true,
	                                onSelect: handleMsSelect,
	                                onDataLoaded: function onDataLoaded() {
	                                    setLoading(false);
	                                }
	                            })
	                        ),
	                        loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.TableWrap },
	                            _react2.default.createElement(
	                                "table",
	                                { className: "table table-hover" },
	                                _react2.default.createElement(
	                                    "thead",
	                                    null,
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0414\u0430\u0442\u0430"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0422\u0438\u043F"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0421\u0443\u043C\u043C\u0430"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    entries.map(function (entry) {
	                                        return _react2.default.createElement(
	                                            "tr",
	                                            { key: entry.id },
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                new Date(entry.created_at).toLocaleString('ru-RU')
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                entry.type_name
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                entry.amount_float.toFixed(2)
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                entry.balance_after_float.toFixed(2)
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                entry.description || ''
	                                            )
	                                        );
	                                    }),
	                                    entries.length === 0 && _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "td",
	                                            { colSpan: "5", className: "text-center text-muted" },
	                                            "\u041D\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0435\u0439"
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = Refills;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _RegistryTable = __webpack_require__(424);
	
	var _RegistryTable2 = _interopRequireDefault(_RegistryTable);
	
	var _RegistryControls = __webpack_require__(178);
	
	var _RegistryControls2 = _interopRequireDefault(_RegistryControls);
	
	var _RegistryUploadInfo = __webpack_require__(182);
	
	var _RegistryUploadInfo2 = _interopRequireDefault(_RegistryUploadInfo);
	
	var _RegistryDADUpload = __webpack_require__(179);
	
	var _RegistryDADUpload2 = _interopRequireDefault(_RegistryDADUpload);
	
	var _RegistryColumnsHelp = __webpack_require__(177);
	
	var _RegistryColumnsHelp2 = _interopRequireDefault(_RegistryColumnsHelp);
	
	var _RegistryInfoCard = __webpack_require__(180);
	
	var _RegistryInfoCard2 = _interopRequireDefault(_RegistryInfoCard);
	
	var _payoutMethods = __webpack_require__(192);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _Modal = __webpack_require__(19);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(5);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(644);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var RegistryUpload = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token;
	
	
	    var location = (0, _reactRouterDom.useLocation)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        projectUUID = _useState2[0],
	        setProjectUUID = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        providerUUID = _useState4[0],
	        setProviderUUID = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        selectedProject = _useState6[0],
	        setSelectedProject = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        selectedTerminal = _useState8[0],
	        setSelectedTerminal = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        initRegistry = _useState10[0],
	        setInitRegistry = _useState10[1];
	
	    var _useState11 = (0, _react.useState)([]),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filteredRegistry = _useState12[0],
	        setFilteredRegistry = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(''),
	        _useState14 = _slicedToArray(_useState13, 2),
	        initRegistryName = _useState14[0],
	        setInitRegistryName = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(''),
	        _useState16 = _slicedToArray(_useState15, 2),
	        registryName = _useState16[0],
	        setRegistryName = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0),
	        _useState18 = _slicedToArray(_useState17, 2),
	        registryAmount = _useState18[0],
	        setRegistryAmount = _useState18[1];
	
	    // Флаг предзагруженного реестра
	
	
	    var _useState19 = (0, _react.useState)(false),
	        _useState20 = _slicedToArray(_useState19, 2),
	        setIsPreloaded = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        projects = _useState22[0],
	        setProjects = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        terminals = _useState24[0],
	        setTerminals = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(0),
	        _useState26 = _slicedToArray(_useState25, 2),
	        commission = _useState26[0],
	        setCommission = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(0),
	        _useState28 = _slicedToArray(_useState27, 2),
	        errorsCount = _useState28[0],
	        setErrorsCount = _useState28[1];
	
	    var _useState29 = (0, _react.useState)([]),
	        _useState30 = _slicedToArray(_useState29, 2),
	        errorsList = _useState30[0],
	        setErrorsList = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(false),
	        _useState32 = _slicedToArray(_useState31, 2),
	        errorsFormat = _useState32[0],
	        setErrorsFormat = _useState32[1];
	    // «Похоже, это реестр СБП» — подсказка приезжает с бэкенда вместе с
	    // ошибкой формата: разбор шапки файла живёт там же, где загрузчик.
	
	
	    var _useState33 = (0, _react.useState)(null),
	        _useState34 = _slicedToArray(_useState33, 2),
	        wrongRegistryType = _useState34[0],
	        setWrongRegistryType = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(null),
	        _useState36 = _slicedToArray(_useState35, 2),
	        wrongRegistryHint = _useState36[0],
	        setWrongRegistryHint = _useState36[1];
	
	    var _useState37 = (0, _react.useState)([]),
	        _useState38 = _slicedToArray(_useState37, 2),
	        tags = _useState38[0],
	        setTags = _useState38[1];
	
	    var _useState39 = (0, _react.useState)([]),
	        _useState40 = _slicedToArray(_useState39, 2),
	        suggestionsTags = _useState40[0],
	        setSuggestionsTags = _useState40[1];
	
	    var _useState41 = (0, _react.useState)({ balance: 0, currency: "RUB" }),
	        _useState42 = _slicedToArray(_useState41, 2),
	        terminalBalance = _useState42[0],
	        setTerminalBalance = _useState42[1];
	
	    var _useState43 = (0, _react.useState)(false),
	        _useState44 = _slicedToArray(_useState43, 2),
	        loadingRegistry = _useState44[0],
	        setLoadingRegistry = _useState44[1];
	
	    var _useState45 = (0, _react.useState)(true),
	        _useState46 = _slicedToArray(_useState45, 2),
	        loadingProjects = _useState46[0],
	        setLoadingProjects = _useState46[1];
	
	    var _useState47 = (0, _react.useState)(false),
	        _useState48 = _slicedToArray(_useState47, 2),
	        loadingTerminals = _useState48[0],
	        setLoadingTerminals = _useState48[1];
	
	    var _useState49 = (0, _react.useState)(false),
	        _useState50 = _slicedToArray(_useState49, 2),
	        isRequest = _useState50[0],
	        setIsRequest = _useState50[1];
	
	    // Duplicate detection states
	
	
	    var _useState51 = (0, _react.useState)([]),
	        _useState52 = _slicedToArray(_useState51, 2),
	        duplicates = _useState52[0],
	        setDuplicates = _useState52[1];
	
	    var _useState53 = (0, _react.useState)(false),
	        _useState54 = _slicedToArray(_useState53, 2),
	        showDuplicateWarning = _useState54[0],
	        setShowDuplicateWarning = _useState54[1];
	
	    var _useState55 = (0, _react.useState)(null),
	        _useState56 = _slicedToArray(_useState55, 2),
	        pendingFile = _useState56[0],
	        setPendingFile = _useState56[1];
	
	    var _useState57 = (0, _react.useState)(null),
	        _useState58 = _slicedToArray(_useState57, 2),
	        pendingData = _useState58[0],
	        setPendingData = _useState58[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    (0, _react.useEffect)(function () {
	        setLoadingProjects(true);
	
	        new _Api2.default({ token: token }).getProjects().then(function (r) {
	            setProjects(Array.isArray(r) ? r : []);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setProjects([]);
	            onMessage({ type: "error", message: "Не удалось загрузить список проектов." });
	        }).finally(function () {
	            setLoadingProjects(false);
	        });
	    }, [token]);
	
	    // Обработка предзагруженного реестра из PayoutsDetail
	    (0, _react.useEffect)(function () {
	        if (location.state && location.state.preloadedRegistry) {
	            var preloadedData = location.state.preloadedRegistry;
	            var preloadedName = location.state.preloadedName || 'Повтор реестра';
	
	            if (Array.isArray(preloadedData) && preloadedData.length > 0) {
	                // Рассчитываем общую сумму
	                var amount = 0;
	                preloadedData.forEach(function (el) {
	                    var v = el && el.row ? el.row.amount : 0;
	                    amount += Number(v) || 0;
	                });
	
	                setInitRegistry(preloadedData);
	                setFilteredRegistry(preloadedData);
	                setInitRegistryName(preloadedName);
	                setRegistryName(preloadedName);
	                setRegistryAmount(amount);
	                setLoadingRegistry(true);
	                setIsPreloaded(true);
	
	                onMessage({
	                    type: "info",
	                    message: "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D \u0440\u0435\u0435\u0441\u0442\u0440 \"" + preloadedName + "\" \u0441 " + preloadedData.length + " \u0437\u0430\u043F\u0438\u0441\u044F\u043C\u0438 \u0434\u043B\u044F \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0439 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438."
	                });
	            }
	
	            // Очищаем state чтобы при обновлении страницы не загружался снова
	            window.history.replaceState({}, document.title);
	        }
	    }, [location.state]);
	
	    var processing = selectedTerminal ? selectedTerminal.processing : null;
	
	    (0, _react.useEffect)(function () {
	        if (!selectedTerminal || !Array.isArray(initRegistry) || initRegistry.length === 0) return;
	
	        var next = applyFinStarDocValidation(initRegistry, processing);
	        setInitRegistry(next);
	
	        if (Array.isArray(filteredRegistry) && filteredRegistry.length > 0) {
	            setFilteredRegistry(applyFinStarDocValidation(filteredRegistry, processing));
	        }
	    }, [processing]);
	
	    function calcCommission(rows, payoutFee) {
	        // rows: массив строк реестра (data.data)
	        if (!Array.isArray(rows) || rows.length === 0) {
	            setCommission(0);
	            return;
	        }
	
	        // payoutFee: объект terminal.fee.payout
	        if (!payoutFee || (typeof payoutFee === "undefined" ? "undefined" : _typeof(payoutFee)) !== "object") {
	            setCommission(0);
	            return;
	        }
	
	        var cost = Number(payoutFee.cost != null ? payoutFee.cost : 0); // %
	        var min = Number(payoutFee.costFixedMinimum != null ? payoutFee.costFixedMinimum : 0);
	        var fixed = Number(payoutFee.fixedPerTransaction != null ? payoutFee.fixedPerTransaction : 0);
	
	        var total = 0;
	
	        rows.forEach(function (el) {
	            var amountRaw = el && el.row ? el.row.amount : 0;
	            var a = Number(amountRaw);
	
	            if (!isFinite(a) || a <= 0) return;
	
	            var pct = a * (cost / 100);
	            total += (pct < min ? min : pct) + fixed;
	        });
	
	        setCommission(total);
	    }
	
	    function isEmptyValue(v) {
	        return v === null || v === undefined || String(v).trim() === "";
	    }
	
	    function addFieldError(errors, fieldKey, message) {
	        if (!errors) {
	            return _defineProperty({}, fieldKey, message);
	        }
	
	        // Если уже объект — пишем по ключу поля (лучше для подсветки ячейки)
	        if (!Array.isArray(errors) && (typeof errors === "undefined" ? "undefined" : _typeof(errors)) === "object") {
	            if (!errors[fieldKey]) {
	                return Object.assign({}, errors, _defineProperty({}, fieldKey, message));
	            }
	            return errors;
	        }
	
	        // Если массив — добавляем строку (не ломаем существующую логику)
	        if (Array.isArray(errors)) {
	            if (errors.includes(message)) return errors;
	            return [].concat(_toConsumableArray(errors), [message]);
	        }
	
	        // fallback
	        return _defineProperty({}, fieldKey, message);
	    }
	
	    function applyFinStarDocValidation(rows, processing) {
	        var isFinStar = String(processing || "").toLowerCase() === "finstar";
	        if (!isFinStar || !Array.isArray(rows)) return rows;
	
	        return rows.map(function (el) {
	            var row = el && el.row ? el.row : {};
	            var hasError = Boolean(el && el.hasError);
	            var errors = el ? el.errors : undefined;
	
	            if (isEmptyValue(row.documentNumber)) {
	                hasError = true;
	                errors = addFieldError(errors, "documentNumber", "Номер документа обязателен для FinStar.");
	            }
	            if (isEmptyValue(row.documentDate)) {
	                hasError = true;
	                errors = addFieldError(errors, "documentDate", "Дата документа обязательна для FinStar.");
	            }
	
	            return Object.assign({}, el, { row: row, hasError: hasError, errors: errors });
	        });
	    }
	
	    function onChangeRegistryName(value) {
	        setRegistryName(value.replace(/[^A-Za-zА-Яа-я0-9\s-_!?=.]+/g, ''));
	    }
	
	    function onSelectProject(project) {
	        setProjectUUID(project.uuid);
	        setSelectedTerminal(null);
	        setProviderUUID(null);
	        setSelectedProject(project);
	        setLoadingTerminals(true);
	
	        if (project.uuid) {
	            new _Api2.default({ token: token }).getTags(project.uuid).then(function (r) {
	                setSuggestionsTags(r);
	            });
	        }
	
	        new _Api2.default({ token: token }).getProjectData(project.uuid).then(function (r) {
	            // Только терминалы, умеющие выплату на карту. СБП-терминал
	            // здесь показывать нельзя: файл с картами уедет в отказ на
	            // банке получателя, а страница до этого попросит у мерчанта
	            // номера карт там, где через терминал платят по телефону.
	            // Фильтруем ДО проверки «терминал единственный», иначе у
	            // мерчанта с обоими терминалами подставится не тот.
	            var usableTerminals = (0, _payoutMethods.filterTerminalsByMethod)(r.terminals, _payoutMethods.PAYOUT_METHOD_CARD);
	
	            if (usableTerminals.length === 1) {
	                var t = usableTerminals[0];
	
	                setTerminalBalance({ balance: t.balance.confirmed, currency: t.currency });
	                setProviderUUID(t.uuid);
	                setSelectedTerminal(t);
	
	                if (Array.isArray(initRegistry) && initRegistry.length > 0) {
	                    var payoutFee = t && t.fee ? t.fee.payout : null;
	                    calcCommission(initRegistry, payoutFee);
	                } else {
	                    setCommission(0);
	                }
	            } else {
	                setCommission(0);
	            }
	
	            setTerminals(usableTerminals);
	            setLoadingTerminals(false);
	        });
	    }
	
	    function onSelectTerminal(terminal) {
	        setSelectedTerminal(terminal);
	        setProviderUUID(terminal.uuid);
	        setTerminalBalance({ balance: terminal.balance.confirmed, currency: terminal.currency });
	
	        if (Array.isArray(initRegistry) && initRegistry.length > 0) {
	            var payoutFee = terminal && terminal.fee ? terminal.fee.payout : null;
	            calcCommission(initRegistry, payoutFee);
	        } else {
	            setCommission(0);
	        }
	    }
	
	    function onSelectedTag(tags) {
	        setTags(tags);
	    }
	
	    function setFilterErrors(val) {
	
	        if (val) {
	            var filteredData = initRegistry.filter(function (e) {
	                return e.hasError;
	            });
	
	            setFilteredRegistry(filteredData);
	        } else {
	            setFilteredRegistry([]);
	        }
	    }
	
	    function submitRegistry() {
	
	        if (!providerUUID || !projectUUID) {
	            onMessage({ type: 'warning', message: 'Для отправки реестра выберите терминал.' });
	            return false;
	        }
	
	        setIsRequest(true);
	
	        var registry = [];
	        var name = void 0;
	
	        initRegistry.forEach(function (item) {
	            registry.push(item.row);
	        });
	
	        if (registryName) {
	            name = registryName;
	        } else {
	            name = initRegistryName;
	        }
	
	        new _Api2.default({ token: token }).registryProcess({ registry: registry, tags: tags, name: name, providerUUID: providerUUID }, projectUUID).then(function (r) {
	            if (r.result === "ok") {
	                clearRegistry();
	                setIsRequest(false);
	                onMessage({ type: "success", message: "Реестр отправлен в очередь выплат." });
	            } else {
	                onMessage({ type: "error", message: +('code: ' + r.code) });
	                setLoadingRegistry(false);
	            }
	        });
	    }
	
	    function clearRegistry() {
	        setInitRegistry([]);
	        setFilteredRegistry([]);
	        setLoadingRegistry(false);
	        setRegistryAmount(0);
	        setCommission(0);
	        setRegistryName('');
	        setInitRegistryName('');
	    }
	
	    // Process uploaded data (extracted for reuse after duplicate confirmation)
	    function processUploadedData(file, data) {
	        var cleanName = file.name.replace(/[^A-Za-zА-Яа-я0-9\s-_!?=.]|\.xlsx+/g, '');
	        setInitRegistryName(cleanName);
	        setRegistryName(cleanName);
	
	        var rows = data && Array.isArray(data.data) ? data.data : [];
	
	        // ВАЖНО: применяем требование FinStar сразу
	        rows = applyFinStarDocValidation(rows, selectedTerminal ? selectedTerminal.processing : null);
	
	        if (rows.length > 0) {
	            var amount = 0;
	
	            rows.forEach(function (el) {
	                var v = el && el.row ? el.row.amount : 0;
	                amount += Number(v) || 0;
	            });
	
	            setRegistryAmount(amount);
	            setInitRegistry(rows);
	            setFilteredRegistry(rows);
	            setLoadingRegistry(true);
	
	            var payoutFee = selectedTerminal && selectedTerminal.fee ? selectedTerminal.fee.payout : null;
	            calcCommission(rows, payoutFee);
	        } else {
	            setLoadingRegistry(false);
	            setRegistryAmount(0);
	            setInitRegistry([]);
	            setFilteredRegistry([]);
	            setCommission(0);
	        }
	
	        if (data && data.errors) {
	            if (data.errors.count) {
	                setErrorsCount(data.errors.count);
	                setErrorsList(data.errors);
	            } else {
	                setErrorsCount(0);
	            }
	
	            if (data.errors.formatError) {
	                setErrorsFormat(true);
	            }
	
	            setWrongRegistryType(data.errors.wrongRegistryType || null);
	            setWrongRegistryHint(data.errors.wrongRegistryHint || null);
	        } else {
	            setWrongRegistryType(null);
	            setWrongRegistryHint(null);
	        }
	    }
	
	    function onRegistryUpload(file, data) {
	        // Check for duplicates
	        if (data && data.duplicates && Array.isArray(data.duplicates) && data.duplicates.length > 0) {
	            setDuplicates(data.duplicates);
	            setPendingFile(file);
	            setPendingData(data);
	            setShowDuplicateWarning(true);
	            return;
	        }
	
	        // No duplicates - process immediately
	        processUploadedData(file, data);
	    }
	
	    function handleConfirmDuplicate() {
	        setShowDuplicateWarning(false);
	        if (pendingFile && pendingData) {
	            processUploadedData(pendingFile, pendingData);
	        }
	        setDuplicates([]);
	        setPendingFile(null);
	        setPendingData(null);
	    }
	
	    function handleCancelDuplicate() {
	        setShowDuplicateWarning(false);
	        setDuplicates([]);
	        setPendingFile(null);
	        setPendingData(null);
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Context2.default.Provider,
	            { value: {
	                    setFilterErrors: setFilterErrors,
	                    onSelectedTag: onSelectedTag,
	                    onChangeRegistryName: onChangeRegistryName,
	                    submitRegistry: submitRegistry,
	                    clearRegistry: clearRegistry
	                } },
	            _react2.default.createElement(
	                _Layout.Container,
	                { className: _stylesModule2.default.StackOnMobile },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "780", className: _stylesModule2.default.MainColumn },
	                    loadingRegistry ? _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Card },
	                        _react2.default.createElement(_RegistryTable2.default, {
	                            data: filteredRegistry.length > 0 ? filteredRegistry : initRegistry,
	                            processing: selectedTerminal ? selectedTerminal.processing : null
	                        })
	                    ) : _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(_RegistryDADUpload2.default, { token: token, onRegistryUpload: onRegistryUpload,
	                            merchantUuid: projectUUID }),
	                        _react2.default.createElement(_RegistryInfoCard.WrongRegistryTypeHint, {
	                            wrongType: wrongRegistryType,
	                            hint: wrongRegistryHint
	                        }),
	                        _react2.default.createElement(_RegistryColumnsHelp2.default, {
	                            token: token,
	                            type: "card",
	                            provider: selectedTerminal ? selectedTerminal.processing : null
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "350", className: _stylesModule2.default.SideColumn },
	                    _react2.default.createElement(_RegistryUploadInfo2.default, { name: initRegistryName, errorsCount: errorsCount, errorsList: errorsList,
	                        errorsFormat: errorsFormat, balance: terminalBalance,
	                        amount: registryAmount, fee: commission }),
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_FieldsHelper.Select, {
	                            label: "FieldsHelper.label.project",
	                            placeholder: "FieldsHelper.label.selectProject",
	                            isLoading: loadingProjects,
	                            values: projects,
	                            onChange: onSelectProject,
	                            selectedValue: selectedProject,
	                            isClean: false,
	                            fieldName: "displayName",
	                            fieldStatus: "status"
	                        }),
	                        selectedProject && _react2.default.createElement(_RegistryInfoCard2.default, {
	                            variant: "project",
	                            project: selectedProject,
	                            terminals: terminals
	                        }),
	                        _react2.default.createElement(_FieldsHelper.Select, {
	                            label: "FieldsHelper.label.terminal",
	                            placeholder: "FieldsHelper.label.selectTerminal",
	                            isLoading: loadingProjects || !selectedProject || loadingTerminals,
	                            values: terminals,
	                            onChange: onSelectTerminal,
	                            selectedValue: selectedTerminal,
	                            isClean: false,
	                            fieldName: "name",
	                            fieldStatus: "enabled"
	                        }),
	                        selectedTerminal && _react2.default.createElement(_RegistryInfoCard2.default, {
	                            variant: "terminal",
	                            terminal: selectedTerminal,
	                            currentMethod: "card"
	                        }),
	                        selectedProject && !loadingTerminals && terminals.length === 0 && _react2.default.createElement(_RegistryInfoCard.NoTerminalsForMethod, { currentMethod: "card" })
	                    ),
	                    loadingRegistry && _react2.default.createElement(_RegistryControls2.default, {
	                        errorsCount: errorsCount,
	                        suggestionsTag: suggestionsTags,
	                        registryFileName: registryName,
	                        amount: registryAmount,
	                        fee: commission,
	                        balance: terminalBalance,
	                        isLoading: isRequest
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default,
	            {
	                isOpen: showDuplicateWarning,
	                onClose: handleCancelDuplicate,
	                onConfirm: handleConfirmDuplicate,
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                    id: "RegistryUpload.modal.duplicateTitle",
	                    defaultMessage: "\u041E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0439 \u0434\u0443\u0431\u043B\u0438\u043A\u0430\u0442"
	                }),
	                isConfirm: true
	            },
	            _react2.default.createElement(
	                "div",
	                { className: _stylesModule2.default.WarningContent },
	                _react2.default.createElement(_Icon2.default, { icon: "warning", size: "48px", color: "#ff9800" }),
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.WarningText },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "RegistryUpload.modal.duplicateWarning",
	                        defaultMessage: "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0444\u0430\u0439\u043B\u0430 \u0431\u044B\u043B\u0438 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u044B \u043F\u043E\u0445\u043E\u0436\u0438\u0435 \u0440\u0435\u0435\u0441\u0442\u0440\u044B \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 30 \u0434\u043D\u0435\u0439:"
	                    })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _stylesModule2.default.DuplicateList },
	                    duplicates.map(function (dup, idx) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: idx },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                dup.name
	                            ),
	                            ' - ',
	                            dup.date ? new Date(dup.date.date || dup.date).toLocaleDateString() : '',
	                            dup.merchantName && _react2.default.createElement(
	                                "span",
	                                null,
	                                " (",
	                                dup.merchantName,
	                                ")"
	                            ),
	                            dup.matchReason && dup.matchReason.length > 0 && _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.MatchReason },
	                                ' [',
	                                dup.matchReason.includes('name') && _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUpload.match.name",
	                                    defaultMessage: "\u0438\u043C\u044F" }),
	                                dup.matchReason.includes('name') && dup.matchReason.includes('dataHash') && ', ',
	                                dup.matchReason.includes('dataHash') && _react2.default.createElement(_reactIntl.FormattedMessage, { id: "RegistryUpload.match.data",
	                                    defaultMessage: "\u0434\u0430\u043D\u043D\u044B\u0435" }),
	                                ']'
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: _stylesModule2.default.WarningConfirm },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, {
	                        id: "RegistryUpload.modal.duplicateConfirm",
	                        defaultMessage: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?"
	                    })
	                )
	            )
	        )
	    );
	});
	
	exports.default = RegistryUpload;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _PayControls = __webpack_require__(173);
	
	var _PayControls2 = _interopRequireDefault(_PayControls);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _reactIntl = __webpack_require__(2);
	
	var _stylesModule = __webpack_require__(206);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _Context = __webpack_require__(28);
	
	var _Context2 = _interopRequireDefault(_Context);
	
	var _ErrorHandler = __webpack_require__(98);
	
	var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);
	
	var _ApiResponseValidator = __webpack_require__(97);
	
	var _ApiResponseValidator2 = _interopRequireDefault(_ApiResponseValidator);
	
	var _MessageFormatter = __webpack_require__(191);
	
	var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);
	
	var _RetryManager = __webpack_require__(511);
	
	var _RetryManager2 = _interopRequireDefault(_RetryManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var onSendForm = function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	            var totalCost, payoutData, response, errorInfo;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	
	                            if (!(!projectUUID || !providerUUID)) {
	                                _context3.next = 4;
	                                break;
	                            }
	
	                            onMessage(_MessageFormatter2.default.warning('Please select a project and terminal for payment'));
	                            return _context3.abrupt("return");
	
	                        case 4:
	                            totalCost = Number(form.amount) + Number(commission);
	
	                            if (!(Number(terminalBalance.balance) < totalCost)) {
	                                _context3.next = 8;
	                                break;
	                            }
	
	                            onMessage(_MessageFormatter2.default.warning('Insufficient funds. Required: ' + totalCost + ' ' + terminalBalance.currency));
	                            return _context3.abrupt("return");
	
	                        case 8:
	                            if (!(!form.phone || !form.bic || !form.cardHolder || !form.amount)) {
	                                _context3.next = 11;
	                                break;
	                            }
	
	                            onMessage(_MessageFormatter2.default.warning('Please fill all required fields: phone, bank ID, recipient name, and amount'));
	                            return _context3.abrupt("return");
	
	                        case 11:
	
	                            setIsRequest(true);
	
	                            payoutData = {
	                                payout_type: 'mobile',
	                                phone: form.phone,
	                                bic: form.bic,
	                                cardHolder: form.cardHolder,
	                                amount: form.amount,
	                                providerUUID: providerUUID
	                            };
	                            _context3.next = 15;
	                            return new _Api2.default({ token: token }).makeSinglePayout(projectUUID, payoutData);
	
	                        case 15:
	                            response = _context3.sent;
	
	                            if (response.transactionId) {
	                                _context3.next = 18;
	                                break;
	                            }
	
	                            throw new Error('Missing transaction ID in response');
	
	                        case 18:
	                            if (!(response.error === true && response.transactionId)) {
	                                _context3.next = 22;
	                                break;
	                            }
	
	                            onMessage(_MessageFormatter2.default.warning('Payment created but may have issues. Transaction ID: ' + response.transactionId));
	                            _context3.next = 31;
	                            break;
	
	                        case 22:
	                            if (!(response.error === false && response.transactionId)) {
	                                _context3.next = 26;
	                                break;
	                            }
	
	                            onMessage(_MessageFormatter2.default.success('Payment successful! Transaction ID: ' + response.transactionId));
	                            _context3.next = 31;
	                            break;
	
	                        case 26:
	                            if (!response.code) {
	                                _context3.next = 30;
	                                break;
	                            }
	
	                            throw new Error(response.message || 'Payment processing failed with code ' + response.code);
	
	                        case 30:
	                            throw new Error('Unexpected payment response');
	
	                        case 31:
	
	                            setForm({ phone: '', bic: '', cardHolder: '', amount: '' });
	                            setCommission(0);
	
	                            _context3.next = 40;
	                            break;
	
	                        case 35:
	                            _context3.prev = 35;
	                            _context3.t0 = _context3["catch"](0);
	                            errorInfo = _ErrorHandler2.default.categorizeError(_context3.t0);
	
	                            _ErrorHandler2.default.logError(_context3.t0, {
	                                action: 'makeSbpPayout',
	                                projectUUID: projectUUID,
	                                providerUUID: providerUUID
	                            });
	
	                            if (errorInfo.type === 'permission_denied') {
	                                onMessage(_MessageFormatter2.default.permissionError('perform SBP payouts', 'this merchant'));
	                            } else if (errorInfo.type === 'validation') {
	                                onMessage(_MessageFormatter2.default.validationError(_context3.t0.message));
	                            } else {
	                                onMessage(_MessageFormatter2.default.error(_ErrorHandler2.default.getMessageForError(_context3.t0, 'payout')));
	                            }
	
	                        case 40:
	                            _context3.prev = 40;
	
	                            setIsRequest(false);
	                            return _context3.finish(40);
	
	                        case 43:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[0, 35, 40, 43]]);
	        }));
	
	        return function onSendForm() {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	
	    var token = _ref.token;
	
	    var _useState = (0, _react.useState)((0, _reactRouterDom.useParams)().uuid),
	        _useState2 = _slicedToArray(_useState, 2),
	        projectUUID = _useState2[0],
	        setProjectUUID = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        providerUUID = _useState4[0],
	        setProviderUUID = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        projects = _useState6[0],
	        setProjects = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        terminals = _useState8[0],
	        setTerminals = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        selectedProject = _useState10[0],
	        setSelectedProject = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        selectedTerminal = _useState12[0],
	        setSelectedTerminal = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ fixedPerTransaction: 0, cost: 1, costFixedMinimum: 40 }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        totalFee = _useState14[0],
	        setTotalFee = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(0),
	        _useState16 = _slicedToArray(_useState15, 2),
	        commission = _useState16[0],
	        setCommission = _useState16[1];
	
	    var _useState17 = (0, _react.useState)({ balance: 0, currency: "RUB" }),
	        _useState18 = _slicedToArray(_useState17, 2),
	        terminalBalance = _useState18[0],
	        setTerminalBalance = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({ phone: '', bic: '', cardHolder: '', amount: '' }),
	        _useState20 = _slicedToArray(_useState19, 2),
	        form = _useState20[0],
	        setForm = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(true),
	        _useState22 = _slicedToArray(_useState21, 2),
	        loadingProjects = _useState22[0],
	        setLoadingProjects = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        loadingTerminals = _useState24[0],
	        setLoadingTerminals = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        isRequest = _useState26[0],
	        setIsRequest = _useState26[1];
	
	    var _useContext = (0, _react.useContext)(_MessageContext2.default),
	        onMessage = _useContext.onMessage;
	
	    (0, _react.useEffect)(function () {
	        var requestKey = 'sbp_pay_load_projects';
	
	        var loadProjects = function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var retryInfo, projectsList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                retryInfo = _RetryManager2.default.canRetry(requestKey, { maxRetries: 3, baseDelay: 500 });
	
	                                if (retryInfo.canRetry) {
	                                    _context.next = 6;
	                                    break;
	                                }
	
	                                _ErrorHandler2.default.logError(new Error('Max retries exceeded for projects'), { action: 'loadProjects', requestKey: requestKey, reason: retryInfo.reason });
	                                onMessage(_MessageFormatter2.default.error('Failed to load projects after multiple attempts'));
	                                setLoadingProjects(false);
	                                return _context.abrupt("return");
	
	                            case 6:
	                                _context.prev = 6;
	                                _context.next = 9;
	                                return new _Api2.default({ token: token }).getProjects();
	
	                            case 9:
	                                projectsList = _context.sent;
	
	                                _ApiResponseValidator2.default.validateListResponse({ data: projectsList });
	
	                                _RetryManager2.default.clearRequest(requestKey);
	                                setProjects(projectsList);
	                                _context.next = 20;
	                                break;
	
	                            case 15:
	                                _context.prev = 15;
	                                _context.t0 = _context["catch"](6);
	
	                                _RetryManager2.default.recordAttempt(requestKey);
	
	                                _ErrorHandler2.default.logError(_context.t0, { action: 'loadProjects', requestKey: requestKey });
	                                onMessage(_MessageFormatter2.default.error('Failed to load projects'));
	
	                            case 20:
	                                _context.prev = 20;
	
	                                setLoadingProjects(false);
	                                return _context.finish(20);
	
	                            case 23:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined, [[6, 15, 20, 23]]);
	            }));
	
	            return function loadProjects() {
	                return _ref2.apply(this, arguments);
	            };
	        }();
	
	        loadProjects();
	        return function () {
	            return _RetryManager2.default.clearRequest(requestKey);
	        };
	    }, [token, onMessage]);
	
	    function calcCommission(amount, fee) {
	        if (!amount || amount.length === 0 || !fee) {
	            return 0;
	        }
	        var cost = Number(fee.cost) || 0;
	        var costFixedMinimum = Number(fee.costFixedMinimum) || 0;
	        var fixedPerTransaction = Number(fee.fixedPerTransaction) || 0;
	        var amountNum = Number(amount) || 0;
	
	        var percentFee = amountNum * (cost / 100);
	        if (percentFee < costFixedMinimum) {
	            return costFixedMinimum + fixedPerTransaction;
	        }
	        return percentFee + fixedPerTransaction;
	    }
	
	    function onSelectProject(project) {
	        var _this = this;
	
	        var requestKey = "sbp_pay_load_project_" + project.uuid;
	
	        var loadTerminals = function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var retryInfo, projectData, terminal;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                retryInfo = _RetryManager2.default.canRetry(requestKey, { maxRetries: 3, baseDelay: 500 });
	
	                                if (retryInfo.canRetry) {
	                                    _context2.next = 6;
	                                    break;
	                                }
	
	                                _ErrorHandler2.default.logError(new Error('Max retries exceeded for project data'), { action: 'loadProjectData', projectUUID: project.uuid, requestKey: requestKey, reason: retryInfo.reason });
	                                onMessage(_MessageFormatter2.default.error('Failed to load terminal data after multiple attempts'));
	                                setLoadingTerminals(false);
	                                return _context2.abrupt("return");
	
	                            case 6:
	                                _context2.prev = 6;
	
	                                setProjectUUID(project.uuid);
	                                setSelectedTerminal(null);
	                                setProviderUUID(null);
	                                setSelectedProject(project);
	                                setLoadingTerminals(true);
	                                setCommission(0);
	                                setTerminalBalance({ balance: 0, currency: "RUB" });
	
	                                _context2.next = 16;
	                                return new _Api2.default({ token: token }).getProjectData(project.uuid);
	
	                            case 16:
	                                projectData = _context2.sent;
	
	                                _ApiResponseValidator2.default.validateResponse(projectData);
	
	                                _RetryManager2.default.clearRequest(requestKey);
	
	                                if (projectData.terminals.length === 1) {
	                                    terminal = projectData.terminals[0];
	
	                                    setTerminalBalance({ balance: terminal.balance.confirmed, currency: terminal.currency });
	                                    setProviderUUID(terminal.uuid);
	                                    setSelectedTerminal(terminal);
	                                    setCommission(calcCommission(form.amount, terminal.fee.payout));
	                                    setTotalFee(terminal.fee.payout);
	                                }
	
	                                setTerminals(projectData.terminals);
	                                _context2.next = 30;
	                                break;
	
	                            case 23:
	                                _context2.prev = 23;
	                                _context2.t0 = _context2["catch"](6);
	
	                                _RetryManager2.default.recordAttempt(requestKey);
	
	                                _ErrorHandler2.default.logError(_context2.t0, { action: 'loadProjectData', projectUUID: project.uuid, requestKey: requestKey });
	                                onMessage(_MessageFormatter2.default.error('Failed to load terminal data. Please try again.'));
	                                setSelectedProject(null);
	                                setTerminals([]);
	
	                            case 30:
	                                _context2.prev = 30;
	
	                                setLoadingTerminals(false);
	                                return _context2.finish(30);
	
	                            case 33:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, _this, [[6, 23, 30, 33]]);
	            }));
	
	            return function loadTerminals() {
	                return _ref3.apply(this, arguments);
	            };
	        }();
	        loadTerminals();
	    }
	
	    function onSelectTerminal(terminal) {
	        setSelectedTerminal(terminal);
	        setProviderUUID(terminal.uuid);
	        setTerminalBalance({ balance: terminal.balance.confirmed, currency: terminal.currency });
	        setTotalFee(terminal.fee.payout);
	
	        if (form.amount.length > 0) setCommission(calcCommission(form.amount, terminal.fee.payout));
	    }
	
	    function onChangeForm(name, value) {
	        setForm(Object.assign({}, form, _defineProperty({}, name, value)));
	
	        if (name === "amount") setCommission(calcCommission(value, totalFee));
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Context2.default.Provider,
	            { value: { onSelectProject: onSelectProject } },
	            _react2.default.createElement(
	                _Layout.Container,
	                { className: _stylesModule2.default.StackOnMobile },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "780", className: _stylesModule2.default.MainColumn },
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        { title: "SbpPay.title" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Block },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Col_1 },
	                                _react2.default.createElement(
	                                    "h4",
	                                    { className: _stylesModule2.default.BlockTitle },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "SbpPay.label.recipient", defaultMessage: "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C (\u0421\u0411\u041F)" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Col_2 },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: onChangeForm,
	                                    value: form.phone,
	                                    placeholder: "79001234567",
	                                    fieldName: "phone",
	                                    label: "Pay.label.recipientPhone",
	                                    changeRegexp: /[^0-9]+/g,
	                                    blurRegexp: /^\d{10,15}$/g,
	                                    changeMessage: "FieldsHelper.error.onlyNumbersPhone",
	                                    blurMessage: "Pay.error.checkPhoneFormat",
	                                    isDisabled: isRequest,
	                                    autoComplete: "off"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Col_3 },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: onChangeForm,
	                                    value: form.bic,
	                                    placeholder: "044525225 или 1crt88888881",
	                                    fieldName: "bic",
	                                    label: "Pay.label.bicOrMemberId",
	                                    blurRegexp: /^.{1,64}$/g,
	                                    blurMessage: "Pay.error.checkBicOrMemberId",
	                                    isDisabled: isRequest,
	                                    autoComplete: "off"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Block },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Col_1 },
	                                _react2.default.createElement(
	                                    "h4",
	                                    { className: _stylesModule2.default.BlockTitle },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Pay.label.recipientName", defaultMessage: "\u0424\u0418\u041E \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Col_2_3 },
	                                _react2.default.createElement(_FieldsHelper.InputHelper, {
	                                    onChange: onChangeForm,
	                                    value: form.cardHolder,
	                                    placeholder: "ИВАНОВ ИВАН ИВАНОВИЧ",
	                                    fieldName: "cardHolder",
	                                    label: "Pay.label.recipientFio",
	                                    blurRegexp: /^.{3,}$/g,
	                                    blurMessage: "Pay.error.checkFio",
	                                    isUppercase: true,
	                                    isDisabled: isRequest,
	                                    autoComplete: "off"
	                                })
	                            )
	                        ),
	                        _react2.default.createElement("div", { className: _stylesModule2.default.Divider }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Block },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Col_1 },
	                                _react2.default.createElement(
	                                    "h4",
	                                    { className: _stylesModule2.default.BlockTitle },
	                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "Pay.label.amount", defaultMessage: "\u0421\u0443\u043C\u043C\u0430" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.Col_2 },
	                                _react2.default.createElement(_FieldsHelper.InputAmountCurrencyHelper, {
	                                    onChange: onChangeForm,
	                                    value: form.amount,
	                                    currency: [terminalBalance.currency],
	                                    placeholder: "1960.20",
	                                    label: "FieldsHelper.label.amount",
	                                    changeMessage: "FieldsHelper.error.onlyNumbersAmount",
	                                    blurMessage: "FieldsHelper.error.checkAmount",
	                                    isDisabled: isRequest,
	                                    autoComplete: "off"
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "350", className: _stylesModule2.default.SideColumn },
	                    _react2.default.createElement(
	                        _EmptyCard2.default,
	                        null,
	                        _react2.default.createElement(_FieldsHelper.Select, {
	                            label: "FieldsHelper.label.project",
	                            placeholder: "FieldsHelper.label.selectProject",
	                            isLoading: loadingProjects || isRequest,
	                            values: projects,
	                            onChange: onSelectProject,
	                            selectedValue: selectedProject,
	                            fieldName: "displayName",
	                            fieldStatus: "status"
	                        }),
	                        _react2.default.createElement(_FieldsHelper.Select, {
	                            label: "FieldsHelper.label.terminal",
	                            placeholder: "FieldsHelper.label.selectTerminal",
	                            isLoading: loadingProjects || !selectedProject || loadingTerminals,
	                            values: terminals,
	                            onChange: onSelectTerminal,
	                            selectedValue: selectedTerminal,
	                            isClean: false,
	                            fieldName: "name",
	                            fieldStatus: "enabled"
	                        })
	                    ),
	                    _react2.default.createElement(_PayControls2.default, {
	                        name: name,
	                        cardHolder: form.cardHolder,
	                        phone: form.phone,
	                        amount: form.amount ? form.amount : 0,
	                        commission: commission,
	                        balance: terminalBalance,
	                        onSendForm: onSendForm,
	                        isLoading: isRequest
	                    })
	                )
	            )
	        )
	    );
	});

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _SecretChat = __webpack_require__(183);
	
	var _SecretChat2 = _interopRequireDefault(_SecretChat);
	
	var _styles = __webpack_require__(208);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Секретные чаты со стороны клиента.
	 *
	 * Разговор может начать любая сторона, поэтому здесь и список уже открытых
	 * чатов (включая начатые поддержкой), и кнопка нового. Форма нового чата
	 * живёт в отдельном окне: постоянно висящая на экране, она занимала место
	 * ровно там, где человек ждёт увидеть переписку.
	 */
	function SecretChats(_ref) {
	    var onCreate = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	            var topic, created;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            e.preventDefault();
	
	                            topic = subject.trim();
	
	                            if (!(!topic || isCreating)) {
	                                _context2.next = 4;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 4:
	
	                            setIsCreating(true);
	                            _context2.prev = 5;
	                            _context2.next = 8;
	                            return new _Api2.default({ token: token }).createSecretChat(topic, firstMessage.trim() || undefined);
	
	                        case 8:
	                            created = _context2.sent;
	
	                            if (mountedRef.current) {
	                                _context2.next = 11;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 11:
	                            setSubject('');
	                            setFirstMessage('');
	                            setError(null);
	                            setIsFormOpen(false);
	                            _context2.next = 17;
	                            return loadChats();
	
	                        case 17:
	                            if (created && created.id) setActiveId(created.id);
	                            _context2.next = 25;
	                            break;
	
	                        case 20:
	                            _context2.prev = 20;
	                            _context2.t0 = _context2['catch'](5);
	
	                            if (mountedRef.current) {
	                                _context2.next = 24;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 24:
	                            setError(intl.formatMessage({ id: 'SecretChats.error.create', defaultMessage: 'Не удалось создать чат' }));
	
	                        case 25:
	                            _context2.prev = 25;
	
	                            if (mountedRef.current) setIsCreating(false);
	                            return _context2.finish(25);
	
	                        case 28:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[5, 20, 25, 28]]);
	        }));
	
	        return function onCreate(_x) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	
	    var token = _ref.token;
	
	    var intl = (0, _reactIntl.useIntl)();
	
	    var _useState = (0, _react.useState)([]),
	        _useState2 = _slicedToArray(_useState, 2),
	        chats = _useState2[0],
	        setChats = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(24),
	        _useState4 = _slicedToArray(_useState3, 2),
	        ttlHours = _useState4[0],
	        setTtlHours = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activeId = _useState6[0],
	        setActiveId = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(true),
	        _useState8 = _slicedToArray(_useState7, 2),
	        isLoading = _useState8[0],
	        setIsLoading = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        isCreating = _useState10[0],
	        setIsCreating = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        isFormOpen = _useState12[0],
	        setIsFormOpen = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(''),
	        _useState14 = _slicedToArray(_useState13, 2),
	        subject = _useState14[0],
	        setSubject = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(''),
	        _useState16 = _slicedToArray(_useState15, 2),
	        firstMessage = _useState16[0],
	        setFirstMessage = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(null),
	        _useState18 = _slicedToArray(_useState17, 2),
	        error = _useState18[0],
	        setError = _useState18[1];
	
	    var mountedRef = (0, _react.useRef)(true);
	
	    (0, _react.useEffect)(function () {
	        mountedRef.current = true;
	        return function () {
	            mountedRef.current = false;
	        };
	    }, []);
	
	    var loadChats = (0, _react.useCallback)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return new _Api2.default({ token: token }).listSecretChats();
	
	                    case 3:
	                        data = _context.sent;
	
	                        if (mountedRef.current) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 6:
	                        setChats(data && data.items || []);
	                        if (data && data.ttlHours) setTtlHours(data.ttlHours);
	                        setError(null);
	                        _context.next = 16;
	                        break;
	
	                    case 11:
	                        _context.prev = 11;
	                        _context.t0 = _context['catch'](0);
	
	                        if (mountedRef.current) {
	                            _context.next = 15;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 15:
	                        setError(intl.formatMessage({
	                            id: 'SecretChats.error.list',
	                            defaultMessage: 'Не удалось загрузить список чатов'
	                        }));
	
	                    case 16:
	                        _context.prev = 16;
	
	                        if (mountedRef.current) setIsLoading(false);
	                        return _context.finish(16);
	
	                    case 19:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[0, 11, 16, 19]]);
	    })), [token, intl]);
	
	    (0, _react.useEffect)(function () {
	        loadChats();
	        // Список перечитывается сам: чат может начать поддержка, и он
	        // должен появиться без перезагрузки страницы.
	        var timer = setInterval(loadChats, 15000);
	        return function () {
	            return clearInterval(timer);
	        };
	    }, [loadChats]);
	
	    var loadMessages = (0, _react.useCallback)(function (id) {
	        return new _Api2.default({ token: token }).getSecretChatMessages(id);
	    }, [token]);
	    var sendMessage = (0, _react.useCallback)(function (id, body, files) {
	        return new _Api2.default({ token: token }).postSecretChatMessage(id, body, files).then(function (data) {
	            loadChats();
	            return data;
	        });
	    }, [token, loadChats]);
	    // Файл скачивается запросом с токеном: у простой ссылки нет заголовка
	    // авторизации, и сервер ответил бы отказом.
	    var downloadFile = (0, _react.useCallback)(function (chatId, fileId) {
	        return new _Api2.default({ token: token }).downloadSecretChatFile(chatId, fileId, false);
	    }, [token]);
	
	    var markRead = (0, _react.useCallback)(function (id) {
	        new _Api2.default({ token: token }).readSecretChat(id).then(loadChats).catch(function () {});
	    }, [token, loadChats]);
	
	    var active = chats.find(function (c) {
	        return c.id === activeId;
	    }) || null;
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: '1180' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Head },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: _styles2.default.Title },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChats.title', defaultMessage: '\u0421\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0447\u0430\u0442\u044B' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _styles2.default.Subtitle },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, {
	                            id: 'SecretChats.subtitle',
	                            defaultMessage: '\u041F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0430 \u0448\u0438\u0444\u0440\u0443\u0435\u0442\u0441\u044F \u0438 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0443\u0434\u0430\u043B\u044F\u0435\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 {hours} \u0447\u0430\u0441\u0430',
	                            values: { hours: ttlHours }
	                        })
	                    )
	                ),
	                error ? _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Error },
	                    error
	                ) : null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _styles2.default.Board },
	                    _react2.default.createElement(_SecretChat.ChatList, {
	                        chats: chats,
	                        activeId: activeId,
	                        isLoading: isLoading,
	                        onPick: setActiveId,
	                        onNew: function onNew() {
	                            return setIsFormOpen(true);
	                        }
	                    }),
	                    _react2.default.createElement(_SecretChat2.default, {
	                        chat: active,
	                        side: 'client',
	                        ttlHours: ttlHours,
	                        loadMessages: loadMessages,
	                        sendMessage: sendMessage,
	                        onRead: markRead,
	                        downloadFile: downloadFile
	                    })
	                ),
	                isFormOpen ? _react2.default.createElement(
	                    'div',
	                    {
	                        className: _styles2.default.Overlay,
	                        onClick: function onClick(e) {
	                            if (e.target === e.currentTarget) setIsFormOpen(false);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'form',
	                        { className: _styles2.default.Dialog, onSubmit: onCreate },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.DialogTitle },
	                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChat.button.new', defaultMessage: '\u041D\u043E\u0432\u044B\u0439 \u0447\u0430\u0442' })
	                        ),
	                        _react2.default.createElement('input', {
	                            className: _styles2.default.Field,
	                            value: subject,
	                            maxLength: 200,
	                            autoFocus: true,
	                            placeholder: intl.formatMessage({
	                                id: 'SecretChats.field.subject',
	                                defaultMessage: 'Тема разговора'
	                            }),
	                            onChange: function onChange(e) {
	                                return setSubject(e.target.value);
	                            }
	                        }),
	                        _react2.default.createElement('textarea', {
	                            className: _styles2.default.Field,
	                            value: firstMessage,
	                            rows: 3,
	                            maxLength: 20000,
	                            placeholder: intl.formatMessage({
	                                id: 'SecretChats.field.first',
	                                defaultMessage: 'Первое сообщение (необязательно)'
	                            }),
	                            onChange: function onChange(e) {
	                                return setFirstMessage(e.target.value);
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _styles2.default.DialogButtons },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: _styles2.default.Cancel,
	                                    onClick: function onClick() {
	                                        return setIsFormOpen(false);
	                                    }
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChats.button.cancel', defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0430' })
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: _styles2.default.Create,
	                                    disabled: isCreating || !subject.trim()
	                                },
	                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SecretChats.button.create', defaultMessage: '\u041D\u0430\u0447\u0430\u0442\u044C \u0447\u0430\u0442' })
	                            )
	                        )
	                    )
	                ) : null
	            )
	        )
	    );
	}
	
	exports.default = (0, _Auth.withAuth)(SecretChats);

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _MerchantTerminalSelect = __webpack_require__(57);
	
	var _MerchantTerminalSelect2 = _interopRequireDefault(_MerchantTerminalSelect);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _stylesModule = __webpack_require__(645);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPE_CREDIT = 1;
	var TYPE_COMMISSION = 2;
	
	var TYPE_OPTIONS = [{ value: "", label: "Все" }, { value: "1", label: "Зачисление" }, { value: "2", label: "Комиссия" }, { value: "3", label: "Выплата мерчанту" }, { value: "4", label: "Отмена выплаты" }, { value: "5", label: "Ручная корректировка" }, { value: "6", label: "Возврат" }, { value: "7", label: "Чарджбэк" }, { value: "8", label: "Пополнение" }];
	
	// Группировка: скрываем строки комиссий, встраиваем их данные в строки зачислений
	function groupEntries(entries) {
	    // Собираем комиссии по transaction_id
	    var commissionByTxId = {};
	    var result = [];
	    var i;
	
	    for (i = 0; i < entries.length; i++) {
	        var e = entries[i];
	        if (e.type === TYPE_COMMISSION && e.transaction_id) {
	            commissionByTxId[e.transaction_id] = e;
	        }
	    }
	
	    for (i = 0; i < entries.length; i++) {
	        var entry = entries[i];
	        // Пропускаем строки комиссий — они уйдут в аккордеон
	        if (entry.type === TYPE_COMMISSION) continue;
	
	        var commissionEntry = null;
	        if (entry.type === TYPE_CREDIT && entry.transaction_id) {
	            commissionEntry = commissionByTxId[entry.transaction_id] || null;
	        }
	
	        result.push({
	            entry: entry,
	            commissionEntry: commissionEntry
	        });
	    }
	
	    return result;
	}
	
	// Пересчёт summary: приход = нетто, расход без комиссий
	function adjustSummary(summary, entries) {
	    if (!summary) return null;
	    var totalCommission = 0;
	    for (var i = 0; i < entries.length; i++) {
	        if (entries[i].type === TYPE_COMMISSION) {
	            totalCommission += Math.abs(entries[i].amount || 0);
	        }
	    }
	    return {
	        total_credit: (summary.total_credit || 0) - totalCommission,
	        total_debit: (summary.total_debit || 0) - totalCommission,
	        total_commission: summary.total_commission || 0
	    };
	}
	
	var LIMIT = 50;
	
	var Statement = (0, _Auth.withAuth)(function (props) {
	    var token = props.token;
	    var onMessage = (0, _react.useContext)(_MessageContext2.default).onMessage;
	
	    var stateEntries = (0, _react.useState)([]);
	    var entries = stateEntries[0];
	    var setEntries = stateEntries[1];
	
	    var stateLoading = (0, _react.useState)(true);
	    var loading = stateLoading[0];
	    var setLoading = stateLoading[1];
	
	    var stateCount = (0, _react.useState)(0);
	    var count = stateCount[0];
	    var setCount = stateCount[1];
	
	    var statePage = (0, _react.useState)(1);
	    var page = statePage[0];
	    var setPage = statePage[1];
	
	    var stateSummary = (0, _react.useState)(null);
	    var summary = stateSummary[0];
	    var setSummary = stateSummary[1];
	
	    var stateSelectedMs = (0, _react.useState)("");
	    var selectedMs = stateSelectedMs[0];
	    var setSelectedMs = stateSelectedMs[1];
	
	    var stateFilterDate = (0, _react.useState)({});
	    var filterDate = stateFilterDate[0];
	    var setFilterDate = stateFilterDate[1];
	
	    var stateSelectedType = (0, _react.useState)("");
	    var selectedType = stateSelectedType[0];
	    var setSelectedType = stateSelectedType[1];
	
	    var stateExporting = (0, _react.useState)(false);
	    var exporting = stateExporting[0];
	    var setExporting = stateExporting[1];
	
	    var stateExpanded = (0, _react.useState)({});
	    var expanded = stateExpanded[0];
	    var setExpanded = stateExpanded[1];
	
	    function toggleExpanded(id) {
	        var next = {};
	        for (var k in expanded) {
	            next[k] = expanded[k];
	        }
	        next[id] = !next[id];
	        setExpanded(next);
	    }
	
	    function handleMsSelect(msId) {
	        setSelectedMs(msId);
	        setPage(1);
	    }
	
	    var dateFrom = filterDate.startDate || "";
	    var dateTo = filterDate.endDate || "";
	
	    // Load statement when filters change
	    (0, _react.useEffect)(function () {
	        if (!selectedMs || !dateFrom || !dateTo) return;
	        setLoading(true);
	        var api = new _Api2.default({ token: token });
	        var params = {
	            merchant_settings_id: selectedMs,
	            date_from: dateFrom,
	            date_to: dateTo,
	            page: page,
	            limit: LIMIT
	        };
	        if (selectedType) {
	            params.type = selectedType;
	        }
	        api.getMerchantStatement(params).then(function (r) {
	            setEntries(r.entries || []);
	            setCount(r.count || 0);
	            setSummary(r.summary || null);
	            setLoading(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setLoading(false);
	            onMessage({ type: "error", message: "Ошибка загрузки выписки" });
	        });
	    }, [token, selectedMs, dateFrom, dateTo, selectedType, page]);
	
	    function handleTypeChange(e) {
	        setSelectedType(e.target.value);
	        setPage(1);
	    }
	
	    function handlePageChange(p) {
	        setPage(p);
	    }
	
	    function handleExportExcel() {
	        if (!selectedMs || !dateFrom || !dateTo) return;
	        setExporting(true);
	        var params = {
	            merchant_settings_id: selectedMs,
	            date_from: dateFrom,
	            date_to: dateTo
	        };
	        if (selectedType) params.type = selectedType;
	        new _Api2.default({ token: token }).exportMerchantStatement(params).then(function () {
	            setExporting(false);
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            setExporting(false);
	            onMessage({ type: "error", message: "Ошибка экспорта" });
	        });
	    }
	
	    function handleSettlementExcel(settlementId) {
	        new _Api2.default({ token: token }).downloadSettlementExcel(settlementId).catch(function (err) {
	            Sentry.captureException(err);
	            onMessage({ type: "error", message: "Ошибка скачивания Excel" });
	        });
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "full" },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Header },
	                        _react2.default.createElement(
	                            "h5",
	                            { className: _stylesModule2.default.Title },
	                            "\u0412\u044B\u043F\u0438\u0441\u043A\u0430"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Content },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SelectorBlock },
	                            _react2.default.createElement(_MerchantTerminalSelect2.default, {
	                                mode: "user",
	                                token: token,
	                                stackOnMobile: true,
	                                onSelect: handleMsSelect,
	                                onDataLoaded: function onDataLoaded() {
	                                    setLoading(false);
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.FiltersRow },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.DateGroup },
	                                _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                                        setFilterDate(range);setPage(1);
	                                    }, defaultPeriod: "week" })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.FilterGroup },
	                                _react2.default.createElement(
	                                    "label",
	                                    null,
	                                    "\u0422\u0438\u043F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438"
	                                ),
	                                _react2.default.createElement(
	                                    "select",
	                                    { className: _stylesModule2.default.TypeSelect, value: selectedType, onChange: handleTypeChange },
	                                    TYPE_OPTIONS.map(function (opt) {
	                                        return _react2.default.createElement(
	                                            "option",
	                                            { key: opt.value, value: opt.value },
	                                            opt.label
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.FilterGroup },
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: _stylesModule2.default.BtnOutline,
	                                        onClick: handleExportExcel,
	                                        disabled: exporting || !selectedMs || !dateFrom || !dateTo
	                                    },
	                                    exporting ? "Экспорт..." : "Экспорт Excel"
	                                )
	                            )
	                        ),
	                        summary && function () {
	                            var adj = adjustSummary(summary, entries);
	                            return _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.SummaryRow },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryCard },
	                                    _react2.default.createElement(
	                                        "small",
	                                        null,
	                                        "\u041F\u0440\u0438\u0445\u043E\u0434"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { style: { color: "#4caf50", fontWeight: 600, fontSize: "1.1rem" } },
	                                        "+",
	                                        ((adj.total_credit || 0) / 100).toFixed(2)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryCard },
	                                    _react2.default.createElement(
	                                        "small",
	                                        null,
	                                        "\u0420\u0430\u0441\u0445\u043E\u0434"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { style: { color: "#f44336", fontWeight: 600, fontSize: "1.1rem" } },
	                                        "-",
	                                        ((adj.total_debit || 0) / 100).toFixed(2)
	                                    )
	                                ),
	                                adj.total_commission > 0 && _react2.default.createElement(
	                                    "div",
	                                    { className: _stylesModule2.default.SummaryCard },
	                                    _react2.default.createElement(
	                                        "small",
	                                        null,
	                                        "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { style: { color: "#ff9800", fontWeight: 600, fontSize: "1.1rem" } },
	                                        (adj.total_commission / 100).toFixed(2)
	                                    )
	                                )
	                            );
	                        }(),
	                        loading ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.TableScroll },
	                                _react2.default.createElement(
	                                    "table",
	                                    { className: _stylesModule2.default.Table },
	                                    _react2.default.createElement(
	                                        "thead",
	                                        null,
	                                        _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0414\u0430\u0442\u0430"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "ID \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041A\u0430\u0440\u0442\u0430"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "Settlement"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041F\u0440\u0438\u0445\u043E\u0434"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0420\u0430\u0441\u0445\u043E\u0434"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "USDT"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u0411\u0430\u043B\u0430\u043D\u0441"
	                                            ),
	                                            _react2.default.createElement(
	                                                "th",
	                                                null,
	                                                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
	                                            ),
	                                            _react2.default.createElement("th", null)
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "tbody",
	                                        null,
	                                        entries.length === 0 && _react2.default.createElement(
	                                            "tr",
	                                            null,
	                                            _react2.default.createElement(
	                                                "td",
	                                                { colSpan: "12", className: "text-center text-muted" },
	                                                !dateFrom || !dateTo ? "Выберите период для просмотра выписки" : "Нет записей"
	                                            )
	                                        ),
	                                        [].concat.apply([], groupEntries(entries).map(function (grouped) {
	                                            var entry = grouped.entry;
	                                            var commEntry = grouped.commissionEntry;
	                                            var hasAccordion = !!commEntry;
	                                            var isOpen = hasAccordion && expanded[entry.id];
	
	                                            // Нетто: приход минус комиссия
	                                            var isPositive = parseInt(entry.amount, 10) > 0;
	                                            var displayAmountFloat = entry.amount_float;
	                                            // Баланс: берём из строки комиссии (после вычета), если есть
	                                            var displayBalanceFloat = hasAccordion ? commEntry.balance_after_float : entry.balance_after_float;
	                                            if (hasAccordion && isPositive && commEntry.amount_float) {
	                                                displayAmountFloat = entry.amount_float - Math.abs(commEntry.amount_float);
	                                            }
	
	                                            var rows = [];
	
	                                            // Основная строка
	                                            rows.push(_react2.default.createElement("tr", {
	                                                key: entry.id,
	                                                className: hasAccordion ? _stylesModule2.default.AccordionRow : "",
	                                                onClick: hasAccordion ? function () {
	                                                    toggleExpanded(entry.id);
	                                                } : undefined,
	                                                style: hasAccordion ? { cursor: "pointer" } : undefined
	                                            }, _react2.default.createElement("td", { style: { whiteSpace: "nowrap" } }, hasAccordion ? _react2.default.createElement("span", { className: _stylesModule2.default.Arrow + (isOpen ? " " + _stylesModule2.default.ArrowOpen : "") }, "\u25B6") : null, " ", new Date(entry.created_at).toLocaleString('ru-RU')), _react2.default.createElement("td", null, entry.type_name), _react2.default.createElement("td", null, entry.transaction_id ? _react2.default.createElement("a", {
	                                                href: "/transactions/" + JSON.stringify({ filters: [{ id: entry.transaction_id, locale: "Search.label.operationId" }] }),
	                                                style: { color: "#0d6efd" },
	                                                onClick: function onClick(e) {
	                                                    e.stopPropagation();
	                                                }
	                                            }, entry.transaction_id) : ''), _react2.default.createElement("td", { style: { whiteSpace: "nowrap" } }, entry.card_mask || ''), _react2.default.createElement("td", null, entry.settlement_id || ''), _react2.default.createElement("td", { className: "text-success" }, isPositive ? displayAmountFloat.toFixed(2) : ''), _react2.default.createElement("td", { className: "text-danger" }, !isPositive ? Math.abs(displayAmountFloat).toFixed(2) : ''), _react2.default.createElement("td", null, entry.commission_float != null ? entry.commission_float.toFixed(2) : ''), _react2.default.createElement("td", null, entry.amount_usdt != null ? Number(entry.amount_usdt).toFixed(4) : ''), _react2.default.createElement("td", null, displayBalanceFloat.toFixed(2)), _react2.default.createElement("td", null, entry.description || ''), _react2.default.createElement("td", null, entry.type === 3 && entry.settlement_id ? _react2.default.createElement("button", {
	                                                className: "btn btn-outline-primary btn-sm",
	                                                style: { fontSize: ".75rem", padding: "2px 6px" },
	                                                onClick: function onClick(e) {
	                                                    e.stopPropagation();handleSettlementExcel(entry.settlement_id);
	                                                },
	                                                title: "Скачать Excel детализации"
	                                            }, "Excel") : null)));
	
	                                            // Раскрытая детализация
	                                            if (isOpen) {
	                                                var grossFloat = entry.amount_float;
	                                                var feeFloat = Math.abs(commEntry.amount_float);
	                                                var netFloat = grossFloat - feeFloat;
	
	                                                rows.push(_react2.default.createElement("tr", { key: entry.id + "-detail", className: _stylesModule2.default.DetailRow }, _react2.default.createElement("td", { colSpan: "12" }, _react2.default.createElement("div", { className: _stylesModule2.default.DetailContent }, _react2.default.createElement("span", null, "Сумма операции: ", _react2.default.createElement("b", null, grossFloat.toFixed(2))), _react2.default.createElement("span", { className: "text-danger" }, " \u2212 \u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F: ", _react2.default.createElement("b", null, feeFloat.toFixed(2))), _react2.default.createElement("span", { className: "text-success" }, " = Зачислено: ", _react2.default.createElement("b", null, netFloat.toFixed(2)))))));
	                                            }
	
	                                            return rows;
	                                        }))
	                                    )
	                                )
	                            ),
	                            count > LIMIT && _react2.default.createElement(
	                                "div",
	                                { className: _stylesModule2.default.PaginationWrap },
	                                _react2.default.createElement(_reactJsPagination2.default, {
	                                    activePage: page,
	                                    itemsCountPerPage: LIMIT,
	                                    totalItemsCount: count,
	                                    pageRangeDisplayed: 5,
	                                    onChange: handlePageChange,
	                                    itemClass: "page-item",
	                                    linkClass: "page-link",
	                                    activeLinkClass: _stylesModule2.default.ActiveLink
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});
	
	exports.default = Statement;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(209);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _reactIntl = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyChart = function EmptyChart() {
	    return _react2.default.createElement(
	        "div",
	        { className: _stylesModule2.default.EmptyChart },
	        _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "EmptyChart.message", defaultMessage: "no translate" })
	        )
	    );
	};
	
	exports.default = EmptyChart;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _SearchTags = __webpack_require__(38);
	
	var _SearchTags2 = _interopRequireDefault(_SearchTags);
	
	var _DateRange = __webpack_require__(18);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _TransactionsFilters = __webpack_require__(433);
	
	var _TransactionsFilters2 = _interopRequireDefault(_TransactionsFilters);
	
	var _TransactionsTable = __webpack_require__(436);
	
	var _TransactionsTable2 = _interopRequireDefault(_TransactionsTable);
	
	var _ReportWidget = __webpack_require__(95);
	
	var _ReportWidget2 = _interopRequireDefault(_ReportWidget);
	
	var _reactJsPagination = __webpack_require__(17);
	
	var _reactJsPagination2 = _interopRequireDefault(_reactJsPagination);
	
	var _FieldsHelper = __webpack_require__(13);
	
	var _ResponsiveSidebarFilters = __webpack_require__(30);
	
	var _ResponsiveSidebarFilters2 = _interopRequireDefault(_ResponsiveSidebarFilters);
	
	var _HTabBar = __webpack_require__(187);
	
	var _HTabBar2 = _interopRequireDefault(_HTabBar);
	
	var _TabBarItem = __webpack_require__(186);
	
	var _TabBarItem2 = _interopRequireDefault(_TabBarItem);
	
	var _MainTransactionsChart = __webpack_require__(339);
	
	var _MainTransactionsChart2 = _interopRequireDefault(_MainTransactionsChart);
	
	var _TransactionsLineChart = __webpack_require__(342);
	
	var _TransactionsLineChart2 = _interopRequireDefault(_TransactionsLineChart);
	
	var _MerchantsTurnoverChart = __webpack_require__(358);
	
	var _MerchantsTurnoverChart2 = _interopRequireDefault(_MerchantsTurnoverChart);
	
	var _EmptyChart = __webpack_require__(506);
	
	var _EmptyChart2 = _interopRequireDefault(_EmptyChart);
	
	var _EmptyCard = __webpack_require__(14);
	
	var _EmptyCard2 = _interopRequireDefault(_EmptyCard);
	
	var _stylesModule = __webpack_require__(209);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var LABELS = {
	    purchase: "Purchase",
	    purchaseDecline: "Purchase Decline",
	    payout: "Payout",
	    payoutDecline: "Payout Decline",
	    payoutCreated: "Payout Created",
	    sbp: "SBP",
	    mP2P: "P2P",
	    refund: "Refund",
	    reversal: "Reversal",
	    recurrent: "Recurrent",
	    threeDSPending: "3DS Pending",
	    purchasePending: "Purchase Pending",
	    payoutPending: "Payout Pending",
	    refundPending: "Refund Pending",
	    reversalPending: "Reversal Pending",
	    mP2PPending: "P2P Pending",
	    sbpPending: "SBP Pending",
	    chargeback: "Chargeback",
	    created: "Created"
	};
	
	var COLORS = {
	    purchase: "#3366CC",
	    purchaseDecline: "#FF9900",
	    payout: "#109618",
	    payoutDecline: "#DC3912",
	    payoutCreated: "#8B0000",
	    sbp: "#00BFFF",
	    mP2P: "#8A2BE2",
	    refund: "#FF1493",
	    reversal: "#808080",
	    recurrent: "#20B2AA",
	    threeDSPending: "#708090",
	    purchasePending: "#778899",
	    payoutPending: "#A9A9A9",
	    refundPending: "#B0C4DE",
	    reversalPending: "#A0522D",
	    mP2PPending: "#483D8B",
	    sbpPending: "#4682B4",
	    chargeback: "#FFD700",
	    created: "#6A5ACD",
	    turnover: "#990099"
	};
	
	var USER_ALLOWED = ["payout", "payoutDecline", "payoutCreated"];
	
	var STATISTICS_ACCESS = 4;
	
	function checkAccess(accountAccessSettings, globalPrivileges, bitMask) {
	    if (globalPrivileges !== null && globalPrivileges !== undefined) {
	        return (globalPrivileges & bitMask) > 0;
	    }
	    if (Array.isArray(accountAccessSettings)) {
	        return accountAccessSettings.some(function (el) {
	            return (el.privileges & bitMask) > 0;
	        });
	    }
	    return false;
	}
	
	var Transactions = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token,
	        adminPrivileges = _ref.adminPrivileges,
	        accountAccessSettings = _ref.accountAccessSettings,
	        globalPrivileges = _ref.globalPrivileges;
	
	    var mountedRef = (0, _react.useRef)(true);
	    var initialTagsRef = (0, _react.useRef)([]);
	    (0, _react.useEffect)(function () {
	        return function () {
	            mountedRef.current = false;
	        };
	    }, []);
	
	    var routFilters = (0, _reactRouterDom.useParams)().filters;
	    var searchBy = [{ key: "id", locale: "Search.label.operationId", placeholder: "Search.example.id" }, { key: "description", locale: "Search.label.description", placeholder: "Search.example.description" }, { key: "rrn", locale: "Search.label.rrn", placeholder: "Search.example.rrn" }, {
	        key: "externalReference",
	        locale: "Search.label.externalReference",
	        placeholder: "Search.example.externalReference"
	    }, { key: "cardNumber", locale: "Search.label.cardNumber", placeholder: "Search.example.cardNumber" }, { key: "cardHolder", locale: "Search.label.cardHolder", placeholder: "Search.example.cardHolder" }, { key: "phone", locale: "Search.label.phone", placeholder: "Search.example.phone" }, { key: "amountEqually", locale: "Search.label.amountEqually", placeholder: "Search.example.amount" }, { key: "amountMore", locale: "Search.label.amountMore", placeholder: "Search.example.amount" }, { key: "amountLess", locale: "Search.label.amountLess", placeholder: "Search.example.amountLess" }];
	
	    var _useState = (0, _react.useState)("week"),
	        _useState2 = _slicedToArray(_useState, 2),
	        defaultPeriod = _useState2[0],
	        setDefaultPeriod = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(null),
	        _useState4 = _slicedToArray(_useState3, 2),
	        projects = _useState4[0],
	        setProjects = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(null),
	        _useState6 = _slicedToArray(_useState5, 2),
	        terminals = _useState6[0],
	        setTerminals = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(1),
	        _useState8 = _slicedToArray(_useState7, 2),
	        currentPage = _useState8[0],
	        setCurrentPage = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(10),
	        _useState10 = _slicedToArray(_useState9, 2),
	        postsPerPage = _useState10[0],
	        setPostsPerPage = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(0),
	        _useState12 = _slicedToArray(_useState11, 2),
	        transactionsCount = _useState12[0],
	        setTransactionsCount = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0),
	        _useState14 = _slicedToArray(_useState13, 2),
	        turnoverAmount = _useState14[0],
	        setTurnoverAmount = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        filterProjects = _useState16[0],
	        setFilterProjects = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        filterTerminals = _useState18[0],
	        setFilterTerminals = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({}),
	        _useState20 = _slicedToArray(_useState19, 2),
	        filterDate = _useState20[0],
	        setFilterDate = _useState20[1];
	
	    var _useState21 = (0, _react.useState)({}),
	        _useState22 = _slicedToArray(_useState21, 2),
	        filterBpaDate = _useState22[0],
	        setFilterBpaDate = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        filters = _useState24[0],
	        setFilters = _useState24[1];
	
	    var _useState25 = (0, _react.useState)([]),
	        _useState26 = _slicedToArray(_useState25, 2),
	        filtersTags = _useState26[0],
	        setFiltersTags = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(null),
	        _useState28 = _slicedToArray(_useState27, 2),
	        chartsData = _useState28[0],
	        setChartsData = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(null),
	        _useState30 = _slicedToArray(_useState29, 2),
	        mainChartData = _useState30[0],
	        setMainChartData = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(null),
	        _useState32 = _slicedToArray(_useState31, 2),
	        turnoverChartData = _useState32[0],
	        setTurnoverChartData = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(null),
	        _useState34 = _slicedToArray(_useState33, 2),
	        merchantsTurnoverData = _useState34[0],
	        setMerchantsTurnoverData = _useState34[1];
	
	    var _useState35 = (0, _react.useState)([]),
	        _useState36 = _slicedToArray(_useState35, 2),
	        transactionsData = _useState36[0],
	        setTransactionsData = _useState36[1];
	
	    var _useState37 = (0, _react.useState)({}),
	        _useState38 = _slicedToArray(_useState37, 2),
	        counts = _useState38[0],
	        setCounts = _useState38[1];
	
	    var _useState39 = (0, _react.useState)(true),
	        _useState40 = _slicedToArray(_useState39, 2),
	        isLoadingProjects = _useState40[0],
	        setIsLoadingProjects = _useState40[1];
	
	    var _useState41 = (0, _react.useState)(false),
	        _useState42 = _slicedToArray(_useState41, 2),
	        loadingTransactions = _useState42[0],
	        setLoadingTransactions = _useState42[1];
	
	    var _useState43 = (0, _react.useState)(false),
	        _useState44 = _slicedToArray(_useState43, 2),
	        loadingCharts = _useState44[0],
	        setLoadingCharts = _useState44[1];
	
	    var _useState45 = (0, _react.useState)(false),
	        _useState46 = _slicedToArray(_useState45, 2),
	        isFiltersOpen = _useState46[0],
	        setIsFiltersOpen = _useState46[1];
	
	    // Load projects and initial filters
	
	
	    (0, _react.useEffect)(function () {
	        new _Api2.default({ token: token }).getProjects().then(function (r) {
	            if (!mountedRef.current) return;
	            setProjects(r);
	            setIsLoadingProjects(false);
	        });
	
	        if (routFilters) {
	            var parseRouteFilters = JSON.parse(routFilters);
	
	            if (parseRouteFilters.filters) {
	                setFiltersTags(parseRouteFilters.filters);
	                initialTagsRef.current = parseRouteFilters.filters;
	                setDefaultPeriod("month");
	            }
	
	            if (parseRouteFilters.period) {
	                setDefaultPeriod(parseRouteFilters.period);
	
	                var startDate = null;
	                var endDate = null;
	
	                var options = {
	                    day: "numeric",
	                    month: "numeric",
	                    year: "numeric",
	                    hour: "numeric",
	                    minute: "numeric"
	                };
	                options.timeZoneName = "short";
	
	                switch (parseRouteFilters.period) {
	                    case "today":
	                        startDate = new Date();
	                        startDate.setHours(0, 0);
	                        endDate = new Date();
	                        break;
	                    case "month":
	                        startDate = new Date();
	                        startDate.setDate(new Date().getDate() - 30);
	                        startDate.setHours(0, 0);
	                        endDate = new Date();
	                        break;
	                    default:
	                        break;
	                }
	
	                var period = {
	                    startDate: String(startDate.toLocaleDateString("ru", options)),
	                    endDate: String(endDate.toLocaleDateString("ru", options))
	                };
	
	                applyFilters(null, null, period);
	                return;
	            }
	        }
	
	        applyFilters();
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, []);
	
	    // Build terminals list from selected projects
	    (0, _react.useEffect)(function () {
	        if (!projects || !Array.isArray(filterProjects) || filterProjects.length === 0) {
	            setTerminals(null);
	            setFilterTerminals([]);
	            return;
	        }
	
	        var terminalsAcc = [];
	        filterProjects.forEach(function (projectUUID) {
	            var project = projects.find(function (el) {
	                return el.uuid === projectUUID;
	            });
	            if (project && project.providers) {
	                project.providers.forEach(function (p) {
	                    return terminalsAcc.push(p);
	                });
	            }
	        });
	
	        // сохраняем только те терминалы, которые реально принадлежат выбранным проектам
	        var cleanFilterTerminals = filterTerminals.filter(function (uuid) {
	            return terminalsAcc.some(function (el) {
	                return el.uuid === uuid;
	            });
	        });
	
	        setFilterTerminals(cleanFilterTerminals);
	        setTerminals(terminalsAcc);
	    }, [filterProjects, projects]); // добавляем projects в зависимости
	
	    function selectFilter(selectedArray) {
	        setFilters(selectedArray);
	    }
	
	    function buildFiltersPayload(dateRangeOverride, tagsOverride) {
	        var tags = tagsOverride || filtersTags;
	        if (tags.length === 0 && initialTagsRef.current.length > 0) {
	            tags = initialTagsRef.current;
	            initialTagsRef.current = [];
	        }
	        var base = {
	            filters: [].concat(_toConsumableArray(filters), _toConsumableArray(tags)),
	            dateRange: dateRangeOverride ? dateRangeOverride : filterDate,
	            page: currentPage,
	            itemsPerPage: postsPerPage
	        };
	
	        if (filterBpaDate && (filterBpaDate.startDate || filterBpaDate.endDate)) {
	            base.balanceProcessedAtRange = filterBpaDate;
	        }
	
	        if (Array.isArray(filterProjects) && filterProjects.length > 0) {
	            base.projects = filterProjects;
	        }
	        if (Array.isArray(filterTerminals) && filterTerminals.length > 0) {
	            base.providers = filterTerminals;
	        }
	
	        return base;
	    }
	
	    function applyFilters(page, itemsPerPage, dateRange, tagsOverride) {
	        setLoadingTransactions(false);
	
	        var nextPage = page || 1;
	        var nextItems = itemsPerPage || postsPerPage;
	
	        setCurrentPage(nextPage);
	        setPostsPerPage(nextItems);
	
	        var payload = Object.assign({}, buildFiltersPayload(dateRange, tagsOverride), {
	            page: nextPage,
	            itemsPerPage: nextItems
	        });
	
	        // загрузка таблицы
	        new _Api2.default({ token: token }).setTransactionsFilters(payload).then(function (r) {
	            if (!mountedRef.current) return;
	
	            setTransactionsData(r && r.data ? r.data : []);
	
	            if (r && r.count && r.count.total) {
	                setTransactionsCount(Number(r.count.total.count));
	                var t = Number(r.count.total.turnover || 0);
	                setTurnoverAmount(Math.round((t + Number.EPSILON) * 100) / 100);
	            } else {
	                setTransactionsCount(0);
	                setTurnoverAmount(0);
	            }
	
	            var nextCounts = {};
	            if (r && r.count) {
	                Object.keys(r.count).forEach(function (k) {
	                    if (k !== "total") {
	                        var v = r.count[k];
	                        nextCounts[k] = Number(v && v.count ? v.count : 0);
	                    }
	                });
	            }
	
	            setCounts(nextCounts);
	            setLoadingTransactions(true);
	        });
	
	        // загрузка графиков
	        new _Api2.default({ token: token }).setTransactionsChartFilters(payload).then(function (r) {
	            if (!mountedRef.current) return;
	
	            setChartsData(r || null);
	            setMainChartData(r && r.main ? r.main : null);
	            setTurnoverChartData(r && r.turnover ? r.turnover : null);
	
	            var t = r && r.turnover && typeof r.turnover.total !== "undefined" ? Number(r.turnover.total) : 0;
	
	            setTurnoverAmount(Math.round((t + Number.EPSILON) * 100) / 100);
	
	            setLoadingCharts(true);
	        });
	
	        // админ-виджет: оборот по мерчантам (только админам)
	        if (adminPrivileges) {
	            new _Api2.default({ token: token }).setMerchantsTurnoverChart(payload).then(function (r) {
	                if (!mountedRef.current) return;
	                setMerchantsTurnoverData(r || null);
	            }).catch(function () {
	                if (!mountedRef.current) return;
	                setMerchantsTurnoverData({ rows: [], total: { amount: 0, count: 0 } });
	            });
	        }
	    }
	
	    function setPage(page, itemsPerPage) {
	        var newPage = page || 1;
	        var newItems = itemsPerPage || postsPerPage;
	
	        setCurrentPage(newPage);
	        setPostsPerPage(newItems);
	
	        var payload = Object.assign({}, buildFiltersPayload(), {
	            page: newPage,
	            itemsPerPage: newItems
	        });
	
	        new _Api2.default({ token: token }).setTransactionsFilters(payload).then(function (r) {
	            if (!mountedRef.current) return;
	
	            setTransactionsData(r && r.data ? r.data : []);
	            setTransactionsCount(Number(r && r.count && r.count.total ? r.count.total.count : 0));
	
	            var nextCounts = {};
	            if (r && r.count) {
	                Object.keys(r.count).forEach(function (k) {
	                    if (k !== "total") {
	                        var v = r.count[k];
	                        nextCounts[k] = Number(v && v.count ? v.count : 0);
	                    }
	                });
	            }
	
	            setCounts(nextCounts);
	        });
	    }
	
	    function onSelectProjects(data) {
	        setFilterProjects(data);
	    }
	
	    function onSelectTerminals(data) {
	        setFilterTerminals(data);
	    }
	
	    function onChangeSearch(tags) {
	        setFiltersTags(tags);
	    }
	
	    function visibleStatusKeys(cData) {
	        if (!cData) return [];
	        var keys = Object.keys(cData).filter(function (k) {
	            return k !== "main" && k !== "turnover";
	        });
	        if (adminPrivileges) return keys;
	        return keys.filter(function (k) {
	            return USER_ALLOWED.indexOf(k) !== -1;
	        });
	    }
	
	    if (!checkAccess(accountAccessSettings, globalPrivileges, STATISTICS_ACCESS)) {
	        return _react2.default.createElement(
	            _Layout.Wrapper,
	            null,
	            _react2.default.createElement(
	                _Layout.Container,
	                { style: { justifyContent: "center" } },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: 1180 },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "d-flex justify-content-center align-items-center", style: { minHeight: '60vh' } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "h4",
	                                null,
	                                "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-muted" },
	                                "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430"
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	
	    var filtersContent = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            _EmptyCard2.default,
	            null,
	            _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                label: "FieldsHelper.label.project",
	                placeholder: "FieldsHelper.label.selectProject",
	                values: projects,
	                selectedValues: filterProjects,
	                isLoading: isLoadingProjects,
	                onChange: onSelectProjects,
	                excludeSearchColumn: []
	            }),
	            _react2.default.createElement(_FieldsHelper.MultipleSelect, {
	                label: "FieldsHelper.label.terminal",
	                placeholder: "FieldsHelper.label.selectTerminal",
	                values: terminals,
	                selectedValues: filterTerminals,
	                isLoading: isLoadingProjects,
	                onChange: onSelectTerminals,
	                excludeSearchColumn: []
	            })
	        ),
	        _react2.default.createElement(
	            _EmptyCard2.default,
	            null,
	            _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                    return setFilterDate(range);
	                }, defaultPeriod: defaultPeriod })
	        ),
	        _react2.default.createElement(
	            _EmptyCard2.default,
	            null,
	            _react2.default.createElement(
	                "div",
	                { style: { fontSize: ".8125rem", fontWeight: 600, marginBottom: 4 } },
	                "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F"
	            ),
	            _react2.default.createElement(_DateRange2.default, { onSelectDate: function onSelectDate(range) {
	                    return setFilterBpaDate(range);
	                }, defaultPeriod: null })
	        ),
	        _react2.default.createElement(_TransactionsFilters2.default, {
	            token: token,
	            adminPrivileges: adminPrivileges,
	            projects: filterProjects,
	            onApplyFilters: applyFilters,
	            onSelectFilter: selectFilter,
	            isLoading: loadingTransactions
	        }),
	        _react2.default.createElement(_ReportWidget2.default, {
	            access: true,
	            token: token,
	            type: "transactions",
	            filter: buildFiltersPayload(),
	            count: transactionsCount,
	            countLabel: "Операций",
	            date: filterDate,
	            name: "transactions_report"
	        }),
	        _react2.default.createElement(_ReportWidget2.default, {
	            access: ["STATISTICS_REPORT_1C_VIEW"],
	            token: token,
	            type: "transactions1C",
	            filter: buildFiltersPayload(),
	            count: transactionsCount,
	            countLabel: "Операций",
	            date: filterDate,
	            name: "transactions_1Creport"
	        })
	    );
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            null,
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-between align-items-center mb-3" },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        "\u041F\u043B\u0430\u0442\u0435\u0436\u0438"
	                    )
	                ),
	                _react2.default.createElement(
	                    "button",
	                    {
	                        type: "button",
	                        className: _stylesModule2.default.FiltersToggle,
	                        onClick: function onClick() {
	                            return setIsFiltersOpen(true);
	                        }
	                    },
	                    "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    loadingCharts ? _react2.default.createElement(
	                        _HTabBar2.default,
	                        null,
	                        _react2.default.createElement(
	                            _TabBarItem2.default,
	                            {
	                                label: "\u041E\u0431\u0449\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
	                                count: transactionsCount ? transactionsCount + " шт." : "0 шт",
	                                isVisible: true
	                            },
	                            _react2.default.createElement(_MainTransactionsChart2.default, { data: mainChartData, count: transactionsCount })
	                        ),
	                        chartsData && visibleStatusKeys(chartsData).map(function (key) {
	                            var chart = chartsData[key];
	                            var label = LABELS[key] || key;
	                            var color = COLORS[key] || "#000000";
	                            var cntFromCounts = typeof counts[key] !== "undefined" ? counts[key] : chart && chart.count ? chart.count : 0;
	
	                            // ВАЖНО: не возвращаем null — отдаём скрытый TabBarItem
	                            if (!adminPrivileges && !cntFromCounts) {
	                                return _react2.default.createElement(
	                                    _TabBarItem2.default,
	                                    {
	                                        key: key,
	                                        label: label,
	                                        labelColor: color,
	                                        count: "0 шт.",
	                                        isVisible: false
	                                    },
	                                    _react2.default.createElement("div", null)
	                                );
	                            }
	
	                            return _react2.default.createElement(
	                                _TabBarItem2.default,
	                                {
	                                    key: key,
	                                    label: label,
	                                    labelColor: color,
	                                    count: cntFromCounts + " шт.",
	                                    isVisible: true
	                                },
	                                _react2.default.createElement(_TransactionsLineChart2.default, {
	                                    data: chart,
	                                    vAxisLabel: label + ", шт",
	                                    lineColor: color,
	                                    count: cntFromCounts
	                                })
	                            );
	                        }),
	                        _react2.default.createElement(
	                            _TabBarItem2.default,
	                            {
	                                label: "\u041E\u0431\u043E\u0440\u043E\u0442",
	                                labelColor: COLORS.turnover,
	                                count: turnoverAmount ? turnoverAmount.toLocaleString() + " ₽" : "0 ₽",
	                                isVisible: true
	                            },
	                            _react2.default.createElement(_TransactionsLineChart2.default, {
	                                data: turnoverChartData,
	                                vAxisLabel: "Оборот",
	                                lineColor: COLORS.turnover,
	                                count: turnoverAmount
	                            })
	                        )
	                    ) : _react2.default.createElement(_EmptyChart2.default, null)
	                ),
	                adminPrivileges && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { padding: "12px 16px 4px 16px", fontWeight: 600, fontSize: 15 } },
	                        "\u041E\u0431\u043E\u0440\u043E\u0442 \u043F\u043E \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430\u043C"
	                    ),
	                    _react2.default.createElement(_MerchantsTurnoverChart2.default, { data: merchantsTurnoverData })
	                ),
	                _react2.default.createElement(_SearchTags2.default, {
	                    onChangeSearch: onChangeSearch,
	                    onSearch: function onSearch(tags) {
	                        applyFilters(null, null, null, tags);
	                    },
	                    isDisabled: false,
	                    defaultSearch: searchBy[0],
	                    searchBy: searchBy
	                }),
	                _react2.default.createElement(_TransactionsTable2.default, {
	                    token: token,
	                    adminPrivileges: adminPrivileges,
	                    transactions: transactionsData,
	                    isLoading: loadingTransactions
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.PaginationWrap },
	                    _react2.default.createElement(_reactJsPagination2.default, {
	                        firstPageText: "\u21E4",
	                        prevPageText: "\u21E0",
	                        lastPageText: "\u21E5",
	                        nextPageText: "\u21E2",
	                        activeLinkClass: _stylesModule2.default.ActiveLink,
	                        activePage: currentPage,
	                        itemsCountPerPage: postsPerPage,
	                        totalItemsCount: transactionsCount,
	                        pageRangeDisplayed: 10,
	                        onChange: function onChange(page) {
	                            return setPage(page, postsPerPage);
	                        }
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SidebarColumn },
	                _react2.default.createElement(
	                    _ResponsiveSidebarFilters2.default,
	                    {
	                        title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B",
	                        isOpen: isFiltersOpen,
	                        onClose: function onClose() {
	                            return setIsFiltersOpen(false);
	                        }
	                    },
	                    filtersContent
	                )
	            )
	        )
	    );
	});
	
	exports.default = Transactions;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(2);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(646);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACCESS_ANTIFRAUD_FILE = 32768;
	
	var INTERNAL_PROVIDERS = ["tkb", "finstar", "manual", "nx"];
	var EXTERNAL_PROVIDERS = ["scanfraud"];
	
	/**
	 * Объединяет результаты провайдеров строки в 2 группы: Внутренняя / Внешняя.
	 */
	function mergeRowProviders(providers) {
	    if (!providers) return { internal: null, external: null };
	
	    var statusPriority = { blocked: 4, error: 3, ok: 2, skipped: 1 };
	
	    function mergeGroup(codes) {
	        var bestStatus = null;
	        var bestPriority = 0;
	        var reason = "";
	        var hasAny = false;
	
	        for (var i = 0; i < codes.length; i++) {
	            var p = providers[codes[i]];
	            if (!p) continue;
	            hasAny = true;
	            var prio = statusPriority[p.status] || 0;
	            if (prio > bestPriority) {
	                bestPriority = prio;
	                bestStatus = p.status;
	            }
	            if (p.status === "blocked" && p.reason) {
	                reason = p.reason;
	            }
	        }
	
	        if (!hasAny) return null;
	        return { status: bestStatus || "skipped", reason: reason };
	    }
	
	    return {
	        internal: mergeGroup(INTERNAL_PROVIDERS),
	        external: mergeGroup(EXTERNAL_PROVIDERS)
	    };
	}
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token,
	        accountAccessSettings = _ref.accountAccessSettings;
	
	    var msgCtx = (0, _react.useContext)(_MessageContext2.default);
	    var onMessage = msgCtx.onMessage;
	    var fileInputRef = (0, _react.useRef)(null);
	
	    var _pu = (0, _react.useState)(null);
	    var projectUUID = _pu[0];
	    var setProjectUUID = _pu[1];
	
	    var _r = (0, _react.useState)(null);
	    var batchResult = _r[0];
	    var setBatchResult = _r[1];
	
	    var _l = (0, _react.useState)(false);
	    var isChecking = _l[0];
	    var setIsChecking = _l[1];
	
	    var _lp = (0, _react.useState)(true);
	    var loadingProjects = _lp[0];
	    var setLoadingProjects = _lp[1];
	
	    var _drag = (0, _react.useState)(false);
	    var isDragging = _drag[0];
	    var setIsDragging = _drag[1];
	
	    // Load projects and auto-select first with ACCESS_ANTIFRAUD_FILE permission
	    (0, _react.useEffect)(function () {
	        var cancelled = false;
	        new _Api2.default({ token: token }).getProjects().then(function (data) {
	            if (cancelled) return;
	            var list = Array.isArray(data) ? data : [];
	            var settings = accountAccessSettings || [];
	
	            var found = null;
	            for (var i = 0; i < list.length; i++) {
	                var p = list[i];
	                for (var j = 0; j < settings.length; j++) {
	                    if (settings[j].merchantUUID === p.uuid && (settings[j].privileges & ACCESS_ANTIFRAUD_FILE) > 0) {
	                        found = p.uuid;
	                        break;
	                    }
	                }
	                if (found) break;
	            }
	
	            if (!found && list.length > 0) {
	                found = list[0].uuid;
	            }
	
	            if (found) {
	                setProjectUUID(found);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            if (!cancelled) onMessage({ type: "error", message: "Ошибка загрузки проектов" });
	        }).finally(function () {
	            if (!cancelled) setLoadingProjects(false);
	        });
	        return function () {
	            cancelled = true;
	        };
	    }, [token, accountAccessSettings]);
	
	    function handleFile(file) {
	        if (!file) return;
	
	        var ext = (file.name || "").split(".").pop().toLowerCase();
	        if (ext !== "xlsx" && ext !== "csv" && ext !== "xls") {
	            onMessage({ type: "error", message: "Поддерживаются только файлы XLSX, XLS и CSV" });
	            return;
	        }
	
	        if (!projectUUID) {
	            onMessage({ type: "error", message: "Нет доступных проектов" });
	            return;
	        }
	
	        setIsChecking(true);
	        setBatchResult(null);
	
	        var formData = new FormData();
	        formData.append("file", file);
	        formData.append("merchantUuid", projectUUID);
	
	        new _Api2.default({ token: token }).antifraudBatchCheck(formData).then(function (data) {
	            setBatchResult(data);
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка проверки файла";
	            onMessage({ type: "error", message: msg });
	        }).finally(function () {
	            setIsChecking(false);
	        });
	    }
	
	    function onDrop(e) {
	        e.preventDefault();
	        setIsDragging(false);
	        var files = e.dataTransfer && e.dataTransfer.files;
	        if (files && files.length > 0) {
	            handleFile(files[0]);
	        }
	    }
	
	    function onDragOver(e) {
	        e.preventDefault();
	        setIsDragging(true);
	    }
	
	    function onDragLeave(e) {
	        e.preventDefault();
	        setIsDragging(false);
	    }
	
	    function onFileSelect(e) {
	        var files = e.target.files;
	        if (files && files.length > 0) {
	            handleFile(files[0]);
	        }
	        if (fileInputRef.current) {
	            fileInputRef.current.value = "";
	        }
	    }
	
	    function clearResults() {
	        setBatchResult(null);
	    }
	
	    function downloadCsv() {
	        if (!batchResult || !batchResult.results) return;
	
	        var headers = ["#", "Карта", "Телефон", "ИНН", "IP", "Статус", "Внутренняя", "Внешняя"];
	        var rows = [headers.join(";")];
	
	        batchResult.results.forEach(function (r) {
	            var d = r.data || {};
	            var merged = mergeRowProviders(r.providers);
	
	            function formatGroup(g) {
	                if (!g) return "-";
	                if (g.status === "blocked") return "НАЙДЕНО" + (g.reason ? ": " + g.reason : "");
	                if (g.status === "ok") return "Не найдено";
	                return g.status;
	            }
	
	            var row = [r.row, d.card_pan || "", d.phone || "", d.inn || "", d.ip || "", r.blocked ? "BLOCKED" : "OK", formatGroup(merged.internal), formatGroup(merged.external)];
	            rows.push(row.join(";"));
	        });
	
	        var csvContent = "\uFEFF" + rows.join("\n");
	        var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
	        var url = URL.createObjectURL(blob);
	        var link = document.createElement("a");
	        link.href = url;
	        link.download = "antifraud-results.csv";
	        link.click();
	        URL.revokeObjectURL(url);
	    }
	
	    if (loadingProjects) {
	        return _react2.default.createElement(
	            _Layout.Wrapper,
	            null,
	            _react2.default.createElement(
	                _Layout.Container,
	                { className: _stylesModule2.default.StackOnMobile },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "780", className: _stylesModule2.default.MainColumn },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.LoaderBox },
	                        _react2.default.createElement(_Loader2.default, null)
	                    )
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { className: _stylesModule2.default.StackOnMobile },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _stylesModule2.default.Title },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "UserMenu.title.antifraudFileCheck", defaultMessage: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0444\u0430\u0439\u043B\u0430" })
	                    ),
	                    !batchResult && !isChecking && _react2.default.createElement(
	                        "div",
	                        {
	                            className: isDragging ? _stylesModule2.default.DropZoneActive : _stylesModule2.default.DropZone,
	                            onDrop: onDrop,
	                            onDragOver: onDragOver,
	                            onDragLeave: onDragLeave,
	                            onClick: function onClick() {
	                                fileInputRef.current && fileInputRef.current.click();
	                            }
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DropIcon },
	                            "\uD83D\uDCC4"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DropText },
	                            "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B XLSX/CSV \u0441\u044E\u0434\u0430 \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.DropHint },
	                            "\u0421\u0442\u043E\u043B\u0431\u0446\u044B: card_pan, phone, inn, ip (\u043C\u0438\u043D\u0438\u043C\u0443\u043C 1)"
	                        ),
	                        _react2.default.createElement("input", {
	                            ref: fileInputRef,
	                            type: "file",
	                            accept: ".xlsx,.xls,.csv",
	                            onChange: onFileSelect,
	                            style: { display: "none" }
	                        })
	                    ),
	                    isChecking && _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.CheckingBox },
	                        _react2.default.createElement(_Loader2.default, null),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.CheckingText },
	                            "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0444\u0430\u0439\u043B\u0430..."
	                        )
	                    ),
	                    batchResult && batchResult.results && _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.ResultsSection },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.TableWrapper },
	                            _react2.default.createElement(
	                                "table",
	                                { className: _stylesModule2.default.Table },
	                                _react2.default.createElement(
	                                    "thead",
	                                    null,
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "#"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0414\u0430\u043D\u043D\u044B\u0435"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0421\u0442\u0430\u0442\u0443\u0441"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0412\u043D\u0435\u0448\u043D\u044F\u044F"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "\u0412\u0440\u0435\u043C\u044F"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    batchResult.results.map(function (r, idx) {
	                                        var d = r.data || {};
	                                        var dataStr = [d.card_pan, d.phone, d.inn, d.ip].filter(Boolean).join(", ") || "-";
	                                        var merged = mergeRowProviders(r.providers);
	
	                                        function renderGroup(g) {
	                                            if (!g) return _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                "-"
	                                            );
	                                            var cls = g.status === "blocked" ? _stylesModule2.default.ProviderBlocked : g.status === "ok" ? _stylesModule2.default.ProviderOk : _stylesModule2.default.ProviderSkipped;
	                                            var label = g.status === "blocked" ? "Найдено" : g.status === "ok" ? "Не найдено" : g.status === "error" ? "Ошибка" : "—";
	                                            var hint = g.reason || g.status;
	                                            return _react2.default.createElement(
	                                                "td",
	                                                { className: cls, title: hint },
	                                                label
	                                            );
	                                        }
	
	                                        return _react2.default.createElement(
	                                            "tr",
	                                            { key: idx, className: r.blocked ? _stylesModule2.default.RowBlocked : "" },
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                r.row
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                { className: _stylesModule2.default.DataCell, title: dataStr },
	                                                dataStr
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "span",
	                                                    { className: r.blocked ? _stylesModule2.default.StatusBadgeBlocked : _stylesModule2.default.StatusBadgeOk },
	                                                    r.blocked ? "Блок" : "OK"
	                                                )
	                                            ),
	                                            renderGroup(merged.internal),
	                                            renderGroup(merged.external),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                (r.checkTimeMs / 1000).toFixed(2),
	                                                " \u0441\u0435\u043A"
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Actions },
	                            _react2.default.createElement(
	                                "button",
	                                { className: _stylesModule2.default.BtnPrimary, onClick: clearResults },
	                                "\u041D\u043E\u0432\u0430\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430"
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SideColumn },
	                batchResult && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SideCard },
	                    _react2.default.createElement(
	                        "h6",
	                        { className: _stylesModule2.default.SideTitle },
	                        "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.SummaryGrid },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SummaryItem },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryLabel },
	                                "\u0424\u0430\u0439\u043B:"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryValue },
	                                batchResult.name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SummaryItem },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryLabel },
	                                "\u0412\u0441\u0435\u0433\u043E:"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryValue },
	                                batchResult.total
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SummaryItem },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryLabel },
	                                "OK:"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryValueOk },
	                                batchResult.ok
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SummaryItem },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryLabel },
	                                "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E:"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryValueBlocked },
	                                batchResult.blocked
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.SummaryItem },
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryLabel },
	                                "\u0412\u0440\u0435\u043C\u044F:"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: _stylesModule2.default.SummaryValue },
	                                (batchResult.totalTimeMs / 1000).toFixed(2),
	                                " \u0441\u0435\u043A"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: _stylesModule2.default.BtnDownload, onClick: downloadCsv },
	                        "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (CSV)"
	                    )
	                ),
	                !batchResult && _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SideCard },
	                    _react2.default.createElement(
	                        "h6",
	                        { className: _stylesModule2.default.SideTitle },
	                        "\u0424\u043E\u0440\u043C\u0430\u0442 \u0444\u0430\u0439\u043B\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.HelpText },
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B XLSX \u0438\u043B\u0438 CSV \u0441\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u0441\u0442\u043E\u043B\u0431\u0446\u0430\u043C\u0438 (\u043C\u0438\u043D\u0438\u043C\u0443\u043C \u043E\u0434\u0438\u043D):"
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            null,
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "card_pan"
	                                ),
	                                " \u2014 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B (13-19 \u0446\u0438\u0444\u0440)"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "phone"
	                                ),
	                                " \u2014 \u0442\u0435\u043B\u0435\u0444\u043E\u043D (\u0432 \u043B\u044E\u0431\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435)"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "inn"
	                                ),
	                                " \u2014 \u0418\u041D\u041D (10 \u0438\u043B\u0438 12 \u0446\u0438\u0444\u0440)"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "ip"
	                                ),
	                                " \u2014 IP \u0430\u0434\u0440\u0435\u0441"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "\u041F\u0435\u0440\u0432\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430 \u2014 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0438. \u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C 1000 \u0441\u0442\u0440\u043E\u043A."
	                        )
	                    )
	                )
	            )
	        )
	    );
	});

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _Api = __webpack_require__(3);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Auth = __webpack_require__(4);
	
	var _Layout = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(2);
	
	var _MessageContext = __webpack_require__(12);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _Loader = __webpack_require__(8);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _stylesModule = __webpack_require__(647);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACCESS_ANTIFRAUD_SINGLE = 65536;
	
	var INTERNAL_PROVIDERS = ["tkb", "finstar", "manual", "nx"];
	var EXTERNAL_PROVIDERS = ["scanfraud"];
	
	var STATUS_LABELS = {
	    ok: "Не найдено",
	    blocked: "Найдено",
	    skipped: "Пропущено",
	    error: "Ошибка"
	};
	
	var KIND_LABELS = {
	    card_pan: "Карта",
	    phone: "Телефон",
	    sbp_phone: "Телефон (СБП)",
	    inn: "ИНН",
	    ip: "IP"
	};
	
	/**
	 * Объединяет результаты провайдеров в 2 группы: Внутренняя / Внешняя.
	 * Для каждой группы берётся "худший" статус: blocked > error > ok > skipped.
	 */
	function mergeProviderGroups(providers) {
	    if (!providers) return [];
	
	    var groups = [{ label: "Внутренняя", codes: INTERNAL_PROVIDERS }, { label: "Внешняя", codes: EXTERNAL_PROVIDERS }];
	
	    var statusPriority = { blocked: 4, error: 3, ok: 2, skipped: 1 };
	
	    var merged = [];
	    for (var g = 0; g < groups.length; g++) {
	        var group = groups[g];
	        var bestStatus = null;
	        var bestPriority = 0;
	        var details = [];
	        var totalMs = 0;
	        var hasAny = false;
	
	        for (var i = 0; i < group.codes.length; i++) {
	            var code = group.codes[i];
	            var p = providers[code];
	            if (!p) continue;
	            hasAny = true;
	            var prio = statusPriority[p.status] || 0;
	            if (prio > bestPriority) {
	                bestPriority = prio;
	                bestStatus = p.status;
	            }
	            totalMs += p.ms || 0;
	            if (p.status === "blocked") {
	                var kindLabel = p.kind ? KIND_LABELS[p.kind] || p.kind : "";
	                details.push(kindLabel + (kindLabel && p.reason ? ": " : "") + (p.reason || ""));
	            }
	        }
	
	        if (!hasAny) continue;
	
	        merged.push({
	            label: group.label,
	            status: bestStatus || "skipped",
	            details: details.length > 0 ? details.join("; ") : "—",
	            ms: totalMs
	        });
	    }
	    return merged;
	}
	
	exports.default = (0, _Auth.withAuth)(function (_ref) {
	    var token = _ref.token,
	        accountAccessSettings = _ref.accountAccessSettings;
	
	    var msgCtx = (0, _react.useContext)(_MessageContext2.default);
	    var onMessage = msgCtx.onMessage;
	
	    var _pu = (0, _react.useState)(null);
	    var projectUUID = _pu[0];
	    var setProjectUUID = _pu[1];
	
	    var _f = (0, _react.useState)({ cardPan: "", phone: "", inn: "", clientIp: "" });
	    var form = _f[0];
	    var setForm = _f[1];
	
	    var _r = (0, _react.useState)(null);
	    var result = _r[0];
	    var setResult = _r[1];
	
	    var _l = (0, _react.useState)(false);
	    var isChecking = _l[0];
	    var setIsChecking = _l[1];
	
	    var _lp = (0, _react.useState)(true);
	    var loadingProjects = _lp[0];
	    var setLoadingProjects = _lp[1];
	
	    // Load projects and auto-select first with ACCESS_ANTIFRAUD_SINGLE permission
	    (0, _react.useEffect)(function () {
	        var cancelled = false;
	        new _Api2.default({ token: token }).getProjects().then(function (data) {
	            if (cancelled) return;
	            var list = Array.isArray(data) ? data : [];
	            var settings = accountAccessSettings || [];
	
	            var found = null;
	            for (var i = 0; i < list.length; i++) {
	                var p = list[i];
	                for (var j = 0; j < settings.length; j++) {
	                    if (settings[j].merchantUUID === p.uuid && (settings[j].privileges & ACCESS_ANTIFRAUD_SINGLE) > 0) {
	                        found = p.uuid;
	                        break;
	                    }
	                }
	                if (found) break;
	            }
	
	            if (!found && list.length > 0) {
	                found = list[0].uuid;
	            }
	
	            if (found) {
	                setProjectUUID(found);
	            }
	        }).catch(function (err) {
	            Sentry.captureException(err);
	            if (!cancelled) onMessage({ type: "error", message: "Ошибка загрузки проектов" });
	        }).finally(function () {
	            if (!cancelled) setLoadingProjects(false);
	        });
	        return function () {
	            cancelled = true;
	        };
	    }, [token, accountAccessSettings]);
	
	    function onFieldChange(field, value) {
	        setForm(function (prev) {
	            var copy = Object.assign({}, prev);
	            copy[field] = value;
	            return copy;
	        });
	        setResult(null);
	    }
	
	    function hasAnyField() {
	        return form.cardPan.trim() !== "" || form.phone.trim() !== "" || form.inn.trim() !== "" || form.clientIp.trim() !== "";
	    }
	
	    function handleSubmit() {
	        if (!projectUUID) {
	            onMessage({ type: "error", message: "Нет доступных проектов" });
	            return;
	        }
	        if (!hasAnyField()) {
	            onMessage({ type: "error", message: "Заполните хотя бы одно поле для проверки" });
	            return;
	        }
	
	        setIsChecking(true);
	        setResult(null);
	
	        var payload = {};
	        if (form.cardPan.trim()) payload.cardPan = form.cardPan.trim();
	        if (form.phone.trim()) payload.phone = form.phone.trim();
	        if (form.inn.trim()) payload.inn = form.inn.trim();
	        if (form.clientIp.trim()) payload.clientIp = form.clientIp.trim();
	
	        new _Api2.default({ token: token }).antifraudSingleCheck(projectUUID, payload).then(function (data) {
	            setResult(data);
	        }).catch(function (e) {
	            Sentry.captureException(e);
	            var msg = e.response && e.response.data && e.response.data.message || e.message || "Ошибка проверки";
	            onMessage({ type: "error", message: msg });
	        }).finally(function () {
	            setIsChecking(false);
	        });
	    }
	
	    function clearForm() {
	        setForm({ cardPan: "", phone: "", inn: "", clientIp: "" });
	        setResult(null);
	    }
	
	    if (loadingProjects) {
	        return _react2.default.createElement(
	            _Layout.Wrapper,
	            null,
	            _react2.default.createElement(
	                _Layout.Container,
	                { className: _stylesModule2.default.StackOnMobile },
	                _react2.default.createElement(
	                    _Layout.Column,
	                    { width: "780", className: _stylesModule2.default.MainColumn },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.LoaderBox },
	                        _react2.default.createElement(_Loader2.default, null)
	                    )
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _Layout.Wrapper,
	        null,
	        _react2.default.createElement(
	            _Layout.Container,
	            { className: _stylesModule2.default.StackOnMobile },
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "780", className: _stylesModule2.default.MainColumn },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.Card },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: _stylesModule2.default.Title },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: "UserMenu.title.antifraudSingleCheck",
	                            defaultMessage: "\u0420\u0430\u0437\u043E\u0432\u0430\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.FormGrid },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Field },
	                            _react2.default.createElement(
	                                "label",
	                                { className: _stylesModule2.default.Label },
	                                "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                className: _stylesModule2.default.Input,
	                                placeholder: "4111111111111111",
	                                value: form.cardPan,
	                                onChange: function onChange(e) {
	                                    onFieldChange("cardPan", e.target.value);
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Field },
	                            _react2.default.createElement(
	                                "label",
	                                { className: _stylesModule2.default.Label },
	                                "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                className: _stylesModule2.default.Input,
	                                placeholder: "79001234567",
	                                value: form.phone,
	                                onChange: function onChange(e) {
	                                    onFieldChange("phone", e.target.value);
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Field },
	                            _react2.default.createElement(
	                                "label",
	                                { className: _stylesModule2.default.Label },
	                                "\u0418\u041D\u041D"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                className: _stylesModule2.default.Input,
	                                placeholder: "7700000000",
	                                value: form.inn,
	                                onChange: function onChange(e) {
	                                    onFieldChange("inn", e.target.value);
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _stylesModule2.default.Field },
	                            _react2.default.createElement(
	                                "label",
	                                { className: _stylesModule2.default.Label },
	                                "IP \u0430\u0434\u0440\u0435\u0441"
	                            ),
	                            _react2.default.createElement("input", {
	                                type: "text",
	                                className: _stylesModule2.default.Input,
	                                placeholder: "192.168.1.1",
	                                value: form.clientIp,
	                                onChange: function onChange(e) {
	                                    onFieldChange("clientIp", e.target.value);
	                                }
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.Actions },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: _stylesModule2.default.BtnPrimary,
	                                onClick: handleSubmit,
	                                disabled: isChecking || !hasAnyField() || !projectUUID
	                            },
	                            isChecking ? _react2.default.createElement(_Loader2.default, { isString: true }) : "Проверить"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { className: _stylesModule2.default.BtnSecondary, onClick: clearForm },
	                            "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C"
	                        )
	                    )
	                ),
	                result && _react2.default.createElement(
	                    "div",
	                    { className: result.blocked ? _stylesModule2.default.ResultBlocked : _stylesModule2.default.ResultOk },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.ResultHeader },
	                        _react2.default.createElement(
	                            "span",
	                            { className: result.blocked ? _stylesModule2.default.BadgeDanger : _stylesModule2.default.BadgeSuccess },
	                            result.blocked ? "ЗАБЛОКИРОВАНО" : "OK"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            {
	                                className: _stylesModule2.default.TimeBadge },
	                            (result.totalTimeMs / 1000).toFixed(2),
	                            " \u0441\u0435\u043A"
	                        )
	                    ),
	                    result.providers && _react2.default.createElement(
	                        "table",
	                        { className: _stylesModule2.default.ProvidersTable },
	                        _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0414\u0435\u0442\u0430\u043B\u0438"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "\u0412\u0440\u0435\u043C\u044F"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tbody",
	                            null,
	                            mergeProviderGroups(result.providers).map(function (row) {
	                                var statusClass = row.status === "blocked" ? _stylesModule2.default.StatusBlocked : row.status === "ok" ? _stylesModule2.default.StatusOk : _stylesModule2.default.StatusSkipped;
	                                return _react2.default.createElement(
	                                    "tr",
	                                    { key: row.label },
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        row.label
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        { className: statusClass },
	                                        STATUS_LABELS[row.status] || row.status
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        row.details
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        (row.ms / 1000).toFixed(2),
	                                        " \u0441\u0435\u043A"
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Layout.Column,
	                { width: "350", className: _stylesModule2.default.SideColumn },
	                _react2.default.createElement(
	                    "div",
	                    { className: _stylesModule2.default.SideCard },
	                    _react2.default.createElement(
	                        "h6",
	                        { className: _stylesModule2.default.SideTitle },
	                        "\u0421\u043F\u0440\u0430\u0432\u043A\u0430"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _stylesModule2.default.HelpText },
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043E\u0434\u043D\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u043B\u0435\u0439 \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043F\u043E \u0431\u0430\u0437\u0430\u043C \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u0430."
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            null,
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B"
	                                ),
	                                " \u2014 13-19 \u0446\u0438\u0444\u0440"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
	                                ),
	                                " \u2014 \u043D\u043E\u043C\u0435\u0440 \u0432 \u043B\u044E\u0431\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "\u0418\u041D\u041D"
	                                ),
	                                " \u2014 10 \u0438\u043B\u0438 12 \u0446\u0438\u0444\u0440"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "strong",
	                                    null,
	                                    "IP \u0430\u0434\u0440\u0435\u0441"
	                                ),
	                                " \u2014 IPv4 \u0438\u043B\u0438 IPv6"
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	});

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PrivateRout = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _Auth = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PrivateRout = (0, _Auth.withAuth)(function (_ref) {
	    var RouteComponent = _ref.component,
	        isAuthorized = _ref.isAuthorized,
	        forcedPasswordChange = _ref.forcedPasswordChange,
	        requires2FASetup = _ref.requires2FASetup,
	        rest = _objectWithoutProperties(_ref, ['component', 'isAuthorized', 'forcedPasswordChange', 'requires2FASetup']);
	
	    return _react2.default.createElement(_reactRouterDom.Route, Object.assign({}, rest, {
	        render: function render(routeProps) {
	            if (!isAuthorized) {
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/login" });
	            }
	
	            // Если требуется смена пароля или настройка 2FA - разрешаем только /profile
	            if (forcedPasswordChange || requires2FASetup) {
	                var pathname = routeProps.location && routeProps.location.pathname;
	                if (pathname === "/profile") {
	                    return _react2.default.createElement(RouteComponent, routeProps);
	                }
	                return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/profile" });
	            }
	
	            return _react2.default.createElement(RouteComponent, routeProps);
	        }
	    }));
	});
	exports.PrivateRout = PrivateRout;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(15);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * RetryManager Service
	 * Управляет повторными попытками API вызовов с exponential backoff
	 * и предотвращает бесконечные циклы запросов
	 */
	
	var RetryManager = function () {
	  function RetryManager() {
	    _classCallCheck(this, RetryManager);
	
	    // Отслеживаем текущие запросы по уникальному ключу
	    this.activeRequests = new Map(); // key -> { count, timestamp, timeoutId }
	    this.retryDelays = new Map(); // key -> delay в ms
	  }
	
	  /**
	   * Проверить, может ли запрос быть повторен
	   * @param {string} requestKey - Уникальный ключ запроса (например, "transactions_filter_page_1")
	   * @param {Object} options - { maxRetries: 3, backoffMultiplier: 2, baseDelay: 1000 }
	   * @returns {Object} { canRetry: boolean, delay: number, retryCount: number }
	   */
	
	
	  _createClass(RetryManager, null, [{
	    key: 'canRetry',
	    value: function canRetry(requestKey) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var _options$maxRetries = options.maxRetries,
	          maxRetries = _options$maxRetries === undefined ? 3 : _options$maxRetries,
	          _options$backoffMulti = options.backoffMultiplier,
	          backoffMultiplier = _options$backoffMulti === undefined ? 2 : _options$backoffMulti,
	          _options$baseDelay = options.baseDelay,
	          baseDelay = _options$baseDelay === undefined ? 1000 : _options$baseDelay;
	
	
	      var manager = this._getInstance();
	      var current = manager.activeRequests.get(requestKey);
	
	      // First request attempt - no entry in tracking map yet
	      if (!current) {
	        return {
	          canRetry: true,
	          delay: 0,
	          retryCount: 0,
	          reason: null
	        };
	      }
	
	      // Если уже было максимальное количество попыток
	      if (current.count >= maxRetries) {
	        return {
	          canRetry: false,
	          delay: 0,
	          retryCount: current.count,
	          reason: 'Max retries (' + maxRetries + ') exceeded'
	        };
	      }
	
	      // Если запрос слишком недавно (менее 100ms назад), не повторяем
	      var timeSinceLastAttempt = Date.now() - current.timestamp;
	      if (timeSinceLastAttempt < 100) {
	        return {
	          canRetry: false,
	          delay: 0,
	          retryCount: current.count,
	          reason: 'Request already in progress'
	        };
	      }
	
	      // Exponential backoff: delay = baseDelay * (backoffMultiplier ^ count)
	      var delay = baseDelay * Math.pow(backoffMultiplier, current.count);
	
	      return {
	        canRetry: true,
	        delay: delay,
	        retryCount: current.count,
	        reason: null
	      };
	    }
	
	    /**
	     * Регистрировать попытку запроса
	     * @param {string} requestKey - Уникальный ключ запроса
	     */
	
	  }, {
	    key: 'recordAttempt',
	    value: function recordAttempt(requestKey) {
	      var manager = this._getInstance();
	      var current = manager.activeRequests.get(requestKey) || { count: 0 };
	
	      manager.activeRequests.set(requestKey, {
	        count: current.count + 1,
	        timestamp: Date.now()
	      });
	    }
	
	    /**
	     * Очистить информацию о запросе при успехе
	     * @param {string} requestKey - Уникальный ключ запроса
	     */
	
	  }, {
	    key: 'clearRequest',
	    value: function clearRequest(requestKey) {
	      var manager = this._getInstance();
	      manager.activeRequests.delete(requestKey);
	    }
	
	    /**
	     * Проверить, находится ли запрос в состоянии retry
	     * @param {string} requestKey - Уникальный ключ запроса
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isRetrying',
	    value: function isRetrying(requestKey) {
	      var manager = this._getInstance();
	      var current = manager.activeRequests.get(requestKey);
	      return current && current.count > 0;
	    }
	
	    /**
	     * Получить количество попыток для запроса
	     * @param {string} requestKey - Уникальный ключ запроса
	     * @returns {number}
	     */
	
	  }, {
	    key: 'getRetryCount',
	    value: function getRetryCount(requestKey) {
	      var manager = this._getInstance();
	      var current = manager.activeRequests.get(requestKey);
	      return current ? current.count : 0;
	    }
	
	    /**
	     * Debounce функция с максимальным timeout
	     * @param {Function} func - Функция для debounce
	     * @param {number} delay - Delay в ms
	     * @param {number} maxWait - Максимальный timeout в ms
	     * @returns {Function}
	     */
	
	  }, {
	    key: 'debounce',
	    value: function debounce(func) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
	      var maxWait = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
	
	      var timeoutId = void 0;
	      var maxTimeoutId = void 0;
	      var lastCallTime = void 0;
	      var lastResult = void 0;
	
	      return function debounced() {
	        var _this = this;
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var now = Date.now();
	
	        // Если прошло больше maxWait с первого вызова, выполнить сразу
	        if (lastCallTime && now - lastCallTime > maxWait) {
	          clearTimeout(timeoutId);
	          if (maxTimeoutId) clearTimeout(maxTimeoutId);
	          lastResult = func.apply(this, args);
	          lastCallTime = now;
	          return lastResult;
	        }
	
	        lastCallTime = now;
	
	        // Отменить предыдущий timeout
	        clearTimeout(timeoutId);
	
	        // Установить новый timeout
	        timeoutId = setTimeout(function () {
	          func.apply(_this, args);
	        }, delay);
	
	        return lastResult;
	      };
	    }
	
	    /**
	     * Throttle функция - вызывать максимум раз в delay ms
	     * @param {Function} func - Функция для throttle
	     * @param {number} delay - Delay в ms
	     * @returns {Function}
	     */
	
	  }, {
	    key: 'throttle',
	    value: function throttle(func) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
	
	      var lastCallTime = 0;
	      var timeoutId = void 0;
	
	      return function throttled() {
	        var _this2 = this;
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        var now = Date.now();
	
	        if (now - lastCallTime >= delay) {
	          clearTimeout(timeoutId);
	          lastCallTime = now;
	          func.apply(this, args);
	        } else if (!timeoutId) {
	          // Если не вызывали в течение delay, запланировать для конца периода
	          timeoutId = setTimeout(function () {
	            lastCallTime = Date.now();
	            func.apply(_this2, args);
	            timeoutId = null;
	          }, delay - (now - lastCallTime));
	        }
	      };
	    }
	
	    /**
	     * Безопасно выполнить функцию с retry логикой
	     * @param {Function} fn - Async функция для выполнения
	     * @param {string} requestKey - Уникальный ключ запроса
	     * @param {Object} options - Опции retry
	     * @returns {Promise}
	     */
	
	  }, {
	    key: 'executeWithRetry',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(fn, requestKey) {
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        var retryInfo, result;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                retryInfo = this.canRetry(requestKey, options);
	
	                if (retryInfo.canRetry) {
	                  _context.next = 3;
	                  break;
	                }
	
	                throw new Error(retryInfo.reason || 'Max retries exceeded');
	
	              case 3:
	
	                this.recordAttempt(requestKey);
	
	                _context.prev = 4;
	                _context.next = 7;
	                return fn();
	
	              case 7:
	                result = _context.sent;
	
	                this.clearRequest(requestKey);
	                return _context.abrupt('return', result);
	
	              case 12:
	                _context.prev = 12;
	                _context.t0 = _context['catch'](4);
	                throw _context.t0;
	
	              case 15:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[4, 12]]);
	      }));
	
	      function executeWithRetry(_x6, _x7) {
	        return _ref.apply(this, arguments);
	      }
	
	      return executeWithRetry;
	    }()
	
	    /**
	     * Получить singleton instance
	     * @private
	     */
	
	  }, {
	    key: '_getInstance',
	    value: function _getInstance() {
	      if (!this._instance) {
	        this._instance = new RetryManager();
	      }
	      return this._instance;
	    }
	
	    /**
	     * Сбросить все отслеживания (для очистки при unmount)
	     */
	
	  }, {
	    key: 'resetAll',
	    value: function resetAll() {
	      var manager = this._getInstance();
	      manager.activeRequests.clear();
	      manager.retryDelays.clear();
	    }
	  }]);
	
	  return RetryManager;
	}();
	
	exports.default = RetryManager;

/***/ },
/* 512 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPayoutFee = getPayoutFee;
	exports.calcFee = calcFee;
	exports.calcAvailableForFee = calcAvailableForFee;
	exports.calcAvailableForTerminal = calcAvailableForTerminal;
	/**
	 * Комиссия выплаты и «сколько можно выплатить с этого остатка».
	 *
	 * Формула комиссии одна и та же во всём кабинете:
	 *
	 *     fee(X) = fixedPerTransaction + max(X × cost / 100, costFixedMinimum)
	 *
	 * Она уже была рассыпана по страницам реестров копипастой; здесь она одна,
	 * чтобы карточка «Доступно к выплатам» и итог по загруженному файлу не
	 * разъезжались.
	 */
	
	/**
	 * Структура комиссии выплаты у терминала.
	 *
	 * @param {object|null} terminal
	 * @returns {object|null}
	 */
	function getPayoutFee(terminal) {
	    if (!terminal || !terminal.fee) {
	        return null;
	    }
	
	    return terminal.fee.payout || null;
	}
	
	/**
	 * Комиссия за одну выплату суммой amount.
	 *
	 * @param {object|null} fee
	 * @param {number|string} amount
	 * @returns {number}
	 */
	function calcFee(fee, amount) {
	    if (!fee) {
	        return 0;
	    }
	
	    var amountNum = Number(amount) || 0;
	    var cost = Number(fee.cost) || 0;
	    var min = Number(fee.costFixedMinimum) || 0;
	    var fixed = Number(fee.fixedPerTransaction) || 0;
	
	    return Math.max(amountNum * (cost / 100), min) + fixed;
	}
	
	/**
	 * Максимальная сумма X, которую можно выплатить одной строкой при остатке
	 * balance, чтобы после списания X вместе с комиссией остаток был не меньше
	 * нуля.
	 *
	 * Списание: debit(X) = X + fixed + max(X × cost/100, min). Отсюда два случая:
	 *
	 *   1) процентная комиссия не меньше минимума: X ≤ (balance − fixed) / (1 + cost/100)
	 *   2) сработал минимум:                       X ≤ balance − fixed − min
	 *
	 * Берём меньшее из двух — тогда сумма проходит при любом раскладе.
	 *
	 * @param {number|string} balance
	 * @param {object|null} fee
	 * @returns {number}
	 */
	function calcAvailableForFee(balance, fee) {
	    var balanceNum = Number(balance) || 0;
	
	    if (balanceNum <= 0) {
	        return 0;
	    }
	
	    if (!fee) {
	        return balanceNum;
	    }
	
	    var cost = Number(fee.cost) || 0;
	    var min = Number(fee.costFixedMinimum) || 0;
	    var fixed = Number(fee.fixedPerTransaction) || 0;
	
	    if (cost === 0 && min === 0 && fixed === 0) {
	        return balanceNum;
	    }
	
	    var availMin = balanceNum - fixed - min;
	
	    if (cost === 0) {
	        return Math.max(0, availMin);
	    }
	
	    var availPercent = (balanceNum - fixed) / (1 + cost / 100);
	
	    return Math.max(0, Math.min(availPercent, availMin));
	}
	
	/**
	 * Сколько можно выплатить через этот терминал с указанного остатка.
	 *
	 * @param {object|null} terminal
	 * @param {number|string} balance
	 * @returns {number}
	 */
	function calcAvailableForTerminal(terminal, balance) {
	    return calcAvailableForFee(balance, getPayoutFee(terminal));
	}

/***/ },
/* 513 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPublicPath = isPublicPath;
	/**
	 * Страницы, которые открываются без входа в кабинет.
	 *
	 * На них протухшая сессия не должна уводить на страницу входа: кабинет при
	 * запуске проверяет сохранённый токен, получает 401 и раньше перебрасывал на
	 * /login с любой страницы. Человек, открывший ссылку подтверждения почты из
	 * письма, вместо результата видел форму входа.
	 */
	var PUBLIC_PATHS = exports.PUBLIC_PATHS = ['/login', '/confirmation', '/widget', '/pay3', '/pay4', '/PayTransfer', '/npay'];
	
	function isPublicPath(pathname) {
	  if (!pathname) return false;
	
	  return PUBLIC_PATHS.some(function (path) {
	    return pathname === path || pathname.startsWith(path + '/');
	  });
	}

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = AdminLayout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RoleLayout = __webpack_require__(100);
	
	var _RoleLayout2 = _interopRequireDefault(_RoleLayout);
	
	var _menuConfig = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AdminLayout(props) {
	    return _react2.default.createElement(_RoleLayout2.default, Object.assign({}, props, {
	        scope: 'admin',
	        fallbackPath: '/',
	        menuConfig: function menuConfig() {
	            return (0, _menuConfig.createAdminHeaderMenuConfig)();
	        }
	    }));
	}

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PublicLayout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(93);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(171);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _stylesModule = __webpack_require__(113);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PublicLayout(_ref) {
	    var children = _ref.children,
	        footerProps = _ref.footerProps,
	        menuConfig = _ref.menuConfig;
	
	    return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.Wrapper },
	        _react2.default.createElement(_Header2.default, { menuConfig: menuConfig, showMenu: false }),
	        _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.Content + ' ' + _stylesModule2.default.PublicContent },
	            children
	        ),
	        _react2.default.createElement(_Footer2.default, footerProps)
	    );
	}

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = UserLayout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RoleLayout = __webpack_require__(100);
	
	var _RoleLayout2 = _interopRequireDefault(_RoleLayout);
	
	var _menuConfig = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserLayout(props) {
	    return _react2.default.createElement(_RoleLayout2.default, Object.assign({}, props, {
	        scope: 'user',
	        fallbackPath: '/console',
	        menuConfig: function menuConfig(_ref) {
	            var adminPrivileges = _ref.adminPrivileges;
	            return (0, _menuConfig.createUserHeaderMenuConfig)({ adminPrivileges: adminPrivileges });
	        }
	    }));
	}

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var useDebounce = function useDebounce(value, delay) {
	    var _useState = (0, _react.useState)(value),
	        _useState2 = _slicedToArray(_useState, 2),
	        debouncedValue = _useState2[0],
	        setDebouncedValue = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        var handler = setTimeout(function () {
	            setDebouncedValue(value);
	        }, delay);
	
	        return function () {
	            clearTimeout(handler);
	        };
	    }, [value]);
	
	    return debouncedValue;
	};
	
	exports.default = useDebounce;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(40);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _browser = __webpack_require__(7);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _tracing = __webpack_require__(293);
	
	var _reactRouterDom = __webpack_require__(10);
	
	var _App = __webpack_require__(329);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _ErrorBoundary = __webpack_require__(170);
	
	var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);
	
	__webpack_require__(649);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Sentry initialization
	Sentry.init({
	    dsn: 'https://75c03c5d99524030f37cb07c12a44ff6@s.unlimco.io/3',
	    environment: ("production") || 'production',
	    integrations: [new _tracing.Integrations.BrowserTracing()],
	    tracesSampleRate: 0.2,
	    beforeSend: function beforeSend(event) {
	        // Don't send events for 401 errors (expected auth flow)
	        if (event.exception && event.exception.values) {
	            var isAuthError = event.exception.values.some(function (v) {
	                return v.value && v.value.includes('401');
	            });
	            if (isAuthError) return null;
	        }
	        return event;
	    }
	});
	
	// Expose Sentry globally for debugging
	window.Sentry = Sentry;
	
	_reactDom2.default.render(_react2.default.createElement(
	    _ErrorBoundary2.default,
	    null,
	    _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        null,
	        _react2.default.createElement(_App2.default, null)
	    )
	), document.getElementById('app'));

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(520);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 520 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 521 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 522 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 523 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"_87dIvCCM9WjUPtOGK8Av3","Title":"_2OZrHMTyNL50ss02PnBroR","MasterToggle":"_1vxRBudBh80SfjIFlc4RAi","Group":"IvUO-cQcMtYdq1AqSQ-gK","GroupTitle":"_35jC_OwaY3yQGd_tB2uJzZ","Toggle":"_1LSEYH5CLoSGhAPeJHm5cb","ToggleInfo":"_2jnzREVrhGBXa0jQq_Fh5w","ToggleLabel":"_1vHCzo6SAs1vEy6U3uiac3","ToggleDesc":"_3FVTgzogb6gZpOMbuJvC93","PaidBadge":"_1r9uRDVKTWupVr4S-yFiKV","FreeBadge":"_1c_4FFRYEfmqgyjeRL8_by","SaveBtn":"_12qfklzIV1fnBtAjE7lwco","StatusMsg":"_2ujXey71e5ETJ6Sfoh_7-2","StatusSuccess":"-pNsI3j0QLBAaAyDC4_ut","StatusError":"M6E3JtSw-2-CyaEwqHzpJ","Disabled":"_2wn0L6-TJpFODaW1FOBJ4m"};

/***/ },
/* 524 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3_8mQaiH4GJ_Znixup9oE9","Body":"_1NE7HeUQQxmYbmh78kXCyw","Footer":"_3DcWZbbjj9cNmVI9aPjgw2","Group":"_2jEWI-4JVjO4ROpEkYv_Ad","Label":"_2P_PlJYiXrS1zqJeINEqhM","Select":"_2V5Y0U7knuE4rYe5Cxf1Yz","Input":"_3tBytBlag5VOb54ChRKx6U","Row":"_2A5UlNWcPG-QBvs9gTwuXZ","Btn":"_1zl-447gc5S2MvChZ33oV8","BtnReset":"_3wWg93WgrSesTZUTQy3gyL"};

/***/ },
/* 525 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3xO_Ga6CBYNC5NjQLG0F86","Table":"_3oupnIBWpQ3BglGdV34xJT","Row":"XpqiUXF8Yj2qmzZ4tklky","DetailRow":"cpGL9L0g4ATPS5BlftYVX","ResultOk":"rJsoixi6KCzZBjcbAqKHC","ResultBlocked":"_3375NrTmA3bkoPdlvPOO8w","ResultError":"_1G9e9bmQiIOiOggVMGwO1_","Empty":"Exi8YyHpmde6MpmQ3Xde_","DetailTable":"_1SZdbSmoDEtgF09lwEQr0c","DetailLabel":"_35BkHny80JAR0fu1jpO3HD","ProvidersTable":"NEOsjbzhUzDiu5d2LIdAL","PaginationWrap":"_27CykXRHB9QMZFk_MS6bEq","ActiveLink":"_2YeNFlWms33FJ1IBMJOW9V"};

/***/ },
/* 526 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2LOyH0bGLtbA9e1-BwiBmv","CardHeader":"_2ows0TQduPI_ZUwUzKybYE","CardBody":"_3UK1MXNyoQr7OYNQh05eQ-","Media":"_3nPUpytZPk3ENmvbKZU4KJ","MediaIcon":"_16e6S8m7V8DYjrD82PxFXD","MediaBody":"_1AnoRfi5muxpzlbt2lP4yH","MediaMore":"_3-cgrUfalKRDW4Bzjv_VLu","Desc":"ordgA7TPmViOThj60rnLx","Link":"_2wljltuPK9hjLIBHc7OLcU","HeaderLink":"nYBqLa3X7e3sLfni9Fkp8","Icon":"_3yrlmcVqtpEi8wpSskNBM3","HeaderIcon":"WYoAncOl1u4Q4qQspEo3u","Balances":"_202AY4G2AQqeUHkmck_Ub3","ExtendedBalances":"_126KgH4yI7yRRLkAQ6SyiI","BalanceRow":"_1DAPghRWUniQX-ZWmRtQ_b","BalanceLabel":"_1atJOXMi8QTjv1njULqPY7","BalanceValue":"_1Kmaae6-HfihrKaXung5C-","TransactionBalance":"_3EhLJ2ICCutD2q6dnaggmI","SettlementBalance":"_1FEjBmpEUIQfhyCSexDXqO","ActualBalance":"_2Cr_v4qXWLEzpKMo_Z_AZh","ExtendedMediaIcon":"_3EzZ8vLFDIkx1oMN8woMW0","IconCircle":"_1v-r7s3CS92j-Y5AaSmjGM","IconCircleGreen":"YKpxknfeo76_hYuw9QAtj","IconCircleBlue":"_3HqX8Lv9Jfu0KlrExj1sUN","IconCircleGold":"_3QpvMxQrtpIfJrfaH6opug"};

/***/ },
/* 527 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"ddfO1NePJzDyMRSLhhs5w","EmptyChart":"_1MAXOhk2wdy5J2mOd2zcGb"};

/***/ },
/* 528 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Btn":"qW8_i0pG0Koq4_dHJLCFG"};

/***/ },
/* 529 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1IOQzOAHjvIy11Bn4m2axk","Body":"wd5HyROch8PfeBeIY5Vta","Group":"_1DOiU0G_S-3Tk7d9xWgNYf","Title":"_6Umkj1n-EscUSiI7QAZ2-","Column":"_2LxLKEzsP8lirLtFazm9x1","CheckboxWrap":"_1kHjYiYaDLezsxjb_LvdVd","CustomCheckbox":"_3JxMBzqCkmI9Qqk7QJ9bMq","InputIcon":"_36KHiYlk5WBvQgduYietwN","ActiveIcon":"_1RnYnSVkSKIoUnr1NDnmq3","BlockIcon":"_1y8AQFsaVTQhFxoCemqoNm","InactiveIcon":"_1MFyLLgGLccUzyILBoHxSX","ClosedIcon":"_3gimwXxHE-y0ttwzyT2GcQ","Footer":"_1dsm9bMh6mibCD5UC-MxBN","Submit":"_2ztRQBS2sYukDzBqwZ-92O","buttonIcon":"D1VZhRfYW84FTcrCMksjp"};

/***/ },
/* 530 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"A4v4A0kGKLzTMQTFZfUoc","Header":"_2gJj_5rwVACcKl6o2Ppbqg","Title":"_1lW2HmMgObgdNhab8LWR0z","RecordId":"_2fwNpWHhUEd4IzRYsyQnfY","Body":"_1YqomynzIyKQApQbewGt6i","Row":"_1whHEVNr6EQK_VgTtSRsMf","Label":"_1yqEUzuTAtkviH2QX5i1J-","Value":"_2C5wXnSeRp4bkYzT2dkFGc","ValueMono":"L9KLloPS9aHuL4ka7yDKZ","StatusBlocked":"_2T-IHitrQQ6gfFnOwbFZXE","StatusOk":"_2l-havazBiCcfvL_SxAzLh","MetaSection":"TdmvZICpQadQmLXsW6LG6","Meta":"_11vrgtdNqI2vNrCGCi9uHP","Actions":"_2vjAF7nVaFA3iEksdFVUbJ","UnblockBtn":"_12NPxlK97l6ubz07X_-RO4","DeleteBtn":"_3Ff47yLabBU0zGfdQE2O94"};

/***/ },
/* 531 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1CXbe1l0cZtgFHCqCeNVbr","Body":"_3Pi5atKnRNC94Hr4B3-YdC","Group":"_2N7bZSK-JT47WtJ4QsOXmT","Title":"u2ykrsl_1VNgtbKHhWrVC","Column":"_3XLPs8tmnKPxafOv1cjTQ2","CheckboxWrap":"_1ZplbpiGpeqmnqxwEpbKCj","CustomCheckbox":"_11BOiWSRl-FSI0IununG8l","ActiveIcon":"_373Yg1XzNHrNs_HBEFXfWx","BlockIcon":"_3bL8t-p3d0LQmtfVDwqyRy","Footer":"_2Zy88X_YuHS3FNe_zt0nNp","Submit":"_3RUdKdqwHAYTEAqthe-GxY","Reset":"_3NeUfI4rico6yUwqN5mUW4","buttonIcon":"_3r87i7F96e_arMej2N0eTG"};

/***/ },
/* 532 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Form":"AYJbnCUfpskIu4reQF7eV","Field":"_2wEEQd3EySIPPmtgYbZHKI","Label":"_1pF1iomCvOSAvl_GJqQN8n","Input":"_2Vm0Gi2lKHOfaXbHD0ux9U","Select":"_2Rob8T3R2X_ve-7t9rILv-","Hint":"_1bkaSm1Hy4w3gWhn0lH3IU","Error":"_1-ZWT29HXNczVvB3b5d3hk","Actions":"_1Dj_uP-NqE2hMZi14YKyi2","Submit":"_3OL5yN0aDSVyO7b20VsIv_"};

/***/ },
/* 533 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"TCYw1YIPv_J1DIo0pDwob","CardBody":"_2TKqbsiFBRFNGrACtl4n5x","FiltersRow":"_2YuhvdToS4e6alRDGUazAM","FilterGroup":"_20lDBV_uICP0SvLs3Ibojg","Label":"_35D9ow7EKuoASB7ik048Fh","Select":"AqOLohlXEUfJ-e6FQvjAU","Input":"-EJlWkavTO0bz_7k_idmE","Actions":"zTdm2-JQiV4dZFvFITQPl","BtnPrimary":"_2cSts0wBWD2VbBC4q22BpJ","BtnSecondary":"_1MAETvQVJ-GPmlwYDNBTIX"};

/***/ },
/* 534 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TableScroll":"hGAC7_ksJjZ1RbcFqg3jd","Table":"_1PzxqRvvaILwWRFNBfSeSp","HeaderCell":"_1OYt5-SUDQE2WBIEB2IDQN","HeaderCellCenter":"eXM9YsBtbGchSerp3bTR4","Row":"v00EDK-hA-8HA1Kat8NKL","Cell":"_3CmsoVvPPsps20W3EreWAJ","CellCenter":"_2Fw0kfv26pPyRkaPrMSSo7","DateTime":"_2QMvcFIi-aML_PTaGLUjkV","Actor":"_3O1w5XlWZFCSP3HnGwVnaD","ActionBadge":"_2mtUf0vjTN7bfhZ3DJhuMQ","EntityType":"_3rcCkDKcC_R6OdJBaQ8jzG","EntityName":"_2iqPYIyfu03sEZIgMiDgH2","ExpandIcon":"_3ztQ3ql_LPcgefdJfgSxUV","DetailsRow":"t-V4G19GkfDseLyG7Z9Vx","DetailsCell":"_2QztzEUukcaCEEFcn98FcD","Changes":"yN5Nj8xIfeG7N8GzDJ29i","ChangesHeader":"_1YZ22qNDJ44gCs7WPobGdA","ChangeItem":"_3wQeu4vvi2jdMke6HJrixj","ChangeField":"_1A5ci5aXhJMtkwu8RLo_m_","ChangeOld":"_1CbwY8tf93JU8xGx0etD1X","ChangeArrow":"_15QQ4wsVmDxcLcxvs_2igj","ChangeNew":"_1b5UdVLwFMsb1EGlS3nNME","MetaInfo":"_2hxnuDjq0UXte19NOzFORA","Loading":"_8MosupniAGP5hW7wG_UJU","Spinner":"qIgRPT74GbBAauCE754ul","spin":"_2nVepokTPPeU9laPOJQG4T","Empty":"_37pGx1NISYpYrfuDs4W01E","EmptyIcon":"_30kAVKJXjI_eY_HQCMTt5w","EmptyText":"_1YtjIPiXnPNAIsRe0NSi7S","MobileList":"_3oFcWBti4ZqvsFNM1XiP8B","MobileCard":"_2mkEWv4-RJC6zuULYEuJIu","MobileRow":"_2QpbVCbl3fGsJv7pw8pqRZ","MobileEntityRow":"ELzUNnrZ885Vv948LQxxK","MobileDetails":"_13o8UCAMSOVliDKJAS5JNR"};

/***/ },
/* 535 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Bar":"_23kVbTjznWnU3AKXcuvHx","Count":"_2ytypWX03raU_OQ0WZLozN","BtnAntifraud":"_2vyxLCHG6vA88LFGpMsB5c","BtnSuccess":"_3GwK7lfSO7hxLp5Qk39m_F","BtnDecline":"_2j8bQIdnjkbzBQUBJRfkc","BtnMoveBack":"_1fe2UndiMrMo6Vzp69L4rx","BtnRegistry":"_16ShrZtil-JBhxNBZrOlcT","BtnClear":"_1OMiZk8hMqWTVedoWh11iJ","ModalContent":"_3-CHwyyDOxIAt9_jOtUPCs","ModalLabel":"_3p9e7a6U9R72wxMv1uNS1d","ModalFooter":"_2P1xCyrlU_zUbPohKheW4W","Input":"_2IjPF3JvY7CntkAPSR45l6","BtnAddToRegistry":"_14Dqmcb9l5tIQQhAabyCEA","RegistryList":"_2IZUywyP0vLAuek7GEaXSz","RegistryOption":"_291yGGu9JBONMiWseRVOnu","RegistryOptionSelected":"_3puvn8wB60uiZ9RNZQE-MN","RegistryOptionName":"CiiYbYwU0Qt-2V79k_KkP","RegistryOptionInfo":"_2ps9P-i_z408X7wp1KhKyb"};

/***/ },
/* 536 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"KanbanBoard":"Ta6soSzgPQ9fX5Ffx-ZTu","KanbanColumn":"_1S2h9psevgLvBaf4hba6jF","ColumnHeader":"QgxHLuahGBTLygUUayQKM","ColumnHeaderTop":"_12uupM07e8GHM6-Yg3pnc6","ColumnCheckbox":"_1SwiODSnFypwqBz_IK3AUN","ColumnTitle":"_21x65wk2JKk1yrHZxVJWss","ColumnMeta":"_3ZzNeZ6nqc_I4ML8ldTpBX","ColumnCount":"_3TBj90DizYCCtykXPujYie","ColumnSum":"_27h6ypBCPORRHDtFqOHQ0r","ColumnBody":"QE4JLMhhsddC0-uQZ9fhp","KanbanCard":"_2jX0p2jJDM8_YIprQmu0_V","KanbanCardActive":"_1E2M2UGYcSjwL91aWL5eaR","KanbanCardSelected":"_1JXt9mu34Vx5rgv-XZuq0c","CardCheckbox":"_25cH2WzjsaFaKaXq2v4QoQ","CardName":"ObQQbtIuiLyim_qRd4xjy","CardAmount":"zPe4SrbeLCA8IcSmtzQyt","CardMeta":"Xzo-kSN6zEivCwQj4OVV1","TypeBadge":"_3H9jTRdTl7isYf8CTmSRcQ","TypeCard":"_1xq5yU550OwlHVw4_5E3C4","CardRequisites":"_3zjpQO57a1jlNAQY401PP6","CardDoc":"_2zyu8VRe8SX2nTHhpy0oTs","RegistryCard":"_3BQZr9CA-GoNvx00sLjswM","RegistryCardName":"_3jEJXWGy6PNFeAto3nG4Wu","RegistryCardAmount":"_2Rj2O76j1tOAzkkNLtsBuD","RegistryCardCount":"_1cgYvS3wRCY4N2Gm0sHS39","RegistryCardDate":"_1UjtbOx2QPwkgY_QNkCUJf","RegistryCardStatus":"_3f7i_GgPbpHGw9Mon1sBMF","EmptyColumn":"_2bk0hMCKyTijzlf5rElK6f","LoadingWrap":"_3CnwKTTcekYPl-GZjyDvws","ColumnDropTarget":"_1LuTwpEU5XX_-OA0f8_bef","ColumnDragOver":"_3VLuKPyi0cmDXHWyFuwReg","ColumnTotal":"_13-uQdtKUIzF9lQ93e5Lzc","LoadMoreButton":"K0MWGYOsPXDgl59PDfT0G"};

/***/ },
/* 537 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Backdrop":"l5fLydNN0jP17d9mDEPDL","Modal":"_1gyCtZMlK-4uhF8DmgK7jH","Header":"_37GXaoXvw5PGQY8IY51VrX","Footer":"_2XSGhtZxFRPnGSmsujkqQ3","Body":"_2pu2QWJDa820WKu7Ssgyqd","Close":"_0EtVBuGuoMB-FrrydOXl","Grid":"_6SboCj2r1iiSKHCxHFs0_"};

/***/ },
/* 538 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ModalBody":"_3UizRjYEHwwow1NptHQeRN","StatusRow":"_36G_2VXExXD4FMOhBPZsRI","StatusPill":"BTRL4eAlsBuM4CRiveoRb","AmountBlock":"_2wDttIL78jYuQRDeCbBmOg","AmountValue":"_3m1-J147VWylNUmORW9CPI","InfoGrid":"_1tADBXgQAcGU2nUpYvj-3J","InfoItem":"_2fbc2LeY0u-YzxB5mvDUOg","InfoItemFull":"_-87T7ARyd1HAbvh51Zxau","InfoLabel":"_3s_xdJu2RZsgf88111kyGe","InfoValue":"_3gARPcT76m85iCcC4GHBo6","InfoValueMono":"_2RopZ-mHaBVwt4K7Q0EUUe","InfoValueLink":"bdEPETxhyeR1-TfEV2KAY","DeclineBox":"_3YjWDUtEhRi-DfsLCXk9t5","DeclineLabel":"_10oBOZav1AGI_s7mLV24mL","DeclineText":"_2rq1i_amThPObEn7O0fks-","AntifraudSection":"_3B2uyt7dbI48laLoeNNFsl","AntifraudToggle":"_1kFgXMNcNaadII0HiZ2WFW","AntifraudPre":"_2EbFPYK8TSXXZaX-Fj4-KM","ActionsSection":"_1dsS9qAbNx2n8DP4zkgAU0","DeclineInputWrap":"_2LcRSrZBRIxsc1xt4nePFn","ActionButtons":"_28iiVJKERE1k656wAfUj_7","BtnPrimary":"_1ex34ZYOHO2ZK0QDa-ka_l","BtnDanger":"_1rWlzE1U7QjJUYOI_mBGc-","BtnSuccess":"_3_a0P-GzOCwWJ4H3mLW3Fy","BtnWarning":"_33GGW-KWMd3OxsXz7aLnZE","BtnSecondary":"_3iXog4yg4AkL1ooFS1Y3lv","Input":"_1dn3RkvV0tfSZKvCHgxP4U"};

/***/ },
/* 539 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FilterOverlay":"_3jSXXQD0Ww8dwcsG0_YaNe","FilterPanel":"WgnzrVlGHeCZHFkzj8pLL","FilterHeader":"_2PH5KNPcYv8ysiN5tGGVNN","FilterTitle":"_3O6zqJ0DePYuBYSF9iOSv1","FilterCloseBtn":"PKR0Asi4llRCSZgNR3avx","FilterBody":"tBZVi0Pdam_yatwIbRFTR","FilterSection":"_3bxOFS3bRAZHKHnOSBIAwG","FilterLabel":"_1cYoahXlE82HCmsiaVuKyW","StatusList":"_3hOLJnwhLcCnZqfjvJMHhs","StatusCheckbox":"_3sVVccktW4DdrE-OIwwy88","StatusDot":"_7e0k4Dx4SC9m4_ei8K6Iq","StatusLabelActive":"_3cCulUnOtMEfaSsobW0Aph","TypeToggle":"v2AgtwXghaCmV5rBUNzCV","ToggleBtn":"WzjyDDyUZEunECwXbCpSr","ToggleBtnActive":"sYLQGAW_aI5CuSohP2oNU","AmountRow":"_2iyghKNd0HMHItpHkeiLVU","AmountInput":"_1e_KqRkQFTMnH4h4EP8-KY","AmountDash":"_29z4ZCJ3KDQ5n7SQndn_Gy","TargetAmountInput":"_15Zlwo2z3I--HcPGUaXsN9","FilterHint":"_2TLnt9JHoB2zGhNK9zryu0","FilterActions":"_5-If3nWcczvsSsLJhuFPF","ApplyBtn":"Xd1FHF4HV3pCP-voyzsPG","ResetBtn":"_24eAo6GUZQomw1n199UWj8"};

/***/ },
/* 540 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"RegistryBody":"_8cWFfBXjxoQQfBXPw-v-Y","RegistryStatusBar":"_3zoHdWGj7wASSPiK338_sW","RegistryStatusBadge":"_1B4UczEc4ApB_ffDYrUf7u","RegistryDateText":"rbqA6zSiyf3KMZ4hm7Gp","RegistryIdText":"_30y_njtK7Ysf49_eY_vTd5","SummaryRow":"_2SNfsWK1tPbjRCt6J1jlJm","SummaryItem":"_2EaiTzgekcOA90fs690Atg","SummaryLabel":"_3UGB719GDy-Q_-_he1WjC6","SummaryValue":"_1SqjIn4W-ZQWYnL5SjTZio","SelectedText":"_1owyFcZQNe1vfPxD1SaH8z","TableWrap":"_19miGhJM_J0AbI5NPxQHVL","Table":"_7wJwpe_VCnFx6ZAlOwLHW","CheckboxCol":"_3i7HLRTPgJ3YFaUt4WfpIW","MonoCell":"PZilHK09qgN_qDKYszdY3","DocCell":"qlSj9oDcev3QeLf330Qhc","EmptyRow":"aKA9KTENP3BMlim_FQb2G","LoadingWrap":"oBZLbXYJue_LQHi3-fiEt","UploadResult":"_1QgWWd49ORiHc6XY5vEk0l","UploadResultTitle":"_2lIEi_i5KaLM80LS8ufgEw","UploadResultRow":"_1-UcwTMLVOsBO09kFUxY5x","SuccessText":"_3v54P8jUvHUmF4lFsrIAqK","FailText":"_1e7ZHBgJwfAZ8yZT2t8kOf","UploadErrors":"_2hhDdGu_TMswnaDnmKC9Hr","ErrorLine":"yA1qFunLVoiEYe8Dbz868","Actions":"_2C7YlmJNFePjN5Zan_Uvye","BtnDownload":"_1558bIxxs50Fdr6HTru52e","BtnUpload":"_3jHpRTFylRaDX1uixUWMW8","PreviewActions":"_2iQ0LlY4c18ds8c4vAWthB","BtnCancelPreview":"_1HclW8YlbGEaSB1mfLir9T","BtnRemove":"_1RuYDgQR8XkD5SmprEdDIz","BtnDisband":"_2SjDe5vXXYi5BX_ezaOzfx","BtnRetry":"Jay1MrZp7g660-t3TUxL","BtnSplit":"_6nfKR2Kz6w0ixY87dmakH","FailedRow":"_3FKT6Ru5cMjc3KXSic_BKP","DisbandText":"_2yeU8MhwBx0bxeAquBxL_G","RetryOverlay":"_2VMe8Ielg_2xnDJGofF5j0","RetryModal":"_5PK-raVa9jbSKskj7X5vm","RetryTitle":"_3M9zvdAlJoQCFxhJqHuCmG","RetryInput":"JRw5lPt0-1gyy6G2qYIza","RetryActions":"_3MSkNshrRMDnlhQoJdugpB","BtnRetryCancel":"_3n2Xg085E3dBUXmAlZKojp","BtnRetryConfirm":"_1RcgwBhJALx5cucJ1NM3Sv","BtnDisbandConfirm":"_3Ek6mLq-NSp9ejfSsE1nip"};

/***/ },
/* 541 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_30YpVH75EqeBGIxRH6fiNN","Header":"_2BGQKBUeYQOB8C1Ms0Q7yO","Title":"_3VDTYoKGJ4JQyCOxPKNzrn","StatusPill":"_3KcXDFAp7l1sq3xbc_MXz3","Body":"_2WOA6tw7H4iA5u4BizH2G_","Section":"_3qc5MJmNbpyuly1wPaNy8z","SectionTitle":"_2Gh8vK7Ld8_TNBal9Sj6N7","InfoGrid":"z7Q0_jPCpmTZqH5xjcH4H","InfoItem":"_6TVToXSMNNM3gMkpWH-Tr","InfoLabel":"rzhVLuIfnSCWpdnYUt57U","InfoValue":"mNEvMxF3394HFoe9oRRow","MessageBox":"-E_1ENFdGAFH34S3eGrzD","TransactionRow":"EVaUvb6o5vX-2SFDWp95m","Input":"_23PiZ370tqZ6Qu-p33ym6V","BtnPrimary":"PVvp_hl3GChMTOAxZZ_dj","BtnSecondary":"_3VgJUozxYtsOvkdreUZLWs","BtnCheck":"_3uidPiyW4ZSf42Dva-nh9e","LinkedTransaction":"_1LbsoV3ODWrY_xyG-l9nca","StatusRow":"_3gQ12h5jQaxKqJZ-SBDjFX","ProviderResult":"_15q5KNCx_QzUFltmFxVpC8","ProviderBox":"_1UgfAL1EzxCyDGpEJGh__z","JsonBox":"oAfJN024Rzcx8er8szj-b","ErrorBox":"_2kZHoqQQVGJw9fVaLtF8Xz","CheckedAt":"iEZg6IZihjWWOxmJK4oAJ","Textarea":"_1lZ8Q5dffTIS4Sp10M76aA","ActionButtons":"_2BaBt5VO3Tc-5O7uZf28ci","BtnOrange":"_3hC_HqTjbpDZpKNmt2BkEx","BtnGreen":"IuXYA682kjvaPJiqKKSe6","BtnGray":"_32gkzvvPyvMAGZyzozXleQ","ResolvedInfo":"_2-rbOGfT7tXL38RH4RJPYV","AttachmentsSection":"_3t1DsCuZpG5H_1yx5Ck4zC","AttachmentsTitle":"_1UKtpPGWrH95GAlOmjZeMZ","AttachmentsList":"qVaEaPOPwkN4UeysnhQ9h","AttachmentItem":"_8xqlsZ4JndA-1FOukIW2b","AttachmentIcon":"_2ZZyeGdJxx5ERE-XGeKkFW","AttachmentInfo":"_1BREYb7Er46bULaRMciwqp","AttachmentName":"_2bfUvnwSt9uhohnbydA3AQ","AttachmentSize":"_1d6qCCR9qNZNm5vK_rdjYE","AttachmentMime":"_3wIc0jX_s6mG_eiC8qhFeZ","BtnAttachment":"_3aEbiCVLjcAEGp-3ZS_lUT"};

/***/ },
/* 542 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"z_VwcWbv95OOBOszyKvzP","Body":"_1eEfYFazKWm5YOLPpns0ue","Group":"_3MQtKyClSiICn0rp3a5Tl9","Title":"qTeHfdRKBL2Ey5zt-QaZh","Column":"do9RNJvEbohPEsKPUYxO1","CheckboxWrap":"_2KX4zefTkxYY2PnezgipMN","CustomCheckbox":"_1lcQnRV3noXDZiNhpl3FUu","StatusDot":"gpm0122Xi9P9F6vo30oew","Footer":"_3hTd_Ht3QeL7bz_heP0h9r","Submit":"_1OXKi4KJ_13zTNvwCFCv8r","buttonIcon":"-Pa7xcaNTDNxG_tNmLRwt","Reset":"nqtAay-wsxZCXZadMTKI6"};

/***/ },
/* 543 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"_3AR6fSsHpSmUE8VpxHuBX0","HeaderCell":"_1jdJZqpAemVXzN_e-BbLR5","HeaderCenter":"AjWUiARcqS1lXwe_DBBbj _1jdJZqpAemVXzN_e-BbLR5","Row":"TzSXSYgV1OhxkMIolHgEw","Active":"_2V9LAN2pqpJq-1YBJ7Pa1t","Cell":"_1v4wDiVYaTlALcj8AoiuJB","CellCenter":"_3cqXtR_IXuWWZrceCuXBim _1v4wDiVYaTlALcj8AoiuJB","ChatInfo":"_1uHE5U_JGhrwsUqwuekWoj","ChatTitle":"_1DZ5GX04vhx0HtBtSD4pFk","SenderName":"_8eUQJqPs1JKIl3A4xkvIy","MessagePreview":"_3ZqZrPtQ8wSwtGY1fU3WRO","AttachmentBadge":"h3L1nf1VRfyCHv8dsxA-c","Empty":"_1Ra2ofuRs7f4ETmh2crRtC"};

/***/ },
/* 544 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"_4HmQGvbV-TaFaMhC76AUG","Loading":"oi-DATO7AfPmLgnugDAbE","Header":"_2wiKMEROkUIszrsK0Ln4cq","Title":"_3kMouiO3T1GAu387vxlocX","QuickActions":"_2q_Rlt8SrdweBLwCAwGXNn","BtnLink":"B35nENEjJIgtvKN2hgaKW","Separator":"_104Nx0bGZ6BuplDNw_rKvI","GroupsList":"_1TCM95ag9z44WVJAZlJ39f","Group":"_3rOnMsPzXy51xezeXVi9Fd","GroupHeader":"_3Hitdfbca7L5HH7XpwsEVT","GroupToggle":"_23f81kbpArx1tweY-g79VI","GroupLabel":"WDtkquxxIuoXrOMUX6nLm","GroupCount":"UjAwKS4RqZmgRO2RY96j9","ExpandIcon":"QVTLB0dvzVdjPtwlG7wmR","Expanded":"_1f5KNdoDpJphzWaYyyEZ1t","PermissionsList":"_3QJ4YyJou9ezKd6A5a1Trg","PermissionItem":"_2MpisdHCRvNI0C2g2uv52V","PermissionItemReadOnly":"_38UT7NLKK1ppntKTZv80tr","PermissionText":"w8UpwP7fjJvboCV5eOmH5","PermissionLabel":"_6UjVej9p5Hy8f7pTiPSPq","PermissionDescription":"_1nOWDaGx2VHxb45TAAufVB","ReadOnlyBanner":"_1eP9gXsYuLiruYGxgaAm2f","Checkbox":"HZ0h5BNQ5VWhOwzwkV5Yl","Footer":"_2uVdm4inJaC0Gl_VpyPRR6","BtnPrimary":"_3E43etfiJj0lCba0yoDzn6","BtnSecondary":"_26loEtrUhXaaRJ9VYyiotT"};

/***/ },
/* 545 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Btn":"zNnK6dZD_vjMHAdSfSUMM"};

/***/ },
/* 546 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"_3DfqY6_nSpXIOgR6ZXxvoo","SearchContainer":"_1wU01mDgNopcpgHTj8sJES","SearchInput":"_3VRyPrVfmRsX6gjG9j-lfZ","DropdownList":"_2e2qa2JZh1gd10DLkbzKXw","slideUp":"bP0umjgn9Q4qcoa9I9_8J","DropdownItem":"H5lwC9tFk8l8R9P4c9kVp","DropdownEmpty":"_3qykghoiKFm06HR9fQlz6","SelectedTitle":"_194xqdTVyjastvrV6ZT3kg","SelectedList":"_1VkmZs6Y1OOlB8r7KUdQh0","SelectedItem":"_3RSrO4npZBieaAu32e_mpI","RemoveBtn":"G2XAplmtmEHzc4pZRitqf","ItemActions":"_3jsv_1xXn2La117qeC5dmQ","PermissionsBtn":"_1_9AoAjOjO6_xeVT42a-iu","PermissionsBtnLocked":"_2Ce24TGcy6ZVZO0En4bYqW"};

/***/ },
/* 547 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1ssgs2fLqYS9SXwNJPkK7b","Body":"_2qQn_caSrPJHRP-dzdKEG9","Group":"_357r3ZL0tcz2YglnzWpdOO","Title":"_3J2DfD_WZqyx0nodp2f8ki","Column":"CUAaMrHj6ppjWo1gcoUFV","CheckboxWrap":"_1Or0K1DB7cUmOYtie2epGg","CustomCheckbox":"L0OABsVIhCVUfRLkiq4VV","InputIcon":"_3d8PC8Tv-8Q9WuE5fLRuG4","ActiveIcon":"_1fpdwcVyB-Ui92Z1kLunnM","BlockIcon":"_2M74Q4bBfLsmUGJRH3JH-r","InactiveIcon":"O9N6GW9Ko5qUc2D-spvcp","Footer":"mXVgSzfSZeUHT9CPDI9X0","Submit":"_2UFhVe_hLoLXdzQOfpvuqf","buttonIcon":"b_UbTIuzZpE2dkdm2VcS7"};

/***/ },
/* 548 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"xrG4OXUyDBkdOXtlAdcJ5","Content":"_1VdAC7RXkGg5VBWgRdKxS-","TerminalHeader":"PYsTQTxIdYu6JCar9iAq3","TerminalHeaderLeft":"_5AYII8aOb6RupJLzypcs","TerminalHeaderTitle":"G6nhz7MZvqDXlAxAhXveQ","TerminalHeaderMeta":"_29rqY_un4tLrPA6XHTtbXU","ProtocolBadge":"h06JnU6iEEu2EQNbyhphb","ProtocolBadgeDot":"_2xzVR6Er8SdqYdlBxL6IHk","TerminalIdLabel":"_2sC_2YPDA2SNxOeyWf7MSw","Section":"_29L_Hz3ghq7NOXojHf_c01","SectionHeader":"_101vfjhYQaYEDmn-EMoSW4","SectionHeaderClickable":"o6ZLE1dDolStDxfcpyVF0","SectionHeaderLeft":"_2zfFaAEqMLK3f57P_sT9Ey","SectionIcon":"_37U6vTT1Lt8uiqYJPdkALR","SectionIconBlue":"_15D8HhrHu9dhNbHHjwdyBD","SectionIconGreen":"_3yDHch5xhRf1xxtV9XV1u1","SectionIconPurple":"_942lXerVuyy18H0okyh84","SectionIconOrange":"_2pMNQ8LeCJ2XblPZ3WJ6ba","SectionIconGray":"_3MvplHsbXKqaNBChrBvVYN","SectionIconRed":"_1jZRpq-peBMyN2mq0h-FHw","SectionTitle":"_157eJF-dYR8QYnQsQfxSpw","SectionSubtitle":"SoxP22gMQX2qVlltR3OnV","SectionToggle":"_1DKnOvJGX1IQrhlkqKpWGI","SectionToggleOpen":"_1VcLqueUtT0X7iqMV7-iZR","SectionBody":"_24TSfFX9CpdhZmOkst2y3a","FieldsGrid2":"_3AGBPD9H21XDtQOVhoALI1","FieldLabel":"RqptVNjIkzQhy5oENTb6P","FieldHint":"_26EyEBztlQQhe4nGESwHlN","FieldInput":"_2DOszdryOUGvNVBMPUPAmZ","FieldTextarea":"TXndZkwiLcWDjmoAhZuAw _2DOszdryOUGvNVBMPUPAmZ","FieldFullWidth":"_1GdedjBYQFXQELodfbwsat","SubSectionLabel":"Vk8ERAOKsWWYnPBo90SzI","EmptyAuthHint":"_9_I-d0dYq7v6FQcEcKv1T","CardFooter":"hQKHNaaQ-fjv0BRh4weFZ","Block":"_1QztMErvjrvvtNsr7C8TsB","Col_1":"_2jDVdtRUUtUll7ZP4QvKJ1","Col_2":"OlzETNN7S7hFcIyBk2EKO","Col_3":"_3QNjyoqh37rQu_xLqR2gOX","Divider":"_2OML6gBQjlwcIMV3MrddUW","BlockTitle":"_3Iec6t6U5URNQFb8TsJAde","inputWrap":"_2Smm5WNzok5StP3P3eIXFy","IconPassword":"_1DJ-wzqROY7xD5tjlxOPE5","Empty":"_3u_oTg327ArImweh4MtWzz","List":"_2RUnrknKhNJM7Z1B_6N4Nb","Btn":"Zqzi7mccE5j-OvnSqGqGD","Status":"_9XMfx3lst71kB9TIXovRh","CurrentStatus":"_3Lqeps0ydO2PMn9_ba4jpU","StatusSelect":"_3f-Q7n5dNaO-Sk45X2PpKk","InputHeader":"_1aTTS6iNLJWLdIdVThHCXK","Label":"_32kMgZJnZ5WJg5o3OmJYIf","InputLink":"_150XmpnplOpm5oB1E_rujZ","LinkIcon":"_1jnQQ9G3Zt0Q2gaYejo7lR","LimitsGrid":"xsfBu_hEG5Wx8XzKRxDdl","LimitsSubGrid2":"_2HDDh-eSRtfUWZzsVzibM0","LimitsSubGrid3":"_1jjoczXsJrniarR8EfKknY","BtnPrimary":"_2r8XKmP84yQcJnENtIB2AX","SavingOverlay":"_1i8MUdEgZF406pRoJBm0j","SavingSpinner":"jzKoYPd87dc3EeH6lGtXw","spin":"_38K4ocB2KMEbW_01EQGfkT","ProjectFields":"_3XyyDQUq4W2A93Vrya7BR6","ToggleLabel":"OUkWFZFtlvZNo-hO5C6Eo","MethodsGrid":"_3fPEBnqwsDUrq8zM4Gzz-b","ToggleSwitch":"_1tMK_tyW4XzFdVZxDqM1w5","ToggleText":"_2hyGcLbkJjeVBFnAyQRCtn","Tabs":"_2jvGNa7Kyq0SHH3QRI8Dc5","Tab":"_3cchmQT0YwFcoLfX2J1P17","TabActive":"_3e9uNmv8AmxFS23-wNx-mw","TabBody":"_3vDluJpl5UHUxVOnFm-rNP","HintBox":"_3kQc0uQSUyJNwYPh8x9a41"};

/***/ },
/* 549 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"sGN6k68SAQKqreRmZasHN","Body":"_2JdPmEGBohjGCsz9tbL9qy","Group":"_3PRkP3nTpNjn--fXibwo6","Title":"_2EzsjwccMpvPU80Nxq38yx","Column":"_1NTjtsYJLKfJLeZsBGXrz9","CheckboxWrap":"_1C8uMdafb2Sk_ODQCmpAMg","CustomCheckbox":"_3Q_b6LM3wqJRhp2aJ_mvX8","InputIcon":"_2Haz2vVh80Q_v5XIH1wulC","ActiveIcon":"_3qbNl85Uiw6hhi5fOF8xjL","BlockIcon":"_13c--_pey0evRgeLWfT8pX","Footer":"_3MbEBJASNZ3tBHHQabRTiE","Submit":"_TPH0MtyAqVXfQlGfENst","buttonIcon":"_2j0PRwEjOQ1beee7RLVEIo"};

/***/ },
/* 550 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_2T-RLWb73vuKA27SQG-5n7","Focus":"_3tIkKwK50SXHYYYVDLk3h2","Header":"_2rUkc_gyUo3AmaYybWz47V","HL":"_2i6vMw3XA9N29NRsAv1-8Y","HR":"_2GcqDUphgl_VFt0Er9qAqY","Title":"_317tjRY2zeZHF1gN1MOd7","Upd":"_1CkMVG-kck3U3Pw0QUw5sW","Live":"_1qmnR0sKcdUWY-VRKkA397","Btn":"_2C358WcHeji0JXU7mG-PNl","Empty":"_1cYm9zX986bkS4jZduobxj","TW":"_36a8MQbU3pltTMUQH9rdKz","Tbl":"_1-E5hJqyMkBdWy5fOsKPkh","Th":"_2FiTzzG4uIQq6_7WmZtLBt","Th30":"_31oqeMu3-ztvcmm8yj_fi8","ThS":"DDvfmzifGZ4uOtyM6FXjX","ThS30":"_2hS9fqvzm8QO6tTobK5kvM","ThP2":"ap1qpYkYddUwv2EnH3anE","ThP30":"_3AZaEKbTPDgN1wufHX-PLN","ThSP":"YAALsH_xiNuG6wUdF3Y4m","ThSP30":"_2e8wyYuUpAxBz0vwU7_eJV","Name":"_2gkxwUTC5_wzzXvxv5sH2K","BarOk":"_1-gM-5YXV4SOmdSRZCGL6L","BarFail":"_35FELNZTDLLlDaeUwxGu1Q","ThBar":"_23oJYu0bFBb-R-sINHmDAh","PDiv":"_3r1svm-0iVXGgIrRuIeyQ1","ThPDiv":"_3pbKPM7DiNk8MmslsdOs1d","Val":"_22ssP3bgM91I35FrQKJYom","Val30":"_1NblX157tXFhpEwgntsyyr","PVal":"_2JXokz4ROJS8DGCj7aX9t5","PVal30":"_1p2Db84ddiR2LXRHT2ByjI","Odd":"_2SSWKp17sAEEdMFZkmh5Fl","Sep":"zkRjF7FMSRJ98Z0M6LZJP","Cnt":"_2InpKC4wf1qApsS9l01m4l","Up":"_2I3KPO52dZWU5SHeRWkRhz","Dn":"_3ucK_FESXGzkVudW41SyCq"};

/***/ },
/* 551 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"_1P0ExQOZBdWybV3JTZ8SO-","SearchContainer":"_3yKNNgk1kwYsBq-IxHPLAP","SearchInput":"_1f9SG0pNiHIqFAl4MTvq89","DropdownList":"_1rY0co9v9uDIRKlmk_N8bT","DropdownEmpty":"Dk76qkNbMk7Lp4-VkbJQd","slideUp":"ntXQiDofpLk4TtyGEJh0N","DropdownItem":"_1565fMC32a5lD-AZkv4u_R","DropdownItemTitle":"_2iMg6wVzlSWdILVxbRrDmM","DropdownItemUuid":"_3YnyboFF13JK5yix-ha23D","LoadingWrapper":"_2ADXNnJdVo2ksO3IPCUeYW","Spinner":"cxlvBf45cNIrPbCsN9Ish","spin":"_37cRIQHxg_KwRgh3on0k4J","SelectedTitle":"_1_In-kitDablcQ0ZTsodFw","SelectedList":"_31zCF_lI6Y7ny3dPhgD3Jl","SelectedItem":"_2p2QGTQDy4XIR-1zdU-8uM","RemoveBtn":"_3qmEsKygPC_Q-dzk7-yma2","ItemActions":"_3MFbqtqP_D2DOCL3e7OzvM","PermissionsBtn":"_1KK4P_eUg0dT91lejdGsdE"};

/***/ },
/* 552 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Footer":"_3qXVPh1biXkI4T-r9d5IT_","Container":"_2Y_ZDAZ403pCUV7LcqYWT2","Copy":"_23c_yYpTTPSA4xe9LpqJ1Q"};

/***/ },
/* 553 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header":"EElLmjBsq1eeYMsjIwKU4","Container":"_3FR12RDW8eaL6i1op1Bf9k","MenuRow":"i79a1n_i9pF4ljzFsET-v"};

/***/ },
/* 554 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Lang":"_2ZXixycwPiTIS8ojLkhbR-","Select":"_2gI2a--KbgrBXnAc7jkdbo","Element":"_12NeNmmFTBvoHC9hADdgk","Current":"_2RmagKhL5MYopubuJOSTLC","Ru":"_3GdXNiNauHVhr9c2AoovTD","En":"_2Mli80iGYlTJtuCcAB2tu2"};

/***/ },
/* 555 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Title":"_2HeFK2opbJqC2CmQc8-KB7","Logo":"_15JU8WrT2KrcdNdmwc_T9l","Input":"_3oq_1B7_ZMnuvXVkFFKjfO","Btn":"_3xTDodSP8iGt89hoFVESex","Row":"_2JQUgqC1f1AwxRWec9Zv08","FormCheck":"_4r5KzncsOjrUcEC4JGIx1","Checkbox":"_1xyo9jp0lzMdcxkpInDtRH","Square":"Qm7Zym3pf8xBD-TfkhqUi","Text":"_3OobN2YNiCvD9kzLlaan96","Time":"_2u6Ii88s09tfmstsTDq-eZ","TimeLeft":"_3gqw2W5BTLJUUmabIOmJR6","HelpLinks":"_1nwdTLvgF53qjWR966KnY1","LinkBtn":"_2lgst6BmZk7z0uHJnqPhZD","ModalOverlay":"_1ERqhgCrIjA6C0J7yYK1nC","Modal":"r25Xxc6xVyR02yCvdxJa1","modalFadeIn":"_1F95OJUS1zcBZ4OLbRPZu_","ModalClose":"_2SPCLtstNeexeX-onq2OX_","ModalList":"_3F7DY2SAU6o99i8tgMpvfh","ScreenshotPlaceholder":"_2tz6ZTY3cPM2hkOh_aLTUR"};

/***/ },
/* 556 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Unlimco":"_1GhzpMUvLApfi-vgOhODao","Eclear":"_3kRNyh6v9Ec-pKrS-RP6k3","WL":"_11Ei2udQN_25CVfKElEAVG"};

/***/ },
/* 557 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"Qs6MpFsz0CO4E-Q7j2q0t","Title":"_1P-MnvACZGr5TauPJMQ46U","MsSelector":"_2YUo0QTGO7iASxfdvnPSoO","MsLabel":"_3W9JbVMp7RNmu6mtNCXJmK","FeeGroup":"TcGNOcNJYPqdITyHjXpB7","FeeGroupTitle":"_1vthDMSy-ABQvgFsfee0cX","FeeGroupDescription":"FWpLAbyR6rpqSxlEBJVl7","FieldRow":"_5vCC95gjum_iTH2-YX5tp","Field":"_3IhA3ubNmJYiuvJDHFfp08","FieldLabel":"_250w89gAgnuIRb1rzt-Q9Q","FieldInput":"_1mTOrUg0HmRMRSdcgxuotL","FieldHint":"_2qssPIW0P4y-P8oCnl2ZDh","SaveBtn":"_3_rWsL5yW-Xu0eq816ddCq","StatusMsg":"_2MnbDmdqnibJSrNoZlUVsZ","StatusSuccess":"HJM7oJr7Ol7sX_ow9yfTq","StatusError":"_2prU-rr_a1Wz7umhhKKyoM","Empty":"_3UGTwZhyzReNQUeXmb6J-Y"};

/***/ },
/* 558 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"SelectorWrapper":"_2RGH7MnlJRwE8dn0MaKXJY","SelectorGroup":"_1ePtK7lO71ze-kXaKxm4g3","SearchableSelect":"_2gBSMQavZa9eWpHPQaae1U","SearchInput":"_1T_vCMgn-1AEg1etW5uWDd","Dropdown":"_1XodTjkAabr6xlkDLdpq81","DropdownItem":"deDl7fpVa2BB_igG5WbE5","DropdownItemActive":"_10EUAgKOJDR4-X5R7Uqz-b","DropdownEmpty":"F77yJawKy4H-5u4kV1khU","TerminalSelect":"_2NGof8tLNQh_nGNDpaakgp","StackOnMobile":"_3tdRgRQcGb6cpJ9x32jdKS"};

/***/ },
/* 559 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1hTFlK7M13ZRY1dMfZrhKc","Content":"_3NzBF6d9ViuePcxjpsrSjo","Title":"_3v4mUTlPxRXv7Jd15ibFoR","Grid":"_3fHms6V_lZQnEQlq69efkF","Item":"_2azSyw6ZVvGURz5KbGLOHI","Label":"_3FAXm2Ile7YaLagptozCjI","Value":"MlQ8VWBUDcHsqnsIWzPV1","Footer":"_1iR-gqnknutXzZqOcGi3jk","Error":"_1rQx63Ucb4zwLsUQlbyhaw","Success":"_2CV_jTOrKYxKsgac39g7lH"};

/***/ },
/* 560 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3pB9WMjJAylH3izqfqXY7","CardHeader":"_1qsKJm2DNmq90SU28u360x","CardBody":"_2sZRggpEMeB1afmqm8EFvT","Media":"_1DfSxsjyC3IhUiVn8vFhPB","MediaIcon":"_3haS1xblb585wgBc7WtX7M","MediaBody":"_1GxOFWDKHhmkJpcwt_k9Ak","MediaMore":"_1TZoQ2tJqFpWHPeHY_5VGn","Desc":"_2FNhkF5EeV0KElOgoRP8kM","Link":"tpoNV98rdhOAHkIu-Jtcb","Icon":"llL-l9AtWeDVo0DoDLmJz"};

/***/ },
/* 561 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2EzFvdEhBGOf1Ogc5ReGNA","CardHeader":"Kf8j3XtKkoO8VATsYqe1E","CardBody":"_3BQUT5eCHRkE1bmGKqDfDT","Media":"wr3jNGYDKPM-Sce8g86KT","MediaIcon":"_1RlK3QdIOycWzD-cs-PXsc","MediaBody":"FtfQ4n8jABQq-FCaS3uzK","MediaMore":"_1S2iGHxt8IMkqziNvugDUT","Desc":"_265Hn94UfjApopmEW0eOuI","Link":"_14A6qr_sZDJ6ecvpNhUWKn","Icon":"rLts16d9D6gspl0OScCIQ"};

/***/ },
/* 562 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Row":"_2vT3h1fFMKGM-eFYs4NkfW","Success":"_1lMZHUBoSni-xAM5DgBmFL","SuccessIcon":"_15VfI_ctiXWvJka4AK84sG","Failed":"izsMg5ERsvmXC-KjjNWLh","FailedIcon":"_1KhHlY64J3_lwAGPOetCke","Other":"_1CsJ8441LvdnT9dfDE7iDO","OtherIcon":"_1tF9Sr8uXswsuBbp7CAJ_l","Label":"utXAuZjr9tz4oeq-DIo2j"};

/***/ },
/* 563 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"J4rBbYugzB8oJNgDHag-D","Body":"_2bj5z14wK9d9WkfCY12iEV","Footer":"_3rKbNF7x3kZQnwBsl0QE3J","Title":"_5ULabzMsiXvyri6BUguZw","Group":"evb4GrbP5XY0jAC38KtFJ","Column":"_2Alt0Ge8oHh6nFG0Lwd-M_","Input":"_3UAiL5jBEXAjesZKdwEdDH"};

/***/ },
/* 564 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2OXYMV1tCXDk8qDU1iD97B","Body":"_3HF8U0NzqfWyLeOplmXrnL","Footer":"_2H1fPQTF3AtchuEt0GSJBc","Title":"qq93sMJZ1prbK14PUCqE9","Group":"_3ZYI-C38-QwERHQcy3TePn","Row":"_30fKJYR_8J-Se__ADQ4EHB","Column":"F7Eij18EOLqX43KmfLS0u","CheckboxWrap":"_3hNDAK-hQYO5Un_SnOqaf0","CustomCheckbox":"_1xHGywrCZRoKfdmBz8vXAV","InputIcon":"_2OMWi2UlqAgv7rUG-SWIJi","Payout":"_1U3vnzIr3VIEThyZp7_t5g","PayoutDecline":"_3RaPjJUEHy6Lg8oYmybLKH","Created":"_27NLswdBrAg9a8_qulJlwJ","Filtered":"_2w7eRO7asc2alKi3xTaY2Q"};

/***/ },
/* 565 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_hISQoLziFgKiUTOSF5wK","Input":"SVGjZ78zUo7z_hw2BruWv","TagSearchWrap":"_1ZPBYyCIMlBieCs2iCXcXM","Suggestions":"_1Y04qt825cnWqM1bT6mv1x","Selected":"_39AYnLSjvwf-AwnOEqUUAu","SelectedTag":"_2l3w6dLEtwsMm8UcMZHPUh"};

/***/ },
/* 566 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3hgVq0JVirEBL2DJORDP0s","Body":"Kz6WqhtlYwNU62MPpGwLW","Footer":"_1AtBZAN2jQEwpUI9waTrO","Title":"_3ZBaEiJ966QW23OmEM2q9_","Group":"qLm0SIhP1WYCI4eZ13Ik-","Row":"_1AsOde2LQvc-GIUQW9Pniu","Column":"_2fSqnPZE_otH7it8xIyQ_W","CheckboxWrap":"_2B8OXZ1pq_hStgfOFdQ-Tp","CustomCheckbox":"_2O6eFaSWlxoBKw5xlcPIDB","InputIcon":"_1RNY36PE_dXuRioaUhBBBR","Submit":"_3i9MrFRN-2UxP39r8s6xUp","InProgressIcon":"_3972F2YWEz0Vi9LdK1vd0U","ProcessedIcon":"_1btqWjbMfpeHLJWTUgg-4g","processedWithErrorsIcon":"_2y_dJ3JXRk07GX0aXwcQp3","DelayedIcon":"_3xbCNsPCjNS0IfukQg5wZl","PendingIcon":"_2VYs6Pi3RJsXTO8KA2i9vW","buttonIcon":"_1i1Uf2clruJpmLGXuu8cz4"};

/***/ },
/* 567 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_23hiVBXfFVVBdzFhzTzvjG","Body":"pLTgHi3Yh8aGU3tvXbwLA","Footer":"_1uZX_CvNSo3ePg8Z70-ldC","Title":"QtEQMD3ecaTV9tm5p1ZSW","Group":"_34XpsIS-440cCPr8NHsd82","Row":"_3jtyMFmv7tAJ5tpI86d5NG","Column":"_2tsjubXo9MOhDVrSbcUZwc","CheckboxWrap":"_1rTnVHXHeXOiE1XQWWO9cs","CustomCheckbox":"_3OI9XZH1Pi4KczEjjie4TT","InputIcon":"cuZDOF1D8E8TOWBdzHYxA","Submit":"_2G1EK-TMteW6lDBcz4SG0d","InProgressIcon":"_3xDOOyIIPZgWF3PZLelepu","ProcessedIcon":"_3FZDBPzrH80GlEXJp3QkH8","DisabledIcon":"unFrGMU4dL4TNzzkdz3Oh","processedWithErrorsIcon":"_296U_WiknBwwJwDR9hl2MC","DelayedIcon":"q8_4N54ejlWwp8GbVZVbj","PendingIcon":"_27nZATWUq4QyK5W_x-nvTI","buttonIcon":"_2yKVTg9pcPcjBVXvO34WXf"};

/***/ },
/* 568 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"MobileCard":"_3qDX15HON5qbbxs0__YcKO","MobileCardHeader":"_2eA5X3TylrFz6RE6jbGmMA","MobileProjectName":"_16MXxtPoAg4oS1QfgSNGoj","FavoriteIcon":"_2gNO3UUW0v0scOEur-orcv","MobileSettingsLink":"_1lb3M0a8R9hpCoEcuOhypr","SettingsIcon":"uDxjzIWTpQW6OAsKumsZk","MobileWebsite":"_1zLMFD1rPpB7EmxyE0n4Ns","MobileMetrics":"_2pWd1lGlyFfUCWgpxFgN8U","MobileLabel":"_3pzoeT-N-PTyYsgNNKUHnC","MobileValue":"tnGxh7XmPPtSo8_ropuRr"};

/***/ },
/* 569 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Title":"_1WinAoZEgzY5dT3kSvN3DD","Row":"_1u1W3OkxKDd6wz4_usVJVj","Input":"_2HclbKWbCHR_6gWogC9Ycs"};

/***/ },
/* 570 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_1ETt-5dWHSBaC8Dp5Z4Qzk","Toggle":"_2vrartPwOPZSTwbL8AVAko","Chevron":"_1blBTDxZRqh61XkyAyF2P9","ChevronOpen":"_3tEGe0Usr4ljVcPf2b1F69","Content":"_158AI0-ZrvwFMysZjhdzZG","helpReveal":"_2H5bI3eNUapuHcCw3spTi6","Placeholder":"_2CUzladJFBrK96HvQ4qyxJ","Loading":"_1u92ncxwxcF7UVN-9FCkO-","Group":"_1Tbc9JJICBNUkPH7BwrFDA","GroupTitle":"_3MyLaPOSNGtj3WXfmiK4aL","Columns":"_3sjeVwwkbb3g5Iv_TU6_1J","Column":"_2Q4ZIkal4wkuobP-sHi6SQ","ColumnHead":"_3XQAt406LkovCajFfq4jNK","ColName":"_2tOacnTyH2-1FLV25FYSeH","Example":"zR0ngg3VI05EurAqp0OrW","ColumnText":"_1nDTkZBICdVf3cmf5pWSPj","Notes":"_3m_ptLKqIZvDFnwVdnoY2A","TemplateLink":"_3eyPw5jL7X_f4fkcOjIQtf"};

/***/ },
/* 571 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1TlxCiK9X6tYYb69zDGX9V","Title":"_1rou2BcmnViSTObivnppyK","Filters":"Fg07abdKB0kudZmS1WLN8","Row":"_3QC0RDjDqpp2tbsxlH3U6Q","Col":"rx7HF-JfF_pa0-rF3oiyQ","Checkbox":"_39zV5VjAZ-xfNTxXwNW1Qa","Footer":"Uwg-9xan2bHpaaJRp_3aL","LinkBtn":"_1JzWwAxCuSeWrYyOJZWNmT"};

/***/ },
/* 572 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"cJ46AGwbAx8Lm2jwnUBMl","IsDrag":"_1pio7oeubuDpGVvWgYTVGO","Icon":"ax8-WTXN-AWHRV44SnwQl"};

/***/ },
/* 573 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"Ar40LOeH-lv2kDZIPj3Mn","Title":"_39euhpC9GOMmHB8wX37Tio","Row":"s2yYexNqHFOQVm3Eko4--","RowLabel":"_3g8kQLTJXEpwMhH8Qn_zwb","RowValue":"sBHZGz256hzdEXoQTsyAv","MethodBody":"h9tAvg8EQRxU2DVc1yFgo","MethodAmount":"_25cbOeETANnAuylEs-Z4wp","MethodFee":"_19wLMPVvD-oopue-8CZLpV","Disclaimer":"_3rKfZfuL6eKAlKZEXCcahd","CrossLinkBlock":"_38zC6UfgVcthpPhpW29HWu","CrossLinkHint":"_1ZoEGuRCrAo0pyMmx1qP7o","CrossLink":"nL1wCx-qAosTDIMVhk_Zd","WrongType":"_19WEYfAjfedNyJ1EgW6rW0","WrongTypeText":"_1GGkI0oQ4flGqpg6eOv_Nw"};

/***/ },
/* 574 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TableWrapper":"_381c233wRmnBtqFVGZIbKm","Table":"_2ygTnv1zwWurqYgViDVp5m","Row":"umC_pZ19sSTAPSsRsHJ0x","Cell":"_3vd62yXbVa1tpsuuAmf7oS","DropdownCell":"_2S_UdyyJNzpur_GOZu9BDc","Icon":"_15I-4glTWnCqs_upd24Afr","HeadCell":"_33mmmyRkp5Dc_s0DM9ZtZb","HeadCellToggle":"_3a6YOdIjWUwUeYS1nhaiHa","InfoRow":"_1-2FuW-xVyieiH_9vd9dkP","Empty":"_1W9IEv9-sxcvYJnxyHHkk0","EmptyRow":"PEhvsFHMNdttqNPzQGBnu"};

/***/ },
/* 575 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Upload":"_3z02AtDHIaXPVkFGTw6ydq","BlockImage":"_2DnlmL1uW-ICDV7qQrDXGM","BlockInfo":"_3DODzttMb4UMoU34FeSxu4","Table":"_2u_uN9k8rOc_2xuBazMwA-","Error":"_2qjTuPpcH9vVh8WArooPgH","Success":"_3PLBiAxiT1mVtwyT1n16p5","ErrorsList":"_3dtubgA82cCHQ9antG4Ovb","ErrorsTitle":"_1E54t9EjOmaA9_-08-v0NS","ErrorsHelp":"_2UWemiCg8IPp1DDROz6Ni4","ErrorsHelpTitle":"_383kORumPAcp0Ff859PYji"};

/***/ },
/* 576 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Avatar":"_1UgNreVYgvNw8fPnI8OJPm","List":"_2OTD5DOGdreeHasUmkqygG","ListHead":"BRt48hZKO_Uq1CLembqVI","ListTitle":"fd7aLbdrzwrNL34JzumlA","NewButton":"GMIpEmhAezFeoYmJ2kLy5","ListBody":"_2y8wl1k1cr3DNjP4KkDWPB","Row":"_1nbib1hF5ZDlgQGj5YeGbP","RowActive":"EjjDbq-pYmBUcWYX1_Oet","RowText":"_1JqjqgXuVOFfTlTgHcfzxD","RowTop":"_1kkGEOY_pRn_GLJVKAvK7t","RowBottom":"_3LMiF7HN__pbxDnGCmw0nb","RowTitle":"_17WxXu9eg_TBGgz3sBEHUj","RowSubtitle":"FK63uO20_lSoXuCs-vemv","RowTime":"_2NnNIZ-KRgOS2Q9Zf-jTml","Badge":"_1TDrqJ8h9rmMyfg3Y2YKR9","Chat":"EpYFaYP2tuWkjai23XjVS","Head":"_3x10jTBTl9LKDKCFpUPizA","HeadText":"_1npTDjtRn5YDHzv_vatQQv","Subject":"_3YCWhYWHq7KN9xyDR_VuvR","Note":"_2bcY6r8kan6No1D90t_6DM","Messages":"_3zQttWNUQPFMczbmYrSEFK","Day":"_3dftZd8DdOcUUicTWzgrNM","Line":"_3icYiUP3RX84St1NOcKcHv","LineMine":"zuj2vzMvvaZUuTVzzI8bD","Bubble":"KF2M3He88yZlXuqLrI6IC","BubbleMine":"xOX3zftHFn4yAfUmGCixf","Author":"_93LVg2z_YNVPi3i0hEA2A","Body":"_1wBmR0nwJq8jdYs8nuRFl9","Time":"_1slyufpq_usUAfwuz-yGRD","Muted":"vjVVs84QSQhGyo6dJaoFp","Empty":"_37sjF1gz2KhGJrGcTQbXHw","EmptyIcon":"_1U9uB7IlYp2Fr61ZHWj6V4","EmptyTitle":"_2XLaPLkTYl8_fWoeMqnKWV","EmptyNote":"_3ov78URP-o67NuZMINjBsl","Error":"lNKorxryW1dmgF3anx6lw","Form":"_1NCnWJQxkYjSJpiYKZeG9-","Input":"_3KNvzHEZtcjmAgpTLZ6zJT","Send":"Y_UUtuRRloCEYo0PSA1cv","File":"_3UjwYK17zgGETq4jp8thRl","FileName":"_1y51GUrGTJJFOLpumjZ6TL","FileSize":"xvzSTw8ZsBm8RZso5p2Gu","Picked":"_1ddhP9OpyutEPJF9PntSQA","PickedItem":"_35dVKmcoef3SQKbDawMh_p","PickedRemove":"_54yq0k8eqwynoNSJACwl2","HiddenInput":"_1Gyh9tsDm5RAzz0yXVliK2","Attach":"WkEEmFi6uNUOvCawMcgHW"};

/***/ },
/* 577 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_2qkTcn93tvu2k_96oY0lDT","Input":"_1og3zUB53k4oZkS9u7jUeg","Suggestions":"_1EWTH75fFeTlW-F-x3SnsZ","Selected":"_2uABCG6OANKpmV9sNwuVqf","SelectedTag":"_3QYEsBh5unE-jYOf9ISXly"};

/***/ },
/* 578 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Fab":"_38Cvrruwoko539_EGN4ig5","FabIcon":"_2WHjTTTcxHVPPwSz6yRqVC","FabIconClose":"_1GlHE16YHNNecDYt7tP3g","Badge":"_2cPPPApzFBMGC8Czu7KfZv","Panel":"_18OGjHknCFw3NwDKkJyuwj","WidgetPop":"_2ZCl5E0N5ysPB0XclC5opO","Header":"_3o83utFYLTnMo37u06ADpx","HeaderTopRow":"_1PAtvk9Hz_dZIujkz13qS","HeaderIcon":"opdajfDE9hO7LDgCGJiol","HeaderTitleBlock":"_1ic1i4jcHF7xKtvhj3lr9_","HeaderTitle":"_3BtmYCs6h9WB8ECaoGzbEY","HeaderSubtitle":"_3mG614_Ss7MT2hFL1fECGd","HeaderBtn":"_3YXCYT62qo4y-ziXNsrB9E","StatusChipHeader":"OfU4QJmWMP6XCFISkTit3","Body":"_2KIK_biYPoRRYgq2zLhpXo","BodyDropActive":"M5BtzYsbOsBlJbp8wiZuS","Empty":"_2WdG_6qZ8DumzroAeF0rSl","EmptyIllustration":"_23UoWWmsNleZ9FEiqP-z5V","EmptyTitle":"_2lcXTA57NUyPRQBDQoDJAb","EmptyText":"_21Nkwtfv87dyXCYvnCFYfJ","NewBtn":"GShpJmDm20d2si-Im_Ytk","NewBtnFull":"_3LmB-wXbupbL4KtIU_zJjs","TicketCard":"aAGT8O6WG2OQsTvwjv6fp","TicketCardTop":"_2EWo9sEOJZOBq7bJd_XhtC","TicketCardSubject":"_1E2sLrCkwcN6BzT-GRzlcb","TicketCardSubjectUnread":"oI5gMcsUvxkt_B553FyBU","TicketCardMeta":"_1DbC-lb7tUhbFt9K9Ms2A_","UnreadDot":"_3hqhCLMP_H9krs0wYXXQQA","StatusChip":"GMvsholr7DHbupxeO165P","StatusOpen":"k4gWvv9fbnfiXBckNiak4","StatusPendingUser":"wibZqLj8GX9dL4qd_NA3O","StatusClosed":"_3eoUVbm2NeJNG9kZBX769p","MsgRow":"VWONyHORI3eWMH5zpIp3H","MsgRowMine":"t3ftjKt1itKqIk6kMTtMN","Avatar":"_33ssQzlqjaYgdsxdIuNHj_","AvatarSupport":"_2u_ynkDziInKFWwIr4LAGt","MsgGroup":"_2IkyoYXsaV5hgAUykFXO0Z","MsgBubble":"mYQIgYIMKJLQJKyjC5b2o","MsgBubbleMine":"_3hnlyac0QbtHy8le-x1aYz","MsgBubbleDeleted":"_39N9tFkWYUiXlCa4WWl53T","MsgFooter":"_24R-Zpt6_cdSLLTqQi-pVy","MsgEditedTag":"Moo4oHXHNc5qxej5-3SRG","EditMsgBtn":"aJKKSufy5tY_Mf5FjWw7U","AttachmentChip":"o-nW4cI2nK8pg00UcFSBE","AttachmentPurged":"_31DvrjDiB8Digv1Z0cwpgx","NewForm":"_3-9L4FV1IK607Mv6NDrLyx","SubjectInput":"_3YTzLjUoDzO1IOxM6FaVFx","NewBodyArea":"_1_PlT1qVgxaV2YYVizUqcP","FormHint":"_31HdxVwnXl91uWzWAZlYt","Composer":"_2elWUTKluKsnZKb31oEvgi","ComposerClosedNote":"_2U7eX78_JP7qtrswKGyMQd","ComposerArea":"O0W3VnIT8EPeT6zSMhIkz","ComposerToolbar":"W5X57BTN-Lr73Rm5NZ3_w","IconBtn":"_3wrEU0L_5V96WPnDjODdkd","SendBtn":"_2Eo41US66kcmmhJkGZDscq","AttachPreviewList":"GxaZu9dpipdcFRkCSmnl-","AttachPreview":"_2KXiTbyuqb5TCgJJrEWznE","AttachRemove":"_1pbFD-bhzKW6OeGCORSlTp","HiddenFile":"_1TEayC47gvhfJBSAtg6KIV","ErrorMsg":"_3VHVkYjVwEkC1eUpTwGYsM","EditForm":"_6JVvCSOXStNIxIDPyPtj_","EditFormArea":"_1sYh4PUTfb_s503tH3A8cE","EditActions":"NygSse9WpWQxlRfXQJsPz","EditSave":"_2Q3wUN739Zh91tAiLZoh7Y","EditCancel":"_1VE9d0TY8_x3ZhTnXKV6ui"};

/***/ },
/* 579 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Overlay":"_33qovhvB1O9b4l-pWlfRpz","overlayIn":"_3lEjUQ_rufMrh05uX5UUPd","WizardCard":"C5GCBDn5E1Cux1v6EuBtm","cardIn":"_3oqFvjk5adfW3zWOscWkuL","WizardHeader":"_3UoUXu3z5ZWIRAbvieJXXO","WizardTitle":"_3Z-7bTq_OdMTUjU92tbuTZ","CloseBtn":"iVohwidQ9Gh4Chm2EKoRI","ProgressBar":"_28hszHeIKUFQ3WG1iLEkqm","ProgressStep":"_5djrIksFaAAxxInDOGV4u","ProgressCircle":"WhhzYAwKkX8E-o5GNlT5L","ProgressLabel":"_3XQC1D5BMvKbtvGDQRKlVy","ProgressStepActive":"_3FbNqdKgYhE0opYW3vI-id","ProgressStepDone":"sJvtJeTObR4xzDCRzkB6T","StepContent":"_5oD1fC7MShIar_fxSwMwP","fadeIn":"_25yYTRM_Wm9RJYXwkf-Zca","StepTitle":"_24dabvUbOKivMaHRhjktsv","StepDescription":"eF4FA46r2K0M5l5VhvbiO","FormGroup":"_1mUquMM96OPREtCTZk_neK","Label":"xneO4gt22IYTmXV6rO1vn","Select":"_2O6FJksiFzX06COKK4k-cG","Input":"_1mChOhkiZL0oqvfyjZa1pA","FieldHint":"_2X-q_c5LFUOvwTJvY1DTZn","FieldHintError":"LDGvEF0HdG7uLV2KFSTP4","ProviderInfo":"_2tjp9va4kQMEdznO0BBb3f","ProviderInfoLabel":"_2ymm2DLJ4lyLKyX0Jd4H_Z","SectionLabel":"_36XFMyuEvPQyJuN5ykkTV1","SectionRequired":"_1JoYqihJpLEijzBlbYKe8w","SectionHint":"_2JoNk0NcZ4jZgZdGP024RR","MethodsGrid":"_3ARZkN5ByKhV39PytJhFhq","ToggleLabel":"_26B0dLnHuwlqKL3Yv4n-9i","ToggleSwitch":"KY0Xa6N2X1gZkHJ1kTdu9","ToggleText":"pb-YqhUVtId65wiv5m6Rs","ToggleDesc":"_2iwgeMo3jFcS_icpz7D3LM","ReviewTable":"_2M0jZ0zNAsUB5c443BHd__","ReviewLabel":"_1Mw4MZWZvgz7AG1efEQ2s2","ReviewMuted":"_2Z7Zq4sRkpZN5jUTgAHBhp","ReviewNote":"_2wrUUcqb2VlK7eVQvdL7tg","MethodBadge":"CJQuv0uDoaWxgxGxHADeS","StatusBadge":"q-8UrtsnKLg4JWfIZoHR1","StatusActive":"_2JKT4zPxJVTIEEwY9aXxNA","StatusInactive":"_1tju75-16hTlx4PHKY6G3y","NavButtons":"_3L_mP4Svcl6Gsc7fVp3jFn","NavRight":"NNYqI0CFbnyAH_BgvC0kk","BtnBack":"_3LR4KBxPlrBzFu5EH_8xq7","BtnSkip":"_3E-34EGnjvtB6GsTzNpL4U","BtnNext":"_1IiEnZ0C-Ry1dBBPEZldG5","BtnCreate":"_1aff05llSpH_pAqnvNCOoq","ProviderGrid":"_1aryO8RD_HwqDcEUnB_XyZ","ProviderCard":"_24Mu6fBo9wHBT0Z5eK--id","ProviderCardSelected":"_14RfrXSea5BXfpppeHpu2k","pulseSelected":"_3k9QaefOBuu3j4jAbSirxt","ProviderCardTitle":"_2IKlUz_qUkinNTuWZhmqvN","ProviderCardDesc":"_3yZcwcb76Yc-Wk62jX_suF","Textarea":"aXQmQv0pd10ckbCuYG3-t","AuthValue":"_3CSI0T2qKoAO5wdRSZuGxr","SearchSelect":"_3JsBoWelaWEVJeqgYCBpFI","SearchSelectClear":"qtOyIVnFJZKGlzlTcn1-M","SearchSelectDropdown":"FJUlOQ3cS5mJNWD6Ennc3","SearchSelectOption":"_3xvyoF10MdYpQ-jHKnBqFM","SearchSelectOptionActive":"_2Wi9wT3Qk2lV4sgox4Het5","SearchSelectName":"_1sRTCMbmQgBQUpbshX5_T","SearchSelectUuid":"_1gUY5RKrrJ76Ehu86kOGX9","SearchSelectEmpty":"_3xTWrmPO0huwKLswdxXjcp","Loading":"EFwtBLWogENbOurW1c0ri"};

/***/ },
/* 580 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3Rs3uZWCVNIj9ybZg5DDli","Content":"nAAW-jr5kavq2wEXRQq-M","BlockTitle":"_3Z13_3PtRxAV4o41rdKpQy","Divider":"N71TwT-QMw3V8TvmWnS8G","BalancesRow":"_2A8TQNMp5wifbC9QACTd_z","BalanceCard":"_2ESU4imf5V8N9lrW-YLlj9","BalanceLabel":"Zcct1T7gcYuKVSBfK3gZM","BalanceValue":"_5DnRob_MrJ3dEUiVwcdpZ","BalanceValuePositive":"_2JOtEBxx0MVUYj2KiqJaG6 _5DnRob_MrJ3dEUiVwcdpZ","BalanceValueNegative":"JUMrlJbz5TyTjfPOrCTOt _5DnRob_MrJ3dEUiVwcdpZ","TableScroll":"_8p6WhRQJ7wP9bGwTtwoDf","Table":"_3tZvo9Z-HFdy81blA14zjO","FormGrid":"_1AZ3Prwj-CoMjwG6qCVuMd","FormGroup":"_1ijkUXhQDCKMqZh7h8NDP8","BtnPrimary":"_70wv7Wnbavh9WY8o1UX-3","BtnSuccess":"_2nNiuMcAPIsxmz2sqZpK25","Section":"_2jEC-qgH_ssHTwKzVqdzdm","SectionTitle":"_23vIbJPNt3MHXV-n73GMCe","ToggleLabel":"_2NvSLQUSk3wpQc2BgJw-D2","ToggleSwitch":"_3NgPmDG_ZrzG50xMTRfbyC","PaginationWrap":"_3u8ekjiC913VYNy6cUBO8L","ActiveLink":"w3GZW7RbbHbffBC5cRsKp","FilterBar":"_1rwEQ0SVbgZOgNLd7wsM91","LoadingOverlay":"_2HEOASloEULU0TnaaAcdCG","Spinner":"_1nRqbEOlPLvS0QPmOfiP30","spin":"_2NfT4sg4CCkPMyjcua_-gH","EmptyText":"_31_CEEThXgSCpv99k8htLA","TypeBadge":"_2gas7S_2MUTgC9Vh2Fbtd2","TypeTopup":"_1qRP1rQAtBhRNBVM_wtSUE _2gas7S_2MUTgC9Vh2Fbtd2","TypeAdjustment":"_3UqLjFrm9tYwHKVFYeJGNK _2gas7S_2MUTgC9Vh2Fbtd2","TypeTransaction":"_2NWUuO22hYuxVL2dVbfQBp _2gas7S_2MUTgC9Vh2Fbtd2","TypeSettlement":"_2vrnkdo7yl_2_0mEgWxRYo _2gas7S_2MUTgC9Vh2Fbtd2","TypeCommission":"_25OtsMaTeTVOO9MChnZMN5 _2gas7S_2MUTgC9Vh2Fbtd2","LimitsGrid":"_1RRNQpNAOFSrVqeYEVUG0Q"};

/***/ },
/* 581 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"_2g8TQbf66clJQ9w-mb-UAD","Title":"_12P37DTPQh2RTtzF3Wiycv","FeeGroup":"_39bykSCa1KP6ybNzBPu8I8","FeeGroupTitle":"_3w6zZJWkR7kwC7UQ5LVouC","FeeGroupDescription":"_2j2hmKfxdPUX_vA-Ixwx5N","FieldRow":"_11OB0HcWEa0VRJoCRfZ1cV","Field":"_9SgzokLKJGqetHDCVsGRq","FieldLabel":"_2eiB1nNltAMENhUDW2OJbK","FieldInput":"_1_AxZuBNmQaGBPVChi0Ndr","FieldHint":"_1RRe4iHLSYzokSESDj_ZLn","SaveBtn":"_1mtLQSYQLti7px5flNDqns","StatusMsg":"T4QST8NSgBw_hl_qZk9rO","StatusSuccess":"_16nuxO1kHt4pZ4xZ8LLLG2","StatusError":"_1G-wq8CA66118Wg44sI2fJ"};

/***/ },
/* 582 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"_1mTQiK7Vzqu7L04Wyh4GZP","Title":"_1lqbOyF0QWt3J0_jhu8y-m","ConfigSection":"_3Klrj0hYil8NwvPz6KC7SO","ConfigTitle":"b7nUgvL_NcKsC5kFQdvV7","ToggleRow":"_2ilICpZEbel1TibE91G8Ky","ToggleLabel":"_1srcYvzEeBzNZFX2UHwRQt","FieldRow":"_1fWIR3A383ZiRtCrIjRYCG","Field":"oDNvHMYce1Bpb2OrA7Xu4","FieldLabel":"_3aDNZ2zO1Js8-KXzQS-hBe","FieldInput":"_3FSJWO0ZEJT_tbiiU7_jSm","SaveBtn":"_1UEelT8X-OebEOFQ047SjP","Divider":"_3nt2y4kpojNOd7eHv1BfmY","SettlementsTitle":"q-kJAFvcroG1bYenKUczd","Table":"_2yQT-NmLmJq_Z9vApOuNDC","TableScroll":"_1jGhU9rUt1Ear-yfmQJKcs","StatusBadge":"_18rkMI8Q_hAjrxCEJHHSb4","StatusConfirmed":"_1Cv0Z2TVlwcYIG4oym58KQ","StatusCancelled":"_1JaJzpt3Fr_6z_A8yRseP","LinkBtn":"g3Z-xIm7Sp5aJrEVbfVqh","StatusMsg":"_2L0i4kk2xniQl2aYBqurqd","StatusSuccess":"_3m5Pr5rnKvKWGsoYFi0wV_","StatusError":"_2GfJi96nD6HDYO5sUIc617","EmptyText":"_247tooiALWVLar2Cjq9xSQ"};

/***/ },
/* 583 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2bm6uftgil4ThitRD6EOX4","Body":"_1MdAXcF6DP0QcJ8IAWyFkK","Footer":"tLI1HBvjR5QzL6bWwfCIU","Title":"XPxNPYINoK7ksUjMiyqrV","Group":"dwhzy3ZihCfH5zbEClsMu","Row":"hd34R_L1jispF3a1ra3X8","Column":"_3_ke1248RfzsoTYD69Ce0B","CheckboxWrap":"_3cEjBUao-1W0NHPJsFr8WH","CustomCheckbox":"_1vUyD9X6yRDS1GUDExrXZj","InputIcon":"e-qJx_rVSGfF72KmnZGCy"};

/***/ },
/* 584 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_38cLy0zSM8KSKgN6VaDVt9","Opened":"_18-DHdkdRvaZa70POjJP8F","Submenu":"UZTAhSksCEDa8zh5hN8sk"};

/***/ },
/* 585 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"uTPDjyDucciVmSy9BCO1N","Trigger":"_2A2l82VfP8LlGjqpA9ot88","TriggerActive":"_3uTZKZtTw0fw6BVZyFTD1p","TriggerLabel":"_34-2dHxqXKVcYoDlzKXGVB","TriggerValue":"_28x_JH4HauUub_fwds6mB5","TriggerPlaceholder":"_2s3-FRysAA4zGX8cOraJl2","TriggerArrow":"_1wVC5jgoUIg95q_eEpj33p","Dropdown":"Q5ukmAImbNq1S83ipLKGF","Sidebar":"_1-3kRGANSJOCaqJqI0ouCl","SidebarTitle":"_1SsuuAFrEsWRzxtx_4k0sU","PresetBtn":"_2Dhek-YhkbAy9IWQHLub-0","SidebarDivider":"MhKC43O2Kcs3OW1U9bfCa","TimeSection":"_2o03Oo7-aTlCBYfTVTgdVl","TimeLabel":"_1LCVkcjKlMWlbpX7cdE5Xg","TimeInput":"_bJQqWLVnc2UrM0u-MVeN","Calendars":"_1K4nC5vdStxXDPhaLztRj0","MonthPanel":"vrYUAGCee_NMLPi_t8cT2","MonthHeader":"_2Mi6VJc-lNcISpFsL9yF38","MonthTitle":"_31Qfs7fVusobqxkWhemZGQ","NavBtn":"LTXkTTjCfJd_6lT3E566f","DayNames":"_3gwVx_fFXXHAulSh8hfU45","Weekend":"_1SohpeeSodmSTeVgE-C9Kf","DaysGrid":"_3BT8OYjjdOk60D8ISVZG90","Day":"_125edzZoNX937Sp5StCHEI","Outside":"_3r0rMp6Rsyu5bvylJMSzlt","Selected":"_2-KWDgIMQ_V8IPMEaJ33x2","InRange":"_39z8KMqKibt_SmFb6bRA8M","RangeStart":"_3nKLpClHBaCmgXrXK5zg5A","RangeEnd":"_2SBltd0pN0_ZyCnebqV19H","SheetBackdrop":"_2MKhPKYHCVfUNogbGmltDl","Sheet":"_3wP__bI3qiCAjbBmSWQFBh","sheetIn":"UTeEtN2gpJX50A4-KY1oG","SheetHeader":"_6HLO94o9KwcvSZl5e_3-A","SheetTitle":"_1DRoY7E2H-5-qEimewjZ6P","SheetClose":"_1PfpQwMP8hxJ_twblBxR4i"};

/***/ },
/* 586 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Link":"RWYZaOgZp2I6NlF5BfJ7b","Active":"_3BwucYsSIyKOQ6fNQiGeYg","IconLeft":"_3SKBvOPtgyMwULcmMLqiRW","IconRight":"Xdi37Z_hRcXNZgzNGZwit","Submenu":"_1y99wqNeYzzF_ig3wPQ6fX","FullSubmenu":"_3tiSAIfyh7MFdF5o7zI779"};

/***/ },
/* 587 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_3HrWs4mszUAn3DKytiw7gv","Label":"_2Dvv_ELGWj6xt_5FMVASHC","Input":"_1YlZgobz9_wT3s8XFKATtn","Uppercase":"GUjBpU_KOhULl25Aq4iDR","Error":"_18Rw4rVkYm74ZH5HWW22Ou","MFFieldError":"_3IX48Z56LjfMP3JPueLctg","InputHeader":"_1WJODvStGobrUbjzVf5Kdv","InputLink":"_2jif1PypZwICJhuyxXCNAX","LinkIcon":"L95NNJcL_q5Tke9UpZIMS","IconPassword":"_1Lx7E6MYH0Ml4tGW-CRkh-","CurrencySelect":"_1pRAa2K0XKLOI0DvXzXuBo","CurrentCurrency":"_3SxmnHLEykW8p5Thuhxz9F","CurrencySelectIcon":"_3Ov7UWxvTJcSOsY9lBDNTB","MFFieldWrap":"mK5vZX79yq-mV_LUvVJoa","MFField":"_15tI6khhcDxecg5fXlegM-","MFAddIcon":"zdxidN-vYOTE0C48E9ZqL","MFRemoveIcon":"_25veUeL_gVD8AP2LzZfZNh","SelectWrap":"_3hf5rU1rem93G3h-OXO6iG","Select":"FtCMl65SAWrjcozhg4zmw","SelectDisabled":"_8yoo8cnS-tzOWBZHldJZf","SelectArrow":"lfKfYvDrRjNDA4YeknP0B","Dropdown":"XdiFj1qSaETjfRFIVNNMi","DropdownItem":"_3MA4dMg_ZmkRJdLUoYMoUQ","MultipleSelectLabel":"_140bZ-ytotp3l4KcRfLQVC","MultipleSelectOption":"ANI8aI0uLnsaa9HWWsdBJ","MultipleSelectSquare":"_3z7OHjbN_vW9FFBcYega4M","IconCheckmark":"_1d2AuS9A8eylSpo2CyvLmj","MultipleSelectSearch":"_35gIqMZxP9OqKDGeodqGGr","MultipleSelectSearchIcon":"_1HrLR5ZPL14UtuD9AHlVFS","MultipleSelectList":"F66DlkKdzK91YLzC7FqvL","Option":"t_BnWhu1vuHhfO6E_pV5H"};

/***/ },
/* 588 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Panel":"_3FQaFq9m-OWL2SuNkfeFNx","PanelOpen":"bJrSAi6jb-i3Wr7RszEk2","ContentShift":"_2i-heShhmHDpE_NBFOxMF6","ContentShiftOpen":"_2O7K6aiABfA8CEFWHeDnyG","Header":"_1Pofek0LgfCSjHke2T8xSM","Title":"_29JE3qreP0K4GGXoVB5TnD","CloseBtn":"CfvRxipNq5xxP3Ug0yaua","Body":"_1kDB245qRvPgeh2xpKMsAS"};

/***/ },
/* 589 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Help":"n-aCundxKBqVJN0XY_MN2","Icon":"_2fsCkA6VKCM1zaiD6nGWBK","Popup":"_3-vOZZd6-os8Jlg_eapSfz","HelpBottom":"_2vETCTmMEoC7tMcU8Sj8ml","Arrow":"_2TdibWbHrUiWJwIqvCoreD"};

/***/ },
/* 590 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Position":"_2jPmtTX5Eq7kpMVWrO3AV2","ButtonPosition":"_2ACqTqsrJFCL0QIY8GK6Hg","ButtonLoader":"_3re0XgOD7jbY5U-AXiMZb","Loader":"_3gUxNCBeDTB52vPjmgvrKI","Grey":"_3TfcVU9gaomBkkuK0UDmAL","White":"_3m057oExsx7CwPaoP3pQKZ","lds-dual-ring":"_2fj-GyVR4XDA5Odo0TD-Am"};

/***/ },
/* 591 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Error":"_34cTo8Qd8VzX-fbtJ4hB","Warning":"_15YiIYQYWybeyH9zW5lGGk","Success":"_2Yayc3RA4cXiCmq1iC7o20","Info":"_28RpUF18mDiDw433vJa73t","Icon":"_36qExuK3F7ZESZ57GpRMO4"};

/***/ },
/* 592 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ModalWrap":"_3BgCqi7O5n8osLQq_IKAUL","Size500":"_1jrOn1YHxjHWNSINXhAjaO","Content":"_3udjx9U3Qgb0megzz4vSR","Header":"_1gArubBRaYm-dnjWzoWmRZ","Close":"_27r_0F3aOhbEjh8xevFimh","Body":"_3OAnhrxAuJ3eiS-wZrKF1H","Title":"_1AnKrxjBihWvkWGmJJlxtk","Footer":"qGjF5j0oeynTQHrwBOUWb","ConfirmBtn":"jQTqcfVge3vgfT0ondNCz","CancelBtn":"_2QZT0sgg2kijExlUPfNTTd"};

/***/ },
/* 593 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2-C9gtC-_0gO_3H39UGBE8","Image":"_1U5L3LyzhE41RnELI5sHdq","Ctrl":"_2FGsY5pfsMdfa-RISdmwKo","Count":"_3eg2EMfdfUliE8923mLqIL","Date":"_1O42Hlf8f5J9uq_ici1YHI","Btn":"_3b9cd7PKO68uka7js30mAW","Icon":"_3uGO-mwT4n7TZ3lX2J_6d2"};

/***/ },
/* 594 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"bTj_-rTbsuzXT_hipozJq","DesktopSidebar":"GLV5n3UhzUw5Ouynvzrv8","Overlay":"_1h64uXE5XGY_lnfmhrX7xa","OverlayClosed":"_3J1wqwnZBUJr1Mmc07qEUp","OverlayOpen":"_233lkQyQGr3kYVKXRv2cfp","Panel":"Qe9uYVRaKS6FhzqpNZLTp","panelIn":"idLdtAYdEhXK_vV08QfLs","Drawer":"_29O-hfaHlg8WnjwdogCM-t","Fullscreen":"_1_-vTkmZwesFnURDXWJB4Z","Header":"Vj8T9tnALawvjl7kbrFi-","Title":"_1SsddZxlFjVMTfkXjt_BQG","CloseButton":"_14uOoqsYzIcGG_DzviN6iv","Content":"_1aXSKnweNErW6DiMx7td6T","ContentWithFooter":"_2Zu4KSYSA1O2nD6aH9EeoU","Footer":"pbr4sQ6Ea6pZCNjmyfJMw","ApplyButton":"_20N7iPDtQg1HahByosoiqv"};

/***/ },
/* 595 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3YOqNbNq6HwoZCjb6D2g9T","Input":"_3YfCNKanofGNMhbNggfKSb","Icon":"NYL9pOtm78wAW3PFkKWAp","Disabled":"_1F8Ec0fjOtuOR-PBKamyk8"};

/***/ },
/* 596 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1K6JxQRzL5u1aPXcHs3Mnm","Search":"_1HkNNkis3j50KMtuQs5i9x","SearchMeta":"_25OLilx6S6CuczJvgGoqa4","Label":"_2uK4nxvf1B9i6NOmw4v5OX","Select":"_1XBqLVQ4nCJ7S9C-iBxblF","Current":"_3mj1xVEBnGMUB2y5A6LAxn","List":"_3f7_k4O5hUEadn82GxRB_4","Li":"_3w3L7_JTByAg78uBpZ5bUO","Input":"KHa5N0tBgCtfKtqxXEN1k","InputWrap":"_2XduVxBTgv8MuCAnMNDAg3","Actions":"_97UFsCoU0CdVRXmM9JxLS","Disabled":"_2dKCO9boOJjCyY4J-V71F4","SearchIcon":"_2GzhmLwRyN3H1R5DttcX0f","CloseIcon":"_31gfFiR43lZQUtrw_m2kxU","CurrentIcon":"_2F2zD0ucEp2-vSlXJnkgM1","Tag":"_1oc9aT-5cw4gCuSRkepQaR","Btn":"_3cLTA1i10ogly7eK6ZP-g5","SearchBtn":"uHiN9ZY-WdppF-TN2A1Ls"};

/***/ },
/* 597 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_3FviuOwCPsNzUozKYSbs3B","TriggerInput":"_1KOrAmnkeonnnS4DErChkv","TriggerInputActive":"_1lCCHXoMse0k82r227elVe","TriggerInputDisabled":"Uf5_0qcGqNLYTJ3ugI5NA","Dropdown":"_3PtGBizVdF7SDWtlnvH8q1","MonthHeader":"_2p4lmbhIUZDGo-Hafl0HYs","MonthTitle":"_2Q7jvyvV_AfAudOeXFKxbq","NavBtn":"_3qVXEb1osyehJ-hlCNRqXp","DayNames":"_2K_g8u--a3vJm9wQTjDTBZ","Weekend":"_3MhJ1fy3vmyeoNIpWIrMR7","DaysGrid":"_3hBV_HEqpiVlmsl8DSyifd","Day":"_35DXVzr_3_kVzkuN0Xvbxf","Outside":"_3AWgVwH3bEUpU5vVwz6y4K","Selected":"_3wRWa8LydGgqc15nAZBcp9","Selectors":"_3ZO7bj9cfamyhNDf8azchX","Select":"SPKkX7MDvsbMWlL6e0fos"};

/***/ },
/* 598 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_291_3C4LXY1HOB-EQrckM9","Label":"UD6kLiLxhHYfphyRraOVi","InputWrap":"_3nVWBFHBcVTKLR2l2VtE5K","Button":"_2xTfW6vN3OQiddMWjlsCRf","Input":"_2LPbw--vN3yRjMxADBSPLi","Tag":"_1-QxSFgx5I3RaGx6Y6nljV","CloseIcon":"_3W0NBAzB2kre5msR2w85NZ","Suggestions":"_392FD3r9ezV-w37Ux0fsMt","LockIcon":"_2xf3MzrRZx6i8rn5rvopI5"};

/***/ },
/* 599 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Btn":"hnSQGgijFX7Xy1y-fGWAX","Icon":"_1WxmNV9IpUQE2h-Nf6ToB_"};

/***/ },
/* 600 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_2knTVDvbai30y_N6k52xpS","Checkbox":"_1_ogQIhg5bJp8AKP7p_urI","Icon":"Ml2Ar_7Q8bd9t7aUbwYVJ"};

/***/ },
/* 601 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"wWSjZiNI0ajGyKdVSB11z","Tabs":"_2eyFs1rDBGKc28o5OK8Y_-","Active":"_3-VR1SAre_0WxEQtzx5baM","TabIcon":"_3JoSkBFPBvD1k8L0QCqeH7","Content":"R08ck5_oqwlsABov42BgJ"};

/***/ },
/* 602 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2nCUgm0i9ES6K2Y-omJj43","Pagination":"_2OhS6AaNNDxWn1IzWpnefS","ActiveLink":"_2IpR3Yf5uKD-FN5jF8NB67","Header":"_1Awztk1n8ulvKETjOEKHHp","Title":"_38YsSreKECFZ0BQ3nSBGeC","IconLeft":"_2lUjrv8gZMZW96ryiQ1xPB","Btn":"_2XO8raibi8AE6X5JYH1GhC","inputWrap":"TWV6ddeQuQY_URTd6UoMl"};

/***/ },
/* 603 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PageHeader":"_2DavkWbhS79si5YZ6j2Ur6","PageTitle":"_22NEC6HuAfA4OszfapxHlu","PageSubtitle":"g7m1r6-nqazyYBzHR0c9P","MobileFiltersToggle":"jFFG5OTJz_5hSWMRRRhG5","Card":"_2BKkOicyFaKzFYrqY0q2qC","PaginationWrap":"_1E-OqnD4xcjqSBzKKNb1-6","PaginationItem":"_3RQvrUpBzdBWPfJpP8xUfA","PaginationLink":"_1QzVQG0LdYccxHu5Lhmwbv","PaginationActive":"_MMTziaw7nVDBWv8Iuzu5","Summary":"_1U55iSUOJRwYxl8tD78Jvw"};

/***/ },
/* 604 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_9RPOTqFmCnXD6lnRh4Ygn","Header":"_2TgCCgxmjHGD6ce_NNTHeL","Title":"_3z-URT9NHltfhElpWY307l","StatsInfo":"_1RxFdfVfdWM6gLX-9_tF6I","Btn":"M42imXBz5utbt9xdPNlO-","IconLeft":"_1CGyAHItW3Cwqu9SP3djDb","PaginationWrap":"GNOAgZ_6OHBPsp1OBRFWH","ActiveLink":"_1EwfH0QYIBl7RL6Yw5SVM9","StatsCard":"_1_J1pOxSDNmcm3q08yllZz","StatsTitle":"PwcDeGLMScmgAO9FH5ysU","StatsList":"gmD1pTtLyB9XwyY4GoAfp","StatsItem":"_2Jloceqt7R2mAL6N2-aIBd","Tabs":"_2eP33LFV7QNuAVRKn1LB2h","Tab":"_3sjxAhPSOoE20H7gf8fHcK","TabActive":"_1hTkexm4Q9jPyHOcUi9RQ_","TableScroll":"MACXLFt5gY8BytB52Dw0N","LogsTable":"_1DPzhy4XQNKw2McD-AQzCW","LogsEmpty":"_3Neri4vN9-t1TXpviFjOBh","ResultBlocked":"_1yJvo9hNDnWXuJOSG4z4uk","ResultOk":"_3R49Dg1WI0i6kVIUuW0VTA","ResultOther":"NkYxW0KtX7YvK9kinKcxW","LogsFilterButtons":"_3jpQBjTkU95Xmhtr344t8Q","LogsFilterBtn":"_2RCOSOO-lI7rtTVkMbOQrE","LogsFilterBtnActive":"_1ZF45CsKXmyNUhMfph1Hjq","LogsMobileList":"_1PRDBaxsvXhl4LVmRNUf0m","LogsMobileCard":"_1_K1_W8UjKE7n9M6qE15uu","container-fluid":"U4WOPs4nTW0QsgMa3Qk9q","LogsMobileRow":"_3sEFq_fF8gs7LCcxoVRLO8","LogsMobilePrimary":"_3pV0zGX5jqWEnvNxzx6qlx","LogsMobileSecondary":"XR6iV-A2yCYW9hzsciiu1","LogsMobileValue":"_2Zy14jGngcNKY07z6AD-1t","LogsMobileReason":"_35OVN79eAeRdd1zbXA8K1O","LogsMobileMuted":"_2Ngy17IYWZWNNx5T0ulap-"};

/***/ },
/* 605 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"HydraRoot":"kohp70ZdAiU-5j3b4hUuI","Header":"_2JoSMdnS-o_SyA5YFPEj2V","FlowSwitch":"_1r7wTnnXtrZODVt57h_P8O","FlowBtn":"_20SDarYys_rYzva6ZW4l7U","FlowBtnActive":"_1FZ7p4mR3X-BZRVAsCvqHp","Layout":"_25wMj6Th0h-sW1imkL38_","FormPane":"hd7vGvDLHiQZCfBX55PyZ","SidePane":"_293tGStY_QM3kc7cjKnf9q","Section":"_2XFFLqE1tuGoCf-psWiedM","SectionHead":"UQCMoaGnlhnmdwO15vwz2","SectionTitle":"_1ziJbjSxh8WYSi8V_1V2Eu","SectionBody":"_2rXcvAmvRmr3q-zVYgxVWw","GridAuto":"_3nMlOiUIS83D4TzqmJU_0s","Field":"_2fYWRcp9brdBdbNOAC0u5h","FieldFull":"_3GBa5D0Gijw8l5s2TewzWu","Label":"_2ZPRtaGSGh6ZBV0BRlAFx","Required":"_2osVmDJT3q1QnMyz0Zz855","Hint":"_2PBZMYebWX8Uja2W8RHKXe","Error":"_2zLoKePZT7ssfdbo_QoLXm","Input":"_1Wv7XuRj0BHoSFVTeorObV","Select":"_1eYGz6gyiI3cuayLMYjY5T","Textarea":"jTQRAKz446BBT2Cm6kgzN","Pre":"_2Ql993eWETsG9x6GT0CALa","Actions":"Fa5TavP5je3EWhA4x9hkE","PrimaryBtn":"_2esHzGAPL1_bu6aKTHp_fz","SecondaryBtn":"_2pZ4xH-zcVsHFjUyWNUZDs","SmallBtn":"_5bt3xhgCUnS84fghpRXHw","StatusLine":"_1qe14iCyoWrndZeUqNlwSZ","StatusBadge":"_2ClZjnwyXDGd0xK2SK4meI","SimpleTable":"_2Ftg0r6Tlu5CQplle8G_hE","ErrorText":"_3elJQNXHz740zjdgRDa2n6","Console":"_1PCvC5jaeJxsVmPNBd0yIp","AlarmBlock":"gsD1Q3kNUEKhCgefbu1BH","container-fluid":"wj24l0OCrTWaU3yNbD5tr","ClRow":"_1lgt4vbkGfUvLacNudGxI9","ClCol":"_1pW7ZtbtUGbt4P49SJqGU2","ClCard":"yduGusgZAZZ6Gfn9ByS1D","ClCardHeader":"_3h8aXTeFX4YY30OzXp04yA","ClCardTitle":"cGRq4iSpdDRh3y_UtaqqM","ClCardBody":"_1Xx21Ra8__qGPOPJAt-Byg","ClChartWrap":"_1XOrpYUfdob15dDhw-fu6m","ClSummaryCard":"eU0_hnZRVFgGsU1kjOHW3","ClSummaryTitle":"_2JZJzfsPy7eic2BEPrdaFD","ClSummaryRow":"_1dzpMNOhGpckmdjGLl2r6L","ClSummaryLabel":"_1ZJzhENpyz_6iCkXFliAEI","ClSummaryValue":"_1uFzzGSKkLO3bkDCpmM3BZ","ClProgressWrap":"_3I76WFSNHSyPbMlI9aXruS","ClProgressBar":"G-pJbTI8zbtC2ZQHfI28N","ClProgressFill":"_2FlyVM0SHMFwgaLYMe_fv4","ClProgressInfo":"_3o9yokluCmdSiv0TDdeAvk","ClBlockedBadge":"Ch2PhRqJiKFVlr2xFf4Os","ClActiveBadge":"_1nyXy90qWWRDFc2E5P1vde","ClMerchantTable":"_2U3Zszm_SrvPrHkBCLqja8","ClAlignRight":"_3_FVg17PruxlW6k9h71ZoU","ClLoadingWrap":"Yt4cVX5UvPmEhmA8b-GFm","ClErrorCard":"EOKIXak5XJsCb6N5eM8Ng","ClDateLabel":"sQ2Kq1rez1JBQgH51ZczL"};

/***/ },
/* 606 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1l--PObBKWETzsbDJ78DPG","Header":"_38Gpx_s-fS8tsUn8_nMFSw","Title":"MJxY9uDqKQFNCtoftC1Oh","Body":"xwYreERT0GH6VbDaMnOg","TableBody":"_1YbwdGaI8Fq-5b6uPPiYiO","ChartWrap":"a_NGQ5TSeTCAdqqQrxs5M","SummaryCard":"uM9oGGx3MKYt2zCkdFmdt","SummaryTitle":"_1Xjd53F1gQ8eDIFyolEs7n","SummaryRow":"_3hTYGRRNz_2IvMxEJqXtC6","SummaryLabel":"_9Jjjylo2qAq3QfiW7cDWQ","SummaryValue":"FrbcL4Za0M17QbOdqnTtl","ProgressWrap":"_8A98fADEdXYbpx3IX-Xpz","ProgressBar":"_1PVxP5jGziBIRrH51fe3FB","ProgressFill":"_3r6g_uTK2SNUMCwEoLFOIh","ProgressInfo":"_1G5n6T-1C346iiWv1wtqNR","BlockedBadge":"_2JfgqwLa_mc_BoZvFdP4Ts","ActiveBadge":"_Ffcn-E-3DxAUvOullT8","MerchantTable":"_3EdzVNAWZ7atbLN9zTrAxv","AlignRight":"_2X1oZiWjw0zc_FFruRlzsv","LoadingWrap":"Er1gJYoLllE-RJS0VdRn6","ErrorCard":"_1UiLXVKubXsPQav0_KMEW_","DateLabel":"_1wPmNNZ5_GTsaxY_uOFurT","ContentGrid":"_2wjqyzXt1x4W71TllffXt8","MainColumn":"_36VlWdT2liWGVu67wURxDw","SideColumn":"_2yf_JgMwZRX3CpCLl871hD"};

/***/ },
/* 607 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PageContainer":"BTqQCXSMQhQ8yIk2OnOr2","PageHeader":"_1gKEYosUtIRCMRm1tih7SY","HeaderButtons":"_1HGprNVGyvm6hOIure_qiE","PageTitle":"UkiX-HZ-18PzZ5i0XT1-G","FiltersPanel":"_3z8fBXFOk_RIyZR0GJTAJS","DateRangeWrap":"_1olPSDxrB4BIlmkwRI6DtF","StatsBar":"_3hK9xbgnaMo-k0WtS7hjnJ","StatsBadge":"_2gSAfKDsLdre8SKvrVf5LL","StatsBadgeLabel":"BSeg46JWmUxd4JexeWKnR","StatsBadgeCount":"_2xq-5XfggRatzfyQnzQM1L","StatsTotalBadge":"_3Lt4wd_eQWnGLGBT0WhFVM","StatsTotalAmount":"_3tvgwWvH75tZRlEbyhHNQO","Card":"V4qUo9G3iLGBxqP_9uHAE","Header":"_3e5tih18tQFvGb1bXKIPTn","Title":"_3v6t4IUE324vxTo53xHD92","StatsInfo":"_2MVZH2klHwIeDP1YvAfI8E","PaginationWrap":"_3CBZhkHiGRj58k22rslSVu","ActiveLink":"_2zCuMJFmAZeGDi6ItbpwCZ","StatsCard":"_2XCmKQAghRAs_sRSDx344Z","StatsTitle":"MZV--Nu62_5RD99xJzK1J","StatsList":"_1-RGe4FtWj5acQymgj5A4m","StatsItem":"_3AaWH2LMzLxhILvy4AHezp","StatsCreated":"_109l_mUe51Ng-xkHxYZSCi","StatsDeclined":"_1oLlSrjy2_PDJrjl5T_ZgZ","StatsInRegistry":"_1oasV6ipuGntJQNsDw1Hbf","StatsProcessing":"_3_asXVU_VgEyvthwygOnUl","StatsSuccess":"_1Lh4gIkYUd9MSJ-m-I_A3b","StatsFailed":"uarMh4eXUZUg42-MD945u","StatsDivider":"PsF3Lzxb7ZjO5JwSjXOSi","ModalBackdrop":"_2Dt8Rcj6JRpEHRd9JVHpQL","Modal":"_379IjptpNi5ILlCoEbrbl5","ModalHeader":"_1mxlQXN232xCvL6xHsUYUe","ModalClose":"_2nuXqE7XyincxRHVVC1qh9","ModalBody":"_1zptTjMeSRHMTK3fSdRDin","ModalFooter":"_1vrs99xN-M5g_EDAvq2EZ"};

/***/ },
/* 608 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"containerFluid":"_3i4oNxfeOy9XkmuX8Vf9BU","Card":"_1EjreCrS7Jcv59-8PQw-lr","Header":"VSCkmzLIV9MyPgxR1b9oA","Title":"_3SvR-1KyzWFiFZeMqdNgaz","Content":"WtelifscC0d_Itxv6gSe9","Btn":"OewLGYnhUjaOeLjiNOaxH","BtnDanger":"i7602zLl-9DXaApmGtjbr","BtnOutline":"_2PGxMf4QeXYIWPb44Tdor1","BtnPrimary":"_2B-2HRo_06e6IJqFjE0KzU","Table":"_1LkSyK3hw8ZzfmTN3QFGom","Badge":"_18y64vR8hm27RwbJkEp9iy","BadgeCreated":"_3JTcBOUOkQ7f-UJkOVycCr _18y64vR8hm27RwbJkEp9iy","BadgeConfirmed":"RyfTRF4yrpNsNJz1CRJDM _18y64vR8hm27RwbJkEp9iy","BadgeCancelled":"_33y6t0vCrBy1vb_ZGM1kJU _18y64vR8hm27RwbJkEp9iy","DetailCard":"_1xkuWqZ4JYZkXQDDP7blDy","DetailGrid":"_2f4zppPhaOLcyDAoln8-4d","DetailLabel":"_7zbIw-fGv8MB-o_TSNUhO","DetailValue":"_1ipdR9E54VbnslB4DGJNW_","FormGroup":"_1N6kP9DIJcYOM3CSlqDbSW","FormRow":"A8pAckXOfoNR4asZ-OMwg","PaginationWrap":"_2XzD-UG0969lRu69GxFn1w","ActiveLink":"_3sDKfrLakNdRRPJNZDZbKy","FilterBar":"acWnGQoieOl32iX5e0n2k","CancelInput":"_3PdxZBdEHcufWC9CwhNjGK","BackLink":"_3gQvmZ6PA3FEuMHHPZ8-JR","Empty":"_2V0IfcCGlqJzzvv9Wv7uDN","Overlay":"_1RsyJ4HBrmNdByesrp5Doz","MobileList":"_2uBblxe1dbzVPrJ573t0wW","MobileCard":"_3G6Ui9kZRVoY1RRDfpRUUA","MobileCardRow":"_1talLNeAMHP6PXUp_QuyxP","MobileCardFooter":"_3Bf7W0Dh3epH7Oxue6D1wE","MobilePrimary":"_2GdBIDqAEyS8UguG6HllrW","MobileAmount":"VarY4rNhnKMfojaRHhY9D","MobileSecondary":"bJMvFjklGh54GkngDMF4m","MobileTertiary":"gamf7RbFMJqXmvbx7vvxW","MobileMuted":"_17ZEb9l-pv_0Pfv-WCsnzO","MobileComment":"_1HOHH4qRML7QVi-2H9231P"};

/***/ },
/* 609 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3s00o0McKReSZ5wiykjhHh","Header":"_21wPL3HG1Br04xgKltfiQv","Title":"_3CDdGSrG0RmLyBswTs9WRm","StatsInfo":"_3566xOG3WfAAtK7CA8eQwc","PaginationWrap":"_2R4lfMWW6-C1DAUpkCKYqw","ActiveLink":"_3vWh2R4fdBOOHoRqEXPnos","StatsCard":"_2sSVttJCNaUAWf57AGVwY6","StatsTitle":"_1uF4CDjiCSaphq5FoE5PBm","StatsList":"_5QzTOoMsv_kv6QlMskFbm","StatsItem":"_6tlDhPVpAXvWlrdyyYMn8","StatsNew":"sW6ftZDxhpO05dEKJzNQm","StatsProgress":"_2zdQUmj84EXmIcU1e-eN_Y","StatsResolved":"_3ZMNsVzxve3Ahx3h0to39F","StatsArchived":"_38zycLDXnJH77ihg_RnKUb","StatsDivider":"_3aXGHINCNTg1UJX_Wifx6p","container-fluid":"_3B8ld8GqasLNDiZasK1baz"};

/***/ },
/* 610 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PageTitle":"_1foFd_iGNxmIFhuQehmEnP","PageContent":"cQIsV6L2NeUS0UXB2zZBD","FiltersGrid":"_1ZRHYJ7q-V7bcYFNgdnmYI","FilterAction":"_2veyafCnt47QIRqUDxasmM","ClearButton":"_1BnSLzsyTqf4cSxeEVO5QG","TableScroll":"_2GFDe1U-Aen57I1dHyfb19","FrodTable":"oPtmp8r19zGp4GO63yqxZ","Status":"NChls5TpQ_DjJKMKtBpJ2","blocked":"bciF1uLCScfSNwcZFDLhE","allowed":"_1edCFJ5bAbtjL4hZ5ziC_P","review":"_1-h0-AxSx3Equ9cNN1iss8","Empty":"_210HbUmONjcO9pF1-sv3YX","Loader":"_2SmUuc8Cqw9luklihoqGtm","Title":"_9R8Me69beHBg0-NXsk2BW","Card":"_2_bpEie9YmIiqAQm6UCzR-","Header":"_2o9qkQZviCrfTz6InROKaH","Btn":"pINYCRpCRVSX2xyGwUhPF","IconLeft":"D1y1_ZtDgCUtSCfxy0PDT","PaginationWrap":"_2_nS1eoUORZ-a5ykZZkg7-","ActiveLink":"wqYUEP3v0D7NEIeFQVjcg","container-fluid":"WjqL3NQ1aUuNU3kQ264mA"};

/***/ },
/* 611 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1PKzBZ_WmNfZ8SqvnD4-c5","Header":"_1TYndKBQfnieaPvLUsUTnZ","Title":"_9xBeq2mCMmOlwScHo-ufG","StatsInfo":"dqFvPfd8k8JneLneN_4qc","Body":"_2MKLrhRzhqQPLsDdB4t6_V","Hint":"_3h6ei6K5BRGYVkGS_Caxd6","Tabs":"_7aDs122AVdm58yIWiNFI8","Tab":"rUqfJW82vjd62eEhijMoq","TabActive":"hNDw0Zr9N_txPeci1MJWv","TableScroll":"_3dOXR-s9kcYFGXfJetybDM","Table":"_1rchNa4Q_FCNtCuL0COiE","Nowrap":"bT1ywR8LlLlDtK_qXShgB","Actions":"_2Cc6Wxk-3hy1u77MOEE_ls","BtnPrimary":"DGvq9GSUqUtx7JA9O1K9z","BtnSecondary":"_3og50payaaAy3XaD-ogwPX","BtnDanger":"_5WTZVAWNvp7Gmp_41OlMo","Muted":"_2D6uUBwd8tWn1cGQ0t-z1D","Empty":"_1Z4Atl9d4fYJFBsl3kvYeo","Removed":"_2m3qV0YtSooMqfRoR3X-nZ","Form":"QUGD8NHU7GzkHd3ortx9-","Label":"_3YM-8Hx4AOxgazzqPtCnVy","Textarea":"JYlFwh60h7zMClkqqG6Jo","Input":"_1ZhZQQsoFvxWbYk-NV-Q0_","Checkbox":"_3pHZAXpGKNr6AIBCAm237W","MessageError":"_1oTIiVUAtOMCUWIY4JPhru","MessageSuccess":"_3nhgyM77m0apEnw4USX2s2"};

/***/ },
/* 612 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Payouts":"_1vPv4MNxix0Evf7esjOhtI","MainColumn":"_1Mobt5oG_1MV5C8Puw51I","SideColumn":"_122RdD5mb4Qc91P7YzhdH4"};

/***/ },
/* 613 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrap":"_3iF14WdJu-LK9neZNrBCHt","PageTitle":"_13l6gx6KaRNJxHxZJndBY","Card":"_2SzhyYZdMWQjA-uxOQJehm","Row2":"_1wec1l1V1jTVM-RBlRPcxE","Grid":"_3AkaYPy7fEeNdPId9ZLBOC","Field":"_2Fd2PkN35m6eWD107HpJjK","Label":"_396C65WVNLIb_uo2wjL-SK","Required":"_2nPRrMNKLZEukbsvilpjdy","Input":"_2EayvDlk1gSxdPYY0Y5Uue","Select":"_2y-acW__C2PdbYAes4sstl","Drop":"WHU10Vn-2SVcRTmgW_ux","DropItem":"ZDgTqmNOu_UuHHhlOjUPS","DropTitle":"_2lRjnTVv6Su_nS2jKgD8H5","DropSub":"_3JyxU8cnIBEwqwi9R0N8hh","Separator":"_2D3vuhaU9mg4ZHDyC-GUfL","Actions":"x2fABL238sDPbpi03p-oM","ActionsSpacer":"_3giDzqA7E3LsXMr7gjDAmh","PrimaryBtn":"_2HVDkalJH8iMxiBCPCET1r","SecondaryBtn":"q5MELs4C78Ik74dvi2fbz","Error":"cOvFESEEinXdfEOAJDAmG","BlockTitle":"_1UStQUf_m_DTGALERqwqbR","Pre":"NryKwe59aWLOANr2ClIJB","CenterWrap":"rASPqJ12ZZMhgfQYt2CwF","LoadingCard":"_3dCKUGUof_RKr4_MCLSl2m","SkeletonTitle":"_2cExUktL6ks_BEYp38BMwi","pulse":"_33e8FTtxC729q00CNH0E_V","SkeletonRow":"_6yU0laOyDjvV0TlJQPy7b","PickerBox":"_2JVKWr2Sp8YF0HXND4qABv","PickerToggle":"_2hWgOvEYqplqEVR7RWd93X","PrettyBox":"_24vuNKprsqllZem4HDsFGr","PreRaw":"_3HZww0_HjGoUwvCkJ4-6KN","Table":"_2XSVnlBlKtEgtpBPQFbWEC","Tr":"_1bqDXFxTPxe41sr9N70QlC","TrHead":"_1te_TQ5_HpfX533891QqfC","Td":"_-1XWC61WOgGjRwtePAFtg","TdRight":"Ytg2DIYJmCbCHUYv9LFrM","MiniBtn":"_2Ok2pcIGBkZUVz9gthXKRN","Pretty":"JTWW8Ld8QENI-X7vuphuV","j-key":"_1vaG6VvCxWcZ1TireJvOAW","j-str":"_1am_m2xsVYPFnFiwaiZYBZ","j-num":"_3hh9ix0MYSH-WHCGHyAk7w","j-lit":"_1-FGPqYp-6DLnQ4Em8AYI9","Details":"_1WmD7X0svuxGrxqPSNdBAa","container-fluid":"_2IpBcfmKQCUQ3pAhtxUM-x"};

/***/ },
/* 614 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_33D-7PUSGyn2g1i_uir11U","Column":"hj_Iv5O5Sm0sw8rsAC72W","Title":"_35ax8-A8tqa5ldZY87LU0_","Text":"_27KVGnrFHE51fKRgtTTVU","InputWrap":"_3L2gaWnW7RDgNmiG6K-Dyn","InputHeader":"_20BTDkfPcSKBsjbAaC_YuW","Label":"EOo7Iuxu3pYFyVpbm65qg","InputLink":"_3Pssk4PhV0RfUqlh4WrtUo","LinkIcon":"wLTpkTWEPO3EyThm8dRyN","Input":"_3mo4VKpOI6c5THanmFqr6k","Btn":"_3ETy-_mZ-m4fjGreoV5Fo2","SaveBtn":"_3SrSQJ5d8MU9TKf4pyif7N","Footer":"_2xPF4i6ig_yVzuJ6uUxU8l","ModalText":"_1eAZFla4fkVQ7GSqUsjfPa","Confirm":"_2i1C6N7XiiuLhp5qTPiUZy","BtnIcon":"_11gEJ7qG292PNaRRmgeQuk","container-fluid":"_3oa5uBtHkm7leZ5JVUgMHq"};

/***/ },
/* 615 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1hAOzr4F-IcL-zDe0ANKDq","Header":"_3UJx3bBotnBc7QkR7DDQxe","Title":"kpKUCXaEaJtjLxP87aBo","Btn":"_2rgtnJq3ymkbfgGNFENeO6","IconLeft":"_1WTu9vjnWPxdOsEmyJMjYX","PaginationWrap":"_2BlhjLGsPYvQakNL7_FGV3","ActiveLink":"_3AFJ4cscRmA9JZwiXBGBo9"};

/***/ },
/* 616 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ReconciliationWrapper":"_18Kkd6gD5VshvgPDrNm-aI","containerFluid":"yISadIHqLgWOR4sHMFjX-","FiltersCard":"_1NKbxqeTgtVMdBltyv271P","FiltersRow":"_3cFukj4-DVEnGgiTyVh-Xv","FilterGroup":"_2LzpGcFdVeBH7n4BNnGZTR","UploadZone":"_3ekJGhWWdc4yLcsrkYN71","UploadZoneDrag":"_1Q6biR_Lr45sm5tBeEjDS7","FileName":"_2DlJDpI0fmFRb3n_i2L46G","FileRemove":"_2RyuLU3UIOVn8peD6wnFwl","SummaryRow":"_3Aqs-T6fYNEgUscSF0z_ld","summaryCard":"_1yDevNebELXL9sxDaCyz5_","summaryCardActive":"_dU_6nZisUYbcEN-rzzB_","summaryCardOk":"_2baBG-H-9g5d1nPWsHIiSi _1yDevNebELXL9sxDaCyz5_","ReconcileBtn":"_2zzDj-WKKhBNJcnTpO0f1O","tabDescription":"_15wPwifNJLRiyGXHOjBLh2"};

/***/ },
/* 617 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Block":"_2q-XcM509ueQuiJUMGul2t","Col_10per":"_1Rt7EkpUTPnwIECRWqX18a","Col_30per":"_2LT7Hdq2T5zEQBn25dfOlz","Col_20per":"_2P-qNmxP9yeg_4LAWJzL7E","Divider":"_1EPnRhd3we9El630DfQiN0","BlockTitle":"_1GdSaX_SK89l2M2KlTgCO7","Footer":"_3gOY9c34mORtvdL5g8vltj","Select":"_28xP7PkZSBHcBJA3CO5Mmk"};

/***/ },
/* 618 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"containerFluid":"H_COC39rzCRtLXVJ6cm8X","Card":"_2F97km_dyZUILOaLh_XRAm","Header":"_3kogkVua6wwQLz0FW1P6S0","Title":"vT8Xwr2V6yyuf1Z8tED2y","Content":"_1BOKFoKqWE1JEiTqS_pKLs","Btn":"_1_cTjVWpt0KymFkw4aIfRe","BtnDanger":"_3xBogYJwg-qFSWISmkK0oX","BtnOutline":"_2rwfLIZ6s4T9vZ1CY6LJ-0","Table":"qJWXIbA4pRb1snxW3rIGI","active":"_2sKNk0Dktii5BfrHupx4tC","Badge":"FO0DdlDkWjNcRWaFE0aOb","BadgeCreated":"_3yHdSa4MHRO9g1p4nm8DEZ FO0DdlDkWjNcRWaFE0aOb","BadgeConfirmed":"_3zTRSfPPlsotsR9GpD1JuW FO0DdlDkWjNcRWaFE0aOb","BadgeCancelled":"_3IQe-hQX22J1lYMETt40ea FO0DdlDkWjNcRWaFE0aOb","DetailCard":"_3bIoF--eoNQDWeXjWJgNrO","DetailGrid":"_2eR-an7zWkCdOqHgk_K7xt","DetailLabel":"_22ZwsEVyc1odvzLX_qC-E1","DetailValue":"cltp5ooYKxFDNWsGR1v","WizardStep":"Ax1qDf4s1HR4VgIx5h3Jn","WizardStepTitle":"_2t-NyLDiWYJayn8RyfuCEb","FormGroup":"aeuln-8iXW8bV3LZlXvKC","FormRow":"NOctV0sa6EUqvffjZ5HIA","PaginationWrap":"_2pX7QDzi3xlYadIu8cZ7qO","ActiveLink":"_2mD5OOqvCdjAQ7K9ZqTz1c","CancelInput":"_1ayMTRtIvbTmlLYUrr9w9b","BackLink":"lC1lFZUhxrYnWEKG3bUcv","Empty":"_2g9a_F-tn8t-jNi50YQFZO","PreviewSummary":"_3h1JvnJhi6jwI_LgsyJhr4","BtnPrimary":"_34IzEoU4XpsepifD0S5Sdk","FilterBar":"_26CUHVB4oJghOvdrNtYsTu","ExcludedRow":"WaHw1NzVFxEAnXGt0QzcM","Overlay":"_3dKurw3Y-od1MTU22-2AP7","MobileList":"_1E2bQU89jVUSZTl1XE3wrD","MobileCard":"HeZc_gyW4quby1kQwPT1","MobileCardRow":"_2q8MX1mUwj401DwJKMJoD6","MobileCardFooter":"_2zrsoUTCFyFtDo_HEPQdIm","MobilePrimary":"_1HZhVUo0EQZi2VCwtzmFls","MobileAmount":"_1Z3PQgk66A48afaYfKM-yf","MobileSecondary":"_3T22MLynECuC_pUygHiBKn","MobileTertiary":"_196nZezkEb9DlmcA4Z24_T","MobileMuted":"_1qIJrqZQWwlO6v-1RKhSg7"};

/***/ },
/* 619 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Outer":"_1I4CMaLQULTbNA6jxMQRxf","Page":"ZzH3ByK4kHlllLPh71xsx","MainPanel":"E3xwZ2uTGCU5ni0aR018_","SidePanel":"_1JHpv9kyshoO9VfGbaZRHn","Empty":"_39ABrR0mUbjh5FW21-kqCp","EmptyIllustration":"_1tyRmjjP5K515ipwC1ee2X","EmptyTitle":"_1el6Ep8EPTWJbWbCQ-4d5k","EmptyText":"_3i4xpYsHU4IzYS9EPadnAW","ChatHeader":"_2ic-2-IstXDtGKs6n2AoOy","ChatHeaderTop":"kmnqzqYK6_biv8w2gIj_J","ChatTitle":"_1f7mSxVxL8x_7yAGgf-CeW","HeaderActions":"_1X5s4BrWugKeDopVrolR_q","MerchantBar":"vVDYhu0bi5P2ge_363cpV","MerchantAvatar":"_34rpw9xx3ZC0rq_LmhTDdA","MerchantInfo":"epHE5XWdphBfHp70x4D0a","Name":"_1BfHdXd6Ryp7f6l-Q7Psu5","Email":"QwzUDUBwgZK79vJnv6x9V","HeaderMeta":"_3bpZS8PWL6oWeJiarqzTjQ","HeaderMetaSep":"u4NvIFJUIh-8GFOBg14iW","ProfileLink":"_1ZCKc7Db1Ax12sfCAmeu3O","TerminalsToggle":"_3xk-mNHy--eqxxh0hHtd4t","TerminalsPopup":"_1q8j2ib8nTiS13ScM3ZbaZ","ChatBody":"_1MQ476n9xyFt6nvDKGWSLI","MsgRow":"_3AsqJIby9NPlGwuY9Wagpl","MsgRowMine":"_1WHr7GVjjziBiEh1cqGAIt","Avatar":"_3hvNGwXKkbgQAW7LgY6ybh","AvatarSupport":"eyjiR9ONmRRt192DdV_Fm","AvatarUser":"_3lLM92jYPvWuxOEmprWPMV","MsgGroup":"bZGFn8gs2yV4V-a78ikf5","MsgBubble":"rLljX5DoOh-5aCMfxXzAL","MsgBubbleMine":"_28CbxBelSpp2sRCuT7odF5","MsgBubbleDeleted":"_3bNIL6IbaeFzPLHgC1QnQ","MsgFooter":"X8qHBMkGJ08hB5yBiD1ef","AuthorTag":"_3PATyib4779ghGYk3GC2yr","AuthorTagAdmin":"_26_woPn_uotcauUz-QZHKb","MsgEditedTag":"_3cMkPOKigirYLBkip-mdPy","MsgActions":"_3d0osWfycfel1ZLSXjW4T0","MsgActionBtn":"_3GC7uuOM0B41wgplk-Un4h","Danger":"iFVuc8hH2K2A-enlryJGZ","AttachmentChip":"_3wljTI_agFB_qjH3idvT4k","AttachmentInline":"D31uaoKi49u823bdPEBAi","AttachmentDelete":"_2JKs7w8NINHRw81PbRosA2","AttachmentPurged":"_3A_QfsS0w4lO7dyeDCqi6i","Composer":"_33b68VwY12y99tZb7JD205","ClosedNote":"_3avmYy3DsFX4bf96hYUyGU","ComposerError":"_2XmWHb_BtZXhrx_9_go_B-","ComposerArea":"_238nAOMt0XsGmS7FBsHqNt","ComposerToolbar":"_3FE2oLNFANGXyISus4ttQ3","IconBtn":"_1wctE_j4sBS_ByDT-SSO9_","SendBtn":"xuHkQ42zLHxIqVFbRqL51","AttachPreviewList":"_2IPhLoKe7wTo3U0QIGr8Cz","AttachPreview":"_3p5Rt5tFPY4cpcij8pkwzU","AttachRemove":"_3LEc9jui9zSe7r4CNSbi9I","HiddenFile":"_-1VRUMaOg1v0x_QGKVtwv","EditForm":"ftwzfR-qbllht2Tkynrna","EditFormArea":"whTmQFvVRLAEyatn4ateW","EditActions":"_3hJyiC47HZSe-HKri7Nmkk","EditSave":"_39ByQAr3YPmRuRiQTiOLfM","EditCancel":"_1co4YD3MDYWsyVR5GuDK-Q","SideHeader":"_23OLWUPpnEFE5-1gEo07ZF","SideTitle":"_2n955Snwr4KRv1wErEArQ1","SideSubtitle":"_128gVo1sbI4eBH3Vax1Nhq","Filters":"_2f23qJAJLAEvYALQqKR2-3","SearchWrap":"_1H6QQtDY-j5Zlb5GjYbGS8","FiltersRow":"sW95jXJ19q4jPE7MMDuq","ListLabel":"EPOlyrRVWXDYzimxgx91","TicketList":"_3mGcVkV1u3t1aSIzGqxKOG","TicketCard":"_2QCIS9sIVqGCChdbYU8N00","TicketCardActive":"_1Ifkx2pCU5jX2OeHxYLbd6","TicketCardTop":"_2_OyPxQGhBeo8K6XrMJIIL","TicketCardSubject":"_2gsvkyLEHKelKMQ44N6iDZ","TicketCardSubjectUnread":"_3D5u_Olr5CXn5dnCdLeFqj","TicketCardEmail":"_3t4efsVeHavNrP5RsWnEtk","TicketCardMeta":"_1zUvjFpmofSIJASgPsULt-","UnreadDot":"_2-VNSAHq_VO0EQ52oMxvI4","StatusChip":"_1d7LATyQLUSY0iuI8CvwSK","StatusChipBig":"_3EZ2dEuUPbo_zJjDdcjVXH","StatusChipHeader":"_33wZ1laqnuuW5aBHfDmwee","StatusOpen":"_3FXo__Fn249VfmcvIoIizf","StatusPendingUser":"_1iDiY3QSowtHG_iL08wKow","StatusClosed":"_2M5z-Giht6byna2-rzIJSg","HeaderBtn":"_2pC7Yn6rJBBEphPsQKE5cd","HeaderBtnPrimary":"_1w8Q6ToBrn8zVRzrtfDMLL","HeaderBtnDanger":"_1rmqp49IPVCjDSNpu4wPfq","Pagination":"ygp1vVXJtn5eapFN9Nkt","PageNav":"_3F-URXVDtYPzkNOukLsvcN","PageBtn":"_33UDfwgc553FGje25vwp1q"};

/***/ },
/* 620 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header":"_1J12imWwUvT5lak_Lc-ylu","Title":"_3Ok46x0z1U-NM_RwGph1AQ","SearchSection":"_1FLdqe4D4KE_LquSDbVuIb","SearchTypeSelector":"_3PgqUMRHa6nn-TpyURJiRV","SearchTypeBtn":"_3QM75mrdN34hvlj8X2PoYX","SearchTypeBtnActive":"ss6Bfb8TNKJM8KVx6EM3R","SearchTypeHint":"_2iCNBlQf75UUsSRHkGqUum","SearchBox":"_3P-kUTHZ-3bFRQcEbYfCfs","SearchInput":"_1Q-MiEXUk1OfbpgxvQZA_O","SearchButton":"_3dM9PUTCWVG9ZAj09Mli8L","RecentSearches":"_2hy-ygT_Ai6mVq1yw1Kalc","RecentLabel":"_1RCNRrnfO1GRMNvm5s6gXN","RecentItem":"_1cUmhQmiLFR6gOrvCNlx_1","ErrorBox":"_1AqXtgL2IykLWGe_duR1U_","ResultSection":"_3BPCAzsygC3nL8pEpzV59s","TransactionInfo":"_169fwssUAVbrkXpReztoy4","SectionTitle":"_3RJRxIEVcNf8cliJhXhEdl","InfoGrid":"IEyaFWHwhD-KEmd6grA-M","InfoItem":"_2YbHZJAVM1SE4EcAfShr1z","InfoLabel":"_31y7QD2NP3yDk330pQEx4P","InfoValue":"_2e38DfsizOoObi5DBSYvZj","TimelineSection":"_2y9N98YQ4Ou2oxcrh3badG","EmptyState":"_1R4nthADqfoQP1xStLUc5U","ModeSelector":"_1TjfB6-iUpeh8xu0RC31_q","ModeBtn":"_2iO1W36G6mHYkgFe1deRgA","ModeBtnActive":"_2lWV5Y9YCYG9JLHjkvIfZP","EventsFilters":"_1lGn_lJQbrJb9eoORnOfM-","FilterGroup":"_2BOw1oiUW-4S7Af14CASI5","FilterLabel":"EjpDLLomjbCEQkk8L6k4O","FilterChips":"_1uzqpK7Dlujq2s-ebjC4aZ","FilterChip":"_1sXbhfs9ZIsK4qQbmA06Sf","FilterChipActive":"_2wozlOQBydjIiJZ0IoCpP0","FilterRow":"_2tBxrf9jRlo-zkepXUgoTU","FilterItem":"LllwxhvQyH5OfaawHs9-H","FilterActions":"_1FxGg6yA-PJ-rXZwSdBZdn","ClearButton":"_3k_WEdU4t76yOLmAh6zeOn","EventsList":"_1vj--HEDZPA0i-PsZNzUGp","EventItem":"_3RLGjaMyW43KYUBMlW0ALX","EventItemHeader":"_19hJEEVRxFTMnLdMcii2bU","EventItemTime":"_1usMOaOYcYp3IcTHpWuK6w","EventItemType":"ROw6SFf_tY4YXBn2Ly55B","EventItemActor":"_3CqJrzziCxTU3LYplDcUFh","EventItemDirection":"AfxLBqwXLR8DRDXjGuWFE","EventItemHttpCode":"_3emVZLeH-hluyjgCZFUAeu","HttpOk":"_2RvzXqDd2wCfbA8ItDOMF7","HttpError":"_15AvbmPwJygAr848bt0WYh","EventItemError":"_3Ijk0V-qzdJEj0AXNNUJ3d","EventItemTransactionId":"_1VfCN3qlKh6PQIv93C9QXc","ExpandIcon":"iGJHlKK0iVcU3nQCnVkoJ","EventItemDetails":"_1ZpcoXvs4JVYql8EMtep41","ErrorDetails":"_2on3lR4ZBdRLow4b13LPVc","StatusChange":"_39f-QW8RCeUf76CffDpGXf","PayloadDetails":"_2pWhavXmfJ7a9k5zDXpb2J","MetaDetails":"KfS6ngKw5JYTgnCq_dtQ3","ComboBox":"_36WldyZhTVFd64EtCwnULD","ComboBoxInput":"_1AOeue5Szae8p_2WYnNoIQ","ComboBoxDropdown":"kDtqo-8gUt1Sy3ep09Y8b","ComboBoxOption":"a2wA7InQI6-i0hee1LNb-","ComboBoxOptionActive":"_2CCCgBeMChnVO-bl6Ie79M","MerchantId":"_3mLxiVlcNUXg8U5Bhoyu_Y","SelectInput":"_3LnIrNK5LDyP6AxbNAwPiM","container-fluid":"_2TFTae9V3ejEXCJKBkqqhr"};

/***/ },
/* 621 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_1oI1hhhPvGxo29aaxNxdTT","LoginPage":"_1lkS6cPEnVa4vKATvcotlv","EclearLoginBG":"_3nLjmer2l1FZNvHed96v3X","UnlimcoLoginBG":"_2WRNdDBdZ6-HAg2xD075uC","WLLoginBG":"cprn2WgCPh11oulRkTRSL","Container":"_3lVRW7sd3JbQi7fWKiaVtX","LoginWrap":"_2-vaGRX7V6ZcwJLNTbHdrg","LoginInfo":"_3WaJGszTo8NGn9eKFfgpvT","LoginForm":"_1vq-yUtProKqMpJHLCVqBs","Title":"_2-2iBLdRs_8N-mlmUjEI8m"};

/***/ },
/* 622 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"_3GolkeK0yq1gLdANGYmzHu","Card":"_2g0Ce9tZTM2QHrHx8fi5XQ","Merchant":"_3GmWEYkx5Cjl3-U9SEOaTF","Title":"_2QFPUoYqN1B5sZtQkNa7w9","Amounts":"_1aZCnDI0ZTZ-5Rmu2jicF7","Amount":"_1jZ8fizzyU7ogW65XQO-Lp","AmountKgs":"_2b6vek3Cy7mMaBjbOuVqXY","QrBox":"_3B3IG1XLnWRtGvGzNw1v-R","Qr":"_3Wvz2rVFindAtht6AA-se7","Timer":"_3KvCAEHw-Y2A5r47qA2D4W","TimerLabel":"IXPZ8MaRAbi0UTq0qIZU","TimerValue":"Wdlj6vJi8Xy4CCwz9o6Z2","TimerValueDanger":"WCivi1vCNKx0OQ8A7r5Wq","Instruction":"xdLp-w03g5oA3aOEJJXcW","InstructionTitle":"_1ZY4yMyfKERo6U3raDg7Qm","Steps":"_2zCGXnq-hMqxVL40uczokO","Note":"_38f-jjnqLKYK5nKh5BIfdK","Waiting":"aOYuce_UH1xcdPsvzBOat","Muted":"_1c6GOYcUwX7nHRkgVN5WbF","StatusTitle":"_3mppmwrrKizy-99wOwxcrU","StatusSuccess":"evCKu3BUXEnV3zA4byLAG","StatusDeclined":"lF4MdAyBZiIHm6EekYOFj"};

/***/ },
/* 623 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sberPage":"_2wXX3zxZZCS8wKiq5dZfQ_","sberCard":"_2J4gsnLLpWGaisFDxMmJe-","sberHeader":"_1IIM4glOt3BYAQZeX0q6qW","sberTitle":"_1oNUPoOwENVKkyLwGFbVrN","sberSubtitle":"_1GpdvfWfkwQStahdVOcPRP","sberInfo":"_23hglskqvyxIzea4mXMWS9","sberInfoBlock":"_1UY1_RT0JMsfUvYv5mRjhy","sberInfoLabel":"_1XMk2R6N76jcww63aFDnrX","sberInfoValue":"_23lBjHy3d4YjS9owINFHPg","sberInfoValueMono":"USTW2oo8GgGvVc4yB8k_9","sberInfoValueAccent":"_1w8Deg_tGUQXgkbNnlFu2R","sberSection":"_2N0rvcG8AQzdETVGZQp9y0","sberSectionHeader":"_235Su7gdBlOlpwSpv7cVdF","sberSectionIcon":"_1TI_-IdELYVhoayHWm5YMc","sberSectionTitle":"_1JzrRYK54UOEvIsyVKpEsL","sberSectionHeaderAndroid":"_1UxEMpNyP9YlL5Atu95TzK","sberSectionHeaderIos":"DLYF8NEb9I2QwwxtFiwyU","sberSectionCount":"hYpjXQ4j-wqyVqsRIVAsJ","sberLinks":"_2S5KiDRCwikBg6MqHhewg1","sberLink":"_1UEqYMrTqy4oG6c5AJgOO2","sberLinkAndroid":"_1wya5qRhUQ6EoDEoDvQY5t","sberLinkIos":"_3k9W6qzIKdjpwI2kmBTunf","sberLinkLabel":"_2qPwJhi8JQodsXTXZYhMg3","sberLinkTag":"_3RjaWcrYLDqmEVLq7KcF5z"};

/***/ },
/* 624 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"paramsTable":"_35NHFP2Tz2jNUPAFzeoVBg","paramRow":"_1hWQoaAtJyGAhkLJFZa3Gp","paramName":"_2z4ivcez5o0PmEyVEnwzLt","paramDesc":"_7bDAKo-Mq1UVfvATqQgvQ","demoArea":"_3cHZ6RUqwruVQwwTALCyMT","demoButton":"_1tbFX7kASUq5GQca4mys9h","demoParams":"_95VLjGJShsyx0DIzxPIWo","infoBlock":"_2YmSp-IQkMw37vabCwBRso","warning":"_1Bqavf_5hu9i2TMU41c_Mi","infoIcon":"-CcIHisdLQ7YXbKOTBfcU","infoContent":"_28tlF65TKzo_rhZCh-dPWt","steps":"_1xylz7UbMY7ZNKBdU0M98s","step":"_1SO4c377CYvrbU2RbVztTr","stepNumber":"_2JFQ9Xc7eo8BoC6WCt6USA","stepContent":"_3JDbEbIUtzOkJSy5fZ4Pt5","stepTitle":"_2XisVCtuJ7gB7cL4TFC-c_","stepDesc":"_36Y_E2VyHB7Xd86Vdf6cpW","statusBadge":"_1zyJC-Wife6mZYgAy7o6nU","success":"kVAxKOqmNbhH69XG3w36k","error":"_3n0ywWinJguwKhzdkRBNbH","pending":"_2p3GWMSoupCBGhuLr9olX1"};

/***/ },
/* 625 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ConfirmPage":"_7iqVMcnjVFapoVhsdB9K5","Container":"_2Lw3EdWHPJVHmIXymikEew","SuccessIcon":"_3Lr3de864E54qE8o-AiuDG","ErrorIcon":"_3lc1jQCuackR7nvD93BVS2","Title":"_3TbmuouGXOduzC-vOZE-UJ","Text":"bt0bYX_fc2-OnT3OQYzPa","Actions":"_3r-7U9lpM6VTmFF8v_Cd96","Btn":"ixSgyPxwOOH3gjocZCjud","BtnSecondary":"_2-JxPL26z5fJso-xzXkk8T"};

/***/ },
/* 626 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container-fluid":"JJxScTZiWCGt68Rd3U8qh","Card":"_2e9LeZc28TGZaio1gNmnh5","PaginationWrap":"_3pyxpA0V_yqLaZY64jplri","ActiveLink":"xIAhvM7oyu0IRDCXxQsn5","ExportBar":"_30hhxWXSZVp8VhLcaXHL4m","ExportBtn":"_1IRRYbUJqBV42ao6oQnFn8"};

/***/ },
/* 627 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Container":"T5gYKjoDEdW8oukSZwT-v","DashboardWrapper":"_2zjFHxZNY7EiUJZzJZjG_h","FullBleed":"_15Z_BBjzJkkXAkthUlDPrX","FlexRow":"_1-9PuMCjlLpIRs3spccSAV","SummaryRow":"_2V33Tu6idwNnXGmOsCHjzk"};

/***/ },
/* 628 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_3jkytdY-JFNSlDLTurPNTg","Column":"_1JCqJADqGz9aZO3egFTdE3","Title":"_2jco4MNV-k7BohKknqPJwd","Text":"_2NAvAId_MxLxcGOFnggS7D","InputWrap":"_20vcI7xPLtMHrgpZdovMdT","DoubleCell":"_2htQdOOL2Y5ghpgbfEi5xj","Input":"_35R2TOnejkZwwbd9i68FCr","Calendar":"_1PRnw-3wTqgp_S2ZtpWm-f","Label":"_1HZui5KJz4HMJOYp5ypYll","container-fluid":"mO48Q1oa3k2yzgCfgYJgb"};

/***/ },
/* 629 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_3aT78nmO1xXcb0yUat3Okt","Column":"_3xFyOlIRxMAPTE9a_1s-UK","Title":"_2_W_UGEdVDaxh_g0RR1MVB","Text":"_3hKZrsNLcRocM4DfIGU1lE","InputWrap":"_1B_VKMyOeLD4vVKvYyUU2g","DoubleCell":"_1lij8FWcJ8cp7gZWvtNr2","Input":"_1bJg4nMgebh4EMzJGs2YcC","Calendar":"_1FHAjgGIFAKgMjViJHzaAV","Label":"_2xmoDPXs9xNxpANnx_9uRd","container-fluid":"_3u_XwrLTLLMCCUv7mMsCmV"};

/***/ },
/* 630 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3iVOj4QqBNFM61ukWpIuaX","Footer":"_3E19RU95m80cC1XoJfu9YX","MenuItem":"_2ARdJf-w-5ZzN9xYXK1PnN","Header":"mloB2F7JkCS3ZFlQa6TrV","Title":"_2FX3UpTbJGYFvCw3CYr5Hg","TableWrap":"hNLyJBCPvkEV0M5UY-Xo8","MainColumn":"_3Y93Sx67zNQ5RLjqbfGy_m","SideColumn":"_20PZG52VFueBbaM_SClh1Q","StackOnMobile":"_37Ly6LrZMsb8BzxVCqGuXo","container-fluid":"_6yf9xVyY3XTpnyequG_Ct"};

/***/ },
/* 631 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2u-jfkONLjLOZ3ElUs26bY","Footer":"_2aVq0CgrW8ageHJIfw5lvc","MenuItem":"_7TdLz4tkL8XO_abajS18g","Header":"_2Cj83Iahdkqis2_MqHJ-y3","Title":"qbkIvXAinC17zFWMchq71","TableWrap":"_19XschnMQrIX4jTWrBKMFd","PaginationWrap":"_2OPGaoHH4tCJ1sTxrXknHG","ActiveLink":"_1B9jst-T2mIuFjXh2ZAioe","MainColumn":"_1KRqX-TdaIkJxZ7bQ_E86w","SideColumn":"_1Sa_xxcfZHIxh0XmZYB8UE","StackOnMobile":"OoP84wbsKEVji4hyQiOwj","container-fluid":"bVW1ATHWvDMj8Hdqvk24y"};

/***/ },
/* 632 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_3fh_-7dnrDX0d1A96EFKb6","Column":"_3lgPbg-Cpt88a3UTj1b6Li","Title":"_1_RdblH7LNNKl1pphOX9Ho","Text":"_1g0gYQSIP5vi0j9zFLqohN","InputWrap":"_3Ai-5g3UU8CuvBjwjIbOIA","DoubleCell":"_30PzwllNBAmhSri8PxQWpx","Input":"_1M-iNb7uRn-XZx3fmQ_YXx","Calendar":"_2ENXjqRtcylm2UizsWScuz","Label":"_1wTPZFzdSgLbFRJ63NyyVU","Table":"_3GidCoANBZETzBNbYOxCar","TableHeader":"_13Yh8CcD9LWa48Chawp1fO","TableRow":"_60TxAm6T_P_IIoOAnvNuL","AddRowButton":"_2udzcc2apKYDa4-cKIqSTZ","Header":"_3icU8IPGwKwr58FzjQCyZ","Row":"_1paWY7qzgb8pAAsI9Xx8Xt","RemoveButton":"ZzB4a1YFThSF8Nr-RmkRx","container-fluid":"_1hyQCzbz7VkAhPEmRPLpDG"};

/***/ },
/* 633 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_1PWoN2HoaV3_IDg248W6-C","Column":"_4GDoT-JBDmy0AmODPPKiD","Title":"GOVm9ag53jWjBjssQc6sl","Text":"_2N85XErQAzEcyenGi3VRTw","InputWrap":"JgPkBxo2iSlSc2g3Kaduj","DoubleCell":"_2btnZEuMBg69G7-4JtZVaq","Input":"_4J6VRjS1zgPuRs1UH_0hW","Calendar":"_1PtcASxhA8uAff32FgHQSe","Label":"_3t9YKw-kv-RX_RXIaBT8nb","Table":"_3uDOqAzhVKRgD_6WJC2QKw","TableHeader":"RzeppxVIuF_RiwOk_yQJC","TableRow":"_2zDICVEtaJ0qg05XILYOrO","AddRowButton":"_1Xt3e2MpUeeSSiHc4NqOAP","Header":"_1b9UwJnKZkkKHKaySLioBO","Row":"_2jpwfeqLBdAYtoZF0F22J_","RemoveButton":"SOWTVj1IEiYODxstMMbUh","container-fluid":"_2h6AzfGMBJADWtzcq4fG1X"};

/***/ },
/* 634 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_3HNJgVE_4smImVQl_N3vG-","Column":"_33zWpGVJbZG-wb_WS0qU63","Enabled":"_3toKe3WR8ndHDpQ_Ar77IG","Disabled":"_1PS9GP5zoqnJEwdt1lpapa","Process":"_296V7lyn3LHt-TIiCWvSQx","Error":"_1S39cSSpm7aZbR0d5TcGFx","Title":"_3gC6FD1TSzLgzjyPgRlI6p","Text":"_2NtG09RdW8fqf2XkCMyUOn","InputWrap":"vaFDhaPBhLeX06APnCoas","DoubleCell":"_3J162FKZ7Dce9khHVNC-fg","Input":"exF-uFZm51FgdcjI7a47x","Calendar":"_21e-DkVPiu-p65Uc9a5UDr","Label":"_1-1siFKM471jSReL1_YyUz","container-fluid":"_3VV5prw01KUWu2gIoHKEiB","TableHeader":"_23bso9u883X_TGyZuk141r","TableRow":"_2tRacv7CGX5ZdqOdJJDlUg","RemoveButton":"_1mjscnmiBiwCc0QETE4Q3Y"};

/***/ },
/* 635 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2X7zQGmkcQNrmDAjYXKNwQ","Footer":"sJ-JjFaoXtqujKzFB_tsS","MenuItem":"_3262o_IuKc9YJ9mwjb87CF","Header":"_2LVy4TqR5c8Hz6y6QgGqxD","Title":"_2G5Ggg8BDsjpUy8-fXISy2","TableWrap":"KbvdVX37UxqVhY_2p5fAH","PaginationWrap":"pSh6QChgrvD1E5Z4Y4XJ0","ActiveLink":"_3ydrSOXB0o8t_uqwOsW6cm","MainColumn":"_3hVgSbgzBQkONfumOAhzRv","SideColumn":"_1nBgC5uiATIQ-ASW4-Nfqx","StackOnMobile":"_3dyXmc8-EEj2IhCWITYwtz","container-fluid":"_14tHgMulJyTzEB_N5r1Je5"};

/***/ },
/* 636 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2N7jfdbiFoZAkrUP_FpPUc","PaginationWrap":"_21UQfKXo0C2KNQ1VvZ_sG8","ActiveLink":"_2Teik0jCGk9UEQ3r9m5Mt-","FiltersToggle":"BHlX47RAhyi9QKlMhzQvc","MainColumn":"_2Dm-5Exgy4IwfyqO8PTiJL","SidebarColumn":"_17lS4bjYCWPSqSo3k6jKHI"};

/***/ },
/* 637 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_2bYljz3tBoWnTweOf6AmaH","MainColumn":"hW2u8PkR3OG5mW98iedu0","SideColumn":"_2I86sotrT7jX5aVeBTrWm5","StackOnMobile":"_3Gkv8OcIDYjTmbmKZ0y7IE","container-fluid":"_1uCRrvcWk-N5oeXOIJy9Lm"};

/***/ },
/* 638 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"ctikhJDFLDkyfgp9pmcep","PaginationWrap":"_2Iu8FTLA96NumjLnxtmPv0","ActiveLink":"_1YTrwQZLkgALGPotrevXj_","FiltersToggle":"MvQHKiSouQi4hJIhzbx2B","MainColumn":"_3H3TCkqeK0GyuZu4SMKo0D","SidebarColumn":"_20rRRTeKZ7_FlZJMZUAwJx"};

/***/ },
/* 639 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3RfdEvQF34csQsBrGY3hTn","PaginationWrap":"_2KOQJJ6NvYsW9MCV2X2D21","ActiveLink":"_2u1lxTetwcpCy0PAjVVlh1","RetryCard":"_13IPU43CQESlYMmxhOW0Ut","RetryBtn":"_3h4vNjArLMFknr13kE-reC","RetryIcon":"_2yGK4HL4ZTVmsX6I2BrIlD","RetryCount":"_2qpMaBOb-h3jDCcQUZYOH4","WarningContent":"LzrEfl1cp4FsdNfFAgY5y","WarningIcon":"_3wbdXYrRcBY4AKr0Gcrr7F","WarningText":"_1zcneamhFlH95n3kfuhwjp","PendingList":"UeiC82__m-mKZm6sVMS_A","PendingTableWrap":"_4pbD-af5Gt6cdgj5tkNNj","PendingListTitle":"_1BuslnbSV5T1PpeiGriF2-","PendingTable":"_3RwzNwAnkS6jSMHoxmPd4K","MoreItems":"_1oA_xYBjTjgbyAJPQxvKEo","container-fluid":"_1AG-bJC7mvKRNBmhCQzmXo"};

/***/ },
/* 640 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Content":"_2cvxVRZjeUBHIUOdqNTLgQ","Column":"_1AmvGpUxLt98Ux7yJq2Tmj","Title":"_2K2I11HzV-Qb2r4xfgWSqk","Text":"_2FrNvyJkp9tfUcTQdo1T2Y","InputWrap":"fV5e2mGKNxkKzNBXmG3HE","DoubleCell":"_2EWzayKFd2F7vcnSY-_WKD","Input":"_14sVmQlFORIUYCv2mmXkQq","Calendar":"XhVGN9iCd-gHKXyyxsqOj","Label":"_2QuIVjtqo83raidFpCb543","container-fluid":"_2_wpsQrT8EIeJnv7fnIclM"};

/***/ },
/* 641 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_1HLMkjVLjYZtbPtzPFyGIE","Footer":"_2M-kwVTwjcDqOedJCyOORQ","IconLeft":"_2_UEEU7LiSTCRZOfPiE4GR","Btn":"_2y73OWmzuMyRCKZw7PdRQV","TabTable":"_1ScqP4XQgtS0baEeElslhI","TabBar":"aPOsyeWsNBSdYc0_JRCGA","container-fluid":"_22yC00_UWQtIg_dSfpCG45"};

/***/ },
/* 642 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"containerFluid":"_16dw0ACMYO1lyxN7V8Kk61","ProjectHeader":"_1wcdbeddCDgY2PkX4bLtrT","ProjectName":"_1wDOhyK7r3pPegiatXomJ","StatusActive":"_3cxlYsALCfJEPw0zHkDO-W","StatusBlocked":"vdvF5RZYV7cvaM2QZ2L0A","HeaderSep":"_2a3aXQsM-WWHfz96r6ARGl","HeaderUrl":"_2aoD-34WYRr2XpaOnSc-UX","BalanceRow":"_2qvfxiC9BF1fgvZB-RCctI","BalanceCard":"_3wxaU29bhYzTEfmusdTh-g","BalanceLabel":"S_gAB5CBVrEBJHn1h9lq0","BalanceValue":"_3I9acIPQFOyQ4_euqDtWim","TransactionLabel":"_122ZUf6KU-JGzm6tOxION7","TransactionValue":"_3Xq1ppULUTM3lMXk1DDCIe","SettlementLabel":"_1Wncz6UGXvwNK-NYO-5K_6","SettlementValue":"_2t2KMHlW57jfN0LMMU59jt","ActualLabel":"xhryTaBQFmMOUSFrCvDV4","ActualValue":"_3oFv2yPHxbVUjlNcXBpUZg","Card":"CTAX0eRajlhXgzIpDOJhB","CardHeader":"_3ESeYsFt4JJF6T6sKhZBzl","CardTitle":"_3xit3RdFIaE77cERcfUm74","CardBody":"_24QuycWzaGmSeS68WeWfIu","InfoGrid":"_10vAJmohtrCRZGWgVdBg91","InfoItem":"_2mepsL6D5tSH1g_QAhzOOw","InfoItemLabel":"_1lK-yTsf0wr-zxVDz_2h9a","InfoItemValue":"_1lWaZofB_u3Bz5cfAUZNQx","TableWrap":"_2XLnP5Yk-cWPrpxAixw8i9","Table":"_2x5UubEXERmq8VRddPMey8","TableRow":"_36rLeE38fONbA8lmunOS9l","Enabled":"_1DL2ZVa54dsFtdqkZ_N7j4","Disabled":"_2SQWlFiSvux7DsJj-PEIzB","FeeTable":"_2fo-nVPK12kOG_17nyFfev","ChevronIcon":"_2As9r0CzQtZuso1wmfflL2","Empty":"_3gXsLtmrVYeRofdIRTkBCf","TerminalBalanceDetail":"G3hOWINcvvehqy7__OSi-","TerminalBalanceItem":"_37mg6JEBXhyXKq-YyfuYNT","TerminalBalanceItemLabel":"_39b313c4aEfufSh9O30HL3","TerminalBalanceItemValue":"_193DX2uk1S7zM5341Wj52p","SharedBalanceNote":"_2SmiHzEGCAqJ22lERdXLj3"};

/***/ },
/* 643 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Test":"_29LWrSys8ghrk3QcadNnut","Card":"_3kGDNHkOOjEuh5Rw34pPMb","Header":"_3pCZEUDpMNi1RDhew3iF3k","Title":"_36TuZtOOOHsx6XzHtZpiGz","Content":"_5PLiCO-7f9ri6hMzz7PyH","SelectorBlock":"_3bCDcCCxnW8OfDwRNS-K83","TableWrap":"_3cnXhCMvfLf_zS3S5lVkVt"};

/***/ },
/* 644 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3lJ8guhfTZry-g9Bh4EFf9","WarningContent":"_2qltWrLB2ws6YFRrGXYu31","WarningText":"_1FNR_v6we-slLYGk5x8Kgs","WarningConfirm":"_106IQAwDMFIcg9Ti4YOJsj","DuplicateList":"_2teckADUoUpoOiLI7-ZQUt","MatchReason":"_3lSct7DkfG8DQi6C2F6y_a","container-fluid":"_2ABr-hG4ba5kI6EFw-vOru","MainColumn":"_3bmk9qqHGWqnzsJgwUg6_p","SideColumn":"_3yZmbgkm48-zhAPK86OpSZ","StackOnMobile":"_1pI93UChVeIHJEWSrOcYgD"};

/***/ },
/* 645 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"StatementWrapper":"_3crAmXU-I_uL3dxp-6UWAF","containerFluid":"_2LQ8RkxAY4Jzp6IK5XoKFo","Card":"_2fygyX7f5Je1LWgoK5V5R6","Header":"_1g0IIQtKWYf8VjNPRYY6QF","Content":"_2vGEb5EQRqqxscVNn0CzhL","SelectorBlock":"_31QdOZs1HY6lF3Atbs2OhB","BtnOutline":"_3HZamYbWYWzMH_e53JGHsq","FiltersCard":"_851c9dunVxNCdKHvbpMOW","FiltersRow":"_1aMVmsPqsSga6W53pccPRm","DateGroup":"_78nxrE3nBRoXNgts1CXII","FilterGroup":"_3VPU9izaYuFw6IIg--Mq2P","TypeSelect":"MgC9rnUklUCDAQl4-wGKk","ExportBtn":"_2PVh3WTCuNnAhCt1DkYWDX","SummaryRow":"_3h8AhqsXaadO-1B_GcBzDE","summaryCard":"_2hE9JE9IuN-3sFimfbUG1z","SummaryCard":"_3QlEOoyOmP3wZcSYGKrAEY","TableScroll":"IKaDwzmBNT6e9oG76ibNJ","Table":"_3WOPeLKg_lqHyrA4NyEcjx","AccordionRow":"_2VM4Vu4DNLx8IXaPhpxbqM","Arrow":"RDC80maQYrE4hMaTOhnrc","ArrowOpen":"_3ioY1DZRG0yyILkjhe_wuW","DetailRow":"C9Cqb3zH3vxYoAzL438XL","DetailContent":"_2bsWQhZSgubcOh5MmQUJo2","PaginationWrap":"Ha9cD1Klr28AJoNg6Q3X3","ActiveLink":"_UZXQcvWYGR0mezUhP5Lz"};

/***/ },
/* 646 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"y2LVZm0J0ewPOYHQqg2z8","Title":"_3Aoe5zDmnlMcjIGLNGDwHT","DropZone":"_2NORvp5gMkT5jE68Qg8JIa","DropZoneActive":"_3hI0sKUUVKT_zTgQ9nM6Qo","DropIcon":"_1MApk_3a1lATEnHOVA4ABh","DropText":"ntN-R90zfyEn5nIfJSRnf","DropHint":"_3FBKSdOsYYYLxOJ5No7_S2","CheckingBox":"_3W2CiI_OJXrtYEVRSI7wwH","CheckingText":"_1LyHNkoIqYsJlFoC6A3nn4","ResultsSection":"_20ETuG9uLkwnJPLMRLJA_1","TableWrapper":"_1FwBvizsN2Om6SFaWVZU3O","Table":"_2OVyhGzCo7r4K4yHfM1p9P","RowBlocked":"_3TYwlC5Wj6vvwKRteULqDj","StatusBadgeOk":"_1dX2U2KhejhJeQre0DHIrp","StatusBadgeBlocked":"_1LgvBs2DRcvIxEUomN3W5s","ReasonCell":"_1wzgqPe2B42EQZfZ1HtD-T","DataCell":"j12jo7nNUe0SD1wRK54wC","ProviderOk":"_136tvJ9YwpOI3ZSYRE2Q45","ProviderBlocked":"_22-8GpOtlXea76J_rH9G6V","ProviderSkipped":"_19K5TQhL4dhFONvK2mTnKw","Actions":"_2Onqdf2EhY5ZbWGXxx6uEd","BtnPrimary":"_1u9ImhOqu3t-ETyKOxGJgn","SideCard":"pKfa1OO7bNYsYtZMsZRkk","SideTitle":"_3693r1sbb0jCGDXGMyAiDL","Select":"_3YFKbm3j5xHTIs82At9xN5","SummaryGrid":"_28_g8KgW3ZnFCBdKSnqWnu","SummaryItem":"tsWqZDQTAlz4cZ9tu7QwW","SummaryLabel":"_17X9RrfmCntMJoOzwhDWfq","SummaryValue":"zSsyClUgi_ktMIvFYl-2I","SummaryValueOk":"tWqq5EfdwyA0euPBtXnVx","SummaryValueBlocked":"_2XcTy0U1nJ6IC99V8u-hwm","BtnDownload":"_2P2kWNlD8H8_sSNS7e3qfc","LoaderBox":"_3nUyyIo6F7kuSllJmqkvKS","HelpText":"_3uKv_2W4HLRYWwpfrj5-jH","MainColumn":"_3p4CTQ7zSoxcdgJNImf-Y8","SideColumn":"_2_GsZRp8BWxflQVwrcFHjV","StackOnMobile":"_1aUuWQKaVSiUoLLRKsbUMv","container-fluid":"_18aSBW_1sfpU69tvCwdK3t"};

/***/ },
/* 647 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"SzdAOtpuLteZJCxptMo1K","Title":"_3ij2cvtPWIRG47vj60ACOU","FormGrid":"iESaIC9GKBOeriUZGdlOs","Field":"_2V-jZWddmltogndzAdi1pW","Label":"hqEY0Fyw8HDnNHgsLlIcg","Input":"_2bSwgL5C4LMqNPa1BKupcC","Actions":"_395WWmLGoxrB5OXZl4XONe","BtnPrimary":"J10ECONv6z-V2TQ_IkYR_","BtnSecondary":"_39GtE8zGhJw6HETzUQuekv","ResultOk":"_30LSyvKrq7FLDgh0gJUvmO","ResultBlocked":"_3y3VT_6x0aEOmx25V_rfJ-","ResultHeader":"_3mvjzEptMeE5StZj-aHfaP","BadgeSuccess":"E0CzNKE6HPMOIGDWs_nul","BadgeDanger":"_1rnUzbpa7l1pGLJ8wvk_c_","TimeBadge":"r1m7dibQCVtlWnCccdDrH","BlockDetails":"eTIkB5DfuPU76P8na7XzS","DetailRow":"_2k2CmX9sQoZcvqwng8hhdN","DetailLabel":"JhjG64yKaFdHkrIuFCjZB","DetailValue":"_2Uj-QL5WLBrn9YZ8_GEsiv","ProvidersTable":"_1h_nbX6rtdwZ24mWfqd1bp","StatusOk":"_2gKc-_wRfSCaxWezBwGFH0","StatusBlocked":"_3VVgdC0yffxhru0iSy5MbA","StatusSkipped":"_2vRJzMZlTHoZLuiruw-lq0","SideCard":"_3aYSUqi832ZBy3Ktk_sMO4","SideTitle":"_24W31wkU7tZLAv6l3jvqUt","Select":"_1jkyVPFAvq0b3TBJ1IeUhW","HelpText":"_3qq5XLqHoo_jeWMeKHUs8k","LoaderBox":"l1md5bYMPdfgoHByqCMSI","MainColumn":"C1i3_-zYNYOcevWzut_6I","SideColumn":"P9_jfXIjtvi5P0a4GRkKI","StackOnMobile":"KUWrXHqlRvjBPELrwzslr","container-fluid":"LIX3PdZjoU-OOYMwwlDXM"};

/***/ },
/* 648 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Card":"_3u-IXkSOdBXKobjEAaEzpI","Title":"_1C9dKNq2HSxMIBmwc3huGj","Body":"_1CLrTZZb0pfIK-iqi9TMFJ"};

/***/ },
/* 649 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/xls.ea1219ec.svg";

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/card.0de72c6c.svg";

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/jcb.2a82975f.svg";

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/maestro.256b1137.svg";

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mastercard.a5aec975.svg";

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mir.e20f6688.svg";

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/visa.0cc81004.svg";

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/1C.564c4b8f.svg";

/***/ },
/* 658 */
650,
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(660);
	var React = __webpack_require__(1);
	var heyListen = __webpack_require__(211);
	var styleValueTypes = __webpack_require__(224);
	var popmotion = __webpack_require__(669);
	var sync = __webpack_require__(210);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	function _interopNamespace(e) {
	    if (e && e.__esModule) return e;
	    var n = Object.create(null);
	    if (e) {
	        Object.keys(e).forEach(function (k) {
	            if (k !== 'default') {
	                var d = Object.getOwnPropertyDescriptor(e, k);
	                Object.defineProperty(n, k, d.get ? d : {
	                    enumerable: true,
	                    get: function () {
	                        return e[k];
	                    }
	                });
	            }
	        });
	    }
	    n['default'] = e;
	    return Object.freeze(n);
	}
	
	var React__namespace = /*#__PURE__*/_interopNamespace(React);
	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var sync__default = /*#__PURE__*/_interopDefaultLegacy(sync);
	
	var createDefinition = function (propNames) { return ({
	    isEnabled: function (props) { return propNames.some(function (name) { return !!props[name]; }); },
	}); };
	var featureDefinitions = {
	    measureLayout: createDefinition([
	        "layout",
	        "layoutId",
	        "drag",
	        "_layoutResetTransform",
	    ]),
	    animation: createDefinition([
	        "animate",
	        "exit",
	        "variants",
	        "whileHover",
	        "whileTap",
	        "whileFocus",
	        "whileDrag",
	    ]),
	    exit: createDefinition(["exit"]),
	    drag: createDefinition(["drag", "dragControls"]),
	    focus: createDefinition(["whileFocus"]),
	    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
	    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
	    pan: createDefinition([
	        "onPan",
	        "onPanStart",
	        "onPanSessionStart",
	        "onPanEnd",
	    ]),
	    layoutAnimation: createDefinition(["layout", "layoutId"]),
	};
	function loadFeatures(features) {
	    for (var key in features) {
	        var Component = features[key];
	        if (Component !== null)
	            featureDefinitions[key].Component = Component;
	    }
	}
	
	var LazyContext = React.createContext({ strict: false });
	
	var featureNames = Object.keys(featureDefinitions);
	var numFeatures = featureNames.length;
	/**
	 * Load features via renderless components based on the provided MotionProps.
	 */
	function useFeatures(props, visualElement, preloadedFeatures) {
	    var features = [];
	    var lazyContext = React.useContext(LazyContext);
	    if (!visualElement)
	        return null;
	    /**
	     * If we're in development mode, check to make sure we're not rendering a motion component
	     * as a child of LazyMotion, as this will break the file-size benefits of using it.
	     */
	    if (false) {
	        heyListen.invariant(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
	    }
	    for (var i = 0; i < numFeatures; i++) {
	        var name_1 = featureNames[i];
	        var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
	        /**
	         * It might be possible in the future to use this moment to
	         * dynamically request functionality. In initial tests this
	         * was producing a lot of duplication amongst bundles.
	         */
	        if (isEnabled(props) && Component) {
	            features.push(React__namespace.createElement(Component, tslib.__assign({ key: name_1 }, props, { visualElement: visualElement })));
	        }
	    }
	    return features;
	}
	
	/**
	 * @public
	 */
	var MotionConfigContext = React.createContext({
	    transformPagePoint: function (p) { return p; },
	    isStatic: false,
	});
	
	var MotionContext = React.createContext({});
	function useVisualElementContext() {
	    return React.useContext(MotionContext).visualElement;
	}
	
	/**
	 * @public
	 */
	var PresenceContext = React.createContext(null);
	
	/**
	 * Creates a constant value over the lifecycle of a component.
	 *
	 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
	 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
	 * you can ensure that initialisers don't execute twice or more.
	 */
	function useConstant(init) {
	    var ref = React.useRef(null);
	    if (ref.current === null) {
	        ref.current = init();
	    }
	    return ref.current;
	}
	
	/**
	 * When a component is the child of `AnimatePresence`, it can use `usePresence`
	 * to access information about whether it's still present in the React tree.
	 *
	 * ```jsx
	 * import { usePresence } from "framer-motion"
	 *
	 * export const Component = () => {
	 *   const [isPresent, safeToRemove] = usePresence()
	 *
	 *   useEffect(() => {
	 *     !isPresent && setTimeout(safeToRemove, 1000)
	 *   }, [isPresent])
	 *
	 *   return <div />
	 * }
	 * ```
	 *
	 * If `isPresent` is `false`, it means that a component has been removed the tree, but
	 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
	 *
	 * @public
	 */
	function usePresence() {
	    var context = React.useContext(PresenceContext);
	    if (context === null)
	        return [true, null];
	    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
	    // It's safe to call the following hooks conditionally (after an early return) because the context will always
	    // either be null or non-null for the lifespan of the component.
	    // Replace with useOpaqueId when released in React
	    var id = useUniqueId();
	    React.useEffect(function () { return register(id); }, []);
	    var safeToRemove = function () { return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id); };
	    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
	}
	/**
	 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
	 * There is no `safeToRemove` function.
	 *
	 * ```jsx
	 * import { useIsPresent } from "framer-motion"
	 *
	 * export const Component = () => {
	 *   const isPresent = useIsPresent()
	 *
	 *   useEffect(() => {
	 *     !isPresent && console.log("I've been removed!")
	 *   }, [isPresent])
	 *
	 *   return <div />
	 * }
	 * ```
	 *
	 * @public
	 */
	function useIsPresent() {
	    return isPresent(React.useContext(PresenceContext));
	}
	function isPresent(context) {
	    return context === null ? true : context.isPresent;
	}
	var counter = 0;
	var incrementId = function () { return counter++; };
	var useUniqueId = function () { return useConstant(incrementId); };
	
	/**
	 * @internal
	 */
	var LayoutGroupContext = React.createContext(null);
	
	var isBrowser = typeof window !== "undefined";
	
	var useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;
	
	function useLayoutId(_a) {
	    var layoutId = _a.layoutId;
	    var layoutGroupId = React.useContext(LayoutGroupContext);
	    return layoutGroupId && layoutId !== undefined
	        ? layoutGroupId + "-" + layoutId
	        : layoutId;
	}
	function useVisualElement(Component, visualState, props, createVisualElement) {
	    var config = React.useContext(MotionConfigContext);
	    var lazyContext = React.useContext(LazyContext);
	    var parent = useVisualElementContext();
	    var presenceContext = React.useContext(PresenceContext);
	    var layoutId = useLayoutId(props);
	    var visualElementRef = React.useRef(undefined);
	    /**
	     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
	     */
	    if (!createVisualElement)
	        createVisualElement = lazyContext.renderer;
	    if (!visualElementRef.current && createVisualElement) {
	        visualElementRef.current = createVisualElement(Component, {
	            visualState: visualState,
	            parent: parent,
	            props: tslib.__assign(tslib.__assign({}, props), { layoutId: layoutId }),
	            presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
	            blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
	        });
	    }
	    var visualElement = visualElementRef.current;
	    useIsomorphicLayoutEffect(function () {
	        if (!visualElement)
	            return;
	        visualElement.setProps(tslib.__assign(tslib.__assign(tslib.__assign({}, config), props), { layoutId: layoutId }));
	        visualElement.isPresent = isPresent(presenceContext);
	        visualElement.isPresenceRoot =
	            !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
	        /**
	         * Fire a render to ensure the latest state is reflected on-screen.
	         */
	        visualElement.syncRender();
	    });
	    React.useEffect(function () {
	        var _a;
	        if (!visualElement)
	            return;
	        /**
	         * In a future refactor we can replace the features-as-components and
	         * have this loop through them all firing "effect" listeners
	         */
	        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
	    });
	    useIsomorphicLayoutEffect(function () { return function () { return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount(); }; }, []);
	    return visualElement;
	}
	
	function isRefObject(ref) {
	    return (typeof ref === "object" &&
	        Object.prototype.hasOwnProperty.call(ref, "current"));
	}
	
	/**
	 * Creates a ref function that, when called, hydrates the provided
	 * external ref and VisualElement.
	 */
	function useMotionRef(visualState, visualElement, externalRef) {
	    return React.useCallback(function (instance) {
	        var _a;
	        instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
	        if (visualElement) {
	            instance
	                ? visualElement.mount(instance)
	                : visualElement.unmount();
	        }
	        if (externalRef) {
	            if (typeof externalRef === "function") {
	                externalRef(instance);
	            }
	            else if (isRefObject(externalRef)) {
	                externalRef.current = instance;
	            }
	        }
	    }, 
	    /**
	     * Only pass a new ref callback to React if we've received a visual element
	     * factory. Otherwise we'll be mounting/remounting every time externalRef
	     * or other dependencies change.
	     */
	    [visualElement]);
	}
	
	/**
	 * Decides if the supplied variable is an array of variant labels
	 */
	function isVariantLabels(v) {
	    return Array.isArray(v);
	}
	/**
	 * Decides if the supplied variable is variant label
	 */
	function isVariantLabel(v) {
	    return typeof v === "string" || isVariantLabels(v);
	}
	/**
	 * Creates an object containing the latest state of every MotionValue on a VisualElement
	 */
	function getCurrent(visualElement) {
	    var current = {};
	    visualElement.forEachValue(function (value, key) { return (current[key] = value.get()); });
	    return current;
	}
	/**
	 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
	 */
	function getVelocity$1(visualElement) {
	    var velocity = {};
	    visualElement.forEachValue(function (value, key) { return (velocity[key] = value.getVelocity()); });
	    return velocity;
	}
	function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
	    var _a;
	    if (currentValues === void 0) { currentValues = {}; }
	    if (currentVelocity === void 0) { currentVelocity = {}; }
	    if (typeof definition === "string") {
	        definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
	    }
	    return typeof definition === "function"
	        ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity)
	        : definition;
	}
	function resolveVariant(visualElement, definition, custom) {
	    var props = visualElement.getProps();
	    return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
	}
	function checkIfControllingVariants(props) {
	    var _a;
	    return (typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" ||
	        isVariantLabel(props.initial) ||
	        isVariantLabel(props.animate) ||
	        isVariantLabel(props.whileHover) ||
	        isVariantLabel(props.whileDrag) ||
	        isVariantLabel(props.whileTap) ||
	        isVariantLabel(props.whileFocus) ||
	        isVariantLabel(props.exit));
	}
	function checkIfVariantNode(props) {
	    return Boolean(checkIfControllingVariants(props) || props.variants);
	}
	
	function getCurrentTreeVariants(props, context) {
	    if (checkIfControllingVariants(props)) {
	        var initial = props.initial, animate = props.animate;
	        return {
	            initial: initial === false || isVariantLabel(initial)
	                ? initial
	                : undefined,
	            animate: isVariantLabel(animate) ? animate : undefined,
	        };
	    }
	    return props.inherit !== false ? context : {};
	}
	
	function useCreateMotionContext(props, isStatic) {
	    var _a = getCurrentTreeVariants(props, React.useContext(MotionContext)), initial = _a.initial, animate = _a.animate;
	    return React.useMemo(function () { return ({ initial: initial, animate: animate }); }, 
	    /**
	     * Only break memoisation in static mode
	     */
	    isStatic
	        ? [
	            variantLabelsAsDependency(initial),
	            variantLabelsAsDependency(animate),
	        ]
	        : []);
	}
	function variantLabelsAsDependency(prop) {
	    return Array.isArray(prop) ? prop.join(" ") : prop;
	}
	
	/**
	 * Create a `motion` component.
	 *
	 * This function accepts a Component argument, which can be either a string (ie "div"
	 * for `motion.div`), or an actual React component.
	 *
	 * Alongside this is a config option which provides a way of rendering the provided
	 * component "offline", or outside the React render cycle.
	 *
	 * @internal
	 */
	function createMotionComponent(_a) {
	    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
	    preloadedFeatures && loadFeatures(preloadedFeatures);
	    function MotionComponent(props, externalRef) {
	        /**
	         * If we're rendering in a static environment, we only visually update the component
	         * as a result of a React-rerender rather than interactions or animations. This
	         * means we don't need to load additional memory structures like VisualElement,
	         * or any gesture/animation features.
	         */
	        var isStatic = React.useContext(MotionConfigContext).isStatic;
	        var features = null;
	        /**
	         * Create the tree context. This is memoized and will only trigger renders
	         * when the current tree variant changes in static mode.
	         */
	        var context = useCreateMotionContext(props, isStatic);
	        /**
	         *
	         */
	        var visualState = useVisualState(props, isStatic);
	        if (!isStatic && isBrowser) {
	            /**
	             * Create a VisualElement for this component. A VisualElement provides a common
	             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
	             * providing a way of rendering to these APIs outside of the React render loop
	             * for more performant animations and interactions
	             */
	            context.visualElement = useVisualElement(Component, visualState, props, createVisualElement);
	            /**
	             * Load Motion gesture and animation features. These are rendered as renderless
	             * components so each feature can optionally make use of React lifecycle methods.
	             *
	             * TODO: The intention is to move these away from a React-centric to a
	             * VisualElement-centric lifecycle scheme.
	             */
	            features = useFeatures(props, context.visualElement, preloadedFeatures);
	        }
	        /**
	         * The mount order and hierarchy is specific to ensure our element ref
	         * is hydrated by the time features fire their effects.
	         */
	        return (React__namespace.createElement(React__namespace.Fragment, null,
	            React__namespace.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic)),
	            features));
	    }
	    return React.forwardRef(MotionComponent);
	}
	
	/**
	 * Convert any React component into a `motion` component. The provided component
	 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
	 *
	 * ```jsx
	 * const Component = React.forwardRef((props, ref) => {
	 *   return <div ref={ref} />
	 * })
	 *
	 * const MotionComponent = motion(Component)
	 * ```
	 *
	 * @public
	 */
	function createMotionProxy(createConfig) {
	    function custom(Component, customMotionComponentConfig) {
	        if (customMotionComponentConfig === void 0) { customMotionComponentConfig = {}; }
	        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
	    }
	    /**
	     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
	     * Rather than generating them anew every render.
	     */
	    var componentCache = new Map();
	    return new Proxy(custom, {
	        /**
	         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
	         * The prop name is passed through as `key` and we can use that to generate a `motion`
	         * DOM component with that name.
	         */
	        get: function (_target, key) {
	            /**
	             * If this element doesn't exist in the component cache, create it and cache.
	             */
	            if (!componentCache.has(key)) {
	                componentCache.set(key, custom(key));
	            }
	            return componentCache.get(key);
	        },
	    });
	}
	
	/**
	 * We keep these listed seperately as we use the lowercase tag names as part
	 * of the runtime bundle to detect SVG components
	 */
	var lowercaseSVGElements = [
	    "animate",
	    "circle",
	    "defs",
	    "desc",
	    "ellipse",
	    "g",
	    "image",
	    "line",
	    "filter",
	    "marker",
	    "mask",
	    "metadata",
	    "path",
	    "pattern",
	    "polygon",
	    "polyline",
	    "rect",
	    "stop",
	    "svg",
	    "switch",
	    "symbol",
	    "text",
	    "tspan",
	    "use",
	    "view",
	];
	
	function isSVGComponent(Component) {
	    if (
	    /**
	     * If it's not a string, it's a custom React component. Currently we only support
	     * HTML custom React components.
	     */
	    typeof Component !== "string" ||
	        /**
	         * If it contains a dash, the element is a custom HTML webcomponent.
	         */
	        Component.includes("-")) {
	        return false;
	    }
	    else if (
	    /**
	     * If it's in our list of lowercase SVG tags, it's an SVG component
	     */
	    lowercaseSVGElements.indexOf(Component) > -1 ||
	        /**
	         * If it contains a capital letter, it's an SVG component
	         */
	        /[A-Z]/.test(Component)) {
	        return true;
	    }
	    return false;
	}
	
	var valueScaleCorrection = {};
	/**
	 * @internal
	 */
	function addScaleCorrection(correctors) {
	    for (var key in correctors) {
	        valueScaleCorrection[key] = correctors[key];
	    }
	}
	
	/**
	 * A list of all transformable axes. We'll use this list to generated a version
	 * of each axes for each transform.
	 */
	var transformAxes = ["", "X", "Y", "Z"];
	/**
	 * An ordered array of each transformable value. By default, transform values
	 * will be sorted to this order.
	 */
	var order = ["translate", "scale", "rotate", "skew"];
	/**
	 * Generate a list of every possible transform key.
	 */
	var transformProps = ["transformPerspective", "x", "y", "z"];
	order.forEach(function (operationKey) {
	    return transformAxes.forEach(function (axesKey) {
	        return transformProps.push(operationKey + axesKey);
	    });
	});
	/**
	 * A function to use with Array.sort to sort transform keys by their default order.
	 */
	function sortTransformProps(a, b) {
	    return transformProps.indexOf(a) - transformProps.indexOf(b);
	}
	/**
	 * A quick lookup for transform props.
	 */
	var transformPropSet = new Set(transformProps);
	function isTransformProp(key) {
	    return transformPropSet.has(key);
	}
	/**
	 * A quick lookup for transform origin props
	 */
	var transformOriginProps = new Set(["originX", "originY", "originZ"]);
	function isTransformOriginProp(key) {
	    return transformOriginProps.has(key);
	}
	
	function isForcedMotionValue(key, _a) {
	    var layout = _a.layout, layoutId = _a.layoutId;
	    return (isTransformProp(key) ||
	        isTransformOriginProp(key) ||
	        ((layout || layoutId !== undefined) &&
	            (!!valueScaleCorrection[key] || key === "opacity")));
	}
	
	var isMotionValue = function (value) {
	    return value !== null && typeof value === "object" && value.getVelocity;
	};
	
	var translateAlias = {
	    x: "translateX",
	    y: "translateY",
	    z: "translateZ",
	    transformPerspective: "perspective",
	};
	/**
	 * Build a CSS transform style from individual x/y/scale etc properties.
	 *
	 * This outputs with a default order of transforms/scales/rotations, this can be customised by
	 * providing a transformTemplate function.
	 */
	function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
	    var transform = _a.transform, transformKeys = _a.transformKeys;
	    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
	    // The transform string we're going to build into.
	    var transformString = "";
	    // Transform keys into their default order - this will determine the output order.
	    transformKeys.sort(sortTransformProps);
	    // Track whether the defined transform has a defined z so we don't add a
	    // second to enable hardware acceleration
	    var transformHasZ = false;
	    // Loop over each transform and build them into transformString
	    var numTransformKeys = transformKeys.length;
	    for (var i = 0; i < numTransformKeys; i++) {
	        var key = transformKeys[i];
	        transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
	        if (key === "z")
	            transformHasZ = true;
	    }
	    if (!transformHasZ && enableHardwareAcceleration) {
	        transformString += "translateZ(0)";
	    }
	    else {
	        transformString = transformString.trim();
	    }
	    // If we have a custom `transform` template, pass our transform values and
	    // generated transformString to that before returning
	    if (transformTemplate) {
	        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
	    }
	    else if (allowTransformNone && transformIsDefault) {
	        transformString = "none";
	    }
	    return transformString;
	}
	/**
	 * Build a transformOrigin style. Uses the same defaults as the browser for
	 * undefined origins.
	 */
	function buildTransformOrigin(_a) {
	    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
	    return originX + " " + originY + " " + originZ;
	}
	
	/**
	 * Returns true if the provided key is a CSS variable
	 */
	function isCSSVariable$1(key) {
	    return key.startsWith("--");
	}
	
	/**
	 * Provided a value and a ValueType, returns the value as that value type.
	 */
	var getValueAsType = function (value, type) {
	    return type && typeof value === "number"
	        ? type.transform(value)
	        : value;
	};
	
	var int = tslib.__assign(tslib.__assign({}, styleValueTypes.number), { transform: Math.round });
	
	var numberValueTypes = {
	    // Border props
	    borderWidth: styleValueTypes.px,
	    borderTopWidth: styleValueTypes.px,
	    borderRightWidth: styleValueTypes.px,
	    borderBottomWidth: styleValueTypes.px,
	    borderLeftWidth: styleValueTypes.px,
	    borderRadius: styleValueTypes.px,
	    radius: styleValueTypes.px,
	    borderTopLeftRadius: styleValueTypes.px,
	    borderTopRightRadius: styleValueTypes.px,
	    borderBottomRightRadius: styleValueTypes.px,
	    borderBottomLeftRadius: styleValueTypes.px,
	    // Positioning props
	    width: styleValueTypes.px,
	    maxWidth: styleValueTypes.px,
	    height: styleValueTypes.px,
	    maxHeight: styleValueTypes.px,
	    size: styleValueTypes.px,
	    top: styleValueTypes.px,
	    right: styleValueTypes.px,
	    bottom: styleValueTypes.px,
	    left: styleValueTypes.px,
	    // Spacing props
	    padding: styleValueTypes.px,
	    paddingTop: styleValueTypes.px,
	    paddingRight: styleValueTypes.px,
	    paddingBottom: styleValueTypes.px,
	    paddingLeft: styleValueTypes.px,
	    margin: styleValueTypes.px,
	    marginTop: styleValueTypes.px,
	    marginRight: styleValueTypes.px,
	    marginBottom: styleValueTypes.px,
	    marginLeft: styleValueTypes.px,
	    // Transform props
	    rotate: styleValueTypes.degrees,
	    rotateX: styleValueTypes.degrees,
	    rotateY: styleValueTypes.degrees,
	    rotateZ: styleValueTypes.degrees,
	    scale: styleValueTypes.scale,
	    scaleX: styleValueTypes.scale,
	    scaleY: styleValueTypes.scale,
	    scaleZ: styleValueTypes.scale,
	    skew: styleValueTypes.degrees,
	    skewX: styleValueTypes.degrees,
	    skewY: styleValueTypes.degrees,
	    distance: styleValueTypes.px,
	    translateX: styleValueTypes.px,
	    translateY: styleValueTypes.px,
	    translateZ: styleValueTypes.px,
	    x: styleValueTypes.px,
	    y: styleValueTypes.px,
	    z: styleValueTypes.px,
	    perspective: styleValueTypes.px,
	    transformPerspective: styleValueTypes.px,
	    opacity: styleValueTypes.alpha,
	    originX: styleValueTypes.progressPercentage,
	    originY: styleValueTypes.progressPercentage,
	    originZ: styleValueTypes.px,
	    // Misc
	    zIndex: int,
	    // SVG
	    fillOpacity: styleValueTypes.alpha,
	    strokeOpacity: styleValueTypes.alpha,
	    numOctaves: int,
	};
	
	function buildHTMLStyles(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
	    var _a;
	    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
	    // Empty the transformKeys array. As we're throwing out refs to its items
	    // this might not be as cheap as suspected. Maybe using the array as a buffer
	    // with a manual incrementation would be better.
	    transformKeys.length = 0;
	    // Track whether we encounter any transform or transformOrigin values.
	    var hasTransform = false;
	    var hasTransformOrigin = false;
	    // Does the calculated transform essentially equal "none"?
	    var transformIsNone = true;
	    /**
	     * Loop over all our latest animated values and decide whether to handle them
	     * as a style or CSS variable.
	     *
	     * Transforms and transform origins are kept seperately for further processing.
	     */
	    for (var key in latestValues) {
	        var value = latestValues[key];
	        /**
	         * If this is a CSS variable we don't do any further processing.
	         */
	        if (isCSSVariable$1(key)) {
	            vars[key] = value;
	            continue;
	        }
	        // Convert the value to its default value type, ie 0 -> "0px"
	        var valueType = numberValueTypes[key];
	        var valueAsType = getValueAsType(value, valueType);
	        if (isTransformProp(key)) {
	            // If this is a transform, flag to enable further transform processing
	            hasTransform = true;
	            transform[key] = valueAsType;
	            transformKeys.push(key);
	            // If we already know we have a non-default transform, early return
	            if (!transformIsNone)
	                continue;
	            // Otherwise check to see if this is a default transform
	            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
	                transformIsNone = false;
	        }
	        else if (isTransformOriginProp(key)) {
	            transformOrigin[key] = valueAsType;
	            // If this is a transform origin, flag and enable further transform-origin processing
	            hasTransformOrigin = true;
	        }
	        else {
	            /**
	             * If layout projection is on, and we need to perform scale correction for this
	             * value type, perform it.
	             */
	            if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) &&
	                (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) &&
	                valueScaleCorrection[key]) {
	                var correctedValue = valueScaleCorrection[key].process(value, layoutState, projection);
	                /**
	                 * Scale-correctable values can define a number of other values to break
	                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
	                 */
	                var applyTo = valueScaleCorrection[key].applyTo;
	                if (applyTo) {
	                    var num = applyTo.length;
	                    for (var i = 0; i < num; i++) {
	                        style[applyTo[i]] = correctedValue;
	                    }
	                }
	                else {
	                    style[key] = correctedValue;
	                }
	            }
	            else {
	                style[key] = valueAsType;
	            }
	        }
	    }
	    if (layoutState &&
	        projection &&
	        buildProjectionTransform &&
	        buildProjectionTransformOrigin) {
	        style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
	        if (transformTemplate) {
	            style.transform = transformTemplate(transform, style.transform);
	        }
	        style.transformOrigin = buildProjectionTransformOrigin(layoutState);
	    }
	    else {
	        if (hasTransform) {
	            style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
	        }
	        if (hasTransformOrigin) {
	            style.transformOrigin = buildTransformOrigin(transformOrigin);
	        }
	    }
	}
	
	var createHtmlRenderState = function () { return ({
	    style: {},
	    transform: {},
	    transformKeys: [],
	    transformOrigin: {},
	    vars: {},
	}); };
	
	function copyRawValuesOnly(target, source, props) {
	    for (var key in source) {
	        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
	            target[key] = source[key];
	        }
	    }
	}
	function useInitialMotionValues(_a, visualState, isStatic) {
	    var transformTemplate = _a.transformTemplate;
	    return React.useMemo(function () {
	        var state = createHtmlRenderState();
	        buildHTMLStyles(state, visualState, undefined, undefined, { enableHardwareAcceleration: !isStatic }, transformTemplate);
	        var vars = state.vars, style = state.style;
	        return tslib.__assign(tslib.__assign({}, vars), style);
	    }, [visualState]);
	}
	function useStyle(props, visualState, isStatic) {
	    var styleProp = props.style || {};
	    var style = {};
	    /**
	     * Copy non-Motion Values straight into style
	     */
	    copyRawValuesOnly(style, styleProp, props);
	    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
	    if (props.transformValues) {
	        style = props.transformValues(style);
	    }
	    return style;
	}
	function useHTMLProps(props, visualState, isStatic) {
	    // The `any` isn't ideal but it is the type of createElement props argument
	    var htmlProps = {};
	    var style = useStyle(props, visualState, isStatic);
	    if (Boolean(props.drag)) {
	        // Disable the ghost element when a user drags
	        htmlProps.draggable = false;
	        // Disable text selection
	        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout =
	            "none";
	        // Disable scrolling on the draggable direction
	        style.touchAction =
	            props.drag === true
	                ? "none"
	                : "pan-" + (props.drag === "x" ? "y" : "x");
	    }
	    htmlProps.style = style;
	    return htmlProps;
	}
	
	/**
	 * A list of all valid MotionProps.
	 *
	 * @internalremarks
	 * This doesn't throw if a `MotionProp` name is missing - it should.
	 */
	var validMotionProps = new Set([
	    "initial",
	    "animate",
	    "exit",
	    "style",
	    "variants",
	    "transition",
	    "transformTemplate",
	    "transformValues",
	    "custom",
	    "inherit",
	    "layout",
	    "layoutId",
	    "_layoutResetTransform",
	    "onLayoutAnimationComplete",
	    "onViewportBoxUpdate",
	    "onLayoutMeasure",
	    "onBeforeLayoutMeasure",
	    "onAnimationStart",
	    "onAnimationComplete",
	    "onUpdate",
	    "onDragStart",
	    "onDrag",
	    "onDragEnd",
	    "onMeasureDragConstraints",
	    "onDirectionLock",
	    "onDragTransitionEnd",
	    "drag",
	    "dragControls",
	    "dragListener",
	    "dragConstraints",
	    "dragDirectionLock",
	    "_dragX",
	    "_dragY",
	    "dragElastic",
	    "dragMomentum",
	    "dragPropagation",
	    "dragTransition",
	    "whileDrag",
	    "onPan",
	    "onPanStart",
	    "onPanEnd",
	    "onPanSessionStart",
	    "onTap",
	    "onTapStart",
	    "onTapCancel",
	    "onHoverStart",
	    "onHoverEnd",
	    "whileFocus",
	    "whileTap",
	    "whileHover",
	]);
	/**
	 * Check whether a prop name is a valid `MotionProp` key.
	 *
	 * @param key - Name of the property to check
	 * @returns `true` is key is a valid `MotionProp`.
	 *
	 * @public
	 */
	function isValidMotionProp(key) {
	    return validMotionProps.has(key);
	}
	
	var shouldForward = function (key) { return !isValidMotionProp(key); };
	/**
	 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
	 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
	 * of these should be passed to the underlying DOM node.
	 *
	 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
	 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
	 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
	 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
	 *
	 * By making it an optionalDependency we can offer this functionality only in the situations where it's
	 * actually required.
	 */
	try {
	    var emotionIsPropValid_1 = __webpack_require__(228).default;
	    shouldForward = function (key) {
	        // Handle events explicitly as Emotion validates them all as true
	        if (key.startsWith("on")) {
	            return !isValidMotionProp(key);
	        }
	        else {
	            return emotionIsPropValid_1(key);
	        }
	    };
	}
	catch (_a) {
	    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
	}
	function filterProps(props, isDom, forwardMotionProps) {
	    var filteredProps = {};
	    for (var key in props) {
	        if (shouldForward(key) ||
	            (forwardMotionProps === true && isValidMotionProp(key)) ||
	            (!isDom && !isValidMotionProp(key))) {
	            filteredProps[key] = props[key];
	        }
	    }
	    return filteredProps;
	}
	
	function calcOrigin$1(origin, offset, size) {
	    return typeof origin === "string"
	        ? origin
	        : styleValueTypes.px.transform(offset + size * origin);
	}
	/**
	 * The SVG transform origin defaults are different to CSS and is less intuitive,
	 * so we use the measured dimensions of the SVG to reconcile these.
	 */
	function calcSVGTransformOrigin(dimensions, originX, originY) {
	    var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
	    var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
	    return pxOriginX + " " + pxOriginY;
	}
	
	// Convert a progress 0-1 to a pixels value based on the provided length
	var progressToPixels = function (progress, length) {
	    return styleValueTypes.px.transform(progress * length);
	};
	var dashKeys = {
	    offset: "stroke-dashoffset",
	    array: "stroke-dasharray",
	};
	var camelKeys = {
	    offset: "strokeDashoffset",
	    array: "strokeDasharray",
	};
	/**
	 * Build SVG path properties. Uses the path's measured length to convert
	 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
	 * and stroke-dasharray attributes.
	 *
	 * This function is mutative to reduce per-frame GC.
	 */
	function buildSVGPath(attrs, totalLength, length, spacing, offset, useDashCase) {
	    if (spacing === void 0) { spacing = 1; }
	    if (offset === void 0) { offset = 0; }
	    if (useDashCase === void 0) { useDashCase = true; }
	    // We use dash case when setting attributes directly to the DOM node and camel case
	    // when defining props on a React component.
	    var keys = useDashCase ? dashKeys : camelKeys;
	    // Build the dash offset
	    attrs[keys.offset] = progressToPixels(-offset, totalLength);
	    // Build the dash array
	    var pathLength = progressToPixels(length, totalLength);
	    var pathSpacing = progressToPixels(spacing, totalLength);
	    attrs[keys.array] = pathLength + " " + pathSpacing;
	}
	
	/**
	 * Build SVG visual attrbutes, like cx and style.transform
	 */
	function buildSVGAttrs(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
	    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, 
	    // This is object creation, which we try to avoid per-frame.
	    latest = tslib.__rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
	    buildHTMLStyles(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
	    state.attrs = state.style;
	    state.style = {};
	    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
	    /**
	     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
	     * and copy it into style.
	     */
	    if (attrs.transform) {
	        if (dimensions)
	            style.transform = attrs.transform;
	        delete attrs.transform;
	    }
	    // Parse transformOrigin
	    if (dimensions &&
	        (originX !== undefined || originY !== undefined || style.transform)) {
	        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
	    }
	    // Treat x/y not as shortcuts but as actual attributes
	    if (attrX !== undefined)
	        attrs.x = attrX;
	    if (attrY !== undefined)
	        attrs.y = attrY;
	    // Build SVG path if one has been measured
	    if (totalPathLength !== undefined && pathLength !== undefined) {
	        buildSVGPath(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
	    }
	}
	
	var createSvgRenderState = function () { return (tslib.__assign(tslib.__assign({}, createHtmlRenderState()), { attrs: {} })); };
	
	function useSVGProps(props, visualState) {
	    var visualProps = React.useMemo(function () {
	        var state = createSvgRenderState();
	        buildSVGAttrs(state, visualState, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
	        return tslib.__assign(tslib.__assign({}, state.attrs), { style: tslib.__assign({}, state.style) });
	    }, [visualState]);
	    if (props.style) {
	        var rawStyles = {};
	        copyRawValuesOnly(rawStyles, props.style, props);
	        visualProps.style = tslib.__assign(tslib.__assign({}, rawStyles), visualProps.style);
	    }
	    return visualProps;
	}
	
	function createUseRender(forwardMotionProps) {
	    if (forwardMotionProps === void 0) { forwardMotionProps = false; }
	    var useRender = function (Component, props, ref, _a, isStatic) {
	        var latestValues = _a.latestValues;
	        var useVisualProps = isSVGComponent(Component)
	            ? useSVGProps
	            : useHTMLProps;
	        var visualProps = useVisualProps(props, latestValues, isStatic);
	        var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
	        var elementProps = tslib.__assign(tslib.__assign(tslib.__assign({}, filteredProps), visualProps), { ref: ref });
	        return React.createElement(Component, elementProps);
	    };
	    return useRender;
	}
	
	var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
	var REPLACE_TEMPLATE = "$1-$2";
	/**
	 * Convert camelCase to dash-case properties.
	 */
	var camelToDash = function (str) {
	    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
	};
	
	function renderHTML(element, _a) {
	    var style = _a.style, vars = _a.vars;
	    // Directly assign style into the Element's style prop. In tests Object.assign is the
	    // fastest way to assign styles.
	    Object.assign(element.style, style);
	    // Loop over any CSS variables and assign those.
	    for (var key in vars) {
	        element.style.setProperty(key, vars[key]);
	    }
	}
	
	/**
	 * A set of attribute names that are always read/written as camel case.
	 */
	var camelCaseAttributes = new Set([
	    "baseFrequency",
	    "diffuseConstant",
	    "kernelMatrix",
	    "kernelUnitLength",
	    "keySplines",
	    "keyTimes",
	    "limitingConeAngle",
	    "markerHeight",
	    "markerWidth",
	    "numOctaves",
	    "targetX",
	    "targetY",
	    "surfaceScale",
	    "specularConstant",
	    "specularExponent",
	    "stdDeviation",
	    "tableValues",
	    "viewBox",
	    "gradientTransform",
	]);
	
	function renderSVG(element, renderState) {
	    renderHTML(element, renderState);
	    for (var key in renderState.attrs) {
	        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
	    }
	}
	
	function scrapeMotionValuesFromProps$1(props) {
	    var style = props.style;
	    var newValues = {};
	    for (var key in style) {
	        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
	            newValues[key] = style[key];
	        }
	    }
	    return newValues;
	}
	
	function scrapeMotionValuesFromProps(props) {
	    var newValues = scrapeMotionValuesFromProps$1(props);
	    for (var key in props) {
	        if (isMotionValue(props[key])) {
	            var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
	            newValues[targetKey] = props[key];
	        }
	    }
	    return newValues;
	}
	
	function isAnimationControls(v) {
	    return typeof v === "object" && typeof v.start === "function";
	}
	
	var isKeyframesTarget = function (v) {
	    return Array.isArray(v);
	};
	
	var isCustomValue = function (v) {
	    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
	};
	var resolveFinalValueInKeyframes = function (v) {
	    // TODO maybe throw if v.length - 1 is placeholder token?
	    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
	};
	
	/**
	 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
	 *
	 * TODO: Remove and move to library
	 *
	 * @internal
	 */
	function resolveMotionValue(value) {
	    var unwrappedValue = isMotionValue(value) ? value.get() : value;
	    return isCustomValue(unwrappedValue)
	        ? unwrappedValue.toValue()
	        : unwrappedValue;
	}
	
	function makeState(_a, props, context, presenceContext) {
	    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
	    var state = {
	        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
	        renderState: createRenderState(),
	    };
	    if (onMount) {
	        state.mount = function (instance) { return onMount(props, instance, state); };
	    }
	    return state;
	}
	var makeUseVisualState = function (config) { return function (props, isStatic) {
	    var context = React.useContext(MotionContext);
	    var presenceContext = React.useContext(PresenceContext);
	    return isStatic
	        ? makeState(config, props, context, presenceContext)
	        : useConstant(function () { return makeState(config, props, context, presenceContext); });
	}; };
	function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
	    var values = {};
	    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
	    var motionValues = scrapeMotionValues(props);
	    for (var key in motionValues) {
	        values[key] = resolveMotionValue(motionValues[key]);
	    }
	    var initial = props.initial, animate = props.animate;
	    var isControllingVariants = checkIfControllingVariants(props);
	    var isVariantNode = checkIfVariantNode(props);
	    if (context &&
	        isVariantNode &&
	        !isControllingVariants &&
	        props.inherit !== false) {
	        initial !== null && initial !== void 0 ? initial : (initial = context.initial);
	        animate !== null && animate !== void 0 ? animate : (animate = context.animate);
	    }
	    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
	    if (variantToSet &&
	        typeof variantToSet !== "boolean" &&
	        !isAnimationControls(variantToSet)) {
	        var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
	        list.forEach(function (definition) {
	            var resolved = resolveVariantFromProps(props, definition);
	            if (!resolved)
	                return;
	            var transitionEnd = resolved.transitionEnd; resolved.transition; var target = tslib.__rest(resolved, ["transitionEnd", "transition"]);
	            for (var key in target)
	                values[key] = target[key];
	            for (var key in transitionEnd)
	                values[key] = transitionEnd[key];
	        });
	    }
	    return values;
	}
	
	var svgMotionConfig = {
	    useVisualState: makeUseVisualState({
	        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
	        createRenderState: createSvgRenderState,
	        onMount: function (props, instance, _a) {
	            var renderState = _a.renderState, latestValues = _a.latestValues;
	            try {
	                renderState.dimensions =
	                    typeof instance.getBBox ===
	                        "function"
	                        ? instance.getBBox()
	                        : instance.getBoundingClientRect();
	            }
	            catch (e) {
	                // Most likely trying to measure an unrendered element under Firefox
	                renderState.dimensions = {
	                    x: 0,
	                    y: 0,
	                    width: 0,
	                    height: 0,
	                };
	            }
	            if (isPath(instance)) {
	                renderState.totalPathLength = instance.getTotalLength();
	            }
	            buildSVGAttrs(renderState, latestValues, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
	            // TODO: Replace with direct assignment
	            renderSVG(instance, renderState);
	        },
	    }),
	};
	function isPath(element) {
	    return element.tagName === "path";
	}
	
	var htmlMotionConfig = {
	    useVisualState: makeUseVisualState({
	        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
	        createRenderState: createHtmlRenderState,
	    }),
	};
	
	function createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement) {
	    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
	    var baseConfig = isSVGComponent(Component)
	        ? svgMotionConfig
	        : htmlMotionConfig;
	    return tslib.__assign(tslib.__assign({}, baseConfig), { preloadedFeatures: preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement: createVisualElement,
	        Component: Component });
	}
	
	var AnimationType;
	(function (AnimationType) {
	    AnimationType["Animate"] = "animate";
	    AnimationType["Hover"] = "whileHover";
	    AnimationType["Tap"] = "whileTap";
	    AnimationType["Drag"] = "whileDrag";
	    AnimationType["Focus"] = "whileFocus";
	    AnimationType["Exit"] = "exit";
	})(AnimationType || (AnimationType = {}));
	
	function addDomEvent(target, eventName, handler, options) {
	    target.addEventListener(eventName, handler, options);
	    return function () { return target.removeEventListener(eventName, handler, options); };
	}
	/**
	 * Attaches an event listener directly to the provided DOM element.
	 *
	 * Bypassing React's event system can be desirable, for instance when attaching non-passive
	 * event handlers.
	 *
	 * ```jsx
	 * const ref = useRef(null)
	 *
	 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
	 *
	 * return <div ref={ref} />
	 * ```
	 *
	 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
	 * @param eventName - Name of the event you want listen for.
	 * @param handler - Function to fire when receiving the event.
	 * @param options - Options to pass to `Event.addEventListener`.
	 *
	 * @public
	 */
	function useDomEvent(ref, eventName, handler, options) {
	    React.useEffect(function () {
	        var element = ref.current;
	        if (handler && element) {
	            return addDomEvent(element, eventName, handler, options);
	        }
	    }, [ref, eventName, handler, options]);
	}
	
	/**
	 *
	 * @param props
	 * @param ref
	 * @internal
	 */
	function useFocusGesture(_a) {
	    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
	    var onFocus = function () {
	        var _a;
	        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, true);
	    };
	    var onBlur = function () {
	        var _a;
	        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, false);
	    };
	    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
	    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
	}
	
	function isMouseEvent(event) {
	    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
	    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
	        return !!(event.pointerType === "mouse");
	    }
	    return event instanceof MouseEvent;
	}
	function isTouchEvent(event) {
	    var hasTouches = !!event.touches;
	    return hasTouches;
	}
	
	/**
	 * Filters out events not attached to the primary pointer (currently left mouse button)
	 * @param eventHandler
	 */
	function filterPrimaryPointer(eventHandler) {
	    return function (event) {
	        var isMouseEvent = event instanceof MouseEvent;
	        var isPrimaryPointer = !isMouseEvent ||
	            (isMouseEvent && event.button === 0);
	        if (isPrimaryPointer) {
	            eventHandler(event);
	        }
	    };
	}
	var defaultPagePoint = { pageX: 0, pageY: 0 };
	function pointFromTouch(e, pointType) {
	    if (pointType === void 0) { pointType = "page"; }
	    var primaryTouch = e.touches[0] || e.changedTouches[0];
	    var point = primaryTouch || defaultPagePoint;
	    return {
	        x: point[pointType + "X"],
	        y: point[pointType + "Y"],
	    };
	}
	function pointFromMouse(point, pointType) {
	    if (pointType === void 0) { pointType = "page"; }
	    return {
	        x: point[pointType + "X"],
	        y: point[pointType + "Y"],
	    };
	}
	function extractEventInfo(event, pointType) {
	    if (pointType === void 0) { pointType = "page"; }
	    return {
	        point: isTouchEvent(event)
	            ? pointFromTouch(event, pointType)
	            : pointFromMouse(event, pointType),
	    };
	}
	function getViewportPointFromEvent(event) {
	    return extractEventInfo(event, "client");
	}
	var wrapHandler = function (handler, shouldFilterPrimaryPointer) {
	    if (shouldFilterPrimaryPointer === void 0) { shouldFilterPrimaryPointer = false; }
	    var listener = function (event) {
	        return handler(event, extractEventInfo(event));
	    };
	    return shouldFilterPrimaryPointer
	        ? filterPrimaryPointer(listener)
	        : listener;
	};
	
	// We check for event support via functions in case they've been mocked by a testing suite.
	var supportsPointerEvents = function () {
	    return isBrowser && window.onpointerdown === null;
	};
	var supportsTouchEvents = function () {
	    return isBrowser && window.ontouchstart === null;
	};
	var supportsMouseEvents = function () {
	    return isBrowser && window.onmousedown === null;
	};
	
	var mouseEventNames = {
	    pointerdown: "mousedown",
	    pointermove: "mousemove",
	    pointerup: "mouseup",
	    pointercancel: "mousecancel",
	    pointerover: "mouseover",
	    pointerout: "mouseout",
	    pointerenter: "mouseenter",
	    pointerleave: "mouseleave",
	};
	var touchEventNames = {
	    pointerdown: "touchstart",
	    pointermove: "touchmove",
	    pointerup: "touchend",
	    pointercancel: "touchcancel",
	};
	function getPointerEventName(name) {
	    if (supportsPointerEvents()) {
	        return name;
	    }
	    else if (supportsTouchEvents()) {
	        return touchEventNames[name];
	    }
	    else if (supportsMouseEvents()) {
	        return mouseEventNames[name];
	    }
	    return name;
	}
	function addPointerEvent(target, eventName, handler, options) {
	    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
	}
	function usePointerEvent(ref, eventName, handler, options) {
	    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
	}
	
	function createLock(name) {
	    var lock = null;
	    return function () {
	        var openLock = function () {
	            lock = null;
	        };
	        if (lock === null) {
	            lock = name;
	            return openLock;
	        }
	        return false;
	    };
	}
	var globalHorizontalLock = createLock("dragHorizontal");
	var globalVerticalLock = createLock("dragVertical");
	function getGlobalLock(drag) {
	    var lock = false;
	    if (drag === "y") {
	        lock = globalVerticalLock();
	    }
	    else if (drag === "x") {
	        lock = globalHorizontalLock();
	    }
	    else {
	        var openHorizontal_1 = globalHorizontalLock();
	        var openVertical_1 = globalVerticalLock();
	        if (openHorizontal_1 && openVertical_1) {
	            lock = function () {
	                openHorizontal_1();
	                openVertical_1();
	            };
	        }
	        else {
	            // Release the locks because we don't use them
	            if (openHorizontal_1)
	                openHorizontal_1();
	            if (openVertical_1)
	                openVertical_1();
	        }
	    }
	    return lock;
	}
	function isDragActive() {
	    // Check the gesture lock - if we get it, it means no drag gesture is active
	    // and we can safely fire the tap gesture.
	    var openGestureLock = getGlobalLock(true);
	    if (!openGestureLock)
	        return true;
	    openGestureLock();
	    return false;
	}
	
	function createHoverEvent(visualElement, isActive, callback) {
	    return function (event, info) {
	        var _a;
	        if (!isMouseEvent(event) || isDragActive())
	            return;
	        callback === null || callback === void 0 ? void 0 : callback(event, info);
	        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
	    };
	}
	function useHoverGesture(_a) {
	    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
	    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
	        ? createHoverEvent(visualElement, true, onHoverStart)
	        : undefined);
	    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
	        ? createHoverEvent(visualElement, false, onHoverEnd)
	        : undefined);
	}
	
	/**
	 * Recursively traverse up the tree to check whether the provided child node
	 * is the parent or a descendant of it.
	 *
	 * @param parent - Element to find
	 * @param child - Element to test against parent
	 */
	var isNodeOrChild = function (parent, child) {
	    if (!child) {
	        return false;
	    }
	    else if (parent === child) {
	        return true;
	    }
	    else {
	        return isNodeOrChild(parent, child.parentElement);
	    }
	};
	
	function useUnmountEffect(callback) {
	    return React.useEffect(function () { return function () { return callback(); }; }, []);
	}
	
	/**
	 * @param handlers -
	 * @internal
	 */
	function useTapGesture(_a) {
	    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
	    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
	    var isPressing = React.useRef(false);
	    var cancelPointerEndListeners = React.useRef(null);
	    function removePointerEndListener() {
	        var _a;
	        (_a = cancelPointerEndListeners.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEndListeners);
	        cancelPointerEndListeners.current = null;
	    }
	    function checkPointerEnd() {
	        var _a;
	        removePointerEndListener();
	        isPressing.current = false;
	        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, false);
	        return !isDragActive();
	    }
	    function onPointerUp(event, info) {
	        if (!checkPointerEnd())
	            return;
	        /**
	         * We only count this as a tap gesture if the event.target is the same
	         * as, or a child of, this component's element
	         */
	        !isNodeOrChild(visualElement.getInstance(), event.target)
	            ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info)
	            : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
	    }
	    function onPointerCancel(event, info) {
	        if (!checkPointerEnd())
	            return;
	        onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
	    }
	    function onPointerDown(event, info) {
	        var _a;
	        removePointerEndListener();
	        if (isPressing.current)
	            return;
	        isPressing.current = true;
	        cancelPointerEndListeners.current = popmotion.pipe(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
	        onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
	        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, true);
	    }
	    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
	    useUnmountEffect(removePointerEndListener);
	}
	
	var makeRenderlessComponent = function (hook) { return function (props) {
	    hook(props);
	    return null;
	}; };
	
	var gestureAnimations = {
	    tap: makeRenderlessComponent(useTapGesture),
	    focus: makeRenderlessComponent(useFocusGesture),
	    hover: makeRenderlessComponent(useHoverGesture),
	};
	
	function shallowCompare(next, prev) {
	    if (!Array.isArray(prev))
	        return false;
	    var prevLength = prev.length;
	    if (prevLength !== next.length)
	        return false;
	    for (var i = 0; i < prevLength; i++) {
	        if (prev[i] !== next[i])
	            return false;
	    }
	    return true;
	}
	
	/**
	 * Converts seconds to milliseconds
	 *
	 * @param seconds - Time in seconds.
	 * @return milliseconds - Converted time in milliseconds.
	 */
	var secondsToMilliseconds = function (seconds) { return seconds * 1000; };
	
	var easingLookup = {
	    linear: popmotion.linear,
	    easeIn: popmotion.easeIn,
	    easeInOut: popmotion.easeInOut,
	    easeOut: popmotion.easeOut,
	    circIn: popmotion.circIn,
	    circInOut: popmotion.circInOut,
	    circOut: popmotion.circOut,
	    backIn: popmotion.backIn,
	    backInOut: popmotion.backInOut,
	    backOut: popmotion.backOut,
	    anticipate: popmotion.anticipate,
	    bounceIn: popmotion.bounceIn,
	    bounceInOut: popmotion.bounceInOut,
	    bounceOut: popmotion.bounceOut,
	};
	var easingDefinitionToFunction = function (definition) {
	    if (Array.isArray(definition)) {
	        // If cubic bezier definition, create bezier curve
	        heyListen.invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
	        var _a = tslib.__read(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
	        return popmotion.cubicBezier(x1, y1, x2, y2);
	    }
	    else if (typeof definition === "string") {
	        // Else lookup from table
	        heyListen.invariant(easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
	        return easingLookup[definition];
	    }
	    return definition;
	};
	var isEasingArray = function (ease) {
	    return Array.isArray(ease) && typeof ease[0] !== "number";
	};
	
	/**
	 * Check if a value is animatable. Examples:
	 *
	 * ✅: 100, "100px", "#fff"
	 * ❌: "block", "url(2.jpg)"
	 * @param value
	 *
	 * @internal
	 */
	var isAnimatable = function (key, value) {
	    // If the list of keys tat might be non-animatable grows, replace with Set
	    if (key === "zIndex")
	        return false;
	    // If it's a number or a keyframes array, we can animate it. We might at some point
	    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
	    // but for now lets leave it like this for performance reasons
	    if (typeof value === "number" || Array.isArray(value))
	        return true;
	    if (typeof value === "string" && // It's animatable if we have a string
	        styleValueTypes.complex.test(value) && // And it contains numbers and/or colors
	        !value.startsWith("url(") // Unless it starts with "url("
	    ) {
	        return true;
	    }
	    return false;
	};
	
	var underDampedSpring = function () { return ({
	    type: "spring",
	    stiffness: 500,
	    damping: 25,
	    restDelta: 0.5,
	    restSpeed: 10,
	}); };
	var criticallyDampedSpring = function (to) { return ({
	    type: "spring",
	    stiffness: 550,
	    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
	    restDelta: 0.01,
	    restSpeed: 10,
	}); };
	var linearTween = function () { return ({
	    type: "keyframes",
	    ease: "linear",
	    duration: 0.3,
	}); };
	var keyframes = function (values) { return ({
	    type: "keyframes",
	    duration: 0.8,
	    values: values,
	}); };
	var defaultTransitions = {
	    x: underDampedSpring,
	    y: underDampedSpring,
	    z: underDampedSpring,
	    rotate: underDampedSpring,
	    rotateX: underDampedSpring,
	    rotateY: underDampedSpring,
	    rotateZ: underDampedSpring,
	    scaleX: criticallyDampedSpring,
	    scaleY: criticallyDampedSpring,
	    scale: criticallyDampedSpring,
	    opacity: linearTween,
	    backgroundColor: linearTween,
	    color: linearTween,
	    default: criticallyDampedSpring,
	};
	var getDefaultTransition = function (valueKey, to) {
	    var transitionFactory;
	    if (isKeyframesTarget(to)) {
	        transitionFactory = keyframes;
	    }
	    else {
	        transitionFactory =
	            defaultTransitions[valueKey] || defaultTransitions.default;
	    }
	    return tslib.__assign({ to: to }, transitionFactory(to));
	};
	
	/**
	 * A map of default value types for common values
	 */
	var defaultValueTypes = tslib.__assign(tslib.__assign({}, numberValueTypes), { 
	    // Color props
	    color: styleValueTypes.color, backgroundColor: styleValueTypes.color, outlineColor: styleValueTypes.color, fill: styleValueTypes.color, stroke: styleValueTypes.color, 
	    // Border props
	    borderColor: styleValueTypes.color, borderTopColor: styleValueTypes.color, borderRightColor: styleValueTypes.color, borderBottomColor: styleValueTypes.color, borderLeftColor: styleValueTypes.color, filter: styleValueTypes.filter, WebkitFilter: styleValueTypes.filter });
	/**
	 * Gets the default ValueType for the provided value key
	 */
	var getDefaultValueType = function (key) { return defaultValueTypes[key]; };
	
	function getAnimatableNone(key, value) {
	    var _a;
	    var defaultValueType = getDefaultValueType(key);
	    if (defaultValueType !== styleValueTypes.filter)
	        defaultValueType = styleValueTypes.complex;
	    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
	    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
	}
	
	/**
	 * Decide whether a transition is defined on a given Transition.
	 * This filters out orchestration options and returns true
	 * if any options are left.
	 */
	function isTransitionDefined(_a) {
	    _a.when; _a.delay; _a.delayChildren; _a.staggerChildren; _a.staggerDirection; _a.repeat; _a.repeatType; _a.repeatDelay; _a.from; var transition = tslib.__rest(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
	    return !!Object.keys(transition).length;
	}
	var legacyRepeatWarning = false;
	/**
	 * Convert Framer Motion's Transition type into Popmotion-compatible options.
	 */
	function convertTransitionToAnimationOptions(_a) {
	    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = tslib.__rest(_a, ["ease", "times", "yoyo", "flip", "loop"]);
	    var options = tslib.__assign({}, transition);
	    if (times)
	        options["offset"] = times;
	    /**
	     * Convert any existing durations from seconds to milliseconds
	     */
	    if (transition.duration)
	        options["duration"] = secondsToMilliseconds(transition.duration);
	    if (transition.repeatDelay)
	        options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
	    /**
	     * Map easing names to Popmotion's easing functions
	     */
	    if (ease) {
	        options["ease"] = isEasingArray(ease)
	            ? ease.map(easingDefinitionToFunction)
	            : easingDefinitionToFunction(ease);
	    }
	    /**
	     * Support legacy transition API
	     */
	    if (transition.type === "tween")
	        options.type = "keyframes";
	    /**
	     * TODO: These options are officially removed from the API.
	     */
	    if (yoyo || loop || flip) {
	        heyListen.warning(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
	        legacyRepeatWarning = true;
	        if (yoyo) {
	            options.repeatType = "reverse";
	        }
	        else if (loop) {
	            options.repeatType = "loop";
	        }
	        else if (flip) {
	            options.repeatType = "mirror";
	        }
	        options.repeat = loop || yoyo || flip || transition.repeat;
	    }
	    /**
	     * TODO: Popmotion 9 has the ability to automatically detect whether to use
	     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
	     * It'd be good to introduce a similar thing here.
	     */
	    if (transition.type !== "spring")
	        options.type = "keyframes";
	    return options;
	}
	/**
	 * Get the delay for a value by checking Transition with decreasing specificity.
	 */
	function getDelayFromTransition(transition, key) {
	    var _a;
	    var valueTransition = getValueTransition(transition, key) || {};
	    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
	}
	function hydrateKeyframes(options) {
	    if (Array.isArray(options.to) && options.to[0] === null) {
	        options.to = tslib.__spreadArray([], tslib.__read(options.to));
	        options.to[0] = options.from;
	    }
	    return options;
	}
	function getPopmotionAnimationOptions(transition, options, key) {
	    var _a;
	    if (Array.isArray(options.to)) {
	        (_a = transition.duration) !== null && _a !== void 0 ? _a : (transition.duration = 0.8);
	    }
	    hydrateKeyframes(options);
	    /**
	     * Get a default transition if none is determined to be defined.
	     */
	    if (!isTransitionDefined(transition)) {
	        transition = tslib.__assign(tslib.__assign({}, transition), getDefaultTransition(key, options.to));
	    }
	    return tslib.__assign(tslib.__assign({}, options), convertTransitionToAnimationOptions(transition));
	}
	/**
	 *
	 */
	function getAnimation(key, value, target, transition, onComplete) {
	    var _a;
	    var valueTransition = getValueTransition(transition, key);
	    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
	    var isTargetAnimatable = isAnimatable(key, target);
	    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
	        /**
	         * If we're trying to animate from "none", try and get an animatable version
	         * of the target. This could be improved to work both ways.
	         */
	        origin = getAnimatableNone(key, target);
	    }
	    else if (isZero(origin) && typeof target === "string") {
	        origin = getZeroUnit(target);
	    }
	    else if (!Array.isArray(target) &&
	        isZero(target) &&
	        typeof origin === "string") {
	        target = getZeroUnit(origin);
	    }
	    var isOriginAnimatable = isAnimatable(key, origin);
	    heyListen.warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to \"" + target + "\". " + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
	    function start() {
	        var options = {
	            from: origin,
	            to: target,
	            velocity: value.getVelocity(),
	            onComplete: onComplete,
	            onUpdate: function (v) { return value.set(v); },
	        };
	        return valueTransition.type === "inertia" ||
	            valueTransition.type === "decay"
	            ? popmotion.inertia(tslib.__assign(tslib.__assign({}, options), valueTransition))
	            : popmotion.animate(tslib.__assign(tslib.__assign({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function (v) {
	                    var _a;
	                    options.onUpdate(v);
	                    (_a = valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, v);
	                }, onComplete: function () {
	                    var _a;
	                    options.onComplete();
	                    (_a = valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
	                } }));
	    }
	    function set() {
	        var _a;
	        value.set(target);
	        onComplete();
	        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
	        return { stop: function () { } };
	    }
	    return !isOriginAnimatable ||
	        !isTargetAnimatable ||
	        valueTransition.type === false
	        ? set
	        : start;
	}
	function isZero(value) {
	    return (value === 0 ||
	        (typeof value === "string" &&
	            parseFloat(value) === 0 &&
	            value.indexOf(" ") === -1));
	}
	function getZeroUnit(potentialUnitType) {
	    return typeof potentialUnitType === "number"
	        ? 0
	        : getAnimatableNone("", potentialUnitType);
	}
	function getValueTransition(transition, key) {
	    return transition[key] || transition["default"] || transition;
	}
	/**
	 * Start animation on a MotionValue. This function is an interface between
	 * Framer Motion and Popmotion
	 *
	 * @internal
	 */
	function startAnimation(key, value, target, transition) {
	    if (transition === void 0) { transition = {}; }
	    return value.start(function (onComplete) {
	        var delayTimer;
	        var controls;
	        var animation = getAnimation(key, value, target, transition, onComplete);
	        var delay = getDelayFromTransition(transition, key);
	        var start = function () { return (controls = animation()); };
	        if (delay) {
	            delayTimer = setTimeout(start, secondsToMilliseconds(delay));
	        }
	        else {
	            start();
	        }
	        return function () {
	            clearTimeout(delayTimer);
	            controls === null || controls === void 0 ? void 0 : controls.stop();
	        };
	    });
	}
	
	/**
	 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
	 */
	var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };
	
	function addUniqueItem(arr, item) {
	    arr.indexOf(item) === -1 && arr.push(item);
	}
	function removeItem(arr, item) {
	    var index = arr.indexOf(item);
	    index > -1 && arr.splice(index, 1);
	}
	
	var SubscriptionManager = /** @class */ (function () {
	    function SubscriptionManager() {
	        this.subscriptions = [];
	    }
	    SubscriptionManager.prototype.add = function (handler) {
	        var _this = this;
	        addUniqueItem(this.subscriptions, handler);
	        return function () { return removeItem(_this.subscriptions, handler); };
	    };
	    SubscriptionManager.prototype.notify = function (a, b, c) {
	        var numSubscriptions = this.subscriptions.length;
	        if (!numSubscriptions)
	            return;
	        if (numSubscriptions === 1) {
	            /**
	             * If there's only a single handler we can just call it without invoking a loop.
	             */
	            this.subscriptions[0](a, b, c);
	        }
	        else {
	            for (var i = 0; i < numSubscriptions; i++) {
	                /**
	                 * Check whether the handler exists before firing as it's possible
	                 * the subscriptions were modified during this loop running.
	                 */
	                var handler = this.subscriptions[i];
	                handler && handler(a, b, c);
	            }
	        }
	    };
	    SubscriptionManager.prototype.getSize = function () {
	        return this.subscriptions.length;
	    };
	    SubscriptionManager.prototype.clear = function () {
	        this.subscriptions.length = 0;
	    };
	    return SubscriptionManager;
	}());
	
	var isFloat = function (value) {
	    return !isNaN(parseFloat(value));
	};
	/**
	 * `MotionValue` is used to track the state and velocity of motion values.
	 *
	 * @public
	 */
	var MotionValue = /** @class */ (function () {
	    /**
	     * @param init - The initiating value
	     * @param config - Optional configuration options
	     *
	     * -  `transformer`: A function to transform incoming values with.
	     *
	     * @internal
	     */
	    function MotionValue(init) {
	        var _this = this;
	        /**
	         * Duration, in milliseconds, since last updating frame.
	         *
	         * @internal
	         */
	        this.timeDelta = 0;
	        /**
	         * Timestamp of the last time this `MotionValue` was updated.
	         *
	         * @internal
	         */
	        this.lastUpdated = 0;
	        /**
	         * Functions to notify when the `MotionValue` updates.
	         *
	         * @internal
	         */
	        this.updateSubscribers = new SubscriptionManager();
	        /**
	         * Functions to notify when the velocity updates.
	         *
	         * @internal
	         */
	        this.velocityUpdateSubscribers = new SubscriptionManager();
	        /**
	         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
	         *
	         * @internal
	         */
	        this.renderSubscribers = new SubscriptionManager();
	        /**
	         * Tracks whether this value can output a velocity. Currently this is only true
	         * if the value is numerical, but we might be able to widen the scope here and support
	         * other value types.
	         *
	         * @internal
	         */
	        this.canTrackVelocity = false;
	        this.updateAndNotify = function (v, render) {
	            if (render === void 0) { render = true; }
	            _this.prev = _this.current;
	            _this.current = v;
	            // Update timestamp
	            var _a = sync.getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
	            if (_this.lastUpdated !== timestamp) {
	                _this.timeDelta = delta;
	                _this.lastUpdated = timestamp;
	                sync__default['default'].postRender(_this.scheduleVelocityCheck);
	            }
	            // Update update subscribers
	            if (_this.prev !== _this.current) {
	                _this.updateSubscribers.notify(_this.current);
	            }
	            // Update velocity subscribers
	            if (_this.velocityUpdateSubscribers.getSize()) {
	                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
	            }
	            // Update render subscribers
	            if (render) {
	                _this.renderSubscribers.notify(_this.current);
	            }
	        };
	        /**
	         * Schedule a velocity check for the next frame.
	         *
	         * This is an instanced and bound function to prevent generating a new
	         * function once per frame.
	         *
	         * @internal
	         */
	        this.scheduleVelocityCheck = function () { return sync__default['default'].postRender(_this.velocityCheck); };
	        /**
	         * Updates `prev` with `current` if the value hasn't been updated this frame.
	         * This ensures velocity calculations return `0`.
	         *
	         * This is an instanced and bound function to prevent generating a new
	         * function once per frame.
	         *
	         * @internal
	         */
	        this.velocityCheck = function (_a) {
	            var timestamp = _a.timestamp;
	            if (timestamp !== _this.lastUpdated) {
	                _this.prev = _this.current;
	                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
	            }
	        };
	        this.hasAnimated = false;
	        this.prev = this.current = init;
	        this.canTrackVelocity = isFloat(this.current);
	    }
	    /**
	     * Adds a function that will be notified when the `MotionValue` is updated.
	     *
	     * It returns a function that, when called, will cancel the subscription.
	     *
	     * When calling `onChange` inside a React component, it should be wrapped with the
	     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
	     * from the `useEffect` function to ensure you don't add duplicate subscribers..
	     *
	     * @library
	     *
	     * ```jsx
	     * function MyComponent() {
	     *   const x = useMotionValue(0)
	     *   const y = useMotionValue(0)
	     *   const opacity = useMotionValue(1)
	     *
	     *   useEffect(() => {
	     *     function updateOpacity() {
	     *       const maxXY = Math.max(x.get(), y.get())
	     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
	     *       opacity.set(newOpacity)
	     *     }
	     *
	     *     const unsubscribeX = x.onChange(updateOpacity)
	     *     const unsubscribeY = y.onChange(updateOpacity)
	     *
	     *     return () => {
	     *       unsubscribeX()
	     *       unsubscribeY()
	     *     }
	     *   }, [])
	     *
	     *   return <Frame x={x} />
	     * }
	     * ```
	     *
	     * @motion
	     *
	     * ```jsx
	     * export const MyComponent = () => {
	     *   const x = useMotionValue(0)
	     *   const y = useMotionValue(0)
	     *   const opacity = useMotionValue(1)
	     *
	     *   useEffect(() => {
	     *     function updateOpacity() {
	     *       const maxXY = Math.max(x.get(), y.get())
	     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
	     *       opacity.set(newOpacity)
	     *     }
	     *
	     *     const unsubscribeX = x.onChange(updateOpacity)
	     *     const unsubscribeY = y.onChange(updateOpacity)
	     *
	     *     return () => {
	     *       unsubscribeX()
	     *       unsubscribeY()
	     *     }
	     *   }, [])
	     *
	     *   return <motion.div style={{ x }} />
	     * }
	     * ```
	     *
	     * @internalremarks
	     *
	     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
	     *
	     * ```jsx
	     * useOnChange(x, () => {})
	     * ```
	     *
	     * @param subscriber - A function that receives the latest value.
	     * @returns A function that, when called, will cancel this subscription.
	     *
	     * @public
	     */
	    MotionValue.prototype.onChange = function (subscription) {
	        return this.updateSubscribers.add(subscription);
	    };
	    MotionValue.prototype.clearListeners = function () {
	        this.updateSubscribers.clear();
	    };
	    /**
	     * Adds a function that will be notified when the `MotionValue` requests a render.
	     *
	     * @param subscriber - A function that's provided the latest value.
	     * @returns A function that, when called, will cancel this subscription.
	     *
	     * @internal
	     */
	    MotionValue.prototype.onRenderRequest = function (subscription) {
	        // Render immediately
	        subscription(this.get());
	        return this.renderSubscribers.add(subscription);
	    };
	    /**
	     * Attaches a passive effect to the `MotionValue`.
	     *
	     * @internal
	     */
	    MotionValue.prototype.attach = function (passiveEffect) {
	        this.passiveEffect = passiveEffect;
	    };
	    /**
	     * Sets the state of the `MotionValue`.
	     *
	     * @remarks
	     *
	     * ```jsx
	     * const x = useMotionValue(0)
	     * x.set(10)
	     * ```
	     *
	     * @param latest - Latest value to set.
	     * @param render - Whether to notify render subscribers. Defaults to `true`
	     *
	     * @public
	     */
	    MotionValue.prototype.set = function (v, render) {
	        if (render === void 0) { render = true; }
	        if (!render || !this.passiveEffect) {
	            this.updateAndNotify(v, render);
	        }
	        else {
	            this.passiveEffect(v, this.updateAndNotify);
	        }
	    };
	    /**
	     * Returns the latest state of `MotionValue`
	     *
	     * @returns - The latest state of `MotionValue`
	     *
	     * @public
	     */
	    MotionValue.prototype.get = function () {
	        return this.current;
	    };
	    /**
	     * @public
	     */
	    MotionValue.prototype.getPrevious = function () {
	        return this.prev;
	    };
	    /**
	     * Returns the latest velocity of `MotionValue`
	     *
	     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
	     *
	     * @public
	     */
	    MotionValue.prototype.getVelocity = function () {
	        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
	        return this.canTrackVelocity
	            ? // These casts could be avoided if parseFloat would be typed better
	                popmotion.velocityPerSecond(parseFloat(this.current) -
	                    parseFloat(this.prev), this.timeDelta)
	            : 0;
	    };
	    /**
	     * Registers a new animation to control this `MotionValue`. Only one
	     * animation can drive a `MotionValue` at one time.
	     *
	     * ```jsx
	     * value.start()
	     * ```
	     *
	     * @param animation - A function that starts the provided animation
	     *
	     * @internal
	     */
	    MotionValue.prototype.start = function (animation) {
	        var _this = this;
	        this.stop();
	        return new Promise(function (resolve) {
	            _this.hasAnimated = true;
	            _this.stopAnimation = animation(resolve);
	        }).then(function () { return _this.clearAnimation(); });
	    };
	    /**
	     * Stop the currently active animation.
	     *
	     * @public
	     */
	    MotionValue.prototype.stop = function () {
	        if (this.stopAnimation)
	            this.stopAnimation();
	        this.clearAnimation();
	    };
	    /**
	     * Returns `true` if this value is currently animating.
	     *
	     * @public
	     */
	    MotionValue.prototype.isAnimating = function () {
	        return !!this.stopAnimation;
	    };
	    MotionValue.prototype.clearAnimation = function () {
	        this.stopAnimation = null;
	    };
	    /**
	     * Destroy and clean up subscribers to this `MotionValue`.
	     *
	     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
	     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
	     * created a `MotionValue` via the `motionValue` function.
	     *
	     * @public
	     */
	    MotionValue.prototype.destroy = function () {
	        this.updateSubscribers.clear();
	        this.renderSubscribers.clear();
	        this.stop();
	    };
	    return MotionValue;
	}());
	/**
	 * @internal
	 */
	function motionValue(init) {
	    return new MotionValue(init);
	}
	
	/**
	 * Tests a provided value against a ValueType
	 */
	var testValueType = function (v) { return function (type) { return type.test(v); }; };
	
	/**
	 * ValueType for "auto"
	 */
	var auto = {
	    test: function (v) { return v === "auto"; },
	    parse: function (v) { return v; },
	};
	
	/**
	 * A list of value types commonly used for dimensions
	 */
	var dimensionValueTypes = [styleValueTypes.number, styleValueTypes.px, styleValueTypes.percent, styleValueTypes.degrees, styleValueTypes.vw, styleValueTypes.vh, auto];
	/**
	 * Tests a dimensional value against the list of dimension ValueTypes
	 */
	var findDimensionValueType = function (v) {
	    return dimensionValueTypes.find(testValueType(v));
	};
	
	/**
	 * A list of all ValueTypes
	 */
	var valueTypes = tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(dimensionValueTypes)), [styleValueTypes.color, styleValueTypes.complex]);
	/**
	 * Tests a value against the list of ValueTypes
	 */
	var findValueType = function (v) { return valueTypes.find(testValueType(v)); };
	
	/**
	 * Set VisualElement's MotionValue, creating a new MotionValue for it if
	 * it doesn't exist.
	 */
	function setMotionValue(visualElement, key, value) {
	    if (visualElement.hasValue(key)) {
	        visualElement.getValue(key).set(value);
	    }
	    else {
	        visualElement.addValue(key, motionValue(value));
	    }
	}
	function setTarget(visualElement, definition) {
	    var resolved = resolveVariant(visualElement, definition);
	    var _a = resolved
	        ? visualElement.makeTargetAnimatable(resolved, false)
	        : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b; _a.transition; var target = tslib.__rest(_a, ["transitionEnd", "transition"]);
	    target = tslib.__assign(tslib.__assign({}, target), transitionEnd);
	    for (var key in target) {
	        var value = resolveFinalValueInKeyframes(target[key]);
	        setMotionValue(visualElement, key, value);
	    }
	}
	function setVariants(visualElement, variantLabels) {
	    var reversedLabels = tslib.__spreadArray([], tslib.__read(variantLabels)).reverse();
	    reversedLabels.forEach(function (key) {
	        var _a;
	        var variant = visualElement.getVariant(key);
	        variant && setTarget(visualElement, variant);
	        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
	            setVariants(child, variantLabels);
	        });
	    });
	}
	function setValues(visualElement, definition) {
	    if (Array.isArray(definition)) {
	        return setVariants(visualElement, definition);
	    }
	    else if (typeof definition === "string") {
	        return setVariants(visualElement, [definition]);
	    }
	    else {
	        setTarget(visualElement, definition);
	    }
	}
	function checkTargetForNewValues(visualElement, target, origin) {
	    var _a, _b, _c;
	    var _d;
	    var newValueKeys = Object.keys(target).filter(function (key) { return !visualElement.hasValue(key); });
	    var numNewValues = newValueKeys.length;
	    if (!numNewValues)
	        return;
	    for (var i = 0; i < numNewValues; i++) {
	        var key = newValueKeys[i];
	        var targetValue = target[key];
	        var value = null;
	        /**
	         * If the target is a series of keyframes, we can use the first value
	         * in the array. If this first value is null, we'll still need to read from the DOM.
	         */
	        if (Array.isArray(targetValue)) {
	            value = targetValue[0];
	        }
	        /**
	         * If the target isn't keyframes, or the first keyframe was null, we need to
	         * first check if an origin value was explicitly defined in the transition as "from",
	         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
	         */
	        if (value === null) {
	            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
	        }
	        /**
	         * If value is still undefined or null, ignore it. Preferably this would throw,
	         * but this was causing issues in Framer.
	         */
	        if (value === undefined || value === null)
	            continue;
	        if (typeof value === "string" && isNumericalString(value)) {
	            // If this is a number read as a string, ie "0" or "200", convert it to a number
	            value = parseFloat(value);
	        }
	        else if (!findValueType(value) && styleValueTypes.complex.test(targetValue)) {
	            value = getAnimatableNone(key, targetValue);
	        }
	        visualElement.addValue(key, motionValue(value));
	        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : (_d[key] = value);
	        visualElement.setBaseTarget(key, value);
	    }
	}
	function getOriginFromTransition(key, transition) {
	    if (!transition)
	        return;
	    var valueTransition = transition[key] || transition["default"] || transition;
	    return valueTransition.from;
	}
	function getOrigin(target, transition, visualElement) {
	    var _a, _b;
	    var origin = {};
	    for (var key in target) {
	        origin[key] =
	            (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
	    }
	    return origin;
	}
	
	/**
	 * @internal
	 */
	function animateVisualElement(visualElement, definition, options) {
	    if (options === void 0) { options = {}; }
	    visualElement.notifyAnimationStart();
	    var animation;
	    if (Array.isArray(definition)) {
	        var animations = definition.map(function (variant) {
	            return animateVariant(visualElement, variant, options);
	        });
	        animation = Promise.all(animations);
	    }
	    else if (typeof definition === "string") {
	        animation = animateVariant(visualElement, definition, options);
	    }
	    else {
	        var resolvedDefinition = typeof definition === "function"
	            ? resolveVariant(visualElement, definition, options.custom)
	            : definition;
	        animation = animateTarget(visualElement, resolvedDefinition, options);
	    }
	    return animation.then(function () {
	        return visualElement.notifyAnimationComplete(definition);
	    });
	}
	function animateVariant(visualElement, variant, options) {
	    var _a;
	    if (options === void 0) { options = {}; }
	    var resolved = resolveVariant(visualElement, variant, options.custom);
	    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
	    if (options.transitionOverride) {
	        transition = options.transitionOverride;
	    }
	    /**
	     * If we have a variant, create a callback that runs it as an animation.
	     * Otherwise, we resolve a Promise immediately for a composable no-op.
	     */
	    var getAnimation = resolved
	        ? function () { return animateTarget(visualElement, resolved, options); }
	        : function () { return Promise.resolve(); };
	    /**
	     * If we have children, create a callback that runs all their animations.
	     * Otherwise, we resolve a Promise immediately for a composable no-op.
	     */
	    var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
	        ? function (forwardDelay) {
	            if (forwardDelay === void 0) { forwardDelay = 0; }
	            var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
	            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
	        }
	        : function () { return Promise.resolve(); };
	    /**
	     * If the transition explicitly defines a "when" option, we need to resolve either
	     * this animation or all children animations before playing the other.
	     */
	    var when = transition.when;
	    if (when) {
	        var _c = tslib.__read(when === "beforeChildren"
	            ? [getAnimation, getChildAnimations]
	            : [getChildAnimations, getAnimation], 2), first = _c[0], last = _c[1];
	        return first().then(last);
	    }
	    else {
	        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
	    }
	}
	/**
	 * @internal
	 */
	function animateTarget(visualElement, definition, _a) {
	    var _b;
	    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
	    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = tslib.__rest(_e, ["transition", "transitionEnd"]);
	    if (transitionOverride)
	        transition = transitionOverride;
	    var animations = [];
	    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
	    for (var key in target) {
	        var value = visualElement.getValue(key);
	        var valueTarget = target[key];
	        if (!value ||
	            valueTarget === undefined ||
	            (animationTypeState &&
	                shouldBlockAnimation(animationTypeState, key))) {
	            continue;
	        }
	        var animation = startAnimation(key, value, valueTarget, tslib.__assign({ delay: delay }, transition));
	        animations.push(animation);
	    }
	    return Promise.all(animations).then(function () {
	        transitionEnd && setTarget(visualElement, transitionEnd);
	    });
	}
	function animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
	    if (delayChildren === void 0) { delayChildren = 0; }
	    if (staggerChildren === void 0) { staggerChildren = 0; }
	    if (staggerDirection === void 0) { staggerDirection = 1; }
	    var animations = [];
	    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
	    var generateStaggerDuration = staggerDirection === 1
	        ? function (i) {
	            if (i === void 0) { i = 0; }
	            return i * staggerChildren;
	        }
	        : function (i) {
	            if (i === void 0) { i = 0; }
	            return maxStaggerDuration - i * staggerChildren;
	        };
	    Array.from(visualElement.variantChildren)
	        .sort(sortByTreeOrder)
	        .forEach(function (child, i) {
	        animations.push(animateVariant(child, variant, tslib.__assign(tslib.__assign({}, options), { delay: delayChildren + generateStaggerDuration(i) })).then(function () { return child.notifyAnimationComplete(variant); }));
	    });
	    return Promise.all(animations);
	}
	function stopAnimation(visualElement) {
	    visualElement.forEachValue(function (value) { return value.stop(); });
	}
	function sortByTreeOrder(a, b) {
	    return a.sortNodePosition(b);
	}
	/**
	 * Decide whether we should block this animation. Previously, we achieved this
	 * just by checking whether the key was listed in protectedKeys, but this
	 * posed problems if an animation was triggered by afterChildren and protectedKeys
	 * had been set to true in the meantime.
	 */
	function shouldBlockAnimation(_a, key) {
	    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
	    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
	    needsAnimating[key] = false;
	    return shouldBlock;
	}
	
	var variantPriorityOrder = [
	    AnimationType.Animate,
	    AnimationType.Hover,
	    AnimationType.Tap,
	    AnimationType.Drag,
	    AnimationType.Focus,
	    AnimationType.Exit,
	];
	var reversePriorityOrder = tslib.__spreadArray([], tslib.__read(variantPriorityOrder)).reverse();
	var numAnimationTypes = variantPriorityOrder.length;
	function animateList(visualElement) {
	    return function (animations) {
	        return Promise.all(animations.map(function (_a) {
	            var animation = _a.animation, options = _a.options;
	            return animateVisualElement(visualElement, animation, options);
	        }));
	    };
	}
	function createAnimationState(visualElement) {
	    var animate = animateList(visualElement);
	    var state = createState();
	    var allAnimatedKeys = {};
	    var isInitialRender = true;
	    /**
	     * This function will be used to reduce the animation definitions for
	     * each active animation type into an object of resolved values for it.
	     */
	    var buildResolvedTypeValues = function (acc, definition) {
	        var resolved = resolveVariant(visualElement, definition);
	        if (resolved) {
	            resolved.transition; var transitionEnd = resolved.transitionEnd, target = tslib.__rest(resolved, ["transition", "transitionEnd"]);
	            acc = tslib.__assign(tslib.__assign(tslib.__assign({}, acc), target), transitionEnd);
	        }
	        return acc;
	    };
	    function isAnimated(key) {
	        return allAnimatedKeys[key] !== undefined;
	    }
	    /**
	     * This just allows us to inject mocked animation functions
	     * @internal
	     */
	    function setAnimateFunction(makeAnimator) {
	        animate = makeAnimator(visualElement);
	    }
	    /**
	     * When we receive new props, we need to:
	     * 1. Create a list of protected keys for each type. This is a directory of
	     *    value keys that are currently being "handled" by types of a higher priority
	     *    so that whenever an animation is played of a given type, these values are
	     *    protected from being animated.
	     * 2. Determine if an animation type needs animating.
	     * 3. Determine if any values have been removed from a type and figure out
	     *    what to animate those to.
	     */
	    function animateChanges(options, changedActiveType) {
	        var _a;
	        var props = visualElement.getProps();
	        var context = visualElement.getVariantContext(true) || {};
	        /**
	         * A list of animations that we'll build into as we iterate through the animation
	         * types. This will get executed at the end of the function.
	         */
	        var animations = [];
	        /**
	         * Keep track of which values have been removed. Then, as we hit lower priority
	         * animation types, we can check if they contain removed values and animate to that.
	         */
	        var removedKeys = new Set();
	        /**
	         * A dictionary of all encountered keys. This is an object to let us build into and
	         * copy it without iteration. Each time we hit an animation type we set its protected
	         * keys - the keys its not allowed to animate - to the latest version of this object.
	         */
	        var encounteredKeys = {};
	        /**
	         * If a variant has been removed at a given index, and this component is controlling
	         * variant animations, we want to ensure lower-priority variants are forced to animate.
	         */
	        var removedVariantIndex = Infinity;
	        var _loop_1 = function (i) {
	            var type = reversePriorityOrder[i];
	            var typeState = state[type];
	            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
	            var propIsVariant = isVariantLabel(prop);
	            /**
	             * If this type has *just* changed isActive status, set activeDelta
	             * to that status. Otherwise set to null.
	             */
	            var activeDelta = type === changedActiveType ? typeState.isActive : null;
	            if (activeDelta === false)
	                removedVariantIndex = i;
	            /**
	             * If this prop is an inherited variant, rather than been set directly on the
	             * component itself, we want to make sure we allow the parent to trigger animations.
	             *
	             * TODO: Can probably change this to a !isControllingVariants check
	             */
	            var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
	            /**
	             *
	             */
	            if (isInherited &&
	                isInitialRender &&
	                visualElement.manuallyAnimateOnMount) {
	                isInherited = false;
	            }
	            /**
	             * Set all encountered keys so far as the protected keys for this type. This will
	             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
	             */
	            typeState.protectedKeys = tslib.__assign({}, encounteredKeys);
	            // Check if we can skip analysing this prop early
	            if (
	            // If it isn't active and hasn't *just* been set as inactive
	            (!typeState.isActive && activeDelta === null) ||
	                // If we didn't and don't have any defined prop for this animation type
	                (!prop && !typeState.prevProp) ||
	                // Or if the prop doesn't define an animation
	                isAnimationControls(prop) ||
	                typeof prop === "boolean") {
	                return "continue";
	            }
	            /**
	             * As we go look through the values defined on this type, if we detect
	             * a changed value or a value that was removed in a higher priority, we set
	             * this to true and add this prop to the animation list.
	             */
	            var shouldAnimateType = variantsHaveChanged(typeState.prevProp, prop) ||
	                // If we're making this variant active, we want to always make it active
	                (type === changedActiveType &&
	                    typeState.isActive &&
	                    !isInherited &&
	                    propIsVariant) ||
	                // If we removed a higher-priority variant (i is in reverse order)
	                (i > removedVariantIndex && propIsVariant);
	            /**
	             * As animations can be set as variant lists, variants or target objects, we
	             * coerce everything to an array if it isn't one already
	             */
	            var definitionList = Array.isArray(prop) ? prop : [prop];
	            /**
	             * Build an object of all the resolved values. We'll use this in the subsequent
	             * animateChanges calls to determine whether a value has changed.
	             */
	            var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
	            if (activeDelta === false)
	                resolvedValues = {};
	            /**
	             * Now we need to loop through all the keys in the prev prop and this prop,
	             * and decide:
	             * 1. If the value has changed, and needs animating
	             * 2. If it has been removed, and needs adding to the removedKeys set
	             * 3. If it has been removed in a higher priority type and needs animating
	             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
	             *    needs adding to the type's protectedKeys list.
	             */
	            var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
	            var allKeys = tslib.__assign(tslib.__assign({}, prevResolvedValues), resolvedValues);
	            var markToAnimate = function (key) {
	                shouldAnimateType = true;
	                removedKeys.delete(key);
	                typeState.needsAnimating[key] = true;
	            };
	            for (var key in allKeys) {
	                var next = resolvedValues[key];
	                var prev = prevResolvedValues[key];
	                // If we've already handled this we can just skip ahead
	                if (encounteredKeys.hasOwnProperty(key))
	                    continue;
	                /**
	                 * If the value has changed, we probably want to animate it.
	                 */
	                if (next !== prev) {
	                    /**
	                     * If both values are keyframes, we need to shallow compare them to
	                     * detect whether any value has changed. If it has, we animate it.
	                     */
	                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
	                        if (!shallowCompare(next, prev)) {
	                            markToAnimate(key);
	                        }
	                        else {
	                            /**
	                             * If it hasn't changed, we want to ensure it doesn't animate by
	                             * adding it to the list of protected keys.
	                             */
	                            typeState.protectedKeys[key] = true;
	                        }
	                    }
	                    else if (next !== undefined) {
	                        // If next is defined and doesn't equal prev, it needs animating
	                        markToAnimate(key);
	                    }
	                    else {
	                        // If it's undefined, it's been removed.
	                        removedKeys.add(key);
	                    }
	                }
	                else if (next !== undefined && removedKeys.has(key)) {
	                    /**
	                     * If next hasn't changed and it isn't undefined, we want to check if it's
	                     * been removed by a higher priority
	                     */
	                    markToAnimate(key);
	                }
	                else {
	                    /**
	                     * If it hasn't changed, we add it to the list of protected values
	                     * to ensure it doesn't get animated.
	                     */
	                    typeState.protectedKeys[key] = true;
	                }
	            }
	            /**
	             * Update the typeState so next time animateChanges is called we can compare the
	             * latest prop and resolvedValues to these.
	             */
	            typeState.prevProp = prop;
	            typeState.prevResolvedValues = resolvedValues;
	            /**
	             *
	             */
	            if (typeState.isActive) {
	                encounteredKeys = tslib.__assign(tslib.__assign({}, encounteredKeys), resolvedValues);
	            }
	            if (isInitialRender && visualElement.blockInitialAnimation) {
	                shouldAnimateType = false;
	            }
	            /**
	             * If this is an inherited prop we want to hard-block animations
	             * TODO: Test as this should probably still handle animations triggered
	             * by removed values?
	             */
	            if (shouldAnimateType && !isInherited) {
	                animations.push.apply(animations, tslib.__spreadArray([], tslib.__read(definitionList.map(function (animation) { return ({
	                    animation: animation,
	                    options: tslib.__assign({ type: type }, options),
	                }); }))));
	            }
	        };
	        /**
	         * Iterate through all animation types in reverse priority order. For each, we want to
	         * detect which values it's handling and whether or not they've changed (and therefore
	         * need to be animated). If any values have been removed, we want to detect those in
	         * lower priority props and flag for animation.
	         */
	        for (var i = 0; i < numAnimationTypes; i++) {
	            _loop_1(i);
	        }
	        allAnimatedKeys = tslib.__assign({}, encounteredKeys);
	        /**
	         * If there are some removed value that haven't been dealt with,
	         * we need to create a new animation that falls back either to the value
	         * defined in the style prop, or the last read value.
	         */
	        if (removedKeys.size) {
	            var fallbackAnimation_1 = {};
	            removedKeys.forEach(function (key) {
	                var fallbackTarget = visualElement.getBaseTarget(key);
	                if (fallbackTarget !== undefined) {
	                    fallbackAnimation_1[key] = fallbackTarget;
	                }
	            });
	            animations.push({ animation: fallbackAnimation_1 });
	        }
	        var shouldAnimate = Boolean(animations.length);
	        if (isInitialRender &&
	            props.initial === false &&
	            !visualElement.manuallyAnimateOnMount) {
	            shouldAnimate = false;
	        }
	        isInitialRender = false;
	        return shouldAnimate ? animate(animations) : Promise.resolve();
	    }
	    /**
	     * Change whether a certain animation type is active.
	     */
	    function setActive(type, isActive, options) {
	        var _a;
	        // If the active state hasn't changed, we can safely do nothing here
	        if (state[type].isActive === isActive)
	            return Promise.resolve();
	        // Propagate active change to children
	        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
	        state[type].isActive = isActive;
	        return animateChanges(options, type);
	    }
	    return {
	        isAnimated: isAnimated,
	        animateChanges: animateChanges,
	        setActive: setActive,
	        setAnimateFunction: setAnimateFunction,
	        getState: function () { return state; },
	    };
	}
	function variantsHaveChanged(prev, next) {
	    if (typeof next === "string") {
	        return next !== prev;
	    }
	    else if (isVariantLabels(next)) {
	        return !shallowCompare(next, prev);
	    }
	    return false;
	}
	function createTypeState(isActive) {
	    if (isActive === void 0) { isActive = false; }
	    return {
	        isActive: isActive,
	        protectedKeys: {},
	        needsAnimating: {},
	        prevResolvedValues: {},
	    };
	}
	function createState() {
	    var _a;
	    return _a = {},
	        _a[AnimationType.Animate] = createTypeState(true),
	        _a[AnimationType.Hover] = createTypeState(),
	        _a[AnimationType.Tap] = createTypeState(),
	        _a[AnimationType.Drag] = createTypeState(),
	        _a[AnimationType.Focus] = createTypeState(),
	        _a[AnimationType.Exit] = createTypeState(),
	        _a;
	}
	
	var animations = {
	    animation: makeRenderlessComponent(function (_a) {
	        var visualElement = _a.visualElement, animate = _a.animate;
	        /**
	         * We dynamically generate the AnimationState manager as it contains a reference
	         * to the underlying animation library. We only want to load that if we load this,
	         * so people can optionally code split it out using the `m` component.
	         */
	        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
	        /**
	         * Subscribe any provided AnimationControls to the component's VisualElement
	         */
	        if (isAnimationControls(animate)) {
	            React.useEffect(function () { return animate.subscribe(visualElement); }, [animate]);
	        }
	    }),
	    exit: makeRenderlessComponent(function (props) {
	        var custom = props.custom, visualElement = props.visualElement;
	        var _a = tslib.__read(usePresence(), 2), isPresent = _a[0], onExitComplete = _a[1];
	        var presenceContext = React.useContext(PresenceContext);
	        React.useEffect(function () {
	            var _a, _b;
	            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
	            !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(onExitComplete));
	        }, [isPresent]);
	    }),
	};
	
	/**
	 * @internal
	 */
	var PanSession = /** @class */ (function () {
	    function PanSession(event, handlers, _a) {
	        var _this = this;
	        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
	        /**
	         * @internal
	         */
	        this.startEvent = null;
	        /**
	         * @internal
	         */
	        this.lastMoveEvent = null;
	        /**
	         * @internal
	         */
	        this.lastMoveEventInfo = null;
	        /**
	         * @internal
	         */
	        this.handlers = {};
	        this.updatePoint = function () {
	            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
	                return;
	            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
	            var isPanStarted = _this.startEvent !== null;
	            // Only start panning if the offset is larger than 3 pixels. If we make it
	            // any larger than this we'll want to reset the pointer history
	            // on the first update to avoid visual snapping to the cursoe.
	            var isDistancePastThreshold = popmotion.distance(info.offset, { x: 0, y: 0 }) >= 3;
	            if (!isPanStarted && !isDistancePastThreshold)
	                return;
	            var point = info.point;
	            var timestamp = sync.getFrameData().timestamp;
	            _this.history.push(tslib.__assign(tslib.__assign({}, point), { timestamp: timestamp }));
	            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
	            if (!isPanStarted) {
	                onStart && onStart(_this.lastMoveEvent, info);
	                _this.startEvent = _this.lastMoveEvent;
	            }
	            onMove && onMove(_this.lastMoveEvent, info);
	        };
	        this.handlePointerMove = function (event, info) {
	            _this.lastMoveEvent = event;
	            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
	            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
	            if (isMouseEvent(event) && event.buttons === 0) {
	                _this.handlePointerUp(event, info);
	                return;
	            }
	            // Throttle mouse move event to once per frame
	            sync__default['default'].update(_this.updatePoint, true);
	        };
	        this.handlePointerUp = function (event, info) {
	            _this.end();
	            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
	            var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
	            if (_this.startEvent && onEnd) {
	                onEnd(event, panInfo);
	            }
	            onSessionEnd && onSessionEnd(event, panInfo);
	        };
	        // If we have more than one touch, don't start detecting this gesture
	        if (isTouchEvent(event) && event.touches.length > 1)
	            return;
	        this.handlers = handlers;
	        this.transformPagePoint = transformPagePoint;
	        var info = extractEventInfo(event);
	        var initialInfo = transformPoint(info, this.transformPagePoint);
	        var point = initialInfo.point;
	        var timestamp = sync.getFrameData().timestamp;
	        this.history = [tslib.__assign(tslib.__assign({}, point), { timestamp: timestamp })];
	        var onSessionStart = handlers.onSessionStart;
	        onSessionStart &&
	            onSessionStart(event, getPanInfo(initialInfo, this.history));
	        this.removeListeners = popmotion.pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
	    }
	    PanSession.prototype.updateHandlers = function (handlers) {
	        this.handlers = handlers;
	    };
	    PanSession.prototype.end = function () {
	        this.removeListeners && this.removeListeners();
	        sync.cancelSync.update(this.updatePoint);
	    };
	    return PanSession;
	}());
	function transformPoint(info, transformPagePoint) {
	    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
	}
	function subtractPoint(a, b) {
	    return { x: a.x - b.x, y: a.y - b.y };
	}
	function getPanInfo(_a, history) {
	    var point = _a.point;
	    return {
	        point: point,
	        delta: subtractPoint(point, lastDevicePoint(history)),
	        offset: subtractPoint(point, startDevicePoint(history)),
	        velocity: getVelocity(history, 0.1),
	    };
	}
	function startDevicePoint(history) {
	    return history[0];
	}
	function lastDevicePoint(history) {
	    return history[history.length - 1];
	}
	function getVelocity(history, timeDelta) {
	    if (history.length < 2) {
	        return { x: 0, y: 0 };
	    }
	    var i = history.length - 1;
	    var timestampedPoint = null;
	    var lastPoint = lastDevicePoint(history);
	    while (i >= 0) {
	        timestampedPoint = history[i];
	        if (lastPoint.timestamp - timestampedPoint.timestamp >
	            secondsToMilliseconds(timeDelta)) {
	            break;
	        }
	        i--;
	    }
	    if (!timestampedPoint) {
	        return { x: 0, y: 0 };
	    }
	    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
	    if (time === 0) {
	        return { x: 0, y: 0 };
	    }
	    var currentVelocity = {
	        x: (lastPoint.x - timestampedPoint.x) / time,
	        y: (lastPoint.y - timestampedPoint.y) / time,
	    };
	    if (currentVelocity.x === Infinity) {
	        currentVelocity.x = 0;
	    }
	    if (currentVelocity.y === Infinity) {
	        currentVelocity.y = 0;
	    }
	    return currentVelocity;
	}
	
	function noop(any) {
	    return any;
	}
	
	/**
	 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
	 * it's easier to consider each axis individually. This function returns a bounding box
	 * as a map of single-axis min/max values.
	 */
	function convertBoundingBoxToAxisBox(_a) {
	    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
	    return {
	        x: { min: left, max: right },
	        y: { min: top, max: bottom },
	    };
	}
	function convertAxisBoxToBoundingBox(_a) {
	    var x = _a.x, y = _a.y;
	    return {
	        top: y.min,
	        bottom: y.max,
	        left: x.min,
	        right: x.max,
	    };
	}
	/**
	 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
	 * provided by Framer to allow measured points to be corrected for device scaling. This is used
	 * when measuring DOM elements and DOM event points.
	 */
	function transformBoundingBox(_a, transformPoint) {
	    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
	    if (transformPoint === void 0) { transformPoint = noop; }
	    var topLeft = transformPoint({ x: left, y: top });
	    var bottomRight = transformPoint({ x: right, y: bottom });
	    return {
	        top: topLeft.y,
	        left: topLeft.x,
	        bottom: bottomRight.y,
	        right: bottomRight.x,
	    };
	}
	/**
	 * Create an empty axis box of zero size
	 */
	function axisBox() {
	    return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
	}
	function copyAxisBox(box) {
	    return {
	        x: tslib.__assign({}, box.x),
	        y: tslib.__assign({}, box.y),
	    };
	}
	/**
	 * Create an empty box delta
	 */
	var zeroDelta = {
	    translate: 0,
	    scale: 1,
	    origin: 0,
	    originPoint: 0,
	};
	function delta() {
	    return {
	        x: tslib.__assign({}, zeroDelta),
	        y: tslib.__assign({}, zeroDelta),
	    };
	}
	
	// Call a handler once for each axis
	function eachAxis(handler) {
	    return [handler("x"), handler("y")];
	}
	
	var clampProgress = function (v) { return popmotion.clamp(0, 1, v); };
	/**
	 * Returns true if the provided value is within maxDistance of the provided target
	 */
	function isNear(value, target, maxDistance) {
	    if (target === void 0) { target = 0; }
	    if (maxDistance === void 0) { maxDistance = 0.01; }
	    return popmotion.distance(value, target) < maxDistance;
	}
	function calcLength(axis) {
	    return axis.max - axis.min;
	}
	/**
	 * Calculate a transform origin relative to the source axis, between 0-1, that results
	 * in an asthetically pleasing scale/transform needed to project from source to target.
	 */
	function calcOrigin(source, target) {
	    var origin = 0.5;
	    var sourceLength = calcLength(source);
	    var targetLength = calcLength(target);
	    if (targetLength > sourceLength) {
	        origin = popmotion.progress(target.min, target.max - sourceLength, source.min);
	    }
	    else if (sourceLength > targetLength) {
	        origin = popmotion.progress(source.min, source.max - targetLength, target.min);
	    }
	    return clampProgress(origin);
	}
	/**
	 * Update the AxisDelta with a transform that projects source into target.
	 *
	 * The transform `origin` is optional. If not provided, it'll be automatically
	 * calculated based on the relative positions of the two bounding boxes.
	 */
	function updateAxisDelta(delta, source, target, origin) {
	    if (origin === void 0) { origin = 0.5; }
	    delta.origin = origin;
	    delta.originPoint = popmotion.mix(source.min, source.max, delta.origin);
	    delta.scale = calcLength(target) / calcLength(source);
	    if (isNear(delta.scale, 1, 0.0001))
	        delta.scale = 1;
	    delta.translate =
	        popmotion.mix(target.min, target.max, delta.origin) - delta.originPoint;
	    if (isNear(delta.translate))
	        delta.translate = 0;
	}
	/**
	 * Update the BoxDelta with a transform that projects the source into the target.
	 *
	 * The transform `origin` is optional. If not provided, it'll be automatically
	 * calculated based on the relative positions of the two bounding boxes.
	 */
	function updateBoxDelta(delta, source, target, origin) {
	    updateAxisDelta(delta.x, source.x, target.x, defaultOrigin(origin.originX));
	    updateAxisDelta(delta.y, source.y, target.y, defaultOrigin(origin.originY));
	}
	/**
	 * Currently this only accepts numerical origins, measured as 0-1, but could
	 * accept pixel values by comparing to the target axis.
	 */
	function defaultOrigin(origin) {
	    return typeof origin === "number" ? origin : 0.5;
	}
	function calcRelativeAxis(target, relative, parent) {
	    target.min = parent.min + relative.min;
	    target.max = target.min + calcLength(relative);
	}
	function calcRelativeBox(projection, parentProjection) {
	    calcRelativeAxis(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
	    calcRelativeAxis(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
	}
	
	/**
	 * Apply constraints to a point. These constraints are both physical along an
	 * axis, and an elastic factor that determines how much to constrain the point
	 * by if it does lie outside the defined parameters.
	 */
	function applyConstraints(point, _a, elastic) {
	    var min = _a.min, max = _a.max;
	    if (min !== undefined && point < min) {
	        // If we have a min point defined, and this is outside of that, constrain
	        point = elastic ? popmotion.mix(min, point, elastic.min) : Math.max(point, min);
	    }
	    else if (max !== undefined && point > max) {
	        // If we have a max point defined, and this is outside of that, constrain
	        point = elastic ? popmotion.mix(max, point, elastic.max) : Math.min(point, max);
	    }
	    return point;
	}
	/**
	 * Calculates a min projection point based on a pointer, pointer progress
	 * within the drag target, and constraints.
	 *
	 * For instance if an element was 100px width, we were dragging from 0.25
	 * along this axis, the pointer is at 200px, and there were no constraints,
	 * we would calculate a min projection point of 175px.
	 */
	function calcConstrainedMinPoint(point, length, progress, constraints, elastic) {
	    // Calculate a min point for this axis and apply it to the current pointer
	    var min = point - length * progress;
	    return constraints ? applyConstraints(min, constraints, elastic) : min;
	}
	/**
	 * Calculate constraints in terms of the viewport when defined relatively to the
	 * measured axis. This is measured from the nearest edge, so a max constraint of 200
	 * on an axis with a max value of 300 would return a constraint of 500 - axis length
	 */
	function calcRelativeAxisConstraints(axis, min, max) {
	    return {
	        min: min !== undefined ? axis.min + min : undefined,
	        max: max !== undefined
	            ? axis.max + max - (axis.max - axis.min)
	            : undefined,
	    };
	}
	/**
	 * Calculate constraints in terms of the viewport when
	 * defined relatively to the measured bounding box.
	 */
	function calcRelativeConstraints(layoutBox, _a) {
	    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
	    return {
	        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
	        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
	    };
	}
	/**
	 * Calculate viewport constraints when defined as another viewport-relative axis
	 */
	function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
	    var _a;
	    var min = constraintsAxis.min - layoutAxis.min;
	    var max = constraintsAxis.max - layoutAxis.max;
	    // If the constraints axis is actually smaller than the layout axis then we can
	    // flip the constraints
	    if (constraintsAxis.max - constraintsAxis.min <
	        layoutAxis.max - layoutAxis.min) {
	        _a = tslib.__read([max, min], 2), min = _a[0], max = _a[1];
	    }
	    return {
	        min: layoutAxis.min + min,
	        max: layoutAxis.min + max,
	    };
	}
	/**
	 * Calculate viewport constraints when defined as another viewport-relative box
	 */
	function calcViewportConstraints(layoutBox, constraintsBox) {
	    return {
	        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
	        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
	    };
	}
	/**
	 * Calculate the an axis position based on two axes and a progress value.
	 */
	function calcPositionFromProgress(axis, constraints, progress) {
	    var axisLength = axis.max - axis.min;
	    var min = popmotion.mix(constraints.min, constraints.max - axisLength, progress);
	    return { min: min, max: min + axisLength };
	}
	/**
	 * Rebase the calculated viewport constraints relative to the layout.min point.
	 */
	function rebaseAxisConstraints(layout, constraints) {
	    var relativeConstraints = {};
	    if (constraints.min !== undefined) {
	        relativeConstraints.min = constraints.min - layout.min;
	    }
	    if (constraints.max !== undefined) {
	        relativeConstraints.max = constraints.max - layout.min;
	    }
	    return relativeConstraints;
	}
	var defaultElastic = 0.35;
	/**
	 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
	 */
	function resolveDragElastic(dragElastic) {
	    if (dragElastic === false) {
	        dragElastic = 0;
	    }
	    else if (dragElastic === true) {
	        dragElastic = defaultElastic;
	    }
	    return {
	        x: resolveAxisElastic(dragElastic, "left", "right"),
	        y: resolveAxisElastic(dragElastic, "top", "bottom"),
	    };
	}
	function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
	    return {
	        min: resolvePointElastic(dragElastic, minLabel),
	        max: resolvePointElastic(dragElastic, maxLabel),
	    };
	}
	function resolvePointElastic(dragElastic, label) {
	    var _a;
	    return typeof dragElastic === "number"
	        ? dragElastic
	        : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
	}
	
	/**
	 * Measure and return the element bounding box.
	 *
	 * We convert the box into an AxisBox2D to make it easier to work with each axis
	 * individually and programmatically.
	 *
	 * This function optionally accepts a transformPagePoint function which allows us to compensate
	 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
	 */
	function getBoundingBox(element, transformPagePoint) {
	    var box = element.getBoundingClientRect();
	    return convertBoundingBoxToAxisBox(transformBoundingBox(box, transformPagePoint));
	}
	
	var compareByDepth = function (a, b) {
	    return a.depth - b.depth;
	};
	
	function isProjecting(visualElement) {
	    var isEnabled = visualElement.projection.isEnabled;
	    return isEnabled || visualElement.shouldResetTransform();
	}
	function collectProjectingAncestors(visualElement, ancestors) {
	    if (ancestors === void 0) { ancestors = []; }
	    var parent = visualElement.parent;
	    if (parent)
	        collectProjectingAncestors(parent, ancestors);
	    if (isProjecting(visualElement))
	        ancestors.push(visualElement);
	    return ancestors;
	}
	function collectProjectingChildren(visualElement) {
	    var children = [];
	    var addChild = function (child) {
	        if (isProjecting(child))
	            children.push(child);
	        child.children.forEach(addChild);
	    };
	    visualElement.children.forEach(addChild);
	    return children.sort(compareByDepth);
	}
	/**
	 * Update the layoutState by measuring the DOM layout. This
	 * should be called after resetting any layout-affecting transforms.
	 */
	function updateLayoutMeasurement(visualElement) {
	    if (visualElement.shouldResetTransform())
	        return;
	    var layoutState = visualElement.getLayoutState();
	    visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
	    layoutState.isHydrated = true;
	    layoutState.layout = visualElement.measureViewportBox();
	    layoutState.layoutCorrected = copyAxisBox(layoutState.layout);
	    visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
	    sync__default['default'].update(function () { return visualElement.rebaseProjectionTarget(); });
	}
	/**
	 * Record the viewport box as it was before an expected mutation/re-render
	 */
	function snapshotViewportBox(visualElement) {
	    if (visualElement.shouldResetTransform())
	        return;
	    visualElement.prevViewportBox = visualElement.measureViewportBox(false);
	    /**
	     * Update targetBox to match the prevViewportBox. This is just to ensure
	     * that targetBox is affected by scroll in the same way as the measured box
	     */
	    visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
	}
	
	function tweenAxis(target, prev, next, p) {
	    target.min = popmotion.mix(prev.min, next.min, p);
	    target.max = popmotion.mix(prev.max, next.max, p);
	}
	function calcRelativeOffsetAxis(parent, child) {
	    return {
	        min: child.min - parent.min,
	        max: child.max - parent.min,
	    };
	}
	function calcRelativeOffset(parent, child) {
	    return {
	        x: calcRelativeOffsetAxis(parent.x, child.x),
	        y: calcRelativeOffsetAxis(parent.y, child.y),
	    };
	}
	function checkIfParentHasChanged(prev, next) {
	    var prevId = prev.getLayoutId();
	    var nextId = next.getLayoutId();
	    return prevId !== nextId || (nextId === undefined && prev !== next);
	}
	
	function isDraggable(visualElement) {
	    var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
	    return drag && !_dragX;
	}
	
	/**
	 * Reset an axis to the provided origin box.
	 *
	 * This is a mutative operation.
	 */
	function resetAxis(axis, originAxis) {
	    axis.min = originAxis.min;
	    axis.max = originAxis.max;
	}
	/**
	 * Reset a box to the provided origin box.
	 *
	 * This is a mutative operation.
	 */
	function resetBox(box, originBox) {
	    resetAxis(box.x, originBox.x);
	    resetAxis(box.y, originBox.y);
	}
	/**
	 * Scales a point based on a factor and an originPoint
	 */
	function scalePoint(point, scale, originPoint) {
	    var distanceFromOrigin = point - originPoint;
	    var scaled = scale * distanceFromOrigin;
	    return originPoint + scaled;
	}
	/**
	 * Applies a translate/scale delta to a point
	 */
	function applyPointDelta(point, translate, scale, originPoint, boxScale) {
	    if (boxScale !== undefined) {
	        point = scalePoint(point, boxScale, originPoint);
	    }
	    return scalePoint(point, scale, originPoint) + translate;
	}
	/**
	 * Applies a translate/scale delta to an axis
	 */
	function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
	    if (translate === void 0) { translate = 0; }
	    if (scale === void 0) { scale = 1; }
	    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
	    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
	}
	/**
	 * Applies a translate/scale delta to a box
	 */
	function applyBoxDelta(box, _a) {
	    var x = _a.x, y = _a.y;
	    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
	    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
	}
	/**
	 * Apply a transform to an axis from the latest resolved motion values.
	 * This function basically acts as a bridge between a flat motion value map
	 * and applyAxisDelta
	 */
	function applyAxisTransforms(final, axis, transforms, _a) {
	    var _b = tslib.__read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
	    // Copy the current axis to the final axis before mutation
	    final.min = axis.min;
	    final.max = axis.max;
	    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
	    var originPoint = popmotion.mix(axis.min, axis.max, axisOrigin);
	    // Apply the axis delta to the final axis
	    applyAxisDelta(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
	}
	/**
	 * The names of the motion values we want to apply as translation, scale and origin.
	 */
	var xKeys = ["x", "scaleX", "originX"];
	var yKeys = ["y", "scaleY", "originY"];
	/**
	 * Apply a transform to a box from the latest resolved motion values.
	 */
	function applyBoxTransforms(finalBox, box, transforms) {
	    applyAxisTransforms(finalBox.x, box.x, transforms, xKeys);
	    applyAxisTransforms(finalBox.y, box.y, transforms, yKeys);
	}
	/**
	 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
	 */
	function removePointDelta(point, translate, scale, originPoint, boxScale) {
	    point -= translate;
	    point = scalePoint(point, 1 / scale, originPoint);
	    if (boxScale !== undefined) {
	        point = scalePoint(point, 1 / boxScale, originPoint);
	    }
	    return point;
	}
	/**
	 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
	 */
	function removeAxisDelta(axis, translate, scale, origin, boxScale) {
	    if (translate === void 0) { translate = 0; }
	    if (scale === void 0) { scale = 1; }
	    if (origin === void 0) { origin = 0.5; }
	    var originPoint = popmotion.mix(axis.min, axis.max, origin) - translate;
	    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
	    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
	}
	/**
	 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
	 * and acts as a bridge between motion values and removeAxisDelta
	 */
	function removeAxisTransforms(axis, transforms, _a) {
	    var _b = tslib.__read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
	    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
	}
	/**
	 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
	 * and acts as a bridge between motion values and removeAxisDelta
	 */
	function removeBoxTransforms(box, transforms) {
	    removeAxisTransforms(box.x, transforms, xKeys);
	    removeAxisTransforms(box.y, transforms, yKeys);
	}
	/**
	 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
	 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
	 *
	 * This is the final nested loop within updateLayoutDelta for future refactoring
	 */
	function applyTreeDeltas(box, treeScale, treePath) {
	    var treeLength = treePath.length;
	    if (!treeLength)
	        return;
	    // Reset the treeScale
	    treeScale.x = treeScale.y = 1;
	    var node;
	    var delta;
	    for (var i = 0; i < treeLength; i++) {
	        node = treePath[i];
	        delta = node.getLayoutState().delta;
	        // Incoporate each ancestor's scale into a culmulative treeScale for this component
	        treeScale.x *= delta.x.scale;
	        treeScale.y *= delta.y.scale;
	        // Apply each ancestor's calculated delta into this component's recorded layout box
	        applyBoxDelta(box, delta);
	        // If this is a draggable ancestor, also incorporate the node's transform to the layout box
	        if (isDraggable(node)) {
	            applyBoxTransforms(box, box, node.getLatestValues());
	        }
	    }
	}
	
	/**
	 * Returns a boolean stating whether or not we converted the projection
	 * to relative projection.
	 */
	function convertToRelativeProjection(visualElement, isLayoutDrag) {
	    if (isLayoutDrag === void 0) { isLayoutDrag = true; }
	    var projectionParent = visualElement.getProjectionParent();
	    if (!projectionParent)
	        return false;
	    var offset;
	    if (isLayoutDrag) {
	        offset = calcRelativeOffset(projectionParent.projection.target, visualElement.projection.target);
	        removeBoxTransforms(offset, projectionParent.getLatestValues());
	    }
	    else {
	        offset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
	    }
	    eachAxis(function (axis) {
	        return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
	    });
	    return true;
	}
	
	var unresolvedJobs = new Set();
	function pushJob(stack, job, pointer) {
	    if (!stack[pointer])
	        stack[pointer] = [];
	    stack[pointer].push(job);
	}
	function batchLayout(callback) {
	    unresolvedJobs.add(callback);
	    return function () { return unresolvedJobs.delete(callback); };
	}
	function flushLayout() {
	    if (!unresolvedJobs.size)
	        return;
	    var pointer = 0;
	    var reads = [[]];
	    var writes = [];
	    var setRead = function (job) { return pushJob(reads, job, pointer); };
	    var setWrite = function (job) {
	        pushJob(writes, job, pointer);
	        pointer++;
	    };
	    /**
	     * Resolve jobs into their array stacks
	     */
	    unresolvedJobs.forEach(function (callback) {
	        callback(setRead, setWrite);
	        pointer = 0;
	    });
	    unresolvedJobs.clear();
	    /**
	     * Execute jobs
	     */
	    var numStacks = writes.length;
	    for (var i = 0; i <= numStacks; i++) {
	        reads[i] && reads[i].forEach(executeJob);
	        writes[i] && writes[i].forEach(executeJob);
	    }
	}
	var executeJob = function (job) { return job(); };
	
	var elementDragControls = new WeakMap();
	/**
	 *
	 */
	var lastPointerEvent;
	var VisualElementDragControls = /** @class */ (function () {
	    function VisualElementDragControls(_a) {
	        var visualElement = _a.visualElement;
	        /**
	         * Track whether we're currently dragging.
	         *
	         * @internal
	         */
	        this.isDragging = false;
	        /**
	         * The current direction of drag, or `null` if both.
	         *
	         * @internal
	         */
	        this.currentDirection = null;
	        /**
	         * The permitted boundaries of travel, in pixels.
	         *
	         * @internal
	         */
	        this.constraints = false;
	        /**
	         * The per-axis resolved elastic values.
	         *
	         * @internal
	         */
	        this.elastic = axisBox();
	        /**
	         * A reference to the host component's latest props.
	         *
	         * @internal
	         */
	        this.props = {};
	        /**
	         * @internal
	         */
	        this.hasMutatedConstraints = false;
	        /**
	         * Track the initial position of the cursor relative to the dragging element
	         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
	         * an ideal bounding box for the VisualElement renderer to project into every frame.
	         *
	         * @internal
	         */
	        this.cursorProgress = {
	            x: 0.5,
	            y: 0.5,
	        };
	        // When updating _dragX, or _dragY instead of the VisualElement,
	        // persist their values between drag gestures.
	        this.originPoint = {};
	        // This is a reference to the global drag gesture lock, ensuring only one component
	        // can "capture" the drag of one or both axes.
	        // TODO: Look into moving this into pansession?
	        this.openGlobalLock = null;
	        /**
	         * @internal
	         */
	        this.panSession = null;
	        this.visualElement = visualElement;
	        this.visualElement.enableLayoutProjection();
	        elementDragControls.set(visualElement, this);
	    }
	    /**
	     * Instantiate a PanSession for the drag gesture
	     *
	     * @public
	     */
	    VisualElementDragControls.prototype.start = function (originEvent, _a) {
	        var _this = this;
	        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
	        var onSessionStart = function (event) {
	            var _a;
	            // Stop any animations on both axis values immediately. This allows the user to throw and catch
	            // the component.
	            _this.stopMotion();
	            /**
	             * Save the initial point. We'll use this to calculate the pointer's position rather
	             * than the one we receive when the gesture actually starts. By then, the pointer will
	             * have already moved, and the perception will be of the pointer "slipping" across the element
	             */
	            var initialPoint = getViewportPointFromEvent(event).point;
	            (_a = _this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(_this);
	            _this.cancelLayout = batchLayout(function (read, write) {
	                var ancestors = collectProjectingAncestors(_this.visualElement);
	                var children = collectProjectingChildren(_this.visualElement);
	                var tree = tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(ancestors)), tslib.__read(children));
	                var hasManuallySetCursorOrigin = false;
	                /**
	                 * Apply a simple lock to the projection target. This ensures no animations
	                 * can run on the projection box while this lock is active.
	                 */
	                _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
	                write(function () {
	                    tree.forEach(function (element) { return element.resetTransform(); });
	                });
	                read(function () {
	                    updateLayoutMeasurement(_this.visualElement);
	                    children.forEach(updateLayoutMeasurement);
	                });
	                write(function () {
	                    tree.forEach(function (element) { return element.restoreTransform(); });
	                    if (snapToCursor) {
	                        hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
	                    }
	                });
	                read(function () {
	                    var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
	                    if (!isRelativeDrag) {
	                        _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
	                    }
	                    _this.visualElement.scheduleUpdateLayoutProjection();
	                    /**
	                     * When dragging starts, we want to find where the cursor is relative to the bounding box
	                     * of the element. Every frame, we calculate a new bounding box using this relative position
	                     * and let the visualElement renderer figure out how to reproject the element into this bounding
	                     * box.
	                     *
	                     * By doing it this way, rather than applying an x/y transform directly to the element,
	                     * we can ensure the component always visually sticks to the cursor as we'd expect, even
	                     * if the DOM element itself changes layout as a result of React updates the user might
	                     * make based on the drag position.
	                     */
	                    var projection = _this.visualElement.projection;
	                    eachAxis(function (axis) {
	                        if (!hasManuallySetCursorOrigin) {
	                            var _a = projection.target[axis], min = _a.min, max = _a.max;
	                            _this.cursorProgress[axis] = cursorProgress
	                                ? cursorProgress[axis]
	                                : popmotion.progress(min, max, initialPoint[axis]);
	                        }
	                        /**
	                         * If we have external drag MotionValues, record their origin point. On pointermove
	                         * we'll apply the pan gesture offset directly to this value.
	                         */
	                        var axisValue = _this.getAxisMotionValue(axis);
	                        if (axisValue) {
	                            _this.originPoint[axis] = axisValue.get();
	                        }
	                    });
	                });
	                write(function () {
	                    sync.flushSync.update();
	                    sync.flushSync.preRender();
	                    sync.flushSync.render();
	                    sync.flushSync.postRender();
	                });
	                read(function () { return _this.resolveDragConstraints(); });
	            });
	        };
	        var onStart = function (event, info) {
	            var _a, _b, _c;
	            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
	            var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
	            if (drag && !dragPropagation) {
	                if (_this.openGlobalLock)
	                    _this.openGlobalLock();
	                _this.openGlobalLock = getGlobalLock(drag);
	                // If we don 't have the lock, don't start dragging
	                if (!_this.openGlobalLock)
	                    return;
	            }
	            flushLayout();
	            // Set current drag status
	            _this.isDragging = true;
	            _this.currentDirection = null;
	            // Fire onDragStart event
	            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, event, info);
	            (_c = _this.visualElement.animationState) === null || _c === void 0 ? void 0 : _c.setActive(AnimationType.Drag, true);
	        };
	        var onMove = function (event, info) {
	            var _a, _b, _c, _d;
	            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
	            // If we didn't successfully receive the gesture lock, early return.
	            if (!dragPropagation && !_this.openGlobalLock)
	                return;
	            var offset = info.offset;
	            // Attempt to detect drag direction if directionLock is true
	            if (dragDirectionLock && _this.currentDirection === null) {
	                _this.currentDirection = getCurrentDirection(offset);
	                // If we've successfully set a direction, notify listener
	                if (_this.currentDirection !== null) {
	                    (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 ? void 0 : _b.call(_a, _this.currentDirection);
	                }
	                return;
	            }
	            // Update each point with the latest position
	            _this.updateAxis("x", info.point, offset);
	            _this.updateAxis("y", info.point, offset);
	            // Fire onDrag event
	            (_d = (_c = _this.props).onDrag) === null || _d === void 0 ? void 0 : _d.call(_c, event, info);
	            // Update the last pointer event
	            lastPointerEvent = event;
	        };
	        var onSessionEnd = function (event, info) {
	            return _this.stop(event, info);
	        };
	        var transformPagePoint = this.props.transformPagePoint;
	        this.panSession = new PanSession(originEvent, {
	            onSessionStart: onSessionStart,
	            onStart: onStart,
	            onMove: onMove,
	            onSessionEnd: onSessionEnd,
	        }, { transformPagePoint: transformPagePoint });
	    };
	    VisualElementDragControls.prototype.resolveDragConstraints = function () {
	        var _this = this;
	        var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
	        var layout = this.visualElement.getLayoutState().layoutCorrected;
	        if (dragConstraints) {
	            this.constraints = isRefObject(dragConstraints)
	                ? this.resolveRefConstraints(layout, dragConstraints)
	                : calcRelativeConstraints(layout, dragConstraints);
	        }
	        else {
	            this.constraints = false;
	        }
	        this.elastic = resolveDragElastic(dragElastic);
	        /**
	         * If we're outputting to external MotionValues, we want to rebase the measured constraints
	         * from viewport-relative to component-relative.
	         */
	        if (this.constraints && !this.hasMutatedConstraints) {
	            eachAxis(function (axis) {
	                if (_this.getAxisMotionValue(axis)) {
	                    _this.constraints[axis] = rebaseAxisConstraints(layout[axis], _this.constraints[axis]);
	                }
	            });
	        }
	    };
	    VisualElementDragControls.prototype.resolveRefConstraints = function (layoutBox, constraints) {
	        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
	        var constraintsElement = constraints.current;
	        heyListen.invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
	        this.constraintsBox = getBoundingBox(constraintsElement, transformPagePoint);
	        var measuredConstraints = calcViewportConstraints(layoutBox, this.constraintsBox);
	        /**
	         * If there's an onMeasureDragConstraints listener we call it and
	         * if different constraints are returned, set constraints to that
	         */
	        if (onMeasureDragConstraints) {
	            var userConstraints = onMeasureDragConstraints(convertAxisBoxToBoundingBox(measuredConstraints));
	            this.hasMutatedConstraints = !!userConstraints;
	            if (userConstraints) {
	                measuredConstraints = convertBoundingBoxToAxisBox(userConstraints);
	            }
	        }
	        return measuredConstraints;
	    };
	    VisualElementDragControls.prototype.cancelDrag = function () {
	        var _a, _b;
	        this.visualElement.unlockProjectionTarget();
	        (_a = this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(this);
	        this.isDragging = false;
	        this.panSession && this.panSession.end();
	        this.panSession = null;
	        if (!this.props.dragPropagation && this.openGlobalLock) {
	            this.openGlobalLock();
	            this.openGlobalLock = null;
	        }
	        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
	    };
	    VisualElementDragControls.prototype.stop = function (event, info) {
	        var _a, _b, _c;
	        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
	        this.panSession = null;
	        var isDragging = this.isDragging;
	        this.cancelDrag();
	        if (!isDragging)
	            return;
	        var velocity = info.velocity;
	        this.animateDragEnd(velocity);
	        (_c = (_b = this.props).onDragEnd) === null || _c === void 0 ? void 0 : _c.call(_b, event, info);
	    };
	    VisualElementDragControls.prototype.snapToCursor = function (point) {
	        var _this = this;
	        return eachAxis(function (axis) {
	            var drag = _this.props.drag;
	            // If we're not dragging this axis, do an early return.
	            if (!shouldDrag(axis, drag, _this.currentDirection))
	                return;
	            var axisValue = _this.getAxisMotionValue(axis);
	            if (axisValue) {
	                var box = _this.visualElement.getLayoutState().layout;
	                var length_1 = box[axis].max - box[axis].min;
	                var center = box[axis].min + length_1 / 2;
	                var offset = point[axis] - center;
	                _this.originPoint[axis] = point[axis];
	                axisValue.set(offset);
	            }
	            else {
	                _this.cursorProgress[axis] = 0.5;
	                return true;
	            }
	        }).includes(true);
	    };
	    /**
	     * Update the specified axis with the latest pointer information.
	     */
	    VisualElementDragControls.prototype.updateAxis = function (axis, point, offset) {
	        var drag = this.props.drag;
	        // If we're not dragging this axis, do an early return.
	        if (!shouldDrag(axis, drag, this.currentDirection))
	            return;
	        return this.getAxisMotionValue(axis)
	            ? this.updateAxisMotionValue(axis, offset)
	            : this.updateVisualElementAxis(axis, point);
	    };
	    VisualElementDragControls.prototype.updateAxisMotionValue = function (axis, offset) {
	        var axisValue = this.getAxisMotionValue(axis);
	        if (!offset || !axisValue)
	            return;
	        var nextValue = this.originPoint[axis] + offset[axis];
	        var update = this.constraints
	            ? applyConstraints(nextValue, this.constraints[axis], this.elastic[axis])
	            : nextValue;
	        axisValue.set(update);
	    };
	    VisualElementDragControls.prototype.updateVisualElementAxis = function (axis, point) {
	        var _a;
	        // Get the actual layout bounding box of the element
	        var axisLayout = this.visualElement.getLayoutState().layout[axis];
	        // Calculate its current length. In the future we might want to lerp this to animate
	        // between lengths if the layout changes as we change the DOM
	        var axisLength = axisLayout.max - axisLayout.min;
	        // Get the initial progress that the pointer sat on this axis on gesture start.
	        var axisProgress = this.cursorProgress[axis];
	        // Calculate a new min point based on the latest pointer position, constraints and elastic
	        var min = calcConstrainedMinPoint(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
	        // Update the axis viewport target with this new min and the length
	        this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
	    };
	    VisualElementDragControls.prototype.setProps = function (_a) {
	        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? defaultElastic : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = tslib.__rest(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
	        this.props = tslib.__assign({ drag: drag,
	            dragDirectionLock: dragDirectionLock,
	            dragPropagation: dragPropagation,
	            dragConstraints: dragConstraints,
	            dragElastic: dragElastic,
	            dragMomentum: dragMomentum }, remainingProps);
	    };
	    /**
	     * Drag works differently depending on which props are provided.
	     *
	     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
	     * - If the component will perform layout animations, we output the gesture to the component's
	     *      visual bounding box
	     * - Otherwise, we apply the delta to the x/y motion values.
	     */
	    VisualElementDragControls.prototype.getAxisMotionValue = function (axis) {
	        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
	        var dragKey = "_drag" + axis.toUpperCase();
	        if (this.props[dragKey]) {
	            return this.props[dragKey];
	        }
	        else if (!layout && layoutId === undefined) {
	            return this.visualElement.getValue(axis, 0);
	        }
	    };
	    VisualElementDragControls.prototype.isLayoutDrag = function () {
	        return !this.getAxisMotionValue("x");
	    };
	    VisualElementDragControls.prototype.isExternalDrag = function () {
	        var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
	        return _dragX || _dragY;
	    };
	    VisualElementDragControls.prototype.animateDragEnd = function (velocity) {
	        var _this = this;
	        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
	        /**
	         * Everything beyond the drag gesture should be performed with
	         * relative projection so children stay in sync with their parent element.
	         */
	        var isRelative = convertToRelativeProjection(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
	        /**
	         * If we had previously resolved constraints relative to the viewport,
	         * we need to also convert those to a relative coordinate space for the animation
	         */
	        var constraints = this.constraints || {};
	        if (isRelative &&
	            Object.keys(constraints).length &&
	            this.isLayoutDrag()) {
	            var projectionParent = this.visualElement.getProjectionParent();
	            if (projectionParent) {
	                var relativeConstraints_1 = calcRelativeOffset(projectionParent.projection.targetFinal, constraints);
	                eachAxis(function (axis) {
	                    var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
	                    constraints[axis] = {
	                        min: isNaN(min) ? undefined : min,
	                        max: isNaN(max) ? undefined : max,
	                    };
	                });
	            }
	        }
	        var momentumAnimations = eachAxis(function (axis) {
	            var _a;
	            if (!shouldDrag(axis, drag, _this.currentDirection)) {
	                return;
	            }
	            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
	            /**
	             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
	             * of spring animations so we should look into adding a disable spring option to `inertia`.
	             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
	             * using the value of `dragElastic`.
	             */
	            var bounceStiffness = dragElastic ? 200 : 1000000;
	            var bounceDamping = dragElastic ? 40 : 10000000;
	            var inertia = tslib.__assign(tslib.__assign({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness: bounceStiffness,
	                bounceDamping: bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
	            // If we're not animating on an externally-provided `MotionValue` we can use the
	            // component's animation controls which will handle interactions with whileHover (etc),
	            // otherwise we just have to animate the `MotionValue` itself.
	            return _this.getAxisMotionValue(axis)
	                ? _this.startAxisValueAnimation(axis, inertia)
	                : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
	        });
	        // Run all animations and then resolve the new drag constraints.
	        return Promise.all(momentumAnimations).then(function () {
	            var _a, _b;
	            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
	        });
	    };
	    VisualElementDragControls.prototype.stopMotion = function () {
	        var _this = this;
	        eachAxis(function (axis) {
	            var axisValue = _this.getAxisMotionValue(axis);
	            axisValue
	                ? axisValue.stop()
	                : _this.visualElement.stopLayoutAnimation();
	        });
	    };
	    VisualElementDragControls.prototype.startAxisValueAnimation = function (axis, transition) {
	        var axisValue = this.getAxisMotionValue(axis);
	        if (!axisValue)
	            return;
	        var currentValue = axisValue.get();
	        axisValue.set(currentValue);
	        axisValue.set(currentValue); // Set twice to hard-reset velocity
	        return startAnimation(axis, axisValue, 0, transition);
	    };
	    VisualElementDragControls.prototype.scalePoint = function () {
	        var _this = this;
	        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
	        if (!isRefObject(dragConstraints) || !this.constraintsBox)
	            return;
	        // Stop any current animations as there can be some visual glitching if we resize mid animation
	        this.stopMotion();
	        // Record the relative progress of the targetBox relative to the constraintsBox
	        var boxProgress = { x: 0, y: 0 };
	        eachAxis(function (axis) {
	            boxProgress[axis] = calcOrigin(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
	        });
	        /**
	         * For each axis, calculate the current progress of the layout axis within the constraints.
	         * Then, using the latest layout and constraints measurements, reposition the new layout axis
	         * proportionally within the constraints.
	         */
	        this.updateConstraints(function () {
	            eachAxis(function (axis) {
	                if (!shouldDrag(axis, drag, null))
	                    return;
	                // Calculate the position of the targetBox relative to the constraintsBox using the
	                // previously calculated progress
	                var _a = calcPositionFromProgress(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
	                _this.visualElement.setProjectionTargetAxis(axis, min, max);
	            });
	        });
	        /**
	         * If any other draggable components are queuing the same tasks synchronously
	         * this will wait until they've all been scheduled before flushing.
	         */
	        setTimeout(flushLayout, 1);
	    };
	    VisualElementDragControls.prototype.updateConstraints = function (onReady) {
	        var _this = this;
	        this.cancelLayout = batchLayout(function (read, write) {
	            var ancestors = collectProjectingAncestors(_this.visualElement);
	            write(function () {
	                return ancestors.forEach(function (element) { return element.resetTransform(); });
	            });
	            read(function () { return updateLayoutMeasurement(_this.visualElement); });
	            write(function () {
	                return ancestors.forEach(function (element) { return element.restoreTransform(); });
	            });
	            read(function () {
	                _this.resolveDragConstraints();
	            });
	            if (onReady)
	                write(onReady);
	        });
	    };
	    VisualElementDragControls.prototype.mount = function (visualElement) {
	        var _this = this;
	        var element = visualElement.getInstance();
	        /**
	         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
	         */
	        var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
	            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
	            drag && dragListener && _this.start(event);
	        });
	        /**
	         * Attach a window resize listener to scale the draggable target within its defined
	         * constraints as the window resizes.
	         */
	        var stopResizeListener = addDomEvent(window, "resize", function () {
	            _this.scalePoint();
	        });
	        /**
	         * Ensure drag constraints are resolved correctly relative to the dragging element
	         * whenever its layout changes.
	         */
	        var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function () {
	            if (_this.isDragging) {
	                _this.resolveDragConstraints();
	            }
	        });
	        /**
	         * If the previous component with this same layoutId was dragging at the time
	         * it was unmounted, we want to continue the same gesture on this component.
	         */
	        var prevDragCursor = visualElement.prevDragCursor;
	        if (prevDragCursor) {
	            this.start(lastPointerEvent, { cursorProgress: prevDragCursor });
	        }
	        /**
	         * Return a function that will teardown the drag gesture
	         */
	        return function () {
	            stopPointerListener === null || stopPointerListener === void 0 ? void 0 : stopPointerListener();
	            stopResizeListener === null || stopResizeListener === void 0 ? void 0 : stopResizeListener();
	            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
	            _this.cancelDrag();
	        };
	    };
	    return VisualElementDragControls;
	}());
	function shouldDrag(direction, drag, currentDirection) {
	    return ((drag === true || drag === direction) &&
	        (currentDirection === null || currentDirection === direction));
	}
	/**
	 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
	 * than the provided threshold, return `null`.
	 *
	 * @param offset - The x/y offset from origin.
	 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
	 */
	function getCurrentDirection(offset, lockThreshold) {
	    if (lockThreshold === void 0) { lockThreshold = 10; }
	    var direction = null;
	    if (Math.abs(offset.y) > lockThreshold) {
	        direction = "y";
	    }
	    else if (Math.abs(offset.x) > lockThreshold) {
	        direction = "x";
	    }
	    return direction;
	}
	
	/**
	 * A hook that allows an element to be dragged.
	 *
	 * @internal
	 */
	function useDrag(props) {
	    var groupDragControls = props.dragControls, visualElement = props.visualElement;
	    var transformPagePoint = React.useContext(MotionConfigContext).transformPagePoint;
	    var dragControls = useConstant(function () {
	        return new VisualElementDragControls({
	            visualElement: visualElement,
	        });
	    });
	    dragControls.setProps(tslib.__assign(tslib.__assign({}, props), { transformPagePoint: transformPagePoint }));
	    // If we've been provided a DragControls for manual control over the drag gesture,
	    // subscribe this component to it on mount.
	    React.useEffect(function () { return groupDragControls && groupDragControls.subscribe(dragControls); }, [dragControls]);
	    // Mount the drag controls with the visualElement
	    React.useEffect(function () { return dragControls.mount(visualElement); }, []);
	}
	
	/**
	 *
	 * @param handlers -
	 * @param ref -
	 *
	 * @internalremarks
	 * Currently this sets new pan gesture functions every render. The memo route has been explored
	 * in the past but ultimately we're still creating new functions every render. An optimisation
	 * to explore is creating the pan gestures and loading them into a `ref`.
	 *
	 * @internal
	 */
	function usePanGesture(_a) {
	    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
	    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
	    var panSession = React.useRef(null);
	    var transformPagePoint = React.useContext(MotionConfigContext).transformPagePoint;
	    var handlers = {
	        onSessionStart: onPanSessionStart,
	        onStart: onPanStart,
	        onMove: onPan,
	        onEnd: function (event, info) {
	            panSession.current = null;
	            onPanEnd && onPanEnd(event, info);
	        },
	    };
	    React.useEffect(function () {
	        if (panSession.current !== null) {
	            panSession.current.updateHandlers(handlers);
	        }
	    });
	    function onPointerDown(event) {
	        panSession.current = new PanSession(event, handlers, {
	            transformPagePoint: transformPagePoint,
	        });
	    }
	    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
	    useUnmountEffect(function () { return panSession.current && panSession.current.end(); });
	}
	
	var drag = {
	    pan: makeRenderlessComponent(usePanGesture),
	    drag: makeRenderlessComponent(useDrag),
	};
	
	/**
	 * @public
	 */
	var Presence;
	(function (Presence) {
	    Presence[Presence["Entering"] = 0] = "Entering";
	    Presence[Presence["Present"] = 1] = "Present";
	    Presence[Presence["Exiting"] = 2] = "Exiting";
	})(Presence || (Presence = {}));
	/**
	 * @public
	 */
	exports.VisibilityAction = void 0;
	(function (VisibilityAction) {
	    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
	    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
	})(exports.VisibilityAction || (exports.VisibilityAction = {}));
	
	function isCSSVariable(value) {
	    return typeof value === "string" && value.startsWith("var(--");
	}
	/**
	 * Parse Framer's special CSS variable format into a CSS token and a fallback.
	 *
	 * ```
	 * `var(--foo, #fff)` => [`--foo`, '#fff']
	 * ```
	 *
	 * @param current
	 */
	var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
	function parseCSSVariable(current) {
	    var match = cssVariableRegex.exec(current);
	    if (!match)
	        return [,];
	    var _a = tslib.__read(match, 3), token = _a[1], fallback = _a[2];
	    return [token, fallback];
	}
	var maxDepth = 4;
	function getVariableValue(current, element, depth) {
	    if (depth === void 0) { depth = 1; }
	    heyListen.invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");
	    var _a = tslib.__read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
	    // No CSS variable detected
	    if (!token)
	        return;
	    // Attempt to read this CSS variable off the element
	    var resolved = window.getComputedStyle(element).getPropertyValue(token);
	    if (resolved) {
	        return resolved.trim();
	    }
	    else if (isCSSVariable(fallback)) {
	        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
	        return getVariableValue(fallback, element, depth + 1);
	    }
	    else {
	        return fallback;
	    }
	}
	/**
	 * Resolve CSS variables from
	 *
	 * @internal
	 */
	function resolveCSSVariables(visualElement, _a, transitionEnd) {
	    var _b;
	    var target = tslib.__rest(_a, []);
	    var element = visualElement.getInstance();
	    if (!(element instanceof HTMLElement))
	        return { target: target, transitionEnd: transitionEnd };
	    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
	    // only if they change but I think this reads clearer and this isn't a performance-critical path.
	    if (transitionEnd) {
	        transitionEnd = tslib.__assign({}, transitionEnd);
	    }
	    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
	    visualElement.forEachValue(function (value) {
	        var current = value.get();
	        if (!isCSSVariable(current))
	            return;
	        var resolved = getVariableValue(current, element);
	        if (resolved)
	            value.set(resolved);
	    });
	    // Cycle through every target property and resolve CSS variables. Currently
	    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
	    for (var key in target) {
	        var current = target[key];
	        if (!isCSSVariable(current))
	            continue;
	        var resolved = getVariableValue(current, element);
	        if (!resolved)
	            continue;
	        // Clone target if it hasn't already been
	        target[key] = resolved;
	        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
	        // CSS variable. This will ensure that after the animation the component will reflect
	        // changes in the value of the CSS variable.
	        if (transitionEnd)
	            (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : (transitionEnd[key] = current);
	    }
	    return { target: target, transitionEnd: transitionEnd };
	}
	
	function pixelsToPercent(pixels, axis) {
	    return (pixels / (axis.max - axis.min)) * 100;
	}
	/**
	 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
	 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
	 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
	 * borderRadius in both states. If we animate between the two in pixels that will trigger
	 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
	 */
	function correctBorderRadius(latest, _layoutState, _a) {
	    var target = _a.target;
	    /**
	     * If latest is a string, if it's a percentage we can return immediately as it's
	     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
	     */
	    if (typeof latest === "string") {
	        if (styleValueTypes.px.test(latest)) {
	            latest = parseFloat(latest);
	        }
	        else {
	            return latest;
	        }
	    }
	    /**
	     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
	     * pixel value as a percentage of each axis
	     */
	    var x = pixelsToPercent(latest, target.x);
	    var y = pixelsToPercent(latest, target.y);
	    return x + "% " + y + "%";
	}
	var varToken = "_$css";
	function correctBoxShadow(latest, _a) {
	    var delta = _a.delta, treeScale = _a.treeScale;
	    var original = latest;
	    /**
	     * We need to first strip and store CSS variables from the string.
	     */
	    var containsCSSVariables = latest.includes("var(");
	    var cssVariables = [];
	    if (containsCSSVariables) {
	        latest = latest.replace(cssVariableRegex, function (match) {
	            cssVariables.push(match);
	            return varToken;
	        });
	    }
	    var shadow = styleValueTypes.complex.parse(latest);
	    // TODO: Doesn't support multiple shadows
	    if (shadow.length > 5)
	        return original;
	    var template = styleValueTypes.complex.createTransformer(latest);
	    var offset = typeof shadow[0] !== "number" ? 1 : 0;
	    // Calculate the overall context scale
	    var xScale = delta.x.scale * treeScale.x;
	    var yScale = delta.y.scale * treeScale.y;
	    shadow[0 + offset] /= xScale;
	    shadow[1 + offset] /= yScale;
	    /**
	     * Ideally we'd correct x and y scales individually, but because blur and
	     * spread apply to both we have to take a scale average and apply that instead.
	     * We could potentially improve the outcome of this by incorporating the ratio between
	     * the two scales.
	     */
	    var averageScale = popmotion.mix(xScale, yScale, 0.5);
	    // Blur
	    if (typeof shadow[2 + offset] === "number")
	        shadow[2 + offset] /= averageScale;
	    // Spread
	    if (typeof shadow[3 + offset] === "number")
	        shadow[3 + offset] /= averageScale;
	    var output = template(shadow);
	    if (containsCSSVariables) {
	        var i_1 = 0;
	        output = output.replace(varToken, function () {
	            var cssVariable = cssVariables[i_1];
	            i_1++;
	            return cssVariable;
	        });
	    }
	    return output;
	}
	var borderCorrectionDefinition = {
	    process: correctBorderRadius,
	};
	var defaultScaleCorrectors = {
	    borderRadius: tslib.__assign(tslib.__assign({}, borderCorrectionDefinition), { applyTo: [
	            "borderTopLeftRadius",
	            "borderTopRightRadius",
	            "borderBottomLeftRadius",
	            "borderBottomRightRadius",
	        ] }),
	    borderTopLeftRadius: borderCorrectionDefinition,
	    borderTopRightRadius: borderCorrectionDefinition,
	    borderBottomLeftRadius: borderCorrectionDefinition,
	    borderBottomRightRadius: borderCorrectionDefinition,
	    boxShadow: {
	        process: correctBoxShadow,
	    },
	};
	
	var progressTarget = 1000;
	var Animate = /** @class */ (function (_super) {
	    tslib.__extends(Animate, _super);
	    function Animate() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * A mutable object that tracks the target viewport box
	         * for the current animation frame.
	         */
	        _this.frameTarget = axisBox();
	        /**
	         * The current animation target, we use this to check whether to start
	         * a new animation or continue the existing one.
	         */
	        _this.currentAnimationTarget = axisBox();
	        /**
	         * Track whether we're animating this axis.
	         */
	        _this.isAnimating = {
	            x: false,
	            y: false,
	        };
	        _this.stopAxisAnimation = {
	            x: undefined,
	            y: undefined,
	        };
	        _this.isAnimatingTree = false;
	        _this.animate = function (target, origin, _a) {
	            if (_a === void 0) { _a = {}; }
	            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = tslib.__rest(_a, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]);
	            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
	            /**
	             * Early return if we've been instructed not to animate this render.
	             */
	            if (shouldStackAnimate === false) {
	                _this.isAnimatingTree = false;
	                return _this.safeToRemove();
	            }
	            /**
	             * Prioritise tree animations
	             */
	            if (_this.isAnimatingTree && shouldStackAnimate !== true) {
	                return;
	            }
	            else if (shouldStackAnimate) {
	                _this.isAnimatingTree = true;
	            }
	            /**
	             * Allow the measured origin (prev bounding box) and target (actual layout) to be
	             * overridden by the provided config.
	             */
	            origin = originBox || origin;
	            target = targetBox || target;
	            /**
	             * If this element has a projecting parent, there's an opportunity to animate
	             * it relatively to that parent rather than relatively to the viewport. This
	             * allows us to add orchestrated animations.
	             */
	            var isRelative = false;
	            var projectionParent = visualElement.getProjectionParent();
	            if (projectionParent) {
	                var prevParentViewportBox = projectionParent.prevViewportBox;
	                var parentLayout = projectionParent.getLayoutState().layout;
	                /**
	                 * If we're being provided a previous parent VisualElement by AnimateSharedLayout
	                 */
	                if (prevParent) {
	                    /**
	                     * If we've been provided an explicit target box it means we're animating back
	                     * to this previous parent. So we can make a relative box by comparing to the previous
	                     * parent's layout
	                     */
	                    if (targetBox) {
	                        parentLayout = prevParent.getLayoutState().layout;
	                    }
	                    /**
	                     * Likewise if we've been provided an explicit origin box it means we're
	                     * animating out from a different element. So we should figure out where that was
	                     * on screen relative to the new parent element.
	                     */
	                    if (originBox &&
	                        !checkIfParentHasChanged(prevParent, projectionParent) &&
	                        prevParent.prevViewportBox) {
	                        prevParentViewportBox = prevParent.prevViewportBox;
	                    }
	                }
	                if (prevParentViewportBox &&
	                    isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
	                    isRelative = true;
	                    origin = calcRelativeOffset(prevParentViewportBox, origin);
	                    target = calcRelativeOffset(parentLayout, target);
	                }
	            }
	            var boxHasMoved = hasMoved(origin, target);
	            var animations = eachAxis(function (axis) {
	                var _a, _b;
	                /**
	                 * If layout is set to "position", we can resize the origin box based on the target
	                 * box and only animate its position.
	                 */
	                if (layout === "position") {
	                    var targetLength = target[axis].max - target[axis].min;
	                    origin[axis].max = origin[axis].min + targetLength;
	                }
	                if (visualElement.projection.isTargetLocked) {
	                    return;
	                }
	                else if (visibilityAction !== undefined) {
	                    visualElement.setVisibility(visibilityAction === exports.VisibilityAction.Show);
	                }
	                else if (boxHasMoved) {
	                    // If the box has moved, animate between it's current visual state and its
	                    // final state
	                    return _this.animateAxis(axis, target[axis], origin[axis], tslib.__assign(tslib.__assign({}, config), { isRelative: isRelative }));
	                }
	                else {
	                    (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
	                    // If the box has remained in the same place, immediately set the axis target
	                    // to the final desired state
	                    return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
	                }
	            });
	            // Force a render to ensure there's no flash of uncorrected bounding box.
	            visualElement.syncRender();
	            /**
	             * If this visualElement isn't present (ie it's been removed from the tree by the user but
	             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
	             * have successfully finished.
	             */
	            return Promise.all(animations).then(function () {
	                _this.isAnimatingTree = false;
	                onComplete && onComplete();
	                visualElement.notifyLayoutAnimationComplete();
	            });
	        };
	        return _this;
	    }
	    Animate.prototype.componentDidMount = function () {
	        var _this = this;
	        var visualElement = this.props.visualElement;
	        visualElement.animateMotionValue = startAnimation;
	        visualElement.enableLayoutProjection();
	        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
	        visualElement.layoutSafeToRemove = function () { return _this.safeToRemove(); };
	        addScaleCorrection(defaultScaleCorrectors);
	    };
	    Animate.prototype.componentWillUnmount = function () {
	        var _this = this;
	        this.unsubLayoutReady();
	        eachAxis(function (axis) { var _a, _b; return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a); });
	    };
	    /**
	     * TODO: This manually performs animations on the visualElement's layout progress
	     * values. It'd be preferable to amend the startLayoutAxisAnimation
	     * API to accept more custom animations like this.
	     */
	    Animate.prototype.animateAxis = function (axis, target, origin, _a) {
	        var _this = this;
	        var _b, _c;
	        var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
	        /**
	         * If we're not animating to a new target, don't run this animation
	         */
	        if (this.isAnimating[axis] &&
	            axisIsEqual(target, this.currentAnimationTarget[axis])) {
	            return;
	        }
	        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 ? void 0 : _c.call(_b);
	        this.isAnimating[axis] = true;
	        var visualElement = this.props.visualElement;
	        var frameTarget = this.frameTarget[axis];
	        var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
	        /**
	         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
	         * be re-incoporated into a subsequent spring animation.
	         */
	        layoutProgress.clearListeners();
	        layoutProgress.set(0);
	        layoutProgress.set(0);
	        /**
	         * Create an animation function to run once per frame. This will tween the visual bounding box from
	         * origin to target using the latest progress value.
	         */
	        var frame = function () {
	            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
	            var p = layoutProgress.get() / progressTarget;
	            // Tween the axis and update the visualElement with the latest values
	            tweenAxis(frameTarget, origin, target, p);
	            visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
	        };
	        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
	        frame();
	        // Create a function to stop animation on this specific axis
	        var unsubscribeProgress = layoutProgress.onChange(frame);
	        this.stopAxisAnimation[axis] = function () {
	            _this.isAnimating[axis] = false;
	            layoutProgress.stop();
	            unsubscribeProgress();
	        };
	        this.currentAnimationTarget[axis] = target;
	        var layoutTransition = transition ||
	            visualElement.getDefaultTransition() ||
	            defaultLayoutTransition;
	        // Start the animation on this axis
	        var animation = startAnimation(axis === "x" ? "layoutX" : "layoutY", layoutProgress, progressTarget, layoutTransition && getValueTransition(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
	        return animation;
	    };
	    Animate.prototype.safeToRemove = function () {
	        var _a, _b;
	        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 ? void 0 : _b.call(_a);
	    };
	    Animate.prototype.render = function () {
	        return null;
	    };
	    return Animate;
	}(React__namespace.Component));
	function AnimateLayoutContextProvider(props) {
	    var _a = tslib.__read(usePresence(), 2), safeToRemove = _a[1];
	    return React__namespace.createElement(Animate, tslib.__assign({}, props, { safeToRemove: safeToRemove }));
	}
	function hasMoved(a, b) {
	    return (!isZeroBox(a) &&
	        !isZeroBox(b) &&
	        (!axisIsEqual(a.x, b.x) || !axisIsEqual(a.y, b.y)));
	}
	var zeroAxis = { min: 0, max: 0 };
	function isZeroBox(a) {
	    return axisIsEqual(a.x, zeroAxis) && axisIsEqual(a.y, zeroAxis);
	}
	function axisIsEqual(a, b) {
	    return a.min === b.min && a.max === b.max;
	}
	var defaultLayoutTransition = {
	    duration: 0.45,
	    ease: [0.4, 0, 0.1, 1],
	};
	function isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
	    return prevParent || (!prevParent && !(originBox || targetBox));
	}
	
	/**
	 * Default handlers for batching VisualElements
	 */
	var defaultHandler = {
	    layoutReady: function (child) { return child.notifyLayoutReady(); },
	};
	/**
	 * Create a batcher to process VisualElements
	 */
	function createBatcher() {
	    var queue = new Set();
	    return {
	        add: function (child) { return queue.add(child); },
	        flush: function (_a) {
	            var _b = _a === void 0 ? defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
	            batchLayout(function (read, write) {
	                var order = Array.from(queue).sort(compareByDepth);
	                var ancestors = parent
	                    ? collectProjectingAncestors(parent)
	                    : [];
	                write(function () {
	                    var allElements = tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(ancestors)), tslib.__read(order));
	                    allElements.forEach(function (element) { return element.resetTransform(); });
	                });
	                read(function () {
	                    order.forEach(updateLayoutMeasurement);
	                });
	                write(function () {
	                    ancestors.forEach(function (element) { return element.restoreTransform(); });
	                    order.forEach(layoutReady);
	                });
	                read(function () {
	                    /**
	                     * After all children have started animating, ensure any Entering components are set to Present.
	                     * If we add deferred animations (set up all animations and then start them in two loops) this
	                     * could be moved to the start loop. But it needs to happen after all the animations configs
	                     * are generated in AnimateSharedLayout as this relies on presence data
	                     */
	                    order.forEach(function (child) {
	                        if (child.isPresent)
	                            child.presence = Presence.Present;
	                    });
	                });
	                write(function () {
	                    /**
	                     * Starting these animations will have queued jobs on the frame loop. In some situations,
	                     * like when removing an element, these will be processed too late after the DOM is manipulated,
	                     * leaving a flash of incorrectly-projected content. By manually flushing these jobs
	                     * we ensure there's no flash.
	                     */
	                    sync.flushSync.preRender();
	                    sync.flushSync.render();
	                });
	                read(function () {
	                    /**
	                     * Schedule a callback at the end of the following frame to assign the latest projection
	                     * box to the prevViewportBox snapshot. Once global batching is in place this could be run
	                     * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
	                     * child attempts to calculate its previous relative position against a prevViewportBox
	                     * it will be against its latest projection box instead, as the snapshot is useless beyond this
	                     * render.
	                     */
	                    sync__default['default'].postRender(function () {
	                        return order.forEach(assignProjectionToSnapshot);
	                    });
	                    queue.clear();
	                });
	            });
	            // TODO: Need to find a layout-synchronous way of flushing this
	            flushLayout();
	        },
	    };
	}
	function assignProjectionToSnapshot(child) {
	    child.prevViewportBox = child.projection.target;
	}
	
	var SharedLayoutContext = React.createContext(createBatcher());
	/**
	 * @internal
	 */
	var FramerTreeLayoutContext = React.createContext(createBatcher());
	function isSharedLayout(context) {
	    return !!context.forceUpdate;
	}
	
	/**
	 * This component is responsible for scheduling the measuring of the motion component
	 */
	var Measure = /** @class */ (function (_super) {
	    tslib.__extends(Measure, _super);
	    function Measure() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * If this is a child of a SyncContext, register the VisualElement with it on mount.
	     */
	    Measure.prototype.componentDidMount = function () {
	        var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
	        isSharedLayout(syncLayout) && syncLayout.register(visualElement);
	        isSharedLayout(framerSyncLayout) &&
	            framerSyncLayout.register(visualElement);
	        visualElement.onUnmount(function () {
	            if (isSharedLayout(syncLayout)) {
	                syncLayout.remove(visualElement);
	            }
	            if (isSharedLayout(framerSyncLayout)) {
	                framerSyncLayout.remove(visualElement);
	            }
	        });
	    };
	    /**
	     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
	     * handle the snapshotting.
	     *
	     * If it is stand-alone component, add it to the batcher.
	     */
	    Measure.prototype.getSnapshotBeforeUpdate = function () {
	        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
	        if (isSharedLayout(syncLayout)) {
	            syncLayout.syncUpdate();
	        }
	        else {
	            snapshotViewportBox(visualElement);
	            syncLayout.add(visualElement);
	        }
	        return null;
	    };
	    Measure.prototype.componentDidUpdate = function () {
	        var syncLayout = this.props.syncLayout;
	        if (!isSharedLayout(syncLayout))
	            syncLayout.flush();
	    };
	    Measure.prototype.render = function () {
	        return null;
	    };
	    return Measure;
	}(React__default['default'].Component));
	function MeasureContextProvider(props) {
	    var syncLayout = React.useContext(SharedLayoutContext);
	    var framerSyncLayout = React.useContext(FramerTreeLayoutContext);
	    return (React__default['default'].createElement(Measure, tslib.__assign({}, props, { syncLayout: syncLayout, framerSyncLayout: framerSyncLayout })));
	}
	
	var layoutAnimations = {
	    measureLayout: MeasureContextProvider,
	    layoutAnimation: AnimateLayoutContextProvider,
	};
	
	var createProjectionState = function () { return ({
	    isEnabled: false,
	    isHydrated: false,
	    isTargetLocked: false,
	    target: axisBox(),
	    targetFinal: axisBox(),
	}); };
	function createLayoutState() {
	    return {
	        isHydrated: false,
	        layout: axisBox(),
	        layoutCorrected: axisBox(),
	        treeScale: { x: 1, y: 1 },
	        delta: delta(),
	        deltaFinal: delta(),
	        deltaTransform: "",
	    };
	}
	var zeroLayout = createLayoutState();
	
	/**
	 * Build a transform style that takes a calculated delta between the element's current
	 * space on screen and projects it into the desired space.
	 */
	function buildLayoutProjectionTransform(_a, treeScale, latestTransform) {
	    var x = _a.x, y = _a.y;
	    /**
	     * The translations we use to calculate are always relative to the viewport coordinate space.
	     * But when we apply scales, we also scale the coordinate space of an element and its children.
	     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
	     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
	     */
	    var xTranslate = x.translate / treeScale.x;
	    var yTranslate = y.translate / treeScale.y;
	    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
	    if (latestTransform) {
	        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
	        if (rotate)
	            transform += "rotate(" + rotate + ") ";
	        if (rotateX)
	            transform += "rotateX(" + rotateX + ") ";
	        if (rotateY)
	            transform += "rotateY(" + rotateY + ") ";
	    }
	    transform += "scale(" + x.scale + ", " + y.scale + ")";
	    return !latestTransform && transform === identityProjection ? "" : transform;
	}
	/**
	 * Take the calculated delta origin and apply it as a transform string.
	 */
	function buildLayoutProjectionTransformOrigin(_a) {
	    var deltaFinal = _a.deltaFinal;
	    return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
	}
	var identityProjection = buildLayoutProjectionTransform(zeroLayout.delta, zeroLayout.treeScale, { x: 1, y: 1 });
	
	var names = [
	    "LayoutMeasure",
	    "BeforeLayoutMeasure",
	    "LayoutUpdate",
	    "ViewportBoxUpdate",
	    "Update",
	    "Render",
	    "AnimationComplete",
	    "LayoutAnimationComplete",
	    "AnimationStart",
	    "SetAxisTarget",
	    "Unmount",
	];
	function createLifecycles() {
	    var managers = names.map(function () { return new SubscriptionManager(); });
	    var propSubscriptions = {};
	    var lifecycles = {
	        clearAllListeners: function () { return managers.forEach(function (manager) { return manager.clear(); }); },
	        updatePropListeners: function (props) {
	            return names.forEach(function (name) {
	                var _a;
	                (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
	                var on = "on" + name;
	                var propListener = props[on];
	                if (propListener) {
	                    propSubscriptions[name] = lifecycles[on](propListener);
	                }
	            });
	        },
	    };
	    managers.forEach(function (manager, i) {
	        lifecycles["on" + names[i]] = function (handler) { return manager.add(handler); };
	        lifecycles["notify" + names[i]] = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return manager.notify.apply(manager, tslib.__spreadArray([], tslib.__read(args)));
	        };
	    });
	    return lifecycles;
	}
	
	function updateMotionValuesFromProps(element, next, prev) {
	    var _a;
	    for (var key in next) {
	        var nextValue = next[key];
	        var prevValue = prev[key];
	        if (isMotionValue(nextValue)) {
	            /**
	             * If this is a motion value found in props or style, we want to add it
	             * to our visual element's motion value map.
	             */
	            element.addValue(key, nextValue);
	        }
	        else if (isMotionValue(prevValue)) {
	            /**
	             * If we're swapping to a new motion value, create a new motion value
	             * from that
	             */
	            element.addValue(key, motionValue(nextValue));
	        }
	        else if (prevValue !== nextValue) {
	            /**
	             * If this is a flat value that has changed, update the motion value
	             * or create one if it doesn't exist. We only want to do this if we're
	             * not handling the value with our animation state.
	             */
	            if (element.hasValue(key)) {
	                var existingValue = element.getValue(key);
	                // TODO: Only update values that aren't being animated or even looked at
	                !existingValue.hasAnimated && existingValue.set(nextValue);
	            }
	            else {
	                element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
	            }
	        }
	    }
	    // Handle removed values
	    for (var key in prev) {
	        if (next[key] === undefined)
	            element.removeValue(key);
	    }
	    return next;
	}
	
	function updateLayoutDeltas(_a, _b, treePath, transformOrigin) {
	    var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
	    var target = _b.target;
	    /**
	     * Reset the corrected box with the latest values from box, as we're then going
	     * to perform mutative operations on it.
	     */
	    resetBox(layoutCorrected, layout);
	    /**
	     * Apply all the parent deltas to this box to produce the corrected box. This
	     * is the layout box, as it will appear on screen as a result of the transforms of its parents.
	     */
	    applyTreeDeltas(layoutCorrected, treeScale, treePath);
	    /**
	     * Update the delta between the corrected box and the target box before user-set transforms were applied.
	     * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
	     * for our layout reprojection, but still allow them to be scaled correctly by the user.
	     * It might be that to simplify this we may want to accept that user-set scale is also corrected
	     * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
	     * to allow people to choose whether these styles are corrected based on just the
	     * layout reprojection or the final bounding box.
	     */
	    updateBoxDelta(delta, layoutCorrected, target, transformOrigin);
	}
	
	var FlatTree = /** @class */ (function () {
	    function FlatTree() {
	        this.children = [];
	        this.isDirty = false;
	    }
	    FlatTree.prototype.add = function (child) {
	        addUniqueItem(this.children, child);
	        this.isDirty = true;
	    };
	    FlatTree.prototype.remove = function (child) {
	        removeItem(this.children, child);
	        this.isDirty = true;
	    };
	    FlatTree.prototype.forEach = function (callback) {
	        this.isDirty && this.children.sort(compareByDepth);
	        this.isDirty = false;
	        this.children.forEach(callback);
	    };
	    return FlatTree;
	}());
	
	function setCurrentViewportBox(visualElement) {
	    var projectionParent = visualElement.getProjectionParent();
	    if (!projectionParent) {
	        visualElement.rebaseProjectionTarget();
	        return;
	    }
	    var relativeOffset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
	    eachAxis(function (axis) {
	        visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
	    });
	}
	
	var visualElement = function (_a) {
	    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
	    return function (_a, options) {
	        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
	        if (options === void 0) { options = {}; }
	        var latestValues = visualState.latestValues, renderState = visualState.renderState;
	        /**
	         * The instance of the render-specific node that will be hydrated by the
	         * exposed React ref. So for example, this visual element can host a
	         * HTMLElement, plain object, or Three.js object. The functions provided
	         * in VisualElementConfig allow us to interface with this instance.
	         */
	        var instance;
	        /**
	         * Manages the subscriptions for a visual element's lifecycle, for instance
	         * onRender and onViewportBoxUpdate.
	         */
	        var lifecycles = createLifecycles();
	        /**
	         *
	         */
	        var projection = createProjectionState();
	        /**
	         * A reference to the nearest projecting parent. This is either
	         * undefined if we haven't looked for the nearest projecting parent,
	         * false if there is no parent performing layout projection, or a reference
	         * to the projecting parent.
	         */
	        var projectionParent;
	        /**
	         * This is a reference to the visual state of the "lead" visual element.
	         * Usually, this will be this visual element. But if it shares a layoutId
	         * with other visual elements, only one of them will be designated lead by
	         * AnimateSharedLayout. All the other visual elements will take on the visual
	         * appearance of the lead while they crossfade to it.
	         */
	        var leadProjection = projection;
	        var leadLatestValues = latestValues;
	        var unsubscribeFromLeadVisualElement;
	        /**
	         * The latest layout measurements and calculated projections. This
	         * is seperate from the target projection data in visualState as
	         * many visual elements might point to the same piece of visualState as
	         * a target, whereas they might each have different layouts and thus
	         * projection calculations needed to project into the same viewport box.
	         */
	        var layoutState = createLayoutState();
	        /**
	         *
	         */
	        var crossfader;
	        /**
	         * Keep track of whether the viewport box has been updated since the
	         * last time the layout projection was re-calculated.
	         */
	        var hasViewportBoxUpdated = false;
	        /**
	         * A map of all motion values attached to this visual element. Motion
	         * values are source of truth for any given animated value. A motion
	         * value might be provided externally by the component via props.
	         */
	        var values = new Map();
	        /**
	         * A map of every subscription that binds the provided or generated
	         * motion values onChange listeners to this visual element.
	         */
	        var valueSubscriptions = new Map();
	        /**
	         * A reference to the previously-provided motion values as returned
	         * from scrapeMotionValuesFromProps. We use the keys in here to determine
	         * if any motion values need to be removed after props are updated.
	         */
	        var prevMotionValues = {};
	        /**
	         * x/y motion values that track the progress of initiated layout
	         * animations.
	         *
	         * TODO: Target for removal
	         */
	        var projectionTargetProgress;
	        /**
	         * When values are removed from all animation props we need to search
	         * for a fallback value to animate to. These values are tracked in baseTarget.
	         */
	        var baseTarget = tslib.__assign({}, latestValues);
	        // Internal methods ========================
	        /**
	         * On mount, this will be hydrated with a callback to disconnect
	         * this visual element from its parent on unmount.
	         */
	        var removeFromVariantTree;
	        /**
	         *
	         */
	        function render() {
	            if (!instance)
	                return;
	            if (element.isProjectionReady()) {
	                /**
	                 * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
	                 * This is the final box that we will then project into by calculating a transform delta and
	                 * applying it to the corrected box.
	                 */
	                applyBoxTransforms(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
	                /**
	                 * Update the delta between the corrected box and the final target box, after
	                 * user-set transforms are applied to it. This will be used by the renderer to
	                 * create a transform style that will reproject the element from its actual layout
	                 * into the desired bounding box.
	                 */
	                updateBoxDelta(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
	            }
	            triggerBuild();
	            renderInstance(instance, renderState);
	        }
	        function triggerBuild() {
	            var valuesToRender = latestValues;
	            if (crossfader && crossfader.isActive()) {
	                var crossfadedValues = crossfader.getCrossfadeState(element);
	                if (crossfadedValues)
	                    valuesToRender = crossfadedValues;
	            }
	            build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
	        }
	        function update() {
	            lifecycles.notifyUpdate(latestValues);
	        }
	        function updateLayoutProjection() {
	            if (!element.isProjectionReady())
	                return;
	            var delta = layoutState.delta, treeScale = layoutState.treeScale;
	            var prevTreeScaleX = treeScale.x;
	            var prevTreeScaleY = treeScale.y;
	            var prevDeltaTransform = layoutState.deltaTransform;
	            updateLayoutDeltas(layoutState, leadProjection, element.path, latestValues);
	            hasViewportBoxUpdated &&
	                element.notifyViewportBoxUpdate(leadProjection.target, delta);
	            hasViewportBoxUpdated = false;
	            var deltaTransform = buildLayoutProjectionTransform(delta, treeScale);
	            if (deltaTransform !== prevDeltaTransform ||
	                // Also compare calculated treeScale, for values that rely on this only for scale correction
	                prevTreeScaleX !== treeScale.x ||
	                prevTreeScaleY !== treeScale.y) {
	                element.scheduleRender();
	            }
	            layoutState.deltaTransform = deltaTransform;
	        }
	        function updateTreeLayoutProjection() {
	            element.layoutTree.forEach(fireUpdateLayoutProjection);
	        }
	        /**
	         *
	         */
	        function bindToMotionValue(key, value) {
	            var removeOnChange = value.onChange(function (latestValue) {
	                latestValues[key] = latestValue;
	                props.onUpdate && sync__default['default'].update(update, false, true);
	            });
	            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
	            valueSubscriptions.set(key, function () {
	                removeOnChange();
	                removeOnRenderRequest();
	            });
	        }
	        /**
	         * Any motion values that are provided to the element when created
	         * aren't yet bound to the element, as this would technically be impure.
	         * However, we iterate through the motion values and set them to the
	         * initial values for this component.
	         *
	         * TODO: This is impure and we should look at changing this to run on mount.
	         * Doing so will break some tests but this isn't neccessarily a breaking change,
	         * more a reflection of the test.
	         */
	        var initialMotionValues = scrapeMotionValuesFromProps(props);
	        for (var key in initialMotionValues) {
	            var value = initialMotionValues[key];
	            if (latestValues[key] !== undefined && isMotionValue(value)) {
	                value.set(latestValues[key], false);
	            }
	        }
	        /**
	         * Determine what role this visual element should take in the variant tree.
	         */
	        var isControllingVariants = checkIfControllingVariants(props);
	        var isVariantNode = checkIfVariantNode(props);
	        var element = tslib.__assign(tslib.__assign({ treeType: treeType, 
	            /**
	             * This is a mirror of the internal instance prop, which keeps
	             * VisualElement type-compatible with React's RefObject.
	             */
	            current: null, 
	            /**
	             * The depth of this visual element within the visual element tree.
	             */
	            depth: parent ? parent.depth + 1 : 0, parent: parent, children: new Set(), 
	            /**
	             * An ancestor path back to the root visual element. This is used
	             * by layout projection to quickly recurse back up the tree.
	             */
	            path: parent ? tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(parent.path)), [parent]) : [], layoutTree: parent ? parent.layoutTree : new FlatTree(), 
	            /**
	             *
	             */
	            presenceId: presenceId,
	            projection: projection, 
	            /**
	             * If this component is part of the variant tree, it should track
	             * any children that are also part of the tree. This is essentially
	             * a shadow tree to simplify logic around how to stagger over children.
	             */
	            variantChildren: isVariantNode ? new Set() : undefined, 
	            /**
	             * Whether this instance is visible. This can be changed imperatively
	             * by AnimateSharedLayout, is analogous to CSS's visibility in that
	             * hidden elements should take up layout, and needs enacting by the configured
	             * render function.
	             */
	            isVisible: undefined, 
	            /**
	             * Normally, if a component is controlled by a parent's variants, it can
	             * rely on that ancestor to trigger animations further down the tree.
	             * However, if a component is created after its parent is mounted, the parent
	             * won't trigger that mount animation so the child needs to.
	             *
	             * TODO: This might be better replaced with a method isParentMounted
	             */
	            manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()), 
	            /**
	             * This can be set by AnimatePresence to force components that mount
	             * at the same time as it to mount as if they have initial={false} set.
	             */
	            blockInitialAnimation: blockInitialAnimation, 
	            /**
	             * Determine whether this component has mounted yet. This is mostly used
	             * by variant children to determine whether they need to trigger their
	             * own animations on mount.
	             */
	            isMounted: function () { return Boolean(instance); }, mount: function (newInstance) {
	                instance = element.current = newInstance;
	                element.pointTo(element);
	                if (isVariantNode && parent && !isControllingVariants) {
	                    removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
	                }
	                parent === null || parent === void 0 ? void 0 : parent.children.add(element);
	            },
	            /**
	             *
	             */
	            unmount: function () {
	                sync.cancelSync.update(update);
	                sync.cancelSync.render(render);
	                sync.cancelSync.preRender(element.updateLayoutProjection);
	                valueSubscriptions.forEach(function (remove) { return remove(); });
	                element.stopLayoutAnimation();
	                element.layoutTree.remove(element);
	                removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
	                parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
	                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
	                lifecycles.clearAllListeners();
	            },
	            /**
	             * Add a child visual element to our set of children.
	             */
	            addVariantChild: function (child) {
	                var _a;
	                var closestVariantNode = element.getClosestVariantNode();
	                if (closestVariantNode) {
	                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
	                    return function () { return closestVariantNode.variantChildren.delete(child); };
	                }
	            },
	            sortNodePosition: function (other) {
	                /**
	                 * If these nodes aren't even of the same type we can't compare their depth.
	                 */
	                if (!sortNodePosition || treeType !== other.treeType)
	                    return 0;
	                return sortNodePosition(element.getInstance(), other.getInstance());
	            }, 
	            /**
	             * Returns the closest variant node in the tree starting from
	             * this visual element.
	             */
	            getClosestVariantNode: function () {
	                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
	            }, 
	            /**
	             * A method that schedules an update to layout projections throughout
	             * the tree. We inherit from the parent so there's only ever one
	             * job scheduled on the next frame - that of the root visual element.
	             */
	            scheduleUpdateLayoutProjection: parent
	                ? parent.scheduleUpdateLayoutProjection
	                : function () {
	                    return sync__default['default'].preRender(element.updateTreeLayoutProjection, false, true);
	                }, 
	            /**
	             * Expose the latest layoutId prop.
	             */
	            getLayoutId: function () { return props.layoutId; }, 
	            /**
	             * Returns the current instance.
	             */
	            getInstance: function () { return instance; }, 
	            /**
	             * Get/set the latest static values.
	             */
	            getStaticValue: function (key) { return latestValues[key]; }, setStaticValue: function (key, value) { return (latestValues[key] = value); }, 
	            /**
	             * Returns the latest motion value state. Currently only used to take
	             * a snapshot of the visual element - perhaps this can return the whole
	             * visual state
	             */
	            getLatestValues: function () { return latestValues; }, 
	            /**
	             * Set the visiblity of the visual element. If it's changed, schedule
	             * a render to reflect these changes.
	             */
	            setVisibility: function (visibility) {
	                if (element.isVisible === visibility)
	                    return;
	                element.isVisible = visibility;
	                element.scheduleRender();
	            },
	            /**
	             * Make a target animatable by Popmotion. For instance, if we're
	             * trying to animate width from 100px to 100vw we need to measure 100vw
	             * in pixels to determine what we really need to animate to. This is also
	             * pluggable to support Framer's custom value types like Color,
	             * and CSS variables.
	             */
	            makeTargetAnimatable: function (target, canMutate) {
	                if (canMutate === void 0) { canMutate = true; }
	                return makeTargetAnimatable(element, target, props, canMutate);
	            },
	            // Motion values ========================
	            /**
	             * Add a motion value and bind it to this visual element.
	             */
	            addValue: function (key, value) {
	                // Remove existing value if it exists
	                if (element.hasValue(key))
	                    element.removeValue(key);
	                values.set(key, value);
	                latestValues[key] = value.get();
	                bindToMotionValue(key, value);
	            },
	            /**
	             * Remove a motion value and unbind any active subscriptions.
	             */
	            removeValue: function (key) {
	                var _a;
	                values.delete(key);
	                (_a = valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
	                valueSubscriptions.delete(key);
	                delete latestValues[key];
	                removeValueFromRenderState(key, renderState);
	            }, 
	            /**
	             * Check whether we have a motion value for this key
	             */
	            hasValue: function (key) { return values.has(key); }, 
	            /**
	             * Get a motion value for this key. If called with a default
	             * value, we'll create one if none exists.
	             */
	            getValue: function (key, defaultValue) {
	                var value = values.get(key);
	                if (value === undefined && defaultValue !== undefined) {
	                    value = motionValue(defaultValue);
	                    element.addValue(key, value);
	                }
	                return value;
	            }, 
	            /**
	             * Iterate over our motion values.
	             */
	            forEachValue: function (callback) { return values.forEach(callback); }, 
	            /**
	             * If we're trying to animate to a previously unencountered value,
	             * we need to check for it in our state and as a last resort read it
	             * directly from the instance (which might have performance implications).
	             */
	            readValue: function (key) { var _a; return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options); }, 
	            /**
	             * Set the base target to later animate back to. This is currently
	             * only hydrated on creation and when we first read a value.
	             */
	            setBaseTarget: function (key, value) {
	                baseTarget[key] = value;
	            },
	            /**
	             * Find the base target for a value thats been removed from all animation
	             * props.
	             */
	            getBaseTarget: function (key) {
	                if (getBaseTarget) {
	                    var target = getBaseTarget(props, key);
	                    if (target !== undefined && !isMotionValue(target))
	                        return target;
	                }
	                return baseTarget[key];
	            } }, lifecycles), { 
	            /**
	             * Build the renderer state based on the latest visual state.
	             */
	            build: function () {
	                triggerBuild();
	                return renderState;
	            },
	            /**
	             * Schedule a render on the next animation frame.
	             */
	            scheduleRender: function () {
	                sync__default['default'].render(render, false, true);
	            }, 
	            /**
	             * Synchronously fire render. It's prefered that we batch renders but
	             * in many circumstances, like layout measurement, we need to run this
	             * synchronously. However in those instances other measures should be taken
	             * to batch reads/writes.
	             */
	            syncRender: render, 
	            /**
	             * Update the provided props. Ensure any newly-added motion values are
	             * added to our map, old ones removed, and listeners updated.
	             */
	            setProps: function (newProps) {
	                props = newProps;
	                lifecycles.updatePropListeners(newProps);
	                prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps(props), prevMotionValues);
	            }, getProps: function () { return props; }, 
	            // Variants ==============================
	            /**
	             * Returns the variant definition with a given name.
	             */
	            getVariant: function (name) { var _a; return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name]; }, 
	            /**
	             * Returns the defined default transition on this component.
	             */
	            getDefaultTransition: function () { return props.transition; }, 
	            /**
	             * Used by child variant nodes to get the closest ancestor variant props.
	             */
	            getVariantContext: function (startAtParent) {
	                if (startAtParent === void 0) { startAtParent = false; }
	                if (startAtParent)
	                    return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
	                if (!isControllingVariants) {
	                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
	                    if (props.initial !== undefined) {
	                        context_1.initial = props.initial;
	                    }
	                    return context_1;
	                }
	                var context = {};
	                for (var i = 0; i < numVariantProps; i++) {
	                    var name_1 = variantProps[i];
	                    var prop = props[name_1];
	                    if (isVariantLabel(prop) || prop === false) {
	                        context[name_1] = prop;
	                    }
	                }
	                return context;
	            },
	            // Layout projection ==============================
	            /**
	             * Enable layout projection for this visual element. Won't actually
	             * occur until we also have hydrated layout measurements.
	             */
	            enableLayoutProjection: function () {
	                projection.isEnabled = true;
	                element.layoutTree.add(element);
	            },
	            /**
	             * Lock the projection target, for instance when dragging, so
	             * nothing else can try and animate it.
	             */
	            lockProjectionTarget: function () {
	                projection.isTargetLocked = true;
	            },
	            unlockProjectionTarget: function () {
	                element.stopLayoutAnimation();
	                projection.isTargetLocked = false;
	            }, getLayoutState: function () { return layoutState; }, setCrossfader: function (newCrossfader) {
	                crossfader = newCrossfader;
	            }, isProjectionReady: function () {
	                return projection.isEnabled &&
	                    projection.isHydrated &&
	                    layoutState.isHydrated;
	            }, 
	            /**
	             * Start a layout animation on a given axis.
	             */
	            startLayoutAnimation: function (axis, transition, isRelative) {
	                if (isRelative === void 0) { isRelative = false; }
	                var progress = element.getProjectionAnimationProgress()[axis];
	                var _a = isRelative
	                    ? projection.relativeTarget[axis]
	                    : projection.target[axis], min = _a.min, max = _a.max;
	                var length = max - min;
	                progress.clearListeners();
	                progress.set(min);
	                progress.set(min); // Set twice to hard-reset velocity
	                progress.onChange(function (v) {
	                    element.setProjectionTargetAxis(axis, v, v + length, isRelative);
	                });
	                return element.animateMotionValue(axis, progress, 0, transition);
	            },
	            /**
	             * Stop layout animations.
	             */
	            stopLayoutAnimation: function () {
	                eachAxis(function (axis) {
	                    return element.getProjectionAnimationProgress()[axis].stop();
	                });
	            },
	            /**
	             * Measure the current viewport box with or without transforms.
	             * Only measures axis-aligned boxes, rotate and skew must be manually
	             * removed with a re-render to work.
	             */
	            measureViewportBox: function (withTransform) {
	                if (withTransform === void 0) { withTransform = true; }
	                var viewportBox = measureViewportBox(instance, options);
	                if (!withTransform)
	                    removeBoxTransforms(viewportBox, latestValues);
	                return viewportBox;
	            },
	            /**
	             * Get the motion values tracking the layout animations on each
	             * axis. Lazy init if not already created.
	             */
	            getProjectionAnimationProgress: function () {
	                projectionTargetProgress || (projectionTargetProgress = {
	                    x: motionValue(0),
	                    y: motionValue(0),
	                });
	                return projectionTargetProgress;
	            },
	            /**
	             * Update the projection of a single axis. Schedule an update to
	             * the tree layout projection.
	             */
	            setProjectionTargetAxis: function (axis, min, max, isRelative) {
	                if (isRelative === void 0) { isRelative = false; }
	                var target;
	                if (isRelative) {
	                    if (!projection.relativeTarget) {
	                        projection.relativeTarget = axisBox();
	                    }
	                    target = projection.relativeTarget[axis];
	                }
	                else {
	                    projection.relativeTarget = undefined;
	                    target = projection.target[axis];
	                }
	                projection.isHydrated = true;
	                target.min = min;
	                target.max = max;
	                // Flag that we want to fire the onViewportBoxUpdate event handler
	                hasViewportBoxUpdated = true;
	                lifecycles.notifySetAxisTarget();
	            },
	            /**
	             * Rebase the projection target on top of the provided viewport box
	             * or the measured layout. This ensures that non-animating elements
	             * don't fall out of sync differences in measurements vs projections
	             * after a page scroll or other relayout.
	             */
	            rebaseProjectionTarget: function (force, box) {
	                if (box === void 0) { box = layoutState.layout; }
	                var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
	                var shouldRebase = !projection.relativeTarget &&
	                    !projection.isTargetLocked &&
	                    !x.isAnimating() &&
	                    !y.isAnimating();
	                if (force || shouldRebase) {
	                    eachAxis(function (axis) {
	                        var _a = box[axis], min = _a.min, max = _a.max;
	                        element.setProjectionTargetAxis(axis, min, max);
	                    });
	                }
	            },
	            /**
	             * Notify the visual element that its layout is up-to-date.
	             * Currently Animate.tsx uses this to check whether a layout animation
	             * needs to be performed.
	             */
	            notifyLayoutReady: function (config) {
	                setCurrentViewportBox(element);
	                element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
	            }, 
	            /**
	             * Temporarily reset the transform of the instance.
	             */
	            resetTransform: function () { return resetTransform(element, instance, props); }, restoreTransform: function () { return restoreTransform(instance, renderState); }, updateLayoutProjection: updateLayoutProjection,
	            updateTreeLayoutProjection: function () {
	                element.layoutTree.forEach(fireResolveRelativeTargetBox);
	                /**
	                 * Schedule the projection updates at the end of the current preRender
	                 * step. This will ensure that all layout trees will first resolve
	                 * relative projection boxes into viewport boxes, and *then*
	                 * update projections.
	                 */
	                sync__default['default'].preRender(updateTreeLayoutProjection, false, true);
	                // sync.postRender(() => element.scheduleUpdateLayoutProjection())
	            },
	            getProjectionParent: function () {
	                if (projectionParent === undefined) {
	                    var foundParent = false;
	                    // Search backwards through the tree path
	                    for (var i = element.path.length - 1; i >= 0; i--) {
	                        var ancestor = element.path[i];
	                        if (ancestor.projection.isEnabled) {
	                            foundParent = ancestor;
	                            break;
	                        }
	                    }
	                    projectionParent = foundParent;
	                }
	                return projectionParent;
	            },
	            resolveRelativeTargetBox: function () {
	                var relativeParent = element.getProjectionParent();
	                if (!projection.relativeTarget || !relativeParent)
	                    return;
	                calcRelativeBox(projection, relativeParent.projection);
	                if (isDraggable(relativeParent)) {
	                    var target = projection.target;
	                    applyBoxTransforms(target, target, relativeParent.getLatestValues());
	                }
	            },
	            shouldResetTransform: function () {
	                return Boolean(props._layoutResetTransform);
	            },
	            /**
	             *
	             */
	            pointTo: function (newLead) {
	                leadProjection = newLead.projection;
	                leadLatestValues = newLead.getLatestValues();
	                /**
	                 * Subscribe to lead component's layout animations
	                 */
	                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
	                unsubscribeFromLeadVisualElement = popmotion.pipe(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function () {
	                    var _a;
	                    if (element.isPresent) {
	                        element.presence = Presence.Present;
	                    }
	                    else {
	                        (_a = element.layoutSafeToRemove) === null || _a === void 0 ? void 0 : _a.call(element);
	                    }
	                }));
	            }, 
	            // TODO: Clean this up
	            isPresent: true, presence: Presence.Entering });
	        return element;
	    };
	};
	function fireResolveRelativeTargetBox(child) {
	    child.resolveRelativeTargetBox();
	}
	function fireUpdateLayoutProjection(child) {
	    child.updateLayoutProjection();
	}
	var variantProps = tslib.__spreadArray(["initial"], tslib.__read(variantPriorityOrder));
	var numVariantProps = variantProps.length;
	
	var positionalKeys = new Set([
	    "width",
	    "height",
	    "top",
	    "left",
	    "right",
	    "bottom",
	    "x",
	    "y",
	]);
	var isPositionalKey = function (key) { return positionalKeys.has(key); };
	var hasPositionalKey = function (target) {
	    return Object.keys(target).some(isPositionalKey);
	};
	var setAndResetVelocity = function (value, to) {
	    // Looks odd but setting it twice doesn't render, it'll just
	    // set both prev and current to the latest value
	    value.set(to, false);
	    value.set(to);
	};
	var isNumOrPxType = function (v) {
	    return v === styleValueTypes.number || v === styleValueTypes.px;
	};
	var BoundingBoxDimension;
	(function (BoundingBoxDimension) {
	    BoundingBoxDimension["width"] = "width";
	    BoundingBoxDimension["height"] = "height";
	    BoundingBoxDimension["left"] = "left";
	    BoundingBoxDimension["right"] = "right";
	    BoundingBoxDimension["top"] = "top";
	    BoundingBoxDimension["bottom"] = "bottom";
	})(BoundingBoxDimension || (BoundingBoxDimension = {}));
	var getPosFromMatrix = function (matrix, pos) {
	    return parseFloat(matrix.split(", ")[pos]);
	};
	var getTranslateFromMatrix = function (pos2, pos3) { return function (_bbox, _a) {
	    var transform = _a.transform;
	    if (transform === "none" || !transform)
	        return 0;
	    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
	    if (matrix3d) {
	        return getPosFromMatrix(matrix3d[1], pos3);
	    }
	    else {
	        var matrix = transform.match(/^matrix\((.+)\)$/);
	        if (matrix) {
	            return getPosFromMatrix(matrix[1], pos2);
	        }
	        else {
	            return 0;
	        }
	    }
	}; };
	var transformKeys = new Set(["x", "y", "z"]);
	var nonTranslationalTransformKeys = transformProps.filter(function (key) { return !transformKeys.has(key); });
	function removeNonTranslationalTransform(visualElement) {
	    var removedTransforms = [];
	    nonTranslationalTransformKeys.forEach(function (key) {
	        var value = visualElement.getValue(key);
	        if (value !== undefined) {
	            removedTransforms.push([key, value.get()]);
	            value.set(key.startsWith("scale") ? 1 : 0);
	        }
	    });
	    // Apply changes to element before measurement
	    if (removedTransforms.length)
	        visualElement.syncRender();
	    return removedTransforms;
	}
	var positionalValues = {
	    // Dimensions
	    width: function (_a) {
	        var x = _a.x;
	        return x.max - x.min;
	    },
	    height: function (_a) {
	        var y = _a.y;
	        return y.max - y.min;
	    },
	    top: function (_bbox, _a) {
	        var top = _a.top;
	        return parseFloat(top);
	    },
	    left: function (_bbox, _a) {
	        var left = _a.left;
	        return parseFloat(left);
	    },
	    bottom: function (_a, _b) {
	        var y = _a.y;
	        var top = _b.top;
	        return parseFloat(top) + (y.max - y.min);
	    },
	    right: function (_a, _b) {
	        var x = _a.x;
	        var left = _b.left;
	        return parseFloat(left) + (x.max - x.min);
	    },
	    // Transform
	    x: getTranslateFromMatrix(4, 13),
	    y: getTranslateFromMatrix(5, 14),
	};
	var convertChangedValueTypes = function (target, visualElement, changedKeys) {
	    var originBbox = visualElement.measureViewportBox();
	    var element = visualElement.getInstance();
	    var elementComputedStyle = getComputedStyle(element);
	    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
	    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform };
	    // If the element is currently set to display: "none", make it visible before
	    // measuring the target bounding box
	    if (display === "none") {
	        visualElement.setStaticValue("display", target.display || "block");
	    }
	    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
	    visualElement.syncRender();
	    var targetBbox = visualElement.measureViewportBox();
	    changedKeys.forEach(function (key) {
	        // Restore styles to their **calculated computed style**, not their actual
	        // originally set style. This allows us to animate between equivalent pixel units.
	        var value = visualElement.getValue(key);
	        setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
	        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
	    });
	    return target;
	};
	var checkAndConvertChangedValueTypes = function (visualElement, target, origin, transitionEnd) {
	    if (origin === void 0) { origin = {}; }
	    if (transitionEnd === void 0) { transitionEnd = {}; }
	    target = tslib.__assign({}, target);
	    transitionEnd = tslib.__assign({}, transitionEnd);
	    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
	    // We want to remove any transform values that could affect the element's bounding box before
	    // it's measured. We'll reapply these later.
	    var removedTransformValues = [];
	    var hasAttemptedToRemoveTransformValues = false;
	    var changedValueTypeKeys = [];
	    targetPositionalKeys.forEach(function (key) {
	        var value = visualElement.getValue(key);
	        if (!visualElement.hasValue(key))
	            return;
	        var from = origin[key];
	        var to = target[key];
	        var fromType = findDimensionValueType(from);
	        var toType;
	        // TODO: The current implementation of this basically throws an error
	        // if you try and do value conversion via keyframes. There's probably
	        // a way of doing this but the performance implications would need greater scrutiny,
	        // as it'd be doing multiple resize-remeasure operations.
	        if (isKeyframesTarget(to)) {
	            var numKeyframes = to.length;
	            for (var i = to[0] === null ? 1 : 0; i < numKeyframes; i++) {
	                if (!toType) {
	                    toType = findDimensionValueType(to[i]);
	                    heyListen.invariant(toType === fromType ||
	                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
	                }
	                else {
	                    heyListen.invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
	                }
	            }
	        }
	        else {
	            toType = findDimensionValueType(to);
	        }
	        if (fromType !== toType) {
	            // If they're both just number or px, convert them both to numbers rather than
	            // relying on resize/remeasure to convert (which is wasteful in this situation)
	            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
	                var current = value.get();
	                if (typeof current === "string") {
	                    value.set(parseFloat(current));
	                }
	                if (typeof to === "string") {
	                    target[key] = parseFloat(to);
	                }
	                else if (Array.isArray(to) && toType === styleValueTypes.px) {
	                    target[key] = to.map(parseFloat);
	                }
	            }
	            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
	                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
	                (from === 0 || to === 0)) {
	                // If one or the other value is 0, it's safe to coerce it to the
	                // type of the other without measurement
	                if (from === 0) {
	                    value.set(toType.transform(from));
	                }
	                else {
	                    target[key] = fromType.transform(to);
	                }
	            }
	            else {
	                // If we're going to do value conversion via DOM measurements, we first
	                // need to remove non-positional transform values that could affect the bbox measurements.
	                if (!hasAttemptedToRemoveTransformValues) {
	                    removedTransformValues = removeNonTranslationalTransform(visualElement);
	                    hasAttemptedToRemoveTransformValues = true;
	                }
	                changedValueTypeKeys.push(key);
	                transitionEnd[key] =
	                    transitionEnd[key] !== undefined
	                        ? transitionEnd[key]
	                        : target[key];
	                setAndResetVelocity(value, to);
	            }
	        }
	    });
	    if (changedValueTypeKeys.length) {
	        var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
	        // If we removed transform values, reapply them before the next render
	        if (removedTransformValues.length) {
	            removedTransformValues.forEach(function (_a) {
	                var _b = tslib.__read(_a, 2), key = _b[0], value = _b[1];
	                visualElement.getValue(key).set(value);
	            });
	        }
	        // Reapply original values
	        visualElement.syncRender();
	        return { target: convertedTarget, transitionEnd: transitionEnd };
	    }
	    else {
	        return { target: target, transitionEnd: transitionEnd };
	    }
	};
	/**
	 * Convert value types for x/y/width/height/top/left/bottom/right
	 *
	 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
	 *
	 * @internal
	 */
	function unitConversion(visualElement, target, origin, transitionEnd) {
	    return hasPositionalKey(target)
	        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
	        : { target: target, transitionEnd: transitionEnd };
	}
	
	/**
	 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
	 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
	 */
	var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
	    var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
	    target = resolved.target;
	    transitionEnd = resolved.transitionEnd;
	    return unitConversion(visualElement, target, origin, transitionEnd);
	};
	
	function getComputedStyle$1(element) {
	    return window.getComputedStyle(element);
	}
	var htmlConfig = {
	    treeType: "dom",
	    readValueFromInstance: function (domElement, key) {
	        if (isTransformProp(key)) {
	            var defaultType = getDefaultValueType(key);
	            return defaultType ? defaultType.default || 0 : 0;
	        }
	        else {
	            var computedStyle = getComputedStyle$1(domElement);
	            return ((isCSSVariable$1(key)
	                ? computedStyle.getPropertyValue(key)
	                : computedStyle[key]) || 0);
	        }
	    },
	    sortNodePosition: function (a, b) {
	        /**
	         * compareDocumentPosition returns a bitmask, by using the bitwise &
	         * we're returning true if 2 in that bitmask is set to true. 2 is set
	         * to true if b preceeds a.
	         */
	        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
	    },
	    getBaseTarget: function (props, key) {
	        var _a;
	        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
	    },
	    measureViewportBox: function (element, _a) {
	        var transformPagePoint = _a.transformPagePoint;
	        return getBoundingBox(element, transformPagePoint);
	    },
	    /**
	     * Reset the transform on the current Element. This is called as part
	     * of a batched process across the entire layout tree. To remove this write
	     * cycle it'd be interesting to see if it's possible to "undo" all the current
	     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
	     * works
	     */
	    resetTransform: function (element, domElement, props) {
	        var transformTemplate = props.transformTemplate;
	        domElement.style.transform = transformTemplate
	            ? transformTemplate({}, "")
	            : "none";
	        // Ensure that whatever happens next, we restore our transform on the next frame
	        element.scheduleRender();
	    },
	    restoreTransform: function (instance, mutableState) {
	        instance.style.transform = mutableState.style.transform;
	    },
	    removeValueFromRenderState: function (key, _a) {
	        var vars = _a.vars, style = _a.style;
	        delete vars[key];
	        delete style[key];
	    },
	    /**
	     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
	     * can be animated by Motion.
	     */
	    makeTargetAnimatable: function (element, _a, _b, isMounted) {
	        var transformValues = _b.transformValues;
	        if (isMounted === void 0) { isMounted = true; }
	        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = tslib.__rest(_a, ["transition", "transitionEnd"]);
	        var origin = getOrigin(target, transition || {}, element);
	        /**
	         * If Framer has provided a function to convert `Color` etc value types, convert them
	         */
	        if (transformValues) {
	            if (transitionEnd)
	                transitionEnd = transformValues(transitionEnd);
	            if (target)
	                target = transformValues(target);
	            if (origin)
	                origin = transformValues(origin);
	        }
	        if (isMounted) {
	            checkTargetForNewValues(element, target, origin);
	            var parsed = parseDomVariant(element, target, origin, transitionEnd);
	            transitionEnd = parsed.transitionEnd;
	            target = parsed.target;
	        }
	        return tslib.__assign({ transition: transition,
	            transitionEnd: transitionEnd }, target);
	    },
	    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
	    build: function (element, renderState, latestValues, projection, layoutState, options, props) {
	        if (element.isVisible !== undefined) {
	            renderState.style.visibility = element.isVisible
	                ? "visible"
	                : "hidden";
	        }
	        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
	        buildHTMLStyles(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
	            ? buildLayoutProjectionTransformOrigin
	            : undefined);
	    },
	    render: renderHTML,
	};
	var htmlVisualElement = visualElement(htmlConfig);
	
	var svgVisualElement = visualElement(tslib.__assign(tslib.__assign({}, htmlConfig), { getBaseTarget: function (props, key) {
	        return props[key];
	    },
	    readValueFromInstance: function (domElement, key) {
	        var _a;
	        if (isTransformProp(key)) {
	            return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
	        }
	        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
	        return domElement.getAttribute(key);
	    },
	    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
	    build: function (_element, renderState, latestValues, projection, layoutState, options, props) {
	        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
	        buildSVGAttrs(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
	            ? buildLayoutProjectionTransformOrigin
	            : undefined);
	    }, render: renderSVG }));
	
	var createDomVisualElement = function (Component, options) {
	    return isSVGComponent(Component)
	        ? svgVisualElement(options, { enableHardwareAcceleration: false })
	        : htmlVisualElement(options, { enableHardwareAcceleration: true });
	};
	
	var featureBundle = tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign({}, animations), gestureAnimations), drag), layoutAnimations);
	/**
	 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
	 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
	 *
	 * @public
	 */
	var motion = /*@__PURE__*/ createMotionProxy(function (Component, config) {
	    return createDomMotionConfig(Component, config, featureBundle, createDomVisualElement);
	});
	/**
	 * Create a DOM `motion` component with the provided string. This is primarily intended
	 * as a full alternative to `motion` for consumers who have to support environments that don't
	 * support `Proxy`.
	 *
	 * ```javascript
	 * import { createDomMotionComponent } from "framer-motion"
	 *
	 * const motion = {
	 *   div: createDomMotionComponent('div')
	 * }
	 * ```
	 *
	 * @public
	 */
	function createDomMotionComponent(key) {
	    return createMotionComponent(createDomMotionConfig(key, { forwardMotionProps: false }, featureBundle, createDomVisualElement));
	}
	
	/**
	 * @public
	 */
	var m = createMotionProxy(createDomMotionConfig);
	
	function useForceUpdate() {
	    var unloadingRef = React.useRef(false);
	    var _a = tslib.__read(React.useState(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
	    useUnmountEffect(function () { return (unloadingRef.current = true); });
	    return React.useCallback(function () {
	        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
	    }, [forcedRenderCount]);
	}
	
	var presenceId = 0;
	function getPresenceId() {
	    var id = presenceId;
	    presenceId++;
	    return id;
	}
	var PresenceChild = function (_a) {
	    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
	    var presenceChildren = useConstant(newChildrenMap);
	    var id = useConstant(getPresenceId);
	    var context = React.useMemo(function () { return ({
	        id: id,
	        initial: initial,
	        isPresent: isPresent,
	        custom: custom,
	        onExitComplete: function (childId) {
	            presenceChildren.set(childId, true);
	            var allComplete = true;
	            presenceChildren.forEach(function (isComplete) {
	                if (!isComplete)
	                    allComplete = false;
	            });
	            allComplete && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
	        },
	        register: function (childId) {
	            presenceChildren.set(childId, false);
	            return function () { return presenceChildren.delete(childId); };
	        },
	    }); }, 
	    /**
	     * If the presence of a child affects the layout of the components around it,
	     * we want to make a new context value to ensure they get re-rendered
	     * so they can detect that layout change.
	     */
	    presenceAffectsLayout ? undefined : [isPresent]);
	    React.useMemo(function () {
	        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
	    }, [isPresent]);
	    /**
	     * If there's no `motion` components to fire exit animations, we want to remove this
	     * component immediately.
	     */
	    React__namespace.useEffect(function () {
	        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
	    }, [isPresent]);
	    return (React__namespace.createElement(PresenceContext.Provider, { value: context }, children));
	};
	function newChildrenMap() {
	    return new Map();
	}
	
	function getChildKey(child) {
	    return child.key || "";
	}
	function updateChildLookup(children, allChildren) {
	    var seenChildren =  false ? new Set() : null;
	    children.forEach(function (child) {
	        var key = getChildKey(child);
	        if (false) {
	            if (seenChildren.has(key)) {
	                console.warn("Children of AnimatePresence require unique keys. \"" + key + "\" is a duplicate.");
	            }
	            seenChildren.add(key);
	        }
	        allChildren.set(key, child);
	    });
	}
	function onlyElements(children) {
	    var filtered = [];
	    // We use forEach here instead of map as map mutates the component key by preprending `.$`
	    React.Children.forEach(children, function (child) {
	        if (React.isValidElement(child))
	            filtered.push(child);
	    });
	    return filtered;
	}
	/**
	 * `AnimatePresence` enables the animation of components that have been removed from the tree.
	 *
	 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
	 *
	 * @library
	 *
	 * Any `Frame` components that have an `exit` property defined will animate out when removed from
	 * the tree.
	 *
	 * ```jsx
	 * import { Frame, AnimatePresence } from 'framer'
	 *
	 * // As items are added and removed from `items`
	 * export function Items({ items }) {
	 *   return (
	 *     <AnimatePresence>
	 *       {items.map(item => (
	 *         <Frame
	 *           key={item.id}
	 *           initial={{ opacity: 0 }}
	 *           animate={{ opacity: 1 }}
	 *           exit={{ opacity: 0 }}
	 *         />
	 *       ))}
	 *     </AnimatePresence>
	 *   )
	 * }
	 * ```
	 *
	 * You can sequence exit animations throughout a tree using variants.
	 *
	 * @motion
	 *
	 * Any `motion` components that have an `exit` property defined will animate out when removed from
	 * the tree.
	 *
	 * ```jsx
	 * import { motion, AnimatePresence } from 'framer-motion'
	 *
	 * export const Items = ({ items }) => (
	 *   <AnimatePresence>
	 *     {items.map(item => (
	 *       <motion.div
	 *         key={item.id}
	 *         initial={{ opacity: 0 }}
	 *         animate={{ opacity: 1 }}
	 *         exit={{ opacity: 0 }}
	 *       />
	 *     ))}
	 *   </AnimatePresence>
	 * )
	 * ```
	 *
	 * You can sequence exit animations throughout a tree using variants.
	 *
	 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
	 * once all `motion` components have finished animating out. Likewise, any components using
	 * `usePresence` all need to call `safeToRemove`.
	 *
	 * @public
	 */
	var AnimatePresence = function (_a) {
	    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
	    // We want to force a re-render once all exiting animations have finished. We
	    // either use a local forceRender function, or one from a parent context if it exists.
	    var forceRender = useForceUpdate();
	    var layoutContext = React.useContext(SharedLayoutContext);
	    if (isSharedLayout(layoutContext)) {
	        forceRender = layoutContext.forceUpdate;
	    }
	    var isInitialRender = React.useRef(true);
	    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
	    var filteredChildren = onlyElements(children);
	    // Keep a living record of the children we're actually rendering so we
	    // can diff to figure out which are entering and exiting
	    var presentChildren = React.useRef(filteredChildren);
	    // A lookup table to quickly reference components by key
	    var allChildren = React.useRef(new Map())
	        .current;
	    // A living record of all currently exiting components.
	    var exiting = React.useRef(new Set()).current;
	    updateChildLookup(filteredChildren, allChildren);
	    // If this is the initial component render, just deal with logic surrounding whether
	    // we play onMount animations or not.
	    if (isInitialRender.current) {
	        isInitialRender.current = false;
	        return (React__namespace.createElement(React__namespace.Fragment, null, filteredChildren.map(function (child) { return (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
	    }
	    // If this is a subsequent render, deal with entering and exiting children
	    var childrenToRender = tslib.__spreadArray([], tslib.__read(filteredChildren));
	    // Diff the keys of the currently-present and target children to update our
	    // exiting list.
	    var presentKeys = presentChildren.current.map(getChildKey);
	    var targetKeys = filteredChildren.map(getChildKey);
	    // Diff the present children with our target children and mark those that are exiting
	    var numPresent = presentKeys.length;
	    for (var i = 0; i < numPresent; i++) {
	        var key = presentKeys[i];
	        if (targetKeys.indexOf(key) === -1) {
	            exiting.add(key);
	        }
	        else {
	            // In case this key has re-entered, remove from the exiting list
	            exiting.delete(key);
	        }
	    }
	    // If we currently have exiting children, and we're deferring rendering incoming children
	    // until after all current children have exiting, empty the childrenToRender array
	    if (exitBeforeEnter && exiting.size) {
	        childrenToRender = [];
	    }
	    // Loop through all currently exiting components and clone them to overwrite `animate`
	    // with any `exit` prop they might have defined.
	    exiting.forEach(function (key) {
	        // If this component is actually entering again, early return
	        if (targetKeys.indexOf(key) !== -1)
	            return;
	        var child = allChildren.get(key);
	        if (!child)
	            return;
	        var insertionIndex = presentKeys.indexOf(key);
	        var onExit = function () {
	            allChildren.delete(key);
	            exiting.delete(key);
	            // Remove this child from the present children
	            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
	            presentChildren.current.splice(removeIndex, 1);
	            // Defer re-rendering until all exiting children have indeed left
	            if (!exiting.size) {
	                presentChildren.current = filteredChildren;
	                forceRender();
	                onExitComplete && onExitComplete();
	            }
	        };
	        childrenToRender.splice(insertionIndex, 0, React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
	    });
	    // Add `MotionContext` even to children that don't need it to ensure we're rendering
	    // the same tree between renders
	    childrenToRender = childrenToRender.map(function (child) {
	        var key = child.key;
	        return exiting.has(key) ? (child) : (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
	    });
	    presentChildren.current = childrenToRender;
	    if (false) {
	        console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
	    }
	    return (React__namespace.createElement(React__namespace.Fragment, null, exiting.size
	        ? childrenToRender
	        : childrenToRender.map(function (child) { return React.cloneElement(child); })));
	};
	
	/**
	 * Animate a single value or a `MotionValue`.
	 *
	 * The first argument is either a `MotionValue` to animate, or an initial animation value.
	 *
	 * The second is either a value to animate to, or an array of keyframes to animate through.
	 *
	 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
	 *
	 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
	 *
	 * ```javascript
	 * const x = useMotionValue(0)
	 *
	 * useEffect(() => {
	 *   const controls = animate(x, 100, {
	 *     type: "spring",
	 *     stiffness: 2000,
	 *     onComplete: v => {}
	 *   })
	 *
	 *   return controls.stop
	 * })
	 * ```
	 *
	 * @public
	 */
	function animate(from, to, transition) {
	    if (transition === void 0) { transition = {}; }
	    var value = isMotionValue(from) ? from : motionValue(from);
	    startAnimation("", value, to, transition);
	    return {
	        stop: function () { return value.stop(); },
	    };
	}
	
	function createCrossfader() {
	    /**
	     * The current state of the crossfade as a value between 0 and 1
	     */
	    var progress = motionValue(1);
	    var options = {
	        lead: undefined,
	        follow: undefined,
	        crossfadeOpacity: false,
	        preserveFollowOpacity: false,
	    };
	    var prevOptions = tslib.__assign({}, options);
	    var leadState = {};
	    var followState = {};
	    /**
	     *
	     */
	    var isActive = false;
	    /**
	     *
	     */
	    var finalCrossfadeFrame = null;
	    /**
	     * Framestamp of the last frame we updated values at.
	     */
	    var prevUpdate = 0;
	    function startCrossfadeAnimation(target, transition) {
	        var lead = options.lead, follow = options.follow;
	        isActive = true;
	        finalCrossfadeFrame = null;
	        var hasUpdated = false;
	        var onUpdate = function () {
	            hasUpdated = true;
	            lead && lead.scheduleRender();
	            follow && follow.scheduleRender();
	        };
	        var onComplete = function () {
	            isActive = false;
	            /**
	             * If the crossfade animation is no longer active, flag a frame
	             * that we're still allowed to crossfade
	             */
	            finalCrossfadeFrame = sync.getFrameData().timestamp;
	        };
	        transition = transition && getValueTransition(transition, "crossfade");
	        return animate(progress, target, tslib.__assign(tslib.__assign({}, transition), { onUpdate: onUpdate, onComplete: function () {
	                if (!hasUpdated) {
	                    progress.set(target);
	                    /**
	                     * If we never ran an update, for instance if this was an instant transition, fire a
	                     * simulated final frame to ensure the crossfade gets applied correctly.
	                     */
	                    sync__default['default'].read(onComplete);
	                }
	                else {
	                    onComplete();
	                }
	                onUpdate();
	            } }));
	    }
	    function updateCrossfade() {
	        var _a, _b;
	        /**
	         * We only want to compute the crossfade once per frame, so we
	         * compare the previous update framestamp with the current frame
	         * and early return if they're the same.
	         */
	        var timestamp = sync.getFrameData().timestamp;
	        var lead = options.lead, follow = options.follow;
	        if (timestamp === prevUpdate || !lead)
	            return;
	        prevUpdate = timestamp;
	        /**
	         * Merge each component's latest values into our crossfaded state
	         * before crossfading.
	         */
	        var latestLeadValues = lead.getLatestValues();
	        Object.assign(leadState, latestLeadValues);
	        var latestFollowValues = follow
	            ? follow.getLatestValues()
	            : options.prevValues;
	        Object.assign(followState, latestFollowValues);
	        var p = progress.get();
	        /**
	         * Crossfade the opacity between the two components. This will result
	         * in a different opacity for each component.
	         */
	        var leadTargetOpacity = (_a = latestLeadValues.opacity) !== null && _a !== void 0 ? _a : 1;
	        var followTargetOpacity = (_b = latestFollowValues === null || latestFollowValues === void 0 ? void 0 : latestFollowValues.opacity) !== null && _b !== void 0 ? _b : 1;
	        if (options.crossfadeOpacity && follow) {
	            leadState.opacity = popmotion.mix(
	            /**
	             * If the follow child has been completely hidden we animate
	             * this opacity from its previous opacity, but otherwise from completely transparent.
	             */
	            follow.isVisible !== false ? 0 : followTargetOpacity, leadTargetOpacity, easeCrossfadeIn(p));
	            followState.opacity = options.preserveFollowOpacity
	                ? followTargetOpacity
	                : popmotion.mix(followTargetOpacity, 0, easeCrossfadeOut(p));
	        }
	        else if (!follow) {
	            leadState.opacity = popmotion.mix(followTargetOpacity, leadTargetOpacity, p);
	        }
	        mixValues(leadState, followState, latestLeadValues, latestFollowValues || {}, Boolean(follow), p);
	    }
	    return {
	        isActive: function () {
	            return leadState &&
	                (isActive || sync.getFrameData().timestamp === finalCrossfadeFrame);
	        },
	        fromLead: function (transition) {
	            return startCrossfadeAnimation(0, transition);
	        },
	        toLead: function (transition) {
	            var initialProgress = 0;
	            if (!options.prevValues && !options.follow) {
	                /**
	                 * If we're not coming from anywhere, start at the end of the animation.
	                 */
	                initialProgress = 1;
	            }
	            else if (prevOptions.lead === options.follow &&
	                prevOptions.follow === options.lead) {
	                /**
	                 * If we're swapping follow/lead we can reverse the progress
	                 */
	                initialProgress = 1 - progress.get();
	            }
	            progress.set(initialProgress);
	            return startCrossfadeAnimation(1, transition);
	        },
	        reset: function () { return progress.set(1); },
	        stop: function () { return progress.stop(); },
	        getCrossfadeState: function (element) {
	            updateCrossfade();
	            if (element === options.lead) {
	                return leadState;
	            }
	            else if (element === options.follow) {
	                return followState;
	            }
	        },
	        setOptions: function (newOptions) {
	            prevOptions = options;
	            options = newOptions;
	            leadState = {};
	            followState = {};
	        },
	        getLatestValues: function () {
	            return leadState;
	        },
	    };
	}
	var easeCrossfadeIn = compress(0, 0.5, popmotion.circOut);
	var easeCrossfadeOut = compress(0.5, 0.95, popmotion.linear);
	function compress(min, max, easing) {
	    return function (p) {
	        // Could replace ifs with clamp
	        if (p < min)
	            return 0;
	        if (p > max)
	            return 1;
	        return easing(popmotion.progress(min, max, p));
	    };
	}
	var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
	var numBorders = borders.length;
	function mixValues(leadState, followState, latestLeadValues, latestFollowValues, hasFollowElement, p) {
	    /**
	     * Mix border radius
	     */
	    for (var i = 0; i < numBorders; i++) {
	        var borderLabel = "border" + borders[i] + "Radius";
	        var followRadius = getRadius(latestFollowValues, borderLabel);
	        var leadRadius = getRadius(latestLeadValues, borderLabel);
	        if (followRadius === undefined && leadRadius === undefined)
	            continue;
	        followRadius || (followRadius = 0);
	        leadRadius || (leadRadius = 0);
	        /**
	         * Currently we're only crossfading between numerical border radius.
	         * It would be possible to crossfade between percentages for a little
	         * extra bundle size.
	         */
	        if (typeof followRadius === "number" &&
	            typeof leadRadius === "number") {
	            var radius = Math.max(popmotion.mix(followRadius, leadRadius, p), 0);
	            leadState[borderLabel] = followState[borderLabel] = radius;
	        }
	    }
	    /**
	     * Mix rotation
	     */
	    if (latestFollowValues.rotate || latestLeadValues.rotate) {
	        var rotate = popmotion.mix(latestFollowValues.rotate || 0, latestLeadValues.rotate || 0, p);
	        leadState.rotate = followState.rotate = rotate;
	    }
	    /**
	     * We only want to mix the background color if there's a follow element
	     * that we're not crossfading opacity between. For instance with switch
	     * AnimateSharedLayout animations, this helps the illusion of a continuous
	     * element being animated but also cuts down on the number of paints triggered
	     * for elements where opacity is doing that work for us.
	     */
	    if (!hasFollowElement &&
	        latestLeadValues.backgroundColor &&
	        latestFollowValues.backgroundColor) {
	        /**
	         * This isn't ideal performance-wise as mixColor is creating a new function every frame.
	         * We could probably create a mixer that runs at the start of the animation but
	         * the idea behind the crossfader is that it runs dynamically between two potentially
	         * changing targets (ie opacity or borderRadius may be animating independently via variants)
	         */
	        leadState.backgroundColor = followState.backgroundColor = popmotion.mixColor(latestFollowValues.backgroundColor, latestLeadValues.backgroundColor)(p);
	    }
	}
	function getRadius(values, radiusName) {
	    var _a;
	    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
	}
	
	function layoutStack() {
	    var stack = new Set();
	    var state = { leadIsExiting: false };
	    var prevState = tslib.__assign({}, state);
	    var prevValues;
	    var prevViewportBox;
	    var prevDragCursor;
	    var crossfader = createCrossfader();
	    var needsCrossfadeAnimation = false;
	    function getFollowViewportBox() {
	        return state.follow ? state.follow.prevViewportBox : prevViewportBox;
	    }
	    function getFollowLayout() {
	        var _a;
	        return (_a = state.follow) === null || _a === void 0 ? void 0 : _a.getLayoutState().layout;
	    }
	    return {
	        add: function (element) {
	            element.setCrossfader(crossfader);
	            stack.add(element);
	            /**
	             * Hydrate new element with previous drag position if we have one
	             */
	            if (prevDragCursor)
	                element.prevDragCursor = prevDragCursor;
	            if (!state.lead)
	                state.lead = element;
	        },
	        remove: function (element) {
	            stack.delete(element);
	        },
	        getLead: function () { return state.lead; },
	        updateSnapshot: function () {
	            if (!state.lead)
	                return;
	            prevValues = crossfader.isActive()
	                ? crossfader.getLatestValues()
	                : state.lead.getLatestValues();
	            prevViewportBox = state.lead.prevViewportBox;
	            var dragControls = elementDragControls.get(state.lead);
	            if (dragControls && dragControls.isDragging) {
	                prevDragCursor = dragControls.cursorProgress;
	            }
	        },
	        clearSnapshot: function () {
	            prevDragCursor = prevViewportBox = undefined;
	        },
	        updateLeadAndFollow: function () {
	            var _a;
	            prevState = tslib.__assign({}, state);
	            var lead;
	            var follow;
	            var order = Array.from(stack);
	            for (var i = order.length; i--; i >= 0) {
	                var element = order[i];
	                if (lead)
	                    follow !== null && follow !== void 0 ? follow : (follow = element);
	                lead !== null && lead !== void 0 ? lead : (lead = element);
	                if (lead && follow)
	                    break;
	            }
	            state.lead = lead;
	            state.follow = follow;
	            state.leadIsExiting = ((_a = state.lead) === null || _a === void 0 ? void 0 : _a.presence) === Presence.Exiting;
	            crossfader.setOptions({
	                lead: lead,
	                follow: follow,
	                prevValues: prevValues,
	                crossfadeOpacity: (follow === null || follow === void 0 ? void 0 : follow.isPresenceRoot) || (lead === null || lead === void 0 ? void 0 : lead.isPresenceRoot),
	            });
	            if (
	            // Don't crossfade if we've just animated back from lead and switched the
	            // old follow to the new lead.
	            state.lead !== prevState.follow &&
	                (prevState.lead !== state.lead ||
	                    prevState.leadIsExiting !== state.leadIsExiting)) {
	                needsCrossfadeAnimation = true;
	            }
	        },
	        animate: function (child, shouldCrossfade) {
	            var _a;
	            if (shouldCrossfade === void 0) { shouldCrossfade = false; }
	            if (child === state.lead) {
	                if (shouldCrossfade) {
	                    /**
	                     * Point a lead to itself in case it was previously pointing
	                     * to a different visual element
	                     */
	                    child.pointTo(state.lead);
	                }
	                else {
	                    child.setVisibility(true);
	                }
	                var config = {};
	                var prevParent = (_a = state.follow) === null || _a === void 0 ? void 0 : _a.getProjectionParent();
	                if (prevParent) {
	                    /**
	                     * We'll use this to determine if the element or its layoutId has been reparented.
	                     */
	                    config.prevParent = prevParent;
	                }
	                if (child.presence === Presence.Entering) {
	                    config.originBox = getFollowViewportBox();
	                }
	                else if (child.presence === Presence.Exiting) {
	                    config.targetBox = getFollowLayout();
	                }
	                if (needsCrossfadeAnimation) {
	                    needsCrossfadeAnimation = false;
	                    var transition = child.getDefaultTransition();
	                    child.presence === Presence.Entering
	                        ? crossfader.toLead(transition)
	                        : crossfader.fromLead(transition);
	                }
	                child.notifyLayoutReady(config);
	            }
	            else {
	                if (shouldCrossfade) {
	                    state.lead && child.pointTo(state.lead);
	                }
	                else {
	                    child.setVisibility(false);
	                }
	            }
	        },
	    };
	}
	
	function resetRotate(child) {
	    // If there's no detected rotation values, we can early return without a forced render.
	    var hasRotate = false;
	    // Keep a record of all the values we've reset
	    var resetValues = {};
	    // Check the rotate value of all axes and reset to 0
	    for (var i = 0; i < transformAxes.length; i++) {
	        var axis = transformAxes[i];
	        var key = "rotate" + axis;
	        // If this rotation doesn't exist as a motion value, then we don't
	        // need to reset it
	        if (!child.hasValue(key) || child.getStaticValue(key) === 0)
	            continue;
	        hasRotate = true;
	        // Record the rotation and then temporarily set it to 0
	        resetValues[key] = child.getStaticValue(key);
	        child.setStaticValue(key, 0);
	    }
	    // If there's no rotation values, we don't need to do any more.
	    if (!hasRotate)
	        return;
	    // Force a render of this element to apply the transform with all rotations
	    // set to 0.
	    child.syncRender();
	    // Put back all the values we reset
	    for (var key in resetValues) {
	        child.setStaticValue(key, resetValues[key]);
	    }
	    // Schedule a render for the next frame. This ensures we won't visually
	    // see the element with the reset rotate value applied.
	    child.scheduleRender();
	}
	
	/**
	 * @public
	 */
	var AnimateSharedLayout = /** @class */ (function (_super) {
	    tslib.__extends(AnimateSharedLayout, _super);
	    function AnimateSharedLayout() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * A list of all the children in the shared layout
	         */
	        _this.children = new Set();
	        /**
	         * As animate components with a defined `layoutId` are added/removed to the tree,
	         * we store them in order. When one is added, it will animate out from the
	         * previous one, and when it's removed, it'll animate to the previous one.
	         */
	        _this.stacks = new Map();
	        /**
	         * Track whether the component has mounted. If it hasn't, the presence of added children
	         * are set to Present, whereas if it has they're considered Entering
	         */
	        _this.hasMounted = false;
	        /**
	         * Track whether we already have an update scheduled. If we don't, we'll run snapshots
	         * and schedule one.
	         */
	        _this.updateScheduled = false;
	        /**
	         * Tracks whether we already have a render scheduled. If we don't, we'll force one with this.forceRender
	         */
	        _this.renderScheduled = false;
	        /**
	         * The methods provided to all children in the shared layout tree.
	         */
	        _this.syncContext = tslib.__assign(tslib.__assign({}, createBatcher()), { syncUpdate: function (force) { return _this.scheduleUpdate(force); }, forceUpdate: function () {
	                // By copying syncContext to itself, when this component re-renders it'll also re-render
	                // all children subscribed to the SharedLayout context.
	                _this.syncContext = tslib.__assign({}, _this.syncContext);
	                _this.scheduleUpdate(true);
	            }, register: function (child) { return _this.addChild(child); }, remove: function (child) { return _this.removeChild(child); } });
	        return _this;
	    }
	    AnimateSharedLayout.prototype.componentDidMount = function () {
	        this.hasMounted = true;
	    };
	    AnimateSharedLayout.prototype.componentDidUpdate = function () {
	        this.startLayoutAnimation();
	    };
	    AnimateSharedLayout.prototype.shouldComponentUpdate = function () {
	        this.renderScheduled = true;
	        return true;
	    };
	    AnimateSharedLayout.prototype.startLayoutAnimation = function () {
	        var _this = this;
	        /**
	         * Reset update and render scheduled status
	         */
	        this.renderScheduled = this.updateScheduled = false;
	        var type = this.props.type;
	        /**
	         * Update presence metadata based on the latest AnimatePresence status.
	         * This is a kind of goofy way of dealing with this, perhaps there's a better model to find.
	         */
	        this.children.forEach(function (child) {
	            if (!child.isPresent) {
	                child.presence = Presence.Exiting;
	            }
	            else if (child.presence !== Presence.Entering) {
	                child.presence =
	                    child.presence === Presence.Exiting
	                        ? Presence.Entering
	                        : Presence.Present;
	            }
	        });
	        this.updateStacks();
	        /**
	         * Create a handler which we can use to flush the children animations
	         */
	        var handler = {
	            layoutReady: function (child) {
	                if (child.getLayoutId() !== undefined) {
	                    var stack = _this.getStack(child);
	                    stack.animate(child, type === "crossfade");
	                }
	                else {
	                    child.notifyLayoutReady();
	                }
	            },
	            parent: this.context.visualElement,
	        };
	        /**
	         * Shared layout animations can be used without the AnimateSharedLayout wrapping component.
	         * This requires some co-ordination across components to stop layout thrashing
	         * and ensure measurements are taken at the correct time.
	         *
	         * Here we use that same mechanism of schedule/flush.
	         */
	        this.children.forEach(function (child) { return _this.syncContext.add(child); });
	        this.syncContext.flush(handler);
	        /**
	         * Clear snapshots so subsequent rerenders don't retain memory of outgoing components
	         */
	        this.stacks.forEach(function (stack) { return stack.clearSnapshot(); });
	    };
	    AnimateSharedLayout.prototype.updateStacks = function () {
	        this.stacks.forEach(function (stack) { return stack.updateLeadAndFollow(); });
	    };
	    AnimateSharedLayout.prototype.scheduleUpdate = function (force) {
	        if (force === void 0) { force = false; }
	        if (!(force || !this.updateScheduled))
	            return;
	        /**
	         * Flag we've scheduled an update
	         */
	        this.updateScheduled = true;
	        /**
	         * Write: Reset transforms so bounding boxes can be accurately measured.
	         */
	        this.children.forEach(function (child) {
	            resetRotate(child);
	            if (child.shouldResetTransform())
	                child.resetTransform();
	        });
	        /**
	         * Read: Snapshot children
	         */
	        this.children.forEach(snapshotViewportBox);
	        /**
	         * Every child keeps a local snapshot, but we also want to record
	         * snapshots of the visible children as, if they're are being removed
	         * in this render, we can still access them.
	         *
	         * TODO: What would be better here is doing a single loop where we
	         * only snapshotViewportBoxes of undefined layoutIds and then one for each stack
	         */
	        this.stacks.forEach(function (stack) { return stack.updateSnapshot(); });
	        /**
	         * Force a rerender by setting state if we aren't already going to render.
	         */
	        if (force || !this.renderScheduled) {
	            this.renderScheduled = true;
	            this.forceUpdate();
	        }
	    };
	    AnimateSharedLayout.prototype.addChild = function (child) {
	        this.children.add(child);
	        this.addToStack(child);
	        child.presence = this.hasMounted ? Presence.Entering : Presence.Present;
	    };
	    AnimateSharedLayout.prototype.removeChild = function (child) {
	        this.scheduleUpdate();
	        this.children.delete(child);
	        this.removeFromStack(child);
	    };
	    AnimateSharedLayout.prototype.addToStack = function (child) {
	        var stack = this.getStack(child);
	        stack === null || stack === void 0 ? void 0 : stack.add(child);
	    };
	    AnimateSharedLayout.prototype.removeFromStack = function (child) {
	        var stack = this.getStack(child);
	        stack === null || stack === void 0 ? void 0 : stack.remove(child);
	    };
	    /**
	     * Return a stack of animate children based on the provided layoutId.
	     * Will create a stack if none currently exists with that layoutId.
	     */
	    AnimateSharedLayout.prototype.getStack = function (child) {
	        var id = child.getLayoutId();
	        if (id === undefined)
	            return;
	        // Create stack if it doesn't already exist
	        !this.stacks.has(id) && this.stacks.set(id, layoutStack());
	        return this.stacks.get(id);
	    };
	    AnimateSharedLayout.prototype.render = function () {
	        return (React__namespace.createElement(SharedLayoutContext.Provider, { value: this.syncContext }, this.props.children));
	    };
	    AnimateSharedLayout.contextType = MotionContext;
	    return AnimateSharedLayout;
	}(React__namespace.Component));
	
	/**
	 * `MotionConfig` is used to set configuration options for all children `motion` components.
	 *
	 * ```jsx
	 * import { motion, MotionConfig } from "framer-motion"
	 *
	 * export function App() {
	 *   return (
	 *     <MotionConfig transition={{ type: "spring" }}>
	 *       <motion.div animate={{ x: 100 }} />
	 *     </MotionConfig>
	 *   )
	 * }
	 * ```
	 *
	 * @public
	 */
	function MotionConfig(_a) {
	    var children = _a.children, config = tslib.__rest(_a, ["children"]);
	    /**
	     * Inherit props from any parent MotionConfig components
	     */
	    config = tslib.__assign(tslib.__assign({}, React.useContext(MotionConfigContext)), config);
	    /**
	     * Don't allow isStatic to change between renders as it affects how many hooks
	     * motion components fire.
	     */
	    config.isStatic = useConstant(function () { return config.isStatic; });
	    /**
	     * Creating a new config context object will re-render every `motion` component
	     * every time it renders. So we only want to create a new one sparingly.
	     */
	    var transitionDependency = typeof config.transition === "object"
	        ? config.transition.toString()
	        : "";
	    var context = React.useMemo(function () { return config; }, [
	        transitionDependency,
	        config.transformPagePoint,
	    ]);
	    return (React__namespace.createElement(MotionConfigContext.Provider, { value: context }, children));
	}
	
	/**
	 * Used in conjunction with the `m` component to reduce bundle size.
	 *
	 * `m` is a version of the `motion` component that only loads functionality
	 * critical for the initial render.
	 *
	 * `LazyMotion` can then be used to either synchronously or asynchronously
	 * load animation and gesture support.
	 *
	 * ```jsx
	 * // Synchronous loading
	 * import { LazyMotion, m, domAnimations } from "framer-motion"
	 *
	 * function App() {
	 *   return (
	 *     <LazyMotion features={domAnimations}>
	 *       <m.div animate={{ scale: 2 }} />
	 *     </LazyMotion>
	 *   )
	 * }
	 *
	 * // Asynchronous loading
	 * import { LazyMotion, m } from "framer-motion"
	 *
	 * function App() {
	 *   return (
	 *     <LazyMotion features={() => import('./path/to/domAnimations')}>
	 *       <m.div animate={{ scale: 2 }} />
	 *     </LazyMotion>
	 *   )
	 * }
	 * ```
	 *
	 * @public
	 */
	function LazyMotion(_a) {
	    var children = _a.children, features = _a.features, _b = _a.strict, strict = _b === void 0 ? false : _b;
	    var _c = tslib.__read(React.useState(!isLazyBundle(features)), 2), setIsLoaded = _c[1];
	    var loadedRenderer = React.useRef(undefined);
	    /**
	     * If this is a synchronous load, load features immediately
	     */
	    if (!isLazyBundle(features)) {
	        var renderer = features.renderer, loadedFeatures = tslib.__rest(features, ["renderer"]);
	        loadedRenderer.current = renderer;
	        loadFeatures(loadedFeatures);
	    }
	    React.useEffect(function () {
	        if (isLazyBundle(features)) {
	            features().then(function (_a) {
	                var renderer = _a.renderer, loadedFeatures = tslib.__rest(_a, ["renderer"]);
	                loadFeatures(loadedFeatures);
	                loadedRenderer.current = renderer;
	                setIsLoaded(true);
	            });
	        }
	    }, []);
	    return (React__namespace.createElement(LazyContext.Provider, { value: { renderer: loadedRenderer.current, strict: strict } }, children));
	}
	function isLazyBundle(features) {
	    return typeof features === "function";
	}
	
	/**
	 * @public
	 */
	var domAnimation = tslib.__assign(tslib.__assign({ renderer: createDomVisualElement }, animations), gestureAnimations);
	
	/**
	 * @public
	 */
	var domMax = tslib.__assign(tslib.__assign(tslib.__assign({}, domAnimation), drag), layoutAnimations);
	
	/**
	 * Creates a `MotionValue` to track the state and velocity of a value.
	 *
	 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
	 *
	 * @library
	 *
	 * ```jsx
	 * export function MyComponent() {
	 *   const scale = useMotionValue(1)
	 *
	 *   return <Frame scale={scale} />
	 * }
	 * ```
	 *
	 * @motion
	 *
	 * ```jsx
	 * export const MyComponent = () => {
	 *   const scale = useMotionValue(1)
	 *
	 *   return <motion.div style={{ scale }} />
	 * }
	 * ```
	 *
	 * @param initial - The initial state.
	 *
	 * @public
	 */
	function useMotionValue(initial) {
	    var value = useConstant(function () { return motionValue(initial); });
	    /**
	     * If this motion value is being used in static mode, like on
	     * the Framer canvas, force components to rerender when the motion
	     * value is updated.
	     */
	    var isStatic = React.useContext(MotionConfigContext).isStatic;
	    if (isStatic) {
	        var _a = tslib.__read(React.useState(initial), 2), setLatest_1 = _a[1];
	        React.useEffect(function () { return value.onChange(setLatest_1); }, []);
	    }
	    return value;
	}
	
	function useOnChange(value, callback) {
	    React.useEffect(function () {
	        if (isMotionValue(value))
	            return value.onChange(callback);
	    }, [callback]);
	}
	function useMultiOnChange(values, handler) {
	    React.useEffect(function () {
	        var subscriptions = values.map(function (value) { return value.onChange(handler); });
	        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
	    });
	}
	
	function useCombineMotionValues(values, combineValues) {
	    /**
	     * Initialise the returned motion value. This remains the same between renders.
	     */
	    var value = useMotionValue(combineValues());
	    /**
	     * Create a function that will update the template motion value with the latest values.
	     * This is pre-bound so whenever a motion value updates it can schedule its
	     * execution in Framesync. If it's already been scheduled it won't be fired twice
	     * in a single frame.
	     */
	    var updateValue = function () { return value.set(combineValues()); };
	    /**
	     * Synchronously update the motion value with the latest values during the render.
	     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
	     */
	    updateValue();
	    /**
	     * Subscribe to all motion values found within the template. Whenever any of them change,
	     * schedule an update.
	     */
	    useMultiOnChange(values, function () { return sync__default['default'].update(updateValue, false, true); });
	    return value;
	}
	
	/**
	 * Combine multiple motion values into a new one using a string template literal.
	 *
	 * ```jsx
	 * import {
	 *   motion,
	 *   useSpring,
	 *   useMotionValue,
	 *   useMotionTemplate
	 * } from "framer-motion"
	 *
	 * function Component() {
	 *   const shadowX = useSpring(0)
	 *   const shadowY = useMotionValue(0)
	 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
	 *
	 *   return <motion.div style={{ filter: shadow }} />
	 * }
	 * ```
	 *
	 * @public
	 */
	function useMotionTemplate(fragments) {
	    var values = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        values[_i - 1] = arguments[_i];
	    }
	    /**
	     * Create a function that will build a string from the latest motion values.
	     */
	    var numFragments = fragments.length;
	    function buildValue() {
	        var output = "";
	        for (var i = 0; i < numFragments; i++) {
	            output += fragments[i];
	            var value = values[i];
	            if (value)
	                output += values[i].get();
	        }
	        return output;
	    }
	    return useCombineMotionValues(values, buildValue);
	}
	
	var isCustomValueType = function (v) {
	    return typeof v === "object" && v.mix;
	};
	var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
	function transform() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var useImmediate = !Array.isArray(args[0]);
	    var argOffset = useImmediate ? 0 : -1;
	    var inputValue = args[0 + argOffset];
	    var inputRange = args[1 + argOffset];
	    var outputRange = args[2 + argOffset];
	    var options = args[3 + argOffset];
	    var interpolator = popmotion.interpolate(inputRange, outputRange, tslib.__assign({ mixer: getMixer(outputRange[0]) }, options));
	    return useImmediate ? interpolator(inputValue) : interpolator;
	}
	
	function useTransform(input, inputRangeOrTransformer, outputRange, options) {
	    var transformer = typeof inputRangeOrTransformer === "function"
	        ? inputRangeOrTransformer
	        : transform(inputRangeOrTransformer, outputRange, options);
	    return Array.isArray(input)
	        ? useListTransform(input, transformer)
	        : useListTransform([input], function (_a) {
	            var _b = tslib.__read(_a, 1), latest = _b[0];
	            return transformer(latest);
	        });
	}
	function useListTransform(values, transformer) {
	    var latest = useConstant(function () { return []; });
	    return useCombineMotionValues(values, function () {
	        latest.length = 0;
	        var numValues = values.length;
	        for (var i = 0; i < numValues; i++) {
	            latest[i] = values[i].get();
	        }
	        return transformer(latest);
	    });
	}
	
	/**
	 * Creates a `MotionValue` that, when `set`, will use a spring animation to animate to its new state.
	 *
	 * It can either work as a stand-alone `MotionValue` by initialising it with a value, or as a subscriber
	 * to another `MotionValue`.
	 *
	 * @remarks
	 *
	 * ```jsx
	 * const x = useSpring(0, { stiffness: 300 })
	 * const y = useSpring(x, { damping: 10 })
	 * ```
	 *
	 * @param inputValue - `MotionValue` or number. If provided a `MotionValue`, when the input `MotionValue` changes, the created `MotionValue` will spring towards that value.
	 * @param springConfig - Configuration options for the spring.
	 * @returns `MotionValue`
	 *
	 * @public
	 */
	function useSpring(source, config) {
	    if (config === void 0) { config = {}; }
	    var isStatic = React.useContext(MotionConfigContext).isStatic;
	    var activeSpringAnimation = React.useRef(null);
	    var value = useMotionValue(isMotionValue(source) ? source.get() : source);
	    React.useMemo(function () {
	        return value.attach(function (v, set) {
	            /**
	             * A more hollistic approach to this might be to use isStatic to fix VisualElement animations
	             * at that level, but this will work for now
	             */
	            if (isStatic)
	                return set(v);
	            if (activeSpringAnimation.current) {
	                activeSpringAnimation.current.stop();
	            }
	            activeSpringAnimation.current = popmotion.animate(tslib.__assign(tslib.__assign({ from: value.get(), to: v, velocity: value.getVelocity() }, config), { onUpdate: set }));
	            return value.get();
	        });
	    }, Object.values(config));
	    useOnChange(source, function (v) { return value.set(parseFloat(v)); });
	    return value;
	}
	
	/**
	 * Creates a `MotionValue` that updates when the velocity of the provided `MotionValue` changes.
	 *
	 * ```javascript
	 * const x = useMotionValue(0)
	 * const xVelocity = useVelocity(x)
	 * const xAcceleration = useVelocity(xVelocity)
	 * ```
	 *
	 * @public
	 */
	function useVelocity(value) {
	    var velocity = useMotionValue(value.getVelocity());
	    React.useEffect(function () {
	        return value.velocityUpdateSubscribers.add(function (newVelocity) {
	            velocity.set(newVelocity);
	        });
	    }, [value]);
	    return velocity;
	}
	
	function createScrollMotionValues() {
	    return {
	        scrollX: motionValue(0),
	        scrollY: motionValue(0),
	        scrollXProgress: motionValue(0),
	        scrollYProgress: motionValue(0),
	    };
	}
	function setProgress(offset, maxOffset, value) {
	    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
	}
	function createScrollUpdater(values, getOffsets) {
	    var update = function () {
	        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
	        // Set absolute positions
	        values.scrollX.set(xOffset);
	        values.scrollY.set(yOffset);
	        // Set 0-1 progress
	        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
	        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
	    };
	    update();
	    return update;
	}
	
	var getElementScrollOffsets = function (element) { return function () {
	    return {
	        xOffset: element.scrollLeft,
	        yOffset: element.scrollTop,
	        xMaxOffset: element.scrollWidth - element.offsetWidth,
	        yMaxOffset: element.scrollHeight - element.offsetHeight,
	    };
	}; };
	/**
	 * Returns MotionValues that update when the provided element scrolls:
	 *
	 * - `scrollX` — Horizontal scroll distance in pixels.
	 * - `scrollY` — Vertical scroll distance in pixels.
	 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
	 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
	 *
	 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
	 *
	 * @library
	 *
	 * ```jsx
	 * import * as React from "react"
	 * import {
	 *   Frame,
	 *   useElementScroll,
	 *   useTransform
	 * } from "framer"
	 *
	 * export function MyComponent() {
	 *   const ref = React.useRef()
	 *   const { scrollYProgress } = useElementScroll(ref)
	 *
	 *   return (
	 *     <Frame ref={ref}>
	 *       <Frame scaleX={scrollYProgress} />
	 *     </Frame>
	 *   )
	 * }
	 * ```
	 *
	 * @motion
	 *
	 * ```jsx
	 * export const MyComponent = () => {
	 *   const ref = useRef()
	 *   const { scrollYProgress } = useElementScroll(ref)
	 *
	 *   return (
	 *     <div ref={ref}>
	 *       <motion.div style={{ scaleX: scrollYProgress }} />
	 *     </div>
	 *   )
	 * }
	 * ```
	 *
	 * @public
	 */
	function useElementScroll(ref) {
	    var values = useConstant(createScrollMotionValues);
	    useIsomorphicLayoutEffect(function () {
	        var element = ref.current;
	        heyListen.invariant(!!element, "ref provided to useScroll must be passed into a HTML element.");
	        if (!element)
	            return;
	        var updateScrollValues = createScrollUpdater(values, getElementScrollOffsets(element));
	        var scrollListener = addDomEvent(element, "scroll", updateScrollValues, { passive: true });
	        var resizeListener = addDomEvent(element, "resize", updateScrollValues);
	        return function () {
	            scrollListener && scrollListener();
	            resizeListener && resizeListener();
	        };
	    }, []);
	    return values;
	}
	
	var viewportScrollValues;
	function getViewportScrollOffsets() {
	    return {
	        xOffset: window.pageXOffset,
	        yOffset: window.pageYOffset,
	        xMaxOffset: document.body.clientWidth - window.innerWidth,
	        yMaxOffset: document.body.clientHeight - window.innerHeight,
	    };
	}
	var hasListeners = false;
	function addEventListeners() {
	    hasListeners = true;
	    if (typeof window === "undefined")
	        return;
	    var updateScrollValues = createScrollUpdater(viewportScrollValues, getViewportScrollOffsets);
	    addDomEvent(window, "scroll", updateScrollValues, { passive: true });
	    addDomEvent(window, "resize", updateScrollValues);
	}
	/**
	 * Returns MotionValues that update when the viewport scrolls:
	 *
	 * - `scrollX` — Horizontal scroll distance in pixels.
	 * - `scrollY` — Vertical scroll distance in pixels.
	 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
	 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
	 *
	 * **Warning:** Setting `body` or `html` to `height: 100%` or similar will break the `Progress`
	 * values as this breaks the browser's capability to accurately measure the page length.
	 *
	 * @library
	 *
	 * ```jsx
	 * import * as React from "react"
	 * import {
	 *   Frame,
	 *   useViewportScroll,
	 *   useTransform
	 * } from "framer"
	 *
	 * export function MyComponent() {
	 *   const { scrollYProgress } = useViewportScroll()
	 *   return <Frame scaleX={scrollYProgress} />
	 * }
	 * ```
	 *
	 * @motion
	 *
	 * ```jsx
	 * export const MyComponent = () => {
	 *   const { scrollYProgress } = useViewportScroll()
	 *   return <motion.div style={{ scaleX: scrollYProgress }} />
	 * }
	 * ```
	 *
	 * @public
	 */
	function useViewportScroll() {
	    /**
	     * Lazy-initialise the viewport scroll values
	     */
	    if (!viewportScrollValues) {
	        viewportScrollValues = createScrollMotionValues();
	    }
	    useIsomorphicLayoutEffect(function () {
	        !hasListeners && addEventListeners();
	    }, []);
	    return viewportScrollValues;
	}
	
	// Does this device prefer reduced motion? Returns `null` server-side.
	var prefersReducedMotion;
	function initPrefersReducedMotion() {
	    prefersReducedMotion = motionValue(null);
	    if (typeof window === "undefined")
	        return;
	    if (window.matchMedia) {
	        var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
	        var setReducedMotionPreferences = function () {
	            return prefersReducedMotion.set(motionMediaQuery_1.matches);
	        };
	        motionMediaQuery_1.addListener(setReducedMotionPreferences);
	        setReducedMotionPreferences();
	    }
	    else {
	        prefersReducedMotion.set(false);
	    }
	}
	/**
	 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
	 *
	 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
	 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
	 *
	 * It will actively respond to changes and re-render your components with the latest setting.
	 *
	 * ```jsx
	 * export function Sidebar({ isOpen }) {
	 *   const shouldReduceMotion = useReducedMotion()
	 *   const closedX = shouldReduceMotion ? 0 : "-100%"
	 *
	 *   return (
	 *     <motion.div animate={{
	 *       opacity: isOpen ? 1 : 0,
	 *       x: isOpen ? 0 : closedX
	 *     }} />
	 *   )
	 * }
	 * ```
	 *
	 * @return boolean
	 *
	 * @public
	 */
	function useReducedMotion() {
	    /**
	     * Lazy initialisation of prefersReducedMotion
	     */
	    !prefersReducedMotion && initPrefersReducedMotion();
	    var _a = tslib.__read(React.useState(prefersReducedMotion.get()), 2), shouldReduceMotion = _a[0], setShouldReduceMotion = _a[1];
	    useOnChange(prefersReducedMotion, setShouldReduceMotion);
	    return shouldReduceMotion;
	}
	
	/**
	 * @public
	 */
	function animationControls() {
	    /**
	     * Track whether the host component has mounted.
	     */
	    var hasMounted = false;
	    /**
	     * Pending animations that are started before a component is mounted.
	     * TODO: Remove this as animations should only run in effects
	     */
	    var pendingAnimations = [];
	    /**
	     * A collection of linked component animation controls.
	     */
	    var subscribers = new Set();
	    var controls = {
	        subscribe: function (visualElement) {
	            subscribers.add(visualElement);
	            return function () { return void subscribers.delete(visualElement); };
	        },
	        start: function (definition, transitionOverride) {
	            /**
	             * TODO: We only perform this hasMounted check because in Framer we used to
	             * encourage the ability to start an animation within the render phase. This
	             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
	             * we can ditch this.
	             */
	            if (hasMounted) {
	                var animations_1 = [];
	                subscribers.forEach(function (visualElement) {
	                    animations_1.push(animateVisualElement(visualElement, definition, {
	                        transitionOverride: transitionOverride,
	                    }));
	                });
	                return Promise.all(animations_1);
	            }
	            else {
	                return new Promise(function (resolve) {
	                    pendingAnimations.push({
	                        animation: [definition, transitionOverride],
	                        resolve: resolve,
	                    });
	                });
	            }
	        },
	        set: function (definition) {
	            heyListen.invariant(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
	            return subscribers.forEach(function (visualElement) {
	                setValues(visualElement, definition);
	            });
	        },
	        stop: function () {
	            subscribers.forEach(function (visualElement) {
	                stopAnimation(visualElement);
	            });
	        },
	        mount: function () {
	            hasMounted = true;
	            pendingAnimations.forEach(function (_a) {
	                var animation = _a.animation, resolve = _a.resolve;
	                controls.start.apply(controls, tslib.__spreadArray([], tslib.__read(animation))).then(resolve);
	            });
	            return function () {
	                hasMounted = false;
	                controls.stop();
	            };
	        },
	    };
	    return controls;
	}
	
	/**
	 * Creates `AnimationControls`, which can be used to manually start, stop
	 * and sequence animations on one or more components.
	 *
	 * The returned `AnimationControls` should be passed to the `animate` property
	 * of the components you want to animate.
	 *
	 * These components can then be animated with the `start` method.
	 *
	 * @library
	 *
	 * ```jsx
	 * import * as React from 'react'
	 * import { Frame, useAnimation } from 'framer'
	 *
	 * export function MyComponent(props) {
	 *    const controls = useAnimation()
	 *
	 *    controls.start({
	 *        x: 100,
	 *        transition: { duration: 0.5 },
	 *    })
	 *
	 *    return <Frame animate={controls} />
	 * }
	 * ```
	 *
	 * @motion
	 *
	 * ```jsx
	 * import * as React from 'react'
	 * import { motion, useAnimation } from 'framer-motion'
	 *
	 * export function MyComponent(props) {
	 *    const controls = useAnimation()
	 *
	 *    controls.start({
	 *        x: 100,
	 *        transition: { duration: 0.5 },
	 *    })
	 *
	 *    return <motion.div animate={controls} />
	 * }
	 * ```
	 *
	 * @returns Animation controller with `start` and `stop` methods
	 *
	 * @public
	 */
	function useAnimation() {
	    var controls = useConstant(animationControls);
	    React.useEffect(controls.mount, []);
	    return controls;
	}
	
	/**
	 * Cycles through a series of visual properties. Can be used to toggle between or cycle through animations. It works similar to `useState` in React. It is provided an initial array of possible states, and returns an array of two arguments.
	 *
	 * @library
	 *
	 * ```jsx
	 * import * as React from "react"
	 * import { Frame, useCycle } from "framer"
	 *
	 * export function MyComponent() {
	 *   const [x, cycleX] = useCycle(0, 50, 100)
	 *
	 *   return (
	 *     <Frame
	 *       animate={{ x: x }}
	 *       onTap={() => cycleX()}
	 *      />
	 *    )
	 * }
	 * ```
	 *
	 * @motion
	 *
	 * An index value can be passed to the returned `cycle` function to cycle to a specific index.
	 *
	 * ```jsx
	 * import * as React from "react"
	 * import { motion, useCycle } from "framer-motion"
	 *
	 * export const MyComponent = () => {
	 *   const [x, cycleX] = useCycle(0, 50, 100)
	 *
	 *   return (
	 *     <motion.div
	 *       animate={{ x: x }}
	 *       onTap={() => cycleX()}
	 *      />
	 *    )
	 * }
	 * ```
	 *
	 * @param items - items to cycle through
	 * @returns [currentState, cycleState]
	 *
	 * @public
	 */
	function useCycle() {
	    var items = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        items[_i] = arguments[_i];
	    }
	    var index = React.useRef(0);
	    var _a = tslib.__read(React.useState(items[index.current]), 2), item = _a[0], setItem = _a[1];
	    return [
	        item,
	        function (next) {
	            index.current =
	                typeof next !== "number"
	                    ? popmotion.wrap(0, items.length, index.current + 1)
	                    : next;
	            setItem(items[index.current]);
	        },
	    ];
	}
	
	/**
	 * Can manually trigger a drag gesture on one or more `drag`-enabled `motion` components.
	 *
	 * @library
	 *
	 * ```jsx
	 * const dragControls = useDragControls()
	 *
	 * function startDrag(event) {
	 *   dragControls.start(event, { snapToCursor: true })
	 * }
	 *
	 * return (
	 *   <>
	 *     <Frame onTapStart={startDrag} />
	 *     <Frame drag="x" dragControls={dragControls} />
	 *   </>
	 * )
	 * ```
	 *
	 * @motion
	 *
	 * ```jsx
	 * const dragControls = useDragControls()
	 *
	 * function startDrag(event) {
	 *   dragControls.start(event, { snapToCursor: true })
	 * }
	 *
	 * return (
	 *   <>
	 *     <div onPointerDown={startDrag} />
	 *     <motion.div drag="x" dragControls={dragControls} />
	 *   </>
	 * )
	 * ```
	 *
	 * @public
	 */
	var DragControls = /** @class */ (function () {
	    function DragControls() {
	        this.componentControls = new Set();
	    }
	    /**
	     * Subscribe a component's internal `VisualElementDragControls` to the user-facing API.
	     *
	     * @internal
	     */
	    DragControls.prototype.subscribe = function (controls) {
	        var _this = this;
	        this.componentControls.add(controls);
	        return function () { return _this.componentControls.delete(controls); };
	    };
	    /**
	     * Start a drag gesture on every `motion` component that has this set of drag controls
	     * passed into it via the `dragControls` prop.
	     *
	     * ```jsx
	     * dragControls.start(e, {
	     *   snapToCursor: true
	     * })
	     * ```
	     *
	     * @param event - PointerEvent
	     * @param options - Options
	     *
	     * @public
	     */
	    DragControls.prototype.start = function (event, options) {
	        this.componentControls.forEach(function (controls) {
	            controls.start(event.nativeEvent || event, options);
	        });
	    };
	    DragControls.prototype.updateConstraints = function (flush) {
	        if (flush === void 0) { flush = true; }
	        this.componentControls.forEach(function (controls) {
	            controls.updateConstraints();
	        });
	        flush && flushLayout();
	    };
	    return DragControls;
	}());
	var createDragControls = function () { return new DragControls(); };
	/**
	 * Usually, dragging is initiated by pressing down on a `motion` component with a `drag` prop
	 * and moving it. For some use-cases, for instance clicking at an arbitrary point on a video scrubber, we
	 * might want to initiate that dragging from a different component than the draggable one.
	 *
	 * By creating a `dragControls` using the `useDragControls` hook, we can pass this into
	 * the draggable component's `dragControls` prop. It exposes a `start` method
	 * that can start dragging from pointer events on other components.
	 *
	 * @library
	 *
	 * ```jsx
	 * const dragControls = useDragControls()
	 *
	 * function startDrag(event) {
	 *   dragControls.start(event, { snapToCursor: true })
	 * }
	 *
	 * return (
	 *   <>
	 *     <Frame onTapStart={startDrag} />
	 *     <Frame drag="x" dragControls={dragControls} />
	 *   </>
	 * )
	 * ```
	 *
	 * @motion
	 *
	 * ```jsx
	 * const dragControls = useDragControls()
	 *
	 * function startDrag(event) {
	 *   dragControls.start(event, { snapToCursor: true })
	 * }
	 *
	 * return (
	 *   <>
	 *     <div onPointerDown={startDrag} />
	 *     <motion.div drag="x" dragControls={dragControls} />
	 *   </>
	 * )
	 * ```
	 *
	 * @public
	 */
	function useDragControls() {
	    return useConstant(createDragControls);
	}
	
	var createObject = function () { return ({}); };
	var stateVisualElement = visualElement({
	    build: function () { },
	    measureViewportBox: axisBox,
	    resetTransform: function () { },
	    restoreTransform: function () { },
	    removeValueFromRenderState: function () { },
	    render: function () { },
	    scrapeMotionValuesFromProps: createObject,
	    readValueFromInstance: function (_state, key, options) {
	        return options.initialState[key] || 0;
	    },
	    makeTargetAnimatable: function (element, _a) {
	        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = tslib.__rest(_a, ["transition", "transitionEnd"]);
	        var origin = getOrigin(target, transition || {}, element);
	        checkTargetForNewValues(element, target, origin);
	        return tslib.__assign({ transition: transition, transitionEnd: transitionEnd }, target);
	    },
	});
	var useVisualState = makeUseVisualState({
	    scrapeMotionValuesFromProps: createObject,
	    createRenderState: createObject,
	});
	/**
	 * This is not an officially supported API and may be removed
	 * on any version.
	 * @internal
	 */
	function useAnimatedState(initialState) {
	    var _a = tslib.__read(React.useState(initialState), 2), animationState = _a[0], setAnimationState = _a[1];
	    var visualState = useVisualState({}, false);
	    var element = useConstant(function () {
	        return stateVisualElement({ props: {}, visualState: visualState }, { initialState: initialState });
	    });
	    React.useEffect(function () {
	        element.mount({});
	        return element.unmount();
	    }, []);
	    React.useEffect(function () {
	        element.setProps({
	            onUpdate: function (v) { return setAnimationState(tslib.__assign({}, v)); },
	        });
	    });
	    var startAnimation = useConstant(function () { return function (animationDefinition) {
	        return animateVisualElement(element, animationDefinition);
	    }; });
	    return [animationState, startAnimation];
	}
	
	// Keep things reasonable and avoid scale: Infinity. In practise we might need
	// to add another value, opacity, that could interpolate scaleX/Y [0,0.01] => [0,1]
	// to simply hide content at unreasonable scales.
	var maxScale = 100000;
	var invertScale = function (scale) {
	    return scale > 0.001 ? 1 / scale : maxScale;
	};
	var hasWarned = false;
	/**
	 * Returns a `MotionValue` each for `scaleX` and `scaleY` that update with the inverse
	 * of their respective parent scales.
	 *
	 * This is useful for undoing the distortion of content when scaling a parent component.
	 *
	 * By default, `useInvertedScale` will automatically fetch `scaleX` and `scaleY` from the nearest parent.
	 * By passing other `MotionValue`s in as `useInvertedScale({ scaleX, scaleY })`, it will invert the output
	 * of those instead.
	 *
	 * @motion
	 *
	 * ```jsx
	 * const MyComponent = () => {
	 *   const { scaleX, scaleY } = useInvertedScale()
	 *   return <motion.div style={{ scaleX, scaleY }} />
	 * }
	 * ```
	 *
	 * @library
	 *
	 * ```jsx
	 * function MyComponent() {
	 *   const { scaleX, scaleY } = useInvertedScale()
	 *   return <Frame scaleX={scaleX} scaleY={scaleY} />
	 * }
	 * ```
	 *
	 * @deprecated
	 * @internal
	 */
	function useInvertedScale(scale) {
	    var parentScaleX = useMotionValue(1);
	    var parentScaleY = useMotionValue(1);
	    var visualElement = useVisualElementContext();
	    heyListen.invariant(!!(scale || visualElement), "If no scale values are provided, useInvertedScale must be used within a child of another motion component.");
	    heyListen.warning(hasWarned, "useInvertedScale is deprecated and will be removed in 3.0. Use the layout prop instead.");
	    hasWarned = true;
	    if (scale) {
	        parentScaleX = scale.scaleX || parentScaleX;
	        parentScaleY = scale.scaleY || parentScaleY;
	    }
	    else if (visualElement) {
	        parentScaleX = visualElement.getValue("scaleX", 1);
	        parentScaleY = visualElement.getValue("scaleY", 1);
	    }
	    var scaleX = useTransform(parentScaleX, invertScale);
	    var scaleY = useTransform(parentScaleY, invertScale);
	    return { scaleX: scaleX, scaleY: scaleY };
	}
	
	exports.AnimatePresence = AnimatePresence;
	exports.AnimateSharedLayout = AnimateSharedLayout;
	exports.DragControls = DragControls;
	exports.FlatTree = FlatTree;
	exports.FramerTreeLayoutContext = FramerTreeLayoutContext;
	exports.LayoutGroupContext = LayoutGroupContext;
	exports.LazyMotion = LazyMotion;
	exports.MotionConfig = MotionConfig;
	exports.MotionConfigContext = MotionConfigContext;
	exports.MotionValue = MotionValue;
	exports.PresenceContext = PresenceContext;
	exports.SharedLayoutContext = SharedLayoutContext;
	exports.addScaleCorrection = addScaleCorrection;
	exports.animate = animate;
	exports.animateVisualElement = animateVisualElement;
	exports.animationControls = animationControls;
	exports.batchLayout = batchLayout;
	exports.createBatcher = createBatcher;
	exports.createCrossfader = createCrossfader;
	exports.createDomMotionComponent = createDomMotionComponent;
	exports.createMotionComponent = createMotionComponent;
	exports.domAnimation = domAnimation;
	exports.domMax = domMax;
	exports.flushLayout = flushLayout;
	exports.isValidMotionProp = isValidMotionProp;
	exports.m = m;
	exports.motion = motion;
	exports.motionValue = motionValue;
	exports.resolveMotionValue = resolveMotionValue;
	exports.snapshotViewportBox = snapshotViewportBox;
	exports.transform = transform;
	exports.useAnimation = useAnimation;
	exports.useCycle = useCycle;
	exports.useDeprecatedAnimatedState = useAnimatedState;
	exports.useDeprecatedInvertedScale = useInvertedScale;
	exports.useDomEvent = useDomEvent;
	exports.useDragControls = useDragControls;
	exports.useElementScroll = useElementScroll;
	exports.useIsPresent = useIsPresent;
	exports.useMotionTemplate = useMotionTemplate;
	exports.useMotionValue = useMotionValue;
	exports.usePresence = usePresence;
	exports.useReducedMotion = useReducedMotion;
	exports.useSpring = useSpring;
	exports.useTransform = useTransform;
	exports.useVelocity = useVelocity;
	exports.useViewportScroll = useViewportScroll;
	exports.visualElement = visualElement;


/***/ },
/* 660 */
29,
/* 661 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 662 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 663 */
/***/ function(module, exports) {

	module.exports = {
		"IcoMoonType": "selection",
		"icons": [
			{
				"icon": {
					"paths": [
						"M48 1024h672c26.464 0 48-21.536 48-48v-240c0-0.32-0.16-0.576-0.192-0.896 1.76-1.12 3.584-2.176 5.312-3.36l255.552 255.552c3.136 3.136 7.232 4.704 11.328 4.704s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-253.216-253.216c40.448-37.984 65.888-91.776 65.888-151.488 0-73.504-38.432-138.112-96.192-175.104 0.032-0.32 0.192-0.576 0.192-0.896v-80c0-0.544-0.256-0.992-0.288-1.504-0.064-0.736-0.256-1.376-0.416-2.080-0.544-2.272-1.472-4.32-2.88-6.112-0.224-0.288-0.192-0.64-0.416-0.928l-256-288c-0.096-0.096-0.224-0.096-0.32-0.192-1.92-2.080-4.384-3.456-7.136-4.288-0.608-0.192-1.152-0.256-1.792-0.352-0.928-0.16-1.792-0.544-2.752-0.544h-448c-26.464 0-48 21.536-48 48v928c0 26.464 21.536 48 48 48zM832 560c0 97.056-78.976 176-176 176s-176-78.944-176-176 78.976-176 176-176 176 78.944 176 176zM512 58.080l204.384 229.92h-188.384c-7.040 0-16-13.44-16-24v-205.92zM32 48c0-8.832 7.2-16 16-16h432v232c0 25.888 20.96 56 48 56h208v48.032c-24.64-10.304-51.648-16.032-80-16.032-58.816 0-111.872 24.64-149.728 64h-330.272c-8.832 0-16 7.168-16 16s7.168 16 16 16h305.024c-18.080 28.128-29.504 60.832-32.192 96h-272.832c-8.832 0-16 7.168-16 16s7.168 16 16 16h272.8c2.688 35.168 14.144 67.872 32.192 96h-304.992c-8.832 0-16 7.168-16 16s7.168 16 16 16h328c0.672 0 1.248-0.288 1.92-0.384 37.888 39.584 91.104 64.384 150.080 64.384 28.352 0 55.36-5.728 80-16.064v224.064c0 8.832-7.2 16-16 16h-672c-8.96 0-16-7.040-16-16v-928zM176 320h192c8.832 0 16-7.168 16-16s-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16zM176 832h416c8.832 0 16-7.168 16-16s-7.168-16-16-16h-416c-8.832 0-16 7.168-16 16s7.168 16 16 16z"
					],
					"width": 1056,
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"search",
						"lookup",
						"find",
						"magnifier"
					],
					"grid": 32
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 0,
					"prevSize": 32,
					"code": 59691,
					"name": "search1"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 0
			},
			{
				"icon": {
					"paths": [
						"M1152.064 736.32l1.824-546.848-993.6 0.608-0.032-62.72h1055.744v608.992l-63.936-0.032zM1119.84 832.544l-63.904-0.064 1.824-546.848-993.6 0.64-0.032-62.72h1055.744v608.992zM1025.696 896.64h-1025.696v-576.96h1025.696v576.96zM961.568 381.792h-897.472v450.752h897.44v-450.752zM865.44 784.48c0 5.664 1.408 10.944 3.232 16h-355.84c88.512 0 160.288-86.080 160.288-192.32s-71.776-192.32-160.288-192.32h355.808c-1.824 5.056-3.232 10.336-3.232 16.032 0 26.56 21.504 48.064 48.064 48.064 5.696 0 10.976-1.408 16.032-3.232v262.88c-5.056-1.792-10.336-3.232-16.032-3.232-26.528 0.032-48.032 21.568-48.032 48.128zM801.312 541.408c-26.56 0-48.064 28.672-48.064 64.096s21.504 64.096 48.064 64.096 48.064-28.672 48.064-64.096-21.504-64.096-48.064-64.096zM579.936 492.608c0.48 0.928 0.864 2.176 1.184 3.712 0.352 1.536 0.576 3.488 0.672 5.824 0.16 2.336 0.224 5.248 0.224 8.736 0 3.872-0.096 7.168-0.288 9.824-0.224 2.688-0.576 4.896-0.992 6.624-0.512 1.76-1.152 3.040-1.984 3.808-0.864 0.8-2.048 1.216-3.52 1.216s-3.776-0.928-7.008-2.784c-3.232-1.888-7.168-3.872-11.808-6.048s-10.080-4.192-16.224-5.984-12.864-2.688-20.224-2.688c-5.76 0-10.752 0.672-15.008 2.080-4.288 1.408-7.872 3.328-10.72 5.792-2.88 2.464-5.024 5.44-6.4 8.864-1.408 3.456-2.112 7.136-2.112 10.976 0 5.76 1.568 10.72 4.704 14.944 3.136 4.192 7.328 7.936 12.64 11.2 5.28 3.296 11.264 6.336 17.92 9.216s13.472 5.92 20.416 9.088c6.944 3.232 13.76 6.848 20.448 10.944 6.688 4.064 12.64 8.928 17.824 14.592 5.216 5.696 9.44 12.352 12.64 20.032s4.8 16.704 4.8 27.136c0 13.6-2.56 25.568-7.616 35.808-5.056 10.272-11.936 18.88-20.64 25.76s-18.816 12.032-30.432 15.488c-1.472 0.448-3.072 0.64-4.576 0.992v35.008h-31.52v-30.88c-0.416 0-0.768 0.096-1.184 0.096-8.928 0-17.248-0.736-24.928-2.176-7.68-1.472-14.464-3.232-20.32-5.248-5.888-2.048-10.784-4.224-14.72-6.464-3.968-2.24-6.784-4.224-8.512-5.952s-2.976-4.224-3.712-7.488-1.12-8-1.12-14.144c0-4.128 0.128-7.616 0.416-10.4 0.256-2.816 0.704-5.088 1.312-6.848 0.608-1.728 1.408-2.976 2.4-3.712 0.992-0.704 2.176-1.088 3.488-1.088 1.888 0 4.512 1.088 7.936 3.328 3.392 2.176 7.776 4.64 13.12 7.296s11.712 5.088 19.136 7.296c7.392 2.208 16 3.328 25.728 3.328 6.4 0 12.16-0.768 17.216-2.304 5.088-1.536 9.376-3.712 12.928-6.496 3.52-2.816 6.208-6.304 8.096-10.432 1.888-4.16 2.816-8.768 2.816-13.856 0-5.888-1.632-10.944-4.8-15.136-3.2-4.224-7.36-7.936-12.512-11.232-5.152-3.264-10.976-6.336-17.504-9.184-6.56-2.88-13.28-5.92-20.224-9.12s-13.696-6.848-20.224-10.912c-6.528-4.064-12.384-8.928-17.504-14.624-5.12-5.664-9.312-12.384-12.512-20.096-3.2-7.744-4.8-17.024-4.8-27.84 0-12.416 2.304-23.328 6.912-32.704 4.608-9.408 10.816-17.216 18.624-23.424 7.808-6.176 17.024-10.848 27.616-13.92 5.44-1.568 11.072-2.72 16.864-3.488v-33.12h31.52v33.12c1.248 0.16 2.496 0.096 3.744 0.288 6.144 0.928 11.904 2.176 17.248 3.776 5.312 1.6 10.048 3.36 14.176 5.376 4.16 1.984 6.88 3.616 8.256 4.96 1.248 1.184 2.144 2.304 2.624 3.264zM352.576 608.16c0 106.208 71.744 192.32 160.256 192.32h-355.808c1.792-5.056 3.232-10.336 3.232-16 0-26.56-21.536-48.096-48.064-48.096-5.696 0-10.976 1.44-16.032 3.232v-262.88c5.056 1.824 10.336 3.232 16.032 3.232 26.56 0 48.064-21.504 48.064-48.064 0-5.696-1.44-10.976-3.232-16.032h355.808c-88.512-0.032-160.256 86.080-160.256 192.288zM224.352 541.408c-26.56 0-48.064 28.672-48.064 64.096s21.536 64.096 48.064 64.096c26.56 0 48.064-28.672 48.064-64.096s-21.504-64.096-48.064-64.096z"
					],
					"width": 1216,
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"dollar",
						"bill",
						"money",
						"stack"
					],
					"grid": 32
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 1,
					"prevSize": 32,
					"code": 59675,
					"name": "dollar"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 1
			},
			{
				"icon": {
					"paths": [
						"M512 801.6l-104-104-24 24 144 144 144-144-24-24-104 104v-353.6h-32v353.6zM624 96h16l192 224v576.295c0 34.963-28.617 63.705-63.918 63.705h-480.165c-35.408 0-63.918-28.759-63.918-64.235v-735.531c0-35.488 28.693-64.235 64.088-64.235h335.912zM608 128h-320.142c-17.595 0-31.858 14.568-31.858 31.855v736.291c0 17.593 14.551 31.855 31.999 31.855h480.003c17.672 0 31.999-14.238 31.999-31.789v-544.211h-128.067c-35.309 0-63.933-28.37-63.933-64.189v-159.811zM640 144v143.719c0 17.828 14.421 32.281 31.896 32.281h118.503l-150.398-176z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"document-download"
					],
					"grid": 32
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 2,
					"prevSize": 32,
					"code": 59693,
					"name": "document-download"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 2
			},
			{
				"icon": {
					"paths": [
						"M846.183 388.811l-361.159 361.586-83.378-83.378 361.347-361.398 83.19 83.19zM868.797 366.17l-83.178-83.178 55.274-55.282c12.523-12.525 32.766-12.428 45.33 0.102l37.754 37.65c12.541 12.506 12.633 32.815 0.153 45.309l-55.334 55.399zM380.919 691.546l79.851 79.851-100.317 19.755 20.465-99.606zM704 320v0l-192-224h-351.912c-35.395 0-64.088 28.747-64.088 64.235v735.531c0 35.476 28.51 64.235 63.918 64.235h480.165c35.301 0 63.918-28.743 63.918-63.705v-320.295l242.563-242.563c25.094-25.094 25.155-65.719 0.309-90.565l-37.744-37.744c-24.924-24.924-65.199-25.057-90.565 0.309l-114.563 114.563zM672 608v288.211c0 17.55-14.326 31.789-31.999 31.789h-480.003c-17.448 0-31.999-14.262-31.999-31.855v-736.291c0-17.286 14.264-31.855 31.858-31.855h320.142v159.811c0 35.82 28.624 64.189 63.933 64.189h128.067l-320 320-32 160 160-32 192-192zM512 144l150.398 176h-118.503c-17.475 0-31.896-14.453-31.896-32.281v-143.719z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"document-edit"
					],
					"grid": 32
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 3,
					"prevSize": 32,
					"code": 59689,
					"name": "document-edit"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 3
			},
			{
				"icon": {
					"paths": [
						"M972.512 405.76l-98.048-19.648c-4.928-14.176-10.752-27.936-17.184-41.248l55.552-83.328c16.928-25.376 13.568-59.2-8-80.736l-61.568-61.568c-12.384-12.384-28.736-18.752-45.312-18.752-12.256 0-24.64 3.52-35.424 10.752l-83.328 55.52c-13.376-6.464-27.136-12.224-41.312-17.152l-19.648-98.080c-5.952-29.952-32.256-51.456-62.752-51.456h-87.040c-30.496 0-56.768 21.536-62.752 51.456l-19.648 98.080c-14.176 4.928-27.936 10.72-41.248 17.152l-83.296-55.52c-10.848-7.232-23.2-10.752-35.488-10.752-16.544 0-32.896 6.368-45.28 18.752l-61.536 61.568c-21.568 21.568-24.928 55.36-8 80.736l55.52 83.328c-6.464 13.344-12.224 27.104-17.152 41.28l-98.112 19.616c-29.92 5.984-51.456 32.256-51.456 62.752v87.040c0 30.496 21.536 56.8 51.456 62.752l98.080 19.68c4.928 14.176 10.72 27.936 17.152 41.248l-55.488 83.328c-16.928 25.376-13.568 59.2 8 80.736l61.568 61.568c12.384 12.384 28.736 18.752 45.28 18.752 12.288 0 24.672-3.552 35.456-10.752l83.328-55.552c13.344 6.496 27.104 12.256 41.28 17.184l19.616 98.048c5.984 29.952 32.256 51.488 62.752 51.488h87.040c30.496 0 56.8-21.568 62.752-51.488l19.68-98.048c14.176-4.928 27.936-10.752 41.248-17.184l83.328 55.552c10.816 7.2 23.2 10.752 35.424 10.752 16.576 0 32.928-6.368 45.312-18.752l61.568-61.568c21.568-21.568 24.928-55.36 8-80.736l-55.552-83.328c6.496-13.376 12.256-27.136 17.184-41.312l98.048-19.616c29.92-5.92 51.488-32.256 51.488-62.752v-87.040c0-30.496-21.568-56.768-51.488-62.752zM861.888 575.2c-22.24 4.448-40.448 20.32-47.872 41.76-4.128 11.808-8.928 23.264-14.304 34.368-9.952 20.448-8.256 44.576 4.32 63.424l55.552 83.328-61.568 61.568-83.328-55.552c-10.688-7.136-23.072-10.752-35.488-10.752-9.504 0-19.072 2.112-27.872 6.368-11.136 5.376-22.56 10.24-34.432 14.368-21.376 7.424-37.248 25.632-41.696 47.872l-19.68 98.112h-87.040l-19.616-98.112c-4.448-22.24-20.32-40.448-41.728-47.872-11.808-4.128-23.296-8.928-34.4-14.304-8.832-4.32-18.368-6.432-27.904-6.432-12.448 0-24.8 3.616-35.488 10.752l-83.328 55.552-61.568-61.568 55.52-83.328c12.576-18.88 14.208-43.008 4.384-63.36-5.376-11.136-10.208-22.56-14.336-34.432-7.424-21.376-25.664-37.248-47.872-41.696l-98.080-19.68-0.064-87.072 98.112-19.616c22.208-4.448 40.448-20.32 47.872-41.728 4.128-11.808 8.896-23.296 14.304-34.4 9.92-20.416 8.256-44.544-4.352-63.392l-55.488-83.328 61.536-61.568 83.328 55.52c10.688 7.136 23.072 10.752 35.488 10.752 9.504 0 19.040-2.112 27.872-6.368 11.104-5.376 22.56-10.208 34.4-14.336 21.408-7.424 37.28-25.664 41.728-47.872l19.648-98.080 87.040-0.032 19.616 98.112c4.448 22.208 20.32 40.448 41.76 47.872 11.808 4.128 23.264 8.896 34.368 14.304 8.864 4.288 18.368 6.4 27.936 6.4 12.448 0 24.8-3.616 35.488-10.752l83.328-55.52 61.568 61.568-55.552 83.328c-12.576 18.88-14.176 42.976-4.384 63.36 5.376 11.104 10.24 22.56 14.368 34.4 7.424 21.408 25.632 37.28 47.872 41.728l98.048 19.648 0.096 87.040-98.112 19.648zM512 288.032c-123.68 0-224 100.32-224 224 0 123.712 100.32 224 224 224s224-100.32 224-224c0-123.68-100.32-224-224-224zM512 708.064c-108.224 0-196-87.808-196-196 0-108.224 87.776-196 196-196 108.192 0 196 87.776 196 196 0 108.192-87.808 196-196 196zM512 384.032c-70.72 0-128 57.28-128 128 0 70.688 57.28 128 128 128 70.688 0 128-57.312 128-128 0-70.688-57.312-128-128-128zM512 608.064c-52.992 0-96-43.008-96-96 0-52.992 43.008-96 96-96s96 43.008 96 96c0 52.992-43.008 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"settings",
						"cog",
						"preferences"
					],
					"grid": 32
				},
				"attrs": [],
				"properties": {
					"id": 4,
					"order": 54,
					"prevSize": 32,
					"code": 59656,
					"name": "settings"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 4
			},
			{
				"icon": {
					"paths": [
						"M800 416v-128c0-159.072-128.928-288-288-288s-288 128.928-288 288v128c-53.024 0-96 42.976-96 96v96 32 64 32c0 159.072 128.928 288 288 288h192c159.072 0 288-128.928 288-288v-32-64-32-96c0-53.056-43.008-96-96-96zM288 288c0-123.712 100.288-224 224-224s224 100.288 224 224v128h-64v-127.936c0-88.384-71.616-160-160-160s-160 71.616-160 160v127.936h-64v-128zM640 288v0.096 127.904h-256v-127.936-0.064c0-70.688 57.312-128 128-128s128 57.312 128 128zM832 608v32 64 32c0 123.488-100.512 224-224 224h-192c-123.488 0-224-100.512-224-224v-32-64-32-96c0-17.664 14.336-32 32-32 21.344 0 42.656 0 64 0h448c21.312 0 42.624 0 64 0 17.632 0 32 14.336 32 32v96zM512 608c35.328 0 64 28.64 64 64 0 19.488-10.496 56.576-21.312 85.824-8.736 23.616-17.664 42.112-42.688 42.112-23.008 0-33.952-18.688-42.656-42.432-10.688-29.184-21.344-66.080-21.344-85.504 0-35.36 28.672-64 64-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"lock",
						"security",
						"private",
						"encryption"
					],
					"grid": 32
				},
				"attrs": [],
				"properties": {
					"id": 5,
					"order": 92,
					"prevSize": 32,
					"code": 59678,
					"name": "lock"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 5
			},
			{
				"icon": {
					"paths": [
						"M1005.28 338.752l-320-320c-15.872-15.872-38.88-22.24-60.672-16.864-11.488 2.816-21.76 8.736-29.888 16.864-7.264 7.264-12.736 16.256-15.872 26.304-14.496 47.008-39.552 87.872-76.64 124.928-49.536 49.504-114.048 87.008-182.304 126.656-72.448 41.984-147.296 85.504-208.64 146.816-52.128 52.192-87.616 110.24-108.416 177.632-7.008 22.752-0.896 47.36 15.872 64.192l320 320c15.872 15.872 38.88 22.24 60.672 16.864 11.488-2.88 21.76-8.736 29.888-16.864 7.264-7.264 12.736-16.256 15.872-26.368 14.528-47.008 39.584-87.872 76.704-124.928 49.504-49.504 113.984-86.944 182.304-126.56 72.384-42.048 147.264-85.568 208.576-146.88 52.128-52.128 87.616-110.24 108.448-177.632 6.976-22.72 0.832-47.424-15.904-64.16zM384 960c-105.984-105.984-214.016-214.048-320-320 90.944-294.432 485.12-281.568 576-576 105.984 105.952 214.048 214.016 320.064 320-90.976 294.368-485.152 281.568-576.064 576zM625.984 476.8c-10.432-8.736-20.928-14.688-31.488-17.632-10.496-2.944-20.992-4.128-31.616-3.36-10.496 0.8-21.248 3.2-32 7.328-10.752 4.192-21.568 8.736-32.448 14.016-17.184-19.744-34.368-39.264-51.552-57.376 7.744-7.008 15.264-10.56 22.496-10.816 7.264-0.32 14.24 0.448 20.864 2.112 6.752 1.696 12.928 3.136 18.624 4.256 5.76 1.12 10.752-0.128 15.136-3.808 4.64-4 7.2-9.184 7.552-15.424 0.32-6.304-2.048-12.448-7.328-18.432-6.752-7.744-14.88-12.448-24.64-14.176-9.632-1.696-19.488-1.568-29.76 0.672-10.112 2.304-19.744 6.112-28.864 11.488s-16.448 10.88-21.888 16.256c-2.080-1.984-4.16-3.936-6.24-5.888-2.304-2.112-5.184-3.264-8.64-3.2-3.488 0-6.368 1.504-8.736 4.256-2.304 2.688-3.36 5.824-2.944 9.12 0.32 3.424 1.696 6.048 4.064 8.064 2.080 1.76 4.16 3.488 6.24 5.312-8.192 9.888-14.944 20.8-20.256 32.32-5.376 11.552-8.576 23.008-9.76 34.112-1.248 11.2-0.064 21.44 3.36 30.944 3.424 9.568 9.76 17.696 19.008 25.376 15.072 12.512 32.8 17.824 53.376 16.64 20.512-1.248 42.624-7.36 66.4-20.128 18.88 21.824 37.824 43.488 56.736 63.616-8 6.752-15.008 10.624-21.184 11.872-6.176 1.312-11.68 1.184-16.672-0.32-4.992-1.568-9.632-3.808-13.888-6.688-4.256-2.944-8.448-5.44-12.64-7.488-4.128-2.048-8.384-3.2-12.736-3.264s-8.992 2.048-14.112 6.432c-5.248 4.576-7.872 9.888-7.872 15.872 0 5.952 2.752 12 8.128 18.112 5.44 6.112 12.512 11.264 21.056 15.328s18.208 6.624 28.832 7.328c10.624 0.736 21.824-0.864 33.632-5.248 11.872-4.32 23.616-12.128 35.2-23.744 5.568 5.44 11.2 10.624 16.8 15.616 2.368 2.048 5.248 3.072 8.736 2.816 3.36-0.128 6.304-1.696 8.64-4.512 2.368-2.88 3.36-6.048 3.008-9.376-0.32-3.36-1.696-5.952-4-7.808-5.632-4.512-11.264-9.248-16.864-14.24 9.568-11.744 17.248-24.128 22.944-36.384 5.696-12.32 9.056-24.192 10.176-35.2 1.12-11.072-0.192-21.056-3.808-30.112-3.584-9.184-9.952-17.056-19.072-24.64zM447.072 498.496c-9.056 0.384-16.96-2.624-23.872-9.312-2.944-2.816-4.992-6.24-6.24-10.304-1.312-4.064-1.76-8.512-1.248-13.376 0.448-4.8 1.888-9.824 4.384-14.88 2.368-5.056 5.888-10.112 10.368-15.008 16.224 16.128 32.416 33.824 48.64 52.128-12.288 6.752-22.976 10.368-32.032 10.752zM598.016 562.56c-2.88 5.312-6.176 10.048-10.048 14.176-17.952-18.112-35.872-38.016-53.76-58.432 4.576-2.048 9.376-4.192 14.56-6.368s10.368-3.616 15.552-4.512c5.312-0.8 10.56-0.576 15.808 0.672 5.184 1.312 10.112 4.128 14.688 8.576 4.512 4.512 7.36 9.184 8.512 14.24 1.248 5.12 1.312 10.304 0.448 15.616-0.928 5.344-2.816 10.656-5.76 16.032zM470.944 709.76c6.304-5.088 15.584-4.832 21.376 1.056 6.272 6.24 6.272 16.448 0 22.688-0.512 0.512-1.056 0.864-1.632 1.312l0.064 0.064c-20.256 15.392-36.896 29.248-54.848 47.2-16.224 16.192-30.88 33.248-43.552 50.56l-20.448 28c-0.64 1.152-1.408 2.208-2.368 3.2-6.272 6.24-16.48 6.24-22.72 0-5.44-5.44-6.112-13.824-2.112-20.064l-0.064-0.064 21.888-29.888c13.664-18.688 29.376-36.992 46.752-54.368 18.080-18.144 37.6-34.336 57.6-49.696h0.064zM588.096 246.88c16.192-16.192 30.816-33.184 43.52-50.592l21.248-29.12c0.768-1.376 1.632-2.752 2.816-3.936 6.304-6.304 16.512-6.304 22.816 0 5.984 6.016 6.24 15.52 0.8 21.888l0.064 0.064-21.888 30.016c-13.696 18.688-29.376 36.928-46.752 54.304-18.080 18.080-37.568 34.336-57.568 49.696l-0.128-0.064c-6.368 5.856-16.256 5.728-22.368-0.448-6.304-6.304-6.304-16.576 0-22.88 1.12-1.184 2.432-2.016 3.744-2.752 18.816-14.368 36.96-29.44 53.696-46.176z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"banknote",
						"check",
						"bill",
						"money",
						"cash"
					],
					"grid": 32
				},
				"attrs": [],
				"properties": {
					"id": 6,
					"order": 111,
					"prevSize": 32,
					"code": 59657,
					"name": "banknote"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 6
			},
			{
				"icon": {
					"paths": [
						"M938.688 96h-138.688v-64c0-17.696-14.304-32-32-32s-32 14.304-32 32v64h-192v-64c0-17.696-14.336-32-32-32s-32 14.304-32 32v64h-192v-64c0-17.696-14.336-32-32-32s-32 14.304-32 32v64h-138.656c-47.136 0-85.344 38.176-85.344 85.312v757.344c0 47.136 38.208 85.344 85.344 85.344h853.344c47.136 0 85.312-38.208 85.312-85.344v-757.344c0-47.136-38.176-85.312-85.312-85.312zM960 938.656c0 11.776-9.568 21.344-21.312 21.344h-853.344c-11.776 0-21.344-9.568-21.344-21.344v-757.344c0-11.744 9.568-21.312 21.344-21.312h138.656v64c0 17.696 14.336 32 32 32s32-14.304 32-32v-64h192v64c0 17.696 14.336 32 32 32s32-14.304 32-32v-64h192v64c0 17.696 14.304 32 32 32s32-14.304 32-32v-64h138.688c11.744 0 21.312 9.568 21.312 21.312v757.344zM224 384h128v96h-128zM224 544h128v96h-128zM224 704h128v96h-128zM448 704h128v96h-128zM448 544h128v96h-128zM448 384h128v96h-128zM672 704h128v96h-128zM672 544h128v96h-128zM672 384h128v96h-128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"calendar",
						"date",
						"schedule"
					],
					"grid": 32
				},
				"attrs": [],
				"properties": {
					"id": 7,
					"order": 41,
					"prevSize": 32,
					"code": 59652,
					"name": "calendar"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 7
			},
			{
				"icon": {
					"paths": [
						"M512 640c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64zM928.032 416c-0.032 0-0.032 0 0 0l-0.032-192v-16-80c0-53.024-43.008-96-96-96h-128-528c-97.056 0-176 78.976-176 176v640c0 97.024 78.944 176 176 176h576c97.024 0 176-78.976 176-176v-48c0 0 0 0 0.032 0 127.936-96.032 127.936-287.968 0-384zM176 96h656c17.632 0 32 14.336 32 32v80 16 101.888c-10.048-3.584-20.736-5.888-32-5.888h-0.032v-32-64-64c0-17.696-14.336-32-32-32h-672c-17.664 0-32 14.304-32 32v64 62.176c-19.744-20.192-31.968-47.712-31.968-78.176 0-61.856 50.112-112 112-112zM799.968 192h-672l0-32h672v32zM799.968 224v32h-672l0-32h672zM799.968 288v32h-623.968c-17.28 0-33.408-4.224-48-11.2v-20.8h671.968zM864 848c0 61.856-50.144 112-112 112h-576c-61.888 0-112-50.144-112-112v-504.352c30.432 25.184 69.472 40.352 112 40.352h528 128c17.632 0 32 14.336 32 32v64h-288c-88.384 0-160 71.616-160 160s71.648 160 160 160h288v48zM904.864 736h-328.864c-52.928 0-96-43.072-96-96s43.072-96 96-96h288c19.744-0.256 39.328-9.824 51.264-25.728 3.328-4.48 5.92-9.504 8-14.752 0.288-0.704 0.8-1.248 1.056-1.984 23.008 30.176 35.68 67.168 35.68 106.464 0 49.216-19.872 94.88-55.136 128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"wallet",
						"money",
						"cash"
					],
					"grid": 32
				},
				"attrs": [],
				"properties": {
					"id": 8,
					"order": 42,
					"prevSize": 32,
					"code": 59653,
					"name": "wallet"
				},
				"setIdx": 0,
				"setId": 6,
				"iconIdx": 8
			},
			{
				"icon": {
					"paths": [
						"M588 648l90-92 256 256-90 92zM746 426q42 0 76-20t54-54 20-74q0-20-5-37t-13-31l-114 114-64-64 114-114q-14-8-31-13t-37-5q-40 0-74 20t-54 54-20 76q0 24 8 48l-78 80-76-76 30-30-60-60 90-92q-24-24-57-32t-66 0-57 32l-152 152 60 60h-120l-30 30 150 152 30-30v-122l62 60 30-30 76 76-316 316 90 90 486-484q24 8 48 8z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"construction"
					],
					"grid": 24
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 0,
					"prevSize": 24,
					"code": 59663,
					"name": "construction"
				},
				"setIdx": 1,
				"setId": 5,
				"iconIdx": 0
			},
			{
				"icon": {
					"paths": [
						"M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"menu"
					],
					"grid": 24
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 1,
					"prevSize": 24,
					"code": 59683,
					"name": "menu"
				},
				"setIdx": 1,
				"setId": 5,
				"iconIdx": 1
			},
			{
				"icon": {
					"paths": [
						"M938 470h-298v-128h-86v340h86v-128h298v342h-298v-128h-170v-426h-86v128h-298v-342h298v128h256v-128h298v342z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"account_tree"
					],
					"grid": 24
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 2,
					"name": "account_tree",
					"prevSize": 24,
					"code": 59679
				},
				"setIdx": 1,
				"setId": 5,
				"iconIdx": 2
			},
			{
				"icon": {
					"paths": [
						"M780.501 183.168l-597.333 597.333c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l597.333-597.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0zM426.667 277.333c0-41.216-16.768-78.635-43.733-105.6s-64.384-43.733-105.6-43.733-78.635 16.768-105.6 43.733-43.733 64.384-43.733 105.6 16.768 78.635 43.733 105.6 64.384 43.733 105.6 43.733 78.635-16.768 105.6-43.733 43.733-64.384 43.733-105.6zM341.333 277.333c0 17.664-7.125 33.621-18.731 45.269s-27.605 18.731-45.269 18.731-33.621-7.125-45.269-18.731-18.731-27.605-18.731-45.269 7.125-33.621 18.731-45.269 27.605-18.731 45.269-18.731 33.621 7.125 45.269 18.731 18.731 27.605 18.731 45.269zM896 746.667c0-41.216-16.768-78.635-43.733-105.6s-64.384-43.733-105.6-43.733-78.635 16.768-105.6 43.733-43.733 64.384-43.733 105.6 16.768 78.635 43.733 105.6 64.384 43.733 105.6 43.733 78.635-16.768 105.6-43.733 43.733-64.384 43.733-105.6zM810.667 746.667c0 17.664-7.125 33.621-18.731 45.269s-27.605 18.731-45.269 18.731-33.621-7.125-45.269-18.731-18.731-27.605-18.731-45.269 7.125-33.621 18.731-45.269 27.605-18.731 45.269-18.731 33.621 7.125 45.269 18.731 18.731 27.605 18.731 45.269z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"percent"
					],
					"grid": 24
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 3,
					"prevSize": 24,
					"code": 59686,
					"name": "percent"
				},
				"setIdx": 1,
				"setId": 5,
				"iconIdx": 3
			},
			{
				"icon": {
					"paths": [
						"M846.72 170.667l-281.984 333.397c-6.272 7.381-10.069 17.024-10.069 27.563v295.339l-85.333-42.667v-252.672c0.043-9.685-3.285-19.499-10.069-27.563l-281.984-333.397zM938.667 85.333h-853.333c-23.552 0-42.667 19.115-42.667 42.667 0 10.539 3.797 20.181 10.069 27.563l331.264 391.68v263.424c0 16.597 9.472 31.019 23.595 38.144l170.667 85.333c21.077 10.539 46.72 2.005 57.259-19.072 3.072-6.229 4.523-12.843 4.48-19.072v-348.757l331.264-391.68c15.232-18.005 12.971-44.928-5.035-60.117-8.064-6.827-17.877-10.155-27.563-10.112z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"filter"
					],
					"grid": 24
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 4,
					"prevSize": 24,
					"code": 59671,
					"name": "filter"
				},
				"setIdx": 1,
				"setId": 5,
				"iconIdx": 4
			},
			{
				"icon": {
					"paths": [
						"M563.2 460.8h204.8v102.4h-204.8v204.8h-102.4v-204.8h-204.8v-102.4h204.8v-204.8h102.4v204.8zM512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512v0c282.77 0 512 229.23 512 512s-229.23 512-512 512v0zM512 921.6c226.216 0 409.6-183.384 409.6-409.6s-183.384-409.6-409.6-409.6v0c-226.216 0-409.6 183.384-409.6 409.6s183.384 409.6 409.6 409.6v0z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"add-outline"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 0,
					"order": 90,
					"prevSize": 20,
					"code": 59674,
					"name": "add-outline"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 0
			},
			{
				"icon": {
					"paths": [
						"M51.2 51.2h921.6v102.4h-921.6v-102.4zM51.2 460.8h921.6v102.4h-921.6v-102.4zM51.2 870.4h921.6v102.4h-921.6v-102.4zM51.2 256h921.6v102.4h-921.6v-102.4zM51.2 665.6h921.6v102.4h-921.6v-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"align-justified"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 1,
					"order": 66,
					"prevSize": 20,
					"code": 59662,
					"name": "align-justified"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 1
			},
			{
				"icon": {
					"paths": [
						"M102.4 102.4c0-56.32 46.080-102.4 102.4-102.4h614.4c56.554 0 102.4 45.846 102.4 102.4v0 819.2c0 56.554-45.846 102.4-102.4 102.4v0h-614.4c-56.554 0-102.4-45.846-102.4-102.4v0-819.2zM256 153.6v102.4h512v-102.4h-512zM256 358.4v102.4h102.4v-102.4h-102.4zM460.8 358.4v102.4h102.4v-102.4h-102.4zM665.6 358.4v102.4h102.4v-102.4h-102.4zM256 563.2v102.4h102.4v-102.4h-102.4zM460.8 563.2v102.4h102.4v-102.4h-102.4zM665.6 563.2v307.2h102.4v-307.2h-102.4zM256 768v102.4h102.4v-102.4h-102.4zM460.8 768v102.4h102.4v-102.4h-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"calculator"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 2,
					"order": 108,
					"prevSize": 20,
					"code": 59688,
					"name": "calculator"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 2
			},
			{
				"icon": {
					"paths": [
						"M51.2 204.8c0-56.32 46.080-102.4 102.4-102.4h716.8c56.554 0 102.4 45.846 102.4 102.4v0 716.8c0 56.554-45.846 102.4-102.4 102.4v0h-716.8c-56.554 0-102.4-45.846-102.4-102.4v0-716.8zM153.6 307.2v614.4h716.8v-614.4h-716.8zM256 0h102.4v102.4h-102.4v-102.4zM665.6 0h102.4v102.4h-102.4v-102.4zM256 460.8h102.4v102.4h-102.4v-102.4zM256 665.6h102.4v102.4h-102.4v-102.4zM460.8 460.8h102.4v102.4h-102.4v-102.4zM460.8 665.6h102.4v102.4h-102.4v-102.4zM665.6 460.8h102.4v102.4h-102.4v-102.4zM665.6 665.6h102.4v102.4h-102.4v-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"calendar"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 3,
					"order": 61,
					"prevSize": 20,
					"code": 59660,
					"name": "calendar1"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 3
			},
			{
				"icon": {
					"paths": [
						"M0 563.2l102.4-102.4 256 256 563.2-563.2 102.4 102.4-665.6 665.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"checkmark"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 4,
					"order": 59,
					"prevSize": 20,
					"code": 59659,
					"name": "checkmark"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 4
			},
			{
				"icon": {
					"paths": [
						"M475.802 663.040l36.198 36.198 289.638-289.638-72.397-72.397-217.242 217.19-217.242-217.19-72.397 72.397z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cheveron-down"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 5,
					"order": 36,
					"prevSize": 20,
					"code": 59649,
					"name": "cheveron-down"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 5
			},
			{
				"icon": {
					"paths": [
						"M548.198 360.96l-36.198-36.198-289.638 289.638 72.397 72.397 217.242-217.19 217.242 217.19 72.397-72.397z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cheveron-up"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 6,
					"order": 65,
					"prevSize": 20,
					"code": 59661,
					"name": "cheveron-up"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 6
			},
			{
				"icon": {
					"paths": [
						"M512 439.603l-362.035-362.035-72.397 72.397 362.035 362.035-362.035 362.035 72.397 72.397 362.035-362.035 362.035 362.035 72.397-72.397-362.035-362.035 362.035-362.035-72.397-72.397-362.035 362.035z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"close"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 7,
					"order": 97,
					"prevSize": 20,
					"code": 59681,
					"name": "close"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 7
			},
			{
				"icon": {
					"paths": [
						"M150.016 873.984c-96.436-93.233-156.308-223.762-156.308-368.276 0-282.77 229.23-512 512-512 144.514 0 275.043 59.872 368.137 156.164l0.138 0.144c88.925 91.979 143.724 217.436 143.724 355.692 0 282.77-229.23 512-512 512-138.256 0-263.713-54.799-355.836-143.863l0.144 0.138zM222.208 801.792c74.164 74.164 176.621 120.036 289.792 120.036 226.342 0 409.828-183.486 409.828-409.828 0-113.171-45.872-215.628-120.036-289.792l-0-0c-74.164-74.164-176.621-120.036-289.792-120.036-226.342 0-409.828 183.486-409.828 409.828 0 113.171 45.872 215.628 120.036 289.792l-0-0zM729.088 367.104l-144.896 144.896 144.896 144.896-72.192 72.192-144.896-144.896-144.896 144.896-72.192-72.192 144.896-144.896-144.896-144.896 72.192-72.192 144.896 144.896 144.896-144.896 72.192 72.192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"close-outline"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 8,
					"order": 76,
					"prevSize": 20,
					"code": 59670,
					"name": "close-outline"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 8
			},
			{
				"icon": {
					"paths": [
						"M921.6 102.4c56.554 0 102.4 45.846 102.4 102.4v0 614.4c0 56.554-45.846 102.4-102.4 102.4v0h-819.2c-56.554 0-102.4-45.846-102.4-102.4v0-614.4c0-56.32 46.080-102.4 102.4-102.4h819.2zM697.856 568.32l326.144 250.88v-102.4l-262.144-199.68 262.144-209.92v-102.4l-512 409.6-512-409.6v102.4l262.144 209.92-262.144 199.68v102.4l326.144-250.88 185.856 148.48 185.856-148.48z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"envelope"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 9,
					"order": 84,
					"prevSize": 20,
					"code": 59672,
					"name": "envelope"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 9
			},
			{
				"icon": {
					"paths": [
						"M512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512v0c282.77 0 512 229.23 512 512s-229.23 512-512 512v0zM614.4 358.4c0 14.336-10.752 40.96-21.504 51.2l-80.896 80.896c-29.184 29.696-51.2 81.92-51.2 123.904v51.2h102.4v-51.2c0-14.848 10.752-40.96 21.504-51.2l80.896-80.896c29.184-29.696 51.2-81.92 51.2-123.904 0-113.108-91.692-204.8-204.8-204.8s-204.8 91.692-204.8 204.8v0h102.4c0-56.554 45.846-102.4 102.4-102.4s102.4 45.846 102.4 102.4v0zM460.8 768v102.4h102.4v-102.4h-102.4z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"question"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 10,
					"order": 99,
					"prevSize": 20,
					"code": 59684,
					"name": "question"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 10
			},
			{
				"icon": {
					"paths": [
						"M204.8 512c0-56.32 46.080-102.4 102.4-102.4h409.6c56.32 0 102.4 46.080 102.4 102.4v409.6c0 56.32-46.080 102.4-102.4 102.4h-409.6c-56.32 0-102.4-46.080-102.4-102.4v-409.6zM307.2 512v409.6h409.6v-409.6h-102.4v-102.4h-204.8v102.4h-102.4zM460.8 196.096v623.104h102.4v-623.104l157.184 157.184 72.704-72.192-281.088-281.088-281.6 281.6 72.704 71.68 157.696-156.672z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"share"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 11,
					"order": 46,
					"prevSize": 20,
					"code": 59654,
					"name": "share"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 11
			},
			{
				"icon": {
					"paths": [
						"M260.096 622.592c-27.575 26.972-65.35 43.615-107.012 43.615-84.548 0-153.088-68.54-153.088-153.088 0-0.393 0.001-0.787 0.004-1.179l-0 0.060c0.054-84.79 68.802-153.505 153.6-153.505 41.373 0 78.926 16.358 106.544 42.959l-0.048-0.046 457.728-228.864c-0.768-5.77-1.206-12.441-1.206-19.214 0-84.831 68.769-153.6 153.6-153.6s153.6 68.769 153.6 153.6c0 84.831-68.769 153.6-153.6 153.6-41.285 0-78.765-16.288-106.366-42.788l0.052 0.050-457.728 228.864c0.739 5.688 1.161 12.267 1.161 18.944s-0.422 13.256-1.24 19.711l0.079-0.767 457.728 228.864c27.575-26.972 65.35-43.615 107.012-43.615 84.548 0 153.088 68.54 153.088 153.088 0 0.393-0.001 0.787-0.004 1.179l0-0.060c-0.727 84.277-69.215 152.316-153.595 152.316-84.831 0-153.6-68.769-153.6-153.6 0-6.223 0.37-12.36 1.089-18.389l-0.071 0.729-457.728-228.864z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"share-alt"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 12,
					"order": 110,
					"prevSize": 20,
					"code": 59690,
					"name": "share-alt"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 12
			},
			{
				"icon": {
					"paths": [
						"M212.992 212.992l72.704 72.704c-81.127 66.138-132.521 166.076-132.521 278.017 0 197.656 160.232 357.888 357.888 357.888 0.329 0 0.659-0 0.988-0.001l-0.051 0c197.722-0.287 357.896-160.638 357.896-358.4 0-111.594-51.003-211.277-130.969-277.008l-0.622-0.496 72.704-72.704c99.127 85.029 161.536 210.425 161.536 350.396 0 254.493-206.307 460.8-460.8 460.8s-460.8-206.307-460.8-460.8c0-139.972 62.408-265.367 160.917-349.878l0.619-0.518zM460.8 0h102.4v409.6h-102.4v-409.6z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"stand-by"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 13,
					"order": 37,
					"prevSize": 20,
					"code": 59650,
					"name": "stand-by"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 13
			},
			{
				"icon": {
					"paths": [
						"M512 768l-300.954 158.208 57.498-335.104-243.507-237.312 336.486-48.896 150.477-304.896 150.477 304.896 336.486 48.896-243.507 237.312 57.498 335.104z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"star-full"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 14,
					"order": 47,
					"prevSize": 20,
					"code": 59655,
					"name": "star-full"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 14
			},
			{
				"icon": {
					"paths": [
						"M921.6 505.344v518.656h-819.2v-518.656c15.389 3.889 33.056 6.12 51.245 6.12 37.467 0 72.723-9.469 103.504-26.146l-1.149 0.569v230.912h512v-230.4c29.492 15.869 64.538 25.194 101.761 25.194 18.402 0 36.272-2.279 53.343-6.57l-1.505 0.32zM153.6 0h204.8l-34.304 308.736c-11.832 85.147-83.292 150.251-170.311 152.061l-0.185 0.003c-84.992 0-132.096-65.024-104.96-145.92l104.96-314.88zM409.6 0h204.8l35.84 322.56c8.704 76.8-46.592 138.24-123.904 138.24h-28.672c-0.941 0.026-2.049 0.041-3.16 0.041-67.299 0-121.856-54.557-121.856-121.856 0-5.793 0.404-11.491 1.186-17.068l-0.074 0.643 35.84-322.56zM665.6 0h204.8l104.96 314.88c27.136 80.896-20.48 145.92-104.96 145.92-87.29-1.589-158.873-66.812-170.394-151.155l-0.102-0.909-34.304-308.736z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"store-front"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 15,
					"order": 103,
					"prevSize": 20,
					"code": 59687,
					"name": "store-front"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 15
			},
			{
				"icon": {
					"paths": [
						"M512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512v0c282.77 0 512 229.23 512 512s-229.23 512-512 512v0zM512 921.6c226.216 0 409.6-183.384 409.6-409.6s-183.384-409.6-409.6-409.6v0c-226.216 0-409.6 183.384-409.6 409.6s183.384 409.6 409.6 409.6v0zM460.8 532.992v-328.192h102.4v286.208l202.24 202.24-72.192 72.192-232.448-232.448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"time"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 16,
					"order": 38,
					"prevSize": 20,
					"code": 59651,
					"name": "time"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 16
			},
			{
				"icon": {
					"paths": [
						"M256 256c0-141.385 114.615-256 256-256s256 114.615 256 256v0 102.4c0 141.385-114.615 256-256 256s-256-114.615-256-256v0-102.4zM0 854.016c146.431-86.26 322.601-137.217 510.673-137.217 0.466 0 0.933 0 1.399 0.001l-0.072-0c186.368 0 361.472 49.664 512 137.216v169.984h-1024v-169.984z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"user"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 17,
					"order": 48,
					"prevSize": 20,
					"code": 59658,
					"name": "user"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 17
			},
			{
				"icon": {
					"paths": [
						"M358.4 409.6c-113.108 0-204.8-91.692-204.8-204.8s91.692-204.8 204.8-204.8v0c113.108 0 204.8 91.692 204.8 204.8s-91.692 204.8-204.8 204.8v0zM358.4 460.8c110.080 0 215.040 20.48 312.32 55.808l-56.32 302.592h-64l-38.4 204.8h-307.2l-38.4-204.8h-64l-56.32-302.592c92.835-35.013 200.137-55.444 312.164-55.808l0.156-0zM783.872 469.504c67.584 9.216 132.608 24.576 194.56 47.104l-56.832 302.592h-64l-38.4 204.8h-202.752l18.944-102.4h64l84.48-452.096zM665.6 0c0.522-0.005 1.138-0.008 1.756-0.008 113.108 0 204.8 91.692 204.8 204.8s-91.692 204.8-204.8 204.8c-25.063 0-49.074-4.502-71.269-12.741l1.417 0.461c42.583-52.050 68.389-119.268 68.389-192.512s-25.805-140.462-68.82-193.056l0.431 0.544c22.016-7.168 44.032-12.288 68.096-12.288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"user-group"
					],
					"grid": 20
				},
				"attrs": [],
				"properties": {
					"id": 18,
					"order": 95,
					"prevSize": 20,
					"code": 59680,
					"name": "user-group"
				},
				"setIdx": 2,
				"setId": 4,
				"iconIdx": 18
			},
			{
				"icon": {
					"paths": [
						"M992 128h-960c-17.664 0-32 14.336-32 32v704c0 17.696 14.336 32 32 32h960c17.696 0 32-14.304 32-32v-704c0-17.664-14.304-32-32-32zM960 800c0 17.696-14.304 32-32 32h-832c-17.664 0-32-14.304-32-32v-576c0-17.664 14.336-32 32-32h832c17.696 0 32 14.336 32 32v576zM303.936 388.512l-123.36-123.392c-12-12-31.456-12-43.456 0s-12 31.456 0 43.456l107.456 107.424-107.456 107.456c-12 12-12 31.424 0 43.424s31.456 12 43.456 0l123.36-123.36c2.432-1.344 4.896-2.56 6.944-4.608 6.304-6.304 9.12-14.656 8.768-22.912 0.32-8.256-2.464-16.608-8.768-22.88-2.048-2.048-4.512-3.264-6.944-4.608zM608 512h-192c-17.664 0-32 14.336-32 32 0 17.696 14.336 32 32 32h192c17.696 0 32-14.304 32-32 0-17.664-14.304-32-32-32z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"console",
						"command line"
					],
					"grid": 16
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 0,
					"name": "console, command-line",
					"prevSize": 32,
					"code": 59677
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 0
			},
			{
				"icon": {
					"paths": [
						"M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"home",
						"house"
					],
					"defaultCode": 59648,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "home, house",
					"name": "home",
					"order": 34,
					"id": 1,
					"prevSize": 32,
					"code": 59648
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 1
			},
			{
				"icon": {
					"paths": [
						"M0 1024h512v-1024h-512v1024zM320 128h128v128h-128v-128zM320 384h128v128h-128v-128zM320 640h128v128h-128v-128zM64 128h128v128h-128v-128zM64 384h128v128h-128v-128zM64 640h128v128h-128v-128zM576 320h448v64h-448zM576 1024h128v-256h192v256h128v-576h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"office",
						"buildings",
						"work"
					],
					"defaultCode": 59651,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "office, buildings",
					"name": "office",
					"order": 101,
					"id": 2,
					"prevSize": 32,
					"code": 59685
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 2
			},
			{
				"icon": {
					"paths": [
						"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 448h448v64h-448zM256 576h448v64h-448zM256 704h448v64h-448zM256 320h448v64h-448z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"file-text",
						"file",
						"document",
						"list",
						"paper"
					],
					"defaultCode": 59682,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "file-text, file",
					"name": "file-text",
					"order": 55,
					"id": 3,
					"prevSize": 32,
					"code": 59682
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 3
			},
			{
				"icon": {
					"paths": [
						"M384 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M1024 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
						"M1024 512v-384h-768c0-35.346-28.654-64-64-64h-192v64h128l48.074 412.054c-29.294 23.458-48.074 59.5-48.074 99.946 0 70.696 57.308 128 128 128h768v-64h-768c-35.346 0-64-28.654-64-64 0-0.218 0.014-0.436 0.016-0.656l831.984-127.344z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cart",
						"purchase",
						"ecommerce",
						"shopping"
					],
					"defaultCode": 59706,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "cart, purchase",
					"name": "cart",
					"order": 64,
					"id": 4,
					"prevSize": 32,
					"code": 59706
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 4
			},
			{
				"icon": {
					"paths": [
						"M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM512 512v-128h128v-64h-128v-64h-64v64h-128v256h128v128h-128v64h128v64h64v-64h128.002l-0.002-256h-128zM448 512h-64v-128h64v128zM576.002 704h-64.002v-128h64.002v128z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"coin-dollar",
						"money",
						"cash",
						"currency-dollar"
					],
					"defaultCode": 59707,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "coin-dollar, money",
					"name": "coin-dollar",
					"order": 44,
					"id": 5,
					"prevSize": 32,
					"code": 59707
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 5
			},
			{
				"icon": {
					"paths": [
						"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM96 192h832c17.346 0 32 14.654 32 32v96h-896v-96c0-17.346 14.654-32 32-32zM928 832h-832c-17.346 0-32-14.654-32-32v-288h896v288c0 17.346-14.654 32-32 32zM128 640h64v128h-64zM256 640h64v128h-64zM384 640h64v128h-64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"credit-card",
						"money",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59711,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "credit-card, money5",
					"name": "credit-card1",
					"order": 62,
					"id": 6,
					"prevSize": 32,
					"code": 59711
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 6
			},
			{
				"icon": {
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM320 512c0-106.040 85.96-192 192-192s192 85.96 192 192-85.96 192-192 192-192-85.96-192-192zM925.98 683.476v0l-177.42-73.49c12.518-30.184 19.44-63.276 19.44-97.986s-6.922-67.802-19.44-97.986l177.42-73.49c21.908 52.822 34.020 110.73 34.020 171.476s-12.114 118.654-34.020 171.476v0zM683.478 98.020v0 0l-73.49 177.42c-30.184-12.518-63.276-19.44-97.988-19.44s-67.802 6.922-97.986 19.44l-73.49-177.422c52.822-21.904 110.732-34.018 171.476-34.018 60.746 0 118.654 12.114 171.478 34.020zM98.020 340.524l177.422 73.49c-12.518 30.184-19.442 63.276-19.442 97.986s6.922 67.802 19.44 97.986l-177.42 73.49c-21.906-52.822-34.020-110.73-34.020-171.476s12.114-118.654 34.020-171.476zM340.524 925.98l73.49-177.42c30.184 12.518 63.276 19.44 97.986 19.44s67.802-6.922 97.986-19.44l73.49 177.42c-52.822 21.904-110.73 34.020-171.476 34.020-60.744 0-118.654-12.114-171.476-34.020z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"lifebuoy",
						"support",
						"help"
					],
					"defaultCode": 59713,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "lifebuoy, support",
					"name": "lifebuoy",
					"order": 85,
					"id": 7,
					"prevSize": 32,
					"code": 59713
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 7
			},
			{
				"icon": {
					"paths": [
						"M704 640c-64 64-64 128-128 128s-128-64-192-128-128-128-128-192 64-64 128-128-128-256-192-256-192 192-192 192c0 128 131.5 387.5 256 512s384 256 512 256c0 0 192-128 192-192s-192-256-256-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"phone",
						"telephone",
						"contact",
						"support",
						"call"
					],
					"defaultCode": 59714,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "phone, telephone",
					"name": "phone1",
					"order": 53,
					"id": 8,
					"prevSize": 32,
					"code": 59714
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 8
			},
			{
				"icon": {
					"paths": [
						"M928 128h-832c-52.8 0-96 43.2-96 96v640c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-640c0-52.8-43.2-96-96-96zM398.74 550.372l-270.74 210.892v-501.642l270.74 290.75zM176.38 256h671.24l-335.62 252-335.62-252zM409.288 561.698l102.712 110.302 102.71-110.302 210.554 270.302h-626.528l210.552-270.302zM625.26 550.372l270.74-290.75v501.642l-270.74-210.892z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"envelop",
						"mail",
						"email",
						"contact",
						"letter"
					],
					"defaultCode": 59717,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "envelop, mail",
					"name": "envelop",
					"order": 52,
					"id": 9,
					"prevSize": 32,
					"code": 59717
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 9
			},
			{
				"icon": {
					"paths": [
						"M640 64c247.424 0 448 200.576 448 448s-200.576 448-448 448v-96c94.024 0 182.418-36.614 248.902-103.098s103.098-154.878 103.098-248.902c0-94.022-36.614-182.418-103.098-248.902s-154.878-103.098-248.902-103.098c-94.022 0-182.418 36.614-248.902 103.098-51.14 51.138-84.582 115.246-97.306 184.902h186.208l-224 256-224-256h164.57c31.060-217.102 217.738-384 443.43-384zM832 448v128h-256v-320h128v192z"
					],
					"width": 1088,
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"history",
						"time",
						"archive",
						"past"
					],
					"defaultCode": 59725,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "history, time",
					"name": "history",
					"order": 100,
					"id": 10,
					"prevSize": 32,
					"code": 59725
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 10
			},
			{
				"icon": {
					"paths": [
						"M512.002 193.212v-65.212h128v-64c0-35.346-28.654-64-64.002-64h-191.998c-35.346 0-64 28.654-64 64v64h128v65.212c-214.798 16.338-384 195.802-384 414.788 0 229.75 186.25 416 416 416s416-186.25 416-416c0-218.984-169.202-398.448-384-414.788zM706.276 834.274c-60.442 60.44-140.798 93.726-226.274 93.726s-165.834-33.286-226.274-93.726c-60.44-60.44-93.726-140.8-93.726-226.274s33.286-165.834 93.726-226.274c58.040-58.038 134.448-91.018 216.114-93.548l-21.678 314.020c-1.86 26.29 12.464 37.802 31.836 37.802s33.698-11.512 31.836-37.802l-21.676-314.022c81.666 2.532 158.076 35.512 216.116 93.55 60.44 60.44 93.726 140.8 93.726 226.274s-33.286 165.834-93.726 226.274z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"stopwatch",
						"time",
						"speed",
						"meter",
						"chronometer"
					],
					"defaultCode": 59730,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "stopwatch, time5",
					"name": "stopwatch",
					"order": 117,
					"id": 11,
					"prevSize": 32,
					"code": 59730
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 11
			},
			{
				"icon": {
					"paths": [
						"M736 0h-448c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 48h256v32h-256v-32zM512 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 768h-512v-640h512v640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"mobile",
						"cell-phone",
						"handheld"
					],
					"defaultCode": 59736,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "mobile, cell-phone",
					"name": "mobile",
					"order": 63,
					"id": 12,
					"prevSize": 32,
					"code": 59736
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 12
			},
			{
				"icon": {
					"paths": [
						"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
						"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM896 768h-128v128h-64v-128h-128v-64h128v-128h64v128h128v64z"
					],
					"width": 1024,
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"user-plus",
						"user",
						"user-add",
						"profile",
						"avatar",
						"person",
						"member"
					],
					"defaultCode": 59763,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "user-plus, user2",
					"name": "user-plus",
					"order": 96,
					"id": 13,
					"prevSize": 32,
					"code": 59763
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 13
			},
			{
				"icon": {
					"paths": [
						"M320 192c0-106.039 85.961-192 192-192s192 85.961 192 192c0 106.039-85.961 192-192 192s-192-85.961-192-192zM768.078 448h-35.424l-199.104 404.244 74.45-372.244-96-96-96 96 74.45 372.244-199.102-404.244h-35.424c-127.924 0-127.924 85.986-127.924 192v320h768v-320c0-106.014 0-192-127.922-192z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"user-tie",
						"user",
						"user-employee",
						"profile",
						"avatar",
						"person",
						"member",
						"job",
						"official"
					],
					"defaultCode": 59766,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "user-tie, user5",
					"name": "user-tie",
					"order": 35,
					"id": 14,
					"prevSize": 32,
					"code": 59766
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 14
			},
			{
				"icon": {
					"paths": [
						"M1024 384h-384l143.53-143.53c-72.53-72.526-168.96-112.47-271.53-112.47s-199 39.944-271.53 112.47c-72.526 72.53-112.47 168.96-112.47 271.53s39.944 199 112.47 271.53c72.53 72.526 168.96 112.47 271.53 112.47s199-39.944 271.528-112.472c6.056-6.054 11.86-12.292 17.456-18.668l96.32 84.282c-93.846 107.166-231.664 174.858-385.304 174.858-282.77 0-512-229.23-512-512s229.23-512 512-512c141.386 0 269.368 57.326 362.016 149.984l149.984-149.984v384z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"spinner",
						"loading",
						"loading-wheel",
						"refresh",
						"repeat",
						"busy",
						"wait",
						"arrow"
					],
					"defaultCode": 59780,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "spinner11, loading12",
					"name": "spinner11",
					"order": 43,
					"id": 15,
					"prevSize": 32,
					"code": 59780
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 15
			},
			{
				"icon": {
					"paths": [
						"M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"search",
						"magnifier",
						"magnifying-glass",
						"inspect",
						"find"
					],
					"defaultCode": 59782,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "search, magnifier",
					"name": "search",
					"order": 60,
					"id": 16,
					"prevSize": 32,
					"code": 59782
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 16
			},
			{
				"icon": {
					"paths": [
						"M1002.132 314.242l-101.106-101.104c-24.792-24.794-65.37-65.368-90.162-90.164l-101.106-101.104c-24.792-24.794-68.954-29.166-98.13-9.716l-276.438 184.292c-29.176 19.452-40.218 61.028-24.536 92.39l70.486 140.974c2.154 4.306 4.646 8.896 7.39 13.66l-356.53 356.53-32 224h192v-64h128v-128h128v-128h128v-71.186c6.396 3.812 12.534 7.216 18.192 10.044l140.97 70.488c31.366 15.682 72.94 4.638 92.39-24.538l184.294-276.44c19.454-29.172 15.078-73.33-9.714-98.126zM150.628 854.626l-45.254-45.254 311.572-311.57 45.254 45.254-311.572 311.57zM917.020 423.764l-45.256 45.256c-12.446 12.444-32.808 12.444-45.254 0l-271.53-271.53c-12.446-12.444-12.446-32.81 0-45.254l45.256-45.256c12.446-12.444 32.808-12.444 45.254 0l271.53 271.53c12.446 12.444 12.446 32.81 0 45.254z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"key",
						"password",
						"login",
						"signin"
					],
					"defaultCode": 59790,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "key2, password2",
					"name": "key2",
					"order": 102,
					"id": 17,
					"prevSize": 32,
					"code": 59790
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 17
			},
			{
				"icon": {
					"paths": [
						"M448 576v-448c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448c0-72.034-17.028-140.084-47.236-200.382l-400.764 200.382zM912.764 247.618c-73.552-146.816-225.374-247.618-400.764-247.618v448l400.764-200.382z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"pie-chart",
						"stats",
						"statistics",
						"graph"
					],
					"defaultCode": 59802,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "pie-chart, stats",
					"name": "pie-chart",
					"order": 39,
					"id": 18,
					"prevSize": 32,
					"code": 59802
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 18
			},
			{
				"icon": {
					"paths": [
						"M128 896h896v128h-1024v-1024h128zM288 832c-53.020 0-96-42.98-96-96s42.98-96 96-96c2.828 0 5.622 0.148 8.388 0.386l103.192-171.986c-9.84-15.070-15.58-33.062-15.58-52.402 0-53.020 42.98-96 96-96s96 42.98 96 96c0 19.342-5.74 37.332-15.58 52.402l103.192 171.986c2.766-0.238 5.56-0.386 8.388-0.386 2.136 0 4.248 0.094 6.35 0.23l170.356-298.122c-10.536-15.408-16.706-34.036-16.706-54.11 0-53.020 42.98-96 96-96s96 42.98 96 96c0 53.020-42.98 96-96 96-2.14 0-4.248-0.094-6.35-0.232l-170.356 298.124c10.536 15.406 16.706 34.036 16.706 54.11 0 53.020-42.98 96-96 96s-96-42.98-96-96c0-19.34 5.74-37.332 15.578-52.402l-103.19-171.984c-2.766 0.238-5.56 0.386-8.388 0.386s-5.622-0.146-8.388-0.386l-103.192 171.986c9.84 15.068 15.58 33.060 15.58 52.4 0 53.020-42.98 96-96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"stats-dots",
						"stats",
						"plot",
						"statistics",
						"chart"
					],
					"defaultCode": 59803,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "stats-dots, stats2",
					"name": "stats-dots",
					"order": 56,
					"id": 19,
					"prevSize": 32,
					"code": 59803
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 19
			},
			{
				"icon": {
					"paths": [
						"M892.268 386.49c2.444-11.11 3.732-22.648 3.732-34.49 0-88.366-71.634-160-160-160-14.222 0-28.014 1.868-41.132 5.352-24.798-77.352-97.29-133.352-182.868-133.352-87.348 0-161.054 58.336-184.326 138.17-22.742-6.622-46.792-10.17-71.674-10.17-141.384 0-256 114.616-256 256 0 141.388 114.616 256 256 256h128v192h256v-192h224c88.366 0 160-71.632 160-160 0-78.72-56.854-144.162-131.732-157.51zM576 640v192h-128v-192h-160l224-224 224 224h-160z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cloud-upload",
						"cloud",
						"load",
						"upload"
					],
					"defaultCode": 59843,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "cloud-upload, cloud3",
					"name": "cloud-upload",
					"order": 82,
					"id": 20,
					"prevSize": 32,
					"code": 59843
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 20
			},
			{
				"icon": {
					"paths": [
						"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 960.002c-62.958 0-122.872-13.012-177.23-36.452l233.148-262.29c5.206-5.858 8.082-13.422 8.082-21.26v-96c0-17.674-14.326-32-32-32-112.99 0-232.204-117.462-233.374-118.626-6-6.002-14.14-9.374-22.626-9.374h-128c-17.672 0-32 14.328-32 32v192c0 12.122 6.848 23.202 17.69 28.622l110.31 55.156v187.886c-116.052-80.956-192-215.432-192-367.664 0-68.714 15.49-133.806 43.138-192h116.862c8.488 0 16.626-3.372 22.628-9.372l128-128c6-6.002 9.372-14.14 9.372-22.628v-77.412c40.562-12.074 83.518-18.588 128-18.588 70.406 0 137.004 16.26 196.282 45.2-4.144 3.502-8.176 7.164-12.046 11.036-36.266 36.264-56.236 84.478-56.236 135.764s19.97 99.5 56.236 135.764c36.434 36.432 85.218 56.264 135.634 56.26 3.166 0 6.342-0.080 9.518-0.236 13.814 51.802 38.752 186.656-8.404 372.334-0.444 1.744-0.696 3.488-0.842 5.224-81.324 83.080-194.7 134.656-320.142 134.656z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"earth",
						"globe",
						"language",
						"web",
						"internet",
						"sphere",
						"planet"
					],
					"defaultCode": 59850,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "earth, globe2",
					"name": "earth",
					"order": 98,
					"id": 21,
					"prevSize": 32,
					"code": 59850
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 21
			},
			{
				"icon": {
					"paths": [
						"M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"eye",
						"views",
						"vision",
						"visit"
					],
					"defaultCode": 59854,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "eye, views",
					"name": "eye",
					"order": 112,
					"id": 22,
					"prevSize": 32,
					"code": 59854
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 22
			},
			{
				"icon": {
					"paths": [
						"M512 92.774l429.102 855.226h-858.206l429.104-855.226zM512 0c-22.070 0-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.3 0 96.792-48.708 63.3-108.24h0.002l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648v0z",
						"M576 832c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
						"M512 704c-35.346 0-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192c0 35.346-28.654 64-64 64z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"warning",
						"sign"
					],
					"defaultCode": 59911,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "warning, sign",
					"name": "warning",
					"order": 109,
					"id": 23,
					"prevSize": 32,
					"code": 59911
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 23
			},
			{
				"icon": {
					"paths": [
						"M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cross",
						"cancel",
						"close",
						"quit",
						"remove"
					],
					"defaultCode": 59919,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "cross, cancel",
					"name": "cross",
					"order": 115,
					"id": 24,
					"prevSize": 32,
					"code": 59919
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 24
			},
			{
				"icon": {
					"paths": [
						"M864 128l-480 480-224-224-160 160 384 384 640-640z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"checkmark",
						"tick",
						"correct",
						"accept",
						"ok"
					],
					"defaultCode": 59920,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "checkmark, tick",
					"name": "checkmark1",
					"order": 116,
					"id": 25,
					"prevSize": 32,
					"code": 59920
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 25
			},
			{
				"icon": {
					"paths": [
						"M425.6 37.4c-1.6-1-3.4-1.8-5-2.6-1.8 0.4-3.4 0.6-5.2 1l10.2 1.6z",
						"M36.8 421c-0.4 1.8-0.6 3.6-0.8 5.2 1 1.6 1.6 3.2 2.6 4.8l-1.8-10z",
						"M986.8 602.6c0.4-1.8 0.6-3.6 1-5.4-1-1.6-1.6-3.2-2.6-4.8l1.6 10.2z",
						"M592 983c1.6 1 3.4 1.8 5 2.6 1.8-0.4 3.6-0.6 5.4-0.8l-10.4-1.8z",
						"M987.8 597.2c-0.4 1.8-0.6 3.6-1 5.4l-1.8-10.4c1 1.8 1.8 3.4 2.8 5 5.2-28.8 8-58.2 8-87.6 0-65.2-12.8-128.6-38-188.2-24.4-57.6-59.2-109.4-103.6-153.8s-96.2-79.2-153.6-103.6c-59.6-25.2-123-38-188.2-38-30.8 0-61.6 2.8-91.6 8.6 0 0-0.2 0-0.2 0 1.6 0.8 3.4 1.6 5 2.6l-10.2-1.6c1.8-0.4 3.4-0.6 5.2-1-41.2-21.8-87.4-33.6-134.2-33.6-76.4 0-148.4 29.8-202.4 83.8s-83.8 126-83.8 202.4c0 48.6 12.6 96.6 36 138.8 0.4-1.8 0.6-3.6 0.8-5.2l1.8 10.2c-1-1.6-1.8-3.2-2.6-4.8-4.8 27.4-7.2 55.4-7.2 83.4 0 65.2 12.8 128.6 38 188.2 24.4 57.6 59.2 109.2 103.6 153.6s96.2 79.2 153.8 103.6c59.6 25.2 123 38 188.2 38 28.4 0 56.8-2.6 84.6-7.6-1.6-1-3.2-1.8-5-2.6l10.4 1.8c-1.8 0.4-3.6 0.6-5.4 0.8 42.8 24.2 91.4 37.2 140.8 37.2 76.4 0 148.4-29.8 202.4-83.8s83.8-126 83.8-202.4c-0.2-48.6-12.8-96.6-36.4-139.2zM514.2 805.8c-171.8 0-248.6-84.4-248.6-147.8 0-32.4 24-55.2 57-55.2 73.6 0 54.4 105.6 191.6 105.6 70.2 0 109-38.2 109-77.2 0-23.4-11.6-49.4-57.8-60.8l-152.8-38.2c-123-30.8-145.4-97.4-145.4-160 0-129.8 122.2-178.6 237-178.6 105.8 0 230.4 58.4 230.4 136.4 0 33.4-29 52.8-62 52.8-62.8 0-51.2-86.8-177.6-86.8-62.8 0-97.4 28.4-97.4 69s49.6 53.6 92.6 63.4l113.2 25.2c123.8 27.6 155.2 100 155.2 168 0 105.4-81 184.2-244.4 184.2z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"skype",
						"brand",
						"social"
					],
					"defaultCode": 60101,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "skype, brand60",
					"name": "skype",
					"order": 86,
					"id": 26,
					"prevSize": 32,
					"code": 60101
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 26
			},
			{
				"icon": {
					"paths": [
						"M743.028 384h-135.292l-95.732 141.032-95.742-141.032h-135.29l162.162 242.464-182.972 269.536h251.838v-91.576h-50.156l50.156-74.994 111.396 166.57h140.444l-182.976-269.536 162.164-242.464z",
						"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"file-excel",
						"file",
						"file-format",
						"xlc"
					],
					"defaultCode": 60130,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "file-excel, file13",
					"name": "file-excel",
					"order": 68,
					"id": 27,
					"prevSize": 32,
					"code": 60130
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 27
			},
			{
				"icon": {
					"paths": [
						"M992 384h-352v-352c0-17.672-14.328-32-32-32h-192c-17.672 0-32 14.328-32 32v352h-352c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h352v352c0 17.672 14.328 32 32 32h192c17.672 0 32-14.328 32-32v-352h352c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32z"
					],
					"attrs": [],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"plus",
						"add",
						"sum"
					],
					"defaultCode": 59914,
					"grid": 16
				},
				"attrs": [],
				"properties": {
					"ligatures": "plus, add",
					"name": "plus",
					"order": 2,
					"id": 28,
					"prevSize": 32,
					"code": 59914
				},
				"setIdx": 3,
				"setId": 3,
				"iconIdx": 28
			},
			{
				"icon": {
					"paths": [
						"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM96 192h832c17.346 0 32 14.654 32 32v96h-896v-96c0-17.346 14.654-32 32-32zM928 832h-832c-17.346 0-32-14.654-32-32v-288h896v288c0 17.346-14.654 32-32 32zM128 640h64v128h-64zM256 640h64v128h-64zM384 640h64v128h-64z"
					],
					"tags": [
						"credit-card",
						"money",
						"payment",
						"ecommerce"
					],
					"defaultCode": 59711,
					"grid": 16,
					"attrs": []
				},
				"attrs": [],
				"properties": {
					"ligatures": "credit-card, money5",
					"name": "credit-card",
					"order": 3,
					"id": 64,
					"prevSize": 32,
					"code": 59712
				},
				"setIdx": 5,
				"setId": 1,
				"iconIdx": 63
			},
			{
				"icon": {
					"paths": [
						"M219.429 877.714h438.857v-219.429h-438.857v219.429zM731.429 877.714h73.143v-512c0-10.857-9.714-34.286-17.143-41.714l-160.571-160.571c-8-8-30.286-17.143-41.714-17.143v237.714c0 30.286-24.571 54.857-54.857 54.857h-329.143c-30.286 0-54.857-24.571-54.857-54.857v-237.714h-73.143v731.429h73.143v-237.714c0-30.286 24.571-54.857 54.857-54.857h475.429c30.286 0 54.857 24.571 54.857 54.857v237.714zM512 347.429v-182.857c0-9.714-8.571-18.286-18.286-18.286h-109.714c-9.714 0-18.286 8.571-18.286 18.286v182.857c0 9.714 8.571 18.286 18.286 18.286h109.714c9.714 0 18.286-8.571 18.286-18.286zM877.714 365.714v530.286c0 30.286-24.571 54.857-54.857 54.857h-768c-30.286 0-54.857-24.571-54.857-54.857v-768c0-30.286 24.571-54.857 54.857-54.857h530.286c30.286 0 72 17.143 93.714 38.857l160 160c21.714 21.714 38.857 63.429 38.857 93.714z"
					],
					"width": 878,
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"floppy-o",
						"save"
					],
					"grid": 14
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 114,
					"id": 0,
					"prevSize": 28,
					"code": 59692,
					"name": "floppy-o"
				},
				"setIdx": 4,
				"setId": 2,
				"iconIdx": 0
			},
			{
				"icon": {
					"paths": [
						"M521.143 969.143c0-5.143-4-9.143-9.143-9.143-45.143 0-82.286-37.143-82.286-82.286 0-5.143-4-9.143-9.143-9.143s-9.143 4-9.143 9.143c0 55.429 45.143 100.571 100.571 100.571 5.143 0 9.143-4 9.143-9.143zM140.571 804.571h742.857c-102.286-115.429-152-272-152-475.429 0-73.714-69.714-182.857-219.429-182.857s-219.429 109.143-219.429 182.857c0 203.429-49.714 360-152 475.429zM987.429 804.571c0 40-33.143 73.143-73.143 73.143h-256c0 80.571-65.714 146.286-146.286 146.286s-146.286-65.714-146.286-146.286h-256c-40 0-73.143-33.143-73.143-73.143 84.571-71.429 182.857-199.429 182.857-475.429 0-109.714 90.857-229.714 242.286-252-2.857-6.857-4.571-14.286-4.571-22.286 0-30.286 24.571-54.857 54.857-54.857s54.857 24.571 54.857 54.857c0 8-1.714 15.429-4.571 22.286 151.429 22.286 242.286 142.286 242.286 252 0 276 98.286 404 182.857 475.429z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"bell-o"
					],
					"grid": 14
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 1,
					"prevSize": 28,
					"code": 59676,
					"name": "bell-o"
				},
				"setIdx": 4,
				"setId": 2,
				"iconIdx": 1
			},
			{
				"icon": {
					"paths": [
						"M679.429 746.857l84-396c7.429-34.857-12.571-48.571-35.429-40l-493.714 190.286c-33.714 13.143-33.143 32-5.714 40.571l126.286 39.429 293.143-184.571c13.714-9.143 26.286-4 16 5.143l-237.143 214.286-9.143 130.286c13.143 0 18.857-5.714 25.714-12.571l61.714-59.429 128 94.286c23.429 13.143 40 6.286 46.286-21.714zM1024 512c0 282.857-229.143 512-512 512s-512-229.143-512-512 229.143-512 512-512 512 229.143 512 512z"
					],
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"telegram"
					],
					"grid": 14
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 2,
					"prevSize": 28,
					"code": 59673,
					"name": "telegram"
				},
				"setIdx": 4,
				"setId": 2,
				"iconIdx": 2
			},
			{
				"icon": {
					"paths": [
						"M178.857 444c0 18.286-7.429 36-20.571 48-11.429 10.286-26.857 14.857-50.857 14.857h-9.714v-125.714h9.714c24 0 38.857 4 50.857 15.429 13.143 11.429 20.571 29.143 20.571 47.429zM1193.714 406.857c0 19.429-12.571 29.714-36.571 29.714h-10.857v-57.714h11.429c23.429 0 36 9.714 36 28zM217.143 444c0-56-41.714-95.429-102.286-95.429h-54.286v190.286h54.286c28.571 0 49.714-6.286 68-21.714 21.714-18.286 34.286-45.143 34.286-73.143zM234.286 538.857h37.143v-190.286h-37.143v190.286zM417.143 481.143c0-30.286-12.571-44-54.857-59.429-22.286-8-28.571-13.714-28.571-24 0-12 11.429-21.143 27.429-21.143 11.429 0 20.571 4.571 30.286 15.429l19.429-25.143c-16-14.286-35.429-21.143-56-21.143-33.714 0-59.429 23.429-59.429 54.286 0 26.286 12 40 46.857 52.571 14.286 5.143 21.714 8 25.714 10.857 7.429 4.571 10.857 11.429 10.857 19.429 0 15.429-12 26.857-28.571 26.857-17.714 0-32-8.571-40.571-25.143l-24 22.857c17.143 25.143 37.714 36.571 65.714 36.571 38.857 0 65.714-25.714 65.714-62.857zM576 532.571v-44c-14.857 14.857-28 21.143-44.571 21.143-37.714 0-64-27.429-64-65.714 0-36.571 27.429-65.714 62.286-65.714 17.714 0 30.857 6.286 46.286 21.714v-44c-16-8-29.714-11.429-45.714-11.429-56 0-101.143 44-101.143 99.429 0 56 44 99.429 100.571 99.429 16 0 29.714-2.857 46.286-10.857zM1280 877.714v-301.143c-91.429 57.143-413.143 240-933.143 337.714h896.571c20 0 36.571-16.571 36.571-36.571zM793.714 445.143c0-57.143-46.286-103.429-103.429-103.429s-103.429 46.286-103.429 103.429 46.286 103.429 103.429 103.429 103.429-46.286 103.429-103.429zM880.571 544l82.286-195.429h-40.571l-51.429 128-50.857-128h-40.571l81.143 195.429h20zM979.429 538.857h105.143v-32h-68v-51.429h65.714v-32h-65.714v-42.286h68v-32.571h-105.143v190.286zM1202.857 538.857h45.714l-60-80c28-5.714 43.429-24.571 43.429-53.714 0-36-24.571-56.571-67.429-56.571h-55.429v190.286h37.143v-76h5.143zM1316.571 149.714v724.571c0 42.286-33.714 76.571-75.429 76.571h-1165.714c-41.714 0-75.429-34.286-75.429-76.571v-724.571c0-42.286 33.714-76.571 75.429-76.571h1165.714c41.714 0 75.429 34.286 75.429 76.571z"
					],
					"width": 1317,
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cc-discover"
					],
					"grid": 14
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 3,
					"prevSize": 28,
					"code": 59669,
					"name": "cc-discover"
				},
				"setIdx": 4,
				"setId": 2,
				"iconIdx": 3
			},
			{
				"icon": {
					"paths": [
						"M490.286 709.143v-396c-79.429 30.857-136 108-136 198.286s56.571 167.429 136 197.714zM778.286 511.429c0-90.286-56.571-167.429-136-198.286v396.571c79.429-30.857 136-108 136-198.286zM901.143 511.429c0 184.571-149.714 334.857-334.857 334.857-184.571 0-334.857-150.286-334.857-334.857 0-185.143 150.286-334.857 334.857-334.857 185.143 0 334.857 149.714 334.857 334.857zM1120 515.429c0-218.286-182.286-369.143-382.286-369.143h-172c-202.286 0-369.143 150.857-369.143 369.143 0 199.429 166.857 362.286 369.143 362.286h172c200 0 382.286-162.857 382.286-362.286zM1316.571 146.286v731.429c0 40-33.143 73.143-73.143 73.143h-1170.286c-40 0-73.143-33.143-73.143-73.143v-731.429c0-40 33.143-73.143 73.143-73.143h1170.286c40 0 73.143 33.143 73.143 73.143z"
					],
					"width": 1317,
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cc-diners-club"
					],
					"grid": 14
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 4,
					"prevSize": 28,
					"code": 59666,
					"name": "cc-diners-club"
				},
				"setIdx": 4,
				"setId": 2,
				"iconIdx": 4
			},
			{
				"icon": {
					"paths": [
						"M1114.857 570.286c0 20.571-13.714 35.429-30.857 38.857-2.286 0.571-7.429 1.143-10.286 1.143h-87.429v-80h87.429c2.857 0 8 0.571 10.286 1.143 17.143 3.429 30.857 18.857 30.857 38.857zM1104.571 448.571c0 20-13.714 33.143-30.286 36-1.714 0.571-5.714 0.571-8.571 0.571h-79.429v-73.714h79.429c2.857 0 6.857 0.571 8.571 0.571 16.571 2.857 30.286 16.571 30.286 36.571zM416 542.286v-176h-130.286v176c0 42.857-29.143 74.857-81.714 74.857-44.571 0-88.571-13.143-130.857-33.714v64c68.571 18.857 155.429 18.857 155.429 18.857 145.143 0 187.429-55.429 187.429-124zM824 647.429v-64.571c-29.714 15.429-67.429 30.286-114.286 33.714-82.286 6.286-131.429-33.714-131.429-104.571s49.143-110.857 131.429-104.571c46.857 3.429 84 17.714 114.286 33.143v-64c-61.143-15.429-118.857-17.714-118.857-17.714-201.143-9.143-258.286 70.286-258.286 153.143s57.143 162.286 258.286 153.143c0 0 57.714-2.286 118.857-17.714zM1243.429 581.714c0-42.286-37.714-69.714-86.857-73.143v-1.714c44.571-6.286 69.143-35.429 69.143-69.143 0-43.429-36-68.571-84.571-70.857-3.429 0-9.714-0.571-14.857-0.571h-260v291.429h280.571c55.429 0 96.571-29.714 96.571-76zM1316.571 146.286v731.429c0 40-33.143 73.143-73.143 73.143h-1170.286c-40 0-73.143-33.143-73.143-73.143v-731.429c0-40 33.143-73.143 73.143-73.143h1170.286c40 0 73.143 33.143 73.143 73.143z"
					],
					"width": 1317,
					"attrs": [
						{}
					],
					"isMulticolor": false,
					"isMulticolor2": false,
					"tags": [
						"cc-jcb"
					],
					"grid": 14
				},
				"attrs": [
					{}
				],
				"properties": {
					"order": 1,
					"id": 5,
					"prevSize": 28,
					"code": 59665,
					"name": "cc-jcb"
				},
				"setIdx": 4,
				"setId": 2,
				"iconIdx": 5
			}
		],
		"height": 1024,
		"metadata": {
			"name": "icomoon"
		},
		"preferences": {
			"showGlyphs": true,
			"showQuickUse": true,
			"showQuickUse2": true,
			"showSVGs": true,
			"fontPref": {
				"prefix": "icon-",
				"metadata": {
					"fontFamily": "icomoon"
				},
				"metrics": {
					"emSize": 1024,
					"baseline": 6.25,
					"whitespace": 50
				},
				"embed": false
			},
			"imagePref": {
				"prefix": "icon-",
				"png": true,
				"useClassSelector": true,
				"color": 0,
				"bgColor": 16777215,
				"classSelector": ".icon"
			},
			"historySize": 50,
			"showCodes": true,
			"gridSize": 16
		}
	};

/***/ },
/* 664 */
/***/ function(module, exports) {

	module.exports = {
		"AccountAdd.btn.add": "Add account",
		"AccountAdd.error.create": "Error creating account. {errors}",
		"AccountAdd.error.message.create": "Failed to create account: {errors}.",
		"AccountAdd.error.server": "Server error. Try again later.",
		"AccountAdd.success.created": "Account created",
		"AccountAdd.success.message.created": "Account created successfully.",
		"AccountAdd.validation.email.this_value_is_not_a_valid_email_address": "Please enter a valid email.",
		"AccountAdd.validation.email.this_value_should_not_be_blank": "Email cannot be empty.",
		"AccountAdd.validation.password.this_value_should_not_be_blank": "Password cannot be empty.",
		"AccountAdd.validation.username.this_value_should_not_be_blank": "Username cannot be empty.",
		"AccountEditing.2FA.notEnabled": "2FA was not enabled for this account",
		"AccountEditing.2FA.resetSuccess": "Two-factor authentication reset",
		"AccountEditing.admin.error": "Error changing administrator status",
		"AccountEditing.admin.granted": "User has been appointed as project administrator",
		"AccountEditing.admin.label": "Project Administrator",
		"AccountEditing.admin.revoked": "Administrator privileges revoked",
		"AccountEditing.admin.save": "Save",
		"AccountEditing.admin.saving": "Saving...",
		"AccountEditing.btn.reset2FA": "Reset 2FA",
		"AccountEditing.btn.save": "Save",
		"AccountEditing.btn.saving": "Saving...",
		"AccountEditing.btn.sendNewPassword": "Send new password",
		"AccountEditing.empty": "No account selected",
		"AccountEditing.error.reset2FA": "Error resetting 2FA",
		"AccountEditing.error.save": "Error saving account",
		"AccountEditing.error.sendPassword": "Error sending new password",
		"AccountEditing.global.configure": "Configure permissions",
		"AccountEditing.global.enable": "Enable global permissions",
		"AccountEditing.global.hint": "Applied to all user projects",
		"AccountEditing.global.modalTitle": "User global permissions",
		"AccountEditing.global.readOnlyMessage": "Global permissions are used. To change them, go to the \"Global permissions\" section.",
		"AccountEditing.global.title": "Global permissions",
		"AccountEditing.label.createdAt": "Creation date",
		"AccountEditing.label.id": "ID",
		"AccountEditing.label.lastLoginAt": "Last login date",
		"AccountEditing.label.neverLoggedIn": "Never logged in",
		"AccountEditing.label.updatedAt": "Last updated",
		"AccountEditing.loading.data": "Loading...",
		"AccountEditing.loading.saving": "Saving...",
		"AccountEditing.modal.permissions": "Permissions on project {project}",
		"AccountEditing.modal.permissionsGlobal": "Permissions on project {project} (global)",
		"AccountEditing.status.active": "Active",
		"AccountEditing.status.blocked": "Blocked",
		"AccountEditing.status.closed": "Closed",
		"AccountEditing.status.inactive": "Inactive",
		"AccountEditing.status.passwordConfirm": "The account «{account}» password has been changed. Save changes?",
		"AccountEditing.success.passwordSent": "New password sent to user's email",
		"AccountEditing.success.saved": "Account changes saved",
		"AccountEditing.title.account": "Account",
		"AccountEditing.title.contacts": "Contacts",
		"AccountEditing.title.merchants": "Merchants",
		"AccountSearchList.empty": "No linked accounts",
		"AccountSearchList.label.email": "Email",
		"AccountSearchList.label.id": "ID",
		"AccountSearchList.label.name": "Name",
		"AccountSearchList.noResults": "Nothing found",
		"AccountSearchList.search.placeholder": "Search by ID, name, email...",
		"Accounts.button.add": "Add",
		"Accounts.modal.addTitle": "Add account",
		"Accounts.title.accountsList": "Accounts list",
		"Accounts.title.terminalsList": "Terminals",
		"AccountsFilters.btn.filter": "Filter",
		"AccountsFilters.status.active": "Active",
		"AccountsFilters.status.blocked": "Blocked",
		"AccountsFilters.status.closed": "Closed",
		"AccountsFilters.status.inactive": "Inactive",
		"AccountsFilters.title.status": "Status",
		"AccountsList.empty": "No accounts found",
		"AccountsList.status.active": "Active",
		"AccountsList.status.blocked": "Blocked",
		"AccountsList.status.closed": "Closed",
		"AccountsList.status.inactive": "Inactive",
		"AccountsList.table.createdAt": "Created",
		"AccountsList.table.email": "Email",
		"AccountsList.table.id": "ID",
		"AccountsList.table.status": "Status",
		"AccountsList.table.user": "User",
		"AdminFiltersToggle.label": "Filters",
		"AdministrationMenu.list.analytics": "Analytics",
		"AdministrationMenu.list.finance": "Finance",
		"AdministrationMenu.list.payments": "Transactions",
		"AdministrationMenu.list.registries": "Registries",
		"AdministrationMenu.list.reports": "Reports",
		"AdministrationMenu.list.settings": "Settings",
		"AdministrationMenu.list.stats": "Statistics",
		"AdministrationMenu.list.support": "Support",
		"AdministrationMenu.title.accounts": "Settings",
		"AdministrationMenu.title.accountsList": "Accounts list",
		"AdministrationMenu.title.adminAudit": "Activity log",
		"AdministrationMenu.title.antifraud": "Antifraud",
		"AdministrationMenu.title.payoutHolds": "Held payouts",
		"AdministrationMenu.title.console": "Admin panel",
		"AdministrationMenu.title.constructor": "Constructor",
		"AdministrationMenu.title.crmPayoutRequests": "CRM requests",
		"AdministrationMenu.title.crmSbpPayoutRequests": "CRM SBP requests",
		"AdministrationMenu.title.deposits": "Deposits",
		"AdministrationMenu.title.disputes": "Disputes",
		"AdministrationMenu.title.frod": "Anti-frod",
		"AdministrationMenu.title.payments": "Payments",
		"AdministrationMenu.title.projectsList": "Projects",
		"AdministrationMenu.title.reconciliation": "Reconciliation",
		"AdministrationMenu.title.registries": "Registries",
		"AdministrationMenu.title.secretChats": "Secret chats",
		"AdministrationMenu.title.settlements": "Settlements",
		"AdministrationMenu.title.terminalsList": "Terminals",
		"AdministrationMenu.title.tickets": "Support tickets",
		"AdministrationMenu.title.trafficMonitoring": "Traffic monitoring",
		"AdministrationMenu.title.transactionAudit": "Transaction Audit",
		"AntiFraud.add": "Add",
		"AntiFraud.details.delete": "Delete",
		"AntiFraud.details.title": "Record details",
		"AntiFraud.details.unblock": "Unblock",
		"AntiFraud.filter.apply": "Apply",
		"AntiFraud.filter.kind": "Data type",
		"AntiFraud.filter.reset": "Reset",
		"AntiFraud.filter.source": "Source",
		"AntiFraud.filter.status": "Status",
		"AntiFraud.form.expiresAt": "Expiration (optional)",
		"AntiFraud.form.kind": "Data type",
		"AntiFraud.form.reason": "Block reason",
		"AntiFraud.form.source": "Source",
		"AntiFraud.form.submit": "Add block",
		"AntiFraud.form.value": "Value",
		"AntiFraud.list.createdAt": "Created",
		"AntiFraud.list.empty": "No records",
		"AntiFraud.list.expiresAt": "Expires",
		"AntiFraud.list.hits": "Hits",
		"AntiFraud.list.id": "ID",
		"AntiFraud.list.kind": "Type",
		"AntiFraud.list.reason": "Reason",
		"AntiFraud.list.source": "Source",
		"AntiFraud.list.status": "Status",
		"AntiFraud.list.value": "Value",
		"AntiFraud.modal.addTitle": "Add block",
		"AntiFraud.search.mask": "Search by mask",
		"AntiFraud.search.maskPlaceholder": "Enter part of card number, IP or phone...",
		"AntiFraud.stats.title": "Statistics",
		"AntiFraud.status.blocked": "Blocked",
		"AntiFraud.status.unblocked": "Unblocked",
		"AntiFraud.title": "Antifraud records",
		"AntiFraudDetails.delete": "Delete",
		"AntiFraudDetails.title": "Record details",
		"AntiFraudDetails.unblock": "Unblock",
		"AntiFraudFilters.btn.filter": "Filter",
		"AntiFraudFilters.btn.reset": "Reset",
		"AntiFraudFilters.status.blocked": "Blocked",
		"AntiFraudFilters.status.unblocked": "Unblocked",
		"AntiFraudFilters.title.kind": "Data type",
		"AntiFraudFilters.title.source": "Source",
		"AntiFraudFilters.title.status": "Status",
		"AntiFraudForm.error.create": "Error adding record",
		"AntiFraudForm.error.kindRequired": "Select a data type",
		"AntiFraudForm.error.valueRequired": "Enter a value",
		"AntiFraudForm.expiresAt": "Expiration (optional)",
		"AntiFraudForm.expiresAt.hint": "Leave empty for an unlimited block",
		"AntiFraudForm.hint.card_pan": "Card number (16-19 digits)",
		"AntiFraudForm.hint.inn": "INN (10 or 12 digits)",
		"AntiFraudForm.hint.ip": "IP address",
		"AntiFraudForm.hint.name": "Full name",
		"AntiFraudForm.hint.phone": "Phone number in format 79001234567",
		"AntiFraudForm.hint.sbp_phone": "SBP phone in format 79001234567",
		"AntiFraudForm.kind": "Data type",
		"AntiFraudForm.kind.placeholder": "-- Select type --",
		"AntiFraudForm.placeholder.cardPan": "4111111111111111",
		"AntiFraudForm.placeholder.inn": "1234567890",
		"AntiFraudForm.placeholder.ip": "192.168.1.1",
		"AntiFraudForm.placeholder.phone": "79001234567",
		"AntiFraudForm.reason": "Block reason",
		"AntiFraudForm.reason.default": "Manual block by administrator",
		"AntiFraudForm.submit": "Add block",
		"AntiFraudForm.value": "Value",
		"AntiFraudForm.value.placeholder": "Enter value",
		"AntiFraudList.empty": "No records",
		"AntiFraudList.status.blocked": "Blocked",
		"AntiFraudList.status.unblocked": "Unblocked",
		"AntiFraudList.table.hits": "Hits",
		"AntiFraudList.table.id": "ID",
		"AntiFraudList.table.kind": "Type",
		"AntiFraudList.table.lastSeen": "Last seen",
		"AntiFraudList.table.reason": "Reason",
		"AntiFraudList.table.source": "Source",
		"AntiFraudList.table.status": "Status",
		"AntiFraudList.table.value": "Value",
		"AuditLogsFilters.button.apply": "Apply",
		"AuditLogsFilters.button.reset": "Reset",
		"AuditLogsFilters.label.action": "Action",
		"AuditLogsFilters.label.admin": "Administrator",
		"AuditLogsFilters.label.entityType": "Object type",
		"AuditLogsFilters.label.periodFrom": "Period from",
		"AuditLogsFilters.label.periodTo": "to",
		"AuditLogsFilters.label.search": "Search",
		"AuditLogsFilters.option.all": "All",
		"AuditLogsFilters.option.allActions": "All actions",
		"AuditLogsFilters.option.allTypes": "All types",
		"AuditLogsFilters.placeholder.search": "Search by username or object",
		"BalanceWidget.actualBalance": "Actual balance",
		"BalanceWidget.section.payin": "Payment intake",
		"BalanceWidget.section.payout": "Payouts",
		"BalanceWidget.settlementLabel.reimbursement": "Reimbursement",
		"BalanceWidget.settlementLabel.reserve": "Reserve",
		"BalanceWidget.transactionBalance": "Transaction balance",
		"Confirmation.btn.cabinet": "Go to your account",
		"Confirmation.btn.login": "Log in",
		"Confirmation.btn.retry": "Try again",
		"Confirmation.text.error": "The address may have already been confirmed with this link, or a new email change was requested. Check the email in your profile and request the change again if needed.",
		"Confirmation.text.failed": "Check your internet connection and try again. If the error persists, contact support.",
		"Confirmation.text.success": "The new address is saved in your profile. Emails and notifications will now be sent to it.",
		"Confirmation.title.error": "This link is no longer valid",
		"Confirmation.title.failed": "Could not confirm your email",
		"Confirmation.title.success": "Email confirmed",
		"Console.created": "Created",
		"Console.error": "Error",
		"Console.loading": "Loading…",
		"Console.pending": "Pending",
		"Console.title": "Admin Panel",
		"Console.transactionsTitle": "Transactions requiring attention",
		"ContractsTable.empty": "No contracts",
		"ContractsTable.menu.edit": "Edit",
		"ContractsTable.menu.newPSA": "New PSA for contract",
		"ContractsTable.menu.psaList": "PSA list",
		"ContractsTable.table.date": "Date",
		"ContractsTable.table.name": "Name",
		"ContractsTable.table.project": "Project",
		"ContractsTable.table.psaCount": "PSA count",
		"ContractsTable.table.psaProcessing": "PSA in processing",
		"CountryTop.table.country": "Country",
		"CountryTop.table.declined": "Declined",
		"CountryTop.table.successful": "Successful",
		"CountryTop.table.transactions": "Transactions",
		"CountryTop.table.turnover": "Turnover",
		"CrmPayout.action.bulkDecline": "Decline selected",
		"CrmPayout.action.decline": "Decline",
		"CrmPayout.action.formRegistry": "Form registry",
		"CrmPayout.action.retry": "Retry",
		"CrmPayout.action.selected": "Selected: {count}",
		"CrmPayout.detail.title": "Request",
		"CrmPayout.empty": "No requests found",
		"CrmPayout.filters.apply": "Apply",
		"CrmPayout.filters.payoutType": "Payout Type",
		"CrmPayout.filters.reset": "Reset",
		"CrmPayout.filters.status": "Status",
		"CrmPayout.filters.title": "Filters",
		"CrmPayout.search.cardMask": "card mask",
		"CrmPayout.search.cardMask.placeholder": "Enter card mask (e.g. 411111)",
		"CrmPayout.search.externalReference": "external ID",
		"CrmPayout.search.externalReference.placeholder": "Enter external ID",
		"CrmPayout.search.fullName": "full name",
		"CrmPayout.search.fullName.placeholder": "Enter recipient name",
		"CrmPayout.stats.title": "Statistics",
		"CrmPayout.stats.total": "Total",
		"CrmPayout.table.amount": "Amount",
		"CrmPayout.table.card": "Card/Phone",
		"CrmPayout.table.date": "Date",
		"CrmPayout.table.fullName": "Full Name",
		"CrmPayout.table.id": "ID",
		"CrmPayout.table.merchant": "Merchant",
		"CrmPayout.table.status": "Status",
		"CrmPayout.table.type": "Type",
		"CrmPayout.title": "CRM Payout Requests",
		"CrmSbpPayout.title": "CRM SBP Payout Requests",
		"CrmPayoutBoard.type.sbp": "SBP",
		"CrmPayoutDetails.action.cancel": "Cancel",
		"CrmPayoutDetails.action.confirm": "Confirm",
		"CrmPayoutDetails.action.confirmDecline": "Confirm decline",
		"CrmPayoutDetails.action.decline": "Decline",
		"CrmPayoutDetails.action.moveBack": "Move back to awaiting",
		"CrmPayoutDetails.action.moveToSuccess": "Move to success",
		"CrmPayoutDetails.action.sendToAntifraud": "Send to antifraud",
		"CrmPayoutDetails.antifraud.toggle": "Antifraud",
		"CrmPayoutDetails.decline.placeholder": "Decline reason...",
		"CrmPayoutDetails.decline.title": "Decline reason",
		"CrmPayoutDetails.declineReasonRequired": "Specify the decline reason",
		"CrmPayoutDetails.error.generic": "Error: {msg}",
		"CrmPayoutDetails.error.unknown": "Unknown error",
		"CrmPayoutDetails.info.card": "Card",
		"CrmPayoutDetails.info.createdAt": "Created at",
		"CrmPayoutDetails.info.description": "Description",
		"CrmPayoutDetails.info.documentDate": "Document date",
		"CrmPayoutDetails.info.documentNumber": "Document number",
		"CrmPayoutDetails.info.email": "Email",
		"CrmPayoutDetails.info.fullName": "Full name",
		"CrmPayoutDetails.info.merchant": "Merchant",
		"CrmPayoutDetails.info.phone": "Phone",
		"CrmPayoutDetails.info.registry": "Registry",
		"CrmPayoutDetails.info.transaction": "Transaction",
		"CrmPayoutDetails.info.updatedAt": "Updated",
		"CrmPayoutDetails.status.antifraud": "Antifraud",
		"CrmPayoutDetails.status.awaitingPayout": "Awaiting payout",
		"CrmPayoutDetails.status.created": "Created",
		"CrmPayoutDetails.status.error": "Error",
		"CrmPayoutDetails.status.registry": "In registry",
		"CrmPayoutDetails.status.rejected": "Rejected",
		"CrmPayoutDetails.status.success": "Success",
		"CrmPayoutDetails.success.feePlaceholder": "Fee (optional)",
		"CrmPayoutDetails.success.movedToSuccess": "Request moved to success",
		"CrmPayoutDetails.success.sentToAntifraud": "Sent to antifraud",
		"CrmPayoutDetails.title": "Request #{id}",
		"CrmPayoutList.status.antifraud": "Antifraud",
		"CrmPayoutList.status.created": "Created",
		"CrmPayoutList.status.error": "Error",
		"CrmPayoutList.status.processing": "Processing",
		"CrmPayoutList.status.registry": "In registry",
		"CrmPayoutList.status.rejected": "Rejected",
		"CrmPayoutList.status.success": "Success",
		"Dashboard.help.payout": "Payout: {count}",
		"Dashboard.help.purchase": "Purchase: {count}",
		"Dashboard.help.recurrent": "Recurrent: {count}",
		"Dashboard.title.balance": "Balance",
		"Dashboard.title.balanceOnDate": "Balance as of {date}",
		"Dashboard.title.errors": "Errors",
		"Dashboard.title.paymentSystems": "Payment systems",
		"Dashboard.title.paymentsThisMonth": "Payments for {month}",
		"Dashboard.title.paymentsToday": "Payments today",
		"Dashboard.title.refills": "Refills",
		"Dashboard.title.statistics": "Statistics",
		"Dashboard.title.successful": "Successful",
		"DateRange.days30": "30 days",
		"DateRange.days7": "7 days",
		"DateRange.from": "From:",
		"DateRange.halfYear": "6 months",
		"DateRange.month": "month",
		"DateRange.placeholder": "Select period",
		"DateRange.quickSelect": "Quick select",
		"DateRange.timeLabel": "Time:",
		"DateRange.title": "Period",
		"DateRange.to": "To:",
		"DateRange.today": "today",
		"DateRange.week": "week",
		"DateRange.yesterday": "yesterday",
		"DisputeDetails.action.archive": "Archive",
		"DisputeDetails.action.resolved": "Resolved",
		"DisputeDetails.action.saveNote": "Save note",
		"DisputeDetails.action.toWork": "Move to work",
		"DisputeDetails.attachments.file": "File",
		"DisputeDetails.attachments.open": "Open",
		"DisputeDetails.attachments.photo": "Photo",
		"DisputeDetails.attachments.title": "Attachments ({count})",
		"DisputeDetails.error.check": "Check failed",
		"DisputeDetails.error.fileLoad": "Failed to get file",
		"DisputeDetails.error.fileOpen": "Failed to open file",
		"DisputeDetails.error.generic": "Error: {message}",
		"DisputeDetails.error.saveNote": "Failed to save note",
		"DisputeDetails.error.unknown": "Unknown error",
		"DisputeDetails.error.updateStatus": "Failed to update status",
		"DisputeDetails.label.attachment": "Attachment:",
		"DisputeDetails.label.chat": "Chat:",
		"DisputeDetails.label.date": "Date:",
		"DisputeDetails.label.sender": "Sender:",
		"DisputeDetails.linked.checkProvider": "Check with provider",
		"DisputeDetails.linked.currentStatus": "Current status:",
		"DisputeDetails.linked.lastCheck": "Last check: {date}",
		"DisputeDetails.linked.merchant": "Merchant:",
		"DisputeDetails.linked.providerResponse": "Provider response:",
		"DisputeDetails.linked.statusAtCreation": "Status at creation:",
		"DisputeDetails.linked.transaction": "Linked transaction:",
		"DisputeDetails.resolution.placeholder": "Note...",
		"DisputeDetails.resolution.resolvedBy": "Resolved by: {name} ({date})",
		"DisputeDetails.section.message": "Message",
		"DisputeDetails.section.resolution": "Resolution",
		"DisputeDetails.section.transaction": "Transaction",
		"DisputeDetails.title": "Dispute",
		"DisputeDetails.transaction.amount": "Amount:",
		"DisputeDetails.transaction.check": "Check",
		"DisputeDetails.transaction.merchant": "Merchant:",
		"DisputeDetails.transaction.ourStatus": "Our status:",
		"DisputeDetails.transaction.placeholder": "Transaction ID",
		"DisputeDetails.transaction.provider": "Provider:",
		"DisputeDetails.transaction.providerStatus": "Provider status:",
		"DisputeDetails.value.no": "No",
		"DisputeDetails.value.yes": "Yes",
		"DisputeFilters.btn.filter": "Filter",
		"DisputeFilters.btn.reset": "Reset",
		"DisputeFilters.title.status": "Status",
		"Disputes.stats.title": "Statistics",
		"Disputes.title": "Disputes",
		"DisputesList.attachment": "Attachment",
		"DisputesList.empty": "No disputes found",
		"DisputesList.table.chat": "Chat / Sender",
		"DisputesList.table.date": "Date",
		"DisputesList.table.id": "ID",
		"DisputesList.table.merchant": "Merchant",
		"DisputesList.table.message": "Message",
		"DisputesList.table.status": "Status",
		"DisputesList.table.transaction": "Transaction",
		"Empty.message.dataSoon": "Data will appear soon",
		"EmptyChart.message": "Not enough data to build the chart",
		"EventsWidget.btn.createTicket": "Open a ticket",
		"EventsWidget.empty.message": "Important notifications will appear here",
		"EventsWidget.title": "Events",
		"FieldsHelper.error.charactersEmail": "The email address can only contain Latin letters, numbers, and the symbols «_.@». For example: john_doe@email.ru",
		"FieldsHelper.error.checkAmount": "Something's wrong with the amount. Please make sure you've typed it correctly. For example: 100.20",
		"FieldsHelper.error.checkBirthPlace": "Something's wrong with the place of birth. Please check and try again. For example: LYTKARINO",
		"FieldsHelper.error.checkCardNumber": "You entered the number incorrectly. Check it and try again",
		"FieldsHelper.error.checkCardholderName": "Something's wrong with the cardholder name. Please make sure you've typed it correctly. For example: JOHN DOE",
		"FieldsHelper.error.checkEmail": "Something's wrong with the address. Please make sure you've typed it correctly. For example: john_doe@email.ru",
		"FieldsHelper.error.checkIpSymbols": "Something's wrong with the IP address. Please check and try again. For example: 192.168.0.1",
		"FieldsHelper.error.checkIssued": "You entered the data incorrectly. Please check the field and try again",
		"FieldsHelper.error.checkLatinUsername": "Something's wrong with the account name. Please make sure you've typed it correctly. For example: john777",
		"FieldsHelper.error.checkNumbersInn": "Something's wrong with the INN. Please make sure you've typed it correctly. For example: 773334101234",
		"FieldsHelper.error.checkOTPCode": "Something's wrong with the one-time password. Please check and try again. For example: HS38ET",
		"FieldsHelper.error.checkPhone": "Something's wrong with the phone number. Please make sure you've typed it correctly. For example: +79854356633",
		"FieldsHelper.error.checkRegisterName": "Something's wrong with the registry name. Please check and try again. For example: Payouts for May",
		"FieldsHelper.error.checkUrlWebsite": "Something's wrong with the website URL. Please make sure you've typed it correctly. For example: https://yandex.ru",
		"FieldsHelper.error.docIssuerCode": "Specify department code",
		"FieldsHelper.error.docNumber": "Specify document number",
		"FieldsHelper.error.docSerial": "Specify document series",
		"FieldsHelper.error.onlyCyrLatinRegisterName": "The name can consist of letters from the Latin and Cyrillic alphabets, numbers, and symbols «_().». For example: Payouts for May",
		"FieldsHelper.error.onlyIpSymbols": "IP address can consist only of digits and separating dots. For example: 192.168.0.1",
		"FieldsHelper.error.onlyLatinBirthPlace": "Place of birth can contain only Latin letters and symbols «.»",
		"FieldsHelper.error.onlyLatinCardholder": "The cardholder name can only contain letters of the Latin alphabet. For example: JOHN DOE",
		"FieldsHelper.error.onlyLatinIssued": "Can contain only Latin letters and symbols «.\"». For example: DEPARTMENT OF THE FEDERAL MIGRATION SERVICE OF RUSSIA IN MOSCOW",
		"FieldsHelper.error.onlyLatinUsername": "The account name can contain only Latin letters and numbers. For example: john777",
		"FieldsHelper.error.onlyLettersAddress": "Address of birth can contain only Latin letters, digits, and symbols «.,/»",
		"FieldsHelper.error.onlyLettersFirstName": "The first name starts with a capital letter and consists of the Russian or Latin alphabet. For example: John",
		"FieldsHelper.error.onlyLettersLastName": "The last name starts with a capital letter and consists of the Russian or Latin alphabet. For example: Doe",
		"FieldsHelper.error.onlyLettersMetalType": "Metal type must consist of letters only",
		"FieldsHelper.error.onlyLettersNumbersOTPCode": "One-time password can contain only Latin letters and numbers. For example: HS38ET",
		"FieldsHelper.error.onlyLettersPatronymic": "The patronymic starts with a capital letter and consists of the Russian or Latin alphabet. For example: John",
		"FieldsHelper.error.onlyLettersProjectName": "The project name consists of the Russian or Latin alphabet, numbers, and symbols «.\"». For example: Google inc.",
		"FieldsHelper.error.onlyNumbersAmount": "The amount contains only digits and a «.» symbol. For example: 100.20",
		"FieldsHelper.error.onlyNumbersInn": "The INN can contain only numbers. For example: 773334101234",
		"FieldsHelper.error.onlyNumbersMetalImpurity": "Impurity must consist of numbers only",
		"FieldsHelper.error.onlyNumbersMetalPrice": "Price must consist of numbers only",
		"FieldsHelper.error.onlyNumbersMetalWeight": "Weight must consist of numbers only",
		"FieldsHelper.error.onlyNumbersPhone": "Phone number contains only digits and the «+» symbol. For example: +79854356633",
		"FieldsHelper.error.onlyUrlWebsite": "The website URL consists of the Latin alphabet, numbers, and symbols «/.:». For example: https://yandex.ru",
		"FieldsHelper.label.ContractName": "Contract name",
		"FieldsHelper.label.IPAccessRestriction": "IP Access Restriction",
		"FieldsHelper.label.Issued": "Issued by",
		"FieldsHelper.label.PcaName": "PSA name",
		"FieldsHelper.label.PcaTypeMetal": "Type of metal",
		"FieldsHelper.label.amount": "Amount",
		"FieldsHelper.label.authentication": "Two-factor authentication",
		"FieldsHelper.label.authenticationSelect": "Select type",
		"FieldsHelper.label.birthCountry": "Country of birth",
		"FieldsHelper.label.birthPlace": "Place of birth",
		"FieldsHelper.label.cardholder": "Cardholder name",
		"FieldsHelper.label.codeWord": "Code word",
		"FieldsHelper.label.contract": "Contract",
		"FieldsHelper.label.contractBtn": "Create",
		"FieldsHelper.label.contractBtnCreatePdf": "Download consent for personal data processing",
		"FieldsHelper.label.contractCreate": "New contract",
		"FieldsHelper.label.contractDelete": "Delete contract",
		"FieldsHelper.label.contractEdit": "Edit contract",
		"FieldsHelper.label.contractSave": "Save",
		"FieldsHelper.label.contractsList": "List of all contracts",
		"FieldsHelper.label.departmentCode": "Department code",
		"FieldsHelper.label.description": "Description",
		"FieldsHelper.label.docNumber": "Document number",
		"FieldsHelper.label.docSerial": "Document series",
		"FieldsHelper.label.email": "Email",
		"FieldsHelper.label.firstName": "First name",
		"FieldsHelper.label.gender": "Gender",
		"FieldsHelper.label.inn": "INN",
		"FieldsHelper.label.kpp": "KPP (Tax registration reason code)",
		"FieldsHelper.label.lastName": "Last name",
		"FieldsHelper.label.legalAddress": "Registration address",
		"FieldsHelper.label.legalName": "Legal entity name",
		"FieldsHelper.label.metalGrossWeight": "Gross weight (tons)",
		"FieldsHelper.label.metalImpurity": "Impurity (%)",
		"FieldsHelper.label.metalPrice": "Price (RUB)",
		"FieldsHelper.label.metalTareWeight": "Tare weight (tons)",
		"FieldsHelper.label.metalType": "Type",
		"FieldsHelper.label.metalWeight": "Weight (tons)",
		"FieldsHelper.label.ogrn": "OGRN (Primary State Registration Number)",
		"FieldsHelper.label.otpCode": "Code",
		"FieldsHelper.label.password": "Password",
		"FieldsHelper.label.patronymic": "Patronymic",
		"FieldsHelper.label.pca": "PSA",
		"FieldsHelper.label.pcaBtn": "Save and pay",
		"FieldsHelper.label.pcaBtnEdit": "Save changes",
		"FieldsHelper.label.pcaComment": "Comment for PSA",
		"FieldsHelper.label.pcaCreate": "Create PSA",
		"FieldsHelper.label.pcaDelete": "Delete PSA",
		"FieldsHelper.label.pcaDescription": "Description of items",
		"FieldsHelper.label.pcaDescriptionMetal": "Description of scrap and waste",
		"FieldsHelper.label.pcaDownload": "Download .xlsx",
		"FieldsHelper.label.pcaEdit": "View PSA",
		"FieldsHelper.label.pcaList": "List of all PSAs",
		"FieldsHelper.label.pcaSourceMetal": "Source of scrap",
		"FieldsHelper.label.pcaTransportMetal": "Vehicle make and number",
		"FieldsHelper.label.phone": "Phone",
		"FieldsHelper.label.processing": "Processing",
		"FieldsHelper.label.project": "Project",
		"FieldsHelper.label.projectName": "Project name",
		"FieldsHelper.label.projects": "Projects",
		"FieldsHelper.label.registryName": "Name",
		"FieldsHelper.label.residenceAddress": "Actual residence address",
		"FieldsHelper.label.selectProcessing": "Select processing",
		"FieldsHelper.label.selectProject": "Select project",
		"FieldsHelper.label.selectTerminal": "Select terminal",
		"FieldsHelper.label.terminal": "Terminal",
		"FieldsHelper.label.username": "Account name",
		"FieldsHelper.label.websiteUrl": "Website URL",
		"FieldsHelper.password.generate": "Generate password",
		"FieldsHelper.placeholder.birthCountry": "Select country",
		"FieldsHelper.placeholder.gender": "Select gender",
		"HeaderMenu.list.account": "My account",
		"HeaderMenu.list.admin": "Admin panel",
		"HeaderMenu.list.adminPanel": "Admin panel",
		"HeaderMenu.list.apiconsole": "Api console",
		"HeaderMenu.list.clientHome": "Home",
		"HeaderMenu.list.closeMenu": "Close menu",
		"HeaderMenu.list.logout": "Logout",
		"HeaderMenu.list.openMenu": "Open menu",
		"HeaderMenu.list.profile": "Profile",
		"HeaderMenu.list.secretChats": "Chats",
		"HeaderMenu.list.support": "Support",
		"LanguageSelect.language.en": "English",
		"LanguageSelect.language.ru": "Russian",
		"LoginForm.btn.continue": "Continue",
		"LoginForm.btn.login": "Login",
		"LoginForm.btn.sendAgain": "Send again",
		"LoginForm.error.codeInvalid": "Invalid confirmation code.",
		"LoginForm.error.codeRequired": "Confirmation code is required.",
		"LoginForm.error.credentials": "Invalid email or password.",
		"LoginForm.error.blocked": "Your account is blocked. Please contact support.",
		"LoginForm.error.empty": "Email and password are required.",
		"LoginForm.label.remember": "Remember me",
		"LoginForm.link.cantLogin": "Can't log in?",
		"LoginForm.link.forgotPassword": "Forgot password?",
		"LoginForm.logo.alt": "Logo",
		"LoginForm.modal.cantLogin.alt.clearSiteData": "Clearing site data",
		"LoginForm.modal.cantLogin.step.clearCache": "Clear the page cache (Ctrl + F5)",
		"LoginForm.modal.cantLogin.step.clearSiteData": "Clear site data in the browser",
		"LoginForm.modal.cantLogin.step.contactSupport": "Contact support:",
		"LoginForm.modal.cantLogin.title": "Can't log in?",
		"LoginForm.modal.close": "Close modal",
		"LoginForm.modal.forgotPassword.btn.sendCode": "Send code",
		"LoginForm.modal.forgotPassword.btn.verifyCode": "Confirm code",
		"LoginForm.modal.forgotPassword.placeholder.code": "Code from email",
		"LoginForm.modal.forgotPassword.placeholder.email": "Email",
		"LoginForm.modal.forgotPassword.title": "Reset password",
		"LoginForm.placeholder.code": "Code",
		"LoginForm.placeholder.email": "Login",
		"LoginForm.placeholder.password": "Password",
		"LoginForm.recovery.error.codeRequired": "Enter code",
		"LoginForm.recovery.error.emailRequired": "Enter email",
		"LoginForm.recovery.error.invalidCode": "Invalid code",
		"LoginForm.recovery.error.sendCode": "Failed to send code",
		"LoginForm.recovery.error.verifyCode": "Code verification failed",
		"LoginForm.recovery.success.codeSent": "If the account exists, the code has been sent by email",
		"LoginForm.recovery.success.passwordSent": "A new password has been sent by email",
		"LoginForm.text.codeExpired": "The verification code has expired.",
		"LoginForm.text.codeValid": "Code is valid for another {seconds} seconds",
		"LoginForm.text.mfaEmailMessage": "Enter the confirmation code from the {type} message sent to {email}",
		"LoginForm.text.mfaGAuthMessage": "Enter the confirmation code from Google Authenticator",
		"LoginForm.text.mfaPhoneMessage": "Enter the confirmation code from the {type} message sent to phone number {phone}",
		"LoginForm.title.login": "Login to your account",
		"MobileRegistry.table.amount": "Amount",
		"MobileRegistry.table.bic": "BIC / Bank ID",
		"MobileRegistry.table.cardHolderRu": "Full name",
		"MobileRegistry.table.documentDate": "Doc. date",
		"MobileRegistry.table.documentNumber": "Doc. number",
		"MobileRegistry.table.phone": "Phone",
		"MobileRegistry.upload.hint": "Drag and drop a registry (phone/SBP) here or use the {link}",
		"Modal.cancel": "Cancel",
		"Modal.confirm": "Confirm",
		"Pay.error.checkBic": "Enter a valid BIC (7-9 digits)",
		"Pay.error.checkBicOrMemberId": "Enter BIC (7-9 digits) or SBP bank ID",
		"Pay.error.checkFio": "Enter recipient full name",
		"Pay.error.checkPhoneFormat": "Enter a valid phone number (10-15 digits)",
		"Pay.error.documentDateFormat": "Enter date in YYYY-MM-DD format",
		"Pay.error.documentNumberRequired": "Enter contract number",
		"Pay.error.onlyNumbersBic": "Numbers only",
		"Pay.label.amount": "Transaction amount",
		"Pay.label.bankMemberId": "Recipient bank (SBP)",
		"Pay.label.bic": "Recipient bank BIC",
		"Pay.label.bicOrMemberId": "BIC or bank ID (SBP)",
		"Pay.label.documentDate": "Contract date",
		"Pay.label.documentNumber": "Contract number",
		"Pay.label.finstarData": "Contract data",
		"Pay.label.mobileRecipient": "Recipient (SBP)",
		"Pay.label.receiverCheck": "Receiver of check",
		"Pay.label.recipientFio": "Full name (Last First Middle)",
		"Pay.label.recipientName": "Recipient name",
		"Pay.label.recipientPhone": "Recipient phone number",
		"Pay.label.transferRecipient": "Transfer recipient",
		"Pay.title.oneTimePayment": "One-time payment",
		"Pay.toggle.card": "To card",
		"Pay.toggle.mobile": "By phone (SBP)",
		"PayControls.btn.send": "Send transfer",
		"PayControls.label.amount": "Amount:",
		"PayControls.label.balance": "Balance:",
		"PayControls.label.card": "Transfer to card:",
		"PayControls.label.commission": "Commission:",
		"PayControls.label.email": "Email:",
		"PayControls.label.holder": "Cardholder:",
		"PayControls.label.phone": "Phone:",
		"PayControls.title": "Payout details",
		"Payouts.title": "Projects",
		"PayoutsDetail.btn.retryFailed": "Retry failed",
		"PayoutsDetail.modal.amount": "Amount",
		"PayoutsDetail.modal.card": "Card",
		"PayoutsDetail.modal.moreItems": "... and {count} more",
		"PayoutsDetail.modal.pendingListTitle": "Matching pending transactions:",
		"PayoutsDetail.modal.pendingWarning": "Cards from the uploaded registry are already being processed. Possible duplicate payouts.",
		"PayoutsDetail.modal.recipient": "Recipient",
		"PayoutsDetail.modal.warningTitle": "Warning",
		"PayoutsDetailAmounts.label.failed": "Unpaid amount:",
		"PayoutsDetailAmounts.label.other": "Deferred amount:",
		"PayoutsDetailAmounts.label.success": "Paid amount:",
		"PayoutsDetailEditing.btn.save": "Save",
		"PayoutsDetailEditing.error.emptyName": "Registry name cannot be empty.",
		"PayoutsDetailEditing.error.generic": "Oops! Something went wrong. Wait a bit and try again.",
		"PayoutsDetailEditing.error.network": "Oops! Something went wrong. Refresh the page and try again.",
		"PayoutsDetailEditing.label.tags": "Tags",
		"PayoutsDetailEditing.placeholder.name": "Name cannot be empty",
		"PayoutsDetailEditing.success.saved": "Success! Data saved.",
		"PayoutsDetailEditing.title": "Registry editing",
		"PayoutsDetailFilters.btn.setFilters": "Apply filters",
		"PayoutsDetailFilters.status.delayed": "Deferred",
		"PayoutsDetailFilters.status.error": "Error",
		"PayoutsDetailFilters.status.filtered": "Filtered",
		"PayoutsDetailFilters.status.paid": "Paid",
		"PayoutsDetailFilters.title.status": "Status",
		"PayoutsDetailTags.noSuggestions": "No tags found",
		"PayoutsDetailTags.placeholder": "Add tag",
		"PayoutsFilters.btn.filter": "Filter",
		"PayoutsFilters.status.created": "Created",
		"PayoutsFilters.status.delayed": "Delayed",
		"PayoutsFilters.status.inProgress": "In progress",
		"PayoutsFilters.status.processed": "Processed",
		"PayoutsFilters.status.processedWithErrors": "Processed with errors",
		"PayoutsFilters.title.status": "Status",
		"PayoutsFilters.title.tags": "Tags",
		"PayoutsTable.empty": "No data matching filters",
		"PayoutsTable.status.created": "Aside",
		"PayoutsTable.status.filtered": "Filtered",
		"PayoutsTable.status.payout": "Payout",
		"PayoutsTable.status.payoutDecline": "Error",
		"PayoutsTable.tab.bank": "Card bank:",
		"PayoutsTable.tab.country": "Card country:",
		"PayoutsTable.tab.created": "Created:",
		"PayoutsTable.tab.extStatus": "Extended status:",
		"PayoutsTable.tab.fee": "Commission:",
		"PayoutsTable.tab.id": "Transaction ID:",
		"PayoutsTable.tab.params": "Payout parameters",
		"PayoutsTable.tab.processed": "Processed:",
		"PayoutsTable.tab.reason": "Error reason:",
		"PayoutsTable.tab.system": "Payment system:",
		"PayoutsTable.table.amount": "Amount",
		"PayoutsTable.table.pan": "PAN",
		"PayoutsTable.table.phone": "Phone",
		"PayoutsTable.table.recipient": "Recipient",
		"PayoutsTable.table.status": "Status",
		"PcaFilters.status.error": "Error / Payment declined",
		"PcaFilters.status.inProgress": "In progress",
		"PcaFilters.status.inactive": "Inactive",
		"PcaFilters.status.processed": "Paid",
		"PcaFilters.title.status": "Status",
		"PcaTable.empty": "No PSA",
		"PcaTable.menu.duplicate": "Duplicate PSA",
		"PcaTable.menu.view": "View PSA",
		"PcaTable.status.declined": "Payment declined",
		"PcaTable.status.error": "Error",
		"PcaTable.status.inProgress": "In progress",
		"PcaTable.status.inactive": "Inactive",
		"PcaTable.status.paid": "Paid",
		"PcaTable.table.amount": "Amount",
		"PcaTable.table.contract": "Contract",
		"PcaTable.table.date": "PSA date",
		"PcaTable.table.id": "ID",
		"PcaTable.table.name": "PSA name",
		"PcaTable.table.provider": "Provider",
		"PcaTable.table.status": "Status",
		"PersonalManager.description": "For all service-related questions, please contact your personal manager:",
		"PersonalManager.phone.mobile": "Mobile",
		"PersonalManager.phone.work": "Work",
		"PersonalManager.title": "Personal Manager",
		"Prepaid.title": "Prepaid Cards",
		"Prepaid.title.activate": "Card activation",
		"Prepaid.title.details": "Card details",
		"PrepaidDetails.button.activate": "Activate",
		"PrepaidDetails.gender.female": "Female",
		"PrepaidDetails.gender.male": "Male",
		"PrepaidDetails.label.birthCountry": "Country of Birth:",
		"PrepaidDetails.label.birthPlace": "Place of Birth:",
		"PrepaidDetails.label.birthday": "Date of Birth:",
		"PrepaidDetails.label.docIssuedDate": "Issue Date:",
		"PrepaidDetails.label.docIssuer": "Issued By:",
		"PrepaidDetails.label.docIssuerCode": "Department Code:",
		"PrepaidDetails.label.docNumber": "Document Number:",
		"PrepaidDetails.label.docSerial": "Document Series:",
		"PrepaidDetails.label.firstName": "First Name:",
		"PrepaidDetails.label.gender": "Gender:",
		"PrepaidDetails.label.lastName": "Last Name:",
		"PrepaidDetails.label.legalAddress": "Registered Address:",
		"PrepaidDetails.label.patronymic": "Patronymic:",
		"PrepaidDetails.label.phone": "Phone:",
		"PrepaidDetails.label.residenceAddress": "Actual Residence Address:",
		"PrepaidDetails.subtitle.ean": "EAN: {ean} ({part})",
		"PrepaidDetails.tab.contacts": "Contact Information",
		"PrepaidDetails.tab.passport": "Passport Data",
		"PrepaidDetails.tab.personal": "Personal Data",
		"PrepaidTable.empty": "No prepaid cards",
		"PrepaidTable.menu.activate": "Activate",
		"PrepaidTable.menu.details": "Details",
		"PrepaidTable.status.active": "Active",
		"PrepaidTable.status.error": "Error",
		"PrepaidTable.status.inactive": "Inactive",
		"PrepaidTable.status.processing": "Processing",
		"PrepaidTable.table.card": "Card",
		"PrepaidTable.table.client": "Client",
		"PrepaidTable.table.ean": "EAN",
		"PrepaidTable.table.project": "Project",
		"PrepaidTable.table.status": "Status",
		"Profile.btn.activate": "Activate",
		"Profile.btn.connectOTP": "Connect",
		"Profile.btn.save": "Save changes",
		"Profile.button.changePassword": "Change password",
		"Profile.button.save": "Save changes",
		"Profile.error.emailConfirmationNotSent": "Could not send an email to {email}. Your address is unchanged — try again later or contact support.",
		"Profile.error.save": "Error. There are errors in the form. Check the data and try again.",
		"Profile.label.email": "Email",
		"Profile.label.firstName": "First name",
		"Profile.label.lastName": "Last name",
		"Profile.label.password": "Password",
		"Profile.label.patronymic": "Patronymic",
		"Profile.link.cancel": "Cancel changes",
		"Profile.modal.title": "Change data",
		"Profile.section.password": "Change password",
		"Profile.section.personal": "Personal data",
		"Profile.success.emailConfirmationPending": "We sent an email to {email}. The address will change after you follow the link in it.",
		"Profile.success.save": "Success. You have successfully saved the form.",
		"Profile.text.changeEmail": "The account email address has been changed. After confirmation, a letter with further instructions will be sent to {email}.",
		"Profile.text.changeIpAccessList": "The list of allowed IP addresses has been changed. After confirmation, the personal cabinet will be accessible only from addresses: {ipAccessList}.",
		"Profile.text.changeIpAccessListClean": "The list of allowed IP addresses has been changed. After confirmation, the personal cabinet will be accessible from all addresses without restrictions.",
		"Profile.text.changeOTPEmail": "To confirm the operation, enter the one-time password sent to the email address {email}. If the email is not in the \"Inbox\" folder, check the \"Spam\" folder.",
		"Profile.text.changeOTPGAuth": "To confirm the operation, enter the one-time password generated in the Google Authenticator app.",
		"Profile.text.changeOTPPhone": "To confirm the operation, enter the one-time password sent in an SMS message to the number {phone}.",
		"Profile.text.changePassword": "The account password has been changed. After confirmation, you will be logged out on all devices. Before confirming, write down and save the new password in a safe place: {password}",
		"Profile.text.logout": "After changing password, you will be logged out on all devices.",
		"Profile.text.support": "To change full name, contact support.",
		"Profile.title.myProfile": "My profile",
		"Profile.warning.requires2FASetup": "To continue, you need to set up two-factor authentication",
		"ProjectAdd.btn.add": "Add project",
		"ProjectAdd.btn.saving": "Saving...",
		"ProjectAdd.error.create": "Error creating project. {errors}",
		"ProjectAdd.success.created": "Project created",
		"ProjectEditing.antifraud.title": "Antifraud",
		"ProjectEditing.button.deleteService": "Delete service",
		"ProjectEditing.button.refresh": "Refresh from API",
		"ProjectEditing.button.reset": "Reset changes",
		"ProjectEditing.button.save": "Save",
		"ProjectEditing.empty": "Project not selected",
		"ProjectEditing.error.load": "Failed to load full merchant data",
		"ProjectEditing.error.refresh": "Failed to refresh data",
		"ProjectEditing.error.save": "Failed to save changes",
		"ProjectEditing.fees.fixed": "Fixed",
		"ProjectEditing.fees.percent": "%",
		"ProjectEditing.fees.type": "Type",
		"ProjectEditing.field.auth": "Authorization data",
		"ProjectEditing.field.description": "Description",
		"ProjectEditing.field.fees": "Fees",
		"ProjectEditing.field.inn": "INN",
		"ProjectEditing.field.kpp": "KPP",
		"ProjectEditing.field.login": "Login",
		"ProjectEditing.field.name": "Name",
		"ProjectEditing.field.ogrn": "OGRN",
		"ProjectEditing.field.provider": "Provider",
		"ProjectEditing.field.secret": "Secret / API Key",
		"ProjectEditing.field.url": "Website",
		"ProjectEditing.loading": "Loading...",
		"ProjectEditing.merchantKey.hint": "This key is used by the merchant for signing/authenticating requests.",
		"ProjectEditing.merchantKey.title": "Merchant key",
		"ProjectEditing.mid.balance": "Balance:",
		"ProjectEditing.mid.currency": "Currency:",
		"ProjectEditing.mid.currencyBalance": "Currency and balance:",
		"ProjectEditing.mid.currentProvider": "Current provider:",
		"ProjectEditing.mid.delete": "Delete",
		"ProjectEditing.mid.fee.add": "Add fee",
		"ProjectEditing.mid.fee.fixed": "Fixed:",
		"ProjectEditing.mid.fee.minFixed": "Min. fixed:",
		"ProjectEditing.mid.fee.payment": "Payment",
		"ProjectEditing.mid.fee.payout": "Payout",
		"ProjectEditing.mid.fee.percent": "%:",
		"ProjectEditing.mid.fees": "Fees:",
		"ProjectEditing.mid.methods": "Available methods:",
		"ProjectEditing.mid.new": "new",
		"ProjectEditing.mid.openTerminal": "Open terminal settings",
		"ProjectEditing.mid.provider": "Provider:",
		"ProjectEditing.mid.terminalNotLinked": "Terminal not linked",
		"ProjectEditing.mid.title": "MID #{id}",
		"ProjectEditing.mid.widget": "Widget settings:",
		"ProjectEditing.modal.terminalSettings": "Terminal settings",
		"ProjectEditing.modal.userPermissions": "User permissions {username}",
		"ProjectEditing.noData": "No data",
		"ProjectEditing.section.services": "Services (MID)",
		"ProjectEditing.settings.add": "+ Add setting (MID)",
		"ProjectEditing.settings.empty": "No settings found",
		"ProjectEditing.settings.refresh": "Refresh from API",
		"ProjectEditing.settings.title": "Merchant settings (MID)",
		"ProjectEditing.success.allSaved": "All changes saved",
		"ProjectEditing.title": "Project",
		"ProjectEditing.users.title": "Project users",
		"ProjectEditing.widget.callback": "Callback URL",
		"ProjectEditing.widget.callbackHint": "URL for sending callbacks from the widget",
		"ProjectEditing.widget.generate": "Generate",
		"ProjectEditing.widget.key": "Widget key",
		"ProjectEditing.widget.keyHint": "Key for widget authorization",
		"ProjectSearchList.empty": "Nothing found",
		"ProjectSearchList.permissions.btn": "Permissions",
		"ProjectSearchList.permissions.title": "Configure permissions",
		"ProjectSearchList.placeholder": "Search project by name or UUID...",
		"ProjectSearchList.remove.aria": "Remove {name}",
		"ProjectSearchList.selected.title": "Selected projects",
		"ProjectSettings.button.save": "Save",
		"ProjectSettings.checkbox.hideCardholder": "Hide \"Cardholder name\" field",
		"ProjectSettings.checkbox.hideReceipt": "Hide \"Get receipt\" field",
		"ProjectSettings.checkbox.uniqueCheck": "Enable uniqueness check",
		"ProjectSettings.general.description": "Project Description",
		"ProjectSettings.general.id": "Project ID",
		"ProjectSettings.general.info.title": "General Information",
		"ProjectSettings.general.inn": "TIN",
		"ProjectSettings.general.name": "Project Name",
		"ProjectSettings.general.site": "Website",
		"ProjectSettings.general.technical": "Technical",
		"ProjectSettings.info.type": "Settlement organization",
		"ProjectSettings.paymentForm.title": "Payment form settings",
		"ProjectSettings.status.active": "Active",
		"ProjectSettings.status.blocked": "Blocked",
		"ProjectSettings.tab.general": "General Settings",
		"ProjectSettings.tab.paymentForm": "Payment Form",
		"ProjectSettings.tab.terminals": "Terminals",
		"ProjectSettings.terminals.title": "List of terminals",
		"Projects.button.add": "Add",
		"Projects.modal.addTitle": "Add new project",
		"ProjectsControl.title.projects": "Projects",
		"ProjectsFilters.btn.filter": "Filter",
		"ProjectsFilters.status.active": "Active",
		"ProjectsFilters.status.blocked": "Blocked",
		"ProjectsFilters.status.inactive": "Inactive",
		"ProjectsFilters.title.status": "Status",
		"ProjectsList.empty": "No accounts found",
		"ProjectsList.table.accounts": "Accounts",
		"ProjectsList.table.createdAt": "Created",
		"ProjectsList.table.name": "Name",
		"ProjectsList.table.status": "Status",
		"ProjectsList.table.website": "Website",
		"ProjectsTable.link.payouts": "Payouts",
		"ProjectsTable.link.settings": "Settings",
		"ProjectsTable.status.active": "Active",
		"ProjectsTable.status.blocked": "Blocked",
		"ProjectsTable.table.actualBalance": "Actual",
		"ProjectsTable.table.balance": "Balance",
		"ProjectsTable.table.project": "Project",
		"ProjectsTable.table.reservedBalance": "Reserved",
		"ProjectsTable.table.settlementBalance": "Settlement",
		"ProjectsTable.table.site": "Site",
		"ProjectsTable.table.status": "Status",
		"ProjectsTable.table.transactionBalance": "Transaction",
		"ProjectsWidget.empty.title": "No active projects",
		"ProjectsWidget.error.load": "Failed to load projects",
		"ProjectsWidget.help.avgBill": "Average bill",
		"ProjectsWidget.link.viewAll": "View all",
		"ProjectsWidget.table.balance": "Balance",
		"ProjectsWidget.table.payments": "Payments",
		"ProjectsWidget.table.payouts": "Payouts",
		"ProjectsWidget.table.project": "Project",
		"ProjectsWidget.table.settings": "Settings",
		"ProjectsWidget.table.website": "Website",
		"ProjectsWidget.title": "Projects",
		"RefillsFilters.btn.setFilters": "Apply filters",
		"RefillsFilters.status.crediting": "Crediting",
		"RefillsFilters.status.writeOff": "Write-off",
		"RefillsFilters.title.status": "Status",
		"RefillsTable.empty": "No transactions",
		"RefillsTable.table.amount": "Amount",
		"RefillsTable.table.date": "Date",
		"RefillsTable.table.project": "Project",
		"RefillsTable.type.crediting": "Crediting",
		"RefillsTable.type.writeOff": "Write-off",
		"RegistryControls.btn.clear": "Clear",
		"RegistryControls.checkbox.showErrors": "Show errors",
		"RegistryControls.tags.label": "Add tags",
		"RegistryControls.tags.placeholder": "Add tags to registry",
		"RegistryControls.title": "Registry management",
		"RegistryDADUpload.error.format": "(code: {code}) Error! Registry format is invalid. Fix errors and try again.",
		"RegistryDADUpload.error.network": "Upload failed. Try again.",
		"RegistryDADUpload.hint": "Drag and drop registry here or click to select",
		"RegistryDADUpload.link": "link",
		"RegistryDADUpload.loading": "Processing...",
		"RegistryList.confirm.reprocess": "Reprocess registry \"{name}\"?",
		"RegistryList.empty": "No registries found",
		"RegistryList.menu.downloadRegistry": "Download registry",
		"RegistryList.menu.report": "Export report",
		"RegistryList.menu.reprocess": "Reprocess",
		"RegistryList.menu.view": "View details",
		"RegistryList.status.created": "Created",
		"RegistryList.status.delayed": "Delayed",
		"RegistryList.status.inProcessing": "In processing",
		"RegistryList.status.processed": "Processed",
		"RegistryList.status.processedWithErrors": "Processed with errors",
		"RegistryList.status.reprocess": "Reprocess",
		"RegistryList.table.amount": "Amount",
		"RegistryList.table.date": "Date",
		"RegistryList.table.fee": "Fee",
		"RegistryList.table.id": "ID",
		"RegistryList.table.merchant": "Merchant",
		"RegistryList.table.status": "Status",
		"RegistryList.table.tags": "Tags",
		"RegistryUpload.btn.sendRegistry": "Upload registry",
		"RegistryUpload.error.field": "Field",
		"RegistryUpload.error.message": "Message",
		"RegistryUpload.error.value": "Value",
		"RegistryUpload.match.data": "Data",
		"RegistryUpload.match.name": "Name",
		"RegistryUpload.modal.duplicateConfirm": "Are you sure you want to continue?",
		"RegistryUpload.modal.duplicateTitle": "Possible duplicate detected",
		"RegistryUpload.modal.duplicateWarning": "Similar registries were found in the last 30 days:",
		"RegistryUpload.table.amount": "Amount",
		"RegistryUpload.table.cardHolderRu": "Cardholder name",
		"RegistryUpload.table.creditCard": "Card number",
		"RegistryUpload.table.phoneNumber": "Phone",
		"RegistryUploadInfo.errors.format": "File format error",
		"RegistryUploadInfo.errors.missingColumn": "Required column missing: {column}",
		"RegistryUploadInfo.table.amount": "Amount:",
		"RegistryUploadInfo.table.balance": "Balance:",
		"RegistryUploadInfo.table.errors": "Errors:",
		"RegistryUploadInfo.table.fee": "Fee:",
		"RegistryUploadInfo.table.registry": "Registry:",
		"ReportConstructor.btn.createReport": "Create report",
		"ReportConstructor.label.format": "Format",
		"ReportConstructor.label.merchant": "Merchant",
		"ReportConstructor.label.minFee": "Min fee",
		"ReportConstructor.label.period": "Period",
		"ReportConstructor.label.providerFee": "Provider fee",
		"ReportConstructor.label.reportConstructor": "Report constructor",
		"ReportConstructor.label.reportType": "Report type",
		"ReportConstructor.label.selectMerchant": "Select merchant",
		"ReportConstructor.msg.error": "Error generating report",
		"ReportConstructor.msg.noData": "No data for report",
		"ReportConstructor.msg.selectMerchant": "Select a merchant",
		"ReportConstructor.msg.selectPeriod": "Select a period",
		"ReportConstructor.option.merchants": "By merchants",
		"ReportConstructor.option.transactions": "By transactions",
		"ReportConstructor.table.amount": "Top-up amount",
		"ReportConstructor.table.count": "Number of transactions",
		"ReportConstructor.table.fee": "Fee",
		"ReportConstructor.table.provider": "Provider",
		"ReportWidget.format": "Format:",
		"ReportWidget.generate": "Generate report {format}",
		"ReportWidget.imageAlt": "Generate report",
		"ReportWidget.operations": "Operations",
		"SbpPay.label.recipient": "Recipient (SBP)",
		"SbpPay.title": "SBP Payout",
		"Search.example.amount": "example: 10 000",
		"Search.example.amountLess": "example: 10 000",
		"Search.example.cardHolder": "example: Ivan Ivanov",
		"Search.example.cardNumber": "example: 777777 •••• 7777",
		"Search.example.description": "example: purchase operation",
		"Search.example.email": "example: support@email.io",
		"Search.example.externalReference": "example: c8c32d92-cd65-428d-9e2f-896923a3b864",
		"Search.example.fio": "example: John Doe",
		"Search.example.id": "example: 1288",
		"Search.example.pan": "example: 4111111111",
		"Search.example.phone": "74954453019",
		"Search.example.rrn": "___",
		"Search.label.accountId": "Account ID",
		"Search.label.amountEqually": "Amount equally",
		"Search.label.amountLess": "Amount less",
		"Search.label.amountMore": "Amount more",
		"Search.label.cardHolder": "Cardholder",
		"Search.label.cardNumber": "Card Number",
		"Search.label.currency": "Currency",
		"Search.label.description": "Description",
		"Search.label.email": "Email",
		"Search.label.externalReference": "External reference",
		"Search.label.fio": "User name",
		"Search.label.merchantName": "merchant name",
		"Search.label.messageText": "message text",
		"Search.label.operationId": "Transaction ID",
		"Search.label.pan": "PAN",
		"Search.label.phone": "Phone",
		"Search.label.projectName": "Project name",
		"Search.label.projectUuid": "Project UUID",
		"Search.label.providerName": "Provider",
		"Search.label.registryData": "Search by: ID, PAN, name, amount or phone",
		"Search.label.rrn": "RRN",
		"Search.label.searchBy": "Search by",
		"Search.label.senderName": "sender",
		"Search.label.terminalId": "Terminal ID",
		"Search.label.terminalName": "Terminal name",
		"Search.label.transactionId": "Transaction ID",
		"Search.label.url": "Website address",
		"Search.label.username": "Login",
		"Search.label.uuid": "Project UUID",
		"Search.placeholder.accountId": "Enter account ID",
		"Search.placeholder.currency": "Enter currency code",
		"Search.placeholder.description": "Enter project description",
		"Search.placeholder.email": "Enter email",
		"Search.placeholder.fio": "Enter full name",
		"Search.placeholder.merchantName": "Enter merchant name",
		"Search.placeholder.messageText": "Enter search text",
		"Search.placeholder.projectName": "Enter project name",
		"Search.placeholder.projectUuid": "Enter project UUID",
		"Search.placeholder.providerName": "Enter provider name",
		"Search.placeholder.senderName": "Enter sender name",
		"Search.placeholder.terminalId": "Enter terminal ID",
		"Search.placeholder.terminalName": "Enter terminal name",
		"Search.placeholder.transactionId": "Enter transaction ID",
		"Search.placeholder.url": "Enter project URL",
		"Search.placeholder.username": "Login",
		"Search.placeholder.uuid": "Enter project UUID",
		"SearchTags.add": "add",
		"SearchTags.find": "Find",
		"SearchTags.label": "Search by",
		"SearchTags.placeholder.phone": "+7 (___) ___-__-__",
		"SearchTags.search": "Search",
		"SecretChat.button.new": "New chat",
		"SecretChat.button.send": "Send",
		"SecretChat.day.today": "Today",
		"SecretChat.empty.messages": "Empty so far — write first",
		"SecretChat.empty.pick": "Pick a chat or start a new one",
		"SecretChat.error.download": "The file was not downloaded — it may already be deleted",
		"SecretChat.error.load": "Failed to load the conversation",
		"SecretChat.error.send": "Message was not sent",
		"SecretChat.file.attach": "Attach a file",
		"SecretChat.file.download": "Download the file",
		"SecretChat.left.hours": "disappears in {hours} h {minutes} min",
		"SecretChat.left.minutes": "disappears in {minutes} min",
		"SecretChat.list.title": "Conversations",
		"SecretChat.loading": "Loading…",
		"SecretChat.note.ttl": "Encrypted, deleted after {hours} h",
		"SecretChat.placeholder": "Message…",
		"SecretChats.admin.title": "Secret chats",
		"SecretChats.button.cancel": "Cancel",
		"SecretChats.button.clearClient": "Pick another",
		"SecretChats.button.create": "Start chat",
		"SecretChats.empty": "No chats yet",
		"SecretChats.error.create": "Failed to create the chat",
		"SecretChats.error.list": "Failed to load the chat list",
		"SecretChats.field.client": "Client: start typing a name or login",
		"SecretChats.field.first": "First message (optional)",
		"SecretChats.field.search": "Search client",
		"SecretChats.field.subject": "Conversation subject",
		"SecretChats.loading": "Loading…",
		"SecretChats.subtitle": "Messages are encrypted and fully deleted after {hours} hours",
		"SecretChats.title": "Secret chats",
		"Status.active": "Active",
		"Status.blocked": "Blocked",
		"Status.inactive": "Inactive",
		"Status.unknown": "Unknown",
		"Support.chat.button": "Support chat",
		"Support.general.title": "General questions",
		"Support.manager.title": "Your manager",
		"Support.tech.title": "Technical questions",
		"Support.ticket.create": "Open a ticket",
		"Support.ticket.title": "Need help?",
		"SupportWidget.action.attachFile": "Attach file",
		"SupportWidget.action.back": "Back",
		"SupportWidget.action.collapse": "Collapse",
		"SupportWidget.action.createTicket": "Create ticket",
		"SupportWidget.action.send": "Send",
		"SupportWidget.action.sending": "Sending...",
		"SupportWidget.attachment.purged": "file removed due to retention policy",
		"SupportWidget.closedNote": "This ticket is closed. Create a new one if you need help.",
		"SupportWidget.edit.cancel": "Cancel",
		"SupportWidget.edit.save": "Save",
		"SupportWidget.edit.title": "Edit",
		"SupportWidget.empty.chat": "Start the conversation and messages will appear here.",
		"SupportWidget.empty.listText": "Describe the issue, attach screenshots or documents, and we will reply as soon as possible.",
		"SupportWidget.empty.listTitle": "Ask support a question",
		"SupportWidget.error.bodyOrFileRequired": "Describe your issue or attach a file.",
		"SupportWidget.error.fileTooLarge": "File \"{name}\" is larger than 25 MB.",
		"SupportWidget.error.maxFiles": "No more than 10 files per message.",
		"SupportWidget.error.save": "Failed to save.",
		"SupportWidget.error.send": "Failed to send.",
		"SupportWidget.error.subjectRequired": "Enter a ticket subject.",
		"SupportWidget.header.listSubtitle": "We usually reply within an hour",
		"SupportWidget.header.listTitle": "Support",
		"SupportWidget.header.newSubtitle": "Describe your issue and we will help",
		"SupportWidget.header.newTitle": "New ticket",
		"SupportWidget.hint.attachments": "You can attach up to 10 files (up to 25 MB each): screenshots, documents, videos.",
		"SupportWidget.message.deleted": "message deleted",
		"SupportWidget.message.edited": "edited",
		"SupportWidget.placeholder.details": "Describe your issue in more detail...",
		"SupportWidget.placeholder.message": "Message...",
		"SupportWidget.placeholder.subject": "Ticket subject",
		"SupportWidget.size.bytes": "{count} B",
		"SupportWidget.size.kb": "{count} KB",
		"SupportWidget.size.mb": "{count} MB",
		"SupportWidget.status.closed": "Closed",
		"SupportWidget.status.open": "Open",
		"SupportWidget.status.pendingUser": "Waiting for response",
		"SupportWidget.time.daysAgo": "{count} d ago",
		"SupportWidget.time.hoursAgo": "{count} h ago",
		"SupportWidget.time.justNow": "just now",
		"SupportWidget.time.minutesAgo": "{count} min ago",
		"TerminalAdd.btn.create": "Create",
		"TerminalAdd.error.create": "Failed to create terminal",
		"TerminalAdd.error.missing": "Specify project and name",
		"TerminalAdd.label.name": "Name",
		"TerminalAdd.label.project": "Project",
		"TerminalAdd.label.provider": "Provider (optional)",
		"TerminalAdd.label.status": "Status",
		"TerminalAdd.placeholder.noProvider": "— do not select —",
		"TerminalAdd.placeholder.selectProject": "— select project —",
		"TerminalAdd.status.active": "Active",
		"TerminalAdd.status.inactive": "Inactive",
		"TerminalAdd.success.created": "Terminal created",
		"TerminalEditing.auth.empty": "No authorization keys",
		"TerminalEditing.button.save": "Save",
		"TerminalEditing.button.saveLimits": "Save limits",
		"TerminalEditing.empty": "No terminal selected",
		"TerminalEditing.error.loadLimits": "Error loading limits",
		"TerminalEditing.error.save": "Failed to save terminal",
		"TerminalEditing.error.saveLimits": "Error saving limits",
		"TerminalEditing.field.balance": "Balance",
		"TerminalEditing.field.bankAccount": "Bank account",
		"TerminalEditing.field.exchangeRate": "Exchange rate",
		"TerminalEditing.field.name": "Name",
		"TerminalEditing.field.paymentMethod": "Payment method",
		"TerminalEditing.field.returnUrl": "Return URL",
		"TerminalEditing.field.status": "Status",
		"TerminalEditing.field.webhookUrl": "Webhook URL",
		"TerminalEditing.limits.amount": "Amount",
		"TerminalEditing.limits.daily": "Day",
		"TerminalEditing.limits.max": "Max. amount",
		"TerminalEditing.limits.min": "Min. amount",
		"TerminalEditing.limits.monthly": "Month",
		"TerminalEditing.limits.payment.title": "Payments (payment)",
		"TerminalEditing.limits.payout.title": "Payouts (payout)",
		"TerminalEditing.limits.payoutLimit.title": "Total payout limit (payoutLimit)",
		"TerminalEditing.limits.perDay": "Per day",
		"TerminalEditing.limits.perHour": "Per hour",
		"TerminalEditing.limits.perMinute": "Per minute",
		"TerminalEditing.limits.velocity.title": "Velocity",
		"TerminalEditing.loading.limits": "Loading limits...",
		"TerminalEditing.method.h2h": "H2H",
		"TerminalEditing.method.partialRefund": "Partial refund",
		"TerminalEditing.method.partialReversal": "Partial reversal",
		"TerminalEditing.method.preAuth": "Pre-authorization",
		"TerminalEditing.method.recurring": "Recurring",
		"TerminalEditing.method.sbp": "SBP",
		"TerminalEditing.placeholder.notSet": "not set",
		"TerminalEditing.provider.current": "Current: {name}",
		"TerminalEditing.provider.noChange": "— do not change —",
		"TerminalEditing.save": "Save",
		"TerminalEditing.saving.limits": "Saving...",
		"TerminalEditing.section.auth": "Authorization data (processingAuth)",
		"TerminalEditing.section.limits": "Limits",
		"TerminalEditing.section.methods": "Methods",
		"TerminalEditing.section.other": "Other",
		"TerminalEditing.section.provider": "Provider binding",
		"TerminalEditing.status.active": "Active",
		"TerminalEditing.status.inactive": "Inactive",
		"TerminalEditing.success.limitsSaved": "Limits saved",
		"TerminalEditing.success.saved": "Terminal saved",
		"TerminalEditing.title": "Terminal",
		"Terminals.add": "Add",
		"Terminals.modal.addTitle": "Add terminal",
		"Terminals.title": "Terminals",
		"TerminalsFilters.btn.apply": "Apply",
		"TerminalsFilters.method.partialRefund": "Partial refund",
		"TerminalsFilters.method.partialReversal": "Partial reversal",
		"TerminalsFilters.method.preAuth": "Pre-authorization",
		"TerminalsFilters.method.recurring": "Recurring",
		"TerminalsFilters.method.sbp": "SBP",
		"TerminalsFilters.provider.any": "— any —",
		"TerminalsFilters.provider.label": "Provider",
		"TerminalsFilters.status.active": "Active",
		"TerminalsFilters.status.inactive": "Inactive",
		"TerminalsFilters.title": "Filters",
		"TerminalsList.currency": "Currency: {name}",
		"TerminalsList.empty": "Nothing found",
		"TerminalsList.method.p2p": "P2P",
		"TerminalsList.method.partialRefund": "Partial refund",
		"TerminalsList.method.partialReversal": "Partial reversal",
		"TerminalsList.method.preAuth": "Pre-auth",
		"TerminalsList.method.recurring": "Recurring",
		"TerminalsList.method.sbp": "SBP",
		"TerminalsList.status.active": "Active",
		"TerminalsList.status.inactive": "Inactive",
		"TerminalsList.table.balance": "Balance",
		"TerminalsList.table.id": "ID",
		"TerminalsList.table.methods": "Methods",
		"TerminalsList.table.project": "Project",
		"TerminalsList.table.provider": "Provider",
		"TerminalsList.table.status": "Status",
		"TerminalsList.table.terminal": "Terminal",
		"TerminalsTable.empty": "No connected terminals",
		"TerminalsTable.fee.fixed": "Transaction fee:",
		"TerminalsTable.fee.fixedValue": "fixed {value}",
		"TerminalsTable.fee.percent": "Transaction fee:",
		"TerminalsTable.fee.percentValue": "{percent}% (min {min}₽)",
		"TerminalsTable.status.active": "Active",
		"TerminalsTable.status.blocked": "Blocked",
		"TerminalsTable.tab.payments": "Payments",
		"TerminalsTable.tab.payouts": "Payouts",
		"TerminalsTable.table.confirmed": "Confirmed balance",
		"TerminalsTable.table.currency": "Currency",
		"TerminalsTable.table.holded": "Holded balance",
		"TerminalsTable.table.id": "ID",
		"TerminalsTable.table.mcc": "MCC",
		"TerminalsTable.table.name": "Name",
		"TerminalsTable.table.status": "Status",
		"TerminalsTable.table.turnover": "Turnover",
		"TicketsTable.empty": "You have no tickets",
		"TicketsTable.table.lastFrom": "Last message from",
		"TicketsTable.table.message": "Message",
		"TicketsTable.table.status": "Status",
		"TicketsTable.table.updated": "Updated",
		"TransactionAudit.amount": "Amount",
		"TransactionAudit.clearFilters": "Clear Filters",
		"TransactionAudit.createdAt": "Created",
		"TransactionAudit.direction": "Direction",
		"TransactionAudit.empty": "No audit data available",
		"TransactionAudit.error": "Error: {error}",
		"TransactionAudit.eventTypes": "Event Types",
		"TransactionAudit.externalRef": "External Ref",
		"TransactionAudit.filters": "Filters",
		"TransactionAudit.fraud.blocked": "Blocked by antifraud",
		"TransactionAudit.fraud.ok": "Antifraud: OK",
		"TransactionAudit.hint": "Enter a transaction ID to view its complete audit history",
		"TransactionAudit.loading": "Loading audit data...",
		"TransactionAudit.merchant": "Merchant",
		"TransactionAudit.meta": "Details",
		"TransactionAudit.noEvents": "No events recorded yet",
		"TransactionAudit.page.title": "Transaction Audit",
		"TransactionAudit.payload": "Payload",
		"TransactionAudit.processingId": "Processing ID",
		"TransactionAudit.search": "Search",
		"TransactionAudit.searching": "Searching...",
		"TransactionAudit.status": "Status",
		"TransactionAudit.timeline": "Event Timeline",
		"TransactionAudit.title": "Transaction Audit",
		"TransactionAudit.transaction": "Transaction",
		"TransactionsFilters.acquiring.card": "Bank cards",
		"TransactionsFilters.acquiring.phone": "Mobile phones",
		"TransactionsFilters.btn.setFilters": "Filter",
		"TransactionsFilters.category.QR": "QR transactions",
		"TransactionsFilters.category.SBP": "SBP transactions",
		"TransactionsFilters.category.p2p": "P2P transactions",
		"TransactionsFilters.category.payments": "Payments",
		"TransactionsFilters.category.payout": "Payouts",
		"TransactionsFilters.filters.registry": "Payouts by registry",
		"TransactionsFilters.label.chargeback": "Chargeback",
		"TransactionsFilters.label.created": "Created",
		"TransactionsFilters.label.isDataLoading": "Loading...",
		"TransactionsFilters.label.mP2P": "Manual P2P",
		"TransactionsFilters.label.mP2PCreated": "Manual P2P Created",
		"TransactionsFilters.label.mP2PDecline": "Manual P2P Decline",
		"TransactionsFilters.label.mP2PPending": "Manual P2P Pending",
		"TransactionsFilters.label.mobilePayout": "Mobile Payout",
		"TransactionsFilters.label.mobilePayoutCreated": "Mobile Payout Created",
		"TransactionsFilters.label.mobilePayoutDecline": "Mobile Payout Decline",
		"TransactionsFilters.label.mobilePayoutPending": "Mobile Payout Pending",
		"TransactionsFilters.label.payout": "Payout",
		"TransactionsFilters.label.payoutCreated": "Payout created",
		"TransactionsFilters.label.payoutDecline": "Payout decline",
		"TransactionsFilters.label.payoutPending": "Payout pending",
		"TransactionsFilters.label.purchase": "Purchase",
		"TransactionsFilters.label.purchaseCreated": "Purchase created",
		"TransactionsFilters.label.purchaseDecline": "Purchase decline",
		"TransactionsFilters.label.purchasePending": "Purchase pending",
		"TransactionsFilters.label.qr": "QR Successful",
		"TransactionsFilters.label.qrCreated": "QR Created",
		"TransactionsFilters.label.qrDecline": "QR Decline",
		"TransactionsFilters.label.qrPending": "QR Pending",
		"TransactionsFilters.label.recurrent": "Recurrent",
		"TransactionsFilters.label.recurrentCreated": "Recurrent created",
		"TransactionsFilters.label.recurrentDecline": "Recurrent decline",
		"TransactionsFilters.label.recurrentPending": "Recurrent pending",
		"TransactionsFilters.label.refund": "Refund",
		"TransactionsFilters.label.refundCreated": "Refund created",
		"TransactionsFilters.label.refundDecline": "Refund decline",
		"TransactionsFilters.label.refundPending": "Refund pending",
		"TransactionsFilters.label.reversal": "Reversal",
		"TransactionsFilters.label.reversalCreated": "Reversal created",
		"TransactionsFilters.label.reversalDecline": "Reversal decline",
		"TransactionsFilters.label.reversalPending": "Reversal pending",
		"TransactionsFilters.label.sbp": "SBP",
		"TransactionsFilters.label.sbpCreated": "SBP Created",
		"TransactionsFilters.label.sbpDecline": "SBP Decline",
		"TransactionsFilters.label.sbpPending": "SBP Pending",
		"TransactionsFilters.label.successfulP2P": "Successful P2P",
		"TransactionsFilters.label.successfulSBP": "Successful SBP",
		"TransactionsFilters.label.successfulSbp": "Successful SBP",
		"TransactionsFilters.label.threeDSPending": "3DS Pending",
		"TransactionsFilters.title.acquiring": "Acquiring",
		"TransactionsFilters.title.filters": "Filters",
		"TransactionsFilters.title.statuses": "Statuses",
		"TransactionsTable.amount.confirm": "Change transaction amount {id} to {amount}?",
		"TransactionsTable.amount.error.invalid": "Invalid amount format. Example: 1000 or 1000.50",
		"TransactionsTable.amount.error.required": "Enter an amount",
		"TransactionsTable.amount.error.save": "Failed to change transaction amount",
		"TransactionsTable.amount.note": "Enter the amount in major units; the database stores minor units.",
		"TransactionsTable.amount.placeholder": "For example: 1000 or 1000.50",
		"TransactionsTable.amount.save": "Save",
		"TransactionsTable.amount.saving": "Saving...",
		"TransactionsTable.amount.section": "Change amount",
		"TransactionsTable.amount.success": "Transaction amount updated",
		"TransactionsTable.cancel.cancel": "Cancel ",
		"TransactionsTable.cancel.error": "Payment cancellation is not possible",
		"TransactionsTable.cancel.initiated": "Operation {id} has been {type}.",
		"TransactionsTable.cancel.loading": "Fetching data...",
		"TransactionsTable.cancel.refund": "Refund ",
		"TransactionsTable.cancel.success": "Cancellation initiated",
		"TransactionsTable.check.amount": "Amount:",
		"TransactionsTable.check.button": "Check transaction",
		"TransactionsTable.check.decline": "Move to Decline",
		"TransactionsTable.check.error": "Error while checking transaction",
		"TransactionsTable.check.loading": "Checking...",
		"TransactionsTable.check.message": "Message:",
		"TransactionsTable.check.orderId": "Order ID:",
		"TransactionsTable.check.payout": "Move to Payout",
		"TransactionsTable.check.provider": "Provider:",
		"TransactionsTable.check.result": "Check result:",
		"TransactionsTable.check.rrn": "RRN:",
		"TransactionsTable.check.status": "Status:",
		"TransactionsTable.confirm.action": "Action",
		"TransactionsTable.confirm.decline": "Move transaction {id} to Decline?",
		"TransactionsTable.confirm.payout": "Move transaction {id} to Payout?",
		"TransactionsTable.confirm.text": "Confirm operation",
		"TransactionsTable.empty": "No payments",
		"TransactionsTable.error.cancel": "Payment cancellation is not possible",
		"TransactionsTable.error.decline": "Failed to move transaction to Decline",
		"TransactionsTable.error.payout": "Failed to move transaction to Payout",
		"TransactionsTable.label.chargeback": "Chargeback",
		"TransactionsTable.label.created": "Created",
		"TransactionsTable.label.mP2P": "Manual P2P",
		"TransactionsTable.label.mP2PCreated": "Manual P2P Created",
		"TransactionsTable.label.mP2PDecline": "Manual P2P Decline",
		"TransactionsTable.label.mP2PPending": "Manual P2P Pending",
		"TransactionsTable.label.mobilePayout": "Mobile Payout",
		"TransactionsTable.label.mobilePayoutCreated": "Mobile Payout Created",
		"TransactionsTable.label.mobilePayoutDecline": "Mobile Payout Decline",
		"TransactionsTable.label.mobilePayoutPending": "Mobile Payout Pending",
		"TransactionsTable.label.payout": "Payout",
		"TransactionsTable.label.payoutCreated": "Payout created",
		"TransactionsTable.label.payoutDecline": "Payout decline",
		"TransactionsTable.label.payoutPending": "Payout pending",
		"TransactionsTable.label.purchase": "Purchase",
		"TransactionsTable.label.purchaseCreated": "Purchase created",
		"TransactionsTable.label.purchaseDecline": "Purchase decline",
		"TransactionsTable.label.purchasePending": "Purchase pending",
		"TransactionsTable.label.qr": "QR Successful",
		"TransactionsTable.label.qrCreated": "QR Created",
		"TransactionsTable.label.qrDecline": "QR Decline",
		"TransactionsTable.label.qrPending": "QR Pending",
		"TransactionsTable.label.recurrent": "Recurrent",
		"TransactionsTable.label.recurrentCreated": "Recurrent created",
		"TransactionsTable.label.recurrentDecline": "Recurrent decline",
		"TransactionsTable.label.recurrentPending": "Recurrent pending",
		"TransactionsTable.label.refund": "Refund",
		"TransactionsTable.label.refundCreated": "Refund created",
		"TransactionsTable.label.refundDecline": "Refund decline",
		"TransactionsTable.label.refundPending": "Refund pending",
		"TransactionsTable.label.reversal": "Reversal",
		"TransactionsTable.label.reversalCreated": "Reversal created",
		"TransactionsTable.label.reversalDecline": "Reversal decline",
		"TransactionsTable.label.reversalPending": "Reversal pending",
		"TransactionsTable.label.sbp": "SBP",
		"TransactionsTable.label.sbpCreated": "SBP Created",
		"TransactionsTable.label.sbpDecline": "SBP Decline",
		"TransactionsTable.label.sbpPending": "SBP Pending",
		"TransactionsTable.label.successfulP2P": "Successful P2P",
		"TransactionsTable.label.successfulSBP": "Successful SBP",
		"TransactionsTable.label.successfulSbp": "Successful SBP",
		"TransactionsTable.label.threeDSPending": "3DS Pending",
		"TransactionsTable.modal.refund": "Refund {amount}",
		"TransactionsTable.modal.reversal": "Cancel payment {amount}",
		"TransactionsTable.modal.title": "Confirm action",
		"TransactionsTable.refund.action": "Action",
		"TransactionsTable.refund.button": "Refund",
		"TransactionsTable.refund.id": "Refund transaction ID",
		"TransactionsTable.refund.initiated": "Refund initiated",
		"TransactionsTable.refund.loading": "Loading data...",
		"TransactionsTable.refund.status": "Status",
		"TransactionsTable.refund.type": "Type",
		"TransactionsTable.resend.button": "Resend to merchant",
		"TransactionsTable.resend.buttonDeposit": "Retry crediting",
		"TransactionsTable.resend.confirm": "Resend the notification for transaction {id} to the merchant?",
		"TransactionsTable.resend.confirmDeposit": "Retry delivering deposit {id} to the merchant?",
		"TransactionsTable.resend.confirmReopen": "Deposit {id} was declined by the merchant. It will be sent to the merchant again and, if accepted, credited to the merchant balance (amount minus fee). Continue?",
		"TransactionsTable.resend.error": "Failed to resend to the merchant",
		"TransactionsTable.resend.flow.agent_deposit": "agent deposit",
		"TransactionsTable.resend.flow.craft_lite": "Paycraft (lite)",
		"TransactionsTable.resend.flow.fins_lite": "FinStar (lite)",
		"TransactionsTable.resend.flow.hydra_lite": "Hydracode (lite)",
		"TransactionsTable.resend.flow.npay_lite": "NPay (lite)",
		"TransactionsTable.resend.flow.queue": "regular notification (queue)",
		"TransactionsTable.resend.result.flow": "Format: {flow}",
		"TransactionsTable.resend.result.host": "Address: {host}",
		"TransactionsTable.resend.result.httpCode": "Merchant response: HTTP {code}",
		"TransactionsTable.resend.sending": "Sending...",
		"TransactionsTable.reversal.action": "Action",
		"TransactionsTable.reversal.button": "Cancel payment",
		"TransactionsTable.reversal.canceled": "Payment canceled",
		"TransactionsTable.reversal.id": "Cancellation transaction ID",
		"TransactionsTable.reversal.loading": "Loading data...",
		"TransactionsTable.reversal.status": "Status",
		"TransactionsTable.reversal.type": "Type",
		"TransactionsTable.status.loading": "Waiting for response...",
		"TransactionsTable.status.waiting": "Status",
		"TransactionsTable.success.cancel": "Cancellation initiated",
		"TransactionsTable.success.decline": "Transaction status updated to Decline",
		"TransactionsTable.success.payout": "Transaction status updated to Payout",
		"TransactionsTable.tab.action": "Action:",
		"TransactionsTable.tab.actions": "Actions",
		"TransactionsTable.tab.amount": "Amount:",
		"TransactionsTable.tab.audit": "Audit",
		"TransactionsTable.tab.bank": "Card bank:",
		"TransactionsTable.tab.cancelId": "ID",
		"TransactionsTable.tab.cancelType": "Operation type",
		"TransactionsTable.tab.cardHolder": "Cardholder:",
		"TransactionsTable.tab.confirm": "Confirmation",
		"TransactionsTable.tab.country": "Card country:",
		"TransactionsTable.tab.email": "E-mail:",
		"TransactionsTable.tab.extStatus": "Extended status:",
		"TransactionsTable.tab.extendedStatus": "Extended status:",
		"TransactionsTable.tab.fee": "Fee:",
		"TransactionsTable.tab.id": "Transaction ID:",
		"TransactionsTable.tab.management": "Management",
		"TransactionsTable.tab.parameters": "Payment parameters",
		"TransactionsTable.tab.params": "Payment parameters",
		"TransactionsTable.tab.payment": "Payment data",
		"TransactionsTable.tab.paymentData": "Payment data",
		"TransactionsTable.tab.phone": "Phone:",
		"TransactionsTable.tab.processId": "Process ID:",
		"TransactionsTable.tab.processed": "Processed:",
		"TransactionsTable.tab.refund": "Refund",
		"TransactionsTable.tab.rrn": "RRN:",
		"TransactionsTable.tab.status": "Status",
		"TransactionsTable.tab.waiting": "Waiting for response...",
		"TransactionsTable.table.amount": "Amount",
		"TransactionsTable.table.date": "Date",
		"TransactionsTable.table.payer": "Payer",
		"TransactionsTable.table.project": "Project",
		"TransactionsTable.text.paymentPartialRefund": "Partial refund is available for this transaction. Maximum amount {amount}. Return time depends on the issuing bank and ranges from 1 to 7 business days.",
		"TransactionsTable.text.paymentPartialReversal": "Partial reversal is available for this transaction. Maximum amount {amount}. Reversal time depends on the issuing bank and usually occurs within an hour.",
		"TransactionsTable.text.paymentRefund": "A refund will be made in the amount of {amount}. The return time depends on the issuing bank and ranges from 1 to 7 business days.",
		"TransactionsTable.text.paymentReversal": "The payment will be canceled for the amount {amount}. Cancellation time depends on the issuing bank and usually occurs within an hour.",
		"UserMenu.list.home": "Home",
		"UserMenu.list.projects": "Projects",
		"UserMenu.list.transactions": "Transactions",
		"UserMenu.title.antifraud": "Antifraud System",
		"UserMenu.title.antifraudFileCheck": "File Check",
		"UserMenu.title.antifraudLog": "Antifraud Log",
		"UserMenu.title.antifraudSingleCheck": "Single Check",
		"UserMenu.title.finance": "Finance",
		"UserMenu.title.metal": "Metal",
		"UserMenu.title.mobileRegistries": "Registries (SBP)",
		"UserMenu.title.payments": "Payments",
		"UserMenu.title.payouts": "Payouts",
		"UserMenu.title.prepaid": "Activated cards",
		"UserMenu.title.registries": "Registries",
		"UserMenu.title.sbpPayouts": "Payouts (SBP)",
		"UserMenu.title.sbpRegistries": "Registries (SBP)",
		"UserMenu.title.statement": "Statement",
		"UserSearchList.empty": "Nothing found",
		"UserSearchList.loading": "Loading users...",
		"UserSearchList.permissions.btn": "Permissions",
		"UserSearchList.permissions.title": "Configure permissions",
		"UserSearchList.placeholder": "Search user by ID, name or email...",
		"UserSearchList.remove.aria": "Remove {name}",
		"UserSearchList.selected.title": "Selected users",
		"binBase.country.0": "United States of America",
		"binBase.country.10": "Antarctic",
		"binBase.country.100": "Bulgaria",
		"binBase.country.104": "Myanmar",
		"binBase.country.108": "Burundi",
		"binBase.country.112": "Belarus",
		"binBase.country.116": "Cambodia",
		"binBase.country.12": "Algeria",
		"binBase.country.120": "Cameroon",
		"binBase.country.124": "Canada",
		"binBase.country.132": "Cape Verde",
		"binBase.country.136": "Cayman Islands",
		"binBase.country.140": "Central African Republic",
		"binBase.country.144": "Sri Lanka",
		"binBase.country.148": "Chad",
		"binBase.country.152": "Chile",
		"binBase.country.156": "China",
		"binBase.country.158": "Taiwan",
		"binBase.country.16": "American Samoa",
		"binBase.country.162": "Christmas Island",
		"binBase.country.166": "Cocos (Keeling) Islands",
		"binBase.country.170": "Colombia",
		"binBase.country.174": "Comoros",
		"binBase.country.175": "Mayotte",
		"binBase.country.178": "Congo",
		"binBase.country.180": "Congo, Democratic Republic of the",
		"binBase.country.184": "Cook Islands",
		"binBase.country.188": "Costa Rica",
		"binBase.country.191": "Croatia",
		"binBase.country.192": "Cuba",
		"binBase.country.196": "Cyprus",
		"binBase.country.20": "Andorra",
		"binBase.country.203": "Czech Republic",
		"binBase.country.204": "Benin",
		"binBase.country.208": "Denmark",
		"binBase.country.212": "Dominica",
		"binBase.country.214": "Dominican Republic",
		"binBase.country.218": "Ecuador",
		"binBase.country.222": "El Salvador",
		"binBase.country.226": "Equatorial Guinea",
		"binBase.country.231": "Ethiopia",
		"binBase.country.232": "Eritrea",
		"binBase.country.233": "Estonia",
		"binBase.country.234": "Faroe Islands",
		"binBase.country.238": "Falkland (Malvinas) Islands",
		"binBase.country.239": "South Georgia and the South Sandwich Islands",
		"binBase.country.24": "Angola",
		"binBase.country.242": "Fiji",
		"binBase.country.246": "Finland",
		"binBase.country.250": "France",
		"binBase.country.254": "French Guiana",
		"binBase.country.258": "French Polynesia",
		"binBase.country.260": "French Southern Territories",
		"binBase.country.262": "Djibouti",
		"binBase.country.266": "Gabon",
		"binBase.country.268": "Georgia",
		"binBase.country.270": "Gambia",
		"binBase.country.275": "Palestinian Territory (occupied)",
		"binBase.country.276": "Germany",
		"binBase.country.28": "Antigua and Barbuda",
		"binBase.country.280": "Germany",
		"binBase.country.288": "Ghana",
		"binBase.country.292": "Gibraltar",
		"binBase.country.296": "Kiribati",
		"binBase.country.300": "Greece",
		"binBase.country.304": "Greenland",
		"binBase.country.308": "Grenada",
		"binBase.country.31": "Azerbaijan",
		"binBase.country.312": "Guadeloupe",
		"binBase.country.316": "Guam",
		"binBase.country.32": "Argentina",
		"binBase.country.320": "Guatemala",
		"binBase.country.324": "Guinea",
		"binBase.country.328": "Guyana",
		"binBase.country.332": "Haiti",
		"binBase.country.334": "Heard and McDonald Islands",
		"binBase.country.336": "Vatican (Holy See)",
		"binBase.country.340": "Honduras",
		"binBase.country.344": "Hong Kong",
		"binBase.country.348": "Hungary",
		"binBase.country.352": "Iceland",
		"binBase.country.356": "India",
		"binBase.country.36": "Australia",
		"binBase.country.360": "Indonesia",
		"binBase.country.364": "Iran",
		"binBase.country.368": "Iraq",
		"binBase.country.372": "Ireland",
		"binBase.country.376": "Israel",
		"binBase.country.380": "Italy",
		"binBase.country.384": "Cote d'Ivoire",
		"binBase.country.388": "Jamaica",
		"binBase.country.392": "Japan",
		"binBase.country.398": "Kazakhstan",
		"binBase.country.4": "Afghanistan",
		"binBase.country.40": "Austria",
		"binBase.country.400": "Jordan",
		"binBase.country.404": "Kenya",
		"binBase.country.408": "Korea (North)",
		"binBase.country.410": "Korea (South)",
		"binBase.country.414": "Kuwait",
		"binBase.country.417": "Kyrgyzstan",
		"binBase.country.418": "Lao People's Democratic Republic",
		"binBase.country.422": "Lebanon",
		"binBase.country.426": "Lesotho",
		"binBase.country.428": "Latvia",
		"binBase.country.430": "Liberia",
		"binBase.country.434": "Libya",
		"binBase.country.438": "Liechtenstein",
		"binBase.country.44": "Bahamas",
		"binBase.country.440": "Lithuania",
		"binBase.country.442": "Luxembourg",
		"binBase.country.446": "Macau (Macao)",
		"binBase.country.450": "Madagascar",
		"binBase.country.454": "Malawi",
		"binBase.country.458": "Malaysia",
		"binBase.country.462": "Maldives",
		"binBase.country.466": "Mali",
		"binBase.country.470": "Malta",
		"binBase.country.474": "Martinique",
		"binBase.country.478": "Mauritania",
		"binBase.country.48": "Bahrain",
		"binBase.country.480": "Mauritius",
		"binBase.country.484": "Mexico",
		"binBase.country.492": "Monaco",
		"binBase.country.496": "Mongolia",
		"binBase.country.498": "Moldova",
		"binBase.country.499": "Montenegro",
		"binBase.country.50": "Bangladesh",
		"binBase.country.500": "Montserrat",
		"binBase.country.504": "Morocco",
		"binBase.country.508": "Mozambique",
		"binBase.country.51": "Armenia",
		"binBase.country.512": "Oman",
		"binBase.country.516": "Namibia",
		"binBase.country.52": "Barbados",
		"binBase.country.520": "Nauru",
		"binBase.country.524": "Nepal",
		"binBase.country.528": "Netherlands",
		"binBase.country.530": "Netherlands Antilles",
		"binBase.country.531": "CURACAO",
		"binBase.country.533": "Aruba",
		"binBase.country.534": "Sint Maarten",
		"binBase.country.535": "Bonaire, Sint Eustatius and Saba",
		"binBase.country.540": "New Caledonia",
		"binBase.country.548": "Vanuatu",
		"binBase.country.554": "New Zealand",
		"binBase.country.558": "Nicaragua",
		"binBase.country.56": "Belgium",
		"binBase.country.562": "Niger",
		"binBase.country.566": "Nigeria",
		"binBase.country.570": "Niue",
		"binBase.country.574": "Norfolk Island",
		"binBase.country.578": "Norway",
		"binBase.country.580": "Northern Mariana Islands",
		"binBase.country.581": "United States Minor Outlying Islands",
		"binBase.country.583": "Federated States of Micronesia",
		"binBase.country.584": "Marshall Islands",
		"binBase.country.585": "Palau",
		"binBase.country.586": "Pakistan",
		"binBase.country.591": "Panama",
		"binBase.country.598": "Papua New Guinea",
		"binBase.country.60": "Bermuda",
		"binBase.country.600": "Paraguay",
		"binBase.country.604": "Peru",
		"binBase.country.608": "Philippines",
		"binBase.country.612": "Pitcairn",
		"binBase.country.616": "Poland",
		"binBase.country.620": "Portugal",
		"binBase.country.624": "Guinea-Bissau",
		"binBase.country.626": "East Timor (TL, TLS)",
		"binBase.country.630": "Puerto Rico",
		"binBase.country.634": "Qatar",
		"binBase.country.638": "Reunion",
		"binBase.country.64": "Bhutan",
		"binBase.country.642": "Romania (ROU)",
		"binBase.country.643": "Russia (Russian Federation)",
		"binBase.country.646": "Rwanda",
		"binBase.country.654": "St. Helena",
		"binBase.country.659": "Saint Kitts (Christopher) and Nevis",
		"binBase.country.660": "Anguilla",
		"binBase.country.662": "Saint Lucia",
		"binBase.country.666": "St. Pierre and Miquelon",
		"binBase.country.670": "Saint Vincent and the Grenadines",
		"binBase.country.674": "San Marino",
		"binBase.country.678": "Sao Tome and Principe",
		"binBase.country.68": "Bolivia",
		"binBase.country.682": "Saudi Arabia",
		"binBase.country.686": "Senegal",
		"binBase.country.688": "Serbia",
		"binBase.country.690": "Seychelles",
		"binBase.country.694": "Sierra Leone",
		"binBase.country.70": "Bosnia & Herzegovina",
		"binBase.country.702": "Singapore",
		"binBase.country.703": "Slovak Republic",
		"binBase.country.704": "Vietnam",
		"binBase.country.705": "Slovenia",
		"binBase.country.706": "Somalia",
		"binBase.country.710": "South Africa",
		"binBase.country.716": "Zimbabwe",
		"binBase.country.72": "Botswana",
		"binBase.country.724": "Spain",
		"binBase.country.728": "South Sudan",
		"binBase.country.729": "Sudan",
		"binBase.country.732": "Western Sahara",
		"binBase.country.736": "Sudan",
		"binBase.country.74": "Bouvet Island",
		"binBase.country.740": "Suriname",
		"binBase.country.744": "Svalbard and Jan Mayen Islands",
		"binBase.country.748": "Eswatini",
		"binBase.country.752": "Sweden",
		"binBase.country.756": "Switzerland",
		"binBase.country.76": "Brazil",
		"binBase.country.760": "Syria",
		"binBase.country.762": "Tajikistan",
		"binBase.country.764": "Thailand",
		"binBase.country.768": "Togo",
		"binBase.country.772": "Tokelau",
		"binBase.country.776": "Tonga",
		"binBase.country.780": "Trinidad and Tobago",
		"binBase.country.784": "United Arab Emirates",
		"binBase.country.788": "Tunisia",
		"binBase.country.792": "Turkey",
		"binBase.country.795": "Turkmenistan",
		"binBase.country.796": "Turks and Caicos Islands",
		"binBase.country.798": "Tuvalu",
		"binBase.country.8": "Albania",
		"binBase.country.800": "Uganda",
		"binBase.country.804": "Ukraine",
		"binBase.country.807": "North Macedonia",
		"binBase.country.818": "Egypt",
		"binBase.country.826": "United Kingdom",
		"binBase.country.831": "Guernsey",
		"binBase.country.832": "Jersey",
		"binBase.country.833": "Isle of Man",
		"binBase.country.834": "Tanzania",
		"binBase.country.84": "Belize",
		"binBase.country.840": "United States of America",
		"binBase.country.850": "Virgin Islands, US",
		"binBase.country.854": "Burkina Faso",
		"binBase.country.858": "Uruguay",
		"binBase.country.86": "British Indian Ocean Territory",
		"binBase.country.860": "Uzbekistan",
		"binBase.country.862": "Venezuela",
		"binBase.country.876": "Wallis and Futuna Islands",
		"binBase.country.882": "Samoa",
		"binBase.country.887": "Yemen",
		"binBase.country.891": "Yugoslavia",
		"binBase.country.894": "Zambia",
		"binBase.country.90": "Solomon Islands",
		"binBase.country.92": "Virgin Islands, British",
		"binBase.country.96": "Brunei Darussalam",
		"binBase.country.999": "Kosovo"
	};

/***/ },
/* 665 */
/***/ function(module, exports) {

	module.exports = {
		"AccountAdd.btn.add": "Добавить аккаунт",
		"AccountAdd.error.create": "Ошибка создания аккаунта. {errors}",
		"AccountAdd.error.message.create": "Ошибка создания аккаунта: {errors}.",
		"AccountAdd.error.server": "Ошибка сервера. Попробуйте позже.",
		"AccountAdd.success.created": "Аккаунт создан",
		"AccountAdd.success.message.created": "Аккаунт успешно создан.",
		"AccountAdd.validation.email.this_value_is_not_a_valid_email_address": "Введите валидный Email.",
		"AccountAdd.validation.email.this_value_should_not_be_blank": "Email не может быть пустым.",
		"AccountAdd.validation.password.this_value_should_not_be_blank": "Пароль не может быть пустым.",
		"AccountAdd.validation.username.this_value_should_not_be_blank": "Название не может быть пустым.",
		"AccountEditing.2FA.notEnabled": "Для аккаунта 2FA не была включена",
		"AccountEditing.2FA.resetSuccess": "Двухфакторная аутентификация сброшена",
		"AccountEditing.admin.error": "Ошибка при изменении статуса администратора",
		"AccountEditing.admin.granted": "Пользователь назначен администратором на проекте",
		"AccountEditing.admin.label": "Администратор на проекте",
		"AccountEditing.admin.revoked": "Администраторские права сняты",
		"AccountEditing.admin.save": "Сохранить",
		"AccountEditing.admin.saving": "Сохранение...",
		"AccountEditing.btn.reset2FA": "Сбросить 2FA",
		"AccountEditing.btn.save": "Сохранить",
		"AccountEditing.btn.saving": "Сохранение...",
		"AccountEditing.btn.sendNewPassword": "Выслать новый пароль",
		"AccountEditing.empty": "Аккаунт не выбран",
		"AccountEditing.error.reset2FA": "Ошибка при сбросе 2FA",
		"AccountEditing.error.save": "Ошибка при сохранении аккаунта",
		"AccountEditing.error.sendPassword": "Ошибка при отправке нового пароля",
		"AccountEditing.global.configure": "Настроить права",
		"AccountEditing.global.enable": "Включить глобальные права",
		"AccountEditing.global.hint": "Применяются ко всем проектам пользователя",
		"AccountEditing.global.modalTitle": "Глобальные права пользователя",
		"AccountEditing.global.readOnlyMessage": "Используются глобальные права. Для изменения перейдите в раздел «Глобальные права».",
		"AccountEditing.global.title": "Глобальные права",
		"AccountEditing.label.createdAt": "Дата создания",
		"AccountEditing.label.id": "ID",
		"AccountEditing.label.lastLoginAt": "Дата последней авторизации",
		"AccountEditing.label.neverLoggedIn": "Не авторизовывался",
		"AccountEditing.label.updatedAt": "Дата последних изменений",
		"AccountEditing.loading.data": "Загрузка...",
		"AccountEditing.loading.saving": "Сохранение...",
		"AccountEditing.modal.permissions": "Права на проекте {project}",
		"AccountEditing.modal.permissionsGlobal": "Права на проекте {project} (глобальные)",
		"AccountEditing.status.active": "Активен",
		"AccountEditing.status.blocked": "Заблокирован",
		"AccountEditing.status.closed": "Закрыт",
		"AccountEditing.status.inactive": "Не активен",
		"AccountEditing.status.passwordConfirm": "Пароль учетной записи «{account}» был изменен. Сохранить изменения?",
		"AccountEditing.success.passwordSent": "Новый пароль отправлен на email пользователя",
		"AccountEditing.success.saved": "Изменения аккаунта сохранены",
		"AccountEditing.title.account": "Аккаунт",
		"AccountEditing.title.contacts": "Контактные",
		"AccountEditing.title.merchants": "Мерчанты",
		"AccountSearchList.empty": "Нет привязанных аккаунтов",
		"AccountSearchList.label.email": "Email",
		"AccountSearchList.label.id": "Идентификатор",
		"AccountSearchList.label.name": "Имя",
		"AccountSearchList.noResults": "Ничего не найдено",
		"AccountSearchList.search.placeholder": "Поиск по ID, ФИО, email...",
		"Accounts.button.add": "Добавить",
		"Accounts.modal.addTitle": "Добавить учетную запись",
		"Accounts.title.accountsList": "Учетные записи",
		"Accounts.title.terminalsList": "Терминалы",
		"AccountsFilters.btn.filter": "Фильтровать",
		"AccountsFilters.status.active": "Активен",
		"AccountsFilters.status.blocked": "Заблокирован",
		"AccountsFilters.status.closed": "Закрыт",
		"AccountsFilters.status.inactive": "Не активен",
		"AccountsFilters.title.status": "Статус",
		"AccountsList.empty": "Учетных записей не найдено",
		"AccountsList.status.active": "Активен",
		"AccountsList.status.blocked": "Заблокирован",
		"AccountsList.status.closed": "Закрыт",
		"AccountsList.status.inactive": "Не активен",
		"AccountsList.table.createdAt": "Дата создания",
		"AccountsList.table.email": "Email",
		"AccountsList.table.id": "ID",
		"AccountsList.table.status": "Статус",
		"AccountsList.table.user": "Пользователь",
		"AdminFiltersToggle.label": "Фильтры",
		"AdministrationMenu.list.analytics": "Аналитика",
		"AdministrationMenu.list.finance": "Финансы",
		"AdministrationMenu.list.payments": "Платежи",
		"AdministrationMenu.list.registries": "Реестры",
		"AdministrationMenu.list.reports": "Отчеты",
		"AdministrationMenu.list.settings": "Настройки",
		"AdministrationMenu.list.stats": "Статистика",
		"AdministrationMenu.list.support": "Поддержка",
		"AdministrationMenu.title.accounts": "Настройки",
		"AdministrationMenu.title.accountsList": "Учетные записи",
		"AdministrationMenu.title.adminAudit": "Журнал действий",
		"AdministrationMenu.title.antifraud": "Антифрод",
		"AdministrationMenu.title.payoutHolds": "Остановленные выплаты",
		"AdministrationMenu.title.console": "Админ-панель",
		"AdministrationMenu.title.constructor": "Конструктор",
		"AdministrationMenu.title.crmPayoutRequests": "CRM-заявки",
		"AdministrationMenu.title.crmSbpPayoutRequests": "CRM-заявки СБП",
		"AdministrationMenu.title.deposits": "Депозиты",
		"AdministrationMenu.title.disputes": "Диспуты",
		"AdministrationMenu.title.frod": "Анти-фрод",
		"AdministrationMenu.title.payments": "Платежи",
		"AdministrationMenu.title.projectsList": "Проекты",
		"AdministrationMenu.title.reconciliation": "Сверка",
		"AdministrationMenu.title.registries": "Реестры",
		"AdministrationMenu.title.secretChats": "Секретные чаты",
		"AdministrationMenu.title.settlements": "Расчёты",
		"AdministrationMenu.title.terminalsList": "Терминалы",
		"AdministrationMenu.title.tickets": "Обращения",
		"AdministrationMenu.title.trafficMonitoring": "Мониторинг трафика",
		"AdministrationMenu.title.transactionAudit": "Аудит транзакций",
		"AntiFraud.add": "Добавить",
		"AntiFraud.details.delete": "Удалить",
		"AntiFraud.details.title": "Детали записи",
		"AntiFraud.details.unblock": "Разблокировать",
		"AntiFraud.filter.apply": "Применить",
		"AntiFraud.filter.kind": "Тип данных",
		"AntiFraud.filter.reset": "Сбросить",
		"AntiFraud.filter.source": "Источник",
		"AntiFraud.filter.status": "Статус",
		"AntiFraud.form.expiresAt": "Срок истечения (опционально)",
		"AntiFraud.form.kind": "Тип данных",
		"AntiFraud.form.reason": "Причина блокировки",
		"AntiFraud.form.source": "Источник",
		"AntiFraud.form.submit": "Добавить блокировку",
		"AntiFraud.form.value": "Значение",
		"AntiFraud.list.createdAt": "Создано",
		"AntiFraud.list.empty": "Нет записей",
		"AntiFraud.list.expiresAt": "Истекает",
		"AntiFraud.list.hits": "Попаданий",
		"AntiFraud.list.id": "ID",
		"AntiFraud.list.kind": "Тип",
		"AntiFraud.list.reason": "Причина",
		"AntiFraud.list.source": "Источник",
		"AntiFraud.list.status": "Статус",
		"AntiFraud.list.value": "Значение",
		"AntiFraud.modal.addTitle": "Добавить блокировку",
		"AntiFraud.search.mask": "Поиск по маске",
		"AntiFraud.search.maskPlaceholder": "Введите часть номера карты, IP или телефона...",
		"AntiFraud.stats.title": "Статистика",
		"AntiFraud.status.blocked": "Заблокирован",
		"AntiFraud.status.unblocked": "Разблокирован",
		"AntiFraud.title": "Антифрод записи",
		"AntiFraudDetails.delete": "Удалить",
		"AntiFraudDetails.title": "Детали записи",
		"AntiFraudDetails.unblock": "Разблокировать",
		"AntiFraudFilters.btn.filter": "Фильтровать",
		"AntiFraudFilters.btn.reset": "Сбросить",
		"AntiFraudFilters.status.blocked": "Заблокирован",
		"AntiFraudFilters.status.unblocked": "Разблокирован",
		"AntiFraudFilters.title.kind": "Тип данных",
		"AntiFraudFilters.title.source": "Источник",
		"AntiFraudFilters.title.status": "Статус",
		"AntiFraudForm.error.create": "Ошибка добавления записи",
		"AntiFraudForm.error.kindRequired": "Выберите тип данных",
		"AntiFraudForm.error.valueRequired": "Введите значение",
		"AntiFraudForm.expiresAt": "Срок действия (опционально)",
		"AntiFraudForm.expiresAt.hint": "Оставьте пустым для бессрочной блокировки",
		"AntiFraudForm.hint.card_pan": "Номер карты (16-19 цифр)",
		"AntiFraudForm.hint.inn": "ИНН (10 или 12 цифр)",
		"AntiFraudForm.hint.ip": "IP адрес",
		"AntiFraudForm.hint.name": "ФИО",
		"AntiFraudForm.hint.phone": "Номер телефона в формате 79001234567",
		"AntiFraudForm.hint.sbp_phone": "Телефон СБП в формате 79001234567",
		"AntiFraudForm.kind": "Тип данных",
		"AntiFraudForm.kind.placeholder": "-- Выберите тип --",
		"AntiFraudForm.placeholder.cardPan": "4111111111111111",
		"AntiFraudForm.placeholder.inn": "1234567890",
		"AntiFraudForm.placeholder.ip": "192.168.1.1",
		"AntiFraudForm.placeholder.phone": "79001234567",
		"AntiFraudForm.reason": "Причина блокировки",
		"AntiFraudForm.reason.default": "Ручная блокировка администратором",
		"AntiFraudForm.submit": "Добавить блокировку",
		"AntiFraudForm.value": "Значение",
		"AntiFraudForm.value.placeholder": "Введите значение",
		"AntiFraudList.empty": "Нет записей",
		"AntiFraudList.status.blocked": "Заблокирован",
		"AntiFraudList.status.unblocked": "Разблокирован",
		"AntiFraudList.table.hits": "Попадания",
		"AntiFraudList.table.id": "Идентификатор",
		"AntiFraudList.table.kind": "Тип",
		"AntiFraudList.table.lastSeen": "Последний раз",
		"AntiFraudList.table.reason": "Причина",
		"AntiFraudList.table.source": "Источник",
		"AntiFraudList.table.status": "Статус",
		"AntiFraudList.table.value": "Значение",
		"AuditLogsFilters.button.apply": "Применить",
		"AuditLogsFilters.button.reset": "Сбросить",
		"AuditLogsFilters.label.action": "Действие",
		"AuditLogsFilters.label.admin": "Администратор",
		"AuditLogsFilters.label.entityType": "Тип объекта",
		"AuditLogsFilters.label.periodFrom": "Период с",
		"AuditLogsFilters.label.periodTo": "по",
		"AuditLogsFilters.label.search": "Поиск",
		"AuditLogsFilters.option.all": "Все",
		"AuditLogsFilters.option.allActions": "Все действия",
		"AuditLogsFilters.option.allTypes": "Все типы",
		"AuditLogsFilters.placeholder.search": "По имени пользователя или объекту",
		"BalanceWidget.actualBalance": "Действительный баланс",
		"BalanceWidget.section.payin": "Приём платежей",
		"BalanceWidget.section.payout": "Выплаты",
		"BalanceWidget.settlementLabel.reimbursement": "Возмещение",
		"BalanceWidget.settlementLabel.reserve": "Резервный",
		"BalanceWidget.transactionBalance": "Транзакционный баланс",
		"Confirmation.btn.cabinet": "Перейти в кабинет",
		"Confirmation.btn.login": "Войти в кабинет",
		"Confirmation.btn.retry": "Попробовать ещё раз",
		"Confirmation.text.error": "Возможно, адрес уже подтверждён по этой ссылке или смену почты запросили заново. Проверьте почту в профиле и при необходимости запросите смену ещё раз.",
		"Confirmation.text.failed": "Проверьте подключение к интернету и попробуйте ещё раз. Если ошибка повторится, напишите в поддержку.",
		"Confirmation.text.success": "Новый адрес сохранён в профиле. Письма и уведомления теперь будут приходить на него.",
		"Confirmation.title.error": "Ссылка недействительна",
		"Confirmation.title.failed": "Не удалось подтвердить почту",
		"Confirmation.title.success": "Почта подтверждена",
		"Console.created": "Created",
		"Console.error": "Error",
		"Console.loading": "Загрузка…",
		"Console.pending": "Pending",
		"Console.title": "Админ-панель",
		"Console.transactionsTitle": "Транзакции требующие внимания",
		"ContractsTable.empty": "Нет контрактов",
		"ContractsTable.menu.edit": "Редактирование",
		"ContractsTable.menu.newPSA": "Новый ПСА для контракта",
		"ContractsTable.menu.psaList": "Список ПСА",
		"ContractsTable.table.date": "Дата",
		"ContractsTable.table.name": "Название",
		"ContractsTable.table.project": "Проект",
		"ContractsTable.table.psaCount": "Кол-во ПСА",
		"ContractsTable.table.psaProcessing": "ПСА в обработке",
		"CountryTop.table.country": "Страна",
		"CountryTop.table.declined": "Отклоненные",
		"CountryTop.table.successful": "Успешные",
		"CountryTop.table.transactions": "Транзакции",
		"CountryTop.table.turnover": "Оборот",
		"CrmPayout.action.bulkDecline": "Отклонить выбранные",
		"CrmPayout.action.decline": "Отклонить",
		"CrmPayout.action.formRegistry": "Сформировать реестр",
		"CrmPayout.action.retry": "Retry",
		"CrmPayout.action.selected": "Выбрано: {count}",
		"CrmPayout.detail.title": "Заявка",
		"CrmPayout.empty": "Заявки не найдены",
		"CrmPayout.filters.apply": "Применить",
		"CrmPayout.filters.payoutType": "Тип выплаты",
		"CrmPayout.filters.reset": "Сбросить",
		"CrmPayout.filters.status": "Статус",
		"CrmPayout.filters.title": "Фильтры",
		"CrmPayout.registry.download": "Скачать Excel",
		"CrmPayout.registry.title": "Реестр",
		"CrmPayout.registry.upload": "Загрузить отчёт",
		"CrmPayout.search.cardMask": "маска карты",
		"CrmPayout.search.cardMask.placeholder": "Введите маску карты (напр. 411111)",
		"CrmPayout.search.externalReference": "внешний ID",
		"CrmPayout.search.externalReference.placeholder": "Введите внешний ID",
		"CrmPayout.search.fullName": "ФИО",
		"CrmPayout.search.fullName.placeholder": "Введите ФИО получателя",
		"CrmPayout.search.merchantName": "мерчант",
		"CrmPayout.search.merchantName.placeholder": "Введите название мерчанта",
		"CrmPayout.search.phone": "телефон",
		"CrmPayout.search.phone.placeholder": "Введите номер телефона",
		"CrmPayout.search.transactionId": "ID транзакции",
		"CrmPayout.search.transactionId.placeholder": "Введите ID транзакции",
		"CrmPayout.stats.title": "Статистика",
		"CrmPayout.stats.total": "Всего",
		"CrmPayout.table.amount": "Сумма",
		"CrmPayout.table.card": "Карта/Телефон",
		"CrmPayout.table.date": "Дата",
		"CrmPayout.table.fullName": "ФИО",
		"CrmPayout.table.id": "Идентификатор",
		"CrmPayout.table.merchant": "Мерчант",
		"CrmPayout.table.status": "Статус",
		"CrmPayout.table.type": "Тип",
		"CrmPayout.title": "CRM-заявки на выплаты",
		"CrmSbpPayout.title": "CRM-заявки СБП",
		"CrmPayoutBoard.type.sbp": "СБП",
		"CrmPayoutDetails.action.cancel": "Отмена",
		"CrmPayoutDetails.action.confirm": "Подтвердить",
		"CrmPayoutDetails.action.confirmDecline": "Подтвердить отклонение",
		"CrmPayoutDetails.action.decline": "Отклонить",
		"CrmPayoutDetails.action.moveBack": "Вернуть в ожидание",
		"CrmPayoutDetails.action.moveToSuccess": "Перевести в успех",
		"CrmPayoutDetails.action.sendToAntifraud": "На антифрод",
		"CrmPayoutDetails.antifraud.toggle": "Антифрод",
		"CrmPayoutDetails.decline.placeholder": "Причина отклонения...",
		"CrmPayoutDetails.decline.title": "Причина отклонения",
		"CrmPayoutDetails.declineReasonRequired": "Укажите причину отклонения",
		"CrmPayoutDetails.error.generic": "Ошибка: {msg}",
		"CrmPayoutDetails.error.unknown": "Неизвестная ошибка",
		"CrmPayoutDetails.info.card": "Карта",
		"CrmPayoutDetails.info.createdAt": "Дата создания",
		"CrmPayoutDetails.info.description": "Описание",
		"CrmPayoutDetails.info.documentDate": "Дата документа",
		"CrmPayoutDetails.info.documentNumber": "Номер документа",
		"CrmPayoutDetails.info.email": "Email",
		"CrmPayoutDetails.info.fullName": "ФИО",
		"CrmPayoutDetails.info.merchant": "Мерчант",
		"CrmPayoutDetails.info.phone": "Телефон",
		"CrmPayoutDetails.info.registry": "Реестр",
		"CrmPayoutDetails.info.transaction": "Транзакция",
		"CrmPayoutDetails.info.updatedAt": "Обновлена",
		"CrmPayoutDetails.status.antifraud": "Антифрод",
		"CrmPayoutDetails.status.awaitingPayout": "Ожидает выплаты",
		"CrmPayoutDetails.status.created": "Создана",
		"CrmPayoutDetails.status.error": "Ошибка",
		"CrmPayoutDetails.status.registry": "В реестре",
		"CrmPayoutDetails.status.rejected": "Отклонена",
		"CrmPayoutDetails.status.success": "Успех",
		"CrmPayoutDetails.success.feePlaceholder": "Комиссия (необязательно)",
		"CrmPayoutDetails.success.movedToSuccess": "Заявка переведена в успех",
		"CrmPayoutDetails.success.sentToAntifraud": "Отправлено на антифрод",
		"CrmPayoutDetails.title": "Заявка #{id}",
		"CrmPayoutList.status.antifraud": "Антифрод",
		"CrmPayoutList.status.created": "Создана",
		"CrmPayoutList.status.error": "Ошибка",
		"CrmPayoutList.status.processing": "Обработка",
		"CrmPayoutList.status.registry": "В реестре",
		"CrmPayoutList.status.rejected": "Отклонена",
		"CrmPayoutList.status.success": "Успех",
		"Dashboard.help.payout": "Выплаты: {count}",
		"Dashboard.help.purchase": "Покупки: {count}",
		"Dashboard.help.recurrent": "Рекуррентные: {count}",
		"Dashboard.title.balance": "Баланс",
		"Dashboard.title.balanceOnDate": "Баланс на {date}",
		"Dashboard.title.errors": "Ошибки",
		"Dashboard.title.paymentSystems": "Платежные системы",
		"Dashboard.title.paymentsThisMonth": "Платежи за {month}",
		"Dashboard.title.paymentsToday": "Платежи за сегодня",
		"Dashboard.title.refills": "Пополнения",
		"Dashboard.title.statistics": "Статистика",
		"Dashboard.title.successful": "Успешных",
		"DateRange.days30": "30 дней",
		"DateRange.days7": "7 дней",
		"DateRange.from": "С:",
		"DateRange.halfYear": "полгода",
		"DateRange.month": "месяц",
		"DateRange.placeholder": "Выберите период",
		"DateRange.quickSelect": "Быстрый выбор",
		"DateRange.timeLabel": "Время:",
		"DateRange.title": "Период",
		"DateRange.to": "По:",
		"DateRange.today": "сегодня",
		"DateRange.week": "неделя",
		"DateRange.yesterday": "вчера",
		"DisputeDetails.action.archive": "В архив",
		"DisputeDetails.action.resolved": "Решено",
		"DisputeDetails.action.saveNote": "Сохранить примечание",
		"DisputeDetails.action.toWork": "В работу",
		"DisputeDetails.attachments.file": "Файл",
		"DisputeDetails.attachments.open": "Открыть",
		"DisputeDetails.attachments.photo": "Фото",
		"DisputeDetails.attachments.title": "Вложения ({count})",
		"DisputeDetails.error.check": "Ошибка проверки",
		"DisputeDetails.error.fileLoad": "Ошибка получения файла",
		"DisputeDetails.error.fileOpen": "Не удалось получить файл",
		"DisputeDetails.error.generic": "Ошибка: {message}",
		"DisputeDetails.error.saveNote": "Ошибка сохранения примечания",
		"DisputeDetails.error.unknown": "Неизвестная ошибка",
		"DisputeDetails.error.updateStatus": "Ошибка обновления статуса",
		"DisputeDetails.label.attachment": "Вложение:",
		"DisputeDetails.label.chat": "Чат:",
		"DisputeDetails.label.date": "Дата:",
		"DisputeDetails.label.sender": "Отправитель:",
		"DisputeDetails.linked.checkProvider": "Проверить у провайдера",
		"DisputeDetails.linked.currentStatus": "Текущий статус:",
		"DisputeDetails.linked.lastCheck": "Последняя проверка: {date}",
		"DisputeDetails.linked.merchant": "Мерчант:",
		"DisputeDetails.linked.providerResponse": "Ответ провайдера:",
		"DisputeDetails.linked.statusAtCreation": "Статус при создании:",
		"DisputeDetails.linked.transaction": "Привязанная транзакция:",
		"DisputeDetails.resolution.placeholder": "Примечание...",
		"DisputeDetails.resolution.resolvedBy": "Решено: {name} ({date})",
		"DisputeDetails.section.message": "Сообщение",
		"DisputeDetails.section.resolution": "Решение",
		"DisputeDetails.section.transaction": "Транзакция",
		"DisputeDetails.title": "Диспут",
		"DisputeDetails.transaction.amount": "Сумма:",
		"DisputeDetails.transaction.check": "Проверить",
		"DisputeDetails.transaction.merchant": "Мерчант:",
		"DisputeDetails.transaction.ourStatus": "Наш статус:",
		"DisputeDetails.transaction.placeholder": "ID транзакции",
		"DisputeDetails.transaction.provider": "Провайдер:",
		"DisputeDetails.transaction.providerStatus": "Статус провайдера:",
		"DisputeDetails.value.no": "Нет",
		"DisputeDetails.value.yes": "Да",
		"DisputeFilters.btn.filter": "Фильтровать",
		"DisputeFilters.btn.reset": "Сбросить",
		"DisputeFilters.title.status": "Статус",
		"Disputes.stats.title": "Статистика",
		"Disputes.title": "Диспуты",
		"DisputesList.attachment": "Вложение",
		"DisputesList.empty": "Диспуты не найдены",
		"DisputesList.table.chat": "Чат / Отправитель",
		"DisputesList.table.date": "Дата",
		"DisputesList.table.id": "Идентификатор",
		"DisputesList.table.merchant": "Мерчант",
		"DisputesList.table.message": "Сообщение",
		"DisputesList.table.status": "Статус",
		"DisputesList.table.transaction": "Транзакция",
		"Empty.message.dataSoon": "Данные скоро появятся",
		"EmptyChart.message": "Недостаточно данных для построения графика",
		"EventsWidget.btn.createTicket": "Оставить обращение",
		"EventsWidget.empty.message": "Здесь будут важные уведомления",
		"EventsWidget.title": "События",
		"FieldsHelper.error.charactersEmail": "Адрес электронной почты может содержать только буквы латинского алфавита, цифры и символы «_.@». Например: john_doe@email.ru",
		"FieldsHelper.error.checkAmount": "С суммой что-то не так. Проверьте и попробуйте еще раз. Например: 100.20",
		"FieldsHelper.error.checkBirthPlace": "С местом рождения что-то не так. Проверьте и попробуйте еще раз. Например: Г. ЛЫТКАРИНО",
		"FieldsHelper.error.checkCardNumber": "Вы указали номер неправильно. Проверьте его и попробуйте еще раз",
		"FieldsHelper.error.checkCardholderName": "С именем держателя карты что-то не так. Проверьте и попробуйте еще раз. Например: JOHN DOE",
		"FieldsHelper.error.checkEmail": "С адресом электронной почты что-то не так. Проверьте и попробуйте еще раз. Например: john_doe@email.ru",
		"FieldsHelper.error.checkIpSymbols": "С IP-адресом что-то не так. Проверьте и попробуйте еще раз. Например: 192.168.0.1",
		"FieldsHelper.error.checkIssued": "Вы указали данные неправильно. Проверьте поле и попробуйте еще раз",
		"FieldsHelper.error.checkLatinUsername": "С именем учетной записи что-то не так. Проверьте и попробуйте еще раз. Например: john777",
		"FieldsHelper.error.checkNumbersInn": "С ИНН что-то не так. Проверьте и попробуйте еще раз. Например: 773334101234",
		"FieldsHelper.error.checkOTPCode": "С одноразовым паролем что-то не так. Проверьте и попробуйте еще раз. Например: HS38ET",
		"FieldsHelper.error.checkPhone": "С номером телефона что-то не так. Проверьте и попробуйте еще раз. Например: +79854356633",
		"FieldsHelper.error.checkRegisterName": "С именем реестра что-то не так. Проверьте и попробуйте еще раз. Например: Выплаты за май",
		"FieldsHelper.error.checkUrlWebsite": "С адресом сайта что-то не так. Проверьте и попробуйте еще раз. Например: https://yandex.ru",
		"FieldsHelper.error.docIssuerCode": "Укажите код подразделения",
		"FieldsHelper.error.docNumber": "Укажите номер документа",
		"FieldsHelper.error.docSerial": "Укажите серию документа",
		"FieldsHelper.error.onlyCyrLatinRegisterName": "Название может состоять из букв латинского и кириллического алфавита, цифр и знаков «_().». Например: Выплаты за май",
		"FieldsHelper.error.onlyIpSymbols": "IP адрес может состоять только из цифр и разделяющих их точек. Например: 192.168.0.1",
		"FieldsHelper.error.onlyLatinBirthPlace": "Место рождения может содержать только латинские буквы и символы «.»",
		"FieldsHelper.error.onlyLatinCardholder": "Имя держателя карты может состоять только из букв латинского алфавита. Например: JOHN DOE",
		"FieldsHelper.error.onlyLatinIssued": "Может содержать только латинские буквы и символы «.\"». Например: ОУФМС РОССИИ ПО ГОР. Москве",
		"FieldsHelper.error.onlyLatinUsername": "Имя учетной записи может содержать только латинские буквы и цифры. Например: john777",
		"FieldsHelper.error.onlyLettersAddress": "Адрес рождения может содержать только латинские буквы, цифры и символы «.,/»",
		"FieldsHelper.error.onlyLettersFirstName": "Имя начинается с заглавной буквы и состоит из русского или латинского алфавита. Например: Игорь",
		"FieldsHelper.error.onlyLettersLastName": "Фамилия начинается с заглавной буквы и состоит из русского или латинского алфавита. Например: Курчатов",
		"FieldsHelper.error.onlyLettersMetalType": "Вид металла должен состоять только из букв",
		"FieldsHelper.error.onlyLettersNumbersOTPCode": "Одноразовый пароль может содержать только латинские буквы и цифры. Например: HS38ET",
		"FieldsHelper.error.onlyLettersPatronymic": "Отчество начинается с заглавной буквы и состоит из русского или латинского алфавита. Например: Васильевич",
		"FieldsHelper.error.onlyLettersProjectName": "Имя проекта может содержать только латинские буквы, цифры и символы «.\"». Например: Яндекс",
		"FieldsHelper.error.onlyNumbersAmount": "Сумма содержит только цифры и знак «.». Например: 100.20",
		"FieldsHelper.error.onlyNumbersInn": "ИНН может содержать только цифры. Например: 773334101234",
		"FieldsHelper.error.onlyNumbersMetalImpurity": "Засоренность может состоять только из цифр",
		"FieldsHelper.error.onlyNumbersMetalPrice": "Цена может состоять только из цифр",
		"FieldsHelper.error.onlyNumbersMetalWeight": "Вес может состоять только из цифр",
		"FieldsHelper.error.onlyNumbersPhone": "Телефон содержит только цифры и знак «+». Например: +79854356633.",
		"FieldsHelper.error.onlyUrlWebsite": "Адрес сайта может содержать только латинские буквы, цифры и символы «/.:». Например: https://yandex.ru",
		"FieldsHelper.label.ContractName": "Название контракта",
		"FieldsHelper.label.IPAccessRestriction": "Ограничение доступа по IP",
		"FieldsHelper.label.Issued": "Кем выдан",
		"FieldsHelper.label.PcaName": "Название ПСА",
		"FieldsHelper.label.PcaTypeMetal": "Вид металла",
		"FieldsHelper.label.amount": "Сумма",
		"FieldsHelper.label.authentication": "Двухфакторная аутентификация",
		"FieldsHelper.label.authenticationSelect": "Выберите тип",
		"FieldsHelper.label.birthCountry": "Страна рождения",
		"FieldsHelper.label.birthPlace": "Место рождения",
		"FieldsHelper.label.cardholder": "Держатель карты",
		"FieldsHelper.label.codeWord": "Кодовое слово",
		"FieldsHelper.label.contract": "Контракт",
		"FieldsHelper.label.contractBtn": "Создать",
		"FieldsHelper.label.contractBtnCreatePdf": "Скачать согласие на ОПД",
		"FieldsHelper.label.contractCreate": "Новый контракт",
		"FieldsHelper.label.contractDelete": "Удалить контракт",
		"FieldsHelper.label.contractEdit": "Редактирование контракта",
		"FieldsHelper.label.contractSave": "Сохранить",
		"FieldsHelper.label.contractsList": "Список всех контрактов",
		"FieldsHelper.label.departmentCode": "Код подразделения",
		"FieldsHelper.label.description": "Описание",
		"FieldsHelper.label.docNumber": "Номер документа",
		"FieldsHelper.label.docSerial": "Серия документа",
		"FieldsHelper.label.email": "Электронная почта",
		"FieldsHelper.label.firstName": "Имя",
		"FieldsHelper.label.gender": "Пол",
		"FieldsHelper.label.inn": "ИНН",
		"FieldsHelper.label.kpp": "КПП",
		"FieldsHelper.label.lastName": "Фамилия",
		"FieldsHelper.label.legalAddress": "Адрес регистрации",
		"FieldsHelper.label.legalName": "Название юрлица",
		"FieldsHelper.label.metalGrossWeight": "Вес брутто (тн)",
		"FieldsHelper.label.metalImpurity": "Засоренность (%)",
		"FieldsHelper.label.metalPrice": "Цена (руб)",
		"FieldsHelper.label.metalTareWeight": "Вес тары (тн)",
		"FieldsHelper.label.metalType": "Вид",
		"FieldsHelper.label.metalWeight": "Вес (тн)",
		"FieldsHelper.label.ogrn": "ОГРН",
		"FieldsHelper.label.otpCode": "Код",
		"FieldsHelper.label.password": "Пароль",
		"FieldsHelper.label.patronymic": "Отчество",
		"FieldsHelper.label.pca": "ПСА",
		"FieldsHelper.label.pcaBtn": "Сохранить и оплатить",
		"FieldsHelper.label.pcaBtnEdit": "Сохранить изменения",
		"FieldsHelper.label.pcaComment": "Комментарий для ПСА",
		"FieldsHelper.label.pcaCreate": "Новый ПСА",
		"FieldsHelper.label.pcaDelete": "Удаление ПСА",
		"FieldsHelper.label.pcaDescription": "Описание позиций",
		"FieldsHelper.label.pcaDescriptionMetal": "Описание лома и отходов",
		"FieldsHelper.label.pcaDownload": "Скачать в формате .xlsx",
		"FieldsHelper.label.pcaEdit": "ПСА",
		"FieldsHelper.label.pcaList": "Список всех ПСА",
		"FieldsHelper.label.pcaSourceMetal": "Источник лома",
		"FieldsHelper.label.pcaTransportMetal": "Марка и номер ТС",
		"FieldsHelper.label.phone": "Телефон",
		"FieldsHelper.label.processing": "Процессинг",
		"FieldsHelper.label.project": "Проект",
		"FieldsHelper.label.projectName": "Название",
		"FieldsHelper.label.projects": "Проекты",
		"FieldsHelper.label.registryName": "Название",
		"FieldsHelper.label.residenceAddress": "Адрес фактического проживания",
		"FieldsHelper.label.selectProcessing": "Выберите процессинг",
		"FieldsHelper.label.selectProject": "Выберите проект",
		"FieldsHelper.label.selectTerminal": "Выберите терминал",
		"FieldsHelper.label.terminal": "Терминал",
		"FieldsHelper.label.username": "Название",
		"FieldsHelper.label.websiteUrl": "Адрес сайта",
		"FieldsHelper.password.generate": "Сгенерировать пароль",
		"FieldsHelper.placeholder.birthCountry": "Выберите страну",
		"FieldsHelper.placeholder.gender": "Выберите пол",
		"HeaderMenu.list.account": "Мой профиль",
		"HeaderMenu.list.admin": "Админ панель",
		"HeaderMenu.list.adminPanel": "Админ-панель",
		"HeaderMenu.list.apiconsole": "Api консоль",
		"HeaderMenu.list.clientHome": "На главную",
		"HeaderMenu.list.closeMenu": "Закрыть меню",
		"HeaderMenu.list.logout": "Выход",
		"HeaderMenu.list.openMenu": "Открыть меню",
		"HeaderMenu.list.profile": "Профиль",
		"HeaderMenu.list.secretChats": "Чаты",
		"HeaderMenu.list.support": "Поддержка",
		"LanguageSelect.language.en": "English",
		"LanguageSelect.language.ru": "Русский",
		"LoginForm.btn.continue": "Продолжить",
		"LoginForm.btn.login": "Войти",
		"LoginForm.btn.sendAgain": "Выслать еще раз",
		"LoginForm.error.codeInvalid": "Код подтверждения неверный.",
		"LoginForm.error.codeRequired": "Код подтверждения обязателен.",
		"LoginForm.error.credentials": "E-mail или пароль неверны.",
		"LoginForm.error.blocked": "Учётная запись заблокирована. Обратитесь в поддержку.",
		"LoginForm.error.empty": "Поле E-mail и пароль обязательные.",
		"LoginForm.label.remember": "Запомнить меня",
		"LoginForm.link.cantLogin": "Не можете войти?",
		"LoginForm.link.forgotPassword": "Забыли пароль?",
		"LoginForm.logo.alt": "Логотип",
		"LoginForm.modal.cantLogin.alt.clearSiteData": "Очистка данных сайта",
		"LoginForm.modal.cantLogin.step.clearCache": "Очистите кеш страницы (Ctrl + F5)",
		"LoginForm.modal.cantLogin.step.clearSiteData": "Очистите данные сайта в браузере",
		"LoginForm.modal.cantLogin.step.contactSupport": "Обратитесь в поддержку:",
		"LoginForm.modal.cantLogin.title": "Не удаётся войти?",
		"LoginForm.modal.close": "Закрыть модальное окно",
		"LoginForm.modal.forgotPassword.btn.sendCode": "Отправить код",
		"LoginForm.modal.forgotPassword.btn.verifyCode": "Подтвердить код",
		"LoginForm.modal.forgotPassword.placeholder.code": "Код из письма",
		"LoginForm.modal.forgotPassword.placeholder.email": "Email",
		"LoginForm.modal.forgotPassword.title": "Сброс пароля",
		"LoginForm.placeholder.code": "Код",
		"LoginForm.placeholder.email": "Имя учетной записи",
		"LoginForm.placeholder.password": "Пароль",
		"LoginForm.recovery.error.codeRequired": "Введите код",
		"LoginForm.recovery.error.emailRequired": "Введите email",
		"LoginForm.recovery.error.invalidCode": "Неверный код",
		"LoginForm.recovery.error.sendCode": "Ошибка отправки кода",
		"LoginForm.recovery.error.verifyCode": "Ошибка проверки кода",
		"LoginForm.recovery.success.codeSent": "Если аккаунт существует, код отправлен на почту",
		"LoginForm.recovery.success.passwordSent": "Новый пароль отправлен на почту",
		"LoginForm.text.codeExpired": "Срок действия кода подтверждения истек.",
		"LoginForm.text.codeValid": "Код действителен еще {seconds} секунд",
		"LoginForm.text.mfaEmailMessage": "Введите код подтверждения из {type}-сообщения, отправленного на {email}",
		"LoginForm.text.mfaGAuthMessage": "Введите код подтверждения из приложения Google Authenticator",
		"LoginForm.text.mfaPhoneMessage": "Введите код подтверждения из {type}-сообщения, отправленного на номер {phone}",
		"LoginForm.title.login": "Вход в личный кабинет",
		"Merchant.select": "Выберите мерчант",
		"Merchant.title": "Мерчант",
		"MobileRegistry.table.amount": "Сумма",
		"MobileRegistry.table.bic": "БИК / ID банка",
		"MobileRegistry.table.cardHolderRu": "ФИО",
		"MobileRegistry.table.documentDate": "Дата док.",
		"MobileRegistry.table.documentNumber": "Номер док.",
		"MobileRegistry.table.phone": "Телефон",
		"MobileRegistry.upload.hint": "Перетащите реестр (телефон/СБП) в эту область или воспользуйтесь {link}",
		"Modal.cancel": "Отмена",
		"Modal.confirm": "Подтвердить",
		"Pay.error.checkBic": "Введите корректный БИК (7-9 цифр)",
		"Pay.error.checkBicOrMemberId": "Введите БИК (7-9 цифр) или ID банка СБП",
		"Pay.error.checkFio": "Введите ФИО получателя",
		"Pay.error.checkPhoneFormat": "Введите корректный номер телефона (10-15 цифр)",
		"Pay.error.documentDateFormat": "Введите дату в формате ГГГГ-ММ-ДД",
		"Pay.error.documentNumberRequired": "Введите номер ПСА",
		"Pay.error.onlyNumbersBic": "Только цифры",
		"Pay.label.amount": "Сумма платежа",
		"Pay.label.bankMemberId": "Банк получателя (СБП)",
		"Pay.label.bic": "БИК банка получателя",
		"Pay.label.bicOrMemberId": "БИК или ID банка (СБП)",
		"Pay.label.documentDate": "Дата ПСА",
		"Pay.label.documentNumber": "Номер ПСА",
		"Pay.label.finstarData": "Данные ПСА",
		"Pay.label.mobileRecipient": "Получатель (СБП)",
		"Pay.label.receiverCheck": "Получатель чека",
		"Pay.label.recipientFio": "ФИО (Фамилия Имя Отчество)",
		"Pay.label.recipientName": "ФИО получателя",
		"Pay.label.recipientPhone": "Номер телефона получателя",
		"Pay.label.transferRecipient": "Получатель перевода",
		"Pay.title.oneTimePayment": "Единовременный платеж",
		"Pay.toggle.card": "На карту",
		"Pay.toggle.mobile": "По телефону (СБП)",
		"PayControls.btn.send": "Отправить",
		"PayControls.label.amount": "Сумма:",
		"PayControls.label.balance": "Баланс:",
		"PayControls.label.card": "Перевод на карту:",
		"PayControls.label.commission": "Коммиссия:",
		"PayControls.label.email": "Email:",
		"PayControls.label.holder": "Держатель карты:",
		"PayControls.label.phone": "Телефон:",
		"PayControls.title": "Данные выплаты",
		"Payouts.title": "Проекты",
		"PayoutsDetail.btn.retryFailed": "Повторить неуспешные",
		"PayoutsDetail.modal.amount": "Сумма",
		"PayoutsDetail.modal.card": "Карта",
		"PayoutsDetail.modal.moreItems": "... и ещё {count}",
		"PayoutsDetail.modal.pendingListTitle": "Совпадающие транзакции в обработке:",
		"PayoutsDetail.modal.pendingWarning": "В обработке уже находятся карты из загруженного реестра. Возможно дублирование выплат.",
		"PayoutsDetail.modal.recipient": "Получатель",
		"PayoutsDetail.modal.warningTitle": "Внимание",
		"PayoutsDetailAmounts.label.failed": "Сумма невыплаченных:",
		"PayoutsDetailAmounts.label.other": "Сумма отложенных:",
		"PayoutsDetailAmounts.label.success": "Сумма выплаченных:",
		"PayoutsDetailEditing.btn.save": "Сохранить",
		"PayoutsDetailEditing.error.emptyName": "Название реестра не может быть пустым.",
		"PayoutsDetailEditing.error.generic": "Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова.",
		"PayoutsDetailEditing.error.network": "Упс! Что-то пошло не так. Обновите страницу и попробуйте снова.",
		"PayoutsDetailEditing.label.tags": "Метки",
		"PayoutsDetailEditing.placeholder.name": "Название не может быть пустым",
		"PayoutsDetailEditing.success.saved": "Успех! Данные сохранены.",
		"PayoutsDetailEditing.title": "Редактирование реестра",
		"PayoutsDetailFilters.btn.setFilters": "Фильтровать",
		"PayoutsDetailFilters.status.delayed": "Отложен",
		"PayoutsDetailFilters.status.error": "Ошибка",
		"PayoutsDetailFilters.status.filtered": "Отфильтрован",
		"PayoutsDetailFilters.status.paid": "Оплачен",
		"PayoutsDetailFilters.title.status": "Статус",
		"PayoutsDetailTags.noSuggestions": "Меток не найдено",
		"PayoutsDetailTags.placeholder": "Добавить метку",
		"PayoutsFilters.btn.filter": "Фильтровать",
		"PayoutsFilters.status.created": "Создан",
		"PayoutsFilters.status.delayed": "Отложен",
		"PayoutsFilters.status.inProgress": "Обрабатывается",
		"PayoutsFilters.status.processed": "Выполнен",
		"PayoutsFilters.status.processedWithErrors": "Выполнен с ошибками",
		"PayoutsFilters.title.status": "Статус",
		"PayoutsFilters.title.tags": "Метки",
		"PayoutsTable.empty": "Нет данных удовлетворяющих фильтрам",
		"PayoutsTable.status.created": "Отложен",
		"PayoutsTable.status.filtered": "Отфильтрован",
		"PayoutsTable.status.payout": "Оплачен",
		"PayoutsTable.status.payoutDecline": "Ошибка",
		"PayoutsTable.tab.bank": "Банк карты:",
		"PayoutsTable.tab.country": "Страна карты:",
		"PayoutsTable.tab.created": "Создан:",
		"PayoutsTable.tab.extStatus": "Расширенный статус:",
		"PayoutsTable.tab.fee": "Комиссия:",
		"PayoutsTable.tab.id": "ID операции:",
		"PayoutsTable.tab.params": "Параметры выплаты",
		"PayoutsTable.tab.processed": "Выполнен:",
		"PayoutsTable.tab.reason": "Причина ошибки:",
		"PayoutsTable.tab.system": "Платежная система:",
		"PayoutsTable.table.amount": "Сумма",
		"PayoutsTable.table.pan": "PAN",
		"PayoutsTable.table.phone": "Телефон",
		"PayoutsTable.table.recipient": "Получатель",
		"PayoutsTable.table.status": "Статус",
		"PcaFilters.status.error": "Ошибка / Платеж отклонен",
		"PcaFilters.status.inProgress": "Обрабатывается",
		"PcaFilters.status.inactive": "Не активен",
		"PcaFilters.status.processed": "Выплачен",
		"PcaFilters.title.status": "Статус",
		"PcaTable.empty": "Нет ПСА",
		"PcaTable.menu.duplicate": "Дублировать ПСА",
		"PcaTable.menu.view": "Просмотр ПСА",
		"PcaTable.status.declined": "Платеж отклонен",
		"PcaTable.status.error": "Ошибка",
		"PcaTable.status.inProgress": "Обрабатывается",
		"PcaTable.status.inactive": "Не активен",
		"PcaTable.status.paid": "Выплачено",
		"PcaTable.table.amount": "Сумма",
		"PcaTable.table.contract": "Контракт",
		"PcaTable.table.date": "Дата ПСА",
		"PcaTable.table.id": "ID",
		"PcaTable.table.name": "Название ПСА",
		"PcaTable.table.provider": "Провайдер",
		"PcaTable.table.status": "Статус",
		"PersonalManager.description": "По всем вопросам работы сервиса вы можете обращаться к вашему персональному менеджеру:",
		"PersonalManager.phone.mobile": "Мобильный",
		"PersonalManager.phone.work": "Рабочий",
		"PersonalManager.title": "Персональный менеджер",
		"Prepaid.title": "Предоплаченные карты",
		"Prepaid.title.activate": "Активация карты",
		"Prepaid.title.details": "Детализация карты",
		"PrepaidDetails.button.activate": "Активировать",
		"PrepaidDetails.gender.female": "Женский",
		"PrepaidDetails.gender.male": "Мужской",
		"PrepaidDetails.label.birthCountry": "Страна рождения:",
		"PrepaidDetails.label.birthPlace": "Место рождения:",
		"PrepaidDetails.label.birthday": "Дата рождения:",
		"PrepaidDetails.label.docIssuedDate": "Дата выдачи:",
		"PrepaidDetails.label.docIssuer": "Кем выдан:",
		"PrepaidDetails.label.docIssuerCode": "Код подразделения:",
		"PrepaidDetails.label.docNumber": "Номер документа:",
		"PrepaidDetails.label.docSerial": "Серия документа:",
		"PrepaidDetails.label.firstName": "Имя:",
		"PrepaidDetails.label.gender": "Пол:",
		"PrepaidDetails.label.lastName": "Фамилия:",
		"PrepaidDetails.label.legalAddress": "Адрес регистрации:",
		"PrepaidDetails.label.patronymic": "Отчество:",
		"PrepaidDetails.label.phone": "Телефон:",
		"PrepaidDetails.label.residenceAddress": "Адрес фактического проживания:",
		"PrepaidDetails.subtitle.ean": "EAN: {ean} ({part})",
		"PrepaidDetails.tab.contacts": "Контактная информация",
		"PrepaidDetails.tab.passport": "Паспортные данные",
		"PrepaidDetails.tab.personal": "Личные данные",
		"PrepaidTable.empty": "Нет предоплаченных карт",
		"PrepaidTable.menu.activate": "Активация",
		"PrepaidTable.menu.details": "Детализация",
		"PrepaidTable.status.active": "Активна",
		"PrepaidTable.status.error": "Ошибка",
		"PrepaidTable.status.inactive": "Не активна",
		"PrepaidTable.status.processing": "Обрабатывается",
		"PrepaidTable.table.card": "Карта",
		"PrepaidTable.table.client": "Клиент",
		"PrepaidTable.table.ean": "EAN",
		"PrepaidTable.table.project": "Проект",
		"PrepaidTable.table.status": "Статус",
		"Profile.btn.activate": "Активировать",
		"Profile.btn.connectOTP": "Подключить",
		"Profile.btn.save": "Сохранить изменения",
		"Profile.button.changePassword": "Изменить пароль",
		"Profile.button.save": "Сохранить изменения",
		"Profile.error.emailConfirmationNotSent": "Не удалось отправить письмо на {email}. Почта пока прежняя — попробуйте сменить её позже или напишите в поддержку.",
		"Profile.error.save": "Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова.",
		"Profile.label.email": "Email",
		"Profile.label.firstName": "Имя",
		"Profile.label.lastName": "Фамилия",
		"Profile.label.password": "Пароль",
		"Profile.label.patronymic": "Отчество",
		"Profile.link.cancel": "Отменить изменения",
		"Profile.modal.title": "Изменение данных",
		"Profile.section.password": "Смена пароля",
		"Profile.section.personal": "Личные данные",
		"Profile.success.emailConfirmationPending": "Мы отправили письмо на {email}. Адрес сменится после перехода по ссылке из письма.",
		"Profile.success.save": "Успех. Вы успешно сохранили форму.",
		"Profile.text.changeEmail": "Почтовый адрес учетной записи был изменен. После подтверждения на адрес {email} будет выслано письмо с дальнейшими инструкциями.",
		"Profile.text.changeIpAccessList": "Список разрешенных IP-адресов был изменен. После подтверждения личный кабинет будет доступен только с адресов: {ipAccessList}.",
		"Profile.text.changeIpAccessListClean": "Список разрешенных IP-адресов был изменен. После подтверждения личный кабинет будет доступен со всех адресов без ограничений.",
		"Profile.text.changeOTPEmail": "Для подтверждения операции необходимо ввести одноразовый пароль отправленный на email-адрес {email}. Если письмо отсутствует в папке \"Входящие\", проверьте папку \"Спам\".",
		"Profile.text.changeOTPGAuth": "Для подтверждения операции необходимо ввести одноразовый пароль сгенерированный в приложении Google Authenticator.",
		"Profile.text.changeOTPPhone": "Для подтверждения операции необходимо ввести одноразовый пароль отправленный в SMS-сообщении на номер {phone}.",
		"Profile.text.changePassword": "Пароль учетной записи был изменен. После подтверждения Вы будете разлогинены на всех устройствах. Перед подтверждением запишите и сохраните в надежном месте новый пароль: {password}",
		"Profile.text.logout": "После смены пароля произойдёт выход из аккаунта на всех устройствах.",
		"Profile.text.support": "Для смены ФИО обратитесь в техническую поддержку.",
		"Profile.title.myProfile": "Мой профиль",
		"Profile.warning.requires2FASetup": "Для продолжения работы необходимо настроить двухфакторную аутентификацию",
		"ProjectAdd.btn.add": "Добавить проект",
		"ProjectAdd.btn.saving": "Сохраняем...",
		"ProjectAdd.error.create": "Ошибка создания проекта. {errors}",
		"ProjectAdd.success.created": "Проект создан",
		"ProjectEditing.antifraud.title": "Антифрод",
		"ProjectEditing.button.deleteService": "Удалить сервис",
		"ProjectEditing.button.refresh": "Обновить из API",
		"ProjectEditing.button.reset": "Сбросить изменения",
		"ProjectEditing.button.save": "Сохранить",
		"ProjectEditing.empty": "Проект не выбран",
		"ProjectEditing.error.load": "Не удалось загрузить полные данные мерчанта",
		"ProjectEditing.error.refresh": "Не удалось обновить данные",
		"ProjectEditing.error.save": "Не удалось сохранить изменения",
		"ProjectEditing.fees.fixed": "Фикс",
		"ProjectEditing.fees.percent": "%",
		"ProjectEditing.fees.type": "Тип",
		"ProjectEditing.field.auth": "Данные авторизации",
		"ProjectEditing.field.description": "Описание",
		"ProjectEditing.field.fees": "Комиссии",
		"ProjectEditing.field.inn": "ИНН",
		"ProjectEditing.field.kpp": "КПП",
		"ProjectEditing.field.login": "Логин",
		"ProjectEditing.field.name": "Название",
		"ProjectEditing.field.ogrn": "ОГРН",
		"ProjectEditing.field.provider": "Провайдер",
		"ProjectEditing.field.secret": "Secret / API Key",
		"ProjectEditing.field.url": "Сайт",
		"ProjectEditing.loading": "Загрузка...",
		"ProjectEditing.merchantKey.hint": "Этот ключ мерчант использует для подписи/аутентификации запросов.",
		"ProjectEditing.merchantKey.title": "Ключ мерчанта",
		"ProjectEditing.mid.balance": "Баланс:",
		"ProjectEditing.mid.currency": "Валюта:",
		"ProjectEditing.mid.currencyBalance": "Валюта и баланс:",
		"ProjectEditing.mid.currentProvider": "Текущий провайдер:",
		"ProjectEditing.mid.delete": "Удалить",
		"ProjectEditing.mid.fee.add": "Добавить комиссию",
		"ProjectEditing.mid.fee.fixed": "Фикс.:",
		"ProjectEditing.mid.fee.minFixed": "Мин. фикс.:",
		"ProjectEditing.mid.fee.payment": "Платёж",
		"ProjectEditing.mid.fee.payout": "Выплата",
		"ProjectEditing.mid.fee.percent": "%:",
		"ProjectEditing.mid.fees": "Комиссии:",
		"ProjectEditing.mid.methods": "Доступные методы:",
		"ProjectEditing.mid.new": "новый",
		"ProjectEditing.mid.openTerminal": "Открыть настройки терминала",
		"ProjectEditing.mid.provider": "Провайдер:",
		"ProjectEditing.mid.terminalNotLinked": "Терминал не привязан",
		"ProjectEditing.mid.title": "МИД #{id}",
		"ProjectEditing.mid.widget": "Настройки виджета:",
		"ProjectEditing.modal.terminalSettings": "Настройки терминала",
		"ProjectEditing.modal.userPermissions": "Права пользователя {username}",
		"ProjectEditing.noData": "Нет данных",
		"ProjectEditing.section.services": "Сервисы (MID)",
		"ProjectEditing.settings.add": "+ Добавить настройку (MID)",
		"ProjectEditing.settings.empty": "Настройки не найдены",
		"ProjectEditing.settings.refresh": "Обновить из API",
		"ProjectEditing.settings.title": "Настройки мерчанта (MID)",
		"ProjectEditing.success.allSaved": "Все изменения сохранены",
		"ProjectEditing.title": "Проект",
		"ProjectEditing.users.title": "Пользователи проекта",
		"ProjectEditing.widget.callback": "Адрес колбека",
		"ProjectEditing.widget.callbackHint": "Адрес для отправки колбеков от виджета",
		"ProjectEditing.widget.generate": "Сгенерировать",
		"ProjectEditing.widget.key": "Ключ виджета",
		"ProjectEditing.widget.keyHint": "Ключ для авторизации виджета",
		"ProjectSearchList.empty": "Ничего не найдено",
		"ProjectSearchList.permissions.btn": "Права",
		"ProjectSearchList.permissions.title": "Настроить права",
		"ProjectSearchList.placeholder": "Поиск проекта по названию или UUID...",
		"ProjectSearchList.remove.aria": "Удалить {name}",
		"ProjectSearchList.selected.title": "Выбранные проекты",
		"ProjectSettings.button.save": "Сохранить",
		"ProjectSettings.checkbox.hideCardholder": "Не показывать поле \"Имя и фамилия держателя карты\"",
		"ProjectSettings.checkbox.hideReceipt": "Не показывать поле \"Получить квитанцию\"",
		"ProjectSettings.checkbox.uniqueCheck": "Включить проверку уникальности значения",
		"ProjectSettings.general.description": "Описание проекта",
		"ProjectSettings.general.id": "ID проекта",
		"ProjectSettings.general.info.title": "Общая информация",
		"ProjectSettings.general.inn": "ИНН",
		"ProjectSettings.general.name": "Название проекта",
		"ProjectSettings.general.site": "Сайт",
		"ProjectSettings.general.technical": "Технические",
		"ProjectSettings.info.type": "Расчётная организация",
		"ProjectSettings.paymentForm.title": "Настройки платежной формы",
		"ProjectSettings.status.active": "Активен",
		"ProjectSettings.status.blocked": "Заблокирован",
		"ProjectSettings.tab.general": "Общие настройки",
		"ProjectSettings.tab.paymentForm": "Платежная форма",
		"ProjectSettings.tab.terminals": "Терминалы",
		"ProjectSettings.terminals.title": "Список терминалов",
		"Projects.button.add": "Добавить",
		"Projects.modal.addTitle": "Добавить новый проект",
		"ProjectsControl.title.projects": "Проекты",
		"ProjectsFilters.btn.filter": "Фильтровать",
		"ProjectsFilters.status.active": "Активен",
		"ProjectsFilters.status.blocked": "Заблокирован",
		"ProjectsFilters.status.inactive": "Не активен",
		"ProjectsFilters.title.status": "Статус",
		"ProjectsList.empty": "Учетных записей не найдено",
		"ProjectsList.table.accounts": "Учетные записи",
		"ProjectsList.table.createdAt": "Дата создания",
		"ProjectsList.table.name": "Название",
		"ProjectsList.table.status": "Статус",
		"ProjectsList.table.website": "Сайт",
		"ProjectsTable.link.payouts": "Выплаты",
		"ProjectsTable.link.settings": "Настройки",
		"ProjectsTable.status.active": "Активен",
		"ProjectsTable.status.blocked": "Заблокирован",
		"ProjectsTable.table.actualBalance": "Действительный",
		"ProjectsTable.table.balance": "Баланс",
		"ProjectsTable.table.project": "Проект",
		"ProjectsTable.table.reservedBalance": "Резервный",
		"ProjectsTable.table.settlementBalance": "Возмещение",
		"ProjectsTable.table.site": "Сайт",
		"ProjectsTable.table.status": "Статус",
		"ProjectsTable.table.transactionBalance": "Транзакционный",
		"ProjectsWidget.empty.title": "Нет активных проектов",
		"ProjectsWidget.error.load": "Не удалось загрузить проекты",
		"ProjectsWidget.help.avgBill": "Средний чек",
		"ProjectsWidget.link.viewAll": "Посмотреть все",
		"ProjectsWidget.table.balance": "Баланс",
		"ProjectsWidget.table.payments": "Платежи",
		"ProjectsWidget.table.payouts": "Выплаты",
		"ProjectsWidget.table.project": "Проект",
		"ProjectsWidget.table.settings": "Настройки",
		"ProjectsWidget.table.website": "Сайт",
		"ProjectsWidget.title": "Проекты",
		"RefillsFilters.btn.setFilters": "Применить фильтры",
		"RefillsFilters.status.crediting": "Пополнение",
		"RefillsFilters.status.writeOff": "Списание",
		"RefillsFilters.title.status": "Статус",
		"RefillsTable.empty": "Операций нет",
		"RefillsTable.table.amount": "Сумма",
		"RefillsTable.table.date": "Дата",
		"RefillsTable.table.project": "Проект",
		"RefillsTable.type.crediting": "Зачисление",
		"RefillsTable.type.writeOff": "Списание",
		"RegistryControls.btn.clear": "Очистить",
		"RegistryControls.checkbox.showErrors": "Показать ошибки",
		"RegistryControls.tags.label": "Добавить метки",
		"RegistryControls.tags.placeholder": "Добавить метки к реестру",
		"RegistryControls.title": "Управление реестром",
		"RegistryDADUpload.error.format": "(code: {code}) Ошибка! Реестр не соответствует формату. Устраните ошибки и повторите попытку.",
		"RegistryDADUpload.error.network": "Ошибка загрузки. Попробуйте снова.",
		"RegistryDADUpload.hint": "Перетащите реестр в эту область или нажмите для выбора",
		"RegistryDADUpload.link": "ссылкой",
		"RegistryDADUpload.loading": "Обработка...",
		"RegistryList.confirm.reprocess": "Обработать повторно реестр \"{name}\"?",
		"RegistryList.empty": "Реестров не найдено",
		"RegistryList.menu.downloadRegistry": "Выгрузить реестр",
		"RegistryList.menu.report": "Выгрузить отчет",
		"RegistryList.menu.reprocess": "Обработать повторно",
		"RegistryList.menu.view": "Детальный просмотр",
		"RegistryList.status.created": "Создан",
		"RegistryList.status.delayed": "Ожидание",
		"RegistryList.status.inProcessing": "Обрабатывается",
		"RegistryList.status.processed": "Выполнен",
		"RegistryList.status.processedWithErrors": "Выполнен с ошибками",
		"RegistryList.status.reprocess": "Повторная обработка",
		"RegistryList.table.amount": "Сумма",
		"RegistryList.table.date": "Дата",
		"RegistryList.table.fee": "Комиссия",
		"RegistryList.table.id": "ID",
		"RegistryList.table.merchant": "Мерчант",
		"RegistryList.table.status": "Статус",
		"RegistryList.table.tags": "Метки",
		"RegistryUpload.btn.sendRegistry": "Отправить реестр",
		"RegistryUpload.error.field": "Поле",
		"RegistryUpload.error.message": "Сообщение",
		"RegistryUpload.error.value": "Значение",
		"RegistryUpload.match.data": "Данные",
		"RegistryUpload.match.name": "Название",
		"RegistryUpload.modal.duplicateConfirm": "Вы уверены, что хотите продолжить?",
		"RegistryUpload.modal.duplicateTitle": "Обнаружен возможный дубликат",
		"RegistryUpload.modal.duplicateWarning": "При загрузке файла были обнаружены похожие реестры за последние 30 дней:",
		"RegistryUpload.table.amount": "Сумма",
		"RegistryUpload.table.cardHolderRu": "Имя держателя карты",
		"RegistryUpload.table.creditCard": "Номер карты",
		"RegistryUpload.table.phoneNumber": "Телефон",
		"RegistryUploadInfo.errors.format": "Ошибка формата файла",
		"RegistryUploadInfo.errors.missingColumn": "Необходимо добавить столбец: {column}",
		"RegistryUploadInfo.table.amount": "Сумма:",
		"RegistryUploadInfo.table.balance": "Баланс:",
		"RegistryUploadInfo.table.errors": "Ошибок:",
		"RegistryUploadInfo.table.fee": "Комиссия:",
		"RegistryUploadInfo.table.registry": "Реестр:",
		"ReportConstructor.btn.createReport": "Создать отчетов",
		"ReportConstructor.label.format": "Формат",
		"ReportConstructor.label.merchant": "Мерчант",
		"ReportConstructor.label.minFee": "Минимальная комиссия",
		"ReportConstructor.label.period": "Период",
		"ReportConstructor.label.providerFee": "Комиссия провайдера",
		"ReportConstructor.label.reportConstructor": "Конструктор отчетов",
		"ReportConstructor.label.reportType": "Тип отчёта",
		"ReportConstructor.label.selectMerchant": "Выберите мерчанта",
		"ReportConstructor.msg.error": "Ошибка при создании отчёта",
		"ReportConstructor.msg.noData": "Нет данных для отчёта",
		"ReportConstructor.msg.selectMerchant": "Выберите мерчанта",
		"ReportConstructor.msg.selectPeriod": "Выберите период",
		"ReportConstructor.option.merchants": "По мерчантам",
		"ReportConstructor.option.transactions": "По транзакциям",
		"ReportConstructor.table.amount": "Сумма пополнений",
		"ReportConstructor.table.count": "Кол-во операций",
		"ReportConstructor.table.fee": "Комиссия",
		"ReportConstructor.table.provider": "Провайдер",
		"ReportWidget.format": "Формат:",
		"ReportWidget.generate": "Сформировать отчет {format}",
		"ReportWidget.imageAlt": "Сформировать отчет",
		"ReportWidget.operations": "Операций",
		"SbpPay.label.recipient": "Получатель (СБП)",
		"SbpPay.title": "Выплата по СБП",
		"Search.example.amount": "например: 10 000",
		"Search.example.amountLess": "например: 10 000",
		"Search.example.cardHolder": "например: Ivan Ivanov",
		"Search.example.cardNumber": "например: 777777 •••• 7777",
		"Search.example.description": "например: Операция списания",
		"Search.example.email": "например: support@email.io",
		"Search.example.externalReference": "например: c8c32d92-cd65-428d-9e2f-896923a3b864",
		"Search.example.fio": "например: Иванов Иван",
		"Search.example.id": "например: 1288",
		"Search.example.pan": "например: 4111111111",
		"Search.example.phone": "74954453019",
		"Search.example.rrn": "___",
		"Search.label.accountId": "Номер учетной записи",
		"Search.label.amountEqually": "Сумма равна",
		"Search.label.amountLess": "Сумма меньше",
		"Search.label.amountMore": "Сумма больше",
		"Search.label.cardHolder": "Держатель карты",
		"Search.label.cardNumber": "Номер карты",
		"Search.label.currency": "Валюта",
		"Search.label.description": "Описание",
		"Search.label.email": "Электронной почте",
		"Search.label.externalReference": "Внешняя ссылка",
		"Search.label.fio": "Ф.И.О",
		"Search.label.merchantName": "имя мерчанта",
		"Search.label.messageText": "текст сообщения",
		"Search.label.operationId": "ID операции",
		"Search.label.pan": "PAN",
		"Search.label.phone": "Телефон",
		"Search.label.projectName": "название проекта",
		"Search.label.projectUuid": "UUID проекта",
		"Search.label.providerName": "Провайдер",
		"Search.label.registryData": "Искать по: ID, PAN, ФИО, сумме или телефону",
		"Search.label.rrn": "RRN",
		"Search.label.searchBy": "Искать по",
		"Search.label.senderName": "отправитель",
		"Search.label.terminalId": "ID терминала",
		"Search.label.terminalName": "Название терминала",
		"Search.label.transactionId": "ID транзакции",
		"Search.label.url": "адрес сайта",
		"Search.label.username": "Логин",
		"Search.label.uuid": "UUID проекта",
		"Search.placeholder.accountId": "Введите ID аккаунта",
		"Search.placeholder.currency": "Введите валюту (код)",
		"Search.placeholder.description": "Введите описание проекта",
		"Search.placeholder.email": "Введите email",
		"Search.placeholder.fio": "Введите ФИО",
		"Search.placeholder.merchantName": "Введите имя мерчанта",
		"Search.placeholder.messageText": "Введите текст для поиска",
		"Search.placeholder.projectName": "Введите название проекта",
		"Search.placeholder.projectUuid": "Введите UUID проекта",
		"Search.placeholder.providerName": "Введите имя провайдера",
		"Search.placeholder.senderName": "Введите имя отправителя",
		"Search.placeholder.terminalId": "Введите ID терминала",
		"Search.placeholder.terminalName": "Введите название терминала",
		"Search.placeholder.transactionId": "Введите ID транзакции",
		"Search.placeholder.url": "Введите адрес проекта",
		"Search.placeholder.username": "Логин",
		"Search.placeholder.uuid": "Введите UUID проекта",
		"SearchTags.add": "добавить",
		"SearchTags.find": "Найти",
		"SearchTags.label": "Поиск по",
		"SearchTags.placeholder.phone": "+7 (___) ___-__-__",
		"SearchTags.search": "Найти",
		"SecretChat.button.new": "Новый чат",
		"SecretChat.button.send": "Отправить",
		"SecretChat.day.today": "Сегодня",
		"SecretChat.empty.messages": "Пока пусто — напишите первым",
		"SecretChat.empty.pick": "Выберите чат или начните новый",
		"SecretChat.error.download": "Файл не скачался — возможно, он уже удалён",
		"SecretChat.error.load": "Не удалось загрузить переписку",
		"SecretChat.error.send": "Сообщение не отправлено",
		"SecretChat.file.attach": "Приложить файл",
		"SecretChat.file.download": "Скачать файл",
		"SecretChat.left.hours": "исчезнет через {hours} ч {minutes} мин",
		"SecretChat.left.minutes": "исчезнет через {minutes} мин",
		"SecretChat.list.title": "Разговоры",
		"SecretChat.loading": "Загрузка…",
		"SecretChat.note.ttl": "Переписка зашифрована и удаляется через {hours} ч",
		"SecretChat.placeholder": "Сообщение…",
		"SecretChats.admin.title": "Секретные чаты",
		"SecretChats.button.cancel": "Отмена",
		"SecretChats.button.clearClient": "Выбрать другого",
		"SecretChats.button.create": "Начать чат",
		"SecretChats.empty": "Чатов пока нет",
		"SecretChats.error.create": "Не удалось создать чат",
		"SecretChats.error.list": "Не удалось загрузить список чатов",
		"SecretChats.field.client": "Клиент: начните вводить имя или логин",
		"SecretChats.field.first": "Первое сообщение (необязательно)",
		"SecretChats.field.search": "Поиск клиента",
		"SecretChats.field.subject": "Тема разговора",
		"SecretChats.loading": "Загрузка…",
		"SecretChats.subtitle": "Переписка шифруется и полностью удаляется через {hours} часа",
		"SecretChats.title": "Секретные чаты",
		"Status.active": "Активен",
		"Status.blocked": "Заблокирован",
		"Status.inactive": "Неактивен",
		"Status.unknown": "Неизвестно",
		"Support.chat.button": "Чат поддержки",
		"Support.general.title": "Общие вопросы",
		"Support.manager.title": "Ваш менеджер",
		"Support.tech.title": "Технические вопросы",
		"Support.ticket.create": "Оставить обращение",
		"Support.ticket.title": "Нужна помощь?",
		"SupportWidget.action.attachFile": "Прикрепить файл",
		"SupportWidget.action.back": "Назад",
		"SupportWidget.action.collapse": "Свернуть",
		"SupportWidget.action.createTicket": "Создать обращение",
		"SupportWidget.action.send": "Отправить",
		"SupportWidget.action.sending": "Отправка...",
		"SupportWidget.attachment.purged": "файл удалён по сроку хранения",
		"SupportWidget.closedNote": "Обращение закрыто. Создайте новое, если нужна помощь.",
		"SupportWidget.edit.cancel": "Отмена",
		"SupportWidget.edit.save": "Сохранить",
		"SupportWidget.edit.title": "Редактировать",
		"SupportWidget.empty.chat": "Начните диалог — сообщения появятся здесь.",
		"SupportWidget.empty.listText": "Опишите проблему, прикрепите скриншоты или документы — мы ответим как можно быстрее.",
		"SupportWidget.empty.listTitle": "Задайте вопрос поддержке",
		"SupportWidget.error.bodyOrFileRequired": "Опишите ваш вопрос или прикрепите файл.",
		"SupportWidget.error.fileTooLarge": "Файл \"{name}\" больше 25 МБ.",
		"SupportWidget.error.maxFiles": "Не более 10 файлов на сообщение.",
		"SupportWidget.error.save": "Не удалось сохранить.",
		"SupportWidget.error.send": "Не удалось отправить.",
		"SupportWidget.error.subjectRequired": "Укажите тему обращения.",
		"SupportWidget.header.listSubtitle": "Мы обычно отвечаем в течение часа",
		"SupportWidget.header.listTitle": "Поддержка",
		"SupportWidget.header.newSubtitle": "Опишите ваш вопрос, мы поможем",
		"SupportWidget.header.newTitle": "Новое обращение",
		"SupportWidget.hint.attachments": "Можно прикрепить до 10 файлов (до 25 МБ каждый): скриншоты, документы, видео.",
		"SupportWidget.message.deleted": "сообщение удалено",
		"SupportWidget.message.edited": "изменено",
		"SupportWidget.placeholder.details": "Опишите ваш вопрос подробнее...",
		"SupportWidget.placeholder.message": "Сообщение...",
		"SupportWidget.placeholder.subject": "Тема обращения",
		"SupportWidget.size.bytes": "{count} б",
		"SupportWidget.size.kb": "{count} КБ",
		"SupportWidget.size.mb": "{count} МБ",
		"SupportWidget.status.closed": "Закрыто",
		"SupportWidget.status.open": "Открыто",
		"SupportWidget.status.pendingUser": "Ожидает ответа",
		"SupportWidget.time.daysAgo": "{count} д назад",
		"SupportWidget.time.hoursAgo": "{count} ч назад",
		"SupportWidget.time.justNow": "только что",
		"SupportWidget.time.minutesAgo": "{count} мин назад",
		"TerminalAdd.btn.create": "Создать",
		"TerminalAdd.error.create": "Не удалось создать терминал",
		"TerminalAdd.error.missing": "Укажите проект и название",
		"TerminalAdd.label.name": "Название",
		"TerminalAdd.label.project": "Проект",
		"TerminalAdd.label.provider": "Провайдер (опционально)",
		"TerminalAdd.label.status": "Статус",
		"TerminalAdd.placeholder.noProvider": "— не выбирать —",
		"TerminalAdd.placeholder.selectProject": "— выберите проект —",
		"TerminalAdd.status.active": "Активен",
		"TerminalAdd.status.inactive": "Неактивен",
		"TerminalAdd.success.created": "Терминал создан",
		"TerminalEditing.auth.empty": "Нет ключей авторизации",
		"TerminalEditing.button.save": "Сохранить",
		"TerminalEditing.button.saveLimits": "Сохранить лимиты",
		"TerminalEditing.empty": "Терминал не выбран",
		"TerminalEditing.error.loadLimits": "Ошибка загрузки лимитов",
		"TerminalEditing.error.save": "Не удалось сохранить терминал",
		"TerminalEditing.error.saveLimits": "Ошибка при сохранении лимитов",
		"TerminalEditing.field.balance": "Баланс",
		"TerminalEditing.field.bankAccount": "Bank account",
		"TerminalEditing.field.exchangeRate": "Exchange rate",
		"TerminalEditing.field.name": "Название",
		"TerminalEditing.field.paymentMethod": "Payment method",
		"TerminalEditing.field.returnUrl": "Адрес возврата",
		"TerminalEditing.field.status": "Статус",
		"TerminalEditing.field.webhookUrl": "Адрес колбека",
		"TerminalEditing.limits.amount": "Сумма",
		"TerminalEditing.limits.daily": "День",
		"TerminalEditing.limits.max": "Макс. сумма",
		"TerminalEditing.limits.min": "Мин. сумма",
		"TerminalEditing.limits.monthly": "Месяц",
		"TerminalEditing.limits.payment.title": "Платежи (payment)",
		"TerminalEditing.limits.payout.title": "Выплаты (payout)",
		"TerminalEditing.limits.payoutLimit.title": "Общий лимит выплат (payoutLimit)",
		"TerminalEditing.limits.perDay": "В день",
		"TerminalEditing.limits.perHour": "В час",
		"TerminalEditing.limits.perMinute": "В минуту",
		"TerminalEditing.limits.velocity.title": "Скорость (velocity)",
		"TerminalEditing.loading.limits": "Загрузка лимитов...",
		"TerminalEditing.method.h2h": "Человек к человеку",
		"TerminalEditing.method.partialRefund": "Частичный возврат",
		"TerminalEditing.method.partialReversal": "Частичная отмена",
		"TerminalEditing.method.preAuth": "Предавторизация",
		"TerminalEditing.method.recurring": "Рекуррент",
		"TerminalEditing.method.sbp": "СБП",
		"TerminalEditing.placeholder.notSet": "не установлено",
		"TerminalEditing.provider.current": "Текущий: {name}",
		"TerminalEditing.provider.noChange": "— не менять —",
		"TerminalEditing.save": "Сохранить",
		"TerminalEditing.saving.limits": "Сохранение...",
		"TerminalEditing.section.auth": "Данные авторизации (processingAuth)",
		"TerminalEditing.section.limits": "Лимиты",
		"TerminalEditing.section.methods": "Методы",
		"TerminalEditing.section.other": "Прочее",
		"TerminalEditing.section.provider": "Привязка провайдера",
		"TerminalEditing.status.active": "Активен",
		"TerminalEditing.status.inactive": "Неактивен",
		"TerminalEditing.success.limitsSaved": "Лимиты сохранены",
		"TerminalEditing.success.saved": "Терминал сохранён",
		"TerminalEditing.title": "Терминал",
		"Terminals.add": "Добавить",
		"Terminals.modal.addTitle": "Добавить терминал",
		"Terminals.title": "Терминалы",
		"TerminalsFilters.btn.apply": "Применить",
		"TerminalsFilters.method.partialRefund": "Частичный возврат",
		"TerminalsFilters.method.partialReversal": "Частичная отмена",
		"TerminalsFilters.method.preAuth": "Предавторизация",
		"TerminalsFilters.method.recurring": "Рекуррент",
		"TerminalsFilters.method.sbp": "СБП",
		"TerminalsFilters.provider.any": "— любой —",
		"TerminalsFilters.provider.label": "Провайдер",
		"TerminalsFilters.status.active": "Активные",
		"TerminalsFilters.status.inactive": "Неактивные",
		"TerminalsFilters.title": "Фильтры",
		"TerminalsList.currency": "Валюта: {name}",
		"TerminalsList.empty": "Ничего не найдено",
		"TerminalsList.method.p2p": "Р2Р",
		"TerminalsList.method.partialRefund": "Част. возврат",
		"TerminalsList.method.partialReversal": "Част. отмена",
		"TerminalsList.method.preAuth": "Предавт.",
		"TerminalsList.method.recurring": "Рекуррент",
		"TerminalsList.method.sbp": "СБП",
		"TerminalsList.status.active": "Активен",
		"TerminalsList.status.inactive": "Неактивен",
		"TerminalsList.table.balance": "Баланс",
		"TerminalsList.table.id": "Идентификатор",
		"TerminalsList.table.methods": "Методы",
		"TerminalsList.table.project": "Проект",
		"TerminalsList.table.provider": "Провайдер",
		"TerminalsList.table.status": "Статус",
		"TerminalsList.table.terminal": "Терминал",
		"TerminalsTable.empty": "Нет подключенных терминалов",
		"TerminalsTable.fee.fixed": "Комиссия за операцию:",
		"TerminalsTable.fee.fixedValue": "фикс. {value}",
		"TerminalsTable.fee.percent": "Комиссия за операцию:",
		"TerminalsTable.fee.percentValue": "{percent}% (минимум {min}р)",
		"TerminalsTable.status.active": "Активен",
		"TerminalsTable.status.blocked": "Заблокирован",
		"TerminalsTable.tab.payments": "Платежи",
		"TerminalsTable.tab.payouts": "Выплаты",
		"TerminalsTable.table.confirmed": "Баланс подтвержденный",
		"TerminalsTable.table.currency": "Валюта",
		"TerminalsTable.table.holded": "Баланс удержанный",
		"TerminalsTable.table.id": "ID",
		"TerminalsTable.table.mcc": "MCC",
		"TerminalsTable.table.name": "Название",
		"TerminalsTable.table.status": "Статус",
		"TerminalsTable.table.turnover": "Оборот",
		"TicketsTable.empty": "У вас нет тикетов",
		"TicketsTable.table.lastFrom": "Последнее сообщение от",
		"TicketsTable.table.message": "Сообщение",
		"TicketsTable.table.status": "Статус",
		"TicketsTable.table.updated": "Обновлён",
		"TransactionAudit.amount": "Сумма",
		"TransactionAudit.clearFilters": "Сбросить фильтры",
		"TransactionAudit.createdAt": "Создана",
		"TransactionAudit.direction": "Направление",
		"TransactionAudit.empty": "Нет данных аудита",
		"TransactionAudit.error": "Ошибка: {error}",
		"TransactionAudit.eventTypes": "Типы событий",
		"TransactionAudit.externalRef": "External Ref",
		"TransactionAudit.filters": "Фильтры",
		"TransactionAudit.fraud.blocked": "Заблокировано антифродом",
		"TransactionAudit.fraud.ok": "Антифрод: OK",
		"TransactionAudit.hint": "Введите ID транзакции для просмотра полной истории",
		"TransactionAudit.loading": "Загрузка данных...",
		"TransactionAudit.merchant": "Мерчант",
		"TransactionAudit.meta": "Детали",
		"TransactionAudit.noEvents": "События не записаны",
		"TransactionAudit.page.title": "Аудит транзакций",
		"TransactionAudit.payload": "Данные",
		"TransactionAudit.processingId": "Processing ID",
		"TransactionAudit.search": "Поиск",
		"TransactionAudit.searching": "Поиск...",
		"TransactionAudit.status": "Статус",
		"TransactionAudit.timeline": "История событий",
		"TransactionAudit.title": "Аудит транзакций",
		"TransactionAudit.transaction": "Транзакция",
		"TransactionsFilters.acquiring.card": "Банковские карты",
		"TransactionsFilters.acquiring.phone": "Мобильные телефоны",
		"TransactionsFilters.btn.setFilters": "Фильтровать",
		"TransactionsFilters.category.QR": "QR операции",
		"TransactionsFilters.category.SBP": "СБП операции",
		"TransactionsFilters.category.p2p": "P2P операции",
		"TransactionsFilters.category.payments": "Платежи",
		"TransactionsFilters.category.payout": "Выплаты",
		"TransactionsFilters.filters.registry": "Выплаты по реестрам",
		"TransactionsFilters.label.chargeback": "Chargeback",
		"TransactionsFilters.label.created": "Created",
		"TransactionsFilters.label.isDataLoading": "Получение данных...",
		"TransactionsFilters.label.mP2P": "Manual P2P",
		"TransactionsFilters.label.mP2PCreated": "Manual P2P Created",
		"TransactionsFilters.label.mP2PDecline": "Manual P2P Decline",
		"TransactionsFilters.label.mP2PPending": "Manual P2P Pending",
		"TransactionsFilters.label.mobilePayout": "Mobile Payout",
		"TransactionsFilters.label.mobilePayoutCreated": "Mobile Payout Created",
		"TransactionsFilters.label.mobilePayoutDecline": "Mobile Payout Decline",
		"TransactionsFilters.label.mobilePayoutPending": "Mobile Payout Pending",
		"TransactionsFilters.label.payout": "Payout",
		"TransactionsFilters.label.payoutCreated": "Payout created",
		"TransactionsFilters.label.payoutDecline": "Payout decline",
		"TransactionsFilters.label.payoutPending": "Payout pending",
		"TransactionsFilters.label.purchase": "Purchase",
		"TransactionsFilters.label.purchaseCreated": "Purchase created",
		"TransactionsFilters.label.purchaseDecline": "Purchase decline",
		"TransactionsFilters.label.purchasePending": "Purchase pending",
		"TransactionsFilters.label.qr": "QR Successful",
		"TransactionsFilters.label.qrCreated": "QR Created",
		"TransactionsFilters.label.qrDecline": "QR Decline",
		"TransactionsFilters.label.qrPending": "QR Pending",
		"TransactionsFilters.label.recurrent": "Recurrent",
		"TransactionsFilters.label.recurrentCreated": "Recurrent created",
		"TransactionsFilters.label.recurrentDecline": "Recurrent decline",
		"TransactionsFilters.label.recurrentPending": "Recurrent pending",
		"TransactionsFilters.label.refund": "Refund",
		"TransactionsFilters.label.refundCreated": "Refund created",
		"TransactionsFilters.label.refundDecline": "Refund decline",
		"TransactionsFilters.label.refundPending": "Refund pending",
		"TransactionsFilters.label.reversal": "Reversal",
		"TransactionsFilters.label.reversalCreated": "Reversal created",
		"TransactionsFilters.label.reversalDecline": "Reversal decline",
		"TransactionsFilters.label.reversalPending": "Reversal pending",
		"TransactionsFilters.label.sbp": "SBP",
		"TransactionsFilters.label.sbpCreated": "SBP Created",
		"TransactionsFilters.label.sbpDecline": "SBP Decline",
		"TransactionsFilters.label.sbpPending": "SBP Pending",
		"TransactionsFilters.label.successfulP2P": "Successful P2P",
		"TransactionsFilters.label.successfulSBP": "Successful SBP",
		"TransactionsFilters.label.successfulSbp": "Successful SBP",
		"TransactionsFilters.label.threeDSPending": "3DS Pending",
		"TransactionsFilters.title.acquiring": "Эквайринг",
		"TransactionsFilters.title.filters": "Фильтры",
		"TransactionsFilters.title.statuses": "Статусы",
		"TransactionsTable.amount.confirm": "Изменить сумму транзакции {id} на {amount}?",
		"TransactionsTable.amount.error.invalid": "Некорректный формат суммы. Пример: 1000 или 1000.50",
		"TransactionsTable.amount.error.required": "Введите сумму",
		"TransactionsTable.amount.error.save": "Не удалось изменить сумму транзакции",
		"TransactionsTable.amount.note": "Введите сумму в рублях, в БД сохраняется в копейках.",
		"TransactionsTable.amount.placeholder": "Например: 1000 или 1000.50",
		"TransactionsTable.amount.save": "Сохранить",
		"TransactionsTable.amount.saving": "Сохранение...",
		"TransactionsTable.amount.section": "Изменить сумму",
		"TransactionsTable.amount.success": "Сумма транзакции обновлена",
		"TransactionsTable.cancel.cancel": "Отмена ",
		"TransactionsTable.cancel.error": "Отмена платежа невозможна",
		"TransactionsTable.cancel.initiated": "По операции {id} инициирован {type}.",
		"TransactionsTable.cancel.loading": "Получение данных...",
		"TransactionsTable.cancel.refund": "Возврат ",
		"TransactionsTable.cancel.success": "Отмена инициирована",
		"TransactionsTable.check.amount": "Сумма:",
		"TransactionsTable.check.button": "Проверить транзакцию",
		"TransactionsTable.check.decline": "Перевести в Decline",
		"TransactionsTable.check.error": "Ошибка при проверке транзакции",
		"TransactionsTable.check.loading": "Проверка...",
		"TransactionsTable.check.message": "Сообщение:",
		"TransactionsTable.check.orderId": "Order ID:",
		"TransactionsTable.check.payout": "Перевести в Payout",
		"TransactionsTable.check.provider": "Провайдер:",
		"TransactionsTable.check.result": "Результат проверки:",
		"TransactionsTable.check.rrn": "RRN:",
		"TransactionsTable.check.status": "Статус:",
		"TransactionsTable.confirm.action": "Действие",
		"TransactionsTable.confirm.decline": "Перевести транзакцию {id} в статус Decline?",
		"TransactionsTable.confirm.payout": "Перевести транзакцию {id} в статус Payout?",
		"TransactionsTable.confirm.text": "Подтвердить операцию",
		"TransactionsTable.empty": "Платежей нет",
		"TransactionsTable.error.cancel": "Отмена платежа невозможна",
		"TransactionsTable.error.decline": "Не удалось перевести транзакцию в статус Decline",
		"TransactionsTable.error.payout": "Не удалось перевести транзакцию в статус Payout",
		"TransactionsTable.label.chargeback": "Chargeback",
		"TransactionsTable.label.created": "Created",
		"TransactionsTable.label.mP2P": "Manual P2P",
		"TransactionsTable.label.mP2PCreated": "Manual P2P Created",
		"TransactionsTable.label.mP2PDecline": "Manual P2P Decline",
		"TransactionsTable.label.mP2PPending": "Manual P2P Pending",
		"TransactionsTable.label.mobilePayout": "Mobile Payout",
		"TransactionsTable.label.mobilePayoutCreated": "Mobile Payout Created",
		"TransactionsTable.label.mobilePayoutDecline": "Mobile Payout Decline",
		"TransactionsTable.label.mobilePayoutPending": "Mobile Payout Pending",
		"TransactionsTable.label.payout": "Payout",
		"TransactionsTable.label.payoutCreated": "Payout created",
		"TransactionsTable.label.payoutDecline": "Payout decline",
		"TransactionsTable.label.payoutPending": "Payout pending",
		"TransactionsTable.label.purchase": "Purchase",
		"TransactionsTable.label.purchaseCreated": "Purchase created",
		"TransactionsTable.label.purchaseDecline": "Purchase decline",
		"TransactionsTable.label.purchasePending": "Purchase pending",
		"TransactionsTable.label.qr": "QR Successful",
		"TransactionsTable.label.qrCreated": "QR Created",
		"TransactionsTable.label.qrDecline": "QR Decline",
		"TransactionsTable.label.qrPending": "QR Pending",
		"TransactionsTable.label.recurrent": "Recurrent",
		"TransactionsTable.label.recurrentCreated": "Recurrent created",
		"TransactionsTable.label.recurrentDecline": "Recurrent decline",
		"TransactionsTable.label.recurrentPending": "Recurrent pending",
		"TransactionsTable.label.refund": "Refund",
		"TransactionsTable.label.refundCreated": "Refund created",
		"TransactionsTable.label.refundDecline": "Refund decline",
		"TransactionsTable.label.refundPending": "Refund pending",
		"TransactionsTable.label.reversal": "Reversal",
		"TransactionsTable.label.reversalCreated": "Reversal created",
		"TransactionsTable.label.reversalDecline": "Reversal decline",
		"TransactionsTable.label.reversalPending": "Reversal pending",
		"TransactionsTable.label.sbp": "SBP",
		"TransactionsTable.label.sbpCreated": "SBP Created",
		"TransactionsTable.label.sbpDecline": "SBP Decline",
		"TransactionsTable.label.sbpPending": "SBP Pending",
		"TransactionsTable.label.successfulP2P": "Successful P2P",
		"TransactionsTable.label.successfulSBP": "Successful SBP",
		"TransactionsTable.label.successfulSbp": "Successful SBP",
		"TransactionsTable.label.threeDSPending": "3DS Pending",
		"TransactionsTable.modal.refund": "Вернуть {amount}",
		"TransactionsTable.modal.reversal": "Отменить платеж {amount}",
		"TransactionsTable.modal.title": "Подтвердите действие",
		"TransactionsTable.refund.action": "Действие",
		"TransactionsTable.refund.button": "Возврат",
		"TransactionsTable.refund.id": "Идентификатор операции возврата",
		"TransactionsTable.refund.initiated": "Возврат инициирован",
		"TransactionsTable.refund.loading": "Получение данных...",
		"TransactionsTable.refund.status": "Статус",
		"TransactionsTable.refund.type": "Тип",
		"TransactionsTable.resend.button": "Отправить мерчанту повторно",
		"TransactionsTable.resend.buttonDeposit": "Повторить зачисление",
		"TransactionsTable.resend.confirm": "Отправить мерчанту уведомление по транзакции {id} повторно?",
		"TransactionsTable.resend.confirmDeposit": "Повторить доставку депозита {id} мерчанту?",
		"TransactionsTable.resend.confirmReopen": "Депозит {id} закрыт отказом мерчанта. Он будет отправлен мерчанту заново и, если мерчант его примет, зачислен на баланс мерчанта (сумма за вычетом комиссии). Продолжить?",
		"TransactionsTable.resend.error": "Не удалось отправить мерчанту повторно",
		"TransactionsTable.resend.flow.agent_deposit": "депозит агента",
		"TransactionsTable.resend.flow.craft_lite": "Paycraft (lite)",
		"TransactionsTable.resend.flow.fins_lite": "FinStar (lite)",
		"TransactionsTable.resend.flow.hydra_lite": "Hydracode (lite)",
		"TransactionsTable.resend.flow.npay_lite": "NPay (lite)",
		"TransactionsTable.resend.flow.queue": "штатное уведомление (очередь)",
		"TransactionsTable.resend.result.flow": "Формат: {flow}",
		"TransactionsTable.resend.result.host": "Адрес: {host}",
		"TransactionsTable.resend.result.httpCode": "Ответ мерчанта: HTTP {code}",
		"TransactionsTable.resend.sending": "Отправка...",
		"TransactionsTable.reversal.action": "Действие",
		"TransactionsTable.reversal.button": "Отменить платеж",
		"TransactionsTable.reversal.canceled": "Платеж отменён",
		"TransactionsTable.reversal.id": "Идентификатор операции отмены",
		"TransactionsTable.reversal.loading": "Получение данных...",
		"TransactionsTable.reversal.status": "Статус",
		"TransactionsTable.reversal.type": "Тип",
		"TransactionsTable.status.loading": "Ожидание ответа...",
		"TransactionsTable.status.waiting": "Статус",
		"TransactionsTable.success.cancel": "Отмена инициирована",
		"TransactionsTable.success.decline": "Статус транзакции обновлён на Decline",
		"TransactionsTable.success.payout": "Статус транзакции обновлён на Payout",
		"TransactionsTable.tab.action": "Действие:",
		"TransactionsTable.tab.actions": "Операции",
		"TransactionsTable.tab.amount": "Сумма:",
		"TransactionsTable.tab.audit": "Аудит",
		"TransactionsTable.tab.bank": "Банк карты:",
		"TransactionsTable.tab.cancelId": "ID",
		"TransactionsTable.tab.cancelType": "Тип операции",
		"TransactionsTable.tab.cardHolder": "Держатель карты:",
		"TransactionsTable.tab.confirm": "Подтверждение",
		"TransactionsTable.tab.country": "Страна карты:",
		"TransactionsTable.tab.email": "Электронная почта:",
		"TransactionsTable.tab.extStatus": "Расширенный статус:",
		"TransactionsTable.tab.extendedStatus": "Расширенный статус:",
		"TransactionsTable.tab.fee": "Коммиссия:",
		"TransactionsTable.tab.id": "Идентификатор операции:",
		"TransactionsTable.tab.management": "Управление",
		"TransactionsTable.tab.parameters": "Параметры платежа",
		"TransactionsTable.tab.params": "Параметры платежа",
		"TransactionsTable.tab.payment": "Данные платежа",
		"TransactionsTable.tab.paymentData": "Данные платежа",
		"TransactionsTable.tab.phone": "Телефон:",
		"TransactionsTable.tab.processId": "Идентификатор процесса:",
		"TransactionsTable.tab.processed": "Обработан:",
		"TransactionsTable.tab.refund": "Возврат средств",
		"TransactionsTable.tab.rrn": "RRN:",
		"TransactionsTable.tab.status": "Статус",
		"TransactionsTable.tab.waiting": "Ожидание ответа...",
		"TransactionsTable.table.amount": "Сумма",
		"TransactionsTable.table.date": "Дата",
		"TransactionsTable.table.payer": "Плательщик",
		"TransactionsTable.table.project": "Проект",
		"TransactionsTable.text.paymentPartialRefund": "По данной операции доступен частичный возврат. Максимальная сумма {amount}. Время возврата зависит от банка эмитента и составляет от 1 до 7 рабочих дней.",
		"TransactionsTable.text.paymentPartialReversal": "По данной операции доступна частичная отмена. Максимальная сумма {amount}. Время отмены зависит от банка эмитента и как правило происходит в течении часа.",
		"TransactionsTable.text.paymentRefund": "Будет осуществлен возврат на сумму {amount}. Время возврата зависит от банка эмитента и составляет от 1 до 7 рабочих дней.",
		"TransactionsTable.text.paymentReversal": "Будет осуществлена отмена платежа на сумму {amount}. Время отмены зависит от банка эмитента и как правило происходит в течении часа.",
		"UserMenu.list.home": "Главная",
		"UserMenu.list.projects": "Проекты",
		"UserMenu.list.transactions": "Операции",
		"UserMenu.title.antifraud": "Антифрод система",
		"UserMenu.title.antifraudFileCheck": "Проверка файла",
		"UserMenu.title.antifraudLog": "Лог проверок",
		"UserMenu.title.antifraudSingleCheck": "Разовая проверка",
		"UserMenu.title.finance": "Финансы",
		"UserMenu.title.metal": "Металл",
		"UserMenu.title.mobileRegistries": "Реестры (СБП)",
		"UserMenu.title.payments": "Платежи",
		"UserMenu.title.payouts": "Выплаты",
		"UserMenu.title.prepaid": "Активированные карты",
		"UserMenu.title.registries": "Реестры",
		"UserMenu.title.sbpPayouts": "Выплаты (СБП)",
		"UserMenu.title.sbpRegistries": "Реестры (СБП)",
		"UserMenu.title.statement": "Выписка",
		"UserSearchList.empty": "Ничего не найдено",
		"UserSearchList.loading": "Загрузка пользователей...",
		"UserSearchList.permissions.btn": "Права",
		"UserSearchList.permissions.title": "Настроить права",
		"UserSearchList.placeholder": "Поиск пользователя по ID, имени или email...",
		"UserSearchList.remove.aria": "Удалить {name}",
		"UserSearchList.selected.title": "Выбранные пользователи",
		"binBase.country.10": "Антарктика",
		"binBase.country.100": "Болгария",
		"binBase.country.104": "Мьянма",
		"binBase.country.108": "Бурунди",
		"binBase.country.112": "Беларусь",
		"binBase.country.116": "Камбоджа",
		"binBase.country.12": "Алжир",
		"binBase.country.120": "Камерун",
		"binBase.country.124": "Канада",
		"binBase.country.132": "Кабо-Верде",
		"binBase.country.136": "Каймановы о-ва (GB)",
		"binBase.country.140": "Центрально-африканская Республика",
		"binBase.country.144": "Шри-Ланка",
		"binBase.country.148": "Чад",
		"binBase.country.152": "Чили",
		"binBase.country.156": "Китай",
		"binBase.country.158": "Тайвань",
		"binBase.country.16": "Восточное Самоа (US)",
		"binBase.country.162": "Рождества о. (AU)",
		"binBase.country.166": "Кокосовые (Киилинг) о-ва (AU)",
		"binBase.country.170": "Колумбия",
		"binBase.country.174": "Коморские о-ва",
		"binBase.country.175": "Майотта о. (KM)",
		"binBase.country.178": "Конго",
		"binBase.country.180": "Демократическая Республика Конго",
		"binBase.country.184": "Кука о-ва (NZ)",
		"binBase.country.188": "Коста-Рика",
		"binBase.country.191": "Хорватия",
		"binBase.country.192": "Куба",
		"binBase.country.196": "Кипр",
		"binBase.country.20": "Андорра",
		"binBase.country.203": "Чехия",
		"binBase.country.204": "Бенин",
		"binBase.country.208": "Дания",
		"binBase.country.212": "Доминика",
		"binBase.country.214": "Доминиканская Республика",
		"binBase.country.218": "Эквадор",
		"binBase.country.222": "Сальвадор",
		"binBase.country.226": "Экваториальная Гвинея",
		"binBase.country.231": "Эфиопия",
		"binBase.country.232": "Эритрия",
		"binBase.country.233": "Эстония",
		"binBase.country.234": "Фарерские о-ва (DK)",
		"binBase.country.238": "Фолклендские (Мальвинские) о-ва (GB/AR)",
		"binBase.country.239": "Южная Георгия и Южные Сандвичевы о-ва",
		"binBase.country.24": "Ангола",
		"binBase.country.242": "Фиджи",
		"binBase.country.246": "Финляндия",
		"binBase.country.250": "Франция",
		"binBase.country.254": "Французская Гвиана (FR)",
		"binBase.country.258": "Французская Полинезия",
		"binBase.country.260": "Французские южные территории (FR)",
		"binBase.country.262": "Джибути",
		"binBase.country.266": "Габон",
		"binBase.country.268": "Грузия",
		"binBase.country.270": "Гамбия",
		"binBase.country.275": "Палестинская автономия",
		"binBase.country.276": "Германия",
		"binBase.country.28": "Антигуа и Барбуда",
		"binBase.country.280": "Германия",
		"binBase.country.288": "Гана",
		"binBase.country.292": "Гибралтар",
		"binBase.country.296": "Кирибати",
		"binBase.country.300": "Греция",
		"binBase.country.304": "Гренландия (DK)",
		"binBase.country.308": "Гренада",
		"binBase.country.31": "Азербайджан",
		"binBase.country.312": "Гваделупа",
		"binBase.country.316": "Гуам",
		"binBase.country.32": "Аргентина",
		"binBase.country.320": "Гватемала",
		"binBase.country.324": "Гвинея",
		"binBase.country.328": "Гайана",
		"binBase.country.332": "Гаити",
		"binBase.country.334": "Херд и Макдональд о-ва (AU)",
		"binBase.country.336": "Ватикан",
		"binBase.country.340": "Гондурас",
		"binBase.country.344": "Гонконг (CN",
		"binBase.country.348": "Венгрия",
		"binBase.country.352": "Исландия",
		"binBase.country.356": "Индия",
		"binBase.country.36": "Австралия",
		"binBase.country.360": "Индонезия",
		"binBase.country.364": "Иран",
		"binBase.country.368": "Ирак",
		"binBase.country.372": "Ирландия",
		"binBase.country.376": "Израиль",
		"binBase.country.380": "Италия",
		"binBase.country.384": "Кот-д'Ивуар",
		"binBase.country.388": "Ямайка",
		"binBase.country.392": "Япония",
		"binBase.country.398": "Казахстан",
		"binBase.country.4": "Афганистан",
		"binBase.country.40": "Австрия",
		"binBase.country.400": "Иордания",
		"binBase.country.404": "Кения",
		"binBase.country.408": "Северная Корея (КНДР)",
		"binBase.country.410": "Южная Корея (Республика Корея)",
		"binBase.country.414": "Кувейт",
		"binBase.country.417": "Киргизстан",
		"binBase.country.418": "Лаос",
		"binBase.country.422": "Ливан",
		"binBase.country.426": "Лесото",
		"binBase.country.428": "Латвия",
		"binBase.country.430": "Либерия",
		"binBase.country.434": "Ливия",
		"binBase.country.438": "Лихтенштейн",
		"binBase.country.44": "Багамы",
		"binBase.country.440": "Литва",
		"binBase.country.442": "Люксембург",
		"binBase.country.446": "Макао (PT)",
		"binBase.country.450": "Мадагаскар",
		"binBase.country.454": "Малави",
		"binBase.country.458": "Малайзия",
		"binBase.country.462": "Мальдивы",
		"binBase.country.466": "Мали",
		"binBase.country.470": "Мальта",
		"binBase.country.474": "Мартиника",
		"binBase.country.478": "Мавритания",
		"binBase.country.48": "Бахрейн",
		"binBase.country.480": "Маврикий",
		"binBase.country.484": "Мексика",
		"binBase.country.492": "Монако",
		"binBase.country.496": "Монголия",
		"binBase.country.498": "Молдова",
		"binBase.country.499": "Черногория",
		"binBase.country.50": "Бангладеш",
		"binBase.country.500": "Монсеррат о. (GB)",
		"binBase.country.504": "Марокко",
		"binBase.country.508": "Мозамбик",
		"binBase.country.51": "Армения",
		"binBase.country.512": "Оман",
		"binBase.country.516": "Намибия",
		"binBase.country.52": "Барбадос",
		"binBase.country.520": "Науру",
		"binBase.country.524": "Непал",
		"binBase.country.528": "Нидерланды",
		"binBase.country.530": "Антильские о-ва (NL)",
		"binBase.country.531": "Кюрасао",
		"binBase.country.533": "Аруба",
		"binBase.country.534": "Синт-Мартен",
		"binBase.country.535": "Бонэйр, Синт-Эстатиус и Саба",
		"binBase.country.540": "Новая Каледония о. (FR)",
		"binBase.country.548": "Вануату",
		"binBase.country.554": "Новая Зеландия",
		"binBase.country.558": "Никарагуа",
		"binBase.country.56": "Бельгия",
		"binBase.country.562": "Нигер",
		"binBase.country.566": "Нигерия",
		"binBase.country.570": "Ниуэ о. (NZ)",
		"binBase.country.574": "Норфолк о. (AU)",
		"binBase.country.578": "Норвегия",
		"binBase.country.580": "Северные Марианские",
		"binBase.country.581": "Соединенные Штаты Америки Внешние малые острова (US)",
		"binBase.country.583": "Микронезия (US)",
		"binBase.country.584": "Маршалловы о-ва",
		"binBase.country.585": "Палау (US)",
		"binBase.country.586": "Пакистан",
		"binBase.country.591": "Панама",
		"binBase.country.598": "Папуа-Новая Гвинея",
		"binBase.country.60": "Бермуды",
		"binBase.country.600": "Парагвай",
		"binBase.country.604": "Перу",
		"binBase.country.608": "Филиппины",
		"binBase.country.612": "Питкэрн о-ва (GB)",
		"binBase.country.616": "Польша",
		"binBase.country.620": "Португалия",
		"binBase.country.624": "Гвинея-Бисау",
		"binBase.country.626": "Восточный Тимор",
		"binBase.country.630": "Пуэрто-Рико (US)",
		"binBase.country.634": "Катар",
		"binBase.country.638": "Реюньон о. (FR)",
		"binBase.country.64": "Бутан",
		"binBase.country.642": "Румыния",
		"binBase.country.643": "Россия",
		"binBase.country.646": "Руанда",
		"binBase.country.654": "Святой Елены о. (GB)",
		"binBase.country.659": "Сент-Кристофер и Невис",
		"binBase.country.660": "Ангилья о. (GB)",
		"binBase.country.662": "Сент-Люсия",
		"binBase.country.666": "Сен-Пьер и Микелон (FR)",
		"binBase.country.670": "Сен-Винсент и Гренадины",
		"binBase.country.674": "Сан Марино",
		"binBase.country.678": "Сан-Томе и Принсипи",
		"binBase.country.68": "Боливия",
		"binBase.country.682": "Саудовская Аравия",
		"binBase.country.686": "Сенегал",
		"binBase.country.688": "Сербия",
		"binBase.country.690": "Сейшелы",
		"binBase.country.694": "Сьерра-Леоне",
		"binBase.country.70": "Босния и Герцеговина",
		"binBase.country.702": "Сингапур",
		"binBase.country.703": "Словакия",
		"binBase.country.704": "Вьетнам",
		"binBase.country.705": "Словения",
		"binBase.country.706": "Сомали",
		"binBase.country.710": "Южная Африка",
		"binBase.country.716": "Зимбабве",
		"binBase.country.72": "Ботсвана",
		"binBase.country.724": "Испания",
		"binBase.country.728": "Южный Судан",
		"binBase.country.729": "Судан",
		"binBase.country.732": "Западная Сахара",
		"binBase.country.736": "Судан",
		"binBase.country.74": "Бове о. (NO)",
		"binBase.country.740": "Суринам",
		"binBase.country.744": "Свалбард и Ян Мейен о-ва (NO)",
		"binBase.country.748": "Свазиленд",
		"binBase.country.752": "Швеция",
		"binBase.country.756": "Швейцария",
		"binBase.country.76": "Бразилия",
		"binBase.country.760": "Сирия",
		"binBase.country.762": "Таджикистан",
		"binBase.country.764": "Таиланд",
		"binBase.country.768": "Того",
		"binBase.country.772": "Токелау о-ва (NZ)",
		"binBase.country.776": "Тонга",
		"binBase.country.780": "Тринидад и Тобаго",
		"binBase.country.784": "Объединенные Арабские Эмираты",
		"binBase.country.788": "Тунис",
		"binBase.country.792": "Турция",
		"binBase.country.795": "Туркменистан",
		"binBase.country.796": "Теркс и Кайкос о-ва (GB)",
		"binBase.country.798": "Тувалу",
		"binBase.country.8": "Албания",
		"binBase.country.800": "Уганда",
		"binBase.country.804": "Украина",
		"binBase.country.807": "Македония",
		"binBase.country.818": "Египет",
		"binBase.country.826": "Великобритания",
		"binBase.country.831": "Гернси",
		"binBase.country.832": "Джерси",
		"binBase.country.833": "Остров Мэн",
		"binBase.country.834": "Танзания",
		"binBase.country.84": "Белиз",
		"binBase.country.840": "Соединенные Штаты Америки",
		"binBase.country.850": "Виргинские о-ва (US)",
		"binBase.country.854": "Буркина-Фасо",
		"binBase.country.858": "Уругвай",
		"binBase.country.86": "Британская территория Индийского океана (GB)",
		"binBase.country.860": "Узбекистан",
		"binBase.country.862": "Венесуэла",
		"binBase.country.876": "Уоллис и Футунао-ва (FR)",
		"binBase.country.882": "Самоа",
		"binBase.country.887": "Йемен",
		"binBase.country.891": "Югославия",
		"binBase.country.894": "Замбия",
		"binBase.country.90": "Соломоновы о-ва",
		"binBase.country.92": "Виргинские о-ва (GB)",
		"binBase.country.96": "Бруней Дарассалам",
		"binBase.country.999": "Республика Косово"
	};

/***/ },
/* 666 */
/***/ function(module, exports) {

	"use strict";function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";const a=o;a.default=o,a.InvalidTokenError=n,module.exports=a;
	//# sourceMappingURL=jwt-decode.cjs.js.map


/***/ },
/* 667 */
/***/ function(module, exports) {

	module.exports = Paginator;
	
	// Paginator constructor
	//
	// `per_page` is the number of results per page, `length` is the number of
	// pages to display. They default to `25` and `10` respectively.
	function Paginator(per_page, length) {
	  // You really should be calling this with `new Paginator`, but WHATEVER.
	  if (!(this instanceof Paginator)) {
	    return new Paginator(per_page, length);
	  }
	
	  // Woo, defaults!
	  this.per_page = per_page || 25;
	  this.length = length || 10;
	}
	
	// Build an object with all the necessary information for outputting pagination
	// controls.
	//
	// (new Paginator(paginator.build(100, 2)
	Paginator.prototype.build = function(total_results, current_page) {
	  // We want the number of pages, rounded up to the nearest page.
	  var total_pages = Math.ceil(total_results / this.per_page);
	
	  // Ensure both total_results and current_page are treated as Numbers
	  total_results = parseInt(total_results, 10);
	  current_page  = parseInt(current_page, 10) || 1;
	
	  // Obviously we can't be on a negative or 0 page.
	  if (current_page < 1) { current_page = 1; }
	  // If the user has done something like /page/99999 we want to clamp that back
	  // down.
	  if (current_page > total_pages) { current_page = total_pages; }
	
	  // This is the first page to be displayed as a numbered link.
	  var first_page = Math.max(1, current_page - Math.floor(this.length / 2));
	
	  // And here's the last page to be displayed specifically.
	  var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));
	
	  // This is triggered if we're at or near one of the extremes; we won't have
	  // enough page links. We need to adjust our bounds accordingly.
	  if (last_page - first_page + 1 < this.length) {
	    if (current_page < (total_pages / 2)) {
	      last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
	    } else {
	      first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
	    }
	  }
	
	  // This can be triggered if the user wants an odd number of pages.
	  if (last_page - first_page + 1 > this.length) {
	    // We want to move towards whatever extreme we're closest to at the time.
	    if (current_page > (total_pages / 2)) {
	      first_page++;
	    } else {
	      last_page--;
	    }
	  }
	
	  // First result on the page. This, along with the field below, can be used to
	  // do "showing x to y of z results" style things.
	  var first_result = this.per_page * (current_page - 1);
	  if (first_result < 0) { first_result = 0; }
	
	  // Last result on the page.
	  var last_result = (this.per_page * current_page) - 1;
	  if (last_result < 0) { last_result = 0; }
	  if (last_result > Math.max(total_results - 1, 0)) { last_result = Math.max(total_results - 1, 0); }
	
	  // GIMME THAT OBJECT
	  return {
	    total_pages: total_pages,
	    pages: Math.min(last_page - first_page + 1, total_pages),
	    current_page: current_page,
	    first_page: first_page,
	    last_page: last_page,
	    previous_page: current_page - 1,
	    next_page: current_page + 1,
	    has_previous_page: current_page > 1,
	    has_next_page: current_page < total_pages,
	    total_results: total_results,
	    results: Math.min(last_result - first_result + 1, total_results),
	    first_result: first_result,
	    last_result: last_result,
	  };
	};


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(662)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = prefix || defaultDelimiter
	    var pattern = capture || group
	    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	function restrictBacktrack(delimiter, prevText) {
	  if (!prevText || prevText.indexOf(delimiter) > -1) {
	    return '[^' + escapeString(delimiter) + ']+?'
	  }
	
	  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(670);
	var heyListen = __webpack_require__(211);
	var styleValueTypes = __webpack_require__(224);
	var sync = __webpack_require__(210);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var sync__default = /*#__PURE__*/_interopDefaultLegacy(sync);
	
	var clamp = function (min, max, v) {
	    return Math.min(Math.max(v, min), max);
	};
	
	var safeMin = 0.001;
	var minDuration = 0.01;
	var maxDuration = 10.0;
	var minDamping = 0.05;
	var maxDamping = 1;
	function findSpring(_a) {
	    var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
	    var envelope;
	    var derivative;
	    heyListen.warning(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
	    var dampingRatio = 1 - bounce;
	    dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
	    duration = clamp(minDuration, maxDuration, duration / 1000);
	    if (dampingRatio < 1) {
	        envelope = function (undampedFreq) {
	            var exponentialDecay = undampedFreq * dampingRatio;
	            var delta = exponentialDecay * duration;
	            var a = exponentialDecay - velocity;
	            var b = calcAngularFreq(undampedFreq, dampingRatio);
	            var c = Math.exp(-delta);
	            return safeMin - (a / b) * c;
	        };
	        derivative = function (undampedFreq) {
	            var exponentialDecay = undampedFreq * dampingRatio;
	            var delta = exponentialDecay * duration;
	            var d = delta * velocity + velocity;
	            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
	            var f = Math.exp(-delta);
	            var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
	            var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
	            return (factor * ((d - e) * f)) / g;
	        };
	    }
	    else {
	        envelope = function (undampedFreq) {
	            var a = Math.exp(-undampedFreq * duration);
	            var b = (undampedFreq - velocity) * duration + 1;
	            return -safeMin + a * b;
	        };
	        derivative = function (undampedFreq) {
	            var a = Math.exp(-undampedFreq * duration);
	            var b = (velocity - undampedFreq) * (duration * duration);
	            return a * b;
	        };
	    }
	    var initialGuess = 5 / duration;
	    var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
	    duration = duration * 1000;
	    if (isNaN(undampedFreq)) {
	        return {
	            stiffness: 100,
	            damping: 10,
	            duration: duration,
	        };
	    }
	    else {
	        var stiffness = Math.pow(undampedFreq, 2) * mass;
	        return {
	            stiffness: stiffness,
	            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
	            duration: duration,
	        };
	    }
	}
	var rootIterations = 12;
	function approximateRoot(envelope, derivative, initialGuess) {
	    var result = initialGuess;
	    for (var i = 1; i < rootIterations; i++) {
	        result = result - envelope(result) / derivative(result);
	    }
	    return result;
	}
	function calcAngularFreq(undampedFreq, dampingRatio) {
	    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
	}
	
	var durationKeys = ["duration", "bounce"];
	var physicsKeys = ["stiffness", "damping", "mass"];
	function isSpringType(options, keys) {
	    return keys.some(function (key) { return options[key] !== undefined; });
	}
	function getSpringOptions(options) {
	    var springOptions = tslib.__assign({ velocity: 0.0, stiffness: 100, damping: 10, mass: 1.0, isResolvedFromDuration: false }, options);
	    if (!isSpringType(options, physicsKeys) &&
	        isSpringType(options, durationKeys)) {
	        var derived = findSpring(options);
	        springOptions = tslib.__assign(tslib.__assign(tslib.__assign({}, springOptions), derived), { velocity: 0.0, mass: 1.0 });
	        springOptions.isResolvedFromDuration = true;
	    }
	    return springOptions;
	}
	function spring(_a) {
	    var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = tslib.__rest(_a, ["from", "to", "restSpeed", "restDelta"]);
	    var state = { done: false, value: from };
	    var _e = getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
	    var resolveSpring = zero;
	    var resolveVelocity = zero;
	    function createSpring() {
	        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
	        var initialDelta = to - from;
	        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
	        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
	        restDelta !== null && restDelta !== void 0 ? restDelta : (restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4);
	        if (dampingRatio < 1) {
	            var angularFreq_1 = calcAngularFreq(undampedAngularFreq, dampingRatio);
	            resolveSpring = function (t) {
	                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
	                return (to -
	                    envelope *
	                        (((initialVelocity +
	                            dampingRatio * undampedAngularFreq * initialDelta) /
	                            angularFreq_1) *
	                            Math.sin(angularFreq_1 * t) +
	                            initialDelta * Math.cos(angularFreq_1 * t)));
	            };
	            resolveVelocity = function (t) {
	                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
	                return (dampingRatio *
	                    undampedAngularFreq *
	                    envelope *
	                    ((Math.sin(angularFreq_1 * t) *
	                        (initialVelocity +
	                            dampingRatio *
	                                undampedAngularFreq *
	                                initialDelta)) /
	                        angularFreq_1 +
	                        initialDelta * Math.cos(angularFreq_1 * t)) -
	                    envelope *
	                        (Math.cos(angularFreq_1 * t) *
	                            (initialVelocity +
	                                dampingRatio *
	                                    undampedAngularFreq *
	                                    initialDelta) -
	                            angularFreq_1 *
	                                initialDelta *
	                                Math.sin(angularFreq_1 * t)));
	            };
	        }
	        else if (dampingRatio === 1) {
	            resolveSpring = function (t) {
	                return to -
	                    Math.exp(-undampedAngularFreq * t) *
	                        (initialDelta +
	                            (initialVelocity + undampedAngularFreq * initialDelta) *
	                                t);
	            };
	        }
	        else {
	            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
	            resolveSpring = function (t) {
	                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
	                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
	                return (to -
	                    (envelope *
	                        ((initialVelocity +
	                            dampingRatio * undampedAngularFreq * initialDelta) *
	                            Math.sinh(freqForT) +
	                            dampedAngularFreq_1 *
	                                initialDelta *
	                                Math.cosh(freqForT))) /
	                        dampedAngularFreq_1);
	            };
	        }
	    }
	    createSpring();
	    return {
	        next: function (t) {
	            var current = resolveSpring(t);
	            if (!isResolvedFromDuration) {
	                var currentVelocity = resolveVelocity(t) * 1000;
	                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
	                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
	                state.done =
	                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
	            }
	            else {
	                state.done = t >= duration;
	            }
	            state.value = state.done ? to : current;
	            return state;
	        },
	        flipTarget: function () {
	            var _a;
	            velocity = -velocity;
	            _a = [to, from], from = _a[0], to = _a[1];
	            createSpring();
	        },
	    };
	}
	spring.needsInterpolation = function (a, b) {
	    return typeof a === "string" || typeof b === "string";
	};
	var zero = function (_t) { return 0; };
	
	var progress = function (from, to, value) {
	    var toFromDifference = to - from;
	    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
	};
	
	var mix = function (from, to, progress) {
	    return -progress * from + progress * to + from;
	};
	
	var mixLinearColor = function (from, to, v) {
	    var fromExpo = from * from;
	    var toExpo = to * to;
	    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
	};
	var colorTypes = [styleValueTypes.hex, styleValueTypes.rgba, styleValueTypes.hsla];
	var getColorType = function (v) {
	    return colorTypes.find(function (type) { return type.test(v); });
	};
	var notAnimatable = function (color) {
	    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
	};
	var mixColor = function (from, to) {
	    var fromColorType = getColorType(from);
	    var toColorType = getColorType(to);
	    heyListen.invariant(!!fromColorType, notAnimatable(from));
	    heyListen.invariant(!!toColorType, notAnimatable(to));
	    heyListen.invariant(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
	    var fromColor = fromColorType.parse(from);
	    var toColor = toColorType.parse(to);
	    var blended = tslib.__assign({}, fromColor);
	    var mixFunc = fromColorType === styleValueTypes.hsla ? mix : mixLinearColor;
	    return function (v) {
	        for (var key in blended) {
	            if (key !== "alpha") {
	                blended[key] = mixFunc(fromColor[key], toColor[key], v);
	            }
	        }
	        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
	        return fromColorType.transform(blended);
	    };
	};
	
	var zeroPoint = {
	    x: 0,
	    y: 0,
	    z: 0
	};
	var isNum = function (v) { return typeof v === 'number'; };
	
	var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
	var pipe = function () {
	    var transformers = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        transformers[_i] = arguments[_i];
	    }
	    return transformers.reduce(combineFunctions);
	};
	
	function getMixer(origin, target) {
	    if (isNum(origin)) {
	        return function (v) { return mix(origin, target, v); };
	    }
	    else if (styleValueTypes.color.test(origin)) {
	        return mixColor(origin, target);
	    }
	    else {
	        return mixComplex(origin, target);
	    }
	}
	var mixArray = function (from, to) {
	    var output = tslib.__spreadArray([], from);
	    var numValues = output.length;
	    var blendValue = from.map(function (fromThis, i) { return getMixer(fromThis, to[i]); });
	    return function (v) {
	        for (var i = 0; i < numValues; i++) {
	            output[i] = blendValue[i](v);
	        }
	        return output;
	    };
	};
	var mixObject = function (origin, target) {
	    var output = tslib.__assign(tslib.__assign({}, origin), target);
	    var blendValue = {};
	    for (var key in output) {
	        if (origin[key] !== undefined && target[key] !== undefined) {
	            blendValue[key] = getMixer(origin[key], target[key]);
	        }
	    }
	    return function (v) {
	        for (var key in blendValue) {
	            output[key] = blendValue[key](v);
	        }
	        return output;
	    };
	};
	function analyse(value) {
	    var parsed = styleValueTypes.complex.parse(value);
	    var numValues = parsed.length;
	    var numNumbers = 0;
	    var numRGB = 0;
	    var numHSL = 0;
	    for (var i = 0; i < numValues; i++) {
	        if (numNumbers || typeof parsed[i] === "number") {
	            numNumbers++;
	        }
	        else {
	            if (parsed[i].hue !== undefined) {
	                numHSL++;
	            }
	            else {
	                numRGB++;
	            }
	        }
	    }
	    return { parsed: parsed, numNumbers: numNumbers, numRGB: numRGB, numHSL: numHSL };
	}
	var mixComplex = function (origin, target) {
	    var template = styleValueTypes.complex.createTransformer(target);
	    var originStats = analyse(origin);
	    var targetStats = analyse(target);
	    heyListen.invariant(originStats.numHSL === targetStats.numHSL &&
	        originStats.numRGB === targetStats.numRGB &&
	        originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
	    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
	};
	
	var mixNumber = function (from, to) { return function (p) { return mix(from, to, p); }; };
	function detectMixerFactory(v) {
	    if (typeof v === 'number') {
	        return mixNumber;
	    }
	    else if (typeof v === 'string') {
	        if (styleValueTypes.color.test(v)) {
	            return mixColor;
	        }
	        else {
	            return mixComplex;
	        }
	    }
	    else if (Array.isArray(v)) {
	        return mixArray;
	    }
	    else if (typeof v === 'object') {
	        return mixObject;
	    }
	}
	function createMixers(output, ease, customMixer) {
	    var mixers = [];
	    var mixerFactory = customMixer || detectMixerFactory(output[0]);
	    var numMixers = output.length - 1;
	    for (var i = 0; i < numMixers; i++) {
	        var mixer = mixerFactory(output[i], output[i + 1]);
	        if (ease) {
	            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
	            mixer = pipe(easingFunction, mixer);
	        }
	        mixers.push(mixer);
	    }
	    return mixers;
	}
	function fastInterpolate(_a, _b) {
	    var from = _a[0], to = _a[1];
	    var mixer = _b[0];
	    return function (v) { return mixer(progress(from, to, v)); };
	}
	function slowInterpolate(input, mixers) {
	    var inputLength = input.length;
	    var lastInputIndex = inputLength - 1;
	    return function (v) {
	        var mixerIndex = 0;
	        var foundMixerIndex = false;
	        if (v <= input[0]) {
	            foundMixerIndex = true;
	        }
	        else if (v >= input[lastInputIndex]) {
	            mixerIndex = lastInputIndex - 1;
	            foundMixerIndex = true;
	        }
	        if (!foundMixerIndex) {
	            var i = 1;
	            for (; i < inputLength; i++) {
	                if (input[i] > v || i === lastInputIndex) {
	                    break;
	                }
	            }
	            mixerIndex = i - 1;
	        }
	        var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
	        return mixers[mixerIndex](progressInRange);
	    };
	}
	function interpolate(input, output, _a) {
	    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
	    var inputLength = input.length;
	    heyListen.invariant(inputLength === output.length, 'Both input and output ranges must be the same length');
	    heyListen.invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
	    if (input[0] > input[inputLength - 1]) {
	        input = [].concat(input);
	        output = [].concat(output);
	        input.reverse();
	        output.reverse();
	    }
	    var mixers = createMixers(output, ease, mixer);
	    var interpolator = inputLength === 2
	        ? fastInterpolate(input, mixers)
	        : slowInterpolate(input, mixers);
	    return isClamp
	        ? function (v) { return interpolator(clamp(input[0], input[inputLength - 1], v)); }
	        : interpolator;
	}
	
	var reverseEasing = function (easing) { return function (p) { return 1 - easing(1 - p); }; };
	var mirrorEasing = function (easing) { return function (p) {
	    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
	}; };
	var createExpoIn = function (power) { return function (p) { return Math.pow(p, power); }; };
	var createBackIn = function (power) { return function (p) {
	    return p * p * ((power + 1) * p - power);
	}; };
	var createAnticipate = function (power) {
	    var backEasing = createBackIn(power);
	    return function (p) {
	        return (p *= 2) < 1
	            ? 0.5 * backEasing(p)
	            : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
	    };
	};
	
	var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
	var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
	var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
	var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
	var linear = function (p) { return p; };
	var easeIn = createExpoIn(2);
	var easeOut = reverseEasing(easeIn);
	var easeInOut = mirrorEasing(easeIn);
	var circIn = function (p) { return 1 - Math.sin(Math.acos(p)); };
	var circOut = reverseEasing(circIn);
	var circInOut = mirrorEasing(circOut);
	var backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
	var backOut = reverseEasing(backIn);
	var backInOut = mirrorEasing(backIn);
	var anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
	var ca = 4356.0 / 361.0;
	var cb = 35442.0 / 1805.0;
	var cc = 16061.0 / 1805.0;
	var bounceOut = function (p) {
	    if (p === 1 || p === 0)
	        return p;
	    var p2 = p * p;
	    return p < BOUNCE_FIRST_THRESHOLD
	        ? 7.5625 * p2
	        : p < BOUNCE_SECOND_THRESHOLD
	            ? 9.075 * p2 - 9.9 * p + 3.4
	            : p < BOUNCE_THIRD_THRESHOLD
	                ? ca * p2 - cb * p + cc
	                : 10.8 * p * p - 20.52 * p + 10.72;
	};
	var bounceIn = reverseEasing(bounceOut);
	var bounceInOut = function (p) {
	    return p < 0.5
	        ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0))
	        : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
	};
	
	function defaultEasing(values, easing) {
	    return values.map(function () { return easing || easeInOut; }).splice(0, values.length - 1);
	}
	function defaultOffset(values) {
	    var numValues = values.length;
	    return values.map(function (_value, i) {
	        return i !== 0 ? i / (numValues - 1) : 0;
	    });
	}
	function convertOffsetToTimes(offset, duration) {
	    return offset.map(function (o) { return o * duration; });
	}
	function keyframes(_a) {
	    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
	    var state = { done: false, value: from };
	    var values = Array.isArray(to) ? to : [from, to];
	    var times = convertOffsetToTimes(offset && offset.length === values.length
	        ? offset
	        : defaultOffset(values), duration);
	    function createInterpolator() {
	        return interpolate(times, values, {
	            ease: Array.isArray(ease) ? ease : defaultEasing(values, ease),
	        });
	    }
	    var interpolator = createInterpolator();
	    return {
	        next: function (t) {
	            state.value = interpolator(t);
	            state.done = t >= duration;
	            return state;
	        },
	        flipTarget: function () {
	            values.reverse();
	            interpolator = createInterpolator();
	        },
	    };
	}
	
	function decay(_a) {
	    var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
	    var state = { done: false, value: from };
	    var amplitude = power * velocity;
	    var ideal = from + amplitude;
	    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
	    if (target !== ideal)
	        amplitude = target - from;
	    return {
	        next: function (t) {
	            var delta = -amplitude * Math.exp(-t / timeConstant);
	            state.done = !(delta > restDelta || delta < -restDelta);
	            state.value = state.done ? target : target + delta;
	            return state;
	        },
	        flipTarget: function () { },
	    };
	}
	
	var types = { keyframes: keyframes, spring: spring, decay: decay };
	function detectAnimationFromOptions(config) {
	    if (Array.isArray(config.to)) {
	        return keyframes;
	    }
	    else if (types[config.type]) {
	        return types[config.type];
	    }
	    var keys = new Set(Object.keys(config));
	    if (keys.has("ease") ||
	        (keys.has("duration") && !keys.has("dampingRatio"))) {
	        return keyframes;
	    }
	    else if (keys.has("dampingRatio") ||
	        keys.has("stiffness") ||
	        keys.has("mass") ||
	        keys.has("damping") ||
	        keys.has("restSpeed") ||
	        keys.has("restDelta")) {
	        return spring;
	    }
	    return keyframes;
	}
	
	function loopElapsed(elapsed, duration, delay) {
	    if (delay === void 0) { delay = 0; }
	    return elapsed - duration - delay;
	}
	function reverseElapsed(elapsed, duration, delay, isForwardPlayback) {
	    if (delay === void 0) { delay = 0; }
	    if (isForwardPlayback === void 0) { isForwardPlayback = true; }
	    return isForwardPlayback
	        ? loopElapsed(duration + -elapsed, duration, delay)
	        : duration - (elapsed - duration) + delay;
	}
	function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
	    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
	}
	
	var framesync = function (update) {
	    var passTimestamp = function (_a) {
	        var delta = _a.delta;
	        return update(delta);
	    };
	    return {
	        start: function () { return sync__default['default'].update(passTimestamp, true); },
	        stop: function () { return sync.cancelSync.update(passTimestamp); },
	    };
	};
	function animate(_a) {
	    var _b, _c;
	    var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = tslib.__rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
	    var to = options.to;
	    var driverControls;
	    var repeatCount = 0;
	    var computedDuration = options.duration;
	    var latest;
	    var isComplete = false;
	    var isForwardPlayback = true;
	    var interpolateFromNumber;
	    var animator = detectAnimationFromOptions(options);
	    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
	        interpolateFromNumber = interpolate([0, 100], [from, to], {
	            clamp: false,
	        });
	        from = 0;
	        to = 100;
	    }
	    var animation = animator(tslib.__assign(tslib.__assign({}, options), { from: from, to: to }));
	    function repeat() {
	        repeatCount++;
	        if (repeatType === "reverse") {
	            isForwardPlayback = repeatCount % 2 === 0;
	            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
	        }
	        else {
	            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
	            if (repeatType === "mirror")
	                animation.flipTarget();
	        }
	        isComplete = false;
	        onRepeat && onRepeat();
	    }
	    function complete() {
	        driverControls.stop();
	        onComplete && onComplete();
	    }
	    function update(delta) {
	        if (!isForwardPlayback)
	            delta = -delta;
	        elapsed += delta;
	        if (!isComplete) {
	            var state = animation.next(Math.max(0, elapsed));
	            latest = state.value;
	            if (interpolateFromNumber)
	                latest = interpolateFromNumber(latest);
	            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
	        }
	        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
	        if (isComplete) {
	            if (repeatCount === 0)
	                computedDuration !== null && computedDuration !== void 0 ? computedDuration : (computedDuration = elapsed);
	            if (repeatCount < repeatMax) {
	                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
	            }
	            else {
	                complete();
	            }
	        }
	    }
	    function play() {
	        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
	        driverControls = driver(update);
	        driverControls.start();
	    }
	    autoplay && play();
	    return {
	        stop: function () {
	            onStop === null || onStop === void 0 ? void 0 : onStop();
	            driverControls.stop();
	        },
	    };
	}
	
	function velocityPerSecond(velocity, frameDuration) {
	    return frameDuration ? velocity * (1000 / frameDuration) : 0;
	}
	
	function inertia(_a) {
	    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
	    var currentAnimation;
	    function isOutOfBounds(v) {
	        return (min !== undefined && v < min) || (max !== undefined && v > max);
	    }
	    function boundaryNearest(v) {
	        if (min === undefined)
	            return max;
	        if (max === undefined)
	            return min;
	        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
	    }
	    function startAnimation(options) {
	        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
	        currentAnimation = animate(tslib.__assign(tslib.__assign({}, options), { driver: driver, onUpdate: function (v) {
	                var _a;
	                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
	                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
	            }, onComplete: onComplete }));
	    }
	    function startSpring(options) {
	        startAnimation(tslib.__assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta: restDelta }, options));
	    }
	    if (isOutOfBounds(from)) {
	        startSpring({ from: from, velocity: velocity, to: boundaryNearest(from) });
	    }
	    else {
	        var target = power * velocity + from;
	        if (typeof modifyTarget !== "undefined")
	            target = modifyTarget(target);
	        var boundary_1 = boundaryNearest(target);
	        var heading_1 = boundary_1 === min ? -1 : 1;
	        var prev_1;
	        var current_1;
	        var checkBoundary = function (v) {
	            prev_1 = current_1;
	            current_1 = v;
	            velocity = velocityPerSecond(v - prev_1, sync.getFrameData().delta);
	            if ((heading_1 === 1 && v > boundary_1) ||
	                (heading_1 === -1 && v < boundary_1)) {
	                startSpring({ from: v, to: boundary_1, velocity: velocity });
	            }
	        };
	        startAnimation({
	            type: "decay",
	            from: from,
	            velocity: velocity,
	            timeConstant: timeConstant,
	            power: power,
	            restDelta: restDelta,
	            modifyTarget: modifyTarget,
	            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
	        });
	    }
	    return {
	        stop: function () { return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(); },
	    };
	}
	
	var radiansToDegrees = function (radians) { return (radians * 180) / Math.PI; };
	
	var angle = function (a, b) {
	    if (b === void 0) { b = zeroPoint; }
	    return radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
	};
	
	var applyOffset = function (from, to) {
	    var hasReceivedFrom = true;
	    if (to === undefined) {
	        to = from;
	        hasReceivedFrom = false;
	    }
	    return function (v) {
	        if (hasReceivedFrom) {
	            return v - from + to;
	        }
	        else {
	            from = v;
	            hasReceivedFrom = true;
	            return to;
	        }
	    };
	};
	
	var identity = function (v) { return v; };
	var createAttractor = function (alterDisplacement) {
	    if (alterDisplacement === void 0) { alterDisplacement = identity; }
	    return function (constant, origin, v) {
	        var displacement = origin - v;
	        var springModifiedDisplacement = -(0 - constant + 1) * (0 - alterDisplacement(Math.abs(displacement)));
	        return displacement <= 0
	            ? origin + springModifiedDisplacement
	            : origin - springModifiedDisplacement;
	    };
	};
	var attract = createAttractor();
	var attractExpo = createAttractor(Math.sqrt);
	
	var degreesToRadians = function (degrees) { return (degrees * Math.PI) / 180; };
	
	var isPoint = function (point) {
	    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
	};
	
	var isPoint3D = function (point) {
	    return isPoint(point) && point.hasOwnProperty('z');
	};
	
	var distance1D = function (a, b) { return Math.abs(a - b); };
	function distance(a, b) {
	    if (isNum(a) && isNum(b)) {
	        return distance1D(a, b);
	    }
	    else if (isPoint(a) && isPoint(b)) {
	        var xDelta = distance1D(a.x, b.x);
	        var yDelta = distance1D(a.y, b.y);
	        var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
	        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
	    }
	}
	
	var pointFromVector = function (origin, angle, distance) {
	    angle = degreesToRadians(angle);
	    return {
	        x: distance * Math.cos(angle) + origin.x,
	        y: distance * Math.sin(angle) + origin.y
	    };
	};
	
	var toDecimal = function (num, precision) {
	    if (precision === void 0) { precision = 2; }
	    precision = Math.pow(10, precision);
	    return Math.round(num * precision) / precision;
	};
	
	var smoothFrame = function (prevValue, nextValue, duration, smoothing) {
	    if (smoothing === void 0) { smoothing = 0; }
	    return toDecimal(prevValue +
	        (duration * (nextValue - prevValue)) / Math.max(smoothing, duration));
	};
	
	var smooth = function (strength) {
	    if (strength === void 0) { strength = 50; }
	    var previousValue = 0;
	    var lastUpdated = 0;
	    return function (v) {
	        var currentFramestamp = sync.getFrameData().timestamp;
	        var timeDelta = currentFramestamp !== lastUpdated ? currentFramestamp - lastUpdated : 0;
	        var newValue = timeDelta
	            ? smoothFrame(previousValue, v, timeDelta, strength)
	            : previousValue;
	        lastUpdated = currentFramestamp;
	        previousValue = newValue;
	        return newValue;
	    };
	};
	
	var snap = function (points) {
	    if (typeof points === 'number') {
	        return function (v) { return Math.round(v / points) * points; };
	    }
	    else {
	        var i_1 = 0;
	        var numPoints_1 = points.length;
	        return function (v) {
	            var lastDistance = Math.abs(points[0] - v);
	            for (i_1 = 1; i_1 < numPoints_1; i_1++) {
	                var point = points[i_1];
	                var distance = Math.abs(point - v);
	                if (distance === 0)
	                    return point;
	                if (distance > lastDistance)
	                    return points[i_1 - 1];
	                if (i_1 === numPoints_1 - 1)
	                    return point;
	                lastDistance = distance;
	            }
	        };
	    }
	};
	
	function velocityPerFrame(xps, frameDuration) {
	    return xps / (1000 / frameDuration);
	}
	
	var wrap = function (min, max, v) {
	    var rangeSize = max - min;
	    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
	};
	
	var a = function (a1, a2) { return 1.0 - 3.0 * a2 + 3.0 * a1; };
	var b = function (a1, a2) { return 3.0 * a2 - 6.0 * a1; };
	var c = function (a1) { return 3.0 * a1; };
	var calcBezier = function (t, a1, a2) {
	    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
	};
	var getSlope = function (t, a1, a2) {
	    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
	};
	var subdivisionPrecision = 0.0000001;
	var subdivisionMaxIterations = 10;
	function binarySubdivide(aX, aA, aB, mX1, mX2) {
	    var currentX;
	    var currentT;
	    var i = 0;
	    do {
	        currentT = aA + (aB - aA) / 2.0;
	        currentX = calcBezier(currentT, mX1, mX2) - aX;
	        if (currentX > 0.0) {
	            aB = currentT;
	        }
	        else {
	            aA = currentT;
	        }
	    } while (Math.abs(currentX) > subdivisionPrecision &&
	        ++i < subdivisionMaxIterations);
	    return currentT;
	}
	var newtonIterations = 8;
	var newtonMinSlope = 0.001;
	function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	    for (var i = 0; i < newtonIterations; ++i) {
	        var currentSlope = getSlope(aGuessT, mX1, mX2);
	        if (currentSlope === 0.0) {
	            return aGuessT;
	        }
	        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	        aGuessT -= currentX / currentSlope;
	    }
	    return aGuessT;
	}
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	function cubicBezier(mX1, mY1, mX2, mY2) {
	    if (mX1 === mY1 && mX2 === mY2)
	        return linear;
	    var sampleValues = new Float32Array(kSplineTableSize);
	    for (var i = 0; i < kSplineTableSize; ++i) {
	        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	    function getTForX(aX) {
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = kSplineTableSize - 1;
	        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	            intervalStart += kSampleStepSize;
	        }
	        --currentSample;
	        var dist = (aX - sampleValues[currentSample]) /
	            (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	        var guessForT = intervalStart + dist * kSampleStepSize;
	        var initialSlope = getSlope(guessForT, mX1, mX2);
	        if (initialSlope >= newtonMinSlope) {
	            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	        }
	        else if (initialSlope === 0.0) {
	            return guessForT;
	        }
	        else {
	            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	        }
	    }
	    return function (t) {
	        return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
	    };
	}
	
	var steps = function (steps, direction) {
	    if (direction === void 0) { direction = 'end'; }
	    return function (progress) {
	        progress =
	            direction === 'end' ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
	        var expanded = progress * steps;
	        var rounded = direction === 'end' ? Math.floor(expanded) : Math.ceil(expanded);
	        return clamp(0, 1, rounded / steps);
	    };
	};
	
	exports.angle = angle;
	exports.animate = animate;
	exports.anticipate = anticipate;
	exports.applyOffset = applyOffset;
	exports.attract = attract;
	exports.attractExpo = attractExpo;
	exports.backIn = backIn;
	exports.backInOut = backInOut;
	exports.backOut = backOut;
	exports.bounceIn = bounceIn;
	exports.bounceInOut = bounceInOut;
	exports.bounceOut = bounceOut;
	exports.circIn = circIn;
	exports.circInOut = circInOut;
	exports.circOut = circOut;
	exports.clamp = clamp;
	exports.createAnticipate = createAnticipate;
	exports.createAttractor = createAttractor;
	exports.createBackIn = createBackIn;
	exports.createExpoIn = createExpoIn;
	exports.cubicBezier = cubicBezier;
	exports.decay = decay;
	exports.degreesToRadians = degreesToRadians;
	exports.distance = distance;
	exports.easeIn = easeIn;
	exports.easeInOut = easeInOut;
	exports.easeOut = easeOut;
	exports.inertia = inertia;
	exports.interpolate = interpolate;
	exports.isPoint = isPoint;
	exports.isPoint3D = isPoint3D;
	exports.keyframes = keyframes;
	exports.linear = linear;
	exports.mirrorEasing = mirrorEasing;
	exports.mix = mix;
	exports.mixColor = mixColor;
	exports.mixComplex = mixComplex;
	exports.pipe = pipe;
	exports.pointFromVector = pointFromVector;
	exports.progress = progress;
	exports.radiansToDegrees = radiansToDegrees;
	exports.reverseEasing = reverseEasing;
	exports.smooth = smooth;
	exports.smoothFrame = smoothFrame;
	exports.snap = snap;
	exports.spring = spring;
	exports.steps = steps;
	exports.toDecimal = toDecimal;
	exports.velocityPerFrame = velocityPerFrame;
	exports.velocityPerSecond = velocityPerSecond;
	exports.wrap = wrap;


/***/ },
/* 670 */
29,
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(216);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(216);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(674);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 674 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(116),r=__webpack_require__(699);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.iconList = void 0;
	var react_1 = __webpack_require__(1);
	var IcoMoon = function (_a) {
	    var iconSet = _a.iconSet, icon = _a.icon, size = _a.size, title = _a.title, disableFill = _a.disableFill, removeInlineStyle = _a.removeInlineStyle, native = _a.native, SvgComponent = _a.SvgComponent, PathComponent = _a.PathComponent, props = __rest(_a, ["iconSet", "icon", "size", "title", "disableFill", "removeInlineStyle", "native", "SvgComponent", "PathComponent"]);
	    // Return type is kept as `any` to match the published 2.x typings.
	    if (!iconSet || !icon)
	        return null;
	    var currentIcon = iconSet.icons.find(function (item) { return item.properties.name === icon; });
	    if (!currentIcon)
	        return null;
	    var initialStyle = {
	        display: "inline-block",
	        stroke: "currentColor",
	        fill: "currentColor",
	    };
	    if (native) {
	        initialStyle.display = "flex";
	        initialStyle.flexDirection = "row";
	        initialStyle.flexWrap = "wrap";
	    }
	    var computedStyle = __assign(__assign(__assign({}, (removeInlineStyle ? {} : initialStyle)), (size ? { width: size, height: size } : {})), (props.style || {}));
	    var _b = currentIcon.icon.width, width = _b === void 0 ? "1024" : _b;
	    var viewBox = "0 0 ".concat(width, " 1024");
	    var children = currentIcon.icon.paths.map(function (path, index) {
	        var _a;
	        var attrs = (_a = currentIcon.icon.attrs) === null || _a === void 0 ? void 0 : _a[index];
	        var pathProps = __assign({ d: path, key: icon + index }, (!disableFill && attrs ? attrs : {}));
	        return (0, react_1.createElement)(PathComponent || "path", pathProps);
	    });
	    if (title && !native) {
	        children.push((0, react_1.createElement)("title", { key: title }, title));
	    }
	    return (0, react_1.createElement)(SvgComponent || "svg", __assign(__assign({}, props), { viewBox: viewBox, style: computedStyle }), children);
	};
	var iconList = function (iconSet) {
	    if (!iconSet || !Array.isArray(iconSet.icons))
	        return null;
	    return iconSet.icons.map(function (icon) { return icon.properties.name; });
	};
	exports.iconList = iconList;
	exports.default = IcoMoon;
	//# sourceMappingURL=index.js.map

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(1)),reactDom=__webpack_require__(40);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return!u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,i;return!isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return!1;var t,n;return(isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h)}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop)},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop()},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null)},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e)},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t)},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t)}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)})},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e)},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return!0}catch(r){}return!f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end)},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else{var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end)}f.runSaveSelectionLoop()}isFunction(f.props.onFocus)&&f.props.onFocus(e)},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e)}isFunction(f.props.onBlur)&&f.props.onBlur(e)},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd()}};document.addEventListener("mouseup",r)}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e)},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""))},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);module.exports=InputElement;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var useIntl_1 = (0, tslib_1.__importDefault)(__webpack_require__(45));
	var FormattedDateTimeRange = function (props) {
	    var intl = (0, useIntl_1.default)();
	    var from = props.from, to = props.to, children = props.children, formatProps = (0, tslib_1.__rest)(props, ["from", "to", "children"]);
	    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
	    if (typeof children === 'function') {
	        return children(formattedValue);
	    }
	    var Text = intl.textComponent || React.Fragment;
	    return React.createElement(Text, null, formattedValue);
	};
	FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
	exports.default = FormattedDateTimeRange;


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var useIntl_1 = (0, tslib_1.__importDefault)(__webpack_require__(45));
	var utils_1 = __webpack_require__(64);
	function areEqual(prevProps, nextProps) {
	    var values = prevProps.values, otherProps = (0, tslib_1.__rest)(prevProps, ["values"]);
	    var nextValues = nextProps.values, nextOtherProps = (0, tslib_1.__rest)(nextProps, ["values"]);
	    return ((0, utils_1.shallowEqual)(nextValues, values) &&
	        (0, utils_1.shallowEqual)(otherProps, nextOtherProps));
	}
	function FormattedMessage(props) {
	    var intl = (0, useIntl_1.default)();
	    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? React.Fragment : _a;
	    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
	    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	    var nodes = formatMessage(descriptor, values, {
	        ignoreTag: ignoreTag,
	    });
	    if (typeof children === 'function') {
	        return children(Array.isArray(nodes) ? nodes : [nodes]);
	    }
	    if (Component) {
	        return React.createElement(Component, null, React.Children.toArray(nodes));
	    }
	    return React.createElement(React.Fragment, null, nodes);
	}
	FormattedMessage.displayName = 'FormattedMessage';
	var MemoizedFormattedMessage = React.memo(FormattedMessage, areEqual);
	MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
	exports.default = MemoizedFormattedMessage;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var useIntl_1 = (0, tslib_1.__importDefault)(__webpack_require__(45));
	var FormattedPlural = function (props) {
	    var _a = (0, useIntl_1.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
	    var value = props.value, other = props.other, children = props.children;
	    var pluralCategory = formatPlural(value, props);
	    var formattedPlural = props[pluralCategory] || other;
	    if (typeof children === 'function') {
	        return children(formattedPlural);
	    }
	    if (Text) {
	        return React.createElement(Text, null, formattedPlural);
	    }
	    // Work around @types/react where React.FC cannot return string
	    return formattedPlural;
	};
	FormattedPlural.defaultProps = {
	    type: 'cardinal',
	};
	FormattedPlural.displayName = 'FormattedPlural';
	exports.default = FormattedPlural;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.createIntl = void 0;
	var tslib_1 = __webpack_require__(29);
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var injectIntl_1 = __webpack_require__(117);
	var utils_1 = __webpack_require__(64);
	var intl_1 = __webpack_require__(73);
	var intl_messageformat_1 = __webpack_require__(39);
	function processIntlConfig(config) {
	    return {
	        locale: config.locale,
	        timeZone: config.timeZone,
	        fallbackOnEmptyString: config.fallbackOnEmptyString,
	        formats: config.formats,
	        textComponent: config.textComponent,
	        messages: config.messages,
	        defaultLocale: config.defaultLocale,
	        defaultFormats: config.defaultFormats,
	        onError: config.onError,
	        onWarn: config.onWarn,
	        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
	        defaultRichTextElements: config.defaultRichTextElements,
	    };
	}
	function assignUniqueKeysToFormatXMLElementFnArgument(values) {
	    if (!values) {
	        return values;
	    }
	    return Object.keys(values).reduce(function (acc, k) {
	        var v = values[k];
	        acc[k] = (0, intl_messageformat_1.isFormatXMLElementFn)(v)
	            ? (0, utils_1.assignUniqueKeysToParts)(v)
	            : v;
	        return acc;
	    }, {});
	}
	var formatMessage = function (config, formatters, descriptor, rawValues) {
	    var rest = [];
	    for (var _i = 4; _i < arguments.length; _i++) {
	        rest[_i - 4] = arguments[_i];
	    }
	    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
	    var chunks = intl_1.formatMessage.apply(void 0, (0, tslib_1.__spreadArray)([config,
	        formatters,
	        descriptor,
	        values], rest, false));
	    if (Array.isArray(chunks)) {
	        return React.Children.toArray(chunks);
	    }
	    return chunks;
	};
	/**
	 * Create intl object
	 * @param config intl config
	 * @param cache cache for formatter instances to prevent memory leak
	 */
	var createIntl = function (_a, cache) {
	    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, tslib_1.__rest)(_a, ["defaultRichTextElements"]);
	    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
	    var coreIntl = (0, intl_1.createIntl)((0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, utils_1.DEFAULT_INTL_CONFIG), config), { defaultRichTextElements: defaultRichTextElements }), cache);
	    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, coreIntl), { formatMessage: formatMessage.bind(null, {
	            locale: coreIntl.locale,
	            timeZone: coreIntl.timeZone,
	            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
	            formats: coreIntl.formats,
	            defaultLocale: coreIntl.defaultLocale,
	            defaultFormats: coreIntl.defaultFormats,
	            messages: coreIntl.messages,
	            onError: coreIntl.onError,
	            defaultRichTextElements: defaultRichTextElements,
	        }, coreIntl.formatters) });
	};
	exports.createIntl = createIntl;
	var IntlProvider = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(IntlProvider, _super);
	    function IntlProvider() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cache = (0, intl_1.createIntlCache)();
	        _this.state = {
	            cache: _this.cache,
	            intl: (0, exports.createIntl)(processIntlConfig(_this.props), _this.cache),
	            prevConfig: processIntlConfig(_this.props),
	        };
	        return _this;
	    }
	    IntlProvider.getDerivedStateFromProps = function (props, _a) {
	        var prevConfig = _a.prevConfig, cache = _a.cache;
	        var config = processIntlConfig(props);
	        if (!(0, utils_1.shallowEqual)(prevConfig, config)) {
	            return {
	                intl: (0, exports.createIntl)(config, cache),
	                prevConfig: config,
	            };
	        }
	        return null;
	    };
	    IntlProvider.prototype.render = function () {
	        (0, utils_1.invariantIntlContext)(this.state.intl);
	        return React.createElement(injectIntl_1.Provider, { value: this.state.intl }, this.props.children);
	    };
	    IntlProvider.displayName = 'IntlProvider';
	    IntlProvider.defaultProps = utils_1.DEFAULT_INTL_CONFIG;
	    return IntlProvider;
	}(React.PureComponent));
	exports.default = IntlProvider;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(29);
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var React = (0, tslib_1.__importStar)(__webpack_require__(1));
	var ecma402_abstract_1 = __webpack_require__(68);
	var useIntl_1 = (0, tslib_1.__importDefault)(__webpack_require__(45));
	var MINUTE = 60;
	var HOUR = 60 * 60;
	var DAY = 60 * 60 * 24;
	function selectUnit(seconds) {
	    var absValue = Math.abs(seconds);
	    if (absValue < MINUTE) {
	        return 'second';
	    }
	    if (absValue < HOUR) {
	        return 'minute';
	    }
	    if (absValue < DAY) {
	        return 'hour';
	    }
	    return 'day';
	}
	function getDurationInSeconds(unit) {
	    switch (unit) {
	        case 'second':
	            return 1;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        default:
	            return DAY;
	    }
	}
	function valueToSeconds(value, unit) {
	    if (!value) {
	        return 0;
	    }
	    switch (unit) {
	        case 'second':
	            return value;
	        case 'minute':
	            return value * MINUTE;
	        default:
	            return value * HOUR;
	    }
	}
	var INCREMENTABLE_UNITS = [
	    'second',
	    'minute',
	    'hour',
	];
	function canIncrement(unit) {
	    if (unit === void 0) { unit = 'second'; }
	    return INCREMENTABLE_UNITS.indexOf(unit) > -1;
	}
	var SimpleFormattedRelativeTime = function (props) {
	    var _a = (0, useIntl_1.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
	    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, tslib_1.__rest)(props, ["children", "value", "unit"]);
	    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
	    if (typeof children === 'function') {
	        return children(formattedRelativeTime);
	    }
	    if (Text) {
	        return React.createElement(Text, null, formattedRelativeTime);
	    }
	    return React.createElement(React.Fragment, null, formattedRelativeTime);
	};
	var FormattedRelativeTime = function (_a) {
	    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, tslib_1.__rest)(_a, ["value", "unit", "updateIntervalInSeconds"]);
	    (0, ecma402_abstract_1.invariant)(!updateIntervalInSeconds ||
	        !!(updateIntervalInSeconds && canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
	    var _b = React.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
	    var _c = React.useState(0), prevValue = _c[0], setPrevValue = _c[1];
	    var _d = React.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
	    var updateTimer;
	    if (unit !== prevUnit || value !== prevValue) {
	        setPrevValue(value || 0);
	        setPrevUnit(unit);
	        setCurrentValueInSeconds(canIncrement(unit) ? valueToSeconds(value, unit) : 0);
	    }
	    React.useEffect(function () {
	        function clearUpdateTimer() {
	            clearTimeout(updateTimer);
	        }
	        clearUpdateTimer();
	        // If there's no interval and we cannot increment this unit, do nothing
	        if (!updateIntervalInSeconds || !canIncrement(unit)) {
	            return clearUpdateTimer;
	        }
	        // Figure out the next interesting time
	        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
	        var nextUnit = selectUnit(nextValueInSeconds);
	        // We've reached the max auto incrementable unit, don't schedule another update
	        if (nextUnit === 'day') {
	            return clearUpdateTimer;
	        }
	        var unitDuration = getDurationInSeconds(nextUnit);
	        var remainder = nextValueInSeconds % unitDuration;
	        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
	        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds
	            ? prevInterestingValueInSeconds - unitDuration
	            : prevInterestingValueInSeconds;
	        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
	        if (currentValueInSeconds !== nextInterestingValueInSeconds) {
	            updateTimer = setTimeout(function () { return setCurrentValueInSeconds(nextInterestingValueInSeconds); }, delayInSeconds * 1e3);
	        }
	        return clearUpdateTimer;
	    }, [currentValueInSeconds, updateIntervalInSeconds, unit]);
	    var currentValue = value || 0;
	    var currentUnit = unit;
	    if (canIncrement(unit) &&
	        typeof currentValueInSeconds === 'number' &&
	        updateIntervalInSeconds) {
	        currentUnit = selectUnit(currentValueInSeconds);
	        var unitDuration = getDurationInSeconds(currentUnit);
	        currentValue = Math.round(currentValueInSeconds / unitDuration);
	    }
	    return (React.createElement(SimpleFormattedRelativeTime, (0, tslib_1.__assign)({ value: currentValue, unit: currentUnit }, otherProps)));
	};
	FormattedRelativeTime.displayName = 'FormattedRelativeTime';
	FormattedRelativeTime.defaultProps = {
	    value: 0,
	    unit: 'second',
	};
	exports.default = FormattedRelativeTime;


/***/ },
/* 683 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(1));
	var _propTypes = _interopRequireDefault(__webpack_require__(23));
	var _classnames = _interopRequireDefault(__webpack_require__(194));
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	var Page = exports["default"] = /*#__PURE__*/function (_Component) {
	  function Page() {
	    _classCallCheck(this, Page);
	    return _callSuper(this, Page, arguments);
	  }
	  _inherits(Page, _Component);
	  return _createClass(Page, [{
	    key: "handleClick",
	    value: function handleClick(e) {
	      var _this$props = this.props,
	        isDisabled = _this$props.isDisabled,
	        pageNumber = _this$props.pageNumber,
	        href = _this$props.href,
	        control = _this$props.control;
	      // Leave modified clicks on real URLs to the browser (new tab, new window,
	      // download), like Next.js and React Router links.
	      var opensElsewhere = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
	      if (opensElsewhere && href && href !== "#" && !isDisabled) {
	        return;
	      }
	      e.preventDefault();
	      if (isDisabled) {
	        return;
	      }
	      this.props.onClick(pageNumber, control);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	        pageText = _this$props2.pageText,
	        activeClass = _this$props2.activeClass,
	        itemClass = _this$props2.itemClass,
	        linkClass = _this$props2.linkClass,
	        activeLinkClass = _this$props2.activeLinkClass,
	        inactiveClass = _this$props2.inactiveClass,
	        inactiveLinkClass = _this$props2.inactiveLinkClass,
	        disabledClass = _this$props2.disabledClass,
	        isActive = _this$props2.isActive,
	        isDisabled = _this$props2.isDisabled,
	        href = _this$props2.href,
	        ariaLabel = _this$props2.ariaLabel;
	      var css = (0, _classnames["default"])(itemClass, isActive ? activeClass : inactiveClass, isDisabled && disabledClass);
	      var linkCss = (0, _classnames["default"])(linkClass, isActive ? activeLinkClass : inactiveLinkClass);
	      return /*#__PURE__*/_react["default"].createElement("li", {
	        className: css,
	        onClick: this.handleClick.bind(this)
	      }, /*#__PURE__*/_react["default"].createElement("a", {
	        className: linkCss,
	        href: href,
	        "aria-label": ariaLabel,
	        "aria-current": isActive ? "page" : undefined,
	        "aria-disabled": isDisabled ? "true" : undefined
	      }, pageText));
	    }
	  }]);
	}(_react.Component);
	_defineProperty(Page, "propTypes", {
	  pageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
	  pageNumber: _propTypes["default"].number.isRequired,
	  onClick: _propTypes["default"].func.isRequired,
	  isActive: _propTypes["default"].bool.isRequired,
	  isDisabled: _propTypes["default"].bool,
	  activeClass: _propTypes["default"].string,
	  activeLinkClass: _propTypes["default"].string,
	  inactiveClass: _propTypes["default"].string,
	  inactiveLinkClass: _propTypes["default"].string,
	  itemClass: _propTypes["default"].string,
	  linkClass: _propTypes["default"].string,
	  disabledClass: _propTypes["default"].string,
	  href: _propTypes["default"].string,
	  ariaLabel: _propTypes["default"].string,
	  control: _propTypes["default"].oneOf(["first", "prev", "page", "next", "last"])
	});
	_defineProperty(Page, "defaultProps", {
	  activeClass: "active",
	  disabledClass: "disabled",
	  itemClass: undefined,
	  linkClass: undefined,
	  activeLinkClass: undefined,
	  isActive: false,
	  isDisabled: false,
	  href: "#",
	  control: "page"
	});

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_React$Component) {
	  _inherits(Script, _React$Component);
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has failed to load.
	
	
	  // A dictionary mapping script URLs to a dictionary mapping
	  // component key to component for all components that are waiting
	  // for the script to load.
	  function Script(props) {
	    _classCallCheck(this, Script);
	
	    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));
	
	    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
	    return _this;
	  }
	
	  // A counter used to generate a unique id for each component that uses
	  // ScriptLoaderMixin.
	
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has already been loaded.
	
	
	  _createClass(Script, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onError = _props.onError,
	          onLoad = _props.onLoad,
	          url = _props.url;
	
	
	      if (this.constructor.loadedScripts[url]) {
	        onLoad();
	        return;
	      }
	
	      if (this.constructor.erroredScripts[url]) {
	        onError();
	        return;
	      }
	
	      // If the script is loading, add the component to the script's observers
	      // and return. Otherwise, initialize the script's observers with the component
	      // and start loading the script.
	      if (this.constructor.scriptObservers[url]) {
	        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
	        return;
	      }
	
	      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);
	
	      this.createScript();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var url = this.props.url;
	
	      var observers = this.constructor.scriptObservers[url];
	
	      // If the component is waiting for the script to load, remove the
	      // component from the script's observers before unmounting the component.
	      if (observers) {
	        delete observers[this.scriptLoaderId];
	      }
	    }
	  }, {
	    key: 'createScript',
	    value: function createScript() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          onCreate = _props2.onCreate,
	          url = _props2.url,
	          attributes = _props2.attributes;
	
	      var script = document.createElement('script');
	
	      onCreate();
	
	      // add 'data-' or non standard attributes to the script tag
	      if (attributes) {
	        Object.keys(attributes).forEach(function (prop) {
	          return script.setAttribute(prop, attributes[prop]);
	        });
	      }
	
	      script.src = url;
	
	      // default async to true if not set with custom attributes
	      if (!script.hasAttribute('async')) {
	        script.async = 1;
	      }
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
	        var observers = _this2.constructor.scriptObservers[url];
	        Object.keys(observers).forEach(function (key) {
	          if (shouldRemoveObserver(observers[key])) {
	            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
	          }
	        });
	      };
	      script.onload = function () {
	        _this2.constructor.loadedScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer.onLoad();
	          return true;
	        });
	      };
	
	      script.onerror = function () {
	        _this2.constructor.erroredScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer.onError();
	          return true;
	        });
	      };
	
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Script;
	}(_react2.default.Component);
	
	Script.propTypes = {
	  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
	  onCreate: _propTypes.PropTypes.func,
	  onError: _propTypes.PropTypes.func.isRequired,
	  onLoad: _propTypes.PropTypes.func.isRequired,
	  url: _propTypes.PropTypes.string.isRequired
	};
	Script.defaultProps = {
	  attributes: {},
	  onCreate: function onCreate() {},
	  onError: function onError() {},
	  onLoad: function onLoad() {} };
	Script.scriptObservers = {};
	Script.loadedScripts = {};
	Script.erroredScripts = {};
	Script.idCount = 0;
	exports.default = Script;
	module.exports = exports['default'];

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var reactRouter = __webpack_require__(221);
	var React = _interopDefault(__webpack_require__(1));
	var history = __webpack_require__(220);
	var PropTypes = _interopDefault(__webpack_require__(23));
	var warning = _interopDefault(__webpack_require__(53));
	var invariant = _interopDefault(__webpack_require__(52));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	
	var BrowserRouter = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.history = history.createBrowserHistory(_this.props);
	    return _this;
	  }
	
	  var _proto = BrowserRouter.prototype;
	
	  _proto.render = function render() {
	    return /*#__PURE__*/React.createElement(reactRouter.Router, {
	      history: this.history,
	      children: this.props.children
	    });
	  };
	
	  return BrowserRouter;
	}(React.Component);
	
	{
	  BrowserRouter.propTypes = {
	    basename: PropTypes.string,
	    children: PropTypes.node,
	    forceRefresh: PropTypes.bool,
	    getUserConfirmation: PropTypes.func,
	    keyLength: PropTypes.number
	  };
	
	  BrowserRouter.prototype.componentDidMount = function () {
	     warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") ;
	  };
	}
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	
	var HashRouter = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.history = history.createHashHistory(_this.props);
	    return _this;
	  }
	
	  var _proto = HashRouter.prototype;
	
	  _proto.render = function render() {
	    return /*#__PURE__*/React.createElement(reactRouter.Router, {
	      history: this.history,
	      children: this.props.children
	    });
	  };
	
	  return HashRouter;
	}(React.Component);
	
	{
	  HashRouter.propTypes = {
	    basename: PropTypes.string,
	    children: PropTypes.node,
	    getUserConfirmation: PropTypes.func,
	    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
	  };
	
	  HashRouter.prototype.componentDidMount = function () {
	     warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") ;
	  };
	}
	
	var resolveToLocation = function resolveToLocation(to, currentLocation) {
	  return typeof to === "function" ? to(currentLocation) : to;
	};
	var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
	  return typeof to === "string" ? history.createLocation(to, null, null, currentLocation) : to;
	};
	
	var forwardRefShim = function forwardRefShim(C) {
	  return C;
	};
	
	var forwardRef = React.forwardRef;
	
	if (typeof forwardRef === "undefined") {
	  forwardRef = forwardRefShim;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
	  var innerRef = _ref.innerRef,
	      navigate = _ref.navigate,
	      _onClick = _ref.onClick,
	      rest = _objectWithoutPropertiesLoose(_ref, ["innerRef", "navigate", "onClick"]);
	
	  var target = rest.target;
	
	  var props = _extends({}, rest, {
	    onClick: function onClick(event) {
	      try {
	        if (_onClick) _onClick(event);
	      } catch (ex) {
	        event.preventDefault();
	        throw ex;
	      }
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && ( // ignore everything but left clicks
	      !target || target === "_self") && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	          navigate();
	        }
	    }
	  }); // React 15 compat
	
	
	  if (forwardRefShim !== forwardRef) {
	    props.ref = forwardedRef || innerRef;
	  } else {
	    props.ref = innerRef;
	  }
	  /* eslint-disable-next-line jsx-a11y/anchor-has-content */
	
	
	  return /*#__PURE__*/React.createElement("a", props);
	});
	
	{
	  LinkAnchor.displayName = "LinkAnchor";
	}
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	
	var Link = forwardRef(function (_ref2, forwardedRef) {
	  var _ref2$component = _ref2.component,
	      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
	      replace = _ref2.replace,
	      to = _ref2.to,
	      innerRef = _ref2.innerRef,
	      rest = _objectWithoutPropertiesLoose(_ref2, ["component", "replace", "to", "innerRef"]);
	
	  return /*#__PURE__*/React.createElement(reactRouter.__RouterContext.Consumer, null, function (context) {
	    !context ?  invariant(false, "You should not use <Link> outside a <Router>")  : void 0;
	    var history$1 = context.history;
	    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
	    var href = location ? history$1.createHref(location) : "";
	
	    var props = _extends({}, rest, {
	      href: href,
	      navigate: function navigate() {
	        var location = resolveToLocation(to, context.location);
	        var isDuplicateNavigation = history.createPath(context.location) === history.createPath(normalizeToLocation(location));
	        var method = replace || isDuplicateNavigation ? history$1.replace : history$1.push;
	        method(location);
	      }
	    }); // React 15 compat
	
	
	    if (forwardRefShim !== forwardRef) {
	      props.ref = forwardedRef || innerRef;
	    } else {
	      props.innerRef = innerRef;
	    }
	
	    return /*#__PURE__*/React.createElement(component, props);
	  });
	});
	
	{
	  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
	  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
	    current: PropTypes.any
	  })]);
	  Link.displayName = "Link";
	  Link.propTypes = {
	    innerRef: refType,
	    onClick: PropTypes.func,
	    replace: PropTypes.bool,
	    target: PropTypes.string,
	    to: toType.isRequired
	  };
	}
	
	var forwardRefShim$1 = function forwardRefShim(C) {
	  return C;
	};
	
	var forwardRef$1 = React.forwardRef;
	
	if (typeof forwardRef$1 === "undefined") {
	  forwardRef$1 = forwardRefShim$1;
	}
	
	function joinClassnames() {
	  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
	    classnames[_key] = arguments[_key];
	  }
	
	  return classnames.filter(function (i) {
	    return i;
	  }).join(" ");
	}
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	
	
	var NavLink = forwardRef$1(function (_ref, forwardedRef) {
	  var _ref$ariaCurrent = _ref["aria-current"],
	      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
	      _ref$activeClassName = _ref.activeClassName,
	      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
	      activeStyle = _ref.activeStyle,
	      classNameProp = _ref.className,
	      exact = _ref.exact,
	      isActiveProp = _ref.isActive,
	      locationProp = _ref.location,
	      sensitive = _ref.sensitive,
	      strict = _ref.strict,
	      styleProp = _ref.style,
	      to = _ref.to,
	      innerRef = _ref.innerRef,
	      rest = _objectWithoutPropertiesLoose(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);
	
	  return /*#__PURE__*/React.createElement(reactRouter.__RouterContext.Consumer, null, function (context) {
	    !context ?  invariant(false, "You should not use <NavLink> outside a <Router>")  : void 0;
	    var currentLocation = locationProp || context.location;
	    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
	    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	
	    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	    var match = escapedPath ? reactRouter.matchPath(currentLocation.pathname, {
	      path: escapedPath,
	      exact: exact,
	      sensitive: sensitive,
	      strict: strict
	    }) : null;
	    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
	    var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
	    var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
	
	    if (isActive) {
	      className = joinClassnames(className, activeClassName);
	      style = _extends({}, style, activeStyle);
	    }
	
	    var props = _extends({
	      "aria-current": isActive && ariaCurrent || null,
	      className: className,
	      style: style,
	      to: toLocation
	    }, rest); // React 15 compat
	
	
	    if (forwardRefShim$1 !== forwardRef$1) {
	      props.ref = forwardedRef || innerRef;
	    } else {
	      props.innerRef = innerRef;
	    }
	
	    return /*#__PURE__*/React.createElement(Link, props);
	  });
	});
	
	{
	  NavLink.displayName = "NavLink";
	  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true", "false"]);
	  NavLink.propTypes = _extends({}, Link.propTypes, {
	    "aria-current": ariaCurrentType,
	    activeClassName: PropTypes.string,
	    activeStyle: PropTypes.object,
	    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	    exact: PropTypes.bool,
	    isActive: PropTypes.func,
	    location: PropTypes.object,
	    sensitive: PropTypes.bool,
	    strict: PropTypes.bool,
	    style: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
	  });
	}
	
	Object.defineProperty(exports, 'MemoryRouter', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.MemoryRouter;
	  }
	});
	Object.defineProperty(exports, 'Prompt', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.Prompt;
	  }
	});
	Object.defineProperty(exports, 'Redirect', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.Redirect;
	  }
	});
	Object.defineProperty(exports, 'Route', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.Route;
	  }
	});
	Object.defineProperty(exports, 'Router', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.Router;
	  }
	});
	Object.defineProperty(exports, 'StaticRouter', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.StaticRouter;
	  }
	});
	Object.defineProperty(exports, 'Switch', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.Switch;
	  }
	});
	Object.defineProperty(exports, 'generatePath', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.generatePath;
	  }
	});
	Object.defineProperty(exports, 'matchPath', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.matchPath;
	  }
	});
	Object.defineProperty(exports, 'useHistory', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.useHistory;
	  }
	});
	Object.defineProperty(exports, 'useLocation', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.useLocation;
	  }
	});
	Object.defineProperty(exports, 'useParams', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.useParams;
	  }
	});
	Object.defineProperty(exports, 'useRouteMatch', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.useRouteMatch;
	  }
	});
	Object.defineProperty(exports, 'withRouter', {
	  enumerable: true,
	  get: function () {
	    return reactRouter.withRouter;
	  }
	});
	exports.BrowserRouter = BrowserRouter;
	exports.HashRouter = HashRouter;
	exports.Link = Link;
	exports.NavLink = NavLink;
	//# sourceMappingURL=react-router-dom.js.map


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(221),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(220);__webpack_require__(23),__webpack_require__(53);var invariant=_interopDefault(__webpack_require__(52));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(223)),valueEqual=_interopDefault(__webpack_require__(225));__webpack_require__(53);var invariant=_interopDefault(__webpack_require__(52));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1)),PropTypes=_interopDefault(__webpack_require__(23)),history=__webpack_require__(691);__webpack_require__(53);var invariant=_interopDefault(__webpack_require__(52)),pathToRegexp=_interopDefault(__webpack_require__(668));__webpack_require__(219);var hoistStatics=_interopDefault(__webpack_require__(212));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},i=Object.keys(t);for(o=0;o<i.length;o++)n=i[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var MAX_SIGNED_31_BIT_INT=1073741823,commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:{};function getUniqueId(){var t="__global_unique_id__";return commonjsGlobal[t]=(commonjsGlobal[t]||0)+1}function objectIs(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}function createEventEmitter(n){var o=[];return{on:function(t){o.push(t)},off:function(e){o=o.filter(function(t){return t!==e})},get:function(){return n},set:function(t,e){n=t,o.forEach(function(t){return t(n,e)})}}}function onlyChild(t){return Array.isArray(t)?t[0]:t}function createReactContext(n,i){var t,e,o="__create-react-context-"+getUniqueId()+"__",r=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).emitter=createEventEmitter(t.props.value),t}_inheritsLoose(t,r);var e=t.prototype;return e.getChildContext=function(){var t;return(t={})[o]=this.emitter,t},e.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e,n=this.props.value,o=t.value;objectIs(n,o)?e=0:(e="function"==typeof i?i(n,o):MAX_SIGNED_31_BIT_INT,0!==(e|=0)&&this.emitter.set(t.value,e))}},e.render=function(){return this.props.children},t}(React.Component);r.childContextTypes=((t={})[o]=PropTypes.object.isRequired,t);var a=function(r){function t(){for(var n,t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))||this).observedBits=void 0,n.state={value:n.getValue()},n.onUpdate=function(t,e){0!=((0|n.observedBits)&e)&&n.setState({value:n.getValue()})},n}_inheritsLoose(t,r);var e=t.prototype;return e.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?MAX_SIGNED_31_BIT_INT:e},e.componentDidMount=function(){this.context[o]&&this.context[o].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?MAX_SIGNED_31_BIT_INT:t},e.componentWillUnmount=function(){this.context[o]&&this.context[o].off(this.onUpdate)},e.getValue=function(){return this.context[o]?this.context[o].get():n},e.render=function(){return onlyChild(this.props.children)(this.state.value)},t}(React.Component);return a.contextTypes=((e={})[o]=PropTypes.object,e),{Provider:r,Consumer:a}}var createContext=React.createContext||createReactContext,createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){var e=this;this._isMounted=!0,this.unlisten&&this.unlisten(),this.props.staticContext||(this.unlisten=this.props.history.listen(function(t){e._isMounted&&e.setState({location:t})})),this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var i=t.computedMatch,a=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(i?"string"==typeof a?generatePath(a,i.params):_extends({},a,{pathname:generatePath(a.pathname,i.params)}):a);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:a})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],i={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=i,cacheCount$1++),i}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,i=e.sensitive,l=void 0!==i&&i;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,i=o.exec(u);if(!i)return null;var a=i[0],c=i.slice(1),s=u===a;return p&&!s?null:{path:e,url:"/"===e&&""===a?"/":a,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,i=o.component,a=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:i?React.createElement(i,n):a?a(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,i=n.context,a=void 0===i?{}:i;a.action=e,a.location=addBasename(r,history.createLocation(t)),a.url=createURL(a.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,i=t.location,a=void 0===i?"/":i,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(a)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,i=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(i.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:i,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 690 */
688,
/* 691 */
[718, 690],
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var React = __webpack_require__(1)
	
	var SIZER_STYLES = {
	  position: 'absolute',
	  width: 0,
	  height: 0,
	  visibility: 'hidden',
	  overflow: 'scroll',
	  whiteSpace: 'pre'
	}
	
	var STYLE_PROPS = [
	  'fontSize',
	  'fontFamily',
	  'fontWeight',
	  'fontStyle',
	  'letterSpacing',
	  'textTransform'
	]
	
	var Input = /*@__PURE__*/(function (superclass) {
	  function Input (props) {
	    superclass.call(this, props)
	    this.state = { inputWidth: null }
	  }
	
	  if ( superclass ) Input.__proto__ = superclass;
	  Input.prototype = Object.create( superclass && superclass.prototype );
	  Input.prototype.constructor = Input;
	
	  Input.prototype.componentDidMount = function componentDidMount () {
	    if (this.props.autoresize) {
	      this.copyInputStyles()
	      this.updateInputWidth()
	    }
	
	    if (this.props.autofocus) {
	      this.input.focus()
	    }
	  };
	
	  Input.prototype.componentDidUpdate = function componentDidUpdate (ref) {
	    var query = ref.query;
	    var placeholder = ref.placeholder;
	
	    if (query !== this.props.query || placeholder !== this.props.placeholder) {
	      this.updateInputWidth()
	    }
	  };
	
	  Input.prototype.copyInputStyles = function copyInputStyles () {
	    var this$1 = this;
	
	    var inputStyle = window.getComputedStyle(this.input)
	
	    STYLE_PROPS.forEach(function (prop) {
	      this$1.sizer.style[prop] = inputStyle[prop]
	    })
	  };
	
	  Input.prototype.updateInputWidth = function updateInputWidth () {
	    var inputWidth
	
	    if (this.props.autoresize) {
	      // scrollWidth is designed to be fast not accurate.
	      // +2 is completely arbitrary but does the job.
	      inputWidth = Math.ceil(this.sizer.scrollWidth) + 2
	    }
	
	    if (inputWidth !== this.state.inputWidth) {
	      this.setState({ inputWidth: inputWidth })
	    }
	  };
	
	  Input.prototype.render = function render () {
	    var this$1 = this;
	
	    var ref = this.props;
	    var inputAttributes = ref.inputAttributes;
	    var inputEventHandlers = ref.inputEventHandlers;
	    var query = ref.query;
	    var placeholder = ref.placeholder;
	    var expandable = ref.expandable;
	    var listboxId = ref.listboxId;
	    var selectedIndex = ref.selectedIndex;
	    var ariaLabel = ref.ariaLabel;
	
	    return (
	      React.createElement( 'div', { className: this.props.classNames.searchInput },
	        React.createElement( 'input', Object.assign({},
	          inputAttributes, inputEventHandlers, { ref: function (c) { this$1.input = c }, value: query, placeholder: placeholder, role: 'combobox', 'aria-autocomplete': 'list', 'aria-label': ariaLabel || placeholder, 'aria-owns': listboxId, 'aria-activedescendant': selectedIndex > -1 ? (listboxId + "-" + selectedIndex) : null, 'aria-expanded': expandable, style: { width: this.state.inputWidth } })),
	        React.createElement( 'div', { ref: function (c) { this$1.sizer = c }, style: SIZER_STYLES }, query || placeholder)
	      )
	    )
	  };
	
	  return Input;
	}(React.Component));
	
	module.exports = Input


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var React = __webpack_require__(1)
	
	function escapeForRegExp (query) {
	  return query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
	}
	
	function markIt (input, query) {
	  if (query) {
	    var regex = RegExp(escapeForRegExp(query), 'gi')
	    input = input.replace(regex, '<mark>$&</mark>')
	  }
	
	  return {
	    __html: input
	  }
	}
	
	function filterSuggestions (query, suggestions, length, suggestionsFilter, noSuggestionsText) {
	  if (!suggestionsFilter) {
	    var regex = new RegExp(("(?:^|\\s)" + (escapeForRegExp(query))), 'i')
	    suggestionsFilter = function (item) { return regex.test(item.name); }
	  }
	
	  var filtered = suggestions.filter(function (item) { return suggestionsFilter(item, query); }).slice(0, length)
	
	  if (filtered.length === 0 && noSuggestionsText) {
	    filtered.push({ id: 0, name: noSuggestionsText, disabled: true, disableMarkIt: true })
	  }
	
	  return filtered
	}
	
	var Suggestions = /*@__PURE__*/(function (superclass) {
	  function Suggestions (props) {
	    superclass.call(this, props)
	
	    this.state = {
	      options: filterSuggestions(this.props.query, this.props.suggestions, this.props.maxSuggestionsLength, this.props.suggestionsFilter, this.props.noSuggestionsText)
	    }
	  }
	
	  if ( superclass ) Suggestions.__proto__ = superclass;
	  Suggestions.prototype = Object.create( superclass && superclass.prototype );
	  Suggestions.prototype.constructor = Suggestions;
	
	  Suggestions.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
	    this.setState({
	      options: filterSuggestions(newProps.query, newProps.suggestions, newProps.maxSuggestionsLength, newProps.suggestionsFilter, newProps.noSuggestionsText)
	    })
	  };
	
	  Suggestions.prototype.handleMouseDown = function handleMouseDown (item, e) {
	    // focus is shifted on mouse down but calling preventDefault prevents this
	    e.preventDefault()
	    this.props.addTag(item)
	  };
	
	  Suggestions.prototype.render = function render () {
	    var this$1 = this;
	
	    if (!this.props.expandable || !this.state.options.length) {
	      return null
	    }
	
	    var options = this.state.options.map(function (item, i) {
	      var key = (this$1.props.listboxId) + "-" + i
	      var classNames = []
	
	      if (this$1.props.selectedIndex === i) {
	        classNames.push(this$1.props.classNames.suggestionActive)
	      }
	
	      if (item.disabled) {
	        classNames.push(this$1.props.classNames.suggestionDisabled)
	      }
	
	      return (
	        React.createElement( 'li', {
	          id: key, key: key, role: 'option', className: classNames.join(' '), 'aria-disabled': item.disabled === true, onMouseDown: this$1.handleMouseDown.bind(this$1, item) },
	          item.disableMarkIt ? item.name
	            : React.createElement( 'span', { dangerouslySetInnerHTML: markIt(item.name, this$1.props.query, item.markInput) })
	        )
	      )
	    })
	
	    return (
	      React.createElement( 'div', { className: this.props.classNames.suggestions },
	        React.createElement( 'ul', { role: 'listbox', id: this.props.listboxId }, options)
	      )
	    )
	  };
	
	  return Suggestions;
	}(React.Component));
	
	module.exports = Suggestions


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var React = __webpack_require__(1)
	
	module.exports = function (props) { return (
	  React.createElement( 'button', { type: 'button', className: props.classNames.selectedTag, title: 'Click to remove tag', onClick: props.onDelete },
	    React.createElement( 'span', { className: props.classNames.selectedTagName }, props.tag.name)
	  )
	); }


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(116),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 697 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 698 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(698);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 700 */
29,
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cache-clear.d292d5cd.png";

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/e-clear_logo.3f9a658b.png";

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step1.8aed38a9.jpg";

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step2.bfff5f32.png";

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step3.93d97808.png";

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step4.b83e9359.png";

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step5.430af9c5.png";

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step6.2924e490.png";

/***/ },
/* 709 */
/***/ function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step1.15e7753a.jpg";

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step2.9206c428.jpg";

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step3.a2e1deac.jpg";

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step4.8d778b42.jpg";

/***/ },
/* 714 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 715 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.15.0"};
	cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	return {"enc": e, "dec": d }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[28591] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	// eslint-disable-next-line no-undef
	if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
	/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ft=javascript: */
	/*jshint newcap: false */
	(function(root, factory) {
	  /*jshint ignore:start */
	  /*eslint-disable */
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	  /*eslint-enable */
	  /*jshint ignore:end */
	}(this, function(cpt){
	  "use strict";
	  /*global module, Buffer */
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpdcache = {};
	  var cpecache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x) { return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  var Buffer_from = function(){};
	  if(has_buf) {
	    var nbfs = !Buffer.from;
	    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	    // $FlowIgnore
	    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	
	    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
	    var make_EE = function make_EE(E){
	      var EE = Buffer.allocUnsafe(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i=0, j=0, D=0, w=0;
	        if(typeof data === 'string') {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = Buffer.allocUnsafe(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out = out.slice(0,j);
	        } else {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c="";
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j=0;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        return mdb.slice(0, 2 * len).toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = Buffer.allocUnsafe(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        return out.slice(0,k).toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      if(typeof data === "string") return utf8_d(data.split("").map(cca));
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      return mdb.slice(0,k).toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      if(has_buf && Buffer.isBuffer(data)) {
	        if(!ofmt || ofmt === 'buf') return data;
	        if(ofmt !== 'arr') return data.toString('binary');
	        return [].slice.call(data);
	      }
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
	      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
	      return [].slice.call(mdb, 0, j);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i=0, s=0;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var null_enc = function(data, ofmt) { void ofmt; return ""; };
	  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = null_enc; last_cp = 0;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc = null_enc, last_cp = 0;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
	    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
	    var C = cpt[cp], E, M = "";
	    var isstr = typeof data === 'string';
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[isstr? data.charAt(i) : data[i]];
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      } else out[j] = w&255;
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          var c = isstr ? data.charAt(i) : data[i].charAt(0);
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          var tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out = out.slice(0,j);
	    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
	    if(!ofmt || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    if(typeof data === "string") return decode(cp, data.split("").map(cca));
	    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
	    var C = cpt[cp], D, M="";
	    if(C && (D=C.dec)) {
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        s = D[(data[i]<<8)+ data[i+1]];
	        if(!s) {
	          j = 1;
	          s = D[data[i]];
	        }
	        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = s;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          // eslint-disable-next-line no-useless-escape
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64 = "";
	          var c1=0, c2=0, c3=0;
	          var e1=0, e2=0, e3=0, e4=0;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    return out.slice(0,k).join("");
	  };
	  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101).Buffer))

/***/ },
/* 717 */
226,
/* 718 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.97c699e4.js